/* -------- common/js/jquery-2.1.3.js -------- */
/*!
 * jQuery JavaScript Library v2.1.3
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright 2005, 2014 jQuery Foundation, Inc. and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2014-12-18T15:11Z
 */

(function( global, factory ) {

	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Support: Firefox 18+
// Can't be in strict mode, several libs including ASP.NET trace
// the stack via arguments.caller.callee and Firefox dies if
// you try to trace through "use strict" call chains. (#13335)
//

var arr = [];

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var support = {};



var
	// Use the correct document accordingly with window argument (sandbox)
	document = window.document,

	version = "2.1.3",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {
		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android<4.1
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([\da-z])/gi,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {
	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// Start with an empty selector
	selector: "",

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {
		return num != null ?

			// Return just the one element from the set
			( num < 0 ? this[ num + this.length ] : this[ num ] ) :

			// Return all the elements in a clean array
			slice.call( this );
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;
		ret.context = this.context;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	// (You can seed the arguments with an array of args, but this is
	// only used internally.)
	each: function( callback, args ) {
		return jQuery.each( this, callback, args );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map(this, function( elem, i ) {
			return callback.call( elem, i, elem );
		}));
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[j] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor(null);
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[0] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction(target) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {
		// Only deal with non-null/undefined values
		if ( (options = arguments[ i ]) != null ) {
			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)) ) ) {
					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray(src) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject(src) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend({
	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type(obj) === "function";
	},

	isArray: Array.isArray,

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {
		// parseFloat NaNs numeric-cast false positives (null|true|false|"")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		// adding 1 corrects loss of precision from parseFloat (#15100)
		return !jQuery.isArray( obj ) && (obj - parseFloat( obj ) + 1) >= 0;
	},

	isPlainObject: function( obj ) {
		// Not plain objects:
		// - Any object or value whose internal [[Class]] property is not "[object Object]"
		// - DOM nodes
		// - window
		if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
			return false;
		}

		if ( obj.constructor &&
				!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
			return false;
		}

		// If the function hasn't returned already, we're confident that
		// |obj| is a plain object, created by {} or constructed with new Object
		return true;
	},

	isEmptyObject: function( obj ) {
		var name;
		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
		// Support: Android<4.0, iOS<6 (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call(obj) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		var script,
			indirect = eval;

		code = jQuery.trim( code );

		if ( code ) {
			// If the code includes a valid, prologue position
			// strict mode pragma, execute code by injecting a
			// script tag into the document.
			if ( code.indexOf("use strict") === 1 ) {
				script = document.createElement("script");
				script.text = code;
				document.head.appendChild( script ).parentNode.removeChild( script );
			} else {
			// Otherwise, avoid the DOM node creation, insertion
			// and removal by using an indirect global eval
				indirect( code );
			}
		}
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE9-11+
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	// args is for internal usage only
	each: function( obj, callback, args ) {
		var value,
			i = 0,
			length = obj.length,
			isArray = isArraylike( obj );

		if ( args ) {
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback.apply( obj[ i ], args );

					if ( value === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					value = callback.apply( obj[ i ], args );

					if ( value === false ) {
						break;
					}
				}
			}

		// A special, fast, case for the most common use of each
		} else {
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback.call( obj[ i ], i, obj[ i ] );

					if ( value === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					value = callback.call( obj[ i ], i, obj[ i ] );

					if ( value === false ) {
						break;
					}
				}
			}
		}

		return obj;
	},

	// Support: Android<4.1
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArraylike( Object(arr) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var value,
			i = 0,
			length = elems.length,
			isArray = isArraylike( elems ),
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArray ) {
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
});

// Populate the class2type map
jQuery.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i, name) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
});

function isArraylike( obj ) {
	var length = obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	if ( obj.nodeType === 1 && length ) {
		return true;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.2.0-pre
 * http://sizzlejs.com/
 *
 * Copyright 2008, 2014 jQuery Foundation, Inc. and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2014-12-16
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// General-purpose constants
	MAX_NEGATIVE = 1 << 31,

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// http://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",
	// http://www.w3.org/TR/css3-syntax/#characters
	characterEncoding = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

	// Loosely modeled on CSS identifier characters
	// An unquoted value should be a CSS identifier http://www.w3.org/TR/css3-selectors/#attribute-selectors
	// Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = characterEncoding.replace( "w", "w#" ),

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + characterEncoding + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + characterEncoding + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + characterEncoding + ")" ),
		"CLASS": new RegExp( "^\\.(" + characterEncoding + ")" ),
		"TAG": new RegExp( "^(" + characterEncoding.replace( "w", "w*" ) + ")" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,
	rescape = /'|\\/g,

	// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	};

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var match, elem, m, nodeType,
		// QSA vars
		i, groups, old, nid, newContext, newSelector;

	if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
		setDocument( context );
	}

	context = context || document;
	results = results || [];
	nodeType = context.nodeType;

	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	if ( !seed && documentIsHTML ) {

		// Try to shortcut find operations when possible (e.g., not under DocumentFragment)
		if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
			// Speed-up: Sizzle("#ID")
			if ( (m = match[1]) ) {
				if ( nodeType === 9 ) {
					elem = context.getElementById( m );
					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document (jQuery #6963)
					if ( elem && elem.parentNode ) {
						// Handle the case where IE, Opera, and Webkit return items
						// by name instead of ID
						if ( elem.id === m ) {
							results.push( elem );
							return results;
						}
					} else {
						return results;
					}
				} else {
					// Context is not a document
					if ( context.ownerDocument && (elem = context.ownerDocument.getElementById( m )) &&
						contains( context, elem ) && elem.id === m ) {
						results.push( elem );
						return results;
					}
				}

			// Speed-up: Sizzle("TAG")
			} else if ( match[2] ) {
				push.apply( results, context.getElementsByTagName( selector ) );
				return results;

			// Speed-up: Sizzle(".CLASS")
			} else if ( (m = match[3]) && support.getElementsByClassName ) {
				push.apply( results, context.getElementsByClassName( m ) );
				return results;
			}
		}

		// QSA path
		if ( support.qsa && (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
			nid = old = expando;
			newContext = context;
			newSelector = nodeType !== 1 && selector;

			// qSA works strangely on Element-rooted queries
			// We can work around this by specifying an extra ID on the root
			// and working up from there (Thanks to Andrew Dupont for the technique)
			// IE 8 doesn't work on object elements
			if ( nodeType === 1 && context.nodeName.toLowerCase() !== "object" ) {
				groups = tokenize( selector );

				if ( (old = context.getAttribute("id")) ) {
					nid = old.replace( rescape, "\\$&" );
				} else {
					context.setAttribute( "id", nid );
				}
				nid = "[id='" + nid + "'] ";

				i = groups.length;
				while ( i-- ) {
					groups[i] = nid + toSelector( groups[i] );
				}
				newContext = rsibling.test( selector ) && testContext( context.parentNode ) || context;
				newSelector = groups.join(",");
			}

			if ( newSelector ) {
				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch(qsaError) {
				} finally {
					if ( !old ) {
						context.removeAttribute("id");
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created div and expects a boolean result
 */
function assert( fn ) {
	var div = document.createElement("div");

	try {
		return !!fn( div );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( div.parentNode ) {
			div.parentNode.removeChild( div );
		}
		// release memory in IE
		div = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = attrs.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			( ~b.sourceIndex || MAX_NEGATIVE ) -
			( ~a.sourceIndex || MAX_NEGATIVE );

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, parent,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// If no document and documentElement is available, return
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Set our document
	document = doc;
	docElem = doc.documentElement;
	parent = doc.defaultView;

	// Support: IE>8
	// If iframe document is assigned to "document" variable and if iframe has been reloaded,
	// IE will throw "permission denied" error when accessing "document" variable, see jQuery #13936
	// IE6-8 do not support the defaultView property so parent will be undefined
	if ( parent && parent !== parent.top ) {
		// IE11 does not have attachEvent, so all must suffer
		if ( parent.addEventListener ) {
			parent.addEventListener( "unload", unloadHandler, false );
		} else if ( parent.attachEvent ) {
			parent.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Support tests
	---------------------------------------------------------------------- */
	documentIsHTML = !isXML( doc );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( div ) {
		div.className = "i";
		return !div.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( div ) {
		div.appendChild( doc.createComment("") );
		return !div.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( doc.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( div ) {
		docElem.appendChild( div ).id = expando;
		return !doc.getElementsByName || !doc.getElementsByName( expando ).length;
	});

	// ID find and filter
	if ( support.getById ) {
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var m = context.getElementById( id );
				// Check parentNode to catch when Blackberry 4.6 returns
				// nodes that are no longer in the document #6963
				return m && m.parentNode ? [ m ] : [];
			}
		};
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
	} else {
		// Support: IE6/7
		// getElementById is not reliable as a find shortcut
		delete Expr.find["ID"];

		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See http://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( doc.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( div ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// http://bugs.jquery.com/ticket/12359
			docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\f]' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( div.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !div.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.2+, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.7+
			if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibing-combinator selector` fails
			if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( div ) {
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = doc.createElement("input");
			input.setAttribute( "type", "hidden" );
			div.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( div.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":enabled").length ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			div.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( div ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( div, "div" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( div, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully does not implement inclusive descendent
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === doc ? -1 :
				b === doc ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return doc;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, outerCache, node, diff, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) {
										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {
							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || (parent[ expando ] = {});
							cache = outerCache[ type ] || [];
							nodeIndex = cache[0] === dirruns && cache[1];
							diff = cache[0] === dirruns && cache[2];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						// Use previously-cached element index if available
						} else if ( useCache && (cache = (elem[ expando ] || (elem[ expando ] = {}))[ type ]) && cache[0] === dirruns ) {
							diff = cache[1];

						// xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)
						} else {
							// Use the same loop as above to seek `elem` from the start
							while ( (node = ++nodeIndex && node && node[ dir ] ||
								(diff = nodeIndex = 0) || start.pop()) ) {

								if ( ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) && ++diff ) {
									// Cache the index of each encountered element
									if ( useCache ) {
										(node[ expando ] || (node[ expando ] = {}))[ type ] = [ dirruns, diff ];
									}

									if ( node === elem ) {
										break;
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": function( elem ) {
			return elem.disabled === false;
		},

		"disabled": function( elem ) {
			return elem.disabled === true;
		},

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		checkNonElements = base && dir === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from dir caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});
						if ( (oldCache = outerCache[ dir ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							outerCache[ dir ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context !== document && context;
			}

			// Add elements passing elementMatchers directly to results
			// Keep `i` a string if there are no elements so `matchedCount` will be "00" below
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// Apply set filters to unmatched elements
			matchedCount += i;
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is no seed and only one group
	if ( match.length === 1 ) {

		// Take a shortcut and set the context if the root selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				support.getById && context.nodeType === 9 && documentIsHTML &&
				Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( div1 ) {
	// Should return 1, but returns 4 (following)
	return div1.compareDocumentPosition( document.createElement("div") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( div ) {
	div.innerHTML = "<a href='#'></a>";
	return div.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( div ) {
	div.innerHTML = "<input/>";
	div.firstChild.setAttribute( "value", "" );
	return div.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( div ) {
	return div.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;
jQuery.expr[":"] = jQuery.expr.pseudos;
jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;



var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = (/^<(\w+)\s*\/?>(?:<\/\1>|)$/);



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			/* jshint -W018 */
			return !!qualifier.call( elem, i, elem ) !== not;
		});

	}

	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		});

	}

	if ( typeof qualifier === "string" ) {
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}

		qualifier = jQuery.filter( qualifier, elements );
	}

	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) >= 0 ) !== not;
	});
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	return elems.length === 1 && elem.nodeType === 1 ?
		jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
		jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		}));
};

jQuery.fn.extend({
	find: function( selector ) {
		var i,
			len = this.length,
			ret = [],
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter(function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			}) );
		}

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		// Needed because $( selector, context ) becomes $( context ).find( selector )
		ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
		ret.selector = this.selector ? this.selector + " " + selector : selector;
		return ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow(this, selector || [], false) );
	},
	not: function( selector ) {
		return this.pushStack( winnow(this, selector || [], true) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
});


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,

	init = jQuery.fn.init = function( selector, context ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[0] === "<" && selector[ selector.length - 1 ] === ">" && selector.length >= 3 ) {
				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && (match[1] || !context) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[1] ) {
					context = context instanceof jQuery ? context[0] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[1],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[1] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {
							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[2] );

					// Support: Blackberry 4.6
					// gEBID returns nodes no longer in the document (#6963)
					if ( elem && elem.parentNode ) {
						// Inject the element directly into the jQuery object
						this.length = 1;
						this[0] = elem;
					}

					this.context = document;
					this.selector = selector;
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || rootjQuery ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this.context = this[0] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return typeof rootjQuery.ready !== "undefined" ?
				rootjQuery.ready( selector ) :
				// Execute immediately if ready is not present
				selector( jQuery );
		}

		if ( selector.selector !== undefined ) {
			this.selector = selector.selector;
			this.context = selector.context;
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.extend({
	dir: function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;

		while ( (elem = elem[ dir ]) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	},

	sibling: function( n, elem ) {
		var matched = [];

		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}

		return matched;
	}
});

jQuery.fn.extend({
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter(function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[i] ) ) {
					return true;
				}
			}
		});
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
				jQuery( selectors, context || this.context ) :
				0;

		for ( ; i < l; i++ ) {
			for ( cur = this[i]; cur && cur !== context; cur = cur.parentNode ) {
				// Always skip document fragments
				if ( cur.nodeType < 11 && (pos ?
					pos.index(cur) > -1 :

					// Don't pass non-elements to Sizzle
					cur.nodeType === 1 &&
						jQuery.find.matchesSelector(cur, selectors)) ) {

					matched.push( cur );
					break;
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.unique( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.unique(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter(selector)
		);
	}
});

function sibling( cur, dir ) {
	while ( (cur = cur[dir]) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each({
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return jQuery.dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return jQuery.dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return jQuery.dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return jQuery.sibling( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return jQuery.sibling( elem.firstChild );
	},
	contents: function( elem ) {
		return elem.contentDocument || jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {
			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.unique( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
});
var rnotwhite = (/\S+/g);



// String to Object options format cache
var optionsCache = {};

// Convert String-formatted options into Object-formatted ones and store in cache
function createOptions( options ) {
	var object = optionsCache[ options ] = {};
	jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	});
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		( optionsCache[ options ] || createOptions( options ) ) :
		jQuery.extend( {}, options );

	var // Last fire value (for non-forgettable lists)
		memory,
		// Flag to know if list was already fired
		fired,
		// Flag to know if list is currently firing
		firing,
		// First callback to fire (used internally by add and fireWith)
		firingStart,
		// End of the loop when firing
		firingLength,
		// Index of currently firing callback (modified by remove if needed)
		firingIndex,
		// Actual callback list
		list = [],
		// Stack of fire calls for repeatable lists
		stack = !options.once && [],
		// Fire callbacks
		fire = function( data ) {
			memory = options.memory && data;
			fired = true;
			firingIndex = firingStart || 0;
			firingStart = 0;
			firingLength = list.length;
			firing = true;
			for ( ; list && firingIndex < firingLength; firingIndex++ ) {
				if ( list[ firingIndex ].apply( data[ 0 ], data[ 1 ] ) === false && options.stopOnFalse ) {
					memory = false; // To prevent further calls using add
					break;
				}
			}
			firing = false;
			if ( list ) {
				if ( stack ) {
					if ( stack.length ) {
						fire( stack.shift() );
					}
				} else if ( memory ) {
					list = [];
				} else {
					self.disable();
				}
			}
		},
		// Actual Callbacks object
		self = {
			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {
					// First, we save the current length
					var start = list.length;
					(function add( args ) {
						jQuery.each( args, function( _, arg ) {
							var type = jQuery.type( arg );
							if ( type === "function" ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && type !== "string" ) {
								// Inspect recursively
								add( arg );
							}
						});
					})( arguments );
					// Do we need to add the callbacks to the
					// current firing batch?
					if ( firing ) {
						firingLength = list.length;
					// With memory, if we're not firing then
					// we should call right away
					} else if ( memory ) {
						firingStart = start;
						fire( memory );
					}
				}
				return this;
			},
			// Remove a callback from the list
			remove: function() {
				if ( list ) {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
							// Handle firing indexes
							if ( firing ) {
								if ( index <= firingLength ) {
									firingLength--;
								}
								if ( index <= firingIndex ) {
									firingIndex--;
								}
							}
						}
					});
				}
				return this;
			},
			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ? jQuery.inArray( fn, list ) > -1 : !!( list && list.length );
			},
			// Remove all callbacks from the list
			empty: function() {
				list = [];
				firingLength = 0;
				return this;
			},
			// Have the list do nothing anymore
			disable: function() {
				list = stack = memory = undefined;
				return this;
			},
			// Is it disabled?
			disabled: function() {
				return !list;
			},
			// Lock the list in its current state
			lock: function() {
				stack = undefined;
				if ( !memory ) {
					self.disable();
				}
				return this;
			},
			// Is it locked?
			locked: function() {
				return !stack;
			},
			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( list && ( !fired || stack ) ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					if ( firing ) {
						stack.push( args );
					} else {
						fire( args );
					}
				}
				return this;
			},
			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},
			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


jQuery.extend({

	Deferred: function( func ) {
		var tuples = [
				// action, add listener, listener list, final state
				[ "resolve", "done", jQuery.Callbacks("once memory"), "resolved" ],
				[ "reject", "fail", jQuery.Callbacks("once memory"), "rejected" ],
				[ "notify", "progress", jQuery.Callbacks("memory") ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				then: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;
					return jQuery.Deferred(function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {
							var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
							// deferred[ done | fail | progress ] for forwarding actions to newDefer
							deferred[ tuple[1] ](function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.done( newDefer.resolve )
										.fail( newDefer.reject )
										.progress( newDefer.notify );
								} else {
									newDefer[ tuple[ 0 ] + "With" ]( this === promise ? newDefer.promise() : this, fn ? [ returned ] : arguments );
								}
							});
						});
						fns = null;
					}).promise();
				},
				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Keep pipe for back-compat
		promise.pipe = promise.then;

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 3 ];

			// promise[ done | fail | progress ] = list.add
			promise[ tuple[1] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(function() {
					// state = [ resolved | rejected ]
					state = stateString;

				// [ reject_list | resolve_list ].disable; progress_list.lock
				}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
			}

			// deferred[ resolve | reject | notify ]
			deferred[ tuple[0] ] = function() {
				deferred[ tuple[0] + "With" ]( this === deferred ? promise : this, arguments );
				return this;
			};
			deferred[ tuple[0] + "With" ] = list.fireWith;
		});

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( subordinate /* , ..., subordinateN */ ) {
		var i = 0,
			resolveValues = slice.call( arguments ),
			length = resolveValues.length,

			// the count of uncompleted subordinates
			remaining = length !== 1 || ( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

			// the master Deferred. If resolveValues consist of only a single Deferred, just use that.
			deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

			// Update function for both resolve and progress values
			updateFunc = function( i, contexts, values ) {
				return function( value ) {
					contexts[ i ] = this;
					values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( values === progressValues ) {
						deferred.notifyWith( contexts, values );
					} else if ( !( --remaining ) ) {
						deferred.resolveWith( contexts, values );
					}
				};
			},

			progressValues, progressContexts, resolveContexts;

		// Add listeners to Deferred subordinates; treat others as resolved
		if ( length > 1 ) {
			progressValues = new Array( length );
			progressContexts = new Array( length );
			resolveContexts = new Array( length );
			for ( ; i < length; i++ ) {
				if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
					resolveValues[ i ].promise()
						.done( updateFunc( i, resolveContexts, resolveValues ) )
						.fail( deferred.reject )
						.progress( updateFunc( i, progressContexts, progressValues ) );
				} else {
					--remaining;
				}
			}
		}

		// If we're not waiting on anything, resolve the master
		if ( !remaining ) {
			deferred.resolveWith( resolveContexts, resolveValues );
		}

		return deferred.promise();
	}
});


// The deferred used on DOM ready
var readyList;

jQuery.fn.ready = function( fn ) {
	// Add the callback
	jQuery.ready.promise().done( fn );

	return this;
};

jQuery.extend({
	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );

		// Trigger any bound ready events
		if ( jQuery.fn.triggerHandler ) {
			jQuery( document ).triggerHandler( "ready" );
			jQuery( document ).off( "ready" );
		}
	}
});

/**
 * The ready event handler and self cleanup method
 */
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed, false );
	window.removeEventListener( "load", completed, false );
	jQuery.ready();
}

jQuery.ready.promise = function( obj ) {
	if ( !readyList ) {

		readyList = jQuery.Deferred();

		// Catch cases where $(document).ready() is called after the browser event has already occurred.
		// We once tried to use readyState "interactive" here, but it caused issues like the one
		// discovered by ChrisS here: http://bugs.jquery.com/ticket/12282#comment:15
		if ( document.readyState === "complete" ) {
			// Handle it asynchronously to allow scripts the opportunity to delay ready
			setTimeout( jQuery.ready );

		} else {

			// Use the handy event callback
			document.addEventListener( "DOMContentLoaded", completed, false );

			// A fallback to window.onload, that will always work
			window.addEventListener( "load", completed, false );
		}
	}
	return readyList.promise( obj );
};

// Kick off the DOM ready check even if the user does not
jQuery.ready.promise();




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = jQuery.access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			jQuery.access( elems, fn, i, key[i], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {
			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn( elems[i], key, raw ? value : value.call( elems[i], i, fn( elems[i], key ) ) );
			}
		}
	}

	return chainable ?
		elems :

		// Gets
		bulk ?
			fn.call( elems ) :
			len ? fn( elems[0], key ) : emptyGet;
};


/**
 * Determines whether an object can have data
 */
jQuery.acceptData = function( owner ) {
	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	/* jshint -W018 */
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};


function Data() {
	// Support: Android<4,
	// Old WebKit does not have Object.preventExtensions/freeze method,
	// return new empty object instead with no [[set]] accessor
	Object.defineProperty( this.cache = {}, 0, {
		get: function() {
			return {};
		}
	});

	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;
Data.accepts = jQuery.acceptData;

Data.prototype = {
	key: function( owner ) {
		// We can accept data for non-element nodes in modern browsers,
		// but we should not, see #8335.
		// Always return the key for a frozen object.
		if ( !Data.accepts( owner ) ) {
			return 0;
		}

		var descriptor = {},
			// Check if the owner object already has a cache key
			unlock = owner[ this.expando ];

		// If not, create one
		if ( !unlock ) {
			unlock = Data.uid++;

			// Secure it in a non-enumerable, non-writable property
			try {
				descriptor[ this.expando ] = { value: unlock };
				Object.defineProperties( owner, descriptor );

			// Support: Android<4
			// Fallback to a less secure definition
			} catch ( e ) {
				descriptor[ this.expando ] = unlock;
				jQuery.extend( owner, descriptor );
			}
		}

		// Ensure the cache object
		if ( !this.cache[ unlock ] ) {
			this.cache[ unlock ] = {};
		}

		return unlock;
	},
	set: function( owner, data, value ) {
		var prop,
			// There may be an unlock assigned to this node,
			// if there is no entry for this "owner", create one inline
			// and set the unlock as though an owner entry had always existed
			unlock = this.key( owner ),
			cache = this.cache[ unlock ];

		// Handle: [ owner, key, value ] args
		if ( typeof data === "string" ) {
			cache[ data ] = value;

		// Handle: [ owner, { properties } ] args
		} else {
			// Fresh assignments by object are shallow copied
			if ( jQuery.isEmptyObject( cache ) ) {
				jQuery.extend( this.cache[ unlock ], data );
			// Otherwise, copy the properties one-by-one to the cache object
			} else {
				for ( prop in data ) {
					cache[ prop ] = data[ prop ];
				}
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		// Either a valid cache is found, or will be created.
		// New caches will be created and the unlock returned,
		// allowing direct access to the newly created
		// empty data object. A valid owner object must be provided.
		var cache = this.cache[ this.key( owner ) ];

		return key === undefined ?
			cache : cache[ key ];
	},
	access: function( owner, key, value ) {
		var stored;
		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				((key && typeof key === "string") && value === undefined) ) {

			stored = this.get( owner, key );

			return stored !== undefined ?
				stored : this.get( owner, jQuery.camelCase(key) );
		}

		// [*]When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i, name, camel,
			unlock = this.key( owner ),
			cache = this.cache[ unlock ];

		if ( key === undefined ) {
			this.cache[ unlock ] = {};

		} else {
			// Support array or space separated string of keys
			if ( jQuery.isArray( key ) ) {
				// If "name" is an array of keys...
				// When data is initially created, via ("key", "val") signature,
				// keys will be converted to camelCase.
				// Since there is no way to tell _how_ a key was added, remove
				// both plain key and camelCase key. #12786
				// This will only penalize the array argument path.
				name = key.concat( key.map( jQuery.camelCase ) );
			} else {
				camel = jQuery.camelCase( key );
				// Try the string as a key before any manipulation
				if ( key in cache ) {
					name = [ key, camel ];
				} else {
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					name = camel;
					name = name in cache ?
						[ name ] : ( name.match( rnotwhite ) || [] );
				}
			}

			i = name.length;
			while ( i-- ) {
				delete cache[ name[ i ] ];
			}
		}
	},
	hasData: function( owner ) {
		return !jQuery.isEmptyObject(
			this.cache[ owner[ this.expando ] ] || {}
		);
	},
	discard: function( owner ) {
		if ( owner[ this.expando ] ) {
			delete this.cache[ owner[ this.expando ] ];
		}
	}
};
var data_priv = new Data();

var data_user = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /([A-Z])/g;

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = data === "true" ? true :
					data === "false" ? false :
					data === "null" ? null :
					// Only convert to a number if it doesn't change the string
					+data + "" === data ? +data :
					rbrace.test( data ) ? jQuery.parseJSON( data ) :
					data;
			} catch( e ) {}

			// Make sure we set the data so it isn't changed later
			data_user.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend({
	hasData: function( elem ) {
		return data_user.hasData( elem ) || data_priv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return data_user.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		data_user.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to data_priv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return data_priv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		data_priv.remove( elem, name );
	}
});

jQuery.fn.extend({
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = data_user.get( elem );

				if ( elem.nodeType === 1 && !data_priv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE11+
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice(5) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					data_priv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each(function() {
				data_user.set( this, key );
			});
		}

		return access( this, function( value ) {
			var data,
				camelKey = jQuery.camelCase( key );

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {
				// Attempt to get data from the cache
				// with the key as-is
				data = data_user.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to get data from the cache
				// with the key camelized
				data = data_user.get( elem, camelKey );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, camelKey, undefined );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each(function() {
				// First, attempt to store a copy or reference of any
				// data that might've been store with a camelCased key.
				var data = data_user.get( this, camelKey );

				// For HTML5 data-* attribute interop, we have to
				// store property names with dashes in a camelCase form.
				// This might not apply to all properties...*
				data_user.set( this, camelKey, value );

				// *... In the case of properties that might _actually_
				// have dashes, we need to also store a copy of that
				// unchanged property.
				if ( key.indexOf("-") !== -1 && data !== undefined ) {
					data_user.set( this, key, value );
				}
			});
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each(function() {
			data_user.remove( this, key );
		});
	}
});


jQuery.extend({
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = data_priv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray( data ) ) {
					queue = data_priv.access( elem, type, jQuery.makeArray(data) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return data_priv.get( elem, key ) || data_priv.access( elem, key, {
			empty: jQuery.Callbacks("once memory").add(function() {
				data_priv.remove( elem, [ type + "queue", key ] );
			})
		});
	}
});

jQuery.fn.extend({
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[0], type );
		}

		return data === undefined ?
			this :
			this.each(function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[0] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			});
	},
	dequeue: function( type ) {
		return this.each(function() {
			jQuery.dequeue( this, type );
		});
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},
	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = data_priv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
});
var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;

var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHidden = function( elem, el ) {
		// isHidden might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;
		return jQuery.css( elem, "display" ) === "none" || !jQuery.contains( elem.ownerDocument, elem );
	};

var rcheckableType = (/^(?:checkbox|radio)$/i);



(function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Safari<=5.1
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Safari<=5.1, Android<4.2
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE<=11+
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
})();
var strundefined = typeof undefined;



support.focusinBubbles = "onfocusin" in window;


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu)|click/,
	rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)$/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = data_priv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !(events = elemData.events) ) {
			events = elemData.events = {};
		}
		if ( !(eventHandle = elemData.handle) ) {
			eventHandle = elemData.handle = function( e ) {
				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== strundefined && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[t] ) || [];
			type = origType = tmp[1];
			namespaces = ( tmp[2] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend({
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join(".")
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !(handlers = events[ type ]) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup || special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle, false );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = data_priv.hasData( elem ) && data_priv.get( elem );

		if ( !elemData || !(events = elemData.events) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[t] ) || [];
			type = origType = tmp[1];
			namespaces = ( tmp[2] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[2] && new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector || selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown || special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			delete elemData.handle;
			data_priv.remove( elem, "events" );
		}
	},

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split(".") : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf(".") >= 0 ) {
			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split(".");
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf(":") < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join(".");
		event.namespace_re = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === (elem.ownerDocument || document) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( (cur = eventPath[i++]) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( data_priv.get( cur, "events" ) || {} )[ event.type ] && data_priv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && jQuery.acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( (!special._default || special._default.apply( eventPath.pop(), data ) === false) &&
				jQuery.acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	dispatch: function( event ) {

		// Make a writable jQuery.Event from the native event object
		event = jQuery.event.fix( event );

		var i, j, ret, matched, handleObj,
			handlerQueue = [],
			args = slice.call( arguments ),
			handlers = ( data_priv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[0] = event;
		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( (matched = handlerQueue[ i++ ]) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( (handleObj = matched.handlers[ j++ ]) && !event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.namespace_re || event.namespace_re.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( (jQuery.event.special[ handleObj.origType ] || {}).handle || handleObj.handler )
							.apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( (event.result = ret) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, matches, sel, handleObj,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		// Black-hole SVG <use> instance trees (#13180)
		// Avoid non-left-click bubbling in Firefox (#3861)
		if ( delegateCount && cur.nodeType && (!event.button || event.type !== "click") ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.disabled !== true || event.type !== "click" ) {
					matches = [];
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matches[ sel ] === undefined ) {
							matches[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) >= 0 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matches[ sel ] ) {
							matches.push( handleObj );
						}
					}
					if ( matches.length ) {
						handlerQueue.push({ elem: cur, handlers: matches });
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		if ( delegateCount < handlers.length ) {
			handlerQueue.push({ elem: this, handlers: handlers.slice( delegateCount ) });
		}

		return handlerQueue;
	},

	// Includes some event props shared by KeyEvent and MouseEvent
	props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),

	fixHooks: {},

	keyHooks: {
		props: "char charCode key keyCode".split(" "),
		filter: function( event, original ) {

			// Add which for key events
			if ( event.which == null ) {
				event.which = original.charCode != null ? original.charCode : original.keyCode;
			}

			return event;
		}
	},

	mouseHooks: {
		props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
		filter: function( event, original ) {
			var eventDoc, doc, body,
				button = original.button;

			// Calculate pageX/Y if missing and clientX/Y available
			if ( event.pageX == null && original.clientX != null ) {
				eventDoc = event.target.ownerDocument || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;

				event.pageX = original.clientX + ( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) - ( doc && doc.clientLeft || body && body.clientLeft || 0 );
				event.pageY = original.clientY + ( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) - ( doc && doc.clientTop  || body && body.clientTop  || 0 );
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			// Note: button is not normalized, so don't use it
			if ( !event.which && button !== undefined ) {
				event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}

			return event;
		}
	},

	fix: function( event ) {
		if ( event[ jQuery.expando ] ) {
			return event;
		}

		// Create a writable copy of the event object and normalize some properties
		var i, prop, copy,
			type = event.type,
			originalEvent = event,
			fixHook = this.fixHooks[ type ];

		if ( !fixHook ) {
			this.fixHooks[ type ] = fixHook =
				rmouseEvent.test( type ) ? this.mouseHooks :
				rkeyEvent.test( type ) ? this.keyHooks :
				{};
		}
		copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

		event = new jQuery.Event( originalEvent );

		i = copy.length;
		while ( i-- ) {
			prop = copy[ i ];
			event[ prop ] = originalEvent[ prop ];
		}

		// Support: Cordova 2.5 (WebKit) (#13255)
		// All events should have a target; Cordova deviceready doesn't
		if ( !event.target ) {
			event.target = document;
		}

		// Support: Safari 6.0+, Chrome<28
		// Target should not be a text node (#504, #13143)
		if ( event.target.nodeType === 3 ) {
			event.target = event.target.parentNode;
		}

		return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
	},

	special: {
		load: {
			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {
			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {
			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	},

	simulate: function( type, elem, event, bubble ) {
		// Piggyback on a donor event to simulate a different one.
		// Fake originalEvent to avoid donor's stopPropagation, but if the
		// simulated event prevents default then we do the same on the donor.
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true,
				originalEvent: {}
			}
		);
		if ( bubble ) {
			jQuery.event.trigger( e, null, elem );
		} else {
			jQuery.event.dispatch.call( elem, e );
		}
		if ( e.isDefaultPrevented() ) {
			event.preventDefault();
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle, false );
	}
};

jQuery.Event = function( src, props ) {
	// Allow instantiation without the 'new' keyword
	if ( !(this instanceof jQuery.Event) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&
				// Support: Android<4.0
				src.returnValue === false ?
			returnTrue :
			returnFalse;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && e.preventDefault ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && e.stopPropagation ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && e.stopImmediatePropagation ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Create mouseenter/leave events using mouseover/out and event-time checks
// Support: Chrome 15+
jQuery.each({
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mousenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || (related !== target && !jQuery.contains( target, related )) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
});

// Support: Firefox, Chrome, Safari
// Create "bubbling" focus and blur events
if ( !support.focusinBubbles ) {
	jQuery.each({ focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ), true );
			};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = data_priv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				data_priv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = data_priv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					data_priv.remove( doc, fix );

				} else {
					data_priv.access( doc, fix, attaches );
				}
			}
		};
	});
}

jQuery.fn.extend({

	on: function( types, selector, data, fn, /*INTERNAL*/ one ) {
		var origFn, type;

		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				this.on( type, selector, data, types[ type ], one );
			}
			return this;
		}

		if ( data == null && fn == null ) {
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return this;
		}

		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return this.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		});
	},
	one: function( types, selector, data, fn ) {
		return this.on( types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {
			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {
			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {
			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each(function() {
			jQuery.event.remove( this, types, fn, selector );
		});
	},

	trigger: function( type, data ) {
		return this.each(function() {
			jQuery.event.trigger( type, data, this );
		});
	},
	triggerHandler: function( type, data ) {
		var elem = this[0];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
});


var
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
	rtagName = /<([\w:]+)/,
	rhtml = /<|&#?\w+;/,
	rnoInnerhtml = /<(?:script|style|link)/i,
	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptType = /^$|\/(?:java|ecma)script/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,

	// We have to close these tags to support XHTML (#13200)
	wrapMap = {

		// Support: IE9
		option: [ 1, "<select multiple='multiple'>", "</select>" ],

		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

		_default: [ 0, "", "" ]
	};

// Support: IE9
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: 1.x compatibility
// Manipulating tables requires a tbody
function manipulationTarget( elem, content ) {
	return jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?

		elem.getElementsByTagName("tbody")[0] ||
			elem.appendChild( elem.ownerDocument.createElement("tbody") ) :
		elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute("type");
	}

	return elem;
}

// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		data_priv.set(
			elems[ i ], "globalEval", !refElements || data_priv.get( refElements[ i ], "globalEval" )
		);
	}
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( data_priv.hasData( src ) ) {
		pdataOld = data_priv.access( src );
		pdataCur = data_priv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( data_user.hasData( src ) ) {
		udataOld = data_user.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		data_user.set( dest, udataCur );
	}
}

function getAll( context, tag ) {
	var ret = context.getElementsByTagName ? context.getElementsByTagName( tag || "*" ) :
			context.querySelectorAll ? context.querySelectorAll( tag || "*" ) :
			[];

	return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
		jQuery.merge( [ context ], ret ) :
		ret;
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

jQuery.extend({
	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	buildFragment: function( elems, context, scripts, selection ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;

		for ( ; i < l; i++ ) {
			elem = elems[ i ];

			if ( elem || elem === 0 ) {

				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
					// Support: QtWebKit, PhantomJS
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );

				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement("div") );

					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + elem.replace( rxhtmlTag, "<$1></$2>" ) + wrap[ 2 ];

					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}

					// Support: QtWebKit, PhantomJS
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );

					// Remember the top-level container
					tmp = fragment.firstChild;

					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}

		// Remove wrapper from fragment
		fragment.textContent = "";

		i = 0;
		while ( (elem = nodes[ i++ ]) ) {

			// #4087 - If origin and destination elements are the same, and this is
			// that element, do not do anything
			if ( selection && jQuery.inArray( elem, selection ) !== -1 ) {
				continue;
			}

			contains = jQuery.contains( elem.ownerDocument, elem );

			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );

			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}

			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( (elem = tmp[ j++ ]) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}

		return fragment;
	},

	cleanData: function( elems ) {
		var data, elem, type, key,
			special = jQuery.event.special,
			i = 0;

		for ( ; (elem = elems[ i ]) !== undefined; i++ ) {
			if ( jQuery.acceptData( elem ) ) {
				key = elem[ data_priv.expando ];

				if ( key && (data = data_priv.cache[ key ]) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}
					if ( data_priv.cache[ key ] ) {
						// Discard any remaining `private` data
						delete data_priv.cache[ key ];
					}
				}
			}
			// Discard any remaining `user` data
			delete data_user.cache[ elem[ data_user.expando ] ];
		}
	}
});

jQuery.fn.extend({
	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each(function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				});
		}, null, value, arguments.length );
	},

	append: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		});
	},

	prepend: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		});
	},

	before: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		});
	},

	after: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		});
	},

	remove: function( selector, keepData /* Internal Use Only */ ) {
		var elem,
			elems = selector ? jQuery.filter( selector, this ) : this,
			i = 0;

		for ( ; (elem = elems[i]) != null; i++ ) {
			if ( !keepData && elem.nodeType === 1 ) {
				jQuery.cleanData( getAll( elem ) );
			}

			if ( elem.parentNode ) {
				if ( keepData && jQuery.contains( elem.ownerDocument, elem ) ) {
					setGlobalEval( getAll( elem, "script" ) );
				}
				elem.parentNode.removeChild( elem );
			}
		}

		return this;
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; (elem = this[i]) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map(function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		});
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = value.replace( rxhtmlTag, "<$1></$2>" );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var arg = arguments[ 0 ];

		// Make the changes, replacing each context element with the new content
		this.domManip( arguments, function( elem ) {
			arg = this.parentNode;

			jQuery.cleanData( getAll( this ) );

			if ( arg ) {
				arg.replaceChild( elem, this );
			}
		});

		// Force removal if there was no new content (e.g., from empty arguments)
		return arg && (arg.length || arg.nodeType) ? this : this.remove();
	},

	detach: function( selector ) {
		return this.remove( selector, true );
	},

	domManip: function( args, callback ) {

		// Flatten any nested arrays
		args = concat.apply( [], args );

		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = this.length,
			set = this,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );

		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return this.each(function( index ) {
				var self = set.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				self.domManip( args, callback );
			});
		}

		if ( l ) {
			fragment = jQuery.buildFragment( args, this[ 0 ].ownerDocument, false, this );
			first = fragment.firstChild;

			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}

			if ( first ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;

				// Use the original fragment for the last item instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;

					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );

						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
							// Support: QtWebKit
							// jQuery.merge because push.apply(_, arraylike) throws
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}

					callback.call( this[ i ], node, i );
				}

				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;

					// Reenable scripts
					jQuery.map( scripts, restoreScript );

					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!data_priv.access( node, "globalEval" ) && jQuery.contains( doc, node ) ) {

							if ( node.src ) {
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
							}
						}
					}
				}
			}
		}

		return this;
	}
});

jQuery.each({
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: QtWebKit
			// .get() because push.apply(_, arraylike) throws
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
});


var iframe,
	elemdisplay = {};

/**
 * Retrieve the actual display of a element
 * @param {String} name nodeName of the element
 * @param {Object} doc Document object
 */
// Called only from within defaultDisplay
function actualDisplay( name, doc ) {
	var style,
		elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),

		// getDefaultComputedStyle might be reliably used only on attached element
		display = window.getDefaultComputedStyle && ( style = window.getDefaultComputedStyle( elem[ 0 ] ) ) ?

			// Use of this method is a temporary fix (more like optimization) until something better comes along,
			// since it was removed from specification and supported only in FF
			style.display : jQuery.css( elem[ 0 ], "display" );

	// We don't have any data stored on the element,
	// so use "detach" method as fast way to get rid of the element
	elem.detach();

	return display;
}

/**
 * Try to determine the default display value of an element
 * @param {String} nodeName
 */
function defaultDisplay( nodeName ) {
	var doc = document,
		display = elemdisplay[ nodeName ];

	if ( !display ) {
		display = actualDisplay( nodeName, doc );

		// If the simple way fails, read from inside an iframe
		if ( display === "none" || !display ) {

			// Use the already-created iframe if possible
			iframe = (iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" )).appendTo( doc.documentElement );

			// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
			doc = iframe[ 0 ].contentDocument;

			// Support: IE
			doc.write();
			doc.close();

			display = actualDisplay( nodeName, doc );
			iframe.detach();
		}

		// Store the correct default display
		elemdisplay[ nodeName ] = display;
	}

	return display;
}
var rmargin = (/^margin/);

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {
		// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		if ( elem.ownerDocument.defaultView.opener ) {
			return elem.ownerDocument.defaultView.getComputedStyle( elem, null );
		}

		return window.getComputedStyle( elem, null );
	};



function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		style = elem.style;

	computed = computed || getStyles( elem );

	// Support: IE9
	// getPropertyValue is only needed for .css('filter') (#12537)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];
	}

	if ( computed ) {

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// Support: iOS < 6
		// A tribute to the "awesome hack by Dean Edwards"
		// iOS < 6 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels
		// this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values
		if ( rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?
		// Support: IE
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {
	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {
				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return (this.get = hookFn).apply( this, arguments );
		}
	};
}


(function() {
	var pixelPositionVal, boxSizingReliableVal,
		docElem = document.documentElement,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	if ( !div.style ) {
		return;
	}

	// Support: IE9-11+
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;" +
		"position:absolute";
	container.appendChild( div );

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computePixelPositionAndBoxSizingReliable() {
		div.style.cssText =
			// Support: Firefox<29, Android 2.3
			// Vendor-prefix box-sizing
			"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;" +
			"box-sizing:border-box;display:block;margin-top:1%;top:1%;" +
			"border:1px;padding:1px;width:4px;position:absolute";
		div.innerHTML = "";
		docElem.appendChild( container );

		var divStyle = window.getComputedStyle( div, null );
		pixelPositionVal = divStyle.top !== "1%";
		boxSizingReliableVal = divStyle.width === "4px";

		docElem.removeChild( container );
	}

	// Support: node.js jsdom
	// Don't assume that getComputedStyle is a property of the global object
	if ( window.getComputedStyle ) {
		jQuery.extend( support, {
			pixelPosition: function() {

				// This test is executed only once but we still do memoizing
				// since we can use the boxSizingReliable pre-computing.
				// No need to check if the test was already performed, though.
				computePixelPositionAndBoxSizingReliable();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				if ( boxSizingReliableVal == null ) {
					computePixelPositionAndBoxSizingReliable();
				}
				return boxSizingReliableVal;
			},
			reliableMarginRight: function() {

				// Support: Android 2.3
				// Check if div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container. (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// This support function is only executed once so no memoizing is needed.
				var ret,
					marginDiv = div.appendChild( document.createElement( "div" ) );

				// Reset CSS: box-sizing; display; margin; border; padding
				marginDiv.style.cssText = div.style.cssText =
					// Support: Firefox<29, Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
					"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
				marginDiv.style.marginRight = marginDiv.style.width = "0";
				div.style.width = "1px";
				docElem.appendChild( container );

				ret = !parseFloat( window.getComputedStyle( marginDiv, null ).marginRight );

				docElem.removeChild( container );
				div.removeChild( marginDiv );

				return ret;
			}
		});
	}
})();


// A method for quickly swapping in/out CSS properties to get correct calculations.
jQuery.swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var
	// Swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),
	rrelNum = new RegExp( "^([+-])=(" + pnum + ")", "i" ),

	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "O", "Moz", "ms" ];

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( style, name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in style ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[0].toUpperCase() + name.slice(1),
		origName = name,
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in style ) {
			return name;
		}
	}

	return origName;
}

function setPositiveNumber( elem, value, subtract ) {
	var matches = rnumsplit.exec( value );
	return matches ?
		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i = extra === ( isBorderBox ? "border" : "content" ) ?
		// If we already have the right measurement, avoid augmentation
		4 :
		// Otherwise initialize for horizontal or vertical properties
		name === "width" ? 1 : 0,

		val = 0;

	for ( ; i < 4; i += 2 ) {
		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {
			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {
			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var valueIsBorderBox = true,
		val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
		styles = getStyles( elem ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {
		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test(val) ) {
			return val;
		}

		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

function showHide( elements, show ) {
	var display, elem, hidden,
		values = [],
		index = 0,
		length = elements.length;

	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		values[ index ] = data_priv.get( elem, "olddisplay" );
		display = elem.style.display;
		if ( show ) {
			// Reset the inline display of this element to learn if it is
			// being hidden by cascaded rules or not
			if ( !values[ index ] && display === "none" ) {
				elem.style.display = "";
			}

			// Set elements which have been overridden with display: none
			// in a stylesheet to whatever the default browser style is
			// for such an element
			if ( elem.style.display === "" && isHidden( elem ) ) {
				values[ index ] = data_priv.access( elem, "olddisplay", defaultDisplay(elem.nodeName) );
			}
		} else {
			hidden = isHidden( elem );

			if ( display !== "none" || !hidden ) {
				data_priv.set( elem, "olddisplay", hidden ? display : jQuery.css( elem, "display" ) );
			}
		}
	}

	// Set the display of most of the elements in a second loop
	// to avoid the constant reflow
	for ( index = 0; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}
		if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
			elem.style.display = show ? values[ index ] || "" : "none";
		}
	}

	return elements;
}

jQuery.extend({

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( style, origName ) );

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && (ret = rrelNum.exec( value )) ) {
				value = ( ret[1] + 1 ) * ret[2] + parseFloat( jQuery.css( elem, name ) );
				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number, add 'px' to the (except for certain CSS properties)
			if ( type === "number" && !jQuery.cssNumber[ origName ] ) {
				value += "px";
			}

			// Support: IE9-11+
			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !("set" in hooks) || (value = hooks.set( elem, value, extra )) !== undefined ) {
				style[ name ] = value;
			}

		} else {
			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks && (ret = hooks.get( elem, false, extra )) !== undefined ) {
				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( elem.style, origName ) );

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || jQuery.isNumeric( num ) ? num || 0 : val;
		}
		return val;
	}
});

jQuery.each([ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) && elem.offsetWidth === 0 ?
					jQuery.swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, name, extra );
					}) :
					getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var styles = extra && getStyles( elem );
			return setPositiveNumber( elem, value, extra ?
				augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				) : 0
			);
		}
	};
});

// Support: Android 2.3
jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
	function( elem, computed ) {
		if ( computed ) {
			return jQuery.swap( elem, { "display": "inline-block" },
				curCSS, [ elem, "marginRight" ] );
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each({
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split(" ") : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
});

jQuery.fn.extend({
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	},
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each(function() {
			if ( isHidden( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		});
	}
});


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || "swing";
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			if ( tween.elem[ tween.prop ] != null &&
				(!tween.elem.style || tween.elem.style[ tween.prop ] == null) ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );
			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {
			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.style && ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null || jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE9
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	}
};

jQuery.fx = Tween.prototype.init;

// Back Compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rfxnum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" ),
	rrun = /queueHooks$/,
	animationPrefilters = [ defaultPrefilter ],
	tweeners = {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value ),
				target = tween.cur(),
				parts = rfxnum.exec( value ),
				unit = parts && parts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

				// Starting value computation is required for potential unit mismatches
				start = ( jQuery.cssNumber[ prop ] || unit !== "px" && +target ) &&
					rfxnum.exec( jQuery.css( tween.elem, prop ) ),
				scale = 1,
				maxIterations = 20;

			if ( start && start[ 3 ] !== unit ) {
				// Trust units reported by jQuery.css
				unit = unit || start[ 3 ];

				// Make sure we update the tween properties later on
				parts = parts || [];

				// Iteratively approximate from a nonzero starting point
				start = +target || 1;

				do {
					// If previous iteration zeroed out, double until we get *something*.
					// Use string for doubling so we don't accidentally see scale as unchanged below
					scale = scale || ".5";

					// Adjust and apply
					start = start / scale;
					jQuery.style( tween.elem, prop, start + unit );

				// Update scale, tolerating zero or NaN from tween.cur(),
				// break the loop if scale is unchanged or perfect, or if we've just had enough
				} while ( scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations );
			}

			// Update tween properties
			if ( parts ) {
				start = tween.start = +start || +target || 0;
				tween.unit = unit;
				// If a +=/-= token was provided, we're doing a relative animation
				tween.end = parts[ 1 ] ?
					start + ( parts[ 1 ] + 1 ) * parts[ 2 ] :
					+parts[ 2 ];
			}

			return tween;
		} ]
	};

// Animations created synchronously will run synchronously
function createFxNow() {
	setTimeout(function() {
		fxNow = undefined;
	});
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4 ; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( tweeners[ prop ] || [] ).concat( tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( (tween = collection[ index ].call( animation, prop, value )) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	/* jshint validthis: true */
	var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHidden( elem ),
		dataShow = data_priv.get( elem, "fxshow" );

	// Handle queue: false promises
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always(function() {
			// Ensure the complete handler is called before this completes
			anim.always(function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			});
		});
	}

	// Height/width overflow pass
	if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
		// Make sure that nothing sneaks out
		// Record all 3 overflow attributes because IE9-10 do not
		// change the overflow attribute when overflowX and
		// overflowY are set to the same value
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Set display property to inline-block for height/width
		// animations on inline elements that are having width/height animated
		display = jQuery.css( elem, "display" );

		// Test default display if display is currently "none"
		checkDisplay = display === "none" ?
			data_priv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;

		if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
			style.display = "inline-block";
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always(function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		});
	}

	// show/hide pass
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.exec( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// If there is dataShow left over from a stopped hide or show and we are going to proceed with show, we should pretend to be hidden
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );

		// Any non-fx value stops us from restoring the original display value
		} else {
			display = undefined;
		}
	}

	if ( !jQuery.isEmptyObject( orig ) ) {
		if ( dataShow ) {
			if ( "hidden" in dataShow ) {
				hidden = dataShow.hidden;
			}
		} else {
			dataShow = data_priv.access( elem, "fxshow", {} );
		}

		// Store state if its toggle - enables .stop().toggle() to "reverse"
		if ( toggle ) {
			dataShow.hidden = !hidden;
		}
		if ( hidden ) {
			jQuery( elem ).show();
		} else {
			anim.done(function() {
				jQuery( elem ).hide();
			});
		}
		anim.done(function() {
			var prop;

			data_priv.remove( elem, "fxshow" );
			for ( prop in orig ) {
				jQuery.style( elem, prop, orig[ prop ] );
			}
		});
		for ( prop in orig ) {
			tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );

			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = tween.start;
				if ( hidden ) {
					tween.end = tween.start;
					tween.start = prop === "width" || prop === "height" ? 1 : 0;
				}
			}
		}

	// If this is a noop like .hide().hide(), restore an overwritten display value
	} else if ( (display === "none" ? defaultDisplay( elem.nodeName ) : display) === "inline" ) {
		style.display = display;
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = animationPrefilters.length,
		deferred = jQuery.Deferred().always( function() {
			// Don't match elem in the :animated selector
			delete tick.elem;
		}),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
				// Support: Android 2.3
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length ; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ]);

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise({
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, { specialEasing: {} }, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,
					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		}),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length ; index++ ) {
		result = animationPrefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		})
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.split(" ");
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length ; index++ ) {
			prop = props[ index ];
			tweeners[ prop ] = tweeners[ prop ] || [];
			tweeners[ prop ].unshift( callback );
		}
	},

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			animationPrefilters.unshift( callback );
		} else {
			animationPrefilters.push( callback );
		}
	}
});

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
		opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend({
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHidden ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate({ opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {
				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || data_priv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each(function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = data_priv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && (type == null || timers[ index ].queue === type) ) {
					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		});
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each(function() {
			var index,
				data = data_priv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		});
	}
});

jQuery.each([ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
});

// Generate shortcuts for custom animations
jQuery.each({
	slideDown: genFx("show"),
	slideUp: genFx("hide"),
	slideToggle: genFx("toggle"),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
});

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];
		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;

jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	clearInterval( timerId );
	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,
	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = setTimeout( next, time );
		hooks.stop = function() {
			clearTimeout( timeout );
		};
	});
};


(function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: iOS<=5.1, Android<=4.2+
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE<=11+
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: Android<=2.3
	// Options inside disabled selects are incorrectly marked as disabled
	select.disabled = true;
	support.optDisabled = !opt.disabled;

	// Support: IE<=11+
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
})();


var nodeHook, boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend({
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each(function() {
			jQuery.removeAttr( this, name );
		});
	}
});

jQuery.extend({
	attr: function( elem, name, value ) {
		var hooks, ret,
			nType = elem.nodeType;

		// don't get/set attributes on text, comment and attribute nodes
		if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === strundefined ) {
			return jQuery.prop( elem, name, value );
		}

		// All attributes are lowercase
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			name = name.toLowerCase();
			hooks = jQuery.attrHooks[ name ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
		}

		if ( value !== undefined ) {

			if ( value === null ) {
				jQuery.removeAttr( elem, name );

			} else if ( hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ) {
				return ret;

			} else {
				elem.setAttribute( name, value + "" );
				return value;
			}

		} else if ( hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ) {
			return ret;

		} else {
			ret = jQuery.find.attr( elem, name );

			// Non-existent attributes return null, we normalize to undefined
			return ret == null ?
				undefined :
				ret;
		}
	},

	removeAttr: function( elem, value ) {
		var name, propName,
			i = 0,
			attrNames = value && value.match( rnotwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( (name = attrNames[i++]) ) {
				propName = jQuery.propFix[ name ] || name;

				// Boolean attributes get special treatment (#10870)
				if ( jQuery.expr.match.bool.test( name ) ) {
					// Set corresponding property to false
					elem[ propName ] = false;
				}

				elem.removeAttribute( name );
			}
		}
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					jQuery.nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	}
});

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {
			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};
jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle;
		if ( !isXML ) {
			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ name ];
			attrHandle[ name ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				name.toLowerCase() :
				null;
			attrHandle[ name ] = handle;
		}
		return ret;
	};
});




var rfocusable = /^(?:input|select|textarea|button)$/i;

jQuery.fn.extend({
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each(function() {
			delete this[ jQuery.propFix[ name ] || name ];
		});
	}
});

jQuery.extend({
	propFix: {
		"for": "htmlFor",
		"class": "className"
	},

	prop: function( elem, name, value ) {
		var ret, hooks, notxml,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		notxml = nType !== 1 || !jQuery.isXMLDoc( elem );

		if ( notxml ) {
			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			return hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ?
				ret :
				( elem[ name ] = value );

		} else {
			return hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ?
				ret :
				elem[ name ];
		}
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {
				return elem.hasAttribute( "tabindex" ) || rfocusable.test( elem.nodeName ) || elem.href ?
					elem.tabIndex :
					-1;
			}
		}
	}
});

if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {
			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		}
	};
}

jQuery.each([
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
});




var rclass = /[\t\r\n\f]/g;

jQuery.fn.extend({
	addClass: function( value ) {
		var classes, elem, cur, clazz, j, finalValue,
			proceed = typeof value === "string" && value,
			i = 0,
			len = this.length;

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( j ) {
				jQuery( this ).addClass( value.call( this, j, this.className ) );
			});
		}

		if ( proceed ) {
			// The disjunction here is for better compressibility (see removeClass)
			classes = ( value || "" ).match( rnotwhite ) || [];

			for ( ; i < len; i++ ) {
				elem = this[ i ];
				cur = elem.nodeType === 1 && ( elem.className ?
					( " " + elem.className + " " ).replace( rclass, " " ) :
					" "
				);

				if ( cur ) {
					j = 0;
					while ( (clazz = classes[j++]) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( elem.className !== finalValue ) {
						elem.className = finalValue;
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, clazz, j, finalValue,
			proceed = arguments.length === 0 || typeof value === "string" && value,
			i = 0,
			len = this.length;

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( j ) {
				jQuery( this ).removeClass( value.call( this, j, this.className ) );
			});
		}
		if ( proceed ) {
			classes = ( value || "" ).match( rnotwhite ) || [];

			for ( ; i < len; i++ ) {
				elem = this[ i ];
				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( elem.className ?
					( " " + elem.className + " " ).replace( rclass, " " ) :
					""
				);

				if ( cur ) {
					j = 0;
					while ( (clazz = classes[j++]) ) {
						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) >= 0 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = value ? jQuery.trim( cur ) : "";
					if ( elem.className !== finalValue ) {
						elem.className = finalValue;
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( i ) {
				jQuery( this ).toggleClass( value.call(this, i, this.className, stateVal), stateVal );
			});
		}

		return this.each(function() {
			if ( type === "string" ) {
				// Toggle individual class names
				var className,
					i = 0,
					self = jQuery( this ),
					classNames = value.match( rnotwhite ) || [];

				while ( (className = classNames[ i++ ]) ) {
					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( type === strundefined || type === "boolean" ) {
				if ( this.className ) {
					// store className if set
					data_priv.set( this, "__className__", this.className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				this.className = this.className || value === false ? "" : data_priv.get( this, "__className__" ) || "";
			}
		});
	},

	hasClass: function( selector ) {
		var className = " " + selector + " ",
			i = 0,
			l = this.length;
		for ( ; i < l; i++ ) {
			if ( this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf( className ) >= 0 ) {
				return true;
			}
		}

		return false;
	}
});




var rreturn = /\r/g;

jQuery.fn.extend({
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[0];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] || jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks && "get" in hooks && (ret = hooks.get( elem, "value" )) !== undefined ) {
					return ret;
				}

				ret = elem.value;

				return typeof ret === "string" ?
					// Handle most common string cases
					ret.replace(rreturn, "") :
					// Handle cases where value is null/undef or number
					ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each(function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				});
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !("set" in hooks) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		});
	}
});

jQuery.extend({
	valHooks: {
		option: {
			get: function( elem ) {
				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :
					// Support: IE10-11+
					// option.text throws exceptions (#14686, #14858)
					jQuery.trim( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one" || index < 0,
					values = one ? null : [],
					max = one ? index + 1 : options.length,
					i = index < 0 ?
						max :
						one ? index : 0;

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// IE6-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&
							// Don't return options that are disabled or in a disabled optgroup
							( support.optDisabled ? !option.disabled : option.getAttribute( "disabled" ) === null ) &&
							( !option.parentNode.disabled || !jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];
					if ( (option.selected = jQuery.inArray( option.value, values ) >= 0) ) {
						optionSet = true;
					}
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
});

// Radios and checkboxes getter/setter
jQuery.each([ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery(elem).val(), value ) >= 0 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute("value") === null ? "on" : elem.value;
		};
	}
});




// Return jQuery for attributes-only inclusion


jQuery.each( ("blur focus focusin focusout load resize scroll unload click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup error contextmenu").split(" "), function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
});

jQuery.fn.extend({
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	},

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {
		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ? this.off( selector, "**" ) : this.off( types, selector || "**", fn );
	}
});


var nonce = jQuery.now();

var rquery = (/\?/);



// Support: Android 2.3
// Workaround failure to string-cast null input
jQuery.parseJSON = function( data ) {
	return JSON.parse( data + "" );
};


// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, tmp;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE9
	try {
		tmp = new DOMParser();
		xml = tmp.parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rhash = /#.*$/,
	rts = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,
	rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Document location
	ajaxLocation = window.location.href,

	// Segment location into parts
	ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];

		if ( jQuery.isFunction( func ) ) {
			// For each dataType in the dataTypeExpression
			while ( (dataType = dataTypes[i++]) ) {
				// Prepend if requested
				if ( dataType[0] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					(structure[ dataType ] = structure[ dataType ] || []).unshift( func );

				// Otherwise append
				} else {
					(structure[ dataType ] = structure[ dataType ] || []).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		});
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || (deep = {}) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {
		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[0] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}
		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},
		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

		// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {
								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s[ "throws" ] ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current };
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend({

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: ajaxLocation,
		type: "GET",
		isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /xml/,
			html: /html/,
			json: /json/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": jQuery.parseJSON,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,
			// URL without anti-cache param
			cacheURL,
			// Response headers
			responseHeadersString,
			responseHeaders,
			// timeout handle
			timeoutTimer,
			// Cross-domain detection vars
			parts,
			// To know if global events are to be dispatched
			fireGlobals,
			// Loop variable
			i,
			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),
			// Callbacks context
			callbackContext = s.context || s,
			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context && ( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,
			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks("once memory"),
			// Status-dependent callbacks
			statusCode = s.statusCode || {},
			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},
			// The jqXHR state
			state = 0,
			// Default abort message
			strAbort = "canceled",
			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( state === 2 ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( (match = rheaders.exec( responseHeadersString )) ) {
								responseHeaders[ match[1].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return state === 2 ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					var lname = name.toLowerCase();
					if ( !state ) {
						name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( !state ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( state < 2 ) {
							for ( code in map ) {
								// Lazy-add the new callback in a way that preserves old ones
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						} else {
							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR ).complete = completeDeferred.add;
		jqXHR.success = jqXHR.done;
		jqXHR.error = jqXHR.fail;

		// Remove hash character (#7531: and string promotion)
		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || ajaxLocation ) + "" ).replace( rhash, "" )
			.replace( rprotocol, ajaxLocParts[ 1 ] + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];

		// A cross-domain request is in order when we have a protocol:host:port mismatch
		if ( s.crossDomain == null ) {
			parts = rurl.exec( s.url.toLowerCase() );
			s.crossDomain = !!( parts &&
				( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
					( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
						( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
			);
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( state === 2 ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger("ajaxStart");
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		cacheURL = s.url;

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add anti-cache in url if needed
			if ( s.cache === false ) {
				s.url = rts.test( cacheURL ) ?

					// If there is already a '_' parameter, set its value
					cacheURL.replace( rts, "$1_=" + nonce++ ) :

					// Otherwise add one to the end
					cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
			}
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[0] ] ?
				s.accepts[ s.dataTypes[0] ] + ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend && ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		for ( i in { success: 1, error: 1, complete: 1 } ) {
			jqXHR[ i ]( s[ i ] );
		}

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}
			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = setTimeout(function() {
					jqXHR.abort("timeout");
				}, s.timeout );
			}

			try {
				state = 1;
				transport.send( requestHeaders, done );
			} catch ( e ) {
				// Propagate exception as error if not done
				if ( state < 2 ) {
					done( -1, e );
				// Simply rethrow otherwise
				} else {
					throw e;
				}
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Called once
			if ( state === 2 ) {
				return;
			}

			// State is "done" now
			state = 2;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader("Last-Modified");
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader("etag");
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {
				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger("ajaxStop");
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
});

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {
		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		return jQuery.ajax({
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		});
	};
});


jQuery._evalUrl = function( url ) {
	return jQuery.ajax({
		url: url,
		type: "GET",
		dataType: "script",
		async: false,
		global: false,
		"throws": true
	});
};


jQuery.fn.extend({
	wrapAll: function( html ) {
		var wrap;

		if ( jQuery.isFunction( html ) ) {
			return this.each(function( i ) {
				jQuery( this ).wrapAll( html.call(this, i) );
			});
		}

		if ( this[ 0 ] ) {

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map(function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			}).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each(function( i ) {
				jQuery( this ).wrapInner( html.call(this, i) );
			});
		}

		return this.each(function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		});
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each(function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call(this, i) : html );
		});
	},

	unwrap: function() {
		return this.parent().each(function() {
			if ( !jQuery.nodeName( this, "body" ) ) {
				jQuery( this ).replaceWith( this.childNodes );
			}
		}).end();
	}
});


jQuery.expr.filters.hidden = function( elem ) {
	// Support: Opera <= 12.12
	// Opera reports offsetWidths and offsetHeights less than zero on some elements
	return elem.offsetWidth <= 0 && elem.offsetHeight <= 0;
};
jQuery.expr.filters.visible = function( elem ) {
	return !jQuery.expr.filters.hidden( elem );
};




var r20 = /%20/g,
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {
		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {
				// Treat each array item as a scalar.
				add( prefix, v );

			} else {
				// Item is non-scalar (array or object), encode its numeric index.
				buildParams( prefix + "[" + ( typeof v === "object" ? i : "" ) + "]", v, traditional, add );
			}
		});

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {
		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {
		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, value ) {
			// If value is a function, invoke it and return its value
			value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
			s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
		};

	// Set traditional to true for jQuery <= 1.3.2 behavior.
	if ( traditional === undefined ) {
		traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		});

	} else {
		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" ).replace( r20, "+" );
};

jQuery.fn.extend({
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map(function() {
			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		})
		.filter(function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		})
		.map(function( i, elem ) {
			var val = jQuery( this ).val();

			return val == null ?
				null :
				jQuery.isArray( val ) ?
					jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					}) :
					{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		}).get();
	}
});


jQuery.ajaxSettings.xhr = function() {
	try {
		return new XMLHttpRequest();
	} catch( e ) {}
};

var xhrId = 0,
	xhrCallbacks = {},
	xhrSuccessStatus = {
		// file protocol always yields status code 0, assume 200
		0: 200,
		// Support: IE9
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

// Support: IE9
// Open requests must be manually aborted on unload (#5280)
// See https://support.microsoft.com/kb/2856746 for more info
if ( window.attachEvent ) {
	window.attachEvent( "onunload", function() {
		for ( var key in xhrCallbacks ) {
			xhrCallbacks[ key ]();
		}
	});
}

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport(function( options ) {
	var callback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr(),
					id = ++xhrId;

				xhr.open( options.type, options.url, options.async, options.username, options.password );

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers["X-Requested-With"] ) {
					headers["X-Requested-With"] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							delete xhrCallbacks[ id ];
							callback = xhr.onload = xhr.onerror = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {
								complete(
									// file: protocol always yields status 0; see #8605, #14207
									xhr.status,
									xhr.statusText
								);
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,
									// Support: IE9
									// Accessing binary-data responseText throws an exception
									// (#11426)
									typeof xhr.responseText === "string" ? {
										text: xhr.responseText
									} : undefined,
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				xhr.onerror = callback("error");

				// Create the abort callback
				callback = xhrCallbacks[ id ] = callback("abort");

				try {
					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {
					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
});




// Install script dataType
jQuery.ajaxSetup({
	accepts: {
		script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /(?:java|ecma)script/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
});

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
});

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {
	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery("<script>").prop({
					async: true,
					charset: s.scriptCharset,
					src: s.url
				}).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
});




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup({
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
});

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" && !( s.contentType || "" ).indexOf("application/x-www-form-urlencoded") && rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters["script json"] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always(function() {
			// Restore preexisting value
			window[ callbackName ] = overwritten;

			// Save back as free
			if ( s[ callbackName ] ) {
				// make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		});

		// Delegate to script
		return "script";
	}
});




// data: string of html
// context (optional): If specified, the fragment will be created in this context, defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}
	context = context || document;

	var parsed = rsingleTag.exec( data ),
		scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[1] ) ];
	}

	parsed = jQuery.buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


// Keep a copy of the old load method
var _load = jQuery.fn.load;

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	if ( typeof url !== "string" && _load ) {
		return _load.apply( this, arguments );
	}

	var selector, type, response,
		self = this,
		off = url.indexOf(" ");

	if ( off >= 0 ) {
		selector = jQuery.trim( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax({
			url: url,

			// if "type" variable is undefined, then "GET" method will be used
			type: type,
			dataType: "html",
			data: params
		}).done(function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery("<div>").append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		}).complete( callback && function( jqXHR, status ) {
			self.each( callback, response || [ jqXHR.responseText, status, jqXHR ] );
		});
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [ "ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend" ], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
});




jQuery.expr.filters.animated = function( elem ) {
	return jQuery.grep(jQuery.timers, function( fn ) {
		return elem === fn.elem;
	}).length;
};




var docElem = window.document.documentElement;

/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf("auto") > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {
			options = options.call( elem, i, curOffset );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend({
	offset: function( options ) {
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each(function( i ) {
					jQuery.offset.setOffset( this, options, i );
				});
		}

		var docElem, win,
			elem = this[ 0 ],
			box = { top: 0, left: 0 },
			doc = elem && elem.ownerDocument;

		if ( !doc ) {
			return;
		}

		docElem = doc.documentElement;

		// Make sure it's not a disconnected DOM node
		if ( !jQuery.contains( docElem, elem ) ) {
			return box;
		}

		// Support: BlackBerry 5, iOS 3 (original iPhone)
		// If we don't have gBCR, just use 0,0 rather than error
		if ( typeof elem.getBoundingClientRect !== strundefined ) {
			box = elem.getBoundingClientRect();
		}
		win = getWindow( doc );
		return {
			top: box.top + win.pageYOffset - docElem.clientTop,
			left: box.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {
			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {
			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
			parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	offsetParent: function() {
		return this.map(function() {
			var offsetParent = this.offsetParent || docElem;

			while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) && jQuery.css( offsetParent, "position" ) === "static" ) ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || docElem;
		});
	}
});

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : window.pageXOffset,
					top ? val : window.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length, null );
	};
});

// Support: Safari<7+, Chrome<37+
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );
				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
});


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name }, function( defaultExtra, funcName ) {
		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {
					// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
					// isn't a whole lot we can do. See pull request at this URL for discussion:
					// https://github.com/jquery/jquery/pull/764
					return elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?
					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable, null );
		};
	});
});


// The number of elements contained in the matched element set
jQuery.fn.size = function() {
	return this.length;
};

jQuery.fn.andSelf = jQuery.fn.addBack;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	});
}




var
	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === strundefined ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;

}));

/* -------- studio/v2/js/bootstrap/3.3.4/bootstrap.js -------- */
/*!
 * Bootstrap v3.3.4 (http://getbootstrap.com)
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */

/*!
 * Generated using the Bootstrap Customizer (http://getbootstrap.com/customize/?id=ced9774c911f98864603)
 * Config saved to config.json and https://gist.github.com/ced9774c911f98864603
 */
if (typeof jQuery === 'undefined') {
  throw new Error('Bootstrap\'s JavaScript requires jQuery')
}
+function ($) {
  'use strict';
  var version = $.fn.jquery.split(' ')[0].split('.')
  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1)) {
    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher')
  }
}(jQuery);

/* ========================================================================
 * Bootstrap: alert.js v3.3.2
 * http://getbootstrap.com/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // ALERT CLASS DEFINITION
  // ======================

  var dismiss = '[data-dismiss="alert"]'
  var Alert   = function (el) {
    $(el).on('click', dismiss, this.close)
  }

  Alert.VERSION = '3.3.2'

  Alert.TRANSITION_DURATION = 150

  Alert.prototype.close = function (e) {
    var $this    = $(this)
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = $(selector)

    if (e) e.preventDefault()

    if (!$parent.length) {
      $parent = $this.closest('.alert')
    }

    $parent.trigger(e = $.Event('close.bs.alert'))

    if (e.isDefaultPrevented()) return

    $parent.removeClass('in')

    function removeElement() {
      // detach from parent, fire event then clean up data
      $parent.detach().trigger('closed.bs.alert').remove()
    }

    $.support.transition && $parent.hasClass('fade') ?
      $parent
        .one('bsTransitionEnd', removeElement)
        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
      removeElement()
  }


  // ALERT PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.alert')

      if (!data) $this.data('bs.alert', (data = new Alert(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.alert

  $.fn.alert             = Plugin
  $.fn.alert.Constructor = Alert


  // ALERT NO CONFLICT
  // =================

  $.fn.alert.noConflict = function () {
    $.fn.alert = old
    return this
  }


  // ALERT DATA-API
  // ==============

  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)

}(jQuery);

/* ========================================================================
 * Bootstrap: button.js v3.3.2
 * http://getbootstrap.com/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // BUTTON PUBLIC CLASS DEFINITION
  // ==============================

  var Button = function (element, options) {
    this.$element  = $(element)
    this.options   = $.extend({}, Button.DEFAULTS, options)
    this.isLoading = false
  }

  Button.VERSION  = '3.3.2'

  Button.DEFAULTS = {
    loadingText: 'loading...'
  }

  Button.prototype.setState = function (state) {
    var d    = 'disabled'
    var $el  = this.$element
    var val  = $el.is('input') ? 'val' : 'html'
    var data = $el.data()

    state = state + 'Text'

    if (data.resetText == null) $el.data('resetText', $el[val]())

    // push to event loop to allow forms to submit
    setTimeout($.proxy(function () {
      $el[val](data[state] == null ? this.options[state] : data[state])

      if (state == 'loadingText') {
        this.isLoading = true
        $el.addClass(d).attr(d, d)
      } else if (this.isLoading) {
        this.isLoading = false
        $el.removeClass(d).removeAttr(d)
      }
    }, this), 0)
  }

  Button.prototype.toggle = function () {
    var changed = true
    var $parent = this.$element.closest('[data-toggle="buttons"]')

    if ($parent.length) {
      var $input = this.$element.find('input')
      if ($input.prop('type') == 'radio') {
        if ($input.prop('checked') && this.$element.hasClass('active')) changed = false
        else $parent.find('.active').removeClass('active')
      }
      if (changed) $input.prop('checked', !this.$element.hasClass('active')).trigger('change')
    } else {
      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
    }

    if (changed) this.$element.toggleClass('active')
  }


  // BUTTON PLUGIN DEFINITION
  // ========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.button')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.button', (data = new Button(this, options)))

      if (option == 'toggle') data.toggle()
      else if (option) data.setState(option)
    })
  }

  var old = $.fn.button

  $.fn.button             = Plugin
  $.fn.button.Constructor = Button


  // BUTTON NO CONFLICT
  // ==================

  $.fn.button.noConflict = function () {
    $.fn.button = old
    return this
  }


  // BUTTON DATA-API
  // ===============

  $(document)
    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      var $btn = $(e.target)
      if (!$btn.hasClass('btn')) $btn = $btn.closest('.btn')
      Plugin.call($btn, 'toggle')
      e.preventDefault()
    })
    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
    })

}(jQuery);

/* ========================================================================
 * Bootstrap: carousel.js v3.3.2
 * http://getbootstrap.com/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CAROUSEL CLASS DEFINITION
  // =========================

  var Carousel = function (element, options) {
    this.$element    = $(element)
    this.$indicators = this.$element.find('.carousel-indicators')
    this.options     = options
    this.paused      = null
    this.sliding     = null
    this.interval    = null
    this.$active     = null
    this.$items      = null

    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))

    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
  }

  Carousel.VERSION  = '3.3.2'

  Carousel.TRANSITION_DURATION = 600

  Carousel.DEFAULTS = {
    interval: 5000,
    pause: 'hover',
    wrap: true,
    keyboard: true
  }

  Carousel.prototype.keydown = function (e) {
    if (/input|textarea/i.test(e.target.tagName)) return
    switch (e.which) {
      case 37: this.prev(); break
      case 39: this.next(); break
      default: return
    }

    e.preventDefault()
  }

  Carousel.prototype.cycle = function (e) {
    e || (this.paused = false)

    this.interval && clearInterval(this.interval)

    this.options.interval
      && !this.paused
      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))

    return this
  }

  Carousel.prototype.getItemIndex = function (item) {
    this.$items = item.parent().children('.item')
    return this.$items.index(item || this.$active)
  }

  Carousel.prototype.getItemForDirection = function (direction, active) {
    var activeIndex = this.getItemIndex(active)
    var willWrap = (direction == 'prev' && activeIndex === 0)
                || (direction == 'next' && activeIndex == (this.$items.length - 1))
    if (willWrap && !this.options.wrap) return active
    var delta = direction == 'prev' ? -1 : 1
    var itemIndex = (activeIndex + delta) % this.$items.length
    return this.$items.eq(itemIndex)
  }

  Carousel.prototype.to = function (pos) {
    var that        = this
    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))

    if (pos > (this.$items.length - 1) || pos < 0) return

    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
    if (activeIndex == pos) return this.pause().cycle()

    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
  }

  Carousel.prototype.pause = function (e) {
    e || (this.paused = true)

    if (this.$element.find('.next, .prev').length && $.support.transition) {
      this.$element.trigger($.support.transition.end)
      this.cycle(true)
    }

    this.interval = clearInterval(this.interval)

    return this
  }

  Carousel.prototype.next = function () {
    if (this.sliding) return
    return this.slide('next')
  }

  Carousel.prototype.prev = function () {
    if (this.sliding) return
    return this.slide('prev')
  }

  Carousel.prototype.slide = function (type, next) {
    var $active   = this.$element.find('.item.active')
    var $next     = next || this.getItemForDirection(type, $active)
    var isCycling = this.interval
    var direction = type == 'next' ? 'left' : 'right'
    var that      = this

    if ($next.hasClass('active')) return (this.sliding = false)

    var relatedTarget = $next[0]
    var slideEvent = $.Event('slide.bs.carousel', {
      relatedTarget: relatedTarget,
      direction: direction
    })
    this.$element.trigger(slideEvent)
    if (slideEvent.isDefaultPrevented()) return

    this.sliding = true

    isCycling && this.pause()

    if (this.$indicators.length) {
      this.$indicators.find('.active').removeClass('active')
      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
      $nextIndicator && $nextIndicator.addClass('active')
    }

    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
    if ($.support.transition && this.$element.hasClass('slide')) {
      $next.addClass(type)
      $next[0].offsetWidth // force reflow
      $active.addClass(direction)
      $next.addClass(direction)
      $active
        .one('bsTransitionEnd', function () {
          $next.removeClass([type, direction].join(' ')).addClass('active')
          $active.removeClass(['active', direction].join(' '))
          that.sliding = false
          setTimeout(function () {
            that.$element.trigger(slidEvent)
          }, 0)
        })
        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
    } else {
      $active.removeClass('active')
      $next.addClass('active')
      this.sliding = false
      this.$element.trigger(slidEvent)
    }

    isCycling && this.cycle()

    return this
  }


  // CAROUSEL PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.carousel')
      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
      var action  = typeof option == 'string' ? option : options.slide

      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
      if (typeof option == 'number') data.to(option)
      else if (action) data[action]()
      else if (options.interval) data.pause().cycle()
    })
  }

  var old = $.fn.carousel

  $.fn.carousel             = Plugin
  $.fn.carousel.Constructor = Carousel


  // CAROUSEL NO CONFLICT
  // ====================

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old
    return this
  }


  // CAROUSEL DATA-API
  // =================

  var clickHandler = function (e) {
    var href
    var $this   = $(this)
    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
    if (!$target.hasClass('carousel')) return
    var options = $.extend({}, $target.data(), $this.data())
    var slideIndex = $this.attr('data-slide-to')
    if (slideIndex) options.interval = false

    Plugin.call($target, options)

    if (slideIndex) {
      $target.data('bs.carousel').to(slideIndex)
    }

    e.preventDefault()
  }

  $(document)
    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)

  $(window).on('load', function () {
    $('[data-ride="carousel"]').each(function () {
      var $carousel = $(this)
      Plugin.call($carousel, $carousel.data())
    })
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: dropdown.js v3.3.2
 * http://getbootstrap.com/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop'
  var toggle   = '[data-toggle="dropdown"]'
  var Dropdown = function (element) {
    $(element).on('click.bs.dropdown', this.toggle)
  }

  Dropdown.VERSION = '3.3.2'

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this)

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    clearMenus()

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $('<div class="dropdown-backdrop"/>').insertAfter($(this)).on('click', clearMenus)
      }

      var relatedTarget = { relatedTarget: this }
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this
        .trigger('focus')
        .attr('aria-expanded', 'true')

      $parent
        .toggleClass('open')
        .trigger('shown.bs.dropdown', relatedTarget)
    }

    return false
  }

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return

    var $this = $(this)

    e.preventDefault()
    e.stopPropagation()

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    if ((!isActive && e.which != 27) || (isActive && e.which == 27)) {
      if (e.which == 27) $parent.find(toggle).trigger('focus')
      return $this.trigger('click')
    }

    var desc = ' li:not(.disabled):visible a'
    var $items = $parent.find('[role="menu"]' + desc + ', [role="listbox"]' + desc)

    if (!$items.length) return

    var index = $items.index(e.target)

    if (e.which == 38 && index > 0)                 index--                        // up
    if (e.which == 40 && index < $items.length - 1) index++                        // down
    if (!~index)                                      index = 0

    $items.eq(index).trigger('focus')
  }

  function clearMenus(e) {
    if (e && e.which === 3) return
    $(backdrop).remove()
    $(toggle).each(function () {
      var $this         = $(this)
      var $parent       = getParent($this)
      var relatedTarget = { relatedTarget: this }

      if (!$parent.hasClass('open')) return

      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this.attr('aria-expanded', 'false')
      $parent.removeClass('open').trigger('hidden.bs.dropdown', relatedTarget)
    })
  }

  function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = selector && $(selector)

    return $parent && $parent.length ? $parent : $this.parent()
  }


  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.dropdown')

      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.dropdown

  $.fn.dropdown             = Plugin
  $.fn.dropdown.Constructor = Dropdown


  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on('click.bs.dropdown.data-api', clearMenus)
    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
    .on('keydown.bs.dropdown.data-api', '[role="menu"]', Dropdown.prototype.keydown)
    .on('keydown.bs.dropdown.data-api', '[role="listbox"]', Dropdown.prototype.keydown)

}(jQuery);

/* ========================================================================
 * Bootstrap: modal.js v3.3.2
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options             = options
    this.$body               = $(document.body)
    this.$element            = $(element)
    this.$dialog             = this.$element.find('.modal-dialog')
    this.$backdrop           = null
    this.isShown             = null
    this.originalBodyPad     = null
    this.scrollbarWidth      = 0
    this.ignoreBackdropClick = false

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION  = '3.3.2'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element
        .addClass('in')
        .attr('aria-hidden', false)

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .attr('aria-hidden', true)
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (this.$element[0] !== e.target && !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $('<div class="modal-backdrop ' + animate + '" />')
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal             = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this   = $(this)
    var href    = $this.attr('href')
    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: tooltip.js v3.3.2
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       = null
    this.options    = null
    this.enabled    = null
    this.timeout    = null
    this.hoverState = null
    this.$element   = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.3.2'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    }
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $(this.options.viewport.selector || this.options.viewport)

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
    }

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (self && self.$tip && self.$tip.is(':visible')) {
      self.hoverState = 'in'
      return
    }

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)
        .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var $container   = this.options.container ? $(this.options.container) : this.$element.parent()
        var containerDim = this.getPosition($container)

        placement = placement == 'bottom' && pos.bottom + actualHeight > containerDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < containerDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > containerDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < containerDim.left   ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one('bsTransitionEnd', complete)
          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  = offset.top  + marginTop
    offset.left = offset.left + marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow()
      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
      .css(isVertical ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = $(this.$tip)
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      that.$element
        .removeAttr('aria-describedby')
        .trigger('hidden.bs.' + that.type)
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && $tip.hasClass('fade') ?
      $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof ($e.attr('data-original-title')) != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var elOffset  = isBody ? { top: 0, left: 0 } : $element.offset()
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.width) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    return (this.$tip = this.$tip || $(this.options.template))
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
    })
  }


  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jQuery);

/* ========================================================================
 * Bootstrap: popover.js v3.3.2
 * http://getbootstrap.com/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

  Popover.VERSION  = '3.3.2'

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

  Popover.prototype.constructor = Popover

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS
  }

  Popover.prototype.setContent = function () {
    var $tip    = this.tip()
    var title   = this.getTitle()
    var content = this.getContent()

    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
    ](content)

    $tip.removeClass('fade top bottom left right in')

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
  }

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }

  Popover.prototype.getContent = function () {
    var $e = this.$element
    var o  = this.options

    return $e.attr('data-content')
      || (typeof o.content == 'function' ?
            o.content.call($e[0]) :
            o.content)
  }

  Popover.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }


  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.popover')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.popover

  $.fn.popover             = Plugin
  $.fn.popover.Constructor = Popover


  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(jQuery);

/* ========================================================================
 * Bootstrap: tab.js v3.3.2
 * http://getbootstrap.com/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    this.element = $(element)
  }

  Tab.VERSION = '3.3.2'

  Tab.TRANSITION_DURATION = 150

  Tab.prototype.show = function () {
    var $this    = this.element
    var $ul      = $this.closest('ul:not(.dropdown-menu)')
    var selector = $this.data('target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return

    var $previous = $ul.find('.active:last a')
    var hideEvent = $.Event('hide.bs.tab', {
      relatedTarget: $this[0]
    })
    var showEvent = $.Event('show.bs.tab', {
      relatedTarget: $previous[0]
    })

    $previous.trigger(hideEvent)
    $this.trigger(showEvent)

    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

    var $target = $(selector)

    this.activate($this.closest('li'), $ul)
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.tab',
        relatedTarget: $this[0]
      })
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: $previous[0]
      })
    })
  }

  Tab.prototype.activate = function (element, container, callback) {
    var $active    = container.find('> .active')
    var transition = callback
      && $.support.transition
      && (($active.length && $active.hasClass('fade')) || !!container.find('> .fade').length)

    function next() {
      $active
        .removeClass('active')
        .find('> .dropdown-menu > .active')
          .removeClass('active')
        .end()
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', false)

      element
        .addClass('active')
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', true)

      if (transition) {
        element[0].offsetWidth // reflow for transition
        element.addClass('in')
      } else {
        element.removeClass('fade')
      }

      if (element.parent('.dropdown-menu').length) {
        element
          .closest('li.dropdown')
            .addClass('active')
          .end()
          .find('[data-toggle="tab"]')
            .attr('aria-expanded', true)
      }

      callback && callback()
    }

    $active.length && transition ?
      $active
        .one('bsTransitionEnd', next)
        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
      next()

    $active.removeClass('in')
  }


  // TAB PLUGIN DEFINITION
  // =====================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.tab')

      if (!data) $this.data('bs.tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tab

  $.fn.tab             = Plugin
  $.fn.tab.Constructor = Tab


  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


  // TAB DATA-API
  // ============

  var clickHandler = function (e) {
    e.preventDefault()
    Plugin.call($(this), 'show')
  }

  $(document)
    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)

}(jQuery);

/* ========================================================================
 * Bootstrap: affix.js v3.3.2
 * http://getbootstrap.com/javascript/#affix
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function (element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options)

    this.$target = $(this.options.target)
      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))

    this.$element     = $(element)
    this.affixed      = null
    this.unpin        = null
    this.pinnedOffset = null

    this.checkPosition()
  }

  Affix.VERSION  = '3.3.2'

  Affix.RESET    = 'affix affix-top affix-bottom'

  Affix.DEFAULTS = {
    offset: 0,
    target: window
  }

  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
    var scrollTop    = this.$target.scrollTop()
    var position     = this.$element.offset()
    var targetHeight = this.$target.height()

    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false

    if (this.affixed == 'bottom') {
      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
    }

    var initializing   = this.affixed == null
    var colliderTop    = initializing ? scrollTop : position.top
    var colliderHeight = initializing ? targetHeight : height

    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'

    return false
  }

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset
    this.$element.removeClass(Affix.RESET).addClass('affix')
    var scrollTop = this.$target.scrollTop()
    var position  = this.$element.offset()
    return (this.pinnedOffset = position.top - scrollTop)
  }

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1)
  }

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return

    var height       = this.$element.height()
    var offset       = this.options.offset
    var offsetTop    = offset.top
    var offsetBottom = offset.bottom
    var scrollHeight = $(document.body).height()

    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)

    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)

    if (this.affixed != affix) {
      if (this.unpin != null) this.$element.css('top', '')

      var affixType = 'affix' + (affix ? '-' + affix : '')
      var e         = $.Event(affixType + '.bs.affix')

      this.$element.trigger(e)

      if (e.isDefaultPrevented()) return

      this.affixed = affix
      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null

      this.$element
        .removeClass(Affix.RESET)
        .addClass(affixType)
        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
    }

    if (affix == 'bottom') {
      this.$element.offset({
        top: scrollHeight - height - offsetBottom
      })
    }
  }


  // AFFIX PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.affix')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.affix

  $.fn.affix             = Plugin
  $.fn.affix.Constructor = Affix


  // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old
    return this
  }


  // AFFIX DATA-API
  // ==============

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this)
      var data = $spy.data()

      data.offset = data.offset || {}

      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
      if (data.offsetTop    != null) data.offset.top    = data.offsetTop

      Plugin.call($spy, data)
    })
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: collapse.js v3.3.2
 * http://getbootstrap.com/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element      = $(element)
    this.options       = $.extend({}, Collapse.DEFAULTS, options)
    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
    this.transitioning = null

    if (this.options.parent) {
      this.$parent = this.getParent()
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
    }

    if (this.options.toggle) this.toggle()
  }

  Collapse.VERSION  = '3.3.2'

  Collapse.TRANSITION_DURATION = 350

  Collapse.DEFAULTS = {
    toggle: true
  }

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width')
    return hasWidth ? 'width' : 'height'
  }

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return

    var activesData
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse')
      if (activesData && activesData.transitioning) return
    }

    var startEvent = $.Event('show.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    if (actives && actives.length) {
      Plugin.call(actives, 'hide')
      activesData || actives.data('bs.collapse', null)
    }

    var dimension = this.dimension()

    this.$element
      .removeClass('collapse')
      .addClass('collapsing')[dimension](0)
      .attr('aria-expanded', true)

    this.$trigger
      .removeClass('collapsed')
      .attr('aria-expanded', true)

    this.transitioning = 1

    var complete = function () {
      this.$element
        .removeClass('collapsing')
        .addClass('collapse in')[dimension]('')
      this.transitioning = 0
      this.$element
        .trigger('shown.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    var scrollSize = $.camelCase(['scroll', dimension].join('-'))

    this.$element
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
  }

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return

    var startEvent = $.Event('hide.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var dimension = this.dimension()

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight

    this.$element
      .addClass('collapsing')
      .removeClass('collapse in')
      .attr('aria-expanded', false)

    this.$trigger
      .addClass('collapsed')
      .attr('aria-expanded', false)

    this.transitioning = 1

    var complete = function () {
      this.transitioning = 0
      this.$element
        .removeClass('collapsing')
        .addClass('collapse')
        .trigger('hidden.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    this.$element
      [dimension](0)
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
  }

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']()
  }

  Collapse.prototype.getParent = function () {
    return $(this.options.parent)
      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
      .each($.proxy(function (i, element) {
        var $element = $(element)
        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
      }, this))
      .end()
  }

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in')

    $element.attr('aria-expanded', isOpen)
    $trigger
      .toggleClass('collapsed', !isOpen)
      .attr('aria-expanded', isOpen)
  }

  function getTargetFromTrigger($trigger) {
    var href
    var target = $trigger.attr('data-target')
      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7

    return $(target)
  }


  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.collapse')
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.collapse

  $.fn.collapse             = Plugin
  $.fn.collapse.Constructor = Collapse


  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old
    return this
  }


  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this   = $(this)

    if (!$this.attr('data-target')) e.preventDefault()

    var $target = getTargetFromTrigger($this)
    var data    = $target.data('bs.collapse')
    var option  = data ? 'toggle' : $this.data()

    Plugin.call($target, option)
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: scrollspy.js v3.3.2
 * http://getbootstrap.com/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // SCROLLSPY CLASS DEFINITION
  // ==========================

  function ScrollSpy(element, options) {
    this.$body          = $(document.body)
    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
    this.selector       = (this.options.target || '') + ' .nav li > a'
    this.offsets        = []
    this.targets        = []
    this.activeTarget   = null
    this.scrollHeight   = 0

    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
    this.refresh()
    this.process()
  }

  ScrollSpy.VERSION  = '3.3.2'

  ScrollSpy.DEFAULTS = {
    offset: 10
  }

  ScrollSpy.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
  }

  ScrollSpy.prototype.refresh = function () {
    var that          = this
    var offsetMethod  = 'offset'
    var offsetBase    = 0

    this.offsets      = []
    this.targets      = []
    this.scrollHeight = this.getScrollHeight()

    if (!$.isWindow(this.$scrollElement[0])) {
      offsetMethod = 'position'
      offsetBase   = this.$scrollElement.scrollTop()
    }

    this.$body
      .find(this.selector)
      .map(function () {
        var $el   = $(this)
        var href  = $el.data('target') || $el.attr('href')
        var $href = /^#./.test(href) && $(href)

        return ($href
          && $href.length
          && $href.is(':visible')
          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
      })
      .sort(function (a, b) { return a[0] - b[0] })
      .each(function () {
        that.offsets.push(this[0])
        that.targets.push(this[1])
      })
  }

  ScrollSpy.prototype.process = function () {
    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
    var scrollHeight = this.getScrollHeight()
    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
    var offsets      = this.offsets
    var targets      = this.targets
    var activeTarget = this.activeTarget
    var i

    if (this.scrollHeight != scrollHeight) {
      this.refresh()
    }

    if (scrollTop >= maxScroll) {
      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
    }

    if (activeTarget && scrollTop < offsets[0]) {
      this.activeTarget = null
      return this.clear()
    }

    for (i = offsets.length; i--;) {
      activeTarget != targets[i]
        && scrollTop >= offsets[i]
        && (offsets[i + 1] === undefined || scrollTop <= offsets[i + 1])
        && this.activate(targets[i])
    }
  }

  ScrollSpy.prototype.activate = function (target) {
    this.activeTarget = target

    this.clear()

    var selector = this.selector +
      '[data-target="' + target + '"],' +
      this.selector + '[href="' + target + '"]'

    var active = $(selector)
      .parents('li')
      .addClass('active')

    if (active.parent('.dropdown-menu').length) {
      active = active
        .closest('li.dropdown')
        .addClass('active')
    }

    active.trigger('activate.bs.scrollspy')
  }

  ScrollSpy.prototype.clear = function () {
    $(this.selector)
      .parentsUntil(this.options.target, '.active')
      .removeClass('active')
  }


  // SCROLLSPY PLUGIN DEFINITION
  // ===========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.scrollspy')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.scrollspy

  $.fn.scrollspy             = Plugin
  $.fn.scrollspy.Constructor = ScrollSpy


  // SCROLLSPY NO CONFLICT
  // =====================

  $.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old
    return this
  }


  // SCROLLSPY DATA-API
  // ==================

  $(window).on('load.bs.scrollspy.data-api', function () {
    $('[data-spy="scroll"]').each(function () {
      var $spy = $(this)
      Plugin.call($spy, $spy.data())
    })
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: transition.js v3.3.2
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap')

    var transEndEventNames = {
      WebkitTransition : 'webkitTransitionEnd',
      MozTransition    : 'transitionend',
      OTransition      : 'oTransitionEnd otransitionend',
      transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false
    var $el = this
    $(this).one('bsTransitionEnd', function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()

    if (!$.support.transition) return

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
      }
    }
  })

}(jQuery);

/* -------- common/js/underscore_js/1.6.0.js -------- */
//     Underscore.js 1.6.0
//     http://underscorejs.org
//     (c) 2009-2014 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Establish the object that gets returned to break out of a loop iteration.
  var breaker = {};

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    concat           = ArrayProto.concat,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeForEach      = ArrayProto.forEach,
    nativeMap          = ArrayProto.map,
    nativeReduce       = ArrayProto.reduce,
    nativeReduceRight  = ArrayProto.reduceRight,
    nativeFilter       = ArrayProto.filter,
    nativeEvery        = ArrayProto.every,
    nativeSome         = ArrayProto.some,
    nativeIndexOf      = ArrayProto.indexOf,
    nativeLastIndexOf  = ArrayProto.lastIndexOf,
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind;

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object via a string identifier,
  // for Closure Compiler "advanced" mode.
  if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.6.0';

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles objects with the built-in `forEach`, arrays, and raw objects.
  // Delegates to **ECMAScript 5**'s native `forEach` if available.
  var each = _.each = _.forEach = function(obj, iterator, context) {
    if (obj == null) return obj;
    if (nativeForEach && obj.forEach === nativeForEach) {
      obj.forEach(iterator, context);
    } else if (obj.length === +obj.length) {
      for (var i = 0, length = obj.length; i < length; i++) {
        if (iterator.call(context, obj[i], i, obj) === breaker) return;
      }
    } else {
      var keys = _.keys(obj);
      for (var i = 0, length = keys.length; i < length; i++) {
        if (iterator.call(context, obj[keys[i]], keys[i], obj) === breaker) return;
      }
    }
    return obj;
  };

  // Return the results of applying the iterator to each element.
  // Delegates to **ECMAScript 5**'s native `map` if available.
  _.map = _.collect = function(obj, iterator, context) {
    var results = [];
    if (obj == null) return results;
    if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
    each(obj, function(value, index, list) {
      results.push(iterator.call(context, value, index, list));
    });
    return results;
  };

  var reduceError = 'Reduce of empty array with no initial value';

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`. Delegates to **ECMAScript 5**'s native `reduce` if available.
  _.reduce = _.foldl = _.inject = function(obj, iterator, memo, context) {
    var initial = arguments.length > 2;
    if (obj == null) obj = [];
    if (nativeReduce && obj.reduce === nativeReduce) {
      if (context) iterator = _.bind(iterator, context);
      return initial ? obj.reduce(iterator, memo) : obj.reduce(iterator);
    }
    each(obj, function(value, index, list) {
      if (!initial) {
        memo = value;
        initial = true;
      } else {
        memo = iterator.call(context, memo, value, index, list);
      }
    });
    if (!initial) throw new TypeError(reduceError);
    return memo;
  };

  // The right-associative version of reduce, also known as `foldr`.
  // Delegates to **ECMAScript 5**'s native `reduceRight` if available.
  _.reduceRight = _.foldr = function(obj, iterator, memo, context) {
    var initial = arguments.length > 2;
    if (obj == null) obj = [];
    if (nativeReduceRight && obj.reduceRight === nativeReduceRight) {
      if (context) iterator = _.bind(iterator, context);
      return initial ? obj.reduceRight(iterator, memo) : obj.reduceRight(iterator);
    }
    var length = obj.length;
    if (length !== +length) {
      var keys = _.keys(obj);
      length = keys.length;
    }
    each(obj, function(value, index, list) {
      index = keys ? keys[--length] : --length;
      if (!initial) {
        memo = obj[index];
        initial = true;
      } else {
        memo = iterator.call(context, memo, obj[index], index, list);
      }
    });
    if (!initial) throw new TypeError(reduceError);
    return memo;
  };

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var result;
    any(obj, function(value, index, list) {
      if (predicate.call(context, value, index, list)) {
        result = value;
        return true;
      }
    });
    return result;
  };

  // Return all the elements that pass a truth test.
  // Delegates to **ECMAScript 5**'s native `filter` if available.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    if (obj == null) return results;
    if (nativeFilter && obj.filter === nativeFilter) return obj.filter(predicate, context);
    each(obj, function(value, index, list) {
      if (predicate.call(context, value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, function(value, index, list) {
      return !predicate.call(context, value, index, list);
    }, context);
  };

  // Determine whether all of the elements match a truth test.
  // Delegates to **ECMAScript 5**'s native `every` if available.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate || (predicate = _.identity);
    var result = true;
    if (obj == null) return result;
    if (nativeEvery && obj.every === nativeEvery) return obj.every(predicate, context);
    each(obj, function(value, index, list) {
      if (!(result = result && predicate.call(context, value, index, list))) return breaker;
    });
    return !!result;
  };

  // Determine if at least one element in the object matches a truth test.
  // Delegates to **ECMAScript 5**'s native `some` if available.
  // Aliased as `any`.
  var any = _.some = _.any = function(obj, predicate, context) {
    predicate || (predicate = _.identity);
    var result = false;
    if (obj == null) return result;
    if (nativeSome && obj.some === nativeSome) return obj.some(predicate, context);
    each(obj, function(value, index, list) {
      if (result || (result = predicate.call(context, value, index, list))) return breaker;
    });
    return !!result;
  };

  // Determine if the array or object contains a given value (using `===`).
  // Aliased as `include`.
  _.contains = _.include = function(obj, target) {
    if (obj == null) return false;
    if (nativeIndexOf && obj.indexOf === nativeIndexOf) return obj.indexOf(target) != -1;
    return any(obj, function(value) {
      return value === target;
    });
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      return (isFunc ? method : value[method]).apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matches(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matches(attrs));
  };

  // Return the maximum element or (element-based computation).
  // Can't optimize arrays of integers longer than 65,535 elements.
  // See [WebKit Bug 80797](https://bugs.webkit.org/show_bug.cgi?id=80797)
  _.max = function(obj, iterator, context) {
    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
      return Math.max.apply(Math, obj);
    }
    var result = -Infinity, lastComputed = -Infinity;
    each(obj, function(value, index, list) {
      var computed = iterator ? iterator.call(context, value, index, list) : value;
      if (computed > lastComputed) {
        result = value;
        lastComputed = computed;
      }
    });
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iterator, context) {
    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
      return Math.min.apply(Math, obj);
    }
    var result = Infinity, lastComputed = Infinity;
    each(obj, function(value, index, list) {
      var computed = iterator ? iterator.call(context, value, index, list) : value;
      if (computed < lastComputed) {
        result = value;
        lastComputed = computed;
      }
    });
    return result;
  };

  // Shuffle an array, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var rand;
    var index = 0;
    var shuffled = [];
    each(obj, function(value) {
      rand = _.random(index++);
      shuffled[index - 1] = shuffled[rand];
      shuffled[rand] = value;
    });
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (obj.length !== +obj.length) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // An internal function to generate lookup iterators.
  var lookupIterator = function(value) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return value;
    return _.property(value);
  };

  // Sort the object's values by a criterion produced by an iterator.
  _.sortBy = function(obj, iterator, context) {
    iterator = lookupIterator(iterator);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iterator.call(context, value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iterator, context) {
      var result = {};
      iterator = lookupIterator(iterator);
      each(obj, function(value, index) {
        var key = iterator.call(context, value, index, obj);
        behavior(result, key, value);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, key, value) {
    _.has(result, key) ? result[key].push(value) : result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, key, value) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, key) {
    _.has(result, key) ? result[key]++ : result[key] = 1;
  });

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iterator, context) {
    iterator = lookupIterator(iterator);
    var value = iterator.call(context, obj);
    var low = 0, high = array.length;
    while (low < high) {
      var mid = (low + high) >>> 1;
      iterator.call(context, array[mid]) < value ? low = mid + 1 : high = mid;
    }
    return low;
  };

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (obj.length === +obj.length) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return (obj.length === +obj.length) ? obj.length : _.keys(obj).length;
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if ((n == null) || guard) return array[0];
    if (n < 0) return [];
    return slice.call(array, 0, n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N. The **guard** check allows it to work with
  // `_.map`.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, array.length - ((n == null) || guard ? 1 : n));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array. The **guard** check allows it to work with `_.map`.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if ((n == null) || guard) return array[array.length - 1];
    return slice.call(array, Math.max(array.length - n, 0));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array. The **guard**
  // check allows it to work with `_.map`.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, (n == null) || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, output) {
    if (shallow && _.every(input, _.isArray)) {
      return concat.apply(output, input);
    }
    each(input, function(value) {
      if (_.isArray(value) || _.isArguments(value)) {
        shallow ? push.apply(output, value) : flatten(value, shallow, output);
      } else {
        output.push(value);
      }
    });
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, []);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Split an array into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(array, predicate) {
    var pass = [], fail = [];
    each(array, function(elem) {
      (predicate(elem) ? pass : fail).push(elem);
    });
    return [pass, fail];
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iterator, context) {
    if (_.isFunction(isSorted)) {
      context = iterator;
      iterator = isSorted;
      isSorted = false;
    }
    var initial = iterator ? _.map(array, iterator, context) : array;
    var results = [];
    var seen = [];
    each(initial, function(value, index) {
      if (isSorted ? (!index || seen[seen.length - 1] !== value) : !_.contains(seen, value)) {
        seen.push(value);
        results.push(array[index]);
      }
    });
    return results;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(_.flatten(arguments, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var rest = slice.call(arguments, 1);
    return _.filter(_.uniq(array), function(item) {
      return _.every(rest, function(other) {
        return _.contains(other, item);
      });
    });
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = concat.apply(ArrayProto, slice.call(arguments, 1));
    return _.filter(array, function(value){ return !_.contains(rest, value); });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    var length = _.max(_.pluck(arguments, 'length').concat(0));
    var results = new Array(length);
    for (var i = 0; i < length; i++) {
      results[i] = _.pluck(arguments, '' + i);
    }
    return results;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    if (list == null) return {};
    var result = {};
    for (var i = 0, length = list.length; i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // If the browser doesn't supply us with indexOf (I'm looking at you, **MSIE**),
  // we need this function. Return the position of the first occurrence of an
  // item in an array, or -1 if the item is not included in the array.
  // Delegates to **ECMAScript 5**'s native `indexOf` if available.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = function(array, item, isSorted) {
    if (array == null) return -1;
    var i = 0, length = array.length;
    if (isSorted) {
      if (typeof isSorted == 'number') {
        i = (isSorted < 0 ? Math.max(0, length + isSorted) : isSorted);
      } else {
        i = _.sortedIndex(array, item);
        return array[i] === item ? i : -1;
      }
    }
    if (nativeIndexOf && array.indexOf === nativeIndexOf) return array.indexOf(item, isSorted);
    for (; i < length; i++) if (array[i] === item) return i;
    return -1;
  };

  // Delegates to **ECMAScript 5**'s native `lastIndexOf` if available.
  _.lastIndexOf = function(array, item, from) {
    if (array == null) return -1;
    var hasIndex = from != null;
    if (nativeLastIndexOf && array.lastIndexOf === nativeLastIndexOf) {
      return hasIndex ? array.lastIndexOf(item, from) : array.lastIndexOf(item);
    }
    var i = (hasIndex ? from : array.length);
    while (i--) if (array[i] === item) return i;
    return -1;
  };

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (arguments.length <= 1) {
      stop = start || 0;
      start = 0;
    }
    step = arguments[2] || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var idx = 0;
    var range = new Array(length);

    while(idx < length) {
      range[idx++] = start;
      start += step;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Reusable constructor function for prototype setting.
  var ctor = function(){};

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    var args, bound;
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError;
    args = slice.call(arguments, 2);
    return bound = function() {
      if (!(this instanceof bound)) return func.apply(context, args.concat(slice.call(arguments)));
      ctor.prototype = func.prototype;
      var self = new ctor;
      ctor.prototype = null;
      var result = func.apply(self, args.concat(slice.call(arguments)));
      if (Object(result) === result) return result;
      return self;
    };
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    return function() {
      var position = 0;
      var args = boundArgs.slice();
      for (var i = 0, length = args.length; i < length; i++) {
        if (args[i] === _) args[i] = arguments[position++];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return func.apply(this, args);
    };
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var funcs = slice.call(arguments, 1);
    if (funcs.length === 0) throw new Error('bindAll must be passed function names');
    each(funcs, function(f) { obj[f] = _.bind(obj[f], obj); });
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memo = {};
    hasher || (hasher = _.identity);
    return function() {
      var key = hasher.apply(this, arguments);
      return _.has(memo, key) ? memo[key] : (memo[key] = func.apply(this, arguments));
    };
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){ return func.apply(null, args); }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = function(func) {
    return _.delay.apply(_, [func, 1].concat(slice.call(arguments, 1)));
  };

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    options || (options = {});
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0) {
        clearTimeout(timeout);
        timeout = null;
        previous = now;
        result = func.apply(context, args);
        context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;
      if (last < wait) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) {
        timeout = setTimeout(later, wait);
      }
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = function(func) {
    var ran = false, memo;
    return function() {
      if (ran) return memo;
      ran = true;
      memo = func.apply(this, arguments);
      func = null;
      return memo;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var funcs = arguments;
    return function() {
      var args = arguments;
      for (var i = funcs.length - 1; i >= 0; i--) {
        args = [funcs[i].apply(this, args)];
      }
      return args[0];
    };
  };

  // Returns a function that will only be executed after being called N times.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Object Functions
  // ----------------

  // Retrieve the names of an object's properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = new Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = new Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = function(obj) {
    each(slice.call(arguments, 1), function(source) {
      if (source) {
        for (var prop in source) {
          obj[prop] = source[prop];
        }
      }
    });
    return obj;
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(obj) {
    var copy = {};
    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
    each(keys, function(key) {
      if (key in obj) copy[key] = obj[key];
    });
    return copy;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj) {
    var copy = {};
    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
    for (var key in obj) {
      if (!_.contains(keys, key)) copy[key] = obj[key];
    }
    return copy;
  };

  // Fill in a given object with default properties.
  _.defaults = function(obj) {
    each(slice.call(arguments, 1), function(source) {
      if (source) {
        for (var prop in source) {
          if (obj[prop] === void 0) obj[prop] = source[prop];
        }
      }
    });
    return obj;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a == 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className != toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, dates, and booleans are compared by value.
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return a == String(b);
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive. An `egal` comparison is performed for
        // other numeric values.
        return a != +a ? b != +b : (a == 0 ? 1 / a == 1 / b : a == +b);
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a == +b;
      // RegExps are compared by their source patterns and flags.
      case '[object RegExp]':
        return a.source == b.source &&
               a.global == b.global &&
               a.multiline == b.multiline &&
               a.ignoreCase == b.ignoreCase;
    }
    if (typeof a != 'object' || typeof b != 'object') return false;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] == a) return bStack[length] == b;
    }
    // Objects with different constructors are not equivalent, but `Object`s
    // from different frames are.
    var aCtor = a.constructor, bCtor = b.constructor;
    if (aCtor !== bCtor && !(_.isFunction(aCtor) && (aCtor instanceof aCtor) &&
                             _.isFunction(bCtor) && (bCtor instanceof bCtor))
                        && ('constructor' in a && 'constructor' in b)) {
      return false;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    var size = 0, result = true;
    // Recursively compare objects and arrays.
    if (className == '[object Array]') {
      // Compare array lengths to determine if a deep comparison is necessary.
      size = a.length;
      result = size == b.length;
      if (result) {
        // Deep compare the contents, ignoring non-numeric properties.
        while (size--) {
          if (!(result = eq(a[size], b[size], aStack, bStack))) break;
        }
      }
    } else {
      // Deep compare objects.
      for (var key in a) {
        if (_.has(a, key)) {
          // Count the expected number of properties.
          size++;
          // Deep compare each member.
          if (!(result = _.has(b, key) && eq(a[key], b[key], aStack, bStack))) break;
        }
      }
      // Ensure that both objects contain the same number of properties.
      if (result) {
        for (key in b) {
          if (_.has(b, key) && !(size--)) break;
        }
        result = !size;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return result;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b, [], []);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (_.isArray(obj) || _.isString(obj)) return obj.length === 0;
    for (var key in obj) if (_.has(obj, key)) return false;
    return true;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) == '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    return obj === Object(obj);
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp.
  each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) == '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return !!(obj && _.has(obj, 'callee'));
    };
  }

  // Optimize `isFunction` if appropriate.
  if (typeof (/./) !== 'function') {
    _.isFunction = function(obj) {
      return typeof obj === 'function';
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj != +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) == '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iterators.
  _.identity = function(value) {
    return value;
  };

  _.constant = function(value) {
    return function () {
      return value;
    };
  };

  _.property = function(key) {
    return function(obj) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of `key:value` pairs.
  _.matches = function(attrs) {
    return function(obj) {
      if (obj === attrs) return true; //avoid comparing an object to itself.
      for (var key in attrs) {
        if (attrs[key] !== obj[key])
          return false;
      }
      return true;
    }
  };

  // Run a function **n** times.
  _.times = function(n, iterator, context) {
    var accum = Array(Math.max(0, n));
    for (var i = 0; i < n; i++) accum[i] = iterator.call(context, i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() { return new Date().getTime(); };

  // List of HTML entities for escaping.
  var entityMap = {
    escape: {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#x27;'
    }
  };
  entityMap.unescape = _.invert(entityMap.escape);

  // Regexes containing the keys and values listed immediately above.
  var entityRegexes = {
    escape:   new RegExp('[' + _.keys(entityMap.escape).join('') + ']', 'g'),
    unescape: new RegExp('(' + _.keys(entityMap.unescape).join('|') + ')', 'g')
  };

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  _.each(['escape', 'unescape'], function(method) {
    _[method] = function(string) {
      if (string == null) return '';
      return ('' + string).replace(entityRegexes[method], function(match) {
        return entityMap[method][match];
      });
    };
  });

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property) {
    if (object == null) return void 0;
    var value = object[property];
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result.call(this, func.apply(_, args));
      };
    });
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\t':     't',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\t|\u2028|\u2029/g;

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  _.template = function(text, data, settings) {
    var render;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = new RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset)
        .replace(escaper, function(match) { return '\\' + escapes[match]; });

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      }
      if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      }
      if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }
      index = offset + match.length;
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + "return __p;\n";

    try {
      render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    if (data) return render(data, _);
    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled function source as a convenience for precompilation.
    template.source = 'function(' + (settings.variable || 'obj') + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function, which will delegate to the wrapper.
  _.chain = function(obj) {
    return _(obj).chain();
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(obj) {
    return this._chain ? _(obj).chain() : obj;
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name == 'shift' || name == 'splice') && obj.length === 0) delete obj[0];
      return result.call(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result.call(this, method.apply(this._wrapped, arguments));
    };
  });

  _.extend(_.prototype, {

    // Start chaining a wrapped Underscore object.
    chain: function() {
      this._chain = true;
      return this;
    },

    // Extracts the result from a wrapped and chained object.
    value: function() {
      return this._wrapped;
    }

  });

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (typeof define === 'function' && define.amd) {
    define('underscore', [], function() {
      return _;
    });
  }
}).call(this);

/* -------- studio/v2/js/modernizr.js -------- */
/*! modernizr 3.0.0-alpha.3 (Custom Build) | MIT *
 * http://v3.modernizr.com/download/#-flash !*/
!function(n,e){function t(n,e){return typeof n===e}function o(){var n,e,o,i,a,s,l;for(var c in r){if(n=[],e=r[c],e.name&&(n.push(e.name.toLowerCase()),e.options&&e.options.aliases&&e.options.aliases.length))for(o=0;o<e.options.aliases.length;o++)n.push(e.options.aliases[o].toLowerCase());for(i=t(e.fn,"function")?e.fn():e.fn,a=0;a<n.length;a++)s=n[a],l=s.split("."),1===l.length?Modernizr[l[0]]=i:(!Modernizr[l[0]]||Modernizr[l[0]]instanceof Boolean||(Modernizr[l[0]]=new Boolean(Modernizr[l[0]])),Modernizr[l[0]][l[1]]=i),f.push((i?"":"no-")+l.join("-"))}}function i(){var n=e.body;return n||(n=u("body"),n.fake=!0),n}function a(n){var e=d.className,t=Modernizr._config.classPrefix||"";if(Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");e=e.replace(o,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(e+=" "+t+n.join(" "+t),d.className=e)}function s(n,e){if("object"==typeof n)for(var t in n)c(n,t)&&s(t,n[t]);else{n=n.toLowerCase();var o=n.split("."),i=Modernizr[o[0]];if(2==o.length&&(i=i[o[1]]),"undefined"!=typeof i)return Modernizr;e="function"==typeof e?e():e,1==o.length?Modernizr[o[0]]=e:(!Modernizr[o[0]]||Modernizr[o[0]]instanceof Boolean||(Modernizr[o[0]]=new Boolean(Modernizr[o[0]])),Modernizr[o[0]][o[1]]=e),a([(e&&0!=e?"":"no-")+o.join("-")]),Modernizr._trigger(n,e)}return Modernizr}var r=[],l={_version:"3.0.0-alpha.3",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(n,e){var t=this;setTimeout(function(){e(t[n])},0)},addTest:function(n,e,t){r.push({name:n,fn:e,options:t})},addAsyncTest:function(n){r.push({name:null,fn:n})}},Modernizr=function(){};Modernizr.prototype=l,Modernizr=new Modernizr;var c,f=[],u=function(){return"function"!=typeof e.createElement?e.createElement(arguments[0]):e.createElement.apply(e,arguments)},d=e.documentElement;!function(){var n={}.hasOwnProperty;c=t(n,"undefined")||t(n.call,"undefined")?function(n,e){return e in n&&t(n.constructor.prototype[e],"undefined")}:function(e,t){return n.call(e,t)}}(),l._l={},l.on=function(n,e){this._l[n]||(this._l[n]=[]),this._l[n].push(e),Modernizr.hasOwnProperty(n)&&setTimeout(function(){Modernizr._trigger(n,Modernizr[n])},0)},l._trigger=function(n,e){if(this._l[n]){var t=this._l[n];setTimeout(function(){var n,o;for(n=0;n<t.length;n++)(o=t[n])(e)},0),delete this._l[n]}},Modernizr._q.push(function(){l.addTest=s}),Modernizr.addAsyncTest(function(){var t,o,a=function(n){n.fake&&n.parentNode&&n.parentNode.removeChild(n)},r=function(n,e){var t=!!n;t&&(t=new Boolean(t),t.blocked="blocked"===n),s("flash",function(){return t}),e&&h.contains(e)&&h.removeChild(e)};try{o="ActiveXObject"in n&&"Pan"in new n.ActiveXObject("ShockwaveFlash.ShockwaveFlash")}catch(l){}if(t=!("plugins"in navigator&&"Shockwave Flash"in navigator.plugins||o))r(!1);else{var c,f,p=u("embed"),h=i();if(p.type="application/x-shockwave-flash",h.appendChild(p),d.appendChild(h),!("Pan"in p||o))return r("blocked",p),void a(h);c=function(){return d.contains(h)?(d.contains(p)?(f=p.style.cssText,""!==f?r("blocked",p):r(!0,p)):r("blocked"),void a(h)):(h=e.body||h,p=e.createElement("embed"),p.type="application/x-shockwave-flash",h.appendChild(p),setTimeout(c,1e3))},setTimeout(c,10)}}),o(),delete l.addTest,delete l.addAsyncTest;for(var p=0;p<Modernizr._q.length;p++)Modernizr._q[p]();n.Modernizr=Modernizr}(window,document);

/* -------- studio/v2/js/clipboard.js -------- */
/*!
 * clipboard.js v1.5.12
 * https://zenorocha.github.io/clipboard.js
 *
 * Licensed MIT © Zeno Rocha
 */
(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Clipboard = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var matches = require('matches-selector')

module.exports = function (element, selector, checkYoSelf) {
  var parent = checkYoSelf ? element : element.parentNode

  while (parent && parent !== document) {
    if (matches(parent, selector)) return parent;
    parent = parent.parentNode
  }
}

},{"matches-selector":5}],2:[function(require,module,exports){
var closest = require('closest');

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector, true);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;

},{"closest":1}],3:[function(require,module,exports){
/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};

},{}],4:[function(require,module,exports){
var is = require('./is');
var delegate = require('delegate');

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;

},{"./is":3,"delegate":2}],5:[function(require,module,exports){

/**
 * Element prototype.
 */

var proto = Element.prototype;

/**
 * Vendor function.
 */

var vendor = proto.matchesSelector
  || proto.webkitMatchesSelector
  || proto.mozMatchesSelector
  || proto.msMatchesSelector
  || proto.oMatchesSelector;

/**
 * Expose `match()`.
 */

module.exports = match;

/**
 * Match `el` to `selector`.
 *
 * @param {Element} el
 * @param {String} selector
 * @return {Boolean}
 * @api public
 */

function match(el, selector) {
  if (vendor) return vendor.call(el, selector);
  var nodes = el.parentNode.querySelectorAll(selector);
  for (var i = 0; i < nodes.length; ++i) {
    if (nodes[i] == el) return true;
  }
  return false;
}
},{}],6:[function(require,module,exports){
function select(element) {
    var selectedText;

    if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        element.focus();
        element.setSelectionRange(0, element.value.length);

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;

},{}],7:[function(require,module,exports){
function E () {
	// Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
	on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;

},{}],8:[function(require,module,exports){
(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['module', 'select'], factory);
    } else if (typeof exports !== "undefined") {
        factory(module, require('select'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.select);
        global.clipboardAction = mod.exports;
    }
})(this, function (module, _select) {
    'use strict';

    var _select2 = _interopRequireDefault(_select);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var ClipboardAction = function () {
        /**
         * @param {Object} options
         */

        function ClipboardAction(options) {
            _classCallCheck(this, ClipboardAction);

            this.resolveOptions(options);
            this.initSelection();
        }

        /**
         * Defines base properties passed from constructor.
         * @param {Object} options
         */


        ClipboardAction.prototype.resolveOptions = function resolveOptions() {
            var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

            this.action = options.action;
            this.emitter = options.emitter;
            this.target = options.target;
            this.text = options.text;
            this.trigger = options.trigger;

            this.selectedText = '';
        };

        ClipboardAction.prototype.initSelection = function initSelection() {
            if (this.text) {
                this.selectFake();
            } else if (this.target) {
                this.selectTarget();
            }
        };

        ClipboardAction.prototype.selectFake = function selectFake() {
            var _this = this;

            var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

            this.removeFake();

            this.fakeHandlerCallback = function () {
                return _this.removeFake();
            };
            this.fakeHandler = document.body.addEventListener('click', this.fakeHandlerCallback) || true;

            this.fakeElem = document.createElement('textarea');
            // Prevent zooming on iOS
            this.fakeElem.style.fontSize = '12pt';
            // Reset box model
            this.fakeElem.style.border = '0';
            this.fakeElem.style.padding = '0';
            this.fakeElem.style.margin = '0';
            // Move element out of screen horizontally
            this.fakeElem.style.position = 'absolute';
            this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
            // Move element to the same position vertically
            this.fakeElem.style.top = (window.pageYOffset || document.documentElement.scrollTop) + 'px';
            this.fakeElem.setAttribute('readonly', '');
            this.fakeElem.value = this.text;

            document.body.appendChild(this.fakeElem);

            this.selectedText = (0, _select2.default)(this.fakeElem);
            this.copyText();
        };

        ClipboardAction.prototype.removeFake = function removeFake() {
            if (this.fakeHandler) {
                document.body.removeEventListener('click', this.fakeHandlerCallback);
                this.fakeHandler = null;
                this.fakeHandlerCallback = null;
            }

            if (this.fakeElem) {
                document.body.removeChild(this.fakeElem);
                this.fakeElem = null;
            }
        };

        ClipboardAction.prototype.selectTarget = function selectTarget() {
            this.selectedText = (0, _select2.default)(this.target);
            this.copyText();
        };

        ClipboardAction.prototype.copyText = function copyText() {
            var succeeded = undefined;

            try {
                succeeded = document.execCommand(this.action);
            } catch (err) {
                succeeded = false;
            }

            this.handleResult(succeeded);
        };

        ClipboardAction.prototype.handleResult = function handleResult(succeeded) {
            if (succeeded) {
                this.emitter.emit('success', {
                    action: this.action,
                    text: this.selectedText,
                    trigger: this.trigger,
                    clearSelection: this.clearSelection.bind(this)
                });
            } else {
                this.emitter.emit('error', {
                    action: this.action,
                    trigger: this.trigger,
                    clearSelection: this.clearSelection.bind(this)
                });
            }
        };

        ClipboardAction.prototype.clearSelection = function clearSelection() {
            if (this.target) {
                this.target.blur();
            }

            window.getSelection().removeAllRanges();
        };

        ClipboardAction.prototype.destroy = function destroy() {
            this.removeFake();
        };

        _createClass(ClipboardAction, [{
            key: 'action',
            set: function set() {
                var action = arguments.length <= 0 || arguments[0] === undefined ? 'copy' : arguments[0];

                this._action = action;

                if (this._action !== 'copy' && this._action !== 'cut') {
                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
                }
            },
            get: function get() {
                return this._action;
            }
        }, {
            key: 'target',
            set: function set(target) {
                if (target !== undefined) {
                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                        }

                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        }

                        this._target = target;
                    } else {
                        throw new Error('Invalid "target" value, use a valid Element');
                    }
                }
            },
            get: function get() {
                return this._target;
            }
        }]);

        return ClipboardAction;
    }();

    module.exports = ClipboardAction;
});

},{"select":6}],9:[function(require,module,exports){
(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['module', './clipboard-action', 'tiny-emitter', 'good-listener'], factory);
    } else if (typeof exports !== "undefined") {
        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
        global.clipboard = mod.exports;
    }
})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
    'use strict';

    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

    var _goodListener2 = _interopRequireDefault(_goodListener);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var Clipboard = function (_Emitter) {
        _inherits(Clipboard, _Emitter);

        /**
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         * @param {Object} options
         */

        function Clipboard(trigger, options) {
            _classCallCheck(this, Clipboard);

            var _this = _possibleConstructorReturn(this, _Emitter.call(this));

            _this.resolveOptions(options);
            _this.listenClick(trigger);
            return _this;
        }

        /**
         * Defines if attributes would be resolved using internal setter functions
         * or custom functions that were passed in the constructor.
         * @param {Object} options
         */


        Clipboard.prototype.resolveOptions = function resolveOptions() {
            var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

            this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
            this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
            this.text = typeof options.text === 'function' ? options.text : this.defaultText;
        };

        Clipboard.prototype.listenClick = function listenClick(trigger) {
            var _this2 = this;

            this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                return _this2.onClick(e);
            });
        };

        Clipboard.prototype.onClick = function onClick(e) {
            var trigger = e.delegateTarget || e.currentTarget;

            if (this.clipboardAction) {
                this.clipboardAction = null;
            }

            this.clipboardAction = new _clipboardAction2.default({
                action: this.action(trigger),
                target: this.target(trigger),
                text: this.text(trigger),
                trigger: trigger,
                emitter: this
            });
        };

        Clipboard.prototype.defaultAction = function defaultAction(trigger) {
            return getAttributeValue('action', trigger);
        };

        Clipboard.prototype.defaultTarget = function defaultTarget(trigger) {
            var selector = getAttributeValue('target', trigger);

            if (selector) {
                return document.querySelector(selector);
            }
        };

        Clipboard.prototype.defaultText = function defaultText(trigger) {
            return getAttributeValue('text', trigger);
        };

        Clipboard.prototype.destroy = function destroy() {
            this.listener.destroy();

            if (this.clipboardAction) {
                this.clipboardAction.destroy();
                this.clipboardAction = null;
            }
        };

        return Clipboard;
    }(_tinyEmitter2.default);

    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */
    function getAttributeValue(suffix, element) {
        var attribute = 'data-clipboard-' + suffix;

        if (!element.hasAttribute(attribute)) {
            return;
        }

        return element.getAttribute(attribute);
    }

    module.exports = Clipboard;
});

},{"./clipboard-action":8,"good-listener":4,"tiny-emitter":7}]},{},[9])(9)
});
/* -------- studio/v2/js/jquery.autosize.js -------- */
/*!
    Autosize 1.18.17
    license: MIT
    http://www.jacklmoore.com/autosize
*/
(function ($) {
    var
    defaults = {
        className: 'autosizejs',
        id: 'autosizejs',
        append: '\n',
        callback: false,
        resizeDelay: 10,
        placeholder: true
    },

    // border:0 is unnecessary, but avoids a bug in Firefox on OSX
    copy = '<textarea tabindex="-1" style="position:absolute; top:-999px; left:0; right:auto; bottom:auto; border:0; padding: 0; -moz-box-sizing:content-box; -webkit-box-sizing:content-box; box-sizing:content-box; word-wrap:break-word; height:0 !important; min-height:0 !important; overflow:hidden; transition:none; -webkit-transition:none; -moz-transition:none;"/>',

    // line-height is conditionally included because IE7/IE8/old Opera do not return the correct value.
    typographyStyles = [
        'fontFamily',
        'fontSize',
        'fontWeight',
        'fontStyle',
        'letterSpacing',
        'textTransform',
        'wordSpacing',
        'textIndent',
        'whiteSpace'
    ],

    // to keep track which textarea is being mirrored when adjust() is called.
    mirrored,

    // the mirror element, which is used to calculate what size the mirrored element should be.
    mirror = $(copy).data('autosize', true)[0];

    // test that line-height can be accurately copied.
    mirror.style.lineHeight = '99px';
    if ($(mirror).css('lineHeight') === '99px') {
        typographyStyles.push('lineHeight');
    }
    mirror.style.lineHeight = '';

    $.fn.autosize = function (options) {
        if (!this.length) {
            return this;
        }

        options = $.extend({}, defaults, options || {});

        if (mirror.parentNode !== document.body) {
            $(document.body).append(mirror);
        }

        return this.each(function () {
            var
            ta = this,
            $ta = $(ta),
            maxHeight,
            minHeight,
            boxOffset = 0,
            callback = $.isFunction(options.callback),
            originalStyles = {
                height: ta.style.height,
                overflow: ta.style.overflow,
                overflowY: ta.style.overflowY,
                wordWrap: ta.style.wordWrap,
                resize: ta.style.resize
            },
            timeout,
            width = $ta.width(),
            taResize = $ta.css('resize');

            if ($ta.data('autosize')) {
                // exit if autosize has already been applied, or if the textarea is the mirror element.
                return;
            }
            $ta.data('autosize', true);

            if ($ta.css('box-sizing') === 'border-box' || $ta.css('-moz-box-sizing') === 'border-box' || $ta.css('-webkit-box-sizing') === 'border-box'){
                boxOffset = $ta.outerHeight() - $ta.height();
            }

            // IE8 and lower return 'auto', which parses to NaN, if no min-height is set.
            minHeight = Math.max(parseFloat($ta.css('minHeight')) - boxOffset || 0, $ta.height());

            $ta.css({
                overflow: 'hidden',
                overflowY: 'hidden',
                wordWrap: 'break-word' // horizontal overflow is hidden, so break-word is necessary for handling words longer than the textarea width
            });

            if (taResize === 'vertical') {
                $ta.css('resize','none');
            } else if (taResize === 'both') {
                $ta.css('resize', 'horizontal');
            }

            // getComputedStyle is preferred here because it preserves sub-pixel values, while jQuery's .width() rounds to an integer.
            function setWidth() {
                var width;
                var style = window.getComputedStyle ? window.getComputedStyle(ta, null) : null;

                if (style) {
                    width = parseFloat(style.width);
                    if (style.boxSizing === 'border-box' || style.webkitBoxSizing === 'border-box' || style.mozBoxSizing === 'border-box') {
                        $.each(['paddingLeft', 'paddingRight', 'borderLeftWidth', 'borderRightWidth'], function(i,val){
                            width -= parseFloat(style[val]);
                        });
                    }
                } else {
                    width = $ta.width();
                }

                mirror.style.width = Math.max(width,0) + 'px';
            }

            function initMirror() {
                var styles = {};

                mirrored = ta;
                mirror.className = options.className;
                mirror.id = options.id;
                maxHeight = parseFloat($ta.css('maxHeight'));

                // mirror is a duplicate textarea located off-screen that
                // is automatically updated to contain the same text as the
                // original textarea.  mirror always has a height of 0.
                // This gives a cross-browser supported way getting the actual
                // height of the text, through the scrollTop property.
                $.each(typographyStyles, function(i,val){
                    styles[val] = $ta.css(val);
                });

                $(mirror).css(styles).attr('wrap', $ta.attr('wrap'));

                setWidth();

                // Chrome-specific fix:
                // When the textarea y-overflow is hidden, Chrome doesn't reflow the text to account for the space
                // made available by removing the scrollbar. This workaround triggers the reflow for Chrome.
                if (window.chrome) {
                    var width = ta.style.width;
                    ta.style.width = '0px';
                    var ignore = ta.offsetWidth;
                    ta.style.width = width;
                }
            }

            // Using mainly bare JS in this function because it is going
            // to fire very often while typing, and needs to very efficient.
            function adjust() {
                var height, originalHeight;

                if (mirrored !== ta) {
                    initMirror();
                } else {
                    setWidth();
                }

                if (!ta.value && options.placeholder) {
                    // If the textarea is empty, copy the placeholder text into
                    // the mirror control and use that for sizing so that we
                    // don't end up with placeholder getting trimmed.
                    mirror.value = ($ta.attr("placeholder") || '');
                } else {
                    mirror.value = ta.value;
                }

                mirror.value += options.append || '';
                mirror.style.overflowY = ta.style.overflowY;
                originalHeight = parseFloat(ta.style.height) || 0;

                // Setting scrollTop to zero is needed in IE8 and lower for the next step to be accurately applied
                mirror.scrollTop = 0;

                mirror.scrollTop = 9e4;

                // Using scrollTop rather than scrollHeight because scrollHeight is non-standard and includes padding.
                height = mirror.scrollTop;

                if (maxHeight && height > maxHeight) {
                    ta.style.overflowY = 'scroll';
                    height = maxHeight;
                } else {
                    ta.style.overflowY = 'hidden';
                    if (height < minHeight) {
                        height = minHeight;
                    }
                }

                height += boxOffset;

                if (Math.abs(originalHeight - height) > 1/100) {
                    ta.style.height = height + 'px';

                    // Trigger a repaint for IE8 for when ta is nested 2 or more levels inside an inline-block
                    mirror.className = mirror.className;

                    if (callback) {
                        options.callback.call(ta,ta);
                    }
                    $ta.trigger('autosize.resized');
                }
            }

            function resize () {
                clearTimeout(timeout);
                timeout = setTimeout(function(){
                    var newWidth = $ta.width();

                    if (newWidth !== width) {
                        width = newWidth;
                        adjust();
                    }
                }, parseInt(options.resizeDelay,10));
            }

            if ('onpropertychange' in ta) {
                if ('oninput' in ta) {
                    // Detects IE9.  IE9 does not fire onpropertychange or oninput for deletions,
                    // so binding to onkeyup to catch most of those occasions.  There is no way that I
                    // know of to detect something like 'cut' in IE9.
                    $ta.on('input.autosize keyup.autosize', adjust);
                } else {
                    // IE7 / IE8
                    $ta.on('propertychange.autosize', function(){
                        if(event.propertyName === 'value'){
                            adjust();
                        }
                    });
                }
            } else {
                // Modern Browsers
                $ta.on('input.autosize', adjust);
            }

            // Set options.resizeDelay to false if using fixed-width textarea elements.
            // Uses a timeout and width check to reduce the amount of times adjust needs to be called after window resize.

            if (options.resizeDelay !== false) {
                $(window).on('resize.autosize', resize);
            }

            // Event for manual triggering if needed.
            // Should only be needed when the value of the textarea is changed through JavaScript rather than user input.
            $ta.on('autosize.resize', adjust);

            // Event for manual triggering that also forces the styles to update as well.
            // Should only be needed if one of typography styles of the textarea change, and the textarea is already the target of the adjust method.
            $ta.on('autosize.resizeIncludeStyle', function() {
                mirrored = null;
                adjust();
            });

            $ta.on('autosize.destroy', function(){
                mirrored = null;
                clearTimeout(timeout);
                $(window).off('resize', resize);
                $ta
                    .off('autosize')
                    .off('.autosize')
                    .css(originalStyles)
                    .removeData('autosize');
            });

            // Call adjust in case the textarea already contains text.
            adjust();
        });
    };
}(jQuery || $)); // jQuery or jQuery-like library, such as Zepto

/* -------- studio/v2/js/jquery.collapseMe.js -------- */
/*
self collapse nav
http://www.bootply.com/snippets/voCGmhNjq6
*/

$.fn.hasOverflow = function(opts) {
    var _elm = $(this)[0];

    if ((_elm.offsetWidth + opts.rightPadding) > $(window).width()) {
        return true;
    }

    return false;
};

$.fn.collapseMe = function(options) {
    var $this = this;
    var opts = options;
    var lastDocumentWidth = $(document).width();

    return this.each(function() {

        var overflowDropdown = $this.find('li.more-tab ul.dropdown-menu');

        function grow() {
            if (!$this.parent().hasOverflow(opts) && ($this.children('li:not(.more-tab)').size() > 0)) {
                var collapsed = overflowDropdown.children('li');

                if (!overflowDropdown.children('li').size()) {
                    return;
                }

                $(collapsed[0]).insertBefore($this.children('li.more-tab'));

                if (!overflowDropdown.children('li').size()) {
                    $('li.more-tab').hide();
                }
            }
        }

        function shrink() {
            while ($this.parent().hasOverflow(opts)) {
                var children = $this.children('li:not(.more-tab)');
                var count = children.size();

                if (count <= 1) {
                    return;
                }

                $(children[count - 1]).prependTo(overflowDropdown);
                $('li.more-tab').css('display', 'inline-block');
            }
        }

        function refresh() {
            if ($this.parent().hasOverflow(opts)) {
                shrink();
            } else {
                if ($(document).width() > lastDocumentWidth) {
                    grow();
                }

                lastDocumentWidth = $(document).width();
            }
        }

        $(window).resize(function() {
            refresh();
        });

        if ($(window).width() >= opts.windowMinWidth) {
            refresh();
        }
    });
}

/* -------- common/js/jquery.cookie.js -------- */
/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

/**
 * Create a cookie with the given name and value and other optional parameters.
 *
 * example $.cookie('the_cookie', 'the_value');
 * desc Set the value of a cookie.
 * example $.cookie('the_cookie', 'the_value', { expires: 7, path: '/', domain: 'jquery.com', secure: true });
 * desc Create a cookie with all available options.
 * example $.cookie('the_cookie', 'the_value');
 * desc Create a session cookie.
 * example $.cookie('the_cookie', null);
 * desc Delete a cookie by passing null as value. Keep in mind that you have to use the same path and domain
 *       used when the cookie was set.
 *
 * param String name The name of the cookie.
 * param String value The value of the cookie.
 * param Object options An object literal containing key/value pairs to provide optional cookie attributes.
 * option Number|Date expires Either an integer specifying the expiration date from now on in days or a Date object.
 *                             If a negative value is specified (e.g. a date in the past), the cookie will be deleted.
 *                             If set to null or omitted, the cookie will be a session cookie and will not be retained
 *                             when the the browser exits.
 * option String path The value of the path atribute of the cookie (default: path of page that created the cookie).
 * option String domain The value of the domain attribute of the cookie (default: domain of page that created the cookie).
 * option Boolean secure If true, the secure attribute of the cookie will be set and the cookie transmission will
 *                        require a secure protocol (like HTTPS).
 * type undefined
 *
 * name $.cookie
 * cat Plugins/Cookie
 * author Klaus Hartl/klaus.hartl@stilbuero.de
 */

/**
 * Get the value of a cookie with the given name.
 *
 * example $.cookie('the_cookie');
 * desc Get the value of a cookie.
 *
 * param String name The name of the cookie.
 * return The value of the cookie.
 * type String
 *
 * name $.cookie
 * cat Plugins/Cookie
 * author Klaus Hartl/klaus.hartl@stilbuero.de
 */
jQuery.cookie = function(name, value, options) {
    if (typeof value != 'undefined') { // name and value given, set cookie
        options = options || {};
        if (value === null) {
            value = '';
            options.expires = -1;
        }
        var expires = '';
        if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
            var date;
            if (typeof options.expires == 'number') {
                date = new Date();
                date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
            } else {
                date = options.expires;
            }
            expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
        }
        // CAUTION: Needed to parenthesize options.path and options.domain
        // in the following expressions, otherwise they evaluate to undefined
        // in the packed version for some reason...
        var path = options.path ? '; path=' + (options.path) : '';
        var domain = options.domain ? '; domain=' + (options.domain) : '';
        var secure = options.secure ? '; secure' : '';
        document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
    } else { // only name given, get cookie
        var cookieValue = null;
        if (document.cookie && document.cookie != '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = jQuery.trim(cookies[i]);
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, name.length + 1) == (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }
};

/* -------- common/js/svg4everybody.js -------- */
!function(root, factory) {
    "function" == typeof define && define.amd ? define([], function() {
        return root.svg4everybody = factory();
    }) : "object" == typeof exports ? module.exports = factory() : root.svg4everybody = factory();
}(this, function() {
    /*! svg4everybody v2.0.0 | github.com/jonathantneal/svg4everybody */
    function embed(svg, g) {
        if (g) {
            var viewBox = !svg.getAttribute("viewBox") && g.getAttribute("viewBox"), fragment = document.createDocumentFragment(), clone = g.cloneNode(!0);
            for (viewBox && svg.setAttribute("viewBox", viewBox); clone.childNodes.length; ) {
                fragment.appendChild(clone.firstChild);
            }
            svg.appendChild(fragment);
        }
    }
    function loadreadystatechange(xhr) {
        xhr.onreadystatechange = function() {
            if (4 === xhr.readyState) {
                var x = document.createElement("x");
                x.innerHTML = xhr.responseText, xhr.s.splice(0).map(function(array) {
                    embed(array[0], x.querySelector("#" + array[1].replace(/(\W)/g, "\\$1")));
                });
            }
        }, xhr.onreadystatechange();
    }
    function svg4everybody(opts) {
        function oninterval() {
            for (var use; use = uses[0]; ) {
                var svg = use.parentNode;
                if (svg && /svg/i.test(svg.nodeName)) {
                    var src = use.getAttribute("xlink:href");
                    if (polyfill && (!validate || validate(src, svg, use))) {
                        var url = src.split("#"), url_root = url[0], url_hash = url[1];
                        if (svg.removeChild(use), url_root.length) {
                            var xhr = svgCache[url_root] = svgCache[url_root] || new XMLHttpRequest();
                            xhr.s || (xhr.s = [], xhr.open("GET", url_root), xhr.send()), xhr.s.push([ svg, url_hash ]), 
                            loadreadystatechange(xhr);
                        } else {
                            embed(svg, document.getElementById(url_hash));
                        }
                    }
                }
            }
            requestAnimationFrame(oninterval, 17);
        }
        opts = opts || {};
        var uses = document.getElementsByTagName("use"), polyfill = "polyfill" in opts ? opts.polyfill : /\bEdge\/12\b|\bTrident\/[567]\b|\bVersion\/7.0 Safari\b/.test(navigator.userAgent) || (navigator.userAgent.match(/AppleWebKit\/(\d+)/) || [])[1] < 537, validate = opts.validate, requestAnimationFrame = window.requestAnimationFrame || setTimeout, svgCache = {};
        polyfill && oninterval();
    }
    return svg4everybody;
});
/* -------- common/js/jquery.switchClass.js -------- */
/**
 *
 * jquery.SwitchClass.js - A jQuery Plugin
 *
 * http://www.pedrocorreia.net/mySnippets/javascript/jQuery-Switch-Replace-Change-Class-Name
 */
(function($){

    /**
     * Switch element(s) Class Name
     */
    $.switchClass = function (selectors) {
        var _selectors = [], //our selectors array container, it will hold all our objects
            _Switch = function(o, oldClass, newClass){
                if(o && oldClass && newClass && o.hasClass(oldClass)){
                  o.removeClass(oldClass).addClass(newClass);
                }
            };

        //check if we have an object or an array of objects,
        //the "selectors" will always be in an array, even if we
        //specify an Object, this will be added to our selectors Array
        if($.isArray(selectors)){ _selectors = selectors; }
        else{ _selectors.push(selectors); }

        //do we have any elements in our, selectors, array?
        if (_selectors.length === 0) { return; }

        //iterate over selectors Array
        $.each(_selectors, function(idx, selector){
            _Switch($(selector.elem), selector.old_class, selector.new_class);
        });
    };

    /**
     * Switch element(s) Class Name
     * jQuery custom function
     *
     */
    $.fn.switchClass = function(old_class, new_class){
      return this.each(function(){
        $.switchClass({elem: this, old_class: old_class, new_class: new_class});
      });
    };

})(jQuery);

/* -------- common/js/jquery.rcmenu.js -------- */
/**
 * jQuery Plugin for creating right click menus
 */
;(function($, window) {

    "use strict";

    // plugin defaults
    var defaults = {
        menuId: 'rcmenu',
        menuClass: '',
        menuContainer: '<div/>',
        menuOpen: function() {},
        selector: 'a[data-right-click="rcmenu"], div[data-right-click="rcmenu"], li[data-right-click="rcmenu"]',
        offset: {
            top: 0,
            right: 10,
            bottom: null,
            left: null
        }
    };

    function RCmenu (options) {
        // apply passed in settings
        this.settings = $.extend({}, defaults, options);

        // scoped vars
        this.mouseOverMenu = false;
        this.size = {};

        // create instance
        this.init();
    }

    $.extend(RCmenu.prototype, {
        init: function() {
            var that = this;

            // create menu
            $(this.settings.menuContainer, {
                id: this.settings.menuId,
                'class': this.settings.menuClass,
                css: 'position:absolute',
                hover: function() {
                    that.mouseOverMenu = true;
                },
                blur: function() {
                    that.mouseOverMenu = false;
                }
            }).hide().appendTo('body');

            // now that we've created container, make a ref
            this.container = $('#' + this.settings.menuId);

            this.applyMouseBindings();
        },
        applyMouseBindings: function() {
            var that = this;

            // display on right click
            $('body').off('contextmenu').on(
                'contextmenu',
                this.settings.selector,
                function(event) {
                    that.show(event);
                    return false;
                }
            );

            // hide right click menu on external click
            $('body').off('mousedown').on('mousedown', function(event) {
                if (!$(event.target).is('#' + that.settings.menuId) &&
                    $(event.target).parents('#' + that.settings.menuId).length === 0) {

                    that.container.hide();
                }
            });
        },
        updateSelector: function(newSelector) {
            this.settings.selector = newSelector;
            this.applyMouseBindings();
        },
        empty: function() {
            this.container.empty();
            return this;
        },
        addMenuItem: function(itemHtml) {
            this.container.append(itemHtml);
            return this;
        },
        show: function(event) {
            event.stopPropagation();

            this.container.show();

            // run the callback
            this.settings.menuOpen(event);

            this.updatePosition(event);
            return this;
        },
        hide: function() {
            this.container.hide();
            return this;
        },
        updatePosition: function(event) {
            this.size = {
                'width': $(window).width(),
                'height': $(window).height(),
                'scroll': $(window).scrollTop(),
                'menuW': $(this.container).width(),
                'menuH': $(this.container).height()
            };

            var topValue = event.clientY + this.size.scroll + this.settings.offset.top;
            if ((event.clientY + this.size.menuH) > this.size.height && event.clientY > this.size.menuH) {
                topValue -= this.size.menuH;
            }

            var leftValue = event.clientX + this.settings.offset.right;
            if ((event.clientX + this.size.menuW) > this.size.width) {
                leftValue -= this.size.menuW;
            }
            this.container.css({
                'top': topValue,
                'left': leftValue
            });

            return this;
        }
    });

    // attach plugin to jQuery namespace
    $.rcmenu = function (options) {
        return new RCmenu(options);
    };
})(jQuery, window);

/* -------- common/js/bootstrap-slider.js -------- */
/**
 * This is version 9f01d34 from https://github.com/seiyria/bootstrap-slider
 */
/*! =========================================================
 * bootstrap-slider.js
 *
 * Maintainers: 
 *		Kyle Kemp 
 *			- Twitter: @seiyria
 *			- Github:  seiyria
 *		Rohit Kalkur
 *			- Twitter: @Rovolutionary
 *			- Github:  rovolution
 *
 * =========================================================
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================= */


/**
 * Bridget makes jQuery widgets
 * v1.0.1
 * MIT license
 */
( function( $ ) {

	( function( $ ) {

		'use strict';

		// -------------------------- utils -------------------------- //

		var slice = Array.prototype.slice;

		function noop() {}

		// -------------------------- definition -------------------------- //

		function defineBridget( $ ) {

			// bail if no jQuery
			if ( !$ ) {
				return;
			}

			// -------------------------- addOptionMethod -------------------------- //

			/**
			 * adds option method -> $().plugin('option', {...})
			 * @param {Function} PluginClass - constructor class
			 */
			function addOptionMethod( PluginClass ) {
				// don't overwrite original option method
				if ( PluginClass.prototype.option ) {
					return;
				}

			  // option setter
			  PluginClass.prototype.option = function( opts ) {
			    // bail out if not an object
			    if ( !$.isPlainObject( opts ) ){
			      return;
			    }
			    this.options = $.extend( true, this.options, opts );
			  };
			}


			// -------------------------- plugin bridge -------------------------- //

			// helper function for logging errors
			// $.error breaks jQuery chaining
			var logError = typeof console === 'undefined' ? noop :
			  function( message ) {
			    console.error( message );
			  };

			/**
			 * jQuery plugin bridge, access methods like $elem.plugin('method')
			 * @param {String} namespace - plugin name
			 * @param {Function} PluginClass - constructor class
			 */
			function bridge( namespace, PluginClass ) {
			  // add to jQuery fn namespace
			  $.fn[ namespace ] = function( options ) {
			    if ( typeof options === 'string' ) {
			      // call plugin method when first argument is a string
			      // get arguments for method
			      var args = slice.call( arguments, 1 );

			      for ( var i=0, len = this.length; i < len; i++ ) {
			        var elem = this[i];
			        var instance = $.data( elem, namespace );
			        if ( !instance ) {
			          logError( "cannot call methods on " + namespace + " prior to initialization; " +
			            "attempted to call '" + options + "'" );
			          continue;
			        }
			        if ( !$.isFunction( instance[options] ) || options.charAt(0) === '_' ) {
			          logError( "no such method '" + options + "' for " + namespace + " instance" );
			          continue;
			        }

			        // trigger method with arguments
			        var returnValue = instance[ options ].apply( instance, args);

			        // break look and return first value if provided
			        if ( returnValue !== undefined && returnValue !== instance) {
			          return returnValue;
			        }
			      }
			      // return this if no return value
			      return this;
			    } else {
			      var objects = this.map( function() {
			        var instance = $.data( this, namespace );
			        if ( instance ) {
			          // apply options & init
			          instance.option( options );
			          instance._init();
			        } else {
			          // initialize new instance
			          instance = new PluginClass( this, options );
			          $.data( this, namespace, instance );
			        }
			        return $(this);
			      });

			      if(!objects || objects.length > 1) {
			      	return objects;
			      } else {
			      	return objects[0];
			      }
			    }
			  };

			}

			// -------------------------- bridget -------------------------- //

			/**
			 * converts a Prototypical class into a proper jQuery plugin
			 *   the class must have a ._init method
			 * @param {String} namespace - plugin name, used in $().pluginName
			 * @param {Function} PluginClass - constructor class
			 */
			$.bridget = function( namespace, PluginClass ) {
			  addOptionMethod( PluginClass );
			  bridge( namespace, PluginClass );
			};

			return $.bridget;

		}

	  	// get jquery from browser global
	  	defineBridget( $ );

	})( $ );


	/*************************************************
					
			BOOTSTRAP-SLIDER SOURCE CODE

	**************************************************/

	(function( $ ) {

		var ErrorMsgs = {
			formatInvalidInputErrorMsg : function(input) {
				return "Invalid input value '" + input + "' passed in";
			},
			callingContextNotSliderInstance : "Calling context element does not have instance of Slider bound to it. Check your code to make sure the JQuery object returned from the call to the slider() initializer is calling the method"
		};



		/*************************************************
						
							CONSTRUCTOR

		**************************************************/
		var Slider = function(element, options) {
			createNewSlider.call(this, element, options);
			return this;
		};

		function createNewSlider(element, options) {
			/*************************************************
						
							Create Markup

			**************************************************/
			if(typeof element === "string") {
				this.element = document.querySelector(element);
			} else if(element instanceof HTMLElement) {
				this.element = element;
			}
			
			var origWidth = this.element.style.width;
			var updateSlider = false;
			var parent = this.element.parentNode;
			var sliderTrackSelection;
			var sliderMinHandle;
			var sliderMaxHandle;

			if (this.sliderElem) {
				updateSlider = true;
			} else {
				/* Create elements needed for slider */
				this.sliderElem = document.createElement("div");
				this.sliderElem.className = "slider";

				/* Create slider track elements */
				var sliderTrack = document.createElement("div");
				sliderTrack.className = "slider-track";

				sliderTrackSelection = document.createElement("div");
				sliderTrackSelection.className = "slider-selection";

				sliderMinHandle = document.createElement("div");
				sliderMinHandle.className = "slider-handle min-slider-handle";

				sliderMaxHandle = document.createElement("div");
				sliderMaxHandle.className = "slider-handle max-slider-handle";

				sliderTrack.appendChild(sliderTrackSelection);
				sliderTrack.appendChild(sliderMinHandle);
				sliderTrack.appendChild(sliderMaxHandle);

				var createAndAppendTooltipSubElements = function(tooltipElem) {
					var arrow = document.createElement("div");
					arrow.className = "tooltip-arrow";

					var inner = document.createElement("div");
					inner.className = "tooltip-inner";

					tooltipElem.appendChild(arrow);
					tooltipElem.appendChild(inner);
				};

				/* Create tooltip elements */
				var sliderTooltip = document.createElement("div");
				sliderTooltip.className = "tooltip tooltip-main";
				createAndAppendTooltipSubElements(sliderTooltip);

				var sliderTooltipMin = document.createElement("div");
				sliderTooltipMin.className = "tooltip tooltip-min";
				createAndAppendTooltipSubElements(sliderTooltipMin);

				var sliderTooltipMax = document.createElement("div");
				sliderTooltipMax.className = "tooltip tooltip-max";
				createAndAppendTooltipSubElements(sliderTooltipMax);


				/* Append components to sliderElem */
				this.sliderElem.appendChild(sliderTrack);
				this.sliderElem.appendChild(sliderTooltip);
				this.sliderElem.appendChild(sliderTooltipMin);
				this.sliderElem.appendChild(sliderTooltipMax);

				/* Append slider element to parent container, right before the original <input> element */
				parent.insertBefore(this.sliderElem, this.element);
				
				/* Hide original <input> element */
				this.element.style.display = "none";
			}
			/* If JQuery exists, cache JQ references */
			if($) {
				this.$element = $(this.element);
				this.$sliderElem = $(this.sliderElem);
			}

			/*************************************************
						
							Process Options

			**************************************************/
			options = options ? options : {};
			var optionTypes = Object.keys(this.defaultOptions);

			for(var i = 0; i < optionTypes.length; i++) {
				var optName = optionTypes[i];

				// First check if an option was passed in via the constructor
				var val = options[optName];
				// If no data attrib, then check data atrributes
				val = (typeof val !== 'undefined') ? val : getDataAttrib(this.element, optName);
				// Finally, if nothing was specified, use the defaults
				val = (val !== null) ? val : this.defaultOptions[optName];

				// Set all options on the instance of the Slider
				if(!this.options) {
					this.options = {};
				}
				this.options[optName] = val;
			}

			function getDataAttrib(element, optName) {
				var dataName = "data-slider-" + optName;
				var dataValString = element.getAttribute(dataName);
				
				try {
					return JSON.parse(dataValString);
				}
				catch(err) {
					return dataValString;
				}
			}

			/*************************************************
						
								Setup

			**************************************************/
			this.eventToCallbackMap = {};
			this.sliderElem.id = this.options.id;

			this.touchCapable = 'ontouchstart' in window || (window.DocumentTouch && document instanceof window.DocumentTouch);

			this.tooltip = this.sliderElem.querySelector('.tooltip-main');
			this.tooltipInner = this.tooltip.querySelector('.tooltip-inner');

			this.tooltip_min = this.sliderElem.querySelector('.tooltip-min');
			this.tooltipInner_min = this.tooltip_min.querySelector('.tooltip-inner');

			this.tooltip_max = this.sliderElem.querySelector('.tooltip-max');
			this.tooltipInner_max= this.tooltip_max.querySelector('.tooltip-inner');

			if (updateSlider === true) {
				// Reset classes
				this._removeClass(this.sliderElem, 'slider-horizontal');
				this._removeClass(this.sliderElem, 'slider-vertical');
				this._removeClass(this.tooltip, 'hide');
				this._removeClass(this.tooltip_min, 'hide');
				this._removeClass(this.tooltip_max, 'hide');

				// Undo existing inline styles for track
				["left", "top", "width", "height"].forEach(function(prop) {
					this._removeProperty(this.trackSelection, prop);
				}, this);

				// Undo inline styles on handles
				[this.handle1, this.handle2].forEach(function(handle) {
					this._removeProperty(handle, 'left');
					this._removeProperty(handle, 'top');	
				}, this);

				// Undo inline styles and classes on tooltips
				[this.tooltip, this.tooltip_min, this.tooltip_max].forEach(function(tooltip) {
					this._removeProperty(tooltip, 'left');
					this._removeProperty(tooltip, 'top');
					this._removeProperty(tooltip, 'margin-left');
					this._removeProperty(tooltip, 'margin-top');

					this._removeClass(tooltip, 'right');
					this._removeClass(tooltip, 'top');
				}, this);
			}

			if(this.options.orientation === 'vertical') {
				this._addClass(this.sliderElem,'slider-vertical');
				
				this.stylePos = 'top';
				this.mousePos = 'pageY';
				this.sizePos = 'offsetHeight';

				this._addClass(this.tooltip, 'right');
				this.tooltip.style.left = '100%';
				
				this._addClass(this.tooltip_min, 'right');
				this.tooltip_min.style.left = '100%';

				this._addClass(this.tooltip_max, 'right');
				this.tooltip_max.style.left = '100%';
			} else {
				this._addClass(this.sliderElem, 'slider-horizontal');
				this.sliderElem.style.width = origWidth;

				this.options.orientation = 'horizontal';
				this.stylePos = 'left';
				this.mousePos = 'pageX';
				this.sizePos = 'offsetWidth';
				
				this._addClass(this.tooltip, 'top');
				this.tooltip.style.top = -this.tooltip.outerHeight - 14 + 'px';
				
				this._addClass(this.tooltip_min, 'top');
				this.tooltip_min.style.top = -this.tooltip_min.outerHeight - 14 + 'px';

				this._addClass(this.tooltip_max, 'top');
				this.tooltip_max.style.top = -this.tooltip_max.outerHeight - 14 + 'px';
			}

			if (this.options.value instanceof Array) {
				this.options.range = true;
			} else if (this.options.range) {
				// User wants a range, but value is not an array
				this.options.value = [this.options.value, this.options.max];
			}

			this.trackSelection = sliderTrackSelection || this.trackSelection;
			if (this.options.selection === 'none') {
				this._addClass(this.trackSelection, 'hide');
			}

			this.handle1 = sliderMinHandle || this.handle1;
			this.handle2 = sliderMaxHandle || this.handle2;

			if (updateSlider === true) {
				// Reset classes
				this._removeClass(this.handle1, 'round triangle');
				this._removeClass(this.handle2, 'round triangle hide');
			}

			var availableHandleModifiers = ['round', 'triangle', 'custom'];
			var isValidHandleType = availableHandleModifiers.indexOf(this.options.handle) !== -1;
			if (isValidHandleType) {
				this._addClass(this.handle1, this.options.handle);
				this._addClass(this.handle2, this.options.handle);
			}

			this.offset = this._offset(this.sliderElem);
			this.size = this.sliderElem[this.sizePos];
			this.setValue(this.options.value);

			/******************************************
						
						Bind Event Listeners

			******************************************/

			// Bind keyboard handlers
			this.handle1Keydown = this._keydown.bind(this, 0);
			this.handle1.addEventListener("keydown", this.handle1Keydown, false);

			this.handle2Keydown = this._keydown.bind(this, 0);
			this.handle2.addEventListener("keydown", this.handle2Keydown, false);

			if (this.touchCapable) {
				// Bind touch handlers
				this.mousedown = this._mousedown.bind(this);
				this.sliderElem.addEventListener("touchstart", this.mousedown, false);
			}
                        // Bind mouse handlers
                        this.mousedown = this._mousedown.bind(this);
                        this.sliderElem.addEventListener("mousedown", this.mousedown, false);

			// Bind tooltip-related handlers
			if(this.options.tooltip === 'hide') {
				this._addClass(this.tooltip, 'hide');
				this._addClass(this.tooltip_min, 'hide');
				this._addClass(this.tooltip_max, 'hide');
			} else if(this.options.tooltip === 'always') {
				this._showTooltip();
				this._alwaysShowTooltip = true;
			} else {
				this.showTooltip = this._showTooltip.bind(this);
				this.hideTooltip = this._hideTooltip.bind(this);

				this.sliderElem.addEventListener("mouseenter", this.showTooltip, false);
				this.sliderElem.addEventListener("mouseleave", this.hideTooltip, false);

				this.handle1.addEventListener("focus", this.showTooltip, false);
				this.handle1.addEventListener("blur", this.hideTooltip, false);

				this.handle2.addEventListener("focus", this.showTooltip, false);
				this.handle2.addEventListener("blur", this.hideTooltip, false);
			}

			if(this.options.enabled) {
				this.enable();
			} else {
				this.disable();
			}
		}

		/*************************************************
						
					INSTANCE PROPERTIES/METHODS

		- Any methods bound to the prototype are considered 
		part of the plugin's `public` interface

		**************************************************/
		Slider.prototype = {
			_init: function() {}, // NOTE: Must exist to support bridget

			constructor: Slider,

			defaultOptions: {
				id: "",
			  	min: 0,
				max: 10,
				step: 1,
				precision: 0,
				orientation: 'horizontal',
				value: 5,
				range: false,
				selection: 'before',
				tooltip: 'show',
				tooltip_split: false,
				handle: 'round',
				reversed: false,
				enabled: true,
				formatter: function(val) {
					if(val instanceof Array) {
						return val[0] + " : " + val[1];
					} else {
						return val;
					}
				},
				natural_arrow_keys: false
			},
			
			over: false,
			
			inDrag: false,

			getValue: function() {
				if (this.options.range) {
					return this.options.value;
				}
				return this.options.value[0];
			},

			setValue: function(val, triggerSlideEvent) {
				if (!val) {
					val = 0;
				}
				this.options.value = this._validateInputValue(val);
				var applyPrecision = this._applyPrecision.bind(this);

				if (this.options.range) {
					this.options.value[0] = applyPrecision(this.options.value[0]);
					this.options.value[1] = applyPrecision(this.options.value[1]); 

					this.options.value[0] = Math.max(this.options.min, Math.min(this.options.max, this.options.value[0]));
					this.options.value[1] = Math.max(this.options.min, Math.min(this.options.max, this.options.value[1]));
				} else {
					this.options.value = applyPrecision(this.options.value);
					this.options.value = [ Math.max(this.options.min, Math.min(this.options.max, this.options.value))];
					this._addClass(this.handle2, 'hide');
					if (this.options.selection === 'after') {
						this.options.value[1] = this.options.max;
					} else {
						this.options.value[1] = this.options.min;
					}
				}

				this.diff = this.options.max - this.options.min;
				if (this.diff > 0) {
					this.percentage = [
						(this.options.value[0] - this.options.min) * 100 / this.diff,
						(this.options.value[1] - this.options.min) * 100 / this.diff,
						this.options.step * 100 / this.diff
					];
				} else {
					this.percentage = [0, 0, 100];
				}

				this._layout();

				var sliderValue = this.options.range ? this.options.value : this.options.value[0];
				this._setDataVal(sliderValue);

				if(triggerSlideEvent === true) {
					this._trigger('slide', sliderValue);
				}

				return this;
			},

			destroy: function(){
				// Remove event handlers on slider elements
				this._removeSliderEventHandlers();

				// Remove the slider from the DOM
				this.sliderElem.parentNode.removeChild(this.sliderElem);
				/* Show original <input> element */
				this.element.style.display = "";

				// Clear out custom event bindings
				this._cleanUpEventCallbacksMap();

				// Remove data values
				this.element.removeAttribute("data");

				// Remove JQuery handlers/data
				if($) {
					this._unbindJQueryEventHandlers();
					this.$element.removeData('slider');
				}
			},

			disable: function() {
				this.options.enabled = false;
				this.handle1.removeAttribute("tabindex");
				this.handle2.removeAttribute("tabindex");
				this._addClass(this.sliderElem, 'slider-disabled');
				this._trigger('slideDisabled');

				return this;
			},

			enable: function() {
				this.options.enabled = true;
				this.handle1.setAttribute("tabindex", 0);
				this.handle2.setAttribute("tabindex", 0);
				this._removeClass(this.sliderElem, 'slider-disabled');
				this._trigger('slideEnabled');

				return this;
			},

			toggle: function() {
				if(this.options.enabled) {
					this.disable();
				} else {
					this.enable();
				}

				return this;
			},

			isEnabled: function() {
				return this.options.enabled;
			},

			on: function(evt, callback) {
				if($) {
					this.$element.on(evt, callback);
					this.$sliderElem.on(evt, callback);
				} else {
					this._bindNonQueryEventHandler(evt, callback);
				}
				return this;
			},

			getAttribute: function(attribute) {
				if(attribute) {
					return this.options[attribute];		
				} else {
					return this.options;
				}
			},

			setAttribute: function(attribute, value) {
				this.options[attribute] = value;
				return this;
			},

			refresh: function() {
				this._removeSliderEventHandlers();
				createNewSlider.call(this, this.element, this.options);
				if($) {
					// Bind new instance of slider to the element
					$.data(this.element, 'slider', this);
				}
				return this;
			},
			
			/******************************+
					
						HELPERS

			- Any method that is not part of the public interface.
			- Place it underneath this comment block and write its signature like so:

			  					_fnName : function() {...}

			********************************/
			_removeSliderEventHandlers: function() {
				// Remove event listeners from handle1
				this.handle1.removeEventListener("keydown", this.handle1Keydown, false);
				this.handle1.removeEventListener("focus", this.showTooltip, false);
				this.handle1.removeEventListener("blur", this.hideTooltip, false);

				// Remove event listeners from handle2
				this.handle2.removeEventListener("keydown", this.handle2Keydown, false);
				this.handle2.removeEventListener("focus", this.handle2Keydown, false);
				this.handle2.removeEventListener("blur", this.handle2Keydown, false);

				// Remove event listeners from sliderElem
				this.sliderElem.removeEventListener("mouseenter", this.showTooltip, false);
				this.sliderElem.removeEventListener("mouseleave", this.hideTooltip, false);
				this.sliderElem.removeEventListener("touchstart", this.mousedown, false);
				this.sliderElem.removeEventListener("mousedown", this.mousedown, false);
			},
			_bindNonQueryEventHandler: function(evt, callback) {
				if(this.eventToCallbackMap[evt]===undefined) {
					this.eventToCallbackMap[evt] = [];
				}
				this.eventToCallbackMap[evt].push(callback);
			},
			_cleanUpEventCallbacksMap: function() {
				var eventNames = Object.keys(this.eventToCallbackMap);
				for(var i = 0; i < eventNames.length; i++) {
					var eventName = eventNames[i];
					this.eventToCallbackMap[eventName] = null;
				}
			},
			_showTooltip: function() {
				if (this.options.tooltip_split === false ){
	            	this._addClass(this.tooltip, 'in');
		        } else {
		            this._addClass(this.tooltip_min, 'in');
		            this._addClass(this.tooltip_max, 'in');
		        }
				this.over = true;
			},
			_hideTooltip: function() {
				if (this.inDrag === false && this.alwaysShowTooltip !== true) {
					this._removeClass(this.tooltip, 'in');
					this._removeClass(this.tooltip_min, 'in');
					this._removeClass(this.tooltip_max, 'in');
				}
				this.over = false;
			},
				_layout: function() {			
				var positionPercentages;

				if(this.options.reversed) {
					positionPercentages = [ 100 - this.percentage[0], this.percentage[1] ];
				} else {
					positionPercentages = [ this.percentage[0], this.percentage[1] ];
				}

				this.handle1.style[this.stylePos] = positionPercentages[0]+'%';
				this.handle2.style[this.stylePos] = positionPercentages[1]+'%';

				if (this.options.orientation === 'vertical') {
					this.trackSelection.style.top = Math.min(positionPercentages[0], positionPercentages[1]) +'%';
					this.trackSelection.style.height = Math.abs(positionPercentages[0] - positionPercentages[1]) +'%';
				} else {
					this.trackSelection.style.left = Math.min(positionPercentages[0], positionPercentages[1]) +'%';
					this.trackSelection.style.width = Math.abs(positionPercentages[0] - positionPercentages[1]) +'%';

			        var offset_min = this.tooltip_min.getBoundingClientRect();
			        var offset_max = this.tooltip_max.getBoundingClientRect();

			        if (offset_min.right > offset_max.left) {
			            this._removeClass(this.tooltip_max, 'top');
			            this._addClass(this.tooltip_max, 'bottom');
			            this.tooltip_max.style.top = 18 + 'px';
			        } else {
			            this._removeClass(this.tooltip_max, 'bottom');
			            this._addClass(this.tooltip_max, 'top');
			            this.tooltip_max.style.top = -30 + 'px';
			        }
	 			}


	 			var formattedTooltipVal;

				if (this.options.range) {
					formattedTooltipVal = this.options.formatter(this.options.value);
					this._setText(this.tooltipInner, formattedTooltipVal);
					this.tooltip.style[this.stylePos] = (positionPercentages[1] + positionPercentages[0])/2 + '%';

					if (this.options.orientation === 'vertical') {
						this._css(this.tooltip, 'margin-top', -this.tooltip.offsetHeight / 2 + 'px');
					} else {
						this._css(this.tooltip, 'margin-left', -this.tooltip.offsetWidth / 2 + 'px');
					}
					
					if (this.options.orientation === 'vertical') {
						this._css(this.tooltip, 'margin-top', -this.tooltip.offsetHeight / 2 + 'px');
					} else {
						this._css(this.tooltip, 'margin-left', -this.tooltip.offsetWidth / 2 + 'px');
					}
					
					var innerTooltipMinText = this.options.formatter(this.options.value[0]);
					this._setText(this.tooltipInner_min, innerTooltipMinText);

					var innerTooltipMaxText = this.options.formatter(this.options.value[1]);
					this._setText(this.tooltipInner_max, innerTooltipMaxText);

					this.tooltip_min.style[this.stylePos] = positionPercentages[0] + '%';

					if (this.options.orientation === 'vertical') {
						this._css(this.tooltip_min, 'margin-top', -this.tooltip_min.offsetHeight / 2 + 'px');
					} else {
						this._css(this.tooltip_min, 'margin-left', -this.tooltip_min.offsetWidth / 2 + 'px');
					}

					this.tooltip_max.style[this.stylePos] = positionPercentages[1] + '%';

					if (this.options.orientation === 'vertical') {
						this._css(this.tooltip_max, 'margin-top', -this.tooltip_max.offsetHeight / 2 + 'px');
					} else {
						this._css(this.tooltip_max, 'margin-left', -this.tooltip_max.offsetWidth / 2 + 'px');
					}
				} else {
					formattedTooltipVal = this.options.formatter(this.options.value[0]);
					this._setText(this.tooltipInner, formattedTooltipVal);

					this.tooltip.style[this.stylePos] = positionPercentages[0] + '%';
					if (this.options.orientation === 'vertical') {
						this._css(this.tooltip, 'margin-top', -this.tooltip.offsetHeight / 2 + 'px');
					} else {
						this._css(this.tooltip, 'margin-left', -this.tooltip.offsetWidth / 2 + 'px');
					}
				}
			},
			_removeProperty: function(element, prop) {
				if (element.style.removeProperty) {
				    element.style.removeProperty(prop);
				} else {
				    element.style.removeAttribute(prop);
				}
			},
			_mousedown: function(ev) {
				if(!this.options.enabled) {
					return false;
				}

				this._triggerFocusOnHandle();

				this.offset = this._offset(this.sliderElem);
				this.size = this.sliderElem[this.sizePos];

				var percentage = this._getPercentage(ev);

				if (this.options.range) {
					var diff1 = Math.abs(this.percentage[0] - percentage);
					var diff2 = Math.abs(this.percentage[1] - percentage);
					this.dragged = (diff1 < diff2) ? 0 : 1;
				} else {
					this.dragged = 0;
				}

				this.percentage[this.dragged] = this.options.reversed ? 100 - percentage : percentage;
				this._layout();

				this.mousemove = this._mousemove.bind(this);
				this.mouseup = this._mouseup.bind(this);

				if (this.touchCapable) {
					// Touch: Bind touch events:
					document.addEventListener("touchmove", this.mousemove, false);
					document.addEventListener("touchend", this.mouseup, false);
				}
                                // Bind mouse events:
                                document.addEventListener("mousemove", this.mousemove, false);
                                document.addEventListener("mouseup", this.mouseup, false);

				this.inDrag = true;

				var val = this._calculateValue();
				this._trigger('slideStart', val);
				this._setDataVal(val);
				this.setValue(val);

				this._pauseEvent(ev);

				return true;
			},
			_triggerFocusOnHandle: function(handleIdx) {
				if(handleIdx === 0) {
					this.handle1.focus();
				}
				if(handleIdx === 1) {
					this.handle2.focus();
				}
			},
			_keydown: function(handleIdx, ev) {
				if(!this.options.enabled) {
					return false;
				}

				var dir;
				switch (ev.keyCode) {
					case 37: // left
					case 40: // down
						dir = -1;
						break;
					case 39: // right
					case 38: // up
						dir = 1;
						break;
				}
				if (!dir) {
					return;
				}

				// use natural arrow keys instead of from min to max
				if (this.options.natural_arrow_keys) {
					var ifVerticalAndNotReversed = (this.options.orientation === 'vertical' && !this.options.reversed);
					var ifHorizontalAndReversed = (this.options.orientation === 'horizontal' && this.options.reversed);

					if (ifVerticalAndNotReversed || ifHorizontalAndReversed) {
						dir = dir * -1;
					}
				}

				var oneStepValuePercentageChange = dir * this.percentage[2];
				var percentage = this.percentage[handleIdx] + oneStepValuePercentageChange;

				if (percentage > 100) {
					percentage = 100;
				} else if (percentage < 0) {
					percentage = 0;
				}

				this.dragged = handleIdx;
				this._adjustPercentageForRangeSliders(percentage);
				this.percentage[this.dragged] = percentage;
				this._layout();

				var val = this._calculateValue();
				
				this._trigger('slideStart', val);
				this._setDataVal(val);
				this.setValue(val, true);

				this._trigger('slideStop', val);
				this._setDataVal(val);
				
				this._pauseEvent(ev);

				return false;
			},
			_pauseEvent: function(ev) {
				if(ev.stopPropagation) {
					ev.stopPropagation();
				}
			    if(ev.preventDefault) {
			    	ev.preventDefault();
			    }
			    ev.cancelBubble=true;
			    ev.returnValue=false;			
			},
			_mousemove: function(ev) {
				if(!this.options.enabled) {
					return false;
				}

				var percentage = this._getPercentage(ev);
				this._adjustPercentageForRangeSliders(percentage);
				this.percentage[this.dragged] = this.options.reversed ? 100 - percentage : percentage;
				this._layout();

				var val = this._calculateValue();
				this.setValue(val, true);

				return false;
			},
			_adjustPercentageForRangeSliders: function(percentage) {
				if (this.options.range) {
					if (this.dragged === 0 && this.percentage[1] < percentage) {
						this.percentage[0] = this.percentage[1];
						this.dragged = 1;
					} else if (this.dragged === 1 && this.percentage[0] > percentage) {
						this.percentage[1] = this.percentage[0];
						this.dragged = 0;
					}
				}
			},
			_mouseup: function() {
				if(!this.options.enabled) {
					return false;
				}
				if (this.touchCapable) {
					// Touch: Unbind touch event handlers:
					document.removeEventListener("touchmove", this.mousemove, false);
					document.removeEventListener("touchend", this.mouseup, false);
				}
                                // Unbind mouse event handlers:
                                document.removeEventListener("mousemove", this.mousemove, false);
                                document.removeEventListener("mouseup", this.mouseup, false);
				
				this.inDrag = false;
				if (this.over === false) {
					this._hideTooltip();
				}
				var val = this._calculateValue();
				
				this._layout();
				this._setDataVal(val);
				this._trigger('slideStop', val);
				
				return false;
			},
			_calculateValue: function() {
				var val;
				if (this.options.range) {
					val = [this.options.min,this.options.max];
			        if (this.percentage[0] !== 0){
			            val[0] = (Math.max(this.options.min, this.options.min + Math.round((this.diff * this.percentage[0]/100)/this.options.step)*this.options.step));
			            val[0] = this._applyPrecision(val[0]);
			        }
			        if (this.percentage[1] !== 100){
			            val[1] = (Math.min(this.options.max, this.options.min + Math.round((this.diff * this.percentage[1]/100)/this.options.step)*this.options.step));
			            val[1] = this._applyPrecision(val[1]);
			        }
					this.options.value = val;
				} else {
					val = (this.options.min + Math.round((this.diff * this.percentage[0]/100)/this.options.step)*this.options.step);
					if (val < this.options.min) {
						val = this.options.min;
					}
					else if (val > this.options.max) {
						val = this.options.max;
					}
					val = parseFloat(val);
					val = this._applyPrecision(val);
					this.options.value = [val, this.options.value[1]];
				}
				return val;
			},
			_applyPrecision: function(val) {
				var precision = this.options.precision || this._getNumDigitsAfterDecimalPlace(this.step);
				return this._applyToFixedAndParseFloat(val, precision);
			},
			_getNumDigitsAfterDecimalPlace: function(num) {
				var match = (''+num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
				if (!match) { return 0; }
				return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
			},
			_applyToFixedAndParseFloat: function(num, toFixedInput) {
				var truncatedNum = num.toFixed(toFixedInput);
				return parseFloat(truncatedNum);
			},
			/*
				Credits to Mike Samuel for the following method!
				Source: http://stackoverflow.com/questions/10454518/javascript-how-to-retrieve-the-number-of-decimals-of-a-string-number
			*/
			_getPercentage: function(ev) {
				if (this.touchCapable && (ev.type === 'touchstart' || ev.type === 'touchmove')) {
					ev = ev.touches[0];
				}
				var percentage = (ev[this.mousePos] - this.offset[this.stylePos])*100/this.size;
				percentage = Math.round(percentage/this.percentage[2])*this.percentage[2];
				return Math.max(0, Math.min(100, percentage));
			},
			_validateInputValue: function(val) {
				if(typeof val === 'number') {
					return val;
				} else if(val instanceof Array) {
					this._validateArray(val);
					return val;
				} else {
					throw new Error( ErrorMsgs.formatInvalidInputErrorMsg(val) );
				}
			},
			_validateArray: function(val) {
				for(var i = 0; i < val.length; i++) {
					var input =  val[i];
					if (typeof input !== 'number') { throw new Error( ErrorMsgs.formatInvalidInputErrorMsg(input) ); }
				}
			},
			_setDataVal: function(val) {
				var value = "value: '" + val + "'";
				this.element.setAttribute('data', value);
				this.element.setAttribute('value', val);
			},
			_trigger: function(evt, val) {
				val = val || undefined;

				var callbackFnArray = this.eventToCallbackMap[evt];
				if(callbackFnArray && callbackFnArray.length) {
					for(var i = 0; i < callbackFnArray.length; i++) {
						var callbackFn = callbackFnArray[i];
						callbackFn(val);
					}
				}

				/* If JQuery exists, trigger JQuery events */
				if($) {
					this._triggerJQueryEvent(evt, val);
				}
			},
			_triggerJQueryEvent: function(evt, val) {
				var eventData = {
					type: evt,
					value: val
				};
				this.$element.trigger(eventData);
				this.$sliderElem.trigger(eventData);
			},
			_unbindJQueryEventHandlers: function() {
				this.$element.off();
				this.$sliderElem.off();
			},
			_setText: function(element, text) {
				if(typeof element.innerText !== "undefined") {
			 		element.innerText = text;
			 	} else if(typeof element.textContent !== "undefined") {
			 		element.textContent = text;
			 	}
			},
			_removeClass: function(element, classString) {
				var classes = classString.split(" ");
				var newClasses = element.className;

				for(var i = 0; i < classes.length; i++) {
					var classTag = classes[i];
					var regex = new RegExp("(?:\\s|^)" + classTag + "(?:\\s|$)");
					newClasses = newClasses.replace(regex, " ");
				}

				element.className = newClasses.trim();
			},
			_addClass: function(element, classString) {
				var classes = classString.split(" ");
				var newClasses = element.className;

				for(var i = 0; i < classes.length; i++) {
					var classTag = classes[i];
					var regex = new RegExp("(?:\\s|^)" + classTag + "(?:\\s|$)");
					var ifClassExists = regex.test(newClasses);
					
					if(!ifClassExists) {
						newClasses += " " + classTag;
					}
				}

				element.className = newClasses.trim();
			},
			_offset: function (obj) {
				var ol = 0;
				var ot = 0;
				if (obj.offsetParent) {
					do {
					  ol += obj.offsetLeft;
					  ot += obj.offsetTop;
					} while (obj = obj.offsetParent);
				}
				return {
					left: ol,
					top: ot
				};
			},
			_css: function(elementRef, styleName, value) {
				elementRef.style[styleName] = value;
			}
		};

		/*********************************

			Attach to global namespace

		*********************************/
		if($) {
			var namespace = $.fn.slider ? 'bootstrapSlider' : 'slider';
			$.bridget(namespace, Slider);
		} else {
			window.Slider = Slider;
		}


	})( $ );

})( window.jQuery );

/* -------- studio/v2/js/redactor/redactor/redactor.js -------- */
/*
    Redactor
    Version 3.3.2
    Updated: November 7, 2019

    http://imperavi.com/redactor/

    Copyright (c) 2009-2019, Imperavi Ltd.
    License: http://imperavi.com/redactor/license/
*/
(function() {
var Ajax = {};

Ajax.settings = {};
Ajax.post = function(options) { return new AjaxRequest('post', options); };
Ajax.get = function(options) { return new AjaxRequest('get', options); };

var AjaxRequest = function(method, options)
{
    var defaults = {
        method: method,
        url: '',
        before: function() {},
        success: function() {},
        error: function() {},
        data: false,
        async: true,
        headers: {}
    };

    this.p = this.extend(defaults, options);
    this.p = this.extend(this.p, Ajax.settings);
    this.p.method = this.p.method.toUpperCase();

    this.prepareData();

    this.xhr = new XMLHttpRequest();
    this.xhr.open(this.p.method, this.p.url, this.p.async);

    this.setHeaders();

    var before = (typeof this.p.before === 'function') ? this.p.before(this.xhr) : true;
    if (before !== false)
    {
        this.send();
    }
};

AjaxRequest.prototype = {
    extend: function(obj1, obj2)
    {
        if (obj2) for (var name in obj2) { obj1[name] = obj2[name]; }
        return obj1;
    },
    prepareData: function()
    {
        if (this.p.method === 'POST' && !this.isFormData()) this.p.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        if (typeof this.p.data === 'object' && !this.isFormData()) this.p.data = this.toParams(this.p.data);
        if (this.p.method === 'GET') this.p.url = (this.p.data) ? this.p.url + '?' + this.p.data : this.p.url;
    },
    setHeaders: function()
    {
        this.xhr.setRequestHeader('X-Requested-With', this.p.headers['X-Requested-With'] || 'XMLHttpRequest');
        for (var name in this.p.headers)
        {
            this.xhr.setRequestHeader(name, this.p.headers[name]);
        }
    },
    isFormData: function()
    {
        return (typeof window.FormData !== 'undefined' && this.p.data instanceof window.FormData);
    },
    isComplete: function()
    {
        return !(this.xhr.status < 200 || this.xhr.status >= 300 && this.xhr.status !== 304);
    },
    send: function()
    {
        if (this.p.async)
        {
            this.xhr.onload = this.loaded.bind(this);
            this.xhr.send(this.p.data);
        }
        else
        {
            this.xhr.send(this.p.data);
            this.loaded.call(this);
        }
    },
    loaded: function()
    {
        if (this.isComplete())
        {
            var response = this.xhr.response;
            var json = this.parseJson(response);
            response = (json) ? json : response;

            if (typeof this.p.success === 'function') this.p.success(response, this.xhr);
        }
        else
        {
            if (typeof this.p.error === 'function') this.p.error(this.xhr.statusText);
        }
    },
    parseJson: function(str)
    {
        try {
            var o = JSON.parse(str);
            if (o && typeof o === 'object')
            {
                return o;
            }

        } catch (e) {}

        return false;
    },
    toParams: function (obj)
    {
        return Object.keys(obj).map(
            function(k){ return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]); }
        ).join('&');
    }
};
var DomCache = [0];
var DomExpando = 'data' + new Date().getTime();
var DomHClass = 'is-hidden';
var DomHMClass = 'is-hidden-mobile';

var Dom = function(selector, context)
{
    return this.parse(selector, context);
};

Dom.ready = function(fn)
{
    if (document.readyState != 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
};

Dom.prototype = {
    get sdom()
    {
        return true;
    },
    get length()
    {
        return this.nodes.length;
    },
    parse: function(selector, context)
    {
        var nodes;
        var reHtmlTest = /^\s*<(\w+|!)[^>]*>/;

        if (!selector)
        {
            nodes = [];
        }
        else if (selector.sdom)
        {
            this.nodes = selector.nodes;
            return selector;
        }
        else if (typeof selector !== 'string')
        {
            if (selector.nodeType && selector.nodeType === 11)
            {
                nodes = selector.childNodes;
            }
            else
            {
                nodes = (selector.nodeType || selector === window) ? [selector] : selector;
            }
        }
        else if (reHtmlTest.test(selector))
        {
            nodes = this.create(selector);
        }
        else
        {
            nodes = this._query(selector, context);
        }

        this.nodes = this._slice(nodes);
    },
    create: function(html)
    {
        if (/^<(\w+)\s*\/?>(?:<\/\1>|)$/.test(html))
        {
            return [document.createElement(RegExp.$1)];
        }

        var elements = [];
        var container = document.createElement('div');
        var children = container.childNodes;

        container.innerHTML = html;

        for (var i = 0, l = children.length; i < l; i++)
        {
            elements.push(children[i]);
        }

        return elements;
    },

    // add
    add: function(nodes)
    {
        this.nodes = this.nodes.concat(this._toArray(nodes));
    },

    // get
    get: function(index)
    {
        return this.nodes[(index || 0)] || false;
    },
    getAll: function()
    {
        return this.nodes;
    },
    eq: function(index)
    {
        return new Dom(this.nodes[index]);
    },
    first: function()
    {
        return new Dom(this.nodes[0]);
    },
    last: function()
    {
        return new Dom(this.nodes[this.nodes.length - 1]);
    },
    contents: function()
    {
        return this.get().childNodes;
    },

    // loop
    each: function(callback)
    {
        var len = this.nodes.length;
        for (var i = 0; i < len; i++)
        {
            callback.call(this, (this.nodes[i].sdom) ? this.nodes[i].get() : this.nodes[i], i);
        }

        return this;
    },

    // traversing
    is: function(selector)
    {
        return (this.filter(selector).length > 0);
    },
    filter: function (selector)
    {
        var callback;
        if (selector === undefined)
        {
            return this;
        }
        else if (typeof selector === 'function')
        {
            callback = selector;
        }
        else
        {
            callback = function(node)
            {
                if (selector instanceof Node)
                {
                    return (selector === node);
                }
                else if (selector && selector.sdom)
                {
                    return ((selector.nodes).indexOf(node) !== -1);
                }
                else
                {
                    node.matches = node.matches || node.msMatchesSelector || node.webkitMatchesSelector;
                    return (node.nodeType === 1) ? node.matches(selector || '*') : false;
                }
            };
        }

        return new Dom(this.nodes.filter(callback));
    },
    not: function(filter)
    {
        return this.filter(function(node)
        {
            return !new Dom(node).is(filter || true);
        });
    },
    find: function(selector)
    {
        var nodes = [];
        this.each(function(node)
        {
            var ns = this._query(selector || '*', node);
            for (var i = 0; i < ns.length; i++)
            {
                nodes.push(ns[i]);
            }
        });

        return new Dom(nodes);
    },
    children: function(selector)
    {
        var nodes = [];
        this.each(function(node)
        {
            if (node.children)
            {
                var ns = node.children;
                for (var i = 0; i < ns.length; i++)
                {
                    nodes.push(ns[i]);
                }
            }
        });

        return new Dom(nodes).filter(selector);
    },
    parent: function(selector)
    {
        var nodes = [];
        this.each(function(node)
        {
            if (node.parentNode) nodes.push(node.parentNode);
        });

        return new Dom(nodes).filter(selector);
    },
    parents: function(selector, context)
    {
        context = this._getContext(context);

        var nodes = [];
        this.each(function(node)
        {
            var parent = node.parentNode;
            while (parent && parent !== context)
            {
                if (selector)
                {
                    if (new Dom(parent).is(selector)) { nodes.push(parent); }
                }
                else
                {
                    nodes.push(parent);
                }

                parent = parent.parentNode;
            }
        });

        return new Dom(nodes);
    },
    closest: function(selector, context)
    {
        context = this._getContext(context);
        selector = (selector.sdom) ? selector.get() : selector;

        var nodes = [];
        var isNode = (selector && selector.nodeType);
        this.each(function(node)
        {
            do {
                if ((isNode && node === selector) || new Dom(node).is(selector)) return nodes.push(node);
            } while ((node = node.parentNode) && node !== context);
        });

        return new Dom(nodes);
    },
    next: function(selector)
    {
         return this._getSibling(selector, 'nextSibling');
    },
    nextElement: function(selector)
    {
        return this._getSibling(selector, 'nextElementSibling');
    },
    prev: function(selector)
    {
        return this._getSibling(selector, 'previousSibling');
    },
    prevElement: function(selector)
    {
        return this._getSibling(selector, 'previousElementSibling');
    },

    // css
    css: function(name, value)
    {
        if (value === undefined && (typeof name !== 'object'))
        {
            var node = this.get();
            if (name === 'width' || name === 'height')
            {
                return (node.style) ? this._getHeightOrWidth(name, node, false) + 'px' : undefined;
            }
            else
            {
                return (node.style) ? getComputedStyle(node, null)[name] : undefined;
            }
        }

        // set
        return this.each(function(node)
        {
            var obj = {};
            if (typeof name === 'object') obj = name;
            else obj[name] = value;

            for (var key in obj)
            {
                if (node.style) node.style[key] = obj[key];
            }
        });
    },

    // attr
    attr: function(name, value, data)
    {
        data = (data) ? 'data-' : '';

        if (value === undefined && (typeof name !== 'object'))
        {
            var node = this.get();
            if (node && node.nodeType !== 3)
            {
                return (name === 'checked') ? node.checked : this._getBooleanFromStr(node.getAttribute(data + name));
            }
            else return;
        }

        // set
        return this.each(function(node)
        {
            var obj = {};
            if (typeof name === 'object') obj = name;
            else obj[name] = value;

            for (var key in obj)
            {
                if (node.nodeType !== 3)
                {
                    if (key === 'checked') node.checked = obj[key];
                    else node.setAttribute(data + key, obj[key]);
                }
            }
        });
    },
    data: function(name, value)
    {
        if (name === undefined)
        {
            var reDataAttr = /^data\-(.+)$/;
            var attrs = this.get().attributes;

            var data = {};
            var replacer = function (g) { return g[1].toUpperCase(); };

            for (var key in attrs)
            {
                if (attrs[key] && reDataAttr.test(attrs[key].nodeName))
                {
                    var dataName = attrs[key].nodeName.match(reDataAttr)[1];
                    var val = attrs[key].value;
                    dataName = dataName.replace(/-([a-z])/g, replacer);

                    if (this._isObjectString(val)) val = this._toObject(val);
                    else val = (this._isNumber(val)) ? parseFloat(val) : this._getBooleanFromStr(val);

                    data[dataName] = val;
                }
            }

            return data;
        }

        return this.attr(name, value, true);
    },
    val: function(value)
    {
        if (value === undefined)
        {
            var el = this.get();
            if (el.type && el.type === 'checkbox') return el.checked;
            else return el.value;
        }

        return this.each(function(node)
        {
            node.value = value;
        });
    },
    removeAttr: function(value)
    {
        return this.each(function(node)
        {
            var rmAttr = function(name) { if (node.nodeType !== 3) node.removeAttribute(name); };
            value.split(' ').forEach(rmAttr);
        });
    },
    removeData: function(value)
    {
        return this.each(function(node)
        {
            var rmData = function(name) { if (node.nodeType !== 3) node.removeAttribute('data-' + name); };
            value.split(' ').forEach(rmData);
        });
    },

    // dataset/dataget
    dataset: function(key, value)
    {
        return this.each(function(node)
        {
            DomCache[this.dataindex(node)][key] = value;
        });
    },
    dataget: function(key)
    {
        return DomCache[this.dataindex(this.get())][key];
    },
    dataindex: function(el)
    {
        var cacheIndex = el[DomExpando];
        var nextCacheIndex = DomCache.length;

        if (!cacheIndex)
        {
            cacheIndex = el[DomExpando] = nextCacheIndex;
            DomCache[cacheIndex] = {};
        }

        return cacheIndex;
    },


    // class
    addClass: function(value)
    {
        return this._eachClass(value, 'add');
    },
    removeClass: function(value)
    {
        return this._eachClass(value, 'remove');
    },
    toggleClass: function(value)
    {
        return this._eachClass(value, 'toggle');
    },
    hasClass: function(value)
    {
        return this.nodes.some(function(node)
        {
            return (node.classList) ? node.classList.contains(value) : false;
        });
    },

    // html & text
    empty: function()
    {
        return this.each(function(node)
        {
            node.innerHTML = '';
        });
    },
    html: function(html)
    {
        return (html === undefined) ? (this.get().innerHTML || '') : this.empty().append(html);
    },
    text: function(text)
    {
        return (text === undefined) ? (this.get().textContent || '') : this.each(function(node) { node.textContent = text; });
    },

    // manipulation
    after: function(html)
    {
        return this._inject(html, function(frag, node)
        {
            if (typeof frag === 'string')
            {
                node.insertAdjacentHTML('afterend', frag);
            }
            else
            {
                var elms = (frag instanceof Node) ? [frag] : this._toArray(frag).reverse();
                for (var i = 0; i < elms.length; i++)
                {
                    node.parentNode.insertBefore(elms[i], node.nextSibling);
                }
            }

            return node;

        });
    },
    before: function(html)
    {
        return this._inject(html, function(frag, node)
        {
            if (typeof frag === 'string')
            {
                node.insertAdjacentHTML('beforebegin', frag);
            }
            else
            {
                var elms = (frag instanceof Node) ? [frag] : this._toArray(frag);
                for (var i = 0; i < elms.length; i++)
                {
                    node.parentNode.insertBefore(elms[i], node);
                }
            }

            return node;
        });
    },
    append: function(html)
    {
        return this._inject(html, function(frag, node)
        {
            if (typeof frag === 'string' || typeof frag === 'number')
            {
                node.insertAdjacentHTML('beforeend', frag);
            }
            else
            {
                var elms = (frag instanceof Node) ? [frag] : this._toArray(frag);
                for (var i = 0; i < elms.length; i++)
                {
                    node.appendChild(elms[i]);
                }
            }

            return node;
        });
    },
    prepend: function(html)
    {
        return this._inject(html, function(frag, node)
        {
            if (typeof frag === 'string' || typeof frag === 'number')
            {
                node.insertAdjacentHTML('afterbegin', frag);
            }
            else
            {
                var elms = (frag instanceof Node) ? [frag] : this._toArray(frag).reverse();
                for (var i = 0; i < elms.length; i++)
                {
                    node.insertBefore(elms[i], node.firstChild);
                }
            }

            return node;
        });
    },
    wrap: function(html)
    {
        return this._inject(html, function(frag, node)
        {
            var wrapper = (typeof frag === 'string' || typeof frag === 'number') ? this.create(frag)[0] : (frag instanceof Node) ? frag : this._toArray(frag)[0];

            if (node.parentNode)
            {
                node.parentNode.insertBefore(wrapper, node);
            }

            wrapper.appendChild(node);

            return new Dom(wrapper);

        });
    },
    unwrap: function()
    {
        return this.each(function(node)
        {
            var $node = new Dom(node);

            return $node.replaceWith($node.contents());
        });
    },
    replaceWith: function(html)
    {
        return this._inject(html, function(frag, node)
        {
            var docFrag = document.createDocumentFragment();
            var elms = (typeof frag === 'string' || typeof frag === 'number') ? this.create(frag) : (frag instanceof Node) ? [frag] : this._toArray(frag);

            for (var i = 0; i < elms.length; i++)
            {
                docFrag.appendChild(elms[i]);
            }

            var result = docFrag.childNodes[0];
            node.parentNode.replaceChild(docFrag, node);

            return result;

        });
    },
    remove: function()
    {
        return this.each(function(node)
        {
            if (node.parentNode) node.parentNode.removeChild(node);
        });
    },
    clone: function(events)
    {
        var nodes = [];
        this.each(function(node)
        {
            var copy = this._clone(node);
            if (events) copy = this._cloneEvents(node, copy);
            nodes.push(copy);
        });

        return new Dom(nodes);
    },

    // show/hide
    show: function()
    {
        return this.each(function(node)
        {
            if (!node.style || !this._hasDisplayNone(node)) return;

            var target = node.getAttribute('domTargetShow');
            var isHidden = (node.classList) ? node.classList.contains(DomHClass) : false;
            var isHiddenMobile = (node.classList) ? node.classList.contains(DomHMClass) : false;
            var type;

            if (isHidden)
            {
                type = DomHClass;
                node.classList.remove(DomHClass);
            }
            else if (isHiddenMobile)
            {
                type = DomHMClass;
                node.classList.remove(DomHMClass);
            }
            else
            {
                node.style.display = (target) ? target : 'block';
            }

            if (type) node.setAttribute('domTargetHide', type);
            node.removeAttribute('domTargetShow');

        }.bind(this));
    },
    hide: function()
    {
        return this.each(function(node)
        {
            if (!node.style || this._hasDisplayNone(node)) return;

            var display = node.style.display;
            var target = node.getAttribute('domTargetHide');

            if (target === DomHClass)
            {
                node.classList.add(DomHClass);
            }
            else if (target === DomHMClass)
            {
                node.classList.add(DomHMClass);
            }
            else
            {
                if (display !== 'block') node.setAttribute('domTargetShow', display);
                node.style.display = 'none';
            }

            node.removeAttribute('domTargetHide');

        });
    },

    // dimensions
    scrollTop: function(value)
    {
        var node = this.get();
        var isWindow = (node === window);
        var isDocument = (node.nodeType === 9);
        var el = (isDocument) ? (document.scrollingElement || document.body.parentNode || document.body || document.documentElement) : node;

        if (value !== undefined)
        {
            if (isWindow) window.scrollTo(0, value);
            else el.scrollTop = value;
            return;
        }

        if (isDocument)
        {
            return (typeof window.pageYOffset != 'undefined') ? window.pageYOffset : ((document.documentElement.scrollTop) ? document.documentElement.scrollTop : ((document.body.scrollTop) ? document.body.scrollTop : 0));
        }
        else
        {
            return (isWindow) ? window.pageYOffset : el.scrollTop;
        }
    },
    offset: function()
    {
        return this._getDim('Offset');
    },
    position: function()
    {
        return this._getDim('Position');
    },
    width: function(value, adjust)
    {
        return this._getSize('width', 'Width', value, adjust);
    },
    height: function(value, adjust)
    {
        return this._getSize('height', 'Height', value, adjust);
    },
    outerWidth: function()
    {
        return this._getInnerOrOuter('width', 'outer');
    },
    outerHeight: function()
    {
        return this._getInnerOrOuter('height', 'outer');
    },
    innerWidth: function()
    {
        return this._getInnerOrOuter('width', 'inner');
    },
    innerHeight: function()
    {
        return this._getInnerOrOuter('height', 'inner');
    },

    // events
    click: function()
    {
        return this._triggerEvent('click');
    },
    focus: function()
    {
        return this._triggerEvent('focus');
    },
    trigger: function(names)
    {
        return this.each(function(node)
        {
            var events = names.split(' ');
            for (var i = 0; i < events.length; i++)
            {
                var ev;
                var opts = { bubbles: true, cancelable: true };

                try {
                    ev = new window.CustomEvent(events[i], opts);
                } catch(e) {
                    ev = document.createEvent('CustomEvent');
                    ev.initCustomEvent(events[i], true, true);
                }

                node.dispatchEvent(ev);
            }
        });
    },
    on: function(names, handler, one)
    {
        return this.each(function(node)
        {
            var events = names.split(' ');
            for (var i = 0; i < events.length; i++)
            {
                var event = this._getEventName(events[i]);
                var namespace = this._getEventNamespace(events[i]);

                handler = (one) ? this._getOneHandler(handler, names) : handler;
                node.addEventListener(event, handler);

                node._e = node._e || {};
                node._e[namespace] = node._e[namespace] || {};
                node._e[namespace][event] = node._e[namespace][event] || [];
                node._e[namespace][event].push(handler);
            }

        });
    },
    one: function(events, handler)
    {
        return this.on(events, handler, true);
    },
    off: function(names, handler)
    {
        var testEvent = function(name, key, event) { return (name === event); };
        var testNamespace = function(name, key, event, namespace) { return (key === namespace); };
        var testEventNamespace = function(name, key, event, namespace) { return (name === event && key === namespace); };
        var testPositive = function() { return true; };

        if (names === undefined)
        {
            // ALL
            return this.each(function(node)
            {
                this._offEvent(node, false, false, handler, testPositive);
            });
        }

        return this.each(function(node)
        {
            var events = names.split(' ');

            for (var i = 0; i < events.length; i++)
            {
                var event = this._getEventName(events[i]);
                var namespace = this._getEventNamespace(events[i]);

                // 1) event without namespace
                if (namespace === '_events') this._offEvent(node, event, namespace, handler, testEvent);
                // 2) only namespace
                else if (!event && namespace !== '_events') this._offEvent(node, event, namespace, handler, testNamespace);
                // 3) event + namespace
                else this._offEvent(node, event, namespace, handler, testEventNamespace);
            }
        });
    },

    // form
    serialize: function(asObject)
    {
        var obj = {};
        var elms = this.get().elements;
        for (var i = 0; i < elms.length; i++)
        {
            var el = elms[i];
            if (/(checkbox|radio)/.test(el.type) && !el.checked) continue;
            if (!el.name || el.disabled || el.type === 'file') continue;

            if (el.type === 'select-multiple')
            {
                for (var z = 0; z < el.options.length; z++)
                {
                    var opt = el.options[z];
                    if (opt.selected) obj[el.name] = opt.value;
                }
            }

            obj[el.name] = (this._isNumber(el.value)) ? parseFloat(el.value) : this._getBooleanFromStr(el.value);
        }

        return (asObject) ? obj : this._toParams(obj);
    },
    ajax: function(success, error)
    {
        if (typeof AjaxRequest !== 'undefined')
        {
            var method = this.attr('method') || 'post';
            var options = {
                url: this.attr('action'),
                data: this.serialize(),
                success: success,
                error: error
            };

            return new AjaxRequest(method, options);
        }
    },

    // private
    _queryContext: function(selector, context)
    {
        context = this._getContext(context);

        return (context.nodeType !== 3 && typeof context.querySelectorAll === 'function') ? context.querySelectorAll(selector) : [];
    },
    _query: function(selector, context)
    {
        if (context)
        {
            return this._queryContext(selector, context);
        }
        else if (/^[.#]?[\w-]*$/.test(selector))
        {
            if (selector[0] === '#')
            {
                var element = document.getElementById(selector.slice(1));
                return element ? [element] : [];
            }

            if (selector[0] === '.')
            {
                return document.getElementsByClassName(selector.slice(1));
            }

            return document.getElementsByTagName(selector);
        }

        return document.querySelectorAll(selector);
    },
    _getContext: function(context)
    {
        context = (typeof context === 'string') ? document.querySelector(context) : context;

        return (context && context.sdom) ? context.get() : (context || document);
    },
    _inject: function(html, fn)
    {
        var len = this.nodes.length;
        var nodes = [];
        while (len--)
        {
            var res = (typeof html === 'function') ? html.call(this, this.nodes[len]) : html;
            var el = (len === 0) ? res : this._clone(res);
            var node = fn.call(this, el, this.nodes[len]);

            if (node)
            {
                if (node.sdom) nodes.push(node.get());
                else nodes.push(node);
            }
        }

        return new Dom(nodes);
    },
    _cloneEvents: function(node, copy)
    {
        var events = node._e;
        if (events)
        {
            copy._e = events;
            for (var name in events._events)
            {
                for (var i = 0; i < events._events[name].length; i++)
                {
                    copy.addEventListener(name, events._events[name][i]);
                }
            }
        }

        return copy;
    },
    _clone: function(node)
    {
        if (typeof node === 'undefined') return;
        if (typeof node === 'string') return node;
        else if (node instanceof Node || node.nodeType) return node.cloneNode(true);
        else if ('length' in node)
        {
            return [].map.call(this._toArray(node), function(el) { return el.cloneNode(true); });
        }
    },
    _slice: function(obj)
    {
        return (!obj || obj.length === 0) ? [] : (obj.length) ? [].slice.call(obj.nodes || obj) : [obj];
    },
    _eachClass: function(value, type)
    {
        return this.each(function(node)
        {
            if (value)
            {
                var setClass = function(name) { if (node.classList) node.classList[type](name); };
                value.split(' ').forEach(setClass);
            }
        });
    },
    _triggerEvent: function(name)
    {
        var node = this.get();
        if (node && node.nodeType !== 3) node[name]();
        return this;
    },
    _getOneHandler: function(handler, events)
    {
        var self = this;
        return function()
        {
            handler.apply(this, arguments);
            self.off(events);
        };
    },
    _getEventNamespace: function(event)
    {
        var arr = event.split('.');
        var namespace = (arr[1]) ? arr[1] : '_events';
        return (arr[2]) ? namespace + arr[2] : namespace;
    },
    _getEventName: function(event)
    {
        return event.split('.')[0];
    },
    _offEvent: function(node, event, namespace, handler, condition)
    {
        for (var key in node._e)
        {
            for (var name in node._e[key])
            {
                if (condition(name, key, event, namespace))
                {
                    var handlers = node._e[key][name];
                    for (var i = 0; i < handlers.length; i++)
                    {
                        if (typeof handler !== 'undefined' && handlers[i].toString() !== handler.toString())
                        {
                            continue;
                        }

                        node.removeEventListener(name, handlers[i]);
                        node._e[key][name].splice(i, 1);

                        if (node._e[key][name].length === 0) delete node._e[key][name];
                        if (Object.keys(node._e[key]).length === 0) delete node._e[key];
                    }
                }
            }
        }
    },
    _getInnerOrOuter: function(method, type)
    {
        return this[method](undefined, type);
    },
    _getDocSize: function(node, type)
    {
        var body = node.body, html = node.documentElement;
        return Math.max(body['scroll' + type], body['offset' + type], html['client' + type], html['scroll' + type], html['offset' + type]);
    },
    _getSize: function(type, captype, value, adjust)
    {
        if (value === undefined)
        {
            var el = this.get();
            if (el.nodeType === 3)      value = 0;
            else if (el.nodeType === 9) value = this._getDocSize(el, captype);
            else if (el === window)     value = window['inner' + captype];
            else                        value = this._getHeightOrWidth(type, el, adjust || 'normal');

            return Math.round(value);
        }

        return this.each(function(node)
        {
            value = parseFloat(value);
            value = value + this._adjustResultHeightOrWidth(type, node, adjust || 'normal');

            new Dom(node).css(type, value + 'px');

        }.bind(this));
    },
    _getHeightOrWidth: function(type, el, adjust)
    {
        if (!el) return 0;

        var name = type.charAt(0).toUpperCase() + type.slice(1);
        var result = 0;
        var style = getComputedStyle(el, null);
        var $el = new Dom(el);
        var $targets = $el.parents().filter(function(node)
        {
            return (node.nodeType === 1 && getComputedStyle(node, null).display === 'none') ? node : false;
        });

        if (style.display === 'none') $targets.add(el);
        if ($targets.length !== 0)
        {
            var fixStyle = 'visibility: hidden !important; display: block !important;';
            var tmp = [];

            $targets.each(function(node)
            {
                var $node = new Dom(node);
                var thisStyle = $node.attr('style');
                if (thisStyle !== null) tmp.push(thisStyle);
                $node.attr('style', (thisStyle !== null) ? thisStyle + ';' + fixStyle : fixStyle);
            });

            result = $el.get()['offset' + name] - this._adjustResultHeightOrWidth(type, el, adjust);

            $targets.each(function(node, i)
            {
                var $node = new Dom(node);
                if (tmp[i] === undefined) $node.removeAttr('style');
                else $node.attr('style', tmp[i]);
            });
        }
        else
        {
            result = el['offset' + name] - this._adjustResultHeightOrWidth(type, el, adjust);
        }

        return result;
    },
    _adjustResultHeightOrWidth: function(type, el, adjust)
    {
        if (!el || adjust === false) return 0;

        var fix = 0;
        var style = getComputedStyle(el, null);
        var isBorderBox = (style.boxSizing === "border-box");

        if (type === 'height')
        {
            if (adjust === 'inner' || (adjust === 'normal' && isBorderBox))
            {
                fix += (parseFloat(style.borderTopWidth) || 0) + (parseFloat(style.borderBottomWidth) || 0);
            }

            if (adjust === 'outer') fix -= (parseFloat(style.marginTop) || 0) + (parseFloat(style.marginBottom) || 0);
        }
        else
        {
            if (adjust === 'inner' || (adjust === 'normal' && isBorderBox))
            {
                fix += (parseFloat(style.borderLeftWidth) || 0) + (parseFloat(style.borderRightWidth) || 0);
            }

            if (adjust === 'outer') fix -= (parseFloat(style.marginLeft) || 0) + (parseFloat(style.marginRight) || 0);
        }

        return fix;
    },
    _getDim: function(type)
    {
        var node = this.get();
        return (node.nodeType === 3) ? { top: 0, left: 0 } : this['_get' + type](node);
    },
    _getPosition: function(node)
    {
        return { top: node.offsetTop, left: node.offsetLeft };
    },
    _getOffset: function(node)
    {
        var rect = node.getBoundingClientRect();
        var doc = node.ownerDocument;
        var docElem = doc.documentElement;
        var win = doc.defaultView;

        return {
            top: rect.top + win.pageYOffset - docElem.clientTop,
            left: rect.left + win.pageXOffset - docElem.clientLeft
        };
    },
    _getSibling: function(selector, method)
    {
        selector = (selector && selector.sdom) ? selector.get() : selector;

        var isNode = (selector && selector.nodeType);
        var sibling;

        this.each(function(node)
        {
            while (node = node[method])
            {
                if ((isNode && node === selector) || new Dom(node).is(selector))
                {
                    sibling = node;
                    return;
                }
            }
        });

        return new Dom(sibling);
    },
    _toArray: function(obj)
    {
        if (obj instanceof NodeList)
        {
            var arr = [];
            for (var i = 0; i < obj.length; i++)
            {
                arr[i] = obj[i];
            }

            return arr;
        }
        else if (obj === undefined) return [];
        else
        {
            return (obj.sdom) ? obj.nodes : obj;
        }
    },
    _toParams: function(obj)
    {
        var params = '';
        for (var key in obj)
        {
            params += '&' + this._encodeUri(key) + '=' + this._encodeUri(obj[key]);
        }

        return params.replace(/^&/, '');
    },
    _toObject: function(str)
    {
        return (new Function("return " + str))();
    },
    _encodeUri: function(str)
    {
        return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
    },
    _isNumber: function(str)
    {
        return !isNaN(str) && !isNaN(parseFloat(str));
    },
    _isObjectString: function(str)
    {
        return (str.search(/^{/) !== -1);
    },
    _getBooleanFromStr: function(str)
    {
        if (str === 'true') return true;
        else if (str === 'false') return false;

        return str;
    },
    _hasDisplayNone: function(el)
    {
        return (el.style.display === 'none') || ((el.currentStyle) ? el.currentStyle.display : getComputedStyle(el, null).display) === 'none';
    }
};
// Unique ID
var uuid = 0;

// Wrapper
var $R = function(selector, options)
{
    return RedactorApp(selector, options, [].slice.call(arguments, 2));
};

// Globals
$R.app = [];
$R.version = '3.3.2';
$R.options = {};
$R.modules = {};
$R.services = {};
$R.classes = {};
$R.plugins = {};
$R.mixins = {};
$R.modals = {};
$R.lang = {};
$R.dom = function(selector, context) { return new Dom(selector, context); };
$R.ajax = Ajax;
$R.Dom = Dom;
$R.keycodes = {
    BACKSPACE: 8,
    DELETE: 46,
    UP: 38,
    DOWN: 40,
    ENTER: 13,
    SPACE: 32,
    ESC: 27,
    TAB: 9,
    CTRL: 17,
    META: 91,
    SHIFT: 16,
    ALT: 18,
    RIGHT: 39,
    LEFT: 37
};
$R.env = {
    'plugin': 'plugins',
    'module': 'modules',
    'service': 'services',
    'class': 'classes',
    'mixin': 'mixins'
};

// jQuery Wrapper
/*eslint-env jquery*/
if (typeof jQuery !== 'undefined')
{
    (function($) { $.fn.redactor = function(options) { return RedactorApp(this.toArray(), options, [].slice.call(arguments, 1)); }; })(jQuery);
}

// Class
var RedactorApp = function(selector, options, args)
{
    var namespace = 'redactor';
    var nodes = (Array.isArray(selector)) ? selector : (selector && selector.nodeType) ? [selector] : document.querySelectorAll(selector);
    var isApi = (typeof options === 'string' || typeof options === 'function');
    var value = [];
    var instance;

    for (var i = 0; i < nodes.length; i++)
    {
        var el = nodes[i];
        var $el = $R.dom(el);

        instance = $el.dataget(namespace);
        if (!instance && !isApi)
        {
            // Initialization
            instance = new App(el, options, uuid);
            $el.dataset(namespace, instance);
            $R.app[uuid] = instance;
            uuid++;
        }

        // API
        if (instance && isApi)
        {
            var isDestroy = (options === 'destroy');
            options = (isDestroy) ? 'stop' : options;

            var methodValue;
            if (typeof options === 'function')
            {
                methodValue = options.apply(instance, args);
            }
            else
            {
                args.unshift(options);
                methodValue = instance.api.apply(instance, args);
            }
            if (methodValue !== undefined) value.push(methodValue);

            if (isDestroy) $el.dataset(namespace, false);
        }
    }

    return (value.length === 0 || value.length === 1) ? ((value.length === 0) ? instance : value[0]) : value;
};

// add
$R.add = function(type, name, obj)
{
    if (typeof $R.env[type] === 'undefined') return;

    // translations
    if (obj.translations)
    {
        $R.lang = $R.extend(true, {}, $R.lang, obj.translations);
    }

    // modals
    if (obj.modals)
    {
        $R.modals = $R.extend(true, {}, $R.modals, obj.modals);
    }

    // mixin
    if (type === 'mixin')
    {
        $R[$R.env[type]][name] = obj;
    }
    else
    {
        // prototype
        var F = function() {};
        F.prototype = obj;

        // mixins
        if (obj.mixins)
        {
            for (var i = 0; i < obj.mixins.length; i++)
            {
                $R.inherit(F, $R.mixins[obj.mixins[i]]);
            }
        }

        $R[$R.env[type]][name] = F;
    }
};

// add lang
$R.addLang = function(lang, obj)
{
    if (typeof $R.lang[lang] === 'undefined')
    {
        $R.lang[lang] = {};
    }

    $R.lang[lang] = $R.extend($R.lang[lang], obj);
};

// create
$R.create = function(name)
{
    var arr = name.split('.');
    var args = [].slice.call(arguments, 1);

    var type = 'classes';
    if (typeof $R.env[arr[0]] !== 'undefined')
    {
        type = $R.env[arr[0]];
        name = arr.slice(1).join('.');
    }

    // construct
    var instance = new $R[type][name]();

    // init
    if (instance.init)
    {
        var res = instance.init.apply(instance, args);

        return (res) ? res : instance;
    }

    return instance;
};

// inherit
$R.inherit = function(current, parent)
{
    var F = function () {};
    F.prototype = parent;
    var f = new F();

    for (var prop in current.prototype)
    {
        if (current.prototype.__lookupGetter__(prop)) f.__defineGetter__(prop, current.prototype.__lookupGetter__(prop));
        else f[prop] = current.prototype[prop];
    }

    current.prototype = f;
    current.prototype.super = parent;

    return current;
};

// error
$R.error = function(exception)
{
    throw exception;
};

// extend
$R.extend = function()
{
    var extended = {};
    var deep = false;
    var i = 0;
    var length = arguments.length;

    if (Object.prototype.toString.call( arguments[0] ) === '[object Boolean]')
    {
        deep = arguments[0];
        i++;
    }

    var merge = function(obj)
    {
        for (var prop in obj)
        {
            if (Object.prototype.hasOwnProperty.call(obj, prop))
            {
                if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') extended[prop] = $R.extend(true, extended[prop], obj[prop]);
                else extended[prop] = obj[prop];
            }
        }
    };

    for (; i < length; i++ )
    {
        var obj = arguments[i];
        merge(obj);
    }

    return extended;
};
$R.opts = {
    animation: true,
    lang: 'en',
    direction: 'ltr',
    spellcheck: true,
    structure: false,
    scrollTarget: false,
    styles: true,
    stylesClass: 'redactor-styles',
    placeholder: false,

    source: true,
    showSource: false,

    inline: false,

    breakline: false,
    markup: 'p',
    enterKey: true,

    clickToEdit: false,
    clickToSave: false,
    clickToCancel: false,

    focus: false,
    focusEnd: false,

    minHeight: false, // string, '100px'
    maxHeight: false, // string, '100px'
    maxWidth: false, // string, '700px'

    plugins: [], // array
    callbacks: {},

    // pre & tab
    preClass: false, // string
    preSpaces: 4, // or false
    tabindex: false, // int
    tabAsSpaces: false, // true or number of spaces
    tabKey: true,

    // autosave
    autosave: false, // false or url
    autosaveName: false,
    autosaveData: false,

    // toolbar
    toolbar: true,
    toolbarFixed: true,
    toolbarFixedTarget: document,
    toolbarFixedTopOffset: 0, // pixels
    toolbarExternal: false, // ID selector
    toolbarContext: true,

    // air
    air: false,

    // formatting
    formatting: ['p', 'blockquote', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
    formattingAdd: false,
    formattingHide: false,

    // buttons
    buttons: ['html', 'format', 'bold', 'italic', 'deleted', 'lists', 'file', 'link'],
    // + 'line', 'redo', 'undo', 'underline', 'ol', 'ul', 'indent', 'outdent'
    buttonsTextLabeled: false,
    buttonsAdd: [],
    buttonsAddFirst: [],
    buttonsAddAfter: false,
    buttonsAddBefore: false,
    buttonsHide: [],
    buttonsHideOnMobile: [],

    // image
    imageUpload: false,
    imageUploadParam: 'file',
    imageData: false,
    imageEditable: true,
    imageCaption: true,
    imageLink: true,
    imagePosition: false,
    imageResizable: false,
    imageFloatMargin: '10px',
    imageFigure: true,
    imageObserve: true,

    // file
    fileUpload: false,
    fileUploadParam: 'file',
    fileData: false,
    fileAttachment: false,

    // upload opts
    uploadData: false,
    dragUpload: true,
    multipleUpload: true,
    clipboardUpload: true,
    uploadBase64: false,

    // link
    linkTarget: false,
    linkTitle: false,
    linkNewTab: true,
    linkNofollow: false,
    linkSize: 30,
    linkValidation: true,

    // clean
    cleanOnEnter: true,
    cleanInlineOnEnter: false,
    paragraphize: true,
    removeScript: true,
    removeNewLines: false,
    removeComments: true,
    replaceTags: {
        'b': 'strong',
        'i': 'em',
        'strike': 'del'
    },

    // paste
    pastePlainText: false,
    pasteLinkTarget: false,
    pasteImages: false,
    pasteLinks: true,
    pasteClean: true,
    pasteKeepStyle: [],
    pasteKeepClass: [],
    pasteKeepAttrs: ['td', 'th'],
    pasteBlockTags: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'table', 'tbody', 'thead', 'tfoot', 'th', 'tr', 'td', 'ul', 'ol', 'li', 'blockquote', 'p', 'figure', 'figcaption'],
    pasteInlineTags: ['a', 'br', 'strong', 'ins', 'del', 'span', 'samp', 'kbd', 'sup', 'sub', 'mark', 'var', 'cite', 'small', 'b', 'u', 'em', 'i', 'abbr'],

    // active buttons
    activeButtons: {
        b: 'bold',
        strong: 'bold',
        i: 'italic',
        em: 'italic',
        del: 'deleted',
        strike: 'deleted',
        u: 'underline'
    },
    activeButtonsAdd: {},
    activeButtonsObservers: {},

    // autoparser
    autoparse: true,
    autoparseStart: true,
    autoparsePaste: true,
    autoparseLinks: true,
    autoparseImages: false,
    autoparseVideo: true,

    // shortcodes
    shortcodes: {
        'p.': { format: 'p' },
        'quote.': { format: 'blockquote' },
        'h1.': { format: 'h1' },
        'h2.': { format: 'h2' },
        'h3.': { format: 'h3' },
        'h4.': { format: 'h4' },
        'h5.': { format: 'h5' },
        'h6.': { format: 'h6' },
        //'1.': { format: 'ol' },
        '*.': { format: 'ul' }
    },
    shortcodesAdd: false, // object

    // shortcuts
    shortcuts: {
        'ctrl+shift+m, meta+shift+m': { api: 'module.inline.clearformat' },
        'ctrl+b, meta+b': { api: 'module.inline.format', args: 'b' },
        'ctrl+i, meta+i': { api: 'module.inline.format', args: 'i' },
        'ctrl+u, meta+u': { api: 'module.inline.format', args: 'u' },
        'ctrl+h, meta+h': { api: 'module.inline.format', args: 'sup' },
        'ctrl+l, meta+l': { api: 'module.inline.format', args: 'sub' },
        'ctrl+k, meta+k': { api: 'module.link.open' },
        'ctrl+alt+0, meta+alt+0': { api: 'module.block.format', args: 'p' },
        'ctrl+alt+1, meta+alt+1': { api: 'module.block.format', args: 'h1' },
        'ctrl+alt+2, meta+alt+2': { api: 'module.block.format', args: 'h2' },
        'ctrl+alt+3, meta+alt+3': { api: 'module.block.format', args: 'h3' },
        'ctrl+alt+4, meta+alt+4': { api: 'module.block.format', args: 'h4' },
        'ctrl+alt+5, meta+alt+5': { api: 'module.block.format', args: 'h5' },
        'ctrl+alt+6, meta+alt+6': { api: 'module.block.format', args: 'h6' },
        'ctrl+shift+7, meta+shift+7': { api: 'module.list.toggle', args: 'ol' },
        'ctrl+shift+8, meta+shift+8': { api: 'module.list.toggle', args: 'ul' }
    },
    shortcutsAdd: false, // object

    // misc
    grammarly: true,
    notranslate: false,

    // private
    bufferLimit: 100,
    emptyHtml: '<p></p>',
    markerChar: '\ufeff',
    imageTypes: ['image/png', 'image/jpeg', 'image/gif'],
    imageAttrs: ['alt', 'title', 'src', 'class', 'width', 'height', 'srcset'],
    inlineTags: ['a', 'span', 'strong', 'strike', 'b', 'u', 'em', 'i', 'del', 'ins', 'samp', 'kbd', 'sup', 'sub', 'mark', 'var', 'cite', 'small', 'abbr'],
    blockTags: ['ul', 'ol', 'li', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',  'dl', 'dt', 'dd', 'div', 'table', 'tbody', 'thead', 'tfoot', 'tr', 'th', 'td', 'blockquote', 'output', 'figcaption', 'figure', 'address', 'section', 'header', 'footer', 'aside', 'article', 'iframe'],
    regex: {
        youtube: /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube\.com\S*[^\w\-\s])([\w\-]{11})(?=[^\w\-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/gi,
        vimeo: /(http|https)?:\/\/(?:www.|player.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?/gi,
        imageurl: /((https?|www)[^\s]+\.)(jpe?g|png|gif)(\?[^\s-]+)?/gi,
        url: /(https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})/gi
    },
    input: true,
    zindex: false,
    modes: {
        "inline": {
            pastePlainText: true,
            pasteImages: false,
            enterKey: false,
            toolbar: false,
            autoparse: false,
            source: false,
            showSource: false,
            styles: false,
            air: false
        },
        "original": {
            styles: false
        }
    }
};
$R.lang['en'] = {
    "format": "Format",
    "image": "Image",
    "file": "File",
    "link": "Link",
    "bold": "Bold",
    "italic": "Italic",
    "deleted": "Strikethrough",
    "underline": "Underline",
    "superscript": "Superscript",
    "subscript": "Subscript",
    "bold-abbr": "B",
    "italic-abbr": "I",
    "deleted-abbr": "S",
    "underline-abbr": "U",
    "superscript-abbr": "Sup",
    "subscript-abbr": "Sub",
    "lists": "Lists",
    "link-insert": "Insert Link",
    "link-edit": "Edit Link",
    "link-in-new-tab": "Open link in new tab",
    "unlink": "Unlink",
    "cancel": "Cancel",
    "close": "Close",
    "insert": "Insert",
    "save": "Save",
    "delete": "Delete",
    "text": "Text",
    "edit": "Edit",
    "title": "Alt",
    "paragraph": "Normal text",
    "quote": "Quote",
    "code": "Code",
    "heading1": "Heading 1",
    "heading2": "Heading 2",
    "heading3": "Heading 3",
    "heading4": "Heading 4",
    "heading5": "Heading 5",
    "heading6": "Heading 6",
    "filename": "Name",
    "optional": "optional",
    "unorderedlist": "Unordered List",
    "orderedlist": "Ordered List",
    "outdent": "Outdent",
    "indent": "Indent",
    "horizontalrule": "Line",
    "upload": "Upload",
    "upload-label": "Drop files here or click to upload",
    "accessibility-help-label": "Rich text editor",
    "caption": "Caption",
    "bulletslist": "Bullets",
    "numberslist": "Numbers",
    "image-position": "Position",
    "none": "None",
    "left": "Left",
    "right": "Right",
    "center": "Center",
    "undo": "Undo",
    "redo": "Redo"
};
$R.buttons = {
    html: {
        title: 'HTML',
        icon: true,
        api: 'module.source.toggle'
    },
    undo: {
        title: '## undo ##',
        icon: true,
        api: 'module.buffer.undo'
    },
    redo: {
        title: '## redo ##',
        icon: true,
        api: 'module.buffer.redo'
    },
    format: {
        title: '## format ##',
        icon: true,
        dropdown: {
            p: {
                title: '## paragraph ##',
                api: 'module.block.format',
                args: {
                    tag: 'p'
                }
            },
            blockquote: {
                title: '## quote ##',
                api: 'module.block.format',
                args: {
                    tag: 'blockquote'
                }
            },
            h1: {
                title: '## heading1 ##',
                api: 'module.block.format',
                args: {
                    tag: 'h1'
                }
            },
            h2: {
                title: '## heading2 ##',
                api: 'module.block.format',
                args: {
                    tag: 'h2'
                }
            },
            h3: {
                title: '## heading3 ##',
                api: 'module.block.format',
                args: {
                    tag: 'h3'
                }
            },
            h4: {
                title: '## heading4 ##',
                api: 'module.block.format',
                args: {
                    tag: 'h4'
                }
            },
            h5: {
                title: '## heading5 ##',
                api: 'module.block.format',
                args: {
                    tag: 'h5'
                }
            },
            h6: {
                title: '## heading6 ##',
                api: 'module.block.format',
                args: {
                    tag: 'h6'
                }
            }
        }
    },
    bold: {
        title: '## bold-abbr ##',
        icon: true,
        tooltip: '## bold ##',
        api: 'module.inline.format',
        args: {
            tag: 'b'
        }
    },
    italic: {
        title: '## italic-abbr ##',
        icon: true,
        tooltip: '## italic ##',
        api: 'module.inline.format',
        args: {
            tag: 'i'
        }
    },
    deleted: {
        title: '## deleted-abbr ##',
        icon: true,
        tooltip: '## deleted ##',
        api: 'module.inline.format',
        args: {
            tag: 'del'
        }
    },
    underline: {
        title: '## underline-abbr ##',
        icon: true,
        tooltip: '## underline ##',
        api: 'module.inline.format',
        args: {
            tag: 'u'
        }
    },
    sup: {
        title: '## superscript-abbr ##',
        icon: true,
        tooltip: '## superscript ##',
        api: 'module.inline.format',
        args: {
            tag: 'sup'
        }
    },
    sub: {
        title: '## subscript-abbr ##',
        icon: true,
        tooltip: '## subscript ##',
        api: 'module.inline.format',
        args: {
            tag: 'sub'
        }
    },
    lists: {
        title: '## lists ##',
        icon: true,
        observe: 'list',
        dropdown: {
            observe: 'list',
            unorderedlist: {
                title: '&bull; ## unorderedlist ##',
                api: 'module.list.toggle',
                args: 'ul'
            },
            orderedlist: {
                title: '1. ## orderedlist ##',
                api: 'module.list.toggle',
                args: 'ol'
            },
            outdent: {
                title: '< ## outdent ##',
                api: 'module.list.outdent'
            },
            indent: {
                title: '> ## indent ##',
                api: 'module.list.indent'
            }
        }
    },
    ul: {
        title: '&bull; ## bulletslist ##',
        icon: true,
        api: 'module.list.toggle',
        observe: 'list',
        args: 'ul'
    },
    ol: {
        title: '1. ## numberslist ##',
        icon: true,
        api: 'module.list.toggle',
        observe: 'list',
        args: 'ol'
    },
    outdent: {
        title: '## outdent ##',
        icon: true,
        api: 'module.list.outdent',
        observe: 'list'
    },
    indent: {
        title: '## indent ##',
        icon: true,
        api: 'module.list.indent',
        observe: 'list'
    },
    image: {
        title: '## image ##',
        icon: true,
        api: 'module.image.open'
    },
    file: {
        title: '## file ##',
        icon: true,
        api: 'module.file.open'
    },
    link: {
        title: '## link ##',
        icon: true,
        observe: 'link',
        dropdown: {
            observe: 'link',
            link: {
                title: '## link-insert ##',
                api: 'module.link.open'
            },
            unlink: {
                title: '## unlink ##',
                api: 'module.link.unlink'
            }
        }
    },
    line: {
        title: '## horizontalrule ##',
        icon: true,
        api: 'module.line.insert'
    }
};
var App = function(element, options, uuid)
{
    this.module = {};
    this.plugin = {};
    this.instances = {};

    // start/stop
    this.started = false;
    this.stopped = false;

    // environment
    this.uuid = uuid;
    this.rootElement = element;
    this.rootOpts = options;
    this.dragInside = false;
    this.dragComponentInside = false;
    this.keycodes = $R.keycodes;
    this.namespace = 'redactor';
    this.$win = $R.dom(window);
    this.$doc = $R.dom(document);
    this.$body = $R.dom('body');
    this.editorReadOnly = false;

    // core services
    this.opts = $R.create('service.options', options, element);
    this.lang = $R.create('service.lang', this);

    // build
    this.buildServices();
    this.buildModules();
    this.buildPlugins();

    // start
    this.start();
};

App.prototype = {
    start: function()
    {
        // start
        this.stopped = false;
        this.broadcast('start');
        this.broadcast('startcode');

        if (this.opts.clickToEdit)
        {
            this.broadcast('startclicktoedit');
        }
        else
        {
            this.broadcast('enable');
            if (this.opts.showSource) this.broadcast('startcodeshow');
            this.broadcast('enablefocus');
        }

        // started
        this.broadcast('started');
        this.started = true;
    },
    stop: function()
    {
        this.started = false;
        this.stopped = true;

        this.broadcast('stop');
        this.broadcast('disable');
        this.broadcast('stopped');
    },

    // started & stopped
    isStarted: function()
    {
        return this.started;
    },
    isStopped: function()
    {
        return this.stopped;
    },

    // build
    buildServices: function()
    {
        var core = ['options', 'lang'];
        var bindable = ['uuid', 'keycodes', 'opts', 'lang', '$win', '$doc', '$body'];
        var services = [];
        for (var name in $R.services)
        {
            if (core.indexOf(name) === -1)
            {
                this[name] = $R.create('service.' + name, this);
                services.push(name);
                bindable.push(name);
            }
        }

        // binding
        for (var i = 0; i < services.length; i++)
        {
            var service = services[i];
            for (var z = 0; z < bindable.length; z++)
            {
                var inj = bindable[z];
                if (service !== inj)
                {
                    this[service][inj] = this[inj];
                }
            }
        }
    },
    buildModules: function()
    {
        for (var name in $R.modules)
        {
            this.module[name] = $R.create('module.' + name, this);
            this.instances[name] = this.module[name];
        }
    },
    buildPlugins: function()
    {
        var plugins = this.opts.plugins;
        for (var i = 0; i < plugins.length; i++)
        {
            var name = plugins[i];
            if (typeof $R.plugins[name] !== 'undefined')
            {
                this.plugin[name] = $R.create('plugin.' + name, this);
                this.instances[name] = this.plugin[name];
            }
        }
    },

    // draginside
    isDragInside: function()
    {
        return this.dragInside;
    },
    setDragInside: function(dragInside)
    {
        this.dragInside = dragInside;
    },
    isDragComponentInside: function()
    {
        return this.dragComponentInside;
    },
    setDragComponentInside: function(dragInside)
    {
        this.dragComponentInside = dragInside;
    },
    getDragComponentInside: function()
    {
        return this.dragComponentInside;
    },

    // readonly
    isReadOnly: function()
    {
        return this.editorReadOnly;
    },
    enableReadOnly: function()
    {
        this.editorReadOnly = true;
        this.broadcast('enablereadonly');
        this.component.clearActive();
        this.toolbar.disableButtons();
    },
    disableReadOnly: function()
    {
        this.editorReadOnly = false;
        this.broadcast('disablereadonly');
        this.toolbar.enableButtons();
    },

    // messaging
    callMessageHandler: function(instance, name, args)
    {
        var arr = name.split('.');
        if (arr.length === 1)
        {
            if (typeof instance['on' + name] === 'function')
            {
                instance['on' + name].apply(instance, args);
            }
        }
        else
        {
            arr[0] = 'on' + arr[0];

            var func = this.utils.checkProperty(instance, arr);
            if (typeof func === 'function')
            {
                func.apply(instance, args);
            }
        }
    },
    broadcast: function(name)
    {
        var args = [].slice.call(arguments, 1);
        for (var moduleName in this.instances)
        {
            this.callMessageHandler(this.instances[moduleName], name, args);
        }

        // callback
        return this.callback.trigger(name, args);
    },

    // callback
    on: function(name, func)
    {
        this.callback.add(name, func);
    },
    off: function(name, func)
    {
        this.callback.remove(name, func);
    },

    // api
    api: function(name)
    {
        if (!this.isStarted() && name !== 'start') return;
        if (this.isReadOnly() && name !== 'disableReadOnly') return;

        this.broadcast('state');

        var args = [].slice.call(arguments, 1);
        var arr = name.split('.');

        var isApp = (arr.length === 1);
        var isCallback = (arr[0] === 'on' || arr[0] === 'off');
        var isService = (!isCallback && arr.length === 2);
        var isPlugin = (arr[0] === 'plugin');
        var isModule = (arr[0] === 'module');

        // app
        if (isApp)
        {
            if (typeof this[arr[0]] === 'function')
            {
                return this.callInstanceMethod(this, arr[0], args);
            }
        }
        // callback
        else if (isCallback)
        {
            return (arr[0] === 'on') ? this.on(arr[1], args[0]) : this.off(arr[1], args[0] || undefined);
        }
        // service
        else if (isService)
        {
            if (this.isInstanceExists(this, arr[0]))
            {
                return this.callInstanceMethod(this[arr[0]], arr[1], args);
            }
            else
            {
                $R.error(new Error('Service "' + arr[0] + '" not found'));
            }
        }
        // plugin
        else if (isPlugin)
        {
            if (this.isInstanceExists(this.plugin, arr[1]))
            {
                return this.callInstanceMethod(this.plugin[arr[1]], arr[2], args);
            }
            else
            {
                $R.error(new Error('Plugin "' + arr[1] + '" not found'));
            }
        }
        // module
        else if (isModule)
        {
            if (this.isInstanceExists(this.module, arr[1]))
            {
                return this.callInstanceMethod(this.module[arr[1]], arr[2], args);
            }
            else
            {
                $R.error(new Error('Module "' + arr[1] + '" not found'));
            }
        }

    },
    isInstanceExists: function(obj, name)
    {
        return (typeof obj[name] !== 'undefined');
    },
    callInstanceMethod: function(instance, method, args)
    {
        if (typeof instance[method] === 'function')
        {
            return instance[method].apply(instance, args);
        }
    }
};
$R.add('mixin', 'formatter', {

    // public
    buildArgs: function(args)
    {
        this.args = {
            'class': args['class'] || false,
            'style': args['style'] || false,
            'attr': args['attr'] || false
        };

        if (!this.args['class'] && !this.args['style'] && !this.args['attr'])
        {
            this.args = false;
        }
    },
    applyArgs: function(nodes, selection)
    {
        if (this.args)
        {
            nodes = this[this.type](this.args, false, nodes, selection);
        }
        else
        {
            nodes = this._clearAll(nodes, selection);
        }

        return nodes;
    },
    clearClass: function(tags, nodes)
    {
        this.selection.save();

        var $elements = (nodes) ? $R.dom(nodes) : this.getElements(tags, true);
        $elements.removeAttr('class');

        nodes = this._unwrapSpanWithoutAttr($elements.getAll());

        this.selection.restore();

        return nodes;
    },
    clearStyle: function(tags, nodes)
    {
        this.selection.save();

        var $elements = (nodes) ? $R.dom(nodes) : this.getElements(tags, true);
        $elements.removeAttr('style');

        nodes = this._unwrapSpanWithoutAttr($elements.getAll());

        this.selection.restore();

        return nodes;
    },
    clearAttr: function(tags, nodes)
    {
        this.selection.save();

        var $elements = (nodes) ? $R.dom(nodes) : this.getElements(tags, true);
        this._removeAllAttr($elements);

        nodes = this._unwrapSpanWithoutAttr($elements.getAll());

        this.selection.restore();

        return nodes;
    },
    set: function(args, tags, nodes, selection)
    {
        if (selection !== false) this.selection.save();

        var $elements = (nodes) ? $R.dom(nodes) : this.getElements(tags);

        if (args['class'])
        {
            $elements.removeAttr('class');
            $elements.addClass(args['class']);
        }

        if (args['style'])
        {
            $elements.removeAttr('style');
            $elements.css(args['style']);
            $elements.each(function(node)
            {
                var $node = $R.dom(node);
                $node.attr('data-redactor-style-cache', $node.attr('style'));
            });
        }

        if (args['attr'])
        {
            this._removeAllAttr($elements);
            $elements.attr(args['attr']);
        }

        if (selection !== false) this.selection.restore();

        return $elements.getAll();
    },
    toggle: function(args, tags, nodes, selection)
    {
        if (selection !== false) this.selection.save();

        var $elements = (nodes) ? $R.dom(nodes) : this.getElements(tags);

        if (args['class'])
        {
            $elements.toggleClass(args['class']);
            $elements.each(function(node)
            {
                if (node.className === '') node.removeAttribute('class');
            });
        }

        var params;
        if (args['style'])
        {
            params = args['style'];
            $elements.each(function(node)
            {
                var $node = $R.dom(node);
                for (var key in params)
                {
                    var newVal = params[key];
                    var oldVal = $node.css(key);

                    oldVal = (this.utils.isRgb(oldVal)) ? this.utils.rgb2hex(oldVal) : oldVal.replace(/"/g, '');
                    newVal = (this.utils.isRgb(newVal)) ? this.utils.rgb2hex(newVal) : newVal.replace(/"/g, '');

                    oldVal = this.utils.hex2long(oldVal);
                    newVal = this.utils.hex2long(newVal);

                    var compareNew = (typeof newVal === 'string') ? newVal.toLowerCase() : newVal;
                    var compareOld = (typeof oldVal === 'string') ? oldVal.toLowerCase() : oldVal;

                    if (compareNew === compareOld) $node.css(key, '');
                    else $node.css(key, newVal);
                }

                this._convertStyleQuotes($node);
                if (this.utils.removeEmptyAttr(node, 'style'))
                {
                    $node.removeAttr('data-redactor-style-cache');
                }
                else
                {
                    $node.attr('data-redactor-style-cache', $node.attr('style'));
                }

            }.bind(this));
        }

        if (args['attr'])
        {
            params = args['attr'];
            $elements.each(function(node)
            {
                var $node = $R.dom(node);
                for (var key in params)
                {
                    if ($node.attr(key)) $node.removeAttr(key);
                    else $node.attr(key, params[key]);
                }
            });

        }

        if (selection !== false) this.selection.restore();

        return $elements.getAll();
    },
    add: function(args, tags, nodes, selection)
    {
        if (selection !== false) this.selection.save();

        var $elements = (nodes) ? $R.dom(nodes) : this.getElements(tags);

        if (args['class'])
        {
            $elements.addClass(args['class']);
        }

        if (args['style'])
        {
            var params = args['style'];
            $elements.each(function(node)
            {
                var $node = $R.dom(node);
                $node.css(params);
                $node.attr('data-redactor-style-cache', $node.attr('style'));

                this._convertStyleQuotes($node);

            }.bind(this));
        }

        if (args['attr'])
        {
            $elements.attr(args['attr']);
        }

        if (selection !== false) this.selection.restore();

        return $elements.getAll();
    },
    remove: function(args, tags, nodes, selection)
    {
        if (selection !== false) this.selection.save();

        var $elements = (nodes) ? $R.dom(nodes) : this.getElements(tags);

        if (args['class'])
        {
            $elements.removeClass(args['class']);
            $elements.each(function(node)
            {
                if (node.className === '') node.removeAttribute('class');
            });
        }

        if (args['style'])
        {
            var name = args['style'];
            $elements.each(function(node)
            {
                var $node = $R.dom(node);
                $node.css(name, '');

                if (this.utils.removeEmptyAttr(node, 'style'))
                {
                    $node.removeAttr('data-redactor-style-cache');
                }
                else
                {
                    $node.attr('data-redactor-style-cache', $node.attr('style'));
                }

            }.bind(this));
        }

        if (args['attr'])
        {
            $elements.removeAttr(args['attr']);
        }

        nodes = this._unwrapSpanWithoutAttr($elements.getAll());

        if (selection !== false) this.selection.restore();

        return nodes;
    },

    // private
    _removeAllAttr: function($elements)
    {
        $elements.each(function(node)
        {
            for (var i = node.attributes.length; i-->0;)
            {
                var nodeAttr = node.attributes[i];
                var name = nodeAttr.name;
                if (name !== 'style' && name !== 'class')
                {
                    node.removeAttributeNode(nodeAttr);
                }
            }
        });
    },
    _convertStyleQuotes: function($node)
    {
        var style = $node.attr('style');
        if (style) $node.attr('style', style.replace(/"/g, '\''));
    },
    _clearAll: function(nodes, selection)
    {
        if (selection !== false) this.selection.save();

        for (var i = 0; i < nodes.length; i++)
        {
            var node = nodes[i];
            while (node.attributes.length > 0)
            {
                node.removeAttribute(node.attributes[0].name);
            }
        }

        nodes = this._unwrapSpanWithoutAttr(nodes);

        if (selection !== false) this.selection.restore();

        return nodes;
    },
    _unwrapSpanWithoutAttr: function(nodes)
    {
        var finalNodes = [];
        for (var i = 0; i < nodes.length; i++)
        {
            var node = nodes[i];
            var len = node.attributes.length;
            if (len <= 0 && node.nodeType !== 3 && node.tagName === 'SPAN')
            {
                $R.dom(node).unwrap();
            }
            else
            {
                finalNodes.push(node);
            }
        }

        return finalNodes;
    }
});
$R.add('mixin', 'dom', $R.Dom.prototype);
$R.add('mixin', 'component', {
    get cmnt()
    {
        return true;
    }
});
$R.add('service', 'options', {
    init: function(options, element)
    {
        var $el = $R.dom(element);
        var opts = $R.extend({}, $R.opts, (element) ? $el.data() : {}, $R.options);
        opts = $R.extend(true, opts, options);

        return opts;
    }
});
$R.add('service', 'lang', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;

        // build
        this.vars = this._build(this.opts.lang);
    },

    // public
    rebuild: function(lang)
    {
        this.opts.lang = lang;
        this.vars = this._build(lang);
    },
    extend: function(obj)
    {
        this.vars = $R.extend(this.vars, obj);
    },
    parse: function(str)
    {
        if (str === undefined)
        {
            return '';
        }

        var matches = str.match(/## (.*?) ##/g);
        if (matches)
        {
            for (var i = 0; i < matches.length; i++)
            {
                var key = matches[i].replace(/^##\s/g, '').replace(/\s##$/g, '');
                str = str.replace(matches[i], this.get(key));
            }
        }

        return str;
    },
    get: function(name)
    {
        var str = '';
        if (typeof this.vars[name] !== 'undefined')
        {
            str = this.vars[name];
        }
        else if (this.opts.lang !== 'en' && typeof $R.lang['en'][name] !== 'undefined')
        {
            str = $R.lang['en'][name];
        }

        return str;
    },

    // private
    _build: function(lang)
    {
        var vars = $R.lang['en'];
        if (lang !== 'en')
        {
            vars = ($R.lang[lang] !== undefined) ? $R.lang[lang] : vars;
        }

        return vars;
    }
});
$R.add('service', 'callback', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;

        // local
        this.callbacks = {};

        // build
        if (this.opts.callbacks)
        {
            this._set(this.opts.callbacks, '');
        }
    },
    stop: function()
    {
        this.callbacks = {};
    },
    add: function(name, handler)
    {
        if (!this.callbacks[name]) this.callbacks[name] = [];
        this.callbacks[name].push(handler);
    },
    remove: function(name, handler)
    {
        if (handler === undefined)
        {
            delete this.callbacks[name];
        }
        else
        {
            for (var i = 0; i < this.callbacks[name].length; i++)
            {
                this.callbacks[name].splice(i, 1);
            }

            if (Object.keys(this.callbacks[name]).length === 0) delete this.callbacks[name];
        }
    },
    trigger: function(name, args)
    {
        var value = this._loop(name, args, this.callbacks);
        return (typeof value === 'undefined' && args && args[0] !== false) ? args[0] : value;
    },

    // private
    _set: function(obj, name)
    {
        for (var key in obj)
        {
            var path = (name === '') ? key : name + '.' + key;
            if (typeof obj[key] === 'object')
            {
                this._set(obj[key], path);
            }
            else
            {
                this.callbacks[path] = [];
                this.callbacks[path].push(obj[key]);
            }
        }
    },
    _loop: function(name, args, obj)
    {
        var value;
        for (var key in obj)
        {
            if (name === key)
            {
                for (var i = 0; i < obj[key].length; i++)
                {
                    value = obj[key][i].apply(this.app, args);
                }
            }
        }

        return value;
    }
});
$R.add('service', 'animate', {
    init: function(app)
    {
        this.animationOpt = app.opts.animation;
    },
    start: function(element, animation, options, callback)
    {
        var defaults = {
            duration: false,
            iterate: false,
            delay: false,
            timing: false,
            prefix: 'redactor-'
        };

        defaults = (typeof options === 'function') ? defaults : $R.extend(defaults, options);
        callback = (typeof options === 'function') ? options : callback;

        // play
        return new $R.AnimatePlay(element, animation, defaults, callback, this.animationOpt);
    },
    stop: function(element)
    {
        this.$el = $R.dom(element);
        this.$el.removeClass('redactor-animated');

        var effect = this.$el.attr('redactor-animate-effect');
        this.$el.removeClass(effect);

        this.$el.removeAttr('redactor-animate-effect');
        var hide = this.$el.attr('redactor-animate-hide');
        if (hide)
        {
            this.$el.addClass(hide).removeAttr('redactor-animate-hide');
        }

        this.$el.off('animationend webkitAnimationEnd');
    }
});

$R.AnimatePlay = function(element, animation, defaults, callback, animationOpt)
{
    this.hidableEffects = ['fadeOut', 'flipOut', 'slideUp', 'zoomOut', 'slideOutUp', 'slideOutRight', 'slideOutLeft'];
    this.prefixes = ['', '-webkit-'];

    this.$el = $R.dom(element);
    this.$body = $R.dom('body');
    this.callback = callback;
    this.animation = (!animationOpt) ? this.buildAnimationOff(animation) : animation;
    this.defaults = defaults;

    if (this.animation === 'slideUp')
    {
        this.$el.height(this.$el.height());
    }

    // animate
    return (this.isInanimate()) ? this.inanimate() : this.animate();
};

$R.AnimatePlay.prototype = {
    buildAnimationOff: function(animation)
    {
        return (this.isHidable(animation)) ? 'hide' : 'show';
    },
    buildHideClass: function()
    {
        return 'redactor-animate-hide';
    },
    isInanimate: function()
    {
        return (this.animation === 'show' || this.animation === 'hide');
    },
    isAnimated: function()
    {
        return this.$el.hasClass('redactor-animated');
    },
    isHidable: function(effect)
    {
        return (this.hidableEffects.indexOf(effect) !== -1);
    },
    inanimate: function()
    {
        this.defaults.timing = 'linear';

        var hide;
        if (this.animation === 'show')
        {
            hide = this.buildHideClass();
            this.$el.attr('redactor-animate-hide', hide);
            this.$el.removeClass(hide);
        }
        else
        {
            hide = this.$el.attr('redactor-animate-hide');
            this.$el.addClass(hide).removeAttr('redactor-animate-hide');
        }

        if (typeof this.callback === 'function') this.callback(this);

        return this;
    },
    animate: function()
    {
        var delay = (this.defaults.delay) ? this.defaults.delay : 0;
        setTimeout(function()
        {
            this.$body.addClass('no-scroll-x');
            this.$el.addClass('redactor-animated');
            if (!this.$el.attr('redactor-animate-hide'))
            {
                var hide = this.buildHideClass();
                this.$el.attr('redactor-animate-hide', hide);
                this.$el.removeClass(hide);
            }

            this.$el.addClass(this.defaults.prefix + this.animation);
            this.$el.attr('redactor-animate-effect', this.defaults.prefix + this.animation);

            this.set(this.defaults.duration + 's', this.defaults.iterate, this.defaults.timing);
            this.complete();

        }.bind(this), delay * 1000);

        return this;
    },
    set: function(duration, iterate, timing)
    {
        var len = this.prefixes.length;

        while (len--)
        {
            if (duration !== false || duration === '') this.$el.css(this.prefixes[len] + 'animation-duration', duration);
            if (iterate !== false || iterate === '') this.$el.css(this.prefixes[len] + 'animation-iteration-count', iterate);
            if (timing !== false || timing === '') this.$el.css(this.prefixes[len] + 'animation-timing-function', timing);
        }
    },
    clean: function()
    {
        this.$body.removeClass('no-scroll-x');
        this.$el.removeClass('redactor-animated');
        this.$el.removeClass(this.defaults.prefix + this.animation);
        this.$el.removeAttr('redactor-animate-effect');

        this.set('', '', '');
    },
    complete: function()
    {
        this.$el.one('animationend webkitAnimationEnd', function()
        {
            if (this.$el.hasClass(this.defaults.prefix + this.animation)) this.clean();
            if (this.isHidable(this.animation))
            {
                var hide = this.$el.attr('redactor-animate-hide');
                this.$el.addClass(hide).removeAttr('redactor-animate-hide');
            }

            if (this.animation === 'slideUp') this.$el.height('');
            if (typeof this.callback === 'function') this.callback(this.$el);

        }.bind(this));
    }
};
$R.add('service', 'caret', {
    init: function(app)
    {
        this.app = app;
    },

    // set
    setStart: function(el)
    {
        this._setCaret('Start', el);
    },
    setEnd: function(el)
    {
        this._setCaret('End', el);
    },
    setBefore: function(el)
    {
        this._setCaret('Before', el);
    },
    setAfter: function(el)
    {
        this._setCaret('After', el);
    },

    // is
    isStart: function(el)
    {
        return this._isStartOrEnd(el, 'First');
    },
    isEnd: function(el)
    {
        return this._isStartOrEnd(el, 'Last');
    },

    // set side
    setAtEnd: function(node)
    {
        var data = this.inspector.parse(node);
        var tag = data.getTag();
        var range = document.createRange();
        if (this._isInPage(node))
        {
            if (tag === 'a')
            {
                var textNode = this.utils.createInvisibleChar();
                $R.dom(node).after(textNode);

                range.selectNodeContents(textNode);
                range.collapse(true);
            }
            else
            {
                range.selectNodeContents(node);
                range.collapse(false);
            }

            this.selection.setRange(range);
        }
    },
    setAtStart: function(node)
    {
        var range = document.createRange();
        var data = this.inspector.parse(node);
        if (this._isInPage(node))
        {
            range.setStart(node, 0);
            range.collapse(true);

            if (data.isInline() || this.utils.isEmpty(node))
            {
                var textNode = this.utils.createInvisibleChar();
                range.insertNode(textNode);
                range.selectNodeContents(textNode);
                range.collapse(false);
            }

            this.selection.setRange(range);
        }
    },
    setAtBefore: function(node)
    {
        var data = this.inspector.parse(node);
        var range = document.createRange();
        if (this._isInPage(node))
        {
            range.setStartBefore(node);
            range.collapse(true);

            if (data.isInline())
            {
                var textNode = this.utils.createInvisibleChar();
                node.parentNode.insertBefore(textNode, node);
                range.selectNodeContents(textNode);
                range.collapse(false);
            }

            this.selection.setRange(range);
        }
    },
    setAtAfter: function(node)
    {

        var range = document.createRange();
        if (this._isInPage(node))
        {
            range.setStartAfter(node);
            range.collapse(true);

            var textNode = this.utils.createInvisibleChar();
            range.insertNode(textNode);
            range.selectNodeContents(textNode);
            range.collapse(false);

            this.selection.setRange(range);
        }
    },
    setAtPrev: function(node)
    {
        var prev = node.previousSibling;
        if (prev)
        {
            prev = (prev.nodeType === 3 && this._isEmptyTextNode(prev)) ? prev.previousElementSibling : prev;
            if (prev) this.setEnd(prev);
        }
    },
    setAtNext: function(node)
    {
        var next = node.nextSibling;
        if (next)
        {
            next = (next.nodeType === 3 && this._isEmptyTextNode(next)) ? next.nextElementSibling : next;
            if (next) this.setStart(next);
        }
    },

    // private
    _setCaret: function(type, el)
    {
        var data = this.inspector.parse(el);
        var node = data.getNode();

        if (node)
        {
            this.component.clearActive();
            this['_set' + type](node, data, data.getTag());
        }
    },
    _setStart: function(node, data, tag)
    {
        // 1. text
        if (data.isText())
        {
            this.editor.focus();
            return this.setAtStart(node);
        }
        // 2. ul, ol
        else if (tag === 'ul' || tag === 'ol')
        {
            node = data.findFirstNode('li');

            var item = this.utils.getFirstElement(node);
            var dataItem = this.inspector.parse(item);
            if (item && dataItem.isComponent())
            {
                return this.setStart(dataItem.getComponent());
            }
        }
        // 3. dl
        else if (tag === 'dl')
        {
            node = data.findFirstNode('dt');
        }
        // 4. br / hr
        else if (tag === 'br' || tag === 'hr')
        {
            return this.setBefore(node);
        }
        // 5. th, td
        else if (tag === 'td' || tag === 'th')
        {
            var el = data.getFirstElement(node);
            if (el)
            {
                return this.setStart(el);
            }
        }
        // 6. table
        else if (tag === 'table' || tag === 'tr')
        {
            return this.setStart(data.findFirstNode('th, td'));
        }
        // 7. figure code
        else if (data.isComponentType('code') && !data.isFigcaption())
        {
            var code = data.findLastNode('pre, code');

            this.editor.focus();
            return this.setAtStart(code);
        }
        // 8. table component
        else if (tag === 'figure' && data.isComponentType('table'))
        {
            var table = data.getTable();
            var tableData = this.inspector.parse(table);

            return this.setStart(tableData.findFirstNode('th, td'));
        }
        // 9. non editable components
        else if (!data.isComponentType('table') && data.isComponent() && !data.isFigcaption())
        {
            return this.component.setActive(node);
        }

        this.editor.focus();

        // set
        if (!this._setInline(node, 'Start'))
        {
            this.setAtStart(node);
        }
    },
    _setEnd: function(node, data, tag)
    {
        // 1. text
        if (data.isText())
        {
            this.editor.focus();
            return this.setAtEnd(node);
        }
        // 2. ul, ol
        else if (tag === 'ul' || tag === 'ol')
        {
            node = data.findLastNode('li');

            var item = this.utils.getLastElement(node);
            var dataItem = this.inspector.parse(item);
            if (item && dataItem.isComponent())
            {
                return this.setEnd(dataItem.getComponent());
            }
        }
        // 3. dl
        else if (tag === 'dl')
        {
            node = data.findLastNode('dd');
        }
        // 4. br / hr
        else if (tag === 'br' || tag === 'hr')
        {
            return this.setAfter(node);
        }
        // 5. th, td
        else if (tag === 'td' || tag === 'th')
        {
            var el = data.getLastElement();
            if (el)
            {
                return this.setEnd(el);
            }
        }
        // 6. table
        else if (tag === 'table' || tag === 'tr')
        {
            return this.setEnd(data.findLastNode('th, td'));
        }
        // 7. figure code
        else if (data.isComponentType('code') && !data.isFigcaption())
        {
            var code = data.findLastNode('pre, code');

            this.editor.focus();
            return this.setAtEnd(code);
        }
        // 8. table component
        else if (tag === 'figure' && data.isComponentType('table'))
        {
            var table = data.getTable();
            var tableData = this.inspector.parse(table);

            return this.setEnd(tableData.findLastNode('th, td'));
        }
        // 9. non editable components
        else if (!data.isComponentType('table') && data.isComponent() && !data.isFigcaption())
        {
            return this.component.setActive(node);
        }

        this.editor.focus();

        // set
        if (!this._setInline(node, 'End'))
        {
            // is element empty
            if (this.utils.isEmpty(node))
            {
                return this.setStart(node);
            }

            this.setAtEnd(node);
        }
    },
    _setBefore: function(node, data, tag)
    {
        // text
        if (node.nodeType === 3)
        {
            return this.setAtBefore(node);
        }
        // inline
        else if (data.isInline())
        {
            return this.setAtBefore(node);
        }
        // td / th
        else if (data.isFirstTableCell())
        {
            return this.setAtPrev(data.getComponent());
        }
        else if (tag === 'td' || tag === 'th')
        {
            return this.setAtPrev(node);
        }
        // li
        else if (data.isFirstListItem())
        {
            return this.setAtPrev(data.getList());
        }
        // figcaption
        else if (data.isFigcaption())
        {
            return this.setStart(data.getComponent());
        }
        // component
        else if (!data.isComponentType('table') && data.isComponent())
        {
            return this.setAtPrev(data.getComponent());
        }
        // block
        else if (data.isBlock())
        {
            return this.setAtPrev(node);
        }

        this.editor.focus();
        this.setAtBefore(node);

    },
    _setAfter: function(node, data, tag)
    {
        // text
        if (node.nodeType === 3)
        {
            return this.setAtAfter(node);
        }
        // inline
        else if (data.isInline())
        {
            return this.setAtAfter(node);
        }
        // td / th
        else if (data.isLastTableCell())
        {
            return this.setAtNext(data.getComponent());
        }
        else if (tag === 'td' || tag === 'th')
        {
            return this.setAtNext(node);
        }
        // li
        else if (data.isFirstListItem())
        {
            return this.setAtNext(data.getList());
        }
        // component
        else if (!data.isComponentType('table') && data.isComponent())
        {
            return this.setAtNext(data.getComponent());
        }
        // block
        else if (data.isBlock())
        {
            return this.setAtNext(node);
        }

        this.editor.focus();
        this.setAtAfter(node);
    },
    _setInline: function(node, type)
    {
        // is first element inline (FF only)
        var inline = this._hasInlineChild(node, (type === 'Start') ? 'first' : 'last');
        if (inline)
        {
            if (type === 'Start')
            {
                this.setStart(inline);
            }
            else
            {
                this.setEnd(inline);
            }

            return true;
        }
    },
    _isStartOrEnd: function(el, type)
    {
        var node = this.utils.getNode(el);
        if (!node) return false;

        var data = this.inspector.parse(node);
        node = this._getStartEndNode(node, data, type);

        if (node && (node.nodeType !== 3 && node.tagName !== 'LI'))
        {
            var html = (node.nodeType === 3) ? node.textContent : node.innerHTML;
            html = this.utils.trimSpaces(html);
            if (html === '') return true;
        }

        if (!data.isFigcaption() && data.isComponent() && !data.isComponentEditable())
        {
            return true;
        }

        var offset = this.offset.get(node, true);
        if (offset)
        {
            return (type === 'First') ? (offset.start === 0) : (offset.end === this.offset.size(node, true));
        }
        else
        {
            return false;
        }
    },
    _isInPage: function(node)
    {
        if (node && node.nodeType)
        {
            return (node === document.body) ? false : document.body.contains(node);
        }
        else
        {
            return false;
        }
    },
    _hasInlineChild: function(el, pos)
    {
        var data = this.inspector.parse(el);
        var node = (pos === 'first') ? data.getFirstNode() : data.getLastNode();
        var $node = $R.dom(node);

        if (node && node.nodeType !== 3
            && this.inspector.isInlineTag(node.tagName)
            && !$node.hasClass('redactor-component')
             && !$node.hasClass('non-editable'))
        {
            return node;
        }
    },
    _isEmptyTextNode: function(node)
    {
        var text = node.textContent.trim().replace(/\n/, '');
        text = this.utils.removeInvisibleChars(text);

        return (text === '');
    },
    _getStartEndNode: function(node, data, type)
    {
        if (data.isFigcaption())
        {
            node = data.getFigcaption();
        }
        else if (data.isTable())
        {
            node = data['find' + type + 'Node']('th, td');
        }
        else if (data.isList())
        {
            node = data['find' + type + 'Node']('li');
        }
        else if (data.isComponentType('code'))
        {
            node = data.findLastNode('pre, code');
        }

        return node;
    }
});
var containsNode = function containsNode(node) {
    return document.getSelection().containsNode(node, true);
};

if (!('containsNode' in Selection.prototype)) {
    containsNode = containsNodePolyfill;
}

var containsNodePolyfill = function polyfill(node) {
    var selection = document.getSelection();
    var start = selection.anchorNode.parentNode;
    var finalnode = selection.focusNode.parentNode;
    var rectSelection = selection.getRangeAt(0).getBoundingClientRect();
    var rectBlock = node.getBoundingClientRect();

    if ($R.dom(start).closest(node).length) {
        return true;
    }

    if ($R.dom(finalnode).closest(node).length) {
        return true;
    }

    if (rectSelection.top < rectBlock.top && rectSelection.height > rectBlock.height) {
        return true;
    }

    return false;
};


$R.add('service', 'selection', {
    init: function(app)
    {
        this.app = app;
    },
    // is
    is: function()
    {
        var sel = this.get();
        if (sel)
        {
            var node = sel.anchorNode;
            var data = this.inspector.parse(node);

            return (data.isInEditor() || data.isEditor());
        }

        return false;
    },
    isCollapsed: function()
    {
        var sel = this.get();
        var range = this.getRange();

        if (sel && sel.isCollapsed) return true;
        else if (range && range.toString().length === 0) return true;

        return false;
    },
    isBackwards: function()
    {
        var backwards = false;
        var sel = this.get();

        if (sel && !sel.isCollapsed)
        {
            var range = document.createRange();
            range.setStart(sel.anchorNode, sel.anchorOffset);
            range.setEnd(sel.focusNode, sel.focusOffset);
            backwards = range.collapsed;
            range.detach();
        }

        return backwards;
    },
    isIn: function(el)
    {
        var node = $R.dom(el).get();
        var current = this.getCurrent();

        return (current && node) ? node.contains(current) : false;
    },
    isText: function()
    {
        var sel = this.get();
        if (sel)
        {
            var el = sel.anchorNode;
            var block = this.getBlock(el);
            var blocks = this.getBlocks();

            // td, th or hasn't block
            if ((block && this.inspector.isTableCellTag(block.tagName)) || (block === false && blocks.length === 0))
            {
                return true;
            }
        }

        return false;
    },
    isAll: function(el)
    {
        var node = this.utils.getNode(el);
        if (!node) return false;

        var isEditor = this.editor.isEditor(node);
        var data = this.inspector.parse(node);

        // component
        if (!data.isFigcaption() && this.component.isNonEditable(node) && this.component.isActive(node))
        {
            return true;
        }

        if (isEditor)
        {
            var $editor = this.editor.getElement();
            var output = $editor.html().replace(/<p><\/p>$/i, '');
            var htmlLen = this.getHtml(false).length;
            var outputLen = output.length;

            if (htmlLen !== outputLen)
            {
                return false;
            }
        }

        // editor empty or collapsed
        if ((isEditor && this.editor.isEmpty()) || this.isCollapsed())
        {
            return false;
        }

        // all
        var offset = this.offset.get(node, true);
        var size = this.offset.size(node, true);

        // pre, table, or pre/code in figure
        if (!isEditor && data.isComponentType('code'))
        {
            size = this.getText().trim().length;
        }

        if (offset && offset.start === 0 && offset.end === size)
        {
            return true;
        }

        return false;
    },

    // has
    hasNonEditable: function()
    {
        var selected = this.getHtml();
        var $wrapper = $R.dom('<div>').html(selected);

        return (!this.isCollapsed() && $wrapper.find('.non-editable').length !== 0);
    },

    // set
    setRange: function(range)
    {
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    },
    setAll: function(el)
    {
        var node = this.utils.getNode(el);
        if (!node) return;

        var data = this.inspector.parse(node);

        this.component.clearActive();

        this.editor.focus();
        this.editor.saveScroll();
        this.editor.disableNonEditables();

        if (node && node.tagName === 'TABLE')
        {
            var first = data.findFirstNode('td, th');
            var last = data.findLastNode('td, th');

            $R.dom(first).prepend(this.marker.build('start'));
            $R.dom(last).append(this.marker.build('end'));

            this.restoreMarkers();
        }
        else if (!data.isFigcaption() && this.component.isNonEditable(node))
        {
            this.component.setActive(node);
        }
        else
        {
            if (data.isComponentType('code'))
            {
                node = data.getComponentCodeElement();
                node.focus();
            }

            var range = document.createRange();
            range.selectNodeContents(node);

            this.setRange(range);
        }

        this.editor.enableNonEditables();
        this.editor.restoreScroll();
    },

    // get
    get: function()
    {
        var sel = window.getSelection();
        return (sel.rangeCount > 0) ? sel : null;
    },
    getRange: function()
    {
        var sel = this.get();
        return (sel) ? ((sel.getRangeAt(0)) ? sel.getRangeAt(0) : null) : null;
    },
    getTextBeforeCaret: function(num)
    {
        num = (typeof num === 'undefined') ? 1 : num;

        var el = this.editor.getElement().get();
        var range = this.getRange();
        var text = false;
        if (range)
        {
            range = range.cloneRange();
            range.collapse(true);
            range.setStart(el, 0);
            text = range.toString().slice(-num);
        }

        return text;
    },
    getTextAfterCaret: function(num)
    {
        num = (typeof num === 'undefined') ? 1 : num;

        var el = this.editor.getElement().get();
        var range = this.getRange();
        var text = false;
        if (range)
        {
            var clonedRange = range.cloneRange();
            clonedRange.selectNodeContents(el);
            clonedRange.setStart(range.endContainer, range.endOffset);

            text = clonedRange.toString().slice(0, num);
        }

        return text;
    },
    getPosition: function()
    {
        var range = this.getRange();
        var pos = { top: 0, left: 0, width: 0, height: 0 };
        if (window.getSelection && range.getBoundingClientRect)
        {
            range = range.cloneRange();
            var offset = (range.startOffset-1);
            range.setStart(range.startContainer, (offset < 0) ? 0 : offset);
            var rect = range.getBoundingClientRect();
            pos = { top: rect.top, left: rect.left, width: (rect.right - rect.left) , height: (rect.bottom - rect.top) };
        }

        return pos;
    },
    getCurrent: function()
    {
        var node = false;
        var sel = this.get();
        var component = this.component.getActive();

        if (component)
        {
            node = component;
        }
        else if (sel && this.is())
        {
            var data = this.inspector.parse(sel.anchorNode);
            node = (!data.isEditor()) ? sel.anchorNode : false;
        }

        return node;
    },
    getParent: function()
    {
        var node = false;
        var current = this.getCurrent();
        if (current)
        {
            var parent = current.parentNode;
            var data = this.inspector.parse(parent);

            node = (!data.isEditor()) ? parent : false;
        }

        return node;
    },
    getElement: function(el)
    {
        var node = el || this.getCurrent();
        while (node)
        {
            var data = this.inspector.parse(node);
            if (data.isElement() && data.isInEditor())
            {
                return node;
            }

            node = node.parentNode;
        }

        return false;
    },
    getInline: function(el)
    {
        var node = el || this.getCurrent();
        var inline = false;
        while (node)
        {
            if (this._isInlineNode(node))
            {
                inline = node;
            }

            node = node.parentNode;
        }

        return inline;
    },
    getInlineFirst: function(el)
    {
        var node = el || this.getCurrent();
        while (node)
        {
            if (this._isInlineNode(node))
            {
                return node;
            }

            node = node.parentNode;
        }

        return false;
    },
    getInlineAll: function(el)
    {
        var node = el || this.getCurrent();
        var inlines = [];
        while (node)
        {
            if (this._isInlineNode(node))
            {
                inlines.push(node);
            }

            node = node.parentNode;
        }

        return inlines;
    },
    getBlock: function(el)
    {
        var node = el || this.getCurrent();
        while (node)
        {
            var data = this.inspector.parse(node);
            var isBlock = this.inspector.isBlockTag(node.tagName);

            if (isBlock && data.isInEditor(node))
            {
                return node;
            }

            node = node.parentNode;
        }

        return false;
    },
    getInlinesAllSelected: function(options)
    {
        if (this.isAll()) return [];

        var inlines = this.getInlines({ all: true });
        var textNodes = this.getNodes({ textnodes: true, inline: false });
        var selected = this.getText().replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
        var finalNodes = [];

        if (textNodes.length !== 0)
        {
            return finalNodes;
        }

        if (selected === '')
        {
            finalNodes = inlines;
        }
        else if (inlines.length > 1)
        {
            for (var i = 0; i < inlines.length; i++)
            {
                if (this._isTextSelected(inlines[i], selected))
                {
                    finalNodes.push(inlines[i]);
                }
            }
        }
        else if (inlines.length === 1)
        {
            if (this._isTextSelected(inlines[0], selected))
            {
                finalNodes = inlines;
            }
        }

        finalNodes = (options && options.tags) ? this._filterNodesByTags(finalNodes, options.tags) : finalNodes;

        return finalNodes;
    },
    getInlines: function(options)
    {
        var nodes = this.getNodes();
        var filteredNodes = [];
        for (var i = 0; i < nodes.length; i++)
        {
            var node;
            if (options && options.all)
            {
                node = nodes[i];
                while (node)
                {
                    if (this._isInlineNode(node) && !this._isInNodesArray(filteredNodes, node))
                    {
                        filteredNodes.push(node);
                    }

                    node = node.parentNode;
                }
            }
            else
            {
                node = this.getInline(nodes[i]);
                if (node && !this._isInNodesArray(filteredNodes, node))
                {
                    filteredNodes.push(node);
                }
            }
        }

        // filter
        filteredNodes = (options && options.tags) ? this._filterNodesByTags(filteredNodes, options.tags) : filteredNodes;
        filteredNodes = (options && options.inside) ? this._filterInlinesInside(filteredNodes, options) : filteredNodes;

        return filteredNodes;
    },
    getBlocks: function(options)
    {
        var nodes = this.getNodes();
        var block = this.getBlock();
        nodes = (nodes.length === 0 && block) ? [block] : nodes;

        var filteredNodes = [];
        for (var i = 0; i < nodes.length; i++)
        {
            var node = this.getBlock(nodes[i]);
            var $node = $R.dom(node);
            if ($node.hasClass('non-editable')) continue;

            if (node && !this._isInNodesArray(filteredNodes, node))
            {
                filteredNodes.push(node);
            }
        }

        // filter
        filteredNodes = (options && options.tags) ? this._filterNodesByTags(filteredNodes, options.tags) : filteredNodes;
        filteredNodes = (options && options.first) ? this._filterBlocksFirst(filteredNodes, options) : filteredNodes;

        return filteredNodes;
    },
    getElements: function(options)
    {
        var nodes = this.getNodes({ textnodes: false });
        var block = this.getBlock();
        nodes = (nodes.length === 0 && block) ? [block] : nodes;

        var filteredNodes = [];
        for (var i = 0; i < nodes.length; i++)
        {
            if (!this._isInNodesArray(filteredNodes, nodes[i]))
            {
                filteredNodes.push(nodes[i]);
            }
        }

        // filter
        filteredNodes = (options && options.tags) ? this._filterNodesByTags(filteredNodes, options.tags) : filteredNodes;

        return filteredNodes;
    },
    getNodes: function(options)
    {
        var nodes = [];
        var activeComponent = this.component.getActive();
        if (activeComponent)
        {
            nodes = this._getNodesComponent(activeComponent);
        }
        else if (this.isCollapsed())
        {
            var current = this.getCurrent();
            nodes = (current) ? [current] : [];
        }
        else if (this.is() && !activeComponent)
        {
            nodes = this._getRangeSelectedNodes();
        }

        // filter
        nodes = this._filterServicesNodes(nodes);
        nodes = this._filterEditor(nodes);

        // options
        nodes = (options && options.tags) ? this._filterNodesByTags(nodes, options.tags) : nodes;
        nodes = (options && options.textnodes) ? this._filterNodesTexts(nodes, options) : nodes;
        nodes = (options && !options.textnodes) ? this._filterNodesElements(nodes) : nodes;

        return nodes;
    },

    // text & html
    getText: function()
    {
        var sel = this.get();
        return (sel) ? this.utils.removeInvisibleChars(sel.toString()) : '';
    },
    getHtml: function(clean)
    {
        var html = '';
        var sel = this.get();
        if (sel)
        {
            var container = document.createElement('div');
            var len = sel.rangeCount;
            for (var i = 0; i < len; ++i)
            {
                container.appendChild(sel.getRangeAt(i).cloneContents());
            }

            html = container.innerHTML;
            html = (clean !== false) ? this.cleaner.output(html) : html;
            html = html.replace(/<p><\/p>$/i, '');
        }

        return html;
    },

    // clear
    clear: function()
    {
        this.component.clearActive();
        this.get().removeAllRanges();
    },

    // collapse
    collapseToStart: function()
    {
        var sel = this.get();
        if (sel && !sel.isCollapsed) sel.collapseToStart();
    },
    collapseToEnd: function()
    {
        var sel = this.get();
        if (sel && !sel.isCollapsed) sel.collapseToEnd();
    },

    // save
    saveActiveComponent: function()
    {
        var activeComponent = this.component.getActive();
        if (activeComponent)
        {
            this.savedComponent = activeComponent;
            return true;
        }

        return false;
    },
    restoreActiveComponent: function()
    {
        if (this.savedComponent)
        {
            this.component.setActive(this.savedComponent);
            return true;
        }

        return false;
    },
    save: function()
    {
        this._clearSaved();

        var el = this.getElement();
        var tags = ['TD', 'TH', 'P', 'DIV', 'PRE', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'LI', 'BLOCKQUOTE'];
        if (el && (tags.indexOf(el.tagName) !== -1) && (el.innerHTML === '' || el.innerHTML === '<br>'))
        {
            this.savedElement = el;
        }
        else if (!this.saveActiveComponent())
        {
            this.saved = this.offset.get();
        }
    },
    restore: function()
    {
        if (!this.saved && !this.savedComponent && !this.savedElement) return;

        this.editor.saveScroll();

        if (this.savedElement)
        {
            this.caret.setStart(this.savedElement);
        }
        else if (!this.restoreActiveComponent())
        {
            this.offset.set(this.saved);
        }

        this._clearSaved();
        this.editor.restoreScroll();
    },
    saveMarkers: function()
    {
        this._clearSaved();

        if (!this.saveActiveComponent())
        {
            this.marker.insert();
        }
    },
    restoreMarkers: function()
    {
        this.editor.saveScroll();

        if (!this.restoreActiveComponent())
        {
            this.marker.restore();
        }

        this._clearSaved();
        this.editor.restoreScroll();
    },

    // private
    _getNextNode: function(node)
    {
        if (node.hasChildNodes()) return node.firstChild;

        while (node && !node.nextSibling)
        {
            node = node.parentNode;
        }

        if (!node) return null;

        return node.nextSibling;
    },
    _getNodesComponent: function(component)
    {
        var current = this.getCurrent();
        var data = this.inspector.parse(current);

        return (data.isFigcaption()) ? [data.getFigcaption()] : [component];
    },
    _getRangeSelectedNodes: function()
    {
        var nodes = [];
        var range = this.getRange();
        var node = range.startContainer;
        var startNode = range.startContainer;
        var endNode = range.endContainer;
        var $editor = this.editor.getElement();

        // editor
        if (startNode === $editor.get() && this.isAll())
        {
            nodes = this.utils.getChildNodes($editor);
        }
        // single node
        else if (node == endNode)
        {
            nodes = [node];
        }
        else
        {
            while (node && node != endNode)
            {
                nodes.push(node = this._getNextNode(node));
            }

            node = range.startContainer;
            while (node && node != range.commonAncestorContainer)
            {
                nodes.unshift(node);
                node = node.parentNode;
            }
        }

        return nodes;
    },
    _isInNodesArray: function(nodes, node)
    {
        return (nodes.indexOf(node) !== -1);
    },
    _filterEditor: function(nodes)
    {
        var filteredNodes = [];
        for (var i = 0; i < nodes.length; i++)
        {
            var data = this.inspector.parse(nodes[i]);
            if (data.isInEditor())
            {
                filteredNodes.push(nodes[i]);
            }
        }

        return filteredNodes;
    },
    _filterServicesNodes: function(nodes)
    {
        var filteredNodes = [];
        for (var i = 0; i < nodes.length; i++)
        {
            var $el = $R.dom(nodes[i]);
            var skip = false;

            if (nodes[i] && nodes[i].nodeType === 3 && this.utils.isEmpty(nodes[i])) skip = true;
            if ($el.hasClass('redactor-script-tag')
                || $el.hasClass('redactor-component-caret')
                || $el.hasClass('redactor-selection-marker')
                || $el.hasClass('non-editable')) skip = true;

            if (!skip)
            {
                filteredNodes.push(nodes[i]);
            }
        }

        return filteredNodes;
    },
    _filterNodesTexts: function(nodes, options)
    {
        var filteredNodes = [];
        for (var i = 0; i < nodes.length; i++)
        {
            if (nodes[i].nodeType === 3 || (options.keepbr && nodes[i].tagName === 'BR'))
            {
                var inline = this.getInline(nodes[i]);
                var isInline = (inline && options && options.inline === false);
                if (!isInline)
                {
                    filteredNodes.push(nodes[i]);
                }
            }
        }

        return filteredNodes;
    },
    _filterNodesElements: function(nodes)
    {
        var filteredNodes = [];
        for (var i = 0; i < nodes.length; i++)
        {
            if (nodes[i].nodeType !== 3)
            {
                filteredNodes.push(nodes[i]);
            }
        }

        return filteredNodes;
    },
    _filterNodesByTags: function(nodes, tags, passtexts)
    {
        var filteredNodes = [];
        for (var i = 0; i < nodes.length; i++)
        {
            if (passtexts && nodes[i].nodeType === 3)
            {
                filteredNodes.push(nodes[i]);
            }
            else if (nodes[i].nodeType !== 3)
            {
                var nodeTag = nodes[i].tagName.toLowerCase();
                if (tags.indexOf(nodeTag.toLowerCase()) !== -1)
                {
                    filteredNodes.push(nodes[i]);
                }
            }
        }

        return filteredNodes;
    },
    _filterBlocksFirst: function(nodes)
    {
        var filteredNodes = [];
        for (var i = 0; i < nodes.length; i++)
        {
            var $node = $R.dom(nodes[i]);
            var parent = $node.parent().get();
            var isFirst = ($node.parent().hasClass('redactor-in'));
            var isCellParent = (parent && (parent.tagName === 'TD' || parent.tagName === 'TH'));
            if (isFirst || isCellParent)
            {
                filteredNodes.push(nodes[i]);
            }
        }

        return filteredNodes;
    },
    _filterInlinesInside: function(nodes)
    {
        var filteredNodes = [];
        for (var i = 0; i < nodes.length; i++)
        {
            if (containsNode(nodes[i], true))
            {
                filteredNodes.push(nodes[i]);
            }
        }

        return filteredNodes;
    },
    _isTextSelected: function(node, selected)
    {
        var text = this.utils.removeInvisibleChars(node.textContent);

        return (
            selected === text
            || text.search(selected) !== -1
            || selected.search(new RegExp('^' + this.utils.escapeRegExp(text))) !== -1
            || selected.search(new RegExp(this.utils.escapeRegExp(text) + '$')) !== -1
        );
    },
    _isInlineNode: function(node)
    {
        var data = this.inspector.parse(node);

        return (this.inspector.isInlineTag(node.tagName) && data.isInEditor());
    },
    _clearSaved: function()
    {
        this.saved = false;
        this.savedComponent = false;
        this.savedElement = false;
    }
});
$R.add('service', 'element', {
    init: function(app)
    {
        this.app = app;
        this.rootElement = app.rootElement;

        // local
        this.$element = {};
        this.type = 'inline';
    },
    start: function()
    {
        this._build();
        this._buildType();
    },

    // public
    isType: function(type)
    {
        return (type === this.type);
    },
    getType: function()
    {
        return this.type;
    },
    getElement: function()
    {
        return this.$element;
    },

    // private
    _build: function()
    {
        this.$element = $R.dom(this.rootElement);
    },
    _buildType: function()
    {
        var tag = this.$element.get().tagName;

        this.type = (tag === 'TEXTAREA') ? 'textarea' : this.type;
        this.type = (tag === 'DIV') ? 'div' : this.type;
        this.type = (this.opts.inline) ? 'inline' : this.type;
    }
});
$R.add('service', 'editor', {
    init: function(app)
    {
        this.app = app;

        // local
        this.scrolltop = false;
        this.pasting = false;
    },

    // start
    start: function()
    {
        this._build();
    },

    // focus
    focus: function()
    {
        if (!this.isFocus() && !this._isContenteditableFocus())
        {
            this.saveScroll();
            this.$editor.focus();
            this.restoreScroll();
        }
    },
    startFocus: function()
    {
        this.caret.setStart(this.getFirstNode());
    },
    endFocus: function()
    {
        this.caret.setEnd(this.getLastNode());
    },

    // pasting
    isPasting: function()
    {
        return this.pasting;
    },
    enablePasting: function()
    {
        this.pasting = true;
    },
    disablePasting: function()
    {
        this.pasting = false;
    },

    // scroll
    saveScroll: function()
    {
        this.scrolltop = this._getScrollTarget().scrollTop();
    },
    restoreScroll: function()
    {
        if (this.scrolltop !== false)
        {
            this._getScrollTarget().scrollTop(this.scrolltop);
            this.scrolltop = false;
        }
    },

    // non editables
    disableNonEditables: function()
    {
        this.$noneditables = this.$editor.find('[contenteditable=false]');
        this.$noneditables.attr('contenteditable', true);
    },
    enableNonEditables: function()
    {
        if (this.$noneditables)
        {
            setTimeout(function() { this.$noneditables.attr('contenteditable', false); }.bind(this), 1);
        }
    },

    // nodes
    getFirstNode: function()
    {
        return this.$editor.contents()[0];
    },
    getLastNode: function()
    {
        var nodes = this.$editor.contents();

        return nodes[nodes.length-1];
    },

    // utils
    isSourceMode: function()
    {
        var $source = this.source.getElement();

        return $source.hasClass('redactor-source-open');
    },
    isEditor: function(el)
    {
        var node = $R.dom(el).get();

        return (node === this.$editor.get());
    },
    isEmpty: function(keeplists)
    {
        return this.utils.isEmptyHtml(this.$editor.html(), false, keeplists);
    },
    isFocus: function()
    {
        var $active = $R.dom(document.activeElement);
        var isComponentSelected = (this.$editor.find('.redactor-component-active').length !== 0);

        return (isComponentSelected || $active.closest('.redactor-in-' + this.uuid).length !== 0);
    },
    setEmpty: function()
    {
        this.$editor.html(this.opts.emptyHtml);
    },

    // element
    getElement: function()
    {
        return this.$editor;
    },

    // private
    _build: function()
    {
        var $element = this.element.getElement();
        var editableElement = (this.element.isType('textarea')) ? '<div>' : $element.get();

        this.$editor = $R.dom(editableElement);
    },
    _getScrollTarget: function()
    {
        var $target = this.$doc;
        if (this.opts.toolbarFixedTarget !== document)
        {
            $target = $R.dom(this.opts.toolbarFixedTarget);
        }
        else
        {
            $target = (this.opts.scrollTarget) ? $R.dom(this.opts.scrollTarget) : $target;
        }

        return $target;
    },
    _isContenteditableFocus: function()
    {
        var block = this.selection.getBlock();
        var $blockParent = (block) ? $R.dom(block).closest('[contenteditable=true]').not('.redactor-in') : [];

        return ($blockParent.length !== 0);
    }
});
$R.add('service', 'container', {
    init: function(app)
    {
        this.app = app;
    },
    // public
    start: function()
    {
        this._build();
    },
    getElement: function()
    {
        return this.$container;
    },

    // private
    _build: function()
    {
        var tag = (this.element.isType('inline')) ? '<span>' : '<div>';
        this.$container = $R.dom(tag);
    }
});
$R.add('service', 'source', {
    init: function(app)
    {
        this.app = app;

        // local
        this.$source = {};
        this.content = '';
    },
    // public
    start: function()
    {
        this._build();
        this._buildName();
        this._buildStartedContent();
    },
    getElement: function()
    {
        return this.$source;
    },
    getCode: function()
    {
        return this.$source.val();
    },
    getName: function()
    {
        return this.$source.attr('name');
    },
    getStartedContent: function()
    {
        return this.content;
    },
    setCode: function(html)
    {
        return this.insertion.set(html, true, false);
    },
    isNameGenerated: function()
    {
        return (this.name);
    },
    rebuildStartedContent: function()
    {
        this._buildStartedContent();
    },

    // private
    _build: function()
    {
        var $element = this.element.getElement();
        var isTextarea = this.element.isType('textarea');
        var sourceElement = (isTextarea) ? $element.get() : '<textarea>';

        this.$source = $R.dom(sourceElement);
    },
    _buildName: function()
    {
        var $element = this.element.getElement();

        this.name = $element.attr('name');
        this.$source.attr('name', (this.name) ? this.name : 'content-' + this.uuid);
    },
    _buildStartedContent: function()
    {
        var $element = this.element.getElement();
        var content = (this.element.isType('textarea')) ? $element.val() : $element.html();

        this.content = content.trim();
    }
});
$R.add('service', 'statusbar', {
    init: function(app)
    {
        this.app = app;

        // local
        this.$statusbar = {};
        this.items = [];
    },
    // public
    start: function()
    {
        this.$statusbar = $R.dom('<ul>');
        this.$statusbar.attr('dir', this.opts.direction);
    },
    add: function(name, html)
    {
        return this.update(name, html);
    },
    update: function(name, html)
    {
        var $item;
        if (typeof this.items[name] !== 'undefined')
        {
            $item = this.items[name];
        }
        else
        {
            $item = $R.dom('<li>');
            this.$statusbar.append($item);
            this.items[name] = $item;
        }

        return $item.html(html);
    },
    get: function(name)
    {
        return (this.items[name]) ? this.items[name] : false;
    },
    remove: function(name)
    {
        if (this.items[name])
        {
            this.items[name].remove();
            delete this.items[name];
        }
    },
    getItems: function()
    {
        return this.items;
    },
    removeItems: function()
    {
        this.items = {};
        this.$statusbar.html('');
    },
    getElement: function()
    {
        return this.$statusbar;
    }
});
$R.add('service', 'toolbar', {
    init: function(app)
    {
        this.app = app;

        // local
        this.buttons = [];
        this.dropdownOpened = false;
        this.buttonsObservers = {};
    },
    // public
    start: function()
    {
        if (this.is())
        {
            this.opts.activeButtons = (this.opts.activeButtonsAdd) ? this._extendActiveButtons() : this.opts.activeButtons;
            this.create();
        }
    },
    stopObservers: function()
    {
        this.buttonsObservers = {};
    },
    create: function()
    {
        this.$wrapper = $R.dom('<div>');
        this.$toolbar = $R.dom('<div>');
    },
    observe: function()
    {
        if (!this.is()) return;

        this.setButtonsInactive();

        var button, observer;

        // observers
        for (var name in this.buttonsObservers)
        {
            observer = this.buttonsObservers[name];
            button = this.getButton(name);
            this.app.broadcast('button.' + observer + '.observe', button);
        }

        // inline buttons
        var buttons = this.opts.activeButtons;
        var inlines = this.selection.getInlinesAllSelected();
        var current = this.selection.getInline();
        if (this.selection.isCollapsed() && current)
        {
            inlines.push(current);
        }

        var tags = this._inlinesToTags(inlines);
        for (var key in buttons)
        {
            if (tags.indexOf(key) !== -1)
            {
                button = this.getButton(buttons[key]);
                if (button) {
                    button.setActive();
                }
            }

        }
    },

    // is
    is: function()
    {
        return !(!this.opts.toolbar || (this.detector.isMobile() && this.opts.air));
    },
    isAir: function()
    {
        return (this.is()) ? this.$toolbar.hasClass('redactor-air') : false;
    },
    isFixed: function()
    {
        return (this.is()) ? this.$toolbar.hasClass('redactor-toolbar-fixed') : false;
    },
    isContextBar: function()
    {
        var $bar = this.$body.find('#redactor-context-toolbar-' + this.uuid);
        return $bar.hasClass('open');
    },
    isTarget: function()
    {
        return (this.opts.toolbarFixedTarget !== document);
    },

    // get
    getElement: function()
    {
        return this.$toolbar;
    },
    getWrapper: function()
    {
        return this.$wrapper;
    },
    getDropdown: function()
    {
        return this.dropdownOpened;
    },
    getTargetElement: function()
    {
        return $R.dom(this.opts.toolbarFixedTarget);
    },
    getButton: function(name)
    {
        var $btn = this._findButton('.re-' + name);

        return ($btn.length !== 0) ? $btn.dataget('data-button-instance') : false;
    },
    getButtons: function()
    {
        var buttons = [];
        this._findButtons().each(function(node)
        {
            var $node = $R.dom(node);
            buttons.push($node.dataget('data-button-instance'));
        });

        return buttons;
    },
    getButtonsKeys: function()
    {
        var keys = [];
        this._findButtons().each(function(node)
        {
            var $node = $R.dom(node);
            keys.push($node.attr('data-re-name'));
        });

        return keys;
    },

    // add
    addButton: function(name, btnObj, position, $el, start)
    {
        position = position || 'end';

        var $button = $R.create('toolbar.button', this.app, name, btnObj);
        if (btnObj.observe)
        {
            this.opts.activeButtonsObservers[name] = { observe: btnObj.observe, button: $button };
        }

        if (this.is())
        {
            if (position === 'first') this.$toolbar.prepend($button);
            else if (position === 'after') $el.after($button);
            else if (position === 'before') $el.before($button);
            else this.$toolbar.append($button);
        }

        return $button;
    },
    addButtonFirst: function(name, btnObj)
    {
        return this.addButton(name, btnObj, 'first');
    },
    addButtonAfter: function(after, name, btnObj)
    {
        var $btn = this.getButton(after);

        return ($btn) ? this.addButton(name, btnObj, 'after', $btn) : this.addButton(name, btnObj);
    },
    addButtonBefore: function(before, name, btnObj)
    {
        var $btn = this.getButton(before);

        return ($btn) ? this.addButton(name, btnObj, 'before', $btn) : this.addButton(name, btnObj);
    },
    addButtonObserver: function(name, observer)
    {
        this.buttonsObservers[name] = observer;
    },

    // set
    setButtons: function(buttons)
    {
        this.buttons = buttons;
    },
    setDropdown: function(dropdown)
    {
        this.dropdownOpened = dropdown;
    },
    setButtonsInactive: function()
    {
        var $buttons = this.getButtons();
        for (var i = 0; i < $buttons.length; i++)
        {
            $buttons[i].setInactive();
        }
    },
    setButtonsActive: function()
    {
        var $buttons = this.getButtons();
        for (var i = 0; i < $buttons.length; i++)
        {
            $buttons[i].setActive();
        }
    },

    // disable & enable
    disableButtons: function()
    {
        var $buttons = this.getButtons();
        for (var i = 0; i < $buttons.length; i++)
        {
            $buttons[i].disable();
        }
    },
    enableButtons: function()
    {
        var $buttons = this.getButtons();
        for (var i = 0; i < $buttons.length; i++)
        {
            $buttons[i].enable();
        }

    },

    // private
    _findButton: function(selector)
    {
        return (this.is()) ? this.$toolbar.find(selector) : $R.dom();
    },
    _findButtons: function()
    {
        return (this.is()) ? this.$toolbar.find('.re-button') : $R.dom();
    },
    _extendActiveButtons: function()
    {
        return $R.extend({}, this.opts.activeButtons, this.opts.activeButtonsAdd);
    },
    _inlinesToTags: function(inlines)
    {
        var tags = [];
        for (var i = 0; i < inlines.length; i++)
        {
            tags.push(inlines[i].tagName.toLowerCase());
        }

        return tags;
    }
});
$R.add('class', 'toolbar.button', {
    mixins: ['dom'],
    init: function(app, name, btnObj)
    {
        this.app = app;
        this.opts = app.opts;
        this.lang = app.lang;
        this.$body = app.$body;
        this.toolbar = app.toolbar;
        this.detector = app.detector;

        // local
        this.obj = btnObj;
        this.name = name;
        this.dropdown = false;
        this.tooltip = false;

        // init
        this._init();
    },
    // is
    isActive: function()
    {
        return this.hasClass('redactor-button-active');
    },
    isDisabled: function()
    {
        return this.hasClass('redactor-button-disabled');
    },

    // has
    hasIcon: function()
    {
        return (this.obj.icon && !this.opts.buttonsTextLabeled);
    },

    // set
    setDropdown: function(dropdown)
    {
        this.obj.dropdown = dropdown;
        this.obj.message = false;
        this.dropdown = $R.create('toolbar.dropdown', this.app, this.name, this.obj.dropdown);
        this.attr('data-dropdown', true);
    },
    setMessage: function(message, args)
    {
        this.obj.message = message;
        this.obj.args = args;
        this.obj.dropdown = false;
    },
    setApi: function(api, args)
    {
        this.obj.api = api;
        this.obj.args = args;
        this.obj.dropdown = false;
    },
    setTitle: function(title)
    {
        this.obj.title = this.lang.parse(title);
        this.obj.tooltip = this.obj.title;

        this.attr({ 'alt': this.obj.tooltip, 'aria-label': this.obj.tooltip });
        if (!this.attr('data-re-icon')) this.html(this.obj.title);
    },
    setTooltip: function(tooltip)
    {
        this.obj.tooltip = this.lang.parse(tooltip);
        this.attr({ 'alt': this.obj.tooltip, 'aria-label': this.obj.tooltip });
    },
    setIcon: function(icon)
    {
        if (this.opts.buttonsTextLabeled) return;

        this.obj.icon = true;
        this.$icon = $R.dom(icon);

        this.html('');
        this.append(this.$icon);
        this.attr('data-re-icon', true);
        this.addClass('re-button-icon');
        this.setTooltip(this.obj.title);
        this._buildTooltip();
    },
    setActive: function()
    {
        this.addClass('redactor-button-active');
    },
    setInactive: function()
    {
        this.removeClass('redactor-button-active');
    },

    // hide
    hideTooltip: function()
    {
        this.$body.find('.re-button-tooltip').remove();
    },

    // get
    getDropdown: function()
    {
        return this.dropdown;
    },

    // enable & disable
    disable: function()
    {
        this.addClass('redactor-button-disabled');
    },
    enable: function()
    {
        this.removeClass('redactor-button-disabled');
    },

    // toggle
    toggle: function(e)
    {
        if (e) e.preventDefault();
        if (this.isDisabled()) return;

        if (this.obj.dropdown)
        {
            this.dropdown.toggle(e);
        }
        else if (this.obj.api)
        {
            // broadcast
            this.app.api(this.obj.api, this.obj.args, this.name);
        }
        else if (this.obj.message)
        {
            // broadcast
            this.app.broadcast(this.obj.message, this.obj.args, this.name);
        }

        this.hideTooltip();
    },

    // private
    _init: function()
    {
        // parse
        this._parseTitle();
        this._parseTooltip();

        // build
        this._build();
        this._buildCallback();
        this._buildAttributes();
        this._buildObserver();

        if (this.hasIcon())
        {
            this._buildIcon();
            this._buildTooltip();
        }
        else
        {
            this.html(this.obj.title);
        }
    },
    _parseTooltip: function()
    {
        this.obj.tooltip = (this.obj.tooltip) ? this.lang.parse(this.obj.tooltip) : this.obj.title;
    },
    _parseTitle: function()
    {
        this.obj.title = this.lang.parse(this.obj.title);
    },
    _build: function()
    {
        this.parse('<a>');
        this.addClass('re-button re-' + this.name);
        this.attr('data-re-name', this.name);
        this.dataset('data-button-instance', this);

        if (this.obj.dropdown) this.setDropdown(this.obj.dropdown);
    },
    _buildCallback: function()
    {
        this.on('click', this.toggle.bind(this));
    },
    _buildAttributes: function()
    {
        var attrs = {
            'href': '#',
            'alt': this.obj.tooltip,
            'rel': this.name,
            'role': 'button',
            'aria-label': this.obj.tooltip,
            'tabindex': '-1'
        };

        this.attr(attrs);
    },
    _buildObserver: function()
    {
        if (typeof this.obj.observe !== 'undefined')
        {
            this.toolbar.addButtonObserver(this.name, this.obj.observe);
        }
    },
    _buildIcon: function()
    {
        var icon = this.obj.icon;
        var isHtml = (/(<([^>]+)>)/ig.test(icon));

        this.$icon = (isHtml) ? $R.dom(icon) : $R.dom('<i>');
        if (!isHtml) this.$icon.addClass('re-icon-' + this.name);

        this.append(this.$icon);
        this.attr('data-re-icon', true);
        this.addClass('re-button-icon');
    },
    _buildTooltip: function()
    {
        if (this.detector.isDesktop())
        {
            this.tooltip = $R.create('toolbar.button.tooltip', this.app, this);
        }
    }
});
$R.add('class', 'toolbar.button.tooltip', {
    mixins: ['dom'],
    init: function(app, $button)
    {
        this.app = app;
        this.uuid = app.uuid;
        this.opts = app.opts;
        this.$body = app.$body;
        this.toolbar = app.toolbar;

        // local
        this.$button = $button;
        this.created = false;

        // init
        this._init();
    },
    open: function()
    {
        if (this.$button.hasClass('redactor-button-disabled') || this.$button.hasClass('redactor-button-active')) return;

        this.created = true;
        this.parse('<span>');
        this.addClass('re-button-tooltip re-button-tooltip-' + this.uuid);
        this.$body.append(this);
        this.html(this.$button.attr('alt'));

        var offset = this.$button.offset();
        var position = 'absolute';
        var height = this.$button.height();
        var width = this.$button.width();
        var arrowOffset = 4;

        this.css({
            top: (offset.top + height + arrowOffset) + 'px',
            left: (offset.left + width/2 - this.width()/2) + 'px',
            position: position
        });

        this.show();
    },
    close: function()
    {
        if (!this.created || this.$button.hasClass('redactor-button-disabled')) return;

        this.remove();
        this.created = false;
    },

    // private
    _init: function()
    {
        this.$button.on('mouseover', this.open.bind(this));
        this.$button.on('mouseout', this.close.bind(this));
    }
});
$R.add('class', 'toolbar.dropdown', {
    mixins: ['dom'],
    init: function(app, name, items)
    {
        this.app = app;
        this.uuid = app.uuid;
        this.opts = app.opts;
        this.$win = app.$win;
        this.$doc = app.$doc;
        this.$body = app.$body;
        this.animate = app.animate;
        this.toolbar = app.toolbar;

        // local
        this.name = name;
        this.started = false;
        this.items = (name === 'format') ? $R.extend({}, true, items) : items;
        this.$items = [];
    },
    // public
    toggle: function(e)
    {
        if (!this.started)
        {
            this._build();
        }

        // toggle
        if (this.isOpened() && this.isActive())
        {
            this.close(false);
        }
        else
        {
            this.open(e);
        }
    },
    isOpened: function()
    {
        var $dropdown = this.$body.find('.redactor-dropdown-' + this.uuid + '.open');

        return ($dropdown.length !== 0 && $dropdown.attr('data-re-name') === this.name);
    },
    isActive: function()
    {
        var $dropdown = this.$body.find('#redactor-dropdown-' + this.uuid + '-' + this.name + '.open');
        return ($dropdown.length !== 0);
    },
    getName: function()
    {
        return this.attr('data-re-name');
    },
    getItem: function(name)
    {
        return this.$items[name];
    },
    getItemsByClass: function(classname)
    {
        var result = [];
        for (var key in this.$items)
        {
            if (typeof this.$items[key] === 'object' && this.$items[key].dom && this.$items[key].hasClass(classname))
            {
                result.push(this.$items[key]);
            }
        }

        return result;
    },
    open: function(e)
    {
        this._closeAll();

        this.$btn = this.toolbar.getButton(this.name);
        this.app.broadcast('dropdown.open', e, this, this.$btn);
        this.toolbar.setDropdown(this);

        this.show();
        this.removeClass('redactor-animate-hide');
        this.addClass('open');
        this._observe();

        this.$btn.hideTooltip();
        this.$btn.setActive();

        this.$doc.on('keyup.redactor.dropdown-' + this.uuid, this._handleKeyboard.bind(this));
        this.$doc.on('click.redactor.dropdown-' + this.uuid, this.close.bind(this));

        this.updatePosition();
        this.app.broadcast('dropdown.opened', e, this, this.$btn);

    },
    close: function(e, animate)
    {
        if (e)
        {
            var $el = $R.dom(e.target);
            if (this._isButton(e) || $el.hasClass('redactor-dropdown-not-close') || $el.hasClass('redactor-dropdown-item-disabled'))
            {
                e.preventDefault();
                return;
            }
        }

        this.app.broadcast('dropdown.close', this, this.$btn);
        this.toolbar.setDropdown(false);

        this.$btn.setInactive();
        if (animate === false)
        {
            this._close();
        }
        else
        {
            this.animate.start(this, 'fadeOut', this._close.bind(this));
        }
    },
    updatePosition: function()
    {
        var isFixed = this.toolbar.isFixed();
        var isTarget = this.toolbar.isTarget();

        var btnHeight = this.$btn.height();
        var btnWidth = this.$btn.width();

        var pos = this.$btn.offset();
        var position = 'absolute';
        var topOffset = 2;

        if (isFixed) {
            pos.top = (isTarget) ? this.$btn.offset().top : this.$btn.position().top;
            position = 'fixed';
            topOffset = topOffset + this.opts.toolbarFixedTopOffset;
        }


        var leftOffset = 0;
        var left = (pos.left + leftOffset);
        var width = parseFloat(this.css('width'));
        var winWidth = this.$win.width();
        var leftFix = (winWidth < (left + width)) ? (width - btnWidth) : 0;
        var leftPos = (left - leftFix);
        var top = (pos.top + btnHeight + topOffset);
        leftPos = (leftPos < 0) ? 4 : leftPos;

        this.css({
            maxHeight: '',
            position: position,
            top: top + 'px',
            left: leftPos + 'px'
        });

        // height adaptive
        var heightTolerance = 10;
        var winHeight = this.$win.height();
        var scrollTop = this.$doc.scrollTop();
        var cropHeight = winHeight - (top - scrollTop) - heightTolerance;

        this.css('max-height', cropHeight + 'px');
    },

    // private
    _build: function()
    {
        this.parse('<div>');
        this.attr('dir', this.opts.direction);
        this.attr('id', 'redactor-dropdown-' + this.uuid + '-' + this.name);
        this.attr('data-re-name', this.name);

        this.addClass('redactor-dropdown redactor-dropdown-' + this.uuid + ' redactor-dropdown-' + this.name);
        this.dataset('data-dropdown-instance', this);
        var isDom = (this.items.sdom || typeof this.items === 'string');

        if (isDom) this._buildDom();
        else this._buildItems();

        this.$body.append(this);
        this.started = true;
    },
    _buildDom: function()
    {
        this.html('').append($R.dom(this.items));
    },
    _buildItems: function()
    {
        this.items = (this.name === 'format') ? this._buildFormattingItems() : this.items;

        for (var key in this.items)
        {
            var obj = this.items[key];

            if (key === 'observe')
            {
                this.attr('data-observe', this.items[key]);
            }
            else
            {
                var $item = $R.create('toolbar.dropdown.item', this.app, key, obj, this);

                this.$items[key] = $item;
                this.append($item);
            }
        }
    },
    _buildFormattingItems: function()
    {
        // build the format set
        for (var key in this.items)
        {
            if (this.opts.formatting.indexOf(key) === -1) delete this.items[key];
        }

        // remove from the format set
        if (this.opts.formattingHide)
        {
            for (var key in this.items)
            {
                if (this.opts.formattingHide.indexOf(key) !== -1) delete this.items[key];
            }
        }

        // add to the format set
        if (this.opts.formattingAdd)
        {
            for (var key in this.opts.formattingAdd)
            {
                this.items[key] = this.opts.formattingAdd[key];
            }
        }

        return this.items;
    },
    _handleKeyboard: function(e)
    {
        if (e.which === 27) this.close();
    },
    _isButton: function(e)
    {
        var $el = $R.dom(e.target);
        var $btn = $el.closest('.re-button');

        return ($btn.get() === this.$btn.get());
    },
    _close: function()
    {
        this.$btn.setInactive();
        this.$doc.off('.redactor.dropdown-' + this.uuid);
        this.removeClass('open');
        this.addClass('redactor-animate-hide');
        this.app.broadcast('dropdown.closed', this, this.$btn);
    },
    _closeAll: function()
    {
        this.$body.find('.redactor-dropdown-' + this.uuid + '.open').each(function(node)
        {
            var $node = $R.dom(node);
            var instance =  $node.dataget('data-dropdown-instance');
            instance._close();
        });
    },
    _observe: function()
    {
        var observer = this.attr('data-observe');
        if (observer)
        {
            this.app.broadcast('dropdown.' + observer + '.observe', this);
        }
    }
});
$R.add('class', 'toolbar.dropdown.item', {
    mixins: ['dom'],
    init: function(app, name, obj, dropdown)
    {
        this.app = app;
        this.lang = app.lang;

        // local
        this.dropdown = dropdown;
        this.name = name;
        this.obj = obj;

        // init
        this._init();
    },
    setTitle: function(html)
    {
        this.$span.html(html);
    },
    getTitle: function()
    {
        return this.$span.html();
    },
    enable: function()
    {
        this.removeClass('redactor-dropdown-item-disabled');
    },
    disable: function()
    {
        this.addClass('redactor-dropdown-item-disabled');
    },
    toggle: function(e)
    {
        if (e) e.preventDefault();
        if (this.hasClass('redactor-dropdown-item-disabled')) return;

        if (this.obj.message)
        {
            // broadcast
            this.app.broadcast(this.obj.message, this.obj.args, this.name);
        }
        else if (this.obj.api)
        {
            this.app.api(this.obj.api, this.obj.args, this.name);
        }
    },

    // private
    _init: function()
    {
        this.parse('<a>');
        this.attr('href', '#');
        this.addClass('redactor-dropdown-item-' + this.name);

        if (this.obj.classname)
        {
            this.addClass(this.obj.classname);
        }

        this.attr('data-re-name', this.name);
        this.on('click', this.toggle.bind(this));

        this.$span = $R.dom('<span>');
        this.append(this.$span);
        this.setTitle(this.lang.parse(this.obj.title));
    }
});
$R.add('service', 'cleaner', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;

        // local
        this.storedComponents = [];
        this.storedImages = [];
        this.storedLinks = [];
        this.deniedTags = ['font', 'html', 'head', 'link', 'title', 'body', 'meta', 'applet'];
        this.convertRules = {};
        this.unconvertRules = {};

        // regex
        this.reComments = /<!--[\s\S]*?-->/g;
        this.reSpacedEmpty = /^(||\s||<br\s?\/?>||&nbsp;)$/i;
        this.reScriptTag = /<script(.*?[^>]?)>([\w\W]*?)<\/script>/gi;
    },
    // public
    addConvertRules: function(name, func)
    {
        this.convertRules[name] = func;
    },
    addUnconvertRules: function(name, func)
    {
        this.unconvertRules[name] = func;
    },
    input: function(html, paragraphize, started)
    {
        // pre/code
        html = this.encodePreCode(html);

        // converting entity
        html = html.replace(/\$/g, '&#36;');
        html = html.replace(/&amp;/g, '&');

        // convert to figure
        var converter = $R.create('cleaner.figure', this.app);
        html = converter.convert(html, this.convertRules);

        // store components
        html = this.storeComponents(html);

        // clean
        html = this.replaceTags(html, this.opts.replaceTags);
        html = this._setSpanAttr(html);
        html = this._setStyleCache(html);
        html = this.removeTags(html, this.deniedTags);
        html = (this.opts.removeScript) ? this._removeScriptTag(html) : this._replaceScriptTag(html);
        //html = (this.opts.removeScript) ? this._removeScriptTag(html) : html;
        html = (this.opts.removeComments) ? this.removeComments(html) : html;
        html = (this._isSpacedEmpty(html)) ? this.opts.emptyHtml : html;

        // restore components
        html = this.restoreComponents(html);

        // clear wrapped components
        html = this._cleanWrapped(html);

        // remove image attributes
        var $wrapper = this.utils.buildWrapper(html);
        var imageattrs = ['alt', 'title', 'src', 'class', 'width', 'height', 'srcset'];
        $wrapper.find('img').each(function(node) {
            if (node.attributes.length > 0) {
                var attrs = node.attributes;
                for (var i = attrs.length - 1; i >= 0; i--) {
                    if (attrs[i].name.search(/^data\-/) === -1 && imageattrs.indexOf(attrs[i].name) === -1) {
                        node.removeAttribute(attrs[i].name);
                    }
                }
            }
        });

        // get wrapper html
        html = this.utils.getWrapperHtml($wrapper);

        // paragraphize
        html = (paragraphize) ? this.paragraphize(html) : html;

        return html;
    },
    output: function(html, removeMarkers)
    {
        html = this.removeInvisibleSpaces(html);

        html = html.replace(/&#36;/g, '$');

        // empty
        if (this._isSpacedEmpty(html)) return '';
        if (this._isParagraphEmpty(html)) return '';

        html = this.removeServiceTagsAndAttrs(html, removeMarkers);

        // store components
        html = this.storeComponents(html);

        html = this.removeSpanWithoutAttributes(html);
        html = this.removeFirstBlockBreaklineInHtml(html);

        html = (this.opts.removeScript) ? html : this._unreplaceScriptTag(html);
        html = (this.opts.preClass) ? this._setPreClass(html) : html;
        html = (this.opts.linkNofollow) ? this._setLinkNofollow(html) : html;
        html = (this.opts.removeNewLines) ? this.cleanNewLines(html) : html;

        // restore components
        html = this.restoreComponents(html);

        // convert to figure
        var converter = $R.create('cleaner.figure', this.app);
        html = converter.unconvert(html, this.unconvertRules);

        // final clean up
        html = this.removeEmptyAttributes(html, ['style', 'class', 'rel', 'alt', 'title']);
        html = this.cleanSpacesInPre(html);
        html = this.tidy(html);

        // converting entity
        html = html.replace(/&amp;/g, '&');

        // breakline tidy
        if (this.opts.breakline) {
            html = html.replace(/<br\s?\/?>/gi, "<br>\n");
            html = html.replace(/<br\s?\/?>\n+/gi, "<br>\n");
        }

        // check whitespaces
        html = (html.replace(/\n/g, '') === '') ? '' : html;

        return html;
    },
    paste: function(html)
    {

        /**
         * PRD-2048: Ensures any HTML-encoded tag characters are explicitly
         * decoded before stripping tags
         */
        var entityTokens = [
            [ '&lt;', '<' ],
            [ '&LT;', '<' ],
            [ '&gt;', '>' ],
            [ '&GT;', '>' ]
        ];

        entityTokens.forEach(function replaceEntityToken(token) {
            var encodedToken = token[0];
            var replacementToken = token[1];

            html = html.replace(encodedToken, replacementToken);
        });

        /**
         * PRD-1703: Address XSS concern by scrubbing non-whitelisted tags
         * (including all multimedia-based tags with an onerror handler) before
         * invoking #storeComponents, which injects and evaluates the tags
         * within a div node in memory
         */
        var exceptedTags = this.opts.pasteBlockTags.concat(this.opts.pasteInlineTags);
        html = this.removeTagsExcept(html, exceptedTags);

        // store components
        html = this.storeComponents(html);

        // remove tags
        var deniedTags = this.deniedTags.concat(['iframe']);
        html = this.removeTags(html, deniedTags);

        // remove doctype tag
        html = html.replace(new RegExp("<\!doctype([\\s\\S]+?)>", 'gi'), '');

        // remove style tag
        html = html.replace(new RegExp("<style([\\s\\S]+?)</style>", 'gi'), '');

        // remove br between
        html = html.replace(new RegExp("</p><br /><p", 'gi'), '</p><p');

        // gdocs & word
        var isMsWord = this._isHtmlMsWord(html);

        html = this._cleanGDocs(html);
        html = (isMsWord) ? this._cleanMsWord(html) : html;

        // do not clean
        if (!this.opts.pasteClean)
        {
            // restore components
            html = this.restoreComponents(html);

            return html;
        }

        // plain text
        if (this.opts.pastePlainText)
        {
            // restore components
            html = this.restoreComponents(html);

            return this.pastePlainText(html);
        }

        // links & images
        html = (this.opts.pasteLinks) ? html : this.removeTags(html, ['a']);
        html = (this.opts.pasteImages) ? html : this.removeTags(html, ['img']);

        // build wrapper
        var $wrapper = this.utils.buildWrapper(html);

        // clean attrs
        var $elms = $wrapper.find('*');

        // remove style
        var filterStyle = (this.opts.pasteKeepStyle.length !== 0) ? ',' + this.opts.pasteKeepStyle.join(',') : '';
        $elms.not('[data-redactor-style-cache]' + filterStyle).removeAttr('style');

        // remove class
        var filterClass = (this.opts.pasteKeepClass.length !== 0) ? ',' + this.opts.pasteKeepClass.join(',') : '';
        $elms.not('[data-redactor-style-cache], span.redactor-component' + filterClass).removeAttr('class');

        // remove attrs
        var filterAttrs = (this.opts.pasteKeepAttrs.length !== 0) ? ',' + this.opts.pasteKeepAttrs.join(',') : '';
        $elms.not('img, a, span.redactor-component, [data-redactor-style-cache]' + filterAttrs).each(function(node)
        {
            var attrs = node.attributes;
            for (var i = attrs.length - 1; i >= 0; i--) {
                if (node.attributes[0].name !== 'class') {
                    node.removeAttribute(attrs[i].name);
                }
            }
        });

        // paste link target
        if (this.opts.pasteLinks && this.opts.pasteLinkTarget !== false)
        {
            $wrapper.find('a').attr('target', this.opts.pasteLinkTarget);
        }

        // keep style
        $wrapper.find('[data-redactor-style-cache]').each(function(node)
        {
            var style = node.getAttribute('data-redactor-style-cache');
            node.setAttribute('style', style);
        });

        // remove image attributes
        var imageattrs = this.opts.imageAttrs;
        $wrapper.find('img').each(function(node) {
            if (node.attributes.length > 0) {
                var attrs = node.attributes;
                for (var i = attrs.length - 1; i >= 0; i--) {
                    if (imageattrs.indexOf(attrs[i].name) === -1) {
                        node.removeAttribute(attrs[i].name);
                    }
                }
            }
        });

        // remove empty span
        $wrapper.find('span').each(function(node)
        {
            if (node.attributes.length === 0)
            {
                $R.dom(node).unwrap();
            }
        });

        // remove empty inline
        $wrapper.find(this.opts.inlineTags.join(',')).each(function(node)
        {
            if (node.attributes.length === 0 && this.utils.isEmptyHtml(node.innerHTML))
            {
                $R.dom(node).unwrap();
            }

        }.bind(this));

        // place ul/ol into li
        $wrapper.find('ul, ol').each(function(node)
        {
            var prev = node.previousSibling;
            if (prev && prev.tagName === 'LI')
            {
                var $li = $R.dom(prev);
                $li.find('p').unwrap();
                $li.append(node);
            }
        });

        // get wrapper
        html = this.utils.getWrapperHtml($wrapper);

        // remove paragraphs form lists (google docs bug)
        html = html.replace(/<li><p>/gi, '<li>');
        html = html.replace(/<\/p><\/li>/gi, '</li>');

        // convert lines to br
        if (this.opts.breakline) {
            html = html.replace(/\n/g, '<br>');
        }

        // clean empty p
        html = html.replace(/<p>&nbsp;<\/p>/gi, '<p></p>');
        html = html.replace(/<p><br\s?\/?><\/p>/gi, '<p></p>');

        if (isMsWord)
        {
            html = html.replace(/<p><\/p>/gi, '');
            html = html.replace(/<p>\s<\/p>/gi, '');
        }

        // restore components
        html = this.restoreComponents(html);

        return html;
    },
    pastePlainText: function(html)
    {
        html = (this.opts.pasteLinks) ? this.storeLinks(html) : html;
        html = (this.opts.pasteImages) ? this.storeImages(html) : html;

        html = this.getPlainText(html);
        html = this._replaceNlToBr(html);

        html = (this.opts.pasteLinks) ? this.restoreLinks(html) : html;
        html = (this.opts.pasteImages) ? this.restoreImages(html) : html;

        return html;
    },
    tidy: function(html)
    {
        return html;
    },
    paragraphize: function(html)
    {
        var paragraphize = $R.create('cleaner.paragraphize', this.app);
        html = paragraphize.convert(html);
        return html;
    },

    // get
    getFlatText: function(html)
    {
        var $div = $R.dom('<div>');

        if (!html.nodeType && !html.dom)
        {
            html = html.toString();
            html = html.trim();
            $div.html(html);
        }
        else
        {
            $div.append(html);
        }

        html = $div.get().textContent || $div.get().innerText || '';

        return (html === undefined) ? '' : html;
    },
    getPlainText: function(html)
    {
        html = html.replace(/<!--[\s\S]*?-->/gi, '');
        html = html.replace(/<style[\s\S]*?style>/gi, '');
        html = html.replace(/<p><\/p>/g, '');
        html = html.replace(/<\/div>|<\/li>|<\/td>/gi, '\n');
        html = html.replace(/<\/p>/gi, '\n\n');
        html = html.replace(/<\/H[1-6]>/gi, '\n\n');

        var tmp = document.createElement('div');
        tmp.innerHTML = html;

        html = tmp.textContent || tmp.innerText;

        return html.trim();
    },

    // replace
    replaceTags: function(html, tags)
    {
        if (tags)
        {
            var self = this;
            var keys = Object.keys(tags);
            var $wrapper = this.utils.buildWrapper(html);
            $wrapper.find(keys.join(',')).each(function(node)
            {
                self.utils.replaceToTag(node, tags[node.tagName.toLowerCase()]);
            });

            html = this.utils.getWrapperHtml($wrapper);
        }

        return html;
    },
    replaceNbspToSpaces: function(html)
    {
        return html.replace('&nbsp;', ' ');
    },
    replaceBlocksToBr: function(html)
    {
        html = html.replace(/<\/div>|<\/li>|<\/td>|<\/p>|<\/H[1-6]>/gi, '<br>');

        return html;
    },

    // clean
    cleanNewLines: function(html)
    {
        return html.replace(/\r?\n/g, "");
    },
    cleanSpacesInPre: function(html)
    {
        return html.replace('&nbsp;&nbsp;&nbsp;&nbsp;', '    ');
    },

    // remove
    removeInvisibleSpaces: function(html)
    {
        html = this.utils.removeInvisibleChars(html);
        html = html.replace(/&#65279;/gi, '');

        return html;
    },
    removeNl: function(html)
    {
        html = html.replace(/\n/g, " ");
        html = html.replace(/\s+/g, "\s");

        return html;
    },
    removeBrAtEnd: function(html)
    {
        html = html.replace(/<br\s?\/?>$/gi, ' ');
        html = html.replace(/<br\s?\/?><li/gi, '<li');

        return html;
    },
    removeTags: function(input, denied)
    {
        var re = (denied) ? /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi : /(<([^>]+)>)/gi;
        var replacer = (!denied) ? '' : function ($0, $1)
        {
            return denied.indexOf($1.toLowerCase()) === -1 ? $0 : '';
        };

        return input.replace(re, replacer);
    },
    removeTagsExcept: function(input, except)
    {
        if (except === undefined) return input.replace(/(<([^>]+)>)/gi, '');

        var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;
        return input.replace(tags, function($0, $1)
        {
            return except.indexOf($1.toLowerCase()) === -1 ? '' : $0;
        });
    },
    removeComments: function(html)
    {
        return html.replace(this.reComments, '');
    },
    removeServiceTagsAndAttrs: function(html, removeMarkers)
    {
        var $wrapper = this.utils.buildWrapper(html);
        var self = this;
        if (removeMarkers !== false)
        {
            $wrapper.find('.redactor-selection-marker').each(function(node)
            {
                var $el = $R.dom(node);
                var text = self.utils.removeInvisibleChars($el.text());

                return (text === '') ? $el.remove() : $el.unwrap();
            });
        }

        $wrapper.find('[data-redactor-style-cache]').removeAttr('data-redactor-style-cache');

        return this.utils.getWrapperHtml($wrapper);
    },
    removeSpanWithoutAttributes: function(html)
    {
        var $wrapper = this.utils.buildWrapper(html);
        $wrapper.find('span').removeAttr('data-redactor-span data-redactor-style-cache').each(function(node)
        {
            if (node.attributes.length === 0) $R.dom(node).unwrap();
        });

        return this.utils.getWrapperHtml($wrapper);
    },
    removeFirstBlockBreaklineInHtml: function(html)
    {
        return html.replace(new RegExp('</li><br\\s?/?>', 'gi'), '</li>');
    },
    removeEmptyAttributes: function(html, attrs)
    {
        var $wrapper = this.utils.buildWrapper(html);
        for (var i = 0; i < attrs.length; i++)
        {
            $wrapper.find('[' + attrs[i] + '=""]').removeAttr(attrs[i]);
        }

        return this.utils.getWrapperHtml($wrapper);
    },

    // encode / decode
    encodeHtml: function(html)
    {
        html = html.replace(/<br\s?\/?>/g, "\n");
        html = html.replace(/&nbsp;/g, ' ');
        html = html.replace(/”/g, '"');
        html = html.replace(/“/g, '"');
        html = html.replace(/‘/g, '\'');
        html = html.replace(/’/g, '\'');
        html = this.encodeEntities(html);
        html = html.replace(/\$/g, '&#36;');

        if (this.opts.preSpaces)
        {
            html = html.replace(/\t/g, new Array(this.opts.preSpaces + 1).join(' '));
        }

        return html;
    },
    encodePreCode: function(html)
    {
        var matched = html.match(new RegExp('<code(.*?)>(.*?)<pre(.*?)>(.*?)</pre>(.*?)</code>', 'gi'));
        if (matched !== null)
        {
            for (var i = 0; i < matched.length; i++)
            {
                var arr = matched[i].match(new RegExp('<pre(.*?)>([\\w\\W]*?)</pre>', 'i'));
                html = html.replace(arr[0], this.encodeEntities(arr[0]));
            }
        }

        var $wrapper = this.utils.buildWrapper(html);

        $wrapper.find('code code').replaceWith(this._encodeOuter.bind(this));
        $wrapper.find('code pre').replaceWith(this._encodeOuter.bind(this));
        $wrapper.find('pre pre').replaceWith(this._encodeOuter.bind(this));
        $wrapper.find('code, pre').each(this._encodePreCodeLine.bind(this));

        html = this.utils.getWrapperHtml($wrapper);

        // restore markers
        html = this._decodeMarkers(html);

        return html;
    },
    encodeEntities: function(str)
    {
        str = this.decodeEntities(str);
        str = str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

        return str;
    },
    encodePhpCode: function(html)
    {
        html = html.replace('<?php', '&lt;?php');
        html = html.replace('<?', '&lt;?');
        html = html.replace('?>', '?&gt;');

        return html;
    },
    decodeEntities: function(str)
    {
        return String(str).replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&amp;/g, '&');
    },

    // store / restore
    storeComponents: function(html)
    {
        var matched = this.utils.getElementsFromHtml(html, 'figure', 'table');

        return this._storeMatched(html, matched, 'Components', 'figure');
    },
    restoreComponents: function(html)
    {
        return this._restoreMatched(html, 'Components', 'figure');
    },
    storeLinks: function(html)
    {
        var matched = this.utils.getElementsFromHtml(html, 'a');

        return this._storeMatched(html, matched, 'Links', 'a');
    },
    storeImages: function(html)
    {
        var matched = this.utils.getElementsFromHtml(html, 'img');

        return this._storeMatched(html, matched, 'Images', 'img');
    },
    restoreLinks: function(html)
    {
        return this._restoreMatched(html, 'Links', 'a');
    },
    restoreImages: function(html)
    {
        return this._restoreMatched(html, 'Images', 'img');
    },

    // PRIVATE

    // clean
    _cleanWrapped: function(html)
    {
        html = html.replace(new RegExp('<p><figure([\\w\\W]*?)</figure></p>', 'gi'), '<figure$1</figure>');

        return html;
    },
    _cleanGDocs: function(html)
    {
        // remove google docs markers
        html = html.replace(/<b\sid="internal-source-marker(.*?)">([\w\W]*?)<\/b>/gi, "$2");
        html = html.replace(/<b(.*?)id="docs-internal-guid(.*?)">([\w\W]*?)<\/b>/gi, "$3");

        html = html.replace(/<span[^>]*(font-style:\s?italic;\s?font-weight:\s?bold|font-weight:\s?bold;\s?font-style:\s?italic)[^>]*>([\w\W]*?)<\/span>/gi, '<b><i>$2</i></b>');
        html = html.replace(/<span[^>]*(font-style:\s?italic;\s?font-weight:\s?600|font-weight:\s?600;\s?font-style:\s?italic)[^>]*>([\w\W]*?)<\/span>/gi, '<b><i>$2</i></b>');
        html = html.replace(/<span[^>]*(font-style:\s?italic;\s?font-weight:\s?700|font-weight:\s?700;\s?font-style:\s?italic)[^>]*>([\w\W]*?)<\/span>/gi, '<b><i>$2</i></b>');
        html = html.replace(/<span[^>]*font-style:\s?italic[^>]*>([\w\W]*?)<\/span>/gi, '<i>$1</i>');
        html = html.replace(/<span[^>]*font-weight:\s?bold[^>]*>([\w\W]*?)<\/span>/gi, '<b>$1</b>');
        html = html.replace(/<span[^>]*font-weight:\s?700[^>]*>([\w\W]*?)<\/span>/gi, '<b>$1</b>');
        html = html.replace(/<span[^>]*font-weight:\s?600[^>]*>([\w\W]*?)<\/span>/gi, '<b>$1</b>');

        return html;
    },
    _cleanMsWord: function(html)
    {
        html = html.replace(/<!--[\s\S]+?-->/gi, '');
        html = html.replace(/<(!|script[^>]*>.*?<\/script(?=[>\s])|\/?(\?xml(:\w+)?|img|meta|link|style|\w:\w+)(?=[\s\/>]))[^>]*>/gi, '');
        html = html.replace(/<(\/?)s>/gi, "<$1strike>");
        html = html.replace(/&nbsp;/gi, ' ');
        html = html.replace(/<span\s+style\s*=\s*"\s*mso-spacerun\s*:\s*yes\s*;?\s*"\s*>([\s\u00a0]*)<\/span>/gi, function(str, spaces) {
            return (spaces.length > 0) ? spaces.replace(/./, " ").slice(Math.floor(spaces.length/2)).split("").join("\u00a0") : '';
        });

        // build wrapper
        var $wrapper = this.utils.buildWrapper(html);

        // footnote fix
        $wrapper.find('.MsoFootnoteText').each(function(node) {
            var $node = $R.dom(node);
            var $parent = $node.parent();
            if ($parent.length !== 0 && $parent.attr('style').search(/mso-element:footnote/) !== -1) {
                $node.find('a').attr('id', '_' + $parent.attr('id'));
            }

        });

        $wrapper.find('.MsoFootnoteReference').each(function(node) {
            var $node = $R.dom(node);
            var $parent = $node.parent();
            if ($parent.length !== 0 && $parent.get().tagName === 'A') {
                $parent.attr('id', $parent.attr('name'));
            }

        });

        // build lists
        $wrapper.find('p').each(function(node)
        {
            var $node = $R.dom(node);
            var str = $node.attr('style');
            var matches = /mso-list:\w+ \w+([0-9]+)/.exec(str);
            if (matches)
            {
                $node.data('_listLevel',  parseInt(matches[1], 10));
            }
        });

        // parse Lists
        this._parseWordLists($wrapper);

        $wrapper.find('[align]').removeAttr('align');
        $wrapper.find('[name]').removeAttr('name');
        $wrapper.find('span').each(function(node)
        {
            var $node = $R.dom(node);
            var str = $node.attr('style');
            var matches = /mso-list:Ignore/.exec(str);

            if (matches) $node.remove();
            else $node.unwrap();

        });
        $wrapper.find('[style]').removeAttr('style');
        $wrapper.find("[class^='Mso']").removeAttr('class');
        $wrapper.find('a').filter(function(node) { return !node.hasAttribute('href'); }).unwrap();

        // get wrapper
        html = this.utils.getWrapperHtml($wrapper);
        html = html.replace(/<p[^>]*><\/p>/gi, '');
        html = html.replace(/<li>·/gi, '<li>');
        html = html.trim();

        // remove spaces between
        html = html.replace(/\/(p|ul|ol|h1|h2|h3|h4|h5|h6|blockquote)>\s+<(p|ul|ol|h1|h2|h3|h4|h5|h6|blockquote)/gi, '/$1>\n<$2');

        var result = '';
        var lines = html.split(/\n/);
        for (var i = 0; i < lines.length; i++)
        {
            var space = (lines[i] !== '' && lines[i].search(/>$/) === -1) ? ' ' : '\n';

            result += lines[i] + space;
        }

        return result;
    },
    _parseWordLists: function($wrapper)
    {
        var lastLevel = 0;
        var $item = null;
        var setPnt = false;
        var $list = null;

        $wrapper.find('p').each(function(node) {
            var $node = $R.dom(node);
            var currentLevel = $node.data('_listLevel');
            if (currentLevel === null && $node.hasClass('MsoListParagraphCxSpMiddle')) {
                currentLevel = 1;
            }

            if (currentLevel !== null) {
                var txt = $node.text();
                var listTag = (/^\s*\w+\./.test(txt)) ? '<ol></ol>' : '<ul></ul>';

                if ($node.hasClass('MsoListParagraphCxSpFirst')) {
                    $node.before(listTag);
                    $list = $node.prev();
                }

                if (currentLevel > lastLevel && lastLevel !== 0) {
                    var $list2 = $R.dom(listTag);
                    if ($item) {
                        $item.append($list2);
                        $list = $list2;
                        setPnt = true;
                    }
                }

                $node.find('span').first().unwrap();
                $item = $R.dom('<li>' + $node.html().trim() + '</li>');
                if ($list === null) {
                    $node.before(listTag);
                    $list = $node.prev();
                }
                $list.append($item);
                $node.remove();

                if (setPnt) {
                    $list = $list.parent();
                }

                lastLevel = currentLevel;
                setPnt = false;
            }
            else {
                lastLevel = 0;
            }
        });
    },

    // is
    _isSpacedEmpty: function(html)
    {
        return (html.search(this.reSpacedEmpty) !== -1);
    },
    _isParagraphEmpty: function(html)
    {
        return (html.search(/^<p><\/p>$/i) !== -1);
    },
    _isHtmlMsWord: function(html)
    {
        return html.match(/class="?Mso|style="[^"]*\bmso-|style='[^'']*\bmso-|w:WordDocument/i);
    },

    // set
    _setSpanAttr: function(html)
    {
        var $wrapper = this.utils.buildWrapper(html);
        $wrapper.find('span').attr('data-redactor-span', true);

        return this.utils.getWrapperHtml($wrapper);
    },
    _setStyleCache: function(html)
    {
        var $wrapper = this.utils.buildWrapper(html);
        $wrapper.find('[style]').each(function(node)
        {
            var $el = $R.dom(node);
            $el.attr('data-redactor-style-cache', $el.attr('style'));
        });

        return this.utils.getWrapperHtml($wrapper);
    },
    _setPreClass: function(html)
    {
        var $wrapper = this.utils.buildWrapper(html);
        $wrapper.find('pre').addClass(this.opts.preClass);

        return this.utils.getWrapperHtml($wrapper);
    },
    _setLinkNofollow: function(html)
    {
        var $wrapper = this.utils.buildWrapper(html);
        $wrapper.find('a').attr('rel', 'nofollow');

        return this.utils.getWrapperHtml($wrapper);
    },

    // replace
    _replaceScriptTag: function(html)
    {
        return html.replace(this.reScriptTag, '<script class="redactor-script-tag" $1>$2</script>');
    },
    _unreplaceScriptTag: function(html)
    {
        return html.replace(/<script class="redactor-script-tag"(.*?[^>]?)>([\w\W]*?)<\/script>/gi, '<script$1>$2</script>');
    },
    _replaceNlToBr: function(html)
    {
        return html.replace(/\n/g, '<br />');
    },

    // remove
    _removeScriptTag: function(html)
    {
        return html.replace(this.reScriptTag, '');
    },

    // private
    _storeMatched: function(html, matched, stored, name)
    {
        this['stored' + stored] = [];
        if (matched)
        {
            for (var i = 0; i < matched.length; i++)
            {
                this['stored' + stored][i] = matched[i];
                html = html.replace(matched[i], '####' + name + i + '####');
            }
        }

        return html;
    },
    _restoreMatched: function(html, stored, name)
    {
        if (this['stored' + stored])
        {
            for (var i = 0; i < this['stored' + stored].length; i++)
            {
                html = html.replace('####' + name + i + '####', this['stored' + stored][i]);
            }
        }

        return html;
    },
    _decodeMarkers: function(html)
    {
        var decodedMarkers = '<span id="selection-marker-$1" class="redactor-selection-marker">​</span>';
        return html.replace(/&lt;span\sid="selection-marker-(start|end)"\sclass="redactor-selection-marker"&gt;(.*?[^>]?)&lt;\/span&gt;/g, decodedMarkers);
    },
    _encodeOuter: function(node)
    {
        return this.encodeEntities(node.outerHTML);
    },
    _encodePreCodeLine: function(node)
    {
        var first = node.firstChild;
        if (node.tagName == 'PRE' && (first && first.tagName === 'CODE')) return;

        var encoded = this.decodeEntities(node.innerHTML);
        encoded = encoded.replace(/&nbsp;/g, ' ').replace(/<br\s?\/?>/g, '\n');
        encoded = (this.opts.preSpaces) ? encoded.replace(/\t/g, new Array(this.opts.preSpaces + 1).join(' ')) : encoded;

        node.textContent = encoded;
    }
});
$R.add('class', 'cleaner.figure', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.utils = app.utils;
        this.detector = app.detector;
    },
    // public
    convert: function(html, rules)
    {
        var $wrapper = this.utils.buildWrapper(html);

        // convert
        $wrapper.find('img').each(this._convertImage.bind(this));
        $wrapper.find('hr').each(this._convertLine.bind(this));
        $wrapper.find('iframe').each(this._convertIframe.bind(this));
        $wrapper.find('table').each(this._convertTable.bind(this));
        $wrapper.find('form').each(this._convertForm.bind(this));
        $wrapper.find('figure pre').each(this._convertCode.bind(this));

        // variables
        $wrapper.find('[data-redactor-type=variable]').addClass('redactor-component');

        // widgets
        $wrapper.find('figure').not('.redactor-component, .redactor-figure-code').each(this._convertWidget.bind(this));

        // contenteditable
        $wrapper.find('figure pre').each(this._setContenteditableCode.bind(this));
        $wrapper.find('.redactor-component, .non-editable').attr('contenteditable', false);

        if (this.detector.isIe())
        {
            $wrapper.find('[data-redactor-type=table]').removeAttr('contenteditable');
        }

        $wrapper.find('figcaption, td, th').attr('contenteditable', true);
        $wrapper.find('.redactor-component, figcaption').attr('tabindex', '-1');

        // extra rules
        this._acceptExtraRules($wrapper, rules);

        return this.utils.getWrapperHtml($wrapper);
    },
    unconvert: function(html, rules)
    {
        var $wrapper = this.utils.buildWrapper(html);

        // contenteditable
        $wrapper.find('th, td, figcaption, figure, pre, code, .redactor-component').removeAttr('contenteditable tabindex');

        // remove class
        $wrapper.find('figure').removeClass('redactor-component redactor-component-active redactor-uploaded-figure');

        // unconvert
        $wrapper.find('[data-redactor-type=variable]').removeClass('redactor-component redactor-component-active');
        $wrapper.find('figure[data-redactor-type=line]').unwrap();
        $wrapper.find('figure[data-redactor-type=widget]').each(this._unconvertWidget.bind(this));
        $wrapper.find('figure[data-redactor-type=form]').each(this._unconvertForm.bind(this));
        $wrapper.find('figure[data-redactor-type=table]').each(this._unconvertTable.bind(this));
        $wrapper.find('figure[data-redactor-type=image]').removeAttr('rel').each(this._unconvertImages.bind(this));

        $wrapper.find('img').removeAttr('data-redactor-type').removeClass('redactor-component');
        $wrapper.find('.non-editable').removeAttr('contenteditable');

        // remove types
        $wrapper.find('figure').each(this._removeTypes.bind(this));

        // remove caret
        $wrapper.find('span.redactor-component-caret').remove();

        if (this.opts.breakline)
        {
            $wrapper.find('[data-redactor-tag="br"], [data-redactor-tag="tbr"]').each(function(node) {
                var $node = $R.dom(node);
                var $next = $node.nextElement();
                var tbr = ($node.attr('data-redactor-tag') === 'tbr');

                if (this.utils.isEmptyHtml($node.html())) {
                    $node.html('<br>');
                }
                else if (node.lastChild && node.lastChild.tagName !== 'BR') {
                    if (tbr) {
                        if ($next.length !== 0 && $next.attr('data-redactor-tag')) {
                            node.appendChild(document.createElement('br'));
                        }
                    }
                    else {
                        node.appendChild(document.createElement('br'));
                    }
                }
            }.bind(this)).unwrap();
        }
        else {
            // table markup
            $wrapper.find('[data-redactor-tag="tbr"]').each(function(node) {
                var $node = $R.dom(node);
                $node.removeAttr('data-redactor-tag');

                if (this.opts.markup !== 'div') {
                    var $next = $node.nextElement();
                    if ($next.length !== 0 && $next.attr('data-redactor-tag')) {
                        node.appendChild(document.createElement('br'));
                    }

                    $node.unwrap();
                }

            }.bind(this));
        }

        // extra rules
        this._acceptExtraRules($wrapper, rules);

        html = this.utils.getWrapperHtml($wrapper);
        html = html.replace(/<br\s?\/?>$/, '');

        return html;
    },

    // private
    _convertImage: function(node)
    {
        var $node = $R.dom(node);
        if (this._isNonEditable($node)) return;

        // set id
        if (this.opts.imageObserve && !$node.attr('data-image'))
        {
            $node.attr('data-image', this.utils.getRandomId());
        }

        var $link = $node.closest('a');
        var $figure = $node.closest('figure');
        var isImage = ($figure.children().not('a, img, br, figcaption').length === 0);
        if (!isImage) return;

        if ($figure.length === 0)
        {
            var $parent = ($link.length !== 0) ? $link.closest('p') : $node.closest('p');
            if (this.opts.imageFigure === false && $parent.length !== 0)
            {
                var $el = this.utils.replaceToTag($parent, 'figure');
                $figure = $el;
                $figure.addClass('redactor-replace-figure');
            }
            else
            {
                if ($parent.length !== 0) {
                    $parent.unwrap();
                }

                $figure = ($link.length !== 0) ? $link.wrap('<figure>') : $node.wrap('<figure>');
            }
        }
        else
        {
            if ($figure.hasClass('redactor-uploaded-figure'))
            {
                $figure.removeClass('redactor-uploaded-figure');
            }
            else
            {
                $figure.addClass('redactor-keep-figure');
            }
        }

        this._setFigure($figure, 'image');
    },
    _convertTable: function(node)
    {
        if (this._isNonEditable(node)) return;

        var $figure = this._wrapFigure(node);
        this._setFigure($figure, 'table');
    },
    _convertLine: function(node)
    {
        if (this._isNonEditable(node)) return;

        var $figure = this._wrapFigure(node);
        this._setFigure($figure, 'line');
    },
    _convertForm: function(node)
    {
        if (this._isNonEditable(node)) return;

        var $figure = this.utils.replaceToTag(node, 'figure');
        this._setFigure($figure, 'form');
    },
    _convertIframe: function(node)
    {
        if (this._isNonEditable(node)) return;

        var $node = $R.dom(node);
        if ($node.closest('.redactor-component').length !== 0) return;

        var src = node.getAttribute('src');
        var isVideo = (src && (src.match(this.opts.regex.youtube) || src.match(this.opts.regex.vimeo)));
        var $figure = this._wrapFigure(node);

        if (isVideo)
        {
            this._setFigure($figure, 'video');
        }
    },
    _convertCode: function(node)
    {
        if (this._isNonEditable(node)) return;

        var $figure = this._wrapFigure(node);
        this._setFigure($figure, 'code');
    },
    _convertWidget: function(node)
    {
        if (this._isNonEditable(node)) return;

        var $node = $R.dom(node);
        $node.addClass('redactor-component');
        $node.attr('data-redactor-type', 'widget');
        $node.attr('data-widget-code', encodeURI(node.innerHTML.trim()));
    },

    // unconvert
    _unconvertForm: function(node)
    {
        this.utils.replaceToTag(node, 'form');
    },
    _unconvertTable: function(node)
    {
        var $node = $R.dom(node);
        $node.unwrap();
    },
    _unconvertWidget: function(node)
    {
        var $node = $R.dom(node);
        $node.html(decodeURI($node.attr('data-widget-code')));
        $node.removeAttr('data-widget-code');
    },
    _unconvertImages: function(node)
    {
        var $node = $R.dom(node);
        $node.removeClass('redactor-component');

        var isList = ($node.closest('li').length !== 0);
        var isTable = ($node.closest('table').length !== 0);
        var hasFigcaption = ($node.find('figcaption').length !== 0);

        var style = $node.attr('style');
        var hasStyle = !(style === null || style === '');
        var hasClass = ($node.attr('class') !== '');

        if (isList || (isTable && !hasFigcaption && !hasStyle && !hasClass))
        {
            $node.unwrap();
        }
    },
    _removeTypes: function(node)
    {
        var $node = $R.dom(node);
        var type = $node.attr('data-redactor-type');
        var removed = ['image', 'widget', 'line', 'video', 'code', 'form', 'table'];
        if (type && removed.indexOf(type) !== -1)
        {
            $node.removeAttr('data-redactor-type');
        }

        // keep figure
        if ($node.hasClass('redactor-keep-figure'))
        {
            $node.removeClass('redactor-keep-figure');
        }

        // unwrap figure
        else if (type === 'image' && this.opts.imageFigure === false)
        {
            var hasFigcaption = ($node.find('figcaption').length !== 0);
            if (!hasFigcaption)
            {
                // replace
                if ($node.hasClass('redactor-replace-figure'))
                {
                    $node.removeClass('redactor-replace-figure');
                    this.utils.replaceToTag($node, 'p');
                }
                else
                {
                    $node.unwrap();
                }
            }
        }

        $node.removeClass('redactor-replace-figure');
    },

    // wrap
    _wrapFigure: function(node)
    {
        var $node = $R.dom(node);
        var $figure = $node.closest('figure');

        return ($figure.length === 0) ? $node.wrap('<figure>') : $figure;
    },

    // set
    _setFigure: function($figure, type)
    {
        $figure.addClass('redactor-component');
        $figure.attr('data-redactor-type', type);
    },
    _setContenteditableCode: function(node)
    {
        if (this._isNonEditable(node)) return;

        var $node = $R.dom(node);
        var $code = $node.children('code').first();

        var $el = ($code.length !== 0) ? $code : $node;
        $el.attr('contenteditable', true).attr('tabindex', '-1');
    },

    // utils
    _acceptExtraRules: function($wrapper, rules)
    {
        for (var key in rules)
        {
            if (typeof rules[key] === 'function')
            {
                rules[key]($wrapper);
            }
        }
    },
    _isNonEditable: function(node)
    {
        return ($R.dom(node).closest('.non-editable').length !== 0);
    }
});
$R.add('class', 'cleaner.paragraphize', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.utils = app.utils;
        this.element = app.element;

        // local
        this.stored = [];
        this.remStart = '#####replace';
        this.remEnd = '#####';
        this.paragraphizeTags = ['table', 'div', 'pre', 'form', 'ul', 'ol', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'dl', 'blockquote', 'figcaption',
                'address', 'section', 'header', 'footer', 'aside', 'article', 'object', 'style', 'script', 'iframe', 'select', 'input', 'textarea',
                'button', 'option', 'map', 'area', 'math', 'hr', 'fieldset', 'legend', 'hgroup', 'nav', 'figure', 'details', 'menu', 'summary', 'p'];
    },
    // public
    convert: function(html)
    {
        var value = this._isConverted(html);

        value = (value === true) ? this._convert(html) : value;

        // table
        var $wrapper = this.utils.buildWrapper(value);
        $wrapper.find('td, th').each(function(node) {
            var $node = $R.dom(node);
            this.stored = [];
            var code = this._convert($node.html(), true);
            $node.html(code);
        }.bind(this));

        value = this.utils.getWrapperHtml($wrapper);

        return value;
    },



    // private
    _convert: function(html, tablemarkup)
    {
        // build markup tag
        var markupTag = (this.opts.breakline) ? 'sdivtag' : this.opts.markup;
        if (tablemarkup) {
            markupTag = 'sdivtag';
        }

        // store tags
        html = this._storeTags(html);

        // store comments
        var storeComments = [];
        var commentsMatch = html.match(new RegExp('<!--([\\w\\W]*?)-->', 'gi'));
        if (commentsMatch !== null)
        {
            for (var i = 0; i < commentsMatch.length; i++)
            {
                html = html.replace(commentsMatch[i], '#####xstarthtmlcommentzz' + i + 'xendhtmlcommentzz#####');
                storeComments.push(commentsMatch[i]);
            }
        }

        // remove new lines
        html = html.trim();

        if (this.opts.breakline)
        {
            html = html.replace(new RegExp('\\n#####', 'gi'), '#####');
            html = html.replace(new RegExp('#####\\n', 'gi'), "#####");
            html = html.replace(/<br\s?\/?>\n/gi, "<br>");
        }
        else
        {
            html = html.replace(/[\n]+/g, "\n");
        }

        html = this._trimEmptyLines(html);

        // paragraph and break markers
        html = (this.opts.breakline) ? html : html.replace(/<br\s?\/?>\n/gi, "xbreakmarkerz\n");
        html = html.replace(/(?:\r\n|\r|\n)/g, "xparagraphmarkerz");

        // replace markers
        html = html.replace(/xparagraphmarkerz/gi, "</" + markupTag + ">\n<" + markupTag + ">");
        html = (this.opts.breakline) ? html : html.replace(/xbreakmarkerz/gi, "<br>");

        // wrap all
        html = '<' + markupTag + '>' + html + '</' + markupTag + '>';

        // clean
        html = html.replace(new RegExp('<' + markupTag + '>#####', 'gi'), '#####');
        html = html.replace(new RegExp('#####</' + markupTag + '>', 'gi'), '#####');

        // restore tags
        html = this._restoreTags(html);

        // restore comments
        for (var i = 0; i < storeComments.length; i++)
        {
            html = html.replace('#####xstarthtmlcommentzz' + i + 'xendhtmlcommentzz#####', storeComments[i]);
        }

        var breaklineAttr = 'br';
        if (tablemarkup) {
            breaklineAttr = 'tbr';
        }

        // clean restored
        html = (this.opts.breakline) ? html : html.replace(new RegExp('<' + markupTag + '><br\\s?/?></' + markupTag + '>', 'gi'), '<' + markupTag + '></' + markupTag + '>');
        html = html.replace(new RegExp('<sdivtag>', 'gi'), '<div data-redactor-tag="' + breaklineAttr + '">');
        html = html.replace(new RegExp('sdivtag', 'gi'), 'div');

        return html;
    },
    _storeTags: function(html)
    {
        var self = this;
        var $wrapper = this.utils.buildWrapper(html);

        if (this.opts.breakline)
        {
            $wrapper.find('p').each(function(node)
            {
                var $node = $R.dom(node);
                var isUnwrap = ($node.closest('figure[data-redactor-type=widget],figure[data-redactor-type=form],.non-editable').length === 0);

                if (isUnwrap)
                {
                    $node.append('<br><br>');
                    $node.unwrap();
                }
            });
        }

        $wrapper.find(this.paragraphizeTags.join(', ')).each(function(node, i)
        {
            var replacement = document.createTextNode("\n" + self.remStart + i + self.remEnd + "\n");
            self.stored.push(node.outerHTML);
            node.parentNode.replaceChild(replacement, node);
        });

        return this.utils.getWrapperHtml($wrapper);
    },
    _restoreTags: function(html)
    {
        for (var i = 0; i < this.stored.length; i++)
        {
            this.stored[i] = this.stored[i].replace(/\$/g, '&#36;');
            html = html.replace(this.remStart + i + this.remEnd, this.stored[i]);
        }

        return html;
    },
    _trimEmptyLines: function(html)
    {
        var str = '';
        var arr = html.split("\n");
        for (var i = 0; i < arr.length; i++)
        {
            if (arr[i].trim() !== '')
            {
                str += arr[i] + "\n";
            }
        }

        return str.replace(/\n$/, '');
    },
    _isConverted: function(html)
    {
        if (this._isDisabled(html)) return html;
        else if (this._isEmptyHtml(html)) return this.opts.emptyHtml;
        else return true;
    },
    _isDisabled: function()
    {
        return (this.opts.paragraphize === false || this.element.isType('inline'));
    },
    _isEmptyHtml: function(html)
    {
        return (html === '' || html === '<p></p>' || html === '<div></div>');
    }
});
$R.add('service', 'detector', {
    init: function(app)
    {
        this.app = app;

        // local
        this.userAgent = navigator.userAgent.toLowerCase();
    },
    isWebkit: function()
    {
        return /webkit/.test(this.userAgent);
    },
    isFirefox: function()
    {
        return (this.userAgent.indexOf('firefox') > -1);
    },
    isIe: function(v)
    {
        if (document.documentMode || /Edge/.test(navigator.userAgent)) return 'edge';

        var ie;
        ie = RegExp('msie' + (!isNaN(v)?('\\s'+v):''), 'i').test(navigator.userAgent);
        if (!ie) ie = !!navigator.userAgent.match(/Trident.*rv[ :]*11\./);

        return ie;
    },
    isMobile: function()
    {
        return /(iPhone|iPod|Android)/.test(navigator.userAgent);
    },
    isDesktop: function()
    {
        return !/(iPhone|iPod|iPad|Android)/.test(navigator.userAgent);
    },
    isIpad: function()
    {
        return /iPad/.test(navigator.userAgent);
    }
});
$R.add('service', 'offset', {
    init: function(app)
    {
        this.app = app;
    },
    get: function(el, trimmed)
    {
        var offset = { start: 0, end: 0 };
        var node = this.utils.getNode(el);
        if (!node) return false;

        var isEditor = this.editor.isEditor(node);
        var isIn = (isEditor) ? true : this.selection.isIn(node);
        var range = this.selection.getRange();

        if (!isEditor && !isIn)
        {
            offset = false;
        }
        else if (this.selection.is() && isIn)
        {
            var $startNode = $R.dom(range.startContainer);
            var fix = ($startNode.hasClass('redactor-component')) ? range.startOffset : 0;
            var clonedRange = range.cloneRange();

            clonedRange.selectNodeContents(node);
            clonedRange.setEnd(range.startContainer, range.startOffset);

            var selection = this._getString(range, trimmed);

            offset.start = this._getString(clonedRange, trimmed).length - fix;
            offset.end = offset.start + selection.length + fix;
        }

        return offset;
    },
    set: function(offset, el)
    {
        if (this._setComponentOffset(el)) return;

        this.component.clearActive();
        var node = this.utils.getNode(el);
        if (!node) return;

        var size = this.size(node);
        var charIndex = 0, range = document.createRange();

        offset.end = (offset.end > size) ? size : offset.end;

        range.setStart(node, 0);
        range.collapse(true);

        var nodeStack = [node], foundStart = false, stop = false;
        while (!stop && (node = nodeStack.pop()))
        {
            if (node.nodeType == 3)
            {
                var nextCharIndex = charIndex + node.length;

                if (!foundStart && !this._isFigcaptionNext(node) && offset.start >= charIndex && offset.start <= nextCharIndex)
                {
                    range.setStart(node, offset.start - charIndex);
                    foundStart = true;
                }

                if (foundStart && offset.end >= charIndex && offset.end <= nextCharIndex)
                {
                    range.setEnd(node, offset.end - charIndex);
                    stop = true;
                }

                charIndex = nextCharIndex;
            }
            else
            {
                var i = node.childNodes.length;
                while (i--)
                {
                    nodeStack.push(node.childNodes[i]);
                }
            }
        }

        this.selection.setRange(range);
    },
    size: function(el, trimmed)
    {
        var node = this.utils.getNode(el);
        if (node)
        {
            var range = document.createRange();

            var clonedRange = range.cloneRange();
            clonedRange.selectNodeContents(node);

            return this._getString(clonedRange, trimmed).length;
        }

        return 0;
    },

    // private
    _getString: function(obj, trimmed)
    {
        var str = obj.toString();
        str = (this.editor.isEmpty()) ? str.replace(/\uFEFF/g, '') : str;
        str = (trimmed) ? str.trim() : str;

        return str;
    },
    _setComponentOffset: function(el)
    {
        return (this.component.isNonEditable(el)) ? this.component.setActive(el) : false;
    },
    _isFigcaptionNext: function(node)
    {
        var next = node.nextSibling;
        return (node.nodeValue.trim() === '' && next && next.tagName === 'FIGCAPTION');
    }
});
$R.add('service', 'inspector', {
    init: function(app)
    {
        this.app = app;
    },
    // parse
    parse: function(el)
    {
        return $R.create('inspector.parser', this.app, this, el);
    },

    // text detection
    isText: function(el)
    {
        if (typeof el === 'string' && !/^\s*<(\w+|!)[^>]*>/.test(el))
        {
            return true;
        }

        var node = $R.dom(el).get();
        return (node && node.nodeType === 3); //  && !this.selection.getBlock(el)
    },

    // tag detection
    isInlineTag: function(tag, extend)
    {
        var tags = this._extendTags(this.opts.inlineTags, extend);

        return (this._isTag(tag) && tags.indexOf(tag.toLowerCase()) !== -1);
    },
    isBlockTag: function(tag, extend)
    {
        var tags = this._extendTags(this.opts.blockTags, extend);

        return (this._isTag(tag) && tags.indexOf(tag.toLowerCase()) !== -1);
    },
    isTableCellTag: function(tag)
    {
        return (['td', 'th'].indexOf(tag.toLowerCase()) !== -1);
    },
    isHeadingTag: function(tag)
    {
        return (['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].indexOf(tag.toLowerCase()) !== -1);
    },


    _isTag: function(tag)
    {
        return (tag !== undefined && tag);
    },
    _extendTags: function(tags, extend)
    {
        tags = tags.concat(tags);

        if (extend)
        {
            for (var i = 0 ; i < extend.length; i++)
            {
                tags.push(extend[i]);
            }
        }

        return tags;
    }
});
$R.add('class', 'inspector.parser', {
    init: function(app, inspector, el)
    {
        this.app = app;
        this.uuid = app.uuid;
        this.opts = app.opts;
        this.utils = app.utils;
        this.editor = app.editor;
        this.selection = app.selection;
        this.inspector = inspector;

        // local
        this.el = el;
        this.$el = $R.dom(this.el, '.redactor-in');
        this.node = this.$el.get();

        // comment node
        if (this.node && this.node.nodeType === 8)
        {
            this.node = false;
        }

        this.$component = this.$el.closest('.redactor-component', '.redactor-in');
    },
    // is
    isEditor: function()
    {
        return (this.node === this.editor.getElement().get());
    },
    isInEditor: function()
    {
        return (this.$el.parents('.redactor-in-' + this.uuid).length !== 0);
    },
    isComponent: function()
    {
        return (this.$component.length !== 0);
    },
    isComponentType: function(type)
    {
        return (this.getComponentType() === type);
    },
    isComponentActive: function()
    {
        return (this.isComponent() && this.$component.hasClass('redactor-component-active'));
    },
    isComponentEditable: function()
    {
        var types = ['code', 'table'];
        var type = this.getComponentType();

        return (this.isComponent() && types.indexOf(type) !== -1);
    },
    isFigcaption: function()
    {
        return this.getFigcaption();
    },
    isPre: function()
    {
        return this.getPre();
    },
    isCode: function()
    {
        var $code = this.$el.closest('code');
        var $parent = $code.parent('pre');

        return ($code.length !== 0 && $parent.length === 0);
    },
    isList: function()
    {
        return this.getList();
    },
    isFirstListItem: function()
    {
        return this._getLastOrFirstListItem('first');
    },
    isLastListItem: function()
    {
        return this._getLastOrFirstListItem('last');
    },
    isFirstTableCell: function()
    {
        return this._getLastOrFirstTableCell('first');
    },
    isLastTableCell: function()
    {
        return this._getLastOrFirstTableCell('last');
    },
    isTable: function()
    {
        return (this.isComponentType('table') || this.getTable());
    },
    isHeading: function()
    {
        return this.getHeading();
    },
    isBlockquote: function()
    {
        return this.getBlockquote();
    },
    isDl: function()
    {
        return this.getDl();
    },
    isParagraph: function()
    {
        return this.getParagraph();
    },
    isLink: function()
    {
        return this.getLink();
    },
    isFile: function()
    {
        return this.getFile();
    },
    isText: function()
    {
        return this.inspector.isText(this.el);
    },
    isInline: function()
    {
        var tags = this.opts.inlineTags;

        return (this.isElement()) ? (tags.indexOf(this.node.tagName.toLowerCase()) !== -1) : false;
    },
    isBlock: function()
    {
        var tags = this.opts.blockTags;

        return (this.isElement()) ? (tags.indexOf(this.node.tagName.toLowerCase()) !== -1) : false;
    },
    isElement: function()
    {
        return (this.node && this.node.nodeType && this.node.nodeType !== 3);
    },

    // has
    hasParent: function(tags)
    {
        return (this.$el.closest(tags.join(',')).length !== 0);
    },

    // get
    getNode: function()
    {
        return this.node;
    },
    getTag: function()
    {
        return (this.isElement()) ? this.node.tagName.toLowerCase() : false;
    },
    getComponent: function()
    {
        return (this.isComponent()) ? this.$component.get() : false;
    },
    getComponentType: function()
    {
        return (this.isComponent()) ? this.$component.attr('data-redactor-type') : false;
    },
    getFirstNode: function()
    {
        return this.utils.getFirstNode(this.node);
    },
    getLastNode: function()
    {
        return this.utils.getLastNode(this.node);
    },
    getFirstElement: function()
    {
        return this.utils.getFirstElement(this.node);
    },
    getLastElement: function()
    {
        return this.utils.getLastElement(this.node);
    },
    getFigcaption: function()
    {
        return this._getClosestNode('figcaption');
    },
    getPre: function()
    {
        return this._getClosestNode('pre');
    },
    getCode: function()
    {
        return this._getClosestNode('code');
    },
    getList: function()
    {
        return this._getClosestNode('ul, ol');
    },
    getParentList: function()
    {
        return this._getClosestUpNode('ul, ol');
    },
    getListItem: function()
    {
        return this._getClosestNode('li');
    },
    getTable: function()
    {
        if (this.getComponentType('table'))
        {
            return this.$component.find('table').get();
        }
        else
        {
            return this._getClosestNode('table');
        }
    },
    getTableCell: function()
    {
        var $td = this.$el.closest('td, th');

        return ($td.length !== 0) ? $td.get() : false;
    },
    getComponentCodeElement: function()
    {
        return (this.isComponentType('code')) ? this.$component.find('pre code, pre').last().get() : false;
    },
    getImageElement: function()
    {
        return (this.isComponentType('image')) ? this.$component.find('img').get() : false;
    },
    getParagraph: function()
    {
        return this._getClosestNode('p');
    },
    getHeading: function()
    {
        return this._getClosestNode('h1, h2, h3, h4, h5, h6');
    },
    getDl: function()
    {
        return this._getClosestNode('dl');
    },
    getBlockquote: function()
    {
        return this._getClosestNode('blockquote');
    },
    getLink: function()
    {
        var isComponent = (this.isComponent() && !this.isFigcaption());
        var isTable = this.isComponentType('table');

        if (isTable || !isComponent)
        {
            var $el = this._getClosestElement('a');

            return ($el && !$el.attr('data-file')) ? $el.get() : false;
        }

        return false;
    },
    getFile: function()
    {
        var isComponent = this.isComponent();
        var isTable = this.isComponentType('table');

        if (isTable || !isComponent)
        {
            var $el = this._getClosestElement('a');

            return ($el && $el.attr('data-file')) ? $el.get() : false;
        }

        return false;
    },

    // find
    findFirstNode: function(selector)
    {
        return this.$el.find(selector).first().get();
    },
    findLastNode: function(selector)
    {
        return this.$el.find(selector).last().get();
    },

    // private
    _getLastOrFirstListItem: function(type)
    {
        var list = this.getList();
        var tag = this.getTag();
        if (list && tag === 'li')
        {
            var item = $R.dom(list).find('li')[type]().get();
            if (item && this.node === item)
            {
                return true;
            }
        }

        return false;
    },
    _getLastOrFirstTableCell: function(type)
    {
        var table = this.getTable();
        var tag = this.getTag();
        if (table && (tag === 'td' || tag === 'th'))
        {
            var item = $R.dom(table).find('td, th')[type]().get();
            if (item && this.node === item)
            {
                return true;
            }
        }

        return false;
    },
    _getClosestUpNode: function(selector)
    {
        var $el = this.$el.parents(selector, '.redactor-in').last();

        return ($el.length !== 0) ? $el.get() : false;
    },
    _getClosestNode: function(selector)
    {
        var $el = this.$el.closest(selector, '.redactor-in');

        return ($el.length !== 0) ? $el.get() : false;
    },
    _getClosestElement: function(selector)
    {
        var $el = this.$el.closest(selector, '.redactor-in');

        return ($el.length !== 0) ? $el : false;
    }
});
$R.add('service', 'marker', {
    init: function(app)
    {
        this.app = app;
    },
    build: function(pos, html)
    {
        var marker = document.createElement('span');

        marker.id = 'selection-marker-' + this._getPos(pos);
        marker.className = 'redactor-selection-marker';
        marker.innerHTML = this.opts.markerChar;

        return (html) ? marker.outerHTML : marker;
    },
    buildHtml: function(pos)
    {
        return this.build(pos, true);
    },
    insert: function(side)
    {
        this.remove();

        var atStart = (side !== 'both' && (side === 'start' || this.selection.isCollapsed()));

        if (!this.selection.is()) this.editor.focus();

        var range = this.selection.getRange();
        if (range)
        {
            var start = this.build('start');
            var end = this.build('end');

            var cloned = range.cloneRange();

            if (!atStart)
            {
                cloned.collapse(false);
                cloned.insertNode(end);
            }

            cloned.setStart(range.startContainer, range.startOffset);
            cloned.collapse(true);
            cloned.insertNode(start);

            range.setStartAfter(start);

            if (!atStart)
            {
                range.setEndBefore(end);
            }

            this.selection.setRange(range);

            return start;
        }
    },
    find: function(pos, $context)
    {
        var $editor = this.editor.getElement();
        var $marker = ($context || $editor).find('span#selection-marker-' + this._getPos(pos));

        return ($marker.length !== 0) ? $marker.get() : false;
    },
    restore: function()
    {
        var start = this.find('start');
        var end = this.find('end');

        var range = this.selection.getRange();
        if (!range || !this.selection.is())
        {
            this.editor.focus();
            range = document.createRange();
        }

        if (start)
        {
            var prev = (end) ? end.previousSibling : false;
            var next = start.nextSibling;
            next = (next && next.nodeType === 3 && next.textContent.replace(/[\n\t]/g, '') === '') ? false : next;

            if (!end)
            {
                if (next)
                {
                    range.selectNodeContents(next);
                    range.collapse(true);
                }
                else
                {
                    this._restoreInject(range, start);
                }
            }
            else if (next && next.id === 'selection-marker-end')
            {
                this._restoreInject(range, start);
            }
            else
            {
                if (prev && next)
                {
                    range.selectNodeContents(prev);
                    range.collapse(false);
                    range.setStart(next, 0);
                }
                else if (prev && !next)
                {
                    range.selectNodeContents(prev);
                    range.collapse(false);
                    range.setStartAfter(start);
                }
                else
                {
                    range.setStartAfter(start);
                    range.setEndBefore(end);
                }
            }

            this.selection.setRange(range);

            if (start) start.parentNode.removeChild(start);
            if (end) end.parentNode.removeChild(end);
        }
    },
    remove: function()
    {
        var start = this.find('start');
        var end = this.find('end');

        if (start) start.parentNode.removeChild(start);
        if (end) end.parentNode.removeChild(end);
    },

    // private
    _getPos: function(pos)
    {
        return (pos === undefined) ? 'start' : pos;
    },
    _restoreInject: function(range, start)
    {
        var textNode = this.utils.createInvisibleChar();
        $R.dom(start).after(textNode);

        range.selectNodeContents(textNode);
        range.collapse(false);
    }
});
$R.add('service', 'component', {
    init: function(app)
    {
        this.app = app;

        // local
        this.activeClass = 'redactor-component-active';
    },
    create: function(type, el)
    {
        return $R.create(type + '.component', this.app, el);
    },
    build: function(el)
    {
        var $el = $R.dom(el);
        var component;
        var type = $el.attr('data-redactor-type');
        if (type)
        {
            component = this.create(type, el);
        }

        return (component) ? component : el;
    },
    remove: function(el, caret)
    {
        var $component = $R.dom(el).closest('.redactor-component');
        var type = $component.attr('data-redactor-type');
        var current = $component.parent();
        var data = this.inspector.parse(current);
        var prev = this.utils.findSiblings($component, 'prev');
        var next = this.utils.findSiblings($component, 'next');
        var stop = this.app.broadcast(type + '.delete', $component);
        if (stop !== false)
        {
            $component.remove();

            // callback
            this.app.broadcast(type + '.deleted', $component);
            this.app.broadcast('contextbar.close');
            this.app.broadcast('imageresizer.stop');

            if (caret !== false)
            {
                var cell = data.getTableCell();
                if (cell && this.utils.isEmptyHtml(cell.innerHTML))
                {
                    this.caret.setStart(cell);
                }
                else if (next) this.caret.setStart(next);
                else if (prev) this.caret.setEnd(prev);
                else
                {
                    this.editor.startFocus();
                }
            }

            // is empty
            if (this.editor.isEmpty())
            {
                this.editor.setEmpty();
                this.editor.startFocus();
                this.app.broadcast('empty');
            }
        }
    },
    isNonEditable: function(el)
    {
        var data = this.inspector.parse(el);
        return (data.isComponent() && !data.isComponentEditable());
    },
    isActive: function(el)
    {
        var $component;
        if (el)
        {
            var data = this.inspector.parse(el);
            $component = $R.dom(data.getComponent());

            return $component.hasClass(this.activeClass);
        }
        else
        {
            $component = this._find();

            return ($component.length !== 0);
        }
    },
    getActive: function(dom)
    {
        var $component = this._find();

        return ($component.length !== 0) ? ((dom) ? $component : $component.get()) : false;
    },
    setActive: function(el)
    {
        this.clearActive();
        this.editor.focus();

        var data = this.inspector.parse(el);
        var component = data.getComponent();
        var $component = $R.dom(component);

        if (!data.isFigcaption())
        {
            var $caret = $component.find('.redactor-component-caret');
            if ($caret.length === 0)
            {
                $caret = this._buildCaret();
                $component.prepend($caret);
            }

            this.caret.setAtStart($caret.get());
        }

        $component.addClass(this.activeClass);
    },
    clearActive: function()
    {
        var $component = this._find();

        $component.removeClass(this.activeClass);
        $component.find('.redactor-component-caret').remove();

        this.app.broadcast('imageresizer.stop');
    },
    setOnEvent: function(e, contextmenu)
    {
        this.clearActive();

        var data = this.inspector.parse(e.target);
        if (data.isFigcaption() || data.isComponentEditable())
        {
            return;
        }

        // component
        if (data.isComponent())
        {
            this.setActive(e.target);
            if (contextmenu !== true) e.preventDefault();
        }
    },
    executeScripts: function(scripts)
    {
        if (scripts === undefined)
        {
            var $editor = this.editor.getElement();
            var scripts = $editor.find('[data-redactor-type]').find("script").getAll();
            this.executeScripts.call(this, scripts);
        }
        else
        {
            for (var i = 0; i < scripts.length; i++)
            {
                if (scripts[i].src !== '')
                {
                    var src = scripts[i].src;
                    this.$doc.find('head script[src="' + src + '"]').remove();

                    var $script = $R.dom('<script>');
                    $script.attr('src', src);
                    $script.attr('async defer');
                    $script.get().onload = function()
                    {
                        if (src.search('instagram') !== -1) window.instgrm.Embeds.process();
                        this.executeScripts(scripts.slice(i + 1));
                    }.bind(this);

                    var head = document.getElementsByTagName('head')[0];
                    if (head) head.appendChild($script.get());

                    break;
                }
                else
                {
                    try {
                        eval(scripts[i].innerHTML);
                    } catch (e) {}
                }
            }
        }
    },

    // private
    _find: function()
    {
        return this.editor.getElement().find('.' + this.activeClass);
    },
    _buildCaret: function()
    {
        var $caret = $R.dom('<span>');
        $caret.addClass('redactor-component-caret');
        $caret.attr('contenteditable', true);

        return $caret;
    }
});
$R.add('service', 'insertion', {
    init: function(app)
    {
        this.app = app;
    },
    set: function(html, clean, focus)
    {
        if (html === null) {
            html = '';
        }

        html = (clean !== false) ? this.cleaner.input(html) : html;
        html = (clean !== false) ? this.cleaner.paragraphize(html) : html;

        // set html
        var $editor = this.editor.getElement();
        $editor.html(html);

        // set focus at the end
        if (focus !== false) this.editor.endFocus();

        return html;
    },
    insertNode: function(node, caret)
    {
        this.editor.focus();
        var fragment = (this.utils.isFragment(node)) ? node : this.utils.createFragment(node);

        this._collapseSelection();
        this._insertFragment(fragment);
        this._setCaret(caret, fragment);

        return this._sendNodes(fragment.nodes);
    },
    insertBreakLine: function()
    {
        return this.insertNode(document.createElement('br'), 'after');
    },
    insertNewline: function()
    {
        return this.insertNode(document.createTextNode('\n'), 'after');
    },
    insertText: function(text)
    {
        return this.insertHtml(this.cleaner.getFlatText(text));
    },
    insertChar: function(charhtml)
    {
        return this.insertNode(charhtml, 'after');
    },
    insertRaw: function(html)
    {
        return this.insertHtml(html, false);
    },
    insertToEnd: function(lastNode, type)
    {
        if (!lastNode) return;
        if (lastNode.nodeType === 3 && lastNode.nodeValue.search(/^\n/) !== -1)
        {
            lastNode = lastNode.previousElementSibling;
        }

        var $lastNode = $R.dom(lastNode);
        if ($lastNode.attr('data-redactor-type') === type)
        {
            var tag = (this.opts.breakline) ? '<br>' : '<p>';
            var $newNode = $R.dom(tag);

            $lastNode.after($newNode);
            this.caret.setStart($newNode);
        }
    },
    insertPoint: function(e)
    {
        var range, data;
        var marker = this.marker.build('start');
        var markerInserted = false;
        var x = e.clientX, y = e.clientY;

        if (document.caretPositionFromPoint)
        {
            var pos = document.caretPositionFromPoint(x, y);
            var sel = document.getSelection();

            data = this.inspector.parse(pos.offsetNode);
            if (data.isInEditor())
            {
                range = sel.getRangeAt(0);
                range.setStart(pos.offsetNode, pos.offset);
                range.collapse(true);
                range.insertNode(marker);
                markerInserted = true;
            }
        }
        else if (document.caretRangeFromPoint)
        {
            range = document.caretRangeFromPoint(x, y);

            data = this.inspector.parse(range.startContainer);
            if (data.isInEditor())
            {
                range.insertNode(marker);
                markerInserted = true;
            }
        }

        return markerInserted;
    },
    insertToPoint: function(e, html, point, clean)
    {
        var pointInserted = (point === true) ? true : this.insertPoint(e);
        if (!pointInserted)
        {
            var lastNode = this.editor.getLastNode();
            $R.dom(lastNode).after(this.marker.build('start'));
        }

        this.component.clearActive();
        this.selection.restoreMarkers();

        return this.insertHtml(html, clean);
    },
    insertToOffset: function(start, html)
    {
        this.offset.set({ start: start, end: start });

        return this.insertHtml(html);
    },
    insertHtml: function(html, clean)
    {
        if (!this.opts.input) return;

        // parse
        var parsedInput = this.utils.parseHtml(html);

        // all selection
        if (this.selection.isAll())
        {
            return this._insertToAllSelected(parsedInput);
        }

        // there is no selection
        if (!this.selection.is())
        {
            var $el = $R.dom('<p>');
            var $editor = this.editor.getElement();

            $editor.append($el);
            this.caret.setStart($el);
        }

        // environment
        var isCollapsed = this.selection.isCollapsed();
        var isText = this.selection.isText();
        var current = this.selection.getCurrent();
        var dataCurrent = this.inspector.parse(current);

        // collapse air
        this._collapseSelection();

        // clean
        parsedInput = this._getCleanedInput(parsedInput, dataCurrent, clean);

        // input is figure or component span
        var isFigure = this._isFigure(parsedInput.html);
        var isComponentSpan = this._isComponentSpan(parsedInput.html);
        var isInsertedText = this.inspector.isText(parsedInput.html);
        var fragment, except;

        // empty editor
        if (this.editor.isEmpty())
        {
            return this._insertToEmptyEditor(parsedInput.html);
        }
        // to component
        else if (dataCurrent.isComponent() && !dataCurrent.isComponentEditable())
        {
            return this._insertToWidget(current, dataCurrent, parsedInput.html);
        }
        // component span
        else if (isComponentSpan)
        {
            return this.insertNode(parsedInput.nodes, 'end');
        }
        // inserting figure & split node
        else if (isFigure && !isText && !dataCurrent.isList())
        {
            if (dataCurrent.isInline())
            {
                return this._insertToInline(current, parsedInput);
            }

            fragment = this.utils.createFragment(parsedInput.html);
            this.utils.splitNode(current, fragment);
            this.caret.setEnd(fragment.last);

            return this._sendNodes(fragment.nodes);
        }
        // to code
        else if (dataCurrent.isCode())
        {
            return this._insertToCode(parsedInput, current, clean);
        }
        // to pre
        else if (dataCurrent.isPre())
        {
            return this._insertToPre(parsedInput, clean);
        }
        // to h1-h6 & figcaption
        else if (dataCurrent.isHeading() || dataCurrent.isFigcaption())
        {
            parsedInput.html = (clean !== false) ? this.cleaner.removeTagsExcept(parsedInput.html, ['a']) : parsedInput.html;
            parsedInput.html = (clean !== false) ? this.cleaner.replaceNbspToSpaces(parsedInput.html) : parsedInput.html;

            fragment = this.utils.createFragment(parsedInput.html);

            return this.insertNode(fragment, 'end');
        }
        // text inserting
        else if (isInsertedText)
        {
            if (!isText && this.opts.markup !== 'br' && this._hasBlocksAndImages(parsedInput.nodes))
            {
                parsedInput.html = (clean !== false) ? this.cleaner.paragraphize(parsedInput.html) : parsedInput.html;

                fragment = this.utils.createFragment(parsedInput.html);

                this.utils.splitNode(current, fragment);
                this.caret.setEnd(fragment.last);
                return this._sendNodes(fragment.nodes);
            }

            parsedInput.html = (clean !== false) ? parsedInput.html.replace(/\n/g, '<br>') : parsedInput.html;

            fragment = this.utils.createFragment(parsedInput.html);

            return this.insertNode(fragment.nodes, 'end');
        }
        // uncollapsed
        else if (!isCollapsed && !isFigure)
        {
            parsedInput.html = (clean !== false) ? this.cleaner.paragraphize(parsedInput.html) : parsedInput.html;

            fragment = this.utils.createFragment(parsedInput.html);

            return this.insertNode(fragment, 'end');
        }
        // to inline tag
        else if (dataCurrent.isInline() && !this._isPlainHtml(parsedInput.html))
        {
            return this._insertToInline(current, parsedInput);
        }
        // to blockquote or dt, dd
        else if (dataCurrent.isBlockquote() || dataCurrent.isDl())
        {
            except = this.opts.inlineTags;
            except.concat(['br']);

            parsedInput.html = (clean !== false) ? this.cleaner.replaceBlocksToBr(parsedInput.html) : parsedInput.html;
            parsedInput.html = (clean !== false) ? this.cleaner.removeTagsExcept(parsedInput.html, except) : parsedInput.html;

            fragment = this.utils.createFragment(parsedInput.html);

            return this.insertNode(fragment, 'end');
        }
        // to p
        else if (dataCurrent.isParagraph())
        {
            if (this._isPlainHtml(parsedInput.html))
            {
                return this.insertNode(parsedInput.nodes, 'end');
            }

            parsedInput.html = (clean !== false) ? this.cleaner.paragraphize(parsedInput.html) : parsedInput.html;

            fragment = this.utils.createFragment(parsedInput.html);

            this.utils.splitNode(current, fragment);
            this.caret.setEnd(fragment.last);

            return this._sendNodes(fragment.nodes);
        }
        // to li
        else if (dataCurrent.isList())
        {
            except = this.opts.inlineTags;
            except = except.concat(['br', 'li', 'ul', 'ol', 'img']);

            parsedInput.html = (clean !== false) ? this.cleaner.replaceBlocksToBr(parsedInput.html) : parsedInput.html;
            parsedInput.html = (clean !== false) ? this.cleaner.removeTagsExcept(parsedInput.html, except) : parsedInput.html;
            parsedInput.html = (clean !== false) ? this.cleaner.removeBrAtEnd(parsedInput.html) : parsedInput.html;

            fragment = this.utils.createFragment(parsedInput.html);
            parsedInput.nodes = fragment.nodes;

            if (this._containsTags(parsedInput.html, ['ul', 'ol', 'li']))
            {
                var element = this.selection.getElement(current);
                if (element && element.tagName === 'LI' && this.caret.isStart(element))
                {
                    parsedInput.nodes = $R.dom(fragment.nodes).unwrap('ul, ol').getAll();
                    $R.dom(element).before(parsedInput.nodes);

                    var lastNode = parsedInput.nodes[parsedInput.nodes.length-1];
                    this.caret.setEnd(lastNode);

                    return this._sendNodes(parsedInput.nodes);
                }
                else if (this._isPlainHtml(parsedInput.html))
                {
                    return this.insertNode(fragment, 'end');
                }
                else
                {
                    fragment = this._buildList(parsedInput, element, fragment);

                    this.utils.splitNode(current, fragment, true);
                    this.caret.setEnd(fragment.last);

                    return this._sendNodes(fragment.nodes);
                }
            }
        }

        // other cases
        return this.insertNode(parsedInput.nodes, 'end');
    },

    // private
    _insertToAllSelected: function(parsedInput)
    {
        var insertedHtml = this.set(parsedInput.html);
        var dataInserted = this.utils.parseHtml(insertedHtml);

        return this._sendNodes(dataInserted.nodes);
    },
    _insertToEmptyEditor: function(html)
    {
        html = this.cleaner.paragraphize(html);

        var fragment = this.utils.createFragment(html);
        var $editor = this.editor.getElement();

        $editor.html('');
        $editor.append(fragment.frag);

        this.caret.setEnd(fragment.last);

        return this._sendNodes(fragment.nodes);
    },
    _insertToInline: function(current, parsedInput)
    {
        var fragment = this.utils.createFragment(parsedInput.html);
        this.utils.splitNode(current, fragment, false, true);
        this.caret.setEnd(fragment.last);

        return this._sendNodes(fragment.nodes);
    },
    _insertToCode: function(parsedInput, current, clean)
    {
        parsedInput.html = (clean !== false) ? this.cleaner.encodeHtml(parsedInput.html) : parsedInput.html;
        parsedInput.html = (clean !== false) ? this.cleaner.removeNl(parsedInput.html) : parsedInput.html;

        var fragment = this.utils.createFragment(parsedInput.html);
        var nodes = this.insertNode(fragment, 'end');

        this.utils.normalizeTextNodes(current);

        return nodes;
    },
    _insertToPre: function(parsedInput, clean)
    {
        parsedInput.html = (clean !== false) ? this.cleaner.encodeHtml(parsedInput.html) : parsedInput.html;

        var fragment = this.utils.createFragment(parsedInput.html);

        return this.insertNode(fragment, 'end');
    },
    _insertToWidget: function(current, dataCurrent, html)
    {
        html = this.selection._isInlineNode(current) ? html : this.cleaner.paragraphize(html);

        var fragment = this.utils.createFragment(html);
        var component = dataCurrent.getComponent();
        var $component = $R.dom(component);

        $component.after(fragment.frag);
        $component.remove();

        this.caret.setEnd(fragment.last);

        return this._sendNodes(fragment.nodes);
    },
    _insertFragment: function(fragment)
    {
        var range = this.selection.getRange();
        if (range)
        {
            if (this.selection.isCollapsed())
            {
                var startNode = range.startContainer;
                if (startNode.nodeType !== 3 && startNode.tagName === 'BR')
                {
                    this.caret.setAfter(startNode);
                    startNode.parentNode.removeChild(startNode);
                }
            }
            else
            {
                range.deleteContents();
            }

            range.insertNode(fragment.frag);
        }
    },
    _sendNodes: function(nodes)
    {
        for (var i = 0; i < nodes.length; i++)
        {
            var el = nodes[i];
            var type = (el.nodeType !== 3 && typeof el.getAttribute === 'function') ? el.getAttribute('data-redactor-type') : false;
            if (type)
            {
                this.app.broadcast(type + '.inserted', this.component.build(el));
            }
        }

        if (this.detector.isIe())
        {
            this.editor.getElement().find('[data-redactor-type=table]').attr('contenteditable', true);
        }

        // callback
        this.app.broadcast('inserted', nodes);

        // widget's scripts
        this.component.executeScripts();

        return nodes;
    },
    _setCaret: function(caret, fragment)
    {
        var isLastInline = this._isLastInline(fragment);

        if (caret)
        {
            caret = (isLastInline && caret === 'end') ? 'after' : caret;
            this.caret['set' + this.utils.ucfirst(caret)](fragment.last);
        }
        else if (caret !== false)
        {
            if (isLastInline) this.caret.setAfter(fragment.last);
        }
    },
    _isLastInline: function(fragment)
    {
        if (fragment.last)
        {
            var data = this.inspector.parse(fragment.last);

            return data.isInline();
        }

        return false;
    },
    _getCleanedInput: function(parsedInput, dataCurrent, clean)
    {
        var isPreformatted = (dataCurrent.isCode() || dataCurrent.isPre());

        parsedInput.html = parsedInput.html.replace(/&nbsp;/g, ' ');
        parsedInput.html = (!isPreformatted && clean !== false) ? this.cleaner.input(parsedInput.html) : parsedInput.html;
        parsedInput = (!isPreformatted && clean !== false) ? this.utils.parseHtml(parsedInput.html) : parsedInput;

        return parsedInput;
    },
    _getContainer: function(nodes)
    {
        return $R.dom(this.utils.createTmpContainer(nodes));
    },
    _buildList: function(parsedInput, list, fragment)
    {
        var nodes = parsedInput.nodes;
        var first = nodes[0];

        if (first && first.nodeType !== 3 && first.tagName === 'li')
        {
            var $parent = $R.dom(list);
            var parentListTag = $parent.get().tagName.toLowerCase();
            var $list = $R.dom('<' + parentListTag + ' />');
            $list.append(fragment.nodes);

            return this.utils.createFragment($list.get().outerHTML);
        }

        return fragment;
    },
    _containsTags: function(html, tags)
    {
        return (this._getContainer(html).find(tags.join(',')).length !== 0);
    },
    _collapseSelection: function()
    {
        //if (this.app.isAirToolbar()) this.selection.collapseToEnd();
    },
    _hasFigureOrTable: function(nodes)
    {
        return (this._getContainer(nodes).find('figure, table').length !== 0);
    },
    _hasBlocks: function(nodes)
    {
        return (this._getContainer(nodes).find(this.opts.blockTags.join(',')).length !== 0);
    },
    _hasBlocksAndImages: function(nodes)
    {
        return (this._getContainer(nodes).find(this.opts.blockTags.join(',') + ',img').length !== 0);
    },
    _isPlainHtml: function(html)
    {
        return (this._getContainer(html).find(this.opts.blockTags.join(',') + ', img').length === 0);
    },
    _isFigure: function(html)
    {
        if (this._isHtmlString(html))
        {
            return ($R.dom(html).closest('figure').length !== 0);
        }
    },
    _isComponentSpan: function(html)
    {
        if (this._isHtmlString(html))
        {
            return ($R.dom(html).closest('span.redactor-component').length !== 0);
        }
    },
    _isHtmlString: function(html)
    {
        return !(typeof html === 'string' && !/^\s*<(\w+|!)[^>]*>/.test(html));
    }
});
$R.add('service', 'block', {
    init: function(app) {
        this.app = app;
        this.tags = ['p', 'div', 'blockquote', 'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
    },
    // format
    format: function(args) {

        // params
        this.params = {
            args: false
        };

        // type of applying styles and attributes
        this.params.type = (args.type) ? args.type : 'set'; // add, remove, toggle

        // tag
        this.params.tag = (typeof args === 'string') ? args : (args.tag || this.opts.markup);
        this.params.tag = this.params.tag.toLowerCase();

        // args
        this.params.args = {
            'class': args['class'] || false,
            'style': args['style'] || false,
            'attr': args['attr'] || false
        };

        if (!args['class'] && !args['style'] && !args['attr']) {
            this.params.args = false;
        }

        // format
        return this._format();
    },

    // funcs
    add: function(args, tags) {
        return this._apply('add', args, tags);
    },
    set: function(args, tags) {
        return this._apply('set', args, tags);
    },
    toggle: function(args, tags) {
        return this._apply('toggle', args, tags);
    },
    remove: function(args, tags) {
        return this._apply('remove', args, tags);
    },

    // clear
    clearFormat: function(tags) {
        return this._clear(tags, 'all');
    },
    clearStyle: function(tags) {
        return this._clear(tags, 'style');
    },
    clearClass: function() {
        return this._clear(tags, 'class');
    },
    clearAttr: function() {
        return this._clear(tags, 'attr');
    },

    // format
    _format: function() {

        var nodes = [];

        // collapsed
        this.collapsed = this.selection.isCollapsed();

        // save selection
        this.selection.save();

        // blocks
        var block = this.selection.getBlock();
        var blocks = this._getBlocks();
        var type = (this._isToggleFormatType(blocks)) ? 'toggle' : 'set';
        var replacedTag = this._getReplacedTag(type);

        nodes = this._replaceBlocks(blocks, replacedTag);


        // apply args & clean
        nodes = this._buildNodes(nodes);

        // restore selection
        this._restoreSelection(nodes);

        return nodes;
    },


    // clear
    _clear: function(tags, type, selection, nodes) {
        // save selection
        if (selection !== false) {
            this.selection.save();
        }

        // get elements
        var $elements = this._getElements(tags, nodes);

        // remove all format
        if (type === 'all') {
            this._removeAllAttr($elements, false);
        }
        // remove style
        else if (type === 'style') {
            $elements.removeAttr('style');
            $elements.removeAttr('data-redactor-style-cache');
        }
        // remove class
        else if (type === 'class') {
            $elements.removeAttr('class');
        }
        // remove attrs
        else if (type === 'attr') {
            this._removeAllAttr($elements);
        }

        // get nodes
        nodes = $elements.getAll();

        // restore selection
        if (selection !== false) {
            this._restoreSelection(nodes);
        }

        return nodes;
    },

    // get
    _getElements: function(tags, nodes) {
        return (nodes) ? $R.dom(nodes) : $R.dom(this._getBlocks(tags));
    },
    _getBlocks: function(tags) {
        var blocks = this.selection.getBlocks({ tags: tags || this.tags });
        var finalBlocks = [];
        for (var i = 0; i < blocks.length; i++) {
            if (blocks[i].tagName === 'DIV' && !blocks[i].getAttribute('data-redactor-tag')) {
                continue;
            }
            else {
                finalBlocks.push(blocks[i]);
            }
        }

        return finalBlocks;
    },

    _getReplacedTag: function(type) {
        if (this.opts.breakline) {
            return (type === 'toggle') ? 'div' : (this.params.tag === 'p') ? 'div' : this.params.tag;
        }
        else {
            return (type === 'toggle') ? this.opts.markup : this.params.tag;
        }
    },

    // is
    _isStandardParagraph: function() {
        return (!this.opts.breakline && this.opts.markup === 'p');
    },
    _isStandardDiv: function() {
        return (!this.opts.breakline && this.opts.markup === 'div');
    },
    _isBreaklineBlock: function(block) {
        return (block && block.tagName === 'DIV' && block.getAttribute('data-redactor-tag') === 'br');
    },
    _isToggleFormatType: function(blocks) {
        var count = 0;
        var len = blocks.length;
        for (var i = 0; i < len; i++) {
            if (blocks[i] && this.params.tag === blocks[i].tagName.toLowerCase()) count++;
        }

        return (count === len);
    },
    _isCurrentBlockOneAndEmpty: function(nodes) {
        return (this.collapsed && nodes.length === 1 && this.utils.isEmpty(nodes[0]));
    },

    // build
    _buildNodes: function(nodes) {
        if (nodes.length > 0) {
            // clean & appliyng styles and attributes
            nodes = this._applyArgs(nodes, false);
            nodes = this._combinePre(nodes);
            nodes = this._cleanBlocks(nodes);
        }

        return nodes;
    },

    // replace
    _replaceBlocks: function(blocks, replacedTag) {
        var nodes = [];

        for (var i = 0; i < blocks.length; i++) {
            var $node = this.utils.replaceToTag(blocks[i], replacedTag);
            nodes.push($node.get());
        }

        return nodes;
    },

    // combine
    _combinePre: function(nodes) {
        var combinedNodes = [];
        for (var i = 0; i < nodes.length; i++) {
            var next = nodes[i].nextElementSibling;
            if (next && nodes[i].tagName === 'PRE' && next.tagName === 'PRE') {
                var $current = $R.dom(nodes[i]);
                var $next = $R.dom(next);
                var newline = document.createTextNode('\n');

                $current.append(newline);
                $current.append($next);
                $next.unwrap('pre');
            }

            combinedNodes.push(nodes[i]);
        }

        return combinedNodes;
    },

    // clean
    _cleanBlocks: function(nodes) {
        var headings = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
        var tags = this.opts.inlineTags;
        for (var i = 0; i < nodes.length; i++) {
            var tag = nodes[i].tagName.toLowerCase();
            var $node = $R.dom(nodes[i]);

            // remove all spans in headings
            if (headings.indexOf(tag) !== - 1) {
                $node.find('span').not('.redactor-component, .non-editable, .redactor-selection-marker').unwrap();
            }
            // remove all inlines in pre
            else if (tag === 'pre') {
                $node.find(tags.join(',')).not('.redactor-selection-marker').unwrap();
            }

            // breakline attr
            if (this.opts.breakline && tag === 'div') {
                $node.attr('data-redactor-tag', 'br');
            }
            else {
                $node.removeAttr('data-redactor-tag');
            }

            // normalize
            this.utils.normalizeTextNodes(nodes[i]);
        }

        return nodes;
    },
    _cleanEmptyClass: function($elements) {
        $elements.each(function(node) {
            if (node.className === '') node.removeAttribute('class');
        });
    },
    _cleanEmptyStyle: function($node) {
         if (this.utils.removeEmptyAttr($node.get(), 'style')) {
            $node.removeAttr('data-redactor-style-cache');
        }
        else {
            $node.attr('data-redactor-style-cache', $node.attr('style'));
        }
    },

    // apply
    _apply: function(type, args, tags, selection, nodes) {
        // save selection
        if (selection !== false) {
            this.selection.save();
        }

        // get elements
        var $elements = this._getElements(tags, nodes);

        // class
        if (args['class']) {
            if (type === 'set') {
                $elements.removeAttr('class');
                $elements.addClass(args['class']);
            }
            else if (type === 'add') {
                $elements.addClass(args['class']);
            }
            else if (type === 'toggle') {
                $elements.toggleClass(args['class']);
            }
            else if (type === 'remove') {
                $elements.removeClass(args['class']);
            }

            this._cleanEmptyClass($elements);
        }

        // attr
        if (args['attr']) {
            if (type === 'set') {
                this._removeAllAttr($elements);
                $elements.attr(args['attr']);
            }
            else if (type === 'add') {
                $elements.attr(args['attr']);
            }
            else if (type === 'toggle') {
                params = args['attr'];
                $elements.each(function(node) {
                    var $node = $R.dom(node);
                    for (var key in params) {
                        if ($node.attr(key)) $node.removeAttr(key);
                        else $node.attr(key, params[key]);
                    }
                });
            }
            else if (type === 'remove') {
                $elements.removeAttr(args['attr']);
            }
        }

        // style
        if (args['style']) {
            if (type === 'set') {
                $elements.removeAttr('style');
                $elements.css(args['style']);
                $elements.each(function(node) {
                    var $node = $R.dom(node);
                    $node.attr('data-redactor-style-cache', $node.attr('style'));
                });
            }
            else if (type === 'add') {
                var params = args['style'];
                $elements.each(function(node) {
                    var $node = $R.dom(node);
                    $node.css(params);
                    $node.attr('data-redactor-style-cache', $node.attr('style'));
                    this._convertStyleQuotes($node);
                }.bind(this));
            }
            else if (type === 'toggle') {
                var params = args['style'];
                $elements.each(function(node) {
                    var $node = $R.dom(node);
                    for (var key in params) {
                        var newVal = params[key];
                        var oldVal = $node.css(key);

                        oldVal = (this.utils.isRgb(oldVal)) ? this.utils.rgb2hex(oldVal) : oldVal.replace(/"/g, '');
                        newVal = (this.utils.isRgb(newVal)) ? this.utils.rgb2hex(newVal) : newVal.replace(/"/g, '');

                        oldVal = this.utils.hex2long(oldVal);
                        newVal = this.utils.hex2long(newVal);

                        var compareNew = (typeof newVal === 'string') ? newVal.toLowerCase() : newVal;
                        var compareOld = (typeof oldVal === 'string') ? oldVal.toLowerCase() : oldVal;

                        if (compareNew === compareOld) $node.css(key, '');
                        else $node.css(key, newVal);
                    }

                    this._convertStyleQuotes($node);
                    this._cleanEmptyStyle($node);
                }.bind(this));
            }
            else if (type === 'remove') {
                var name = args['style'];
                $elements.each(function(node) {
                    var $node = $R.dom(node);
                    $node.css(name, '');
                    this._cleanEmptyStyle($node);
                }.bind(this));
            }
        }

        // get nodes
        nodes = $elements.getAll();

        // restore selection
        if (selection !== false) {
            this._restoreSelection(nodes);
        }

        return nodes;
    },
    _applyArgs: function(nodes) {
        if (this.params.args) {
            nodes = this._apply(this.params.type, this.params.args, false, false, nodes);
        }
        else {
            nodes = this._clear(false, 'all', false, nodes);
        }

        return nodes;
    },

    // remove
    _removeAllAttr: function($elements, keepStyleAndClass) {
        $elements.each(function(node) {
            var keepAttrs = ['data-redactor-tag', 'data-redactor-style-cache'];
            if (keepStyleAndClass === false) {
                keepAttrs.push('style');
                keepAttrs.push('class');
            }

            for (var i = node.attributes.length; i--> 0;) {
                var nodeAttr = node.attributes[i];
                var name = nodeAttr.name;
                if (keepAttrs.indexOf(name) === -1) {
                    node.removeAttributeNode(nodeAttr);
                }
            }
        });
    },

    // selection
    _restoreSelection: function(nodes) {
        if (this._isCurrentBlockOneAndEmpty(nodes)) {
            this.caret.setStart(nodes[0]);
        }
        else {
            setTimeout(function() { this.selection.restore(); }.bind(this), 1);
        }
    },

    // convert
    _convertStyleQuotes: function($node) {
        var style = $node.attr('style');
        if (style) $node.attr('style', style.replace(/"/g, '\''));
    }
});
$R.add('service', 'inline', {
    mixins: ['formatter'],
    init: function(app)
    {
        this.app = app;

        this.count = 0;
    },
    // public
    format: function(args)
    {
        if (!this._isFormat()) return [];

        // type of applying styles and attributes
        this.type = (args.type) ? args.type : 'set'; // add, remove, toggle
        // tag
        this.tag = (typeof args === 'string') ? args : args.tag;
        this.tag = this.tag.toLowerCase();
        this.tag = this.arrangeTag(this.tag);

        if (typeof args === 'string') this.args = false;
        else this.buildArgs(args);

        if (!this.detector.isIe())
        {
            this.editor.disableNonEditables();
        }

        // format
        var nodes = (this.selection.isCollapsed()) ? this.formatCollapsed() : this.formatUncollapsed();

        if (!this.detector.isIe())
        {
            this.editor.enableNonEditables();
        }

        return nodes;
    },

    // private
    _isFormat: function()
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var isComponent = (data.isComponent() && !data.isComponentType('table') && !data.isFigcaption());

        if (current === false && this.selection.isAll())
        {
            return true;
        }
        else if (!current || data.isPre() || data.isCode() || isComponent)
        {
            return false;
        }

        return true;
    },
    arrangeTag: function(tag)
    {
        var replaced = this.opts.replaceTags;
        for (var key in replaced)
        {
            if (tag === key) tag = replaced[key];
        }

        return tag;
    },
    formatCollapsed: function()
    {
        var nodes = [];
        var inline = this.selection.getInlineFirst();
        var inlines = this.selection.getInlines({ all: true });
        var $inline = $R.dom(inline);
        var $parent, parent, $secondPart, extractedContent;

        // 1) not inline
        if (!inline)
        {
            nodes = this.insertInline(nodes);
        }
        else
        {
            var dataInline = this.inspector.parse(inline);
            var isEmpty = this.utils.isEmptyHtml(inline.innerHTML);

            // 2) inline is empty
            if (isEmpty)
            {
                // 2.1) has same tag
                if (inline.tagName.toLowerCase() === this.tag)
                {
                    // 2.1.1) has same args or hasn't args
                    if (this.hasSameArgs(inline))
                    {
                        this.caret.setAfter(inline);
                        $inline.remove();

                        var el = this.selection.getElement();
                        this.utils.normalizeTextNodes(el);
                    }
                    // 2.1.2) has different args and it is span tag
                    else if (this.tag === 'span')
                    {
                        nodes = this.applyArgs([inline], false);
                        this.caret.setStart(inline);
                    }
                    // 2.1.3) has different args and it is not span tag
                    else
                    {
                       nodes = this.insertInline(nodes);
                    }

                }
                // 2.2) has another tag
                else
                {
                    // 2.2.1) has parent
                    if (dataInline.hasParent([this.tag]))
                    {
                        $parent = $inline.closest(this.tag);
                        parent = $parent.get();
                        if (this.hasSameArgs(parent))
                        {
                            $parent.unwrap();
                            this.caret.setStart(inline);
                        }
                        else
                        {
                            nodes = this.insertInline(nodes);
                        }
                    }
                    // 2.2.2) hasn't parent
                    else
                    {
                        nodes = this.insertInline(nodes);
                    }
                }
            }
            // 3) inline isn't empty
            else
            {
                // 3.1) has same tag
                if (inline.tagName.toLowerCase() === this.tag)
                {
                    // 3.1.1) has same args or hasn't args
                    if (this.hasSameArgs(inline))
                    {
                        // insert break
                        extractedContent = this.utils.extractHtmlFromCaret(inline);
                        $secondPart = $R.dom('<' + this.tag + ' />');
                        $secondPart = this.utils.cloneAttributes(inline, $secondPart);

                        $inline.after($secondPart.append(extractedContent));

                        this.caret.setAfter(inline);
                    }
                    else
                    {
                        nodes = this.insertInline(nodes);
                    }
                }
                // 3.2) has another tag
                else
                {
                    // 3.2.1) has parent
                    if (dataInline.hasParent([this.tag]))
                    {
                        $parent = $inline.closest(this.tag);
                        parent = $parent.get();
                        if (this.hasSameArgs(parent))
                        {
                            // insert break
                            extractedContent = this.utils.extractHtmlFromCaret(parent, parent);
                            $secondPart = $R.dom('<' + this.tag + ' />');
                            $secondPart = this.utils.cloneAttributes(parent, $secondPart);

                            var $breaked, $last;
                            var z = 0;
                            inlines = inlines.reverse();
                            for (var i = 0; i < inlines.length; i++)
                            {
                                if (inlines[i] !== parent)
                                {
                                    $last = $R.dom('<' + inlines[i].tagName.toLowerCase() + '>');
                                    if (z === 0)
                                    {
                                        $breaked = $last;
                                    }
                                    else
                                    {
                                        $breaked.append($last);
                                    }

                                    z++;
                                }
                            }

                            $parent.after($secondPart.append(extractedContent));
                            $parent.after($breaked);

                            this.caret.setStart($last);
                        }
                        else
                        {
                            nodes = this.insertInline(nodes);
                        }
                    }
                    // 3.2.2) hasn't parent
                    else
                    {
                        nodes = this.insertInline(nodes);
                    }
                }
            }
        }

        return nodes;
    },
    insertInline: function(nodes)
    {
        var node = document.createElement(this.tag);
        nodes = this.insertion.insertNode(node, 'start');

        return this.applyArgs(nodes, false);
    },
    hasSameArgs: function(inline)
    {
        if (inline.attributes.length === 0 && this.args === false)
        {
            return true;
        }
        else
        {
            var same = true;
            if (this.args)
            {
                var count = 0;
                for (var key in this.args)
                {
                    var $node = $R.dom(inline);
                    var args = (this.args[key]);
                    var value = this.utils.toParams(args);
                    var nodeAttrValue = $node.attr(key);

                    if (args)
                    {
                        if (key === 'style')
                        {
                            value = value.trim().replace(/;$/, '');

                            var origRules = this.utils.styleToObj($node.attr('style'));
                            var rules = value.split(';');
                            var innerCount = 0;

                            for (var i = 0; i < rules.length; i++)
                            {
                                var arr = rules[i].split(':');
                                var ruleName = arr[0].trim();
                                var ruleValue = arr[1].trim();

                                if (ruleName.search(/color/) !== -1)
                                {
                                    var val = $node.css(ruleName);
                                    if (val && (val === ruleValue || this.utils.rgb2hex(val) === ruleValue))
                                    {
                                        innerCount++;
                                    }
                                }
                                else if ($node.css(ruleName) === ruleValue)
                                {
                                    innerCount++;
                                }
                            }

                            if (innerCount === rules.length && Object.keys(origRules).length === rules.length)
                            {
                                count++;
                            }
                        }
                        else
                        {
                            if (nodeAttrValue === value)
                            {
                                count++;
                            }
                        }
                    }
                    else
                    {
                        if (!nodeAttrValue || nodeAttrValue === '')
                        {
                            count++;
                        }
                    }
                }

                same = (count === Object.keys(this.args).length);
            }

            return same;
        }
    },
    formatUncollapsed: function()
    {
        var inlines = this.selection.getInlines({ all: true, inside: true });

        if (this.detector.isIe()) this.selection.saveMarkers();
        else this.selection.save();

        // convert del / u
        this._convertTags('u');
        this._convertTags('del');

        // convert target tags
        this._convertToStrike(inlines);

        if (this.detector.isIe()) this.selection.restoreMarkers();
        else this.selection.restore();

        // apply strike
        document.execCommand('strikethrough');

        // clear decoration
        this._clearDecoration();

        this.selection.save();

        // revert and set style
        var nodes = this._revertToInlines();
        nodes = this.applyArgs(nodes, false);

        // unwrap if attributes was removed
        for (var i = 0; i < nodes.length; i++)
        {
            var node = nodes[i];
            var tag = node.tagName.toLowerCase();
            var len = node.attributes.length;

            if (tag === this.tag && len === 0 && this.args)
            {
                $R.dom(node).unwrap();
                nodes.splice(i, 1);
            }
        }

        this.selection.restore();

        // clear and normalize
        this._clearEmptyStyle();
        nodes = this._normalizeBlocks(nodes);

        return nodes;
    },
    _convertTags: function(tag)
    {
        if (this.tag !== tag)
        {
            var $editor = this.editor.getElement();
            $editor.find(tag).each(function(node)
            {
                var $el = this.utils.replaceToTag(node, 'span');
                $el.addClass('redactor-convertable-' + tag);
            }.bind(this));
        }
    },
    _revertTags: function(tag)
    {
        var $editor = this.editor.getElement();

        $editor.find('span.redactor-convertable-' + tag).each(function(node)
        {
            var $el = this.utils.replaceToTag(node, tag);
            $el.removeClass('redactor-convertable-' + tag);
            if (this.utils.removeEmptyAttr($el, 'class')) $el.removeAttr('class');

        }.bind(this));
    },
    _convertToStrike: function(inlines)
    {
        var selected = this.selection.getText().replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");

        for (var i = 0; i < inlines.length; i++)
        {
            var tag = this.arrangeTag(inlines[i].tagName.toLowerCase());
            var inline = inlines[i];
            var $inline = $R.dom(inline);
            var hasSameArgs = this.hasSameArgs(inline);

            if (tag === this.tag)
            {
                if (this.tag === 'span' && this._isTextSelected(inline, selected))
                {
                    $inline.addClass('redactor-convertable-apply');
                }
                else if (hasSameArgs && this.tag !== 'a')
                {
                    this._replaceToStrike($inline);
                }
                else if (this.tag === 'span')
                {
                    $inline.addClass('redactor-unconvertable-apply');
                }
                else if (!hasSameArgs)
                {
                    $inline.addClass('redactor-convertable-apply');
                }
            }
        }
    },
    _replaceToStrike: function($el)
    {
        $el.replaceWith(function()
        {
            return $R.dom('<strike>').append($el.contents());
        });
    },
    _revertToInlines: function()
    {
        var nodes = [];
        var $editor = this.editor.getElement();

        if (this.tag !== 'u') $editor.find('u').unwrap();

        // span convertable
        $editor.find('.redactor-convertable-apply').each(function(node)
        {
            var $node = $R.dom(node);
            $node.find('strike').unwrap();

            this._forceRemoveClass($node, 'redactor-convertable-apply');
            nodes.push(node);

        }.bind(this));

        // span unconvertable
        $editor.find('span.redactor-unconvertable-apply').each(function(node)
        {
            var $node = $R.dom(node);
            this._forceRemoveClass($node, 'redactor-unconvertable-apply');

        }.bind(this));

        // strike
        $editor.find('strike').each(function(node)
        {
            var $node = this.utils.replaceToTag(node, this.tag);
            nodes.push($node.get());

        }.bind(this));


        this._revertTags('u');
        this._revertTags('del');

        return nodes;
    },
    _normalizeBlocks: function(nodes)
    {
        var tags = this.opts.inlineTags;
        var blocks = this.selection.getBlocks();
        if (blocks)
        {
            for (var i = 0; i < blocks.length; i++)
            {
                if (blocks[i].tagName === 'PRE')
                {
                    var $node = $R.dom(blocks[i]);
                    $node.find(tags.join(',')).not('.redactor-selection-marker').each(function(inline)
                    {
                        if (nodes.indexOf(inline) !== -1)
                        {
                            nodes = this.utils.removeFromArrayByValue(nodes, inline);
                        }

                        $R.dom(inline).unwrap();
                    }.bind(this));
                }
            }
        }

        return nodes;
    },
    _clearDecoration: function()
    {
        var $editor = this.editor.getElement();
        $editor.find(this.opts.inlineTags.join(',')).each(function(node)
        {
            if (node.style.textDecoration === 'line-through' || node.style.textDecorationLine === 'line-through')
            {
                var $el = $R.dom(node);
                $el.css('textDecorationLine', '');
                $el.css('textDecoration', '');
                $el.wrap('<strike>');
            }
        });
    },
    _clearEmptyStyle: function()
    {
        var inlines = this.getInlines();
        for (var i = 0; i < inlines.length; i++)
        {
            this._clearEmptyStyleAttr(inlines[i]);

            var childNodes = inlines[i].childNodes;
            if (childNodes)
            {
                for (var z = 0; z < childNodes.length; z++)
                {
                    this._clearEmptyStyleAttr(childNodes[z]);
                }
            }
        }
    },
    _clearEmptyStyleAttr: function(node)
    {
        if (node.nodeType !== 3 && this.utils.removeEmptyAttr(node, 'style'))
        {
            node.removeAttribute('style');
            node.removeAttribute('data-redactor-style-cache');
        }
    },
    _forceRemoveClass: function($node, classname)
    {
        $node.removeClass(classname);
        if (this.utils.removeEmptyAttr($node, 'class')) $node.removeAttr('class');
    },
    _isTextSelected: function(node, selected)
    {
        var text = this.utils.removeInvisibleChars(node.textContent);

        return (selected === text || selected.search(new RegExp('^' + this.utils.escapeRegExp(text) + '$')) !== -1);
    },

    getInlines: function(tags)
    {
        return (tags) ? this.selection.getInlines({ tags: tags, all: true }) : this.selection.getInlines({ all: true });
    },
    getElements: function(tags)
    {
        return $R.dom(this.getInlines(tags));
    },
    clearFormat: function()
    {
        this.selection.save();

        var nodes = this.selection.getInlines({ all: true });
        for (var i = 0; i < nodes.length; i++)
        {
            var $el = $R.dom(nodes[i]);
            var inline = this.selection.getInline(nodes[i]);
            if (inline)
            {
                $el.unwrap();
            }
        }

        this.selection.restore();
    }
});
$R.add('service', 'autoparser', {
    init: function(app)
    {
        this.app = app;
    },
    observe: function()
    {
        var $editor = this.editor.getElement();
        var $objects = $editor.find('.redactor-autoparser-object').each(function(node)
        {
           var $node = $R.dom(node);
           $node.removeClass('redactor-autoparser-object');
           if ($node.attr('class') === '') $node.removeAttr('class');
        });

        if ($objects.length > 0)
        {
            $objects.each(function(node)
            {
                var type;
                var $object = false;
                var tag = node.tagName;

                if (tag === 'A') type = 'link';
                else if (tag === 'IMG') type = 'image';
                else if (tag === 'IFRAME') type = 'video';

                if (type)
                {
                    $object = $R.create(type + '.component', this.app, node);
                    this.app.broadcast(type + '.inserted', $object);
                    this.app.broadcast('autoparse', type, $object);
                }

            }.bind(this));
        }
    },
    format: function(e, key)
    {
        if (this._isKey(key))
        {
            this._format(key === this.keycodes.ENTER);
        }
    },
    parse: function(html)
    {
        var tags = ['figure', 'form', 'pre', 'iframe', 'code', 'a', 'img'];
        var stored = [];
        var z = 0;

        // encode
        html = this.cleaner.encodePreCode(html);

        // store tags
        for (var i = 0; i < tags.length; i++)
        {
            var reTags = (tags[i] === 'img') ? '<' + tags[i] + '[^>]*>' : '<' + tags[i] + '([\\w\\W]*?)</' + tags[i] + '>';
            var matched = html.match(new RegExp(reTags, 'gi'));

            if (matched !== null)
            {
                for (var y = 0; y < matched.length; y++)
                {
                    html = html.replace(matched[y], '#####replaceparse' + z + '#####');
                    stored.push(matched[y]);
                    z++;
                }
            }
        }

        // images
        if (this.opts.autoparseImages && html.match(this.opts.regex.imageurl))
        {
            var imagesMatches = html.match(this.opts.regex.imageurl);
            for (var i = 0; i < imagesMatches.length; i++)
            {
                html = html.replace(imagesMatches[i], '<img class="redactor-autoparser-object" src="' + imagesMatches[i] + '">');
            }
        }

        // video
        if (this.opts.autoparseVideo && (html.match(this.opts.regex.youtube) || html.match(this.opts.regex.vimeo)))
        {
            var iframeStart = '<iframe width="500" height="281" src="';
            var iframeEnd = '" frameborder="0" allowfullscreen></iframe>';

            var str, re;
            if (html.match(this.opts.regex.youtube))
            {
                str = '//www.youtube.com/embed/$1';
                re = this.opts.regex.youtube;
            }
            else if (html.match(this.opts.regex.vimeo))
            {
                str = '//player.vimeo.com/video/$2';
                re = this.opts.regex.vimeo;
            }

            var $video = this.component.create('video', iframeStart + str + iframeEnd);

            html = html.replace(re, $video.get().outerHTML);
        }

        // links
        if (this.opts.autoparseLinks && html.match(this.opts.regex.url))
        {
            html = this._formatLinks(html);
        }

        // restore
        html = this._restoreReplaced(stored, html);

        // repeat for nested tags
        html = this._restoreReplaced(stored, html);

        return html;
    },

    // private
    _isKey: function(key)
    {
        return (key === this.keycodes.ENTER || key === this.keycodes.SPACE);
    },
    _format: function(enter)
    {
        var parent = this.selection.getParent();
        var $parent = $R.dom(parent);

        var isNotFormatted = (parent && $parent.closest('figure, pre, code, img, a, iframe').length !== 0);
        if (isNotFormatted || !this.selection.isCollapsed())
        {
            return;
        }

        // add split marker
        var marker = this.utils.createInvisibleChar();
        var range = this.selection.getRange();
        range.insertNode(marker);

        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var $current = $R.dom(current);

        // remove split marker
        marker.parentNode.removeChild(marker);

        if (current && current.nodeType === 3)
        {
            var content = current.textContent;
            var type;

            // images
            if (this.opts.autoparseImages && content.match(this._convertToRegExp(this.opts.regex.imageurl)))
            {
                var isList = data.isList();
                var matches = content.match(this.opts.regex.imageurl);
                var el = (isList) ? undefined : '<figure><img></figure>';

                var $img = this.component.create('image', el);
                $img.setSrc(matches[0]);
                $img.addClass('redactor-autoparser-object');

                content = content.replace(matches[0], $img.get().outerHTML);
                type = 'image';
            }
            // video
            else if (this.opts.autoparseVideo && (content.match(this._convertToRegExp(this.opts.regex.youtube)) || content.match(this._convertToRegExp(this.opts.regex.vimeo))))
            {
                var iframeStart = '<iframe width="500" height="281" src="';
                var iframeEnd = '" frameborder="0" allowfullscreen></iframe>';
                var str, re;

                if (content.match(this.opts.regex.youtube))
                {
                    str = '//www.youtube.com/embed/$1';
                    re = this.opts.regex.youtube;
                }
                else if (content.match(this.opts.regex.vimeo))
                {
                    str = '//player.vimeo.com/video/$2';
                    re = this.opts.regex.vimeo;
                }

                var $video = this.component.create('video', iframeStart + str + iframeEnd);
                $video.addClass('redactor-autoparser-object');

                content = content.replace(re, $video.get().outerHTML);
                type = 'video';
            }
            // links
            else if (this.opts.autoparseLinks && content.match(this._convertToRegExp(this.opts.regex.url)))
            {
                content = this._formatLinks(content, enter);
                type = 'link';
            }

            // replace
            if (type)
            {
                if (enter)
                {
                    this.selection.save();
                    $current.replaceWith(content);
                    this.selection.restore();
                }
                else
                {
                    $current.replaceWith(content);
                }

                // object
                var $editor = this.editor.getElement();
                var $object = $editor.find('.redactor-autoparser-object').removeClass('redactor-autoparser-object');
                $object = (type === 'link') ? $R.create('link.component', this.app, $object) : $object;

                // caret
                if (type === 'link')
                {
                    if (!enter) this.caret.setAfter($object);
                    this.app.broadcast('link.inserted', $object);
                }
                else
                {
                    this.caret.setAfter($object);

                    var $cloned = $object.clone();
                    $object.remove();
                    $object = this.insertion.insertHtml($cloned);
                    $object = this.component.build($object);
                }

                // callback
                this.app.broadcast('autoparse', type, $object);
            }
        }
    },
    _formatLinks: function(content, enter)
    {
        var matches = content.match(this.opts.regex.url);
        var obj = {};
        for (var i = 0; i < matches.length; i++)
        {
            if (enter && matches[i].search(/\.$/) !== -1)
            {
                matches[i] = matches[i].replace(/\.$/, '');
            }

            var href = matches[i], text = href;
            var linkProtocol = (href.match(/(https?|ftp):\/\//i) !== null) ? '' : 'http://';
            var regexB = (["/", "&", "="].indexOf(href.slice(-1)) !== -1) ? "" : "\\b";
            var target = (this.opts.pasteLinkTarget !== false) ? ' target="' + this.opts.pasteLinkTarget + '"' : '';

            text = (text.length > this.opts.linkSize) ? text.substring(0, this.opts.linkSize) + '...' : text;
            text = (text.search('%') === -1) ? decodeURIComponent(text) : text;

            // escaping url
            var regexp = '(' + href.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&") + regexB + ')';
            var classstr = ' class="redactor-autoparser-object"';

            obj[regexp] = '<a href="' + linkProtocol + href.trim() + '"' + target + classstr + '>' + text.trim() + '</a>';
        }

        // replace
        for (var key in obj)
        {
            content = content.replace(new RegExp(key, 'g'), obj[key]);
        }

        return content;
    },
    _restoreReplaced: function(stored, html)
    {
        for (var i = 0; i < stored.length; i++)
        {
            html = html.replace('#####replaceparse' + i + '#####', stored[i]);
        }

        return html;
    },
    _convertToRegExp: function(str)
    {
        return new RegExp(String(str).replace(/^\//, '').replace(/\/ig$/, '').replace(/\/gi$/, '') + '$', 'gi');
    }
});
$R.add('service', 'storage', {
    init: function(app)
    {
        this.app = app;

        // local
        this.data = [];
    },
    // public
    observeImages: function()
    {
        if (this.opts.imageObserve) {
            var $editor = this.editor.getElement();
            var $images = $editor.find('[data-image]');
            $images.each(this._addImage.bind(this));
        }
    },
    observeFiles: function()
    {
        var $editor = this.editor.getElement();
        var $files = $editor.find('[data-file]');

        $files.each(this._addFile.bind(this));
    },
    setStatus: function(url, status)
    {
        this.data[url].status = status;
    },
    getChanges: function()
    {
        var $editor = this.editor.getElement();

        // check status
        for (var key in this.data)
        {
            var data = this.data[key];
            var $el = $editor.find('[data-' + data.type + '="' + data.id + '"]');

            this.setStatus(data.id, ($el.length === 0) ? false : true);
        }

        return this.data;
    },
    add: function(type, node)
    {
        var $node = $R.dom(node);
        var id = $node.attr('data-' + type);

        this.data[id] = { type: type, status: true, node: $node.get(), id: $node.attr('data-' + type) };
    },

    // private
    _addImage: function(node)
    {
        this.add('image', node);
    },
    _addFile: function(node)
    {
        this.add('file', node);
    }
});
$R.add('service', 'utils', {
    init: function(app)
    {
        this.app = app;
    },
    // empty
    isEmpty: function(el)
    {
        var isEmpty = false;
        el = $R.dom(el).get();
        if (el)
        {
            isEmpty = (el.nodeType === 3) ? (el.textContent.trim().replace(/\n/, '') === '') : (el.innerHTML === '');
        }

        return isEmpty;
    },
    isEmptyHtml: function(html, keepbr, keeplists)
    {
        html = this.removeInvisibleChars(html);
        html = html.replace(/&nbsp;/gi, '');
        html = html.replace(/<\/?br\s?\/?>/g, ((keepbr) ? 'br' : ''));
        html = html.replace(/\s/g, '');
        html = html.replace(/^<p>[^\W\w\D\d]*?<\/p>$/i, '');
        html = html.replace(/^<div>[^\W\w\D\d]*?<\/div>$/i, '');

        if (keeplists)
        {
            html = html.replace(/<ul(.*?[^>])>$/i, 'ul');
            html = html.replace(/<ol(.*?[^>])>$/i, 'ol');
        }

        html = html.replace(/<hr(.*?[^>])>$/i, 'hr');
        html = html.replace(/<iframe(.*?[^>])>$/i, 'iframe');
        html = html.replace(/<source(.*?[^>])>$/i, 'source');

        // remove empty tags
        html = html.replace(/<[^\/>][^>]*><\/[^>]+>/gi, '');
        html = html.replace(/<[^\/>][^>]*><\/[^>]+>/gi, '');

        // trim
        html = html.trim();

        return html === '';
    },
    trimSpaces: function(html)
    {
        return html = this.removeInvisibleChars(html.trim());
    },

    // invisible chars
    createInvisibleChar: function()
    {
        return document.createTextNode(this.opts.markerChar);
    },
    searchInvisibleChars: function(str)
    {
        return str.search(/^\uFEFF$/g);
    },
    removeInvisibleChars: function(html)
    {
        return html.replace(/\uFEFF/g, '');
    },
    trimInvisibleChars: function(direction)
    {
        if (!this.selection.isCollapsed()) return;

        var current = this.selection.getCurrent();
        var side = (direction === 'left') ? this.selection.getTextBeforeCaret() : this.selection.getTextAfterCaret();
        var isSpace = (current && current.nodeType === 3 && this.searchInvisibleChars(side) === 0);

        if (isSpace)
        {
            if (direction === 'left')
            {
                $R.dom(current).replaceWith(current.textContent.trim());
            }
            else
            {
                var offset = this.offset.get();
                this.offset.set({ start: offset.start + 1, end: offset.end + 1 });
            }
        }
    },

    // wrapper
    buildWrapper: function(html)
    {
        return $R.dom('<div>').html(html);
    },
    getWrapperHtml: function($wrapper)
    {
        var html = $wrapper.html();
        $wrapper.remove();

        return html;
    },

    // fragment
    createTmpContainer: function(html)
    {
        var $div = $R.dom('<div>');

        if (typeof html === 'string')
        {
            $div.html(html);
        }
        else
        {
            $div.append($R.dom(html).clone(true));
        }

        return $div.get();
    },
    createFragment: function(html)
    {
        var el = this.createTmpContainer(html);
        var frag = document.createDocumentFragment(), node, firstNode, lastNode;
        var nodes = [];
        var i = 0;
        while ((node = el.firstChild))
        {
            i++;
            var n = frag.appendChild(node);
            if (i === 1) firstNode = n;

            nodes.push(n);
            lastNode = n;
        }

        return { frag: frag, first: firstNode, last: lastNode, nodes: nodes };
    },
    isFragment: function(obj)
    {
        return (typeof obj === 'object' && obj.frag);
    },
    parseHtml: function(html)
    {
        var div = this.createTmpContainer(html);

        return { html: div.innerHTML, nodes: div.childNodes };
    },

    splitNode: function(current, nodes, isList, inline)
    {
        nodes = (this.isFragment(nodes)) ? nodes.frag : nodes;

        var element;
        if (inline)
        {
            element = (this.inspector.isInlineTag(current.tagName)) ? current : this.selection.getInline(current);
        }
        else
        {
            element = (this.inspector.isBlockTag(current.tagName)) ? current : this.selection.getBlock(current);
        }

        var $element = $R.dom(element);

        // replace is empty
        if (!inline && this.isEmptyHtml(element.innerHTML, true))
        {
            $element.after(nodes);
            $element.remove();

            return nodes;
        }

        var tag = $element.get().tagName.toLowerCase();
        var isEnd = this.caret.isEnd(element);
        var isStart = this.caret.isStart(element);

        if (!isEnd && !isStart)
        {
            var extractedContent = this.extractHtmlFromCaret(inline);

            var $secondPart = $R.dom('<' + tag + ' />');
            $secondPart = this.cloneAttributes(element, $secondPart);

            $element.after($secondPart.append(extractedContent));
        }

        if (isStart)
        {
            return $element.before(nodes);
        }
        else
        {
            if (isList)
            {
                return $element.append(nodes);
            }
            else
            {
                nodes = $element.after(nodes);

                var html = $element.html();
                html = this.removeInvisibleChars(html);
                html = html.replace(/&nbsp;/gi, '');

                if (html === '') $element.remove();

                return nodes;
            }
        }
    },
    extractHtmlFromCaret: function(inline, element)
    {
        var range = this.selection.getRange();
        if (range)
        {
            element = (element) ? element : ((inline) ? this.selection.getInline() : this.selection.getBlock());
            if (element)
            {
                var clonedRange = range.cloneRange();
                clonedRange.selectNodeContents(element);
                clonedRange.setStart(range.endContainer, range.endOffset);

                return clonedRange.extractContents();
            }
        }
    },
    createMarkup: function(el)
    {
        var markup = document.createElement(this.opts.markup);
        if (this.opts.breakline) markup.setAttribute('data-redactor-tag', 'br');

        var $el = $R.dom(el);

        $el.after(markup);
        this.caret.setStart(markup);
    },
    createMarkupBefore: function(el)
    {
        var markup = document.createElement(this.opts.markup);
        if (this.opts.breakline) markup.setAttribute('data-redactor-tag', 'br');

        var $el = $R.dom(el);

        $el.before(markup);
        this.caret.setEnd(markup);
    },
    getNode: function(el)
    {
        var node = $R.dom(el).get();
        var editor = this.editor.getElement().get();

        return (typeof el === 'undefined') ? editor : ((node) ? node : false);
    },
    findSiblings: function(node, type)
    {
        node = $R.dom(node).get();
        type = (type === 'next') ? 'nextSibling' : 'previousSibling';

        while (node = node[type])
        {
            if ((node.nodeType === 3 && node.textContent.trim() === '') || node.tagName === 'BR')
            {
                continue;
            }

            return node;
        }

        return false;
    },
    getElementsFromHtml: function(html, selector, exclude)
    {
        var div = document.createElement("div");
        div.innerHTML = html;

        var elems = div.querySelectorAll(selector);

        // array map polyfill
        var mapping = function(callback, thisArg)
        {
            if (typeof this.length !== 'number') return;
            if (typeof callback !== 'function') return;

            var newArr = [];
            if (typeof this == 'object')
            {
                for (var i = 0; i < this.length; i++)
                {
                    if (i in this) newArr[i] = callback.call(thisArg || this, this[i], i, this);
                    else return;
                }
            }

            return newArr;
        };

        return mapping.call(elems, function(el)
        {
            var type = el.getAttribute('data-redactor-type');
            if (exclude && type && type === exclude) {}
            else return el.outerHTML;
        });
    },

    // childnodes
    getChildNodes: function(el, recursive, elements)
    {
        el = (el && el.nodeType && el.nodeType === 11) ? el : $R.dom(el).get();

        var nodes = el.childNodes;
        var result = [];
        if (nodes)
        {
            for (var i = 0; i < nodes.length; i++)
            {
                if (elements === true && nodes[i].nodeType === 3) continue;
                else if (nodes[i].nodeType === 3 && this.isEmpty(nodes[i])) continue;

                result.push(nodes[i]);

                if (recursive !== false)
                {
                    var nestedNodes = this.getChildNodes(nodes[i], elements);
                    if (nestedNodes.length > 0)
                    {
                        result = result.concat(nestedNodes);
                    }
                }
            }
        }

        return result;
    },
    getChildElements: function(el)
    {
        return this.getChildNodes(el, true, true);
    },
    getFirstNode: function(el)
    {
        return this._getFirst(this.getChildNodes(el, false));
    },
    getLastNode: function(el)
    {
        return this._getLast(this.getChildNodes(el, false));
    },
    getFirstElement: function(el)
    {
        return this._getFirst(this.getChildNodes(el, false, true));
    },
    getLastElement: function(el)
    {
        return this._getLast(this.getChildNodes(el, false, true));
    },

    // replace
    replaceToTag: function(node, tag)
    {
        var $node = $R.dom(node);
        return $node.replaceWith(function(node)
        {
            var $replaced = $R.dom('<' + tag + '>').append($R.dom(node).contents());
            if (node.attributes)
            {
                var attrs = node.attributes;
                for (var i = 0; i < attrs.length; i++)
                {
                    $replaced.attr(attrs[i].nodeName, attrs[i].value);
                }
            }

            return $replaced;

        });
    },

    // string
    ucfirst: function(str)
    {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },

    // array
    removeFromArrayByValue: function(arr, value)
    {
        var a = arguments, len = a.length, ax;
        while (len > 1 && arr.length)
        {
            value = a[--len];
            while ((ax= arr.indexOf(value)) !== -1)
            {
                arr.splice(ax, 1);
            }
        }

        return arr;
    },

    // attributes
    removeEmptyAttr: function(el, attr)
    {
        var $el = $R.dom(el);

        if (typeof $el.attr(attr) === 'undefined' || $el.attr(attr) === null) return true;
        else if ($el.attr(attr) === '')
        {
            $el.removeAttr(attr);
            return true;
        }

        return false;
    },
    cloneAttributes: function(elFrom, elTo)
    {
        elFrom = $R.dom(elFrom).get();
        elTo = $R.dom(elTo);

        var attrs = elFrom.attributes;
        var len = attrs.length;
        while (len--)
        {
            var attr = attrs[len];
            elTo.attr(attr.name, attr.value);
        }

        return elTo;
    },

    // object
    toParams: function(obj)
    {
        if (typeof obj !== 'object') return obj;

        var keys = Object.keys(obj);
        if (!keys.length) return '';
        var result = '';

        for (var i = 0; i < keys.length; i++)
        {
            var key = keys[i];
            result += key + ':' + obj[key] + ';';
        }

        return result;
    },
    styleToObj: function(str)
    {
        var obj = {};

        if (str)
        {
            var style = str.replace(/;$/, '').split(';');
            for (var i = 0; i < style.length; i++)
            {
                var rule = style[i].split(':');
                obj[rule[0].trim()] = rule[1].trim();
            }
        }

        return obj;
    },
    checkProperty: function(obj)
    {
        var args = (arguments[1] && Array.isArray(arguments[1])) ? arguments[1] : [].slice.call(arguments, 1);

        for (var i = 0; i < args.length; i++)
        {
            if (!obj || (typeof obj[args[i]] === 'undefined'))
            {
                return false;
            }

            obj = obj[args[i]];
        }

        return obj;
    },

    // data
    extendData: function(data, obj)
    {
        for (var key in obj)
        {
            if (key === 'elements')
            {
                var $elms = $R.dom(obj[key]);
                $elms.each(function(node)
                {
                    var $node = $R.dom(node);
                    if (node.tagName === 'FORM')
                    {
                        var serializedData = $node.serialize(true);
                        for (var z in serializedData)
                        {
                            data = this._setData(data, z, serializedData[z]);
                        }
                    }
                    else
                    {
                        var name = ($node.attr('name')) ? $node.attr('name') : $node.attr('id');
                        data = this._setData(data, name, $node.val());
                    }
                }.bind(this));
            }
            else
            {
                data = this._setData(data, key, obj[key]);
            }
        }

        return data;
    },
    _setData: function(data, name, value)
    {
        if (data instanceof FormData) data.append(name, value);
        else data[name] = value;

        return data;
    },

    // normalize
    normalizeTextNodes: function(el)
    {
        el = $R.dom(el).get();
        if (el) el.normalize();
    },

    // color
    isRgb: function(str)
    {
        return (str.search(/^rgb/i) === 0);
    },
    rgb2hex: function(rgb)
    {
        rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);

        return (rgb && rgb.length === 4) ? "#" +
        ("0" + parseInt(rgb[1],10).toString(16)).slice(-2) +
        ("0" + parseInt(rgb[2],10).toString(16)).slice(-2) +
        ("0" + parseInt(rgb[3],10).toString(16)).slice(-2) : '';
    },
    hex2long: function(val)
    {
        if (val.search(/^#/) !== -1 && val.length === 4)
        {
            val = '#' + val[1] + val[1] + val[2] + val[2] + val[3] + val[3];
        }

        return val;
    },

    // escape
    escapeRegExp: function(s)
    {
        return s.replace(/[-\/\\^$*~+?.()|[\]{}]/g, '\\$&');
    },

    // random
    getRandomId: function()
    {
        var id = '';
        var possible = 'abcdefghijklmnopqrstuvwxyz0123456789';

        for (var i = 0; i < 12; i++)
        {
            id += possible.charAt(Math.floor(Math.random() * possible.length));
        }

        return id;
    },

    // private
    _getFirst: function(nodes)
    {
        return (nodes.length !== 0) ? nodes[0] : false;
    },
    _getLast: function(nodes)
    {
        return (nodes.length !== 0) ? nodes[nodes.length-1] : false;
    }
});
$R.add('service', 'progress', {
    init: function(app)
    {
        this.app = app;

        // local
        this.$box = null;
        this.$bar = null;
    },

    // public
    show: function()
    {
        if (!this._is()) this._build();
        this.$box.show();
    },
    hide: function()
    {
        if (this._is())
        {
            this.animate.start(this.$box, 'fadeOut', this._destroy.bind(this));
        }
    },
    update: function(value)
    {
        this.show();
        this.$bar.css('width', value + '%');
    },

    // private
    _is: function()
    {
        return (this.$box !== null);
    },
    _build: function()
    {
        this.$bar = $R.dom('<span />');
        this.$box = $R.dom('<div id="redactor-progress" />');

        this.$box.append(this.$bar);
        this.$body.append(this.$box);
    },
    _destroy: function()
    {
        if (this._is()) this.$box.remove();

        this.$box = null;
        this.$bar = null;
    }
});
$R.add('module', 'starter', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.plugin = app.plugin;
        this.module = app.module;
    },
    // messages
    onstart: function()
    {
        var services = ['element', 'container', 'source', 'editor', 'statusbar', 'toolbar'];
        var modules = ['element', 'container', 'source', 'editor', 'statusbar', 'contextbar', 'input'];

        this._startStop('start', this.app, services);
        this._startStop('start', this.module, modules);
    },
    onstop: function()
    {
        var modules = ['observer', 'element', 'container', 'source', 'editor', 'contextbar'];

        this._startStop('stop', this.module, modules);
    },
    onenable: function()
    {
        var modules = ['observer', 'toolbar'];
        var plugins = this.opts.plugins;

        this._startStop('start', this.module, modules);
        this._startStop('start', this.plugin, plugins);
    },
    ondisable: function()
    {
        var modules = ['observer', 'toolbar'];
        var plugins = this.opts.plugins;

        this._startStop('stop', this.module, modules);
        this._startStop('stop', this.plugin, plugins);
    },

    // private
    _startStop: function(type, obj, arr)
    {
        for (var i = 0; i < arr.length; i++)
        {
            if (typeof obj[arr[i]] !== 'undefined')
            {
                this.app.callInstanceMethod(obj[arr[i]], type);
            }
        }
    }
});
$R.add('module', 'element', {
    init: function(app)
    {
        this.app = app;
        this.uuid = app.uuid;
        this.opts = app.opts;
        this.namespace = app.namespace;
        this.element = app.element;
        this.rootOpts = $R.extend({}, true, $R.options, app.rootOpts);
    },
    // public
    start: function()
    {
        this._build();
        this._buildModes();
        this._buildMarkup();
    },
    stop: function()
    {
        var $element = this.element.getElement();
        $element.removeData(this.namespace + '-uuid');
    },

    // private
    _build: function()
    {
        var $element = this.element.getElement();
        $element.data(this.namespace + '-uuid', this.uuid);
    },
    _buildModes: function()
    {
        var type = this.element.getType();

        if (type === 'inline') this._redefineOptions(this.opts.modes['inline']);
        if (type === 'div') this._redefineOptions(this.opts.modes['original']);

        if (type !== 'inline')
        {
            if (this._isRootOption('styles') && this.rootOpts.styles) this.opts.styles = true;
            if (this._isRootOption('source') && !this.rootOpts.source) this.opts.showSource = false;
        }
    },
    _buildMarkup: function()
    {
        var type = this.element.getType();

        if (type === 'inline')
        {
            this.opts.emptyHtml = '';
        }
        else if (this.opts.breakline)
        {
            this.opts.markup = 'div';
            this.opts.emptyHtml = '<div data-redactor-tag="br">' + this.opts.markerChar + '</div>';
        }
        else
        {
            this.opts.emptyHtml = '<' + this.opts.markup + '></' + this.opts.markup + '>';
        }
    },
    _redefineOptions: function(opts)
    {
        for (var key in opts)
        {
            this.opts[key] = opts[key];
        }
    },
    _isRootOption: function()
    {
        return (typeof this.rootOpts['styles'] !== 'undefined');
    }
});
$R.add('module', 'editor', {
    init: function(app)
    {
        this.app = app;
        this.uuid = app.uuid;
        this.opts = app.opts;
        this.editor = app.editor;
        this.source = app.source;
        this.element = app.element;
        this.component = app.component;
        this.container = app.container;
        this.inspector = app.inspector;
        this.autoparser = app.autoparser;

        // local
        this.placeholder = false;
        this.events = false;
    },
    // messages
    onenable: function()
    {
        this.enable();
    },
    ondisable: function()
    {
        this.disable();
    },
    onenablefocus: function()
    {
        this._enableFocus();
    },
    oncontextmenu: function(e)
    {
        this.component.setOnEvent(e, true);
    },
    onclick: function(e)
    {
        this.component.setOnEvent(e);
    },
    onkeyup: function(e)
    {
        var data = this.inspector.parse(e.target);
        if (!data.isComponent())
        {
            this.component.clearActive();
        }
    },
    onenablereadonly: function()
    {
        this._enableReadOnly();
    },
    ondisablereadonly: function()
    {
        this._disableReadOnly();
    },
    onautoparseobserve: function()
    {
        this.autoparser.observe();
    },
    onplaceholder: {
        build: function()
        {
            this._buildPlaceholder();
        },
        toggle: function()
        {
            this._togglePlacehodler();
        }
    },

    // public
    start: function()
    {
        this._build();
        this._buildEvents();
        this._buildOptions();
        this._buildAccesibility();
    },
    stop: function()
    {
        var $editor = this.editor.getElement();
        var $container = this.container.getElement();

        var classesEditor = ['redactor-in', 'redactor-in-' + this.uuid, 'redactor-structure', 'redactor-placeholder', 'notranslate', this.opts.stylesClass];
        var classesContainer = ['redactor-focus', 'redactor-blur', 'redactor-over', 'redactor-styles-on',
                                'redactor-styles-off', 'redactor-toolbar-on', 'redactor-text-labeled-on', 'redactor-source-view'];

        $editor.removeAttr('spellcheck');
        $editor.removeAttr('dir');
        $editor.removeAttr('contenteditable');
        $editor.removeAttr('placeholder');
        $editor.removeAttr('data-gramm_editor');
        $editor.removeClass(classesEditor.join(' '));

        $container.removeClass(classesContainer.join(' '));

        this._destroyEvents();

        if ($editor.get().classList.length === 0) $editor.removeAttr('class');
    },
    enable: function()
    {
        var $editor = this.editor.getElement();
        var $container = this.container.getElement();

        $editor.addClass('redactor-in redactor-in-' + this.uuid);
        $editor.attr({ 'contenteditable': true });

        if (this.opts.structure)
        {
            $editor.addClass('redactor-structure');
        }

        if (this.opts.toolbar && !this.opts.air && !this.opts.toolbarExternal)
        {
            $container.addClass('redactor-toolbar-on');
        }

        // prevent editing
        this._disableBrowsersEditing();
    },
    disable: function()
    {
        var $editor = this.editor.getElement();
        var $container = this.container.getElement();

        $editor.removeClass('redactor-in redactor-in-' + this.uuid);
        $editor.removeClass('redactor-structure');
        $editor.removeAttr('contenteditable');

        $container.addClass('redactor-toolbar-on');
    },

    // private
    _build: function()
    {
        var $editor = this.editor.getElement();
        var $element = this.element.getElement();
        var $container = this.container.getElement();

        $container.addClass('redactor-blur');

        if (!this.opts.grammarly)
        {
            $editor.attr('data-gramm_editor', false);
        }

        if (this.opts.notranslate)
        {
            $editor.addClass('notranslate');
        }

        if (this.opts.styles)
        {
            $editor.addClass(this.opts.stylesClass);
            $container.addClass('redactor-styles-on');
        }
        else
        {
            $container.addClass('redactor-styles-off');
        }

        if (this.opts.buttonsTextLabeled)
        {
            $container.addClass('redactor-text-labeled-on');
        }

        if (this.element.isType('textarea')) $element.before($editor);
    },
    _buildEvents: function()
    {
        this.events = $R.create('editor.events', this.app);
    },
    _buildOptions: function()
    {
        var $editor = this.editor.getElement();

        $editor.attr('dir', this.opts.direction);

        if (this.opts.tabindex)  $editor.attr('tabindex', this.opts.tabindex);
        if (this.opts.minHeight) $editor.css('min-height', this.opts.minHeight);
        if (this.opts.maxHeight) $editor.css('max-height', this.opts.maxHeight);
        if (this.opts.maxWidth)  $editor.css({ 'max-width': this.opts.maxWidth, 'margin': 'auto' });
    },
    _buildAccesibility: function()
    {
        var $editor = this.editor.getElement();

        $editor.attr({ 'aria-labelledby': 'redactor-voice-' + this.uuid, 'role': 'presentation' });
    },
    _buildPlaceholder: function()
    {
        this.placeholder = $R.create('editor.placeholder', this.app);
    },
    _enableFocus: function()
    {
        if (this.opts.showSource) this._enableFocusSource();
        else this._enableFocusEditor();
    },
    _enableFocusSource: function()
    {
        var $source = this.source.getElement();

        if (this.opts.focus)
        {
            $source.focus();
            $source.get().setSelectionRange(0, 0);
        }
        else if (this.opts.focusEnd)
        {
            $source.focus();
        }
    },
    _enableFocusEditor: function()
    {
        if (this.opts.focus)
        {
            setTimeout(this.editor.startFocus.bind(this.editor), 100);
        }
        else if (this.opts.focusEnd)
        {
            setTimeout(this.editor.endFocus.bind(this.editor), 100);
        }
    },
    _togglePlacehodler: function()
    {
        if (this.placeholder) this.placeholder.toggle();
    },
    _disableBrowsersEditing: function()
    {
        try {
            // FF fix
            document.execCommand('enableObjectResizing', false, false);
            document.execCommand('enableInlineTableEditing', false, false);
            // IE prevent converting links
            document.execCommand("AutoUrlDetect", false, false);

            // IE disable image resizing
            var $editor = this.editor.getElement();
            var el = $editor.get();
            if (el.addEventListener) el.addEventListener('mscontrolselect', function(e) { e.preventDefault(); });
            else el.attachEvent('oncontrolselect', function(e) { e.returnValue = false; });

        } catch (e) {}
    },
    _destroyEvents: function()
    {
        if (this.events)
        {
            this.events.destroy();
        }
    },
    _enableReadOnly: function()
    {
        var $editor = this.editor.getElement();

        this._getEditables($editor).removeAttr('contenteditable');
        $editor.removeAttr('contenteditable');
        $editor.addClass('redactor-read-only');

        if (this.events) this.events.destroy();
    },
    _disableReadOnly: function()
    {
        var $editor = this.editor.getElement();

        this._getEditables($editor).attr({ 'contenteditable': true });
        $editor.removeClass('redactor-read-only');
        $editor.attr({ 'contenteditable': true });

        this._buildEvents();
    },
    _getEditables: function($editor)
    {
        return $editor.find('figcaption, td, th');
    }
});
$R.add('class', 'editor.placeholder', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.editor = app.editor;
        this.element = app.element;

        // build
        this.build();
    },
    build: function()
    {
        var $element = this.element.getElement();
        var $editor = this.editor.getElement();

        if (this.opts.placeholder !== false || $element.attr('placeholder'))
        {
            var text = (this.opts.placeholder !== false) ? this.opts.placeholder : $element.attr('placeholder');
            $editor.attr('placeholder', text);
            this.toggle();
        }
    },
    toggle: function()
    {
        return (this.editor.isEmpty(true)) ? this.show() : this.hide();
    },
    show: function()
    {
        var $editor = this.editor.getElement();
        $editor.addClass('redactor-placeholder');
    },
    hide: function()
    {
        var $editor = this.editor.getElement();
        $editor.removeClass('redactor-placeholder');
    }
});
$R.add('class', 'editor.events', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.$doc = app.$doc;
        this.uuid = app.uuid;
        this.source = app.source;
        this.editor = app.editor;
        this.cleaner = app.cleaner;
        this.container = app.container;
        this.insertion = app.insertion;
        this.inspector = app.inspector;
        this.selection = app.selection;
        this.component = app.component;

        // local
        this.blurNamespace = '.redactor-blur.' + this.uuid;
        this.eventsList = ['paste', 'click', 'contextmenu', 'keydown', 'keyup', 'mouseup', 'touchstart',
                           'cut', 'copy', 'dragenter', 'dragstart', 'drop', 'dragover', 'dragleave'];

        // init
        this._init();
    },
    destroy: function()
    {
        var $editor = this.editor.getElement();

        $editor.off('.redactor-focus');
        this.$doc.off('keyup' + this.blurNamespace + ' mousedown' + this.blurNamespace);

        // all events
        this._loop('off');
    },
    focus: function(e)
    {
        var $container = this.container.getElement();

        if (this.editor.isPasting() || $container.hasClass('redactor-focus')) return;

        $container.addClass('redactor-focus');
        $container.removeClass('redactor-blur');

        this.app.broadcast('observe', e);
        this.app.broadcast('focus', e);

        this.isFocused = true;
        this.isBlured = false;
    },
    blur: function(e)
    {
        var $container = this.container.getElement();
        var $target = $R.dom(e.target);
        var targets = ['.redactor-in-' + this.uuid,  '.redactor-toolbar', '.redactor-dropdown',
        '.redactor-context-toolbar', '#redactor-modal', '#redactor-image-resizer'];

        this.app.broadcast('originalblur', e);
        if (this.app.stopBlur) return;

        if (!this.app.isStarted() || this.editor.isPasting()) return;
        if ($target.closest(targets.join(',')).length !== 0) return;

        if (!this.isBlured && !$container.hasClass('redactor-blur'))
        {
            $container.removeClass('redactor-focus');
            $container.addClass('redactor-blur');
            this.app.broadcast('blur', e);

            this.isFocused = false;
            this.isBlured = true;
        }
    },
    cut: function(e)
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);

        this.app.broadcast('state', e);

        if (this.component.isNonEditable(current))
        {
            this._passSelectionToClipboard(e, data, true);
            e.preventDefault();
        }
    },
    copy: function(e)
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);

        this.app.broadcast('state', e);

        if (this.component.isNonEditable(current))
        {
            this._passSelectionToClipboard(e, data, false);
            e.preventDefault();
        }
    },
    drop: function(e)
    {
        e = e.originalEvent || e;
        e.stopPropagation();
        this._removeOverClass();

        if (this.opts.dragUpload === false)
        {
            e.preventDefault();
            return;
        }

        if (this.app.isDragComponentInside())
        {
            var $dragComponent = $R.dom(this.app.getDragComponentInside());
            var $component = $dragComponent.clone(true);
            this.insertion.insertToPoint(e, $component);

            $dragComponent.remove();

            this.app.setDragComponentInside(false);
            this.app.broadcast('state', e);
            this.app.broadcast('drop', e);
            this.app.broadcast('image.observe', e);

            e.preventDefault();

            return;
        }
        else if (this.app.isDragInside() && this.opts.input)
        {
            this.insertion.insertPoint(e);

            var dt = e.dataTransfer;
            var html = dt.getData('text/html');

            // clear selected
            var range = this.selection.getRange();
            if (range)
            {
                var blocks = this.selection.getBlocks();
                range.deleteContents();

                // remove empty blocks
                for (var i = 0; i < blocks.length; i++)
                {
                    if (blocks[i].innerHTML === '') $R.dom(blocks[i]).remove();
                }
            }

            // paste
            $R.create('input.paste', this.app, e, true, html, true);

            this.app.broadcast('state', e);
            this.app.broadcast('drop', e);

            this.app.setDragInside(false);
            e.preventDefault();

            return;
        }

        this.app.broadcast('state', e);
        this.app.broadcast('paste', e, e.dataTransfer);
        this.app.broadcast('drop', e);

    },
    dragenter: function(e)
    {
        e.preventDefault();
    },
    dragstart: function(e)
    {
        this.app.setDragComponentInside(false);
        this.app.setDragInside(false);

        var data = this.inspector.parse(e.target);
        if (data.isComponent() && !data.isComponentEditable() && !data.isFigcaption())
        {
            this.app.setDragComponentInside(data.getComponent());
        }
        else if (this.selection.is() && !this.selection.isCollapsed())
        {
            // drag starts inside editor
            this.app.setDragInside(true);
            this._setDragData(e);
        }

        this.app.broadcast('dragstart', e);
    },
    dragover: function(e)
    {
        this.app.broadcast('dragover', e);
    },
    dragleave: function(e)
    {
        this.app.broadcast('dragleave', e);
    },
    paste: function(e)
    {
        this.app.broadcast('paste', e);
    },
    contextmenu: function(e)
    {
        // chrome crashes fix
        //this.editor.disableNonEditables();

        //setTimeout(function()
        //{
          //  this.editor.enableNonEditables();
           // this.app.broadcast('contextmenu', e);

        //}.bind(this), 0);
    },
    click: function(e)
    {
        // triple click selection
        if (e.detail === 3)
        {
            e.preventDefault();

            var block = this.selection.getBlock();
            var range = document.createRange();
            range.selectNodeContents(block);
            this.selection.setRange(range)
        }

        // observe bottom click & start click
        var $target = $R.dom(e.target);
        if ($target.hasClass('redactor-in'))
        {
            var top = $target.offset().top;
            var pad = parseFloat($target.css('padding-bottom'));
            var height = $target.height();
            var posHeight = top + height - pad*2;

            if (posHeight < e.pageY)
            {
                this.app.broadcast('bottomclick', e);
            }
        }

        this.app.broadcast('state', e);
        this.app.broadcast('click', e);
    },
    keydown: function(e)
    {
        this.app.broadcast('state', e);
        var stop = this.app.broadcast('keydown', e);
        if (stop === false)
        {
            return e.preventDefault();
        }
    },
    keyup: function(e)
    {
        this.app.broadcast('keyup', e);
    },
    mouseup: function(e)
    {
        this.app.broadcast('observe', e);
        this.app.broadcast('state', e);
    },
    touchstart: function(e)
    {
        this.app.broadcast('observe', e);
        this.app.broadcast('state', e);
    },

    // private
    _init: function()
    {
        var $editor = this.editor.getElement();

        $editor.on('focus.redactor-focus click.redactor-focus', this.focus.bind(this));
        this.$doc.on('keyup' + this.blurNamespace + ' mousedown' + this.blurNamespace, this.blur.bind(this));

        // all events
        this._loop('on');
    },
    _removeOverClass: function()
    {
        var $editor = this.editor.getElement();
        $editor.removeClass('over');
    },
    _loop: function(func)
    {
        var $editor = this.editor.getElement();
        for (var i = 0; i < this.eventsList.length; i++)
        {
            var event = this.eventsList[i] + '.redactor-events';
            var method = this.eventsList[i];

            $editor[func](event, this[method].bind(this));
        }
    },
    _passAllToClipboard: function(e)
    {
        var clipboard = e.clipboardData;
        var content = this.source.getCode();

        clipboard.setData('text/html', content);
        clipboard.setData('text/plain', content.toString().replace(/\n$/, ""));
    },
    _passSelectionToClipboard: function(e, data, remove)
    {
        var clipboard = e.clipboardData;
        var node = data.getComponent();
        var $node = $R.dom(node);
        var $cloned = $node.clone();

        // clean
        $cloned.find('.redactor-component-caret').remove();
        $cloned.removeClass('redactor-component-active');
        $cloned.removeAttr('contenteditable');
        $cloned.removeAttr('tabindex');

        // html
        var content = $cloned.get().outerHTML;

        if (remove) this.component.remove(node);

        clipboard.setData('text/html', content);
        clipboard.setData('text/plain', content.toString().replace(/\n$/, ""));
    },
    _setDragData: function(e)
    {
        e = e.originalEvent || e;

        var dt = e.dataTransfer;
        dt.effectAllowed = 'move';
        dt.setData('text/Html', this.selection.getHtml());
    }
});
$R.add('module', 'container', {
    init: function(app)
    {
        this.app = app;
        this.uuid = app.uuid;
        this.opts = app.opts;
        this.lang = app.lang;
        this.element = app.element;
        this.container = app.container;
    },
    // public
    start: function()
    {
        this._build();
        this._buildAccesibility();
    },
    stop: function()
    {
        var $element = this.element.getElement();
        var $container = this.container.getElement();

        $container.after($element);
        $container.remove();
        $element.show();
    },

    // private
    _build: function()
    {
        var $element = this.element.getElement();
        var $container = this.container.getElement();

        $container.addClass('redactor-box');
        $container.attr('dir', this.opts.direction);

        if (this.element.isType('inline')) $container.addClass('redactor-inline');

        $element.after($container);
        $container.append($element);
    },
    _buildAccesibility: function()
    {
        var $container = this.container.getElement();
        var $label = $R.dom('<span />');

        $label.addClass('redactor-voice-label');
        $label.attr({ 'id': 'redactor-voice-' + this.uuid, 'aria-hidden': false });
        $label.html(this.lang.get('accessibility-help-label'));

        $container.prepend($label);
    }
});
$R.add('module', 'source', {
    init: function(app)
    {
        this.app = app;
        this.uuid = app.uuid;
        this.opts = app.opts;
        this.utils = app.utils;
        this.element = app.element;
        this.source = app.source;
        this.editor = app.editor;
        this.toolbar = app.toolbar;
        this.cleaner = app.cleaner;
        this.component = app.component;
        this.container = app.container;
        this.autoparser = app.autoparser;
        this.selection = app.selection;

        // local
        this.syncedHtml = '';
    },
    // messages
    onstartcode: function()
    {
        var sourceContent = this.source.getStartedContent();
        var $editor = this.editor.getElement();
        var $source = this.source.getElement();

        // autoparse
        if (this.opts.autoparse && this.opts.autoparseStart)
        {
            sourceContent = this.autoparser.parse(sourceContent);
        }

        // started content
        var startContent = this.cleaner.input(sourceContent, true, true);
        var syncContent = this.cleaner.output(startContent);

        // set content
        $editor.html(startContent);
        $source.val(syncContent);

        this.syncedHtml = syncContent;
        this.app.broadcast('placeholder.build');
        this.app.broadcast('autoparseobserve');

        // widget's scripts
        this.component.executeScripts();
    },
    onstartcodeshow: function()
    {
        this.show();
    },
    ontrytosync: function()
    {
        this.sync();
    },
    onhardsync: function()
    {
        var $editor = this.editor.getElement();
        var html = $editor.html();

        html = this.app.broadcast('syncBefore', html);
        html = this.cleaner.output(html);

        this._syncing(html);
    },

    // public
    start: function()
    {
        this._build();
        this._buildClasses();
    },
    stop: function()
    {
        var $element = this.element.getElement();
        var $source = this.source.getElement();

        $element.removeClass('redactor-source redactor-source-open');
        $source.off('input.redactor-source');
        $source.removeAttr('data-gramm_editor');

        if ($source.get().classList.length === 0) $source.removeAttr('class');
        if (!this.source.isNameGenerated()) $element.removeAttr('name');
        if (!this.element.isType('textarea')) $source.remove();

    },
    getCode: function()
    {
        return this.source.getCode();
    },

    // public
    toggle: function()
    {
        if (!this.opts.source) return;

        var $source = this.source.getElement();

        return ($source.hasClass('redactor-source-open')) ? this.hide() : this.show();
    },
    show: function()
    {
        if (!this.opts.source) return;

        var $editor = this.editor.getElement();
        var $source = this.source.getElement();
        var $container = this.container.getElement();

        var html = $source.val();

        if (this.app.isStarted()) html = this.app.broadcast('source.open', html);

        // get height
        var editorHeight = $editor.height();

        $editor.hide();
        $source.height(editorHeight);
        $source.val(html.trim());
        $source.show();
        $source.addClass('redactor-source-open');
        $source.on('input.redactor-source-events', this._onChangedSource.bind(this));
        $source.on('keydown.redactor-source-events', this._onTabKey.bind(this));
        $source.on('focus.redactor-source-events', this._onFocus.bind(this));

        if (this.opts.source.hasOwnProperty('codemirror')) {
            var opts = (typeof this.opts.source.codemirror === 'object') ? this.opts.source.codemirror : {};
            this.codemirror = CodeMirror.fromTextArea($source.get(), opts);
            this.codemirror.setSize(null, editorHeight);
            this.codemirror.on('change', function(cm, changeObj){ cm.save() });
            this.codemirror.on('change', this._onChangedSource.bind(this));
        }
        else {
            $container.addClass('redactor-source-view');
        }

        // buttons
        setTimeout(function()
        {
            this._disableButtons();
            this._setActiveSourceButton();

        }.bind(this), 100);

        if (this.app.isStarted()) this.app.broadcast('source.opened');
    },
    hide: function()
    {
        if (!this.opts.source) return;

        var $editor = this.editor.getElement();
        var $source = this.source.getElement();
        var $container = this.container.getElement();

        var html = $source.val();
        if (this.opts.source.hasOwnProperty('codemirror')) {
            html = this.codemirror.getValue();
            this.codemirror.toTextArea();
        }


        // clean
        html = this.cleaner.input(html, true);
        html = (this.utils.isEmptyHtml(html)) ? this.opts.emptyHtml : html;
        html = this.app.broadcast('source.close', html);

        // buttons
        this._enableButtons();
        this._setInactiveSourceButton();

        $source.hide();
        $source.removeClass('redactor-source-open');
        $source.off('.redactor-source-events');
        $editor.show();
        $editor.html(html);

        $container.removeClass('redactor-source-view');

        setTimeout(function()
        {
            this.editor.startFocus();

            // widget's scripts
            this.component.executeScripts();

        }.bind(this), 0);

        this.app.broadcast('source.closed');
    },
    sync: function()
    {
        var self = this;
        var $editor = this.editor.getElement();
        var html = $editor.html();

        html = this.app.broadcast('syncBefore', html);
        html = this.cleaner.output(html);

        if (this._isSync(html))
        {
            if (this.timeout) clearTimeout(this.timeout);
            this.timeout = setTimeout(function() { self._syncing(html); }, 200);
        }
    },

    // private
    _build: function()
    {
        var $source = this.source.getElement();
        var $element = this.element.getElement();

        $source.hide();

        if (!this.opts.grammarly)
        {
            $source.attr('data-gramm_editor', false);
        }

        if (!this.element.isType('textarea'))
        {
            $element.after($source);
        }
    },
    _buildClasses: function()
    {
        var $source = this.source.getElement();

        $source.addClass('redactor-source');
    },
    _syncing: function(html)
    {
        html = this.app.broadcast('syncing', html);

        var $source = this.source.getElement();
        $source.val(html);

        this.app.broadcast('synced', html);
        this.app.broadcast('changed', html);
    },
    _isSync: function(html)
    {
        if (this.syncedHtml !== html)
        {
            this.syncedHtml = html;
            return true;
        }

        return false;
    },
    _onChangedSource: function()
    {
        var $source = this.source.getElement();
        var html = $source.val();

        this.app.broadcast('changed', html);
        this.app.broadcast('source.changed', html);
    },
    _onTabKey: function(e)
    {
        if (e.keyCode !== 9) return true;

        e.preventDefault();

        var $source = this.source.getElement();
        var el = $source.get();
        var start = el.selectionStart;

        $source.val($source.val().substring(0, start) + "    " + $source.val().substring(el.selectionEnd));
        el.selectionStart = el.selectionEnd = start + 4;
    },
    _onFocus: function()
    {
        this.app.broadcast('sourcefocus');
    },
    _disableButtons: function()
    {
        this.toolbar.disableButtons();
    },
    _enableButtons: function()
    {
        this.toolbar.enableButtons();
    },
    _setActiveSourceButton: function()
    {
        var $btn = this.toolbar.getButton('html');
        $btn.enable();
        $btn.setActive();
    },
    _setInactiveSourceButton: function()
    {
        var $btn = this.toolbar.getButton('html');
        $btn.setInactive();
    }
});
$R.add('module', 'observer', {
    init: function(app)
    {
        this.app = app;
        this.editor = app.editor;

        // local
        this.observerUnit = false;
    },
    // public
    start: function()
    {
        if (window.MutationObserver)
        {
            var $editor = this.editor.getElement();
            var el = $editor.get();
            this.observerUnit = this._build(el);
            this.observerUnit.observe(el, {
                 attributes: true,
                 subtree: true,
                 childList: true,
                 characterData: true,
                 characterDataOldValue: true
            });
        }
    },
    stop: function()
    {
        if (this.observerUnit) this.observerUnit.disconnect();
    },

    // private
    _build: function(el)
    {
        var self = this;
        return new MutationObserver(function(mutations)
        {
            self._observe(mutations[mutations.length-1], el);
        });
    },
    _observe: function(mutation, el)
    {
        if (this.app.isReadOnly() || (mutation.type === 'attributes' && mutation.target === el))
        {
            return;
        }

        this.app.broadcast('observe');
        this.app.broadcast('trytosync');
        this.app.broadcast('placeholder.toggle');
    }
});
$R.add('module', 'clicktoedit', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.source = app.source;
        this.editor = app.editor;
        this.container = app.container;
        this.selection = app.selection;
    },
    // messages
    onstartclicktoedit: function()
    {
        this.start();
    },
    onenablereadonly: function()
    {
        if (!this._isEnabled()) this.stop();
    },
    ondisablereadonly: function()
    {
        if (!this._isEnabled()) this.start();
    },
    onstop: function()
    {
        this.stop();
    },

    // public
    start: function()
    {
        this._build();
    },
    stop: function()
    {
        if (this.buttonSave) this.buttonSave.stop();
        if (this.buttonCancel) this.buttonCancel.stop();

        this._destroy();
        this.app.broadcast('disable');
    },
    enable: function()
    {
        this.app.broadcast('clickStart');

        var isEmpty = this.editor.isEmpty();
        if (!isEmpty) this.selection.saveMarkers();

        this._setFocus();
        this._destroy();
        this.app.broadcast('enable');
        this.buttonSave.enable();
        this.buttonCancel.enable();

        if (!isEmpty) this.selection.restoreMarkers();
        if (isEmpty) this.editor.focus();

        var $container = this.container.getElement();
        $container.addClass('redactor-clicktoedit-enabled');

        this.source.rebuildStartedContent();

        this.app.broadcast('startcode');
        this.app.broadcast('image.observe');
    },
    save: function(e)
    {
        if (e) e.preventDefault();

        var html = this.source.getCode();

        this.app.broadcast('disable');
        this.app.broadcast('clickSave', html);
        this.app.broadcast('clickStop');
        this.app.broadcast('toolbar.removeexternal');
        this._build();
    },
    cancel: function(e)
    {
        if (e) e.preventDefault();

        var html = this.saved;
        var $editor = this.editor.getElement();
        $editor.html(html);

        this.saved = '';

        this.app.broadcast('disable');
        this.app.broadcast('clickCancel', html);
        this.app.broadcast('clickStop');
        this.app.broadcast('toolbar.removeexternal');
        this._build();
    },

    // private
    _build: function()
    {
        // buttons
        this.buttonSave = $R.create('clicktoedit.button', 'save', this.app, this);
        this.buttonCancel = $R.create('clicktoedit.button', 'cancel', this.app, this);

        this.buttonSave.stop();
        this.buttonCancel.stop();

        var $editor = this.editor.getElement();
        var $container = this.container.getElement();

        $editor.on('click.redactor-click-to-edit mouseup.redactor-click-to-edit', this.enable.bind(this));
        $container.addClass('redactor-over');
        $container.removeClass('redactor-clicktoedit-enabled');
    },
    _isEnabled: function()
    {
        return this.container.getElement().hasClass('redactor-clicktoedit-enabled');
    },
    _destroy: function()
    {
        var $editor = this.editor.getElement();
        var $container = this.container.getElement();

        $editor.off('.redactor-click-to-edit');
        $container.removeClass('redactor-over redactor-clicktoedit-enabled');
    },
    _setFocus: function()
    {
        this.saved = this.source.getCode();

        this.buttonSave.start();
        this.buttonCancel.start();
    }
});
$R.add('class', 'clicktoedit.button', {
    init: function(type, app, context)
    {
        this.app = app;
        this.opts = app.opts;
        this.toolbar = app.toolbar;
        this.context = context;

        // local
        this.type = type;
        this.name = (type === 'save') ? 'clickToSave' : 'clickToCancel';
        this.objected = false;
        this.enabled = false;
        this.namespace = '.redactor-click-to-edit';

        // build
        this._build();
    },
    enable: function()
    {
        if (!this.objected) return;

        var data = this.opts[this.name];
        data.api = 'module.clicktoedit.' + this.type;

        this.toolbar.addButton(this.type, data);
        this.enabled = true;
    },
    start: function()
    {
        if (this.objected) return;

        this.$button.off(this.namespace);
        this.$button.show();
        this.$button.on('click' + this.namespace, this.context[this.type].bind(this.context));
    },
    stop: function()
    {
        if (this.objected || !this.enabled) return;

        this.$button.hide();
    },

    // private
    _build: function()
    {
        this.objected = (typeof this.opts[this.name] === 'object');

        if (!this.objected)
        {
            this.$button = $R.dom(this.opts[this.name]);
            this.enabled = true;
        }
    }
});
$R.add('module', 'statusbar', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.element = app.element;
        this.statusbar = app.statusbar;
        this.container = app.container;
    },
    // public
    start: function()
    {
        if (!this.element.isType('inline'))
        {
            var $statusbar = this.statusbar.getElement();
            var $container = this.container.getElement();

            $statusbar.addClass('redactor-statusbar');
            $container.append($statusbar);
        }
    }
});
$R.add('module', 'contextbar', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.uuid = app.uuid;
        this.$win = app.$win;
        this.$doc = app.$doc;
        this.$body = app.$body;
        this.editor = app.editor;
        this.toolbar = app.toolbar;
        this.detector = app.detector;

        // local
        this.$target = (this.toolbar.isTarget()) ? this.toolbar.getTargetElement() : this.$body;
    },
    // messages
    onenablereadonly: function()
    {
        this.stop();
    },
    ondisablereadonly: function()
    {
        this.start();
    },
    oncontextbar: {
        close: function()
        {
            this.close();
        }
    },

    // public
    start: function()
    {
        if (this.opts.toolbarContext)
        {
            var $editor = this.editor.getElement();

            this._build();
            $editor.on('click.redactor-context mouseup.redactor-context', this.open.bind(this));

            if (this.opts.scrollTarget)
            {
                $R.dom(this.opts.scrollTarget).on('scroll.redactor-context', this.close.bind(this));
            }
            else if (this.opts.maxHeight !== false)
            {
                $editor.on('scroll.redactor-context', this.close.bind(this));
            }
        }
    },
    stop: function()
    {
        var $editor = this.editor.getElement();
        $editor.off('.redactor-context');

        this.$doc.off('.redactor-context');
        this.$win.off('.redactor-context');

        if (this.$contextbar) this.$contextbar.remove();
        if (this.opts.scrollTarget)
        {
            $R.dom(this.opts.scrollTarget).off('.redactor-context');
        }
    },
    is: function()
    {
        return (this.$contextbar && this.$contextbar.hasClass('open'));
    },
    set: function(e, node, buttons, position)
    {
        this.$contextbar.html('');
        this.$el = $R.dom(node);

        // buttons
        for (var key in buttons)
        {
            var $btn = $R.create('contextbar.button', this.app, buttons[key]);
            if ($btn.html() !== '')
            {
                this.$contextbar.append($btn);
            }
        }

        // show
        var pos = this._buildPosition(e, this.$el, position);

        this.$contextbar.css(pos);
        this.$contextbar.show();
        this.$contextbar.addClass('open');
        this.$doc.on('click.redactor-context mouseup.redactor-context', this.close.bind(this));
        this.$win.on('resize.redactor-context', this.close.bind(this));
    },
    open: function(e)
    {
        setTimeout(function()
        {
            this.app.broadcast('contextbar', e, this);
        }.bind(this), 0);
    },
    close: function(e)
    {
        if (!this.$contextbar) return;
        if (e)
        {
            var $target = $R.dom(e.target);
            if (this.$el && $target.closest(this.$el).length !== 0)
            {
                return;
            }
        }

        this.$contextbar.hide();
        this.$contextbar.removeClass('open');
        this.$doc.off('.redactor.context');
    },

    // private
    _build: function()
    {
        this.$contextbar = $R.dom('<div>');
        this.$contextbar.attr('id', 'redactor-context-toolbar-' + this.uuid);
        this.$contextbar.attr('dir', this.opts.direction);
        this.$contextbar.addClass('redactor-context-toolbar');
        this.$contextbar.hide();

        this.$target.append(this.$contextbar);
    },
    _buildPosition: function(e, $el, position)
    {
        var top, left;
        var isTarget = this.toolbar.isTarget();
        var offset = (isTarget) ? $el.position() : $el.offset();

        var width = $el.width();
        var height = $el.height();

        var barWidth = this.$contextbar.width();
        var barHeight = this.$contextbar.height();
        var docScrollTop = (isTarget) ? (this.$target.scrollTop() + this.$doc.scrollTop()) : this.$doc.scrollTop();

        var targetOffset = this.$target.offset();
        var leftFix = (isTarget) ? targetOffset.left : 0;
        var topFix = (isTarget) ? targetOffset.top : 0;

        if (!position)
        {
            top = (e.clientY + docScrollTop - barHeight);
            left = (e.clientX - barWidth/2);
        }
        else if (position === 'top')
        {
            top = (offset.top - barHeight);
            left = (offset.left + width/2 - barWidth/2);
        }
        else if (position === 'bottom')
        {
            top = (offset.top + height);
            left = (offset.left + width/2 - barWidth/2);
        }

        if (left < 0) left = 0;

        return { top: (top - topFix) + 'px', left: (left - leftFix) + 'px' };
    }
});
$R.add('class', 'contextbar.button', {
    mixins: ['dom'],
    init: function(app, obj)
    {
        this.app = app;

        // local
        this.obj = obj;

        // init
        this._init();
    },
    // private
    _init: function()
    {
        this.parse('<a>');

        if (typeof this.obj.title !== 'string')
        {
            var url = this.obj.title.attr('href');
            this.attr('href', url);

            if (url.search(/^#/) === -1) {
                this.attr('target', '_blank');
            }

            this.html(this.obj.html || url);
        }
        else
        {
            this.attr('href', '#');

            this._buildTitle();
            this._buildMessage();
        }
    },
    _buildTitle: function()
    {
        this.html(this.obj.title);
    },
    _buildMessage: function()
    {
        if (typeof this.obj.message !== 'undefined' || typeof this.obj.api !== 'undefined')
        {
            this.on('click', this._toggle.bind(this));
        }
    },
    _toggle: function(e)
    {
        e.preventDefault();

        if (this.obj.message)
        {
            this.app.broadcast(this.obj.message, this.obj.args);
        }
        else if (this.obj.api)
        {
            this.app.api(this.obj.api, this.obj.args);
        }
    }
});
$R.add('module', 'toolbar', {
    init: function(app)
    {
        this.app = app;
        this.uuid = app.uuid;
        this.opts = app.opts;
        this.utils = app.utils;
        this.toolbar = app.toolbar;

        // local
        this.buttons = [];
        this.toolbarModule = false;
    },
    // messages
    onsource: {
        open: function()
        {
            if (!this.toolbar.isAir() && this.toolbar.isFixed())
            {
                this.toolbarModule.resetPosition();
            }
        },
        opened: function()
        {
            if (this.toolbar.isAir() && this.toolbarModule)
            {
                this.toolbarModule.createSourceHelper();
            }

            // hide tooltips
            setTimeout(function()
            {
                $R.dom('.re-button-tooltip-' + this.uuid).remove();
            }.bind(this), 100)

        },
        close: function()
        {
            if (this.toolbar.isAir() && this.toolbarModule)
            {
                this.toolbarModule.destroySourceHelper();
            }
        },
        closed: function()
        {
            if (this.toolbar.is() && this.opts.air)
            {
                this.toolbarModule.openSelected();
            }
        }
    },
    ontoolbar: {
        removeexternal: function() {
            if (!this.opts.air && this.opts.toolbarExternal && this.opts.clickToEdit) {
                $R.dom(this.opts.toolbarExternal).html('');
            }
        }
    },
    onobserve: function()
    {
        if (this.toolbar.is())
        {
            this.toolbar.observe();
        }
    },
    onfocus: function()
    {
        this._setExternalOnFocus();
    },
    onsourcefocus: function()
    {
        this._setExternalOnFocus();
    },
    onempty: function()
    {
        if (this.toolbar.isFixed())
        {
            this.toolbarModule.resetPosition();
        }
    },
    onenablereadonly: function()
    {
        if (this.toolbar.isAir())
        {
            this.toolbarModule.close();
        }
    },

    // public
    start: function()
    {
        if (this.toolbar.is())
        {
            this._buildButtons();
            this._initToolbar();
            this._initButtons();
        }
    },
    stop: function()
    {
        if (this.toolbarModule)
        {
            this.toolbarModule.stop();
        }

        // stop dropdowns
        $R.dom('.redactor-dropdown-' + this.uuid).remove();
    },

    // private
    _buildButtons: function()
    {
        this.buttons = this.opts.buttons.concat();

        this._buildImageButton();
        this._buildFileButton();
        this._buildSourceButton();
        this._buildAdditionalButtons();
        this._buildHiddenButtons();
    },
    _buildImageButton: function()
    {
        if (!this.opts.imageUpload && !this.opts.imageManagerJson) this.utils.removeFromArrayByValue(this.buttons, 'image');
    },
    _buildFileButton: function()
    {
        if (!this.opts.fileUpload) this.utils.removeFromArrayByValue(this.buttons, 'file');
    },
    _buildSourceButton: function()
    {
        if (!this.opts.source) this.utils.removeFromArrayByValue(this.buttons, 'html');
    },
    _buildAdditionalButtons: function()
    {
        // end
        if (this.opts.buttonsAdd.length !== 0)
        {
            this.opts.buttonsAdd = this._removeExistButtons(this.opts.buttonsAdd);
            this.buttons = this.buttons.concat(this.opts.buttonsAdd);
        }

        // beginning
        if (this.opts.buttonsAddFirst.length !== 0)
        {
            this.opts.buttonsAddFirst = this._removeExistButtons(this.opts.buttonsAddFirst);
            this.buttons.unshift(this.opts.buttonsAddFirst);
        }

        var index, btns;

        // after
        if (this.opts.buttonsAddAfter !== false)
        {
            index = this.buttons.indexOf(this.opts.buttonsAddAfter.after) + 1;
            btns = this.opts.buttonsAddAfter.buttons;
            for (var i = 0; i < btns.length; i++)
            {
                this.buttons.splice(index+i, 0, btns[i]);
            }
        }

        // before
        if (this.opts.buttonsAddBefore !== false)
        {
            index = this.buttons.indexOf(this.opts.buttonsAddBefore.before)+1;
            btns = this.opts.buttonsAddBefore.buttons;
            for (var i = 0; i < btns.length; i++)
            {
                this.buttons.splice(index-(1-i), 0, btns[i]);
            }
        }
    },
    _buildHiddenButtons: function()
    {
        if (this.opts.buttonsHide.length !== 0)
        {
            var buttons = this.opts.buttonsHide;
            for (var i = 0; i < buttons.length; i++)
            {
                this.utils.removeFromArrayByValue(this.buttons, buttons[i]);
            }
        }
    },
    _removeExistButtons: function(buttons)
    {
        for (var i = 0; i < buttons.length; i++)
        {
            if (this.opts.buttons.indexOf(buttons[i]) !== -1)
            {
                this.utils.removeFromArrayByValue(buttons, buttons[i]);
            }
        }

        return buttons;
    },
    _setExternalOnFocus: function()
    {
        if (!this.opts.air && this.opts.toolbarExternal)
        {
            this.toolbarModule.setExternal();
        }
    },
    _initToolbar: function()
    {
        this.toolbarModule = (this.opts.air) ? $R.create('toolbar.air', this.app) : $R.create('toolbar.standard', this.app);
    },
    _initButtons: function()
    {
        this.toolbar.setButtons(this.buttons);

        for (var i = 0; i < this.buttons.length; i++)
        {
            var name = this.buttons[i];
            if ($R.buttons[name])
            {
                this.toolbar.addButton(name, $R.buttons[name], false, false, true);
            }
        }
    }
});
$R.add('class', 'toolbar.air', {
    init: function(app)
    {
        this.app = app;
        this.uuid = app.uuid;
        this.$doc = app.$doc;
        this.$win = app.$win;
        this.utils = app.utils;
        this.editor = app.editor;
        this.animate = app.animate;
        this.toolbar = app.toolbar;
        this.container = app.container;
        this.inspector = app.inspector;
        this.selection = app.selection;

        // local
        this.clicks = 0;

        // init
        this._init();
    },
    // public
    stop: function()
    {
        var $wrapper = this.toolbar.getWrapper();
        $wrapper.remove();

        var $editor = this.editor.getElement();
        $editor.off('.redactor-air-trigger-' + this.uuid);

        this.$doc.off('.redactor-air-' + this.uuid);
        this.$doc.off('.redactor-air-trigger-' + this.uuid);

        this.toolbar.stopObservers();
    },
    createSourceHelper: function()
    {
        this.$airHelper = $R.dom('<span>');
        this.$airHelper.addClass('redactor-air-helper');
        this.$airHelper.html('<i class="re-icon-html"></i>');
        this.$airHelper.on('click', function(e)
        {
            e.preventDefault();
            this.app.api('module.source.hide');

        }.bind(this));

        var $container = this.container.getElement();
        $container.append(this.$airHelper);
    },
    destroySourceHelper: function()
    {
        if (this.$airHelper) this.$airHelper.remove();
    },
    openSelected: function()
    {
        setTimeout(function()
        {
            if (this._isSelection()) this._open(false);

        }.bind(this), 0);
    },
    close: function()
    {
        this.$doc.off('.redactor-air-' + this.uuid);

        var $toolbar = this.toolbar.getElement();
        $toolbar.removeClass('open');
        $toolbar.hide();
    },

    // private
    _init: function()
    {
        this.toolbar.create();

        var $wrapper = this.toolbar.getWrapper();
        var $toolbar = this.toolbar.getElement();
        var $editor = this.editor.getElement();
        var $container = this.container.getElement();

        $wrapper.addClass('redactor-toolbar-wrapper-air');
        $toolbar.addClass('redactor-air');
        //$toolbar.addClass('redactor-animate-hide');
        $toolbar.hide();

        $wrapper.append($toolbar);
        $container.prepend($wrapper);

        // open selected
        this.openSelected();

        // events
        this.$doc.on('mouseup.redactor-air-trigger-' + this.uuid, this._open.bind(this));
        $editor.on('keyup.redactor-air-trigger-' + this.uuid, this._openCmd.bind(this));
    },
    _isSelection: function()
    {
        return (this.selection.is() && !this.selection.isCollapsed());
    },
    _isOpened: function()
    {
        var $toolbar = this.toolbar.getElement();

        return $toolbar.hasClass('open');
    },
    _open: function(e)
    {
        var target = (e) ? e.target : false;
        var $el = (e) ? $R.dom(e.target) : false;
        var dataTarget = this.inspector.parse(target);
        var isComponent = (dataTarget.isComponent() && !dataTarget.isComponentType('table'));
        var isFigcaption = (dataTarget.isFigcaption());
        var isModalTarget = ($el && $el.closest('.redactor-modal').length !== 0);
        var isButtonCall = (e && $el.closest('.re-button').length !== 0);
        var isDropdownCall = (e && $el.closest('.redactor-dropdown').length !== 0);

        if (isDropdownCall || isButtonCall || isModalTarget || isFigcaption || isComponent || this.toolbar.isContextBar() || !this._isSelection())
        {
            return;
        }

        var pos = this.selection.getPosition();

        setTimeout(function()
        {
            if (this.app.isReadOnly()) return;
            if (this._isSelection()) this._doOpen(pos);

        }.bind(this), 1);

    },
    _openCmd: function()
    {
        if (this.selection.isAll())
        {
            var $toolbar = this.toolbar.getElement();
            var pos = this.selection.getPosition();

            pos.top = (pos.top < 20) ? 0 : pos.top - $toolbar.height();
            pos.height = 0;

            this._doOpen(pos);
        }
    },
    _doOpen: function(pos)
    {
        var $wrapper = this.toolbar.getWrapper();
        var $toolbar = this.toolbar.getElement();
        var $container = this.container.getElement();
        var containerOffset = $container.offset();
        var leftFix = 0;
        var winWidth = this.$win.width();
        var toolbarWidth = $toolbar.width();

        if (winWidth < (pos.left + toolbarWidth))
        {
            var selPos = this.selection.getPosition();
            leftFix = toolbarWidth - selPos.width;
        }

        $wrapper.css({
            left: (pos.left - containerOffset.left - leftFix) + 'px',
            top: (pos.top - containerOffset.top + pos.height + this.$doc.scrollTop()) + 'px'
        });

        this.app.broadcast('airOpen');
        $toolbar.addClass('open');
        $toolbar.show();

        this.$doc.on('click.redactor-air-' + this.uuid, this._close.bind(this));
        this.$doc.on('keydown.redactor-air-' + this.uuid, this._close.bind(this));
        this.app.broadcast('airOpened');
    },
    _close: function(e)
    {
        var $el = (e) ? $R.dom(e.target) : false;
        var isDropdownCall = (e && $el.closest('[data-dropdown], .redactor-dropdown-not-close').length !== 0);
        var isButtonCall = (!isDropdownCall && e && $el.closest('.re-button').length !== 0);

        if (!isButtonCall && (isDropdownCall || !this._isOpened()))
        {
            return;
        }

        // close
        this.app.broadcast('airClose');

        this.close();
        this.app.broadcast('airClosed');
    }
});
$R.add('class', 'toolbar.fixed', {
    init: function(app)
    {
        this.app = app;
        this.uuid = app.uuid;
        this.opts = app.opts;
        this.$doc = app.$doc;
        this.$win = app.$win;
        this.editor = app.editor;
        this.toolbar = app.toolbar;
        this.detector = app.detector;
        this.container = app.container;

        // init
        this._init();
    },
    // public
    stop: function()
    {
        this.$fixedTarget.off('.redactor-toolbar-' + this.uuid);
        this.$win.off('.redactor-toolbar-' + this.uuid);
    },
    reset: function()
    {
        var $toolbar = this.toolbar.getElement();
        var $wrapper = this.toolbar.getWrapper();

        $wrapper.css('height', '');
        $toolbar.removeClass('redactor-toolbar-fixed');
        $toolbar.css({ position: '', top: '', left: '', width: '' });

        var dropdown = this.toolbar.getDropdown();
        if (dropdown) dropdown.updatePosition();
    },

    // private
    _init: function()
    {
        this.$fixedTarget = (this.toolbar.isTarget()) ? this.toolbar.getTargetElement() : this.$win;
        this._doFixed();

        if (this.toolbar.isTarget())
        {
            this.$win.on('scroll.redactor-toolbar-' + this.uuid, this._doFixed.bind(this));
            this.$win.on('resize.redactor-toolbar-' + this.uuid, this._doFixed.bind(this));
        }

        this.$fixedTarget.on('scroll.redactor-toolbar-' + this.uuid, this._doFixed.bind(this));
        this.$fixedTarget.on('resize.redactor-toolbar-' + this.uuid, this._doFixed.bind(this));
    },
    _doFixed: function()
    {
        var $editor = this.editor.getElement();
        var $container = this.container.getElement();
        var $toolbar = this.toolbar.getElement();
        var $wrapper = this.toolbar.getWrapper();

        if (this.editor.isSourceMode())
        {
            return;
        }

        var $targets = $container.parents().filter(function(node)
        {
            return (getComputedStyle(node, null).display === 'none') ? node : false;
        });

        // has hidden parent
        if ($targets.length !== 0) return;

        var isHeight = ($editor.height() < 100);
        var isEmpty = this.editor.isEmpty();

        if (isHeight || isEmpty) {
            this.reset();
            return;
        }

        if (this.editor.isSourceMode()) {
            return;
        }

        var toolbarHeight = $toolbar.height();
        var toleranceEnd = 60;
        var containerOffset = (this.toolbar.isTarget()) ? $container.position() : $container.offset();
        var boxOffset = containerOffset.top;
        var boxEnd = boxOffset + $container.height() - toleranceEnd;
        var scrollOffset = this.$fixedTarget.scrollTop() + this.opts.toolbarFixedTopOffset;
        var top = (!this.toolbar.isTarget()) ? 0 : this.$fixedTarget.offset().top - this.$win.scrollTop();
        if (this.toolbar.isTarget() && this.$fixedTarget.css('position') === 'fixed') {
            var bs = (this.$fixedTarget.hasClass('modal') && this.$fixedTarget.hasClass('fade'));
            var bsFix = (bs) ? $container.closest('.modal-dialog').position().top : 0;
            top = this.$fixedTarget.scrollTop() - bsFix;
        }


        if (scrollOffset > boxOffset && scrollOffset < boxEnd)
        {
            var position = (this.detector.isDesktop()) ? 'fixed' : 'absolute';
            top = (this.detector.isDesktop()) ? top : (scrollOffset - boxOffset);

            if (this.detector.isMobile())
            {
                if (this.fixedScrollTimeout)
                {
                    clearTimeout(this.fixedScrollTimeout);
                }

                $toolbar.hide();
                this.fixedScrollTimeout = setTimeout(function()
                {
                    $toolbar.show();
                }, 250);
            }

            $wrapper.height(toolbarHeight);
            $toolbar.addClass('redactor-toolbar-fixed');

            if ($container.hasClass('redactor-box-fullscreen'))
            {
                $toolbar.css({
                    position: position,
                    top: '0px',
                    width: $container.width() + 'px'
                });
            }
            else
            {
                $toolbar.css({
                    position: position,
                    top: (top + this.opts.toolbarFixedTopOffset) + 'px',
                    width: $container.width() + 'px'
                });
            }

            var dropdown = this.toolbar.getDropdown();
            if (dropdown) dropdown.updatePosition();

            this.app.broadcast('toolbar.fixed');
        }
        else
        {
            this.reset();
            this.app.broadcast('toolbar.unfixed');
        }
    }
});
$R.add('class', 'toolbar.standard', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.uuid = app.uuid;
        this.$body = app.$body;
        this.toolbar = app.toolbar;
        this.container = app.container;

        // local
        this.isExternalMultiple = false;
        this.toolbarFixed = false;

        // init
        this._init();
    },
    // public
    stop: function()
    {
        var $wrapper = this.toolbar.getWrapper();
        $wrapper.remove();

        if (this.toolbarFixed) this.toolbarFixed.stop();
        if (this.opts.toolbarExternal) this._findToolbars();

        this.toolbar.stopObservers();
        this.$body.find('.re-button-tooltip-' + this.uuid).remove();
    },
    setExternal: function()
    {
        this._findToolbars();
        if (this.isExternalMultiple)
        {
            this.$toolbars.hide();
            var $current = this.$external.find('.redactor-toolbar-external-' + this.uuid);
            $current.show();
        }
    },
    resetPosition: function()
    {
        if (this.toolbarFixed) this.toolbarFixed.reset();
    },

    // private
    _init: function()
    {
        this._build();

        if (this.opts.toolbarExternal)
        {
            this._buildExternal();
        }
        else
        {
            this._buildFixed();

            var $toolbar = this.toolbar.getElement();
            $toolbar.show();
        }
    },
    _build: function()
    {
        this.toolbar.create();

        var $wrapper = this.toolbar.getWrapper();
        var $toolbar = this.toolbar.getElement();

        $wrapper.addClass('redactor-toolbar-wrapper');
        $toolbar.addClass('redactor-toolbar');
        $toolbar.hide();
        $wrapper.append($toolbar);

        if (!this.opts.toolbarExternal)
        {
            var $container = this.container.getElement();
            $container.prepend($wrapper);
        }
    },
    _buildExternal: function()
    {
        this._initExternal();
        this._findToolbars();

        if (this.isExternalMultiple)
        {
            this._hideToolbarsExceptFirst();
        }
        else
        {
            var $toolbar = this.toolbar.getElement();
            $toolbar.show();
        }
    },
    _buildFixed: function()
    {
        if (this.opts.toolbarFixed)
        {
            this.toolbarFixed = $R.create('toolbar.fixed', this.app);
        }
    },
    _initExternal: function()
    {
        var $toolbar = this.toolbar.getElement();
        var $wrapper = this.toolbar.getElement();

        $toolbar.addClass('redactor-toolbar-external redactor-toolbar-external-' + this.uuid);

        this.$external = $R.dom(this.opts.toolbarExternal);
        this.$external.append($wrapper);

    },
    _findToolbars: function()
    {
        this.$toolbars = this.$external.find('.redactor-toolbar-external');
        this.isExternalMultiple = (this.$toolbars.length > 1);
    },
    _hideToolbarsExceptFirst: function()
    {
        this.$toolbars.hide();
        var $first = this.$toolbars.first();
        $first.show();
    }
});
$R.add('module', 'line', {
    init: function(app)
    {
        this.app = app;
        this.lang = app.lang;
        this.component = app.component;
        this.inspector = app.inspector;
        this.insertion = app.insertion;
    },
    // messages
    oncontextbar: function(e, contextbar)
    {
        var data = this.inspector.parse(e.target);
        if (data.isComponentType('line'))
        {
            var node = data.getComponent();
            var buttons = {
                "remove": {
                    title: this.lang.get('delete'),
                    api: 'module.line.remove',
                    args: node
                }
            };

            contextbar.set(e, node, buttons, 'bottom');
        }

    },

    // public
    insert: function()
    {
        var line = this.component.create('line');
        this.insertion.insertRaw(line);
    },
    remove: function(node)
    {
        this.component.remove(node);
    }
});
$R.add('class', 'line.component', {
    mixins: ['dom', 'component'],
    init: function(app, el)
    {
        this.app = app;

        // init
        return (el && el.cmnt !== undefined) ? el : this._init(el);
    },
    // private
    _init: function(el)
    {
        var wrapper, element;
        if (typeof el !== 'undefined')
        {
            var $node = $R.dom(el);
            var node = $node.get();

            if (node.tagName === 'HR') element = node;
            else if (node.tagName === 'FIGURE')
            {
                wrapper = node;
                element = $node.find('hr').get();
            }
        }

        this._buildWrapper(wrapper);
        this._buildElement(element);
        this._initWrapper();
    },
    _buildElement: function(node)
    {
        if (node)
        {
            this.$element = $R.dom(node);
        }
        else
        {
            this.$element = $R.dom('<hr>');
            this.append(this.$element);
        }
    },
    _buildWrapper: function(node)
    {
        node = node || '<figure>';

        this.parse(node);
    },
    _initWrapper: function()
    {
        this.addClass('redactor-component');
        this.attr({
            'data-redactor-type': 'line',
            'tabindex': '-1',
            'contenteditable': false
        });
    }
});
$R.add('module', 'link', {
    modals: {
        'link':
            '<form action=""> \
                <div class="form-item"> \
                    <label for="modal-link-url">URL <span class="req">*</span></label> \
                    <input type="text" id="modal-link-url" name="url"> \
                </div> \
                <div class="form-item"> \
                    <label for="modal-link-text">## text ##</label> \
                    <input type="text" id="modal-link-text" name="text"> \
                </div> \
                <div class="form-item form-item-title"> \
                    <label for="modal-link-title">## title ##</label> \
                    <input type="text" id="modal-link-title" name="title"> \
                </div> \
                <div class="form-item form-item-target"> \
                    <label class="checkbox"> \
                        <input type="checkbox" name="target"> ## link-in-new-tab ## \
                    </label> \
                </div> \
            </form>'
    },
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.lang = app.lang;
        this.caret = app.caret;
        this.cleaner = app.cleaner;
        this.utils = app.utils;
        this.inline = app.inline;
        this.editor = app.editor;
        this.inspector = app.inspector;
        this.insertion = app.insertion;
        this.selection = app.selection;

        // local
        this.isCurrentLink = false;
        this.currentText = false;
    },
    // messages
    onmodal: {
        link: {
            open: function($modal, $form)
            {
                this._setFormData($form, $modal);
            },
            opened: function($modal, $form)
            {
                this._setFormFocus($form);
            },
            update: function($modal, $form)
            {
                var data = $form.getData();
                if (this._validateData($form, data))
                {
                    this._update(data);
                }
            },
            insert: function($modal, $form)
            {
                var data = $form.getData();
                if (this._validateData($form, data))
                {
                    this._insert(data);
                }
            },
            unlink: function()
            {
                this._unlink();
            }
        }
    },
    onbutton: {
        link: {
            observe: function(button)
            {
                this._observeButton(button);
            }
        }
    },
    ondropdown: {
        link: {
            observe: function(dropdown)
            {
                this._observeUnlink(dropdown);
                this._observeEdit(dropdown);
            }
        }
    },
    oncontextbar: function(e, contextbar)
    {
        var current = this._getCurrent();
        var data = this.inspector.parse(current);
        if (data.isLink() || data.isFile())
        {
            var node = (data.isFile()) ? data.getFile() : data.getLink();
            var $el = $R.dom(node);

            var $point = $R.dom('<a>');
            var url = $el.attr('href');

            $point.text(this._truncateText(url));
            $point.attr('href', url);
            $point.attr('target', '_blank');

            var buttons = {
                "link": {
                    title: $point,
                    html: this._truncateText(url)
                },
                "edit": {
                    title: this.lang.get('edit'),
                    api: 'module.link.open'
                },
                "unlink": {
                    title: this.lang.get('unlink'),
                    api: 'module.link.unlink'
                }
            };

            contextbar.set(e, node, buttons, 'bottom');
        }
    },

    // public
    open: function()
    {
        this.$link = this._buildCurrent();
        this.app.api('module.modal.build', this._getModalData());
    },
    insert: function(data)
    {
        this._insert(data);
    },
    update: function(data)
    {
        this._update(data);
    },
    unlink: function()
    {
        this._unlink();
    },

    // private
    _observeButton: function(button)
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);

        if (data.isPre() || data.isCode())
        {
            button.disable();
        }
        else
        {
            button.enable();
        }
    },
    _observeUnlink: function(dropdown)
    {
        var $item = dropdown.getItem('unlink');
        var links = this._getLinks();

        if (links.length === 0) $item.disable();
        else                    $item.enable();
    },
    _observeEdit: function(dropdown)
    {
        var current = this._getCurrent();
        var $item = dropdown.getItem('link');

        var data = this.inspector.parse(current);
        var title = (data.isLink() || data.isFile()) ? this.lang.get('link-edit') : this.lang.get('link-insert');

        $item.setTitle(title);
    },
    _unlink: function()
    {
        this.app.api('module.modal.close');

        var elms = [];
        var nodes = this._getLinks();

        this.selection.save();
        for (var i = 0; i < nodes.length; i++)
        {
            var $link = $R.create('link.component', this.app, nodes[i]);
            elms.push(this.selection.getElement(nodes[i]));

            $link.unwrap();

            // callback
            this.app.broadcast('link.deleted', $link);
        }
        this.selection.restore();

        // normalize
        for (var i = 0; i < elms.length; i++)
        {
            var el = (elms[i]) ? elms[i] : this.editor.getElement();
            this.utils.normalizeTextNodes(el);
        }

        this._resetCurrent();
    },
    _cleanData: function(data)
    {
        data.url = this.cleaner.removeTags(data.url);
        data.text = this.cleaner.removeTags(data.text);
    },
    _update: function(data)
    {
        this.app.api('module.modal.close');

        var nodes = this._getLinks();

        this._cleanData(data);
        this._setLinkData(nodes, data, 'updated');
        this._resetCurrent();

        // callback
        this.app.broadcast('link.changed', nodes);
    },
    _insert: function(data)
    {
        this.app.api('module.modal.close');

        var links = this._getLinks();
        this._cleanData(data);

        if (!this._insertSingle(links, data))
        {
            this._removeInSelection(links);
            this._insertMultiple(data);
        }

        this._resetCurrent();
    },
    _removeInSelection: function(links)
    {
        this.selection.save();
        for (var i = 0; i < links.length; i++)
        {
            var $link = $R.create('link.component', this.app, links[i]);
            var $clonedLink = $link.clone();
            $link.unwrap();

            // callback
            this.app.broadcast('link.deleted', $clonedLink);
        }
        this.selection.restore();
    },
    _insertMultiple: function(data)
    {
        var range = this.selection.getRange();
        if (range && this._isCurrentTextChanged(data))
        {
            this._deleteContents(range);
        }

        var nodes = this.inline.format({ tag: 'a' });

        this._setLinkData(nodes, data, 'inserted');
    },
    _insertSingle: function(links, data)
    {
        var inline = this.selection.getInline();
        if (links.length === 1 && (links[0].textContext === this.selection.getText()) || (inline && inline.tagName === 'A'))
        {
            var $link = $R.create('link.component', this.app, links[0]);

            $link.setData(data);
            this.caret.setAfter($link);

            // callback
            this.app.broadcast('link.inserted', $link);

            return true;
        }

        return false;
    },
    _setLinkData: function(nodes, data, type)
    {
        data.text = (data.text.trim() === '') ? this._truncateText(data.url) : data.text;

        var isTextChanged = (!this.currentText || this.currentText !== data.text);

        this.selection.save();
        for (var i = 0; i < nodes.length; i++)
        {
            var $link = $R.create('link.component', this.app, nodes[i]);
            var linkData = {};

            if (data.text && isTextChanged) linkData.text = data.text;
            if (data.url) linkData.url = data.url;
            if (data.title !== undefined) linkData.title = data.title;
            if (data.target !== undefined) linkData.target = data.target;

            $link.setData(linkData);

            // callback
            this.app.broadcast('link.' + type, $link);
        }

        setTimeout(this.selection.restore.bind(this.selection), 0);
    },
    _deleteContents: function(range)
    {
        var html = this.selection.getHtml();
        var parsed = this.utils.parseHtml(html);
        var first = parsed.nodes[0];

        if (first && first.nodeType !== 3)
        {
            var tag = first.tagName.toLowerCase();
            var container = document.createElement(tag);

            this.insertion.insertNode(container, 'start');
        }
        else
        {
            range.deleteContents();
        }
    },
    _getModalData: function()
    {
        var commands;
        if (this._isLink())
        {
           commands = {
                update: { title: this.lang.get('save') },
                unlink: { title: this.lang.get('unlink'), type: 'danger' },
                cancel: { title: this.lang.get('cancel') }
            };
        }
        else
        {
            commands = {
                insert: { title: this.lang.get('insert') },
                cancel: { title: this.lang.get('cancel') }
            };
        }

        var modalData = {
            name: 'link',
            title: (this._isLink()) ? this.lang.get('link-edit') : this.lang.get('link-insert'),
            handle: (this._isLink()) ? 'update' : 'insert',
            commands: commands
        };


        return modalData;
    },
    _isLink: function()
    {
        return this.currentLink;
    },
    _isCurrentTextChanged: function(data)
    {
        return (this.currentText && this.currentText !== data.text);
    },
    _buildCurrent: function()
    {
        var current = this._getCurrent();
        var data = this.inspector.parse(current);
        var $link;

        if (data.isLink() || data.isFile())
        {
            this.currentLink = true;

            $link = (data.isFile()) ? data.getFile() : data.getLink();
            $link = $R.create('link.component', this.app, $link);
        }
        else
        {
            this.currentLink = false;

            $link = $R.create('link.component', this.app);
            var linkData = {
                text: this.selection.getText()
            };

            $link.setData(linkData);
        }

        return $link;
    },
    _getCurrent: function()
    {
        return this.selection.getInlinesAllSelected({ tags: ['a'] })[0];
    },
    _getLinks: function()
    {
        var links = this.selection.getInlines({ all: true, tags: ['a'] });
        var arr = [];
        for (var i = 0; i < links.length; i++)
        {
            var data = this.inspector.parse(links[i]);
            if (data.isLink() || data.isFile())
            {
                arr.push(links[i]);
            }
        }

        return arr;
    },
    _resetCurrent: function()
    {
        this.isCurrentLink = false;
        this.currentText = false;
    },
    _truncateText: function(url)
    {
        return (url && url.length > this.opts.linkSize) ? url.substring(0, this.opts.linkSize) + '...' : url;
    },
    _validateData: function($form, data)
    {
        return (data.url.trim() === '') ? $form.setError('url') : true;
    },
    _setFormFocus: function($form)
    {
        $form.getField('url').focus();
    },
    _setFormData: function($form, $modal)
    {
        var linkData = this.$link.getData();
        var data = {
            url: linkData.url,
            text: linkData.text,
            title: linkData.title,
            target: (this.opts.linkTarget || linkData.target)
        };

        if (!this.opts.linkNewTab) $modal.find('.form-item-target').hide();
        if (!this.opts.linkTitle) $modal.find('.form-item-title').hide();

        $form.setData(data);
        this.currentText = $form.getField('text').val();
    }
});
$R.add('class', 'link.component', {
    mixins: ['dom', 'component'],
    init: function(app, el)
    {
        this.app = app;
        this.opts = app.opts;

        // local
        this.reUrl = /^(?:(?:(?:https?|ftp):)?\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

        // init
        return (el && el.cmnt !== undefined) ? el :  this._init(el);
    },

    // public
    setData: function(data)
    {
        for (var name in data)
        {
            this._set(name, data[name]);
        }
    },
    getData: function()
    {
        var names = ['url', 'text', 'target', 'title'];
        var data = {};

        for (var i = 0; i < names.length; i++)
        {
            data[names[i]] = this._get(names[i]);
        }

        return data;
    },

    // private
    _init: function(el)
    {
        var $el = $R.dom(el);
        if (el === undefined)
        {
            this.parse('<a>');
        }
        else
        {
            this.parse($el);
        }
    },
    _set: function(name, value)
    {
        this['_set_' + name](value);
    },
    _get: function(name)
    {
        return this['_get_' + name]();
    },
    _get_target: function()
    {
        return (this.attr('target')) ? this.attr('target') : false;
    },
    _get_url: function()
    {
        return this.attr('href');
    },
    _get_title: function()
    {
        return this.attr('title');
    },
    _get_text: function()
    {
        return this._getContext().text();
    },
    _getContext: function()
    {
        return this._findDeepestChild(this).element;
    },
    _set_target: function(target)
    {
        if (target === false) this.removeAttr('target');
        else if (target)
        {
            this.attr('target', (target === true) ? '_blank' : target);
        }
    },
    _set_text: function(text)
    {
        this._getContext().html(text);
    },
    _set_title: function(title)
    {
        if (!title || title === '') this.removeAttr('title');
        else this.attr('title', title);
    },
    _set_url: function(url)
    {
        if (this.opts.linkValidation)
        {
            url = this._cleanUrl(url);

            if (this._isMailto(url))
            {
                url = 'mailto:' + url.replace('mailto:', '');
            }
            else if (this._isUrl(url) && url.search(/^(ftp|https?)/i) === -1)
            {
                url = 'http://' + url.replace(/(ftp|https?):\/\//i, '');
            }
        }

        this.attr('href', url);
    },
    _isMailto: function(url)
    {
        return (url.search('@') !== -1 && /(ftp|https?):\/\//i.test(url) === false);
    },
    _isUrl: function(url)
    {
        return this.reUrl.test(url);
    },
    _cleanUrl: function(url)
    {
        return url.trim().replace(/[^\W\w\D\d+&\'@#/%?=~_|!:,.;\(\)]/gi, '');
    },
    _findDeepestChild: function(parent)
    {
        var result = {depth: 0, element: parent };

        parent.children().each(function(node)
        {
            var child = $R.dom(node);

            if (node.outerHTML !== parent.html())
            {
                return;
            }
            else
            {
                var childResult = this._findDeepestChild(child);
                if (childResult.depth + 1 > result.depth)
                {
                    result = {
                        depth: 1 + childResult.depth,
                        element: childResult.element
                    };
                }
            }
        }.bind(this));

        return result;
    }
});
$R.add('module', 'modal', {
    init: function(app)
    {
        this.app = app;
        this.lang = app.lang;
        this.$doc = app.$doc;
        this.$win = app.$win;
        this.$body = app.$body;
        this.utils = app.utils;
        this.editor = app.editor;
        this.animate = app.animate;
        this.detector = app.detector;
        this.selection = app.selection;

        // local
        this.$box = false;
        this.$modal = false;
        this.selectionMarkers = false;

        // defaults
        this.defaults = {
            name: false,
            url: false,
            title: false,
            width: '600px',
            height: false,
            handle: false,
            commands: false
        };
    },
    // public
    build: function(data)
    {
        this._open(data);
    },
    close: function()
    {
        this._close();
    },
    stop: function()
    {
        if (this.$box)
        {
            this.$box.remove();
            this.$box = false;
            this.$modal = false;

            this.$doc.off('.redactor.modal');
            this.$win.off('.redactor.modal');
        }

        if (this.$overlay)
        {
            this.$overlay.remove();
        }
    },
    resize: function()
    {
        this.$modal.setWidth(this.p.width);
        this.$modal.updatePosition();
    },

    // private
    _isOpened: function()
    {
        return (this.$modal && this.$modal.hasClass('open'));
    },
    _open: function(data)
    {
        this._buildDefaults(data);

        if (this.p.url) this._openUrl();
        else this._openTemplate();
    },
    _openUrl: function()
    {
        $R.ajax.post({
            url: this.p.url,
            success: this._doOpen.bind(this)
        });
    },
    _openTemplate: function()
    {
        if (typeof $R.modals[this.p.name] !== 'undefined')
        {
            var template = this.lang.parse($R.modals[this.p.name]);
            this._doOpen(template);
        }
    },
    _doOpen: function(template)
    {
        this.stop();

        if (this.selection.isCollapsed())
        {
            this.selection.save();
            this.selectionMarkers = false;
        }
        else
        {
            this.selection.saveMarkers();
            this.selectionMarkers = true;
        }

        if (!this.detector.isDesktop())
        {
            document.activeElement.blur();
        }

        this._createModal(template);

        this._buildModalBox();
        this._buildOverlay();
        this._buildModal();
        this._buildModalForm();
        this._buildModalCommands();

        this._broadcast('open');

        this.$modal.updatePosition();
        this._buildModalTabs();

        this.animate.start(this.$box, 'fadeIn', this._opened.bind(this));
        this.animate.start(this.$overlay, 'fadeIn');

    },
    _opened: function()
    {
        this.$modal.addClass('open');
        this.$box.on('mousedown.redactor.modal', this._close.bind(this));
        this.$doc.on('keyup.redactor.modal', this._handleEscape.bind(this));
        this.$win.on('resize.redactor.modal', this.resize.bind(this));
        this.$modal.getBody().find('input[type=text],input[type=url],input[type=email]').on('keydown.redactor.modal', this._handleEnter.bind(this));

        // fix bootstrap modal focus
        if (window.jQuery) jQuery(document).off('focusin.modal');

        this._broadcast('opened');
    },
    _close: function(e)
    {
        if (!this.$box || !this._isOpened()) return;

        if (e)
        {
            if (!this._needToClose(e.target))
            {
                return;
            }

            e.stopPropagation();
            e.preventDefault();
        }

        if (this.selectionMarkers) this.selection.restoreMarkers();
        else this.selection.restore();

        this.selectionMarkers = false;

        this._broadcast('close');

        this.animate.start(this.$box, 'fadeOut', this._closed.bind(this));
        this.animate.start(this.$overlay, 'fadeOut');
    },
    _closed: function()
    {
        this.$modal.removeClass('open');
        this.$box.off('.redactor.modal');
        this.$doc.off('.redactor.modal');
        this.$win.off('.redactor.modal');

        this._broadcast('closed');
    },
    _createModal: function(template)
    {
        this.$modal = $R.create('modal.element', this.app, template);
    },
    _broadcast: function(message)
    {
        this.app.broadcast('modal.' + message, this.$modal, this.$modalForm);
        this.app.broadcast('modal.' + this.p.name + '.' + message, this.$modal, this.$modalForm);
    },
    _buildDefaults: function(data)
    {
         this.p = $R.extend({}, this.defaults, data);
    },
    _buildModalBox: function()
    {
        this.$box = $R.dom('<div>');
        this.$box.attr('id', 'redactor-modal');
        this.$box.addClass('redactor-animate-hide');
        this.$box.html('');
        this.$body.append(this.$box);
    },
    _buildOverlay: function()
    {
        this.$overlay = $R.dom('#redactor-overlay');
        if (this.$overlay.length === 0)
        {
            this.$overlay = $R.dom('<div>');
            this.$overlay.attr('id', 'redactor-overlay');
            this.$overlay.addClass('redactor-animate-hide');
            this.$body.prepend(this.$overlay);
        }
    },
    _buildModal: function()
    {
        this.$box.append(this.$modal);

        this.$modal.setTitle(this.p.title);
        this.$modal.setHeight(this.p.height);
        this.$modal.setWidth(this.p.width);
    },
    _buildModalCommands: function()
    {
        if (this.p.commands)
        {
            var commands = this.p.commands;
            var $footer = this.$modal.getFooter();
            for (var key in commands)
            {
                var $btn = $R.dom('<button>');

                $btn.html(commands[key].title);
                $btn.attr('data-command', key);

                // cancel
                if (key === 'cancel')
                {
                    $btn.attr('data-action', 'close');
                    $btn.addClass('redactor-button-unstyled');
                }

                // danger
                if (typeof commands[key].type !== 'undefined' && commands[key].type === 'danger')
                {
                    $btn.addClass('redactor-button-danger');
                }

                $btn.on('click', this._handleCommand.bind(this));

                $footer.append($btn);
            }
        }
    },
    _buildModalTabs: function()
    {
        var $body = this.$modal.getBody();
        var $tabs = $body.find('.redactor-modal-tab');
        var $box = $body.find('.redactor-modal-tabs');


        if ($tabs.length > 1)
        {
            $box = ($box.length === 0) ? $R.dom('<div>') : $box.html('');
            $box.addClass('redactor-modal-tabs');

            $tabs.each(function(node, i)
            {
                var $node = $R.dom(node);
                var $item = $R.dom('<a>');
                $item.attr('href', '#');
                $item.attr('rel', i);
                $item.text($node.attr('data-title'));
                $item.on('click', this._showTab.bind(this));

                if (i === 0)
                {
                    $item.addClass('active');
                }

                $box.append($item);

            }.bind(this));

            $body.prepend($box);
        }

        if ($tabs.length === 1) {
            $tabs.show();
        }
    },
    _buildModalForm: function()
    {
        this.$modalForm = $R.create('modal.form', this.app, this.$modal.getForm());
    },
    _showTab: function(e)
    {
        e.preventDefault();

        var $el = $R.dom(e.target);
        var index = $el.attr('rel');
        var $body = this.$modal.getBody();
        var $tabs = $body.find('.redactor-modal-tab');

        $tabs.hide();
        $tabs.eq(index).show();

        $body.find('.redactor-modal-tabs a').removeClass('active');
        $el.addClass('active');

    },
    _needToClose: function(el)
    {
        var $target = $R.dom(el);
        if ($target.attr('data-action') === 'close' || this.$modal.isCloseNode(el) || $target.closest('.redactor-modal').length === 0)
        {
            return true;
        }

        return false;
    },
    _handleCommand: function(e)
    {
        var $btn = $R.dom(e.target).closest('button');
        var command = $btn.attr('data-command');

        if (command !== 'cancel') e.preventDefault();

        this._broadcast(command);
    },
    _handleEnter: function(e)
    {
        if (e.which === 13)
        {
            if (this.p.handle)
            {
                e.preventDefault();
                this._broadcast(this.p.handle);
            }
        }
    },
    _handleEscape: function(e)
    {
        if (e.which === 27) this._close();
    }
});
$R.add('class', 'modal.element', {
    mixins: ['dom'],
    init: function(app, template)
    {
        this.app = app;
        this.opts = app.opts;
        this.$win = app.$win;

        // init
        this._init(template);
    },

    // get
    getForm: function()
    {
        return this.find('form');
    },
    getHeader: function()
    {
        return this.$modalHeader;
    },
    getBody: function()
    {
        return this.$modalBody;
    },
    getFooter: function()
    {
        return this.$modalFooter;
    },

    // set
    setTitle: function(title)
    {
        if (title) this.$modalHeader.html(title);
    },
    setWidth: function(width)
    {
        width = (parseInt(width) >= this.$win.width()) ? '96%' : width;

        this.css('max-width', width);
    },
    setHeight: function(height)
    {
        if (height !== false) this.$modalBody.css('height', height);
    },

    // update
    updatePosition: function()
    {
        var width = this.width();
        this.css({ 'left': '50%', 'margin-left': '-' + (width/2) + 'px' });

        var windowHeight = this.$win.height();
        var height = this.height();
        var marginTop = (windowHeight/2 - height/2);

        if (height < windowHeight && marginTop !== 0)
        {
            this.css('margin-top', marginTop + 'px');
        }
    },

    // is
    isCloseNode: function(el)
    {
        return (el === this.$modalClose.get());
    },

    // private
    _init: function(template)
    {
        this._build();
        this._buildClose();
        this._buildHeader();
        this._buildBody();
        this._buildFooter();
        this._buildTemplate(template);
    },
    _build: function()
    {
        this.parse('<div>');
        this.addClass('redactor-modal');
        this.attr('dir', this.opts.direction);
    },
    _buildClose: function()
    {
        this.$modalClose = $R.dom('<span>');
        this.$modalClose.addClass('redactor-close');

        this.append(this.$modalClose);
    },
    _buildHeader: function()
    {
        this.$modalHeader = $R.dom('<div>');
        this.$modalHeader.addClass('redactor-modal-header');

        this.append(this.$modalHeader);
    },
    _buildBody: function()
    {
        this.$modalBody = $R.dom('<div>');
        this.$modalBody.addClass('redactor-modal-body');

        this.append(this.$modalBody);
    },
    _buildFooter: function()
    {
        this.$modalFooter = $R.dom('<div>');
        this.$modalFooter.addClass('redactor-modal-footer');

        this.append(this.$modalFooter);
    },
    _buildTemplate: function(template)
    {
        this.$modalBody.html(template);
    }
});
$R.add('class', 'modal.form', {
    mixins: ['dom'],
    init: function(app, element)
    {
        this.app = app;

        // build
        this.build(element);
    },

    // public
    build: function(element)
    {
        this.parse(element);
    },
    getData: function()
    {
        var data = {};
        this.find('[name]').each(function(node)
        {
            var $node = $R.dom(node);
            data[$node.attr('name')] = $node.val();
        });

        return data;
    },
    setData: function(data)
    {
        this.find('[name]').each(function(node)
        {
            var $node = $R.dom(node);
            var name = $node.attr('name');
            if (data.hasOwnProperty(name))
            {
                if (node.type && node.type === 'checkbox') node.checked = data[name];
                else $node.val(data[name]);
            }
        });
    },
    getField: function(name)
    {
        return this.find('[name=' + name + ']');
    },
    setError: function(name)
    {
        var $el = this.getField(name);

        $el.addClass('error');
        $el.one(this._getFieldEventName($el.get()), this._clearError);

        return false;
    },

    // private
    _clearError: function()
    {
        return $R.dom(this).removeClass('error');
    },
    _getFieldEventName: function(el)
    {
        return (el.tagName === 'SELECT' || el.type === 'checkbox' || el.type === 'radio') ? 'change' : 'keyup';
    }
});
$R.add('module', 'block', {
    init: function(app)
    {
        this.app = app;
        this.block = app.block;
    },
    // public
    format: function(args)
    {
        var nodes = this.block.format(args);

        // callback
        this.app.broadcast('format', 'block', nodes);
    },
    clearformat: function()
    {
        this.block.clearFormat();
    },
    clearstyle: function()
    {
        this.block.clearStyle();
    },
    clearclass: function()
    {
        this.block.clearClass();
    },
    clearattr: function()
    {
        this.block.clearAttr();
    },
    add: function(args, tags)
    {
        this.block.add(args, tags);
    },
    toggle: function(args, tags)
    {
        this.block.toggle(args, tags);
    },
    set: function(args, tags)
    {
        this.block.set(args, tags);
    },
    remove: function(args, tags)
    {
        this.block.remove(args, tags);
    }
});
$R.add('module', 'inline', {
    init: function(app)
    {
        this.app = app;
        this.inline = app.inline;
    },
    format: function(args)
    {
        var nodes = this.inline.format(args);

        // callback
        this.app.broadcast('format', 'inline', nodes);
    },
    clearformat: function()
    {
        this.inline.clearFormat();
    },
    clearstyle: function()
    {
        this.inline.clearStyle();
    },
    clearclass: function()
    {
        this.inline.clearClass();
    },
    clearattr: function()
    {
        this.inline.clearAttr();
    },
    add: function(args, tags)
    {
        this.inline.add(args, tags);
    },
    toggle: function(args, tags)
    {
        this.inline.toggle(args, tags);
    },
    set: function(args, tags)
    {
        this.inline.set(args, tags);
    },
    remove: function(args, tags)
    {
        this.inline.remove(args, tags);
    }
});
$R.add('module', 'autosave', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.utils = app.utils;
        this.source = app.source;
    },
    // messages
    onsynced: function()
    {
        if (this.opts.autosave)
        {
            this._send();
        }
    },

    // private
    _send: function()
    {
        var name = (this.opts.autosaveName) ? this.opts.autosaveName : this.source.getName();

        var data = {};
        data[name] = this.source.getCode();
        data = this.utils.extendData(data, this.opts.autosaveData);

        $R.ajax.post({
            url: this.opts.autosave,
            data: data,
            success: function(response)
            {
                this._complete(response, name, data);
            }.bind(this)
        });
    },
    _complete: function(response, name, data)
    {
        var callback = (response && response.error) ? 'autosaveError' : 'autosave';
        this.app.broadcast(callback, name, data, response);
    }
});
$R.add('module', 'input', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.utils = app.utils;
        this.editor = app.editor;
        this.keycodes = app.keycodes;
        this.element = app.element;
        this.selection = app.selection;
        this.insertion = app.insertion;
        this.inspector = app.inspector;
        this.autoparser = app.autoparser;

        // local
        this.lastShiftKey = false;
    },
    // messages
    onpaste: function(e, dataTransfer)
    {
        if (!this.opts.input) return;

        return $R.create('input.paste', this.app, e, dataTransfer);
    },
    onkeydown: function(e)
    {
        if (!this.opts.input) return;

        // key
        var key = e.which;

        // shortcuts
        var shortcut = $R.create('input.shortcut', this.app, e);
        if (shortcut.is()) return;

        // select all
        if ((e.ctrlKey || e.metaKey) && !e.altKey && key === 65)
        {
            e.preventDefault();
            return this._selectAll();
        }

        // set empty if all selected
        var keys = [this.keycodes.ENTER, this.keycodes.SPACE, this.keycodes.BACKSPACE, this.keycodes.DELETE];
        var arrowKeys = [this.keycodes.UP, this.keycodes.DOWN, this.keycodes.LEFT, this.keycodes.RIGHT];
        var isKeys = (keys.indexOf(key) !== -1);
        var isArrowKeys = (arrowKeys.indexOf(key) !== -1);
        var isXKey = ((e.ctrlKey || e.metaKey) && key === 88); // x
        var isAlphaKeys = ((!e.ctrlKey && !e.metaKey) && ((key >= 48 && key <= 57) || (key >= 65 && key <= 90)));

        if (this.selection.isAll() && isArrowKeys && (isXKey || (!e.ctrlKey && !e.metaKey && !e.altKey && !e.shiftKey)))
        {
            if (isXKey)
            {
                this.editor.disableNonEditables();
                this.app.broadcast('empty');
                return;
            }

            if (this._isArrowKey(key)) return true;
            if (isKeys) e.preventDefault();

            if (this.element.isType('inline'))
            {
                var $editor = this.editor.getElement();
                $editor.html('');

                this.editor.startFocus();
            }
            else
            {
                this.insertion.set(this.opts.emptyHtml);
            }

            if (isKeys) return;
            else this.app.broadcast('empty');
        }

        // autoparse
        if (this.opts.autoparse)
        {
            this.autoparser.format(e, key);
        }

        // a-z, 0-9 - non editable
        if (isAlphaKeys)
        {
            // has non-editable
            if (this.selection.hasNonEditable())
            {
                e.preventDefault();
                return;
            }
        }

        // enter, shift/ctrl + enter
        if (key === this.keycodes.ENTER)
        {
            return $R.create('input.enter', this.app, e, key);
        }
        // cmd + [
        else if (e.metaKey && key === 219)
        {
            e.preventDefault();
            this.app.api('module.list.outdent');
            return;
        }
        // tab or cmd + ]
        else if (key === this.keycodes.TAB || e.metaKey && key === 221)
        {
            return $R.create('input.tab', this.app, e, key);
        }
        // space
        else if (key === this.keycodes.SPACE)
        {
            return $R.create('input.space', this.app, e, key, this.lastShiftKey);
        }
        // backspace or delete
        else if (this._isDeleteKey(key))
        {
            return $R.create('input.delete', this.app, e, key);
        }
        else if (this._isArrowKey(key))
        {
            return $R.create('input.arrow', this.app, e, key);
        }
    },
    onkeyup: function(e)
    {
        if (!this.opts.input) return;

        // key
        var key = e.which;

        // shift key
        this.lastShiftKey = e.shiftKey;

        // hide context toolbar
        this.app.broadcast('contextbar.close');

        // shortcode
        var shortcode = $R.create('input.shortcode', this.app, e, key);
        if (shortcode.is()) return;

        // is empty
        if (key === this.keycodes.BACKSPACE)
        {
            var $editor = this.editor.getElement();
            var html = this.utils.trimSpaces($editor.html());
            html = html.replace(/<br\s?\/?>/g, '');
            html = html.replace(/<div><\/div>/, '');

            if (html === '')
            {
                e.preventDefault();
                this.editor.setEmpty();
                this.editor.startFocus();
                return;
            }
        }

        if (this.editor.isEmpty())
        {
            this.app.broadcast('empty');
        }
    },

    // public
    start: function()
    {
        // extend shortcuts
        if (this.opts.shortcutsAdd)
        {
            this.opts.shortcuts = $R.extend({}, true, this.opts.shortcuts, this.opts.shortcutsAdd);
        }
    },

    // private
    _selectAll: function()
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var el;

        if (data.isComponentType('table'))
        {
            el = data.getTable();
            this.selection.setAll(el);
            return;
        }
        else if (data.isComponentType('code'))
        {
            el = data.getComponentCodeElement();
            this.selection.setAll(el);
            return;
        }

        this.selection.setAll();
    },
    _isArrowKey: function(key)
    {
        return ([this.keycodes.UP, this.keycodes.DOWN, this.keycodes.RIGHT, this.keycodes.LEFT].indexOf(key) !== -1);
    },
    _isDeleteKey: function(key)
    {
        return (key === this.keycodes.BACKSPACE || key === this.keycodes.DELETE);
    }
});
$R.add('class', 'input.arrow', {
    init: function(app, e, key)
    {
        this.app = app;
        this.opts = app.opts;
        this.utils = app.utils;
        this.caret = app.caret;
        this.offset = app.offset;
        this.marker = app.marker;
        this.editor = app.editor;
        this.keycodes = app.keycodes;
        this.component = app.component;
        this.inspector = app.inspector;
        this.selection = app.selection;

        // local
        this.key = key;

        // init
        this._init(e);
    },
    // private
    _init: function(e)
    {
        if (this._isRightLeftKey() && this._isExitVariable(e)) return;

        if (this._isRightDownKey())
        {
            if (this._isExitOnDownRight(e)) return;
            if (this._selectComponent(e, 'End', 'next')) return;
        }

        if (this._isLeftUpKey())
        {
            if (this._isExitOnUpLeft(e)) return;
            if (this._selectComponent(e, 'Start', 'prev')) return;
        }

        if (this.key === this.keycodes.LEFT) this.utils.trimInvisibleChars('left');
        else if (this.key === this.keycodes.RIGHT) this.utils.trimInvisibleChars('right');

    },
    _isRightDownKey: function()
    {
        return ([this.keycodes.DOWN, this.keycodes.RIGHT].indexOf(this.key) !== -1);
    },
    _isLeftUpKey: function()
    {
        return ([this.keycodes.UP, this.keycodes.LEFT].indexOf(this.key) !== -1);
    },
    _isRightLeftKey: function()
    {
        return ([this.keycodes.RIGHT, this.keycodes.LEFT].indexOf(this.key) !== -1);
    },
    _isExitVariable: function(e)
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var component = data.getComponent();
        if (data.isComponentType('variable') && data.isComponentActive())
        {
            e.preventDefault();
            var func = (this.key === this.keycodes.LEFT) ? 'setBefore' : 'setAfter';
            this.caret[func](component);
            return;
        }
    },
    _isExitOnUpLeft: function(e)
    {
        var current = this.selection.getCurrent();
        var block = this.selection.getBlock(current);
        var data = this.inspector.parse(current);
        var prev = block.previousElementSibling;
        var isStart = this.caret.isStart(block);

        // prev table
        if (isStart && prev && prev.tagName === 'TABLE')
        {
            e.preventDefault();
            this.caret.setEnd(prev);
            return true;
        }
        // figcaption
        else if (data.isFigcaption())
        {
            block = data.getFigcaption();
            isStart = this.caret.isStart(block);

            var $component = $R.dom(block).closest('.redactor-component');
            if (isStart && $component.length !== 0)
            {
                e.preventDefault();
                this.caret.setEnd($component);
                return true;
            }
        }
        // exit table
        else if (data.isTable() && isStart)
        {
            e.preventDefault();
            this.caret.setEnd(block.previousElementSibling);
            return true;
        }
        // component
        else if (!data.isComponentEditable() && data.isComponent() && !data.isComponentType('variable'))
        {
            var component = data.getComponent();
            if (!component.previousElementSibling)
            {
                e.preventDefault();
                this.component.clearActive();

                if (data.isInline()) this.caret.setBefore(component);
                else this._exitPrevElement(e, data.getComponent());

                return true;
            }
            else if (component.previousElementSibling)
            {
                e.preventDefault();
                this.component.clearActive();

                if (data.isInline()) this.caret.setBefore(component);
                else this.caret.setEnd(component.previousElementSibling);

                return true;
            }
        }
    },
    _isExitOnDownRight: function(e)
    {
        var $editor = this.editor.getElement();
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var isEndEditor = this.caret.isEnd();
        var block, isEnd;

        // table
        if (data.isTable())
        {
            if (isEnd || isEndEditor)
            {
                return this._exitNextElement(e, data.getComponent());
            }
        }
        // figcaption
        else if (data.isFigcaption())
        {
            block = data.getFigcaption();
            isEnd = this.caret.isEnd(block);

            if (isEnd || isEndEditor)
            {
                return this._exitNextElement(e, data.getComponent());
            }
        }
        // figure/code
        else if (data.isComponentType('code'))
        {
            var component = data.getComponent();
            var pre = $R.dom(data.getComponentCodeElement()).closest('pre');

            isEnd = this.caret.isEnd(block);

            var isNext = (pre && pre.get().nextElementSibling);
            if (isEnd && !isNext)
            {
                return this._exitNextElement(e, component);
            }
        }
        // pre & blockquote & dl
        else if (data.isPre() || data.isBlockquote() || data.isDl())
        {
            if (isEndEditor)
            {
                if (data.isPre()) return this._exitNextElement(e, data.getPre());
                else if (data.isBlockquote()) return this._exitNextElement(e, data.getBlockquote());
                else if (data.isDl()) return this._exitNextElement(e, data.getDl());
            }
        }
        // li
        else if (data.isList())
        {
            var $list = $R.dom(current).parents('ul, ol', $editor).last();
            isEnd = this.caret.isEnd($list);

            if (isEnd || isEndEditor)
            {
                return this._exitNextElement(e, $list.get());
            }
        }
        // component
        else if (data.isComponent() && !data.isComponentType('variable') && data.getTag() !== 'span')
        {
            this.component.clearActive();

            if (data.isInline()) return this.caret.setEnd(data.getComponent());

            return this._exitNextElement(e, data.getComponent());
        }
    },
    _exitPrevElement: function(e, node)
    {
        e.preventDefault();

        if (node.previousElementSibling) this.caret.setEnd(node.previousElementSibling);
        else this.utils.createMarkupBefore(node);

        return true;
    },
    _exitNextElement: function(e, node)
    {
        e.preventDefault();

        if (node.nextElementSibling) this.caret.setStart(node.nextElementSibling);
        else this.utils.createMarkup(node);

        return true;
    },
    _selectComponent: function(e, caret, type)
    {
        var current = this.selection.getCurrent();
        var block = this.selection.getBlock(current);
        var sibling = this.utils.findSiblings(current, type);
        var siblingBlock = this.utils.findSiblings(block, type);

        if (sibling && this.caret['is' + caret](current))
        {
            this._selectComponentItem(e, sibling, caret);
        }
        else if (siblingBlock && this.caret['is' + caret](block))
        {
            this._selectComponentItem(e, siblingBlock, caret);
        }
    },
    _selectComponentItem: function(e, item, caret)
    {
        if (this.component.isNonEditable(item))
        {
            e.preventDefault();
            this.caret['set' + caret](item);
            return true;
        }
    }
});
$R.add('class', 'input.delete', {
    init: function(app, e, key)
    {
        this.app = app;
        this.opts = app.opts;
        this.caret = app.caret;
        this.utils = app.utils;
        this.editor = app.editor;
        this.marker = app.marker;
        this.keycodes = app.keycodes;
        this.component = app.component;
        this.inspector = app.inspector;
        this.selection = app.selection;
        this.insertion = app.insertion;

        // local
        this.key = key;

        // init
        this._init(e);
    },
    // private
    _init: function(e)
    {
        if (this._removeActiveComponent(e)) return;
        if (this._removeAllSelectedTable(e)) return;

        // is empty
        if (this.key === this.keycodes.BACKSPACE)
        {
            var $editor = this.editor.getElement();
            var html = this.utils.trimSpaces($editor.html());

            if (html === this.opts.emptyHtml)
            {
                e.preventDefault();
                return;
            }
        }

        // variable or non editable prev/next or selection
        if (this._detectVariableOrNonEditable() || this.selection.hasNonEditable())
        {
            e.preventDefault();
            return;
        }

        // all selected
        if (this.selection.isAll())
        {
            e.preventDefault();
            this.insertion.set(this.opts.emptyHtml);
            return;
        }

        // collapsed
        if (this.selection.isCollapsed())
        {
            // next / prev
            if (this.key === this.keycodes.BACKSPACE) this._traverseBackspace(e);
            else if (this.key === this.keycodes.DELETE) this._traverseDelete(e);
        }

        if (this.key === this.keycodes.BACKSPACE) this.utils.trimInvisibleChars('left');

        this._removeUnwantedStyles();
        this._removeEmptySpans();
        this._removeSpanTagsInHeadings();
        this._removeInlineTagsInPre();
    },
    _detectVariableOrNonEditable: function()
    {
        var block = this.selection.getBlock();
        var isBlockStart = this.caret.isStart(block);
        var isBlockEnd = this.caret.isEnd(block);
        var el;

        // backspace
        if (this.key === this.keycodes.BACKSPACE && isBlockStart)
        {
            el = block.previousSibling;
            if (this._isNonEditable(el)) return true;
        }
        // delete
        else if (this.key === this.keycodes.DELETE && isBlockEnd)
        {
            el = block.nextSibling;
            if (this._isNonEditable(el)) return true;
        }

        var current = this.selection.getCurrent();
        var isCurrentStart = this.caret.isStart(current);
        var isCurrentEnd = this.caret.isEnd(current);
        var isCurrentStartSpace = (this.selection.getTextBeforeCaret().trim() === '');
        var isCurrentEndSpace = (this.selection.getTextAfterCaret().trim() === '');

        // backspace
        if (this.key === this.keycodes.BACKSPACE && isCurrentStart && !isCurrentStartSpace)
        {
            el = current.previousSibling;
            if (this._isVariable(el))
            {
                this.caret.setEnd(el);
                return true;
            }
            else if (this._isNonEditable(el)) return true;
        }
        // delete
        else if (this.key === this.keycodes.DELETE && isCurrentEnd && !isCurrentEndSpace)
        {
            el = current.nextSibling;
            if (this._isVariable(el))
            {
                this.caret.setStart(el);
                return true;
            }
            else if (this._isNonEditable(el)) return true;
        }
    },
    _isVariable: function(node)
    {
        return ($R.dom(node).closest('[data-redactor-type="variable"]').length !== 0);
    },
    _isNonEditable: function(node)
    {
        return ($R.dom(node).closest('.non-editable').length !== 0);
    },
    _getBlock: function()
    {
        var $editor = this.editor.getElement();
        var block = this.selection.getBlock();
        var data = this.inspector.parse(block);

        block = (data.isList()) ? $R.dom(block).parents('ul, ol', $editor).last().get() : block;
        block = (data.isDl()) ? data.getDl() : block;
        block = (data.isTable()) ? data.getTable() : block;

        return block;
    },
    _traverseDelete: function(e)
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var block, isEnd, $next;

        // figcaption
        if (data.isFigcaption())
        {
            block = data.getFigcaption();
            isEnd = this.caret.isEnd(block);

            if (isEnd)
            {
                e.preventDefault();
                return;
            }
        }
        // figure/code
        else if (data.isComponentType('code'))
        {
            block = data.getComponent();
            isEnd = this.caret.isEnd(block);

            if (isEnd)
            {
                e.preventDefault();
                return;
            }
        }

        // next
        block = this._getBlock();
        var next = this.utils.findSiblings(block, 'next');
        if (!next) return;

        isEnd = this.caret.isEnd(block);
        var dataNext = this.inspector.parse(next);
        var isNextBlock = (next.tagName === 'P' || next.tagName === 'DIV');

        // figure/code or table
        if (isEnd && dataNext.isComponentEditable())
        {
            e.preventDefault();
            this.component.remove(next, false);
            return;
        }
        // component
        else if (isEnd && dataNext.isComponent())
        {
            e.preventDefault();

            // select component
            this.caret.setStart(next);

            // remove current if empty
            if (this.utils.isEmptyHtml(block.innerHTML))
            {
                $R.dom(block).remove();
            }

            return;
        }
        // combine list
        else if (isEnd && dataNext.isList())
        {
            var $currentList = $R.dom(block);
            $next = $R.dom(next);

            // current list
            if (data.isList())
            {
                e.preventDefault();

                $currentList.append($next);
                $next.unwrap();

                return;
            }
            else
            {
                var $first = $next.children('li').first();
                var $lists = $first.find('ul, ol');

                if ($lists.length !== 0)
                {
                    e.preventDefault();

                    $next.prepend($lists);
                    $lists.unwrap();

                    $currentList.append($first);
                    $first.unwrap();

                    return;
                }
            }
        }
        // block
        else if (isEnd && !data.isList() && !data.isTable() && isNextBlock && !this.utils.isEmptyHtml(block.innerHTML))
        {
            e.preventDefault();

            var $current = $R.dom(block);
            $next = $R.dom(next);

            $current.append($next);
            $next.unwrap();

            return;
        }
    },
    _traverseBackspace: function(e)
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var block, isStart, $prev, $currentList;

        // figcaption
        if (data.isFigcaption())
        {
            block = data.getFigcaption();
            isStart = this.caret.isStart(block);

            if (isStart)
            {
                e.preventDefault();
                return;
            }
        }
        // figure/code
        else if (data.isComponentType('code'))
        {
            block = data.getComponent();
            isStart = this.caret.isStart(block);

            if (isStart && block.previousElementSibling)
            {
                e.preventDefault();
                this.caret.setEnd(block.previousElementSibling);
                return true;
            }
        }

        // prev
        block = this._getBlock();
        var prev = this.utils.findSiblings(block, 'prev');

        if (!prev)
        {
            setTimeout(this._replaceBlock.bind(this), 1);
            return;
        }

        isStart = this.caret.isStart(block);
        var dataPrev = this.inspector.parse(prev);
        var isPrevBlock = (prev.tagName === 'P' || prev.tagName === 'DIV');

        // figure/code or table
        if (isStart && dataPrev.isComponentEditable())
        {
            e.preventDefault();
            this.component.remove(prev, false);
            return;
        }
        // component
        else if (isStart && dataPrev.isComponent())
        {
            e.preventDefault();

            // select component
            this.caret.setStart(prev);

            // remove current if empty
            if (this.utils.isEmptyHtml(block.innerHTML))
            {
                $R.dom(block).remove();
            }

            return;
        }
        // lists
        else if (isStart && data.isList())
        {
            e.preventDefault();

            $currentList = $R.dom(block);
            $prev = $R.dom(prev);

            if (dataPrev.isList())
            {
                $currentList.children('li').first().prepend(this.marker.build('start'));
                $prev.append($currentList);
                $currentList.unwrap();

                this.selection.restoreMarkers();
            }
            else
            {
                var $first = $currentList.children('li').first();
                var first = $first.get();
                var $lists = $first.find('ul, ol');

                var $newnode = this.utils.replaceToTag(first, this.opts.markup);
                if (this.opts.breakline) $newnode.attr('data-redactor-tag', 'br');
                $currentList.before($newnode);
                this.caret.setStart($newnode);

                if ($lists.length !== 0)
                {
                    $currentList.prepend($lists);
                    $lists.unwrap();
                }
            }

            return;
        }
        // block
        else if (isStart && isPrevBlock)
        {
            e.preventDefault();

            if (this.utils.isEmpty(prev)) {
                $prev = $R.dom(prev);
                $prev.remove();
                return;
            }

            var textNode = this.utils.createInvisibleChar();
            var $current = $R.dom(block);
            $prev = $R.dom(prev);

            this.caret.setEnd($prev);

            $current.prepend(textNode);
            $prev.append($current.contents());
            $current.remove();

            return;
        }
    },
    _replaceBlock: function()
    {
        var block = this.selection.getBlock();
        var $block = $R.dom(block);

        if (this.opts.markup === 'p' && block && this._isNeedToReplaceBlock(block))
        {
            var markup = document.createElement(this.opts.markup);

            $block.replaceWith(markup);
            this.caret.setStart(markup);
        }

        if (this.opts.breakline && block && block.tagName === 'DIV')
        {
            $block.attr('data-redactor-tag', 'br');
        }
    },
    _isNeedToReplaceBlock: function(block)
    {
        return (block.tagName === 'DIV' && this.utils.isEmptyHtml(block.innerHTML));
    },
    _removeActiveComponent: function(e)
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var component = data.getComponent();
        if (data.isComponent() && this.component.isActive(component))
        {
            e.preventDefault();
            this.component.remove(component);
            return true;
        }
    },
    _removeAllSelectedTable: function(e)
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var table = data.getTable();
        if (table && this.selection.isAll(table))
        {
            e.preventDefault();
            this.component.remove(table);
            return true;
        }
    },
    _removeUnwantedStyles: function()
    {
        var $editor = this.editor.getElement();

        setTimeout(function()
        {
            var $tags = $editor.find('*[style]');
            $tags.not('img, figure, iframe, [data-redactor-style-cache], [data-redactor-span]').removeAttr('style');

        }, 0);
    },
    _removeEmptySpans: function()
    {
        var $editor = this.editor.getElement();

        setTimeout(function()
        {
            $editor.find('span').each(function(node)
            {
                if (node.attributes.length === 0)
                {
                    $R.dom(node).replaceWith(node.childNodes);
                }
            });

        }, 0);
    },
    _removeSpanTagsInHeadings: function()
    {
        var $editor = this.editor.getElement();

        setTimeout(function()
        {
            $editor.find('h1, h2, h3, h4, h5, h6').each(function(node)
            {
                var $node = $R.dom(node);
                if ($node.closest('figure').length === 0)
                {
                    $node.find('span').not('.redactor-component, .non-editable, .redactor-selection-marker, [data-redactor-style-cache], [data-redactor-span]').unwrap();
                }
            });

        }, 1);
    },
    _removeInlineTagsInPre: function()
    {
        var $editor = this.editor.getElement();
        var tags = this.opts.inlineTags;

        setTimeout(function()
        {
            $editor.find('pre').each(function(node)
            {
                var $node = $R.dom(node);
                if ($node.closest('figure').length === 0)
                {
                    $node.find(tags.join(',')).not('code, .redactor-selection-marker').unwrap();
                }
            });

        }, 1);
    }
});
$R.add('class', 'input.enter', {
    init: function(app, e)
    {
        this.app = app;
        this.opts = app.opts;
        this.utils = app.utils;
        this.caret = app.caret;
        this.editor = app.editor;
        this.insertion = app.insertion;
        this.selection = app.selection;
        this.inspector = app.inspector;

        // init
        this._init(e);
    },
    // private
    _init: function(e)
    {
        // turn off
        if (!this.opts.enterKey) return this._disable(e);

        // callback
        var stop = this.app.broadcast('enter', e);
        if (stop === false) return e.preventDefault();

        // has non-editable
        if (this.selection.hasNonEditable())
        {
            e.preventDefault();
            return;
        }

        // shift enter
        if (e.ctrlKey || e.shiftKey) return this._insertBreak(e);

        // enter & exit
        if (this._isExit(e)) return;

        // traverse
        this._traverse(e);
    },
    _disable: function(e)
    {
        e.preventDefault();
        var range = this.selection.getRange();
        if (range && !range.collapsed) range.deleteContents();
    },
    _insertBreak: function(e)
    {
        e.preventDefault();

        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);

        if ((data.isComponent() && !data.isComponentEditable()) || data.isCode()) return;
        else if (data.isPre()) this.insertion.insertNewline();
        else this.insertion.insertBreakLine();
    },
    _isExit: function(e)
    {
        var $editor = this.editor.getElement();
        var block = this.selection.getBlock();
        var data = this.inspector.parse(block);
        var isEnd = this.caret.isEnd(block);
        var current = this.selection.getCurrent();
        var prev = current.previousSibling;

        // blockquote
        if (data.isBlockquote())
        {
            var isParagraphExit = (isEnd && this._isExitableBlock(block, 'P'));
            var isBreaklineExit = (isEnd && this._isExitableDblBreak(prev));

            if (isParagraphExit || isBreaklineExit)
            {
                return this._exitFromElement(e, ((isBreaklineExit) ? prev : block), data.getBlockquote());
            }
        }
        // pre
        else if (!data.isComponentType('code') && data.isPre())
        {
            if (isEnd)
            {
                var html = block.innerHTML;
                html = this.utils.removeInvisibleChars(html);
                if (html.match(/(\n\n\n)$/) !== null)
                {
                    $R.dom(prev.previousSibling.previousSibling).remove();
                    return this._exitFromElement(e, prev, block);
                }
            }
        }
        // dl
        else if (data.isDl())
        {
            if (isEnd && this._isExitableBlock(block, 'DT'))
            {
                return this._exitFromElement(e, block, data.getDl());
            }
        }
        // li
        else if (data.isList())
        {
            var list = $R.dom(current).parents('ul, ol', $editor).last();

            isEnd = this.caret.isEnd(list);
            if (isEnd && this._isExitableBlock(block, 'LI'))
            {
                return this._exitFromElement(e, block, list);
            }
        }
        else if (data.isComponent() && data.isComponentActive() && !data.isFigcaption() && !data.isComponentEditable())
        {
            return this._exitFromElement(e, false, data.getComponent());
        }
    },
    _isExitableDblBreak: function(prev)
    {
        var next = (prev) ? prev.nextSibling : false;
        if (next)
        {
            var text = this.utils.removeInvisibleChars(next.textContent);

            return (next.nodeType === 3 && text.trim() === '');
        }
    },
    _isExitableBlock: function(block, tag)
    {
        return (block && block.tagName === tag && this.utils.isEmptyHtml(block.innerHTML));
    },
    _exitFromElement: function(e, prev, el)
    {
        e.preventDefault();
        if (prev) $R.dom(prev).remove();
        this.utils.createMarkup(el);

        return true;
    },
    _exitNextElement: function(e, node)
    {
        e.preventDefault();

        if (node.nextSibling) this.caret.setStart(node.nextSibling);
        else this.utils.createMarkup(node);

        return true;
    },
    _traverse: function(e)
    {
        var current = this.selection.getCurrent();
        var isText = this.selection.isText();
        var block = this.selection.getBlock();
        var data = this.inspector.parse(current);
        var blockTag = (block) ? block.tagName.toLowerCase() : false;
        var $variable = $R.dom(current).closest('[data-redactor-type=variable]');
        // variable parent
        if ($variable.length !== 0) {
            this.caret.setAfter($variable);
        }

        // pre
        if (data.isPre())
        {
            e.preventDefault();
            return this.insertion.insertNewline();
        }
        // blockquote
        else if (data.isBlockquote())
        {
            block = this.selection.getBlock(current);
            if (block && block.tagName === 'BLOCKQUOTE')
            {
                e.preventDefault();
                return this.insertion.insertBreakLine();
            }
        }
        // figcaption
        else if (data.isFigcaption())
        {
            block = data.getFigcaption();
            var isEnd = this.caret.isEnd(block);
            var isEndEditor = this.caret.isEnd();
            if (isEnd || isEndEditor)
            {
                return this._exitNextElement(e, data.getComponent());
            }
            else
            {
                e.preventDefault();
                return;
            }
        }
        // dl
        else if (data.isDl())
        {
            e.preventDefault();
            return this._traverseDl(current);
        }
        // breakline
        else if (this.opts.breakline && blockTag === 'div') {
            setTimeout(this._replaceBlock.bind(this), 1);
            return;
        }
        // text
        else if (isText)
        {
            e.preventDefault();
            return this.insertion.insertBreakLine();
        }
        // div / p
        else
        {
            setTimeout(this._replaceBlock.bind(this), 1);
            return;
        }
    },
    _traverseDl: function(current)
    {
        var block = this.selection.getBlock(current);
        var data = this.inspector.parse(block);
        var tag = data.getTag();
        var $el = $R.dom(block);
        var next = $el.get().nextSibling || false;
        var $next = $R.dom(next);
        var nextDd = (next && $next.is('dd'));
        var nextDt = (next && $next.is('dt'));
        var isEnd = this.caret.isEnd(block);

        if (tag === 'dt' && !nextDd && isEnd)
        {
            var dd = document.createElement('dd');
            $el.after(dd);

            this.caret.setStart(dd);
            return;
        }
        else if (tag === 'dd' && !nextDt && isEnd)
        {
            var dt = document.createElement('dt');
            $el.after(dt);

            this.caret.setStart(dt);
            return;
        }

        return this.insertion.insertBreakLine();
    },
    _replaceBlock: function()
    {
        var block = this.selection.getBlock();
        var $block = $R.dom(block);

        if (this.opts.markup === 'p' && block && this._isNeedToReplaceBlock(block))
        {
            var markup = document.createElement(this.opts.markup);

            $block.replaceWith(markup);
            this.caret.setStart(markup);
        }
        else
        {
            if (block)
            {
                if (this.utils.isEmptyHtml(block.innerHTML))
                {
                    this._clearBlock($block, block);
                }
                else
                {
                    var first = this.utils.getFirstNode(block);
                    if (first && first.tagName === 'BR')
                    {
                        $R.dom(first).remove();
                        this.caret.setStart(block);
                    }
                }
            }
        }

        if (block && this._isNeedToCleanBlockStyle(block) && this.opts.cleanOnEnter)
        {
            $block.removeAttr('class style');
        }

        if (this.opts.breakline && block && block.tagName === 'DIV')
        {
            $block.attr('data-redactor-tag', 'br');
        }
    },
    _clearBlock: function($block, block)
    {
        if (this.opts.cleanInlineOnEnter || block.innerHTML === '<br>')
        {
            $block.html('');
        }

        this.caret.setStart(block);
    },
    _isNeedToReplaceBlock: function(block)
    {
        return (block.tagName === 'DIV' && this.utils.isEmptyHtml(block.innerHTML));
    },
    _isNeedToCleanBlockStyle: function(block)
    {
        return (block.tagName === 'P' && this.utils.isEmptyHtml(block.innerHTML));
    }
});
$R.add('class', 'input.paste', {
    init: function(app, e, dataTransfer, html, point)
    {
        this.app = app;
        this.opts = app.opts;
        this.editor = app.editor;
        this.cleaner = app.cleaner;
        this.container = app.container;
        this.inspector = app.inspector;
        this.insertion = app.insertion;
        this.selection = app.selection;
        this.autoparser = app.autoparser;

        // local
        this.pasteHtml = html;
        this.pointInserted = point;
        this.dataTransfer = dataTransfer;

        // init
        this._init(e);
    },
    // private
    _init: function(e)
    {
        var clipboard = this.dataTransfer || e.clipboardData;
        var current = this.selection.getCurrent();
        var dataCurrent = this.inspector.parse(current);

        this.dropPasted = this.dataTransfer;
        this.isRawCode = (dataCurrent.isPre() || dataCurrent.isCode());

        this.editor.enablePasting();
        this.editor.saveScroll();

        if (!this.dropPasted)
        {
            this.selection.saveMarkers();
        }

        if (this.isRawCode || !clipboard)
        {
            var text;
            if (!this.isRawCode && !clipboard && window.clipboardData)
            {
                text = window.clipboardData.getData("text");
            }
            else
            {
                text = clipboard.getData("text/plain");
            }

            e.preventDefault();
            this._insert(e, text);
            return;
        }
        else if (this.pasteHtml)
        {
            e.preventDefault();
            this._insert(e, this.pasteHtml);
        }
        else
        {
            // html / text
            var url = clipboard.getData('URL');
            var html = (this._isPlainText(clipboard)) ? clipboard.getData("text/plain") : clipboard.getData("text/html");

            // safari anchor links
            html = (!url || url === '') ? html : url;

            // file
            if (clipboard.files !== null && clipboard.files.length > 0 && html === '')
            {
                var files = [];
                for (var i = 0; i < clipboard.files.length; i++)
                {
                    var file = clipboard.files[i] || clipboard.items[i].getAsFile();
                    if (file) files.push(file);
                }

                if (files.length > 0)
                {
                    e.preventDefault();
                    this._insertFiles(e, files);
                    return;
                }
            }


            e.preventDefault();
            this._insert(e, html);
        }
    },
    _isPlainText: function(clipboard)
    {
        var text = clipboard.getData("text/plain");
        var html = clipboard.getData("text/html");

        if (text && html)
        {
            var element = document.createElement("div");
            element.innerHTML = html;

            if (element.textContent === text)
            {
                return !element.querySelector(":not(meta)");
            }
        }
        else
        {
            return (text !== null);
        }
    },
    _restoreSelection: function()
    {
        this.editor.restoreScroll();
        this.editor.disablePasting();
        if (!this.dropPasted)
        {
            this.selection.restoreMarkers();
        }
    },
    _insert: function(e, html)
    {
        // pasteBefore callback
        var returned = this.app.broadcast('pasteBefore', html);
        html = (returned === undefined) ? html : returned;

        // clean
        html = html.trim();
        html = (this.isRawCode) ? html : this.cleaner.paste(html);
        html = html.trim();
        html = (this.isRawCode) ? this.cleaner.encodePhpCode(html) : html;

        // paste callback
        returned = this.app.broadcast('pasting', html);
        html = (returned === undefined) ? html : returned;

        this._restoreSelection();

        // stop input
        if (!this.opts.input) return;

        var nodes = [];
        if (this.isRawCode) {
            var textNode = document.createTextNode(html)
            nodes = this.insertion.insertNode(textNode, 'after');

            this.app.broadcast('pasted', nodes);
        }
        else {

            // autoparse
            if (this.opts.autoparse && this.opts.autoparsePaste)
            {
                html = this.autoparser.parse(html);
            }

            nodes = (this.dropPasted) ? this.insertion.insertToPoint(e, html, this.pointInserted) : this.insertion.insertHtml(html);

            // pasted callback
            this.app.broadcast('pasted', nodes);
            this.app.broadcast('autoparseobserve');
        }
    },
    _insertFiles: function(e, files)
    {
        this._restoreSelection();

        // drop or clipboard
        var isImage = (this.opts.imageTypes.indexOf(files[0].type) !== -1);
        var isClipboard = (typeof this.dropPasted === 'undefined');

        if (isImage) this.app.broadcast('dropimage', e, files, isClipboard);
        else this.app.broadcast('dropfile', e, files, isClipboard);
    }
});
$R.add('class', 'input.shortcode', {
    init: function(app, e, key)
    {
        this.app = app;
        this.opts = app.opts;
        this.utils = app.utils;
        this.marker = app.marker;
        this.keycodes = app.keycodes;
        this.selection = app.selection;

        // local
        this.worked = false;

        // init
        if (key === this.keycodes.SPACE) this._init();
    },
    // public
    is: function()
    {
        return this.worked;
    },
    // private
    _init: function()
    {
        var current = this.selection.getCurrent();
        if (current && current.nodeType === 3)
        {
            var text = this.utils.removeInvisibleChars(current.textContent);
            var shortcodes = this.opts.shortcodes;
            for (var name in shortcodes)
            {
                var re = new RegExp('^' + this.utils.escapeRegExp(name));
                var match = text.match(re);
                if (match !== null)
                {
                    if (typeof shortcodes[name].format !== 'undefined')
                    {
                        return this._format(shortcodes[name].format, current, re);
                    }
                }
            }
        }
    },
    _format: function(tag, current, re)
    {
        var marker = this.marker.insert('start');
        current = marker.previousSibling;

        var text = current.textContent;
        text = this.utils.trimSpaces(text);
        text = text.replace(re, '');
        current.textContent = text;

        var api = (tag === 'ul' || tag === 'ol') ? 'module.list.toggle' : 'module.block.format';

        this.app.api(api, tag);
        this.selection.restoreMarkers();

        this.worked = true;
    }
});
$R.add('class', 'input.shortcut', {
    init: function(app, e)
    {
        this.app = app;
        this.opts = app.opts;

        // local
        this.worked = false;

        // based on https://github.com/jeresig/jquery.hotkeys
        this.hotkeys = {
            8: "backspace", 9: "tab", 10: "return", 13: "return", 16: "shift", 17: "ctrl", 18: "alt", 19: "pause",
            20: "capslock", 27: "esc", 32: "space", 33: "pageup", 34: "pagedown", 35: "end", 36: "home",
            37: "left", 38: "up", 39: "right", 40: "down", 45: "insert", 46: "del", 59: ";", 61: "=",
            96: "0", 97: "1", 98: "2", 99: "3", 100: "4", 101: "5", 102: "6", 103: "7",
            104: "8", 105: "9", 106: "*", 107: "+", 109: "-", 110: ".", 111 : "/",
            112: "f1", 113: "f2", 114: "f3", 115: "f4", 116: "f5", 117: "f6", 118: "f7", 119: "f8",
            120: "f9", 121: "f10", 122: "f11", 123: "f12", 144: "numlock", 145: "scroll", 173: "-", 186: ";", 187: "=",
            188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\", 221: "]", 222: "'"
        };

        this.hotkeysShiftNums = {
            "`": "~", "1": "!", "2": "@", "3": "#", "4": "$", "5": "%", "6": "^", "7": "&",
            "8": "*", "9": "(", "0": ")", "-": "_", "=": "+", ";": ": ", "'": "\"", ",": "<",
            ".": ">",  "/": "?",  "\\": "|"
        };

        // init
        this._init(e);
    },
    // public
    is: function()
    {
        return this.worked;
    },
    // private
    _init: function(e)
    {
        // disable browser's hot keys for bold and italic if shortcuts off
        if (this.opts.shortcuts === false)
        {
            if ((e.ctrlKey || e.metaKey) && (e.which === 66 || e.which === 73)) e.preventDefault();
            return;
        }

        // build
        for (var key in this.opts.shortcuts)
        {
            this._build(e, key, this.opts.shortcuts[key]);
        }
    },
    _build: function(e, str, command)
    {
        var keys = str.split(',');
        var len = keys.length;
        for (var i = 0; i < len; i++)
        {
            if (typeof keys[i] === 'string')
            {
                this._handler(e, keys[i].trim(), command);
            }
        }
    },
    _handler: function(e, keys, command)
    {
        keys = keys.toLowerCase().split(" ");

        var special = this.hotkeys[e.keyCode];
        var character = String.fromCharCode(e.which).toLowerCase();
        var modif = "", possible = {};
        var cmdKeys = ["meta", "ctrl", "alt", "shift"];

        for (var i = 0; i < cmdKeys.length; i++)
        {
            var specialKey = cmdKeys[i];
            if (e[specialKey + 'Key'] && special !== specialKey)
            {
                modif += specialKey + '+';
            }
        }

        if (special) possible[modif + special] = true;
        if (character)
        {
            possible[modif + character] = true;
            possible[modif + this.hotkeysShiftNums[character]] = true;

            // "$" can be triggered as "Shift+4" or "Shift+$" or just "$"
            if (modif === "shift+")
            {
                possible[this.hotkeysShiftNums[character]] = true;
            }
        }

        var len = keys.length;
        for (var i = 0; i < len; i++)
        {
            if (possible[keys[i]])
            {

                e.preventDefault();
                this.worked = true;

                if (command.message)
                {
                    this.app.broadcast(command.message, command.args);
                    this.app.broadcast('buffer.trigger');
                }
                else if (command.api)
                {
                    this.app.api(command.api, command.args);
                    this.app.broadcast('buffer.trigger');
                }

                return;
            }
        }
    }
});
$R.add('class', 'input.space', {
    init: function(app, e, key, lastShiftKey)
    {
        this.app = app;
        this.keycodes = app.keycodes;
        this.insertion = app.insertion;
        this.selection = app.selection;

        // local
        this.key = key;
        this.lastShiftKey = lastShiftKey;

        // init
        this._init(e);
    },
    // private
    _init: function(e)
    {
        // has non-editable
        if (this.selection.hasNonEditable())
        {
            e.preventDefault();
            return;
        }

        // shift/ctrl + space
        if (!this.lastShiftKey && this.key === this.keycodes.SPACE && (e.ctrlKey || e.shiftKey) && !e.metaKey)
        {
            e.preventDefault();
            this.insertion.insertChar('&nbsp;');
            return;
        }
    }
});
$R.add('class', 'input.tab', {
    init: function(app, e)
    {
        this.app = app;
        this.opts = app.opts;
        this.inspector = app.inspector;
        this.insertion = app.insertion;
        this.selection = app.selection;

        // init
        this._init(e);
    },
    // private
    _init: function(e)
    {
        // turn off tab
        if (!this.opts.tabKey) return;

        // callback
        var stop = this.app.broadcast('tab', e);
        if (stop === false) return e.preventDefault();

        // traverse
        this._traverse(e);
    },
    _traverse: function(e)
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);

        // hard tab
        if (!data.isComponent() && e.shiftKey)
        {
            return this._insertHardTab(e, 4);
        }

        // list
        if (data.isList())
        {
            e.preventDefault();
            return this.app.api('module.list.indent');
        }
        // pre
        if (data.isPre() || (data.isComponentType('code') && !data.isFigcaption()))
        {
            return this._tabCode(e);
        }

        // tab as spaces
        if (this.opts.tabAsSpaces !== false)
        {
            return this._insertHardTab(e, this.opts.tabAsSpaces);
        }
    },
    _insertHardTab: function(e, num)
    {
        e.preventDefault();
        var node = document.createTextNode(Array(num + 1).join('\u00a0'));
        return this.insertion.insertNode(node, 'end');
    },
    _tabCode: function(e)
    {
        e.preventDefault();

        var node = (this.opts.preSpaces) ? document.createTextNode(Array(this.opts.preSpaces + 1).join('\u00a0')) : document.createTextNode('\t');

        return this.insertion.insertNode(node, 'end');
    }
});
$R.add('module', 'upload', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.lang = app.lang;
        this.utils = app.utils;
        this.editor = app.editor;
        this.progress = app.progress;

        // local
        this.defaults = {
            event: false,
            element: false,
            name: false,
            files: false,
            url: false,
            data: false,
            paramName: false
        };
    },
    // public
    build: function(options)
    {
        this.p = $R.extend(this.defaults, options);
        this.$el = $R.dom(this.p.element);

        if (this.$el.get().tagName === 'INPUT') this._buildInput();
        else                                    this._buildBox();
    },
    send: function(options)
    {
        this.p = $R.extend(this.defaults, options);
        this.$uploadbox = this.editor.getElement();
        this._send(this.p.event, this.p.files);
    },
    complete: function(response, e)
    {
        this._complete(response, e);
    },

    // private
    _buildInput: function()
    {
        this.box = false;
        this.prefix = '';

        this.$uploadbox = $R.dom('<div class="upload-redactor-box" />');

        this.$el.hide();
        this.$el.after(this.$uploadbox);

        if (this.opts.multipleUpload) this.$el.attr('multiple', 'multiple');
        else this.$el.removeAttr('multiple');

        if (this.p.name !== 'file')
        {
            this.$el.attr('accept', 'image/*');
        }

        this._buildPlaceholder();
        this._buildEvents();
    },
    _buildBox: function()
    {
        this.box = true;
        this.prefix = 'box-';

        this.$uploadbox = this.$el;
        this.$uploadbox.attr('ondragstart', 'return false;');

        // events
        this.$uploadbox.on('drop.redactor.upload', this._onDropBox.bind(this));
        this.$uploadbox.on('dragover.redactor.upload', this._onDragOver.bind(this));
        this.$uploadbox.on('dragleave.redactor.upload', this._onDragLeave.bind(this));
    },
    _buildPlaceholder: function()
    {
        this.$placeholder = $R.dom('<div class="upload-redactor-placeholder" />');
        this.$placeholder.html(this.lang.get('upload-label'));
        this.$uploadbox.append(this.$placeholder);
    },
    _buildEvents: function()
    {
        this.$el.on('change.redactor.upload', this._onChange.bind(this));
        this.$uploadbox.on('click.redactor.upload', this._onClick.bind(this));
        this.$uploadbox.on('drop.redactor.upload', this._onDrop.bind(this));
        this.$uploadbox.on('dragover.redactor.upload', this._onDragOver.bind(this));
        this.$uploadbox.on('dragleave.redactor.upload', this._onDragLeave.bind(this));
    },
    _onClick: function(e)
    {
        e.preventDefault();
        this.$el.click();
    },
    _onChange: function(e)
    {
        this._send(e, this.$el.get().files);
    },
    _onDrop: function(e)
    {
        e.preventDefault();

        this._clear();
        this._setStatusDrop();
        this._send(e);
    },
    _onDragOver: function(e)
    {
        e.preventDefault();
        this._setStatusHover();

        return false;
    },
    _onDragLeave: function(e)
    {
        e.preventDefault();
        this._removeStatusHover();

        return false;
    },
    _onDropBox: function(e)
    {
        e.preventDefault();

        this._clear();
        this._setStatusDrop();
        this._send(e);
    },
    _removeStatusHover: function()
    {
        this.$uploadbox.removeClass('upload-redactor-' + this.prefix + 'hover');
    },
    _setStatusDrop: function()
    {
        this.$uploadbox.addClass('upload-redactor-' + this.prefix + 'drop');
    },
    _setStatusHover: function()
    {
        this.$uploadbox.addClass('upload-redactor-' + this.prefix + 'hover');
    },
    _setStatusError: function()
    {
        this.$uploadbox.addClass('upload-redactor-' + this.prefix + 'error');
    },
    _setStatusSuccess: function()
    {
        this.$uploadbox.addClass('upload-redactor-' + this.prefix + 'success');
    },
    _clear: function()
    {
        var classes = ['drop', 'hover', 'error', 'success'];
        for (var i = 0; i < classes.length; i++)
        {
            this.$uploadbox.removeClass('upload-redactor-' + this.prefix + classes[i]);
        }

        this.$uploadbox.removeAttr('ondragstart');
    },
    _send: function(e, files)
    {
        e = e.originalEvent || e;

        files = (files) ? files : e.dataTransfer.files;

        var data = new FormData();
        var name = this._getUploadParam();

        data = this._buildData(name, files, data);
        data = this.utils.extendData(data, this.p.data);

        var stop = this.app.broadcast('upload.start', e, data, files);
        if (stop !== false)
        {
            this._sendData(data, files, e);
        }
    },
    _sendData: function(data, files, e)
    {
        this.progress.show();
        if (typeof this.p.url === 'function')
        {
            var res = this.p.url(data, files, e, this);
            if (!(res instanceof Promise))
            {
                this._complete(res, e);
            }
        }
        else
        {
            $R.ajax.post({
                url: this.p.url,
                data: data,
                before: function(xhr)
                {
                    return this.app.broadcast('upload.beforeSend', xhr);

                }.bind(this),
                success: function(response)
                {
                    this._complete(response, e);
                }.bind(this)
            });
        }
    },
    _getUploadParam: function()
    {
        return (this.p.paramName) ? this.p.paramName : 'file';
    },
    _buildData: function(name, files, data)
    {
        if (files.length === 1)
        {
            data.append(name + '[]', files[0]);
        }
        else if (files.length > 1 && this.opts.multipleUpload !== false)
        {
            for (var i = 0; i < files.length; i++)
            {
                data.append(name + '[]', files[i]);
            }
        }

        return data;
    },
    _complete: function(response, e)
    {
        this._clear();
        this.progress.hide();

        if (response && response.error)
        {
            this._setStatusError();

            this.app.broadcast('upload.' + this.p.name + '.error', response, e);
            this.app.broadcast('upload.error', response);
        }
        else
        {
            this._setStatusSuccess();

            this.app.broadcast('upload.' + this.p.name + '.complete', response, e);
            this.app.broadcast('upload.complete', response);

            setTimeout(this._clear.bind(this), 500);
        }
    }
});
$R.add('class', 'code.component', {
    mixins: ['dom', 'component'],
    init: function(app, el)
    {
        this.app = app;

        // init
        return (el && el.cmnt !== undefined) ? el : this._init(el);
    },

    // private
   _init: function(el)
    {
        var $pre;
        if (typeof el !== 'undefined')
        {
            var $node = $R.dom(el);
            var $wrapper = $node.closest('figure');
            if ($wrapper.length !== 0)
            {
                this.parse($wrapper);
            }
            else
            {
                this.parse('<figure>');
                this.append(el);
            }

            $pre = this.find('pre code, pre').last();
        }
        else
        {
            $pre = $R.dom('<pre>');

            this.parse('<figure>');
            this.append($pre);
        }

        this._initElement($pre);
        this._initWrapper();
    },
    _initElement: function($pre)
    {
        $pre.attr({
            'tabindex': '-1',
            'contenteditable': true
        });
    },
    _initWrapper: function()
    {
        this.addClass('redactor-component');
        this.attr({
            'data-redactor-type': 'code',
            'tabindex': '-1',
            'contenteditable': false
        });
    }
});
$R.add('module', 'form', {
    init: function(app)
    {
        this.app = app;
        this.lang = app.lang;
        this.component = app.component;
        this.inspector = app.inspector;
    },
    // messages
    onform: {
        remove: function(node)
        {
            this._remove(node);
        }
    },
    oncontextbar: function(e, contextbar)
    {
        var data = this.inspector.parse(e.target);
        if (data.isComponentType('form'))
        {
            var node = data.getComponent();
            var buttons = {
                "remove": {
                    title: this.lang.get('delete'),
                    api: 'module.form.remove',
                    args: node
                }
            };

            contextbar.set(e, node, buttons, 'top');
        }

    },

    // private
    _remove: function(node)
    {
        this.component.remove(node);
    }
});
$R.add('class', 'form.component', {
    mixins: ['dom', 'component'],
    init: function(app, el)
    {
        this.app = app;
        this.utils = app.utils;

        // init
        return (el && el.cmnt !== undefined) ? el : this._init(el);
    },
    // private
    _init: function(el)
    {
        if (typeof el !== 'undefined')
        {
            var $node = $R.dom(el);
            var $wrapper = $node.closest('form');
            if ($wrapper.length !== 0)
            {
                var $figure = this.utils.replaceToTag(el, 'figure');
                this.parse($figure);
            }
            else
            {
                this.parse('<figure>');
                this.append(el);
            }
        }
        else
        {
            this.parse('<figure>');
        }

        this._initWrapper();
    },
    _initWrapper: function()
    {
        this.addClass('redactor-component');
        this.attr({
            'data-redactor-type': 'form',
            'tabindex': '-1',
            'contenteditable': false
        });
    }
});
$R.add('module', 'image', {
    modals: {
        'image':
            '<div class="redactor-modal-tab redactor-modal-tab-upload" data-title="## upload ##"><form action=""> \
                <input type="file" name="file"> \
            </form></div>',
        'imageedit':
            '<div class="redactor-modal-group"> \
                <div id="redactor-modal-image-preview" class="redactor-modal-side"></div> \
                <form action="" class="redactor-modal-area"> \
                    <div class="form-item"> \
                        <label for="modal-image-title"> ## title ##</label> \
                        <input type="text" id="modal-image-title" name="title" /> \
                    </div> \
                    <div class="form-item form-item-caption"> \
                        <label for="modal-image-caption">## caption ##</label> \
                        <input type="text" id="modal-image-caption" name="caption" aria-label="## caption ##" /> \
                    </div> \
                    <div class="form-item form-item-align"> \
                        <label>## image-position ##</label> \
                        <select name="align" aria-label="## image-position ##"> \
                            <option value="none">## none ##</option> \
                            <option value="left">## left ##</option> \
                            <option value="center">## center ##</option> \
                            <option value="right">## right ##</option> \
                        </select> \
                    </div> \
                    <div class="form-item form-item-link"> \
                        <label for="modal-image-url">## link ##</label> \
                        <input type="text" id="modal-image-url" name="url" aria-label="## link ##" /> \
                    </div> \
                    <div class="form-item form-item-link"> \
                        <label class="checkbox"><input type="checkbox" name="target" aria-label="## link-in-new-tab ##"> ## link-in-new-tab ##</label> \
                    </div> \
                </form> \
            </div>'
    },
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.lang = app.lang;
        this.caret = app.caret;
        this.utils = app.utils;
        this.editor = app.editor;
        this.storage = app.storage;
        this.component = app.component;
        this.inspector = app.inspector;
        this.insertion = app.insertion;
        this.selection = app.selection;

        // local
        this.justResized = false;
    },
    // messages
    oninsert: function()
    {
        this._observeImages();
    },
    onstarted: function()
    {
        // storage observe
        this.storage.observeImages();

        // resize
        if (this.opts.imageResizable)
        {
            this.resizer = $R.create('image.resize', this.app);
        }

        // observe
        this._observeImages();
    },
    ondropimage: function(e, files, clipboard)
    {
        if (!this.opts.imageUpload) return;

        var options = {
            url: this.opts.imageUpload,
            event: (clipboard) ? false : e,
            files: files,
            name: 'imagedrop',
            data: this.opts.imageData,
            paramName: this.opts.imageUploadParam
        };

        this.app.api('module.upload.send', options);
    },
    onstop: function()
    {
        if (this.resizer) this.resizer.stop();
    },
    onbottomclick: function()
    {
        this.insertion.insertToEnd(this.editor.getLastNode(), 'image');
    },
    onimageresizer: {
        stop: function()
        {
            if (this.resizer) this.resizer.hide();
        }
    },
    onsource: {
        open: function()
        {
            if (this.resizer) this.resizer.hide();
        },
        closed: function()
        {
            this._observeImages();
            if (this.resizer) this.resizer.rebuild();
        }
    },
    onupload: {
        complete: function()
        {
            this._observeImages();
        },
        image: {
            complete: function(response)
            {
                this._insert(response);
            },
            error: function(response)
            {
                this._uploadError(response);
            }
        },
        imageedit: {
            complete: function(response)
            {
                this._change(response);
            },
            error: function(response)
            {
                this._uploadError(response);
            }
        },
        imagedrop: {
            complete: function(response, e)
            {
                this._insert(response, e);
            },
            error: function(response)
            {
                this._uploadError(response);
            }
        },
        imagereplace: {
            complete: function(response)
            {
                this._change(response, false);
            },
            error: function(response)
            {
                this._uploadError(response);
            }
        }
    },
    onmodal: {
        image: {
            open: function($modal, $form)
            {
                this._setUpload($modal, $form);
            }
        },
        imageedit: {
            open: function($modal, $form)
            {
                this._setFormData($modal, $form);
            },
            opened: function($modal, $form)
            {
                this._setFormFocus($form);
            },
            remove: function()
            {
                this._remove(this.$image);
            },
            save: function($modal, $form)
            {
                this._save($modal, $form);
            }
        }
    },
    onimage: {
        observe: function()
        {
            this._observeImages();
        },
        resized: function()
        {
            this.justResized = true;
        }
    },
    oncontextbar: function(e, contextbar)
    {
        if (this.justResized)
        {
            this.justResized = false;
            return;
        }

        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var $img = $R.dom(current).closest('img');

        if (!data.isFigcaption() && data.isComponentType('image') || $img.length !== 0)
        {
            var node = ($img.length !== 0) ? $img.get() : data.getComponent();
            var buttons = {
                "edit": {
                    title: this.lang.get('edit'),
                    api: 'module.image.open'
                },
                "remove": {
                    title: this.lang.get('delete'),
                    api: 'module.image.remove',
                    args: node
                }
            };

            contextbar.set(e, node, buttons);
        }
    },

    // public
    open: function()
    {
        this.$image = this._getCurrent();
        this.app.api('module.modal.build', this._getModalData());
    },
    insert: function(data)
    {
        this._insert(data);
    },
    remove: function(node)
    {
        this._remove(node);
    },

    // private
    _getModalData: function()
    {
        var modalData;
        if (this._isImage() && this.opts.imageEditable)
        {
            modalData = {
                name: 'imageedit',
                width: '800px',
                title: this.lang.get('edit'),
                handle: 'save',
                commands: {
                    save: { title: this.lang.get('save') },
                    remove: { title: this.lang.get('delete'), type: 'danger' },
                    cancel: { title: this.lang.get('cancel') }
                }
            };
        }
        else
        {
            modalData = {
                name: 'image',
                title: this.lang.get('image')
            };
        }

        return modalData;
    },
    _isImage: function()
    {
        return this.$image;
    },
    _getCurrent: function()
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var $img = $R.dom(current).closest('img');

        if ($img.length !== 0) {
            return this.component.create('image', $img);
        }
        else {
            return (data.isComponentType('image') && data.isComponentActive()) ? this.component.create('image', data.getComponent()) : false;
        }
    },
    _insert: function(response, e)
    {
        this.app.api('module.modal.close');

        if (Array.isArray(response))
        {
            var obj = {};
            for (var i = 0; i < response.length; i++)
            {
                obj = $R.extend(obj, response[i]);
            }

            response = obj;
        }
        else if (typeof response === 'string')
        {
            response = { "file": { url: response }};
        }

        if (typeof response === 'object')
        {

            var multiple = 0;
            for (var key in response)
            {
                if (typeof response[key] === 'object') multiple++;
            }

            if (multiple > 1)
            {
                this._insertMultiple(response, e);
            }
            else
            {
                this._insertSingle(response, e);
            }
        }
    },
    _insertSingle: function(response, e)
    {
        for (var key in response)
        {
            if (typeof response[key] === 'object')
            {
                var $img = this._createImageAndStore(response[key]);
                var inserted = (e) ? this.insertion.insertToPoint(e, $img, false, false) : this.insertion.insertHtml($img, false);

                this._removeSpaceBeforeFigure(inserted[0]);

                // set is active
                this.component.setActive(inserted[0]);
                this.app.broadcast('image.uploaded', inserted[0], response);
            }
        }
    },
    _insertMultiple: function(response, e)
    {
        var z = 0;
        var inserted = [];
        var last;
        for (var key in response)
        {
            if (typeof response[key] === 'object')
            {
                z++;

                var $img = this._createImageAndStore(response[key]);

                if (z === 1)
                {
                    inserted = (e) ? this.insertion.insertToPoint(e, $img, false, false) : this.insertion.insertHtml($img, false);
                }
                else
                {
                    var $inserted = $R.dom(inserted[0]);
                    $inserted.after($img);
                    inserted = [$img.get()];

                    this.app.broadcast('image.inserted', $img);
                }

                last = inserted[0];

                this._removeSpaceBeforeFigure(inserted[0]);
                this.app.broadcast('image.uploaded', inserted[0], response);
            }
        }

        // set last is active
        this.component.setActive(last);
    },
    _createImageAndStore: function(item)
    {
        var $img = this.component.create('image');

        $img.addClass('redactor-uploaded-figure');
        $img.setData({
            src: item.url,
            id: (item.id) ? item.id : this.utils.getRandomId()
        });

        // add to storage
        this.storage.add('image', $img.getElement());

        return $img;
    },
    _removeSpaceBeforeFigure: function(img)
    {
        if (!img) return;

        var prev = img.previousSibling;
        var next = img.nextSibling;
        var $prev = $R.dom(prev);
        var $next = $R.dom(next);

        if (this.opts.breakline) {
            if (next && $next.attr('data-redactor-tag') === 'br') {
                $next.find('br').first().remove();
            }
            if (prev && $prev.attr('data-redactor-tag') === 'br') {
                $prev.find('br').last().remove();
            }
        }

        if (prev)
        {
            this._removeInvisibleSpace(prev);
            this._removeInvisibleSpace(prev.previousSibling);
        }
    },
    _removeInvisibleSpace: function(el)
    {
        if (el && el.nodeType === 3 && this.utils.searchInvisibleChars(el.textContent) !== -1)
        {
            el.parentNode.removeChild(el);
        }
    },
    _save: function($modal, $form)
    {
        var data = $form.getData();
        var imageData = {
            title: data.title
        };

        if (this.opts.imageLink) imageData.link = { url: data.url, target: data.target };
        if (this.opts.imageCaption) imageData.caption = data.caption;
        if (this.opts.imagePosition) imageData.align = data.align;

        this.$image.setData(imageData);
        if (this.resizer) this.resizer.rebuild();

        this.app.broadcast('image.changed', this.$image);
        this.app.api('module.modal.close');
    },
    _change: function(response, modal)
    {
        if (typeof response === 'string')
        {
            response = { "file": { url: response }};
        }

        if (typeof response === 'object')
        {
            var $img;
            for (var key in response)
            {
                if (typeof response[key] === 'object')
                {
                    $img = $R.dom('<img>');
                    $img.attr('src', response[key].url);

                    this.$image.changeImage(response[key]);

                    this.app.broadcast('image.changed', this.$image, response);
                    this.app.broadcast('image.uploaded', this.$image, response);

                    this.app.broadcast('hardsync');

                    break;
                }
            }

            if (modal !== false)
            {
                $img.on('load', function() { this.$previewBox.html($img); }.bind(this));
            }
        }
    },
    _uploadError: function(response)
    {
        this.app.broadcast('image.uploadError', response);
    },
    _remove: function(node)
    {
        this.app.api('module.modal.close');
        this.component.remove(node);
    },
    _observeImages: function()
    {
        var $editor = this.editor.getElement();
        var self = this;
        $editor.find('img').each(function(node)
        {
            var $node = $R.dom(node);

            $node.off('.drop-to-replace');
            $node.on('dragover.drop-to-replace dragenter.drop-to-replace', function(e)
            {
                e.preventDefault();
                return;
            });

            $node.on('drop.drop-to-replace', function(e)
            {
                if (!self.app.isDragComponentInside())
                {
                    return self._setReplaceUpload(e, $node);
                }
            });
        });
    },
    _setFormData: function($modal, $form)
    {
        this._buildPreview();
        this._buildPreviewUpload();

        var imageData = this.$image.getData();
        var data = {
            title: imageData.title
        };

        // caption
        if (this.opts.imageCaption) data.caption = imageData.caption;
        else $modal.find('.form-item-caption').hide();

        // position
        if (this.opts.imagePosition) data.align = imageData.align;
        else $modal.find('.form-item-align').hide();

        // link
        if (this.opts.imageLink)
        {
            if (imageData.link)
            {
                data.url = imageData.link.url;
                if (imageData.link.target) data.target = true;
            }
        }
        else $modal.find('.form-item-link').hide();

        $form.setData(data);
    },
    _setFormFocus: function($form)
    {
        $form.getField('title').focus();
    },
    _setReplaceUpload: function(e, $node)
    {
        e = e.originalEvent || e;
        e.stopPropagation();
        e.preventDefault();

        if (!this.opts.imageUpload) return;

        this.$image = this.component.create('image', $node);

        var options = {
            url: this.opts.imageUpload,
            files: e.dataTransfer.files,
            name: 'imagereplace',
            data: this.opts.imageData,
            paramName: this.opts.imageUploadParam
        };

        this.app.api('module.upload.send', options);

        return;
    },
    _setUpload: function($modal, $form)
    {
        if (!this.opts.imageUpload) {
            var $body = $modal.getBody();
            var $tab = $body.find('.redactor-modal-tab-upload');
            $tab.remove();
        }

        var options = {
            url: this.opts.imageUpload,
            element: $form.getField('file'),
            name: 'image',
            data: this.opts.imageData,
            paramName: this.opts.imageUploadParam
        };

        this.app.api('module.upload.build', options);
    },
    _buildPreview: function()
    {
        this.$preview = $R.dom('#redactor-modal-image-preview');

        var imageData = this.$image.getData();
        var $previewImg = $R.dom('<img>');
        $previewImg.attr('src', imageData.src);

        this.$previewBox = $R.dom('<div>');
        this.$previewBox.append($previewImg);

        this.$preview.html('');
        this.$preview.append(this.$previewBox);
    },
    _buildPreviewUpload: function()
    {
        if (!this.opts.imageUpload) return;

        var $desc = $R.dom('<div class="desc">');
        $desc.html(this.lang.get('upload-change-label'));

        this.$preview.append($desc);

        var options = {
            url: this.opts.imageUpload,
            element: this.$previewBox,
            name: 'imageedit',
            data: this.opts.imageData,
            paramName: this.opts.imageUploadParam
        };

        this.app.api('module.upload.build', options);
    }
});
$R.add('class', 'image.component', {
    mixins: ['dom', 'component'],
    init: function(app, el)
    {
        this.app = app;
        this.opts = app.opts;
        this.selection = app.selection;

        // init
        return (el && el.cmnt !== undefined) ? el : this._init(el);
    },
    setData: function(data)
    {
        for (var name in data)
        {
            this._set(name, data[name]);
        }
    },
    getData: function()
    {
        var names = ['src', 'title', 'caption', 'align', 'link', 'id'];
        var data = {};

        for (var i = 0; i < names.length; i++)
        {
            data[names[i]] = this._get(names[i]);
        }

        return data;
    },
    getElement: function()
    {
        return this.$element;
    },
    changeImage: function(data)
    {
        this.$element.attr('src', data.url);
    },


    // private
    _init: function(el)
    {
        var $el = $R.dom(el);
        var $figure = $el.closest('figure');

        if (el === undefined)
        {
            this.$element = $R.dom('<img>');
            this.parse('<figure>');
            this.append(this.$element);
        }
        else if ($figure.length === 0)
        {
            this.parse('<figure>');
            this.$element = $el;
            this.$element.wrap(this);
        }
        else
        {
            this.parse($figure);
            this.$element = this.find('img');
        }

        this._initWrapper();
    },
    _set: function(name, value)
    {
        this['_set_' + name](value);
    },
    _get: function(name)
    {
        return this['_get_' + name]();
    },
    _set_src: function(src)
    {
       this.$element.attr('src', src);
    },
    _set_id: function(id)
    {
        if (this.opts.imageObserve) {
            this.$element.attr('data-image', id);
        }
    },
    _set_title: function(title)
    {
        title = title.trim().replace(/(<([^>]+)>)/ig,"");

        if (title === '')
        {
            this.$element.removeAttr('alt');
        }
        else
        {
            this.$element.attr('alt', title);
        }

    },
    _set_caption: function(caption)
    {
        var $figcaption = this.find('figcaption');
        if ($figcaption.length === 0)
        {
            $figcaption = $R.dom('<figcaption>');
            $figcaption.attr('contenteditable', 'true');

            this.append($figcaption);
        }

        if (caption === '') $figcaption.remove();
        else $figcaption.html(caption);

        return $figcaption;
    },
    _set_align: function(align)
    {
        var imageFloat = '';
        var imageMargin = '';
        var textAlign = '';
        var $el = this;
        var $img = this.find('img');
        var $figcaption = this.find('figcaption');

        if (typeof this.opts.imagePosition === 'object')
        {
            var positions = this.opts.imagePosition;
            for (var key in positions)
            {
                $el.removeClass(positions[key]);
            }

            var alignClass = (typeof positions[align] !== 'undefined') ? positions[align] : false;
            if (alignClass)
            {
                $el.addClass(alignClass);
            }
        }
        else
        {
            var width = $img.width();

            switch (align)
            {
                case 'left':
                    imageFloat = 'left';
                    imageMargin = '0 ' + this.opts.imageFloatMargin + ' ' + this.opts.imageFloatMargin + ' 0';
                break;
                case 'right':
                    imageFloat = 'right';
                    imageMargin = '0 0 ' + this.opts.imageFloatMargin + ' ' + this.opts.imageFloatMargin;
                break;
                case 'center':
                    textAlign = 'center';
                break;
            }

            $el.css({ 'float': imageFloat, width: width + 'px', maxWidth: width + 'px', 'margin': imageMargin, 'text-align': textAlign });
            $el.attr('rel', $el.attr('style'));

            if (align === 'none') {
                $el.css('max-width', '');
                $el.css('width', '');
            }

            if (align === 'center')
            {
                $el.css('max-width', '');
                $el.css('width', '');
                $figcaption.css('text-align', 'center');
            }
            else
            {
                $figcaption.css('text-align', '');
            }
        }
    },
    _set_link: function(data)
    {
        var $link = this._findLink();
        if (data.url === '')
        {
            if ($link) $link.unwrap();

            return;
        }

        if (!$link)
        {
            $link = $R.dom('<a>');
            this.$element.wrap($link);
        }

        $link.attr('href', data.url);

        if (data.target) $link.attr('target', (data.target === true) ? '_blank' : data.target);
        else $link.removeAttr('target');

        return $link;
    },
    _get_src: function()
    {
        return this.$element.attr('src');
    },
    _get_id: function()
    {
        return this.$element.attr('data-image');
    },
    _get_title: function()
    {
        var alt = this.$element.attr('alt');

        return (alt) ? alt : '';
    },
    _get_caption: function()
    {
        var $figcaption = this.find('figcaption');

        if ($figcaption.length === 0)
        {
            return '';
        }
        else
        {
            return $figcaption.html();
        }
    },
    _get_align: function()
    {
        var align = '';
        if (typeof this.opts.imagePosition === 'object')
        {
            align = 'none';
            var positions = this.opts.imagePosition;
            for (var key in positions)
            {
                if (this.hasClass(positions[key]))
                {
                    align = key;
                    break;
                }
            }
        }
        else
        {
            align = (this.css('text-align') === 'center') ? 'center' : this.css('float');
        }

        return align;
    },
    _get_link: function()
    {
        var $link = this._findLink();
        if ($link)
        {
            var target = ($link.attr('target')) ? true : false;

            return {
                url: $link.attr('href'),
                target: target
            };
        }
    },
    _initWrapper: function()
    {
        this.addClass('redactor-component');
        this.attr({
            'data-redactor-type': 'image',
            'tabindex': '-1',
            'contenteditable': false
        });
    },
    _findLink: function()
    {
        var $link = this.find('a').filter(function(node)
        {
            return ($R.dom(node).closest('figcaption').length === 0);
        });

        if ($link.length !== 0)
        {
            return $link;
        }

        return false;
    }
});
$R.add('class', 'image.resize', {
    init: function(app)
    {
        this.app = app;
        this.$doc = app.$doc;
        this.$win = app.$win;
        this.$body = app.$body;
        this.editor = app.editor;
        this.toolbar = app.toolbar;
        this.inspector = app.inspector;

        // init
        this.$target = (this.toolbar.isTarget()) ? this.toolbar.getTargetElement() : this.$body;
        this._init();
    },
    // public
    rebuild: function()
    {
        this._setResizerPosition();
    },
    hide: function()
    {
        this.$target.find('#redactor-image-resizer').remove();
    },
    stop: function()
    {
        var $editor = this.editor.getElement();
        $editor.off('.redactor.image-resize');

        this.$doc.off('.redactor.image-resize');
        this.$win.off('resize.redactor.image-resize');
        this.hide();
    },

    // private
    _init: function()
    {
        var $editor = this.editor.getElement();
        $editor.on('click.redactor.image-resize', this._build.bind(this));

        this.$win.on('resize.redactor.image-resize', this._setResizerPosition.bind(this));
    },
    _build: function(e)
    {
        this.$target.find('#redactor-image-resizer').remove();

        var data = this.inspector.parse(e.target);
        var $editor = this.editor.getElement();

        if (data.isComponentType('image'))
        {
            this.$resizableBox = $editor;
            this.$resizableImage = $R.dom(data.getImageElement());

            this.$resizer = $R.dom('<span>');
            this.$resizer.attr('id', 'redactor-image-resizer');

            this.$target.append(this.$resizer);

            this._setResizerPosition();
            this.$resizer.on('mousedown touchstart', this._set.bind(this));
        }
    },
    _setResizerPosition: function()
    {
        if (this.$resizer)
        {
            var isTarget = this.toolbar.isTarget();
            var targetOffset = this.$target.offset();
            var offsetFix = 7;
            var topOffset = (isTarget) ? (offsetFix - targetOffset.top + this.$target.scrollTop()) : offsetFix;
            var leftOffset = (isTarget) ? (offsetFix - targetOffset.left) : offsetFix;
            var pos = this.$resizableImage.offset();
            var width = this.$resizableImage.width();
            var height = this.$resizableImage.height();
            var resizerWidth =  this.$resizer.width();
            var resizerHeight =  this.$resizer.height();

            this.$resizer.css({ top: Math.round(pos.top + height - resizerHeight + topOffset) + 'px', left: Math.round(pos.left + width - resizerWidth + leftOffset) + 'px' });
        }
    },
    _set: function(e)
    {
        e.preventDefault();

        this.resizeHandle = {
            x : e.pageX,
            y : e.pageY,
            el : this.$resizableImage,
            $figure: this.$resizableImage.closest('figure'),
            ratio: this.$resizableImage.width() / this.$resizableImage.height(),
            h: this.$resizableImage.height()
        };

        e = e.originalEvent || e;

        if (e.targetTouches)
        {
             this.resizeHandle.x = e.targetTouches[0].pageX;
             this.resizeHandle.y = e.targetTouches[0].pageY;
        }

        this.app.broadcast('contextbar.close');
        this.app.broadcast('image.resize', this.$resizableImage);
        this._start();
    },
    _start: function()
    {
        this.$doc.on('mousemove.redactor.image-resize touchmove.redactor.image-resize', this._move.bind(this));
        this.$doc.on('mouseup.redactor.image-resize touchend.redactor.image-resize', this._stop.bind(this));
    },
    _stop: function()
    {
        this.$doc.off('.redactor.image-resize');
        this.app.broadcast('image.resized', this.$resizableImage);
    },
    _move: function(e)
    {
        e.preventDefault();

        e = e.originalEvent || e;

        var height = this.resizeHandle.h;

        if (e.targetTouches) height += (e.targetTouches[0].pageY -  this.resizeHandle.y);
        else height += (e.pageY -  this.resizeHandle.y);

        var width = height * this.resizeHandle.ratio;

        width = Math.round(width);
        height = Math.round(height);

        if (height < 20 || width < 100) return;
        if (this._getResizableBoxWidth() <= width) return;

        if (this.resizeHandle.$figure.length !== 0 && this.resizeHandle.$figure.css('max-width') !== '') {
            this.resizeHandle.$figure.css('max-width', width + 'px');
        }

        this.resizeHandle.el.attr({width: width, height: height});
        this.resizeHandle.el.width(width);
        this.resizeHandle.el.height(height);
        this._setResizerPosition();
    },
    _getResizableBoxWidth: function()
    {
        var width = this.$resizableBox.width();
        return width - parseInt(this.$resizableBox.css('padding-left')) - parseInt(this.$resizableBox.css('padding-right'));
    }
});
$R.add('module', 'file', {
    modals: {
        'file':
            '<div class="redactor-modal-tab" data-title="## upload ##"><form action=""> \
                <div class="form-item form-item-title"> \
                    <label for="modal-file-title"> ## filename ## <span class="desc">(## optional ##)</span></label> \
                    <input type="text" id="modal-file-title" name="title" /> \
                </div> \
                <input type="file" name="file"> \
            </form></div>'
    },
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.lang = app.lang;
        this.caret = app.caret;
        this.utils = app.utils;
        this.storage = app.storage;
        this.component = app.component;
        this.inspector = app.inspector;
        this.insertion = app.insertion;
        this.selection = app.selection;
    },
    // messages
    onstarted: function()
    {
        // storage observe
        this.storage.observeFiles();
    },
    ondropfile: function(e, files, clipboard)
    {
        if (!this.opts.fileUpload) return;

        var options = {
            url: this.opts.fileUpload,
            event: (clipboard) ? false : e,
            files: files,
            name: 'filedrop',
            data: this.opts.fileData
        };

        this.app.api('module.upload.send', options);
    },
    onmodal: {
        file: {
            open: function($modal, $form)
            {
                this._setFormData($modal, $form);
                this._setUpload($form);
            },
            opened: function($modal, $form)
            {
                this._setFormFocus($form);

                this.$form = $form;
            }
        }
    },
    onupload: {
        file: {
            complete: function(response)
            {
                this._insert(response);
            },
            error: function(response)
            {
                this._uploadError(response);
            }
        },
        filedrop: {
            complete: function(response, e)
            {
                this._insert(response, e);
            },
            error: function(response)
            {
                this._uploadError(response);
            }
        }
    },

    // public
    open: function()
    {
        this._open();
    },
    insert: function(data)
    {
        this._insert(data);
    },
    remove: function(node)
    {
        this._remove(node);
    },

    // private
    _open: function()
    {
        this.app.api('module.modal.build', this._getModalData());
    },
    _getModalData: function()
    {
        var modalData = {
            name: 'file',
            title: this.lang.get('file')
        };

        return modalData;
    },
    _insert: function(response, e)
    {
        this.app.api('module.modal.close');
        if (typeof response !== 'object') return;

        if (Array.isArray(response))
        {
            var obj = {};
            for (var i = 0; i < response.length; i++)
            {
                obj = $R.extend(obj, response[i]);
            }

            response = obj;
        }

        var multiple = (Object.keys(response).length  > 1);

        if (multiple)
        {
            this._insertMultiple(response, e);
        }
        else
        {
            this._insertSingle(response, e);
        }

        this.$form = false;
    },
    _insertSingle: function(response, e)
    {
        var inserted = [];
        for (var key in response)
        {
            var $file = this._createFileAndStore(response[key]);

            if (this.opts.fileAttachment)
            {
                inserted = this._insertAsAttachment($file);
            }
            else
            {
                inserted = (e) ? this.insertion.insertToPoint(e, $file) : this.insertion.insertRaw($file);
            }

            this.app.broadcast('file.uploaded', inserted[0], response);
        }
    },
    _insertMultiple: function(response, e)
    {
        var z = 0;
        var inserted = [];
        var $last;
        for (var key in response)
        {
            z++;

            var $file = this._createFileAndStore(response[key]);

            if (this.opts.fileAttachment)
            {
                inserted = this._insertAsAttachment($file, response);
            }
            else
            {
                if (z === 1)
                {
                    inserted = (e) ? this.insertion.insertToPoint(e, $file) : this.insertion.insertRaw($file);
                }
                else
                {
                    var $inserted = $R.dom(inserted[0]);
                    $inserted.after($file).after(' ');
                    inserted = [$file.get()];

                    this.app.broadcast('file.inserted', $file);
                }
            }

            $last = $file;
            this.app.broadcast('file.uploaded', inserted[0], response);
        }

        // set caret after last
        if (!this.opts.fileAttachment)
        {
            this.caret.setAfter($last);
        }
    },
    _insertAsAttachment: function($file, response)
    {
        var $box = $R.dom(this.opts.fileAttachment);
        var $wrapper = $file.wrapAttachment();
        $box.append($wrapper);

        var inserted = [$wrapper.get()];
        this.app.broadcast('file.appended', inserted[0], response);

        return inserted;
    },
    _createFileAndStore: function(item)
    {
        var modalFormData = (this.$form) ? this.$form.getData() : false;
        var name = (item.name) ? item.name : item.url;
        var title = (!this.opts.fileAttachment && modalFormData && modalFormData.title !== '') ? modalFormData.title : this._truncateUrl(name);

        var $file = this.component.create('file');
        $file.attr('href', item.url);
        $file.attr('data-file', (item.id) ? item.id : this.utils.getRandomId());
        $file.attr('data-name', item.name);
        $file.html(title);

        // add to storage
        this.storage.add('file', $file);

        return $file;
    },
    _remove: function(node)
    {
        this.selection.save();

        var $file = this.component.create('file', node);
        var stop = this.app.broadcast('file.delete', $file);
        if (stop !== false)
        {
            $file.unwrap();

            this.selection.restore();

            // callback
            this.app.broadcast('file.deleted', $file);
        }
        else
        {
            this.selection.restore();
        }
    },
    _truncateUrl: function(url)
    {
        return (url.search(/^http/) !== -1 && url.length > 20) ? url.substring(0, 20) + '...' : url;
    },
    _setUpload: function($form)
    {
        var options = {
            url: this.opts.fileUpload,
            element: $form.getField('file'),
            name: 'file',
            data: this.opts.fileData,
            paramName: this.opts.fileUploadParam
        };

        this.app.api('module.upload.build', options);
    },
    _setFormData: function($modal, $form)
    {
        if (this.opts.fileAttachment)
        {
            $modal.find('.form-item-title').hide();
        }
        else
        {
            $form.setData({ title: this.selection.getText() });
        }
    },
    _setFormFocus: function($form)
    {
        $form.getField('title').focus();
    },
    _uploadError: function(response)
    {
        this.app.broadcast('file.uploadError', response);
    }
});
$R.add('class', 'file.component', {
    mixins: ['dom', 'component'],
    init: function(app, el)
    {
        this.app = app;
        this.opts = app.opts;

        // init
        return (el && el.cmnt !== undefined) ? el : this._init(el);
    },
    wrapAttachment: function()
    {
        this.$wrapper = $R.dom('<span class="redactor-file-item">');
        this.$remover = $R.dom('<span class="redactor-file-remover">');
        this.$remover.html('&times;');
        this.$remover.on('click', this.removeAttachment.bind(this));

        this.$wrapper.append(this);
        this.$wrapper.append(this.$remover);

        return this.$wrapper;
    },
    removeAttachment: function(e)
    {
        e.preventDefault();

        var stop = this.app.broadcast('file.delete', this, this.$wrapper);
        if (stop !== false)
        {
            this.$wrapper.remove();
            this.app.broadcast('file.deleted', this);
            this.app.broadcast('file.removeAttachment', this);
        }
    },

    // private
    _init: function(el)
    {
        if (el === undefined)
        {
            this.parse('<a>');
        }
        else
        {
            var $a = $R.dom(el).closest('a');
            this.parse($a);
        }
    }
});
$R.add('module', 'buffer', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.editor = app.editor;
        this.offset = app.offset;
        this.keycodes = app.keycodes;
        this.selection = app.selection;

        // local
        this.state = false;
        this.passed = false;
        this.keyPressed = false;
        this.undoStorage = [];
        this.redoStorage = [];
    },
    // messages
    onkeydown: function(e)
    {
        this._listen(e);
    },
    onsyncing: function()
    {
        if (!this.keyPressed)
        {
            this.trigger();
        }

        this.keyPressed = false;
    },
    onbuffer: {
        trigger: function()
        {
            this.trigger();
        }
    },
    onstate: function(e, html, offset)
    {
        if ((e && (e.ctrlKey || e.metaKey)) || (e && (this._isUndo(e) || this._isRedo(e))))
        {
            return;
        }

        this.passed = false;
        this._saveState(html, offset);
    },
    onenable: function()
    {
        this.clear();
    },

    // public
    clear: function()
    {
        this.state = false;
        this.undoStorage = [];
        this.redoStorage = [];
    },
    undo: function()
    {
        this._getUndo();
    },
    redo: function()
    {
        this._getRedo();
    },
    trigger: function()
    {
        if (this.state && this.passed === false) this._setUndo();
    },

    // private
    _saveState: function(html, offset)
    {
        var $editor = this.editor.getElement();

        this.state = {
            html: html || $editor.html(),
            offset: offset || this.offset.get()
        };
    },
    _listen: function(e)
    {
        var key = e.which;
        var ctrl = e.ctrlKey || e.metaKey;
        var cmd = ctrl || e.shiftKey || e.altKey;
        var keys = [this.keycodes.SPACE, this.keycodes.ENTER, this.keycodes.BACKSPACE, this.keycodes.DELETE, this.keycodes.TAB,
                    this.keycodes.LEFT, this.keycodes.RIGHT, this.keycodes.UP, this.keycodes.DOWN];
        // undo
        if (this._isUndo(e)) // z key
        {
            e.preventDefault();
            this.undo();
            return;
        }
        // redo
        else if (this._isRedo(e))
        {
            e.preventDefault();
            this.redo();
            return;
        }
        // spec keys
        else if (!ctrl && keys.indexOf(key) !== -1)
        {
            cmd = true;
            this.trigger();
        }
        // cut & copy
        else if (ctrl && (key === 88 || key === 67))
        {
            cmd = true;
            this.trigger();
        }


        // empty buffer
        if (!cmd && !this._hasUndo())
        {
            this.trigger();
        }

        this.keyPressed = true;
    },
    _isUndo: function(e)
    {
        var key = e.which;
        var ctrl = e.ctrlKey || e.metaKey;

        return (ctrl && key === 90 && !e.shiftKey && !e.altKey);
    },
    _isRedo: function(e)
    {
        var key = e.which;
        var ctrl = e.ctrlKey || e.metaKey;

        return (ctrl && (key === 90 && e.shiftKey || key === 89 && !e.shiftKey) && !e.altKey);
    },
    _setUndo: function()
    {
        var last = this.undoStorage[this.undoStorage.length-1];
        if (typeof last === 'undefined' || last[0] !== this.state.html)
        {
            this.undoStorage.push([this.state.html, this.state.offset]);
            this._removeOverStorage();
        }
    },
    _setRedo: function()
    {
        var $editor = this.editor.getElement();
        var offset = this.offset.get();
        var html = $editor.html();

        this.redoStorage.push([html, offset]);
        this.redoStorage = this.redoStorage.slice(0, this.opts.bufferLimit);
    },
    _getUndo: function()
    {
        if (!this._hasUndo()) return;

        this.passed = true;

        var $editor = this.editor.getElement();
        var buffer = this.undoStorage.pop();

        this._setRedo();

        $editor.html(buffer[0]);
        this.offset.set(buffer[1]);
        this.selection.restore();

        this.app.broadcast('undo', buffer[0], buffer[1]);

    },
    _getRedo: function()
    {
        if (!this._hasRedo()) return;

        this.passed = true;

        var $editor = this.editor.getElement();
        var buffer = this.redoStorage.pop();

        this._setUndo();
        $editor.html(buffer[0]);
        this.offset.set(buffer[1]);

        this.app.broadcast('redo', buffer[0], buffer[1]);
    },
    _removeOverStorage: function()
    {
        if (this.undoStorage.length > this.opts.bufferLimit)
        {
            this.undoStorage = this.undoStorage.slice(0, (this.undoStorage.length - this.opts.bufferLimit));
        }
    },
    _hasUndo: function()
    {
        return (this.undoStorage.length !== 0);
    },
    _hasRedo: function()
    {
        return (this.redoStorage.length !== 0);
    }
});
$R.add('module', 'list', {
    init: function(app)
    {
        this.app = app;
        this.opts = app.opts;
        this.utils = app.utils;
        this.block = app.block;
        this.toolbar = app.toolbar;
        this.inspector = app.inspector;
        this.selection = app.selection;
    },
    // messages
    onbutton: {
        list: {
            observe: function(button)
            {
                this._observeButton(button);
            }
        }
    },
    ondropdown: {
        list: {
            observe: function(dropdown)
            {
                this._observeDropdown(dropdown);
            }
        }
    },

    // public
    toggle: function(type)
    {
        var nodes = this._getBlocks();
        var block = this.selection.getBlock();
        var $list = $R.dom(block).parents('ul, ol',  '.redactor-in').last();
        if (nodes.length === 0 && $list.length !== 0)
        {
            nodes = [$list.get()];
        }

        if (block && (block.tagName === 'TD' || block.tagName === 'TH'))
        {
            nodes = this.block.format('div');
        }

        this.selection.saveMarkers();

        nodes = (nodes.length !== 0 && this._isUnformat(type, nodes)) ? this._unformat(type, nodes) : this._format(type, nodes);

        this.selection.restoreMarkers();

        return nodes;
    },
    indent: function()
    {
        var isCollapsed = this.selection.isCollapsed();
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var item = (data.isList()) ? data.getListItem() : false;
        var $item = $R.dom(item);
        var $prev = $item.prevElement();
        var prev = $prev.get();
        var isIndent = (isCollapsed && item && prev && prev.tagName === 'LI');

        if (isIndent)
        {
            this.selection.saveMarkers();

            $prev = $R.dom(prev);
            var $prevChild = $prev.children('ul, ol');
            var $list = $item.closest('ul, ol');

            if ($prevChild.length !== 0)
            {
                $prevChild.append($item);
            }
            else
            {
                var listTag = $list.get().tagName.toLowerCase();
                var $newList = $R.dom('<' + listTag + '>');

                $newList.append($item);
                $prev.append($newList);
            }

            this.selection.restoreMarkers();
        }
    },
    outdent: function()
    {
        var isCollapsed = this.selection.isCollapsed();
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var item = (data.isList()) ? data.getListItem() : false;
        var $item = $R.dom(item);

        if (isCollapsed && item)
        {

            var $listItem = $item.parent();
            var $liItem = $listItem.closest('li', '.redactor-in');
            var $prev = $item.prevElement();
            var $next = $item.nextElement();
            var prev = $prev.get();
            var next = $next.get();
            var nextItems, nextList, $newList, $nextList;
            var isTop = (prev === false);
            var isMiddle = (prev !== false && next !== false);
            var isBottom = (!isTop && next === false);

            this.selection.saveMarkers();

            // out
            if ($liItem.length !== 0)
            {
                if (isMiddle)
                {
                    nextItems = this._getAllNext($item.get());
                    $newList = $R.dom('<' + $listItem.get().tagName.toLowerCase() + '>');

                    for (var i = 0; i < nextItems.length; i++)
                    {
                        $newList.append(nextItems[i]);
                    }

                    $liItem.after($item);
                    $item.append($newList);
                }
                else
                {
                    $liItem.after($item);

                    if ($listItem.children().length === 0)
                    {
                        $listItem.remove();
                    }
                    else
                    {
                        if (isTop) $item.append($listItem);
                    }
                }
            }
            // unformat
            else
            {
                var $container =  this._createUnformatContainer($item);
                var $childList = $container.find('ul, ol').first();

                if (isTop) $listItem.before($container);
                else if (isBottom) $listItem.after($container);
                else if (isMiddle)
                {
                    $newList = $R.dom('<' + $listItem.get().tagName.toLowerCase() + '>');
                    nextItems = this._getAllNext($item.get());

                    for (var i = 0; i < nextItems.length; i++)
                    {
                        $newList.append(nextItems[i]);
                    }

                    $listItem.after($container);
                    $container.after($newList);
                }

                if ($childList.length !== 0)
                {
                    $nextList = $container.nextElement();
                    nextList = $nextList.get();
                    if (nextList && nextList.tagName === $listItem.get().tagName)
                    {
                        $R.dom(nextList).prepend($childList);
                        $childList.unwrap();
                    }
                    else
                    {
                        $container.after($childList);
                    }
                }

                $item.remove();
            }

            this.selection.restoreMarkers();
        }
    },

    // private
    _getAllNext: function(next)
    {
        var nodes = [];

        while (next)
        {
            var $next = $R.dom(next).nextElement();
            next = $next.get();

            if (next) nodes.push(next);
            else return nodes;
        }

        return nodes;
    },
    _isUnformat: function(type, nodes)
    {
        var countLists = 0;
        for (var i = 0; i < nodes.length; i++)
        {
            if (nodes[i].nodeType !== 3)
            {
                var tag = nodes[i].tagName.toLowerCase();
                if (tag === type || tag === 'figure')
                {
                    countLists++;
                }
            }
        }

        return (countLists === nodes.length);
    },
    _format: function(type, nodes)
    {
        var tags = ['p', 'div', 'blockquote', 'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol'];
        var blocks = this._uniteBlocks(nodes, tags);
        var lists = [];

        for (var key in blocks)
        {
            var items = blocks[key];
            var $list = this._createList(type, blocks[key]);

            for (var i = 0; i < items.length; i++)
            {
                var $item;

                // lists
                if (items[i].nodeType !== 3 && (items[i].tagName === 'UL' || items[i].tagName === 'OL'))
                {
                    var $oldList = $R.dom(items[i]);

                    $item = $oldList.contents();
                    $list.append($item);

                    // old is empty
                    if (this.utils.isEmpty($oldList)) $oldList.remove();
                }
                // other blocks or texts
                else
                {
                    $item = this._createListItem(items[i]);
                    this.utils.normalizeTextNodes($item);
                    $list.append($item);
                }
            }

            lists.push($list.get());
        }

        return lists;
    },
    _uniteBlocks: function(nodes, tags)
    {
        var z = 0;
        var blocks = { 0: [] };
        var lastcell = false;
        for (var i = 0; i < nodes.length; i++)
        {
            var $node = $R.dom(nodes[i]);
            var $cell = $node.closest('th, td');

            if ($cell.length !== 0)
            {
                if ($cell.get() !== lastcell)
                {
                    // create block
                    z++;
                    blocks[z] = [];
                }

                if (this._isUniteBlock(nodes[i], tags))
                {
                    blocks[z].push(nodes[i]);
                }
            }
            else
            {
                if (this._isUniteBlock(nodes[i], tags))
                {
                    blocks[z].push(nodes[i]);
                }
                else
                {
                    // create block
                    z++;
                    blocks[z] = [];
                }
            }

            lastcell = $cell.get();
        }

        return blocks;
    },
    _isUniteBlock: function(node, tags)
    {
        return (node.nodeType === 3 || tags.indexOf(node.tagName.toLowerCase()) !== -1);
    },
    _createList: function(type, blocks)
    {
        var last = blocks[blocks.length-1];
        var $last = $R.dom(last);
        var $list = $R.dom('<' + type + '>');
        $last.after($list);

        return $list;
    },
    _createListItem: function(item)
    {
        var $item = $R.dom('<li>');
        if (item.nodeType === 3)
        {
            $item.append(item);
        }
        else
        {
            var $el = $R.dom(item);
            $item.append($el.contents());
            $el.remove();
        }

        return $item;
    },
    _unformat: function(type, nodes)
    {
        if (nodes.length === 1)
        {
            // one list
            var $list = $R.dom(nodes[0]);
            var $items = $list.find('li');

            var selectedItems = this.selection.getNodes({ tags: ['li'] });
            var block = this.selection.getBlock();
            var $li = $R.dom(block).closest('li');
            if (selectedItems.length === 0 && $li.length !== 0)
            {
                selectedItems = [$li.get()];
            }


            // 1) entire
            if (selectedItems.length === $items.length)
            {
                return this._unformatEntire(nodes[0]);
            }

            var pos = this._getItemsPosition($items, selectedItems);

            // 2) top
            if (pos === 'Top')
            {
                return this._unformatAtSide('before', selectedItems, $list);
            }

            // 3) bottom
            else if (pos === 'Bottom')
            {
                selectedItems.reverse();
                return this._unformatAtSide('after', selectedItems, $list);
            }

            // 4) middle
            else if (pos === 'Middle')
            {
                var $last = $R.dom(selectedItems[selectedItems.length-1]);

                var ci = false;

                var $parent = false;
                var $secondList = $R.dom('<' + $list.get().tagName.toLowerCase() + '>');
                $items.each(function(node)
                {
                    if (ci)
                    {
                        var $node = $R.dom(node);
                        if ($node.closest('.redactor-split-item').length === 0 && ($parent === false || $node.closest($parent).length === 0))
                        {
                            $node.addClass('redactor-split-item');
                        }

                        $parent = $node;
                    }

                    if (node === $last.get())
                    {
                        ci = true;
                    }
                });

                $items.filter('.redactor-split-item').each(function(node)
                {
                    var $node = $R.dom(node);
                    $node.removeClass('redactor-split-item');
                    $secondList.append(node);
                });

                $list.after($secondList);

                selectedItems.reverse();
                for (var i = 0; i < selectedItems.length; i++)
                {
                    var $item = $R.dom(selectedItems[i]);
                    var $container = this._createUnformatContainer($item);

                    $list.after($container);
                    $container.find('ul, ol').remove();
                    $item.remove();
                }


                return;
            }

        }
        else
        {
            // unformat all
            for (var i = 0; i < nodes.length; i++)
            {
                if (nodes[i].nodeType !== 3 && nodes[i].tagName.toLowerCase() === type)
                {
                    this._unformatEntire(nodes[i]);
                }
            }
        }
    },
    _unformatEntire: function(list)
    {
        var $list = $R.dom(list);
        var $items = $list.find('li');
        $items.each(function(node)
        {
            var $item = $R.dom(node);
            var $container = this._createUnformatContainer($item);

            $item.remove();
            $list.before($container);

        }.bind(this));

        $list.remove();
    },
    _unformatAtSide: function(type, selectedItems, $list)
    {
        for (var i = 0; i < selectedItems.length; i++)
        {
            var $item = $R.dom(selectedItems[i]);
            var $container = this._createUnformatContainer($item);

            $list[type]($container);

            var $innerLists = $container.find('ul, ol').first();
            $item.append($innerLists);

            $innerLists.each(function(node)
            {
                var $node = $R.dom(node);
                var $parent = $node.closest('li');

                if ($parent.get() === selectedItems[i])
                {
                    $node.unwrap();
                    $parent.addClass('r-unwrapped');
                }

            });

            if (this.utils.isEmptyHtml($item.html())) $item.remove();
        }

        // clear empty
        $list.find('.r-unwrapped').each(function(node)
        {
            var $node = $R.dom(node);
            if ($node.html().trim() === '') $node.remove();
            else $node.removeClass('r-unwrapped');
        });
    },
    _getItemsPosition: function($items, selectedItems)
    {
        var pos = 'Middle';

        var sFirst = selectedItems[0];
        var sLast = selectedItems[selectedItems.length-1];

        var first = $items.first().get();
        var last = $items.last().get();

        if (first === sFirst && last !== sLast)
        {
            pos = 'Top';
        }
        else if (first !== sFirst && last === sLast)
        {
            pos = 'Bottom';
        }

        return pos;
    },
    _createUnformatContainer: function($item)
    {
        var $container = $R.dom('<' + this.opts.markup + '>');
        if (this.opts.breakline) $container.attr('data-redactor-tag', 'br');

        $container.append($item.contents());

        return $container;
    },
    _getBlocks: function()
    {
        return this.selection.getBlocks({ first: true });
    },
    _observeButton: function()
    {
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var isDisabled = (data.isPre() || data.isCode() || data.isFigcaption());

        this._observeButtonsList(isDisabled, ['lists', 'ul', 'ol', 'outdent', 'indent']);

        var itemOutdent = this.toolbar.getButton('outdent');
        var itemIndent = this.toolbar.getButton('indent');

        this._observeIndent(itemIndent, itemOutdent);
    },
    _observeDropdown: function(dropdown)
    {
        var itemOutdent = dropdown.getItem('outdent');
        var itemIndent = dropdown.getItem('indent');

        this._observeIndent(itemIndent, itemOutdent);
    },
    _observeIndent: function(itemIndent, itemOutdent)
    {
        var isCollapsed = this.selection.isCollapsed();
        var current = this.selection.getCurrent();
        var data = this.inspector.parse(current);
        var item = (data.isList()) ? data.getListItem() : false;
        var $item = $R.dom(item);
        var $prev = $item.prevElement();
        var prev = $prev.get();
        var isIndent = (isCollapsed && item && prev && prev.tagName === 'LI');

        if (itemOutdent)
        {
            if (item && isCollapsed) itemOutdent.enable();
            else itemOutdent.disable();
        }

        if (itemIndent)
        {
            if (item && isIndent) itemIndent.enable();
            else itemIndent.disable();
        }
    },
    _observeButtonsList: function(param, buttons)
    {
        for (var i = 0; i < buttons.length; i++)
        {
            var button = this.toolbar.getButton(buttons[i]);
            if (button)
            {
                if (param) button.disable();
                else button.enable();
            }
        }
    }
});
$R.add('class', 'video.component', {
    mixins: ['dom', 'component'],
    init: function(app, el)
    {
        this.app = app;

        // init
        return (el && el.cmnt !== undefined) ? el : this._init(el);
    },

    // private
    _init: function(el)
    {
        if (typeof el !== 'undefined')
        {
            var $node = $R.dom(el);
            var $wrapper = $node.closest('figure');
            if ($wrapper.length !== 0)
            {
                this.parse($wrapper);
            }
            else
            {
                this.parse('<figure>');
                this.append(el);
            }
        }
        else
        {
            this.parse('<figure>');
        }


        this._initWrapper();
    },
    _initWrapper: function()
    {
        this.addClass('redactor-component');
        this.attr({
            'data-redactor-type': 'video',
            'tabindex': '-1',
            'contenteditable': false
        });
    }
});

$R.add('class', 'widget.component', {
    mixins: ['dom', 'component'],
    init: function(app, el)
    {
        this.app = app;

        // init
        return (el && el.cmnt !== undefined) ? el : this._init(el);
    },
    getData: function()
    {
        return {
            html: this._getHtml()
        };
    },

    // private
    _init: function(el)
    {
        if (typeof el !== 'undefined')
        {
            var $node = $R.dom(el);
            var $figure = $node.closest('figure');
            if ($figure.length !== 0)
            {
                this.parse($figure);
            }
            else
            {
                this.parse('<figure>');
                this.html(el);
            }
        }
        else
        {
            this.parse('<figure>');
        }


        this._initWrapper();
    },
    _getHtml: function()
    {
        var $wrapper = $R.dom('<div>');
        $wrapper.html(this.html());
        $wrapper.find('.redactor-component-caret').remove();

        return $wrapper.html();
    },
    _initWrapper: function()
    {
        this.addClass('redactor-component');
        this.attr({
            'data-redactor-type': 'widget',
            'tabindex': '-1',
            'contenteditable': false
        });
    }
});

    window.Redactor = window.$R = $R;

    // Data attribute load
    window.addEventListener('load', function()
    {
        $R('[data-redactor]');
    });

}());

/* -------- studio/v2/js/redactor/redactor/plugins/alignment/alignment.js -------- */
(function($R)
{
    $R.add('plugin', 'alignment', {
        translations: {
    		en: {
    			"align": "Align",
    			"align-left": "Align Left",
    			"align-center": "Align Center",
    			"align-right": "Align Right",
    			"align-justify": "Align Justify"
    		}
        },
        init: function(app)
        {
            this.app = app;
            this.opts = app.opts;
            this.lang = app.lang;
            this.block = app.block;
            this.toolbar = app.toolbar;
        },
        // public
        start: function()
        {
            var dropdown = {};

    		dropdown.left = { title: this.lang.get('align-left'), api: 'plugin.alignment.set', args: 'left' };
    		dropdown.center = { title: this.lang.get('align-center'), api: 'plugin.alignment.set', args: 'center' };
    		dropdown.right = { title: this.lang.get('align-right'), api: 'plugin.alignment.set', args: 'right' };
    		dropdown.justify = { title: this.lang.get('align-justify'), api: 'plugin.alignment.set', args: 'justify' };

            var $button = this.toolbar.addButton('alignment', { title: this.lang.get('align') });
            $button.setIcon('<i class="re-icon-alignment"></i>');
			$button.setDropdown(dropdown);
        },
        set: function(type)
		{
    		if (type === 'left' && this.opts.direction === 'ltr')
    		{
        		return this._remove();
    		}

    		var args = {
        	    style: { 'text-align': type }
    		};

			this.block.toggle(args);
		},

		// private
		_remove: function()
		{
		    this.block.remove({ style: 'text-align' });
		}
    });
})(Redactor);
/* -------- studio/v2/js/redactor/redactor/plugins/counter/counter.js -------- */
(function($R)
{
    $R.add('plugin', 'counter', {
        translations: {
    		en: {
    			"words": "words",
    			"chars": "chars"
    		}
        },
        init: function(app)
        {
            this.app = app;
            this.lang = app.lang;
            this.utils = app.utils;
            this.editor = app.editor;
            this.statusbar = app.statusbar;
        },
        // public
        start: function()
        {
            var $editor = this.editor.getElement();
            $editor.on('keyup.redactor-plugin-counter', this.count.bind(this));

            this.count();
        },
        stop: function()
        {
            var $editor = this.editor.getElement();
            $editor.off('.redactor-plugin-counter');

            this.statusbar.remove('words');
            this.statusbar.remove('chars');
        },
		count: function()
		{
			var words = 0, characters = 0, spaces = 0;
			var $editor = this.editor.getElement();
			var html = $editor.html();

			html = this._clean(html)
			if (html !== '')
			{
				var arrWords = html.split(/\s+/);
				var arrSpaces = html.match(/\s/g);

				words = (arrWords) ? arrWords.length : 0;
				spaces = (arrSpaces) ? arrSpaces.length : 0;

				characters = html.length;
			}

            var data = { words: words, characters: characters, spaces: spaces };

            // callback
			this.app.broadcast('counter', data);

            // statusbar
            this.statusbar.add('words', this.lang.get('words') + ': ' + data.words);
            this.statusbar.add('chars', this.lang.get('chars') + ': ' + data.characters);
		},

        // private
        _clean: function(html)
        {
			html = html.replace(/<\/(.*?)>/gi, ' ');
			html = html.replace(/<(.*?)>/gi, '');
			html = html.replace(/\t/gi, '');
			html = html.replace(/\n/gi, ' ');
			html = html.replace(/\r/gi, ' ');
			html = html.replace(/&nbsp;/g, '1');
			html = html.trim();
			html = this.utils.removeInvisibleChars(html);

			return html;
        }
    });
})(Redactor);
/* -------- studio/v2/js/redactor/redactor/plugins/limiter/limiter.js -------- */
(function($R)
{
    $R.add('plugin', 'limiter', {
        init: function(app)
        {
            this.app = app;
            this.utils = app.utils;
            this.opts = app.opts;
            this.editor = app.editor;
            this.keycodes = app.keycodes;
        },
        // events
        onpasting: function(html)
        {
            if (!this.opts.limiter) return;

            html = this.utils.removeInvisibleChars(html);

            var text = this._getText();
            var len = html.length + text.length;

			this.opts.input = !(len >= this.opts.limiter);
        },
        // public
        start: function()
        {
			if (!this.opts.limiter) return;
            this._count();

            var $editor = this.editor.getElement();
            $editor.on('keydown.redactor-plugin-limiter', this._limit.bind(this));
		},
		stop: function()
		{
            var $editor = this.editor.getElement();
            $editor.off('.redactor-plugin-limiter');

            this.opts.input = true;
		},

		// private
		_limit: function(e)
		{
    		var key = e.which;
			var ctrl = e.ctrlKey || e.metaKey;
			var arrows = [37, 38, 39, 40];

			if (key === this.keycodes.BACKSPACE
			   	|| key === this.keycodes.DELETE
			    || key === this.keycodes.ESC
			    || key === this.keycodes.SHIFT
			    || (ctrl && key === 65)
			    || (ctrl && key === 88)
			    || (ctrl && key === 82)
			    || (ctrl && key === 116)
			    || (arrows.indexOf(key) !== -1)
			)
			{
				return;
			}

            this._count(e);
		},
		_count: function(e)
		{
            var text = this._getText();
			var count = text.length;
			if (count >= this.opts.limiter)
			{
                if (e) e.preventDefault();
                this.opts.input = false;
				return false;
			}
			else
			{
    			this.opts.input = true;
			}
		},
		_getText: function()
		{
            var $editor = this.editor.getElement();
			var text = $editor.text();

			return this.utils.removeInvisibleChars(text);
		}
    });
})(Redactor);
/* -------- studio/v2/js/braintree-web/dist/browser/index.js -------- */
(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.braintree = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(_dereq_,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromiseGlobal = void 0;
var promise_polyfill_1 = __importDefault(_dereq_("promise-polyfill"));
var PromiseGlobal = 
// eslint-disable-next-line no-undef
typeof Promise !== "undefined" ? Promise : promise_polyfill_1.default;
exports.PromiseGlobal = PromiseGlobal;

},{"promise-polyfill":68}],2:[function(_dereq_,module,exports){
"use strict";
var promise_1 = _dereq_("./lib/promise");
var scriptPromiseCache = {};
function loadScript(options) {
    var scriptLoadPromise;
    var stringifiedOptions = JSON.stringify(options);
    if (!options.forceScriptReload) {
        scriptLoadPromise = scriptPromiseCache[stringifiedOptions];
        if (scriptLoadPromise) {
            return scriptLoadPromise;
        }
    }
    var script = document.createElement("script");
    var attrs = options.dataAttributes || {};
    var container = options.container || document.head;
    script.src = options.src;
    script.id = options.id || "";
    script.async = true;
    if (options.crossorigin) {
        script.setAttribute("crossorigin", "" + options.crossorigin);
    }
    Object.keys(attrs).forEach(function (key) {
        script.setAttribute("data-" + key, "" + attrs[key]);
    });
    scriptLoadPromise = new promise_1.PromiseGlobal(function (resolve, reject) {
        script.addEventListener("load", function () {
            resolve(script);
        });
        script.addEventListener("error", function () {
            reject(new Error(options.src + " failed to load."));
        });
        script.addEventListener("abort", function () {
            reject(new Error(options.src + " has aborted."));
        });
        container.appendChild(script);
    });
    scriptPromiseCache[stringifiedOptions] = scriptLoadPromise;
    return scriptLoadPromise;
}
loadScript.clearCache = function () {
    scriptPromiseCache = {};
};
module.exports = loadScript;

},{"./lib/promise":1}],3:[function(_dereq_,module,exports){
module.exports = _dereq_("./dist/load-script");

},{"./dist/load-script":2}],4:[function(_dereq_,module,exports){
"use strict";
module.exports = function isAndroid(ua) {
    ua = ua || window.navigator.userAgent;
    return /Android/i.test(ua);
};

},{}],5:[function(_dereq_,module,exports){
"use strict";
module.exports = function isChromeOS(ua) {
    ua = ua || window.navigator.userAgent;
    return /CrOS/i.test(ua);
};

},{}],6:[function(_dereq_,module,exports){
"use strict";
var isEdge = _dereq_("./is-edge");
var isSamsung = _dereq_("./is-samsung");
var isDuckDuckGo = _dereq_("./is-duckduckgo");
var isOpera = _dereq_("./is-opera");
var isSilk = _dereq_("./is-silk");
module.exports = function isChrome(ua) {
    ua = ua || window.navigator.userAgent;
    return ((ua.indexOf("Chrome") !== -1 || ua.indexOf("CriOS") !== -1) &&
        !isEdge(ua) &&
        !isSamsung(ua) &&
        !isDuckDuckGo(ua) &&
        !isOpera(ua) &&
        !isSilk(ua));
};

},{"./is-duckduckgo":7,"./is-edge":8,"./is-opera":18,"./is-samsung":19,"./is-silk":20}],7:[function(_dereq_,module,exports){
"use strict";
module.exports = function isDuckDuckGo(ua) {
    ua = ua || window.navigator.userAgent;
    return ua.indexOf("DuckDuckGo/") !== -1;
};

},{}],8:[function(_dereq_,module,exports){
"use strict";
module.exports = function isEdge(ua) {
    ua = ua || window.navigator.userAgent;
    return ua.indexOf("Edge/") !== -1;
};

},{}],9:[function(_dereq_,module,exports){
"use strict";
module.exports = function isFirefox(ua) {
    ua = ua || window.navigator.userAgent;
    return /Firefox/i.test(ua);
};

},{}],10:[function(_dereq_,module,exports){
"use strict";
module.exports = function isIe9(ua) {
    ua = ua || window.navigator.userAgent;
    return ua.indexOf("MSIE 9") !== -1;
};

},{}],11:[function(_dereq_,module,exports){
"use strict";
module.exports = function isIosFirefox(ua) {
    ua = ua || window.navigator.userAgent;
    return /FxiOS/i.test(ua);
};

},{}],12:[function(_dereq_,module,exports){
"use strict";
var isIos = _dereq_("./is-ios");
function isGoogleSearchApp(ua) {
    return /\bGSA\b/.test(ua);
}
module.exports = function isIosGoogleSearchApp(ua) {
    ua = ua || window.navigator.userAgent;
    return isIos(ua) && isGoogleSearchApp(ua);
};

},{"./is-ios":16}],13:[function(_dereq_,module,exports){
"use strict";
var isIos = _dereq_("./is-ios");
var isIosFirefox = _dereq_("./is-ios-firefox");
var webkitRegexp = /webkit/i;
function isWebkit(ua) {
    return webkitRegexp.test(ua);
}
function isIosChrome(ua) {
    return ua.indexOf("CriOS") > -1;
}
function isFacebook(ua) {
    return ua.indexOf("FBAN") > -1;
}
module.exports = function isIosSafari(ua) {
    ua = ua || window.navigator.userAgent;
    return (isIos(ua) &&
        isWebkit(ua) &&
        !isIosChrome(ua) &&
        !isIosFirefox(ua) &&
        !isFacebook(ua));
};

},{"./is-ios":16,"./is-ios-firefox":11}],14:[function(_dereq_,module,exports){
"use strict";
var isIos = _dereq_("./is-ios");
var isIosGoogleSearchApp = _dereq_("./is-ios-google-search-app");
module.exports = function isIosWebview(ua) {
    ua = ua || window.navigator.userAgent;
    if (isIos(ua)) {
        // The Google Search iOS app is technically a webview and doesn't support popups.
        if (isIosGoogleSearchApp(ua)) {
            return true;
        }
        // Historically, a webview could be identified by the presence of AppleWebKit and _no_ presence of Safari after.
        return /.+AppleWebKit(?!.*Safari)/i.test(ua);
    }
    return false;
};

},{"./is-ios":16,"./is-ios-google-search-app":12}],15:[function(_dereq_,module,exports){
"use strict";
var isIosWebview = _dereq_("./is-ios-webview");
module.exports = function isIosWKWebview(ua, statusBarVisible) {
    statusBarVisible =
        typeof statusBarVisible !== "undefined"
            ? statusBarVisible
            : window.statusbar.visible;
    return isIosWebview(ua) && statusBarVisible;
};

},{"./is-ios-webview":14}],16:[function(_dereq_,module,exports){
"use strict";
var isIpadOS = _dereq_("./is-ipados");
module.exports = function isIos(ua, checkIpadOS, document) {
    if (checkIpadOS === void 0) { checkIpadOS = true; }
    ua = ua || window.navigator.userAgent;
    var iOsTest = /iPhone|iPod|iPad/i.test(ua);
    return checkIpadOS ? iOsTest || isIpadOS(ua, document) : iOsTest;
};

},{"./is-ipados":17}],17:[function(_dereq_,module,exports){
"use strict";
module.exports = function isIpadOS(ua, document) {
    ua = ua || window.navigator.userAgent;
    document = document || window.document;
    // "ontouchend" is used to determine if a browser is on an iPad, otherwise
    // user-agents for iPadOS behave/identify as a desktop browser
    return /Mac|iPad/i.test(ua) && "ontouchend" in document;
};

},{}],18:[function(_dereq_,module,exports){
"use strict";
module.exports = function isOpera(ua) {
    ua = ua || window.navigator.userAgent;
    return (ua.indexOf("OPR/") !== -1 ||
        ua.indexOf("Opera/") !== -1 ||
        ua.indexOf("OPT/") !== -1);
};

},{}],19:[function(_dereq_,module,exports){
"use strict";
module.exports = function isSamsungBrowser(ua) {
    ua = ua || window.navigator.userAgent;
    return /SamsungBrowser/i.test(ua);
};

},{}],20:[function(_dereq_,module,exports){
"use strict";
module.exports = function isSilk(ua) {
    ua = ua || window.navigator.userAgent;
    return ua.indexOf("Silk/") !== -1;
};

},{}],21:[function(_dereq_,module,exports){
"use strict";
var MINIMUM_SUPPORTED_CHROME_IOS_VERSION = 48;
var isAndroid = _dereq_("./is-android");
var isIosFirefox = _dereq_("./is-ios-firefox");
var isIosWebview = _dereq_("./is-ios-webview");
var isChrome = _dereq_("./is-chrome");
var isSamsungBrowser = _dereq_("./is-samsung");
var isDuckDuckGo = _dereq_("./is-duckduckgo");
function isUnsupportedIosChrome(ua) {
    ua = ua || window.navigator.userAgent;
    var match = ua.match(/CriOS\/(\d+)\./);
    if (!match) {
        return false;
    }
    var version = parseInt(match[1], 10);
    return version < MINIMUM_SUPPORTED_CHROME_IOS_VERSION;
}
function isOperaMini(ua) {
    ua = ua || window.navigator.userAgent;
    return ua.indexOf("Opera Mini") > -1;
}
function isAndroidWebview(ua) {
    var androidWebviewRegExp = /Version\/[\d.]+/i;
    ua = ua || window.navigator.userAgent;
    if (isAndroid(ua)) {
        return (androidWebviewRegExp.test(ua) && !isOperaMini(ua) && !isDuckDuckGo(ua));
    }
    return false;
}
function isOldSamsungBrowserOrSamsungWebview(ua) {
    return !isChrome(ua) && !isSamsungBrowser(ua) && /samsung/i.test(ua);
}
module.exports = function supportsPopups(ua) {
    ua = ua || window.navigator.userAgent;
    return !(isIosWebview(ua) ||
        isIosFirefox(ua) ||
        isAndroidWebview(ua) ||
        isOperaMini(ua) ||
        isUnsupportedIosChrome(ua) ||
        isOldSamsungBrowserOrSamsungWebview(ua));
};

},{"./is-android":4,"./is-chrome":6,"./is-duckduckgo":7,"./is-ios-firefox":11,"./is-ios-webview":14,"./is-samsung":19}],22:[function(_dereq_,module,exports){
module.exports = _dereq_("./dist/is-android");

},{"./dist/is-android":4}],23:[function(_dereq_,module,exports){
module.exports = _dereq_("./dist/is-chrome-os");

},{"./dist/is-chrome-os":5}],24:[function(_dereq_,module,exports){
module.exports = _dereq_("./dist/is-chrome");

},{"./dist/is-chrome":6}],25:[function(_dereq_,module,exports){
module.exports = _dereq_("./dist/is-firefox");

},{"./dist/is-firefox":9}],26:[function(_dereq_,module,exports){
module.exports = _dereq_("./dist/is-ie9");

},{"./dist/is-ie9":10}],27:[function(_dereq_,module,exports){
module.exports = _dereq_("./dist/is-ios-safari");

},{"./dist/is-ios-safari":13}],28:[function(_dereq_,module,exports){
module.exports = _dereq_("./dist/is-ios-webview");

},{"./dist/is-ios-webview":14}],29:[function(_dereq_,module,exports){
module.exports = _dereq_("./dist/is-ios-wkwebview");

},{"./dist/is-ios-wkwebview":15}],30:[function(_dereq_,module,exports){
module.exports = _dereq_("./dist/is-ios");

},{"./dist/is-ios":16}],31:[function(_dereq_,module,exports){
module.exports = _dereq_("./dist/is-samsung");

},{"./dist/is-samsung":19}],32:[function(_dereq_,module,exports){
module.exports = _dereq_("./dist/supports-popups");

},{"./dist/supports-popups":21}],33:[function(_dereq_,module,exports){
"use strict";
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this._events = {};
    }
    EventEmitter.prototype.on = function (event, callback) {
        if (this._events[event]) {
            this._events[event].push(callback);
        }
        else {
            this._events[event] = [callback];
        }
    };
    EventEmitter.prototype.off = function (event, callback) {
        var eventCallbacks = this._events[event];
        if (!eventCallbacks) {
            return;
        }
        var indexOfCallback = eventCallbacks.indexOf(callback);
        eventCallbacks.splice(indexOfCallback, 1);
    };
    EventEmitter.prototype._emit = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var eventCallbacks = this._events[event];
        if (!eventCallbacks) {
            return;
        }
        eventCallbacks.forEach(function (callback) {
            callback.apply(void 0, args);
        });
    };
    EventEmitter.prototype.hasListener = function (event) {
        var eventCallbacks = this._events[event];
        if (!eventCallbacks) {
            return false;
        }
        return eventCallbacks.length > 0;
    };
    EventEmitter.createChild = function (ChildObject) {
        ChildObject.prototype = Object.create(EventEmitter.prototype, {
            constructor: ChildObject,
        });
    };
    return EventEmitter;
}());
module.exports = EventEmitter;

},{}],34:[function(_dereq_,module,exports){
"use strict";
var GlobalPromise = (typeof Promise !== "undefined"
    ? Promise // eslint-disable-line no-undef
    : null);
var ExtendedPromise = /** @class */ (function () {
    function ExtendedPromise(options) {
        var _this = this;
        if (typeof options === "function") {
            this._promise = new ExtendedPromise.Promise(options);
            return;
        }
        this._promise = new ExtendedPromise.Promise(function (resolve, reject) {
            _this._resolveFunction = resolve;
            _this._rejectFunction = reject;
        });
        options = options || {};
        this._onResolve = options.onResolve || ExtendedPromise.defaultOnResolve;
        this._onReject = options.onReject || ExtendedPromise.defaultOnReject;
        if (ExtendedPromise.shouldCatchExceptions(options)) {
            this._promise.catch(function () {
                // prevents unhandled promise rejection warning
                // in the console for extended promises that
                // that catch the error in an asynchronous manner
            });
        }
        this._resetState();
    }
    ExtendedPromise.defaultOnResolve = function (result) {
        return ExtendedPromise.Promise.resolve(result);
    };
    ExtendedPromise.defaultOnReject = function (err) {
        return ExtendedPromise.Promise.reject(err);
    };
    ExtendedPromise.setPromise = function (PromiseClass) {
        ExtendedPromise.Promise = PromiseClass;
    };
    ExtendedPromise.shouldCatchExceptions = function (options) {
        if (options.hasOwnProperty("suppressUnhandledPromiseMessage")) {
            return Boolean(options.suppressUnhandledPromiseMessage);
        }
        return Boolean(ExtendedPromise.suppressUnhandledPromiseMessage);
    };
    // start Promise methods documented in:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise#Methods
    ExtendedPromise.all = function (args) {
        return ExtendedPromise.Promise.all(args);
    };
    ExtendedPromise.allSettled = function (args) {
        return ExtendedPromise.Promise.allSettled(args);
    };
    ExtendedPromise.race = function (args) {
        return ExtendedPromise.Promise.race(args);
    };
    ExtendedPromise.reject = function (arg) {
        return ExtendedPromise.Promise.reject(arg);
    };
    ExtendedPromise.resolve = function (arg) {
        return ExtendedPromise.Promise.resolve(arg);
    };
    ExtendedPromise.prototype.then = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = this._promise).then.apply(_a, args);
    };
    ExtendedPromise.prototype.catch = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = this._promise).catch.apply(_a, args);
    };
    ExtendedPromise.prototype.resolve = function (arg) {
        var _this = this;
        if (this.isFulfilled) {
            return this;
        }
        this._setResolved();
        ExtendedPromise.Promise.resolve()
            .then(function () {
            return _this._onResolve(arg);
        })
            .then(function (argForResolveFunction) {
            _this._resolveFunction(argForResolveFunction);
        })
            .catch(function (err) {
            _this._resetState();
            _this.reject(err);
        });
        return this;
    };
    ExtendedPromise.prototype.reject = function (arg) {
        var _this = this;
        if (this.isFulfilled) {
            return this;
        }
        this._setRejected();
        ExtendedPromise.Promise.resolve()
            .then(function () {
            return _this._onReject(arg);
        })
            .then(function (result) {
            _this._setResolved();
            _this._resolveFunction(result);
        })
            .catch(function (err) {
            return _this._rejectFunction(err);
        });
        return this;
    };
    ExtendedPromise.prototype._resetState = function () {
        this.isFulfilled = false;
        this.isResolved = false;
        this.isRejected = false;
    };
    ExtendedPromise.prototype._setResolved = function () {
        this.isFulfilled = true;
        this.isResolved = true;
        this.isRejected = false;
    };
    ExtendedPromise.prototype._setRejected = function () {
        this.isFulfilled = true;
        this.isResolved = false;
        this.isRejected = true;
    };
    ExtendedPromise.Promise = GlobalPromise;
    return ExtendedPromise;
}());
module.exports = ExtendedPromise;

},{}],35:[function(_dereq_,module,exports){
"use strict";
var set_attributes_1 = _dereq_("./lib/set-attributes");
var default_attributes_1 = _dereq_("./lib/default-attributes");
var assign_1 = _dereq_("./lib/assign");
module.exports = function createFrame(options) {
    if (options === void 0) { options = {}; }
    var iframe = document.createElement("iframe");
    var config = assign_1.assign({}, default_attributes_1.defaultAttributes, options);
    if (config.style && typeof config.style !== "string") {
        assign_1.assign(iframe.style, config.style);
        delete config.style;
    }
    set_attributes_1.setAttributes(iframe, config);
    if (!iframe.getAttribute("id")) {
        iframe.id = iframe.name;
    }
    return iframe;
};

},{"./lib/assign":36,"./lib/default-attributes":37,"./lib/set-attributes":38}],36:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assign = void 0;
function assign(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
target) {
    var objs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        objs[_i - 1] = arguments[_i];
    }
    objs.forEach(function (obj) {
        if (typeof obj !== "object") {
            return;
        }
        Object.keys(obj).forEach(function (key) {
            target[key] = obj[key];
        });
    });
    return target;
}
exports.assign = assign;

},{}],37:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultAttributes = void 0;
exports.defaultAttributes = {
    src: "about:blank",
    frameBorder: 0,
    allowtransparency: true,
    scrolling: "no",
};

},{}],38:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAttributes = void 0;
function setAttributes(element, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
attributes) {
    for (var key in attributes) {
        if (attributes.hasOwnProperty(key)) {
            var value = attributes[key];
            if (value == null) {
                element.removeAttribute(key);
            }
            else {
                element.setAttribute(key, value);
            }
        }
    }
}
exports.setAttributes = setAttributes;

},{}],39:[function(_dereq_,module,exports){
'use strict';

function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;

    return v.toString(16);
  });
}

module.exports = uuid;

},{}],40:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function deferred(fn) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        setTimeout(function () {
            try {
                fn.apply(void 0, args);
            }
            catch (err) {
                /* eslint-disable no-console */
                console.log("Error in callback function");
                console.log(err);
                /* eslint-enable no-console */
            }
        }, 1);
    };
}
exports.deferred = deferred;

},{}],41:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function once(fn) {
    var called = false;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!called) {
            called = true;
            fn.apply(void 0, args);
        }
    };
}
exports.once = once;

},{}],42:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable consistent-return */
function promiseOrCallback(promise, callback) {
    if (!callback) {
        return promise;
    }
    promise.then(function (data) { return callback(null, data); }).catch(function (err) { return callback(err); });
}
exports.promiseOrCallback = promiseOrCallback;

},{}],43:[function(_dereq_,module,exports){
"use strict";
var deferred_1 = _dereq_("./lib/deferred");
var once_1 = _dereq_("./lib/once");
var promise_or_callback_1 = _dereq_("./lib/promise-or-callback");
function wrapPromise(fn) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var callback;
        var lastArg = args[args.length - 1];
        if (typeof lastArg === "function") {
            callback = args.pop();
            callback = once_1.once(deferred_1.deferred(callback));
        }
        // I know, I know, this looks bad. But it's a quirk of the library that
        // we need to allow passing the this context to the original function
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore: this has an implicit any
        return promise_or_callback_1.promiseOrCallback(fn.apply(this, args), callback); // eslint-disable-line no-invalid-this
    };
}
wrapPromise.wrapPrototype = function (target, options) {
    if (options === void 0) { options = {}; }
    var ignoreMethods = options.ignoreMethods || [];
    var includePrivateMethods = options.transformPrivateMethods === true;
    var methods = Object.getOwnPropertyNames(target.prototype).filter(function (method) {
        var isNotPrivateMethod;
        var isNonConstructorFunction = method !== "constructor" &&
            typeof target.prototype[method] === "function";
        var isNotAnIgnoredMethod = ignoreMethods.indexOf(method) === -1;
        if (includePrivateMethods) {
            isNotPrivateMethod = true;
        }
        else {
            isNotPrivateMethod = method.charAt(0) !== "_";
        }
        return (isNonConstructorFunction && isNotPrivateMethod && isNotAnIgnoredMethod);
    });
    methods.forEach(function (method) {
        var original = target.prototype[method];
        target.prototype[method] = wrapPromise(original);
    });
    return target;
};
module.exports = wrapPromise;

},{"./lib/deferred":40,"./lib/once":41,"./lib/promise-or-callback":42}],44:[function(_dereq_,module,exports){
"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var cardTypes = _dereq_("./lib/card-types");
var add_matching_cards_to_results_1 = _dereq_("./lib/add-matching-cards-to-results");
var is_valid_input_type_1 = _dereq_("./lib/is-valid-input-type");
var find_best_match_1 = _dereq_("./lib/find-best-match");
var clone_1 = _dereq_("./lib/clone");
var customCards = {};
var cardNames = {
    VISA: "visa",
    MASTERCARD: "mastercard",
    AMERICAN_EXPRESS: "american-express",
    DINERS_CLUB: "diners-club",
    DISCOVER: "discover",
    JCB: "jcb",
    UNIONPAY: "unionpay",
    MAESTRO: "maestro",
    ELO: "elo",
    MIR: "mir",
    HIPER: "hiper",
    HIPERCARD: "hipercard",
};
var ORIGINAL_TEST_ORDER = [
    cardNames.VISA,
    cardNames.MASTERCARD,
    cardNames.AMERICAN_EXPRESS,
    cardNames.DINERS_CLUB,
    cardNames.DISCOVER,
    cardNames.JCB,
    cardNames.UNIONPAY,
    cardNames.MAESTRO,
    cardNames.ELO,
    cardNames.MIR,
    cardNames.HIPER,
    cardNames.HIPERCARD,
];
var testOrder = clone_1.clone(ORIGINAL_TEST_ORDER);
function findType(cardType) {
    return customCards[cardType] || cardTypes[cardType];
}
function getAllCardTypes() {
    return testOrder.map(function (cardType) { return clone_1.clone(findType(cardType)); });
}
function getCardPosition(name, ignoreErrorForNotExisting) {
    if (ignoreErrorForNotExisting === void 0) { ignoreErrorForNotExisting = false; }
    var position = testOrder.indexOf(name);
    if (!ignoreErrorForNotExisting && position === -1) {
        throw new Error('"' + name + '" is not a supported card type.');
    }
    return position;
}
function creditCardType(cardNumber) {
    var results = [];
    if (!is_valid_input_type_1.isValidInputType(cardNumber)) {
        return results;
    }
    if (cardNumber.length === 0) {
        return getAllCardTypes();
    }
    testOrder.forEach(function (cardType) {
        var cardConfiguration = findType(cardType);
        add_matching_cards_to_results_1.addMatchingCardsToResults(cardNumber, cardConfiguration, results);
    });
    var bestMatch = find_best_match_1.findBestMatch(results);
    if (bestMatch) {
        return [bestMatch];
    }
    return results;
}
creditCardType.getTypeInfo = function (cardType) {
    return clone_1.clone(findType(cardType));
};
creditCardType.removeCard = function (name) {
    var position = getCardPosition(name);
    testOrder.splice(position, 1);
};
creditCardType.addCard = function (config) {
    var existingCardPosition = getCardPosition(config.type, true);
    customCards[config.type] = config;
    if (existingCardPosition === -1) {
        testOrder.push(config.type);
    }
};
creditCardType.updateCard = function (cardType, updates) {
    var originalObject = customCards[cardType] || cardTypes[cardType];
    if (!originalObject) {
        throw new Error("\"" + cardType + "\" is not a recognized type. Use `addCard` instead.'");
    }
    if (updates.type && originalObject.type !== updates.type) {
        throw new Error("Cannot overwrite type parameter.");
    }
    var clonedCard = clone_1.clone(originalObject);
    clonedCard = __assign(__assign({}, clonedCard), updates);
    customCards[clonedCard.type] = clonedCard;
};
creditCardType.changeOrder = function (name, position) {
    var currentPosition = getCardPosition(name);
    testOrder.splice(currentPosition, 1);
    testOrder.splice(position, 0, name);
};
creditCardType.resetModifications = function () {
    testOrder = clone_1.clone(ORIGINAL_TEST_ORDER);
    customCards = {};
};
creditCardType.types = cardNames;
module.exports = creditCardType;

},{"./lib/add-matching-cards-to-results":45,"./lib/card-types":46,"./lib/clone":47,"./lib/find-best-match":48,"./lib/is-valid-input-type":49}],45:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addMatchingCardsToResults = void 0;
var clone_1 = _dereq_("./clone");
var matches_1 = _dereq_("./matches");
function addMatchingCardsToResults(cardNumber, cardConfiguration, results) {
    var i, patternLength;
    for (i = 0; i < cardConfiguration.patterns.length; i++) {
        var pattern = cardConfiguration.patterns[i];
        if (!matches_1.matches(cardNumber, pattern)) {
            continue;
        }
        var clonedCardConfiguration = clone_1.clone(cardConfiguration);
        if (Array.isArray(pattern)) {
            patternLength = String(pattern[0]).length;
        }
        else {
            patternLength = String(pattern).length;
        }
        if (cardNumber.length >= patternLength) {
            clonedCardConfiguration.matchStrength = patternLength;
        }
        results.push(clonedCardConfiguration);
        break;
    }
}
exports.addMatchingCardsToResults = addMatchingCardsToResults;

},{"./clone":47,"./matches":50}],46:[function(_dereq_,module,exports){
"use strict";
var cardTypes = {
    visa: {
        niceType: "Visa",
        type: "visa",
        patterns: [4],
        gaps: [4, 8, 12],
        lengths: [16, 18, 19],
        code: {
            name: "CVV",
            size: 3,
        },
    },
    mastercard: {
        niceType: "Mastercard",
        type: "mastercard",
        patterns: [[51, 55], [2221, 2229], [223, 229], [23, 26], [270, 271], 2720],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
            name: "CVC",
            size: 3,
        },
    },
    "american-express": {
        niceType: "American Express",
        type: "american-express",
        patterns: [34, 37],
        gaps: [4, 10],
        lengths: [15],
        code: {
            name: "CID",
            size: 4,
        },
    },
    "diners-club": {
        niceType: "Diners Club",
        type: "diners-club",
        patterns: [[300, 305], 36, 38, 39],
        gaps: [4, 10],
        lengths: [14, 16, 19],
        code: {
            name: "CVV",
            size: 3,
        },
    },
    discover: {
        niceType: "Discover",
        type: "discover",
        patterns: [6011, [644, 649], 65],
        gaps: [4, 8, 12],
        lengths: [16, 19],
        code: {
            name: "CID",
            size: 3,
        },
    },
    jcb: {
        niceType: "JCB",
        type: "jcb",
        patterns: [2131, 1800, [3528, 3589]],
        gaps: [4, 8, 12],
        lengths: [16, 17, 18, 19],
        code: {
            name: "CVV",
            size: 3,
        },
    },
    unionpay: {
        niceType: "UnionPay",
        type: "unionpay",
        patterns: [
            620,
            [624, 626],
            [62100, 62182],
            [62184, 62187],
            [62185, 62197],
            [62200, 62205],
            [622010, 622999],
            622018,
            [622019, 622999],
            [62207, 62209],
            [622126, 622925],
            [623, 626],
            6270,
            6272,
            6276,
            [627700, 627779],
            [627781, 627799],
            [6282, 6289],
            6291,
            6292,
            810,
            [8110, 8131],
            [8132, 8151],
            [8152, 8163],
            [8164, 8171],
        ],
        gaps: [4, 8, 12],
        lengths: [14, 15, 16, 17, 18, 19],
        code: {
            name: "CVN",
            size: 3,
        },
    },
    maestro: {
        niceType: "Maestro",
        type: "maestro",
        patterns: [
            493698,
            [500000, 504174],
            [504176, 506698],
            [506779, 508999],
            [56, 59],
            63,
            67,
            6,
        ],
        gaps: [4, 8, 12],
        lengths: [12, 13, 14, 15, 16, 17, 18, 19],
        code: {
            name: "CVC",
            size: 3,
        },
    },
    elo: {
        niceType: "Elo",
        type: "elo",
        patterns: [
            401178,
            401179,
            438935,
            457631,
            457632,
            431274,
            451416,
            457393,
            504175,
            [506699, 506778],
            [509000, 509999],
            627780,
            636297,
            636368,
            [650031, 650033],
            [650035, 650051],
            [650405, 650439],
            [650485, 650538],
            [650541, 650598],
            [650700, 650718],
            [650720, 650727],
            [650901, 650978],
            [651652, 651679],
            [655000, 655019],
            [655021, 655058],
        ],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
            name: "CVE",
            size: 3,
        },
    },
    mir: {
        niceType: "Mir",
        type: "mir",
        patterns: [[2200, 2204]],
        gaps: [4, 8, 12],
        lengths: [16, 17, 18, 19],
        code: {
            name: "CVP2",
            size: 3,
        },
    },
    hiper: {
        niceType: "Hiper",
        type: "hiper",
        patterns: [637095, 63737423, 63743358, 637568, 637599, 637609, 637612],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
            name: "CVC",
            size: 3,
        },
    },
    hipercard: {
        niceType: "Hipercard",
        type: "hipercard",
        patterns: [606282],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
            name: "CVC",
            size: 3,
        },
    },
};
module.exports = cardTypes;

},{}],47:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clone = void 0;
function clone(originalObject) {
    if (!originalObject) {
        return null;
    }
    return JSON.parse(JSON.stringify(originalObject));
}
exports.clone = clone;

},{}],48:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findBestMatch = void 0;
function hasEnoughResultsToDetermineBestMatch(results) {
    var numberOfResultsWithMaxStrengthProperty = results.filter(function (result) { return result.matchStrength; }).length;
    /*
     * if all possible results have a maxStrength property that means the card
     * number is sufficiently long enough to determine conclusively what the card
     * type is
     * */
    return (numberOfResultsWithMaxStrengthProperty > 0 &&
        numberOfResultsWithMaxStrengthProperty === results.length);
}
function findBestMatch(results) {
    if (!hasEnoughResultsToDetermineBestMatch(results)) {
        return null;
    }
    return results.reduce(function (bestMatch, result) {
        if (!bestMatch) {
            return result;
        }
        /*
         * If the current best match pattern is less specific than this result, set
         * the result as the new best match
         * */
        if (Number(bestMatch.matchStrength) < Number(result.matchStrength)) {
            return result;
        }
        return bestMatch;
    });
}
exports.findBestMatch = findBestMatch;

},{}],49:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidInputType = void 0;
function isValidInputType(cardNumber) {
    return typeof cardNumber === "string" || cardNumber instanceof String;
}
exports.isValidInputType = isValidInputType;

},{}],50:[function(_dereq_,module,exports){
"use strict";
/*
 * Adapted from https://github.com/polvo-labs/card-type/blob/aaab11f80fa1939bccc8f24905a06ae3cd864356/src/cardType.js#L37-L42
 * */
Object.defineProperty(exports, "__esModule", { value: true });
exports.matches = void 0;
function matchesRange(cardNumber, min, max) {
    var maxLengthToCheck = String(min).length;
    var substr = cardNumber.substr(0, maxLengthToCheck);
    var integerRepresentationOfCardNumber = parseInt(substr, 10);
    min = parseInt(String(min).substr(0, substr.length), 10);
    max = parseInt(String(max).substr(0, substr.length), 10);
    return (integerRepresentationOfCardNumber >= min &&
        integerRepresentationOfCardNumber <= max);
}
function matchesPattern(cardNumber, pattern) {
    pattern = String(pattern);
    return (pattern.substring(0, cardNumber.length) ===
        cardNumber.substring(0, pattern.length));
}
function matches(cardNumber, pattern) {
    if (Array.isArray(pattern)) {
        return matchesRange(cardNumber, pattern[0], pattern[1]);
    }
    return matchesPattern(cardNumber, pattern);
}
exports.matches = matches;

},{}],51:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Framebus = void 0;
var lib_1 = _dereq_("./lib");
var DefaultPromise = (typeof window !== "undefined" &&
    window.Promise);
var Framebus = /** @class */ (function () {
    function Framebus(options) {
        if (options === void 0) { options = {}; }
        this.origin = options.origin || "*";
        this.channel = options.channel || "";
        this.verifyDomain = options.verifyDomain;
        // if a targetFrames configuration is not passed in,
        // the default behavior is to broadcast the payload
        // to the top level window or to the frame itself.
        // By default, the broadcast function will loop through
        // all the known siblings and children of the window.
        // If a targetFrames array is passed, it will instead
        // only broadcast to those specified targetFrames
        this.targetFrames = options.targetFrames || [];
        this.limitBroadcastToFramesArray = Boolean(options.targetFrames);
        this.isDestroyed = false;
        this.listeners = [];
        this.hasAdditionalChecksForOnListeners = Boolean(this.verifyDomain || this.limitBroadcastToFramesArray);
    }
    Framebus.setPromise = function (PromiseGlobal) {
        Framebus.Promise = PromiseGlobal;
    };
    Framebus.target = function (options) {
        return new Framebus(options);
    };
    Framebus.prototype.addTargetFrame = function (frame) {
        if (!this.limitBroadcastToFramesArray) {
            return;
        }
        this.targetFrames.push(frame);
    };
    Framebus.prototype.include = function (childWindow) {
        if (childWindow == null) {
            return false;
        }
        if (childWindow.Window == null) {
            return false;
        }
        if (childWindow.constructor !== childWindow.Window) {
            return false;
        }
        lib_1.childWindows.push(childWindow);
        return true;
    };
    Framebus.prototype.target = function (options) {
        return Framebus.target(options);
    };
    Framebus.prototype.emit = function (eventName, data, reply) {
        if (this.isDestroyed) {
            return false;
        }
        var origin = this.origin;
        eventName = this.namespaceEvent(eventName);
        if ((0, lib_1.isntString)(eventName)) {
            return false;
        }
        if ((0, lib_1.isntString)(origin)) {
            return false;
        }
        if (typeof data === "function") {
            reply = data;
            data = undefined; // eslint-disable-line no-undefined
        }
        var payload = (0, lib_1.packagePayload)(eventName, origin, data, reply);
        if (!payload) {
            return false;
        }
        if (this.limitBroadcastToFramesArray) {
            this.targetFramesAsWindows().forEach(function (frame) {
                (0, lib_1.sendMessage)(frame, payload, origin);
            });
        }
        else {
            (0, lib_1.broadcast)(payload, {
                origin: origin,
                frame: window.top || window.self,
            });
        }
        return true;
    };
    Framebus.prototype.emitAsPromise = function (eventName, data) {
        var _this = this;
        return new Framebus.Promise(function (resolve, reject) {
            var didAttachListener = _this.emit(eventName, data, function (payload) {
                resolve(payload);
            });
            if (!didAttachListener) {
                reject(new Error("Listener not added for \"".concat(eventName, "\"")));
            }
        });
    };
    Framebus.prototype.on = function (eventName, originalHandler) {
        if (this.isDestroyed) {
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var self = this;
        var origin = this.origin;
        var handler = originalHandler;
        eventName = this.namespaceEvent(eventName);
        if ((0, lib_1.subscriptionArgsInvalid)(eventName, handler, origin)) {
            return false;
        }
        if (this.hasAdditionalChecksForOnListeners) {
            /* eslint-disable no-invalid-this, @typescript-eslint/ban-ts-comment */
            handler = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                // @ts-ignore
                if (!self.passesVerifyDomainCheck(this && this.origin)) {
                    return;
                }
                // @ts-ignore
                if (!self.hasMatchingTargetFrame(this && this.source)) {
                    return;
                }
                originalHandler.apply(void 0, args);
            };
            /* eslint-enable no-invalid-this, @typescript-eslint/ban-ts-comment */
        }
        this.listeners.push({
            eventName: eventName,
            handler: handler,
            originalHandler: originalHandler,
        });
        lib_1.subscribers[origin] = lib_1.subscribers[origin] || {};
        lib_1.subscribers[origin][eventName] = lib_1.subscribers[origin][eventName] || [];
        lib_1.subscribers[origin][eventName].push(handler);
        return true;
    };
    Framebus.prototype.off = function (eventName, originalHandler) {
        var handler = originalHandler;
        if (this.isDestroyed) {
            return false;
        }
        if (this.verifyDomain) {
            for (var i = 0; i < this.listeners.length; i++) {
                var listener = this.listeners[i];
                if (listener.originalHandler === originalHandler) {
                    handler = listener.handler;
                }
            }
        }
        eventName = this.namespaceEvent(eventName);
        var origin = this.origin;
        if ((0, lib_1.subscriptionArgsInvalid)(eventName, handler, origin)) {
            return false;
        }
        var subscriberList = lib_1.subscribers[origin] && lib_1.subscribers[origin][eventName];
        if (!subscriberList) {
            return false;
        }
        for (var i = 0; i < subscriberList.length; i++) {
            if (subscriberList[i] === handler) {
                subscriberList.splice(i, 1);
                return true;
            }
        }
        return false;
    };
    Framebus.prototype.teardown = function () {
        if (this.isDestroyed) {
            return;
        }
        this.isDestroyed = true;
        for (var i = 0; i < this.listeners.length; i++) {
            var listener = this.listeners[i];
            this.off(listener.eventName, listener.handler);
        }
        this.listeners.length = 0;
    };
    Framebus.prototype.passesVerifyDomainCheck = function (origin) {
        if (!this.verifyDomain) {
            // always pass this check if no verifyDomain option was set
            return true;
        }
        return this.checkOrigin(origin);
    };
    Framebus.prototype.targetFramesAsWindows = function () {
        if (!this.limitBroadcastToFramesArray) {
            return [];
        }
        return this.targetFrames
            .map(function (frame) {
            // we can't pull off the contentWindow
            // when the iframe is originally added
            // to the array, because if it is not
            // in the DOM at that time, it will have
            // a contentWindow of `null`
            if (frame instanceof HTMLIFrameElement) {
                return frame.contentWindow;
            }
            return frame;
        })
            .filter(function (win) {
            // just in case an iframe element
            // was removed from the DOM
            // and the contentWindow property
            // is null
            return win;
        });
    };
    Framebus.prototype.hasMatchingTargetFrame = function (source) {
        if (!this.limitBroadcastToFramesArray) {
            // always pass this check if we aren't limiting to the target frames
            return true;
        }
        var matchingFrame = this.targetFramesAsWindows().find(function (frame) {
            return frame === source;
        });
        return Boolean(matchingFrame);
    };
    Framebus.prototype.checkOrigin = function (postMessageOrigin) {
        var merchantHost;
        var a = document.createElement("a");
        a.href = location.href;
        if (a.protocol === "https:") {
            merchantHost = a.host.replace(/:443$/, "");
        }
        else if (a.protocol === "http:") {
            merchantHost = a.host.replace(/:80$/, "");
        }
        else {
            merchantHost = a.host;
        }
        var merchantOrigin = a.protocol + "//" + merchantHost;
        if (merchantOrigin === postMessageOrigin) {
            return true;
        }
        if (this.verifyDomain) {
            return this.verifyDomain(postMessageOrigin);
        }
        return true;
    };
    Framebus.prototype.namespaceEvent = function (eventName) {
        if (!this.channel) {
            return eventName;
        }
        return "".concat(this.channel, ":").concat(eventName);
    };
    Framebus.Promise = DefaultPromise;
    return Framebus;
}());
exports.Framebus = Framebus;

},{"./lib":59}],52:[function(_dereq_,module,exports){
"use strict";
var lib_1 = _dereq_("./lib");
var framebus_1 = _dereq_("./framebus");
(0, lib_1.attach)();
module.exports = framebus_1.Framebus;

},{"./framebus":51,"./lib":59}],53:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detach = exports.attach = void 0;
var _1 = _dereq_("./");
var isAttached = false;
function attach() {
    if (isAttached || typeof window === "undefined") {
        return;
    }
    isAttached = true;
    window.addEventListener("message", _1.onMessage, false);
}
exports.attach = attach;
// removeIf(production)
function detach() {
    isAttached = false;
    window.removeEventListener("message", _1.onMessage, false);
}
exports.detach = detach;
// endRemoveIf(production)

},{"./":59}],54:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.broadcastToChildWindows = void 0;
var _1 = _dereq_("./");
function broadcastToChildWindows(payload, origin, source) {
    for (var i = _1.childWindows.length - 1; i >= 0; i--) {
        var childWindow = _1.childWindows[i];
        if (childWindow.closed) {
            _1.childWindows.splice(i, 1);
        }
        else if (source !== childWindow) {
            (0, _1.broadcast)(payload, {
                origin: origin,
                frame: childWindow.top,
            });
        }
    }
}
exports.broadcastToChildWindows = broadcastToChildWindows;

},{"./":59}],55:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.broadcast = void 0;
var _1 = _dereq_("./");
function broadcast(payload, options) {
    var i = 0;
    var frameToBroadcastTo;
    var origin = options.origin, frame = options.frame;
    try {
        frame.postMessage(payload, origin);
        if ((0, _1.hasOpener)(frame) && frame.opener.top !== window.top) {
            broadcast(payload, {
                origin: origin,
                frame: frame.opener.top,
            });
        }
        // previously, our max value was frame.frames.length
        // but frames.length inherits from window.length
        // which can be overwritten if a developer does
        // `var length = value;` outside of a function
        // scope, it'll prevent us from looping through
        // all the frames. With this, we loop through
        // until there are no longer any frames
        // eslint-disable-next-line no-cond-assign
        while ((frameToBroadcastTo = frame.frames[i])) {
            broadcast(payload, {
                origin: origin,
                frame: frameToBroadcastTo,
            });
            i++;
        }
    }
    catch (_) {
        /* ignored */
    }
}
exports.broadcast = broadcast;

},{"./":59}],56:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribers = exports.childWindows = exports.prefix = void 0;
exports.prefix = "/*framebus*/";
exports.childWindows = [];
exports.subscribers = {};

},{}],57:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dispatch = void 0;
var _1 = _dereq_("./");
function dispatch(origin, event, data, reply, e) {
    if (!_1.subscribers[origin]) {
        return;
    }
    if (!_1.subscribers[origin][event]) {
        return;
    }
    var args = [];
    if (data) {
        args.push(data);
    }
    if (reply) {
        args.push(reply);
    }
    for (var i = 0; i < _1.subscribers[origin][event].length; i++) {
        _1.subscribers[origin][event][i].apply(e, args);
    }
}
exports.dispatch = dispatch;

},{"./":59}],58:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasOpener = void 0;
function hasOpener(frame) {
    if (frame.top !== frame) {
        return false;
    }
    if (frame.opener == null) {
        return false;
    }
    if (frame.opener === frame) {
        return false;
    }
    if (frame.opener.closed === true) {
        return false;
    }
    return true;
}
exports.hasOpener = hasOpener;

},{}],59:[function(_dereq_,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(_dereq_("./attach"), exports);
__exportStar(_dereq_("./broadcast-to-child-windows"), exports);
__exportStar(_dereq_("./broadcast"), exports);
__exportStar(_dereq_("./constants"), exports);
__exportStar(_dereq_("./dispatch"), exports);
__exportStar(_dereq_("./has-opener"), exports);
__exportStar(_dereq_("./is-not-string"), exports);
__exportStar(_dereq_("./message"), exports);
__exportStar(_dereq_("./package-payload"), exports);
__exportStar(_dereq_("./send-message"), exports);
__exportStar(_dereq_("./subscribe-replier"), exports);
__exportStar(_dereq_("./subscription-args-invalid"), exports);
__exportStar(_dereq_("./types"), exports);
__exportStar(_dereq_("./unpack-payload"), exports);

},{"./attach":53,"./broadcast":55,"./broadcast-to-child-windows":54,"./constants":56,"./dispatch":57,"./has-opener":58,"./is-not-string":60,"./message":61,"./package-payload":62,"./send-message":63,"./subscribe-replier":64,"./subscription-args-invalid":65,"./types":66,"./unpack-payload":67}],60:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isntString = void 0;
function isntString(str) {
    return typeof str !== "string";
}
exports.isntString = isntString;

},{}],61:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onMessage = void 0;
var _1 = _dereq_("./");
function onMessage(e) {
    if ((0, _1.isntString)(e.data)) {
        return;
    }
    var payload = (0, _1.unpackPayload)(e);
    if (!payload) {
        return;
    }
    var data = payload.eventData;
    var reply = payload.reply;
    (0, _1.dispatch)("*", payload.event, data, reply, e);
    (0, _1.dispatch)(e.origin, payload.event, data, reply, e);
    (0, _1.broadcastToChildWindows)(e.data, payload.origin, e.source);
}
exports.onMessage = onMessage;

},{"./":59}],62:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.packagePayload = void 0;
var _1 = _dereq_("./");
function packagePayload(event, origin, data, reply) {
    var packaged;
    var payload = {
        event: event,
        origin: origin,
    };
    if (typeof reply === "function") {
        payload.reply = (0, _1.subscribeReplier)(reply, origin);
    }
    payload.eventData = data;
    try {
        packaged = _1.prefix + JSON.stringify(payload);
    }
    catch (e) {
        throw new Error("Could not stringify event: ".concat(e.message));
    }
    return packaged;
}
exports.packagePayload = packagePayload;

},{"./":59}],63:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessage = void 0;
/**
 * A basic function for wrapping the sending of postMessages to frames.
 */
function sendMessage(frame, payload, origin) {
    try {
        frame.postMessage(payload, origin);
    }
    catch (error) {
        /* ignored */
    }
}
exports.sendMessage = sendMessage;

},{}],64:[function(_dereq_,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeReplier = void 0;
var framebus_1 = _dereq_("../framebus");
var uuid_1 = __importDefault(_dereq_("@braintree/uuid"));
function subscribeReplier(fn, origin) {
    var uuid = (0, uuid_1.default)();
    function replier(data, replyOriginHandler) {
        fn(data, replyOriginHandler);
        framebus_1.Framebus.target({
            origin: origin,
        }).off(uuid, replier);
    }
    framebus_1.Framebus.target({
        origin: origin,
    }).on(uuid, replier);
    return uuid;
}
exports.subscribeReplier = subscribeReplier;

},{"../framebus":51,"@braintree/uuid":39}],65:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscriptionArgsInvalid = void 0;
var _1 = _dereq_("./");
function subscriptionArgsInvalid(event, fn, origin) {
    if ((0, _1.isntString)(event)) {
        return true;
    }
    if (typeof fn !== "function") {
        return true;
    }
    return (0, _1.isntString)(origin);
}
exports.subscriptionArgsInvalid = subscriptionArgsInvalid;

},{"./":59}],66:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

},{}],67:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unpackPayload = void 0;
var _1 = _dereq_("./");
function unpackPayload(e) {
    var payload;
    if (e.data.slice(0, _1.prefix.length) !== _1.prefix) {
        return false;
    }
    try {
        payload = JSON.parse(e.data.slice(_1.prefix.length));
    }
    catch (err) {
        return false;
    }
    if (payload.reply) {
        var replyOrigin_1 = e.origin;
        var replySource_1 = e.source;
        var replyEvent_1 = payload.reply;
        payload.reply = function reply(replyData) {
            if (!replySource_1) {
                return;
            }
            var replyPayload = (0, _1.packagePayload)(replyEvent_1, replyOrigin_1, replyData);
            if (!replyPayload) {
                return;
            }
            replySource_1.postMessage(replyPayload, replyOrigin_1);
        };
    }
    return payload;
}
exports.unpackPayload = unpackPayload;

},{"./":59}],68:[function(_dereq_,module,exports){
'use strict';

/**
 * @this {Promise}
 */
function finallyConstructor(callback) {
  var constructor = this.constructor;
  return this.then(
    function(value) {
      // @ts-ignore
      return constructor.resolve(callback()).then(function() {
        return value;
      });
    },
    function(reason) {
      // @ts-ignore
      return constructor.resolve(callback()).then(function() {
        // @ts-ignore
        return constructor.reject(reason);
      });
    }
  );
}

function allSettled(arr) {
  var P = this;
  return new P(function(resolve, reject) {
    if (!(arr && typeof arr.length !== 'undefined')) {
      return reject(
        new TypeError(
          typeof arr +
            ' ' +
            arr +
            ' is not iterable(cannot read property Symbol(Symbol.iterator))'
        )
      );
    }
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        var then = val.then;
        if (typeof then === 'function') {
          then.call(
            val,
            function(val) {
              res(i, val);
            },
            function(e) {
              args[i] = { status: 'rejected', reason: e };
              if (--remaining === 0) {
                resolve(args);
              }
            }
          );
          return;
        }
      }
      args[i] = { status: 'fulfilled', value: val };
      if (--remaining === 0) {
        resolve(args);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
}

// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function isArray(x) {
  return Boolean(x && typeof x.length !== 'undefined');
}

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

/**
 * @constructor
 * @param {Function} fn
 */
function Promise(fn) {
  if (!(this instanceof Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  /** @type {!number} */
  this._state = 0;
  /** @type {!boolean} */
  this._handled = false;
  /** @type {Promise|undefined} */
  this._value = undefined;
  /** @type {!Array<!Function>} */
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function() {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

/**
 * @constructor
 */
function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

Promise.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

Promise.prototype.then = function(onFulfilled, onRejected) {
  // @ts-ignore
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.prototype['finally'] = finallyConstructor;

Promise.all = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!isArray(arr)) {
      return reject(new TypeError('Promise.all accepts an array'));
    }

    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.allSettled = allSettled;

Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function(resolve) {
    resolve(value);
  });
};

Promise.reject = function(value) {
  return new Promise(function(resolve, reject) {
    reject(value);
  });
};

Promise.race = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!isArray(arr)) {
      return reject(new TypeError('Promise.race accepts an array'));
    }

    for (var i = 0, len = arr.length; i < len; i++) {
      Promise.resolve(arr[i]).then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn =
  // @ts-ignore
  (typeof setImmediate === 'function' &&
    function(fn) {
      // @ts-ignore
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

module.exports = Promise;

},{}],69:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIos = exports.isIE9 = exports.isSamsungBrowser = exports.isAndroidChrome = exports.isKitKatWebview = void 0;
// server side rendering check
var UA = (typeof window !== "undefined" &&
    window.navigator &&
    window.navigator.userAgent);
// TODO remove this when browser detection is converted to typescript
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-ignore
var isAndroid = _dereq_("@braintree/browser-detection/is-android");
// @ts-ignore
var isChromeOs = _dereq_("@braintree/browser-detection/is-chrome-os");
// @ts-ignore
var isChrome = _dereq_("@braintree/browser-detection/is-chrome");
// @ts-ignore
var isIos = _dereq_("@braintree/browser-detection/is-ios");
exports.isIos = isIos;
// @ts-ignore
var isIE9 = _dereq_("@braintree/browser-detection/is-ie9");
exports.isIE9 = isIE9;
/* eslint-enable @typescript-eslint/ban-ts-comment */
// Old Android Webviews used specific versions of Chrome with 0.0.0 as their version suffix
// https://developer.chrome.com/multidevice/user-agent#webview_user_agent
var KITKAT_WEBVIEW_REGEX = /Version\/\d\.\d* Chrome\/\d*\.0\.0\.0/;
function isOldSamsungBrowserOrSamsungWebview(ua) {
    return !isChrome(ua) && ua.indexOf("Samsung") > -1;
}
function isKitKatWebview(ua) {
    if (ua === void 0) { ua = UA; }
    return isAndroid(ua) && KITKAT_WEBVIEW_REGEX.test(ua);
}
exports.isKitKatWebview = isKitKatWebview;
function isAndroidChrome(ua) {
    if (ua === void 0) { ua = UA; }
    return (isAndroid(ua) || isChromeOs(ua)) && isChrome(ua);
}
exports.isAndroidChrome = isAndroidChrome;
function isSamsungBrowser(ua) {
    if (ua === void 0) { ua = UA; }
    return /SamsungBrowser/.test(ua) || isOldSamsungBrowserOrSamsungWebview(ua);
}
exports.isSamsungBrowser = isSamsungBrowser;

},{"@braintree/browser-detection/is-android":22,"@braintree/browser-detection/is-chrome":24,"@braintree/browser-detection/is-chrome-os":23,"@braintree/browser-detection/is-ie9":26,"@braintree/browser-detection/is-ios":30}],70:[function(_dereq_,module,exports){
"use strict";
var device_1 = _dereq_("./lib/device");
module.exports = function supportsInputFormatting() {
    // Digits get dropped in samsung browser
    return !(0, device_1.isSamsungBrowser)();
};

},{"./lib/device":69}],71:[function(_dereq_,module,exports){
module.exports = _dereq_("./dist/supports-input-formatting");

},{"./dist/supports-input-formatting":70}],72:[function(_dereq_,module,exports){
"use strict";

var BraintreeError = _dereq_("../lib/braintree-error");
var errors = _dereq_("./errors");
var assign = _dereq_("../lib/assign").assign;
var methods = _dereq_("../lib/methods");
var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
var wrapPromise = _dereq_("@braintree/wrap-promise");

/**
 * @class
 * @param {object} options Options
 * @description <strong>You cannot use this constructor directly. Use {@link module:braintree-web/american-express.create|braintree.american-express.create} instead.</strong>
 * @classdesc This class allows you use a nonce to interact with American Express Checkout. To accept American Express cards, use Hosted Fields.
 */
function AmericanExpress(options) {
  this._client = options.client;
}

/**
 * Gets the rewards balance associated with a Braintree nonce.
 * @public
 * @param {object} options Request options
 * @param {string} options.nonce An existing Braintree nonce.
 * @param {callback} [callback] The second argument, <code>data</code>, is the returned server data. If no callback is provided, `getRewardsBalance` returns a promise that resolves with the server data.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * var americanExpress = require('braintree-web/american-express');
 *
 * americanExpress.create({client: clientInstance}, function (createErr, americanExpressInstance) {
 *   var options = {nonce: existingBraintreeNonce};
 *   americanExpressInstance.getRewardsBalance(options, function (getErr, payload) {
 *     if (getErr || payload.error) {
 *       // Handle error
 *       return;
 *     }
 *
 *     console.log('Rewards amount: ' + payload.rewardsAmount);
 *   });
 * });
 */
AmericanExpress.prototype.getRewardsBalance = function (options) {
  var nonce = options.nonce;
  var data;

  if (!nonce) {
    return Promise.reject(
      new BraintreeError({
        type: errors.AMEX_NONCE_REQUIRED.type,
        code: errors.AMEX_NONCE_REQUIRED.code,
        message: "getRewardsBalance must be called with a nonce.",
      })
    );
  }

  data = assign(
    {
      _meta: { source: "american-express" },
      paymentMethodNonce: nonce,
    },
    options
  );

  delete data.nonce;

  return this._client
    .request({
      method: "get",
      endpoint: "payment_methods/amex_rewards_balance",
      data: data,
    })
    .catch(function (err) {
      return Promise.reject(
        new BraintreeError({
          type: errors.AMEX_NETWORK_ERROR.type,
          code: errors.AMEX_NETWORK_ERROR.code,
          message:
            "A network error occurred when getting the American Express rewards balance.",
          details: {
            originalError: err,
          },
        })
      );
    });
};

/**
 * Gets the Express Checkout nonce profile given a nonce from American Express.
 * @public
 * @param {object} options Request options
 * @param {string} options.nonce An existing nonce from American Express (note that this is <em>not</em> a nonce from Braintree).
 * @param {callback} [callback] The second argument, <code>data</code>, is the returned server data. If no callback is provided, `getExpressCheckoutProfile` returns a promise that resolves with the server data.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * var americanExpress = require('braintree-web/american-express');
 *
 * americanExpress.create({client: clientInstance}, function (createErr, americanExpressInstance) {
 *   var options = {nonce: existingAmericanExpressNonce};
 *   americanExpressInstance.getExpressCheckoutProfile(options, function (getErr, payload) {
 *     if (getErr) {
 *       // Handle error
 *       return;
 *     }
 *
 *     console.log('Number of cards: ' + payload.amexExpressCheckoutCards.length);
 *   });
 * });
 */
AmericanExpress.prototype.getExpressCheckoutProfile = function (options) {
  if (!options.nonce) {
    return Promise.reject(
      new BraintreeError({
        type: errors.AMEX_NONCE_REQUIRED.type,
        code: errors.AMEX_NONCE_REQUIRED.code,
        message: "getExpressCheckoutProfile must be called with a nonce.",
      })
    );
  }

  return this._client
    .request({
      method: "get",
      endpoint: "payment_methods/amex_express_checkout_cards/" + options.nonce,
      data: {
        _meta: { source: "american-express" },
        paymentMethodNonce: options.nonce,
      },
    })
    .catch(function (err) {
      return Promise.reject(
        new BraintreeError({
          type: errors.AMEX_NETWORK_ERROR.type,
          code: errors.AMEX_NETWORK_ERROR.code,
          message:
            "A network error occurred when getting the American Express Checkout nonce profile.",
          details: {
            originalError: err,
          },
        })
      );
    });
};

/**
 * Cleanly tear down anything set up by {@link module:braintree-web/american-express.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * americanExpressInstance.teardown();
 * @example <caption>With callback</caption>
 * americanExpressInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
AmericanExpress.prototype.teardown = function () {
  convertMethodsToError(this, methods(AmericanExpress.prototype));

  return Promise.resolve();
};

module.exports = wrapPromise.wrapPrototype(AmericanExpress);

},{"../lib/assign":121,"../lib/braintree-error":124,"../lib/convert-methods-to-error":127,"../lib/methods":155,"./errors":73,"@braintree/wrap-promise":43}],73:[function(_dereq_,module,exports){
"use strict";

/**
 * @name BraintreeError.American Express - getRewardsBalance Error Codes
 * @description Errors that occur when creating components.
 * @property {MERCHANT} AMEX_NONCE_REQUIRED Occurs when a nonce is not provided to method.
 * @property {NETWORK} AMEX_NETWORK_ERROR Occurs when there is an error communicating with the Braintree gateway.
 */

/**
 * @name BraintreeError.American Express - getExpressCheckoutProfile Error Codes
 * @description Errors that occur when creating components.
 * @property {MERCHANT} AMEX_NONCE_REQUIRED Occurs when a nonce is not provided to method.
 * @property {NETWORK} AMEX_NETWORK_ERROR Occurs when there is an error communicating with the Braintree gateway.
 */

var BraintreeError = _dereq_("../lib/braintree-error");

module.exports = {
  AMEX_NONCE_REQUIRED: {
    type: BraintreeError.types.MERCHANT,
    code: "AMEX_NONCE_REQUIRED",
  },
  AMEX_NETWORK_ERROR: {
    type: BraintreeError.types.NETWORK,
    code: "AMEX_NETWORK_ERROR",
  },
};

},{"../lib/braintree-error":124}],74:[function(_dereq_,module,exports){
"use strict";
/**
 * @module braintree-web/american-express
 * @description This module is for use with Amex Express Checkout. To accept American Express cards, use Hosted Fields.
 */

var AmericanExpress = _dereq_("./american-express");
var basicComponentVerification = _dereq_("../lib/basic-component-verification");
var createDeferredClient = _dereq_("../lib/create-deferred-client");
var createAssetsUrl = _dereq_("../lib/create-assets-url");
var VERSION = "3.101.3";
var wrapPromise = _dereq_("@braintree/wrap-promise");

/**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {callback} [callback] The second argument, `data`, is the {@link AmericanExpress} instance. If no callback is provided, `create` returns a promise that resolves with the {@link AmericanExpress} instance.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
function create(options) {
  var name = "American Express";

  return basicComponentVerification
    .verify({
      name: name,
      client: options.client,
      authorization: options.authorization,
    })
    .then(function () {
      return createDeferredClient.create({
        authorization: options.authorization,
        client: options.client,
        debug: options.debug,
        assetsUrl: createAssetsUrl.create(options.authorization),
        name: name,
      });
    })
    .then(function (client) {
      options.client = client;

      return new AmericanExpress(options);
    });
}

module.exports = {
  create: wrapPromise(create),
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION,
};

},{"../lib/basic-component-verification":122,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./american-express":72,"@braintree/wrap-promise":43}],75:[function(_dereq_,module,exports){
"use strict";

var BraintreeError = _dereq_("../lib/braintree-error");
var analytics = _dereq_("../lib/analytics");
var errors = _dereq_("./errors");
var methods = _dereq_("../lib/methods");
var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
var wrapPromise = _dereq_("@braintree/wrap-promise");

/**
 * @typedef {object} ApplePay~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {object} details Additional details.
 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
 * @property {string} details.cardHolderName The name of the card holder.
 * @property {string} details.dpanLastTwo Last two digits of card number.
 * @property {string} description A human-readable description.
 * @property {string} type The payment method type, always `ApplePayCard`.
 * @property {object} binData Information about the card based on the bin.
 * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.countryOfIssuance The country of issuance.
 * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.issuingBank The issuing bank.
 * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.productId The product id.
 */

/**
 * An Apple Pay Payment Authorization Event object.
 * @typedef {object} ApplePayPaymentAuthorizedEvent
 * @external ApplePayPaymentAuthorizedEvent
 * @see {@link https://developer.apple.com/reference/applepayjs/applepaypaymentauthorizedevent ApplePayPaymentAuthorizedEvent}
 */

/**
 * An Apple Pay Payment Request object.
 * @typedef {object} ApplePayPaymentRequest
 * @external ApplePayPaymentRequest
 * @see {@link https://developer.apple.com/reference/applepayjs/1916082-applepay_js_data_types/paymentrequest PaymentRequest}
 */

/**
 * @class
 * @param {object} options Options
 * @description <strong>You cannot use this constructor directly. Use {@link module:braintree-web/apple-pay.create|braintree.applePay.create} instead.</strong>
 * @classdesc This class represents an Apple Pay component. Instances of this class have methods for validating the merchant server and tokenizing payments.
 */
function ApplePay(options) {
  this._instantiatedWithClient = Boolean(!options.useDeferredClient);
  this._client = options.client;
  this._createPromise = options.createPromise;

  if (this._client) {
    this._setMerchantIdentifier();
  }
}

ApplePay.prototype._waitForClient = function () {
  if (this._client) {
    return Promise.resolve();
  }

  return this._createPromise.then(
    function (client) {
      this._client = client;

      this._setMerchantIdentifier();
    }.bind(this)
  );
};

ApplePay.prototype._setMerchantIdentifier = function () {
  var applePayConfig =
    this._client.getConfiguration().gatewayConfiguration.applePayWeb;

  if (!applePayConfig) {
    return;
  }
  /**
   * @name ApplePay#merchantIdentifier
   * @description A special merchant ID which represents the merchant association with Braintree. Required when using `ApplePaySession.canMakePaymentsWithActiveCard`.
   * @example
   * var promise = ApplePaySession.canMakePaymentsWithActiveCard(applePayInstance.merchantIdentifier);
   * promise.then(function (canMakePaymentsWithActiveCard) {
   *   if (canMakePaymentsWithActiveCard) {
   *     // Set up Apple Pay buttons
   *   }
   * });
   */
  Object.defineProperty(this, "merchantIdentifier", {
    value: applePayConfig.merchantIdentifier,
    configurable: false,
    writable: false,
  });
};

/**
 * Merges a payment request with Braintree defaults to return an {external:ApplePayPaymentRequest}.
 *
 * The following properties are assigned to `paymentRequest` if not already defined. Their default values come from the Braintree gateway.
 * - `countryCode`
 * - `currencyCode`
 * - `merchantCapabilities`
 * - `supportedNetworks`
 * @public
 * @param {external:ApplePayPaymentRequest} paymentRequest The payment request details to apply on top of those from Braintree.
 * @returns {external:ApplePayPaymentRequest|Promise} The decorated `paymentRequest` object. If `useDeferredClient` is used along with an `authorization`, this method will return a promise that resolves with the `paymentRequest` object.
 * @example
 * var applePay = require('braintree-web/apple-pay');
 *
 * applePay.create({client: clientInstance}, function (applePayErr, applePayInstance) {
 *   if (applePayErr) {
 *     // Handle error here
 *     return;
 *   }
 *
 *   var paymentRequest = applePayInstance.createPaymentRequest({
 *     total: {
 *       label: 'My Company',
 *       amount: '19.99'
 *     }
 *   });
 *
 *   var session = new ApplePaySession(3, paymentRequest);
 *
 *   // ...
 * @example <caption>With deferred client</caption>
 * var applePay = require('braintree-web/apple-pay');
 *
 * applePay.create({
 *   authorization: 'client-token-or-tokenization-key',
 *   useDeferredClient: true
 * }, function (applePayErr, applePayInstance) {
 *   if (applePayErr) {
 *     // Handle error here
 *     return;
 *   }
 *
 *   applePayInstance.createPaymentRequest({
 *     total: {
 *       label: 'My Company',
 *       amount: '19.99'
 *     }
 *   }).then(function (paymentRequest) {
 *     var session = new ApplePaySession(3, paymentRequest);
 *
 *     // ...
 *   });
 */
ApplePay.prototype.createPaymentRequest = function (paymentRequest) {
  if (this._instantiatedWithClient) {
    return this._createPaymentRequestSynchronously(paymentRequest);
  }

  return this._waitForClient().then(
    function () {
      return this._createPaymentRequestSynchronously(paymentRequest);
    }.bind(this)
  );
};

ApplePay.prototype._createPaymentRequestSynchronously = function (
  paymentRequest
) {
  var applePay =
    this._client.getConfiguration().gatewayConfiguration.applePayWeb;
  var defaults = {
    countryCode: applePay.countryCode,
    currencyCode: applePay.currencyCode,
    merchantCapabilities: applePay.merchantCapabilities || ["supports3DS"],
    supportedNetworks: applePay.supportedNetworks.map(function (network) {
      return network === "mastercard" ? "masterCard" : network;
    }),
  };

  return Object.assign({}, defaults, paymentRequest);
};

/**
 * Validates your merchant website, as required by `ApplePaySession` before payment can be authorized.
 * @public
 * @param {object} options Options
 * @param {string} options.validationURL The validationURL from an `ApplePayValidateMerchantEvent`.
 * @param {string} options.displayName The canonical name for your store. Use a non-localized name. This parameter should be a UTF-8 string that is a maximum of 64 characters. The system may display this name to the user.
 * @param {callback} [callback] The second argument, <code>data</code>, is the Apple Pay merchant session object. If no callback is provided, `performValidation` returns a promise.
 * Pass the merchant session to your Apple Pay session's `completeMerchantValidation` method.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * var applePay = require('braintree-web/apple-pay');
 *
 * applePay.create({client: clientInstance}, function (applePayErr, applePayInstance) {
 *   if (applePayErr) {
 *     // Handle error here
 *     return;
 *   }
 *
 *   var paymentRequest = applePayInstance.createPaymentRequest({
 *     total: {
 *       label: 'My Company',
 *       amount: '19.99'
 *     }
 *   });
 *   var session = new ApplePaySession(3, paymentRequest);
 *
 *   session.onvalidatemerchant = function (event) {
 *     applePayInstance.performValidation({
 *       validationURL: event.validationURL,
 *       displayName: 'My Great Store'
 *     }, function (validationErr, validationData) {
 *       if (validationErr) {
 *         console.error(validationErr);
 *         session.abort();
 *         return;
 *       }
 *
 *       session.completeMerchantValidation(validationData);
 *     });
 *   };
 * });
 */
ApplePay.prototype.performValidation = function (options) {
  var self = this;

  if (!options || !options.validationURL) {
    return Promise.reject(
      new BraintreeError(errors.APPLE_PAY_VALIDATION_URL_REQUIRED)
    );
  }

  return this._waitForClient()
    .then(function () {
      var applePayWebSession = {
        validationUrl: options.validationURL,
        domainName: options.domainName || window.location.hostname,
        merchantIdentifier:
          options.merchantIdentifier || self.merchantIdentifier,
      };

      if (options.displayName != null) {
        applePayWebSession.displayName = options.displayName;
      }

      return self._client.request({
        method: "post",
        endpoint: "apple_pay_web/sessions",
        data: {
          _meta: { source: "apple-pay" },
          applePayWebSession: applePayWebSession,
        },
      });
    })
    .then(function (response) {
      analytics.sendEvent(self._client, "applepay.performValidation.succeeded");

      return Promise.resolve(response);
    })
    .catch(function (err) {
      analytics.sendEvent(self._client, "applepay.performValidation.failed");

      if (err.code === "CLIENT_REQUEST_ERROR") {
        return Promise.reject(
          new BraintreeError({
            type: errors.APPLE_PAY_MERCHANT_VALIDATION_FAILED.type,
            code: errors.APPLE_PAY_MERCHANT_VALIDATION_FAILED.code,
            message: errors.APPLE_PAY_MERCHANT_VALIDATION_FAILED.message,
            details: {
              originalError: err.details.originalError,
            },
          })
        );
      }

      return Promise.reject(
        new BraintreeError({
          type: errors.APPLE_PAY_MERCHANT_VALIDATION_NETWORK.type,
          code: errors.APPLE_PAY_MERCHANT_VALIDATION_NETWORK.code,
          message: errors.APPLE_PAY_MERCHANT_VALIDATION_NETWORK.message,
          details: {
            originalError: err,
          },
        })
      );
    });
};

/**
 * Tokenizes an Apple Pay payment. This will likely be called in your `ApplePaySession`'s `onpaymentauthorized` callback.
 * @public
 * @param {object} options Options
 * @param {object} options.token The `payment.token` property of an {@link external:ApplePayPaymentAuthorizedEvent}.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link ApplePay~tokenizePayload|tokenizePayload}. If no callback is provided, `tokenize` returns a promise that resolves with a {@link ApplePay~tokenizePayload|tokenizePayload}.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * var applePay = require('braintree-web/apple-pay');
 *
 * applePay.create({client: clientInstance}, function (applePayErr, applePayInstance) {
 *   if (applePayErr) {
 *     // Handle error here
 *     return;
 *   }
 *
 *   var paymentRequest = applePayInstance.createPaymentRequest({
 *     total: {
 *       label: 'My Company',
 *       amount: '19.99'
 *     }
 *   });
 *   var session = new ApplePaySession(3, paymentRequest);
 *
 *   session.onpaymentauthorized = function (event) {
 *     applePayInstance.tokenize({
 *       token: event.payment.token
 *     }, function (tokenizeErr, tokenizedPayload) {
 *       if (tokenizeErr) {
 *         session.completePayment(ApplePaySession.STATUS_FAILURE);
 *         return;
 *       }
 *       // Send the tokenizedPayload to your server here!
 *
 *       // Once the transaction is complete, call completePayment
 *       // to close the Apple Pay sheet
 *       session.completePayment(ApplePaySession.STATUS_SUCCESS);
 *     });
 *   };
 *
 *   // ...
 * });
 */
ApplePay.prototype.tokenize = function (options) {
  var self = this;

  if (!options.token) {
    return Promise.reject(
      new BraintreeError(errors.APPLE_PAY_PAYMENT_TOKEN_REQUIRED)
    );
  }

  return this._waitForClient()
    .then(function () {
      return self._client.request({
        method: "post",
        endpoint: "payment_methods/apple_payment_tokens",
        data: {
          _meta: {
            source: "apple-pay",
          },
          applePaymentToken: Object.assign({}, options.token, {
            // The gateway requires this key to be base64-encoded.
            paymentData: btoa(JSON.stringify(options.token.paymentData)),
          }),
        },
      });
    })
    .then(function (response) {
      analytics.sendEvent(self._client, "applepay.tokenize.succeeded");

      return Promise.resolve(response.applePayCards[0]);
    })
    .catch(function (err) {
      analytics.sendEvent(self._client, "applepay.tokenize.failed");

      return Promise.reject(
        new BraintreeError({
          type: errors.APPLE_PAY_TOKENIZATION.type,
          code: errors.APPLE_PAY_TOKENIZATION.code,
          message: errors.APPLE_PAY_TOKENIZATION.message,
          details: {
            originalError: err,
          },
        })
      );
    });
};

/**
 * Cleanly tear down anything set up by {@link module:braintree-web/apple-pay.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * applePayInstance.teardown();
 * @example <caption>With callback</caption>
 * applePayInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
ApplePay.prototype.teardown = function () {
  convertMethodsToError(this, methods(ApplePay.prototype));

  return Promise.resolve();
};

module.exports = wrapPromise.wrapPrototype(ApplePay);

},{"../lib/analytics":119,"../lib/braintree-error":124,"../lib/convert-methods-to-error":127,"../lib/methods":155,"./errors":76,"@braintree/wrap-promise":43}],76:[function(_dereq_,module,exports){
"use strict";

/**
 * @name BraintreeError.Apple Pay - Creation Error Codes
 * @description Errors that occur when [creating the Apple Pay component](./module-braintree-web_apple-pay.html#.create).
 * @property {MERCHANT} APPLE_PAY_NOT_ENABLED Occurs when the authorization used is not authorized to process Apple Pay.
 */

/**
 * @name BraintreeError.Apple Pay - performValidation Error Codes
 * @description Errors that occur when [validating](./ApplePay.html#performValidation).
 * @property {MERCHANT} APPLE_PAY_VALIDATION_URL_REQUIRED Occurs when the `validationURL` option is not passed in.
 * @property {MERCHANT} APPLE_PAY_MERCHANT_VALIDATION_FAILED Occurs when the website domain has not been registered in the Braintree control panel.
 * @property {NETWORK} APPLE_PAY_MERCHANT_VALIDATION_NETWORK Occurs when an unknown network error occurs.
 */

/**
 * @name BraintreeError.Apple Pay - tokenize Error Codes
 * @description Errors that occur when [tokenizing](./ApplePay.html#tokenize).
 * @property {MERCHANT} APPLE_PAY_PAYMENT_TOKEN_REQUIRED Occurs when the `token` option is not passed in.
 * @property {NETWORK} APPLE_PAY_TOKENIZATION Occurs when an unknown network error occurs.
 */

var BraintreeError = _dereq_("../lib/braintree-error");

module.exports = {
  APPLE_PAY_NOT_ENABLED: {
    type: BraintreeError.types.MERCHANT,
    code: "APPLE_PAY_NOT_ENABLED",
    message: "Apple Pay is not enabled for this merchant.",
  },
  APPLE_PAY_VALIDATION_URL_REQUIRED: {
    type: BraintreeError.types.MERCHANT,
    code: "APPLE_PAY_VALIDATION_URL_REQUIRED",
    message: "performValidation must be called with a validationURL.",
  },
  APPLE_PAY_MERCHANT_VALIDATION_NETWORK: {
    type: BraintreeError.types.NETWORK,
    code: "APPLE_PAY_MERCHANT_VALIDATION_NETWORK",
    message: "A network error occurred when validating the Apple Pay merchant.",
  },
  APPLE_PAY_MERCHANT_VALIDATION_FAILED: {
    type: BraintreeError.types.MERCHANT,
    code: "APPLE_PAY_MERCHANT_VALIDATION_FAILED",
    message:
      "Make sure you have registered your domain name in the Braintree Control Panel.",
  },
  APPLE_PAY_PAYMENT_TOKEN_REQUIRED: {
    type: BraintreeError.types.MERCHANT,
    code: "APPLE_PAY_PAYMENT_TOKEN_REQUIRED",
    message: "tokenize must be called with a payment token.",
  },
  APPLE_PAY_TOKENIZATION: {
    type: BraintreeError.types.NETWORK,
    code: "APPLE_PAY_TOKENIZATION",
    message: "A network error occurred when processing the Apple Pay payment.",
  },
};

},{"../lib/braintree-error":124}],77:[function(_dereq_,module,exports){
"use strict";

/**
 * @module braintree-web/apple-pay
 * @description Accept Apple Pay on the Web. *This component is currently in beta and is subject to change.*
 */

var ApplePay = _dereq_("./apple-pay");
var analytics = _dereq_("../lib/analytics");
var BraintreeError = _dereq_("../lib/braintree-error");
var basicComponentVerification = _dereq_("../lib/basic-component-verification");
var createAssetsUrl = _dereq_("../lib/create-assets-url");
var createDeferredClient = _dereq_("../lib/create-deferred-client");
var errors = _dereq_("./errors");
var VERSION = "3.101.3";
var wrapPromise = _dereq_("@braintree/wrap-promise");

/**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {boolean} [options.useDeferredClient] Used in conjunction with `authorization`, allows the Apple Pay instance to be available right away by fetching the client configuration in the background. When this option is used, {@link ApplePay#createPaymentRequest} will return a promise that resolves with the configuration instead of returning synchronously.
 * @param {callback} [callback] The second argument, `data`, is the {@link ApplePay} instance. If no callback is provided, `create` returns a promise that resolves with the {@link ApplePay} instance.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
function create(options) {
  var name = "Apple Pay";

  return basicComponentVerification
    .verify({
      name: name,
      client: options.client,
      authorization: options.authorization,
    })
    .then(function () {
      var applePayInstance;
      var createPromise = createDeferredClient
        .create({
          authorization: options.authorization,
          client: options.client,
          debug: options.debug,
          assetsUrl: createAssetsUrl.create(options.authorization),
          name: name,
        })
        .then(function (client) {
          if (!client.getConfiguration().gatewayConfiguration.applePayWeb) {
            return Promise.reject(
              new BraintreeError(errors.APPLE_PAY_NOT_ENABLED)
            );
          }

          analytics.sendEvent(client, "applepay.initialized");

          return client;
        });

      options.createPromise = createPromise;
      applePayInstance = new ApplePay(options);

      if (!options.useDeferredClient) {
        return createPromise.then(function (client) {
          applePayInstance._client = client;

          return applePayInstance;
        });
      }

      return applePayInstance;
    });
}

module.exports = {
  create: wrapPromise(create),
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION,
};

},{"../lib/analytics":119,"../lib/basic-component-verification":122,"../lib/braintree-error":124,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./apple-pay":75,"./errors":76,"@braintree/wrap-promise":43}],78:[function(_dereq_,module,exports){
"use strict";

var BRAINTREE_VERSION = _dereq_("./constants").BRAINTREE_VERSION;

var GraphQL = _dereq_("./request/graphql");
var request = _dereq_("./request");
var isVerifiedDomain = _dereq_("../lib/is-verified-domain");
var BraintreeError = _dereq_("../lib/braintree-error");
var convertToBraintreeError = _dereq_("../lib/convert-to-braintree-error");
var getGatewayConfiguration = _dereq_("./get-configuration").getConfiguration;
var createAuthorizationData = _dereq_("../lib/create-authorization-data");
var addMetadata = _dereq_("../lib/add-metadata");
var wrapPromise = _dereq_("@braintree/wrap-promise");
var once = _dereq_("../lib/once");
var deferred = _dereq_("../lib/deferred");
var assign = _dereq_("../lib/assign").assign;
var analytics = _dereq_("../lib/analytics");
var errors = _dereq_("./errors");
var VERSION = _dereq_("../lib/constants").VERSION;
var GRAPHQL_URLS = _dereq_("../lib/constants").GRAPHQL_URLS;
var methods = _dereq_("../lib/methods");
var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
var assets = _dereq_("../lib/assets");
var FRAUDNET_FNCLS = _dereq_("../lib/constants").FRAUDNET_FNCLS;
var FRAUDNET_SOURCE = _dereq_("../lib/constants").FRAUDNET_SOURCE;
var FRAUDNET_URL = _dereq_("../lib/constants").FRAUDNET_URL;

var cachedClients = {};

/**
 * This object is returned by {@link Client#getConfiguration|getConfiguration}. This information is used extensively by other Braintree modules to properly configure themselves.
 * @typedef {object} Client~configuration
 * @property {object} client The braintree-web/client parameters.
 * @property {string} client.authorization A tokenizationKey or clientToken.
 * @property {object} gatewayConfiguration Gateway-supplied configuration.
 * @property {object} analyticsMetadata Analytics-specific data.
 * @property {string} analyticsMetadata.sessionId Uniquely identifies a browsing session.
 * @property {string} analyticsMetadata.sdkVersion The braintree.js version.
 * @property {string} analyticsMetadata.merchantAppId Identifies the merchant's web app.
 */

/**
 * @class
 * @param {Client~configuration} configuration Options
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/client.create|braintree.client.create} instead.</strong>
 * @classdesc This class is required by many other Braintree components. It serves as the base API layer that communicates with our servers. It is also capable of being used to formulate direct calls to our servers, such as direct credit card tokenization. See {@link Client#request}.
 */
function Client(configuration) {
  var configurationJSON, gatewayConfiguration;

  configuration = configuration || {};

  configurationJSON = JSON.stringify(configuration);
  gatewayConfiguration = configuration.gatewayConfiguration;

  if (!gatewayConfiguration) {
    throw new BraintreeError(errors.CLIENT_MISSING_GATEWAY_CONFIGURATION);
  }

  ["assetsUrl", "clientApiUrl", "configUrl"].forEach(function (property) {
    if (
      property in gatewayConfiguration &&
      !isVerifiedDomain(gatewayConfiguration[property])
    ) {
      throw new BraintreeError({
        type: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.type,
        code: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.code,
        message: property + " property is on an invalid domain.",
      });
    }
  });

  /**
   * Returns a copy of the configuration values.
   * @public
   * @returns {Client~configuration} configuration
   */
  this.getConfiguration = function () {
    return JSON.parse(configurationJSON);
  };

  this._request = request;
  this._configuration = this.getConfiguration();

  this._clientApiBaseUrl = gatewayConfiguration.clientApiUrl + "/v1/";

  if (gatewayConfiguration.graphQL) {
    if (!isVerifiedDomain(gatewayConfiguration.graphQL.url)) {
      throw new BraintreeError({
        type: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.type,
        code: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.code,
        message: "graphQL.url property is on an invalid domain.",
      });
    }

    this._graphQL = new GraphQL({
      graphQL: gatewayConfiguration.graphQL,
    });
  }
}

Client.initialize = function (options) {
  var clientInstance, authData;
  var promise = cachedClients[options.authorization];

  if (promise) {
    analytics.sendEvent(promise, "custom.client.load.cached");

    return promise;
  }

  try {
    authData = createAuthorizationData(options.authorization);
  } catch (err) {
    return Promise.reject(
      new BraintreeError(errors.CLIENT_INVALID_AUTHORIZATION)
    );
  }

  promise = getGatewayConfiguration(authData).then(function (configuration) {
    if (options.debug) {
      configuration.isDebug = true;
    }

    configuration.authorization = options.authorization;

    clientInstance = new Client(configuration);

    return clientInstance;
  });

  cachedClients[options.authorization] = promise;

  analytics.sendEvent(promise, "custom.client.load.initialized");

  return promise
    .then(function (client) {
      analytics.sendEvent(clientInstance, "custom.client.load.succeeded");

      return client;
    })
    .catch(function (err) {
      delete cachedClients[options.authorization];

      return Promise.reject(err);
    });
};

// Primarily used for testing the client initalization call
Client.clearCache = function () {
  cachedClients = {};
};

Client.prototype._findOrCreateFraudnetJSON = function (clientMetadataId) {
  var el = document.querySelector('script[fncls="' + FRAUDNET_FNCLS + '"]');
  var config, additionalData, authorizationFingerprint, parameters;

  if (!el) {
    el = document.body.appendChild(document.createElement("script"));
    el.type = "application/json";
    el.setAttribute("fncls", FRAUDNET_FNCLS);
  }

  config = this.getConfiguration();
  additionalData = {
    rda_tenant: "bt_card", // eslint-disable-line camelcase
    mid: config.gatewayConfiguration.merchantId,
  };
  authorizationFingerprint = config.authorizationFingerprint;

  if (authorizationFingerprint) {
    authorizationFingerprint.split("&").forEach(function (pieces) {
      var component = pieces.split("=");

      if (component[0] === "customer_id" && component.length > 1) {
        additionalData.cid = component[1];
      }
    });
  }

  parameters = {
    f: clientMetadataId.substr(0, 32),
    fp: additionalData,
    bu: false,
    s: FRAUDNET_SOURCE,
  };
  el.text = JSON.stringify(parameters);
};

/**
 * Used by other modules to formulate all network requests to the Braintree gateway. It is also capable of being used directly from your own form to tokenize credit card information. However, be sure to satisfy PCI compliance if you use direct card tokenization.
 * @public
 * @param {object} options Request options:
 * @param {string} options.method HTTP method, e.g. "get" or "post".
 * @param {string} options.endpoint Endpoint path, e.g. "payment_methods".
 * @param {object} options.data Data to send with the request.
 * @param {number} [options.timeout=60000] Set a timeout (in milliseconds) for the request.
 * @param {callback} [callback] The second argument, <code>data</code>, is the returned server data.
 * @example
 * <caption>Direct Credit Card Tokenization</caption>
 * var createClient = require('braintree-web/client').create;
 *
 * createClient({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (createErr, clientInstance) {
 *   var form = document.getElementById('my-form-id');
 *   var data = {
 *     creditCard: {
 *       number: form['cc-number'].value,
 *       cvv: form['cc-cvv'].value,
 *       expirationDate: form['cc-expiration-date'].value,
 *       billingAddress: {
 *         postalCode: form['cc-postal-code'].value
 *       },
 *       options: {
 *         validate: false
 *       }
 *     }
 *   };
 *
 *   // Warning: For a merchant to be eligible for the easiest level of PCI compliance (SAQ A),
 *   // payment fields cannot be hosted on your checkout page.
 *   // For an alternative to the following, use Hosted Fields.
 *   clientInstance.request({
 *     endpoint: 'payment_methods/credit_cards',
 *     method: 'post',
 *     data: data
 *   }, function (requestErr, response) {
 *     // More detailed example of handling API errors: https://codepen.io/braintree/pen/MbwjdM
 *     if (requestErr) { throw new Error(requestErr); }
 *
 *     console.log('Got nonce:', response.creditCards[0].nonce);
 *   });
 * });
 * @example
 * <caption>Tokenizing Fields for AVS Checks</caption>
 * var createClient = require('braintree-web/client').create;
 *
 * createClient({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (createErr, clientInstance) {
 *   var form = document.getElementById('my-form-id');
 *   var data = {
 *     creditCard: {
 *       number: form['cc-number'].value,
 *       cvv: form['cc-cvv'].value,
 *       expirationDate: form['cc-date'].value,
 *       // The billing address can be checked with AVS rules.
 *       // See: https://articles.braintreepayments.com/support/guides/fraud-tools/basic/avs-cvv-rules
 *       billingAddress: {
 *         postalCode: form['cc-postal-code'].value,
 *         streetAddress: form['cc-street-address'].value,
 *         countryName: form['cc-country-name'].value,
 *         countryCodeAlpha2: form['cc-country-alpha2'].value,
 *         countryCodeAlpha3: form['cc-country-alpha3'].value,
 *         countryCodeNumeric: form['cc-country-numeric'].value
 *       },
 *       options: {
 *         validate: false
 *       }
 *     }
 *   };
 *
 *   // Warning: For a merchant to be eligible for the easiest level of PCI compliance (SAQ A),
 *   // payment fields cannot be hosted on your checkout page.
 *   // For an alternative to the following, use Hosted Fields.
 *   clientInstance.request({
 *     endpoint: 'payment_methods/credit_cards',
 *     method: 'post',
 *     data: data
 *   }, function (requestErr, response) {
 *     // More detailed example of handling API errors: https://codepen.io/braintree/pen/MbwjdM
 *     if (requestErr) { throw new Error(requestErr); }
 *
 *     console.log('Got nonce:', response.creditCards[0].nonce);
 *   });
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
Client.prototype.request = function (options, callback) {
  var self = this; // eslint-disable-line no-invalid-this
  var requestPromise = new Promise(function (resolve, reject) {
    var optionName, api, baseUrl, requestOptions;
    var shouldCollectData = Boolean(
      options.endpoint === "payment_methods/credit_cards" &&
        self.getConfiguration().gatewayConfiguration.creditCards
          .collectDeviceData
    );

    if (options.api !== "graphQLApi") {
      if (!options.method) {
        optionName = "options.method";
      } else if (!options.endpoint) {
        optionName = "options.endpoint";
      }
    }

    if (optionName) {
      throw new BraintreeError({
        type: errors.CLIENT_OPTION_REQUIRED.type,
        code: errors.CLIENT_OPTION_REQUIRED.code,
        message: optionName + " is required when making a request.",
      });
    }

    if ("api" in options) {
      api = options.api;
    } else {
      api = "clientApi";
    }

    requestOptions = {
      method: options.method,
      graphQL: self._graphQL,
      timeout: options.timeout,
      metadata: self._configuration.analyticsMetadata,
    };

    if (api === "clientApi") {
      baseUrl = self._clientApiBaseUrl;

      requestOptions.data = addMetadata(self._configuration, options.data);
    } else if (api === "graphQLApi") {
      baseUrl =
        GRAPHQL_URLS[self._configuration.gatewayConfiguration.environment];
      options.endpoint = "";
      requestOptions.method = "post";
      requestOptions.data = assign(
        {
          clientSdkMetadata: {
            platform: self._configuration.analyticsMetadata.platform,
            source: self._configuration.analyticsMetadata.source,
            integration: self._configuration.analyticsMetadata.integration,
            sessionId: self._configuration.analyticsMetadata.sessionId,
            version: VERSION,
          },
        },
        options.data
      );

      requestOptions.headers = getAuthorizationHeadersForGraphQL(
        self._configuration
      );
    } else {
      throw new BraintreeError({
        type: errors.CLIENT_OPTION_INVALID.type,
        code: errors.CLIENT_OPTION_INVALID.code,
        message: "options.api is invalid.",
      });
    }

    requestOptions.url = baseUrl + options.endpoint;
    requestOptions.sendAnalyticsEvent = function (kind) {
      analytics.sendEvent(self, kind);
    };

    self._request(requestOptions, function (err, data, status) {
      var resolvedData, requestError;

      requestError = formatRequestError(status, err);

      if (requestError) {
        reject(requestError);

        return;
      }

      if (api === "graphQLApi" && data.errors) {
        reject(
          convertToBraintreeError(data.errors, {
            type: errors.CLIENT_GRAPHQL_REQUEST_ERROR.type,
            code: errors.CLIENT_GRAPHQL_REQUEST_ERROR.code,
            message: errors.CLIENT_GRAPHQL_REQUEST_ERROR.message,
          })
        );

        return;
      }

      resolvedData = assign({ _httpStatus: status }, data);

      if (
        shouldCollectData &&
        resolvedData.creditCards &&
        resolvedData.creditCards.length > 0
      ) {
        self._findOrCreateFraudnetJSON(resolvedData.creditCards[0].nonce);

        assets.loadScript({
          src: FRAUDNET_URL,
          forceScriptReload: true,
        });
      }
      resolve(resolvedData);
    });
  });

  if (typeof callback === "function") {
    callback = once(deferred(callback));

    requestPromise
      .then(function (response) {
        callback(null, response, response._httpStatus);
      })
      .catch(function (err) {
        var status = err && err.details && err.details.httpStatus;

        callback(err, null, status);
      });

    return;
  }

  return requestPromise; // eslint-disable-line consistent-return
};

// eslint-disable-next-line consistent-return
function formatRequestError(status, err) {
  var requestError;

  if (status === -1) {
    requestError = new BraintreeError(errors.CLIENT_REQUEST_TIMEOUT);
  } else if (status === 401) {
    requestError = new BraintreeError(errors.CLIENT_AUTHORIZATION_INVALID);
  } else if (status === 403) {
    requestError = new BraintreeError(errors.CLIENT_AUTHORIZATION_INSUFFICIENT);
  } else if (status === 429) {
    requestError = new BraintreeError(errors.CLIENT_RATE_LIMITED);
  } else if (status >= 500) {
    requestError = new BraintreeError(errors.CLIENT_GATEWAY_NETWORK);
  } else if (status < 200 || status >= 400) {
    requestError = convertToBraintreeError(err, {
      type: errors.CLIENT_REQUEST_ERROR.type,
      code: errors.CLIENT_REQUEST_ERROR.code,
      message: errors.CLIENT_REQUEST_ERROR.message,
    });
  }

  if (requestError) {
    requestError.details = requestError.details || {};
    requestError.details.httpStatus = status;

    return requestError;
  }
}

Client.prototype.toJSON = function () {
  return this.getConfiguration();
};

/**
 * Returns the Client version.
 * @public
 * @returns {String} The created client's version.
 * @example
 * var createClient = require('braintree-web/client').create;
 *
 * createClient({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (createErr, clientInstance) {
 *   console.log(clientInstance.getVersion()); // Ex: 1.0.0
 * });
 * @returns {void}
 */
Client.prototype.getVersion = function () {
  return VERSION;
};

/**
 * Cleanly tear down anything set up by {@link module:braintree-web/client.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * clientInstance.teardown();
 * @example <caption>With callback</caption>
 * clientInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
Client.prototype.teardown = wrapPromise(function () {
  var self = this; // eslint-disable-line no-invalid-this

  delete cachedClients[self.getConfiguration().authorization];
  convertMethodsToError(self, methods(Client.prototype));

  return Promise.resolve();
});

function getAuthorizationHeadersForGraphQL(configuration) {
  var token =
    configuration.authorizationFingerprint || configuration.authorization;

  return {
    Authorization: "Bearer " + token,
    "Braintree-Version": BRAINTREE_VERSION,
  };
}

module.exports = Client;

},{"../lib/add-metadata":118,"../lib/analytics":119,"../lib/assets":120,"../lib/assign":121,"../lib/braintree-error":124,"../lib/constants":126,"../lib/convert-methods-to-error":127,"../lib/convert-to-braintree-error":128,"../lib/create-authorization-data":130,"../lib/deferred":132,"../lib/is-verified-domain":153,"../lib/methods":155,"../lib/once":156,"./constants":79,"./errors":80,"./get-configuration":81,"./request":92,"./request/graphql":90,"@braintree/wrap-promise":43}],79:[function(_dereq_,module,exports){
"use strict";

module.exports = {
  BRAINTREE_VERSION: "2018-05-10",
};

},{}],80:[function(_dereq_,module,exports){
"use strict";

/**
 * @name BraintreeError.Client - Internal Error Codes
 * @ignore
 * @description These codes should never be experienced by the merchant directly.
 * @property {MERCHANT} CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN An error to prevent client creation for domains that are not allowed in the JS.
 * @property {INTERNAL} CLIENT_MISSING_GATEWAY_CONFIGURATION Occurs when the client is created without a gateway configuration. Should never happen.
 */

/**
 * @name BraintreeError.Client - Create Error Codes
 * @description Errors that may occur when [creating the client](./module-braintree-web_client.html#.create)
 * @property {MERCHANT} CLIENT_INVALID_AUTHORIZATION Occurs when client token cannot be parsed.
 */

/**
 * @name BraintreeError.Client - Request Error Codes
 * @description Errors that may occur when [using the request method](./Client.html#request)
 * @property {MERCHANT} CLIENT_OPTION_REQUIRED An option required in the request method was not provided. Usually `options.method` or `options.endpoint`
 * @property {MERCHANT} CLIENT_OPTION_INVALID The request option provided is invalid.
 * @property {MERCHANT} CLIENT_GATEWAY_NETWORK The Braintree gateway could not be contacted.
 * @property {NETWORK} CLIENT_REQUEST_TIMEOUT The request took too long to complete and timed out.
 * @property {NETWORK} CLIENT_REQUEST_ERROR The response from a request had status 400 or greater.
 * @property {NETWORK} CLIENT_GRAPHQL_REQUEST_ERROR The response from a request to GraphQL contained an error.
 * @property {MERCHANT} CLIENT_RATE_LIMITED The response from a request had a status of 429, indicating rate limiting.
 * @property {MERCHANT} CLIENT_AUTHORIZATION_INSUFFICIENT The user associated with the client token or tokenization key does not have permissions to make the request.
 * @property {MERCHANT} CLIENT_AUTHORIZATION_INVALID The provided authorization could not be found. Either the client token has expired and a new client token must be generated or the tokenization key used is set to be inactive or has been deleted.
 */

var BraintreeError = _dereq_("../lib/braintree-error");

module.exports = {
  CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN: {
    type: BraintreeError.types.MERCHANT,
    code: "CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN",
  },
  CLIENT_OPTION_REQUIRED: {
    type: BraintreeError.types.MERCHANT,
    code: "CLIENT_OPTION_REQUIRED",
  },
  CLIENT_OPTION_INVALID: {
    type: BraintreeError.types.MERCHANT,
    code: "CLIENT_OPTION_INVALID",
  },
  CLIENT_MISSING_GATEWAY_CONFIGURATION: {
    type: BraintreeError.types.INTERNAL,
    code: "CLIENT_MISSING_GATEWAY_CONFIGURATION",
    message: "Missing gatewayConfiguration.",
  },
  CLIENT_INVALID_AUTHORIZATION: {
    type: BraintreeError.types.MERCHANT,
    code: "CLIENT_INVALID_AUTHORIZATION",
    message:
      "Authorization is invalid. Make sure your client token or tokenization key is valid.",
  },
  CLIENT_GATEWAY_NETWORK: {
    type: BraintreeError.types.NETWORK,
    code: "CLIENT_GATEWAY_NETWORK",
    message: "Cannot contact the gateway at this time.",
  },
  CLIENT_REQUEST_TIMEOUT: {
    type: BraintreeError.types.NETWORK,
    code: "CLIENT_REQUEST_TIMEOUT",
    message: "Request timed out waiting for a reply.",
  },
  CLIENT_REQUEST_ERROR: {
    type: BraintreeError.types.NETWORK,
    code: "CLIENT_REQUEST_ERROR",
    message: "There was a problem with your request.",
  },
  CLIENT_GRAPHQL_REQUEST_ERROR: {
    type: BraintreeError.types.NETWORK,
    code: "CLIENT_GRAPHQL_REQUEST_ERROR",
    message: "There was a problem with your request.",
  },
  CLIENT_RATE_LIMITED: {
    type: BraintreeError.types.MERCHANT,
    code: "CLIENT_RATE_LIMITED",
    message: "You are being rate-limited; please try again in a few minutes.",
  },
  CLIENT_AUTHORIZATION_INSUFFICIENT: {
    type: BraintreeError.types.MERCHANT,
    code: "CLIENT_AUTHORIZATION_INSUFFICIENT",
    message: "The authorization used has insufficient privileges.",
  },
  CLIENT_AUTHORIZATION_INVALID: {
    type: BraintreeError.types.MERCHANT,
    code: "CLIENT_AUTHORIZATION_INVALID",
    message:
      "Either the client token has expired and a new one should be generated or the tokenization key has been deactivated or deleted.",
  },
};

},{"../lib/braintree-error":124}],81:[function(_dereq_,module,exports){
"use strict";

var BraintreeError = _dereq_("../lib/braintree-error");
var wrapPromise = _dereq_("@braintree/wrap-promise");
var request = _dereq_("./request");
var uuid = _dereq_("@braintree/uuid");
var constants = _dereq_("../lib/constants");
var errors = _dereq_("./errors");
var GraphQL = _dereq_("./request/graphql");
var GRAPHQL_URLS = _dereq_("../lib/constants").GRAPHQL_URLS;
var isDateStringBeforeOrOn = _dereq_("../lib/is-date-string-before-or-on");

var BRAINTREE_VERSION = _dereq_("./constants").BRAINTREE_VERSION;

function getConfiguration(authData) {
  return new Promise(function (resolve, reject) {
    var configuration, attrs, configUrl, reqOptions;
    var sessionId = uuid();
    var analyticsMetadata = {
      merchantAppId: window.location.host,
      platform: constants.PLATFORM,
      sdkVersion: constants.VERSION,
      source: constants.SOURCE,
      // NEXT_MAJOR_VERSION remove one of these to not duplicate data. Target parity with mobile platforms approach.
      integration: constants.INTEGRATION,
      integrationType: constants.INTEGRATION,
      sessionId: sessionId,
    };

    attrs = authData.attrs;
    configUrl = authData.configUrl;

    attrs._meta = analyticsMetadata;
    attrs.braintreeLibraryVersion = constants.BRAINTREE_LIBRARY_VERSION;
    attrs.configVersion = "3";

    reqOptions = {
      url: configUrl,
      method: "GET",
      data: attrs,
    };

    if (attrs.authorizationFingerprint && authData.graphQL) {
      if (isDateStringBeforeOrOn(authData.graphQL.date, BRAINTREE_VERSION)) {
        reqOptions.graphQL = new GraphQL({
          graphQL: {
            url: authData.graphQL.url,
            features: ["configuration"],
          },
        });
      }

      reqOptions.metadata = analyticsMetadata;
    } else if (attrs.tokenizationKey) {
      reqOptions.graphQL = new GraphQL({
        graphQL: {
          url: GRAPHQL_URLS[authData.environment],
          features: ["configuration"],
        },
      });

      reqOptions.metadata = analyticsMetadata;
    }

    // NEXT_MAJOR_VERSION
    // there are various issues with the config endpoint where the values returned
    // do not match the values from the merchant account id passed into a client token
    // we need to update the configuration request endpoint to be able to pass the
    // correct values. The following ones are incorrect
    // * applePayWeb - definitely supportedNetworks, which compiles all the card
    //    networks from all the merchant accounts instead of providing just the
    //    ones from the specified one. The same is probably true for ios apple pay
    //    Also the merchantidentifier
    // NEXT_MAJOR_VERSION Allow passing in merchant account id when creating the component
    // to fetch the config for that merchant account id (particularly helpful when using
    // a tokenization key for authorization)
    request(reqOptions, function (err, response, status) {
      var errorTemplate;

      if (err) {
        if (status === 403) {
          errorTemplate = errors.CLIENT_AUTHORIZATION_INSUFFICIENT;
        } else if (status === 401) {
          errorTemplate = errors.CLIENT_AUTHORIZATION_INVALID;
        } else {
          errorTemplate = errors.CLIENT_GATEWAY_NETWORK;
        }

        reject(
          new BraintreeError({
            type: errorTemplate.type,
            code: errorTemplate.code,
            message: errorTemplate.message,
            details: {
              originalError: err,
            },
          })
        );

        return;
      }

      configuration = {
        authorizationType: attrs.tokenizationKey
          ? "TOKENIZATION_KEY"
          : "CLIENT_TOKEN",
        authorizationFingerprint: attrs.authorizationFingerprint,
        analyticsMetadata: analyticsMetadata,
        gatewayConfiguration: response,
      };

      resolve(configuration);
    });
  });
}

module.exports = {
  getConfiguration: wrapPromise(getConfiguration),
};

},{"../lib/braintree-error":124,"../lib/constants":126,"../lib/is-date-string-before-or-on":151,"./constants":79,"./errors":80,"./request":92,"./request/graphql":90,"@braintree/uuid":39,"@braintree/wrap-promise":43}],82:[function(_dereq_,module,exports){
"use strict";

var BraintreeError = _dereq_("../lib/braintree-error");
var Client = _dereq_("./client");
var VERSION = "3.101.3";
var wrapPromise = _dereq_("@braintree/wrap-promise");
var sharedErrors = _dereq_("../lib/errors");

/** @module braintree-web/client */

/**
 * @function create
 * @description This function is the entry point for the <code>braintree.client</code> module. It is used for creating {@link Client} instances that service communication to Braintree servers.
 * @param {object} options Object containing all {@link Client} options:
 * @param {string} options.authorization A tokenizationKey or clientToken.
 * @param {callback} [callback] The second argument, <code>data</code>, is the {@link Client} instance.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * var createClient = require('braintree-web/client').create;
 *
 * createClient({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (createErr, clientInstance) {
 *   if (createErr) {
 *     if (createErr.code === 'CLIENT_AUTHORIZATION_INVALID') {
 *       // either the client token has expired, and a new one should be generated
 *       // or the tokenization key was deactivated or deleted
 *     } else {
 *       console.log('something went wrong creating the client instance', createErr);
 *     }
 *     return;
 *   }
 *
 *  // set up other components
 * });
 * @static
 */
function create(options) {
  if (!options.authorization) {
    return Promise.reject(
      new BraintreeError({
        type: sharedErrors.INSTANTIATION_OPTION_REQUIRED.type,
        code: sharedErrors.INSTANTIATION_OPTION_REQUIRED.code,
        message:
          "options.authorization is required when instantiating a client.",
      })
    );
  }

  return Client.initialize(options);
}

module.exports = {
  create: wrapPromise(create),
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION,
};

},{"../lib/braintree-error":124,"../lib/errors":135,"./client":78,"@braintree/wrap-promise":43}],83:[function(_dereq_,module,exports){
"use strict";

var querystring = _dereq_("../../lib/querystring");
var assign = _dereq_("../../lib/assign").assign;
var prepBody = _dereq_("./prep-body");
var parseBody = _dereq_("./parse-body");
var xhr = _dereq_("./xhr");
var isXHRAvailable = xhr.isAvailable;
var GraphQLRequest = _dereq_("./graphql/request");
var DefaultRequest = _dereq_("./default-request");

var MAX_TCP_RETRYCOUNT = 1;
var TCP_PRECONNECT_BUG_STATUS_CODE = 408;

function requestShouldRetry(status) {
  return !status || status === TCP_PRECONNECT_BUG_STATUS_CODE;
}

function graphQLRequestShouldRetryWithClientApi(body) {
  var errorClass =
    !body.data &&
    body.errors &&
    body.errors[0] &&
    body.errors[0].extensions &&
    body.errors[0].extensions.errorClass;

  return errorClass === "UNKNOWN" || errorClass === "INTERNAL";
}

function _requestWithRetry(options, tcpRetryCount, cb) {
  var status, resBody, ajaxRequest, body, method, headers, parsedBody;
  var url = options.url;
  var graphQL = options.graphQL;
  var timeout = options.timeout;
  var req = xhr.getRequestObject();
  var callback = cb;
  var isGraphQLRequest = Boolean(
    graphQL && graphQL.isGraphQLRequest(url, options.data)
  );

  options.headers = assign(
    { "Content-Type": "application/json" },
    options.headers
  );

  if (isGraphQLRequest) {
    ajaxRequest = new GraphQLRequest(options);
  } else {
    ajaxRequest = new DefaultRequest(options);
  }

  url = ajaxRequest.getUrl();
  body = ajaxRequest.getBody();
  method = ajaxRequest.getMethod();
  headers = ajaxRequest.getHeaders();

  if (method === "GET") {
    url = querystring.queryify(url, body);
    body = null;
  }

  if (isXHRAvailable) {
    req.onreadystatechange = function () {
      if (req.readyState !== 4) {
        return;
      }

      if (req.status === 0 && isGraphQLRequest) {
        // If a merchant experiences a connection
        // issue to the GraphQL endpoint (possibly
        // due to a Content Security Policy), retry
        // the request against the old client API.
        delete options.graphQL;
        _requestWithRetry(options, tcpRetryCount, cb);

        return;
      }

      parsedBody = parseBody(req.responseText);
      resBody = ajaxRequest.adaptResponseBody(parsedBody);
      status = ajaxRequest.determineStatus(req.status, parsedBody);

      if (status >= 400 || status < 200) {
        if (
          isGraphQLRequest &&
          graphQLRequestShouldRetryWithClientApi(parsedBody)
        ) {
          delete options.graphQL;
          _requestWithRetry(options, tcpRetryCount, cb);

          return;
        }

        if (tcpRetryCount < MAX_TCP_RETRYCOUNT && requestShouldRetry(status)) {
          tcpRetryCount++;
          _requestWithRetry(options, tcpRetryCount, cb);

          return;
        }
        callback(resBody || "error", null, status || 500);
      } else {
        callback(null, resBody, status);
      }
    };
  } else {
    if (options.headers) {
      url = querystring.queryify(url, headers);
    }

    req.onload = function () {
      callback(null, parseBody(req.responseText), req.status);
    };

    req.onerror = function () {
      // XDomainRequest does not report a body or status for errors, so
      // hardcode to 'error' and 500, respectively
      callback("error", null, 500);
    };

    // This must remain for IE9 to work
    req.onprogress = function () {};

    req.ontimeout = function () {
      callback("timeout", null, -1);
    };
  }

  try {
    req.open(method, url, true);
  } catch (requestOpenError) {
    // If a merchant has a Content Security Policy and they have
    // not allowed our endpoints, some browsers may
    // synchronously throw an error. If it is not a GraphQL
    // request, we throw the error. If it is a GraphQL request
    // we remove the GraphQL option and try the request against
    // the old client API.
    if (!isGraphQLRequest) {
      throw requestOpenError;
    }

    delete options.graphQL;

    _requestWithRetry(options, tcpRetryCount, cb);

    return;
  }

  req.timeout = timeout;

  if (isXHRAvailable) {
    Object.keys(headers).forEach(function (headerKey) {
      req.setRequestHeader(headerKey, headers[headerKey]);
    });
  }

  try {
    req.send(prepBody(method, body));
  } catch (e) {
    /* ignored */
  }
}

function request(options, cb) {
  _requestWithRetry(options, 0, cb);
}

module.exports = {
  request: request,
};

},{"../../lib/assign":121,"../../lib/querystring":157,"./default-request":84,"./graphql/request":91,"./parse-body":93,"./prep-body":94,"./xhr":95}],84:[function(_dereq_,module,exports){
"use strict";

function DefaultRequest(options) {
  this._url = options.url;
  this._data = options.data;
  this._method = options.method;
  this._headers = options.headers;
}

DefaultRequest.prototype.getUrl = function () {
  return this._url;
};

DefaultRequest.prototype.getBody = function () {
  return this._data;
};

DefaultRequest.prototype.getMethod = function () {
  return this._method;
};

DefaultRequest.prototype.getHeaders = function () {
  return this._headers;
};

DefaultRequest.prototype.adaptResponseBody = function (parsedBody) {
  return parsedBody;
};

DefaultRequest.prototype.determineStatus = function (status) {
  return status;
};

module.exports = DefaultRequest;

},{}],85:[function(_dereq_,module,exports){
"use strict";

var errorResponseAdapter = _dereq_("./error");
var assign = _dereq_("../../../../lib/assign").assign;

/* eslint-disable camelcase */
var cardTypeTransforms = {
  creditCard: {
    AMERICAN_EXPRESS: "American Express",
    DISCOVER: "Discover",
    INTERNATIONAL_MAESTRO: "Maestro",
    JCB: "JCB",
    MASTERCARD: "MasterCard",
    SOLO: "Solo",
    UK_MAESTRO: "UK Maestro",
    UNION_PAY: "UnionPay",
    VISA: "Visa",
    ELO: "Elo",
    HIPER: "Hiper",
    HIPERCARD: "Hipercard",
  },
  applePayWeb: {
    VISA: "visa",
    MASTERCARD: "mastercard",
    DISCOVER: "discover",
    AMERICAN_EXPRESS: "amex",
    INTERNATIONAL_MAESTRO: "maestro",
    ELO: "elo",
  },
  visaCheckout: {
    VISA: "Visa",
    MASTERCARD: "MasterCard",
    DISCOVER: "Discover",
    AMERICAN_EXPRESS: "American Express",
  },
  googlePay: {
    VISA: "visa",
    MASTERCARD: "mastercard",
    DISCOVER: "discover",
    AMERICAN_EXPRESS: "amex",
    INTERNATIONAL_MAESTRO: "maestro",
    ELO: "elo",
  },
  masterpass: {
    VISA: "visa",
    MASTERCARD: "master",
    DISCOVER: "discover",
    AMERICAN_EXPRESS: "amex",
    DINERS: "diners",
    INTERNATIONAL_MAESTRO: "maestro",
    JCB: "jcb",
  },
};
/* eslint-enable camelcase */

function configurationResponseAdapter(responseBody, ctx) {
  var adaptedResponse;

  if (responseBody.data && !responseBody.errors) {
    adaptedResponse = adaptConfigurationResponseBody(responseBody, ctx);
  } else {
    adaptedResponse = errorResponseAdapter(responseBody);
  }

  return adaptedResponse;
}

function adaptConfigurationResponseBody(body, ctx) {
  var configuration = body.data.clientConfiguration;
  var response;

  response = {
    environment: configuration.environment.toLowerCase(),
    clientApiUrl: configuration.clientApiUrl,
    assetsUrl: configuration.assetsUrl,
    analytics: {
      url: configuration.analyticsUrl,
    },
    merchantId: configuration.merchantId,
    venmo: "off",
  };

  if (configuration.supportedFeatures) {
    response.graphQL = {
      url: ctx._graphQL._config.url,
      features: configuration.supportedFeatures.map(function (feature) {
        return feature.toLowerCase();
      }),
    };
  }

  if (configuration.braintreeApi) {
    response.braintreeApi = configuration.braintreeApi;
  }

  if (configuration.applePayWeb) {
    response.applePayWeb = configuration.applePayWeb;
    response.applePayWeb.supportedNetworks = mapCardTypes(
      configuration.applePayWeb.supportedCardBrands,
      cardTypeTransforms.applePayWeb
    );

    delete response.applePayWeb.supportedCardBrands;
  }

  if (configuration.ideal) {
    response.ideal = configuration.ideal;
  }

  if (configuration.kount) {
    response.kount = {
      kountMerchantId: configuration.kount.merchantId,
    };
  }

  if (configuration.creditCard) {
    response.challenges = configuration.creditCard.challenges.map(function (
      challenge
    ) {
      return challenge.toLowerCase();
    });

    response.creditCards = {
      supportedCardTypes: mapCardTypes(
        configuration.creditCard.supportedCardBrands,
        cardTypeTransforms.creditCard
      ),
    };
    response.threeDSecureEnabled = configuration.creditCard.threeDSecureEnabled;
    response.threeDSecure = configuration.creditCard.threeDSecure;
  } else {
    response.challenges = [];
    response.creditCards = {
      supportedCardTypes: [],
    };
    response.threeDSecureEnabled = false;
  }

  if (configuration.googlePay) {
    response.androidPay = {
      displayName: configuration.googlePay.displayName,
      enabled: true,
      environment: configuration.googlePay.environment.toLowerCase(),
      googleAuthorizationFingerprint:
        configuration.googlePay.googleAuthorization,
      paypalClientId: configuration.googlePay.paypalClientId,
      supportedNetworks: mapCardTypes(
        configuration.googlePay.supportedCardBrands,
        cardTypeTransforms.googlePay
      ),
    };
  }

  if (configuration.venmo) {
    response.payWithVenmo = {
      merchantId: configuration.venmo.merchantId,
      accessToken: configuration.venmo.accessToken,
      environment: configuration.venmo.environment.toLowerCase(),
      enrichedCustomerDataEnabled:
        configuration.venmo.enrichedCustomerDataEnabled,
    };
  }

  if (configuration.paypal) {
    response.paypalEnabled = true;
    response.paypal = assign({}, configuration.paypal);
    response.paypal.currencyIsoCode = response.paypal.currencyCode;
    response.paypal.environment = response.paypal.environment.toLowerCase();

    delete response.paypal.currencyCode;
  } else {
    response.paypalEnabled = false;
  }

  if (configuration.unionPay) {
    response.unionPay = {
      enabled: true,
      merchantAccountId: configuration.unionPay.merchantAccountId,
    };
  }

  if (configuration.visaCheckout) {
    response.visaCheckout = {
      apikey: configuration.visaCheckout.apiKey,
      encryptionKey: configuration.visaCheckout.encryptionKey,
      externalClientId: configuration.visaCheckout.externalClientId,
      supportedCardTypes: mapCardTypes(
        configuration.visaCheckout.supportedCardBrands,
        cardTypeTransforms.visaCheckout
      ),
    };
  }

  if (configuration.masterpass) {
    response.masterpass = {
      merchantCheckoutId: configuration.masterpass.merchantCheckoutId,
      supportedNetworks: mapCardTypes(
        configuration.masterpass.supportedCardBrands,
        cardTypeTransforms.masterpass
      ),
    };
  }

  if (configuration.usBankAccount) {
    response.usBankAccount = {
      routeId: configuration.usBankAccount.routeId,
      plaid: {
        publicKey: configuration.usBankAccount.plaidPublicKey,
      },
    };
  }

  return response;
}

function mapCardTypes(cardTypes, cardTypeTransformMap) {
  return cardTypes.reduce(function (acc, type) {
    if (cardTypeTransformMap.hasOwnProperty(type)) {
      return acc.concat(cardTypeTransformMap[type]);
    }

    return acc;
  }, []);
}

module.exports = configurationResponseAdapter;

},{"../../../../lib/assign":121,"./error":87}],86:[function(_dereq_,module,exports){
"use strict";

var errorResponseAdapter = _dereq_("./error");

var CARD_BRAND_MAP = {
  /* eslint-disable camelcase */
  AMERICAN_EXPRESS: "American Express",
  DINERS: "Discover",
  DISCOVER: "Discover",
  ELO: "Elo",
  HIPER: "Hiper",
  HIPERCARD: "Hipercard",
  INTERNATIONAL_MAESTRO: "Maestro",
  JCB: "JCB",
  MASTERCARD: "MasterCard",
  UK_MAESTRO: "Maestro",
  UNION_PAY: "UnionPay",
  VISA: "Visa",
  /* eslint-enable camelcase */
};

var BIN_DATA_MAP = {
  YES: "Yes",
  NO: "No",
  UNKNOWN: "Unknown",
};

var AUTHENTICATION_INSIGHT_MAP = {
  PSDTWO: "psd2",
};

function creditCardTokenizationResponseAdapter(responseBody) {
  var adaptedResponse;

  if (responseBody.data && !responseBody.errors) {
    adaptedResponse = adaptTokenizeCreditCardResponseBody(responseBody);
  } else {
    adaptedResponse = errorResponseAdapter(responseBody);
  }

  return adaptedResponse;
}

function adaptTokenizeCreditCardResponseBody(body) {
  var data = body.data.tokenizeCreditCard;
  var creditCard = data.creditCard;
  var lastTwo = creditCard.last4 ? creditCard.last4.substr(2, 4) : "";
  var binData = creditCard.binData;
  var response, regulationEnvironment;

  if (binData) {
    [
      "commercial",
      "debit",
      "durbinRegulated",
      "healthcare",
      "payroll",
      "prepaid",
    ].forEach(function (key) {
      if (binData[key]) {
        binData[key] = BIN_DATA_MAP[binData[key]];
      } else {
        binData[key] = "Unknown";
      }
    });

    ["issuingBank", "countryOfIssuance", "productId"].forEach(function (key) {
      if (!binData[key]) {
        binData[key] = "Unknown";
      }
    });
  }

  response = {
    creditCards: [
      {
        binData: binData,
        consumed: false,
        description: lastTwo ? "ending in " + lastTwo : "",
        nonce: data.token,
        details: {
          cardholderName: creditCard.cardholderName,
          expirationMonth: creditCard.expirationMonth,
          expirationYear: creditCard.expirationYear,
          bin: creditCard.bin || "",
          cardType: CARD_BRAND_MAP[creditCard.brandCode] || "Unknown",
          lastFour: creditCard.last4 || "",
          lastTwo: lastTwo,
        },
        type: "CreditCard",
        threeDSecureInfo: null,
      },
    ],
  };

  if (data.authenticationInsight) {
    regulationEnvironment =
      data.authenticationInsight.customerAuthenticationRegulationEnvironment;
    response.creditCards[0].authenticationInsight = {
      regulationEnvironment:
        AUTHENTICATION_INSIGHT_MAP[regulationEnvironment] ||
        regulationEnvironment.toLowerCase(),
    };
  }

  return response;
}

module.exports = creditCardTokenizationResponseAdapter;

},{"./error":87}],87:[function(_dereq_,module,exports){
"use strict";

function errorResponseAdapter(responseBody) {
  var response;
  var errorClass =
    responseBody.errors &&
    responseBody.errors[0] &&
    responseBody.errors[0].extensions &&
    responseBody.errors[0].extensions.errorClass;

  if (errorClass === "VALIDATION") {
    response = userErrorResponseAdapter(responseBody);
  } else if (errorClass) {
    response = errorWithClassResponseAdapter(responseBody);
  } else {
    response = {
      error: { message: "There was a problem serving your request" },
      fieldErrors: [],
    };
  }

  return response;
}

function errorWithClassResponseAdapter(responseBody) {
  return {
    error: { message: responseBody.errors[0].message },
    fieldErrors: [],
  };
}

function userErrorResponseAdapter(responseBody) {
  var fieldErrors = buildFieldErrors(responseBody.errors);

  if (fieldErrors.length === 0) {
    return { error: { message: responseBody.errors[0].message } };
  }

  return {
    error: { message: getLegacyMessage(fieldErrors) },
    fieldErrors: fieldErrors,
  };
}

function buildFieldErrors(errors) {
  var fieldErrors = [];

  errors.forEach(function (error) {
    if (!(error.extensions && error.extensions.inputPath)) {
      return;
    }
    addFieldError(error.extensions.inputPath.slice(1), error, fieldErrors);
  });

  return fieldErrors;
}

function addFieldError(inputPath, errorDetail, fieldErrors) {
  var fieldError;
  var legacyCode = errorDetail.extensions.legacyCode;
  var inputField = inputPath[0];

  if (inputPath.length === 1) {
    fieldErrors.push({
      code: legacyCode,
      field: inputField,
      message: errorDetail.message,
    });

    return;
  }

  fieldErrors.forEach(function (candidate) {
    if (candidate.field === inputField) {
      fieldError = candidate;
    }
  });

  if (!fieldError) {
    fieldError = { field: inputField, fieldErrors: [] };
    fieldErrors.push(fieldError);
  }

  addFieldError(inputPath.slice(1), errorDetail, fieldError.fieldErrors);
}

function getLegacyMessage(errors) {
  var legacyMessages = {
    creditCard: "Credit card is invalid",
  };

  var field = errors[0].field;

  return legacyMessages[field];
}

module.exports = errorResponseAdapter;

},{}],88:[function(_dereq_,module,exports){
"use strict";

var CONFIGURATION_QUERY =
  "query ClientConfiguration { " +
  "  clientConfiguration { " +
  "    analyticsUrl " +
  "    environment " +
  "    merchantId " +
  "    assetsUrl " +
  "    clientApiUrl " +
  "    creditCard { " +
  "      supportedCardBrands " +
  "      challenges " +
  "      threeDSecureEnabled " +
  "      threeDSecure { " +
  "        cardinalAuthenticationJWT " +
  "      } " +
  "    } " +
  "    applePayWeb { " +
  "      countryCode " +
  "      currencyCode " +
  "      merchantIdentifier " +
  "      supportedCardBrands " +
  "    } " +
  "    googlePay { " +
  "      displayName " +
  "      supportedCardBrands " +
  "      environment " +
  "      googleAuthorization " +
  "      paypalClientId " +
  "    } " +
  "    ideal { " +
  "      routeId " +
  "      assetsUrl " +
  "    } " +
  "    kount { " +
  "      merchantId " +
  "    } " +
  "    masterpass { " +
  "      merchantCheckoutId " +
  "      supportedCardBrands " +
  "    } " +
  "    paypal { " +
  "      displayName " +
  "      clientId " +
  "      assetsUrl " +
  "      environment " +
  "      environmentNoNetwork " +
  "      unvettedMerchant " +
  "      braintreeClientId " +
  "      billingAgreementsEnabled " +
  "      merchantAccountId " +
  "      currencyCode " +
  "      payeeEmail " +
  "    } " +
  "    unionPay { " +
  "      merchantAccountId " +
  "    } " +
  "    usBankAccount { " +
  "      routeId " +
  "      plaidPublicKey " +
  "    } " +
  "    venmo { " +
  "      merchantId " +
  "      accessToken " +
  "      environment " +
  "      enrichedCustomerDataEnabled" +
  "    } " +
  "    visaCheckout { " +
  "      apiKey " +
  "      externalClientId " +
  "      supportedCardBrands " +
  "    } " +
  "    braintreeApi { " +
  "      accessToken " +
  "      url " +
  "    } " +
  "    supportedFeatures " +
  "  } " +
  "}";

function configuration() {
  return {
    query: CONFIGURATION_QUERY,
    operationName: "ClientConfiguration",
  };
}

module.exports = configuration;

},{}],89:[function(_dereq_,module,exports){
"use strict";

var assign = _dereq_("../../../../lib/assign").assign;

function createMutation(config) {
  var hasAuthenticationInsight = config.hasAuthenticationInsight;
  var mutation = "mutation TokenizeCreditCard($input: TokenizeCreditCardInput!";

  if (hasAuthenticationInsight) {
    mutation += ", $authenticationInsightInput: AuthenticationInsightInput!";
  }

  mutation +=
    ") { " +
    "  tokenizeCreditCard(input: $input) { " +
    "    token " +
    "    creditCard { " +
    "      bin " +
    "      brandCode " +
    "      last4 " +
    "      cardholderName " +
    "      expirationMonth" +
    "      expirationYear" +
    "      binData { " +
    "        prepaid " +
    "        healthcare " +
    "        debit " +
    "        durbinRegulated " +
    "        commercial " +
    "        payroll " +
    "        issuingBank " +
    "        countryOfIssuance " +
    "        productId " +
    "      } " +
    "    } ";

  if (hasAuthenticationInsight) {
    mutation +=
      "    authenticationInsight(input: $authenticationInsightInput) {" +
      "      customerAuthenticationRegulationEnvironment" +
      "    }";
  }

  mutation += "  } }";

  return mutation;
}

function createCreditCardTokenizationBody(body, options) {
  var cc = body.creditCard;
  var billingAddress = cc && cc.billingAddress;
  var expDate = cc && cc.expirationDate;
  var expirationMonth =
    cc && (cc.expirationMonth || (expDate && expDate.split("/")[0].trim()));
  var expirationYear =
    cc && (cc.expirationYear || (expDate && expDate.split("/")[1].trim()));
  var variables = {
    input: {
      creditCard: {
        number: cc && cc.number,
        expirationMonth: expirationMonth,
        expirationYear: expirationYear,
        cvv: cc && cc.cvv,
        cardholderName: cc && cc.cardholderName,
      },
      options: {},
    },
  };

  if (options.hasAuthenticationInsight) {
    variables.authenticationInsightInput = {
      merchantAccountId: body.merchantAccountId,
    };
  }

  if (billingAddress) {
    variables.input.creditCard.billingAddress = billingAddress;
  }

  variables.input = addValidationRule(body, variables.input);

  return variables;
}

function addValidationRule(body, input) {
  var validate;

  if (
    body.creditCard &&
    body.creditCard.options &&
    typeof body.creditCard.options.validate === "boolean"
  ) {
    validate = body.creditCard.options.validate;
  } else if (
    (body.authorizationFingerprint && body.tokenizationKey) ||
    body.authorizationFingerprint
  ) {
    validate = true;
  } else if (body.tokenizationKey) {
    validate = false;
  }

  if (typeof validate === "boolean") {
    input.options = assign(
      {
        validate: validate,
      },
      input.options
    );
  }

  return input;
}

function creditCardTokenization(body) {
  var options = {
    hasAuthenticationInsight: Boolean(
      body.authenticationInsight && body.merchantAccountId
    ),
  };

  return {
    query: createMutation(options),
    variables: createCreditCardTokenizationBody(body, options),
    operationName: "TokenizeCreditCard",
  };
}

module.exports = creditCardTokenization;

},{"../../../../lib/assign":121}],90:[function(_dereq_,module,exports){
"use strict";

var features = {
  tokenize_credit_cards: "payment_methods/credit_cards", // eslint-disable-line camelcase
  configuration: "configuration",
};

var disallowedInputPaths = ["creditCard.options.unionPayEnrollment"];

function GraphQL(config) {
  this._config = config.graphQL;
}

GraphQL.prototype.getGraphQLEndpoint = function () {
  return this._config.url;
};

GraphQL.prototype.isGraphQLRequest = function (url, body) {
  var featureEnabled;
  var path = this.getClientApiPath(url);

  if (!this._isGraphQLEnabled() || !path) {
    return false;
  }

  featureEnabled = this._config.features.some(function (feature) {
    return features[feature] === path;
  });

  if (containsDisallowedlistedKeys(body)) {
    return false;
  }

  return featureEnabled;
};

GraphQL.prototype.getClientApiPath = function (url) {
  var path;
  var clientApiPrefix = "/client_api/v1/";
  var pathParts = url.split(clientApiPrefix);

  if (pathParts.length > 1) {
    path = pathParts[1].split("?")[0];
  }

  return path;
};

GraphQL.prototype._isGraphQLEnabled = function () {
  return Boolean(this._config);
};

function containsDisallowedlistedKeys(body) {
  return disallowedInputPaths.some(function (keys) {
    var value = keys.split(".").reduce(function (accumulator, key) {
      return accumulator && accumulator[key];
    }, body);

    return value !== undefined; // eslint-disable-line no-undefined
  });
}

module.exports = GraphQL;

},{}],91:[function(_dereq_,module,exports){
"use strict";

var BRAINTREE_VERSION = _dereq_("../../constants").BRAINTREE_VERSION;

var assign = _dereq_("../../../lib/assign").assign;
var snakeCaseToCamelCase = _dereq_("../../../lib/snake-case-to-camel-case");

var creditCardTokenizationBodyGenerator = _dereq_("./generators/credit-card-tokenization");
var creditCardTokenizationResponseAdapter = _dereq_("./adapters/credit-card-tokenization");

var configurationBodyGenerator = _dereq_("./generators/configuration");
var configurationResponseAdapter = _dereq_("./adapters/configuration");

var generators = {
  "payment_methods/credit_cards": creditCardTokenizationBodyGenerator,
  configuration: configurationBodyGenerator,
};
var adapters = {
  "payment_methods/credit_cards": creditCardTokenizationResponseAdapter,
  configuration: configurationResponseAdapter,
};

function GraphQLRequest(options) {
  var clientApiPath = options.graphQL.getClientApiPath(options.url);

  this._graphQL = options.graphQL;
  this._data = options.data;
  this._method = options.method;
  this._headers = options.headers;
  this._clientSdkMetadata = {
    source: options.metadata.source,
    integration: options.metadata.integration,
    sessionId: options.metadata.sessionId,
  };
  this._sendAnalyticsEvent = options.sendAnalyticsEvent || Function.prototype;

  this._generator = generators[clientApiPath];
  this._adapter = adapters[clientApiPath];

  this._sendAnalyticsEvent("graphql.init");
}

GraphQLRequest.prototype.getUrl = function () {
  return this._graphQL.getGraphQLEndpoint();
};

GraphQLRequest.prototype.getBody = function () {
  var formattedBody = formatBodyKeys(this._data);
  var generatedBody = this._generator(formattedBody);
  var body = assign(
    { clientSdkMetadata: this._clientSdkMetadata },
    generatedBody
  );

  return JSON.stringify(body);
};

GraphQLRequest.prototype.getMethod = function () {
  return "POST";
};

GraphQLRequest.prototype.getHeaders = function () {
  var authorization, headers;

  if (this._data.authorizationFingerprint) {
    this._sendAnalyticsEvent("graphql.authorization-fingerprint");
    authorization = this._data.authorizationFingerprint;
  } else {
    this._sendAnalyticsEvent("graphql.tokenization-key");
    authorization = this._data.tokenizationKey;
  }

  headers = {
    Authorization: "Bearer " + authorization,
    "Braintree-Version": BRAINTREE_VERSION,
  };

  return assign({}, this._headers, headers);
};

GraphQLRequest.prototype.adaptResponseBody = function (parsedBody) {
  return this._adapter(parsedBody, this);
};

GraphQLRequest.prototype.determineStatus = function (
  httpStatus,
  parsedResponse
) {
  var status, errorClass;

  if (httpStatus === 200) {
    errorClass =
      parsedResponse.errors &&
      parsedResponse.errors[0] &&
      parsedResponse.errors[0].extensions &&
      parsedResponse.errors[0].extensions.errorClass;

    if (parsedResponse.data && !parsedResponse.errors) {
      status = 200;
    } else if (errorClass === "VALIDATION") {
      status = 422;
    } else if (errorClass === "AUTHORIZATION") {
      status = 403;
    } else if (errorClass === "AUTHENTICATION") {
      status = 401;
    } else if (isGraphQLError(errorClass, parsedResponse)) {
      status = 403;
    } else {
      status = 500;
    }
  } else if (!httpStatus) {
    status = 500;
  } else {
    status = httpStatus;
  }

  this._sendAnalyticsEvent("graphql.status." + httpStatus);
  this._sendAnalyticsEvent("graphql.determinedStatus." + status);

  return status;
};

function isGraphQLError(errorClass, parsedResponse) {
  return !errorClass && parsedResponse.errors[0].message;
}

function formatBodyKeys(originalBody) {
  var body = {};

  Object.keys(originalBody).forEach(function (key) {
    var camelCaseKey = snakeCaseToCamelCase(key);

    if (typeof originalBody[key] === "object") {
      body[camelCaseKey] = formatBodyKeys(originalBody[key]);
    } else if (typeof originalBody[key] === "number") {
      body[camelCaseKey] = String(originalBody[key]);
    } else {
      body[camelCaseKey] = originalBody[key];
    }
  });

  return body;
}

module.exports = GraphQLRequest;

},{"../../../lib/assign":121,"../../../lib/snake-case-to-camel-case":159,"../../constants":79,"./adapters/configuration":85,"./adapters/credit-card-tokenization":86,"./generators/configuration":88,"./generators/credit-card-tokenization":89}],92:[function(_dereq_,module,exports){
"use strict";

var once = _dereq_("../../lib/once");
var AJAXDriver = _dereq_("./ajax-driver");

module.exports = function (options, cb) {
  cb = once(cb || Function.prototype);
  options.method = (options.method || "GET").toUpperCase();
  options.timeout = options.timeout == null ? 60000 : options.timeout;
  options.data = options.data || {};

  AJAXDriver.request(options, cb);
};

},{"../../lib/once":156,"./ajax-driver":83}],93:[function(_dereq_,module,exports){
"use strict";

module.exports = function (body) {
  try {
    body = JSON.parse(body);
  } catch (e) {
    /* ignored */
  }

  return body;
};

},{}],94:[function(_dereq_,module,exports){
"use strict";

module.exports = function (method, body) {
  if (typeof method !== "string") {
    throw new Error("Method must be a string");
  }

  if (method.toLowerCase() !== "get" && body != null) {
    body = typeof body === "string" ? body : JSON.stringify(body);
  }

  return body;
};

},{}],95:[function(_dereq_,module,exports){
"use strict";

var isXHRAvailable =
  typeof window !== "undefined" &&
  window.XMLHttpRequest &&
  "withCredentials" in new window.XMLHttpRequest();

function getRequestObject() {
  return isXHRAvailable
    ? new window.XMLHttpRequest()
    : new window.XDomainRequest();
}

module.exports = {
  isAvailable: isXHRAvailable,
  getRequestObject: getRequestObject,
};

},{}],96:[function(_dereq_,module,exports){
"use strict";

/**
 * @name BraintreeError.Data Collector - Creation Error Codes
 * @description Errors that occur when [creating the Data Collector component](./module-braintree-web_data-collector.html#.create).
 * @property {MERCHANT} DATA_COLLECTOR_KOUNT_NOT_ENABLED Occurs when Kount is enabled in creation options but is not enabled on the Braintree control panel.
 * @property {MERCHANT} DATA_COLLECTOR_KOUNT_ERROR Occurs when Kount errors while setting up.
 * @property {MERCHANT} DATA_COLLECTOR_REQUIRES_CREATE_OPTIONS Occurs when Kount or PayPal Fraudnet could not be enabled.
 */

var BraintreeError = _dereq_("../lib/braintree-error");

module.exports = {
  DATA_COLLECTOR_KOUNT_NOT_ENABLED: {
    type: BraintreeError.types.MERCHANT,
    code: "DATA_COLLECTOR_KOUNT_NOT_ENABLED",
    message: "Kount is not enabled for this merchant.",
  },
  DATA_COLLECTOR_KOUNT_ERROR: {
    type: BraintreeError.types.MERCHANT,
    code: "DATA_COLLECTOR_KOUNT_ERROR",
  },
  DATA_COLLECTOR_REQUIRES_CREATE_OPTIONS: {
    type: BraintreeError.types.MERCHANT,
    code: "DATA_COLLECTOR_REQUIRES_CREATE_OPTIONS",
    message: "Data Collector must be created with Kount and/or PayPal.",
  },
};

},{"../lib/braintree-error":124}],97:[function(_dereq_,module,exports){
"use strict";

var FRAUDNET_FNCLS = _dereq_("../lib/constants").FRAUDNET_FNCLS;
var FRAUDNET_SOURCE = _dereq_("../lib/constants").FRAUDNET_SOURCE;
var FRAUDNET_URL = _dereq_("../lib/constants").FRAUDNET_URL;
var loadScript = _dereq_("../lib/assets").loadScript;

var cachedSessionId;

function setup(options) {
  var fraudNet = new Fraudnet();

  options = options || {};

  if (!options.sessionId && cachedSessionId) {
    fraudNet.sessionId = cachedSessionId;

    return Promise.resolve(fraudNet);
  }

  return fraudNet.initialize(options);
}

function clearSessionIdCache() {
  cachedSessionId = null;
}

function Fraudnet() {}

Fraudnet.prototype.initialize = function (options) {
  var environment = options.environment;
  var self = this;

  this.sessionId = options.sessionId || _generateSessionId();
  if (!options.sessionId) {
    cachedSessionId = this.sessionId;
  }
  this._beaconId = _generateBeaconId(this.sessionId);
  this._parameterBlock = _createParameterBlock(
    this.sessionId,
    this._beaconId,
    environment
  );

  return loadScript({
    src: FRAUDNET_URL,
  })
    .then(function (block) {
      self._thirdPartyBlock = block;

      return self;
    })
    .catch(function () {
      // if the fraudnet script fails to load
      // we just resolve with nothing
      // and data collector ignores it
      return null;
    });
};

Fraudnet.prototype.teardown = function () {
  removeElementIfOnPage(document.querySelector('iframe[title="ppfniframe"]'));
  removeElementIfOnPage(document.querySelector('iframe[title="pbf"]'));

  removeElementIfOnPage(this._parameterBlock);
  removeElementIfOnPage(this._thirdPartyBlock);
};

function removeElementIfOnPage(element) {
  if (element && element.parentNode) {
    element.parentNode.removeChild(element);
  }
}

function _generateSessionId() {
  var i;
  var id = "";

  for (i = 0; i < 32; i++) {
    id += Math.floor(Math.random() * 16).toString(16);
  }

  return id;
}

function _generateBeaconId(sessionId) {
  var timestamp = new Date().getTime() / 1000;

  return (
    "https://b.stats.paypal.com/counter.cgi" +
    "?i=127.0.0.1" +
    "&p=" +
    sessionId +
    "&t=" +
    timestamp +
    "&a=14"
  );
}

function _createParameterBlock(sessionId, beaconId, environment) {
  var el = document.body.appendChild(document.createElement("script"));
  var config = {
    f: sessionId,
    s: FRAUDNET_SOURCE,
    b: beaconId,
  };

  // for some reason, the presence of the sandbox
  // attribute in a production environment causes
  // some weird behavior with what url paths are
  // hit, so instead, we only apply this attribute
  // when it is not a production environment
  if (environment !== "production") {
    config.sandbox = true;
  }

  el.type = "application/json";
  el.setAttribute("fncls", FRAUDNET_FNCLS);
  el.text = JSON.stringify(config);

  return el;
}

module.exports = {
  setup: setup,
  clearSessionIdCache: clearSessionIdCache,
};

},{"../lib/assets":120,"../lib/constants":126}],98:[function(_dereq_,module,exports){
"use strict";
/** @module braintree-web/data-collector */

var kount = _dereq_("./kount");
var fraudnet = _dereq_("./fraudnet");
var BraintreeError = _dereq_("../lib/braintree-error");
var basicComponentVerification = _dereq_("../lib/basic-component-verification");
var createDeferredClient = _dereq_("../lib/create-deferred-client");
var createAssetsUrl = _dereq_("../lib/create-assets-url");
var methods = _dereq_("../lib/methods");
var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
var VERSION = "3.101.3";
var wrapPromise = _dereq_("@braintree/wrap-promise");
var errors = _dereq_("./errors");

/**
 * @class
 * @global
 * @name DataCollector
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/data-collector.create|braintree-web.data-collector.create} instead.</strong>
 * @classdesc This class is used for fraud integration with PayPal and Kount. Instances of this class have {@link DataCollector#deviceData|deviceData} which is used to correlate user sessions with server transactions.
 */

/**
 * @memberof DataCollector
 * @name deviceData
 * @type string
 * @description JSON string to pass with server transactions.
 * @instance
 */

/**
 * @memberof DataCollector
 * @name rawDeviceData
 * @type object
 * @description The device data as an object instead of a string.
 * @instance
 */

/**
 * @memberof DataCollector
 * @name teardown
 * @function
 * @description Cleanly remove anything set up by {@link module:braintree-web/data-collector.create|create}.
 * @param {callback} [callback] Called on completion. If no callback is provided, `teardown` returns a promise.
 * @instance
 * @example
 * dataCollectorInstance.teardown();
 * @example <caption>With callback</caption>
 * dataCollectorInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */

/**
 * @memberof DataCollector
 * @name getDeviceData
 * @function
 * @description Resolves with device data once it is ready.
 * @param {object} [options] Options for how device data is resolved.
 * @param {boolean} [options.raw=false] When set to true, the device data will resolve as an object instead of a JSON string.
 * @param {callback} [callback] Called on completion. If no callback is provided, `getDeviceData` returns a promise.
 * @instance
 * @example
 * dataCollectorInstance.getDeviceData();
 * @example <caption>Without options</caption>
 * dataCollectorInstance.getDeviceData().then(function (deviceData) {
 *   // typeof deviceData === 'string'
 *   // pass onto your server with the payment method nonce
 * });
 * @example <caption>With options</caption>
 * dataCollectorInstance.getDeviceData({
 *   raw: true
 * }).then(function (deviceData) {
 *   // typeof deviceData === 'object'
 *   // for if you'd like to parse the data before sending it to your server
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */

/**
 * @static
 * @function create
 * @description Creates a DataCollector instance and collects device data based on your merchant configuration. We recommend that you call this method as early as possible, e.g. as soon as your website loads. If that's too early, call it at the beginning of customer checkout.
 * **Note:** To use your own Kount ID, contact our support team ([support@braintreepayments.com](mailto:support@braintreepayments.com) or [877.434.2894](tel:877.434.2894)).
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {boolean} [options.useDeferredClient] Used in conjunction with `authorization`, allows the Data Collector instance to be available right away by fetching the client configuration in the background. When this option is used, {@link GooglePayment#getDeviceData} must be used to collect the device data.
 * @param {boolean} [options.kount] Kount fraud data collection will occur if the merchant configuration has it enabled.
 * **Note:** the data sent to Kount is asynchronous and may not have completed by the time the data collector create call is complete. In most cases, this will not matter, but if you create the data collector instance and immediately navigate away from the page, the device information may fail to be sent to Kount.
 * @param {boolean} [options.paypal] *Deprecated:* PayPal fraud data collection will occur when the DataCollector instance is created.
 * @param {string} [options.riskCorrelationId] Pass a custom risk correlation id when creating the data collector.
 * @param {string} [options.clientMetadataId] Deprecated. Use `options.riskCorrelationId` instead.
 * @param {string} [options.correlationId] Deprecated. Use `options.riskCorrelationId` instead.
 * @param {callback} [callback] The second argument, `data`, is the {@link DataCollector} instance.
 * @returns {(Promise|void)} Returns a promise that resolves the {@link DataCollector} instance if no callback is provided.
 */
function create(options) {
  var name = "Data Collector";
  var result = {
    _instances: [],
  };
  var data;

  return basicComponentVerification
    .verify({
      name: name,
      client: options.client,
      authorization: options.authorization,
    })
    .then(function () {
      result._instantiatedWithAClient = !options.useDeferredClient;
      result._createPromise = createDeferredClient
        .create({
          authorization: options.authorization,
          client: options.client,
          debug: options.debug,
          assetsUrl: createAssetsUrl.create(options.authorization),
          name: name,
        })
        .then(function (client) {
          var kountInstance;
          var config = client.getConfiguration();

          if (options.kount === true && config.gatewayConfiguration.kount) {
            try {
              kountInstance = kount.setup({
                environment: config.gatewayConfiguration.environment,
                merchantId: config.gatewayConfiguration.kount.kountMerchantId,
              });
            } catch (err) {
              return Promise.reject(
                new BraintreeError({
                  type: errors.DATA_COLLECTOR_KOUNT_ERROR.type,
                  code: errors.DATA_COLLECTOR_KOUNT_ERROR.code,
                  message: err.message,
                })
              );
            }

            data = kountInstance.deviceData;
            result._instances.push(kountInstance);
          } else {
            data = {};
          }

          return Promise.resolve(client);
        })
        .then(function (client) {
          return fraudnet
            .setup({
              sessionId:
                options.riskCorrelationId ||
                options.clientMetadataId ||
                options.correlationId,
              environment:
                client.getConfiguration().gatewayConfiguration.environment,
            })
            .then(function (fraudnetInstance) {
              if (fraudnetInstance) {
                data.correlation_id = fraudnetInstance.sessionId; // eslint-disable-line camelcase
                result._instances.push(fraudnetInstance);
              }
            });
        })
        .then(function () {
          if (result._instances.length === 0) {
            // NEXT_MAJOR_VERSION either this should error with a specific error that
            // no data collector instances could be set up, or we should just swallow
            // the error and document that no device data will be returned if
            // data collector cannot be instantiated. We can't change the error code here
            // without possibly breaking merchant integrations relying on this inccorrect
            // behavior.
            return Promise.reject(
              new BraintreeError(errors.DATA_COLLECTOR_REQUIRES_CREATE_OPTIONS)
            );
          }

          result.deviceData = JSON.stringify(data);
          result.rawDeviceData = data;

          return result;
        });

      result.teardown = createTeardownMethod(result);
      result.getDeviceData = createGetDeviceDataMethod(result);

      if (result._instantiatedWithAClient) {
        return result._createPromise;
      }

      return result;
    });
}

function createTeardownMethod(result) {
  return wrapPromise(function teardown() {
    return result._createPromise.then(function () {
      result._instances.forEach(function (instance) {
        if (instance) {
          instance.teardown();
        }
      });

      convertMethodsToError(result, methods(result));
    });
  });
}

function createGetDeviceDataMethod(result) {
  return wrapPromise(function getDeviceData(options) {
    options = options || {};

    return result._createPromise.then(function () {
      if (options.raw) {
        return Promise.resolve(result.rawDeviceData);
      }

      return Promise.resolve(result.deviceData);
    });
  });
}

module.exports = {
  create: wrapPromise(create),
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION,
};

},{"../lib/basic-component-verification":122,"../lib/braintree-error":124,"../lib/convert-methods-to-error":127,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"../lib/methods":155,"./errors":96,"./fraudnet":97,"./kount":99,"@braintree/wrap-promise":43}],99:[function(_dereq_,module,exports){
"use strict";

var sjcl = _dereq_("./vendor/sjcl");
var camelCaseToSnakeCase = _dereq_("../lib/camel-case-to-snake-case");

var QA_URL = "https://assets.qa.braintreepayments.com/data";
var IFRAME_ID_PREFIX = "braintreeDataFrame-";
var environmentUrls = {
  development: QA_URL,
  qa: QA_URL,
  sandbox: "https://assets.braintreegateway.com/sandbox/data",
  production: "https://assets.braintreegateway.com/data",
};
var cachedDeviceData = {};

function setup(o) {
  var options = o != null ? o : {};

  return new Kount(options);
}

function Kount(options) {
  var previouslyInitializedDeviceData = Kount.getCachedDeviceData(
    options.merchantId
  );

  if (previouslyInitializedDeviceData) {
    this.deviceData = previouslyInitializedDeviceData;
    this._isCached = true;

    return;
  }

  this._currentEnvironment = this._initializeEnvironment(options);

  sjcl.random.startCollectors();

  this._deviceSessionId = this._generateDeviceSessionId();
  this.deviceData = this._getDeviceData();

  Kount.setCachedDeviceData(options.merchantId, this.deviceData);

  this._iframe = this._setupIFrame();
}

Kount.getCachedDeviceData = function (merchantId) {
  return cachedDeviceData[merchantId];
};

Kount.setCachedDeviceData = function (merchantId, data) {
  cachedDeviceData[merchantId] = data;
};

Kount.prototype.teardown = function () {
  if (!this._isCached) {
    sjcl.random.stopCollectors();

    this._removeIframe();
  }
};

Kount.prototype._removeIframe = function () {
  this._iframe.parentNode.removeChild(this._iframe);
};

Kount.prototype._getDeviceData = function () {
  return camelCaseToSnakeCase({
    deviceSessionId: this._deviceSessionId,
    fraudMerchantId: this._currentEnvironment.id,
  });
};

Kount.prototype._generateDeviceSessionId = function () {
  var bits, hexString;

  bits = sjcl.random.randomWords(4, 0);
  hexString = sjcl.codec.hex.fromBits(bits);

  return hexString;
};

Kount.prototype._setupIFrame = function () {
  var params, iframe;
  var self = this;

  params = "?m=" + this._currentEnvironment.id + "&s=" + this._deviceSessionId;

  iframe = document.createElement("iframe");
  iframe.width = 1;
  iframe.id = IFRAME_ID_PREFIX + this._deviceSessionId;
  iframe.height = 1;
  iframe.frameBorder = 0;
  iframe.scrolling = "no";
  iframe.style.position = "fixed";
  iframe.style.left = "-999999px";
  iframe.style.top = "-999999px";
  iframe.title = "Braintree-Kount-iframe";
  iframe.setAttribute("aria-hidden", "true");

  document.body.appendChild(iframe);
  setTimeout(function () {
    iframe.src = self._currentEnvironment.url + "/logo.htm" + params;
    iframe.innerHTML =
      '<img src="' +
      self._currentEnvironment.url +
      "/logo.gif" +
      params +
      '" alt="" />';
  }, 10);

  return iframe;
};

Kount.prototype._initializeEnvironment = function (options) {
  var url = environmentUrls[options.environment];

  if (url == null) {
    throw new Error(
      options.environment + " is not a valid environment for kount.environment"
    );
  }

  return {
    url: url,
    name: options.environment,
    id: options.merchantId,
  };
};

module.exports = {
  setup: setup,
  Kount: Kount,
  environmentUrls: environmentUrls,
};

},{"../lib/camel-case-to-snake-case":125,"./vendor/sjcl":100}],100:[function(_dereq_,module,exports){
"use strict";
var sjcl = {
  cipher: {},
  hash: {},
  keyexchange: {},
  mode: {},
  misc: {},
  codec: {},
  exception: {
    corrupt: function (a) {
      this.toString = function () {
        return "CORRUPT: " + this.message;
      };
      this.message = a;
    },
    invalid: function (a) {
      this.toString = function () {
        return "INVALID: " + this.message;
      };
      this.message = a;
    },
    bug: function (a) {
      this.toString = function () {
        return "BUG: " + this.message;
      };
      this.message = a;
    },
    notReady: function (a) {
      this.toString = function () {
        return "NOT READY: " + this.message;
      };
      this.message = a;
    },
  },
};
sjcl.cipher.aes = function (a) {
  this.l[0][0][0] || this.G();
  var b,
    c,
    d,
    e,
    f = this.l[0][4],
    g = this.l[1];
  b = a.length;
  var k = 1;
  if (4 !== b && 6 !== b && 8 !== b)
    throw new sjcl.exception.invalid("invalid aes key size");
  this.b = [(d = a.slice(0)), (e = [])];
  for (a = b; a < 4 * b + 28; a++) {
    c = d[a - 1];
    if (0 === a % b || (8 === b && 4 === a % b))
      (c =
        (f[c >>> 24] << 24) ^
        (f[(c >> 16) & 255] << 16) ^
        (f[(c >> 8) & 255] << 8) ^
        f[c & 255]),
        0 === a % b &&
          ((c = (c << 8) ^ (c >>> 24) ^ (k << 24)),
          (k = (k << 1) ^ (283 * (k >> 7))));
    d[a] = d[a - b] ^ c;
  }
  for (b = 0; a; b++, a--)
    (c = d[b & 3 ? a : a - 4]),
      (e[b] =
        4 >= a || 4 > b
          ? c
          : g[0][f[c >>> 24]] ^
            g[1][f[(c >> 16) & 255]] ^
            g[2][f[(c >> 8) & 255]] ^
            g[3][f[c & 255]]);
};
sjcl.cipher.aes.prototype = {
  encrypt: function (a) {
    return t(this, a, 0);
  },
  decrypt: function (a) {
    return t(this, a, 1);
  },
  l: [
    [[], [], [], [], []],
    [[], [], [], [], []],
  ],
  G: function () {
    var a = this.l[0],
      b = this.l[1],
      c = a[4],
      d = b[4],
      e,
      f,
      g,
      k = [],
      l = [],
      p,
      n,
      h,
      m;
    for (e = 0; 0x100 > e; e++) l[(k[e] = (e << 1) ^ (283 * (e >> 7))) ^ e] = e;
    for (f = g = 0; !c[f]; f ^= p || 1, g = l[g] || 1)
      for (
        h = g ^ (g << 1) ^ (g << 2) ^ (g << 3) ^ (g << 4),
          h = (h >> 8) ^ (h & 255) ^ 99,
          c[f] = h,
          d[h] = f,
          n = k[(e = k[(p = k[f])])],
          m = (0x1010101 * n) ^ (0x10001 * e) ^ (0x101 * p) ^ (0x1010100 * f),
          n = (0x101 * k[h]) ^ (0x1010100 * h),
          e = 0;
        4 > e;
        e++
      )
        (a[e][f] = n = (n << 24) ^ (n >>> 8)),
          (b[e][h] = m = (m << 24) ^ (m >>> 8));
    for (e = 0; 5 > e; e++) (a[e] = a[e].slice(0)), (b[e] = b[e].slice(0));
  },
};
function t(a, b, c) {
  if (4 !== b.length)
    throw new sjcl.exception.invalid("invalid aes block size");
  var d = a.b[c],
    e = b[0] ^ d[0],
    f = b[c ? 3 : 1] ^ d[1],
    g = b[2] ^ d[2];
  b = b[c ? 1 : 3] ^ d[3];
  var k,
    l,
    p,
    n = d.length / 4 - 2,
    h,
    m = 4,
    q = [0, 0, 0, 0];
  k = a.l[c];
  a = k[0];
  var r = k[1],
    v = k[2],
    w = k[3],
    x = k[4];
  for (h = 0; h < n; h++)
    (k =
      a[e >>> 24] ^ r[(f >> 16) & 255] ^ v[(g >> 8) & 255] ^ w[b & 255] ^ d[m]),
      (l =
        a[f >>> 24] ^
        r[(g >> 16) & 255] ^
        v[(b >> 8) & 255] ^
        w[e & 255] ^
        d[m + 1]),
      (p =
        a[g >>> 24] ^
        r[(b >> 16) & 255] ^
        v[(e >> 8) & 255] ^
        w[f & 255] ^
        d[m + 2]),
      (b =
        a[b >>> 24] ^
        r[(e >> 16) & 255] ^
        v[(f >> 8) & 255] ^
        w[g & 255] ^
        d[m + 3]),
      (m += 4),
      (e = k),
      (f = l),
      (g = p);
  for (h = 0; 4 > h; h++)
    (q[c ? 3 & -h : h] =
      (x[e >>> 24] << 24) ^
      (x[(f >> 16) & 255] << 16) ^
      (x[(g >> 8) & 255] << 8) ^
      x[b & 255] ^
      d[m++]),
      (k = e),
      (e = f),
      (f = g),
      (g = b),
      (b = k);
  return q;
}
sjcl.bitArray = {
  bitSlice: function (a, b, c) {
    a = sjcl.bitArray.M(a.slice(b / 32), 32 - (b & 31)).slice(1);
    return void 0 === c ? a : sjcl.bitArray.clamp(a, c - b);
  },
  extract: function (a, b, c) {
    var d = Math.floor((-b - c) & 31);
    return (
      (((b + c - 1) ^ b) & -32
        ? (a[(b / 32) | 0] << (32 - d)) ^ (a[(b / 32 + 1) | 0] >>> d)
        : a[(b / 32) | 0] >>> d) &
      ((1 << c) - 1)
    );
  },
  concat: function (a, b) {
    if (0 === a.length || 0 === b.length) return a.concat(b);
    var c = a[a.length - 1],
      d = sjcl.bitArray.getPartial(c);
    return 32 === d
      ? a.concat(b)
      : sjcl.bitArray.M(b, d, c | 0, a.slice(0, a.length - 1));
  },
  bitLength: function (a) {
    var b = a.length;
    return 0 === b ? 0 : 32 * (b - 1) + sjcl.bitArray.getPartial(a[b - 1]);
  },
  clamp: function (a, b) {
    if (32 * a.length < b) return a;
    a = a.slice(0, Math.ceil(b / 32));
    var c = a.length;
    b = b & 31;
    0 < c &&
      b &&
      (a[c - 1] = sjcl.bitArray.partial(
        b,
        a[c - 1] & (2147483648 >> (b - 1)),
        1
      ));
    return a;
  },
  partial: function (a, b, c) {
    return 32 === a ? b : (c ? b | 0 : b << (32 - a)) + 0x10000000000 * a;
  },
  getPartial: function (a) {
    return Math.round(a / 0x10000000000) || 32;
  },
  equal: function (a, b) {
    if (sjcl.bitArray.bitLength(a) !== sjcl.bitArray.bitLength(b)) return !1;
    var c = 0,
      d;
    for (d = 0; d < a.length; d++) c |= a[d] ^ b[d];
    return 0 === c;
  },
  M: function (a, b, c, d) {
    var e;
    e = 0;
    for (void 0 === d && (d = []); 32 <= b; b -= 32) d.push(c), (c = 0);
    if (0 === b) return d.concat(a);
    for (e = 0; e < a.length; e++)
      d.push(c | (a[e] >>> b)), (c = a[e] << (32 - b));
    e = a.length ? a[a.length - 1] : 0;
    a = sjcl.bitArray.getPartial(e);
    d.push(sjcl.bitArray.partial((b + a) & 31, 32 < b + a ? c : d.pop(), 1));
    return d;
  },
  Y: function (a, b) {
    return [a[0] ^ b[0], a[1] ^ b[1], a[2] ^ b[2], a[3] ^ b[3]];
  },
  byteswapM: function (a) {
    var b, c;
    for (b = 0; b < a.length; ++b)
      (c = a[b]),
        (a[b] =
          (c >>> 24) | ((c >>> 8) & 0xff00) | ((c & 0xff00) << 8) | (c << 24));
    return a;
  },
};
sjcl.codec.utf8String = {
  fromBits: function (a) {
    var b = "",
      c = sjcl.bitArray.bitLength(a),
      d,
      e;
    for (d = 0; d < c / 8; d++)
      0 === (d & 3) && (e = a[d / 4]),
        (b += String.fromCharCode(((e >>> 8) >>> 8) >>> 8)),
        (e <<= 8);
    return decodeURIComponent(escape(b));
  },
  toBits: function (a) {
    a = unescape(encodeURIComponent(a));
    var b = [],
      c,
      d = 0;
    for (c = 0; c < a.length; c++)
      (d = (d << 8) | a.charCodeAt(c)), 3 === (c & 3) && (b.push(d), (d = 0));
    c & 3 && b.push(sjcl.bitArray.partial(8 * (c & 3), d));
    return b;
  },
};
sjcl.codec.hex = {
  fromBits: function (a) {
    var b = "",
      c;
    for (c = 0; c < a.length; c++)
      b += ((a[c] | 0) + 0xf00000000000).toString(16).substr(4);
    return b.substr(0, sjcl.bitArray.bitLength(a) / 4);
  },
  toBits: function (a) {
    var b,
      c = [],
      d;
    a = a.replace(/\s|0x/g, "");
    d = a.length;
    a = a + "00000000";
    for (b = 0; b < a.length; b += 8) c.push(parseInt(a.substr(b, 8), 16) ^ 0);
    return sjcl.bitArray.clamp(c, 4 * d);
  },
};
sjcl.hash.sha256 = function (a) {
  this.b[0] || this.G();
  a
    ? ((this.u = a.u.slice(0)), (this.o = a.o.slice(0)), (this.h = a.h))
    : this.reset();
};
sjcl.hash.sha256.hash = function (a) {
  return new sjcl.hash.sha256().update(a).finalize();
};
sjcl.hash.sha256.prototype = {
  blockSize: 512,
  reset: function () {
    this.u = this.K.slice(0);
    this.o = [];
    this.h = 0;
    return this;
  },
  update: function (a) {
    "string" === typeof a && (a = sjcl.codec.utf8String.toBits(a));
    var b,
      c = (this.o = sjcl.bitArray.concat(this.o, a));
    b = this.h;
    a = this.h = b + sjcl.bitArray.bitLength(a);
    if (0x1fffffffffffff < a)
      throw new sjcl.exception.invalid("Cannot hash more than 2^53 - 1 bits");
    if ("undefined" !== typeof Uint32Array) {
      var d = new Uint32Array(c),
        e = 0;
      for (b = 512 + b - ((512 + b) & 0x1ff); b <= a; b += 512)
        u(this, d.subarray(16 * e, 16 * (e + 1))), (e += 1);
      c.splice(0, 16 * e);
    } else
      for (b = 512 + b - ((512 + b) & 0x1ff); b <= a; b += 512)
        u(this, c.splice(0, 16));
    return this;
  },
  finalize: function () {
    var a,
      b = this.o,
      c = this.u,
      b = sjcl.bitArray.concat(b, [sjcl.bitArray.partial(1, 1)]);
    for (a = b.length + 2; a & 15; a++) b.push(0);
    b.push(Math.floor(this.h / 0x100000000));
    for (b.push(this.h | 0); b.length; ) u(this, b.splice(0, 16));
    this.reset();
    return c;
  },
  K: [],
  b: [],
  G: function () {
    function a(a) {
      return (0x100000000 * (a - Math.floor(a))) | 0;
    }
    for (var b = 0, c = 2, d, e; 64 > b; c++) {
      e = !0;
      for (d = 2; d * d <= c; d++)
        if (0 === c % d) {
          e = !1;
          break;
        }
      e &&
        (8 > b && (this.K[b] = a(Math.pow(c, 0.5))),
        (this.b[b] = a(Math.pow(c, 1 / 3))),
        b++);
    }
  },
};
function u(a, b) {
  var c,
    d,
    e,
    f = a.u,
    g = a.b,
    k = f[0],
    l = f[1],
    p = f[2],
    n = f[3],
    h = f[4],
    m = f[5],
    q = f[6],
    r = f[7];
  for (c = 0; 64 > c; c++)
    16 > c
      ? (d = b[c])
      : ((d = b[(c + 1) & 15]),
        (e = b[(c + 14) & 15]),
        (d = b[c & 15] =
          (((d >>> 7) ^ (d >>> 18) ^ (d >>> 3) ^ (d << 25) ^ (d << 14)) +
            ((e >>> 17) ^ (e >>> 19) ^ (e >>> 10) ^ (e << 15) ^ (e << 13)) +
            b[c & 15] +
            b[(c + 9) & 15]) |
          0)),
      (d =
        d +
        r +
        ((h >>> 6) ^
          (h >>> 11) ^
          (h >>> 25) ^
          (h << 26) ^
          (h << 21) ^
          (h << 7)) +
        (q ^ (h & (m ^ q))) +
        g[c]),
      (r = q),
      (q = m),
      (m = h),
      (h = (n + d) | 0),
      (n = p),
      (p = l),
      (l = k),
      (k =
        (d +
          ((l & p) ^ (n & (l ^ p))) +
          ((l >>> 2) ^
            (l >>> 13) ^
            (l >>> 22) ^
            (l << 30) ^
            (l << 19) ^
            (l << 10))) |
        0);
  f[0] = (f[0] + k) | 0;
  f[1] = (f[1] + l) | 0;
  f[2] = (f[2] + p) | 0;
  f[3] = (f[3] + n) | 0;
  f[4] = (f[4] + h) | 0;
  f[5] = (f[5] + m) | 0;
  f[6] = (f[6] + q) | 0;
  f[7] = (f[7] + r) | 0;
}
sjcl.prng = function (a) {
  this.c = [new sjcl.hash.sha256()];
  this.i = [0];
  this.H = 0;
  this.v = {};
  this.F = 0;
  this.J = {};
  this.L = this.f = this.j = this.T = 0;
  this.b = [0, 0, 0, 0, 0, 0, 0, 0];
  this.g = [0, 0, 0, 0];
  this.C = void 0;
  this.D = a;
  this.s = !1;
  this.B = { progress: {}, seeded: {} };
  this.m = this.S = 0;
  this.w = 1;
  this.A = 2;
  this.O = 0x10000;
  this.I = [0, 48, 64, 96, 128, 192, 0x100, 384, 512, 768, 1024];
  this.P = 3e4;
  this.N = 80;
};
sjcl.prng.prototype = {
  randomWords: function (a, b) {
    var c = [],
      d;
    d = this.isReady(b);
    var e;
    if (d === this.m)
      throw new sjcl.exception.notReady("generator isn't seeded");
    if (d & this.A) {
      d = !(d & this.w);
      e = [];
      var f = 0,
        g;
      this.L = e[0] = new Date().valueOf() + this.P;
      for (g = 0; 16 > g; g++) e.push((0x100000000 * Math.random()) | 0);
      for (
        g = 0;
        g < this.c.length &&
        ((e = e.concat(this.c[g].finalize())),
        (f += this.i[g]),
        (this.i[g] = 0),
        d || !(this.H & (1 << g)));
        g++
      );
      this.H >= 1 << this.c.length &&
        (this.c.push(new sjcl.hash.sha256()), this.i.push(0));
      this.f -= f;
      f > this.j && (this.j = f);
      this.H++;
      this.b = sjcl.hash.sha256.hash(this.b.concat(e));
      this.C = new sjcl.cipher.aes(this.b);
      for (
        d = 0;
        4 > d && ((this.g[d] = (this.g[d] + 1) | 0), !this.g[d]);
        d++
      );
    }
    for (d = 0; d < a; d += 4)
      0 === (d + 1) % this.O && y(this),
        (e = z(this)),
        c.push(e[0], e[1], e[2], e[3]);
    y(this);
    return c.slice(0, a);
  },
  setDefaultParanoia: function (a, b) {
    if (
      0 === a &&
      "Setting paranoia=0 will ruin your security; use it only for testing" !==
        b
    )
      throw new sjcl.exception.invalid(
        "Setting paranoia=0 will ruin your security; use it only for testing"
      );
    this.D = a;
  },
  addEntropy: function (a, b, c) {
    c = c || "user";
    var d,
      e,
      f = new Date().valueOf(),
      g = this.v[c],
      k = this.isReady(),
      l = 0;
    d = this.J[c];
    void 0 === d && (d = this.J[c] = this.T++);
    void 0 === g && (g = this.v[c] = 0);
    this.v[c] = (this.v[c] + 1) % this.c.length;
    switch (typeof a) {
      case "number":
        void 0 === b && (b = 1);
        this.c[g].update([d, this.F++, 1, b, f, 1, a | 0]);
        break;
      case "object":
        c = Object.prototype.toString.call(a);
        if ("[object Uint32Array]" === c) {
          e = [];
          for (c = 0; c < a.length; c++) e.push(a[c]);
          a = e;
        } else
          for (
            "[object Array]" !== c && (l = 1), c = 0;
            c < a.length && !l;
            c++
          )
            "number" !== typeof a[c] && (l = 1);
        if (!l) {
          if (void 0 === b)
            for (c = b = 0; c < a.length; c++)
              for (e = a[c]; 0 < e; ) b++, (e = e >>> 1);
          this.c[g].update([d, this.F++, 2, b, f, a.length].concat(a));
        }
        break;
      case "string":
        void 0 === b && (b = a.length);
        this.c[g].update([d, this.F++, 3, b, f, a.length]);
        this.c[g].update(a);
        break;
      default:
        l = 1;
    }
    if (l)
      throw new sjcl.exception.bug(
        "random: addEntropy only supports number, array of numbers or string"
      );
    this.i[g] += b;
    this.f += b;
    k === this.m &&
      (this.isReady() !== this.m && A("seeded", Math.max(this.j, this.f)),
      A("progress", this.getProgress()));
  },
  isReady: function (a) {
    a = this.I[void 0 !== a ? a : this.D];
    return this.j && this.j >= a
      ? this.i[0] > this.N && new Date().valueOf() > this.L
        ? this.A | this.w
        : this.w
      : this.f >= a
      ? this.A | this.m
      : this.m;
  },
  getProgress: function (a) {
    a = this.I[a ? a : this.D];
    return this.j >= a ? 1 : this.f > a ? 1 : this.f / a;
  },
  startCollectors: function () {
    if (!this.s) {
      this.a = {
        loadTimeCollector: B(this, this.V),
        mouseCollector: B(this, this.W),
        keyboardCollector: B(this, this.U),
        accelerometerCollector: B(this, this.R),
        touchCollector: B(this, this.X),
      };
      if (window.addEventListener)
        window.addEventListener("load", this.a.loadTimeCollector, !1),
          window.addEventListener("mousemove", this.a.mouseCollector, !1),
          window.addEventListener("keypress", this.a.keyboardCollector, !1),
          window.addEventListener(
            "devicemotion",
            this.a.accelerometerCollector,
            !1
          ),
          window.addEventListener("touchmove", this.a.touchCollector, !1);
      else if (document.attachEvent)
        document.attachEvent("onload", this.a.loadTimeCollector),
          document.attachEvent("onmousemove", this.a.mouseCollector),
          document.attachEvent("keypress", this.a.keyboardCollector);
      else throw new sjcl.exception.bug("can't attach event");
      this.s = !0;
    }
  },
  stopCollectors: function () {
    this.s &&
      (window.removeEventListener
        ? (window.removeEventListener("load", this.a.loadTimeCollector, !1),
          window.removeEventListener("mousemove", this.a.mouseCollector, !1),
          window.removeEventListener("keypress", this.a.keyboardCollector, !1),
          window.removeEventListener(
            "devicemotion",
            this.a.accelerometerCollector,
            !1
          ),
          window.removeEventListener("touchmove", this.a.touchCollector, !1))
        : document.detachEvent &&
          (document.detachEvent("onload", this.a.loadTimeCollector),
          document.detachEvent("onmousemove", this.a.mouseCollector),
          document.detachEvent("keypress", this.a.keyboardCollector)),
      (this.s = !1));
  },
  addEventListener: function (a, b) {
    this.B[a][this.S++] = b;
  },
  removeEventListener: function (a, b) {
    var c,
      d,
      e = this.B[a],
      f = [];
    for (d in e) e.hasOwnProperty(d) && e[d] === b && f.push(d);
    for (c = 0; c < f.length; c++) (d = f[c]), delete e[d];
  },
  U: function () {
    C(this, 1);
  },
  W: function (a) {
    var b, c;
    try {
      (b = a.x || a.clientX || a.offsetX || 0),
        (c = a.y || a.clientY || a.offsetY || 0);
    } catch (d) {
      c = b = 0;
    }
    0 != b && 0 != c && this.addEntropy([b, c], 2, "mouse");
    C(this, 0);
  },
  X: function (a) {
    a = a.touches[0] || a.changedTouches[0];
    this.addEntropy([a.pageX || a.clientX, a.pageY || a.clientY], 1, "touch");
    C(this, 0);
  },
  V: function () {
    C(this, 2);
  },
  R: function (a) {
    a =
      a.accelerationIncludingGravity.x ||
      a.accelerationIncludingGravity.y ||
      a.accelerationIncludingGravity.z;
    if (window.orientation) {
      var b = window.orientation;
      "number" === typeof b && this.addEntropy(b, 1, "accelerometer");
    }
    a && this.addEntropy(a, 2, "accelerometer");
    C(this, 0);
  },
};
function A(a, b) {
  var c,
    d = sjcl.random.B[a],
    e = [];
  for (c in d) d.hasOwnProperty(c) && e.push(d[c]);
  for (c = 0; c < e.length; c++) e[c](b);
}
function C(a, b) {
  "undefined" !== typeof window &&
  window.performance &&
  "function" === typeof window.performance.now
    ? a.addEntropy(window.performance.now(), b, "loadtime")
    : a.addEntropy(new Date().valueOf(), b, "loadtime");
}
function y(a) {
  a.b = z(a).concat(z(a));
  a.C = new sjcl.cipher.aes(a.b);
}
function z(a) {
  for (var b = 0; 4 > b && ((a.g[b] = (a.g[b] + 1) | 0), !a.g[b]); b++);
  return a.C.encrypt(a.g);
}
function B(a, b) {
  return function () {
    b.apply(a, arguments);
  };
}
sjcl.random = new sjcl.prng(6);
a: try {
  var D, E, F, G;
  if ((G = "undefined" !== typeof module && module.exports)) {
    var H;
    try {
      H = _dereq_("crypto");
    } catch (a) {
      H = null;
    }
    G = E = H;
  }
  if (G && E.randomBytes)
    (D = E.randomBytes(128)),
      (D = new Uint32Array(new Uint8Array(D).buffer)),
      sjcl.random.addEntropy(D, 1024, "crypto['randomBytes']");
  else if (
    "undefined" !== typeof window &&
    "undefined" !== typeof Uint32Array
  ) {
    F = new Uint32Array(32);
    if (window.crypto && window.crypto.getRandomValues)
      window.crypto.getRandomValues(F);
    else if (window.msCrypto && window.msCrypto.getRandomValues)
      window.msCrypto.getRandomValues(F);
    else break a;
    sjcl.random.addEntropy(F, 1024, "crypto['getRandomValues']");
  }
} catch (a) {
  "undefined" !== typeof window &&
    window.console &&
    (console.log("There was an error collecting entropy from the browser:"),
    console.log(a));
}
"undefined" !== typeof module && module.exports && (module.exports = sjcl);
"function" === typeof define &&
  define([], function () {
    return sjcl;
  });

},{"crypto":undefined}],101:[function(_dereq_,module,exports){
"use strict";

/**
 * @name BraintreeError.Google Payment - Creation Error Codes
 * @description Errors that occur when [creating the Google Payment component](./module-braintree-web_google-payment.html#.create).
 * @property {MERCHANT} GOOGLE_PAYMENT_NOT_ENABLED Occurs when Google Pay is not enabled on the Braintree control panel.
 * @property {MERCHANT} GOOGLE_PAYMENT_UNSUPPORTED_VERSION Occurs when a Google Pay version is used that is not supported by the Braintree SDK.
 */

/**
 * @name BraintreeError.Google Payment - parseResponse Error Codes
 * @description Errors that occur when [parsing the response from Google](./GooglePayment.html#parseResponse).
 * @property {UNKNOWN} GOOGLE_PAYMENT_GATEWAY_ERROR Occurs when Google Pay could not be tokenized.
 */

var BraintreeError = _dereq_("../lib/braintree-error");

module.exports = {
  GOOGLE_PAYMENT_NOT_ENABLED: {
    type: BraintreeError.types.MERCHANT,
    code: "GOOGLE_PAYMENT_NOT_ENABLED",
    message: "Google Pay is not enabled for this merchant.",
  },
  GOOGLE_PAYMENT_GATEWAY_ERROR: {
    code: "GOOGLE_PAYMENT_GATEWAY_ERROR",
    message:
      "There was an error when tokenizing the Google Pay payment method.",
    type: BraintreeError.types.UNKNOWN,
  },
  GOOGLE_PAYMENT_UNSUPPORTED_VERSION: {
    code: "GOOGLE_PAYMENT_UNSUPPORTED_VERSION",
    type: BraintreeError.types.MERCHANT,
  },
};

},{"../lib/braintree-error":124}],102:[function(_dereq_,module,exports){
"use strict";

var analytics = _dereq_("../lib/analytics");
var assign = _dereq_("../lib/assign").assign;
var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
var find = _dereq_("../lib/find");
var generateGooglePayConfiguration = _dereq_("../lib/generate-google-pay-configuration");
var BraintreeError = _dereq_("../lib/braintree-error");
var errors = _dereq_("./errors");
var methods = _dereq_("../lib/methods");
var wrapPromise = _dereq_("@braintree/wrap-promise");

var CREATE_PAYMENT_DATA_REQUEST_METHODS = {
  1: "_createV1PaymentDataRequest",
  2: "_createV2PaymentDataRequest",
};

/**
 * @typedef {object} GooglePayment~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {object} details Additional account details.
 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
 * @property {string} details.lastFour Last four digits of card number.
 * @property {string} details.lastTwo Last two digits of card number.
 * @property {boolean} details.isNetworkTokenized True if the card is network tokenized.
 * @property {string} details.bin First six digits of card number.
 * @property {string} description A human-readable description.
 * @property {string} type The payment method type, `CreditCard` or `AndroidPayCard`.
 * @property {object} binData Information about the card based on the bin.
 * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.countryOfIssuance The country of issuance.
 * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.issuingBank The issuing bank.
 * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.productId The product id.
 */

/**
 * @class GooglePayment
 * @param {object} options Google Payment {@link module:braintree-web/google-payment.create create} options.
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/google-payment.create|braintree-web.google-payment.create} instead.</strong>
 * @classdesc This class represents a Google Payment component produced by {@link module:braintree-web/google-payment.create|braintree-web/google-payment.create}. Instances of this class have methods for initializing the Google Pay flow.
 */
function GooglePayment(options) {
  this._createPromise = options.createPromise;
  this._client = options.client;
  this._useDeferredClient = options.useDeferredClient;
  // NEXT_MAJOR_VERSION this should be updated to 2 (or whatever the current latest version is)
  this._googlePayVersion = options.googlePayVersion || 1;
  this._googleMerchantId = options.googleMerchantId;

  if (this._isUnsupportedGooglePayAPIVersion()) {
    throw new BraintreeError({
      code: errors.GOOGLE_PAYMENT_UNSUPPORTED_VERSION.code,
      message:
        "The Braintree SDK does not support Google Pay version " +
        this._googlePayVersion +
        ". Please upgrade the version of your Braintree SDK and contact support if this error persists.",
      type: errors.GOOGLE_PAYMENT_UNSUPPORTED_VERSION.type,
    });
  }
}

GooglePayment.prototype._waitForClient = function () {
  if (this._client) {
    return Promise.resolve();
  }

  return this._createPromise.then(
    function (client) {
      this._client = client;
    }.bind(this)
  );
};

GooglePayment.prototype._isUnsupportedGooglePayAPIVersion = function () {
  // if we don't have createPaymentDatqRequest method for the specific
  // API version, then the version is not supported
  return !(this._googlePayVersion in CREATE_PAYMENT_DATA_REQUEST_METHODS);
};

GooglePayment.prototype._getDefaultConfig = function () {
  if (!this._defaultConfig) {
    this._defaultConfig = generateGooglePayConfiguration(
      this._client.getConfiguration(),
      this._googlePayVersion,
      this._googleMerchantId
    );
  }

  return this._defaultConfig;
};

GooglePayment.prototype._createV1PaymentDataRequest = function (
  paymentDataRequest
) {
  var defaultConfig = this._getDefaultConfig();
  var overrideCardNetworks =
    paymentDataRequest.cardRequirements &&
    paymentDataRequest.cardRequirements.allowedCardNetworks;
  var defaultConfigCardNetworks =
    defaultConfig.cardRequirements.allowedCardNetworks;
  var allowedCardNetworks = overrideCardNetworks || defaultConfigCardNetworks;

  paymentDataRequest = assign({}, defaultConfig, paymentDataRequest);

  // this way we can preserve allowedCardNetworks from default integration
  // if merchant did not pass any in `cardRequirements`
  paymentDataRequest.cardRequirements.allowedCardNetworks = allowedCardNetworks;

  return paymentDataRequest;
};

GooglePayment.prototype._createV2PaymentDataRequest = function (
  paymentDataRequest
) {
  var defaultConfig = this._getDefaultConfig();

  if (paymentDataRequest.allowedPaymentMethods) {
    paymentDataRequest.allowedPaymentMethods.forEach(function (paymentMethod) {
      var defaultPaymentMethod = find(
        defaultConfig.allowedPaymentMethods,
        "type",
        paymentMethod.type
      );

      if (defaultPaymentMethod) {
        applyDefaultsToPaymentMethodConfiguration(
          paymentMethod,
          defaultPaymentMethod
        );
      }
    });
  }

  paymentDataRequest = assign({}, defaultConfig, paymentDataRequest);

  return paymentDataRequest;
};

/**
 * Create a configuration object for use in the `loadPaymentData` method.
 *
 * **Note**: Version 1 of the Google Pay Api is deprecated and will become unsupported in a future version. Until then, version 1 will continue to be used by default, and version 1 schema parameters and overrides will remain functional on existing integrations. However, new integrations and all following examples will be presented in the GooglePay version 2 schema. See [Google Pay's upgrade guide](https://developers.google.com/pay/api/web/guides/resources/update-to-latest-version) to see how to update your integration.
 *
 * If `options.googlePayVersion === 2` was set during the initial {@link module:braintree-web/google-payment.create|create} call, overrides must match the Google Pay v2 schema to be valid.
 *
 * @public
 * @param {object} overrides The supplied parameters for creating the PaymentDataRequest object. Required parameters are:
 *  @param {object} overrides.transactionInfo Object according to the [Google Pay Transaction Info](https://developers.google.com/pay/api/web/reference/object#TransactionInfo) spec.
 *  Optionally, any of the parameters in the [PaymentDataRequest](https://developers.google.com/pay/api/web/reference/object#PaymentDataRequest) parameters can be overridden, but note that it is recommended only to override top level parameters to avoid squashing deeply nested configuration objects. An example can be found below showing how to safely edit these deeply nested objects.
 * @example
 * var paymentDataRequest = googlePaymentInstance.createPaymentDataRequest({
 *   merchantInfo: {
 *     merchantId: 'my-merchant-id-from-google'
 *   },
 *   transactionInfo: {
 *     currencyCode: 'USD',
 *     totalPriceStatus: 'FINAL',
 *     totalPrice: '100.00'
 *   }
 * });
 *
 * // Update card payment methods to require billing address
 * var cardPaymentMethod = paymentDataRequest.allowedPaymentMethods;
 * cardPaymentMethod.parameters.billingAddressRequired = true;
 * cardPaymentMethod.parameters.billingAddressParameters = {
 *   format: 'FULL',
 *   phoneNumberRequired: true
 * };
 *
 * var paymentsClient = new google.payments.api.PaymentsClient({
 *   environment: 'TEST' // or 'PRODUCTION'
 * })
 *
 * paymentsClient.loadPaymentData(paymentDataRequest).then(function (response) {
 *   // handle response with googlePaymentInstance.parseResponse
 *   // (see below)
 * });
 * @example <caption>With deferred client</caption>
 * googlePaymentInstance.createPaymentDataRequest({
 *   merchantInfo: {
 *     merchantId: 'my-merchant-id-from-google'
 *   },
 *   transactionInfo: {
 *     currencyCode: 'USD',
 *     totalPriceStatus: 'FINAL',
 *     totalPrice: '100.00'
 *   }
 * }).then(function (paymentDataRequest) {
 *   // Update card payment methods to require billing address
 *   var cardPaymentMethod = paymentDataRequest.allowedPaymentMethods;
 *   cardPaymentMethod.parameters.billingAddressRequired = true;
 *   cardPaymentMethod.parameters.billingAddressParameters = {
 *     format: 'FULL',
 *     phoneNumberRequired: true
 *   };
 *
 *   var paymentsClient = new google.payments.api.PaymentsClient({
 *     environment: 'TEST' // or 'PRODUCTION'
 *   })
 *
 *   return paymentsClient.loadPaymentData(paymentDataRequest);
 * }).then(function (response) {
 *   // handle response with googlePaymentInstance.parseResponse
 *   // (see below)
 * });
 * @returns {object|Promise} Returns a configuration object for Google PaymentDataRequest. If instantiated with `useDeferredClient` and an `authorization` it will return a promise that resolves with the configuration.
 */
GooglePayment.prototype.createPaymentDataRequest = function (overrides) {
  if (!this._useDeferredClient) {
    return this._createPaymentDataRequestSyncronously(overrides);
  }

  return this._waitForClient().then(
    function () {
      return this._createPaymentDataRequestSyncronously(overrides);
    }.bind(this)
  );
};

GooglePayment.prototype._createPaymentDataRequestSyncronously = function (
  overrides
) {
  var paymentDataRequest = assign({}, overrides);
  var version = this._googlePayVersion;
  var createPaymentDataRequestMethod =
    CREATE_PAYMENT_DATA_REQUEST_METHODS[version];

  analytics.sendEvent(
    this._createPromise,
    "google-payment.v" + version + ".createPaymentDataRequest"
  );

  return this[createPaymentDataRequestMethod](paymentDataRequest);
};

/**
 * Parse the response from the tokenization.
 * @public
 * @param {object} response The response back from the Google Pay tokenization.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link GooglePay~tokenizePayload|tokenizePayload}. If no callback is provided, `parseResponse` returns a promise that resolves with a {@link GooglePayment~tokenizePayload|tokenizePayload}.
 * @example with callback
 * var paymentsClient = new google.payments.api.PaymentsClient({
 *   environment: 'TEST' // or 'PRODUCTION'
 * })
 *
 * paymentsClient.loadPaymentData(paymentDataRequestFromCreatePaymentDataRequest).then(function (response) {
 *   googlePaymentInstance.parseResponse(response, function (err, data) {
 *     if (err) {
 *       // handle errors
 *     }
 *     // send parsedResponse.nonce to your server
 *   });
 * });
 * @example with promise
 * var paymentsClient = new google.payments.api.PaymentsClient({
 *   environment: 'TEST' // or 'PRODUCTION'
 * })
 *
 * paymentsClient.loadPaymentData(paymentDataRequestFromCreatePaymentDataRequest).then(function (response) {
 *   return googlePaymentInstance.parseResponse(response);
 * }).then(function (parsedResponse) {
 *   // send parsedResponse.nonce to your server
 * }).catch(function (err) {
 *   // handle errors
 * });
 * @returns {(Promise|void)} Returns a promise that resolves the parsed response if no callback is provided.
 */
GooglePayment.prototype.parseResponse = function (response) {
  var self = this;

  return Promise.resolve()
    .then(function () {
      var payload;
      var rawResponse =
        response.apiVersion === 2
          ? response.paymentMethodData.tokenizationData.token
          : response.paymentMethodToken.token;
      var parsedResponse = JSON.parse(rawResponse);
      var error = parsedResponse.error;

      if (error) {
        return Promise.reject(error);
      }

      analytics.sendEvent(
        self._createPromise,
        "google-payment.parseResponse.succeeded"
      );

      if (parsedResponse.paypalAccounts) {
        payload = parsedResponse.paypalAccounts[0];
        analytics.sendEvent(
          self._createPromise,
          "google-payment.parseResponse.succeeded.paypal"
        );

        return Promise.resolve({
          nonce: payload.nonce,
          type: payload.type,
          description: payload.description,
        });
      }
      payload = parsedResponse.androidPayCards[0];
      analytics.sendEvent(
        self._createPromise,
        "google-payment.parseResponse.succeeded.google-payment"
      );

      return Promise.resolve({
        nonce: payload.nonce,
        type: payload.type,
        description: payload.description,
        details: {
          cardType: payload.details.cardType,
          lastFour: payload.details.lastFour,
          lastTwo: payload.details.lastTwo,
          isNetworkTokenized: payload.details.isNetworkTokenized,
          bin: payload.details.bin,
        },
        binData: payload.binData,
      });
    })
    .catch(function (error) {
      analytics.sendEvent(
        self._createPromise,
        "google-payment.parseResponse.failed"
      );

      return Promise.reject(
        new BraintreeError({
          code: errors.GOOGLE_PAYMENT_GATEWAY_ERROR.code,
          message: errors.GOOGLE_PAYMENT_GATEWAY_ERROR.message,
          type: errors.GOOGLE_PAYMENT_GATEWAY_ERROR.type,
          details: {
            originalError: error,
          },
        })
      );
    });
};

/**
 * Cleanly tear down anything set up by {@link module:braintree-web/google-payment.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * googlePaymentInstance.teardown();
 * @example <caption>With callback</caption>
 * googlePaymentInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
GooglePayment.prototype.teardown = function () {
  convertMethodsToError(this, methods(GooglePayment.prototype));

  return Promise.resolve();
};

function applyDefaultsToPaymentMethodConfiguration(
  merchantSubmittedPaymentMethod,
  defaultPaymentMethod
) {
  Object.keys(defaultPaymentMethod).forEach(function (parameter) {
    if (typeof defaultPaymentMethod[parameter] === "object") {
      merchantSubmittedPaymentMethod[parameter] = assign(
        {},
        defaultPaymentMethod[parameter],
        merchantSubmittedPaymentMethod[parameter]
      );
    } else {
      merchantSubmittedPaymentMethod[parameter] =
        merchantSubmittedPaymentMethod[parameter] ||
        defaultPaymentMethod[parameter];
    }
  });
}

module.exports = wrapPromise.wrapPrototype(GooglePayment);

},{"../lib/analytics":119,"../lib/assign":121,"../lib/braintree-error":124,"../lib/convert-methods-to-error":127,"../lib/find":137,"../lib/generate-google-pay-configuration":149,"../lib/methods":155,"./errors":101,"@braintree/wrap-promise":43}],103:[function(_dereq_,module,exports){
"use strict";
/**
 * @module braintree-web/google-payment
 * @description A component to integrate with Google Pay. The majority of the integration uses [Google's pay.js JavaScript file](https://pay.google.com/gp/p/js/pay.js). The Braintree component generates the configuration object necessary for Google Pay to initiate the Payment Request and parse the returned data to retrieve the payment method nonce which is used to process the transaction on the server.
 */

var GooglePayment = _dereq_("./google-payment");
var BraintreeError = _dereq_("../lib/braintree-error");
var createAssetsUrl = _dereq_("../lib/create-assets-url");
var createDeferredClient = _dereq_("../lib/create-deferred-client");
var basicComponentVerification = _dereq_("../lib/basic-component-verification");
var wrapPromise = _dereq_("@braintree/wrap-promise");
var VERSION = "3.101.3";
var errors = _dereq_("./errors");

/**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {boolean} [options.useDeferredClient] Used in conjunction with `authorization`, allows the Google Payment instance to be available right away by fetching the client configuration in the background. When this option is used, {@link GooglePayment#createPaymentDataRequest} will return a promise that resolves with the configuration instead of returning synchronously.
 * @param {number} [options.googlePayVersion] The version of the Google Pay API to use. Value of 2 is required to accept parameters documented [by Google](https://developers.google.com/pay/api/web/reference/object). Omit this parameter to use the deprecated Google Pay Version 1.
 * @param {string} [options.googleMerchantId] A Google merchant identifier issued after your website is approved by Google. Required when PaymentsClient is initialized with an environment property of PRODUCTION, but may be omitted in TEST environment.
 * @param {callback} [callback] The second argument, `data`, is the {@link GooglePayment} instance. If no callback is provided, `create` returns a promise that resolves with the {@link GooglePayment} instance.
 * @example <caption>Simple Example</caption>
 * // include https://pay.google.com/gp/p/js/pay.js in a script tag
 * // on your page to load the `google.payments.api.PaymentsClient` global object.
 *
 * var paymentButton = document.querySelector('#google-pay-button');
 * var paymentsClient = new google.payments.api.PaymentsClient({
 *   environment: 'TEST' // or 'PRODUCTION'
 * });
 *
 * braintree.client.create({
 *   authorization: 'tokenization-key-or-client-token'
 * }).then(function (clientInstance) {
 *   return braintree.googlePayment.create({
 *     client: clientInstance,
 *      googlePayVersion: 2,
 *      googleMerchantId: 'your-merchant-id-from-google'
 *   });
 * }).then(function (googlePaymentInstance) {
 *   paymentButton.addEventListener('click', function (event) {
 *     var paymentDataRequest;
 *
 *     event.preventDefault();
 *
 *     paymentDataRequest = googlePaymentInstance.createPaymentDataRequest({
 *       transactionInfo: {
 *         currencyCode: 'USD',
 *         totalPriceStatus: 'FINAL',
 *         totalPrice: '100.00'
 *       }
 *     });
 *
 *     paymentsClient.loadPaymentData(paymentDataRequest).then(function (paymentData) {
 *       return googlePaymentInstance.parseResponse(paymentData);
 *     }).then(function (result) {
 *       // send result.nonce to your server
 *     }).catch(function (err) {
 *       // handle err
 *     });
 *   });
 * });
 * @example <caption>Check Browser and Customer Compatibility</caption>
 * var paymentsClient = new google.payments.api.PaymentsClient({
 *   environment: 'TEST' // or 'PRODUCTION'
 * });
 *
 * function setupGooglePayButton(googlePaymentInstance) {
 *   var button = document.createElement('button');
 *
 *   button.id = 'google-pay';
 *   button.appendChild(document.createTextNode('Google Pay'));
 *   button.addEventListener('click', function (event) {
 *     var paymentRequestData;
 *
 *     event.preventDefault();
 *
 *     paymentDataRequest = googlePaymentInstance.createPaymentDataRequest({
 *       transactionInfo: {
 *         currencyCode: 'USD',
 *         totalPriceStatus: 'FINAL',
 *         totalPrice: '100.00' // your amount
 *       }
 *     });
 *
 *     paymentsClient.loadPaymentData(paymentDataRequest).then(function (paymentData) {
 *       return googlePaymentInstance.parseResponse(paymentData);
 *       }).then(function (result) {
 *       // send result.nonce to your server
 *     }).catch(function (err) {
 *       // handle errors
 *     });
 *   });
 *
 *   document.getElementById('container').appendChild(button);
 * }
 *
 * braintree.client.create({
 *   authorization: 'tokenization-key-or-client-token'
 * }).then(function (clientInstance) {
 *   return braintree.googlePayment.create({
 *     client: clientInstance,
 *     googlePayVersion: 2,
 *     googleMerchantId: 'your-merchant-id-from-google'
 *   });
 * }).then(function (googlePaymentInstance) {
 *
 *   return paymentsClient.isReadyToPay({
 *     // see https://developers.google.com/pay/api/web/reference/object#IsReadyToPayRequest for all options
 *     apiVersion: 2,
 *     apiVersionMinor: 0,
 *     allowedPaymentMethods: googlePaymentInstance.createPaymentDataRequest().allowedPaymentMethods,
 *     existingPaymentMethodRequired: true
 *   });
 * }).then(function (response) {
 *   if (response.result) {
 *     setupGooglePayButton(googlePaymentInstance);
 *   }
 * }).catch(function (err) {
 *   // handle setup errors
 * });
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
function create(options) {
  var name = "Google Pay";

  return basicComponentVerification
    .verify({
      name: name,
      client: options.client,
      authorization: options.authorization,
    })
    .then(function () {
      var createPromise, instance;

      createPromise = createDeferredClient
        .create({
          authorization: options.authorization,
          client: options.client,
          debug: options.debug,
          assetsUrl: createAssetsUrl.create(options.authorization),
          name: name,
        })
        .then(function (client) {
          var configuration = client.getConfiguration();

          options.client = client;
          if (!configuration.gatewayConfiguration.androidPay) {
            return Promise.reject(
              new BraintreeError(errors.GOOGLE_PAYMENT_NOT_ENABLED)
            );
          }

          return client;
        });

      options.createPromise = createPromise;
      instance = new GooglePayment(options);

      if (!options.useDeferredClient) {
        return createPromise.then(function (client) {
          instance._client = client;

          return instance;
        });
      }

      return instance;
    });
}

module.exports = {
  create: wrapPromise(create),
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION,
};

},{"../lib/basic-component-verification":122,"../lib/braintree-error":124,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./errors":101,"./google-payment":102,"@braintree/wrap-promise":43}],104:[function(_dereq_,module,exports){
"use strict";

var BraintreeError = _dereq_("../../lib/braintree-error");
var errors = _dereq_("../shared/errors");
var allowedAttributes = _dereq_("../shared/constants").allowedAttributes;

function attributeValidationError(attribute, value) {
  var err;

  if (!allowedAttributes.hasOwnProperty(attribute)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED.type,
      code: errors.HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED.code,
      message:
        'The "' + attribute + '" attribute is not supported in Hosted Fields.',
    });
  } else if (value != null && !_isValid(attribute, value)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED.type,
      code: errors.HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED.code,
      message:
        'Value "' +
        value +
        '" is not allowed for "' +
        attribute +
        '" attribute.',
    });
  }

  return err;
}

function _isValid(attribute, value) {
  if (allowedAttributes[attribute] === "string") {
    return typeof value === "string" || typeof value === "number";
  } else if (allowedAttributes[attribute] === "boolean") {
    return String(value) === "true" || String(value) === "false";
  }

  return false;
}

module.exports = attributeValidationError;

},{"../../lib/braintree-error":124,"../shared/constants":112,"../shared/errors":113}],105:[function(_dereq_,module,exports){
"use strict";

var constants = _dereq_("../shared/constants");
var useMin = _dereq_("../../lib/use-min");

module.exports = function composeUrl(assetsUrl, componentId, isDebug) {
  return (
    assetsUrl +
    "/web/" +
    constants.VERSION +
    "/html/hosted-fields-frame" +
    useMin(isDebug) +
    ".html#" +
    componentId
  );
};

},{"../../lib/use-min":160,"../shared/constants":112}],106:[function(_dereq_,module,exports){
"use strict";

var directions = _dereq_("../shared/constants").navigationDirections;
var browserDetection = _dereq_("../shared/browser-detection");
var focusIntercept = _dereq_("../shared/focus-intercept");
var findParentTags = _dereq_("../shared/find-parent-tags");
var userFocusableTagNames = ["INPUT", "SELECT", "TEXTAREA"];
// Devices with software keyboards do not or cannot focus on input types
// that do not require keyboard-based interaction.
var unfocusedInputTypes = [
  "hidden",
  "button",
  "reset",
  "submit",
  "checkbox",
  "radio",
  "file",
];

function _isUserFocusableElement(element) {
  if (!browserDetection.hasSoftwareKeyboard()) {
    // on desktop browsers, the only input type that isn't focusable
    // is the hidden input
    return element.type !== "hidden";
  }

  return (
    userFocusableTagNames.indexOf(element.tagName) > -1 &&
    unfocusedInputTypes.indexOf(element.type) < 0
  );
}

function _createNavigationHelper(direction, numberOfElementsInForm) {
  switch (direction) {
    case directions.BACK:
      return {
        checkIndexBounds: function (index) {
          return index < 0;
        },
        indexChange: -1,
      };
    case directions.FORWARD:
      return {
        checkIndexBounds: function (index) {
          return index > numberOfElementsInForm - 1;
        },
        indexChange: 1,
      };
    default:
  }

  return {};
}

function _findFirstFocusableElement(elementsInForm) {
  var elementsIndex, element;

  for (
    elementsIndex = 0;
    elementsIndex < elementsInForm.length;
    elementsIndex++
  ) {
    element = elementsInForm[elementsIndex];

    if (_isUserFocusableElement(element)) {
      return element;
    }
  }

  return null;
}

module.exports = {
  removeExtraFocusElements: function (checkoutForm, onRemoveFocusIntercepts) {
    var elements = Array.prototype.slice.call(checkoutForm.elements);
    var firstFocusableInput = _findFirstFocusableElement(elements);
    var lastFocusableInput = _findFirstFocusableElement(elements.reverse());

    // these should never be identical, because there will at least be the
    // before and the after input
    [firstFocusableInput, lastFocusableInput].forEach(function (input) {
      if (!input) {
        return;
      }

      if (focusIntercept.matchFocusElement(input.getAttribute("id"))) {
        onRemoveFocusIntercepts(input.getAttribute("id"));
      }
    });
  },

  createFocusChangeHandler: function (hostedFieldsId, callbacks) {
    return function (data) {
      var currentIndex, targetElement, checkoutForm, navHelper;
      var sourceElement = document.getElementById(
        "bt-" + data.field + "-" + data.direction + "-" + hostedFieldsId
      );

      if (!sourceElement) {
        return;
      }

      checkoutForm = findParentTags(sourceElement, "form")[0];

      if (document.forms.length < 1 || !checkoutForm) {
        callbacks.onRemoveFocusIntercepts();

        return;
      }

      checkoutForm = [].slice.call(checkoutForm.elements);
      currentIndex = checkoutForm.indexOf(sourceElement);
      navHelper = _createNavigationHelper(data.direction, checkoutForm.length);

      do {
        currentIndex += navHelper.indexChange;
        if (navHelper.checkIndexBounds(currentIndex)) {
          return;
        }
        targetElement = checkoutForm[currentIndex];
      } while (!_isUserFocusableElement(targetElement));

      if (focusIntercept.matchFocusElement(targetElement.getAttribute("id"))) {
        callbacks.onTriggerInputFocus(
          targetElement.getAttribute("data-braintree-type")
        );
      } else {
        targetElement.focus();
      }
    };
  },
};

},{"../shared/browser-detection":111,"../shared/constants":112,"../shared/find-parent-tags":114,"../shared/focus-intercept":115}],107:[function(_dereq_,module,exports){
"use strict";

var allowedStyles = _dereq_("../shared/constants").allowedStyles;

module.exports = function getStylesFromClass(cssClass) {
  var element = document.createElement("input");
  var styles = {};
  var computedStyles;

  if (cssClass[0] === ".") {
    cssClass = cssClass.substring(1);
  }

  element.className = cssClass;
  element.style.display = "none !important";
  element.style.position = "fixed !important";
  element.style.left = "-99999px !important";
  element.style.top = "-99999px !important";
  document.body.appendChild(element);

  computedStyles = window.getComputedStyle(element);

  allowedStyles.forEach(function (style) {
    var value = computedStyles[style];

    if (value) {
      styles[style] = value;
    }
  });

  document.body.removeChild(element);

  return styles;
};

},{"../shared/constants":112}],108:[function(_dereq_,module,exports){
"use strict";

var assign = _dereq_("../../lib/assign").assign;
var createAssetsUrl = _dereq_("../../lib/create-assets-url");
var isVerifiedDomain = _dereq_("../../lib/is-verified-domain");
var Destructor = _dereq_("../../lib/destructor");
var iFramer = _dereq_("@braintree/iframer");
var Bus = _dereq_("framebus");
var createDeferredClient = _dereq_("../../lib/create-deferred-client");
var BraintreeError = _dereq_("../../lib/braintree-error");
var composeUrl = _dereq_("./compose-url");
var getStylesFromClass = _dereq_("./get-styles-from-class");
var constants = _dereq_("../shared/constants");
var errors = _dereq_("../shared/errors");
var INTEGRATION_TIMEOUT_MS =
  _dereq_("../../lib/constants").INTEGRATION_TIMEOUT_MS;
var uuid = _dereq_("@braintree/uuid");
var findParentTags = _dereq_("../shared/find-parent-tags");
var browserDetection = _dereq_("../shared/browser-detection");
var events = constants.events;
var EventEmitter = _dereq_("@braintree/event-emitter");
var injectFrame = _dereq_("./inject-frame");
var analytics = _dereq_("../../lib/analytics");
var allowedFields = constants.allowedFields;
var methods = _dereq_("../../lib/methods");
var shadow = _dereq_("../../lib/shadow");
var findRootNode = _dereq_("../../lib/find-root-node");
var convertMethodsToError = _dereq_("../../lib/convert-methods-to-error");
var sharedErrors = _dereq_("../../lib/errors");
var getCardTypes = _dereq_("../shared/get-card-types");
var attributeValidationError = _dereq_("./attribute-validation-error");
var wrapPromise = _dereq_("@braintree/wrap-promise");
var focusChange = _dereq_("./focus-change");
var destroyFocusIntercept = _dereq_("../shared/focus-intercept").destroy;

var SAFARI_FOCUS_TIMEOUT = 5;

/**
 * @typedef {object} HostedFields~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {object} authenticationInsight Info about the [regulatory environment](https://developer.paypal.com/braintree/docs/guides/3d-secure/advanced-options/javascript/v3#authentication-insight) of the tokenized card. Only available if `authenticationInsight.merchantAccountId` is passed in the `tokenize` method options.
 * @property {string} authenticationInsight.regulationEnvironment The [regulation environment](https://developer.paypal.com/braintree/docs/guides/3d-secure/advanced-options/javascript/v3#authentication-insight) for the tokenized card.
 * @property {object} details Additional account details.
 * @property {string} details.bin The BIN number of the card.
 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
 * @property {string} details.expirationMonth The expiration month of the card.
 * @property {string} details.expirationYear The expiration year of the card.
 * @property {string} details.cardholderName The cardholder name tokenized with the card.
 * @property {string} details.lastFour Last four digits of card number.
 * @property {string} details.lastTwo Last two digits of card number.
 * @property {string} description A human-readable description.
 * @property {string} type The payment method type, always `CreditCard`.
 * @property {object} binData Information about the card based on the bin.
 * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.countryOfIssuance The country of issuance.
 * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.issuingBank The issuing bank.
 * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.productId The product id.
 */

/**
 * @typedef {object} HostedFields~stateObject
 * @description The event payload sent from {@link HostedFields#on|on} or {@link HostedFields#getState|getState}.
 * @property {HostedFields~hostedFieldsCard[]} cards
 * This will return an array of potential {@link HostedFields~hostedFieldsCard|cards}. If the card type has been determined, the array will contain only one card.
 * Internally, Hosted Fields uses <a href="https://github.com/braintree/credit-card-type">credit-card-type</a>,
 * an open-source card detection library.
 * @property {string} emittedBy
 * The name of the field associated with an event. This will not be included if returned by {@link HostedFields#getState|getState}. It will be one of the following strings:<br>
 * - `"number"`
 * - `"cvv"`
 * - `"expirationDate"`
 * - `"expirationMonth"`
 * - `"expirationYear"`
 * - `"postalCode"`
 * - `"cardholderName"`
 * @property {object} fields
 * @property {?HostedFields~hostedFieldsFieldData} fields.number {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the number field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.cvv {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the CVV field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.expirationDate {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the expiration date field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.expirationMonth {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the expiration month field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.expirationYear {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the expiration year field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.postalCode {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the postal code field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.cardholderName {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the cardholder name field, if it is present.
 */

/**
 * @typedef {object} HostedFields~binPayload
 * @description The event payload sent from {@link HostedFields#on|on} when the {@link HostedFields#event:binAvailable|binAvailable} event is emitted.
 * @property {string} bin The first 6 digits of the card number.
 */

/**
 * @typedef {object} HostedFields~hostedFieldsFieldData
 * @description Data about Hosted Fields fields, sent in {@link HostedFields~stateObject|stateObjects}.
 * @property {HTMLElement} container Reference to the container DOM element on your page associated with the current event.
 * @property {boolean} isFocused Whether or not the input is currently focused.
 * @property {boolean} isEmpty Whether or not the user has entered a value in the input.
 * @property {boolean} isPotentiallyValid
 * A determination based on the future validity of the input value.
 * This is helpful when a user is entering a card number and types <code>"41"</code>.
 * While that value is not valid for submission, it is still possible for
 * it to become a fully qualified entry. However, if the user enters <code>"4x"</code>
 * it is clear that the card number can never become valid and isPotentiallyValid will
 * return false.
 * @property {boolean} isValid Whether or not the value of the associated input is <i>fully</i> qualified for submission.
 */

/**
 * @typedef {object} HostedFields~hostedFieldsCard
 * @description Information about the card type, sent in {@link HostedFields~stateObject|stateObjects}.
 * @property {string} type The code-friendly representation of the card type. It will be one of the following strings:
 * - `american-express`
 * - `diners-club`
 * - `discover`
 * - `jcb`
 * - `maestro`
 * - `master-card`
 * - `unionpay`
 * - `visa`
 * @property {string} niceType The pretty-printed card type. It will be one of the following strings:
 * - `American Express`
 * - `Diners Club`
 * - `Discover`
 * - `JCB`
 * - `Maestro`
 * - `MasterCard`
 * - `UnionPay`
 * - `Visa`
 * @property {object} code
 * This object contains data relevant to the security code requirements of the card brand.
 * For example, on a Visa card there will be a <code>CVV</code> of 3 digits, whereas an
 * American Express card requires a 4-digit <code>CID</code>.
 * @property {string} code.name <code>"CVV"</code> <code>"CID"</code> <code>"CVC"</code>
 * @property {number} code.size The expected length of the security code. Typically, this is 3 or 4.
 */

/**
 * @name HostedFields#on
 * @function
 * @param {string} event The name of the event to which you are subscribing.
 * @param {function} handler A callback to handle the event.
 * @description Subscribes a handler function to a named event.
 *
 * **Events that emit a {@link HostedFields~stateObject|stateObject}.**
 * * {@link HostedFields#event:blur|blur}
 * * {@link HostedFields#event:focus|focus}
 * * {@link HostedFields#event:empty|empty}
 * * {@link HostedFields#event:notEmpty|notEmpty}
 * * {@link HostedFields#event:cardTypeChange|cardTypeChange}
 * * {@link HostedFields#event:validityChange|validityChange}
 * * {@link HostedFields#event:inputSubmitRequest|inputSubmitRequest}
 *
 * **Other Events**
 * * {@link HostedFields#event:binAvailable|binAvailable} - emits a {@link HostedFields~binPayload|bin payload}. Note: If you are using a [Referrer-Policy](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Referrer-Policy) header that prevents the origin from being sent, this event will not fire.
 * @example
 * <caption>Listening to a Hosted Field event, in this case 'focus'</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('focus', function (event) {
 *     console.log(event.emittedBy, 'has been focused');
 *   });
 * });
 * @returns {void}
 */

/**
 * @name HostedFields#off
 * @function
 * @param {string} event The name of the event to which you are unsubscribing.
 * @param {function} handler The callback for the event you are unsubscribing from.
 * @description Unsubscribes the handler function to a named event.
 * @example
 * <caption>Subscribing and then unsubscribing from a Hosted Field event, in this case 'focus'</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   var callback = function (event) {
 *     console.log(event.emittedBy, 'has been focused');
 *   };
 *   hostedFieldsInstance.on('focus', callback);
 *
 *   // later on
 *   hostedFieldsInstance.off('focus', callback);
 * });
 * @returns {void}
 */

/**
 * This event is emitted when the user requests submission of an input field, such as by pressing the Enter or Return key on their keyboard, or mobile equivalent.
 * @event HostedFields#inputSubmitRequest
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Clicking a submit button upon hitting Enter (or equivalent) within a Hosted Field</caption>
 * var hostedFields = require('braintree-web/hosted-fields');
 * var submitButton = document.querySelector('input[type="submit"]');
 *
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('inputSubmitRequest', function () {
 *     // User requested submission, e.g. by pressing Enter or equivalent
 *     submitButton.click();
 *   });
 * });
 */

/**
 * This event is emitted when a field transitions from having data to being empty.
 * @event HostedFields#empty
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to an empty event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('empty', function (event) {
 *     console.log(event.emittedBy, 'is now empty');
 *   });
 * });
 */

/**
 * This event is emitted when a field transitions from being empty to having data.
 * @event HostedFields#notEmpty
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to an notEmpty event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('notEmpty', function (event) {
 *     console.log(event.emittedBy, 'is now not empty');
 *   });
 * });
 */

/**
 * This event is emitted when a field loses focus.
 * @event HostedFields#blur
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to a blur event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('blur', function (event) {
 *     console.log(event.emittedBy, 'lost focus');
 *   });
 * });
 */

/**
 * This event is emitted when a field gains focus.
 * @event HostedFields#focus
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to a focus event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('focus', function (event) {
 *     console.log(event.emittedBy, 'gained focus');
 *   });
 * });
 */

/**
 * This event is emitted when activity within the number field has changed such that the possible card type has changed.
 * @event HostedFields#cardTypeChange
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to a cardTypeChange event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('cardTypeChange', function (event) {
 *     if (event.cards.length === 1) {
 *       console.log(event.cards[0].type);
 *     } else {
 *       console.log('Type of card not yet known');
 *     }
 *   });
 * });
 */

/**
 * This event is emitted when the validity of a field has changed. Validity is represented in the {@link HostedFields~stateObject|stateObject} as two booleans: `isValid` and `isPotentiallyValid`.
 * @event HostedFields#validityChange
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to a validityChange event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('validityChange', function (event) {
 *     var field = event.fields[event.emittedBy];
 *
 *     if (field.isValid) {
 *       console.log(event.emittedBy, 'is fully valid');
 *     } else if (field.isPotentiallyValid) {
 *       console.log(event.emittedBy, 'is potentially valid');
 *     } else {
 *       console.log(event.emittedBy, 'is not valid');
 *     }
 *   });
 * });
 */

/**
 * This event is emitted when the first 6 digits of the card number have been entered by the customer.
 * @event HostedFields#binAvailable
 * @type {string}
 * @example
 * <caption>Listening to a `binAvailable` event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('binAvailable', function (event) {
 *     event.bin // send bin to 3rd party bin service
 *   });
 * });
 */

function createInputEventHandler(fields) {
  return function (eventData) {
    var field;
    var merchantPayload = eventData.merchantPayload;
    var emittedBy = merchantPayload.emittedBy;
    var container = fields[emittedBy].containerElement;

    Object.keys(merchantPayload.fields).forEach(function (key) {
      merchantPayload.fields[key].container = fields[key].containerElement;
    });

    field = merchantPayload.fields[emittedBy];

    container.classList.toggle(
      constants.externalClasses.FOCUSED,
      field.isFocused
    );
    container.classList.toggle(constants.externalClasses.VALID, field.isValid);

    container.classList.toggle(
      constants.externalClasses.INVALID,
      !field.isPotentiallyValid
    );

    // eslint-disable-next-line no-invalid-this
    this._state = {
      cards: merchantPayload.cards,
      fields: merchantPayload.fields,
    };

    this._emit(eventData.type, merchantPayload); // eslint-disable-line no-invalid-this
  };
}

function isVisibleEnough(node) {
  var boundingBox = node.getBoundingClientRect();
  var verticalMidpoint = Math.floor(boundingBox.height / 2);
  var horizontalMidpoint = Math.floor(boundingBox.width / 2);

  return (
    boundingBox.top <
      (window.innerHeight - verticalMidpoint ||
        document.documentElement.clientHeight - verticalMidpoint) &&
    boundingBox.right > horizontalMidpoint &&
    boundingBox.bottom > verticalMidpoint &&
    boundingBox.left <
      (window.innerWidth - horizontalMidpoint ||
        document.documentElement.clientWidth - horizontalMidpoint)
  );
}

/**
 * @class HostedFields
 * @param {object} options The Hosted Fields {@link module:braintree-web/hosted-fields.create create} options.
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/hosted-fields.create|braintree-web.hosted-fields.create} instead.</strong>
 * @classdesc This class represents a Hosted Fields component produced by {@link module:braintree-web/hosted-fields.create|braintree-web/hosted-fields.create}. Instances of this class have methods for interacting with the input fields within Hosted Fields' iframes.
 */
function HostedFields(options) {
  var failureTimeout, clientConfig, assetsUrl, isDebug, hostedFieldsUrl;
  var self = this;
  var fields = {};
  var frameReadyPromiseResolveFunctions = {};
  var frameReadyPromises = [];
  var componentId = uuid();

  this._merchantConfigurationOptions = assign({}, options);

  if (options.client) {
    clientConfig = options.client.getConfiguration();
    assetsUrl = clientConfig.gatewayConfiguration.assetsUrl;
    isDebug = clientConfig.isDebug;
  } else {
    assetsUrl = createAssetsUrl.create(options.authorization);
    isDebug = Boolean(options.isDebug);
  }

  this._clientPromise = createDeferredClient.create({
    client: options.client,
    authorization: options.authorization,
    debug: isDebug,
    assetsUrl: assetsUrl,
    name: "Hosted Fields",
  });

  hostedFieldsUrl = composeUrl(assetsUrl, componentId, isDebug);

  if (!options.fields || Object.keys(options.fields).length === 0) {
    throw new BraintreeError({
      type: sharedErrors.INSTANTIATION_OPTION_REQUIRED.type,
      code: sharedErrors.INSTANTIATION_OPTION_REQUIRED.code,
      message: "options.fields is required when instantiating Hosted Fields.",
    });
  }

  EventEmitter.call(this);

  this._injectedNodes = [];
  this._destructor = new Destructor();
  this._fields = fields;
  this._state = {
    fields: {},
    cards: getCardTypes(""),
  };

  this._bus = new Bus({
    channel: componentId,
    verifyDomain: isVerifiedDomain,
    targetFrames: [window],
  });

  this._destructor.registerFunctionForTeardown(function () {
    self._bus.teardown();
  });

  // NEXT_MAJOR_VERSION analytics events should have present tense verbs
  if (!options.client) {
    analytics.sendEvent(
      this._clientPromise,
      "custom.hosted-fields.initialized.deferred-client"
    );
  } else {
    analytics.sendEvent(
      this._clientPromise,
      "custom.hosted-fields.initialized"
    );
  }

  Object.keys(options.fields).forEach(
    function (key) {
      var field, externalContainer, internalContainer, frame, frameReadyPromise;

      if (!constants.allowedFields.hasOwnProperty(key)) {
        throw new BraintreeError({
          type: errors.HOSTED_FIELDS_INVALID_FIELD_KEY.type,
          code: errors.HOSTED_FIELDS_INVALID_FIELD_KEY.code,
          message: '"' + key + '" is not a valid field.',
        });
      }

      field = options.fields[key];
      // NEXT_MAJOR_VERSION remove selector as an option
      // and simply make the API take a container
      externalContainer = field.container || field.selector;

      if (typeof externalContainer === "string") {
        externalContainer = document.querySelector(externalContainer);
      }

      if (!externalContainer || externalContainer.nodeType !== 1) {
        throw new BraintreeError({
          type: errors.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.type,
          code: errors.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.code,
          message: errors.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.message,
          details: {
            fieldSelector: field.selector,
            fieldContainer: field.container,
            fieldKey: key,
          },
        });
      } else if (
        externalContainer.querySelector('iframe[name^="braintree-"]')
      ) {
        throw new BraintreeError({
          type: errors.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.type,
          code: errors.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.code,
          message: errors.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.message,
          details: {
            fieldSelector: field.selector,
            fieldContainer: field.container,
            fieldKey: key,
          },
        });
      }

      internalContainer = externalContainer;

      if (shadow.isShadowElement(internalContainer)) {
        internalContainer = shadow.transformToSlot(
          internalContainer,
          "height: 100%"
        );
      }

      if (field.maxlength && typeof field.maxlength !== "number") {
        throw new BraintreeError({
          type: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.type,
          code: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.code,
          message: "The value for maxlength must be a number.",
          details: {
            fieldKey: key,
          },
        });
      }

      if (field.minlength && typeof field.minlength !== "number") {
        throw new BraintreeError({
          type: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.type,
          code: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.code,
          message: "The value for minlength must be a number.",
          details: {
            fieldKey: key,
          },
        });
      }

      frame = iFramer({
        type: key,
        name: "braintree-hosted-field-" + key,
        style: constants.defaultIFrameStyle,
        title:
          field.iframeTitle ||
          "Secure Credit Card Frame - " + constants.allowedFields[key].label,
      });
      this._bus.addTargetFrame(frame);

      this._injectedNodes.push.apply(
        this._injectedNodes,
        injectFrame(componentId, frame, internalContainer, function () {
          self.focus(key);
        })
      );

      this._setupLabelFocus(key, externalContainer);
      fields[key] = {
        frameElement: frame,
        containerElement: externalContainer,
      };
      frameReadyPromise = new Promise(function (resolve) {
        frameReadyPromiseResolveFunctions[key] = resolve;
      });
      frameReadyPromises.push(frameReadyPromise);

      this._state.fields[key] = {
        isEmpty: true,
        isValid: false,
        isPotentiallyValid: true,
        isFocused: false,
        container: externalContainer,
      };

      // prevents loading the iframe from blocking the code
      setTimeout(function () {
        frame.src = hostedFieldsUrl;
      }, 0);
    }.bind(this)
  );

  if (this._merchantConfigurationOptions.styles) {
    Object.keys(this._merchantConfigurationOptions.styles).forEach(function (
      selector
    ) {
      var className = self._merchantConfigurationOptions.styles[selector];

      if (typeof className === "string") {
        self._merchantConfigurationOptions.styles[selector] =
          getStylesFromClass(className);
      }
    });
  }

  this._bus.on(events.REMOVE_FOCUS_INTERCEPTS, function (data) {
    destroyFocusIntercept(data && data.id);
  });

  this._bus.on(
    events.TRIGGER_FOCUS_CHANGE,
    focusChange.createFocusChangeHandler(componentId, {
      onRemoveFocusIntercepts: function (element) {
        self._bus.emit(events.REMOVE_FOCUS_INTERCEPTS, {
          id: element,
        });
      },
      onTriggerInputFocus: function (targetType) {
        self.focus(targetType);
      },
    })
  );

  this._bus.on(events.READY_FOR_CLIENT, function (reply) {
    self._clientPromise.then(function (client) {
      reply(client);
    });
  });

  this._bus.on(events.CARD_FORM_ENTRY_HAS_BEGUN, function () {
    analytics.sendEvent(self._clientPromise, "hosted-fields.input.started");
  });

  this._bus.on(events.BIN_AVAILABLE, function (bin) {
    self._emit("binAvailable", {
      bin: bin,
    });
  });

  failureTimeout = setTimeout(function () {
    analytics.sendEvent(
      self._clientPromise,
      "custom.hosted-fields.load.timed-out"
    );
    self._emit("timeout");
  }, INTEGRATION_TIMEOUT_MS);

  Promise.all(frameReadyPromises).then(function (results) {
    var reply = results[0];

    clearTimeout(failureTimeout);
    reply(
      formatMerchantConfigurationForIframes(self._merchantConfigurationOptions)
    );

    self._cleanUpFocusIntercepts();

    self._emit("ready");
  });

  this._bus.on(events.FRAME_READY, function (data, reply) {
    frameReadyPromiseResolveFunctions[data.field](reply);
  });

  this._bus.on(events.INPUT_EVENT, createInputEventHandler(fields).bind(this));

  this._destructor.registerFunctionForTeardown(function () {
    var j, node, parent;

    for (j = 0; j < self._injectedNodes.length; j++) {
      node = self._injectedNodes[j];
      parent = node.parentNode;

      parent.removeChild(node);

      parent.classList.remove(
        constants.externalClasses.FOCUSED,
        constants.externalClasses.INVALID,
        constants.externalClasses.VALID
      );
    }
  });

  this._destructor.registerFunctionForTeardown(function () {
    destroyFocusIntercept();
  });

  this._destructor.registerFunctionForTeardown(function () {
    var methodNames = methods(HostedFields.prototype).concat(
      methods(EventEmitter.prototype)
    );

    convertMethodsToError(self, methodNames);
  });
}

EventEmitter.createChild(HostedFields);

HostedFields.prototype._setupLabelFocus = function (type, container) {
  var labels, i;
  var self = this;
  var rootNode = findRootNode(container);

  if (container.id == null) {
    return;
  }

  function triggerFocus() {
    self.focus(type);
  }

  // find any labels in the normal DOM
  labels = Array.prototype.slice.call(
    document.querySelectorAll('label[for="' + container.id + '"]')
  );
  if (rootNode !== document) {
    // find any labels within the shadow dom
    labels = labels.concat(
      Array.prototype.slice.call(
        rootNode.querySelectorAll('label[for="' + container.id + '"]')
      )
    );
  }
  // find any labels surrounding the container that don't also have the `for` attribute
  labels = labels.concat(findParentTags(container, "label"));
  // filter out any accidental duplicates
  labels = labels.filter(function (label, index, arr) {
    return arr.indexOf(label) === index;
  });

  for (i = 0; i < labels.length; i++) {
    labels[i].addEventListener("click", triggerFocus, false);
  }

  this._destructor.registerFunctionForTeardown(function () {
    for (i = 0; i < labels.length; i++) {
      labels[i].removeEventListener("click", triggerFocus, false);
    }
  });
};

HostedFields.prototype._getAnyFieldContainer = function () {
  var self = this;

  return Object.keys(this._fields).reduce(function (found, field) {
    return found || self._fields[field].containerElement;
  }, null);
};

HostedFields.prototype._cleanUpFocusIntercepts = function () {
  var iframeContainer, checkoutForm;

  if (document.forms.length < 1) {
    this._bus.emit(events.REMOVE_FOCUS_INTERCEPTS);
  } else {
    iframeContainer = this._getAnyFieldContainer();
    checkoutForm = findParentTags(iframeContainer, "form")[0];

    if (checkoutForm) {
      focusChange.removeExtraFocusElements(
        checkoutForm,
        function (id) {
          this._bus.emit(events.REMOVE_FOCUS_INTERCEPTS, {
            id: id,
          });
        }.bind(this)
      );
    } else {
      this._bus.emit(events.REMOVE_FOCUS_INTERCEPTS);
    }
  }
};

HostedFields.prototype._attachInvalidFieldContainersToError = function (err) {
  if (
    !(
      err.details &&
      err.details.invalidFieldKeys &&
      err.details.invalidFieldKeys.length > 0
    )
  ) {
    return;
  }
  err.details.invalidFields = {};
  err.details.invalidFieldKeys.forEach(
    function (field) {
      err.details.invalidFields[field] = this._fields[field].containerElement;
    }.bind(this)
  );
};

/**
 * Get card verification challenges, such as requirements for cvv and postal code.
 * @public
 * @param {callback} [callback] Called on completion, containing an error if one occurred. If no callback is provided, `getChallenges` returns a promise.
 * @example
 * hostedFieldsInstance.getChallenges().then(function (challenges) {
 *   challenges // ['cvv', 'postal_code']
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
HostedFields.prototype.getChallenges = function () {
  return this._clientPromise.then(function (client) {
    return client.getConfiguration().gatewayConfiguration.challenges;
  });
};

/**
 * Get supported card types configured in the Braintree Control Panel
 * @public
 * @param {callback} [callback] Called on completion, containing an error if one occurred. If no callback is provided, `getSupportedCardTypes` returns a promise.
 * @example
 * hostedFieldsInstance.getSupportedCardTypes().then(function (cardTypes) {
 *   cardTypes // ['Visa', 'American Express', 'Mastercard']
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
HostedFields.prototype.getSupportedCardTypes = function () {
  return this._clientPromise.then(function (client) {
    var cards = client
      .getConfiguration()
      .gatewayConfiguration.creditCards.supportedCardTypes.map(function (
        cardType
      ) {
        if (cardType === "MasterCard") {
          // Mastercard changed their branding. We can't update our
          // config without creating a breaking change, so we just
          // hard code the change here
          return "Mastercard";
        }

        return cardType;
      });

    return cards;
  });
};

/**
 * Cleanly remove anything set up by {@link module:braintree-web/hosted-fields.create|create}.
 * @public
 * @param {callback} [callback] Called on completion, containing an error if one occurred. No data is returned if teardown completes successfully. If no callback is provided, `teardown` returns a promise.
 * @example
 * hostedFieldsInstance.teardown(function (teardownErr) {
 *   if (teardownErr) {
 *     console.error('Could not tear down Hosted Fields!');
 *   } else {
 *     console.info('Hosted Fields has been torn down!');
 *   }
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
HostedFields.prototype.teardown = function () {
  var self = this;

  return new Promise(function (resolve, reject) {
    self._destructor.teardown(function (err) {
      analytics.sendEvent(
        self._clientPromise,
        "custom.hosted-fields.teardown-completed"
      );

      if (err) {
        reject(err);
      } else {
        resolve();
      }
    });
  });
};

/**
 * Tokenizes fields and returns a nonce payload.
 * @public
 * @param {object} [options] All tokenization options for the Hosted Fields component.
 * @param {boolean} [options.vault=false] When true, will vault the tokenized card. Cards will only be vaulted when using a client created with a client token that includes a customer ID. Note: merchants using Advanced Fraud Tools should not use this option, as device data will not be included.
 * @param {object} [options.authenticationInsight] Options for checking authentication insight - the [regulatory environment](https://developer.paypal.com/braintree/docs/guides/3d-secure/advanced-options/javascript/v3#authentication-insight) of the tokenized card.
 * @param {string} options.authenticationInsight.merchantAccountId The Braintree merchant account id to use to look up the authentication insight information.
 * @param {array} [options.fieldsToTokenize] By default, all fields will be tokenized. You may specify which fields specifically you wish to tokenize with this property. Valid options are `'number'`, `'cvv'`, `'expirationDate'`, `'expirationMonth'`, `'expirationYear'`, `'postalCode'`, `'cardholderName'`.
 * @param {string} [options.cardholderName] When supplied, the cardholder name to be tokenized with the contents of the fields.
 * @param {string} [options.billingAddress.postalCode] When supplied, this postal code will be tokenized along with the contents of the fields. If a postal code is provided as part of the Hosted Fields configuration, the value of the field will be tokenized and this value will be ignored.
 * @param {string} [options.billingAddress.firstName] When supplied, this customer first name will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.lastName] When supplied, this customer last name will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.company] When supplied, this company name will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.streetAddress] When supplied, this street address will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.extendedAddress] When supplied, this extended address will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.locality] When supplied, this locality (the city) will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.region] When supplied, this region (the state) will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.countryCodeNumeric] When supplied, this numeric country code will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.countryCodeAlpha2] When supplied, this alpha 2 representation of a country will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.countryCodeAlpha3] When supplied, this alpha 3 representation of a country will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.countryName] When supplied, this country name will be tokenized along with the contents of the fields.
 *
 * @param {callback} [callback] May be used as the only parameter of the function if no options are passed in. The second argument, <code>data</code>, is a {@link HostedFields~tokenizePayload|tokenizePayload}. If no callback is provided, `tokenize` returns a function that resolves with a {@link HostedFields~tokenizePayload|tokenizePayload}.
 * @example <caption>Tokenize a card</caption>
 * hostedFieldsInstance.tokenize(function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     switch (tokenizeErr.code) {
 *       case 'HOSTED_FIELDS_FIELDS_EMPTY':
 *         // occurs when none of the fields are filled in
 *         console.error('All fields are empty! Please fill out the form.');
 *         break;
 *       case 'HOSTED_FIELDS_FIELDS_INVALID':
 *         // occurs when certain fields do not pass client side validation
 *         console.error('Some fields are invalid:', tokenizeErr.details.invalidFieldKeys);
 *
 *         // you can also programmatically access the field containers for the invalid fields
 *         tokenizeErr.details.invalidFields.forEach(function (fieldContainer) {
 *           fieldContainer.className = 'invalid';
 *         });
 *         break;
 *       case 'HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE':
 *         // occurs when:
 *         //   * the client token used for client authorization was generated
 *         //     with a customer ID and the fail on duplicate payment method
 *         //     option is set to true
 *         //   * the card being tokenized has previously been vaulted (with any customer)
 *         // See: https://developer.paypal.com/braintree/docs/reference/request/client-token/generate#options.fail_on_duplicate_payment_method
 *         console.error('This payment method already exists in your vault.');
 *         break;
 *       case 'HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED':
 *         // occurs when:
 *         //   * the client token used for client authorization was generated
 *         //     with a customer ID and the verify card option is set to true
 *         //     and you have credit card verification turned on in the Braintree
 *         //     control panel
 *         //   * the cvv does not pass verification (https://developer.paypal.com/braintree/docs/reference/general/testing#avs-and-cvv/cid-responses)
 *         // See: https://developer.paypal.com/braintree/docs/reference/request/client-token/generate#options.verify_card
 *         console.error('CVV did not pass verification');
 *         break;
 *       case 'HOSTED_FIELDS_FAILED_TOKENIZATION':
 *         // occurs for any other tokenization error on the server
 *         console.error('Tokenization failed server side. Is the card valid?');
 *         break;
 *       case 'HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR':
 *         // occurs when the Braintree gateway cannot be contacted
 *         console.error('Network error occurred when tokenizing.');
 *         break;
 *       default:
 *         console.error('Something bad happened!', tokenizeErr);
 *     }
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Tokenize and vault a card</caption>
 * hostedFieldsInstance.tokenize({
 *   vault: true
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Tokenize a card with non-Hosted Fields cardholder name</caption>
 * hostedFieldsInstance.tokenize({
 *   cardholderName: 'First Last'
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Tokenize a card with non-Hosted Fields postal code option</caption>
 * hostedFieldsInstance.tokenize({
 *   billingAddress: {
 *     postalCode: '11111'
 *   }
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Tokenize a card with additional billing address options</caption>
 * hostedFieldsInstance.tokenize({
 *   billingAddress: {
 *     firstName: 'First',
 *     lastName: 'Last',
 *     company: 'Company',
 *     streetAddress: '123 Street',
 *     extendedAddress: 'Unit 1',
 *     // passing just one of the country options is sufficient to
 *     // associate the card details with a particular country
 *     // valid country names and codes can be found here:
 *     // https://developer.paypal.com/braintree/docs/reference/general/countries/ruby#list-of-countries
 *     countryName: 'United States',
 *     countryCodeAlpha2: 'US',
 *     countryCodeAlpha3: 'USA',
 *     countryCodeNumeric: '840'
 *   }
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Allow tokenization with empty cardholder name field</caption>
 * var state = hostedFieldsInstance.getState();
 * var fields = Object.keys(state.fields);
 *
 * // normally, if you tried to tokenize an empty cardholder name field
 * // you would get an error, to allow making this field optional,
 * // tokenize all the fields except for the cardholder name field
 * // when the cardholder name field is empty. Otherwise, tokenize
 * // all the fields
 * if (state.fields.cardholderName.isEmpty) {
 *  fields = fields.filter(function (field) {
 *    return field !== 'cardholderName';
 *  });
 * }
 *
 * hostedFieldsInstance.tokenize({
 *  fieldsToTokenize: fields
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
HostedFields.prototype.tokenize = function (options) {
  var self = this;

  if (!options) {
    options = {};
  }

  return new Promise(function (resolve, reject) {
    self._bus.emit(events.TOKENIZATION_REQUEST, options, function (response) {
      var err = response[0];
      var payload = response[1];

      if (err) {
        self._attachInvalidFieldContainersToError(err);
        reject(new BraintreeError(err));
      } else {
        resolve(payload);
      }
    });
  });
};

/**
 * Add a class to a {@link module:braintree-web/hosted-fields~field field}. Useful for updating field styles when events occur elsewhere in your checkout.
 * @public
 * @param {string} field The field you wish to add a class to. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} classname The class to be added.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the class is added successfully.
 *
 * @example
 * hostedFieldsInstance.addClass('number', 'custom-class', function (addClassErr) {
 *   if (addClassErr) {
 *     console.error(addClassErr);
 *   }
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
HostedFields.prototype.addClass = function (field, classname) {
  var err;

  if (!allowedFields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
      message:
        '"' +
        field +
        '" is not a valid field. You must use a valid field option when adding a class.',
    });
  } else if (!this._fields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
      message:
        'Cannot add class to "' +
        field +
        '" field because it is not part of the current Hosted Fields options.',
    });
  } else {
    this._bus.emit(events.ADD_CLASS, {
      field: field,
      classname: classname,
    });
  }

  if (err) {
    return Promise.reject(err);
  }

  return Promise.resolve();
};

/**
 * Removes a class to a {@link module:braintree-web/hosted-fields~field field}. Useful for updating field styles when events occur elsewhere in your checkout.
 * @public
 * @param {string} field The field you wish to remove a class from. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} classname The class to be removed.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the class is removed successfully.
 *
 * @example
 * hostedFieldsInstance.addClass('number', 'custom-class', function (addClassErr) {
 *   if (addClassErr) {
 *     console.error(addClassErr);
 *     return;
 *   }
 *
 *   // some time later...
 *   hostedFieldsInstance.removeClass('number', 'custom-class');
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
HostedFields.prototype.removeClass = function (field, classname) {
  var err;

  if (!allowedFields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
      message:
        '"' +
        field +
        '" is not a valid field. You must use a valid field option when removing a class.',
    });
  } else if (!this._fields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
      message:
        'Cannot remove class from "' +
        field +
        '" field because it is not part of the current Hosted Fields options.',
    });
  } else {
    this._bus.emit(events.REMOVE_CLASS, {
      field: field,
      classname: classname,
    });
  }

  if (err) {
    return Promise.reject(err);
  }

  return Promise.resolve();
};

/**
 * Sets an attribute of a {@link module:braintree-web/hosted-fields~field field}.
 * Supported attributes are `aria-invalid`, `aria-required`, `disabled`, and `placeholder`.
 *
 * @public
 * @param {object} options The options for the attribute you wish to set.
 * @param {string} options.field The field to which you wish to add an attribute. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} options.attribute The name of the attribute you wish to add to the field.
 * @param {string} options.value The value for the attribute.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the attribute is set successfully.
 *
 * @example <caption>Set the placeholder attribute of a field</caption>
 * hostedFieldsInstance.setAttribute({
 *   field: 'number',
 *   attribute: 'placeholder',
 *   value: '1111 1111 1111 1111'
 * }, function (attributeErr) {
 *   if (attributeErr) {
 *     console.error(attributeErr);
 *   }
 * });
 *
 * @example <caption>Set the aria-required attribute of a field</caption>
 * hostedFieldsInstance.setAttribute({
 *   field: 'number',
 *   attribute: 'aria-required',
 *   value: true
 * }, function (attributeErr) {
 *   if (attributeErr) {
 *     console.error(attributeErr);
 *   }
 * });
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
HostedFields.prototype.setAttribute = function (options) {
  var attributeErr, err;

  if (!allowedFields.hasOwnProperty(options.field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
      message:
        '"' +
        options.field +
        '" is not a valid field. You must use a valid field option when setting an attribute.',
    });
  } else if (!this._fields.hasOwnProperty(options.field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
      message:
        'Cannot set attribute for "' +
        options.field +
        '" field because it is not part of the current Hosted Fields options.',
    });
  } else {
    attributeErr = attributeValidationError(options.attribute, options.value);

    if (attributeErr) {
      err = attributeErr;
    } else {
      this._bus.emit(events.SET_ATTRIBUTE, {
        field: options.field,
        attribute: options.attribute,
        value: options.value,
      });
    }
  }

  if (err) {
    return Promise.reject(err);
  }

  return Promise.resolve();
};

/**
 * Sets the month options for the expiration month field when presented as a select element.
 *
 * @public
 * @param {array} options An array of 12 entries corresponding to the 12 months.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the options are updated successfully. Errors if expirationMonth is not configured on the Hosted Fields instance or if the expirationMonth field is not configured to be a select input.
 *
 * @example <caption>Update the month options to spanish</caption>
 * hostedFieldsInstance.setMonthOptions([
 *   '01 - enero',
 *   '02 - febrero',
 *   '03 - marzo',
 *   '04 - abril',
 *   '05 - mayo',
 *   '06 - junio',
 *   '07 - julio',
 *   '08 - agosto',
 *   '09 - septiembre',
 *   '10 - octubre',
 *   '11 - noviembre',
 *   '12 - diciembre'
 * ]);
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
HostedFields.prototype.setMonthOptions = function (options) {
  var self = this;
  var merchantOptions = this._merchantConfigurationOptions.fields;
  var errorMessage;

  if (!merchantOptions.expirationMonth) {
    errorMessage = "Expiration month field must exist to use setMonthOptions.";
  } else if (!merchantOptions.expirationMonth.select) {
    errorMessage = "Expiration month field must be a select element.";
  }

  if (errorMessage) {
    return Promise.reject(
      new BraintreeError({
        type: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.type,
        code: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.code,
        message: errorMessage,
      })
    );
  }

  return new Promise(function (resolve) {
    self._bus.emit(events.SET_MONTH_OPTIONS, options, resolve);
  });
};

/**
 * Sets a visually hidden message (for screen readers) on a {@link module:braintree-web/hosted-fields~field field}.
 *
 * @public
 * @param {object} options The options for the attribute you wish to set.
 * @param {string} options.field The field to which you wish to add an attribute. Must be a valid {@link module:braintree-web/hosted-fields~field field}.
 * @param {string} options.message The message to set.
 *
 * @example <caption>Set an error message on a field</caption>
 * hostedFieldsInstance.setMessage({
 *   field: 'number',
 *   message: 'Invalid card number'
 * });
 *
 * @example <caption>Remove the message on a field</caption>
 * hostedFieldsInstance.setMessage({
 *   field: 'number',
 *   message: ''
 * });
 *
 * @returns {void}
 */
HostedFields.prototype.setMessage = function (options) {
  this._bus.emit(events.SET_MESSAGE, {
    field: options.field,
    message: options.message,
  });
};

/**
 * Removes a supported attribute from a {@link module:braintree-web/hosted-fields~field field}.
 *
 * @public
 * @param {object} options The options for the attribute you wish to remove.
 * @param {string} options.field The field from which you wish to remove an attribute. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} options.attribute The name of the attribute you wish to remove from the field.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the attribute is removed successfully.
 *
 * @example <caption>Remove the placeholder attribute of a field</caption>
 * hostedFieldsInstance.removeAttribute({
 *   field: 'number',
 *   attribute: 'placeholder'
 * }, function (attributeErr) {
 *   if (attributeErr) {
 *     console.error(attributeErr);
 *   }
 * });
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
HostedFields.prototype.removeAttribute = function (options) {
  var attributeErr, err;

  if (!allowedFields.hasOwnProperty(options.field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
      message:
        '"' +
        options.field +
        '" is not a valid field. You must use a valid field option when removing an attribute.',
    });
  } else if (!this._fields.hasOwnProperty(options.field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
      message:
        'Cannot remove attribute for "' +
        options.field +
        '" field because it is not part of the current Hosted Fields options.',
    });
  } else {
    attributeErr = attributeValidationError(options.attribute);

    if (attributeErr) {
      err = attributeErr;
    } else {
      this._bus.emit(events.REMOVE_ATTRIBUTE, {
        field: options.field,
        attribute: options.attribute,
      });
    }
  }

  if (err) {
    return Promise.reject(err);
  }

  return Promise.resolve();
};

/**
 * @deprecated since version 3.8.0. Use {@link HostedFields#setAttribute|setAttribute} instead.
 *
 * @public
 * @param {string} field The field whose placeholder you wish to change. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} placeholder Will be used as the `placeholder` attribute of the input.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the placeholder updated successfully.
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
HostedFields.prototype.setPlaceholder = function (field, placeholder) {
  return this.setAttribute({
    field: field,
    attribute: "placeholder",
    value: placeholder,
  });
};

/**
 * Clear the value of a {@link module:braintree-web/hosted-fields~field field}.
 * @public
 * @param {string} field The field you wish to clear. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the field cleared successfully.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * hostedFieldsInstance.clear('number', function (clearErr) {
 *   if (clearErr) {
 *     console.error(clearErr);
 *   }
 * });
 *
 * @example <caption>Clear several fields</caption>
 * hostedFieldsInstance.clear('number');
 * hostedFieldsInstance.clear('cvv');
 * hostedFieldsInstance.clear('expirationDate');
 */
HostedFields.prototype.clear = function (field) {
  var err;

  if (!allowedFields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
      message:
        '"' +
        field +
        '" is not a valid field. You must use a valid field option when clearing a field.',
    });
  } else if (!this._fields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
      message:
        'Cannot clear "' +
        field +
        '" field because it is not part of the current Hosted Fields options.',
    });
  } else {
    this._bus.emit(events.CLEAR_FIELD, {
      field: field,
    });
  }

  if (err) {
    return Promise.reject(err);
  }

  return Promise.resolve();
};

/**
 * Programmatically focus a {@link module:braintree-web/hosted-fields~field field}.
 * @public
 * @param {string} field The field you want to focus. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the field focused successfully.
 * @returns {void}
 * @example
 * hostedFieldsInstance.focus('number', function (focusErr) {
 *   if (focusErr) {
 *     console.error(focusErr);
 *   }
 * });
 * @example <caption>Using an event listener</caption>
 * myElement.addEventListener('click', function (e) {
 *   // In Firefox, the focus method can be suppressed
 *   //   if the element has a tabindex property or the element
 *   //   is an anchor link with an href property.
 *   e.preventDefault();
 *   hostedFieldsInstance.focus('number');
 * });
 */
HostedFields.prototype.focus = function (field) {
  var err;
  var fieldConfig = this._fields[field];

  if (!allowedFields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
      message:
        '"' +
        field +
        '" is not a valid field. You must use a valid field option when focusing a field.',
    });
  } else if (!this._fields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
      message:
        'Cannot focus "' +
        field +
        '" field because it is not part of the current Hosted Fields options.',
    });
  } else {
    fieldConfig.frameElement.focus();

    this._bus.emit(events.TRIGGER_INPUT_FOCUS, {
      field: field,
    });

    if (browserDetection.isIos()) {
      // Inputs outside of the viewport don't always scroll into view on
      // focus in iOS Safari. 5ms timeout gives the browser a chance to
      // do the right thing and prevents stuttering.
      setTimeout(function () {
        if (!isVisibleEnough(fieldConfig.containerElement)) {
          fieldConfig.containerElement.scrollIntoView();
        }
      }, SAFARI_FOCUS_TIMEOUT);
    }
  }

  if (err) {
    return Promise.reject(err);
  }

  return Promise.resolve();
};

/**
 * Returns an {@link HostedFields~stateObject|object} that includes the state of all fields and possible card types.
 * @public
 * @returns {object} {@link HostedFields~stateObject|stateObject}
 * @example <caption>Check if all fields are valid</caption>
 * var state = hostedFieldsInstance.getState();
 *
 * var formValid = Object.keys(state.fields).every(function (key) {
 *   return state.fields[key].isValid;
 * });
 */
HostedFields.prototype.getState = function () {
  return this._state;
};

// React adds decorations to DOM nodes that cause
// circular dependencies, so we remove them from the
// config before sending it to the iframes. However,
// we don't want to mutate the original object that
// was passed in, so we create fresh objects via assign
function formatMerchantConfigurationForIframes(config) {
  var formattedConfig = assign({}, config);

  formattedConfig.fields = assign({}, formattedConfig.fields);
  Object.keys(formattedConfig.fields).forEach(function (field) {
    formattedConfig.fields[field] = assign({}, formattedConfig.fields[field]);
    delete formattedConfig.fields[field].container;
  });

  return formattedConfig;
}

module.exports = wrapPromise.wrapPrototype(HostedFields);

},{"../../lib/analytics":119,"../../lib/assign":121,"../../lib/braintree-error":124,"../../lib/constants":126,"../../lib/convert-methods-to-error":127,"../../lib/create-assets-url":129,"../../lib/create-deferred-client":131,"../../lib/destructor":133,"../../lib/errors":135,"../../lib/find-root-node":136,"../../lib/is-verified-domain":153,"../../lib/methods":155,"../../lib/shadow":158,"../shared/browser-detection":111,"../shared/constants":112,"../shared/errors":113,"../shared/find-parent-tags":114,"../shared/focus-intercept":115,"../shared/get-card-types":116,"./attribute-validation-error":104,"./compose-url":105,"./focus-change":106,"./get-styles-from-class":107,"./inject-frame":109,"@braintree/event-emitter":33,"@braintree/iframer":35,"@braintree/uuid":39,"@braintree/wrap-promise":43,"framebus":52}],109:[function(_dereq_,module,exports){
"use strict";

var focusIntercept = _dereq_("../shared/focus-intercept");
var directions = _dereq_("../shared/constants").navigationDirections;

module.exports = function injectFrame(id, frame, container, focusHandler) {
  var frameType = frame.getAttribute("type");
  var clearboth = document.createElement("div");
  var fragment = document.createDocumentFragment();
  var focusInterceptBefore = focusIntercept.generate(
    id,
    frameType,
    directions.BACK,
    focusHandler
  );
  var focusInterceptAfter = focusIntercept.generate(
    id,
    frameType,
    directions.FORWARD,
    focusHandler
  );

  clearboth.style.clear = "both";

  fragment.appendChild(focusInterceptBefore);
  fragment.appendChild(frame);
  fragment.appendChild(focusInterceptAfter);
  fragment.appendChild(clearboth);

  container.appendChild(fragment);

  return [frame, clearboth];
};

},{"../shared/constants":112,"../shared/focus-intercept":115}],110:[function(_dereq_,module,exports){
"use strict";
/** @module braintree-web/hosted-fields */

var HostedFields = _dereq_("./external/hosted-fields");
var basicComponentVerification = _dereq_("../lib/basic-component-verification");
var errors = _dereq_("./shared/errors");
var supportsInputFormatting = _dereq_("restricted-input/supports-input-formatting");
var wrapPromise = _dereq_("@braintree/wrap-promise");
var BraintreeError = _dereq_("../lib/braintree-error");
var VERSION = "3.101.3";

/**
 * Fields used in {@link module:braintree-web/hosted-fields~fieldOptions fields options}
 * @typedef {object} field
 * @property {string} selector Deprecated: Now an alias for `options.container`.
 * @property {(string|HTMLElement)} container A DOM node or CSS selector to find the container where the hosted field will be inserted.
 * @property {string} [placeholder] Will be used as the `placeholder` attribute of the input. If `placeholder` is not natively supported by the browser, it will be polyfilled.
 * @property {string} [type] Will be used as the `type` attribute of the input. To mask `cvv` input, for instance, `type: "password"` can be used.
 * @property {string} [iframeTitle] The title used for the iframe containing the credit card input. By default, this will be `Secure Credit Card Frame - <the name of the specific field>`.
 * @property {string} [internalLabel] Each Hosted Field iframe has a hidden label that is used by screen readers to identify the input. The `internalLabel` property can be used to customize the field for localization purposes. The default values are:
 * * number: Credit Card Number
 * * cvv: CVV
 * * expirationDate: Expiration Date
 * * expirationMonth: Expiration Month
 * * expirationYear: Expiration Year
 * * postalCode: Postal Code
 * * cardholderName: Cardholder Name
 * @property {boolean} [formatInput=true] Enable or disable automatic formatting on this field.
 * @property {(object|boolean)} [maskInput=false] Enable or disable input masking when input is not focused. If set to `true` instead of an object, the defaults for the `maskInput` parameters will be used.
 * @property {string} [maskInput.character=•] The character to use when masking the input. The default character ('•') uses a unicode symbol, so the webpage must support UTF-8 characters when using the default.
 * @property {Boolean} [maskInput.showLastFour=false] Only applicable for the credit card field. Whether or not to show the last 4 digits of the card when masking.
 * @property {(object|boolean)} [select] If truthy, this field becomes a `<select>` dropdown list. This can only be used for `expirationMonth` and `expirationYear` fields. If you do not use a `placeholder` property for the field, the current month/year will be the default selected value.
 * @property {string[]} [select.options] An array of 12 strings, one per month. This can only be used for the `expirationMonth` field. For example, the array can look like `['01 - January', '02 - February', ...]`.
 * @property {number} [maxCardLength] This option applies only to the number field. Allows a limit to the length of the card number, even if the card brand may support numbers of a greater length. If the value passed is greater than the max length for a card brand, the smaller number of the 2 values will be used. For example, is `maxCardLength` is set to 16, but an American Express card is entered (which has a max card length of 15), a max card length of 15 will be used.
 * @property {number} [maxlength] This option applies only to the CVV and postal code fields. Will be used as the `maxlength` attribute of the input. The primary use cases for the `maxlength` option are: limiting the length of the CVV input for CVV-only verifications when the card type is known and setting the length of the postal code input when cards are coming from a known region. The default `maxlength` for the postal code input is `10`.
 * @property {number} [minlength=3] This option applies only to the cvv and postal code fields. Will be used as the `minlength` attribute of the input.
 * For postal code fields, the default value is 3, representing the Icelandic postal code length. This option's primary use case is to increase the `minlength`, e.g. for US customers, the postal code `minlength` can be set to 5.
 * For cvv fields, the default value is 3. The `minlength` attribute only applies to integrations capturing a cvv without a number field.
 * @property {string} [prefill] A value to prefill the field with. For example, when creating an update card form, you can prefill the expiration date fields with the old expiration date data.
 * @property {boolean} [rejectUnsupportedCards=false] Deprecated since version 3.46.0, use `supportedCardBrands` instead. Only allow card types that your merchant account is able to process. Unsupported card types will invalidate the card form. e.g. if you only process Visa cards, a customer entering a American Express card would get an invalid card field. This can only be used for the `number` field.
 * @property {object} [supportedCardBrands] Override card brands that are supported by the card form. Pass `'card-brand-id': true` to override the default in the merchant configuration and enable a card brand. Pass `'card-brand-id': false` to disable a card brand. Unsupported card types will invalidate the card form. e.g. if you only process Visa cards, a customer entering an American Express card would get an invalid card field. This can only be used for the  `number` field. (Note: only allow card types that your merchant account is actually able to process.)
 *
 * Valid card brand ids are:
 * * visa
 * * mastercard
 * * american-express
 * * diners-club
 * * discover
 * * jcb
 * * union-pay
 * * maestro
 * * elo
 * * mir
 * * hiper
 * * hipercard
 */

/**
 * An object that has {@link module:braintree-web/hosted-fields~field field objects} for each field. Used in {@link module:braintree-web/hosted-fields~create create}.
 * @typedef {object} fieldOptions
 * @property {field} [number] A field for card number.
 * @property {field} [expirationDate] A field for expiration date in `MM/YYYY` or `MM/YY` format. This should not be used with the `expirationMonth` and `expirationYear` properties.
 * @property {field} [expirationMonth] A field for expiration month in `MM` format. This should be used with the `expirationYear` property.
 * @property {field} [expirationYear] A field for expiration year in `YYYY` or `YY` format. This should be used with the `expirationMonth` property.
 * @property {field} [cvv] A field for 3 or 4 digit card verification code (like CVV or CID). If you wish to create a CVV-only payment method nonce to verify a card already stored in your Vault, omit all other fields to only collect CVV.
 * @property {field} [postalCode] A field for postal or region code.
 * @property {field} [cardholderName] A field for the cardholder name on the customer's credit card.
 */

/**
 * An object that represents CSS that will be applied in each hosted field. This object looks similar to CSS. Typically, these styles involve fonts (such as `font-family` or `color`).
 *
 * You may also pass the name of a class on your site that contains the styles you would like to apply. The style properties will be automatically pulled off the class and applied to the Hosted Fields inputs. Note: this is recommended for `input` elements only. If using a `select` for the expiration date, unexpected styling may occur.
 *
 * These are the CSS properties that Hosted Fields supports. Any other CSS should be specified on your page and outside of any Braintree configuration. Trying to set unsupported properties will fail and put a warning in the console.
 *
 * Supported CSS properties are:
 * `appearance`
 * `box-shadow`
 * `color`
 * `direction`
 * `font-family`
 * `font-size-adjust`
 * `font-size`
 * `font-stretch`
 * `font-style`
 * `font-variant-alternates`
 * `font-variant-caps`
 * `font-variant-east-asian`
 * `font-variant-ligatures`
 * `font-variant-numeric`
 * `font-variant`
 * `font-weight`
 * `font`
 * `letter-spacing`
 * `line-height`
 * `opacity`
 * `outline`
 * `margin`
 * `margin-top`
 * `margin-right`
 * `margin-bottom`
 * `margin-left`
 * `padding`
 * `padding-top`
 * `padding-right`
 * `padding-bottom`
 * `padding-left`
 * `text-align`
 * `text-shadow`
 * `transition`
 * `-moz-appearance`
 * `-moz-box-shadow`
 * `-moz-osx-font-smoothing`
 * `-moz-tap-highlight-color`
 * `-moz-transition`
 * `-webkit-appearance`
 * `-webkit-box-shadow`
 * `-webkit-font-smoothing`
 * `-webkit-tap-highlight-color`
 * `-webkit-transition`
 * @typedef {object} styleOptions
 */

/**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {fieldOptions} options.fields A {@link module:braintree-web/hosted-fields~fieldOptions set of options for each field}.
 * @param {styleOptions} [options.styles] {@link module:braintree-web/hosted-fields~styleOptions Styles} applied to each field.
 * @param {boolean} [options.preventAutofill=false] When true, browsers will not try to prompt the customer to autofill their credit card information.
 * @param {callback} [callback] The second argument, `data`, is the {@link HostedFields} instance. If no callback is provided, `create` returns a promise that resolves with the {@link HostedFields} instance.
 * @returns {void}
 * @example
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   styles: {
 *     'input': {
 *       'font-size': '16pt',
 *       'color': '#3A3A3A'
 *     },
 *     '.number': {
 *       'font-family': 'monospace'
 *     },
 *     '.valid': {
 *       'color': 'green'
 *     }
 *   },
 *   fields: {
 *     number: {
 *       container: '#card-number'
 *     },
 *     cvv: {
 *       container: '#cvv',
 *       placeholder: '•••'
 *     },
 *     expirationDate: {
 *       container: '#expiration-date'
 *     }
 *   }
 * }, callback);
 * @example <caption>With cardholder name</caption>
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   fields: {
 *     number: {
 *       container: '#card-number'
 *     },
 *     cardholderName: {
 *       container: '#cardholder-name'
 *     },
 *     cvv: {
 *       container: '#cvv',
 *     },
 *     expirationDate: {
 *       container: '#expiration-date'
 *     }
 *   }
 * }, callback);
 * @example <caption>Applying styles with a class name</caption>
 * // in document head
 * <style>
 *   .braintree-input-class {
 *     color: black;
 *   }
 *   .braintree-valid-class {
 *     color: green;
 *   }
 *   .braintree-invalid-class {
 *     color: red;
 *   }
 * </style>
 * // in a script tag
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   styles: {
 *     'input': 'braintree-input-class',
 *     '.invalid': 'braintree-invalid-class',
 *     '.valid': {
 *       // you can also use the object syntax alongside
 *       // the class name syntax
 *       color: green;
 *     }
 *   },
 *   fields: {
 *     number: {
 *       container: '#card-number'
 *     },
 *     // etc...
 *   }
 * }, callback);
 * @example <caption>Right to Left Language Support</caption>
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   styles: {
 *     'input': {
 *       // other styles
 *       direction: 'rtl'
 *     },
 *   },
 *   fields: {
 *     number: {
 *       container: '#card-number',
 *       // Credit card formatting is not currently supported
 *       // with RTL languages, so we need to turn it off for the number input
 *       formatInput: false
 *     },
 *     cvv: {
 *       container: '#cvv',
 *       placeholder: '•••'
 *     },
 *     expirationDate: {
 *       container: '#expiration-date',
 *       type: 'month'
 *     }
 *   }
 * }, callback);
 * @example <caption>Setting up Hosted Fields to tokenize CVV only</caption>
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   fields: {
 *     // Only add the `cvv` option.
 *     cvv: {
 *       container: '#cvv',
 *       placeholder: '•••'
 *     }
 *   }
 * }, callback);
 * @example <caption>Creating an expiration date update form with prefilled data</caption>
 * var storedCreditCardInformation = {
 *   // get this info from your server
 *   // with a payment method lookup
 *   month: '09',
 *   year: '2017'
 * };
 *
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   fields: {
 *     expirationMonth: {
 *       container: '#expiration-month',
 *       prefill: storedCreditCardInformation.month
 *     },
 *     expirationYear: {
 *       container: '#expiration-year',
 *       prefill: storedCreditCardInformation.year
 *     }
 *   }
 * }, callback);
 * @example <caption>Validate the card form for supported card types</caption>
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   fields: {
 *     number: {
 *       container: '#card-number',
 *       supportedCardBrands: {
 *         visa: false, // prevents Visas from showing up as valid even when the Braintree control panel is configured to allow them
 *         'diners-club': true // allow Diners Club cards to be valid (processed as Discover cards on the Braintree backend)
 *       }
 *     },
 *     cvv: {
 *       container: '#cvv',
 *       placeholder: '•••'
 *     },
 *     expirationDate: {
 *       container: '#expiration-date',
 *       type: 'month'
 *     }
 *   },
 * }, callback);
 */
function create(options) {
  return basicComponentVerification
    .verify({
      name: "Hosted Fields",
      authorization: options.authorization,
      client: options.client,
    })
    .then(function () {
      var integration = new HostedFields(options);

      return new Promise(function (resolve, reject) {
        integration.on("ready", function () {
          resolve(integration);
        });
        integration.on("timeout", function () {
          reject(new BraintreeError(errors.HOSTED_FIELDS_TIMEOUT));
        });
      });
    });
}

module.exports = {
  /**
   * @static
   * @function supportsInputFormatting
   * @description Returns false if input formatting will be automatically disabled due to browser incompatibility. Otherwise, returns true. For a list of unsupported browsers, [go here](https://github.com/braintree/restricted-input/blob/main/README.md#browsers-where-formatting-is-turned-off-automatically).
   * @returns {Boolean} Returns false if input formatting will be automatically disabled due to browser incompatibility. Otherwise, returns true.
   * @example
   * <caption>Conditionally choosing split expiration date inputs if formatting is unavailable</caption>
   * var canFormat = braintree.hostedFields.supportsInputFormatting();
   * var fields = {
   *   number: {
   *     container: '#card-number'
   *   },
   *   cvv: {
   *     container: '#cvv'
   *   }
   * };
   *
   * if (canFormat) {
   *   fields.expirationDate = {
   *     selection: '#expiration-date'
   *   };
   *   functionToCreateAndInsertExpirationDateDivToForm();
   * } else {
   *   fields.expirationMonth = {
   *     selection: '#expiration-month'
   *   };
   *   fields.expirationYear = {
   *     selection: '#expiration-year'
   *   };
   *   functionToCreateAndInsertExpirationMonthAndYearDivsToForm();
   * }
   *
   * braintree.hostedFields.create({
   *   client: clientInstance,
   *   styles: {
   *     // Styles
   *   },
   *   fields: fields
   * }, callback);
   */
  supportsInputFormatting: supportsInputFormatting,
  create: wrapPromise(create),
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION,
};

},{"../lib/basic-component-verification":122,"../lib/braintree-error":124,"./external/hosted-fields":108,"./shared/errors":113,"@braintree/wrap-promise":43,"restricted-input/supports-input-formatting":71}],111:[function(_dereq_,module,exports){
"use strict";

var isAndroid = _dereq_("@braintree/browser-detection/is-android");
var isChromeOS = _dereq_("@braintree/browser-detection/is-chrome-os");
var isIos = _dereq_("@braintree/browser-detection/is-ios");
var isChrome = _dereq_("@braintree/browser-detection/is-chrome");

function hasSoftwareKeyboard() {
  return isAndroid() || isChromeOS() || isIos();
}

function isChromeIos() {
  return isChrome() && isIos();
}

module.exports = {
  isAndroid: isAndroid,
  isChromeOS: isChromeOS,
  isChromeIos: isChromeIos,
  isFirefox: _dereq_("@braintree/browser-detection/is-firefox"),
  isIos: isIos,
  isIosWebview: _dereq_("@braintree/browser-detection/is-ios-webview"),
  hasSoftwareKeyboard: hasSoftwareKeyboard,
};

},{"@braintree/browser-detection/is-android":22,"@braintree/browser-detection/is-chrome":24,"@braintree/browser-detection/is-chrome-os":23,"@braintree/browser-detection/is-firefox":25,"@braintree/browser-detection/is-ios":30,"@braintree/browser-detection/is-ios-webview":28}],112:[function(_dereq_,module,exports){
"use strict";

var enumerate = _dereq_("../../lib/enumerate");
var errors = _dereq_("./errors");
var VERSION = "3.101.3";

var constants = {
  VERSION: VERSION,
  maxExpirationYearAge: 19,
  externalEvents: {
    FOCUS: "focus",
    BLUR: "blur",
    EMPTY: "empty",
    NOT_EMPTY: "notEmpty",
    VALIDITY_CHANGE: "validityChange",
    CARD_TYPE_CHANGE: "cardTypeChange",
  },
  defaultMaxLengths: {
    number: 19,
    postalCode: 8,
    expirationDate: 7,
    expirationMonth: 2,
    expirationYear: 4,
    cvv: 3,
  },
  externalClasses: {
    FOCUSED: "braintree-hosted-fields-focused",
    INVALID: "braintree-hosted-fields-invalid",
    VALID: "braintree-hosted-fields-valid",
  },
  navigationDirections: {
    BACK: "before",
    FORWARD: "after",
  },
  defaultIFrameStyle: {
    border: "none",
    width: "100%",
    height: "100%",
    float: "left",
  },
  tokenizationErrorCodes: {
    81724: errors.HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE,
    // NEXT_MAJOR_VERSION this error triggers for both AVS and CVV errors
    // but the code name implies that it would only trigger for CVV verification
    // failures
    81736: errors.HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED,
  },
  allowedStyles: [
    "-moz-appearance",
    "-moz-box-shadow",
    "-moz-osx-font-smoothing",
    "-moz-tap-highlight-color",
    "-moz-transition",
    "-webkit-appearance",
    "-webkit-box-shadow",
    "-webkit-font-smoothing",
    "-webkit-tap-highlight-color",
    "-webkit-transition",
    "appearance",
    "box-shadow",
    "color",
    "direction",
    "font",
    "font-family",
    "font-size",
    "font-size-adjust",
    "font-stretch",
    "font-style",
    "font-variant",
    "font-variant-alternates",
    "font-variant-caps",
    "font-variant-east-asian",
    "font-variant-ligatures",
    "font-variant-numeric",
    "font-weight",
    "letter-spacing",
    "line-height",
    "margin",
    "margin-top",
    "margin-right",
    "margin-bottom",
    "margin-left",
    "opacity",
    "outline",
    "padding",
    "padding-top",
    "padding-right",
    "padding-bottom",
    "padding-left",
    "text-align",
    "text-shadow",
    "transition",
  ],
  allowedFields: {
    cardholderName: {
      name: "cardholder-name",
      label: "Cardholder Name",
    },
    number: {
      name: "credit-card-number",
      label: "Credit Card Number",
    },
    cvv: {
      name: "cvv",
      label: "CVV",
    },
    expirationDate: {
      name: "expiration",
      label: "Expiration Date",
    },
    expirationMonth: {
      name: "expiration-month",
      label: "Expiration Month",
    },
    expirationYear: {
      name: "expiration-year",
      label: "Expiration Year",
    },
    postalCode: {
      name: "postal-code",
      label: "Postal Code",
    },
  },
  allowedAttributes: {
    "aria-invalid": "boolean",
    "aria-required": "boolean",
    disabled: "boolean",
    placeholder: "string",
  },
  autocompleteMappings: {
    "cardholder-name": "cc-name",
    "credit-card-number": "cc-number",
    expiration: "cc-exp",
    "expiration-month": "cc-exp-month",
    "expiration-year": "cc-exp-year",
    cvv: "cc-csc",
    "postal-code": "billing postal-code",
  },
};

constants.events = enumerate(
  [
    "ADD_CLASS",
    "AUTOFILL_DATA_AVAILABLE",
    "BIN_AVAILABLE",
    "CARD_FORM_ENTRY_HAS_BEGUN",
    "CLEAR_FIELD",
    "CONFIGURATION",
    "FRAME_READY",
    "INPUT_EVENT",
    "READY_FOR_CLIENT",
    "REMOVE_ATTRIBUTE",
    "REMOVE_CLASS",
    "REMOVE_FOCUS_INTERCEPTS",
    "SET_ATTRIBUTE",
    "SET_MESSAGE",
    "SET_MONTH_OPTIONS",
    "TOKENIZATION_REQUEST",
    "TRIGGER_FOCUS_CHANGE",
    "TRIGGER_INPUT_FOCUS",
    "VALIDATE_STRICT",
  ],
  "hosted-fields:"
);

module.exports = constants;

},{"../../lib/enumerate":134,"./errors":113}],113:[function(_dereq_,module,exports){
"use strict";

/**
 * @name BraintreeError.Hosted Fields - Creation Error Codes
 * @description Errors that occur when [creating the Hosted Fields component](./module-braintree-web_hosted-fields.html#.create).
 * @property {UNKNOWN} HOSTED_FIELDS_TIMEOUT Occurs when Hosted Fields does not finish setting up within 60 seconds.
 * @property {MERCHANT} HOSTED_FIELDS_INVALID_FIELD_KEY Occurs when Hosted Fields is instantiated with an invalid Field option.
 * @property {MERCHANT} HOSTED_FIELDS_INVALID_FIELD_SELECTOR Occurs when Hosted Fields given a field selector that is not valid.
 * @property {MERCHANT} HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME Occurs when Hosted Fields given a field selector that already contains an iframe.
 * @property {MERCHANT} HOSTED_FIELDS_FIELD_PROPERTY_INVALID Occurs when a field configuration option is not valid.
 */

/**
 * @name BraintreeError.Hosted Fields - Field Manipulation Error Codes
 * @description Errors that occur when modifying fields through [`addClass`](./HostedFields.html#addClass), [`removeClass`](./HostedFields.html#removeClass), [`setAttribute`](./HostedFields.html#setAttribute), [`removeAttribute`](./HostedFields.html#removeAttribute), [`clear`](./HostedFields.html#clear), [`focus`](./HostedFields.html#focus), and [`setMonthOptions`](./HostedFields.html#setMonthOptions).
 * @property {MERCHANT} HOSTED_FIELDS_FIELD_INVALID Occurs when attempting to modify a field that is not a valid Hosted Fields option.
 * @property {MERCHANT} HOSTED_FIELDS_FIELD_NOT_PRESENT Occurs when attempting to modify a field that is not configured with Hosted Fields.
 * @property {MERCHANT} HOSTED_FIELDS_FIELD_PROPERTY_INVALID Occurs when a field configuration option is not valid.
 */

/**
 * @name BraintreeError.Hosted Fields - Set Attribute Error Codes
 * @description Errors that occur when using the [`setAttribute` method](./HostedFields.html#setAttribute)
 * @property {MERCHANT} HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED Occurs when trying to set an attribute that is not supported to be set.
 * @property {MERCHANT} HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED Occurs when the type of value for an attribute is not allowed to be set.
 */

/**
 * @name BraintreeError.Hosted Fields - Tokenize Error Codes
 * @description Errors that occur when [tokenizing the card details with Hosted Fields](./HostedFields.html#tokenize).
 * @property {NETWORK} HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR Occurs when the Braintree gateway cannot be contacted.
 * @property {CUSTOMER} HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE Occurs when attempting to vault a card, but the client token being used is configured to fail if the card already exists in the vault.
 * @property {CUSTOMER} HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED Occurs when cvv verification is turned on in the Braintree control panel.
 * @property {CUSTOMER} HOSTED_FIELDS_FAILED_TOKENIZATION Occurs when the credit card details were sent to Braintree, but failed to tokenize.
 * @property {CUSTOMER} HOSTED_FIELDS_FIELDS_EMPTY Occurs when all the Hosted Fields inputs are empty.
 * @property {CUSTOMER} HOSTED_FIELDS_FIELDS_INVALID Occurs when one ore more fields are invalid.
 */

var BraintreeError = _dereq_("../../lib/braintree-error");

module.exports = {
  HOSTED_FIELDS_TIMEOUT: {
    type: BraintreeError.types.UNKNOWN,
    code: "HOSTED_FIELDS_TIMEOUT",
    message: "Hosted Fields timed out when attempting to set up.",
  },
  HOSTED_FIELDS_INVALID_FIELD_KEY: {
    type: BraintreeError.types.MERCHANT,
    code: "HOSTED_FIELDS_INVALID_FIELD_KEY",
  },
  HOSTED_FIELDS_INVALID_FIELD_SELECTOR: {
    type: BraintreeError.types.MERCHANT,
    code: "HOSTED_FIELDS_INVALID_FIELD_SELECTOR",
    message: "Selector does not reference a valid DOM node.",
  },
  HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME: {
    type: BraintreeError.types.MERCHANT,
    code: "HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME",
    message: "Element already contains a Braintree iframe.",
  },
  HOSTED_FIELDS_FIELD_INVALID: {
    type: BraintreeError.types.MERCHANT,
    code: "HOSTED_FIELDS_FIELD_INVALID",
  },
  HOSTED_FIELDS_FIELD_NOT_PRESENT: {
    type: BraintreeError.types.MERCHANT,
    code: "HOSTED_FIELDS_FIELD_NOT_PRESENT",
  },
  HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR: {
    type: BraintreeError.types.NETWORK,
    code: "HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR",
    message: "A tokenization network error occurred.",
  },
  HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE: {
    type: BraintreeError.types.CUSTOMER,
    code: "HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE",
    message: "This credit card already exists in the merchant's vault.",
  },
  HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED: {
    type: BraintreeError.types.CUSTOMER,
    code: "HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED",
    message: "CVV verification failed during tokenization.",
  },
  HOSTED_FIELDS_FAILED_TOKENIZATION: {
    type: BraintreeError.types.CUSTOMER,
    code: "HOSTED_FIELDS_FAILED_TOKENIZATION",
    message: "The supplied card data failed tokenization.",
  },
  HOSTED_FIELDS_FIELDS_EMPTY: {
    type: BraintreeError.types.CUSTOMER,
    code: "HOSTED_FIELDS_FIELDS_EMPTY",
    message: "All fields are empty. Cannot tokenize empty card fields.",
  },
  HOSTED_FIELDS_FIELDS_INVALID: {
    type: BraintreeError.types.CUSTOMER,
    code: "HOSTED_FIELDS_FIELDS_INVALID",
    message:
      "Some payment input fields are invalid. Cannot tokenize invalid card fields.",
  },
  HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED: {
    type: BraintreeError.types.MERCHANT,
    code: "HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED",
  },
  HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED: {
    type: BraintreeError.types.MERCHANT,
    code: "HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED",
  },
  HOSTED_FIELDS_FIELD_PROPERTY_INVALID: {
    type: BraintreeError.types.MERCHANT,
    code: "HOSTED_FIELDS_FIELD_PROPERTY_INVALID",
  },
};

},{"../../lib/braintree-error":124}],114:[function(_dereq_,module,exports){
"use strict";

function findParentTags(element, tag) {
  var parent = element.parentNode;
  var parents = [];

  while (parent != null) {
    if (parent.tagName != null && parent.tagName.toLowerCase() === tag) {
      parents.push(parent);
    }

    parent = parent.parentNode;
  }

  return parents;
}

module.exports = findParentTags;

},{}],115:[function(_dereq_,module,exports){
"use strict";

var browserDetection = _dereq_("./browser-detection");
var constants = _dereq_("./constants");
var allowedFields = Object.keys(constants.allowedFields);
var directions = constants.navigationDirections;

var focusIntercept = {
  generate: function (hostedFieldsId, type, direction, handler) {
    var input = document.createElement("input");
    var focusInterceptStyles = {
      border: "none !important",
      display: "block !important",
      height: "1px !important",
      left: "-1px !important",
      opacity: "0 !important",
      position: "absolute !important",
      top: "-1px !important",
      width: "1px !important",
    };
    var shouldCreateFocusIntercept =
      browserDetection.hasSoftwareKeyboard() || browserDetection.isFirefox();

    if (!shouldCreateFocusIntercept) {
      return document.createDocumentFragment();
    }

    input.setAttribute("aria-hidden", "true");
    input.setAttribute("autocomplete", "off");
    input.setAttribute("data-braintree-direction", direction);
    input.setAttribute("data-braintree-type", type);
    input.setAttribute(
      "id",
      "bt-" + type + "-" + direction + "-" + hostedFieldsId
    );
    input.setAttribute(
      "style",
      JSON.stringify(focusInterceptStyles)
        .replace(/[{}"]/g, "")
        .replace(/,/g, ";")
    );

    input.classList.add("focus-intercept");

    input.addEventListener("focus", function (event) {
      handler(event);

      /*
        Certain browsers without software keyboards (Firefox, Internet
        Explorer) need the focus intercept inputs that get inserted
        around the actual input to blur themselves, otherwise the
        browser gets confused about what should have focus. Can't
        apply this to browsers with software keyboards however,
        because it blurs everything, and focus on the actual input is
        also lost.
      */
      if (!browserDetection.hasSoftwareKeyboard()) {
        input.blur();
      }
    });

    return input;
  },
  destroy: function (idString) {
    var focusInputs;

    if (!idString) {
      focusInputs = document.querySelectorAll("[data-braintree-direction]");
      focusInputs = [].slice.call(focusInputs);
    } else {
      focusInputs = [document.getElementById(idString)];
    }

    focusInputs.forEach(function (node) {
      if (
        node &&
        node.nodeType === 1 &&
        focusIntercept.matchFocusElement(node.getAttribute("id"))
      ) {
        node.parentNode.removeChild(node);
      }
    });
  },
  matchFocusElement: function (idString) {
    var idComponents, hasBTPrefix, isAllowedType, isValidDirection;

    if (!idString) {
      return false;
    }

    idComponents = idString.split("-");

    if (idComponents.length < 4) {
      return false;
    }

    hasBTPrefix = idComponents[0] === "bt";
    isAllowedType = allowedFields.indexOf(idComponents[1]) > -1;
    isValidDirection =
      idComponents[2] === directions.BACK ||
      idComponents[2] === directions.FORWARD;

    return Boolean(hasBTPrefix && isAllowedType && isValidDirection);
  },
};

module.exports = focusIntercept;

},{"./browser-detection":111,"./constants":112}],116:[function(_dereq_,module,exports){
"use strict";

var creditCardType = _dereq_("credit-card-type");

module.exports = function (number) {
  var results = creditCardType(number);

  results.forEach(function (card) {
    // NEXT_MAJOR_VERSION credit-card-type fixed the mastercard enum
    // but we still pass master-card in the braintree API
    // in a major version bump, we can remove this and
    // this will be mastercard instead of master-card
    if (card.type === "mastercard") {
      card.type = "master-card";
    }
  });

  return results;
};

},{"credit-card-type":44}],117:[function(_dereq_,module,exports){
"use strict";
/**
 * @module braintree-web
 * @description This is the top-level module exported by the Braintree JavaScript SDK. In a browser environment, this will be the global <code>braintree</code> object. In a CommonJS environment (like Browserify or Webpack), it will be the default export of the <code>braintree-web</code> package. In AMD environments (like RequireJS), it can be `require`d like other modules.
 * @example
 * <caption>CommonJS</caption>
 * var braintree = require('braintree-web');
 *
 * braintree.client.create(...);
 * @example
 * <caption>In the browser</caption>
 * <script src="https://js.braintreegateway.com/web/{@pkg version}/js/client.min.js"></script>
 * <script>
 *   window.braintree.client.create(...);
 * </script>
 * @example
 * <caption>AMD</caption>
 * // main.js
 * require.config({
 *   paths: {
 *     braintreeClient: 'https://js.braintreegateway.com/web/{@pkg version}/js/client.min'
 *   }
 * });
 *
 * require(['braintreeClient'], function (braintreeClient) {
 *   braintreeClient.create(...);
 * });
 */

/**
 * @global
 * @callback callback
 * @param {?BraintreeError} [err] `null` or `undefined` if there was no error.
 * @param {?any} [data] The successful result of the asynchronous function call (if data exists).
 * @description The Node.js-style callback pattern used throughout the SDK.
 * @returns {void}
 */

var americanExpress = _dereq_("./american-express");
var applePay = _dereq_("./apple-pay");
var client = _dereq_("./client");
var dataCollector = _dereq_("./data-collector");
var hostedFields = _dereq_("./hosted-fields");
var localPayment = _dereq_("./local-payment");
var masterpass = _dereq_("./masterpass");
var paymentRequest = _dereq_("./payment-request");
var paypal = _dereq_("./paypal");
var paypalCheckout = _dereq_("./paypal-checkout");
var googlePayment = _dereq_("./google-payment");
var sepa = _dereq_("./sepa");
var threeDSecure = _dereq_("./three-d-secure");
var unionpay = _dereq_("./unionpay");
var usBankAccount = _dereq_("./us-bank-account");
var vaultManager = _dereq_("./vault-manager");
var venmo = _dereq_("./venmo");
var visaCheckout = _dereq_("./visa-checkout");
var preferredPaymentMethods = _dereq_("./preferred-payment-methods");
var VERSION = "3.101.3";

module.exports = {
  /** @type {module:braintree-web/american-express} */
  americanExpress: americanExpress,
  /** @type {module:braintree-web/apple-pay} */
  applePay: applePay,
  /** @type {module:braintree-web/client} */
  client: client,
  /** @type {module:braintree-web/data-collector} */
  dataCollector: dataCollector,
  /** @type {module:braintree-web/hosted-fields} */
  hostedFields: hostedFields,
  /** @type {module:braintree-web/local-payment} */
  localPayment: localPayment,
  /** @type {module:braintree-web/masterpass} */
  masterpass: masterpass,
  /** @type {module:braintree-web/google-payment} */
  googlePayment: googlePayment,
  /** @type {module:braintree-web/payment-request} */
  paymentRequest: paymentRequest,
  /** @type {module:braintree-web/paypal} */
  paypal: paypal,
  /** @type {module:braintree-web/paypal-checkout} */
  paypalCheckout: paypalCheckout,
  /** @type {module:braintree-web/three-d-secure} */
  threeDSecure: threeDSecure,
  /** @type {module:braintree-web/unionpay} */
  unionpay: unionpay,
  /** @type {module:braintree-web/us-bank-account} */
  usBankAccount: usBankAccount,
  /** @type {module:braintree-web/vault-manager} */
  vaultManager: vaultManager,
  /** @type {module:braintree-web/venmo} */
  venmo: venmo,
  /** @type {module:braintree-web/visa-checkout} */
  visaCheckout: visaCheckout,
  /** @type {module:braintree-web/sepa} */
  sepa: sepa,
  /** @type {module:braintree-web/preferred-payment-methods} */
  preferredPaymentMethods: preferredPaymentMethods,
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION,
};

},{"./american-express":74,"./apple-pay":77,"./client":82,"./data-collector":98,"./google-payment":103,"./hosted-fields":110,"./local-payment":164,"./masterpass":167,"./payment-request":172,"./paypal":179,"./paypal-checkout":176,"./preferred-payment-methods":182,"./sepa":186,"./three-d-secure":198,"./unionpay":202,"./us-bank-account":208,"./vault-manager":211,"./venmo":216,"./visa-checkout":226}],118:[function(_dereq_,module,exports){
"use strict";

var createAuthorizationData = _dereq_("./create-authorization-data");
var jsonClone = _dereq_("./json-clone");
var constants = _dereq_("./constants");

function addMetadata(configuration, data) {
  var key;
  var attrs = data ? jsonClone(data) : {};
  var authAttrs = createAuthorizationData(configuration.authorization).attrs;
  var _meta = jsonClone(configuration.analyticsMetadata);

  attrs.braintreeLibraryVersion = constants.BRAINTREE_LIBRARY_VERSION;

  for (key in attrs._meta) {
    if (attrs._meta.hasOwnProperty(key)) {
      _meta[key] = attrs._meta[key];
    }
  }

  attrs._meta = _meta;

  if (authAttrs.tokenizationKey) {
    attrs.tokenizationKey = authAttrs.tokenizationKey;
  } else {
    attrs.authorizationFingerprint = authAttrs.authorizationFingerprint;
  }

  return attrs;
}

module.exports = addMetadata;

},{"./constants":126,"./create-authorization-data":130,"./json-clone":154}],119:[function(_dereq_,module,exports){
"use strict";

var constants = _dereq_("./constants");
var addMetadata = _dereq_("./add-metadata");

function sendAnalyticsEvent(clientInstanceOrPromise, kind, callback) {
  var timestamp = Date.now(); // milliseconds

  return Promise.resolve(clientInstanceOrPromise)
    .then(function (client) {
      var timestampInPromise = Date.now();
      var configuration = client.getConfiguration();
      var request = client._request;
      var url = configuration.gatewayConfiguration.analytics.url;
      var data = {
        analytics: [
          {
            kind: constants.ANALYTICS_PREFIX + kind,
            isAsync:
              Math.floor(timestampInPromise / 1000) !==
              Math.floor(timestamp / 1000),
            timestamp: timestamp,
          },
        ],
      };

      request(
        {
          url: url,
          method: "post",
          data: addMetadata(configuration, data),
          timeout: constants.ANALYTICS_REQUEST_TIMEOUT_MS,
        },
        callback
      );
    })
    .catch(function (err) {
      // for all non-test cases, we don't provide a callback,
      // so this error will always be swallowed. In this case,
      // that's fine, it should only error when the deferred
      // client fails to set up, in which case we don't want
      // that error to report over and over again via these
      // deferred analytics events
      if (callback) {
        callback(err);
      }
    });
}

module.exports = {
  sendEvent: sendAnalyticsEvent,
};

},{"./add-metadata":118,"./constants":126}],120:[function(_dereq_,module,exports){
"use strict";

var loadScript = _dereq_("@braintree/asset-loader/load-script");

module.exports = {
  loadScript: loadScript,
};

},{"@braintree/asset-loader/load-script":3}],121:[function(_dereq_,module,exports){
"use strict";

var assignNormalized =
  typeof Object.assign === "function" ? Object.assign : assignPolyfill;

function assignPolyfill(destination) {
  var i, source, key;

  for (i = 1; i < arguments.length; i++) {
    source = arguments[i];
    for (key in source) {
      if (source.hasOwnProperty(key)) {
        destination[key] = source[key];
      }
    }
  }

  return destination;
}

module.exports = {
  assign: assignNormalized,
  _assign: assignPolyfill,
};

},{}],122:[function(_dereq_,module,exports){
"use strict";

var BraintreeError = _dereq_("./braintree-error");
var sharedErrors = _dereq_("./errors");
var VERSION = "3.101.3";

function basicComponentVerification(options) {
  var client, authorization, name;

  if (!options) {
    return Promise.reject(
      new BraintreeError({
        type: sharedErrors.INVALID_USE_OF_INTERNAL_FUNCTION.type,
        code: sharedErrors.INVALID_USE_OF_INTERNAL_FUNCTION.code,
        message:
          "Options must be passed to basicComponentVerification function.",
      })
    );
  }

  name = options.name;
  client = options.client;
  authorization = options.authorization;

  if (!client && !authorization) {
    return Promise.reject(
      new BraintreeError({
        type: sharedErrors.INSTANTIATION_OPTION_REQUIRED.type,
        code: sharedErrors.INSTANTIATION_OPTION_REQUIRED.code,
        // NEXT_MAJOR_VERSION in major version, we expose passing in authorization for all components
        // instead of passing in a client instance. Leave this a silent feature for now.
        message: "options.client is required when instantiating " + name + ".",
      })
    );
  }

  if (!authorization && client.getVersion() !== VERSION) {
    return Promise.reject(
      new BraintreeError({
        type: sharedErrors.INCOMPATIBLE_VERSIONS.type,
        code: sharedErrors.INCOMPATIBLE_VERSIONS.code,
        message:
          "Client (version " +
          client.getVersion() +
          ") and " +
          name +
          " (version " +
          VERSION +
          ") components must be from the same SDK version.",
      })
    );
  }

  return Promise.resolve();
}

module.exports = {
  verify: basicComponentVerification,
};

},{"./braintree-error":124,"./errors":135}],123:[function(_dereq_,module,exports){
"use strict";

var once = _dereq_("./once");

function call(fn, callback) {
  var isSync = fn.length === 0;

  if (isSync) {
    fn();
    callback(null);
  } else {
    fn(callback);
  }
}

module.exports = function (functions, cb) {
  var i;
  var length = functions.length;
  var remaining = length;
  var callback = once(cb);

  if (length === 0) {
    callback(null);

    return;
  }

  function finish(err) {
    if (err) {
      callback(err);

      return;
    }

    remaining -= 1;
    if (remaining === 0) {
      callback(null);
    }
  }

  for (i = 0; i < length; i++) {
    call(functions[i], finish);
  }
};

},{"./once":156}],124:[function(_dereq_,module,exports){
"use strict";

var enumerate = _dereq_("./enumerate");

/**
 * @class
 * @global
 * @param {object} options Construction options
 * @classdesc This class is used to report error conditions, frequently as the first parameter to callbacks throughout the Braintree SDK.
 * @description <strong>You cannot use this constructor directly. Interact with instances of this class through {@link callback callbacks}.</strong>
 */
function BraintreeError(options) {
  if (!BraintreeError.types.hasOwnProperty(options.type)) {
    throw new Error(options.type + " is not a valid type.");
  }

  if (!options.code) {
    throw new Error("Error code required.");
  }

  if (!options.message) {
    throw new Error("Error message required.");
  }

  this.name = "BraintreeError";

  /**
   * @type {string}
   * @description A code that corresponds to specific errors.
   */
  this.code = options.code;

  /**
   * @type {string}
   * @description A short description of the error.
   */
  this.message = options.message;

  /**
   * @type {BraintreeError.types}
   * @description The type of error.
   */
  this.type = options.type;

  /**
   * @type {object=}
   * @description Additional information about the error, such as an underlying network error response.
   */
  this.details = options.details;
}

BraintreeError.prototype = Object.create(Error.prototype);
BraintreeError.prototype.constructor = BraintreeError;

/**
 * Enum for {@link BraintreeError} types.
 * @name BraintreeError.types
 * @enum
 * @readonly
 * @memberof BraintreeError
 * @property {string} CUSTOMER An error caused by the customer.
 * @property {string} MERCHANT An error that is actionable by the merchant.
 * @property {string} NETWORK An error due to a network problem.
 * @property {string} INTERNAL An error caused by Braintree code.
 * @property {string} UNKNOWN An error where the origin is unknown.
 */
BraintreeError.types = enumerate([
  "CUSTOMER",
  "MERCHANT",
  "NETWORK",
  "INTERNAL",
  "UNKNOWN",
]);

BraintreeError.findRootError = function (err) {
  if (
    err instanceof BraintreeError &&
    err.details &&
    err.details.originalError
  ) {
    return BraintreeError.findRootError(err.details.originalError);
  }

  return err;
};

module.exports = BraintreeError;

},{"./enumerate":134}],125:[function(_dereq_,module,exports){
"use strict";

// Taken from https://github.com/sindresorhus/decamelize/blob/95980ab6fb44c40eaca7792bdf93aff7c210c805/index.js
function transformKey(key) {
  return key
    .replace(/([a-z\d])([A-Z])/g, "$1_$2")
    .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, "$1_$2")
    .toLowerCase();
}

module.exports = function (obj) {
  return Object.keys(obj).reduce(function (newObj, key) {
    var transformedKey = transformKey(key);

    newObj[transformedKey] = obj[key];

    return newObj;
  }, {});
};

},{}],126:[function(_dereq_,module,exports){
"use strict";

var VERSION = "3.101.3";
var PLATFORM = "web";

var CLIENT_API_URLS = {
  production: "https://api.braintreegateway.com:443",
  sandbox: "https://api.sandbox.braintreegateway.com:443",
};

var ASSETS_URLS = {
  production: "https://assets.braintreegateway.com",
  sandbox: "https://assets.braintreegateway.com",
};

var GRAPHQL_URLS = {
  production: "https://payments.braintree-api.com/graphql",
  sandbox: "https://payments.sandbox.braintree-api.com/graphql",
};

// endRemoveIf(production)

module.exports = {
  ANALYTICS_PREFIX: PLATFORM + ".",
  ANALYTICS_REQUEST_TIMEOUT_MS: 2000,
  ASSETS_URLS: ASSETS_URLS,
  CLIENT_API_URLS: CLIENT_API_URLS,
  FRAUDNET_SOURCE: "BRAINTREE_SIGNIN",
  FRAUDNET_FNCLS: "fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99",
  FRAUDNET_URL: "https://c.paypal.com/da/r/fb.js",
  BUS_CONFIGURATION_REQUEST_EVENT: "BUS_CONFIGURATION_REQUEST",
  GRAPHQL_URLS: GRAPHQL_URLS,
  INTEGRATION_TIMEOUT_MS: 60000,
  VERSION: VERSION,
  INTEGRATION: "custom",
  SOURCE: "client",
  PLATFORM: PLATFORM,
  BRAINTREE_LIBRARY_VERSION: "braintree/" + PLATFORM + "/" + VERSION,
};

},{}],127:[function(_dereq_,module,exports){
"use strict";

var BraintreeError = _dereq_("./braintree-error");
var sharedErrors = _dereq_("./errors");

module.exports = function (instance, methodNames) {
  methodNames.forEach(function (methodName) {
    instance[methodName] = function () {
      throw new BraintreeError({
        type: sharedErrors.METHOD_CALLED_AFTER_TEARDOWN.type,
        code: sharedErrors.METHOD_CALLED_AFTER_TEARDOWN.code,
        message: methodName + " cannot be called after teardown.",
      });
    };
  });
};

},{"./braintree-error":124,"./errors":135}],128:[function(_dereq_,module,exports){
"use strict";

var BraintreeError = _dereq_("./braintree-error");

function convertToBraintreeError(originalErr, btErrorObject) {
  if (originalErr instanceof BraintreeError) {
    return originalErr;
  }

  return new BraintreeError({
    type: btErrorObject.type,
    code: btErrorObject.code,
    message: btErrorObject.message,
    details: {
      originalError: originalErr,
    },
  });
}

module.exports = convertToBraintreeError;

},{"./braintree-error":124}],129:[function(_dereq_,module,exports){
"use strict";

// endRemoveIf(production)
var ASSETS_URLS = _dereq_("./constants").ASSETS_URLS;

function createAssetsUrl(authorization) {
  // endRemoveIf(production)

  return ASSETS_URLS.production;
}
/* eslint-enable */

module.exports = {
  create: createAssetsUrl,
};

},{"./constants":126}],130:[function(_dereq_,module,exports){
"use strict";

var atob = _dereq_("../lib/vendor/polyfill").atob;
var CLIENT_API_URLS = _dereq_("../lib/constants").CLIENT_API_URLS;

function _isTokenizationKey(str) {
  return /^[a-zA-Z0-9]+_[a-zA-Z0-9]+_[a-zA-Z0-9_]+$/.test(str);
}

function _parseTokenizationKey(tokenizationKey) {
  var tokens = tokenizationKey.split("_");
  var environment = tokens[0];
  var merchantId = tokens.slice(2).join("_");

  return {
    merchantId: merchantId,
    environment: environment,
  };
}

function createAuthorizationData(authorization) {
  var parsedClientToken, parsedTokenizationKey;
  var data = {
    attrs: {},
    configUrl: "",
  };

  if (_isTokenizationKey(authorization)) {
    parsedTokenizationKey = _parseTokenizationKey(authorization);
    data.environment = parsedTokenizationKey.environment;
    data.attrs.tokenizationKey = authorization;
    data.configUrl =
      CLIENT_API_URLS[parsedTokenizationKey.environment] +
      "/merchants/" +
      parsedTokenizationKey.merchantId +
      "/client_api/v1/configuration";
  } else {
    parsedClientToken = JSON.parse(atob(authorization));
    data.environment = parsedClientToken.environment;
    data.attrs.authorizationFingerprint =
      parsedClientToken.authorizationFingerprint;
    data.configUrl = parsedClientToken.configUrl;
    data.graphQL = parsedClientToken.graphQL;
  }

  return data;
}

module.exports = createAuthorizationData;

},{"../lib/constants":126,"../lib/vendor/polyfill":161}],131:[function(_dereq_,module,exports){
"use strict";

var BraintreeError = _dereq_("./braintree-error");
var assets = _dereq_("./assets");
var sharedErrors = _dereq_("./errors");

var VERSION = "3.101.3";

function createDeferredClient(options) {
  var promise = Promise.resolve();

  if (options.client) {
    return Promise.resolve(options.client);
  }

  if (!(window.braintree && window.braintree.client)) {
    promise = assets
      .loadScript({
        src: options.assetsUrl + "/web/" + VERSION + "/js/client.min.js",
      })
      .catch(function (err) {
        return Promise.reject(
          new BraintreeError({
            type: sharedErrors.CLIENT_SCRIPT_FAILED_TO_LOAD.type,
            code: sharedErrors.CLIENT_SCRIPT_FAILED_TO_LOAD.code,
            message: sharedErrors.CLIENT_SCRIPT_FAILED_TO_LOAD.message,
            details: {
              originalError: err,
            },
          })
        );
      });
  }

  return promise.then(function () {
    if (window.braintree.client.VERSION !== VERSION) {
      return Promise.reject(
        new BraintreeError({
          type: sharedErrors.INCOMPATIBLE_VERSIONS.type,
          code: sharedErrors.INCOMPATIBLE_VERSIONS.code,
          message:
            "Client (version " +
            window.braintree.client.VERSION +
            ") and " +
            options.name +
            " (version " +
            VERSION +
            ") components must be from the same SDK version.",
        })
      );
    }

    return window.braintree.client.create({
      authorization: options.authorization,
      debug: options.debug,
    });
  });
}

module.exports = {
  create: createDeferredClient,
};

},{"./assets":120,"./braintree-error":124,"./errors":135}],132:[function(_dereq_,module,exports){
"use strict";

module.exports = function (fn) {
  return function () {
    // IE9 doesn't support passing arguments to setTimeout so we have to emulate it.
    var args = arguments;

    setTimeout(function () {
      fn.apply(null, args);
    }, 1);
  };
};

},{}],133:[function(_dereq_,module,exports){
"use strict";

var batchExecuteFunctions = _dereq_("./batch-execute-functions");

function Destructor() {
  this._teardownRegistry = [];

  this._isTearingDown = false;
}

Destructor.prototype.registerFunctionForTeardown = function (fn) {
  if (typeof fn === "function") {
    this._teardownRegistry.push(fn);
  }
};

Destructor.prototype.teardown = function (callback) {
  if (this._isTearingDown) {
    callback(new Error("Destructor is already tearing down"));

    return;
  }

  this._isTearingDown = true;

  batchExecuteFunctions(
    this._teardownRegistry,
    function (err) {
      this._teardownRegistry = [];
      this._isTearingDown = false;

      if (typeof callback === "function") {
        callback(err);
      }
    }.bind(this)
  );
};

module.exports = Destructor;

},{"./batch-execute-functions":123}],134:[function(_dereq_,module,exports){
"use strict";

function enumerate(values, prefix) {
  prefix = prefix == null ? "" : prefix;

  return values.reduce(function (enumeration, value) {
    enumeration[value] = prefix + value;

    return enumeration;
  }, {});
}

module.exports = enumerate;

},{}],135:[function(_dereq_,module,exports){
"use strict";

/**
 * @name BraintreeError.Shared Internal Error Codes
 * @ignore
 * @description These codes should never be experienced by the merchant directly.
 * @property {INTERNAL} INVALID_USE_OF_INTERNAL_FUNCTION Occurs when the client is created without a gateway configuration. Should never happen.
 */

/**
 * @name BraintreeError.Shared Errors - Component Creation Error Codes
 * @description Errors that occur when creating components.
 * @property {MERCHANT} INSTANTIATION_OPTION_REQUIRED Occurs when a component is created that is missing a required option.
 * @property {MERCHANT} INCOMPATIBLE_VERSIONS Occurs when a component is created with a client with a different version than the component.
 * @property {NETWORK} CLIENT_SCRIPT_FAILED_TO_LOAD Occurs when a component attempts to load the Braintree client script, but the request fails.
 */

/**
 * @name BraintreeError.Shared Errors - Component Instance Error Codes
 * @description Errors that occur when using instances of components.
 * @property {MERCHANT} METHOD_CALLED_AFTER_TEARDOWN Occurs when a method is called on a component instance after it has been torn down.
 */

var BraintreeError = _dereq_("./braintree-error");

module.exports = {
  INVALID_USE_OF_INTERNAL_FUNCTION: {
    type: BraintreeError.types.INTERNAL,
    code: "INVALID_USE_OF_INTERNAL_FUNCTION",
  },
  INSTANTIATION_OPTION_REQUIRED: {
    type: BraintreeError.types.MERCHANT,
    code: "INSTANTIATION_OPTION_REQUIRED",
  },
  INCOMPATIBLE_VERSIONS: {
    type: BraintreeError.types.MERCHANT,
    code: "INCOMPATIBLE_VERSIONS",
  },
  CLIENT_SCRIPT_FAILED_TO_LOAD: {
    type: BraintreeError.types.NETWORK,
    code: "CLIENT_SCRIPT_FAILED_TO_LOAD",
    message: "Braintree client script could not be loaded.",
  },
  METHOD_CALLED_AFTER_TEARDOWN: {
    type: BraintreeError.types.MERCHANT,
    code: "METHOD_CALLED_AFTER_TEARDOWN",
  },
};

},{"./braintree-error":124}],136:[function(_dereq_,module,exports){
"use strict";

module.exports = function findRootNode(element) {
  while (element.parentNode) {
    element = element.parentNode;
  }

  return element;
};

},{}],137:[function(_dereq_,module,exports){
"use strict";

module.exports = function (array, key, value) {
  var i;

  for (i = 0; i < array.length; i++) {
    if (array[i].hasOwnProperty(key) && array[i][key] === value) {
      return array[i];
    }
  }

  return null;
};

},{}],138:[function(_dereq_,module,exports){
"use strict";

var Popup = _dereq_("./strategies/popup");
var PopupBridge = _dereq_("./strategies/popup-bridge");
var Modal = _dereq_("./strategies/modal");
var Bus = _dereq_("framebus");
var events = _dereq_("../shared/events");
var errors = _dereq_("../shared/errors");
var constants = _dereq_("../shared/constants");
var uuid = _dereq_("@braintree/uuid");
var iFramer = _dereq_("@braintree/iframer");
var BraintreeError = _dereq_("../../braintree-error");
var browserDetection = _dereq_("../shared/browser-detection");
var assign = _dereq_("./../../assign").assign;
var BUS_CONFIGURATION_REQUEST_EVENT =
  _dereq_("../../constants").BUS_CONFIGURATION_REQUEST_EVENT;

var REQUIRED_CONFIG_KEYS = ["name", "dispatchFrameUrl", "openFrameUrl"];

function noop() {}

function _validateFrameConfiguration(options) {
  if (!options) {
    throw new Error("Valid configuration is required");
  }

  REQUIRED_CONFIG_KEYS.forEach(function (key) {
    if (!options.hasOwnProperty(key)) {
      throw new Error("A valid frame " + key + " must be provided");
    }
  });

  if (!/^[\w_]+$/.test(options.name)) {
    throw new Error("A valid frame name must be provided");
  }
}

function FrameService(options) {
  _validateFrameConfiguration(options);

  this._serviceId = uuid().replace(/-/g, "");

  this._options = {
    name: options.name + "_" + this._serviceId,
    dispatchFrameUrl: options.dispatchFrameUrl,
    openFrameUrl: options.openFrameUrl,
    height: options.height,
    width: options.width,
    top: options.top,
    left: options.left,
  };
  this.state = options.state || {};

  this._bus = new Bus({ channel: this._serviceId });
  this._setBusEvents();
}

FrameService.prototype.initialize = function (callback) {
  var dispatchFrameReadyHandler = function () {
    callback();
    this._bus.off(events.DISPATCH_FRAME_READY, dispatchFrameReadyHandler);
  }.bind(this);

  this._bus.on(events.DISPATCH_FRAME_READY, dispatchFrameReadyHandler);
  this._writeDispatchFrame();
};

FrameService.prototype._writeDispatchFrame = function () {
  var frameName = constants.DISPATCH_FRAME_NAME + "_" + this._serviceId;
  var frameSrc = this._options.dispatchFrameUrl;

  this._dispatchFrame = iFramer({
    "aria-hidden": true,
    name: frameName,
    title: frameName,
    src: frameSrc,
    class: constants.DISPATCH_FRAME_CLASS,
    height: 0,
    width: 0,
    style: {
      position: "absolute",
      left: "-9999px",
    },
  });

  document.body.appendChild(this._dispatchFrame);
};

FrameService.prototype._setBusEvents = function () {
  this._bus.on(
    events.DISPATCH_FRAME_REPORT,
    function (res, reply) {
      if (this._onCompleteCallback) {
        this._onCompleteCallback.call(null, res.err, res.payload);
      }
      this._frame.close();

      this._onCompleteCallback = null;

      if (reply) {
        reply();
      }
    }.bind(this)
  );

  this._bus.on(
    BUS_CONFIGURATION_REQUEST_EVENT,
    function (reply) {
      reply(this.state);
    }.bind(this)
  );
};

FrameService.prototype.open = function (options, callback) {
  options = options || {};
  this._frame = this._getFrameForEnvironment(options);

  this._frame.initialize(callback);

  if (this._frame instanceof PopupBridge) {
    // Frameservice loads a spinner then redirects to the final destination url.
    // For Popupbridge it doesn't have the same rules around popups since it's deferred to the mobile side
    // therefore, skips the regular open path and instead uses `#redirect` to handle things
    return;
  }

  assign(this.state, options.state);

  this._onCompleteCallback = callback;
  this._frame.open();

  if (this.isFrameClosed()) {
    this._cleanupFrame();

    if (callback) {
      callback(new BraintreeError(errors.FRAME_SERVICE_FRAME_OPEN_FAILED));
    }

    return;
  }
  this._pollForPopupClose();
};

FrameService.prototype.redirect = function (url) {
  if (this._frame && !this.isFrameClosed()) {
    this._frame.redirect(url);
  }
};

FrameService.prototype.close = function () {
  if (!this.isFrameClosed()) {
    this._frame.close();
  }
};

FrameService.prototype.focus = function () {
  if (!this.isFrameClosed()) {
    this._frame.focus();
  }
};

FrameService.prototype.createHandler = function (options) {
  options = options || {};

  return {
    close: function () {
      if (options.beforeClose) {
        options.beforeClose();
      }

      this.close();
    }.bind(this),
    focus: function () {
      if (options.beforeFocus) {
        options.beforeFocus();
      }

      this.focus();
    }.bind(this),
  };
};

FrameService.prototype.createNoopHandler = function () {
  return {
    close: noop,
    focus: noop,
  };
};

FrameService.prototype.teardown = function () {
  this.close();
  this._dispatchFrame.parentNode.removeChild(this._dispatchFrame);
  this._dispatchFrame = null;
  this._cleanupFrame();
};

FrameService.prototype.isFrameClosed = function () {
  return this._frame == null || this._frame.isClosed();
};

FrameService.prototype._cleanupFrame = function () {
  this._frame = null;
  clearInterval(this._popupInterval);
  this._popupInterval = null;
};

FrameService.prototype._pollForPopupClose = function () {
  this._popupInterval = setInterval(
    function () {
      if (this.isFrameClosed()) {
        this._cleanupFrame();
        if (this._onCompleteCallback) {
          this._onCompleteCallback(
            new BraintreeError(errors.FRAME_SERVICE_FRAME_CLOSED)
          );
        }
      }
    }.bind(this),
    constants.POPUP_POLL_INTERVAL
  );

  return this._popupInterval;
};

FrameService.prototype._getFrameForEnvironment = function (options) {
  var usePopup = browserDetection.supportsPopups();
  var popupBridgeExists = Boolean(window.popupBridge);

  var initOptions = assign({}, this._options, options);

  if (popupBridgeExists) {
    return new PopupBridge(initOptions);
  } else if (usePopup) {
    return new Popup(initOptions);
  }

  return new Modal(initOptions);
};

module.exports = FrameService;

},{"../../braintree-error":124,"../../constants":126,"../shared/browser-detection":145,"../shared/constants":146,"../shared/errors":147,"../shared/events":148,"./../../assign":121,"./strategies/modal":140,"./strategies/popup":143,"./strategies/popup-bridge":141,"@braintree/iframer":35,"@braintree/uuid":39,"framebus":52}],139:[function(_dereq_,module,exports){
"use strict";

var FrameService = _dereq_("./frame-service");

/**
 * @ignore
 * @function create
 * Initializing FrameService should be done at the point when the component is created, so it is ready whenever a component needs to open a popup window.
 * Browsers have varying rules around what constitutes and async action worth blocking a popup for, but the likes of Safari
 * will block the popup if `frameService#create` is invoked during any asynchronous process (such as an API request to tokenize payment details).
 *
 * The process of setting up the dispatch frame and subsequent framebus communications via event listeners are considered async by Safari's standards.
 *
 * @param {object} options The options provided to frameservice
 * @param {string} options.name The name to use for identifying the various pieces associated with frameservice.
 * @param {string} options.dispatchFrameUrl The static asset to load for use as the dispatch frame. This allows for secure communication between the iframe and the popup, since they are on the same asset domain (usually checkout.paypal.com or assets.braintreegateway.com)
 * @param {string} options.openFrameUrl The url to load in the popup. Sometimes it is the case that you'll need info that comes _after_ the popup loads in which case we load the `landing-frame` that's a loading spinner then redirect to the proper/final destination. See the PayPal component for an example.
 * Otherwise if all the info needed is ready up-front, then you can forego a landing frame and go straight to the final destination.
 * @param {string} [options.height] The desired popup height.
 * @param {string} [options.width] The desired popup width.
 * @param {string} [options.top] The desired top value of the popup for positioning.
 * @param {string} [options.left] The desired left value of the popup for positioning.
 * @param {object} [options.state] Seems to be dead code, but allows for injecting data in to popup. NEXT_MAJOR_VERSION remove this param if no usage exists.
 * @param {function} callback The function to invoke once the frameservice is created and ready to use. FrameService instance is returned.
 */
module.exports = {
  create: function createFrameService(options, callback) {
    var frameService = new FrameService(options);

    frameService.initialize(function () {
      callback(frameService);
    });
  },
};

},{"./frame-service":138}],140:[function(_dereq_,module,exports){
"use strict";

var iFramer = _dereq_("@braintree/iframer");
var assign = _dereq_("../../../assign").assign;
var browserDetection = _dereq_("../../shared/browser-detection");

var ELEMENT_STYLES = {
  position: "fixed",
  top: 0,
  left: 0,
  bottom: 0,
  padding: 0,
  margin: 0,
  border: 0,
  outline: "none",
  zIndex: 20001,
  background: "#FFFFFF",
};

function noop() {}

/**
 *
 * We should not ever really use the Modal. Modals are _like_  popups, but the key difference is that the customer can't actually verify it's app domain and thus secure/valid. Old PP sdk (./src/paypal) uses this
 * to get info from webviews (e.g. facebook).
 */

function Modal(options) {
  this._closed = null;
  this._frame = null;
  this._options = options || {};
  this._container = this._options.container || document.body;
}

Modal.prototype.initialize = noop;

Modal.prototype.open = function () {
  var iframerConfig = {
    src: this._options.openFrameUrl,
    name: this._options.name,
    scrolling: "yes",
    height: "100%",
    width: "100%",
    style: assign({}, ELEMENT_STYLES),
    title: "Lightbox Frame",
  };

  if (browserDetection.isIos()) {
    // WKWebView has buggy behavior when scrolling a fixed position modal. The workaround is to lock scrolling in
    // the background. When modal is closed, we restore scrolling and return to the previous scroll position.
    if (browserDetection.isIosWKWebview()) {
      this._lockScrolling();
      // Allows WKWebView to scroll all the way down to bottom
      iframerConfig.style = {};
    }

    this._el = document.createElement("div");

    assign(this._el.style, ELEMENT_STYLES, {
      height: "100%",
      width: "100%",
      overflow: "auto",
      "-webkit-overflow-scrolling": "touch",
    });

    this._frame = iFramer(iframerConfig);
    this._el.appendChild(this._frame);
  } else {
    this._el = this._frame = iFramer(iframerConfig);
  }
  this._closed = false;

  this._container.appendChild(this._el);
};

Modal.prototype.focus = noop;

Modal.prototype.close = function () {
  this._container.removeChild(this._el);
  this._frame = null;
  this._closed = true;
  if (browserDetection.isIosWKWebview()) {
    this._unlockScrolling();
  }
};

Modal.prototype.isClosed = function () {
  return Boolean(this._closed);
};

Modal.prototype.redirect = function (redirectUrl) {
  this._frame.src = redirectUrl;
};

Modal.prototype._unlockScrolling = function () {
  document.body.style.overflow = this._savedBodyProperties.overflowStyle;
  document.body.style.position = this._savedBodyProperties.positionStyle;
  window.scrollTo(
    this._savedBodyProperties.left,
    this._savedBodyProperties.top
  );
  delete this._savedBodyProperties;
};

Modal.prototype._lockScrolling = function () {
  var doc = document.documentElement;

  // From https://stackoverflow.com/questions/9538868/prevent-body-from-scrolling-when-a-modal-is-opened#comment65626743_24727206
  this._savedBodyProperties = {
    left: (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0),
    top: (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0),
    overflowStyle: document.body.style.overflow,
    positionStyle: document.body.style.position,
  };
  document.body.style.overflow = "hidden";
  document.body.style.position = "fixed";
  window.scrollTo(0, 0);
};

module.exports = Modal;

},{"../../../assign":121,"../../shared/browser-detection":145,"@braintree/iframer":35}],141:[function(_dereq_,module,exports){
"use strict";

var BraintreeError = _dereq_("../../../braintree-error");
var errors = _dereq_("../../shared/errors");

function noop() {}

function PopupBridge(options) {
  this._closed = null;
  this._options = options;
}

PopupBridge.prototype.initialize = function (callback) {
  var self = this;

  window.popupBridge.onComplete = function (err, payload) {
    var popupDismissed = !payload && !err;

    self._closed = true;

    if (err || popupDismissed) {
      // User clicked "Done" button of browser view
      callback(new BraintreeError(errors.FRAME_SERVICE_FRAME_CLOSED));

      return;
    }
    // User completed popup flow (includes success and cancel cases)
    callback(null, payload);
  };
};

PopupBridge.prototype.open = function (options) {
  var url;

  options = options || {};
  url = options.openFrameUrl || this._options.openFrameUrl;

  this._closed = false;
  window.popupBridge.open(url);
};

PopupBridge.prototype.focus = noop;

PopupBridge.prototype.close = noop;

PopupBridge.prototype.isClosed = function () {
  return Boolean(this._closed);
};

PopupBridge.prototype.redirect = function (redirectUrl) {
  this.open({ openFrameUrl: redirectUrl });
};

module.exports = PopupBridge;

},{"../../../braintree-error":124,"../../shared/errors":147}],142:[function(_dereq_,module,exports){
"use strict";

var constants = _dereq_("../../../shared/constants");
var position = _dereq_("./position");

function calculatePosition(type, userDefinedPosition, size) {
  if (typeof userDefinedPosition !== "undefined") {
    return userDefinedPosition;
  }

  return position[type](size);
}

module.exports = function composePopupOptions(options) {
  var height = options.height || constants.DEFAULT_POPUP_HEIGHT;
  var width = options.width || constants.DEFAULT_POPUP_WIDTH;
  var top = calculatePosition("top", options.top, height);
  var left = calculatePosition("left", options.left, width);

  return [
    constants.POPUP_BASE_OPTIONS,
    "height=" + height,
    "width=" + width,
    "top=" + top,
    "left=" + left,
  ].join(",");
};

},{"../../../shared/constants":146,"./position":144}],143:[function(_dereq_,module,exports){
"use strict";

var composeOptions = _dereq_("./compose-options");

function noop() {}

function Popup(options) {
  this._frame = null;
  this._options = options || {};
}

Popup.prototype.initialize = noop;

Popup.prototype.open = function () {
  this._frame = window.open(
    this._options.openFrameUrl,
    this._options.name,
    composeOptions(this._options)
  );
};

Popup.prototype.focus = function () {
  this._frame.focus();
};

Popup.prototype.close = function () {
  if (this._frame.closed) {
    return;
  }
  this._frame.close();
};

Popup.prototype.isClosed = function () {
  return !this._frame || Boolean(this._frame.closed);
};

Popup.prototype.redirect = function (redirectUrl) {
  this._frame.location.href = redirectUrl;
};

module.exports = Popup;

},{"./compose-options":142}],144:[function(_dereq_,module,exports){
"use strict";

function top(height) {
  var windowHeight =
    window.outerHeight || document.documentElement.clientHeight;
  var windowTop = window.screenY == null ? window.screenTop : window.screenY;

  return center(windowHeight, height, windowTop);
}

function left(width) {
  var windowWidth = window.outerWidth || document.documentElement.clientWidth;
  var windowLeft = window.screenX == null ? window.screenLeft : window.screenX;

  return center(windowWidth, width, windowLeft);
}

function center(windowMetric, popupMetric, offset) {
  return (windowMetric - popupMetric) / 2 + offset;
}

module.exports = {
  top: top,
  left: left,
  center: center,
};

},{}],145:[function(_dereq_,module,exports){
"use strict";

module.exports = {
  isIos: _dereq_("@braintree/browser-detection/is-ios"),
  isIosWKWebview: _dereq_("@braintree/browser-detection/is-ios-wkwebview"),
  supportsPopups: _dereq_("@braintree/browser-detection/supports-popups"),
};

},{"@braintree/browser-detection/is-ios":30,"@braintree/browser-detection/is-ios-wkwebview":29,"@braintree/browser-detection/supports-popups":32}],146:[function(_dereq_,module,exports){
"use strict";

module.exports = {
  DISPATCH_FRAME_NAME: "dispatch",
  DISPATCH_FRAME_CLASS: "braintree-dispatch-frame",
  POPUP_BASE_OPTIONS: "resizable,scrollbars",
  DEFAULT_POPUP_WIDTH: 450,
  DEFAULT_POPUP_HEIGHT: 535,
  POPUP_POLL_INTERVAL: 100,
  POPUP_CLOSE_TIMEOUT: 100,
};

},{}],147:[function(_dereq_,module,exports){
"use strict";

/**
 * @name BraintreeError.Popup Related Error Codes
 * @ignore
 * @description Errors that occur when using a component that opens a popup window.
 * @property {INTERNAL} FRAME_SERVICE_FRAME_CLOSED - Occurs when the frame is closed before tokenization can occur.
 * @property {INTERNAL} FRAME_SERVICE_FRAME_OPEN_FAILED - Occurs when the popup could not be opened.
 */

var BraintreeError = _dereq_("../../braintree-error");

module.exports = {
  FRAME_SERVICE_FRAME_CLOSED: {
    type: BraintreeError.types.INTERNAL,
    code: "FRAME_SERVICE_FRAME_CLOSED",
    message: "Frame closed before tokenization could occur.",
  },
  FRAME_SERVICE_FRAME_OPEN_FAILED: {
    type: BraintreeError.types.INTERNAL,
    code: "FRAME_SERVICE_FRAME_OPEN_FAILED",
    message: "Frame failed to open.",
  },
};

},{"../../braintree-error":124}],148:[function(_dereq_,module,exports){
"use strict";

var enumerate = _dereq_("../../enumerate");

module.exports = enumerate(
  ["DISPATCH_FRAME_READY", "DISPATCH_FRAME_REPORT"],
  "frameService:"
);

},{"../../enumerate":134}],149:[function(_dereq_,module,exports){
"use strict";

var VERSION = "3.101.3";
var assign = _dereq_("./assign").assign;

function generateTokenizationParameters(configuration, overrides) {
  var metadata = configuration.analyticsMetadata;
  var basicTokenizationParameters = {
    gateway: "braintree",
    "braintree:merchantId": configuration.gatewayConfiguration.merchantId,
    "braintree:apiVersion": "v1",
    "braintree:sdkVersion": VERSION,
    "braintree:metadata": JSON.stringify({
      source: metadata.source,
      integration: metadata.integration,
      sessionId: metadata.sessionId,
      version: VERSION,
      platform: metadata.platform,
    }),
  };

  return assign({}, basicTokenizationParameters, overrides);
}

module.exports = function (configuration, googlePayVersion, googleMerchantId) {
  var data, paypalPaymentMethod;
  var androidPayConfiguration = configuration.gatewayConfiguration.androidPay;
  var environment =
    configuration.gatewayConfiguration.environment === "production"
      ? "PRODUCTION"
      : "TEST";

  if (googlePayVersion === 2) {
    data = {
      apiVersion: 2,
      apiVersionMinor: 0,
      environment: environment,
      allowedPaymentMethods: [
        {
          type: "CARD",
          parameters: {
            allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
            allowedCardNetworks: androidPayConfiguration.supportedNetworks.map(
              function (card) {
                return card.toUpperCase();
              }
            ),
          },
          tokenizationSpecification: {
            type: "PAYMENT_GATEWAY",
            parameters: generateTokenizationParameters(configuration, {
              "braintree:authorizationFingerprint":
                androidPayConfiguration.googleAuthorizationFingerprint,
            }),
          },
        },
      ],
    };

    if (googleMerchantId) {
      data.merchantInfo = {
        merchantId: googleMerchantId,
      };
    }

    if (androidPayConfiguration.paypalClientId) {
      paypalPaymentMethod = {
        type: "PAYPAL",
        parameters: {
          /* eslint-disable camelcase */
          purchase_context: {
            purchase_units: [
              {
                payee: {
                  client_id: androidPayConfiguration.paypalClientId,
                },
                recurring_payment: true,
              },
            ],
          },
          /* eslint-enable camelcase */
        },
        tokenizationSpecification: {
          type: "PAYMENT_GATEWAY",
          parameters: generateTokenizationParameters(configuration, {
            "braintree:paypalClientId": androidPayConfiguration.paypalClientId,
          }),
        },
      };

      data.allowedPaymentMethods.push(paypalPaymentMethod);
    }
  } else {
    data = {
      environment: environment,
      allowedPaymentMethods: ["CARD", "TOKENIZED_CARD"],
      paymentMethodTokenizationParameters: {
        tokenizationType: "PAYMENT_GATEWAY",
        parameters: generateTokenizationParameters(configuration, {
          "braintree:authorizationFingerprint":
            androidPayConfiguration.googleAuthorizationFingerprint,
        }),
      },
      cardRequirements: {
        allowedCardNetworks: androidPayConfiguration.supportedNetworks.map(
          function (card) {
            return card.toUpperCase();
          }
        ),
      },
    };

    if (configuration.authorizationType === "TOKENIZATION_KEY") {
      data.paymentMethodTokenizationParameters.parameters[
        "braintree:clientKey"
      ] = configuration.authorization;
    }

    if (googleMerchantId) {
      data.merchantId = googleMerchantId;
    }

    if (googlePayVersion) {
      data.apiVersion = googlePayVersion;
    }
  }

  return data;
};

},{"./assign":121}],150:[function(_dereq_,module,exports){
"use strict";

module.exports = function inIframe(win) {
  win = win || window;

  try {
    return win.self !== win.top;
  } catch (e) {
    return true;
  }
};

},{}],151:[function(_dereq_,module,exports){
"use strict";

function convertDateStringToDate(dateString) {
  var splitDate = dateString.split("-");

  return new Date(splitDate[0], splitDate[1], splitDate[2]);
}

function isDateStringBeforeOrOn(firstDate, secondDate) {
  return (
    convertDateStringToDate(firstDate) <= convertDateStringToDate(secondDate)
  );
}

module.exports = isDateStringBeforeOrOn;

},{}],152:[function(_dereq_,module,exports){
"use strict";

function isHTTPS(protocol) {
  protocol = protocol || window.location.protocol;

  return protocol === "https:";
}

module.exports = {
  isHTTPS: isHTTPS,
};

},{}],153:[function(_dereq_,module,exports){
"use strict";

var parser;
var legalHosts = {
  "paypal.com": 1,
  "braintreepayments.com": 1,
  "braintreegateway.com": 1,
  "braintree-api.com": 1,
};

// endRemoveIf(production)

function stripSubdomains(domain) {
  return domain.split(".").slice(-2).join(".");
}

function isVerifiedDomain(url) {
  var mainDomain;

  url = url.toLowerCase();

  if (!/^https:/.test(url)) {
    return false;
  }

  parser = parser || document.createElement("a");
  parser.href = url;
  mainDomain = stripSubdomains(parser.hostname);

  return legalHosts.hasOwnProperty(mainDomain);
}

module.exports = isVerifiedDomain;

},{}],154:[function(_dereq_,module,exports){
"use strict";

module.exports = function (value) {
  return JSON.parse(JSON.stringify(value));
};

},{}],155:[function(_dereq_,module,exports){
"use strict";

module.exports = function (obj) {
  return Object.keys(obj).filter(function (key) {
    return typeof obj[key] === "function";
  });
};

},{}],156:[function(_dereq_,module,exports){
"use strict";

function once(fn) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      fn.apply(null, arguments);
    }
  };
}

module.exports = once;

},{}],157:[function(_dereq_,module,exports){
"use strict";

function _notEmpty(obj) {
  var key;

  for (key in obj) {
    if (obj.hasOwnProperty(key)) {
      return true;
    }
  }

  return false;
}

/* eslint-disable no-mixed-operators */
function _isArray(value) {
  return (
    (value &&
      typeof value === "object" &&
      typeof value.length === "number" &&
      Object.prototype.toString.call(value) === "[object Array]") ||
    false
  );
}
/* eslint-enable no-mixed-operators */

function hasQueryParams(url) {
  url = url || window.location.href;

  return /\?/.test(url);
}

function parse(url) {
  var query, params;

  url = url || window.location.href;

  if (!hasQueryParams(url)) {
    return {};
  }

  query = url.split("?")[1] || "";
  query = query.replace(/#.*$/, "").split("&");

  params = query.reduce(function (toReturn, keyValue) {
    var parts = keyValue.split("=");
    var key = decodeURIComponent(parts[0]);
    var value = decodeURIComponent(parts[1]);

    toReturn[key] = value;

    return toReturn;
  }, {});

  return params;
}

function stringify(params, namespace) {
  var k, v, p;
  var query = [];

  for (p in params) {
    if (!params.hasOwnProperty(p)) {
      continue;
    }

    v = params[p];

    if (namespace) {
      if (_isArray(params)) {
        k = namespace + "[]";
      } else {
        k = namespace + "[" + p + "]";
      }
    } else {
      k = p;
    }
    if (typeof v === "object") {
      query.push(stringify(v, k));
    } else {
      query.push(encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
  }

  return query.join("&");
}

function queryify(url, params) {
  url = url || "";

  if (params != null && typeof params === "object" && _notEmpty(params)) {
    url += url.indexOf("?") === -1 ? "?" : "";
    url += url.indexOf("=") !== -1 ? "&" : "";
    url += stringify(params);
  }

  return url;
}

module.exports = {
  parse: parse,
  stringify: stringify,
  queryify: queryify,
  hasQueryParams: hasQueryParams,
};

},{}],158:[function(_dereq_,module,exports){
"use strict";

var uuid = _dereq_("@braintree/uuid");
var findRootNode = _dereq_("./find-root-node");

// based on https://github.com/krakenjs/belter/blob/cdddc4f8ddb172d29db9e7e1ad1eeeacfb93e215/src/dom.js#L981-L1031
// thanks @bluepnume

function isShadowElement(element) {
  element = findRootNode(element);

  return element.toString() === "[object ShadowRoot]";
}

function getShadowHost(element) {
  element = findRootNode(element);

  if (!isShadowElement(element)) {
    return null;
  }

  return element.host;
}

function transformToSlot(element, styles) {
  var styleNode = findRootNode(element).querySelector("style");
  var shadowHost = getShadowHost(element);
  var slotName = "shadow-slot-" + uuid();
  var slot = document.createElement("slot");
  var slotProvider = document.createElement("div");

  slot.setAttribute("name", slotName);
  element.appendChild(slot);

  slotProvider.setAttribute("slot", slotName);
  shadowHost.appendChild(slotProvider);

  if (styles) {
    if (!styleNode) {
      styleNode = document.createElement("style");
      element.appendChild(styleNode);
    }

    styleNode.sheet.insertRule(
      '::slotted([slot="' + slotName + '"]) { ' + styles + " }"
    );
  }

  if (isShadowElement(shadowHost)) {
    return transformToSlot(slotProvider, styles);
  }

  return slotProvider;
}

module.exports = {
  isShadowElement: isShadowElement,
  getShadowHost: getShadowHost,
  transformToSlot: transformToSlot,
};

},{"./find-root-node":136,"@braintree/uuid":39}],159:[function(_dereq_,module,exports){
"use strict";

module.exports = function (snakeString) {
  if (snakeString.indexOf("_") === -1) {
    return snakeString;
  }

  return snakeString.toLowerCase().replace(/(\_\w)/g, function (match) {
    return match[1].toUpperCase();
  });
};

},{}],160:[function(_dereq_,module,exports){
"use strict";

function useMin(isDebug) {
  return isDebug ? "" : ".min";
}

module.exports = useMin;

},{}],161:[function(_dereq_,module,exports){
"use strict";

// NEXT_MAJOR_VERSION old versions of IE don't have atob, in the
// next major version, we're dropping support for those versions
// so we can eliminate the need to have this atob polyfill
var atobNormalized = typeof atob === "function" ? atob : atobPolyfill;

function atobPolyfill(base64String) {
  var a, b, c, b1, b2, b3, b4, i;
  var base64Matcher = new RegExp(
    "^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})([=]{1,2})?$"
  );
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  var result = "";

  if (!base64Matcher.test(base64String)) {
    throw new Error("Non base64 encoded input passed to window.atob polyfill");
  }

  i = 0;
  do {
    b1 = characters.indexOf(base64String.charAt(i++));
    b2 = characters.indexOf(base64String.charAt(i++));
    b3 = characters.indexOf(base64String.charAt(i++));
    b4 = characters.indexOf(base64String.charAt(i++));

    a = ((b1 & 0x3f) << 2) | ((b2 >> 4) & 0x3);
    b = ((b2 & 0xf) << 4) | ((b3 >> 2) & 0xf);
    c = ((b3 & 0x3) << 6) | (b4 & 0x3f);

    result +=
      String.fromCharCode(a) +
      (b ? String.fromCharCode(b) : "") +
      (c ? String.fromCharCode(c) : "");
  } while (i < base64String.length);

  return result;
}

module.exports = {
  atob: function (base64String) {
    return atobNormalized.call(window, base64String);
  },
  _atob: atobPolyfill,
};

},{}],162:[function(_dereq_,module,exports){
"use strict";

module.exports = {
  REQUIRED_OPTIONS_FOR_START_PAYMENT: [
    "givenName",
    "surname",
    "currencyCode",
    "onPaymentStart",
    "paymentType",
    "amount",
    "fallback",
  ],
  REQUIRED_OPTIONS_FOR_PAY_UPON_INVOICE_PAYMENT_TYPE: [
    "givenName",
    "surname",
    "currencyCode",
    "onPaymentStart",
    "paymentType",
    "amount",
    "address",
    "billingAddress",
    "birthDate",
    "email",
    "locale",
    "customerServiceInstructions",
    "correlationId",
    "phone",
    "phoneCountryCode",
    "lineItems",
  ],
  REQUIRED_OPTIONS_FOR_ADDRESS: [
    "streetAddress",
    "locality",
    "postalCode",
    "countryCode",
  ],
  REQUIRED_OPTIONS_FOR_LINE_ITEMS: [
    "category",
    "name",
    "quantity",
    "unitAmount",
    "unitTaxAmount",
  ],
  REQUIRED_OPTIONS_FOR_BLIK_SEAMLESS_PAYMENT_TYPE: [
    "givenName",
    "surname",
    "currencyCode",
    "onPaymentStart",
    "paymentType",
    "amount",
  ],
  REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_LEVEL_0: ["authCode"],
  REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_FIRST: [
    "authCode",
    "consumerReference",
    "aliasLabel",
  ],
  REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_SUBSEQUENT: [
    "consumerReference",
    "aliasKey",
  ],
};

},{}],163:[function(_dereq_,module,exports){
"use strict";

var frameService = _dereq_("../../lib/frame-service/external");
var BraintreeError = _dereq_("../../lib/braintree-error");
var useMin = _dereq_("../../lib/use-min");
var VERSION = "3.101.3";
var INTEGRATION_TIMEOUT_MS =
  _dereq_("../../lib/constants").INTEGRATION_TIMEOUT_MS;
var analytics = _dereq_("../../lib/analytics");
var methods = _dereq_("../../lib/methods");
var convertMethodsToError = _dereq_("../../lib/convert-methods-to-error");
var convertToBraintreeError = _dereq_("../../lib/convert-to-braintree-error");
var ExtendedPromise = _dereq_("@braintree/extended-promise");
var querystring = _dereq_("../../lib/querystring");
var wrapPromise = _dereq_("@braintree/wrap-promise");
var constants = _dereq_("./constants");
var errors = _dereq_("../shared/errors");

var DEFAULT_WINDOW_WIDTH = 1282;
var DEFAULT_WINDOW_HEIGHT = 720;

ExtendedPromise.suppressUnhandledPromiseMessage = true;

/**
 * @class
 * @param {object} options see {@link module:braintree-web/local-payment.create|local-payment.create}
 * @classdesc This class represents a LocalPayment component. Instances of this class can open a LocalPayment window for paying with alternate payments local to a specific country. Any additional UI, such as disabling the page while authentication is taking place, is up to the developer.
 *
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/local-payment.create|braintree-web.local-payment.create} instead.</strong>
 */
function LocalPayment(options) {
  this._client = options.client;
  this._assetsUrl =
    options.client.getConfiguration().gatewayConfiguration.assetsUrl +
    "/web/" +
    VERSION;
  this._isDebug = options.client.getConfiguration().isDebug;
  this._loadingFrameUrl =
    this._assetsUrl +
    "/html/local-payment-landing-frame" +
    useMin(this._isDebug) +
    ".html";
  this._authorizationInProgress = false;
  this._paymentType = "unknown";
  this._merchantAccountId = options.merchantAccountId;
}

LocalPayment.prototype._initialize = function () {
  var self = this;
  var client = this._client;
  var failureTimeout = setTimeout(function () {
    analytics.sendEvent(client, "local-payment.load.timed-out");
  }, INTEGRATION_TIMEOUT_MS);

  return new Promise(function (resolve) {
    frameService.create(
      {
        name: "localpaymentlandingpage",
        dispatchFrameUrl:
          self._assetsUrl +
          "/html/dispatch-frame" +
          useMin(self._isDebug) +
          ".html",
        openFrameUrl: self._loadingFrameUrl,
      },
      function (service) {
        self._frameService = service;
        clearTimeout(failureTimeout);
        analytics.sendEvent(client, "local-payment.load.succeeded");
        resolve(self);
      }
    );
  });
};

/**
 * Options used for most local payment types.
 * @typedef {object} LocalPayment~StartPaymentOptions
 * @property {object} fallback Configuration for what to do when app switching back from a Bank app on a mobile device.
 * @property {string} fallback.buttonText The text to display in a button to redirect back to the merchant page.
 * @property {string} fallback.url The url to redirect to when the redirect button is pressed. Query params will be added to the url to process the data returned from the bank.
 * @property {string} fallback.cancelButtonText The text to display in a button to redirect back to the merchant page when the customer cancels. If no `cancelButtonText` is provided, `buttonText` will be used.
 * @property {string} fallback.cancelUrl The url to redirect to when the redirect button is pressed when the customer cancels. Query params will be added to the url to check the state of the payment. If no `cancelUrl` is provided, `url` will be used.
 * @property {object} [windowOptions] The options for configuring the window that is opened when starting the payment.
 * @property {number} [windowOptions.width=1282] The width in pixels of the window opened when starting the payment. The default width size is this large to allow various banking partner landing pages to display the QR Code to be scanned by the bank's mobile app. Many will not display the QR code when the window size is smaller than a standard desktop screen.
 * @property {number} [windowOptions.height=720] The height in pixels of the window opened when starting the payment.
 * @property {string} amount The amount to authorize for the transaction.
 * @property {string} currencyCode The currency to process the payment (three-character ISO-4217).
 * @property {string} [displayName] The merchant name displayed inside of the window that is opened when starting the payment.
 * @property {string} paymentType The type of local payment. See https://developer.paypal.com/braintree/docs/guides/local-payment-methods/client-side-custom
 * @property {string} paymentTypeCountryCode The country code of the local payment. This value must be one of the supported country codes for a given local payment type listed {@link https://developer.paypal.com/braintree/docs/guides/local-payment-methods/client-side-custom/javascript/v3#render-local-payment-method-buttons|here}. For local payments supported in multiple countries, this value may determine which banks are presented to the customer.
 * @property {string} email Payer email of the customer.
 * @property {string} givenName First name of the customer.
 * @property {string} surname Last name of the customer.
 * @property {string} phone Phone number of the customer.
 * @property {string} bic Bank Identification Code of the customer (specific to iDEAL transactions).
 * @property {boolean} recurrent Enable recurrent payment.
 * @property {string} customerId The customer's id in merchant's system (required for recurrent payments).
 * @property {boolean} shippingAddressRequired Indicates whether or not the payment needs to be shipped. For digital goods, this should be false. Defaults to false.
 * @property {object} address The shipping address.
 * @property {string} address.streetAddress Line 1 of the Address (eg. number, street, etc). An error will occur if this address is not valid.
 * @property {string} address.extendedAddress Line 2 of the Address (eg. suite, apt #, etc.). An error will occur if this address is not valid.
 * @property {string} address.locality Customer's city.
 * @property {string} address.region Customer's region or state.
 * @property {string} address.postalCode Customer's postal code.
 * @property {string} address.countryCode Customer's country code (two-character ISO 3166-1 code).
 * @property {function} onPaymentStart A function that will be called with two parameters: an object containing the  `paymentId` and a `continueCallback` that must be called to launch the flow. You can use method to do any preprocessing on your server before the flow begins..
 */

/**
 * Options used for the Pay Upon Invoice local payment type.
 * @typedef {object} LocalPayment~StartPaymentPayUponInvoiceOptions
 * @property {string} amount The amount to authorize for the transaction.
 * @property {string} currencyCode The currency to process the payment (three-character ISO-4217).
 * @property {string} [displayName] The merchant name displayed inside of the window that is opened when starting the payment.
 * @property {string} paymentType The type of local payment. Must be `pay_upon_invoice`.
 * @property {string} [paymentTypeCountryCode] The country code of the local payment. This value must be one of the supported country codes for a given local payment type listed {@link https://developer.paypal.com/braintree/docs/guides/local-payment-methods/client-side-custom/javascript/v3#render-local-payment-method-buttons|here}. For local payments supported in multiple countries, this value may determine which banks are presented to the customer.
 * @property {string} email Payer email of the customer.
 * @property {string} givenName First name of the customer.
 * @property {string} surname Last name of the customer.
 * @property {string} phone Phone number of the customer.
 * @property {string} phoneCountryCode The country calling code.
 * @property {string} birthDate The birth date of the customer in `YYYY-MM-DD` format.
 * @property {object} address The shipping address.
 * @property {string} address.streetAddress Line 1 of the Address (eg. number, street, etc). An error will occur if this address is not valid.
 * @property {string} [address.extendedAddress] Line 2 of the Address (eg. suite, apt #, etc.). An error will occur if this address is not valid.
 * @property {string} address.locality Customer's city.
 * @property {string} [address.region] Customer's region or state.
 * @property {string} address.postalCode Customer's postal code.
 * @property {string} address.countryCode Customer's country code (two-character ISO 3166-1 code).
 * @property {string} [shippingAmount] The shipping fee for all items. This value can not be a negative number.
 * @property {string} [discountAmount] The discount for all items. This value can not be a negative number.
 * @property {object} billingAddress The billing address.
 * @property {string} billingAddress.streetAddress Line 1 of the Address (eg. number, street, etc). An error will occur if this address is not valid.
 * @property {string} [billingAddress.extendedAddress] Line 2 of the Address (eg. suite, apt #, etc.). An error will occur if this address is not valid.
 * @property {string} billingAddress.locality Customer's city.
 * @property {string} [billingAddress.region] Customer's region or state.
 * @property {string} billingAddress.postalCode Customer's postal code.
 * @property {string} billingAddress.countryCode Customer's country code (two-character ISO 3166-1 code).
 * @property {object[]} lineItems List of line items.
 * @property {string} lineItems.category The item category type: `'DIGITAL_GOODS'`, `'PHYSICAL_GOODS'`, or `'DONATION'`.
 * @property {string} lineItems.name Item name. Maximum 127 characters.
 * @property {string} lineItems.quantity Number of units of the item purchased. This value must be a whole number and can't be negative or zero.
 * @property {string} lineItems.unitAmount Per-unit price of the item. Can include up to 2 decimal places. This value can't be negative or zero.
 * @property {string} lineItems.unitTaxAmount Per-unit tax price of the item. Can include up to 2 decimal places. This value can't be negative.
 * @property {string} locale The BCP 47-formatted locale. PayPal supports a five-character code. For example, `en-DE`, `da-DK`, `he-IL`, `id-ID`, `ja-JP`, `no-NO`, `pt-BR`, `ru-RU`, `sv-SE`, `th-TH`, `zh-CN`, `zh-HK`, or `zh-TW`.
 * @property {string} customerServiceInstructions Instructions for how to contact the merchant's customer service. Maximum 4,000 characters.
 * @property {string} correlationId Used to correlate user sessions with server transactions.
 * @property {function} onPaymentStart A function that will be called with an object containing the `paymentId`. The `continueCallback` is not provided as it is not needed for this use case.
 */

/**
 * Options used for the seamless/oneclick BLIK local payment type.
 * @typedef {object} LocalPayment~StartPaymentOptions
 * @property {string} amount The amount to authorize for the transaction.
 * @property {string} currencyCode The currency to process the payment (three-character ISO-4217).
 * @property {string} [displayName] The merchant name displayed inside of the window that is opened when starting the payment.
 * @property {string} paymentType The type of local payment. Must be `blik`.
 * @property {string} paymentTypeCountryCode The country code of the local payment. This value must be one of the supported country codes for a given local payment type listed {@link https://developer.paypal.com/braintree/docs/guides/local-payment-methods/client-side-custom/javascript/v3#render-local-payment-method-buttons|here}. For local payments supported in multiple countries, this value may determine which banks are presented to the customer.
 * @property {string} email Payer email of the customer.
 * @property {string} givenName First name of the customer.
 * @property {string} surname Last name of the customer.
 * @property {string} phone Phone number of the customer.
 * @property {boolean} shippingAddressRequired Indicates whether or not the payment needs to be shipped. For digital goods, this should be false. Defaults to false.
 * @property {object} address The shipping address.
 * @property {string} address.streetAddress Line 1 of the Address (eg. number, street, etc). An error will occur if this address is not valid.
 * @property {string} address.extendedAddress Line 2 of the Address (eg. suite, apt #, etc.). An error will occur if this address is not valid.
 * @property {string} address.locality Customer's city.
 * @property {string} address.region Customer's region or state.
 * @property {string} address.postalCode Customer's postal code.
 * @property {string} address.countryCode Customer's country code (two-character ISO 3166-1 code).
 * @property {object} blikOptions Blik seamless/oneclick specific options. Should contain only one object: `level_0` or `oneClick`.
 * @property {object} blikOptions.level_0 Blik seamless specific options.
 * @property {string} blikOptions.level_0.authCode 6-digit code used to authenticate a consumer within BLIK.
 * @property {object} blikOptions.oneClick Blik oneclick specific options.
 * @property {string} blikOptions.oneClick.authCode 6-digit code used to authenticate a consumer within BLIK.
 * @property {string} blikOptions.oneClick.consumerReference The merchant generated, unique reference serving as a primary identifier for accounts connected between Blik and a merchant.
 * @property {string} blikOptions.oneClick.aliasLabel A bank defined identifier used as a display name to allow the payer to differentiate between multiple registered bank accounts.
 * @property {string} blikOptions.oneClick.aliasKey A Blik-defined identifier for a specific Blik-enabled bank account that is associated with a given merchant. Used only in conjunction with a Consumer Reference.
 * @property {function} onPaymentStart A function that will be called with an object containing the `paymentId`. The `continueCallback` is not provided as it is not needed for this use case.
 */

/**
 * Launches the local payment flow and returns a nonce payload. Only one local payment flow should be active at a time. One way to achieve this is to disable your local payment button while the flow is open.
 * @public
 * @function
 * @param {LocalPayment~StartPaymentOptions|LocalPayment~StartPaymentPayUponInvoiceOptions} options Options for initiating the local payment payment flow.
 * @param {callback} callback The second argument, <code>data</code>, is a {@link LocalPayment~startPaymentPayload|startPaymentPayload}. If no callback is provided, the method will return a Promise that resolves with a {@link LocalPayment~startPaymentPayload|startPaymentPayload}.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * localPaymentInstance.startPayment({
 *   paymentType: 'ideal',
 *   paymentTypeCountryCode: 'NL',
 *   fallback: {
 *     buttonText: 'Return to Merchant',
 *     url: 'https://example.com/my-checkout-page'
 *   },
 *   amount: '10.00',
 *   currencyCode: 'EUR',
 *   givenName: 'Joe',
 *   surname: 'Doe',
 *   address: {
 *     countryCode: 'NL'
 *   },
 *   onPaymentStart: function (data, continueCallback) {
 *     // Do any preprocessing before starting the flow
 *     // data.paymentId is the ID of the localPayment
 *     continueCallback();
 *   }
 * }).then(function (payload) {
 *   // Submit payload.nonce to your server
 * }).catch(function (startPaymentError) {
 *   // Handle flow errors or premature flow closure
 *   console.error('Error!', startPaymentError);
 * });
 * @example <caption>Pay Upon Invoice</caption>
 * localPaymentInstance.startPayment({
 *   paymentType: 'pay_upon_invoice',
 *   amount: '100.00',
 *   currencyCode: 'EUR',
 *   givenName: 'Max',
 *   surname: 'Mustermann',
 *   address: { // This is used as the shipping address.
 *     streetAddress: 'Taunusanlage 12',
 *     locality: 'Frankfurt',
 *     postalCode: '60325',
 *     countryCode: 'DE',
 *   },
 *   billingAddress: {
 *     streetAddress: 'Schönhauser Allee 84',
 *     locality: 'Berlin',
 *     postalCode: '10439',
 *     countryCode: 'DE'
 *   },
 *   birthDate: '1990-01-01',
 *   email: 'buyer@example.com',
 *   locale: 'en-DE',
 *   customerServiceInstructions: 'Customer service phone is +49 6912345678.',
 *   lineItems: [{
 *     category: 'PHYSICAL_GOODS',
 *     name: 'Basketball Shoes',
 *     quantity: '1',
 *     unitAmount: '81.00',
 *     unitTaxAmount: '19.00',
 *   }],
 *   phone: '6912345678',
 *   phoneCountryCode: '49',
 *   correlationId: correlationId,
 *   onPaymentStart: function (data) {
 *     // NOTE: It is critical here to store data.paymentId on your server
 *     //       so it can be mapped to a webhook sent by Braintree once the
 *     //       buyer completes their payment.
 *     console.log('Payment ID:', data.paymentId);
 *   },
 * }).catch(function (err) {
 *   // Handle any error calling startPayment.
 *   console.error(err);
 * });
 * @example <caption>BLIK seamless</caption>
 * localPaymentInstance.startPayment({
 *   paymentType: 'blik',
 *   paymentTypeCountryCode: 'PL',
 *   amount: '10.00',
 *   currencyCode: 'PLN',
 *   givenName: 'Joe',
 *   surname: 'Doe',
 *   phone: '1234566789',
 *   address: {
 *     streetAddress: 'Mokotowska 1234',
 *     locality: 'Warsaw',
 *     postalCode: '02-697',
 *     countryCode: 'PL',
 *   },
 *   blikOptions: {
 *     level_0: {
 *       authCode: "123456",
 *     },
 *   },
 *   onPaymentStart: function (data) {
 *     // NOTE: It is critical here to store data.paymentId on your server
 *     //       so it can be mapped to a webhook sent by Braintree once the
 *     //       buyer completes their payment.
 *     console.log('Payment ID:', data.paymentId);
 *   },
 * }).catch(function (err) {
 *   // Handle any error calling startPayment.
 *   console.error(err);
 * });
 * @example <caption>BLIK oneclick first payment</caption>
 * localPaymentInstance.startPayment({
 *   paymentType: 'blik',
 *   paymentTypeCountryCode: 'PL',
 *   amount: '10.00',
 *   currencyCode: 'PLN',
 *   givenName: 'Joe',
 *   surname: 'Doe',
 *   phone: '1234566789',
 *   address: {
 *     streetAddress: 'Mokotowska 1234',
 *     locality: 'Warsaw',
 *     postalCode: '02-697',
 *     countryCode: 'PL',
 *   },
 *   blikOptions: {
 *     oneClick: {
 *       authCode: "123456",
 *       consumerReference: "ABCde123",
 *       aliasLabel: "my uniq alias",
 *     },
 *   },
 *   onPaymentStart: function (data) {
 *     // NOTE: It is critical here to store data.paymentId on your server
 *     //       so it can be mapped to a webhook sent by Braintree once the
 *     //       buyer completes their payment.
 *     console.log('Payment ID:', data.paymentId);
 *   },
 * }).catch(function (err) {
 *   // Handle any error calling startPayment.
 *   console.error(err);
 * });
 * @example <caption>BLIK oneclick subsequent payment</caption>
 * localPaymentInstance.startPayment({
 *   paymentType: 'blik',
 *   paymentTypeCountryCode: 'PL',
 *   amount: '10.00',
 *   currencyCode: 'PLN',
 *   givenName: 'Joe',
 *   surname: 'Doe',
 *   phone: '1234566789',
 *   address: {
 *     streetAddress: 'Mokotowska 1234',
 *     locality: 'Warsaw',
 *     postalCode: '02-697',
 *     countryCode: 'PL',
 *   },
 *   blikOptions: {
 *     oneClick: {
 *       consumerReference: "ABCde123",
 *       aliasKey: "123456789",
 *     },
 *   },
 *   onPaymentStart: function (data) {
 *     // NOTE: It is critical here to store data.paymentId on your server
 *     //       so it can be mapped to a webhook sent by Braintree once the
 *     //       buyer completes their payment.
 *     console.log('Payment ID:', data.paymentId);
 *   },
 * }).catch(function (err) {
 *   // Handle any error calling startPayment.
 *   console.error(err);
 * });
 */
LocalPayment.prototype.startPayment = function (options) {
  var missingOption,
    missingError,
    address,
    fallback,
    params,
    promise,
    billingAddress,
    windowOptions,
    onPaymentStartPromise;
  var self = this; // eslint-disable-line no-invalid-this
  var serviceId = this._frameService._serviceId; // eslint-disable-line no-invalid-this

  // In order to provide the merchant with appropriate error messaging,
  // more robust validation is being done on the client-side, since some
  // option names are mapped to legacy names for the sake of the API.
  // For example, if `billingAddress.streetAddress` was missing, then
  // the API error response would say that `billing_address.line1` was
  // missing. This client-side validation will correctly tell the
  // merchant that `billingAddress.streetAddress` was missing.
  missingOption = hasMissingOption(options);
  if (missingOption) {
    missingError = new BraintreeError(
      errors.LOCAL_PAYMENT_START_PAYMENT_MISSING_REQUIRED_OPTION
    );
    if (typeof missingOption === "string") {
      missingError.details = "Missing required '" + missingOption + "' option.";
    }

    return Promise.reject(missingError);
  }
  windowOptions = options.windowOptions || {};
  address = options.address || {};
  fallback = options.fallback || {};
  billingAddress = options.billingAddress || {};
  params = {
    amount: options.amount,
    bic: options.bic,
    billingAddress: {
      line1: billingAddress.streetAddress,
      line2: billingAddress.extendedAddress,
      city: billingAddress.locality,
      state: billingAddress.region,
      postalCode: billingAddress.postalCode,
      countryCode: billingAddress.countryCode,
    },
    birthDate: options.birthDate,
    blikOptions: options.blikOptions,
    cancelUrl: querystring.queryify(
      self._assetsUrl +
        "/html/local-payment-redirect-frame" +
        useMin(self._isDebug) +
        ".html",
      {
        channel: serviceId,
        r: fallback.cancelUrl || fallback.url,
        t: fallback.cancelButtonText || fallback.buttonText,
        c: 1, // indicating we went through the cancel flow
      }
    ),
    city: address.locality,
    correlationId: options.correlationId,
    countryCode: address.countryCode,
    currencyIsoCode: options.currencyCode,
    discountAmount: options.discountAmount,
    experienceProfile: {
      brandName: options.displayName,
      customerServiceInstructions: options.customerServiceInstructions,
      locale: options.locale,
      noShipping: !options.shippingAddressRequired,
    },
    firstName: options.givenName,
    fundingSource: options.paymentType,
    intent: "sale",
    lastName: options.surname,
    line1: address.streetAddress,
    line2: address.extendedAddress,
    lineItems: options.lineItems,
    merchantAccountId: self._merchantAccountId,
    merchantOrPartnerCustomerId: options.customerId,
    payerEmail: options.email,
    paymentTypeCountryCode: options.paymentTypeCountryCode,
    phone: options.phone,
    phoneCountryCode: options.phoneCountryCode,
    postalCode: address.postalCode,
    recurrent: options.recurrent,
    returnUrl: querystring.queryify(
      self._assetsUrl +
        "/html/local-payment-redirect-frame" +
        useMin(self._isDebug) +
        ".html",
      {
        channel: serviceId,
        r: fallback.url,
        t: fallback.buttonText,
      }
    ),
    shippingAmount: options.shippingAmount,
    state: address.region,
  };

  self._paymentType = options.paymentType.toLowerCase();
  if (self._authorizationInProgress) {
    analytics.sendEvent(
      self._client,
      self._paymentType + ".local-payment.start-payment.error.already-opened"
    );

    return Promise.reject(
      new BraintreeError(errors.LOCAL_PAYMENT_ALREADY_IN_PROGRESS)
    );
  }

  self._authorizationInProgress = true;

  promise = new ExtendedPromise();

  // For deferred payment types, the popup window should not be opened,
  // since the actual payment will be done outside of this session.
  if (!isDeferredPaymentTypeOptions(options)) {
    self._startPaymentCallback = self._createStartPaymentCallback(
      function (val) {
        promise.resolve(val);
      },
      function (err) {
        promise.reject(err);
      }
    );

    self._frameService.open(
      {
        width: windowOptions.width || DEFAULT_WINDOW_WIDTH,
        height: windowOptions.height || DEFAULT_WINDOW_HEIGHT,
      },
      self._startPaymentCallback
    );
  }

  self._client
    .request({
      method: "post",
      endpoint: "local_payments/create",
      data: params,
    })
    .then(function (response) {
      var redirectUrl = response.paymentResource.redirectUrl;

      analytics.sendEvent(
        self._client,
        self._paymentType + ".local-payment.start-payment.opened"
      );
      self._startPaymentOptions = options;

      if (isDeferredPaymentTypeOptions(options)) {
        self._authorizationInProgress = false;

        if (typeof redirectUrl === "string" && redirectUrl.length) {
          promise.reject(
            new BraintreeError(
              errors.LOCAL_PAYMENT_START_PAYMENT_DEFERRED_PAYMENT_FAILED
            )
          );
        } else {
          onPaymentStartPromise = options.onPaymentStart({
            paymentId: response.paymentResource.paymentToken,
          });

          if (onPaymentStartPromise instanceof Promise) {
            onPaymentStartPromise.then(function () {
              promise.resolve();
            });
          } else {
            promise.resolve();
          }
        }
      } else {
        options.onPaymentStart(
          { paymentId: response.paymentResource.paymentToken },
          function () {
            self._frameService.redirect(response.paymentResource.redirectUrl);
          }
        );
      }
    })
    .catch(function (err) {
      var status = err.details && err.details.httpStatus;

      self._frameService.close();
      self._authorizationInProgress = false;

      if (status === 422) {
        promise.reject(
          new BraintreeError({
            type: errors.LOCAL_PAYMENT_INVALID_PAYMENT_OPTION.type,
            code: errors.LOCAL_PAYMENT_INVALID_PAYMENT_OPTION.code,
            message: errors.LOCAL_PAYMENT_INVALID_PAYMENT_OPTION.message,
            details: {
              originalError: err,
            },
          })
        );

        return;
      }

      promise.reject(
        convertToBraintreeError(err, {
          type: errors.LOCAL_PAYMENT_START_PAYMENT_FAILED.type,
          code: errors.LOCAL_PAYMENT_START_PAYMENT_FAILED.code,
          message: errors.LOCAL_PAYMENT_START_PAYMENT_FAILED.message,
        })
      );
    });

  return promise;
};

/**
 * Manually tokenizes params for a local payment received from PayPal.When app switching back from a mobile application (such as a bank application for an iDEAL payment), the window may lose context with the parent page. In that case, a fallback url is used, and this method can be used to finish the flow.
 * @public
 * @function
 * @param {object} [params] All options for tokenizing local payment parameters. If no params are passed in, the params will be pulled off of the query string of the page.
 * @param {string} params.btLpToken The token representing the local payment. Aliased to `token` if `btLpToken` is not present.
 * @param {string} params.btLpPaymentId The payment id for the local payment. Aliased to `paymentId` if `btLpPaymentId` is not present.
 * @param {string} params.btLpPayerId The payer id for the local payment. Aliased to `PayerID` if `btLpPayerId` is not present.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link LocalPayment~startPaymentPayload|startPaymentPayload}. If no callback is provided, the method will return a Promise that resolves with a {@link LocalPayment~startPaymentPayload|startPaymentPayload}.
 * @example
 * localPaymentInstance.tokenize().then(function (payload) {
 *   // send payload.nonce to your server
 * }).catch(function (err) {
 *   // handle tokenization error
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
LocalPayment.prototype.tokenize = function (params) {
  var self = this;
  var client = this._client;

  params = params || querystring.parse();

  // iOS Safari parses query params by adding the params inside an object called: queryItems
  if (params.queryItems) {
    params = params.queryItems;
  }

  if (params.c || params.wasCanceled) {
    return Promise.reject(
      new BraintreeError({
        type: errors.LOCAL_PAYMENT_CANCELED.type,
        code: errors.LOCAL_PAYMENT_CANCELED.code,
        message: errors.LOCAL_PAYMENT_CANCELED.message,
        details: {
          originalError: {
            errorcode: params.errorcode,
            token: params.btLpToken,
          },
        },
      })
    );
  } else if (params.errorcode) {
    return Promise.reject(
      new BraintreeError({
        type: errors.LOCAL_PAYMENT_START_PAYMENT_FAILED.type,
        code: errors.LOCAL_PAYMENT_START_PAYMENT_FAILED.code,
        message: errors.LOCAL_PAYMENT_START_PAYMENT_FAILED.message,
        details: {
          originalError: {
            errorcode: params.errorcode,
            token: params.btLpToken,
          },
        },
      })
    );
  }

  return client
    .request({
      endpoint: "payment_methods/paypal_accounts",
      method: "post",
      data: this._formatTokenizeData(params),
    })
    .then(function (response) {
      var payload = self._formatTokenizePayload(response);

      if (window.popupBridge) {
        analytics.sendEvent(
          client,
          self._paymentType + ".local-payment.tokenization.success-popupbridge"
        );
      } else {
        analytics.sendEvent(
          client,
          self._paymentType + ".local-payment.tokenization.success"
        );
      }

      return payload;
    })
    .catch(function (err) {
      analytics.sendEvent(
        client,
        self._paymentType + ".local-payment.tokenization.failed"
      );

      return Promise.reject(
        convertToBraintreeError(err, {
          type: errors.LOCAL_PAYMENT_TOKENIZATION_FAILED.type,
          code: errors.LOCAL_PAYMENT_TOKENIZATION_FAILED.code,
          message: errors.LOCAL_PAYMENT_TOKENIZATION_FAILED.message,
        })
      );
    });
};

/**
 * Closes the LocalPayment window if it is open.
 * @public
 * @example
 * localPaymentInstance.closeWindow();
 * @returns {void}
 */
LocalPayment.prototype.closeWindow = function () {
  if (this._authoriztionInProgress) {
    analytics.sendEvent(
      this._client,
      this._paymentType + ".local-payment.start-payment.closed.by-merchant"
    );
  }
  this._frameService.close();
};

/**
 * Focuses the LocalPayment window if it is open.
 * @public
 * @example
 * localPaymentInstance.focusWindow();
 * @returns {void}
 */
LocalPayment.prototype.focusWindow = function () {
  this._frameService.focus();
};

LocalPayment.prototype._createStartPaymentCallback = function (
  resolve,
  reject
) {
  var self = this;
  var client = this._client;

  return function (err, params) {
    self._authorizationInProgress = false;
    if (err) {
      if (err.code === "FRAME_SERVICE_FRAME_CLOSED") {
        if (params && params.errorcode === "processing_error") {
          // something failed within the payment window (rather than when
          // tokenizing with Braintree)
          analytics.sendEvent(
            client,
            self._paymentType + ".local-payment.failed-in-window"
          );
          reject(new BraintreeError(errors.LOCAL_PAYMENT_START_PAYMENT_FAILED));

          return;
        }

        // its possible to have a query param with errorcode=payment_error, which
        // indicates that the customer cancelled the flow from within the UI,
        // but as there's no meaningful difference to the merchant whether the
        // customer closes via the UI or by manually closing the window, we
        // don't differentiate these
        analytics.sendEvent(
          client,
          self._paymentType + ".local-payment.tokenization.closed.by-user"
        );
        reject(new BraintreeError(errors.LOCAL_PAYMENT_WINDOW_CLOSED));
      } else if (
        err.code &&
        err.code.indexOf("FRAME_SERVICE_FRAME_OPEN_FAILED") > -1
      ) {
        reject(
          new BraintreeError({
            code: errors.LOCAL_PAYMENT_WINDOW_OPEN_FAILED.code,
            type: errors.LOCAL_PAYMENT_WINDOW_OPEN_FAILED.type,
            message: errors.LOCAL_PAYMENT_WINDOW_OPEN_FAILED.message,
            details: {
              originalError: err,
            },
          })
        );
      }
    } else if (params) {
      if (!window.popupBridge) {
        self._frameService.redirect(self._loadingFrameUrl);
      }

      self
        .tokenize(params)
        .then(resolve)
        .catch(reject)
        .then(function () {
          self._frameService.close();
        });
    }
  };
};

LocalPayment.prototype._formatTokenizePayload = function (response) {
  var payload;
  var account = {};

  if (response.paypalAccounts) {
    account = response.paypalAccounts[0];
  }

  payload = {
    nonce: account.nonce,
    details: {},
    type: account.type,
  };

  if (account.details) {
    if (account.details.payerInfo) {
      payload.details = account.details.payerInfo;
    }
    if (account.details.correlationId) {
      payload.correlationId = account.details.correlationId;
    }
  }

  return payload;
};

/**
 * Checks if required tokenization parameters are available in querystring for manual tokenization requests.
 * @public
 * @function
 * @example
 * // if query string contains
 * // ?btLpToken=token&btLpPaymentId=payment-id&btLpPayerId=payer-id
 * localPaymentInstance.hasTokenizationParams(); // true
 *
 * // if query string is missing required params
 * localPaymentInstance.hasTokenizationParams(); // false
 *
 * if (localPaymentInstance.hasTokenizationParams()) {
 *   localPaymentInstance.tokenize();
 * }
 * @returns {Boolean} Returns a Boolean value for the state of the query string.
 */
LocalPayment.prototype.hasTokenizationParams = function () {
  var params = querystring.parse();

  if (params.errorcode) {
    return true;
  }

  return Boolean(
    params.btLpToken && params.btLpPaymentId && params.btLpPayerId
  );
};

LocalPayment.prototype._formatTokenizeData = function (params) {
  var clientConfiguration = this._client.getConfiguration();
  var gatewayConfiguration = clientConfiguration.gatewayConfiguration;
  var data = {
    merchantAccountId: this._merchantAccountId,
    paypalAccount: {
      correlationId: params.btLpToken || params.token,
      paymentToken: params.btLpPaymentId || params.paymentId,
      payerId: params.btLpPayerId || params.PayerID,
      unilateral: gatewayConfiguration.paypal.unvettedMerchant,
      intent: "sale",
    },
  };

  return data;
};

// Some payment types are deferred. Meaning, the actual payment will
// occur at a later time outside of this session. For example, with
// Pay Upon Invoice, the customer will later receive an email that will
// be used to make the actual payment through RatePay. This function
// will return `true` if the given options contain `paymentType` of
// a deferred payment type; and/or some payments, like blik, may have
// specific extra options to be treated as deferred. Otherwise, it
// will return `false`.
function isDeferredPaymentTypeOptions(options) {
  var blikOptions = options.blikOptions || {};
  var paymentType =
    typeof options.paymentType === "string"
      ? options.paymentType.toLowerCase()
      : options.paymentType;

  if (paymentType === "pay_upon_invoice") {
    return true;
  } else if (paymentType === "blik") {
    return (
      blikOptions.hasOwnProperty("level_0") ||
      blikOptions.hasOwnProperty("oneClick")
    );
  }

  return false;
}

function hasMissingAddressOption(options) {
  var i, option;

  for (i = 0; i < constants.REQUIRED_OPTIONS_FOR_ADDRESS.length; i++) {
    option = constants.REQUIRED_OPTIONS_FOR_ADDRESS[i];
    if (!options.hasOwnProperty(option)) {
      return option;
    }
  }

  return false;
}

function hasMissingLineItemsOption(items) {
  var i, j, item, option;

  for (j = 0; j < items.length; j++) {
    item = items[j];
    for (i = 0; i < constants.REQUIRED_OPTIONS_FOR_LINE_ITEMS.length; i++) {
      option = constants.REQUIRED_OPTIONS_FOR_LINE_ITEMS[i];
      if (!item.hasOwnProperty(option)) {
        return option;
      }
    }
  }

  return false;
}

function hasMissingBlikOptions(options) {
  var i, option, oneClick;
  var blikOptions = options.blikOptions || {};

  for (
    i = 0;
    i < constants.REQUIRED_OPTIONS_FOR_BLIK_SEAMLESS_PAYMENT_TYPE.length;
    i++
  ) {
    option = constants.REQUIRED_OPTIONS_FOR_BLIK_SEAMLESS_PAYMENT_TYPE[i];
    if (!options.hasOwnProperty(option)) {
      return option;
    }
  }

  if (blikOptions.hasOwnProperty("level_0")) {
    for (
      i = 0;
      i < constants.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_LEVEL_0.length;
      i++
    ) {
      option = constants.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_LEVEL_0[i];

      // eslint-disable-next-line camelcase
      if (!blikOptions.level_0.hasOwnProperty(option)) {
        return "blikOptions.level_0." + option;
      }
    }
  } else if (blikOptions.hasOwnProperty("oneClick")) {
    oneClick = blikOptions.oneClick || {};

    if (oneClick.hasOwnProperty("aliasKey")) {
      for (
        i = 0;
        i <
        constants.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_SUBSEQUENT.length;
        i++
      ) {
        option =
          constants.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_SUBSEQUENT[i];

        if (!oneClick.hasOwnProperty(option)) {
          return "blikOptions.oneClick." + option;
        }
      }
    } else {
      for (
        i = 0;
        i < constants.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_FIRST.length;
        i++
      ) {
        option = constants.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_FIRST[i];

        if (!oneClick.hasOwnProperty(option)) {
          return "blikOptions.oneClick." + option;
        }
      }
    }
  }

  return false;
}

// This will return the name of the first missing required option that
// is found or `true` if `options` itself is not defined. Otherwise, it
// will return `false`.
function hasMissingOption(options) {
  var i, option, missingAddressOption, missingLineItemOption, paymentType;

  if (!options) {
    return true;
  }

  if (isDeferredPaymentTypeOptions(options)) {
    paymentType = options.paymentType || "";

    if (paymentType.toLowerCase() === "pay_upon_invoice") {
      for (
        i = 0;
        i < constants.REQUIRED_OPTIONS_FOR_PAY_UPON_INVOICE_PAYMENT_TYPE.length;
        i++
      ) {
        option =
          constants.REQUIRED_OPTIONS_FOR_PAY_UPON_INVOICE_PAYMENT_TYPE[i];
        if (!options.hasOwnProperty(option)) {
          return option;
        }
        if (option === "address" || option === "billingAddress") {
          missingAddressOption = hasMissingAddressOption(options[option]);
          if (missingAddressOption) {
            return option + "." + missingAddressOption;
          }
        } else if (option === "lineItems") {
          missingLineItemOption = hasMissingLineItemsOption(options[option]);
          if (missingLineItemOption) {
            return option + "." + missingLineItemOption;
          }
        }
      }
    } else if (paymentType.toLowerCase() === "blik") {
      return hasMissingBlikOptions(options);
    }
  } else {
    for (i = 0; i < constants.REQUIRED_OPTIONS_FOR_START_PAYMENT.length; i++) {
      option = constants.REQUIRED_OPTIONS_FOR_START_PAYMENT[i];

      if (!options.hasOwnProperty(option)) {
        return option;
      }
    }

    if (!options.fallback.url) {
      return "fallback.url";
    }
    if (!options.fallback.buttonText) {
      return "fallback.buttonText";
    }
    if (options.recurrent === true && !options.customerId) {
      return "customerId";
    }
  }

  return false;
}

/**
 * Cleanly remove anything set up by {@link module:braintree-web/local-payment.create|create}.
 * @public
 * @param {callback} [callback] Called on completion.
 * @example
 * localPaymentInstance.teardown();
 * @example <caption>With callback</caption>
 * localPaymentInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
LocalPayment.prototype.teardown = function () {
  var self = this; // eslint-disable-line no-invalid-this

  self._frameService.teardown();

  convertMethodsToError(self, methods(LocalPayment.prototype));

  analytics.sendEvent(self._client, "local-payment.teardown-completed");

  return Promise.resolve();
};

module.exports = wrapPromise.wrapPrototype(LocalPayment);

},{"../../lib/analytics":119,"../../lib/braintree-error":124,"../../lib/constants":126,"../../lib/convert-methods-to-error":127,"../../lib/convert-to-braintree-error":128,"../../lib/frame-service/external":139,"../../lib/methods":155,"../../lib/querystring":157,"../../lib/use-min":160,"../shared/errors":165,"./constants":162,"@braintree/extended-promise":34,"@braintree/wrap-promise":43}],164:[function(_dereq_,module,exports){
"use strict";
/**
 * @module braintree-web/local-payment
 * @description A component to integrate with local payment methods. *This component is currently in beta and is subject to change.*
 */

var analytics = _dereq_("../lib/analytics");
var basicComponentVerification = _dereq_("../lib/basic-component-verification");
var createDeferredClient = _dereq_("../lib/create-deferred-client");
var createAssetsUrl = _dereq_("../lib/create-assets-url");
var LocalPayment = _dereq_("./external/local-payment");
var VERSION = "3.101.3";
var wrapPromise = _dereq_("@braintree/wrap-promise");
var BraintreeError = _dereq_("../lib/braintree-error");
var errors = _dereq_("./shared/errors");

/**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {string} [options.merchantAccountId] A non-default merchant account ID to use for tokenization and creation of the authorizing transaction. Braintree strongly recommends specifying this parameter.
 * @param {callback} callback The second argument, `data`, is the {@link LocalPayment} instance.
 * @example <caption>Using the local payment component to set up an iDEAL button</caption>
 * var idealButton = document.querySelector('.ideal-button');
 *
 * braintree.client.create({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (clientErr, clientInstance) {
 *   if (clientErr) {
 *     console.error('Error creating client:', clientErr);
 *     return;
 *   }
 *
 *   braintree.localPayment.create({
 *     client: clientInstance,
 *     merchantAccountId: 'merchantAccountEUR',
 *   }, function (localPaymentErr, localPaymentInstance) {
 *     if (localPaymentErr) {
 *       console.error('Error creating local payment component:', localPaymentErr);
 *       return;
 *     }
 *
 *     idealButton.removeAttribute('disabled');
 *
 *     // When the button is clicked, attempt to start the payment flow.
 *     idealButton.addEventListener('click', function (event) {
 *       // Because this opens a popup, this has to be called as a result of
 *       // customer action, like clicking a button. You cannot call this at any time.
 *       localPaymentInstance.startPayment({
 *         paymentType: 'ideal',
 *         amount: '10.67',
 *         city: 'Den Haag',
 *         countryCode: 'NL',
 *         firstName: 'Test',
 *         lastName: 'McTester',
 *         line1: '123 of 456 Fake Lane',
 *         line2: 'Apartment 789',
 *         payerEmail: 'payer@example.com',
 *         phone: '123456789',
 *         postalCode: '1234 AA',
 *         currencyCode: 'EUR',
 *         onPaymentStart: function (data, continueCallback) {
 *           // Do any preprocessing to store the ID and setup webhook
 *           // Call start to initiate the popup
 *           continueCallback();
 *         }
 **       }, function (startPaymentErr, payload) {
 *         if (startPaymentErr) {
 *           if (startPaymentErr.type !== 'CUSTOMER') {
 *             console.error('Error starting payment:', startPaymentErr);
 *           }
 *           return;
 *         }
 *
 *         idealButton.setAttribute('disabled', true);
 *
 *         console.log(payload.paymentId);
 *       });
 *     }, false);
 *   });
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
function create(options) {
  var name = "Local Payment";

  return basicComponentVerification
    .verify({
      name: name,
      client: options.client,
      authorization: options.authorization,
    })
    .then(function () {
      return createDeferredClient.create({
        authorization: options.authorization,
        client: options.client,
        debug: options.debug,
        assetsUrl: createAssetsUrl.create(options.authorization),
        name: name,
      });
    })
    .then(function (client) {
      var localPaymentInstance;
      var config = client.getConfiguration();

      options.client = client;

      if (config.gatewayConfiguration.paypalEnabled !== true) {
        return Promise.reject(
          new BraintreeError(errors.LOCAL_PAYMENT_NOT_ENABLED)
        );
      }

      analytics.sendEvent(client, "local-payment.initialized");

      localPaymentInstance = new LocalPayment(options);

      return localPaymentInstance._initialize();
    });
}

module.exports = {
  create: wrapPromise(create),
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION,
};

},{"../lib/analytics":119,"../lib/basic-component-verification":122,"../lib/braintree-error":124,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./external/local-payment":163,"./shared/errors":165,"@braintree/wrap-promise":43}],165:[function(_dereq_,module,exports){
"use strict";

/**
 * @name BraintreeError.LocalPayment - Creation Error Codes
 * @description Errors that occur when [creating the Local Payment component](./module-braintree-web_local-payment.html#.create).
 * @property {MERCHANT} LOCAL_PAYMENT_NOT_ENABLED Occurs when Local Payment is not enabled on the Braintree control panel.
 */

/**
 * @name BraintreeError.LocalPayment - startPayment Error Codes
 * @description Errors that occur when using the [`startPayment` method](./LocalPayment.html#startPayment).
 * @property {MERCHANT} LOCAL_PAYMENT_START_PAYMENT_MISSING_REQUIRED_OPTION Occurs when a startPayment is missing a required option.
 * @property {MERCHANT} LOCAL_PAYMENT_ALREADY_IN_PROGRESS Occurs when a startPayment call is already in progress.
 * @property {MERCHANT} LOCAL_PAYMENT_INVALID_PAYMENT_OPTION Occurs when a startPayment call has an invalid option.
 * @property {NETWORK} LOCAL_PAYMENT_START_PAYMENT_FAILED Occurs when a startPayment call fails.
 * @property {NETWORK} LOCAL_PAYMENT_TOKENIZATION_FAILED Occurs when a startPayment call fails to tokenize the result from authorization.
 * @property {CUSTOMER} LOCAL_PAYMENT_CANCELED Occurs when the customer cancels the Local Payment.
 * @property {CUSTOMER} LOCAL_PAYMENT_WINDOW_CLOSED Occurs when the customer closes the Local Payment window.
 * @property {MERCHANT} LOCAL_PAYMENT_WINDOW_OPEN_FAILED Occurs when the Local Payment window fails to open. Usually because `startPayment` was not called as a direct result of a user action.
 */

var BraintreeError = _dereq_("../../lib/braintree-error");

module.exports = {
  LOCAL_PAYMENT_NOT_ENABLED: {
    type: BraintreeError.types.MERCHANT,
    code: "LOCAL_PAYMENT_NOT_ENABLED",
    message: "LocalPayment is not enabled for this merchant.",
  },
  LOCAL_PAYMENT_ALREADY_IN_PROGRESS: {
    type: BraintreeError.types.MERCHANT,
    code: "LOCAL_PAYMENT_ALREADY_IN_PROGRESS",
    message: "LocalPayment payment is already in progress.",
  },
  LOCAL_PAYMENT_CANCELED: {
    type: BraintreeError.types.CUSTOMER,
    code: "LOCAL_PAYMENT_CANCELED",
    message: "Customer canceled the LocalPayment before authorizing.",
  },
  LOCAL_PAYMENT_WINDOW_CLOSED: {
    type: BraintreeError.types.CUSTOMER,
    code: "LOCAL_PAYMENT_WINDOW_CLOSED",
    message: "Customer closed LocalPayment window before authorizing.",
  },
  LOCAL_PAYMENT_WINDOW_OPEN_FAILED: {
    type: BraintreeError.types.MERCHANT,
    code: "LOCAL_PAYMENT_WINDOW_OPEN_FAILED",
    message:
      "LocalPayment window failed to open; make sure startPayment was called in response to a user action.",
  },
  LOCAL_PAYMENT_START_PAYMENT_FAILED: {
    type: BraintreeError.types.NETWORK,
    code: "LOCAL_PAYMENT_START_PAYMENT_FAILED",
    message: "LocalPayment startPayment failed.",
  },
  LOCAL_PAYMENT_START_PAYMENT_MISSING_REQUIRED_OPTION: {
    type: BraintreeError.types.MERCHANT,
    code: "LOCAL_PAYMENT_START_PAYMENT_MISSING_REQUIRED_OPTION",
    message: "Missing required option for startPayment.",
  },
  LOCAL_PAYMENT_START_PAYMENT_DEFERRED_PAYMENT_FAILED: {
    type: BraintreeError.types.UNKNOWN,
    code: "LOCAL_PAYMENT_START_PAYMENT_DEFERRED_PAYMENT_FAILED",
    message: "LocalPayment startPayment deferred payment failed.",
  },
  LOCAL_PAYMENT_TOKENIZATION_FAILED: {
    type: BraintreeError.types.NETWORK,
    code: "LOCAL_PAYMENT_TOKENIZATION_FAILED",
    message: "Could not tokenize user's local payment method.",
  },
  LOCAL_PAYMENT_INVALID_PAYMENT_OPTION: {
    type: BraintreeError.types.MERCHANT,
    code: "LOCAL_PAYMENT_INVALID_PAYMENT_OPTION",
    message: "Local payment options are invalid.",
  },
};

},{"../../lib/braintree-error":124}],166:[function(_dereq_,module,exports){
"use strict";

var frameService = _dereq_("../../lib/frame-service/external");
var BraintreeError = _dereq_("../../lib/braintree-error");
var errors = _dereq_("../shared/errors");
var VERSION = "3.101.3";
var methods = _dereq_("../../lib/methods");
var wrapPromise = _dereq_("@braintree/wrap-promise");
var analytics = _dereq_("../../lib/analytics");
var convertMethodsToError = _dereq_("../../lib/convert-methods-to-error");
var convertToBraintreeError = _dereq_("../../lib/convert-to-braintree-error");
var constants = _dereq_("../shared/constants");

var INTEGRATION_TIMEOUT_MS =
  _dereq_("../../lib/constants").INTEGRATION_TIMEOUT_MS;

/**
 * Masterpass Address object.
 * @typedef {object} Masterpass~Address
 * @property {string} countryCodeAlpha2 The customer's country code.
 * @property {string} extendedAddress The customer's extended address.
 * @property {string} locality The customer's locality.
 * @property {string} postalCode The customer's postal code.
 * @property {string} region The customer's region.
 * @property {string} streetAddress The customer's street address.
 */

/**
 * @typedef {object} Masterpass~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {string} description The human readable description.
 * @property {string} type The payment method type, always `MasterpassCard`.
 * @property {object} details Additional account details.
 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
 * @property {string} details.lastFour Last four digits of card number.
 * @property {string} details.lastTwo Last two digits of card number.
 * @property {object} contact The customer's contact information.
 * @property {string} contact.firstName The customer's first name.
 * @property {string} contact.lastName The customer's last name.
 * @property {string} contact.phoneNumber The customer's phone number.
 * @property {string} contact.emailAddress The customer's email address.
 * @property {Masterpass~Address} billingAddress The customer's billing address.
 * @property {Masterpass~Address} shippingAddress The customer's shipping address.
 * @property {object} binData Information about the card based on the bin.
 * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.countryOfIssuance The country of issuance.
 * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.issuingBank The issuing bank.
 * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.productId The product id.
 */

/**
 * @class
 * @param {object} options see {@link module:braintree-web/masterpass.create|masterpass.create}
 * @description <strong>You cannot use this constructor directly. Use {@link module:braintree-web/masterpass.create|braintree.masterpass.create} instead.</strong>
 * @classdesc This class represents an Masterpass component. Instances of this class have methods for launching a new window to process a transaction with Masterpass.
 */
function Masterpass(options) {
  var configuration = options.client.getConfiguration();

  this._client = options.client;
  this._assetsUrl =
    configuration.gatewayConfiguration.assetsUrl + "/web/" + VERSION;
  this._isDebug = configuration.isDebug;
  this._authInProgress = false;
  if (
    window.popupBridge &&
    typeof window.popupBridge.getReturnUrlPrefix === "function"
  ) {
    this._callbackUrl = window.popupBridge.getReturnUrlPrefix() + "return";
  } else {
    this._callbackUrl =
      this._assetsUrl +
      "/html/redirect-frame" +
      (this._isDebug ? "" : ".min") +
      ".html";
  }
}

Masterpass.prototype._initialize = function () {
  var self = this;

  return new Promise(function (resolve) {
    var failureTimeout = setTimeout(function () {
      analytics.sendEvent(self._client, "masterpass.load.timed-out");
    }, INTEGRATION_TIMEOUT_MS);

    frameService.create(
      {
        name: constants.LANDING_FRAME_NAME,
        height: constants.POPUP_HEIGHT,
        width: constants.POPUP_WIDTH,
        dispatchFrameUrl:
          self._assetsUrl +
          "/html/dispatch-frame" +
          (self._isDebug ? "" : ".min") +
          ".html",
        openFrameUrl:
          self._assetsUrl +
          "/html/masterpass-landing-frame" +
          (self._isDebug ? "" : ".min") +
          ".html",
      },
      function (service) {
        self._frameService = service;
        clearTimeout(failureTimeout);
        analytics.sendEvent(self._client, "masterpass.load.succeeded");
        resolve(self);
      }
    );
  });
};

/**
 * Launches the Masterpass flow and returns a nonce payload. Only one Masterpass flow should be active at a time. One way to achieve this is to disable your Masterpass button while the flow is open.
 *
 * Braintree will apply these properties in `options.config`. Merchants should not override these values, except for advanced usage.
 *  - `environment`
 *  - `requestToken`
 *  - `callbackUrl`
 *  - `merchantCheckoutId`
 *  - `allowedCardTypes`
 *  - `version`
 *
 * @public
 * @param {object} options All options for initiating the Masterpass payment flow.
 * @param {string} options.currencyCode The currency code to process the payment.
 * @param {string} options.subtotal The amount to authorize for the transaction.
 * @param {object} [options.config] All configuration parameters accepted by Masterpass lightbox, except `function` data type. These options will override the values set by Braintree server. Please see {@link Masterpass Lightbox Parameters|https://developer.mastercard.com/page/masterpass-lightbox-parameters} for more information.
 * @param {object} [options.frameOptions] Used to configure the window that contains the Masterpass login.
 * @param {number} [options.frameOptions.width] Popup width to be used instead of default value (450px).
 * @param {number} [options.frameOptions.height] Popup height to be used instead of default value (660px).
 * @param {number} [options.frameOptions.top] The top position of the popup window to be used instead of default value, that is calculated based on provided height, and parent window size.
 * @param {number} [options.frameOptions.left] The left position to the popup window to be used instead of default value, that is calculated based on provided width, and parent window size.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link Masterpass~tokenizePayload|tokenizePayload}. If no callback is provided, the method will return a Promise that resolves with a {@link Masterpass~tokenizePayload|tokenizePayload}.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * button.addEventListener('click', function () {
 *   // Disable the button so that we don't attempt to open multiple popups.
 *   button.setAttribute('disabled', 'disabled');
 *
 *   // Because tokenize opens a new window, this must be called
 *   // as a result of a user action, such as a button click.
 *   masterpassInstance.tokenize({
 *     currencyCode: 'USD',
 *     subtotal: '10.00'
 *   }).then(function (payload) {
 *     button.removeAttribute('disabled');
 *     // Submit payload.nonce to your server
 *   }).catch(function (tokenizeError) {
 *     button.removeAttribute('disabled');
 *     // Handle flow errors or premature flow closure
 *
 *     switch (tokenizeErr.code) {
 *       case 'MASTERPASS_POPUP_CLOSED':
 *         console.error('Customer closed Masterpass popup.');
 *         break;
 *       case 'MASTERPASS_ACCOUNT_TOKENIZATION_FAILED':
 *         console.error('Masterpass tokenization failed. See details:', tokenizeErr.details);
 *         break;
 *       case 'MASTERPASS_FLOW_FAILED':
 *         console.error('Unable to initialize Masterpass flow. Are your options correct?', tokenizeErr.details);
 *         break;
 *       default:
 *         console.error('Error!', tokenizeErr);
 *     }
 *   });
 * });
 */
Masterpass.prototype.tokenize = function (options) {
  var self = this;

  if (!options || hasMissingOption(options)) {
    return Promise.reject(
      new BraintreeError(errors.MASTERPASS_TOKENIZE_MISSING_REQUIRED_OPTION)
    );
  }

  if (self._authInProgress) {
    return Promise.reject(
      new BraintreeError(errors.MASTERPASS_TOKENIZATION_ALREADY_IN_PROGRESS)
    );
  }

  return new Promise(function (resolve, reject) {
    self._navigateFrameToLoadingPage(options).catch(reject);
    // This MUST happen after _navigateFrameToLoadingPage for Metro browsers to work.
    self._frameService.open(
      options.frameOptions,
      self._createFrameOpenHandler(resolve, reject)
    );
  });
};

Masterpass.prototype._navigateFrameToLoadingPage = function (options) {
  var self = this;

  this._authInProgress = true;

  return this._client
    .request({
      method: "post",
      endpoint: "masterpass/request_token",
      data: {
        requestToken: {
          originUrl: window.location.protocol + "//" + window.location.hostname,
          subtotal: options.subtotal,
          currencyCode: options.currencyCode,
          callbackUrl: this._callbackUrl,
        },
      },
    })
    .then(function (response) {
      var redirectUrl =
        self._assetsUrl +
        "/html/masterpass-loading-frame" +
        (self._isDebug ? "" : ".min") +
        ".html?";
      var gatewayConfiguration =
        self._client.getConfiguration().gatewayConfiguration;
      var config = options.config || {};
      var queryParams;

      queryParams = {
        environment: gatewayConfiguration.environment,
        requestToken: response.requestToken,
        callbackUrl: self._callbackUrl,
        merchantCheckoutId: gatewayConfiguration.masterpass.merchantCheckoutId,
        allowedCardTypes: gatewayConfiguration.masterpass.supportedNetworks,
        version: constants.MASTERPASS_VERSION,
      };

      Object.keys(config).forEach(function (key) {
        if (typeof config[key] !== "function") {
          queryParams[key] = config[key];
        }
      });

      redirectUrl += Object.keys(queryParams)
        .map(function (key) {
          return key + "=" + queryParams[key];
        })
        .join("&");

      self._frameService.redirect(redirectUrl);
    })
    .catch(function (err) {
      var status = err.details && err.details.httpStatus;

      self._closeWindow();

      if (status === 422) {
        return Promise.reject(
          convertToBraintreeError(err, errors.MASTERPASS_INVALID_PAYMENT_OPTION)
        );
      }

      return Promise.reject(
        convertToBraintreeError(err, errors.MASTERPASS_FLOW_FAILED)
      );
    });
};

Masterpass.prototype._createFrameOpenHandler = function (resolve, reject) {
  var self = this;

  if (window.popupBridge) {
    return function (popupBridgeErr, payload) {
      self._authInProgress = false;

      if (popupBridgeErr) {
        analytics.sendEvent(
          self._client,
          "masterpass.tokenization.closed-popupbridge.by-user"
        );
        reject(
          convertToBraintreeError(
            popupBridgeErr,
            errors.MASTERPASS_POPUP_CLOSED
          )
        );

        return;
      } else if (!payload.queryItems) {
        analytics.sendEvent(
          self._client,
          "masterpass.tokenization.failed-popupbridge"
        );
        reject(new BraintreeError(errors.MASTERPASS_FLOW_FAILED));

        return;
      }

      self._tokenizeMasterpass(payload.queryItems).then(resolve).catch(reject);
    };
  }

  return function (frameServiceErr, payload) {
    if (frameServiceErr) {
      self._authInProgress = false;

      if (frameServiceErr.code === "FRAME_SERVICE_FRAME_CLOSED") {
        analytics.sendEvent(
          self._client,
          "masterpass.tokenization.closed.by-user"
        );
        reject(new BraintreeError(errors.MASTERPASS_POPUP_CLOSED));

        return;
      }

      if (
        frameServiceErr.code &&
        frameServiceErr.code.indexOf("FRAME_SERVICE_FRAME_OPEN_FAILED") > -1
      ) {
        analytics.sendEvent(
          self._client,
          "masterpass.tokenization.failed.to-open"
        );
        reject(
          new BraintreeError({
            code: errors.MASTERPASS_POPUP_OPEN_FAILED.code,
            type: errors.MASTERPASS_POPUP_OPEN_FAILED.type,
            message: errors.MASTERPASS_POPUP_OPEN_FAILED.message,
            details: {
              originalError: frameServiceErr,
            },
          })
        );

        return;
      }

      analytics.sendEvent(self._client, "masterpass.tokenization.failed");
      self._closeWindow();
      reject(
        convertToBraintreeError(frameServiceErr, errors.MASTERPASS_FLOW_FAILED)
      );

      return;
    }

    self._tokenizeMasterpass(payload).then(resolve).catch(reject);
  };
};

Masterpass.prototype._tokenizeMasterpass = function (payload) {
  var self = this;

  if (payload.mpstatus !== "success") {
    analytics.sendEvent(self._client, "masterpass.tokenization.closed.by-user");
    self._closeWindow();

    return Promise.reject(new BraintreeError(errors.MASTERPASS_POPUP_CLOSED));
  }

  if (isMissingRequiredPayload(payload)) {
    analytics.sendEvent(
      self._client,
      "masterpass.tokenization.closed.missing-payload"
    );
    self._closeWindow();

    return Promise.reject(
      new BraintreeError(errors.MASTERPASS_POPUP_MISSING_REQUIRED_PARAMETERS)
    );
  }

  return self._client
    .request({
      endpoint: "payment_methods/masterpass_cards",
      method: "post",
      data: {
        masterpassCard: {
          checkoutResourceUrl: payload.checkout_resource_url,
          requestToken: payload.oauth_token,
          verifierToken: payload.oauth_verifier,
        },
      },
    })
    .then(function (response) {
      self._closeWindow();
      if (window.popupBridge) {
        analytics.sendEvent(
          self._client,
          "masterpass.tokenization.success-popupbridge"
        );
      } else {
        analytics.sendEvent(self._client, "masterpass.tokenization.success");
      }

      return response.masterpassCards[0];
    })
    .catch(function (tokenizeErr) {
      self._closeWindow();
      if (window.popupBridge) {
        analytics.sendEvent(
          self._client,
          "masterpass.tokenization.failed-popupbridge"
        );
      } else {
        analytics.sendEvent(self._client, "masterpass.tokenization.failed");
      }

      return Promise.reject(
        convertToBraintreeError(
          tokenizeErr,
          errors.MASTERPASS_ACCOUNT_TOKENIZATION_FAILED
        )
      );
    });
};

function isMissingRequiredPayload(payload) {
  return [
    payload.oauth_verifier,
    payload.oauth_token,
    payload.checkout_resource_url,
  ].some(function (element) {
    return element == null || element === "null";
  });
}

Masterpass.prototype._closeWindow = function () {
  this._authInProgress = false;
  this._frameService.close();
};

/**
 * Cleanly tear down anything set up by {@link module:braintree-web/masterpass.create|create}.
 * @public
 * @param {callback} [callback] Called on completion. If no callback is provided, `teardown` returns a promise.
 * @example
 * masterpassInstance.teardown();
 * @example <caption>With callback</caption>
 * masterpassInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
Masterpass.prototype.teardown = function () {
  var self = this;

  return new Promise(function (resolve) {
    self._frameService.teardown();

    convertMethodsToError(self, methods(Masterpass.prototype));

    analytics.sendEvent(self._client, "masterpass.teardown-completed");

    resolve();
  });
};

function hasMissingOption(options) {
  var i, option;

  for (i = 0; i < constants.REQUIRED_OPTIONS_FOR_TOKENIZE.length; i++) {
    option = constants.REQUIRED_OPTIONS_FOR_TOKENIZE[i];

    if (!options.hasOwnProperty(option)) {
      return true;
    }
  }

  return false;
}

module.exports = wrapPromise.wrapPrototype(Masterpass);

},{"../../lib/analytics":119,"../../lib/braintree-error":124,"../../lib/constants":126,"../../lib/convert-methods-to-error":127,"../../lib/convert-to-braintree-error":128,"../../lib/frame-service/external":139,"../../lib/methods":155,"../shared/constants":169,"../shared/errors":170,"@braintree/wrap-promise":43}],167:[function(_dereq_,module,exports){
"use strict";
/** @module braintree-web/masterpass
 * @description Processes Masterpass. *This component is currently in beta and is subject to change.*
 */

var BraintreeError = _dereq_("../lib/braintree-error");
var basicComponentVerification = _dereq_("../lib/basic-component-verification");
var browserDetection = _dereq_("./shared/browser-detection");
var Masterpass = _dereq_("./external/masterpass");
var createDeferredClient = _dereq_("../lib/create-deferred-client");
var createAssetsUrl = _dereq_("../lib/create-assets-url");
var VERSION = "3.101.3";
var errors = _dereq_("./shared/errors");
var wrapPromise = _dereq_("@braintree/wrap-promise");

/**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {callback} [callback] The second argument, `data`, is the {@link Masterpass} instance. If no callback is passed in, the create function returns a promise that resolves the {@link Masterpass} instance.
 * @example
 * braintree.masterpass.create({
 *   client: clientInstance
 * }, function (createErr, masterpassInstance) {
 *   if (createErr) {
 *     if (createErr.code === 'MASTERPASS_BROWSER_NOT_SUPPORTED') {
 *       console.error('This browser is not supported.');
 *     } else {
 *       console.error('Error!', createErr);
 *     }
 *     return;
 *   }
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
function create(options) {
  var name = "Masterpass";

  return basicComponentVerification
    .verify({
      name: name,
      client: options.client,
      authorization: options.authorization,
    })
    .then(function () {
      if (!isSupported()) {
        return Promise.reject(
          new BraintreeError(errors.MASTERPASS_BROWSER_NOT_SUPPORTED)
        );
      }

      return Promise.resolve();
    })
    .then(function () {
      return createDeferredClient.create({
        authorization: options.authorization,
        client: options.client,
        debug: options.debug,
        assetsUrl: createAssetsUrl.create(options.authorization),
        name: name,
      });
    })
    .then(function (client) {
      var masterpassInstance, configuration;

      options.client = client;
      configuration = options.client.getConfiguration().gatewayConfiguration;

      if (!configuration.masterpass) {
        return Promise.reject(
          new BraintreeError(errors.MASTERPASS_NOT_ENABLED)
        );
      }

      masterpassInstance = new Masterpass(options);

      return masterpassInstance._initialize();
    });
}

/**
 * @static
 * @function isSupported
 * @description Returns true if Masterpass supports this browser.
 * @example
 * if (braintree.masterpass.isSupported()) {
 *   // Add Masterpass button to the page
 * } else {
 *   // Hide Masterpass payment option
 * }
 * @returns {Boolean} Returns true if Masterpass supports this browser.
 */
function isSupported() {
  return Boolean(window.popupBridge || browserDetection.supportsPopups());
}

module.exports = {
  create: wrapPromise(create),
  isSupported: isSupported,
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION,
};

},{"../lib/basic-component-verification":122,"../lib/braintree-error":124,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./external/masterpass":166,"./shared/browser-detection":168,"./shared/errors":170,"@braintree/wrap-promise":43}],168:[function(_dereq_,module,exports){
"use strict";

module.exports = {
  supportsPopups: _dereq_("@braintree/browser-detection/supports-popups"),
};

},{"@braintree/browser-detection/supports-popups":32}],169:[function(_dereq_,module,exports){
"use strict";

module.exports = {
  LANDING_FRAME_NAME: "braintreemasterpasslanding",
  POPUP_WIDTH: 450,
  POPUP_HEIGHT: 660,
  MASTERPASS_VERSION: "v6",
  REQUIRED_OPTIONS_FOR_TOKENIZE: ["subtotal", "currencyCode"],
};

},{}],170:[function(_dereq_,module,exports){
"use strict";

/**
 * @name BraintreeError.Masterpass - Creation Error Codes
 * @description Errors that occur when [creating the Masterpass component](./module-braintree-web_masterpass#.create).
 * @property {CUSTOMER} MASTERPASS_BROWSER_NOT_SUPPORTED Occurs when browser is not a supported browser for Masterpass.
 * @property {MERCHANT} MASTERPASS_NOT_ENABLED Occurs when Masterpass is not enabled in the Braintree control panel.
 */

/**
 * @name BraintreeError.Masterpass - Tokenize Error Codes
 * @description Errors that occur when [tokenizing](./Masterpass.html#tokenize).
 * @property {MERCHANT} MASTERPASS_TOKENIZE_MISSING_REQUIRED_OPTION Occurs when tokenize is called without a required option.
 * @property {MERCHANT} MASTERPASS_TOKENIZATION_ALREADY_IN_PROGRESS Occurs if tokenization flow is initialized while another flow is already in progress.
 * @property {NETWORK} MASTERPASS_ACCOUNT_TOKENIZATION_FAILED Occurs when tokenization of Masterpass details fails.
 * @property {MERCHANT} MASTERPASS_POPUP_OPEN_FAILED Occurs when the popup fails to open.
 * @property {MERCHANT} MASTERPASS_POPUP_MISSING_REQUIRED_PARAMETERS Occurs when Masterpass is missing required parameters for tokenization.
 * @property {CUSTOMER} MASTERPASS_POPUP_CLOSED Occurs when the popup is closed by the customer.
 * @property {MERCHANT} MASTERPASS_INVALID_PAYMENT_OPTION Occurs when an invalid payment option is used to tokenize Masterpass.
 * @property {NETWORK} MASTERPASS_FLOW_FAILED Occurs when an error is returned from request to tokenize.
 */

var BraintreeError = _dereq_("../../lib/braintree-error");

module.exports = {
  MASTERPASS_BROWSER_NOT_SUPPORTED: {
    type: BraintreeError.types.CUSTOMER,
    code: "MASTERPASS_BROWSER_NOT_SUPPORTED",
    message: "Browser is not supported.",
  },
  MASTERPASS_NOT_ENABLED: {
    type: BraintreeError.types.MERCHANT,
    code: "MASTERPASS_NOT_ENABLED",
    message: "Masterpass is not enabled for this merchant.",
  },
  MASTERPASS_TOKENIZE_MISSING_REQUIRED_OPTION: {
    type: BraintreeError.types.MERCHANT,
    code: "MASTERPASS_TOKENIZE_MISSING_REQUIRED_OPTION",
    message: "Missing required option for tokenize.",
  },
  MASTERPASS_TOKENIZATION_ALREADY_IN_PROGRESS: {
    type: BraintreeError.types.MERCHANT,
    code: "MASTERPASS_TOKENIZATION_ALREADY_IN_PROGRESS",
    message: "Masterpass tokenization is already in progress.",
  },
  MASTERPASS_ACCOUNT_TOKENIZATION_FAILED: {
    type: BraintreeError.types.NETWORK,
    code: "MASTERPASS_ACCOUNT_TOKENIZATION_FAILED",
    message: "Could not tokenize user's Masterpass account.",
  },
  MASTERPASS_POPUP_OPEN_FAILED: {
    type: BraintreeError.types.MERCHANT,
    code: "MASTERPASS_POPUP_OPEN_FAILED",
    message:
      "Masterpass popup failed to open. Make sure to tokenize in response to a user action, such as a click.",
  },
  MASTERPASS_POPUP_MISSING_REQUIRED_PARAMETERS: {
    type: BraintreeError.types.MERCHANT,
    code: "MASTERPASS_POPUP_MISSING_REQUIRED_PARAMETERS",
    message:
      "Masterpass popup failed to return all required parameters needed to continue tokenization.",
  },
  MASTERPASS_POPUP_CLOSED: {
    type: BraintreeError.types.CUSTOMER,
    code: "MASTERPASS_POPUP_CLOSED",
    message: "Customer closed Masterpass popup before authorizing.",
  },
  MASTERPASS_INVALID_PAYMENT_OPTION: {
    type: BraintreeError.types.MERCHANT,
    code: "MASTERPASS_INVALID_PAYMENT_OPTION",
    message: "Masterpass payment options are invalid.",
  },
  MASTERPASS_FLOW_FAILED: {
    type: BraintreeError.types.NETWORK,
    code: "MASTERPASS_FLOW_FAILED",
    message: "Could not initialize Masterpass flow.",
  },
};

},{"../../lib/braintree-error":124}],171:[function(_dereq_,module,exports){
"use strict";

var analytics = _dereq_("../../lib/analytics");
var assign = _dereq_("../../lib/assign").assign;
var Bus = _dereq_("framebus");
var convertMethodsToError = _dereq_("../../lib/convert-methods-to-error");
var generateGooglePayConfiguration = _dereq_("../../lib/generate-google-pay-configuration");
var iFramer = _dereq_("@braintree/iframer");
var uuid = _dereq_("@braintree/uuid");
var useMin = _dereq_("../../lib/use-min");
var methods = _dereq_("../../lib/methods");
var EventEmitter = _dereq_("@braintree/event-emitter");
var BraintreeError = _dereq_("../../lib/braintree-error");
var VERSION = "3.101.3";
var constants = _dereq_("../shared/constants");
var events = constants.events;
var errors = constants.errors;
var wrapPromise = _dereq_("@braintree/wrap-promise");

/**
 * @typedef {object} PaymentRequestComponent~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {object} details Additional account details.
 * @property {string} details.bin The BIN number of the card..
 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
 * @property {string} details.lastFour Last four digits of card number.
 * @property {string} details.lastTwo Last two digits of card number.
 * @property {object} details.rawPaymentResponse The raw payment response from the payment request, with sensitive card details removed.
 * @property {string} description A human-readable description.
 * @property {string} type The payment method type, `CreditCard` or `AndroidPayCard`.
 * @property {object} binData Information about the card based on the bin.
 * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.countryOfIssuance The country of issuance.
 * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.issuingBank The issuing bank.
 * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.productId The product id.
 */

/**
 * @typedef {object} PaymentRequestComponent~paymentRequestConfiguration
 * @property {object} configuration.details The payment details. For details on this object, see [Google's PaymentRequest API documentation](https://developers.google.com/web/fundamentals/discovery-and-monetization/payment-request/deep-dive-into-payment-request#defining_payment_details).
 * @property {array} [configuration.supportedPaymentMethods] The supported payment methods. If not passed in, the supported payment methods from the merchant account that generated the authorization for the client will be used. For details on this array, see [Google's PaymentRequest API documentation](https://developers.google.com/web/fundamentals/discovery-and-monetization/payment-request/deep-dive-into-payment-request#defining_supported_payment_methods).
 * @property {object} [configuration.options] Additional payment request options. For details on this object, see [Google's PaymentRequest API documentation](https://developers.google.com/web/fundamentals/discovery-and-monetization/payment-request/deep-dive-into-payment-request#defining_options_optional).
 */

/**
 * @typedef {object} PaymentRequestComponent~shippingEventObject
 * @description The event payload sent from {@link PaymentRequestComponent#on|on}.
 * @property {object} target An object which contains data about the event.
 * @property {function} updateWith A method to call with the updated Payment Request details.
 */

/**
 * @name PaymentRequestComponent#on
 * @function
 * @param {string} event The name of the event to which you are subscribing.
 * @param {function} handler A callback to handle the event.
 * @description Subscribes a handler function to a named event. `event` should be {@link PaymentRequestComponent#event:shippingAddressChange|shippingAddressChange} or {@link PaymentRequestComponent#event:shippingOptionChange|shippingOptionChange}. For convenience, you can also listen on `shippingaddresschange` or `shippingoptionchange` to match the event listeners in the [Payment Request API documentation](https://developers.google.com/web/fundamentals/payments/deep-dive-into-payment-request#shipping_in_payment_request_api). Events will emit a {@link PaymentRequestComponent~shippingEventObject|shippingEventObject}.
 * @example
 * <caption>Listening to a Payment Request event, in this case 'shippingAddressChange'</caption>
 * braintree.paymentRequest.create({ ... }, function (createErr, paymentRequestInstance) {
 *   paymentRequestInstance.on('shippingAddressChange', function (event) {
 *     console.log(event.target.shippingAddress);
 *   });
 * });
 * @returns {void}
 */

/**
 * @name PaymentRequestComponent#off
 * @function
 * @param {string} event The name of the event to which you are unsubscribing.
 * @param {function} handler The callback for the event you are unsubscribing from.
 * @description Unsubscribes the handler function to a named event.
 * @example
 * <caption>Subscribing and then unsubscribing from a Payment Request event, in this case 'shippingAddressChange'</caption>
 * braintree.paymentRequest.create({ ... }, function (createErr, paymentRequestInstance) {
 *   var callback = function (event) {
 *     console.log(event.target.shippingAddress);
 *   };
 *   paymentRequestInstance.on('shippingAddressChange', callback);
 *
 *   // later on
 *   paymentRequestInstance.off('shippingAddressChange', callback);
 * });
 * @returns {void}
 */

/**
 * This event is emitted when the customer selects a shipping address.
 * @event PaymentRequestComponent#shippingAddressChange
 * @type {PaymentRequestComponent~shippingEventObject}
 * @example
 * <caption>Listening to a shipping address change event</caption>
 * braintree.paymentRequest.create({ ... }, function (createErr, paymentRequestInstance) {
 *   paymentRequestInstance.on('shippingAddressChange', function (event) {
 *     // validate event.target.shippingAddress if needed
 *
 *     event.updateWith(paymentRequestDetails);
 *   });
 * });
 */

/**
 * This event is emitted when the customer selects a shipping option.
 * @event PaymentRequestComponent#shippingOptionChange
 * @type {PaymentRequestComponent~shippingEventObject}
 * @example
 * <caption>Listening to a shipping option change event</caption>
 * braintree.paymentRequest.create({ ... }, function (createErr, paymentRequestInstance) {
 *   paymentRequestInstance.on('shippingOptionChange', function (event) {
 *     // validate event.target.shippingOption if needed
 *
 *     paymentRequestDetails.shippingOptions.forEach(function (option) {
 *       option.selected = option.id === event.target.shippingOption;
 *     });
 *
 *     event.updateWith(paymentRequestDetails);
 *   });
 * });
 */

var CARD_TYPE_MAPPINGS = {
  Visa: "visa",
  MasterCard: "mastercard",
  "American Express": "amex",
  "Diners Club": "diners",
  Discover: "discover",
  JCB: "jcb",
  UnionPay: "unionpay",
  Maestro: "maestro",
};

var BRAINTREE_GOOGLE_PAY_MERCHANT_ID = "18278000977346790994";

function composeUrl(assetsUrl, componentId, isDebug) {
  var baseUrl = assetsUrl;

  // endRemoveIf(production)

  return (
    baseUrl +
    "/web/" +
    VERSION +
    "/html/payment-request-frame" +
    useMin(isDebug) +
    ".html#" +
    componentId
  );
}

/**
 * @class PaymentRequestComponent
 * @param {object} options The Payment Request Component {@link module:braintree-web/payment-request.create create} options.
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/payment-request.create|braintree-web.payment-request.create} instead.</strong>
 *
 * @classdesc This class represents a Payment Request component produced by {@link module:braintree-web/payment-request.create|braintree-web/payment-request.create}. Instances of this class have methods for initializing a Payment Request.
 *
 * **Note:** This component is currently in beta and the API may include breaking changes when upgrading. Please review the [Changelog](https://github.com/braintree/braintree-web/blob/main/CHANGELOG.md) for upgrade steps whenever you upgrade the version of braintree-web.
 */
function PaymentRequestComponent(options) {
  var enabledPaymentMethods = options.enabledPaymentMethods || {};

  EventEmitter.call(this);

  this._componentId = uuid();
  this._client = options.client;
  this._enabledPaymentMethods = {
    basicCard: enabledPaymentMethods.basicCard !== false,
    googlePay: enabledPaymentMethods.googlePay !== false,
  };
  this._googlePayVersion = options.googlePayVersion === 2 ? 2 : 1;
  this._googleMerchantId = BRAINTREE_GOOGLE_PAY_MERCHANT_ID;
  this._supportedPaymentMethods =
    this._constructDefaultSupportedPaymentMethods();
  this._defaultSupportedPaymentMethods = Object.keys(
    this._supportedPaymentMethods
  ).map(
    function (key) {
      return this._supportedPaymentMethods[key];
    }.bind(this)
  );
  this._bus = new Bus({ channel: this._componentId });
}

EventEmitter.createChild(PaymentRequestComponent);

PaymentRequestComponent.prototype._constructDefaultSupportedPaymentMethods =
  function () {
    var configuration = this._client.getConfiguration();
    var androidPayConfiguration = configuration.gatewayConfiguration.androidPay;
    var cardConfiguration = configuration.gatewayConfiguration.creditCards;
    var supportedPaymentMethods = {};

    if (
      this._enabledPaymentMethods.basicCard &&
      cardConfiguration &&
      cardConfiguration.supportedCardTypes.length > 0
    ) {
      supportedPaymentMethods.basicCard = {
        supportedMethods: "basic-card",
        data: {
          supportedNetworks: cardConfiguration.supportedCardTypes.reduce(
            function (types, cardType) {
              if (cardType in CARD_TYPE_MAPPINGS) {
                types.push(CARD_TYPE_MAPPINGS[cardType]);
              }

              return types;
            },
            []
          ),
        },
      };
    }

    if (
      this._enabledPaymentMethods.googlePay &&
      androidPayConfiguration &&
      androidPayConfiguration.enabled
    ) {
      supportedPaymentMethods.googlePay = {
        supportedMethods: "https://google.com/pay",
        data: generateGooglePayConfiguration(
          configuration,
          this._googlePayVersion,
          this._googleMerchantId
        ),
      };
    }

    return supportedPaymentMethods;
  };

PaymentRequestComponent.prototype.initialize = function () {
  var clientConfiguration = this._client.getConfiguration();
  var self = this;

  this._frame = iFramer({
    allowPaymentRequest: true,
    name: "braintree-payment-request-frame",
    class: "braintree-payment-request-frame",
    height: 0,
    width: 0,
    style: {
      position: "absolute",
      left: "-9999px",
    },
    title: "Secure Payment Frame",
  });

  if (this._defaultSupportedPaymentMethods.length === 0) {
    return Promise.reject(
      new BraintreeError(
        errors.PAYMENT_REQUEST_NO_VALID_SUPPORTED_PAYMENT_METHODS
      )
    );
  }

  return new Promise(function (resolve) {
    self._bus.on(events.FRAME_READY, function (reply) {
      reply(self._client);
    });
    self._bus.on(events.FRAME_CAN_MAKE_REQUESTS, function () {
      analytics.sendEvent(self._client, "payment-request.initialized");
      self._bus.on(events.SHIPPING_ADDRESS_CHANGE, function (shippingAddress) {
        var shippingAddressChangeEvent = {
          target: {
            shippingAddress: shippingAddress,
          },
          updateWith: function (paymentDetails) {
            self._bus.emit(events.UPDATE_SHIPPING_ADDRESS, paymentDetails);
          },
        };

        self._emit("shippingAddressChange", shippingAddressChangeEvent);
        self._emit("shippingaddresschange", shippingAddressChangeEvent);
      });
      self._bus.on(events.SHIPPING_OPTION_CHANGE, function (shippingOption) {
        var shippingOptionChangeEvent = {
          target: {
            shippingOption: shippingOption,
          },
          updateWith: function (paymentDetails) {
            self._bus.emit(events.UPDATE_SHIPPING_OPTION, paymentDetails);
          },
        };

        self._emit("shippingOptionChange", shippingOptionChangeEvent);
        self._emit("shippingoptionchange", shippingOptionChangeEvent);
      });
      resolve(self);
    });

    // TODO - We may need to apply the same setTimeout hack that Hosted Fields
    // uses for iframes to load correctly in Edge. See:
    // https://github.com/braintree/braintree-web/blob/0c951e5f9859c606652485de14188b6bd6656677/src/hosted-fields/external/hosted-fields.js#L449-L469
    self._frame.src = composeUrl(
      clientConfiguration.gatewayConfiguration.assetsUrl,
      self._componentId,
      clientConfiguration.isDebug
    );
    document.body.appendChild(self._frame);
  });
};

/**
 * Create an object to pass into tokenize to specify a custom configuration. If no overrides are provided, the default configuration will be provided.
 * @public
 * @param {string} type The supported payment method type. Possible values are `basicCard` and `googlePay`.
 * If no type is provided, the function will throw an error. If the type provided is not an enabled payment method for the merchant account , the function will throw an error.
 * @param {object} [overrides] The configuration overrides for the [data property on the supported payment methods objects](https://developers.google.com/web/fundamentals/payments/deep-dive-into-payment-request). If not passed in, the default configuration for the specified type will be provided. If a property is not provided, the value from the default configuration will be used.
 * @example <caption>Getting the default configuration for a specified type</caption>
 * var configuration = paymentRequestInstance.createSupportedPaymentMethodsConfiguration('basicCard');
 *
 * configuration.supportedMethods; // 'basic-card'
 * configuration.data.supportedNetworks; // ['visa', 'mastercard', 'amex'] <- whatever the supported card networks for the merchant account are
 * @example <caption>Specifying overrides</caption>
 * var configuration = paymentRequestInstance.createSupportedPaymentMethodsConfiguration('basicCard', {
 *   supportedNetworks: ['visa'],
 *   supportedTypes: ['credit', 'debit']
 * });
 *
 * configuration.supportedMethods; // 'basic-card'
 * configuration.data.supportedNetworks; // ['visa']
 * configuration.data.supportedTypes; // ['credit', 'debit']
 * @returns {object} Returns a configuration object for use in the tokenize function.
 */
PaymentRequestComponent.prototype.createSupportedPaymentMethodsConfiguration =
  function (type, overrides) {
    var configuration;

    if (!type) {
      throw new BraintreeError(
        errors.PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_MUST_INCLUDE_TYPE
      );
    }

    if (!this._enabledPaymentMethods[type]) {
      throw new BraintreeError(
        errors.PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_TYPE_NOT_ENABLED
      );
    }

    configuration = assign({}, this._supportedPaymentMethods[type]);
    configuration.data = assign({}, configuration.data, overrides);

    return configuration;
  };

/**
 * Tokenizes a Payment Request
 * @public
 * @param {object} configuration A {@link PaymentRequestComponent~paymentRequestConfiguration|paymentRequestConfiguration}.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link PaymentRequest~paymentPayload|paymentPayload}. If no callback is provided, `tokenize` returns a function that resolves with a {@link PaymentRequestComponent~tokenizePayload|tokenizePayload}.
 * @example
 * paymentRequestInstance.tokenize({
 *   details: {
 *     total: {
 *       label: 'Price',
 *       amount: {
 *         currency: 'USD',
 *         value: '100.00'
 *       }
 *     }
 *   }
 * }).then(function (payload) {
 *   // send payload.nonce to server
 *
 *   // examine the raw response (with card details removed for security) from the payment request
 *   console.log(payload.details.rawPaymentResponse);
 * }).catch(function (err) {
 *   if (err.code === 'PAYMENT_REQUEST_CANCELED') {
 *     // payment request was canceled by user
 *   } else {
 *     // an error occurred while processing
 *   }
 * });
 * @example <caption>Tokenize only Visa cards</caption>
 * var basicCardConfiguration = paymentRequestInstance.createSupportedPaymentMethodsConfiguration('basicCard', {
 *   supportedNetworks: ['visa']
 * };
 *
 * paymentRequestInstance.tokenize({
 *   supportedPaymentMethods: [basicCardConfiguration],
 *   details: {
 *     total: {
 *       label: 'Price',
 *       amount: {
 *         currency: 'USD',
 *         value: '100.00'
 *       }
 *     }
 *   }
 * }).then(function (payload) {
 *   // send payload.nonce to your server
 * });
 * @example <caption>Include payment request options</caption>
 * paymentRequestInstance.tokenize({
 *   details: {
 *     total: {
 *       label: 'Price',
 *       amount: {
 *         currency: 'USD',
 *         value: '100.00'
 *       }
 *     }
 *   },
 *   options: {
 *     requestPayerName: true,
 *     requestPayerPhone: true,
 *     requestPayerEmail: true
 *   }
 * }).then(function (payload) {
 *   // send payload.nonce to your server
 *   // collect additional info from the raw response
 *   console.log(payload.details.rawPaymentResponse);
 * });
 * @example <caption>Request Shipping Information</caption>
 * var shippingOptions = [
 *   {
 *     id: 'economy',
 *     label: 'Economy Shipping (5-7 Days)',
 *     amount: {
 *       currency: 'USD',
 *       value: '0',
 *     },
 *   }, {
 *     id: 'express',
 *     label: 'Express Shipping (2-3 Days)',
 *     amount: {
 *       currency: 'USD',
 *       value: '5',
 *     },
 *   }, {
 *     id: 'next-day',
 *     label: 'Next Day Delivery',
 *     amount: {
 *       currency: 'USD',
 *       value: '12',
 *     },
 *   },
 * ];
 * var paymentDetails = {
 * 	 total: {
 *     label: 'Total',
 *     amount: {
 *       currency: 'USD',
 *       value: '10.00',
 *     }
 *   },
 *   shippingOptions: shippingOptions
 * };
 *
 * paymentRequestInstance.on('shippingAddressChange', function (event) {
 *   // validate shipping address on event.target.shippingAddress
 *   // make changes to the paymentDetails or shippingOptions if necessary
 *
 *   event.updateWith(paymentDetails)
 * });
 *
 * paymentRequestInstance.on('shippingOptionChange', function (event) {
 *   shippingOptions.forEach(function (option) {
 *     option.selected = option.id === event.target.shippingOption;
 *   });
 *
 *   event.updateWith(paymentDetails)
 * });
 *
 * paymentRequestInstance.tokenize({
 *   details: paymentDetails,
 *   options: {
 *     requestShipping: true
 *   }
 * }).then(function (payload) {
 *   // send payload.nonce to your server
 *   // collect shipping information from payload
 *   console.log(payload.details.rawPaymentResponse.shippingAddress);
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
PaymentRequestComponent.prototype.tokenize = function (configuration) {
  var self = this;

  // NEXT_MAJOR_VERSION fail early if a payment method is passed in
  // that the component does not support
  return new Promise(function (resolve, reject) {
    self._bus.emit(
      events.PAYMENT_REQUEST_INITIALIZED,
      {
        supportedPaymentMethods:
          configuration.supportedPaymentMethods ||
          self._defaultSupportedPaymentMethods,
        details: configuration.details,
        options: configuration.options,
      },
      function (response) {
        var rawError = response[0];
        var payload = response[1];

        if (rawError) {
          reject(self._formatTokenizationError(rawError));

          return;
        }

        analytics.sendEvent(self._client, "payment-request.tokenize.succeeded");
        resolve({
          nonce: payload.nonce,
          type: payload.type,
          description: payload.description,
          details: {
            rawPaymentResponse: payload.details.rawPaymentResponse,
            cardType: payload.details.cardType,
            lastFour: payload.details.lastFour,
            lastTwo: payload.details.lastTwo,
          },
          binData: payload.binData,
        });
      }
    );
  });
};

/**
 * Check if the customer can make payments.
 * @public
 * @param {object} configuration A {@link PaymentRequestComponent~paymentRequestConfiguration|paymentRequestConfiguration}.
 * @param {callback} [callback] Called on completion.
 * @example
 * var paymentDetails = {
 * 	 total: {
 *     label: 'Total',
 *     amount: {
 *       currency: 'USD',
 *       value: '10.00',
 *     }
 *   }
 * };
 *
 * paymentRequestInstance.canMakePayment({
 *   details: paymentDetails
 * }).then(function (result) {
 *   if (result) {
 *     // set up payment request button
 *   }
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
PaymentRequestComponent.prototype.canMakePayment = function (configuration) {
  var self = this;
  var unsupportedPaymentMethod;

  // NEXT_MAJOR_VERSION Move this check to component creation
  if (!window.PaymentRequest) {
    analytics.sendEvent(
      self._client,
      "payment-request.can-make-payment.not-available"
    );

    return Promise.resolve(false);
  }

  if (configuration.supportedPaymentMethods) {
    configuration.supportedPaymentMethods.forEach(function (config) {
      var supportedMethods = config.supportedMethods;

      if (!(supportedMethods in constants.SUPPORTED_METHODS)) {
        unsupportedPaymentMethod = supportedMethods;
      }
    });

    if (unsupportedPaymentMethod) {
      return Promise.reject(
        new BraintreeError({
          type: errors.PAYMENT_REQUEST_UNSUPPORTED_PAYMENT_METHOD.type,
          code: errors.PAYMENT_REQUEST_UNSUPPORTED_PAYMENT_METHOD.code,
          message:
            unsupportedPaymentMethod + " is not a supported payment method.",
        })
      );
    }
  }

  return new Promise(function (resolve, reject) {
    self._bus.emit(
      events.CAN_MAKE_PAYMENT,
      {
        supportedPaymentMethods:
          configuration.supportedPaymentMethods ||
          self._defaultSupportedPaymentMethods,
        details: configuration.details,
        options: configuration.options,
      },
      function (response) {
        var error = response[0];
        var payload = response[1];

        if (error) {
          reject(self._formatCanMakePaymentError(error));

          return;
        }

        analytics.sendEvent(
          self._client,
          "payment-request.can-make-payment." + payload
        );

        resolve(payload);
      }
    );
  });
};

/**
 * Cleanly remove anything set up by {@link module:braintree-web/payment-request.create|create}.
 * @public
 * @param {callback} [callback] Called on completion.
 * @example
 * paymentRequestInstance.teardown();
 * @example <caption>With callback</caption>
 * paymentRequestInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
PaymentRequestComponent.prototype.teardown = function () {
  this._bus.teardown();
  this._frame.parentNode.removeChild(this._frame);

  convertMethodsToError(this, methods(PaymentRequestComponent.prototype));

  analytics.sendEvent(this._client, "payment-request.teardown-completed");

  return Promise.resolve();
};

PaymentRequestComponent.prototype._formatTokenizationError = function (error) {
  var formattedError;

  switch (error.name) {
    case "AbortError":
      formattedError = new BraintreeError({
        type: errors.PAYMENT_REQUEST_CANCELED.type,
        code: errors.PAYMENT_REQUEST_CANCELED.code,
        message: errors.PAYMENT_REQUEST_CANCELED.message,
        details: {
          originalError: error,
        },
      });

      analytics.sendEvent(this._client, "payment-request.tokenize.canceled");

      return formattedError;
    case "PAYMENT_REQUEST_INITIALIZATION_FAILED":
      formattedError = new BraintreeError({
        type: errors.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.type,
        code: errors.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.code,
        message: errors.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.message,
        details: {
          originalError: error,
        },
      });
      break;
    case "BRAINTREE_GATEWAY_GOOGLE_PAYMENT_TOKENIZATION_ERROR":
      formattedError = new BraintreeError({
        type: errors.PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE.type,
        code: errors.PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE.code,
        message:
          errors.PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE.message,
        details: {
          originalError: error,
        },
      });
      break;
    case "BRAINTREE_GATEWAY_GOOGLE_PAYMENT_PARSING_ERROR":
      formattedError = new BraintreeError({
        type: errors.PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR.type,
        code: errors.PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR.code,
        message: errors.PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR.message,
        details: {
          originalError: error,
        },
      });
      break;
    default:
      formattedError = new BraintreeError({
        code: errors.PAYMENT_REQUEST_NOT_COMPLETED.code,
        type: error.type || BraintreeError.types.CUSTOMER,
        message: errors.PAYMENT_REQUEST_NOT_COMPLETED.message,
        details: {
          originalError: error,
        },
      });
  }

  analytics.sendEvent(this._client, "payment-request.tokenize.failed");

  return formattedError;
};

PaymentRequestComponent.prototype._formatCanMakePaymentError = function (
  error
) {
  var formattedError;

  switch (error.name) {
    case "PAYMENT_REQUEST_INITIALIZATION_FAILED":
      formattedError = new BraintreeError({
        type: errors.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.type,
        code: errors.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.code,
        message: errors.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.message,
        details: {
          originalError: error,
        },
      });
      break;
    case "NotAllowedError":
      formattedError = new BraintreeError({
        type: errors.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED.type,
        code: errors.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED.code,
        message: errors.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED.message,
        details: {
          originalError: error,
        },
      });
      break;
    default:
      formattedError = new BraintreeError({
        code: errors.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED.code,
        type: errors.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED.type,
        message: errors.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED.message,
        details: {
          originalError: error,
        },
      });
  }

  analytics.sendEvent(this._client, "payment-request.can-make-payment.failed");

  return formattedError;
};

module.exports = wrapPromise.wrapPrototype(PaymentRequestComponent);

},{"../../lib/analytics":119,"../../lib/assign":121,"../../lib/braintree-error":124,"../../lib/convert-methods-to-error":127,"../../lib/generate-google-pay-configuration":149,"../../lib/methods":155,"../../lib/use-min":160,"../shared/constants":173,"@braintree/event-emitter":33,"@braintree/iframer":35,"@braintree/uuid":39,"@braintree/wrap-promise":43,"framebus":52}],172:[function(_dereq_,module,exports){
"use strict";
/**
 * @module braintree-web/payment-request
 * @description A component to integrate with the Payment Request API.
 *
 * **Note:** This component is currently in beta and the API may include breaking changes when upgrading. Please review the [Changelog](https://github.com/braintree/braintree-web/blob/main/CHANGELOG.md) for upgrade steps whenever you upgrade the version of braintree-web.
 * */

var PaymentRequestComponent = _dereq_("./external/payment-request");
var basicComponentVerification = _dereq_("../lib/basic-component-verification");
var createDeferredClient = _dereq_("../lib/create-deferred-client");
var createAssetsUrl = _dereq_("../lib/create-assets-url");
var wrapPromise = _dereq_("@braintree/wrap-promise");
var VERSION = "3.101.3";

/**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {object} [options.enabledPaymentMethods] An object representing which payment methods to display.
 * @param {boolean} [options.enabledPaymentMethods.basicCard=true] Whether or not to display credit card as an option in the Payment Request dialog. If left blank or set to true, credit cards will be displayed in the dialog if the merchant account is set up to process credit cards.
 * @param {boolean} [options.enabledPaymentMethods.googlePay=true] Whether or not to display Google Pay as an option in the Payment Request dialog. If left blank or set to true, Google Pay will be displayed in the dialog if the merchant account is set up to process Google Pay.
 * @param {Number} [options.googlePayVersion=1] Ignored if `options.enabledPaymentMethods.googlePay = false`. If `true`, this option specifies the version of Google Pay to use. Choose either 1 (default) or 2.
 * @param {callback} [callback] The second argument, `data`, is the {@link PaymentRequestComponent} instance. If no callback is provided, `create` returns a promise that resolves with the {@link PaymentRequestComponent} instance.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * if (window.PaymentRequest) {
 *   braintree.paymentRequest.create({
 *     client: clientInstance
 *   }, cb);
 * } else {
 *   // fall back to Hosted Fields if browser does not support Payment Request API
 *   braintree.hostedFields.create(hostedFieldsOptions, cb);
 * }
 * @example <caption>Explicitly turning off credit cards from Payment Request API dialog</caption>
 * braintree.paymentRequest.create({
 *   client: clientInstance,
 *   enabledPaymentMethods: {
 *     googlePay: true,
 *     basicCard: false
 *   }
 * }, cb);
 * @example <caption>Using Google Pay v2 or basic card</caption>
 * braintree.paymentRequest.create({
 *   client: clientInstance,
 *   enabledPaymentMethods: {
 *     basicCard: true,
 *     googlePay: true
 *   },
 *   googlePayVersion: 2
 * }, cb);
 *
 */
function create(options) {
  var name = "Payment Request";

  return basicComponentVerification
    .verify({
      name: name,
      client: options.client,
      authorization: options.authorization,
    })
    .then(function () {
      return createDeferredClient.create({
        authorization: options.authorization,
        client: options.client,
        debug: options.debug,
        assetsUrl: createAssetsUrl.create(options.authorization),
        name: name,
      });
    })
    .then(function (client) {
      var paymentRequestInstance;

      options.client = client;
      paymentRequestInstance = new PaymentRequestComponent(options);

      return paymentRequestInstance.initialize();
    });
}

module.exports = {
  create: wrapPromise(create),
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION,
};

},{"../lib/basic-component-verification":122,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./external/payment-request":171,"@braintree/wrap-promise":43}],173:[function(_dereq_,module,exports){
"use strict";

var enumerate = _dereq_("../../lib/enumerate");
var errors = _dereq_("./errors");

var constants = {};

constants.events = enumerate(
  [
    "CAN_MAKE_PAYMENT",
    "FRAME_READY",
    "FRAME_CAN_MAKE_REQUESTS",
    "PAYMENT_REQUEST_INITIALIZED",
    "SHIPPING_ADDRESS_CHANGE",
    "UPDATE_SHIPPING_ADDRESS",
    "SHIPPING_OPTION_CHANGE",
    "UPDATE_SHIPPING_OPTION",
  ],
  "payment-request:"
);

constants.errors = errors;

constants.SUPPORTED_METHODS = {
  "basic-card": true,
  "https://google.com/pay": true,
};

module.exports = constants;

},{"../../lib/enumerate":134,"./errors":174}],174:[function(_dereq_,module,exports){
"use strict";

/**
 * @name BraintreeError.Payment Request - Creation Error Codes
 * @description Errors that occur when [creating the Payment Request component](./module-braintree-web_payment-request.html#.create).
 * @property {MERCHANT} PAYMENT_REQUEST_NO_VALID_SUPPORTED_PAYMENT_METHODS Occurs when there are no valid payment methods configured.
 */

/**
 * @name BraintreeError.Payment Request - createSupportedPaymentMethodsConfiguration  Error Codes
 * @description Errors that occur when using the [`createSupportedPaymentMethodsConfiguration` method](./PaymentRequestComponent.html#createSupportedPaymentMethodsConfiguration)
 * @property {MERCHANT} PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_MUST_INCLUDE_TYPE Occurs when no type is supplied for method.
 * @property {MERCHANT} PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_TYPE_NOT_ENABLED Occurs when configured type is not enabled.
 */

/**
 * @name BraintreeError.Payment Request - tokenize  Error Codes
 * @description Errors that occur when using the [`tokenize` method](./PaymentRequestComponent.html#tokenize)
 * @property {CUSTOMER} PAYMENT_REQUEST_CANCELED Occurs when customer cancels the Payment Request.
 * @property {MERCHANT} PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED Occurs when the Payment Request is closed do to the options being misconfigured.
 * @property {MERCHANT} PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE Occurs when a Google Payment payment method is unable to be tokenized.
 * @property {UNKNOWN} PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR Occurs when the result of tokenizing a Google Payment payment method could not be parsed.
 * @property {CUSTOMER} PAYMENT_REQUEST_NOT_COMPLETED Occurs when an error prevented the Payment Request from being completed.
 */

/**
 * @name BraintreeError.Payment Request - canMakePayment  Error Codes
 * @description Errors that occur when using the [`canMakePayment` method](./PaymentRequestComponent.html#canMakePayment)
 * @property {MERCHANT} PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED Occurs when the Payment Request is instantiated with misconfigured options.
 * @property {MERCHANT} PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED Occurs when `canMakePayment` results in a `DomException` with a `NotAllowedError`. This usually occurs when `canMakePayment` is called multiple times with different supported payment options.
 * @property {MERCHANT} PAYMENT_REQUEST_UNSUPPORTED_PAYMENT_METHOD Occurs when `canMakePayment` is called with a `supportedPaymentMethods` array that contains a payment method that is not supported by the Braintree SDK.
 * @property {UNKNOWN} PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED Occurs when `canMakePayment` fails for any reason other than a misconfigured Payment Request object.
 */

var BraintreeError = _dereq_("../../lib/braintree-error");

module.exports = {
  PAYMENT_REQUEST_NO_VALID_SUPPORTED_PAYMENT_METHODS: {
    type: BraintreeError.types.MERCHANT,
    code: "PAYMENT_REQUEST_NO_VALID_SUPPORTED_PAYMENT_METHODS",
    message:
      "There are no supported payment methods associated with this account.",
  },
  PAYMENT_REQUEST_CANCELED: {
    type: BraintreeError.types.CUSTOMER,
    code: "PAYMENT_REQUEST_CANCELED",
    message: "Payment request was canceled.",
  },
  PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED: {
    type: BraintreeError.types.MERCHANT,
    code: "PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED",
    message: "Something went wrong when configuring the payment request.",
  },
  PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED: {
    type: BraintreeError.types.UNKNOWN,
    code: "PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED",
    message: "Something went wrong when calling `canMakePayment`",
  },
  PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED: {
    type: BraintreeError.types.MERCHANT,
    code: "PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED",
    message:
      "Something went wrong when calling `canMakePayment`. Most likely, `canMakePayment` was called multiple times with different supportedMethods configurations.",
  },
  PAYMENT_REQUEST_UNSUPPORTED_PAYMENT_METHOD: {
    type: BraintreeError.types.MERCHANT,
    code: "PAYMENT_REQUEST_UNSUPPORTED_PAYMENT_METHOD",
  },
  PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE: {
    type: BraintreeError.types.MERCHANT,
    code: "PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE",
    message: "Something went wrong when tokenizing the Google Pay card.",
  },
  PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR: {
    type: BraintreeError.types.UNKNOWN,
    code: "PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR",
    message: "Something went wrong when tokenizing the Google Pay card.",
  },
  PAYMENT_REQUEST_NOT_COMPLETED: {
    code: "PAYMENT_REQUEST_NOT_COMPLETED",
    message: "Payment request could not be completed.",
  },
  PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_MUST_INCLUDE_TYPE:
    {
      type: BraintreeError.types.MERCHANT,
      code: "PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_MUST_INCLUDE_TYPE",
      message:
        "createSupportedPaymentMethodsConfiguration must include a type parameter.",
    },
  PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_TYPE_NOT_ENABLED:
    {
      type: BraintreeError.types.MERCHANT,
      code: "PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_TYPE_NOT_ENABLED",
      message:
        "createSupportedPaymentMethodsConfiguration type parameter must be valid or enabled.",
    },
};

},{"../../lib/braintree-error":124}],175:[function(_dereq_,module,exports){
"use strict";

/**
 * @name BraintreeError.PayPal Checkout - Creation Error Codes
 * @description Errors that occur when [creating the PayPal Checkout component](./module-braintree-web_paypal-checkout.html#.create).
 * @property {MERCHANT} PAYPAL_NOT_ENABLED Occurs when PayPal is not enabled on the Braintree control panel.
 * @property {MERCHANT} PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED Occurs only when testing in Sandbox, when a PayPal sandbox account is not linked to the merchant account in the Braintree control panel.
 */

/**
 * @name BraintreeError.PayPal Checkout - createPayment Error Codes
 * @description Errors that occur when using the [`createPayment` method](./PayPalCheckout.html#createPayment).
 * @property {MERCHANT} PAYPAL_FLOW_OPTION_REQUIRED Occurs when a required option is missing.
 * @property {MERCHANT} PAYPAL_INVALID_PAYMENT_OPTION Occurs when an option contains an invalid value.
 * @property {NETWORK} PAYPAL_FLOW_FAILED Occurs when something goes wrong when initializing the flow.
 */

/**
 * @name BraintreeError.PayPal Checkout - startVaultInitiatedCheckout Error Codes
 * @description Errors that occur when using the [`startVaultInitiatedCheckout` method](./PayPalCheckout.html#startVaultInitiatedCheckout).
 * @property {MERCHANT} PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED Occurs when a required param is missing when calling the method.
 * @property {MERCHANT} PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED Occurs when PayPal window could not be opened. This often occurs because the call to start the vault initiated flow was not triggered from a click event.
 * @property {CUSTOMER} PAYPAL_START_VAULT_INITIATED_CHECKOUT_CANCELED Occurs when a customer closes the PayPal flow before completion.
 * @property {MERCHANT} PAYPAL_START_VAULT_INITIATED_CHECKOUT_IN_PROGRESS Occurs when the flow is initialized while an authorization is already in progress.
 * @property {NETWORK} PAYPAL_START_VAULT_INITIATED_CHECKOUT_SETUP_FAILED Occurs when something went wrong setting up the flow.
 */

/**
 * @name BraintreeError.PayPal Checkout - tokenizePayment Error Codes
 * @description Errors that occur when using the [`tokenizePayment` method](./PayPalCheckout.html#tokenizePayment).
 * @property {NETWORK} PAYPAL_ACCOUNT_TOKENIZATION_FAILED Occurs when PayPal account could not be tokenized.
 */

/**
 * @name BraintreeError.Paypal Checkout - updatePayment Error Codes
 * @description Errors that occur when using the [`updatePayment` method](./PayPalCheckout.html#updatePayment).
 * @property {MERCHANT} PAYPAL_INVALID_PAYMENT_OPTION Occurs when an option contains an invalid value.
 * @property {MERCHANT} PAYPAL_MISSING_REQUIRED_OPTION Occurs when a required option is missing.
 * @property {NETWORK} PAYPAL_FLOW_FAILED Occurs when something goes wrong when initializing the flow or communicating with the server.
 */
var BraintreeError = _dereq_("../lib/braintree-error");

module.exports = {
  PAYPAL_NOT_ENABLED: {
    type: BraintreeError.types.MERCHANT,
    code: "PAYPAL_NOT_ENABLED",
    message: "PayPal is not enabled for this merchant.",
  },
  PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED: {
    type: BraintreeError.types.MERCHANT,
    code: "PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED",
    message:
      "A linked PayPal Sandbox account is required to use PayPal Checkout in Sandbox. See https://developer.paypal.com/braintree/docs/guides/paypal/testing-go-live#linked-paypal-testing for details on linking your PayPal sandbox with Braintree.",
  },
  PAYPAL_ACCOUNT_TOKENIZATION_FAILED: {
    type: BraintreeError.types.NETWORK,
    code: "PAYPAL_ACCOUNT_TOKENIZATION_FAILED",
    message: "Could not tokenize user's PayPal account.",
  },
  PAYPAL_FLOW_FAILED: {
    type: BraintreeError.types.NETWORK,
    code: "PAYPAL_FLOW_FAILED",
    message: "Could not initialize PayPal flow.",
  },
  PAYPAL_FLOW_OPTION_REQUIRED: {
    type: BraintreeError.types.MERCHANT,
    code: "PAYPAL_FLOW_OPTION_REQUIRED",
    message: "PayPal flow property is invalid or missing.",
  },
  PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED: {
    type: BraintreeError.types.MERCHANT,
    code: "PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED",
  },
  PAYPAL_START_VAULT_INITIATED_CHECKOUT_SETUP_FAILED: {
    type: BraintreeError.types.NETWORK,
    code: "PAYPAL_START_VAULT_INITIATED_CHECKOUT_SETUP_FAILED",
    message: "Something went wrong when setting up the checkout workflow.",
  },
  PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED: {
    type: BraintreeError.types.MERCHANT,
    code: "PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED",
    message:
      "PayPal popup failed to open, make sure to initiate the vault checkout in response to a user action.",
  },
  PAYPAL_START_VAULT_INITIATED_CHECKOUT_CANCELED: {
    type: BraintreeError.types.CUSTOMER,
    code: "PAYPAL_START_VAULT_INITIATED_CHECKOUT_CANCELED",
    message: "Customer closed PayPal popup before authorizing.",
  },
  PAYPAL_START_VAULT_INITIATED_CHECKOUT_IN_PROGRESS: {
    type: BraintreeError.types.MERCHANT,
    code: "PAYPAL_START_VAULT_INITIATED_CHECKOUT_IN_PROGRESS",
    message: "Vault initiated checkout already in progress.",
  },
  PAYPAL_INVALID_PAYMENT_OPTION: {
    type: BraintreeError.types.MERCHANT,
    code: "PAYPAL_INVALID_PAYMENT_OPTION",
    message: "PayPal payment options are invalid.",
  },
  PAYPAL_MISSING_REQUIRED_OPTION: {
    type: BraintreeError.types.MERCHANT,
    code: "PAYPAL_MISSING_REQUIRED_OPTION",
    message: "Missing required option.",
  },
};

},{"../lib/braintree-error":124}],176:[function(_dereq_,module,exports){
"use strict";
/**
 * @module braintree-web/paypal-checkout
 * @description A component to integrate with the [PayPal JS SDK](https://github.com/paypal/paypal-checkout-components).
 */

var basicComponentVerification = _dereq_("../lib/basic-component-verification");
var wrapPromise = _dereq_("@braintree/wrap-promise");
var PayPalCheckout = _dereq_("./paypal-checkout");
var VERSION = "3.101.3";

/**
 * @static
 * @function create
 * @description There are two ways to integrate the PayPal Checkout component. See the [PayPal Checkout constructor documentation](PayPalCheckout.html#PayPalCheckout) for more information and examples.
 *
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {string} [options.merchantAccountId] A non-default merchant account ID to use for tokenization.
 * @param {boolean} [options.autoSetDataUserIdToken=false] Whether or not to render the PayPal SDK button with a customer's vaulted PayPal account. Must be used in conjunction with a Client Token generated with a customer id.
 * @param {callback} [callback] The second argument, `data`, is the {@link PayPalCheckout} instance.
 * @example
 * braintree.client.create({
 *   authorization: 'authorization'
 * }).then(function (clientInstance) {
 *   return braintree.paypalCheckout.create({
 *     client: clientInstance
 *   });
 * }).then(function (paypalCheckoutInstance) {
 *   // set up the PayPal JS SDK
 * }).catch(function (err) {
 *   console.error('Error!', err);
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
function create(options) {
  var name = "PayPal Checkout";

  return basicComponentVerification
    .verify({
      name: name,
      client: options.client,
      authorization: options.authorization,
    })
    .then(function () {
      var instance = new PayPalCheckout(options);

      return instance._initialize(options);
    });
}

/**
 * @static
 * @function isSupported
 * @description Returns true if PayPal Checkout [supports this browser](index.html#browser-support-webviews).
 * @deprecated Previously, this method checked for Popup support in the browser. The PayPal JS SDK now falls back to a modal if popups are not supported.
 * @returns {Boolean} Returns true if PayPal Checkout supports this browser.
 */
function isSupported() {
  return true;
}

module.exports = {
  create: wrapPromise(create),
  isSupported: isSupported,
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION,
};

},{"../lib/basic-component-verification":122,"./paypal-checkout":177,"@braintree/wrap-promise":43}],177:[function(_dereq_,module,exports){
"use strict";

var analytics = _dereq_("../lib/analytics");
var assign = _dereq_("../lib/assign").assign;
var createDeferredClient = _dereq_("../lib/create-deferred-client");
var createAssetsUrl = _dereq_("../lib/create-assets-url");
var ExtendedPromise = _dereq_("@braintree/extended-promise");
var wrapPromise = _dereq_("@braintree/wrap-promise");
var BraintreeError = _dereq_("../lib/braintree-error");
var convertToBraintreeError = _dereq_("../lib/convert-to-braintree-error");
var errors = _dereq_("./errors");
var constants = _dereq_("../paypal/shared/constants");
var frameService = _dereq_("../lib/frame-service/external");
var createAuthorizationData = _dereq_("../lib/create-authorization-data");
var methods = _dereq_("../lib/methods");
var useMin = _dereq_("../lib/use-min");
var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
var querystring = _dereq_("../lib/querystring");
var VERSION = "3.101.3";
var INTEGRATION_TIMEOUT_MS = _dereq_("../lib/constants").INTEGRATION_TIMEOUT_MS;

var REQUIRED_PARAMS_FOR_START_VAULT_INITIATED_CHECKOUT = [
  "amount",
  "currency",
  "vaultInitiatedCheckoutPaymentMethodToken",
];

var PAYPAL_SDK_PRELOAD_URL =
  "https://www.{ENV}paypal.com/smart/buttons/preload";

ExtendedPromise.suppressUnhandledPromiseMessage = true;

/**
 * PayPal Checkout tokenized payload. Returned in {@link PayPalCheckout#tokenizePayment}'s callback as the second argument, `data`.
 * @typedef {object} PayPalCheckout~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {string} type The payment method type, always `PayPalAccount`.
 * @property {object} details Additional PayPal account details.
 * @property {string} details.email User's email address.
 * @property {string} details.payerId User's payer ID, the unique identifier for each PayPal account.
 * @property {string} details.firstName User's given name.
 * @property {string} details.lastName User's surname.
 * @property {?string} details.countryCode User's 2 character country code.
 * @property {?string} details.phone User's phone number (e.g. 555-867-5309).
 * @property {?object} details.shippingAddress User's shipping address details, only available if shipping address is enabled.
 * @property {string} details.shippingAddress.recipientName Recipient of postage.
 * @property {string} details.shippingAddress.line1 Street number and name.
 * @property {string} details.shippingAddress.line2 Extended address.
 * @property {string} details.shippingAddress.city City or locality.
 * @property {string} details.shippingAddress.state State or region.
 * @property {string} details.shippingAddress.postalCode Postal code.
 * @property {string} details.shippingAddress.countryCode 2 character country code (e.g. US).
 * @property {?object} details.billingAddress User's billing address details.
 * Not available to all merchants; [contact support](https://developer.paypal.com/braintree/help) for details on eligibility and enabling this feature.
 * Alternatively, see `shippingAddress` above as an available client option.
 * @property {string} details.billingAddress.line1 Street number and name.
 * @property {string} details.billingAddress.line2 Extended address.
 * @property {string} details.billingAddress.city City or locality.
 * @property {string} details.billingAddress.state State or region.
 * @property {string} details.billingAddress.postalCode Postal code.
 * @property {string} details.billingAddress.countryCode 2 character country code (e.g. US).
 * @property {?object} creditFinancingOffered This property will only be present when the customer pays with PayPal Credit.
 * @property {object} creditFinancingOffered.totalCost This is the estimated total payment amount including interest and fees the user will pay during the lifetime of the loan.
 * @property {string} creditFinancingOffered.totalCost.value An amount defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
 * @property {string} creditFinancingOffered.totalCost.currency 3 letter currency code as defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm).
 * @property {number} creditFinancingOffered.term Length of financing terms in months.
 * @property {object} creditFinancingOffered.monthlyPayment This is the estimated amount per month that the customer will need to pay including fees and interest.
 * @property {string} creditFinancingOffered.monthlyPayment.value An amount defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
 * @property {string} creditFinancingOffered.monthlyPayment.currency 3 letter currency code as defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm).
 * @property {object} creditFinancingOffered.totalInterest Estimated interest or fees amount the payer will have to pay during the lifetime of the loan.
 * @property {string} creditFinancingOffered.totalInterest.value An amount defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
 * @property {string} creditFinancingOffered.totalInterest.currency 3 letter currency code as defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm).
 * @property {boolean} creditFinancingOffered.payerAcceptance Status of whether the customer ultimately was approved for and chose to make the payment using the approved installment credit.
 * @property {boolean} creditFinancingOffered.cartAmountImmutable Indicates whether the cart amount is editable after payer's acceptance on PayPal side.
 */

/**
 * @class
 * @param {object} options see {@link module:braintree-web/paypal-checkout.create|paypal-checkout.create}
 * @classdesc This class represents a PayPal Checkout component that coordinates with the {@link https://developer.paypal.com/docs/checkout/integrate/#2-add-the-paypal-script-to-your-web-page|PayPal SDK}. Instances of this class can generate payment data and tokenize authorized payments.
 *
 * All UI (such as preventing actions on the parent page while authentication is in progress) is managed by the {@link https://developer.paypal.com/docs/checkout/integrate/#2-add-the-paypal-script-to-your-web-page|PayPal SDK}. You must provide your PayPal `client-id` as a query parameter. You can [retrieve this value from the PayPal Dashboard](https://developer.paypal.com/docs/checkout/integrate/#1-get-paypal-rest-api-credentials).
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/paypal-checkout.create|braintree-web.paypal-checkout.create} instead.</strong>
 *
 * #### Integrate Checkout Flow with PayPal SDK
 *
 * You must have [PayPal's script, configured with various query parameters](https://developer.paypal.com/docs/checkout/integrate/#2-add-the-paypal-script-to-your-web-page), loaded on your page:
 *
 * ```html
 * <script src="https://www.paypal.com/sdk/js?client-id=your-sandbox-or-prod-client-id"></script>
 * <div id="paypal-button"></div>
 * ```
 *
 * When passing values in the `createPayment` method, make sure they match the [corresponding parameters in the query parameters for the PayPal SDK script](https://developer.paypal.com/docs/checkout/reference/customize-sdk/).
 *
 * ```javascript
 * braintree.client.create({
 *   authorization: 'authorization'
 * }).then(function (clientInstance) {
 *   return braintree.paypalCheckout.create({
 *     client: clientInstance
 *   });
 * }).then(function (paypalCheckoutInstance) {
 *   return paypal.Buttons({
 *     createOrder: function () {
 *       return paypalCheckoutInstance.createPayment({
 *         flow: 'checkout',
 *         currency: 'USD',
 *         amount: '10.00',
 *         intent: 'capture' // this value must either be `capture` or match the intent passed into the PayPal SDK intent query parameter
 *         // your other createPayment options here
 *       });
 *     },
 *
 *     onApprove: function (data, actions) {
 *       // some logic here before tokenization happens below
 *       return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
 *         // Submit payload.nonce to your server
 *       });
 *     },
 *
 *     onCancel: function () {
 *       // handle case where user cancels
 *     },
 *
 *     onError: function (err) {
 *       // handle case where error occurs
 *     }
 *   }).render('#paypal-button');
 * }).catch(function (err) {
 *  console.error('Error!', err);
 * });
 * ```
 *
 * #### Integrate Vault Flow with PayPal SDK
 *
 * You must have [PayPal's script, configured with various query parameters](https://developer.paypal.com/docs/checkout/integrate/#2-add-the-paypal-script-to-your-web-page), loaded on your page:
 *
 * ```html
 * <script src="https://www.paypal.com/sdk/js?client-id=your-sandbox-or-prod-client-id&vault=true"></script>
 * <div id="paypal-button"></div>
 * ```
 *
 * When passing values in the `createPayment` method, make sure they match the [corresponding parameters in the query parameters for the PayPal SDK script](https://developer.paypal.com/docs/checkout/reference/customize-sdk/).
 *
 * ```javascript
 * braintree.client.create({
 *   authorization: 'authorization'
 * }).then(function (clientInstance) {
 *   return braintree.paypalCheckout.create({
 *     client: clientInstance
 *   });
 * }).then(function (paypalCheckoutInstance) {
 *   return paypal.Buttons({
 *     createBillingAgreement: function () {
 *       return paypalCheckoutInstance.createPayment({
 *         flow: 'vault'
 *         // your other createPayment options here
 *       });
 *     },
 *
 *     onApprove: function (data, actions) {
 *       // some logic here before tokenization happens below
 *       return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
 *         // Submit payload.nonce to your server
 *       });
 *     },
 *
 *     onCancel: function () {
 *       // handle case where user cancels
 *     },
 *
 *     onError: function (err) {
 *       // handle case where error occurs
 *     }
 *   }).render('#paypal-button');
 * }).catch(function (err) {
 *  console.error('Error!', err);
 * });
 * ```
 *
 * #### Integrate with Checkout.js (deprecated PayPal SDK)
 *
 * If you are creating a new PayPal integration, please follow the previous integration guide to use the current version of the PayPal SDK. Use this integration guide only as a reference if you are already integrated with Checkout.js.
 *
 * You must have PayPal's Checkout.js script loaded on your page.
 *
 * ```html
 * <script src="https://www.paypalobjects.com/api/checkout.js" data-version-4 log-level="warn"></script>
 * ```
 *
 * ```javascript
 * braintree.client.create({
 *   authorization: 'authorization'
 * }).then(function (clientInstance) {
 *   return braintree.paypalCheckout.create({
 *     client: clientInstance
 *   });
 * }).then(function (paypalCheckoutInstance) {
 *   return paypal.Button.render({
 *     env: 'production', // or 'sandbox'
 *
 *     payment: function () {
 *       return paypalCheckoutInstance.createPayment({
 *         // your createPayment options here
 *       });
 *     },
 *
 *     onAuthorize: function (data, actions) {
 *       // some logic here before tokenization happens below
 *       return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
 *         // Submit payload.nonce to your server
 *       });
 *     }
 *   }, '#paypal-button');
 * }).catch(function (err) {
 *  console.error('Error!', err);
 * });
 * ```
 */
function PayPalCheckout(options) {
  this._merchantAccountId = options.merchantAccountId;
  // TODO remove this requirement for it to be opt in.
  // This feature is not yet GA, so we're intentionally making
  // it opt in and not publicly documenting it yet. Once it's
  // GA, we can remove the requirement to opt in to it
  this._autoSetDataUserIdToken = Boolean(options.autoSetDataUserIdToken);
}

PayPalCheckout.prototype._initialize = function (options) {
  var config;

  if (options.client) {
    config = options.client.getConfiguration();
    this._authorizationInformation = {
      fingerprint: config.authorizationFingerprint,
      environment: config.gatewayConfiguration.environment,
    };
  } else {
    config = createAuthorizationData(options.authorization);
    this._authorizationInformation = {
      fingerprint: config.attrs.authorizationFingerprint,
      environment: config.environment,
    };
  }

  this._clientPromise = createDeferredClient
    .create({
      authorization: options.authorization,
      client: options.client,
      debug: options.debug,
      assetsUrl: createAssetsUrl.create(options.authorization),
      name: "PayPal Checkout",
    })
    .then(
      function (client) {
        this._configuration = client.getConfiguration();

        // we skip these checks if a merchant account id is
        // passed in, because the default merchant account
        // may not have paypal enabled
        if (!this._merchantAccountId) {
          if (!this._configuration.gatewayConfiguration.paypalEnabled) {
            this._setupError = new BraintreeError(errors.PAYPAL_NOT_ENABLED);
          } else if (
            this._configuration.gatewayConfiguration.paypal
              .environmentNoNetwork === true
          ) {
            this._setupError = new BraintreeError(
              errors.PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED
            );
          }
        }

        if (this._setupError) {
          return Promise.reject(this._setupError);
        }

        analytics.sendEvent(client, "paypal-checkout.initialized");
        this._frameServicePromise = this._setupFrameService(client);

        return client;
      }.bind(this)
    );

  // if client was passed in, let config checks happen before
  // resolving the instance. Otherwise, just resolve the instance
  if (options.client) {
    return this._clientPromise.then(
      function () {
        return this;
      }.bind(this)
    );
  }

  return Promise.resolve(this);
};

PayPalCheckout.prototype._setupFrameService = function (client) {
  var frameServicePromise = new ExtendedPromise();
  var config = client.getConfiguration();
  var timeoutRef = setTimeout(function () {
    analytics.sendEvent(client, "paypal-checkout.frame-service.timed-out");
    frameServicePromise.reject(
      new BraintreeError(
        errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_SETUP_FAILED
      )
    );
  }, INTEGRATION_TIMEOUT_MS);

  this._assetsUrl =
    config.gatewayConfiguration.paypal.assetsUrl + "/web/" + VERSION;
  this._isDebug = config.isDebug;
  // Note: this is using the static landing frame that the deprecated PayPal component builds and uses
  this._loadingFrameUrl =
    this._assetsUrl +
    "/html/paypal-landing-frame" +
    useMin(this._isDebug) +
    ".html";

  frameService.create(
    {
      name: "braintreepaypallanding",
      dispatchFrameUrl:
        this._assetsUrl +
        "/html/dispatch-frame" +
        useMin(this._isDebug) +
        ".html",
      openFrameUrl: this._loadingFrameUrl,
    },
    function (service) {
      this._frameService = service;
      clearTimeout(timeoutRef);

      frameServicePromise.resolve();
    }.bind(this)
  );

  return frameServicePromise;
};

/**
 * @typedef {object} PayPalCheckout~lineItem
 * @property {string} quantity Number of units of the item purchased. This value must be a whole number and can't be negative or zero.
 * @property {string} unitAmount Per-unit price of the item. Can include up to 2 decimal places. This value can't be negative or zero.
 * @property {string} name Item name. Maximum 127 characters.
 * @property {string} kind Indicates whether the line item is a debit (sale) or credit (refund) to the customer. Accepted values: `debit` and `credit`.
 * @property {?string} unitTaxAmount Per-unit tax price of the item. Can include up to 2 decimal places. This value can't be negative or zero.
 * @property {?string} description Item description. Maximum 127 characters.
 * @property {?string} productCode Product or UPC code for the item. Maximum 127 characters.
 * @property {?string} url The URL to product information.
 */

/**
 * @typedef {object} PayPalCheckout~shippingOption
 * @property {string} id A unique ID that identifies a payer-selected shipping option.
 * @property {string} label A description that the payer sees, which helps them choose an appropriate shipping option. For example, `Free Shipping`, `USPS Priority Shipping`, `Expédition prioritaire USPS`, or `USPS yōuxiān fā huò`. Localize this description to the payer's locale.
 * @property {boolean} selected If `selected = true` is specified as part of the API request it represents the shipping option that the payee/merchant expects to be pre-selected for the payer when they first view the shipping options within the PayPal checkout experience. As part of the response if a shipping option has `selected = true` it represents the shipping option that the payer selected during the course of checkout with PayPal. Only 1 `shippingOption` can be set to `selected = true`.
 * @property {string} type The method by which the payer wants to get their items. The possible values are:
 * * `SHIPPING` - The payer intends to receive the items at a specified address.
 * * `PICKUP` - The payer intends to pick up the items at a specified address. For example, a store address.
 * @property {object} amount The shipping cost for the selected option.
 * @property {string} amount.currency The three-character ISO-4217 currency code. PayPal does not support all currencies.
 * @property {string} amount.value The amount the shipping option will cost. Includes the specified number of digits after decimal separator for the ISO-4217 currency code.
 */

/**
 * Creates a PayPal payment ID or billing token using the given options. This is meant to be passed to the PayPal JS SDK.
 * When a {@link callback} is defined, the function returns undefined and invokes the callback with the id to be used with the PayPal JS SDK. Otherwise, it returns a Promise that resolves with the id.
 * @public
 * @param {object} options All options for the PayPalCheckout component.
 * @param {string} options.flow Set to 'checkout' for one-time payment flow, or 'vault' for Vault flow. If 'vault' is used with a client token generated with a customer ID, the PayPal account will be added to that customer as a saved payment method.
 * @param {string} [options.intent=authorize]
 * * `authorize` - Submits the transaction for authorization but not settlement.
 * * `order` - Validates the transaction without an authorization (i.e. without holding funds). Useful for authorizing and capturing funds up to 90 days after the order has been placed. Only available for Checkout flow.
 * * `capture` - Payment will be immediately submitted for settlement upon creating a transaction. `sale` can be used as an alias for this value.
 * @param {boolean} [options.offerCredit=false] Offers PayPal Credit as the default funding instrument for the transaction. If the customer isn't pre-approved for PayPal Credit, they will be prompted to apply for it.
 * @param {(string|number)} [options.amount] The amount of the transaction. Required when using the Checkout flow. Should not include shipping cost.
 * * Supports up to 2 digits after the decimal point
 * @param {string} [options.currency] The currency code of the amount, such as 'USD'. Required when using the Checkout flow.
 * @param {string} [options.displayName] The merchant name displayed inside of the PayPal lightbox; defaults to the company name on your Braintree account
 * @param {boolean} [options.requestBillingAgreement] If `true` and `flow = checkout`, the customer will be prompted to consent to a billing agreement during the checkout flow. This value is ignored when `flow = vault`.
 * @param {object} [options.billingAgreementDetails] When `requestBillingAgreement = true`, allows for details to be set for the billing agreement portion of the flow.
 * @param {string} [options.billingAgreementDetails.description] Description of the billing agreement to display to the customer.
 * @param {string} [options.vaultInitiatedCheckoutPaymentMethodToken] Use the payment method nonce representing a PayPal account with a Billing Agreement ID to create the payment and redirect the customer to select a new financial instrument. This option is only applicable to the `checkout` flow.
 * @param {shippingOption[]} [options.shippingOptions] List of shipping options offered by the payee or merchant to the payer to ship or pick up their items.
 * @param {boolean} [options.enableShippingAddress=false] Returns a shipping address object in {@link PayPal#tokenize}.
 * @param {object} [options.shippingAddressOverride] Allows you to pass a shipping address you have already collected into the PayPal payment flow.
 * @param {string} options.shippingAddressOverride.line1 Street address.
 * @param {string} [options.shippingAddressOverride.line2] Street address (extended).
 * @param {string} options.shippingAddressOverride.city City.
 * @param {string} options.shippingAddressOverride.state State.
 * @param {string} options.shippingAddressOverride.postalCode Postal code.
 * @param {string} options.shippingAddressOverride.countryCode Country.
 * @param {string} [options.shippingAddressOverride.phone] Phone number.
 * @param {string} [options.shippingAddressOverride.recipientName] Recipient's name.
 * @param {boolean} [options.shippingAddressEditable=true] Set to false to disable user editing of the shipping address.
 * @param {string} [options.billingAgreementDescription] Use this option to set the description of the preapproved payment agreement visible to customers in their PayPal profile during Vault flows. Max 255 characters.
 * @param {string} [options.landingPageType] Use this option to specify the PayPal page to display when a user lands on the PayPal site to complete the payment.
 * * `login` - A PayPal account login page is used.
 * * `billing` - A non-PayPal account landing page is used.
 * @param {lineItem[]} [options.lineItems] The {@link PayPalCheckout~lineItem|line items} for this transaction. It can include up to 249 line items.
 * @param {callback} [callback] The second argument is a PayPal `paymentId` or `billingToken` string, depending on whether `options.flow` is `checkout` or `vault`. This is also what is resolved by the promise if no callback is provided.
 * @example
 * // this paypal object is created by the PayPal JS SDK
 * // see https://github.com/paypal/paypal-checkout-components
 * paypal.Buttons({
 *   createOrder: function () {
 *     // when createPayment resolves, it is automatically passed to the PayPal JS SDK
 *     return paypalCheckoutInstance.createPayment({
 *       flow: 'checkout',
 *       amount: '10.00',
 *       currency: 'USD',
 *       intent: 'capture' // this value must either be `capture` or match the intent passed into the PayPal SDK intent query parameter
 *     });
 *   },
 *   // Add other options, e.g. onApproved, onCancel, onError
 * }).render('#paypal-button');
 *
 * @example
 * // shippingOptions are passed to createPayment. You can review the result from onAuthorize to determine which shipping option id was selected.
 * ```javascript
 * braintree.client.create({
 *   authorization: 'authorization'
 * }).then(function (clientInstance) {
 *   return braintree.paypalCheckout.create({
 *     client: clientInstance
 *   });
 * }).then(function (paypalCheckoutInstance) {
 *   return paypal.Button.render({
 *     env: 'production'
 *
 *     payment: function () {
 *       return paypalCheckoutInstance.createPayment({
 *         flow: 'checkout',
 *         amount: '10.00',
 *         currency: 'USD',
 *         shippingOptions: [
 *           {
 *             id: 'UUID-9',
 *             type: 'PICKUP',
 *             label: 'Store Location Five',
 *             selected: true,
 *             amount: {
 *               value: '1.00',
 *               currency: 'USD'
 *             }
 *           },
 *           {
 *             id: 'shipping-speed-fast',
 *             type: 'SHIPPING',
 *             label: 'Fast Shipping',
 *             selected: false,
 *             amount: {
 *               value: '1.00',
 *               currency: 'USD'
 *             }
 *           },
 *           {
 *             id: 'shipping-speed-slow',
 *             type: 'SHIPPING',
 *             label: 'Slow Shipping',
 *             selected: false,
 *             amount: {
 *               value: '1.00',
 *               currency: 'USD'
 *             }
 *           }
 *         ]
 *       });
 *     },
 *
 *     onAuthorize: function (data, actions) {
 *       return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
 *         // Submit payload.nonce to your server
 *       });
 *     }
 *   }, '#paypal-button');
 * }).catch(function (err) {
 *  console.error('Error!', err);
 * });
 * ```
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
PayPalCheckout.prototype.createPayment = function (options) {
  if (!options || !constants.FLOW_ENDPOINTS.hasOwnProperty(options.flow)) {
    return Promise.reject(
      new BraintreeError(errors.PAYPAL_FLOW_OPTION_REQUIRED)
    );
  }

  analytics.sendEvent(this._clientPromise, "paypal-checkout.createPayment");

  return this._createPaymentResource(options).then(function (response) {
    var flowToken, urlParams;

    if (options.flow === "checkout") {
      urlParams = querystring.parse(response.paymentResource.redirectUrl);
      flowToken = urlParams.token;
    } else {
      flowToken = response.agreementSetup.tokenId;
    }

    return flowToken;
  });
};

PayPalCheckout.prototype._createPaymentResource = function (options, config) {
  var self = this;
  var endpoint = "paypal_hermes/" + constants.FLOW_ENDPOINTS[options.flow];

  delete this.intentFromCreatePayment;

  config = config || {};

  if (options.offerCredit === true) {
    analytics.sendEvent(this._clientPromise, "paypal-checkout.credit.offered");
  }

  return this._clientPromise
    .then(function (client) {
      return client
        .request({
          endpoint: endpoint,
          method: "post",
          data: self._formatPaymentResourceData(options, config),
        })
        .then(function (data) {
          self.intentFromCreatePayment = options.intent;

          return data;
        });
    })
    .catch(function (err) {
      var status;

      if (self._setupError) {
        return Promise.reject(self._setupError);
      }

      status = err.details && err.details.httpStatus;

      if (status === 422) {
        return Promise.reject(
          new BraintreeError({
            type: errors.PAYPAL_INVALID_PAYMENT_OPTION.type,
            code: errors.PAYPAL_INVALID_PAYMENT_OPTION.code,
            message: errors.PAYPAL_INVALID_PAYMENT_OPTION.message,
            details: {
              originalError: err,
            },
          })
        );
      }

      return Promise.reject(
        convertToBraintreeError(err, {
          type: errors.PAYPAL_FLOW_FAILED.type,
          code: errors.PAYPAL_FLOW_FAILED.code,
          message: errors.PAYPAL_FLOW_FAILED.message,
        })
      );
    });
};

/**
 * Use this function to update {@link PayPalCheckout~lineItem|line items} and/or {@link PayPalCheckout~shippingOption|shipping options} associated with a PayPalCheckout flow (`paymentId`).
 * When a {@link callback} is defined, this function returns undefined and invokes the callback. The second callback argument, <code>data</code>, is the returned server data. If no callback is provided, `updatePayment` returns a promise that resolves with the server data.
 * @public
 * @param {object} options All options for the PayPalCheckout component.
 * @param {string} options.paymentId This should be PayPal `paymentId`.
 * @param {(string|number)} options.amount The amount of the transaction, including the amount of the selected shipping option, and all `line_items`.
 * * Supports up to 2 decimal digits.
 * @param {string} options.currency The currency code of the amount, such as 'USD'. Required when using the Checkout flow.
 * @param {shippingOption[]} [options.shippingOptions] List of {@link PayPalCheckout~shippingOption|shipping options} offered by the payee or merchant to the payer to ship or pick up their items.
 * @param {lineItem[]} [options.lineItems] The {@link PayPalCheckout~lineItem|line items} for this transaction. It can include up to 249 line items.
 * @param {callback} [callback] The second argument is a PayPal `paymentId` or `billingToken` string, depending on whether `options.flow` is `checkout` or `vault`. This is also what is resolved by the promise if no callback is provided.
 * @example
 * // this paypal object is created by the PayPal JS SDK
 * // see https://github.com/paypal/paypal-checkout-components
 * paypal.Buttons({
 *   createOrder: function () {
 *     // when createPayment resolves, it is automatically passed to the PayPal JS SDK
 *     return paypalCheckoutInstance.createPayment({
 *       //
 *     });
 *   },
 *   onShippingChange: function (data) {
 *     // Examine data and determine if the payment needs to be updated.
 *     // when updatePayment resolves, it is automatically passed to the PayPal JS SDK
 *     return paypalCheckoutInstance.updatePayment({
 *         paymentId: data.paymentId,
 *         amount: '15.00',
 *         currency: 'USD',
 *         shippingOptions: [
 *           {
 *             id: 'shipping-speed-fast',
 *             type: 'SHIPPING',
 *             label: 'Fast Shipping',
 *             selected: true,
 *             amount: {
 *               value: '5.00',
 *               currency: 'USD'
 *             }
 *           },
 *           {
 *             id: 'shipping-speed-slow',
 *             type: 'SHIPPING',
 *             label: 'Slow Shipping',
 *             selected: false,
 *             amount: {
 *               value: '1.00',
 *               currency: 'USD'
 *             }
 *           }
 *         ]
 *     });
 *   }
 *   // Add other options, e.g. onApproved, onCancel, onError
 * }).render('#paypal-button');
 *
 * ```
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
PayPalCheckout.prototype.updatePayment = function (options) {
  var self = this;
  var endpoint = "paypal_hermes/patch_payment_resource";

  if (!options || this._hasMissingOption(options, constants.REQUIRED_OPTIONS)) {
    analytics.sendEvent(
      self._clientPromise,
      "paypal-checkout.updatePayment.missing-options"
    );

    return Promise.reject(
      new BraintreeError(errors.PAYPAL_MISSING_REQUIRED_OPTION)
    );
  }

  if (!this._verifyConsistentCurrency(options)) {
    analytics.sendEvent(
      self._clientPromise,
      "paypal-checkout.updatePayment.inconsistent-currencies"
    );

    return Promise.reject(
      new BraintreeError({
        type: errors.PAYPAL_INVALID_PAYMENT_OPTION.type,
        code: errors.PAYPAL_INVALID_PAYMENT_OPTION.code,
        message: errors.PAYPAL_INVALID_PAYMENT_OPTION.message,
        details: {
          originalError: new Error(
            "One or more shipping option currencies differ from checkout currency."
          ),
        },
      })
    );
  }

  analytics.sendEvent(this._clientPromise, "paypal-checkout.updatePayment");

  return this._clientPromise
    .then(function (client) {
      return client.request({
        endpoint: endpoint,
        method: "post",
        data: self._formatUpdatePaymentData(options),
      });
    })
    .catch(function (err) {
      var status = err.details && err.details.httpStatus;

      if (status === 422) {
        analytics.sendEvent(
          self._clientPromise,
          "paypal-checkout.updatePayment.invalid"
        );

        return Promise.reject(
          new BraintreeError({
            type: errors.PAYPAL_INVALID_PAYMENT_OPTION.type,
            code: errors.PAYPAL_INVALID_PAYMENT_OPTION.code,
            message: errors.PAYPAL_INVALID_PAYMENT_OPTION.message,
            details: {
              originalError: err,
            },
          })
        );
      }

      analytics.sendEvent(
        self._clientPromise,
        "paypal-checkout.updatePayment." + errors.PAYPAL_FLOW_FAILED.code
      );

      return Promise.reject(
        convertToBraintreeError(err, {
          type: errors.PAYPAL_FLOW_FAILED.type,
          code: errors.PAYPAL_FLOW_FAILED.code,
          message: errors.PAYPAL_FLOW_FAILED.message,
        })
      );
    });
};

/**
 * Initializes the PayPal checkout flow with a payment method nonce that represents a vaulted PayPal account.
 * When a {@link callback} is defined, the function returns undefined and invokes the callback with the id to be used with the PayPal JS SDK. Otherwise, it returns a Promise that resolves with the id.
 * @public
 * @ignore
 * @param {object} options These options are identical to the {@link PayPalCheckout#createPayment|options for creating a payment resource}, except for the following:
 * * `flow` cannot be set (will always be `'checkout'`)
 * * `amount`, `currency`, and `vaultInitiatedCheckoutPaymentMethodToken` are required instead of optional
 * * Additional configuration is available (listed below)
 * @param {boolean} [options.optOutOfModalBackdrop=false] By default, the webpage will darken and become unusable while the PayPal window is open. For full control of the UI, pass `true` for this option.
 * @param {callback} [callback] The second argument, <code>payload</code>, is a {@link PayPalCheckout~tokenizePayload|tokenizePayload}. If no callback is provided, the promise resolves with a {@link PayPalCheckout~tokenizePayload|tokenizePayload}.
 * @example
 * paypalCheckoutInstance.startVaultInitiatedCheckout({
 *   vaultInitiatedCheckoutPaymentMethodToken: 'nonce-that-represents-a-vaulted-paypal-account',
 *   amount: '10.00',
 *   currency: 'USD'
 * }).then(function (payload) {
 *   // send payload.nonce to your server
 * }).catch(function (err) {
 *   if (err.code === 'PAYPAL_POPUP_CLOSED') {
 *     // indicates that customer canceled by
 *     // manually closing the PayPal popup
 *   }
 *
 *   // handle other errors
 * });
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
PayPalCheckout.prototype.startVaultInitiatedCheckout = function (options) {
  var missingRequiredParam;
  var self = this;

  if (this._vaultInitiatedCheckoutInProgress) {
    analytics.sendEvent(
      this._clientPromise,
      "paypal-checkout.startVaultInitiatedCheckout.error.already-in-progress"
    );

    return Promise.reject(
      new BraintreeError(
        errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_IN_PROGRESS
      )
    );
  }

  REQUIRED_PARAMS_FOR_START_VAULT_INITIATED_CHECKOUT.forEach(function (param) {
    if (!options.hasOwnProperty(param)) {
      missingRequiredParam = param;
    }
  });

  if (missingRequiredParam) {
    return Promise.reject(
      new BraintreeError({
        type: errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED.type,
        code: errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED.code,
        message: "Required param " + missingRequiredParam + " is missing.",
      })
    );
  }

  this._vaultInitiatedCheckoutInProgress = true;
  this._addModalBackdrop(options);

  options = assign({}, options, {
    flow: "checkout",
  });

  analytics.sendEvent(
    this._clientPromise,
    "paypal-checkout.startVaultInitiatedCheckout.started"
  );

  return this._waitForVaultInitiatedCheckoutDependencies()
    .then(function () {
      var frameCommunicationPromise = new ExtendedPromise();
      var startVaultInitiatedCheckoutPromise = self
        ._createPaymentResource(options, {
          returnUrl: self._constructVaultCheckutUrl("redirect-frame"),
          cancelUrl: self._constructVaultCheckutUrl("cancel-frame"),
        })
        .then(function (response) {
          var redirectUrl = response.paymentResource.redirectUrl;

          self._frameService.redirect(redirectUrl);

          return frameCommunicationPromise;
        });

      self._frameService.open(
        {},
        self._createFrameServiceCallback(frameCommunicationPromise)
      );

      return startVaultInitiatedCheckoutPromise;
    })
    .catch(function (err) {
      self._vaultInitiatedCheckoutInProgress = false;
      self._removeModalBackdrop();

      if (err.code === "FRAME_SERVICE_FRAME_CLOSED") {
        analytics.sendEvent(
          self._clientPromise,
          "paypal-checkout.startVaultInitiatedCheckout.canceled.by-customer"
        );

        return Promise.reject(
          new BraintreeError(
            errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_CANCELED
          )
        );
      }

      if (self._frameService) {
        self._frameService.close();
      }

      if (
        err.code &&
        err.code.indexOf("FRAME_SERVICE_FRAME_OPEN_FAILED") > -1
      ) {
        analytics.sendEvent(
          self._clientPromise,
          "paypal-checkout.startVaultInitiatedCheckout.failed.popup-not-opened"
        );

        return Promise.reject(
          new BraintreeError({
            code: errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED
              .code,
            type: errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED
              .type,
            message:
              errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED
                .message,
            details: {
              originalError: err,
            },
          })
        );
      }

      return Promise.reject(err);
    })
    .then(function (response) {
      self._frameService.close();
      self._vaultInitiatedCheckoutInProgress = false;
      self._removeModalBackdrop();
      analytics.sendEvent(
        self._clientPromise,
        "paypal-checkout.startVaultInitiatedCheckout.succeeded"
      );

      return Promise.resolve(response);
    });
};

PayPalCheckout.prototype._addModalBackdrop = function (options) {
  if (options.optOutOfModalBackdrop) {
    return;
  }

  if (!this._modalBackdrop) {
    this._modalBackdrop = document.createElement("div");
    this._modalBackdrop.setAttribute(
      "data-braintree-paypal-vault-initiated-checkout-modal",
      true
    );
    this._modalBackdrop.style.position = "fixed";
    this._modalBackdrop.style.top = 0;
    this._modalBackdrop.style.bottom = 0;
    this._modalBackdrop.style.left = 0;
    this._modalBackdrop.style.right = 0;
    this._modalBackdrop.style.zIndex = 9999;
    this._modalBackdrop.style.background = "black";
    this._modalBackdrop.style.opacity = "0.7";
    this._modalBackdrop.addEventListener(
      "click",
      function () {
        this.focusVaultInitiatedCheckoutWindow();
      }.bind(this)
    );
  }

  document.body.appendChild(this._modalBackdrop);
};

PayPalCheckout.prototype._removeModalBackdrop = function () {
  if (!(this._modalBackdrop && this._modalBackdrop.parentNode)) {
    return;
  }

  this._modalBackdrop.parentNode.removeChild(this._modalBackdrop);
};

/**
 * Closes the PayPal window if it is opened via `startVaultInitiatedCheckout`.
 * @public
 * @ignore
 * @param {callback} [callback] Gets called when window is closed.
 * @example
 * paypalCheckoutInstance.closeVaultInitiatedCheckoutWindow();
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
PayPalCheckout.prototype.closeVaultInitiatedCheckoutWindow = function () {
  if (this._vaultInitiatedCheckoutInProgress) {
    analytics.sendEvent(
      this._clientPromise,
      "paypal-checkout.startVaultInitiatedCheckout.canceled.by-merchant"
    );
  }

  return this._waitForVaultInitiatedCheckoutDependencies().then(
    function () {
      this._frameService.close();
    }.bind(this)
  );
};

/**
 * Focuses the PayPal window if it is opened via `startVaultInitiatedCheckout`.
 * @public
 * @ignore
 * @param {callback} [callback] Gets called when window is focused.
 * @example
 * paypalCheckoutInstance.focusVaultInitiatedCheckoutWindow();
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
PayPalCheckout.prototype.focusVaultInitiatedCheckoutWindow = function () {
  return this._waitForVaultInitiatedCheckoutDependencies().then(
    function () {
      this._frameService.focus();
    }.bind(this)
  );
};

PayPalCheckout.prototype._createFrameServiceCallback = function (
  frameCommunicationPromise
) {
  var self = this;

  // TODO when a merchant integrates an iOS or Android integration
  // with a webview using the web SDK, we will have to add popupbridge
  // support
  return function (err, payload) {
    if (err) {
      frameCommunicationPromise.reject(err);
    } else if (payload) {
      self._frameService.redirect(self._loadingFrameUrl);
      self
        .tokenizePayment({
          paymentToken: payload.token,
          payerID: payload.PayerID,
          paymentID: payload.paymentId,
          orderID: payload.orderId,
        })
        .then(function (res) {
          frameCommunicationPromise.resolve(res);
        })
        .catch(function (tokenizationError) {
          frameCommunicationPromise.reject(tokenizationError);
        });
    }
  };
};

PayPalCheckout.prototype._waitForVaultInitiatedCheckoutDependencies =
  function () {
    var self = this;

    return this._clientPromise.then(function () {
      return self._frameServicePromise;
    });
  };

PayPalCheckout.prototype._constructVaultCheckutUrl = function (frameName) {
  var serviceId = this._frameService._serviceId;

  return (
    this._assetsUrl +
    "/html/" +
    frameName +
    useMin(this._isDebug) +
    ".html?channel=" +
    serviceId
  );
};

/**
 * Tokenizes the authorize data from the PayPal JS SDK when completing a buyer approval flow.
 * When a {@link callback} is defined, invokes the callback with {@link PayPalCheckout~tokenizePayload|tokenizePayload} and returns undefined. Otherwise, returns a Promise that resolves with a {@link PayPalCheckout~tokenizePayload|tokenizePayload}.
 * @public
 * @param {object} tokenizeOptions Tokens and IDs required to tokenize the payment.
 * @param {string} tokenizeOptions.payerId Payer ID returned by PayPal `onApproved` callback.
 * @param {string} [tokenizeOptions.paymentId] Payment ID returned by PayPal `onApproved` callback.
 * @param {string} [tokenizeOptions.billingToken] Billing Token returned by PayPal `onApproved` callback.
 * @param {boolean} [tokenizeOptions.vault=true] Whether or not to vault the resulting PayPal account (if using a client token generated with a customer id and the vault flow).
 * @param {callback} [callback] The second argument, <code>payload</code>, is a {@link PayPalCheckout~tokenizePayload|tokenizePayload}. If no callback is provided, the promise resolves with a {@link PayPalCheckout~tokenizePayload|tokenizePayload}.
 * @example <caption>Opt out of auto-vaulting behavior</caption>
 * // create the paypalCheckoutInstance with a client token generated with a customer id
 * paypal.Buttons({
 *   createBillingAgreement: function () {
 *     return paypalCheckoutInstance.createPayment({
 *       flow: 'vault'
 *       // your other createPayment options here
 *     });
 *   },
 *   onApproved: function (data) {
 *     data.vault = false;
 *
 *     return paypalCheckoutInstance.tokenizePayment(data);
 *   },
 *   // Add other options, e.g. onCancel, onError
 * }).render('#paypal-button');
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
PayPalCheckout.prototype.tokenizePayment = function (tokenizeOptions) {
  var self = this;
  var shouldVault = true;
  var payload;
  var options = {
    flow:
      tokenizeOptions.billingToken && !tokenizeOptions.paymentID
        ? "vault"
        : "checkout",
    intent: tokenizeOptions.intent || this.intentFromCreatePayment,
  };
  var params = {
    // The paymentToken provided by the PayPal JS SDK is the EC Token
    ecToken: tokenizeOptions.paymentToken,
    billingToken: tokenizeOptions.billingToken,
    payerId: tokenizeOptions.payerID,
    paymentId: tokenizeOptions.paymentID,
    orderId: tokenizeOptions.orderID,
    shippingOptionsId: tokenizeOptions.shippingOptionsId,
  };

  if (tokenizeOptions.hasOwnProperty("vault")) {
    shouldVault = tokenizeOptions.vault;
  }

  options.vault = shouldVault;

  analytics.sendEvent(
    this._clientPromise,
    "paypal-checkout.tokenization.started"
  );

  return this._clientPromise
    .then(function (client) {
      return client.request({
        endpoint: "payment_methods/paypal_accounts",
        method: "post",
        data: self._formatTokenizeData(options, params),
      });
    })
    .then(function (response) {
      payload = self._formatTokenizePayload(response);

      analytics.sendEvent(
        self._clientPromise,
        "paypal-checkout.tokenization.success"
      );
      if (payload.creditFinancingOffered) {
        analytics.sendEvent(
          self._clientPromise,
          "paypal-checkout.credit.accepted"
        );
      }

      return payload;
    })
    .catch(function (err) {
      if (self._setupError) {
        return Promise.reject(self._setupError);
      }

      analytics.sendEvent(
        self._clientPromise,
        "paypal-checkout.tokenization.failed"
      );

      return Promise.reject(
        convertToBraintreeError(err, {
          type: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.type,
          code: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.code,
          message: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.message,
        })
      );
    });
};

/**
 * Resolves with the PayPal client id to be used when loading the PayPal SDK.
 * @public
 * @param {callback} [callback] The second argument, <code>id</code>, is a the PayPal client id. If no callback is provided, the promise resolves with the PayPal client id.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * paypalCheckoutInstance.getClientId().then(function (id) {
 *  var script = document.createElement('script');
 *
 *  script.src = 'https://www.paypal.com/sdk/js?client-id=' + id;
 *  script.onload = function () {
 *    // setup the PayPal SDK
 *  };
 *
 *  document.body.appendChild(script);
 * });
 */
PayPalCheckout.prototype.getClientId = function () {
  return this._clientPromise.then(function (client) {
    return client.getConfiguration().gatewayConfiguration.paypal.clientId;
  });
};

/**
 * Resolves when the PayPal SDK has been successfully loaded onto the page.
 * @public
 * @param {object} [options] A configuration object to modify the query params and data-attributes on the PayPal SDK. A subset of the parameters are listed below. For a full list of query params, see the [PayPal docs](https://developer.paypal.com/docs/checkout/reference/customize-sdk/?mark=query#query-parameters).
 * @param {string} [options.client-id] By default, this will be the client id associated with the authorization used to create the Braintree component. When used in conjunction with passing `authorization` when creating the PayPal Checkout component, you can speed up the loading of the PayPal SDK.
 * @param {string} [options.intent="authorize"] By default, the PayPal SDK defaults to an intent of `capture`. Since the default intent when calling {@link PayPalCheckout#createPayment|`createPayment`} is `authorize`, the PayPal SDK will be loaded with `intent=authorize`. If you wish to use a different intent when calling {@link PayPalCheckout#createPayment|`createPayment`}, make sure it matches here. If `sale` is used, it will be converted to `capture` for the PayPal SDK. If the `vault: true` param is used, `tokenize` will be passed as the default intent.
 * @param {string} [options.locale=en_US] Use this option to change the language, links, and terminology used in the PayPal flow. This locale will be used unless the buyer has set a preferred locale for their account. If an unsupported locale is supplied, a fallback locale (determined by buyer preference or browser data) will be used and no error will be thrown.
 *
 * Supported locales are:
 * `da_DK`,
 * `de_DE`,
 * `en_AU`,
 * `en_GB`,
 * `en_US`,
 * `es_ES`,
 * `fr_CA`,
 * `fr_FR`,
 * `id_ID`,
 * `it_IT`,
 * `ja_JP`,
 * `ko_KR`,
 * `nl_NL`,
 * `no_NO`,
 * `pl_PL`,
 * `pt_BR`,
 * `pt_PT`,
 * `ru_RU`,
 * `sv_SE`,
 * `th_TH`,
 * `zh_CN`,
 * `zh_HK`,
 * and `zh_TW`.
 *
 * @param {string} [options.currency="USD"] If a currency is passed in {@link PayPalCheckout#createPayment|`createPayment`}, it must match the currency passed here.
 * @param {boolean} [options.vault] Must be `true` when using `flow: vault` in {@link PayPalCheckout#createPayment|`createPayment`}.
 * @param {string} [options.components=buttons] By default, the Braintree SDK will only load the PayPal smart buttons component. If you would like to load just the [messages component](https://developer.paypal.com/docs/business/checkout/add-capabilities/credit-messaging/), pass `messages`. If you would like to load both, pass `buttons,messages`
 * @param {object} [options.dataAttributes] The data attributes to apply to the script. Any data attribute can be passed. A subset of the parameters are listed below. For a full list of data attributes, see the [PayPal docs](https://developer.paypal.com/docs/checkout/reference/customize-sdk/#script-parameters).
 * @param {string} [options.dataAttributes.client-token] The client token to use in the script. (usually not needed)
 * @param {string} [options.dataAttributes.csp-nonce] See the [PayPal docs about content security nonces](https://developer.paypal.com/docs/checkout/reference/customize-sdk/#csp-nonce).
 * @param {callback} [callback] Called when the PayPal SDK has been loaded onto the page. The second argument is the PayPal Checkout instance. If no callback is provided, the promise resolves with the PayPal Checkout instance when the PayPal SDK has been loaded onto the page.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example <caption>Without options</caption>
 * paypalCheckoutInstance.loadPayPalSDK().then(function () {
 *   // window.paypal.Buttons is now available to use
 * });
 * @example <caption>With options</caption>
 * paypalCheckoutInstance.loadPayPalSDK({
 *   'client-id': 'PayPal Client Id', // Can speed up rendering time to hardcode this value
 *
 *   intent: 'capture', // Make sure this value matches the value in createPayment
 *   currency: 'USD', // Make sure this value matches the value in createPayment
 * }).then(function () {
 *   // window.paypal.Buttons is now available to use
 * });
 * @example <caption>With Vaulting</caption>
 * paypalCheckoutInstance.loadPayPalSDK({
 *   vault: true
 * }).then(function () {
 *   // window.paypal.Buttons is now available to use
 * });
 */
PayPalCheckout.prototype.loadPayPalSDK = function (options) {
  var idPromise, src;
  var loadPromise = new ExtendedPromise();
  var dataAttributes = (options && options.dataAttributes) || {};
  var userIdToken =
    dataAttributes["user-id-token"] || dataAttributes["data-user-id-token"];

  if (!userIdToken) {
    userIdToken =
      this._authorizationInformation.fingerprint &&
      this._authorizationInformation.fingerprint.split("?")[0];
  }

  this._paypalScript = document.createElement("script");

  // NEXT_MAJOR_VERSION
  // this options object should have 2 properties:
  // * queryParams
  // * dataAttributes
  // should make organizing this better than squashing
  // all the query params at the top level and extracting
  // the data attributes
  options = assign(
    {},
    {
      components: "buttons",
    },
    options
  );
  delete options.dataAttributes;

  // NEXT_MAJOR_VERSION if merchant passes an explicit intent,
  // currency, amount, etc, save those for use in createPayment
  // if no explicit param of that type is passed in when calling
  // createPayment to reduce the number of items that need to be
  // duplicated here and in createPayment
  if (options.vault) {
    options.intent = options.intent || "tokenize";
  } else {
    options.intent = options.intent || "authorize";
    options.currency = options.currency || "USD";
  }

  src = "https://www.paypal.com/sdk/js?";
  this._paypalScript.onload = function () {
    loadPromise.resolve();
  };

  Object.keys(dataAttributes).forEach(
    function (attribute) {
      this._paypalScript.setAttribute(
        "data-" + attribute.replace(/^data\-/, ""),
        dataAttributes[attribute]
      );
    }.bind(this)
  );

  if (options["client-id"]) {
    idPromise = Promise.resolve(options["client-id"]);
  } else {
    idPromise = this.getClientId();
  }

  idPromise.then(
    function (id) {
      options["client-id"] = id;

      if (this._autoSetDataUserIdToken && userIdToken) {
        this._paypalScript.setAttribute("data-user-id-token", userIdToken);

        // preloading improves the rendering time of the PayPal button
        this._attachPreloadPixel({
          id: id,
          userIdToken: userIdToken,
          amount: dataAttributes.amount,
          currency: options.currency,
          merchantId: options["merchant-id"],
        });
      }

      this._paypalScript.src = querystring.queryify(src, options);
      document.head.insertBefore(
        this._paypalScript,
        document.head.firstElementChild
      );
    }.bind(this)
  );

  return loadPromise.then(
    function () {
      return this;
    }.bind(this)
  );
};

PayPalCheckout.prototype._attachPreloadPixel = function (options) {
  var request;
  var id = options.id;
  var userIdToken = options.userIdToken;
  var env = this._authorizationInformation.environment;
  var subdomain = env === "production" ? "" : "sandbox.";
  var url = PAYPAL_SDK_PRELOAD_URL.replace("{ENV}", subdomain);
  var preloadOptions = {
    "client-id": id,
    "user-id-token": userIdToken,
  };

  if (options.amount) {
    preloadOptions.amount = options.amount;
  }
  if (options.currency) {
    preloadOptions.currency = options.currency;
  }
  if (options.merchantId) {
    preloadOptions["merchant-id"] = options.merchantId;
  }

  request = new XMLHttpRequest();
  request.open("GET", querystring.queryify(url, preloadOptions));
  request.send();
};

PayPalCheckout.prototype._formatPaymentResourceData = function (
  options,
  config
) {
  var key;
  var gatewayConfiguration = this._configuration.gatewayConfiguration;
  // NEXT_MAJOR_VERSION default value for intent in PayPal SDK is capture
  // but our integrations default value is authorize. Default this to capture
  // in the next major version.
  var intent = options.intent;
  var paymentResource = {
    // returnUrl and cancelUrl are required in hermes create_payment_resource route
    // but are not used by the PayPal sdk, except to redirect to an error page
    returnUrl: config.returnUrl || "https://www.paypal.com/checkoutnow/error",
    cancelUrl: config.cancelUrl || "https://www.paypal.com/checkoutnow/error",
    offerPaypalCredit: options.offerCredit === true,
    merchantAccountId: this._merchantAccountId,
    experienceProfile: {
      brandName: options.displayName || gatewayConfiguration.paypal.displayName,
      localeCode: options.locale,
      noShipping: (!options.enableShippingAddress).toString(),
      addressOverride: options.shippingAddressEditable === false,
      landingPageType: options.landingPageType,
    },
    shippingOptions: options.shippingOptions,
  };

  if (options.flow === "checkout") {
    paymentResource.amount = options.amount;
    paymentResource.currencyIsoCode = options.currency;
    paymentResource.requestBillingAgreement = options.requestBillingAgreement;

    if (intent) {
      // 'sale' has been changed to 'capture' in PayPal's backend, but
      // we use an old version with 'sale'. We provide capture as an alias
      // to match the PayPal SDK
      if (intent === "capture") {
        intent = "sale";
      }
      paymentResource.intent = intent;
    }

    if (options.hasOwnProperty("lineItems")) {
      paymentResource.lineItems = options.lineItems;
    }

    if (options.hasOwnProperty("vaultInitiatedCheckoutPaymentMethodToken")) {
      paymentResource.vaultInitiatedCheckoutPaymentMethodToken =
        options.vaultInitiatedCheckoutPaymentMethodToken;
    }

    if (options.hasOwnProperty("shippingOptions")) {
      paymentResource.shippingOptions = options.shippingOptions;
    }

    for (key in options.shippingAddressOverride) {
      if (options.shippingAddressOverride.hasOwnProperty(key)) {
        paymentResource[key] = options.shippingAddressOverride[key];
      }
    }

    if (options.hasOwnProperty("billingAgreementDetails")) {
      paymentResource.billingAgreementDetails = options.billingAgreementDetails;
    }
  } else {
    paymentResource.shippingAddress = options.shippingAddressOverride;

    if (options.billingAgreementDescription) {
      paymentResource.description = options.billingAgreementDescription;
    }
  }

  // this needs to be set outside of the block where add it to the
  // payment request so that a follow up tokenization call can use it,
  // but if a second create payment resource call is made without
  // the correlation id, we want to reset it to undefined so that the
  // tokenization call does not use a stale correlation id
  this._riskCorrelationId = options.riskCorrelationId;
  if (options.riskCorrelationId) {
    paymentResource.correlationId = this._riskCorrelationId;
  }

  return paymentResource;
};

/**
 * @ignore
 * @static
 * @function _verifyConsistentCurrency
 * Verifies that `options.currency` and the currencies for each `shippingOption` the same.
 * @param {object} options `options` provided for `updatePayment`.
 * @returns {boolean} true is currencies match (or no shipping options); false if currencies do not match.
 */

PayPalCheckout.prototype._verifyConsistentCurrency = function (options) {
  if (
    options.currency &&
    options.hasOwnProperty("shippingOptions") &&
    Array.isArray(options.shippingOptions)
  ) {
    return options.shippingOptions.every(function (item) {
      return (
        item.amount &&
        item.amount.currency &&
        options.currency.toLowerCase() === item.amount.currency.toLowerCase()
      );
    });
  }

  return true;
};

/**
 * @ignore
 * @static
 * @function _hasMissingOption
 * @param {object} options All options provided for intiating the PayPal flow.
 * @param {array} required A list of required inputs that must be include as part of the options.
 * @returns {boolean} Returns a boolean.
 */

PayPalCheckout.prototype._hasMissingOption = function (options, required) {
  var i, option;

  required = required || [];

  if (
    !options.hasOwnProperty("amount") &&
    !options.hasOwnProperty("lineItems")
  ) {
    return true;
  }

  for (i = 0; i < required.length; i++) {
    option = required[i];

    if (!options.hasOwnProperty(option)) {
      return true;
    }
  }

  return false;
};

PayPalCheckout.prototype._formatUpdatePaymentData = function (options) {
  var self = this;
  var paymentResource = {
    merchantAccountId: this._merchantAccountId,
    paymentId: options.paymentId || options.orderId,
    currencyIsoCode: options.currency,
  };

  if (options.hasOwnProperty("amount")) {
    paymentResource.amount = options.amount;
  }

  if (options.hasOwnProperty("lineItems")) {
    paymentResource.lineItems = options.lineItems;
  }

  if (options.hasOwnProperty("shippingOptions")) {
    paymentResource.shippingOptions = options.shippingOptions;
  }

  /* shippingAddress not supported yet */
  if (options.hasOwnProperty("shippingAddress")) {
    analytics.sendEvent(
      self._clientPromise,
      "paypal-checkout.updatePayment.shippingAddress.provided.by-the-merchant"
    );

    paymentResource.line1 = options.shippingAddress.line1;

    if (options.shippingAddress.hasOwnProperty("line2")) {
      paymentResource.line2 = options.shippingAddress.line2;
    }

    paymentResource.city = options.shippingAddress.city;
    paymentResource.state = options.shippingAddress.state;
    paymentResource.postalCode = options.shippingAddress.postalCode;
    paymentResource.countryCode = options.shippingAddress.countryCode;

    if (options.shippingAddress.hasOwnProperty("phone")) {
      paymentResource.phone = options.shippingAddress.phone;
    }

    if (options.shippingAddress.hasOwnProperty("recipientName")) {
      paymentResource.recipientName = options.shippingAddress.recipientName;
    }
  }

  return paymentResource;
};

PayPalCheckout.prototype._formatTokenizeData = function (options, params) {
  var clientConfiguration = this._configuration;
  var gatewayConfiguration = clientConfiguration.gatewayConfiguration;
  var isTokenizationKey =
    clientConfiguration.authorizationType === "TOKENIZATION_KEY";
  var isVaultFlow = options.flow === "vault";
  var correlationId =
    this._riskCorrelationId || params.billingToken || params.ecToken;
  var data = {
    paypalAccount: {
      correlationId: correlationId,
      options: {
        validate: isVaultFlow && !isTokenizationKey && options.vault,
      },
    },
  };

  if (isVaultFlow) {
    data.paypalAccount.billingAgreementToken = params.billingToken;
  } else {
    data.paypalAccount.paymentToken = params.paymentId || params.orderId;
    data.paypalAccount.payerId = params.payerId;
    data.paypalAccount.unilateral =
      gatewayConfiguration.paypal.unvettedMerchant;

    if (options.intent) {
      data.paypalAccount.intent = options.intent;
    }
  }

  if (this._merchantAccountId) {
    data.merchantAccountId = this._merchantAccountId;
  }

  return data;
};

PayPalCheckout.prototype._formatTokenizePayload = function (response) {
  var payload;
  var account = {};

  if (response.paypalAccounts) {
    account = response.paypalAccounts[0];
  }

  payload = {
    nonce: account.nonce,
    details: {},
    type: account.type,
  };

  if (account.details && account.details.payerInfo) {
    payload.details = account.details.payerInfo;
  }

  if (account.details && account.details.creditFinancingOffered) {
    payload.creditFinancingOffered = account.details.creditFinancingOffered;
  }

  if (account.details && account.details.shippingOptionId) {
    payload.shippingOptionId = account.details.shippingOptionId;
  }

  if (account.details && account.details.cobrandedCardLabel) {
    payload.cobrandedCardLabel = account.details.cobrandedCardLabel;
  }

  return payload;
};

/**
 * Cleanly tear down anything set up by {@link module:braintree-web/paypal-checkout.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * paypalCheckoutInstance.teardown();
 * @example <caption>With callback</caption>
 * paypalCheckoutInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
PayPalCheckout.prototype.teardown = function () {
  var self = this;

  convertMethodsToError(this, methods(PayPalCheckout.prototype));

  if (this._paypalScript && this._paypalScript.parentNode) {
    this._paypalScript.parentNode.removeChild(this._paypalScript);
  }

  return this._frameServicePromise
    .catch(function () {
      // no need to error in teardown for an error setting up the frame service
    })
    .then(function () {
      if (!self._frameService) {
        return Promise.resolve();
      }

      return self._frameService.teardown();
    });
};

module.exports = wrapPromise.wrapPrototype(PayPalCheckout);

},{"../lib/analytics":119,"../lib/assign":121,"../lib/braintree-error":124,"../lib/constants":126,"../lib/convert-methods-to-error":127,"../lib/convert-to-braintree-error":128,"../lib/create-assets-url":129,"../lib/create-authorization-data":130,"../lib/create-deferred-client":131,"../lib/frame-service/external":139,"../lib/methods":155,"../lib/querystring":157,"../lib/use-min":160,"../paypal/shared/constants":180,"./errors":175,"@braintree/extended-promise":34,"@braintree/wrap-promise":43}],178:[function(_dereq_,module,exports){
"use strict";

var frameService = _dereq_("../../lib/frame-service/external");
var BraintreeError = _dereq_("../../lib/braintree-error");
var convertToBraintreeError = _dereq_("../../lib/convert-to-braintree-error");
var useMin = _dereq_("../../lib/use-min");
var once = _dereq_("../../lib/once");
var VERSION = "3.101.3";
var constants = _dereq_("../shared/constants");
var INTEGRATION_TIMEOUT_MS =
  _dereq_("../../lib/constants").INTEGRATION_TIMEOUT_MS;
var analytics = _dereq_("../../lib/analytics");
var methods = _dereq_("../../lib/methods");
var deferred = _dereq_("../../lib/deferred");
var errors = _dereq_("../shared/errors");
var convertMethodsToError = _dereq_("../../lib/convert-methods-to-error");
var querystring = _dereq_("../../lib/querystring");
var wrapPromise = _dereq_("@braintree/wrap-promise");

/**
 * @typedef {object} PayPal~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {string} type The payment method type, always `PayPalAccount`.
 * @property {object} details Additional PayPal account details.
 * @property {string} details.email User's email address.
 * @property {string} details.payerId User's payer ID, the unique identifier for each PayPal account.
 * @property {string} details.firstName User's given name.
 * @property {string} details.lastName User's surname.
 * @property {?string} details.countryCode User's 2 character country code.
 * @property {?string} details.phone User's phone number (e.g. 555-867-5309).
 * @property {?object} details.shippingAddress User's shipping address details, only available if shipping address is enabled.
 * @property {string} details.shippingAddress.recipientName Recipient of postage.
 * @property {string} details.shippingAddress.line1 Street number and name.
 * @property {string} details.shippingAddress.line2 Extended address.
 * @property {string} details.shippingAddress.city City or locality.
 * @property {string} details.shippingAddress.state State or region.
 * @property {string} details.shippingAddress.postalCode Postal code.
 * @property {string} details.shippingAddress.countryCode 2 character country code (e.g. US).
 * @property {?object} details.billingAddress User's billing address details.
 * Not available to all merchants; [contact support](https://developer.paypal.com/braintree/help) for details on eligibility and enabling this feature.
 * Alternatively, see `shippingAddress` above as an available client option.
 * @property {string} details.billingAddress.line1 Street number and name.
 * @property {string} details.billingAddress.line2 Extended address.
 * @property {string} details.billingAddress.city City or locality.
 * @property {string} details.billingAddress.state State or region.
 * @property {string} details.billingAddress.postalCode Postal code.
 * @property {string} details.billingAddress.countryCode 2 character country code (e.g. US).
 * @property {?object} creditFinancingOffered This property will only be present when the customer pays with PayPal Credit.
 * @property {object} creditFinancingOffered.totalCost This is the estimated total payment amount including interest and fees the user will pay during the lifetime of the loan.
 * @property {string} creditFinancingOffered.totalCost.value An amount defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
 * @property {string} creditFinancingOffered.totalCost.currency 3 letter currency code as defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm).
 * @property {number} creditFinancingOffered.term Length of financing terms in months.
 * @property {object} creditFinancingOffered.monthlyPayment This is the estimated amount per month that the customer will need to pay including fees and interest.
 * @property {string} creditFinancingOffered.monthlyPayment.value An amount defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
 * @property {string} creditFinancingOffered.monthlyPayment.currency 3 letter currency code as defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm).
 * @property {object} creditFinancingOffered.totalInterest Estimated interest or fees amount the payer will have to pay during the lifetime of the loan.
 * @property {string} creditFinancingOffered.totalInterest.value An amount defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
 * @property {string} creditFinancingOffered.totalInterest.currency 3 letter currency code as defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm).
 * @property {boolean} creditFinancingOffered.payerAcceptance Status of whether the customer ultimately was approved for and chose to make the payment using the approved installment credit.
 * @property {boolean} creditFinancingOffered.cartAmountImmutable Indicates whether the cart amount is editable after payer's acceptance on PayPal side.
 *
 */

/**
 * @typedef {object} PayPal~tokenizeReturn
 * @property {Function} close A handle to close the PayPal checkout flow.
 * @property {Function} focus A handle to focus the PayPal checkout flow. Note that some browsers (notably iOS Safari) do not support focusing popups. Firefox requires the focus call to occur as the result of a user interaction, such as a button click.
 */

/**
 * @class
 * @param {object} options see {@link module:braintree-web/paypal.create|paypal.create}
 * @classdesc This class represents a PayPal component. Instances of this class can open a PayPal window for authenticating a PayPal account. Any additional UI, such as disabling the page while authentication is taking place, is up to the developer.
 *
 * This component has been deprecated in favor of the {@link PayPalCheckout|PayPal Checkout component}, which provides a fully managed UI. New features will not be added to this component.
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/paypal.create|braintree-web.paypal.create} instead.</strong>
 */
function PayPal(options) {
  this._client = options.client;
  this._assetsUrl =
    options.client.getConfiguration().gatewayConfiguration.paypal.assetsUrl +
    "/web/" +
    VERSION;
  this._isDebug = options.client.getConfiguration().isDebug;
  this._loadingFrameUrl =
    this._assetsUrl +
    "/html/paypal-landing-frame" +
    useMin(this._isDebug) +
    ".html";
  this._authorizationInProgress = false;
}

PayPal.prototype._initialize = function () {
  var self = this;
  var client = this._client;
  var failureTimeout = setTimeout(function () {
    analytics.sendEvent(client, "paypal.load.timed-out");
  }, INTEGRATION_TIMEOUT_MS);

  return new Promise(function (resolve) {
    frameService.create(
      {
        name: constants.LANDING_FRAME_NAME,
        dispatchFrameUrl:
          self._assetsUrl +
          "/html/dispatch-frame" +
          useMin(self._isDebug) +
          ".html",
        openFrameUrl: self._loadingFrameUrl,
      },
      function (service) {
        self._frameService = service;
        clearTimeout(failureTimeout);
        analytics.sendEvent(client, "paypal.load.succeeded");
        resolve(self);
      }
    );
  });
};

/**
 * Launches the PayPal login flow and returns a nonce payload. Only one PayPal login flow should be active at a time. One way to achieve this is to disable your PayPal button while the flow is open.
 * @public
 * @param {object} options All tokenization options for the PayPal component.
 * @param {string} options.flow Set to 'checkout' for one-time payment flow, or 'vault' for Vault flow. If 'vault' is used with a client token generated with a customer id, the PayPal account will be added to that customer as a saved payment method.
 * @param {string} [options.intent=authorize]
 * * `authorize` - Submits the transaction for authorization but not settlement.
 * * `order` - Validates the transaction without an authorization (i.e. without holding funds). Useful for authorizing and capturing funds up to 90 days after the order has been placed. Only available for Checkout flow.
 * * `sale` - Payment will be immediately submitted for settlement upon creating a transaction.
 * @param {boolean} [options.offerCredit=false] Offers PayPal Credit as the default funding instrument for the transaction. If the customer isn't pre-approved for PayPal Credit, they will be prompted to apply for it.
 * @param {boolean} [options.offerPayLater=false] Offers PayPal Pay Later if the customer qualifies. Defaults to false. Only available with `flow: 'checkout'`.
 * @param {string} [options.useraction]
 * Changes the call-to-action in the PayPal flow. By default the final button will show the localized
 * word for "Continue" and implies that the final amount billed is not yet known.
 *
 * Setting this option to `commit` changes the button text to "Pay Now" and page text will convey to
 * the user that billing will take place immediately.
 * @param {(string|number)} [options.amount] The amount of the transaction. Required when using the Checkout flow.
 * @param {string} [options.currency] The currency code of the amount, such as 'USD'. Required when using the Checkout flow.
 * @param {string} [options.displayName] The merchant name displayed inside of the PayPal lightbox; defaults to the company name on your Braintree account
 * @param {string} [options.locale=en_US] Use this option to change the language, links, and terminology used in the PayPal flow. This locale will be used unless the buyer has set a preferred locale for their account. If an unsupported locale is supplied, a fallback locale (determined by buyer preference or browser data) will be used and no error will be thrown.
 *
 * Supported locales are:
 * `da_DK`,
 * `de_DE`,
 * `en_AU`,
 * `en_GB`,
 * `en_US`,
 * `es_ES`,
 * `fr_CA`,
 * `fr_FR`,
 * `id_ID`,
 * `it_IT`,
 * `ja_JP`,
 * `ko_KR`,
 * `nl_NL`,
 * `no_NO`,
 * `pl_PL`,
 * `pt_BR`,
 * `pt_PT`,
 * `ru_RU`,
 * `sv_SE`,
 * `th_TH`,
 * `zh_CN`,
 * `zh_HK`,
 * and `zh_TW`.
 *
 * @param {boolean} [options.enableShippingAddress=false] Returns a shipping address object in {@link PayPal#tokenize}.
 * @param {object} [options.shippingAddressOverride] Allows you to pass a shipping address you have already collected into the PayPal payment flow.
 * @param {string} options.shippingAddressOverride.line1 Street address.
 * @param {string} [options.shippingAddressOverride.line2] Street address (extended).
 * @param {string} options.shippingAddressOverride.city City.
 * @param {string} options.shippingAddressOverride.state State.
 * @param {string} options.shippingAddressOverride.postalCode Postal code.
 * @param {string} options.shippingAddressOverride.countryCode Country.
 * @param {string} [options.shippingAddressOverride.phone] Phone number.
 * @param {string} [options.shippingAddressOverride.recipientName] Recipient's name.
 * @param {boolean} [options.shippingAddressEditable=true] Set to false to disable user editing of the shipping address.
 * @param {string} [options.billingAgreementDescription] Use this option to set the description of the preapproved payment agreement visible to customers in their PayPal profile during Vault flows. Max 255 characters.
 * @param {string} [options.landingPageType] Use this option to specify the PayPal page to display when a user lands on the PayPal site to complete the payment.
 * * `login` - A PayPal account login page is used.
 * * `billing` - A non-PayPal account landing page is used.
 * @param {callback} callback The second argument, <code>data</code>, is a {@link PayPal~tokenizePayload|tokenizePayload}.
 * @example
 * <caption>Tokenizing with the vault flow</caption>
 * button.addEventListener('click', function () {
 *   // Disable the button so that we don't attempt to open multiple popups.
 *   button.setAttribute('disabled', 'disabled');
 *
 *   // if there is any other part of the page that must be disabled
 *   // while authentication is in progress, do so now
 *
 *   // Because PayPal tokenization opens a popup, this must be called
 *   // as a result of a user action, such as a button click.
 *   paypalInstance.tokenize({
 *     flow: 'vault' // Required
 *     // Any other tokenization options
 *   }, function (tokenizeErr, payload) {
 *     button.removeAttribute('disabled');
 *
 *     // if any other part of the page was disabled, re-enable now
 *
 *     if (tokenizeErr) {
 *       // Handle tokenization errors or premature flow closure
 *
 *       switch (tokenizeErr.code) {
 *         case 'PAYPAL_POPUP_CLOSED':
 *           console.error('Customer closed PayPal popup.');
 *           break;
 *         case 'PAYPAL_ACCOUNT_TOKENIZATION_FAILED':
 *           console.error('PayPal tokenization failed. See details:', tokenizeErr.details);
 *           break;
 *         case 'PAYPAL_FLOW_FAILED':
 *           console.error('Unable to initialize PayPal flow. Are your options correct?', tokenizeErr.details);
 *           break;
 *         default:
 *           console.error('Error!', tokenizeErr);
 *       }
 *     } else {
 *       // Submit payload.nonce to your server
 *     }
 *   });
 * });

 * @example
 * <caption>Tokenizing with the checkout flow</caption>
 * button.addEventListener('click', function () {
 *   // Disable the button so that we don't attempt to open multiple popups.
 *   button.setAttribute('disabled', 'disabled');
 *
 *   // Because PayPal tokenization opens a popup, this must be called
 *   // as a result of a user action, such as a button click.
 *   paypalInstance.tokenize({
 *     flow: 'checkout', // Required
 *     amount: '10.00', // Required
 *     currency: 'USD' // Required
 *     // Any other tokenization options
 *   }, function (tokenizeErr, payload) {
 *     button.removeAttribute('disabled');
 *
 *     if (tokenizeErr) {
 *       // Handle tokenization errors or premature flow closure
 *
 *       switch (tokenizeErr.code) {
 *         case 'PAYPAL_POPUP_CLOSED':
 *           console.error('Customer closed PayPal popup.');
 *           break;
 *         case 'PAYPAL_ACCOUNT_TOKENIZATION_FAILED':
 *           console.error('PayPal tokenization failed. See details:', tokenizeErr.details);
 *           break;
 *         case 'PAYPAL_FLOW_FAILED':
 *           console.error('Unable to initialize PayPal flow. Are your options correct?', tokenizeErr.details);
 *           break;
 *         default:
 *           console.error('Error!', tokenizeErr);
 *       }
 *     } else {
 *       // Submit payload.nonce to your server
 *     }
 *   });
 * });
 * @returns {Promise|PayPal~tokenizeReturn} A handle to manage the PayPal checkout frame. If no callback is provided, returns a promise.
 */
PayPal.prototype.tokenize = function (options, callback) {
  var self = this;
  var client = this._client;
  var tokenizePromise, optionError;

  if (callback) {
    callback = once(deferred(callback));
  }

  if (!options || !constants.FLOW_ENDPOINTS.hasOwnProperty(options.flow)) {
    optionError = new BraintreeError(errors.PAYPAL_FLOW_OPTION_REQUIRED);

    if (callback) {
      callback(optionError);

      return this._frameService.createNoopHandler();
    }

    return Promise.reject(optionError);
  }

  tokenizePromise = new Promise(function (resolve, reject) {
    if (self._authorizationInProgress) {
      analytics.sendEvent(client, "paypal.tokenization.error.already-opened");

      reject(new BraintreeError(errors.PAYPAL_TOKENIZATION_REQUEST_ACTIVE));
    } else {
      self._authorizationInProgress = true;

      if (!window.popupBridge) {
        analytics.sendEvent(client, "paypal.tokenization.opened");
      }

      if (options.offerCredit === true) {
        analytics.sendEvent(client, "paypal.credit.offered");
      }

      if (options.offerPayLater === true) {
        analytics.sendEvent(client, "paypal.paylater.offered");
      }

      self._navigateFrameToAuth(options).catch(reject);
      // self MUST happen after _navigateFrameToAuth for Metro browsers to work.
      self._frameService.open(
        {},
        self._createFrameServiceCallback(options, resolve, reject)
      );
    }
  });

  if (callback) {
    tokenizePromise
      .then(function (res) {
        callback(null, res);
      })
      .catch(callback);

    return this._frameService.createHandler({
      beforeClose: function () {
        analytics.sendEvent(client, "paypal.tokenization.closed.by-merchant");
      },
    });
  }

  return tokenizePromise;
};

PayPal.prototype._createFrameServiceCallback = function (
  options,
  resolve,
  reject
) {
  var self = this;
  var client = this._client;

  if (window.popupBridge) {
    return function (err, payload) {
      var canceled =
        payload && payload.path && payload.path.substring(0, 7) === "/cancel";

      self._authorizationInProgress = false;

      // `err` exists when the user clicks "Done" button of browser view
      if (err || canceled) {
        analytics.sendEvent(
          client,
          "paypal.tokenization.closed-popupbridge.by-user"
        );
        // Call merchant's tokenize callback with an error
        reject(new BraintreeError(errors.PAYPAL_POPUP_CLOSED));
      } else if (payload) {
        self
          ._tokenizePayPal(options, payload.queryItems)
          .then(resolve)
          .catch(reject);
      }
    };
  }

  return function (err, params) {
    self._authorizationInProgress = false;

    if (err) {
      if (err.code === "FRAME_SERVICE_FRAME_CLOSED") {
        analytics.sendEvent(client, "paypal.tokenization.closed.by-user");
        reject(new BraintreeError(errors.PAYPAL_POPUP_CLOSED));
      } else if (
        err.code &&
        err.code.indexOf("FRAME_SERVICE_FRAME_OPEN_FAILED") > -1
      ) {
        reject(
          new BraintreeError({
            code: errors.PAYPAL_POPUP_OPEN_FAILED.code,
            type: errors.PAYPAL_POPUP_OPEN_FAILED.type,
            message: errors.PAYPAL_POPUP_OPEN_FAILED.message,
            details: {
              originalError: err,
            },
          })
        );
      }
    } else if (params) {
      self._tokenizePayPal(options, params).then(resolve).catch(reject);
    }
  };
};

PayPal.prototype._tokenizePayPal = function (options, params) {
  var self = this;
  var client = this._client;

  if (!window.popupBridge) {
    this._frameService.redirect(this._loadingFrameUrl);
  }

  return client
    .request({
      endpoint: "payment_methods/paypal_accounts",
      method: "post",
      data: this._formatTokenizeData(options, params),
    })
    .then(function (response) {
      var payload = self._formatTokenizePayload(response);

      if (window.popupBridge) {
        analytics.sendEvent(client, "paypal.tokenization.success-popupbridge");
      } else {
        analytics.sendEvent(client, "paypal.tokenization.success");
      }

      if (payload.creditFinancingOffered) {
        analytics.sendEvent(client, "paypal.credit.accepted");
      }

      self._frameService.close();

      return payload;
    })
    .catch(function (err) {
      if (window.popupBridge) {
        analytics.sendEvent(client, "paypal.tokenization.failed-popupbridge");
      } else {
        analytics.sendEvent(client, "paypal.tokenization.failed");
      }

      self._frameService.close();

      return Promise.reject(
        convertToBraintreeError(err, {
          type: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.type,
          code: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.code,
          message: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.message,
        })
      );
    });
};

PayPal.prototype._formatTokenizePayload = function (response) {
  var payload;
  var account = {};

  if (response.paypalAccounts) {
    account = response.paypalAccounts[0];
  }

  payload = {
    nonce: account.nonce,
    details: {},
    type: account.type,
  };

  if (account.details && account.details.payerInfo) {
    payload.details = account.details.payerInfo;
  }

  if (account.details && account.details.creditFinancingOffered) {
    payload.creditFinancingOffered = account.details.creditFinancingOffered;
  }

  return payload;
};

PayPal.prototype._formatTokenizeData = function (options, params) {
  var clientConfiguration = this._client.getConfiguration();
  var gatewayConfiguration = clientConfiguration.gatewayConfiguration;
  var isTokenizationKey =
    clientConfiguration.authorizationType === "TOKENIZATION_KEY";
  var data = {
    paypalAccount: {
      correlationId: params.ba_token || params.token,
      options: {
        validate: options.flow === "vault" && !isTokenizationKey,
      },
    },
  };

  if (params.ba_token) {
    data.paypalAccount.billingAgreementToken = params.ba_token;
  } else {
    data.paypalAccount.paymentToken = params.paymentId;
    data.paypalAccount.payerId = params.PayerID;
    data.paypalAccount.unilateral =
      gatewayConfiguration.paypal.unvettedMerchant;

    if (options.hasOwnProperty("intent")) {
      data.paypalAccount.intent = options.intent;
    }
  }

  return data;
};

PayPal.prototype._navigateFrameToAuth = function (options) {
  var self = this;
  var client = this._client;
  var endpoint = "paypal_hermes/" + constants.FLOW_ENDPOINTS[options.flow];

  return client
    .request({
      endpoint: endpoint,
      method: "post",
      data: this._formatPaymentResourceData(options),
    })
    .then(function (response) {
      var redirectUrl;

      if (options.flow === "checkout") {
        redirectUrl = response.paymentResource.redirectUrl;
      } else {
        redirectUrl = response.agreementSetup.approvalUrl;
      }

      if (options.useraction === "commit") {
        redirectUrl = querystring.queryify(redirectUrl, {
          useraction: "commit",
        });
      }

      if (window.popupBridge) {
        analytics.sendEvent(client, "paypal.tokenization.opened-popupbridge");
      }

      self._frameService.redirect(redirectUrl);
    })
    .catch(function (err) {
      var status = err.details && err.details.httpStatus;

      self._frameService.close();
      self._authorizationInProgress = false;

      if (status === 422) {
        return Promise.reject(
          new BraintreeError({
            type: errors.PAYPAL_INVALID_PAYMENT_OPTION.type,
            code: errors.PAYPAL_INVALID_PAYMENT_OPTION.code,
            message: errors.PAYPAL_INVALID_PAYMENT_OPTION.message,
            details: {
              originalError: err,
            },
          })
        );
      }

      return Promise.reject(
        convertToBraintreeError(err, {
          type: errors.PAYPAL_FLOW_FAILED.type,
          code: errors.PAYPAL_FLOW_FAILED.code,
          message: errors.PAYPAL_FLOW_FAILED.message,
        })
      );
    });
};

PayPal.prototype._formatPaymentResourceData = function (options) {
  var key;
  var gatewayConfiguration =
    this._client.getConfiguration().gatewayConfiguration;
  var serviceId = this._frameService._serviceId;
  var paymentResource = {
    returnUrl:
      gatewayConfiguration.paypal.assetsUrl +
      "/web/" +
      VERSION +
      "/html/redirect-frame" +
      useMin(this._isDebug) +
      ".html?channel=" +
      serviceId,
    cancelUrl:
      gatewayConfiguration.paypal.assetsUrl +
      "/web/" +
      VERSION +
      "/html/cancel-frame" +
      useMin(this._isDebug) +
      ".html?channel=" +
      serviceId,
    offerPaypalCredit: options.offerCredit === true,
    offerPayLater: options.offerPayLater === true,
    experienceProfile: {
      brandName: options.displayName || gatewayConfiguration.paypal.displayName,
      localeCode: options.locale,
      noShipping: (!options.enableShippingAddress).toString(),
      addressOverride: options.shippingAddressEditable === false,
      landingPageType: options.landingPageType,
    },
  };

  if (
    window.popupBridge &&
    typeof window.popupBridge.getReturnUrlPrefix === "function"
  ) {
    paymentResource.returnUrl =
      window.popupBridge.getReturnUrlPrefix() + "return";
    paymentResource.cancelUrl =
      window.popupBridge.getReturnUrlPrefix() + "cancel";
  }

  if (options.flow === "checkout") {
    paymentResource.amount = options.amount;
    paymentResource.currencyIsoCode = options.currency;

    if (options.hasOwnProperty("intent")) {
      paymentResource.intent = options.intent;
    }

    for (key in options.shippingAddressOverride) {
      if (options.shippingAddressOverride.hasOwnProperty(key)) {
        paymentResource[key] = options.shippingAddressOverride[key];
      }
    }
  } else {
    paymentResource.shippingAddress = options.shippingAddressOverride;

    if (options.billingAgreementDescription) {
      paymentResource.description = options.billingAgreementDescription;
    }
  }

  return paymentResource;
};

/**
 * Closes the PayPal window if it is open.
 * @public
 * @example
 * paypalInstance.closeWindow();
 * @returns {void}
 */
PayPal.prototype.closeWindow = function () {
  if (this._authorizationInProgress) {
    analytics.sendEvent(this._client, "paypal.tokenize.closed.by-merchant");
  }
  this._frameService.close();
};

/**
 * Focuses the PayPal window if it is open.
 * @public
 * @example
 * paypalInstance.focusWindow();
 * @returns {void}
 */
PayPal.prototype.focusWindow = function () {
  this._frameService.focus();
};

/**
 * Cleanly remove anything set up by {@link module:braintree-web/paypal.create|create}.
 * @public
 * @param {callback} [callback] Called on completion.
 * @example
 * paypalInstance.teardown();
 * @example <caption>With callback</caption>
 * paypalInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
PayPal.prototype.teardown = wrapPromise(function () {
  var self = this; // eslint-disable-line no-invalid-this

  self._frameService.teardown();

  convertMethodsToError(self, methods(PayPal.prototype));

  analytics.sendEvent(self._client, "paypal.teardown-completed");

  return Promise.resolve();
});

module.exports = PayPal;

},{"../../lib/analytics":119,"../../lib/braintree-error":124,"../../lib/constants":126,"../../lib/convert-methods-to-error":127,"../../lib/convert-to-braintree-error":128,"../../lib/deferred":132,"../../lib/frame-service/external":139,"../../lib/methods":155,"../../lib/once":156,"../../lib/querystring":157,"../../lib/use-min":160,"../shared/constants":180,"../shared/errors":181,"@braintree/wrap-promise":43}],179:[function(_dereq_,module,exports){
"use strict";
/**
 * @module braintree-web/paypal
 * @description A component to integrate with PayPal.
 * @deprecated Use the {@link PayPalCheckout|PayPal Checkout component} instead.
 */

var analytics = _dereq_("../lib/analytics");
var basicComponentVerification = _dereq_("../lib/basic-component-verification");
var createDeferredClient = _dereq_("../lib/create-deferred-client");
var createAssetsUrl = _dereq_("../lib/create-assets-url");
var BraintreeError = _dereq_("../lib/braintree-error");
var errors = _dereq_("./shared/errors");
var PayPal = _dereq_("./external/paypal");
var VERSION = "3.101.3";
var wrapPromise = _dereq_("@braintree/wrap-promise");

/**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {callback} callback The second argument, `data`, is the {@link PayPal} instance.
 * @example
 * // We recommend creating your PayPal button with button.js
 * // For an example, see https://codepen.io/braintree/pen/LNKJWa
 * var paypalButton = document.querySelector('.paypal-button');
 *
 * braintree.client.create({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (clientErr, clientInstance) {
 *   if (clientErr) {
 *     console.error('Error creating client:', clientErr);
 *     return;
 *   }
 *
 *   braintree.paypal.create({
 *     client: clientInstance
 *   }, function (paypalErr, paypalInstance) {
 *     if (paypalErr) {
 *       console.error('Error creating PayPal:', paypalErr);
 *       return;
 *     }
 *
 *     paypalButton.removeAttribute('disabled');
 *
 *     // When the button is clicked, attempt to tokenize.
 *     paypalButton.addEventListener('click', function (event) {
 *       // Because tokenization opens a popup, this has to be called as a result of
 *       // customer action, like clicking a button. You cannot call this at any time.
 *       paypalInstance.tokenize({
 *         flow: 'vault'
 *         // For more tokenization options, see the full PayPal tokenization documentation
 *         // https://braintree.github.io/braintree-web/current/PayPal.html#tokenize
 *       }, function (tokenizeErr, payload) {
 *         if (tokenizeErr) {
 *           if (tokenizeErr.type !== 'CUSTOMER') {
 *             console.error('Error tokenizing:', tokenizeErr);
 *           }
 *           return;
 *         }
 *
 *         // Tokenization succeeded
 *         paypalButton.setAttribute('disabled', true);
 *         console.log('Got a nonce! You should submit this to your server.');
 *         console.log(payload.nonce);
 *       });
 *     }, false);
 *   });
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
function create(options) {
  var name = "PayPal";

  return basicComponentVerification
    .verify({
      name: name,
      client: options.client,
      authorization: options.authorization,
    })
    .then(function () {
      return createDeferredClient.create({
        authorization: options.authorization,
        client: options.client,
        debug: options.debug,
        assetsUrl: createAssetsUrl.create(options.authorization),
        name: name,
      });
    })
    .then(function (client) {
      var pp;
      var config = client.getConfiguration();

      options.client = client;

      if (config.gatewayConfiguration.paypalEnabled !== true) {
        return Promise.reject(new BraintreeError(errors.PAYPAL_NOT_ENABLED));
      }

      analytics.sendEvent(options.client, "paypal.initialized");

      pp = new PayPal(options);

      return pp._initialize();
    });
}

/**
 * @static
 * @function isSupported
 * @description Returns true if PayPal [supports this browser](index.html#browser-support-webviews).
 * @example
 * if (braintree.paypal.isSupported()) {
 *   // Add PayPal button to the page
 * } else {
 *   // Hide PayPal payment option
 * }
 * @returns {Boolean} Returns true if PayPal supports this browser.
 */
function isSupported() {
  return true;
}

module.exports = {
  create: wrapPromise(create),
  isSupported: isSupported,
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION,
};

},{"../lib/analytics":119,"../lib/basic-component-verification":122,"../lib/braintree-error":124,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./external/paypal":178,"./shared/errors":181,"@braintree/wrap-promise":43}],180:[function(_dereq_,module,exports){
"use strict";

module.exports = {
  LANDING_FRAME_NAME: "braintreepaypallanding",
  FLOW_ENDPOINTS: {
    checkout: "create_payment_resource",
    vault: "setup_billing_agreement",
  },
  REQUIRED_OPTIONS: ["paymentId", "currency"],
};

},{}],181:[function(_dereq_,module,exports){
"use strict";

/**
 * @name BraintreeError.PayPal - Creation Error Codes
 * @description Errors that occur when [creating the PayPal component](./module-braintree-web_paypal.html#.create).
 * @property {MERCHANT} PAYPAL_NOT_ENABLED Occurs when PayPal is not enabled on the Braintree control panel.
 */

/**
 * @name BraintreeError.PayPal - tokenize Error Codes
 * @description Errors that occur when using the [`tokenize` method](./PayPal.html#tokenize).
 * @property {MERCHANT} PAYPAL_TOKENIZATION_REQUEST_ACTIVE Occurs when a tokenization request is already in progress.
 * @property {MERCHANT} PAYPAL_FLOW_OPTION_REQUIRED Occurs when flow option is not provided.
 * @property {NETWORK} PAYPAL_ACCOUNT_TOKENIZATION_FAILED Occurs when PayPal account could not be tokenized.
 * @property {NETWORK} PAYPAL_FLOW_FAILED Occurs when PayPal flow could not be initiated.
 * @property {MERCHANT} PAYPAL_POPUP_OPEN_FAILED Occurs when PayPal window could not be opened.
 * @property {CUSTOMER} PAYPAL_POPUP_CLOSED Occurs when customer closes the PayPal window before completing the flow.
 * @property {MERCHANT} PAYPAL_INVALID_PAYMENT_OPTION Occurs when an invalid payment option is passed.
 */

var BraintreeError = _dereq_("../../lib/braintree-error");

module.exports = {
  PAYPAL_NOT_ENABLED: {
    type: BraintreeError.types.MERCHANT,
    code: "PAYPAL_NOT_ENABLED",
    message: "PayPal is not enabled for this merchant.",
  },
  PAYPAL_TOKENIZATION_REQUEST_ACTIVE: {
    type: BraintreeError.types.MERCHANT,
    code: "PAYPAL_TOKENIZATION_REQUEST_ACTIVE",
    message: "Another tokenization request is active.",
  },
  PAYPAL_ACCOUNT_TOKENIZATION_FAILED: {
    type: BraintreeError.types.NETWORK,
    code: "PAYPAL_ACCOUNT_TOKENIZATION_FAILED",
    message: "Could not tokenize user's PayPal account.",
  },
  PAYPAL_FLOW_FAILED: {
    type: BraintreeError.types.NETWORK,
    code: "PAYPAL_FLOW_FAILED",
    message: "Could not initialize PayPal flow.",
  },
  PAYPAL_FLOW_OPTION_REQUIRED: {
    type: BraintreeError.types.MERCHANT,
    code: "PAYPAL_FLOW_OPTION_REQUIRED",
    message: "PayPal flow property is invalid or missing.",
  },
  PAYPAL_POPUP_OPEN_FAILED: {
    type: BraintreeError.types.MERCHANT,
    code: "PAYPAL_POPUP_OPEN_FAILED",
    message:
      "PayPal popup failed to open, make sure to tokenize in response to a user action.",
  },
  PAYPAL_POPUP_CLOSED: {
    type: BraintreeError.types.CUSTOMER,
    code: "PAYPAL_POPUP_CLOSED",
    message: "Customer closed PayPal popup before authorizing.",
  },
  PAYPAL_INVALID_PAYMENT_OPTION: {
    type: BraintreeError.types.MERCHANT,
    code: "PAYPAL_INVALID_PAYMENT_OPTION",
    message: "PayPal payment options are invalid.",
  },
};

},{"../../lib/braintree-error":124}],182:[function(_dereq_,module,exports){
"use strict";
/** @module braintree-web/preferred-payment-methods */

var wrapPromise = _dereq_("@braintree/wrap-promise");
var basicComponentVerification = _dereq_("../lib/basic-component-verification");
var PreferredPaymentMethods = _dereq_("./preferred-payment-methods");
var VERSION = "3.101.3";

// NEXT_MAJOR_VERSION
// Remove this integration entirely. It doesn't work, isn't documented, and otherwise isn't going to be pursued further beyond the non-operational beta it is in.
/**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {callback} [callback] The second argument, `data`, is the {@link PreferredPaymentMethods} instance.
 * @example
 * braintree.preferredPaymentMethods.create({
 *   client: clientInstance
 * }).then(function (preferredPaymentMethodsInstance) {
 *   // preferredPaymentMethodsInstance is ready to be used.
 * }).catch(function (error) {
 *   // handle creation error
 * });
 * @returns {Promise|void} Returns a Promise with resolves with the PreferredPaymentMethods instance.
 */
function create(options) {
  var name = "PreferredPaymentMethods";

  return basicComponentVerification
    .verify({
      name: name,
      client: options.client,
      authorization: options.authorization,
    })
    .then(function () {
      var instance = new PreferredPaymentMethods();

      return instance.initialize(options);
    });
}

module.exports = {
  create: wrapPromise(create),
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION,
};

},{"../lib/basic-component-verification":122,"./preferred-payment-methods":183,"@braintree/wrap-promise":43}],183:[function(_dereq_,module,exports){
"use strict";

var wrapPromise = _dereq_("@braintree/wrap-promise");
var analytics = _dereq_("../lib/analytics");
var createAssetsUrl = _dereq_("../lib/create-assets-url");
var createDeferredClient = _dereq_("../lib/create-deferred-client");

/**
 * @class
 * @param {object} options See {@link module:braintree-web/preferred-payment-methods.create|preferred-payment-methods.create}
 */
function PreferredPaymentMethods() {}

PreferredPaymentMethods.prototype.initialize = function (options) {
  var self = this;

  this._clientPromise = createDeferredClient
    .create({
      authorization: options.authorization,
      client: options.client,
      debug: options.debug,
      assetsUrl: createAssetsUrl.create(options.authorization),
      name: "PreferredPaymentMethods",
    })
    .catch(function (err) {
      self._setupError = err;

      return Promise.reject(err);
    });

  analytics.sendEvent(
    this._clientPromise,
    "preferred-payment-methods.initialized"
  );

  return Promise.resolve(this);
};

/**
 * Fetches information about which payment methods are preferred on the device.
 * Used to determine which payment methods are given preference in your UI,
 * not whether they are presented entirely.
 *
 * This class is currently in beta and may change in future releases.
 * @public
 * @returns {Promise|void} Returns a promise if no callback is provided.
 * @example
 * <caption>Preferred Payment Methods</caption>
 * preferredPaymentMethodsInstance.fetchPreferredPaymentMethods().then(function (result) {
 *   if (result.paypalPreferred) {
 *     // PayPal preferred
 *   } else {
 *     // PayPal not preferred
 *   }
 *
 *   if (result.venmoPreferred) {
 *     // Venmo preferred
 *   } else {
 *     // Venmo not preferred
 *   }
 * });
 */
PreferredPaymentMethods.prototype.fetchPreferredPaymentMethods = function () {
  var client;
  var self = this;

  return this._clientPromise
    .then(function (clientInstance) {
      client = clientInstance;

      return client.request({
        api: "graphQLApi",
        data: {
          query:
            "query PreferredPaymentMethods { " +
            "preferredPaymentMethods { " +
            "paypalPreferred " +
            "venmoPreferred " +
            "} " +
            "}",
        },
      });
    })
    .then(function (result) {
      var paypalPreferred = result.data.preferredPaymentMethods.paypalPreferred;
      var venmoPreferred = result.data.preferredPaymentMethods.venmoPreferred;

      analytics.sendEvent(
        client,
        "preferred-payment-methods.paypal.api-detected." + paypalPreferred
      );
      analytics.sendEvent(
        client,
        "preferred-payment-methods.venmo.api-detected." + venmoPreferred
      );

      return {
        paypalPreferred: paypalPreferred,
        venmoPreferred: venmoPreferred,
      };
    })
    .catch(function () {
      if (self._setupError) {
        return Promise.reject(self._setupError);
      }

      analytics.sendEvent(client, "preferred-payment-methods.api-error");

      return {
        paypalPreferred: false,
        venmoPreferred: false,
      };
    });
};

module.exports = wrapPromise.wrapPrototype(PreferredPaymentMethods);

},{"../lib/analytics":119,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"@braintree/wrap-promise":43}],184:[function(_dereq_,module,exports){
"use strict";

var BraintreeError = _dereq_("../../lib/braintree-error");
var sepaErrors = _dereq_("../shared/errors");
var frameService = _dereq_("../../lib/frame-service/external");
var analytics = _dereq_("../../lib/analytics");
var useMin = _dereq_("../../lib/use-min");
var billingAddressOptions =
  _dereq_("../shared/constants").BILLING_ADDRESS_OPTIONS;
var snakeCaseToCamelCase = _dereq_("../../lib/snake-case-to-camel-case");

var POPUP_WIDTH = 400;
var POPUP_HEIGHT = 570;

/**
 * @ignore
 * @typedef CreateMandateResponse
 * @property {string} approvalUrl The URL to present to the customer for payment approval.
 * @property {string} last4 The last four digits of the iban.
 * @property {string} bankReferenceToken The tokenized payment source to fun the payment.
 */

/**
 *
 * A function that creates a mandate so that we can present the mandate to the customer via a popup.
 *
 * @ignore
 * @static
 * @function createMandate
 * @param {object} client The Braintree client.
 * @param {object} options All options for intiating the SEPA payment flow.
 * @param {string} [options.accountHolderName] The account holder name.
 * @param {object} [options.billingAddress] The customer's billing address
 * @param {string} [options.billingAddress.addressLine1] Line 1 of the Address (eg. number, street, etc). An error will occur if this address is not valid.
 * @param {string} [options.billingAddress.addressLine2] Line 2 of the Address (eg. suite, apt #, etc.). An error will occur if this address is not valid.
 * @param {string} [options.billingAddress.adminArea1] Customer's city.
 * @param {string} [options.billingAddress.adminArea2] Customer's region or state.
 * @param {string} [options.billingAddress.postalCode] Customer's postal code.
 * @param {string} [options.cancelUrl] The URL to redirect to if authorization is cancelled.
 * @param {string} [options.countryCode] The customer's country code. Also used as billing address country code.
 * @param {string} [options.customerId] The customer's id.
 * @param {string} [options.iban] The customer's International Bank Account Number.
 * @param {string} [options.locale] The BCP 47-formatted locale. See https://developer.paypal.com/reference/locale-codes/ for a list of possible values.
 * @param {string} [options.mandateType] Specify ONE_OFF or RECURRENT payment.
 * @param {string} [options.merchantAccountId] The merchant's account id.
 * @param {string} [options.merchantId] The merchant id.
 * @param {string} [options.returnUrl] The URL to redirect to if authorization is successful.
 * @returns {Promise<CreateMandateResponse|Error>} Returns a promise with the mandate response or an error.
 */

function createMandate(client, options) {
  // Disabling eslint because api is expecting snake_case format for the keys
  /* eslint-disable */
  var data = {
    sepa_debit: {
      account_holder_name: options.accountHolderName,
      billing_address: {
        country_code: options.countryCode,
      },
      iban: options.iban,
      merchant_or_partner_customer_id: options.customerId,
      mandate_type: options.mandateType,
    },
    locale: options.locale,
    cancel_url: options.cancelUrl,
    return_url: options.returnUrl,
    merchant_account_id: options.merchantAccountId,
  };

  if (options.billingAddress) {
    billingAddressOptions.forEach(function (option) {
      var ccOption = snakeCaseToCamelCase(option);
      if (ccOption in options.billingAddress) {
        data.sepa_debit.billing_address[option] =
          options.billingAddress[ccOption]; // camelCase equivilent of option (eg. postal_code = postalCode) ]
      }
    });
  }
  /* eslint-enable */

  return client
    .request({
      api: "clientApi",
      method: "post",
      endpoint: "sepa_debit",
      data: data,
    })
    .then(function (response) {
      var sepaDebitAccount = response.message.body.sepaDebitAccount;

      if (!sepaDebitAccount) {
        throw new BraintreeError(sepaErrors.SEPA_CREATE_MANDATE_FAILED);
      }

      return {
        approvalUrl: sepaDebitAccount.approvalUrl,
        last4: sepaDebitAccount.last4,
        bankReferenceToken: sepaDebitAccount.bankReferenceToken,
      };
    })
    .catch(function () {
      throw new BraintreeError(sepaErrors.SEPA_CREATE_MANDATE_FAILED);
    });
}

/**
 *
 * A function for opening and managing the popup used for authorization.
 *
 * @ignore
 * @param {string} client The Braintree client.
 * @param {string} options The input options needed to manage the popup portion of the flow.
 * @param {string} [options.assetsUrl] The url to the Braintree asset to be used in frameservice.
 * @param {string} [options.approvalUrl] The url to open for SEPA authorization. It is `approvalUrl` coming back from the mandate creation, but commonly refered to as the mandate link.
 * @param {string} [options.debug] Whether to use debugging modes or not.
 * @returns {Promise<void|Error>} Returns a promise.
 */
function openPopup(client, options) {
  var popupName = "sepadirectdebit";
  var assetsBaseUrl = options.assetsUrl + "/html";
  var debug = options.debug || false;

  return new Promise(function (resolve, reject) {
    var popupLocation = centeredPopupDimensions();

    frameService.create(
      {
        name: popupName,
        dispatchFrameUrl:
          assetsBaseUrl + "/dispatch-frame" + useMin(debug) + ".html",
        openFrameUrl:
          assetsBaseUrl + "/sepa-landing-frame" + useMin(debug) + ".html",
        top: popupLocation.top,
        left: popupLocation.left,
        height: POPUP_HEIGHT,
        width: POPUP_WIDTH,
      },
      function (frameServiceInstance) {
        analytics.sendEvent(client, "sepa.popup.initialized");
        frameServiceInstance.open({}, function (err, params) {
          if (mandateApproved(params)) {
            frameServiceInstance.close();

            return resolve();
          }

          if (customerCanceled(params, err)) {
            frameServiceInstance.close();

            return reject(
              new BraintreeError(sepaErrors.SEPA_CUSTOMER_CANCELED)
            );
          }

          frameServiceInstance.close();

          return reject(
            new BraintreeError(sepaErrors.SEPA_TOKENIZATION_FAILED)
          );
        });

        frameServiceInstance.redirect(options.approvalUrl);
      }
    );
  });
}

function mandateApproved(params) {
  return params && params.success;
}

function customerCanceled(params, error) {
  return (
    (params && params.cancel) ||
    (error && error.code === "FRAME_SERVICE_FRAME_CLOSED")
  );
}

function centeredPopupDimensions() {
  var popupTop =
    Math.round((window.outerHeight - POPUP_HEIGHT) / 2) + window.screenTop;
  var popupLeft =
    Math.round((window.outerWidth - POPUP_WIDTH) / 2) + window.screenLeft;

  return {
    top: popupTop,
    left: popupLeft,
  };
}

/**
 *
 * A function that creates a mandate so that we can present the mandate to the customer via a popup.
 *
 * @ignore
 * @static
 * @function handleApproval
 * @param {object} client The Braintree client.
 * @param {object} options All options for intiating the SEPA payment flow.
 * @param {string} [options.bankReferenceToken] The tokenized payment source to fun the payment.
 * @param {string} [options.customerId] The customer's id.
 * @param {string} [options.last4] The last four digits of iban.
 * @param {string} [options.mandateType] The mandate type being used. Specify ONE_OFF or RECURRENT payment.
 * @param {string} [options.merchantAccountId] The merchant's account id.
 * @param {string} [options.merchantId] The merchant id.
 * @returns {Promise<tokenizePayload|Error>} Returns a promise with the approval response or an error.
 */

function handleApproval(client, options) {
  // Disabling eslint because api is expecting snake_case format for the keys
  /* eslint-disable */
  var data = {
    sepa_debit_account: {
      last_4: options.last4,
      merchant_or_partner_customer_id: options.customerId,
      bank_reference_token: options.bankReferenceToken,
      mandate_type: options.mandateType,
    },
    merchant_account_id: options.merchantAccountId,
  };

  /* eslint-enable */
  return client
    .request({
      api: "clientApi",
      method: "post",
      endpoint: "payment_methods/sepa_debit_accounts",
      data: data,
    })
    .then(function (response) {
      if (!response.nonce) {
        throw new BraintreeError(sepaErrors.SEPA_TRANSACTION_FAILED);
      }

      return {
        nonce: response.nonce,
        ibanLastFour: options.last4,
        customerId: options.customerId,
        mandateType: options.mandateType,
      };
    })
    .catch(function () {
      throw new BraintreeError(sepaErrors.SEPA_TRANSACTION_FAILED);
    });
}

module.exports = {
  createMandate: createMandate,
  openPopup: openPopup,
  handleApproval: handleApproval,
  POPUP_WIDTH: POPUP_WIDTH,
  POPUP_HEIGHT: POPUP_HEIGHT,
};

},{"../../lib/analytics":119,"../../lib/braintree-error":124,"../../lib/frame-service/external":139,"../../lib/snake-case-to-camel-case":159,"../../lib/use-min":160,"../shared/constants":187,"../shared/errors":188}],185:[function(_dereq_,module,exports){
"use strict";

var wrapPromise = _dereq_("@braintree/wrap-promise");
var BraintreeError = _dereq_("../../lib/braintree-error");
var sepaErrors = _dereq_("../shared/errors");
var constants = _dereq_("../shared/constants");
var mandates = _dereq_("./mandate");
var hasMissingOption = _dereq_("../shared/has-missing-option");
var analytics = _dereq_("../../lib/analytics");
var VERSION = "3.101.3";
var assign = _dereq_("../../lib/assign").assign;

/**
 * @class
 * @param {object} options see {@link module:braintree-web/sepa.create|sepa.create}
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/sepa.create|braintree-web.sepa.create} instead.</strong>
 * @classdesc This class represents a SEPA component produced by {@link module:braintree-web/sepa.create|braintree-web.sepa.create}. Instances provide methods for tokenizing SEPA payments.
 */
function SEPA(options) {
  var getConfiguration = options.client.getConfiguration();

  this._client = options.client;
  this._assetsUrl =
    getConfiguration.gatewayConfiguration.assetsUrl + "/web/" + VERSION;
  this._isDebug = getConfiguration.isDebug;
  this._returnUrl = this._assetsUrl + "/html/redirect-frame.html?success=1";
  this._cancelUrl = this._assetsUrl + "/html/redirect-frame.html?cancel=1";

  analytics.sendEvent(this._client, "sepa.component.initialized");
}

/**
 * SEPA tokenize payload.
 * @typedef SEPA~tokenizePayload
 * @property {string} nonce The payment nonce.
 * @property {string} ibanLastFour The last four digits of the customer's IBAN.
 * @property {string} mandateType The specified mandateType used.
 * @property {string} customerId The provided customer id.
 */

/**
 * @public
 * @param {object} options All options for intiating the SEPA payment flow.
 * @param {string} [options.accountHolderName] The account holder name.
 * @param {string} [options.customerId] The customer's id.
 * @param {string} [options.iban] The customer's International Bank Account Number.
 * @param {string} [options.mandateType] Specify ONE_OFF or RECURRENT payment.
 * @param {string} [options.countryCode] The customer's country code.
 * @param {string} [options.merchantAccountId] The merchant's account id.
 * @param {callback} [callback] The first argument is an error object, where the second is a {@link SEPA~tokenizePayload|tokenizePayload}
 * @returns {(Promise<tokenizePayload|error>)} Returns a promise if no callback is provided.
 *
 * @example
 * button.addEventListener('click', function () {
 *   var tokenizeInputs = {
 *     accountHolderName: "some-accnt-holder-name",
 *     customerId: "a-customer-id",
 *     iban: "a-full-iban",
 *     mandateType: "ONE_OFF",
 *     countryCode: "LI",
 *     merchantAccountId: "a-merchant-account-id"
 *   }
 *   sepaInstance.tokenize(tokenizeInputs).then(function (payload) {
 *      // Submit payload.nonce to your server
 *   }).catch(function(tokenizationErr) {
 *     // Handle errors in the flow
 *   })
 * })
 */
SEPA.prototype.tokenize = function (options) {
  var self = this;
  var createMandateOptions = assign(
    { cancelUrl: self._cancelUrl, returnUrl: self._returnUrl },
    options
  );

  if (!options || hasMissingOption(options, constants.REQUIRED_OPTIONS)) {
    analytics.sendEvent(self._client, "sepa.input-validation.missing-options");

    return Promise.reject(
      new BraintreeError(sepaErrors.SEPA_TOKENIZE_MISSING_REQUIRED_OPTION)
    );
  }

  if (!constants.MANDATE_TYPE_ENUM.includes(options.mandateType)) {
    analytics.sendEvent(self._client, "sepa.input-validation.invalid-mandate");

    return Promise.reject(
      new BraintreeError(sepaErrors.SEPA_INVALID_MANDATE_TYPE)
    );
  }

  return mandates
    .createMandate(self._client, createMandateOptions)
    .then(function (mandateResponse) {
      analytics.sendEvent(self._client, "sepa.create-mandate.success");
      options.last4 = mandateResponse.last4;
      options.bankReferenceToken = mandateResponse.bankReferenceToken;

      return mandates.openPopup(self._client, {
        approvalUrl: mandateResponse.approvalUrl,
        assetsUrl: self._assetsUrl,
      });
    })
    .then(function () {
      analytics.sendEvent(self._client, "sepa.mandate.approved");

      return mandates.handleApproval(self._client, {
        bankReferenceToken: options.bankReferenceToken,
        last4: options.last4,
        customerId: options.customerId,
        mandateType: options.mandateType,
        merchantAccountId: options.merchantAccountId,
      });
    })
    .then(function (approval) {
      analytics.sendEvent(self._client, "sepa.tokenization.success");

      return Promise.resolve(approval);
    })
    .catch(function (err) {
      analytics.sendEvent(self._client, "sepa." + err.details + ".failed");

      return Promise.reject(err);
    });
};

module.exports = wrapPromise.wrapPrototype(SEPA);

},{"../../lib/analytics":119,"../../lib/assign":121,"../../lib/braintree-error":124,"../shared/constants":187,"../shared/errors":188,"../shared/has-missing-option":189,"./mandate":184,"@braintree/wrap-promise":43}],186:[function(_dereq_,module,exports){
"use strict";
/** @module braintree-web/sepa */

var analytics = _dereq_("../lib/analytics");
var SEPA = _dereq_("./external/sepa");
var createAssetsUrl = _dereq_("../lib/create-assets-url");
var createDeferredClient = _dereq_("../lib/create-deferred-client");
var basicComponentVerification = _dereq_("../lib/basic-component-verification");
var wrapPromise = _dereq_("@braintree/wrap-promise");
var VERSION = "3.101.3";

/**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {boolean} [options.debug] A debug flag.
 * @param {callback} [callback] When provided, will be used instead of a promise. First argument is an error object, where the second is an instance of {@link SEPA|SEPA}.
 * @returns {Promise<void|error>} Returns the SEPA instance.
 * @example
 * braintree.sepa.create({
 *   client: clientInstance
 * }).then(function (sepaInstance) {
 *   // sepaInstance is ready to be used.
 * }).catch(function (createErr) {
 *   console.error('Error creating SEPA instance', createErr);
 * });
 * @example <caption>Creating a SEPA component</caption>
 * braintree.sepa.create({
 *   client: clientInstance,
 * }).then(function (sepaInstance) {
 *   // sepaInstance is ready to be used.
 * }).catch(function (createErr) {
 *   console.error('Error creating SEPA instance', createErr);
 * });
 */

function create(options) {
  var name = "SEPA";

  return basicComponentVerification
    .verify({
      name: name,
      client: options.client,
      authorization: options.authorization,
    })
    .then(function () {
      return createDeferredClient.create({
        authorization: options.authorization,
        client: options.client,
        debug: options.debug,
        assetsUrl: createAssetsUrl.create(options.authorization),
        name: name,
      });
    })
    .then(function (client) {
      options.client = client;

      analytics.sendEvent(options.client, "sepa.client.initialized");

      return new SEPA(options);
    });
}

module.exports = {
  create: wrapPromise(create),
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION,
};

},{"../lib/analytics":119,"../lib/basic-component-verification":122,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./external/sepa":185,"@braintree/wrap-promise":43}],187:[function(_dereq_,module,exports){
"use strict";

module.exports = {
  REQUIRED_OPTIONS: [
    "iban",
    "merchantAccountId",
    "mandateType",
    "customerId",
    "accountHolderName",
    "countryCode",
  ],
  BILLING_ADDRESS_OPTIONS: [
    "address_line_1",
    "address_line_2",
    "admin_area_1",
    "admin_area_2",
    "postal_code",
  ],
  MANDATE_TYPE_ENUM: ["ONE_OFF", "RECURRENT"],
};

},{}],188:[function(_dereq_,module,exports){
"use strict";

var BraintreeError = _dereq_("../../lib/braintree-error");

/**
 * @name BraintreeError.SEPA - tokenize Error Codes
 * @description Errors that occur when using the {@link module:braintree-web/sepa.tokenize|sepa.tokenize} method.
 * @property {MERCHANT} SEPA_CREATE_MANDATE_FAILED Occurs when there was an issue creating a mandate. This can occur if the request fails, or if the merchant does not have SEPA enabled.
 * @property {CUSTOMER} SEPA_CUSTOMER_CANCELED Occurs when the customer has canceled the SEPA authorization process. This can be within the mandate approval popup, or by canceling the popup itself.
 * @property {MERCHANT} SEPA_INVALID_MANDATE_TYPE Occurs when an invalid mandate type is provided.
 * @property {UNKNOWN} SEPA_TOKENIZATION_FAILED Occurs when tokenization fails during the mandate approval process for unknown reasons.
 * @property {MERCHANT} SEPA_TOKENIZE_MISSING_REQUIRED_OPTION Occurs when there are required input options not provided.
 * @property {UNKNOWN} SEPA_TRANSACTION_FAILED Occurs when final tokenization fails.
 */

// Those with a "details" property are used in specific locations and this prop serves to identify where in the imlpementation the error originates.
module.exports = {
  SEPA_CREATE_MANDATE_FAILED: {
    type: BraintreeError.types.MERCHANT,
    code: "SEPA_CREATE_MANDATE_FAILED",
    message: "SEPA create mandate failed.",
    details: "create-mandate",
  },
  SEPA_CUSTOMER_CANCELED: {
    type: BraintreeError.types.CUSTOMER,
    code: "SEPA_CUSTOMER_CANCELED",
    message: "User canceled SEPA authorization",
    details: "customer-canceled",
  },
  SEPA_INVALID_MANDATE_TYPE: {
    type: BraintreeError.types.MERCHANT,
    code: "SEPA_INVALID_MANDATE_TYPE",
    message: "SEPA mandate type is invalid",
  },
  SEPA_TOKENIZATION_FAILED: {
    type: BraintreeError.types.UNKNOWN,
    code: "SEPA_TOKENIZATION_FAILED",
    message: "SEPA encountered a problem",
    details: "open-popup",
  },
  SEPA_TOKENIZE_MISSING_REQUIRED_OPTION: {
    type: BraintreeError.types.MERCHANT,
    code: "SEPA_TOKENIZE_MISSING_REQUIRED_OPTION",
    message: "Missing required option for tokenize.",
  },
  SEPA_TRANSACTION_FAILED: {
    type: BraintreeError.types.UNKNOWN,
    code: "SEPA_TRANSACTION_FAILED",
    message: "SEPA transaction failed",
    details: "handle-approval",
  },
};

},{"../../lib/braintree-error":124}],189:[function(_dereq_,module,exports){
"use strict";

/**
 * @ignore
 * @static
 * @function hasMissingOption
 * @param {object} options All options provided for intiating the SEPA payment flow.
 * @param {array} required A list of required inputs that must be include as part of the options.
 * @returns {boolean} Returns a boolean.
 */
function hasMissingOption(options, required) {
  var i, option;

  required = required || [];

  for (i = 0; i < required.length; i++) {
    option = required[i];

    if (!options.hasOwnProperty(option)) {
      return true;
    }
  }

  return false;
}

module.exports = hasMissingOption;

},{}],190:[function(_dereq_,module,exports){
"use strict";

var assign = _dereq_("../../../lib/assign").assign;
var analytics = _dereq_("../../../lib/analytics");
var BraintreeError = _dereq_("../../../lib/braintree-error");
var isVerifiedDomain = _dereq_("../../../lib/is-verified-domain");
var ExtendedPromise = _dereq_("@braintree/extended-promise");
var EventEmitter = _dereq_("@braintree/event-emitter");
var errors = _dereq_("../../shared/errors");
var iFramer = _dereq_("@braintree/iframer");
var Bus = _dereq_("framebus");
var constants = _dereq_("../../shared/constants");
var uuid = _dereq_("@braintree/uuid");
var events = _dereq_("../../shared/events");
var useMin = _dereq_("../../../lib/use-min");
var BUS_CONFIGURATION_REQUEST_EVENT =
  _dereq_("../../../lib/constants").BUS_CONFIGURATION_REQUEST_EVENT;

var VERSION = "3.101.3";
var IFRAME_HEIGHT = 400;
var IFRAME_WIDTH = 400;

ExtendedPromise.suppressUnhandledPromiseMessage = true;

function BaseFramework(options) {
  EventEmitter.call(this);

  this._client = options.client;
  this._createPromise = options.createPromise;
  this._createOptions = options;

  if (this._client) {
    this._isDebug = this._client.getConfiguration().isDebug;
    this._assetsUrl =
      this._client.getConfiguration().gatewayConfiguration.assetsUrl;
  } else {
    this._isDebug = Boolean(options.isDebug);
    this._assetsUrl = options.assetsUrl;
  }
  this._assetsUrl = this._assetsUrl + "/web/" + VERSION;
}

EventEmitter.createChild(BaseFramework);

BaseFramework.prototype._waitForClient = function () {
  if (this._client) {
    return Promise.resolve();
  }

  return this._createPromise.then(
    function (client) {
      this._client = client;
    }.bind(this)
  );
};

BaseFramework.prototype.setUpEventListeners = function () {
  throw new BraintreeError(errors.THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED);
};

BaseFramework.prototype.verifyCard = function (options, privateOptions) {
  var formattedOptions, error;
  var self = this;

  privateOptions = privateOptions || {};

  error = this._checkForVerifyCardError(options, privateOptions);

  if (error) {
    return Promise.reject(error);
  }

  this._verifyCardInProgress = true;

  formattedOptions = this._formatVerifyCardOptions(options);

  return this._formatLookupData(formattedOptions)
    .then(function (data) {
      analytics.sendEvent(
        self._createPromise,
        "three-d-secure.verification-flow.started"
      );

      return self._performLookup(formattedOptions.nonce, data);
    })
    .then(function (response) {
      analytics.sendEvent(
        self._createPromise,
        "three-d-secure.verification-flow.3ds-version." +
          response.lookup.threeDSecureVersion
      );

      return self._onLookupComplete(response, formattedOptions);
    })
    .then(function (response) {
      return self.initializeChallengeWithLookupResponse(
        response,
        formattedOptions
      );
    })
    .then(function (payload) {
      self._resetVerificationState();

      analytics.sendEvent(
        self._createPromise,
        "three-d-secure.verification-flow.completed"
      );

      return payload;
    })
    .catch(function (err) {
      self._resetVerificationState();

      analytics.sendEvent(
        self._createPromise,
        "three-d-secure.verification-flow.failed"
      );

      return Promise.reject(err);
    });
};

BaseFramework.prototype._checkForFrameworkSpecificVerifyCardErrors =
  function () {
    throw new BraintreeError(errors.THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED);
  };

BaseFramework.prototype._presentChallenge = function () {
  throw new BraintreeError(errors.THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED);
};

BaseFramework.prototype.prepareLookup = function () {
  throw new BraintreeError(errors.THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED);
};

BaseFramework.prototype._resetVerificationState = function () {
  this._verifyCardInProgress = false;
  this._verifyCardPromisePlus = null;

  if (typeof this._reloadThreeDSecure === "function") {
    this._reloadThreeDSecure();
  }
};

BaseFramework.prototype._performLookup = function (nonce, data) {
  var self = this;
  var url = "payment_methods/" + nonce + "/three_d_secure/lookup";

  return this._waitForClient().then(function () {
    return self._client
      .request({
        endpoint: url,
        method: "post",
        data: data,
      })
      .catch(function (err) {
        var status = err && err.details && err.details.httpStatus;
        var analyticsMessage = "three-d-secure.verification-flow.lookup-failed";
        var lookupError;

        if (status === 404) {
          lookupError = errors.THREEDS_LOOKUP_TOKENIZED_CARD_NOT_FOUND_ERROR;
          analyticsMessage += ".404";
        } else if (status === 422) {
          lookupError = errors.THREEDS_LOOKUP_VALIDATION_ERROR;
          analyticsMessage += ".422";
        } else {
          lookupError = errors.THREEDS_LOOKUP_ERROR;
        }

        analytics.sendEvent(self._createPromise, analyticsMessage);

        return Promise.reject(
          new BraintreeError({
            type: lookupError.type,
            code: lookupError.code,
            message: lookupError.message,
            details: {
              originalError: err,
            },
          })
        );
      });
  });
};

BaseFramework.prototype._checkForVerifyCardError = function (
  options,
  privateOptions
) {
  var errorOption;

  if (this._verifyCardInProgress === true) {
    return new BraintreeError(errors.THREEDS_AUTHENTICATION_IN_PROGRESS);
  } else if (!options.nonce) {
    errorOption = "a nonce";
  } else if (!options.amount) {
    errorOption = "an amount";
  }

  if (!errorOption) {
    errorOption = this._checkForFrameworkSpecificVerifyCardErrors(
      options,
      privateOptions
    );
  }

  if (errorOption) {
    return new BraintreeError({
      type: errors.THREEDS_MISSING_VERIFY_CARD_OPTION.type,
      code: errors.THREEDS_MISSING_VERIFY_CARD_OPTION.code,
      message: "verifyCard options must include " + errorOption + ".",
    });
  }

  return null;
};

BaseFramework.prototype.initializeChallengeWithLookupResponse = function (
  lookupResponse,
  options
) {
  var self = this;

  options = options || {};

  this._lookupPaymentMethod = lookupResponse.paymentMethod;

  // sets this in the case that initializeChallengeWithLookupResponse is
  // called as a standalone method from a server side lookup. In a normal
  // verifyCard flow, this promise will already exist
  self._verifyCardPromisePlus =
    self._verifyCardPromisePlus || new ExtendedPromise();
  self._handleLookupResponse(lookupResponse, options);

  return self._verifyCardPromisePlus.then(function (payload) {
    analytics.sendEvent(
      self._createPromise,
      "three-d-secure.verification-flow.liability-shifted." +
        String(payload.liabilityShifted)
    );
    analytics.sendEvent(
      self._createPromise,
      "three-d-secure.verification-flow.liability-shift-possible." +
        String(payload.liabilityShiftPossible)
    );

    return payload;
  });
};

BaseFramework.prototype._handleLookupResponse = function (
  lookupResponse,
  options
) {
  var challengeShouldBePresented = Boolean(
    lookupResponse.lookup && lookupResponse.lookup.acsUrl
  );
  var details;

  analytics.sendEvent(
    this._createPromise,
    "three-d-secure.verification-flow.challenge-presented." +
      String(challengeShouldBePresented)
  );

  if (challengeShouldBePresented) {
    this._presentChallenge(lookupResponse, options);
  } else {
    details = this._formatAuthResponse(
      lookupResponse.paymentMethod,
      lookupResponse.threeDSecureInfo
    );
    details.verificationDetails = lookupResponse.threeDSecureInfo;

    this._verifyCardPromisePlus.resolve(details);
  }
};

BaseFramework.prototype._onLookupComplete = function (response) {
  this._lookupPaymentMethod = response.paymentMethod;
  this._verifyCardPromisePlus = new ExtendedPromise();

  return Promise.resolve(response);
};

BaseFramework.prototype._formatAuthResponse = function (
  paymentMethod,
  threeDSecureInfo
) {
  return {
    nonce: paymentMethod.nonce,
    type: paymentMethod.type,
    binData: paymentMethod.binData,
    details: paymentMethod.details,
    description:
      paymentMethod.description &&
      paymentMethod.description.replace(/\+/g, " "),
    liabilityShifted: threeDSecureInfo && threeDSecureInfo.liabilityShifted,
    liabilityShiftPossible:
      threeDSecureInfo && threeDSecureInfo.liabilityShiftPossible,
    threeDSecureInfo: paymentMethod.threeDSecureInfo,
  };
};

BaseFramework.prototype._formatVerifyCardOptions = function (options) {
  return assign({}, options);
};

BaseFramework.prototype._formatLookupData = function (options) {
  var data = {
    amount: options.amount,
  };

  if (options.collectDeviceData === true) {
    data.browserColorDepth = window.screen.colorDepth;
    data.browserJavaEnabled = window.navigator.javaEnabled();
    data.browserJavascriptEnabled = true;
    data.browserLanguage = window.navigator.language;
    data.browserScreenHeight = window.screen.height;
    data.browserScreenWidth = window.screen.width;
    data.browserTimeZone = new Date().getTimezoneOffset();
    data.deviceChannel = "Browser";
  }

  return Promise.resolve(data);
};

BaseFramework.prototype._handleV1AuthResponse = function (data) {
  var authResponse = JSON.parse(data.auth_response);

  if (authResponse.success) {
    this._verifyCardPromisePlus.resolve(
      this._formatAuthResponse(
        authResponse.paymentMethod,
        authResponse.threeDSecureInfo
      )
    );
  } else if (
    authResponse.threeDSecureInfo &&
    authResponse.threeDSecureInfo.liabilityShiftPossible
  ) {
    this._verifyCardPromisePlus.resolve(
      this._formatAuthResponse(
        this._lookupPaymentMethod,
        authResponse.threeDSecureInfo
      )
    );
  } else {
    this._verifyCardPromisePlus.reject(
      new BraintreeError({
        type: BraintreeError.types.UNKNOWN,
        code: "UNKNOWN_AUTH_RESPONSE",
        message: authResponse.error.message,
      })
    );
  }
};

BaseFramework.prototype.cancelVerifyCard = function () {
  var response, threeDSecureInfo;

  this._verifyCardInProgress = false;

  if (!this._lookupPaymentMethod) {
    return Promise.reject(
      new BraintreeError(errors.THREEDS_NO_VERIFICATION_PAYLOAD)
    );
  }

  threeDSecureInfo = this._lookupPaymentMethod.threeDSecureInfo;

  response = assign({}, this._lookupPaymentMethod, {
    liabilityShiftPossible:
      threeDSecureInfo && threeDSecureInfo.liabilityShiftPossible,
    liabilityShifted: threeDSecureInfo && threeDSecureInfo.liabilityShifted,
    verificationDetails:
      threeDSecureInfo && threeDSecureInfo.verificationDetails,
  });

  return Promise.resolve(response);
};

BaseFramework.prototype._setupV1Bus = function (options) {
  var clientConfiguration = this._client.getConfiguration();
  var parentURL = window.location.href.split("#")[0];
  var lookupResponse = options.lookupResponse;
  var channel = uuid();
  var bus = new Bus({
    channel: channel,
    verifyDomain: isVerifiedDomain,
  });
  var authenticationCompleteBaseUrl =
    this._assetsUrl +
    "/html/three-d-secure-authentication-complete-frame.html?channel=" +
    encodeURIComponent(channel) +
    "&";

  bus.on(BUS_CONFIGURATION_REQUEST_EVENT, function (reply) {
    reply({
      clientConfiguration: clientConfiguration,
      nonce: options.nonce,
      acsUrl: lookupResponse.acsUrl,
      pareq: lookupResponse.pareq,
      termUrl:
        lookupResponse.termUrl +
        "&three_d_secure_version=" +
        VERSION +
        "&authentication_complete_base_url=" +
        encodeURIComponent(authenticationCompleteBaseUrl),
      md: lookupResponse.md,
      parentUrl: parentURL,
    });
  });

  bus.on(events.AUTHENTICATION_COMPLETE, options.handleAuthResponse);

  return bus;
};

BaseFramework.prototype._setupV1Iframe = function (options) {
  var url =
    this._assetsUrl +
    "/html/three-d-secure-bank-frame" +
    useMin(this._isDebug) +
    ".html?showLoader=" +
    options.showLoader;
  var bankIframe = iFramer({
    src: url,
    height: IFRAME_HEIGHT,
    width: IFRAME_WIDTH,
    name: constants.LANDING_FRAME_NAME + "_" + this._v1Bus.channel,
    title: "3D Secure Authorization Frame",
  });

  return bankIframe;
};

BaseFramework.prototype._setupV1Elements = function (options) {
  this._v1Bus = this._setupV1Bus(options);
  this._v1Iframe = this._setupV1Iframe(options);
};

BaseFramework.prototype._teardownV1Elements = function () {
  if (this._v1Bus) {
    this._v1Bus.teardown();
    this._v1Bus = null;
  }

  if (this._v1Iframe && this._v1Iframe.parentNode) {
    this._v1Iframe.parentNode.removeChild(this._v1Iframe);
    this._v1Iframe = null;
  }

  if (this._onV1Keyup) {
    document.removeEventListener("keyup", this._onV1Keyup);
    this._onV1Keyup = null;
  }
};

BaseFramework.prototype.teardown = function () {
  analytics.sendEvent(this._createPromise, "three-d-secure.teardown-completed");

  this._teardownV1Elements();

  return Promise.resolve();
};

module.exports = BaseFramework;

},{"../../../lib/analytics":119,"../../../lib/assign":121,"../../../lib/braintree-error":124,"../../../lib/constants":126,"../../../lib/is-verified-domain":153,"../../../lib/use-min":160,"../../shared/constants":199,"../../shared/errors":200,"../../shared/events":201,"@braintree/event-emitter":33,"@braintree/extended-promise":34,"@braintree/iframer":35,"@braintree/uuid":39,"framebus":52}],191:[function(_dereq_,module,exports){
"use strict";
// NEXT_MAJOR_VERSION drop support for Bootstrap framework,
// recomend using inline frame version and putting it in
// the merchant's own bootstrap modal

var SongbirdFramework = _dereq_("./songbird");

function Bootstrap3ModalFramework(options) {
  SongbirdFramework.call(this, options);
}

Bootstrap3ModalFramework.prototype = Object.create(
  SongbirdFramework.prototype,
  {
    constructor: SongbirdFramework,
  }
);

Bootstrap3ModalFramework.prototype._createV1IframeModalElement = function (
  iframe
) {
  var modal = document.createElement("div");

  modal.innerHTML =
    '<div class="modal fade in" tabindex="-1" role="dialog" aria-labelledby="CCAFrameModal-label" aria-hidden="true" style="display: block;">' +
    '<div class="modal-dialog" style="width:440px;z-index:999999;">' +
    '<div class="modal-content">' +
    '<div class="modal-body" data-braintree-v1-fallback-iframe-container>' +
    '<button type="button" data-braintree-v1-fallback-close-button class="close" data-dismiss="modal" aria-hidden="true">×</button>' +
    "</div>" +
    "</div>" +
    "</div>" +
    '<div data-braintree-v1-fallback-backdrop style="' +
    "position: fixed;" +
    "cursor: pointer;" +
    "z-index: 999998;" +
    "top: 0;" +
    "left: 0;" +
    "width: 100%;" +
    "height: 100%;" +
    '"></div>' +
    "</div>";

  modal
    .querySelector("[data-braintree-v1-fallback-iframe-container]")
    .appendChild(iframe);

  return modal;
};

Bootstrap3ModalFramework.prototype._createCardinalConfigurationOptions =
  function (setupOptions) {
    var options =
      SongbirdFramework.prototype._createCardinalConfigurationOptions.call(
        this,
        setupOptions
      );

    options.payment.framework = "bootstrap3";

    return options;
  };

module.exports = Bootstrap3ModalFramework;

},{"./songbird":196}],192:[function(_dereq_,module,exports){
"use strict";

var SongbirdFramework = _dereq_("./songbird");

function CardinalModalFramework(options) {
  SongbirdFramework.call(this, options);
}

CardinalModalFramework.prototype = Object.create(SongbirdFramework.prototype, {
  constructor: SongbirdFramework,
});

CardinalModalFramework.prototype._createV1IframeModalElement = function (
  iframe
) {
  var modal = document.createElement("div");
  var addCloseButton = Boolean(
    this._createOptions &&
      this._createOptions.cardinalSDKConfig &&
      this._createOptions.cardinalSDKConfig.payment &&
      this._createOptions.cardinalSDKConfig.payment.displayExitButton
  );

  modal.innerHTML =
    '<div style="' +
    "position: fixed;" +
    "z-index: 999999;" +
    "top: 50%;" +
    "left: 50%;" +
    "padding: 24px 20px;" +
    "transform: translate(-50%,-50%);" +
    "border-radius: 2px;" +
    "background: #fff;" +
    "max-width: 100%;" +
    "overflow: auto;" +
    '">' +
    "<div>" +
    "<button data-braintree-v1-fallback-close-button " +
    'style="' +
    "font-family: Helvetica,Arial,sans-serif;" +
    "font-size: 25px;" +
    "line-height: 12px;" +
    "position: absolute;" +
    "top: 2px;" +
    "right: 0px;" +
    "cursor: pointer;" +
    "color: #999;" +
    "border: 0;" +
    "outline: none;" +
    "background: none;" +
    '" ' +
    "onMouseOver=\"this.style.color='#000'\" " +
    "onMouseOut=\"this.style.color='#999'\"" +
    ">×</button>" +
    "</div>" +
    // iframe container
    '<div data-braintree-v1-fallback-iframe-container style="' +
    "height: 400px;" +
    '"></div>' +
    "</div>" +
    // modal backdrop
    '<div data-braintree-v1-fallback-backdrop style="' +
    "position: fixed;" +
    "z-index: 999998;" +
    "cursor: pointer;" +
    "top: 0;" +
    "left: 0;" +
    "width: 100%;" +
    "height: 100%;" +
    "transition: opacity 1ms ease;" +
    "background: rgba(0,0,0,.6);" +
    '"></div>';

  if (!addCloseButton) {
    modal.querySelector(
      "[data-braintree-v1-fallback-close-button]"
    ).style.display = "none";
  }
  modal
    .querySelector("[data-braintree-v1-fallback-iframe-container]")
    .appendChild(iframe);

  return modal;
};

module.exports = CardinalModalFramework;

},{"./songbird":196}],193:[function(_dereq_,module,exports){
"use strict";

var LegacyFramework = _dereq_("./legacy");
var CardinalModalFramework = _dereq_("./cardinal-modal");
var Bootstrap3ModalFramework = _dereq_("./bootstrap3-modal");
var InlineIframeFramework = _dereq_("./inline-iframe");

module.exports = {
  legacy: LegacyFramework,
  "cardinal-modal": CardinalModalFramework,
  "bootstrap3-modal": Bootstrap3ModalFramework,
  "inline-iframe": InlineIframeFramework,
};

},{"./bootstrap3-modal":191,"./cardinal-modal":192,"./inline-iframe":194,"./legacy":195}],194:[function(_dereq_,module,exports){
"use strict";

var SongbirdFramework = _dereq_("./songbird");
var BraintreeError = _dereq_("../../../lib/braintree-error");
var errors = _dereq_("../../shared/errors");
var enumerate = _dereq_("../../../lib/enumerate");

function InlineIframeFramework(options) {
  SongbirdFramework.call(this, options);
}

InlineIframeFramework.prototype = Object.create(SongbirdFramework.prototype, {
  constructor: SongbirdFramework,
});

InlineIframeFramework.events = enumerate(
  ["AUTHENTICATION_IFRAME_AVAILABLE"],
  "inline-iframe-framework:"
);

InlineIframeFramework.prototype.setUpEventListeners = function (reply) {
  SongbirdFramework.prototype.setUpEventListeners.call(this, reply);

  this.on(
    InlineIframeFramework.events.AUTHENTICATION_IFRAME_AVAILABLE,
    function (payload, next) {
      reply("authentication-iframe-available", payload, next);
    }
  );
};

InlineIframeFramework.prototype._createCardinalConfigurationOptions = function (
  setupOptions
) {
  var options =
    SongbirdFramework.prototype._createCardinalConfigurationOptions.call(
      this,
      setupOptions
    );

  options.payment.framework = "inline";

  return options;
};

InlineIframeFramework.prototype._addV1IframeToPage = function () {
  this._emit(
    InlineIframeFramework.events.AUTHENTICATION_IFRAME_AVAILABLE,
    {
      element: this._v1Modal,
    },
    function () {
      // NOOP
    }
  );
};

InlineIframeFramework.prototype._setupFrameworkSpecificListeners = function () {
  this.setCardinalListener("ui.inline.setup", this._onInlineSetup.bind(this));
};

InlineIframeFramework.prototype._onInlineSetup = function (
  htmlTemplate,
  details,
  resolve,
  reject
) {
  var container, hasError;

  if (!htmlTemplate || !details) {
    hasError = true;
  } else if (details.paymentType !== "CCA") {
    hasError = true;
  } else if (
    !(details.data.mode === "suppress" || details.data.mode === "static")
  ) {
    hasError = true;
  }

  if (hasError) {
    reject(new BraintreeError(errors.THREEDS_INLINE_IFRAME_DETAILS_INCORRECT));

    return;
  }

  container = document.createElement("div");
  container.innerHTML = htmlTemplate;

  if (details.data.mode === "suppress") {
    container.style.display = "none";
    document.body.appendChild(container);
    resolve();
  } else if (details.data.mode === "static") {
    this._emit(
      InlineIframeFramework.events.AUTHENTICATION_IFRAME_AVAILABLE,
      {
        element: container,
      },
      function () {
        resolve();
      }
    );
  }
};

module.exports = InlineIframeFramework;

},{"../../../lib/braintree-error":124,"../../../lib/enumerate":134,"../../shared/errors":200,"./songbird":196}],195:[function(_dereq_,module,exports){
"use strict";

var BaseFramework = _dereq_("./base");
var deferred = _dereq_("../../../lib/deferred");

function LegacyFramework(options) {
  BaseFramework.call(this, options);
}

LegacyFramework.prototype = Object.create(BaseFramework.prototype, {
  constructor: LegacyFramework,
});

LegacyFramework.prototype.setUpEventListeners = function () {
  // noop
};

LegacyFramework.prototype.transformV1CustomerBillingAddress = function (
  customer
) {
  customer.billingAddress.line1 = customer.billingAddress.streetAddress;
  customer.billingAddress.line2 = customer.billingAddress.extendedAddress;
  customer.billingAddress.city = customer.billingAddress.locality;
  customer.billingAddress.state = customer.billingAddress.region;
  customer.billingAddress.countryCode =
    customer.billingAddress.countryCodeAlpha2;
  delete customer.billingAddress.streetAddress;
  delete customer.billingAddress.extendedAddress;
  delete customer.billingAddress.locality;
  delete customer.billingAddress.region;
  delete customer.billingAddress.countryCodeAlpha2;

  return customer;
};

LegacyFramework.prototype._createIframe = function (options) {
  var self = this;

  this._setupV1Elements({
    nonce: options.nonce,
    lookupResponse: options.lookupResponse,
    showLoader: options.showLoader,
    handleAuthResponse: function (data) {
      self._handleAuthResponse(data, options);
    },
  });

  return this._v1Iframe;
};

LegacyFramework.prototype._handleAuthResponse = function (data, options) {
  this._v1Bus.teardown();

  options.removeFrame();

  // This also has to be in a setTimeout so it executes after the `removeFrame`.
  deferred(
    function () {
      this._handleV1AuthResponse(data);
    }.bind(this)
  )();
};

LegacyFramework.prototype._checkForFrameworkSpecificVerifyCardErrors =
  function (options) {
    var errorOption;

    if (typeof options.addFrame !== "function") {
      errorOption = "an addFrame function";
    } else if (typeof options.removeFrame !== "function") {
      errorOption = "a removeFrame function";
    }

    return errorOption;
  };

LegacyFramework.prototype._formatVerifyCardOptions = function (options) {
  var modifiedOptions = BaseFramework.prototype._formatVerifyCardOptions.call(
    this,
    options
  );

  modifiedOptions.addFrame = deferred(options.addFrame);
  modifiedOptions.removeFrame = deferred(options.removeFrame);
  modifiedOptions.showLoader = options.showLoader !== false;

  return modifiedOptions;
};

LegacyFramework.prototype._formatLookupData = function (options) {
  var self = this;

  return BaseFramework.prototype._formatLookupData
    .call(this, options)
    .then(function (data) {
      if (options.customer && options.customer.billingAddress) {
        data.customer = self.transformV1CustomerBillingAddress(
          options.customer
        );
      }

      return data;
    });
};

LegacyFramework.prototype._presentChallenge = function (
  lookupResponse,
  options
) {
  options.addFrame(
    null,
    this._createIframe({
      showLoader: options.showLoader,
      lookupResponse: lookupResponse.lookup,
      nonce: lookupResponse.paymentMethod.nonce,
      removeFrame: options.removeFrame,
    })
  );
};

module.exports = LegacyFramework;

},{"../../../lib/deferred":132,"./base":190}],196:[function(_dereq_,module,exports){
"use strict";

var BaseFramework = _dereq_("./base");
var assign = _dereq_("../../../lib/assign").assign;
var deferred = _dereq_("../../../lib/deferred");
var BraintreeError = _dereq_("../../../lib/braintree-error");
var convertToBraintreeError = _dereq_("../../../lib/convert-to-braintree-error");
var analytics = _dereq_("../../../lib/analytics");
var assets = _dereq_("../../../lib/assets");
var errors = _dereq_("../../shared/errors");
var enumerate = _dereq_("../../../lib/enumerate");
var constants = _dereq_("../../shared/constants");
var ExtendedPromise = _dereq_("@braintree/extended-promise");

var INTEGRATION_TIMEOUT_MS =
  _dereq_("../../../lib/constants").INTEGRATION_TIMEOUT_MS;
var PLATFORM = _dereq_("../../../lib/constants").PLATFORM;
var VERSION = "3.101.3";
var CUSTOMER_CANCELED_SONGBIRD_MODAL = "01";
var SONGBIRD_UI_EVENTS = [
  "ui.close",
  "ui.render",

  // TODO these events are not documented in the
  // client reference because so far we have
  // not been able to trigger them in our testing
  "ui.renderHidden",
  "ui.loading.close",
  "ui.loading.render",
];

var SCA_EXEMPTION_TYPES = ["low_value", "transaction_risk_analysis"];

ExtendedPromise.suppressUnhandledPromiseMessage = true;

function SongbirdFramework(options) {
  BaseFramework.call(this, options);

  this._songbirdInitFailed = false;
  this._clientMetadata = {
    requestedThreeDSecureVersion: "2",
    sdkVersion: PLATFORM + "/" + VERSION,
  };
  this.originalSetupOptions = options;
  this._getDfReferenceIdPromisePlus = new ExtendedPromise();
  this.setupSongbird(options);
  this._cardinalEvents = [];
}

SongbirdFramework.prototype = Object.create(BaseFramework.prototype, {
  constructor: SongbirdFramework,
});

SongbirdFramework.events = enumerate(
  [
    "LOOKUP_COMPLETE",
    "CUSTOMER_CANCELED",
    "UI.CLOSE",
    "UI.RENDER",
    "UI.RENDERHIDDEN",
    "UI.LOADING.CLOSE",
    "UI.LOADING.RENDER",
  ],
  "songbird-framework:"
);

SongbirdFramework.prototype.setUpEventListeners = function (reply) {
  this.on(SongbirdFramework.events.LOOKUP_COMPLETE, function (data, next) {
    reply("lookup-complete", data, next);
  });
  this.on(SongbirdFramework.events.CUSTOMER_CANCELED, function () {
    reply("customer-canceled");
  });
  this.on(SongbirdFramework.events["UI.CLOSE"], function () {
    reply("authentication-modal-close");
  });
  this.on(SongbirdFramework.events["UI.RENDER"], function () {
    reply("authentication-modal-render");
  });
  this.on(SongbirdFramework.events["UI.RENDERHIDDEN"], function () {
    reply("authentication-modal-render-hidden");
  });
  this.on(SongbirdFramework.events["UI.LOADING.CLOSE"], function () {
    reply("authentication-modal-loader-close");
  });
  this.on(SongbirdFramework.events["UI.LOADING.RENDER"], function () {
    reply("authentication-modal-loader-render");
  });
};

SongbirdFramework.prototype.prepareLookup = function (options) {
  var data = assign({}, options);
  var self = this;

  return this.getDfReferenceId()
    .then(function (id) {
      data.dfReferenceId = id;
    })
    .then(function () {
      return self._triggerCardinalBinProcess(options.bin);
    })
    .catch(function () {
      // catch and ignore errors from looking up
      // df reference and Cardinal bin process
    })
    .then(function () {
      return self._waitForClient();
    })
    .then(function () {
      data.clientMetadata = self._clientMetadata;
      data.authorizationFingerprint =
        self._client.getConfiguration().authorizationFingerprint;
      data.braintreeLibraryVersion = "braintree/web/" + VERSION;

      return data;
    });
};

SongbirdFramework.prototype.initializeChallengeWithLookupResponse = function (
  lookupResponse,
  options
) {
  return this.setupSongbird().then(
    function () {
      return BaseFramework.prototype.initializeChallengeWithLookupResponse.call(
        this,
        lookupResponse,
        options
      );
    }.bind(this)
  );
};

SongbirdFramework.prototype.handleSongbirdError = function (errorType) {
  this._songbirdInitFailed = true;
  this._removeSongbirdListeners();
  analytics.sendEvent(
    this._createPromise,
    "three-d-secure.cardinal-sdk.songbird-error." + errorType
  );

  if (this._songbirdPromise) {
    this._songbirdPromise.resolve();
  }
};

SongbirdFramework.prototype._triggerCardinalBinProcess = function (bin) {
  var self = this;
  var issuerStartTime = Date.now();

  return window.Cardinal.trigger("bin.process", bin).then(function (
    binResults
  ) {
    self._clientMetadata.issuerDeviceDataCollectionTimeElapsed =
      Date.now() - issuerStartTime;
    self._clientMetadata.issuerDeviceDataCollectionResult =
      binResults && binResults.Status;
  });
};

SongbirdFramework.prototype.transformBillingAddress = function (
  additionalInformation,
  billingAddress
) {
  if (billingAddress) {
    // map from public API to the API that the Gateway expects
    extractAddressData(billingAddress, additionalInformation, "billing");
    additionalInformation.billingPhoneNumber = billingAddress.phoneNumber;
    additionalInformation.billingGivenName = billingAddress.givenName;
    additionalInformation.billingSurname = billingAddress.surname;
  }

  return additionalInformation;
};

SongbirdFramework.prototype.transformShippingAddress = function (
  additionalInformation
) {
  var shippingAddress = additionalInformation.shippingAddress;

  if (shippingAddress) {
    // map from public API to the API that the Gateway expects
    extractAddressData(shippingAddress, additionalInformation, "shipping");

    delete additionalInformation.shippingAddress;
  }

  return additionalInformation;
};

SongbirdFramework.prototype._createV1IframeModalElement = function (iframe) {
  var modal = document.createElement("div");

  modal.innerHTML =
    '<div data-braintree-v1-fallback-iframe-container="true" style="' +
    "height: 400px;" +
    '"></div>';
  modal
    .querySelector('[data-braintree-v1-fallback-iframe-container="true"]')
    .appendChild(iframe);

  return modal;
};

SongbirdFramework.prototype._createV1IframeModal = function (iframe) {
  var modal = this._createV1IframeModalElement(iframe);
  var btn = modal.querySelector("[data-braintree-v1-fallback-close-button]");
  var backdrop = modal.querySelector("[data-braintree-v1-fallback-backdrop]");
  var self = this;

  function closeHandler() {
    modal.parentNode.removeChild(modal);
    self.cancelVerifyCard(errors.THREEDS_CARDINAL_SDK_CANCELED);
    document.removeEventListener("keyup", self._onV1Keyup);
    self._onV1Keyup = null;
  }

  this._onV1Keyup = function (e) {
    if (e.key !== "Escape") {
      return;
    }

    if (!modal.parentNode) {
      // modal not on page
      return;
    }

    closeHandler();
  };

  if (btn) {
    btn.addEventListener("click", closeHandler);
  }

  if (backdrop) {
    backdrop.addEventListener("click", closeHandler);
  }

  document.addEventListener("keyup", this._onV1Keyup);

  return modal;
};

SongbirdFramework.prototype._addV1IframeToPage = function () {
  document.body.appendChild(this._v1Modal);
};

SongbirdFramework.prototype.setupSongbird = function (setupOptions) {
  var self = this;
  var startTime = Date.now();

  if (this._songbirdPromise) {
    return this._songbirdPromise;
  }

  setupOptions = setupOptions || {};

  this._songbirdPromise = new ExtendedPromise();
  this._v2SetupFailureReason = "reason-unknown";

  self
    ._loadCardinalScript(setupOptions)
    .then(function () {
      if (!window.Cardinal) {
        self._v2SetupFailureReason = "cardinal-global-unavailable";

        return Promise.reject(
          new BraintreeError(errors.THREEDS_CARDINAL_SDK_SETUP_FAILED)
        );
      }

      return self._configureCardinalSdk({
        setupOptions: setupOptions,
        setupStartTime: startTime,
      });
    })
    .catch(function (err) {
      var error = convertToBraintreeError(err, {
        type: errors.THREEDS_CARDINAL_SDK_SETUP_FAILED.type,
        code: errors.THREEDS_CARDINAL_SDK_SETUP_FAILED.code,
        message: errors.THREEDS_CARDINAL_SDK_SETUP_FAILED.message,
      });

      self._getDfReferenceIdPromisePlus.reject(error);

      window.clearTimeout(self._songbirdSetupTimeoutReference);
      analytics.sendEvent(
        self._client,
        "three-d-secure.cardinal-sdk.init.setup-failed"
      );
      self.handleSongbirdError(
        "cardinal-sdk-setup-failed." + self._v2SetupFailureReason
      );
    });

  return this._songbirdPromise;
};

SongbirdFramework.prototype._configureCardinalSdk = function (config) {
  var self = this;

  return this._waitForClient()
    .then(function () {
      var threeDSConfig =
        self._client.getConfiguration().gatewayConfiguration.threeDSecure;

      return threeDSConfig;
    })
    .then(function (threeDSConfig) {
      var jwt = threeDSConfig.cardinalAuthenticationJWT;
      var setupOptions = config.setupOptions;
      var setupStartTime = config.setupStartTime;
      var cardinalConfiguration =
        self._createCardinalConfigurationOptions(setupOptions);

      SONGBIRD_UI_EVENTS.forEach(function (eventName) {
        self.setCardinalListener(eventName, function () {
          self._emit(SongbirdFramework.events[eventName.toUpperCase()]);
        });
      });
      self.setCardinalListener(
        "payments.setupComplete",
        self._createPaymentsSetupCompleteCallback()
      );

      self._setupFrameworkSpecificListeners();

      window.Cardinal.configure(cardinalConfiguration);

      window.Cardinal.setup("init", {
        jwt: jwt,
      });

      self._clientMetadata.cardinalDeviceDataCollectionTimeElapsed =
        Date.now() - setupStartTime;

      self.setCardinalListener(
        "payments.validated",
        self._createPaymentsValidatedCallback()
      );
    })
    .catch(function (err) {
      self._v2SetupFailureReason = "cardinal-configuration-threw-error";

      return Promise.reject(err);
    });
};

SongbirdFramework.prototype.setCardinalListener = function (eventName, cb) {
  this._cardinalEvents.push(eventName);
  window.Cardinal.on(eventName, cb);
};

SongbirdFramework.prototype._setupFrameworkSpecificListeners = function () {
  // noop
};

SongbirdFramework.prototype._createCardinalConfigurationOptions = function (
  setupOptions
) {
  var cardinalConfiguration = setupOptions.cardinalSDKConfig || {};
  var paymentSettings = cardinalConfiguration.payment || {};

  if (!cardinalConfiguration.logging && setupOptions.loggingEnabled) {
    cardinalConfiguration.logging = {
      level: "verbose",
    };
  }

  cardinalConfiguration.payment = {};

  if (paymentSettings.hasOwnProperty("displayLoading")) {
    cardinalConfiguration.payment.displayLoading =
      paymentSettings.displayLoading;
  }
  if (paymentSettings.hasOwnProperty("displayExitButton")) {
    cardinalConfiguration.payment.displayExitButton =
      paymentSettings.displayExitButton;
  }

  return cardinalConfiguration;
};

SongbirdFramework.prototype._loadCardinalScript = function (setupOptions) {
  var self = this;

  return this._waitForClient()
    .then(function () {
      var scriptSource = self._getCardinalScriptSource();

      self._songbirdSetupTimeoutReference = window.setTimeout(function () {
        analytics.sendEvent(
          self._client,
          "three-d-secure.cardinal-sdk.init.setup-timeout"
        );
        self.handleSongbirdError("cardinal-sdk-setup-timeout");
      }, setupOptions.timeout || INTEGRATION_TIMEOUT_MS);

      return assets.loadScript({ src: scriptSource });
    })
    .catch(function (err) {
      self._v2SetupFailureReason = "songbird-js-failed-to-load";

      return Promise.reject(
        convertToBraintreeError(
          err,
          errors.THREEDS_CARDINAL_SDK_SCRIPT_LOAD_FAILED
        )
      );
    });
};

SongbirdFramework.prototype._getCardinalScriptSource = function () {
  var gatewayConfig = this._client.getConfiguration().gatewayConfiguration;

  if (gatewayConfig && gatewayConfig.environment === "production") {
    return constants.CARDINAL_SCRIPT_SOURCE.production;
  }

  return constants.CARDINAL_SCRIPT_SOURCE.sandbox;
};

SongbirdFramework.prototype._createPaymentsSetupCompleteCallback = function () {
  var self = this;

  return function (data) {
    self._getDfReferenceIdPromisePlus.resolve(data.sessionId);

    window.clearTimeout(self._songbirdSetupTimeoutReference);
    analytics.sendEvent(
      self._createPromise,
      "three-d-secure.cardinal-sdk.init.setup-completed"
    );

    self._songbirdPromise.resolve();
  };
};

SongbirdFramework.prototype.getDfReferenceId = function () {
  return this._getDfReferenceIdPromisePlus;
};

SongbirdFramework.prototype._performJWTValidation = function (
  rawCardinalSDKVerificationData,
  jwt
) {
  var self = this;
  var nonce = this._lookupPaymentMethod.nonce;
  var url =
    "payment_methods/" + nonce + "/three_d_secure/authenticate_from_jwt";
  var cancelCode =
    rawCardinalSDKVerificationData &&
    rawCardinalSDKVerificationData.Payment &&
    rawCardinalSDKVerificationData.Payment.ExtendedData &&
    rawCardinalSDKVerificationData.Payment.ExtendedData.ChallengeCancel;

  if (cancelCode) {
    // see ChallengeCancel docs here for different values:
    // https://cardinaldocs.atlassian.net/wiki/spaces/CC/pages/98315/Response+Objects
    analytics.sendEvent(
      this._createPromise,
      "three-d-secure.verification-flow.cardinal-sdk.cancel-code." + cancelCode
    );

    if (cancelCode === CUSTOMER_CANCELED_SONGBIRD_MODAL) {
      this._emit(SongbirdFramework.events.CUSTOMER_CANCELED);
    }
  }

  analytics.sendEvent(
    this._createPromise,
    "three-d-secure.verification-flow.upgrade-payment-method.started"
  );

  return this._waitForClient()
    .then(function () {
      return self._client.request({
        method: "post",
        endpoint: url,
        data: {
          jwt: jwt,
          paymentMethodNonce: nonce,
        },
      });
    })
    .then(function (response) {
      var paymentMethod = response.paymentMethod || self._lookupPaymentMethod;
      var formattedResponse = self._formatAuthResponse(
        paymentMethod,
        response.threeDSecureInfo
      );

      formattedResponse.rawCardinalSDKVerificationData =
        rawCardinalSDKVerificationData;
      analytics.sendEvent(
        self._client,
        "three-d-secure.verification-flow.upgrade-payment-method.succeeded"
      );

      return Promise.resolve(formattedResponse);
    })
    .catch(function (err) {
      var error = new BraintreeError({
        type: errors.THREEDS_JWT_AUTHENTICATION_FAILED.type,
        code: errors.THREEDS_JWT_AUTHENTICATION_FAILED.code,
        message: errors.THREEDS_JWT_AUTHENTICATION_FAILED.message,
        details: {
          originalError: err,
        },
      });

      analytics.sendEvent(
        self._client,
        "three-d-secure.verification-flow.upgrade-payment-method.errored"
      );

      return Promise.reject(error);
    });
};

SongbirdFramework.prototype._createPaymentsValidatedCallback = function () {
  var self = this;

  /**
   * @param {object} data Response Data
   * @see {@link https://cardinaldocs.atlassian.net/wiki/spaces/CC/pages/98315/Response+Objects#ResponseObjects-ObjectDefinition}
   * @param {string} data.ActionCode The resulting state of the transaction.
   * @param {boolean} data.Validated Represents whether transaction was successfully or not.
   * @param {object} data.Payment Represents additional information about the verification.
   * @param {number} data.ErrorNumber A non-zero value represents the error encountered while attempting the process the message request.
   * @param {string} data.ErrorDescription Application error description for the associated error number.
   * @param {string} validatedJwt Response JWT
   * @returns {void}
   * */
  return function (data, validatedJwt) {
    var formattedError;

    analytics.sendEvent(
      self._createPromise,
      "three-d-secure.verification-flow.cardinal-sdk.action-code." +
        data.ActionCode.toLowerCase()
    );

    if (!self._verifyCardPromisePlus) {
      self.handleSongbirdError(
        "cardinal-sdk-setup-error.number-" + data.ErrorNumber
      );

      return;
    }

    switch (data.ActionCode) {
      // Handle these scenarios based on liability shift information in the response.
      case "SUCCESS":
      case "NOACTION":
      case "FAILURE":
        self
          ._performJWTValidation(data, validatedJwt)
          .then(function (result) {
            self._verifyCardPromisePlus.resolve(result);
          })
          .catch(function (err) {
            self._verifyCardPromisePlus.reject(err);
          });
        break;

      case "ERROR":
        analytics.sendEvent(
          self._createPromise,
          "three-d-secure.verification-flow.cardinal-sdk-error." +
            data.ErrorNumber
        );

        switch (data.ErrorNumber) {
          case 10001: // Cardinal Docs: Timeout when sending an /Init message
          case 10002: // Cardinal Docs: Timeout when sending an /Start message
            formattedError = new BraintreeError(
              errors.THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT
            );
            break;
          case 10003: // Cardinal Docs: Timeout when sending an /Validate message. Although this code exists we do not yet have a flow where a validate message is sent to Midas. This error should not yet be triggered
          case 10007: // Cardinal Docs: Timeout when sending an /Confirm message
          case 10009: // Cardinal Docs: Timeout when sending an /Continue message
            formattedError = new BraintreeError(
              errors.THREEDS_CARDINAL_SDK_RESPONSE_TIMEDOUT
            );
            break;
          case 10005: // Cardinal Docs: Songbird was started without a request jwt.
          case 10006: // Cardinal Docs: This is a general configuration error. The description is populated by the specific configuration error that caused the error.
            formattedError = new BraintreeError(
              errors.THREEDS_CARDINAL_SDK_BAD_CONFIG
            );
            break;
          case 10008: // Cardinal Docs: Songbird was initialized without a merchant JWT.
          case 10010: // Cardinal Docs: The response JWT was
            formattedError = new BraintreeError(
              errors.THREEDS_CARDINAL_SDK_BAD_JWT
            );
            break;
          case 10011:
            // This may never get called, according to the Cardinal docs:
            // The user has canceled the transaction. This is generally found in alternative
            // payments that supply a cancel button on the payment brand side.
            analytics.sendEvent(
              self._createPromise,
              "three-d-secure.verification-flow.canceled"
            );
            formattedError = new BraintreeError(
              errors.THREEDS_CARDINAL_SDK_CANCELED
            );
            break;
          default:
            formattedError = new BraintreeError(
              errors.THREEDS_CARDINAL_SDK_ERROR
            );
        }

        formattedError.details = {
          originalError: {
            code: data.ErrorNumber,
            description: data.ErrorDescription,
          },
        };

        self._verifyCardPromisePlus.reject(formattedError);
        break;

      default:
    }
  };
};

SongbirdFramework.prototype._checkForVerifyCardError = function (
  options,
  privateOptions
) {
  if (!options.bin) {
    return new BraintreeError({
      type: errors.THREEDS_MISSING_VERIFY_CARD_OPTION.type,
      code: errors.THREEDS_MISSING_VERIFY_CARD_OPTION.code,
      message: "verifyCard options must include a BIN.",
    });
  }

  return BaseFramework.prototype._checkForVerifyCardError.call(
    this,
    options,
    privateOptions
  );
};

SongbirdFramework.prototype._checkForFrameworkSpecificVerifyCardErrors =
  function (options, privateOptions) {
    var errorOption;

    if (
      typeof options.onLookupComplete !== "function" &&
      !privateOptions.ignoreOnLookupCompleteRequirement
    ) {
      errorOption = "an onLookupComplete function";
    }

    return errorOption;
  };

SongbirdFramework.prototype._formatVerifyCardOptions = function (options) {
  var modifiedOptions = BaseFramework.prototype._formatVerifyCardOptions.call(
    this,
    options
  );
  var additionalInformation = modifiedOptions.additionalInformation || {};

  additionalInformation = this.transformBillingAddress(
    additionalInformation,
    options.billingAddress
  );
  additionalInformation = this.transformShippingAddress(additionalInformation);

  if (options.onLookupComplete) {
    modifiedOptions.onLookupComplete = deferred(options.onLookupComplete);
  }
  if (options.email) {
    additionalInformation.email = options.email;
  }
  if (options.mobilePhoneNumber) {
    additionalInformation.mobilePhoneNumber = options.mobilePhoneNumber;
  }

  modifiedOptions.additionalInformation = additionalInformation;

  return modifiedOptions;
};

SongbirdFramework.prototype._onLookupComplete = function (
  lookupResponse,
  options
) {
  var self = this;

  return BaseFramework.prototype._onLookupComplete
    .call(this, lookupResponse)
    .then(function (response) {
      return new Promise(function (resolve, reject) {
        // NEXT_MAJOR_VERSION format this response object to look like the mobile sdk response
        // which is basically the lookup param at the top level with some additional accessors
        response.requiresUserAuthentication = Boolean(
          response.lookup && response.lookup.acsUrl
        );

        function next() {
          resolve(response);
        }

        self._verifyCardPromisePlus.catch(reject);

        // If both event and callback are mistakenly used together,
        // prefer the callback when it is passed into the verifyCard options
        if (options.onLookupComplete) {
          options.onLookupComplete(response, next);
        } else {
          self._emit(SongbirdFramework.events.LOOKUP_COMPLETE, response, next);
        }
      });
    });
};

SongbirdFramework.prototype._presentChallenge = function (lookupResponse) {
  // transactionId is required for the Songbird flow, so if it
  // does not exist, we just return
  if (this._songbirdInitFailed || !lookupResponse.lookup.transactionId) {
    return;
  }

  // set up listener for ref id to call out to bt before calling verify callback
  window.Cardinal.continue(
    "cca",
    {
      AcsUrl: lookupResponse.lookup.acsUrl,
      Payload: lookupResponse.lookup.pareq,
    },
    {
      OrderDetails: { TransactionId: lookupResponse.lookup.transactionId },
    }
  );
};

SongbirdFramework.prototype._formatLookupData = function (options) {
  var self = this;

  return BaseFramework.prototype._formatLookupData
    .call(this, options)
    .then(function (data) {
      data.additionalInfo = options.additionalInformation;

      if (options.accountType) {
        data.accountType = options.accountType;
      }
      if (options.challengeRequested) {
        data.challengeRequested = options.challengeRequested;
      }
      if (options.requestedExemptionType) {
        if (!SCA_EXEMPTION_TYPES.includes(options.requestedExemptionType)) {
          throw new BraintreeError({
            code: errors.THREEDS_REQUESTED_EXEMPTION_TYPE_INVALID.code,
            type: errors.THREEDS_REQUESTED_EXEMPTION_TYPE_INVALID.type,
            message:
              "requestedExemptionType `" +
              options.requestedExemptionType +
              "` is not a valid exemption. The accepted values are: `" +
              SCA_EXEMPTION_TYPES.join("`, `") +
              "`",
          });
        }
        data.requestedExemptionType = options.requestedExemptionType;
      }
      if (options.customFields) {
        data.customFields = options.customFields;
      }
      if (options.dataOnlyRequested) {
        data.dataOnlyRequested = options.dataOnlyRequested;
      }
      if (options.exemptionRequested) {
        data.exemptionRequested = options.exemptionRequested;
      }
      if (options.requestVisaDAF) {
        data.requestVisaDAF = options.requestVisaDAF;
      }
      if (options.bin) {
        data.bin = options.bin;
      }
      // NEXT_MAJOR_VERSION remove cardAdd in favor of cardAddChallengeRequested
      if (options.cardAdd != null) {
        data.cardAdd = options.cardAdd;
      }
      if (options.cardAddChallengeRequested != null) {
        data.cardAdd = options.cardAddChallengeRequested;
      }
      if (options.merchantName) {
        data.merchantName = options.merchantName;
      }

      return self.prepareLookup(data);
    });
};

SongbirdFramework.prototype.cancelVerifyCard = function (verifyCardError) {
  var self = this;

  return BaseFramework.prototype.cancelVerifyCard
    .call(this)
    .then(function (response) {
      if (self._verifyCardPromisePlus) {
        verifyCardError =
          verifyCardError ||
          new BraintreeError(errors.THREEDS_VERIFY_CARD_CANCELED_BY_MERCHANT);

        self._verifyCardPromisePlus.reject(verifyCardError);
      }

      return response;
    });
};

SongbirdFramework.prototype._removeSongbirdListeners = function () {
  this._cardinalEvents.forEach(function (eventName) {
    window.Cardinal.off(eventName);
  });

  this._cardinalEvents = [];
};

SongbirdFramework.prototype.teardown = function () {
  if (window.Cardinal) {
    this._removeSongbirdListeners();
  }

  // we intentionally do not remove the Cardinal SDK
  // from the page when tearing down. Subsequent
  // component creations will be faster because
  // the asset is already on the page

  return BaseFramework.prototype.teardown.call(this);
};

SongbirdFramework.prototype._reloadThreeDSecure = function () {
  var self = this;
  var startTime = Date.now();

  return self.teardown().then(function () {
    self._configureCardinalSdk({
      setupOptions: self.originalSetupOptions,
      setupStartTime: startTime,
    });
  });
};

function extractAddressData(source, target, prefix) {
  target[prefix + "Line1"] = source.streetAddress;
  target[prefix + "Line2"] = source.extendedAddress;
  target[prefix + "Line3"] = source.line3;
  target[prefix + "City"] = source.locality;
  target[prefix + "State"] = source.region;
  target[prefix + "PostalCode"] = source.postalCode;
  target[prefix + "CountryCode"] = source.countryCodeAlpha2;
}

module.exports = SongbirdFramework;

},{"../../../lib/analytics":119,"../../../lib/assets":120,"../../../lib/assign":121,"../../../lib/braintree-error":124,"../../../lib/constants":126,"../../../lib/convert-to-braintree-error":128,"../../../lib/deferred":132,"../../../lib/enumerate":134,"../../shared/constants":199,"../../shared/errors":200,"./base":190,"@braintree/extended-promise":34}],197:[function(_dereq_,module,exports){
"use strict";

var wrapPromise = _dereq_("@braintree/wrap-promise");
var methods = _dereq_("../../lib/methods");
var convertMethodsToError = _dereq_("../../lib/convert-methods-to-error");
var EventEmitter = _dereq_("@braintree/event-emitter");
var FRAMEWORKS = _dereq_("./frameworks");

/**
 * @deprecated
 * @callback ThreeDSecure~addFrameCallback
 * @param {?BraintreeError} [err] `null` or `undefined` if there was no error.
 * @param {HTMLIFrameElement} iframe An iframe element containing the bank's authentication page that you must put on your page.
 * @description **Deprecated** The callback used for options.addFrame in 3DS 1.0's {@link ThreeDSecure#verifyCard|verifyCard}.
 * @returns {void}
 */

/**
 * @deprecated
 * @callback ThreeDSecure~removeFrameCallback
 * @description **Deprecated** The callback used for options.removeFrame in 3DS 1.0's {@link ThreeDSecure#verifyCard|verifyCard}.
 * @returns {void}
 */

/**
 * @deprecated
 * @typedef {object} ThreeDSecure~verifyCardCustomerObject
 * @property {string} [customer.mobilePhoneNumber] The mobile phone number used for verification. Only numbers; remove dashes, parenthesis and other characters.
 * @property {string} [customer.email] The email used for verification.
 * @property {string} [customer.shippingMethod] The 2-digit string indicating the shipping method chosen for the transaction.
 * @property {string} [customer.billingAddress.firstName] The first name associated with the address.
 * @property {string} [customer.billingAddress.lastName] The last name associated with the address.
 * @property {string} [customer.billingAddress.streetAddress] Line 1 of the Address (eg. number, street, etc).
 * @property {string} [customer.billingAddress.extendedAddress] Line 2 of the Address (eg. suite, apt #, etc.).
 * @property {string} [customer.billingAddress.locality] The locality (city) name associated with the address.
 * @property {string} [customer.billingAddress.region] The 2 letter code for US states or an ISO-3166-2 country subdivision code of up to three letters.
 * @property {string} [customer.billingAddress.postalCode] The zip code or equivalent for countries that have them.
 * @property {string} [customer.billingAddress.countryCodeAlpha2] The 2 character country code.
 * @property {string} [customer.billingAddress.phoneNumber] The phone number associated with the address. Only numbers; remove dashes, parenthesis and other characters.
 * @description **Deprecated** Optional customer information to be passed to 3DS 1.0 for verification.
 */

/**
 * @typedef {object} ThreeDSecure~verifyPayload
 * @property {string} nonce The new payment method nonce produced by the 3D Secure lookup. The original nonce passed into {@link ThreeDSecure#verifyCard|verifyCard} was consumed. This new nonce should be used to transact on your server.
 * @property {string} type The payment method type.
 * @property {object} details Additional account details.
 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
 * @property {string} details.lastFour Last four digits of card number.
 * @property {string} details.lastTwo Last two digits of card number.
 * @property {string} description A human-readable description.
 * @property {object} binData Information about the card based on the bin.
 * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.countryOfIssuance The country of issuance.
 * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.issuingBank The issuing bank.
 * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.productId The product id.
 * @property {boolean} liabilityShiftPossible *Deprecated:* Use `threeDSecureInfo.liabilityShiftPossible` instead.
 * @property {boolean} liabilityShifted *Deprecated:* Use `threeDSecureInfo.liabilityShifted` instead.
 * @property {object} threeDSecureInfo 3DS information about the card. Note: This information should be verified on the server by using the [payment method nonce find method](https://developer.paypal.com/braintree/docs/reference/request/payment-method-nonce/find). The values provided here are merely for convenience. Only values looked up on the server should determine the logic about how to process a transaction.
 * @property {string} threeDSecureInfo.acsTransactionId The transaction identifier from the issuing bank.
 * @property {string} threeDSecureInfo.cavv Cardholder authentication verification value or CAVV. The main encrypted message issuers and card networks use to verify authentication has occurred. Mastercard uses an AVV message and American Express uses an AEVV message, each of which should also be passed in the cavv parameter.
 * @property {string} threeDSecureInfo.dsTransactionId Transaction identifier resulting from 3D Secure 2 authentication.
 * @property {string} threeDSecureInfo.eciFlag The value of the electronic commerce indicator (ECI) flag, which indicates the outcome of the 3DS authentication. This will be a two-digit value.
 * @property {boolean} threeDSecureInfo.enrolled Indicates the status of 3D Secure authentication eligibility with the card issuer.
 * @property {boolean} threeDSecureInfo.liabilityShifted Indicates whether the liability for fraud has been shifted away from the merchant.
 * @property {boolean} threeDSecureInfo.liabilityShiftPossible Indicates whether liability shift is still possible on a retry.
 * @property {string} threeDSecureInfo.paresStatus Transaction status result identifier.
 * @property {string} threeDSecureInfo.status Indicates the outcome of the 3D Secure event.
 * @property {string} threeDSecureInfo.threeDSecureAuthenticationId ID of the 3D Secure authentication performed for this transaction. Do not provide this field as a transaction sale parameter if you are using the returned payment method nonce from the payload.
 * @property {string} threeDSecureInfo.threeDSecureServerTransactionId Transaction identifier provided by the issuing bank who recieved the 3D Secure event.
 * @property {string} threeDSecureInfo.threeDSecureVersion The version of 3D Secure authentication used for the transaction.
 * @property {string} threeDSecureInfo.xid Transaction identifier resulting from 3D Secure authentication. Uniquely identifies the transaction and sometimes required in the authorization message. This is a base64-encoded value. This field will no longer be used in 3D Secure 2 authentications for Visa and Mastercard, however it will be supported by American Express.
 * @property {string} threeDSecureInfo.lookup.transStatus Error code returned from the 3D Secure MPI provider.
 * @property {string} threeDSecureInfo.lookup.transStatusReason Description correlating to the transStatus error code.
 * @property {string} threeDSecureInfo.authentication.transStatus Error code returned from the 3D Secure MPI provider.
 * @property {string} threeDSecureInfo.authentication.transStatusReason Description correlating to the transStatus error code.
 * @property {object} rawCardinalSDKVerificationData The response back from the Cardinal SDK after verification has completed. See [Cardinal's Documentation](https://cardinaldocs.atlassian.net/wiki/spaces/CC/pages/98315/Response+Objects) for more information. If the customer was not required to do a 3D Secure challenge, this object will not be available.
 */

/**
 * @typedef {string} ThreeDSecure~prepareLookupPayload The client data to pass on when doing a server side lookup call.
 */

/**
 * @typedef {object} ThreeDSecure~verificationData
 * @property {boolean} requiresUserAuthentication When `true`, the user will be presented with a 3D Secure challenge when calling `next` in the {@link ThreeDSecure#event:lookup-complete|`lookup-complete` event}.
 * @property {object} threeDSecureInfo Contains liability shift details.
 * @property {boolean} threeDSecureInfo.liabilityShiftPossible Indicates whether the card was eligible for 3D Secure.
 * @property {boolean} threeDSecureInfo.liabilityShifted Indicates whether the liability for fraud has been shifted away from the merchant.
 * @property {object} paymentMethod A {@link ThreeDSecure~verifyPayload|verifyPayload} object.
 * @property {object} lookup Details about the 3D Secure lookup.
 * @property {string} lookup.threeDSecureVersion The version of 3D Secure that will be used for the 3D Secure challenge.
 */

/**
 * @typedef {object} ThreeDSecure~billingAddress
 * @property {string} [givenName] The first name associated with the billing address. (maximum length 50, ASCII characters)
 * @property {string} [surname] The last name associated with the billing address. (maximum length 50, ASCII characters)
 * @property {string} [phoneNumber] The phone number associated with the billing address. Only numbers; remove dashes, parenthesis and other characters.
 * @property {string} [streetAddress] Line 1 of the billing address (eg. number, street, etc). (maximum length 50)
 * @property {string} [extendedAddress] Line 2 of the billing address (eg. suite, apt #, etc.). (maximum length 50)
 * @property {string} [line3] Line 3 of the billing address if needed (eg. suite, apt #, etc). (maximum length 50)
 * @property {string} [locality] The locality (city) name associated with the billing address.
 * @property {string} [region] This field expects an ISO3166-2 subdivision code. The subdivision code is what follows the hyphen separator in the full ISO 3166-2 code. For example, the state of Ohio in the United States we expect "OH" as opposed to the full ISO 3166-2 code "US-OH".
 * @property {string} [postalCode] The zip code or equivalent for countries that have them.
 * @property {string} [countryCodeAlpha2] The 2 character country code.
 */

/**
 * @typedef {object} ThreeDSecure~additionalInformation
 * @property {string} [workPhoneNumber] The work phone number used for verification. Only numbers; remove dashes, parenthesis and other characters. (maximum length 25)
 * @property {string} [shippingGivenName] The first name associated with the shipping address. (maximum length 50, ASCII characters)
 * @property {string} [shippingSurname] The last name associated with the shipping address. (maximum length 50, ASCII characters)
 * @property {object} [shippingAddress]
 * @property {string} [shippingAddress.streetAddress] Line 1 of the shipping address (eg. number, street, etc). (maximum length 50)
 * @property {string} [shippingAddress.extendedAddress] Line 2 of the shipping address (eg. suite, apt #, etc.). (maximum length 50)
 * @property {string} [shippingAddress.line3] Line 3 of the shipping address if needed (eg. suite, apt #, etc). (maximum length 50)
 * @property {string} [shippingAddress.locality] The locality (city) name associated with the shipping address. (maximum length 50)
 * @property {string} [shippingAddress.region] This field expects an ISO3166-2 subdivision code. The subdivision code is what follows the hyphen separator in the full ISO 3166-2 code. For example, the state of Ohio in the United States we expect "OH" as opposed to the full ISO 3166-2 code "US-OH".
 * @property {string} [shippingAddress.postalCode] The zip code or equivalent for countries that have them. (maximum length 10)
 * @property {string} [shippingAddress.countryCodeAlpha2] The 2 character country code. (maximum length 2)
 * @property {string} [shippingPhone] The phone number associated with the shipping address. Only numbers; remove dashes, parenthesis and other characters. (maximum length 20)
 * @property {string} [shippingMethod] The 2-digit string indicating the name of the shipping method chosen for the transaction. (maximum length 50) Possible values:
 * - `01` Same Day
 * - `02` Overnight / Expedited
 * - `03` Priority (2-3 Days)
 * - `04` Ground
 * - `05` Electronic Delivery
 * - `06` Ship to Store
 * @property {string} [shippingMethodIndicator] The 2-digit string indicating the shipping method chosen for the transaction Possible values.
 * - `01` Ship to cardholder billing address
 * - `02` Ship to another verified address on file with merchant
 * - `03` Ship to address that is different from billing address
 * - `04` Ship to store (store address should be populated on request)
 * - `05` Digital goods
 * - `06` Travel and event tickets, not shipped
 * - `07` Other
 * @property {string} [productCode] The 3-letter string representing the merchant product code. Possible values:
 * - `AIR` Airline
 * - `GEN` General Retail
 * - `DIG` Digital Goods
 * - `SVC` Services
 * - `RES` Restaurant
 * - `TRA` Travel
 * - `DSP` Cash Dispensing
 * - `REN` Car Rental
 * - `GAS` Fuel
 * - `LUX` Luxury Retail
 * - `ACC` Accommodation Retail
 * - `TBD` Other
 * @property {string} [deliveryTimeframe] The 2-digit number indicating the delivery time frame. Possible values:
 * - `01` Electronic delivery
 * - `02` Same day shipping
 * - `03` Overnight shipping
 * - `04` Two or more day shipping
 * @property {string} [deliveryEmail] For electronic delivery, email address to which the merchandise was delivered. (maximum length 254)
 * @property {string} [reorderindicator] The 2-digit number indicating whether the cardholder is reordering previously purchased merchandise. possible values:
 * - `01` First time ordered
 * - `02` Reordered
 * @property {string} [preorderIndicator] The 2-digit number indicating whether cardholder is placing an order with a future availability or release date. possible values:
 * - `01` Merchandise available
 * - `02` Future availability
 * @property {string} [preorderDate] The 8-digit number (format: YYYYMMDD) indicating expected date that a pre-ordered purchase will be available.
 * @property {string} [giftCardAmount] The purchase amount total for prepaid gift cards in major units. (maximum length 15)
 * @property {string} [giftCardCurrencyCode] ISO 4217 currency code for the gift card purchased. (maximum length 3)
 * @property {string} [giftCardCount] Total count of individual prepaid gift cards purchased. (maximum length 2)
 * @property {string} [accountAgeIndicator] The 2-digit value representing the length of time cardholder has had account. Possible values:
 * - `01` No Account
 * - `02` Created during transaction
 * - `03` Less than 30 days
 * - `04` 30-60 days
 * - `05` More than 60 days
 * @property {string} [accountCreateDate] The 8-digit number (format: YYYYMMDD) indicating the date the cardholder opened the account.
 * @property {string} [accountChangeIndicator] The 2-digit value representing the length of time since the last change to the cardholder account. This includes shipping address, new payment account or new user added. Possible values:
 * - `01` Changed during transaction
 * - `02` Less than 30 days
 * - `03` 30-60 days
 * - `04` More than 60 days
 * @property {string} [accountChangeDate] The 8-digit number (format: YYYYMMDD) indicating the date the cardholder's account was last changed. This includes changes to the billing or shipping address, new payment accounts or new users added.
 * @property {string} [accountPwdChangeIndicator] The 2-digit value representing the length of time since the cardholder changed or reset the password on the account. Possible values:
 * - `01` No change
 * - `02` Changed during transaction
 * - `03` Less than 30 days
 * - `04` 30-60 days
 * - `05` More than 60 days
 * @property {string} [accountPwdChangeDate] The 8-digit number (format: YYYYMMDD) indicating the date the cardholder last changed or reset password on account.
 * @property {string} [shippingAddressUsageIndicator] The 2-digit value indicating when the shipping address used for transaction was first used. Possible values:
 * - `01` This transaction
 * - `02` Less than 30 days
 * - `03` 30-60 days
 * - `04` More than 60 days
 * @property {string} [shippingAddressUsageDate] The 8-digit number (format: YYYYMMDD) indicating the date when the shipping address used for this transaction was first used.
 * @property {string} [transactionCountDay] Number of transactions (successful or abandoned) for this cardholder account within the last 24 hours. (maximum length 3)
 * @property {string} [transactionCountYear] Number of transactions (successful or abandoned) for this cardholder account within the last year. (maximum length 3)
 * @property {string} [addCardAttempts] Number of add card attempts in the last 24 hours. (maximum length 3)
 * @property {string} [accountPurchases] Number of purchases with this cardholder account during the previous six months.
 * @property {string} [fraudActivity] The 2-digit value indicating whether the merchant experienced suspicious activity (including previous fraud) on the account. Possible values:
 * - `01` No suspicious activity
 * - `02` Suspicious activity observed
 * @property {string} [shippingNameIndicator] The 2-digit value indicating if the cardholder name on the account is identical to the shipping name used for the transaction. Possible values:
 * - `01` Account and shipping name identical
 * - `02` Account and shipping name differ
 * @property {string} [paymentAccountIndicator] The 2-digit value indicating the length of time that the payment account was enrolled in the merchant account. Possible values:
 * - `01` No account (guest checkout)
 * - `02` During the transaction
 * - `03` Less than 30 days
 * - `04` 30-60 days
 * - `05` More than 60 days
 * @property {string} [paymentAccountAge] The 8-digit number (format: YYYYMMDD) indicating the date the payment account was added to the cardholder account.
 * @property {string} [acsWindowSize] The 2-digit number to set the challenge window size to display to the end cardholder.  The ACS will reply with content that is formatted appropriately to this window size to allow for the best user experience.  The sizes are width x height in pixels of the window displayed in the cardholder browser window. Possible values:
 * - `01` 250x400
 * - `02` 390x400
 * - `03` 500x600
 * - `04` 600x400
 * - `05` Full page
 * @property {string} [sdkMaxTimeout] The 2-digit number of minutes (minimum 05) to set the maximum amount of time for all 3DS 2.0 messages to be communicated between all components.
 * @property {string} [addressMatch] The 1-character value (Y/N) indicating whether cardholder billing and shipping addresses match.
 * @property {string} [accountId] Additional cardholder account information. (maximum length 64)
 * @property {string} [ipAddress] The IP address of the consumer. IPv4 and IPv6 are supported.
 * - only one IP address supported
 * - only numbers, letters, period '.' chars, or colons ':' are acceptable
 * @property {string} [orderDescription] Brief description of items purchased. (maximum length 256)
 * @property {string} [taxAmount] Unformatted tax amount without any decimalization (ie. $123.67 = 12367). (maximum length 20)
 * @property {string} [userAgent] The exact content of the HTTP user agent header. (maximum length 500)
 * @property {string} [authenticationIndicator] The 2-digit number indicating the type of authentication request. Possible values:
 *  - `01` Payment
 *  - `02` Recurring transaction
 *  - `03` Installment
 *  - `04` Add card
 *  - `05` Maintain card
 *  - `06` Cardholder verification as part of EMV token ID&V
 * @property {string} [installment] An integer value greater than 1 indicating the maximum number of permitted authorizations for installment payments. (maximum length 3)
 * @property {string} [purchaseDate] The 14-digit number (format: YYYYMMDDHHMMSS) indicating the date in UTC of original purchase.
 * @property {string} [recurringEnd] The 8-digit number (format: YYYYMMDD) indicating the date after which no further recurring authorizations should be performed.
 * @property {string} [recurringFrequency] Integer value indicating the minimum number of days between recurring authorizations. A frequency of monthly is indicated by the value 28. Multiple of 28 days will be used to indicate months (ex. 6 months = 168). (maximum length 3)
 */

/**
 * @name ThreeDSecure#on
 * @function
 * @param {string} event The name of the event to which you are subscribing.
 * @param {function} handler A callback to handle the event.
 * @description Subscribes a handler function to a named event. The following events are available:
 *   * {@link ThreeDSecure#event:lookup-complete|lookup-complete}
 *   * {@link ThreeDSecure#event:customer-canceled|customer-canceled}
 *   * {@link ThreeDSecure#event:authentication-iframe-available|authentication-iframe-available}
 *   * {@link ThreeDSecure#event:authentication-modal-render|authentication-modal-render}
 *   * {@link ThreeDSecure#event:authentication-modal-close|authentication-modal-close}
 * @example
 * <caption>Listening to a 3D Secure event</caption>
 * braintree.threeDSecure.create({ ... }, function (createErr, threeDSecureInstance) {
 *   threeDSecureInstance.on('lookup-complete', function (data, next) {
 *     console.log('data from the lookup', data);
 *     next();
 *   });
 *   threeDSecureInstance.on('customer-canceled', function () {
 *     console.log('log that the customer canceled');
 *   });
 * });
 * @returns {void}
 */

/**
 * @name ThreeDSecure#off
 * @function
 * @param {string} event The name of the event to which you are unsubscribing.
 * @param {function} handler The callback for the event you are unsubscribing from.
 * @description Unsubscribes the handler function to a named event.
 * @example
 * <caption>Subscribing and then unsubscribing from a 3D Secure eld event</caption>
 * braintree.threeDSecure.create({ ... }, function (createErr, threeDSecureInstance) {
 *   var lookupCallback = function (data, next) {
 *     console.log(data);
 *     next();
 *   };
 *   var cancelCallback = function () {
 *     // log the cancelation
 *     // or update UI
 *   };
 *
 *   threeDSecureInstance.on('lookup-complete', lookupCallback);
 *   threeDSecureInstance.on('customer-canceled', cancelCallback);
 *
 *   // later on
 *   threeDSecureInstance.off('lookup-complete', lookupCallback);
 *   threeDSecureInstance.off('customer-canceled', cancelCallback);
 * });
 * @returns {void}
 */

/**
 * This event is emitted when the `2-inline-iframe` version is specified when creating the 3D Secure instance and the authentication iframe becomes available.
 * @event ThreeDSecure#authentication-iframe-available
 * @example
 * <caption>Listening for the authentication iframe to be available</caption>
 *   threeDSecureInstance.on('authentication-iframe-available', function (event, next) {
 *     document.body.appendChild(event.element); // add iframe element to page
 *
 *     next(); // let the SDK know the iframe is ready
 *   });
 * });
 */

/**
 * This event is emitted when using the 3D Secure 2.0 flow and the initial lookup request completes. If this is not used, a `onLookupComplete` callback must be passed into the `verifyCard` method.
 * @event ThreeDSecure#lookup-complete
 * @example
 * <caption>Listening for when the lookup request is complete</caption>
 * braintree.threeDSecure.create({
 *   client: clientInstance,
 *   version: '2'
 * }, function (createErr, threeDSecureInstance) {
 *   threeDSecureInstance.on('lookup-complete', function (data, next) {
 *     // inspect the data
 *
 *     // call next when ready to proceed with the challenge
 *     next();
 *   });
 * });
 */

/**
 * This event is emitted when using the 3D Secure 2.0 flow and the customer cancels the 3D Secure challenge.
 * @event ThreeDSecure#customer-canceled
 * @example
 * <caption>Listening for when the customer cancels the 3D Secure challenge</caption>
 * braintree.threeDSecure.create({
 *   client: clientInstance,
 *   version: '2'
 * }, function (createErr, threeDSecureInstance) {
 *   threeDSecureInstance.on('customer-canceled', function () {
 *     // the customer canceled the 3D Secure challenge
 *   });
 * });
 */

/**
 * This event is emitted when using the 3D Secure 2.0 flow and the authentication modal closes, either because the authentication was completed or because the customer canceled the process.
 * @event ThreeDSecure#authentication-modal-close
 * @example
 * braintree.threeDSecure.create({
 *   client: clientInstance,
 *   version: '2'
 * }, function (createErr, threeDSecureInstance) {
 *   threeDSecureInstance.on('authentication-modal-close', function () {
 *     // the modal was closed
 *   });
 * });
 */

/**
 * This event is emitted when using the 3D Secure 2.0 flow and the authentication modal is rendered.
 * @event ThreeDSecure#authentication-modal-render
 * @example
 * braintree.threeDSecure.create({
 *   client: clientInstance,
 *   version: '2'
 * }, function (createErr, threeDSecureInstance) {
 *   threeDSecureInstance.on('authentication-modal-render', function () {
 *     // the modal was rendered, presenting the authentication form to the customer
 *   });
 * });
 */

/**
 * @class
 * @param {object} options 3D Secure {@link module:braintree-web/three-d-secure.create create} options
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/three-d-secure.create|braintree.threeDSecure.create} instead.</strong>
 * @classdesc This class represents a ThreeDSecure component produced by {@link module:braintree-web/three-d-secure.create|braintree.threeDSecure.create}. Instances of this class have a method for launching a 3D Secure authentication flow.
 *
 * If you use the Braintree SDK from within an iframe, you must not use the `sandbox` attribute on your iframe or the 3D Secure modal will not function correctly.
 *
 * **Note**: 3D Secure 2.0 is documented below and will become the default integration method in a future version of Braintree-web. Until then, version 1.0 will continue to be supported. To view 3D Secure 1.0 documentation, look at Braintree-web documentation from version [3.40.0](https://braintree.github.io/braintree-web/3.40.0/ThreeDSecure.html) and earlier, or upgrade your integration by referring to the [3D Secure 2.0 adoption guide](https://developer.paypal.com/braintree/docs/guides/3d-secure/migration/javascript/v3).
 */
function ThreeDSecure(options) {
  var self = this;
  var Framework = FRAMEWORKS[options.framework];

  EventEmitter.call(this);

  this._framework = new Framework(options);
  this._framework.setUpEventListeners(function () {
    self._emit.apply(self, arguments);
  });
}

EventEmitter.createChild(ThreeDSecure);
// NEXT_MAJOR_VERSION remove exemptionRequested entirely in favor of `requestedExemptionType`
/**
 * Launch the 3D Secure login flow, returning a nonce payload.
 *
 * @public
 * @param {object} options Options for card verification.
 * @param {string} options.nonce The nonce representing the card from a tokenization payload. For example, this can be a {@link HostedFields~tokenizePayload|tokenizePayload} returned by Hosted Fields under `payload.nonce`.
 * @param {string} options.bin The numeric Bank Identification Number (bin) of the card from a tokenization payload. For example, this can be a {@link HostedFields~tokenizePayload|tokenizePayload} returned by Hosted Fields under `payload.details.bin`.
 * @param {string} options.amount The amount of the transaction in the current merchant account's currency. This must be expressed in numbers with an optional decimal (using `.`) and precision up to the hundredths place. For example, if you're processing a transaction for 1.234,56 € then `amount` should be `1234.56`.
 * @param {string} [options.accountType] The account type for the card (if known). Accepted values: `credit` or `debit`.
 * @param {boolean} [options.cardAddChallengeRequested] If set to `true`, a card-add challenge will be requested from the issuer. If set to `false`, a card-add challenge will not be requested. If the param is missing, a card-add challenge will only be requested for $0 amount. An authentication created using this flag should only be used for vaulting operations (creation of customers' credit cards or payment methods) and not for creating transactions.
 * @param {boolean} [options.cardAdd] *Deprecated:* Use `cardAddChallengeRequested` instead.
 * @param {boolean} [options.challengeRequested] If set to true, an authentication challenge will be forced if possible.
 * @param {boolean} [options.dataOnlyRequested] Indicates whether to use the data only flow. In this flow, frictionless 3DS is ensured for Mastercard cardholders as the card scheme provides a risk score for the issuer to determine whether to approve. If data only is not supported by the processor, a validation error will be raised. Non-Mastercard cardholders will fallback to a normal 3DS flow.
 * @param {boolean} [options.exemptionRequested] *Deprecated:* Use `requestedExemptionType` instead.
 * @param {boolean} [options.requestVisaDAF] Request to use VISA Digital Authentication Framework. If set to true, a Visa DAF authenticated payment credential will be created and/or used for authentication if the merchant is eligible.
 * @param {string} [options.merchantName] Allows to override the merchant name that is shown in the challenge.
 * @param {string} [options.requestedExemptionType] If an exemption is requested and the exemption's conditions are satisfied, then it will be applied. The following supported exemptions are defined as per PSD2 regulation: `low_value`, `transaction_risk_analysis`
 * @param {object} [options.customFields] Object where each key is the name of a custom field which has been configured in the Control Panel. In the Control Panel you can configure 3D Secure Rules which trigger on certain values.
 * @param {function} [options.onLookupComplete] *Deprecated:* Use {@link ThreeDSecure#event:lookup-complete|`threeDSecureInstance.on('lookup-complete')`} instead. Function to execute when lookup completes. The first argument, `data`, is a {@link ThreeDSecure~verificationData|verificationData} object, and the second argument, `next`, is a callback. `next` must be called to continue.
 * @param {string} [options.email] The email used for verification. (maximum length 255)
 * @param {string} [options.mobilePhoneNumber] The mobile phone number used for verification. Only numbers; remove dashes, parenthesis and other characters. (maximum length 25)
 * @param {object} [options.billingAddress] An {@link ThreeDSecure~billingAddress|billingAddress} object for verification.
 * @param {object} [options.additionalInformation] An {@link ThreeDSecure~additionalInformation|additionalInformation} object for verification.
 * @param {object} [options.collectDeviceData] If set to `true`, device data such as browser screen dimensions, language and time zone is submitted with lookup data.
 * @param {object} [options.customer] **Deprecated** Customer information for use in 3DS 1.0 verifications. Can contain any subset of a {@link ThreeDSecure~verifyCardCustomerObject|verifyCardCustomerObject}. Only to be used for 3DS 1.0 integrations.
 * @param {callback} options.addFrame **Deprecated** This {@link ThreeDSecure~addFrameCallback|addFrameCallback} will be called when the bank frame needs to be added to your page. Only to be used for 3DS 1.0 integrations.
 * @param {callback} options.removeFrame **Deprecated** For use in 3DS 1.0 Flows. This {@link ThreeDSecure~removeFrameCallback|removeFrameCallback} will be called when the bank frame needs to be removed from your page. Only to be used in 3DS 1.0 integrations.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link ThreeDSecure~verifyPayload|verifyPayload}. If no callback is provided, it will return a promise that resolves {@link ThreeDSecure~verifyPayload|verifyPayload}.

 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * <caption>Verifying a payment method nonce with 3DS 2.0</caption>
 * var my3DSContainer;
 *
 * // set up listener after initialization
 * threeDSecure.on(('lookup-complete', function (data, next) {
 *   // use `data` here, then call `next()`
 *   next();
 * });
 *
 * // call verifyCard after tokenizing a card
 * threeDSecure.verifyCard({
 *   amount: '123.45',
 *   nonce: hostedFieldsTokenizationPayload.nonce,
 *   bin: hostedFieldsTokenizationPayload.details.bin,
 *   email: 'test@example.com'
 *   billingAddress: {
 *     givenName: 'Jill',
 *     surname: 'Doe',
 *     phoneNumber: '8101234567',
 *     streetAddress: '555 Smith St.',
 *     extendedAddress: '#5',
 *     locality: 'Oakland',
 *     region: 'CA',
 *     postalCode: '12345',
 *     countryCodeAlpha2: 'US'
 *   },
 *   additionalInformation: {
 *     workPhoneNumber: '5555555555',
 *     shippingGivenName: 'Jill',
 *     shippingSurname: 'Doe',
 *     shippingAddress: {
 *       streetAddress: '555 Smith st',
 *       extendedAddress: '#5',
 *       locality: 'Oakland',
 *       region: 'CA',
 *       postalCode: '12345',
 *       countryCodeAlpha2: 'US'
 *     }
 *     shippingPhone: '8101234567'
 *   }
 * }, function (err, payload) {
 *   if (err) {
 *     console.error(err);
 *     return;
 *   }
 *
 *   if (payload.liabilityShifted) {
 *     // Liability has shifted
 *     submitNonceToServer(payload.nonce);
 *   } else if (payload.liabilityShiftPossible) {
 *     // Liability may still be shifted
 *     // Decide if you want to submit the nonce
 *   } else {
 *     // Liability has not shifted and will not shift
 *     // Decide if you want to submit the nonce
 *   }
 * });
 * @example
 * <caption>Verifying a payment method nonce with 3DS 2.0 with onLookupComplete callback</caption>
 * var my3DSContainer;
 *
 * threeDSecure.verifyCard({
 *   amount: '123.45',
 *   nonce: hostedFieldsTokenizationPayload.nonce,
 *   bin: hostedFieldsTokenizationPayload.details.bin,
 *   email: 'test@example.com'
 *   billingAddress: {
 *     givenName: 'Jill',
 *     surname: 'Doe',
 *     phoneNumber: '8101234567',
 *     streetAddress: '555 Smith St.',
 *     extendedAddress: '#5',
 *     locality: 'Oakland',
 *     region: 'CA',
 *     postalCode: '12345',
 *     countryCodeAlpha2: 'US'
 *   },
 *   additionalInformation: {
 *     workPhoneNumber: '5555555555',
 *     shippingGivenName: 'Jill',
 *     shippingSurname: 'Doe',
 *     shippingAddress: {
 *       streetAddress: '555 Smith st',
 *       extendedAddress: '#5',
 *       locality: 'Oakland',
 *       region: 'CA',
 *       postalCode: '12345',
 *       countryCodeAlpha2: 'US'
 *     }
 *     shippingPhone: '8101234567'
 *   },
 *   onLookupComplete: function (data, next) {
 *     // use `data` here, then call `next()`
 *     next();
 *   }
 * }, function (err, payload) {
 *   if (err) {
 *     console.error(err);
 *     return;
 *   }
 *
 *   if (payload.liabilityShifted) {
 *     // Liability has shifted
 *     submitNonceToServer(payload.nonce);
 *   } else if (payload.liabilityShiftPossible) {
 *     // Liability may still be shifted
 *     // Decide if you want to submit the nonce
 *   } else {
 *     // Liability has not shifted and will not shift
 *     // Decide if you want to submit the nonce
 *   }
 * });
 * @example
 * <caption>Handling 3DS lookup errors</caption>
 * var my3DSContainer;
 *
 * // set up listener after initialization
 * threeDSecure.on(('lookup-complete', function (data, next) {
 *   // use `data` here, then call `next()`
 *   next();
 * });
 *
 * // call verifyCard after tokenizing a card
 * threeDSecure.verifyCard({
 *   amount: '123.45',
 *   nonce: hostedFieldsTokenizationPayload.nonce,
 *   bin: hostedFieldsTokenizationPayload.details.bin,
 *   email: 'test@example.com',
 *   billingAddress: billingAddressFromCustomer,
 *   additionalInformation: additionalInfoFromCustomer
 * }, function (err, payload) {
 *   if (err) {
 *     if (err.code.indexOf('THREEDS_LOOKUP') === 0) {
 *       // an error occurred during the initial lookup request
 *
 *       if (err.code === 'THREEDS_LOOKUP_TOKENIZED_CARD_NOT_FOUND_ERROR') {
 *         // either the passed payment method nonce does not exist
 *         // or it was already consumed before the lookup call was made
 *       } else if (err.code.indexOf('THREEDS_LOOKUP_VALIDATION') === 0) {
 *         // a validation error occurred
 *         // likely some non-ascii characters were included in the billing
 *         // address given name or surname fields, or the cardholdername field
 *
 *         // Instruct your user to check their data and try again
 *       } else {
 *         // an unknown lookup error occurred
 *       }
 *     } else {
 *       // some other kind of error
 *     }
 *     return;
 *   }
 *
 *   // handle success
 * });
 */
ThreeDSecure.prototype.verifyCard = function (options) {
  var privateOptions;

  if (this.hasListener("lookup-complete")) {
    privateOptions = {
      ignoreOnLookupCompleteRequirement: true,
    };
  }

  return this._framework.verifyCard(options, privateOptions);
};

/* eslint-disable-next-line valid-jsdoc */
/**
 * Launch the iframe challenge using a 3D Secure lookup response from a server side lookup.
 *
 * @public
 * @param {(object|string)} lookupResponse The lookup response from the server side call to lookup the 3D Secure information. The raw string or a parsed object can be passed.
 * @returns {Promise} Returns a promise.
 * @example
 * var my3DSContainer;
 *
 * threeDSecure.initializeChallengeWithLookupResponse(lookupResponseFromServer).then(function (payload) {
 *   if (payload.liabilityShifted) {
 *     // Liability has shifted
 *     submitNonceToServer(payload.nonce);
 *   } else if (payload.liabilityShiftPossible) {
 *     // Liability may still be shifted
 *     // Decide if you want to submit the nonce
 *   } else {
 *     // Liability has not shifted and will not shift
 *     // Decide if you want to submit the nonce
 *   }
 * });
 */
ThreeDSecure.prototype.initializeChallengeWithLookupResponse = function (
  lookupResponse
) {
  if (typeof lookupResponse === "string") {
    lookupResponse = JSON.parse(lookupResponse);
  }

  return this._framework.initializeChallengeWithLookupResponse(lookupResponse);
};

/**
 * Gather the data needed for a 3D Secure lookup call.
 *
 * @public
 * @param {object} options Options for 3D Secure lookup.
 * @param {string} options.nonce The nonce representing the card from a tokenization payload. For example, this can be a {@link HostedFields~tokenizePayload|tokenizePayload} returned by Hosted Fields under `payload.nonce`.
 * @param {string} options.bin The numeric Bank Identification Number (bin) of the card from a tokenization payload. For example, this can be a {@link HostedFields~tokenizePayload|tokenizePayload} returned by Hosted Fields under `payload.details.bin`.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link ThreeDSecure~prepareLookupPayload|prepareLookupPayload}. If no callback is provided, it will return a promise that resolves {@link ThreeDSecure~prepareLookupPayload|prepareLookupPayload}.

 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * <caption>Preparing data for a 3D Secure lookup</caption>
 * threeDSecure.prepareLookup({
 *   nonce: hostedFieldsTokenizationPayload.nonce,
 *   bin: hostedFieldsTokenizationPayload.details.bin
 * }, function (err, payload) {
 *   if (err) {
 *     console.error(err);
 *     return;
 *   }
 *
 *   // send payload to server to do server side lookup
 * });
 */
ThreeDSecure.prototype.prepareLookup = function (options) {
  return this._framework.prepareLookup(options).then(function (data) {
    return JSON.stringify(data);
  });
};

/**
 * Cancel the 3DS flow and return the verification payload if available. If using 3D Secure version 2, this will not close the UI of the authentication modal. It is recommended that this method only be used in the {@link ThreeDSecure#event:lookup-complete|`lookup-complete`} event or the `onLookupComplete` callback.
 * @public
 * @param {callback} [callback] The second argument is a {@link ThreeDSecure~verifyPayload|verifyPayload}. If there is no verifyPayload (the initial lookup did not complete), an error will be returned. If no callback is passed, `cancelVerifyCard` will return a promise.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example <caption>Cancel the verification in `lookup-complete` event</caption>
 * // set up listener after instantiation
 * threeDSecure.on('lookup-complete', function (data, next) {
 *   // determine if you want to call next to start the challenge,
 *   // if not, call cancelVerifyCard
 *   threeDSecure.cancelVerifyCard(function (err, verifyPayload) {
 *     if (err) {
 *       // Handle error
 *       console.log(err.message); // No verification payload available
 *       return;
 *     }
 *
 *     verifyPayload.nonce; // The nonce returned from the 3ds lookup call
 *     verifyPayload.liabilityShifted; // boolean
 *     verifyPayload.liabilityShiftPossible; // boolean
 *   });
 * });
 *
 * // after tokenizing a credit card
 * threeDSecure.verifyCard({
 *   amount: '100.00',
 *   nonce: nonceFromTokenizationPayload,
 *   bin: binFromTokenizationPayload
 *   // other fields such as billing address
 * }, function (verifyError, payload) {
 *   if (verifyError) {
 *     if (verifyError.code === 'THREEDS_VERIFY_CARD_CANCELED_BY_MERCHANT ') {
 *       // flow was canceled by merchant, 3ds info can be found in the payload
 *       // for cancelVerifyCard
 *     }
 *   }
 * });
 * @example <caption>Cancel the verification in onLookupComplete callback</caption>
 * threeDSecure.verifyCard({
 *   amount: '100.00',
 *   nonce: nonceFromTokenizationPayload,
 *   bin: binFromTokenizationPayload,
 *   // other fields such as billing address
 *   onLookupComplete: function (data, next) {
 *     // determine if you want to call next to start the challenge,
 *     // if not, call cancelVerifyCard
 *     threeDSecure.cancelVerifyCard(function (err, verifyPayload) {
 *       if (err) {
 *         // Handle error
 *         console.log(err.message); // No verification payload available
 *         return;
 *       }
 *
 *       verifyPayload.nonce; // The nonce returned from the 3ds lookup call
 *       verifyPayload.liabilityShifted; // boolean
 *       verifyPayload.liabilityShiftPossible; // boolean
 *     });
 *   }
 * }, function (verifyError, payload) {
 *   if (verifyError) {
 *     if (verifyError.code === 'THREEDS_VERIFY_CARD_CANCELED_BY_MERCHANT ') {
 *       // flow was canceled by merchant, 3ds info can be found in the payload
 *       // for cancelVerifyCard
 *     }
 *   }
 * });
 * @example <caption>Cancel the verification in 3D Secure version 1</caption>
 * // unlike with v2, this will not cause `verifyCard` to error, it will simply
 * // never call the callback
 * threeDSecure.cancelVerifyCard(function (err, verifyPayload) {
 *   if (err) {
 *     // Handle error
 *     console.log(err.message); // No verification payload available
 *     return;
 *   }
 *
 *   verifyPayload.nonce; // The nonce returned from the 3ds lookup call
 *   verifyPayload.liabilityShifted; // boolean
 *   verifyPayload.liabilityShiftPossible; // boolean
 * });
 */
ThreeDSecure.prototype.cancelVerifyCard = function () {
  return this._framework.cancelVerifyCard();
};

/**
 * Cleanly remove anything set up by {@link module:braintree-web/three-d-secure.create|create}, with the exception that the Cardinal SDK, on window.Cardinal, will remain.
 * @public
 * @param {callback} [callback] Called on completion. If no callback is passed, `teardown` will return a promise.
 * @example
 * threeDSecure.teardown();
 * @example <caption>With callback</caption>
 * threeDSecure.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
ThreeDSecure.prototype.teardown = function () {
  var methodNames = methods(ThreeDSecure.prototype).concat(
    methods(EventEmitter.prototype)
  );

  convertMethodsToError(this, methodNames);

  return this._framework.teardown();
};

module.exports = wrapPromise.wrapPrototype(ThreeDSecure);

},{"../../lib/convert-methods-to-error":127,"../../lib/methods":155,"./frameworks":193,"@braintree/event-emitter":33,"@braintree/wrap-promise":43}],198:[function(_dereq_,module,exports){
"use strict";
/** @module braintree-web/three-d-secure */

var ThreeDSecure = _dereq_("./external/three-d-secure");
var isHTTPS = _dereq_("../lib/is-https").isHTTPS;
var basicComponentVerification = _dereq_("../lib/basic-component-verification");
var createDeferredClient = _dereq_("../lib/create-deferred-client");
var createAssetsUrl = _dereq_("../lib/create-assets-url");
var BraintreeError = _dereq_("../lib/braintree-error");
var analytics = _dereq_("../lib/analytics");
var errors = _dereq_("./shared/errors");
var VERSION = "3.101.3";
var wrapPromise = _dereq_("@braintree/wrap-promise");

/**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {object} [options.cardinalSDKConfig] A config for the underlying Cardinal SDK.
 * @param {object} [options.cardinalSDKConfig.logging] The logging configuration for the Cardinal SDK. See [Cardinal's documentation for the logging object](https://cardinaldocs.atlassian.net/wiki/spaces/CC/pages/1409568/Configurations#Configurations-Logging) for more information.
 * @param {number} [options.cardinalSDKConfig.timeout] The time in milliseconds to wait before a request to Cardinal's API times out. See [Cardinal's documentation for root level configuration](https://cardinaldocs.atlassian.net/wiki/spaces/CC/pages/1409568/Configurations#Configurations-RootLevelConfiguration) for more information.
 * @param {number} [options.cardinalSDKConfig.maxRequestRetries] How many times a request should be re-attempted to Cardinal's API before giving up as a failure. See [Cardinal's documentation for root level configuration](https://cardinaldocs.atlassian.net/wiki/spaces/CC/pages/1409568/Configurations#Configurations-RootLevelConfiguration) for more information.
 * @param {object} [options.cardinalSDKConfig.payment] An object to describe how you want the user interactions to behave. Only a subset of the [Cardinal SDK payment configuration object](https://cardinaldocs.atlassian.net/wiki/spaces/CC/pages/1409568/Configurations#Configurations-Payment) are supported: `displayLoading` and `displayExitButton`.
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {(number|string)} [options.version=1] The version of 3D Secure to use. Possible options:
 * * 1 - The legacy 3D Secure v1.0 integration.
 * * 2 - A 3D Secure v2.0 integration that uses a modal to host the 3D Secure iframe.
 * * 2-bootstrap3-modal - A 3D Secure v2.0 integration that uses a modal styled with Bootstrap 3 styles to host the 3D Secure iframe. Requires having the Bootstrap 3 script files and stylesheets on your page.
 * * 2-inline-iframe - A 3D Secure v2.0 integration that provides the authentication iframe directly to the merchant.
 * @param {callback} [callback] The second argument, `data`, is the {@link ThreeDSecure} instance. If no callback is provided, it returns a promise that resolves the {@link ThreeDSecure} instance.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
@example
 * <caption>Creating a v2 3D Secure component using 2 version (Cardinal modal)</caption>
 * braintree.threeDSecure.create({
 *   client: clientInstance,
 *   version: '2'
 * }, function (createError, threeDSecure) {
 *   // set up lookup-complete listener
 *   threeDSecure.on('lookup-complete', function (data, next) {
 *     // check lookup data
 *
 *     next();
 *   });
 *
 *   // using Hosted Fields, use `tokenize` to get back a credit card nonce
 *
 *   threeDSecure.verifyCard({
 *     nonce: nonceFromTokenizationPayload,,
 *     bin: binFromTokenizationPayload,
 *     amount: '100.00'
 *   }, function (verifyError, payload) {
 *     // inspect payload
 *     // send payload.nonce to your server
 *   });
 * });
 * @example
 * <caption>Creating a v2 3D Secure component using 2-bootstrap3-modal version</caption>
 * // must have the boostrap js, css and jquery files on your page
 * braintree.threeDSecure.create({
 *   client: clientInstance,
 *   version: '2-bootstrap3-modal'
 * }, function (createError, threeDSecure) {
 *   // set up lookup-complete listener
 *   threeDSecure.on('lookup-complete', function (data, next) {
 *     // check lookup data
 *
 *     next();
 *   });
 *
 *   // using Hosted Fields, use `tokenize` to get back a credit card nonce
 *
 *   // challenge will be presented in a bootstrap 3 modal
 *   threeDSecure.verifyCard({
 *     nonce: nonceFromTokenizationPayload,
 *     bin: binFromTokenizationPayload,
 *     amount: '100.00'
 *   }, function (verifyError, payload) {
 *     // inspect payload
 *     // send payload.nonce to your server
 *   });
 * });
 * @example
 * <caption>Creating a v2 3D Secure component using 2-inline-iframe version</caption>
 * braintree.threeDSecure.create({
 *   client: clientInstance,
 *   version: '2-inline-iframe'
 * }, function (createError, threeDSecure) {
 *   // set up lookup-complete listener
 *   threeDSecure.on('lookup-complete', function (data, next) {
 *     // check lookup data
 *
 *     next();
 *   });
 *   // set up iframe listener
 *   threeDSecure.on('authentication-iframe-available', function (event, next) {
 *     var element = event.element; // an html element that contains the iframe
 *
 *     document.body.appendChild(element); // put it on your page
 *
 *     next(); // let the sdk know the element has been added to the page
 *   });
 *
 *   // using Hosted Fields, use `tokenize` to get back a credit card nonce
 *
 *   threeDSecure.verifyCard({
 *     nonce: nonceFromTokenizationPayload,,
 *     bin: binFromTokenizationPayload,
 *     amount: '100.00'
 *   }, function (verifyError, payload) {
 *     // inspect payload
 *     // send payload.nonce to your server
 *   });
 * });
 */
function create(options) {
  var name = "3D Secure";
  var framework = getFramework(options);

  return basicComponentVerification
    .verify({
      name: name,
      client: options.client,
      authorization: options.authorization,
    })
    .then(function () {
      var assetsUrl = createAssetsUrl.create(options.authorization);
      var createPromise = createDeferredClient
        .create({
          authorization: options.authorization,
          client: options.client,
          debug: options.debug,
          assetsUrl: assetsUrl,
          name: name,
        })
        .then(function (client) {
          var error, isProduction;
          var config = client.getConfiguration();
          var gwConfig = config.gatewayConfiguration;

          options.client = client;

          if (!gwConfig.threeDSecureEnabled) {
            error = errors.THREEDS_NOT_ENABLED;
          }

          if (config.authorizationType === "TOKENIZATION_KEY") {
            error = errors.THREEDS_CAN_NOT_USE_TOKENIZATION_KEY;
          }

          isProduction = gwConfig.environment === "production";

          if (isProduction && !isHTTPS()) {
            error = errors.THREEDS_HTTPS_REQUIRED;
          }

          if (
            framework !== "legacy" &&
            !(
              gwConfig.threeDSecure &&
              gwConfig.threeDSecure.cardinalAuthenticationJWT
            )
          ) {
            analytics.sendEvent(
              options.client,
              "three-d-secure.initialization.failed.missing-cardinalAuthenticationJWT"
            );
            error = errors.THREEDS_NOT_ENABLED_FOR_V2;
          }

          if (error) {
            return Promise.reject(new BraintreeError(error));
          }

          analytics.sendEvent(options.client, "three-d-secure.initialized");

          return client;
        });
      var instance = new ThreeDSecure({
        client: options.client,
        assetsUrl: assetsUrl,
        createPromise: createPromise,
        loggingEnabled: options.loggingEnabled,
        cardinalSDKConfig: options.cardinalSDKConfig,
        framework: framework,
      });

      if (options.client) {
        return createPromise.then(function () {
          return instance;
        });
      }

      return instance;
    });
}

function getFramework(options) {
  var version = String(options.version || "");

  if (!version || version === "1") {
    throw new BraintreeError({
      code: errors.THREEDS_UNSUPPORTED_VERSION.code,
      type: errors.THREEDS_UNSUPPORTED_VERSION.type,
      message: errors.THREEDS_UNSUPPORTED_VERSION.message,
    });
  }

  switch (version) {
    case "2":
    case "2-cardinal-modal":
      return "cardinal-modal";
    case "2-bootstrap3-modal":
      return "bootstrap3-modal";
    case "2-inline-iframe":
      return "inline-iframe";
    default:
      throw new BraintreeError({
        code: errors.THREEDS_UNRECOGNIZED_VERSION.code,
        type: errors.THREEDS_UNRECOGNIZED_VERSION.type,
        message:
          "Version `" +
          options.version +
          "` is not a recognized version. You may need to update the version of your Braintree SDK to support this version.",
      });
  }
}

module.exports = {
  create: wrapPromise(create),
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION,
};

},{"../lib/analytics":119,"../lib/basic-component-verification":122,"../lib/braintree-error":124,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"../lib/is-https":152,"./external/three-d-secure":197,"./shared/errors":200,"@braintree/wrap-promise":43}],199:[function(_dereq_,module,exports){
"use strict";

module.exports = {
  LANDING_FRAME_NAME: "braintreethreedsecurelanding",
  CARDINAL_SCRIPT_SOURCE: {
    production: "https://songbird.cardinalcommerce.com/edge/v1/songbird.js",
    sandbox: "https://songbirdstag.cardinalcommerce.com/edge/v1/songbird.js",
  },
};

},{}],200:[function(_dereq_,module,exports){
"use strict";

/**
 * @name BraintreeError.3D Secure - Creation Error Codes
 * @description Errors that occur when [creating the 3D Secure component](./module-braintree-web_three-d-secure.html#.create).
 * @property {MERCHANT} THREEDS_NOT_ENABLED Occurs when 3D Secure is not enabled in the Braintree control panel.
 * @property {MERCHANT} THREEDS_CAN_NOT_USE_TOKENIZATION_KEY Occurs when 3D Secure component is created without a Client Token.
 * @property {MERCHANT} THREEDS_HTTPS_REQUIRED Occurs when 3D Secure component is created in production over HTTPS.
 * @property {MERCHANT} THREEDS_NOT_ENABLED_FOR_V2 Occurs when 3D Secure component is created with version 2 parameter, but merchant is not enabled to use version 2.
 * @property {MERCHANT} THREEDS_UNRECOGNIZED_VERSION Occurs when unrecognized version enum is passed into the create call.
 * @property {UNKNOWN} THREEDS_CARDINAL_SDK_SETUP_FAILED Occurs when Cardinal's Songbird.js library fails to setup for an unknown reason.
 * @property {NETWORK} THREEDS_CARDINAL_SDK_SCRIPT_LOAD_FAILED Occurs when using version 2 and Cardinal's Songbird.js script could not be loaded.
 * @property {UNKNOWN} THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT Occurs when Cardinal's Songbird.js library takes longer than 60 seconds to set up.
 * @property {UNKNOWN} THREEDS_CARDINAL_SDK_RESPONSE_TIMEDOUT Occurs when Cardinal sends a response indicating a timeout on /Validate, /Confirm, or /Continue.
 * @property {MERCHANT} THREEDS_CARDINAL_SDK_BAD_CONFIG Occurs when there is no JWT in the request. Also when there's some other malformed aspect of config.
 * @property {MERCHANT} THREEDS_CARDINAL_SDK_BAD_JWT Occurs when a malformed config causes a either a missing response JWT or a malformed Cardinal response.
 * @property {UNKNOWN} THREEDS_CARDINAL_SDK_ERROR Occurs when a "general error" or a Cardinal hosted fields error happens. Description contains more details.
 * @property {CUSTOMER} THREEDS_CARDINAL_SDK_CANCELED Occurs when customer cancels the transaction mid-flow, usually with alt-pays that have their own cancel buttons.
 * @property {MERCHANT} THREEDS_UNSUPPORTED_VERSION Occurs when 3D Secure component is created with version 1 (or default version) parameter.
 */

/**
 * @name BraintreeError.3D Secure - verifyCard Error Codes
 * @description Errors that occur when using the [`verifyCard` method](./ThreeDSecure.html#verifyCard).
 * @property {MERCHANT} THREEDS_AUTHENTICATION_IN_PROGRESS Occurs when another verification is already in progress.
 * @property {MERCHANT} THREEDS_MISSING_VERIFY_CARD_OPTION Occurs when a required option is missing.
 * @property {UNKNOWN} THREEDS_JWT_AUTHENTICATION_FAILED Occurs when something went wrong authenticating the JWT from the Cardinal SDK.
 * @property {MERCHANT} THREEDS_LOOKUP_TOKENIZED_CARD_NOT_FOUND_ERROR Occurs when the supplied payment method nonce does not exist or the payment method nonce has already been consumed.
 * @property {CUSTOMER} THREEDS_LOOKUP_VALIDATION_ERROR Occurs when a validation error occurs during the 3D Secure lookup.
 * @property {UNKNOWN} THREEDS_LOOKUP_ERROR An unknown error occurred while attempting the 3D Secure lookup.
 * @property {MERCHANT} THREEDS_VERIFY_CARD_CANCELED_BY_MERCHANT Occurs when the 3D Secure flow is canceled by the merchant using `cancelVerifyCard` (3D Secure v2 flows only).
 * @property {UNKNOWN} THREEDS_INLINE_IFRAME_DETAILS_INCORRECT An unknown error occurred while attempting to use the inline iframe framework.
 * @property {MERCHANT} THREEDS_REQUESTED_EXEMPTION_TYPE_INVALID Occurs when unrecognized exemption enum value is passed into verifyCard.
 */

/**
 * @name BraintreeError.3D Secure - cancelVerifyCard Error Codes
 * @description Errors that occur when using the [`cancelVerifyCard` method](./ThreeDSecure.html#cancelVerifyCard).
 * @property {MERCHANT} THREEDS_NO_VERIFICATION_PAYLOAD Occurs when the 3D Secure flow is canceled, but there is no 3D Secure information available.
 */

/**
 * @name BraintreeError.3D Secure - Internal Error Codes
 * @ignore
 * @description Errors that occur internally
 * @property {INTERNAL} THREEDS_TERM_URL_REQUIRES_BRAINTREE_DOMAIN Occurs when iframe is initialized on a non-verified domain.
 * @property {INTERNAL} THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED Occurs when a 3D Secure framework method is not implemented.
 */

var BraintreeError = _dereq_("../../lib/braintree-error");

module.exports = {
  THREEDS_NOT_ENABLED: {
    type: BraintreeError.types.MERCHANT,
    code: "THREEDS_NOT_ENABLED",
    message: "3D Secure is not enabled for this merchant.",
  },
  THREEDS_CAN_NOT_USE_TOKENIZATION_KEY: {
    type: BraintreeError.types.MERCHANT,
    code: "THREEDS_CAN_NOT_USE_TOKENIZATION_KEY",
    message: "3D Secure can not use a tokenization key for authorization.",
  },
  THREEDS_HTTPS_REQUIRED: {
    type: BraintreeError.types.MERCHANT,
    code: "THREEDS_HTTPS_REQUIRED",
    message: "3D Secure requires HTTPS.",
  },
  THREEDS_NOT_ENABLED_FOR_V2: {
    type: BraintreeError.types.MERCHANT,
    code: "THREEDS_NOT_ENABLED_FOR_V2",
    message:
      "3D Secure version 2 is not enabled for this merchant. Contact Braintree Support for assistance at https://help.braintreepayments.com/",
  },
  THREEDS_UNRECOGNIZED_VERSION: {
    type: BraintreeError.types.MERCHANT,
    code: "THREEDS_UNRECOGNIZED_VERSION",
  },
  THREEDS_CARDINAL_SDK_SETUP_FAILED: {
    type: BraintreeError.types.UNKNOWN,
    code: "THREEDS_CARDINAL_SDK_SETUP_FAILED",
    message: "Something went wrong setting up Cardinal's Songbird.js library.",
  },
  THREEDS_CARDINAL_SDK_SCRIPT_LOAD_FAILED: {
    type: BraintreeError.types.NETWORK,
    code: "THREEDS_CARDINAL_SDK_SCRIPT_LOAD_FAILED",
    message: "Cardinal's Songbird.js library could not be loaded.",
  },
  THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT: {
    type: BraintreeError.types.UNKNOWN,
    code: "THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT",
    message: "Cardinal's Songbird.js took too long to setup.",
  },
  THREEDS_CARDINAL_SDK_RESPONSE_TIMEDOUT: {
    type: BraintreeError.types.UNKNOWN,
    code: "THREEDS_CARDINAL_SDK_RESPONSE_TIMEDOUT",
    message: "Cardinal's API took too long to respond.",
  },
  THREEDS_CARDINAL_SDK_BAD_CONFIG: {
    type: BraintreeError.types.MERCHANT,
    code: "THREEDS_CARDINAL_SDK_BAD_CONFIG",
    message:
      "JWT or other required field missing. Please check your setup configuration.",
  },
  THREEDS_CARDINAL_SDK_BAD_JWT: {
    type: BraintreeError.types.MERCHANT,
    code: "THREEDS_CARDINAL_SDK_BAD_JWT",
    message:
      "Cardinal JWT missing or malformed. Please check your setup configuration.",
  },
  THREEDS_CARDINAL_SDK_ERROR: {
    type: BraintreeError.types.UNKNOWN,
    code: "THREEDS_CARDINAL_SDK_ERROR",
    message:
      "A general error has occurred with Cardinal. See description for more information.",
  },
  THREEDS_CARDINAL_SDK_CANCELED: {
    type: BraintreeError.types.CUSTOMER,
    code: "THREEDS_CARDINAL_SDK_CANCELED",
    message: "Canceled by user.",
  },
  THREEDS_VERIFY_CARD_CANCELED_BY_MERCHANT: {
    type: BraintreeError.types.MERCHANT,
    code: "THREEDS_VERIFY_CARD_CANCELED_BY_MERCHANT",
    message: "3D Secure verfication canceled by merchant.",
  },
  THREEDS_AUTHENTICATION_IN_PROGRESS: {
    type: BraintreeError.types.MERCHANT,
    code: "THREEDS_AUTHENTICATION_IN_PROGRESS",
    message:
      "Cannot call verifyCard while existing authentication is in progress.",
  },
  THREEDS_MISSING_VERIFY_CARD_OPTION: {
    type: BraintreeError.types.MERCHANT,
    code: "THREEDS_MISSING_VERIFY_CARD_OPTION",
  },
  THREEDS_JWT_AUTHENTICATION_FAILED: {
    type: BraintreeError.types.UNKNOWN,
    code: "THREEDS_JWT_AUTHENTICATION_FAILED",
    message: "Something went wrong authenticating the JWT from Cardinal",
  },
  THREEDS_LOOKUP_TOKENIZED_CARD_NOT_FOUND_ERROR: {
    type: BraintreeError.types.MERCHANT,
    code: "THREEDS_LOOKUP_TOKENIZED_CARD_NOT_FOUND_ERROR",
    message:
      "Either the payment method nonce passed to `verifyCard` does not exist, or it was already consumed",
  },
  THREEDS_LOOKUP_VALIDATION_ERROR: {
    type: BraintreeError.types.CUSTOMER,
    code: "THREEDS_LOOKUP_VALIDATION_ERROR",
    message:
      "The data passed in `verifyCard` did not pass validation checks. See details for more info",
  },
  THREEDS_LOOKUP_ERROR: {
    type: BraintreeError.types.UNKNOWN,
    code: "THREEDS_LOOKUP_ERROR",
    message: "Something went wrong during the 3D Secure lookup",
  },
  THREEDS_INLINE_IFRAME_DETAILS_INCORRECT: {
    type: BraintreeError.types.UNKNOWN,
    code: "THREEDS_INLINE_IFRAME_DETAILS_INCORRECT",
    message:
      "Something went wrong when attempting to add the authentication iframe to the page.",
  },
  THREEDS_NO_VERIFICATION_PAYLOAD: {
    type: BraintreeError.types.MERCHANT,
    code: "THREEDS_NO_VERIFICATION_PAYLOAD",
    message: "No verification payload available.",
  },
  THREEDS_TERM_URL_REQUIRES_BRAINTREE_DOMAIN: {
    type: BraintreeError.types.INTERNAL,
    code: "THREEDS_TERM_URL_REQUIRES_BRAINTREE_DOMAIN",
    message: "Term Url must be on a Braintree domain.",
  },
  THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED: {
    type: BraintreeError.types.INTERNAL,
    code: "THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED",
    message: "Method not implemented for this framework.",
  },
  THREEDS_REQUESTED_EXEMPTION_TYPE_INVALID: {
    type: BraintreeError.types.MERCHANT,
    code: "THREEDS_REQUESTED_EXEMPTION_TYPE_INVALID",
    message: "Requested Exemption Type is invalid.",
  },
  THREEDS_UNSUPPORTED_VERSION: {
    type: BraintreeError.types.MERCHANT,
    code: "THREEDS_UNSUPPORTED_VERSION",
    message:
      "3D Secure `1` is deprecated and no longer supported. See available versions at https://braintree.github.io/braintree-web/current/module-braintree-web_three-d-secure.html#.create",
  },
};

},{"../../lib/braintree-error":124}],201:[function(_dereq_,module,exports){
"use strict";

var enumerate = _dereq_("../../lib/enumerate");

module.exports = enumerate(["AUTHENTICATION_COMPLETE"], "threedsecure:");

},{"../../lib/enumerate":134}],202:[function(_dereq_,module,exports){
"use strict";
/**
 * @module braintree-web/unionpay
 * @description This module allows you to accept UnionPay payments. *It is currently in beta and is subject to change.*
 */

var UnionPay = _dereq_("./shared/unionpay");
var basicComponentVerification = _dereq_("../lib/basic-component-verification");
var BraintreeError = _dereq_("../lib/braintree-error");
var createDeferredClient = _dereq_("../lib/create-deferred-client");
var createAssetsUrl = _dereq_("../lib/create-assets-url");
var analytics = _dereq_("../lib/analytics");
var errors = _dereq_("./shared/errors");
var VERSION = "3.101.3";
var wrapPromise = _dereq_("@braintree/wrap-promise");

/**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {callback} [callback] The second argument, `data`, is the {@link UnionPay} instance. If no callback is provided, `create` returns a promise that resolves with the {@link UnionPay} instance.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * braintree.unionpay.create({ client: clientInstance }, function (createErr, unionpayInstance) {
 *   if (createErr) {
 *     console.error(createErr);
 *     return;
 *   }
 *   // ...
 * });
 */
function create(options) {
  var name = "UnionPay";

  return basicComponentVerification
    .verify({
      name: name,
      client: options.client,
      authorization: options.authorization,
    })
    .then(function () {
      return createDeferredClient.create({
        authorization: options.authorization,
        client: options.client,
        debug: options.debug,
        assetsUrl: createAssetsUrl.create(options.authorization),
        name: name,
      });
    })
    .then(function (client) {
      var config = client.getConfiguration();

      options.client = client;

      if (
        !config.gatewayConfiguration.unionPay ||
        config.gatewayConfiguration.unionPay.enabled !== true
      ) {
        return Promise.reject(new BraintreeError(errors.UNIONPAY_NOT_ENABLED));
      }

      analytics.sendEvent(options.client, "unionpay.initialized");

      return new UnionPay(options);
    });
}

module.exports = {
  create: wrapPromise(create),
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION,
};

},{"../lib/analytics":119,"../lib/basic-component-verification":122,"../lib/braintree-error":124,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./shared/errors":204,"./shared/unionpay":205,"@braintree/wrap-promise":43}],203:[function(_dereq_,module,exports){
"use strict";

var enumerate = _dereq_("../../lib/enumerate");

module.exports = {
  events: enumerate(
    [
      "HOSTED_FIELDS_FETCH_CAPABILITIES",
      "HOSTED_FIELDS_ENROLL",
      "HOSTED_FIELDS_TOKENIZE",
    ],
    "union-pay:"
  ),
  HOSTED_FIELDS_FRAME_NAME: "braintreeunionpayhostedfields",
};

},{"../../lib/enumerate":134}],204:[function(_dereq_,module,exports){
"use strict";

/**
 * @name BraintreeError.Union Pay - Creation Error Codes
 * @description Errors that occur when [creating the Union Pay component](./module-braintree-web_union-pay.html#.create).
 * @property {MERCHANT} UNIONPAY_NOT_ENABLED Occurs when Union Pay is not enabled on the Braintree control panel.
 */

/**
 * @name BraintreeError.Union Pay - Shared Error Codes
 * @description Errors that occur when starting the Union Pay Flow
 * @property {MERCHANT} UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES Occurs when a method is used with both card details and a Hosted Fields instance.
 * @property {MERCHANT} UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID Occurs when Hosted Fields instance used is not a valid Hosted Fields instance.
 * @property {MERCHANT} UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED Occurs when neither card details or Hosted Fields are used.
 * @property {MERCHANT} UNIONPAY_HOSTED_FIELDS_INSTANCE_REQUIRED Occurs when Hosted Fields cannot be found on the page.
 */

/**
 * @name BraintreeError.Union Pay - fetchCapabilities Error Codes
 * @description Errors that occur when using the [`fetchCapabilities` method](./UnionPay.html#fetchCapabilities).
 * @property {NETWORK} UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR Occurs when there is an error looking up the Union Pay capabilities.
 */

/**
 * @name BraintreeError.Union Pay - enroll Error Codes
 * @description Errors that occur when using the [`enroll` method](./UnionPay.html#enroll).
 * @property {MERCHANT} UNIONPAY_MISSING_MOBILE_PHONE_DATA Occurs when no mobile phone data is provided.
 * @property {MERCHANT} UNIONPAY_EXPIRATION_DATE_INCOMPLETE Occurs when expiration date is incomplete.
 * @property {CUSTOMER} UNIONPAY_ENROLLMENT_CUSTOMER_INPUT_INVALID Occurs when customer enrollment input is invalid.
 * @property {NETWORK} UNIONPAY_ENROLLMENT_NETWORK_ERROR Occurs when there is an error during enrollment.
 */

/**
 * @name BraintreeError.Union Pay - tokenize Error Codes
 * @description Errors that occur when using the [`tokenize` method](./UnionPay.html#tokenize).
 * @property {CUSTOMER} UNIONPAY_FAILED_TOKENIZATION Occurs when data cannot be tokenized.
 * @property {NETWORK} UNIONPAY_TOKENIZATION_NETWORK_ERROR Occurs when the Braintree gateway cannot be reached.
 */

var BraintreeError = _dereq_("../../lib/braintree-error");

module.exports = {
  UNIONPAY_NOT_ENABLED: {
    type: BraintreeError.types.MERCHANT,
    code: "UNIONPAY_NOT_ENABLED",
    message: "UnionPay is not enabled for this merchant.",
  },
  UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID: {
    type: BraintreeError.types.MERCHANT,
    code: "UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID",
    message:
      "Found an invalid Hosted Fields instance. Please use a valid Hosted Fields instance.",
  },
  UNIONPAY_HOSTED_FIELDS_INSTANCE_REQUIRED: {
    type: BraintreeError.types.MERCHANT,
    code: "UNIONPAY_HOSTED_FIELDS_INSTANCE_REQUIRED",
    message: "Could not find the Hosted Fields instance.",
  },
  UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED: {
    type: BraintreeError.types.MERCHANT,
    code: "UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED",
    message:
      "A card or a Hosted Fields instance is required. Please supply a card or a Hosted Fields instance.",
  },
  UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES: {
    type: BraintreeError.types.MERCHANT,
    code: "UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES",
    message:
      "Please supply either a card or a Hosted Fields instance, not both.",
  },
  UNIONPAY_EXPIRATION_DATE_INCOMPLETE: {
    type: BraintreeError.types.MERCHANT,
    code: "UNIONPAY_EXPIRATION_DATE_INCOMPLETE",
    message: "You must supply expiration month and year or neither.",
  },
  UNIONPAY_ENROLLMENT_CUSTOMER_INPUT_INVALID: {
    type: BraintreeError.types.CUSTOMER,
    code: "UNIONPAY_ENROLLMENT_CUSTOMER_INPUT_INVALID",
    message: "Enrollment failed due to user input error.",
  },
  UNIONPAY_ENROLLMENT_NETWORK_ERROR: {
    type: BraintreeError.types.NETWORK,
    code: "UNIONPAY_ENROLLMENT_NETWORK_ERROR",
    message: "Could not enroll UnionPay card.",
  },
  UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR: {
    type: BraintreeError.types.NETWORK,
    code: "UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR",
    message: "Could not fetch card capabilities.",
  },
  UNIONPAY_TOKENIZATION_NETWORK_ERROR: {
    type: BraintreeError.types.NETWORK,
    code: "UNIONPAY_TOKENIZATION_NETWORK_ERROR",
    message: "A tokenization network error occurred.",
  },
  UNIONPAY_MISSING_MOBILE_PHONE_DATA: {
    type: BraintreeError.types.MERCHANT,
    code: "UNIONPAY_MISSING_MOBILE_PHONE_DATA",
    message: "A `mobile` with `countryCode` and `number` is required.",
  },
  UNIONPAY_FAILED_TOKENIZATION: {
    type: BraintreeError.types.CUSTOMER,
    code: "UNIONPAY_FAILED_TOKENIZATION",
    message: "The supplied card data failed tokenization.",
  },
};

},{"../../lib/braintree-error":124}],205:[function(_dereq_,module,exports){
"use strict";

var analytics = _dereq_("../../lib/analytics");
var BraintreeError = _dereq_("../../lib/braintree-error");
var Bus = _dereq_("framebus");
var constants = _dereq_("./constants");
var isVerifiedDomain = _dereq_("../../lib/is-verified-domain");
var useMin = _dereq_("../../lib/use-min");
var convertMethodsToError = _dereq_("../../lib/convert-methods-to-error");
var errors = _dereq_("./errors");
var events = constants.events;
var iFramer = _dereq_("@braintree/iframer");
var methods = _dereq_("../../lib/methods");
var VERSION = "3.101.3";
var uuid = _dereq_("@braintree/uuid");
var wrapPromise = _dereq_("@braintree/wrap-promise");
var BUS_CONFIGURATION_REQUEST_EVENT =
  _dereq_("../../lib/constants").BUS_CONFIGURATION_REQUEST_EVENT;

/**
 * @class
 * @param {object} options See {@link module:braintree-web/unionpay.create|unionpay.create}.
 * @description <strong>You cannot use this constructor directly. Use {@link module:braintree-web/unionpay.create|braintree-web.unionpay.create} instead.</strong>
 * @classdesc This class represents a UnionPay component. Instances of this class have methods for {@link UnionPay#fetchCapabilities fetching capabilities} of UnionPay cards, {@link UnionPay#enroll enrolling} a UnionPay card, and {@link UnionPay#tokenize tokenizing} a UnionPay card.
 */
function UnionPay(options) {
  this._options = options;
}

/**
 * @typedef {object} UnionPay~fetchCapabilitiesPayload
 * @property {boolean} isUnionPay Determines if this card is a UnionPay card.
 * @property {boolean} isDebit Determines if this card is a debit card. This property is only present if `isUnionPay` is `true`.
 * @property {object} unionPay UnionPay specific properties. This property is only present if `isUnionPay` is `true`.
 * @property {boolean} unionPay.supportsTwoStepAuthAndCapture Determines if the card allows for an authorization, but settling the transaction later.
 * @property {boolean} unionPay.isSupported Determines if Braintree can process this UnionPay card. When false, Braintree cannot process this card and the user should use a different card.
 */

/**
 * Fetches the capabilities of a card, including whether or not the SMS enrollment process is required.
 * @public
 * @param {object} options UnionPay {@link UnionPay#fetchCapabilities fetchCapabilities} options
 * @param {object} [options.card] The card from which to fetch capabilities. Note that this will only have one property, `number`. Required if you are not using the `hostedFields` option.
 * @param {string} options.card.number Card number.
 * @param {HostedFields} [options.hostedFields] The Hosted Fields instance used to collect card data. Required if you are not using the `card` option.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link UnionPay#fetchCapabilitiesPayload fetchCapabilitiesPayload}. If no callback is provided, `fetchCapabilities` returns a promise that resolves with a {@link UnionPay#fetchCapabilitiesPayload fetchCapabilitiesPayload}.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
UnionPay.prototype.fetchCapabilities = function (options) {
  var self = this;
  var client = this._options.client;
  var cardNumber = options.card ? options.card.number : null;
  var hostedFields = options.hostedFields;

  if (cardNumber && hostedFields) {
    return Promise.reject(
      new BraintreeError(errors.UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES)
    );
  } else if (cardNumber) {
    return client
      .request({
        method: "get",
        endpoint: "payment_methods/credit_cards/capabilities",
        data: {
          _meta: { source: "unionpay" },
          creditCard: {
            number: cardNumber,
          },
        },
      })
      .then(function (response) {
        analytics.sendEvent(client, "unionpay.capabilities-received");

        return response;
      })
      .catch(function (err) {
        var status = err.details && err.details.httpStatus;

        analytics.sendEvent(client, "unionpay.capabilities-failed");

        if (status === 403) {
          return Promise.reject(err);
        }

        return Promise.reject(
          new BraintreeError({
            type: errors.UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR.type,
            code: errors.UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR.code,
            message: errors.UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR.message,
            details: {
              originalError: err,
            },
          })
        );
      });
  } else if (hostedFields) {
    if (!hostedFields._bus) {
      return Promise.reject(
        new BraintreeError(errors.UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID)
      );
    }

    return self._initializeHostedFields().then(function () {
      return new Promise(function (resolve, reject) {
        self._bus.emit(
          events.HOSTED_FIELDS_FETCH_CAPABILITIES,
          { hostedFields: hostedFields },
          function (response) {
            if (response.err) {
              reject(new BraintreeError(response.err));

              return;
            }

            resolve(response.payload);
          }
        );
      });
    });
  }

  return Promise.reject(
    new BraintreeError(errors.UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED)
  );
};

/**
 * @typedef {object} UnionPay~enrollPayload
 * @property {string} enrollmentId UnionPay enrollment ID. This value should be passed to `tokenize`.
 * @property {boolean} smsCodeRequired UnionPay `smsCodeRequired` flag.
 * </p><b>true</b> - the user will receive an SMS code that needs to be supplied for tokenization.
 * </p><b>false</b> - the card can be immediately tokenized.
 */

/**
 * Enrolls a UnionPay card. Use {@link UnionPay#fetchCapabilities|fetchCapabilities} to determine if the SMS enrollment process is required.
 * @public
 * @param {object} options UnionPay enrollment options:
 * @param {object} [options.card] The card to enroll. Required if you are not using the `hostedFields` option.
 * @param {string} options.card.number The card number.
 * @param {string} [options.card.expirationDate] The card's expiration date. May be in the form `MM/YY` or `MM/YYYY`. When defined `expirationMonth` and `expirationYear` are ignored.
 * @param {string} [options.card.expirationMonth] The card's expiration month. This should be used with the `expirationYear` parameter. When `expirationDate` is defined this parameter is ignored.
 * @param {string} [options.card.expirationYear] The card's expiration year. This should be used with the `expirationMonth` parameter. When `expirationDate` is defined this parameter is ignored.
 * @param {HostedFields} [options.hostedFields] The Hosted Fields instance used to collect card data. Required if you are not using the `card` option.
 * @param {object} options.mobile The mobile information collected from the customer.
 * @param {string} options.mobile.countryCode The country code of the customer's mobile phone number.
 * @param {string} options.mobile.number The customer's mobile phone number.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link UnionPay~enrollPayload|enrollPayload}. If no callback is provided, `enroll` returns a promise that resolves with {@link UnionPay~enrollPayload|enrollPayload}.
 * @returns {void}
 */
UnionPay.prototype.enroll = function (options) {
  var self = this;
  var client = this._options.client;
  var card = options.card;
  var mobile = options.mobile;
  var hostedFields = options.hostedFields;
  var data;

  if (!mobile) {
    return Promise.reject(
      new BraintreeError(errors.UNIONPAY_MISSING_MOBILE_PHONE_DATA)
    );
  }

  if (hostedFields) {
    if (!hostedFields._bus) {
      return Promise.reject(
        new BraintreeError(errors.UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID)
      );
    } else if (card) {
      return Promise.reject(
        new BraintreeError(errors.UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES)
      );
    }

    return new Promise(function (resolve, reject) {
      self._initializeHostedFields().then(function () {
        self._bus.emit(
          events.HOSTED_FIELDS_ENROLL,
          { hostedFields: hostedFields, mobile: mobile },
          function (response) {
            if (response.err) {
              reject(new BraintreeError(response.err));

              return;
            }

            resolve(response.payload);
          }
        );
      });
    });
  } else if (card && card.number) {
    data = {
      _meta: { source: "unionpay" },
      unionPayEnrollment: {
        number: card.number,
        mobileCountryCode: mobile.countryCode,
        mobileNumber: mobile.number,
      },
    };

    if (card.expirationDate) {
      data.unionPayEnrollment.expirationDate = card.expirationDate;
    } else if (card.expirationMonth || card.expirationYear) {
      if (card.expirationMonth && card.expirationYear) {
        data.unionPayEnrollment.expirationYear = card.expirationYear;
        data.unionPayEnrollment.expirationMonth = card.expirationMonth;
      } else {
        return Promise.reject(
          new BraintreeError(errors.UNIONPAY_EXPIRATION_DATE_INCOMPLETE)
        );
      }
    }

    return client
      .request({
        method: "post",
        endpoint: "union_pay_enrollments",
        data: data,
      })
      .then(function (response) {
        analytics.sendEvent(client, "unionpay.enrollment-succeeded");

        return {
          enrollmentId: response.unionPayEnrollmentId,
          smsCodeRequired: response.smsCodeRequired,
        };
      })
      .catch(function (err) {
        var error;
        var status = err.details && err.details.httpStatus;

        if (status === 403) {
          error = err;
        } else if (status < 500) {
          error = new BraintreeError(
            errors.UNIONPAY_ENROLLMENT_CUSTOMER_INPUT_INVALID
          );
          error.details = { originalError: err };
        } else {
          error = new BraintreeError(errors.UNIONPAY_ENROLLMENT_NETWORK_ERROR);
          error.details = { originalError: err };
        }

        analytics.sendEvent(client, "unionpay.enrollment-failed");

        return Promise.reject(error);
      });
  }

  return Promise.reject(
    new BraintreeError(errors.UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED)
  );
};

/**
 * @typedef {object} UnionPay~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {string} type Always <code>CreditCard</code>.
 * @property {object} details Additional account details:
 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
 * @property {string} details.lastFour Last four digits of card number.
 * @property {string} details.lastTwo Last two digits of card number.
 * @property {string} description A human-readable description.
 */

/**
 * Tokenizes a UnionPay card and returns a nonce payload.
 * @public
 * @param {object} options UnionPay tokenization options:
 * @param {object} [options.card] The card to enroll. Required if you are not using the `hostedFields` option.
 * @param {string} options.card.number The card number.
 * @param {string} [options.card.expirationDate] The card's expiration date. May be in the form `MM/YY` or `MM/YYYY`. When defined `expirationMonth` and `expirationYear` are ignored.
 * @param {string} [options.card.expirationMonth] The card's expiration month. This should be used with the `expirationYear` parameter. When `expirationDate` is defined this parameter is ignored.
 * @param {string} [options.card.expirationYear] The card's expiration year. This should be used with the `expirationMonth` parameter. When `expirationDate` is defined this parameter is ignored.
 * @param {string} [options.card.cvv] The card's security number.
 * @param {HostedFields} [options.hostedFields] The Hosted Fields instance used to collect card data. Required if you are not using the `card` option.
 * @param {string} options.enrollmentId The enrollment ID from {@link UnionPay#enroll}.
 * @param {string} [options.smsCode] The SMS code received from the user if {@link UnionPay#enroll} payload have `smsCodeRequired`. if `smsCodeRequired` is false, smsCode should not be passed.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link UnionPay~tokenizePayload|tokenizePayload}. If no callback is provided, `tokenize` returns a promise that resolves with a {@link UnionPay~tokenizePayload|tokenizePayload}.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
UnionPay.prototype.tokenize = function (options) {
  var data;
  var self = this;
  var client = this._options.client;
  var card = options.card;
  var hostedFields = options.hostedFields;

  if (card && hostedFields) {
    return Promise.reject(
      new BraintreeError(errors.UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES)
    );
  } else if (card) {
    data = {
      _meta: { source: "unionpay" },
      creditCard: {
        number: options.card.number,
        options: {
          unionPayEnrollment: {
            id: options.enrollmentId,
          },
        },
      },
    };

    if (options.smsCode) {
      data.creditCard.options.unionPayEnrollment.smsCode = options.smsCode;
    }

    if (card.expirationDate) {
      data.creditCard.expirationDate = card.expirationDate;
    } else if (card.expirationMonth && card.expirationYear) {
      data.creditCard.expirationYear = card.expirationYear;
      data.creditCard.expirationMonth = card.expirationMonth;
    }

    if (options.card.cvv) {
      data.creditCard.cvv = options.card.cvv;
    }

    return client
      .request({
        method: "post",
        endpoint: "payment_methods/credit_cards",
        data: data,
      })
      .then(function (response) {
        var tokenizedCard = response.creditCards[0];

        delete tokenizedCard.consumed;
        delete tokenizedCard.threeDSecureInfo;

        analytics.sendEvent(client, "unionpay.nonce-received");

        return tokenizedCard;
      })
      .catch(function (err) {
        var error;
        var status = err.details && err.details.httpStatus;

        analytics.sendEvent(client, "unionpay.nonce-failed");

        if (status === 403) {
          error = err;
        } else if (status < 500) {
          error = new BraintreeError(errors.UNIONPAY_FAILED_TOKENIZATION);
          error.details = { originalError: err };
        } else {
          error = new BraintreeError(
            errors.UNIONPAY_TOKENIZATION_NETWORK_ERROR
          );
          error.details = { originalError: err };
        }

        return Promise.reject(error);
      });
  } else if (hostedFields) {
    if (!hostedFields._bus) {
      return Promise.reject(
        new BraintreeError(errors.UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID)
      );
    }

    return new Promise(function (resolve, reject) {
      self._initializeHostedFields().then(function () {
        self._bus.emit(
          events.HOSTED_FIELDS_TOKENIZE,
          options,
          function (response) {
            if (response.err) {
              reject(new BraintreeError(response.err));

              return;
            }

            resolve(response.payload);
          }
        );
      });
    });
  }

  return Promise.reject(
    new BraintreeError(errors.UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED)
  );
};

/**
 * Cleanly remove anything set up by {@link module:braintree-web/unionpay.create|create}. This only needs to be called when using UnionPay with Hosted Fields.
 * @public
 * @param {callback} [callback] Called on completion. If no callback is provided, returns a promise.
 * @example
 * unionpayInstance.teardown();
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
UnionPay.prototype.teardown = function () {
  if (this._bus) {
    this._hostedFieldsFrame.parentNode.removeChild(this._hostedFieldsFrame);
    this._bus.teardown();
  }

  convertMethodsToError(this, methods(UnionPay.prototype));

  return Promise.resolve();
};

UnionPay.prototype._initializeHostedFields = function () {
  var assetsUrl, isDebug;
  var componentId = uuid();
  var self = this;

  if (this._hostedFieldsInitializePromise) {
    return this._hostedFieldsInitializePromise;
  }

  this._hostedFieldsInitializePromise = new Promise(function (resolve) {
    assetsUrl =
      self._options.client.getConfiguration().gatewayConfiguration.assetsUrl;
    isDebug = self._options.client.getConfiguration().isDebug;

    self._bus = new Bus({
      channel: componentId,
      verifyDomain: isVerifiedDomain,
    });
    self._hostedFieldsFrame = iFramer({
      name: constants.HOSTED_FIELDS_FRAME_NAME + "_" + componentId,
      src:
        assetsUrl +
        "/web/" +
        VERSION +
        "/html/unionpay-hosted-fields-frame" +
        useMin(isDebug) +
        ".html",
      height: 0,
      width: 0,
    });

    self._bus.on(BUS_CONFIGURATION_REQUEST_EVENT, function (reply) {
      reply(self._options.client);

      resolve();
    });

    document.body.appendChild(self._hostedFieldsFrame);
  });

  return this._hostedFieldsInitializePromise;
};

module.exports = wrapPromise.wrapPrototype(UnionPay);

},{"../../lib/analytics":119,"../../lib/braintree-error":124,"../../lib/constants":126,"../../lib/convert-methods-to-error":127,"../../lib/is-verified-domain":153,"../../lib/methods":155,"../../lib/use-min":160,"./constants":203,"./errors":204,"@braintree/iframer":35,"@braintree/uuid":39,"@braintree/wrap-promise":43,"framebus":52}],206:[function(_dereq_,module,exports){
"use strict";

module.exports = {
  PLAID_LINK_JS: "https://cdn.plaid.com/link/v2/stable/link-initialize.js",
};

},{}],207:[function(_dereq_,module,exports){
"use strict";

/**
 * @name BraintreeError.Us Bank Account - Creation Error Codes
 * @description Errors that occur when [creating the Us Bank Account component](./module-braintree-web_us-bank-account.html#.create).
 * @property {MERCHANT} US_BANK_ACCOUNT_NOT_ENABLED Occurs when US Bank Account is not enabled in the Braintree control panel.
 */

/**
 * @name BraintreeError.Us Bank Account - tokenize Error Codes
 * @description Errors that occur when using the [`tokenize` method](./UsBankAccount.html#tokenize).
 * @property {MERCHANT} US_BANK_ACCOUNT_OPTION_REQUIRED Occurs when a required option is not passed.
 * @property {MERCHANT} US_BANK_ACCOUNT_MUTUALLY_EXCLUSIVE_OPTIONS Occurs when 1 or more incompatible options are passed.
 * @property {NETWORK} US_BANK_ACCOUNT_LOGIN_LOAD_FAILED Occurs when bank login flow fails.
 * @property {CUSTOMER} US_BANK_ACCOUNT_LOGIN_CLOSED Occurs when bank login window is closed.
 * @property {MERCHANT} US_BANK_ACCOUNT_LOGIN_REQUEST_ACTIVE Occurs when a bank login flow is already active.
 * @property {NETWORK} US_BANK_ACCOUNT_TOKENIZATION_NETWORK_ERROR Occurs when payment details could not be tokenized.
 * @property {CUSTOMER} US_BANK_ACCOUNT_FAILED_TOKENIZATION Occurs when payment details failed to be tokenized.
 * @property {MERCHANT} US_BANK_ACCOUNT_BANK_LOGIN_NOT_ENABLED Occurs when bank login flow is not enabled in the Braintree control panel.
 */

var BraintreeError = _dereq_("../lib/braintree-error");

module.exports = {
  US_BANK_ACCOUNT_OPTION_REQUIRED: {
    type: BraintreeError.types.MERCHANT,
    code: "US_BANK_ACCOUNT_OPTION_REQUIRED",
  },
  US_BANK_ACCOUNT_MUTUALLY_EXCLUSIVE_OPTIONS: {
    type: BraintreeError.types.MERCHANT,
    code: "US_BANK_ACCOUNT_MUTUALLY_EXCLUSIVE_OPTIONS",
  },
  US_BANK_ACCOUNT_LOGIN_LOAD_FAILED: {
    type: BraintreeError.types.NETWORK,
    code: "US_BANK_ACCOUNT_LOGIN_LOAD_FAILED",
    message: "Bank login flow failed to load.",
  },
  US_BANK_ACCOUNT_LOGIN_CLOSED: {
    type: BraintreeError.types.CUSTOMER,
    code: "US_BANK_ACCOUNT_LOGIN_CLOSED",
    message: "Customer closed bank login flow before authorizing.",
  },
  US_BANK_ACCOUNT_LOGIN_REQUEST_ACTIVE: {
    type: BraintreeError.types.MERCHANT,
    code: "US_BANK_ACCOUNT_LOGIN_REQUEST_ACTIVE",
    message: "Another bank login tokenization request is active.",
  },
  US_BANK_ACCOUNT_TOKENIZATION_NETWORK_ERROR: {
    type: BraintreeError.types.NETWORK,
    code: "US_BANK_ACCOUNT_TOKENIZATION_NETWORK_ERROR",
    message: "A tokenization network error occurred.",
  },
  US_BANK_ACCOUNT_FAILED_TOKENIZATION: {
    type: BraintreeError.types.CUSTOMER,
    code: "US_BANK_ACCOUNT_FAILED_TOKENIZATION",
    message: "The supplied data failed tokenization.",
  },
  US_BANK_ACCOUNT_NOT_ENABLED: {
    type: BraintreeError.types.MERCHANT,
    code: "US_BANK_ACCOUNT_NOT_ENABLED",
    message: "US bank account is not enabled.",
  },
  US_BANK_ACCOUNT_BANK_LOGIN_NOT_ENABLED: {
    type: BraintreeError.types.MERCHANT,
    code: "US_BANK_ACCOUNT_BANK_LOGIN_NOT_ENABLED",
    message: "Bank login is not enabled.",
  },
};

},{"../lib/braintree-error":124}],208:[function(_dereq_,module,exports){
"use strict";
/**
 * @module braintree-web/us-bank-account
 * @description This module is for accepting payments of US bank accounts.
 */

var basicComponentVerification = _dereq_("../lib/basic-component-verification");
var BraintreeError = _dereq_("../lib/braintree-error");
var createDeferredClient = _dereq_("../lib/create-deferred-client");
var createAssetsUrl = _dereq_("../lib/create-assets-url");
var errors = _dereq_("./errors");
var USBankAccount = _dereq_("./us-bank-account");
var VERSION = "3.101.3";
var wrapPromise = _dereq_("@braintree/wrap-promise");

/**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {callback} [callback] The second argument, `data`, is the {@link USBankAccount} instance. If no callback is provided, `create` returns a promise that resolves with the {@link USBankAccount} instance.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
function create(options) {
  var name = "US Bank Account";

  return basicComponentVerification
    .verify({
      name: name,
      client: options.client,
      authorization: options.authorization,
    })
    .then(function () {
      return createDeferredClient.create({
        authorization: options.authorization,
        client: options.client,
        debug: options.debug,
        assetsUrl: createAssetsUrl.create(options.authorization),
        name: name,
      });
    })
    .then(function (client) {
      var usBankAccount;

      options.client = client;

      usBankAccount =
        options.client.getConfiguration().gatewayConfiguration.usBankAccount;
      if (!usBankAccount) {
        return Promise.reject(
          new BraintreeError(errors.US_BANK_ACCOUNT_NOT_ENABLED)
        );
      }

      return new USBankAccount(options);
    });
}

module.exports = {
  create: wrapPromise(create),
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION,
};

},{"../lib/basic-component-verification":122,"../lib/braintree-error":124,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./errors":207,"./us-bank-account":209,"@braintree/wrap-promise":43}],209:[function(_dereq_,module,exports){
"use strict";

var BraintreeError = _dereq_("../lib/braintree-error");
var constants = _dereq_("./constants");
var errors = _dereq_("./errors");
var sharedErrors = _dereq_("../lib/errors");
var analytics = _dereq_("../lib/analytics");
var once = _dereq_("../lib/once");
var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
var methods = _dereq_("../lib/methods");
var wrapPromise = _dereq_("@braintree/wrap-promise");

var TOKENIZE_BANK_DETAILS_MUTATION = createGraphQLMutation("UsBankAccount");
var TOKENIZE_BANK_LOGIN_MUTATION = createGraphQLMutation("UsBankLogin");

/**
 * @typedef {object} USBankAccount~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {string} type The payment method type, always `us_bank_account`.
 * @property {object} details Additional account details. Currently empty.
 */

/**
 * @class
 * @param {object} options See {@link module:braintree-web/us-bank-account.create|us-bank-account.create}.
 * @classdesc This class represents a US Bank Account component. Instances of this class can tokenize raw bank details or present a bank login. <strong>You cannot use this constructor directly. Use {@link module:braintree-web/us-bank-account.create|braintree.us-bank-account.create} instead.</strong>
 */
function USBankAccount(options) {
  this._client = options.client;

  this._isTokenizingBankLogin = false;

  analytics.sendEvent(this._client, "usbankaccount.initialized");
}

/**
 * Tokenizes bank information to return a payment method nonce. You can tokenize bank details by providing information like account and routing numbers. You can also tokenize with a bank login UI that prompts the customer to log into their bank account.
 * @public
 * @param {object} options All tokenization options for the US Bank Account component.
 * @param {string} options.mandateText A string for proof of customer authorization. For example, `'I authorize Braintree to debit my bank account on behalf of My Online Store.'`.
 * @param {object} [options.bankDetails] Bank detail information (such as account and routing numbers). `bankDetails` or `bankLogin` option must be provided.
 * @param {string} options.bankDetails.routingNumber The customer's bank routing number, such as `'307075259'`.
 * @param {string} options.bankDetails.accountNumber The customer's bank account number, such as `'999999999'`.
 * @param {string} options.bankDetails.accountType The customer's bank account type. Must be `'checking'` or `'savings'`.
 * @param {string} options.bankDetails.ownershipType The customer's bank account ownership type. Must be `'personal'` or `'business'`.
 * @param {string} [options.bankDetails.firstName] The customer's first name. Required when account ownership type is `personal`.
 * @param {string} [options.bankDetails.lastName] The customer's last name. Required when account ownership type is `personal`.
 * @param {string} [options.bankDetails.businessName] The customer's business name. Required when account ownership type is `business`.
 * @param {object} options.bankDetails.billingAddress The customer's billing address.
 * @param {string} options.bankDetails.billingAddress.streetAddress The street address for the customer's billing address, such as `'123 Fake St'`.
 * @param {string} [options.bankDetails.billingAddress.extendedAddress] The extended street address for the customer's billing address, such as `'Apartment B'`.
 * @param {string} options.bankDetails.billingAddress.locality The locality for the customer's billing address. This is typically a city, such as `'San Francisco'`.
 * @param {string} options.bankDetails.billingAddress.region The region for the customer's billing address. This is typically a state, such as `'CA'`.
 * @param {string} options.bankDetails.billingAddress.postalCode The postal code for the customer's billing address. This is typically a ZIP code, such as `'94119'`.
 * @param {object} [options.bankLogin] Bank login information. `bankLogin` or `bankDetails` option must be provided.
 * @param {string} options.bankLogin.displayName Display name for the bank login UI, such as `'My Store'`.
 * @param {string} options.bankLogin.ownershipType The customer's bank account ownership type. Must be `'personal'` or `'business'`.
 * @param {string} [options.bankLogin.firstName] The customer's first name. Required when account ownership type is `personal`.
 * @param {string} [options.bankLogin.lastName] The customer's last name. Required when account ownership type is `personal`.
 * @param {string} [options.bankLogin.businessName] The customer's business name. Required when account ownership type is `business`.
 * @param {object} options.bankLogin.billingAddress The customer's billing address.
 * @param {string} options.bankLogin.billingAddress.streetAddress The street address for the customer's billing address, such as `'123 Fake St'`.
 * @param {string} [options.bankLogin.billingAddress.extendedAddress] The extended street address for the customer's billing address, such as `'Apartment B'`.
 * @param {string} options.bankLogin.billingAddress.locality The locality for the customer's billing address. This is typically a city, such as `'San Francisco'`.
 * @param {string} options.bankLogin.billingAddress.region The region for the customer's billing address. This is typically a state, such as `'CA'`.
 * @param {string} options.bankLogin.billingAddress.postalCode The postal code for the customer's billing address. This is typically a ZIP code, such as `'94119'`.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link USBankAccount~tokenizePayload|tokenizePayload}. If no callback is provided, `tokenize` returns a promise that resolves with {@link USBankAccount~tokenizePayload|tokenizePayload}.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * <caption>Tokenizing raw bank details</caption>
 * var routingNumberInput = document.querySelector('input[name="routing-number"]');
 * var accountNumberInput = document.querySelector('input[name="account-number"]');
 * var accountTypeInput = document.querySelector('input[name="account-type"]:checked');
 * var ownershipTypeInput = document.querySelector('input[name="ownership-type"]:checked');
 * var firstNameInput = document.querySelector('input[name="first-name"]');
 * var lastNameInput = document.querySelector('input[name="last-name"]');
 * var businessNameInput = document.querySelector('input[name="business-name"]');
 * var billingAddressStreetInput = document.querySelector('input[name="street-address"]');
 * var billingAddressExtendedInput = document.querySelector('input[name="extended-address"]');
 * var billingAddressLocalityInput = document.querySelector('input[name="locality"]');
 * var billingAddressRegionSelect = document.querySelector('select[name="region"]');
 * var billingAddressPostalInput = document.querySelector('input[name="postal-code"]');
 *
 * submitButton.addEventListener('click', function (event) {
 *   var bankDetails = {
 *     routingNumber: routingNumberInput.value,
 *     accountNumber: accountNumberInput.value,
 *     accountType: accountTypeInput.value,
 *     ownershipType: ownershipTypeInput.value,
 *     billingAddress: {
 *       streetAddress: billingAddressStreetInput.value,
 *       extendedAddress: billingAddressExtendedInput.value,
 *       locality: billingAddressLocalityInput.value,
 *       region: billingAddressRegionSelect.value,
 *       postalCode: billingAddressPostalInput.value
 *     }
 *   };
 *
 *   if (bankDetails.ownershipType === 'personal') {
 *     bankDetails.firstName = firstNameInput.value;
 *     bankDetails.lastName = lastNameInput.value;
 *   } else {
 *     bankDetails.businessName = businessNameInput.value;
 *   }
 *
 *   event.preventDefault();
 *
 *   usBankAccountInstance.tokenize({
 *     bankDetails: bankDetails,
 *     mandateText: 'I authorize Braintree to debit my bank account on behalf of My Online Store.'
 *   }, function (tokenizeErr, tokenizedPayload) {
 *     if (tokenizeErr) {
 *       console.error('There was an error tokenizing the bank details.');
 *       return;
 *     }
 *
 *     // Send tokenizePayload.nonce to your server here!
 *   });
 * });
 * @example
 * <caption>Tokenizing with bank login UI</caption>
 * var ownershipTypeInput = document.querySelector('input[name="ownership-type"]:checked');
 * var firstNameInput = document.querySelector('input[name="first-name"]');
 * var lastNameInput = document.querySelector('input[name="last-name"]');
 * var businessNameInput = document.querySelector('input[name="business-name"]');
 * var billingAddressStreetInput = document.querySelector('input[name="street-address"]');
 * var billingAddressExtendedInput = document.querySelector('input[name="extended-address"]');
 * var billingAddressLocalityInput = document.querySelector('input[name="locality"]');
 * var billingAddressRegionSelect = document.querySelector('select[name="region"]');
 * var billingAddressPostalInput = document.querySelector('input[name="postal-code"]');
 *
 * bankLoginButton.addEventListener('click', function (event) {
 *   var bankLogin = {
 *     displayName: 'My Online Store',
 *     ownershipType: ownershipTypeInput.value,
 *     billingAddress: {
 *       streetAddress: billingAddressStreetInput.value,
 *       extendedAddress: billingAddressExtendedInput.value,
 *       locality: billingAddressLocalityInput.value,
 *       region: billingAddressRegionSelect.value,
 *       postalCode: billingAddressPostalInput.value
 *     }
 *   }
 *   event.preventDefault();
 *
 *   if (bankLogin.ownershipType === 'personal') {
 *     bankLogin.firstName = firstNameInput.value;
 *     bankLogin.lastName = lastNameInput.value;
 *   } else {
 *     bankLogin.businessName = businessNameInput.value;
 *   }
 *
 *   usBankAccountInstance.tokenize({
 *     bankLogin: bankLogin,
 *     mandateText: 'I authorize Braintree to debit my bank account on behalf of My Online Store.'
 *   }, function (tokenizeErr, tokenizedPayload) {
 *     if (tokenizeErr) {
 *       console.error('There was an error tokenizing the bank details.');
 *       return;
 *     }
 *
 *     // Send tokenizePayload.nonce to your server here!
 *   });
 * });
 */
USBankAccount.prototype.tokenize = function (options) {
  options = options || {};

  if (!options.mandateText) {
    return Promise.reject(
      new BraintreeError({
        type: errors.US_BANK_ACCOUNT_OPTION_REQUIRED.type,
        code: errors.US_BANK_ACCOUNT_OPTION_REQUIRED.code,
        message: "mandateText property is required.",
      })
    );
  }

  if (options.bankDetails && options.bankLogin) {
    return Promise.reject(
      new BraintreeError({
        type: errors.US_BANK_ACCOUNT_MUTUALLY_EXCLUSIVE_OPTIONS.type,
        code: errors.US_BANK_ACCOUNT_MUTUALLY_EXCLUSIVE_OPTIONS.code,
        message:
          "tokenize must be called with bankDetails or bankLogin, not both.",
      })
    );
  } else if (options.bankDetails) {
    return this._tokenizeBankDetails(options);
  } else if (options.bankLogin) {
    return this._tokenizeBankLogin(options);
  }

  return Promise.reject(
    new BraintreeError({
      type: errors.US_BANK_ACCOUNT_OPTION_REQUIRED.type,
      code: errors.US_BANK_ACCOUNT_OPTION_REQUIRED.code,
      message: "tokenize must be called with bankDetails or bankLogin.",
    })
  );
};

USBankAccount.prototype._tokenizeBankDetails = function (options) {
  var client = this._client;
  var bankDetails = options.bankDetails;
  var data = {
    achMandate: options.mandateText,
    routingNumber: bankDetails.routingNumber,
    accountNumber: bankDetails.accountNumber,
    accountType: bankDetails.accountType.toUpperCase(),
    billingAddress: formatBillingAddressForGraphQL(
      bankDetails.billingAddress || {}
    ),
  };

  formatDataForOwnershipType(data, bankDetails);

  return client
    .request({
      api: "graphQLApi",
      data: {
        query: TOKENIZE_BANK_DETAILS_MUTATION,
        variables: {
          input: {
            usBankAccount: data,
          },
        },
      },
    })
    .then(function (response) {
      analytics.sendEvent(
        client,
        "usbankaccount.bankdetails.tokenization.succeeded"
      );

      return Promise.resolve(
        formatTokenizeResponseFromGraphQL(response, "tokenizeUsBankAccount")
      );
    })
    .catch(function (err) {
      var error = errorFrom(err);

      analytics.sendEvent(
        client,
        "usbankaccount.bankdetails.tokenization.failed"
      );

      return Promise.reject(error);
    });
};

USBankAccount.prototype._tokenizeBankLogin = function (options) {
  var self = this;
  var client = this._client;
  var gatewayConfiguration = client.getConfiguration().gatewayConfiguration;
  var isProduction = gatewayConfiguration.environment === "production";
  var plaidConfig = gatewayConfiguration.usBankAccount.plaid;

  if (!options.bankLogin.displayName) {
    return Promise.reject(
      new BraintreeError({
        type: errors.US_BANK_ACCOUNT_OPTION_REQUIRED.type,
        code: errors.US_BANK_ACCOUNT_OPTION_REQUIRED.code,
        message: "displayName property is required when using bankLogin.",
      })
    );
  }

  if (!plaidConfig) {
    return Promise.reject(
      new BraintreeError(errors.US_BANK_ACCOUNT_BANK_LOGIN_NOT_ENABLED)
    );
  }

  if (this._isTokenizingBankLogin) {
    return Promise.reject(
      new BraintreeError(errors.US_BANK_ACCOUNT_LOGIN_REQUEST_ACTIVE)
    );
  }
  this._isTokenizingBankLogin = true;

  return new Promise(function (resolve, reject) {
    self._loadPlaid(function (plaidLoadErr, plaid) {
      if (plaidLoadErr) {
        reject(plaidLoadErr);

        return;
      }

      plaid
        .create({
          clientName: options.bankLogin.displayName,
          apiVersion: "v2",
          env: isProduction ? "production" : "sandbox",
          key: plaidConfig.publicKey,
          product: "auth",
          selectAccount: true,
          onExit: function () {
            self._isTokenizingBankLogin = false;

            analytics.sendEvent(
              client,
              "usbankaccount.banklogin.tokenization.closed.by-user"
            );

            reject(new BraintreeError(errors.US_BANK_ACCOUNT_LOGIN_CLOSED));
          },
          onSuccess: function (publicToken, metadata) {
            var bankLogin = options.bankLogin;
            var data = {
              publicToken: publicToken,
              accountId: isProduction
                ? metadata.account_id
                : "plaid_account_id",
              accountType: metadata.account.subtype.toUpperCase(),
              achMandate: options.mandateText,
              billingAddress: formatBillingAddressForGraphQL(
                bankLogin.billingAddress || {}
              ),
            };

            formatDataForOwnershipType(data, bankLogin);

            client
              .request({
                api: "graphQLApi",
                data: {
                  query: TOKENIZE_BANK_LOGIN_MUTATION,
                  variables: {
                    input: {
                      usBankLogin: data,
                    },
                  },
                },
              })
              .then(function (response) {
                self._isTokenizingBankLogin = false;

                analytics.sendEvent(
                  client,
                  "usbankaccount.banklogin.tokenization.succeeded"
                );

                resolve(
                  formatTokenizeResponseFromGraphQL(
                    response,
                    "tokenizeUsBankLogin"
                  )
                );
              })
              .catch(function (tokenizeErr) {
                var error;

                self._isTokenizingBankLogin = false;
                error = errorFrom(tokenizeErr);

                analytics.sendEvent(
                  client,
                  "usbankaccount.banklogin.tokenization.failed"
                );

                reject(error);
              });
          },
        })
        .open();

      analytics.sendEvent(
        client,
        "usbankaccount.banklogin.tokenization.started"
      );
    });
  });
};

function errorFrom(err) {
  var error;
  var status = err.details && err.details.httpStatus;

  if (status === 401) {
    error = new BraintreeError(sharedErrors.BRAINTREE_API_ACCESS_RESTRICTED);
  } else if (status < 500) {
    error = new BraintreeError(errors.US_BANK_ACCOUNT_FAILED_TOKENIZATION);
  } else {
    error = new BraintreeError(
      errors.US_BANK_ACCOUNT_TOKENIZATION_NETWORK_ERROR
    );
  }
  error.details = { originalError: err };

  return error;
}

function formatTokenizeResponseFromGraphQL(response, type) {
  var data = response.data[type].paymentMethod;
  var last4 = data.details.last4;
  var description = "US bank account ending in - " + last4;

  return {
    nonce: data.id,
    details: {},
    description: description,
    type: "us_bank_account",
  };
}

USBankAccount.prototype._loadPlaid = function (callback) {
  var existingScript, script;

  callback = once(callback);

  if (window.Plaid) {
    callback(null, window.Plaid);

    return;
  }

  existingScript = document.querySelector(
    'script[src="' + constants.PLAID_LINK_JS + '"]'
  );

  if (existingScript) {
    addLoadListeners(existingScript, callback);
  } else {
    script = document.createElement("script");

    script.src = constants.PLAID_LINK_JS;
    script.async = true;

    addLoadListeners(script, callback);

    document.body.appendChild(script);

    this._plaidScript = script;
  }
};

function addLoadListeners(script, callback) {
  function loadHandler() {
    var readyState = this.readyState; // eslint-disable-line no-invalid-this

    if (!readyState || readyState === "loaded" || readyState === "complete") {
      removeLoadListeners();
      callback(null, window.Plaid);
    }
  }

  function errorHandler() {
    script.parentNode.removeChild(script);

    callback(new BraintreeError(errors.US_BANK_ACCOUNT_LOGIN_LOAD_FAILED));
  }

  function removeLoadListeners() {
    script.removeEventListener("error", errorHandler);
    script.removeEventListener("load", loadHandler);
    script.removeEventListener("readystatechange", loadHandler);
  }

  script.addEventListener("error", errorHandler);
  script.addEventListener("load", loadHandler);
  script.addEventListener("readystatechange", loadHandler);
}

function formatBillingAddressForGraphQL(address) {
  return {
    streetAddress: address.streetAddress,
    extendedAddress: address.extendedAddress,
    city: address.locality,
    state: address.region,
    zipCode: address.postalCode,
  };
}

function formatDataForOwnershipType(data, details) {
  if (details.ownershipType === "personal") {
    data.individualOwner = {
      firstName: details.firstName,
      lastName: details.lastName,
    };
  } else if (details.ownershipType === "business") {
    data.businessOwner = {
      businessName: details.businessName,
    };
  }
}

function createGraphQLMutation(type) {
  return (
    "" +
    "mutation Tokenize" +
    type +
    "($input: Tokenize" +
    type +
    "Input!) {" +
    "  tokenize" +
    type +
    "(input: $input) {" +
    "    paymentMethod {" +
    "      id" +
    "      details {" +
    "        ... on UsBankAccountDetails {" +
    "          last4" +
    "        }" +
    "      }" +
    "    }" +
    "  }" +
    "}"
  );
}

/**
 * Cleanly tear down anything set up by {@link module:braintree-web/us-bank-account.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * usBankAccountInstance.teardown();
 * @example <caption>With callback</caption>
 * usBankAccountInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
USBankAccount.prototype.teardown = function () {
  if (this._plaidScript) {
    document.body.removeChild(this._plaidScript);
  }

  convertMethodsToError(this, methods(USBankAccount.prototype));

  return Promise.resolve();
};

module.exports = wrapPromise.wrapPrototype(USBankAccount);

},{"../lib/analytics":119,"../lib/braintree-error":124,"../lib/convert-methods-to-error":127,"../lib/errors":135,"../lib/methods":155,"../lib/once":156,"./constants":206,"./errors":207,"@braintree/wrap-promise":43}],210:[function(_dereq_,module,exports){
"use strict";

/**
 * @name BraintreeError.Vault Manager - deletePaymentMethod Error Codes
 * @description Errors that occur when using the [`deletePaymentMethod` method](./VaultManager.html#deletePaymentMethod).
 * @property {MERCHANT} VAULT_MANAGER_DELETE_PAYMENT_METHOD_NONCE_REQUIRES_CLIENT_TOKEN Occurs when vault manager is initialized with a tokenization key instead of a Client Token.
 * @property {MERCHANT} VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND Occurs when the specified payment method can not be found.
 * @property {UNKNOWN} VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR Occurs when there is an error attempting to delete the payment method.
 */

var BraintreeError = _dereq_("../lib/braintree-error");

module.exports = {
  VAULT_MANAGER_DELETE_PAYMENT_METHOD_NONCE_REQUIRES_CLIENT_TOKEN: {
    type: BraintreeError.types.MERCHANT,
    code: "VAULT_MANAGER_DELETE_PAYMENT_METHOD_NONCE_REQUIRES_CLIENT_TOKEN",
    message:
      "A client token with a customer id must be used to delete a payment method nonce.",
  },
  VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND: {
    type: BraintreeError.types.MERCHANT,
    code: "VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND",
  },
  VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR: {
    type: BraintreeError.types.UNKNOWN,
    code: "VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR",
  },
};

},{"../lib/braintree-error":124}],211:[function(_dereq_,module,exports){
"use strict";
/**
 * @module braintree-web/vault-manager
 * @description Manages customer's payment methods.
 */

var basicComponentVerification = _dereq_("../lib/basic-component-verification");
var createDeferredClient = _dereq_("../lib/create-deferred-client");
var createAssetsUrl = _dereq_("../lib/create-assets-url");
var VaultManager = _dereq_("./vault-manager");
var VERSION = "3.101.3";
var wrapPromise = _dereq_("@braintree/wrap-promise");

/**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {callback} callback The second argument, `data`, is the {@link VaultManager} instance.
 * @returns {void}
 */
function create(options) {
  var name = "Vault Manager";

  return basicComponentVerification
    .verify({
      name: name,
      client: options.client,
      authorization: options.authorization,
    })
    .then(function () {
      return new VaultManager({
        createPromise: createDeferredClient.create({
          authorization: options.authorization,
          client: options.client,
          debug: options.debug,
          assetsUrl: createAssetsUrl.create(options.authorization),
          name: name,
        }),
      });
    });
}

module.exports = {
  create: wrapPromise(create),
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION,
};

},{"../lib/basic-component-verification":122,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./vault-manager":212,"@braintree/wrap-promise":43}],212:[function(_dereq_,module,exports){
"use strict";

var analytics = _dereq_("../lib/analytics");
var BraintreeError = _dereq_("../lib/braintree-error");
var errors = _dereq_("./errors");
var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
var methods = _dereq_("../lib/methods");
var wrapPromise = _dereq_("@braintree/wrap-promise");

var DELETE_PAYMENT_METHOD_MUTATION =
  "mutation DeletePaymentMethodFromSingleUseToken($input: DeletePaymentMethodFromSingleUseTokenInput!) {" +
  "  deletePaymentMethodFromSingleUseToken(input: $input) {" +
  "    clientMutationId" +
  "  }" +
  "}";

/**
 * @typedef {array} VaultManager~fetchPaymentMethodsPayload The customer's payment methods.
 * @property {object} paymentMethod The payment method object.
 * @property {string} paymentMethod.nonce A nonce that can be sent to your server to transact on the payment method.
 * @property {boolean} paymentMethod.default Whether or not this is the default payment method for the customer.
 * @property {object} paymentMethod.details Any additional details about the payment method. Varies depending on the type of payment method.
 * @property {string} paymentMethod.type A constant indicating the type of payment method.
 * @property {?string} paymentMethod.description Additional description about the payment method.
 * @property {?object} paymentMethod.binData Bin data about the payment method.
 *
 */

/**
 * @class
 * @param {object} options Options
 * @description <strong>You cannot use this constructor directly. Use {@link module:braintree-web/vault-manager.create|braintree.vault-manager.create} instead.</strong>
 * @classdesc This class allows you to manage a customer's payment methods on the client.
 */
function VaultManager(options) {
  this._createPromise = options.createPromise;
}

/**
 * Fetches payment methods owned by the customer whose id was used to generate the client token used to create the {@link module:braintree-web/client|client}.
 * @public
 * @param {object} [options] Options for fetching payment methods.
 * @param {boolean} [options.defaultFirst = false] If `true`, the payment methods will be returned with the default payment method for the customer first. Otherwise, order is not guaranteed.
 * @param {callback} [callback] The second argument is a {@link VaultManager~fetchPaymentMethodsPayload|fetchPaymentMethodsPayload}. This is also what is resolved by the promise if no callback is provided.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * vaultManagerInstance.fetchPaymentMethods(function (err, paymentMethods) {
 *   paymentMethods.forEach(function (paymentMethod) {
 *     // add payment method to UI
 *     // paymentMethod.nonce <- transactable nonce associated with payment method
 *     // paymentMethod.details <- object with additional information about payment method
 *     // paymentMethod.type <- a constant signifying the type
 *   });
 * });
 */
VaultManager.prototype.fetchPaymentMethods = function (options) {
  var defaultFirst;

  options = options || {};

  defaultFirst = options.defaultFirst === true ? 1 : 0;

  return this._createPromise
    .then(function (client) {
      return client.request({
        endpoint: "payment_methods",
        method: "get",
        data: {
          defaultFirst: defaultFirst,
        },
      });
    })
    .then(
      function (paymentMethodsPayload) {
        analytics.sendEvent(
          this._createPromise,
          "vault-manager.fetch-payment-methods.succeeded"
        );

        return paymentMethodsPayload.paymentMethods.map(
          formatPaymentMethodPayload
        );
      }.bind(this)
    );
};

/**
 * Deletes a payment method owned by the customer whose id was used to generate the client token used to create the {@link module:braintree-web/client|client}.
 * @public
 * @param {string} paymentMethodNonce The payment method nonce that references a vaulted payment method.
 * @param {callback} [callback] No data is returned if the operation is successful.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * vaultManagerInstance.deletePaymentMethod('nonce-to-delete', function (err) {
 *   // handle err if it exists
 * });
 */
VaultManager.prototype.deletePaymentMethod = function (paymentMethodNonce) {
  return this._createPromise.then(function (client) {
    var usesClientToken =
      client.getConfiguration().authorizationType === "CLIENT_TOKEN";

    if (!usesClientToken) {
      return Promise.reject(
        new BraintreeError(
          errors.VAULT_MANAGER_DELETE_PAYMENT_METHOD_NONCE_REQUIRES_CLIENT_TOKEN
        )
      );
    }

    return client
      .request({
        api: "graphQLApi",
        data: {
          query: DELETE_PAYMENT_METHOD_MUTATION,
          variables: {
            input: {
              singleUseTokenId: paymentMethodNonce,
            },
          },
          operationName: "DeletePaymentMethodFromSingleUseToken",
        },
      })
      .then(function () {
        analytics.sendEvent(
          client,
          "vault-manager.delete-payment-method.succeeded"
        );

        // noop to prevent sending back the raw graphql data
      })
      .catch(function (error) {
        var originalError = error.details.originalError;
        var formattedError;

        analytics.sendEvent(
          client,
          "vault-manager.delete-payment-method.failed"
        );

        if (
          originalError[0] &&
          originalError[0].extensions.errorClass === "NOT_FOUND"
        ) {
          formattedError = new BraintreeError({
            type: errors.VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND.type,
            code: errors.VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND.code,
            message:
              "A payment method for payment method nonce `" +
              paymentMethodNonce +
              "` could not be found.",
            details: {
              originalError: originalError,
            },
          });
        }

        if (!formattedError) {
          formattedError = new BraintreeError({
            type: errors.VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR.type,
            code: errors.VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR.code,
            message:
              "An unknown error occured when attempting to delete the payment method assocaited with the payment method nonce `" +
              paymentMethodNonce +
              "`.",
            details: {
              originalError: originalError,
            },
          });
        }

        return Promise.reject(formattedError);
      });
  });
};

function formatPaymentMethodPayload(paymentMethod) {
  var formattedPaymentMethod = {
    nonce: paymentMethod.nonce,
    default: paymentMethod.default,
    details: paymentMethod.details,
    hasSubscription: paymentMethod.hasSubscription,
    type: paymentMethod.type,
  };

  if (paymentMethod.description) {
    formattedPaymentMethod.description = paymentMethod.description;
  }

  if (paymentMethod.binData) {
    formattedPaymentMethod.binData = paymentMethod.binData;
  }

  return formattedPaymentMethod;
}

/**
 * Cleanly tear down anything set up by {@link module:braintree-web/vault-manager.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * vaultManagerInstance.teardown();
 * @example <caption>With callback</caption>
 * vaultManagerInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
VaultManager.prototype.teardown = function () {
  convertMethodsToError(this, methods(VaultManager.prototype));

  return Promise.resolve();
};

module.exports = wrapPromise.wrapPrototype(VaultManager);

},{"../lib/analytics":119,"../lib/braintree-error":124,"../lib/convert-methods-to-error":127,"../lib/methods":155,"./errors":210,"@braintree/wrap-promise":43}],213:[function(_dereq_,module,exports){
"use strict";
var __importDefault =
  (this && this.__importDefault) ||
  function (mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
var venmo_desktop_1 = __importDefault(_dereq_("./venmo-desktop"));
module.exports = function createVenmoDesktop(options) {
  var instance = new venmo_desktop_1.default(options);
  return instance.initialize();
};

},{"./venmo-desktop":215}],214:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VENMO_PAYMENT_CONTEXT_STATUS_QUERY =
  exports.LEGACY_VENMO_PAYMENT_CONTEXT_STATUS_QUERY =
  exports.UPDATE_PAYMENT_CONTEXT_QUERY =
  exports.LEGACY_UPDATE_PAYMENT_CONTEXT_QUERY =
  exports.CREATE_PAYMENT_CONTEXT_QUERY =
  exports.LEGACY_CREATE_PAYMENT_CONTEXT_QUERY =
    void 0;
exports.LEGACY_CREATE_PAYMENT_CONTEXT_QUERY =
  "mutation CreateVenmoQRCodePaymentContext($input: CreateVenmoQRCodePaymentContextInput!) {\n  createVenmoQRCodePaymentContext(input: $input) {\n    clientMutationId\n    venmoQRCodePaymentContext {\n      id\n      merchantId\n      createdAt\n      expiresAt\n    }\n  }\n}";
exports.CREATE_PAYMENT_CONTEXT_QUERY =
  "mutation CreateVenmoPaymentContext($input: CreateVenmoPaymentContextInput!) {\n  createVenmoPaymentContext(input: $input) {\n    clientMutationId\n    venmoPaymentContext {\n      id\n      merchantId\n      createdAt\n      expiresAt\n    }\n  }\n}";
exports.LEGACY_UPDATE_PAYMENT_CONTEXT_QUERY =
  "mutation UpdateVenmoQRCodePaymentContext($input: UpdateVenmoQRCodePaymentContextInput!) {\n  updateVenmoQRCodePaymentContext(input: $input) {\n    clientMutationId\n  }\n}";
exports.UPDATE_PAYMENT_CONTEXT_QUERY =
  "mutation UpdateVenmoPaymentContextStatus($input: UpdateVenmoPaymentContextStatusInput!) {\n  updateVenmoPaymentContextStatus(input: $input) {\n    clientMutationId\n  }\n}";
exports.LEGACY_VENMO_PAYMENT_CONTEXT_STATUS_QUERY =
  "query PaymentContext($id: ID!) {\n  node(id: $id) {\n    ... on VenmoQRCodePaymentContext {\n      status\n      paymentMethodId\n      userName\n    }\n  }\n}";
exports.VENMO_PAYMENT_CONTEXT_STATUS_QUERY =
  "query PaymentContext($id: ID!) {\n  node(id: $id) {\n    ... on VenmoPaymentContext {\n      status\n      paymentMethodId\n      userName\n      payerInfo {\n        firstName\n        lastName\n        phoneNumber\n        email\n        externalId\n        userName\n        billingAddress {\n          fullName\n          addressLine1\n          addressLine2\n          adminArea1\n          adminArea2\n          postalCode\n          countryCode\n        }\n        shippingAddress {\n          fullName\n          addressLine1\n          addressLine2\n          adminArea1\n          adminArea2\n          postalCode\n          countryCode\n        }\n      }\n    }\n  }\n}";

},{}],215:[function(_dereq_,module,exports){
"use strict";
var __assign =
  (this && this.__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
    return __assign.apply(this, arguments);
  };
var __importDefault =
  (this && this.__importDefault) ||
  function (mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
var framebus_1 = __importDefault(_dereq_("framebus"));
var iframer_1 = __importDefault(_dereq_("@braintree/iframer"));
var uuid_1 = __importDefault(_dereq_("@braintree/uuid"));
var events_1 = _dereq_("../shared/events");
var queries_1 = _dereq_("./queries");
var VENMO_DESKTOP_POLLING_INTERVAL = 1000; // 1 second
var VISUAL_DELAY_BEFORE_SIGNALLING_COMPLETION = 2000; // 2 seconds
var VenmoDesktop = /** @class */ (function () {
  function VenmoDesktop(options) {
    this.isHidden = true;
    this.env = options.environment;
    this.id = uuid_1.default();
    this.profileId = options.profileId;
    this.displayName = options.displayName;
    this.paymentMethodUsage = options.paymentMethodUsage;
    this.shouldUseLegacyQRCodeMutation = !this.paymentMethodUsage;
    var frameUrl = options.url + "#" + this.env + "_" + this.id;
    this.bus = new framebus_1.default({
      channel: this.id,
      verifyDomain: options.verifyDomain,
      targetFrames: [],
    });
    this.apiRequest = options.apiRequest;
    this.sendEvent = options.sendEvent;
    this.Promise = options.Promise;
    this.alertBox = document.createElement("div");
    this.alertBox.setAttribute("data-venmo-desktop-id", this.id);
    this.alertBox.setAttribute("role", "alert");
    this.alertBox.style.position = "fixed";
    this.alertBox.style.display = "none";
    this.alertBox.style.height = "1px";
    this.alertBox.style.width = "1px";
    this.alertBox.style.overflow = "hidden";
    this.alertBox.style.zIndex = "0";
    this.iframe = iframer_1.default({
      src: frameUrl,
      name: "venmo-desktop-iframe",
      style: {
        display: "none",
        position: "fixed",
        top: "0",
        bottom: "0",
        right: "0",
        left: "0",
        height: "100%",
        width: "100%",
        zIndex: "9999999",
      },
      title: "Venmo Desktop",
    });
    this.bus.addTargetFrame(this.iframe);
  }
  VenmoDesktop.prototype.initialize = function () {
    var _this = this;
    return new this.Promise(function (resolve) {
      _this.bus.on(events_1.VENMO_DESKTOP_IFRAME_READY, function () {
        resolve(_this);
      });
      _this.bus.on(events_1.VENMO_DESKTOP_REQUEST_NEW_QR_CODE, function () {
        _this.sendEvent("venmo.tokenize.desktop.restarted-from-error-view");
        _this.startPolling();
      });
      document.body.appendChild(_this.iframe);
      document.body.appendChild(_this.alertBox);
    });
  };
  VenmoDesktop.prototype.launchDesktopFlow = function () {
    var _this = this;
    this.isHidden = false;
    var promise = new this.Promise(function (resolve, reject) {
      _this.launchDesktopPromiseRejectFunction = reject;
      var removeListeners = function () {
        /* eslint-disable @typescript-eslint/no-use-before-define */
        _this.bus.off(
          events_1.VENMO_DESKTOP_CUSTOMER_CANCELED,
          customerCancelledHandler
        );
        _this.bus.off(
          events_1.VENMO_DESKTOP_UNKNOWN_ERROR,
          unknownErrorHandler
        );
        /* eslint-enable @typescript-eslint/no-use-before-define */
      };
      var unknownErrorHandler = function (err) {
        removeListeners();
        _this.sendEvent("venmo.tokenize.desktop.unknown-error");
        reject({
          allowUIToHandleError: false,
          reason: "UNKNOWN_ERROR",
          err: err,
        });
      };
      var customerCancelledHandler = function () {
        removeListeners();
        _this.updateVenmoDesktopPaymentContext("CANCELED");
        _this.sendEvent(
          "venmo.tokenize.desktop.status-change.canceled-from-modal"
        );
        reject({
          allowUIToHandleError: false,
          reason: "CUSTOMER_CANCELED",
        });
      };
      _this.completedHandler = function (payload) {
        removeListeners();
        resolve(payload);
      };
      _this.bus.on(
        events_1.VENMO_DESKTOP_CUSTOMER_CANCELED,
        customerCancelledHandler
      );
      _this.bus.on(events_1.VENMO_DESKTOP_UNKNOWN_ERROR, unknownErrorHandler);
    });
    this.iframe.style.display = "block";
    this.setAlert("Generating a QR code, get your Venmo app ready");
    this.iframe.focus();
    this.startPolling();
    return promise
      .then(function (result) {
        delete _this.venmoContextId;
        delete _this.launchDesktopPromiseRejectFunction;
        return result;
      })
      .catch(function (err) {
        delete _this.venmoContextId;
        delete _this.launchDesktopPromiseRejectFunction;
        return _this.Promise.reject(err);
      });
  };
  VenmoDesktop.prototype.triggerCompleted = function (result) {
    var _this = this;
    if (this.isHidden) {
      return;
    }
    setTimeout(function () {
      if (_this.completedHandler) {
        _this.completedHandler(result);
      }
      delete _this.completedHandler;
    }, VISUAL_DELAY_BEFORE_SIGNALLING_COMPLETION);
  };
  VenmoDesktop.prototype.triggerRejected = function (err) {
    if (this.launchDesktopPromiseRejectFunction) {
      this.launchDesktopPromiseRejectFunction(err);
    }
  };
  VenmoDesktop.prototype.hideDesktopFlow = function () {
    this.setAlert("");
    this.iframe.style.display = "none";
    this.bus.emit(events_1.VENMO_DESKTOP_CLOSED_FROM_PARENT);
    this.isHidden = true;
  };
  VenmoDesktop.prototype.displayError = function (message) {
    if (this.isHidden) {
      return;
    }
    this.bus.emit(events_1.VENMO_DESKTOP_DISPLAY_ERROR, {
      message: message,
    });
    this.setAlert(message);
  };
  VenmoDesktop.prototype.displayQRCode = function (id, merchantId) {
    if (this.isHidden) {
      return;
    }
    this.bus.emit(events_1.VENMO_DESKTOP_DISPLAY_QR_CODE, {
      id: id,
      merchantId: merchantId,
    });
    this.setAlert("To scan the QR code, open your Venmo app");
  };
  VenmoDesktop.prototype.authorize = function () {
    if (this.isHidden) {
      return;
    }
    this.bus.emit(events_1.VENMO_DESKTOP_AUTHORIZE);
    this.setAlert("Venmo account authorized");
  };
  VenmoDesktop.prototype.authorizing = function () {
    if (this.isHidden) {
      return;
    }
    this.bus.emit(events_1.VENMO_DESKTOP_AUTHORIZING);
    this.setAlert("Authorize on your Venmo app");
  };
  VenmoDesktop.prototype.startPolling = function () {
    var _this = this;
    return this.createVenmoDesktopPaymentContext()
      .then(function (result) {
        var expiresIn =
          new Date(result.expiresAt).getTime() -
          new Date(result.createdAt).getTime();
        var expiredTime = Date.now() + expiresIn;
        _this.displayQRCode(result.id, result.merchantId);
        return _this.pollForStatusChange(result.status, expiredTime);
      })
      .then(function (result) {
        if (!result) {
          return;
        }
        // since we are manually adding a prepended @ sign
        // we want to make sure that the username does not
        // start giving us the @ sign up front in the future
        var username = result.userName || "";
        username = "@" + username.replace("@", "");
        _this.triggerCompleted({
          paymentMethodNonce: result.paymentMethodId,
          username: username,
          payerInfo: result.payerInfo,
          id: _this.venmoContextId || "",
        });
      })
      .catch(function (err) {
        if (err.allowUIToHandleError) {
          // noop here and let the UI handle the customer error
          return;
        }
        _this.sendEvent("venmo.tokenize.desktop.unhandled-error");
        _this.triggerRejected(err);
      });
  };
  VenmoDesktop.prototype.pollForStatusChange = function (status, expiredTime) {
    var _this = this;
    if (!this.venmoContextId) {
      return this.Promise.resolve();
    }
    if (Date.now() > expiredTime) {
      return this.updateVenmoDesktopPaymentContext("EXPIRED").then(function () {
        _this.displayError("Something went wrong");
        _this.sendEvent("venmo.tokenize.desktop.status-change.sdk-timeout");
        return _this.Promise.reject({
          allowUIToHandleError: true,
          reason: "TIMEOUT",
        });
      });
    }
    return this.lookupVenmoDesktopPaymentContext().then(function (response) {
      if (!_this.venmoContextId || !response) {
        return _this.Promise.resolve();
      }
      var newStatus = response.status;
      if (newStatus !== status) {
        status = newStatus;
        _this.sendEvent(
          "venmo.tokenize.desktop.status-change." + status.toLowerCase()
        );
        switch (status) {
          case "CREATED":
            // noop, no need to do anything here
            // should never be able to get to this point
            // but we'll keep it in to enumerate the statuses
            break;
          case "EXPIRED":
          case "FAILED":
          case "CANCELED":
            var message =
              status === "CANCELED"
                ? "The authorization was canceled"
                : "Something went wrong";
            _this.displayError(message);
            // these are all terminal states, so we end it here
            return _this.Promise.reject({
              allowUIToHandleError: true,
              reason: status,
            });
          case "SCANNED":
            _this.authorizing();
            break;
          case "APPROVED":
            _this.authorize();
            return _this.Promise.resolve(response);
          default:
          // any other statuses are irrelevant to the polling
          // and can just be ignored
        }
      }
      return new _this.Promise(function (resolve, reject) {
        setTimeout(function () {
          _this
            .pollForStatusChange(status, expiredTime)
            .then(resolve)
            .catch(reject);
        }, VENMO_DESKTOP_POLLING_INTERVAL);
      });
    });
  };
  VenmoDesktop.prototype.teardown = function () {
    this.bus.teardown();
    if (this.iframe.parentNode) {
      this.iframe.parentNode.removeChild(this.iframe);
    }
    if (this.alertBox.parentNode) {
      this.alertBox.parentNode.removeChild(this.alertBox);
    }
  };
  VenmoDesktop.prototype.setAlert = function (message) {
    this.alertBox.style.display = message ? "block" : "none";
    this.alertBox.textContent = message;
  };
  VenmoDesktop.prototype.createPaymentContextFromGraphqlLegacyQRCodeMutation =
    function (intent) {
      return this.apiRequest(queries_1.LEGACY_CREATE_PAYMENT_CONTEXT_QUERY, {
        input: {
          environment: this.env,
          intent: intent,
        },
      }).then(function (response) {
        return response
          .createVenmoQRCodePaymentContext.venmoQRCodePaymentContext;
      });
    };
  VenmoDesktop.prototype.createPaymentContextFromGraphQL = function (intent) {
    var input = {
      intent: intent,
      paymentMethodUsage: this.paymentMethodUsage,
      customerClient: "DESKTOP",
    };
    if (this.profileId) {
      input.merchantProfileId = this.profileId;
    }
    if (this.displayName) {
      input.displayName = this.displayName;
    }
    return this.apiRequest(queries_1.CREATE_PAYMENT_CONTEXT_QUERY, {
      input: input,
    }).then(function (response) {
      return response.createVenmoPaymentContext.venmoPaymentContext;
    });
  };
  VenmoDesktop.prototype.createVenmoDesktopPaymentContext = function () {
    var _this = this;
    var contextPromise = this.shouldUseLegacyQRCodeMutation
      ? this.createPaymentContextFromGraphqlLegacyQRCodeMutation("PAY_FROM_APP")
      : this.createPaymentContextFromGraphQL("PAY_FROM_APP");
    return contextPromise.then(function (context) {
      _this.venmoContextId = context.id;
      var merchantId = _this.profileId || context.merchantId;
      return {
        id: context.id,
        status: context.status,
        merchantId: merchantId,
        createdAt: context.createdAt,
        expiresAt: context.expiresAt,
      };
    });
  };
  VenmoDesktop.prototype.updateVenmoDesktopPaymentContext = function (
    status,
    additionalOptions
  ) {
    if (additionalOptions === void 0) {
      additionalOptions = {};
    }
    if (!this.venmoContextId) {
      return this.Promise.resolve();
    }
    var data = {
      input: __assign(
        { id: this.venmoContextId, status: status },
        additionalOptions
      ),
    };
    var query = this.shouldUseLegacyQRCodeMutation
      ? queries_1.LEGACY_UPDATE_PAYMENT_CONTEXT_QUERY
      : queries_1.UPDATE_PAYMENT_CONTEXT_QUERY;
    return this.apiRequest(query, data).then(function () {
      // noop so we can resolve without any data to match the type
    });
  };
  VenmoDesktop.prototype.lookupVenmoDesktopPaymentContext = function () {
    if (!this.venmoContextId) {
      return this.Promise.resolve();
    }
    var query = this.shouldUseLegacyQRCodeMutation
      ? queries_1.LEGACY_VENMO_PAYMENT_CONTEXT_STATUS_QUERY
      : queries_1.VENMO_PAYMENT_CONTEXT_STATUS_QUERY;
    return this.apiRequest(query, {
      id: this.venmoContextId,
    }).then(function (response) {
      return response.node;
    });
  };
  return VenmoDesktop;
})();
exports.default = VenmoDesktop;

},{"../shared/events":220,"./queries":214,"@braintree/iframer":35,"@braintree/uuid":39,"framebus":52}],216:[function(_dereq_,module,exports){
"use strict";
/** @module braintree-web/venmo */

var analytics = _dereq_("../lib/analytics");
var basicComponentVerification = _dereq_("../lib/basic-component-verification");
var createDeferredClient = _dereq_("../lib/create-deferred-client");
var createAssetsUrl = _dereq_("../lib/create-assets-url");
var errors = _dereq_("./shared/errors");
var wrapPromise = _dereq_("@braintree/wrap-promise");
var BraintreeError = _dereq_("../lib/braintree-error");
var Venmo = _dereq_("./venmo");
var supportsVenmo = _dereq_("./shared/supports-venmo");
var VERSION = "3.101.3";

/**
 * @typedef {object} Venmo~lineItem
 * @property {number} quantity Number of units of the item purchased. This value must be a whole number and can't be negative or zero.
 * @property {string} unitAmount Per-unit price of the item. Can include up to 2 decimal places. This value can't be negative or zero.
 * @property {string} name Item name. Maximum 127 characters.
 * @property {string} kind Indicates whether the line item is a debit (sale) or credit (refund) to the customer. Accepted values: `debit` and `credit`.
 * @property {?string} unitTaxAmount Per-unit tax price of the item. Can include up to 2 decimal places. This value can't be negative or zero.
 * @property {?string} description Item description. Maximum 127 characters.
 * @property {?string} productCode Product or UPC code for the item. Maximum 127 characters.
 * @property {?string} url The URL to product information.
 */

/**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {boolean} [options.allowNewBrowserTab=true] This should be set to false if your payment flow requires returning to the same tab, e.g. single page applications. Doing so causes {@link Venmo#isBrowserSupported|isBrowserSupported} to return true only for mobile web browsers that support returning from the Venmo app to the same tab.
 * @param {boolean} [options.allowWebviews=true] This should be set to false if your payment flow does not occur from within a webview that you control. Doing so causes {@link Venmo#isBrowserSupported|isBrowserSupported} to return true only for mobile web browsers that are not webviews.
 * @param {boolean} [options.ignoreHistoryChanges=false] When the Venmo app returns to the website, it will modify the hash of the url to include data about the tokenization. By default, the SDK will put the state of the hash back to where it was before the change was made. Pass `true` to handle the hash change instead of the SDK.
 * @param {string} [options.profileId] The Venmo profile ID to be used during payment authorization. Customers will see the business name and logo associated with this Venmo profile, and it will show up in the Venmo app as a "Connected Merchant". Venmo profile IDs can be found in the Braintree Control Panel. Omitting this value will use the default Venmo profile.
 * @param {string} [options.deepLinkReturnUrl] An override for the URL that the Venmo iOS app opens to return from an app switch.
 * @param {boolean} [options.requireManualReturn=false] When `true`, the customer will have to manually switch back to the browser/webview that is presenting Venmo to complete the payment.
 * @param {boolean} [options.useRedirectForIOS=false] Normally, the Venmo flow is launched using `window.open` and the Venmo app intercepts that call and opens the Venmo app instead. If the customer does not have the Venmo app installed, it opens the Venmo website in a new window and instructs the customer to install the app.
 
 * In iOS webviews and Safari View Controllers (a webview-like environment which is indistinguishable from Safari for JavaScript environments), this call to `window.open` will always fail to app switch to Venmo, resulting instead in a white screen. Because of this, an alternate approach is required to launch the Venmo flow.
 *
 * When `useRedirectForIOS` is `true` and the Venmo flow is started in an iOS environment, the Venmo flow will be started by setting `window.location.href` to the Venmo website (which will still be intercepted by the Venmo app and should be the same behavior as if `window.open` was called). However, if the customer does not have the Venmo app installed, the merchant page will instead be replaced with the Venmo website and the customer will need to use the browser's back button to return to the merchant's website. Ensure that your customer's checkout information will not be lost if they are navigated away from the website and return using the browser back button.
 *
 * Due to a bug in iOS's implementation of `window.open` in iOS webviews and Safari View Controllers, if `useRedirectForIOS` is not set to `true` and the flow is launched from an iOS webview or Safari View Controller, the customer will be presented with a blank screen, halting the flow and leaving the customer unable to return to the merchant's website. Setting `useRedirectForIOS` to `true` will allow the flow to continue, but the Venmo app will be unable to return back to the webview/Safari View Controller. It will instead open the merchant's site in a new window in the customer's browser, which means the merchant site must be able to process the Venmo payment. If the SDK is configured with `allowNewBrowserTab = false`, it is unlikely that the website is set up to process the Venmo payment from a new window.
 *
 * If processing the payment from a new window is not possible, use this flag in conjunction with `requireManualReturn` so that the customer may start the flow from a webview/Safari View Controller or their Safari browser and manually return to the place that originated the flow once the Venmo app has authorized the payment and instructed them to do so.
 * @param {string} [options.paymentMethodUsage] The intended usage for the Venmo payment method nonce. Possible options are:
 * * single_use - intended as a one time transaction
 * * multi_use - intended to be vaulted and used for multiple transactions
 * @param {string} [options.displayName] The business name that will be displayed in the Venmo app payment approval screen. Only applicable when used with `paymentMethodUsage` and used by merchants onboarded as PayFast channel partners.
 * @param {boolean} [options.allowDesktop] Used to support desktop users. When enabled, the default mode is to render a scannable QR-code customers scan with their phone's to approve via the mobile app.
 * @param {boolean} [options.allowDesktopWebLogin=false] When `true`, the customer will authorize payment via a window popup that allows them to sign in to their Venmo account. This is used explicitly for customers operating from desktop browsers wanting to avoid the QR Code flow.
 * @param {boolean} [options.mobileWebFallBack] Use this option when you want to use a web-login experience, such as if on mobile and the Venmo app isn't installed.
 * @param {boolean} [options.allowAndroidRecreation=true] This flag is for when your integration uses the [Android PopupBridge](https://github.com/braintree/popup-bridge-android). Setting this flag to false will avoid a page refresh when returning to your page after payment authorization. If not specified, it defaults to true and the Android activity will be recreated, resulting in a page refresh.
 * @param {boolean} [options.collectCustomerBillingAddress] When `true`, the customer's billing address will be collected and displayed on the Venmo paysheet (provided the Enriched Customer Data checkbox is also enabled for the merchant account).
 * @param {boolean} [options.collectCustomerShippingAddress] When `true`, the customer's shipping address will be collected and displayed on the Venmo paysheet (provided the Enriched Customer Data checkbox is also enabled for the merchant account).
 * @param {boolean} [options.isFinalAmount=false] When `true`, it denotes that the purchase amount (`totalAmount`) is final and will not change.
 * @param {lineItem[]} [options.lineItems] The {@link Venmo~lineItem|line items} belonging to the transaction. It can include up to 249 line items.
 * @param {string} [options.subTotalAmount] The subtotal amount of the transaction, excluding taxes, discounts, and shipping.
 * @param {string} [options.discountAmount] The total discount amount applied on the transaction.
 * @param {string} [options.shippingAmount] Shipping amount to be charged for the transaction.
 * @param {string} [options.taxAmount] The total tax amount applied to the transaction. This value can't be negative or zero.
 * @param {string} [options.totalAmount] The grand total amount of the transaction.
 *
 * Note: This flow currently requires a full page redirect, which means to utilize this flow your page will need to be able to handle the checkout session across different pages.
 * @param {callback} [callback] The second argument, `data`, is the {@link Venmo} instance. If no callback is provided, `create` returns a promise that resolves with the {@link Venmo} instance.
 * @example
 * braintree.venmo.create({
 *   client: clientInstance
 * }).then(function (venmoInstance) {
 *   // venmoInstance is ready to be used.
 * }).catch(function (createErr) {
 *   console.error('Error creating Venmo instance', createErr);
 * });
 * @example <caption>Allow desktop flow to be used</caption>
 * braintree.venmo.create({
 *   client: clientInstance,
 *   allowDesktop: true
 * }).then(function (venmoInstance) {
 *   // venmoInstance is ready to be used.
 * }).catch(function (createErr) {
 *   console.error('Error creating Venmo instance', createErr);
 * });
 * @returns {(Promise|void)} Returns the Venmo instance.
 */
function create(options) {
  var name = "Venmo";

  return basicComponentVerification
    .verify({
      name: name,
      client: options.client,
      authorization: options.authorization,
    })
    .then(function () {
      var createPromise, instance;

      if (options.profileId && typeof options.profileId !== "string") {
        return Promise.reject(
          new BraintreeError(errors.VENMO_INVALID_PROFILE_ID)
        );
      }

      if (
        options.deepLinkReturnUrl &&
        typeof options.deepLinkReturnUrl !== "string"
      ) {
        return Promise.reject(
          new BraintreeError(errors.VENMO_INVALID_DEEP_LINK_RETURN_URL)
        );
      }

      createPromise = createDeferredClient
        .create({
          authorization: options.authorization,
          client: options.client,
          debug: options.debug,
          assetsUrl: createAssetsUrl.create(options.authorization),
          name: name,
        })
        .then(function (client) {
          var configuration = client.getConfiguration();

          options.client = client;

          if (!configuration.gatewayConfiguration.payWithVenmo) {
            return Promise.reject(new BraintreeError(errors.VENMO_NOT_ENABLED));
          }

          return client;
        });

      options.createPromise = createPromise;
      instance = new Venmo(options);

      analytics.sendEvent(createPromise, "venmo.initialized");

      return createPromise.then(function () {
        return instance;
      });
    });
}

/**
 * @static
 * @function isBrowserSupported
 * @param {object} [options] browser support options:
 * @param {boolean} [options.allowNewBrowserTab=true] This should be set to false if your payment flow requires returning to the same tab, e.g. single page applications.
 * @param {boolean} [options.allowWebviews=true] This should be set to false if your payment flow does not occur from within a webview that you control.
 * @example
 * if (braintree.venmo.isBrowserSupported()) {
 *   // set up Venmo
 * }
 * @example <caption>Explicitly require browser support returning to the same tab</caption>
 * if (braintree.venmo.isBrowserSupported({
 *   allowNewBrowserTab: false
 * })) {
 *   // set up Venmo
 * }
 * @example <caption>Explicitly set webviews as disallowed browsers</caption>
 * if (braintree.venmo.isBrowserSupported({
 *   allowWebviews: false
 * })) {
 *   // set up Venmo
 * }
 * @returns {boolean} Whether or not the browser supports Venmo.
 */
function isBrowserSupported(options) {
  return supportsVenmo.isBrowserSupported(options);
}

module.exports = {
  create: wrapPromise(create),
  isBrowserSupported: isBrowserSupported,
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION,
};

},{"../lib/analytics":119,"../lib/basic-component-verification":122,"../lib/braintree-error":124,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./shared/errors":219,"./shared/supports-venmo":222,"./venmo":224,"@braintree/wrap-promise":43}],217:[function(_dereq_,module,exports){
"use strict";

var isAndroid = _dereq_("@braintree/browser-detection/is-android");
var isChrome = _dereq_("@braintree/browser-detection/is-chrome");
var isIos = _dereq_("@braintree/browser-detection/is-ios");
var isIosSafari = _dereq_("@braintree/browser-detection/is-ios-safari");
var isIosWebview = _dereq_("@braintree/browser-detection/is-ios-webview");
var isSamsung = _dereq_("@braintree/browser-detection/is-samsung");

function isAndroidWebview() {
  return (
    isAndroid() && window.navigator.userAgent.toLowerCase().indexOf("wv") > -1
  );
}

function doesNotSupportWindowOpenInIos() {
  if (!isIos()) {
    return false;
  }

  return isIosWebview() || !isIosSafari();
}

function isFacebookOwnedBrowserOnAndroid() {
  var ua = window.navigator.userAgent.toLowerCase();

  // Huawei's Facebook useragent does not include Android
  if (ua.indexOf("huawei") > -1 && ua.indexOf("fban") > -1) {
    return true;
  }

  if (!isAndroid()) {
    return false;
  }

  return ua.indexOf("fb_iab") > -1 || ua.indexOf("instagram") > -1;
}

function isIosChrome() {
  return isIos() && isChrome();
}

module.exports = {
  isAndroid: isAndroid,
  isAndroidWebview: isAndroidWebview,
  isChrome: isChrome,
  isIos: isIos,
  isIosChrome: isIosChrome,
  isSamsung: isSamsung,
  isIosSafari: isIosSafari,
  isIosWebview: isIosWebview,
  isFacebookOwnedBrowserOnAndroid: isFacebookOwnedBrowserOnAndroid,
  doesNotSupportWindowOpenInIos: doesNotSupportWindowOpenInIos,
};

},{"@braintree/browser-detection/is-android":22,"@braintree/browser-detection/is-chrome":24,"@braintree/browser-detection/is-ios":30,"@braintree/browser-detection/is-ios-safari":27,"@braintree/browser-detection/is-ios-webview":28,"@braintree/browser-detection/is-samsung":31}],218:[function(_dereq_,module,exports){
"use strict";

/**
 * Venmo shared constants
 * @typedef {object} Venmo~venmoConstants
 * @ignore
 * @property {string} VENMO_APP_OR_MOBILE_AUTH_URL A deep-linked url that will open the Venmo app if installed, or navigate to a Venmo web-login experience if the Venmo app is not present.
 * @property {string} VENMO_MOBILE_APP_AUTH_ONLY_URL A deep-linked url that leads to a Venmo dead-end page if the Venmo app is not installed (page asks customer to download the app).
 * @property {string} VENMO_WEB_LOGIN_URL A non-deeplinked url that leads to a Venmo login page. For use when explicitly wanting to avoid using the Venmo mobile app via a deep-linked url.
 */
module.exports = {
  DOCUMENT_VISIBILITY_CHANGE_EVENT_DELAY: 500,
  DEFAULT_PROCESS_RESULTS_DELAY: 1000,
  VENMO_APP_OR_MOBILE_AUTH_URL: "https://venmo.com/go/checkout",
  VENMO_MOBILE_APP_AUTH_ONLY_URL: "https://venmo.com/braintree/checkout",
  VENMO_WEB_LOGIN_URL: "https://account.venmo.com/go/web",
};

},{}],219:[function(_dereq_,module,exports){
"use strict";

/**
 * @name BraintreeError.Venmo - Creation Error Codes
 * @description Errors that occur when [creating the Venmo component](./module-braintree-web_venmo.html#.create).
 * @property {MERCHANT} VENMO_NOT_ENABLED Occurs when Venmo is not enabled on the Braintree control panel.
 * @property {MERCHANT} VENMO_INVALID_PROFILE_ID Occurs when Venmo is initialized with a profile id, but it is invalid.
 * @property {UNKNOWN} VENMO_MOBILE_POLLING_SETUP_FAILED __Deprecated__ No longer returned. Use `VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED` instead.
 * @property {UNKNOWN} VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED Occurs when the request to set up a Venmo Payment Context object fails.
 */

/**
 * @name BraintreeError.Venmo - tokenize Error Codes
 * @description Errors that occur when using the [`tokenize` method](./Venmo.html#tokenize).
 * @property {CUSTOMER} VENMO_APP_CANCELED Occurs when customer cancels flow from the Venmo app.
 * @property {UNKNOWN} VENMO_APP_FAILED Occurs when tokenization fails.
 * @property {CUSTOMER} VENMO_CANCELED Occurs when customer cancels the flow or Venmo app is not available.
 * @property {CUSTOMER} VENMO_CUSTOMER_CANCELED Occurs when customer cancels the flow.
 * @property {CUSTOMER} VENMO_DESKTOP_CANCELED Occurs when customer cancels the Venmo Desktop flow by closing the modal.
 * @property {UNKNOWN} VENMO_DESKTOP_UNKNOWN_ERROR Occurs when an unknown error causes the Venmo Desktop flow to fail.
 * @property {UNKNOWN} VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR Occurs when an unknown network error causes the mobile polling process to fail.
 * @property {CUSTOMER} VENMO_MOBILE_POLLING_TOKENIZATION_EXPIRED Occurs when the polling has expired and the payment cannot be completed.
 * @property {CUSTOMER} VENMO_MOBILE_POLLING_TOKENIZATION_CANCELED Occurs when the polling operation is canceled by the customer.
 * @property {CUSTOMER} VENMO_MOBILE_POLLING_TOKENIZATION_TIMEOUT Occurs when customer takes too long to complete payment.
 * @property {UNKNOWN} VENMO_MOBILE_POLLING_TOKENIZATION_FAILED Occurs if there is an unknown error during the mobile polling process.
 * @property {NETWORK} VENMO_NETWORK_ERROR Occurs when a network error causes a request to fail.
 * @property {MERCHANT} VENMO_TOKENIZATION_CANCELED_BY_MERCHANT Occurs when `cancelTokenization` is called while tokenization is in progress.
 * @property {UNKNOWN} VENMO_TOKENIZATION_FAILED Occurs when there is an unknown error during the web login experience.
 * @property {MERCHANT} VENMO_TOKENIZATION_REQUEST_ACTIVE Occurs when `tokenize` is called when the flow is already in progress.
 * @property {MERCHANT} VENMO_TOKENIZATION_REQUEST_NOT_ACTIVE Occurs when `cancelTokenization` is called when the flow is not in progress.
 * @property {MERCHANT} VENMO_ECD_DISABLED Occurs when the merchant tries to access customer details without enabling Enriched Customer Data.
 */

var BraintreeError = _dereq_("../../lib/braintree-error");

module.exports = {
  VENMO_NOT_ENABLED: {
    type: BraintreeError.types.MERCHANT,
    code: "VENMO_NOT_ENABLED",
    message: "Venmo is not enabled for this merchant.",
  },
  VENMO_TOKENIZATION_REQUEST_ACTIVE: {
    type: BraintreeError.types.MERCHANT,
    code: "VENMO_TOKENIZATION_REQUEST_ACTIVE",
    message: "Another tokenization request is active.",
  },
  VENMO_TOKENIZATION_REQUEST_NOT_ACTIVE: {
    type: BraintreeError.types.MERCHANT,
    code: "VENMO_TOKENIZATION_REQUEST_NOT_ACTIVE",
    message: "No tokenization in progress.",
  },
  VENMO_APP_FAILED: {
    type: BraintreeError.types.UNKNOWN,
    code: "VENMO_APP_FAILED",
    message: "Venmo app encountered a problem.",
  },
  VENMO_APP_CANCELED: {
    type: BraintreeError.types.CUSTOMER,
    code: "VENMO_APP_CANCELED",
    message: "Venmo app authorization was canceled.",
  },
  VENMO_CANCELED: {
    type: BraintreeError.types.CUSTOMER,
    code: "VENMO_CANCELED",
    message:
      "User canceled Venmo authorization, or Venmo app is not available.",
  },
  VENMO_CUSTOMER_CANCELED: {
    type: BraintreeError.types.CUSTOMER,
    code: "VENMO_CUSTOMER_CANCELED",
    message: "User canceled Venmo authorization.",
  },
  VENMO_NETWORK_ERROR: {
    type: BraintreeError.types.NETWORK,
    code: "VENMO_NETWORK_ERROR",
    message: "Something went wrong making the request",
  },
  VENMO_DESKTOP_CANCELED: {
    type: BraintreeError.types.CUSTOMER,
    code: "VENMO_DESKTOP_CANCELED",
    message:
      "User canceled Venmo authorization by closing the Venmo Desktop modal.",
  },
  VENMO_TOKENIZATION_CANCELED_BY_MERCHANT: {
    type: BraintreeError.types.MERCHANT,
    code: "VENMO_TOKENIZATION_CANCELED_BY_MERCHANT",
    message: "The Venmo tokenization was canceled by the merchant.",
  },
  VENMO_DESKTOP_UNKNOWN_ERROR: {
    type: BraintreeError.types.UNKNOWN,
    code: "VENMO_DESKTOP_UNKNOWN_ERROR",
    message: "Something went wrong with the Venmo Desktop flow.",
  },
  VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED: {
    type: BraintreeError.types.NETWORK,
    code: "VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED",
    message: "Something went wrong creating the Venmo Payment Context.",
  },
  VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR: {
    type: BraintreeError.types.UNKNOWN,
    code: "VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR",
    message: "Something went wrong during mobile polling.",
  },
  VENMO_MOBILE_POLLING_TOKENIZATION_EXPIRED: {
    type: BraintreeError.types.CUSTOMER,
    code: "VENMO_MOBILE_POLLING_TOKENIZATION_EXPIRED",
    message: "The Venmo authorization request is expired.",
  },
  VENMO_MOBILE_POLLING_TOKENIZATION_CANCELED: {
    type: BraintreeError.types.CUSTOMER,
    code: "VENMO_MOBILE_POLLING_TOKENIZATION_CANCELED",
    message: "The Venmo authorization was canceled",
  },
  VENMO_MOBILE_POLLING_TOKENIZATION_TIMEOUT: {
    type: BraintreeError.types.CUSTOMER,
    code: "VENMO_MOBILE_POLLING_TOKENIZATION_TIMEOUT",
    message: "Customer took too long to authorize Venmo payment.",
  },
  VENMO_MOBILE_POLLING_TOKENIZATION_FAILED: {
    type: BraintreeError.types.UNKNOWN,
    code: "VENMO_MOBILE_POLLING_TOKENIZATION_FAILED",
    message: "The Venmo authorization failed.",
  },
  VENMO_INVALID_PROFILE_ID: {
    type: BraintreeError.types.MERCHANT,
    code: "VENMO_INVALID_PROFILE_ID",
    message: "Venmo profile ID is invalid.",
  },
  VENMO_INVALID_DEEP_LINK_RETURN_URL: {
    type: BraintreeError.types.MERCHANT,
    code: "VENMO_INVALID_DEEP_LINK_RETURN_URL",
    message: "Venmo deep link return URL is invalid.",
  },
  VENMO_TOKENIZATION_FAILED: {
    type: BraintreeError.types.UNKNOWN,
    code: "VENMO_TOKENIZATION_FAILED",
    message: "Venmo encountered a problem",
  },
  VENMO_ECD_DISABLED: {
    type: BraintreeError.types.MERCHANT,
    code: "ECD_DISABLED",
    message:
      "Cannot collect customer data when ECD is disabled. Enable this feature in the Control Panel to collect this data.",
  },
};

},{"../../lib/braintree-error":124}],220:[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VENMO_DESKTOP_UNKNOWN_ERROR =
  exports.VENMO_DESKTOP_REQUEST_NEW_QR_CODE =
  exports.VENMO_DESKTOP_CLOSED_FROM_PARENT =
  exports.VENMO_DESKTOP_IFRAME_READY =
  exports.VENMO_DESKTOP_DISPLAY_QR_CODE =
  exports.VENMO_DESKTOP_DISPLAY_ERROR =
  exports.VENMO_DESKTOP_CUSTOMER_CANCELED =
  exports.VENMO_DESKTOP_AUTHORIZING =
  exports.VENMO_DESKTOP_AUTHORIZE =
  exports.VENMO_DESKTOP_AUTHORIZATION_TIMED_OUT =
    void 0;
exports.VENMO_DESKTOP_AUTHORIZATION_TIMED_OUT =
  "VENMO_DESKTOP_AUTHORIZATION_TIMED_OUT";
exports.VENMO_DESKTOP_AUTHORIZE = "VENMO_DESKTOP_AUTHORIZE";
exports.VENMO_DESKTOP_AUTHORIZING = "VENMO_DESKTOP_AUTHORIZING";
exports.VENMO_DESKTOP_CUSTOMER_CANCELED = "VENMO_DESKTOP_CUSTOMER_CANCELED";
exports.VENMO_DESKTOP_DISPLAY_ERROR = "VENMO_DESKTOP_DISPLAY_ERROR";
exports.VENMO_DESKTOP_DISPLAY_QR_CODE = "VENMO_DESKTOP_DISPLAY_QR_CODE";
exports.VENMO_DESKTOP_IFRAME_READY = "VENMO_DESKTOP_IFRAME_READY";
exports.VENMO_DESKTOP_CLOSED_FROM_PARENT = "VENMO_DESKTOP_CLOSED_FROM_PARENT";
exports.VENMO_DESKTOP_REQUEST_NEW_QR_CODE = "VENMO_DESKTOP_REQUEST_NEW_QR_CODE";
exports.VENMO_DESKTOP_UNKNOWN_ERROR = "VENMO_DESKTOP_UNKNOWN_ERROR";

},{}],221:[function(_dereq_,module,exports){
"use strict";
var venmoConstants = _dereq_("./constants");

function getVenmoUrl(options) {
  if (options.useAllowDesktopWebLogin)
    return venmoConstants.VENMO_WEB_LOGIN_URL;

  if (options.mobileWebFallBack)
    return venmoConstants.VENMO_APP_OR_MOBILE_AUTH_URL;

  return venmoConstants.VENMO_MOBILE_APP_AUTH_ONLY_URL;
}

module.exports = getVenmoUrl;

},{"./constants":218}],222:[function(_dereq_,module,exports){
"use strict";

var browserDetection = _dereq_("./browser-detection");
var inIframe = _dereq_("../../lib/in-iframe");

function isBrowserSupported(options) {
  var isKnownUnsupportedMobileBrowser,
    merchantAllowsDesktopBrowsers,
    merchantAllowsIosChrome,
    merchantAllowsReturningToNewBrowserTab,
    merchantAllowsWebviews;
  var isAndroid = browserDetection.isAndroid();
  var isMobileDevice = isAndroid || browserDetection.isIos();
  var isAndroidChrome = isAndroid && browserDetection.isChrome();
  var isMobileDeviceThatSupportsReturnToSameTab =
    browserDetection.isIosSafari() || isAndroidChrome;

  options = options || {};
  // NEXT_MAJOR_VERSION allowDesktop will default to true, but can be opted out
  merchantAllowsDesktopBrowsers =
    (options.allowDesktopWebLogin || options.allowDesktop) === true;
  merchantAllowsReturningToNewBrowserTab = options.hasOwnProperty(
    "allowNewBrowserTab"
  )
    ? options.allowNewBrowserTab
    : true;
  // NEXT_MAJOR_VERSION webviews are not supported, except for the case where
  // the merchant themselves is presenting venmo in a webview using the deep
  // link url to get back to their app. For the next major version, we should
  // just not have this option and instead require the merchant to determine
  // if the venmo button should be displayed when presenting it in the
  // merchant's app via a webview.
  merchantAllowsWebviews = options.hasOwnProperty("allowWebviews")
    ? options.allowWebviews
    : true;
  // Venmo only works on iOS Chrome when the
  // button is not rendered in an iFrame and
  // allowNewBrowserTab is set to true
  merchantAllowsIosChrome =
    merchantAllowsReturningToNewBrowserTab && !inIframe();

  isKnownUnsupportedMobileBrowser =
    (!merchantAllowsIosChrome && browserDetection.isIosChrome()) ||
    browserDetection.isFacebookOwnedBrowserOnAndroid() ||
    browserDetection.isSamsung();

  if (isKnownUnsupportedMobileBrowser) {
    return false;
  }

  if (
    !merchantAllowsWebviews &&
    (browserDetection.isAndroidWebview() || browserDetection.isIosWebview())
  ) {
    return false;
  }

  if (!isMobileDevice) {
    return merchantAllowsDesktopBrowsers;
  }

  if (!merchantAllowsReturningToNewBrowserTab) {
    return isMobileDeviceThatSupportsReturnToSameTab;
  }

  return isMobileDevice;
}

module.exports = {
  isBrowserSupported: isBrowserSupported,
};

},{"../../lib/in-iframe":150,"./browser-detection":217}],223:[function(_dereq_,module,exports){
"use strict";

var frameService = _dereq_("../../lib/frame-service/external");
var useMin = _dereq_("../../lib/use-min");
var ExtendedPromise = _dereq_("@braintree/extended-promise");
var errors = _dereq_("../shared/errors");
var BraintreeError = _dereq_("../../lib/braintree-error");

var VERSION = "3.101.3";
var VENMO_LOGO_SVG =
  '<svg width="198" height="58" viewBox="0 0 198 58" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M43.0702 13.6572C44.1935 15.4585 44.6999 17.3139 44.6999 19.6576C44.6999 27.1328 38.1277 36.8436 32.7935 43.6625H20.6099L15.7236 15.2939L26.3917 14.3105L28.9751 34.4966C31.389 30.6783 34.3678 24.6779 34.3678 20.587C34.3678 18.3477 33.9727 16.8225 33.3553 15.5666L43.0702 13.6572Z" fill="white"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M56.8965 26.1491C58.8596 26.1491 63.8018 25.2772 63.8018 22.5499C63.8018 21.2402 62.8481 20.587 61.7242 20.587C59.7579 20.587 57.1776 22.8763 56.8965 26.1491ZM56.6715 31.5506C56.6715 34.8807 58.5787 36.1873 61.107 36.1873C63.8603 36.1873 66.4966 35.534 69.923 33.8433L68.6324 42.3523C66.2183 43.4976 62.4559 44.2617 58.8039 44.2617C49.5403 44.2617 46.2249 38.8071 46.2249 31.9879C46.2249 23.1496 51.6179 13.765 62.7365 13.765C68.858 13.765 72.2809 17.0949 72.2809 21.7317C72.2815 29.2066 62.4005 31.4965 56.6715 31.5506Z" fill="white"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M103.067 20.3142C103.067 21.4052 102.897 22.9875 102.727 24.0216L99.5262 43.6622H89.1385L92.0585 25.658C92.1139 25.1696 92.284 24.1865 92.284 23.6411C92.284 22.3314 91.4414 22.0047 90.4282 22.0047C89.0826 22.0047 87.7337 22.6042 86.8354 23.0418L83.5234 43.6625H73.0772L77.8495 14.257H86.8908L87.0052 16.6041C89.1382 15.2404 91.9469 13.7656 95.932 13.7656C101.212 13.765 103.067 16.3845 103.067 20.3142Z" fill="white"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M133.906 16.9841C136.881 14.9131 139.69 13.765 143.563 13.765C148.897 13.765 150.753 16.3845 150.753 20.3142C150.753 21.4052 150.583 22.9875 150.413 24.0216L147.216 43.6622H136.825L139.801 25.2774C139.855 24.786 139.971 24.1865 139.971 23.8063C139.971 22.3317 139.128 22.0047 138.115 22.0047C136.824 22.0047 135.535 22.5501 134.577 23.0418L131.266 43.6625H120.878L123.854 25.2777C123.908 24.7863 124.02 24.1868 124.02 23.8065C124.02 22.332 123.177 22.0049 122.167 22.0049C120.819 22.0049 119.473 22.6045 118.574 23.0421L115.26 43.6628H104.817L109.589 14.2573H118.52L118.8 16.7122C120.878 15.241 123.684 13.7662 127.446 13.7662C130.704 13.765 132.837 15.129 133.906 16.9841Z" fill="white"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M171.426 25.5502C171.426 23.1496 170.808 21.513 168.956 21.513C164.857 21.513 164.015 28.55 164.015 32.1498C164.015 34.8807 164.802 36.5709 166.653 36.5709C170.528 36.5709 171.426 29.1497 171.426 25.5502ZM153.458 31.7152C153.458 22.442 158.511 13.765 170.136 13.765C178.896 13.765 182.098 18.7854 182.098 25.7148C182.098 34.8805 177.099 44.3723 165.194 44.3723C156.378 44.3723 153.458 38.7525 153.458 31.7152Z" fill="white"/>\n</svg>';
var CONTINUE_OR_CANCEL_INSTRUCTIONS =
  "Tap cancel payment to cancel and return to the business. Continue payment will relaunch the payment window.";

var POPUP_WIDTH = 400;
var POPUP_HEIGHT = 570;
var ELEMENT_IDS = {
  backdrop: "venmo-desktop-web-backdrop",
  backdropHidden: "venmo-desktop-web-backdrop.hidden",
  backdropContainer: "venmo-backdrop-container",
  cancelButton: "venmo-popup-cancel-button",
  continueButton: "venmo-popup-continue-button",
  message: "venmo-message",
  instructions: "venmo-instructions",
  venmoLogo: "venmo-full-logo",
};

ExtendedPromise.suppressUnhandledPromiseMessage = true;

function openPopup(options) {
  var frameServiceInstance = options.frameServiceInstance;
  var venmoUrl = options.venmoUrl;
  var checkForStatusChange = options.checkForStatusChange;
  var cancelTokenization = options.cancelTokenization;
  var checkPaymentContextStatus = options.checkPaymentContextStatus;
  var extendedPromise = new ExtendedPromise();

  document
    .getElementById(ELEMENT_IDS.continueButton)
    .addEventListener("click", function () {
      frameServiceInstance.focus();
    });
  document
    .getElementById(ELEMENT_IDS.cancelButton)
    .addEventListener("click", function () {
      frameServiceInstance.close();
      cancelTokenization();
      closeBackdrop();
    });
  frameServiceInstance.open({}, function (frameServiceErr) {
    var retryStartingCount = 1;

    if (frameServiceErr) {
      extendedPromise.reject(frameServiceErr);
    } else {
      checkForStatusChange(retryStartingCount)
        .then(function (data) {
          extendedPromise.resolve(data);
        })
        .catch(function (statusCheckError) {
          // We add this check here because at this point
          // the status should not be in CREATED status.
          // However, there is an edge case where if a buyer
          // cancels in the popup, the popup might close itself
          // before it can send the graphQL mutation to update its status.
          // In these cases, the status will be stuck in CREATED status, and
          // tokenization would fail, incorrectly throwing a tokenization error
          // instead of informing the merchant that the customer canceled.
          checkPaymentContextStatus().then(function (node) {
            if (node.status === "CREATED") {
              extendedPromise.reject(
                new BraintreeError(errors.VENMO_CUSTOMER_CANCELED)
              );
            } else {
              extendedPromise.reject(statusCheckError);
            }
          });
        });
    }

    frameServiceInstance.close();
    closeBackdrop();
  });
  frameServiceInstance.redirect(venmoUrl);

  return extendedPromise;
}

function centeredPopupDimensions() {
  var popupTop =
    Math.round((window.outerHeight - POPUP_HEIGHT) / 2) + window.screenTop;
  var popupLeft =
    Math.round((window.outerWidth - POPUP_WIDTH) / 2) + window.screenLeft;

  return {
    top: popupTop,
    left: popupLeft,
  };
}

function closeBackdrop() {
  document.getElementById("venmo-desktop-web-backdrop").classList.add("hidden");
}

function getElementStyles() {
  var backdropStyles = [
    "#" + ELEMENT_IDS.backdropHidden + " {",
    "display: none;",
    "}",
    "#" + ELEMENT_IDS.backdrop + " {",
    "z-index: 3141592632;",
    "cursor: pointer;",
    "position: fixed;",
    "top: 0;",
    "left: 0;",
    "bottom: 0;",
    "width: 100%;",
    "background: rgba(0, 0, 0, 0.8);",
    "}",
  ];
  var backdropContainerStyles = [
    "#" + ELEMENT_IDS.backdropContainer + " {",
    "display: flex;",
    "align-content: center;",
    "justify-content: center;",
    "align-items: center;",
    "width: 100%;",
    "height: 100%;",
    "flex-direction: column;",
    "}",
  ];

  var cancelButtonStyles = [
    "#" + ELEMENT_IDS.cancelButton + " {",
    "height: 24px;",
    "width: 380px;",
    "font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;",
    "font-style: normal;",
    "font-weight: 700;",
    "font-size: 18px;",
    "line-height: 24px;",
    "text-align: center;",
    "background-color: transparent;",
    "border: none;",
    "color: #FFFFFF;",
    "margin-top: 28px;",
    "}",
  ];

  var continueButtonStyles = [
    "#" + ELEMENT_IDS.continueButton + " {",
    "width: 400px;",
    "height: 50px;",
    "background: #0074DE;",
    "border-radius: 24px;",
    "border: none;",
    "font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;",
    "font-style: normal;",
    "font-weight: 700;",
    "font-size: 18px;",
    "color: #FFFFFF;",
    "margin-top: 44px;",
    "}",
  ];

  var messageStyles = [
    "#" + ELEMENT_IDS.message + " {",
    "font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;",
    "font-style: normal;",
    "font-weight: 500;",
    "font-size: 24px;",
    "line-height: 32px;",
    "text-align: center;",
    "color: #FFFFFF;",
    "margin-top: 32px;",
    "}",
  ];

  var instructionStyles = [
    "#" + ELEMENT_IDS.instructions + " {",
    "font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;",
    "font-style: normal;",
    "font-weight: 400;",
    "font-size: 16px;",
    "line-height: 20px;",
    "text-align: center;",
    "color: #FFFFFF;",
    "margin-top: 16px;",
    "width: 400px;",
    "}",
  ];

  var allStyles = backdropStyles.concat(
    backdropContainerStyles,
    cancelButtonStyles,
    continueButtonStyles,
    messageStyles,
    instructionStyles
  );

  return allStyles.join("\n");
}

function buildAndStyleElements() {
  var alreadyRenderedBackdrop = document.getElementById(ELEMENT_IDS.backdrop);
  var backdropStylesElement,
    backdropDiv,
    backDropContentContainer,
    venmoLogoDiv,
    venmoMessageDiv,
    instructionsDiv,
    continueButton,
    cancelButton;

  if (alreadyRenderedBackdrop) {
    alreadyRenderedBackdrop.classList.remove("hidden");

    return;
  }
  backdropStylesElement = document.createElement("style");
  backdropDiv = document.createElement("div");
  backDropContentContainer = document.createElement("div");
  venmoLogoDiv = document.createElement("div");
  venmoMessageDiv = document.createElement("div");
  instructionsDiv = document.createElement("div");
  continueButton = document.createElement("button");
  cancelButton = document.createElement("button");

  backdropStylesElement.id = "venmo-desktop-web__injected-styles";
  backdropStylesElement.innerHTML = getElementStyles();

  backdropDiv.id = ELEMENT_IDS.backdrop;

  backDropContentContainer.id = ELEMENT_IDS.backdropContainer;

  venmoLogoDiv.id = ELEMENT_IDS.venmoLogo;
  venmoLogoDiv.innerHTML = VENMO_LOGO_SVG;

  venmoMessageDiv.id = ELEMENT_IDS.message;
  venmoMessageDiv.innerText = "What would you like to do?";

  instructionsDiv.id = ELEMENT_IDS.instructions;
  instructionsDiv.innerText = CONTINUE_OR_CANCEL_INSTRUCTIONS;

  continueButton.id = ELEMENT_IDS.continueButton;
  continueButton.innerText = "Continue payment";

  cancelButton.id = ELEMENT_IDS.cancelButton;
  cancelButton.innerText = "Cancel payment";

  document.head.appendChild(backdropStylesElement);
  backDropContentContainer.appendChild(venmoLogoDiv);
  backDropContentContainer.appendChild(venmoMessageDiv);
  backDropContentContainer.appendChild(instructionsDiv);
  backDropContentContainer.appendChild(continueButton);
  backDropContentContainer.appendChild(cancelButton);
  backdropDiv.appendChild(backDropContentContainer);
  document.body.appendChild(backdropDiv);

  backdropDiv.addEventListener("click", function (event) {
    event.stopPropagation();
  });
}

/**
 * Applies a backdrop over the page, and opens a popup to the supplied url. Uses supplied status and cancel functions to handle the flow.
 * @function runWebLogin
 * @ignore
 * @param {object} options Options for running the web login flow.
 * @param {string} options.venmoUrl Venmo url that is to be used for logging in.
 * @param {Venmo~checkPaymentContextStatusAndProcessResult} options.checkForStatusChange {@link Venmo~checkPaymentContextStatusAndProcessResult} to be invoked in order to check for a payment context status update.
 * @param {Venmo~cancelTokenization} options.cancelTokenization {@link Venmo~cancelTokenization} to be invoked when the appropriate payment context status is retrieved.
 * @param {boolean} options.debug A flag to control whether to use minified assets or not.
 * @returns {Promise} Returns a promise
 */
function runWebLogin(options) {
  buildAndStyleElements();

  return openPopup(options);
}

/**
 * When using frameservice, it needs to be created separately from the action of opening. The setup process includes
 * steps that browsers may consider async or too disconnected from the user action required to open a popup.
 *
 * This function enables us to do that setup at an appropriate time.
 * @function setupDesktopWebLogin
 * @ignore
 * @param {object} options Options use for setting up the Desktop Web Login flow.
 * @param {string} options.assetsUrl Url that points to the hosted Braintree assets.
 * @param {boolean} options.debug A flag to control whether to use minified assets or not.

 * @returns {Promise} Returns a promise
 */
function setupDesktopWebLogin(options) {
  var extendedPromise = new ExtendedPromise();
  var popupName = "venmoDesktopWebLogin";
  var assetsUrl = options.assetsUrl;
  var debug = options.debug || false;
  var popupLocation = centeredPopupDimensions();
  var assetsBaseUrl = assetsUrl + "/web/" + VERSION + "/html";

  frameService.create(
    {
      name: popupName,
      dispatchFrameUrl:
        assetsBaseUrl + "/dispatch-frame" + useMin(debug) + ".html",
      openFrameUrl:
        assetsBaseUrl + "/venmo-landing-frame" + useMin(debug) + ".html",
      top: popupLocation.top,
      left: popupLocation.left,
      height: POPUP_HEIGHT,
      width: POPUP_WIDTH,
    },
    function (frameServiceInstance) {
      extendedPromise.resolve(frameServiceInstance);
    }
  );

  return extendedPromise;
}

module.exports = {
  runWebLogin: runWebLogin,
  openPopup: openPopup,
  setupDesktopWebLogin: setupDesktopWebLogin,
  POPUP_WIDTH: POPUP_WIDTH,
  POPUP_HEIGHT: POPUP_HEIGHT,
};

},{"../../lib/braintree-error":124,"../../lib/frame-service/external":139,"../../lib/use-min":160,"../shared/errors":219,"@braintree/extended-promise":34}],224:[function(_dereq_,module,exports){
"use strict";

var analytics = _dereq_("../lib/analytics");
var isBrowserSupported = _dereq_("./shared/supports-venmo");
var browserDetection = _dereq_("./shared/browser-detection");
var constants = _dereq_("./shared/constants");
var errors = _dereq_("./shared/errors");
var querystring = _dereq_("../lib/querystring");
var isVerifiedDomain = _dereq_("../lib/is-verified-domain");
var methods = _dereq_("../lib/methods");
var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
var wrapPromise = _dereq_("@braintree/wrap-promise");
var BraintreeError = _dereq_("../lib/braintree-error");
var inIframe = _dereq_("../lib/in-iframe");
var ExtendedPromise = _dereq_("@braintree/extended-promise");
var getVenmoUrl = _dereq_("./shared/get-venmo-url");
var desktopWebLogin = _dereq_("./shared/web-login-backdrop");
var snakeCaseToCamelCase = _dereq_("../lib/snake-case-to-camel-case");

// NEXT_MAJOR_VERSION the source code for this is actually in a
// typescript repo called venmo-desktop, once the SDK is migrated
// to typescript, we can move the TS files out of that separate
// repo and into the web SDK properly
var createVenmoDesktop = _dereq_("./external/");
var graphqlQueries = _dereq_("./external/queries");

var VERSION = "3.101.3";
var DEFAULT_MOBILE_POLLING_INTERVAL = 250; // 1/4 second
var DEFAULT_MOBILE_EXPIRING_THRESHOLD = 300000; // 5 minutes

ExtendedPromise.suppressUnhandledPromiseMessage = true;

/**
 * Venmo tokenize payload.
 * @typedef {object} Venmo~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {string} type The payment method type, always `VenmoAccount`.
 * @property {object} details Additional Venmo account details.
 * @property {string} details.username The username of the Venmo account.
 * @property {string} details.paymentContextId The context ID of the Venmo payment. Only available when used with {@link https://braintree.github.io/braintree-web/current/module-braintree-web_venmo.html#.create|`paymentMethodUsage`}.
 */

/**
 * @class
 * @param {object} options The Venmo {@link module:braintree-web/venmo.create create} options.
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/venmo.create|braintree-web.venmo.create} instead.</strong>
 * @classdesc This class represents a Venmo component produced by {@link module:braintree-web/venmo.create|braintree-web/venmo.create}. Instances of this class have methods for tokenizing Venmo payments.
 */
function Venmo(options) {
  var self = this;

  this._allowDesktopWebLogin = options.allowDesktopWebLogin || false;
  this._mobileWebFallBack = options.mobileWebFallBack || false;
  this._createPromise = options.createPromise;
  this._allowNewBrowserTab = options.allowNewBrowserTab !== false;
  this._allowWebviews = options.allowWebviews !== false;
  this._allowDesktop = options.allowDesktop === true;
  this._useRedirectForIOS = options.useRedirectForIOS === true;
  this._profileId = options.profileId;
  this._displayName = options.displayName;
  this._deepLinkReturnUrl = options.deepLinkReturnUrl;
  this._ignoreHistoryChanges = options.ignoreHistoryChanges;
  this._paymentMethodUsage = (options.paymentMethodUsage || "").toUpperCase();
  this._shouldUseLegacyFlow = !this._paymentMethodUsage;
  this._requireManualReturn = options.requireManualReturn === true;
  this._useDesktopQRFlow =
    this._allowDesktop && this._isDesktop() && !this._allowDesktopWebLogin;
  this._useAllowDesktopWebLogin =
    this._allowDesktopWebLogin && this._isDesktop();
  this._cannotHaveReturnUrls = inIframe() || this._requireManualReturn;
  this._allowAndroidRecreation = options.allowAndroidRecreation !== false;
  this._maxRetryCount = 3;
  this._collectCustomerBillingAddress =
    options.collectCustomerBillingAddress || false;
  this._collectCustomerShippingAddress =
    options.collectCustomerShippingAddress || false;
  this._isFinalAmount = options.isFinalAmount || false;
  this._lineItems = options.lineItems;
  this._subTotalAmount = options.subTotalAmount;
  this._discountAmount = options.discountAmount;
  this._taxAmount = options.taxAmount;
  this._shippingAmount = options.shippingAmount;
  this._totalAmount = options.totalAmount;

  this._shouldCreateVenmoPaymentContext =
    this._cannotHaveReturnUrls || !this._shouldUseLegacyFlow;

  analytics.sendEvent(
    this._createPromise,
    "venmo.desktop-flow.configured." + String(Boolean(this._allowDesktop))
  );

  // if the url has a tokenization result, that indicates
  // that it cannot be the desktop flow or the manual return
  // flow. If it's the hash change with paymentMethodUsage
  // flow, we want to skip creating a new payment context, since
  // there is already a pending payment context waiting to be
  // processed. For the hash change flow without paymentMethodUsage,
  // no further actions are needed.
  if (this.hasTokenizationResult()) {
    analytics.sendEvent(
      this._createPromise,
      "venmo.appswitch.return-in-new-tab"
    );
  } else if (this._useDesktopQRFlow) {
    this._createPromise = this._createPromise.then(function (client) {
      var config = client.getConfiguration().gatewayConfiguration;

      return createVenmoDesktop({
        url:
          config.assetsUrl +
          "/web/" +
          VERSION +
          "/html/venmo-desktop-frame.html",
        environment:
          config.environment === "production" ? "PRODUCTION" : "SANDBOX",
        profileId: self._profileId || config.payWithVenmo.merchantId,
        paymentMethodUsage: self._paymentMethodUsage,
        displayName: self._displayName,
        Promise: Promise,
        apiRequest: function (query, data) {
          return client
            .request({
              api: "graphQLApi",
              data: {
                query: query,
                variables: data,
              },
            })
            .then(function (response) {
              return response.data;
            });
        },
        sendEvent: function (eventName) {
          analytics.sendEvent(self._createPromise, eventName);
        },
        verifyDomain: isVerifiedDomain,
      })
        .then(function (venmoDesktopInstance) {
          self._venmoDesktopInstance = venmoDesktopInstance;
          analytics.sendEvent(
            self._createPromise,
            "venmo.desktop-flow.presented"
          );

          return client;
        })
        .catch(function () {
          analytics.sendEvent(
            self._createPromise,
            "venmo.desktop-flow.setup-failed"
          );
          self._useDesktopQRFlow = false;

          return client;
        });
    });
  } else if (this._shouldCreateVenmoPaymentContext) {
    // these variables are only relevant for the manual return flow
    // and they are only set to make testing easier (so they can
    // be overwritten with smaller values in the tests)
    this._mobilePollingInterval = DEFAULT_MOBILE_POLLING_INTERVAL;
    this._mobilePollingExpiresThreshold = DEFAULT_MOBILE_EXPIRING_THRESHOLD;

    this._createPromise = this._createPromise.then(function (client) {
      var paymentContextPromise, webLoginPromise;
      var analyticsCategory = self._cannotHaveReturnUrls
        ? "manual-return"
        : "mobile-payment-context";
      var config = client.getConfiguration();

      webLoginPromise = desktopWebLogin
        .setupDesktopWebLogin({
          assetsUrl: config.gatewayConfiguration.assetsUrl,
          debug: config.isDebug,
        })
        .then(function (frameServiceInstance) {
          self._frameServiceInstance = frameServiceInstance;
        })
        .catch(function (desktopWebErr) {
          return desktopWebErr;
        });

      self._mobilePollingContextEnvironment =
        config.gatewayConfiguration.environment.toUpperCase();

      paymentContextPromise = self
        ._createVenmoPaymentContext(client)
        .then(function () {
          analytics.sendEvent(
            self._createPromise,
            "venmo." + analyticsCategory + ".presented"
          );

          return client;
        })
        .catch(function (err) {
          analytics.sendEvent(
            self._createPromise,
            "venmo." + analyticsCategory + ".setup-failed"
          );

          return Promise.reject(
            new BraintreeError({
              type: errors.VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED.type,
              code: errors.VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED.code,
              message: isValidationError(err)
                ? err.details.originalError[0].message
                : errors.VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED.message,
              details: {
                originalError: err,
              },
            })
          );
        });

      return ExtendedPromise.all([webLoginPromise, paymentContextPromise])
        .then(function (results) {
          var paymentContextResult = results[1]; // We only care about the returned value of the paymentContextPromise

          return Promise.resolve(paymentContextResult);
        })
        .catch(function (promiseErr) {
          // ExtendedPromise.all returns just one error and it's either which fails first/at all.
          return Promise.reject(promiseErr);
        });
    });
  }
}

function isValidationError(err) {
  return (
    err.details &&
    err.details.originalError &&
    err.details.originalError[0] &&
    err.details.originalError[0].extensions &&
    err.details.originalError[0].extensions.errorClass === "VALIDATION" &&
    err.details.originalError[0].extensions.errorType === "user_error"
  );
}

Venmo.prototype._createVenmoPaymentContext = function (
  client,
  cancelIfTokenizationInProgress
) {
  var self = this;
  var promise, transactionDetails;
  var configuration = client.getConfiguration();
  var venmoConfiguration = configuration.gatewayConfiguration.payWithVenmo;
  var transactionDetailsPresent = false;
  var customerClientChannel = self._useAllowDesktopWebLogin
    ? "NATIVE_WEB"
    : "MOBILE_WEB";

  if (!this._shouldCreateVenmoPaymentContext) {
    return Promise.resolve();
  }

  if (this._shouldUseLegacyFlow) {
    promise = client
      .request({
        api: "graphQLApi",
        data: {
          query: graphqlQueries.LEGACY_CREATE_PAYMENT_CONTEXT_QUERY,
          variables: {
            input: {
              environment: this._mobilePollingContextEnvironment,
              intent: "PAY_FROM_APP",
            },
          },
        },
      })
      .then(function (response) {
        return response
          .data.createVenmoQRCodePaymentContext.venmoQRCodePaymentContext;
      });
  } else {
    // Merchants are not allowed to collect user addresses unless ECD (Enriched Customer Data) is enabled on the BT Control Panel.
    if (
      (this._collectCustomerBillingAddress ||
        this._collectCustomerShippingAddress) &&
      !venmoConfiguration.enrichedCustomerDataEnabled
    ) {
      return Promise.reject(new BraintreeError(errors.VENMO_ECD_DISABLED));
    }

    if (this._lineItems) {
      this._lineItems.forEach(function (item) {
        item.unitTaxAmount = item.unitTaxAmount || "0";
      });
    }
    transactionDetails = {
      subTotalAmount: this._subTotalAmount,
      discountAmount: this._discountAmount,
      taxAmount: this._taxAmount,
      shippingAmount: this._shippingAmount,
      totalAmount: this._totalAmount,
      lineItems: this._lineItems,
    };
    transactionDetailsPresent = Object.keys(transactionDetails).some(function (
      detail
    ) {
      return transactionDetails[detail] !== undefined; // eslint-disable-line no-undefined
    });

    promise = client
      .request({
        api: "graphQLApi",
        data: {
          query: graphqlQueries.CREATE_PAYMENT_CONTEXT_QUERY,
          variables: {
            input: {
              paymentMethodUsage: this._paymentMethodUsage,
              intent: "CONTINUE",
              customerClient: customerClientChannel,
              isFinalAmount: this._isFinalAmount,
              displayName: this._displayName,
              paysheetDetails: {
                collectCustomerBillingAddress:
                  this._collectCustomerBillingAddress,
                collectCustomerShippingAddress:
                  this._collectCustomerShippingAddress,
                transactionDetails: transactionDetailsPresent
                  ? transactionDetails
                  : undefined, // eslint-disable-line no-undefined
              },
            },
          },
        },
      })
      .then(function (response) {
        return response.data.createVenmoPaymentContext.venmoPaymentContext;
      });
  }

  return promise.then(function (context) {
    var expiredTime = new Date(context.expiresAt) - new Date(context.createdAt);
    var refreshIn = expiredTime * 0.6666;

    // prevents multiple setTimeouts from firing from separate calls
    // to create a payment context by canceling the previous one
    // if there is a pending call
    clearTimeout(self._refreshPaymentContextTimeout);
    self._refreshPaymentContextTimeout = setTimeout(function () {
      if (self._tokenizationInProgress) {
        return;
      }
      self._createVenmoPaymentContext(client, true);
    }, refreshIn);

    if (cancelIfTokenizationInProgress && self._tokenizationInProgress) {
      return;
    }

    self._venmoPaymentContextStatus = context.status;
    self._venmoPaymentContextId = context.id;
  });
};

Venmo.prototype.appSwitch = function (url) {
  if (this._deepLinkReturnUrl) {
    if (isIosWebviewInDeepLinkReturnUrlFlow()) {
      analytics.sendEvent(
        this._createPromise,
        "venmo.appswitch.start.ios-webview"
      );
      // Deep link URLs do not launch iOS apps from a webview when using window.open or PopupBridge.open.
      window.location.href = url;
    } else if (
      window.popupBridge &&
      typeof window.popupBridge.open === "function"
    ) {
      analytics.sendEvent(
        this._createPromise,
        "venmo.appswitch.start.popup-bridge"
      );
      window.popupBridge.open(url);
    } else {
      analytics.sendEvent(this._createPromise, "venmo.appswitch.start.webview");
      window.open(url);
    }
  } else {
    analytics.sendEvent(this._createPromise, "venmo.appswitch.start.browser");

    if (
      browserDetection.doesNotSupportWindowOpenInIos() ||
      this._shouldUseRedirectStrategy()
    ) {
      window.location.href = url;
    } else {
      window.open(url);
    }
  }
};

Venmo.prototype.getUrl = function () {
  return this._createPromise.then(
    function (client) {
      var configuration = client.getConfiguration();
      var params = {};
      var currentUrl =
        this._deepLinkReturnUrl ||
        window.location.href.replace(window.location.hash, "");
      var venmoConfiguration = configuration.gatewayConfiguration.payWithVenmo;
      var analyticsMetadata = configuration.analyticsMetadata;
      var accessToken = venmoConfiguration.accessToken;
      var braintreeData = {
        _meta: {
          version: analyticsMetadata.sdkVersion,
          integration: analyticsMetadata.integration,
          platform: analyticsMetadata.platform,
          sessionId: analyticsMetadata.sessionId,
        },
      };

      this._isDebug = configuration.isDebug;
      this._assetsUrl = configuration.gatewayConfiguration.assetsUrl;

      currentUrl = currentUrl.replace(/#*$/, "");

      /* eslint-disable camelcase */
      if (this._venmoPaymentContextId) {
        if (this._shouldUseLegacyFlow) {
          // NEXT_MAJOR_VERSION stop adding the context id to the access token.
          // the context id is placed here for backwards compatiblity
          // with versions of the venmo app that did not support
          // pulling the resource id off of the query params
          accessToken += "|pcid:" + this._venmoPaymentContextId;
        } else {
          params.resource_id = this._venmoPaymentContextId;
        }
      }

      if (this._shouldIncludeReturnUrls() || this._useAllowDesktopWebLogin) {
        if (this._useAllowDesktopWebLogin) {
          currentUrl =
            this._assetsUrl + "/web/" + VERSION + "/html/redirect-frame.html";
        }
        params["x-success"] = currentUrl + "#venmoSuccess=1";
        params["x-cancel"] = currentUrl + "#venmoCancel=1";
        params["x-error"] = currentUrl + "#venmoError=1";
      } else {
        params["x-success"] = "NOOP";
        params["x-cancel"] = "NOOP";
        params["x-error"] = "NOOP";
      }

      if (!this._allowAndroidRecreation) {
        params.allowAndroidRecreation = 0;
      } else {
        params.allowAndroidRecreation = 1;
      }

      params.ua = window.navigator.userAgent;
      params.braintree_merchant_id =
        this._profileId || venmoConfiguration.merchantId;
      params.braintree_access_token = accessToken;
      params.braintree_environment = venmoConfiguration.environment;
      params.braintree_sdk_data = btoa(JSON.stringify(braintreeData));

      return (
        getVenmoUrl({
          useAllowDesktopWebLogin: this._useAllowDesktopWebLogin,
          mobileWebFallBack: this._mobileWebFallBack,
        }) +
        "?" +
        querystring.stringify(params)
      );
    }.bind(this)
  );
};

/**
 * Returns a boolean indicating whether the current browser supports Venmo as a payment method. Please note that iOS Chrome is not supported when the Venmo button is rendered in an iFrame.
 *
 * If `options.allowNewBrowserTab` is false when calling {@link module:braintree-web/venmo.create|venmo.create}, this method will return true only for browsers known to support returning from the Venmo app to the same browser tab. Currently, this is limited to iOS Safari and Android Chrome.
 * If `options.allowWebviews` is false when calling {@link module:braintree-web/venmo.create|venmo.create}, this method will return true only for mobile browsers that are not webviews.
 * @public
 * @returns {boolean} True if the current browser is supported, false if not.
 */
Venmo.prototype.isBrowserSupported = function () {
  return isBrowserSupported.isBrowserSupported({
    allowNewBrowserTab: this._allowNewBrowserTab,
    allowWebviews: this._allowWebviews,
    allowDesktop: this._allowDesktop,
    allowDesktopWebLogin: this._allowDesktopWebLogin,
  });
};

/**
 * Returns a boolean indicating whether a Venmo tokenization result is ready to be processed immediately.
 *
 * This method should be called after initialization to see if the result of Venmo authorization is available. If it returns true, call {@link Venmo#tokenize|tokenize} immediately to process the results.
 *
 * @public
 * @returns {boolean} True if the results of Venmo payment authorization are available and ready to process.
 */
Venmo.prototype.hasTokenizationResult = function () {
  return this._hasTokenizationResult();
};

// a private version that lets us pass in a custom hash
// when listening on a hashchange event
Venmo.prototype._hasTokenizationResult = function (hash) {
  var params = getFragmentParameters(hash);

  return (
    typeof (params.venmoSuccess || params.venmoError || params.venmoCancel) !==
    "undefined"
  );
};

Venmo.prototype._shouldIncludeReturnUrls = function () {
  // when a deep link return url is passed, we should always
  // respect it and include the return urls so the venmo app
  // can app switch back to it
  if (this._deepLinkReturnUrl) {
    return true;
  }

  // when the sdk is initialized within an iframe, it's
  // impossible to return back to the correct place automatically
  // without also setting a deepLinkReturnUrl. When the return
  // urls are omitted, the Venmo app prompts the user to return
  // manually.
  return !this._cannotHaveReturnUrls;
};

Venmo.prototype._isDesktop = function () {
  return !(browserDetection.isIos() || browserDetection.isAndroid());
};

/**
 * Launches the Venmo flow and returns a nonce payload.
 *
 * If {@link Venmo#hasTokenizationResult|hasTokenizationResult} returns true, calling tokenize will immediately process and return the results without initiating the Venmo payment authorization flow.
 *
 * Only one Venmo flow can be active at a time. One way to achieve this is to disable your Venmo button while the flow is open.
 * @public
 * @param {object} [options] Options for tokenization.
 * @param {number} [options.processResultsDelay=500] The amount of time in milliseconds to delay processing the results. In most cases, this value should be left as the default.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link Venmo~tokenizePayload|tokenizePayload}. If no callback is provided, the method will return a Promise that resolves with a {@link Venmo~tokenizePayload|tokenizePayload}.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * button.addEventListener('click', function () {
 *   // Disable the button so that we don't attempt to open multiple popups.
 *   button.setAttribute('disabled', 'disabled');
 *
 *   // Because tokenize opens a new window, this must be called
 *   // as a result of a user action, such as a button click.
 *   venmoInstance.tokenize().then(function (payload) {
 *     // Submit payload.nonce to your server
 *     // Use payload.username to get the Venmo username and display any UI
 *   }).catch(function (tokenizeError) {
 *     // Handle flow errors or premature flow closure
 *     switch (tokenizeErr.code) {
 *       case 'VENMO_APP_CANCELED':
 *         console.log('User canceled Venmo flow.');
 *         break;
 *       case 'VENMO_CANCELED':
 *         console.log('User canceled Venmo, or Venmo app is not available.');
 *         break;
 *       default:
 *         console.error('Error!', tokenizeErr);
 *     }
 *   }).then(function () {
 *     button.removeAttribute('disabled');
 *   });
 * });
 */
Venmo.prototype.tokenize = function (options) {
  var self = this;
  var tokenizationPromise;

  options = options || {};

  if (this._tokenizationInProgress === true) {
    return Promise.reject(
      new BraintreeError(errors.VENMO_TOKENIZATION_REQUEST_ACTIVE)
    );
  }

  this._tokenizationInProgress = true;
  if (this._useDesktopQRFlow) {
    // for the desktop flow, we create a venmo payment
    // context and then present a qr code modal to the
    // customer and they will open up their venmo app
    // and scan it and approve the purchase on their
    // mobile device. The sdk will start polling
    // in order to determine when the status of the
    // payment context has updated and then pass the
    // resulting nonce back to the merchant.
    tokenizationPromise = this._tokenizeForDesktopQRFlow(options);
  } else if (this._useAllowDesktopWebLogin) {
    /**
     * For Desktop Web Login, we open a browser popup to allow for authorization. Once authorized, the redirect urls are used by Venmo, and we query the API for a payment context status update.
     *
     * - Payment context is created on initialization
     * - Popup is opened to Venmo login url.
     *  - The payment is authorized or canceled, and the popup is closed
     * - Once the popup is closed, we query the API for a payment context status update
     *
     * This is an alternate, opt-in flow to be used the Desktop QR Flow is not desired for Pay with Venmo desktop experiences.
     */
    tokenizationPromise = this._tokenizeWebLoginWithRedirect();
  } else if (this._cannotHaveReturnUrls) {
    // in the manual return strategy, we create the payment
    // context on initialization, then continually poll once
    // the app switch begins until we get a response indiciating
    // the payment context was approved by the customer on the
    // Venmo app. The payment context response also includes a
    // nonce. There are 2 cases where we use the manual return
    // strategy:
    // 1. the sdk is instantiated in an iframe, because
    //    the venmo app is unable to redirect automatically
    //    when that is the case so we rely on the customer
    //    to do a manual redirect and continunally poll for
    //    updates on the payment context to get the nonce
    // 2. same deal for when `requireManualReturn` is configured
    tokenizationPromise = this._tokenizeForMobileWithManualReturn();
  } else {
    // the default mobile flow is to app switch to the
    // venmo app, and then have the venmo app switch
    // back to the page with the venmo nonce details
    // encoded into the hash portion of the url. If
    // `paymentMethodUsage` is provided when instantiating
    // the sdk, we also create a payment context and pass
    // the resource id to the Venmo app during the app switch.
    // Once we get a succesful return, we ping the payment
    // context query to get any additional data needed
    // to send back to the merchant.
    tokenizationPromise =
      this._tokenizeForMobileWithHashChangeListeners(options);
  }

  return tokenizationPromise
    .then(function (payload) {
      return self._createPromise
        .then(function (client) {
          return self._createVenmoPaymentContext(client);
        })
        .then(function () {
          self._tokenizationInProgress = false;

          return formatTokenizePayload(payload);
        });
    })
    .catch(function (err) {
      return self._createPromise
        .then(function (client) {
          // We create a new Payment Context because if the last one failed, then presumably we don't want to use it again.
          // On the first pass, we create the payment context at initialization, and since we used that first one we now need to create a new one
          // for the next time someone tries to tokenize.
          return self._createVenmoPaymentContext(client);
        })
        .then(function () {
          self._tokenizationInProgress = false;

          return Promise.reject(err);
        });
    });
};

/**
 * Cancels the venmo tokenization process
 *
 * @public
 * @function Venmo~cancelTokenization
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * venmoTokenizeButton.addEventListener('click', function () {
 *   venmoInstance.tokenize().then(function (payload) {
 *     // handle payload
 *   }).catch(function (err) {
 *     if (err.code === 'VENMO_TOKENIZATION_CANCELED_BY_MERCHANT') {
 *       // tokenization was canceled by calling cancelTokenization
 *     }
 *   });
 * });
 *
 * venmoCancelButton.addEventListener('click', function () {
 *   // Hide the button when the venmo flow is not in progress
 *   venmoCancelButton.style.display = "none";
 *
 *   venmoInstance.cancelTokenization().then(function () {
 *     // done canceling the flow
 *   }).catch(function (err) {
 *     // should only get here if there is no tokenization in progress
 *   });
 * });
 */
Venmo.prototype.cancelTokenization = function () {
  if (!this._tokenizationInProgress) {
    return Promise.reject(
      new BraintreeError(errors.VENMO_TOKENIZATION_REQUEST_NOT_ACTIVE)
    );
  }

  this._removeVisibilityEventListener();

  // important to reject the tokenization promise first
  // so the tokenize method rejects with this error
  // rather than a customer canceled error in the mobile
  // polling and desktop flows
  if (this._tokenizePromise) {
    this._tokenizePromise.reject(
      new BraintreeError(errors.VENMO_TOKENIZATION_CANCELED_BY_MERCHANT)
    );
  }

  return Promise.all([
    this._cancelMobilePaymentContext(),
    this._cancelVenmoDesktopContext(),
  ]);
};

Venmo.prototype._tokenizeWebLoginWithRedirect = function () {
  var self = this;

  analytics.sendEvent(self._createPromise, "venmo.tokenize.web-login.start");
  this._tokenizePromise = new ExtendedPromise();

  return this.getUrl().then(function (url) {
    desktopWebLogin
      .runWebLogin({
        checkForStatusChange:
          self._checkPaymentContextStatusAndProcessResult.bind(self),
        cancelTokenization: self.cancelTokenization.bind(self),
        frameServiceInstance: self._frameServiceInstance,
        venmoUrl: url,
        debug: self._isDebug,
        checkPaymentContextStatus: self._checkPaymentContextStatus.bind(self),
      })
      .then(function (payload) {
        analytics.sendEvent(
          self._createPromise,
          "venmo.tokenize.web-login.success"
        );

        self._tokenizePromise.resolve({
          paymentMethodNonce: payload.paymentMethodId,
          username: payload.userName,
          payerInfo: payload.payerInfo,
          id: self._venmoPaymentContextId,
        });
      })
      .catch(function (err) {
        analytics.sendEvent(
          self._createPromise,
          "venmo.tokenize.web-login.failure"
        );

        self._tokenizePromise.reject(err);
      });

    return self._tokenizePromise;
  });
};

Venmo.prototype._queryPaymentContextStatus = function (id) {
  var self = this;

  return this._createPromise
    .then(function (client) {
      var query = self._shouldUseLegacyFlow
        ? graphqlQueries.LEGACY_VENMO_PAYMENT_CONTEXT_STATUS_QUERY
        : graphqlQueries.VENMO_PAYMENT_CONTEXT_STATUS_QUERY;

      return client.request({
        api: "graphQLApi",
        data: {
          query: query,
          variables: {
            id: id,
          },
        },
      });
    })
    .then(function (response) {
      return response.data.node;
    });
};

/**
 * Queries the GraphQL API to get the payment context and process the status. Retries until there is an update to the payment context status.
 * @name Venmo~checkPaymentContextStatusAndProcessResult
 * @ignore
 * @param {number} retryCount The counter for tracking number of retries made against the API.
 * @returns {Promise} Returns a promise
 */
Venmo.prototype._checkPaymentContextStatusAndProcessResult = function (
  retryCount
) {
  var self = this;

  return self._checkPaymentContextStatus().then(function (node) {
    var resultStatus = node.status;

    if (resultStatus !== self._venmoPaymentContextStatus) {
      self._venmoPaymentContextStatus = resultStatus;

      analytics.sendEvent(
        self._createPromise,
        "venmo.tokenize.web-login.status-change"
      );

      switch (resultStatus) {
        case "APPROVED":
          return Promise.resolve(node);
        case "CANCELED":
          return Promise.reject(
            new BraintreeError(errors.VENMO_CUSTOMER_CANCELED)
          );
        case "FAILED":
          return Promise.reject(
            new BraintreeError(errors.VENMO_TOKENIZATION_FAILED)
          );
        default:
      }
    }

    return new Promise(function (resolve, reject) {
      if (retryCount < self._maxRetryCount) {
        retryCount++;

        return self
          ._checkPaymentContextStatusAndProcessResult(retryCount)
          .then(resolve)
          .catch(reject);
      }

      return reject(new BraintreeError(errors.VENMO_TOKENIZATION_FAILED));
    });
  });
};

Venmo.prototype._checkPaymentContextStatus = function () {
  var self = this;

  return self
    ._queryPaymentContextStatus(self._venmoPaymentContextId)
    .catch(function (networkError) {
      return Promise.reject(
        new BraintreeError({
          type: errors.VENMO_NETWORK_ERROR.type,
          code: errors.VENMO_NETWORK_ERROR.code,
          message: errors.VENMO_NETWORK_ERROR.message,
          details: networkError,
        })
      );
    })
    .then(function (node) {
      return Promise.resolve(node);
    });
};

Venmo.prototype._pollForStatusChange = function () {
  var self = this;

  if (Date.now() > self._mobilePollingContextExpiresIn) {
    return Promise.reject(
      new BraintreeError(errors.VENMO_MOBILE_POLLING_TOKENIZATION_TIMEOUT)
    );
  }

  return this._queryPaymentContextStatus(this._venmoPaymentContextId)
    .catch(function (networkError) {
      return Promise.reject(
        new BraintreeError({
          type: errors.VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR.type,
          code: errors.VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR.code,
          message:
            errors.VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR.message,
          details: {
            originalError: networkError,
          },
        })
      );
    })
    .then(function (node) {
      var newStatus = node.status;

      if (newStatus !== self._venmoPaymentContextStatus) {
        self._venmoPaymentContextStatus = newStatus;

        analytics.sendEvent(
          self._createPromise,
          "venmo.tokenize.manual-return.status-change." +
            newStatus.toLowerCase()
        );

        switch (newStatus) {
          case "EXPIRED":
          case "FAILED":
          case "CANCELED":
            return Promise.reject(
              new BraintreeError(
                errors["VENMO_MOBILE_POLLING_TOKENIZATION_" + newStatus]
              )
            );
          case "APPROVED":
            return Promise.resolve(node);
          case "CREATED":
          case "SCANNED":
          default:
          // any other statuses are irrelevant to the polling
          // and can just be ignored
        }
      }

      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          self._pollForStatusChange().then(resolve).catch(reject);
        }, self._mobilePollingInterval);
      });
    });
};

Venmo.prototype._tokenizeForMobileWithManualReturn = function () {
  var self = this;

  analytics.sendEvent(
    this._createPromise,
    "venmo.tokenize.manual-return.start"
  );

  this._mobilePollingContextExpiresIn =
    Date.now() + this._mobilePollingExpiresThreshold;
  this._tokenizePromise = new ExtendedPromise();

  this._pollForStatusChange()
    .then(function (payload) {
      analytics.sendEvent(
        self._createPromise,
        "venmo.tokenize.manual-return.success"
      );

      self._tokenizePromise.resolve({
        paymentMethodNonce: payload.paymentMethodId,
        username: payload.userName,
        payerInfo: payload.payerInfo,
        id: self._venmoPaymentContextId,
      });
    })
    .catch(function (err) {
      analytics.sendEvent(
        self._createPromise,
        "venmo.tokenize.manual-return.failure"
      );

      self._tokenizePromise.reject(err);
    });

  return this.getUrl().then(function (url) {
    self.appSwitch(url);

    return self._tokenizePromise;
  });
};

Venmo.prototype._shouldUseRedirectStrategy = function () {
  if (!browserDetection.isIos()) {
    return false;
  }

  if (this._mobileWebFallBack === true) {
    return true;
  }

  return this._useRedirectForIOS;
};

Venmo.prototype._tokenizeForMobileWithHashChangeListeners = function (options) {
  var self = this;
  var resultProcessingInProgress, visibilityChangeListenerTimeout;

  if (this.hasTokenizationResult()) {
    return this.processHashChangeFlowResults();
  }

  analytics.sendEvent(this._createPromise, "venmo.tokenize.mobile.start");
  this._tokenizePromise = new ExtendedPromise();

  this._previousHash = window.location.hash;

  function completeFlow(hash) {
    var error;

    self
      .processHashChangeFlowResults(hash)
      .catch(function (err) {
        error = err;
      })
      .then(function (res) {
        if (
          !self._ignoreHistoryChanges &&
          window.location.hash !== self._previousHash
        ) {
          window.location.hash = self._previousHash;
        }
        self._removeVisibilityEventListener();

        if (error) {
          self._tokenizePromise.reject(error);
        } else {
          self._tokenizePromise.resolve(res);
        }
        delete self._tokenizePromise;
      });
  }

  // The Venmo SDK app switches back with the results of the
  // tokenization encoded in the hash
  this._onHashChangeListener = function (e) {
    var hash = e.newURL.split("#")[1];

    if (!self._hasTokenizationResult(hash)) {
      return;
    }

    resultProcessingInProgress = true;
    clearTimeout(visibilityChangeListenerTimeout);
    completeFlow(hash);
  };

  window.addEventListener("hashchange", this._onHashChangeListener, false);

  // Subscribe to document visibility change events to detect when app switch
  // has returned. Acts as a fallback for the hashchange listener and catches
  // the cancel case via manual app switch back
  this._visibilityChangeListener = function () {
    var delay =
      options.processResultsDelay || constants.DEFAULT_PROCESS_RESULTS_DELAY;

    if (!window.document.hidden) {
      if (!resultProcessingInProgress) {
        visibilityChangeListenerTimeout = setTimeout(completeFlow, delay);
      }
    }
  };

  return this.getUrl().then(function (url) {
    self.appSwitch(url);

    // Add a brief delay to ignore visibility change events that occur right before app switch
    setTimeout(function () {
      window.document.addEventListener(
        documentVisibilityChangeEventName(),
        self._visibilityChangeListener
      );
    }, constants.DOCUMENT_VISIBILITY_CHANGE_EVENT_DELAY);

    return self._tokenizePromise;
  });
};

Venmo.prototype._tokenizeForDesktopQRFlow = function () {
  var self = this;

  analytics.sendEvent(this._createPromise, "venmo.tokenize.desktop.start");

  this._tokenizePromise = new ExtendedPromise();

  this._createPromise
    .then(function () {
      return self._venmoDesktopInstance.launchDesktopFlow();
    })
    .then(function (payload) {
      self._venmoDesktopInstance.hideDesktopFlow();

      analytics.sendEvent(
        self._createPromise,
        "venmo.tokenize.desktop.success"
      );

      self._tokenizePromise.resolve(payload);
    })
    .catch(function (err) {
      analytics.sendEvent(
        self._createPromise,
        "venmo.tokenize.desktop.failure"
      );

      if (self._venmoDesktopInstance) {
        self._venmoDesktopInstance.hideDesktopFlow();
      }

      if (err && err.reason === "CUSTOMER_CANCELED") {
        self._tokenizePromise.reject(
          new BraintreeError(errors.VENMO_DESKTOP_CANCELED)
        );

        return;
      }

      self._tokenizePromise.reject(
        new BraintreeError({
          type: errors.VENMO_DESKTOP_UNKNOWN_ERROR.type,
          code: errors.VENMO_DESKTOP_UNKNOWN_ERROR.code,
          message: errors.VENMO_DESKTOP_UNKNOWN_ERROR.message,
          details: {
            originalError: err,
          },
        })
      );
    });

  return this._tokenizePromise;
};

Venmo.prototype._cancelMobilePaymentContext = function () {
  var self = this;

  return this._createPromise.then(function (client) {
    var query;

    if (self._venmoPaymentContextId) {
      query = self._shouldUseLegacyFlow
        ? graphqlQueries.LEGACY_UPDATE_PAYMENT_CONTEXT_QUERY
        : graphqlQueries.UPDATE_PAYMENT_CONTEXT_QUERY;

      return client.request({
        api: "graphQLApi",
        data: {
          query: query,
          variables: {
            input: {
              id: self._venmoPaymentContextId,
              status: "CANCELED",
            },
          },
        },
      });
    }

    return Promise.resolve();
  });
};

Venmo.prototype._cancelVenmoDesktopContext = function () {
  var self = this;

  return this._createPromise.then(function () {
    if (self._venmoDesktopInstance) {
      self._venmoDesktopInstance.updateVenmoDesktopPaymentContext("CANCELED");
    }

    return Promise.resolve();
  });
};

/**
 * Cleanly tear down anything set up by {@link module:braintree-web/venmo.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * venmoInstance.teardown();
 * @example <caption>With callback</caption>
 * venmoInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
Venmo.prototype.teardown = function () {
  var self = this;

  this._removeVisibilityEventListener();

  return this._createPromise.then(
    function () {
      if (self._venmoDesktopInstance) {
        self._venmoDesktopInstance.teardown();
      }

      clearTimeout(self._refreshPaymentContextTimeout);
      self._cancelMobilePaymentContext();

      convertMethodsToError(this, methods(Venmo.prototype));
    }.bind(this)
  );
};

Venmo.prototype._removeVisibilityEventListener = function () {
  window.removeEventListener("hashchange", this._onHashChangeListener);
  window.document.removeEventListener(
    documentVisibilityChangeEventName(),
    this._visibilityChangeListener
  );

  delete this._visibilityChangeListener;
  delete this._onHashChangeListener;
};

/**
 * The hash parameter in this function is optional. If no hash parameter is passed, the `getFragmentParameters` function will default to the hash present in the website's URL instead.
 *
 * There are two scenarios where this method is called:
 *
 * 1. When called within a browser that is capable of returning to the same tab that started the Venmo flow, we set up a listener to detect hash changes in the url. Part of the return to the merchant's website from the Venmo app includes encoding the details of the purchase in the hash of the url. The callback is invoked and the hash is pulled off from the event payload. The reason we pull the hash off of the event payload instead of pulling it directly from the URL is because sometimes a single page app will use the hash parameter for it's routing system, and it's possible to hit a race condition where the routing code has already removed the Venmo specific attributes from the hash before we are able to pull it off the url. Grabbing the hash from the event handler instead ensures we get the Venmo details, no matter what the url is converted to.
 * 2. The other scenario is for browsers that cannot return to the same tab, and instead the Venmo app must open a new tab. Since there is no hash listener to pull the hash from, we pull the hash details directly from the url using the `getFragmentParameters` method.
 *
 * @ignore
 * @param {string} [hash] Optionally provided browser url hash.
 * @returns {Promise} Returns a promise
 */
Venmo.prototype.processHashChangeFlowResults = function (hash) {
  var self = this;
  var params = getFragmentParameters(hash);

  // NEXT_MAJOR_VERSION only rely on payment context status call and stop relying on the
  // content of the hash

  return new Promise(function (resolve, reject) {
    if (!self._shouldUseLegacyFlow) {
      self
        ._pollForStatusChange()
        .then(function (payload) {
          analytics.sendEvent(
            self._createPromise,
            "venmo.appswitch.handle.payment-context-status-query.success"
          );

          return resolve({
            paymentMethodNonce: payload.paymentMethodId,
            username: payload.userName,
            payerInfo: payload.payerInfo,
            id: self._venmoPaymentContextId,
          });
        })
        .catch(function (err) {
          if (
            err.type === errors.VENMO_MOBILE_POLLING_TOKENIZATION_CANCELED.type
          ) {
            // We want to reject in this case because if it the process was canceled, we don't want to take the happy path
            reject(err);
          }

          analytics.sendEvent(
            self._createPromise,
            "venmo.process-results.payment-context-status-query-failed"
          );
          // If the polling request fails, but not because of cancelization, we will rely on the params provided from the hash
          resolve(params);
        });
    } else if (params.venmoSuccess) {
      analytics.sendEvent(
        self._createPromise,
        "venmo.appswitch.handle.success"
      );

      resolve(params);
    } else if (params.venmoError) {
      analytics.sendEvent(self._createPromise, "venmo.appswitch.handle.error");
      reject(
        new BraintreeError({
          type: errors.VENMO_APP_FAILED.type,
          code: errors.VENMO_APP_FAILED.code,
          message: errors.VENMO_APP_FAILED.message,
          details: {
            originalError: {
              message: decodeURIComponent(params.errorMessage),
              code: params.errorCode,
            },
          },
        })
      );
    } else if (params.venmoCancel) {
      analytics.sendEvent(self._createPromise, "venmo.appswitch.handle.cancel");
      reject(new BraintreeError(errors.VENMO_APP_CANCELED));
    } else {
      // User has either manually switched back to browser, or app is not available for app switch
      analytics.sendEvent(
        self._createPromise,
        "venmo.appswitch.cancel-or-unavailable"
      );
      reject(new BraintreeError(errors.VENMO_CANCELED));
    }

    self._clearFragmentParameters();
  });
};

Venmo.prototype._clearFragmentParameters = function () {
  if (this._ignoreHistoryChanges) {
    return;
  }

  if (
    typeof window.history.replaceState === "function" &&
    window.location.hash
  ) {
    history.pushState(
      {},
      "",
      window.location.href.slice(0, window.location.href.indexOf("#"))
    );
  }
};

function getFragmentParameters(hash) {
  var keyValuesArray = (hash || window.location.hash.substring(1)).split("&");

  var parsedParams = keyValuesArray.reduce(function (toReturn, keyValue) {
    var parts = keyValue.split("=");
    // some Single Page Apps may pre-pend a / to the first value
    // in the hash, assuming it's a route in their app
    // instead of information from Venmo, this removes all
    // non-alphanumeric characters from the keys in the params
    var decodedKey = decodeURIComponent(parts[0]).replace(/\W/g, "");
    var key = snakeCaseToCamelCase(decodedKey);
    var value = decodeURIComponent(parts[1]);

    toReturn[key] = value;

    return toReturn;
  }, {});

  if (parsedParams.resourceId) {
    parsedParams.id = parsedParams.resourceId;
  }

  return parsedParams;
}

function formatUserName(username) {
  username = username || "";

  // NEXT_MAJOR_VERSION the web sdks have a prepended @ sign
  // but the ios and android ones do not. This should be standardized
  return "@" + username.replace("@", "");
}

function formatTokenizePayload(payload) {
  var formattedPayload = {
    nonce: payload.paymentMethodNonce,
    type: "VenmoAccount",
    details: {
      username: formatUserName(payload.username),
      paymentContextId: payload.id,
    },
  };

  if (payload.payerInfo) {
    formattedPayload.details.payerInfo = payload.payerInfo;
    formattedPayload.details.payerInfo.userName = formatUserName(
      payload.payerInfo.userName
    );
  }

  return formattedPayload;
}

// From https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
function documentVisibilityChangeEventName() {
  var visibilityChange;

  if (typeof window.document.hidden !== "undefined") {
    // Opera 12.10 and Firefox 18 and later support
    visibilityChange = "visibilitychange";
  } else if (typeof window.document.msHidden !== "undefined") {
    visibilityChange = "msvisibilitychange";
  } else if (typeof window.document.webkitHidden !== "undefined") {
    visibilityChange = "webkitvisibilitychange";
  }

  return visibilityChange;
}

function isIosWebviewInDeepLinkReturnUrlFlow() {
  // we know it's a webview because this flow only gets
  // used when checking the deep link flow
  // test the platform here to get around custom useragents
  return (
    window.navigator.platform &&
    /iPhone|iPad|iPod/.test(window.navigator.platform)
  );
}

module.exports = wrapPromise.wrapPrototype(Venmo);

},{"../lib/analytics":119,"../lib/braintree-error":124,"../lib/convert-methods-to-error":127,"../lib/in-iframe":150,"../lib/is-verified-domain":153,"../lib/methods":155,"../lib/querystring":157,"../lib/snake-case-to-camel-case":159,"./external/":213,"./external/queries":214,"./shared/browser-detection":217,"./shared/constants":218,"./shared/errors":219,"./shared/get-venmo-url":221,"./shared/supports-venmo":222,"./shared/web-login-backdrop":223,"@braintree/extended-promise":34,"@braintree/wrap-promise":43}],225:[function(_dereq_,module,exports){
"use strict";

/**
 * @name BraintreeError.Visa Checkout - Creation Error Codes
 * @description Errors that occur when [creating the Visa Checkout component](./module-braintree-web_venmo.html#.create).
 * @property {MERCHANT} VISA_CHECKOUT_NOT_ENABLED Occurs when Visa Checkout is not enabled in the Braintree control panel.
 */

/**
 * @name BraintreeError.Visa Checkout - createInitOptions Error Codes
 * @description Errors that occur when using the [`createInitOptions` method](./VisaCheckout.html#createInitOptions).
 * @property {MERCHANT} VISA_CHECKOUT_INIT_OPTIONS_REQUIRED Occurs when no options are provided to method.
 */

/**
 * @name BraintreeError.Visa Checkout - tokenize Error Codes
 * @description Errors that occur when using the [`tokenize` method](./VisaCheckout.html#tokenize).
 * @property {MERCHANT} VISA_CHECKOUT_PAYMENT_REQUIRED Occurs when no payment data is not provided.
 * @property {NETWORK} VISA_CHECKOUT_TOKENIZATION Occurs when tokenization fails.
 */

var BraintreeError = _dereq_("../lib/braintree-error");

module.exports = {
  VISA_CHECKOUT_NOT_ENABLED: {
    type: BraintreeError.types.MERCHANT,
    code: "VISA_CHECKOUT_NOT_ENABLED",
    message: "Visa Checkout is not enabled for this merchant.",
  },
  VISA_CHECKOUT_INIT_OPTIONS_REQUIRED: {
    type: BraintreeError.types.MERCHANT,
    code: "VISA_CHECKOUT_INIT_OPTIONS_REQUIRED",
    message: "initOptions requires an object.",
  },
  VISA_CHECKOUT_PAYMENT_REQUIRED: {
    type: BraintreeError.types.MERCHANT,
    code: "VISA_CHECKOUT_PAYMENT_REQUIRED",
    message: "tokenize requires callid, encKey, and encPaymentData.",
  },
  VISA_CHECKOUT_TOKENIZATION: {
    type: BraintreeError.types.NETWORK,
    code: "VISA_CHECKOUT_TOKENIZATION",
    message:
      "A network error occurred when processing the Visa Checkout payment.",
  },
};

},{"../lib/braintree-error":124}],226:[function(_dereq_,module,exports){
"use strict";

/**
 * @module braintree-web/visa-checkout
 * @description Processes Visa Checkout. *This component is currently in beta and is subject to change.*
 */

var basicComponentVerification = _dereq_("../lib/basic-component-verification");
var BraintreeError = _dereq_("../lib/braintree-error");
var createDeferredClient = _dereq_("../lib/create-deferred-client");
var createAssetsUrl = _dereq_("../lib/create-assets-url");
var VisaCheckout = _dereq_("./visa-checkout");
var analytics = _dereq_("../lib/analytics");
var errors = _dereq_("./errors");
var VERSION = "3.101.3";
var wrapPromise = _dereq_("@braintree/wrap-promise");

/**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {callback} [callback] The second argument, `data`, is the {@link VisaCheckout} instance. If no callback is provided, `create` returns a promise that resolves with the {@link VisaCheckout} instance.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
function create(options) {
  var name = "Visa Checkout";

  return basicComponentVerification
    .verify({
      name: name,
      client: options.client,
      authorization: options.authorization,
    })
    .then(function () {
      return createDeferredClient.create({
        authorization: options.authorization,
        client: options.client,
        debug: options.debug,
        assetsUrl: createAssetsUrl.create(options.authorization),
        name: name,
      });
    })
    .then(function (client) {
      options.client = client;

      if (
        !options.client.getConfiguration().gatewayConfiguration.visaCheckout
      ) {
        return Promise.reject(
          new BraintreeError(errors.VISA_CHECKOUT_NOT_ENABLED)
        );
      }

      analytics.sendEvent(options.client, "visacheckout.initialized");

      return new VisaCheckout(options);
    });
}

module.exports = {
  create: wrapPromise(create),
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION,
};

},{"../lib/analytics":119,"../lib/basic-component-verification":122,"../lib/braintree-error":124,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./errors":225,"./visa-checkout":227,"@braintree/wrap-promise":43}],227:[function(_dereq_,module,exports){
"use strict";

var BraintreeError = _dereq_("../lib/braintree-error");
var analytics = _dereq_("../lib/analytics");
var errors = _dereq_("./errors");
var jsonClone = _dereq_("../lib/json-clone");
var methods = _dereq_("../lib/methods");
var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
var wrapPromise = _dereq_("@braintree/wrap-promise");
var cardTypeTransformMap = {
  Visa: "VISA",
  MasterCard: "MASTERCARD",
  Discover: "DISCOVER",
  "American Express": "AMEX",
};

/**
 * Visa Checkout Address object.
 * @typedef {object} VisaCheckout~Address
 * @property {string} countryCode The customer's country code.
 * @property {string} extendedAddress The customer's extended address.
 * @property {string} firstName The customer's first name.
 * @property {string} lastName The customer's last name.
 * @property {string} locality The customer's locality.
 * @property {string} postalCode The customer's postal code.
 * @property {string} region The customer's region.
 * @property {string} streetAddress The customer's street address.
 * @property {string} phoneNumber The customer's phone number.
 */

/**
 * Visa Checkout UserData object.
 * @typedef {object} VisaCheckout~UserData
 * @property {string} userEmail The customer's email address.
 * @property {string} userFirstName The customer's first name.
 * @property {string} userLastName The customer's last name.
 * @property {string} userFullName The customer's full name.
 * @property {string} userName The customer's username.
 */

/**
 * Visa Checkout tokenize payload.
 * @typedef {object} VisaCheckout~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {object} details Additional account details.
 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
 * @property {string} details.lastFour Last four digits of card number.
 * @property {string} details.lastTwo Last two digits of card number.
 * @property {string} description A human-readable description.
 * @property {string} type The payment method type, always `VisaCheckoutCard`.
 * @property {VisaCheckout~Address} billingAddress The customer's billing address.
 * @property {VisaCheckout~Address} shippingAddress The customer's shipping address.
 * @property {VisaCheckout~UserData} userData Information about the customer.
 * @property {object} binData Information about the card based on the bin.
 * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.countryOfIssuance The country of issuance.
 * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.issuingBank The issuing bank.
 * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.productId The product id.
 */

/**
 * @class
 * @param {object} options The Visa Checkout {@link module:braintree-web/visa-checkout.create create} options.
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/visa-checkout.create|braintree-web.visa-checkout.create} instead.</strong>
 * @classdesc This class represents a Visa Checkout component produced by {@link module:braintree-web/visa-checkout.create|braintree-web/visa-checkout.create}. Instances of this class have methods for interacting with Visa Checkout's JavaScript library.
 */
function VisaCheckout(options) {
  this._client = options.client;
}

function transformCardTypes(cardTypes) {
  return cardTypes.reduce(function (acc, type) {
    if (cardTypeTransformMap.hasOwnProperty(type)) {
      return acc.concat(cardTypeTransformMap[type]);
    }

    return acc;
  }, []);
}

/**
 * Creates an `initOptions` object from the passed `options`, applying properties that Braintree needs to transact Visa Checkout.
 *
 * Braintree will apply these properties if they do not exist on the given `options`:
 *  - `apikey`
 *  - `externalClientId`
 *  - `settings.payment.cardBrands`
 *
 * Braintree will overwrite `settings.dataLevel = 'FULL'` to access the full payment method.
 * @public
 * @param {object} options The base `initOptions` that will be used to init Visa Checkout.
 * @param {string} [options.apikey] The API key used to initialize Visa Checkout. When not supplied, Braintree will set this property.
 * @param {string} [options.externalClientId] The external client ID key used to initialize Visa Checkout. When not supplied, Braintree will set this property.
 * @param {object} [options.settings] The settings object used to initialize Visa Checkout.
 * @param {string} [options.settings.dataLevel] The data level used to initialize Visa Checkout. Braintree will overwrite this property to 'FULL'.
 * @param {object} [options.settings.payment] The payment object used to initialize Visa Checkout.
 * @param {string[]} [options.settings.payment.cardBrands] The card brands that Visa Checkout will allow the customer to pay with. When not supplied, Braintree will set this property.
 * @returns {object} `initOptions` The `initOptions` that Visa Checkout should be initialized with.
 */
VisaCheckout.prototype.createInitOptions = function (options) {
  var initOptions;
  var gatewayConfiguration =
    this._client.getConfiguration().gatewayConfiguration;
  var visaCheckoutConfiguration = gatewayConfiguration.visaCheckout;

  if (!options) {
    throw new BraintreeError(errors.VISA_CHECKOUT_INIT_OPTIONS_REQUIRED);
  }

  initOptions = jsonClone(options);
  initOptions.apikey = initOptions.apikey || visaCheckoutConfiguration.apikey;
  initOptions.encryptionKey = visaCheckoutConfiguration.encryptionKey;
  initOptions.externalClientId =
    initOptions.externalClientId || visaCheckoutConfiguration.externalClientId;
  initOptions.settings = initOptions.settings || {};
  initOptions.settings.dataLevel = "FULL";
  initOptions.settings.payment = initOptions.settings.payment || {};

  if (!initOptions.settings.payment.cardBrands) {
    initOptions.settings.payment.cardBrands = transformCardTypes(
      gatewayConfiguration.visaCheckout.supportedCardTypes
    );
  }

  return initOptions;
};

/**
 * Tokenizes the Visa Checkout payload, returning a payment method nonce.
 * @public
 * @param {object} payment The object that Visa Checkout supplies on `payment.success`.
 * @param {string} payment.callid Visa Checkout transaction ID associated with this payment.
 * @param {string} payment.encKey The encrypted key used to decrypt the payment data.
 * @param {string} payment.encPaymentData The encrypted payment data.
 * @param {callback} [callback] The second argument, <code>tokenizePayload</code> is a {@link VisaCheckout~tokenizePayload|tokenizePayload}. If no callback is provided, `tokenize` returns a promise that resolves with the {@link VisaCheckout~tokenizePayload|tokenizePayload}.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
VisaCheckout.prototype.tokenize = function (payment) {
  var self = this;

  if (!payment.callid || !payment.encKey || !payment.encPaymentData) {
    return Promise.reject(
      new BraintreeError(errors.VISA_CHECKOUT_PAYMENT_REQUIRED)
    );
  }

  return this._client
    .request({
      method: "post",
      endpoint: "payment_methods/visa_checkout_cards",
      data: {
        _meta: {
          source: "visa-checkout",
        },
        visaCheckoutCard: {
          callId: payment.callid,
          encryptedPaymentData: payment.encPaymentData,
          encryptedKey: payment.encKey,
        },
      },
    })
    .then(function (response) {
      analytics.sendEvent(self._client, "visacheckout.tokenize.succeeded");

      return response.visaCheckoutCards[0];
    })
    .catch(function (err) {
      analytics.sendEvent(self._client, "visacheckout.tokenize.failed");

      return Promise.reject(
        new BraintreeError({
          type: errors.VISA_CHECKOUT_TOKENIZATION.type,
          code: errors.VISA_CHECKOUT_TOKENIZATION.code,
          message: errors.VISA_CHECKOUT_TOKENIZATION.message,
          details: {
            originalError: err,
          },
        })
      );
    });
};

/**
 * Cleanly tear down anything set up by {@link module:braintree-web/visa-checkout.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * visaCheckoutInstance.teardown();
 * @example <caption>With callback</caption>
 * visaCheckoutInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */
VisaCheckout.prototype.teardown = function () {
  convertMethodsToError(this, methods(VisaCheckout.prototype));

  return Promise.resolve();
};

module.exports = wrapPromise.wrapPrototype(VisaCheckout);

},{"../lib/analytics":119,"../lib/braintree-error":124,"../lib/convert-methods-to-error":127,"../lib/json-clone":154,"../lib/methods":155,"./errors":225,"@braintree/wrap-promise":43}]},{},[117])(117)
});

/* -------- studio/v2/js/redactor-tokens.js -------- */
(function ($R, $) {
    $R.add('plugin', 'tokens', {
        dropdown: {},
        init: function (app) {
            this.app = app;
            this.insertion = app.insertion;
            this.toolbar = app.toolbar;
        },
        start: function () {
            this.toolbar.addButton('tokens', { title: 'Variables' });

            // Initialize dropdown with provided initial tokens, if present
            if (this.app.opts.templateTokens) {
                this.updateTokenList(this.app.opts.templateTokens);
            }
        },
        updateTokenList: function (tokens) {
            this.dropdown = {};

            $.each(tokens, $.proxy(function (key, token) {
                this.dropdown['token-' + token.id] = {
                    title: token.description + ': ' + token.token,
                    api: 'plugin.tokens.insertToken',
                    args: { token: token.token }
                };
            }, this));

            this.toolbar.getButton('tokens').setDropdown(this.dropdown);
        },
        insertToken: function (args) {
            this.insertion.insertText(args.token);
        }
    })
})(window.$R, window.$);

/* -------- common/js/jasny-bootstrap-fileinput.js -------- */
/**
 * Generated using the "Customize and download" tool here:
 * http://jasny.github.io/bootstrap/customize/
 *
 * Options selected for custom build:
 * - Less files > JavaScript components > File input
 * - jQuery plugins > Linked to components > File input
 */

/* ===========================================================
 * Bootstrap: fileinput.js v3.1.3
 * http://jasny.github.com/bootstrap/javascript/#fileinput
 * ===========================================================
 * Copyright 2012-2014 Arnold Daniels
 *
 * Licensed under the Apache License, Version 2.0 (the "License")
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */

+function ($) { "use strict";

  var isIE = window.navigator.appName == 'Microsoft Internet Explorer'

  // FILEUPLOAD PUBLIC CLASS DEFINITION
  // =================================

  var Fileinput = function (element, options) {
    this.$element = $(element)

    this.$input = this.$element.find(':file')
    if (this.$input.length === 0) return

    this.name = this.$input.attr('name') || options.name

    this.$hidden = this.$element.find('input[type=hidden][name="' + this.name + '"]')
    if (this.$hidden.length === 0) {
      this.$hidden = $('<input type="hidden">').insertBefore(this.$input)
    }

    this.$preview = this.$element.find('.fileinput-preview')
    var height = this.$preview.css('height')
    if (this.$preview.css('display') !== 'inline' && height !== '0px' && height !== 'none') {
      this.$preview.css('line-height', height)
    }

    this.original = {
      exists: this.$element.hasClass('fileinput-exists'),
      preview: this.$preview.html(),
      hiddenVal: this.$hidden.val()
    }

    this.listen()
  }

  Fileinput.prototype.listen = function() {
    this.$input.on('change.bs.fileinput', $.proxy(this.change, this))
    $(this.$input[0].form).on('reset.bs.fileinput', $.proxy(this.reset, this))

    this.$element.find('[data-trigger="fileinput"]').on('click.bs.fileinput', $.proxy(this.trigger, this))
    this.$element.find('[data-dismiss="fileinput"]').on('click.bs.fileinput', $.proxy(this.clear, this))
  },

  Fileinput.prototype.change = function(e) {
    var files = e.target.files === undefined ? (e.target && e.target.value ? [{ name: e.target.value.replace(/^.+\\/, '')}] : []) : e.target.files

    e.stopPropagation()

    if (files.length === 0) {
      this.clear()
      return
    }

    this.$hidden.val('')
    this.$hidden.attr('name', '')
    this.$input.attr('name', this.name)

    var file = files[0]

    if (this.$preview.length > 0 && (typeof file.type !== "undefined" ? file.type.match(/^image\/(gif|png|jpeg)$/) : file.name.match(/\.(gif|png|jpe?g)$/i)) && typeof FileReader !== "undefined") {
      var reader = new FileReader()
      var preview = this.$preview
      var element = this.$element

      reader.onload = function(re) {
        var $img = $('<img>')
        $img[0].src = re.target.result
        files[0].result = re.target.result

        element.find('.fileinput-filename').text(file.name)

        // if parent has max-height, using `(max-)height: 100%` on child doesn't take padding and border into account
        if (preview.css('max-height') != 'none') $img.css('max-height', parseInt(preview.css('max-height'), 10) - parseInt(preview.css('padding-top'), 10) - parseInt(preview.css('padding-bottom'), 10)  - parseInt(preview.css('border-top'), 10) - parseInt(preview.css('border-bottom'), 10))

        preview.html($img)
        element.addClass('fileinput-exists').removeClass('fileinput-new')

        element.trigger('change.bs.fileinput', files)
      }

      reader.readAsDataURL(file)
    } else {
      this.$element.find('.fileinput-filename').text(file.name)
      this.$preview.text(file.name)

      this.$element.addClass('fileinput-exists').removeClass('fileinput-new')

      this.$element.trigger('change.bs.fileinput')
    }
  },

  Fileinput.prototype.clear = function(e) {
    if (e) e.preventDefault()

    this.$hidden.val('')
    this.$hidden.attr('name', this.name)
    this.$input.attr('name', '')

    //ie8+ doesn't support changing the value of input with type=file so clone instead
    if (isIE) {
      var inputClone = this.$input.clone(true);
      this.$input.after(inputClone);
      this.$input.remove();
      this.$input = inputClone;
    } else {
      this.$input.val('')
    }

    this.$preview.html('')
    this.$element.find('.fileinput-filename').text('')
    this.$element.addClass('fileinput-new').removeClass('fileinput-exists')

    if (e !== undefined) {
      this.$input.trigger('change')
      this.$element.trigger('clear.bs.fileinput')
    }
  },

  Fileinput.prototype.reset = function() {
    this.clear()

    this.$hidden.val(this.original.hiddenVal)
    this.$preview.html(this.original.preview)
    this.$element.find('.fileinput-filename').text('')

    if (this.original.exists) this.$element.addClass('fileinput-exists').removeClass('fileinput-new')
     else this.$element.addClass('fileinput-new').removeClass('fileinput-exists')

    this.$element.trigger('reset.bs.fileinput')
  },

  Fileinput.prototype.trigger = function(e) {
    this.$input.trigger('click')
    e.preventDefault()
  }


  // FILEUPLOAD PLUGIN DEFINITION
  // ===========================

  var old = $.fn.fileinput

  $.fn.fileinput = function (options) {
    return this.each(function () {
      var $this = $(this),
          data = $this.data('bs.fileinput')
      if (!data) $this.data('bs.fileinput', (data = new Fileinput(this, options)))
      if (typeof options == 'string') data[options]()
    })
  }

  $.fn.fileinput.Constructor = Fileinput


  // FILEINPUT NO CONFLICT
  // ====================

  $.fn.fileinput.noConflict = function () {
    $.fn.fileinput = old
    return this
  }


  // FILEUPLOAD DATA-API
  // ==================

  $(document).on('click.fileinput.data-api', '[data-provides="fileinput"]', function (e) {
    var $this = $(this)
    if ($this.data('bs.fileinput')) return
    $this.fileinput($this.data())

    var $target = $(e.target).closest('[data-dismiss="fileinput"],[data-trigger="fileinput"]');
    if ($target.length > 0) {
      e.preventDefault()
      $target.trigger('click.bs.fileinput')
    }
  })

}(window.jQuery);


/* -------- common/js/zero_clipboard/0.2.2/jquery.zeroclipboard.js -------- */
/*!
 * jquery.zeroclipboard
 * Bind to the `beforecopy`, `copy`, `aftercopy`, and `copy-error` events, custom DOM-like events for clipboard injection generated using jQuery's Special Events API and ZeroClipboard's Core module.
 * Copyright (c) 2014 
 * Licensed MIT
 * https://github.com/zeroclipboard/jquery.zeroclipboard
 * v0.2.0
 */
(function($, window, undefined) {
  "use strict";
  var require, module, exports;
  var zcExistsAlready = !!window.ZeroClipboard;
  /*!
 * ZeroClipboard
 * The ZeroClipboard library provides an easy way to copy text to the clipboard using an invisible Adobe Flash movie and a JavaScript interface.
 * Copyright (c) 2014 Jon Rohan, James M. Greene
 * Licensed MIT
 * http://zeroclipboard.org/
 * v2.1.2
 */
  (function(window, undefined) {
    /**
 * Store references to critically important global functions that may be
 * overridden on certain web pages.
 */
    var _window = window, _document = _window.document, _navigator = _window.navigator, _setTimeout = _window.setTimeout, _encodeURIComponent = _window.encodeURIComponent, _ActiveXObject = _window.ActiveXObject, _parseInt = _window.Number.parseInt || _window.parseInt, _parseFloat = _window.Number.parseFloat || _window.parseFloat, _isNaN = _window.Number.isNaN || _window.isNaN, _round = _window.Math.round, _now = _window.Date.now, _keys = _window.Object.keys, _defineProperty = _window.Object.defineProperty, _hasOwn = _window.Object.prototype.hasOwnProperty, _slice = _window.Array.prototype.slice;
    /**
 * Convert an `arguments` object into an Array.
 *
 * @returns The arguments as an Array
 * @private
 */
    var _args = function(argumentsObj) {
      return _slice.call(argumentsObj, 0);
    };
    /**
 * Shallow-copy the owned, enumerable properties of one object over to another, similar to jQuery's `$.extend`.
 *
 * @returns The target object, augmented
 * @private
 */
    var _extend = function() {
      var i, len, arg, prop, src, copy, args = _args(arguments), target = args[0] || {};
      for (i = 1, len = args.length; i < len; i++) {
        if ((arg = args[i]) != null) {
          for (prop in arg) {
            if (_hasOwn.call(arg, prop)) {
              src = target[prop];
              copy = arg[prop];
              if (target !== copy && copy !== undefined) {
                target[prop] = copy;
              }
            }
          }
        }
      }
      return target;
    };
    /**
 * Return a deep copy of the source object or array.
 *
 * @returns Object or Array
 * @private
 */
    var _deepCopy = function(source) {
      var copy, i, len, prop;
      if (typeof source !== "object" || source == null) {
        copy = source;
      } else if (typeof source.length === "number") {
        copy = [];
        for (i = 0, len = source.length; i < len; i++) {
          if (_hasOwn.call(source, i)) {
            copy[i] = _deepCopy(source[i]);
          }
        }
      } else {
        copy = {};
        for (prop in source) {
          if (_hasOwn.call(source, prop)) {
            copy[prop] = _deepCopy(source[prop]);
          }
        }
      }
      return copy;
    };
    /**
 * Makes a shallow copy of `obj` (like `_extend`) but filters its properties based on a list of `keys` to keep.
 * The inverse of `_omit`, mostly. The big difference is that these properties do NOT need to be enumerable to
 * be kept.
 *
 * @returns A new filtered object.
 * @private
 */
    var _pick = function(obj, keys) {
      var newObj = {};
      for (var i = 0, len = keys.length; i < len; i++) {
        if (keys[i] in obj) {
          newObj[keys[i]] = obj[keys[i]];
        }
      }
      return newObj;
    };
    /**
 * Makes a shallow copy of `obj` (like `_extend`) but filters its properties based on a list of `keys` to omit.
 * The inverse of `_pick`.
 *
 * @returns A new filtered object.
 * @private
 */
    var _omit = function(obj, keys) {
      var newObj = {};
      for (var prop in obj) {
        if (keys.indexOf(prop) === -1) {
          newObj[prop] = obj[prop];
        }
      }
      return newObj;
    };
    /**
 * Remove all owned, enumerable properties from an object.
 *
 * @returns The original object without its owned, enumerable properties.
 * @private
 */
    var _deleteOwnProperties = function(obj) {
      if (obj) {
        for (var prop in obj) {
          if (_hasOwn.call(obj, prop)) {
            delete obj[prop];
          }
        }
      }
      return obj;
    };
    /**
 * Determine if an element is contained within another element.
 *
 * @returns Boolean
 * @private
 */
    var _containedBy = function(el, ancestorEl) {
      if (el && el.nodeType === 1 && el.ownerDocument && ancestorEl && (ancestorEl.nodeType === 1 && ancestorEl.ownerDocument && ancestorEl.ownerDocument === el.ownerDocument || ancestorEl.nodeType === 9 && !ancestorEl.ownerDocument && ancestorEl === el.ownerDocument)) {
        do {
          if (el === ancestorEl) {
            return true;
          }
          el = el.parentNode;
        } while (el);
      }
      return false;
    };
    /**
 * Keep track of the state of the Flash object.
 * @private
 */
    var _flashState = {
      bridge: null,
      version: "0.0.0",
      pluginType: "unknown",
      disabled: null,
      outdated: null,
      unavailable: null,
      deactivated: null,
      overdue: null,
      ready: null
    };
    /**
 * The minimum Flash Player version required to use ZeroClipboard completely.
 * @readonly
 * @private
 */
    var _minimumFlashVersion = "11.0.0";
    /**
 * Keep track of all event listener registrations.
 * @private
 */
    var _handlers = {};
    /**
 * Keep track of the currently activated element.
 * @private
 */
    var _currentElement;
    /**
 * Keep track of data for the pending clipboard transaction.
 * @private
 */
    var _clipData = {};
    /**
 * Keep track of data formats for the pending clipboard transaction.
 * @private
 */
    var _clipDataFormatMap = null;
    /**
 * The `message` store for events
 * @private
 */
    var _eventMessages = {
      ready: "Flash communication is established",
      error: {
        "flash-disabled": "Flash is disabled or not installed",
        "flash-outdated": "Flash is too outdated to support ZeroClipboard",
        "flash-unavailable": "Flash is unable to communicate bidirectionally with JavaScript",
        "flash-deactivated": "Flash is too outdated for your browser and/or is configured as click-to-activate",
        "flash-overdue": "Flash communication was established but NOT within the acceptable time limit"
      }
    };
    /**
 * The presumed location of the "ZeroClipboard.swf" file, based on the location
 * of the executing JavaScript file (e.g. "ZeroClipboard.js", etc.).
 * @private
 */
    var _swfPath = function() {
      var i, jsDir, tmpJsPath, jsPath, swfPath = "ZeroClipboard.swf";
      if (!(_document.currentScript && (jsPath = _document.currentScript.src))) {
        var scripts = _document.getElementsByTagName("script");
        if ("readyState" in scripts[0]) {
          for (i = scripts.length; i--; ) {
            if (scripts[i].readyState === "interactive" && (jsPath = scripts[i].src)) {
              break;
            }
          }
        } else if (_document.readyState === "loading") {
          jsPath = scripts[scripts.length - 1].src;
        } else {
          for (i = scripts.length; i--; ) {
            tmpJsPath = scripts[i].src;
            if (!tmpJsPath) {
              jsDir = null;
              break;
            }
            tmpJsPath = tmpJsPath.split("#")[0].split("?")[0];
            tmpJsPath = tmpJsPath.slice(0, tmpJsPath.lastIndexOf("/") + 1);
            if (jsDir == null) {
              jsDir = tmpJsPath;
            } else if (jsDir !== tmpJsPath) {
              jsDir = null;
              break;
            }
          }
          if (jsDir !== null) {
            jsPath = jsDir;
          }
        }
      }
      if (jsPath) {
        jsPath = jsPath.split("#")[0].split("?")[0];
        swfPath = jsPath.slice(0, jsPath.lastIndexOf("/") + 1) + swfPath;
      }
      return swfPath;
    }();
    /**
 * ZeroClipboard configuration defaults for the Core module.
 * @private
 */
    var _globalConfig = {
      swfPath: _swfPath,
      trustedDomains: window.location.host ? [ window.location.host ] : [],
      cacheBust: true,
      forceEnhancedClipboard: false,
      flashLoadTimeout: 3e4,
      autoActivate: true,
      bubbleEvents: true,
      containerId: "global-zeroclipboard-html-bridge",
      containerClass: "global-zeroclipboard-container",
      swfObjectId: "global-zeroclipboard-flash-bridge",
      hoverClass: "zeroclipboard-is-hover",
      activeClass: "zeroclipboard-is-active",
      forceHandCursor: false,
      title: null,
      zIndex: 999999999
    };
    /**
 * The underlying implementation of `ZeroClipboard.config`.
 * @private
 */
    var _config = function(options) {
      if (typeof options === "object" && options !== null) {
        for (var prop in options) {
          if (_hasOwn.call(options, prop)) {
            if (/^(?:forceHandCursor|title|zIndex|bubbleEvents)$/.test(prop)) {
              _globalConfig[prop] = options[prop];
            } else if (_flashState.bridge == null) {
              if (prop === "containerId" || prop === "swfObjectId") {
                if (_isValidHtml4Id(options[prop])) {
                  _globalConfig[prop] = options[prop];
                } else {
                  throw new Error("The specified `" + prop + "` value is not valid as an HTML4 Element ID");
                }
              } else {
                _globalConfig[prop] = options[prop];
              }
            }
          }
        }
      }
      if (typeof options === "string" && options) {
        if (_hasOwn.call(_globalConfig, options)) {
          return _globalConfig[options];
        }
        return;
      }
      return _deepCopy(_globalConfig);
    };
    /**
 * The underlying implementation of `ZeroClipboard.state`.
 * @private
 */
    var _state = function() {
      return {
        browser: _pick(_navigator, [ "userAgent", "platform", "appName" ]),
        flash: _omit(_flashState, [ "bridge" ]),
        zeroclipboard: {
          version: ZeroClipboard.version,
          config: ZeroClipboard.config()
        }
      };
    };
    /**
 * The underlying implementation of `ZeroClipboard.isFlashUnusable`.
 * @private
 */
    var _isFlashUnusable = function() {
      return !!(_flashState.disabled || _flashState.outdated || _flashState.unavailable || _flashState.deactivated);
    };
    /**
 * The underlying implementation of `ZeroClipboard.on`.
 * @private
 */
    var _on = function(eventType, listener) {
      var i, len, events, added = {};
      if (typeof eventType === "string" && eventType) {
        events = eventType.toLowerCase().split(/\s+/);
      } else if (typeof eventType === "object" && eventType && typeof listener === "undefined") {
        for (i in eventType) {
          if (_hasOwn.call(eventType, i) && typeof i === "string" && i && typeof eventType[i] === "function") {
            ZeroClipboard.on(i, eventType[i]);
          }
        }
      }
      if (events && events.length) {
        for (i = 0, len = events.length; i < len; i++) {
          eventType = events[i].replace(/^on/, "");
          added[eventType] = true;
          if (!_handlers[eventType]) {
            _handlers[eventType] = [];
          }
          _handlers[eventType].push(listener);
        }
        if (added.ready && _flashState.ready) {
          ZeroClipboard.emit({
            type: "ready"
          });
        }
        if (added.error) {
          var errorTypes = [ "disabled", "outdated", "unavailable", "deactivated", "overdue" ];
          for (i = 0, len = errorTypes.length; i < len; i++) {
            if (_flashState[errorTypes[i]] === true) {
              ZeroClipboard.emit({
                type: "error",
                name: "flash-" + errorTypes[i]
              });
              break;
            }
          }
        }
      }
      return ZeroClipboard;
    };
    /**
 * The underlying implementation of `ZeroClipboard.off`.
 * @private
 */
    var _off = function(eventType, listener) {
      var i, len, foundIndex, events, perEventHandlers;
      if (arguments.length === 0) {
        events = _keys(_handlers);
      } else if (typeof eventType === "string" && eventType) {
        events = eventType.split(/\s+/);
      } else if (typeof eventType === "object" && eventType && typeof listener === "undefined") {
        for (i in eventType) {
          if (_hasOwn.call(eventType, i) && typeof i === "string" && i && typeof eventType[i] === "function") {
            ZeroClipboard.off(i, eventType[i]);
          }
        }
      }
      if (events && events.length) {
        for (i = 0, len = events.length; i < len; i++) {
          eventType = events[i].toLowerCase().replace(/^on/, "");
          perEventHandlers = _handlers[eventType];
          if (perEventHandlers && perEventHandlers.length) {
            if (listener) {
              foundIndex = perEventHandlers.indexOf(listener);
              while (foundIndex !== -1) {
                perEventHandlers.splice(foundIndex, 1);
                foundIndex = perEventHandlers.indexOf(listener, foundIndex);
              }
            } else {
              perEventHandlers.length = 0;
            }
          }
        }
      }
      return ZeroClipboard;
    };
    /**
 * The underlying implementation of `ZeroClipboard.handlers`.
 * @private
 */
    var _listeners = function(eventType) {
      var copy;
      if (typeof eventType === "string" && eventType) {
        copy = _deepCopy(_handlers[eventType]) || null;
      } else {
        copy = _deepCopy(_handlers);
      }
      return copy;
    };
    /**
 * The underlying implementation of `ZeroClipboard.emit`.
 * @private
 */
    var _emit = function(event) {
      var eventCopy, returnVal, tmp;
      event = _createEvent(event);
      if (!event) {
        return;
      }
      if (_preprocessEvent(event)) {
        return;
      }
      if (event.type === "ready" && _flashState.overdue === true) {
        return ZeroClipboard.emit({
          type: "error",
          name: "flash-overdue"
        });
      }
      eventCopy = _extend({}, event);
      _dispatchCallbacks.call(this, eventCopy);
      if (event.type === "copy") {
        tmp = _mapClipDataToFlash(_clipData);
        returnVal = tmp.data;
        _clipDataFormatMap = tmp.formatMap;
      }
      return returnVal;
    };
    /**
 * The underlying implementation of `ZeroClipboard.create`.
 * @private
 */
    var _create = function() {
      if (typeof _flashState.ready !== "boolean") {
        _flashState.ready = false;
      }
      if (!ZeroClipboard.isFlashUnusable() && _flashState.bridge === null) {
        var maxWait = _globalConfig.flashLoadTimeout;
        if (typeof maxWait === "number" && maxWait >= 0) {
          _setTimeout(function() {
            if (typeof _flashState.deactivated !== "boolean") {
              _flashState.deactivated = true;
            }
            if (_flashState.deactivated === true) {
              ZeroClipboard.emit({
                type: "error",
                name: "flash-deactivated"
              });
            }
          }, maxWait);
        }
        _flashState.overdue = false;
        _embedSwf();
      }
    };
    /**
 * The underlying implementation of `ZeroClipboard.destroy`.
 * @private
 */
    var _destroy = function() {
      ZeroClipboard.clearData();
      ZeroClipboard.blur();
      ZeroClipboard.emit("destroy");
      _unembedSwf();
      ZeroClipboard.off();
    };
    /**
 * The underlying implementation of `ZeroClipboard.setData`.
 * @private
 */
    var _setData = function(format, data) {
      var dataObj;
      if (typeof format === "object" && format && typeof data === "undefined") {
        dataObj = format;
        ZeroClipboard.clearData();
      } else if (typeof format === "string" && format) {
        dataObj = {};
        dataObj[format] = data;
      } else {
        return;
      }
      for (var dataFormat in dataObj) {
        if (typeof dataFormat === "string" && dataFormat && _hasOwn.call(dataObj, dataFormat) && typeof dataObj[dataFormat] === "string" && dataObj[dataFormat]) {
          _clipData[dataFormat] = dataObj[dataFormat];
        }
      }
    };
    /**
 * The underlying implementation of `ZeroClipboard.clearData`.
 * @private
 */
    var _clearData = function(format) {
      if (typeof format === "undefined") {
        _deleteOwnProperties(_clipData);
        _clipDataFormatMap = null;
      } else if (typeof format === "string" && _hasOwn.call(_clipData, format)) {
        delete _clipData[format];
      }
    };
    /**
 * The underlying implementation of `ZeroClipboard.getData`.
 * @private
 */
    var _getData = function(format) {
      if (typeof format === "undefined") {
        return _deepCopy(_clipData);
      } else if (typeof format === "string" && _hasOwn.call(_clipData, format)) {
        return _clipData[format];
      }
    };
    /**
 * The underlying implementation of `ZeroClipboard.focus`/`ZeroClipboard.activate`.
 * @private
 */
    var _focus = function(element) {
      if (!(element && element.nodeType === 1)) {
        return;
      }
      if (_currentElement) {
        _removeClass(_currentElement, _globalConfig.activeClass);
        if (_currentElement !== element) {
          _removeClass(_currentElement, _globalConfig.hoverClass);
        }
      }
      _currentElement = element;
      _addClass(element, _globalConfig.hoverClass);
      var newTitle = element.getAttribute("title") || _globalConfig.title;
      if (typeof newTitle === "string" && newTitle) {
        var htmlBridge = _getHtmlBridge(_flashState.bridge);
        if (htmlBridge) {
          htmlBridge.setAttribute("title", newTitle);
        }
      }
      var useHandCursor = _globalConfig.forceHandCursor === true || _getStyle(element, "cursor") === "pointer";
      _setHandCursor(useHandCursor);
      _reposition();
    };
    /**
 * The underlying implementation of `ZeroClipboard.blur`/`ZeroClipboard.deactivate`.
 * @private
 */
    var _blur = function() {
      var htmlBridge = _getHtmlBridge(_flashState.bridge);
      if (htmlBridge) {
        htmlBridge.removeAttribute("title");
        htmlBridge.style.left = "0px";
        htmlBridge.style.top = "-9999px";
        htmlBridge.style.width = "1px";
        htmlBridge.style.top = "1px";
      }
      if (_currentElement) {
        _removeClass(_currentElement, _globalConfig.hoverClass);
        _removeClass(_currentElement, _globalConfig.activeClass);
        _currentElement = null;
      }
    };
    /**
 * The underlying implementation of `ZeroClipboard.activeElement`.
 * @private
 */
    var _activeElement = function() {
      return _currentElement || null;
    };
    /**
 * Check if a value is a valid HTML4 `ID` or `Name` token.
 * @private
 */
    var _isValidHtml4Id = function(id) {
      return typeof id === "string" && id && /^[A-Za-z][A-Za-z0-9_:\-\.]*$/.test(id);
    };
    /**
 * Create or update an `event` object, based on the `eventType`.
 * @private
 */
    var _createEvent = function(event) {
      var eventType;
      if (typeof event === "string" && event) {
        eventType = event;
        event = {};
      } else if (typeof event === "object" && event && typeof event.type === "string" && event.type) {
        eventType = event.type;
      }
      if (!eventType) {
        return;
      }
      _extend(event, {
        type: eventType.toLowerCase(),
        target: event.target || _currentElement || null,
        relatedTarget: event.relatedTarget || null,
        currentTarget: _flashState && _flashState.bridge || null,
        timeStamp: event.timeStamp || _now() || null
      });
      var msg = _eventMessages[event.type];
      if (event.type === "error" && event.name && msg) {
        msg = msg[event.name];
      }
      if (msg) {
        event.message = msg;
      }
      if (event.type === "ready") {
        _extend(event, {
          target: null,
          version: _flashState.version
        });
      }
      if (event.type === "error") {
        if (/^flash-(disabled|outdated|unavailable|deactivated|overdue)$/.test(event.name)) {
          _extend(event, {
            target: null,
            minimumVersion: _minimumFlashVersion
          });
        }
        if (/^flash-(outdated|unavailable|deactivated|overdue)$/.test(event.name)) {
          _extend(event, {
            version: _flashState.version
          });
        }
      }
      if (event.type === "copy") {
        event.clipboardData = {
          setData: ZeroClipboard.setData,
          clearData: ZeroClipboard.clearData
        };
      }
      if (event.type === "aftercopy") {
        event = _mapClipResultsFromFlash(event, _clipDataFormatMap);
      }
      if (event.target && !event.relatedTarget) {
        event.relatedTarget = _getRelatedTarget(event.target);
      }
      event = _addMouseData(event);
      return event;
    };
    /**
 * Get a relatedTarget from the target's `data-clipboard-target` attribute
 * @private
 */
    var _getRelatedTarget = function(targetEl) {
      var relatedTargetId = targetEl && targetEl.getAttribute && targetEl.getAttribute("data-clipboard-target");
      return relatedTargetId ? _document.getElementById(relatedTargetId) : null;
    };
    /**
 * Add element and position data to `MouseEvent` instances
 * @private
 */
    var _addMouseData = function(event) {
      if (event && /^_(?:click|mouse(?:over|out|down|up|move))$/.test(event.type)) {
        var srcElement = event.target;
        var fromElement = event.type === "_mouseover" && event.relatedTarget ? event.relatedTarget : undefined;
        var toElement = event.type === "_mouseout" && event.relatedTarget ? event.relatedTarget : undefined;
        var pos = _getDOMObjectPosition(srcElement);
        var screenLeft = _window.screenLeft || _window.screenX || 0;
        var screenTop = _window.screenTop || _window.screenY || 0;
        var scrollLeft = _document.body.scrollLeft + _document.documentElement.scrollLeft;
        var scrollTop = _document.body.scrollTop + _document.documentElement.scrollTop;
        var pageX = pos.left + (typeof event._stageX === "number" ? event._stageX : 0);
        var pageY = pos.top + (typeof event._stageY === "number" ? event._stageY : 0);
        var clientX = pageX - scrollLeft;
        var clientY = pageY - scrollTop;
        var screenX = screenLeft + clientX;
        var screenY = screenTop + clientY;
        var moveX = typeof event.movementX === "number" ? event.movementX : 0;
        var moveY = typeof event.movementY === "number" ? event.movementY : 0;
        delete event._stageX;
        delete event._stageY;
        _extend(event, {
          srcElement: srcElement,
          fromElement: fromElement,
          toElement: toElement,
          screenX: screenX,
          screenY: screenY,
          pageX: pageX,
          pageY: pageY,
          clientX: clientX,
          clientY: clientY,
          x: clientX,
          y: clientY,
          movementX: moveX,
          movementY: moveY,
          offsetX: 0,
          offsetY: 0,
          layerX: 0,
          layerY: 0
        });
      }
      return event;
    };
    /**
 * Determine if an event's registered handlers should be execute synchronously or asynchronously.
 *
 * @returns {boolean}
 * @private
 */
    var _shouldPerformAsync = function(event) {
      var eventType = event && typeof event.type === "string" && event.type || "";
      return !/^(?:(?:before)?copy|destroy)$/.test(eventType);
    };
    /**
 * Control if a callback should be executed asynchronously or not.
 *
 * @returns `undefined`
 * @private
 */
    var _dispatchCallback = function(func, context, args, async) {
      if (async) {
        _setTimeout(function() {
          func.apply(context, args);
        }, 0);
      } else {
        func.apply(context, args);
      }
    };
    /**
 * Handle the actual dispatching of events to client instances.
 *
 * @returns `undefined`
 * @private
 */
    var _dispatchCallbacks = function(event) {
      if (!(typeof event === "object" && event && event.type)) {
        return;
      }
      var async = _shouldPerformAsync(event);
      var wildcardTypeHandlers = _handlers["*"] || [];
      var specificTypeHandlers = _handlers[event.type] || [];
      var handlers = wildcardTypeHandlers.concat(specificTypeHandlers);
      if (handlers && handlers.length) {
        var i, len, func, context, eventCopy, originalContext = this;
        for (i = 0, len = handlers.length; i < len; i++) {
          func = handlers[i];
          context = originalContext;
          if (typeof func === "string" && typeof _window[func] === "function") {
            func = _window[func];
          }
          if (typeof func === "object" && func && typeof func.handleEvent === "function") {
            context = func;
            func = func.handleEvent;
          }
          if (typeof func === "function") {
            eventCopy = _extend({}, event);
            _dispatchCallback(func, context, [ eventCopy ], async);
          }
        }
      }
      return this;
    };
    /**
 * Preprocess any special behaviors, reactions, or state changes after receiving this event.
 * Executes only once per event emitted, NOT once per client.
 * @private
 */
    var _preprocessEvent = function(event) {
      var element = event.target || _currentElement || null;
      var sourceIsSwf = event._source === "swf";
      delete event._source;
      var flashErrorNames = [ "flash-disabled", "flash-outdated", "flash-unavailable", "flash-deactivated", "flash-overdue" ];
      switch (event.type) {
       case "error":
        if (flashErrorNames.indexOf(event.name) !== -1) {
          _extend(_flashState, {
            disabled: event.name === "flash-disabled",
            outdated: event.name === "flash-outdated",
            unavailable: event.name === "flash-unavailable",
            deactivated: event.name === "flash-deactivated",
            overdue: event.name === "flash-overdue",
            ready: false
          });
        }
        break;

       case "ready":
        var wasDeactivated = _flashState.deactivated === true;
        _extend(_flashState, {
          disabled: false,
          outdated: false,
          unavailable: false,
          deactivated: false,
          overdue: wasDeactivated,
          ready: !wasDeactivated
        });
        break;

       case "copy":
        var textContent, htmlContent, targetEl = event.relatedTarget;
        if (!(_clipData["text/html"] || _clipData["text/plain"]) && targetEl && (htmlContent = targetEl.value || targetEl.outerHTML || targetEl.innerHTML) && (textContent = targetEl.value || targetEl.textContent || targetEl.innerText)) {
          event.clipboardData.clearData();
          event.clipboardData.setData("text/plain", textContent);
          if (htmlContent !== textContent) {
            event.clipboardData.setData("text/html", htmlContent);
          }
        } else if (!_clipData["text/plain"] && event.target && (textContent = event.target.getAttribute("data-clipboard-text"))) {
          event.clipboardData.clearData();
          event.clipboardData.setData("text/plain", textContent);
        }
        break;

       case "aftercopy":
        ZeroClipboard.clearData();
        if (element && element !== _safeActiveElement() && element.focus) {
          element.focus();
        }
        break;

       case "_mouseover":
        ZeroClipboard.focus(element);
        if (_globalConfig.bubbleEvents === true && sourceIsSwf) {
          if (element && element !== event.relatedTarget && !_containedBy(event.relatedTarget, element)) {
            _fireMouseEvent(_extend({}, event, {
              type: "mouseenter",
              bubbles: false,
              cancelable: false
            }));
          }
          _fireMouseEvent(_extend({}, event, {
            type: "mouseover"
          }));
        }
        break;

       case "_mouseout":
        ZeroClipboard.blur();
        if (_globalConfig.bubbleEvents === true && sourceIsSwf) {
          if (element && element !== event.relatedTarget && !_containedBy(event.relatedTarget, element)) {
            _fireMouseEvent(_extend({}, event, {
              type: "mouseleave",
              bubbles: false,
              cancelable: false
            }));
          }
          _fireMouseEvent(_extend({}, event, {
            type: "mouseout"
          }));
        }
        break;

       case "_mousedown":
        _addClass(element, _globalConfig.activeClass);
        if (_globalConfig.bubbleEvents === true && sourceIsSwf) {
          _fireMouseEvent(_extend({}, event, {
            type: event.type.slice(1)
          }));
        }
        break;

       case "_mouseup":
        _removeClass(element, _globalConfig.activeClass);
        if (_globalConfig.bubbleEvents === true && sourceIsSwf) {
          _fireMouseEvent(_extend({}, event, {
            type: event.type.slice(1)
          }));
        }
        break;

       case "_click":
       case "_mousemove":
        if (_globalConfig.bubbleEvents === true && sourceIsSwf) {
          _fireMouseEvent(_extend({}, event, {
            type: event.type.slice(1)
          }));
        }
        break;
      }
      if (/^_(?:click|mouse(?:over|out|down|up|move))$/.test(event.type)) {
        return true;
      }
    };
    /**
 * Dispatch a synthetic MouseEvent.
 *
 * @returns `undefined`
 * @private
 */
    var _fireMouseEvent = function(event) {
      if (!(event && typeof event.type === "string" && event)) {
        return;
      }
      var e, target = event.target || null, doc = target && target.ownerDocument || _document, defaults = {
        view: doc.defaultView || _window,
        canBubble: true,
        cancelable: true,
        detail: event.type === "click" ? 1 : 0,
        button: typeof event.which === "number" ? event.which - 1 : typeof event.button === "number" ? event.button : doc.createEvent ? 0 : 1
      }, args = _extend(defaults, event);
      if (!target) {
        return;
      }
      if (doc.createEvent && target.dispatchEvent) {
        args = [ args.type, args.canBubble, args.cancelable, args.view, args.detail, args.screenX, args.screenY, args.clientX, args.clientY, args.ctrlKey, args.altKey, args.shiftKey, args.metaKey, args.button, args.relatedTarget ];
        e = doc.createEvent("MouseEvents");
        if (e.initMouseEvent) {
          e.initMouseEvent.apply(e, args);
          e._source = "js";
          target.dispatchEvent(e);
        }
      }
    };
    /**
 * Create the HTML bridge element to embed the Flash object into.
 * @private
 */
    var _createHtmlBridge = function() {
      var container = _document.createElement("div");
      container.id = _globalConfig.containerId;
      container.className = _globalConfig.containerClass;
      container.style.position = "absolute";
      container.style.left = "0px";
      container.style.top = "-9999px";
      container.style.width = "1px";
      container.style.height = "1px";
      container.style.zIndex = "" + _getSafeZIndex(_globalConfig.zIndex);
      return container;
    };
    /**
 * Get the HTML element container that wraps the Flash bridge object/element.
 * @private
 */
    var _getHtmlBridge = function(flashBridge) {
      var htmlBridge = flashBridge && flashBridge.parentNode;
      while (htmlBridge && htmlBridge.nodeName === "OBJECT" && htmlBridge.parentNode) {
        htmlBridge = htmlBridge.parentNode;
      }
      return htmlBridge || null;
    };
    /**
 * Create the SWF object.
 *
 * @returns The SWF object reference.
 * @private
 */
    var _embedSwf = function() {
      var len, flashBridge = _flashState.bridge, container = _getHtmlBridge(flashBridge);
      if (!flashBridge) {
        var allowScriptAccess = _determineScriptAccess(_window.location.host, _globalConfig);
        var allowNetworking = allowScriptAccess === "never" ? "none" : "all";
        var flashvars = _vars(_globalConfig);
        var swfUrl = _globalConfig.swfPath + _cacheBust(_globalConfig.swfPath, _globalConfig);
        container = _createHtmlBridge();
        var divToBeReplaced = _document.createElement("div");
        container.appendChild(divToBeReplaced);
        _document.body.appendChild(container);
        var tmpDiv = _document.createElement("div");
        var oldIE = _flashState.pluginType === "activex";
        tmpDiv.innerHTML = '<object id="' + _globalConfig.swfObjectId + '" name="' + _globalConfig.swfObjectId + '" ' + 'width="100%" height="100%" ' + (oldIE ? 'classid="clsid:d27cdb6e-ae6d-11cf-96b8-444553540000"' : 'type="application/x-shockwave-flash" data="' + swfUrl + '"') + ">" + (oldIE ? '<param name="movie" value="' + swfUrl + '"/>' : "") + '<param name="allowScriptAccess" value="' + allowScriptAccess + '"/>' + '<param name="allowNetworking" value="' + allowNetworking + '"/>' + '<param name="menu" value="false"/>' + '<param name="wmode" value="transparent"/>' + '<param name="flashvars" value="' + flashvars + '"/>' + "</object>";
        flashBridge = tmpDiv.firstChild;
        tmpDiv = null;
        flashBridge.ZeroClipboard = ZeroClipboard;
        container.replaceChild(flashBridge, divToBeReplaced);
      }
      if (!flashBridge) {
        flashBridge = _document[_globalConfig.swfObjectId];
        if (flashBridge && (len = flashBridge.length)) {
          flashBridge = flashBridge[len - 1];
        }
        if (!flashBridge && container) {
          flashBridge = container.firstChild;
        }
      }
      _flashState.bridge = flashBridge || null;
      return flashBridge;
    };
    /**
 * Destroy the SWF object.
 * @private
 */
    var _unembedSwf = function() {
      var flashBridge = _flashState.bridge;
      if (flashBridge) {
        var htmlBridge = _getHtmlBridge(flashBridge);
        if (htmlBridge) {
          if (_flashState.pluginType === "activex" && "readyState" in flashBridge) {
            flashBridge.style.display = "none";
            (function removeSwfFromIE() {
              if (flashBridge.readyState === 4) {
                for (var prop in flashBridge) {
                  if (typeof flashBridge[prop] === "function") {
                    flashBridge[prop] = null;
                  }
                }
                if (flashBridge.parentNode) {
                  flashBridge.parentNode.removeChild(flashBridge);
                }
                if (htmlBridge.parentNode) {
                  htmlBridge.parentNode.removeChild(htmlBridge);
                }
              } else {
                _setTimeout(removeSwfFromIE, 10);
              }
            })();
          } else {
            if (flashBridge.parentNode) {
              flashBridge.parentNode.removeChild(flashBridge);
            }
            if (htmlBridge.parentNode) {
              htmlBridge.parentNode.removeChild(htmlBridge);
            }
          }
        }
        _flashState.ready = null;
        _flashState.bridge = null;
        _flashState.deactivated = null;
      }
    };
    /**
 * Map the data format names of the "clipData" to Flash-friendly names.
 *
 * @returns A new transformed object.
 * @private
 */
    var _mapClipDataToFlash = function(clipData) {
      var newClipData = {}, formatMap = {};
      if (!(typeof clipData === "object" && clipData)) {
        return;
      }
      for (var dataFormat in clipData) {
        if (dataFormat && _hasOwn.call(clipData, dataFormat) && typeof clipData[dataFormat] === "string" && clipData[dataFormat]) {
          switch (dataFormat.toLowerCase()) {
           case "text/plain":
           case "text":
           case "air:text":
           case "flash:text":
            newClipData.text = clipData[dataFormat];
            formatMap.text = dataFormat;
            break;

           case "text/html":
           case "html":
           case "air:html":
           case "flash:html":
            newClipData.html = clipData[dataFormat];
            formatMap.html = dataFormat;
            break;

           case "application/rtf":
           case "text/rtf":
           case "rtf":
           case "richtext":
           case "air:rtf":
           case "flash:rtf":
            newClipData.rtf = clipData[dataFormat];
            formatMap.rtf = dataFormat;
            break;

           default:
            break;
          }
        }
      }
      return {
        data: newClipData,
        formatMap: formatMap
      };
    };
    /**
 * Map the data format names from Flash-friendly names back to their original "clipData" names (via a format mapping).
 *
 * @returns A new transformed object.
 * @private
 */
    var _mapClipResultsFromFlash = function(clipResults, formatMap) {
      if (!(typeof clipResults === "object" && clipResults && typeof formatMap === "object" && formatMap)) {
        return clipResults;
      }
      var newResults = {};
      for (var prop in clipResults) {
        if (_hasOwn.call(clipResults, prop)) {
          if (prop !== "success" && prop !== "data") {
            newResults[prop] = clipResults[prop];
            continue;
          }
          newResults[prop] = {};
          var tmpHash = clipResults[prop];
          for (var dataFormat in tmpHash) {
            if (dataFormat && _hasOwn.call(tmpHash, dataFormat) && _hasOwn.call(formatMap, dataFormat)) {
              newResults[prop][formatMap[dataFormat]] = tmpHash[dataFormat];
            }
          }
        }
      }
      return newResults;
    };
    /**
 * Will look at a path, and will create a "?noCache={time}" or "&noCache={time}"
 * query param string to return. Does NOT append that string to the original path.
 * This is useful because ExternalInterface often breaks when a Flash SWF is cached.
 *
 * @returns The `noCache` query param with necessary "?"/"&" prefix.
 * @private
 */
    var _cacheBust = function(path, options) {
      var cacheBust = options == null || options && options.cacheBust === true;
      if (cacheBust) {
        return (path.indexOf("?") === -1 ? "?" : "&") + "noCache=" + _now();
      } else {
        return "";
      }
    };
    /**
 * Creates a query string for the FlashVars param.
 * Does NOT include the cache-busting query param.
 *
 * @returns FlashVars query string
 * @private
 */
    var _vars = function(options) {
      var i, len, domain, domains, str = "", trustedOriginsExpanded = [];
      if (options.trustedDomains) {
        if (typeof options.trustedDomains === "string") {
          domains = [ options.trustedDomains ];
        } else if (typeof options.trustedDomains === "object" && "length" in options.trustedDomains) {
          domains = options.trustedDomains;
        }
      }
      if (domains && domains.length) {
        for (i = 0, len = domains.length; i < len; i++) {
          if (_hasOwn.call(domains, i) && domains[i] && typeof domains[i] === "string") {
            domain = _extractDomain(domains[i]);
            if (!domain) {
              continue;
            }
            if (domain === "*") {
              trustedOriginsExpanded.length = 0;
              trustedOriginsExpanded.push(domain);
              break;
            }
            trustedOriginsExpanded.push.apply(trustedOriginsExpanded, [ domain, "//" + domain, _window.location.protocol + "//" + domain ]);
          }
        }
      }
      if (trustedOriginsExpanded.length) {
        str += "trustedOrigins=" + _encodeURIComponent(trustedOriginsExpanded.join(","));
      }
      if (options.forceEnhancedClipboard === true) {
        str += (str ? "&" : "") + "forceEnhancedClipboard=true";
      }
      if (typeof options.swfObjectId === "string" && options.swfObjectId) {
        str += (str ? "&" : "") + "swfObjectId=" + _encodeURIComponent(options.swfObjectId);
      }
      return str;
    };
    /**
 * Extract the domain (e.g. "github.com") from an origin (e.g. "https://github.com") or
 * URL (e.g. "https://github.com/zeroclipboard/zeroclipboard/").
 *
 * @returns the domain
 * @private
 */
    var _extractDomain = function(originOrUrl) {
      if (originOrUrl == null || originOrUrl === "") {
        return null;
      }
      originOrUrl = originOrUrl.replace(/^\s+|\s+$/g, "");
      if (originOrUrl === "") {
        return null;
      }
      var protocolIndex = originOrUrl.indexOf("//");
      originOrUrl = protocolIndex === -1 ? originOrUrl : originOrUrl.slice(protocolIndex + 2);
      var pathIndex = originOrUrl.indexOf("/");
      originOrUrl = pathIndex === -1 ? originOrUrl : protocolIndex === -1 || pathIndex === 0 ? null : originOrUrl.slice(0, pathIndex);
      if (originOrUrl && originOrUrl.slice(-4).toLowerCase() === ".swf") {
        return null;
      }
      return originOrUrl || null;
    };
    /**
 * Set `allowScriptAccess` based on `trustedDomains` and `window.location.host` vs. `swfPath`.
 *
 * @returns The appropriate script access level.
 * @private
 */
    var _determineScriptAccess = function() {
      var _extractAllDomains = function(origins) {
        var i, len, tmp, resultsArray = [];
        if (typeof origins === "string") {
          origins = [ origins ];
        }
        if (!(typeof origins === "object" && origins && typeof origins.length === "number")) {
          return resultsArray;
        }
        for (i = 0, len = origins.length; i < len; i++) {
          if (_hasOwn.call(origins, i) && (tmp = _extractDomain(origins[i]))) {
            if (tmp === "*") {
              resultsArray.length = 0;
              resultsArray.push("*");
              break;
            }
            if (resultsArray.indexOf(tmp) === -1) {
              resultsArray.push(tmp);
            }
          }
        }
        return resultsArray;
      };
      return function(currentDomain, configOptions) {
        var swfDomain = _extractDomain(configOptions.swfPath);
        if (swfDomain === null) {
          swfDomain = currentDomain;
        }
        var trustedDomains = _extractAllDomains(configOptions.trustedDomains);
        var len = trustedDomains.length;
        if (len > 0) {
          if (len === 1 && trustedDomains[0] === "*") {
            return "always";
          }
          if (trustedDomains.indexOf(currentDomain) !== -1) {
            if (len === 1 && currentDomain === swfDomain) {
              return "sameDomain";
            }
            return "always";
          }
        }
        return "never";
      };
    }();
    /**
 * Get the currently active/focused DOM element.
 *
 * @returns the currently active/focused element, or `null`
 * @private
 */
    var _safeActiveElement = function() {
      try {
        return _document.activeElement;
      } catch (err) {
        return null;
      }
    };
    /**
 * Add a class to an element, if it doesn't already have it.
 *
 * @returns The element, with its new class added.
 * @private
 */
    var _addClass = function(element, value) {
      if (!element || element.nodeType !== 1) {
        return element;
      }
      if (element.classList) {
        if (!element.classList.contains(value)) {
          element.classList.add(value);
        }
        return element;
      }
      if (value && typeof value === "string") {
        var classNames = (value || "").split(/\s+/);
        if (element.nodeType === 1) {
          if (!element.className) {
            element.className = value;
          } else {
            var className = " " + element.className + " ", setClass = element.className;
            for (var c = 0, cl = classNames.length; c < cl; c++) {
              if (className.indexOf(" " + classNames[c] + " ") < 0) {
                setClass += " " + classNames[c];
              }
            }
            element.className = setClass.replace(/^\s+|\s+$/g, "");
          }
        }
      }
      return element;
    };
    /**
 * Remove a class from an element, if it has it.
 *
 * @returns The element, with its class removed.
 * @private
 */
    var _removeClass = function(element, value) {
      if (!element || element.nodeType !== 1) {
        return element;
      }
      if (element.classList) {
        if (element.classList.contains(value)) {
          element.classList.remove(value);
        }
        return element;
      }
      if (typeof value === "string" && value) {
        var classNames = value.split(/\s+/);
        if (element.nodeType === 1 && element.className) {
          var className = (" " + element.className + " ").replace(/[\n\t]/g, " ");
          for (var c = 0, cl = classNames.length; c < cl; c++) {
            className = className.replace(" " + classNames[c] + " ", " ");
          }
          element.className = className.replace(/^\s+|\s+$/g, "");
        }
      }
      return element;
    };
    /**
 * Attempt to interpret the element's CSS styling. If `prop` is `"cursor"`,
 * then we assume that it should be a hand ("pointer") cursor if the element
 * is an anchor element ("a" tag).
 *
 * @returns The computed style property.
 * @private
 */
    var _getStyle = function(el, prop) {
      var value = _window.getComputedStyle(el, null).getPropertyValue(prop);
      if (prop === "cursor") {
        if (!value || value === "auto") {
          if (el.nodeName === "A") {
            return "pointer";
          }
        }
      }
      return value;
    };
    /**
 * Get the zoom factor of the browser. Always returns `1.0`, except at
 * non-default zoom levels in IE<8 and some older versions of WebKit.
 *
 * @returns Floating unit percentage of the zoom factor (e.g. 150% = `1.5`).
 * @private
 */
    var _getZoomFactor = function() {
      var rect, physicalWidth, logicalWidth, zoomFactor = 1;
      if (typeof _document.body.getBoundingClientRect === "function") {
        rect = _document.body.getBoundingClientRect();
        physicalWidth = rect.right - rect.left;
        logicalWidth = _document.body.offsetWidth;
        zoomFactor = _round(physicalWidth / logicalWidth * 100) / 100;
      }
      return zoomFactor;
    };
    /**
 * Get the DOM positioning info of an element.
 *
 * @returns Object containing the element's position, width, and height.
 * @private
 */
    var _getDOMObjectPosition = function(obj) {
      var info = {
        left: 0,
        top: 0,
        width: 0,
        height: 0
      };
      if (obj.getBoundingClientRect) {
        var rect = obj.getBoundingClientRect();
        var pageXOffset, pageYOffset, zoomFactor;
        if ("pageXOffset" in _window && "pageYOffset" in _window) {
          pageXOffset = _window.pageXOffset;
          pageYOffset = _window.pageYOffset;
        } else {
          zoomFactor = _getZoomFactor();
          pageXOffset = _round(_document.documentElement.scrollLeft / zoomFactor);
          pageYOffset = _round(_document.documentElement.scrollTop / zoomFactor);
        }
        var leftBorderWidth = _document.documentElement.clientLeft || 0;
        var topBorderWidth = _document.documentElement.clientTop || 0;
        info.left = rect.left + pageXOffset - leftBorderWidth;
        info.top = rect.top + pageYOffset - topBorderWidth;
        info.width = "width" in rect ? rect.width : rect.right - rect.left;
        info.height = "height" in rect ? rect.height : rect.bottom - rect.top;
      }
      return info;
    };
    /**
 * Reposition the Flash object to cover the currently activated element.
 *
 * @returns `undefined`
 * @private
 */
    var _reposition = function() {
      var htmlBridge;
      if (_currentElement && (htmlBridge = _getHtmlBridge(_flashState.bridge))) {
        var pos = _getDOMObjectPosition(_currentElement);
        _extend(htmlBridge.style, {
          width: pos.width + "px",
          height: pos.height + "px",
          top: pos.top + "px",
          left: pos.left + "px",
          zIndex: "" + _getSafeZIndex(_globalConfig.zIndex)
        });
      }
    };
    /**
 * Sends a signal to the Flash object to display the hand cursor if `true`.
 *
 * @returns `undefined`
 * @private
 */
    var _setHandCursor = function(enabled) {
      if (_flashState.ready === true) {
        if (_flashState.bridge && typeof _flashState.bridge.setHandCursor === "function") {
          _flashState.bridge.setHandCursor(enabled);
        } else {
          _flashState.ready = false;
        }
      }
    };
    /**
 * Get a safe value for `zIndex`
 *
 * @returns an integer, or "auto"
 * @private
 */
    var _getSafeZIndex = function(val) {
      if (/^(?:auto|inherit)$/.test(val)) {
        return val;
      }
      var zIndex;
      if (typeof val === "number" && !_isNaN(val)) {
        zIndex = val;
      } else if (typeof val === "string") {
        zIndex = _getSafeZIndex(_parseInt(val, 10));
      }
      return typeof zIndex === "number" ? zIndex : "auto";
    };
    /**
 * Detect the Flash Player status, version, and plugin type.
 *
 * @see {@link https://code.google.com/p/doctype-mirror/wiki/ArticleDetectFlash#The_code}
 * @see {@link http://stackoverflow.com/questions/12866060/detecting-pepper-ppapi-flash-with-javascript}
 *
 * @returns `undefined`
 * @private
 */
    var _detectFlashSupport = function(ActiveXObject) {
      var plugin, ax, mimeType, hasFlash = false, isActiveX = false, isPPAPI = false, flashVersion = "";
      /**
   * Derived from Apple's suggested sniffer.
   * @param {String} desc e.g. "Shockwave Flash 7.0 r61"
   * @returns {String} "7.0.61"
   * @private
   */
      function parseFlashVersion(desc) {
        var matches = desc.match(/[\d]+/g);
        matches.length = 3;
        return matches.join(".");
      }
      function isPepperFlash(flashPlayerFileName) {
        return !!flashPlayerFileName && (flashPlayerFileName = flashPlayerFileName.toLowerCase()) && (/^(pepflashplayer\.dll|libpepflashplayer\.so|pepperflashplayer\.plugin)$/.test(flashPlayerFileName) || flashPlayerFileName.slice(-13) === "chrome.plugin");
      }
      function inspectPlugin(plugin) {
        if (plugin) {
          hasFlash = true;
          if (plugin.version) {
            flashVersion = parseFlashVersion(plugin.version);
          }
          if (!flashVersion && plugin.description) {
            flashVersion = parseFlashVersion(plugin.description);
          }
          if (plugin.filename) {
            isPPAPI = isPepperFlash(plugin.filename);
          }
        }
      }
      if (_navigator.plugins && _navigator.plugins.length) {
        plugin = _navigator.plugins["Shockwave Flash"];
        inspectPlugin(plugin);
        if (_navigator.plugins["Shockwave Flash 2.0"]) {
          hasFlash = true;
          flashVersion = "2.0.0.11";
        }
      } else if (_navigator.mimeTypes && _navigator.mimeTypes.length) {
        mimeType = _navigator.mimeTypes["application/x-shockwave-flash"];
        plugin = mimeType && mimeType.enabledPlugin;
        inspectPlugin(plugin);
      } else if (typeof ActiveXObject !== "undefined") {
        isActiveX = true;
        try {
          ax = new ActiveXObject("ShockwaveFlash.ShockwaveFlash.7");
          hasFlash = true;
          flashVersion = parseFlashVersion(ax.GetVariable("$version"));
        } catch (e1) {
          try {
            ax = new ActiveXObject("ShockwaveFlash.ShockwaveFlash.6");
            hasFlash = true;
            flashVersion = "6.0.21";
          } catch (e2) {
            try {
              ax = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
              hasFlash = true;
              flashVersion = parseFlashVersion(ax.GetVariable("$version"));
            } catch (e3) {
              isActiveX = false;
            }
          }
        }
      }
      _flashState.disabled = hasFlash !== true;
      _flashState.outdated = flashVersion && _parseFloat(flashVersion) < _parseFloat(_minimumFlashVersion);
      _flashState.version = flashVersion || "0.0.0";
      _flashState.pluginType = isPPAPI ? "pepper" : isActiveX ? "activex" : hasFlash ? "netscape" : "unknown";
    };
    /**
 * Invoke the Flash detection algorithms immediately upon inclusion so we're not waiting later.
 */
    _detectFlashSupport(_ActiveXObject);
    /**
 * A shell constructor for `ZeroClipboard` client instances.
 *
 * @constructor
 */
    var ZeroClipboard = function() {
      if (!(this instanceof ZeroClipboard)) {
        return new ZeroClipboard();
      }
      if (typeof ZeroClipboard._createClient === "function") {
        ZeroClipboard._createClient.apply(this, _args(arguments));
      }
    };
    /**
 * The ZeroClipboard library's version number.
 *
 * @static
 * @readonly
 * @property {string}
 */
    _defineProperty(ZeroClipboard, "version", {
      value: "2.1.2",
      writable: false,
      configurable: true,
      enumerable: true
    });
    /**
 * Update or get a copy of the ZeroClipboard global configuration.
 * Returns a copy of the current/updated configuration.
 *
 * @returns Object
 * @static
 */
    ZeroClipboard.config = function() {
      return _config.apply(this, _args(arguments));
    };
    /**
 * Diagnostic method that describes the state of the browser, Flash Player, and ZeroClipboard.
 *
 * @returns Object
 * @static
 */
    ZeroClipboard.state = function() {
      return _state.apply(this, _args(arguments));
    };
    /**
 * Check if Flash is unusable for any reason: disabled, outdated, deactivated, etc.
 *
 * @returns Boolean
 * @static
 */
    ZeroClipboard.isFlashUnusable = function() {
      return _isFlashUnusable.apply(this, _args(arguments));
    };
    /**
 * Register an event listener.
 *
 * @returns `ZeroClipboard`
 * @static
 */
    ZeroClipboard.on = function() {
      return _on.apply(this, _args(arguments));
    };
    /**
 * Unregister an event listener.
 * If no `listener` function/object is provided, it will unregister all listeners for the provided `eventType`.
 * If no `eventType` is provided, it will unregister all listeners for every event type.
 *
 * @returns `ZeroClipboard`
 * @static
 */
    ZeroClipboard.off = function() {
      return _off.apply(this, _args(arguments));
    };
    /**
 * Retrieve event listeners for an `eventType`.
 * If no `eventType` is provided, it will retrieve all listeners for every event type.
 *
 * @returns array of listeners for the `eventType`; if no `eventType`, then a map/hash object of listeners for all event types; or `null`
 */
    ZeroClipboard.handlers = function() {
      return _listeners.apply(this, _args(arguments));
    };
    /**
 * Event emission receiver from the Flash object, forwarding to any registered JavaScript event listeners.
 *
 * @returns For the "copy" event, returns the Flash-friendly "clipData" object; otherwise `undefined`.
 * @static
 */
    ZeroClipboard.emit = function() {
      return _emit.apply(this, _args(arguments));
    };
    /**
 * Create and embed the Flash object.
 *
 * @returns The Flash object
 * @static
 */
    ZeroClipboard.create = function() {
      return _create.apply(this, _args(arguments));
    };
    /**
 * Self-destruct and clean up everything, including the embedded Flash object.
 *
 * @returns `undefined`
 * @static
 */
    ZeroClipboard.destroy = function() {
      return _destroy.apply(this, _args(arguments));
    };
    /**
 * Set the pending data for clipboard injection.
 *
 * @returns `undefined`
 * @static
 */
    ZeroClipboard.setData = function() {
      return _setData.apply(this, _args(arguments));
    };
    /**
 * Clear the pending data for clipboard injection.
 * If no `format` is provided, all pending data formats will be cleared.
 *
 * @returns `undefined`
 * @static
 */
    ZeroClipboard.clearData = function() {
      return _clearData.apply(this, _args(arguments));
    };
    /**
 * Get a copy of the pending data for clipboard injection.
 * If no `format` is provided, a copy of ALL pending data formats will be returned.
 *
 * @returns `String` or `Object`
 * @static
 */
    ZeroClipboard.getData = function() {
      return _getData.apply(this, _args(arguments));
    };
    /**
 * Sets the current HTML object that the Flash object should overlay. This will put the global
 * Flash object on top of the current element; depending on the setup, this may also set the
 * pending clipboard text data as well as the Flash object's wrapping element's title attribute
 * based on the underlying HTML element and ZeroClipboard configuration.
 *
 * @returns `undefined`
 * @static
 */
    ZeroClipboard.focus = ZeroClipboard.activate = function() {
      return _focus.apply(this, _args(arguments));
    };
    /**
 * Un-overlays the Flash object. This will put the global Flash object off-screen; depending on
 * the setup, this may also unset the Flash object's wrapping element's title attribute based on
 * the underlying HTML element and ZeroClipboard configuration.
 *
 * @returns `undefined`
 * @static
 */
    ZeroClipboard.blur = ZeroClipboard.deactivate = function() {
      return _blur.apply(this, _args(arguments));
    };
    /**
 * Returns the currently focused/"activated" HTML element that the Flash object is wrapping.
 *
 * @returns `HTMLElement` or `null`
 * @static
 */
    ZeroClipboard.activeElement = function() {
      return _activeElement.apply(this, _args(arguments));
    };
    if (typeof define === "function" && define.amd) {
      define(function() {
        return ZeroClipboard;
      });
    } else if (typeof module === "object" && module && typeof module.exports === "object" && module.exports) {
      module.exports = ZeroClipboard;
    } else {
      window.ZeroClipboard = ZeroClipboard;
    }
  })(function() {
    return this || window;
  }());
  (function($, window, undefined) {
    var mouseEnterBindingCount = 0, customEventNamespace = ".zeroclipboard", ZeroClipboard = window.ZeroClipboard, _trustedDomains = ZeroClipboard.config("trustedDomains");
    function getSelectionData() {
      var range, selectedText = "", selectedData = {}, sel = window.getSelection(), tmp = document.createElement("div");
      for (var i = 0, len = sel.rangeCount; i < len; i++) {
        range = sel.getRangeAt(i);
        selectedText += range.toString();
        tmp.appendChild(range.cloneContents());
      }
      selectedData["text/plain"] = selectedText;
      if (selectedText.replace(/\s/g, "")) {
        selectedData["text/html"] = tmp.innerHTML;
      }
      return selectedData;
    }
    function convertHtmlToRtf(html) {
      if (!(typeof html === "string" && html)) {
        return null;
      }
      var tmpRichText, hasHyperlinks, richText = html;
      richText = richText.replace(/<(?:hr)(?:\s+[^>]*)?\s*[\/]?>/gi, "{\\pard \\brdrb \\brdrs \\brdrw10 \\brsp20 \\par}\n{\\pard\\par}\n");
      richText = richText.replace(/<(?:br)(?:\s+[^>]*)?\s*[\/]?>/gi, "{\\pard\\par}\n");
      richText = richText.replace(/<(?:p|div|section|article)(?:\s+[^>]*)?\s*[\/]>/gi, "{\\pard\\par}\n");
      richText = richText.replace(/<(?:[^>]+)\/>/g, "");
      richText = richText.replace(/<a(?:\s+[^>]*)?(?:\s+href=(["'])(?:javascript:void\(0?\);?|#|return false;?|void\(0?\);?|)\1)(?:\s+[^>]*)?>/gi, "{{{\n");
      tmpRichText = richText;
      richText = richText.replace(/<a(?:\s+[^>]*)?(?:\s+href=(["'])(.+)\1)(?:\s+[^>]*)?>/gi, '{\\field{\\*\\fldinst{HYPERLINK\n "$2"\n}}{\\fldrslt{\\ul\\cf1\n');
      hasHyperlinks = richText !== tmpRichText;
      richText = richText.replace(/<a(?:\s+[^>]*)?>/gi, "{{{\n");
      richText = richText.replace(/<\/a(?:\s+[^>]*)?>/gi, "\n}}}");
      richText = richText.replace(/<(?:b|strong)(?:\s+[^>]*)?>/gi, "{\\b\n");
      richText = richText.replace(/<(?:i|em)(?:\s+[^>]*)?>/gi, "{\\i\n");
      richText = richText.replace(/<(?:u|ins)(?:\s+[^>]*)?>/gi, "{\\ul\n");
      richText = richText.replace(/<(?:strike|del)(?:\s+[^>]*)?>/gi, "{\\strike\n");
      richText = richText.replace(/<sup(?:\s+[^>]*)?>/gi, "{\\super\n");
      richText = richText.replace(/<sub(?:\s+[^>]*)?>/gi, "{\\sub\n");
      richText = richText.replace(/<(?:p|div|section|article)(?:\s+[^>]*)?>/gi, "{\\pard\n");
      richText = richText.replace(/<\/(?:p|div|section|article)(?:\s+[^>]*)?>/gi, "\n\\par}\n");
      richText = richText.replace(/<\/(?:b|strong|i|em|u|ins|strike|del|sup|sub)(?:\s+[^>]*)?>/gi, "\n}");
      richText = richText.replace(/<(?:[^>]+)>/g, "");
      richText = "{\\rtf1\\ansi\n" + (hasHyperlinks ? "{\\colortbl\n;\n\\red0\\green0\\blue255;\n}\n" : "") + richText + "\n}";
      return richText;
    }
    function zcEventHandler(e) {
      var $event = $.Event(e.type, $.extend(e, {
        _source: "swf"
      }));
      $(e.target).trigger($event);
      if ($event.type === "copy") {
        if ($.event.special.copy.options.requirePreventDefault === true && !$event.isDefaultPrevented()) {
          e.clipboardData.clearData();
          var selectionData = getSelectionData();
          if (selectionData["text/plain"] || selectionData["text/html"]) {
            e.clipboardData.setData(selectionData);
          }
        }
        var _clipData = ZeroClipboard.getData();
        if ($.event.special.copy.options.autoConvertHtmlToRtf === true && _clipData["text/html"] && !_clipData["application/rtf"]) {
          var richText = convertHtmlToRtf(_clipData["text/html"]);
          e.clipboardData.setData("application/rtf", richText);
        }
      }
    }
    function zcErrorHandler(e) {
      var $event = $.Event("copy-error", $.extend(e, {
        type: "copy-error",
        _source: "swf"
      }));
      $(e.target).trigger($event);
    }
    function setup() {
      $.event.props.push("clipboardData");
      ZeroClipboard.config($.extend(true, {
        autoActivate: false
      }, copyEventDef.options));
      ZeroClipboard.on("beforecopy copy aftercopy", zcEventHandler);
      ZeroClipboard.on("error", zcErrorHandler);
      ZeroClipboard.create();
    }
    function teardown() {
      ZeroClipboard.destroy();
      var indy = $.event.props.indexOf("clipboardData");
      if (indy !== -1) {
        $.event.props.splice(indy, 1);
      }
    }
    function mouseEnterHandler($event) {
      mouseSuppressor($event);
      if ($event.target && $event.target !== ZeroClipboard.activeElement() && $event.target !== $("#" + ZeroClipboard.config("containerId"))[0] && $event.target !== $("#" + ZeroClipboard.config("swfObjectId"))[0]) {
        ZeroClipboard.focus($event.target);
      }
    }
    function mouseLeaveHandler($event) {
      mouseSuppressor($event);
      if ($event.relatedTarget && $event.relatedTarget !== ZeroClipboard.activeElement() && $event.relatedTarget !== $("#" + ZeroClipboard.config("containerId"))[0] && $event.relatedTarget !== $("#" + ZeroClipboard.config("swfObjectId"))[0]) {
        ZeroClipboard.blur();
      }
    }
    function mouseSuppressor($event) {
      if (!ZeroClipboard.isFlashUnusable() && $event.originalEvent._source !== "js") {
        $event.stopImmediatePropagation();
        $event.preventDefault();
      }
    }
    var copyEventDef = {
      add: function(handleObj) {
        if (0 === mouseEnterBindingCount++) {
          setup();
        }
        var namespaces = customEventNamespace + (handleObj.namespace ? "." + handleObj.namespace : ""), selector = handleObj.selector, zcDataKey = "zc|{" + selector + "}|{" + namespaces + "}|count", $this = $(this);
        if (typeof $this.data(zcDataKey) !== "number") {
          $this.data(zcDataKey, 0);
        }
        if ($this.data(zcDataKey) === 0) {
          $this.on("mouseenter" + namespaces, selector, mouseEnterHandler);
          $this.on("mouseleave" + namespaces, selector, mouseLeaveHandler);
          $this.on("mouseover" + namespaces, selector, mouseSuppressor);
          $this.on("mouseout" + namespaces, selector, mouseSuppressor);
          $this.on("mousemove" + namespaces, selector, mouseSuppressor);
          $this.on("mousedown" + namespaces, selector, mouseSuppressor);
          $this.on("mouseup" + namespaces, selector, mouseSuppressor);
          $this.on("click" + namespaces, selector, mouseSuppressor);
        }
        $this.data(zcDataKey, $this.data(zcDataKey) + 1);
      },
      remove: function(handleObj) {
        var namespaces = customEventNamespace + (handleObj.namespace ? "." + handleObj.namespace : ""), selector = handleObj.selector, zcDataKey = "zc|{" + selector + "}|{" + namespaces + "}|count", $this = $(this);
        $this.data(zcDataKey, $this.data(zcDataKey) - 1);
        if ($this.data(zcDataKey) === 0) {
          $this.off("click" + namespaces, selector, mouseSuppressor);
          $this.off("mouseup" + namespaces, selector, mouseSuppressor);
          $this.off("mousedown" + namespaces, selector, mouseSuppressor);
          $this.off("mousemove" + namespaces, selector, mouseSuppressor);
          $this.off("mouseout" + namespaces, selector, mouseSuppressor);
          $this.off("mouseover" + namespaces, selector, mouseSuppressor);
          $this.off("mouseleave" + namespaces, selector, mouseLeaveHandler);
          $this.off("mouseenter" + namespaces, selector, mouseEnterHandler);
          $this.removeData(zcDataKey);
        }
        if (0 === --mouseEnterBindingCount) {
          teardown();
        }
      },
      trigger: function($event) {
        if ($event.type === "copy") {
          var $this = $(this);
          var sourceIsSwf = $event._source === "swf";
          delete $event._source;
          if (!sourceIsSwf) {
            $this.trigger($.extend(true, {}, $event, {
              type: "beforecopy"
            }));
            $this.one("copy", function() {
              var successData = {}, _clipData = ZeroClipboard.getData();
              $.each(_clipData, function(key) {
                successData[key] = false;
              });
              var $e = $.extend(true, {}, $event, {
                type: "aftercopy",
                data: $.extend(true, {}, _clipData),
                success: successData
              });
              $this.trigger($e);
            });
          }
        }
      },
      _default: function() {
        return true;
      },
      options: {
        requirePreventDefault: true,
        autoConvertHtmlToRtf: true,
        trustedDomains: _trustedDomains,
        hoverClass: "hover",
        activeClass: "active"
      }
    };
    $.event.special.beforecopy = copyEventDef;
    $.event.special.copy = copyEventDef;
    $.event.special.aftercopy = copyEventDef;
    $.event.special["copy-error"] = copyEventDef;
  })(jQuery, function() {
    return this || window;
  }());
  if (!zcExistsAlready) {
    delete window.ZeroClipboard;
  }
})(jQuery, function() {
  return this || window;
}());
/* -------- common/js/bootstrap-colorpicker/2.0.0/dist/js/bootstrap-colorpicker.js -------- */
/*!
 * Bootstrap Colorpicker
 * http://mjolnic.github.io/bootstrap-colorpicker/
 *
 * Originally written by (c) 2012 Stefan Petre
 * Licensed under the Apache License v2.0
 * http://www.apache.org/licenses/LICENSE-2.0.txt
 *
 * @todo Update DOCS
 */

(function(factory) {
        "use strict";
        if (typeof define === 'function' && define.amd) {
            define(['jquery'], factory);
        } else if (window.jQuery && !window.jQuery.fn.colorpicker) {
            factory(window.jQuery);
        }
    }
    (function($) {
        'use strict';

        // Color object
        var Color = function(val) {
            this.value = {
                h: 0,
                s: 0,
                b: 0,
                a: 1
            };
            this.origFormat = null; // original string format
            if (val) {
                if (val.toLowerCase !== undefined) {
                    this.setColor(val);
                } else if (val.h !== undefined) {
                    this.value = val;
                }
            }
        };

        Color.prototype = {
            constructor: Color,
            // 140 predefined colors from the HTML Colors spec
            colors: {
                "aliceblue": "#f0f8ff",
                "antiquewhite": "#faebd7",
                "aqua": "#00ffff",
                "aquamarine": "#7fffd4",
                "azure": "#f0ffff",
                "beige": "#f5f5dc",
                "bisque": "#ffe4c4",
                "black": "#000000",
                "blanchedalmond": "#ffebcd",
                "blue": "#0000ff",
                "blueviolet": "#8a2be2",
                "brown": "#a52a2a",
                "burlywood": "#deb887",
                "cadetblue": "#5f9ea0",
                "chartreuse": "#7fff00",
                "chocolate": "#d2691e",
                "coral": "#ff7f50",
                "cornflowerblue": "#6495ed",
                "cornsilk": "#fff8dc",
                "crimson": "#dc143c",
                "cyan": "#00ffff",
                "darkblue": "#00008b",
                "darkcyan": "#008b8b",
                "darkgoldenrod": "#b8860b",
                "darkgray": "#a9a9a9",
                "darkgreen": "#006400",
                "darkkhaki": "#bdb76b",
                "darkmagenta": "#8b008b",
                "darkolivegreen": "#556b2f",
                "darkorange": "#ff8c00",
                "darkorchid": "#9932cc",
                "darkred": "#8b0000",
                "darksalmon": "#e9967a",
                "darkseagreen": "#8fbc8f",
                "darkslateblue": "#483d8b",
                "darkslategray": "#2f4f4f",
                "darkturquoise": "#00ced1",
                "darkviolet": "#9400d3",
                "deeppink": "#ff1493",
                "deepskyblue": "#00bfff",
                "dimgray": "#696969",
                "dodgerblue": "#1e90ff",
                "firebrick": "#b22222",
                "floralwhite": "#fffaf0",
                "forestgreen": "#228b22",
                "fuchsia": "#ff00ff",
                "gainsboro": "#dcdcdc",
                "ghostwhite": "#f8f8ff",
                "gold": "#ffd700",
                "goldenrod": "#daa520",
                "gray": "#808080",
                "green": "#008000",
                "greenyellow": "#adff2f",
                "honeydew": "#f0fff0",
                "hotpink": "#ff69b4",
                "indianred ": "#cd5c5c",
                "indigo ": "#4b0082",
                "ivory": "#fffff0",
                "khaki": "#f0e68c",
                "lavender": "#e6e6fa",
                "lavenderblush": "#fff0f5",
                "lawngreen": "#7cfc00",
                "lemonchiffon": "#fffacd",
                "lightblue": "#add8e6",
                "lightcoral": "#f08080",
                "lightcyan": "#e0ffff",
                "lightgoldenrodyellow": "#fafad2",
                "lightgrey": "#d3d3d3",
                "lightgreen": "#90ee90",
                "lightpink": "#ffb6c1",
                "lightsalmon": "#ffa07a",
                "lightseagreen": "#20b2aa",
                "lightskyblue": "#87cefa",
                "lightslategray": "#778899",
                "lightsteelblue": "#b0c4de",
                "lightyellow": "#ffffe0",
                "lime": "#00ff00",
                "limegreen": "#32cd32",
                "linen": "#faf0e6",
                "magenta": "#ff00ff",
                "maroon": "#800000",
                "mediumaquamarine": "#66cdaa",
                "mediumblue": "#0000cd",
                "mediumorchid": "#ba55d3",
                "mediumpurple": "#9370d8",
                "mediumseagreen": "#3cb371",
                "mediumslateblue": "#7b68ee",
                "mediumspringgreen": "#00fa9a",
                "mediumturquoise": "#48d1cc",
                "mediumvioletred": "#c71585",
                "midnightblue": "#191970",
                "mintcream": "#f5fffa",
                "mistyrose": "#ffe4e1",
                "moccasin": "#ffe4b5",
                "navajowhite": "#ffdead",
                "navy": "#000080",
                "oldlace": "#fdf5e6",
                "olive": "#808000",
                "olivedrab": "#6b8e23",
                "orange": "#ffa500",
                "orangered": "#ff4500",
                "orchid": "#da70d6",
                "palegoldenrod": "#eee8aa",
                "palegreen": "#98fb98",
                "paleturquoise": "#afeeee",
                "palevioletred": "#d87093",
                "papayawhip": "#ffefd5",
                "peachpuff": "#ffdab9",
                "peru": "#cd853f",
                "pink": "#ffc0cb",
                "plum": "#dda0dd",
                "powderblue": "#b0e0e6",
                "purple": "#800080",
                "red": "#ff0000",
                "rosybrown": "#bc8f8f",
                "royalblue": "#4169e1",
                "saddlebrown": "#8b4513",
                "salmon": "#fa8072",
                "sandybrown": "#f4a460",
                "seagreen": "#2e8b57",
                "seashell": "#fff5ee",
                "sienna": "#a0522d",
                "silver": "#c0c0c0",
                "skyblue": "#87ceeb",
                "slateblue": "#6a5acd",
                "slategray": "#708090",
                "snow": "#fffafa",
                "springgreen": "#00ff7f",
                "steelblue": "#4682b4",
                "tan": "#d2b48c",
                "teal": "#008080",
                "thistle": "#d8bfd8",
                "tomato": "#ff6347",
                "turquoise": "#40e0d0",
                "violet": "#ee82ee",
                "wheat": "#f5deb3",
                "white": "#ffffff",
                "whitesmoke": "#f5f5f5",
                "yellow": "#ffff00",
                "yellowgreen": "#9acd32"
            },
            _sanitizeNumber: function(val) {
                if (typeof val === 'number') {
                    return val;
                }
                if (isNaN(val) || (val === null) || (val === '') || (val === undefined)) {
                    return 1;
                }
                if (val.toLowerCase !== undefined) {
                    return parseFloat(val);
                }
                return 1;
            },
            //parse a string to HSB
            setColor: function(strVal) {
                strVal = strVal.toLowerCase();
                this.value = this.stringToHSB(strVal) || {
                    h: 0,
                    s: 0,
                    b: 0,
                    a: 1
                };
            },
            stringToHSB: function(strVal) {
                strVal = strVal.toLowerCase();
                var that = this,
                    result = false;
                $.each(this.stringParsers, function(i, parser) {
                    var match = parser.re.exec(strVal),
                        values = match && parser.parse.apply(that, [match]),
                        format = parser.format || 'rgba';
                    if (values) {
                        if (format.match(/hsla?/)) {
                            result = that.RGBtoHSB.apply(that, that.HSLtoRGB.apply(that, values));
                        } else {
                            result = that.RGBtoHSB.apply(that, values);
                        }
                        that.origFormat = format;
                        return false;
                    }
                    return true;
                });
                return result;
            },
            setHue: function(h) {
                this.value.h = 1 - h;
            },
            setSaturation: function(s) {
                this.value.s = s;
            },
            setBrightness: function(b) {
                this.value.b = 1 - b;
            },
            setAlpha: function(a) {
                this.value.a = parseInt((1 - a) * 100, 10) / 100;
            },
            toRGB: function(h, s, b, a) {
                if (!h) {
                    h = this.value.h;
                    s = this.value.s;
                    b = this.value.b;
                }
                h *= 360;
                var R, G, B, X, C;
                h = (h % 360) / 60;
                C = b * s;
                X = C * (1 - Math.abs(h % 2 - 1));
                R = G = B = b - C;

                h = ~~h;
                R += [C, X, 0, 0, X, C][h];
                G += [X, C, C, X, 0, 0][h];
                B += [0, 0, X, C, C, X][h];
                return {
                    r: Math.round(R * 255),
                    g: Math.round(G * 255),
                    b: Math.round(B * 255),
                    a: a || this.value.a
                };
            },
            toHex: function(h, s, b, a) {
                var rgb = this.toRGB(h, s, b, a);
                return '#' + ((1 << 24) | (parseInt(rgb.r) << 16) | (parseInt(rgb.g) << 8) | parseInt(rgb.b)).toString(16).substr(1);
            },
            toHSL: function(h, s, b, a) {
                h = h || this.value.h;
                s = s || this.value.s;
                b = b || this.value.b;
                a = a || this.value.a;

                var H = h,
                    L = (2 - s) * b,
                    S = s * b;
                if (L > 0 && L <= 1) {
                    S /= L;
                } else {
                    S /= 2 - L;
                }
                L /= 2;
                if (S > 1) {
                    S = 1;
                }
                return {
                    h: isNaN(H) ? 0 : H,
                    s: isNaN(S) ? 0 : S,
                    l: isNaN(L) ? 0 : L,
                    a: isNaN(a) ? 0 : a
                };
            },
            toAlias: function(r, g, b, a) {
                var rgb = this.toHex(r, g, b, a);
                for (var alias in this.colors) {
                    if (this.colors[alias] == rgb) {
                        return alias;
                    }
                }
                return false;
            },
            RGBtoHSB: function(r, g, b, a) {
                r /= 255;
                g /= 255;
                b /= 255;

                var H, S, V, C;
                V = Math.max(r, g, b);
                C = V - Math.min(r, g, b);
                H = (C === 0 ? null :
                    V === r ? (g - b) / C :
                    V === g ? (b - r) / C + 2 :
                    (r - g) / C + 4
                );
                H = ((H + 360) % 6) * 60 / 360;
                S = C === 0 ? 0 : C / V;
                return {
                    h: this._sanitizeNumber(H),
                    s: S,
                    b: V,
                    a: this._sanitizeNumber(a)
                };
            },
            HueToRGB: function(p, q, h) {
                if (h < 0) {
                    h += 1;
                } else if (h > 1) {
                    h -= 1;
                }
                if ((h * 6) < 1) {
                    return p + (q - p) * h * 6;
                } else if ((h * 2) < 1) {
                    return q;
                } else if ((h * 3) < 2) {
                    return p + (q - p) * ((2 / 3) - h) * 6;
                } else {
                    return p;
                }
            },
            HSLtoRGB: function(h, s, l, a) {
                if (s < 0) {
                    s = 0;
                }
                var q;
                if (l <= 0.5) {
                    q = l * (1 + s);
                } else {
                    q = l + s - (l * s);
                }

                var p = 2 * l - q;

                var tr = h + (1 / 3);
                var tg = h;
                var tb = h - (1 / 3);

                var r = Math.round(this.HueToRGB(p, q, tr) * 255);
                var g = Math.round(this.HueToRGB(p, q, tg) * 255);
                var b = Math.round(this.HueToRGB(p, q, tb) * 255);
                return [r, g, b, this._sanitizeNumber(a)];
            },
            toString: function(format) {
                format = format || 'rgba';
                switch (format) {
                    case 'rgb':
                        {
                            var rgb = this.toRGB();
                            return 'rgb(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ')';
                        }
                        break;
                    case 'rgba':
                        {
                            var rgb = this.toRGB();
                            return 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')';
                        }
                        break;
                    case 'hsl':
                        {
                            var hsl = this.toHSL();
                            return 'hsl(' + Math.round(hsl.h * 360) + ',' + Math.round(hsl.s * 100) + '%,' + Math.round(hsl.l * 100) + '%)';
                        }
                        break;
                    case 'hsla':
                        {
                            var hsl = this.toHSL();
                            return 'hsla(' + Math.round(hsl.h * 360) + ',' + Math.round(hsl.s * 100) + '%,' + Math.round(hsl.l * 100) + '%,' + hsl.a + ')';
                        }
                        break;
                    case 'hex':
                        {
                            return this.toHex();
                        }
                        break;
                    case 'alias':
                        return this.toAlias() || this.toHex();
                    default:
                        {
                            return false;
                        }
                        break;
                }
            },
            // a set of RE's that can match strings and generate color tuples.
            // from John Resig color plugin
            // https://github.com/jquery/jquery-color/
            stringParsers: [{
                re: /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,
                format: 'hex',
                parse: function(execResult) {
                    return [
                        parseInt(execResult[1], 16),
                        parseInt(execResult[2], 16),
                        parseInt(execResult[3], 16),
                        1
                    ];
                }
            }, {
                re: /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/,
                format: 'hex',
                parse: function(execResult) {
                    return [
                        parseInt(execResult[1] + execResult[1], 16),
                        parseInt(execResult[2] + execResult[2], 16),
                        parseInt(execResult[3] + execResult[3], 16),
                        1
                    ];
                }
            }, {
                re: /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*?\)/,
                format: 'rgb',
                parse: function(execResult) {
                    return [
                        execResult[1],
                        execResult[2],
                        execResult[3],
                        1
                    ];
                }
            }, {
                re: /rgb\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*?\)/,
                format: 'rgb',
                parse: function(execResult) {
                    return [
                        2.55 * execResult[1],
                        2.55 * execResult[2],
                        2.55 * execResult[3],
                        1
                    ];
                }
            }, {
                re: /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
                format: 'rgba',
                parse: function(execResult) {
                    return [
                        execResult[1],
                        execResult[2],
                        execResult[3],
                        execResult[4]
                    ];
                }
            }, {
                re: /rgba\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
                format: 'rgba',
                parse: function(execResult) {
                    return [
                        2.55 * execResult[1],
                        2.55 * execResult[2],
                        2.55 * execResult[3],
                        execResult[4]
                    ];
                }
            }, {
                re: /hsl\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*?\)/,
                format: 'hsl',
                parse: function(execResult) {
                    return [
                        execResult[1] / 360,
                        execResult[2] / 100,
                        execResult[3] / 100,
                        execResult[4]
                    ];
                }
            }, {
                re: /hsla\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
                format: 'hsla',
                parse: function(execResult) {
                    return [
                        execResult[1] / 360,
                        execResult[2] / 100,
                        execResult[3] / 100,
                        execResult[4]
                    ];
                }
            }, {
                //predefined color name
                re: /^([a-z]{3,})$/,
                format: 'alias',
                parse: function(execResult) {
                    var hexval = this.colorNameToHex(execResult[0]) || '#000000';
                    var match = this.stringParsers[0].re.exec(hexval),
                        values = match && this.stringParsers[0].parse.apply(this, [match]);
                    return values;
                }
            }],
            colorNameToHex: function(name) {
                if (typeof this.colors[name.toLowerCase()] !== 'undefined') {
                    return this.colors[name.toLowerCase()];
                }
                return false;
            }
        };


        var defaults = {
            horizontal: false, // horizontal mode layout ?
            inline: false, //forces to show the colorpicker as an inline element
            color: false, //forces a color
            format: false, //forces a format
            input: 'input', // children input selector
            container: false, // container selector
            component: '.add-on, .input-group-addon', // children component selector
            sliders: {
                saturation: {
                    maxLeft: 100,
                    maxTop: 100,
                    callLeft: 'setSaturation',
                    callTop: 'setBrightness'
                },
                hue: {
                    maxLeft: 0,
                    maxTop: 100,
                    callLeft: false,
                    callTop: 'setHue'
                },
                alpha: {
                    maxLeft: 0,
                    maxTop: 100,
                    callLeft: false,
                    callTop: 'setAlpha'
                }
            },
            slidersHorz: {
                saturation: {
                    maxLeft: 100,
                    maxTop: 100,
                    callLeft: 'setSaturation',
                    callTop: 'setBrightness'
                },
                hue: {
                    maxLeft: 100,
                    maxTop: 0,
                    callLeft: 'setHue',
                    callTop: false
                },
                alpha: {
                    maxLeft: 100,
                    maxTop: 0,
                    callLeft: 'setAlpha',
                    callTop: false
                }
            },
            template: '<div class="colorpicker dropdown-menu">' +
                '<div class="colorpicker-saturation"><i><b></b></i></div>' +
                '<div class="colorpicker-hue"><i></i></div>' +
                '<div class="colorpicker-alpha"><i></i></div>' +
                '<div class="colorpicker-color"><div /></div>' +
                '</div>'
        };

        var Colorpicker = function(element, options) {
            this.element = $(element).addClass('colorpicker-element');
            this.options = $.extend({}, defaults, this.element.data(), options);
            this.component = this.options.component;
            this.component = (this.component !== false) ? this.element.find(this.component) : false;
            if (this.component && (this.component.length === 0)) {
                this.component = false;
            }
            this.container = (this.options.container === true) ? this.element : this.options.container;
            this.container = (this.container !== false) ? $(this.container) : false;

            // Is the element an input? Should we search inside for any input?
            this.input = this.element.is('input') ? this.element : (this.options.input ?
                this.element.find(this.options.input) : false);
            if (this.input && (this.input.length === 0)) {
                this.input = false;
            }
            // Set HSB color
            this.color = new Color(this.options.color !== false ? this.options.color : this.getValue());
            this.format = this.options.format !== false ? this.options.format : this.color.origFormat;

            // Setup picker
            this.picker = $(this.options.template);
            if (this.options.inline) {
                this.picker.addClass('colorpicker-inline colorpicker-visible');
            } else {
                this.picker.addClass('colorpicker-hidden');
            }
            if (this.options.horizontal) {
                this.picker.addClass('colorpicker-horizontal');
            }
            if (this.format === 'rgba' || this.format === 'hsla') {
                this.picker.addClass('colorpicker-with-alpha');
            }
            this.picker.on('mousedown.colorpicker', $.proxy(this.mousedown, this));
            this.picker.appendTo(this.container ? this.container : $('body'));

            // Bind events
            if (this.input !== false) {
                this.input.on({
                    'keyup.colorpicker': $.proxy(this.keyup, this)
                });
                if (this.component === false) {
                    this.element.on({
                        'focus.colorpicker': $.proxy(this.show, this)
                    });
                }
                if (this.options.inline === false) {
                    this.element.on({
                        'focusout.colorpicker': $.proxy(this.hide, this)
                    });
                }
            }

            if (this.component !== false) {
                this.component.on({
                    'click.colorpicker': $.proxy(this.show, this)
                });
            }

            if ((this.input === false) && (this.component === false)) {
                this.element.on({
                    'click.colorpicker': $.proxy(this.show, this)
                });
            }
            this.update();

            $($.proxy(function() {
                this.element.trigger('create');
            }, this));
        };

        Colorpicker.version = '2.0.0-beta';

        Colorpicker.Color = Color;

        Colorpicker.prototype = {
            constructor: Colorpicker,
            destroy: function() {
                this.picker.remove();
                this.element.removeData('colorpicker').off('.colorpicker');
                if (this.input !== false) {
                    this.input.off('.colorpicker');
                }
                if (this.component !== false) {
                    this.component.off('.colorpicker');
                }
                this.element.removeClass('colorpicker-element');
                this.element.trigger({
                    type: 'destroy'
                });
            },
            reposition: function() {
                if (this.options.inline !== false) {
                    return false;
                }
                var type = this.container && this.container[0] !== document.body ? 'position' : 'offset';
                var offset = this.component ? this.component[type]() : this.element[type]();
                this.picker.css({
                    top: offset.top + (this.component ? this.component.outerHeight() : this.element.outerHeight()),
                    left: offset.left
                });
            },
            show: function(e) {
                if (this.isDisabled()) {
                    return false;
                }
                this.picker.addClass('colorpicker-visible').removeClass('colorpicker-hidden');
                this.reposition();
                $(window).on('resize.colorpicker', $.proxy(this.reposition, this));
                if (!this.hasInput() && e) {
                    if (e.stopPropagation && e.preventDefault) {
                        e.stopPropagation();
                        e.preventDefault();
                    }
                }
                if (this.options.inline === false) {
                    $(window.document).on({
                        'mousedown.colorpicker': $.proxy(this.hide, this)
                    });
                }
                this.element.trigger({
                    type: 'showPicker',
                    color: this.color
                });
            },
            hide: function() {
                this.picker.addClass('colorpicker-hidden').removeClass('colorpicker-visible');
                $(window).off('resize.colorpicker', this.reposition);
                $(document).off({
                    'mousedown.colorpicker': this.hide
                });
                this.update();
                this.element.trigger({
                    type: 'hidePicker',
                    color: this.color
                });
            },
            updateData: function(val) {
                val = val || this.color.toString(this.format);
                this.element.data('color', val);
                return val;
            },
            updateInput: function(val) {
                val = val || this.color.toString(this.format);
                if (this.input !== false) {
                    this.input.prop('value', val);
                }
                return val;
            },
            updatePicker: function(val) {
                if (val !== undefined) {
                    this.color = new Color(val);
                }
                var sl = (this.options.horizontal === false) ? this.options.sliders : this.options.slidersHorz;
                var icns = this.picker.find('i');
                if (icns.length === 0) {
                    return;
                }
                if (this.options.horizontal === false) {
                    sl = this.options.sliders;
                    icns.eq(1).css('top', sl.hue.maxTop * (1 - this.color.value.h)).end()
                        .eq(2).css('top', sl.alpha.maxTop * (1 - this.color.value.a));
                } else {
                    sl = this.options.slidersHorz;
                    icns.eq(1).css('left', sl.hue.maxLeft * (1 - this.color.value.h)).end()
                        .eq(2).css('left', sl.alpha.maxLeft * (1 - this.color.value.a));
                }
                icns.eq(0).css({
                    'top': sl.saturation.maxTop - this.color.value.b * sl.saturation.maxTop,
                    'left': this.color.value.s * sl.saturation.maxLeft
                });
                this.picker.find('.colorpicker-saturation').css('backgroundColor', this.color.toHex(this.color.value.h, 1, 1, 1));
                this.picker.find('.colorpicker-alpha').css('backgroundColor', this.color.toHex());
                this.picker.find('.colorpicker-color, .colorpicker-color div').css('backgroundColor', this.color.toString(this.format));
                return val;
            },
            updateComponent: function(val) {
                val = val || this.color.toString(this.format);
                if (this.component !== false) {
                    var icn = this.component.find('i').eq(0);
                    if (icn.length > 0) {
                        icn.css({
                            'backgroundColor': val
                        });
                    } else {
                        this.component.css({
                            'backgroundColor': val
                        });
                    }
                }
                return val;
            },
            update: function(force) {
                var val = this.updateComponent();
                if ((this.getValue(false) !== false) || (force === true)) {
                    // Update input/data only if the current value is not blank
                    this.updateInput(val);
                    this.updateData(val);
                }
                this.updatePicker();
                return val;

            },
            setValue: function(val) { // set color manually
                this.color = new Color(val);
                this.update();
                this.element.trigger({
                    type: 'changeColor',
                    color: this.color,
                    value: val
                });
            },
            getValue: function(defaultValue) {
                defaultValue = (defaultValue === undefined) ? '#000000' : defaultValue;
                var val;
                if (this.hasInput()) {
                    val = this.input.val();
                } else {
                    val = this.element.data('color');
                }
                if ((val === undefined) || (val === '') || (val === null)) {
                    // if not defined or empty, return default
                    val = defaultValue;
                }
                return val;
            },
            hasInput: function() {
                return (this.input !== false);
            },
            isDisabled: function() {
                if (this.hasInput()) {
                    return (this.input.prop('disabled') === true);
                }
                return false;
            },
            disable: function() {
                if (this.hasInput()) {
                    this.input.prop('disabled', true);
                    return true;
                }
                return false;
            },
            enable: function() {
                if (this.hasInput()) {
                    this.input.prop('disabled', false);
                    return true;
                }
                return false;
            },
            currentSlider: null,
            mousePointer: {
                left: 0,
                top: 0
            },
            mousedown: function(e) {
                e.stopPropagation();
                e.preventDefault();

                var target = $(e.target);

                //detect the slider and set the limits and callbacks
                var zone = target.closest('div');
                var sl = this.options.horizontal ? this.options.slidersHorz : this.options.sliders;
                if (!zone.is('.colorpicker')) {
                    if (zone.is('.colorpicker-saturation')) {
                        this.currentSlider = $.extend({}, sl.saturation);
                    } else if (zone.is('.colorpicker-hue')) {
                        this.currentSlider = $.extend({}, sl.hue);
                    } else if (zone.is('.colorpicker-alpha')) {
                        this.currentSlider = $.extend({}, sl.alpha);
                    } else {
                        return false;
                    }
                    var offset = zone.offset();
                    //reference to guide's style
                    this.currentSlider.guide = zone.find('i')[0].style;
                    this.currentSlider.left = e.pageX - offset.left;
                    this.currentSlider.top = e.pageY - offset.top;
                    this.mousePointer = {
                        left: e.pageX,
                        top: e.pageY
                    };
                    //trigger mousemove to move the guide to the current position
                    $(document).on({
                        'mousemove.colorpicker': $.proxy(this.mousemove, this),
                        'mouseup.colorpicker': $.proxy(this.mouseup, this)
                    }).trigger('mousemove');
                }
                return false;
            },
            mousemove: function(e) {
                e.stopPropagation();
                e.preventDefault();
                var left = Math.max(
                    0,
                    Math.min(
                        this.currentSlider.maxLeft,
                        this.currentSlider.left + ((e.pageX || this.mousePointer.left) - this.mousePointer.left)
                    )
                );
                var top = Math.max(
                    0,
                    Math.min(
                        this.currentSlider.maxTop,
                        this.currentSlider.top + ((e.pageY || this.mousePointer.top) - this.mousePointer.top)
                    )
                );
                this.currentSlider.guide.left = left + 'px';
                this.currentSlider.guide.top = top + 'px';
                if (this.currentSlider.callLeft) {
                    this.color[this.currentSlider.callLeft].call(this.color, left / 100);
                }
                if (this.currentSlider.callTop) {
                    this.color[this.currentSlider.callTop].call(this.color, top / 100);
                }
                this.update(true);

                this.element.trigger({
                    type: 'changeColor',
                    color: this.color
                });
                return false;
            },
            mouseup: function(e) {
                e.stopPropagation();
                e.preventDefault();
                $(document).off({
                    'mousemove.colorpicker': this.mousemove,
                    'mouseup.colorpicker': this.mouseup
                });
                return false;
            },
            keyup: function(e) {
                if ((e.keyCode === 38)) {
                    if (this.color.value.a < 1) {
                        this.color.value.a = Math.round((this.color.value.a + 0.01) * 100) / 100;
                    }
                    this.update(true);
                } else if ((e.keyCode === 40)) {
                    if (this.color.value.a > 0) {
                        this.color.value.a = Math.round((this.color.value.a - 0.01) * 100) / 100;
                    }
                    this.update(true);
                } else {
                    var val = this.input.val();
                    this.color = new Color(val);
                    if (this.getValue(false) !== false) {
                        this.updateData();
                        this.updateComponent();
                        this.updatePicker();
                    }
                }
                this.element.trigger({
                    type: 'changeColor',
                    color: this.color,
                    value: val
                });
            }
        };

        $.colorpicker = Colorpicker;

        $.fn.colorpicker = function(option) {
            var pickerArgs = arguments;

            return this.each(function() {
                var $this = $(this),
                    inst = $this.data('colorpicker'),
                    options = ((typeof option === 'object') ? option : {});
                if ((!inst) && (typeof option !== 'string')) {
                    $this.data('colorpicker', new Colorpicker(this, options));
                } else {
                    if (typeof option === 'string') {
                        inst[option].apply(inst, Array.prototype.slice.call(pickerArgs, 1));
                    }
                }
            });
        };

        $.fn.colorpicker.constructor = Colorpicker;

    }));

/* -------- common/js/md5.js -------- */
/*
 * JavaScript MD5 1.0.1
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/MIT
 * 
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/*jslint bitwise: true */
/*global unescape, define */

(function ($) {
    'use strict';

    /*
    * Add integers, wrapping at 2^32. This uses 16-bit operations internally
    * to work around bugs in some JS interpreters.
    */
    function safe_add(x, y) {
        var lsw = (x & 0xFFFF) + (y & 0xFFFF),
            msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return (msw << 16) | (lsw & 0xFFFF);
    }

    /*
    * Bitwise rotate a 32-bit number to the left.
    */
    function bit_rol(num, cnt) {
        return (num << cnt) | (num >>> (32 - cnt));
    }

    /*
    * These functions implement the four basic operations the algorithm uses.
    */
    function md5_cmn(q, a, b, x, s, t) {
        return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
    }
    function md5_ff(a, b, c, d, x, s, t) {
        return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
    }
    function md5_gg(a, b, c, d, x, s, t) {
        return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
    }
    function md5_hh(a, b, c, d, x, s, t) {
        return md5_cmn(b ^ c ^ d, a, b, x, s, t);
    }
    function md5_ii(a, b, c, d, x, s, t) {
        return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
    }

    /*
    * Calculate the MD5 of an array of little-endian words, and a bit length.
    */
    function binl_md5(x, len) {
        /* append padding */
        x[len >> 5] |= 0x80 << (len % 32);
        x[(((len + 64) >>> 9) << 4) + 14] = len;

        var i, olda, oldb, oldc, oldd,
            a =  1732584193,
            b = -271733879,
            c = -1732584194,
            d =  271733878;

        for (i = 0; i < x.length; i += 16) {
            olda = a;
            oldb = b;
            oldc = c;
            oldd = d;

            a = md5_ff(a, b, c, d, x[i],       7, -680876936);
            d = md5_ff(d, a, b, c, x[i +  1], 12, -389564586);
            c = md5_ff(c, d, a, b, x[i +  2], 17,  606105819);
            b = md5_ff(b, c, d, a, x[i +  3], 22, -1044525330);
            a = md5_ff(a, b, c, d, x[i +  4],  7, -176418897);
            d = md5_ff(d, a, b, c, x[i +  5], 12,  1200080426);
            c = md5_ff(c, d, a, b, x[i +  6], 17, -1473231341);
            b = md5_ff(b, c, d, a, x[i +  7], 22, -45705983);
            a = md5_ff(a, b, c, d, x[i +  8],  7,  1770035416);
            d = md5_ff(d, a, b, c, x[i +  9], 12, -1958414417);
            c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
            b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
            a = md5_ff(a, b, c, d, x[i + 12],  7,  1804603682);
            d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
            c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
            b = md5_ff(b, c, d, a, x[i + 15], 22,  1236535329);

            a = md5_gg(a, b, c, d, x[i +  1],  5, -165796510);
            d = md5_gg(d, a, b, c, x[i +  6],  9, -1069501632);
            c = md5_gg(c, d, a, b, x[i + 11], 14,  643717713);
            b = md5_gg(b, c, d, a, x[i],      20, -373897302);
            a = md5_gg(a, b, c, d, x[i +  5],  5, -701558691);
            d = md5_gg(d, a, b, c, x[i + 10],  9,  38016083);
            c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
            b = md5_gg(b, c, d, a, x[i +  4], 20, -405537848);
            a = md5_gg(a, b, c, d, x[i +  9],  5,  568446438);
            d = md5_gg(d, a, b, c, x[i + 14],  9, -1019803690);
            c = md5_gg(c, d, a, b, x[i +  3], 14, -187363961);
            b = md5_gg(b, c, d, a, x[i +  8], 20,  1163531501);
            a = md5_gg(a, b, c, d, x[i + 13],  5, -1444681467);
            d = md5_gg(d, a, b, c, x[i +  2],  9, -51403784);
            c = md5_gg(c, d, a, b, x[i +  7], 14,  1735328473);
            b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);

            a = md5_hh(a, b, c, d, x[i +  5],  4, -378558);
            d = md5_hh(d, a, b, c, x[i +  8], 11, -2022574463);
            c = md5_hh(c, d, a, b, x[i + 11], 16,  1839030562);
            b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
            a = md5_hh(a, b, c, d, x[i +  1],  4, -1530992060);
            d = md5_hh(d, a, b, c, x[i +  4], 11,  1272893353);
            c = md5_hh(c, d, a, b, x[i +  7], 16, -155497632);
            b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
            a = md5_hh(a, b, c, d, x[i + 13],  4,  681279174);
            d = md5_hh(d, a, b, c, x[i],      11, -358537222);
            c = md5_hh(c, d, a, b, x[i +  3], 16, -722521979);
            b = md5_hh(b, c, d, a, x[i +  6], 23,  76029189);
            a = md5_hh(a, b, c, d, x[i +  9],  4, -640364487);
            d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
            c = md5_hh(c, d, a, b, x[i + 15], 16,  530742520);
            b = md5_hh(b, c, d, a, x[i +  2], 23, -995338651);

            a = md5_ii(a, b, c, d, x[i],       6, -198630844);
            d = md5_ii(d, a, b, c, x[i +  7], 10,  1126891415);
            c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
            b = md5_ii(b, c, d, a, x[i +  5], 21, -57434055);
            a = md5_ii(a, b, c, d, x[i + 12],  6,  1700485571);
            d = md5_ii(d, a, b, c, x[i +  3], 10, -1894986606);
            c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
            b = md5_ii(b, c, d, a, x[i +  1], 21, -2054922799);
            a = md5_ii(a, b, c, d, x[i +  8],  6,  1873313359);
            d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
            c = md5_ii(c, d, a, b, x[i +  6], 15, -1560198380);
            b = md5_ii(b, c, d, a, x[i + 13], 21,  1309151649);
            a = md5_ii(a, b, c, d, x[i +  4],  6, -145523070);
            d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
            c = md5_ii(c, d, a, b, x[i +  2], 15,  718787259);
            b = md5_ii(b, c, d, a, x[i +  9], 21, -343485551);

            a = safe_add(a, olda);
            b = safe_add(b, oldb);
            c = safe_add(c, oldc);
            d = safe_add(d, oldd);
        }
        return [a, b, c, d];
    }

    /*
    * Convert an array of little-endian words to a string
    */
    function binl2rstr(input) {
        var i,
            output = '';
        for (i = 0; i < input.length * 32; i += 8) {
            output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xFF);
        }
        return output;
    }

    /*
    * Convert a raw string to an array of little-endian words
    * Characters >255 have their high-byte silently ignored.
    */
    function rstr2binl(input) {
        var i,
            output = [];
        output[(input.length >> 2) - 1] = undefined;
        for (i = 0; i < output.length; i += 1) {
            output[i] = 0;
        }
        for (i = 0; i < input.length * 8; i += 8) {
            output[i >> 5] |= (input.charCodeAt(i / 8) & 0xFF) << (i % 32);
        }
        return output;
    }

    /*
    * Calculate the MD5 of a raw string
    */
    function rstr_md5(s) {
        return binl2rstr(binl_md5(rstr2binl(s), s.length * 8));
    }

    /*
    * Calculate the HMAC-MD5, of a key and some data (raw strings)
    */
    function rstr_hmac_md5(key, data) {
        var i,
            bkey = rstr2binl(key),
            ipad = [],
            opad = [],
            hash;
        ipad[15] = opad[15] = undefined;
        if (bkey.length > 16) {
            bkey = binl_md5(bkey, key.length * 8);
        }
        for (i = 0; i < 16; i += 1) {
            ipad[i] = bkey[i] ^ 0x36363636;
            opad[i] = bkey[i] ^ 0x5C5C5C5C;
        }
        hash = binl_md5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
        return binl2rstr(binl_md5(opad.concat(hash), 512 + 128));
    }

    /*
    * Convert a raw string to a hex string
    */
    function rstr2hex(input) {
        var hex_tab = '0123456789abcdef',
            output = '',
            x,
            i;
        for (i = 0; i < input.length; i += 1) {
            x = input.charCodeAt(i);
            output += hex_tab.charAt((x >>> 4) & 0x0F) +
                hex_tab.charAt(x & 0x0F);
        }
        return output;
    }

    /*
    * Encode a string as utf-8
    */
    function str2rstr_utf8(input) {
        return unescape(encodeURIComponent(input));
    }

    /*
    * Take string arguments and return either raw or hex encoded strings
    */
    function raw_md5(s) {
        return rstr_md5(str2rstr_utf8(s));
    }
    function hex_md5(s) {
        return rstr2hex(raw_md5(s));
    }
    function raw_hmac_md5(k, d) {
        return rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d));
    }
    function hex_hmac_md5(k, d) {
        return rstr2hex(raw_hmac_md5(k, d));
    }

    function md5(string, key, raw) {
        if (!key) {
            if (!raw) {
                return hex_md5(string);
            }
            return raw_md5(string);
        }
        if (!raw) {
            return hex_hmac_md5(key, string);
        }
        return raw_hmac_md5(key, string);
    }

    if (typeof define === 'function' && define.amd) {
        define(function () {
            return md5;
        });
    } else {
        $.md5 = md5;
    }
}(this));

/* -------- common/js/hideShowPassword.js -------- */
(function (factory) {

  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    // Node/CommonJS
    factory(require('jquery'));
  } else {
    // Browser globals
    factory(jQuery);
  }

}(function ($, undef) {

  var dataKey = 'plugin_hideShowPassword',
    shorthandArgs = ['show', 'innerToggle'],
    SPACE = 32,
    ENTER = 13;

  var canSetInputAttribute = (function(){
    var body = document.body,
      input = document.createElement('input'),
      result = true;
    if (! body) {
      body = document.createElement('body');
    }
    input = body.appendChild(input);
    try {
      input.setAttribute('type', 'text');
    } catch (e) {
      result = false;
    }
    body.removeChild(input);
    return result;
  }());

  var defaults = {
    // Visibility of the password text. Can be true, false, 'toggle'
    // or 'infer'. If 'toggle', it will be the opposite of whatever
    // it currently is. If 'infer', it will be based on the input
    // type (false if 'password', otherwise true).
    show: 'infer',

    // Set to true to create an inner toggle for this input. Can
    // also be sent to an event name to delay visibility of toggle
    // until that event is triggered on the input element.
    innerToggle: false,

    // If false, the plugin will be disabled entirely. Set to
    // the outcome of a test to insure input attributes can be
    // set after input has been inserted into the DOM.
    enable: canSetInputAttribute,

    // Class to add to input element when the plugin is enabled.
    className: 'hideShowPassword-field',

    // Event to trigger when the plugin is initialized and enabled.
    initEvent: 'hideShowPasswordInit',

    // Event to trigger whenever the visibility changes.
    changeEvent: 'passwordVisibilityChange',

    // Properties to add to the input element.
    props: {
      autocapitalize: 'off',
      autocomplete: 'off',
      autocorrect: 'off',
      spellcheck: 'false'
    },

    // Options specific to the inner toggle.
    toggle: {
      // The element to create.
      element: '<button type="button">',
      // Class name of element.
      className: 'hideShowPassword-toggle',
      // Whether or not to support touch-specific enhancements.
      // Defaults to the value of Modernizr.touch if available,
      // otherwise false.
      touchSupport: (typeof Modernizr === 'undefined') ? false : Modernizr.touch,
      // Non-touch event to bind to.
      attachToEvent: 'click.hideShowPassword',
      // Event to bind to when touchSupport is true.
      attachToTouchEvent: 'touchstart.hideShowPassword mousedown.hideShowPassword',
      // Key event to bind to if attachToKeyCodes is an array
      // of at least one keycode.
      attachToKeyEvent: 'keyup',
      // Key codes to bind the toggle event to for accessibility.
      // If false, this feature is disabled entirely.
      // If true, the array of key codes will be determined based
      // on the value of the element option.
      attachToKeyCodes: true,
      // Styles to add to the toggle element. Does not include
      // positioning styles.
      styles: { position: 'absolute' },
      // Styles to add only when touchSupport is true.
      touchStyles: { pointerEvents: 'none' },
      // Where to position the inner toggle relative to the
      // input element. Can be 'right', 'left' or 'infer'. If
      // 'infer', it will be based on the text-direction of the
      // input element.
      position: 'infer',
      // Where to position the inner toggle on the y-axis
      // relative to the input element. Can be 'top', 'bottom'
      // or 'middle'.
      verticalAlign: 'middle',
      // Amount by which to "offset" the toggle from the edge
      // of the input element.
      offset: 0,
      // Attributes to add to the toggle element.
      attr: {
        role: 'button',
        'aria-label': 'Show Password',
        tabIndex: 0
      }
    },

    // Options specific to the wrapper element, created
    // when the innerToggle is initialized to help with
    // positioning of that element.
    wrapper: {
      // The element to create.
      element: '<div>',
      // Class name of element.
      className: 'hideShowPassword-wrapper',
      // If true, the width of the wrapper will be set
      // unless it is already the same width as the inner
      // element. If false, the width will never be set. Any
      // other value will be used as the width.
      enforceWidth: true,
      // Styles to add to the wrapper element. Does not
      // include inherited styles or width if enforceWidth
      // is not false.
      styles: { position: 'relative' },
      // Styles to "inherit" from the input element, allowing
      // the wrapper to avoid disrupting page styles.
      inheritStyles: [
        'display',
        'verticalAlign',
        'marginTop',
        'marginRight',
        'marginBottom',
        'marginLeft'
      ],
      // Styles for the input element when wrapped.
      innerElementStyles: {
        marginTop: 0,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0
      }
    },

    // Options specific to the 'shown' or 'hidden'
    // states of the input element.
    states: {
      shown: {
        className: 'hideShowPassword-shown',
        changeEvent: 'passwordShown',
        props: { type: 'text' },
        toggle: {
          className: 'hideShowPassword-toggle-hide',
          content: 'Hide',
          attr: { 'aria-pressed': 'true' }
        }
      },
      hidden: {
        className: 'hideShowPassword-hidden',
        changeEvent: 'passwordHidden',
        props: { type: 'password' },
        toggle: {
          className: 'hideShowPassword-toggle-show',
          content: 'Show',
          attr: { 'aria-pressed': 'false' }
        }
      }
    }

  };

  function HideShowPassword (element, options) {
    this.element = $(element);
    this.wrapperElement = $();
    this.toggleElement = $();
    this.init(options);
  }

  HideShowPassword.prototype = {

    init: function (options) {
      if (this.update(options, defaults)) {
        this.element.addClass(this.options.className);
        if (this.options.innerToggle) {
          this.wrapElement(this.options.wrapper);
          this.initToggle(this.options.toggle);
          if (typeof this.options.innerToggle === 'string') {
            this.toggleElement.hide();
            this.element.one(this.options.innerToggle, $.proxy(function(){
              this.toggleElement.show();
            }, this));
          }
        }
        this.element.trigger(this.options.initEvent, [ this ]);
      }
    },

    update: function (options, base) {
      this.options = this.prepareOptions(options, base);
      if (this.updateElement()) {
        this.element
          .trigger(this.options.changeEvent, [ this ])
          .trigger(this.state().changeEvent, [ this ]);
      }
      return this.options.enable;
    },

    toggle: function (showVal) {
      showVal = showVal || 'toggle';
      return this.update({ show: showVal });
    },

    prepareOptions: function (options, base) {
      var keyCodes = [],
        testElement;
      base = base || this.options;
      options = $.extend(true, {}, base, options);
      if (options.enable) {
        if (options.show === 'toggle') {
          options.show = this.isType('hidden', options.states);
        } else if (options.show === 'infer') {
          options.show = this.isType('shown', options.states);
        }
        if (options.toggle.position === 'infer') {
          options.toggle.position = (this.element.css('text-direction') === 'rtl') ? 'left' : 'right';
        }
        if (! $.isArray(options.toggle.attachToKeyCodes)) {
          if (options.toggle.attachToKeyCodes === true) {
            testElement = $(options.toggle.element);
            switch(testElement.prop('tagName').toLowerCase()) {
              case 'button':
              case 'input':
                break;
              case 'a':
                if (testElement.filter('[href]').length) {
                  keyCodes.push(SPACE);
                  break;
                }
              default:
                keyCodes.push(SPACE, ENTER);
                break;
            }
          }
          options.toggle.attachToKeyCodes = keyCodes;
        }
      }
      return options;
    },

    updateElement: function () {
      if (! this.options.enable || this.isType()) return false;
      this.element
        .prop($.extend({}, this.options.props, this.state().props))
        .addClass(this.state().className)
        .removeClass(this.otherState().className);
      this.updateToggle();
      return true;
    },

    isType: function (comparison, states) {
      states = states || this.options.states;
      comparison = comparison || this.state(undef, undef, states).props.type;
      if (states[comparison]) {
        comparison = states[comparison].props.type;
      }
      return this.element.prop('type') === comparison;
    },

    state: function (key, invert, states) {
      states = states || this.options.states;
      if (key === undef) {
        key = this.options.show;
      }
      if (typeof key === 'boolean') {
        key = key ? 'shown' : 'hidden';
      }
      if (invert) {
        key = (key === 'shown') ? 'hidden' : 'shown';
      }
      return states[key];
    },

    otherState: function (key) {
      return this.state(key, true);
    },

    wrapElement: function (options) {
      var enforceWidth = options.enforceWidth,
        targetWidth;
      if (! this.wrapperElement.length) {
        targetWidth = this.element.outerWidth();
        $.each(options.inheritStyles, $.proxy(function (index, prop) {
          options.styles[prop] = this.element.css(prop);
        }, this));
        this.element.css(options.innerElementStyles).wrap(
          $(options.element).addClass(options.className).css(options.styles)
        );
        this.wrapperElement = this.element.parent();
        if (enforceWidth === true) {
          enforceWidth = (this.wrapperElement.outerWidth() === targetWidth) ? false : targetWidth;
        }
        if (enforceWidth !== false) {
          this.wrapperElement.css('width', enforceWidth);
        }
      }
      return this.wrapperElement;
    },

    initToggle: function (options) {
      if (! this.toggleElement.length) {
        // Create element
        this.toggleElement = $(options.element)
          .attr(options.attr)
          .addClass(options.className)
          .css(options.styles)
          .appendTo(this.wrapperElement);
        // Update content/attributes
        this.updateToggle();
        // Position
        this.positionToggle(options.position, options.verticalAlign, options.offset);
        // Events
        if (options.touchSupport) {
          this.toggleElement.css(options.touchStyles);
          this.element.on(options.attachToTouchEvent, $.proxy(this.toggleTouchEvent, this));
        } else {
          this.toggleElement.on(options.attachToEvent, $.proxy(this.toggleEvent, this));
        }
        if (options.attachToKeyCodes.length) {
          this.toggleElement.on(options.attachToKeyEvent, $.proxy(this.toggleKeyEvent, this));
        }
      }
      return this.toggleElement;
    },

    positionToggle: function (position, verticalAlign, offset) {
      var styles = {};
      styles[position] = offset;
      switch (verticalAlign) {
        case 'top':
        case 'bottom':
          styles[verticalAlign] = offset;
          break;
        case 'middle':
          styles.top = '50%';
          styles.marginTop = this.toggleElement.outerHeight() / -2;
          break;
      }
      return this.toggleElement.css(styles);
    },

    updateToggle: function (state, otherState) {
      var paddingProp,
        targetPadding;
      if (this.toggleElement.length) {
        paddingProp = 'padding-' + this.options.toggle.position;
        state = state || this.state().toggle;
        otherState = otherState || this.otherState().toggle;
        this.toggleElement
          .attr(state.attr)
          .addClass(state.className)
          .removeClass(otherState.className)
          .html(state.content);
        targetPadding = this.toggleElement.outerWidth() + (this.options.toggle.offset * 2);
        if (this.element.css(paddingProp) !== targetPadding) {
          this.element.css(paddingProp, targetPadding);
        }
      }
      return this.toggleElement;
    },

    toggleEvent: function (event) {
      event.preventDefault();
      this.toggle();
    },

    toggleKeyEvent: function (event) {
      $.each(this.options.toggle.attachToKeyCodes, $.proxy(function(index, keyCode) {
        if (event.which === keyCode) {
          this.toggleEvent(event);
          return false;
        }
      }, this));
    },

    toggleTouchEvent: function (event) {
      var toggleX = this.toggleElement.offset().left,
        eventX,
        lesser,
        greater;
      if (toggleX) {
        eventX = event.pageX || event.originalEvent.pageX;
        if (this.options.toggle.position === 'left') {
          toggleX+= this.toggleElement.outerWidth();
          lesser = eventX;
          greater = toggleX;
        } else {
          lesser = toggleX;
          greater = eventX;
        }
        if (greater >= lesser) {
          this.toggleEvent(event);
        }
      }
    }

  };

  $.fn.hideShowPassword = function () {
    var options = {};
    $.each(arguments, function (index, value) {
      var newOptions = {};
      if (typeof value === 'object') {
        newOptions = value;
      } else if (shorthandArgs[index]) {
        newOptions[shorthandArgs[index]] = value;
      } else {
        return false;
      }
      $.extend(true, options, newOptions);
    });
    return this.each(function(){
      var $this = $(this),
        data = $this.data(dataKey);
      if (data) {
        data.update(options);
      } else {
        $this.data(dataKey, new HideShowPassword(this, options));
      }
    });
  };

  $.each({ 'show':true, 'hide':false, 'toggle':'toggle' }, function (verb, showVal) {
    $.fn[verb + 'Password'] = function (innerToggle, options) {
      return this.hideShowPassword(showVal, innerToggle, options);
    };
  });

}));

/* -------- studio/v2/js/select2.js -------- */
/*!
 * Select2 4.0.0-rc.2
 * https://select2.github.io
 *
 * Released under the MIT license
 * https://github.com/select2/select2/blob/master/LICENSE.md
 */
(function (factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    // Node/CommonJS
    factory(require('jquery'));
  } else {
    // Browser globals
    factory(jQuery);
  }
}(function (jQuery) {
  // This is needed so we can catch the AMD loader configuration and use it
  // The inner file should be wrapped (by `banner.start.js`) in a function that
  // returns the AMD loader references.
  var S2 =
(function () {
  // Restore the Select2 AMD loader so it can be used
  // Needed mostly in the language files, where the loader is not inserted
  if (jQuery && jQuery.fn && jQuery.fn.select2 && jQuery.fn.select2.amd) {
    var S2 = jQuery.fn.select2.amd;
  }
var S2;(function () { if (!S2 || !S2.requirejs) {
if (!S2) { S2 = {}; } else { require = S2; }
/**
 * @license almond 0.2.9 Copyright (c) 2011-2014, The Dojo Foundation All Rights Reserved.
 * Available via the MIT or new BSD license.
 * see: http://github.com/jrburke/almond for details
 */
//Going sloppy to avoid 'use strict' string cost, but strict practices should
//be followed.
/*jslint sloppy: true */
/*global setTimeout: false */

var requirejs, require, define;
(function (undef) {
    var main, req, makeMap, handlers,
        defined = {},
        waiting = {},
        config = {},
        defining = {},
        hasOwn = Object.prototype.hasOwnProperty,
        aps = [].slice,
        jsSuffixRegExp = /\.js$/;

    function hasProp(obj, prop) {
        return hasOwn.call(obj, prop);
    }

    /**
     * Given a relative module name, like ./something, normalize it to
     * a real name that can be mapped to a path.
     * @param {String} name the relative name
     * @param {String} baseName a real name that the name arg is relative
     * to.
     * @returns {String} normalized name
     */
    function normalize(name, baseName) {
        var nameParts, nameSegment, mapValue, foundMap, lastIndex,
            foundI, foundStarMap, starI, i, j, part,
            baseParts = baseName && baseName.split("/"),
            map = config.map,
            starMap = (map && map['*']) || {};

        //Adjust any relative paths.
        if (name && name.charAt(0) === ".") {
            //If have a base name, try to normalize against it,
            //otherwise, assume it is a top-level require that will
            //be relative to baseUrl in the end.
            if (baseName) {
                //Convert baseName to array, and lop off the last part,
                //so that . matches that "directory" and not name of the baseName's
                //module. For instance, baseName of "one/two/three", maps to
                //"one/two/three.js", but we want the directory, "one/two" for
                //this normalization.
                baseParts = baseParts.slice(0, baseParts.length - 1);
                name = name.split('/');
                lastIndex = name.length - 1;

                // Node .js allowance:
                if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
                    name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
                }

                name = baseParts.concat(name);

                //start trimDots
                for (i = 0; i < name.length; i += 1) {
                    part = name[i];
                    if (part === ".") {
                        name.splice(i, 1);
                        i -= 1;
                    } else if (part === "..") {
                        if (i === 1 && (name[2] === '..' || name[0] === '..')) {
                            //End of the line. Keep at least one non-dot
                            //path segment at the front so it can be mapped
                            //correctly to disk. Otherwise, there is likely
                            //no path mapping for a path starting with '..'.
                            //This can still fail, but catches the most reasonable
                            //uses of ..
                            break;
                        } else if (i > 0) {
                            name.splice(i - 1, 2);
                            i -= 2;
                        }
                    }
                }
                //end trimDots

                name = name.join("/");
            } else if (name.indexOf('./') === 0) {
                // No baseName, so this is ID is resolved relative
                // to baseUrl, pull off the leading dot.
                name = name.substring(2);
            }
        }

        //Apply map config if available.
        if ((baseParts || starMap) && map) {
            nameParts = name.split('/');

            for (i = nameParts.length; i > 0; i -= 1) {
                nameSegment = nameParts.slice(0, i).join("/");

                if (baseParts) {
                    //Find the longest baseName segment match in the config.
                    //So, do joins on the biggest to smallest lengths of baseParts.
                    for (j = baseParts.length; j > 0; j -= 1) {
                        mapValue = map[baseParts.slice(0, j).join('/')];

                        //baseName segment has  config, find if it has one for
                        //this name.
                        if (mapValue) {
                            mapValue = mapValue[nameSegment];
                            if (mapValue) {
                                //Match, update name to the new value.
                                foundMap = mapValue;
                                foundI = i;
                                break;
                            }
                        }
                    }
                }

                if (foundMap) {
                    break;
                }

                //Check for a star map match, but just hold on to it,
                //if there is a shorter segment match later in a matching
                //config, then favor over this star map.
                if (!foundStarMap && starMap && starMap[nameSegment]) {
                    foundStarMap = starMap[nameSegment];
                    starI = i;
                }
            }

            if (!foundMap && foundStarMap) {
                foundMap = foundStarMap;
                foundI = starI;
            }

            if (foundMap) {
                nameParts.splice(0, foundI, foundMap);
                name = nameParts.join('/');
            }
        }

        return name;
    }

    function makeRequire(relName, forceSync) {
        return function () {
            //A version of a require function that passes a moduleName
            //value for items that may need to
            //look up paths relative to the moduleName
            return req.apply(undef, aps.call(arguments, 0).concat([relName, forceSync]));
        };
    }

    function makeNormalize(relName) {
        return function (name) {
            return normalize(name, relName);
        };
    }

    function makeLoad(depName) {
        return function (value) {
            defined[depName] = value;
        };
    }

    function callDep(name) {
        if (hasProp(waiting, name)) {
            var args = waiting[name];
            delete waiting[name];
            defining[name] = true;
            main.apply(undef, args);
        }

        if (!hasProp(defined, name) && !hasProp(defining, name)) {
            throw new Error('No ' + name);
        }
        return defined[name];
    }

    //Turns a plugin!resource to [plugin, resource]
    //with the plugin being undefined if the name
    //did not have a plugin prefix.
    function splitPrefix(name) {
        var prefix,
            index = name ? name.indexOf('!') : -1;
        if (index > -1) {
            prefix = name.substring(0, index);
            name = name.substring(index + 1, name.length);
        }
        return [prefix, name];
    }

    /**
     * Makes a name map, normalizing the name, and using a plugin
     * for normalization if necessary. Grabs a ref to plugin
     * too, as an optimization.
     */
    makeMap = function (name, relName) {
        var plugin,
            parts = splitPrefix(name),
            prefix = parts[0];

        name = parts[1];

        if (prefix) {
            prefix = normalize(prefix, relName);
            plugin = callDep(prefix);
        }

        //Normalize according
        if (prefix) {
            if (plugin && plugin.normalize) {
                name = plugin.normalize(name, makeNormalize(relName));
            } else {
                name = normalize(name, relName);
            }
        } else {
            name = normalize(name, relName);
            parts = splitPrefix(name);
            prefix = parts[0];
            name = parts[1];
            if (prefix) {
                plugin = callDep(prefix);
            }
        }

        //Using ridiculous property names for space reasons
        return {
            f: prefix ? prefix + '!' + name : name, //fullName
            n: name,
            pr: prefix,
            p: plugin
        };
    };

    function makeConfig(name) {
        return function () {
            return (config && config.config && config.config[name]) || {};
        };
    }

    handlers = {
        require: function (name) {
            return makeRequire(name);
        },
        exports: function (name) {
            var e = defined[name];
            if (typeof e !== 'undefined') {
                return e;
            } else {
                return (defined[name] = {});
            }
        },
        module: function (name) {
            return {
                id: name,
                uri: '',
                exports: defined[name],
                config: makeConfig(name)
            };
        }
    };

    main = function (name, deps, callback, relName) {
        var cjsModule, depName, ret, map, i,
            args = [],
            callbackType = typeof callback,
            usingExports;

        //Use name if no relName
        relName = relName || name;

        //Call the callback to define the module, if necessary.
        if (callbackType === 'undefined' || callbackType === 'function') {
            //Pull out the defined dependencies and pass the ordered
            //values to the callback.
            //Default to [require, exports, module] if no deps
            deps = !deps.length && callback.length ? ['require', 'exports', 'module'] : deps;
            for (i = 0; i < deps.length; i += 1) {
                map = makeMap(deps[i], relName);
                depName = map.f;

                //Fast path CommonJS standard dependencies.
                if (depName === "require") {
                    args[i] = handlers.require(name);
                } else if (depName === "exports") {
                    //CommonJS module spec 1.1
                    args[i] = handlers.exports(name);
                    usingExports = true;
                } else if (depName === "module") {
                    //CommonJS module spec 1.1
                    cjsModule = args[i] = handlers.module(name);
                } else if (hasProp(defined, depName) ||
                           hasProp(waiting, depName) ||
                           hasProp(defining, depName)) {
                    args[i] = callDep(depName);
                } else if (map.p) {
                    map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
                    args[i] = defined[depName];
                } else {
                    throw new Error(name + ' missing ' + depName);
                }
            }

            ret = callback ? callback.apply(defined[name], args) : undefined;

            if (name) {
                //If setting exports via "module" is in play,
                //favor that over return value and exports. After that,
                //favor a non-undefined return value over exports use.
                if (cjsModule && cjsModule.exports !== undef &&
                        cjsModule.exports !== defined[name]) {
                    defined[name] = cjsModule.exports;
                } else if (ret !== undef || !usingExports) {
                    //Use the return value from the function.
                    defined[name] = ret;
                }
            }
        } else if (name) {
            //May just be an object definition for the module. Only
            //worry about defining if have a module name.
            defined[name] = callback;
        }
    };

    requirejs = require = req = function (deps, callback, relName, forceSync, alt) {
        if (typeof deps === "string") {
            if (handlers[deps]) {
                //callback in this case is really relName
                return handlers[deps](callback);
            }
            //Just return the module wanted. In this scenario, the
            //deps arg is the module name, and second arg (if passed)
            //is just the relName.
            //Normalize module name, if it contains . or ..
            return callDep(makeMap(deps, callback).f);
        } else if (!deps.splice) {
            //deps is a config object, not an array.
            config = deps;
            if (config.deps) {
                req(config.deps, config.callback);
            }
            if (!callback) {
                return;
            }

            if (callback.splice) {
                //callback is an array, which means it is a dependency list.
                //Adjust args if there are dependencies
                deps = callback;
                callback = relName;
                relName = null;
            } else {
                deps = undef;
            }
        }

        //Support require(['a'])
        callback = callback || function () {};

        //If relName is a function, it is an errback handler,
        //so remove it.
        if (typeof relName === 'function') {
            relName = forceSync;
            forceSync = alt;
        }

        //Simulate async callback;
        if (forceSync) {
            main(undef, deps, callback, relName);
        } else {
            //Using a non-zero value because of concern for what old browsers
            //do, and latest browsers "upgrade" to 4 if lower value is used:
            //http://www.whatwg.org/specs/web-apps/current-work/multipage/timers.html#dom-windowtimers-settimeout:
            //If want a value immediately, use require('id') instead -- something
            //that works in almond on the global level, but not guaranteed and
            //unlikely to work in other AMD implementations.
            setTimeout(function () {
                main(undef, deps, callback, relName);
            }, 4);
        }

        return req;
    };

    /**
     * Just drops the config on the floor, but returns req in case
     * the config return value is used.
     */
    req.config = function (cfg) {
        return req(cfg);
    };

    /**
     * Expose module registry for debugging and tooling
     */
    requirejs._defined = defined;

    define = function (name, deps, callback) {

        //This module may not have dependencies
        if (!deps.splice) {
            //deps is not an array, so probably means
            //an object literal or factory function for
            //the value. Adjust args.
            callback = deps;
            deps = [];
        }

        if (!hasProp(defined, name) && !hasProp(waiting, name)) {
            waiting[name] = [name, deps, callback];
        }
    };

    define.amd = {
        jQuery: true
    };
}());

S2.requirejs = requirejs;S2.require = require;S2.define = define;
}
}());
S2.define("almond", function(){});

/* global jQuery:false, $:false */
S2.define('jquery',[],function () {
  var _$ = jQuery || $;

  if (_$ == null && console && console.error) {
    console.error(
      'Select2: An instance of jQuery or a jQuery-compatible library was not ' +
      'found. Make sure that you are including jQuery before Select2 on your ' +
      'web page.'
    );
  }

  return _$;
});

S2.define('select2/utils',[
  'jquery'
], function ($) {
  var Utils = {};

  Utils.Extend = function (ChildClass, SuperClass) {
    var __hasProp = {}.hasOwnProperty;

    function BaseConstructor () {
      this.constructor = ChildClass;
    }

    for (var key in SuperClass) {
      if (__hasProp.call(SuperClass, key)) {
        ChildClass[key] = SuperClass[key];
      }
    }

    BaseConstructor.prototype = SuperClass.prototype;
    ChildClass.prototype = new BaseConstructor();
    ChildClass.__super__ = SuperClass.prototype;

    return ChildClass;
  };

  function getMethods (theClass) {
    var proto = theClass.prototype;

    var methods = [];

    for (var methodName in proto) {
      var m = proto[methodName];

      if (typeof m !== 'function') {
        continue;
      }

      if (methodName === 'constructor') {
        continue;
      }

      methods.push(methodName);
    }

    return methods;
  }

  Utils.Decorate = function (SuperClass, DecoratorClass) {
    var decoratedMethods = getMethods(DecoratorClass);
    var superMethods = getMethods(SuperClass);

    function DecoratedClass () {
      var unshift = Array.prototype.unshift;

      var argCount = DecoratorClass.prototype.constructor.length;

      var calledConstructor = SuperClass.prototype.constructor;

      if (argCount > 0) {
        unshift.call(arguments, SuperClass.prototype.constructor);

        calledConstructor = DecoratorClass.prototype.constructor;
      }

      calledConstructor.apply(this, arguments);
    }

    DecoratorClass.displayName = SuperClass.displayName;

    function ctr () {
      this.constructor = DecoratedClass;
    }

    DecoratedClass.prototype = new ctr();

    for (var m = 0; m < superMethods.length; m++) {
        var superMethod = superMethods[m];

        DecoratedClass.prototype[superMethod] =
          SuperClass.prototype[superMethod];
    }

    var calledMethod = function (methodName) {
      // Stub out the original method if it's not decorating an actual method
      var originalMethod = function () {};

      if (methodName in DecoratedClass.prototype) {
        originalMethod = DecoratedClass.prototype[methodName];
      }

      var decoratedMethod = DecoratorClass.prototype[methodName];

      return function () {
        var unshift = Array.prototype.unshift;

        unshift.call(arguments, originalMethod);

        return decoratedMethod.apply(this, arguments);
      };
    };

    for (var d = 0; d < decoratedMethods.length; d++) {
      var decoratedMethod = decoratedMethods[d];

      DecoratedClass.prototype[decoratedMethod] = calledMethod(decoratedMethod);
    }

    return DecoratedClass;
  };

  var Observable = function () {
    this.listeners = {};
  };

  Observable.prototype.on = function (event, callback) {
    this.listeners = this.listeners || {};

    if (event in this.listeners) {
      this.listeners[event].push(callback);
    } else {
      this.listeners[event] = [callback];
    }
  };

  Observable.prototype.trigger = function (event) {
    var slice = Array.prototype.slice;

    this.listeners = this.listeners || {};

    if (event in this.listeners) {
      this.invoke(this.listeners[event], slice.call(arguments, 1));
    }

    if ('*' in this.listeners) {
      this.invoke(this.listeners['*'], arguments);
    }
  };

  Observable.prototype.invoke = function (listeners, params) {
    for (var i = 0, len = listeners.length; i < len; i++) {
      listeners[i].apply(this, params);
    }
  };

  Utils.Observable = Observable;

  Utils.generateChars = function (length) {
    var chars = '';

    for (var i = 0; i < length; i++) {
      var randomChar = Math.floor(Math.random() * 36);
      chars += randomChar.toString(36);
    }

    return chars;
  };

  Utils.bind = function (func, context) {
    return function () {
      func.apply(context, arguments);
    };
  };

  Utils._convertData = function (data) {
    for (var originalKey in data) {
      var keys = originalKey.split('-');

      var dataLevel = data;

      if (keys.length === 1) {
        continue;
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k];

        // Lowercase the first letter
        // By default, dash-separated becomes camelCase
        key = key.substring(0, 1).toLowerCase() + key.substring(1);

        if (!(key in dataLevel)) {
          dataLevel[key] = {};
        }

        if (k == keys.length - 1) {
          dataLevel[key] = data[originalKey];
        }

        dataLevel = dataLevel[key];
      }

      delete data[originalKey];
    }

    return data;
  };

  Utils.hasScroll = function (index, el) {
    // Adapted from the function created by @ShadowScripter
    // and adapted by @BillBarry on the Stack Exchange Code Review website.
    // The original code can be found at
    // http://codereview.stackexchange.com/q/13338
    // and was designed to be used with the Sizzle selector engine.

    var $el = $(el);
    var overflowX = el.style.overflowX;
    var overflowY = el.style.overflowY;

    //Check both x and y declarations
    if (overflowX === overflowY &&
        (overflowY === 'hidden' || overflowY === 'visible')) {
      return false;
    }

    if (overflowX === 'scroll' || overflowY === 'scroll') {
      return true;
    }

    return ($el.innerHeight() < el.scrollHeight ||
      $el.innerWidth() < el.scrollWidth);
  };

  Utils.escapeMarkup = function (markup) {
    var replaceMap = {
      '\\': '&#92;',
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      '\'': '&#39;',
      '/': '&#47;'
    };

    // Do not try to escape the markup if it's not a string
    if (typeof markup !== 'string') {
      return markup;
    }

    return String(markup).replace(/[&<>"'\/\\]/g, function (match) {
      return replaceMap[match];
    });
  };

  return Utils;
});

S2.define('select2/results',[
  'jquery',
  './utils'
], function ($, Utils) {
  function Results ($element, options, dataAdapter) {
    this.$element = $element;
    this.data = dataAdapter;
    this.options = options;

    Results.__super__.constructor.call(this);
  }

  Utils.Extend(Results, Utils.Observable);

  Results.prototype.render = function () {
    var $results = $(
      '<ul class="select2-results__options" role="tree"></ul>'
    );

    if (this.options.get('multiple')) {
      $results.attr('aria-multiselectable', 'true');
    }

    this.$results = $results;

    return $results;
  };

  Results.prototype.clear = function () {
    this.$results.empty();
  };

  Results.prototype.displayMessage = function (params) {
    var escapeMarkup = this.options.get('escapeMarkup');

    this.clear();
    this.hideLoading();

    var $message = $(
      '<li role="treeitem" class="select2-results__option"></li>'
    );

    var message = this.options.get('translations').get(params.message);

    $message.append(
      escapeMarkup(
        message(params.args)
      )
    );

    this.$results.append($message);
  };

  Results.prototype.append = function (data) {
    this.hideLoading();

    var $options = [];

    if (data.results == null || data.results.length === 0) {
      if (this.$results.children().length === 0) {
        this.trigger('results:message', {
          message: 'noResults'
        });
      }

      return;
    }

    data.results = this.sort(data.results);

    for (var d = 0; d < data.results.length; d++) {
      var item = data.results[d];

      var $option = this.option(item);

      $options.push($option);
    }

    this.$results.append($options);
  };

  Results.prototype.position = function ($results, $dropdown) {
    var $resultsContainer = $dropdown.find('.select2-results');
    $resultsContainer.append($results);
  };

  Results.prototype.sort = function (data) {
    var sorter = this.options.get('sorter');

    return sorter(data);
  };

  Results.prototype.setClasses = function () {
    var self = this;

    this.data.current(function (selected) {
      var selectedIds = $.map(selected, function (s) {
        return s.id.toString();
      });

      var $options = self.$results
        .find('.select2-results__option[aria-selected]');

      $options.each(function () {
        var $option = $(this);

        var item = $.data(this, 'data');

        // id needs to be converted to a string when comparing
        var id = '' + item.id;

        if ($.inArray(id, selectedIds) > -1) {
          $option.attr('aria-selected', 'true');
        } else {
          $option.attr('aria-selected', 'false');
        }
      });

      var $selected = $options.filter('[aria-selected=true]');

      // Check if there are any selected options
      if ($selected.length > 0) {
        // If there are selected options, highlight the first
        $selected.first().trigger('mouseenter');
      } else {
        // If there are no selected options, highlight the first option
        // in the dropdown
        $options.first().trigger('mouseenter');
      }
    });
  };

  Results.prototype.showLoading = function (params) {
    this.hideLoading();

    var loadingMore = this.options.get('translations').get('searching');

    var loading = {
      disabled: true,
      loading: true,
      text: loadingMore(params)
    };
    var $loading = this.option(loading);
    $loading.className += ' loading-results';

    this.$results.prepend($loading);
  };

  Results.prototype.hideLoading = function () {
    this.$results.find('.loading-results').remove();
  };

  Results.prototype.option = function (data) {
    var option = document.createElement('li');
    option.className = 'select2-results__option';

    var attrs = {
      'role': 'treeitem',
      'aria-selected': 'false'
    };

    if (data.disabled) {
      delete attrs['aria-selected'];
      attrs['aria-disabled'] = 'true';
    }

    if (data.id == null) {
      delete attrs['aria-selected'];
    }

    if (data._resultId != null) {
      option.id = data._resultId;
    }

    if (data.title) {
      option.title = data.title;
    }

    if (data.children) {
      attrs.role = 'group';
      attrs['aria-label'] = data.text;
      delete attrs['aria-selected'];
    }

    for (var attr in attrs) {
      var val = attrs[attr];

      option.setAttribute(attr, val);
    }

    if (data.children) {
      var $option = $(option);

      var label = document.createElement('strong');
      label.className = 'select2-results__group';

      var $label = $(label);
      this.template(data, label);

      var $children = [];

      for (var c = 0; c < data.children.length; c++) {
        var child = data.children[c];

        var $child = this.option(child);

        $children.push($child);
      }

      var $childrenContainer = $('<ul></ul>', {
        'class': 'select2-results__options select2-results__options--nested'
      });

      $childrenContainer.append($children);

      $option.append(label);
      $option.append($childrenContainer);
    } else {
      this.template(data, option);
    }

    $.data(option, 'data', data);

    return option;
  };

  Results.prototype.bind = function (container, $container) {
    var self = this;

    var id = container.id + '-results';

    this.$results.attr('id', id);

    container.on('results:all', function (params) {
      self.clear();
      self.append(params.data);

      if (container.isOpen()) {
        self.setClasses();
      }
    });

    container.on('results:append', function (params) {
      self.append(params.data);

      if (container.isOpen()) {
        self.setClasses();
      }
    });

    container.on('query', function (params) {
      self.showLoading(params);
    });

    container.on('select', function () {
      if (!container.isOpen()) {
        return;
      }

      self.setClasses();
    });

    container.on('unselect', function () {
      if (!container.isOpen()) {
        return;
      }

      self.setClasses();
    });

    container.on('open', function () {
      // When the dropdown is open, aria-expended="true"
      self.$results.attr('aria-expanded', 'true');
      self.$results.attr('aria-hidden', 'false');

      self.setClasses();
      self.ensureHighlightVisible();
    });

    container.on('close', function () {
      // When the dropdown is closed, aria-expended="false"
      self.$results.attr('aria-expanded', 'false');
      self.$results.attr('aria-hidden', 'true');
      self.$results.removeAttr('aria-activedescendant');
    });

    container.on('results:toggle', function () {
      var $highlighted = self.getHighlightedResults();

      if ($highlighted.length === 0) {
        return;
      }

      $highlighted.trigger('mouseup');
    });

    container.on('results:select', function () {
      var $highlighted = self.getHighlightedResults();

      if ($highlighted.length === 0) {
        return;
      }

      var data = $highlighted.data('data');

      if ($highlighted.attr('aria-selected') == 'true') {
        self.trigger('close');
      } else {
        self.trigger('select', {
          data: data
        });
      }
    });

    container.on('results:previous', function () {
      var $highlighted = self.getHighlightedResults();

      var $options = self.$results.find('[aria-selected]');

      var currentIndex = $options.index($highlighted);

      // If we are already at te top, don't move further
      if (currentIndex === 0) {
        return;
      }

      var nextIndex = currentIndex - 1;

      // If none are highlighted, highlight the first
      if ($highlighted.length === 0) {
        nextIndex = 0;
      }

      var $next = $options.eq(nextIndex);

      $next.trigger('mouseenter');

      var currentOffset = self.$results.offset().top;
      var nextTop = $next.offset().top;
      var nextOffset = self.$results.scrollTop() + (nextTop - currentOffset);

      if (nextIndex === 0) {
        self.$results.scrollTop(0);
      } else if (nextTop - currentOffset < 0) {
        self.$results.scrollTop(nextOffset);
      }
    });

    container.on('results:next', function () {
      var $highlighted = self.getHighlightedResults();

      var $options = self.$results.find('[aria-selected]');

      var currentIndex = $options.index($highlighted);

      var nextIndex = currentIndex + 1;

      // If we are at the last option, stay there
      if (nextIndex >= $options.length) {
        return;
      }

      var $next = $options.eq(nextIndex);

      $next.trigger('mouseenter');

      var currentOffset = self.$results.offset().top +
        self.$results.outerHeight(false);
      var nextBottom = $next.offset().top + $next.outerHeight(false);
      var nextOffset = self.$results.scrollTop() + nextBottom - currentOffset;

      if (nextIndex === 0) {
        self.$results.scrollTop(0);
      } else if (nextBottom > currentOffset) {
        self.$results.scrollTop(nextOffset);
      }
    });

    container.on('results:focus', function (params) {
      params.element.addClass('select2-results__option--highlighted');
    });

    container.on('results:message', function (params) {
      self.displayMessage(params);
    });

    if ($.fn.mousewheel) {
      this.$results.on('mousewheel', function (e) {
        var top = self.$results.scrollTop();

        var bottom = (
          self.$results.get(0).scrollHeight -
          self.$results.scrollTop() +
          e.deltaY
        );

        var isAtTop = e.deltaY > 0 && top - e.deltaY <= 0;
        var isAtBottom = e.deltaY < 0 && bottom <= self.$results.height();

        if (isAtTop) {
          self.$results.scrollTop(0);

          e.preventDefault();
          e.stopPropagation();
        } else if (isAtBottom) {
          self.$results.scrollTop(
            self.$results.get(0).scrollHeight - self.$results.height()
          );

          e.preventDefault();
          e.stopPropagation();
        }
      });
    }

    this.$results.on('mouseup', '.select2-results__option[aria-selected]',
      function (evt) {
      var $this = $(this);

      var data = $this.data('data');

      if ($this.attr('aria-selected') === 'true') {
        if (self.options.get('multiple')) {
          self.trigger('unselect', {
            originalEvent: evt,
            data: data
          });
        } else {
          self.trigger('close');
        }

        return;
      }

      self.trigger('select', {
        originalEvent: evt,
        data: data
      });
    });

    this.$results.on('mouseenter', '.select2-results__option[aria-selected]',
      function (evt) {
      var data = $(this).data('data');

      self.getHighlightedResults()
          .removeClass('select2-results__option--highlighted');

      self.trigger('results:focus', {
        data: data,
        element: $(this)
      });
    });
  };

  Results.prototype.getHighlightedResults = function () {
    var $highlighted = this.$results
    .find('.select2-results__option--highlighted');

    return $highlighted;
  };

  Results.prototype.destroy = function () {
    this.$results.remove();
  };

  Results.prototype.ensureHighlightVisible = function () {
    var $highlighted = this.getHighlightedResults();

    if ($highlighted.length === 0) {
      return;
    }

    var $options = this.$results.find('[aria-selected]');

    var currentIndex = $options.index($highlighted);

    var currentOffset = this.$results.offset().top;
    var nextTop = $highlighted.offset().top;
    var nextOffset = this.$results.scrollTop() + (nextTop - currentOffset);

    var offsetDelta = nextTop - currentOffset;
    nextOffset -= $highlighted.outerHeight(false) * 2;

    if (currentIndex <= 2) {
      this.$results.scrollTop(0);
    } else if (offsetDelta > this.$results.outerHeight() || offsetDelta < 0) {
      this.$results.scrollTop(nextOffset);
    }
  };

  Results.prototype.template = function (result, container) {
    var template = this.options.get('templateResult');
    var escapeMarkup = this.options.get('escapeMarkup');

    var content = template(result);

    if (content == null) {
      container.style.display = 'none';
    } else if (typeof content === 'string') {
      container.innerHTML = escapeMarkup(content);
    } else {
      $(container).append(content);
    }
  };

  return Results;
});

S2.define('select2/keys',[

], function () {
  var KEYS = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    DELETE: 46
  };

  return KEYS;
});

S2.define('select2/selection/base',[
  'jquery',
  '../utils',
  '../keys'
], function ($, Utils, KEYS) {
  function BaseSelection ($element, options) {
    this.$element = $element;
    this.options = options;

    BaseSelection.__super__.constructor.call(this);
  }

  Utils.Extend(BaseSelection, Utils.Observable);

  BaseSelection.prototype.render = function () {
    var $selection = $(
      '<span class="select2-selection" role="combobox" ' +
      'aria-autocomplete="list" aria-haspopup="true" aria-expanded="false">' +
      '</span>'
    );

    this._tabindex = 0;

    if (this.$element.data('old-tabindex') != null) {
      this._tabindex = this.$element.data('old-tabindex');
    } else if (this.$element.attr('tabindex') != null) {
      this._tabindex = this.$element.attr('tabindex');
    }

    $selection.attr('title', this.$element.attr('title'));
    $selection.attr('tabindex', this._tabindex);

    this.$selection = $selection;

    return $selection;
  };

  BaseSelection.prototype.bind = function (container, $container) {
    var self = this;

    var id = container.id + '-container';
    var resultsId = container.id + '-results';

    this.container = container;

    this.$selection.on('focus', function (evt) {
      self.trigger('focus', evt);
    });

    this.$selection.on('blur', function (evt) {
      self.trigger('blur', evt);
    });

    this.$selection.on('keydown', function (evt) {
      self.trigger('keypress', evt);

      if (evt.which === KEYS.SPACE) {
        evt.preventDefault();
      }
    });

    container.on('results:focus', function (params) {
      self.$selection.attr('aria-activedescendant', params.data._resultId);
    });

    container.on('selection:update', function (params) {
      self.update(params.data);
    });

    container.on('open', function () {
      // When the dropdown is open, aria-expanded="true"
      self.$selection.attr('aria-expanded', 'true');
      self.$selection.attr('aria-owns', resultsId);

      self._attachCloseHandler(container);
    });

    container.on('close', function () {
      // When the dropdown is closed, aria-expanded="false"
      self.$selection.attr('aria-expanded', 'false');
      self.$selection.removeAttr('aria-activedescendant');
      self.$selection.removeAttr('aria-owns');

      self.$selection.focus();

      self._detachCloseHandler(container);
    });

    container.on('enable', function () {
      self.$selection.attr('tabindex', self._tabindex);
    });

    container.on('disable', function () {
      self.$selection.attr('tabindex', '-1');
    });
  };

  BaseSelection.prototype._attachCloseHandler = function (container) {
    var self = this;

    $(document.body).on('mousedown.select2.' + container.id, function (e) {
      var $target = $(e.target);

      var $select = $target.closest('.select2');

      var $all = $('.select2.select2-container--open');

      $all.each(function () {
        var $this = $(this);

        if (this == $select[0]) {
          return;
        }

        var $element = $this.data('element');

        $element.select2('close');
      });
    });
  };

  BaseSelection.prototype._detachCloseHandler = function (container) {
    $(document.body).off('mousedown.select2.' + container.id);
  };

  BaseSelection.prototype.position = function ($selection, $container) {
    var $selectionContainer = $container.find('.selection');
    $selectionContainer.append($selection);
  };

  BaseSelection.prototype.destroy = function () {
    this._detachCloseHandler(this.container);
  };

  BaseSelection.prototype.update = function (data) {
    throw new Error('The `update` method must be defined in child classes.');
  };

  return BaseSelection;
});

S2.define('select2/selection/single',[
  'jquery',
  './base',
  '../utils',
  '../keys'
], function ($, BaseSelection, Utils, KEYS) {
  function SingleSelection () {
    SingleSelection.__super__.constructor.apply(this, arguments);
  }

  Utils.Extend(SingleSelection, BaseSelection);

  SingleSelection.prototype.render = function () {
    var $selection = SingleSelection.__super__.render.call(this);

    $selection.addClass('select2-selection--single');

    $selection.html(
      '<span class="select2-selection__rendered"></span>' +
      '<span class="select2-selection__arrow" role="presentation">' +
        '<b role="presentation"></b>' +
      '</span>'
    );

    return $selection;
  };

  SingleSelection.prototype.bind = function (container, $container) {
    var self = this;

    SingleSelection.__super__.bind.apply(this, arguments);

    var id = container.id + '-container';

    this.$selection.find('.select2-selection__rendered').attr('id', id);
    this.$selection.attr('aria-labelledby', id);

    this.$selection.on('mousedown', function (evt) {
      // Only respond to left clicks
      if (evt.which !== 1) {
        return;
      }

      self.trigger('toggle', {
        originalEvent: evt
      });
    });

    this.$selection.on('focus', function (evt) {
      // User focuses on the container
    });

    this.$selection.on('blur', function (evt) {
      // User exits the container
    });

    container.on('selection:update', function (params) {
      self.update(params.data);
    });
  };

  SingleSelection.prototype.clear = function () {
    this.$selection.find('.select2-selection__rendered').empty();
  };

  SingleSelection.prototype.display = function (data) {
    var template = this.options.get('templateSelection');
    var escapeMarkup = this.options.get('escapeMarkup');

    return escapeMarkup(template(data));
  };

  SingleSelection.prototype.selectionContainer = function () {
    return $('<span></span>');
  };

  SingleSelection.prototype.update = function (data) {
    if (data.length === 0) {
      this.clear();
      return;
    }

    var selection = data[0];

    var formatted = this.display(selection);

    var $rendered = this.$selection.find('.select2-selection__rendered');
    $rendered.empty().append(formatted);
    $rendered.prop('title', selection.title || selection.text);
  };

  return SingleSelection;
});

S2.define('select2/selection/multiple',[
  'jquery',
  './base',
  '../utils'
], function ($, BaseSelection, Utils) {
  function MultipleSelection ($element, options) {
    MultipleSelection.__super__.constructor.apply(this, arguments);
  }

  Utils.Extend(MultipleSelection, BaseSelection);

  MultipleSelection.prototype.render = function () {
    var $selection = MultipleSelection.__super__.render.call(this);

    $selection.addClass('select2-selection--multiple');

    $selection.html(
      '<ul class="select2-selection__rendered"></ul>'
    );

    return $selection;
  };

  MultipleSelection.prototype.bind = function (container, $container) {
    var self = this;

    MultipleSelection.__super__.bind.apply(this, arguments);

    this.$selection.on('click', function (evt) {
      self.trigger('toggle', {
        originalEvent: evt
      });
    });

    this.$selection.on('click', '.select2-selection__choice__remove',
      function (evt) {
      var $remove = $(this);
      var $selection = $remove.parent();

      var data = $selection.data('data');

      self.trigger('unselect', {
        originalEvent: evt,
        data: data
      });
    });
  };

  MultipleSelection.prototype.clear = function () {
    this.$selection.find('.select2-selection__rendered').empty();
  };

  MultipleSelection.prototype.display = function (data) {
    var template = this.options.get('templateSelection');
    var escapeMarkup = this.options.get('escapeMarkup');

    return escapeMarkup(template(data));
  };

  MultipleSelection.prototype.selectionContainer = function () {
    var $container = $(
      '<li class="select2-selection__choice">' +
        '<span class="select2-selection__choice__remove" role="presentation">' +
          '&times;' +
        '</span>' +
      '</li>'
    );

    return $container;
  };

  MultipleSelection.prototype.update = function (data) {
    this.clear();

    if (data.length === 0) {
      return;
    }

    var $selections = $();

    for (var d = 0; d < data.length; d++) {
      var selection = data[d];

      var formatted = this.display(selection);
      var $selection = this.selectionContainer();

      $selection.append(formatted);
      $selection.prop('title', selection.title || selection.text);

      $selection.data('data', selection);

      $selections = $selections.add($selection);
    }

    this.$selection.find('.select2-selection__rendered').append($selections);
  };

  return MultipleSelection;
});

S2.define('select2/selection/placeholder',[
  '../utils'
], function (Utils) {
  function Placeholder (decorated, $element, options) {
    this.placeholder = this.normalizePlaceholder(options.get('placeholder'));

    decorated.call(this, $element, options);
  }

  Placeholder.prototype.normalizePlaceholder = function (_, placeholder) {
    if (typeof placeholder === 'string') {
      placeholder = {
        id: '',
        text: placeholder
      };
    }

    return placeholder;
  };

  Placeholder.prototype.createPlaceholder = function (decorated, placeholder) {
    var $placeholder = this.selectionContainer();

    $placeholder.html(this.display(placeholder));
    $placeholder.addClass('select2-selection__placeholder')
                .removeClass('select2-selection__choice');

    return $placeholder;
  };

  Placeholder.prototype.update = function (decorated, data) {
    var singlePlaceholder = (
      data.length == 1 && data[0].id != this.placeholder.id
    );
    var multipleSelections = data.length > 1;

    if (multipleSelections || singlePlaceholder) {
      return decorated.call(this, data);
    }

    this.clear();

    var $placeholder = this.createPlaceholder(this.placeholder);

    this.$selection.find('.select2-selection__rendered').append($placeholder);
  };

  return Placeholder;
});

S2.define('select2/selection/allowClear',[
  'jquery'
], function ($) {
  function AllowClear () { }

  AllowClear.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    if (self.placeholder == null) {
      if (self.options.get('debug') && window.console && console.error) {
        console.error(
          'Select2: The `allowClear` option should be used in combination ' +
          'with the `placeholder` option.'
        );
      }
    }

    this.$selection.on('mousedown', '.select2-selection__clear',
      function (evt) {
        // Ignore the event if it is disabled
        if (self.options.get('disabled')) {
          return;
        }

        evt.stopPropagation();

        var data = $(this).data('data');

        for (var d = 0; d < data.length; d++) {
          var unselectData = {
            data: data[d]
          };

          // Trigger the `unselect` event, so people can prevent it from being
          // cleared.
          self.trigger('unselect', unselectData);

          // If the event was prevented, don't clear it out.
          if (unselectData.prevented) {
            return;
          }
        }

        self.$element.val(self.placeholder.id).trigger('change');

        self.trigger('toggle');
    });
  };

  AllowClear.prototype.update = function (decorated, data) {
    decorated.call(this, data);

    if (this.$selection.find('.select2-selection__placeholder').length > 0 ||
        data.length === 0) {
      return;
    }

    var $remove = $(
      '<span class="select2-selection__clear">' +
        '&times;' +
      '</span>'
    );
    $remove.data('data', data);

    this.$selection.find('.select2-selection__rendered').prepend($remove);
  };

  return AllowClear;
});

S2.define('select2/selection/search',[
  'jquery',
  '../utils',
  '../keys'
], function ($, Utils, KEYS) {
  function Search (decorated, $element, options) {
    decorated.call(this, $element, options);
  }

  Search.prototype.render = function (decorated) {
    var $search = $(
      '<li class="select2-search select2-search--inline">' +
        '<input class="select2-search__field" type="search" tabindex="-1"' +
        ' autocomplete="off" autocorrect="off" autocapitalize="off"' +
        ' spellcheck="false" role="textbox" />' +
      '</li>'
    );

    this.$searchContainer = $search;
    this.$search = $search.find('input');

    var $rendered = decorated.call(this);

    return $rendered;
  };

  Search.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    container.on('open', function () {
      self.$search.attr('tabindex', 0);

      self.$search.focus();
    });

    container.on('close', function () {
      self.$search.attr('tabindex', -1);

      self.$search.val('');
      self.$search.focus();
    });

    container.on('enable', function () {
      self.$search.prop('disabled', false);
    });

    container.on('disable', function () {
      self.$search.prop('disabled', true);
    });

    this.$selection.on('focusin', '.select2-search--inline', function (evt) {
      self.trigger('focus', evt);
    });

    this.$selection.on('focusout', '.select2-search--inline', function (evt) {
      self.trigger('blur', evt);
    });

    this.$selection.on('keydown', '.select2-search--inline', function (evt) {
      evt.stopPropagation();

      self.trigger('keypress', evt);

      self._keyUpPrevented = evt.isDefaultPrevented();

      var key = evt.which;

      if (key === KEYS.BACKSPACE && self.$search.val() === '') {
        var $previousChoice = self.$searchContainer
          .prev('.select2-selection__choice');

        if ($previousChoice.length > 0) {
          var item = $previousChoice.data('data');

          self.searchRemoveChoice(item);
        }
      }
    });

    // Workaround for browsers which do not support the `input` event
    // This will prevent double-triggering of events for browsers which support
    // both the `keyup` and `input` events.
    this.$selection.on('input', '.select2-search--inline', function (evt) {
      // Unbind the duplicated `keyup` event
      self.$selection.off('keyup.search');
    });

    this.$selection.on('keyup.search input', '.select2-search--inline',
        function (evt) {
      self.handleSearch(evt);
    });
  };

  Search.prototype.createPlaceholder = function (decorated, placeholder) {
    this.$search.attr('placeholder', placeholder.text);
  };

  Search.prototype.update = function (decorated, data) {
    this.$search.attr('placeholder', '');

    decorated.call(this, data);

    this.$selection.find('.select2-selection__rendered')
                   .append(this.$searchContainer);

    this.resizeSearch();
  };

  Search.prototype.handleSearch = function () {
    this.resizeSearch();

    if (!this._keyUpPrevented) {
      var input = this.$search.val();

      this.trigger('query', {
        term: input
      });
    }

    this._keyUpPrevented = false;
  };

  Search.prototype.searchRemoveChoice = function (decorated, item) {
    this.trigger('unselect', {
      data: item
    });

    this.trigger('open');

    this.$search.val(item.text + ' ');
  };

  Search.prototype.resizeSearch = function () {
    this.$search.css('width', '25px');

    var width = '';

    if (this.$search.attr('placeholder') !== '') {
      width = this.$selection.find('.select2-selection__rendered').innerWidth();
    } else {
      var minimumWidth = this.$search.val().length + 1;

      width = (minimumWidth * 0.75) + 'em';
    }

    this.$search.css('width', width);
  };

  return Search;
});

S2.define('select2/selection/eventRelay',[
  'jquery'
], function ($) {
  function EventRelay () { }

  EventRelay.prototype.bind = function (decorated, container, $container) {
    var self = this;
    var relayEvents = [
      'open', 'opening',
      'close', 'closing',
      'select', 'selecting',
      'unselect', 'unselecting'
    ];

    var preventableEvents = ['opening', 'closing', 'selecting', 'unselecting'];

    decorated.call(this, container, $container);

    container.on('*', function (name, params) {
      // Ignore events that should not be relayed
      if ($.inArray(name, relayEvents) === -1) {
        return;
      }

      // The parameters should always be an object
      params = params || {};

      // Generate the jQuery event for the Select2 event
      var evt = $.Event('select2:' + name, {
        params: params
      });

      self.$element.trigger(evt);

      // Only handle preventable events if it was one
      if ($.inArray(name, preventableEvents) === -1) {
        return;
      }

      params.prevented = evt.isDefaultPrevented();
    });
  };

  return EventRelay;
});

S2.define('select2/translation',[
  'jquery',
  'require'
], function ($, require) {
  function Translation (dict) {
    this.dict = dict || {};
  }

  Translation.prototype.all = function () {
    return this.dict;
  };

  Translation.prototype.get = function (key) {
    return this.dict[key];
  };

  Translation.prototype.extend = function (translation) {
    this.dict = $.extend({}, translation.all(), this.dict);
  };

  // Static functions

  Translation._cache = {};

  Translation.loadPath = function (path) {
    if (!(path in Translation._cache)) {
      var translations = require(path);

      Translation._cache[path] = translations;
    }

    return new Translation(Translation._cache[path]);
  };

  return Translation;
});

S2.define('select2/diacritics',[

], function () {
  var diacritics = {
    '\u24B6': 'A',
    '\uFF21': 'A',
    '\u00C0': 'A',
    '\u00C1': 'A',
    '\u00C2': 'A',
    '\u1EA6': 'A',
    '\u1EA4': 'A',
    '\u1EAA': 'A',
    '\u1EA8': 'A',
    '\u00C3': 'A',
    '\u0100': 'A',
    '\u0102': 'A',
    '\u1EB0': 'A',
    '\u1EAE': 'A',
    '\u1EB4': 'A',
    '\u1EB2': 'A',
    '\u0226': 'A',
    '\u01E0': 'A',
    '\u00C4': 'A',
    '\u01DE': 'A',
    '\u1EA2': 'A',
    '\u00C5': 'A',
    '\u01FA': 'A',
    '\u01CD': 'A',
    '\u0200': 'A',
    '\u0202': 'A',
    '\u1EA0': 'A',
    '\u1EAC': 'A',
    '\u1EB6': 'A',
    '\u1E00': 'A',
    '\u0104': 'A',
    '\u023A': 'A',
    '\u2C6F': 'A',
    '\uA732': 'AA',
    '\u00C6': 'AE',
    '\u01FC': 'AE',
    '\u01E2': 'AE',
    '\uA734': 'AO',
    '\uA736': 'AU',
    '\uA738': 'AV',
    '\uA73A': 'AV',
    '\uA73C': 'AY',
    '\u24B7': 'B',
    '\uFF22': 'B',
    '\u1E02': 'B',
    '\u1E04': 'B',
    '\u1E06': 'B',
    '\u0243': 'B',
    '\u0182': 'B',
    '\u0181': 'B',
    '\u24B8': 'C',
    '\uFF23': 'C',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010A': 'C',
    '\u010C': 'C',
    '\u00C7': 'C',
    '\u1E08': 'C',
    '\u0187': 'C',
    '\u023B': 'C',
    '\uA73E': 'C',
    '\u24B9': 'D',
    '\uFF24': 'D',
    '\u1E0A': 'D',
    '\u010E': 'D',
    '\u1E0C': 'D',
    '\u1E10': 'D',
    '\u1E12': 'D',
    '\u1E0E': 'D',
    '\u0110': 'D',
    '\u018B': 'D',
    '\u018A': 'D',
    '\u0189': 'D',
    '\uA779': 'D',
    '\u01F1': 'DZ',
    '\u01C4': 'DZ',
    '\u01F2': 'Dz',
    '\u01C5': 'Dz',
    '\u24BA': 'E',
    '\uFF25': 'E',
    '\u00C8': 'E',
    '\u00C9': 'E',
    '\u00CA': 'E',
    '\u1EC0': 'E',
    '\u1EBE': 'E',
    '\u1EC4': 'E',
    '\u1EC2': 'E',
    '\u1EBC': 'E',
    '\u0112': 'E',
    '\u1E14': 'E',
    '\u1E16': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u00CB': 'E',
    '\u1EBA': 'E',
    '\u011A': 'E',
    '\u0204': 'E',
    '\u0206': 'E',
    '\u1EB8': 'E',
    '\u1EC6': 'E',
    '\u0228': 'E',
    '\u1E1C': 'E',
    '\u0118': 'E',
    '\u1E18': 'E',
    '\u1E1A': 'E',
    '\u0190': 'E',
    '\u018E': 'E',
    '\u24BB': 'F',
    '\uFF26': 'F',
    '\u1E1E': 'F',
    '\u0191': 'F',
    '\uA77B': 'F',
    '\u24BC': 'G',
    '\uFF27': 'G',
    '\u01F4': 'G',
    '\u011C': 'G',
    '\u1E20': 'G',
    '\u011E': 'G',
    '\u0120': 'G',
    '\u01E6': 'G',
    '\u0122': 'G',
    '\u01E4': 'G',
    '\u0193': 'G',
    '\uA7A0': 'G',
    '\uA77D': 'G',
    '\uA77E': 'G',
    '\u24BD': 'H',
    '\uFF28': 'H',
    '\u0124': 'H',
    '\u1E22': 'H',
    '\u1E26': 'H',
    '\u021E': 'H',
    '\u1E24': 'H',
    '\u1E28': 'H',
    '\u1E2A': 'H',
    '\u0126': 'H',
    '\u2C67': 'H',
    '\u2C75': 'H',
    '\uA78D': 'H',
    '\u24BE': 'I',
    '\uFF29': 'I',
    '\u00CC': 'I',
    '\u00CD': 'I',
    '\u00CE': 'I',
    '\u0128': 'I',
    '\u012A': 'I',
    '\u012C': 'I',
    '\u0130': 'I',
    '\u00CF': 'I',
    '\u1E2E': 'I',
    '\u1EC8': 'I',
    '\u01CF': 'I',
    '\u0208': 'I',
    '\u020A': 'I',
    '\u1ECA': 'I',
    '\u012E': 'I',
    '\u1E2C': 'I',
    '\u0197': 'I',
    '\u24BF': 'J',
    '\uFF2A': 'J',
    '\u0134': 'J',
    '\u0248': 'J',
    '\u24C0': 'K',
    '\uFF2B': 'K',
    '\u1E30': 'K',
    '\u01E8': 'K',
    '\u1E32': 'K',
    '\u0136': 'K',
    '\u1E34': 'K',
    '\u0198': 'K',
    '\u2C69': 'K',
    '\uA740': 'K',
    '\uA742': 'K',
    '\uA744': 'K',
    '\uA7A2': 'K',
    '\u24C1': 'L',
    '\uFF2C': 'L',
    '\u013F': 'L',
    '\u0139': 'L',
    '\u013D': 'L',
    '\u1E36': 'L',
    '\u1E38': 'L',
    '\u013B': 'L',
    '\u1E3C': 'L',
    '\u1E3A': 'L',
    '\u0141': 'L',
    '\u023D': 'L',
    '\u2C62': 'L',
    '\u2C60': 'L',
    '\uA748': 'L',
    '\uA746': 'L',
    '\uA780': 'L',
    '\u01C7': 'LJ',
    '\u01C8': 'Lj',
    '\u24C2': 'M',
    '\uFF2D': 'M',
    '\u1E3E': 'M',
    '\u1E40': 'M',
    '\u1E42': 'M',
    '\u2C6E': 'M',
    '\u019C': 'M',
    '\u24C3': 'N',
    '\uFF2E': 'N',
    '\u01F8': 'N',
    '\u0143': 'N',
    '\u00D1': 'N',
    '\u1E44': 'N',
    '\u0147': 'N',
    '\u1E46': 'N',
    '\u0145': 'N',
    '\u1E4A': 'N',
    '\u1E48': 'N',
    '\u0220': 'N',
    '\u019D': 'N',
    '\uA790': 'N',
    '\uA7A4': 'N',
    '\u01CA': 'NJ',
    '\u01CB': 'Nj',
    '\u24C4': 'O',
    '\uFF2F': 'O',
    '\u00D2': 'O',
    '\u00D3': 'O',
    '\u00D4': 'O',
    '\u1ED2': 'O',
    '\u1ED0': 'O',
    '\u1ED6': 'O',
    '\u1ED4': 'O',
    '\u00D5': 'O',
    '\u1E4C': 'O',
    '\u022C': 'O',
    '\u1E4E': 'O',
    '\u014C': 'O',
    '\u1E50': 'O',
    '\u1E52': 'O',
    '\u014E': 'O',
    '\u022E': 'O',
    '\u0230': 'O',
    '\u00D6': 'O',
    '\u022A': 'O',
    '\u1ECE': 'O',
    '\u0150': 'O',
    '\u01D1': 'O',
    '\u020C': 'O',
    '\u020E': 'O',
    '\u01A0': 'O',
    '\u1EDC': 'O',
    '\u1EDA': 'O',
    '\u1EE0': 'O',
    '\u1EDE': 'O',
    '\u1EE2': 'O',
    '\u1ECC': 'O',
    '\u1ED8': 'O',
    '\u01EA': 'O',
    '\u01EC': 'O',
    '\u00D8': 'O',
    '\u01FE': 'O',
    '\u0186': 'O',
    '\u019F': 'O',
    '\uA74A': 'O',
    '\uA74C': 'O',
    '\u01A2': 'OI',
    '\uA74E': 'OO',
    '\u0222': 'OU',
    '\u24C5': 'P',
    '\uFF30': 'P',
    '\u1E54': 'P',
    '\u1E56': 'P',
    '\u01A4': 'P',
    '\u2C63': 'P',
    '\uA750': 'P',
    '\uA752': 'P',
    '\uA754': 'P',
    '\u24C6': 'Q',
    '\uFF31': 'Q',
    '\uA756': 'Q',
    '\uA758': 'Q',
    '\u024A': 'Q',
    '\u24C7': 'R',
    '\uFF32': 'R',
    '\u0154': 'R',
    '\u1E58': 'R',
    '\u0158': 'R',
    '\u0210': 'R',
    '\u0212': 'R',
    '\u1E5A': 'R',
    '\u1E5C': 'R',
    '\u0156': 'R',
    '\u1E5E': 'R',
    '\u024C': 'R',
    '\u2C64': 'R',
    '\uA75A': 'R',
    '\uA7A6': 'R',
    '\uA782': 'R',
    '\u24C8': 'S',
    '\uFF33': 'S',
    '\u1E9E': 'S',
    '\u015A': 'S',
    '\u1E64': 'S',
    '\u015C': 'S',
    '\u1E60': 'S',
    '\u0160': 'S',
    '\u1E66': 'S',
    '\u1E62': 'S',
    '\u1E68': 'S',
    '\u0218': 'S',
    '\u015E': 'S',
    '\u2C7E': 'S',
    '\uA7A8': 'S',
    '\uA784': 'S',
    '\u24C9': 'T',
    '\uFF34': 'T',
    '\u1E6A': 'T',
    '\u0164': 'T',
    '\u1E6C': 'T',
    '\u021A': 'T',
    '\u0162': 'T',
    '\u1E70': 'T',
    '\u1E6E': 'T',
    '\u0166': 'T',
    '\u01AC': 'T',
    '\u01AE': 'T',
    '\u023E': 'T',
    '\uA786': 'T',
    '\uA728': 'TZ',
    '\u24CA': 'U',
    '\uFF35': 'U',
    '\u00D9': 'U',
    '\u00DA': 'U',
    '\u00DB': 'U',
    '\u0168': 'U',
    '\u1E78': 'U',
    '\u016A': 'U',
    '\u1E7A': 'U',
    '\u016C': 'U',
    '\u00DC': 'U',
    '\u01DB': 'U',
    '\u01D7': 'U',
    '\u01D5': 'U',
    '\u01D9': 'U',
    '\u1EE6': 'U',
    '\u016E': 'U',
    '\u0170': 'U',
    '\u01D3': 'U',
    '\u0214': 'U',
    '\u0216': 'U',
    '\u01AF': 'U',
    '\u1EEA': 'U',
    '\u1EE8': 'U',
    '\u1EEE': 'U',
    '\u1EEC': 'U',
    '\u1EF0': 'U',
    '\u1EE4': 'U',
    '\u1E72': 'U',
    '\u0172': 'U',
    '\u1E76': 'U',
    '\u1E74': 'U',
    '\u0244': 'U',
    '\u24CB': 'V',
    '\uFF36': 'V',
    '\u1E7C': 'V',
    '\u1E7E': 'V',
    '\u01B2': 'V',
    '\uA75E': 'V',
    '\u0245': 'V',
    '\uA760': 'VY',
    '\u24CC': 'W',
    '\uFF37': 'W',
    '\u1E80': 'W',
    '\u1E82': 'W',
    '\u0174': 'W',
    '\u1E86': 'W',
    '\u1E84': 'W',
    '\u1E88': 'W',
    '\u2C72': 'W',
    '\u24CD': 'X',
    '\uFF38': 'X',
    '\u1E8A': 'X',
    '\u1E8C': 'X',
    '\u24CE': 'Y',
    '\uFF39': 'Y',
    '\u1EF2': 'Y',
    '\u00DD': 'Y',
    '\u0176': 'Y',
    '\u1EF8': 'Y',
    '\u0232': 'Y',
    '\u1E8E': 'Y',
    '\u0178': 'Y',
    '\u1EF6': 'Y',
    '\u1EF4': 'Y',
    '\u01B3': 'Y',
    '\u024E': 'Y',
    '\u1EFE': 'Y',
    '\u24CF': 'Z',
    '\uFF3A': 'Z',
    '\u0179': 'Z',
    '\u1E90': 'Z',
    '\u017B': 'Z',
    '\u017D': 'Z',
    '\u1E92': 'Z',
    '\u1E94': 'Z',
    '\u01B5': 'Z',
    '\u0224': 'Z',
    '\u2C7F': 'Z',
    '\u2C6B': 'Z',
    '\uA762': 'Z',
    '\u24D0': 'a',
    '\uFF41': 'a',
    '\u1E9A': 'a',
    '\u00E0': 'a',
    '\u00E1': 'a',
    '\u00E2': 'a',
    '\u1EA7': 'a',
    '\u1EA5': 'a',
    '\u1EAB': 'a',
    '\u1EA9': 'a',
    '\u00E3': 'a',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u1EB1': 'a',
    '\u1EAF': 'a',
    '\u1EB5': 'a',
    '\u1EB3': 'a',
    '\u0227': 'a',
    '\u01E1': 'a',
    '\u00E4': 'a',
    '\u01DF': 'a',
    '\u1EA3': 'a',
    '\u00E5': 'a',
    '\u01FB': 'a',
    '\u01CE': 'a',
    '\u0201': 'a',
    '\u0203': 'a',
    '\u1EA1': 'a',
    '\u1EAD': 'a',
    '\u1EB7': 'a',
    '\u1E01': 'a',
    '\u0105': 'a',
    '\u2C65': 'a',
    '\u0250': 'a',
    '\uA733': 'aa',
    '\u00E6': 'ae',
    '\u01FD': 'ae',
    '\u01E3': 'ae',
    '\uA735': 'ao',
    '\uA737': 'au',
    '\uA739': 'av',
    '\uA73B': 'av',
    '\uA73D': 'ay',
    '\u24D1': 'b',
    '\uFF42': 'b',
    '\u1E03': 'b',
    '\u1E05': 'b',
    '\u1E07': 'b',
    '\u0180': 'b',
    '\u0183': 'b',
    '\u0253': 'b',
    '\u24D2': 'c',
    '\uFF43': 'c',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010B': 'c',
    '\u010D': 'c',
    '\u00E7': 'c',
    '\u1E09': 'c',
    '\u0188': 'c',
    '\u023C': 'c',
    '\uA73F': 'c',
    '\u2184': 'c',
    '\u24D3': 'd',
    '\uFF44': 'd',
    '\u1E0B': 'd',
    '\u010F': 'd',
    '\u1E0D': 'd',
    '\u1E11': 'd',
    '\u1E13': 'd',
    '\u1E0F': 'd',
    '\u0111': 'd',
    '\u018C': 'd',
    '\u0256': 'd',
    '\u0257': 'd',
    '\uA77A': 'd',
    '\u01F3': 'dz',
    '\u01C6': 'dz',
    '\u24D4': 'e',
    '\uFF45': 'e',
    '\u00E8': 'e',
    '\u00E9': 'e',
    '\u00EA': 'e',
    '\u1EC1': 'e',
    '\u1EBF': 'e',
    '\u1EC5': 'e',
    '\u1EC3': 'e',
    '\u1EBD': 'e',
    '\u0113': 'e',
    '\u1E15': 'e',
    '\u1E17': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u00EB': 'e',
    '\u1EBB': 'e',
    '\u011B': 'e',
    '\u0205': 'e',
    '\u0207': 'e',
    '\u1EB9': 'e',
    '\u1EC7': 'e',
    '\u0229': 'e',
    '\u1E1D': 'e',
    '\u0119': 'e',
    '\u1E19': 'e',
    '\u1E1B': 'e',
    '\u0247': 'e',
    '\u025B': 'e',
    '\u01DD': 'e',
    '\u24D5': 'f',
    '\uFF46': 'f',
    '\u1E1F': 'f',
    '\u0192': 'f',
    '\uA77C': 'f',
    '\u24D6': 'g',
    '\uFF47': 'g',
    '\u01F5': 'g',
    '\u011D': 'g',
    '\u1E21': 'g',
    '\u011F': 'g',
    '\u0121': 'g',
    '\u01E7': 'g',
    '\u0123': 'g',
    '\u01E5': 'g',
    '\u0260': 'g',
    '\uA7A1': 'g',
    '\u1D79': 'g',
    '\uA77F': 'g',
    '\u24D7': 'h',
    '\uFF48': 'h',
    '\u0125': 'h',
    '\u1E23': 'h',
    '\u1E27': 'h',
    '\u021F': 'h',
    '\u1E25': 'h',
    '\u1E29': 'h',
    '\u1E2B': 'h',
    '\u1E96': 'h',
    '\u0127': 'h',
    '\u2C68': 'h',
    '\u2C76': 'h',
    '\u0265': 'h',
    '\u0195': 'hv',
    '\u24D8': 'i',
    '\uFF49': 'i',
    '\u00EC': 'i',
    '\u00ED': 'i',
    '\u00EE': 'i',
    '\u0129': 'i',
    '\u012B': 'i',
    '\u012D': 'i',
    '\u00EF': 'i',
    '\u1E2F': 'i',
    '\u1EC9': 'i',
    '\u01D0': 'i',
    '\u0209': 'i',
    '\u020B': 'i',
    '\u1ECB': 'i',
    '\u012F': 'i',
    '\u1E2D': 'i',
    '\u0268': 'i',
    '\u0131': 'i',
    '\u24D9': 'j',
    '\uFF4A': 'j',
    '\u0135': 'j',
    '\u01F0': 'j',
    '\u0249': 'j',
    '\u24DA': 'k',
    '\uFF4B': 'k',
    '\u1E31': 'k',
    '\u01E9': 'k',
    '\u1E33': 'k',
    '\u0137': 'k',
    '\u1E35': 'k',
    '\u0199': 'k',
    '\u2C6A': 'k',
    '\uA741': 'k',
    '\uA743': 'k',
    '\uA745': 'k',
    '\uA7A3': 'k',
    '\u24DB': 'l',
    '\uFF4C': 'l',
    '\u0140': 'l',
    '\u013A': 'l',
    '\u013E': 'l',
    '\u1E37': 'l',
    '\u1E39': 'l',
    '\u013C': 'l',
    '\u1E3D': 'l',
    '\u1E3B': 'l',
    '\u017F': 'l',
    '\u0142': 'l',
    '\u019A': 'l',
    '\u026B': 'l',
    '\u2C61': 'l',
    '\uA749': 'l',
    '\uA781': 'l',
    '\uA747': 'l',
    '\u01C9': 'lj',
    '\u24DC': 'm',
    '\uFF4D': 'm',
    '\u1E3F': 'm',
    '\u1E41': 'm',
    '\u1E43': 'm',
    '\u0271': 'm',
    '\u026F': 'm',
    '\u24DD': 'n',
    '\uFF4E': 'n',
    '\u01F9': 'n',
    '\u0144': 'n',
    '\u00F1': 'n',
    '\u1E45': 'n',
    '\u0148': 'n',
    '\u1E47': 'n',
    '\u0146': 'n',
    '\u1E4B': 'n',
    '\u1E49': 'n',
    '\u019E': 'n',
    '\u0272': 'n',
    '\u0149': 'n',
    '\uA791': 'n',
    '\uA7A5': 'n',
    '\u01CC': 'nj',
    '\u24DE': 'o',
    '\uFF4F': 'o',
    '\u00F2': 'o',
    '\u00F3': 'o',
    '\u00F4': 'o',
    '\u1ED3': 'o',
    '\u1ED1': 'o',
    '\u1ED7': 'o',
    '\u1ED5': 'o',
    '\u00F5': 'o',
    '\u1E4D': 'o',
    '\u022D': 'o',
    '\u1E4F': 'o',
    '\u014D': 'o',
    '\u1E51': 'o',
    '\u1E53': 'o',
    '\u014F': 'o',
    '\u022F': 'o',
    '\u0231': 'o',
    '\u00F6': 'o',
    '\u022B': 'o',
    '\u1ECF': 'o',
    '\u0151': 'o',
    '\u01D2': 'o',
    '\u020D': 'o',
    '\u020F': 'o',
    '\u01A1': 'o',
    '\u1EDD': 'o',
    '\u1EDB': 'o',
    '\u1EE1': 'o',
    '\u1EDF': 'o',
    '\u1EE3': 'o',
    '\u1ECD': 'o',
    '\u1ED9': 'o',
    '\u01EB': 'o',
    '\u01ED': 'o',
    '\u00F8': 'o',
    '\u01FF': 'o',
    '\u0254': 'o',
    '\uA74B': 'o',
    '\uA74D': 'o',
    '\u0275': 'o',
    '\u01A3': 'oi',
    '\u0223': 'ou',
    '\uA74F': 'oo',
    '\u24DF': 'p',
    '\uFF50': 'p',
    '\u1E55': 'p',
    '\u1E57': 'p',
    '\u01A5': 'p',
    '\u1D7D': 'p',
    '\uA751': 'p',
    '\uA753': 'p',
    '\uA755': 'p',
    '\u24E0': 'q',
    '\uFF51': 'q',
    '\u024B': 'q',
    '\uA757': 'q',
    '\uA759': 'q',
    '\u24E1': 'r',
    '\uFF52': 'r',
    '\u0155': 'r',
    '\u1E59': 'r',
    '\u0159': 'r',
    '\u0211': 'r',
    '\u0213': 'r',
    '\u1E5B': 'r',
    '\u1E5D': 'r',
    '\u0157': 'r',
    '\u1E5F': 'r',
    '\u024D': 'r',
    '\u027D': 'r',
    '\uA75B': 'r',
    '\uA7A7': 'r',
    '\uA783': 'r',
    '\u24E2': 's',
    '\uFF53': 's',
    '\u00DF': 's',
    '\u015B': 's',
    '\u1E65': 's',
    '\u015D': 's',
    '\u1E61': 's',
    '\u0161': 's',
    '\u1E67': 's',
    '\u1E63': 's',
    '\u1E69': 's',
    '\u0219': 's',
    '\u015F': 's',
    '\u023F': 's',
    '\uA7A9': 's',
    '\uA785': 's',
    '\u1E9B': 's',
    '\u24E3': 't',
    '\uFF54': 't',
    '\u1E6B': 't',
    '\u1E97': 't',
    '\u0165': 't',
    '\u1E6D': 't',
    '\u021B': 't',
    '\u0163': 't',
    '\u1E71': 't',
    '\u1E6F': 't',
    '\u0167': 't',
    '\u01AD': 't',
    '\u0288': 't',
    '\u2C66': 't',
    '\uA787': 't',
    '\uA729': 'tz',
    '\u24E4': 'u',
    '\uFF55': 'u',
    '\u00F9': 'u',
    '\u00FA': 'u',
    '\u00FB': 'u',
    '\u0169': 'u',
    '\u1E79': 'u',
    '\u016B': 'u',
    '\u1E7B': 'u',
    '\u016D': 'u',
    '\u00FC': 'u',
    '\u01DC': 'u',
    '\u01D8': 'u',
    '\u01D6': 'u',
    '\u01DA': 'u',
    '\u1EE7': 'u',
    '\u016F': 'u',
    '\u0171': 'u',
    '\u01D4': 'u',
    '\u0215': 'u',
    '\u0217': 'u',
    '\u01B0': 'u',
    '\u1EEB': 'u',
    '\u1EE9': 'u',
    '\u1EEF': 'u',
    '\u1EED': 'u',
    '\u1EF1': 'u',
    '\u1EE5': 'u',
    '\u1E73': 'u',
    '\u0173': 'u',
    '\u1E77': 'u',
    '\u1E75': 'u',
    '\u0289': 'u',
    '\u24E5': 'v',
    '\uFF56': 'v',
    '\u1E7D': 'v',
    '\u1E7F': 'v',
    '\u028B': 'v',
    '\uA75F': 'v',
    '\u028C': 'v',
    '\uA761': 'vy',
    '\u24E6': 'w',
    '\uFF57': 'w',
    '\u1E81': 'w',
    '\u1E83': 'w',
    '\u0175': 'w',
    '\u1E87': 'w',
    '\u1E85': 'w',
    '\u1E98': 'w',
    '\u1E89': 'w',
    '\u2C73': 'w',
    '\u24E7': 'x',
    '\uFF58': 'x',
    '\u1E8B': 'x',
    '\u1E8D': 'x',
    '\u24E8': 'y',
    '\uFF59': 'y',
    '\u1EF3': 'y',
    '\u00FD': 'y',
    '\u0177': 'y',
    '\u1EF9': 'y',
    '\u0233': 'y',
    '\u1E8F': 'y',
    '\u00FF': 'y',
    '\u1EF7': 'y',
    '\u1E99': 'y',
    '\u1EF5': 'y',
    '\u01B4': 'y',
    '\u024F': 'y',
    '\u1EFF': 'y',
    '\u24E9': 'z',
    '\uFF5A': 'z',
    '\u017A': 'z',
    '\u1E91': 'z',
    '\u017C': 'z',
    '\u017E': 'z',
    '\u1E93': 'z',
    '\u1E95': 'z',
    '\u01B6': 'z',
    '\u0225': 'z',
    '\u0240': 'z',
    '\u2C6C': 'z',
    '\uA763': 'z',
    '\u0386': '\u0391',
    '\u0388': '\u0395',
    '\u0389': '\u0397',
    '\u038A': '\u0399',
    '\u03AA': '\u0399',
    '\u038C': '\u039F',
    '\u038E': '\u03A5',
    '\u03AB': '\u03A5',
    '\u038F': '\u03A9',
    '\u03AC': '\u03B1',
    '\u03AD': '\u03B5',
    '\u03AE': '\u03B7',
    '\u03AF': '\u03B9',
    '\u03CA': '\u03B9',
    '\u0390': '\u03B9',
    '\u03CC': '\u03BF',
    '\u03CD': '\u03C5',
    '\u03CB': '\u03C5',
    '\u03B0': '\u03C5',
    '\u03C9': '\u03C9',
    '\u03C2': '\u03C3'
  };

  return diacritics;
});

S2.define('select2/data/base',[
  '../utils'
], function (Utils) {
  function BaseAdapter ($element, options) {
    BaseAdapter.__super__.constructor.call(this);
  }

  Utils.Extend(BaseAdapter, Utils.Observable);

  BaseAdapter.prototype.current = function (callback) {
    throw new Error('The `current` method must be defined in child classes.');
  };

  BaseAdapter.prototype.query = function (params, callback) {
    throw new Error('The `query` method must be defined in child classes.');
  };

  BaseAdapter.prototype.bind = function (container, $container) {
    // Can be implemented in subclasses
  };

  BaseAdapter.prototype.destroy = function () {
    // Can be implemented in subclasses
  };

  BaseAdapter.prototype.generateResultId = function (container, data) {
    var id = container.id + '-result-';

    id += Utils.generateChars(4);

    if (data.id != null) {
      id += '-' + data.id.toString();
    } else {
      id += '-' + Utils.generateChars(4);
    }
    return id;
  };

  return BaseAdapter;
});

S2.define('select2/data/select',[
  './base',
  '../utils',
  'jquery'
], function (BaseAdapter, Utils, $) {
  function SelectAdapter ($element, options) {
    this.$element = $element;
    this.options = options;

    SelectAdapter.__super__.constructor.call(this);
  }

  Utils.Extend(SelectAdapter, BaseAdapter);

  SelectAdapter.prototype.current = function (callback) {
    var data = [];
    var self = this;

    this.$element.find(':selected').each(function () {
      var $option = $(this);

      var option = self.item($option);

      data.push(option);
    });

    callback(data);
  };

  SelectAdapter.prototype.select = function (data) {
    var self = this;

    // If data.element is a DOM nose, use it instead
    if ($(data.element).is('option')) {
      data.element.selected = true;

      this.$element.trigger('change');

      return;
    }

    if (this.$element.prop('multiple')) {
      this.current(function (currentData) {
        var val = [];

        data = [data];
        data.push.apply(data, currentData);

        for (var d = 0; d < data.length; d++) {
          var id = data[d].id;

          if ($.inArray(id, val) === -1) {
            val.push(id);
          }
        }

        self.$element.val(val);
        self.$element.trigger('change');
      });
    } else {
      var val = data.id;

      this.$element.val(val);
      this.$element.trigger('change');
    }
  };

  SelectAdapter.prototype.unselect = function (data) {
    var self = this;

    if (!this.$element.prop('multiple')) {
      return;
    }

    if ($(data.element).is('option')) {
      data.element.selected = false;

      this.$element.trigger('change');

      return;
    }

    this.current(function (currentData) {
      var val = [];

      for (var d = 0; d < currentData.length; d++) {
        var id = currentData[d].id;

        if (id !== data.id && $.inArray(id, val) === -1) {
          val.push(id);
        }
      }

      self.$element.val(val);

      self.$element.trigger('change');
    });
  };

  SelectAdapter.prototype.bind = function (container, $container) {
    var self = this;

    this.container = container;

    container.on('select', function (params) {
      self.select(params.data);
    });

    container.on('unselect', function (params) {
      self.unselect(params.data);
    });
  };

  SelectAdapter.prototype.destroy = function () {
    // Remove anything added to child elements
    this.$element.find('*').each(function () {
      // Remove any custom data set by Select2
      $.removeData(this, 'data');
    });
  };

  SelectAdapter.prototype.query = function (params, callback) {
    var data = [];
    var self = this;

    var $options = this.$element.children();

    $options.each(function () {
      var $option = $(this);

      if (!$option.is('option') && !$option.is('optgroup')) {
        return;
      }

      var option = self.item($option);

      var matches = self.matches(params, option);

      if (matches !== null) {
        data.push(matches);
      }
    });

    callback({
      results: data
    });
  };

  SelectAdapter.prototype.addOptions = function ($options) {
    this.$element.append($options);
  };

  SelectAdapter.prototype.option = function (data) {
    var option;

    if (data.children) {
      option = document.createElement('optgroup');
      option.label = data.text;
    } else {
      option = document.createElement('option');

      if (option.textContent !== undefined) {
        option.textContent = data.text;
      } else {
        option.innerText = data.text;
      }
    }

    if (data.id) {
      option.value = data.id;
    }

    if (data.disabled) {
      option.disabled = true;
    }

    if (data.selected) {
      option.selected = true;
    }

    if (data.title) {
      option.title = data.title;
    }

    var $option = $(option);

    var normalizedData = this._normalizeItem(data);
    normalizedData.element = option;

    // Override the option's data with the combined data
    $.data(option, 'data', normalizedData);

    return $option;
  };

  SelectAdapter.prototype.item = function ($option) {
    var data = {};

    data = $.data($option[0], 'data');

    if (data != null) {
      return data;
    }

    if ($option.is('option')) {
      data = {
        id: $option.val(),
        text: $option.text(),
        disabled: $option.prop('disabled'),
        selected: $option.prop('selected'),
        title: $option.prop('title')
      };
    } else if ($option.is('optgroup')) {
      data = {
        text: $option.prop('label'),
        children: [],
        title: $option.prop('title')
      };

      var $children = $option.children('option');
      var children = [];

      for (var c = 0; c < $children.length; c++) {
        var $child = $($children[c]);

        var child = this.item($child);

        children.push(child);
      }

      data.children = children;
    }

    data = this._normalizeItem(data);
    data.element = $option[0];

    $.data($option[0], 'data', data);

    return data;
  };

  SelectAdapter.prototype._normalizeItem = function (item) {
    if (!$.isPlainObject(item)) {
      item = {
        id: item,
        text: item
      };
    }

    item = $.extend({}, {
      text: ''
    }, item);

    var defaults = {
      selected: false,
      disabled: false
    };

    if (item.id != null) {
      item.id = item.id.toString();
    }

    if (item.text != null) {
      item.text = item.text.toString();
    }

    if (item._resultId == null && item.id && this.container != null) {
      item._resultId = this.generateResultId(this.container, item);
    }

    return $.extend({}, defaults, item);
  };

  SelectAdapter.prototype.matches = function (params, data) {
    var matcher = this.options.get('matcher');

    return matcher(params, data);
  };

  return SelectAdapter;
});

S2.define('select2/data/array',[
  './select',
  '../utils',
  'jquery'
], function (SelectAdapter, Utils, $) {
  function ArrayAdapter ($element, options) {
    var data = options.get('data') || [];

    ArrayAdapter.__super__.constructor.call(this, $element, options);

    this.addOptions(this.convertToOptions(data));
  }

  Utils.Extend(ArrayAdapter, SelectAdapter);

  ArrayAdapter.prototype.select = function (data) {
    var $option = this.$element.find('option[value="' + data.id + '"]');

    if ($option.length === 0) {
      $option = this.option(data);

      this.addOptions($option);
    }

    ArrayAdapter.__super__.select.call(this, data);
  };

  ArrayAdapter.prototype.convertToOptions = function (data) {
    var self = this;

    var $existing = this.$element.find('option');
    var existingIds = $existing.map(function () {
      return self.item($(this)).id;
    }).get();

    var $options = $();

    // Filter out all items except for the one passed in the argument
    function onlyItem (item) {
      return function () {
        return $(this).val() == item.id;
      };
    }

    for (var d = 0; d < data.length; d++) {
      var item = this._normalizeItem(data[d]);

      // Skip items which were pre-loaded, only merge the data
      if ($.inArray(item.id, existingIds) >= 0) {
        var $existingOption = $existing.filter(onlyItem(item));

        var existingData = this.item($existingOption);
        var newData = $.extend(true, {}, existingData, item);

        var $newOption = this.option(existingData);

        $existingOption.replaceWith($newOption);

        continue;
      }

      var $option = this.option(item);

      if (item.children) {
        var $children = this.convertToOptions(item.children);

        $option.append($children);
      }

      $options = $options.add($option);
    }

    return $options;
  };

  return ArrayAdapter;
});

S2.define('select2/data/ajax',[
  './array',
  '../utils',
  'jquery'
], function (ArrayAdapter, Utils, $) {
  function AjaxAdapter ($element, options) {
    this.ajaxOptions = this._applyDefaults(options.get('ajax'));

    if (this.ajaxOptions.processResults != null) {
      this.processResults = this.ajaxOptions.processResults;
    }

    ArrayAdapter.__super__.constructor.call(this, $element, options);
  }

  Utils.Extend(AjaxAdapter, ArrayAdapter);

  AjaxAdapter.prototype._applyDefaults = function (options) {
    var defaults = {
      data: function (params) {
        return {
          q: params.term
        };
      },
      transport: function (params, success, failure) {
        var $request = $.ajax(params);

        $request.then(success);
        $request.fail(failure);

        return $request;
      }
    };

    return $.extend({}, defaults, options, true);
  };

  AjaxAdapter.prototype.processResults = function (results) {
    return results;
  };

  AjaxAdapter.prototype.query = function (params, callback) {
    var matches = [];
    var self = this;

    if (this._request) {
      this._request.abort();
      this._request = null;
    }

    var options = $.extend({
      type: 'GET'
    }, this.ajaxOptions);

    if (typeof options.url === 'function') {
      options.url = options.url(params);
    }

    if (typeof options.data === 'function') {
      options.data = options.data(params);
    }

    function request () {
      var $request = options.transport(options, function (data) {
        var results = self.processResults(data, params);

        if (self.options.get('debug') && window.console && console.error) {
          // Check to make sure that the response included a `results` key.
          if (!results || !results.results || !$.isArray(results.results)) {
            console.error(
              'Select2: The AJAX results did not return an array in the ' +
              '`results` key of the response.'
            );
          }
        }

        callback(results);
      }, function () {
        // TODO: Handle AJAX errors
      });

      self._request = $request;
    }

    if (this.ajaxOptions.delay && params.term !== '') {
      if (this._queryTimeout) {
        window.clearTimeout(this._queryTimeout);
      }

      this._queryTimeout = window.setTimeout(request, this.ajaxOptions.delay);
    } else {
      request();
    }
  };

  return AjaxAdapter;
});

S2.define('select2/data/tags',[
  'jquery'
], function ($) {
  function Tags (decorated, $element, options) {
    var tags = options.get('tags');

    var createTag = options.get('createTag');

    if (createTag !== undefined) {
      this.createTag = createTag;
    }

    decorated.call(this, $element, options);

    if ($.isArray(tags)) {
      for (var t = 0; t < tags.length; t++) {
        var tag = tags[t];
        var item = this._normalizeItem(tag);

        var $option = this.option(item);

        this.$element.append($option);
      }
    }
  }

  Tags.prototype.query = function (decorated, params, callback) {
    var self = this;

    this._removeOldTags();

    if (params.term == null || params.page != null) {
      decorated.call(this, params, callback);
      return;
    }

    function wrapper (obj, child) {
      var data = obj.results;

      for (var i = 0; i < data.length; i++) {
        var option = data[i];

        var checkChildren = (
          option.children != null &&
          !wrapper({
            results: option.children
          }, true)
        );

        var checkText = option.text === params.term;

        if (checkText || checkChildren) {
          if (child) {
            return false;
          }

          obj.data = data;
          callback(obj);

          return;
        }
      }

      if (child) {
        return true;
      }

      var tag = self.createTag(params);

      if (tag != null) {
        var $option = self.option(tag);
        $option.attr('data-select2-tag', true);

        self.addOptions($option);

        self.insertTag(data, tag);
      }

      obj.results = data;

      callback(obj);
    }

    decorated.call(this, params, wrapper);
  };

  Tags.prototype.createTag = function (decorated, params) {
    var term = $.trim(params.term);

    if (term === '') {
      return null;
    }

    return {
      id: term,
      text: term
    };
  };

  Tags.prototype.insertTag = function (_, data, tag) {
    data.unshift(tag);
  };

  Tags.prototype._removeOldTags = function (_) {
    var tag = this._lastTag;

    var $options = this.$element.find('option[data-select2-tag]');

    $options.each(function () {
      if (this.selected) {
        return;
      }

      $(this).remove();
    });
  };

  return Tags;
});

S2.define('select2/data/tokenizer',[
  'jquery'
], function ($) {
  function Tokenizer (decorated, $element, options) {
    var tokenizer = options.get('tokenizer');

    if (tokenizer !== undefined) {
      this.tokenizer = tokenizer;
    }

    decorated.call(this, $element, options);
  }

  Tokenizer.prototype.bind = function (decorated, container, $container) {
    decorated.call(this, container, $container);

    this.$search =  container.dropdown.$search || container.selection.$search ||
      $container.find('.select2-search__field');
  };

  Tokenizer.prototype.query = function (decorated, params, callback) {
    var self = this;

    function select (data) {
      self.select(data);
    }

    params.term = params.term || '';

    var tokenData = this.tokenizer(params, this.options, select);

    if (tokenData.term !== params.term) {
      // Replace the search term if we have the search box
      if (this.$search.length) {
        this.$search.val(tokenData.term);
        this.$search.focus();
      }

      params.term = tokenData.term;
    }

    decorated.call(this, params, callback);
  };

  Tokenizer.prototype.tokenizer = function (_, params, options, callback) {
    var separators = options.get('tokenSeparators') || [];
    var term = params.term;
    var i = 0;

    var createTag = this.createTag || function (params) {
      return {
        id: params.term,
        text: params.term
      };
    };

    while (i < term.length) {
      var termChar = term[i];

      if ($.inArray(termChar, separators) === -1) {
        i++;

        continue;
      }

      var part = term.substr(0, i);
      var partParams = $.extend({}, params, {
        term: part
      });

      var data = createTag(partParams);

      callback(data);

      // Reset the term to not include the tokenized portion
      term = term.substr(i + 1) || '';
      i = 0;
    }

    return {
      term: term
    };
  };

  return Tokenizer;
});

S2.define('select2/data/minimumInputLength',[

], function () {
  function MinimumInputLength (decorated, $e, options) {
    this.minimumInputLength = options.get('minimumInputLength');

    decorated.call(this, $e, options);
  }

  MinimumInputLength.prototype.query = function (decorated, params, callback) {
    params.term = params.term || '';

    if (params.term.length < this.minimumInputLength) {
      this.trigger('results:message', {
        message: 'inputTooShort',
        args: {
          minimum: this.minimumInputLength,
          input: params.term,
          params: params
        }
      });

      return;
    }

    decorated.call(this, params, callback);
  };

  return MinimumInputLength;
});

S2.define('select2/data/maximumInputLength',[

], function () {
  function MaximumInputLength (decorated, $e, options) {
    this.maximumInputLength = options.get('maximumInputLength');

    decorated.call(this, $e, options);
  }

  MaximumInputLength.prototype.query = function (decorated, params, callback) {
    params.term = params.term || '';

    if (this.maximumInputLength > 0 &&
        params.term.length > this.maximumInputLength) {
      this.trigger('results:message', {
        message: 'inputTooLong',
        args: {
          maximum: this.maximumInputLength,
          input: params.term,
          params: params
        }
      });

      return;
    }

    decorated.call(this, params, callback);
  };

  return MaximumInputLength;
});

S2.define('select2/data/maximumSelectionLength',[

], function (){
  function MaximumSelectionLength (decorated, $e, options) {
    this.maximumSelectionLength = options.get('maximumSelectionLength');

    decorated.call(this, $e, options);
  }

  MaximumSelectionLength.prototype.query =
    function (decorated, params, callback) {
      var self = this;

      this.current(function (currentData) {
        var count = currentData != null ? currentData.length : 0;
        if (self.maximumSelectionLength > 0 &&
          count >= self.maximumSelectionLength) {
          self.trigger('results:message', {
            message: 'maximumSelected',
            args: {
              maximum: self.maximumSelectionLength
            }
          });
          return;
        }
        decorated.call(self, params, callback);
      });
  };

  return MaximumSelectionLength;
});

S2.define('select2/dropdown',[
  'jquery',
  './utils'
], function ($, Utils) {
  function Dropdown ($element, options) {
    this.$element = $element;
    this.options = options;

    Dropdown.__super__.constructor.call(this);
  }

  Utils.Extend(Dropdown, Utils.Observable);

  Dropdown.prototype.render = function () {
    var $dropdown = $(
      '<span class="select2-dropdown">' +
        '<span class="select2-results"></span>' +
      '</span>'
    );

    $dropdown.attr('dir', this.options.get('dir'));

    this.$dropdown = $dropdown;

    return $dropdown;
  };

  Dropdown.prototype.position = function ($dropdown, $container) {
    // Should be implmented in subclasses
  };

  Dropdown.prototype.destroy = function () {
    // Remove the dropdown from the DOM
    this.$dropdown.remove();
  };

  return Dropdown;
});

S2.define('select2/dropdown/search',[
  'jquery',
  '../utils'
], function ($, Utils) {
  function Search () { }

  Search.prototype.render = function (decorated) {
    var $rendered = decorated.call(this);

    var $search = $(
      '<span class="select2-search select2-search--dropdown">' +
        '<input class="select2-search__field" type="search" tabindex="-1"' +
        ' autocomplete="off" autocorrect="off" autocapitalize="off"' +
        ' spellcheck="false" role="textbox" />' +
      '</span>'
    );

    this.$searchContainer = $search;
    this.$search = $search.find('input');

    $rendered.prepend($search);

    return $rendered;
  };

  Search.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    this.$search.on('keydown', function (evt) {
      self.trigger('keypress', evt);

      self._keyUpPrevented = evt.isDefaultPrevented();
    });

    // Workaround for browsers which do not support the `input` event
    // This will prevent double-triggering of events for browsers which support
    // both the `keyup` and `input` events.
    this.$search.on('input', function (evt) {
      // Unbind the duplicated `keyup` event
      $(this).off('keyup');
    });

    this.$search.on('keyup input', function (evt) {
      self.handleSearch(evt);
    });

    container.on('open', function () {
      self.$search.attr('tabindex', 0);

      self.$search.focus();

      window.setTimeout(function () {
        self.$search.focus();
      }, 0);
    });

    container.on('close', function () {
      self.$search.attr('tabindex', -1);

      self.$search.val('');
    });

    container.on('results:all', function (params) {
      if (params.query.term == null || params.query.term === '') {
        var showSearch = self.showSearch(params);

        if (showSearch) {
          self.$searchContainer.removeClass('select2-search--hide');
        } else {
          self.$searchContainer.addClass('select2-search--hide');
        }
      }
    });
  };

  Search.prototype.handleSearch = function (evt) {
    if (!this._keyUpPrevented) {
      var input = this.$search.val();

      this.trigger('query', {
        term: input
      });
    }

    this._keyUpPrevented = false;
  };

  Search.prototype.showSearch = function (_, params) {
    return true;
  };

  return Search;
});

S2.define('select2/dropdown/hidePlaceholder',[

], function () {
  function HidePlaceholder (decorated, $element, options, dataAdapter) {
    this.placeholder = this.normalizePlaceholder(options.get('placeholder'));

    decorated.call(this, $element, options, dataAdapter);
  }

  HidePlaceholder.prototype.append = function (decorated, data) {
    data.results = this.removePlaceholder(data.results);

    decorated.call(this, data);
  };

  HidePlaceholder.prototype.normalizePlaceholder = function (_, placeholder) {
    if (typeof placeholder === 'string') {
      placeholder = {
        id: '',
        text: placeholder
      };
    }

    return placeholder;
  };

  HidePlaceholder.prototype.removePlaceholder = function (_, data) {
    var modifiedData = data.slice(0);

    for (var d = data.length - 1; d >= 0; d--) {
      var item = data[d];

      if (this.placeholder.id === item.id) {
        modifiedData.splice(d, 1);
      }
    }

    return modifiedData;
  };

  return HidePlaceholder;
});

S2.define('select2/dropdown/infiniteScroll',[
  'jquery'
], function ($) {
  function InfiniteScroll (decorated, $element, options, dataAdapter) {
    this.lastParams = {};

    decorated.call(this, $element, options, dataAdapter);

    this.$loadingMore = this.createLoadingMore();
    this.loading = false;
  }

  InfiniteScroll.prototype.append = function (decorated, data) {
    this.$loadingMore.remove();
    this.loading = false;

    decorated.call(this, data);

    if (this.showLoadingMore(data)) {
      this.$results.append(this.$loadingMore);
    }
  };

  InfiniteScroll.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    container.on('query', function (params) {
      self.lastParams = params;
      self.loading = true;
    });

    container.on('query:append', function (params) {
      self.lastParams = params;
      self.loading = true;
    });

    this.$results.on('scroll', function () {
      var isLoadMoreVisible = $.contains(
        document.documentElement,
        self.$loadingMore[0]
      );

      if (self.loading || !isLoadMoreVisible) {
        return;
      }

      var currentOffset = self.$results.offset().top +
        self.$results.outerHeight(false);
      var loadingMoreOffset = self.$loadingMore.offset().top +
        self.$loadingMore.outerHeight(false);

      if (currentOffset + 50 >= loadingMoreOffset) {
        self.loadMore();
      }
    });
  };

  InfiniteScroll.prototype.loadMore = function () {
    this.loading = true;

    var params = $.extend({}, {page: 1}, this.lastParams);

    params.page++;

    this.trigger('query:append', params);
  };

  InfiniteScroll.prototype.showLoadingMore = function (_, data) {
    return data.pagination && data.pagination.more;
  };

  InfiniteScroll.prototype.createLoadingMore = function () {
    var $option = $(
      '<li class="option load-more" role="treeitem"></li>'
    );

    var message = this.options.get('translations').get('loadingMore');

    $option.html(message(this.lastParams));

    return $option;
  };

  return InfiniteScroll;
});

S2.define('select2/dropdown/attachBody',[
  'jquery',
  '../utils'
], function ($, Utils) {
  function AttachBody (decorated, $element, options) {
    this.$dropdownParent = options.get('dropdownParent') || document.body;

    decorated.call(this, $element, options);
  }

  AttachBody.prototype.bind = function (decorated, container, $container) {
    var self = this;

    var setupResultsEvents = false;

    decorated.call(this, container, $container);

    container.on('open', function () {
      self._showDropdown();
      self._attachPositioningHandler(container);

      if (!setupResultsEvents) {
        setupResultsEvents = true;

        container.on('results:all', function () {
          self._positionDropdown();
          self._resizeDropdown();
        });

        container.on('results:append', function () {
          self._positionDropdown();
          self._resizeDropdown();
        });
      }
    });

    container.on('close', function () {
      self._hideDropdown();
      self._detachPositioningHandler(container);
    });

    this.$dropdownContainer.on('mousedown', function (evt) {
      evt.stopPropagation();
    });
  };

  AttachBody.prototype.position = function (decorated, $dropdown, $container) {
    // Clone all of the container classes
    $dropdown.attr('class', $container.attr('class'));

    $dropdown.removeClass('select2');
    $dropdown.addClass('select2-container--open');

    $dropdown.css({
      position: 'absolute',
      top: -999999
    });

    this.$container = $container;
  };

  AttachBody.prototype.render = function (decorated) {
    var $container = $('<span></span>');

    var $dropdown = decorated.call(this);
    $container.append($dropdown);

    this.$dropdownContainer = $container;

    return $container;
  };

  AttachBody.prototype._hideDropdown = function (decorated) {
    this.$dropdownContainer.detach();
  };

  AttachBody.prototype._attachPositioningHandler = function (container) {
    var self = this;

    var scrollEvent = 'scroll.select2.' + container.id;
    var resizeEvent = 'resize.select2.' + container.id;
    var orientationEvent = 'orientationchange.select2.' + container.id;

    var $watchers = this.$container.parents().filter(Utils.hasScroll);
    $watchers.each(function () {
      $(this).data('select2-scroll-position', {
        x: $(this).scrollLeft(),
        y: $(this).scrollTop()
      });
    });

    $watchers.on(scrollEvent, function (ev) {
      var position = $(this).data('select2-scroll-position');
      $(this).scrollTop(position.y);
    });

    $(window).on(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent,
      function (e) {
      self._positionDropdown();
      self._resizeDropdown();
    });
  };

  AttachBody.prototype._detachPositioningHandler = function (container) {
    var scrollEvent = 'scroll.select2.' + container.id;
    var resizeEvent = 'resize.select2.' + container.id;
    var orientationEvent = 'orientationchange.select2.' + container.id;

    var $watchers = this.$container.parents().filter(Utils.hasScroll);
    $watchers.off(scrollEvent);

    $(window).off(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent);
  };

  AttachBody.prototype._positionDropdown = function () {
    var $window = $(window);

    var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
    var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');

    var newDirection = null;

    var position = this.$container.position();
    var offset = this.$container.offset();

    offset.bottom = offset.top + this.$container.outerHeight(false);

    var container = {
      height: this.$container.outerHeight(false)
    };

    container.top = offset.top;
    container.bottom = offset.top + container.height;

    var dropdown = {
      height: this.$dropdown.outerHeight(false)
    };

    var viewport = {
      top: $window.scrollTop(),
      bottom: $window.scrollTop() + $window.height()
    };

    var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
    var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);

    var css = {
      left: offset.left,
      top: container.bottom
    };

    if (!isCurrentlyAbove && !isCurrentlyBelow) {
      newDirection = 'below';
    }

    if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
      newDirection = 'above';
    } else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
      newDirection = 'below';
    }

    if (newDirection == 'above' ||
      (isCurrentlyAbove && newDirection !== 'below')) {
      css.top = container.top - dropdown.height;
    }

    if (newDirection != null) {
      this.$dropdown
        .removeClass('select2-dropdown--below select2-dropdown--above')
        .addClass('select2-dropdown--' + newDirection);
      this.$container
        .removeClass('select2-container--below select2-container--above')
        .addClass('select2-container--' + newDirection);
    }

    this.$dropdownContainer.css(css);
  };

  AttachBody.prototype._resizeDropdown = function () {
    this.$dropdownContainer.width();

    this.$dropdown.css({
      width: this.$container.outerWidth(false) + 'px'
    });
  };

  AttachBody.prototype._showDropdown = function (decorated) {
    this.$dropdownContainer.appendTo(this.$dropdownParent);

    this._positionDropdown();
    this._resizeDropdown();
  };

  return AttachBody;
});

S2.define('select2/dropdown/minimumResultsForSearch',[

], function () {
  function countResults (data) {
    var count = 0;

    for (var d = 0; d < data.length; d++) {
      var item = data[d];

      if (item.children) {
        count += countResults(item.children);
      } else {
        count++;
      }
    }

    return count;
  }

  function MinimumResultsForSearch (decorated, $element, options, dataAdapter) {
    this.minimumResultsForSearch = options.get('minimumResultsForSearch');

    if (this.minimumResultsForSearch < 0) {
      this.minimumResultsForSearch = Infinity;
    }

    decorated.call(this, $element, options, dataAdapter);
  }

  MinimumResultsForSearch.prototype.showSearch = function (decorated, params) {
    if (countResults(params.data.results) < this.minimumResultsForSearch) {
      return false;
    }

    return decorated.call(this, params);
  };

  return MinimumResultsForSearch;
});

S2.define('select2/dropdown/selectOnClose',[

], function () {
  function SelectOnClose () { }

  SelectOnClose.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    container.on('close', function () {
      self._handleSelectOnClose();
    });
  };

  SelectOnClose.prototype._handleSelectOnClose = function () {
    var $highlightedResults = this.getHighlightedResults();

    if ($highlightedResults.length < 1) {
      return;
    }

    $highlightedResults.trigger('mouseup');
  };

  return SelectOnClose;
});

S2.define('select2/dropdown/closeOnSelect',[

], function () {
  function CloseOnSelect () { }

  CloseOnSelect.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    container.on('select', function (evt) {
      self._selectTriggered(evt);
    });

    container.on('unselect', function (evt) {
      self._selectTriggered(evt);
    });
  };

  CloseOnSelect.prototype._selectTriggered = function (_, evt) {
    var originalEvent = evt.originalEvent;

    // Don't close if the control key is being held
    if (originalEvent && originalEvent.ctrlKey) {
      return;
    }

    this.trigger('close');
  };

  return CloseOnSelect;
});

S2.define('select2/i18n/en',[],function () {
  // English
  return {
    errorLoading: function () {
      return 'The results could not be loaded.';
    },
    inputTooLong: function (args) {
      var overChars = args.input.length - args.maximum;

      var message = 'Please delete ' + overChars + ' character';

      if (overChars != 1) {
        message += 's';
      }

      return message;
    },
    inputTooShort: function (args) {
      var remainingChars = args.minimum - args.input.length;

      var message = 'Please enter ' + remainingChars + ' or more characters';

      return message;
    },
    loadingMore: function () {
      return 'Loading more results…';
    },
    maximumSelected: function (args) {
      var message = 'You can only select ' + args.maximum + ' item';

      if (args.maximum != 1) {
        message += 's';
      }

      return message;
    },
    noResults: function () {
      return 'No results found';
    },
    searching: function () {
      return 'Searching…';
    }
  };
});

S2.define('select2/defaults',[
  'jquery',
  'require',

  './results',

  './selection/single',
  './selection/multiple',
  './selection/placeholder',
  './selection/allowClear',
  './selection/search',
  './selection/eventRelay',

  './utils',
  './translation',
  './diacritics',

  './data/select',
  './data/array',
  './data/ajax',
  './data/tags',
  './data/tokenizer',
  './data/minimumInputLength',
  './data/maximumInputLength',
  './data/maximumSelectionLength',

  './dropdown',
  './dropdown/search',
  './dropdown/hidePlaceholder',
  './dropdown/infiniteScroll',
  './dropdown/attachBody',
  './dropdown/minimumResultsForSearch',
  './dropdown/selectOnClose',
  './dropdown/closeOnSelect',

  './i18n/en'
], function ($, require,

             ResultsList,

             SingleSelection, MultipleSelection, Placeholder, AllowClear,
             SelectionSearch, EventRelay,

             Utils, Translation, DIACRITICS,

             SelectData, ArrayData, AjaxData, Tags, Tokenizer,
             MinimumInputLength, MaximumInputLength, MaximumSelectionLength,

             Dropdown, DropdownSearch, HidePlaceholder, InfiniteScroll,
             AttachBody, MinimumResultsForSearch, SelectOnClose, CloseOnSelect,

             EnglishTranslation) {
  function Defaults () {
    this.reset();
  }

  Defaults.prototype.apply = function (options) {
    options = $.extend({}, this.defaults, options);

    if (options.dataAdapter == null) {
      if (options.ajax != null) {
        options.dataAdapter = AjaxData;
      } else if (options.data != null) {
        options.dataAdapter = ArrayData;
      } else {
        options.dataAdapter = SelectData;
      }

      if (options.minimumInputLength > 0) {
        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          MinimumInputLength
        );
      }

      if (options.maximumInputLength > 0) {
        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          MaximumInputLength
        );
      }

      if (options.maximumSelectionLength > 0) {
        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          MaximumSelectionLength
        );
      }

      if (options.tags) {
        options.dataAdapter = Utils.Decorate(options.dataAdapter, Tags);
      }

      if (options.tokenSeparators != null || options.tokenizer != null) {
        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          Tokenizer
        );
      }

      if (options.query != null) {
        var Query = require(options.amdBase + 'compat/query');

        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          Query
        );
      }

      if (options.initSelection != null) {
        var InitSelection = require(options.amdBase + 'compat/initSelection');

        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          InitSelection
        );
      }
    }

    if (options.resultsAdapter == null) {
      options.resultsAdapter = ResultsList;

      if (options.ajax != null) {
        options.resultsAdapter = Utils.Decorate(
          options.resultsAdapter,
          InfiniteScroll
        );
      }

      if (options.placeholder != null) {
        options.resultsAdapter = Utils.Decorate(
          options.resultsAdapter,
          HidePlaceholder
        );
      }

      if (options.selectOnClose) {
        options.resultsAdapter = Utils.Decorate(
          options.resultsAdapter,
          SelectOnClose
        );
      }
    }

    if (options.dropdownAdapter == null) {
      if (options.multiple) {
        options.dropdownAdapter = Dropdown;
      } else {
        var SearchableDropdown = Utils.Decorate(Dropdown, DropdownSearch);

        options.dropdownAdapter = SearchableDropdown;
      }

      if (options.minimumResultsForSearch !== 0) {
        options.dropdownAdapter = Utils.Decorate(
          options.dropdownAdapter,
          MinimumResultsForSearch
        );
      }

      if (options.closeOnSelect) {
        options.dropdownAdapter = Utils.Decorate(
          options.dropdownAdapter,
          CloseOnSelect
        );
      }

      options.dropdownAdapter = Utils.Decorate(
        options.dropdownAdapter,
        AttachBody
      );
    }

    if (options.selectionAdapter == null) {
      if (options.multiple) {
        options.selectionAdapter = MultipleSelection;
      } else {
        options.selectionAdapter = SingleSelection;
      }

      // Add the placeholder mixin if a placeholder was specified
      if (options.placeholder != null) {
        options.selectionAdapter = Utils.Decorate(
          options.selectionAdapter,
          Placeholder
        );
      }

      if (options.allowClear) {
        options.selectionAdapter = Utils.Decorate(
          options.selectionAdapter,
          AllowClear
        );
      }

      if (options.multiple) {
        options.selectionAdapter = Utils.Decorate(
          options.selectionAdapter,
          SelectionSearch
        );
      }

      options.selectionAdapter = Utils.Decorate(
        options.selectionAdapter,
        EventRelay
      );
    }

    if (typeof options.language === 'string') {
      // Check if the language is specified with a region
      if (options.language.indexOf('-') > 0) {
        // Extract the region information if it is included
        var languageParts = options.language.split('-');
        var baseLanguage = languageParts[0];

        options.language = [options.language, baseLanguage];
      } else {
        options.language = [options.language];
      }
    }

    if ($.isArray(options.language)) {
      var languages = new Translation();
      options.language.push('en');

      var languageNames = options.language;

      for (var l = 0; l < languageNames.length; l++) {
        var name = languageNames[l];
        var language = {};

        try {
          // Try to load it with the original name
          language = Translation.loadPath(name);
        } catch (e) {
          try {
            // If we couldn't load it, check if it wasn't the full path
            name = this.defaults.amdLanguageBase + name;
            language = Translation.loadPath(name);
          } catch (ex) {
            // The translation could not be loaded at all. Sometimes this is
            // because of a configuration problem, other times this can be
            // because of how Select2 helps load all possible translation files.
            if (options.debug && window.console && console.warn) {
              console.warn(
                'Select2: The language file for "' + name + '" could not be ' +
                'automatically loaded. A fallback will be used instead.'
              );
            }

            continue;
          }
        }

        languages.extend(language);
      }

      options.translations = languages;
    } else {
      options.translations = new Translation(options.language);
    }

    return options;
  };

  Defaults.prototype.reset = function () {
    function stripDiacritics (text) {
      // Used 'uni range + named function' from http://jsperf.com/diacritics/18
      function match(a) {
        return DIACRITICS[a] || a;
      }

      return text.replace(/[^\u0000-\u007E]/g, match);
    }

    function matcher (params, data) {
      // Always return the object if there is nothing to compare
      if ($.trim(params.term) === '') {
        return data;
      }

      // Do a recursive check for options with children
      if (data.children && data.children.length > 0) {
        // Clone the data object if there are children
        // This is required as we modify the object to remove any non-matches
        var match = $.extend(true, {}, data);

        // Check each child of the option
        for (var c = data.children.length - 1; c >= 0; c--) {
          var child = data.children[c];

          var matches = matcher(params, child);

          // If there wasn't a match, remove the object in the array
          if (matches == null) {
            match.children.splice(c, 1);
          }
        }

        // If any children matched, return the new object
        if (match.children.length > 0) {
          return match;
        }

        // If there were no matching children, check just the plain object
        return matcher(params, match);
      }

      var original = stripDiacritics(data.text).toUpperCase();
      var term = stripDiacritics(params.term).toUpperCase();

      // Check if the text contains the term
      if (original.indexOf(term) > -1) {
        return data;
      }

      // If it doesn't contain the term, don't return anything
      return null;
    }

    this.defaults = {
      amdBase: './',
      amdLanguageBase: './i18n/',
      closeOnSelect: true,
      debug: false,
      escapeMarkup: Utils.escapeMarkup,
      language: EnglishTranslation,
      matcher: matcher,
      minimumInputLength: 0,
      maximumInputLength: 0,
      maximumSelectionLength: 0,
      minimumResultsForSearch: 0,
      selectOnClose: false,
      sorter: function (data) {
        return data;
      },
      templateResult: function (result) {
        return result.text;
      },
      templateSelection: function (selection) {
        return selection.text;
      },
      theme: 'default',
      width: 'resolve'
    };
  };

  Defaults.prototype.set = function (key, value) {
    var camelKey = $.camelCase(key);

    var data = {};
    data[camelKey] = value;

    var convertedData = Utils._convertData(data);

    $.extend(this.defaults, convertedData);
  };

  var defaults = new Defaults();

  return defaults;
});

S2.define('select2/options',[
  'jquery',
  './defaults',
  './utils'
], function ($, Defaults, Utils) {
  function Options (options, $element) {
    this.options = options;

    if ($element != null) {
      this.fromElement($element);
    }

    this.options = Defaults.apply(this.options);

    if ($element && $element.is('input')) {
      var InputCompat = require(this.get('amdBase') + 'compat/inputData');

      this.options.dataAdapter = Utils.Decorate(
        this.options.dataAdapter,
        InputCompat
      );
    }
  }

  Options.prototype.fromElement = function ($e) {
    var excludedData = ['select2'];

    if (this.options.multiple == null) {
      this.options.multiple = $e.prop('multiple');
    }

    if (this.options.disabled == null) {
      this.options.disabled = $e.prop('disabled');
    }

    if (this.options.language == null) {
      if ($e.prop('lang')) {
        this.options.language = $e.prop('lang').toLowerCase();
      } else if ($e.closest('[lang]').prop('lang')) {
        this.options.language = $e.closest('[lang]').prop('lang');
      }
    }

    if (this.options.dir == null) {
      if ($e.prop('dir')) {
        this.options.dir = $e.prop('dir');
      } else if ($e.closest('[dir]').prop('dir')) {
        this.options.dir = $e.closest('[dir]').prop('dir');
      } else {
        this.options.dir = 'ltr';
      }
    }

    $e.prop('disabled', this.options.disabled);
    $e.prop('multiple', this.options.multiple);

    if ($e.data('select2Tags')) {
      if (this.options.debug && window.console && console.warn) {
        console.warn(
          'Select2: The `data-select2-tags` attribute has been changed to ' +
          'use the `data-data` and `data-tags="true"` attributes and will be ' +
          'removed in future versions of Select2.'
        );
      }

      $e.data('data', $e.data('select2Tags'));
      $e.data('tags', true);
    }

    if ($e.data('ajaxUrl')) {
      if (this.options.debug && window.console && console.warn) {
        console.warn(
          'Select2: The `data-ajax-url` attribute has been changed to ' +
          '`data-ajax--url` and support for the old attribute will be removed' +
          ' in future versions of Select2.'
        );
      }

      $e.attr('ajax--url', $e.data('ajaxUrl'));
      $e.data('ajax--url', $e.data('ajaxUrl'));
    }

    var dataset = {};

    // Prefer the element's `dataset` attribute if it exists
    // jQuery 1.x does not correctly handle data attributes with multiple dashes
    if ($.fn.jquery && $.fn.jquery.substr(0, 2) == '1.' && $e[0].dataset) {
      dataset = $.extend(true, {}, $e[0].dataset, $e.data());
    } else {
      dataset = $e.data();
    }

    var data = $.extend(true, {}, dataset);

    data = Utils._convertData(data);

    for (var key in data) {
      if ($.inArray(key, excludedData) > -1) {
        continue;
      }

      if ($.isPlainObject(this.options[key])) {
        $.extend(this.options[key], data[key]);
      } else {
        this.options[key] = data[key];
      }
    }

    return this;
  };

  Options.prototype.get = function (key) {
    return this.options[key];
  };

  Options.prototype.set = function (key, val) {
    this.options[key] = val;
  };

  return Options;
});

S2.define('select2/core',[
  'jquery',
  './options',
  './utils',
  './keys'
], function ($, Options, Utils, KEYS) {
  var Select2 = function ($element, options) {
    if ($element.data('select2') != null) {
      $element.data('select2').destroy();
    }

    this.$element = $element;

    this.id = this._generateId($element);

    options = options || {};

    this.options = new Options(options, $element);

    Select2.__super__.constructor.call(this);

    // Set up the tabindex

    var tabindex = $element.attr('tabindex') || 0;
    $element.data('old-tabindex', tabindex);
    $element.attr('tabindex', '-1');

    // Set up containers and adapters

    var DataAdapter = this.options.get('dataAdapter');
    this.dataAdapter = new DataAdapter($element, this.options);

    var $container = this.render();

    this._placeContainer($container);

    var SelectionAdapter = this.options.get('selectionAdapter');
    this.selection = new SelectionAdapter($element, this.options);
    this.$selection = this.selection.render();

    this.selection.position(this.$selection, $container);

    var DropdownAdapter = this.options.get('dropdownAdapter');
    this.dropdown = new DropdownAdapter($element, this.options);
    this.$dropdown = this.dropdown.render();

    this.dropdown.position(this.$dropdown, $container);

    var ResultsAdapter = this.options.get('resultsAdapter');
    this.results = new ResultsAdapter($element, this.options, this.dataAdapter);
    this.$results = this.results.render();

    this.results.position(this.$results, this.$dropdown);

    // Bind events

    var self = this;

    // Bind the container to all of the adapters
    this._bindAdapters();

    // Register any DOM event handlers
    this._registerDomEvents();

    // Register any internal event handlers
    this._registerDataEvents();
    this._registerSelectionEvents();
    this._registerDropdownEvents();
    this._registerResultsEvents();
    this._registerEvents();

    // Set the initial state
    this.dataAdapter.current(function (initialData) {
      self.trigger('selection:update', {
        data: initialData
      });
    });

    // Hide the original select
    $element.hide();

    // Synchronize any monitored attributes
    this._syncAttributes();

    $element.data('select2', this);
  };

  Utils.Extend(Select2, Utils.Observable);

  Select2.prototype._generateId = function ($element) {
    var id = '';

    if ($element.attr('id') != null) {
      id = $element.attr('id');
    } else if ($element.attr('name') != null) {
      id = $element.attr('name') + '-' + Utils.generateChars(2);
    } else {
      id = Utils.generateChars(4);
    }

    id = 'select2-' + id;

    return id;
  };

  Select2.prototype._placeContainer = function ($container) {
    $container.insertAfter(this.$element);

    var width = this._resolveWidth(this.$element, this.options.get('width'));

    if (width != null) {
      $container.css('width', width);
    }
  };

  Select2.prototype._resolveWidth = function ($element, method) {
    var WIDTH = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;

    if (method == 'resolve') {
      var styleWidth = this._resolveWidth($element, 'style');

      if (styleWidth != null) {
        return styleWidth;
      }

      return this._resolveWidth($element, 'element');
    }

    if (method == 'element') {
      var elementWidth = $element.outerWidth(false);

      if (elementWidth <= 0) {
        return 'auto';
      }

      return elementWidth + 'px';
    }

    if (method == 'style') {
      var style = $element.attr('style');

      if (typeof(style) !== 'string') {
        return null;
      }

      var attrs = style.split(';');

      for (var i = 0, l = attrs.length; i < l; i = i + 1) {
        var attr = attrs[i].replace(/\s/g, '');
        var matches = attr.match(WIDTH);

        if (matches !== null && matches.length >= 1) {
          return matches[1];
        }
      }

      return null;
    }

    return method;
  };

  Select2.prototype._bindAdapters = function () {
    this.dataAdapter.bind(this, this.$container);
    this.selection.bind(this, this.$container);

    this.dropdown.bind(this, this.$container);
    this.results.bind(this, this.$container);
  };

  Select2.prototype._registerDomEvents = function () {
    var self = this;

    this.$element.on('change.select2', function () {
      self.dataAdapter.current(function (data) {
        self.trigger('selection:update', {
          data: data
        });
      });
    });

    this._sync = Utils.bind(this._syncAttributes, this);

    if (this.$element[0].attachEvent) {
      this.$element[0].attachEvent('onpropertychange', this._sync);
    }

    var observer = window.MutationObserver ||
      window.WebKitMutationObserver ||
      window.MozMutationObserver
    ;

    if (observer != null) {
      this._observer = new observer(function (mutations) {
        $.each(mutations, self._sync);
      });
      this._observer.observe(this.$element[0], {
        attributes: true,
        subtree: false
      });
    } else if (this.$element[0].addEventListener) {
      this.$element[0].addEventListener('DOMAttrModified', self._sync, false);
    }
  };

  Select2.prototype._registerDataEvents = function () {
    var self = this;

    this.dataAdapter.on('*', function (name, params) {
      self.trigger(name, params);
    });
  };

  Select2.prototype._registerSelectionEvents = function () {
    var self = this;
    var nonRelayEvents = ['toggle'];

    this.selection.on('toggle', function () {
      self.toggleDropdown();
    });

    this.selection.on('*', function (name, params) {
      if ($.inArray(name, nonRelayEvents) !== -1) {
        return;
      }

      self.trigger(name, params);
    });
  };

  Select2.prototype._registerDropdownEvents = function () {
    var self = this;

    this.dropdown.on('*', function (name, params) {
      self.trigger(name, params);
    });
  };

  Select2.prototype._registerResultsEvents = function () {
    var self = this;

    this.results.on('*', function (name, params) {
      self.trigger(name, params);
    });
  };

  Select2.prototype._registerEvents = function () {
    var self = this;

    this.on('open', function () {
      self.$container.addClass('select2-container--open');
    });

    this.on('close', function () {
      self.$container.removeClass('select2-container--open');
    });

    this.on('enable', function () {
      self.$container.removeClass('select2-container--disabled');
    });

    this.on('disable', function () {
      self.$container.addClass('select2-container--disabled');
    });

    this.on('focus', function () {
      self.$container.addClass('select2-container--focus');
    });

    this.on('blur', function () {
      self.$container.removeClass('select2-container--focus');
    });

    this.on('query', function (params) {
      if (!self.isOpen()) {
        self.trigger('open');
      }

      this.dataAdapter.query(params, function (data) {
        self.trigger('results:all', {
          data: data,
          query: params
        });
      });
    });

    this.on('query:append', function (params) {
      this.dataAdapter.query(params, function (data) {
        self.trigger('results:append', {
          data: data,
          query: params
        });
      });
    });

    this.on('keypress', function (evt) {
      var key = evt.which;

      if (self.isOpen()) {
        if (key === KEYS.ENTER) {
          self.trigger('results:select');

          evt.preventDefault();
        } else if ((key === KEYS.SPACE && evt.ctrlKey)) {
          self.trigger('results:toggle');

          evt.preventDefault();
        } else if (key === KEYS.UP) {
          self.trigger('results:previous');

          evt.preventDefault();
        } else if (key === KEYS.DOWN) {
          self.trigger('results:next');

          evt.preventDefault();
        } else if (key === KEYS.ESC || key === KEYS.TAB) {
          self.close();

          evt.preventDefault();
        }
      } else {
        if (key === KEYS.ENTER || key === KEYS.SPACE ||
            ((key === KEYS.DOWN || key === KEYS.UP) && evt.altKey)) {
          self.open();

          evt.preventDefault();
        }
      }
    });
  };

  Select2.prototype._syncAttributes = function () {
    this.options.set('disabled', this.$element.prop('disabled'));

    if (this.options.get('disabled')) {
      if (this.isOpen()) {
        this.close();
      }

      this.trigger('disable');
    } else {
      this.trigger('enable');
    }
  };

  /**
   * Override the trigger method to automatically trigger pre-events when
   * there are events that can be prevented.
   */
  Select2.prototype.trigger = function (name, args) {
    var actualTrigger = Select2.__super__.trigger;
    var preTriggerMap = {
      'open': 'opening',
      'close': 'closing',
      'select': 'selecting',
      'unselect': 'unselecting'
    };

    if (name in preTriggerMap) {
      var preTriggerName = preTriggerMap[name];
      var preTriggerArgs = {
        prevented: false,
        name: name,
        args: args
      };

      actualTrigger.call(this, preTriggerName, preTriggerArgs);

      if (preTriggerArgs.prevented) {
        args.prevented = true;

        return;
      }
    }

    actualTrigger.call(this, name, args);
  };

  Select2.prototype.toggleDropdown = function () {
    if (this.options.get('disabled')) {
      return;
    }

    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  };

  Select2.prototype.open = function () {
    if (this.isOpen()) {
      return;
    }

    this.trigger('query', {});

    this.trigger('open');
  };

  Select2.prototype.close = function () {
    if (!this.isOpen()) {
      return;
    }

    this.trigger('close');
  };

  Select2.prototype.isOpen = function () {
    return this.$container.hasClass('select2-container--open');
  };

  Select2.prototype.enable = function (args) {
    if (this.options.get('debug') && window.console && console.warn) {
      console.warn(
        'Select2: The `select2("enable")` method has been deprecated and will' +
        ' be removed in later Select2 versions. Use $element.prop("disabled")' +
        ' instead.'
      );
    }

    if (args == null || args.length === 0) {
      args = [true];
    }

    var disabled = !args[0];

    this.$element.prop('disabled', disabled);
  };

  Select2.prototype.data = function () {
    if (this.options.get('debug') &&
        arguments.length > 0 && window.console && console.warn) {
      console.warn(
        'Select2: Data can no longer be set using `select2("data")`. You ' +
        'should consider setting the value instead using `$element.val()`.'
      );
    }

    var data = [];

    this.dataAdapter.current(function (currentData) {
      data = currentData;
    });

    return data;
  };

  Select2.prototype.val = function (args) {
    if (this.options.get('debug') && window.console && console.warn) {
      console.warn(
        'Select2: The `select2("val")` method has been deprecated and will be' +
        ' removed in later Select2 versions. Use $element.val() instead.'
      );
    }

    if (args == null || args.length === 0) {
      return this.$element.val();
    }

    var newVal = args[0];

    if ($.isArray(newVal)) {
      newVal = $.map(newVal, function (obj) {
        return obj.toString();
      });
    }

    this.$element.val(newVal).trigger('change');
  };

  Select2.prototype.destroy = function () {
    this.$container.remove();

    if (this.$element[0].detachEvent) {
      this.$element[0].detachEvent('onpropertychange', this._sync);
    }

    if (this._observer != null) {
      this._observer.disconnect();
      this._observer = null;
    } else if (this.$element[0].removeEventListener) {
      this.$element[0]
        .removeEventListener('DOMAttrModified', this._sync, false);
    }

    this._sync = null;

    this.$element.off('.select2');
    this.$element.attr('tabindex', this.$element.data('old-tabindex'));

    this.$element.show();
    this.$element.removeData('select2');

    this.dataAdapter.destroy();
    this.selection.destroy();
    this.dropdown.destroy();
    this.results.destroy();

    this.dataAdapter = null;
    this.selection = null;
    this.dropdown = null;
    this.results = null;
  };

  Select2.prototype.render = function () {
    var $container = $(
      '<span class="select2 select2-container">' +
        '<span class="selection"></span>' +
        '<span class="dropdown-wrapper" aria-hidden="true"></span>' +
      '</span>'
    );

    $container.attr('dir', this.options.get('dir'));

    this.$container = $container;

    this.$container.addClass('select2-container--' + this.options.get('theme'));

    $container.data('element', this.$element);

    return $container;
  };

  return Select2;
});

S2.define('jquery.select2',[
  'jquery',
  './select2/core',
  './select2/defaults'
], function ($, Select2, Defaults) {
  // Force jQuery.mousewheel to be loaded if it hasn't already
  try {
    require('jquery.mousewheel');
  } catch (Exception) { }

  if ($.fn.select2 == null) {
    $.fn.select2 = function (options) {
      options = options || {};

      if (typeof options === 'object') {
        this.each(function () {
          var instanceOptions = $.extend({}, options, true);

          var instance = new Select2($(this), instanceOptions);
        });

        return this;
      } else if (typeof options === 'string') {
        var instance = this.data('select2');
        var args = Array.prototype.slice.call(arguments, 1);

        return instance[options](args);
      } else {
        throw new Error('Invalid arguments for Select2: ' + options);
      }
    };
  }

  if ($.fn.select2.defaults == null) {
    $.fn.select2.defaults = Defaults;
  }

  return Select2;
});

  // Return the AMD loader configuration so it can be used outside of this file
  return {
    define: S2.define,
    require: S2.require
  };
}());

  // Autoload the jQuery bindings
  // We know that all of the modules exist above this, so we're safe
  var select2 = S2.require('jquery.select2');

  // Hold the AMD module references on the jQuery function that was just loaded
  // This allows Select2 to use the internal loader outside of this file, such
  // as in the language files.
  $.fn.select2.amd = S2;

  // Return the Select2 instance for anyone who is importing it.
  return select2;
}));

/* -------- studio/v2/js/icheck.js -------- */
/*!
 * iCheck v1.0.2, http://git.io/arlzeA
 * ===================================
 * Powerful jQuery and Zepto plugin for checkboxes and radio buttons customization
 *
 * (c) 2013 Damir Sultanov, http://fronteed.com
 * MIT Licensed
 */

(function($) {

  // Cached vars
  var _iCheck = 'iCheck',
    _iCheckHelper = _iCheck + '-helper',
    _checkbox = 'checkbox',
    _radio = 'radio',
    _checked = 'checked',
    _unchecked = 'un' + _checked,
    _disabled = 'disabled',
    _determinate = 'determinate',
    _indeterminate = 'in' + _determinate,
    _update = 'update',
    _type = 'type',
    _click = 'click',
    _touch = 'touchbegin.i touchend.i',
    _add = 'addClass',
    _remove = 'removeClass',
    _callback = 'trigger',
    _label = 'label',
    _cursor = 'cursor',
    _mobile = /ipad|iphone|ipod|android|blackberry|windows phone|opera mini|silk/i.test(navigator.userAgent);

  // Plugin init
  $.fn[_iCheck] = function(options, fire) {

    // Walker
    var handle = 'input[type="' + _checkbox + '"], input[type="' + _radio + '"]',
      stack = $(),
      walker = function(object) {
        object.each(function() {
          var self = $(this);

          if (self.is(handle)) {
            stack = stack.add(self);
          } else {
            stack = stack.add(self.find(handle));
          }
        });
      };

    // Check if we should operate with some method
    if (/^(check|uncheck|toggle|indeterminate|determinate|disable|enable|update|destroy)$/i.test(options)) {

      // Normalize method's name
      options = options.toLowerCase();

      // Find checkboxes and radio buttons
      walker(this);

      return stack.each(function() {
        var self = $(this);

        if (options == 'destroy') {
          tidy(self, 'ifDestroyed');
        } else {
          operate(self, true, options);
        }

        // Fire method's callback
        if ($.isFunction(fire)) {
          fire();
        }
      });

    // Customization
    } else if (typeof options == 'object' || !options) {

      // Check if any options were passed
      var settings = $.extend({
          checkedClass: _checked,
          disabledClass: _disabled,
          indeterminateClass: _indeterminate,
          labelHover: true
        }, options),

        selector = settings.handle,
        hoverClass = settings.hoverClass || 'hover',
        focusClass = settings.focusClass || 'focus',
        activeClass = settings.activeClass || 'active',
        labelHover = !!settings.labelHover,
        labelHoverClass = settings.labelHoverClass || 'hover',

        // Setup clickable area
        area = ('' + settings.increaseArea).replace('%', '') | 0;

      // Selector limit
      if (selector == _checkbox || selector == _radio) {
        handle = 'input[type="' + selector + '"]';
      }

      // Clickable area limit
      if (area < -50) {
        area = -50;
      }

      // Walk around the selector
      walker(this);

      return stack.each(function() {
        var self = $(this);

        // If already customized
        tidy(self);

        var node = this,
          id = node.id,

          // Layer styles
          offset = -area + '%',
          size = 100 + (area * 2) + '%',
          layer = {
            position: 'absolute',
            top: offset,
            left: offset,
            display: 'block',
            width: size,
            height: size,
            margin: 0,
            padding: 0,
            background: '#fff',
            border: 0,
            opacity: 0
          },

          // Choose how to hide input
          hide = _mobile ? {
            position: 'absolute',
            visibility: 'hidden'
          } : area ? layer : {
            position: 'absolute',
            opacity: 0
          },

          // Get proper class
          className = node[_type] == _checkbox ? settings.checkboxClass || 'i' + _checkbox : settings.radioClass || 'i' + _radio,

          // Find assigned labels
          label = $(_label + '[for="' + id + '"]').add(self.closest(_label)),

          // Check ARIA option
          aria = !!settings.aria,

          // Set ARIA placeholder
          ariaID = _iCheck + '-' + Math.random().toString(36).substr(2,6),

          // Parent & helper
          parent = '<div class="' + className + '" ' + (aria ? 'role="' + node[_type] + '" ' : ''),
          helper;

        // Set ARIA "labelledby"
        if (aria) {
          label.each(function() {
            parent += 'aria-labelledby="';

            if (this.id) {
              parent += this.id;
            } else {
              this.id = ariaID;
              parent += ariaID;
            }

            parent += '"';
          });
        }

        // Wrap input
        parent = self.wrap(parent + '/>')[_callback]('ifCreated').parent().append(settings.insert);

        // Layer addition
        helper = $('<ins class="' + _iCheckHelper + '"/>').css(layer).appendTo(parent);

        // Finalize customization
        self.data(_iCheck, {o: settings, s: self.attr('style')}).css(hide);
        !!settings.inheritClass && parent[_add](node.className || '');
        !!settings.inheritID && id && parent.attr('id', _iCheck + '-' + id);
        parent.css('position') == 'static' && parent.css('position', 'relative');
        operate(self, true, _update);

        // Label events
        if (label.length) {
          label.on(_click + '.i mouseover.i mouseout.i ' + _touch, function(event) {
            var type = event[_type],
              item = $(this);

            // Do nothing if input is disabled
            if (!node[_disabled]) {

              // Click
              if (type == _click) {
                if ($(event.target).is('a')) {
                  return;
                }
                operate(self, false, true);

              // Hover state
              } else if (labelHover) {

                // mouseout|touchend
                if (/ut|nd/.test(type)) {
                  parent[_remove](hoverClass);
                  item[_remove](labelHoverClass);
                } else {
                  parent[_add](hoverClass);
                  item[_add](labelHoverClass);
                }
              }

              if (_mobile) {
                event.stopPropagation();
              } else {
                return false;
              }
            }
          });
        }

        // Input events
        self.on(_click + '.i focus.i blur.i keyup.i keydown.i keypress.i', function(event) {
          var type = event[_type],
            key = event.keyCode;

          // Click
          if (type == _click) {
            return false;

          // Keydown
          } else if (type == 'keydown' && key == 32) {
            if (!(node[_type] == _radio && node[_checked])) {
              if (node[_checked]) {
                off(self, _checked);
              } else {
                on(self, _checked);
              }
            }

            return false;

          // Keyup
          } else if (type == 'keyup' && node[_type] == _radio) {
            !node[_checked] && on(self, _checked);

          // Focus/blur
          } else if (/us|ur/.test(type)) {
            parent[type == 'blur' ? _remove : _add](focusClass);
          }
        });

        // Helper events
        helper.on(_click + ' mousedown mouseup mouseover mouseout ' + _touch, function(event) {
          var type = event[_type],

            // mousedown|mouseup
            toggle = /wn|up/.test(type) ? activeClass : hoverClass;

          // Do nothing if input is disabled
          if (!node[_disabled]) {

            // Click
            if (type == _click) {
              operate(self, false, true);

            // Active and hover states
            } else {

              // State is on
              if (/wn|er|in/.test(type)) {

                // mousedown|mouseover|touchbegin
                parent[_add](toggle);

              // State is off
              } else {
                parent[_remove](toggle + ' ' + activeClass);
              }

              // Label hover
              if (label.length && labelHover && toggle == hoverClass) {

                // mouseout|touchend
                label[/ut|nd/.test(type) ? _remove : _add](labelHoverClass);
              }
            }

            if (_mobile) {
              event.stopPropagation();
            } else {
              return false;
            }
          }
        });
      });
    } else {
      return this;
    }
  };

  // Do something with inputs
  function operate(input, direct, method) {
    var node = input[0],
      state = /er/.test(method) ? _indeterminate : /bl/.test(method) ? _disabled : _checked,
      active = method == _update ? {
        checked: node[_checked],
        disabled: node[_disabled],
        indeterminate: input.attr(_indeterminate) == 'true' || input.attr(_determinate) == 'false'
      } : node[state];

    // Check, disable or indeterminate
    if (/^(ch|di|in)/.test(method) && !active) {
      on(input, state);

    // Uncheck, enable or determinate
    } else if (/^(un|en|de)/.test(method) && active) {
      off(input, state);

    // Update
    } else if (method == _update) {

      // Handle states
      for (var each in active) {
        if (active[each]) {
          on(input, each, true);
        } else {
          off(input, each, true);
        }
      }

    } else if (!direct || method == 'toggle') {

      // Helper or label was clicked
      if (!direct) {
        input[_callback]('ifClicked');
      }

      // Toggle checked state
      if (active) {
        if (node[_type] !== _radio) {
          off(input, state);
        }
      } else {
        on(input, state);
      }
    }
  }

  // Add checked, disabled or indeterminate state
  function on(input, state, keep) {
    var node = input[0],
      parent = input.parent(),
      checked = state == _checked,
      indeterminate = state == _indeterminate,
      disabled = state == _disabled,
      callback = indeterminate ? _determinate : checked ? _unchecked : 'enabled',
      regular = option(input, callback + capitalize(node[_type])),
      specific = option(input, state + capitalize(node[_type]));

    // Prevent unnecessary actions
    if (node[state] !== true) {

      // Toggle assigned radio buttons
      if (!keep && state == _checked && node[_type] == _radio && node.name) {
        var form = input.closest('form'),
          inputs = 'input[name="' + node.name + '"]';

        inputs = form.length ? form.find(inputs) : $(inputs);

        inputs.each(function() {
          if (this !== node && $(this).data(_iCheck)) {
            off($(this), state);
          }
        });
      }

      // Indeterminate state
      if (indeterminate) {

        // Add indeterminate state
        node[state] = true;

        // Remove checked state
        if (node[_checked]) {
          off(input, _checked, 'force');
        }

      // Checked or disabled state
      } else {

        // Add checked or disabled state
        if (!keep) {
          node[state] = true;
        }

        // Remove indeterminate state
        if (checked && node[_indeterminate]) {
          off(input, _indeterminate, false);
        }
      }

      // Trigger callbacks
      callbacks(input, checked, state, keep);
    }

    // Add proper cursor
    if (node[_disabled] && !!option(input, _cursor, true)) {
      parent.find('.' + _iCheckHelper).css(_cursor, 'default');
    }

    // Add state class
    parent[_add](specific || option(input, state) || '');

    // Set ARIA attribute
    if (!!parent.attr('role') && !indeterminate) {
      parent.attr('aria-' + (disabled ? _disabled : _checked), 'true');
    }

    // Remove regular state class
    parent[_remove](regular || option(input, callback) || '');
  }

  // Remove checked, disabled or indeterminate state
  function off(input, state, keep) {
    var node = input[0],
      parent = input.parent(),
      checked = state == _checked,
      indeterminate = state == _indeterminate,
      disabled = state == _disabled,
      callback = indeterminate ? _determinate : checked ? _unchecked : 'enabled',
      regular = option(input, callback + capitalize(node[_type])),
      specific = option(input, state + capitalize(node[_type]));

    // Prevent unnecessary actions
    if (node[state] !== false) {

      // Toggle state
      if (indeterminate || !keep || keep == 'force') {
        node[state] = false;
      }

      // Trigger callbacks
      callbacks(input, checked, callback, keep);
    }

    // Add proper cursor
    if (!node[_disabled] && !!option(input, _cursor, true)) {
      parent.find('.' + _iCheckHelper).css(_cursor, 'pointer');
    }

    // Remove state class
    parent[_remove](specific || option(input, state) || '');

    // Set ARIA attribute
    if (!!parent.attr('role') && !indeterminate) {
      parent.attr('aria-' + (disabled ? _disabled : _checked), 'false');
    }

    // Add regular state class
    parent[_add](regular || option(input, callback) || '');
  }

  // Remove all traces
  function tidy(input, callback) {
    if (input.data(_iCheck)) {

      // Remove everything except input
      input.parent().html(input.attr('style', input.data(_iCheck).s || ''));

      // Callback
      if (callback) {
        input[_callback](callback);
      }

      // Unbind events
      input.off('.i').unwrap();
      $(_label + '[for="' + input[0].id + '"]').add(input.closest(_label)).off('.i');
    }
  }

  // Get some option
  function option(input, state, regular) {
    if (input.data(_iCheck)) {
      return input.data(_iCheck).o[state + (regular ? '' : 'Class')];
    }
  }

  // Capitalize some string
  function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  // Executable handlers
  function callbacks(input, checked, callback, keep) {
    if (!keep) {
      if (checked) {
        input[_callback]('ifToggled');
      }

      input[_callback]('ifChanged')[_callback]('if' + capitalize(callback));
    }
  }
})(window.jQuery || window.Zepto);

/* -------- studio/v2/js/iphone-style-checkboxes.js -------- */
// Generated by CoffeeScript 1.6.2
(function() {
  var iOSCheckbox, matched, userAgent,
    __slice = [].slice;

  if ($.browser == null) {
    userAgent = navigator.userAgent || "";
    jQuery.uaMatch = function(ua) {
      var match;

      ua = ua.toLowerCase();
      match = /(chrome)[ \/]([\w.]+)/.exec(ua) || /(webkit)[ \/]([\w.]+)/.exec(ua) || /(opera)(?:.*version)?[ \/]([\w.]+)/.exec(ua) || /(msie) ([\w.]+)/.exec(ua) || ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+))?/.exec(ua) || [];
      return {
        browser: match[1] || "",
        version: match[2] || "0"
      };
    };
    matched = jQuery.uaMatch(userAgent);
    jQuery.browser = {};
    if (matched.browser) {
      jQuery.browser[matched.browser] = true;
      jQuery.browser.version = matched.version;
    }
    if (jQuery.browser.webkit) {
      jQuery.browser.safari = true;
    }
  }

  iOSCheckbox = (function() {
    function iOSCheckbox(elem, options) {
      var key, opts, value;

      this.elem = $(elem);
      opts = $.extend({}, iOSCheckbox.defaults, options);
      for (key in opts) {
        value = opts[key];
        this[key] = value;
      }
      this.elem.data(this.dataName, this);
      this.wrapCheckboxWithDivs();
      this.attachEvents();
      this.disableTextSelection();
      this.calculateDimensions();
    }

    iOSCheckbox.prototype.calculateDimensions = function() {
      if (this.resizeHandle) {
        this.optionallyResize('handle');
      }
      if (this.resizeContainer) {
        this.optionallyResize('container');
      }
      return this.initialPosition();
    };

    iOSCheckbox.prototype.isDisabled = function() {
      return this.elem.is(':disabled');
    };

    iOSCheckbox.prototype.wrapCheckboxWithDivs = function() {
      this.elem.wrap("<div class='" + this.containerClass + "' />");
      this.container = this.elem.parent();
      this.offLabel = $("<label class='" + this.labelOffClass + "'>\n  <span>" + this.uncheckedLabel + "</span>\n</label>").appendTo(this.container);
      this.offSpan = this.offLabel.children('span');
      this.onLabel = $("<label class='" + this.labelOnClass + "'>\n  <span>" + this.checkedLabel + "</span>\n</label>").appendTo(this.container);
      this.onSpan = this.onLabel.children('span');
      return this.handle = $("<div class='" + this.handleClass + "'>\n  <div class='" + this.handleRightClass + "'>\n    <div class='" + this.handleCenterClass + "' />\n  </div>\n</div>").appendTo(this.container);
    };

    iOSCheckbox.prototype.disableTextSelection = function() {
      if ($.browser.msie) {
        return $([this.handle, this.offLabel, this.onLabel, this.container]).attr("unselectable", "on");
      }
    };

    iOSCheckbox.prototype._getDimension = function(elem, dimension) {
      if ($.fn.actual != null) {
        return elem.actual(dimension);
      } else {
        return elem[dimension]();
      }
    };

    iOSCheckbox.prototype.optionallyResize = function(mode) {
      var newWidth, offLabelWidth, offSpan, onLabelWidth, onSpan;

      onSpan = this.onLabel.find('span');
      onLabelWidth = this._getDimension(onSpan, "width");
      onLabelWidth += parseInt(onSpan.css('padding-left'), 10);
      offSpan = this.offLabel.find('span');
      offLabelWidth = this._getDimension(offSpan, "width");
      offLabelWidth += parseInt(offSpan.css('padding-right'), 10);
      if (mode === "container") {
        newWidth = onLabelWidth > offLabelWidth ? onLabelWidth : offLabelWidth;
        newWidth += this._getDimension(this.handle, "width") + this.handleMargin;
        return this.container.css({
          width: newWidth
        });
      } else {
        newWidth = onLabelWidth > offLabelWidth ? onLabelWidth : offLabelWidth;
        return this.handle.css({
          width: newWidth
        });
      }
    };

    iOSCheckbox.prototype.onMouseDown = function(event) {
      var x;

      event.preventDefault();
      if (this.isDisabled()) {
        return;
      }
      x = event.pageX || event.originalEvent.changedTouches[0].pageX;
      iOSCheckbox.currentlyClicking = this.handle;
      iOSCheckbox.dragStartPosition = x;
      return iOSCheckbox.handleLeftOffset = parseInt(this.handle.css('left'), 10) || 0;
    };

    iOSCheckbox.prototype.onDragMove = function(event, x) {
      var newWidth, p;

      if (iOSCheckbox.currentlyClicking !== this.handle) {
        return;
      }
      p = (x + iOSCheckbox.handleLeftOffset - iOSCheckbox.dragStartPosition) / this.rightSide;
      if (p < 0) {
        p = 0;
      }
      if (p > 1) {
        p = 1;
      }
      newWidth = p * this.rightSide;
      this.handle.css({
        left: newWidth
      });
      this.onLabel.css({
        width: newWidth + this.handleRadius
      });
      this.offSpan.css({
        marginRight: -newWidth
      });
      return this.onSpan.css({
        marginLeft: -(1 - p) * this.rightSide
      });
    };

    iOSCheckbox.prototype.onDragEnd = function(event, x) {
      var p;

      if (iOSCheckbox.currentlyClicking !== this.handle) {
        return;
      }
      if (this.isDisabled()) {
        return;
      }
      if (iOSCheckbox.dragging) {
        p = (x - iOSCheckbox.dragStartPosition) / this.rightSide;
        this.elem.prop('checked', p >= 0.5);
      } else {
        this.elem.prop('checked', !this.elem.prop('checked'));
      }
      iOSCheckbox.currentlyClicking = null;
      iOSCheckbox.dragging = null;
      return this.didChange();
    };

    iOSCheckbox.prototype.refresh = function() {
      return this.didChange();
    };

    iOSCheckbox.prototype.didChange = function() {
      var new_left;

      if (typeof this.onChange === "function") {
        this.onChange(this.elem, this.elem.prop('checked'));
      }
      if (this.isDisabled()) {
        this.container.addClass(this.disabledClass);
        return false;
      } else {
        this.container.removeClass(this.disabledClass);
      }
      new_left = this.elem.prop('checked') ? this.rightSide : 0;
      this.handle.animate({
        left: new_left
      }, this.duration);
      this.onLabel.animate({
        width: new_left + this.handleRadius
      }, this.duration);
      this.offSpan.animate({
        marginRight: -new_left
      }, this.duration);
      return this.onSpan.animate({
        marginLeft: new_left - this.rightSide
      }, this.duration);
    };

    iOSCheckbox.prototype.attachEvents = function() {
      var localMouseMove, localMouseUp, self;

      self = this;
      localMouseMove = function(event) {
        return self.onGlobalMove.apply(self, arguments);
      };
      localMouseUp = function(event) {
        self.onGlobalUp.apply(self, arguments);
        $(document).unbind('mousemove touchmove', localMouseMove);
        return $(document).unbind('mouseup touchend', localMouseUp);
      };
      this.elem.change(function() {
        return self.refresh();
      });
      return this.container.bind('mousedown touchstart', function(event) {
        self.onMouseDown.apply(self, arguments);
        $(document).bind('mousemove touchmove', localMouseMove);
        return $(document).bind('mouseup touchend', localMouseUp);
      });
    };

    iOSCheckbox.prototype.initialPosition = function() {
      var containerWidth, offset;

      containerWidth = this._getDimension(this.container, "width");
      this.offLabel.css({
        width: containerWidth - this.containerRadius
      });
      offset = this.containerRadius + 1;
      if ($.browser.msie && $.browser.version < 7) {
        offset -= 3;
      }
      this.rightSide = containerWidth - this._getDimension(this.handle, "width") - offset;
      if (this.elem.is(':checked')) {
        this.handle.css({
          left: this.rightSide
        });
        this.onLabel.css({
          width: this.rightSide + this.handleRadius
        });
        this.offSpan.css({
          marginRight: -this.rightSide
        });
      } else {
        this.onLabel.css({
          width: 0
        });
        this.onSpan.css({
          marginLeft: -this.rightSide
        });
      }
      if (this.isDisabled()) {
        return this.container.addClass(this.disabledClass);
      }
    };

    iOSCheckbox.prototype.onGlobalMove = function(event) {
      var x;

      if (!(!this.isDisabled() && iOSCheckbox.currentlyClicking)) {
        return;
      }
      event.preventDefault();
      x = event.pageX || event.originalEvent.changedTouches[0].pageX;
      if (!iOSCheckbox.dragging && (Math.abs(iOSCheckbox.dragStartPosition - x) > this.dragThreshold)) {
        iOSCheckbox.dragging = true;
      }
      return this.onDragMove(event, x);
    };

    iOSCheckbox.prototype.onGlobalUp = function(event) {
      var x;

      if (!iOSCheckbox.currentlyClicking) {
        return;
      }
      event.preventDefault();
      x = event.pageX || event.originalEvent.changedTouches[0].pageX;
      this.onDragEnd(event, x);
      return false;
    };

    iOSCheckbox.defaults = {
      duration: 200,
      checkedLabel: 'ON',
      uncheckedLabel: 'OFF',
      resizeHandle: true,
      resizeContainer: true,
      disabledClass: 'iPhoneCheckDisabled',
      containerClass: 'iPhoneCheckContainer',
      labelOnClass: 'iPhoneCheckLabelOn',
      labelOffClass: 'iPhoneCheckLabelOff',
      handleClass: 'iPhoneCheckHandle',
      handleCenterClass: 'iPhoneCheckHandleCenter',
      handleRightClass: 'iPhoneCheckHandleRight',
      dragThreshold: 5,
      handleMargin: 15,
      handleRadius: 4,
      containerRadius: 5,
      dataName: "iphoneStyle",
      onChange: function() {}
    };

    return iOSCheckbox;

  })();

  $.iphoneStyle = this.iOSCheckbox = iOSCheckbox;

  $.fn.iphoneStyle = function() {
    var args, checkbox, dataName, existingControl, method, params, _i, _len, _ref, _ref1, _ref2, _ref3;

    args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
    dataName = (_ref = (_ref1 = args[0]) != null ? _ref1.dataName : void 0) != null ? _ref : iOSCheckbox.defaults.dataName;
    _ref2 = this.filter(':checkbox');
    for (_i = 0, _len = _ref2.length; _i < _len; _i++) {
      checkbox = _ref2[_i];
      existingControl = $(checkbox).data(dataName);
      if (existingControl != null) {
        method = args[0], params = 2 <= args.length ? __slice.call(args, 1) : [];
        if ((_ref3 = existingControl[method]) != null) {
          _ref3.apply(existingControl, params);
        }
      } else {
        new iOSCheckbox(checkbox, args[0]);
      }
    }
    return this;
  };

  $.fn.iOSCheckbox = function(options) {
    var opts;

    if (options == null) {
      options = {};
    }
    opts = $.extend({}, options, {
      resizeHandle: false,
      disabledClass: 'iOSCheckDisabled',
      containerClass: 'iOSCheckContainer',
      labelOnClass: 'iOSCheckLabelOn',
      labelOffClass: 'iOSCheckLabelOff',
      handleClass: 'iOSCheckHandle',
      handleCenterClass: 'iOSCheckHandleCenter',
      handleRightClass: 'iOSCheckHandleRight',
      dataName: 'iOSCheckbox'
    });
    return this.iphoneStyle(opts);
  };

}).call(this);

/* -------- studio/v2/js/bootstrap-datepicker.js -------- */
/* =========================================================
 * bootstrap-datepicker.js
 * Repo: https://github.com/eternicode/bootstrap-datepicker/
 * Demo: http://eternicode.github.io/bootstrap-datepicker/
 * Docs: http://bootstrap-datepicker.readthedocs.org/
 * Forked from http://www.eyecon.ro/bootstrap-datepicker
 * =========================================================
 * Started by Stefan Petre; improvements by Andrew Rowls + contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================= */

(function($, undefined){

	var $window = $(window);

	function UTCDate(){
		return new Date(Date.UTC.apply(Date, arguments));
	}
	function UTCToday(){
		var today = new Date();
		return UTCDate(today.getFullYear(), today.getMonth(), today.getDate());
	}
	function alias(method){
		return function(){
			return this[method].apply(this, arguments);
		};
	}

	var DateArray = (function(){
		var extras = {
			get: function(i){
				return this.slice(i)[0];
			},
			contains: function(d){
				// Array.indexOf is not cross-browser;
				// $.inArray doesn't work with Dates
				var val = d && d.valueOf();
				for (var i=0, l=this.length; i < l; i++)
					if (this[i].valueOf() === val)
						return i;
				return -1;
			},
			remove: function(i){
				this.splice(i,1);
			},
			replace: function(new_array){
				if (!new_array)
					return;
				if (!$.isArray(new_array))
					new_array = [new_array];
				this.clear();
				this.push.apply(this, new_array);
			},
			clear: function(){
				this.length = 0;
			},
			copy: function(){
				var a = new DateArray();
				a.replace(this);
				return a;
			}
		};

		return function(){
			var a = [];
			a.push.apply(a, arguments);
			$.extend(a, extras);
			return a;
		};
	})();


	// Picker object

	var Datepicker = function(element, options){
		this.dates = new DateArray();
		this.viewDate = UTCToday();
		this.focusDate = null;

		this._process_options(options);

		this.element = $(element);
		this.isInline = false;
		this.isInput = this.element.is('input');
		this.component = this.element.is('.date') ? this.element.find('.add-on, .input-group-addon, .btn') : false;
		this.hasInput = this.component && this.element.find('input').length;
		if (this.component && this.component.length === 0)
			this.component = false;

		this.picker = $(DPGlobal.template);
		this._buildEvents();
		this._attachEvents();

		if (this.isInline){
			this.picker.addClass('datepicker-inline').appendTo(this.element);
		}
		else {
			this.picker.addClass('datepicker-dropdown dropdown-menu');
		}

		if (this.o.rtl){
			this.picker.addClass('datepicker-rtl');
		}

		this.viewMode = this.o.startView;

		if (this.o.calendarWeeks)
			this.picker.find('tfoot th.today, tfoot th.clear')
						.attr('colspan', function(i, val){
							return parseInt(val) + 1;
						});

		this._allow_update = false;

		this.setStartDate(this._o.startDate);
		this.setEndDate(this._o.endDate);
		this.setDaysOfWeekDisabled(this.o.daysOfWeekDisabled);

		this.fillDow();
		this.fillMonths();

		this._allow_update = true;

		this.update();
		this.showMode();

		if (this.isInline){
			this.show();
		}
	};

	Datepicker.prototype = {
		constructor: Datepicker,

		_process_options: function(opts){
			// Store raw options for reference
			this._o = $.extend({}, this._o, opts);
			// Processed options
			var o = this.o = $.extend({}, this._o);

			// Check if "de-DE" style date is available, if not language should
			// fallback to 2 letter code eg "de"
			var lang = o.language;
			if (!dates[lang]){
				lang = lang.split('-')[0];
				if (!dates[lang])
					lang = defaults.language;
			}
			o.language = lang;

			switch (o.startView){
				case 2:
				case 'decade':
					o.startView = 2;
					break;
				case 1:
				case 'year':
					o.startView = 1;
					break;
				default:
					o.startView = 0;
			}

			switch (o.minViewMode){
				case 1:
				case 'months':
					o.minViewMode = 1;
					break;
				case 2:
				case 'years':
					o.minViewMode = 2;
					break;
				default:
					o.minViewMode = 0;
			}

			o.startView = Math.max(o.startView, o.minViewMode);

			// true, false, or Number > 0
			if (o.multidate !== true){
				o.multidate = Number(o.multidate) || false;
				if (o.multidate !== false)
					o.multidate = Math.max(0, o.multidate);
				else
					o.multidate = 1;
			}
			o.multidateSeparator = String(o.multidateSeparator);

			o.weekStart %= 7;
			o.weekEnd = ((o.weekStart + 6) % 7);

			var format = DPGlobal.parseFormat(o.format);
			if (o.startDate !== -Infinity){
				if (!!o.startDate){
					if (o.startDate instanceof Date)
						o.startDate = this._local_to_utc(this._zero_time(o.startDate));
					else
						o.startDate = DPGlobal.parseDate(o.startDate, format, o.language);
				}
				else {
					o.startDate = -Infinity;
				}
			}
			if (o.endDate !== Infinity){
				if (!!o.endDate){
					if (o.endDate instanceof Date)
						o.endDate = this._local_to_utc(this._zero_time(o.endDate));
					else
						o.endDate = DPGlobal.parseDate(o.endDate, format, o.language);
				}
				else {
					o.endDate = Infinity;
				}
			}

			o.daysOfWeekDisabled = o.daysOfWeekDisabled||[];
			if (!$.isArray(o.daysOfWeekDisabled))
				o.daysOfWeekDisabled = o.daysOfWeekDisabled.split(/[,\s]*/);
			o.daysOfWeekDisabled = $.map(o.daysOfWeekDisabled, function(d){
				return parseInt(d, 10);
			});

			var plc = String(o.orientation).toLowerCase().split(/\s+/g),
				_plc = o.orientation.toLowerCase();
			plc = $.grep(plc, function(word){
				return (/^auto|left|right|top|bottom$/).test(word);
			});
			o.orientation = {x: 'auto', y: 'auto'};
			if (!_plc || _plc === 'auto')
				; // no action
			else if (plc.length === 1){
				switch (plc[0]){
					case 'top':
					case 'bottom':
						o.orientation.y = plc[0];
						break;
					case 'left':
					case 'right':
						o.orientation.x = plc[0];
						break;
				}
			}
			else {
				_plc = $.grep(plc, function(word){
					return (/^left|right$/).test(word);
				});
				o.orientation.x = _plc[0] || 'auto';

				_plc = $.grep(plc, function(word){
					return (/^top|bottom$/).test(word);
				});
				o.orientation.y = _plc[0] || 'auto';
			}
		},
		_events: [],
		_secondaryEvents: [],
		_applyEvents: function(evs){
			for (var i=0, el, ch, ev; i < evs.length; i++){
				el = evs[i][0];
				if (evs[i].length === 2){
					ch = undefined;
					ev = evs[i][1];
				}
				else if (evs[i].length === 3){
					ch = evs[i][1];
					ev = evs[i][2];
				}
				el.on(ev, ch);
			}
		},
		_unapplyEvents: function(evs){
			for (var i=0, el, ev, ch; i < evs.length; i++){
				el = evs[i][0];
				if (evs[i].length === 2){
					ch = undefined;
					ev = evs[i][1];
				}
				else if (evs[i].length === 3){
					ch = evs[i][1];
					ev = evs[i][2];
				}
				el.off(ev, ch);
			}
		},
		_buildEvents: function(){
			if (this.isInput){ // single input
				this._events = [
					[this.element, {
						focus: $.proxy(this.show, this),
						keyup: $.proxy(function(e){
							if ($.inArray(e.keyCode, [27,37,39,38,40,32,13,9]) === -1)
								this.update();
						}, this),
						keydown: $.proxy(this.keydown, this)
					}]
				];
			}
			else if (this.component && this.hasInput){ // component: input + button
				this._events = [
					// For components that are not readonly, allow keyboard nav
					[this.element.find('input'), {
						focus: $.proxy(this.show, this),
						keyup: $.proxy(function(e){
							if ($.inArray(e.keyCode, [27,37,39,38,40,32,13,9]) === -1)
								this.update();
						}, this),
						keydown: $.proxy(this.keydown, this)
					}],
					[this.component, {
						click: $.proxy(this.show, this)
					}]
				];
			}
			else if (this.element.is('div')){  // inline datepicker
				this.isInline = true;
			}
			else {
				this._events = [
					[this.element, {
						click: $.proxy(this.show, this)
					}]
				];
			}
			this._events.push(
				// Component: listen for blur on element descendants
				[this.element, '*', {
					blur: $.proxy(function(e){
						this._focused_from = e.target;
					}, this)
				}],
				// Input: listen for blur on element
				[this.element, {
					blur: $.proxy(function(e){
						this._focused_from = e.target;
					}, this)
				}]
			);

			this._secondaryEvents = [
				[this.picker, {
					click: $.proxy(this.click, this)
				}],
				[$(window), {
					resize: $.proxy(this.place, this)
				}],
				[$(document), {
					'mousedown touchend': $.proxy(function(e){
						// Clicked outside the datepicker, hide it
						if (!(
							this.element.is(e.target) ||
							this.element.find(e.target).length ||
							this.picker.is(e.target) ||
							this.picker.find(e.target).length
						)){
							this.hide();
						}
					}, this)
				}]
			];
		},
		_attachEvents: function(){
			this._detachEvents();
			this._applyEvents(this._events);
		},
		_detachEvents: function(){
			this._unapplyEvents(this._events);
		},
		_attachSecondaryEvents: function(){
			this._detachSecondaryEvents();
			this._applyEvents(this._secondaryEvents);
		},
		_detachSecondaryEvents: function(){
			this._unapplyEvents(this._secondaryEvents);
		},
		_trigger: function(event, altdate){
			var date = altdate || this.dates.get(-1),
				local_date = this._utc_to_local(date);

			this.element.trigger({
				type: event,
				namespace: 'bs.datepicker',
				date: local_date,
				dates: $.map(this.dates, this._utc_to_local),
				format: $.proxy(function(ix, format){
					if (arguments.length === 0){
						ix = this.dates.length - 1;
						format = this.o.format;
					}
					else if (typeof ix === 'string'){
						format = ix;
						ix = this.dates.length - 1;
					}
					format = format || this.o.format;
					var date = this.dates.get(ix);
					return DPGlobal.formatDate(date, format, this.o.language);
				}, this)
			});
		},

		show: function(){
			if (!this.isInline)
				this.element.after(this.picker);
			this.place();
			this.picker.show();
			this._attachSecondaryEvents();
			this._trigger('show');
		},

		hide: function(){
			if (this.isInline)
				return;
			if (!this.picker.is(':visible'))
				return;
			this.focusDate = null;
			this.picker.hide().detach();
			this._detachSecondaryEvents();
			this.viewMode = this.o.startView;
			this.showMode();

			if (
				this.o.forceParse &&
				(
					this.isInput && this.element.val() ||
					this.hasInput && this.element.find('input').val()
				)
			)
				this.setValue();
			this._trigger('hide');
		},

		remove: function(){
			this.hide();
			this._detachEvents();
			this._detachSecondaryEvents();
			this.picker.remove();
			delete this.element.data().datepicker;
			if (!this.isInput){
				delete this.element.data().date;
			}
		},

		_utc_to_local: function(utc){
			return utc && new Date(utc.getTime() + (utc.getTimezoneOffset()*60000));
		},
		_local_to_utc: function(local){
			return local && new Date(local.getTime() - (local.getTimezoneOffset()*60000));
		},
		_zero_time: function(local){
			return local && new Date(local.getFullYear(), local.getMonth(), local.getDate());
		},
		_zero_utc_time: function(utc){
			return utc && new Date(Date.UTC(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate()));
		},

		getDates: function(){
			return $.map(this.dates, this._utc_to_local);
		},

		getUTCDates: function(){
			return $.map(this.dates, function(d){
				return new Date(d);
			});
		},

		getDate: function(){
			return this._utc_to_local(this.getUTCDate());
		},

		getUTCDate: function(){
			return new Date(this.dates.get(-1));
		},

		clearDates: function(){
			var element;
			if (this.isInput){
				element = this.element;
			} else if (this.component){
				element = this.element.find('input');
			}
			if (element){
				element.val("");
			}
			this.update();
			this._trigger('changeDate');
			if (element){
				element.trigger('change.bs.datepicker');
			}
		},

		setDates: function(){
			var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
			this.update.apply(this, args);
			this._trigger('changeDate');
			this._trigger('change');
			this.setValue();
		},

		setUTCDates: function(){
			var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
			this.update.apply(this, $.map(args, this._utc_to_local));
			this._trigger('changeDate');
			this._trigger('change');
			this.setValue();
		},

		setDate: alias('setDates'),
		setUTCDate: alias('setUTCDates'),

		setValue: function(){
			var formatted = this.getFormattedDate();
			if (!this.isInput){
				if (this.component){
					this.element.find('input').val(formatted);
				}
			}
			else {
				this.element.val(formatted);
			}
		},

		getFormattedDate: function(format){
			if (format === undefined)
				format = this.o.format;

			var lang = this.o.language;
			return $.map(this.dates, function(d){
				return DPGlobal.formatDate(d, format, lang);
			}).join(this.o.multidateSeparator);
		},

		setStartDate: function(startDate){
			this._process_options({startDate: startDate});
			this.update();
			this.updateNavArrows();
		},

		setEndDate: function(endDate){
			this._process_options({endDate: endDate});
			this.update();
			this.updateNavArrows();
		},

		setDaysOfWeekDisabled: function(daysOfWeekDisabled){
			this._process_options({daysOfWeekDisabled: daysOfWeekDisabled});
			this.update();
			this.updateNavArrows();
		},

		place: function(){
			if (this.isInline)
				return;
			var calendarWidth = this.picker.outerWidth(),
				calendarHeight = this.picker.outerHeight(),
				visualPadding = 10,
				windowWidth = $window.width(),
				windowHeight = $window.height(),
				scrollTop = $window.scrollTop();

			var parentZIndexes = this.element.parents().map(function() {
					return parseInt($(this).css('z-index')) || 0;
				});
			var zIndex = Math.max.apply(Math, Array.prototype.slice.apply(parentZIndexes)) + 10;
			var offset = this.component ? this.component.parent().offset() : this.element.offset();
			var height = this.component ? this.component.outerHeight(true) : this.element.outerHeight(false);
			var width = this.component ? this.component.outerWidth(true) : this.element.outerWidth(false);
			var left = this.component ? this.component.parent().position().left : this.element.position().left;
			var top = this.component ? this.component.parent().position().top : this.element.position().top;

			this.picker.removeClass(
				'datepicker-orient-top datepicker-orient-bottom '+
				'datepicker-orient-right datepicker-orient-left'
			);

			if (this.o.orientation.x !== 'auto'){
				this.picker.addClass('datepicker-orient-' + this.o.orientation.x);
				if (this.o.orientation.x === 'right')
					left -= calendarWidth - width;
			}
			// auto x orientation is best-placement: if it crosses a window
			// edge, fudge it sideways
			else {
				// Default to left
				this.picker.addClass('datepicker-orient-left');
				if (offset.left < 0)
					left -= offset.left - visualPadding;
				else if (offset.left + calendarWidth > windowWidth)
					left = windowWidth - calendarWidth - visualPadding;
			}

			// auto y orientation is best-situation: top or bottom, no fudging,
			// decision based on which shows more of the calendar
			var yorient = this.o.orientation.y,
				top_overflow, bottom_overflow;
			if (yorient === 'auto'){
				top_overflow = -scrollTop + offset.top - calendarHeight;
				bottom_overflow = scrollTop + windowHeight - (offset.top + height + calendarHeight);
				if (Math.max(top_overflow, bottom_overflow) === bottom_overflow)
					yorient = 'top';
				else
					yorient = 'bottom';
			}
			this.picker.addClass('datepicker-orient-' + yorient);
			if (yorient === 'top')
				top += height;
			else
				top -= calendarHeight + parseInt(this.picker.css('padding-top'));

			this.picker.css({
				top: top,
				left: left,
				zIndex: zIndex
			});
		},

		_allow_update: true,
		update: function(){
			if (!this._allow_update)
				return;

			var oldDates = this.dates.copy(),
				dates = [],
				fromArgs = false;
			if (arguments.length){
				$.each(arguments, $.proxy(function(i, date){
					if (date instanceof Date)
						date = this._local_to_utc(date);
					dates.push(date);
				}, this));
				fromArgs = true;
			}
			else {
				dates = this.isInput
						? this.element.val()
						: this.element.data('date') || this.element.find('input').val();
				if (dates && this.o.multidate)
					dates = dates.split(this.o.multidateSeparator);
				else
					dates = [dates];
				delete this.element.data().date;
			}

			dates = $.map(dates, $.proxy(function(date){
				return DPGlobal.parseDate(date, this.o.format, this.o.language);
			}, this));
			dates = $.grep(dates, $.proxy(function(date){
				return (
					date < this.o.startDate ||
					date > this.o.endDate ||
					!date
				);
			}, this), true);
			this.dates.replace(dates);

			if (this.dates.length)
				this.viewDate = new Date(this.dates.get(-1));
			else if (this.viewDate < this.o.startDate)
				this.viewDate = new Date(this.o.startDate);
			else if (this.viewDate > this.o.endDate)
				this.viewDate = new Date(this.o.endDate);

			if (fromArgs){
				// setting date by clicking
				this.setValue();
			}
			else if (dates.length){
				// setting date by typing
				if (String(oldDates) !== String(this.dates))
					this._trigger('changeDate');
			}
			if (!this.dates.length && oldDates.length)
				this._trigger('clearDate');

			this.fill();
		},

		fillDow: function(){
			var dowCnt = this.o.weekStart,
				html = '<tr>';
			if (this.o.calendarWeeks){
				var cell = '<th class="cw">&#160;</th>';
				html += cell;
				this.picker.find('.datepicker-days thead tr:first-child').prepend(cell);
			}
			while (dowCnt < this.o.weekStart + 7){
				html += '<th class="dow">'+dates[this.o.language].daysMin[(dowCnt++)%7]+'</th>';
			}
			html += '</tr>';
			this.picker.find('.datepicker-days thead').append(html);
		},

		fillMonths: function(){
			var html = '',
			i = 0;
			while (i < 12){
				html += '<span class="month">'+dates[this.o.language].monthsShort[i++]+'</span>';
			}
			this.picker.find('.datepicker-months td').html(html);
		},

		setRange: function(range){
			if (!range || !range.length)
				delete this.range;
			else
				this.range = $.map(range, function(d){
					return d.valueOf();
				});
			this.fill();
		},

		getClassNames: function(date){
			var cls = [],
				year = this.viewDate.getUTCFullYear(),
				month = this.viewDate.getUTCMonth(),
				today = new Date();
			if (date.getUTCFullYear() < year || (date.getUTCFullYear() === year && date.getUTCMonth() < month)){
				cls.push('old');
			}
			else if (date.getUTCFullYear() > year || (date.getUTCFullYear() === year && date.getUTCMonth() > month)){
				cls.push('new');
			}
			if (this.focusDate && date.valueOf() === this.focusDate.valueOf())
				cls.push('focused');
			// Compare internal UTC date with local today, not UTC today
			if (this.o.todayHighlight &&
				date.getUTCFullYear() === today.getFullYear() &&
				date.getUTCMonth() === today.getMonth() &&
				date.getUTCDate() === today.getDate()){
				cls.push('today');
			}
			if (this.dates.contains(date) !== -1)
				cls.push('active');
			if (date.valueOf() < this.o.startDate || date.valueOf() > this.o.endDate ||
				$.inArray(date.getUTCDay(), this.o.daysOfWeekDisabled) !== -1){
				cls.push('disabled');
			}
			if (this.range){
				if (date > this.range[0] && date < this.range[this.range.length-1]){
					cls.push('range');
				}
				if ($.inArray(date.valueOf(), this.range) !== -1){
					cls.push('selected');
				}
			}
			return cls;
		},

		fill: function(){
			var d = new Date(this.viewDate),
				year = d.getUTCFullYear(),
				month = d.getUTCMonth(),
				startYear = this.o.startDate !== -Infinity ? this.o.startDate.getUTCFullYear() : -Infinity,
				startMonth = this.o.startDate !== -Infinity ? this.o.startDate.getUTCMonth() : -Infinity,
				endYear = this.o.endDate !== Infinity ? this.o.endDate.getUTCFullYear() : Infinity,
				endMonth = this.o.endDate !== Infinity ? this.o.endDate.getUTCMonth() : Infinity,
				todaytxt = dates[this.o.language].today || dates['en'].today || '',
				cleartxt = dates[this.o.language].clear || dates['en'].clear || '',
				tooltip;
			this.picker.find('.datepicker-days thead th.datepicker-switch')
						.text(dates[this.o.language].months[month]+' '+year);
			this.picker.find('tfoot th.today')
						.text(todaytxt)
						.toggle(this.o.todayBtn !== false);
			this.picker.find('tfoot th.clear')
						.text(cleartxt)
						.toggle(this.o.clearBtn !== false);
			this.updateNavArrows();
			this.fillMonths();
			var prevMonth = UTCDate(year, month-1, 28),
				day = DPGlobal.getDaysInMonth(prevMonth.getUTCFullYear(), prevMonth.getUTCMonth());
			prevMonth.setUTCDate(day);
			prevMonth.setUTCDate(day - (prevMonth.getUTCDay() - this.o.weekStart + 7)%7);
			var nextMonth = new Date(prevMonth);
			nextMonth.setUTCDate(nextMonth.getUTCDate() + 42);
			nextMonth = nextMonth.valueOf();
			var html = [];
			var clsName;
			while (prevMonth.valueOf() < nextMonth){
				if (prevMonth.getUTCDay() === this.o.weekStart){
					html.push('<tr>');
					if (this.o.calendarWeeks){
						// ISO 8601: First week contains first thursday.
						// ISO also states week starts on Monday, but we can be more abstract here.
						var
							// Start of current week: based on weekstart/current date
							ws = new Date(+prevMonth + (this.o.weekStart - prevMonth.getUTCDay() - 7) % 7 * 864e5),
							// Thursday of this week
							th = new Date(Number(ws) + (7 + 4 - ws.getUTCDay()) % 7 * 864e5),
							// First Thursday of year, year from thursday
							yth = new Date(Number(yth = UTCDate(th.getUTCFullYear(), 0, 1)) + (7 + 4 - yth.getUTCDay())%7*864e5),
							// Calendar week: ms between thursdays, div ms per day, div 7 days
							calWeek =  (th - yth) / 864e5 / 7 + 1;
						html.push('<td class="cw">'+ calWeek +'</td>');

					}
				}
				clsName = this.getClassNames(prevMonth);
				clsName.push('day');

				if (this.o.beforeShowDay !== $.noop){
					var before = this.o.beforeShowDay(this._utc_to_local(prevMonth));
					if (before === undefined)
						before = {};
					else if (typeof(before) === 'boolean')
						before = {enabled: before};
					else if (typeof(before) === 'string')
						before = {classes: before};
					if (before.enabled === false)
						clsName.push('disabled');
					if (before.classes)
						clsName = clsName.concat(before.classes.split(/\s+/));
					if (before.tooltip)
						tooltip = before.tooltip;
				}

				clsName = $.unique(clsName);
				html.push('<td class="'+clsName.join(' ')+'"' + (tooltip ? ' title="'+tooltip+'"' : '') + '>'+prevMonth.getUTCDate() + '</td>');
				if (prevMonth.getUTCDay() === this.o.weekEnd){
					html.push('</tr>');
				}
				prevMonth.setUTCDate(prevMonth.getUTCDate()+1);
			}
			this.picker.find('.datepicker-days tbody').empty().append(html.join(''));

			var months = this.picker.find('.datepicker-months')
						.find('th:eq(1)')
							.text(year)
							.end()
						.find('span').removeClass('active');

			$.each(this.dates, function(i, d){
				if (d.getUTCFullYear() === year)
					months.eq(d.getUTCMonth()).addClass('active');
			});

			if (year < startYear || year > endYear){
				months.addClass('disabled');
			}
			if (year === startYear){
				months.slice(0, startMonth).addClass('disabled');
			}
			if (year === endYear){
				months.slice(endMonth+1).addClass('disabled');
			}

			html = '';
			year = parseInt(year/10, 10) * 10;
			var yearCont = this.picker.find('.datepicker-years')
								.find('th:eq(1)')
									.text(year + '-' + (year + 9))
									.end()
								.find('td');
			year -= 1;
			var years = $.map(this.dates, function(d){
					return d.getUTCFullYear();
				}),
				classes;
			for (var i = -1; i < 11; i++){
				classes = ['year'];
				if (i === -1)
					classes.push('old');
				else if (i === 10)
					classes.push('new');
				if ($.inArray(year, years) !== -1)
					classes.push('active');
				if (year < startYear || year > endYear)
					classes.push('disabled');
				html += '<span class="' + classes.join(' ') + '">'+year+'</span>';
				year += 1;
			}
			yearCont.html(html);
		},

		updateNavArrows: function(){
			if (!this._allow_update)
				return;

			var d = new Date(this.viewDate),
				year = d.getUTCFullYear(),
				month = d.getUTCMonth();
			switch (this.viewMode){
				case 0:
					if (this.o.startDate !== -Infinity && year <= this.o.startDate.getUTCFullYear() && month <= this.o.startDate.getUTCMonth()){
						this.picker.find('.prev').css({visibility: 'hidden'});
					}
					else {
						this.picker.find('.prev').css({visibility: 'visible'});
					}
					if (this.o.endDate !== Infinity && year >= this.o.endDate.getUTCFullYear() && month >= this.o.endDate.getUTCMonth()){
						this.picker.find('.next').css({visibility: 'hidden'});
					}
					else {
						this.picker.find('.next').css({visibility: 'visible'});
					}
					break;
				case 1:
				case 2:
					if (this.o.startDate !== -Infinity && year <= this.o.startDate.getUTCFullYear()){
						this.picker.find('.prev').css({visibility: 'hidden'});
					}
					else {
						this.picker.find('.prev').css({visibility: 'visible'});
					}
					if (this.o.endDate !== Infinity && year >= this.o.endDate.getUTCFullYear()){
						this.picker.find('.next').css({visibility: 'hidden'});
					}
					else {
						this.picker.find('.next').css({visibility: 'visible'});
					}
					break;
			}
		},

		click: function(e){
			e.preventDefault();
			var target = $(e.target).closest('span, td, th'),
				year, month, day;
			if (target.length === 1){
				switch (target[0].nodeName.toLowerCase()){
					case 'th':
						switch (target[0].className){
							case 'datepicker-switch':
								this.showMode(1);
								break;
							case 'prev':
							case 'next':
								var dir = DPGlobal.modes[this.viewMode].navStep * (target[0].className === 'prev' ? -1 : 1);
								switch (this.viewMode){
									case 0:
										this.viewDate = this.moveMonth(this.viewDate, dir);
										this._trigger('changeMonth', this.viewDate);
										break;
									case 1:
									case 2:
										this.viewDate = this.moveYear(this.viewDate, dir);
										if (this.viewMode === 1)
											this._trigger('changeYear', this.viewDate);
										break;
								}
								this.fill();
								break;
							case 'today':
								var date = new Date();
								date = UTCDate(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);

								this.showMode(-2);
								var which = this.o.todayBtn === 'linked' ? null : 'view';
								this._setDate(date, which);
								break;
							case 'clear':
								this.clearDates();
								if (this.o.autoclose)
									this.hide();
								break;
						}
						break;
					case 'span':
						if (!target.is('.disabled')){
							this.viewDate.setUTCDate(1);
							if (target.is('.month')){
								day = 1;
								month = target.parent().find('span').index(target);
								year = this.viewDate.getUTCFullYear();
								this.viewDate.setUTCMonth(month);
								this._trigger('changeMonth', this.viewDate);
								if (this.o.minViewMode === 1){
									this._setDate(UTCDate(year, month, day));
								}
							}
							else {
								day = 1;
								month = 0;
								year = parseInt(target.text(), 10)||0;
								this.viewDate.setUTCFullYear(year);
								this._trigger('changeYear', this.viewDate);
								if (this.o.minViewMode === 2){
									this._setDate(UTCDate(year, month, day));
								}
							}
							this.showMode(-1);
							this.fill();
						}
						break;
					case 'td':
						if (target.is('.day') && !target.is('.disabled')){
							day = parseInt(target.text(), 10)||1;
							year = this.viewDate.getUTCFullYear();
							month = this.viewDate.getUTCMonth();
							if (target.is('.old')){
								if (month === 0){
									month = 11;
									year -= 1;
								}
								else {
									month -= 1;
								}
							}
							else if (target.is('.new')){
								if (month === 11){
									month = 0;
									year += 1;
								}
								else {
									month += 1;
								}
							}
							this._setDate(UTCDate(year, month, day));
						}
						break;
				}
			}
			if (this.picker.is(':visible') && this._focused_from){
				$(this._focused_from).focus();
			}
			delete this._focused_from;
		},

		_toggle_multidate: function(date){
			if (!date){
				this.dates.clear();
				return;
			}
			// remove to prevent duplicates
			var ix = this.dates.contains(date);
			if (ix !== -1){ // found
				this.dates.remove(ix);
				if (this.o.multidate !== true) {
					this.dates.push(date);
				}
			} else {
				this.dates.push(date);
			}
			if (typeof this.o.multidate === 'number') {
				while (this.dates.length > this.o.multidate){
					this.dates.shift();
				}
			}
		},

		_setDate: function(date, which){
			if (!which || which === 'date')
				this._toggle_multidate(date && new Date(date));
			if (!which || which  === 'view')
				this.viewDate = date && new Date(date);

			this.fill();
			this.setValue();
			this._trigger('changeDate');
			var element;
			if (this.isInput){
				element = this.element;
			}
			else if (this.component){
				element = this.element.find('input');
			}
			if (element){
				element.trigger('change.bs.datepicker');
			}
			if (this.o.autoclose && (!which || which === 'date')){
				this.hide();
			}
		},

		moveMonth: function(date, dir){
			if (!date)
				return undefined;
			if (!dir)
				return date;
			var new_date = new Date(date.valueOf()),
				day = new_date.getUTCDate(),
				month = new_date.getUTCMonth(),
				mag = Math.abs(dir),
				new_month, test;
			dir = dir > 0 ? 1 : -1;
			if (mag === 1){
				test = dir === -1
					// If going back one month, make sure month is not current month
					// (eg, Mar 31 -> Feb 31 == Feb 28, not Mar 02)
					? function(){
						return new_date.getUTCMonth() === month;
					}
					// If going forward one month, make sure month is as expected
					// (eg, Jan 31 -> Feb 31 == Feb 28, not Mar 02)
					: function(){
						return new_date.getUTCMonth() !== new_month;
					};
				new_month = month + dir;
				new_date.setUTCMonth(new_month);
				// Dec -> Jan (12) or Jan -> Dec (-1) -- limit expected date to 0-11
				if (new_month < 0 || new_month > 11)
					new_month = (new_month + 12) % 12;
			}
			else {
				// For magnitudes >1, move one month at a time...
				for (var i=0; i < mag; i++)
					// ...which might decrease the day (eg, Jan 31 to Feb 28, etc)...
					new_date = this.moveMonth(new_date, dir);
				// ...then reset the day, keeping it in the new month
				new_month = new_date.getUTCMonth();
				new_date.setUTCDate(day);
				test = function(){
					return new_month !== new_date.getUTCMonth();
				};
			}
			// Common date-resetting loop -- if date is beyond end of month, make it
			// end of month
			while (test()){
				new_date.setUTCDate(--day);
				new_date.setUTCMonth(new_month);
			}
			return new_date;
		},

		moveYear: function(date, dir){
			return this.moveMonth(date, dir*12);
		},

		dateWithinRange: function(date){
			return date >= this.o.startDate && date <= this.o.endDate;
		},

		keydown: function(e){
			if (this.picker.is(':not(:visible)')){
				if (e.keyCode === 27) // allow escape to hide and re-show picker
					this.show();
				return;
			}
			var dateChanged = false,
				dir, newDate, newViewDate,
				focusDate = this.focusDate || this.viewDate;
			switch (e.keyCode){
				case 27: // escape
					if (this.focusDate){
						this.focusDate = null;
						this.viewDate = this.dates.get(-1) || this.viewDate;
						this.fill();
					}
					else
						this.hide();
					e.preventDefault();
					break;
				case 37: // left
				case 39: // right
					if (!this.o.keyboardNavigation)
						break;
					dir = e.keyCode === 37 ? -1 : 1;
					if (e.ctrlKey){
						newDate = this.moveYear(this.dates.get(-1) || UTCToday(), dir);
						newViewDate = this.moveYear(focusDate, dir);
						this._trigger('changeYear', this.viewDate);
					}
					else if (e.shiftKey){
						newDate = this.moveMonth(this.dates.get(-1) || UTCToday(), dir);
						newViewDate = this.moveMonth(focusDate, dir);
						this._trigger('changeMonth', this.viewDate);
					}
					else {
						newDate = new Date(this.dates.get(-1) || UTCToday());
						newDate.setUTCDate(newDate.getUTCDate() + dir);
						newViewDate = new Date(focusDate);
						newViewDate.setUTCDate(focusDate.getUTCDate() + dir);
					}
					if (this.dateWithinRange(newDate)){
						this.focusDate = this.viewDate = newViewDate;
						this.setValue();
						this.fill();
						e.preventDefault();
					}
					break;
				case 38: // up
				case 40: // down
					if (!this.o.keyboardNavigation)
						break;
					dir = e.keyCode === 38 ? -1 : 1;
					if (e.ctrlKey){
						newDate = this.moveYear(this.dates.get(-1) || UTCToday(), dir);
						newViewDate = this.moveYear(focusDate, dir);
						this._trigger('changeYear', this.viewDate);
					}
					else if (e.shiftKey){
						newDate = this.moveMonth(this.dates.get(-1) || UTCToday(), dir);
						newViewDate = this.moveMonth(focusDate, dir);
						this._trigger('changeMonth', this.viewDate);
					}
					else {
						newDate = new Date(this.dates.get(-1) || UTCToday());
						newDate.setUTCDate(newDate.getUTCDate() + dir * 7);
						newViewDate = new Date(focusDate);
						newViewDate.setUTCDate(focusDate.getUTCDate() + dir * 7);
					}
					if (this.dateWithinRange(newDate)){
						this.focusDate = this.viewDate = newViewDate;
						this.setValue();
						this.fill();
						e.preventDefault();
					}
					break;
				case 32: // spacebar
					// Spacebar is used in manually typing dates in some formats.
					// As such, its behavior should not be hijacked.
					break;
				case 13: // enter
					focusDate = this.focusDate || this.dates.get(-1) || this.viewDate;
					this._toggle_multidate(focusDate);
					dateChanged = true;
					this.focusDate = null;
					this.viewDate = this.dates.get(-1) || this.viewDate;
					this.setValue();
					this.fill();
					if (this.picker.is(':visible')){
						e.preventDefault();
						if (this.o.autoclose)
							this.hide();
					}
					break;
				case 9: // tab
					this.focusDate = null;
					this.viewDate = this.dates.get(-1) || this.viewDate;
					this.fill();
					this.hide();
					break;
			}
			if (dateChanged){
				if (this.dates.length)
					this._trigger('changeDate');
				else
					this._trigger('clearDate');
				var element;
				if (this.isInput){
					element = this.element;
				}
				else if (this.component){
					element = this.element.find('input');
				}
				if (element){
					element.trigger('change.bs.datepicker');
				}
			}
		},

		showMode: function(dir){
			if (dir){
				this.viewMode = Math.max(this.o.minViewMode, Math.min(2, this.viewMode + dir));
			}
			this.picker
				.find('>div')
				.hide()
				.filter('.datepicker-'+DPGlobal.modes[this.viewMode].clsName)
					.css('display', 'block');
			this.updateNavArrows();
		}
	};

	var DateRangePicker = function(element, options){
		this.element = $(element);
		this.inputs = $.map(options.inputs, function(i){
			return i.jquery ? i[0] : i;
		});
		delete options.inputs;

		$(this.inputs)
			.datepicker(options)
			.bind('changeDate', $.proxy(this.dateUpdated, this));

		this.pickers = $.map(this.inputs, function(i){
			return $(i).data('datepicker');
		});
		this.updateDates();
	};
	DateRangePicker.prototype = {
		updateDates: function(){
			this.dates = $.map(this.pickers, function(i){
				return i.getUTCDate();
			});
			this.updateRanges();
		},
		updateRanges: function(){
			var range = $.map(this.dates, function(d){
				return d.valueOf();
			});
			$.each(this.pickers, function(i, p){
				p.setRange(range);
			});
		},
		dateUpdated: function(e){
			// `this.updating` is a workaround for preventing infinite recursion
			// between `changeDate` triggering and `setUTCDate` calling.  Until
			// there is a better mechanism.
			if (this.updating)
				return;
			this.updating = true;

			var dp = $(e.target).data('datepicker'),
				new_date = dp.getUTCDate(),
				i = $.inArray(e.target, this.inputs),
				l = this.inputs.length;
			if (i === -1)
				return;

			$.each(this.pickers, function(i, p){
				if (!p.getUTCDate())
					p.setUTCDate(new_date);
			});

			if (new_date < this.dates[i]){
				// Date being moved earlier/left
				while (i >= 0 && new_date < this.dates[i]){
					this.pickers[i--].setUTCDate(new_date);
				}
			}
			else if (new_date > this.dates[i]){
				// Date being moved later/right
				while (i < l && new_date > this.dates[i]){
					this.pickers[i++].setUTCDate(new_date);
				}
			}
			this.updateDates();

			delete this.updating;
		},
		remove: function(){
			$.map(this.pickers, function(p){ p.remove(); });
			delete this.element.data().datepicker;
		}
	};

	function opts_from_el(el, prefix){
		// Derive options from element data-attrs
		var data = $(el).data(),
			out = {}, inkey,
			replace = new RegExp('^' + prefix.toLowerCase() + '([A-Z])');
		prefix = new RegExp('^' + prefix.toLowerCase());
		function re_lower(_,a){
			return a.toLowerCase();
		}
		for (var key in data)
			if (prefix.test(key)){
				inkey = key.replace(replace, re_lower);
				out[inkey] = data[key];
			}
		return out;
	}

	function opts_from_locale(lang){
		// Derive options from locale plugins
		var out = {};
		// Check if "de-DE" style date is available, if not language should
		// fallback to 2 letter code eg "de"
		if (!dates[lang]){
			lang = lang.split('-')[0];
			if (!dates[lang])
				return;
		}
		var d = dates[lang];
		$.each(locale_opts, function(i,k){
			if (k in d)
				out[k] = d[k];
		});
		return out;
	}

	var old = $.fn.datepicker;
	$.fn.datepicker = function(option){
		var args = Array.apply(null, arguments);
		args.shift();
		var internal_return;
		this.each(function(){
			var $this = $(this),
				data = $this.data('datepicker'),
				options = typeof option === 'object' && option;
			if (!data){
				var elopts = opts_from_el(this, 'date'),
					// Preliminary otions
					xopts = $.extend({}, defaults, elopts, options),
					locopts = opts_from_locale(xopts.language),
					// Options priority: js args, data-attrs, locales, defaults
					opts = $.extend({}, defaults, locopts, elopts, options);
				if ($this.is('.input-daterange') || opts.inputs){
					var ropts = {
						inputs: opts.inputs || $this.find('input').toArray()
					};
					$this.data('datepicker', (data = new DateRangePicker(this, $.extend(opts, ropts))));
				}
				else {
					$this.data('datepicker', (data = new Datepicker(this, opts)));
				}
			}
			if (typeof option === 'string' && typeof data[option] === 'function'){
				internal_return = data[option].apply(data, args);
				if (internal_return !== undefined)
					return false;
			}
		});
		if (internal_return !== undefined)
			return internal_return;
		else
			return this;
	};

	var defaults = $.fn.datepicker.defaults = {
		autoclose: false,
		beforeShowDay: $.noop,
		calendarWeeks: false,
		clearBtn: false,
		daysOfWeekDisabled: [],
		endDate: Infinity,
		forceParse: true,
		format: 'mm/dd/yyyy',
		keyboardNavigation: true,
		language: 'en',
		minViewMode: 0,
		multidate: false,
		multidateSeparator: ',',
		orientation: "auto",
		rtl: false,
		startDate: -Infinity,
		startView: 0,
		todayBtn: false,
		todayHighlight: false,
		weekStart: 0
	};
	var locale_opts = $.fn.datepicker.locale_opts = [
		'format',
		'rtl',
		'weekStart'
	];
	$.fn.datepicker.Constructor = Datepicker;
	var dates = $.fn.datepicker.dates = {
		en: {
			days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
			daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
			daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
			months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
			monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
			today: "Today",
			clear: "Clear"
		}
	};

	var DPGlobal = {
		modes: [
			{
				clsName: 'days',
				navFnc: 'Month',
				navStep: 1
			},
			{
				clsName: 'months',
				navFnc: 'FullYear',
				navStep: 1
			},
			{
				clsName: 'years',
				navFnc: 'FullYear',
				navStep: 10
		}],
		isLeapYear: function(year){
			return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));
		},
		getDaysInMonth: function(year, month){
			return [31, (DPGlobal.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
		},
		validParts: /dd?|DD?|mm?|MM?|yy(?:yy)?/g,
		nonpunctuation: /[^ -\/:-@\[\u3400-\u9fff-`{-~\t\n\r]+/g,
		parseFormat: function(format){
			// IE treats \0 as a string end in inputs (truncating the value),
			// so it's a bad format delimiter, anyway
			var separators = format.replace(this.validParts, '\0').split('\0'),
				parts = format.match(this.validParts);
			if (!separators || !separators.length || !parts || parts.length === 0){
				throw new Error("Invalid date format.");
			}
			return {separators: separators, parts: parts};
		},
		parseDate: function(date, format, language){
			if (!date)
				return undefined;
			if (date instanceof Date)
				return date;
			if (typeof format === 'string')
				format = DPGlobal.parseFormat(format);
			var part_re = /([\-+]\d+)([dmwy])/,
				parts = date.match(/([\-+]\d+)([dmwy])/g),
				part, dir, i;
			if (/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/.test(date)){
				date = new Date();
				for (i=0; i < parts.length; i++){
					part = part_re.exec(parts[i]);
					dir = parseInt(part[1]);
					switch (part[2]){
						case 'd':
							date.setUTCDate(date.getUTCDate() + dir);
							break;
						case 'm':
							date = Datepicker.prototype.moveMonth.call(Datepicker.prototype, date, dir);
							break;
						case 'w':
							date.setUTCDate(date.getUTCDate() + dir * 7);
							break;
						case 'y':
							date = Datepicker.prototype.moveYear.call(Datepicker.prototype, date, dir);
							break;
					}
				}
				return UTCDate(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0);
			}
			parts = date && date.match(this.nonpunctuation) || [];
			date = new Date();
			var parsed = {},
				setters_order = ['yyyy', 'yy', 'M', 'MM', 'm', 'mm', 'd', 'dd'],
				setters_map = {
					yyyy: function(d,v){
						return d.setUTCFullYear(v);
					},
					yy: function(d,v){
						return d.setUTCFullYear(2000+v);
					},
					m: function(d,v){
						if (isNaN(d))
							return d;
						v -= 1;
						while (v < 0) v += 12;
						v %= 12;
						d.setUTCMonth(v);
						while (d.getUTCMonth() !== v)
							d.setUTCDate(d.getUTCDate()-1);
						return d;
					},
					d: function(d,v){
						return d.setUTCDate(v);
					}
				},
				val, filtered;
			setters_map['M'] = setters_map['MM'] = setters_map['mm'] = setters_map['m'];
			setters_map['dd'] = setters_map['d'];
			date = UTCDate(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
			var fparts = format.parts.slice();
			// Remove noop parts
			if (parts.length !== fparts.length){
				fparts = $(fparts).filter(function(i,p){
					return $.inArray(p, setters_order) !== -1;
				}).toArray();
			}
			// Process remainder
			function match_part(){
				var m = this.slice(0, parts[i].length),
					p = parts[i].slice(0, m.length);
				return m === p;
			}
			if (parts.length === fparts.length){
				var cnt;
				for (i=0, cnt = fparts.length; i < cnt; i++){
					val = parseInt(parts[i], 10);
					part = fparts[i];
					if (isNaN(val)){
						switch (part){
							case 'MM':
								filtered = $(dates[language].months).filter(match_part);
								val = $.inArray(filtered[0], dates[language].months) + 1;
								break;
							case 'M':
								filtered = $(dates[language].monthsShort).filter(match_part);
								val = $.inArray(filtered[0], dates[language].monthsShort) + 1;
								break;
						}
					}
					parsed[part] = val;
				}
				var _date, s;
				for (i=0; i < setters_order.length; i++){
					s = setters_order[i];
					if (s in parsed && !isNaN(parsed[s])){
						_date = new Date(date);
						setters_map[s](_date, parsed[s]);
						if (!isNaN(_date))
							date = _date;
					}
				}
			}
			return date;
		},
		formatDate: function(date, format, language){
			if (!date)
				return '';
			if (typeof format === 'string')
				format = DPGlobal.parseFormat(format);
			var val = {
				d: date.getUTCDate(),
				D: dates[language].daysShort[date.getUTCDay()],
				DD: dates[language].days[date.getUTCDay()],
				m: date.getUTCMonth() + 1,
				M: dates[language].monthsShort[date.getUTCMonth()],
				MM: dates[language].months[date.getUTCMonth()],
				yy: date.getUTCFullYear().toString().substring(2),
				yyyy: date.getUTCFullYear()
			};
			val.dd = (val.d < 10 ? '0' : '') + val.d;
			val.mm = (val.m < 10 ? '0' : '') + val.m;
			date = [];
			var seps = $.extend([], format.separators);
			for (var i=0, cnt = format.parts.length; i <= cnt; i++){
				if (seps.length)
					date.push(seps.shift());
				date.push(val[format.parts[i]]);
			}
			return date.join('');
		},
		headTemplate: '<thead>'+
							'<tr>'+
								'<th class="prev">&#171;</th>'+
								'<th colspan="5" class="datepicker-switch"></th>'+
								'<th class="next">&#187;</th>'+
							'</tr>'+
						'</thead>',
		contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>',
		footTemplate: '<tfoot>'+
							'<tr>'+
								'<th colspan="7" class="today"></th>'+
							'</tr>'+
							'<tr>'+
								'<th colspan="7" class="clear"></th>'+
							'</tr>'+
						'</tfoot>'
	};
	DPGlobal.template = '<div class="datepicker">'+
							'<div class="datepicker-days">'+
								'<table class=" table-condensed">'+
									DPGlobal.headTemplate+
									'<tbody></tbody>'+
									DPGlobal.footTemplate+
								'</table>'+
							'</div>'+
							'<div class="datepicker-months">'+
								'<table class="table-condensed">'+
									DPGlobal.headTemplate+
									DPGlobal.contTemplate+
									DPGlobal.footTemplate+
								'</table>'+
							'</div>'+
							'<div class="datepicker-years">'+
								'<table class="table-condensed">'+
									DPGlobal.headTemplate+
									DPGlobal.contTemplate+
									DPGlobal.footTemplate+
								'</table>'+
							'</div>'+
						'</div>';

	$.fn.datepicker.DPGlobal = DPGlobal;


	/* DATEPICKER NO CONFLICT
	* =================== */

	$.fn.datepicker.noConflict = function(){
		$.fn.datepicker = old;
		return this;
	};


	/* DATEPICKER DATA-API
	* ================== */

	$(document).on(
		'focus.datepicker.data-api click.datepicker.data-api',
		'[data-provide="datepicker"]',
		function(e){
			var $this = $(this);
			if ($this.data('datepicker'))
				return;
			e.preventDefault();
			// component click requires us to explicitly show it
			$this.datepicker('show');
		}
	);
	$(function(){
		$('[data-provide="datepicker-inline"]').datepicker();
	});

}(window.jQuery));

/* -------- studio/v2/js/typeahead.bundle.js -------- */
/*!
 * typeahead.js 0.10.1
 * https://github.com/twitter/typeahead.js
 * Copyright 2013 Twitter, Inc. and other contributors; Licensed MIT
 */

(function($) {
    var _ = {
        isMsie: function() {
            return /(msie|trident)/i.test(navigator.userAgent) ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false;
        },
        isBlankString: function(str) {
            return !str || /^\s*$/.test(str);
        },
        escapeRegExChars: function(str) {
            return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
        },
        isString: function(obj) {
            return typeof obj === "string";
        },
        isNumber: function(obj) {
            return typeof obj === "number";
        },
        isArray: $.isArray,
        isFunction: $.isFunction,
        isObject: $.isPlainObject,
        isUndefined: function(obj) {
            return typeof obj === "undefined";
        },
        bind: $.proxy,
        each: function(collection, cb) {
            $.each(collection, reverseArgs);
            function reverseArgs(index, value) {
                return cb(value, index);
            }
        },
        map: $.map,
        filter: $.grep,
        every: function(obj, test) {
            var result = true;
            if (!obj) {
                return result;
            }
            $.each(obj, function(key, val) {
                if (!(result = test.call(null, val, key, obj))) {
                    return false;
                }
            });
            return !!result;
        },
        some: function(obj, test) {
            var result = false;
            if (!obj) {
                return result;
            }
            $.each(obj, function(key, val) {
                if (result = test.call(null, val, key, obj)) {
                    return false;
                }
            });
            return !!result;
        },
        mixin: $.extend,
        getUniqueId: function() {
            var counter = 0;
            return function() {
                return counter++;
            };
        }(),
        templatify: function templatify(obj) {
            return $.isFunction(obj) ? obj : template;
            function template() {
                return String(obj);
            }
        },
        defer: function(fn) {
            setTimeout(fn, 0);
        },
        debounce: function(func, wait, immediate) {
            var timeout, result;
            return function() {
                var context = this, args = arguments, later, callNow;
                later = function() {
                    timeout = null;
                    if (!immediate) {
                        result = func.apply(context, args);
                    }
                };
                callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) {
                    result = func.apply(context, args);
                }
                return result;
            };
        },
        throttle: function(func, wait) {
            var context, args, timeout, result, previous, later;
            previous = 0;
            later = function() {
                previous = new Date();
                timeout = null;
                result = func.apply(context, args);
            };
            return function() {
                var now = new Date(), remaining = wait - (now - previous);
                context = this;
                args = arguments;
                if (remaining <= 0) {
                    clearTimeout(timeout);
                    timeout = null;
                    previous = now;
                    result = func.apply(context, args);
                } else if (!timeout) {
                    timeout = setTimeout(later, remaining);
                }
                return result;
            };
        },
        noop: function() {}
    };
    var VERSION = "0.10.1";
    var LruCache = function(root, undefined) {
        function LruCache(maxSize) {
            this.maxSize = maxSize || 100;
            this.size = 0;
            this.hash = {};
            this.list = new List();
        }
        _.mixin(LruCache.prototype, {
            set: function set(key, val) {
                var tailItem = this.list.tail, node;
                if (this.size >= this.maxSize) {
                    this.list.remove(tailItem);
                    delete this.hash[tailItem.key];
                }
                if (node = this.hash[key]) {
                    node.val = val;
                    this.list.moveToFront(node);
                } else {
                    node = new Node(key, val);
                    this.list.add(node);
                    this.hash[key] = node;
                    this.size++;
                }
            },
            get: function get(key) {
                var node = this.hash[key];
                if (node) {
                    this.list.moveToFront(node);
                    return node.val;
                }
            }
        });
        function List() {
            this.head = this.tail = null;
        }
        _.mixin(List.prototype, {
            add: function add(node) {
                if (this.head) {
                    node.next = this.head;
                    this.head.prev = node;
                }
                this.head = node;
                this.tail = this.tail || node;
            },
            remove: function remove(node) {
                node.prev ? node.prev.next = node.next : this.head = node.next;
                node.next ? node.next.prev = node.prev : this.tail = node.prev;
            },
            moveToFront: function(node) {
                this.remove(node);
                this.add(node);
            }
        });
        function Node(key, val) {
            this.key = key;
            this.val = val;
            this.prev = this.next = null;
        }
        return LruCache;
    }(this);
    var PersistentStorage = function() {
        var ls, methods;
        try {
            ls = window.localStorage;
            ls.setItem("~~~", "!");
            ls.removeItem("~~~");
        } catch (err) {
            ls = null;
        }
        function PersistentStorage(namespace) {
            this.prefix = [ "__", namespace, "__" ].join("");
            this.ttlKey = "__ttl__";
            this.keyMatcher = new RegExp("^" + this.prefix);
        }
        if (ls && window.JSON) {
            methods = {
                _prefix: function(key) {
                    return this.prefix + key;
                },
                _ttlKey: function(key) {
                    return this._prefix(key) + this.ttlKey;
                },
                get: function(key) {
                    if (this.isExpired(key)) {
                        this.remove(key);
                    }
                    return decode(ls.getItem(this._prefix(key)));
                },
                set: function(key, val, ttl) {
                    if (_.isNumber(ttl)) {
                        ls.setItem(this._ttlKey(key), encode(now() + ttl));
                    } else {
                        ls.removeItem(this._ttlKey(key));
                    }
                    return ls.setItem(this._prefix(key), encode(val));
                },
                remove: function(key) {
                    ls.removeItem(this._ttlKey(key));
                    ls.removeItem(this._prefix(key));
                    return this;
                },
                clear: function() {
                    var i, key, keys = [], len = ls.length;
                    for (i = 0; i < len; i++) {
                        if ((key = ls.key(i)).match(this.keyMatcher)) {
                            keys.push(key.replace(this.keyMatcher, ""));
                        }
                    }
                    for (i = keys.length; i--; ) {
                        this.remove(keys[i]);
                    }
                    return this;
                },
                isExpired: function(key) {
                    var ttl = decode(ls.getItem(this._ttlKey(key)));
                    return _.isNumber(ttl) && now() > ttl ? true : false;
                }
            };
        } else {
            methods = {
                get: _.noop,
                set: _.noop,
                remove: _.noop,
                clear: _.noop,
                isExpired: _.noop
            };
        }
        _.mixin(PersistentStorage.prototype, methods);
        return PersistentStorage;
        function now() {
            return new Date().getTime();
        }
        function encode(val) {
            return JSON.stringify(_.isUndefined(val) ? null : val);
        }
        function decode(val) {
            return JSON.parse(val);
        }
    }();
    var Transport = function() {
        var pendingRequestsCount = 0, pendingRequests = {}, maxPendingRequests = 6, requestCache = new LruCache(10);
        function Transport(o) {
            o = o || {};
            this._send = o.transport ? callbackToDeferred(o.transport) : $.ajax;
            this._get = o.rateLimiter ? o.rateLimiter(this._get) : this._get;
        }
        Transport.setMaxPendingRequests = function setMaxPendingRequests(num) {
            maxPendingRequests = num;
        };
        Transport.resetCache = function clearCache() {
            requestCache = new LruCache(10);
        };
        _.mixin(Transport.prototype, {
            _get: function(url, o, cb) {
                var that = this, jqXhr;
                if (jqXhr = pendingRequests[url]) {
                    jqXhr.done(done);
                } else if (pendingRequestsCount < maxPendingRequests) {
                    pendingRequestsCount++;
                    pendingRequests[url] = this._send(url, o).done(done).always(always);
                } else {
                    this.onDeckRequestArgs = [].slice.call(arguments, 0);
                }
                function done(resp) {
                    cb && cb(resp);
                    requestCache.set(url, resp);
                }
                function always() {
                    pendingRequestsCount--;
                    delete pendingRequests[url];
                    if (that.onDeckRequestArgs) {
                        that._get.apply(that, that.onDeckRequestArgs);
                        that.onDeckRequestArgs = null;
                    }
                }
            },
            get: function(url, o, cb) {
                var that = this, resp;
                if (_.isFunction(o)) {
                    cb = o;
                    o = {};
                }
                if (resp = requestCache.get(url)) {
                    _.defer(function() {
                        cb && cb(resp);
                    });
                } else {
                    this._get(url, o, cb);
                }
                return !!resp;
            }
        });
        return Transport;
        function callbackToDeferred(fn) {
            return function customSendWrapper(url, o) {
                var deferred = $.Deferred();
                fn(url, o, onSuccess, onError);
                return deferred;
                function onSuccess(resp) {
                    _.defer(function() {
                        deferred.resolve(resp);
                    });
                }
                function onError(err) {
                    _.defer(function() {
                        deferred.reject(err);
                    });
                }
            };
        }
    }();
    var SearchIndex = function() {
        function SearchIndex(o) {
            o = o || {};
            if (!o.datumTokenizer || !o.queryTokenizer) {
                $.error("datumTokenizer and queryTokenizer are both required");
            }
            this.datumTokenizer = o.datumTokenizer;
            this.queryTokenizer = o.queryTokenizer;
            this.datums = [];
            this.trie = newNode();
        }
        _.mixin(SearchIndex.prototype, {
            bootstrap: function bootstrap(o) {
                this.datums = o.datums;
                this.trie = o.trie;
            },
            add: function(data) {
                var that = this;
                data = _.isArray(data) ? data : [ data ];
                _.each(data, function(datum) {
                    var id, tokens;
                    id = that.datums.push(datum) - 1;
                    tokens = normalizeTokens(that.datumTokenizer(datum));
                    _.each(tokens, function(token) {
                        var node, chars, ch, ids;
                        node = that.trie;
                        chars = token.split("");
                        while (ch = chars.shift()) {
                            node = node.children[ch] || (node.children[ch] = newNode());
                            node.ids.push(id);
                        }
                    });
                });
            },
            get: function get(query) {
                var that = this, tokens, matches;
                tokens = normalizeTokens(this.queryTokenizer(query));
                _.each(tokens, function(token) {
                    var node, chars, ch, ids;
                    if (matches && matches.length === 0) {
                        return false;
                    }
                    node = that.trie;
                    chars = token.split("");
                    while (node && (ch = chars.shift())) {
                        node = node.children[ch];
                    }
                    if (node && chars.length === 0) {
                        ids = node.ids.slice(0);
                        matches = matches ? getIntersection(matches, ids) : ids;
                    } else {
                        matches = [];
                        return false;
                    }
                });
                return matches ? _.map(unique(matches), function(id) {
                    return that.datums[id];
                }) : [];
            },
            serialize: function serialize() {
                return {
                    datums: this.datums,
                    trie: this.trie
                };
            }
        });
        return SearchIndex;
        function normalizeTokens(tokens) {
            tokens = _.filter(tokens, function(token) {
                return !!token;
            });
            tokens = _.map(tokens, function(token) {
                return token.toLowerCase();
            });
            return tokens;
        }
        function newNode() {
            return {
                ids: [],
                children: {}
            };
        }
        function unique(array) {
            var seen = {}, uniques = [];
            for (var i = 0; i < array.length; i++) {
                if (!seen[array[i]]) {
                    seen[array[i]] = true;
                    uniques.push(array[i]);
                }
            }
            return uniques;
        }
        function getIntersection(arrayA, arrayB) {
            var ai = 0, bi = 0, intersection = [];
            arrayA = arrayA.sort(compare);
            arrayB = arrayB.sort(compare);
            while (ai < arrayA.length && bi < arrayB.length) {
                if (arrayA[ai] < arrayB[bi]) {
                    ai++;
                } else if (arrayA[ai] > arrayB[bi]) {
                    bi++;
                } else {
                    intersection.push(arrayA[ai]);
                    ai++;
                    bi++;
                }
            }
            return intersection;
            function compare(a, b) {
                return a - b;
            }
        }
    }();
    var oParser = function() {
        return {
            local: getLocal,
            prefetch: getPrefetch,
            remote: getRemote
        };
        function getLocal(o) {
            var local = o.local || null;
            if (_.isFunction(local)) {
                local = local.call(null);
            }
            return local;
        }
        function getPrefetch(o) {
            var prefetch, defaults;
            defaults = {
                url: null,
                thumbprint: "",
                ttl: 24 * 60 * 60 * 1e3,
                filter: null,
                ajax: {}
            };
            if (prefetch = o.prefetch || null) {
                prefetch = _.isString(prefetch) ? {
                    url: prefetch
                } : prefetch;
                prefetch = _.mixin(defaults, prefetch);
                prefetch.thumbprint = VERSION + prefetch.thumbprint;
                prefetch.ajax.type = prefetch.ajax.type || "GET";
                prefetch.ajax.dataType = prefetch.ajax.dataType || "json";
                !prefetch.url && $.error("prefetch requires url to be set");
            }
            return prefetch;
        }
        function getRemote(o) {
            var remote, defaults;
            defaults = {
                url: null,
                wildcard: "%QUERY",
                replace: null,
                rateLimitBy: "debounce",
                rateLimitWait: 300,
                send: null,
                filter: null,
                ajax: {}
            };
            if (remote = o.remote || null) {
                remote = _.isString(remote) ? {
                    url: remote
                } : remote;
                remote = _.mixin(defaults, remote);
                remote.rateLimiter = /^throttle$/i.test(remote.rateLimitBy) ? byThrottle(remote.rateLimitWait) : byDebounce(remote.rateLimitWait);
                remote.ajax.type = remote.ajax.type || "GET";
                remote.ajax.dataType = remote.ajax.dataType || "json";
                delete remote.rateLimitBy;
                delete remote.rateLimitWait;
                !remote.url && $.error("remote requires url to be set");
            }
            return remote;
            function byDebounce(wait) {
                return function(fn) {
                    return _.debounce(fn, wait);
                };
            }
            function byThrottle(wait) {
                return function(fn) {
                    return _.throttle(fn, wait);
                };
            }
        }
    }();
    var Bloodhound = window.Bloodhound = function() {
        var keys;
        keys = {
            data: "data",
            protocol: "protocol",
            thumbprint: "thumbprint"
        };
        function Bloodhound(o) {
            if (!o || !o.local && !o.prefetch && !o.remote) {
                $.error("one of local, prefetch, or remote is required");
            }
            this.limit = o.limit || 5;
            this.sorter = getSorter(o.sorter);
            this.dupDetector = o.dupDetector || ignoreDuplicates;
            this.local = oParser.local(o);
            this.prefetch = oParser.prefetch(o);
            this.remote = oParser.remote(o);
            this.cacheKey = this.prefetch ? this.prefetch.cacheKey || this.prefetch.url : null;
            this.index = new SearchIndex({
                datumTokenizer: o.datumTokenizer,
                queryTokenizer: o.queryTokenizer
            });
            this.storage = this.cacheKey ? new PersistentStorage(this.cacheKey) : null;
        }
        Bloodhound.tokenizers = {
            whitespace: function whitespaceTokenizer(s) {
                return s.split(/\s+/);
            },
            nonword: function nonwordTokenizer(s) {
                return s.split(/\W+/);
            }
        };
        _.mixin(Bloodhound.prototype, {
            _loadPrefetch: function loadPrefetch(o) {
                var that = this, serialized, deferred;
                if (serialized = this._readFromStorage(o.thumbprint)) {
                    this.index.bootstrap(serialized);
                    deferred = $.Deferred().resolve();
                } else {
                    deferred = $.ajax(o.url, o.ajax).done(handlePrefetchResponse);
                }
                return deferred;
                function handlePrefetchResponse(resp) {
                    var filtered;
                    filtered = o.filter ? o.filter(resp) : resp;
                    that.add(filtered);
                    that._saveToStorage(that.index.serialize(), o.thumbprint, o.ttl);
                }
            },
            _getFromRemote: function getFromRemote(query, cb) {
                var that = this, url, uriEncodedQuery;
                query = query || "";
                uriEncodedQuery = encodeURIComponent(query);
                url = this.remote.replace ? this.remote.replace(this.remote.url, query) : this.remote.url.replace(this.remote.wildcard, uriEncodedQuery);
                return this.transport.get(url, this.remote.ajax, handleRemoteResponse);
                function handleRemoteResponse(resp) {
                    var filtered = that.remote.filter ? that.remote.filter(resp) : resp;
                    cb(filtered);
                }
            },
            _saveToStorage: function saveToStorage(data, thumbprint, ttl) {
                if (this.storage) {
                    this.storage.set(keys.data, data, ttl);
                    this.storage.set(keys.protocol, location.protocol, ttl);
                    this.storage.set(keys.thumbprint, thumbprint, ttl);
                }
            },
            _readFromStorage: function readFromStorage(thumbprint) {
                var stored = {}, isExpired;
                if (this.storage) {
                    stored.data = this.storage.get(keys.data);
                    stored.protocol = this.storage.get(keys.protocol);
                    stored.thumbprint = this.storage.get(keys.thumbprint);
                }
                isExpired = stored.thumbprint !== thumbprint || stored.protocol !== location.protocol;
                return stored.data && !isExpired ? stored.data : null;
            },
            initialize: function initialize() {
                var that = this, deferred;
                deferred = this.prefetch ? this._loadPrefetch(this.prefetch) : $.Deferred().resolve();
                this.local && deferred.done(addLocalToIndex);
                this.transport = this.remote ? new Transport(this.remote) : null;
                this.initialize = function initialize() {
                    return deferred.promise();
                };
                return deferred.promise();
                function addLocalToIndex() {
                    that.add(that.local);
                }
            },
            add: function add(data) {
                this.index.add(data);
            },
            get: function get(query, cb) {
                var that = this, matches, cacheHit = false;
                matches = this.index.get(query);
                matches = this.sorter(matches).slice(0, this.limit);
                if (matches.length < this.limit && this.transport) {
                    cacheHit = this._getFromRemote(query, returnRemoteMatches);
                }
                !cacheHit && cb && cb(matches);
                function returnRemoteMatches(remoteMatches) {
                    var matchesWithBackfill = matches.slice(0);
                    _.each(remoteMatches, function(remoteMatch) {
                        var isDuplicate;
                        isDuplicate = _.some(matchesWithBackfill, function(match) {
                            return that.dupDetector(remoteMatch, match);
                        });
                        !isDuplicate && matchesWithBackfill.push(remoteMatch);
                        return matchesWithBackfill.length < that.limit;
                    });
                    cb && cb(that.sorter(matchesWithBackfill));
                }
            },
            ttAdapter: function ttAdapter() {
                return _.bind(this.get, this);
            }
        });
        return Bloodhound;
        function getSorter(sortFn) {
            return _.isFunction(sortFn) ? sort : noSort;
            function sort(array) {
                return array.sort(sortFn);
            }
            function noSort(array) {
                return array;
            }
        }
        function ignoreDuplicates() {
            return false;
        }
    }();
    var html = {
        wrapper: '<span class="twitter-typeahead"></span>',
        dropdown: '<span class="tt-dropdown-menu"></span>',
        dataset: '<div class="tt-dataset-%CLASS%"></div>',
        suggestions: '<span class="tt-suggestions"></span>',
        suggestion: '<div class="tt-suggestion">%BODY%</div>'
    };
    var css = {
        wrapper: {
            position: "relative",
            display: "inline-block"
        },
        hint: {
            position: "absolute",
            top: "0",
            left: "0",
            borderColor: "transparent",
            boxShadow: "none"
        },
        input: {
            position: "relative",
            verticalAlign: "top",
            backgroundColor: "transparent"
        },
        inputWithNoHint: {
            position: "relative",
            verticalAlign: "top"
        },
        dropdown: {
            position: "absolute",
            top: "100%",
            left: "0",
            zIndex: "100",
            display: "none"
        },
        suggestions: {
            display: "block"
        },
        suggestion: {
            whiteSpace: "nowrap",
            cursor: "pointer"
        },
        suggestionChild: {
            whiteSpace: "normal"
        },
        ltr: {
            left: "0",
            right: "auto"
        },
        rtl: {
            left: "auto",
            right: " 0"
        }
    };
    if (_.isMsie()) {
        _.mixin(css.input, {
            backgroundImage: "url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)"
        });
    }
    if (_.isMsie() && _.isMsie() <= 7) {
        _.mixin(css.input, {
            marginTop: "-1px"
        });
    }
    var EventBus = function() {
        var namespace = "typeahead:";
        function EventBus(o) {
            if (!o || !o.el) {
                $.error("EventBus initialized without el");
            }
            this.$el = $(o.el);
        }
        _.mixin(EventBus.prototype, {
            trigger: function(type) {
                var args = [].slice.call(arguments, 1);
                this.$el.trigger(namespace + type, args);
            }
        });
        return EventBus;
    }();
    var EventEmitter = function() {
        var splitter = /\s+/, nextTick = getNextTick();
        return {
            onSync: onSync,
            onAsync: onAsync,
            off: off,
            trigger: trigger
        };
        function on(method, types, cb, context) {
            var type;
            if (!cb) {
                return this;
            }
            types = types.split(splitter);
            cb = context ? bindContext(cb, context) : cb;
            this._callbacks = this._callbacks || {};
            while (type = types.shift()) {
                this._callbacks[type] = this._callbacks[type] || {
                    sync: [],
                    async: []
                };
                this._callbacks[type][method].push(cb);
            }
            return this;
        }
        function onAsync(types, cb, context) {
            return on.call(this, "async", types, cb, context);
        }
        function onSync(types, cb, context) {
            return on.call(this, "sync", types, cb, context);
        }
        function off(types) {
            var type;
            if (!this._callbacks) {
                return this;
            }
            types = types.split(splitter);
            while (type = types.shift()) {
                delete this._callbacks[type];
            }
            return this;
        }
        function trigger(types) {
            var that = this, type, callbacks, args, syncFlush, asyncFlush;
            if (!this._callbacks) {
                return this;
            }
            types = types.split(splitter);
            args = [].slice.call(arguments, 1);
            while ((type = types.shift()) && (callbacks = this._callbacks[type])) {
                syncFlush = getFlush(callbacks.sync, this, [ type ].concat(args));
                asyncFlush = getFlush(callbacks.async, this, [ type ].concat(args));
                syncFlush() && nextTick(asyncFlush);
            }
            return this;
        }
        function getFlush(callbacks, context, args) {
            return flush;
            function flush() {
                var cancelled;
                for (var i = 0; !cancelled && i < callbacks.length; i += 1) {
                    cancelled = callbacks[i].apply(context, args) === false;
                }
                return !cancelled;
            }
        }
        function getNextTick() {
            var nextTickFn, messageChannel;
            if (window.setImmediate) {
                nextTickFn = function nextTickSetImmediate(fn) {
                    setImmediate(function() {
                        fn();
                    });
                };
            } else {
                nextTickFn = function nextTickSetTimeout(fn) {
                    setTimeout(function() {
                        fn();
                    }, 0);
                };
            }
            return nextTickFn;
        }
        function bindContext(fn, context) {
            return fn.bind ? fn.bind(context) : function() {
                fn.apply(context, [].slice.call(arguments, 0));
            };
        }
    }();
    var highlight = function(doc) {
        var defaults = {
            node: null,
            pattern: null,
            tagName: "strong",
            className: null,
            wordsOnly: false,
            caseSensitive: false
        };
        return function hightlight(o) {
            var regex;
            o = _.mixin({}, defaults, o);
            if (!o.node || !o.pattern) {
                return;
            }
            o.pattern = _.isArray(o.pattern) ? o.pattern : [ o.pattern ];
            regex = getRegex(o.pattern, o.caseSensitive, o.wordsOnly);
            traverse(o.node, hightlightTextNode);
            function hightlightTextNode(textNode) {
                var match, patternNode;
                if (match = regex.exec(textNode.data)) {
                    wrapperNode = doc.createElement(o.tagName);
                    o.className && (wrapperNode.className = o.className);
                    patternNode = textNode.splitText(match.index);
                    patternNode.splitText(match[0].length);
                    wrapperNode.appendChild(patternNode.cloneNode(true));
                    textNode.parentNode.replaceChild(wrapperNode, patternNode);
                }
                return !!match;
            }
            function traverse(el, hightlightTextNode) {
                var childNode, TEXT_NODE_TYPE = 3;
                for (var i = 0; i < el.childNodes.length; i++) {
                    childNode = el.childNodes[i];
                    if (childNode.nodeType === TEXT_NODE_TYPE) {
                        i += hightlightTextNode(childNode) ? 1 : 0;
                    } else {
                        traverse(childNode, hightlightTextNode);
                    }
                }
            }
        };
        function getRegex(patterns, caseSensitive, wordsOnly) {
            var escapedPatterns = [], regexStr;
            for (var i = 0; i < patterns.length; i++) {
                escapedPatterns.push(_.escapeRegExChars(patterns[i]));
            }
            regexStr = wordsOnly ? "\\b(" + escapedPatterns.join("|") + ")\\b" : "(" + escapedPatterns.join("|") + ")";
            return caseSensitive ? new RegExp(regexStr) : new RegExp(regexStr, "i");
        }
    }(window.document);
    var Input = function() {
        var specialKeyCodeMap;
        specialKeyCodeMap = {
            9: "tab",
            27: "esc",
            37: "left",
            39: "right",
            13: "enter",
            38: "up",
            40: "down"
        };
        function Input(o) {
            var that = this, onBlur, onFocus, onKeydown, onInput;
            o = o || {};
            if (!o.input) {
                $.error("input is missing");
            }
            onBlur = _.bind(this._onBlur, this);
            onFocus = _.bind(this._onFocus, this);
            onKeydown = _.bind(this._onKeydown, this);
            onInput = _.bind(this._onInput, this);
            this.$hint = $(o.hint);
            this.$input = $(o.input).on("blur.tt", onBlur).on("focus.tt", onFocus).on("keydown.tt", onKeydown);
            if (this.$hint.length === 0) {
                this.setHintValue = this.getHintValue = this.clearHint = _.noop;
            }
            if (!_.isMsie()) {
                this.$input.on("input.tt", onInput);
            } else {
                this.$input.on("keydown.tt keypress.tt cut.tt paste.tt", function($e) {
                    if (specialKeyCodeMap[$e.which || $e.keyCode]) {
                        return;
                    }
                    _.defer(_.bind(that._onInput, that, $e));
                });
            }
            this.query = this.$input.val();
            this.$overflowHelper = buildOverflowHelper(this.$input);
        }
        Input.normalizeQuery = function(str) {
            return (str || "").replace(/^\s*/g, "").replace(/\s{2,}/g, " ");
        };
        _.mixin(Input.prototype, EventEmitter, {
            _onBlur: function onBlur($e) {
                this.resetInputValue();
                this.trigger("blurred");
            },
            _onFocus: function onFocus($e) {
                this.trigger("focused");
            },
            _onKeydown: function onKeydown($e) {
                var keyName = specialKeyCodeMap[$e.which || $e.keyCode];
                this._managePreventDefault(keyName, $e);
                if (keyName && this._shouldTrigger(keyName, $e)) {
                    this.trigger(keyName + "Keyed", $e);
                }
            },
            _onInput: function onInput($e) {
                this._checkInputValue();
            },
            _managePreventDefault: function managePreventDefault(keyName, $e) {
                var preventDefault, hintValue, inputValue;
                switch (keyName) {
                  case "tab":
                    hintValue = this.getHintValue();
                    inputValue = this.getInputValue();
                    preventDefault = hintValue && hintValue !== inputValue && !withModifier($e);
                    break;

                  case "up":
                  case "down":
                    preventDefault = !withModifier($e);
                    break;

                  default:
                    preventDefault = false;
                }
                preventDefault && $e.preventDefault();
            },
            _shouldTrigger: function shouldTrigger(keyName, $e) {
                var trigger;
                switch (keyName) {
                  case "tab":
                    trigger = !withModifier($e);
                    break;

                  default:
                    trigger = true;
                }
                return trigger;
            },
            _checkInputValue: function checkInputValue() {
                var inputValue, areEquivalent, hasDifferentWhitespace;
                inputValue = this.getInputValue();
                areEquivalent = areQueriesEquivalent(inputValue, this.query);
                hasDifferentWhitespace = areEquivalent ? this.query.length !== inputValue.length : false;
                if (!areEquivalent) {
                    this.trigger("queryChanged", this.query = inputValue);
                } else if (hasDifferentWhitespace) {
                    this.trigger("whitespaceChanged", this.query);
                }
            },
            focus: function focus() {
                this.$input.focus();
            },
            blur: function blur() {
                this.$input.blur();
            },
            getQuery: function getQuery() {
                return this.query;
            },
            setQuery: function setQuery(query) {
                this.query = query;
            },
            getInputValue: function getInputValue() {
                return this.$input.val();
            },
            setInputValue: function setInputValue(value, silent) {
                this.$input.val(value);
                !silent && this._checkInputValue();
            },
            getHintValue: function getHintValue() {
                return this.$hint.val();
            },
            setHintValue: function setHintValue(value) {
                this.$hint.val(value);
            },
            resetInputValue: function resetInputValue() {
                this.$input.val(this.query);
            },
            clearHint: function clearHint() {
                this.$hint.val("");
            },
            getLanguageDirection: function getLanguageDirection() {
                return (this.$input.css("direction") || "ltr").toLowerCase();
            },
            hasOverflow: function hasOverflow() {
                var constraint = this.$input.width() - 2;
                this.$overflowHelper.text(this.getInputValue());
                return this.$overflowHelper.width() >= constraint;
            },
            isCursorAtEnd: function() {
                var valueLength, selectionStart, range;
                valueLength = this.$input.val().length;
                selectionStart = this.$input[0].selectionStart;
                if (_.isNumber(selectionStart)) {
                    return selectionStart === valueLength;
                } else if (document.selection) {
                    range = document.selection.createRange();
                    range.moveStart("character", -valueLength);
                    return valueLength === range.text.length;
                }
                return true;
            },
            destroy: function destroy() {
                this.$hint.off(".tt");
                this.$input.off(".tt");
                this.$hint = this.$input = this.$overflowHelper = null;
            }
        });
        return Input;
        function buildOverflowHelper($input) {
            return $('<pre aria-hidden="true"></pre>').css({
                position: "absolute",
                visibility: "hidden",
                whiteSpace: "nowrap",
                fontFamily: $input.css("font-family"),
                fontSize: $input.css("font-size"),
                fontStyle: $input.css("font-style"),
                fontVariant: $input.css("font-variant"),
                fontWeight: $input.css("font-weight"),
                wordSpacing: $input.css("word-spacing"),
                letterSpacing: $input.css("letter-spacing"),
                textIndent: $input.css("text-indent"),
                textRendering: $input.css("text-rendering"),
                textTransform: $input.css("text-transform")
            }).insertAfter($input);
        }
        function areQueriesEquivalent(a, b) {
            return Input.normalizeQuery(a) === Input.normalizeQuery(b);
        }
        function withModifier($e) {
            return $e.altKey || $e.ctrlKey || $e.metaKey || $e.shiftKey;
        }
    }();
    var Dataset = function() {
        var datasetKey = "ttDataset", valueKey = "ttValue", datumKey = "ttDatum";
        function Dataset(o) {
            o = o || {};
            o.templates = o.templates || {};
            if (!o.source) {
                $.error("missing source");
            }
            if (o.name && !isValidName(o.name)) {
                $.error("invalid dataset name: " + o.name);
            }
            this.query = null;
            this.highlight = !!o.highlight;
            this.name = o.name || _.getUniqueId();
            this.source = o.source;
            this.displayFn = getDisplayFn(o.display || o.displayKey);
            this.templates = getTemplates(o.templates, this.displayFn);
            this.$el = $(html.dataset.replace("%CLASS%", this.name));
        }
        Dataset.extractDatasetName = function extractDatasetName(el) {
            return $(el).data(datasetKey);
        };
        Dataset.extractValue = function extractDatum(el) {
            return $(el).data(valueKey);
        };
        Dataset.extractDatum = function extractDatum(el) {
            return $(el).data(datumKey);
        };
        _.mixin(Dataset.prototype, EventEmitter, {
            _render: function render(query, suggestions) {
                if (!this.$el) {
                    return;
                }
                var that = this, hasSuggestions;
                this.$el.empty();
                hasSuggestions = suggestions && suggestions.length;
                if (!hasSuggestions && this.templates.empty) {
                    this.$el.html(getEmptyHtml()).prepend(that.templates.header ? getHeaderHtml() : null).append(that.templates.footer ? getFooterHtml() : null);
                } else if (hasSuggestions) {
                    this.$el.html(getSuggestionsHtml()).prepend(that.templates.header ? getHeaderHtml() : null).append(that.templates.footer ? getFooterHtml() : null);
                }
                this.trigger("rendered");
                function getEmptyHtml() {
                    return that.templates.empty({
                        query: query,
                        isEmpty: true
                    });
                }
                function getSuggestionsHtml() {
                    var $suggestions, nodes;
                    $suggestions = $(html.suggestions).css(css.suggestions);
                    nodes = _.map(suggestions, getSuggestionNode);
                    $suggestions.append.apply($suggestions, nodes);
                    that.highlight && highlight({
                        node: $suggestions[0],
                        pattern: query
                    });
                    return $suggestions;
                    function getSuggestionNode(suggestion) {
                        var $el, innerHtml, outerHtml;
                        innerHtml = that.templates.suggestion(suggestion);
                        outerHtml = html.suggestion.replace("%BODY%", innerHtml);
                        $el = $(outerHtml).data(datasetKey, that.name).data(valueKey, that.displayFn(suggestion)).data(datumKey, suggestion);
                        $el.children().each(function() {
                            $(this).css(css.suggestionChild);
                        });
                        return $el;
                    }
                }
                function getHeaderHtml() {
                    return that.templates.header({
                        query: query,
                        isEmpty: !hasSuggestions
                    });
                }
                function getFooterHtml() {
                    return that.templates.footer({
                        query: query,
                        isEmpty: !hasSuggestions
                    });
                }
            },
            getRoot: function getRoot() {
                return this.$el;
            },
            update: function update(query) {
                var that = this;
                this.query = query;
                this.source(query, renderIfQueryIsSame);
                function renderIfQueryIsSame(suggestions) {
                    query === that.query && that._render(query, suggestions);
                }
            },
            clear: function clear() {
                this._render(this.query || "");
            },
            isEmpty: function isEmpty() {
                return this.$el.is(":empty");
            },
            destroy: function destroy() {
                this.$el = null;
            }
        });
        return Dataset;
        function getDisplayFn(display) {
            display = display || "value";
            return _.isFunction(display) ? display : displayFn;
            function displayFn(obj) {
                return obj[display];
            }
        }
        function getTemplates(templates, displayFn) {
            return {
                empty: templates.empty && _.templatify(templates.empty),
                header: templates.header && _.templatify(templates.header),
                footer: templates.footer && _.templatify(templates.footer),
                suggestion: templates.suggestion || suggestionTemplate
            };
            function suggestionTemplate(context) {
                return "<p>" + displayFn(context) + "</p>";
            }
        }
        function isValidName(str) {
            return /^[_a-zA-Z0-9-]+$/.test(str);
        }
    }();
    var Dropdown = function() {
        function Dropdown(o) {
            var that = this, onSuggestionClick, onSuggestionMouseEnter, onSuggestionMouseLeave;
            o = o || {};
            if (!o.menu) {
                $.error("menu is required");
            }
            this.isOpen = false;
            this.isEmpty = true;
            this.datasets = _.map(o.datasets, initializeDataset);
            onSuggestionClick = _.bind(this._onSuggestionClick, this);
            onSuggestionMouseEnter = _.bind(this._onSuggestionMouseEnter, this);
            onSuggestionMouseLeave = _.bind(this._onSuggestionMouseLeave, this);
            this.$menu = $(o.menu).on("click.tt", ".tt-suggestion", onSuggestionClick).on("mouseenter.tt", ".tt-suggestion", onSuggestionMouseEnter).on("mouseleave.tt", ".tt-suggestion", onSuggestionMouseLeave);
            _.each(this.datasets, function(dataset) {
                that.$menu.append(dataset.getRoot());
                dataset.onSync("rendered", that._onRendered, that);
            });
        }
        _.mixin(Dropdown.prototype, EventEmitter, {
            _onSuggestionClick: function onSuggestionClick($e) {
                this.trigger("suggestionClicked", $($e.currentTarget));
            },
            _onSuggestionMouseEnter: function onSuggestionMouseEnter($e) {
                this._removeCursor();
                this._setCursor($($e.currentTarget), true);
            },
            _onSuggestionMouseLeave: function onSuggestionMouseLeave($e) {
                this._removeCursor();
            },
            _onRendered: function onRendered() {
                this.isEmpty = _.every(this.datasets, isDatasetEmpty);
                this.isEmpty ? this._hide() : this.isOpen && this._show();
                this.trigger("datasetRendered");
                function isDatasetEmpty(dataset) {
                    return dataset.isEmpty();
                }
            },
            _hide: function() {
                this.$menu.hide();
            },
            _show: function() {
                this.$menu.css("display", "block");
            },
            _getSuggestions: function getSuggestions() {
                return this.$menu.find(".tt-suggestion");
            },
            _getCursor: function getCursor() {
                return this.$menu.find(".tt-cursor").first();
            },
            _setCursor: function setCursor($el, silent) {
                $el.first().addClass("tt-cursor");
                !silent && this.trigger("cursorMoved");
            },
            _removeCursor: function removeCursor() {
                this._getCursor().removeClass("tt-cursor");
            },
            _moveCursor: function moveCursor(increment) {
                var $suggestions, $oldCursor, newCursorIndex, $newCursor;
                if (!this.isOpen) {
                    return;
                }
                $oldCursor = this._getCursor();
                $suggestions = this._getSuggestions();
                this._removeCursor();
                newCursorIndex = $suggestions.index($oldCursor) + increment;
                newCursorIndex = (newCursorIndex + 1) % ($suggestions.length + 1) - 1;
                if (newCursorIndex === -1) {
                    this.trigger("cursorRemoved");
                    return;
                } else if (newCursorIndex < -1) {
                    newCursorIndex = $suggestions.length - 1;
                }
                this._setCursor($newCursor = $suggestions.eq(newCursorIndex));
                this._ensureVisible($newCursor);
            },
            _ensureVisible: function ensureVisible($el) {
                var elTop, elBottom, menuScrollTop, menuHeight;
                elTop = $el.position().top;
                elBottom = elTop + $el.outerHeight(true);
                menuScrollTop = this.$menu.scrollTop();
                menuHeight = this.$menu.height() + parseInt(this.$menu.css("paddingTop"), 10) + parseInt(this.$menu.css("paddingBottom"), 10);
                if (elTop < 0) {
                    this.$menu.scrollTop(menuScrollTop + elTop);
                } else if (menuHeight < elBottom) {
                    this.$menu.scrollTop(menuScrollTop + (elBottom - menuHeight));
                }
            },
            close: function close() {
                if (this.isOpen) {
                    this.isOpen = false;
                    this._removeCursor();
                    this._hide();
                    this.trigger("closed");
                }
            },
            open: function open() {
                if (!this.isOpen) {
                    this.isOpen = true;
                    !this.isEmpty && this._show();
                    this.trigger("opened");
                }
            },
            setLanguageDirection: function setLanguageDirection(dir) {
                this.$menu.css(dir === "ltr" ? css.ltr : css.rtl);
            },
            moveCursorUp: function moveCursorUp() {
                this._moveCursor(-1);
            },
            moveCursorDown: function moveCursorDown() {
                this._moveCursor(+1);
            },
            getDatumForSuggestion: function getDatumForSuggestion($el) {
                var datum = null;
                if ($el.length) {
                    datum = {
                        raw: Dataset.extractDatum($el),
                        value: Dataset.extractValue($el),
                        datasetName: Dataset.extractDatasetName($el)
                    };
                }
                return datum;
            },
            getDatumForCursor: function getDatumForCursor() {
                return this.getDatumForSuggestion(this._getCursor().first());
            },
            getDatumForTopSuggestion: function getDatumForTopSuggestion() {
                return this.getDatumForSuggestion(this._getSuggestions().first());
            },
            update: function update(query) {
                _.each(this.datasets, updateDataset);
                function updateDataset(dataset) {
                    dataset.update(query);
                }
            },
            empty: function empty() {
                _.each(this.datasets, clearDataset);
                this.isEmpty = true;
                function clearDataset(dataset) {
                    dataset.clear();
                }
            },
            isVisible: function isVisible() {
                return this.isOpen && !this.isEmpty;
            },
            destroy: function destroy() {
                this.$menu.off(".tt");
                this.$menu = null;
                _.each(this.datasets, destroyDataset);
                function destroyDataset(dataset) {
                    dataset.destroy();
                }
            }
        });
        return Dropdown;
        function initializeDataset(oDataset) {
            return new Dataset(oDataset);
        }
    }();
    var Typeahead = function() {
        var attrsKey = "ttAttrs";
        function Typeahead(o) {
            var $menu, $input, $hint, datasets;
            o = o || {};
            if (!o.input) {
                $.error("missing input");
            }
            this.autoselect = !!o.autoselect;
            this.minLength = _.isNumber(o.minLength) ? o.minLength : 1;
            this.$node = buildDomStructure(o.input, o.withHint);
            $menu = this.$node.find(".tt-dropdown-menu");
            $input = this.$node.find(".tt-input");
            $hint = this.$node.find(".tt-hint");
            this.eventBus = o.eventBus || new EventBus({
                el: $input
            });
            this.dropdown = new Dropdown({
                menu: $menu,
                datasets: o.datasets
            }).onSync("suggestionClicked", this._onSuggestionClicked, this).onSync("cursorMoved", this._onCursorMoved, this).onSync("cursorRemoved", this._onCursorRemoved, this).onSync("opened", this._onOpened, this).onSync("closed", this._onClosed, this).onAsync("datasetRendered", this._onDatasetRendered, this);
            this.input = new Input({
                input: $input,
                hint: $hint
            }).onSync("focused", this._onFocused, this).onSync("blurred", this._onBlurred, this).onSync("enterKeyed", this._onEnterKeyed, this).onSync("tabKeyed", this._onTabKeyed, this).onSync("escKeyed", this._onEscKeyed, this).onSync("upKeyed", this._onUpKeyed, this).onSync("downKeyed", this._onDownKeyed, this).onSync("leftKeyed", this._onLeftKeyed, this).onSync("rightKeyed", this._onRightKeyed, this).onSync("queryChanged", this._onQueryChanged, this).onSync("whitespaceChanged", this._onWhitespaceChanged, this);
            $menu.on("mousedown.tt", function($e) {
                if (_.isMsie() && _.isMsie() < 9) {
                    $input[0].onbeforedeactivate = function() {
                        window.event.returnValue = false;
                        $input[0].onbeforedeactivate = null;
                    };
                }
                $e.preventDefault();
            });
        }
        _.mixin(Typeahead.prototype, {
            _onSuggestionClicked: function onSuggestionClicked(type, $el) {
                var datum;
                if (datum = this.dropdown.getDatumForSuggestion($el)) {
                    this._select(datum);
                }
            },
            _onCursorMoved: function onCursorMoved() {
                var datum = this.dropdown.getDatumForCursor();
                this.input.clearHint();
                this.input.setInputValue(datum.value, true);
                this.eventBus.trigger("cursorchanged", datum.raw, datum.datasetName);
            },
            _onCursorRemoved: function onCursorRemoved() {
                this.input.resetInputValue();
                this._updateHint();
            },
            _onDatasetRendered: function onDatasetRendered() {
                this._updateHint();
            },
            _onOpened: function onOpened() {
                this._updateHint();
                this.eventBus.trigger("opened");
            },
            _onClosed: function onClosed() {
                this.input.clearHint();
                this.eventBus.trigger("closed");
            },
            _onFocused: function onFocused() {
                this.dropdown.empty();
                this.dropdown.open();
            },
            _onBlurred: function onBlurred() {
                this.dropdown.close();
            },
            _onEnterKeyed: function onEnterKeyed(type, $e) {
                var cursorDatum, topSuggestionDatum;
                cursorDatum = this.dropdown.getDatumForCursor();
                topSuggestionDatum = this.dropdown.getDatumForTopSuggestion();
                if (cursorDatum) {
                    this._select(cursorDatum);
                    $e.preventDefault();
                } else if (this.autoselect && topSuggestionDatum) {
                    this._select(topSuggestionDatum);
                    $e.preventDefault();
                }
            },
            _onTabKeyed: function onTabKeyed(type, $e) {
                var datum;
                if (datum = this.dropdown.getDatumForCursor()) {
                    this._select(datum);
                    $e.preventDefault();
                } else {
                    this._autocomplete();
                }
            },
            _onEscKeyed: function onEscKeyed() {
                this.dropdown.close();
                this.input.resetInputValue();
            },
            _onUpKeyed: function onUpKeyed() {
                var query = this.input.getQuery();
                if (!this.dropdown.isOpen && query.length >= this.minLength) {
                    this.dropdown.update(query);
                }
                this.dropdown.open();
                this.dropdown.moveCursorUp();
            },
            _onDownKeyed: function onDownKeyed() {
                var query = this.input.getQuery();
                if (!this.dropdown.isOpen && query.length >= this.minLength) {
                    this.dropdown.update(query);
                }
                this.dropdown.open();
                this.dropdown.moveCursorDown();
            },
            _onLeftKeyed: function onLeftKeyed() {
                this.dir === "rtl" && this._autocomplete();
            },
            _onRightKeyed: function onRightKeyed() {
                this.dir === "ltr" && this._autocomplete();
            },
            _onQueryChanged: function onQueryChanged(e, query) {
                this.input.clearHint();
                this.dropdown.empty();
                query.length >= this.minLength && this.dropdown.update(query);
                this.dropdown.open();
                this._setLanguageDirection();
            },
            _onWhitespaceChanged: function onWhitespaceChanged() {
                this._updateHint();
                this.dropdown.open();
            },
            _setLanguageDirection: function setLanguageDirection() {
                var dir;
                if (this.dir !== (dir = this.input.getLanguageDirection())) {
                    this.dir = dir;
                    this.$node.css("direction", dir);
                    this.dropdown.setLanguageDirection(dir);
                }
            },
            _updateHint: function updateHint() {
                var datum, inputValue, query, escapedQuery, frontMatchRegEx, match;
                datum = this.dropdown.getDatumForTopSuggestion();
                if (datum && this.dropdown.isVisible() && !this.input.hasOverflow()) {
                    inputValue = this.input.getInputValue();
                    query = Input.normalizeQuery(inputValue);
                    escapedQuery = _.escapeRegExChars(query);
                    frontMatchRegEx = new RegExp("^(?:" + escapedQuery + ")(.*$)", "i");
                    match = frontMatchRegEx.exec(datum.value);
                    this.input.setHintValue(inputValue + (match ? match[1] : ""));
                }
            },
            _autocomplete: function autocomplete() {
                var hint, query, datum;
                hint = this.input.getHintValue();
                query = this.input.getQuery();
                if (hint && query !== hint && this.input.isCursorAtEnd()) {
                    datum = this.dropdown.getDatumForTopSuggestion();
                    datum && this.input.setInputValue(datum.value);
                    this.eventBus.trigger("autocompleted", datum.raw, datum.datasetName);
                }
            },
            _select: function select(datum) {
                this.input.clearHint();
                this.input.setQuery(datum.value);
                this.input.setInputValue(datum.value, true);
                this._setLanguageDirection();
                this.eventBus.trigger("selected", datum.raw, datum.datasetName);
                this.dropdown.close();
                _.defer(_.bind(this.dropdown.empty, this.dropdown));
            },
            open: function open() {
                this.dropdown.open();
            },
            close: function close() {
                this.dropdown.close();
            },
            getQuery: function getQuery() {
                return this.input.getQuery();
            },
            setQuery: function setQuery(val) {
                this.input.setInputValue(val);
            },
            destroy: function destroy() {
                this.input.destroy();
                this.dropdown.destroy();
                destroyDomStructure(this.$node);
                this.$node = null;
            }
        });
        return Typeahead;
        function buildDomStructure(input, withHint) {
            var $input, $wrapper, $dropdown, $hint;
            $input = $(input);
            $wrapper = $(html.wrapper).css(css.wrapper);
            $dropdown = $(html.dropdown).css(css.dropdown);
            $hint = $input.clone().css(css.hint).css(getBackgroundStyles($input));
            $hint.val("").removeData().addClass("tt-hint").removeAttr("id name placeholder").prop("disabled", true).attr({
                autocomplete: "off",
                spellcheck: "false"
            });
            $input.data(attrsKey, {
                dir: $input.attr("dir"),
                autocomplete: $input.attr("autocomplete"),
                spellcheck: $input.attr("spellcheck"),
                style: $input.attr("style")
            });
            $input.addClass("tt-input").attr({
                autocomplete: "off",
                spellcheck: false
            }).css(withHint ? css.input : css.inputWithNoHint);
            try {
                !$input.attr("dir") && $input.attr("dir", "auto");
            } catch (e) {}
            return $input.wrap($wrapper).parent().prepend(withHint ? $hint : null).append($dropdown);
        }
        function getBackgroundStyles($el) {
            return {
                backgroundAttachment: $el.css("background-attachment"),
                backgroundClip: $el.css("background-clip"),
                backgroundColor: $el.css("background-color"),
                backgroundImage: $el.css("background-image"),
                backgroundOrigin: $el.css("background-origin"),
                backgroundPosition: $el.css("background-position"),
                backgroundRepeat: $el.css("background-repeat"),
                backgroundSize: $el.css("background-size")
            };
        }
        function destroyDomStructure($node) {
            var $input = $node.find(".tt-input");
            _.each($input.data(attrsKey), function(val, key) {
                _.isUndefined(val) ? $input.removeAttr(key) : $input.attr(key, val);
            });
            $input.detach().removeData(attrsKey).removeClass("tt-input").insertAfter($node);
            $node.remove();
        }
    }();
    (function() {
        var old, typeaheadKey, methods;
        old = $.fn.typeahead;
        typeaheadKey = "ttTypeahead";
        methods = {
            initialize: function initialize(o, datasets) {
                datasets = _.isArray(datasets) ? datasets : [].slice.call(arguments, 1);
                o = o || {};
                return this.each(attach);
                function attach() {
                    var $input = $(this), eventBus, typeahead;
                    _.each(datasets, function(d) {
                        d.highlight = !!o.highlight;
                    });
                    typeahead = new Typeahead({
                        input: $input,
                        eventBus: eventBus = new EventBus({
                            el: $input
                        }),
                        withHint: _.isUndefined(o.hint) ? true : !!o.hint,
                        minLength: o.minLength,
                        autoselect: o.autoselect,
                        datasets: datasets
                    });
                    $input.data(typeaheadKey, typeahead);
                }
            },
            open: function open() {
                return this.each(openTypeahead);
                function openTypeahead() {
                    var $input = $(this), typeahead;
                    if (typeahead = $input.data(typeaheadKey)) {
                        typeahead.open();
                    }
                }
            },
            close: function close() {
                return this.each(closeTypeahead);
                function closeTypeahead() {
                    var $input = $(this), typeahead;
                    if (typeahead = $input.data(typeaheadKey)) {
                        typeahead.close();
                    }
                }
            },
            val: function val(newVal) {
                return !arguments.length ? getQuery(this.first()) : this.each(setQuery);
                function setQuery() {
                    var $input = $(this), typeahead;
                    if (typeahead = $input.data(typeaheadKey)) {
                        typeahead.setQuery(newVal);
                    }
                }
                function getQuery($input) {
                    var typeahead, query;
                    if (typeahead = $input.data(typeaheadKey)) {
                        query = typeahead.getQuery();
                    }
                    return query;
                }
            },
            destroy: function destroy() {
                return this.each(unattach);
                function unattach() {
                    var $input = $(this), typeahead;
                    if (typeahead = $input.data(typeaheadKey)) {
                        typeahead.destroy();
                        $input.removeData(typeaheadKey);
                    }
                }
            }
        };
        $.fn.typeahead = function(method) {
            if (methods[method]) {
                return methods[method].apply(this, [].slice.call(arguments, 1));
            } else {
                return methods.initialize.apply(this, arguments);
            }
        };
        $.fn.typeahead.noConflict = function noConflict() {
            $.fn.typeahead = old;
            return this;
        };
    })();
})(window.jQuery);
/* -------- studio/v2/js/bootstrap-tokenfield.js -------- */
/*!
 * bootstrap-tokenfield
 * https://github.com/sliptree/bootstrap-tokenfield
 * Copyright 2013-2014 Sliptree and other contributors; Licensed MIT
 */

(function (factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    // For CommonJS and CommonJS-like environments where a window with jQuery
    // is present, execute the factory with the jQuery instance from the window object
    // For environments that do not inherently posses a window with a document
    // (such as Node.js), expose a Tokenfield-making factory as module.exports
    // This accentuates the need for the creation of a real window or passing in a jQuery instance
    // e.g. require("bootstrap-tokenfield")(window); or require("bootstrap-tokenfield")($);
    module.exports = global.window && global.window.$ ?
      factory( global.window.$ ) :
      function( input ) {
        if ( !input.$ && !input.fn ) {
          throw new Error( "Tokenfield requires a window object with jQuery or a jQuery instance" );
        }
        return factory( input.$ || input );
      };
  } else {
    // Browser globals
    factory(jQuery, window);
  }
}(function ($, window) {

  "use strict"; // jshint ;_;

 /* TOKENFIELD PUBLIC CLASS DEFINITION
  * ============================== */

  var Tokenfield = function (element, options) {
    var _self = this

    this.$element = $(element)
    this.textDirection = this.$element.css('direction');

    // Extend options
    this.options = $.extend(true, {}, $.fn.tokenfield.defaults, { tokens: this.$element.val() }, this.$element.data(), options)

    // Setup delimiters and trigger keys
    this._delimiters = (typeof this.options.delimiter === 'string') ? [this.options.delimiter] : this.options.delimiter
    this._triggerKeys = $.map(this._delimiters, function (delimiter) {
      return delimiter.charCodeAt(0);
    });
    this._firstDelimiter = this._delimiters[0];

    // Check for whitespace, dash and special characters
    var whitespace = $.inArray(' ', this._delimiters)
      , dash = $.inArray('-', this._delimiters)

    if (whitespace >= 0)
      this._delimiters[whitespace] = '\\s'

    if (dash >= 0) {
      delete this._delimiters[dash]
      this._delimiters.unshift('-')
    }

    var specialCharacters = ['\\', '$', '[', '{', '^', '.', '|', '?', '*', '+', '(', ')']
    $.each(this._delimiters, function (index, character) {
      var pos = $.inArray(character, specialCharacters)
      if (pos >= 0) _self._delimiters[index] = '\\' + character;
    });

    // Store original input width
    var elRules = (window && typeof window.getMatchedCSSRules === 'function') ? window.getMatchedCSSRules( element ) : null
      , elStyleWidth = element.style.width
      , elCSSWidth
      , elWidth = this.$element.width()

    if (elRules) {
      $.each( elRules, function (i, rule) {
        if (rule.style.width) {
          elCSSWidth = rule.style.width;
        }
      });
    }

    // Move original input out of the way
    var hidingPosition = $('body').css('direction') === 'rtl' ? 'right' : 'left',
        originalStyles = { position: this.$element.css('position') };
    originalStyles[hidingPosition] = this.$element.css(hidingPosition);

    this.$element
      .data('original-styles', originalStyles)
      .data('original-tabindex', this.$element.prop('tabindex'))
      .css('position', 'absolute')
      .css(hidingPosition, '-10000px')
      .prop('tabindex', -1)

    // Create a wrapper
    this.$wrapper = $('<div class="tokenfield form-control" />')
    if (this.$element.hasClass('input-lg')) this.$wrapper.addClass('input-lg')
    if (this.$element.hasClass('input-sm')) this.$wrapper.addClass('input-sm')
    if (this.textDirection === 'rtl') this.$wrapper.addClass('rtl')

    // Create a new input
    var id = this.$element.prop('id') || new Date().getTime() + '' + Math.floor((1 + Math.random()) * 100)
    this.$input = $('<input type="'+this.options.inputType+'" class="token-input" autocomplete="off" />')
                    .appendTo( this.$wrapper )
                    .prop( 'placeholder',  this.$element.prop('placeholder') )
                    .prop( 'id', id + '-tokenfield' )
                    .prop( 'tabindex', this.$element.data('original-tabindex') )

    // Re-route original input label to new input
    var $label = $( 'label[for="' + this.$element.prop('id') + '"]' )
    if ( $label.length ) {
      $label.prop( 'for', this.$input.prop('id') )
    }

    // Set up a copy helper to handle copy & paste
    this.$copyHelper = $('<input type="text" />').css('position', 'absolute').css(hidingPosition, '-10000px').prop('tabindex', -1).prependTo( this.$wrapper )

    // Set wrapper width
    if (elStyleWidth) {
      this.$wrapper.css('width', elStyleWidth);
    }
    else if (elCSSWidth) {
      this.$wrapper.css('width', elCSSWidth);
    }
    // If input is inside inline-form with no width set, set fixed width
    else if (this.$element.parents('.form-inline').length) {
      this.$wrapper.width( elWidth )
    }

    // Set tokenfield disabled, if original or fieldset input is disabled
    if (this.$element.prop('disabled') || this.$element.parents('fieldset[disabled]').length) {
      this.disable();
    }

    // Set tokenfield readonly, if original input is readonly
    if (this.$element.prop('readonly')) {
      this.readonly();
    }

    // Set up mirror for input auto-sizing
    this.$mirror = $('<span style="position:absolute; top:-999px; left:0; white-space:pre;"/>');
    this.$input.css('min-width', this.options.minWidth + 'px')
    $.each([
        'fontFamily',
        'fontSize',
        'fontWeight',
        'fontStyle',
        'letterSpacing',
        'textTransform',
        'wordSpacing',
        'textIndent'
    ], function (i, val) {
        _self.$mirror[0].style[val] = _self.$input.css(val);
    });
    this.$mirror.appendTo( 'body' )

    // Insert tokenfield to HTML
    this.$wrapper.insertBefore( this.$element )
    this.$element.prependTo( this.$wrapper )

    // Calculate inner input width
    this.update()

    // Create initial tokens, if any
    this.setTokens(this.options.tokens, false, ! this.$element.val() && this.options.tokens )

    // Start listening to events
    this.listen()

    // Initialize autocomplete, if necessary
    if ( ! $.isEmptyObject( this.options.autocomplete ) ) {
      var side = this.textDirection === 'rtl' ? 'right' : 'left'
       ,  autocompleteOptions = $.extend({
            minLength: this.options.showAutocompleteOnFocus ? 0 : null,
            position: { my: side + " top", at: side + " bottom", of: this.$wrapper }
          }, this.options.autocomplete )

      this.$input.autocomplete( autocompleteOptions )
    }

    // Initialize typeahead, if necessary
    if ( ! $.isEmptyObject( this.options.typeahead ) ) {

      var typeaheadOptions = this.options.typeahead
        , defaults = {
            minLength: this.options.showAutocompleteOnFocus ? 0 : null
          }
        , args = $.isArray( typeaheadOptions ) ? typeaheadOptions : [typeaheadOptions, typeaheadOptions]

      args[0] = $.extend( {}, defaults, args[0] )

      this.$input.typeahead.apply( this.$input, args )
      this.typeahead = true
    }
  }

  Tokenfield.prototype = {

    constructor: Tokenfield

  , createToken: function (attrs, triggerChange) {
      var _self = this

      if (typeof attrs === 'string') {
        attrs = { value: attrs, label: attrs }
      } else {
        // Copy objects to prevent contamination of data sources.
        attrs = $.extend( {}, attrs )
      }

      if (typeof triggerChange === 'undefined') {
         triggerChange = true
      }

      // Normalize label and value
      attrs.value = $.trim(attrs.value.toString());
      attrs.label = attrs.label && attrs.label.length ? $.trim(attrs.label) : attrs.value

      // Bail out if has no value or label, or label is too short
      if (!attrs.value.length || !attrs.label.length || attrs.label.length <= this.options.minLength) return

      // Bail out if maximum number of tokens is reached
      if (this.options.limit && this.getTokens().length >= this.options.limit) return

      // Allow changing token data before creating it
      var createEvent = $.Event('tokenfield:createtoken', { attrs: attrs })
      this.$element.trigger(createEvent)

      // Bail out if there if attributes are empty or event was defaultPrevented
      if (!createEvent.attrs || createEvent.isDefaultPrevented()) return

      var $token = $('<div class="token" />')
            .append('<span class="token-label" />')
            .append('<a href="#" class="close" tabindex="-1">&times;</a>')
            .data('attrs', attrs)

      // Insert token into HTML
      if (this.$input.hasClass('tt-input')) {
        // If the input has typeahead enabled, insert token before it's parent
        this.$input.parent().before( $token )
      } else {
        this.$input.before( $token )
      }

      // Temporarily set input width to minimum
      this.$input.css('width', this.options.minWidth + 'px')

      var $tokenLabel = $token.find('.token-label')
        , $closeButton = $token.find('.close')

      // Determine maximum possible token label width
      if (!this.maxTokenWidth) {
        this.maxTokenWidth =
          this.$wrapper.width() - $closeButton.outerWidth() -
          parseInt($closeButton.css('margin-left'), 10) -
          parseInt($closeButton.css('margin-right'), 10) -
          parseInt($token.css('border-left-width'), 10) -
          parseInt($token.css('border-right-width'), 10) -
          parseInt($token.css('padding-left'), 10) -
          parseInt($token.css('padding-right'), 10)
          parseInt($tokenLabel.css('border-left-width'), 10) -
          parseInt($tokenLabel.css('border-right-width'), 10) -
          parseInt($tokenLabel.css('padding-left'), 10) -
          parseInt($tokenLabel.css('padding-right'), 10)
          parseInt($tokenLabel.css('margin-left'), 10) -
          parseInt($tokenLabel.css('margin-right'), 10)
      }

      $tokenLabel
        .text(attrs.label)
        .css('max-width', this.maxTokenWidth)

      // Listen to events on token
      $token
        .on('mousedown',  function (e) {
          if (_self._disabled || _self._readonly) return false
          _self.preventDeactivation = true
        })
        .on('click',    function (e) {
          if (_self._disabled || _self._readonly) return false
          _self.preventDeactivation = false

          if (e.ctrlKey || e.metaKey) {
            e.preventDefault()
            return _self.toggle( $token )
          }

          _self.activate( $token, e.shiftKey, e.shiftKey )
        })
        .on('dblclick', function (e) {
          if (_self._disabled || _self._readonly || !_self.options.allowEditing ) return false
          _self.edit( $token )
        })

      $closeButton
          .on('click',  $.proxy(this.remove, this))

      // Trigger createdtoken event on the original field
      // indicating that the token is now in the DOM
      this.$element.trigger($.Event('tokenfield:createdtoken', {
        attrs: attrs,
        relatedTarget: $token.get(0)
      }))

      // Trigger change event on the original field
      if (triggerChange) {
        this.$element.val( this.getTokensList() ).trigger( $.Event('change', { initiator: 'tokenfield' }) )
      }

      // Update tokenfield dimensions
      this.update()

      // Return original element
      return this.$element.get(0)
    }

  , setTokens: function (tokens, add, triggerChange) {
      if (!tokens) return

      if (!add) this.$wrapper.find('.token').remove()

      if (typeof triggerChange === 'undefined') {
          triggerChange = true
      }

      if (typeof tokens === 'string') {
        if (this._delimiters.length) {
          // Split based on delimiters
          tokens = tokens.split( new RegExp( '[' + this._delimiters.join('') + ']' ) )
        } else {
          tokens = [tokens];
        }
      }

      var _self = this
      $.each(tokens, function (i, attrs) {
        _self.createToken(attrs, triggerChange)
      })

      return this.$element.get(0)
    }

  , getTokenData: function($token) {
      var data = $token.map(function() {
        var $token = $(this);
        return $token.data('attrs')
      }).get();

      if (data.length == 1) {
        data = data[0];
      }

      return data;
    }

  , getTokens: function(active) {
      var self = this
        , tokens = []
        , activeClass = active ? '.active' : '' // get active tokens only
      this.$wrapper.find( '.token' + activeClass ).each( function() {
        tokens.push( self.getTokenData( $(this) ) )
      })
      return tokens
  }

  , getTokensList: function(delimiter, beautify, active) {
      delimiter = delimiter || this._firstDelimiter
      beautify = ( typeof beautify !== 'undefined' && beautify !== null ) ? beautify : this.options.beautify

      var separator = delimiter + ( beautify && delimiter !== ' ' ? ' ' : '')
      return $.map( this.getTokens(active), function (token) {
        return token.value
      }).join(separator)
  }

  , getInput: function() {
    return this.$input.val()
  }

  , listen: function () {
      var _self = this

      this.$element
        .on('change',   $.proxy(this.change, this))

      this.$wrapper
        .on('mousedown',$.proxy(this.focusInput, this))

      this.$input
        .on('focus',    $.proxy(this.focus, this))
        .on('blur',     $.proxy(this.blur, this))
        .on('paste',    $.proxy(this.paste, this))
        .on('keydown',  $.proxy(this.keydown, this))
        .on('keypress', $.proxy(this.keypress, this))
        .on('keyup',    $.proxy(this.keyup, this))

      this.$copyHelper
        .on('focus',    $.proxy(this.focus, this))
        .on('blur',     $.proxy(this.blur, this))
        .on('keydown',  $.proxy(this.keydown, this))
        .on('keyup',    $.proxy(this.keyup, this))

      // Secondary listeners for input width calculation
      this.$input
        .on('keypress', $.proxy(this.update, this))
        .on('keyup',    $.proxy(this.update, this))

      this.$input
        .on('autocompletecreate', function() {
          // Set minimum autocomplete menu width
          var $_menuElement = $(this).data('ui-autocomplete').menu.element

          var minWidth = _self.$wrapper.outerWidth() -
              parseInt( $_menuElement.css('border-left-width'), 10 ) -
              parseInt( $_menuElement.css('border-right-width'), 10 )

          $_menuElement.css( 'min-width', minWidth + 'px' )
        })
        .on('autocompleteselect', function (e, ui) {
          if (_self.createToken( ui.item )) {
            _self.$input.val('')
            if (_self.$input.data( 'edit' )) {
              _self.unedit(true)
            }
          }
          return false
        })
        .on('typeahead:selected typeahead:autocompleted', function (e, datum, dataset) {
          // Create token
          if (_self.createToken( datum )) {
            _self.$input.typeahead('val', '')
            if (_self.$input.data( 'edit' )) {
              _self.unedit(true)
            }
          }
        })

      // Listen to window resize
      $(window).on('resize', $.proxy(this.update, this ))

    }

  , keydown: function (e) {

      if (!this.focused) return

      var _self = this

      switch(e.keyCode) {
        case 8: // backspace
          if (!this.$input.is(document.activeElement)) break
          this.lastInputValue = this.$input.val()
          break

        case 37: // left arrow
          leftRight( this.textDirection === 'rtl' ? 'next': 'prev' )
          break

        case 38: // up arrow
          upDown('prev')
          break

        case 39: // right arrow
          leftRight( this.textDirection === 'rtl' ? 'prev': 'next' )
          break

        case 40: // down arrow
          upDown('next')
          break

        case 65: // a (to handle ctrl + a)
          if (this.$input.val().length > 0 || !(e.ctrlKey || e.metaKey)) break
          this.activateAll()
          e.preventDefault()
          break

        case 9: // tab
        case 13: // enter

          // We will handle creating tokens from autocomplete in autocomplete events
          if (this.$input.data('ui-autocomplete') && this.$input.data('ui-autocomplete').menu.element.find("li:has(a.ui-state-focus), li.ui-state-focus").length) break

          // We will handle creating tokens from typeahead in typeahead events
          if (this.$input.hasClass('tt-input') && this.$wrapper.find('.tt-cursor').length ) break
          if (this.$input.hasClass('tt-input') && this.$wrapper.find('.tt-hint').val() && this.$wrapper.find('.tt-hint').val().length) break

          // Create token
          if (this.$input.is(document.activeElement) && this.$input.val().length || this.$input.data('edit')) {
            return this.createTokensFromInput(e, this.$input.data('edit'));
          }

          // Edit token
          if (e.keyCode === 13) {
            if (!this.$copyHelper.is(document.activeElement) || this.$wrapper.find('.token.active').length !== 1) break
            if (!_self.options.allowEditing) break
            this.edit( this.$wrapper.find('.token.active') )
          }
      }

      function leftRight(direction) {
        if (_self.$input.is(document.activeElement)) {
          if (_self.$input.val().length > 0) return

          direction += 'All'
          var $token = _self.$input.hasClass('tt-input') ? _self.$input.parent()[direction]('.token:first') : _self.$input[direction]('.token:first')
          if (!$token.length) return

          _self.preventInputFocus = true
          _self.preventDeactivation = true

          _self.activate( $token )
          e.preventDefault()

        } else {
          _self[direction]( e.shiftKey )
          e.preventDefault()
        }
      }

      function upDown(direction) {
        if (!e.shiftKey) return

        if (_self.$input.is(document.activeElement)) {
          if (_self.$input.val().length > 0) return

          var $token = _self.$input.hasClass('tt-input') ? _self.$input.parent()[direction + 'All']('.token:first') : _self.$input[direction + 'All']('.token:first')
          if (!$token.length) return

          _self.activate( $token )
        }

        var opposite = direction === 'prev' ? 'next' : 'prev'
          , position = direction === 'prev' ? 'first' : 'last'

        _self.$firstActiveToken[opposite + 'All']('.token').each(function() {
          _self.deactivate( $(this) )
        })

        _self.activate( _self.$wrapper.find('.token:' + position), true, true )
        e.preventDefault()
      }

      this.lastKeyDown = e.keyCode
    }

  , keypress: function(e) {

      // Comma
      if ($.inArray( e.which, this._triggerKeys) !== -1 && this.$input.is(document.activeElement)) {
        if (this.$input.val()) {
          this.createTokensFromInput(e)
        }
        return false;
      }
    }

  , keyup: function (e) {
      this.preventInputFocus = false

      if (!this.focused) return

      switch(e.keyCode) {
        case 8: // backspace
          if (this.$input.is(document.activeElement)) {
            if (this.$input.val().length || this.lastInputValue.length && this.lastKeyDown === 8) break

            this.preventDeactivation = true
            var $prevToken = this.$input.hasClass('tt-input') ? this.$input.parent().prevAll('.token:first') : this.$input.prevAll('.token:first')

            if (!$prevToken.length) break

            this.activate( $prevToken )
          } else {
            this.remove(e)
          }
          break

        case 46: // delete
          this.remove(e, 'next')
          break
      }
      this.lastKeyUp = e.keyCode
    }

  , focus: function (e) {
      this.focused = true
      this.$wrapper.addClass('focus')

      if (this.$input.is(document.activeElement)) {
        this.$wrapper.find('.active').removeClass('active')
        this.$firstActiveToken = null

        if (this.options.showAutocompleteOnFocus) {
          this.search()
        }
      }
    }

  , blur: function (e) {

      this.focused = false
      this.$wrapper.removeClass('focus')

      if (!this.preventDeactivation && !this.$element.is(document.activeElement)) {
        this.$wrapper.find('.active').removeClass('active')
        this.$firstActiveToken = null
      }

      if (!this.preventCreateTokens && (this.$input.data('edit') && !this.$input.is(document.activeElement) || this.options.createTokensOnBlur )) {
        this.createTokensFromInput(e)
      }

      this.preventDeactivation = false
      this.preventCreateTokens = false
    }

  , paste: function (e) {
      var _self = this

      // Add tokens to existing ones
      if (_self.options.allowPasting) {
        setTimeout(function () {
          _self.createTokensFromInput(e)
        }, 1)
      }
    }

  , change: function (e) {
      if ( e.initiator === 'tokenfield' ) return // Prevent loops

      this.setTokens( this.$element.val() )
    }

  , createTokensFromInput: function (e, focus) {
      if (this.$input.val().length < this.options.minLength)
        return // No input, simply return

      var tokensBefore = this.getTokensList()
      this.setTokens( this.$input.val(), true )

      if (tokensBefore == this.getTokensList() && this.$input.val().length)
        return false // No tokens were added, do nothing (prevent form submit)

      if (this.$input.hasClass('tt-input')) {
        // Typeahead acts weird when simply setting input value to empty,
        // so we set the query to empty instead
        this.$input.typeahead('val', '')
      } else {
        this.$input.val('')
      }

      if (this.$input.data( 'edit' )) {
        this.unedit(focus)
      }

      return false // Prevent form being submitted
    }

  , next: function (add) {
      if (add) {
        var $firstActiveToken = this.$wrapper.find('.active:first')
          , deactivate = $firstActiveToken && this.$firstActiveToken ? $firstActiveToken.index() < this.$firstActiveToken.index() : false

        if (deactivate) return this.deactivate( $firstActiveToken )
      }

      var $lastActiveToken = this.$wrapper.find('.active:last')
        , $nextToken = $lastActiveToken.nextAll('.token:first')

      if (!$nextToken.length) {
        this.$input.focus()
        return
      }

      this.activate($nextToken, add)
    }

  , prev: function (add) {

      if (add) {
        var $lastActiveToken = this.$wrapper.find('.active:last')
          , deactivate = $lastActiveToken && this.$firstActiveToken ? $lastActiveToken.index() > this.$firstActiveToken.index() : false

        if (deactivate) return this.deactivate( $lastActiveToken )
      }

      var $firstActiveToken = this.$wrapper.find('.active:first')
        , $prevToken = $firstActiveToken.prevAll('.token:first')

      if (!$prevToken.length) {
        $prevToken = this.$wrapper.find('.token:first')
      }

      if (!$prevToken.length && !add) {
        this.$input.focus()
        return
      }

      this.activate( $prevToken, add )
    }

  , activate: function ($token, add, multi, remember) {

      if (!$token) return

      if (typeof remember === 'undefined') var remember = true

      if (multi) var add = true

      this.$copyHelper.focus()

      if (!add) {
        this.$wrapper.find('.active').removeClass('active')
        if (remember) {
          this.$firstActiveToken = $token
        } else {
          delete this.$firstActiveToken
        }
      }

      if (multi && this.$firstActiveToken) {
        // Determine first active token and the current tokens indicies
        // Account for the 1 hidden textarea by subtracting 1 from both
        var i = this.$firstActiveToken.index() - 2
          , a = $token.index() - 2
          , _self = this

        this.$wrapper.find('.token').slice( Math.min(i, a) + 1, Math.max(i, a) ).each( function() {
          _self.activate( $(this), true )
        })
      }

      $token.addClass('active')
      this.$copyHelper.val( this.getTokensList( null, null, true ) ).select()
    }

  , activateAll: function() {
      var _self = this

      this.$wrapper.find('.token').each( function (i) {
        _self.activate($(this), i !== 0, false, false)
      })
    }

  , deactivate: function($token) {
      if (!$token) return

      $token.removeClass('active')
      this.$copyHelper.val( this.getTokensList( null, null, true ) ).select()
    }

  , toggle: function($token) {
      if (!$token) return

      $token.toggleClass('active')
      this.$copyHelper.val( this.getTokensList( null, null, true ) ).select()
    }

  , edit: function ($token) {
      if (!$token) return

      var attrs = $token.data('attrs')

      // Allow changing input value before editing
      var options = { attrs: attrs, relatedTarget: $token.get(0) }
      var editEvent = $.Event('tokenfield:edittoken', options)
      this.$element.trigger( editEvent )

      // Edit event can be cancelled if default is prevented
      if (editEvent.isDefaultPrevented()) return

      $token.find('.token-label').text(attrs.value)
      var tokenWidth = $token.outerWidth()

      var $_input = this.$input.hasClass('tt-input') ? this.$input.parent() : this.$input

      $token.replaceWith( $_input )

      this.preventCreateTokens = true

      this.$input.val( attrs.value )
                .select()
                .data( 'edit', true )
                .width( tokenWidth )

      this.update();

      // Indicate that token is now being edited, and is replaced with an input field in the DOM
      this.$element.trigger($.Event('tokenfield:editedtoken', options ))
    }

  , unedit: function (focus) {
      var $_input = this.$input.hasClass('tt-input') ? this.$input.parent() : this.$input
      $_input.appendTo( this.$wrapper )

      this.$input.data('edit', false)
      this.$mirror.text('')

      this.update()

      // Because moving the input element around in DOM
      // will cause it to lose focus, we provide an option
      // to re-focus the input after appending it to the wrapper
      if (focus) {
        var _self = this
        setTimeout(function () {
          _self.$input.focus()
        }, 1)
      }
    }

  , remove: function (e, direction) {
      if (this.$input.is(document.activeElement) || this._disabled || this._readonly) return

      var $token = (e.type === 'click') ? $(e.target).closest('.token') : this.$wrapper.find('.token.active')

      if (e.type !== 'click') {
        if (!direction) var direction = 'prev'
        this[direction]()

        // Was it the first token?
        if (direction === 'prev') var firstToken = $token.first().prevAll('.token:first').length === 0
      }

      // Prepare events and their options
      var options = { attrs: this.getTokenData( $token ), relatedTarget: $token.get(0) }
        , removeEvent = $.Event('tokenfield:removetoken', options)

      this.$element.trigger(removeEvent);

      // Remove event can be intercepted and cancelled
      if (removeEvent.isDefaultPrevented()) return

      var removedEvent = $.Event('tokenfield:removedtoken', options)
        , changeEvent = $.Event('change', { initiator: 'tokenfield' })

      // Remove token from DOM
      $token.remove()

      // Trigger events
      this.$element.val( this.getTokensList() ).trigger( removedEvent ).trigger( changeEvent )

      // Focus, when necessary:
      // When there are no more tokens, or if this was the first token
      // and it was removed with backspace or it was clicked on
      if (!this.$wrapper.find('.token').length || e.type === 'click' || firstToken) this.$input.focus()

      // Adjust input width
      this.$input.css('width', this.options.minWidth + 'px')
      this.update()

      // Cancel original event handlers
      e.preventDefault()
      e.stopPropagation()
    }

    /**
     * Update tokenfield dimensions
     */
  , update: function (e) {
      var value = this.$input.val()
        , inputPaddingLeft = parseInt(this.$input.css('padding-left'), 10)
        , inputPaddingRight = parseInt(this.$input.css('padding-right'), 10)
        , inputPadding = inputPaddingLeft + inputPaddingRight

      if (this.$input.data('edit')) {

        if (!value) {
          value = this.$input.prop("placeholder")
        }
        if (value === this.$mirror.text()) return

        this.$mirror.text(value)

        var mirrorWidth = this.$mirror.width() + 10;
        if ( mirrorWidth > this.$wrapper.width() ) {
          return this.$input.width( this.$wrapper.width() )
        }

        this.$input.width( mirrorWidth )
      }
      else {
        var w = (this.textDirection === 'rtl')
              ? this.$input.offset().left + this.$input.outerWidth() - this.$wrapper.offset().left - parseInt(this.$wrapper.css('padding-left'), 10) - inputPadding - 1
              : this.$wrapper.offset().left + this.$wrapper.width() + parseInt(this.$wrapper.css('padding-left'), 10) - this.$input.offset().left - inputPadding;
        //
        // some usecases pre-render widget before attaching to DOM,
        // dimensions returned by jquery will be NaN -> we default to 100%
        // so placeholder won't be cut off.
        isNaN(w) ? this.$input.width('100%') : this.$input.width(w);
      }
    }

  , focusInput: function (e) {
      if ( $(e.target).closest('.token').length || $(e.target).closest('.token-input').length || $(e.target).closest('.tt-dropdown-menu').length ) return
      // Focus only after the current call stack has cleared,
      // otherwise has no effect.
      // Reason: mousedown is too early - input will lose focus
      // after mousedown. However, since the input may be moved
      // in DOM, there may be no click or mouseup event triggered.
      var _self = this
      setTimeout(function() {
        _self.$input.focus()
      }, 0)
    }

  , search: function () {
      if ( this.$input.data('ui-autocomplete') ) {
        this.$input.autocomplete('search')
      }
    }

  , disable: function () {
      this.setProperty('disabled', true);
    }

  , enable: function () {
      this.setProperty('disabled', false);
    }

  , readonly: function () {
      this.setProperty('readonly', true);
    }

  , writeable: function () {
      this.setProperty('readonly', false);
    }

  , setProperty: function(property, value) {
      this['_' + property] = value;
      this.$input.prop(property, value);
      this.$element.prop(property, value);
      this.$wrapper[ value ? 'addClass' : 'removeClass' ](property);
  }

  , destroy: function() {
      // Set field value
      this.$element.val( this.getTokensList() );
      // Restore styles and properties
      this.$element.css( this.$element.data('original-styles') );
      this.$element.prop( 'tabindex', this.$element.data('original-tabindex') );

      // Re-route tokenfield label to original input
      var $label = $( 'label[for="' + this.$input.prop('id') + '"]' )
      if ( $label.length ) {
        $label.prop( 'for', this.$element.prop('id') )
      }

      // Move original element outside of tokenfield wrapper
      this.$element.insertBefore( this.$wrapper );

      // Remove tokenfield-related data
      this.$element.removeData('original-styles')
                   .removeData('original-tabindex')
                   .removeData('bs.tokenfield');

      // Remove tokenfield from DOM
      this.$wrapper.remove();
      this.$mirror.remove();

      var $_element = this.$element;

      return $_element;
  }

  }


 /* TOKENFIELD PLUGIN DEFINITION
  * ======================== */

  var old = $.fn.tokenfield

  $.fn.tokenfield = function (option, param) {
    var value
      , args = []

    Array.prototype.push.apply( args, arguments );

    var elements = this.each(function () {
      var $this = $(this)
        , data = $this.data('bs.tokenfield')
        , options = typeof option == 'object' && option

      if (typeof option === 'string' && data && data[option]) {
        args.shift()
        value = data[option].apply(data, args)
      } else {
        if (!data && typeof option !== 'string' && !param) {
          $this.data('bs.tokenfield', (data = new Tokenfield(this, options)))
          $this.trigger('tokenfield:initialize')
        }
      }
    })

    return typeof value !== 'undefined' ? value : elements;
  }

  $.fn.tokenfield.defaults = {
    minWidth: 60,
    minLength: 0,
    allowEditing: true,
    allowPasting: true,
    limit: 0,
    autocomplete: {},
    typeahead: {},
    showAutocompleteOnFocus: false,
    createTokensOnBlur: false,
    delimiter: ',',
    beautify: true,
    inputType: 'text'
  }

  $.fn.tokenfield.Constructor = Tokenfield


 /* TOKENFIELD NO CONFLICT
  * ================== */

  $.fn.tokenfield.noConflict = function () {
    $.fn.tokenfield = old
    return this
  }

  return Tokenfield;

}));

/* -------- studio/v2/js/lightbox.js -------- */
/**
 * Lightbox v2.7.1
 * by Lokesh Dhakar - http://lokeshdhakar.com/projects/lightbox2/
 *
 * @license http://creativecommons.org/licenses/by/2.5/
 * - Free for use in both personal and commercial projects
 * - Attribution requires leaving author name, author link, and the license info intact
 */

(function() {
  // Use local alias
  var $ = jQuery;

  var LightboxOptions = (function() {
    function LightboxOptions() {
      this.fadeDuration                = 300;
      this.fitImagesInViewport         = true;
      this.resizeDuration              = 300;
      this.positionFromTop             = 50;
      this.showImageNumberLabel        = true;
      this.alwaysShowNavOnTouchDevices = false;
      this.wrapAround                  = false;
    }

    // Change to localize to non-english language
    LightboxOptions.prototype.albumLabel = function(curImageNum, albumSize) {
      return "Photo " + curImageNum + " of " + albumSize;
    };

    return LightboxOptions;
  })();


  var Lightbox = (function() {
    function Lightbox(options) {
      this.options           = options;
      this.album             = [];
      this.currentImageIndex = void 0;
      this.init();
    }

    Lightbox.prototype.init = function() {
      this.enable();
      this.build();
    };

    // Loop through anchors and areamaps looking for either data-lightbox attributes or rel attributes
    // that contain 'lightbox'. When these are clicked, start lightbox.
    Lightbox.prototype.enable = function() {
      var self = this;
      $('body').on('click', 'div[data-lightbox], a[rel^=lightbox], area[rel^=lightbox], a[data-lightbox], area[data-lightbox]', function(event) {
        self.start($(event.currentTarget));
        event.preventDefault();
        event.stopPropagation();
        return false;
      });
    };

    // Build html for the lightbox and the overlay.
    // Attach event handlers to the new DOM elements. click click click
    Lightbox.prototype.build = function() {
      var self = this;
      $("<div id='lightboxOverlay' class='lightboxOverlay'></div><div id='lightbox' class='lightbox'><div class='lb-outerContainer'><div class='lb-container'><img class='lb-image' src='' /><div class='lb-nav'><a class='lb-prev' href='' ></a><a class='lb-next' href='' ></a></div><div class='lb-loader'><a class='lb-cancel'></a></div></div></div><div class='lb-dataContainer'><div class='lb-data'><div class='lb-details'><span class='lb-caption'></span><span class='lb-number'></span></div><div class='lb-closeContainer'><a class='lb-close'></a></div></div></div></div>").appendTo($('body'));

      // Cache jQuery objects
      this.$lightbox       = $('#lightbox');
      this.$overlay        = $('#lightboxOverlay');
      this.$outerContainer = this.$lightbox.find('.lb-outerContainer');
      this.$container      = this.$lightbox.find('.lb-container');

      // Store css values for future lookup
      this.containerTopPadding = parseInt(this.$container.css('padding-top'), 10);
      this.containerRightPadding = parseInt(this.$container.css('padding-right'), 10);
      this.containerBottomPadding = parseInt(this.$container.css('padding-bottom'), 10);
      this.containerLeftPadding = parseInt(this.$container.css('padding-left'), 10);

      // Attach event handlers to the newly minted DOM elements
      this.$overlay.hide().on('click', function() {
        self.end();
        return false;
      });

      this.$lightbox.hide().on('click', function(event) {
        if ($(event.target).attr('id') === 'lightbox') {
          self.end();
        }
        return false;
      });

      this.$outerContainer.on('click', function(event) {
        if ($(event.target).attr('id') === 'lightbox') {
          self.end();
        }
        return false;
      });

      this.$lightbox.find('.lb-prev').on('click', function() {
        if (self.currentImageIndex === 0) {
          self.changeImage(self.album.length - 1);
        } else {
          self.changeImage(self.currentImageIndex - 1);
        }
        return false;
      });

      this.$lightbox.find('.lb-next').on('click', function() {
        if (self.currentImageIndex === self.album.length - 1) {
          self.changeImage(0);
        } else {
          self.changeImage(self.currentImageIndex + 1);
        }
        return false;
      });

      this.$lightbox.find('.lb-loader, .lb-close').on('click', function() {
        self.end();
        return false;
      });
    };

    // Show overlay and lightbox. If the image is part of a set, add siblings to album array.
    Lightbox.prototype.start = function($link) {
      var self    = this;
      var $window = $(window);

      $window.on('resize', $.proxy(this.sizeOverlay, this));

      $('select, object, embed').css({
        visibility: "hidden"
      });

      this.sizeOverlay();

      this.album = [];
      var imageNumber = 0;

      function addToAlbum($link) {
        self.album.push({
          link: $link.attr('href'),
          title: $link.attr('data-title') || $link.attr('title')
        });
      }

      // Support both data-lightbox attribute and rel attribute implementations
      var dataLightboxValue = $link.attr('data-lightbox');
      var $links;

      if (dataLightboxValue) {
        $links = $($link.prop("tagName") + '[data-lightbox="' + dataLightboxValue + '"]');
        for (var i = 0; i < $links.length; i = ++i) {
          addToAlbum($($links[i]));
          if ($links[i] === $link[0]) {
            imageNumber = i;
          }
        }
      } else {
        if ($link.attr('rel') === 'lightbox') {
          // If image is not part of a set
          addToAlbum($link);
        } else {
          // If image is part of a set
          $links = $($link.prop("tagName") + '[rel="' + $link.attr('rel') + '"]');
          for (var j = 0; j < $links.length; j = ++j) {
            addToAlbum($($links[j]));
            if ($links[j] === $link[0]) {
              imageNumber = j;
            }
          }
        }
      }

      // Position Lightbox
      var top  = $window.scrollTop() + this.options.positionFromTop;
      var left = $window.scrollLeft();
      this.$lightbox.css({
        top: top + 'px',
        left: left + 'px'
      }).fadeIn(this.options.fadeDuration);

      this.changeImage(imageNumber);
    };

    // Hide most UI elements in preparation for the animated resizing of the lightbox.
    Lightbox.prototype.changeImage = function(imageNumber) {
      var self = this;

      this.disableKeyboardNav();
      var $image = this.$lightbox.find('.lb-image');

      this.$overlay.fadeIn(this.options.fadeDuration);

      $('.lb-loader').fadeIn('slow');
      this.$lightbox.find('.lb-image, .lb-nav, .lb-prev, .lb-next, .lb-dataContainer, .lb-numbers, .lb-caption').hide();

      this.$outerContainer.addClass('animating');

      // When image to show is preloaded, we send the width and height to sizeContainer()
      var preloader = new Image();
      preloader.onload = function() {
        var $preloader, imageHeight, imageWidth, maxImageHeight, maxImageWidth, windowHeight, windowWidth;
        $image.attr('src', self.album[imageNumber].link);

        $preloader = $(preloader);

        $image.width(preloader.width);
        $image.height(preloader.height);

        if (self.options.fitImagesInViewport) {
          // Fit image inside the viewport.
          // Take into account the border around the image and an additional 10px gutter on each side.

          windowWidth    = $(window).width();
          windowHeight   = $(window).height();
          maxImageWidth  = windowWidth - self.containerLeftPadding - self.containerRightPadding - 20;
          maxImageHeight = windowHeight - self.containerTopPadding - self.containerBottomPadding - 120;

          // Is there a fitting issue?
          if ((preloader.width > maxImageWidth) || (preloader.height > maxImageHeight)) {
            if ((preloader.width / maxImageWidth) > (preloader.height / maxImageHeight)) {
              imageWidth  = maxImageWidth;
              imageHeight = parseInt(preloader.height / (preloader.width / imageWidth), 10);
              $image.width(imageWidth);
              $image.height(imageHeight);
            } else {
              imageHeight = maxImageHeight;
              imageWidth = parseInt(preloader.width / (preloader.height / imageHeight), 10);
              $image.width(imageWidth);
              $image.height(imageHeight);
            }
          }
        }
        self.sizeContainer($image.width(), $image.height());
      };

      preloader.src          = this.album[imageNumber].link;
      this.currentImageIndex = imageNumber;
    };

    // Stretch overlay to fit the viewport
    Lightbox.prototype.sizeOverlay = function() {
      this.$overlay
        .width($(window).width())
        .height($(document).height());
    };

    // Animate the size of the lightbox to fit the image we are showing
    Lightbox.prototype.sizeContainer = function(imageWidth, imageHeight) {
      var self = this;

      var oldWidth  = this.$outerContainer.outerWidth();
      var oldHeight = this.$outerContainer.outerHeight();
      var newWidth  = imageWidth + this.containerLeftPadding + this.containerRightPadding;
      var newHeight = imageHeight + this.containerTopPadding + this.containerBottomPadding;

      function postResize() {
        self.$lightbox.find('.lb-dataContainer').width(newWidth);
        self.$lightbox.find('.lb-prevLink').height(newHeight);
        self.$lightbox.find('.lb-nextLink').height(newHeight);
        self.showImage();
      }

      if (oldWidth !== newWidth || oldHeight !== newHeight) {
        this.$outerContainer.animate({
          width: newWidth,
          height: newHeight
        }, this.options.resizeDuration, 'swing', function() {
          postResize();
        });
      } else {
        postResize();
      }
    };

    // Display the image and it's details and begin preload neighboring images.
    Lightbox.prototype.showImage = function() {
      this.$lightbox.find('.lb-loader').hide();
      this.$lightbox.find('.lb-image').fadeIn('slow');

      this.updateNav();
      this.updateDetails();
      this.preloadNeighboringImages();
      this.enableKeyboardNav();
    };

    // Display previous and next navigation if appropriate.
    Lightbox.prototype.updateNav = function() {
      // Check to see if the browser supports touch events. If so, we take the conservative approach
      // and assume that mouse hover events are not supported and always show prev/next navigation
      // arrows in image sets.
      var alwaysShowNav = false;
      try {
        document.createEvent("TouchEvent");
        alwaysShowNav = (this.options.alwaysShowNavOnTouchDevices)? true: false;
      } catch (e) {}

      this.$lightbox.find('.lb-nav').show();

      if (this.album.length > 1) {
        if (this.options.wrapAround) {
          if (alwaysShowNav) {
            this.$lightbox.find('.lb-prev, .lb-next').css('opacity', '1');
          }
          this.$lightbox.find('.lb-prev, .lb-next').show();
        } else {
          if (this.currentImageIndex > 0) {
            this.$lightbox.find('.lb-prev').show();
            if (alwaysShowNav) {
              this.$lightbox.find('.lb-prev').css('opacity', '1');
            }
          }
          if (this.currentImageIndex < this.album.length - 1) {
            this.$lightbox.find('.lb-next').show();
            if (alwaysShowNav) {
              this.$lightbox.find('.lb-next').css('opacity', '1');
            }
          }
        }
      }
    };

    // Display caption, image number, and closing button.
    Lightbox.prototype.updateDetails = function() {
      var self = this;

      // Enable anchor clicks in the injected caption html.
      // Thanks Nate Wright for the fix. @https://github.com/NateWr
      if (typeof this.album[this.currentImageIndex].title !== 'undefined' && this.album[this.currentImageIndex].title !== "") {
        this.$lightbox.find('.lb-caption')
          .html(this.album[this.currentImageIndex].title)
          .fadeIn('fast')
          .find('a').on('click', function(event){
            location.href = $(this).attr('href');
          });
      }

      if (this.album.length > 1 && this.options.showImageNumberLabel) {
        this.$lightbox.find('.lb-number').text(this.options.albumLabel(this.currentImageIndex + 1, this.album.length)).fadeIn('fast');
      } else {
        this.$lightbox.find('.lb-number').hide();
      }

      this.$outerContainer.removeClass('animating');

      this.$lightbox.find('.lb-dataContainer').fadeIn(this.options.resizeDuration, function() {
        return self.sizeOverlay();
      });
    };

    // Preload previous and next images in set.
    Lightbox.prototype.preloadNeighboringImages = function() {
      if (this.album.length > this.currentImageIndex + 1) {
        var preloadNext = new Image();
        preloadNext.src = this.album[this.currentImageIndex + 1].link;
      }
      if (this.currentImageIndex > 0) {
        var preloadPrev = new Image();
        preloadPrev.src = this.album[this.currentImageIndex - 1].link;
      }
    };

    Lightbox.prototype.enableKeyboardNav = function() {
      $(document).on('keyup.keyboard', $.proxy(this.keyboardAction, this));
    };

    Lightbox.prototype.disableKeyboardNav = function() {
      $(document).off('.keyboard');
    };

    Lightbox.prototype.keyboardAction = function(event) {
      var KEYCODE_ESC        = 27;
      var KEYCODE_LEFTARROW  = 37;
      var KEYCODE_RIGHTARROW = 39;

      var keycode = event.keyCode;
      var key     = String.fromCharCode(keycode).toLowerCase();
      if (keycode === KEYCODE_ESC || key.match(/x|o|c/)) {
        this.end();
      } else if (key === 'p' || keycode === KEYCODE_LEFTARROW) {
        if (this.currentImageIndex !== 0) {
          this.changeImage(this.currentImageIndex - 1);
        } else if (this.options.wrapAround && this.album.length > 1) {
          this.changeImage(this.album.length - 1);
        }
      } else if (key === 'n' || keycode === KEYCODE_RIGHTARROW) {
        if (this.currentImageIndex !== this.album.length - 1) {
          this.changeImage(this.currentImageIndex + 1);
        } else if (this.options.wrapAround && this.album.length > 1) {
          this.changeImage(0);
        }
      }
    };

    // Closing time. :-(
    Lightbox.prototype.end = function() {
      this.disableKeyboardNav();
      $(window).off("resize", this.sizeOverlay);
      this.$lightbox.fadeOut(this.options.fadeDuration);
      this.$overlay.fadeOut(this.options.fadeDuration);
      $('select, object, embed').css({
        visibility: "visible"
      });
    };

    return Lightbox;

  })();

  $(function() {
    var options  = new LightboxOptions();
    var lightbox = new Lightbox(options);
  });

}).call(this);

/* -------- common/js/common.js -------- */
// fake a console.log method if one does not exist.
if (typeof console === "undefined") {
    console = { log: function() {} }; // jshint ignore:line
}

// The ShootProof javascipt namespace
var Sp = {
    isLoggedIn: false,

    // method to zebra strip a table
    zebraStripe: function () {

        var row_even = true; // Used for zebra striping.

        $("tr.zebra").each(function() {
            var $row = $(this);
            var href = $row.attr("href");

            // Prevents swapping row stripe if the class has same_row as class name
            // This is used because some "rows" have rowspans
            if ($row.hasClass("same_row") === false) {
                 row_even = !row_even;
            }

            // Set background
            if(row_even) {
                $row.addClass("even"); // Add 'even' class to every other tr for zebra stripes
            } else {
                $row.removeClass("even");
            }

            // If row has non-standard href on tr, make it clickable
            // but prevent clicking thru on elements like checkboxes and links et al
            if ($.trim(href).length > 0) {
                $row.click(function(e) {
                    var target = e ? e.target : window.event.srcElement;
                    if($(target).is('td')) {
                        location.href = href;
                    }
                });
            }

            // Add hover class to row
            $row.hover(
                function() {
                    $row.addClass("hover");
                },
                function() {
                    $row.removeClass("hover");
                }
            );
        });
    },

    // method to get the timezone for a user from their browser
    getTimeZone: function () {
        var rightNow = new Date();
        var jan1 = new Date(rightNow.getFullYear(), 0, 1, 0, 0, 0, 0);  // jan 1st
        var june1 = new Date(rightNow.getFullYear(), 6, 1, 0, 0, 0, 0); // june 1st
        var temp = jan1.toGMTString();
        var jan2 = new Date(temp.substring(0, temp.lastIndexOf(" ")-1));
        temp = june1.toGMTString();
        var june2 = new Date(temp.substring(0, temp.lastIndexOf(" ")-1));
        var std_time_offset = (jan1 - jan2) / (1000 * 60 * 60);
        var daylight_time_offset = (june1 - june2) / (1000 * 60 * 60);
        var dst;
        if (std_time_offset == daylight_time_offset) {
            // daylight savings time is NOT observed
            dst = "0";
        } else {
            // positive is southern, negative is northern hemisphere
            var hemisphere = std_time_offset - daylight_time_offset;
            if (hemisphere >= 0) {
                std_time_offset = daylight_time_offset;
            }
            // daylight savings time is observed
            dst = "1";
        }

        return Sp.convertTimezoneData(std_time_offset) + "," + dst;
    },

    convertTimezoneData: function (value) {
        var hours = parseInt(value, 10);
        value -= parseInt(value, 10);
        value *= 60;
        var mins = parseInt(value, 10);
        var display_hours = hours;

        // handle GMT case (00:00)
        if (hours === 0) {
            display_hours = "00";
        } else if (hours > 0) {
            // add a plus sign and perhaps an extra 0
            display_hours = (hours < 10) ? "+0"+hours : "+"+hours;
        } else {
            // add an extra 0 if needed
            display_hours = (hours > -10) ? "-0"+Math.abs(hours) : hours;
        }

        mins = (mins < 10) ? "0"+mins : mins;
        return display_hours+":"+mins;
    },

    moneyFormat: function (money, symbol) {
        return symbol + Sp.numberFormat(money, 2, '.', ',');
    },

    getObjectById: function (objId, objArray) {

        var returnIndex = Sp.getObjectIndex(objId, objArray);

        if (returnIndex == -1) {
            return;
        }

        return objArray[returnIndex];
    },

    getObjectIndex: function (objId, objArray) {

        var returnIndex = -1;
        var length = objArray.length;

        for (var i=0; i < length; i++) {
            var obj = objArray[i];

            if (obj.id == objId) {
                returnIndex = i;
            }
        }

        return returnIndex;
    },

    //Call format Sp.dropDownMessage('message to user', 'defined class name', 'delay time':
    //delay time: default 3sec
    //class name: default "success"
    dropDownMessageType: {
        success: 'success',
        error: 'error',
        info: 'info'
    },

    dropDownMessageActive: false,
    dropDownMessageQueue: [],
    dropDownMessage: function(message, msgType, delayTime) {

        delayTime = (typeof(delayTime) !== 'undefined' && delayTime !== '') ? delayTime : 3000;
        msgType = (typeof(msgType) !== 'undefined' && msgType !== '') ? msgType : 'success';

        if (Sp.dropDownMessageActive) {
            Sp.dropDownMessageQueue.push({
                msg: message,
                type: msgType,
                delay: delayTime
            });

            return;
        }

        Sp.dropDownMessageActive = true;

        $(document.createElement('div'))
            .attr('id', 'dropDownMessage')
            .addClass(msgType)
            .append(document.createTextNode(message))
            .appendTo('body')
            .delay(200)
            .slideDown(300)
            .delay(delayTime)
            .slideUp(300, function() {
                $(this).remove();
                Sp.dropDownMessageActive = false;

                // do we have a queue to work through?
                if (Sp.dropDownMessageQueue.length > 0) {
                    var options = Sp.dropDownMessageQueue.pop();

                    Sp.dropDownMessage(options.msg, options.type, options.delay);
                    return;
                }
            });
    },

    // this is modeled after the PHP function number_format
    numberFormat: function(number, decimals, dec_point, thousands_sep) {
        number = (number+'').replace(',', '').replace(' ', '');
        var n = !isFinite(+number) ? 0 : +number,
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
            s = '',
            toFixedFix = function (n, prec) {
                var k = Math.pow(10, prec);
                return '' + Math.round(n * k) / k;
            };

        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');

        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }

        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }

        return s.join(dec);
    },

    numbersOnly: function (str) {
        return str.replace(/[^0-9]/g, "");
    },

    moneyOnly: function (str, allowNegative) {
        // The caller can choose to allow negative values, but it is
        // disabled by default.
        if (allowNegative === 'undefined') {
            allowNegative = false;
        }

        if (allowNegative === false) {
            return str.replace(/[^0-9\.]/g, "");
        } else {
            return str.replace(/[^0-9\.\-]/g, "");
        }
    },

    getParameterByName: function(name) {
        var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    },

    nl2br: function (str) {
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
    },

    isValidEmail: function (email) {

        var valid = true;
        var emailReg = Sp.regex.email;

        if (email === '') {
            valid = false;
        } else if (!emailReg.test(email)) {
            valid = false;
        }

        return valid;
    },

    watchCountryStateField: function (options) {
        var defaults = {
            formPrefix: '',
            zipCodeFieldNames: {},
            cityFieldNames: {},
            selectedStateId: '',
            selectedCountryId: ''
        };
        options = $.extend(defaults, options);

        var allSelectOptions = [];

        $('#' + options.formPrefix + 'state option').each(function () {

            if ($(this).val() === '') {
                return;
            }

            var pieces = $(this).val().split('_');

            allSelectOptions.push({
                label: $(this).text(),
                value: $(this).val(),
                country: pieces[0]
            });
        });

        $('#' + options.formPrefix + 'country').change(function () {
            updateStateFieldValues($(this).val());
        });

        var updateStateFieldValues = function (countryVal) {
            $('#' + options.formPrefix + 'state').empty();
            var count = 0;
            var optionSelected = false;

            for (var i = 0; i < allSelectOptions.length; i++) {
                if (allSelectOptions[i].country == countryVal) {

                    var selected = false;

                    if (options.selectedStateId == allSelectOptions[i].value) {
                        selected = true;
                        optionSelected = true;
                    }

                    $('#' + options.formPrefix + 'state').append($('<option></option>')
                        .attr('value', allSelectOptions[i].value)
                        .attr('selected', selected)
                        .text(allSelectOptions[i].label));

                    count++;
                }
            }

            if (count > 0) {
                var chooseText = 'State / Province';

                if (Sp.hasOwnProperty('translations') && Sp.translations.hasOwnProperty('stateProvince')) {
                    chooseText = Sp.translations.stateProvince;
                }

                $('#' + options.formPrefix + 'state_other').parents('.form_element, .form-group').hide();
                $('#' + options.formPrefix + 'state_other').val('');
                $('#' + options.formPrefix + 'state').parents('.form_element, .form-group').show();
                $('#' + options.formPrefix + 'state').prepend($('<option></option>')
                    .attr('value', '')
                    .attr('selected', ((!optionSelected) ? true: false))
                    .text('- ' + chooseText + ' -'));
                $('#' + options.formPrefix + 'state').parents('.city-state-zip').removeClass('no-state-field');

            } else if (jQuery.inArray(countryVal, options.countryNoState) > -1) {
                $('#' + options.formPrefix + 'state').parents('.form_element, .form-group').hide();
                $('#' + options.formPrefix + 'state_other').parents('.form_element, .form-group').hide();
                $('#' + options.formPrefix + 'state').parents('.city-state-zip').addClass('no-state-field');
            } else {
                $('#' + options.formPrefix + 'state').parents('.form_element, .form-group').hide();
                $('#' + options.formPrefix + 'state_other').blur().parents('.form_element, .form-group').show();// IE 9 blur element to trigger placeholder
                $('#' + options.formPrefix + 'state').parents('.city-state-zip').removeClass('no-state-field');
            }

            if ($('#' + options.formPrefix + 'zip_postal').attr('skip_placeholder') === '' || $('#' + options.formPrefix + 'zip_postal').attr('skip_placeholder') === null) {
                if (options.zipCodeFieldNames.hasOwnProperty(countryVal)) {
                    // IE 9 hack
                    if(!$('html').hasClass('placeholder')) {
                        if($('#' + options.formPrefix + 'zip_postal').val() == $('#' + options.formPrefix + 'zip_postal').attr('placeholder') ||
                            $('#' + options.formPrefix + 'zip_postal').val() === '') {

                            $('#' + options.formPrefix + 'zip_postal').val(options.zipCodeFieldNames[countryVal]);
                        }
                    }

                    $('#' + options.formPrefix + 'zip_postal').attr('placeholder', options.zipCodeFieldNames[countryVal]);
                } else {
                    // IE 9 hack
                    if(!$('html').hasClass('placeholder')) {
                        if($('#' + options.formPrefix + 'zip_postal').val() == $('#' + options.formPrefix + 'zip_postal').attr('placeholder') ||
                            $('#' + options.formPrefix + 'zip_postal').val() === '') {

                            $('#' + options.formPrefix + 'zip_postal').val('Postal Code');
                        }
                    }

                    $('#' + options.formPrefix + 'zip_postal').attr('placeholder', 'Postal Code');
                }
            }

            if (Sp.hasOwnProperty('translations') && Sp.translations.hasOwnProperty('city')) {
                $('#' + options.formPrefix + 'city').parents('.form_element, .form-group').find('label, .label').text(Sp.translations.city);
            } else if (options.cityFieldNames.hasOwnProperty(countryVal)) {
                $('#' + options.formPrefix + 'city').parents('.form_element, .form-group').find('label, .label').text(options.cityFieldNames[countryVal]);
            } else {
                $('#' + options.formPrefix + 'city').parents('.form_element, .form-group').find('label, .label').text('City');
            }
        };

        updateStateFieldValues($('#' + options.formPrefix + 'country').val());
    },

    photo: {
        size: {
            s: 's',
            m: 'm',
            ml: 'ml',
            l: 'l',
            xl: 'xl'
        }
    },

    objectSize: function(obj) {
        var size = 0, key;

        for (key in obj) {
            if (obj.hasOwnProperty(key)) size++;
        }

        return size;
    },

    currentPage: '',
    setPage: function (page) {
        this.currentPage = page;
    },

    isPage: function (page) {
        return this.currentPage == page ? true : false;
    },

    clone: function (src) {
        // pulled from http://davidwalsh.name/javascript-clone
        function mixin (dest, source, copyFunc) {
            var name, s, empty = {};
            for (name in source) {
                // the (!(name in empty) || empty[name] !== s) condition avoids copying properties in "source"
                // inherited from Object.prototype.  For example, if dest has a custom toString() method,
                // don't overwrite it with the toString() method that source inherited from Object.prototype
                s = source[name];
                if (!(name in dest) || (dest[name] !== s && (!(name in empty) || empty[name] !== s))) {
                    dest[name] = copyFunc ? copyFunc(s) : s;
                }
            }
            return dest;
        }

        if (!src || typeof src != "object" || Object.prototype.toString.call(src) === "[object Function]") {
            // null, undefined, any non-object, or function
            return src; // anything
        }
        if (src.nodeType && "cloneNode" in src) {
            // DOM Node
            return src.cloneNode(true); // Node
        }
        if (src instanceof Date) {
            // Date
            return new Date(src.getTime()); // Date
        }
        if (src instanceof RegExp) {
            // RegExp
            return new RegExp(src);   // RegExp
        }
        var r, i, l;
        if (src instanceof Array) {
            // array
            r = [];
            for (i = 0, l = src.length; i < l; ++i) {
                if (i in src) {
                    r.push(this.clone(src[i]));
                }
            }
            // we don't clone functions for performance reasons
            //      }else if(d.isFunction(src)){
            //          // function
            //          r = function(){ return src.apply(this, arguments); };
        } else {
            // generic objects
            r = src.constructor ? new src.constructor() : {};
        }
        return mixin(r, src, this.clone);
    },

    formatFilesize: function (bytes) {
        bytes = parseInt(bytes, 10);

        if (bytes >= 1099511627776) {
            bytes = Sp.numberFormat(bytes / 1099511627776, 1) + ' TB';
        } else if (bytes >= 1073741824) {
            bytes = Sp.numberFormat(bytes / 1073741824, 1) + ' GB';
        } else if (bytes >= 1048576) {
            bytes = Sp.numberFormat(bytes / 1048576, 2) + ' MB';
        } else if (bytes >= 1024) {
            bytes = Sp.numberFormat(bytes / 1024, 2) + ' KB';
        } else if (bytes > 1) {
            bytes = bytes + ' bytes';
        } else if (bytes == 1) {
            bytes = bytes + ' byte';
        } else {
            bytes = '0 bytes';
        }

        return bytes;
    },

    shortFormatNumber: function (number) {
        // Returns the shortened format of a given number as a string

        // cast to string
        number = '' + number;

        // only operate on digits and decimals
        number = number.replace(/[^\d.]/, '');
        number = Sp.numberFormat(parseFloat(number), 1, '.', '');

        if (Math.abs(parseFloat(number)) >= 1000 && Math.abs(parseFloat(number)) < 100000) {
            // case -99999 -> -1000, 1000 -> 99999
            number = Sp.numberFormat(parseFloat(number) / 1000, 1, '.', '');

            if (number == Math.round(number)) {
                number = Math.round(number);
            }

            number = '' + number;

            return number + 'k';
        } else if (parseFloat(number) <= -1000000) {
            // case -infinity -> -1000000
            return '< -1M';
        } else if (parseFloat(number) > 999500) {
            // case 999500 -> infinity
            return '999k+';
        } else if (Math.abs(parseFloat(number)) >= 100000) {
            // case 100000 -> 999499
            number = '' + Math.round(parseFloat(number) / 1000);

            if (parseFloat(number) == Math.round(parseFloat(number))) {
                number = '' + Math.round(parseFloat(number));
            }

            return number + 'k';
        } else {
            // case -999 -> 999

            if (parseFloat(number) == Math.round(parseFloat(number))) {
                number = Math.round(parseFloat(number));
            }

            return '' + number;
        }
    },

    removeArrayValue: function(arr, what) {
        var a = arguments, L = a.length, ax;

        while (L > 1 && arr.length) {
            what = a[--L];
            while ((ax= arr.indexOf(what)) !== -1) {
                arr.splice(ax, 1);
            }
        }

        return arr;
    },

    stripTags: function(raw) {
        return raw.replace(/(<([^>]+)>)/gi, '').trim();
    }
};

/* -------- studio/v2/js/studio.js -------- */
/* eslint-disable prettier/prettier */
Sp.studio = {
    brandId: null,
    isLoggedIn: false,
    submitSent: false,
    unsavedChanges: false,
    constants: {
        svgVersion: 'svg-version',
        svgSprite: 'svg-sprite'
    },
    configs: {
        switchSettings: {
            containerClass: 'iPhoneCheckContainer',
            checkedLabel: '',
            uncheckedLabel: '',
            resizeHandle: false,
            resizeContainer: true,
            handleMargin: 50,
            handleRadius: 27,
            containerRadius: 27
        },
        iCheck: {
            checkboxClass: 'icheckbox_flat-sp',
            radioClass: 'iradio_flat-sp'
        },
        contactAutocomplete: {
            // Null value allows unlimited by default.
            numAllowed: null,
            showName: true,
            showEmail: false,
            showPhone: false,
            // Called when an autocomplete option is chosen.
            onSelected: null,
            // Called when an autocomplete option is not chosen, and
            // the user blurs out of the autocomplete field.
            onSelectionNotChosen: null
        }
    },
    sessionStorage: {
        getItem: (key) => {
            return window.sessionStorage.getItem(key);
        },
        removeItem: (key) => {
            window.sessionStorage.removeItem(key);
        },
        setItem: (key, value) => {
            try {
                window.sessionStorage.setItem(key, value);
            } catch {
                // Continue as we are unable to use window.sessionStorage
            }
        }
    },
    devTools: () => {
        $('.dev-tools').show();
    },
    updateSwitchStyle: (that) => {
        that.elem.parent().removeClass('status-true status-false');

        if (that.elem.prop('checked')) {
            that.elem.parent().toggleClass('status-true');
        } else {
            that.elem.parent().toggleClass('status-false');
        }
    },

    queryString: ((a) => {
        if (a === '') {
            return {};
        }

        var b = {};

        for (var i = 0; i < a.length; ++i) {
            var p = a[i].split('=', 2);

            if (p.length === 1) {
                b[p[0]] = '';
            } else {
                b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
            }
        }

        return b;
    })(window.location.search.substr(1).split('&')),

    focalPointBackgroundPosition: (element, photo) => {

        if (!photo.url) {
            return;
        }

        // defaults
        var focalPointPercentages = {
            x: 50.00,
            y: 50.00
        };

        if (typeof photo.focalPoint === 'object') {
            focalPointPercentages = photo.focalPoint;
        }

        // server focal point values are based off 0 - 100, translating to 0 - 1
        focalPointPercentages.x = focalPointPercentages.x / 100;
        focalPointPercentages.y = focalPointPercentages.y / 100;

        var imageAspectRatio = photo.width / photo.height;

        // position image

        var containerWidth = element.width();
        var containerHeight = element.height();

        var containerAspectRatio = containerWidth / containerHeight;

        var imageWidth;
        var imageHeight;

        // fill container with image
        if (imageAspectRatio > containerAspectRatio) {
            // image is wider than the container
            // therefore match heights
            imageWidth = containerHeight * imageAspectRatio;
            imageHeight = containerHeight;
        } else {
            // image is skinnier than the container
            // therefore match widths
            imageWidth = containerWidth;
            imageHeight = containerWidth / imageAspectRatio;
        }

        // compute background position
        var imageOffsetX = (containerWidth / 2) - (focalPointPercentages.x * imageWidth);
        var imageOffsetY = (containerHeight / 2) - (focalPointPercentages.y * imageHeight);

        // extending too far in quadrant II
        if (imageOffsetX < -1 * (imageWidth - containerWidth) ) {
            imageOffsetX = -1 * (imageWidth - containerWidth);
        }

        if (imageOffsetY < -1 * (imageHeight - containerHeight) ) {
            imageOffsetY = -1 * (imageHeight - containerHeight);
        }

        // extending too far in quadrant IV
        imageOffsetX = (imageOffsetX > 0) ? 0 : imageOffsetX;
        imageOffsetY = (imageOffsetY > 0) ? 0 : imageOffsetY;

        element.css({
            'background-size': imageWidth + 'px ' + imageHeight + 'px',
            'background-position': imageOffsetX + 'px ' + imageOffsetY + 'px'
        });
    },

    // Orient the photo according to focal point information
    // provided in the DOM
    initFocalPoints: function initFocalPoints(selector) {
        $.each($(selector), function renderCoverPhoto(i, el) {
            var $el = $(el);

            this.focalPointBackgroundPosition($el, {
                url: $el.data('coverPhotoSrc'),
                width: $el.data('coverPhotoWidth'),
                height: $el.data('coverPhotoHeight'),
                focalPoint: {
                    x: $el.data('coverPhotoFocalPointX'),
                    y: $el.data('coverPhotoFocalPointY')
                }
            });

            $el.css('backgroundImage', 'url(' + $el.data('coverPhotoSrc') + ')');
        });
    },

    init: function init() {
        this.commonInit();
        this.navInit();
        this.initPagination();

        // make sure the first form error is shown on the page
        if ($('ul.form-error').length) {
            this.scrollToFirstFormError();
        }

        if (Sp.isPage('account_acceptpayments')) {
            this.handleAccountAcceptpayments();
        } else if (Sp.isPage('account_contactinfo')) {
            this.handleAccountContactinfo();
        } else if (Sp.isPage('account_paymentcompliance')) {
            this.handleAccountPaymentCompliance();
        } else if (Sp.isPage('account_refer')) {
            this.handleAccountRefer();
        } else if (Sp.isPage('signup_index')) {
            this.handleSignupPage();
        } else if (Sp.isPage('deal_confirm')) {
            this.handleDealConfirm();
        } else if (Sp.isPage('deal_index') || Sp.isPage('deal_upgrade')) {
            this.handleDealIndex();
        } else if (Sp.isPage('dealsignup_index')) {
            this.handleDealSignupIndex();
        } else if (Sp.isPage('deal_index-music')) {
            this.handleDealIndexMusic();
        } else if (Sp.isPage('email_activity')) {
            this.handleEmailActivity();
        } else if (Sp.isPage('order_approve')) {
            this.handleOrderApprove();
        } else if (Sp.isPage('order_index')) {
            this.handleOrderIndex();
        } else if (Sp.isPage('order_view')) {
            this.handleOrderView();
        } else if (Sp.isPage('order_print')) {
            this.handleOrderPrint();
        } else if (Sp.isPage('order_laborderdefaults')) {
            this.handleOrderLabOrderDefaults();
        } else if (Sp.isPage('report_galleryvisitor')) {
            this.handleReportGalleryVisitor();
        } else if (Sp.isPage('report_sale')) {
            this.handleReportSale();
        } else if (Sp.isPage('report_printstoresale')) {
            this.handlePrintStoreReportSale();
        } else if (Sp.isPage('report_item')) {
            this.handleReportItem();
        } else if (Sp.isPage('gallery_defaults')) {
            this.handleGalleryDefaults();
        } else if (Sp.isPage('gallery_editbrandeventdefaults')) {
            this.handleGalleryEditBrandEventDefaults();
        } else if (Sp.isPage('gallery_edit')) {
            this.handleGalleryEdit();
        } else if (Sp.isPage('gallery_settings')) {
            this.handleGallerySettings();
        } else if (Sp.isPage('gallery_contactsettings')) {
            this.handleGalleryContactSettings();
        } else if (Sp.isPage('gallery_addphoto')) {
            this.handleGalleryAddPhoto();
        } else if (Sp.isPage('gallery_index')) {
            this.handleGalleryIndex();
        } else if (Sp.isPage('gallery_filelist')) {
            this.handleGalleryFileList();
        } else if (Sp.isPage('gallery_clientemailfavorite')) {
            this.handleGalleryClientEmailFavorite();
        } else if (Sp.isPage('gallery_clientemaillabeled')) {
            this.handleGalleryClientEmailLabeled();
        } else if (Sp.isPage('gallery_loginwidget')) {
            this.handleGalleryLoginWidget();
        } else if (Sp.isPage('account_user')) {
            this.handleAccountUser();
        } else if (Sp.isPage('account_useredit')) {
            this.handleAccountUseredit();
        } else if (Sp.isPage('account_planbilling')) {
            this.handleAccountPlanBilling();
        } else if (Sp.isPage('account_creditcard')) {
            var formErrors = this.jsValues.formErrors;
            var formValues = this.jsValues.formValues;
            var hasFormValues = Object.values(formValues).some(Boolean);

            var joinErrorMessages = (name) => {
                if (!formErrors[name]) {
                    return '';
                }

                return Object.values(formErrors[name]).join(' ');
            };

            var initialFormValueErrors = {
                creditCardNumber: joinErrorMessages('cc_num'),
                cvv: joinErrorMessages('cc_cvs'),
                month: joinErrorMessages('exp_month'),
                postalCode: joinErrorMessages('zip_postal'),
                year: joinErrorMessages('exp_year'),
            };
            var initialFormError = formErrors.token ? 'Please resubmit the form.' : undefined;
            var initialFormValues = hasFormValues
                ? {
                    creditCardNumber: formValues['cc_num'],
                    cvv: formValues['cc_cvs'],
                    month: Number(formValues['exp_month']),
                    postalCode: formValues['zip_postal'],
                    year: Number(formValues['exp_year'])
                }
                : undefined;
            const { emailVerification } = this.jsValues;

            window.Sp.v2ReactBridge.showPlanBillingSubNav({
                isEmailVerified: emailVerification.isVerified,
                initialFormError: initialFormError,
                initialFormValueErrors: initialFormValueErrors,
                initialFormValues: initialFormValues,
                initialTab: 'credit-card',
                maskedCreditCardNumber: this.jsValues.cardOnFile,
                onCreditCardFormSubmit: this.updateCardOnFile,
                onSendVerificationEmail: handleSendVerificationEmail(emailVerification),
                showLabCreditTab: this.jsValues.studioHasLabCredit

            });

            if (this.queryString.firstcard) {
                this.updateAnalyticsDataLayer({
                    event: this.queryString.firstcard === '1' ? 'addedcc' : 'account_cc_changed',
                    subscriberEmail: Sp.userEmail
                });
            }
        } else if (Sp.isPage('account_labcredit')) {
            const orderURI = `${this.studioPanelUri('/order/view')}`;
            const { emailVerification } = this.jsValues;
            window.Sp.v2ReactBridge.showPlanBillingSubNav({
                isEmailVerified: emailVerification.isVerified,
                initialTab: 'lab-credit',
                labCreditHistory: this.jsValues.labCreditHistory,
                labCredits: this.jsValues.labCredits,
                maskedCreditCardNumber: this.jsValues.cardOnFile,
                onCreditCardFormSubmit: this.updateCardOnFile,
                onViewOrderClick: (orderId) =>
                    window.open(`${orderURI}/${orderId}`),
                onSendVerificationEmail: handleSendVerificationEmail(emailVerification),
                showLabCreditTab: true
            });
        } else if (Sp.isPage('account_authorizedapps')) {
            this.handleAccountAuthorizedApps();
        } else if (Sp.isPage('brand_integration')) {
            this.handleBrandIntegration();
        } else if (Sp.isPage('brand_watermark')) {
            this.handleBrandWatermark();
        } else if (Sp.isPage('brand_watermarkedit')) {
            this.handleBrandWatermarkEdit();
        } else if (Sp.isPage('payment_index')) {
            this.handlePaymentIndex();
        } else if (Sp.isPage('pricing_pricesheet')) {
            this.handlePricingPricesheet();
        } else if (Sp.isPage('pricing_edit')) {
            this.handlePricingEdit();
        } else if (Sp.isPage('pricing_catalog')) {
            this.handlePricingCatalog();
        } else if (Sp.isPage('pricing_discount')) {
            this.handlePricingDiscount();
        } else if (Sp.isPage('mobileapp_index')) {
            this.handleMobileAppIndex();
        } else if (Sp.isPage('mobileapp_edit')) {
            this.handleMobileAppEdit();
        } else if (Sp.isPage('email_template')) {
            this.handleEmailTemplate();
        } else if (Sp.isPage('email_templateedit')) {
            this.handleEmailTemplateEdit();
        } else if (Sp.isPage('mobileapp_addphoto')) {
            this.handleMobileAppAddPhoto();
        } else if (Sp.isPage('notification_index')) {
            this.handleNotificationIndex();
        } else if (Sp.isPage('notification_dismissed')) {
            this.handleNotificationDismissed();
        } else if (Sp.isPage('account_tou')) {
            this.handleAccountTou();
        } else if (Sp.isPage('account_new-gallery-management')) {
            this.handleAccountNewGalleryManagement();
        } else if (Sp.isPage('login_change')) {
            var passwordFormState = {
                isPasswordValid: false
            };

            this.renderPasswordForm({
                isRequired: true,
                isStudioSignup: false,
                passwordFormState: passwordFormState,
                showValidation: false,
            });

            $('[name="password"]').on('focus', () => {
                $('.form-error').remove();
            });

            $('form').on('submit', (event) => {
                if (passwordFormState.isPasswordValid) {
                    $('[name="confirmPassword"]').attr('name', 'confirm_password');
                } else {
                    event.preventDefault();
                }
            });
        }

        if (Sp.studio.hasOwnProperty('isFaqEditor') && Sp.studio.isFaqEditor) {
            this.setupFaqEditor();
        }

        /**
         * @todo remove this after dev is complete
         */
        delete Sp.dropDownMessageType;
        delete Sp.dropDownMessageActive;
        delete Sp.dropDownMessageQueue;
        delete Sp.dropDownMessage;
        delete Sp.watchCountryStateField;
    },

    activateSwitch: function activateSwitch(selector, settings) {
        var switchSettings = this.configs.switchSettings;

        $(selector).each((i, el) => {
            var tempSwitchSettings = Sp.clone(switchSettings);
            var iphoneStyleConfig = $.extend(
                tempSwitchSettings,
                settings
            );

            $(el).iphoneStyle(iphoneStyleConfig);

        });

        // set each initial state on page load
        $(selector).each((i, el) => {
            $(el).parent().removeClass('status-true status-false');

            if ($(el).prop('checked')) {
                $(el).parent().addClass('status-true');
            } else {
                $(el).parent().addClass('status-false');
            }

        });
    },

    handleBrandIntegration: function handleBrandIntegration() {
        this.initCopy();
    },

    handleGalleryLoginWidget: function handleGalleryLoginWidget() {
        this.initCopy();

        function updateDemo() {
            var chooserUrl = $('#demo-pane').data('chooserUrl');
            var demoUrl = $('#demo-pane').data('demoUrl');
            var showEventList = $('#showEventList').is(':checked') ? 1 : 0;
            var showEmailField = $('#showEmailAddressField').is(':checked') ? 1 : 0;
            var language = $('#language').val();
            var cb = parseInt(Math.random() * 99999999, 10);
            var code = '<scr' + 'ipt type="text/javascript">var _cb = parseInt(Math.random() * 99999999);document.write(\'<sc\' + \'ript type="text/javascript" src="' + chooserUrl + '?events=' + showEventList + '&email=' + showEmailField + '&language=' + language + '&cb=\' + _cb + \'"></sc\' + \'ript>\');</sc' + 'ript>';

            $('#demo-frame').attr('src',  demoUrl + '?chooserUrl=' + encodeURIComponent(chooserUrl) + '&showEventList=' + encodeURIComponent(showEventList) + '&showEmailField=' + encodeURIComponent(showEmailField) + '&language=' + encodeURIComponent(language) + '&cb=' + cb);
            $('#loginWidgetCode').val(code);
        }

        $('input').on('ifToggled ', () => {
            updateDemo();
        });

        $('#language').select2().on('change', () => {
            updateDemo();
        });

        updateDemo();
    },
    
    handleBrandWatermark: function () {

        var that = this;

        this.initPushPops();

        $('#watermarkUse').on('ifChanged', function () {
            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/brand/watermark'), 'brand_watermark'), {
                watermark_use: ($('#watermarkUse').is(':checked') ? 1 : 0)
            }, function (data) {
                that.hoverMessage.show(data.msg, data.status);
            }, 'json');
        });

        $('.default-watermark').click(function () {
            var id = $(this).data('watermarkId');

            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/brand/watermark'), 'brand_watermark'), {
                watermark_default: id
            }, function (data) {
                that.hoverMessage.show(data.msg, data.status);

                if (data.status === that.hoverMessage.type.success) {
                    $('#watermark-tile-' + id).find('.img-rounded-top').first().append($('.default-flag'));
                }
            }, 'json').fail(function (jqXHR) {
                that.hoverMessage.show(jqXHR.responseJSON.msg, jqXHR.responseJSON.status);
            });
        });

        $('.js-add-watermark').on('click', function (e) {
            e.preventDefault();

            that.modal({
                title: 'Add Watermark',
                body: _.template($('#templateAddWatermark').html(), {}),
                sizeClass: 'modal-md',
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Create',
                        'class': 'btn-primary',
                        click: function () {
                            var name = $.trim($('#watermarkName').val());
                            var modal = $(this).parents('.modal');

                            if (name === '') {
                                that.displayFormErrors(modal, {
                                    'watermarkName': [
                                        'Please enter a name for this new watermark.'
                                    ]
                                });
                                return;
                            }

                            that.loading('Creating', 'show');

                            self.location.href = that.studioPanelUri('/brand/watermark/new') + '?name=' + name;
                        }
                    }
                ]
            });
        });

        $('.delete-watermark').click(function () {
            that.displayWatermarkDeleteModal(this, that);
        });
    },

    handleBrandWatermarkEdit: function () {

        var that = this;
        var nameChanged;
        var error = false;

        if (this.jsValues.watermarkId !== null) {
            nameChanged = function (newName) {
                $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/brand/updatewatermarkname'), 'brand_updatewatermarkname'), {
                    watermark_id: that.jsValues.watermarkId,
                    name: newName
                }, function (json) {
                    that.hoverMessage.show(json.msg, json.status);
                    $('#name').val(newName);
                }, 'json');
            };
        } else {
            nameChanged = function (newName) {
                $('#name').val(newName);
            };
        }

        this.inlineEditName({
            placeholderText: 'Watermark Name',
            wrapperSelector: '#pageTitleHeaderText',
            maxInputTextLength: 100,
            nameChangedCallback: nameChanged,
            syncInputSelector: '#name'
        });

        $('input[type="checkbox"]').on('ifChecked', function () {
            if($('input[name="is_free_plan"]').val() === "1"){
                $('.submit-form').attr('disabled', 'disabled');
                $('.default-watermark').attr('disabled', 'disabled');
                $('#aiFeatureNotAvailable').show();
                error = true;
            }
        });

        $('input[type="checkbox"]').on('ifUnchecked', function () {
            if($('input[name="is_free_plan"]').val() === "1"){
                $('.submit-form').removeAttr('disabled');
                $('.default-watermark').removeAttr('disabled');
                $('#aiFeatureNotAvailable').hide();
                error = false;
            }
        });

        $('.default-watermark').click(function () {
            if(error){
                // Prevents the user from submitting the form if they manipulated the dom
                return;
            }

            var id = $(this).data('watermarkId');

            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/brand/watermark'), 'brand_watermark'), {
                watermark_default: id
            }, function (json) {
                that.hoverMessage.show(json.msg, json.status);
                $('.default-watermark').remove();
            }, 'json');
        });

        $('input[name="brand_watermark_type_id"]').on('ifChecked', function () {
            $('.tab.selected').removeClass('selected');
            $('.tab[data-brand-watermark-type-id="' + $(this).val() + '"]').addClass('selected');
            updateWatermarkDemo();
        });

        $('input[name="setting_watermark_text_color"]').on('ifChecked', function () {
            updateWatermarkDemo();
        });

        $('#setting_watermark_is_ai_resistant').on('ifChanged', function () {
            updateWatermarkDemo();
        });


        $('.submit-form').click(function (e) {
            if(error){
                // Prevents the user from submitting the form if they manipulated the dom
                return;
            }
            e.preventDefault();
            $('#watermarkEditForm').submit();
        });

        var updateWatermarkDemo = function () {

            var demoUrl = that.studioPanelUri('/brand/watermark/demo');

            var image1 = $('#demo-image-1 img'),
                image2 = $('#demo-image-2 img');

            var params = {
                use: 1,
                op: $('#setting_watermark_opacity').val(),
                type: $('input[name="brand_watermark_type_id"]:checked').val(),
                txt: $('#setting_watermark_text').val(),
                color: $('input[name="setting_watermark_text_color"]:checked').val(),
                font: $('#setting_watermark_font').val(),
                img_loc: $('#setting_watermark_location').val(),
                img_size: $('#setting_watermark_image_size').val(),
                watermark_id: $('#watermark_id').val(),
                ai_resistance: $('#setting_watermark_is_ai_resistant').is(':checked'),
                text_loc: $('#setting_watermark_text_location').val(),
                '_cb': Math.random()
            };

            image1.attr('src', demoUrl + '?img=1&' + $.param(params));
            image2.attr('src', demoUrl + '?img=2&' + $.param(params));
        };

        $('input, select').on('change', function () {
            if ($(this).val()) {
                updateWatermarkDemo();
            }
        });

        $('.slider').on('slideStop', function () {
            if ($(this).val()) {
                updateWatermarkDemo();
            }
        });

        $('.fileinput').on('change.bs.fileinput', function () {
            that.modal({
                title: 'Previewing Your Watermark Image',
                body: '<p>Please click "save" to upload your new watermark image and preview the changes.</p>',
                buttons: [
                    {
                        'class': 'btn-primary',
                        label: 'Okay',
                        close: true
                    }
                ]
            });
        });

        updateWatermarkDemo();
    },

    handleGalleryIndex: function () {
        var that = this;

        this.setupDatagridFilter();
        this.addGalleryInit();
        this.initPushPops();
        this.initFocalPoints('.gallery-cover-photo');

        $('#eventStatusToggle').on('change', function () {
            self.location.href = that.studioPanelUri('/gallery') + '?event_status_id=' + this.value;
        });

        $('.js-toggle-select-gallery-mode').click(function(e) {
            e.preventDefault();

            var selectMode = $('.galleries-card-view').hasClass('select-mode');

            if (selectMode) {
                $('.galleries-card-view').removeClass('select-mode');
                $('.js-toggle-select-gallery-mode').text('Select');
                $('.hover-block span').html('View');
            } else {
                $('.galleries-card-view').addClass('select-mode');
                $('.js-toggle-select-gallery-mode').text('Cancel');
                $('.hover-block span').html('Select');
            }
        });

        // initialize with no selection
        $('.sp-tile input[type="checkbox"]').iCheck('uncheck');

        $('.sp-tile input[type="checkbox"]').on('ifChecked', function () {
            $(this).parents('.sp-grid-item').addClass('selected');
        });
        $('.sp-tile input[type="checkbox"]').on('ifUnchecked', function () {
            $(this).parents('.sp-grid-item').removeClass('selected');
        });

        // mobile click area
        $('.mobile-input-touch-area').click(function() {
            $(this).find('input').iCheck('toggle');
        });

        // block clickthrough for popped push-pops
        $('a.js-edit-gallery').click(function (e) {
            if ($(e.target).parents('.sp-tile').hasClass('popped')) {
                e.preventDefault();
            }
        });

        $('.js-client-view, .js-gallery-visitors, .js-settings').on('click', function(e) {
            e.preventDefault();
            self.location.href = $(this).data('href');
        });

        $('.js-activate-event').on('click', function (e) {
            e.preventDefault();
            var eventId = $(this).data('eventId');

            that.modal({
                title: 'Activate Gallery',
                body: _.template($('#templateActivateGallery').html(), {}),
                sizeClass: 'modal-md',
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Activate',
                        'class': 'btn-primary',
                        click: function () {

                            $(this).parents('.modal').modal('hide');

                            $.post(that.studioPanelUri('/gallery/updateactive/' + eventId), {
                                active: 1
                            }, function () {
                                location.reload();
                            }, 'json');
                        }
                    }
                ]
            });
        });

        $('#startBulkActions').on('click', function (e) {
            e.preventDefault();

            var events = [];
            if ($('#galleryList').hasClass('sp-grid-container')) {
                $('#galleryList .sp-grid-item.selected').each(function(i, val) {
                    events.push($(val).data('eventId'));
                });
            } else {
                $('#galleryList .td:first-child input:checkbox:checked:not(.skip,.switch)').each(function (i, val) {
                    events.push($(val).val());
                });
            }

            if (events.length === 0) {
                return;
            }

            that.modal({
                title: 'Bulk Actions',
                body: _.template($('#templateBulkActions').html(), {
                    events: events,
                    num: $('#galleryList input:checkbox:not(.skip):checked').length
                }),
                sizeClass: 'modal-lg',
                open: function () {
                    $('#' + this.id).find('select').select2({
                        width: '100%',
                        minimumResultsForSearch: Infinity
                    });

                    that.editor('#bulk_intro_text', {
                        minHeight: 100,
                        maxHeight: 300
                    });

                    $('#' + this.id + ' input.switch').each(function(i,el) {
                        $(el).parents('.form-group').find('.clearfix').remove();
                        $(el).parents('.form-group').append('<div class="exterior-label-checked">').find('.exterior-label-checked').html($(el).data('checkedLabel'));
                        $(el).parents('.form-group').append('<div class="exterior-label-unchecked">').find('.exterior-label-unchecked').html($(el).data('uncheckedLabel'));
                        $(el).parents('.form-group').append('<div class="clearfix"></div>');
                    });

                    $('.js-select-total-results').on('click', function (e) {
                        e.preventDefault();

                        var eventIdsElement = $(this).parents('form').find('input[name="event_ids"]');

                        if ($(this).data('clearShowing') === 0) {
                            $(eventIdsElement).data('eventIds', $(eventIdsElement).val());
                            $(eventIdsElement).val('');
                            $('.js-only-this-page').hide();
                            $(this).parents('form').find('input[name="all_results"]').val($(this).data('searchParams'));
                            $(this).data('clearShowing', 1);
                            $(this).data('label', $(this).text());
                            $(this).text('Clear Selection');
                        } else {
                            $(eventIdsElement).val($(eventIdsElement).data('eventIds'));
                            $(this).parents('form').find('input[name="all_results"]').val('');
                            $('.js-only-this-page').show();
                            $(this).data('clearShowing', 0);
                            $(this).text($(this).data('label'));
                        }
                    });

                    that.activateSwitch('#' + this.id + ' input.switch', {
                        onChange: function() {
                            Sp.studio.updateSwitchStyle(this);
                        }
                    });

                    $('#bulk_gallery_expiration_date').datepicker({
                        format: 'yyyy-mm-dd',
                        autoclose: true
                    }).on('show', function (e) {
                        // For issue #1941, we have to set the z-index so the
                        // date picker can display correctly in a modal.  Due
                        // to that Bootstrap Datepicker event bubbling up, we
                        // want to stop propagation here, which will prevent
                        // the modal's open method above from being run
                        // multiple times.
                        e.stopPropagation();
                        $('.datepicker').css('zIndex', 2000);
                    });
                },
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Apply Actions',
                        'class': 'btn-primary',
                        click: function () {
                            $('#bulkActionsForm').submit();
                        }
                    }
                ]
            });
        });

        $('.release-event').on('click', function (e) {
            e.preventDefault();
            var eventId = $(this).data('eventId');

            that.loading('Loading', 'show');

            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/email/templatelist'), 'email_templatelist'), {
                event_id: eventId,
                template_type_id: 4
            }, function (json) {
                var fromEmail = json.fromEmail;
                var templates = json.templates;

                $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/email/defaulttemplatecontents'), 'email_defaulttemplatecontents'), {
                    email_template_type_id: 4,
                    event_id: eventId
                }, function (json) {

                    that.loading('Loading', 'hide');

                    that.modal({
                        title: 'Release Gallery',
                        sizeClass: 'modal-fullscreen',
                        body: _.template($('#templateReleaseEvent').html(), {
                            fromEmail: fromEmail,
                            templates: templates,
                            subject: json.subject,
                            body: json.body,
                            headline: json.headline,
                            buttonText: json.buttonText,
                            templateTypeId: 4,
                            buttonTextHelper: json.buttonTextHelper
                        }),
                        open: function () {
                            that.initEmailPreview();

                            var previewEmail = function () {
                                var params = {
                                    email_template_type_id: $('#templateTypeId').val(),
                                    subject: $('#emailSubject').val(),
                                    headline: $('#emailHeadline').val(),
                                    button_text: $('#emailButtonText').val(),
                                    body: $R('#emailBody').source.getCode(),
                                    event_id: eventId
                                };

                                that.handleEmailPreview(params);
                            };

                            $('#emailHeadline, #emailButtonText').on('input', function () {
                                previewEmail();
                            });

                            that.editor('#emailBody', {
                                minHeight: 100,
                                maxHeight: 300,
                                changeCallback: previewEmail
                            });

                            $('#emailTemplateId').select2({
                                width: '100%',
                                minimumResultsForSearch: Infinity
                            });

                            // Get the default message text at open time.
                            var defaultMessageText = $('#emailBody').val();
                            var defaultSubjectText = $('#emailSubject').val();
                            var defaultHeadline = $('#emailHeadline').val();
                            var defaultButtonText = $('#emailButtonText').val();

                            $('#emailTemplateId').on('change', function () {
                                if (this.value !== '') {
                                    var template = Sp.getObjectById(this.value, templates);
                                    $('#emailSubject').val(template.subject);
                                    $R('#emailBody').source.setCode(template.body);
                                    $('#emailHeadline').val(template.headline);
                                    $('#emailButtonText').val(template.buttonText);
                                } else {
                                    $('#emailSubject').val(defaultSubjectText);
                                    $R('#emailBody').source.setCode(defaultMessageText);
                                    $('#emailHeadline').val(defaultHeadline);
                                    $('#emailButtonText').val(defaultButtonText);
                                }

                                previewEmail();
                            });

                            $('#' + this.id).find('input:checkbox').iCheck(that.configs.iCheck);

                            $('.email-preview button.send-mail').click(function () {
                                var modal = $(this).parents('.modal');
                                var sendEmail = 0;

                                if ($('#sendEmail').is(':checked')) {
                                    sendEmail = 1;
                                }

                                if (sendEmail) {
                                    that.loading('Sending Email', 'show');
                                } else {
                                    that.loading('Releasing Gallery', 'show');
                                }

                                $.post(that.studioPanelUri('/gallery/release'), {
                                    event_id: eventId,
                                    send_email: sendEmail,
                                    subject: $('#emailSubject').val(),
                                    body: $('#emailBody').val(),
                                    headline: $('#emailHeadline').val(),
                                    button_text: $('#emailButtonText').val()
                                }, function () {
                                    $(modal).modal('hide');
                                    self.location.href = self.location.href;
                                }, 'json');
                            });

                            previewEmail();
                        },
                        buttons: []
                    });
                }, 'json');
            }, 'json');
        });
    },

    handleGalleryFileList: function () {
        $('a[data-lightbox]').on('click', function () {
            $(this).parents('.btn-group').removeClass('open');
        });
    },

    handleGalleryEdit: function () {
        var that = this;
        this.tempGalleryName = $('#name').val();

        this.activateSwitch('input.switch:not(.custom)', {
            onChange: function() {
                that.updateSwitchStyle(this);
            }
        });


        this.doRulesApply = function (actionObject, ruleType) {
            rules = that.checkDisplayClasses();

            var ruleMet = false
            var checkObject = actionObject.displayRules;

            // are we checking to display or if to show as disabled?
            if (typeof ruleType !== 'undefined' &&
                ruleType === 'disabled') {

                if (!actionObject.hasOwnProperty('disabledRules')) {
                    return false;
                }

                checkObject = actionObject.disabledRules;
            }

            $.each(rules, function (i, rule) {
                if (checkObject.hasOwnProperty(rule)) {
                    ruleMet = true;
                    return;
                }
            });

            return ruleMet;
        };

        // map classes to rules
        this.checkDisplayClasses = function () {
            // grab all classes on album-header
            var albumStateClasses = $('.album-header').attr('class').split(/\s/);
            var applicableRules = [];

            if (albumStateClasses.indexOf('all-photos') > -1) {
                if (albumStateClasses.indexOf('multiple-photos-selected') < 0 &&
                    albumStateClasses.indexOf('single-photo-selected') < 0) {

                    applicableRules.push('all-photos');
                } else if (albumStateClasses.indexOf('multiple-photos-selected') > -1) {
                    applicableRules.push('all-photo-multi');
                } else if (albumStateClasses.indexOf('single-photo-selected') > -1) {
                    applicableRules.push('all-photo-single');
                }

            } else if (albumStateClasses.indexOf('root-folder') > -1) {
                applicableRules.push('root');

            } else if (albumStateClasses.indexOf('single-album') > -1) {
                if (albumStateClasses.indexOf('multiple-photos-selected') < 0 &&
                    albumStateClasses.indexOf('single-photo-selected') < 0) {

                    applicableRules.push('album');
                    if (albumStateClasses.indexOf('has-sub-albums') > -1) {
                        applicableRules.push('album-has-sub');
                    } else {
                        applicableRules.push('photo');
                    }
                } else if (albumStateClasses.indexOf('multiple-photos-selected') > -1) {
                    applicableRules.push('photo-multi');
                } else if (albumStateClasses.indexOf('single-photo-selected') > -1) {
                    applicableRules.push('photo-single');
                }
            }

            return applicableRules;
        };

        this.initRcmenu = function() {
            var that = this;

            // initialize right click menu
            this.rcmenu = $.rcmenu({
                selector: 'ul.photos-view .fourthree-container',
                menuClass: 'dropdown-menu',
                menuOpen: function(event) {
                    if ($('.photos-view').hasClass('multi-select')) {
                        if (($(event.target).is('.fourthree-container') && !$(event.target).hasClass('ui-selected')) ||
                            !$(event.target).parents('li.photo-tile').find('.fourthree-container').hasClass('ui-selected')) {

                            that.rcmenu.container.hide();
                        } else {
                            that.buildGalleryActions();
                        }
                    } else if (!$('.photos-view .fourthree-container.ui-selected').length) {
                        // force a select on the right click case where no photos are selected
                        $(event.target).click();
                    }
                }
            });
        };

        this.initRcmenu();

        this.buildGalleryActions = function() {
            // init vars
            var that = this;
            var containerWidth = $('.main-pane').width() / 2;
            // account for more-tab width
            var maxWidth = containerWidth - 62;
            var roomForButtons = true;

            // clear old actions
            $('.collapse-buttons li:not(.more-tab), .collapse-buttons .more-tab ul li').remove();
            $('#conmenu').empty();
            that.rcmenu.empty();


            // start with the overflow button hidden for calculations
            $('.collapse-buttons .more-tab').hide();

            // loop through gallery action elements
            $.each(Sp.studio.jsValues.galleryActions, function (i, el) {
                if (that.doRulesApply(el, 'display')) {

                    // build a clone of el to modify class param if action is disabled
                    var templateVars = {};
                    $.extend(true, templateVars, el);

                    // append disabled class to elements that should be disabled
                    if (that.doRulesApply(el, 'disabled')) {
                        if (!templateVars.hasOwnProperty('classes')) {
                            templateVars.classes = '';
                        }
                        templateVars.classes += ' disabled';
                    }

                    if (roomForButtons) {
                        $('.collapse-buttons .more-tab').before(_.template($('#templateGalleryActionButtons').html(), templateVars));
                        if ($('.collapse-buttons').width() > maxWidth) {
                            $('.collapse-buttons li:nth-last-child(2)').remove();
                            $('.collapse-buttons .more-tab ul').append(_.template($('#templateGalleryActionList').html(), templateVars));
                            roomForButtons = false;
                        }
                    } else {
                        $('.collapse-buttons .more-tab ul').append(_.template($('#templateGalleryActionList').html(), templateVars));
                    }

                    // populate right click menu
                    that.rcmenu.addMenuItem(_.template($('#templateGalleryActionList').html(), templateVars));
                }
            });

            // if the dropdown is initially closed, display the dropdown to compute its size
            var dropdownInitialStateClose = $('.collapse-buttons .more-tab a:not([aria-expanded="true"])').length;

            $('.collapse-buttons .more-tab').show();
            if (dropdownInitialStateClose) {
                $('.collapse-buttons .more-tab > a').click();
            }


            // determine whether to show the more button
            if ($('.collapse-buttons .more-tab ul').height() > 0) {
                $('.collapse-buttons .more-tab').show();
            } else {
                $('.collapse-buttons .more-tab').hide();
            }

            // hide the dropdown if it was initially hidden
            if (dropdownInitialStateClose) {
                $('.collapse-buttons .more-tab > a').click().blur();
            }

            // include disabled rules
            if ($('.album-header').hasClass('inception-reached')) {
                $('.js-current-album-add-sub').addClass('disabled');
            } else {
                $('.js-current-album-add-sub').removeClass('disabled');
            }
        };

        // update album sidebar height
        $(window).resize(function() {
            $('.sidebar-gallery').css('height', $(window).height() - 28);
            $('.sidebar-gallery-spacer').css('height', $(window).height() - 14);

            // trigger action buttons build on page load
            Sp.studio.buildGalleryActions();
        });

        if (Sp.studio.jsValues.archived) {
            $('#bd').addClass('archived');
        }

        // set status flags
        $('.status-flags > div').hide();
        if (Sp.studio.jsValues.archived) {
            $('.flag-archived').show();
        } else if (Sp.studio.jsValues.inactive) {
            $('.flag-inactive').show();
        } else if (Sp.studio.jsValues.preRegistration) {
            $('.flag-pre-registration').show();
        } else {
            $('.flag-active').show();
        }

        // init view mode
        $('#bd').addClass('display-albums');

        // header edit name
        that.inlineEditName({
            wrapperSelector: 'h3.gallery-title',
            placeholderText: 'Gallery Name',
            maxInputTextLength: 100,
            nameChangedCallback: function(name) {
                $.post(that.studioPanelUri('/gallery/updateeventname'),
                    {
                        event_id: that.jsValues.eventId,
                        name: name
                    },
                    function(data) {
                        that.hoverMessage.show(data.msg, data.status);
                    },
                    'json'
                );
            }
        });

        // position gallery cover preview by focal point
        if (that.jsValues.eventHasCoverPhoto === true) {

            that.focalPointBackgroundPosition($('.js-event-cover'), {
                url: that.jsValues.eventCoverPhoto.url,
                width: that.jsValues.eventCoverPhoto.width,
                height: that.jsValues.eventCoverPhoto.height,
                focalPoint: {
                    x: that.jsValues.eventCoverPhoto.focalPoint[0],
                    y: that.jsValues.eventCoverPhoto.focalPoint[1]
                }
            });

        }

        that.gallery.populateContactSidebar();

        // build album list
        that.gallery.populateAlbumSidebar();

        // init drag & drop
        that.gallery.makeAlbumsDroppable();

        // setup the scroll update
        that.gallery.scrollPhotoLoader();

        // display photos
        that.gallery.switchAlbum('a_all');

        $('body').on('click', '.switch-album', function(e) {
            e.stopPropagation();
            var albumId = $(this).data('switchAlbum');

            if (albumId === 'a_all') {
                $('#hideNoAlbumPhotos').iCheck('uncheck');
            }

            Sp.studio.gallery.switchAlbum(albumId);
        });

        $('body').on('click', '.js-deselect-all', function(e) {
            e.preventDefault();

            $('.ui-selected').removeClass('ui-selected');

            // update selection counts value and visibility
            that.gallery.updateMultiSelectCount();

            // reset draggable to account for changes in filtered elements
            that.gallery.initDraggable();

            // remove the selection history for shift + selects
            that.gallery.lastSelected = false;
        });

        $('body').on('click', '.js-create-contact', function (e) {
            var link = $(e.target).data('href');

            window.localStorage.setItem('sp-ref-studio-contract-for-new-gallery-flow', window.location.pathname.split('/')[window.location.pathname.split('/').length - 1]);
            window.location.href = link;
        });

        $('.album-header').on('ifChecked', '#hideNoAlbumPhotos', function () {
            that.gallery.updateAlbumHeader('noAlbum');
            that.gallery.appendPhotos('noAlbum');
        });
        $('.album-header').on('ifUnchecked', '#hideNoAlbumPhotos', function () {
            that.gallery.updateAlbumHeader('a_all');
            that.gallery.appendPhotos('a_all');
        });

        $('#linkContact').on('click', function (e) {
            e.preventDefault();

            that.loading('Loading Contacts', 'show');

            $.get(that.studioPanelUri('/contact/list'), {
                event_id: that.jsValues.eventId
            }, function (json) {

                that.loading('Loading Contacts', 'hide');

                that.modal({
                    title: 'Link a Contact',
                    body: _.template($('#templateLinkContact').html(), {
                        currentContactId: json.currentLinkContactId,
                        contacts: json.contacts
                    }),
                    sizeClass: 'modal-md',
                    open: function () {
                        $('#' + this.id).find('select').select2();
                        if (window.localStorage.getItem('sp-ref-gallery-link-contact-prompt-id')) {
                            $('#contactList').select2('val', window.localStorage.getItem('sp-ref-gallery-link-contact-prompt-id'), true);
                            window.localStorage.removeItem('sp-ref-gallery-link-contact-prompt-id');
                        }
                    },
                    buttons: [
                        {
                            label: 'Cancel',
                            close: true
                        },{
                            label: 'Save',
                            'class': 'btn-primary',
                            click: function () {

                                that.loading('Saving', 'show');
                                var contactId = $('#contactList').val();
                                $(this).parents('.modal').modal('hide');

                                $.post(that.studioPanelUri('/contact/updateeventlink'), {
                                    event_id: that.jsValues.eventId,
                                    contact_id: contactId
                                }, function (json) {
                                    that.loading('Saving', 'hide');
                                    that.hoverMessage.show(json.msg, json.status);

                                    if (json.status === 'success') {
                                        if (json.contact_name.length > 0) {
                                            that.jsValues.contact = json.contact_event_details;
                                            Sp.studio.gallery.populateContactSidebar();
                                            $('#linkContact').hide();
                                        }
                                    }
                                }, 'json');
                            }
                        }
                    ]
                });
            }, 'json');
        });

        // cover photo click handling
        $('body').on('click', '.js-event-cover, .js-current-album-cover', function () {
            var param = 'album';

            if ($(this).hasClass('js-event-cover')) {
                param = 'event';
            }

            Sp.studio.gallery.uploadAlbumCover(param);
        });

        $('body').on('change', '#albumCoverImage', function () {

            var files = this.files;
            var ext, file;

            if (!files.length) {
                return;
            }

            for (var i = 0; i < files.length; i++) {
                file = files[i].name;
                ext = file.substr((file.lastIndexOf('.') + 1)).toLowerCase();
                if (ext !== 'jpg' && ext !== 'jpeg') {
                    return;
                }
            }

            var albumId = ($('#uploadCoverAlbumType').val() === 'event') ? 'a_all' : that.gallery.currentSelection;

            $(this).parents('div.modal').modal('hide');
            that.loading('Uploading', 'show');

            var formData = new FormData();
            formData.append('event_id', that.jsValues.eventId);
            formData.append('album_id', albumId);
            formData.append('file', files[0]);

            $.ajax({
                url: that.studioPanelUri('/gallery/uploadcover'),
                cache: false,
                contentType: false,
                dataType: 'json',
                processData: false,
                async: true,
                data: formData,
                type: 'post',
                success: function(json) {

                    that.loading('Uploading', 'hide');

                    if (json.status === 'success') {
                        // update thumbnails
                        Sp.getObjectById(json.album.album_id, Sp.studio.jsValues.albums).coverPhoto = json.album.coverPhoto;
                        Sp.studio.gallery.updateCoverSelection(json.album.album_id);
                    } else {
                        that.hoverMessage.show(json.msg, json.status);
                    }
                }
            });
        });

        // add button click handling
        $('body').on('click', '.js-root-album-add-sub', function() {
            Sp.studio.gallery.switchAlbum('root');
            Sp.studio.gallery.returnToAllPhotos = true;
            $('.js-current-album-add-sub').click();
        });

        $('body').on('click', '.js-current-album-add-sub', function() {
            if (!$('body').hasClass('modal-open')) {
                Sp.studio.modal({
                    autoOpen: true,
                    title: 'Create a New Album',
                    sizeClass: 'modal-md',
                    body: _.template($('#templateNewAlbumDialog').html(), {
                        hasPhotos: ($('.album-header').is('.single-album.has-photos')),
                        firstAlbum: (that.jsValues.albums.length <= 3)
                    }),
                    close: function() {
                        if ((Sp.studio.gallery.currentSelection === 'root' && !Sp.studio.jsValues.albumAssociations.hasOwnProperty('root')) ||
                            Sp.studio.gallery.returnToAllPhotos) {

                            Sp.studio.gallery.switchAlbum('a_all');
                            Sp.studio.gallery.returnToAllPhotos = false;
                        }
                    },
                    buttons: [
                        {
                            label: 'Cancel',
                            close: true
                        },{
                            label: 'Add Album',
                            'class': 'btn-primary',
                            click: function() {
                                var name = $('#newAlbumName').val();

                                if ($.trim(name) === '') {
                                    return;
                                }

                                // success, attempting to create new album, stay on this page
                                Sp.studio.gallery.returnToAllPhotos = false;

                                $(this).parents('div.modal').modal('hide');
                                var parentId = Sp.numbersOnly(that.gallery.currentSelection);

                                $.post(that.studioPanelUri('/gallery/addalbum'), {
                                    event_id: that.jsValues.eventId,
                                    new_album_name: name,
                                    parent_album_id: parentId
                                }, function (data) {
                                    // cleanup data
                                    if (data.album.parentId === null) {
                                        data.album.parentId = 'root';
                                    } else {
                                        data.album.parentId = 'a' + data.album.parentId;
                                    }

                                    data.album.id = 'a' + data.album.id;

                                    if (data.status !== 'success') {
                                        that.hoverMessage.show(data.msg, data.status);
                                    }

                                    if (that.jsValues.albumAssociations.hasOwnProperty(data.album.parentId)) {
                                        that.jsValues.albumAssociations[data.album.parentId].push(data.album.id);
                                    } else {
                                        that.jsValues.albumAssociations[data.album.parentId] = [data.album.id];
                                        that.gallery.updateAlbumHeader(Sp.studio.gallery.currentSelection);
                                    }

                                    parentAlbum = Sp.getObjectById(data.album.parentId, Sp.studio.jsValues.albums);

                                    // default settings
                                    var album_totalPhotos = 0;
                                    var album_photo_ids;
                                    var album_photos;

                                    if (parseInt(parentAlbum.totalPhotos, 10)) {
                                        album_totalPhotos = parentAlbum.totalPhotos;
                                        album_photo_ids = parentAlbum.photo_ids;
                                        album_photos = parentAlbum.photos;

                                        parentAlbum.totalPhotos = 0;
                                        parentAlbum.photo_ids = undefined;
                                        parentAlbum.photos = undefined;
                                    }

                                    that.jsValues.albums.push({
                                        id: data.album.id,
                                        hasCoverPhoto: false,
                                        coverPhoto: that.gallery.generateEmptyCoverPhotoObject(),
                                        displayOrder: null,
                                        loaded: false,
                                        name: data.album.name,
                                        parentId: data.album.parentId,
                                        password: null,
                                        totalPhotos: album_totalPhotos,
                                        photo_ids: album_photo_ids,
                                        photos: album_photos
                                    });

                                    that.gallery.populateAlbumSidebar();
                                    $('#allPhotos > ul.photos-view').hide();
                                    $('#allPhotos > ul.sub-albums-view').html('').show().append(that.gallery.buildAlbumChildren(data.album.parentId));

                                    that.gallery.setAlbumCovers();
                                    that.gallery.updateAlbumHeader(that.gallery.currentSelection);

                                    // init drag & drop
                                    that.gallery.makeAlbumsDroppable();
                                }, 'json');
                            }
                        }
                    ],
                    shown: function() {
                        $('.modal input').focus();
                    }
                });
            } else {
                // caught duplicate modal exception
                if (window.console && console.warn) {
                    console.warn('Warning: js-current-album-add-sub called with modal open.');
                }
            }
        });

        $('.album-header .password-protected').click(that.gallery.setAlbumPassword);

        // dropdown selection handling / delegate
        $('body').on('click', '.album-header .btn-container a:not(.skip):not(.disabled), #rcmenu a:not(.skip):not(.disabled), a.gallery-action-aux', function(e) {
            e.preventDefault();

            that.rcmenu.hide();

            switch ($(this).data('action')) {
                case 'add-photo':
                    that.gallery.addPhotoToAlbum(this);
                    break;
                case 'set-password':
                    that.gallery.setAlbumPassword();
                    break;
                case 'download-photos':
                    that.gallery.bulkDownloadPhotos($('#allPhotos > ul.photos-view div.ui-selected')[0]);
                    break;
                case 'create-mobile-app':
                    that.gallery.createMobileApp();
                    break;
                case 'delete-photos':
                    that.gallery.bulkDeletePhotos($('#allPhotos > ul.photos-view div.ui-selected'));
                    break;
                case 'sort-alpha':
                    that.gallery.sortAlbumsAlpha();
                    break;
                case 'generate-passwords':
                    that.gallery.generateAlbumPasswords();
                    break;
                case 're-watermark-all':
                    that.gallery.reWatermarkPhotos();
                    break;
                case 'delete-album':
                    that.gallery.deleteAlbum();
                    break;
                case 'delete-all':
                    that.gallery.deleteAllPhotos();
                    break;
                case 'download-all':
                    that.gallery.downloadAllPhotos();
                    break;
                case 'set-album-cover':
                    that.gallery.setPhotoAsAlbumCover();
                    break;
                case 'upload-album-cover':
                    that.gallery.uploadAlbumCover('album');
                    break;
                case 'set-event-cover':
                    that.gallery.setPhotoAsGalleryCover();
                    break;
                case 'download-photo':
                    that.gallery.bulkDownloadPhotos();
                    break;
                case 'rename-photo':
                    that.gallery.renamePhoto();
                    break;
                case 'remove-from-album':
                    that.gallery.removePhotoFromAlbum();
                    break;
                case 'delete-photo':
                    that.gallery.bulkDeletePhotos($('#allPhotos > ul.photos-view div.ui-selected'));
                    break;
                case 'download-album-link':
                    that.gallery.getDownloadLink();
                    break;
            }
        });

        /**
         * Check for contact, pull data and subsequently load contact into cache
         */
        if (!that.contactCache) {
            that.contactCache = [];
        }
        $('.main-content').on('mouseenter', '#contactDetails .contact-name', function (e) {
            var contactId = $(e.currentTarget).data('contactId');
            var customerCard = $(e.currentTarget).find('.customer-card-container');

            setTimeout(function () {
                if ($(e.target).is(':hover') && contactId) {

                    if (!that.contactCache[contactId]) {

                        that.contactCache[contactId] = "pending response...";

                        getContact(contactId, function (contact) {
                            that.contactCache[contactId] = (contact) ? contact : "no contact exists";
                            if (contact && contact.email) {
                                customerCard.html(_.template($('#templateContactCard').html(), {contact: contact}));
                            }

                            bindContactCardEvents();

                        });
                    } else {
                        var contact = that.contactCache[contactId];

                        if (contact && contact.email) {
                            customerCard.html(_.template($('#templateContactCard').html(), {contact: contact}));
                        }

                        bindContactCardEvents();

                    }

                }

            }, 300);
        });

        $('.customer-card-container').click(function (ev) {
            ev.stopPropagation();
        });

        // prompt for contact link
        if (window.localStorage.getItem('sp-ref-gallery-link-contact-prompt-id')) {
            $('#linkContact').click();
        }

        function bindContactCardEvents() {
            $('.customer-card-container .js-link-contact-view').off().on('click', function (ev) {
                var customerCard = $(ev.target).parents('.contact-name');
                var contactId = customerCard.data('contactId');
                var baseUri = customerCard.data('contactLink');

                window.location.href = baseUri + contactId;
            });

            $('.customer-card-container .js-link-contact-email').off().on('click', function (ev) {
                var customerCard = $(ev.target).parents('.contact-name');
                var contactId = customerCard.data('contactId');
                var baseUri = customerCard.data('contactLink');

                window.location.href = baseUri + contactId + '/email';
            });
        }

        function getContact(id, callback) {
            $.ajax({
                type: "GET",
                url: Sp.urls.api + "/brand/" + Sp.studio.brandId + "/contact/" + id,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', Sp.studio.studioV3DataToken);
                },
                success: function (data) {
                    callback(data);
                }
            });
        }
    },

    monitorScrollPosition: function (breakpoint) {
        if (!breakpoint || breakpoint <= 0) {
            breakpoint = 80;
        }
        $(window).off('scroll').on('scroll', function() {
            if ($(window).scrollTop() >= breakpoint) {
                $('body').addClass('scrolled');
            } else {
                $('body').removeClass('scrolled');
            }
        });
    },

    gallerySettingsCommon: function () {
        var that = this;

        // init sticky headers
        this.monitorScrollPosition(18);

        // setup scrollspy
        $('body').scrollspy({target: '.settings-view-scrollspy'});

        // protect from [enter] form submissions
        that.formSubmit = false;
        $('#settingsForm').on('submit', function (e) {
            if (!that.formSubmit) {
                e.preventDefault();
                return false;
            }
        });

        function submitSettingsForm() {
            that.formSubmit = true;
            $('#settingsForm').submit();
        }

        function showActiveButExpiredModal() {
            that.modal({
                title: 'Gallery is Expired',
                body: $('#activeButExpired').html(),
                sizeClass: 'modal-md',
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Save and Activate',
                        'class': 'btn-primary',
                        click: function () {
                            $('.modal').modal('hide');
                            $('#gallery_expiration_date').val('');
                            submitSettingsForm();
                        }
                    }
                ]
            });
        }

        $('#submit, #submit2').on('click', function () {
            var galleryExpirationDate = $('#gallery_expiration_date').data('datepicker');
            var isExpired = galleryExpirationDate && galleryExpirationDate.getDate().getTime() < new Date().getTime();
            var isActive = $('#event_status_id').val() === '1';
            if (isExpired && isActive) {
                // Form submission handled in modal in this case
                showActiveButExpiredModal();
            } else {
                submitSettingsForm();
            }
        });


        // Gallery Intro
        that.editor('#intro_text', {
            minHeight: 200,
            maxHeight: 400
        });

        // display first error
        if (Sp.studio.jsValues.firstFormError) {
            var firstErrorPage = $('#' + Sp.studio.jsValues.firstFormError).parents('.gallery-settings-page').attr('id');
            $('.setting-tab[data-page="' + firstErrorPage + '"]').click();
        }

        // general / basics --

        $('#release_date').change(function() {
            if ($('#gallery_expiration_date').data('datepicker').getFormattedDate('yyyy-mm-dd') < $('#release_date').data('datepicker').getFormattedDate('yyyy-mm-dd')) {
                $('#gallery_expiration_date').val($('#release_date').data('datepicker').getFormattedDate('yyyy-mm-dd'));
            }
            $('#gallery_expiration_date').datepicker('setStartDate', $('#release_date').val());
        });

        new Clipboard('.copy-to-clipboard');
        $('#url_slug').on('blur', function () {
            // NOTE: with the first regexp group, caret, backtick,
            // backslash, and brackets weren't being removed, so let's place
            // those specific characters in an OR condition so we can be
            // sure they are removed.
            $(this).val($(this).val().replace(/([^0-9a-zA-z.&\-+_]|[\^`\\\[\]])/g, ""));
        });

        var baseUrl = $('.copy-to-clipboard').attr('data-clipboard-text');
        var slug = $('#url_slug').val();

        if (slug === '') {
            var galleryId = $('#settingsForm').attr('action').split('settings/')[1];
            slug = 'gallery/' + galleryId;
        }

        $('.copy-to-clipboard').attr('data-clipboard-text', baseUrl + slug);

        $("#url_slug").keyup(function(){
            slug = $('#url_slug').val();

            if (slug.length === 0) {
                var galleryId = $('#settingsForm').attr('action').split('settings/')[1];
                slug = 'gallery/' + galleryId;
            }

            $('.copy-to-clipboard').attr('data-clipboard-text', baseUrl + slug);
        });

        // access & privacy --

        this.updateEventPasswordVisibility();

        $('#access_level').change(function() {Sp.studio.updateEventPasswordVisibility()});

        // gallery --

        // drive setting dependencies
        $('#social_sharing').on('ifChecked ifUnchecked', function() {
            if (!$('#social_sharing').is(':checked')) {
                $('#custom_social_message').attr('disabled', 'disabled');
                $('.requires-social_sharing').addClass('disabled');
            } else {
                $('#custom_social_message').removeAttr('disabled');
                $('.requires-social_sharing').removeClass('disabled');
            }
        }).trigger('ifChecked');

        $('input[name="landing_layout_type"]').on('ifChecked', function () {
            if ($(this).is(':checked')) {
                $('#jsLandingLayoutTypeDemo').removeClass().addClass($(this).val());
            }
        });

        $('input[name="view_type"]').on('ifChecked', function () {
            if ($(this).is(':checked')) {
                $('#jsViewTypeDemo').removeClass().addClass($(this).val());
            }
        });

        $('input[name="landing_layout_type"]:checked').trigger('ifChecked');
        $('input[name="view_type"]:checked').trigger('ifChecked');

        // prints & digitals --

        $('#price_sheet_id').change(function() {
            if ($('#price_sheet_id').val() === '') {
                $('.requires-pricesheet').prop('disabled', true).addClass('disabled').parents('.icheckbox_flat-sp').addClass('disabled');
            } else {
                $('.requires-pricesheet').prop('disabled', false).removeClass('disabled').parents('.icheckbox_flat-sp').removeClass('disabled');
            }
        }).change();

        $('#free_digitals').on('ifChecked ifUnchecked', function() {
            if (!$(this).is(':checked')) {
                $('.requires-free_digitals').addClass('disabled').find('input, textarea').prop('disabled', true);
            } else {
                $('.requires-free_digitals').removeClass('disabled').find('input, textarea').prop('disabled', false);
            }
        }).trigger('ifChecked');

        if ($('#free_digitals_pin').val() !== '') {
            $('#require_pin_toggle').iCheck('check');
        }

        $('#require_pin_toggle').on('ifChecked ifUnchecked', function () {
            if (!$(this).is(':checked')) {
                $('#free_digitals_pin').prop('disabled', true);
                $('#free_digitals_pin').val('');
            } else {
                $('#free_digitals_pin').prop('disabled', false);
            }
        }).trigger('ifChecked');

        // advanced --

        // update display based on current form values
        if ($('#studio_homepage_link_visible').prop('checked')) {
            $('.logo-link-to').addClass('active');

            if ($('#logo_link_to-studiohomepage').prop('checked')) {
                $('#studio_logo_link-one').prop('checked', true);
            } else {
                $('#studio_logo_link-two').prop('checked', true);
            }
        } else {
            $('#studio_logo_link-off').prop('checked', true);
        }
        $('.studio_logo_link-list input').each(function(i, v) {
            $(v).iCheck('update')
        });

        $('label[for="studio_logo_link-one"]').html($('label[for="logo_link_to-studiohomepage"]').html());
        $('label[for="studio_logo_link-two"]').html($('label[for="logo_link_to-studiowebsite"]').html());

        // drive form values based on display changes
        $('.studio_logo_link-list input').on('ifChecked', function() {
            if ($(this).is('#studio_logo_link-off')) {
                $('#studio_homepage_link_visible').prop('checked', false);
            } else if ($(this).is('#studio_logo_link-one')) {
                $('#studio_homepage_link_visible').prop('checked', true);
                $('#logo_link_to-studiohomepage').iCheck('check');
            } else if ($(this).is('#studio_logo_link-two')) {
                $('#studio_homepage_link_visible').prop('checked', true);
                $('#logo_link_to-studiowebsite').iCheck('check');
            }
        });
    },

    handleGallerySettings: function () {
        this.gallerySettingsCommon();

        // Money-only setup
        $('body').on('blur', 'input.money-only', function () {
            var val = Sp.moneyOnly($(this).val(), true);

            if (val === '') {
                if ($(this).hasClass('allow-empty')) {
                    return;
                } else {
                    val = '0.00';
                }
            }

            val = parseFloat(val);

            $(this).val(val.toFixed(2));
        });
    },

    handleGalleryContactSettings: function () {
        var that = this;

        $('#submit').on('click', function () {
            $('#contactSettings').submit();
        });

        var tagData = JSON.parse($('#tags').val());

        $('#tagList').html(_.template($('#templateTagList').html(), {tags: tagData}));

        var showAddRow = function () {
            if ($('li.sortable').length < 6) {
                $('.add').parents('li').show();
            }
        };

        var updateTagOrder = function () {
            var rows = [];
            var rowId;

            $('li.sortable').each(function () {
                var input = $(this).find('input');
                rowId = $(input).attr('name');

                if (rowId === 'new_tags[]') {
                    rowId = 'new_tag';
                }

                rows.push({
                    id: rowId,
                    name: $(input).val()
                });

                $('#tags').val(JSON.stringify(rows));
            });
        };

        var makeSortable = function () {
            $('#tagList').sortable({
                axis: 'y',
                containment: false,
                tolerance: 'pointer',
                items: 'li.sortable',
                handle: '.handle',
                distance: 1,
                stop: function () {
                    updateTagOrder();
                }
            });
        };

        $('#tagList').on('click', '.add', function (e) {
            e.preventDefault();

            var rowCopy = $(this).parents('li').clone();
            rowCopy.addClass('sortable');
            rowCopy.find('.add').remove();
            rowCopy.find('.handle.empty').remove();
            rowCopy.find('.hidden').removeClass('hidden');
            rowCopy.find('input').attr('disabled', false);

            if ($('li.sortable').length) {
                rowCopy.insertAfter('li.sortable:last');
            } else {
                rowCopy.prependTo('#tagList');
            }

            updateTagOrder();
            makeSortable();

            if ($('li.sortable').length >= 6) {
                $('.add').parents('li').hide();
            }
        });

        $('#tagList').on('click', '.remove', function () {

            if ($(this).parents('li').find('input').attr('name') == 'new_tags[]') {
                $(this).parents('li').remove();
                showAddRow();
                updateTagOrder();
                makeSortable();
                return;
            } else {
                var row = this;

                that.modal({
                    title: 'Remove Label',
                    body: $('#templateRemoveTag').html(),
                    sizeClass: 'modal-md',
                    buttons: [
                        {
                            label: 'Cancel',
                            close: true
                        },{
                            label: 'Yes, Remove',
                            'class': 'btn-danger',
                            click: function () {
                                $('.modal').modal('hide');
                                $(row).parents('li').remove();
                                showAddRow();
                                updateTagOrder();
                                makeSortable();
                            }
                        }
                    ]
                });
            }
        });

        $('#tagList').on('keyup', 'input', function () {
            $(this).val($(this).val().replace(/[^\d\s\w\-]/g, ''));
            updateTagOrder();
        });

        makeSortable();

        $('.js-unlink-contact').on('click', function (e) {
            e.preventDefault();

            that.modal({
                title: 'Remove Linked Contact',
                body: $('#templateUnlinkContact').html(),
                sizeClass: 'modal-md',
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Yes, Remove',
                        'class': 'btn-danger',
                        click: function () {
                            $('.modal').modal('hide');
                            that.loading('Unlinking Contact', 'show');
                            self.location.href = that.studioPanelUri('/gallery/unlinkcontact') + '?event_id=' + that.jsValues.eventId + '&contact_id=' + that.jsValues.contactId;
                        }
                    }
                ]
            });
        });
    },

    handleEmailActivity: function () {
        var that = this;

        this.setupDatagridFilter();

        $('body').on('click', 'a.history-link', function(e) {
            e.preventDefault();

            var emailToken = $(this).attr('data-email-token');
            var row = $('div.tr[data-email-token="' + emailToken + '"]');

            // slide up the current items
            if (row.find('div.detail-info:not(:hidden)').length) {
                row.find('div.detail-info').slideUp(300);
            } else {
                if (row.data('loaded') === '1') {
                    // show the details now
                    //row.find('div.detail-info').slideDown(300);
                } else {
                    $.post(that.studioPanelUri('/email/getinfo'), {
                        email_token: emailToken
                    }, function (json) {
                        row.data('loaded', '1');
                        row.find('div.subject div.detail-info *').remove();
                        row.find('div.subject div.detail-info').html(json.actions);
                        //row.find('div.detail-info').slideDown(300);

                        $('.modal .loading-placeholder').parent().html(row.find('div.detail-info').html());
                    }, 'json');
                }
            }

            that.modal({
                title: row.find('.td.subject').html(),
                body: _.template($('#templateLoadingPlaceholder').html(), {height: '300px'})
            });

            if (row.data('loaded') === '1') {
                $('.modal .loading-placeholder').parent().html(row.find('div.detail-info').html());
            }
        });

        $('body').on('click', 'a.view-email-body', function (e) {
            e.preventDefault();

            that.loading('Loading', 'show');

            $.post(that.studioPanelUri('/email/loademail'),
                {
                    token: $(this).attr('data-email-token')
                },
                function (json) {

                    that.loading('Loading', 'hide');

                    if (json.found) {
                        that.modal({
                            title: json.subject,
                            sizeClass: 'modal-emailbody',
                            body: json.body,
                            open: function () {
                                // Disable the unsubscribe link in the preview
                                $('#unsubscribe').removeAttr('target');
                                $('#unsubscribe').attr('href', '#');
                                $('#unsubscribe').click(function (event) {
                                    event.preventDefault();
                                });
                            },
                            buttons: [
                                {
                                    label: 'Close',
                                    'class': 'btn-primary',
                                    close: true
                                }
                            ]
                        });

                    } else {

                        that.modal({
                            title: 'Not Available at this Time',
                            body: '<p>The email message is not stored for this email.',
                            buttons: [
                                {
                                    label: 'Close',
                                    'class': 'btn-primary',
                                    close: true
                                }
                            ]
                        });
                    }

                }, 'json');
        });
    },

    handleOrderApprove: function () {
        var that = this;
        var updateDisabled = true;

        $('#accordion .panel-heading[data-toggle="collapse"]').on('click', function(e) {
            e.preventDefault();
            $(this).find('input:radio').iCheck('check');

            if ($(this).parents('.panel').children('.panel-collapse').hasClass('in')) {
                e.stopPropagation();
            }
        });

        $('#boutiquePackaging').on('change', function () {

            $('#boutiquePackagingSample').hide();

            if (this.value !== '') {
                var option = $(this).find('option:selected').first();
                if (option.data('image') !== '') {

                    $('#boutiquePackagingSample')
                        .attr('href', option.data('image'))
                        .attr('data-title', option.text())
                        .show();
                }
            }

            if (!updateDisabled) {
                updateLabSummary();
            }
        }).trigger('change');

        $('#colorCorrect, #softProof').on('ifToggled', function () {
            updateLabSummary();
        });

        $('#shippingMethod').on('change', function () {
            if (!updateDisabled) {
                checkIfShippingAllowsBoutiquePackaging();
                updateLabSummary();
            }
        });

        var restrictedCities = {};
        var restrictedStates = {};
        var shippingMethods = [];

        $('#shippingMethod option').each(function (i, el) {
            var tmp = {
                id: $(el).attr('value'),
                name: $(el).text(),
                price: $(el).data('price'),
                method_constant: $(el).data('methodConstant'),
                only_city_list: $(el).data('onlyCityList'),
                only_state_list: $(el).data('onlyStateList'),
                country_code: $(el).data('countryCode'),
                city_list: $(el).data('onlyCityList'),
                state_list: $(el).data('onlyStateList'),
                disallows_boutique_packaging: Boolean($(el).data('disallowsBoutiquePackaging'))
            };

            if (tmp.only_city_list !== '' && tmp.only_city_list !== null) {
                if (!restrictedCities.hasOwnProperty(tmp.country_code)) {
                    restrictedCities[tmp.country_code] = [];
                }

                restrictedCities[tmp.country_code] = tmp.only_city_list.split(',');
                tmp.city_list = tmp.only_city_list.split(',');
            }

            if (tmp.only_state_list !== '' && tmp.only_state_list !== null) {
                if (!restrictedStates.hasOwnProperty(tmp.country_code)) {
                    restrictedStates[tmp.country_code] = [];
                }

                restrictedStates[tmp.country_code] = tmp.only_state_list.split(',');
                tmp.state_list = tmp.only_state_list.split(',');
            }

            shippingMethods.push(tmp);
        });

        // bind the address form for the alternate country field
        $('#city').on('keyup', function () {
            addressChange();
        });

        $('#state').on('change', function () {
            addressChange();
        });

        $('#country').on('change', function () {
            addressChange();
        });

        $('input:radio').on('ifChecked', function () {
            addressChange();
        })

        $('input:radio').on('ifClicked', function () {
            $(this).parents('.panel-heading').trigger('click');
        });

        this.watchCountryStateField({
            citySelector: '#city',
            stateDropdownSelector: '#state',
            stateOtherSelector: '#state_other',
            countrySelector: '#country',
            zipCodeSelector: '#zip_postal',
            zipCodeFieldNames: this.jsValues.zipCodeFieldNames,
            cityFieldNames: this.jsValues.cityFieldNames,
            countryNoState: this.jsValues.countryNoState
        });

        var updateShippingMethodOptions = function (countryId, state, city) {

            // we only need to change this if the countries are different
            $('#shippingMethod').empty();
            var cityOnly = false;
            city = $.trim(city);
            city = city.toLowerCase();

            if (city !== '' & restrictedCities.hasOwnProperty(countryId)) {
                for (var i = 0; i < restrictedCities[countryId].length; i++) {
                    if (restrictedCities[countryId][i].toLowerCase() === city) {
                        cityOnly = true;
                        break;
                    }
                }
            }

            var compiledOptions = {};

            _.each(shippingMethods, function (option) {
                if (option.country_code === countryId ||
                    option.country_code === '') {

                    if (!cityOnly && option.city_list.length > 0) {
                        return;
                    } else if (cityOnly) {
                        var tmpCities = option.city_list;
                        var found = false;

                        for (var s = 0; s < tmpCities.length; s++) {
                            if (tmpCities[s].toLowerCase() === city) {
                                found = true;
                                break;
                            }
                        }

                        if (!found) {
                            return;
                        }
                    }

                    if (option.state_list.length > 0) {
                        if (option.state_list.indexOf(countryId + '_' + state) === -1) {
                            return;
                        }
                    }

                    if (!compiledOptions.hasOwnProperty(option.method_constant)) {
                        compiledOptions[option.method_constant] = [];
                    }

                    compiledOptions[option.method_constant].push(option);
                }
            });

            _.each(compiledOptions, function (options) {

                var option = options[0];

                if (options.length > 1) {

                    var lowestOption = options[0];

                    _.each(options, function (tmpOption) {
                        if (tmpOption.price < lowestOption.price) {
                            lowestOption = tmpOption;
                        }
                    });

                    option = lowestOption;
                }

                $('#shippingMethod').append($('<option></option>')
                    .attr('value', option.id)
                    .text(option.name));
            });

            $('#shippingMethod').select2('destroy');

            if (that.jsValues.userSelectedLabShippingCode) {
                $('#shippingMethod').val(that.jsValues.userSelectedLabShippingCode);
            }

            if ($('#shippingMethod').val() === '' || $('#shippingMethod').val() === null) {
                $('#shippingMethod').val($('#shippingMethod option').first().val());
            }

            $('#shippingMethod').select2();

            if (!updateDisabled) {
                checkIfShippingAllowsBoutiquePackaging();
                updateLabSummary();
            }
        };

        var addressChange = function () {

            var addressType = $('input[type="radio"]:checked');
            var countryId;
            var stateId;
            var city;

            if (addressType.val() === 'alternate') {
                countryId = $('#country').val();
                stateId = $('#state').val();
                city = $('#city').val();
            } else {
                countryId = addressType.data('countryCode');
                stateId = addressType.data('state');
                city = addressType.data('city');
            }

            updateShippingMethodOptions(countryId, stateId, city);
        };

        var updateLabSummary = function () {
            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/order/labsummary'), 'order_labsummary'), {
                order_id: Sp.studio.jsValues.order.id,
                shipping_method: $('#shippingMethod').val(),
                boutique_packaging_option_id: (($('#boutiquePackaging').length) ? $('#boutiquePackaging').val() : 0),
                soft_proof_photos: (($('#softProof')) ? ($('#softProof').is(':checked') ? 1 : 0) : 0),
                color_correct_photos: (($('#colorCorrect')) ? ($('#colorCorrect').is(':checked') ? 1 : 0) : 0)
            }, function (json) {
                $('#orderSummary').html(_.template($('#templateOrderSummary').html(), {
                    labSummary: json,
                    hasProfit: json.profit !== json.zeroAmountString && json.balanceDue === json.zeroAmountString
                }));
            }, 'json');
        };

        // make sure we have at least one address type checked
        if ($('input:radio:checked').length === 0) {
            $($('input:radio:not(:disabled)').first()).iCheck('check');
        }

        // make sure the correct detail pane is shown
        $('input:radio:checked').parents('div.panel').find('div.panel-collapse').addClass('in');

        addressChange();
        checkIfShippingAllowsBoutiquePackaging();
        updateLabSummary();

        updateDisabled = false;
        let skipTaxCheck = false;

        $('#order').on('submit', (e) => {
            let error = false;
            $('#submitToLabButton').attr('disabled', true);
            $('#cropError').hide();
            $('#approveCrops').parents('div.checkbox').removeClass('error');

            if (!$('#approveCrops').is(':checked')) {
                error = true;
                $('#cropError').show();
            }

            let params = {};
            params.address_type = $('input[type="radio"]:checked').val();

            if (params.address_type === 'alternate') {

                if ($('#name').val().trim() === '') {
                    error = true;
                    $('#nameError').show();
                } else {
                    $('#nameError').hide();
                }

                if ($('#streetLine1').val().trim() === '') {
                    error = true;
                    $('#streetLine1Error').show();
                } else {
                    $('#streetLine1Error').hide();
                }

                if ($('#city').val().trim() === '') {
                    error = true;
                    $('#cityError').show();
                } else {
                    $('#cityError').hide();
                }

                if ($('#state').val().trim() === '' && $('#state').parents('.form-group').is(':visible')) {
                    error = true;
                    $('#stateError').show();
                } else {
                    $('#stateError').hide();
                }

                if ($('#postalCode').val().trim() === '') {
                    error = true;
                    $('#postalCodeError').show();
                } else {
                    $('#postalCodeError').hide();
                }
            }

            if (error) {
                e.preventDefault();
                $('#submitToLabButton').attr('disabled', false);
                that.scrollToFirstFormError();
                return;
            }

            if (Sp.studio.jsValues.order.is_automatic_sales_tax && params.address_type !== 'client' && !skipTaxCheck) {
                e.preventDefault();

                $.get(that.studioPanelUri('/order/getSalesTaxForAddress'), {
                    order_id: Sp.studio.jsValues.order.id,
                    radio: params.address_type,
                    ...(params.address_type === 'alternate' ? {
                        name: document.getElementById('name')?.value,
                        street_line_1: document.getElementById('streetLine1')?.value,
                        street_line_2: document.getElementById('streetLine2')?.value,
                        city: document.getElementById('city')?.value,
                        state_province: document.getElementById('state')?.value,
                        country: document.getElementById('country')?.value,
                        postal_code: document.getElementById('postalCode')?.value
                    } : {})
                }, function (json) {
                    const { needsConfirmation, originalSalesTax, taxDifference, updatedSalesTax } = json;

                    if (!needsConfirmation) {
                        skipTaxCheck = true;
                        const approveForm = document.getElementById('order');

                        approveForm?.submit();
                        return;
                    }
                    
                    const reSubmitOrderApproval = () => {
                        const approveForm = document.getElementById('order');

                        const requiresTaxUpdateInput = approveForm.elements[
                            'requires_tax_update'
                        ];
        
                        if (requiresTaxUpdateInput) {
                            requiresTaxUpdateInput.value = 'true';
                        }
        
                        approveForm?.submit();
        
                        Sp.studio.loading('Submitting Order', 'show');
        
                        const submitButton = document.getElementById(
                            'submitToLabButton'
                        );
        
                        submitButton?.setAttribute('disabled', 'true');
                    }

                    Sp.v2ReactBridge.showUpdatedSalesTaxConfirmationModal({
                        onConfirm: reSubmitOrderApproval,
                        originalSalesTax,
                        taxDifference,
                        updatedSalesTax,
                    });

                    $('#submitToLabButton').attr('disabled', false);
                }, 'json');

                return;
            }

            Sp.studio.loading('Submitting Order', 'show');
        });

        function checkIfShippingAllowsBoutiquePackaging() {
            const selectedShippingMethodId = $('#shippingMethod').val();
            const shippingMethod = shippingMethods.find(function (shippingMethod) {
                return shippingMethod.id === selectedShippingMethodId;
            });

            if (shippingMethod.disallows_boutique_packaging) {
                $('#boutiquePackaging')
                    .val(null)
                    .attr('disabled', '')
                    .trigger('change');
                $('.approve-section .boutique').show();
            } else {
                $('#boutiquePackaging').removeAttr('disabled');
                $('.approve-section .boutique').hide();
            }
        }
    },

    handleOrderIndex: function () {
        var that = this;

        this.setupDatagridFilter();

        // handle disabling or enabling the bulk actions
        $('.row-select').on('ifChecked ifUnchecked', function() {
            if ($('.row-select:checked').length > 1) {
                $('#startBulkActions').css('display', 'inline-block');
            } else {
                $('#startBulkActions').hide();
            }
        });

        $('.icon-comment-container[data-order-id]').each((i, el) => {
            window.Sp.v2ReactBridge.showOrderCommentIndicator(el, {
                children: el.children,
                placement: 'top',
                tooltipLabel: 'Items in this order contain comments'
            });
        });

        $('ul.dropdown-menu.bulk-actions a').on('click', function (e) {
            e.preventDefault();

            var selectedIds = [];
            $('#orders .td:first-child input:checkbox:checked:not(.skip,.switch)').each(function (i, val) {
                selectedIds.push($(val).val());
            });

            var total = selectedIds.length;
            var action = $(this).attr('data-action');

            if (total === 0) {
                that.modal({
                    title: 'No Orders Selected',
                    body: _.template($('#templateNoOrdersSelected').html(), {}),
                    sizeClass: 'modal-md',
                    buttons: [{
                        label: 'Ok',
                        'class': 'btn-primary',
                        close: true
                    }]
                });
                return;
            }

            // is this studio trying to combine orders?
            if (action === 'combine') {

                Sp.studio.loading('Checking Orders', 'show');

                $.post(that.studioPanelUri('/order/checkforlabs'), {
                    order_ids: selectedIds.join(',')
                }, function (json) {
                    Sp.studio.loading('Checking Orders', 'hide');

                    var error = false;
                    var title, body;

                    if (json.multipleLabs) {

                        error = true;
                        title = 'Error: Multiple Labs Detected';
                        body = _.template($('#templateCombineMultipleLabs').html(), {});

                    } else if (json.multiplePaymentGatewaysWithSpPay) {
                        error = true;
                        title = 'Error: Multiple Gateways Detected';
                        body = _.template($('#templateCombineMultipleGateways').html(), {});

                    } else if (!json.correctStatus) {

                        error = true;
                        title = 'Error: Lab Progress issue';
                        body = _.template($('#templateCombineWrongStatus').html(), {});

                    } else if (json.alreadyCombined.length > 0) {

                        error = true;
                        title = 'Error: Already Combined';
                        body = _.template($('#templateCombineAlreadyCombined').html(), {
                            orderNumString: json.alreadyCombined.join(', ')
                        });

                    } else if (json.nonLabOrders.length > 0) {

                        error = true;
                        title = 'Error: Non-lab Order';
                        body = _.template($('#templateCombineNonLabOrders').html(), {
                            orderNumString: json.nonLabOrders.join(', ')
                        });
                    }

                    if (error) {
                        that.modal({
                            title: title,
                            body: body,
                            sizeClass: 'modal-md',
                            buttons: [{
                                label: 'Ok',
                                'class': 'btn-primary',
                                close: true
                            }]
                        });
                        return;
                    }

                    function captureFundsForOrders(orderIds) {
                        $.post(
                            that.studioPanelCsrfWrapper(that.studioPanelUri('/order/capturefunds'), 'order_combineorders'),
                            { order_ids: orderIds },
                            function (captureResponse) {
                                var response = captureResponse.response;

                                var failedOrders = response.filter(function(order) {
                                    return order.status === 'failed';
                                });

                                var successfulOrders = response.filter(function(order) {
                                    return order.status === 'succeeded';
                                });

                                if(failedOrders.length > 0) {
                                    Sp.studio.loading('Combining Orders', 'hide');

                                    setTimeout(() => {
                                        window.Sp.v2ReactBridge.showCombineOrdersFailureModal({
                                            orders: response,
                                            onClose: function() {
                                                self.location.href = self.location.href;
                                            },
                                            onCombineOrders: function() {
                                                var successfulOrderIds = successfulOrders.map(function(order) {
                                                    return order.id;
                                                }).join(',');

                                                postCombineOrders(successfulOrderIds);
                                            }
                                        });
                                    }, 0);
                                } else {
                                    postCombineOrders(orderIds);
                                }
                            }
                        );
                    }

                    function postCombineOrders(orderIds) {
                        $.post(
                            that.studioPanelCsrfWrapper(that.studioPanelUri('/order/combineorders'), 'order_combineorders'),
                            { order_ids: orderIds },
                            function () {
                                self.location.href = self.location.href;
                            },
                            'json'
                        );
                    }

                    that.modal({
                        title: 'Create Combined Order?',
                        body: _.template($('#templateCombineConfirm').html(), {
                            numOrders: selectedIds.length
                        }),
                        sizeClass: 'modal-md',
                        buttons: [
                            {
                                label: 'Cancel',
                                close: true
                            },{
                                label: 'Create Combined Order',
                                'class': 'btn-primary',
                                click: function () {
                                    $(this).parents('div.modal').modal('hide');
                                    Sp.studio.loading('Combining Orders', 'show');

                                    captureFundsForOrders(selectedIds.join(','));
                                }
                            }
                        ]
                    });

                }, 'json');

            } else if (action === 'print') {

                window.open(that.studioPanelUri('/order/print') + '?bulk=1&ids=' + selectedIds.join(','), 'PrintWindow', 'width=800,height=600,menubar=1,resizable=1');

            } else {

                that.modal({
                    title: 'Confirm Bulk Action',
                    body: _.template($('#templateBulkConfirm').html(), {
                        numOrders: total
                    }),
                    sizeClass: 'modal-md',
                    buttons: [
                        {
                            label: 'Close',
                            close: true
                        },{
                            label: 'Yes, Apply',
                            'class': 'btn-primary',
                            click: function () {
                                $(this).parents('div.modal').modal('hide');
                                Sp.studio.loading('Apply Actions', 'show');
                                $('#bulkAction').val(action);
                                $('#orders').submit();
                            }
                        }
                    ]
                });
            }
        });

        /**
         * Check for contact, pull data and subsequently load contact into cache
         */
        if (!that.contactCache) {
            that.contactCache = {};
        }
        $('.customer-email').parent().hover(function (e) {
            var email = $(e.target).find('.customer-email').data('email');
            var customerCard = $(e.target).find('.customer-card-container');

            setTimeout(function () {

                if ($(e.target).is(':hover')) {

                    if (!that.contactCache[email]) {

                        that.contactCache[email] = "pending response...";

                        getContactId(email, function (contact) {
                            that.contactCache[email] = (contact) ? "pending contact..." : "no contact exists";
                            if (contact && contact.id) {
                                getContact(contact.id, function (contact) {
                                    that.contactCache[email] = (contact) ? contact : "no contact exists";
                                    customerCard.html(_.template($('#templateContactCard').html(), {contact: contact}));
                                    bindContactCardEvents();
                                });
                            }


                        });
                    } else {
                        var contact = that.contactCache[email];

                        if (contact && contact.email) {
                            customerCard.html(_.template($('#templateContactCard').html(), {contact: contact}));
                            bindContactCardEvents();
                        }

                    }

                }

            }, 300);
        });

        $('.customer-card-container').click(function (ev) {
            ev.preventDefault();
        });

        function bindContactCardEvents() {
            $('.customer-card-container .js-link-contact-view').off().on('click', function (ev) {
                var contactId = $(ev.currentTarget).data('contactId');
                var baseUri = $(ev.target).parents('.customer-card-container').data('contactLink');

                window.location.href = baseUri + contactId;
            });

            $('.customer-card-container .js-link-contact-email').off().on('click', function (ev) {
                var contactId = $(ev.currentTarget).data('contactId');
                var baseUri = $(ev.target).parents('.customer-card-container').data('contactLink');

                window.location.href = baseUri + contactId + '/email';
            });
        }

        function getContactId(email, callback) {
            $.ajax({
                type: "GET",
                url: Sp.urls.api + "/brand/" + Sp.studio.brandId + "/contact",
                data: {
                    searchEmail: email
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', Sp.studio.studioV3DataToken);
                },
                success: function (data) {
                    callback(data.items[0]);
                }
            });
        }

        function getContact(id, callback) {
            $.ajax({
                type: "GET",
                url: Sp.urls.api + "/brand/" + Sp.studio.brandId + "/contact/" + id,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', Sp.studio.studioV3DataToken);
                },
                success: function (data) {
                    callback(data);
                }
            });
        }
    },

    handleOrderLabOrderDefaults: function () {
        Sp.studio.activateSwitch('input.switch', {
            onChange: function(e) {
                Sp.studio.updateSwitchStyle(this);

                // Handle state change for auto-approve orders.
                if (e.prop('id') === 'auto_send') {
                    if (e.iCheck().prop('checked') === true) {
                        this.elem.parents('.iPhoneCheckContainer').removeClass('status-false');
                        this.elem.parents('.iPhoneCheckContainer').addClass('status-true');
                        $('.auto-approve-orders-on').show();
                    } else {
                        this.elem.parents('.iPhoneCheckContainer').removeClass('status-true');
                        this.elem.parents('.iPhoneCheckContainer').addClass('status-false');
                        $('.auto-approve-orders-on').hide();
                    }
                }
            }
        });

        // Handle initial display of the auto-approve orders text.
        if ($('#auto_send').iCheck().prop('checked') === false) {
            $('.auto-approve-orders-on').hide();
        }

        $('#lab_settings_lab_id').change(function (event) {
            event.preventDefault();
            updateShippingOptions($(this).val());
            updateBoutiquePackagingOptions($(this).val());
            updateColorCorrectionSoftProofing($(this).val());
        });

        //
        // Lab-specific option changes.
        //
        var allShippingOptions = [];
        var selectedShipping = $('#shipping_method').val();
        var selectedBoutiquePackaging = $('#boutique_packaging').val();

        $('#shipping_method option').each(function () {
            if (this.label === '') {
                return;
            }

            var pieces = this.value.split('-');

            allShippingOptions.push({
                label: this.label,
                value: this.value,
                lab: parseInt(pieces[0], 10)
            });
        });

        var allBoutiquePackagingOptions = [];

        $('#boutique_packaging option').each(function () {
            if (this.label === '') {
                return;
            }

            var pieces = this.value.split('-');

            allBoutiquePackagingOptions.push({
                label: this.label,
                value: this.value,
                lab: parseInt(pieces[0], 10)
            });
        });

        var updateBoutiquePackagingOptions = function (labId) {
            var selectedVal = $('#boutique_packaging').val();

            $('#boutique_packaging').empty();

            labId = parseInt(labId, 10);

            $('#boutique_packaging').append($('<option></option>')
                .attr('value', '')
                .text('- Options, None Selected -'));

            for (var i = 0; i < allBoutiquePackagingOptions.length; i++) {
                if (allBoutiquePackagingOptions[i].lab != labId) {
                    continue;
                }

                // Build up the new option.
                var newOption = $('<option></option');

                newOption.attr('value', allBoutiquePackagingOptions[i].value)
                         .text(allBoutiquePackagingOptions[i].label);

                // Mark the currently selected value as selected after we
                // re-render.
                if (allBoutiquePackagingOptions[i].value === selectedVal) {
                    newOption.attr('selected', 'selected');
                }

                $('#boutique_packaging').append(newOption);
            }

            $('#boutique_packaging').select2('destroy');
            $('#boutique_packaging').select2();
        };

        var updateShippingOptions = function (labId) {
            var currentValue = $('#shipping_method').val();
            $('#shipping_method').empty();

            labId = parseInt(labId, 10);

            for (var i = 0; i < allShippingOptions.length; i++) {
                if (allShippingOptions[i].lab != labId) {
                    continue;
                }

                $('#shipping_method').append($('<option></option>')
                    .attr('value', allShippingOptions[i].value)
                    .text(allShippingOptions[i].label));
            }

            // Try to set the value with the current value, if it exists
            if ($('#shipping_method option[value="' + currentValue + '"]').length) {
                $('#shipping_method').val(currentValue);
            }

            $('#shipping_method').select2('destroy');
            $('#shipping_method').select2();
        };

        var updateColorCorrectionSoftProofing = function (labId) {
            var has = $('#lab' + labId + 'SoftProofing').val();

            if (has === '1') {
                $('#colorCorrection').hide();
                $('#softProofing').show();
            } else {
                $('#colorCorrection').show();
                $('#softProofing').hide();
            }
        };

        $('#lab_settings_lab_id').change(function (event) {
            event.preventDefault();
            updateShippingOptions($(this).val());
            updateBoutiquePackagingOptions($(this).val());
            updateColorCorrectionSoftProofing($(this).val());
        });

        $('#lab_settings_lab_id').trigger('change');

        $('input[name="auto_send"]').change(function () {
            if ($('input[name="auto_send"]:checked').val() === '0') {
                $('input[name="notify_email"]').attr('disabled', true);
                $('#auto_send_time').attr('disabled', true);
            } else {
                $('input[name="notify_email"]').attr('disabled', false);
                $('#auto_send_time').attr('disabled', false);
            }
        });

        $('input[name="auto_send"]').trigger('change');

        $('#shipping_method').val(selectedShipping);
        $('#boutique_packaging').val(selectedBoutiquePackaging);

        $('#backprint_text').off('keyup');
        $('#backprint_text').on('keyup', function () {
            $(this).val($(this).val().replace(/[^\w\s\-\.]/g, ''));
        });
        $('#backprint_text').trigger('keyup');

        $('#btnSubmitForm').on('click', function () {
            $('#labOrderSettings').submit();
        });

    },

    handleOrderView: function () {

        var that = this;

        const getDataFromElement = (el, dataKeys, defaultValues = {}) => {
            return dataKeys.reduce((dataValues, dataKey) => {
                const elementData = $(el).data(dataKey);

                return {
                    ...dataValues,
                    [dataKey]: elementData !== undefined
                        ? elementData
                        : defaultValues[dataKey]
                };

            }, {});
        };

        const buildProductMaskUrls = (productId, frameTexture) => {
            const {
                urls: {
                    productMasksUrl: urlBase
                }  = {}
            } = Sp.studio.jsValues;

            return {
                clipImageUrl: urlBase ? `${urlBase}/${productId}-mask.svg` : '',
                overImageUrl: urlBase ? `${urlBase}/${productId}-over.svg` : '',
                frameImageUrl: urlBase && frameTexture ? `${urlBase}/frames/${frameTexture}.jpg` : ''
            }
        }

        $('.client-comment').each(function() {
            if ($(this).prop('scrollHeight') >  $(this).height()) {
                $(this).siblings('.client-comment-show-more').show();
            }
        });

        $('.product-preview-thumbnail').each(function() {
            const {
                isOrnament,
                photoUrl,
                cropDataObject,
                photoDataObject,
                labCatalogProductId,
                frame
            } = getDataFromElement(
                this,
                ['isOrnament', 'photoUrl', 'cropDataObject', 'photoDataObject', 'labCatalogProductId', 'frame'],
                { cropDataObject: null, frame: null }
            );
            const productMasks = buildProductMaskUrls(labCatalogProductId, frame.frameTexture);

            // Check if the width and height are strings and convert them to numbers if needed
            photoDataObject.width = typeof photoDataObject.width === 'string' ? parseFloat(photoDataObject.width) : photoDataObject.width;
            photoDataObject.height = typeof photoDataObject.height === 'string' ? parseFloat(photoDataObject.height) : photoDataObject.height;
            const rotation = isOrnament && (photoDataObject.width <= photoDataObject.height) ? 1 : undefined;

            window.Sp.v2ReactBridge.renderProductPreviewThumbnail(this, {
                item: { crop: cropDataObject, productMasks, rotation },
                photo: photoDataObject,
                photoUrl: photoUrl,
                variant: 'small',
                frame: { ...frame, frameImageUrl: productMasks.frameImageUrl }
            });
        })

        /**
         *  Start the item type toggle at the top of the page
         */
        var totalDigital = $('table.items tr.item-digital').length;
        $('#itemTypeToggle li[data-type="digital"]').find('span').text(totalDigital);

        var totalLab = $('table.items tr.item-lab').length;
        $('#itemTypeToggle li[data-type="lab"]').find('span').text(totalLab);

        var totalSelf = $('table.items tr.item-self').length;
        $('#itemTypeToggle li[data-type="self"]').find('span').text(totalSelf);

        var totalAll = $('table.items tr.order-item').length;
        if (totalAll !== 0) {
            $('#itemTypeToggle li[data-type="all"]').find('span').text(totalAll);
        } else{
            $('#itemTypeToggle li[data-type="all"]').find('span').text(totalDigital + totalLab + totalSelf);
        }

        $('#itemTypeToggle li.type').on('click', function () {
            var type = $(this).data('type');

            $(this).parents('ul').find('.selected').removeClass('selected');
            $(this).addClass('selected');

            if (type === 'all') {
                $('table.items tr.item-digital').show();
                $('table.items tr.item-self').show();
                $('table.items tr.item-lab').show();
                $('#noItems').hide();
            } else if (type === 'lab') {
                $('table.items tr.item-digital').hide();
                $('table.items tr.item-self').hide();
                $('table.items tr.item-lab').show();

                $('#noItems').hide();

                if (totalLab === 0) {
                    $('#noItems').find('p').hide();
                    $('#noItems').find('p.type-lab').show();
                    $('#noItems').show();
                }
            } else if (type === 'self') {
                $('table.items tr.item-digital').hide();
                $('table.items tr.item-self').show();
                $('table.items tr.item-lab').hide();

                $('#noItems').hide();

                if (totalSelf === 0) {
                    $('#noItems').find('p').hide();
                    $('#noItems').find('p.type-self').show();
                    $('#noItems').show();
                }
            } else if (type === 'digital') {
                $('table.items tr.item-digital').show();
                $('table.items tr.item-self').hide();
                $('table.items tr.item-lab').hide();

                $('#noItems').hide();

                if (totalDigital === 0) {
                    $('#noItems').find('p').hide();
                    $('#noItems').find('p.type-digital').show();
                    $('#noItems').show();
                }
            }

            $('table.items tbody').each(function () {
                $(this).parents('.complete-block').show();

                var total = $(this).find('tr.order-item').length;
                var hidden = $(this).find('tr.order-item:hidden').length;

                if (total === hidden) {
                    $(this).parents('.complete-block').hide();
                }
            });
        });
        /**
         * End the item type toggle at the top of the page
         */

        // show any low dpi warnings that are needed
        $('tr.order-item.dpi-low').each(function () {
            var $tbody = $(this).parents('tbody');
            var $warningRow = $tbody.find('tr.dpi-warning-row');
            var count = $tbody.find('tr.dpi-low').length;
            $warningRow.find('.count').text(count);
            $warningRow.show();

            if (count > 1) {
                $warningRow.find('.multiple').show();
            } else {
                $warningRow.find('.single').show();
            }
        });

        $('#showFilenameList').on('click', function (e) {
            e.preventDefault();

            that.modal({
                title: 'Filenames in Order',
                body: _.template($('#templateFilenameList').html(), {}),
                sizeClass: 'modal-md',
                shown: function () {
                    that.initCopy();
                },
                buttons: [{
                    label: 'Ok',
                    'class': 'btn-primary',
                    close: true
                }]
            });
        });

        $('#downloadFiles').on('click', function (e) {
            e.preventDefault();

            Sp.studio.downloadPhoto({
                photoIds: [], // we do not want to send photo ids because they get duplicated in the order download
                orderId: Sp.studio.jsValues.order.id,
                emailAddress: Sp.userEmail,
                subject: Sp.studio.jsValues.downloadEmailSubject
            });
        });

        $('#showItemsByQuantity').on('click', function (e) {
            e.preventDefault();

            that.modal({
                title: 'Items by Quantity',
                body: _.template($('#templateItemsByQty').html(), {}),
                sizeClass: 'modal-md',
                buttons: [
                    {
                        label: 'Close',
                        close: true
                    }
                ]
            });
        });

        $('#convertToSelfFulfilled').on('click', function(e) {
            e.preventDefault();

            that.loading('Loading', 'show');

            $.get(that.studioPanelUri('/order/convert'), {
                order_id: that.jsValues.order.id
            }, function (html) {

                that.loading('Loading', 'hide');

                that.modal({
                    id: 'convertLabItemModal',
                    title: 'Choose Items to Convert',
                    body: html,
                    open: function () {
                        $('#convertLabItemModal input:checkbox').iCheck(that.configs.iCheck);

                        $('#convertLabItemModal input:checkbox').on('ifChanged', function () {
                            var totalChecked = $('#convertLabItemModal input:checkbox:checked').length;

                            if (totalChecked) {
                                $('#convertLabItemModal').find('.btn-primary').removeClass('disabled');
                            } else {
                                $('#convertLabItemModal').find('.btn-primary').addClass('disabled');
                            }
                        });
                    },
                    buttons: [
                        {
                            label: 'Cancel',
                            close: true
                        },{
                            label: 'Convert Items',
                            'class': 'btn-primary disabled',
                            click: function () {

                                that.loading('Converting', 'show');

                                var ids = [];

                                $('#convertLabItemModal input:checkbox:checked').each(function () {
                                    ids.push($(this).val());
                                });

                                $('#convertLabItemModal').modal('hide');

                                $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/order/convert'), 'order_convert'), {
                                    order_id: that.jsValues.order.id,
                                    item: ids
                                }, function ({ errorMessage, isPaymentFailure, status }) {
                                    if (status === 'error') {
                                        that.loading('Converting', 'hide');

                                        function showConvertModal() {
                                            if (isPaymentFailure) {
                                                window.Sp.v2ReactBridge.showConvertToSelfFulfilledFailueModal({
                                                    errorMessage: errorMessage,
                                                    onClose: function onClose() { location.reload() }
                                                })
                                            } else {
                                                window.Sp.v2ReactBridge.showErrorModal({
                                                    errorMessage: 'An error occurred attempting to convert your items. Please try again.',
                                                    headerText: 'Unable to convert items',
                                                    onClose: function onClose() { location.reload() }
                                                })
                                            }
                                        }

                                        setTimeout(showConvertModal, 0);
                                    } else {
                                        location.reload();
                                    }
                                }, 'json')
                            }
                        }
                    ]
                });

            }, 'html');
        });

        // show the images with crops
        $('.thumbnail-crop').each(function (i, obj) {
            that.updateOrderItemCropPreview(obj);
        });

        $('a.edit-item').on('click', function (e) {
            e.preventDefault();

            var orderItemId = $(this).parents('tr.order-item').data('orderItemId');
            Sp.studio.loading('Loading', 'show');

            $.get(that.studioPanelUri('/order/edititem'), {
                order_id: Sp.studio.jsValues.order.id,
                order_item_id: orderItemId
            }, function (json) {

                Sp.studio.loading('Loading', 'hide');

                if (!json.allowed) {
                    self.location.href = self.location.href;
                    return;
                }

                var currentLabItemId = json.labItemId;

                // Since the edititem call always returns the three character
                // currency code, add a space after "symbol" for readability
                var currencySymbol = json.currencySymbol + ' ';

                that.modal({
                    title: 'Edit Item',
                    body: _.template($('#templateItemEdit').html(), {
                        currentLabItemId: currentLabItemId,
                        optionGroups: json.optionGroups,
                        quantity: json.quantity,
                        currencySymbol: currencySymbol,
                        hasMountingOptions: ((json.mountingOptions.length) ? true : false),
                        mountingOptions: _.template($('#templateProductAddonOptions').html(), {
                            options: json.mountingOptions,
                            defaultText: '- No Mounting -',
                            selectedValue: json.selected.mounting,
                            currencySymbol: currencySymbol,
                            quantity: json.quantity
                        }),
                        hasTextureOptions: ((json.textureOptions.length) ? true : false),
                        textureOptions: _.template($('#templateProductAddonOptions').html(), {
                            options: json.textureOptions,
                            defaultText: '- No Texture -',
                            selectedValue: json.selected.texture,
                            currencySymbol: currencySymbol,
                            quantity: json.quantity
                        }),
                        hasCoatingOptions: ((json.coatingOptions.length) ? true : false),
                        coatingOptions: _.template($('#templateProductAddonOptions').html(), {
                            options: json.coatingOptions,
                            defaultText: '- No Coating -',
                            selectedValue: json.selected.coating,
                            currencySymbol: currencySymbol,
                            quantity: json.quantity
                        })
                    }),
                    sizeClass: 'modal-md',
                    open: function (e) {
                        $('#newLabItemId').select2({
                            width: '100%',
                            templateSelection: function (obj) {
                                return $(obj.element).data('bounds') + ' - ' + $.trim(obj.text);
                            }
                        });

                        // set the current value
                        $('#newLabItemId').on('change', function () {
                            that.updateOrderItemProductOptions();
                        });

                        $('#mounting, #texture, #coating').select2();

                        $('#newOrderItemQuantity').off('change');
                        $('#newOrderItemQuantity').on('change', function () {
                            var val = $.trim($(this).val());

                            if (val === '') {
                                $(this).val(1);
                                that.updateOrderItemProductOptions();
                                return;
                            }

                            var parsedVal = parseInt(Sp.numbersOnly(val), 10);

                            if (parsedVal > 0) {
                                $(this).val(parseVal);
                                that.updateOrderItemProductOptions();
                                return;
                            }

                            $(this).val(1);
                            that.updateOrderItemProductOptions();
                        });

                        $(e.target).find('.icon-quantity-minus').off('click');
                        $(e.target).find('.icon-quantity-minus').on('click', function () {
                            var el = $(this).parents('.input-group').find('input');
                            var val = parseInt(el.val(), 10);

                            if (val - 1 < 1) {
                                return;
                            } else {
                                el.val(val - 1);
                                that.updateOrderItemProductOptions();
                            }
                        });

                        $(e.target).find('.icon-quantity-plus').off('click');
                        $(e.target).find('.icon-quantity-plus').on('click', function () {
                            var el = $(this).parents('.input-group').find('input');
                            var val = parseInt(el.val(), 10);
                            el.val(val + 1);
                            that.updateOrderItemProductOptions();
                        });
                    },
                    buttons: [
                        {
                            label: 'Cancel',
                            close: true
                        },{
                            'class': 'btn-primary',
                            label: 'Save',
                            click: function () {
                                Sp.studio.loading('Saving', 'show');

                                self.location.href = that.studioPanelCsrfWrapper(that.studioPanelUri('/order/edititem') +
                                    '?edit=1&' +
                                    'order_id=' + Sp.studio.jsValues.order.id + '&' +
                                    'order_item_id=' + orderItemId + '&' +
                                    'lab_item_id=' + $('#newLabItemId').val() + '&' +
                                    'mounting_id=' + $('#mounting').val() + '&' +
                                    'texture_id=' + $('#texture').val() + '&' +
                                    'coating_id=' + $('#coating').val() + '&' +
                                    'quantity=' + $('#newOrderItemQuantity').val(),
                                    'order_edititem'
                                );
                            }
                        }
                    ]
                });
            }, 'json');
        });

        $('#emailReceipt').on('click', function (e) {
            e.preventDefault();

            that.modal({
                title: 'Email Order Receipt',
                sizeClass: 'modal-md',
                body: _.template($('#templateEmailReceipt').html(), {
                    email: that.jsValues.order.email
                }),
                open: function () {
                    that.editor('#receiptOptionalMessage', {
                        minHeight: 150
                    });

                    var id = '#' + this.id;
                    var checkbox = $(id + ' input:checkbox');
                    var email = $(id + ' #email');
                    var downloadEmail = $('#send_digital_download_email');
                    var label = $('.send-download-email-label');

                    checkbox.iCheck(that.configs.iCheck);

                    email.on('keyup', function () {
                        if (email.val() !== that.jsValues.order.email) {
                            downloadEmail.iCheck('disable');
                            downloadEmail.iCheck('uncheck');
                            label.addClass('disabled');
                        } else {
                            downloadEmail.iCheck('enable');
                            label.removeClass('disabled');
                        }
                    });
                },
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Send Email',
                        'class': 'btn-primary',
                        click: function () {

                            var modal = $(this).parents('div.modal');
                            var email = modal.find('input').val();
                            var msg = modal.find('textarea').val();
                            var sendDigitalDownloadEmail = modal.find('#send_digital_download_email').prop('checked');

                            if (email === '' ||
                                !Sp.isValidEmail(email)) {
                                modal.find('.form-group').addClass('has-error');
                                modal.find('label.control-label').show();
                                return;
                            }

                            modal.modal('hide');
                            that.loading('Sending Email', 'show');

                            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/order/emailreceipt'), 'order_emailreceipt'), {
                                email: email,
                                order_id: that.jsValues.order.id,
                                optional_msg: msg,
                                send_digital_download_email: (sendDigitalDownloadEmail ? 1 : 0)
                            }, function (json) {
                                if (json.status === 'success') {
                                    that.loading('Sending Email', 'hide');
                                } else if (json.status ==='form_errors') {
                                    that.displayFormErrors(modal, json.errors);
                                }
                            }, 'json');
                        }
                    }
                ]
            });
        });

        $('#printOrder').on('click', function (e) {
            e.preventDefault();

            window.open(that.studioPanelUri('/order/print?id=' + Sp.studio.jsValues.order.id), 'PrintWindow', 'width=800,height=600,menubar=1,resizable=1');
        });

        $('body').on('click', '.js-replace-photo-simple', function (e) {
            e.preventDefault();

            $(this).parents('.group-block').find('.big-preview-cell .js-replace-image').trigger('click');
        });

        $('body').on('click', '.js-replace-image', function (e) {
            e.preventDefault();
            var orderPhotoId = $(this).data('orderPhotoId');
            var originalDimensions = $(this).data('originalDimensions');
            var filename = $(this).data('filename');
            var thumbnailUrl = $(this).data('thumbnailUrl');

            if ($('div.modal.in')) {
                $('div.modal.in').modal('hide');
            }

            showReplaceImageModal(that, { orderPhotoId, originalDimensions, filename, thumbnailUrl });
        });

        $('.product-preview-thumbnail').on('click', function (e) {
            e.preventDefault();

            const boundsName = $(this).data('boundsName');
            const cropDataObject = $(this).data('cropDataObject');
            const isEditable = Boolean($(this).data('editable'));
            const itemFileName = $(this).data('fileName');
            const itemProductName = $(this).data('itemName');
            const itemQuantity = $(this).data('quantity');
            const labCatalogProductId = $(this).data('labCatalogProductId');
            const photoUrl = $(this).data('photoUrl');
            const photoDataObject = $(this).data('photoDataObject');
            const thumbnailUrl = $(this).data('thumbnailUrl');
            const originalDimensions = $(this).data('originalDimensions');
            const orderPhotoId = $(this).data('orderPhotoId');
            const orderItemId = $(this).data('orderItemId');
            const frame = $(this).data('frame');
            const productMasks = buildProductMaskUrls(labCatalogProductId, frame.frameTexture);
            const isOrnament = $(this).data('isOrnament');

            const originalDimensionsSplit = originalDimensions.split(',');
            const rotation = isOrnament && originalDimensionsSplit?.length > 1 && (originalDimensionsSplit[0] <= originalDimensionsSplit[1]) ? 1 : undefined;

            const onReplace = () => {
                window.Sp.v2ReactBridge.renderOrderItemPreviewModal('orderItemPreviewModalContainer', {
                    isOpen: false
                });

                showReplaceImageModal(that, {
                    orderPhotoId,
                    originalDimensions,
                    filename: itemFileName,
                    thumbnailUrl
                });
            };
            const onEditCrop = () => {
                window.Sp.v2ReactBridge.renderOrderItemEditModal('orderItemEditModalContainer', {
                    item:  { boundsName, crop: cropDataObject, productMasks, rotation },
                    disableRotating: isOrnament,
                    photo: photoDataObject,
                    photoUrl: photoUrl,
                    isOpen: true,
                    frame: { ...frame, frameImageUrl: productMasks.frameImageUrl },
                    onSubmit: (crop) => {
                        const updateCropUrl = that.studioPanelCsrfWrapper(that.studioPanelUri('/order/updatecrop'), 'order_updatecrop');
                        const updateRequestData = {
                                order_id: that.jsValues.order.id,
                                order_item_id: orderItemId,
                                crop: [crop.start.x, crop.start.y, crop.end.x, crop.end.y].join(',')
                        };

                        $.post(
                            updateCropUrl,
                            updateRequestData
                        ).promise().then(() => {
                            location.reload();
                        }, 'json');
                    }
                });

                window.Sp.v2ReactBridge.renderOrderItemPreviewModal('orderItemPreviewModalContainer', {
                    isOpen: false
                });
            }

            window.Sp.v2ReactBridge.renderOrderItemPreviewModal('orderItemPreviewModalContainer', {
                isEditable: isEditable,
                item: { crop: cropDataObject, productMasks, rotation },
                itemFileName: itemFileName,
                itemProductName: itemProductName,
                itemQuantity: itemQuantity,
                photo: photoDataObject,
                photoUrl: photoUrl,
                onReplace: onReplace,
                onEdit: onEditCrop,
                variant: 'medium',
                frame: { ...frame, frameImageUrl: productMasks.frameImageUrl }
            });

        });

        $('a.crop-image').on('click', function (e) {
            e.preventDefault();

            if ($(this).hasClass('disable')) {
                return;
            }

            var orderItemId = $(this).parents('.order-item').data('orderItemId');
            var photoUrl = $(this).data('photoUrl');
            var crop = $(this).data('crop');
            var cropPieces = crop.split(',');
            var bounds = $(this).data('bounds');
            var boundPieces = bounds.split(',');
            var canvasDepth = $(this).data('canvasDepth');
            var circleCrop = $(this).data('circleCrop');
            var useCanvasCrop = $(this).data('canvasCrop');
            var orderPhotoId = $(this).data('orderPhotoId');
            var originalDimensions = $(this).data('originalDimensions');
            var editable = (($(this).data('editable') === 1) ? true : false);

            var buttons = [];

            buttons.push({
                label: 'Cancel',
                close: true
            });

            if (editable) {
                buttons.push({
                    label: 'Save',
                    'class': 'btn-primary',
                    click: function () {

                        var plugin = that.darkroom.getPlugin('crop');
                        var currentCrop = plugin.getCurrentCrop();
                        var w = Math.round(that.darkroom.image.currentWidth);
                        var h = Math.round(that.darkroom.image.currentHeight);

                        var coordinates = [
                            ((currentCrop.getLeft() / w) * 100).toFixed(4),
                            ((currentCrop.getTop() / h) * 100).toFixed(4),
                            (((currentCrop.getWidth() + currentCrop.getLeft()) / w) * 100).toFixed(4),
                            (((currentCrop.getHeight() + currentCrop.getTop()) / h) * 100).toFixed(4)
                        ];

                        if (coordinates[0] === coordinates[2]) {
                            return;
                        }

                        that.loading('Saving', 'show');

                        $(this).parents('.modal').modal('hide');

                        $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/order/updatecrop'), 'order_updatecrop'), {
                            order_id: that.jsValues.order.id,
                            order_item_id: orderItemId,
                            crop: coordinates.join(',')
                        }, function (json) {
                            var row = $('tr.order-item[data-order-item-id="' + orderItemId + '"]');
                            $(row).find('a.crop-image').data('crop', coordinates.join(','));

                            // now update the crop preview on the main page
                            var previewId = $(row).find('a.crop-image').data('thumbnailId');
                            var instance = Sp.darkroomCropPreviews[previewId];
                            var cropPlugin = instance.getPlugin('crop');
                            cropPlugin.selectZone(
                                (instance.canvas.width * (parseFloat(coordinates[0]) / 100)),
                                (instance.canvas.height * (parseFloat(coordinates[1]) / 100)),
                                (instance.canvas.width * ((parseFloat(coordinates[2]) - parseFloat(coordinates[0])) / 100)),
                                (instance.canvas.height * ((parseFloat(coordinates[3]) - parseFloat(coordinates[1])) / 100)),
                                true);

                            if (json.hasOwnProperty('lowDpi') && json.lowDpi) {
                                $(row).addClass('dpi-low');
                                $(row).parents('tbody').find('.dpi-warning-row').show();
                            } else {
                                $(row).removeClass('dpi-low');
                                if (!$(row).parents('tbody').find('tr.dpi-low').length) {
                                    $(row).parents('tbody').find('.dpi-warning-row').hide();
                                }
                            }

                            that.loading('Saving', 'hide');
                            that.hoverMessage.show(json.msg, json.status);
                        }, 'json');
                    }
                });
            }

            that.modal({
                body: _.template($('#templateCropModal').html(), {
                    editable: editable,
                    orderPhotoId: orderPhotoId,
                    photoUrl: photoUrl,
                    crop: crop,
                    bounds: bounds,
                    canvasDepth: '',
                    circleCrop: circleCrop,
                    useCanvasCrop: useCanvasCrop,
                    originalDimensions: originalDimensions,
                    filename: $(this).data('filename'),
                    itemName: $(this).data('itemName'),
                    quantity: $(this).data('qty')
                }),
                open: function () {
                    var date = new Date().getTime();
                    var id = 'crop' + date;

                    $('<img>').on('load', function () {

                        var widthPixels = this.width * (parseFloat(cropPieces[2]) - parseFloat(cropPieces[0]));
                        var heightPixels = this.height * (parseFloat(cropPieces[3]) - parseFloat(cropPieces[1]));

                        var boundRatio1 = parseFloat(boundPieces[2]) / parseFloat(boundPieces[3]);
                        var boundRatio2 = parseFloat(boundPieces[3]) / parseFloat(boundPieces[2]);

                        var ratio1, ratio2;

                        // landscape crop
                        if (widthPixels > heightPixels) {
                            if (boundRatio1 > boundRatio2) {
                                ratio1 = boundRatio1;
                                ratio2 = boundRatio2;
                            } else {
                                ratio1 = boundRatio2;
                                ratio2 = boundRatio1;
                            }
                        } else {
                            if (boundRatio1 > boundRatio2) {
                                ratio1 = boundRatio2;
                                ratio2 = boundRatio1;
                            } else {
                                ratio1 = boundRatio1;
                                ratio2 = boundRatio2;
                            }
                        }

                        // setup the crops now
                        that.darkroom = new Darkroom('#' + id, {
                            minWidth: 100,
                            minHeight: 100,
                            maxWidth: 518,
                            maxHeight: 500,
                            plugins: {
                                save: false,
                                crop: {
                                    minWidth: 50,
                                    minHeight: 50,
                                    ratio: ratio1,
                                    ratio1: ratio1,
                                    ratio2: ratio2,
                                    bounds: boundPieces,
                                    canvasDepth: canvasDepth,
                                    circleCrop: circleCrop,
                                    useCanvasCrop: useCanvasCrop
                                }
                            },
                            init: function() {
                                var cropPlugin = this.getPlugin('crop');
                                cropPlugin.selectZone(
                                    (this.image.currentWidth * (parseFloat(cropPieces[0]) / 100)),
                                    (this.image.currentHeight * (parseFloat(cropPieces[1]) / 100)),
                                    (this.image.currentWidth * ((parseFloat(cropPieces[2]) - parseFloat(cropPieces[0])) / 100)),
                                    (this.image.currentHeight * ((parseFloat(cropPieces[3]) - parseFloat(cropPieces[1])) / 100)));
                            }
                        });
                    })
                    .attr('src', photoUrl)
                    .attr('id', id)
                    .appendTo('.crop-modal .image');

                    $('.rotate-crop').on('click', function (e) {
                        e.preventDefault();

                        var canvas = that.darkroom.canvas;
                        var cropPlugin = that.darkroom.getPlugin('crop');
                        var options = cropPlugin.options;
                        var newRatio;
                        var photoRatio = canvas.getWidth() / canvas.getHeight();

                        if (options.ratio === options.ratio1) {
                            newRatio = options.ratio2;
                        } else {
                            newRatio = options.ratio1;
                        }

                        cropPlugin.setRatio(newRatio);

                        // resize to largest
                        that.darkroom.canvas.getActiveObject().scaleX = 1;
                        that.darkroom.canvas.getActiveObject().scaleY = 1;

                        var canvasOffsetX = (canvas.getWidth() - (canvas.getHeight() * newRatio)) / 2;
                        var canvasOffsetY = (canvas.getHeight() - (canvas.getWidth() / newRatio)) / 2;

                        // if so, this is a landscape ratio
                        if (newRatio > photoRatio) {
                            cropPlugin.selectZone(
                                0,
                                canvasOffsetY,
                                canvas.getWidth(),
                                canvas.getWidth() / newRatio
                            );
                        } else {
                            cropPlugin.selectZone(
                                canvasOffsetX,
                                0,
                                canvas.getHeight() * newRatio,
                                canvas.getHeight()
                            );
                        }
                    });
                },
                buttons: buttons
            });
        });

        /**
         * Check for contact, pull data and subsequently load contact into cache
         */
        if (!that.contactCache) {
            that.contactCache = [];
        }
        $('.contact-wrapper').hover(function (e) {
            var customerCard = $(e.currentTarget).find('.customer-card-container');
            var contactEmail = customerCard.data('contactEmail');

            setTimeout(function () {
                if ($(e.target).is(':hover') && contactEmail) {

                    if (!that.contactCache[contactEmail]) {

                        that.contactCache[contactEmail] = "pending response...";

                        getContactId(contactEmail, function (contact) {
                            that.contactCache[contactEmail] = (contact) ? "pending contact..." : "no contact exists";
                            if (contact && contact.id) {
                                getContact(contact.id, function (contact) {
                                    that.contactCache[contactEmail] = (contact) ? contact : "no contact exists";
                                    customerCard.html(_.template($('#templateContactCard').html(), {contact: contact}));
                                    bindContactCardEvents();
                                });
                            }
                        });
                    } else {
                        var contact = that.contactCache[contactEmail];

                        if (contact && contact.email) {
                            customerCard.html(_.template($('#templateContactCard').html(), {contact: contact}));
                        }

                        bindContactCardEvents();

                    }

                }

            }, 300);
        });

        $('.customer-card-container').click(function (ev) {
            ev.stopPropagation();
        });

        function bindContactCardEvents() {
            $('.customer-card-container .js-link-contact-view').off().on('click', function (ev) {
                var contactId = $(ev.currentTarget).data('contactId');
                var baseUri = $(ev.target).parents('.customer-card-container').data('contactLink');

                window.location.href = baseUri + contactId;
            });

            $('.customer-card-container .js-link-contact-email').off().on('click', function (ev) {
                var contactId = $(ev.currentTarget).data('contactId');
                var baseUri = $(ev.target).parents('.customer-card-container').data('contactLink');

                window.location.href = baseUri + contactId + '/email';
            });
        }

        function getContactId(email, callback) {
            $.ajax({
                type: "GET",
                url: Sp.urls.api + "/brand/" + Sp.studio.brandId + "/contact",
                data: {
                    searchEmail: email
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', Sp.studio.studioV3DataToken);
                },
                success: function (data) {
                    callback(data.items[0]);
                }
            });
        }

        function getContact(id, callback) {
            $.ajax({
                type: "GET",
                url: Sp.urls.api + "/brand/" + Sp.studio.brandId + "/contact/" + id,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', Sp.studio.studioV3DataToken);
                },
                success: function (data) {
                    callback(data);
                }
            });
        }

        // Handles editing of shipping and lab shipping addresses.
        $('.js-edit-shipping-info').click(function (e) {
            e.preventDefault();
            let requiresTaxUpdate = false;
            let skipTaxCheck = false;

            that.modal({
                title: 'Edit Shipping Address',
                body: _.template($('#templateEditShippingInfo').html(), {}),
                autoOpen: true,
                modal: true,
                width: 440,
                open: function () {
                    $('#name').val(that.jsValues.order.address.name);
                    $('#address_1').val(that.jsValues.order.address.address_line_1);
                    $('#address_2').val(that.jsValues.order.address.address_line_2);
                    $('#city').val(that.jsValues.order.address.city);
                    $('#country').val(that.jsValues.order.address.country);
                    $('#state').val(that.jsValues.order.address.state);
                    $('#state_other').val(that.jsValues.order.address.state_other);
                    $('#zip_postal').val(that.jsValues.order.address.zip);
                    $('#country').trigger('change');
                    $('#email').val(that.jsValues.order.email);
                    $('#country').select2();
                    $('#state').select2();

                    // Watch its country and state fields for international address
                    // handling.
                    that.watchCountryStateField({
                        citySelector: '#city',
                        stateDropdownSelector: '#state',
                        stateOtherSelector: '#state_other',
                        countrySelector: '#country',
                        zipCodeSelector: '#zip_postal',
                        zipCodeFieldNames: that.jsValues.zipCodeFieldNames,
                        cityFieldNames: that.jsValues.cityFieldNames,
                        countryNoState: that.jsValues.countryNoState,
                        selectedStateId: that.jsValues.order.address.state
                    });
                },
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Save',
                        'class': 'btn-primary btn-save',
                        click: function () {
                            const isAvailableForApproval = Sp.studio.jsValues.order.editable;

                            if (Sp.studio.jsValues.order.is_automatic_sales_tax && isAvailableForApproval && !skipTaxCheck) {
                                $.get(that.studioPanelUri('/order/getSalesTaxForAddress'), {
                                    order_id: Sp.studio.jsValues.order.id,
                                    radio: 'alternate',
                                    name: document.getElementById('name')?.value,
                                    street_line_1: document.getElementById('address_1')?.value,
                                    street_line_2: document.getElementById('address_2')?.value,
                                    city: document.getElementById('city')?.value,
                                    state_province: document.getElementById('state')?.value,
                                    country: document.getElementById('country')?.value,
                                    postal_code: document.getElementById('zip_postal')?.value
                                }, function (json) {
                                    const { needsConfirmation, originalSalesTax, taxDifference, updatedSalesTax } = json;
                                    
                                    const reSubmitAddressModalSave = () => {
                                        skipTaxCheck = true;
                                        document.getElementsByClassName('btn-save')[0].click();
                                    }

                                    if (needsConfirmation) {
                                        Sp.v2ReactBridge.showUpdatedSalesTaxConfirmationModal({
                                            onConfirm: () => { 
                                                requiresTaxUpdate = true;
                                                reSubmitAddressModalSave();
                                            },
                                            originalSalesTax,
                                            taxDifference,
                                            updatedSalesTax,
                                        });
                                    } else {
                                        reSubmitAddressModalSave();
                                    }
                                }, 'json');
                            } else {
                                Sp.studio.loading('Saving', 'show');
                                var dialog = $(this).parents('.modal');
    
                                $('.btn-primary').toggleClass('disabled');
    
                                $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/order/clientaddress'), 'order_clientaddress'),
                                    {
                                        order_id: that.jsValues.order.id,
                                        requires_tax_update: requiresTaxUpdate,
                                        name: $('#name').val(),
                                        address_1: $('#address_1').val(),
                                        address_2: $('#address_2').val(),
                                        city: $('#city').val(),
                                        country: $('#country').val(),
                                        state: $('#state').val(),
                                        state_other: $('#state_other').val(),
                                        zip_postal: $('#zip_postal').val(),
                                        email: $('#email').val()
                                    },
                                    function (json) {
                                        Sp.studio.loading('Saving', 'hide');
    
                                        if (json.status === 'success') {
                                            that.jsValues.order = json.order;
                                            $('#orderAddressName').text(that.jsValues.order.address.name);
                                            $('#orderEmailDisplay').text(that.jsValues.order.email);
                                            $('#orderShippingAddress').html(json.address_html);
                                        } else if (json.status === 'form_errors') {
    
                                            // Combine together name- and
                                            // address-level errors so that form
                                            // errors can be displayed in the
                                            // modal.
                                            var combinedErrors = {};
    
                                            if (typeof json.errors.address === 'object') {
                                                combinedErrors = json.errors.address;
                                            }
    
                                            if (typeof json.errors.name === 'object') {
                                                combinedErrors.name = json.errors.name;
                                            }
    
                                            if (typeof json.errors.email === 'object') {
                                                combinedErrors.email = json.errors.email;
                                            }
    
                                            that.displayFormErrors(dialog, combinedErrors);
                                            return;
                                        } else {
                                            that.hoverMessage.show(json.msg, json.status);
                                        }
    
                                        dialog.modal('hide');
                                    },
                                    'json'
                                ).always(
                                    function() {
                                        $('.btn-primary').toggleClass('disabled');
                                    }
                                );
                            }
                        }
                    }
                ]
            });
        });

        $('#createMobileApp').click(function () {
            that.createMobileApp(that.jsValues.photoIds);
        });

        // ability for studio to regenerate an old digital download link
        $('body').on('click', '.js-regen-digital-download', function (e) {
            e.preventDefault();

            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/order/regendownload'), 'order_regendownload'), {
                order_id: $(this).attr('href')
            }, function (json) {
                that.hoverMessage.show(json.msg, json.status);
            }, 'json');
        });

        $('.js-order-summary').on('click', function (e) {
            e.preventDefault();

            that.modal({
                title: 'Order Summary',
                body: _.template($('#templateOrderSummary').html(), {})
            });
        });

        function setOrderPaymentErrorMessage(message) {
            message = message || '';

            var errorContainer = $('#studioOrderPaymentError');

            if (errorContainer) {
                errorContainer.text(message);
            }
        }

        function onSubmitStripePayment(formData) {
            that.loading('Processing', 'show');

            var orderId = $('#studioOrderPaymentContainer').attr('data-order-id');

            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/order/addcreditcard'), 'order_addcreditcard'), {
                card_holder_name: formData.cardholderName,
                order_id: orderId,
                payment_method_id: formData.paymentMethodId,
                transaction_amount: formData.amount
            }, function (response) {
                var status = response.status;

                that.loading('Processing', 'hide');

                if (status === 'error') {
                    setOrderPaymentErrorMessage(response.errorMessage);

                    return;
                }

                if (status === 'form_errors') {
                    setOrderPaymentErrorMessage('The payment could not be processed.');

                    return;
                }

                $('#orderPaymentCreditCardModal').modal('hide');

                location.reload();

                return;
            }, 'json');
        }

        function perform3DSVerification(creditCard, chargeAmount) {
            let standardClient;
            let paymentMethodNonce;
            const braintreeToken = $('#accept-credit-card-braintree-token').val();
            const VERIFIED_STATUS_SUCCESS = 'authenticate_successful';
            const VERIFIED_STATUS_UNAVAILABLE = 'authentication_unavailable';

            that.loading('Processing', 'show');
            $('#loading').css('z-index', '1100')

            function checkVerifiedResponse({ nonce: verifiedNonce, threeDSecureInfo, details }) {
                const { status: verifiedStatus } = threeDSecureInfo;
                const isVerified = [VERIFIED_STATUS_SUCCESS, VERIFIED_STATUS_UNAVAILABLE].includes(
                    verifiedStatus
                );

                return {
                    creditCard: details,
                    paymentMethodNonce: isVerified ? verifiedNonce : null,
                    verified: isVerified,
                    verifiedStatus
                };
            }

            function createBrainTreeClient() {
                return braintree.client.create({
                    authorization: braintreeToken
                });
            }

            function create3DSecureClient(standardClient) {
                return braintree.threeDSecure
                    .create({
                        client: standardClient,
                        version: '2-inline-iframe'
                    })
                    .then((secureClient) => {
                        secureClient.on('authentication-iframe-available', (event, next) => {
                            const { element } = event;

                            renderChallenge(element);
                            next();
                        });

                        return secureClient;
                    });
            }

            function handleVerificationFlow(secureClient, paymentMethodNonce, chargeAmount) {
                return secureClient
                    .verifyCard({
                        nonce: paymentMethodNonce,
                        amount: chargeAmount,
                        onLookupComplete: (_, next) => (
                            next()
                        )
                    })
                    .then(checkVerifiedResponse);
            }

            function parsePaymentMethodNonce(tokenizedCreditCardData) {
                const { creditCards } = tokenizedCreditCardData;
                const [{ nonce }] = creditCards;

                return nonce;
            }


            function tokenizeCreditCard(client, creditCard) {
                return client.request({
                    endpoint: 'payment_methods/credit_cards',
                    method: 'post',
                    data: {
                        creditCard
                    }
                });
            }

            function renderChallenge(iframe) {
                window.Sp.v2ReactBridge.openBraintreeChallenge()
                window.Sp.v2ReactBridge.updateBraintreeChallenge(iframe)

                that.loading('Processing', 'hide');
            }

            // Verify Card
            return createBrainTreeClient()
                .then((client) => (standardClient = client))
                .then(() => tokenizeCreditCard(standardClient, creditCard))
                .then((tokenizedResponse) => parsePaymentMethodNonce(tokenizedResponse))
                .then((nonce) => (paymentMethodNonce = nonce))
                .then(() => create3DSecureClient(standardClient))
                .then((secureClient) =>
                    handleVerificationFlow(secureClient, paymentMethodNonce, chargeAmount)
                )
        }

        function getBraintreeVerificationCodeKey(code) {
            const VERIFICATION_CODES = {
                AUTHENTICATE_ATTEMPT_SUCCESSFUL: 'authenticate_attempt_successful',
                AUTHENTICATE_ERROR: 'authenticate_error',
                AUTHENTICATE_FAILED: 'authenticate_failed',
                AUTHENTICATE_FAILED_ACS_ERROR: 'authenticate_failed_acs_error',
                AUTHENTICATE_REJECTED: 'authenticate_rejected',
                AUTHENTICATE_FRICTIONLESS_FAILED: 'authenticate_frictionless_failed',
                AUTHENTICATE_SIGNATURE_VERIFICATION_FAILED: 'authenticate_signature_verification_failed',
                AUTHENTICATE_SUCCESSFUL: 'authenticate_successful',
                AUTHENTICATE_SUCCESSFUL_ISSUER_NOT_PARTICIPATING:
                    'authenticate_successful_issuer_not_participating',
                AUTHENTICATE_UNABLE_TO_AUTHENTICATE: 'authenticate_unable_to_authenticate',
                AUTHENTICATION_BYPASSED: 'authentication_bypassed',
                AUTHENTICATION_UNAVAILABLE: 'authentication_unavailable',
                CHALLENGE_REQUIRED: 'challenge_required',
                DATA_ONLY_SUCCESSFUL: 'data_only_successful',
                LOOKUP_BYPASSED: 'lookup_bypassed',
                LOOKUP_ENROLLED: 'lookup_enrolled',
                LOOKUP_ERROR: 'lookup_error',
                LOOKUP_FAILED_ACS_ERROR: 'lookup_failed_acs_error',
                LOOKUP_NOT_ENROLLED: 'lookup_not_enrolled',
                UNSUPPORTED_ACCOUNT_TYPE: 'unsupported_account_type',
                UNSUPPORTED_CARD: 'unsupported_card',
                UNSUPPORTED_THREE_D_SECURE_VERSION: 'unsupported_three_d_secure_version'
            };

            switch (code) {
                case VERIFICATION_CODES.AUTHENTICATE_ERROR:
                case VERIFICATION_CODES.AUTHENTICATE_SIGNATURE_VERIFICATION_FAILED:
                    return "systemError";
                case VERIFICATION_CODES.AUTHENTICATE_FAILED:
                case VERIFICATION_CODES.CHALLENGE_REQUIRED:
                    return "3dsError";
                case VERIFICATION_CODES.AUTHENTICATE_UNABLE_TO_AUTHENTICATE:
                    return "bankSystemError";
                case VERIFICATION_CODES.AUTHENTICATE_REJECTED:
                case VERIFICATION_CODES.AUTHENTICATE_FRICTIONLESS_FAILED:
                case VERIFICATION_CODES.AUTHENTICATE_FAILED_ACS_ERROR:
                    return "creditCardBankError";
                default:
                    return 'genericError';
            }
        }

        function submitPayment(paymentInfo) {
            const modal = $(this).parents('.modal');
            const path = that.studioPanelCsrfWrapper(that.studioPanelUri('/order/addcreditcard'), 'order_addcreditcard')

            $.post(path, paymentInfo, function (json) {

                $(modal).find('ul.form-error').remove();

                if (json.status == 'form_errors') {

                    that.loading('Processing', 'hide');

                    let formElementId, objKey;

                    for (formElementId in json.errors) {
                        for (objKey in json.errors[formElementId]) {
                            const msg = json.errors[formElementId][objKey];
                            $('#' + formElementId)
                                .parents('.form-group')
                                .find('label')
                                .first()
                                .after('<ul class="form-error list-unstyled"><li>' + msg + '</li></ul>');
                        }
                    }
                } else {
                    self.location.href = self.location.href;
                    return;
                }
            }, 'json')
        }

        function onThreeDSecureComplete(threeDSecureData, paymentDetails) {
            const { creditCard, paymentMethodNonce, verified, verifiedStatus } = threeDSecureData;

            that.loading('Processing', 'show');

            if (!verified) {
                let verificationMessage;
                const verificationKey = verifiedStatus
                    ? getBraintreeVerificationCodeKey(verifiedStatus)
                    : undefined;

                if (verificationKey) {
                    verificationMessage = $('#threeds-error-translation_' + verificationKey).val()
                }

                window.Sp.v2ReactBridge.showBraintreeChallenge({ errorMessage: verificationMessage, hasError: true });
                window.Sp.v2ReactBridge.closeBraintreeChallenge()

                that.loading('Processing', 'hide');

                return;
            }

            var paymentWithNonce = Object.assign(paymentDetails, {
                card_number: creditCard.lastFour,
                exp_month: creditCard.expirationMonth,
                exp_year: creditCard.expirationYear,
                payment_method_nonce: paymentMethodNonce
            })

            return submitPayment(paymentWithNonce)
        }

        function parseCreditCardDataFor3DS(paymentDetails) {
            return {
                number: paymentDetails.card_number,
                cvv: paymentDetails.csc_code,
                expirationDate: `${paymentDetails.exp_month}/${paymentDetails.exp_year}`,
                billingAddress: {
                    postalCode: paymentDetails.zip_postal
                }
            };
        }


        $('body').on('click', '.js-enter-credit-card', function (e) {
            e.preventDefault();
            $('#paymentDetailsModal').modal('hide');

            const stripeStandardOrderPaymentContainer = document.getElementById('stripeStandardOrderPaymentContainer');

            if (stripeStandardOrderPaymentContainer) {
                const currencyCode = stripeStandardOrderPaymentContainer.getAttribute('data-currency-code');
                const currencyMultiplier = parseInt(stripeStandardOrderPaymentContainer.getAttribute('data-currency-multiplier'));
                const orderAmount = parseFloat(stripeStandardOrderPaymentContainer.getAttribute('data-order-amount'));
                const orderId = stripeStandardOrderPaymentContainer.getAttribute('data-order-id');
                const staticUrl = stripeStandardOrderPaymentContainer.getAttribute('data-static-url');
                const stripeConfigId = stripeStandardOrderPaymentContainer.getAttribute('data-stripe-config-id');
                const stripeApiKey = stripeStandardOrderPaymentContainer.getAttribute('data-stripe-key');
                const stripeStandardAccountId = stripeStandardOrderPaymentContainer.getAttribute('data-stripe-standard-account-id');
        
                Sp.v2ReactBridge.showStripeStandardPaymentModal({
                    currencyCode,
                    currencyMultiplier,
                    orderAmount,
                    orderId,
                    staticUrl,
                    stripeApiKey,
                    stripeConfigId,
                    stripeStandardAccountId
                });
            } else {
                that.modal({
                    id: 'orderPaymentCreditCardModal',
                    title: 'Enter Client Credit Card Information',
                    body: _.template($('#templateAcceptCreditCard').html(), {}),
                    sizeClass: 'modal-md',
                    open: function () {
                        $('#' + this.id).find('select').select2({
                            width: '100%'
                        });
    
                        $('#creditCardAmountError').hide();
    
                        $('#cardNumber, #cscCode').on('blur', function () {
                            $(this).val(Sp.numbersOnly($(this).val()));
                        });
    
                        $('#transactionAmount').on('blur', function () {
                            $(this).val(Sp.moneyOnly($(this).val()));
                        });
    
                        const studioOrderPaymentContainer = document.getElementById('studioOrderPaymentContainer');
                        const errorContainer = document.getElementById('studioOrderPaymentError');
    
                        if (errorContainer && errorContainer.innerText && errorContainer.innerText.length) {
                            setOrderPaymentErrorMessage();
                        }
    
                        if (studioOrderPaymentContainer) {
                            const stripeKey = studioOrderPaymentContainer.getAttribute('data-stripe-key');
                            const amount = studioOrderPaymentContainer.getAttribute('data-order-amount');
    
                            window.Sp.v2ReactBridge.renderOrderPayment('studioOrderPaymentContainer', {
                                amount: Number(amount),
                                amountIsFixed: true,
                                onSubmit: onSubmitStripePayment,
                                stripeKey: stripeKey
                            });
                        }
                    },
                    buttons: [
                        {
                            label: 'Cancel',
                            close: true
                        },{
                            label: 'Process Transaction',
                            'class': 'btn-primary',
                            click: function () {
                                // If the Stripe-powered Order Payment modal exists, submit it instead
                                if (window.Sp.v2ReactBridge.orderPaymentFormRef && window.Sp.v2ReactBridge.orderPaymentFormRef.current) {
                                    window.Sp.v2ReactBridge.orderPaymentFormRef.current.submitForm();
    
                                    return;
                                }
    
                                const isBraintreeGateway = $('#is-braintree-gateway').val();
                                const use3DS = $('#braintree-has-3ds-enabled').val();
                                const paymentDetails = {
                                    order_id: that.jsValues.order.id,
                                    card_holder_name: $.trim($('#card_holder_name').val()),
                                    card_type: $('#card_type').val(),
                                    card_number: $.trim($('#card_number').val()),
                                    exp_month: $('#exp_month').val(),
                                    exp_year: $('#exp_year').val(),
                                    csc_code: $.trim($('#csc_code').val()),
                                    zip_postal: $.trim($('#billing_zip_postal').val()),
                                    transaction_amount: $.trim($('#transaction_amount').val()),
                                }
    
                                if (isBraintreeGateway && use3DS) {
                                    window.Sp.v2ReactBridge.showBraintreeChallenge({ errorMessage: '', hasError: false });
    
                                    const creditCardDetails = parseCreditCardDataFor3DS(paymentDetails)
    
                                    perform3DSVerification(
                                        creditCardDetails,
                                        paymentDetails.transaction_amount,
                                    ).then((threeDSecureData) => (
                                        onThreeDSecureComplete(threeDSecureData, paymentDetails)
                                    )).finally(() => {
                                        window.Sp.v2ReactBridge.closeBraintreeChallenge()
                                    })
                                } else {
                                    that.loading('Processing', 'show');
    
                                    submitPayment(paymentDetails)
                                }
                            }
                        }
                    ]
                });
            }
        });



        // is the order being marked paid?
        $('body').on('change', '#is-paid', function () {
            if ($(this).val() == '0') {
                $('.warning-digital-send').addClass('show');
            } else {
                $('.warning-digital-send').removeClass('show');
            }

            var val = $(this).val();

            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/order/updateispaid'), 'order_updateispaid'), {
                order_id: $(this).data('orderId'),
                is_paid: val
            }, function (data) {
                that.jsValues.order.is_paid = ((val === '1') ? true : false);
                that.hoverMessage.show(data.msg, data.status);
            }, 'json');
        });

        $('.client-comment-show-more').on('click', function() {
            var clientComment = $(this).siblings('.client-comment');

            if (clientComment.hasClass('client-comment-full')) {
                clientComment.removeClass('client-comment-full');
                clientComment.addClass('client-comment-partial');
                $(this).text('Show More');
            } else {
                clientComment.removeClass('client-comment-partial');
                clientComment.addClass('client-comment-full');
                $(this).text('Show Less');
            }
        });

        // if the studio changes the status of an order
        $('#orderStatusChange').on('change', function() {

            var selectedVal = $('#orderStatusChange').val();

            if (selectedVal === that.jsValues.order.order_status_id) {
                // The change event was triggered but the value is the same
                return;
            }

            if (that.jsValues.order.is_parent_order) {
                // Show a different modal if this is a parent order
                Sp.studio.modal({
                    title: 'Order Status Change',
                    body: _.template($('#templateOrderStatusChangeWithChildOrders').html(), {
                        newStatusId: selectedVal,
                        newStatus: that.jsValues.orderStatuses[selectedVal],
                        oldStatus: that.jsValues.orderStatuses[that.jsValues.order.order_status_id],
                        isSpPayments: that.jsValues.isSpPayments,
                        isSpPaymentsRefunded: that.jsValues.isSpPaymentsRefunded,
                        isLabOrder: that.jsValues.isLabOrder,
                        isSubmittedToLab: that.jsValues.isSubmittedToLab,
                        orderStatusEmailTemplates: that.jsValues.orderStatusEmailTemplates
                    }),
                    buttons: [
                        {
                            label: 'Cancel',
                            click: function () {
                                $('#orderStatusChange').val(that.jsValues.order.order_status_id).trigger('change');
                                $(this).parents('.modal').modal('hide');
                            }
                        },{
                            label: 'Update Status',
                            'class': 'btn-primary',
                            click: function() {

                                var modal = $(this).parents('div.modal');
                                modal.modal('hide');
                                that.loading('Updating Status', 'show');

                                $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/order/updatestatus'), 'order_updatestatus'), {
                                    order_id: that.jsValues.order.id,
                                    status_id: selectedVal,
                                    send_email: 0
                                }, function () {
                                    location.reload();
                                }, 'json');
                            }
                        }
                    ],
                    open: function () {
                        $('.modal .close').click(function () {
                            $('#orderStatusChange').val(that.jsValues.order.order_status_id).trigger('change');
                        });
                    }
                });

                return;
            }

            // When emailing the link, fetch the default message contents from
            // the server-side.
            $.get(that.studioPanelUri('/email/defaulttemplatecontents'), {
                email_template_type_id: 8,
                order_id: that.jsValues.order.id
            }, function (json) {
                // Once we've loaded the default subject and body, show the
                // modal.
                that.loading('Loading', 'hide');

                // Get the default message text at open time.
                var defaultSubject = '';
                var defaultMessageText = '';
                var defaultHeadline = '';

                // Set the subject and body values based on the response.
                if (json.subject) {
                    defaultSubject = json.subject;
                }

                if (json.body) {
                    defaultMessageText = json.body;
                }

                if (json.headline) {
                    defaultHeadline = json.headline;
                }

                Sp.studio.modal({
                    title: 'Order Status Change',
                    sizeClass: 'modal-fullscreen',
                    body: _.template($('#templateOrderStatusChange').html(), {
                        templateTypeId: 8,
                        subject: defaultSubject,
                        headline: defaultHeadline,
                        body: defaultMessageText,
                        newStatusId: selectedVal,
                        newStatus: that.jsValues.orderStatuses[selectedVal],
                        oldStatus: that.jsValues.orderStatuses[that.jsValues.order.order_status_id],
                        isSpPayments: that.jsValues.isSpPayments,
                        isSpPaymentsRefunded: that.jsValues.isSpPaymentsRefunded,
                        isLabOrder: that.jsValues.isLabOrder,
                        isSubmittedToLab: that.jsValues.isSubmittedToLab,
                        orderStatusEmailTemplates: that.jsValues.orderStatusEmailTemplates
                    }),
                    buttons: [],
                    open: function (e) {
                        that.initEmailPreview();

                        var previewEmail = function () {
                            var params = {
                                email_template_type_id: $('#templateTypeId').val(),
                                subject: $('#emailSubject').val(),
                                headline: $('#emailHeadline').val(),
                                body: $R('#emailMsg').source.getCode(),
                                order_id: that.jsValues.order.id,
                                order_status_id: selectedVal
                            };

                            that.handleEmailPreview(params);
                        };

                        $('#emailHeadline').on('input', function () {
                            previewEmail();
                        });

                        Sp.studio.editor('#emailMsg', {
                            minHeight: 100,
                            maxHeight: 300,
                            changeCallback: previewEmail
                        });

                        previewEmail();

                        $(e.target).find('input:checkbox').iCheck(that.configs.iCheck);

                        $('#emailTemplate').select2({
                            width: '100%',
                            minimumResultsForSearch: Infinity
                        }).on('change', function () {
                            if (this.value === '') {
                                $('#emailSubject').val(defaultSubject);
                                $('#emailHeadline').val(defaultHeadline);
                                $R('#emailMsg').source.setCode(defaultMessageText);
                                previewEmail();
                                return;
                            }

                            $.get(that.studioPanelUri('/email/templatecontents'), {
                                id: this.value,
                                order_id: that.jsValues.order.id
                            }, function (json) {
                                $('#emailSubject').val(json.subject)
                                $('#emailHeadline').val(json.headline);
                                $R('#emailMsg').source.setCode(json.body);
                                previewEmail();
                            }, 'json');
                        });

                        $('.modal .close, .email-preview .cancel-update-status').click(function () {
                            $('#orderStatusChange').val(that.jsValues.order.order_status_id).trigger('change');
                        });

                        $('.email-preview button.send-mail').click(function () {
                            var modal = $(this).parents('div.modal');
                            var sendEmail = 0;
                            var emailMsg = $('#emailMsg').val();
                            var subject = $('#emailSubject').val();
                            var headline = $('#emailHeadline').val();
                            var templateTypeId = $('#templateTypeId').val();


                            // The checkbox and message inputs are not present
                            // on combined Orders.
                            if (modal.find('input:checkbox').length > 0 &&
                                modal.find('input:checkbox').first().is(':checked')
                            ) {
                                sendEmail = 1;
                            }

                            modal.modal('hide');
                            that.loading('Updating Status', 'show');

                            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/order/updatestatus'), 'order_updatestatus'), {
                                order_id: that.jsValues.order.id,
                                status_id: selectedVal,
                                send_email: sendEmail,
                                email_msg: emailMsg,
                                subject: subject,
                                headline: headline,
                                email_template_type_id: templateTypeId
                            }, function (json) {
                                that.loading('Updating Status', 'hide');
                                that.jsValues.order.order_status_id = selectedVal;
                                that.hoverMessage.show(json.msg, json.status);
                            }, 'json');
                        });
                    }
                });
            });
        });

        $('.js-payment-details').on('click', function (e) {
            e.preventDefault();

            that.modal({
                id: 'paymentDetailsModal',
                title: 'Payment Details',
                body: _.template($('#templatePaymentInformation').html(), {
                    order: that.jsValues.order
                }),
                sizeClass: 'modal-md',
                open: function () {
                    var $modalContent = $('#' + this.id);

                    $modalContent.find('select').select2();

                    var $viewSpPayTransactionLink = $modalContent.find('.view-in-sp-pay');

                    if ($viewSpPayTransactionLink[0]) {
                        $.get(
                            that.studioPanelUri('/order/' + that.jsValues.order.id + '/sp-pay-transaction'),
                            function (json) {
                                $viewSpPayTransactionLink.attr('href', json['uiUrl']);
                            },
                            'json'
                        );
                    }
                },
                buttons: [
                    {
                        label: 'Close',
                        close: true
                    }
                ]
            });
        });

        $('body').on('click', '.js-issue-refund', function (e) {
            e.preventDefault();

            $('#paymentDetailsModal').modal('hide');
            that.loading('Loading', 'show');

            $.post(that.studioPanelUri('/order/refundallowed'), {
                order_id: that.jsValues.order.id
            }, function (json) {
                that.loading('Loading', 'hide');

                if (json.type === 'msg') {

                    that.modal({
                        title: json.title,
                        body: '<p>' + json.msg + '</p>',
                        sizeClass: 'modal-md',
                        buttons: [{
                            label: 'Ok',
                            'class': 'btn-primary',
                            close: true
                        }]
                    });

                } else if (json.type === 'void') {

                    that.modal({
                        title: 'Refund Payment?',
                        body: _.template($('#templateVoid').html(), {
                            amount: json.amount
                        }),
                        sizeClass: 'modal-md',
                        buttons: [
                            {
                                label: 'Cancel',
                                close: true
                            },{
                                label: 'Refund',
                                'class': 'btn-primary',
                                click: function () {
                                    $(this).parents('.modal').modal('hide');
                                    that.loading('Issuing Refund', 'show');

                                    $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/order/refund'), 'order_refund'), {
                                        order_id: that.jsValues.order.id,
                                        type: 'void'
                                    }, function (json) {
                                        Sp.studio.loading('Issuing Refund', 'hide');
                                        that.hoverMessage.show(json.msg, json.status);
                                    }, 'json');
                                }
                            }
                        ]
                    });

                } else if (json.type === 'refund') {

                    that.jsValues.order.maxRefund = json.amount;

                    that.modal({
                        title: 'Refund Payment?',
                        body: _.template($('#templateRefund').html(), {
                            allowedAmount: json.amount
                        }),
                        sizeClass: 'modal-md',
                        buttons: [
                            {
                                label: 'Cancel',
                                close: true
                            },{
                                label: 'Refund',
                                'class': 'btn-primary',
                                click: function () {

                                    var refundAmount = parseFloat(Sp.moneyOnly($('#refundAmount').val()));
                                    var refundNote = $('#refundNote').val();

                                    if (refundAmount > that.jsValues.order.maxRefund ||
                                        refundAmount <= 0 ||
                                        isNaN(refundAmount)) {

                                        $(this).parents('.modal').find('.input-group').addClass('has-error');
                                        $(this).parents('.modal').find('p.error').show();
                                        return;
                                    }

                                    $(this).parents('.modal').modal('hide');
                                    that.loading('Issuing Refund', 'show');

                                    $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/order/refund'), 'order_refund'), {
                                        order_id: that.jsValues.order.id,
                                        type: 'refund',
                                        amount: refundAmount,
                                        note: refundNote
                                    }, function (json) {
                                        that.loading('Issuing Refund', 'hide');

                                        // This signifies a different error coming back from the API
                                        // which we need to treat with a different modal
                                        if (json.status === 'error') {
                                            that.modal({
                                                title: json.title,
                                                body: '<p>' + json.msg + '</p>',
                                                sizeClass: 'modal-md',
                                                buttons: [{
                                                    label: 'Ok',
                                                    'class': 'btn-primary',
                                                    close: true
                                                }]
                                            });
                                        } else {
                                            that.hoverMessage.show(json.msg, json.status);
                                        }
                                    }, 'json');
                                }
                            }
                        ]
                    });
                }
            },
            'json');
        });

        $('.js-edit-studio-notes').on('click', function (e) {
            e.preventDefault();

            that.modal({
                title: 'Studio Notes',
                body: _.template($('#templateEditStudioNotes').html(), {}),
                open: function () {
                    $('#studioNoteText').val(that.jsValues.order.studio_notes);
                },
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Save',
                        'class': 'btn-primary',
                        click: function () {

                            var noteText = $('#studioNoteText').val();
                            $(this).parents('.modal').modal('hide');
                            that.loading('Saving', 'show');

                            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/order/note'), 'order_note'), {
                                order_id: that.jsValues.order.id,
                                note: noteText
                            }, function (json) {
                                that.loading('Saving', 'hide');

                                if (json.status === 'success') {
                                    that.jsValues.order = json.order;

                                    if (that.jsValues.order.studio_notes !== null) {
                                        $('#studioNotes').html(Sp.nl2br(that.jsValues.order.studio_notes));
                                        $('.js-studio-note-section').show();
                                        $('.js-add-studio-notes').hide()
                                    } else {
                                        $('.js-studio-note-section').hide();
                                        $('.js-add-studio-notes').show();
                                    }
                                }

                                that.hoverMessage.show(json.msg, json.status);
                            }, 'json');
                        }
                    }
                ]
            });
        });

        $('.order-item-whcc-card-preview').on('click', function() {
            const $this = $(this);
            const data = $this.data();
            const backProductImageUrl = data.backProductImageUrl;
            const frontProductImageUrl = data.frontProductImageUrl;

            window.Sp.v2ReactBridge.showOrderItemWhccCardPreviewModal($(this).next()[0], {
                backProductImageUrl: backProductImageUrl,
                frontProductImageUrl: frontProductImageUrl,
                withOpen: function (open) {
                    open();
                }
            });
        });
    },

    updateOrderItemProductOptions: function () {
        var that = this;

        this.loading('Loading Options', 'show');

        $.post(this.studioPanelUri('/order/itemoptions'), {
            lab_catalog_product_id: $('#newLabItemId').val()
        }, function (json) {

            $('#mounting *').remove();
            $('#mounting').html(
                _.template($('#templateProductAddonOptions').html(), {
                    options: json.mountingOptions,
                    defaultText: '- No Mounting -',
                    selectedValue: '',
                    currencySymbol: $('#newLabItemId').data('currencySymbol'),
                    quantity: $('#newOrderItemQuantity').val()
                })
            );

            $('#mounting').select2('destroy');
            $('#mounting').select2();

            if (json.mountingOptions.length === 0) {
                $('#formGroupMounting').hide();
            } else {
                $('#formGroupMounting').show();
            }

            // start texture options
            $('#texture *').remove();
            $('#texture').html(
                _.template($('#templateProductAddonOptions').html(), {
                    options: json.textureOptions,
                    defaultText: '- No Texture -',
                    selectedValue: '',
                    currencySymbol: $('#newLabItemId').data('currencySymbol'),
                    quantity: $('#newOrderItemQuantity').val()
                })
            );

            $('#texture').select2('destroy');
            $('#texture').select2();

            if (json.textureOptions.length === 0) {
                $('#formGroupTexture').hide();
            } else {
                $('#formGroupTexture').show();
            }

            // start coating options
            $('#coating *').remove();
            $('#coating').html(
                _.template($('#templateProductAddonOptions').html(), {
                    options: json.coatingOptions,
                    defaultText: '- No Coating -',
                    selectedValue: '',
                    currencySymbol: $('#newLabItemId').data('currencySymbol'),
                    quantity: $('#newOrderItemQuantity').val()
                })
            );

            $('#coating').select2('destroy');
            $('#coating').select2();

            if (json.coatingOptions.length === 0) {
                $('#formGroupCoating').hide();
            } else {
                $('#formGroupCoating').show();
            }

            that.loading('Loading Options', 'hide');
        }, 'json');

    },

    handleOrderPrint: function () {
        window.print();
    },

    updateOrderItemCropPreview: function (img) {

        var crop = $(img).parents('a.crop-image').data('crop');
        var cropPieces = crop.split(',');
        var bounds = $(img).parents('a.crop-image').data('bounds');
        var boundPieces = bounds.split(',');
        var canvasDepth = $(img).parents('a.crop-image').data('canvasDepth');
        var circleCrop = $(img).parents('a.crop-image').data('circleCrop');

        var widthPixels = img.width * (parseFloat(cropPieces[2]) - parseFloat(cropPieces[0]));
        var heightPixels = img.height * (parseFloat(cropPieces[3]) - parseFloat(cropPieces[1]));

        var boundRatio1 = parseFloat(boundPieces[2]) / parseFloat(boundPieces[3]);
        var boundRatio2 = parseFloat(boundPieces[3]) / parseFloat(boundPieces[2]);

        var ratio1, ratio2;

        // landscape crop
        if (widthPixels > heightPixels) {
            if (boundRatio1 > boundRatio2) {
                ratio1 = boundRatio1;
                ratio2 = boundRatio2;
            } else {
                ratio1 = boundRatio2;
                ratio2 = boundRatio1;
            }
        } else {
            if (boundRatio1 > boundRatio2) {
                ratio1 = boundRatio2;
                ratio2 = boundRatio1;
            } else {
                ratio1 = boundRatio1;
                ratio2 = boundRatio2;
            }
        }

        if (!Sp.hasOwnProperty('darkroomCropPreviews')) {
            Sp.darkroomCropPreviews = {};
        }

        // setup the crops now
        Sp.darkroomCropPreviews[img.id] = new Darkroom('#' + img.id, {
            plugins: {
                save: false,
                crop: {
                    minWidth: 50,
                    minHeight: 50,
                    ratio: ratio1,
                    ratio1: ratio1,
                    ratio2: ratio2,
                    bounds: boundPieces,
                    canvasDepth: canvasDepth,
                    circleCrop: circleCrop,
                    thirdsGrid: false,
                    lock: true
                }
            },
            init: function() {
                var cropPlugin = this.getPlugin('crop');
                cropPlugin.selectZone(
                    (this.canvas.width * (parseFloat(cropPieces[0]) / 100)),
                    (this.canvas.height * (parseFloat(cropPieces[1]) / 100)),
                    (this.canvas.width * ((parseFloat(cropPieces[2]) - parseFloat(cropPieces[0])) / 100)),
                    (this.canvas.height * ((parseFloat(cropPieces[3]) - parseFloat(cropPieces[1])) / 100)),
                    true);
            }
        });
    },

    handleReportGalleryVisitor: function () {
        var that = this;
        this.setupDatagridFilter();
        this.setupResubscribe();

        $('#rowSelectAll').on('ifToggled', function () {
            var isChecked = $('#rowSelectAll').is(':checked');

            $('div.table-body input:checkbox').each(function () {
                if (isChecked) {
                    $(this).iCheck('check');
                } else {
                    $(this).iCheck('uncheck');
                }
            });
        });

        $('div.table-body input:checkbox').on('ifChanged', function () {
            var total = $('div.table-body input:checkbox:checked').length;

            if (total) {
                $('#deleteVisitor').css('display', 'inline-block');
                $('#emailVisitors').addClass('disabled');
            } else {
                $('#deleteVisitor').hide();
                $('#emailVisitors').removeClass('disabled');
            }
        });

        $('#deleteVisitor').on('click', function (e) {
            e.preventDefault();
            var total = $('div.table-body input:checkbox:checked').length;

            that.modal({
                title: ((total > 1) ? 'Delete Visitors' : 'Delete Visitor'),
                body: _.template($('#templateDeleteVisitor').html(), {
                    num: total
                }),
                sizeClass: 'modal-md',
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Yes, Delete',
                        'class': 'btn-danger',
                        click: function () {
                            that.loading('Deleting', 'show');
                            var visitors = [];
                            $(this).parents('.modal').modal('hide');

                            $('div.table-body input:checkbox:checked').each(function () {
                                visitors.push($(this).val());
                            });

                            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/gallery/deletevisitor'), 'gallery_deletevisitor'), {
                                visitors: visitors
                            }, function () {
                               location.reload();
                            }, 'json');
                        }
                    }
                ]
            });
        });

        $('#emailVisitors').on('click', function (e) {
            e.preventDefault();
            const eventId = $(this).data('eventId');
            const isInTrial = Boolean($(this).data('isInTrial'));

            that.loading('Loading Email', 'show');

            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/email/templatelist'), 'email_templatelist'), {
                event_id: eventId,
                template_type_id: '1,2'
            }, function (json) {
                that.loading('Loading Email', 'hide');
                var templates = json.templates;

                that.modal({
                    title: 'Email Visitors',
                    body: _.template($('#templateEmailVisitors').html(), {
                        fromEmail: json.fromEmail,
                        templates: templates,
                        templateTypeId: 2
                    }),
                    sizeClass: 'modal-fullscreen',
                    open: function () {
                        that.initEmailPreview();

                        var previewEmail = function () {
                            var params = {
                                email_template_type_id: $('#templateTypeId').val(),
                                subject: $('#emailSubject').val(),
                                headline: $('#emailHeadline').val(),
                                button_text: $('#button_text').val(),
                                body: $R('#emailBody').source.getCode(),
                                event_id: eventId
                            };

                            that.handleEmailPreview(params);
                        };

                        var toggleButtonText = function (buttonText, buttonHelperText) {
                            // If we have button helper text, show the button field
                            if (buttonHelperText) {
                                $('#buttonTextHelper').html(buttonHelperText);
                                $('#button_text').val(buttonText);
                                $('#buttonText').show();
                            } else {
                                $('#buttonText').hide();
                                $('#button_text').val('');
                                $('#buttonTextHelper').html('');
                            }
                        };

                        $('#emailHeadline, #button_text').on('input', function () {
                            previewEmail();
                        });

                        $('#' + this.id).find('select').select2({
                            width: '100%',
                            minimumResultsForSearch: Infinity
                        });

                        that.editor('#emailBody', {
                            minHeight: 100,
                            maxHeight: 300,
                            changeCallback: previewEmail
                        });

                        const emailGalleryVisitorRecaptchaCallback = () => {
                            const modal = $('.modal');

                            modal.find('ul.form-error').remove();

                            const templateTypeId = $('#templateTypeId').val();

                            var error = false;
                            var to = $('#sendToList').val();

                            if (to === '') {
                                $('#sendToList')
                                    .parents('.form-group')
                                    .addClass('has-error')
                                    .append('<ul class="form-error list-unstyled"><li>Please select who to send this email to.</li></ul>');
                                error = true;
                            }

                            var subject = $.trim($('#emailSubject').val());

                            if (subject === '') {
                                $('#emailSubject')
                                    .parents('.form-group')
                                    .addClass('has-error')
                                    .append('<ul class="form-error list-unstyled"><li>Please specify the subject for the email.</li></ul>');
                                error = true;
                            }

                            var body = $.trim($R('#emailBody').source.getCode());

                            if (body === '') {
                                $('#emailBody')
                                    .parents('.form-group')
                                    .addClass('has-error')
                                    .append('<ul class="form-error list-unstyled"><li>Please specify the body for this email.</li></ul>');
                                error = true;
                            }

                            var headline = $.trim($('#emailHeadline').val());

                            if (error) {
                                if ($('#emailPreviewNavigation').is(':visible')) {
                                    $('.email-preview ul.on-page-tabs li.edit').click();
                                }
                                $(modal).animate({ scrollTop: 0 }, 'slow');
                                if ('grecaptcha' in window && window.grecaptcha && 'reset' in window.grecaptcha) {
                                    window.grecaptcha.reset();
                                }
                                return;
                            }

                            var buttonText = $.trim($('#button_text').val());

                            that.loading('Sending Email', 'show');

                            const recaptchaToken = ('grecaptcha' in window && window.grecaptcha && 'getResponse' in window.grecaptcha) 
                                ? window.grecaptcha.getResponse() 
                                : null;

                            $.post(that.studioPanelUri('/report/emailgalleryvisitor'), {
                                event_id: eventId,
                                to: to,
                                subject: subject,
                                body: body,
                                headline: headline,
                                button_text: buttonText,
                                template_type_id: templateTypeId,
                                recaptcha_token: recaptchaToken
                            }, function (json) {
                                that.loading('Sending Email', 'hide');

                                if (json.status === that.hoverMessage.type.success) {
                                    modal.modal('hide');
                                }

                                that.hoverMessage.show(json.msg, json.status);
                            }, 'json');
                        };

                        window.galleryVisitorRecaptchaCallback = emailGalleryVisitorRecaptchaCallback;

                        $('.email-preview button.send-mail').click(function () {
                            if ('grecaptcha' in window && window.grecaptcha) {
                                window.grecaptcha.ready(() => {
                                    window.grecaptcha.execute();
                                });
                            } else {
                                // If grecaptcha is not available (disabled for studio), call the callback directly
                                window.galleryVisitorRecaptchaCallback();
                            }
                        });

                        $.get(that.studioPanelUri('/email/defaulttemplatecontents'), {
                            email_template_type_id: 2,
                            event_id: eventId
                        }, function (templateDefaults) {
                            $('#emailSubject').val(templateDefaults.subject);
                            $('#emailHeadline').val(templateDefaults.headline);
                            $('#emailBody').val(templateDefaults.body);

                            toggleButtonText(templateDefaults.buttonText, templateDefaults.buttonTextHelper);

                            var baseTemplateTypeId = $('#templateTypeId').val();
                            var baseSubject = $('#emailSubject').val();
                            var baseHeadline = $('#emailHeadline').val();
                            var baseBody = $('#emailBody').val();
                            var baseButtonText = templateDefaults.buttonText;
                            var baseButtonTextHelper = templateDefaults.buttonTextHelper;

                            $('#emailTemplateId').on('change', function () {
                                if (this.value !== '') {
                                    var template = Sp.getObjectById(this.value, templates);
                                    $('#emailSubject').val(template.subject);
                                    $R('#emailBody').source.setCode(template.body);
                                    $('#emailHeadline').val(template.headline);
                                    $('#templateTypeId').val(template.email_template_type_id);
                                    toggleButtonText(template.buttonText, template.email_template_type.defaults.buttonTextHelper);
                                } else {
                                    $('#emailSubject').val(baseSubject);
                                    $R('#emailBody').source.setCode(baseBody);
                                    $('#emailHeadline').val(baseHeadline);
                                    $('#templateTypeId').val(baseTemplateTypeId);
                                    toggleButtonText(baseButtonText, baseButtonTextHelper);
                                }

                                previewEmail();
                            });

                            previewEmail();
                        });
                    },
                    buttons: []
                });
            }, 'json');
        });

        $('#addEventEmail').click(function (e) {
            e.preventDefault();
            var eventId = $(this).data('eventId');

            that.loading('Loading', 'show');

            const addGalleryEmailRecaptchaCallback = () => {
                const modal = $('.modal');
                that.loading('Processing', 'show');

                const recaptchaToken = ('grecaptcha' in window && window.grecaptcha && 'getResponse' in window.grecaptcha) 
                    ? window.grecaptcha.getResponse() 
                    : null;

                $.post(that.studioPanelUri('/gallery/addemail'), {
                    event_id: eventId,
                    token:  $('#token').val(),
                    email: $('#email').val(),
                    recaptcha_token: recaptchaToken
                },
                function (json) {
                    that.loading('Processing', 'hide');

                    if (json.status === 'success') {
                        // Reload the entire page so the new
                        // address appears.
                        location.reload();
                    } else if (json.status === 'form_errors') {
                        that.displayFormErrors(modal, json.errors);
                        if ('grecaptcha' in window && window.grecaptcha && 'reset' in window.grecaptcha) {
                            window.grecaptcha.reset();
                        }
                    }
                },
                'json');
            };

            window.galleryVisitorRecaptchaCallback = addGalleryEmailRecaptchaCallback;

            $.get(that.studioPanelUri('/gallery/addemail'), {
                event_id: eventId
            }, function (html) {
                that.loading('Loading', 'hide');

                that.modal({
                    title: 'Add Gallery Visitor',
                    body: _.template(html, {}),
                    buttons: [
                        {
                            label: 'Cancel',
                            close: true
                        },                        {
                            label: 'Save',
                            'class': 'btn-primary',
                            click: function () {
                                if ('grecaptcha' in window && window.grecaptcha) {
                                    window.grecaptcha.ready(() => {
                                        window.grecaptcha.execute();
                                    });
                                } else {
                                    // If grecaptcha is not available, call the callback directly
                                    window.galleryVisitorRecaptchaCallback();
                                }
                            }
                        }
                    ]
                });

            });
        });
    },

    handleReportSale: function () {
        $('#reportToggle').change(function () {
            self.location.href = $(this).val();
        });
    },

    handlePrintStoreReportSale: function () {
        $('#reportPrintStoreToggle').change(function () {
            self.location.href = $(this).val();
        });
    },

    handleReportItem: function () {
        $('#daysFilter').change(function () {
            self.location.href = '?days=' + this.value;
        });
    },

    handleAccountAcceptpayments: function () {
        var that = this;

        if ($('#setupStep1').data('hasStripePaymentsEnabled')) {
            var removeGatewayButton = '<a href="#" class="btn btn-danger btn-sm remove-gateway">Remove Payment Gateway</a>';
            $('.on-page-help.dropdown-toggle').before(removeGatewayButton);
        }

        // Number of requests to verification service exceeded case
        if (that.jsValues.identityFormDisabled) {
            // disable the input elements (no form tag?)
            $('input, select, button', '#identityForm').prop('disabled', true);
            // show the warning div above the form with a message explaining the problem and show the div
            $('#maxAttempts').show();
        }

        $('.setup-shootproof-payments').on('click', function (e) {
            e.preventDefault();

            // hide the initial display
            $('#setupStep1').hide();
            $('.page-title').hide();

            // show the identity form
            $('#identityForm').show();

            var helperText = '<p class="helper-text">We need your SSN to keep your identity secure. <a href="https://help.shootproof.com/hc/en-us/articles/115008322368" target="_target">Learn more.</a></p>';
            $('.hideShowPassword-wrapper').after(helperText);
        });

        $('body').on('click', '.cancel-flow', function (e) {
            e.preventDefault();
            self.location.href = that.studioPanelUri('/account/acceptpayments');
        });

        $('.setup-paypal-basic').on('click', function (e) {
            e.preventDefault();

            that.modal({
                title: ' ',
                body: _.template($('#templatePayPalBasic').html(), {}),
                buttons: [{
                    label: 'Save',
                    'class': 'btn-primary',
                    click: function () {

                        var merchantId = $.trim($('#paypal_basic_merchant_id').val());

                        if (merchantId === '') {
                            $('#paypal_basic_merchant_id').parents('.form-group').addClass('has-error');
                            return;
                        }

                        that.loading('Setting Gateway', 'show');

                        $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/account/acceptpayments'), 'account_acceptpayments'), {
                            'action': 'set-gateway',
                            'gateway_type': 'paypal.basic',
                            'paypal_basic_merchant_id': merchantId
                        }, function () {
                            if (window.trackPendoEvent){
                                window.trackPendoEvent('Payment Gateway Connected', { type: 'PayPal Basic' });
                            }
                            self.location.href = that.studioPanelUri('/account/acceptpayments');
                        }, 'json');
                    }
                }]
            });
        });

        $('.setup-paypal-pro').on('click', function (e) {
            e.preventDefault();

            that.modal({
                title: ' ',
                body: _.template($('#templatePayPalPro').html(), {}),
                sizeClass: 'modal-md',
                buttons: [{
                    label: 'Save',
                    'class': 'btn-primary',
                    click: function () {

                        $(this).parents('.modal').find('.has-error').removeClass('has-error');

                        var username = $.trim($('#paypal_pro_username').val());

                        if (username === '') {
                            $('#paypal_pro_username').parents('.form-group').addClass('has-error');
                            return;
                        }

                        var password = $.trim($('#paypal_pro_password').val());

                        if (password === '') {
                            $('#paypal_pro_password').parents('.form-group').addClass('has-error');
                            return;
                        }

                        var signature = $.trim($('#paypal_pro_signature').val());

                        if (signature === '') {
                            $('#paypal_pro_signature').parents('.form-group').addClass('has-error');
                            return;
                        }

                        that.loading('Setting Gateway', 'show');

                        $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/account/acceptpayments'), 'account_acceptpayments'), {
                            'action': 'set-gateway',
                            'gateway_type': 'paypal.pro',
                            'paypal_pro_username': username,
                            'paypal_pro_password': password,
                            'paypal_pro_signature': signature
                        }, function () {
                            if (window.trackPendoEvent){
                                window.trackPendoEvent('Payment Gateway Connected', { type: 'PayPal Pro' });
                            }
                            self.location.href = that.studioPanelCsrfWrapper(
                                that.studioPanelUri('/account/acceptpayments'),
                                'account_acceptpayments'
                            );
                        }, 'json');
                    }
                }]
            });
        });

        $('.setup-authorize-net').on('click', function (e) {
            e.preventDefault();

            that.modal({
                title: ' ',
                body: _.template($('#templateAuthorizeNet').html(), {}),
                sizeClass: 'modal-md',
                buttons: [{
                    label: 'Save',
                    'class': 'btn-primary',
                    click: function () {

                        $(this).parents('.modal').find('.has-error').removeClass('has-error');

                        var login = $.trim($('#authorize_api_login').val());

                        if (login === '') {
                            $('#authorize_api_login').parents('.form-group').addClass('has-error');
                            return;
                        }

                        var key = $.trim($('#authorize_trans_key').val());

                        if (key === '') {
                            $('#authorize_trans_key').parents('.form-group').addClass('has-error');
                            return;
                        }

                        that.loading('Setting Gateway', 'show');

                        $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/account/acceptpayments'), 'account_acceptpayments'), {
                            'action': 'set-gateway',
                            'gateway_type': 'authorize_net',
                            'authorize_api_login': login,
                            'authorize_trans_key': key
                        }, function () {
                            if (window.trackPendoEvent){
                                window.trackPendoEvent('Payment Gateway Connected', { type: 'Auth.net' });
                            }
                            self.location.href = that.studioPanelCsrfWrapper(
                                that.studioPanelUri('/account/acceptpayments'),
                                'account_acceptpayments'
                            );
                        }, 'json');
                    }
                }]
            });
        });

        $('.setup-braintree').on('click', function (e) {
            e.preventDefault();

            that.modal({
                title: ' ',
                body: _.template($('#templateBraintree').html(), {}),
                sizeClass: 'modal-md',
                buttons: [{
                    label: 'Save',
                    'class': 'btn-primary',
                    click: function () {

                        $(this).parents('.modal').find('.has-error').removeClass('has-error');

                        var merchantId = $.trim($('#braintree_merchant_id').val());

                        if (merchantId === '') {
                            $('#braintree_merchant_id').parents('.form-group').addClass('has-error');
                            return;
                        }

                        var privateKey = $.trim($('#braintree_private_key').val());

                        if (privateKey === '') {
                            $('#braintree_private_key').parents('.form-group').addClass('has-error');
                            return;
                        }

                        var publicKey = $.trim($('#braintree_public_key').val());

                        if (publicKey === '') {
                            $('#braintree_public_key').parents('.form-group').addClass('has-error');
                            return;
                        }

                        that.loading('Setting Gateway', 'show');

                        $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/account/acceptpayments'), 'account_acceptpayments'), {
                            'action': 'set-gateway',
                            'gateway_type': 'braintree',
                            'braintree_merchant_id': merchantId,
                            'braintree_private_key': privateKey,
                            'braintree_public_key': publicKey
                        }, function () {
                            if (window.trackPendoEvent){
                                window.trackPendoEvent('Payment Gateway Connected', { type: 'Braintree' });
                            }
                            self.location.href = that.studioPanelCsrfWrapper(
                                that.studioPanelUri('/account/acceptpayments'),
                                'account_acceptpayments'
                            );
                        }, 'json');
                    }
                }]
            });
        });

        $('.remove-gateway').on('click', function (e) {
            e.preventDefault();
            var currentGatewayType = $('#setupStep1').data('currentGatewayType');
            var hasProfitBalance = $('#setupStep1').data('hasProfitBalance');
            var hasStripePaymentsEnabled = $('#setupStep1').data('hasStripePaymentsEnabled');
            var extendedURI = hasStripePaymentsEnabled
                ? '?action=remove-gateway&remove-gateway-success=true'
                : '?action=remove-gateway';
            var hasAwaitingLabOrders = parseInt($('#setupStep1').data('ordersAwaitingStudio')) > 0;
            var hasNegativeBalance = parseInt($('#setupStep1').data('currentMoneyBalance')) < 0;
            var isCurrentGatewaySPPayments = currentGatewayType === 'shootproof';

            if (isCurrentGatewaySPPayments && hasNegativeBalance) {
                that.modal({
                    title: _.template($('#templateRemoveGatewayWarningHeader').html(), {}),
                    body: _.template($('#templateRemoveGatewayWarningBody').html(), {
                        hasNegativeBalance: true,
                        hasAwaitingLabOrders: false
                    }),
                    sizeClass: 'modal-md',
                    buttons: [
                        {
                            label: 'Close',
                            'class': 'btn-primary',
                            close: true
                        }
                    ]
                });
            } else if (isCurrentGatewaySPPayments && hasAwaitingLabOrders) {
                that.modal({
                    title: _.template($('#templateRemoveGatewayWarningHeader').html(), {}),
                    body: _.template($('#templateRemoveGatewayWarningBody').html(), {
                        hasNegativeBalance: false,
                        hasAwaitingLabOrders: true
                    }),
                    sizeClass: 'modal-md',
                    buttons: [
                        {
                            label: 'Close',
                            'class': 'btn-primary',
                            close: true
                        }
                    ]
                });
            } else if (
                hasStripePaymentsEnabled &&
                isCurrentGatewaySPPayments &&
                hasProfitBalance
            ) {
                that.modal({
                    title: _.template($('#templateFundAvailbleInfoHeader').html(), {}),
                    body: _.template($('#templateFundAvailbleInfoBody').html(), {}),
                    sizeClass: 'modal-md',
                    buttons: [
                        {
                            label: 'Cancel',
                            'class': 'btn-secondary',
                            close: true
                        },
                        {
                            label: 'Continue',
                            'class': 'btn-primary',
                            close: true,
                            click: function () {
                                openRemovePaymentGatewayModal();
                            }
                        }
                    ]
                });
            } else {
                openRemovePaymentGatewayModal();
            }

            function openRemovePaymentGatewayModal() {
                that.modal({
                    title: 'Remove Payment Gateway',
                    body: _.template($('#templateRemoveGateway').html(), {
                        numInvoiceCreditCards: that.jsValues.invoiceCreditCardUsage.numInvoiceCreditCards,
                        numAutoPayEnabled: that.jsValues.invoiceCreditCardUsage.numAutoPayEnabled
                    }),
                    sizeClass: 'modal-md',
                    buttons: [
                        {
                            label: 'Cancel',
                            close: true
                        },{
                            label: 'Remove Gateway',
                            'class': 'btn-danger',
                            click: function () {
                                that.loading('Removing Gateway', 'show');
                                self.location.href = that.studioPanelCsrfWrapper(
                                    that.studioPanelUri('/account/acceptpayments') + extendedURI,
                                    'account_acceptpayments'
                                );
                            }
                        }
                    ]
                });
            }
        });

        // setup click handlers
        $('#zip_postal').on('blur', function () {
            this.value = Sp.numbersOnly(this.value);
        });

        $('#ssn').on('keyup', function () {
            this.value = Sp.numbersOnly(this.value);
        });

        $('#ssn').showPassword('focus', {
            show: false,
            toggle: {
                className: 'ssn-toggle',
                attachToKeyEvent: false
            },
            wrapper: {
                enforceWidth: false
            }
        });

        $('#identitySubmit').on('click', function () {

            that.loading('Verifying Identity', 'show');
            var form = $('#identityForm');

            that.jsValues.step1Params = {
                step: '1a',
                first_name: $(form).find('input[name="first_name"]').val(),
                last_name: $(form).find('input[name="last_name"]').val(),
                address_1: $(form).find('input[name="address_1"]').val(),
                city: $(form).find('input[name="city"]').val(),
                state: $('#state').val(),
                zip_postal: $(form).find('input[name="zip_postal"]').val(),
                ssn: $(form).find('input[name="ssn"]').val(),
                birth_year: $('#birth_year').val(),
                birth_month: $('#birth_month').val(),
                birth_day: $('#birth_day').val(),
                business_name: $(form).find('input[name="business_name"]').val(),
                phone: $(form).find('input[name="phone"]').val(),
                terms: $(form).find('input[name="terms"]:checked').length
            };

            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/account/identity'), 'account_identity'),
                that.jsValues.step1Params,
                function (json) {
                    that.loading('Verifying Identity', 'hide');

                    if (json.status === 'form_errors') {
                        $('.form-group.has-error').removeClass('has-error');
                        that.displayFormErrors(form, json.errors);

                        if (json.errors.ssn) {
                            $('.hideShowPassword-wrapper ~ .helper-text').hide();
                        } else {
                            $('.hideShowPassword-wrapper ~ .helper-text').show();
                        }

                        return;
                    } else if (json.status === 'max-attempts') {
                        $('#maxAttempts').show();
                        return;
                    } else if (json.status === 'no-identity') {
                        that.hoverMessage.show(json.msg, 'warning', 3000);
                        return;
                    } else if (json.status === 'questions') {
                        that.jsValues.step1Params.verifyHash = json.verifyHash;

                        $('#identityForm').hide();

                        $('#identityQuestions').html(_.template($('#templateVerifyQuestions').html(), {
                            questions: json.questions
                        }));

                        $('#identityQuestions').find(':radio').iCheck(that.configs.iCheck);
                        $('#identityQuestions').show();

                    } else if (json.status === 'verified') {
                        that.jsValues.step1Params.verifyHash = json.verifyHash;
                        $('#identityForm').hide();

                        that.verifyUserStep2(json.form);
                    }
                }, 'json');
        });

        $('#identityQuestions').on('click', '#questionsSubmit', function () {

            var answers = [];
            var error = false;

            $('.question-answers').each(function () {
                if (!$(this).find('input:radio:checked').length) {
                    that.hoverMessage.show('Please answer all questions before proceeding.', 'warning', 1000);
                    error = true;
                    return false;
                }

                answers.push({
                    type: $(this).data('questionType'),
                    answer: $(this).find('input:radio:checked').val(),
                    num: $(this).data('question')
                });
            });

            if (error) {
                return;
            }

            that.loading('Submitting', 'show');

            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/account/identity'), 'account_identity'), {
                step: '1b',
                hash: that.jsValues.step1Params.verifyHash,
                answers: answers
            }, function (json) {

                that.loading('Submitting', 'hide');

                if (json.status === 'verified') {
                    $('#identityQuestions').hide();
                    that.verifyUserStep2(json.form);
                    return;
                }

                $('#identityQuestions').html(
                    _.template($('#templateUnableToVerify').html(), {
                        attempts: that.jsValues.identityAttempts
                    })
                );
            }, 'json');
        });

        $('#identityQuestions').on('click', '#tryIdentityAgain', function () {
            self.location.href = that.studioPanelCsrfWrapper(
                that.studioPanelUri('/account/acceptpayments') + '?attempts=1#stepIdentity',
                'account_acceptpayments'
            );
        });

        $('body').on('blur', '#confirm_routing_number', function () {
            if ($(this).val().length === 9) {
                $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/account/routingbank'), 'account_routingbank'), {
                    routing: $(this).val()
                }, function (json) {
                    $('.bank-name').text(json.name);
                }, 'json');
            } else {
                $('.bank-name').text('');
            }
        });

        $('input[name="deposit_frequency"]').on('ifChecked', function () {
            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/account/depositfrequency'), 'account_depositfrequency'), {
                freq: $('input[name="deposit_frequency"]:checked').val()
            }, function () {
            }, 'json');
        });

        if (window.location.hash === '#stepIdentity') {
            $('.setup-shootproof-payments').trigger('click');
        }
    },

    verifyUserStep2: function (formHtml) {
        var that = this;
        var accountNumberReset = false;

        $('#bankingForm').html(formHtml);
        $('#bankingForm').find(':radio, :checkbox').iCheck(that.configs.iCheck);
        $('#bankingForm').find('select').select2();
        $('#bankingForm').show();

        $('input[name="account_number"]').on('focus', function () {
            if (!accountNumberReset && $(this).val().includes('*')) {
                $(this).val('');
                $('input[name="confirm_account_number"]').val('');
                accountNumberReset = true;
            }
        });

        $('input[name="confirm_account_number"]').on('focus', function () {
            if (!accountNumberReset && $(this).val().includes('*')) {
                $(this).val('');
                $('input[name="account_number"]').val('');
                $('input[name="account_number"]').focus();
                accountNumberReset = true;
            }
        });

        $('#bankingSubmit').on('click', function () {

            that.loading('Saving', 'show');
            var form = $('#bankingForm');

            var step2Params = {
                account_type: $('#account_type').val(),
                account_use: $('#account_use').val(),
                name_on_account: $(form).find('input[name="name_on_account"]').val(),
                account_number: $(form).find('input[name="account_number"]').val(),
                confirm_account_number: $(form).find('input[name="confirm_account_number"]').val(),
                routing_number: $(form).find('input[name="routing_number"]').val(),
                confirm_routing_number: $(form).find('input[name="confirm_routing_number"]').val(),
                auto_send_frequency: $(form).find('input[name="auto_send_frequency"]:checked').val()
            };

            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/account/banking'), 'account_banking'), {
                step1: that.jsValues.step1Params,
                step2: step2Params
            }, function (json) {

                if (json.status === 'form_errors') {
                    that.loading('Saving', 'hide');
                    that.displayFormErrors(form, json.errors);
                    return;
                }

                location.reload();
            }, 'json');
        });
    },

    handleAccountPaymentCompliance: function () {

        var that = this;

        // setup click handlers
        $('#zip_postal').on('blur', function () {
            this.value = Sp.numbersOnly(this.value);
        });

        $('#ssn').on('keyup', function () {
            this.value = Sp.numbersOnly(this.value);
        });

        $('#ssn').showPassword('focus', {
            show: false,
            toggle: {
                className: 'ssn-toggle',
                attachToKeyEvent: false
            },
            wrapper: {
                enforceWidth: false
            }
        });

        var helperText = '<p class="helper-text">We need your SSN to keep your identity secure. <a href="https://help.shootproof.com/hc/en-us/articles/115008322368" target="_target">Learn more.</a></p>';
        $('.hideShowPassword-wrapper').after(helperText);

        $('#identitySubmit').on('click', function () {

            that.loading('Verifying Identity', 'show');
            var form = $('#identityForm');

            that.jsValues.step1Params = {
                step: '1a',
                first_name: $(form).find('input[name="first_name"]').val(),
                last_name: $(form).find('input[name="last_name"]').val(),
                address_1: $(form).find('input[name="address_1"]').val(),
                city: $(form).find('input[name="city"]').val(),
                state: $('#state').val(),
                zip_postal: $(form).find('input[name="zip_postal"]').val(),
                ssn: $(form).find('input[name="ssn"]').val(),
                birth_year: $('#birth_year').val(),
                birth_month: $('#birth_month').val(),
                birth_day: $('#birth_day').val(),
                business_name: $(form).find('input[name="business_name"]').val(),
                phone: $(form).find('input[name="phone"]').val(),
                terms: $(form).find('input[name="terms"]:checked').length
            };

            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/account/identity'), 'account_identity'),
                that.jsValues.step1Params,
                function (json) {
                    that.loading('Verifying Identity', 'hide');

                    if (json.status === 'form_errors') {
                        $('.form-group.has-error').removeClass('has-error');
                        that.displayFormErrors(form, json.errors);

                        if (json.errors.ssn) {
                            $('.hideShowPassword-wrapper ~ .helper-text').hide();
                        } else {
                            $('.hideShowPassword-wrapper ~ .helper-text').show();
                        }

                        return;
                    } else if (json.status === 'max-attempts') {
                        $('#maxAttempts').show();
                        return;
                    } else if (json.status === 'no-identity') {
                        that.hoverMessage.show(json.msg, 'warning', 3000);
                        return;
                    } else if (json.status === 'questions') {
                        that.jsValues.step1Params.verifyHash = json.verifyHash;

                        $('#identityForm').hide();

                        $('#identityQuestions').html(_.template($('#templateVerifyQuestions').html(), {
                            questions: json.questions
                        }));

                        $('#identityQuestions').find(':radio').iCheck(that.configs.iCheck);
                        $('#identityQuestions').show();

                    } else if (json.status === 'verified') {
                        that.loading('Verifying Identity', 'show');
                        that.jsValues.step1Params.verifyHash = json.verifyHash;

                        $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/account/paymentcompliance'), 'account_paymentcompliance'),
                            that.jsValues.step1Params,
                            function (json) {

                                if (json.status === 'success') {
                                    self.location.href = that.studioPanelUri('/dashboard');
                                    return;
                                }

                            }, 'json');
                    }
                }, 'json');
        });

        $('#identityQuestions').on('click', '#questionsSubmit', function () {

            var answers = [];
            var error = false;

            $('.question-answers').each(function () {
                if (!$(this).find('input:radio:checked').length) {
                    that.hoverMessage.show('Please answer all questions before proceeding.', 'warning', 1000);
                    error = true;
                    return false;
                }

                answers.push({
                    type: $(this).data('questionType'),
                    answer: $(this).find('input:radio:checked').val(),
                    num: $(this).data('question')
                });
            });

            if (error) {
                return;
            }

            that.loading('Submitting', 'show');

            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/account/identity'), 'account_identity'), {
                step: '1b',
                hash: that.jsValues.step1Params.verifyHash,
                answers: answers
            }, function (json) {

                if (json.status === 'verified') {
                    $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/account/paymentcompliance'), 'account_paymentcompliance'),
                        that.jsValues.step1Params,
                        function (json) {

                            if (json.status === 'success') {
                                self.location.href = that.studioPanelUri('/dashboard');
                                return;
                            }

                        }, 'json');

                    return;
                } else {
                    that.loading('Submitting', 'hide');
                }

                $('#identityQuestions').html(
                    _.template($('#templateUnableToVerify').html(), {
                        attempts: that.jsValues.identityAttempts
                    })
                );
            }, 'json');
        });

        $('#identityQuestions').on('click', '#tryIdentityAgain', function () {
            self.location.href = that.studioPanelCsrfWrapper(
                that.studioPanelUri('/account/acceptpayments') + '?attempts=1#stepIdentity',
                'account_acceptpayments'
            );
        });
    },

    handleAccountUser: function () {
        var that = this;

        $('.user-duplicate').click(function (e) {
            e.preventDefault();
            const userId = $(e.target).parents('a.tr').data('userId');
            that.handleAddUser(userId);
        });
        $('.user-new').click(function (e) {
            e.preventDefault();
            that.handleAddUser();
        })
    },

    handleAccountUseredit: function () {
        var that = this;
        var originalEmail = $('#email').val();
        var beforeSend = function (xhr) {
            xhr.setRequestHeader('Authorization', Sp.studio.studioV3DataToken);
        };
        var passwordFormState = {
            isPasswordValid: true
        };

        that.renderPasswordForm({
            passwordFormState: passwordFormState,
            showValidation: false
        });

        $('.remove-mfa').click(function (e) {
            var mfaPhone = $(this).data('mfa-phone') || null;

            e.preventDefault();

            function requestMfaCode() {
                return new Promise((resolve, reject) => $.ajax({
                    type: "POST",
                    url: Sp.urls.api + "/me/mfa/code",
                    contentType: "application/vnd.shootproof+json",
                    data: JSON.stringify({ type: "user-mfa-code" }),
                    beforeSend,
                    success: resolve,
                    error: reject,
                }));
            }

            function deleteMfa(code) {
                return new Promise((resolve, reject) => $.ajax({
                    type: "DELETE",
                    url: Sp.urls.api + "/me/mfa",
                    contentType: "application/vnd.shootproof+json",
                    data: JSON.stringify({ code }),
                    beforeSend,
                    success: resolve,
                    error: reject,
                }));
            }

            window.Sp.v2ReactBridge.showMfaDeleteModal({
                onDeleteAttempt: deleteMfa,
                onRequestCode: requestMfaCode,
                onSuccess: () => location.reload(),
                mfaPhone: mfaPhone
             });
        })

        $('.user-duplicate').click(function (e) {
            e.preventDefault();
            that.handleAddUser($(this).data('userId'));
        })
        $('.user-delete').click(function () {
            that.displayUserDeleteModal(this, that, true);
        });

        $('.user-status').click(function () {
            that.displayUserStatusModal(this, that, true);
        });

        $('#email').on('keyup', function (e) {
            // If the email address value is changing, let the user know that
            // a password reset email will be sent if the password
            // isn't being specified.
            if ($(e.target).val() != originalEmail && $('#password').val() === '' && originalEmail !== '') {
                $('p.error.reset-password').show();
            } else {
                $('p.error.reset-password').hide();
            }
        });

        // Watch for password changing, because if the user is specifying a
        // password and changing the user's email address, we don't need to
        // send the user an email to reset their password because the Studio
        // owner is specifying it.
        $('[name="password"]')
            .on('keyup', function (e) {
                if ($(e.target).val() === '' && $('#email').val() != originalEmail && originalEmail !== '') {
                    $('p.error.reset-password').show();
                } else {
                    $('p.error.reset-password').hide();
                }
            })
            .on('focus', function () {
                $(this).parents('#password-form').siblings('.form-error').remove();
            });

        $('#save').click(function () {
            if (passwordFormState.isPasswordValid) {
                $('[name="confirmPassword"]').attr('name', 'confirm_password');
                $('#userForm').submit();
            }
        });

        // Make the cancel button return to the user listing page when clicked
        $('#cancel').click(function () {
            window.location.href = $(this).data('url');
        });

        // Submit the form when the Save button is clicked
        $('#save').click(function () {
            $(this).closest('form').submit();
        });

        $('.permission_toggle').on('ifChecked', function () {
            var permissionColumnClass = '.' + $(this).data('permissionColumn');
            $(permissionColumnClass).iCheck('check');
        });

        $('.permission_toggle').on('ifUnchecked', function () {
            var permissionColumnClass = '.' + $(this).data('permissionColumn');
            $(permissionColumnClass).iCheck('uncheck');
        });

        // Initialize the permission toggle checkboxes to checked or unchecked,
        // according to whether all boxes in the column are checked.
        $('.permission_toggle').each(function () {
            var allChecked = true;
            var permissionColumnClass = '.' + $(this).data('permissionColumn');

            $(permissionColumnClass).each(function () {
                if (!this.checked) {
                    allChecked = false;
                    return false;
                }
            });

            if (allChecked) {
                $(this).iCheck('check');
            }
        });

        // enforce that when editis checked that view is also checked
        $('.edit-toggle').on('ifChecked', function () {
            $(this).parents('.form-group').first().find('.edit-lock').iCheck('check');
        });
    },

    handleAccountPlanBilling: function () {
        var that = this;
        var moneyBalance = that.jsValues.studioMoneyBalance > 0
            ? that.jsValues.studioMoneyBalanceCurrencySymbol + that.jsValues.studioMoneyBalance
            : undefined;

        const { emailVerification } = this.jsValues;

        window.Sp.v2ReactBridge.showPlanBillingSubNav({
            initialTab: 'plan-info',
            maskedCreditCardNumber: that.jsValues.cardOnFile,
            onCreditCardFormSubmit: that.updateCardOnFile,
            onTabChange: function (tab) {
                $planInfoPage = $('#plan-info-page');

                if (tab === 'plan-info') {
                    $planInfoPage.show();
                } else {
                    $planInfoPage.hide();
                }
            },
            showLabCreditTab: that.jsValues.studioHasLabCredit,
            onSendVerificationEmail: handleSendVerificationEmail(emailVerification),
            isEmailVerified: emailVerification.isVerified
        });
        window.Sp.v2ReactBridge.showMusicPlanSection({
            canStartTrial: that.jsValues.canStartMusicTrial,
            moneyBalance: moneyBalance,
            musicPlans: that.jsValues.musicPlans,
            onCancelPlan: function () {
                that.loading('Canceling', 'show');

                self.location.href = that.studioPanelUri('/music/cancel');
            },
            onChangePlan: function (musicPlan) {
                var currentUri = window.location.toString();
                var cleanUri = currentUri.substring(0, currentUri.indexOf('?'));
                var musicPlanId = musicPlan.isMonthly ? musicPlan.monthly.plan_id : musicPlan.yearly.plan_id;

                that.loading('Changing Plans', 'show');
                window.history.replaceState({}, document.title, cleanUri);

                self.location.href = that.studioPanelUri('/music/changeplan?plan_id=' + musicPlanId);
            }
        });
        window.Sp.v2ReactBridge.showBookingPlanSection();

        const receiptURI = `${that.studioPanelUri('/account/receipt')}?id=`;
        window.Sp.v2ReactBridge.showPlanBillingHistory({
            accountCredits: that.jsValues.accountCredits,
            bills: that.jsValues.bills,
            onPrintClick: (billId) =>
                window.open(`${receiptURI}${billId}`,'PrintWindow','width=800,height=600,menubar=1,resizable=1'),
            unbilledUsage: that.jsValues.unbilledUsage,
            upcomingBookingPlanDetails: that.jsValues.upcomingBookingPlanDetails || undefined,
            upcomingPlanDetails: that.jsValues.upcomingPlanDetails,
            upcomingMusicPlanDetails: that.jsValues.upcomingMusicPlanDetails || undefined,
        });

        window.Sp.v2ReactBridge.showPhotoPlans();

        $('.print-bill').click(function () {
            var id = $(this).data('id');
            var url = $(this).data('receiptUrl');
            window.open(url + '?id=' + id , 'PrintWindow', 'width=800,height=600,menubar=1,resizable=1');
        });

        // If we have a session parameter requesting the Downgrade Archive Warning,
        // activate it and clear the session parameter
        if (that.sessionStorage.getItem('showDowngradeArchiveWarning') !== null) {
            that.sessionStorage.removeItem('showDowngradeArchiveWarning');

            that.modal({
                title: 'Don\'t Forget Your Archives',
                body: _.template($('#templateArchiveReminderModal').html(), {}),
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },
                    {
                        label: 'Go to Galleries',
                        'class': 'btn btn-primary',
                        click: function () {
                            that.loading('Loading', 'show');

                            self.location.href =
                                that.studioPanelCsrfWrapper(that.studioPanelUri('/gallery'));
                        }
                    }
                ]
            });
        }

        if (that.sessionStorage.getItem('trackPlanChange') !== null) {
            var trackPlanChangeData = JSON.parse(that.sessionStorage.getItem('trackPlanChange'));

            that.sessionStorage.removeItem('trackPlanChange');

            if (window.trackPendoEvent) {
                window.trackPendoEvent('Plan Changed', trackPlanChangeData);

                if (trackPlanChangeData.to_plan_band !== trackPlanChangeData.from_plan_band) {
                    window.trackPendoEvent(
                        `Plan ${trackPlanChangeData.to_plan_band > trackPlanChangeData.from_plan_band ? 'Upgraded' : 'Downgraded'}`,
                        {
                            ...trackPlanChangeData,
                            source: 'plan-and-billing'
                        }
                    );
                }
            }
        }
    },

    updateAnalyticsDataLayer: function (dataObject) {
        if (window.dataLayer) {
            window.dataLayer.push(dataObject);
        }
    },

    updatePlanInAnalyticsDataLayer: function (plan) {
        this.updateAnalyticsDataLayer({
            click_photoplancurrency: plan.currency,
            click_photoplanid: plan.uuid,
            click_photoplanname: plan.name,
            click_photoplanprice: plan.price,
            click_photoplanpromo: plan.promo ? plan.promo : 'none',
            event: 'planbilling_select_button_click',
        });
    },

    showPhotoPlansModal: function (plan) {
        var that = this;
        var isDowngrade =
            (!plan.hasContracts && plan.currentPlan.hasContracts) ||
            (!plan.hasInvoices && plan.currentPlan.hasInvoices)

        that.modal({
            title: isDowngrade ? 'Are you sure you want to change plans?' : 'Confirm Plan Change',
            body: _.template($('#templateConfirmPlanChange').html(), {
                newNumPhotos: plan.photosAllowed,
                newPrice: plan.planPriceText,
                newPeriod: plan.planPeriod,
                showLossOfContractsAndOrInvoicesWarning: isDowngrade
            }),
            open: function () {
                if (plan.isUnlimited) {
                    $('#unlimitedNote').show();
                } else {
                    $('#unlimitedNote').hide();
                }

                // If we're changing from a BF monthly plan to a BF yearly plan
                // we want to show the additional note about not being able to go back
                if (plan.isBlackFriday && plan.planPeriod === "annually" && plan.currentPlan.planPeriod === 30) {
                    $('#blackFridayMonthlyToYearlyNote').show();
                } else {
                    $('#blackFridayMonthlyToYearlyNote').hide();
                }

                that.showLosingTaveWarningMessage(plan.includesTave, plan.currentPlan.includesTave);
            },
            buttons: [
                {
                    label: 'Cancel',
                    close: true
                },{
                    'class': ['btn', isDowngrade ? 'btn-danger' : 'btn-primary'].join(' '),
                    click: function (event) {
                        that.loading('Submitting', 'show');

                        // Set a session parameter to advise the next page to show
                        // the archive fee warning dialog, if applicable. This works
                        // like Flash Messages, except that it's JavaScript based.
                        if (plan.archiveFee > 0 && !plan.isUnlimited) {
                            that.sessionStorage.setItem('showDowngradeArchiveWarning', true);
                        }

                        that.sessionStorage.setItem('trackPlanChange', JSON.stringify({
                            from_plan_band: plan.currentPlan.band,
                            from_plan_id: plan.currentPlan.id,
                            from_plan_name: plan.currentPlan.name,
                            to_plan_band: plan.band,
                            to_plan_id: plan.id,
                            to_plan_name: plan.name,
                            to_plan_uuid: plan.uuid
                        }));

                        that.updatePlanInAnalyticsDataLayer(plan);

                        that.updateAnalyticsDataLayer({
                            difference_in_plan_rank: plan.band - plan.currentPlan.band,
                            event: 'plan_changed',
                            new_plan_rank: plan.band,
                            old_plan_rank: plan.currentPlan.band
                        });

                        self.location.href =
                            that.studioPanelCsrfWrapper(that.studioPanelUri('/account/planbilling?action=change&plan=' + plan.id), 'account_changebillingplan');
                        return;
                    },
                    data: 'confirm-plan-select-button',
                    label: 'Yes, change my plan',
                }
            ]
        })
    },

    showCannotChangePhotoPlanModal: function (plan) {
        var that = this;
        var cannotChangePlanReasons = plan.cannotChangePlanReasons;

        that.modal({
            title: 'Cannot Change to This Plan',
            body: _.template($('#templateCantMoveToPlan').html(), {
                tooManyBrands: cannotChangePlanReasons.tooManyBrands,
                tooManyContracts: cannotChangePlanReasons.tooManyContracts,
                tooManyInvoices: cannotChangePlanReasons.tooManyInvoices,
                tooManyMobileApps: cannotChangePlanReasons.tooManyMobileApps,
                tooManyPhotos: cannotChangePlanReasons.tooManyPhotos,
                tooManyPriceSheets: cannotChangePlanReasons.tooManyPriceSheets,
                tooManyUsers: cannotChangePlanReasons.tooManyUsers
            }),
            open: function () {
                that.showLosingTaveWarningMessage(plan.includesTave, plan.currentPlan.includesTave);
            },
            buttons: [
                {
                    label: 'Close',
                    'class': 'btn-primary',
                    close: true
                }
            ]
        });
    },

    showLosingTaveWarningMessage: function (newPlanHasTave, currentPlanHasTave) {
        if (!newPlanHasTave && currentPlanHasTave) {
            $('#blackFridayLosingTaveNote').show();
        } else {
            $('#blackFridayLosingTaveNote').hide();
        }
    },

    handleAccountAuthorizedApps: function () {
        var that = this;

        $('.submit-form').click(function (e) {
            e.preventDefault();
            $('form').submit();
        });

        $('.confirm').click(function (e) {
            e.preventDefault();
            var tokenId = $(e.target).data('tokenId');

            that.modal({
                title: 'Deauthorize App',
                body: _.template($('#templateConfirmDeauthorize').html(), {}),
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Yes, Deauthorize',
                        'class': 'btn-danger',
                        click: function () {
                            self.location.href =
                                that.studioPanelUri('/account/removeauthorizedapp?id=' + tokenId);
                        }
                    }
                ]
            });
        });

        $('.js-show-permissions').click(function (e) {
            e.preventDefault();

            var modalContent = $(this).parent().find('ul.permissions').html();

            that.modal({
                title: 'App Permissions',
                body: modalContent,
                buttons: [
                    {
                        label: 'Ok',
                        close: true,
                        'class': 'btn btn-default'
                    }
                ]
            });
        });
    },

    handleGalleryAddPhoto: function () {
        var that = this;

        $.post(this.studioPanelUri('/gallery/addphotofilelist'), {
            event_id: Sp.studio.jsValues.eventId
        }, function (json) {
            Sp.studio.jsValues.currentFilenames = json;
        }, 'json');

        var updateMainProgressBar = function (completed, total) {
            $('.progress-totals .completed').text(Sp.numberFormat(completed, 0, '.', ','))
            $('.progress-totals .total').text(Sp.numberFormat(total, 0, '.', ','));

            // handle updating the main progress bar
            var percent = ((completed / total) * 100);
            $('#mainProgress .completed').css('width', percent + '%');
        };

        var updateOnDeckTotal = function (num) {

            if (num === 0) {
                num = '';
                $('.js-upload-on-deck').hide();
            } else {
                $('.js-upload-on-deck').show();
                num = Sp.numberFormat(num, 0, '', ',');
            }

            $('#uploadQueueCount').text(num);
        };

        Sp.uploader.opts.maxFileSize = Sp.studio.jsValues.maxFileSize;
        Sp.uploader.opts.uploadUrl = Sp.studio.jsValues.uploadUrl;
        Sp.uploader.opts.postParams = Sp.studio.jsValues.postParams;

        Sp.uploader.callbacks.singleUploadStarting = function (file, fileList) {
            updateOnDeckTotal(fileList.length);
        };

        Sp.uploader.callbacks.singleUploadComplete = function (file, fileList) {
            $.post(
                that.studioPanelUri('/gallery/addphoto/' + Sp.studio.jsValues.eventId), {
                    'name': file.name,
                    'size': file.size,
                    'album_id': $('#albums').val(),
                    'random_key': file.randomFolder,
                    'watermark_id': $('#watermark').val(),
                    'upload_time': ((file.uploadComplete - file.uploadStart) / 1000),
                    'response_text': ((file.responseText !== '') ? file.responseText : '')
                }, function(data) {

                    if (data.hasOwnProperty('requeue') && data.requeue) {
                        Sp.uploader.requeueFile(file);
                        return;
                    }

                    if (!data.success) {

                        if (data.hasOwnProperty('stopUpload') && data.stopUpload) {
                            $('#planLimitReached').show();
                            Sp.uploader.stopUpload();
                        }
                        // not sure what to do here!
                        return;
                    }

                    if (!data.storage_used) {
                        if (data.photos_used >= data.photos_allowed) {
                            $('#planLimitReached').show();
                            Sp.uploader.stopUpload();
                        }
                    }
                }, 'json'
            );

            updateMainProgressBar(Sp.uploader.filesCompleted, Sp.uploader.getTotalFiles());

            $('#uploadedCount').text(Sp.numberFormat(Sp.uploader.filesCompleted, 0, '', ','));

            updateOnDeckTotal(fileList.length);
        };

        Sp.uploader.callbacks.allUploadingComplete = function () {
            $('#pageHeaderTitle').show();
            $('#pageHeaderTitleUploading').hide();
            $('.uploading-in-progress').hide();
            $('.upload-complete').show();
        };

        Sp.uploader.callbacks.uploadingStarting = function () {
            $('#pageHeaderTitle').hide();
            $('#pageHeaderTitleUploading').show();

            // hide the dropzone and show the queues
            $('#dropzoneRow').hide();
            $('#queues').show();

            $('.uploading-in-progress').show();
            $('.upload-complete').hide();
        };

        Sp.uploader.callbacks.uploadStopped = function () {
            $('#pageHeaderTitle').show();
            $('#pageHeaderTitleUploading').hide();
        };

        Sp.uploader.callbacks.fileAddedToQueue = function (file, fileList) {
            $('#uploadQueueCount').text(Sp.numberFormat(fileList.length, 0, '', ','));
            $('#dropzone .queue-count').text(Sp.numberFormat(fileList.length, 0, '', ','));

            if (!Sp.uploader.uploading && $('#dropzone').is(':visible') && $('.photos-queued').is(':hidden')) {
                $('.queue-empty').hide();
                $('.btn-file').removeClass('btn-primary').addClass('btn-default');
                $('.photos-queued').css('display', 'block');
            }

            updateMainProgressBar(Sp.uploader.filesCompleted, Sp.uploader.getTotalFiles());
        };

        Sp.uploader.getCompleteDuplicateFileList = function (currentList) {
            return currentList.concat(Sp.studio.jsValues.currentFilenames);
        };

        Sp.uploader.callbacks.duplicateFileSkipped = function (file, fileList) {
            $('.upload-warnings span.num').text(fileList.length + ' ' + ((fileList.length > 1) ? 'photos were' : 'photo was'));
            $('.upload-warnings').show();
            $('.upload-warnings span.duplicates').show();
        };

        Sp.uploader.callbacks.unsupportedFileSkipped = function (file, fileList) {
            $('.upload-warnings span.num').text(fileList.length + ' ' + ((fileList.length > 1) ? 'photos were' : 'photo was'));
            $('.upload-warnings').show();
            $('.upload-warnings span.unsupported').show();
        };

        Sp.uploader.callbacks.onError = function (file, type) {
            $.post(that.studioPanelUri('/gallery/addphotoerror'), {
                name: file.name,
                size: file.size,
                type: type
            }, function () {}, 'json');
        };

        Sp.uploader.setup();

        var toggleSubAlbumButton = function () {
            var albumId = $('#albums').val();
            var level = 0;

            if (albumId.length) {
                var album = Sp.getObjectById(albumId, Sp.studio.jsValues.albums);

                if (album !== null) {
                    level = album.dataLevel;
                }
            }

            if (level >= 3) {
                $('#addAlbumWrapper').switchClass('show', 'hide');
            } else {
                $('#addAlbumWrapper').switchClass('hide', 'show');
            }
        };

        $('#albums').on('change', function () {
            toggleSubAlbumButton();
        });

        $('#addAlbum').on('click', function (e) {
            e.preventDefault();

            if (Sp.uploader.uploading) {
                return false;
            }

            var parentId = $('#albums').val();

            that.modal({
                title: 'Create a New Album',
                sizeClass: 'modal-md',
                body: _.template($('#templateNewAlbumDialog').html(), {
                    hasPhotos: ($('.album-header').is('.single-album.has-photos'))
                }),
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Add Album',
                        'class': 'btn-primary',
                        click: function() {
                            var name = $('#newAlbumName').val();

                            if ($.trim(name) === '') {
                                return;
                            }

                            $(this).parents('div.modal').modal('hide');

                            $.post(that.studioPanelUri('/gallery/addalbum'), {
                                event_id: that.jsValues.eventId,
                                new_album_name: name,
                                parent_album_id: parentId
                            },
                            function (data) {
                                updateAlbumList(data.album.id);
                            },
                            'json');
                        }
                    }
                ]
            });
        });

        var updateAlbumList = function (idToSelect) {
            var idToSelectAfterUpdate = idToSelect;

            $.post(that.studioPanelUri('/gallery/addphotoalbumlist'), {
                event_id: that.jsValues.eventId
            },
            function (json) {
                that.jsValues.albums = json;

                $('#albums *').remove();

                _.each(json, function (opt) {
                    $('#albums').append(
                        $('<option></option>').val(opt.id).html(opt.text).prop('disabled', opt.disabled)
                    );
                });

                if (idToSelectAfterUpdate !== '') {
                    $('#albums').val(idToSelectAfterUpdate);
                }

                $('#albums').select2({
                    width: '200px'
                });

                toggleSubAlbumButton();
            },
            'json');
        };

        updateAlbumList(Sp.studio.jsValues.albumId);

        $('a.upload-options-toggle').on('click', function (e) {
            e.preventDefault();

            $(this).parents('.upload-options-section').toggleClass('open');
        });

        if (Sp.studio.jsValues.uploadAllowed) {

            $('div.add-photos').show();

            this.activateSwitch('input.switch', {
                onChange: function () {
                    if ($('#duplicates').is(':checked')) {
                        Sp.uploader.opts.allowDuplicates = true;
                    } else {
                        Sp.uploader.opts.allowDuplicates = false;
                    }

                    Sp.studio.updateSwitchStyle(this);
                }
            });

            $('#startUpload').on('click', function (e) {
                e.preventDefault();
                Sp.uploader.startUpload();
            });

            $('#addMore').on('click', function (e) {
                e.preventDefault();
                self.location.href = self.location.href;
            });

            $('#stopUpload').on('click', function (e) {
                e.preventDefault();
                Sp.uploader.stopUpload();
            });

        } else {
            $('#planLimitReached').show();
        }
    },

    handleAddUser: function (duplicateUserId) {
        if (Sp.studio.jsValues.hasMultipleUsersAllowed) {
            window.location.href = this.studioPanelUri(`/account/user/new${duplicateUserId ? `?duplicate=${duplicateUserId}` : ``}`);
        } else {
            window.Sp.v2ReactBridge.showUsersUpsellModal({
                onAccept: () => window.location.assign(this.studioPanelUri('/account/planbilling'))
            });
        }
    },

    displayUserDeleteModal: function (element, sp, redirect) {

        redirect = redirect || false;

        var userId = $(element).data('userId');
        var userName = $(element).data('userName');

        sp.modal({
            title: 'Confirm Delete',
            body: '<p>Are you sure you want to remove ' + userName +
                ' from your list of users? This cannot be undone.',
            buttons: [
                {
                    label: 'Cancel',
                    close: true
                },{
                    label: 'Yes, Delete',
                    'class': 'btn-primary',
                    click: function() {
                        $.ajax({
                            url: sp.studioPanelCsrfWrapper(sp.studioPanelUri('/account/user/' + userId), 'user_delete'),
                            type: 'DELETE',
                            success: function (data) {
                                if (redirect) {
                                    window.location.href = sp.studioPanelUri('/account/user');
                                } else {
                                    $('#user-row-' + userId).remove();
                                    sp.hoverMessage.show(data.msg, data.status);
                                }
                            },
                            error: function (jqXHR) {
                                sp.hoverMessage.show(jqXHR.responseJSON.msg, jqXHR.responseJSON.status);
                            }
                        });
                    },
                    close: true
                }
            ]
        });

    },

    displayUserStatusModal: function (element, sp, redirect) {

        redirect = redirect || false;

        var userId = $(element).data('userId');
        var userName = $(element).data('userName');
        var statusId = $(element).data('statusId');

        if (statusId === Sp.studio.jsValues.USER_STATUS_ACTIVE_ENUM && !Sp.studio.jsValues.hasMultipleUsersAllowed) {
            window.Sp.v2ReactBridge.showUsersUpsellModal({
                onAccept: () => window.location.assign(this.studioPanelUri('/account/planbilling'))
            });
            return;
        }
        var statusName = $(element).data('statusName');

        var confirmMsg = `<p>Are you sure you want to <strong>${statusName}</strong> ${userName}?`;

        if (statusName.toLowerCase() == 'deactivate') {
            confirmMsg += ' This user will no longer be able to log in.';
        } else if (statusName.toLowerCase() == 'activate') {
            confirmMsg += ' This user will be able to log in.';
        }

        confirmMsg += '</p>';

        sp.modal({
            title: 'Confirm Status Change',
            body: confirmMsg,
            buttons: [
                {
                    label: 'Cancel',
                    close: true
                },{
                    label: 'Yes, ' + statusName,
                    'class': 'btn-primary',
                    click: function() {
                        $.ajax({
                            url: sp.studioPanelUri('/account/user/status'),
                            type: 'POST',
                            data: {
                                id: userId,
                                statusId: statusId
                            },
                            success: function () {
                                if (redirect) {
                                    window.location.href = sp.studioPanelUri('/account/user');
                                } else {
                                    if (statusName.toLowerCase() == 'deactivate') {
                                        $('#user-row-' + userId).addClass('inactive info');
                                    } else if (statusName.toLowerCase() == 'activate') {
                                        $('#user-row-' + userId).removeClass('inactive info');
                                    }
                                }
                            }
                        });
                    },
                    close: true
                }
            ]
        });

    },

    displayWatermarkDeleteModal: function (element, sp) {

        var watermarkId = $(element).data('watermarkId');
        var watermarkName = $(element).data('watermarkName');
        var isDefault = parseInt($(element).data('isDefault'), 10);
        var buttons = [];
        var message = '';

        buttons[buttons.length] = {
            label: 'Cancel',
            close: true
        };

        if (isDefault) {

            message = '<p>' + watermarkName + ' is currently set as the ' +
                'default watermark for this brand. First, choose another ' +
                'default watermark, then you may delete this one.</p>';

        } else {

            message = '<p>Are you sure you want to delete ' + watermarkName +
                '? You will no longer be able to use this watermark. This ' +
                'cannot be undone.</p>'

            buttons[buttons.length] = {
                label: 'Yes, Delete',
                'class': 'btn-danger',
                click: function() {
                    $.ajax({
                        url: sp.studioPanelCsrfWrapper(sp.studioPanelUri('/brand/watermark/' + watermarkId), 'brand_watermark_delete'),
                        type: 'DELETE',
                        success: function (data) {
                            $('#watermark-tile-' + watermarkId).remove();
                            sp.hoverMessage.show(data.msg, data.status);
                        },
                        error: function (jqXHR) {
                            sp.hoverMessage.show(jqXHR.responseJSON.msg, jqXHR.responseJSON.status);
                        }
                    });
                },
                close: true
            };
        }

        sp.modal({
            title: 'Confirm Delete',
            body: message,
            sizeClass: 'modal-md',
            buttons: buttons
        });

    },

    displayEmailTemplateDeleteModal: function (element, sp) {

        var templateId = $(element).data('templateId');
        var templateName = $(element).data('templateName');
        var usedInAutomation = parseInt($(element).data('usedInAutomation'), 10);
        var buttons = [];
        var message = '';

        buttons[buttons.length] = {
            label: 'Cancel',
            close: true
        };

        if (usedInAutomation) {

            message = '<p><strong>' + templateName + '</strong> is currently used in a ' +
                'campaign and may not be deleted.</p>';

        } else {

            message = '<p>Are you sure you want to delete <strong>' + templateName +
                '</strong>? You will no longer be able to use this email template. This ' +
                'cannot be undone.</p>'

            buttons[buttons.length] = {
                label: 'Yes, Delete',
                'class': 'btn-danger',
                click: function() {
                    $.ajax({
                        url: sp.studioPanelCsrfWrapper(sp.studioPanelUri('/email/template/' + templateId), 'emailtemplate_delete'),
                        type: 'DELETE',
                        success: function () {
                            $('#template-row-' + templateId).remove();
                        },
                        error: function (jqXHR) {
                            sp.hoverMessage.show(jqXHR.responseJSON.msg, jqXHR.responseJSON.status);
                        }
                    });
                },
                close: true
            };

        }

        sp.modal({
            title: 'Confirm Delete',
            body: message,
            buttons: buttons
        });

    },

    dateFieldInit: function () {
        $('.date-field:not(.custom)').datepicker({
            format: 'yyyy-mm-dd',
            autoclose: true
        });
    },

    checkboxInit: function () {
        $('input:checkbox:not(.switch):not(.custom), input:radio:not(.custom)').iCheck(this.configs.iCheck);

        // setup external labels for switches
        $('input:checkbox.show-exterior-label:not(.custom)').each(function(i,el) {
            $(el).parents('.form-group').find('.clearfix').remove();
            $(el).parents('.form-group').append('<div class="exterior-label-checked">').find('.exterior-label-checked').html($(el).data('checkedLabel'));
            $(el).parents('.form-group').append('<div class="exterior-label-unchecked">').find('.exterior-label-unchecked').html($(el).data('uncheckedLabel'));
            $(el).parents('.form-group').append('<div class="clearfix"></div>');
        });
    },

    commonInit: function () {
        var that = this;

        svg4everybody();

        this.checkboxInit();
        this.dateFieldInit();

        // handle table checkboxes
        $('.th.check, .td.check').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $(e.target).find('.icheckbox_flat-sp ins').click();
        });

        // radio button UI
        $('.radio_list-button li').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            $(this).find('input:radio').prop('checked', true);
            $(this).find('input:radio').trigger('change');
        });
        $('.radio_list-button input:radio').on('change', function () {
            $(this).parents('ul').find('li.chosen').removeClass('chosen');
            $(this).parents('li').addClass('chosen');
        });

        // setup links to clear search filters
        $('.clear-search-filter').click(function () {
            var field = $(this).data('searchField');
            var qs = that.queryString;

            if (field) {
                delete qs[field];
                window.location = window.location.pathname + '?' + $.param(qs);
            }
        });

        // class driven disabled links
        $('body').on('click', 'a.disabled', function (e) {
            e.preventDefault();
        });

        // setup any default selects
        $('select:not(.no-search):not(.custom)').select2({
            dropdownAutoWidth: 'true'
        });

        // setup selects without integrated searchbar
        $('select.no-search').select2({
            minimumResultsForSearch: Infinity
        });

        // handle focus / blur on input elements
        $('.form-group input').focus(function(e) {
            $(e.target).parents('.form-group').addClass('focus');
        });

        $('.form-group input').blur(function(e) {
            $(e.target).parents('.form-group').removeClass('focus');
        });

        // setup any default editors
        $('textarea.editor:not(.custom)').each(function (i, el) {
            that.editor(el, {});
        });

        // setup and default textareas with counters
        $('textarea:not(.editor):not(.custom)').each(function(i, el) {
            that.plainTextCounter(el);
        });

        // setup any default color pickers
        $('input.color:not(.custom)').each(function (i, el) {
            var pickerHtml = '<div class="input-group">' +
                '<span class="input-group-addon"><i></i></span>' +
                $(el)[0].outerHTML +
                '</div>';
            var pickerElement = $(pickerHtml);
            $(el).replaceWith(pickerElement);
            that.colorpicker(pickerElement, {});
        });

        // setup any default sliders
        $('input.slider:not(.custom)').each(function (i, el) {
            that.slider(el, {});
        });

        $('#rowSelectAll, .row-select-all').on('ifChecked', function() {
            $(this).parents('.table').find('.table-body > .tr .row-select').iCheck('check');
        });

        $('#rowSelectAll, .row-select-all').on('ifUnchecked', function() {
            $(this).parents('.table').find('.table-body > .tr .row-select').iCheck('uncheck');
        });

        $('.row-select').on('ifChecked ifUnchecked', function() {
            if ($('.row-select:checked').length) {
                $('#startBulkActions').css('display', 'inline-block');
            } else {
                $('#startBulkActions').hide();
            }
        });

        this.initCalendarIconClick();

        /** This is here to have the last 2 quick actions dropdown drop up in tables when the screen is small enough for the table-response to be enabled **/
        if ($(window).width() <= 768) {
            $('.table-responsive.has-dropdown .table-body .tr').slice(-2).find('.dropdown').addClass('dropup');
        }

        // handle spContactCard gallery links
        $('body').on('click', '.sp-contact-card .js-open-gallery', function (ev) {
            var contactId = $(ev.target).parents('.sp-contact-card').find('.js-open-gallery').data('galleryId');
            var baseUri = $(ev.target).parents('.customer-card-container').data('galleryLink');
            window.location.href = baseUri + contactId;
        });

        // extend jQuery with cancelZoom plugin
        function cancelZoom()
        {
            var d = document,
                viewport,
                content,
                maxScale = ',maximum-scale=',
                maxScaleRegex = /,*maximum\-scale\=\d*\.*\d*/;

            // this should be a focusable DOM Element
            if(!this.addEventListener || !d.querySelector) {
                return;
            }

            viewport = d.querySelector('meta[name="viewport"]');
            content = viewport.content;

            function changeViewport(event)
            {
                // http://nerd.vasilis.nl/prevent-ios-from-zooming-onfocus/
                viewport.content = content + (event.type == 'blur' ? (content.match(maxScaleRegex, '') ? '' : maxScale + 10) : maxScale + 1);
            }

            // We could use DOMFocusIn here, but it's deprecated.
            this.addEventListener('focus', changeViewport, true);
            this.addEventListener('blur', changeViewport, false);
        }

        $.fn.cancelZoom = function() {
            return this.each(cancelZoom);
        };

        $('input:text, select, textarea').cancelZoom();

        $('form.block_double_submit').submit(function () {
            if (!that.submitSent) {
                that.submitSent = true;
                return true;
            }

            return false;
        });

        // the test for this plugin is a bit different than others, leave it the way it is
        if ($.cookie('tz') === '' || $.cookie('tz') === null) {
            $.cookie('tz', Sp.getTimeZone(), {
                expires: 365,
                path: '/',
                domain: '.shootproof.com'
            });
        }

        var mainSearchTimer = null;
        var navSearchTimer = null;
        $('#main #help-dropdown-search input')
            .on('click', function(event) {
                event.stopPropagation();
            })
            .on('keyup', function() {
                clearTimeout(mainSearchTimer);
                var phrase = $('#main #help-dropdown-search input').val();
                if (phrase.length > 0) {
                    mainSearchTimer = setTimeout(function() { searchKnowledgebase(phrase, '#main') }, 500);
                } else {
                    $('#main .kb-faqs').show();
                    $('#main li.suggestion').remove();
                }
            });

        $('.nav-secondary #help-dropdown-search input')
            .on('click', function(event) {
                event.stopPropagation();
            })
            .on('keyup', function() {
                clearTimeout(navSearchTimer);
                var phrase = $('.nav-secondary #help-dropdown-search input').val();
                if (phrase.length > 0) {
                    navSearchTimer = setTimeout(function() { searchKnowledgebase(phrase, '.nav-secondary') }, 500);
                } else {
                    $('.nav-secondary .kb-faqs').show();
                    $('.nav-secondary li.suggestion').remove();
                }
            });

        function searchKnowledgebase(phrase, selector) {

            getSuggestions(phrase,
                function(suggestions) {
                $(selector + ' .kb-faqs').hide();
                $(selector + ' li.suggestion').remove();
                    var suggestionList = '';

                    if (suggestions.length === 0) {
                        suggestionList += '<li class="suggestion no-results">No Results Found</li>';
                    } else if (suggestions.length > 0) {
                        suggestionList += '<li class="suggestion">';
                        suggestions.forEach(function(element) {
                            suggestionList += '<a href="' + element.url + '" target="_blank" rel="noopener noreferrer">' + element.name + '</a>';
                        });
                    }

                    if (suggestions.length === 5) {
                        var learnMore = '<a class="learn-more" href="https://help.shootproof.com/hc/en-us/search?query=' + phrase + '" target="_blank" rel="noopener noreferrer">More Results &rsaquo;</a>';
                        suggestionList += learnMore;
                    }

                    suggestionList += '</li>';

                    $(selector + ' #help-dropdown-search').after(suggestionList);
                }
            );
        }

        $('#supportRequest, #supportRequestWelcome, #supportRequestErrorPage').on('click', function (e) {
            e.preventDefault();
            $('#onPageHelp').dropdown('toggle');

            that.modal({
                title: 'How can we help you?',
                body: _.template($('#templateSupportRequest').html(), {}),
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Send',
                        'class': 'btn-primary',
                        click: function () {
                            that.loading('Submitting', 'show');
                            var modal = $(this).parents('.modal');

                            $.post(that.studioPanelUri('/support/submit'), {
                                question: $('#supportQuestion').val(),
                                details: $('#supportDetails').val()
                            }, function (json) {
                                $(modal).modal('hide');
                                that.loading('Submitting', 'hide');
                                that.hoverMessage.show(json.msg, json.status);
                            }, 'json');
                        }
                    }
                ]
            });
        });

        // use this loading class to target elements while the dom is loading.
        $('body').removeClass('loading');

        function getSuggestions(phrase, callback) {
            $.ajax({
                type: 'get',
                url: Sp.urls.api + '/knowledge-base-article',
                data: { 'phrase': phrase },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', Sp.studio.studioV3DataToken);
                },
                success: function (data) {
                    callback(data);
                }
            });
        }
    },

    navInit: function () {
        const location = window.location.href;
        const activeRoute = location.split(`v2/${Sp.studio.brandId}`)[1];
        const apiFullUrl = Sp.urls ? Sp.urls.api : '';
        const apiRoot = apiFullUrl.substring(0, apiFullUrl.lastIndexOf('/'));

        window.Sp.v2ReactBridge.showNav({
            activeRoute: activeRoute,
            apiRoot: apiRoot,
            dataToken: Sp.studio.studioV3DataToken,
            currentBrandId: Sp.studio.brandId,
        });
    },

    addGalleryInit: function () {
        var that = this;
        $('body').on('click', '.js-add-gallery', function(e) {
            e.preventDefault();

            that.modal({
                title: 'Add a Gallery',
                body: _.template($('#templateAddGallery').html(), {}),
                sizeClass: 'modal-md',
                shown: function() {
                    $($('.modal input')[0]).focus();

                    $('#event_date').datepicker({
                        format: 'yyyy-mm-dd',
                        autoclose: true
                    });

                    $('#brand_event_defaults_id + span.select2-container').css('width', '100%');

                    if ($(e.target).data('linkedContact')) {
                        $('#linked_contact_id').val($(e.target).data('linkedContact'));
                    }

                    that.initCoachMarks(that.coachMarks, true);
                },
                open: function () {
                    $('#' + this.id).find('select').select2({
                        minimumResultsForSearch: Infinity
                    });

                    that.initCalendarIconClick();
                },
                close: function () {
                    that.initCoachMarks(that.coachMarks);
                },
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Create',
                        'class': 'btn-primary',
                        click: function() {
                            var name = $.trim($('#name').val());

                            if (name === '') {
                                $('#name')
                                    .parents('.form-group')
                                    .addClass('has-error')
                                    .append('<ul class="form-error list-unstyled"><li>Please specify a name for this gallery.</li></ul>');
                                return;
                            }

                            that.loading('Creating Gallery', 'show');
                            var linkedContactId = '';

                            if ($('#linked_contact_id').val() && $('#linked_contact_id').val() !== '') {
                                linkedContactId = $('#linked_contact_id').val();
                            }

                            var defaultId = $('#brand_event_defaults_id').val();
                            var eventDate = $('#event_date').val();

                            $.post(that.studioPanelUri('/gallery/add'), {
                                name: name,
                                brand_event_defaults_id: defaultId,
                                event_date: eventDate,
                                linked_contact_id: linkedContactId
                            }, function (json) {
                                self.location.href = that.studioPanelUri('/gallery/edit/' + json.event_id);
                            }, 'json');
                        }
                    }
                ]
            });
        });
    },

    initCalendarIconClick: function () {
        $('svg.icon-calendar').parents('.input-group-addon').off('click');
        $('svg.icon-calendar').parents('.input-group-addon').click(function (e) {
            e.preventDefault();
            $(this).siblings('input').focus();
        });
    },

    downloadPhoto: function(params) {

        var that = this;
        var id = 'download-' + new Date().getTime();
        var html = '';
        var returnType = 'dialog';

        if (params.hasOwnProperty('returnType') && params.returnType !== null) {
            returnType = params.returnType;
        }

        if (params.hasOwnProperty('modalBody') && params.modalBody !== null) {
            html = params.modalBody;
        } else if (params.hasOwnProperty('emailAddress') && params.emailAddress !== null) {
            html = '<p>When the photos are ready for download, an email will be sent to ' + params.emailAddress + '. It should be just a few moments!</p>';
        } else {
            html = '<p>The photos are being prepared for download, it should be just a few minutes.</p>';
        }

        var typeId = ((params.hasOwnProperty('typeId') && params.typeId !== null) ? params.typeId : null);
        var photoIds = params.photoIds;
        var eventId = ((params.hasOwnProperty('eventId') && params.eventId !== null) ? params.eventId : null);
        var albumId = ((params.hasOwnProperty('albumId') && params.albumId !== null) ? params.albumId : null);
        var orderId = ((params.hasOwnProperty('orderId') && params.orderId !== null) ? params.orderId : null);
        var subject = ((params.hasOwnProperty('subject') && params.subject !== null) ? params.subject : null);
        var emailAddress = ((params.hasOwnProperty('emailAddress') && params.emailAddress !== null) ? params.emailAddress : null);
        var modalTitle = ((params.hasOwnProperty('modalTitle') && params.modalTitle !== null) ? params.modalTitle : 'Download Photos');

        this.modal({
            id: id,
            body: html,
            title: modalTitle,
            sizeClass: 'modal-md',
            buttons: [
                {
                    label: 'Cancel',
                    close: true
                },{
                    label: 'Submit Request',
                    'class': 'btn-primary',
                    click: function () {

                        $(this).parents('div.modal').modal('hide');
                        Sp.studio.loading('Submitting Request', 'show');

                        $.post(that.studioPanelUri('/download/photos'), {
                            type_id: typeId,
                            photo_ids: photoIds.join(','),
                            event_id: eventId,
                            album_id: albumId,
                            order_id: orderId,
                            email_address: emailAddress,
                            subject: subject
                        }, function (json) {
                            Sp.studio.loading('Submitting Request', 'hide');

                            // If the caller specifically requested a link
                            // type, show a modal that displays the link right
                            // away.
                            if (returnType === 'link') {
                                that.modal({
                                    title: 'Download Link',
                                    body: '<p>The download link is:</p><p><textarea class="form-control">' + json.download_url + '</textarea></p>',
                                    buttons: [{
                                        label: 'Close',
                                        close: true
                                    }]
                                });
                            } else if (json.stat === 'recent_zip_bundle_available' ||
                                       json.stat === 'recent_zip_bundle_pending'
                            ) {
                                // Otherwise, if the response indicates that
                                // the ZIP Bundle is still available or
                                // currently pending, show a modal messaging
                                // these specific cases.
                                Sp.studio.modal({
                                    title: json.headline,
                                    body: _.template($('#templateRecentZipBundle').html(), {
                                        download_page_url: json.url,
                                        message: json.msg
                                    }),
                                    sizeClass: 'modal-md',
                                    buttons: [
                                        {
                                            label: 'Close',
                                            close: true
                                        }
                                    ]
                                });

                                return;
                            } else {
                                // Otherwise, the ZIP Bundle was requested, so
                                // show a hover message.
                                that.hoverMessage.show(json.msg, json.stat);
                            }
                        }, 'json');
                    }
                }
            ]

        });
    },

    initContentEditorMode: function () {
        $('span.content_item_hook span.edit_link').click(function (event) {
            event.preventDefault();
            var contentKey = $(this).parent().attr('data-key');

            $.post('/v2/content',
                {
                    action: 'get',
                    content_key: contentKey
                },
                function (json) {

                    $('#content-in-page-dialog').remove();
                    $('<div id="content-in-page-dialog" style="display:none"><textarea>' + json.value + '</textarea></div>').appendTo('body');

                    var editingContentKey = json.content_key;
                    $('#content-in-page-dialog').dialog({
                        width: 600,
                        title: 'Content Key: ' + editingContentKey,
                        buttons: [
                            {
                                text: 'Update',
                                'class': 'primary',
                                click: function () {
                                    var thisDialog = $(this);

                                    $.post('/v2/content',
                                        {
                                            action: 'update',
                                            content_key: editingContentKey,
                                            value: $('#content-in-page-dialog').find('textarea').val()
                                        },
                                        function (json) {
                                            if (json.status === Sp.hoverMessage.type.success) {
                                                thisDialog.dialog('close');
                                                $('#content-' + json.content_key_md5 + ' span.content_item_data_' + json.content_key_md5).html(json.value);
                                                Sp.studio.hoverMessage.show('Content has been updated.', json.status);
                                            }
                                        }, 'json');
                                }
                            },{
                                text: 'Cancel',
                                click: function () {
                                    $(this).dialog('close');
                                }
                            }
                        ]
                    });

                }, 'json');
        });
    },

    serializeForms: function() {
        // only call this method on a fresh page load
        // or a state where all forms are at their reference point
        var that = this;
        this.formInitialState = [];

        $('form.js-catch-unsaved-changes').each(function(i, el) {
            that.formInitialState.push($(el).serialize());
        });
    },

    formDataHasChanged: function() {
        var that = this;
        this.verifySerial = [];

        $('form.js-catch-unsaved-changes').each(function(i, el) {
            that.verifySerial.push($(el).serialize());
        });

        if (this.verifySerial.toString() !== this.formInitialState.toString()) {
            return true;
        }

        return false;
    },

    setupFaqEditor: function () {
        $('#faqEditorAttach').on('click', function (event) {
            event.preventDefault();

            var selected = $('#faqEditorAllFaqs').val();

            if (selected === '') {
                return;
            }

            $.post('/v2/content/attachfaq',
                {
                    p: Sp.currentPage,
                    id: selected,
                    title: $('#faqEditorAllFaqs option:selected').text()
                },
                function (json) {

                    $('#faqEditorPageFaqs').empty();

                    $.each(json.list, function(i, article) {
                        $('#faqEditorPageFaqs')
                            .append($("<option></option>")
                                .attr("value", article.article_id)
                                .text(article.title));
                    });

                    $('#faqEditorPageFaqs').select2('destroy');
                    $('#faqEditorPageFaqs').select2();

                }, 'json');
        });

        $('#faqEditorRemove').on('click', function (event) {
            event.preventDefault();

            var selected = $('#faqEditorPageFaqs').val();

            if (selected === '') {
                return;
            }

            $.post('/v2/content/removefaq',
                {
                    p: Sp.currentPage,
                    id: selected
                },
                function (json) {

                    $('#faqEditorPageFaqs').empty();

                    $.each(json.list, function(i, article) {
                        $('#faqEditorPageFaqs')
                            .append($("<option></option>")
                                .attr("value", article.article_id)
                                .text(article.title));
                    });

                    $('#faqEditorPageFaqs').select2('destroy');
                    $('#faqEditorPageFaqs').select2();

                }, 'json');
        });
    },

    initPagination: function () {
        $('.sp-pagination select').select2({
            minimumResultsForSearch: Infinity
        }).on('change', function () {
            if (this.value !== '') {
                self.location.href = this.value;
            }
        });
    },

    initEmailPreview: function () {
        $('.email-preview iframe').load(function () {
            $(this).contents().find('a').each(function (index, element) {
                // Disable all links in the preview pane
                $(element).removeAttr('target');
                $(element).attr('href', '#');
                $(element).click(function (event) {
                    event.preventDefault();
                });
            });

            this.style.height = this.contentWindow.document.body.offsetHeight + 'px';
        });

        $('.email-preview ul.on-page-tabs li').click(function () {
            var toggleId = $(this).data('toggleId');

            $('.email-preview ul.on-page-tabs li').each(function () {
                $(this).removeClass('selected');
            });

            $('.email-preview .pane').each(function () {
                $(this).removeClass('visible-sm-block visible-xs-block').addClass('hidden-sm hidden-xs');
            });

            $(this).addClass('selected');
            $(toggleId).removeClass('hidden-sm hidden-xs').addClass('visible-sm-block visible-xs-block');
        });

        $('.email-preview .preview-toggle').click(function () {
            var toggleShow = $(this).data('toggleShow');

            if (toggleShow === 'edit') {
                $('.email-preview ul.on-page-tabs li.edit').click();
            }

            if (toggleShow === 'preview') {
                $('.email-preview ul.on-page-tabs li.preview').click();
            }

            var modal = $(this).parents('div.modal');
            $(modal).animate({ scrollTop: 0 }, 'slow');
        });

        $(window).resize(function () {
            // Reset the visibility classes when the window is resized.
            // Most people won't be resizing their windows while using this, but
            // during testing and QA, our staff actively resizes the window, placing
            // the classes in odd states, so we need to reset them on each resize.
            $('.email-preview ul.on-page-tabs li.edit').click();
            $('.email-preview #editPane').removeClass('hidden-sm hidden-xs visible-sm-block visible-xs-block');
            $('.email-preview #previewPane').removeClass('visible-sm-block visible-xs-block').addClass('hidden-sm hidden-xs');
        });
    },

    handleEmailPreview: function (params) {
        var postUrl = this.studioPanelUri('/email/templatepreview');
        var frameName = 'emailPreviewIframe';
        var formId = 'emailPreviewForm';

        // Add form to body
        $('body').append('<form action="' + postUrl + '" method="post" target="' + frameName + '" id="' + formId + '"></form>');
        $.each(params, function (name, value) {
            var input = $('<input type="hidden" name="' + name + '">').attr('value', value);
            $('#' + formId).append(input);
        });

        // Submit form to iframe and remove from body
        $('#' + formId).submit().remove();
    },

    modal: function (options) {
        var date = new Date().getTime();

        var defaultOptions = {
            id: 'modal' + date,
            title: '',
            autoOpen: true,
            showHeaderClose: true,
            open: function (e) {
                e = null;
            },
            shown: function (e) {
                e = null;
            },
            close: function (e) {
                e = null;
            }
        };

        var combinedOptions = $.extend({}, defaultOptions, options);
        var buttons = [];

        if (combinedOptions.hasOwnProperty('buttons') &&
            combinedOptions.buttons.length > 0) {

            _.each(combinedOptions.buttons, function (button, i) {
                if (!button.hasOwnProperty('id')) {
                    button.id = combinedOptions.id + '-' + i
                    buttons.push(button);
                }
            });
        }

        combinedOptions.buttons = buttons;

        var html = _.template($('#templateModal').html(), {
            'modal': combinedOptions
        });

        // remove the modal if it already exists
        $('#' + combinedOptions.id).remove();
        $('body').append(html);

        // Ensure the SVG "X" may be clicked to close the modal
        // In some cases--such as Safari--the modal will only close when the
        // button area is clicked and not the SVG. This hooks up the "hide"
        // event to clicks on the SVG, as well.
        $('svg.modal-close').on('click', function () {
            $(this).parents('div.modal').modal('hide');
        });

        // attach the click handlers
        _.each(combinedOptions.buttons, function (button) {
            if (button.hasOwnProperty('click')) {
                $('#' + button.id).on('click', button.click);
            }
        });

        // attach the gtm data attribute
        _.each(combinedOptions.buttons, function (button) {
            if (button.hasOwnProperty('data')) {
                $('#' + button.id).attr('data-gtmid', button.data);
            }
        });

        // remove the modal when it is hidden
        $('#' + combinedOptions.id).on('hidden.bs.modal', function (e) {
            var r = combinedOptions.close(e);
            if (r !== false) {
                $(this).remove();
            }
        });

        $('#' + combinedOptions.id).on('show.bs.modal', function (e) {
            var modal = this;

            // Use a state machine to avoid clicking the button more than once
            var isKeyPressed = false;

            $(modal).find('input').keyup(function (event) {
                if (event.which === 13 && !isKeyPressed) {
                    isKeyPressed = true;
                    // Make return/enter key "click" the primary modal button
                    $.when($(modal).find('.btn-primary').first().click()).done(function () {
                        isKeyPressed = false;
                    });
                }
            });

            combinedOptions.open(e);
        });

        $('#' + combinedOptions.id).on('shown.bs.modal', function (e) {
            // Focus on the first visible form input field
            var field = $(this).find('input,textarea,select,.select2').filter(':visible:first');

            if (field.length) {

                if ($(field).is('input[type=text]:not(.calendar),textarea')) {
                    field.focus();

                    // Try to use setSelectionRange to place cursor at end of existing text.
                    // If it's not available, replace the value with the same value, and most
                    // browsers will put the cursor at the end.
                    if (field[0].setSelectionRange) {
                        // Everyone says to multiply it by 2 because of browser inconsistencies
                        var len = field.val().length * 2;
                        field[0].setSelectionRange(len, len);
                    } else {
                        field.val(field.val());
                    }
                }
            }

            combinedOptions.shown(e);
        });

        if (combinedOptions.autoOpen) {
            $('#' + combinedOptions.id).modal(combinedOptions);
        }

        return {
            selector: '#' + combinedOptions.id
        };
    },

    setupDatagridFilter: function () {
        var that = this;
        var $templateFilter = $('#templateFilter'); 

        $('#filter').on('click', function (e) {
            e.preventDefault();

            that.modal({
                title: $templateFilter.data('title'),
                body: _.template($templateFilter.html(), {}),
                sizeClass: 'modal-md',
                open: function (e) {
                    $(e.target).find('select').select2({
                        width: '100%',
                        minimumResultsForSearch: Infinity
                    });
                },
                buttons: [
                    {
                        label: 'Close',
                        close: true
                    },{
                        label: 'Search',
                        'class': 'btn-primary',
                        click: function () {
                            $(this).parents('div.modal-content').find('form').submit();
                        }
                    }
                ]
            });
        });
    },

    setupResubscribe: () => {
        $('.resubscribe-button').on('click', function (e) {
            e.preventDefault();

            const resubscribeLink = e.target;

            const brandId = resubscribeLink.getAttribute('data-brandId');
            const email = resubscribeLink.getAttribute('data-email');
            const eventId = resubscribeLink.getAttribute('data-eventId');

            Sp.v2ReactBridge.showEventResubscribeModal({
                brandId,
                email,
                eventId
            });
        });
    },

    studioPanelUri: function (uri) {
        return '/v2/' + this.brandId + uri;
    },
    studioPanelCsrfWrapper: function (uri, formName) {
        var delimiter = '?';
        var uriFragment = '';
        var token;

        // If URI has querystring, use correct char to append params
        if (uri.includes('?')) {
            delimiter = '&';
        }

        // IF URI has fragment move it to after token is appended
        if (uri.includes('#')) {
            uriFragment = uri.slice(uri.indexOf('#'), uri.length);
            uri = uri.replace(uriFragment, '');
        }

        jQuery.ajax({
            url: this.studioPanelUri('/csrf') + '?form_name=' + encodeURIComponent(formName),
            success: function (result) {
                token = result.token;
            },
            async: false
        });

        return uri + delimiter + 'token=' + token + uriFragment;
    },

    loading: function(text, action) {

        if (action === 'show') {

            var $l = $('#loading');
            var $ld = $('#loading div.t');

            $ld.text(text + ' ...');

            $l.css({
                height: '100vh',
                top: $(window).scrollTop()
            });

            $l.fadeIn(100);

        } else {
            $('#loading').fadeOut(100);
        }
    },

    plainTextCounter: function (element) {
        var elId = element.id;
        var selector = '#' + elId;
        var counterSelector = selector + ' + .redactor-counter.for-' + elId;
        var maxValue = 0;
        var currentCount;

        if ($(selector).prop('maxlength') && $(selector).prop('maxlength') > 1) {
            maxValue = $(selector).prop('maxlength');
        }

        // perge existing counter display
        $(counterSelector).remove();

        // create counter display
        $(selector).after('<div class="redactor-counter redactor-counter-plain for-' + elId + '"></div>');

        // manage display count visibility
        $(selector).off('focus blur').on('focus', function() {
            $(counterSelector).addClass('show');
        }).on('blur', function() {
            $(counterSelector).removeClass('show');
        });

        // update display count
        $(selector).off('input').on('input', function() {
            currentCount = $(selector).val().replace(/(\r\n|\n)/g, '--').length

            if (maxValue && maxValue <= 1000) {
                if (currentCount > maxValue) {

                }

                $(counterSelector).html(currentCount + ' of ' + maxValue);

                if (currentCount >= maxValue) {
                    $(counterSelector).addClass('limit-reached');
                } else {
                    $(counterSelector).removeClass('limit-reached');
                }
            } else {
                $(counterSelector).html(currentCount);

                if (maxValue && currentCount >= maxValue) {
                    $(counterSelector).addClass('limit-reached');
                } else {
                    $(counterSelector).removeClass('limit-reached');
                }
            }
        }).trigger('input');
    },

    editor: function (selector, options) {
        var originalLangsEn = $R.lang.en;
        var langsEnChanges = $.extend(originalLangsEn, {
            unlink: 'Remove link'
        });

        var defaultOptions = {
            autoparseImages: false,
            buttons: ['bold', 'italic', 'underline', 'link', 'lists'],
            focus: false,
            linkNewTab: true,
            minHeight: 50,
            pasteBlockTags: ['p', 'div', 'ul', 'ol', 'li'],
            pasteInlineTags: ['b', 'i', 'u', 'br', 'strong', 'em'],
            pasteLinks: false,
            pasteImages: false,
            pastePlainText: true,
            replaceTags: {
                'b': 'strong',
                'big': 'strong',
                'i': 'em',
                'strike': 'del'
            },
            plugins: ['alignment'],
            callbacks: {}
        };

        if (options.changeCallback) {
            defaultOptions.callbacks.changed = options.changeCallback;
        }

        // by default include a char counter if maxlength is specified.
        if ($(selector).prop('maxlength') && $(selector).prop('maxlength') > 1) {
            defaultOptions.limiter = $(selector).prop('maxlength');
        }

        var allOptions = $.extend(defaultOptions, options);

        if (allOptions.hasOwnProperty('limiter')) {
            var limiterCallbacks = {
                started: function () {
                    $('.redactor-statusbar').hide();
                    $('<div class="redactor-counter">&nbsp;</div>').insertAfter($('.redactor-in'));
                },
                counter: function (data) {
                    var characterCountText;

                    if (this.opts.limiter <= 10000) {
                        characterCountText = Sp.numberFormat(data.characters, 0, '', ',') + ' of ' + Sp.numberFormat(this.opts.limiter, 0, '', ',');
                    } else {
                        characterCountText = Sp.numberFormat(data.characters, 0, '', ',');
                    }

                    $('.redactor-counter').text(characterCountText);
                },
                focus: function () {
                    $('.redactor-counter').addClass('show');
                },
                blur: function () {
                    $('.redactor-counter').removeClass('show');
                },
                paste: function (html) {
                    var targetContent = html.currentTarget.textContent;
                    var targetHtml = html.currentTarget.innerHTML;

                    // Verify the maximum length has not been exceeded
                    var combinedLength = targetContent.length;
                    if (combinedLength > allOptions.limiter) {
                        Sp.studio.modal({
                            title: 'Cannot paste!',
                            body: '<p>The content you are trying to paste will exceed the allowed character limit by ' + (combinedLength - allOptions.limiter) + ' characters. Please edit your content and try again.</p>',
                            buttons: [
                                {
                                    label: 'Ok',
                                    'class': 'btn-primary',
                                    close: true
                                }
                            ]
                        });
                        pasteHtml = '&nbsp;';
                    } else {
                        pasteHtml = targetHtml;
                    }

                    return pasteHtml;
                }
            };

            allOptions.plugins = allOptions.plugins.concat(['counter', 'limiter']);
            $.extend(allOptions.callbacks, limiterCallbacks);
        }

        // If the caller wants to warn the end user if there's no URL
        // present in the value, add on a keyup callback method.
        if (allOptions.warnOnNoUrl === true) {
            var urlCheckingOptions = {
                keyup: function (e) {
                    // Run a rudimentary regex check for
                    // http:// or https:// to determine if the
                    // message body contains a URL.
                    var regex = new RegExp("http(s)?://");

                    if (regex.test($(e.target).html()) === false) {

                        // Only add the error message if it's not already
                        // present in the DOM.
                        if ($('p.redactor-requires-url-error-message').length === 0) {
                            $(e.target).parents('div.form-group').prepend(
                                '<p class="form-error redactor-requires-url-error-message">' + allOptions.warnOnNoUrlErrorMessage + "</p>");
                        }
                    } else {
                        $('p.redactor-requires-url-error-message').remove();
                    }
                }
            };

            $.extend(allOptions.callbacks, urlCheckingOptions);
        }

        $(selector).redactor(allOptions);
    },

    colorpicker: function (selector, options) {

        var defaultOptions = {
            format: 'hex'
        };

        var allOptions = $.extend(defaultOptions, options);

        $(selector).colorpicker(allOptions);

    },

    slider: function (selector, options) {

        // Provide the ability to specify simple formatting from
        // a data-slider-simple-formatter attribute on the element
        if ($(selector).data('sliderSimpleFormatter')) {
            options.formatter = function (value) {
                return $(selector).data('sliderSimpleFormatter').replace('{{value}}', value);
            };
        }

        var defaultOptions = {
            min: (($(selector).data('sliderMin') !== 'undefined') ? $(selector).data('sliderMin') : 0),
            max: (($(selector).data('slideMax') !== 'undefined') ? $(selector).data('slideMax') : 100),
            step: (($(selector).data('sliderStep') !== 'undefined') ? $(selector).data('sliderStep') : 1),
            precision: (($(selector).data('sliderPrecision') !== 'undefined') ? $(selector).data('sliderPrecision') : 0),
            orientation: (($(selector).data('sliderOrientation') !== 'undefined') ? $(selector).data('sliderOrientation') : 'horizontal')
        };

        var allOptions = $.extend(defaultOptions, options);

        $(selector).slider(allOptions);
    },

    hoverMessage: {
        type: {
            success: 'success',
            info: 'info',
            warning: 'warning',
            error: 'error'
        },
        classMap: {
            success: 'success',
            info:'info',
            warning: 'warning',
            error: 'danger'
        },
        active: false,
        queue: [],
        show: function (msg, type, delay) {

            delay = (typeof(delay) !== 'undefined' && delay !== '') ? delay : 3000;
            type = (typeof(type) !== 'undefined' && type !== '') ? type : this.type.success;

            if (this.active) {
                this.queue.push({
                    msg: msg,
                    type: type,
                    delay: delay
                });
                return;
            }

            this.active = true;
            var html = '<div class="hover-alert hover-alert-' + this.classMap[type] + ' text-center">' + msg + '</div>';

            $(html).attr('id', 'hoverMessage')
                .css('top', (($(window).height() / 2) - 42))
                .appendTo('body')
                .delay(200)
                .fadeIn(300)
                .delay(delay)
                .fadeOut(300, function() {
                    $(this).remove();
                    Sp.studio.hoverMessage.active = false;

                    // do we have a queue to work through?
                    if (Sp.studio.hoverMessage.queue.length > 0) {
                        var options = Sp.studio.hoverMessage.queue.pop();
                        Sp.studio.hoverMessage.show(options.msg, options.type, options.delay);
                        return;
                    }
                });
        }
    },

    initCopy: function() {
        var that = this;

        Modernizr.on('flash', function(result) {
            if (!result) {
                $('.zclip').hide();
            }
        });

        $.event.special.copy.options = {
            swfPath: Sp.urls['static'] + '/common/js/zero_clipboard/0.2.2/ZeroClipboard.swf', // jshint ignore:line
            trustedDomains: ['*']
        };

        $('body').on('copy', '.zclip', function(e) {
            var val = '';
            var copyElement = $($(this).data('copyFrom'))[0];
            var elementName = copyElement.tagName.toLowerCase();

            if (elementName === 'input' || elementName === 'textarea') {
                val = $(copyElement).val();
            } else {
                val = $(copyElement).text();
            }

            if ($(this).data('copyPrepend') !== undefined &&
                $(this).data('copyPrepend') !== '') {
                val = $(this).data('copyPrepend') + val;
            }

            e.clipboardData.clearData();
            e.clipboardData.setData("text/plain", val);
            e.preventDefault();

            if ($(this).data('copiedClass') !== undefined) {
                $(this).addClass($(this).data('copiedClass'));
            } else if ($(this).data('copiedMsg') !== undefined) {
                that.hoverMessage.show($(this).data('copiedMsg'), 'info');
            }
        });

        // this is here to prevent IE11 from freezing when the copy link button is clicked
        if (/MSIE|Trident/.test(window.navigator.userAgent)) {
            (function($) {
                // https://github.com/zeroclipboard/zeroclipboard/issues/159#issuecomment-49782199
                $('#global-zeroclipboard-html-bridge').on('focusin', false);
            })(window.jQuery);
        }
    },

    initPushPops: function() {
        // sp-tile, grid-item, cards
        $('body').on('click', '.js-toggle-push-pop', function() {
            if ($(this).parents('.sp-tile').hasClass('popped')) {
                $('.sp-tile.popped').removeClass('popped');
            } else {
                $('.sp-tile.popped').removeClass('popped');
                $(this).parents('.sp-tile').addClass('popped');
            }
        });

        // click outside, collapse push-pops
        $('body').on('click', function(e) {
            if (!$(e.target).parents('.push-pop').length && !$(e.target).is('.push-pop')) {
                 $('.sp-tile.popped').removeClass('popped');
            }
        });
    },

    handleGalleryDefaults: function() {
        var that = this;

        $('.js-delete-default, .js-set-as-default').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            self.location.href = $(this).data('href');
        });

        $('.js-new-brand-event-default').click(function () {
            that.modal({
                title: 'Add New Gallery Defaults',
                body: _.template($('#templateAddBrandEventDefaults').html(), {}),
                sizeClass: 'modal-md',
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Create',
                        'class': 'btn-primary',
                        click: function() {
                            Sp.studio.loading('Creating', 'show');

                            var modal = $(this).parents('div.modal');

                            $.post(that.studioPanelUri('/gallery/defaults/new'), {
                                name: $('#name').val()
                            }, function (json) {
                                Sp.studio.loading('Creating', 'hide');

                                if (json.status === 'success') {
                                    // handle form submission exception
                                    that.formIsSubmitting = true;
                                    self.location.href =
                                        that.studioPanelUri('/gallery/defaults/edit/' + json.brand_event_defaults_id);
                                } else if (json.status === 'form_errors') {
                                    that.displayFormErrors(modal, json.errors);
                                } else if (json.status === 'error') {
                                    modal.modal('hide');
                                    that.hoverMessage.show(json.msg, json.status);
                                }
                            }, 'json');
                        }
                    }
                ]
            });
        });
    },

    updateEventPasswordVisibility: function () {
        if ($('#access_level').val() === '2' ||
            $('#access_level').val() === '3') {

            $('#event_password').prop('disabled', false).removeClass('disabled').parents('.form-group').removeClass('disabled');
        } else {
            $('#event_password').prop('disabled', true).addClass('disabled').parents('.form-group').addClass('disabled');
        }
    },

    handleGalleryEditBrandEventDefaults: function() {
        var that = this;
        this.gallerySettingsCommon();

        // Allow Brand Event Defaults set name to be edited.
        that.inlineEditName({
            wrapperSelector: '#pageTitleHeaderText',
            maxInputTextLength: 100,
            placeholderText: 'Enter a name',
            nameChangedCallback: function(name) {
                $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/gallery/updatedefaultname'), 'gallery_updatedefaultname'), {
                    brand_event_defaults_id: that.jsValues.id,
                    brand_event_defaults_name: name
                }, function(data) {
                    that.hoverMessage.show(data.msg, data.status);
                }, 'json');
            }
        });
    },

    handlePaymentIndex: function() {
        var that = this;

        $('#orderSelect').change(function () {
            if ($(this).val() !== '') {
                self.location.href = that.studioPanelUri('/order/view/' + $(this).val());
            }
        });

        $('a.request-payment').on('click', function (e) {
            e.preventDefault();

            if (that.jsValues.availableAmount > 0) {
                var amount = Sp.numberFormat(parseFloat(that.jsValues.availableAmount) - parseFloat(that.jsValues.withdrawalFee), 2, '.', ',');

                that.modal({
                    title: 'Withdrawal Request',
                    body: _.template($('#templatePaymentWithdrawal').html(), {
                        amount: amount
                    }),
                    sizeClass: 'modal-md',
                    buttons: [
                        {
                            label: 'Cancel',
                            close: true
                        },{
                            label: 'Yes, Proceed',
                            'class': 'btn-primary',
                            click: function () {

                                var allowedAmount = parseFloat(that.jsValues.availableAmount) - parseFloat(that.jsValues.withdrawalFee);
                                allowedAmount = Sp.numberFormat(allowedAmount, 2, '.', ',');
                                var selectedAmount = parseFloat(Sp.moneyOnly($('#withdrawalAmount').val()));

                                if ((allowedAmount < selectedAmount) || selectedAmount <= 0) {
                                    $('#amountError li').text('Please enter an amount between ' + allowedAmount + ' and 0.01.');
                                    $('#amountError').show();
                                    return;
                                }

                                that.loading('Requesting Withdrawal', 'show');

                                self.location.href = that.studioPanelUri('/payment/withdrawal') + '?amount=' + selectedAmount;
                                return;
                            }
                        }
                    ]
                });
            } else {
                that.modal({
                    title: 'Withdrawal Request',
                    sizeClass: 'modal-md',
                    body: _.template($('#templatePaymentNoWithdrawal').html(), {}),
                    buttons: [
                        {
                            label: 'Ok',
                            'class': 'btn-primary',
                            close: true
                        }
                    ]
                });
            }
        });
    },

    handlePricingPricesheet: function () {
        var that = this;

        this.initPushPops();
        var clickedLabCatalogId = null;

        $('a.create').on('click', function (e) {
            e.preventDefault();

            that.modal({
                title: 'Create New Price Sheet',
                body: _.template($('#templateNewPricesheet').html(), {
                    catalogs: that.jsValues.catalogs,
                    hasLabCatalogs: that.jsValues.hasLabCatalogs
                }),
                sizeClass: 'modal-md',
                open: function () {
                    $('#' + this.id).find('select').select2({
                        width: '100%'
                    });

                    if (clickedLabCatalogId) {
                        $('#' + this.id).find('select').val(clickedLabCatalogId).trigger('change');
                    }
                },
                clsoe: function () {
                    clickedLabCatalogId = null;
                },
                shown: function() {
                    $('.modal').find('input').focus();
                },
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Create',
                        'class': 'btn-primary',
                        click: function () {
                            var name = $.trim($(this).parents('.modal').find('input').val());
                            var catalogId = $('#catalogId').val();

                            // The -1 value for catalog ID indicates that a
                            // selection needs to be made.  An empty value
                            // already indicates "Self-Fulfilled - Empty".
                            if (name === '' || catalogId === '-1') {
                                $(this).parents('.modal').find('.form-group').addClass('has-error');
                                return;
                            }

                            $(this).parents('.modal').modal('hide');
                            that.loading('Creating', 'show');
                            self.location.href = that.studioPanelUri('/pricing/createpricesheet') +
                                '?&name=' + encodeURIComponent(name) + '&catalog_id=' + catalogId;
                        }
                    }
                ]
            });
        });

        $('input.lab-compare').on('ifChecked', function () {
            $(this).parents('.lab-container').addClass('selected');

            compareLabAvailable();
        });

        $('input.lab-compare').on('ifUnchecked', function () {
            $(this).parents('.lab-container').removeClass('selected');

            compareLabAvailable();
        });

        $('div.compare').on('click', function (e) {
            e.preventDefault();

            $(this).find('input:checkbox').iCheck('toggle');
            return false;
        });

        function compareLabAvailable() {
            var numSelected = $('input:checked').length;

            if (numSelected > 1) {
                $('h3.compare-selected').show();
                $('h3.none-selected').hide();
            } else {
                $('h3.compare-selected').hide();
                $('h3.none-selected').show();
            }

            if (numSelected == 3) {
                $('input:not(:checked)').iCheck('disable');
            } else {
                $('input:disabled').iCheck('enable');
            }
        }

        $('div.lab-container').on('click', function () {
            clickedLabCatalogId = $(this).data('catalogId');
            $('a.create').trigger('click');
        });

        $('.show-comparing').on('click', function (e) {
            e.preventDefault();

            $('#priceSheetContainer').hide();
            $('#compareContainer').show();
        });

        $('.compare-close').on('click', function () {
            $('#compareContainer').hide();
            $('#priceSheetContainer').show();
        });

        $('#compare-labs').on('click', function (e) {
            e.preventDefault();

            var selectedLabIds = [];

            $('input:checked').each(function (i, elm) {
                selectedLabIds.push($(elm).val());
            });

            $('div.lab-overview').hide();
            $('div.lab-compare-detail').html(_.template($('#compareLabDetails').html(), {
                totalLabs: selectedLabIds.length,
                bayPhoto: (($.inArray('2', selectedLabIds) >= 0) ? true : false),
                blackRiver: (($.inArray('4', selectedLabIds) >= 0) ? true : false),
                printrefinery: (($.inArray('5', selectedLabIds) >= 0) ? true : false),
                millers: (($.inArray('10', selectedLabIds) >= 0) ? true : false),
                mpix: (($.inArray('11', selectedLabIds) >= 0) ? true : false),
                prodpi: (($.inArray('3', selectedLabIds) >= 0 || $.inArray('9', selectedLabIds) >= 0) ? true : false),
                technicare: (($.inArray('8', selectedLabIds) >= 0) ? true : false),
                richard: (($.inArray('12', selectedLabIds) >= 0) ? true : false),
                whcc: (($.inArray('15', selectedLabIds) >= 0) ? true : false),
                atkins: (($.inArray('14', selectedLabIds) >= 0) ? true : false),
                gta: (($.inArray('16', selectedLabIds) >= 0) ? true : false),
                hcPro: (($.inArray('7', selectedLabIds) >= 0) ? true : false)
            }));
            $('div.lab-compare-detail').show();

            $('h3.select-other').show();
            $('h3.compare-selected').hide();

            $('a.choose-lab').on('click', function (e) {
                e.preventDefault();
                clickedLabCatalogId = $(this).data('labCatalogId');
                $('a.create').trigger('click');
            });
        });

        $('h3.select-other a').on('click', function (e) {
            e.preventDefault();

            $('h3.select-other').hide();
            $('div.lab-compare-detail').hide();
            $('div.lab-overview').show();
            $('h3.compare-selected').show();
        });

        $('a.duplicate').on('click', function (e) {
            e.preventDefault();
            var pricesheetId = $(this).parents('.sp-tile').data('pricesheetId');

            that.modal({
                title: 'Duplicate Pricesheet',
                body: _.template($('#templateConfirmDuplicate').html(), {}),
                sizeClass: 'modal-md',
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Duplicate',
                        'class': 'btn-primary',
                        click: function () {
                            var name = $.trim($(this).parents('.modal').find('input').val());

                            if (name === '') {
                                $(this).parents('.modal').find('.form-group').addClass('has-error');
                                return;
                            }

                            $(this).parents('.modal').modal('hide');
                            that.loading('Duplicating', 'show');
                            self.location.href = that.studioPanelUri('/pricing/duplicatepricesheet') +
                                '?pricesheet_id=' + pricesheetId + '&name=' + encodeURIComponent(name);
                        }
                    }
                ]
            });
        });

        $('a.delete').on('click', function (e) {
            e.preventDefault();
            var pricesheetId = $(this).parents('.sp-tile').data('pricesheetId');

            that.loading('Loading', 'show');

            $.get(that.studioPanelUri('/pricing/deletepricesheet'), {
                action: 'check',
                pricesheet_id: pricesheetId
            }, function (json) {

                that.loading('Loading', 'hide');

                // If the Price Sheet isn't associated with any Brand Event
                // Defaults, we don't have to block deletion because the user
                // can change the Price Sheet on any Events using it from this
                // modal.
                if (json.brand_event_defaults.length === 0) {
                    that.modal({
                        title: 'Confirm Deletion',
                        body: _.template($('#templateConfirmDelete').html(), json),
                        sizeClass: 'modal-md',
                        open: function () {
                            $('#newPricesheetId').select2();
                        },
                        buttons: [
                            {
                                label: 'Cancel',
                                close: true
                            },{
                                label: 'Delete',
                                'class': 'btn-danger',
                                click: function () {
                                    var newId = '';

                                    if ($('#newPricesheetId').length) {
                                        newId = $('#newPricesheetId').val();
                                    }

                                    $(this).parents('.modal').modal('hide');

                                    that.loading('Deleting', 'show');
                                    self.location.href =
                                        that.studioPanelUri('/pricing/deletepricesheet') +
                                        '?pricesheet_id=' + pricesheetId +
                                        '&new_pricesheet_id=' + newId;
                                }
                            }
                        ]
                    });
                } else {
                    // Pass the current Brand ID to the template, so we can
                    // display the Brand name for any Brand Event Defaults
                    // that are present in a Brand other than the current one.
                    json.currentBrandId = that.brandId;

                    that.modal({
                        title: 'Cannot Delete Price Sheet',
                        body: _.template($('#templateCannotDeleteBrandEventDefaultsInUse').html(), json),
                        sizeClass: 'modal-md',
                        buttons: [
                            {
                                label: 'Close',
                                close: true
                            }
                        ]
                    });
                }
            }, 'json');
        });
    },

    handlePricingEdit: function () {
        var that = this;

        this.inlineEditName({
            placeholderText: 'Pricesheet Name',
            wrapperSelector: '#pageTitleHeaderText',
            maxInputTextLength: 30,
            nameChangedCallback: function (newName) {
                $('#name').val(newName);

                $.post(that.studioPanelUri('/pricing/updatename'), {
                    pricesheet_id: that.jsValues.pricesheetId,
                    name: newName
                }, function (json) {
                    that.hoverMessage.show(json.msg, json.status);
                }, 'json');
            }
        });

        // money-only setup
        $('body').on('blur', 'input.money-only', function () {
            var val = Sp.moneyOnly($(this).val());

            if (val === '') {
                val = '0.00';
            }

            val = parseFloat(val);

            $(this).val(val.toFixed(2));
        });

        // Decimal number with three places.
        $('body').on('blur', 'input.decimal-3', function () {
            var val = Sp.numberFormat($(this).val(), 3, '.', '');

            if (val === '') {
                val = '0.00';
            }

            val = parseFloat(val);

            $(this).val(val.toFixed(3));
        });

        // top tabs
        $('#groups').on('click', 'li.type', function () {
            var id = $(this).data('toggleId');

            $('.group-pane').removeClass('selected');
            $(id).addClass('selected');

            $(this).parents('ul').find('.selected').removeClass('selected');
            $(this).addClass('selected');
        });

        // handle deleting an item
        $('#groupPanes').on('click', '.js-remove-pricing-item', function () {
            var itemId = $(this).parents('tr.item').data('itemId');

            that.modal({
                title: 'Confirm Item Deletion',
                sizeClass: 'modal-md',
                body: _.template($('#templateItemDelete').html(), {}),
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Yes, Delete',
                        'class': 'btn-danger',
                        click: function () {
                            that.hoverMessage.show('Deleting item', that.hoverMessage.type.info);

                            $.post(that.studioPanelUri('/pricing/deleteitem'), {
                                pricesheet_id: that.jsValues.pricesheetId,
                                item_id: itemId
                            },
                            function (data) {
                                if (data.hasChildren) {
                                    $('tr[data-parent-item-id="' + itemId + '"]').remove();
                                } else {
                                    var row = $('tr[data-item-id="' + itemId + '"]');

                                    var prev = $(row).prev();
                                    var next = $(row).next();

                                    // remove the row
                                    $(row).remove();

                                    // if the next and previous headers are both sub headings we need to get rid of this section
                                    if (prev.hasClass('sub-heading') && (next.hasClass('sub-heading') || next.length === 0)) {
                                        $(prev).remove();
                                    }
                                }

                                // update tab count
                                that.updatePricingTabCount();

                                that.hoverMessage.show(data.msg, data.status);
                            },
                            'json');

                            $(this).parents('div.modal').modal('hide');
                        }
                    }
                ]
            });
        });

        // update tab count on pricing edit page
        this.updatePricingTabCount = function (tabId) {
            var inputId = parseInt(tabId, 10);
            var tabIds = [];
            var count = 0;
            if (inputId > 0) {
                tabIds.push(inputId);
            } else {
                $('#groups li.type').each(function(i, el) {
                    tabIds.push(parseInt($(el).data('id'), 10));
                });
            }
            for (var tabIdsIndex in tabIds) {
                var id = tabIds[tabIdsIndex];
                if (id > 0) {
                    count += $('#groupList' + id + ' .js-contains-items-in-pricesheet tr.item').length;
                    count += $('#groupList' + id + ' .js-contains-switchable-items-in-pricesheet tr.item input.for-sale:checked').length;
                    $('#groups > li[data-id="' + id + '"] .count').html(count);
                }
                count = 0;
            }
        }

        // setup the shipping toggle
        $('body').on('click', 'td.shipping a.shipping-toggle', function (e) {
            e.preventDefault();

            var cell = $(this).parents('td').first();
            $(this).hide();
            $(cell).find('.input-group').css('display', 'table');
        });

        var updateItemProfit = function (row) {
            row = $(row);
            if (!row.find('td.cost').length) {
                return;
            }

            var cost = parseFloat(row.find('td.cost').data('cost'));
            var price = parseFloat(row.find('td.price input').val());
            var profit = price - cost;
            var profitCol = row.find('td.profit span.show-profit');
            profitCol.removeClass('gain').removeClass('loss');
            profitCol.text(that.jsValues.catalogCurrencySymbol + profit.toFixed(2));

            if (profit > 0) {
                profitCol.addClass('gain');
            } else if (profit < 0) {
                profitCol.addClass('loss');
            }
        };

        var updateItemInfo = function (elm) {

            var row = $(elm).parents('tr.item');

            var params = {
                pricesheet_id: that.jsValues.pricesheetId,
                item_id: row.data('itemId'),
                item_name: '',
                item_price: '',
                item_shipping_charge: '',
                charge_shipping: 1
            };

            row.find('input').each(function() {
                if ($(this).attr('name') === 'name') {
                    params.item_name = $(this).val();
                }

                if ($(this).attr('name') === 'price') {
                    params.item_price = $(this).val();
                }

                if ($(this).attr('name') === 'shipping_charge') {
                    params.item_shipping_charge = $(this).val();
                }

                if ($(this).attr('name') === 'charge_shipping') {
                    params.charge_shipping = (($(this).is(':checked')) ? 1 : 0);
                }
            });

            $.post(that.studioPanelUri('/pricing/updateitem'),
            params, function (json) {
                that.hoverMessage.show(json.msg, json.status);

                if (json.status === that.hoverMessage.type.success) {
                    var row = $('tr.item[data-item-id="' + json.item_id + '"]');
                    updateItemProfit(row);

                    // Because our formatted profit amount comes back in the
                    // response, just set the value within the span.
                    $(row).find('span.show-profit').text(json.formatted_profit);
                }
            }, 'json');

        };

        var activeFieldValue = null;

        // the save of the item on blur change
        $('#groupPanes').on('focusin', 'table.items:not(.new-item) tr.item input', function () {
            activeFieldValue = $(this).val();
            $(this).select();
        }).on('focusout', 'table.items:not(.new-item) tr.item input', function() {
            // was there an actual update done?
            if (activeFieldValue === $(this).val()) {
                return;
            }

            updateItemInfo(this);
        });

        $('body').on('ifToggled', 'table.items:not(.new-item) input[name="charge_shipping"]', function () {
            updateItemInfo(this);
        });

        $('body').on('click', 'table.items:not(.new-item) td.desc, table.auto-digital-items td.desc', function () {

            var itemId;

            if ($(this).parents('tr.item').data('parentItemId') > 0) {
                itemId = $(this).parents('tr.item').data('parentItemId');
            } else {
                itemId = $(this).parents('tr.item').data('itemId');
            }

            var cell = $(this);

            $.get(that.studioPanelUri('/pricing/itemdescription'), {
                item_id: itemId,
                pricesheet_id: that.jsValues.pricesheetId
            }, function (json) {

                that.modal({
                    title: 'Item Description',
                    body: _.template($('#templateItemDescription').html(), json),
                    open: function () {
                        var modalId = this.id;

                        that.editor('#' + modalId + ' textarea', {
                            minHeight: 200,
                            maxHeight: 350,
                            limiter: 1000
                        });

                        $('#' + modalId).find(':file').on('change', function () {
                            var files = this.files;
                            var ext, file;

                            for (var i = 0; i < files.length; i++) {
                                file = files[i].name;
                                ext = file.substr((file.lastIndexOf('.') + 1)).toLowerCase();
                                if (ext !== 'jpg' && ext !== 'jpeg') {
                                    return;
                                }
                            }

                            that.loading('Uploading', 'show');

                            var formData = new FormData();
                            formData.append('pricesheet_id', that.jsValues.pricesheetId);
                            formData.append('item_id', itemId);
                            formData.append('file', files[0]);

                            $.ajax({
                                url: that.studioPanelUri('/pricing/additemimage'),
                                cache: false,
                                contentType: false,
                                dataType: 'json',
                                processData: false,
                                async: true,
                                data: formData,
                                type: 'post',
                                success: function(json) {

                                    that.loading('Uploading', 'hide');

                                    $('#' + modalId).find(':file').val('');
                                    if (json.status === 'success') {
                                        $('#' + modalId).find('.images').append('<li><img src="' + json.thumbnail_url + '"><div><a href="' + json.id + '" class="btn btn-xs btn-default desc-image">Remove</a></div></li>');
                                    } else {
                                        that.hoverMessage.show(json.msg, json.status);
                                    }
                                }
                            });
                        });
                    },
                    buttons: [
                        {
                            label: 'Cancel',
                            close: true
                        },{
                            label: 'Save',
                            'class': 'btn-primary',
                            click: function() {

                                var thisDialog = $(this).parents('div.modal');

                                $.post(that.studioPanelUri('/pricing/itemdescription'), {
                                    pricesheet_id: that.jsValues.pricesheetId,
                                    item_id: itemId,
                                    description: thisDialog.find('textarea').val()
                                }, function (json) {
                                    if (json.status === 'success') {

                                        thisDialog.modal('hide');

                                        if (json.has_description) {
                                            $(cell).find('span.desc-container').html(that.svgIcon('iconMinus', 'icon-minus touch-icon'));
                                        } else {
                                            $(cell).find('span.desc-container').html(that.svgIcon('iconPlus', 'icon-plus touch-icon'));
                                        }
                                    } else {
                                        that.hoverMessage.show(json.msg, Sp.dropDownMessageType.error);
                                    }
                                }, 'json');
                            }
                        }
                    ]
                });
            }, 'json');
        });

        $('body').on('click', 'a.desc-image', function (e) {
            e.preventDefault();

            var cell = $(this).parents('li');
            that.loading('Removing', 'show');

            $.post(that.studioPanelUri('/pricing/removeitemimage'), {
                pricesheet_id: that.jsValues.pricesheetId,
                image_id: $(this).attr('href')
            }, function (json) {
                that.loading('Removing', 'hide');

                if (json.status === 'success') {
                    cell.remove();
                } else {
                    that.hoverMessage.show(json.msg, json.status);
                }
            }, 'json');
        });

        $('.alert button.close').on('click', function () {
            $.post(that.studioPanelUri('/pricing/removemessage'), {
                pricesheet_id: that.jsValues.pricesheetId,
                note_id: $(this).parents('div.alert').data('messageId')
            },
            function () {
            }, 'json');
        });

        $('body').on('click', 'a.add-custom-item', function (e) {
            e.preventDefault();

            $(this).parents('div.group-pane').find('.custom-auto-item').hide();

            var customItemPane = $(this).parents('div.group-pane').find('.custom-item');
            customItemPane.find('.error').removeClass('error');
            customItemPane.find('input[name="new_size_width"]').val('');
            customItemPane.find('input[name="new_size_height"]').val('');
            customItemPane.find('input[name="canvas_depth"]').val('');
            customItemPane.find('input[name="name"]').val('');
            customItemPane.find('input[name="price"]').val('0.00');
            customItemPane.find('input[name="shipping_charge"]').val('0.00');
            customItemPane.show();
        });

        $('body').on('click', 'a.add-custom-auto-item', function (e) {
            e.preventDefault();

            $(this).parents('div.group-pane').find('.custom-item').hide();

            var customItemPane = $(this).parents('div.group-pane').find('.custom-auto-item');
            customItemPane.find('.error').removeClass('error');
            customItemPane.find('input[name="name"]').val('');
            customItemPane.find('input[name="pixels"]').val('');
            customItemPane.find('input[name="price"]').val('0.00');
            customItemPane.find('input.for-sale').iCheck('uncheck');
            customItemPane.show();
        });

        $('a.terms-of-sale').on('click', function (e) {
            e.preventDefault();

            that.loading('Loading', 'show');

            $.get(that.studioPanelUri('/pricing/termsofsale'), {
                pricesheet_id: that.jsValues.pricesheetId
            }, function (json) {

                that.loading('Loading', 'hide');

                that.modal({
                    title: 'Terms of Sale',
                    body: _.template($('#templateTermsOfSale').html(), json),
                    open: function () {
                        that.editor('#' + this.id + ' textarea', {
                            minHeight: 200,
                            maxHeight: 350,
                            limiter: 30000
                        });
                    },
                    buttons: [
                        {
                            label: 'Close',
                            close: true
                        },{
                            label: 'Save',
                            'class': 'btn-primary',
                            click: function () {

                                that.loading('Saving', 'show');

                                var modal = $(this).parents('.modal');
                                modal.modal('hide');

                                $.post(that.studioPanelUri('/pricing/termsofsale'), {
                                    pricesheet_id: that.jsValues.pricesheetId,
                                    text: modal.find('textarea').val()
                                }, function (json) {
                                    that.loading('Saving', 'hide');
                                    that.hoverMessage.show(json.msg, json.status);
                                }, 'json');
                            }
                        }
                    ]
                });
            }, 'json');
        });

        $('a.lab-shipping-rates').on('click', function (e) {
            e.preventDefault();

            var template = $('#templateLabShippingCharges');

            that.modal({
                title: template.data('title'),
                body: template.html(),
                sizeClass: 'modal-lg',
                buttons: [{
                    label: 'Close',
                    close: true
                }]
            });
        });

        this.activateSwitch('input.tax-switch', {
            onChange: function () {
                that.updateSwitchStyle(this);
                saveTaxInfo();
            }
        });

        var saveTaxInfo = function () {
            $.post(that.studioPanelUri('/pricing/updatetaxinfo'), {
                pricesheet_id: that.jsValues.pricesheetId,
                sales_tax_percent: $('#salesTaxPercent').val(),
                sales_tax_title: $('#salesTaxTitle').val(),
                sales_tax_state_id: $('#salesTaxStateId').val(),
                sales_tax_on_digitals: (($('#salesTaxOnDigitals').is(':checked')) ? 1 : 0),
                sales_tax_on_shipping: (($('#salesTaxOnShipping').is(':checked')) ? 1 : 0),
                vat_number: $('#vatNumber').val()
            }, function (json) {
                that.hoverMessage.show(json.msg, json.status);
            }, 'json');
        };

        var handleStateTaxWarning = function () {
            if ($('#salesTaxStateId').val()) {
                $('.state-tax-warning').show();
                $('.state-tax-warning span.locale').html($('#salesTaxStateId option[value="' + $('#salesTaxStateId').val() + '"]').html());
            } else {
                $('.state-tax-warning').hide();
            }
        };

        handleStateTaxWarning();

        $('#salesTaxPercent, #salesTaxTitle, #vatNumber').on('blur', function () {
            saveTaxInfo();
            handleStateTaxWarning();
        });

        $('#salesTaxStateId').on('change', function () {
            saveTaxInfo();
            handleStateTaxWarning();
        });

        var saveShippingInfo = function () {
            $.post(that.studioPanelUri('/pricing/updateshippinginfo'), {
                pricesheet_id: that.jsValues.pricesheetId,
                shipping_title: $('#shippingTitle').val(),
                pass_on_lab_costs: (($('#passOnLabCosts').is(':checked')) ? 1 : 0),
                allow_client_to_select: (($('#allowClientToSelectOptions').is(':checked')) ? 1 : 0)
            }, function (json) {
                that.hoverMessage.show(json.msg, json.status);
            }, 'json');
        };

        this.activateSwitch('input.shipping-switch', {
            onChange: function () {
                that.updateSwitchStyle(this);
                saveShippingInfo();

                var elem = $(this.elem[0]);

                if (elem.attr('id') === 'passOnLabCosts') {
                    if (elem.is(':checked')) {
                        $('#allowClientRow').removeClass('dont');
                        $('#customShippingOptions').addClass('dont');
                    } else {
                        $('#allowClientRow').addClass('dont');
                        $('#customShippingOptions').removeClass('dont');
                    }
                }
            }
        });

        $('#shippingTitle').on('blur', function () {
            var val = $.trim($(this).val());

            $(this).val(val);

            saveShippingInfo();
        });

        $('#addShippingOption').on('click', function (e) {
            e.preventDefault();

            $('#shippingOptionsTable tbody').append(
                $('#templateShippingOption').html());
        });

        $('#shippingOptionsTable').on('click', '.icon-delete', function () {
            $(this).parents('tr').remove();
        });

        $('#saveShippingOptions').on('click', function (e) {
            e.preventDefault();

            var emptyFound = false;
            var options = [];

            $('#shippingOptionsTable tbody').find('tr').each(function (i, row) {

                var price = $(row).find('input.price').val();
                var title = $.trim($(row).find('input.title').val());

                if (price === '' || title === '') {
                    emptyFound = true;
                    return;
                }

                options.push({
                    price: price,
                    title: title
                });
            });

            if (emptyFound) {
                $('#shippingOptionsError').show();
                return;
            }

            $('#shippingOptionsError').hide();

            that.loading('Saving', 'show');

            $.post(that.studioPanelUri('/pricing/customshippingoptions'), {
                pricesheet_id: that.jsValues.pricesheetId,
                options: options
            }, function (json) {
                that.loading('Saving', 'hide');
                that.hoverMessage.show(json.msg, json.status);
            }, 'json');
        });

        var getMarkupGroupId = function () {
            var applyTo = $('#markupApplyTo').val();
            var groupId = '';

            if (applyTo === 'all') {
                groupId = '#groupPanes';
            } else if (applyTo === 'prints') {
                groupId = '.group-pane[data-type="1"]';
            } else if (applyTo === 'canvas') {
                groupId = '.group-pane[data-type="2"]';
            } else if (applyTo === 'metal') {
                groupId = '.group-pane[data-type="5"]';
            } else if (applyTo === 'product') {
                groupId = '.group-pane[data-type="4"]';
            }

            return groupId;
        };

        $('#applyMarkupChanges').on('click', function (e) {
            e.preventDefault();

            var markupPercent = parseFloat($('#markupPercent').val());

            if (markupPercent <= 0 || isNaN(markupPercent)) {
                return;
            }

            // the markup multiple
            markupPercent = 1 + (markupPercent / 100);

            var groupSelector = getMarkupGroupId();
            var roundType = $('#markupRounding').val();
            var labCost, price, pennies;

            $(groupSelector).find('tr.item').each(function (i, row) {
                if ($(row).find('td[data-cost]').length > 0) {
                    labCost = parseFloat($(row).find('td[data-cost]').data('cost'));
                    if (labCost !== 0) {
                        price = labCost * markupPercent;

                        if (roundType === 'none') {
                            $(row).find('input[name="price"]').val(Sp.numberFormat(price.toFixed(2), 2, '.', ''));
                        } else if (roundType === '0.10') {
                            $(row).find('input[name="price"]').val(Sp.numberFormat(price.toFixed(1), 2, '.', ''));
                        } else if (roundType === '0.50') {
                            pennies = price - Math.floor(price);
                            if (pennies < 0.5) {
                                price = Math.floor(price) + 0.5;
                            } else {
                                price = Math.floor(price) + 1;
                            }

                            $(row).find('input[name="price"]').val(Sp.numberFormat(price.toFixed(2), 2, '.', ''));
                        } else if (roundType === '0.95') {
                            pennies = price - Math.floor(price);
                            if (pennies < 0.95) {
                                price = Math.floor(price) + 0.95;
                            } else {
                                price = Math.floor(price) + 1.95;
                            }

                            $(row).find('input[name="price"]').val(Sp.numberFormat(price.toFixed(2), 2, '.', ''));
                        } else if (roundType === '0.99') {
                            pennies = price - Math.floor(price);
                            if (pennies < 0.99) {
                                price = Math.floor(price) + 0.99;
                            } else {
                                price = Math.floor(price) + 1.99;
                            }

                            $(row).find('input[name="price"]').val(Sp.numberFormat(price.toFixed(2), 2, '.', ''));
                        } else if (roundType === '1.00') {
                            $(row).find('input[name="price"]').val(Sp.numberFormat(Math.ceil(price), 2, '.', ''));
                        }
                    }
                }
            });

            // Enable the save "button"
            $('#savePriceChanges').removeClass('disabled');
            $('#savePriceChanges').addClass('btn-primary');
        });

        // Initialize as a disabled "button"
        $('#savePriceChanges').addClass('disabled');

        $('#savePriceChanges').on('click', function (e) {
            e.preventDefault();

            var prices = {};
            var groupSelector = getMarkupGroupId();

            that.loading('Saving Prices', 'show');

            $(groupSelector).find('tr.item').each(function (i, row) {
                prices[$(row).data('itemId')] = $(row).find('input[name="price"]').val();
            });

            $.post(that.studioPanelUri('/pricing/bulkpricesave'), {
                pricesheet_id: that.jsValues.pricesheetId,
                prices: prices
            }, function (json) {
                that.loading('Saving Prices', 'hide');
                that.hoverMessage.show(json.msg, json.status);

                // update the profit for each item
                $('tr.item').each(function (i, obj) {
                    var itemId = $(obj).data('itemId');
                    updateItemProfit(obj);

                    // Update the displayed profit value in each row
                    // that was affected.
                    if (json.formatted_profits !== undefined &&
                        json.formatted_profits[itemId]
                    ) {
                        var row = $('tr.item[data-item-id="' + itemId + '"]');
                        $(row).find('span.show-profit').text(json.formatted_profits[itemId]);
                    }
                });
            }, 'json');

            // Disable the "save" button so that future uses of the markup tool
            // properly force users to click the "Apply" button first
            $('#savePriceChanges').removeClass('btn-primary');
            $('#savePriceChanges').addClass('disabled');
        });

        var maxGroups = 3;

        $('.add-group').on('click', function () {

            if ($('li.custom-group').length >= maxGroups) {
                return;
            }

            var html = _.template($('#templateAddGroup').html(), {
                totalAllowed: maxGroups,
                remaining: maxGroups - $('li.custom-group').length
            });

            that.modal({
                title: 'Create New Group',
                body: html,
                sizeClass: 'modal-md',
                buttons: [
                    {
                        label: 'Close',
                        close: true
                    },{
                        label: 'Create',
                        'class': 'btn-primary',
                        click: function() {

                            var name = $.trim($('#groupName').val());

                            if (name === '') {
                                return;
                            }

                            $(this).parents('.modal').modal('hide');
                            that.loading('Creating Group', 'show');

                            $.post(that.studioPanelUri('/pricing/addgroup'), {
                                pricesheet_id: that.jsValues.pricesheetId,
                                name: name,
                                order: $('#groups li.type').length + 1
                            }, function (json) {

                                that.loading('Creating Group', 'hide');

                                if (json.status === 'success') {
                                    var tabHtml = _.template($('#templateGroupTab').html(), json.group);
                                    $(tabHtml).insertBefore('li.group-menu');

                                    var paneHtml = _.template($('#templateGroupPane').html(), json.group);
                                    $('#groupPanes').append(paneHtml);

                                    // trigger a click so the tab is shown
                                    $('#groups li[data-id="' + json.group.id + '"]').trigger('click');
                                } else {
                                    that.hoverMessage.show(json.msg, json.status);
                                }

                                if ($('li.custom-group').length >= maxGroups) {
                                    $('.add-group').hide();
                                }
                            }, 'json');
                        }
                    }
                ]
            });
        });

        $('.delete-group').on('click', function (e) {
            e.preventDefault();

            if ($('#groups li.selected').data('type') !== '') {
                that.modal({
                    title: 'Cannot Delete',
                    body: _.template($('#templateCannotDeleteGroup').html(), {}),
                    sizeClass: 'modal-sm',
                    buttons: [
                        {
                            label: 'Close',
                            close: true
                        }
                    ]
                });
                return;
            }

            var groupId = $('#groups li.selected').data('id');

            that.modal({
                title: 'Delete Group',
                body: _.template($('#templateDeleteGroup').html(), {}),
                sizeClass: 'modal-md',
                buttons: [
                    {
                        label: 'Close',
                        close: true
                    },{
                        label: 'Yes, Delete',
                        'class': 'btn-danger',
                        click: function () {
                            $(this).parents('.modal').modal('hide');
                            that.loading('Deleting', 'show');

                            $.post(that.studioPanelUri('/pricing/deletegroup'), {
                                pricesheet_id: that.jsValues.pricesheetId,
                                group_id: groupId
                            }, function () {
                                that.loading('Deleting', 'hide');
                                $('#groups li[data-id="' + groupId + '"]').remove();
                                $('#groups li:first').trigger('click');

                                if ($('li.custom-group').length < maxGroups) {
                                    $('li.add-group').show();
                                }
                            }, 'json');
                        }
                    }
                ]
            });
        });

        $('.rename-group-prompt').on('click', function (e) {
            e.preventDefault();

            var groupId = $('#groups li.selected').data('id');

            that.modal({
                title: 'Rename Group',
                body: _.template($('#templateRenameGroup').html(), {
                    name: $('#groups li.selected').data('name')
                }),
                sizeClass: 'modal-md',
                buttons: [
                    {
                        label: 'Close',
                        close: true
                    },{
                        label: 'Rename',
                        'class': 'btn-primary',
                        click: function () {

                            var name = $.trim($('#groupName').val());

                            if (name === '') {
                                return;
                            }

                            $(this).parents('.modal').modal('hide');
                            that.loading('Renaming', 'show');

                            $.post(that.studioPanelUri('/pricing/renamegroup'), {
                                pricesheet_id: that.jsValues.pricesheetId,
                                group_id: groupId,
                                name: name
                            }, function () {
                                that.loading('Renaming', 'hide');
                                $('#groups li[data-id="' + groupId + '"] span.name').text(name);
                            }, 'json');
                        }
                    }
                ]
            });
        });

        $('#groupPanes').on('click', '.js-save-and-new, .js-save-and-close', function (e) {
            e.preventDefault();

            var close = $(this).data('close');
            var $pane = $(this).parents('.group-pane');
            var form = $pane.find('table.new-item').first();
            var error = false;

            var name = $.trim(form.find('input[name="name"]').val());

            if (name === '') {
                form.find('input[name="name"]').parents('td').addClass('has-error');
                error = true;
            }

            var width = $.trim(form.find('input[name="new_size_width"]').val());
            var height = $.trim(form.find('input[name="new_size_height"]').val());
            var canvas = 0;
            var bounds = '';

            if (form.find('input[name="canvas_depth"]').length) {
                canvas = form.find('input[name="canvas_depth"]').val();
            }

            if (width !== '' && height !== '') {
                if (isNaN(width)) {
                    form.find('input[name="new_size_width"]').addClass('invalid-bound');
                } else {
                    form.find('input[name="new_size_width"]').removeClass('invalid-bound');
                }

                if (isNaN(height)) {
                    form.find('input[name="new_size_height"]').addClass('invalid-bound');
                } else {
                    form.find('input[name="new_size_height"]').removeClass('invalid-bound');
                }

                // If either size value is invalid, just return.
                if (form.find('input[name="new_size_width"]').hasClass('invalid-bound') ||
                    form.find('input[name="new_size_height"]').hasClass('invalid-bound')
                ) {
                    return;
                }

                var tmpCanvas = 0;
                var tmpWidth = parseFloat(width);
                var tmpHeight = parseFloat(height);

                if (canvas !== '') {
                    tmpCanvas = parseFloat(canvas);
                }

                bounds = '0,0,' + (tmpWidth + (2 * tmpCanvas)).toString() + ',' + (tmpHeight + (2 * tmpCanvas)).toString();
            } else {
                // If the values are empty, ensure that they don't have the
                // class on them denoting the bound is invalid, because
                // empty values are allowed.
                form.find('input[name="new_size_width"]').removeClass('invalid-bound');
                form.find('input[name="new_size_height"]').removeClass('invalid-bound');
            }

            var price = form.find('input[name="price"]').val();

            if (price === '') {
                form.find('input[name="price"]').parents('.input-group').addClass('has-error');
                error = true;
            }

            var shipping = form.find('input[name="shipping_charge"]').val();
            var chargeShipping = '';

            if (form.find('input[name="charge_shipping"]').length) {
                chargeShipping = ((form.find('input[name="charge_shipping"]').is(':checked')) ? 1 : 0);
            }

            if (error) {
                return;
            }

            that.loading('Adding Item', 'show');

            $.post(that.studioPanelUri('/pricing/additem'), {
                pricesheet_id: that.jsValues.pricesheetId,
                name: name,
                price: price,
                bounds: bounds,
                canvas_depth: canvas,
                shipping_charge: shipping,
                charge_shipping: chargeShipping,
                group_id: $('#groups li.selected').data('id')
            }, function (json) {

                form.find('input[name="name"]').val('');
                form.find('input[name="new_size_width"]').val('');
                form.find('input[name="new_size_height"]').val('');
                form.find('input[name="canvas_depth"]').val('');
                form.find('input[name="price"]').val('0.00');
                form.find('input[name="charge_shipping"]').iCheck('check');
                form.find('input[name="shipping_charge"]').val('0.00');

                if (!json.digital) {
                    // check to see if a heading already exists
                    if (!$pane.find('td.crop-heading[data-bounds="' + json.bounds + '"]').length) {
                        // make the new heading amd insert it
                        var lastHeading = null;

                        $pane.find('td.crop-heading').each(function (i, td) {
                            if (json.cropArea < $(td).data('area')) {
                                lastHeading = $(td).parents('tr');
                                return false;
                            }
                        });

                        var html = _.template($('#templateNewCropHeading').html(), json);

                        // this is the case the tab is entirely empty
                        if (lastHeading === null) {
                            $pane.find('p.no-items').hide();
                            $pane.find('table.items').show();
                            $pane.find('table.items-table tbody').append(html);
                        } else {
                            $(lastHeading).before(html);
                        }
                    }

                    var rowHtml = _.template($('#templateNewItem').html(), json);
                    var boundsGroup = $pane.find('tr.item[data-bounds="' + json.bounds + '"]');

                    if (boundsGroup.length > 0) {
                        boundsGroup.last().after(rowHtml);
                    } else {
                        // first this after the new bounds heading
                        $pane.find('td.crop-heading[data-bounds="' + json.bounds + '"]').parents('tr').after(rowHtml);
                    }
                } else {
                    $('table.self-digital-items').removeClass('hide-sp');
                    $('table.self-digital-items tbody').append(_.template($('#templateNewItem').html(), json));
                    $('table.self-digital-items tbody tr').last().find('input:checkbox').iCheck(that.configs.iCheck);
                }

                // update tab count
                that.updatePricingTabCount(json.groupId);

                if (close === 1) {
                    $pane.find('.custom-item').hide();
                }

                that.loading('Adding Item', 'hide');
                that.hoverMessage.show(json.msg, json.status);

            }, 'json');
        });

        $('#groupPanes').on('click', '.js-auto-save-and-new, .js-auto-save-and-close', function (e) {
            e.preventDefault();

            var close = $(this).data('close');
            var $pane = $(this).parents('.group-pane');
            var form = $pane.find('table.new-auto-item').first();

            var name = $.trim(form.find('input[name="name"]').val());

            if (name === '') {
                form.find('input[name="name"]').parents('td').addClass('has-error');
                return;
            }

            var pixels = $.trim(form.find('input[name="pixels"]').val());

            var prices = {
                individual: {
                    for_sale: ((form.find('tr.first input:checkbox').is(':checked')) ? 1 : 0),
                    price: $.trim(form.find('tr.first input[name="price"]').val())
                },
                album: {
                    for_sale: ((form.find('tr.second input:checkbox').is(':checked')) ? 1 : 0),
                    price: $.trim(form.find('tr.second input[name="price"]').val())
                },
                event: {
                    for_sale: ((form.find('tr.third input:checkbox').is(':checked')) ? 1 : 0),
                    price: $.trim(form.find('tr.third input[name="price"]').val())
                }
            };

            that.loading('Adding Item', 'show');

            $.post(that.studioPanelUri('/pricing/adddigitalitem'), {
                pricesheet_id: that.jsValues.pricesheetId,
                name: name,
                pixels: pixels,
                prices: prices,
                group_id: $('#groups li.selected').data('id')
            }, function (json) {

                form.find('input[name="name"]').val('');
                form.find('input[name="pixels"]').val('');
                form.find('input[name="price"]').val('0.00');
                form.find('input:checkbox').iCheck('uncheck');

                $('table.auto-digital-items:not(.new-auto-item) tbody').append(_.template($('#templateNewAutoDigitalItem').html(), json));
                $('table.auto-digital-items:not(.new-auto-item) tbody tr[data-parent-item-id="' + json.items.individual.id + '"]').find('input:checkbox').iCheck(that.configs.iCheck);

                if (close === 1) {
                    $pane.find('.custom-auto-item').hide();
                }

                that.loading('Adding Item', 'hide');
                that.hoverMessage.show(json.msg, json.status);

            }, 'json');
        });

        $('a.js-cancel').on('click', function (e) {
            e.preventDefault();

            $($(this).data('cancelSelector')).hide();
        });

        // add the hovering for the rows that CSS can not previous sibling select
        $('table.auto-digital-items').on('mouseover', 'tr.second, tr.third', function () {
            if ($(this).hasClass('second')) {
                $(this).prev().addClass('hover');
            } else if ($(this).hasClass('third')) {
                $(this).prev().addClass('hover');
                $(this).prev().prev().addClass('hover');
            }
        }).on('mouseout', 'tr.second, tr.third', function () {
            if ($(this).hasClass('second')) {
                $(this).prev().removeClass('hover');
            } else if ($(this).hasClass('third')) {
                $(this).prev().removeClass('hover');
                $(this).prev().prev().removeClass('hover');
            }
        });

        var updateDigitalProperties = function (parentItemId) {
            var params = {};
            params.pricesheet_id = that.jsValues.pricesheetId;
            params.parent_item_id = parentItemId;

            params.name = $.trim($('tr.item[data-parent-item-id="' + parentItemId + '"] input[name="name"]').val());

            if (params.name === '') {
                $('tr.item[data-parent-item-id="' + parentItemId + '"] input[name="name"]').val('Download');
                params.name = 'Downlaod';
            }

            params.pixels = $.trim($('tr.item[data-parent-item-id="' + parentItemId + '"] input[name="pixels"]').val());

            if (params.pixels === '') {
                $('tr.item[data-parent-item-id="' + parentItemId + '"] input[name="pixels"]').val('0');
                pixels = 0;
            }

            params.items = {};

            $('tr.item[data-parent-item-id="' + parentItemId + '"]').each(function (i, row) {
                params.items[$(row).data('itemId')] = {
                    for_sale: (($(row).find('input.for-sale').is(':checked')) ? 1 : 0),
                    price: Sp.moneyOnly($(row).find('input[name="price"]').val())
                };
            });

            $.post(that.studioPanelUri('/pricing/updatedigitals'),
                params,
            function (json) {
                that.hoverMessage.show(json.msg, json.status);
            }, 'json');
        };

        $('table.auto-digital-items').on('ifToggled', 'input.for-sale', function () {
            var row = $(this).parents('tr');

            // update tab count
            that.updatePricingTabCount();

            if (!$(this).parents('table.auto-digital-items').hasClass('new-auto-item')) {
                updateDigitalProperties($(row).data('parentItemId'));
            }

            if ($(this).is(':checked')) {
                $(row).find('input[name="price"]').prop('disabled', false);
            } else {
                $(row).find('input[name="price"]').prop('disabled', true);
            }
        });

        $('table.auto-digital-items:not(.new-auto-item)').on('focusin', 'input', function () {
            activeFieldValue = $(this).val();
        }).on('focusout', 'input', function () {
            // was there an actual update done?
            if (activeFieldValue === $(this).val()) {
                return;
            }

            updateDigitalProperties($(this).parents('tr').data('parentItemId'));
        });

        // the print button
        $('#print').on('click', function (e) {
            e.preventDefault();

            window.open(that.studioPanelUri('/pricing/print') + '?price_sheet_id=' + that.jsValues.pricesheetId, 'PriceSheetPrintWindow' + that.jsValues.pricesheetId, 'width=800,height=600,menubar=1,resizable=1');
            return false;
        });
    },

    handlePricingCatalog: function () {

        $('#groups li.type').on('click', function () {
            var id = $(this).data('toggleId');

            $('.group-pane').removeClass('selected');
            $(id).addClass('selected');

            $(this).parents('ul').find('.selected').removeClass('selected');
            $(this).addClass('selected');
        });

        var updateTabTotals = function () {
            $('.group-pane').each(function (i, obj) {
                $('li[data-toggle-id="#' + $(obj).attr('id') + '"]').find('span').text($(obj).find('input:checked').length);
            });
        };

        updateTabTotals();

        $('input:checkbox').on('change', function () {
            updateTabTotals();
        });

        $('#saveButton').on('click', function () {
            $('#catalogForm').submit();
        });
    },

    handlePricingDiscount: function () {
        discount.setup();
        discount.bindTabAutoSelect();
    },

    handleMobileAppIndex: function () {
        var that = this;

        this.setupDatagridFilter();
        this.setupMobileAppEmailLink();

        this.initPushPops();

        // block clickthrough for popped push-pops
        $('a.js-edit-mobileapp').click(function (e) {
            if ($(e.target).parents('.sp-tile').hasClass('popped')) {
                e.preventDefault();
            }
        });

        // Delete confirmation modal.
        $('.delete-prompt').click(function (e) {
            e.preventDefault();

            var mobileAppId = $(this).data('mobileAppId');
            var mobileAppName = $(this).data('mobileAppName');

            that.modal({
                title: 'Confirm Delete',
                body: _.template($('#templateDelete').html(), {
                    id: mobileAppId,
                    name: mobileAppName
                }),
                sizeClass: 'modal-md',
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Yes, Delete',
                        'class': 'btn-danger',
                        click: function () {
                            $(this).parents('div.modal').modal('hide');
                            Sp.studio.loading('Deleting', 'true');

                            self.location.href = that.studioPanelCsrfWrapper(
                                that.studioPanelUri('/mobileapp/delete') + '?mobile_app_id=' + mobileAppId,
                                'mobile_app_delete'
                            );
                        }
                    }
                ]
            });
        });

        // Add a new Mobile App; name only.
        $('.new-mobile-app').click(function (e) {
            e.preventDefault();

            that.modal({
                title: 'New Mobile App',
                body: _.template($('#templateNewApp').html(), {}),
                sizeClass: 'modal-md',
                shown: function () {
                    $('#name').focus();
                },
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Create App',
                        'class': 'btn-primary',
                        click: function () {
                            var name = $(this).parents('.modal').find('input[name="name"]').val();
                            var div = $(this).parents('.modal');

                            that.loading('Creating App', 'show');

                            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/mobileapp/new'), 'mobile_app_new'), {
                                name: name
                            }, function (json) {

                                if (json.status === 'form_errors') {
                                    that.loading('Creating App', 'hide');
                                    that.displayFormErrors(div, json.errors);
                                } else {
                                    that.updateAnalyticsDataLayer({
                                        event: 'app_create'
                                    });

                                    self.location.href = that.studioPanelCsrfWrapper(
                                        that.studioPanelUri('/mobileapp/edit/' + json.id),
                                        'mobile_app_edit'
                                    );
                                }
                            }, 'json');
                        }
                    }
                ]
            });
        });
    },

    sanitizeWebAddress: function (input) {
        if (!input) { return; }

        // trim leading or trailing spaces
        input = input.replace(/^ +/g, '').replace(/ +$/g, '');

        // include `http://` when valid protocol is not included
        if (input.match(/^((?!http(s)?:\/\/).)*$/gi) && input.length == input.match(/^((?!http(s)?:\/\/).)*$/gi)[0].length) {
            sanitized = 'http://' + input;
        } else {
            sanitized = input;
        }

        return sanitized;
    },

    handleMobileAppEdit: function () {
        var that = this;

        this.setupMobileAppEmailLink();
        this.numFooterLinks = $('li.footer-link-editor:not(.footer-link-new)').length;

        // Local function to handle updating Mobile App settings
        // upon change.
        function updateMobileAppSettings() {
            var mobileAppId = Sp.studio.jsValues.mobileAppId;
            var updateEventId = $('#event_id').length;
            var eventId = $('#event_id').val();
            var brandThemeId = $('#brand_theme_id').val();
            var showContactInfo = $('#show_contact_info').prop('checked') ? 1 : 0;
            var showSocialSharing = $('#show_social_sharing').prop('checked') ? 1 : 0;

            // Handles v1 vs. v2 Mobile App settings.  With v2 enabled,
            // view_type is in a radio list.  For v1 Studios, it's in a
            // hidden value, so we need to vary how we get the new value.
            var viewType;

            if ($('#view_type-list').length > 0) {
                viewType = $('#view_type-list input:checked').val();
            } else {
                viewType = $('#view_type').val();
            }

            var playlistId = $('#playlist_id').val();
            var languageCode = $('#language_code').val();

            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/mobileapp/updatesettings'), 'mobile_app_updatesettings'), {
                mobile_app_id: mobileAppId,
                update_event_id: updateEventId,
                event_id: eventId,
                brand_theme_id: brandThemeId,
                show_contact_info: showContactInfo,
                show_social_sharing: showSocialSharing,
                view_type: viewType,
                playlist_id: playlistId,
                language_code: languageCode
            },
            function (data) {
                if (data.status !== Sp.studio.hoverMessage.type.success) {
                    that.hoverMessage.show(data.msg, data.status);
                }
                if (data.backgroundColor) {
                    Sp.studio.jsValues.themeBackground = data.backgroundColor;
                }
            });
        }

        function validateAddFooterLink() {
            var urlLength = $('#footerLinkUrl').val().length;

            if ($('#footerLinkUrl').val().length &&
                 $('#footerLinkUrl').val().match(/.+\..{2}/) &&
                 urlLength <= 300
            ) {
                $('.js-add-footer-link').removeClass('disabled');
            } else {
                if (urlLength > 300) {
                    $('div.input-footer-link-url-length-error').show();
                } else {
                    $('div.input-footer-link-url-length-error').hide();
                }

                $('.js-add-footer-link').addClass('disabled');
            }
        }

        function handleFooterLinkCountChange() {
            if (that.numFooterLinks >= that.jsValues.footerLinkLimit) {
                $('.footer-link-new').addClass('max-footer-links');
            } else {
                $('.footer-link-new').removeClass('max-footer-links');
            }
        }

        function launchIconCrop(tmpImageUrl) {
            var winHeight = $(window).height() * 0.8;

            if (winHeight > 650) {
                winHeight = 650;
            }

            var cropData;
            var aspectRatio = 1;
            var defaultCrop = {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            };

            that.modal({
                body: _.template($('#templateCropIconDialog').html(), {}),
                sizeClass: 'modal-md',
                autoOpen: true,
                width: 850,
                title: 'Crop Icon',
                height: winHeight,
                open: function() {
                    var large = $('#imageBody');

                    // clean out the old dialog
                    $('#imageBody *').remove();

                    $('<img/>').attr('src', tmpImageUrl)
                        .attr('id', 'cropImage')
                        .css({
                            'max-height': '500px',
                            'max-width': '100%'
                        })
                        .click(function (event) {
                            event.stopPropagation();
                        })
                        .bind('load', function () {

                            that.loading('Loading Image', 'hide');

                            that.darkroom = new Darkroom('#cropImage', {
                                plugins: {
                                    save: false,
                                    crop: {
                                        minHeight: 100,
                                        minWidth: 100,
                                        ratio: aspectRatio,
                                        canvasDepth: ''
                                    }
                                },
                                init: function () {
                                    // Start with width and height equal to canvas height for a square
                                    defaultCrop.width = this.canvas.height;
                                    defaultCrop.height = this.canvas.height;
                                    defaultCrop.x = (this.canvas.width - defaultCrop.width) / 2;
                                    defaultCrop.y = 0;

                                    if (this.canvas.height > this.canvas.width) {
                                        // If the canvas height is greater than width, we use canvas
                                        // width as the starting point for our square
                                        defaultCrop.width = this.canvas.width;
                                        defaultCrop.height = this.canvas.width;
                                        defaultCrop.x = 0;
                                        defaultCrop.y = (this.canvas.height - defaultCrop.height) / 2;
                                    }

                                    var cropPlugin = this.getPlugin('crop');
                                    cropPlugin.selectZone(
                                        defaultCrop.x,
                                        defaultCrop.y,
                                        defaultCrop.width,
                                        defaultCrop.height
                                    );
                                }
                            });
                        })
                        .appendTo(large);
                },
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Save Icon',
                        'class': 'btn-primary',
                        click: function () {

                            var plugin = that.darkroom.getPlugin('crop');
                            var currentCrop = plugin.getCurrentCrop();
                            var w = Math.round(that.darkroom.image.currentWidth);
                            var h = Math.round(that.darkroom.image.currentHeight);

                            var coordinates = [
                                ((currentCrop.getLeft() / w) * 100).toFixed(4),
                                ((currentCrop.getTop() / h) * 100).toFixed(4),
                                (((currentCrop.getWidth() + currentCrop.getLeft()) / w) * 100).toFixed(4),
                                (((currentCrop.getHeight() + currentCrop.getTop()) / h) * 100).toFixed(4)
                            ];

                            // let's check to make sure the crop pieces are all floats
                            cropData = coordinates.join(',');
                            var badCropPieces = cropData.match(/[^\d,.]/g);

                            if (coordinates[0] === coordinates[2]) {
                                badCropPieces = 1;
                            }

                            var modal = $(this).parents('div.modal');

                            if (null !== badCropPieces) {
                                that.modal({
                                    body: _.template($('#templateCropBad').html(), {}),
                                    autoOpen: true,
                                    modal: true,
                                    width: 350,
                                    title: 'Oops... There is an issue with the crop information',
                                    buttons: [
                                        {
                                            text: 'Ok',
                                            'class': 'primary',
                                            click: function () {
                                                $(this).dialog('close');
                                            }
                                        }
                                    ]
                                });

                                return;
                            }

                            that.loading('Creating Icon', 'show');

                            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/mobileapp/saveicon'), 'mobile_app_saveicon'), {
                                    mobile_app_id: that.jsValues.mobileAppId,
                                    crop: cropData
                                },
                                function (json) {
                                    modal.modal('hide');

                                    that.loading('Creating Icon', 'hide');
                                    that.hoverMessage.show('Mobile app icon has been set.', that.hoverMessage.type.success);

                                    $('img.mobile-app-icon').attr('src', json.url);
                                }, 'json');
                        }
                    }
                ]
            });

        }

        function isValidUrl(url) {
            if (url.length < 4) {
                return false;
            }

            if (url.match(/.+\..{2}/)) {
                return true;
            }

            return false;
        }

        // Whenever a Mobile App setting is changed, update all of its
        // settings values.
        $('#brand_theme_id, #selected_event_id, #playlist_id, #language_code').on('change', function () {
            updateMobileAppSettings();
        });

        $('#view_type-list input').on('ifChecked', function () {
            updateMobileAppSettings();
        });

        $('.js-goto-homepage').click(function (e) {
            e.preventDefault();
            self.location.href = that.studioPanelUri('/brand/homepage');
        });

        // init data param on gallery-text to populate modal select2
        $('.gallery-text').data('eventId', Sp.studio.jsValues.eventId);

        // Raise a modal whenever the user wants to set or change the
        // Gallery associated with their MobileApp.
        $('.set-mobile-app-gallery, .change-mobile-app-gallery').click(function(e) {
            e.preventDefault();

            that.modal({
                title: 'Choose Gallery',
                body: _.template($('#templateSetGallery').html(), {}),
                open: function () {
                    if ($('.gallery-text').data('eventId') > 0) {
                        $('#event_id').val($('.gallery-text').data('eventId'));
                    }
                    $('#event_id').select2();
                },
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Choose Gallery',
                        'class': 'btn-primary',
                        click: function () {
                            var modal = $(this).parents('div.modal');

                            // Get the new Event ID and name from the selected
                            // option.
                            var event = modal.find('#event_id');
                            var newEventId = event.val();
                            var newEventName = $(event).find('option[value="' + newEventId + '"]').text();

                            // Update the selected_event_id hidden input in
                            // the right sidebar's top section, and update the
                            // name and href displayed, too.
                            var $body = $(this).parents('body');
                            $body.find('#selected_event_id').val(newEventId);

                            var $eventName = $body.find('.gallery-text');

                            if (newEventId) {
                                $eventName.html(newEventName);
                                $('.gallery-text').data('eventId', $('#event_id').val());
                            } else {
                                $eventName.html('Link Gallery');
                                $('.gallery-text').data('eventId', 0);
                            }


                            // Trigger a change event so that the Mobile App's
                            // settings are updated as the modal closes.
                            updateMobileAppSettings();

                            modal.modal('hide');
                        }
                    }
                ]
            });
        });

        // photo selection
        $('#allPhotos ul.photos-view').on('click', '.fourthree-container', function(e) {
            if (!$(e.target).is('.view-larger') &&
                !$(e.target).parents('.view-larger').length) {

                var wasSelected = false;
                if ($(this).is('.ui-selected')) {
                    wasSelected = true;
                }

                $('#allPhotos ul.photos-view .fourthree-container').removeClass('ui-selected');
                if (!wasSelected) {
                    $(this).addClass('ui-selected');
                }

                if ($('#allPhotos ul.photos-view .ui-selected').length) {
                    $('.mobile-app-photos').addClass('photos-selected');
                } else {
                    $('.mobile-app-photos').removeClass('photos-selected');
                }
            }
        });

        // Make the Mobile App photos sortable.
        $('#allPhotos ul.photos-view').sortable({
            containment: false,
            tolerance: 'pointer',
            items: '> li',
            handle: false,
            distance: 1,
            stop: function () {
                var order = $('#allPhotos > ul.photos-view').sortable('toArray', {attribute: 'data-mobile-app-photo-id'});

                $.post(
                    that.studioPanelCsrfWrapper(Sp.studio.studioPanelUri('/mobileapp/updatephotosorder'), 'mobile_app_updatephotosorder'),
                    {
                        mobile_app_id: that.jsValues.mobileAppId,
                        photos_order: order
                    },
                    function (data) {
                        if (data.status !== 'success') {
                            that.hoverMessage.show(data.msg, data.status);
                        }
                    },
                    'json');
            }
        });

        // set a photo as the Mobile App icon.
        $('body').on('click', '.set-as-app-icon', function (e) {
            e.preventDefault();

            that.loading('Loading Tools', 'show');

            var li = $('.ui-selected').first().parents('li.photo-tile');
            var mobileAppPhotoId = $(li).data('mobileAppPhotoId');

            $.post(that.studioPanelUri('/mobileapp/setphotoascover'), {
                    mobile_app_id: that.jsValues.mobileAppId,
                    photo_id: mobileAppPhotoId
                },
                function (data) {

                    that.loading('Loading Tools', 'show');

                    if (data.status !== 'success') {
                        Sp.studio.hoverMessage.show('Cropping is unavailable at this time.', data.status);
                        return;
                    }

                    that.loading('Loading Tools', 'show');

                    // Get the temporary image URL from the first request,
                    // which we can now crop.
                    launchIconCrop(data.url);

                    that.loading('Loading Tools', 'hide');

                },
                'json');
        });

        // Handle changing Mobile App icon image with separate image upload.
        $('.change-cover').click(function(e) {
            e.preventDefault();

            that.modal({
                title: 'Upload Icon',
                body: _.template($('#templateUploadIcon').html(), {}),
                open: function () {
                    var modalId = this.id;

                    $('#' + modalId).find(':file').on('change', function () {
                        var files = this.files;
                        var ext, file;

                        for (var i = 0; i < files.length; i++) {
                            file = files[i].name;
                            ext = file.substr((file.lastIndexOf('.') + 1)).toLowerCase();
                            if (ext !== 'jpg' && ext !== 'jpeg') {
                                return;
                            }
                        }

                        var modal = $(this).parents('div.modal');

                        that.loading('Uploading', 'show');

                        var formData = new FormData();
                        formData.append('mobile_app_id', that.jsValues.mobileAppId);
                        formData.append('file', files[0]);

                        $.ajax({
                            url: that.studioPanelCsrfWrapper(that.studioPanelUri('/mobileapp/uploadicon'), 'mobile_app_uploadicon'),
                            cache: false,
                            contentType: false,
                            dataType: 'json',
                            processData: false,
                            async: true,
                            data: formData,
                            type: 'post',
                            success: function(json) {

                                that.loading('Uploading', 'hide');

                                modal.modal('hide');

                                if (json.status === 'success') {
                                    launchIconCrop(json.url);
                                } else {
                                    that.hoverMessage.show(json.msg, json.status);
                                }
                            }
                        });
                    });
                },
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    }
                ]
            });
        });

        // delete a Mobile App photo.
        $('body').on('click', '.delete-photo', function (e) {
            e.preventDefault();

            var li = $('.ui-selected').first().parents('li.photo-tile');
            var mobileAppPhotoId = $(li).data('mobileAppPhotoId');
            var mobileAppPhotoOriginalName = $(li).data('mobileAppPhotoOriginalName');

            // Confirm deletion.
            that.modal({
                title: 'Delete Mobile App Photo',
                body: _.template($('#templateDeleteMobileAppPhoto').html(), {
                    photoOriginalName: mobileAppPhotoOriginalName
                }),
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Yes, Delete',
                        'class': 'btn-danger',
                        click: function () {
                            var modal = $(this).parents('div.modal');

                            $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/mobileapp/deletephoto'), 'mobile_app_deletephoto'), {
                                mobile_app_id: that.jsValues.mobileAppId,
                                photo_id: mobileAppPhotoId
                            },
                            function (data) {
                                // Display the success or error hover message.
                                that.hoverMessage.show(data.msg, data.status);

                                if (data.status === 'success') {
                                    // Remove the Photo's list item.
                                    $(li).remove();

                                    // Update the Photo count on the page.
                                    $('.js-mobile-app-photos-count').text(data.num_photos);
                                }

                                modal.modal('hide');
                            });
                        }
                    }
                ]
            });
        });

        $('body').on('click', '.js-reload', function () {
            self.location.reload();
        });

        // If the Mobile App has no photos initially, show the
        // empty state text.
        if ($('#allPhotos ul li').length === 0) {
            $('#noPhotosInMobileApp').show();
        }

        // Attach to delete footer link buttons.
        $('body').on('click', '.delete-footer-link', function (e) {
            e.preventDefault();

            var mobileAppLinkId = $(e.target).data('linkId');

            that.modal({
                title: 'Delete Link',
                sizeClass: 'modal-md',
                body: _.template($('#templateDeleteFooterLink').html(), {}),
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Yes, Delete',
                        'class': 'btn-danger',
                        click: function () {
                            $.post(that.studioPanelUri('/mobileapp/deletelink'), {
                                mobile_app_id: that.jsValues.mobileAppId,
                                link_id: mobileAppLinkId
                            },
                            function (data) {
                                // Remove the list item once we know it's been
                                // deleted.
                                if (data.status === 'success') {
                                    $('.footer-link-editor[data-link-id="' + mobileAppLinkId + '"]').remove();

                                    that.numFooterLinks--;
                                    handleFooterLinkCountChange();
                                }

                                that.hoverMessage.show(data.msg, data.status);
                            },
                            'json');

                            $(this).parents('div.modal').modal('hide');

                            // If there's another modal left in the body,
                            // close it.  This is used from the edit footer
                            // link case, where a delete button is present,
                            // which raises this modal.
                            if ($('body').find('div.modal').length) {
                                $('body').find('div.modal').modal('hide');
                            }
                        }
                    }
                ]
            });
        });

        // handle toggle footer link editors
        $('.footer-link-editors').on('click', '.footer-link-editor .js-expand-editor', function(e) {
            e.preventDefault();
            $('.footer-link-editor.open').removeClass('open');
            $(this).parents('.footer-link-editor').addClass('open');
        });
        $('.footer-link-editors').on('click', '.footer-link-editor .js-collapse-editor', function(e) {
            e.preventDefault();
            $(this).parents('.footer-link-editor').removeClass('open');
        });

        $('.footer-link-editors').on('blur', 'input#footerLinkUrl', function () {
            var currentValue = $('#footerLinkUrl').val();
            var clean = that.sanitizeWebAddress(currentValue);
            $('#footerLinkUrl').val(clean);
        });

        $('.footer-link-editors').on('input keyup change blur', 'input#footerLinkUrl', function() {
            // validate submit button on all changes
            var el = $('input#footerLinkUrl');
            if (el.val().length && el.val().match(/.+\..{2}/)) {
                $('div.input-footer-link-url-error').hide();
            }

            validateAddFooterLink();
        });

        // add footer link
        $('.footer-link-editors').on('click', '.js-add-footer-link', function (e) {
            e.preventDefault();

            if (!$('#footerLinkUrl').val().length) {
                that.hoverMessage.show('Please provide a url before saving.', 'error', 2000);
            } else if (!isValidUrl($('#footerLinkUrl').val())) {
                that.hoverMessage.show('Please provide a valid url before saving.', 'error', 2000);
            } else if ($('input#footerLinkFile')[0].files.length) {

                that.loading('Uploading', 'show');

                // Get the files from the input, assuming that we
                // always use the 0th one.
                var files = $('input#footerLinkFile')[0].files,
                    displayName = $('#footerLinkName').val(),
                    url = $('#footerLinkUrl').val(),
                    ext,
                    file;

                for (var i = 0; i < files.length; i++) {
                    file = files[i].name;
                    ext = file.substr((file.lastIndexOf('.') + 1)).toLowerCase();

                    if (ext !== 'jpg' && ext !== 'jpeg' && ext !== 'png') {
                        that.loading('Uploading', 'hide');
                        $(modal).find('.image-type-error').show();
                        return;
                    }
                }

                var formData = new FormData();
                formData.append('mobile_app_id', that.jsValues.mobileAppId);
                formData.append('file', files[0]);
                formData.append('name', displayName);
                formData.append('url', url);

                $.ajax({
                    url: that.studioPanelCsrfWrapper(that.studioPanelUri('/mobileapp/uploadlink'), 'mobile_app_uploadlink'),
                    cache: false,
                    contentType: false,
                    dataType: 'json',
                    processData: false,
                    async: true,
                    data: formData,
                    type: 'post',
                    success: function(json) {

                        that.loading('Uploading', 'hide');

                        if (json.status !== Sp.studio.hoverMessage.type.success) {
                            that.hoverMessage.show(json.msg, json.status);
                            return;
                        }

                        $('form#newFooterLink')[0].reset();
                        $('.footer-link-new').removeClass('open');

                        // add new footer link editor
                        $('.footer-link-editors').append(_.template($('#templateFooterLinkEditor').html(), {
                            id: json.id,
                            linkUrl: json.link_url,
                            name: json.display_name,
                            imageUrl: json.image_url
                        }));

                        that.numFooterLinks++;
                        handleFooterLinkCountChange();
                    }
                });

            } else {
                that.hoverMessage.show('Please select a photo to upload before saving.', 'error', 2000);
            }
        });

        // update footer link changes
        $('.footer-link-editors').on('click', '.js-update-footer-link', function(e) {
            e.preventDefault();
            var id = $(this).data('id');
            var newUrl = $('#footerLinkUrl_' + id).val();
            var newDisplayName = $('#footerLinkName_' + id).val();
            var $currentEditor = $(this).parents('.footer-link-editor');

            if (isValidUrl(newUrl)) {
                $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/mobileapp/updatelink'), 'mobile_app_updatelink'), {
                    mobile_app_id: that.jsValues.mobileAppId,
                    mobile_app_link_id: id,
                    name: newDisplayName,
                    url: newUrl
                },
                function (data) {
                    if (data.status !== Sp.studio.hoverMessage.type.success) {
                        that.hoverMessage.show(data.msg, data.status);
                    }

                    $currentEditor.find('.link-url').html(Sp.stripTags(newUrl));
                    $currentEditor.find('.link-name').html(Sp.stripTags(newDisplayName));
                },
                'json');

                $currentEditor.removeClass('open');
            } else {
                that.hoverMessage.show('Please provide a valid url before saving.', 'error', 2000);
            }
        });

        // ensure absolute link urls
        $('.footer-link-editors').on('blur', '.footer-link-editor input[type="text"].js-filter-web-address', function () {
            var formGroup = $(this).parent('.form-group');
            var editorContainer = $(formGroup).parents('.footer-link-editor');
            var updateButton = editorContainer.find('.js-update-footer-link');

            var currentValue = $(this).val();

            if (currentValue.length === 0) {
                updateButton.addClass('disabled');
                return;
            }

            var clean = that.sanitizeWebAddress(currentValue);
            $(this).val(clean);

            if (clean.length > 300) {
                formGroup.find('.input-footer-link-url-length-error').show();
                updateButton.addClass('disabled');
            } else {
                formGroup.find('.input-footer-link-url-length-error').hide();
                updateButton.removeClass('disabled');
            }
        });

        $('#show_contact_info, #show_social_sharing').on('ifChecked ifUnchecked', function(){
            updateMobileAppSettings();
        });

        // check on init if footer links are in empty state
        handleFooterLinkCountChange();

        // Allow Mobile App name to be edited.
        // header edit name
        that.inlineEditName({
            wrapperSelector: '.mobile-app-title',
            maxInputTextLength: 40,
            nameChangedCallback: function(name) {
                $.post(that.studioPanelCsrfWrapper(that.studioPanelUri('/mobileapp/updatename'), 'mobile_app_updatename'),
                    {
                        mobile_app_id: that.jsValues.mobileAppId,
                        name: name
                    },
                    function(data) {
                        that.hoverMessage.show(data.msg, data.status);
                    },
                    'json'
                );
            }
        });
    },

    handleEmailTemplate: function () {
        var that = this;

        this.setupDatagridFilter();

        $('.js-add-template').on('click', function (e) {
            e.preventDefault();

            that.modal({
                title: 'New Email Template',
                body: _.template($('#templateAddEmailTemplate').html(), {}),
                sizeClass: 'modal-md',
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Create',
                        'class': 'btn-primary',
                        click: function () {
                            var name = $.trim($('#emailTemplateName').val());
                            var modal = $(this).parents('.modal');

                            if (name === '') {
                                that.displayFormErrors(modal, {
                                    'emailTemplateName': [
                                        'Please enter a name for this new email template.'
                                    ]
                                });
                                return;
                            }

                            that.loading('Creating', 'show');

                            self.location.href = that.studioPanelUri('/email/template/new') +
                                '?name=' + encodeURIComponent(name);
                        }
                    }
                ]
            });
        });

        $('.js-email-template-delete').click(function (e) {
            e.stopPropagation();
            e.preventDefault();
            that.displayEmailTemplateDeleteModal(this, that);
        });

        $('body').on('change', '#templateFilter', function () {
            var value = $(this).val();
            if (value.substr(0, 5) === 'auto-') {
                window.location.href = that.studioPanelUri('/email/template?filter_auto=' + value.substr(5));
            } else if (value.substr(0, 5) === 'type-') {
                window.location.href = that.studioPanelUri('/email/template?filter_type=' + value.substr(5));
            } else {
                window.location.href = that.studioPanelUri('/email/template');
            }
        });
    },

    handleEmailTemplateEdit: function () {
        var that = this;
        var nameChanged;
        var bodyRedactorLoaded = false;

        this.initEmailPreview();

        var previewEmail = function () {
            var params = {
                email_template_type_id: $('#email_template_type_id').val(),
                subject: $('#subject').val(),
                headline: $('#headline').val(),
                button_text: $('#button_text').val(),
                body: (bodyRedactorLoaded ? $R('#body').source.getCode() : '')
            };

            that.handleEmailPreview(params);
        };

        var bodyRedactorLoad = function () {
            if (!bodyRedactorLoaded) {
                that.editor('#body', {
                    minHeight: 300,
                    templateTokens: that.jsValues.emailTemplateTokens[that.jsValues.emailTemplateTypeId],
                    plugins: ['tokens', 'alignment'],
                    changeCallback: previewEmail
                });
                bodyRedactorLoaded = true;
            }
        };

        bodyRedactorLoad();

        $('.submit-form').click(function (e) {
            e.preventDefault();
            $('#templateEditForm').submit();
        });

        if (this.jsValues.templateId !== null) {
            nameChanged = function (newName) {
                $.post(that.studioPanelUri('/email/updatetemplatename'), {
                    template_id: that.jsValues.templateId,
                    studio_note: newName
                }, function (json) {
                    that.hoverMessage.show(json.msg, json.status);
                    $('#studio_note').val(newName);
                }, 'json');
            };
        } else {
            nameChanged = function (newName) {
                $('#studio_note').val(newName);
            };
        }

        this.inlineEditName({
            placeholderText: 'Email Template Name',
            wrapperSelector: '#pageTitleHeaderText',
            maxInputTextLength: 100,
            nameChangedCallback: nameChanged,
            syncInputSelector: '#studio_note'
        });

        $('#headline, #button_text').on('input', function () {
            previewEmail();
        });

        $('#email_template_type_id').change(function (e) {
            var emailTemplateTypeId = $(e.target).val();

            if (that.jsValues.isNewTemplate) {
                if (emailTemplateTypeId) {
                    $('#subject').prop('disabled', false);
                    $('#headline').prop('disabled', false);
                    $('#button_text').prop('disabled', false);
                    $('#body').prop('disabled', false);
                    bodyRedactorLoad();
                    $('.submit-form').removeAttr('disabled');
                } else {
                    // Clear and reset everything if they choose the "select template" option
                    $('#templateDescription').hide();
                    $('#buttonTextHelper').hide();
                    $('#buttonText').hide();
                    $('#headlineText').hide();
                    $('#subject').val('');
                    $('#subject').prop('disabled', true);
                    $('#headline').val('');
                    $('#headline').prop('disabled', true);
                    $('#button_text').val('');
                    $('#button_text').prop('disabled', true);
                    $R('#body').source.setCode('');
                    $('#body').prop('disabled', true);
                    $('.submit-form').attr('disabled', 'disabled');
                }
            }

            if (bodyRedactorLoaded) {
                if (emailTemplateTypeId in that.jsValues.emailTemplateTokens) {
                    $R('#body').api('plugin.tokens.updateTokenList', that.jsValues.emailTemplateTokens[emailTemplateTypeId]);
                } else {
                    $R('#body').api('plugin.tokens.updateTokenList', []);
                }
            }

            // If they're editing an existing template, and they switch back
            // to the same template type as the page was originally rendered
            // for, put its original subject and body back in place.
            // Otherwise, we can use the defaults from the server-side.
            if (emailTemplateTypeId == that.jsValues.emailTemplateTypeId) {
                $('#subject').val(that.jsValues.originalTemplateSubject);
                $('#headline').val(that.jsValues.originalTemplateHeadline);
                $('#button_text').val(that.jsValues.originalTemplateButtonText);
                if (bodyRedactorLoaded) {
                    $R('#body').source.setCode(that.jsValues.originalTemplateBody);
                }
            } else if (!emailTemplateTypeId) {
                // If they've chosen no template, default the values back
                // to being empty.
                $('#subject').val('');
                $('#headline').val('');
                $('#button_text').val('');
                if (bodyRedactorLoaded) {
                    $R('#body').source.setCode('');
                }
            }

            // suggest the gallery option over the single album template type
            if (emailTemplateTypeId == '7') {
                $('.album-gallery-suggestion').show();
            } else {
                $('.album-gallery-suggestion').hide();
            }

            $('.album-gallery-suggestion a').on('click', function(ev) {
                ev.preventDefault();
                $('#email_template_type_id').val('3').change();
            });

            // If the user has now selected no template, we don't need to
            // retrieve any default text from the server-side, so just go
            // ahead and return.
            if (!emailTemplateTypeId) {
                return;
            }

            // If the user chose a template, fetch its default
            // value from the server-side.
            $.get(that.studioPanelUri('/email/defaulttemplatecontents'), {
                email_template_type_id: emailTemplateTypeId
            }, function (json) {
                // Set the description, subject and body values based on the response.

                // If we get an empty description back, hide the DIV
                // altogether, or show it if we've got content.  We always do
                // this regardless of any new vs. edit states, because the
                // description should always be shown on the page, and is not
                // controlled by the user.
                if (json.description) {
                    $('#templateDescription p').html(json.description);
                    $('#templateDescription').show();
                } else {
                    $('#templateDescription').hide();
                }

                // Only show the headline text field if we have default headline
                // text set for this template type
                if (json.headline) {
                    $('#headlineText').show();
                } else {
                    $('#headlineText').hide();
                }

                // Only show the button text field if we have default button
                // text set for this template type
                if (json.buttonText) {
                    $('#buttonText').show();
                } else {
                    $('#buttonText').hide();
                }

                if (json.buttonTextHelper) {
                    $('#buttonTextHelper').html(json.buttonTextHelper);
                    $('#buttonTextHelper').show();
                } else {
                    $('#buttonTextHelper').hide();
                }

                // If the currently selected Email Template Type ID is not
                // equal to the one that the page loaded with, then it's safe
                // for us to set the subject and body to whatever we received
                // back from the server-side.
                if (emailTemplateTypeId != that.jsValues.emailTemplateTypeId) {
                    $('#subject').val(json.subject);
                    $('#headline').val(json.headline);
                    $('#button_text').val(json.buttonText);
                    if (bodyRedactorLoaded) {
                        $R('#body').source.setCode(json.body);
                    }
                }

                previewEmail();
            });
        });

        // If this is for a new template, hide certain fields until a template
        // type has been selected
        if (that.jsValues.isNewTemplate) {
            // Disable all input elements for a new template at first;
            // We'll renable them when they choose a template type
            $('#subject').prop('disabled', true);
            $('#headline').prop('disabled', true);
            $('#button_text').prop('disabled', true);
            $('#body').prop('disabled', true);
            $('.submit-form').attr('disabled', 'disabled');

            $('#templateDescription').hide();
            $('#buttonTextHelper').hide();
            $('#buttonText').hide();
            $('#headlineText').hide();

            // If a type_id is passed in and this is a new template, then we'll
            // use that template type as a starting point
            if (that.jsValues.startingTemplateTypeId) {
                $('#email_template_type_id').val(that.jsValues.startingTemplateTypeId);
                $('#email_template_type_id').trigger('change');
            }
        } else {
            // If it's an edit, trigger the Template Type ID change event
            // so that the UI can update as needed.
            $('#email_template_type_id').trigger('change');
        }

        previewEmail();
    },

    handleMobileAppAddPhoto: function () {
        var that = this;

        var updateMainProgressBar = function (completed, total) {
            $('.progress-totals .completed').text(Sp.numberFormat(completed, 0, '.', ','))
            $('.progress-totals .total').text(Sp.numberFormat(total, 0, '.', ','));

            // handle updating the main progress bar
            var percent = ((completed / total) * 100);
            $('#mainProgress .completed').css('width', percent + '%');
        };

        var updateOnDeckTotal = function (num) {

            if (num === 0) {
                num = '';
            } else {
                num = Sp.numberFormat(num, 0, '', ',');
            }

            $('#uploadQueueCount').text(num);
        };

        Sp.uploader.opts.maxFileSize = Sp.studio.jsValues.maxFileSize;
        Sp.uploader.opts.uploadUrl = Sp.studio.jsValues.uploadUrl;
        Sp.uploader.allowDuplicates = true;
        Sp.uploader.opts.postParams = Sp.studio.jsValues.postParams;
        Sp.uploader.callbacks.beforeFileAdd = function (file, fileList) {
            var numPhotosRemaining = that.jsValues.numPhotosLimit - that.jsValues.numActivePendingPhotos;

            if (fileList.length >= numPhotosRemaining) {
                $('#mobileAppAddPhotoFilesSkipped').show();
                return false;
            }

            return true;
        };

        Sp.uploader.callbacks.singleUploadStarting = function (file, fileList) {
            updateOnDeckTotal(fileList.length);
        };

        Sp.uploader.callbacks.singleUploadComplete = function (file, fileList) {
            $.post(
                that.studioPanelUri('/mobileapp/addphoto/' + that.jsValues.mobileAppId),
                {
                    'name': file.name,
                    'size': file.size,
                    'random_key': file.randomFolder
                },
                function(data) {

                    if (!data.status) {
                        // not sure what to do here!
                        return;
                    }

                    // TODO: what's the Mobile App equivalent?
                    if (!data.storage_used) {
                        if (data.photos_used >= data.photos_allowed) {
                            $('#mobileAppLimitReached').show();
                            Sp.uploader.stop();
                        }
                    }
                },
                'json'
            );

            updateMainProgressBar(Sp.uploader.filesCompleted, Sp.uploader.getTotalFiles());

            $('#uploadedCount').text(Sp.numberFormat(Sp.uploader.filesCompleted, 0, '', ','));

            updateOnDeckTotal(fileList.length);
        };

        Sp.uploader.callbacks.allUploadingComplete = function () {
            $('#pageHeaderTitle').show();
            $('#pageHeaderTitleUploading').hide();
            $('.uploading-in-progress').hide();
            $('.upload-complete').show();
        };

        Sp.uploader.callbacks.uploadingStarting = function () {
            $('#pageHeaderTitle').hide();
            $('#pageHeaderTitleUploading').show();

            // hide the dropzone and show the queues
            $('#dropzoneRow').hide();
            $('#queues').show();

            $('.uploading-in-progress').show();
            $('.upload-complete').hide();
        };

        Sp.uploader.callbacks.uploadStopped = function () {
            $('#pageHeaderTitle').show();
            $('#pageHeaderTitleUploading').hide();
        };

        Sp.uploader.callbacks.fileAddedToQueue = function (file, fileList) {
            $('#uploadQueueCount').text(Sp.numberFormat(fileList.length, 0, '', ','));
            $('#dropzone .queue-count').text(Sp.numberFormat(fileList.length, 0, '', ','));

            if (!Sp.uploader.uploading && $('#dropzone').is(':visible') && $('.photos-queued').is(':hidden')) {
                $('.queue-empty').hide();
                $('.btn-file').removeClass('btn-primary').addClass('btn-default');
                $('.photos-queued').css('display', 'block');
            }

            updateMainProgressBar(Sp.uploader.filesCompleted, Sp.uploader.getTotalFiles());
        };

        Sp.uploader.setup();

        if (Sp.studio.jsValues.uploadAllowed) {

            $('div.add-photos').show();

            this.activateSwitch('input.switch', {
                onChange: function () {
                    if ($('#duplicates').is(':checked')) {
                        Sp.uploader.opts.allowDuplicates = true;
                    } else {
                        Sp.uploader.opts.allowDuplicates = false;
                    }

                    Sp.studio.updateSwitchStyle(this);
                }
            });

            $('#startUpload').on('click', function (e) {
                e.preventDefault();
                Sp.uploader.startUpload();
            });

            $('#addMore').on('click', function (e) {
                e.preventDefault();
                self.location.href = self.location.href;
            });

            $('#stopUpload').on('click', function (e) {
                e.preventDefault();
                Sp.uploader.stopUpload();
            });

        } else {
            $('#mobileAppLimitReached').show();
        }

    },

    svgIcon: function (icon, classes) {
        if (!classes || !classes.length) {
            classes='';
        }

        icon = icon.replace('#', '');

        return '<svg class="' + classes + '"><use xlink:href="/v2/content/' + Sp.release + '/svg.svg#' + icon + '"></use></svg>';
    },

    inlineEditName: function (options) {
        var that = this;
        var defaultOptions = {
            wrapperSelector: '',
            placeholderText: '',
            maxInputTextLength: 10,
            inputClass: '',
            nameChangedCallback: function (name) {
                name = null;
            },
            syncInputSelector: ''
        };

        var closeFromSubmit = false;

        var opts = $.extend({}, defaultOptions, options);
        var wrapText = function (text) {
            return '<span class="name pull-left">' + $.trim($('<div>' + text + '</div>').text()) + '</span>' + that.svgIcon('iconEdit', 'touch-icon pull-left icon-edit');
        };

        // setup the edit icon
        $(opts.wrapperSelector).removeClass('has-field').html(wrapText($(opts.wrapperSelector).text()));

        // destroy old modal
        $(opts.wrapperSelector).off('click');

        // build new modal
        $(opts.wrapperSelector).on('click', function () {
            var parent = ($(this).is(opts.wrapperSelector)) ? $(this) : $(this).parents(opts.wrapperSelector);

            if ($(parent).hasClass('has-field')) {
                return;
            }

            var startName = $.trim($(parent).find('span.name').text());

            modalBody = '<input type="text" ';
            modalBody += 'class="form-control inline-edit-field ' + opts.inputClass + '" ';
            modalBody += 'placeholder="' + opts.placeholderText + '" ';
            modalBody += 'maxlength="' + opts.maxInputTextLength + '" ';
            modalBody += 'value="' + startName + '" ';
            modalBody += '>';

            that.modal({
                title: 'Rename',
                body: modalBody,
                sizeClass: 'modal-md',
                open: function () {
                    // ensure closeFromSubmit state is reset
                    closeFromSubmit = false;

                    // keep the name field synchronized with the changes to the inline edit field
                    $('.modal .inline-edit-field').on('input', function() {
                        var tmpValue = $('.modal .inline-edit-field').val().replace(/<\/?[^>]+>/gi, '');
                        $(this).val(tmpValue);
                        $(parent).find('span').text(tmpValue);
                    });

                    // keep a form field synchronized with changes to the inline edit field
                    if (opts.syncInputSelector.length && $(opts.syncInputSelector).is('input')) {
                        $('.modal .inline-edit-field').on('input', function() {
                            $(opts.syncInputSelector).val($('.has-field .inline-edit-field').val());
                        });
                    }
                },
                close: function () {
                    if (!closeFromSubmit) {
                        $(opts.wrapperSelector).find('span').html(startName);
                    }
                },
                autoOpen: true,
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Rename',
                        'class': 'btn-primary',
                        click: function () {
                            var tmpValue = $('.modal .inline-edit-field').val().replace(/<\/?[^>]+>/gi, '');

                            closeFromSubmit = true;

                            $(this).parents('div.modal').modal('hide');

                            if (tmpValue !== '' && tmpValue !== startName) {
                                // only submit if a new non-empty value has been selected
                                opts.nameChangedCallback(tmpValue);
                            } else {
                                if (opts.syncInputSelector.length && $(opts.syncInputSelector).is('input')) {
                                    // if we are syncing an input field, revert on empty string submission
                                    $(opts.syncInputSelector).val(startName);
                                }
                            }
                        }
                    }
                ]
            });
        });

    },

    handleAccountContactinfo: function () {
        var that = this;
        var openBrandUpgradeModal = null;

        Sp.v2ReactBridge.showBrandUpgradeModal('brand-upgrade-modal', {
            onPrimaryButtonClick: function () {
                location.assign(that.studioPanelUri('/account/planbilling'));
            },
            withOpen: function (open) {
                openBrandUpgradeModal = open;
            }
        });

        $('body').on('click', '.expand-collapse', function (e) {
            e.preventDefault();

            var panel = $(this).parents('div.panel');

            if (panel.hasClass('expanded')) {
                panel.switchClass('expanded', 'collapsed');
            } else {
                panel.switchClass('collapsed', 'expanded');
            }
        });

        function showNewBrandPanel() {
            var html = _.template($('#templateAddNewBrandPanel').html());

            // Add the new Brand panel to the page.
            $('div.brand-panels').append(html);

            // Enable Select2 for its select elements.
            $('#newBrand select:not(.no-search):not(.custom)').select2();

            // Watch its country and state fields for international address
            // handling.
            that.watchCountryStateField({
                citySelector: '#brandFormNew input[name="city"]',
                stateDropdownSelector: '#brandFormNew select[name="state"]',
                stateOtherSelector: '#brandFormNew input[name="state_other"]',
                countrySelector: '#brandFormNew select[name="country"]',
                zipCodeSelector: '#brandFormNew input[name="zip_postal"]',
                zipCodeFieldNames: that.jsValues.zipCodeFieldNames,
                cityFieldNames: that.jsValues.cityFieldNames,
                countryNoState: that.jsValues.countryNoState,
                selectedStateId: $('#brandFormNew select[name="state"]').val()
            });
        }

        $('.add-brand').on('click', function (e) {
            e.preventDefault();

            if (Sp.studio.jsValues.hasPlanWithMultipleBrands) {
                showNewBrandPanel();

                // Remove the "Add Brand" button altogether, because it can
                // only be used once on the page.
                $(this).remove();
            } else {
                openBrandUpgradeModal();
            }
        });

        // Handle buttons for making a Brand the default.
        $('.make-default-brand').click(function (e) {
            e.preventDefault();

            var brandRow = $(this).parents('div.brand-row');
            var brandId = brandRow.data('brandId');
            var brandName = brandRow.data('brandName');

            that.modal({
                title: 'Make Default Brand',
                body: _.template($('#templateMakeDefaultBrand').html(), {brand_name: brandName}),
                autoOpen: true,
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Yes, Change Default Brand',
                        'class': 'btn-danger',
                        click: function () {
                            $(this).parents('div.modal').modal('hide');
                            Sp.studio.loading('Changing default brand', 'show');

                            self.location.href =
                                that.studioPanelUri('/account/changedefaultbrand?brand_id=' + brandId);
                        }
                    }
                ]
            });
        });

        // Handle buttons for deleting a Brand.
        $('.delete-brand').click(function (e) {
            e.preventDefault();

            var brandRow = $(this).parents('div.brand-row');
            var brandId = brandRow.data('brandId');
            var brandName = brandRow.data('brandName');
            var isDefaultBrand = brandRow.data('isDefaultBrand');

            // Show a modal to block deletion of the default Brand.
            if (isDefaultBrand) {
                that.modal({
                    title: 'You Cannot Delete Your Default Brand',
                    body: _.template($('#templateCannotDeleteDefaultBrand').html(), {brand_name: brandName}),
                    autoOpen: true,
                    buttons: [
                        {
                            label: 'Close',
                            close: true
                        }
                    ]
                });

                return;
            }

            that.loading('Loading', 'show');

            // Make a requets first to get data on the number of
            // objects associated with the Brand, so we can show it
            // to the end user as they consider whether or not to
            // delete the Brand.
            $.get(that.studioPanelUri('/account/brandcounts'), {
                brand_id: brandId
            }, function (json) {
                that.loading('Loading', 'hide');

                if (!json.success) {
                    that.hoverMessage.show('Brand deletion is not available at this time.', 'error');
                    return;
                }

                var brandDetails = json.counts;
                brandDetails.brand_name = brandName;

                that.modal({
                    title: 'Delete Brand',
                    body: _.template($('#templateDeleteBrand1').html(), brandDetails),
                    autoOpen: true,
                    buttons: [
                        {
                            label: 'Cancel',
                            close: true
                        },{
                            label: 'Yes, Delete Brand',
                            'class': 'btn-danger',
                            click: function () {

                                $(this).parents('div.modal').modal('hide');

                                // Confirm another time!
                                that.modal({
                                    title: 'Delete Brand - ARE YOU SURE?',
                                    body: _.template($('#templateDeleteBrand2').html(), brandDetails),
                                    autoOpen: true,
                                    buttons: [
                                        {
                                            label: 'Cancel',
                                            close: true
                                        },{
                                            label: 'Yes, REALLY Delete Brand',
                                            'class': 'btn-danger',
                                            click: function () {

                                                $(this).parents('div.modal').modal('hide');
                                                Sp.studio.loading('Deleting brand', 'show');

                                                self.location.href =
                                                    that.studioPanelCsrfWrapper(
                                                        that.studioPanelUri('/account/deletebrand?brand_id=' + brandId),
                                                        'account_deletebrand'
                                                    );
                                            }
                                        }
                                    ]
                                });
                            }
                        }
                    ]
                });
            });
        });

        // Iterate over all of the Brand panels, and attach to their
        // location form fields.
        //
        // This is necessary because we have multiple forms on the page, which
        // all need to be selected by their specific form.
        var panels = $('div.panel');

        for (var i = 0; i < panels.length; i++) {
            // Reach into each panel's form, using a form prefix in order to
            // reach the specific form and state field value on each
            // Sp.watchCountryStateField() call.
            var panelForm = $(panels[i]).find('form');
            var panelFormPrefix = '#brandForm' + panelForm.data('formIndex');

            // Handle edge cases where state might not be selected
            var selectedStateId = panelForm.find('select[name="state"]').val();
            if (selectedStateId === '') {
                selectedStateId = that.jsValues.selectedStateId;
            }

            that.watchCountryStateField({
                citySelector: panelFormPrefix + ' input[name="city"]',
                stateDropdownSelector: panelFormPrefix + ' select[name="state"]',
                stateOtherSelector: panelFormPrefix + ' input[name="state_other"]',
                countrySelector: panelFormPrefix + ' select[name="country"]',
                zipCodeSelector: panelFormPrefix + ' input[name="zip_postal"]',
                zipCodeFieldNames: that.jsValues.zipCodeFieldNames,
                cityFieldNames: that.jsValues.cityFieldNames,
                countryNoState: that.jsValues.countryNoState,
                selectedStateId: selectedStateId
            });
        }

        // If the new Brand form has errors upon page load, display
        // it without requiring user interaction.
        if (that.jsValues.hasNewBrandFormErrors) {
            showNewBrandPanel();
            $('.add-brand').remove();
        }
    },

    handleAccountRefer: function () {
        var that = this;

        that.initCopy();

        $('body').on('aftercopy', '.zclip', function () {
            that.hoverMessage.show('Copied ' + that.jsValues.referralShortUrl + ' to your clipboard.');
            $('#shortlinkCopy').blur();
        });

        $('#referFacebook').on('click', function () {
            FB.ui({
                method: 'feed',
                link: that.jsValues.referralShortUrl,
                picture: that.jsValues.referralPicture,
                name: 'ShootProof / Photo Proofing',
                description: 'Photographers - check out ShootProof for photo proofing, mobile apps, commission free sales and invoicing!'
            }, function () {});
        });
    },

    handleGalleryClientEmailFavorite: function () {
        var that = this;

        $('#emailDownloadLink').on('click', function (e) {
            e.preventDefault();

            if (that.jsValues.photoIds.length > 0) {
                that.downloadPhoto({
                    typeId: 5,
                    photoIds: that.jsValues.photoIds,
                    eventId: that.jsValues.eventId,
                    emailAddress: that.jsValues.email,
                    modalTitle: 'Send Files to Contact',
                    modalBody: 'Send an email to ' + that.jsValues.email + ' with a link to download these photos.',
                    subject: 'Zip file of favorites ready for download'
                });
            } else {
                that.hoverMessage.show(
                    'All of the photos have previously been deleted, nothing to download.',
                    that.hoverMessage.type.info);
            }
        });

        $('#downloadAllFavorites').on('click', function (e) {
            e.preventDefault();

            if (that.jsValues.photoIds.length > 0) {
                that.downloadPhoto({
                    photoIds: that.jsValues.photoIds,
                    eventId: that.jsValues.eventId,
                    emailAddress: Sp.userEmail,
                    subject: that.jsValues.studioSubject
                });
            } else {
                that.hoverMessage.show(
                    'All of the photos have previously been deleted, nothing to download.',
                    that.hoverMessage.type.info);
            }
        });

        $('#createMobileApp').on('click', function () {
            that.createMobileApp(that.jsValues.photoIds);
        });
    },

    handleGalleryClientEmailLabeled: function () {
        var that = this;

        $('ul.on-page-tabs li').on('click', function (e) {
            e.preventDefault();

            $('ul.on-page-tabs li.selected').removeClass('selected');
            $('div.tab').removeClass('active');
            $(this).addClass('selected');
            $('#' + $(this).data('tabId')).addClass('active');
        });

        if (that.jsValues.tab !== '' && that.jsValues.tab !== null) {
            $('li.type[data-tab-id="' + that.jsValues.tab + '"]').trigger('click');
        } else {
            $('li.type').first().trigger('click');
        }

        // handle disabling or enabling the bulk actions
        $('.row-select').on('ifChecked ifUnchecked', function() {
            var tab = $('div.tab.active');

            if ($(tab).find('.row-select:checked').length > 1) {
                $(tab).find('.js-download-checked').css('display', 'inline-block');
                $(tab).find('.zclip, .js-create-mobile-app, .js-email-download-link').addClass('disabled');
            } else {
                $(tab).find('.js-download-checked').hide();
                $(tab).find('.zclip, .js-create-mobile-app, .js-email-download-link').removeClass('disabled');
            }
        });

        $('.js-email-download-link').on('click', function () {

            var ids = $('div.tab.active').data('photoIds');

            if (typeof ids === 'string') {
                ids = ids.split(',');
            } else {
                ids = [ids];
            }

            that.downloadPhoto({
                typeId: 5,
                photoIds: ids,
                eventId: that.jsValues.eventId,
                emailAddress: that.jsValues.email,
                modalTitle: 'Send Files to Contact',
                modalBody: 'Send an email to ' + that.jsValues.email + ' with a link to download these photos.',
                subject: 'Zip file of photos ready for download'
            });
        });

        $('.js-delete-from-gallery').on('click', function () {
            that.modal({
                title: 'Confirm Deletion',
                body: _.template($('#templateConfirmHiddenDelete').html(), {}),
                sizeClass: 'modal-md',
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Yes, Delete',
                        'class': 'btn-danger',
                        click: function () {
                            that.loading('Deleting', 'show');
                            $('.modal').modal('hide');

                            $.post(that.studioPanelUri('/gallery/deleteallhidden'), {
                                event_id: that.jsValues.eventId,
                                contact_id: that.jsValues.contactId
                            }, function (json) {
                                that.loading('Deleting', 'hide');

                                if (json.status === that.hoverMessage.type.success) {
                                    self.location.reload();
                                } else {
                                    that.hoverMessage.show(json.msg, json.status);
                                }
                            }, 'json');
                        }
                    }
                ]
            });
        });

        $('.js-download-checked').on('click', function () {

            var tab = $('div.tab.active');
            var ids = [];

            $(tab).find('.table-body input:checkbox:checked').each(function () {
                ids.push($(this).val());
            });

            if (ids.length > 0) {
                that.downloadPhoto({
                    photoIds: ids,
                    eventId: that.jsValues.eventId,
                    emailAddress: Sp.userEmail,
                    subject: that.jsValues.studioSubject
                });
            } else if ($(tab).find('.table-body input:checkbox').length) {
                that.hoverMessage.show(
                    'Please check at least 1 photo to download.',
                    that.hoverMessage.type.info);
            }
        });

        $('.js-create-mobile-app').on('click', function () {

            var ids = $('div.tab.active').data('photoIds');

            if (typeof ids === 'string') {
                ids = ids.split(',');
            } else {
                ids = [ids];
            }

            that.createMobileApp(ids);
        });

        this.initCopy();
    },

    renderNotificationsInContainer: function(
        notifications,
        containerSelector,
        templateSelector,
        emptyStateTemplateSelector
    ) {
        // Remove any .notification-center DIVs within the container.
        $(containerSelector).empty();

        if (notifications && notifications.length === 0) {
            var emptyStateHtml = $(emptyStateTemplateSelector).html();
            $(containerSelector).append(emptyStateHtml);
            return;
        }

        $(notifications).each(function (i, n) {
            var notificationHtml =
                _.template($(templateSelector).html(), {
                    notificationId: n.id,
                    typeName: n.notification_type_name,
                    url: n.url,
                    notificationTypeId: n.notification_type_id,
                    descriptor: n.descriptor,
                    message: n.message,
                    createdString: n.created_string,
                    timeString: n.time_string,
                    createdToday: n.created_today,
                    createdYesterday: n.created_yesterday
                });

            $(containerSelector).append(notificationHtml);
        });
    },

    handleSignupPage: function () {
        var passwordFormState = {
            isPasswordValid: true
        };

        this.handleCookiePolicy();

        // Hide resubmit error
        $('ul.errors li:contains("Please resubmit the form.")').parent().css( 'display', 'none');

        $('#doesAcceptTerms').on('change', validateDoesAcceptTerms);
        $('#email').on('blur', validateEmail);
        $('#locale').on('change', validateCountry);
        $('#password').on('blur', validatePassword);

        $('#promoCode').on('click', function (e) {
            e.preventDefault();
            $('#promo_code').toggle();
            $('.form-group.promo-code').find('ul.errors').toggle();
        });

        $('#signup').on('submit', function (event) {
            const isFormInvalid = [
                isCountryValid(),
                isDoesAcceptTermsValid(),
                isEmailValid(),
                passwordFormState.isPasswordValid,
                isStudioNameValid()
            ].some((valid) => !valid);

            if (isFormInvalid) {
                event.preventDefault();
                validateCountry();
                validateDoesAcceptTerms();
                validateEmail();
                validatePassword();
                validateStudioName();
            }
        });

        $('#studio_name').on('blur', validateStudioName);

        if ($('#promo_code').val()) {
            $('#promo_code').show();
        }

        function createErrorMessage(obj, msg) {
            var $formGroup = obj.closest('.form-group');

            if (!$formGroup.hasClass('has-error')) {
                $formGroup.addClass('has-error');
                $formGroup.append('<ul class="errors"><li></li></ul>');
            }

            $formGroup.find('ul.errors li').text(msg);
        }

        function isCountryValid() {
            return $('option:selected',this).text() !== '- Select Your Country -';
        }

        function isDoesAcceptTermsValid() {
            return $('#doesAcceptTerms').is(':checked');
        }

        function isEmailValid() {
            return $('#email').val() && Sp.regex.email.test($('#email').val());
        }

        function isStudioNamePresent() {
            return $('#studio_name').val().trim();
        }

        function isStudioNameValid() {
            return $('#studio_name').val().trim().length >= 3;
        }

        function removeErrorMessage(obj) {
            var $formGroup = obj.closest('.form-group');

            if ($formGroup.hasClass('has-error')) {
                $formGroup.removeClass('has-error');
                $formGroup.find('ul.errors').remove();
            }
        }

        function validateCountry() {
            if (isCountryValid()) {
                removeErrorMessage($('#locale'));
            } else {
                createErrorMessage($('#locale'), 'Select a Country');
            }
        }

        function validateDoesAcceptTerms() {
            if (isDoesAcceptTermsValid()) {
                removeErrorMessage($('#doesAcceptTerms'));
            } else {
                createErrorMessage(
                    $('#doesAcceptTerms'),
                    'Please review and confirm your acceptance of the Terms of Service and Privacy Policy.'
                );
            }
        }

        function validateEmail() {
            if (isEmailValid()) {
                removeErrorMessage($('#email'));
            } else {
                createErrorMessage($('#email'), 'Enter a valid Email Address');
            }
        }

        function validatePassword() {
            if (passwordFormState.isPasswordValid) {
                removeErrorMessage($('#password'));
            }
        }

        function validateStudioName() {
            if (!isStudioNamePresent()) {
                createErrorMessage($('#studio_name'), 'Enter a Studio Name');
            } else if (!isStudioNameValid()) {
                createErrorMessage($('#studio_name'), 'Enter your complete business name');
            } else {
                removeErrorMessage($('#studio_name'));
            }
        }
    },

    handleDealConfirm: function () {
        if (this.queryString.neededCard === '1') {
            this.updateAnalyticsDataLayer({
                event: 'addedcc',
                subscriberEmail: Sp.userEmail
            });
        }
    },

    handleDealIndex: function () {
        var that = this;
        var searchParams = $(location).attr('href').split("/");
        var key = searchParams[searchParams.length-1];

        $('.bundle-details-link-new').on('click', function (e) {
            var internalTitle = $(this).parents('.deal').data('internalTitle');
            var internalDetails = $(this).parents('.deal').data('internalDetails');
            var bundleName = $(e.target).parents('.deal').data('dealName');

            openBundleDetailsModal(bundleName, internalTitle, internalDetails);
        });

        $('.deal').on('click', '.btn', function (e) {
            e.preventDefault();

            $('.bundle-details-link-confirm').unbind('click');
            $('.bundle-details-link-new').unbind('click');

            var internalTitle = $(this).parents('.deal').data('internalTitle');
            var internalDetails = $(this).parents('.deal').data('internalDetails');
            var isInTrial = Boolean($(this).parents('.deal').data('isInTrial'));
            var isDealMonthly = Boolean($(this).parents('.deal').data('dealIsMonthly'));
            var currentPlanIsYearly = Boolean($(e.target).data('currentPlanIsYearly'));
            var dealPrice = parseInt($(this).parents('.deal').data('price'));
            var planPrice =  parseInt($(e.target).data('currentPlanPrice'));
            var dealTitle = internalTitle || getDealTitle($(e.target).parents('.deal').data('dealName'));

            if(!isInTrial && isDealHigherInPrice(key, currentPlanIsYearly, isDealMonthly,  dealPrice, planPrice)) {
                displayWarningModal();
                $('#step2').hide();
                $('#step1').show();
            } else if (e.target.className.includes('cant-move-to-plan')) {
                var tooManyPhotos = $(e.target).data('tooManyPhotos');
                var tooManyMobileApps = $(e.target).data('tooManyMobileApps');
                var tooManyInvoices = $(e.target).data('tooManyInvoices');
                var tooManyContracts = $(e.target).data('tooManyContracts');

                that.modal({
                    title: 'Cannot Change to This Plan',
                    body: _.template($('#templateCantMoveToPlan').html(), {
                        tooManyPhotos: tooManyPhotos,
                        tooManyMobileApps: tooManyMobileApps,
                        tooManyInvoices: tooManyInvoices,
                        tooManyContracts: tooManyContracts
                    }),
                    buttons: [
                        {
                            label: 'Close',
                            'class': 'btn-primary',
                            close: true
                        }
                    ]
                });
            } else {
                var selectedDeal = $(this).parents('.deal').data('key');
                var selectedDealName = $(this).parents('.deal').data('dealName');

                $('#step1').hide();
                $('#step2').show();
                $('#deal_id').val(selectedDeal);
                $('td.new-deal-title').text(dealTitle);
                $('td.new-deal-price').text($(this).parents('.deal').data('priceFormatted') + "*");

                var chargeAmount = parseFloat($(this).parents('.deal').data('price'));
                var creditAmount = parseFloat($('td.credit').data('credit') || 0);
                var moneyBalanceAmount = parseFloat($('td.money-balance').data('balance') || 0);
                var totalChargeDisplay = $('td.total-charge');
                var currencySymbol = totalChargeDisplay.data('currencySymbol');
                var formatteDealPrice = $(this).parents('.deal').data('priceFormatted');
                var dealMoveBillDateDays = Number($(this).parents('.deal').data('dealMoveBillDateDays'));

                if (dealMoveBillDateDays % 365 == 0) {
                    var numYears = dealMoveBillDateDays / 365;
                    var yearsText = numYears > 1 ? 'years.' : 'year.';

                    $('#new-plan-disclaimer').text(`*When you prepay for ${numYears} ${yearsText}`);
                } else {
                    $('#new-plan-disclaimer').text(`*When you prepay for ${dealMoveBillDateDays} days.`);
                }

                $('#new-deal-title').text(dealTitle);
                $('#new-deal-price').text(formatteDealPrice);

                let newDealSubscriptionTypeText = isDealMonthly ? 'Paid Monthly' : 'Paid Yearly';
                if (internalTitle) {
                    newDealSubscriptionTypeText = 'Paid Today';
                }

                $('#new-deal-subscription-type').text(newDealSubscriptionTypeText);

                if (internalTitle && internalDetails) {
                    $('.bundle-details-link-confirm').text('Get the Details');
                }

                chargeAmount -= creditAmount;
                chargeAmount -= moneyBalanceAmount;

                if (chargeAmount < 0) {
                    chargeAmount = 0;
                }

                totalChargeDisplay.text(currencySymbol + Sp.numberFormat(chargeAmount, 2, '.', ','));
                $("html, body").animate({
                    scrollTop: 0
                }, 300);

                $('.bundle-details-link-confirm').on('click', function (e) {
                    openBundleDetailsModal(selectedDealName, internalTitle, internalDetails);
                });

                $('.bundle-details-link-new').on('click', function (e) {
                    var internalTitle = $(this).parents('.deal').data('internalTitle');
                    var internalDetails = $(this).parents('.deal').data('internalDetails');
                    var bundleName = $(e.target).parents('.deal').data('dealName');

                    openBundleDetailsModal(bundleName, internalTitle, internalDetails);
                });
            }
        });

        $('.back-link').on('click', function (e) {
            e.preventDefault();

            $('#step2').hide();
            $('#step1').show();
        });

        $('.toggle-monthly').on('click', function (e) {
            e.preventDefault();

            $('.toggle-monthly').addClass('active');
            $('.toggle-yearly').removeClass('active');

            $(".deal.new-deal").each(function() {
                hideOrDisplayDeal(this, Boolean($(this).data('dealIsMonthly')));
            });
        });

        $('.toggle-yearly').on('click', function (e) {
            e.preventDefault();

            $('.toggle-monthly').removeClass('active');
            $('.toggle-yearly').addClass('active');

            $(".deal.new-deal").each(function() {
                hideOrDisplayDeal(this, Boolean($(this).data('dealIsYearly')));
            });
        });

        function hideOrDisplayDeal(thisDeal, isMonthly) {
            if (isMonthly) {
                $(thisDeal).removeClass('hide');
                $(thisDeal).parent().removeClass('hide-deal');
            } else {
                $(thisDeal).addClass('hide');
                $(thisDeal).parent().addClass('hide-deal');
            }
        };

        function getDealTitle(bundleName) {
            var planCode = bundleName.toLowerCase();

            var planName = 'Starting Bundle';
            if (planCode.includes('unlimited')) {
                 planName = 'Scaling Bundle';
            } else if (planCode.includes('25,000')) {
                planName = 'Optimizing Bundle';
            } else if (planCode.includes('5,000') || planCode.includes('10,000')) {
                planName = 'Growing Bundle';
            }

            return planName;
        }

        // If the page is rendered with a selected deal ID in the form,
        // then act as though the end user clicked the button in order
        // to populate the selected deal values in step two.
        var lookupKey = that.jsValues.fetchedDealId || key || that.jsValues.selectedDealId;
        if (lookupKey) {
            // Find the deal button by its ID value.
            var dealButton = $('.deal[data-key="' + (lookupKey)  + '"] .btn');

            if (dealButton && dealButton.length === 0 && key && key.length > 11) {
                displayWarningModal();
            } else if (dealButton.length) {
                dealButton.trigger('click');
            }

            // If key equals blackfriday then hide the deal toggle
            const hasMonthlyAndYearlyOptions = $('[data-deal-is-monthly=1]').length > 0 && $('[data-deal-is-yearly=1]').length > 0;

            if (!hasMonthlyAndYearlyOptions) {
                $('#deal-toggle').hide();
            } else {
                $('.toggle-monthly').trigger('click');
            }
        }

        function displayWarningModal() {
            that.modal({
                title: 'Deal Not Available',
                body: 'We\'re sorry! Based on your plan history, you\'re not eligible for this deal. An upgrade is required for existing studios. Read this article to <a target="_blank" rel="noopener noreferrer" href="https://help.shootproof.com/hc/en-us/articles/360037251454-Black-Friday-FAQ">learn more.</a>',
                buttons: [
                    {
                        label: 'View Available Deals',
                        'class': 'btn-primary',
                        close: true,
                        click: function () {
                            $('#step2').hide();
                            $('#step1').show();
                        }
                    }
                ]
            });
            $('.modal').addClass('sp-deal-not-available-message');
            $('.modal-footer.centered').removeClass( "centered" );
            $('.bundle-details-link-new').on('click', function (e) {
                var bundleName = $(e.target).parents('.deal').data('dealName');
                openBundleDetailsModal(bundleName);
            });
        }

        function isDealHigherInPrice(key, currentPlanIsYearly, isDealMonthly,  dealPrice, planPrice) {
            return key && ((isDealMonthly && currentPlanIsYearly && dealPrice * 12 < planPrice)
                || (isDealMonthly && !currentPlanIsYearly && dealPrice < planPrice)
                || (!isDealMonthly && currentPlanIsYearly && dealPrice < planPrice)
                || (!isDealMonthly && !currentPlanIsYearly && dealPrice < planPrice * 10))
        }

        function openBundleDetailsModal(bundleName, internalTitle, internalDetailsHtml) {
            if (internalDetailsHtml && internalTitle) {
                that.modal({
                    title: internalTitle,
                    body: _.template($('#templateBundleDetails').html(), {
                        internalDetailsHtml: internalDetailsHtml,
                    }),
                    buttons: [
                        {
                            label: 'Close',
                            'class': 'btn-primary',
                            close: true
                        }
                    ]
                });

                $('.modal').addClass('bundle-details-modal');
                $('.modal-footer.centered').removeClass( "centered" );
            }
        }
    },

    handleDealSignupIndex: function () {
        var that = this;
        var isCloseButtonVisible = false;
        var isMobileFormVisible = false;
        var isAsideVisible = false;
        var background = document.querySelector('.bg');
        var aside = $('aside');
        var section = $('section');
        var form1 = $('.sp-deal-index-v2-input-container-form-1');
        var form2 = $('.sp-deal-index-v2-input-container-form-2');
        var backButton = $('.back-button');
        var continueButton = $('.continue-button');
        var closeButton = $('.close-button');
        var mobileSignupButton = $('.cta-sm');
        var mobileSignupButtonContainer = $('.cta-sm-wrapper');
        var submitButton = $('.submit-button');
        var acceptTerms = $('.accept-terms');
        var passwordFormState = {
            isPasswordValid: false
        };

        this.handleCookiePolicy();

        this.renderPasswordForm({
            isRequired: true,
            isStudioSignup: true,
            onChange: toggleCtas,
            passwordFormState: passwordFormState,
            showValidation: false
        });

        $(window).on('resize', function () {
            if (isMobileFormVisible) {
                if ($(this).width() > 999) {
                    if (isCloseButtonVisible) {
                        setCloseButtonVisibility(false);
                        setSectionVisibility(true);
                    }
                } else if ($(this).width() <= 999) {
                    if (!isCloseButtonVisible) {
                        setCloseButtonVisibility(true);
                        setSectionVisibility(false);
                    }
                }
            } else {
                if (!isAsideVisible) {
                    if ($(this).width() > 999) {
                        setAsideVisibility(true);
                    }
                }  else if ($(this).width() <= 999) {
                    setAsideVisibility(false);
                }
            }
        });

        function toggleCtas() {
            var form1Showing = form1.hasClass('sp-deal-index-v2-input-container-form-1-active');
            var form2Showing = form2.hasClass('sp-deal-index-v2-input-container-form-2-active');

            if (form1Showing) {
                if ($('#deal_id').val().length > 0 &&
                    $('#studio_name').val().length > 0 &&
                    $('#email').val().length > 0 &&
                    passwordFormState.isPasswordValid) {
                    continueButton.removeClass('op-1');
                    continueButton.addClass('op-10');
                } else {
                    continueButton.removeClass('op-10');
                    continueButton.addClass('op-1');
                }
            } else if (form2Showing) {
                if ($('#locale').val().length > 0 &&
                    $('#billing_postal_code').val().length > 0 &&
                    $('#card_number').val().length > 0 &&
                    $('#expiration_month').val().length === 2 &&
                    $('#expiration_year').val().length === 4 &&
                    $('#cvv_code').val().length >= 3) {
                    submitButton.removeClass('op-1');
                    submitButton.addClass('op-10');
                } else {
                    submitButton.removeClass('op-10');
                    submitButton.addClass('op-1');
                }
            }
        }

        if ($('.page-deal-index-v2').length > 0) {
            $('form input, form select').on('keyup blur change', toggleCtas);

            $('button.hide-not-mdl').on('click', function () {
                $(document).scrollTop(0);
            });
        }

        backButton.on('click', function () {
            $('span.form-error').empty();
            background.classList.remove('expand');
            form2
                .removeClass('sp-deal-index-v2-input-container-form-2-active')
                .delay(800)
                .queue(function (next) {
                    $(this).css('visibility', 'hidden');
                    next();
                });
            continueButton.show();
            submitButton.hide();
            acceptTerms.hide();
            form1
                .css('visibility', 'visible')
                .delay(300)
                .queue(function (next) {
                    $(this).removeClass('sp-deal-index-v2-input-container-form-1-inactive');
                    next();
                });
        });

        continueButton.on('click', function (e) {
            e.preventDefault();

            $('form').find('div.form-group').removeClass('has-error');
            $('form').find('span.form-error').remove();
            $('.general-error').hide();

            if (!passwordFormState.isPasswordValid) {
                return;
            }

            continueButton.prop('disabled', true);

            $.post(that.jsValues.dealPageData.stepOneActionUrl, {
                deal_id: $('#deal_id').val(),
                studio_name: $('#studio_name').val(),
                email: $('#email').val(),
                password: $('[name="password"]').val()
            })
            .done(function () {
                background.classList.add('expand');
                form1
                    .removeClass('sp-deal-index-v2-input-container-form-1-active')
                    .addClass('sp-deal-index-v2-input-container-form-1-inactive')
                    .delay(800)
                    .queue(function (next) {
                        $(this).css('visibility', 'hidden');
                        next();
                    });
                continueButton.hide();
                submitButton.show();
                acceptTerms.show();
                form2
                    .css('visibility', 'visible')
                    .delay(300)
                    .queue(function (next) {
                        $(this).addClass('sp-deal-index-v2-input-container-form-2-active');
                        next();
                    });

                setTimeout(function () {
                    aside.animate({
                        scrollTop: 0
                    });
                }, 1000);
            })
            .fail(function (jqXHR) {
                if (jqXHR.status === 400) {
                    that.displayFormErrors($('form'), jqXHR.responseJSON);
                } else {
                    $('.general-error').show();
                }
            })
            .always(function () {
                continueButton.prop('disabled', false);
            });
        });

        closeButton.on('click', function () {
            setMobileFormVisibility(false);
            setCloseButtonVisibility(false);
            setAsideVisibility(false);
            setSectionVisibility(true);
        });

        mobileSignupButton.on('click', function () {
            setMobileFormVisibility(true);
            setCloseButtonVisibility(true);
            setAsideVisibility(true);
            setSectionVisibility(false);
        });

        submitButton.on('click', function (e) {
            e.preventDefault();
            var platformAccountId = $('.deal-platform-account-id').val();

            $('form').find('div.form-group').removeClass('has-error');
            $('form').find('span.form-error').remove();
            $('.general-error').hide();

            // Don't submit the form unless step two is active.
            if (!form2.hasClass('sp-deal-index-v2-input-container-form-2-active')) {
                return;
            }

            if (!passwordFormState.isPasswordValid) {
                return;
            }

            submitButton.prop('disabled', true);

            $.post(that.jsValues.dealPageData.purchaseActionUrl, {
                deal_id: $('#deal_id').val(),
                studio_name: $('#studio_name').val(),
                email: $('#email').val(),
                password: $('[name="password"]').val(),
                locale: $('#locale').val(),
                billing_postal_code: $('#billing_postal_code').val(),
                card_number: Sp.numbersOnly($('#card_number').val()),
                expiration_month: $('#expiration_month').val(),
                expiration_year: $('#expiration_year').val(),
                cvv_code: $('#cvv_code').val(),
                doesAcceptTerms: $('#doesAcceptTerms').prop('checked') ? 1 : 0,
                platform_account_id: platformAccountId
            })
            .done(function (data, status, jqXHR) {
                if (window.dataLayer) {
                    window.dataLayer.push({ uuid: platformAccountId });
                }

                window.location.href = jqXHR.responseJSON.studio_url;
            })
            .fail(function (jqXHR) {
                submitButton.prop('disabled', false);

                if (jqXHR.status === 400) {
                    that.displayFormErrors($('form'), jqXHR.responseJSON);
                } else {
                    $('.general-error').show();
                }
            })
            .always(function () {
                submitButton.prop('disabled', false);
            });
        });

        function setCloseButtonVisibility(isVisible) {
            if (isVisible) {
                closeButton
                    .show(0)
                    .delay(500)
                    .queue(function (next) {
                        $(this).removeClass('op-0');
                        next();
                    });
            } else {
                closeButton
                    .addClass('op-0')
                    .delay(500)
                    .hide(0);
            }

            isCloseButtonVisible = isVisible;
        }

        function setMobileFormVisibility(isVisible) {
            if (isVisible) {
                mobileSignupButton
                    .addClass('op-0')
                    .delay(500)
                    .hide(0);

                mobileSignupButtonContainer
                    .delay(300)
                    .queue(function (next) {
                        $(this)
                        .css('height', '100vh')
                        .css('background', 'white');
                        next();
                    });
            } else {
                mobileSignupButtonContainer
                    .css('height', '80px')
                    .css('background', 'rgba(255,255,255,' + 0.9 + ')');

                mobileSignupButton
                    .show(0)
                    .delay(500)
                    .queue(function (next) {
                        $(this).removeClass('op-0');
                        next();
                    });
            }

            isMobileFormVisible = isVisible;
        }

        function setAsideVisibility (isVisible) {
            if (isVisible) {
                aside
                    .show(0)
                    .delay(800)
                    .queue(function (next) {
                        $(this).css('opacity', 1);
                        next();
                    });
            } else {
                aside
                    .css('opacity', 0)
                    .delay(800)
                    .hide(0);
            }

            isAsideVisible = isVisible;
        }

        function setSectionVisibility(isVisible) {
            if (isVisible) {
                section
                    .show(0)
                    .delay(500)
                    .queue(function (next) {
                        $(this).removeClass('op-0');
                        next();
                    });
            } else {
                section
                    .addClass('op-0')
                    .delay(500)
                    .hide(0);
            }
        }

        $('#email').on('blur', function () {
            var dealId = $('#deal_id').val();
            var email = $.trim($(this).val());

            if (dealId !== '' && email !== '') {
                $.post('/deal/check',
                    {
                        deal_id: dealId,
                        email: email
                    },
                    function (json) {
                        if (json.found) {
                            $('#email').parent('.form-group').addClass('has-error');
                            $('#email').parent('.form-group').find('ul.errors.email').show();
                        } else {
                            $('#email').parent('.form-group').removeClass('has-error');
                            $('#email').parent('.form-group').find('ul.errors.email').hide();
                        }
                    },
                    'json'
                );
            }
        });

        $('#card_number').keyup(function () {
            $(this).val(that.creditCardNumberFormat(Sp.numbersOnly(this.value)));

            // If they're changing the credit card number and already have a
            // CVV code value, validate it.
            if ($('#cvv_code').val().length > 0) {
                $('#cvv_code').trigger('keyup');
            }
        });

        $('#cvv_code').keyup(function () {
            // Drop non-numeric characters.
            $(this).val(Sp.numbersOnly(this.value));

            if (!that.validateCvvCode($('#card_number').val(), this.value)) {
                $(this).parents('.form-group').addClass('has-error');
            } else {
                $(this).parents('.form-group').removeClass('has-error');
            }
        });
    },

    handleDealIndexMusic: function () {
        var that = this;

        $('.deal').on('click', '.btn', function (e) {
            e.preventDefault();

            var selectedDeal = $(this).parents('.deal').data('key');

            $('#step1').hide();
            $('#step2').show();
            $('#deal_id').val(selectedDeal);
            $('td.new-deal-title').text($(this).parents('.deal').data('title'));
            $('td.new-deal-price').text($(this).parents('.deal').data('priceFormatted'));

            var chargeAmount = parseFloat($(this).parents('.deal').data('price'));
            var creditAmount = parseFloat($('td.credit').data('credit'));
            chargeAmount -= creditAmount;

            if (chargeAmount < 0) {
                chargeAmount = 0;
            }

            $('td.total-charge').text(Sp.numberFormat(chargeAmount, 2, '.', ','));
            $("html, body").animate({
                scrollTop: 0
            }, 300);
        });

        $('.back-link').on('click', function (e) {
            e.preventDefault();

            $('#step2').hide();
            $('#step1').show();
        });

        // If the page is rendered with a selected deal ID in the form,
        // then act as though the end user clicked the button in order
        // to populate the selected deal values in step two.
        if (that.jsValues.selectedDealId) {
            // Find the deal button by its ID value.
            var dealButton = $('.deal[data-key="' + that.jsValues.selectedDealId + '"] .btn');

            if (dealButton) {
                dealButton.trigger('click');
            }
        }
    },

    handleNotificationIndex: function () {
        var that = this;

        // Load Notifications.
        that.loading('Loading', 'show');

        var num_recent = 50;
        var page_number = this.queryString.page_number ? this.queryString.page_number : 1;

        $.get(that.studioPanelUri('/notification/getrecent?num_recent=' + num_recent + '&page_number=' + page_number), {
        }, function (json) {
            that.loading('Loading', 'hide');

            // Handle empty state.
            if (json.notifications.length === 0) {
                var emptyStateHtml = $('#templateNotificationPageEmptyState').html();
                $('div.notification-groups-container').append(emptyStateHtml);
                return;
            }

            var showing = $('.showing');
            showing.append('Showing: ' + json.num_recent + ' of ' + + json.num_total);

            if (json.num_total > json.num_recent) {
                var paginate = $('.paginate');
                var pages = Math.ceil(json.num_total / num_recent);
                for (let page = 1; page <= pages; page++) {
                    if (json.page_number === page) {
                        paginate.append(page);
                    } else {
                        paginate.append("<a href='" +
                            that.studioPanelUri('/notification/?page_number=' + (page)) +
                            "'>" + page + "</a>");
                    }
                    if ((page+1) <= pages) {
                        paginate.append(', ');
                    }
                }
            }

            $('a.dismiss-all').show();
            var separated = that.separateNotifications(json.notifications);

            // Render search set in their respective container DIV.
            if (separated.today.length > 0) {
                $('div.today').show();

                that.renderNotificationsInContainer(
                    separated.today,
                    'div.today div.notifications',
                    '#templateNotificationPage',
                    '#templateNotificationPageEmptyState'
                );
            }

            if (separated.yesterday.length > 0) {
                $('div.yesterday').show();

                that.renderNotificationsInContainer(
                    separated.yesterday,
                    'div.yesterday div.notifications',
                    '#templateNotificationPage',
                    '#templateNotificationPageEmptyState'
                );
            }

            if (separated.older.length > 0) {
                $('div.older').show();

                that.renderNotificationsInContainer(
                    separated.older,
                    'div.older div.notifications',
                    '#templateNotificationPage',
                    '#templateNotificationPageEmptyState'
                );
            }
        });

        // NOTE: because we're not rendering Notifications with JavaScript
        // on this page, we don't have selectors to pass.  The method
        // handles this.
        that.setupNotificationDismissal(
            undefined,
            undefined,
            '#templateNotificationEmptyState',
            undefined
        );

        // Handle "Dismiss All" usage.
        $('.js-dismiss-all-notifications').click(function () {
            var notificationIds = [];

            $('div.notification-item').each(function (i, e) {
                if ($(e).data('notificationId')) {
                    notificationIds.push($(e).data('notificationId'));
                }
            });

            that.modal({
                title: 'Confirm Dismissal',
                body: _.template($('#templateConfirmDismissAll').html(), {
                    numNotifications: notificationIds.length
                }),
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },
                    {
                        label: 'Yes, dismiss all',
                        'class': 'btn-primary',
                        click: function () {
                            var modal = $(this).parents('.modal');

                            $.post(that.studioPanelUri('/notification/dismissmulti'), {
                                ids: notificationIds
                            },
                            function (json) {
                                if (json.status === 'success') {
                                    // Remove all Notification groups from the page.
                                    $('div.notifications-group').remove();
                                    $('.js-dismiss-all-notifications').remove();

                                    // Show the empty state.
                                    var emptyStateHtml = $('#templateNotificationsEmptyState').html();
                                    $('div.notification-groups-container').append(emptyStateHtml);
                                }

                                that.hoverMessage.show(json.msg, json.status);
                                $(modal).modal('hide');
                            },
                            'json');
                        }
                    }
                ]
            });
        });
    },

    handleNotificationDismissed: function () {
        var that = this;

        var num_recent = 50;
        var page_number = this.queryString.page_number ? this.queryString.page_number : 1;

        // Load Notifications.
        $.get(that.studioPanelUri('/notification/getdismissed?num_recent=' + num_recent + '&page_number=' + page_number), {
        }, function (json) {
            // Handle empty state.
            if (json.notifications.length === 0) {
                var emptyStateHtml = $('#templateNotificationPageEmptyState').html();
                $('div.notification-groups-container').append(emptyStateHtml);
                return;
            }

            var showing = $('.showing');
            showing.append('Showing: ' + json.num_recent + ' of ' + + json.num_total);

            if (json.num_total > json.num_recent) {
                var paginate = $('.paginate');
                var pages = Math.ceil(json.num_total / num_recent);
                for (let page = 1; page <= pages; page++) {
                    if (json.page_number === page) {
                        paginate.append(page);
                    } else {
                        paginate.append("<a href='" +
                            that.studioPanelUri('/notification/dismissed?page_number=' + page) +
                            "'>" + page + "</a>");
                    }
                    if ((page+1) <= pages) {
                        paginate.append(', ');
                    }
                }
            }

            var separated = that.separateNotifications(json.notifications);

            // Render search set in their respective container DIV.
            if (separated.today.length > 0) {
                $('div.today').show();

                that.renderNotificationsInContainer(
                    separated.today,
                    'div.today div.notifications',
                    '#templateNotificationPage',
                    '#templateNotificationPageEmptyState'
                );
            }

            if (separated.yesterday.length > 0) {
                $('div.yesterday').show();

                that.renderNotificationsInContainer(
                    separated.yesterday,
                    'div.yesterday div.notifications',
                    '#templateNotificationPage',
                    '#templateNotificationPageEmptyState'
                );
            }

            if (separated.older.length > 0) {
                $('div.older').show();

                that.renderNotificationsInContainer(
                    separated.older,
                    'div.older div.notifications',
                    '#templateNotificationPage',
                    '#templateNotificationPageEmptyState'
                );
            }
        });
    },

    handleAccountTou: function () {
        var that = this;

        if ($('.terms-text').css('max-height') !== 'none') {
            $('.terms-text').bind('scroll', function (e) {
                // If they're not the owner, or the button's already enabled,
                // then there's nothing to do.
                if (!that.jsValues.isStudioOwner ||
                    $('.accept').prop('disabled') === false
                ) {
                    return;
                }

                // Once they scroll to the bottom once, enable the button.
                // Allow a 20 pixel tolerance to allow this to work in IE /
                // Edge.
                if ($(this).scrollTop() + $(this).innerHeight() >= this.scrollHeight - 20) {
                    enableAcceptButton();
                }
            });
        } else {
            $(window).bind('scroll', function (e) {
                if (!that.jsValues.isStudioOwner ||
                    $('.accept').prop('disabled') === false
                ) {
                    return;
                }

                if (window.pageYOffset + window.innerHeight === $(document).height()) {
                    enableAcceptButton();
                }
            });
        }

        function enableAcceptButton() {
            $('.accept').removeAttr('disabled');
        }
    },

    handleAccountNewGalleryManagement: function () {
        var that = this;

        $('.opt-out').click(function () {
            var optOutHtml = _.template($('#templateOptOut').html(), {});
            $('#newGalleryManagement').empty().append(optOutHtml);
        });

        $('#migrateStudio').click(function () {
            that.loading('Migrating', 'show');

            $.post(
                that.studioPanelUri('/account/gallery-management-migration'),
                {},
                function (response) {
                    that.loading('Migrating', 'hide');

                    self.location.href = response.nextUrl;
                },
                'json'
            ).fail(
                function (jqXHR) {
                    that.loading('Migrating', 'hide');

                    var status;
                    if (jqXHR.responseJSON !== undefined
                        && jqXHR.responseJSON.status !== undefined
                    ) {
                        status = jqXHR.responseJSON.status;
                    }

                    if (status === 'already-migrated'
                        || status === 'user-not-owner'
                    ) {
                        location.reload();
                    } else if (status === 'limit-reached') {
                        var errorHtml = _.template($('#templateMigrationNowFull').html(), {});
                        $('#newGalleryManagement').empty().append(errorHtml);
                    } else {
                        var errorHtml = _.template($('#templateMigrationFailed').html(), {});
                        $('#newGalleryManagement').empty().append(errorHtml);
                    }
                }
            );
        });
    },

    renderPasswordForm: function (config) {
        window.Sp.v2ReactBridge.showPasswordForm({
            initialTouched: config.showValidation,
            isRequired: config.isStudioSignup || config.isRequired || false,
            isStudioSignup: config.isStudioSignup || false,
            onChange: function (_, isValid) {
                config.passwordFormState.isPasswordValid = isValid;

                if (config.onChange) {
                    config.onChange();
                }
            }
        });
    },

    separateNotifications: function (notifications) {
        // Fetch all Notifications, but split them up into
        // today, yesterday, and older.
        var today = [];
        var yesterday = [];
        var older = [];

        for (var i = 0; i < notifications.length; i++) {
            if (notifications[i].created_today) {
                today.push(notifications[i]);
            } else if (notifications[i].created_yesterday) {
                yesterday.push(notifications[i]);
            } else {
                older.push(notifications[i]);
            }
        }

        return {
            today: today,
            yesterday: yesterday,
            older: older
        };
    },

    createMobileApp: function (photoIds) {
        var that = this;

        // default the photo ids
        photoIds = ((typeof photoIds !== 'undefined') ? photoIds : []);

        this.loading('Loading', 'show');

        $.get(this.studioPanelUri('/mobileapp/create'), {
            photo_ids: photoIds.join(',')
        }, function (html) {
            that.loading('Loading', 'hide');

            if (html === 'plan_limit') {
                Sp.studio.mobileAppPlanLimitReached();
                return;
            }

            that.modal({
                title: 'Create a Mobile App',
                body: html,
                sizeClass: 'modal-md',
                open: function () {
                    $('#' + this.id).find('select').select2({
                        width: '100%',
                        minimumResultsForSearch: Infinity
                    });

                    $('#show_contact_info, #show_social_sharing, #view_type-list').iCheck(that.configs.iCheck);
                },
                buttons: [
                    {
                        label: 'Cancel',
                        close: true
                    },{
                        label: 'Create',
                        'class': 'btn-primary',
                        click: function () {

                            var modal = $(this).parents('.modal');
                            that.loading('Creating App', 'show');

                            // Get Mobile Apps v2-specific values.
                            var viewType;
                            var languageCode;
                            var playlistId;

                            if ($('#view_type-list').length > 0) {
                                viewType = $('#view_type-list input:checked').val();
                            }

                            if ($('#language_code').length > 0) {
                                languageCode = $('#language_code').val();
                            }

                            if ($('#playlist_id').length > 0) {
                                playlistId = $('#playlist_id').val();
                            }

                            $.post(that.studioPanelUri('/mobileapp/create'), {
                                name: $(modal).find('input[name="name"]').val(),
                                event_id: $(modal).find('select[name="event_id"]').val(),
                                brand_theme_id: $(modal).find('select[name="brand_theme_id"]').val(),
                                show_contact_info: (($(modal).find('input[name=show_contact_info]').is(':checked')) ? 1 : 0),
                                show_social_sharing: (($(modal).find('input[name=show_social_sharing]').is(':checked')) ? 1 : 0),
                                photo_ids: $(modal).find('input[name="hidden_photo_ids"]').val(),
                                view_type: viewType,
                                language_code: languageCode,
                                playlist_id: playlistId
                            }, function (json) {
                                $(modal).find('.error').removeClass('error');
                                $(modal).find('div.errors').remove();
                                that.loading('Creating App', 'hide');

                                if (json.status === 'form_errors') {
                                    var formElementId, objKey;

                                    for (formElementId in json.errors) {
                                        for (objKey in json.errors[formElementId]) {
                                            var msg = json.errors[formElementId][objKey];
                                            $(modal).find('input[name="' + formElementId + '"]').parents('.form-group').addClass('has-error');
                                            $(modal).find('input[name="' + formElementId + '"]').parents('.form-group').append('<div class="errors">' + msg + '</div>');
                                        }
                                    }

                                } else {
                                    modal.modal('hide')
                                    self.location.href = json.href;
                                    return;
                                }
                            }, 'json');
                        }
                    }
                ]
            });
        }, 'html');
    },

    mobileAppPlanLimitReached: function () {
        this.modal({
            title: 'Plan Limit Reached',
            body: '<p>You have reached your plan limit for mobile apps. To get the ability to create unlimited mobile apps you can <a href="' + this.studioPanelUri('/account/planbilling') + '">upgrade your plan</a>.</p>',
            sizeClass: 'modal-md',
            buttons: [{
                label: 'Ok',
                'class': 'btn-primary',
                close: true
            }]
        });
    },

    setupMobileAppEmailLink: function () {
        var that = this;

        // Email link modal.
        $('#bd').on('click', '.email-link', function (e) {
            e.preventDefault();

            var mobileAppId = $(e.target).data('mobileAppId');
            that.loading('Loading', 'show');

            // When emailing the link, fetch the default message contents from
            // the server-side.
            $.get(that.studioPanelUri('/email/defaulttemplatecontents'), {
                // Sp_Email_Template::TYPE_MOBILE_APP_LINK
                email_template_type_id: 6,
                mobile_app_id: mobileAppId
            }, function (json) {
                // Once we've loaded the default subject and body, show the
                // modal.
                that.loading('Loading', 'hide');

                // Get the default message text at open time.
                var defaultSubject = '';
                var defaultMessageText = '';
                var defaultHeadline = '';
                var defaultButtonText = '';

                // Set the subject and body values based on the response.
                if (json.subject) {
                    defaultSubject = json.subject;
                }

                if (json.body) {
                    defaultMessageText = json.body;
                }

                if (json.headline) {
                    defaultHeadline = json.headline;
                }

                if (json.buttonText) {
                    defaultButtonText = json.buttonText;
                }

                that.modal({
                    title: 'Email Mobile App Link',
                    sizeClass: 'modal-fullscreen',
                    body: _.template($('#templateEmailLink').html(), {}),
                    open: function () {
                        $('#buttonTextHelper').html($('#button_text_helper').val());

                        that.initEmailPreview();

                        var previewEmail = function () {
                            var params = {
                                email_template_type_id: $('#email_template_type_id').val(),
                                subject: $('#subject').val(),
                                headline: $('#headline').val(),
                                button_text: $('#button_text').val(),
                                body: $R('#message').source.getCode(),
                                mobile_app_id: mobileAppId
                            };

                            that.handleEmailPreview(params);
                        };

                        $('#headline, #button_text').on('input', function () {
                            previewEmail();
                        });

                        // Enable Select2 on template select.
                        $('#templates').select2({
                            width: '100%',
                            minimumResultsForSearch: Infinity
                        }).on('change', function () {
                            // As the user selects any of their user-defined
                            // templates, retrieve its contents for the chosen
                            // Mobile App.
                            if (this.value === '') {
                                $('#subject').val(defaultSubject);
                                $R('#message').source.setCode(defaultMessageText);
                                $('#headline').val(defaultHeadline);
                                $('#button_text').val(defaultButtonText);
                                previewEmail();
                                return;
                            }

                            $.get(that.studioPanelUri('/email/templatecontents'), {
                                id: this.value,
                                mobile_app_id: mobileAppId
                            }, function (json) {
                                $('#subject').val(json.subject)
                                $('#headline').val(json.headline);
                                $('#button_text').val(json.buttonText);
                                $R('#message').source.setCode(json.body);
                                previewEmail();
                            }, 'json');
                        });

                        // Use WYSIWYG editor on message body.
                        Sp.studio.editor('#message', {
                            minHeight: 100,
                            maxHeight: 300,
                            changeCallback: previewEmail
                        });

                        const emailMobileAppRecaptchaCallback = () => {
                            const modal = $('.modal');
                            Sp.studio.loading('Sending Email', 'show');

                            const recaptchaToken = ('grecaptcha' in window && window.grecaptcha && 'getResponse' in window.grecaptcha) 
                                ? window.grecaptcha.getResponse() 
                                : null;

                            var postParams = {
                                template_id: $('#templates').val(),
                                email_template_type_id: $('#email_template_type_id').val(),
                                mobile_app_id: mobileAppId,
                                to_email: $('#to_email').val(),
                                subject: $('#subject').val(),
                                headline: $('#headline').val(),
                                button_text: $('#button_text').val(),
                                message: $R('#message').source.getCode(),
                                recaptcha_token: recaptchaToken
                            };

                            $.post(that.studioPanelUri('/mobileapp/email'), postParams, function (json) {
                                that.loading('Sending Email', 'hide');

                                if (json.status === 'success') {
                                    modal.modal('hide');
                                    Sp.studio.hoverMessage.show(json.msg, json.status);
                                } else if (json.status === 'form_errors') {
                                    that.displayFormErrors(modal, json.errors);
                                    if ('grecaptcha' in window && window.grecaptcha && 'reset' in window.grecaptcha) {
                                        window.grecaptcha.reset();
                                    }
                                    if ($('#emailPreviewNavigation').is(':visible')) {
                                        $('.email-preview ul.on-page-tabs li.edit').click();
                                    }
                                    $(modal).animate({ scrollTop: 0 }, 'slow');
                                }
                            }, 'json');
                        }

                        window.emailMobileAppRecaptchaCallback = emailMobileAppRecaptchaCallback;

                        $('.email-preview button.send-mail').click(function () {
                            if ('grecaptcha' in window && window.grecaptcha) {
                                window.grecaptcha.ready(() => {
                                    window.grecaptcha.execute();
                                });
                            } else {
                                // If grecaptcha is not available (disabled for studio), call the callback directly
                                window.emailMobileAppRecaptchaCallback();
                            }
                        });

                        // If the event's target has a download URL attribute on
                        // it, copy its value into a hidden input within the body
                        // that is addressed by #emailLinkUrl.  We do this because
                        // the copy to clipboard functionality needs to copy out
                        // of an input or textarea.  Note that in the close method
                        // here, we remove any #emailLinkUrl elements from the
                        // page.

                        $('.email-preview .mobile-app-copy-download-url').click(function () {
                            var dataMobileAppDownloadUrl = $(e.target).data('mobileAppDownloadUrl');

                            if (dataMobileAppDownloadUrl !== undefined) {
                                var emailLinkUrl = $('#emailLinkUrl');
                                emailLinkUrl.val(dataMobileAppDownloadUrl);
                                emailLinkUrl.attr('type', '');
                                emailLinkUrl.select();

                                try {
                                    document.execCommand('copy');

                                    $(this).parents('div.modal').modal('hide');

                                    Sp.studio.hoverMessage.show(
                                        'Mobile app download link copied to your clipboard!',
                                        'success',
                                        2000
                                    );
                                } catch (err) {
                                    Sp.studio.hoverMessage.show(
                                        'An error occurred while copying to your clipboard.',
                                        'failure',
                                        2000
                                    );
                                }

                                emailLinkUrl.attr('type', 'hidden');
                            } else {
                                Sp.studio.hoverMessage.show(
                                    'Mobile app download link not available.',
                                    'failure',
                                    2000
                                );
                            }
                        });

                        // Set the default subject and message text.
                        $('#subject').val(defaultSubject);
                        $('#headline').val(defaultHeadline);
                        $('#button_text').val(defaultButtonText);
                        $R('#message').source.setCode(defaultMessageText);
                        previewEmail();
                    },
                    close: function () {
                        $('#emailLinkUrl').val('');
                    },
                    buttons: []
                });
            });
        });
    },

    scrollToFirstFormError: function () {
        if ($('ul.form-error:visible').length) {
            $('html, body').animate({
                scrollTop: $('ul.form-error').first().parents('.form-group').offset().top - 120
            }, 300);
        }
    },

    setupContactTags: function (contactId, autosave) {
        var that = this;

        //
        // Tags handling
        //
        var tagsInput = $('input.tags');

        // Take the tags on the Contact, and generate an array
        // of just the tag values.
        var contactTagNames = [];

        var i;

        if (Sp.studio.jsValues.contactTags !== undefined) {
            for (i = 0; i < Sp.studio.jsValues.contactTags.length; i++) {
                contactTagNames.push({value: Sp.studio.jsValues.contactTags[i].tag_name});
            }
        }

        // Bolt the Contact's tags onto the defaults that are
        // available.
        for (i = 0; i < Sp.studio.jsValues.availableTagNames.length; i++) {
            contactTagNames.push({value: Sp.studio.jsValues.availableTagNames[i]});
        }

        contactTagNames = $.unique(contactTagNames);

        // Use Bloodhound for tags autocompletion.
        var tagsEngine = new Bloodhound({
            name: 'tags',
            local: contactTagNames,
            datumTokenizer: function (d) {
                return Bloodhound.tokenizers.whitespace(d.value);
            },
            queryTokenizer: Bloodhound.tokenizers.whitespace
        });

        tagsEngine.initialize();

        tagsInput.tokenfield({
            createTokensOnBlur: true,
            typeahead: [{
                hint: false
            },{
                source: tagsEngine.ttAdapter()
            }]
        });

        // Called before a tag is added.
        tagsInput.on('tokenfield:createtoken', function(event) {
            // We can't add tags for Contacts being duplicated.  They'll
            // be handled upon POST.  Same for new Contacts.
            if (that.jsValues.isNew === true ||
                that.jsValues.isDuplicate === true
            ) {
                return;
            }

            var newTag = event.attrs.value;
            var tagsInField = $(this).tokenfield('getTokens');

            // If the tag already exists on the Contact, return false
            // so it can't be added again.  We do this in a case-insensitive
            // manner, because tags are scrubbed for case-insensitive uniqueness
            // on the server-side anyway.
            $.each(tagsInField, function(index, token) {
                if (token.value.toLowerCase() === newTag.toLowerCase()) {
                    $('#tags-tokenfield').val('');
                    event.preventDefault();
                    return false;
                }
            });

            // If the incoming tag is already present on the Contact's
            // tags, don't attempt to add it again on the server-side.
            // This is helpful at initial page load time.
            if (Sp.studio.jsValues.contactTags !== undefined) {
                for (var i = 0; i < Sp.studio.jsValues.contactTags.length; i++) {
                    if (Sp.studio.jsValues.contactTags[i].tag_name === newTag) {
                        return;
                    }
                }
            }

            if (!autosave) {
                return;
            }

            $.post(that.studioPanelUri('/contact/addtag/' + that.jsValues.contactId), {
                tagName: newTag
            },
            function (data) {
                // Reset the array of tags on the page to the set
                // that was returned in the response.
                that.jsValues.contactTags = data;
            },
            'json');
        });

        tagsInput.on('tokenfield:removetoken', function(event) {
            // We can't do anything witih a new Contact before it's been
            // saved, or if we're been asked not to auto-save Contact tags.
            if (contactId === null || !autosave) {
                return;
            }

            var tagToRemove = event.attrs.value;

            $.post(that.studioPanelUri('/contact/removetag/' + contactId), {
                tagName: tagToRemove
            },
            function (data) {
                // Reset the array of tags on the page to the set
                // that was returned in the response.
                that.jsValues.contactTags = data;
            },
            'json');
        });
    },

    setupNotificationDismissal: function (
        containerSelector,
        templateSelector,
        emptyStateTemplateSelector,
        numRecentToLoad
    ) {
        var that = this;

        $('body').on('click', '.js-dismiss-notification', function (e) {
            e.stopPropagation();

            var notificationDiv = $(this).parents('.notification-item');
            var notificationId = $(notificationDiv).data('notificationId');

            $.ajax({
                url: that.studioPanelUri('/notification/dismiss'),
                type: 'POST',
                data: {
                    id: notificationId,
                    num_recent: numRecentToLoad
                },
                success: function (json) {
                    if (json.status === 'success') {

                        // This call will empty the container, and redraw
                        // the new Notifications within it.
                        if (templateSelector !== undefined) {
                            that.renderNotificationsInContainer(
                                json.recentNotifications.notifications,
                                containerSelector,
                                templateSelector,
                                emptyStateTemplateSelector
                            );
                        } else {
                            // If we don't have a template to redraw
                            // Notifications with, just remove the DIV from
                            // the DOM, and handle an emtpy group.

                            // If this Notifications is within a group that
                            // now has no Notification items within in it,
                            // remove the group altogether below.
                            var parentNotificationsGroup =
                                $(notificationDiv).parents('div.notifications-group');

                            // Once we have a reference to the grouping, if
                            // present, we can delete the Notification item.
                            $(notificationDiv).remove();

                            if ($(parentNotificationsGroup).find('.notification-item').length === 0) {
                                $(parentNotificationsGroup).remove();
                            }

                            // If there are now no visible Notification groups
                            // on the page, show the empty state template.
                            if ($('div.notifications-group:visible').length === 0) {
                                var emptyStateHtml = $('#templateNotificationsEmptyState').html();
                                $('div.notification-groups-container').append(emptyStateHtml);

                                // If there's a "Dismiss All" button on the page,
                                // hide it.
                                $('.js-dismiss-all-notifications').hide();
                            }
                        }

                        // Finally, update the formatted count in the top nav.
                        if (json.recentNotifications.num_total === 0) {
                            $('div.notification-counter').remove();
                        } else {
                            $('.notification-count').text(json.recentNotifications.num_total_short_format);
                        }
                    } else {
                        that.hoverMessage.show(
                            json.msg,
                            json.status
                        );
                    }
                }
            });
        });
    },

    displayFormErrors: function (container, formErrors) {
        $(container).find('ul.form-error').remove();

        var formElementId, objKey;
        for (formElementId in formErrors) {
            for (objKey in formErrors[formElementId]) {
                var msg = formErrors[formElementId][objKey];
                var formElement = $(container).find('#' + formElementId);

                // append to the end of the parent container
                $(formElement)
                    .parents('.form-group')
                    .addClass('has-error')
                    .append('<ul class="form-error list-unstyled"><li>' + msg + '</li></ul>');
            }
        }
    },

    initCoachMarks: function (coachMarks, inModal) {
        var that = this;
        this.coachMarks = coachMarks;
        var pos, mark, elementId, top, left, width, height;
        var beaconAdjust = 20;

        inModal = (typeof(inModal) !== 'undefined' && inModal !== '') ? inModal : false;

        for (var i in coachMarks) {
            mark = coachMarks[i];
            elementId = 'coackMark' + mark.id;

            if (mark.loaded) {

                if ($(mark.anchor_selector).is(':visible')) {
                    $('#' + elementId).show()
                } else {
                    $('#' + elementId).hide();

                    // hide the popover if it is open
                    $('.popover.in').popover('hide');
                }

                continue;
            }

            if (!$(mark.anchor_selector).length || !$(mark.anchor_selector).is(':visible')) {
                continue;
            }

            pos = $(mark.anchor_selector).offset();
            width = $(mark.anchor_selector).width();
            height = $(mark.anchor_selector).height();

            top = 0;
            left = 0;

            switch (mark.gravity) {
                case 1:
                    // top left
                    top = pos.top - beaconAdjust;
                    left = pos.left - beaconAdjust;
                    break;

                case 2:
                    // top center
                    top = pos.top - beaconAdjust;
                    left = pos.left + (width / 2) - beaconAdjust;
                    break;

                case 3:
                    // top right
                    top = pos.top - beaconAdjust;
                    left = pos.left + width - beaconAdjust;
                    break;

                case 4:
                    // middle left
                    top = pos.top + (height / 2) - beaconAdjust;
                    left = pos.left - beaconAdjust;
                    break;

                case 5:
                    // middle center
                    top = pos.top + (height / 2) - beaconAdjust;
                    left = pos.left + (width / 2) - beaconAdjust;
                    break;

                case 6:
                    // middle right
                    top = pos.top + (height / 2) - beaconAdjust;
                    left = pos.left + width - beaconAdjust;
                    break;

                case 7:
                    // bottom left
                    top = pos.top + height - beaconAdjust;
                    left = pos.left - beaconAdjust;
                    break;

                case 8:
                    // bottom center
                    top = pos.top + height - beaconAdjust;
                    left = pos.left + (width / 2) - beaconAdjust;
                    break;

                case 9:
                    // bottom right
                    top = pos.top + height - beaconAdjust;
                    left = pos.left + width - beaconAdjust;
                    break;
            }

            $('<div id="' + elementId + '" class="coach-mark-beacon ' + ((inModal) ? 'in-modal' : null) + '" data-coach-mark-id="' + mark.id + '"></div>').css({
                top: top,
                left: left
            }).appendTo('body');

            $('#' + elementId).popover({
                container: 'body',
                placement: 'auto',
                content: mark.description + '<p class="text-right delete-row"><a href="#" class="delete-coach-mark" data-coach-mark-id="' + mark.id + '">' + mark.button_label + '</a></p>',
                template: '<div class="popover coach-mark" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
                html: true,
                title: mark.title,
                trigger: 'focus click',
                viewport: {
                    selector: 'body',
                    padding: 10
                }
            });

            mark.loaded = true;
            that.coachMarks[Sp.getObjectIndex(mark.id, that.coachMarks)] = mark;
        }

        $('body').on('click', 'a.delete-coach-mark', function(e) {
            e.preventDefault();
            var id = $(this).data('coachMarkId');
            $(this).parents('.popover.coach-mark').popover('hide');
            $('body [data-coach-mark-id="' + id + '"]').remove();

            $.post(that.studioPanelUri('/support/deletecoachmark'), {
                id: id
            }, function () {
            }, 'json');
        });
    },

    watchCountryStateField: function (options) {
        var defaults = {
            citySelector: '',
            stateDropdownSelector: '',
            stateOtherSelector: '',
            countrySelector: '',
            zipCodeSelector: '',
            zipCodeFieldNames: {},
            cityFieldNames: {},
            selectedStateId: '',
            selectedCountryId: ''
        };
        options = $.extend(defaults, options);

        var allSelectOptions = [];

        $(options.stateDropdownSelector + ' option').each(function () {

            if ($(this).val() === '') {
                return;
            }

            var pieces = $(this).val().split('_');

            allSelectOptions.push({
                label: $(this).text(),
                value: $(this).val(),
                country: pieces[0]
            });
        });

        // country change
        $(options.countrySelector).change(function () {
            updateStateFieldValues($(this).val());
        });

        var updateStateFieldValues = function (countryVal) {
            $(options.stateDropdownSelector).empty();
            var count = 0;
            var optionSelected = false;

            for (var i = 0; i < allSelectOptions.length; i++) {
                if (allSelectOptions[i].country == countryVal) {

                    var selected = false;

                    if (options.selectedStateId == allSelectOptions[i].value) {
                        selected = true;
                        optionSelected = true;
                    }

                    $(options.stateDropdownSelector).append($('<option></option>')
                        .attr('value', allSelectOptions[i].value)
                        .attr('selected', selected)
                        .text(allSelectOptions[i].label));

                    count++;
                }
            }

            if (count > 0) {
                var chooseText = 'State / Province';

                $(options.stateOtherSelector).parents('.form-group').hide();
                $(options.stateOtherSelector).val('');
                $(options.stateDropdownSelector).parents('.form-group').show();
                $(options.stateDropdownSelector).prepend($('<option></option>')
                    .attr('value', '')
                    .attr('selected', ((!optionSelected) ? true: false))
                    .text('- ' + chooseText + ' -'));

            } else if (jQuery.inArray(countryVal, options.countryNoState) > -1) {
                $(options.stateDropdownSelector).parents('.form-group').hide();
                $(options.stateOtherSelector).parents('.form-group').hide();
            } else {
                $(options.stateDropdownSelector).parents('.form-group').hide();
                $(options.stateOtherSelector).parents('.form-group').show();
            }

            $(options.stateDropdownSelector).select2('destroy');
            $(options.stateDropdownSelector).select2();

            // Internationalize city names
            if (options.cityFieldNames.hasOwnProperty(countryVal)) {
                $(options.citySelector).parents('.form-group').find('label').text(options.cityFieldNames[countryVal] + ' *');
            } else {
                $(options.citySelector).parents('.form-group').find('label').text('City *');
            }
        };

        updateStateFieldValues($(options.countrySelector).val());
    },

    creditCardNumberFormat: function creditCardNumberFormat(cardNumberString) {
        var cardType = this.getCardType(cardNumberString);

        if (typeof cardType !== 'string') {
            return cardNumberString;
        }

        switch (cardType) {
        case 'amex':
            return cardNumberString
                .match(/^([0-9]{1,4})?([0-9]{1,6})?([0-9]{1,5})?/)
                .slice(1, 4)
                .join(' ')
                .trim();
        default:
            return cardNumberString
                .match(/^([0-9]{1,4}){1,4}/g)[0]
                .match(/[0-9]{1,4}/g)
                .join(' ');
        }
    },

    getCardType: function getCardType(creditCardNumber) {
        var CCV_PROVIDER_TAGS = {
            AMEX: ['34', '37'],
            DISCOVER: [
                '6011',
                '622126',
                '622127',
                '622128',
                '622129',
                '62213',
                '62214',
                '62215',
                '62216',
                '62217',
                '62218',
                '62219',
                '6222',
                '6223',
                '6224',
                '6225',
                '6226',
                '6227',
                '6228',
                '62290',
                '62291',
                '622920',
                '622921',
                '622922',
                '622923',
                '622924',
                '622925',
                '644',
                '645',
                '646',
                '647',
                '648',
                '649',
                '65'
            ],
            MASTERCARD: [
                '51',
                '52',
                '53',
                '54',
                '55',
                '2221',
                '2222',
                '2223',
                '2224',
                '2225',
                '2226',
                '2227',
                '2228',
                '2229',
                '223',
                '224',
                '225',
                '226',
                '227',
                '228',
                '229',
                '23',
                '24',
                '25',
                '26',
                '2700',
                '2710',
                '2720'
            ],
            VISA: ['4']
        };

        var cardType = false;

        if (!creditCardNumber) {
            return cardType;
        }

        switch (creditCardNumber[0]) {
        case '3':
            if (creditCardNumberStartsWithCCVProviderTag(CCV_PROVIDER_TAGS.AMEX)) {
                cardType = 'amex';
            }

            break;
        case '6':
            if (creditCardNumberStartsWithCCVProviderTag(CCV_PROVIDER_TAGS.DISCOVER)) {
                cardType = 'discover';
            }

            break;
        case '2':
        case '5':
            if (creditCardNumberStartsWithCCVProviderTag(CCV_PROVIDER_TAGS.MASTERCARD)) {
                cardType = 'mastercard';
            }

            break;
        case '4':
            if (creditCardNumberStartsWithCCVProviderTag(CCV_PROVIDER_TAGS.VISA)) {
                cardType = 'visa';
            }

            break;
        }

        return cardType;

        function creditCardNumberStartsWithCCVProviderTag(ccvProviderTags) {
            return ccvProviderTags.reduce(function withCCVProviderTag(isMatch, ccvProviderTag) {
                return isMatch || creditCardNumber.indexOf(ccvProviderTag) === 0;
            }, false);
        }
    },

    updateCardOnFile: async (formValues) => {
        Sp.studio.updateAnalyticsDataLayer({
            subscriberEmail: Sp.userEmail
        });

        $('<form>', {
            action: '/v2/' + Sp.studio.brandId + '/account/creditcard',
            method: 'POST'
        })
            .append(
                createHiddenInput('cc_num', formValues.creditCardNumber),
                createHiddenInput('cc_cvs', formValues.cvv),
                createHiddenInput('exp_month', formValues.month),
                createHiddenInput('exp_year', formValues.year),
                createHiddenInput('payment_method_nonce', await formValues.paymentMethodNonce()),
                createHiddenInput('token', $('#credit-card-form-token input[name="token"]').val()),
                createHiddenInput('zip_postal', formValues.postalCode)
            )
            .appendTo('body')
            .submit();

        function createHiddenInput(name, value) {
            return $('<input>', { type: 'hidden', name: name, value: value });
        }
    },

    validateCvvCode: function validateCvvCode(cardNumberString, cvvCodeString) {
        if (typeof cvvCodeString !== 'string' ||
            typeof cardNumberString !== 'string') {
            return false;
        }

        var cardType = this.getCardType(cardNumberString);
        var targetLength = 3;

        if (cardType === 'amex') {
            targetLength = 4;
        }

        if (cvvCodeString.length === targetLength) {
            return true;
        }

        return false;
    },

    handleCookiePolicy: function handleCookiePolicy() {

        if (!this.isSubjectToGdpr || window.location.pathname === '/legal/cookie-policy') {
            return;
        }

        var cookieName = 'cpa';

        if (!$.cookie(cookieName)) {
            $('#cookie-policy').fadeIn();

            $('#cookie-policy .accept').click(() => {
                $.cookie(cookieName, '1', {
                    expires: new Date('2038-12-31T23:59:59+00:00'),
                    secure: true
                });

                $('#cookie-policy').fadeOut();
            });
        }
    },
};

function handleSendVerificationEmail({ challengeLink }) {
    return () => {
        $('#creditCardFormMessage').remove();

        $.get(challengeLink)
            .success(() => {
                $('#pageHeaderTitle').after(
                    $(`
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div id="creditCardFormMessage" class="alert alert-success">Verification email was sent. Check your inbox.</div>
                                </div>
                            </div>
                        </div>
                    `)
                );
            })
            .error(() => {
                $('#pageHeaderTitle').after(
                    $(`
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div id="creditCardFormMessage" class="alert alert-danger">There was an error sending the verification email. Please try again.</div>
                                </div>
                            </div>
                        </div>
                    `)
                );
            });
    }
}

function showReplaceImageModal(thisInstance, { orderPhotoId, originalDimensions, filename, thumbnailUrl }) {
    thisInstance.modal({
        title: 'Replace Image',
        body: window._.template($('#templateReplacePhoto').html(), {
            filename,
            thumbnailUrl,
            originalDimensions: originalDimensions.split(',')
        }),
        open: function onModalOpen() {
            const modalId = this.id;

            $('#' + modalId).find(':file').on('change', function onFileChange() {
                const files = this.files;
                const hasValidFileExtensions = Array.from(files).every(file => (/\.(jpe?g)$/i).test(file.name));

                if (!hasValidFileExtensions) {
                    return;
                }

                thisInstance.loading('Uploading', 'show');

                const formData = new FormData();

                formData.append('order_photo_id', orderPhotoId);
                formData.append('file', files[0]);

                $.ajax({
                    url: thisInstance.studioPanelCsrfWrapper(thisInstance.studioPanelUri('/order/replacephoto'), 'order_replacephoto'),
                    cache: false,
                    contentType: false,
                    dataType: 'json',
                    processData: false,
                    async: true,
                    data: formData,
                    type: 'post',
                    success: () => {
                        location.reload();
                    }
                });
            });
        },
        buttons: [{
            label: 'Cancel',
            close: true
        }]
    });
}

/* -------- studio_react_bridge/build.js -------- */
(()=>{var e,t,n={7936:(e,t,n)=>{"use strict";n.d(t,{BN:()=>v,ER:()=>y,Ej:()=>b,RK:()=>l,UE:()=>s,UU:()=>c,__:()=>i,cY:()=>g,jD:()=>p,mG:()=>h,rD:()=>a});var r=n(80692);function o(e,t,n){let{reference:o,floating:i}=e;const a=(0,r.TV)(t),s=(0,r.Dz)(t),l=(0,r.sq)(s),c=(0,r.C0)(t),u="y"===a,d=o.x+o.width/2-i.width/2,p=o.y+o.height/2-i.height/2,f=o[l]/2-i[l]/2;let h;switch(c){case"top":h={x:d,y:o.y-i.height};break;case"bottom":h={x:d,y:o.y+o.height};break;case"right":h={x:o.x+o.width,y:p};break;case"left":h={x:o.x-i.width,y:p};break;default:h={x:o.x,y:o.y}}switch((0,r.Sg)(t)){case"start":h[s]-=f*(n&&u?-1:1);break;case"end":h[s]+=f*(n&&u?-1:1)}return h}async function i(e,t){var n;void 0===t&&(t={});const{x:o,y:i,platform:a,rects:s,elements:l,strategy:c}=e,{boundary:u="clippingAncestors",rootBoundary:d="viewport",elementContext:p="floating",altBoundary:f=!1,padding:h=0}=(0,r._3)(t,e),m=(0,r.nI)(h),g=l[f?"floating"===p?"reference":"floating":p],v=(0,r.B1)(await a.getClippingRect({element:null==(n=await(null==a.isElement?void 0:a.isElement(g)))||n?g:g.contextElement||await(null==a.getDocumentElement?void 0:a.getDocumentElement(l.floating)),boundary:u,rootBoundary:d,strategy:c})),y="floating"===p?{x:o,y:i,width:s.floating.width,height:s.floating.height}:s.reference,b=await(null==a.getOffsetParent?void 0:a.getOffsetParent(l.floating)),_=await(null==a.isElement?void 0:a.isElement(b))&&await(null==a.getScale?void 0:a.getScale(b))||{x:1,y:1},A=(0,r.B1)(a.convertOffsetParentRelativeRectToViewportRelativeRect?await a.convertOffsetParentRelativeRectToViewportRelativeRect({elements:l,rect:y,offsetParent:b,strategy:c}):y);return{top:(v.top-A.top+m.top)/_.y,bottom:(A.bottom-v.bottom+m.bottom)/_.y,left:(v.left-A.left+m.left)/_.x,right:(A.right-v.right+m.right)/_.x}}const a=async(e,t,n)=>{const{placement:r="bottom",strategy:a="absolute",middleware:s=[],platform:l}=n,c=l.detectOverflow?l:{...l,detectOverflow:i},u=await(null==l.isRTL?void 0:l.isRTL(t));let d=await l.getElementRects({reference:e,floating:t,strategy:a}),{x:p,y:f}=o(d,r,u),h=r,m=0;const g={};for(let n=0;n<s.length;n++){const i=s[n];if(!i)continue;const{name:v,fn:y}=i,{x:b,y:_,data:A,reset:E}=await y({x:p,y:f,initialPlacement:r,placement:h,strategy:a,middlewareData:g,rects:d,platform:c,elements:{reference:e,floating:t}});p=null!=b?b:p,f=null!=_?_:f,g[v]={...g[v],...A},E&&m<50&&(m++,"object"==typeof E&&(E.placement&&(h=E.placement),E.rects&&(d=!0===E.rects?await l.getElementRects({reference:e,floating:t,strategy:a}):E.rects),({x:p,y:f}=o(d,h,u))),n=-1)}return{x:p,y:f,placement:h,strategy:a,middlewareData:g}},s=e=>({name:"arrow",options:e,async fn(t){const{x:n,y:o,placement:i,rects:a,platform:s,elements:l,middlewareData:c}=t,{element:u,padding:d=0}=(0,r._3)(e,t)||{};if(null==u)return{};const p=(0,r.nI)(d),f={x:n,y:o},h=(0,r.Dz)(i),m=(0,r.sq)(h),g=await s.getDimensions(u),v="y"===h,y=v?"top":"left",b=v?"bottom":"right",_=v?"clientHeight":"clientWidth",A=a.reference[m]+a.reference[h]-f[h]-a.floating[m],E=f[h]-a.reference[h],w=await(null==s.getOffsetParent?void 0:s.getOffsetParent(u));let x=w?w[_]:0;x&&await(null==s.isElement?void 0:s.isElement(w))||(x=l.floating[_]||a.floating[m]);const k=A/2-E/2,C=x/2-g[m]/2-1,S=(0,r.jk)(p[y],C),M=(0,r.jk)(p[b],C),T=S,O=x-g[m]-M,D=x/2-g[m]/2+k,L=(0,r.qE)(T,D,O),P=!c.arrow&&null!=(0,r.Sg)(i)&&D!==L&&a.reference[m]/2-(D<T?S:M)-g[m]/2<0,I=P?D<T?D-T:D-O:0;return{[h]:f[h]+I,data:{[h]:L,centerOffset:D-L-I,...P&&{alignmentOffset:I}},reset:P}}});const l=function(e){return void 0===e&&(e={}),{name:"autoPlacement",options:e,async fn(t){var n,o,i;const{rects:a,middlewareData:s,placement:l,platform:c,elements:u}=t,{crossAxis:d=!1,alignment:p,allowedPlacements:f=r.DD,autoAlignment:h=!0,...m}=(0,r._3)(e,t),g=void 0!==p||f===r.DD?function(e,t,n){return(e?[...n.filter((t=>(0,r.Sg)(t)===e)),...n.filter((t=>(0,r.Sg)(t)!==e))]:n.filter((e=>(0,r.C0)(e)===e))).filter((n=>!e||(0,r.Sg)(n)===e||!!t&&(0,r.aD)(n)!==n))}(p||null,h,f):f,v=await c.detectOverflow(t,m),y=(null==(n=s.autoPlacement)?void 0:n.index)||0,b=g[y];if(null==b)return{};const _=(0,r.w7)(b,a,await(null==c.isRTL?void 0:c.isRTL(u.floating)));if(l!==b)return{reset:{placement:g[0]}};const A=[v[(0,r.C0)(b)],v[_[0]],v[_[1]]],E=[...(null==(o=s.autoPlacement)?void 0:o.overflows)||[],{placement:b,overflows:A}],w=g[y+1];if(w)return{data:{index:y+1,overflows:E},reset:{placement:w}};const x=E.map((e=>{const t=(0,r.Sg)(e.placement);return[e.placement,t&&d?e.overflows.slice(0,2).reduce(((e,t)=>e+t),0):e.overflows[0],e.overflows]})).sort(((e,t)=>e[1]-t[1])),k=(null==(i=x.filter((e=>e[2].slice(0,(0,r.Sg)(e[0])?2:3).every((e=>e<=0))))[0])?void 0:i[0])||x[0][0];return k!==l?{data:{index:y+1,overflows:E},reset:{placement:k}}:{}}}},c=function(e){return void 0===e&&(e={}),{name:"flip",options:e,async fn(t){var n,o;const{placement:i,middlewareData:a,rects:s,initialPlacement:l,platform:c,elements:u}=t,{mainAxis:d=!0,crossAxis:p=!0,fallbackPlacements:f,fallbackStrategy:h="bestFit",fallbackAxisSideDirection:m="none",flipAlignment:g=!0,...v}=(0,r._3)(e,t);if(null!=(n=a.arrow)&&n.alignmentOffset)return{};const y=(0,r.C0)(i),b=(0,r.TV)(l),_=(0,r.C0)(l)===l,A=await(null==c.isRTL?void 0:c.isRTL(u.floating)),E=f||(_||!g?[(0,r.bV)(l)]:(0,r.WJ)(l)),w="none"!==m;!f&&w&&E.push(...(0,r.lP)(l,g,m,A));const x=[l,...E],k=await c.detectOverflow(t,v),C=[];let S=(null==(o=a.flip)?void 0:o.overflows)||[];if(d&&C.push(k[y]),p){const e=(0,r.w7)(i,s,A);C.push(k[e[0]],k[e[1]])}if(S=[...S,{placement:i,overflows:C}],!C.every((e=>e<=0))){var M,T;const e=((null==(M=a.flip)?void 0:M.index)||0)+1,t=x[e];if(t){if(!("alignment"===p&&b!==(0,r.TV)(t))||S.every((e=>(0,r.TV)(e.placement)!==b||e.overflows[0]>0)))return{data:{index:e,overflows:S},reset:{placement:t}}}let n=null==(T=S.filter((e=>e.overflows[0]<=0)).sort(((e,t)=>e.overflows[1]-t.overflows[1]))[0])?void 0:T.placement;if(!n)switch(h){case"bestFit":{var O;const e=null==(O=S.filter((e=>{if(w){const t=(0,r.TV)(e.placement);return t===b||"y"===t}return!0})).map((e=>[e.placement,e.overflows.filter((e=>e>0)).reduce(((e,t)=>e+t),0)])).sort(((e,t)=>e[1]-t[1]))[0])?void 0:O[0];e&&(n=e);break}case"initialPlacement":n=l}if(i!==n)return{reset:{placement:n}}}return{}}}};function u(e,t){return{top:e.top-t.height,right:e.right-t.width,bottom:e.bottom-t.height,left:e.left-t.width}}function d(e){return r.r_.some((t=>e[t]>=0))}const p=function(e){return void 0===e&&(e={}),{name:"hide",options:e,async fn(t){const{rects:n,platform:o}=t,{strategy:i="referenceHidden",...a}=(0,r._3)(e,t);switch(i){case"referenceHidden":{const e=u(await o.detectOverflow(t,{...a,elementContext:"reference"}),n.reference);return{data:{referenceHiddenOffsets:e,referenceHidden:d(e)}}}case"escaped":{const e=u(await o.detectOverflow(t,{...a,altBoundary:!0}),n.floating);return{data:{escapedOffsets:e,escaped:d(e)}}}default:return{}}}}};function f(e){const t=(0,r.jk)(...e.map((e=>e.left))),n=(0,r.jk)(...e.map((e=>e.top)));return{x:t,y:n,width:(0,r.T9)(...e.map((e=>e.right)))-t,height:(0,r.T9)(...e.map((e=>e.bottom)))-n}}const h=function(e){return void 0===e&&(e={}),{name:"inline",options:e,async fn(t){const{placement:n,elements:o,rects:i,platform:a,strategy:s}=t,{padding:l=2,x:c,y:u}=(0,r._3)(e,t),d=Array.from(await(null==a.getClientRects?void 0:a.getClientRects(o.reference))||[]),p=function(e){const t=e.slice().sort(((e,t)=>e.y-t.y)),n=[];let o=null;for(let e=0;e<t.length;e++){const r=t[e];!o||r.y-o.y>o.height/2?n.push([r]):n[n.length-1].push(r),o=r}return n.map((e=>(0,r.B1)(f(e))))}(d),h=(0,r.B1)(f(d)),m=(0,r.nI)(l);const g=await a.getElementRects({reference:{getBoundingClientRect:function(){if(2===p.length&&p[0].left>p[1].right&&null!=c&&null!=u)return p.find((e=>c>e.left-m.left&&c<e.right+m.right&&u>e.top-m.top&&u<e.bottom+m.bottom))||h;if(p.length>=2){if("y"===(0,r.TV)(n)){const e=p[0],t=p[p.length-1],o="top"===(0,r.C0)(n),i=e.top,a=t.bottom,s=o?e.left:t.left,l=o?e.right:t.right;return{top:i,bottom:a,left:s,right:l,width:l-s,height:a-i,x:s,y:i}}const e="left"===(0,r.C0)(n),t=(0,r.T9)(...p.map((e=>e.right))),o=(0,r.jk)(...p.map((e=>e.left))),i=p.filter((n=>e?n.left===o:n.right===t)),a=i[0].top,s=i[i.length-1].bottom;return{top:a,bottom:s,left:o,right:t,width:t-o,height:s-a,x:o,y:a}}return h}},floating:o.floating,strategy:s});return i.reference.x!==g.reference.x||i.reference.y!==g.reference.y||i.reference.width!==g.reference.width||i.reference.height!==g.reference.height?{reset:{rects:g}}:{}}}},m=new Set(["left","top"]);const g=function(e){return void 0===e&&(e=0),{name:"offset",options:e,async fn(t){var n,o;const{x:i,y:a,placement:s,middlewareData:l}=t,c=await async function(e,t){const{placement:n,platform:o,elements:i}=e,a=await(null==o.isRTL?void 0:o.isRTL(i.floating)),s=(0,r.C0)(n),l=(0,r.Sg)(n),c="y"===(0,r.TV)(n),u=m.has(s)?-1:1,d=a&&c?-1:1,p=(0,r._3)(t,e);let{mainAxis:f,crossAxis:h,alignmentAxis:g}="number"==typeof p?{mainAxis:p,crossAxis:0,alignmentAxis:null}:{mainAxis:p.mainAxis||0,crossAxis:p.crossAxis||0,alignmentAxis:p.alignmentAxis};return l&&"number"==typeof g&&(h="end"===l?-1*g:g),c?{x:h*d,y:f*u}:{x:f*u,y:h*d}}(t,e);return s===(null==(n=l.offset)?void 0:n.placement)&&null!=(o=l.arrow)&&o.alignmentOffset?{}:{x:i+c.x,y:a+c.y,data:{...c,placement:s}}}}},v=function(e){return void 0===e&&(e={}),{name:"shift",options:e,async fn(t){const{x:n,y:o,placement:i,platform:a}=t,{mainAxis:s=!0,crossAxis:l=!1,limiter:c={fn:e=>{let{x:t,y:n}=e;return{x:t,y:n}}},...u}=(0,r._3)(e,t),d={x:n,y:o},p=await a.detectOverflow(t,u),f=(0,r.TV)((0,r.C0)(i)),h=(0,r.PG)(f);let m=d[h],g=d[f];if(s){const e="y"===h?"bottom":"right",t=m+p["y"===h?"top":"left"],n=m-p[e];m=(0,r.qE)(t,m,n)}if(l){const e="y"===f?"bottom":"right",t=g+p["y"===f?"top":"left"],n=g-p[e];g=(0,r.qE)(t,g,n)}const v=c.fn({...t,[h]:m,[f]:g});return{...v,data:{x:v.x-n,y:v.y-o,enabled:{[h]:s,[f]:l}}}}}},y=function(e){return void 0===e&&(e={}),{options:e,fn(t){const{x:n,y:o,placement:i,rects:a,middlewareData:s}=t,{offset:l=0,mainAxis:c=!0,crossAxis:u=!0}=(0,r._3)(e,t),d={x:n,y:o},p=(0,r.TV)(i),f=(0,r.PG)(p);let h=d[f],g=d[p];const v=(0,r._3)(l,t),y="number"==typeof v?{mainAxis:v,crossAxis:0}:{mainAxis:0,crossAxis:0,...v};if(c){const e="y"===f?"height":"width",t=a.reference[f]-a.floating[e]+y.mainAxis,n=a.reference[f]+a.reference[e]-y.mainAxis;h<t?h=t:h>n&&(h=n)}if(u){var b,_;const e="y"===f?"width":"height",t=m.has((0,r.C0)(i)),n=a.reference[p]-a.floating[e]+(t&&(null==(b=s.offset)?void 0:b[p])||0)+(t?0:y.crossAxis),o=a.reference[p]+a.reference[e]+(t?0:(null==(_=s.offset)?void 0:_[p])||0)-(t?y.crossAxis:0);g<n?g=n:g>o&&(g=o)}return{[f]:h,[p]:g}}}},b=function(e){return void 0===e&&(e={}),{name:"size",options:e,async fn(t){var n,o;const{placement:i,rects:a,platform:s,elements:l}=t,{apply:c=(()=>{}),...u}=(0,r._3)(e,t),d=await s.detectOverflow(t,u),p=(0,r.C0)(i),f=(0,r.Sg)(i),h="y"===(0,r.TV)(i),{width:m,height:g}=a.floating;let v,y;"top"===p||"bottom"===p?(v=p,y=f===(await(null==s.isRTL?void 0:s.isRTL(l.floating))?"start":"end")?"left":"right"):(y=p,v="end"===f?"top":"bottom");const b=g-d.top-d.bottom,_=m-d.left-d.right,A=(0,r.jk)(g-d[v],b),E=(0,r.jk)(m-d[y],_),w=!t.middlewareData.shift;let x=A,k=E;if(null!=(n=t.middlewareData.shift)&&n.enabled.x&&(k=_),null!=(o=t.middlewareData.shift)&&o.enabled.y&&(x=b),w&&!f){const e=(0,r.T9)(d.left,0),t=(0,r.T9)(d.right,0),n=(0,r.T9)(d.top,0),o=(0,r.T9)(d.bottom,0);h?k=m-2*(0!==e||0!==t?e+t:(0,r.T9)(d.left,d.right)):x=g-2*(0!==n||0!==o?n+o:(0,r.T9)(d.top,d.bottom))}await c({...t,availableWidth:k,availableHeight:x});const C=await s.getDimensions(l.floating);return m!==C.width||g!==C.height?{reset:{rects:!0}}:{}}}}},58018:(e,t,n)=>{"use strict";n.d(t,{BN:()=>S,ER:()=>P,Ej:()=>T,RK:()=>C,UE:()=>D,UU:()=>M,__:()=>x,cY:()=>k,iD:()=>A,jD:()=>O,ll:()=>w,mG:()=>L,rD:()=>I});var r=n(80692),o=n(7936),i=n(61266);function a(e){const t=(0,i.L9)(e);let n=parseFloat(t.width)||0,o=parseFloat(t.height)||0;const a=(0,i.sb)(e),s=a?e.offsetWidth:n,l=a?e.offsetHeight:o,c=(0,r.LI)(n)!==s||(0,r.LI)(o)!==l;return c&&(n=s,o=l),{width:n,height:o,$:c}}function s(e){return(0,i.vq)(e)?e:e.contextElement}function l(e){const t=s(e);if(!(0,i.sb)(t))return(0,r.Jx)(1);const n=t.getBoundingClientRect(),{width:o,height:l,$:c}=a(t);let u=(c?(0,r.LI)(n.width):n.width)/o,d=(c?(0,r.LI)(n.height):n.height)/l;return u&&Number.isFinite(u)||(u=1),d&&Number.isFinite(d)||(d=1),{x:u,y:d}}const c=(0,r.Jx)(0);function u(e){const t=(0,i.zk)(e);return(0,i.Tc)()&&t.visualViewport?{x:t.visualViewport.offsetLeft,y:t.visualViewport.offsetTop}:c}function d(e,t,n,o){void 0===t&&(t=!1),void 0===n&&(n=!1);const a=e.getBoundingClientRect(),c=s(e);let d=(0,r.Jx)(1);t&&(o?(0,i.vq)(o)&&(d=l(o)):d=l(e));const p=function(e,t,n){return void 0===t&&(t=!1),!(!n||t&&n!==(0,i.zk)(e))&&t}(c,n,o)?u(c):(0,r.Jx)(0);let f=(a.left+p.x)/d.x,h=(a.top+p.y)/d.y,m=a.width/d.x,g=a.height/d.y;if(c){const e=(0,i.zk)(c),t=o&&(0,i.vq)(o)?(0,i.zk)(o):o;let n=e,r=(0,i._m)(n);for(;r&&o&&t!==n;){const e=l(r),t=r.getBoundingClientRect(),o=(0,i.L9)(r),a=t.left+(r.clientLeft+parseFloat(o.paddingLeft))*e.x,s=t.top+(r.clientTop+parseFloat(o.paddingTop))*e.y;f*=e.x,h*=e.y,m*=e.x,g*=e.y,f+=a,h+=s,n=(0,i.zk)(r),r=(0,i._m)(n)}}return(0,r.B1)({width:m,height:g,x:f,y:h})}function p(e,t){const n=(0,i.CP)(e).scrollLeft;return t?t.left+n:d((0,i.ep)(e)).left+n}function f(e,t){const n=e.getBoundingClientRect();return{x:n.left+t.scrollLeft-p(e,n),y:n.top+t.scrollTop}}const h=25;function m(e,t,n){let o;if("viewport"===t)o=function(e,t){const n=(0,i.zk)(e),r=(0,i.ep)(e),o=n.visualViewport;let a=r.clientWidth,s=r.clientHeight,l=0,c=0;if(o){a=o.width,s=o.height;const e=(0,i.Tc)();(!e||e&&"fixed"===t)&&(l=o.offsetLeft,c=o.offsetTop)}const u=p(r);if(u<=0){const e=r.ownerDocument,t=e.body,n=getComputedStyle(t),o="CSS1Compat"===e.compatMode&&parseFloat(n.marginLeft)+parseFloat(n.marginRight)||0,i=Math.abs(r.clientWidth-t.clientWidth-o);i<=h&&(a-=i)}else u<=h&&(a+=u);return{width:a,height:s,x:l,y:c}}(e,n);else if("document"===t)o=function(e){const t=(0,i.ep)(e),n=(0,i.CP)(e),o=e.ownerDocument.body,a=(0,r.T9)(t.scrollWidth,t.clientWidth,o.scrollWidth,o.clientWidth),s=(0,r.T9)(t.scrollHeight,t.clientHeight,o.scrollHeight,o.clientHeight);let l=-n.scrollLeft+p(e);const c=-n.scrollTop;return"rtl"===(0,i.L9)(o).direction&&(l+=(0,r.T9)(t.clientWidth,o.clientWidth)-a),{width:a,height:s,x:l,y:c}}((0,i.ep)(e));else if((0,i.vq)(t))o=function(e,t){const n=d(e,!0,"fixed"===t),o=n.top+e.clientTop,a=n.left+e.clientLeft,s=(0,i.sb)(e)?l(e):(0,r.Jx)(1);return{width:e.clientWidth*s.x,height:e.clientHeight*s.y,x:a*s.x,y:o*s.y}}(t,n);else{const n=u(e);o={x:t.x-n.x,y:t.y-n.y,width:t.width,height:t.height}}return(0,r.B1)(o)}function g(e,t){const n=(0,i.$4)(e);return!(n===t||!(0,i.vq)(n)||(0,i.eu)(n))&&("fixed"===(0,i.L9)(n).position||g(n,t))}function v(e,t,n){const o=(0,i.sb)(t),a=(0,i.ep)(t),s="fixed"===n,l=d(e,!0,s,t);let c={scrollLeft:0,scrollTop:0};const u=(0,r.Jx)(0);function h(){u.x=p(a)}if(o||!o&&!s)if(("body"!==(0,i.mq)(t)||(0,i.ZU)(a))&&(c=(0,i.CP)(t)),o){const e=d(t,!0,s,t);u.x=e.x+t.clientLeft,u.y=e.y+t.clientTop}else a&&h();s&&!o&&a&&h();const m=!a||o||s?(0,r.Jx)(0):f(a,c);return{x:l.left+c.scrollLeft-u.x-m.x,y:l.top+c.scrollTop-u.y-m.y,width:l.width,height:l.height}}function y(e){return"static"===(0,i.L9)(e).position}function b(e,t){if(!(0,i.sb)(e)||"fixed"===(0,i.L9)(e).position)return null;if(t)return t(e);let n=e.offsetParent;return(0,i.ep)(e)===n&&(n=n.ownerDocument.body),n}function _(e,t){const n=(0,i.zk)(e);if((0,i.Tf)(e))return n;if(!(0,i.sb)(e)){let t=(0,i.$4)(e);for(;t&&!(0,i.eu)(t);){if((0,i.vq)(t)&&!y(t))return t;t=(0,i.$4)(t)}return n}let r=b(e,t);for(;r&&(0,i.Lv)(r)&&y(r);)r=b(r,t);return r&&(0,i.eu)(r)&&y(r)&&!(0,i.sQ)(r)?n:r||(0,i.gJ)(e)||n}const A={convertOffsetParentRelativeRectToViewportRelativeRect:function(e){let{elements:t,rect:n,offsetParent:o,strategy:a}=e;const s="fixed"===a,c=(0,i.ep)(o),u=!!t&&(0,i.Tf)(t.floating);if(o===c||u&&s)return n;let p={scrollLeft:0,scrollTop:0},h=(0,r.Jx)(1);const m=(0,r.Jx)(0),g=(0,i.sb)(o);if((g||!g&&!s)&&(("body"!==(0,i.mq)(o)||(0,i.ZU)(c))&&(p=(0,i.CP)(o)),g)){const e=d(o);h=l(o),m.x=e.x+o.clientLeft,m.y=e.y+o.clientTop}const v=!c||g||s?(0,r.Jx)(0):f(c,p);return{width:n.width*h.x,height:n.height*h.y,x:n.x*h.x-p.scrollLeft*h.x+m.x+v.x,y:n.y*h.y-p.scrollTop*h.y+m.y+v.y}},getDocumentElement:i.ep,getClippingRect:function(e){let{element:t,boundary:n,rootBoundary:o,strategy:a}=e;const s=[..."clippingAncestors"===n?(0,i.Tf)(t)?[]:function(e,t){const n=t.get(e);if(n)return n;let r=(0,i.v9)(e,[],!1).filter((e=>(0,i.vq)(e)&&"body"!==(0,i.mq)(e))),o=null;const a="fixed"===(0,i.L9)(e).position;let s=a?(0,i.$4)(e):e;for(;(0,i.vq)(s)&&!(0,i.eu)(s);){const t=(0,i.L9)(s),n=(0,i.sQ)(s);n||"fixed"!==t.position||(o=null),(a?!n&&!o:!n&&"static"===t.position&&o&&("absolute"===o.position||"fixed"===o.position)||(0,i.ZU)(s)&&!n&&g(e,s))?r=r.filter((e=>e!==s)):o=t,s=(0,i.$4)(s)}return t.set(e,r),r}(t,this._c):[].concat(n),o],l=m(t,s[0],a);let c=l.top,u=l.right,d=l.bottom,p=l.left;for(let e=1;e<s.length;e++){const n=m(t,s[e],a);c=(0,r.T9)(n.top,c),u=(0,r.jk)(n.right,u),d=(0,r.jk)(n.bottom,d),p=(0,r.T9)(n.left,p)}return{width:u-p,height:d-c,x:p,y:c}},getOffsetParent:_,getElementRects:async function(e){const t=this.getOffsetParent||_,n=this.getDimensions,r=await n(e.floating);return{reference:v(e.reference,await t(e.floating),e.strategy),floating:{x:0,y:0,width:r.width,height:r.height}}},getClientRects:function(e){return Array.from(e.getClientRects())},getDimensions:function(e){const{width:t,height:n}=a(e);return{width:t,height:n}},getScale:l,isElement:i.vq,isRTL:function(e){return"rtl"===(0,i.L9)(e).direction}};function E(e,t){return e.x===t.x&&e.y===t.y&&e.width===t.width&&e.height===t.height}function w(e,t,n,o){void 0===o&&(o={});const{ancestorScroll:a=!0,ancestorResize:l=!0,elementResize:c="function"==typeof ResizeObserver,layoutShift:u="function"==typeof IntersectionObserver,animationFrame:p=!1}=o,f=s(e),h=a||l?[...f?(0,i.v9)(f):[],...t?(0,i.v9)(t):[]]:[];h.forEach((e=>{a&&e.addEventListener("scroll",n,{passive:!0}),l&&e.addEventListener("resize",n)}));const m=f&&u?function(e,t){let n,o=null;const a=(0,i.ep)(e);function s(){var e;clearTimeout(n),null==(e=o)||e.disconnect(),o=null}return function i(l,c){void 0===l&&(l=!1),void 0===c&&(c=1),s();const u=e.getBoundingClientRect(),{left:d,top:p,width:f,height:h}=u;if(l||t(),!f||!h)return;const m={rootMargin:-(0,r.RI)(p)+"px "+-(0,r.RI)(a.clientWidth-(d+f))+"px "+-(0,r.RI)(a.clientHeight-(p+h))+"px "+-(0,r.RI)(d)+"px",threshold:(0,r.T9)(0,(0,r.jk)(1,c))||1};let g=!0;function v(t){const r=t[0].intersectionRatio;if(r!==c){if(!g)return i();r?i(!1,r):n=setTimeout((()=>{i(!1,1e-7)}),1e3)}1!==r||E(u,e.getBoundingClientRect())||i(),g=!1}try{o=new IntersectionObserver(v,{...m,root:a.ownerDocument})}catch(e){o=new IntersectionObserver(v,m)}o.observe(e)}(!0),s}(f,n):null;let g,v=-1,y=null;c&&(y=new ResizeObserver((e=>{let[r]=e;r&&r.target===f&&y&&t&&(y.unobserve(t),cancelAnimationFrame(v),v=requestAnimationFrame((()=>{var e;null==(e=y)||e.observe(t)}))),n()})),f&&!p&&y.observe(f),t&&y.observe(t));let b=p?d(e):null;return p&&function t(){const r=d(e);b&&!E(b,r)&&n();b=r,g=requestAnimationFrame(t)}(),n(),()=>{var e;h.forEach((e=>{a&&e.removeEventListener("scroll",n),l&&e.removeEventListener("resize",n)})),null==m||m(),null==(e=y)||e.disconnect(),y=null,p&&cancelAnimationFrame(g)}}const x=o.__,k=o.cY,C=o.RK,S=o.BN,M=o.UU,T=o.Ej,O=o.jD,D=o.UE,L=o.mG,P=o.ER,I=(e,t,n)=>{const r=new Map,i={platform:A,...n},a={...i.platform,_c:r};return(0,o.rD)(e,t,{...i,platform:a})}},61266:(e,t,n)=>{"use strict";function r(){return"undefined"!=typeof window}function o(e){return s(e)?(e.nodeName||"").toLowerCase():"#document"}function i(e){var t;return(null==e||null==(t=e.ownerDocument)?void 0:t.defaultView)||window}function a(e){var t;return null==(t=(s(e)?e.ownerDocument:e.document)||window.document)?void 0:t.documentElement}function s(e){return!!r()&&(e instanceof Node||e instanceof i(e).Node)}function l(e){return!!r()&&(e instanceof Element||e instanceof i(e).Element)}function c(e){return!!r()&&(e instanceof HTMLElement||e instanceof i(e).HTMLElement)}function u(e){return!(!r()||"undefined"==typeof ShadowRoot)&&(e instanceof ShadowRoot||e instanceof i(e).ShadowRoot)}function d(e){const{overflow:t,overflowX:n,overflowY:r,display:o}=E(e);return/auto|scroll|overlay|hidden|clip/.test(t+r+n)&&"inline"!==o&&"contents"!==o}function p(e){return/^(table|td|th)$/.test(o(e))}function f(e){try{if(e.matches(":popover-open"))return!0}catch(e){}try{return e.matches(":modal")}catch(e){return!1}}n.d(t,{$4:()=>x,CP:()=>w,L9:()=>E,Lv:()=>p,Ng:()=>u,Tc:()=>_,Tf:()=>f,ZU:()=>d,_m:()=>S,ep:()=>a,eu:()=>A,gJ:()=>b,mq:()=>o,sQ:()=>y,sb:()=>c,v9:()=>C,vq:()=>l,zk:()=>i});const h=/transform|translate|scale|rotate|perspective|filter/,m=/paint|layout|strict|content/,g=e=>!!e&&"none"!==e;let v;function y(e){const t=l(e)?E(e):e;return g(t.transform)||g(t.translate)||g(t.scale)||g(t.rotate)||g(t.perspective)||!_()&&(g(t.backdropFilter)||g(t.filter))||h.test(t.willChange||"")||m.test(t.contain||"")}function b(e){let t=x(e);for(;c(t)&&!A(t);){if(y(t))return t;if(f(t))return null;t=x(t)}return null}function _(){return null==v&&(v="undefined"!=typeof CSS&&CSS.supports&&CSS.supports("-webkit-backdrop-filter","none")),v}function A(e){return/^(html|body|#document)$/.test(o(e))}function E(e){return i(e).getComputedStyle(e)}function w(e){return l(e)?{scrollLeft:e.scrollLeft,scrollTop:e.scrollTop}:{scrollLeft:e.scrollX,scrollTop:e.scrollY}}function x(e){if("html"===o(e))return e;const t=e.assignedSlot||e.parentNode||u(e)&&e.host||a(e);return u(t)?t.host:t}function k(e){const t=x(e);return A(t)?e.ownerDocument?e.ownerDocument.body:e.body:c(t)&&d(t)?t:k(t)}function C(e,t,n){var r;void 0===t&&(t=[]),void 0===n&&(n=!0);const o=k(e),a=o===(null==(r=e.ownerDocument)?void 0:r.body),s=i(o);if(a){const e=S(s);return t.concat(s,s.visualViewport||[],d(o)?o:[],e&&n?C(e):[])}return t.concat(o,C(o,[],n))}function S(e){return e.parent&&Object.getPrototypeOf(e.parent)?e.frameElement:null}},80692:(e,t,n)=>{"use strict";n.d(t,{B1:()=>O,C0:()=>h,DD:()=>i,Dz:()=>b,Jx:()=>u,LI:()=>l,PG:()=>g,RI:()=>c,Sg:()=>m,T9:()=>s,TV:()=>y,WJ:()=>A,_3:()=>f,aD:()=>E,bV:()=>M,jk:()=>a,lP:()=>S,nI:()=>T,qE:()=>p,r_:()=>r,sq:()=>v,w7:()=>_});const r=["top","right","bottom","left"],o=["start","end"],i=r.reduce(((e,t)=>e.concat(t,t+"-"+o[0],t+"-"+o[1])),[]),a=Math.min,s=Math.max,l=Math.round,c=Math.floor,u=e=>({x:e,y:e}),d={left:"right",right:"left",bottom:"top",top:"bottom"};function p(e,t,n){return s(e,a(t,n))}function f(e,t){return"function"==typeof e?e(t):e}function h(e){return e.split("-")[0]}function m(e){return e.split("-")[1]}function g(e){return"x"===e?"y":"x"}function v(e){return"y"===e?"height":"width"}function y(e){const t=e[0];return"t"===t||"b"===t?"y":"x"}function b(e){return g(y(e))}function _(e,t,n){void 0===n&&(n=!1);const r=m(e),o=b(e),i=v(o);let a="x"===o?r===(n?"end":"start")?"right":"left":"start"===r?"bottom":"top";return t.reference[i]>t.floating[i]&&(a=M(a)),[a,M(a)]}function A(e){const t=M(e);return[E(e),t,E(t)]}function E(e){return e.includes("start")?e.replace("start","end"):e.replace("end","start")}const w=["left","right"],x=["right","left"],k=["top","bottom"],C=["bottom","top"];function S(e,t,n,r){const o=m(e);let i=function(e,t,n){switch(e){case"top":case"bottom":return n?t?x:w:t?w:x;case"left":case"right":return t?k:C;default:return[]}}(h(e),"start"===n,r);return o&&(i=i.map((e=>e+"-"+o)),t&&(i=i.concat(i.map(E)))),i}function M(e){const t=h(e);return d[t]+e.slice(t.length)}function T(e){return"number"!=typeof e?function(e){return{top:0,right:0,bottom:0,left:0,...e}}(e):{top:e,right:e,bottom:e,left:e}}function O(e){const{x:t,y:n,width:r,height:o}=e;return{width:r,height:o,top:n,left:t,right:t+r,bottom:n+o,x:t,y:n}}},2063:(e,t,n)=>{"use strict";n.d(t,{A:()=>s});var r=n(15516),o=n.n(r),i=n(81364),a=n.n(i)()(o());a.push([e.id,'@charset "UTF-8";\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker__navigation-icon::before {\n  border-color: #ccc;\n  border-style: solid;\n  border-width: 3px 3px 0 0;\n  content: "";\n  display: block;\n  height: 9px;\n  position: absolute;\n  top: 6px;\n  width: 9px;\n}\n.react-datepicker-wrapper {\n  display: inline-block;\n  padding: 0;\n  border: 0;\n}\n\n.react-datepicker {\n  font-family: "Helvetica Neue", helvetica, arial, sans-serif;\n  font-size: 0.8rem;\n  background-color: #fff;\n  color: #000;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  display: inline-block;\n  position: relative;\n  line-height: initial;\n}\n\n.react-datepicker--time-only .react-datepicker__time-container {\n  border-left: 0;\n}\n.react-datepicker--time-only .react-datepicker__time,\n.react-datepicker--time-only .react-datepicker__time-box {\n  border-bottom-left-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker-popper {\n  z-index: 1;\n  line-height: 0;\n}\n.react-datepicker-popper .react-datepicker__triangle {\n  stroke: #aeaeae;\n}\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {\n  fill: #f0f0f0;\n  color: #f0f0f0;\n}\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle {\n  fill: #fff;\n  color: #fff;\n}\n\n.react-datepicker__header {\n  text-align: center;\n  background-color: #f0f0f0;\n  border-bottom: 1px solid #aeaeae;\n  border-top-left-radius: 0.3rem;\n  padding: 8px 0;\n  position: relative;\n}\n.react-datepicker__header--time {\n  padding-bottom: 8px;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n.react-datepicker__header--time:not(.react-datepicker__header--time--only) {\n  border-top-left-radius: 0;\n}\n.react-datepicker__header:not(.react-datepicker__header--has-time-select) {\n  border-top-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select,\n.react-datepicker__month-year-dropdown-container--select,\n.react-datepicker__year-dropdown-container--scroll,\n.react-datepicker__month-dropdown-container--scroll,\n.react-datepicker__month-year-dropdown-container--scroll {\n  display: inline-block;\n  margin: 0 15px;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  margin-top: 0;\n  color: #000;\n  font-weight: bold;\n  font-size: 0.944rem;\n}\n\n.react-datepicker-time__header {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation {\n  align-items: center;\n  background: none;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  cursor: pointer;\n  position: absolute;\n  top: 2px;\n  padding: 0;\n  border: none;\n  z-index: 1;\n  height: 32px;\n  width: 32px;\n  text-indent: -999em;\n  overflow: hidden;\n}\n.react-datepicker__navigation--previous {\n  left: 2px;\n}\n.react-datepicker__navigation--next {\n  right: 2px;\n}\n.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n  right: 85px;\n}\n.react-datepicker__navigation--years {\n  position: relative;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.react-datepicker__navigation--years-previous {\n  top: 4px;\n}\n.react-datepicker__navigation--years-upcoming {\n  top: -4px;\n}\n.react-datepicker__navigation:hover *::before {\n  border-color: #a6a6a6;\n}\n\n.react-datepicker__navigation-icon {\n  position: relative;\n  top: -1px;\n  font-size: 20px;\n  width: 0;\n}\n.react-datepicker__navigation-icon--next {\n  left: -2px;\n}\n.react-datepicker__navigation-icon--next::before {\n  transform: rotate(45deg);\n  left: -7px;\n}\n.react-datepicker__navigation-icon--previous {\n  right: -2px;\n}\n.react-datepicker__navigation-icon--previous::before {\n  transform: rotate(225deg);\n  right: -7px;\n}\n\n.react-datepicker__month-container {\n  float: left;\n}\n\n.react-datepicker__year {\n  margin: 0.4rem;\n  text-align: center;\n}\n.react-datepicker__year-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  max-width: 180px;\n}\n.react-datepicker__year .react-datepicker__year-text {\n  display: inline-block;\n  width: 4rem;\n  margin: 2px;\n}\n\n.react-datepicker__month {\n  margin: 0.4rem;\n  text-align: center;\n}\n.react-datepicker__month .react-datepicker__month-text,\n.react-datepicker__month .react-datepicker__quarter-text {\n  display: inline-block;\n  width: 4rem;\n  margin: 2px;\n}\n\n.react-datepicker__input-time-container {\n  clear: both;\n  width: 100%;\n  float: left;\n  margin: 5px 0 10px 15px;\n  text-align: left;\n}\n.react-datepicker__input-time-container .react-datepicker-time__caption {\n  display: inline-block;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container {\n  display: inline-block;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {\n  display: inline-block;\n  margin-left: 10px;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input {\n  width: auto;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-inner-spin-button,\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time] {\n  -moz-appearance: textfield;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter {\n  margin-left: 5px;\n  display: inline-block;\n}\n\n.react-datepicker__time-container {\n  float: right;\n  border-left: 1px solid #aeaeae;\n  width: 85px;\n}\n.react-datepicker__time-container--with-today-button {\n  display: inline;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  position: absolute;\n  right: -87px;\n  top: 0;\n}\n.react-datepicker__time-container .react-datepicker__time {\n  position: relative;\n  background: white;\n  border-bottom-right-radius: 0.3rem;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {\n  width: 85px;\n  overflow-x: hidden;\n  margin: 0 auto;\n  text-align: center;\n  border-bottom-right-radius: 0.3rem;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {\n  list-style: none;\n  margin: 0;\n  height: calc(195px + 1.7rem / 2);\n  overflow-y: scroll;\n  padding-right: 0;\n  padding-left: 0;\n  width: 100%;\n  box-sizing: content-box;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {\n  height: 30px;\n  padding: 5px 10px;\n  white-space: nowrap;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {\n  cursor: pointer;\n  background-color: #f0f0f0;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #216ba5;\n  color: white;\n  font-weight: bold;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {\n  background-color: #216ba5;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {\n  color: #ccc;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {\n  cursor: default;\n  background-color: transparent;\n}\n\n.react-datepicker__week-number {\n  color: #ccc;\n  display: inline-block;\n  width: 1.7rem;\n  line-height: 1.7rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n.react-datepicker__week-number.react-datepicker__week-number--clickable {\n  cursor: pointer;\n}\n.react-datepicker__week-number.react-datepicker__week-number--clickable:not(.react-datepicker__week-number--selected,\n.react-datepicker__week-number--keyboard-selected):hover {\n  border-radius: 0.3rem;\n  background-color: #f0f0f0;\n}\n.react-datepicker__week-number--selected {\n  border-radius: 0.3rem;\n  background-color: #216ba5;\n  color: #fff;\n}\n.react-datepicker__week-number--selected:hover {\n  background-color: #1d5d90;\n}\n.react-datepicker__week-number--keyboard-selected {\n  border-radius: 0.3rem;\n  background-color: #2a87d0;\n  color: #fff;\n}\n.react-datepicker__week-number--keyboard-selected:hover {\n  background-color: #1d5d90;\n}\n\n.react-datepicker__day-names {\n  white-space: nowrap;\n  margin-bottom: -8px;\n}\n\n.react-datepicker__week {\n  white-space: nowrap;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  color: #000;\n  display: inline-block;\n  width: 1.7rem;\n  line-height: 1.7rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n\n.react-datepicker__day,\n.react-datepicker__month-text,\n.react-datepicker__quarter-text,\n.react-datepicker__year-text {\n  cursor: pointer;\n}\n.react-datepicker__day:hover,\n.react-datepicker__month-text:hover,\n.react-datepicker__quarter-text:hover,\n.react-datepicker__year-text:hover {\n  border-radius: 0.3rem;\n  background-color: #f0f0f0;\n}\n.react-datepicker__day--today,\n.react-datepicker__month-text--today,\n.react-datepicker__quarter-text--today,\n.react-datepicker__year-text--today {\n  font-weight: bold;\n}\n.react-datepicker__day--highlighted,\n.react-datepicker__month-text--highlighted,\n.react-datepicker__quarter-text--highlighted,\n.react-datepicker__year-text--highlighted {\n  border-radius: 0.3rem;\n  background-color: #3dcc4a;\n  color: #fff;\n}\n.react-datepicker__day--highlighted:hover,\n.react-datepicker__month-text--highlighted:hover,\n.react-datepicker__quarter-text--highlighted:hover,\n.react-datepicker__year-text--highlighted:hover {\n  background-color: #32be3f;\n}\n.react-datepicker__day--highlighted-custom-1,\n.react-datepicker__month-text--highlighted-custom-1,\n.react-datepicker__quarter-text--highlighted-custom-1,\n.react-datepicker__year-text--highlighted-custom-1 {\n  color: magenta;\n}\n.react-datepicker__day--highlighted-custom-2,\n.react-datepicker__month-text--highlighted-custom-2,\n.react-datepicker__quarter-text--highlighted-custom-2,\n.react-datepicker__year-text--highlighted-custom-2 {\n  color: green;\n}\n.react-datepicker__day--holidays,\n.react-datepicker__month-text--holidays,\n.react-datepicker__quarter-text--holidays,\n.react-datepicker__year-text--holidays {\n  position: relative;\n  border-radius: 0.3rem;\n  background-color: #ff6803;\n  color: #fff;\n}\n.react-datepicker__day--holidays .overlay,\n.react-datepicker__month-text--holidays .overlay,\n.react-datepicker__quarter-text--holidays .overlay,\n.react-datepicker__year-text--holidays .overlay {\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #333;\n  color: #fff;\n  padding: 4px;\n  border-radius: 4px;\n  white-space: nowrap;\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 0s, opacity 0.3s ease-in-out;\n}\n.react-datepicker__day--holidays:hover,\n.react-datepicker__month-text--holidays:hover,\n.react-datepicker__quarter-text--holidays:hover,\n.react-datepicker__year-text--holidays:hover {\n  background-color: #cf5300;\n}\n.react-datepicker__day--holidays:hover .overlay,\n.react-datepicker__month-text--holidays:hover .overlay,\n.react-datepicker__quarter-text--holidays:hover .overlay,\n.react-datepicker__year-text--holidays:hover .overlay {\n  visibility: visible;\n  opacity: 1;\n}\n.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--selected,\n.react-datepicker__year-text--in-selecting-range,\n.react-datepicker__year-text--in-range {\n  border-radius: 0.3rem;\n  background-color: #216ba5;\n  color: #fff;\n}\n.react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover,\n.react-datepicker__month-text--selected:hover,\n.react-datepicker__month-text--in-selecting-range:hover,\n.react-datepicker__month-text--in-range:hover,\n.react-datepicker__quarter-text--selected:hover,\n.react-datepicker__quarter-text--in-selecting-range:hover,\n.react-datepicker__quarter-text--in-range:hover,\n.react-datepicker__year-text--selected:hover,\n.react-datepicker__year-text--in-selecting-range:hover,\n.react-datepicker__year-text--in-range:hover {\n  background-color: #1d5d90;\n}\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n  border-radius: 0.3rem;\n  background-color: #bad9f1;\n  color: rgb(0, 0, 0);\n}\n.react-datepicker__day--keyboard-selected:hover,\n.react-datepicker__month-text--keyboard-selected:hover,\n.react-datepicker__quarter-text--keyboard-selected:hover,\n.react-datepicker__year-text--keyboard-selected:hover {\n  background-color: #1d5d90;\n}\n.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range) {\n  background-color: rgba(33, 107, 165, 0.5);\n}\n.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range), .react-datepicker__year--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__year--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__year--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__month--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__year--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range) {\n  background-color: #f0f0f0;\n  color: #000;\n}\n.react-datepicker__day--disabled,\n.react-datepicker__month-text--disabled,\n.react-datepicker__quarter-text--disabled,\n.react-datepicker__year-text--disabled {\n  cursor: default;\n  color: #ccc;\n}\n.react-datepicker__day--disabled:hover,\n.react-datepicker__month-text--disabled:hover,\n.react-datepicker__quarter-text--disabled:hover,\n.react-datepicker__year-text--disabled:hover {\n  background-color: transparent;\n}\n.react-datepicker__day--disabled .overlay,\n.react-datepicker__month-text--disabled .overlay,\n.react-datepicker__quarter-text--disabled .overlay,\n.react-datepicker__year-text--disabled .overlay {\n  position: absolute;\n  bottom: 70%;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #333;\n  color: #fff;\n  padding: 4px;\n  border-radius: 4px;\n  white-space: nowrap;\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 0s, opacity 0.3s ease-in-out;\n}\n\n.react-datepicker__input-container {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n.react-datepicker__input-container .react-datepicker__calendar-icon {\n  position: absolute;\n  padding: 0.5rem;\n  box-sizing: content-box;\n}\n\n.react-datepicker__view-calendar-icon input {\n  padding: 6px 10px 5px 25px;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n  border: 1px solid transparent;\n  border-radius: 0.3rem;\n  position: relative;\n}\n.react-datepicker__year-read-view:hover,\n.react-datepicker__month-read-view:hover,\n.react-datepicker__month-year-read-view:hover {\n  cursor: pointer;\n}\n.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {\n  border-top-color: #b3b3b3;\n}\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  transform: rotate(135deg);\n  right: -16px;\n  top: 0;\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n  background-color: #f0f0f0;\n  position: absolute;\n  width: 50%;\n  left: 25%;\n  top: 30px;\n  z-index: 1;\n  text-align: center;\n  border-radius: 0.3rem;\n  border: 1px solid #aeaeae;\n}\n.react-datepicker__year-dropdown:hover,\n.react-datepicker__month-dropdown:hover,\n.react-datepicker__month-year-dropdown:hover {\n  cursor: pointer;\n}\n.react-datepicker__year-dropdown--scrollable,\n.react-datepicker__month-dropdown--scrollable,\n.react-datepicker__month-year-dropdown--scrollable {\n  height: 150px;\n  overflow-y: scroll;\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-year-option {\n  line-height: 20px;\n  width: 100%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.react-datepicker__year-option:first-of-type,\n.react-datepicker__month-option:first-of-type,\n.react-datepicker__month-year-option:first-of-type {\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n}\n.react-datepicker__year-option:last-of-type,\n.react-datepicker__month-option:last-of-type,\n.react-datepicker__month-year-option:last-of-type {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border-bottom-left-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover {\n  background-color: #ccc;\n}\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {\n  border-bottom-color: #b3b3b3;\n}\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {\n  border-top-color: #b3b3b3;\n}\n.react-datepicker__year-option--selected,\n.react-datepicker__month-option--selected,\n.react-datepicker__month-year-option--selected {\n  position: absolute;\n  left: 15px;\n}\n\n.react-datepicker__close-icon {\n  cursor: pointer;\n  background-color: transparent;\n  border: 0;\n  outline: 0;\n  padding: 0 6px 0 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  display: table-cell;\n  vertical-align: middle;\n}\n.react-datepicker__close-icon::after {\n  cursor: pointer;\n  background-color: #216ba5;\n  color: #fff;\n  border-radius: 50%;\n  height: 16px;\n  width: 16px;\n  padding: 2px;\n  font-size: 12px;\n  line-height: 1;\n  text-align: center;\n  display: table-cell;\n  vertical-align: middle;\n  content: "×";\n}\n.react-datepicker__close-icon--disabled {\n  cursor: default;\n}\n.react-datepicker__close-icon--disabled::after {\n  cursor: default;\n  background-color: #ccc;\n}\n\n.react-datepicker__today-button {\n  background: #f0f0f0;\n  border-top: 1px solid #aeaeae;\n  cursor: pointer;\n  text-align: center;\n  font-weight: bold;\n  padding: 5px 0;\n  clear: left;\n}\n\n.react-datepicker__portal {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.8);\n  left: 0;\n  top: 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  z-index: 2147483647;\n}\n.react-datepicker__portal .react-datepicker__day-name,\n.react-datepicker__portal .react-datepicker__day,\n.react-datepicker__portal .react-datepicker__time-name {\n  width: 3rem;\n  line-height: 3rem;\n}\n@media (max-width: 400px), (max-height: 550px) {\n  .react-datepicker__portal .react-datepicker__day-name,\n  .react-datepicker__portal .react-datepicker__day,\n  .react-datepicker__portal .react-datepicker__time-name {\n    width: 2rem;\n    line-height: 2rem;\n  }\n}\n.react-datepicker__portal .react-datepicker__current-month,\n.react-datepicker__portal .react-datepicker-time__header {\n  font-size: 1.44rem;\n}\n\n.react-datepicker__children-container {\n  width: 13.8rem;\n  margin: 0.4rem;\n  padding-right: 0.2rem;\n  padding-left: 0.2rem;\n  height: auto;\n}\n\n.react-datepicker__aria-live {\n  position: absolute;\n  clip-path: circle(0);\n  border: 0;\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  width: 1px;\n  white-space: nowrap;\n}\n\n.react-datepicker__calendar-icon {\n  width: 1em;\n  height: 1em;\n  vertical-align: -0.125em;\n}\n',"",{version:3,sources:["webpack://./node_modules/react-datepicker/dist/react-datepicker.css"],names:[],mappings:"AAAA,gBAAgB;AAChB;;;EAGE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,2DAA2D;EAC3D,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;AACA;;EAEE,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,+BAA+B;AACjC;;AAEA;;;;;;EAME,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,QAAQ;AACV;AACA;EACE,SAAS;AACX;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,QAAQ;AACV;AACA;EACE,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,qBAAqB;EACrB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;;EAEE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,MAAM;AACR;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;EAIE,eAAe;AACjB;AACA;;;;EAIE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;;;;EAIE,iBAAiB;AACnB;AACA;;;;EAIE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;;;EAIE,cAAc;AAChB;AACA;;;;EAIE,YAAY;AACd;AACA;;;;EAIE,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;AACA;;;;EAIE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mDAAmD;AACrD;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;;;EAIE,mBAAmB;EACnB,UAAU;AACZ;AACA;;;;;;;;;;EAUE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;AACA;;;;;;;;;;EAUE,yBAAyB;AAC3B;AACA;;;;EAIE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;;;;;;;;;;;;;;;EAgBE,yCAAyC;AAC3C;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA+BE,yBAAyB;EACzB,WAAW;AACb;AACA;;;;EAIE,eAAe;EACf,WAAW;AACb;AACA;;;;EAIE,6BAA6B;AAC/B;AACA;;;;EAIE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;EAGE,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;AACA;;;EAGE,eAAe;AACjB;AACA;;;;;;EAME,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;EACzB,YAAY;EACZ,MAAM;AACR;;AAEA;;;EAGE,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,aAAa;EACb,kBAAkB;AACpB;;AAEA;;;EAGE,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;;EAGE,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;;;EAGE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,iCAAiC;EACjC,kCAAkC;AACpC;AACA;;;EAGE,sBAAsB;AACxB;AACA;;;EAGE,4BAA4B;AAC9B;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;;EAGE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,OAAO;EACP,MAAM;EACN,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA;;;EAGE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE;;;IAGE,WAAW;IACX,iBAAiB;EACnB;AACF;AACA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,wBAAwB;AAC1B",sourcesContent:['@charset "UTF-8";\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker__navigation-icon::before {\n  border-color: #ccc;\n  border-style: solid;\n  border-width: 3px 3px 0 0;\n  content: "";\n  display: block;\n  height: 9px;\n  position: absolute;\n  top: 6px;\n  width: 9px;\n}\n.react-datepicker-wrapper {\n  display: inline-block;\n  padding: 0;\n  border: 0;\n}\n\n.react-datepicker {\n  font-family: "Helvetica Neue", helvetica, arial, sans-serif;\n  font-size: 0.8rem;\n  background-color: #fff;\n  color: #000;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  display: inline-block;\n  position: relative;\n  line-height: initial;\n}\n\n.react-datepicker--time-only .react-datepicker__time-container {\n  border-left: 0;\n}\n.react-datepicker--time-only .react-datepicker__time,\n.react-datepicker--time-only .react-datepicker__time-box {\n  border-bottom-left-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker-popper {\n  z-index: 1;\n  line-height: 0;\n}\n.react-datepicker-popper .react-datepicker__triangle {\n  stroke: #aeaeae;\n}\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {\n  fill: #f0f0f0;\n  color: #f0f0f0;\n}\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle {\n  fill: #fff;\n  color: #fff;\n}\n\n.react-datepicker__header {\n  text-align: center;\n  background-color: #f0f0f0;\n  border-bottom: 1px solid #aeaeae;\n  border-top-left-radius: 0.3rem;\n  padding: 8px 0;\n  position: relative;\n}\n.react-datepicker__header--time {\n  padding-bottom: 8px;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n.react-datepicker__header--time:not(.react-datepicker__header--time--only) {\n  border-top-left-radius: 0;\n}\n.react-datepicker__header:not(.react-datepicker__header--has-time-select) {\n  border-top-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select,\n.react-datepicker__month-year-dropdown-container--select,\n.react-datepicker__year-dropdown-container--scroll,\n.react-datepicker__month-dropdown-container--scroll,\n.react-datepicker__month-year-dropdown-container--scroll {\n  display: inline-block;\n  margin: 0 15px;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  margin-top: 0;\n  color: #000;\n  font-weight: bold;\n  font-size: 0.944rem;\n}\n\n.react-datepicker-time__header {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation {\n  align-items: center;\n  background: none;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  cursor: pointer;\n  position: absolute;\n  top: 2px;\n  padding: 0;\n  border: none;\n  z-index: 1;\n  height: 32px;\n  width: 32px;\n  text-indent: -999em;\n  overflow: hidden;\n}\n.react-datepicker__navigation--previous {\n  left: 2px;\n}\n.react-datepicker__navigation--next {\n  right: 2px;\n}\n.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n  right: 85px;\n}\n.react-datepicker__navigation--years {\n  position: relative;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.react-datepicker__navigation--years-previous {\n  top: 4px;\n}\n.react-datepicker__navigation--years-upcoming {\n  top: -4px;\n}\n.react-datepicker__navigation:hover *::before {\n  border-color: #a6a6a6;\n}\n\n.react-datepicker__navigation-icon {\n  position: relative;\n  top: -1px;\n  font-size: 20px;\n  width: 0;\n}\n.react-datepicker__navigation-icon--next {\n  left: -2px;\n}\n.react-datepicker__navigation-icon--next::before {\n  transform: rotate(45deg);\n  left: -7px;\n}\n.react-datepicker__navigation-icon--previous {\n  right: -2px;\n}\n.react-datepicker__navigation-icon--previous::before {\n  transform: rotate(225deg);\n  right: -7px;\n}\n\n.react-datepicker__month-container {\n  float: left;\n}\n\n.react-datepicker__year {\n  margin: 0.4rem;\n  text-align: center;\n}\n.react-datepicker__year-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  max-width: 180px;\n}\n.react-datepicker__year .react-datepicker__year-text {\n  display: inline-block;\n  width: 4rem;\n  margin: 2px;\n}\n\n.react-datepicker__month {\n  margin: 0.4rem;\n  text-align: center;\n}\n.react-datepicker__month .react-datepicker__month-text,\n.react-datepicker__month .react-datepicker__quarter-text {\n  display: inline-block;\n  width: 4rem;\n  margin: 2px;\n}\n\n.react-datepicker__input-time-container {\n  clear: both;\n  width: 100%;\n  float: left;\n  margin: 5px 0 10px 15px;\n  text-align: left;\n}\n.react-datepicker__input-time-container .react-datepicker-time__caption {\n  display: inline-block;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container {\n  display: inline-block;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {\n  display: inline-block;\n  margin-left: 10px;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input {\n  width: auto;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-inner-spin-button,\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time] {\n  -moz-appearance: textfield;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter {\n  margin-left: 5px;\n  display: inline-block;\n}\n\n.react-datepicker__time-container {\n  float: right;\n  border-left: 1px solid #aeaeae;\n  width: 85px;\n}\n.react-datepicker__time-container--with-today-button {\n  display: inline;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  position: absolute;\n  right: -87px;\n  top: 0;\n}\n.react-datepicker__time-container .react-datepicker__time {\n  position: relative;\n  background: white;\n  border-bottom-right-radius: 0.3rem;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {\n  width: 85px;\n  overflow-x: hidden;\n  margin: 0 auto;\n  text-align: center;\n  border-bottom-right-radius: 0.3rem;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {\n  list-style: none;\n  margin: 0;\n  height: calc(195px + 1.7rem / 2);\n  overflow-y: scroll;\n  padding-right: 0;\n  padding-left: 0;\n  width: 100%;\n  box-sizing: content-box;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {\n  height: 30px;\n  padding: 5px 10px;\n  white-space: nowrap;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {\n  cursor: pointer;\n  background-color: #f0f0f0;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #216ba5;\n  color: white;\n  font-weight: bold;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {\n  background-color: #216ba5;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {\n  color: #ccc;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {\n  cursor: default;\n  background-color: transparent;\n}\n\n.react-datepicker__week-number {\n  color: #ccc;\n  display: inline-block;\n  width: 1.7rem;\n  line-height: 1.7rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n.react-datepicker__week-number.react-datepicker__week-number--clickable {\n  cursor: pointer;\n}\n.react-datepicker__week-number.react-datepicker__week-number--clickable:not(.react-datepicker__week-number--selected,\n.react-datepicker__week-number--keyboard-selected):hover {\n  border-radius: 0.3rem;\n  background-color: #f0f0f0;\n}\n.react-datepicker__week-number--selected {\n  border-radius: 0.3rem;\n  background-color: #216ba5;\n  color: #fff;\n}\n.react-datepicker__week-number--selected:hover {\n  background-color: #1d5d90;\n}\n.react-datepicker__week-number--keyboard-selected {\n  border-radius: 0.3rem;\n  background-color: #2a87d0;\n  color: #fff;\n}\n.react-datepicker__week-number--keyboard-selected:hover {\n  background-color: #1d5d90;\n}\n\n.react-datepicker__day-names {\n  white-space: nowrap;\n  margin-bottom: -8px;\n}\n\n.react-datepicker__week {\n  white-space: nowrap;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  color: #000;\n  display: inline-block;\n  width: 1.7rem;\n  line-height: 1.7rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n\n.react-datepicker__day,\n.react-datepicker__month-text,\n.react-datepicker__quarter-text,\n.react-datepicker__year-text {\n  cursor: pointer;\n}\n.react-datepicker__day:hover,\n.react-datepicker__month-text:hover,\n.react-datepicker__quarter-text:hover,\n.react-datepicker__year-text:hover {\n  border-radius: 0.3rem;\n  background-color: #f0f0f0;\n}\n.react-datepicker__day--today,\n.react-datepicker__month-text--today,\n.react-datepicker__quarter-text--today,\n.react-datepicker__year-text--today {\n  font-weight: bold;\n}\n.react-datepicker__day--highlighted,\n.react-datepicker__month-text--highlighted,\n.react-datepicker__quarter-text--highlighted,\n.react-datepicker__year-text--highlighted {\n  border-radius: 0.3rem;\n  background-color: #3dcc4a;\n  color: #fff;\n}\n.react-datepicker__day--highlighted:hover,\n.react-datepicker__month-text--highlighted:hover,\n.react-datepicker__quarter-text--highlighted:hover,\n.react-datepicker__year-text--highlighted:hover {\n  background-color: #32be3f;\n}\n.react-datepicker__day--highlighted-custom-1,\n.react-datepicker__month-text--highlighted-custom-1,\n.react-datepicker__quarter-text--highlighted-custom-1,\n.react-datepicker__year-text--highlighted-custom-1 {\n  color: magenta;\n}\n.react-datepicker__day--highlighted-custom-2,\n.react-datepicker__month-text--highlighted-custom-2,\n.react-datepicker__quarter-text--highlighted-custom-2,\n.react-datepicker__year-text--highlighted-custom-2 {\n  color: green;\n}\n.react-datepicker__day--holidays,\n.react-datepicker__month-text--holidays,\n.react-datepicker__quarter-text--holidays,\n.react-datepicker__year-text--holidays {\n  position: relative;\n  border-radius: 0.3rem;\n  background-color: #ff6803;\n  color: #fff;\n}\n.react-datepicker__day--holidays .overlay,\n.react-datepicker__month-text--holidays .overlay,\n.react-datepicker__quarter-text--holidays .overlay,\n.react-datepicker__year-text--holidays .overlay {\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #333;\n  color: #fff;\n  padding: 4px;\n  border-radius: 4px;\n  white-space: nowrap;\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 0s, opacity 0.3s ease-in-out;\n}\n.react-datepicker__day--holidays:hover,\n.react-datepicker__month-text--holidays:hover,\n.react-datepicker__quarter-text--holidays:hover,\n.react-datepicker__year-text--holidays:hover {\n  background-color: #cf5300;\n}\n.react-datepicker__day--holidays:hover .overlay,\n.react-datepicker__month-text--holidays:hover .overlay,\n.react-datepicker__quarter-text--holidays:hover .overlay,\n.react-datepicker__year-text--holidays:hover .overlay {\n  visibility: visible;\n  opacity: 1;\n}\n.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--selected,\n.react-datepicker__year-text--in-selecting-range,\n.react-datepicker__year-text--in-range {\n  border-radius: 0.3rem;\n  background-color: #216ba5;\n  color: #fff;\n}\n.react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover,\n.react-datepicker__month-text--selected:hover,\n.react-datepicker__month-text--in-selecting-range:hover,\n.react-datepicker__month-text--in-range:hover,\n.react-datepicker__quarter-text--selected:hover,\n.react-datepicker__quarter-text--in-selecting-range:hover,\n.react-datepicker__quarter-text--in-range:hover,\n.react-datepicker__year-text--selected:hover,\n.react-datepicker__year-text--in-selecting-range:hover,\n.react-datepicker__year-text--in-range:hover {\n  background-color: #1d5d90;\n}\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n  border-radius: 0.3rem;\n  background-color: #bad9f1;\n  color: rgb(0, 0, 0);\n}\n.react-datepicker__day--keyboard-selected:hover,\n.react-datepicker__month-text--keyboard-selected:hover,\n.react-datepicker__quarter-text--keyboard-selected:hover,\n.react-datepicker__year-text--keyboard-selected:hover {\n  background-color: #1d5d90;\n}\n.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range) {\n  background-color: rgba(33, 107, 165, 0.5);\n}\n.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range), .react-datepicker__year--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__year--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__year--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__month--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__year--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range) {\n  background-color: #f0f0f0;\n  color: #000;\n}\n.react-datepicker__day--disabled,\n.react-datepicker__month-text--disabled,\n.react-datepicker__quarter-text--disabled,\n.react-datepicker__year-text--disabled {\n  cursor: default;\n  color: #ccc;\n}\n.react-datepicker__day--disabled:hover,\n.react-datepicker__month-text--disabled:hover,\n.react-datepicker__quarter-text--disabled:hover,\n.react-datepicker__year-text--disabled:hover {\n  background-color: transparent;\n}\n.react-datepicker__day--disabled .overlay,\n.react-datepicker__month-text--disabled .overlay,\n.react-datepicker__quarter-text--disabled .overlay,\n.react-datepicker__year-text--disabled .overlay {\n  position: absolute;\n  bottom: 70%;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #333;\n  color: #fff;\n  padding: 4px;\n  border-radius: 4px;\n  white-space: nowrap;\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 0s, opacity 0.3s ease-in-out;\n}\n\n.react-datepicker__input-container {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n.react-datepicker__input-container .react-datepicker__calendar-icon {\n  position: absolute;\n  padding: 0.5rem;\n  box-sizing: content-box;\n}\n\n.react-datepicker__view-calendar-icon input {\n  padding: 6px 10px 5px 25px;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n  border: 1px solid transparent;\n  border-radius: 0.3rem;\n  position: relative;\n}\n.react-datepicker__year-read-view:hover,\n.react-datepicker__month-read-view:hover,\n.react-datepicker__month-year-read-view:hover {\n  cursor: pointer;\n}\n.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {\n  border-top-color: #b3b3b3;\n}\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  transform: rotate(135deg);\n  right: -16px;\n  top: 0;\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n  background-color: #f0f0f0;\n  position: absolute;\n  width: 50%;\n  left: 25%;\n  top: 30px;\n  z-index: 1;\n  text-align: center;\n  border-radius: 0.3rem;\n  border: 1px solid #aeaeae;\n}\n.react-datepicker__year-dropdown:hover,\n.react-datepicker__month-dropdown:hover,\n.react-datepicker__month-year-dropdown:hover {\n  cursor: pointer;\n}\n.react-datepicker__year-dropdown--scrollable,\n.react-datepicker__month-dropdown--scrollable,\n.react-datepicker__month-year-dropdown--scrollable {\n  height: 150px;\n  overflow-y: scroll;\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-year-option {\n  line-height: 20px;\n  width: 100%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.react-datepicker__year-option:first-of-type,\n.react-datepicker__month-option:first-of-type,\n.react-datepicker__month-year-option:first-of-type {\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n}\n.react-datepicker__year-option:last-of-type,\n.react-datepicker__month-option:last-of-type,\n.react-datepicker__month-year-option:last-of-type {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border-bottom-left-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover {\n  background-color: #ccc;\n}\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {\n  border-bottom-color: #b3b3b3;\n}\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {\n  border-top-color: #b3b3b3;\n}\n.react-datepicker__year-option--selected,\n.react-datepicker__month-option--selected,\n.react-datepicker__month-year-option--selected {\n  position: absolute;\n  left: 15px;\n}\n\n.react-datepicker__close-icon {\n  cursor: pointer;\n  background-color: transparent;\n  border: 0;\n  outline: 0;\n  padding: 0 6px 0 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  display: table-cell;\n  vertical-align: middle;\n}\n.react-datepicker__close-icon::after {\n  cursor: pointer;\n  background-color: #216ba5;\n  color: #fff;\n  border-radius: 50%;\n  height: 16px;\n  width: 16px;\n  padding: 2px;\n  font-size: 12px;\n  line-height: 1;\n  text-align: center;\n  display: table-cell;\n  vertical-align: middle;\n  content: "×";\n}\n.react-datepicker__close-icon--disabled {\n  cursor: default;\n}\n.react-datepicker__close-icon--disabled::after {\n  cursor: default;\n  background-color: #ccc;\n}\n\n.react-datepicker__today-button {\n  background: #f0f0f0;\n  border-top: 1px solid #aeaeae;\n  cursor: pointer;\n  text-align: center;\n  font-weight: bold;\n  padding: 5px 0;\n  clear: left;\n}\n\n.react-datepicker__portal {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.8);\n  left: 0;\n  top: 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  z-index: 2147483647;\n}\n.react-datepicker__portal .react-datepicker__day-name,\n.react-datepicker__portal .react-datepicker__day,\n.react-datepicker__portal .react-datepicker__time-name {\n  width: 3rem;\n  line-height: 3rem;\n}\n@media (max-width: 400px), (max-height: 550px) {\n  .react-datepicker__portal .react-datepicker__day-name,\n  .react-datepicker__portal .react-datepicker__day,\n  .react-datepicker__portal .react-datepicker__time-name {\n    width: 2rem;\n    line-height: 2rem;\n  }\n}\n.react-datepicker__portal .react-datepicker__current-month,\n.react-datepicker__portal .react-datepicker-time__header {\n  font-size: 1.44rem;\n}\n\n.react-datepicker__children-container {\n  width: 13.8rem;\n  margin: 0.4rem;\n  padding-right: 0.2rem;\n  padding-left: 0.2rem;\n  height: auto;\n}\n\n.react-datepicker__aria-live {\n  position: absolute;\n  clip-path: circle(0);\n  border: 0;\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  width: 1px;\n  white-space: nowrap;\n}\n\n.react-datepicker__calendar-icon {\n  width: 1em;\n  height: 1em;\n  vertical-align: -0.125em;\n}\n'],sourceRoot:""}]);const s=a},69795:(e,t,n)=>{"use strict";n.d(t,{A:()=>h});var r=n(15516),o=n.n(r),i=n(81364),a=n.n(i),s=n(83615),l=n.n(s),c=new URL(n(88348),n.b),u=new URL(n(11269),n.b),d=a()(o()),p=l()(c),f=l()(u);d.push([e.id,`.rx-reset * {\n  box-sizing: border-box;\n  background: transparent;\n  border: 0;\n  font-size: 100%;\n  line-height: 1;\n  margin: 0;\n  padding: 0;\n  vertical-align: baseline; }\n\n.rx-reset h1:empty,\n.rx-reset h2:empty,\n.rx-reset h3:empty,\n.rx-reset h4:empty,\n.rx-reset h5:empty,\n.rx-reset h6:empty,\n.rx-reset p:empty,\n.rx-reset li:empty,\n.rx-reset dt:empty,\n.rx-reset dd:empty,\n.rx-reset address:empty,\n.rx-reset figcaption:empty,\n.rx-reset blockquote:empty {\n  min-height: 1.5em; }\n\n.rx-reset pre:empty {\n  min-height: 3.5em; }\n\n.rx-reset strong:empty, .rx-reset b:empty, .rx-reset em:empty, .rx-reset i:empty, .rx-reset span:empty, .rx-reset sup:empty, .rx-reset sub:empty, .rx-reset u:empty, .rx-reset ins:empty, .rx-reset code:empty {\n  display: inline-block;\n  min-width: 1px;\n  min-height: 1em; }\n\n.rx-reset code:after, .rx-reset kbd:after, .rx-reset mark:after, .rx-reset th:after, .rx-reset td:after {\n  content: '\\200B'; }\n\n.rx-reset code + code {\n  margin-left: 2px; }\n\n.rx-reset table {\n  empty-cells: show; }\n\n.rx-reset embed, .rx-reset img, .rx-reset object {\n  max-width: 100%;\n  height: auto; }\n\n.rx-reset figure > img,\n.rx-reset figure > iframe {\n  vertical-align: middle; }\n\n.rx-reset figcaption {\n  display: block;\n  top: 0; }\n  .rx-reset figcaption:empty {\n    min-height: 18px; }\n\n.rx-content {\n  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Helvetica Neue", Arial, sans-serif;\n  font-size: 16px;\n  line-height: 1.5; }\n  .rx-content h1 + *, .rx-content h2 + *, .rx-content h3 + *, .rx-content h4 + *, .rx-content h5 + *, .rx-content h6 + * {\n    margin-top: 12px; }\n  .rx-content p + h2, .rx-content ul + h2, .rx-content ol + h2, .rx-content blockquote + h2, .rx-content figure + h2, .rx-content pre + h2, .rx-content table + h2, .rx-content dl + h2, .rx-content address + h2 {\n    margin-top: 24px; }\n  .rx-content p + h3, .rx-content ul + h3, .rx-content ol + h3, .rx-content blockquote + h3, .rx-content figure + h3, .rx-content pre + h3, .rx-content table + h3, .rx-content dl + h3, .rx-content address + h3 {\n    margin-top: 24px; }\n  .rx-content p + h4, .rx-content ul + h4, .rx-content ol + h4, .rx-content blockquote + h4, .rx-content figure + h4, .rx-content pre + h4, .rx-content table + h4, .rx-content dl + h4, .rx-content address + h4 {\n    margin-top: 24px; }\n  .rx-content p + h5, .rx-content ul + h5, .rx-content ol + h5, .rx-content blockquote + h5, .rx-content figure + h5, .rx-content pre + h5, .rx-content table + h5, .rx-content dl + h5, .rx-content address + h5 {\n    margin-top: 24px; }\n  .rx-content p + h6, .rx-content ul + h6, .rx-content ol + h6, .rx-content blockquote + h6, .rx-content figure + h6, .rx-content pre + h6, .rx-content table + h6, .rx-content dl + h6, .rx-content address + h6 {\n    margin-top: 24px; }\n  .rx-content p + *, .rx-content ul + *, .rx-content ol + *, .rx-content blockquote + *, .rx-content figure + *, .rx-content pre + *, .rx-content table + *, .rx-content dl + *, .rx-content address + * {\n    margin-top: 16px; }\n  .rx-content div + * {\n    margin-top: 24px; }\n  .rx-content h1 + h2 {\n    margin-top: 24px; }\n  .rx-content h2 + h3 {\n    margin-top: 24px; }\n  .rx-content h3 + h4 {\n    margin-top: 24px; }\n  .rx-content h4 + h5 {\n    margin-top: 24px; }\n  .rx-content h5 + h6 {\n    margin-top: 24px; }\n  .rx-content a,\n  .rx-content a:hover,\n  .rx-content a:focus {\n    color: #0044C3; }\n  .rx-content p {\n    font-size: 16px;\n    line-height: 1.5; }\n  .rx-content h1,\n  .rx-content h2,\n  .rx-content h3,\n  .rx-content h4,\n  .rx-content h5,\n  .rx-content h6 {\n    font-family: inherit;\n    font-weight: bold;\n    font-style: normal;\n    font-size: 16px;\n    line-height: 1.5;\n    color: #000B1D;\n    text-rendering: optimizeLegibility;\n    letter-spacing: -0.01em; }\n    .rx-content h1 a,\n    .rx-content h1 a:focus,\n    .rx-content h1 a:hover,\n    .rx-content h2 a,\n    .rx-content h2 a:focus,\n    .rx-content h2 a:hover,\n    .rx-content h3 a,\n    .rx-content h3 a:focus,\n    .rx-content h3 a:hover,\n    .rx-content h4 a,\n    .rx-content h4 a:focus,\n    .rx-content h4 a:hover,\n    .rx-content h5 a,\n    .rx-content h5 a:focus,\n    .rx-content h5 a:hover,\n    .rx-content h6 a,\n    .rx-content h6 a:focus,\n    .rx-content h6 a:hover {\n      color: inherit;\n      text-decoration: none; }\n  .rx-content h1 {\n    font-size: 40px;\n    line-height: 1.2; }\n  .rx-content h2 {\n    font-size: 24px;\n    line-height: 1.3; }\n  .rx-content h3 {\n    font-size: 21px;\n    line-height: 1.5; }\n  .rx-content ul,\n  .rx-content ol {\n    margin-left: 20px; }\n  .rx-content li {\n    font-size: 16px;\n    line-height: 1.5; }\n  .rx-content li li {\n    font-size: 1em; }\n  .rx-content dt, .rx-content dd {\n    font-size: 16px;\n    line-height: 1.5; }\n  .rx-content dt {\n    font-weight: bold; }\n  .rx-content dd + dt {\n    margin-top: 0.25em; }\n  .rx-content pre {\n    overflow: auto;\n    white-space: pre;\n    font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, Courier, monospace;\n    font-size: 90%;\n    line-height: 1.5;\n    color: #262F3F;\n    background-color: #F5F5F6;\n    padding: 1em; }\n  .rx-content pre code {\n    padding: 0;\n    border: 0;\n    background: none;\n    font-size: 100%;\n    display: block;\n    line-height: inherit; }\n  .rx-content blockquote {\n    color: #262F3F;\n    font-style: italic;\n    font-weight: normal;\n    padding: 0;\n    background: transparent; }\n    .rx-content blockquote p {\n      color: #262F3F;\n      font-size: 125%;\n      line-height: 1.5; }\n    .rx-content blockquote p + p {\n      margin-top: 4px; }\n  .rx-content blockquote cite,\n  .rx-content figcaption cite {\n    font-style: inherit;\n    font-size: 14px;\n    line-height: 1.5;\n    color: rgba(38, 47, 63, 0.7); }\n  .rx-content caption {\n    text-align: left;\n    font-style: normal; }\n  .rx-content table {\n    border-collapse: collapse;\n    border-spacing: 0;\n    width: 100%;\n    empty-cells: show; }\n  .rx-content td,\n  .rx-content th {\n    text-align: left;\n    vertical-align: top;\n    font-size: 95%;\n    line-height: 1.5;\n    padding: 0.75em;\n    border: 1px solid rgba(217, 219, 221, 0.5); }\n  .rx-content th {\n    font-weight: normal; }\n  .rx-content thead th {\n    font-weight: bold; }\n  .rx-content address {\n    font-style: normal; }\n  .rx-content dfn,\n  .rx-content abbr {\n    font-size: 95%; }\n  .rx-content time,\n  .rx-content cite,\n  .rx-content small,\n  .rx-content var,\n  .rx-content samp,\n  .rx-content kbd,\n  .rx-content code {\n    font-size: 85%; }\n  .rx-content sup,\n  .rx-content sub {\n    font-size: 65%; }\n  .rx-content var,\n  .rx-content code,\n  .rx-content kbd,\n  .rx-content samp {\n    display: inline-block;\n    font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, Courier, monospace;\n    font-style: normal;\n    line-height: 1;\n    color: rgba(0, 11, 29, 0.85);\n    vertical-align: baseline; }\n  .rx-content samp,\n  .rx-content kbd,\n  .rx-content code {\n    border-radius: 2px; }\n  .rx-content kbd {\n    border: 1px solid rgba(0, 11, 29, 0.15);\n    padding: .2em .4em; }\n  .rx-content code {\n    position: relative;\n    top: -1px;\n    border: 1px solid transparent;\n    background-color: #F5F5F6;\n    padding: .2em .4em .2em; }\n  .rx-content mark {\n    background-color: yellow;\n    color: black; }\n  .rx-content b,\n  .rx-content strong {\n    font-weight: 600; }\n  .rx-content dfn[title],\n  .rx-content abbr[title] {\n    letter-spacing: .01em;\n    text-transform: uppercase;\n    text-decoration: none;\n    border-bottom: 1px dotted rgba(0, 0, 0, 0.4);\n    cursor: help; }\n  .rx-content cite {\n    font-style: italic; }\n  .rx-content sub,\n  .rx-content sup {\n    line-height: 1;\n    margin-left: 2px; }\n  .rx-content sub {\n    vertical-align: sub; }\n  .rx-content sup {\n    vertical-align: super; }\n  .rx-content figure > img,\n  .rx-content figure > iframe,\n  .rx-content figure > pre,\n  .rx-content figure > div {\n    vertical-align: middle; }\n  .rx-content figure figcaption {\n    display: block;\n    font-style: normal;\n    margin-top: 0.25em;\n    font-size: 12px;\n    line-height: 1.5; }\n  .rx-content .embed-responsive {\n    position: relative;\n    padding: 0;\n    margin: 0;\n    padding-bottom: 56.25%;\n    padding-top: 25px;\n    height: 0; }\n    .rx-content .embed-responsive iframe {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%; }\n  .rx-content hr {\n    position: relative;\n    line-height: 1;\n    background: none;\n    border: none;\n    text-align: left;\n    margin-top: 1em;\n    margin-bottom: 1em;\n    height: 10px; }\n    .rx-content hr:before {\n      content: '';\n      position: absolute;\n      top: 50%; }\n    .rx-content hr:before {\n      width: 100%;\n      max-width: 100%;\n      margin-top: -0.5px;\n      border-top-width: 1px;\n      border-top-style: solid;\n      border-top-color: rgba(217, 219, 221, 0.6); }\n  .rx-content .align-right {\n    text-align: right; }\n  .rx-content .align-center {\n    text-align: center; }\n  .rx-content .align-justify {\n    text-align: justify; }\n  .rx-content div.align-center img,\n  .rx-content p.align-center img,\n  .rx-content figure.align-center img {\n    max-width: 80%; }\n  .rx-content div.align-center figcaption,\n  .rx-content p.align-center figcaption,\n  .rx-content figure.align-center figcaption {\n    text-align: center; }\n  .rx-content .float-left {\n    float: left;\n    margin-right: 1em;\n    margin-bottom: 1em;\n    max-width: 200px; }\n  .rx-content .float-right {\n    float: right;\n    margin-left: 1em;\n    margin-bottom: 1em;\n    max-width: 200px; }\n\n@keyframes slideUp {\n  to {\n    height: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    margin-bottom: 0; } }\n\n@keyframes slideDown {\n  from {\n    height: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    margin-bottom: 0; } }\n\n@keyframes fadeIn {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@keyframes fadeOut {\n  from {\n    opacity: 1; }\n  to {\n    opacity: 0; } }\n\n.rx-container {\n  box-sizing: border-box;\n  border-radius: 2px;\n  background-color: #ffffff;\n  border: 1px solid rgba(0, 11, 29, 0.1); }\n\n.rx-toolbar {\n  display: flex;\n  flex: 1;\n  white-space: nowrap;\n  height: 40px;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  scrollbar-width: none;\n  -ms-overflow-style: none; }\n  .rx-toolbar::-webkit-scrollbar {\n    width: 0;\n    height: 0; }\n  .rx-toolbar-container {\n    position: relative;\n    z-index: 4;\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    display: flex; }\n  .rx-toolbar-container.is-rx-toolbar {\n    border-top-left-radius: 2px;\n    border-top-right-radius: 2px;\n    background-color: rgba(255, 255, 255, 0.98);\n    border-bottom: 1px solid rgba(0, 11, 29, 0.1); }\n  .rx-toolbar-container.is-rx-toolbar .rx-topbar {\n    position: relative;\n    margin-left: auto;\n    display: flex; }\n  .rx-toolbar-sticky {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0; }\n\n.rx-editor-container {\n  box-sizing: border-box; }\n\n.rx-source-container {\n  display: none; }\n\n.rx-context {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 4;\n  padding: 0;\n  margin: 0;\n  line-height: 1;\n  border-radius: 99px;\n  background-color: #000B1D; }\n\n.rx-control {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 3;\n  padding: 0;\n  margin: 0;\n  line-height: 1; }\n\n.rx-topbar {\n  position: absolute;\n  right: 0; }\n\n.rx-source,\n.rx-source:hover,\n.rx-source:focus {\n  text-align: left;\n  box-sizing: border-box;\n  font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, Courier, monospace;\n  width: 100%;\n  display: block;\n  margin: 0;\n  border: none;\n  box-shadow: none;\n  border-radius: 0;\n  background-color: #262F3F;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 14px;\n  outline: none;\n  padding: 10px 18px 20px 18px;\n  line-height: 1.5;\n  min-height: 60px;\n  resize: vertical; }\n\n.rx-draggable-placeholder {\n  height: 20px;\n  min-width: 80px;\n  outline: 3px dashed gold !important;\n  background-color: rgba(255, 215, 0, 0.2) !important;\n  margin-bottom: 20px; }\n\n.rx-drag-active {\n  outline: 3px dashed gold !important;\n  outline-offset: 0 !important;\n  position: relative;\n  max-height: 40px;\n  overflow: hidden;\n  padding: 0; }\n  .rx-drag-active:before {\n    width: 100%;\n    height: 100%;\n    content: "";\n    top: 0;\n    left: 0;\n    background-color: rgba(255, 215, 0, 0.4);\n    position: absolute;\n    z-index: 1; }\n\n.rx-dragging {\n  opacity: 0.95;\n  background-color: #ffffff;\n  box-shadow: 0 15px 30px 0 15px 30px rgba(0, 11, 29, 0.3); }\n  .rx-dragging img {\n    max-width: 100%; }\n\n.rx-voice-label {\n  display: none; }\n\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0; }\n  to {\n    background-position: 0 0; } }\n\n.rx-editor-progress {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 11000;\n  width: 100%;\n  background-color: rgba(0, 11, 29, 0.2); }\n  .rx-editor-progress span {\n    animation: progress-bar-stripes 2s linear infinite;\n    content: '';\n    display: block;\n    min-height: 8px;\n    width: 100%;\n    height: 100%;\n    background-color: #0058FB;\n    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%, transparent);\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%, transparent);\n    background-size: 40px 40px; }\n\n.rx-nowrap {\n  white-space: nowrap !important; }\n\n.rx-handle {\n  cursor: move; }\n\n.rx-placeholder:before {\n  position: absolute;\n  z-index: 0;\n  content: attr(placeholder);\n  color: rgba(0, 11, 29, 0.4);\n  font-weight: normal;\n  cursor: text; }\n\n@font-face {\n  font-family: 'RedactorX';\n  src: url(${p}) format("truetype");\n  font-weight: normal;\n  font-style: normal;\n  font-display: block; }\n\n[class^="rx-icon-"], [class*=" rx-icon-"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'RedactorX' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\n.rx-icon-paragraph:before {\n  content: "\\e91b"; }\n\n.rx-icon-outdent:before {\n  content: "\\e921"; }\n\n.rx-icon-sub:before {\n  content: "\\e90c"; }\n\n.rx-icon-sup:before {\n  content: "\\e920"; }\n\n.rx-icon-align-center:before {\n  content: "\\e900"; }\n\n.rx-icon-align-justify:before {\n  content: "\\e901"; }\n\n.rx-icon-alignment:before,\n.rx-icon-align-left:before {\n  content: "\\e902"; }\n\n.rx-icon-add:before {\n  content: "\\e903"; }\n\n.rx-icon-align-right:before {\n  content: "\\e904"; }\n\n.rx-icon-embed:before {\n  content: "\\e905"; }\n\n.rx-icon-file:before {\n  content: "\\e906"; }\n\n.rx-icon-duplicate:before {\n  content: "\\e907"; }\n\n.rx-icon-format:before {\n  content: "\\e908"; }\n\n.rx-icon-bold:before {\n  content: "\\e909"; }\n\n.rx-icon-pre:before,\n.rx-icon-html:before,\n.rx-icon-code:before {\n  content: "\\e90a"; }\n\n.rx-icon-deleted:before {\n  content: "\\e90b"; }\n\n.rx-icon-image:before {\n  content: "\\e90d"; }\n\n.rx-icon-indent:before {\n  content: "\\e90e"; }\n\n.rx-icon-italic:before {\n  content: "\\e90f"; }\n\n.rx-icon-kbd:before {\n  content: "\\e910"; }\n\n.rx-icon-line:before {\n  content: "\\e911"; }\n\n.rx-icon-link:before {\n  content: "\\e912"; }\n\n.rx-icon-list:before {\n  content: "\\e913"; }\n\n.rx-icon-mark:before {\n  content: "\\e914"; }\n\n.rx-icon-quote:before {\n  content: "\\e915"; }\n\n.rx-icon-redo:before {\n  content: "\\e916"; }\n\n.rx-icon-selector:before {\n  content: "\\e917"; }\n\n.rx-icon-shortcut:before {\n  content: "\\e918"; }\n\n.rx-icon-sort:before {\n  content: "\\e919"; }\n\n.rx-icon-table:before {\n  content: "\\e91a"; }\n\n.rx-icon-trash:before {\n  content: "\\e91c"; }\n\n.rx-icon-tune:before {\n  content: "\\e91d"; }\n\n.rx-icon-underline:before {\n  content: "\\e91e"; }\n\n.rx-icon-undo:before {\n  content: "\\e91f"; }\n\n.rx-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  vertical-align: middle;\n  text-decoration: none;\n  background: none;\n  outline: none;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer; }\n  .rx-button:hover {\n    text-decoration: none; }\n  .rx-button-icon {\n    display: inline-flex; }\n  .rx-button-icon svg {\n    display: inline-block; }\n\n.rx-button-icon {\n  width: 31px;\n  height: 30px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  border: 1px solid transparent; }\n\n.rx-button-control {\n  width: 20px;\n  color: rgba(0, 11, 29, 0.4); }\n  .rx-button-control:hover {\n    color: #000B1D; }\n\n.rx-button-context, .rx-button-context:active, .rx-button-context:focus {\n  width: 36px;\n  min-width: 36px;\n  height: 34px;\n  background-color: transparent;\n  color: rgba(255, 255, 255, 0.85); }\n\n.rx-button-context:first-child {\n  padding-left: 6px; }\n\n.rx-button-context:last-child {\n  padding-right: 6px; }\n\n.rx-button-context svg {\n  fill: rgba(255, 255, 255, 0.85); }\n\n.rx-button-context.active {\n  background-color: rgba(255, 255, 255, 0.2);\n  color: rgba(255, 255, 255, 0.85); }\n\n.rx-button-context:hover {\n  transition: all 0.2s linear;\n  background-color: rgba(255, 255, 255, 0.3);\n  color: #ffffff; }\n  .rx-button-context:hover svg {\n    fill: #ffffff; }\n  .rx-button-context:hover .rx-button-icon {\n    border-color: transparent; }\n\n.rx-button-toolbar {\n  padding-top: 1px;\n  width: 40px;\n  min-width: 40px;\n  height: 41px; }\n\n.rx-button-topbar {\n  width: 36px;\n  height: 40px;\n  padding-top: 1px; }\n\n.rx-button-toolbar,\n.rx-button-topbar {\n  color: rgba(0, 11, 29, 0.8); }\n  .rx-button-toolbar svg,\n  .rx-button-topbar svg {\n    fill: rgba(0, 11, 29, 0.8); }\n  .rx-button-toolbar.active .rx-button-icon,\n  .rx-button-topbar.active .rx-button-icon {\n    border-color: #e4e8ed;\n    background-color: rgba(228, 232, 237, 0.5); }\n  .rx-button-toolbar.toggled,\n  .rx-button-topbar.toggled {\n    background-color: #E4E8ED;\n    color: #000B1D; }\n    .rx-button-toolbar.toggled svg,\n    .rx-button-topbar.toggled svg {\n      fill: #000B1D; }\n  .rx-button-toolbar.disable, .rx-button-toolbar.disable:hover,\n  .rx-button-topbar.disable,\n  .rx-button-topbar.disable:hover {\n    cursor: default;\n    background-color: transparent !important;\n    color: rgba(0, 11, 29, 0.4) !important; }\n  .rx-button-toolbar.disable svg,\n  .rx-button-topbar.disable svg {\n    fill: rgba(0, 11, 29, 0.4) !important; }\n  .rx-button-toolbar.disable .rx-button-icon,\n  .rx-button-topbar.disable .rx-button-icon {\n    background-color: transparent !important;\n    color: rgba(0, 11, 29, 0.4) !important; }\n  .rx-button-toolbar:hover,\n  .rx-button-topbar:hover {\n    transition: all 0.2s linear;\n    background-color: #E4E8ED;\n    color: #000B1D; }\n    .rx-button-toolbar:hover svg,\n    .rx-button-topbar:hover svg {\n      fill: #000B1D; }\n    .rx-button-toolbar:hover .rx-button-icon,\n    .rx-button-topbar:hover .rx-button-icon {\n      border-color: transparent; }\n\n.rx-tooltip {\n  position: absolute;\n  z-index: 99;\n  margin: 0;\n  padding: 4px 7px;\n  border-radius: 2px;\n  line-height: 1;\n  font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, Courier, monospace;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.85);\n  background-color: #000B1D; }\n\n.rx-statusbar {\n  font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, Courier, monospace;\n  margin: 0;\n  padding: 8px 10px;\n  position: relative;\n  overflow: hidden;\n  background-color: #F5F5F6;\n  box-sizing: border-box;\n  border: none; }\n  .rx-statusbar:empty {\n    display: none; }\n  .rx-statusbar-item {\n    float: left;\n    font-size: 12px;\n    padding: 0 10px;\n    margin: 0;\n    line-height: 16px;\n    color: rgba(0, 11, 29, 0.5);\n    border-right: 1px solid rgba(0, 11, 29, 0.1); }\n  .rx-statusbar-item:last-child {\n    border-right-color: transparent; }\n  .rx-statusbar-item a {\n    color: rgba(0, 11, 29, 0.5);\n    text-decoration: underline; }\n  .rx-statusbar-item a:hover {\n    color: #FF4F7F;\n    text-decoration: underline; }\n\n.rx-panel {\n  position: absolute;\n  min-width: 240px;\n  max-height: 300px;\n  margin: 0;\n  padding: 0;\n  z-index: 99;\n  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Helvetica Neue", Arial, sans-serif;\n  font-size: 14px;\n  overflow: auto;\n  border-radius: 4px;\n  background-color: #000B1D; }\n  .rx-panel-item {\n    box-sizing: border-box;\n    padding: 4px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.07); }\n  .rx-panel-item a {\n    display: block;\n    border-radius: 6px;\n    padding: 8px;\n    line-height: 1;\n    text-decoration: none;\n    color: #ffffff;\n    background-color: transparent; }\n  .rx-panel-item.active a,\n  .rx-panel-item a:hover {\n    color: #ffffff;\n    background-color: #0058FB; }\n\n.rx-editor, .rx-editor [data-rx-type], .rx-editor a, .rx-editor p, .rx-editor figcaption, .rx-editor td, .rx-editor th {\n  outline: none; }\n\n.rx-editor::after {\n  content: "";\n  clear: both;\n  display: table; }\n\n.rx-editor [data-rx-type=embed], .rx-editor [data-rx-type=embed] a,\n.rx-editor [data-rx-type=image],\n.rx-editor [data-rx-type=image] a {\n  cursor: pointer; }\n\n.rx-editor [data-rx-type=embed] figcaption,\n.rx-editor [data-rx-type=image] figcaption {\n  cursor: text; }\n\n.rx-editor [data-rx-type=embed].rx-block-focus,\n.rx-editor [data-rx-type=image].rx-block-focus,\n.rx-editor [data-rx-type=line].rx-block-focus,\n.rx-editor [data-rx-type=layer].rx-block-focus {\n  outline: 3px solid rgba(0, 88, 251, 0.4) !important; }\n\n.rx-editor [data-rx-type].rx-block-meta-focus {\n  outline: 3px solid rgba(0, 88, 251, 0.4) !important; }\n\n.rx-editor [data-rx-type=text] {\n  margin: 0;\n  line-height: 1.5; }\n  .rx-editor [data-rx-type=text]:empty {\n    min-height: 1.5em; }\n\n.rx-editor [data-rx-type=embed] {\n  position: relative; }\n  .rx-editor [data-rx-type=embed]:before {\n    width: 100%;\n    height: 100%;\n    content: "";\n    position: absolute;\n    z-index: 1; }\n  .rx-editor [data-rx-type=embed] iframe {\n    display: inline-block; }\n  .rx-editor [data-rx-type=embed] figcaption {\n    position: relative;\n    top: 0;\n    z-index: 2; }\n\n.rx-editor [data-placeholder]:empty:before {\n  content: attr(data-placeholder);\n  display: inline-block;\n  color: rgba(0, 11, 29, 0.4);\n  font-weight: normal;\n  font-style: italic;\n  font-size: inherit;\n  cursor: text;\n  max-height: 20px; }\n\n.rx-editor [data-placeholder]:empty:focus:before {\n  content: ""; }\n\n.rx-popup {\n  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Helvetica Neue", Arial, sans-serif;\n  border-radius: 4px;\n  background-color: #ffffff;\n  box-shadow: 0 14px 28px rgba(0, 11, 29, 0.25), 0 10px 10px rgba(0, 11, 29, 0.1);\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 100;\n  margin-bottom: 16px;\n  overflow-x: auto; }\n\n.rx-popup-body {\n  box-sizing: border-box;\n  padding: 0; }\n  .rx-popup-body form {\n    padding-bottom: 16px; }\n\n.rx-popup-items {\n  padding: 8px; }\n\n.rx-popup-type-grid .rx-popup-items {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0;\n  box-sizing: border-box; }\n\n.rx-popup-type-grid .rx-popup-item {\n  box-sizing: border-box;\n  border-radius: 0;\n  margin-bottom: -1px;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n  padding: 0;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid #D9DBDD;\n  color: #000B1D;\n  border-left-color: transparent;\n  border-top-color: transparent; }\n\n.rx-popup-type-grid .rx-popup-item svg {\n  width: 16px;\n  height: 16px; }\n\n.rx-popup-header {\n  font-size: 14px;\n  font-weight: bold;\n  color: #000B1D;\n  padding: 0 16px;\n  position: relative; }\n  .rx-popup-header:empty {\n    display: none; }\n  .rx-popup-header-box {\n    white-space: nowrap; }\n  .rx-popup-header-item {\n    position: relative;\n    display: inline-block;\n    color: #000B1D;\n    font-weight: bold;\n    padding-top: 16px;\n    padding-bottom: 16px;\n    margin-right: 8px;\n    padding-right: 8px;\n    text-decoration: none; }\n  .rx-popup-header-item:after {\n    content: '';\n    position: absolute;\n    right: 0;\n    top: 18px;\n    width: 1px;\n    height: 16px;\n    background-color: rgba(0, 11, 29, 0.2); }\n  .rx-popup-header-item:last-child {\n    margin-right: 0;\n    padding-right: 0; }\n  .rx-popup-header-item:last-child:after {\n    display: none; }\n  .rx-popup-header-item-link {\n    color: rgba(0, 11, 29, 0.6); }\n  .rx-popup-header-item-link:hover {\n    color: #000B1D;\n    text-decoration: underline; }\n  .rx-popup-header-item-link.active {\n    color: #000B1D;\n    text-decoration: none;\n    cursor: text; }\n\n.rx-popup-footer {\n  overflow: hidden;\n  box-sizing: border-box;\n  margin-top: 8px;\n  padding: 16px;\n  padding-bottom: 20px; }\n  .rx-popup-footer .rx-form-button {\n    margin-right: 4px; }\n  .rx-popup-footer:empty {\n    display: none; }\n\n.rx-popup-item {\n  font-size: 14px;\n  border-radius: 4px;\n  padding: 10px 8px;\n  display: flex;\n  line-height: 1;\n  align-items: center;\n  cursor: pointer;\n  position: relative; }\n  .rx-popup-item-container {\n    width: 92px;\n    height: 76px;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n    vertical-align: middle; }\n  .rx-popup-item-container .rx-popup-item-title {\n    flex: none;\n    font-size: 12px;\n    color: rgba(0, 11, 29, 0.6); }\n  .rx-popup-item-container .rx-popup-item-icon {\n    font-size: 16px;\n    margin-bottom: 10px;\n    margin-right: 0;\n    line-height: 1; }\n  .rx-popup-item-container .rx-popup-item-icon svg {\n    position: relative;\n    top: 2px; }\n  .rx-popup-item-title {\n    flex: 1; }\n  .rx-popup-item-icon {\n    font-size: 16px;\n    margin-right: 6px; }\n  .rx-popup-item-shortcut {\n    font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, Courier, monospace;\n    font-size: 11px;\n    color: rgba(0, 11, 29, 0.5);\n    margin-left: auto;\n    padding-top: 1px;\n    text-align: right; }\n  .rx-popup-item-shortcut b {\n    position: relative;\n    top: 2px;\n    font-weight: normal;\n    font-size: 14px; }\n  .rx-popup-item-image {\n    display: inline-block;\n    max-width: 38px !important;\n    height: auto;\n    padding: 4px;\n    border-radius: 4px;\n    background-color: #D9DBDD; }\n  .rx-popup-item-image > img,\n  .rx-popup-item-image > svg {\n    max-width: 30px !important;\n    height: auto;\n    display: inline-block; }\n  .rx-popup-item-trash {\n    font-size: 14px;\n    margin-left: auto;\n    color: rgba(0, 11, 29, 0.7); }\n  .rx-popup-item-trash:hover {\n    color: #000B1D; }\n  .rx-popup-item-hidden {\n    display: none; }\n  .rx-popup-item:hover {\n    background-color: #E4E8ED; }\n  .rx-popup-item.active {\n    background-color: rgba(0, 88, 251, 0.65);\n    color: #ffffff; }\n  .rx-popup-item.active span {\n    background: none !important;\n    color: #ffffff !important; }\n  .rx-popup-item-divider-top {\n    margin-top: 9px; }\n  .rx-popup-item-divider-top:before {\n    top: -5px; }\n  .rx-popup-item-divider-bottom {\n    margin-bottom: 9px; }\n  .rx-popup-item-divider-bottom:before {\n    bottom: -5px; }\n  .rx-popup-item-divider-top:before, .rx-popup-item-divider-bottom:before {\n    position: absolute;\n    content: '';\n    width: calc(100% - 8px);\n    height: 1px;\n    left: 4px;\n    background-color: rgba(0, 11, 29, 0.07); }\n\n.rx-popup-close {\n  position: absolute !important;\n  right: 16px;\n  top: 14px;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5; }\n  .rx-popup-close::before, .rx-popup-close::after {\n    content: "";\n    display: block;\n    left: 50%;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%) rotate(45deg);\n    background-color: #000B1D; }\n  .rx-popup-close::before {\n    height: 1px;\n    width: 75%; }\n  .rx-popup-close::after {\n    height: 75%;\n    width: 1px; }\n  .rx-popup-close:hover {\n    opacity: 1; }\n\n.rx-popup-list {\n  list-style: none;\n  margin: 0;\n  padding: 16px 8px;\n  padding-top: 0; }\n  .rx-popup-list li {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    border-radius: 4px;\n    line-height: 1;\n    border-bottom: 1px solid rgba(0, 11, 29, 0.07); }\n  .rx-popup-list li:last-child {\n    border-bottom-color: transparent; }\n  .rx-popup-list li:hover {\n    background-color: #E4E8ED; }\n  .rx-popup-list-item {\n    text-decoration: none;\n    flex: 1;\n    padding: 7px 8px;\n    font-size: 14px;\n    color: #000B1D; }\n  .rx-popup-list-aside {\n    font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, Courier, monospace;\n    font-size: 11px;\n    color: rgba(0, 11, 29, 0.5);\n    margin-left: auto;\n    padding-left: 4px; }\n\n.rx-popup.has-footer form,\n.rx-popup.has-form .rx-popup-header-item,\n.rx-popup.has-items .rx-popup-header-item {\n  padding-bottom: 0; }\n\n.rx-popup[dir=rtl] .rx-popup-close {\n  right: auto;\n  left: 20px; }\n\n.rx-form-item {\n  padding: 16px 16px 0 16px; }\n  .rx-form-item:empty {\n    display: none; }\n\n.rx-form-image img,\n.rx-form-image svg {\n  max-width: 100%; }\n\n.rx-form-label {\n  box-sizing: border-box;\n  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Helvetica Neue", Arial, sans-serif;\n  font-size: 14px;\n  font-weight: bold;\n  display: block;\n  padding: 0;\n  margin: 0;\n  padding-bottom: 6px;\n  color: rgba(0, 11, 29, 0.65); }\n\n.rx-form-container-flex {\n  display: flex; }\n  .rx-form-container-flex .rx-form-input,\n  .rx-form-container-flex .rx-form-select {\n    flex: auto; }\n  .rx-form-container-flex .rx-form-button {\n    margin-left: 4px; }\n\n.rx-form-button-push-right {\n  float: right; }\n\n.rx-form-button {\n  box-sizing: border-box;\n  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Helvetica Neue", Arial, sans-serif;\n  font-size: 14px;\n  font-weight: bold;\n  outline: none;\n  border-radius: 4px;\n  padding: 8px 24px;\n  min-height: 38px;\n  cursor: pointer;\n  line-height: 1.25;\n  height: auto;\n  background-color: #ffffff;\n  border: 1px solid #D9DBDD;\n  color: rgba(0, 11, 29, 0.9); }\n  .rx-form-button:hover {\n    color: rgba(0, 11, 29, 0.9);\n    background-color: #F5F5F6; }\n\n.rx-form-button-primary {\n  background-color: #000B1D;\n  border: 1px solid #000B1D;\n  color: #ffffff; }\n  .rx-form-button-primary:hover {\n    color: #ffffff;\n    background-color: #262F3F; }\n\n.rx-form-button-danger {\n  background-color: #ffffff;\n  border: 1px solid #BF3D66;\n  color: #BF3D66; }\n  .rx-form-button-danger:hover {\n    color: #BF3D66;\n    background-color: #F5F5F6; }\n\n.rx-form-button-fullwidth {\n  display: block;\n  width: 100%; }\n\n.rx-form-input,\n.rx-form-select,\n.rx-form-textarea {\n  box-sizing: border-box;\n  display: block;\n  width: 100%;\n  vertical-align: middle;\n  font-weight: normal;\n  padding: 8px;\n  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Helvetica Neue", Arial, sans-serif;\n  font-size: 15px;\n  outline: none;\n  border-radius: 4px;\n  box-shadow: none;\n  line-height: 1.3;\n  color: #000B1D;\n  background-color: #F5F5F6;\n  border: 1px solid #D9DBDD; }\n  .rx-form-input:focus,\n  .rx-form-select:focus,\n  .rx-form-textarea:focus {\n    border-color: rgba(0, 88, 251, 0.5);\n    box-shadow: 0 1px 2px rgba(0, 11, 29, 0.13) inset, 0 0 2px rgba(0, 88, 251, 0.4); }\n\n.rx-form-textarea {\n  resize: vertical;\n  line-height: 1.5; }\n\n.rx-form-select {\n  font-size: 15px;\n  cursor: pointer;\n  -webkit-appearance: none;\n  background-image: url(${f});\n  background-repeat: no-repeat;\n  background-position: right 0.65em center;\n  padding-right: 28px;\n  min-height: 35px; }\n\n.rx-form-checkbox {\n  box-sizing: border-box;\n  vertical-align: middle;\n  position: relative;\n  bottom: -0.1em;\n  margin-top: 0 !important;\n  margin-right: 4px !important;\n  margin-left: 0 !important;\n  font-size: 15px; }\n\n.rx-popup[dir=rtl] .rx-form-checkbox {\n  margin-right: 0 !important;\n  margin-left: 4px !important; }\n\n.rx-form-checkbox-item span {\n  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Helvetica Neue", Arial, sans-serif;\n  font-size: 14px;\n  font-weight: normal;\n  color: #000B1D; }\n\n.rx-form-segment {\n  display: flex;\n  flex-wrap: wrap;\n  background-color: #F0F1F1;\n  border-radius: 4px;\n  padding: 2px;\n  gap: 4px; }\n\n.rx-form-segment-item {\n  border: 1px solid transparent;\n  font-size: 16px;\n  padding: 8px 5px;\n  margin: 0;\n  cursor: pointer;\n  flex: auto;\n  text-align: center;\n  border-radius: 4px;\n  min-width: 32px;\n  color: rgba(0, 11, 29, 0.6); }\n  .rx-form-segment-item:hover {\n    background-color: #ffffff;\n    color: #000B1D; }\n  .rx-form-segment-item.active {\n    cursor: default;\n    background-color: #ffffff;\n    box-shadow: 0 1px 3px rgba(0, 11, 29, 0.12), 0 1px 2px rgba(0, 11, 29, 0.2);\n    color: #000B1D; }\n\n.rx-form-upload-box {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  margin-bottom: 10px;\n  border: 2px dashed rgba(0, 11, 29, 0.12);\n  background-color: #F5F5F6;\n  border-radius: 4px;\n  min-width: 160px;\n  height: 160px;\n  cursor: pointer;\n  position: relative; }\n  .rx-form-upload-box input[type="file"] {\n    font-size: 13px; }\n  .rx-form-upload-box img {\n    position: relative;\n    z-index: 2;\n    object-fit: cover;\n    height: 100%;\n    width: 100%; }\n  .rx-form-upload-box:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 100%; }\n  .rx-form-upload-box.rx-form-upload-hover {\n    border-color: rgba(0, 88, 251, 0.35);\n    background-color: rgba(0, 88, 251, 0.05); }\n  .rx-form-upload-box.rx-form-upload-error {\n    border-color: rgba(255, 79, 127, 0.35);\n    background-color: rgba(255, 79, 127, 0.05); }\n\n.rx-upload-remove {\n  position: absolute;\n  z-index: 3;\n  top: -6px;\n  right: -10px;\n  background-color: #FF4F7F;\n  color: #ffffff;\n  opacity: 1;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  border-radius: 10px;\n  font-size: 14px;\n  line-height: 20px; }\n  .rx-upload-remove:after {\n    content: '\\00d7'; }\n  .rx-upload-remove:hover {\n    background-color: #000B1D; }\n\n.rx-form-upload-cover-off img {\n  object-fit: initial;\n  height: auto;\n  width: auto; }\n\n.rx-form-upload-placeholder {\n  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Helvetica Neue", Arial, sans-serif;\n  color: rgba(0, 11, 29, 0.5);\n  font-size: 12px;\n  line-height: 1.35;\n  padding: 0 8px;\n  text-align: center; }\n  .rx-form-upload-placeholder svg {\n    fill: rgba(0, 11, 29, 0.5); }\n\n.rx-popup-addbar .rx-popup-items {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 4px; }\n\n.rx-popup-image .rx-popup-body,\n.rx-popup-stack-image .rx-popup-body {\n  padding: 16px;\n  padding-top: 0; }\n\n.rx-popup-image-section-or {\n  margin: 16px 0;\n  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Helvetica Neue", Arial, sans-serif;\n  text-transform: uppercase;\n  font-weight: bold;\n  text-align: center;\n  font-size: 12px;\n  color: #000B1D; }\n\n.rx-popup-images-box {\n  margin-top: 12px; }\n  .rx-popup-images-box img {\n    vertical-align: top;\n    max-width: 100px;\n    height: auto;\n    cursor: pointer;\n    margin-bottom: 8px;\n    margin-right: 8px; }\n  .rx-popup-images-box img:hover {\n    outline: 3px solid rgba(0, 88, 251, 0.5); }\n\n.rx-form-item-edit-image-box {\n  padding: 20px;\n  padding-bottom: 0; }\n\n.rx-form-item-image {\n  margin-right: 8px; }\n  .rx-form-item-image img {\n    max-height: 160px;\n    width: auto; }\n\n.rx-popup-shortcut-item {\n  border-radius: 0;\n  border-bottom: 1px solid rgba(0, 11, 29, 0.08);\n  cursor: text; }\n  .rx-popup-shortcut-item:hover {\n    background-color: transparent; }\n  .rx-popup-shortcut-item:last-child {\n    border-bottom-color: transparent; }\n\n.rx-popup-shortcut-title {\n  font-size: 14px;\n  line-height: 20px;\n  color: #000B1D;\n  margin-right: 16px; }\n\n.rx-popup-shortcut-kbd {\n  white-space: nowrap;\n  line-height: 20px;\n  font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, Courier, monospace;\n  font-size: 12px;\n  padding: 0;\n  display: inline-block;\n  color: rgba(0, 11, 29, 0.65);\n  margin-left: auto;\n  text-align: right; }\n  .rx-popup-shortcut-kbd span {\n    display: inline-block;\n    border-radius: 4px;\n    padding-left: 3px;\n    padding-right: 3px;\n    color: rgba(0, 11, 29, 0.85);\n    background-color: #F5F5F6; }\n  .rx-popup-shortcut-kbd b {\n    font-weight: normal;\n    font-size: 18px;\n    display: inline-block;\n    line-height: 12px;\n    position: relative;\n    top: 3px; }\n`,"",{version:3,sources:["webpack://./node_modules/sp-ui/dist/assets/vendor/redactorx/redactorx.css"],names:[],mappings:"AAAA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,cAAc;EACd,SAAS;EACT,UAAU;EACV,wBAAwB,EAAE;;AAE5B;;;;;;;;;;;;;EAaE,iBAAiB,EAAE;;AAErB;EACE,iBAAiB,EAAE;;AAErB;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe,EAAE;;AAEnB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,iBAAiB,EAAE;;AAErB;EACE,eAAe;EACf,YAAY,EAAE;;AAEhB;;EAEE,sBAAsB,EAAE;;AAE1B;EACE,cAAc;EACd,MAAM,EAAE;EACR;IACE,gBAAgB,EAAE;;AAEtB;EACE,6HAA6H;EAC7H,eAAe;EACf,gBAAgB,EAAE;EAClB;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;;;IAGE,cAAc,EAAE;EAClB;IACE,eAAe;IACf,gBAAgB,EAAE;EACpB;;;;;;IAME,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kCAAkC;IAClC,uBAAuB,EAAE;IACzB;;;;;;;;;;;;;;;;;;MAkBE,cAAc;MACd,qBAAqB,EAAE;EAC3B;IACE,eAAe;IACf,gBAAgB,EAAE;EACpB;IACE,eAAe;IACf,gBAAgB,EAAE;EACpB;IACE,eAAe;IACf,gBAAgB,EAAE;EACpB;;IAEE,iBAAiB,EAAE;EACrB;IACE,eAAe;IACf,gBAAgB,EAAE;EACpB;IACE,cAAc,EAAE;EAClB;IACE,eAAe;IACf,gBAAgB,EAAE;EACpB;IACE,iBAAiB,EAAE;EACrB;IACE,kBAAkB,EAAE;EACtB;IACE,cAAc;IACd,gBAAgB;IAChB,mFAAmF;IACnF,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,YAAY,EAAE;EAChB;IACE,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,oBAAoB,EAAE;EACxB;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,uBAAuB,EAAE;IACzB;MACE,cAAc;MACd,eAAe;MACf,gBAAgB,EAAE;IACpB;MACE,eAAe,EAAE;EACrB;;IAEE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,4BAA4B,EAAE;EAChC;IACE,gBAAgB;IAChB,kBAAkB,EAAE;EACtB;IACE,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;IACX,iBAAiB,EAAE;EACrB;;IAEE,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,0CAA0C,EAAE;EAC9C;IACE,mBAAmB,EAAE;EACvB;IACE,iBAAiB,EAAE;EACrB;IACE,kBAAkB,EAAE;EACtB;;IAEE,cAAc,EAAE;EAClB;;;;;;;IAOE,cAAc,EAAE;EAClB;;IAEE,cAAc,EAAE;EAClB;;;;IAIE,qBAAqB;IACrB,mFAAmF;IACnF,kBAAkB;IAClB,cAAc;IACd,4BAA4B;IAC5B,wBAAwB,EAAE;EAC5B;;;IAGE,kBAAkB,EAAE;EACtB;IACE,uCAAuC;IACvC,kBAAkB,EAAE;EACtB;IACE,kBAAkB;IAClB,SAAS;IACT,6BAA6B;IAC7B,yBAAyB;IACzB,uBAAuB,EAAE;EAC3B;IACE,wBAAwB;IACxB,YAAY,EAAE;EAChB;;IAEE,gBAAgB,EAAE;EACpB;;IAEE,qBAAqB;IACrB,yBAAyB;IACzB,qBAAqB;IACrB,4CAA4C;IAC5C,YAAY,EAAE;EAChB;IACE,kBAAkB,EAAE;EACtB;;IAEE,cAAc;IACd,gBAAgB,EAAE;EACpB;IACE,mBAAmB,EAAE;EACvB;IACE,qBAAqB,EAAE;EACzB;;;;IAIE,sBAAsB,EAAE;EAC1B;IACE,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB,EAAE;EACpB;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,sBAAsB;IACtB,iBAAiB;IACjB,SAAS,EAAE;IACX;MACE,kBAAkB;MAClB,MAAM;MACN,OAAO;MACP,WAAW;MACX,YAAY,EAAE;EAClB;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,YAAY,EAAE;IACd;MACE,WAAW;MACX,kBAAkB;MAClB,QAAQ,EAAE;IACZ;MACE,WAAW;MACX,eAAe;MACf,kBAAkB;MAClB,qBAAqB;MACrB,uBAAuB;MACvB,0CAA0C,EAAE;EAChD;IACE,iBAAiB,EAAE;EACrB;IACE,kBAAkB,EAAE;EACtB;IACE,mBAAmB,EAAE;EACvB;;;IAGE,cAAc,EAAE;EAClB;;;IAGE,kBAAkB,EAAE;EACtB;IACE,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB,EAAE;EACpB;IACE,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB,EAAE;;AAEtB;EACE;IACE,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,gBAAgB,EAAE,EAAE;;AAExB;EACE;IACE,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,gBAAgB,EAAE,EAAE;;AAExB;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE;;AAElB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,sCAAsC,EAAE;;AAE1C;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB,EAAE;EAC1B;IACE,QAAQ;IACR,SAAS,EAAE;EACb;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,aAAa,EAAE;EACjB;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,2CAA2C;IAC3C,6CAA6C,EAAE;EACjD;IACE,kBAAkB;IAClB,iBAAiB;IACjB,aAAa,EAAE;EACjB;IACE,wBAAwB;IACxB,gBAAgB;IAChB,MAAM,EAAE;;AAEZ;EACE,sBAAsB,EAAE;;AAE1B;EACE,aAAa,EAAE;;AAEjB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,UAAU;EACV,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,yBAAyB,EAAE;;AAE7B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,UAAU;EACV,SAAS;EACT,cAAc,EAAE;;AAElB;EACE,kBAAkB;EAClB,QAAQ,EAAE;;AAEZ;;;EAGE,gBAAgB;EAChB,sBAAsB;EACtB,mFAAmF;EACnF,WAAW;EACX,cAAc;EACd,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB,EAAE;;AAEpB;EACE,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,mDAAmD;EACnD,mBAAmB,EAAE;;AAEvB;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU,EAAE;EACZ;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,MAAM;IACN,OAAO;IACP,wCAAwC;IACxC,kBAAkB;IAClB,UAAU,EAAE;;AAEhB;EACE,aAAa;EACb,yBAAyB;EACzB,wDAAwD,EAAE;EAC1D;IACE,eAAe,EAAE;;AAErB;EACE,aAAa,EAAE;;AAEjB;EACE;IACE,2BAA2B,EAAE;EAC/B;IACE,wBAAwB,EAAE,EAAE;;AAEhC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX,sCAAsC,EAAE;EACxC;IACE,kDAAkD;IAClD,WAAW;IACX,cAAc;IACd,eAAe;IACf,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,0MAA0M;IAC1M,kMAAkM;IAClM,0BAA0B,EAAE;;AAEhC;EACE,8BAA8B,EAAE;;AAElC;EACE,YAAY,EAAE;;AAEhB;EACE,kBAAkB;EAClB,UAAU;EACV,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY,EAAE;;AAEhB;EACE,wBAAwB;EACxB,+DAA4iU;EAC5iU,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB,EAAE;;AAEvB;EACE,+EAA+E;EAC/E,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC,EAAE;;AAEtC;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;;EAEE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;;;EAGE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,eAAe,EAAE;EACjB;IACE,qBAAqB,EAAE;EACzB;IACE,oBAAoB,EAAE;EACxB;IACE,qBAAqB,EAAE;;AAE3B;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B,EAAE;;AAEjC;EACE,WAAW;EACX,2BAA2B,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,gCAAgC,EAAE;;AAEpC;EACE,iBAAiB,EAAE;;AAErB;EACE,kBAAkB,EAAE;;AAEtB;EACE,+BAA+B,EAAE;;AAEnC;EACE,0CAA0C;EAC1C,gCAAgC,EAAE;;AAEpC;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,cAAc,EAAE;EAChB;IACE,aAAa,EAAE;EACjB;IACE,yBAAyB,EAAE;;AAE/B;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,YAAY,EAAE;;AAEhB;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB,EAAE;;AAEpB;;EAEE,2BAA2B,EAAE;EAC7B;;IAEE,0BAA0B,EAAE;EAC9B;;IAEE,qBAAqB;IACrB,0CAA0C,EAAE;EAC9C;;IAEE,yBAAyB;IACzB,cAAc,EAAE;IAChB;;MAEE,aAAa,EAAE;EACnB;;;IAGE,eAAe;IACf,wCAAwC;IACxC,sCAAsC,EAAE;EAC1C;;IAEE,qCAAqC,EAAE;EACzC;;IAEE,wCAAwC;IACxC,sCAAsC,EAAE;EAC1C;;IAEE,2BAA2B;IAC3B,yBAAyB;IACzB,cAAc,EAAE;IAChB;;MAEE,aAAa,EAAE;IACjB;;MAEE,yBAAyB,EAAE;;AAEjC;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mFAAmF;EACnF,eAAe;EACf,gCAAgC;EAChC,yBAAyB,EAAE;;AAE7B;EACE,mFAAmF;EACnF,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY,EAAE;EACd;IACE,aAAa,EAAE;EACjB;IACE,WAAW;IACX,eAAe;IACf,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB,2BAA2B;IAC3B,4CAA4C,EAAE;EAChD;IACE,+BAA+B,EAAE;EACnC;IACE,2BAA2B;IAC3B,0BAA0B,EAAE;EAC9B;IACE,cAAc;IACd,0BAA0B,EAAE;;AAEhC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,WAAW;EACX,6HAA6H;EAC7H,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB,EAAE;EAC3B;IACE,sBAAsB;IACtB,YAAY;IACZ,kDAAkD,EAAE;EACtD;IACE,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,qBAAqB;IACrB,cAAc;IACd,6BAA6B,EAAE;EACjC;;IAEE,cAAc;IACd,yBAAyB,EAAE;;AAE/B;EACE,aAAa,EAAE;;AAEjB;EACE,WAAW;EACX,WAAW;EACX,cAAc,EAAE;;AAElB;;;EAGE,eAAe,EAAE;;AAEnB;;EAEE,YAAY,EAAE;;AAEhB;;;;EAIE,mDAAmD,EAAE;;AAEvD;EACE,mDAAmD,EAAE;;AAEvD;EACE,SAAS;EACT,gBAAgB,EAAE;EAClB;IACE,iBAAiB,EAAE;;AAEvB;EACE,kBAAkB,EAAE;EACpB;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU,EAAE;EACd;IACE,qBAAqB,EAAE;EACzB;IACE,kBAAkB;IAClB,MAAM;IACN,UAAU,EAAE;;AAEhB;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB,EAAE;;AAEpB;EACE,WAAW,EAAE;;AAEf;EACE,6HAA6H;EAC7H,kBAAkB;EAClB,yBAAyB;EACzB,+EAA+E;EAC/E,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,gBAAgB,EAAE;;AAEpB;EACE,sBAAsB;EACtB,UAAU,EAAE;EACZ;IACE,oBAAoB,EAAE;;AAE1B;EACE,YAAY,EAAE;;AAEhB;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,8BAA8B;EAC9B,6BAA6B,EAAE;;AAEjC;EACE,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB,EAAE;EACpB;IACE,aAAa,EAAE;EACjB;IACE,mBAAmB,EAAE;EACvB;IACE,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB,EAAE;EACzB;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,YAAY;IACZ,sCAAsC,EAAE;EAC1C;IACE,eAAe;IACf,gBAAgB,EAAE;EACpB;IACE,aAAa,EAAE;EACjB;IACE,2BAA2B,EAAE;EAC/B;IACE,cAAc;IACd,0BAA0B,EAAE;EAC9B;IACE,cAAc;IACd,qBAAqB;IACrB,YAAY,EAAE;;AAElB;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,oBAAoB,EAAE;EACtB;IACE,iBAAiB,EAAE;EACrB;IACE,aAAa,EAAE;;AAEnB;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB,EAAE;EACpB;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB,EAAE;EAC1B;IACE,UAAU;IACV,eAAe;IACf,2BAA2B,EAAE;EAC/B;IACE,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,cAAc,EAAE;EAClB;IACE,kBAAkB;IAClB,QAAQ,EAAE;EACZ;IACE,OAAO,EAAE;EACX;IACE,eAAe;IACf,iBAAiB,EAAE;EACrB;IACE,mFAAmF;IACnF,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB,EAAE;EACrB;IACE,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,eAAe,EAAE;EACnB;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,yBAAyB,EAAE;EAC7B;;IAEE,0BAA0B;IAC1B,YAAY;IACZ,qBAAqB,EAAE;EACzB;IACE,eAAe;IACf,iBAAiB;IACjB,2BAA2B,EAAE;EAC/B;IACE,cAAc,EAAE;EAClB;IACE,aAAa,EAAE;EACjB;IACE,yBAAyB,EAAE;EAC7B;IACE,wCAAwC;IACxC,cAAc,EAAE;EAClB;IACE,2BAA2B;IAC3B,yBAAyB,EAAE;EAC7B;IACE,eAAe,EAAE;EACnB;IACE,SAAS,EAAE;EACb;IACE,kBAAkB,EAAE;EACtB;IACE,YAAY,EAAE;EAChB;IACE,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,WAAW;IACX,SAAS;IACT,uCAAuC,EAAE;;AAE7C;EACE,6BAA6B;EAC7B,WAAW;EACX,SAAS;EACT,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,YAAY,EAAE;EACd;IACE,WAAW;IACX,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,QAAQ;IACR,8CAA8C;IAC9C,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,UAAU,EAAE;EACd;IACE,WAAW;IACX,UAAU,EAAE;EACd;IACE,UAAU,EAAE;;AAEhB;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,cAAc,EAAE;EAChB;IACE,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,8CAA8C,EAAE;EAClD;IACE,gCAAgC,EAAE;EACpC;IACE,yBAAyB,EAAE;EAC7B;IACE,qBAAqB;IACrB,OAAO;IACP,gBAAgB;IAChB,eAAe;IACf,cAAc,EAAE;EAClB;IACE,mFAAmF;IACnF,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,iBAAiB,EAAE;;AAEvB;;;EAGE,iBAAiB,EAAE;;AAErB;EACE,WAAW;EACX,UAAU,EAAE;;AAEd;EACE,yBAAyB,EAAE;EAC3B;IACE,aAAa,EAAE;;AAEnB;;EAEE,eAAe,EAAE;;AAEnB;EACE,sBAAsB;EACtB,6HAA6H;EAC7H,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,4BAA4B,EAAE;;AAEhC;EACE,aAAa,EAAE;EACf;;IAEE,UAAU,EAAE;EACd;IACE,gBAAgB,EAAE;;AAEtB;EACE,YAAY,EAAE;;AAEhB;EACE,sBAAsB;EACtB,6HAA6H;EAC7H,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B,EAAE;EAC7B;IACE,2BAA2B;IAC3B,yBAAyB,EAAE;;AAE/B;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc,EAAE;EAChB;IACE,cAAc;IACd,yBAAyB,EAAE;;AAE/B;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc,EAAE;EAChB;IACE,cAAc;IACd,yBAAyB,EAAE;;AAE/B;EACE,cAAc;EACd,WAAW,EAAE;;AAEf;;;EAGE,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,6HAA6H;EAC7H,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,yBAAyB,EAAE;EAC3B;;;IAGE,mCAAmC;IACnC,gFAAgF,EAAE;;AAEtF;EACE,gBAAgB;EAChB,gBAAgB,EAAE;;AAEpB;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,yDAAkX;EAClX,4BAA4B;EAC5B,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB,EAAE;;AAEpB;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,eAAe,EAAE;;AAEnB;EACE,0BAA0B;EAC1B,2BAA2B,EAAE;;AAE/B;EACE,6HAA6H;EAC7H,eAAe;EACf,mBAAmB;EACnB,cAAc,EAAE;;AAElB;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,QAAQ,EAAE;;AAEZ;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,2BAA2B,EAAE;EAC7B;IACE,yBAAyB;IACzB,cAAc,EAAE;EAClB;IACE,eAAe;IACf,yBAAyB;IACzB,2EAA2E;IAC3E,cAAc,EAAE;;AAEpB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,kBAAkB,EAAE;EACpB;IACE,eAAe,EAAE;EACnB;IACE,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,YAAY;IACZ,WAAW,EAAE;EACf;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,YAAY,EAAE;EAChB;IACE,oCAAoC;IACpC,wCAAwC,EAAE;EAC5C;IACE,sCAAsC;IACtC,0CAA0C,EAAE;;AAEhD;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB,EAAE;EACnB;IACE,gBAAgB,EAAE;EACpB;IACE,yBAAyB,EAAE;;AAE/B;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW,EAAE;;AAEf;EACE,6HAA6H;EAC7H,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB,EAAE;EACpB;IACE,0BAA0B,EAAE;;AAEhC;EACE,aAAa;EACb,eAAe;EACf,YAAY,EAAE;;AAEhB;;EAEE,aAAa;EACb,cAAc,EAAE;;AAElB;EACE,cAAc;EACd,6HAA6H;EAC7H,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc,EAAE;;AAElB;EACE,gBAAgB,EAAE;EAClB;IACE,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iBAAiB,EAAE;EACrB;IACE,wCAAwC,EAAE;;AAE9C;EACE,aAAa;EACb,iBAAiB,EAAE;;AAErB;EACE,iBAAiB,EAAE;EACnB;IACE,iBAAiB;IACjB,WAAW,EAAE;;AAEjB;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,YAAY,EAAE;EACd;IACE,6BAA6B,EAAE;EACjC;IACE,gCAAgC,EAAE;;AAEtC;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB,EAAE;;AAEtB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mFAAmF;EACnF,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB,EAAE;EACnB;IACE,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;IAC5B,yBAAyB,EAAE;EAC7B;IACE,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ,EAAE",sourcesContent:['.rx-reset * {\n  box-sizing: border-box;\n  background: transparent;\n  border: 0;\n  font-size: 100%;\n  line-height: 1;\n  margin: 0;\n  padding: 0;\n  vertical-align: baseline; }\n\n.rx-reset h1:empty,\n.rx-reset h2:empty,\n.rx-reset h3:empty,\n.rx-reset h4:empty,\n.rx-reset h5:empty,\n.rx-reset h6:empty,\n.rx-reset p:empty,\n.rx-reset li:empty,\n.rx-reset dt:empty,\n.rx-reset dd:empty,\n.rx-reset address:empty,\n.rx-reset figcaption:empty,\n.rx-reset blockquote:empty {\n  min-height: 1.5em; }\n\n.rx-reset pre:empty {\n  min-height: 3.5em; }\n\n.rx-reset strong:empty, .rx-reset b:empty, .rx-reset em:empty, .rx-reset i:empty, .rx-reset span:empty, .rx-reset sup:empty, .rx-reset sub:empty, .rx-reset u:empty, .rx-reset ins:empty, .rx-reset code:empty {\n  display: inline-block;\n  min-width: 1px;\n  min-height: 1em; }\n\n.rx-reset code:after, .rx-reset kbd:after, .rx-reset mark:after, .rx-reset th:after, .rx-reset td:after {\n  content: \'\\200B\'; }\n\n.rx-reset code + code {\n  margin-left: 2px; }\n\n.rx-reset table {\n  empty-cells: show; }\n\n.rx-reset embed, .rx-reset img, .rx-reset object {\n  max-width: 100%;\n  height: auto; }\n\n.rx-reset figure > img,\n.rx-reset figure > iframe {\n  vertical-align: middle; }\n\n.rx-reset figcaption {\n  display: block;\n  top: 0; }\n  .rx-reset figcaption:empty {\n    min-height: 18px; }\n\n.rx-content {\n  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Helvetica Neue", Arial, sans-serif;\n  font-size: 16px;\n  line-height: 1.5; }\n  .rx-content h1 + *, .rx-content h2 + *, .rx-content h3 + *, .rx-content h4 + *, .rx-content h5 + *, .rx-content h6 + * {\n    margin-top: 12px; }\n  .rx-content p + h2, .rx-content ul + h2, .rx-content ol + h2, .rx-content blockquote + h2, .rx-content figure + h2, .rx-content pre + h2, .rx-content table + h2, .rx-content dl + h2, .rx-content address + h2 {\n    margin-top: 24px; }\n  .rx-content p + h3, .rx-content ul + h3, .rx-content ol + h3, .rx-content blockquote + h3, .rx-content figure + h3, .rx-content pre + h3, .rx-content table + h3, .rx-content dl + h3, .rx-content address + h3 {\n    margin-top: 24px; }\n  .rx-content p + h4, .rx-content ul + h4, .rx-content ol + h4, .rx-content blockquote + h4, .rx-content figure + h4, .rx-content pre + h4, .rx-content table + h4, .rx-content dl + h4, .rx-content address + h4 {\n    margin-top: 24px; }\n  .rx-content p + h5, .rx-content ul + h5, .rx-content ol + h5, .rx-content blockquote + h5, .rx-content figure + h5, .rx-content pre + h5, .rx-content table + h5, .rx-content dl + h5, .rx-content address + h5 {\n    margin-top: 24px; }\n  .rx-content p + h6, .rx-content ul + h6, .rx-content ol + h6, .rx-content blockquote + h6, .rx-content figure + h6, .rx-content pre + h6, .rx-content table + h6, .rx-content dl + h6, .rx-content address + h6 {\n    margin-top: 24px; }\n  .rx-content p + *, .rx-content ul + *, .rx-content ol + *, .rx-content blockquote + *, .rx-content figure + *, .rx-content pre + *, .rx-content table + *, .rx-content dl + *, .rx-content address + * {\n    margin-top: 16px; }\n  .rx-content div + * {\n    margin-top: 24px; }\n  .rx-content h1 + h2 {\n    margin-top: 24px; }\n  .rx-content h2 + h3 {\n    margin-top: 24px; }\n  .rx-content h3 + h4 {\n    margin-top: 24px; }\n  .rx-content h4 + h5 {\n    margin-top: 24px; }\n  .rx-content h5 + h6 {\n    margin-top: 24px; }\n  .rx-content a,\n  .rx-content a:hover,\n  .rx-content a:focus {\n    color: #0044C3; }\n  .rx-content p {\n    font-size: 16px;\n    line-height: 1.5; }\n  .rx-content h1,\n  .rx-content h2,\n  .rx-content h3,\n  .rx-content h4,\n  .rx-content h5,\n  .rx-content h6 {\n    font-family: inherit;\n    font-weight: bold;\n    font-style: normal;\n    font-size: 16px;\n    line-height: 1.5;\n    color: #000B1D;\n    text-rendering: optimizeLegibility;\n    letter-spacing: -0.01em; }\n    .rx-content h1 a,\n    .rx-content h1 a:focus,\n    .rx-content h1 a:hover,\n    .rx-content h2 a,\n    .rx-content h2 a:focus,\n    .rx-content h2 a:hover,\n    .rx-content h3 a,\n    .rx-content h3 a:focus,\n    .rx-content h3 a:hover,\n    .rx-content h4 a,\n    .rx-content h4 a:focus,\n    .rx-content h4 a:hover,\n    .rx-content h5 a,\n    .rx-content h5 a:focus,\n    .rx-content h5 a:hover,\n    .rx-content h6 a,\n    .rx-content h6 a:focus,\n    .rx-content h6 a:hover {\n      color: inherit;\n      text-decoration: none; }\n  .rx-content h1 {\n    font-size: 40px;\n    line-height: 1.2; }\n  .rx-content h2 {\n    font-size: 24px;\n    line-height: 1.3; }\n  .rx-content h3 {\n    font-size: 21px;\n    line-height: 1.5; }\n  .rx-content ul,\n  .rx-content ol {\n    margin-left: 20px; }\n  .rx-content li {\n    font-size: 16px;\n    line-height: 1.5; }\n  .rx-content li li {\n    font-size: 1em; }\n  .rx-content dt, .rx-content dd {\n    font-size: 16px;\n    line-height: 1.5; }\n  .rx-content dt {\n    font-weight: bold; }\n  .rx-content dd + dt {\n    margin-top: 0.25em; }\n  .rx-content pre {\n    overflow: auto;\n    white-space: pre;\n    font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, Courier, monospace;\n    font-size: 90%;\n    line-height: 1.5;\n    color: #262F3F;\n    background-color: #F5F5F6;\n    padding: 1em; }\n  .rx-content pre code {\n    padding: 0;\n    border: 0;\n    background: none;\n    font-size: 100%;\n    display: block;\n    line-height: inherit; }\n  .rx-content blockquote {\n    color: #262F3F;\n    font-style: italic;\n    font-weight: normal;\n    padding: 0;\n    background: transparent; }\n    .rx-content blockquote p {\n      color: #262F3F;\n      font-size: 125%;\n      line-height: 1.5; }\n    .rx-content blockquote p + p {\n      margin-top: 4px; }\n  .rx-content blockquote cite,\n  .rx-content figcaption cite {\n    font-style: inherit;\n    font-size: 14px;\n    line-height: 1.5;\n    color: rgba(38, 47, 63, 0.7); }\n  .rx-content caption {\n    text-align: left;\n    font-style: normal; }\n  .rx-content table {\n    border-collapse: collapse;\n    border-spacing: 0;\n    width: 100%;\n    empty-cells: show; }\n  .rx-content td,\n  .rx-content th {\n    text-align: left;\n    vertical-align: top;\n    font-size: 95%;\n    line-height: 1.5;\n    padding: 0.75em;\n    border: 1px solid rgba(217, 219, 221, 0.5); }\n  .rx-content th {\n    font-weight: normal; }\n  .rx-content thead th {\n    font-weight: bold; }\n  .rx-content address {\n    font-style: normal; }\n  .rx-content dfn,\n  .rx-content abbr {\n    font-size: 95%; }\n  .rx-content time,\n  .rx-content cite,\n  .rx-content small,\n  .rx-content var,\n  .rx-content samp,\n  .rx-content kbd,\n  .rx-content code {\n    font-size: 85%; }\n  .rx-content sup,\n  .rx-content sub {\n    font-size: 65%; }\n  .rx-content var,\n  .rx-content code,\n  .rx-content kbd,\n  .rx-content samp {\n    display: inline-block;\n    font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, Courier, monospace;\n    font-style: normal;\n    line-height: 1;\n    color: rgba(0, 11, 29, 0.85);\n    vertical-align: baseline; }\n  .rx-content samp,\n  .rx-content kbd,\n  .rx-content code {\n    border-radius: 2px; }\n  .rx-content kbd {\n    border: 1px solid rgba(0, 11, 29, 0.15);\n    padding: .2em .4em; }\n  .rx-content code {\n    position: relative;\n    top: -1px;\n    border: 1px solid transparent;\n    background-color: #F5F5F6;\n    padding: .2em .4em .2em; }\n  .rx-content mark {\n    background-color: yellow;\n    color: black; }\n  .rx-content b,\n  .rx-content strong {\n    font-weight: 600; }\n  .rx-content dfn[title],\n  .rx-content abbr[title] {\n    letter-spacing: .01em;\n    text-transform: uppercase;\n    text-decoration: none;\n    border-bottom: 1px dotted rgba(0, 0, 0, 0.4);\n    cursor: help; }\n  .rx-content cite {\n    font-style: italic; }\n  .rx-content sub,\n  .rx-content sup {\n    line-height: 1;\n    margin-left: 2px; }\n  .rx-content sub {\n    vertical-align: sub; }\n  .rx-content sup {\n    vertical-align: super; }\n  .rx-content figure > img,\n  .rx-content figure > iframe,\n  .rx-content figure > pre,\n  .rx-content figure > div {\n    vertical-align: middle; }\n  .rx-content figure figcaption {\n    display: block;\n    font-style: normal;\n    margin-top: 0.25em;\n    font-size: 12px;\n    line-height: 1.5; }\n  .rx-content .embed-responsive {\n    position: relative;\n    padding: 0;\n    margin: 0;\n    padding-bottom: 56.25%;\n    padding-top: 25px;\n    height: 0; }\n    .rx-content .embed-responsive iframe {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%; }\n  .rx-content hr {\n    position: relative;\n    line-height: 1;\n    background: none;\n    border: none;\n    text-align: left;\n    margin-top: 1em;\n    margin-bottom: 1em;\n    height: 10px; }\n    .rx-content hr:before {\n      content: \'\';\n      position: absolute;\n      top: 50%; }\n    .rx-content hr:before {\n      width: 100%;\n      max-width: 100%;\n      margin-top: -0.5px;\n      border-top-width: 1px;\n      border-top-style: solid;\n      border-top-color: rgba(217, 219, 221, 0.6); }\n  .rx-content .align-right {\n    text-align: right; }\n  .rx-content .align-center {\n    text-align: center; }\n  .rx-content .align-justify {\n    text-align: justify; }\n  .rx-content div.align-center img,\n  .rx-content p.align-center img,\n  .rx-content figure.align-center img {\n    max-width: 80%; }\n  .rx-content div.align-center figcaption,\n  .rx-content p.align-center figcaption,\n  .rx-content figure.align-center figcaption {\n    text-align: center; }\n  .rx-content .float-left {\n    float: left;\n    margin-right: 1em;\n    margin-bottom: 1em;\n    max-width: 200px; }\n  .rx-content .float-right {\n    float: right;\n    margin-left: 1em;\n    margin-bottom: 1em;\n    max-width: 200px; }\n\n@keyframes slideUp {\n  to {\n    height: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    margin-bottom: 0; } }\n\n@keyframes slideDown {\n  from {\n    height: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    margin-bottom: 0; } }\n\n@keyframes fadeIn {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@keyframes fadeOut {\n  from {\n    opacity: 1; }\n  to {\n    opacity: 0; } }\n\n.rx-container {\n  box-sizing: border-box;\n  border-radius: 2px;\n  background-color: #ffffff;\n  border: 1px solid rgba(0, 11, 29, 0.1); }\n\n.rx-toolbar {\n  display: flex;\n  flex: 1;\n  white-space: nowrap;\n  height: 40px;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  scrollbar-width: none;\n  -ms-overflow-style: none; }\n  .rx-toolbar::-webkit-scrollbar {\n    width: 0;\n    height: 0; }\n  .rx-toolbar-container {\n    position: relative;\n    z-index: 4;\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    display: flex; }\n  .rx-toolbar-container.is-rx-toolbar {\n    border-top-left-radius: 2px;\n    border-top-right-radius: 2px;\n    background-color: rgba(255, 255, 255, 0.98);\n    border-bottom: 1px solid rgba(0, 11, 29, 0.1); }\n  .rx-toolbar-container.is-rx-toolbar .rx-topbar {\n    position: relative;\n    margin-left: auto;\n    display: flex; }\n  .rx-toolbar-sticky {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0; }\n\n.rx-editor-container {\n  box-sizing: border-box; }\n\n.rx-source-container {\n  display: none; }\n\n.rx-context {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 4;\n  padding: 0;\n  margin: 0;\n  line-height: 1;\n  border-radius: 99px;\n  background-color: #000B1D; }\n\n.rx-control {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 3;\n  padding: 0;\n  margin: 0;\n  line-height: 1; }\n\n.rx-topbar {\n  position: absolute;\n  right: 0; }\n\n.rx-source,\n.rx-source:hover,\n.rx-source:focus {\n  text-align: left;\n  box-sizing: border-box;\n  font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, Courier, monospace;\n  width: 100%;\n  display: block;\n  margin: 0;\n  border: none;\n  box-shadow: none;\n  border-radius: 0;\n  background-color: #262F3F;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 14px;\n  outline: none;\n  padding: 10px 18px 20px 18px;\n  line-height: 1.5;\n  min-height: 60px;\n  resize: vertical; }\n\n.rx-draggable-placeholder {\n  height: 20px;\n  min-width: 80px;\n  outline: 3px dashed gold !important;\n  background-color: rgba(255, 215, 0, 0.2) !important;\n  margin-bottom: 20px; }\n\n.rx-drag-active {\n  outline: 3px dashed gold !important;\n  outline-offset: 0 !important;\n  position: relative;\n  max-height: 40px;\n  overflow: hidden;\n  padding: 0; }\n  .rx-drag-active:before {\n    width: 100%;\n    height: 100%;\n    content: "";\n    top: 0;\n    left: 0;\n    background-color: rgba(255, 215, 0, 0.4);\n    position: absolute;\n    z-index: 1; }\n\n.rx-dragging {\n  opacity: 0.95;\n  background-color: #ffffff;\n  box-shadow: 0 15px 30px 0 15px 30px rgba(0, 11, 29, 0.3); }\n  .rx-dragging img {\n    max-width: 100%; }\n\n.rx-voice-label {\n  display: none; }\n\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0; }\n  to {\n    background-position: 0 0; } }\n\n.rx-editor-progress {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 11000;\n  width: 100%;\n  background-color: rgba(0, 11, 29, 0.2); }\n  .rx-editor-progress span {\n    animation: progress-bar-stripes 2s linear infinite;\n    content: \'\';\n    display: block;\n    min-height: 8px;\n    width: 100%;\n    height: 100%;\n    background-color: #0058FB;\n    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%, transparent);\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%, transparent);\n    background-size: 40px 40px; }\n\n.rx-nowrap {\n  white-space: nowrap !important; }\n\n.rx-handle {\n  cursor: move; }\n\n.rx-placeholder:before {\n  position: absolute;\n  z-index: 0;\n  content: attr(placeholder);\n  color: rgba(0, 11, 29, 0.4);\n  font-weight: normal;\n  cursor: text; }\n\n@font-face {\n  font-family: \'RedactorX\';\n  src: url("data:application/x-font-ttf;charset=utf-8;base64,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") format("truetype");\n  font-weight: normal;\n  font-style: normal;\n  font-display: block; }\n\n[class^="rx-icon-"], [class*=" rx-icon-"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: \'RedactorX\' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\n.rx-icon-paragraph:before {\n  content: "\\e91b"; }\n\n.rx-icon-outdent:before {\n  content: "\\e921"; }\n\n.rx-icon-sub:before {\n  content: "\\e90c"; }\n\n.rx-icon-sup:before {\n  content: "\\e920"; }\n\n.rx-icon-align-center:before {\n  content: "\\e900"; }\n\n.rx-icon-align-justify:before {\n  content: "\\e901"; }\n\n.rx-icon-alignment:before,\n.rx-icon-align-left:before {\n  content: "\\e902"; }\n\n.rx-icon-add:before {\n  content: "\\e903"; }\n\n.rx-icon-align-right:before {\n  content: "\\e904"; }\n\n.rx-icon-embed:before {\n  content: "\\e905"; }\n\n.rx-icon-file:before {\n  content: "\\e906"; }\n\n.rx-icon-duplicate:before {\n  content: "\\e907"; }\n\n.rx-icon-format:before {\n  content: "\\e908"; }\n\n.rx-icon-bold:before {\n  content: "\\e909"; }\n\n.rx-icon-pre:before,\n.rx-icon-html:before,\n.rx-icon-code:before {\n  content: "\\e90a"; }\n\n.rx-icon-deleted:before {\n  content: "\\e90b"; }\n\n.rx-icon-image:before {\n  content: "\\e90d"; }\n\n.rx-icon-indent:before {\n  content: "\\e90e"; }\n\n.rx-icon-italic:before {\n  content: "\\e90f"; }\n\n.rx-icon-kbd:before {\n  content: "\\e910"; }\n\n.rx-icon-line:before {\n  content: "\\e911"; }\n\n.rx-icon-link:before {\n  content: "\\e912"; }\n\n.rx-icon-list:before {\n  content: "\\e913"; }\n\n.rx-icon-mark:before {\n  content: "\\e914"; }\n\n.rx-icon-quote:before {\n  content: "\\e915"; }\n\n.rx-icon-redo:before {\n  content: "\\e916"; }\n\n.rx-icon-selector:before {\n  content: "\\e917"; }\n\n.rx-icon-shortcut:before {\n  content: "\\e918"; }\n\n.rx-icon-sort:before {\n  content: "\\e919"; }\n\n.rx-icon-table:before {\n  content: "\\e91a"; }\n\n.rx-icon-trash:before {\n  content: "\\e91c"; }\n\n.rx-icon-tune:before {\n  content: "\\e91d"; }\n\n.rx-icon-underline:before {\n  content: "\\e91e"; }\n\n.rx-icon-undo:before {\n  content: "\\e91f"; }\n\n.rx-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  vertical-align: middle;\n  text-decoration: none;\n  background: none;\n  outline: none;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer; }\n  .rx-button:hover {\n    text-decoration: none; }\n  .rx-button-icon {\n    display: inline-flex; }\n  .rx-button-icon svg {\n    display: inline-block; }\n\n.rx-button-icon {\n  width: 31px;\n  height: 30px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  border: 1px solid transparent; }\n\n.rx-button-control {\n  width: 20px;\n  color: rgba(0, 11, 29, 0.4); }\n  .rx-button-control:hover {\n    color: #000B1D; }\n\n.rx-button-context, .rx-button-context:active, .rx-button-context:focus {\n  width: 36px;\n  min-width: 36px;\n  height: 34px;\n  background-color: transparent;\n  color: rgba(255, 255, 255, 0.85); }\n\n.rx-button-context:first-child {\n  padding-left: 6px; }\n\n.rx-button-context:last-child {\n  padding-right: 6px; }\n\n.rx-button-context svg {\n  fill: rgba(255, 255, 255, 0.85); }\n\n.rx-button-context.active {\n  background-color: rgba(255, 255, 255, 0.2);\n  color: rgba(255, 255, 255, 0.85); }\n\n.rx-button-context:hover {\n  transition: all 0.2s linear;\n  background-color: rgba(255, 255, 255, 0.3);\n  color: #ffffff; }\n  .rx-button-context:hover svg {\n    fill: #ffffff; }\n  .rx-button-context:hover .rx-button-icon {\n    border-color: transparent; }\n\n.rx-button-toolbar {\n  padding-top: 1px;\n  width: 40px;\n  min-width: 40px;\n  height: 41px; }\n\n.rx-button-topbar {\n  width: 36px;\n  height: 40px;\n  padding-top: 1px; }\n\n.rx-button-toolbar,\n.rx-button-topbar {\n  color: rgba(0, 11, 29, 0.8); }\n  .rx-button-toolbar svg,\n  .rx-button-topbar svg {\n    fill: rgba(0, 11, 29, 0.8); }\n  .rx-button-toolbar.active .rx-button-icon,\n  .rx-button-topbar.active .rx-button-icon {\n    border-color: #e4e8ed;\n    background-color: rgba(228, 232, 237, 0.5); }\n  .rx-button-toolbar.toggled,\n  .rx-button-topbar.toggled {\n    background-color: #E4E8ED;\n    color: #000B1D; }\n    .rx-button-toolbar.toggled svg,\n    .rx-button-topbar.toggled svg {\n      fill: #000B1D; }\n  .rx-button-toolbar.disable, .rx-button-toolbar.disable:hover,\n  .rx-button-topbar.disable,\n  .rx-button-topbar.disable:hover {\n    cursor: default;\n    background-color: transparent !important;\n    color: rgba(0, 11, 29, 0.4) !important; }\n  .rx-button-toolbar.disable svg,\n  .rx-button-topbar.disable svg {\n    fill: rgba(0, 11, 29, 0.4) !important; }\n  .rx-button-toolbar.disable .rx-button-icon,\n  .rx-button-topbar.disable .rx-button-icon {\n    background-color: transparent !important;\n    color: rgba(0, 11, 29, 0.4) !important; }\n  .rx-button-toolbar:hover,\n  .rx-button-topbar:hover {\n    transition: all 0.2s linear;\n    background-color: #E4E8ED;\n    color: #000B1D; }\n    .rx-button-toolbar:hover svg,\n    .rx-button-topbar:hover svg {\n      fill: #000B1D; }\n    .rx-button-toolbar:hover .rx-button-icon,\n    .rx-button-topbar:hover .rx-button-icon {\n      border-color: transparent; }\n\n.rx-tooltip {\n  position: absolute;\n  z-index: 99;\n  margin: 0;\n  padding: 4px 7px;\n  border-radius: 2px;\n  line-height: 1;\n  font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, Courier, monospace;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.85);\n  background-color: #000B1D; }\n\n.rx-statusbar {\n  font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, Courier, monospace;\n  margin: 0;\n  padding: 8px 10px;\n  position: relative;\n  overflow: hidden;\n  background-color: #F5F5F6;\n  box-sizing: border-box;\n  border: none; }\n  .rx-statusbar:empty {\n    display: none; }\n  .rx-statusbar-item {\n    float: left;\n    font-size: 12px;\n    padding: 0 10px;\n    margin: 0;\n    line-height: 16px;\n    color: rgba(0, 11, 29, 0.5);\n    border-right: 1px solid rgba(0, 11, 29, 0.1); }\n  .rx-statusbar-item:last-child {\n    border-right-color: transparent; }\n  .rx-statusbar-item a {\n    color: rgba(0, 11, 29, 0.5);\n    text-decoration: underline; }\n  .rx-statusbar-item a:hover {\n    color: #FF4F7F;\n    text-decoration: underline; }\n\n.rx-panel {\n  position: absolute;\n  min-width: 240px;\n  max-height: 300px;\n  margin: 0;\n  padding: 0;\n  z-index: 99;\n  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Helvetica Neue", Arial, sans-serif;\n  font-size: 14px;\n  overflow: auto;\n  border-radius: 4px;\n  background-color: #000B1D; }\n  .rx-panel-item {\n    box-sizing: border-box;\n    padding: 4px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.07); }\n  .rx-panel-item a {\n    display: block;\n    border-radius: 6px;\n    padding: 8px;\n    line-height: 1;\n    text-decoration: none;\n    color: #ffffff;\n    background-color: transparent; }\n  .rx-panel-item.active a,\n  .rx-panel-item a:hover {\n    color: #ffffff;\n    background-color: #0058FB; }\n\n.rx-editor, .rx-editor [data-rx-type], .rx-editor a, .rx-editor p, .rx-editor figcaption, .rx-editor td, .rx-editor th {\n  outline: none; }\n\n.rx-editor::after {\n  content: "";\n  clear: both;\n  display: table; }\n\n.rx-editor [data-rx-type=embed], .rx-editor [data-rx-type=embed] a,\n.rx-editor [data-rx-type=image],\n.rx-editor [data-rx-type=image] a {\n  cursor: pointer; }\n\n.rx-editor [data-rx-type=embed] figcaption,\n.rx-editor [data-rx-type=image] figcaption {\n  cursor: text; }\n\n.rx-editor [data-rx-type=embed].rx-block-focus,\n.rx-editor [data-rx-type=image].rx-block-focus,\n.rx-editor [data-rx-type=line].rx-block-focus,\n.rx-editor [data-rx-type=layer].rx-block-focus {\n  outline: 3px solid rgba(0, 88, 251, 0.4) !important; }\n\n.rx-editor [data-rx-type].rx-block-meta-focus {\n  outline: 3px solid rgba(0, 88, 251, 0.4) !important; }\n\n.rx-editor [data-rx-type=text] {\n  margin: 0;\n  line-height: 1.5; }\n  .rx-editor [data-rx-type=text]:empty {\n    min-height: 1.5em; }\n\n.rx-editor [data-rx-type=embed] {\n  position: relative; }\n  .rx-editor [data-rx-type=embed]:before {\n    width: 100%;\n    height: 100%;\n    content: "";\n    position: absolute;\n    z-index: 1; }\n  .rx-editor [data-rx-type=embed] iframe {\n    display: inline-block; }\n  .rx-editor [data-rx-type=embed] figcaption {\n    position: relative;\n    top: 0;\n    z-index: 2; }\n\n.rx-editor [data-placeholder]:empty:before {\n  content: attr(data-placeholder);\n  display: inline-block;\n  color: rgba(0, 11, 29, 0.4);\n  font-weight: normal;\n  font-style: italic;\n  font-size: inherit;\n  cursor: text;\n  max-height: 20px; }\n\n.rx-editor [data-placeholder]:empty:focus:before {\n  content: ""; }\n\n.rx-popup {\n  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Helvetica Neue", Arial, sans-serif;\n  border-radius: 4px;\n  background-color: #ffffff;\n  box-shadow: 0 14px 28px rgba(0, 11, 29, 0.25), 0 10px 10px rgba(0, 11, 29, 0.1);\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 100;\n  margin-bottom: 16px;\n  overflow-x: auto; }\n\n.rx-popup-body {\n  box-sizing: border-box;\n  padding: 0; }\n  .rx-popup-body form {\n    padding-bottom: 16px; }\n\n.rx-popup-items {\n  padding: 8px; }\n\n.rx-popup-type-grid .rx-popup-items {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0;\n  box-sizing: border-box; }\n\n.rx-popup-type-grid .rx-popup-item {\n  box-sizing: border-box;\n  border-radius: 0;\n  margin-bottom: -1px;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n  padding: 0;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid #D9DBDD;\n  color: #000B1D;\n  border-left-color: transparent;\n  border-top-color: transparent; }\n\n.rx-popup-type-grid .rx-popup-item svg {\n  width: 16px;\n  height: 16px; }\n\n.rx-popup-header {\n  font-size: 14px;\n  font-weight: bold;\n  color: #000B1D;\n  padding: 0 16px;\n  position: relative; }\n  .rx-popup-header:empty {\n    display: none; }\n  .rx-popup-header-box {\n    white-space: nowrap; }\n  .rx-popup-header-item {\n    position: relative;\n    display: inline-block;\n    color: #000B1D;\n    font-weight: bold;\n    padding-top: 16px;\n    padding-bottom: 16px;\n    margin-right: 8px;\n    padding-right: 8px;\n    text-decoration: none; }\n  .rx-popup-header-item:after {\n    content: \'\';\n    position: absolute;\n    right: 0;\n    top: 18px;\n    width: 1px;\n    height: 16px;\n    background-color: rgba(0, 11, 29, 0.2); }\n  .rx-popup-header-item:last-child {\n    margin-right: 0;\n    padding-right: 0; }\n  .rx-popup-header-item:last-child:after {\n    display: none; }\n  .rx-popup-header-item-link {\n    color: rgba(0, 11, 29, 0.6); }\n  .rx-popup-header-item-link:hover {\n    color: #000B1D;\n    text-decoration: underline; }\n  .rx-popup-header-item-link.active {\n    color: #000B1D;\n    text-decoration: none;\n    cursor: text; }\n\n.rx-popup-footer {\n  overflow: hidden;\n  box-sizing: border-box;\n  margin-top: 8px;\n  padding: 16px;\n  padding-bottom: 20px; }\n  .rx-popup-footer .rx-form-button {\n    margin-right: 4px; }\n  .rx-popup-footer:empty {\n    display: none; }\n\n.rx-popup-item {\n  font-size: 14px;\n  border-radius: 4px;\n  padding: 10px 8px;\n  display: flex;\n  line-height: 1;\n  align-items: center;\n  cursor: pointer;\n  position: relative; }\n  .rx-popup-item-container {\n    width: 92px;\n    height: 76px;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n    vertical-align: middle; }\n  .rx-popup-item-container .rx-popup-item-title {\n    flex: none;\n    font-size: 12px;\n    color: rgba(0, 11, 29, 0.6); }\n  .rx-popup-item-container .rx-popup-item-icon {\n    font-size: 16px;\n    margin-bottom: 10px;\n    margin-right: 0;\n    line-height: 1; }\n  .rx-popup-item-container .rx-popup-item-icon svg {\n    position: relative;\n    top: 2px; }\n  .rx-popup-item-title {\n    flex: 1; }\n  .rx-popup-item-icon {\n    font-size: 16px;\n    margin-right: 6px; }\n  .rx-popup-item-shortcut {\n    font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, Courier, monospace;\n    font-size: 11px;\n    color: rgba(0, 11, 29, 0.5);\n    margin-left: auto;\n    padding-top: 1px;\n    text-align: right; }\n  .rx-popup-item-shortcut b {\n    position: relative;\n    top: 2px;\n    font-weight: normal;\n    font-size: 14px; }\n  .rx-popup-item-image {\n    display: inline-block;\n    max-width: 38px !important;\n    height: auto;\n    padding: 4px;\n    border-radius: 4px;\n    background-color: #D9DBDD; }\n  .rx-popup-item-image > img,\n  .rx-popup-item-image > svg {\n    max-width: 30px !important;\n    height: auto;\n    display: inline-block; }\n  .rx-popup-item-trash {\n    font-size: 14px;\n    margin-left: auto;\n    color: rgba(0, 11, 29, 0.7); }\n  .rx-popup-item-trash:hover {\n    color: #000B1D; }\n  .rx-popup-item-hidden {\n    display: none; }\n  .rx-popup-item:hover {\n    background-color: #E4E8ED; }\n  .rx-popup-item.active {\n    background-color: rgba(0, 88, 251, 0.65);\n    color: #ffffff; }\n  .rx-popup-item.active span {\n    background: none !important;\n    color: #ffffff !important; }\n  .rx-popup-item-divider-top {\n    margin-top: 9px; }\n  .rx-popup-item-divider-top:before {\n    top: -5px; }\n  .rx-popup-item-divider-bottom {\n    margin-bottom: 9px; }\n  .rx-popup-item-divider-bottom:before {\n    bottom: -5px; }\n  .rx-popup-item-divider-top:before, .rx-popup-item-divider-bottom:before {\n    position: absolute;\n    content: \'\';\n    width: calc(100% - 8px);\n    height: 1px;\n    left: 4px;\n    background-color: rgba(0, 11, 29, 0.07); }\n\n.rx-popup-close {\n  position: absolute !important;\n  right: 16px;\n  top: 14px;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5; }\n  .rx-popup-close::before, .rx-popup-close::after {\n    content: "";\n    display: block;\n    left: 50%;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%) rotate(45deg);\n    background-color: #000B1D; }\n  .rx-popup-close::before {\n    height: 1px;\n    width: 75%; }\n  .rx-popup-close::after {\n    height: 75%;\n    width: 1px; }\n  .rx-popup-close:hover {\n    opacity: 1; }\n\n.rx-popup-list {\n  list-style: none;\n  margin: 0;\n  padding: 16px 8px;\n  padding-top: 0; }\n  .rx-popup-list li {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    border-radius: 4px;\n    line-height: 1;\n    border-bottom: 1px solid rgba(0, 11, 29, 0.07); }\n  .rx-popup-list li:last-child {\n    border-bottom-color: transparent; }\n  .rx-popup-list li:hover {\n    background-color: #E4E8ED; }\n  .rx-popup-list-item {\n    text-decoration: none;\n    flex: 1;\n    padding: 7px 8px;\n    font-size: 14px;\n    color: #000B1D; }\n  .rx-popup-list-aside {\n    font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, Courier, monospace;\n    font-size: 11px;\n    color: rgba(0, 11, 29, 0.5);\n    margin-left: auto;\n    padding-left: 4px; }\n\n.rx-popup.has-footer form,\n.rx-popup.has-form .rx-popup-header-item,\n.rx-popup.has-items .rx-popup-header-item {\n  padding-bottom: 0; }\n\n.rx-popup[dir=rtl] .rx-popup-close {\n  right: auto;\n  left: 20px; }\n\n.rx-form-item {\n  padding: 16px 16px 0 16px; }\n  .rx-form-item:empty {\n    display: none; }\n\n.rx-form-image img,\n.rx-form-image svg {\n  max-width: 100%; }\n\n.rx-form-label {\n  box-sizing: border-box;\n  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Helvetica Neue", Arial, sans-serif;\n  font-size: 14px;\n  font-weight: bold;\n  display: block;\n  padding: 0;\n  margin: 0;\n  padding-bottom: 6px;\n  color: rgba(0, 11, 29, 0.65); }\n\n.rx-form-container-flex {\n  display: flex; }\n  .rx-form-container-flex .rx-form-input,\n  .rx-form-container-flex .rx-form-select {\n    flex: auto; }\n  .rx-form-container-flex .rx-form-button {\n    margin-left: 4px; }\n\n.rx-form-button-push-right {\n  float: right; }\n\n.rx-form-button {\n  box-sizing: border-box;\n  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Helvetica Neue", Arial, sans-serif;\n  font-size: 14px;\n  font-weight: bold;\n  outline: none;\n  border-radius: 4px;\n  padding: 8px 24px;\n  min-height: 38px;\n  cursor: pointer;\n  line-height: 1.25;\n  height: auto;\n  background-color: #ffffff;\n  border: 1px solid #D9DBDD;\n  color: rgba(0, 11, 29, 0.9); }\n  .rx-form-button:hover {\n    color: rgba(0, 11, 29, 0.9);\n    background-color: #F5F5F6; }\n\n.rx-form-button-primary {\n  background-color: #000B1D;\n  border: 1px solid #000B1D;\n  color: #ffffff; }\n  .rx-form-button-primary:hover {\n    color: #ffffff;\n    background-color: #262F3F; }\n\n.rx-form-button-danger {\n  background-color: #ffffff;\n  border: 1px solid #BF3D66;\n  color: #BF3D66; }\n  .rx-form-button-danger:hover {\n    color: #BF3D66;\n    background-color: #F5F5F6; }\n\n.rx-form-button-fullwidth {\n  display: block;\n  width: 100%; }\n\n.rx-form-input,\n.rx-form-select,\n.rx-form-textarea {\n  box-sizing: border-box;\n  display: block;\n  width: 100%;\n  vertical-align: middle;\n  font-weight: normal;\n  padding: 8px;\n  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Helvetica Neue", Arial, sans-serif;\n  font-size: 15px;\n  outline: none;\n  border-radius: 4px;\n  box-shadow: none;\n  line-height: 1.3;\n  color: #000B1D;\n  background-color: #F5F5F6;\n  border: 1px solid #D9DBDD; }\n  .rx-form-input:focus,\n  .rx-form-select:focus,\n  .rx-form-textarea:focus {\n    border-color: rgba(0, 88, 251, 0.5);\n    box-shadow: 0 1px 2px rgba(0, 11, 29, 0.13) inset, 0 0 2px rgba(0, 88, 251, 0.4); }\n\n.rx-form-textarea {\n  resize: vertical;\n  line-height: 1.5; }\n\n.rx-form-select {\n  font-size: 15px;\n  cursor: pointer;\n  -webkit-appearance: none;\n  background-image: url(\'data:image/svg+xml;utf8,<svg height="10" viewBox="0 0 9 10" width="9" xmlns="http://www.w3.org/2000/svg"><path fill="rgba(0, 0, 0, .6)" d="m3.27162899.66658308.8-.70211699 4 3.51058495-.8.70211699-3.2-2.80846796-3.2 2.80846796-.8-.70211699zm0 8.59576602-3.2-2.80846795.8-.70211699 3.2 2.80846796 3.2-2.80846796.8.70211699-4 3.51058494z" /></svg>\');\n  background-repeat: no-repeat;\n  background-position: right 0.65em center;\n  padding-right: 28px;\n  min-height: 35px; }\n\n.rx-form-checkbox {\n  box-sizing: border-box;\n  vertical-align: middle;\n  position: relative;\n  bottom: -0.1em;\n  margin-top: 0 !important;\n  margin-right: 4px !important;\n  margin-left: 0 !important;\n  font-size: 15px; }\n\n.rx-popup[dir=rtl] .rx-form-checkbox {\n  margin-right: 0 !important;\n  margin-left: 4px !important; }\n\n.rx-form-checkbox-item span {\n  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Helvetica Neue", Arial, sans-serif;\n  font-size: 14px;\n  font-weight: normal;\n  color: #000B1D; }\n\n.rx-form-segment {\n  display: flex;\n  flex-wrap: wrap;\n  background-color: #F0F1F1;\n  border-radius: 4px;\n  padding: 2px;\n  gap: 4px; }\n\n.rx-form-segment-item {\n  border: 1px solid transparent;\n  font-size: 16px;\n  padding: 8px 5px;\n  margin: 0;\n  cursor: pointer;\n  flex: auto;\n  text-align: center;\n  border-radius: 4px;\n  min-width: 32px;\n  color: rgba(0, 11, 29, 0.6); }\n  .rx-form-segment-item:hover {\n    background-color: #ffffff;\n    color: #000B1D; }\n  .rx-form-segment-item.active {\n    cursor: default;\n    background-color: #ffffff;\n    box-shadow: 0 1px 3px rgba(0, 11, 29, 0.12), 0 1px 2px rgba(0, 11, 29, 0.2);\n    color: #000B1D; }\n\n.rx-form-upload-box {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  margin-bottom: 10px;\n  border: 2px dashed rgba(0, 11, 29, 0.12);\n  background-color: #F5F5F6;\n  border-radius: 4px;\n  min-width: 160px;\n  height: 160px;\n  cursor: pointer;\n  position: relative; }\n  .rx-form-upload-box input[type="file"] {\n    font-size: 13px; }\n  .rx-form-upload-box img {\n    position: relative;\n    z-index: 2;\n    object-fit: cover;\n    height: 100%;\n    width: 100%; }\n  .rx-form-upload-box:after {\n    content: \'\';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 100%; }\n  .rx-form-upload-box.rx-form-upload-hover {\n    border-color: rgba(0, 88, 251, 0.35);\n    background-color: rgba(0, 88, 251, 0.05); }\n  .rx-form-upload-box.rx-form-upload-error {\n    border-color: rgba(255, 79, 127, 0.35);\n    background-color: rgba(255, 79, 127, 0.05); }\n\n.rx-upload-remove {\n  position: absolute;\n  z-index: 3;\n  top: -6px;\n  right: -10px;\n  background-color: #FF4F7F;\n  color: #ffffff;\n  opacity: 1;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  border-radius: 10px;\n  font-size: 14px;\n  line-height: 20px; }\n  .rx-upload-remove:after {\n    content: \'\\00d7\'; }\n  .rx-upload-remove:hover {\n    background-color: #000B1D; }\n\n.rx-form-upload-cover-off img {\n  object-fit: initial;\n  height: auto;\n  width: auto; }\n\n.rx-form-upload-placeholder {\n  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Helvetica Neue", Arial, sans-serif;\n  color: rgba(0, 11, 29, 0.5);\n  font-size: 12px;\n  line-height: 1.35;\n  padding: 0 8px;\n  text-align: center; }\n  .rx-form-upload-placeholder svg {\n    fill: rgba(0, 11, 29, 0.5); }\n\n.rx-popup-addbar .rx-popup-items {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 4px; }\n\n.rx-popup-image .rx-popup-body,\n.rx-popup-stack-image .rx-popup-body {\n  padding: 16px;\n  padding-top: 0; }\n\n.rx-popup-image-section-or {\n  margin: 16px 0;\n  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Helvetica Neue", Arial, sans-serif;\n  text-transform: uppercase;\n  font-weight: bold;\n  text-align: center;\n  font-size: 12px;\n  color: #000B1D; }\n\n.rx-popup-images-box {\n  margin-top: 12px; }\n  .rx-popup-images-box img {\n    vertical-align: top;\n    max-width: 100px;\n    height: auto;\n    cursor: pointer;\n    margin-bottom: 8px;\n    margin-right: 8px; }\n  .rx-popup-images-box img:hover {\n    outline: 3px solid rgba(0, 88, 251, 0.5); }\n\n.rx-form-item-edit-image-box {\n  padding: 20px;\n  padding-bottom: 0; }\n\n.rx-form-item-image {\n  margin-right: 8px; }\n  .rx-form-item-image img {\n    max-height: 160px;\n    width: auto; }\n\n.rx-popup-shortcut-item {\n  border-radius: 0;\n  border-bottom: 1px solid rgba(0, 11, 29, 0.08);\n  cursor: text; }\n  .rx-popup-shortcut-item:hover {\n    background-color: transparent; }\n  .rx-popup-shortcut-item:last-child {\n    border-bottom-color: transparent; }\n\n.rx-popup-shortcut-title {\n  font-size: 14px;\n  line-height: 20px;\n  color: #000B1D;\n  margin-right: 16px; }\n\n.rx-popup-shortcut-kbd {\n  white-space: nowrap;\n  line-height: 20px;\n  font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, Courier, monospace;\n  font-size: 12px;\n  padding: 0;\n  display: inline-block;\n  color: rgba(0, 11, 29, 0.65);\n  margin-left: auto;\n  text-align: right; }\n  .rx-popup-shortcut-kbd span {\n    display: inline-block;\n    border-radius: 4px;\n    padding-left: 3px;\n    padding-right: 3px;\n    color: rgba(0, 11, 29, 0.85);\n    background-color: #F5F5F6; }\n  .rx-popup-shortcut-kbd b {\n    font-weight: normal;\n    font-size: 18px;\n    display: inline-block;\n    line-height: 12px;\n    position: relative;\n    top: 3px; }\n'],sourceRoot:""}]);const h=d},41984:e=>{function t(e){var t=new Error("Cannot find module '"+e+"'");throw t.code="MODULE_NOT_FOUND",t}t.keys=()=>[],t.resolve=t,t.id=41984,e.exports=t},35358:(e,t,n)=>{var r={"./af":19183,"./af.js":19183,"./ar":31035,"./ar-dz":47214,"./ar-dz.js":47214,"./ar-kw":40830,"./ar-kw.js":40830,"./ar-ly":68899,"./ar-ly.js":68899,"./ar-ma":77258,"./ar-ma.js":77258,"./ar-ps":19121,"./ar-ps.js":19121,"./ar-sa":64096,"./ar-sa.js":64096,"./ar-tn":97826,"./ar-tn.js":97826,"./ar.js":31035,"./az":20051,"./az.js":20051,"./be":23813,"./be.js":23813,"./bg":64323,"./bg.js":64323,"./bm":57837,"./bm.js":57837,"./bn":75780,"./bn-bd":25959,"./bn-bd.js":25959,"./bn.js":75780,"./bo":81451,"./bo.js":81451,"./br":76480,"./br.js":76480,"./bs":91607,"./bs.js":91607,"./ca":23232,"./ca.js":23232,"./cs":91034,"./cs.js":91034,"./cv":54213,"./cv.js":54213,"./cy":95800,"./cy.js":95800,"./da":40739,"./da.js":40739,"./de":66951,"./de-at":82181,"./de-at.js":82181,"./de-ch":61339,"./de-ch.js":61339,"./de.js":66951,"./dv":16938,"./dv.js":16938,"./el":59573,"./el.js":59573,"./en-au":62458,"./en-au.js":62458,"./en-ca":51816,"./en-ca.js":51816,"./en-gb":8069,"./en-gb.js":8069,"./en-ie":15586,"./en-ie.js":15586,"./en-il":60009,"./en-il.js":60009,"./en-in":51207,"./en-in.js":51207,"./en-nz":83724,"./en-nz.js":83724,"./en-sg":24334,"./en-sg.js":24334,"./eo":1292,"./eo.js":1292,"./es":66328,"./es-do":61452,"./es-do.js":61452,"./es-mx":94444,"./es-mx.js":94444,"./es-us":81285,"./es-us.js":81285,"./es.js":66328,"./et":7181,"./et.js":7181,"./eu":62830,"./eu.js":62830,"./fa":19565,"./fa.js":19565,"./fi":85541,"./fi.js":85541,"./fil":65661,"./fil.js":65661,"./fo":26087,"./fo.js":26087,"./fr":25396,"./fr-ca":96581,"./fr-ca.js":96581,"./fr-ch":81294,"./fr-ch.js":81294,"./fr.js":25396,"./fy":12533,"./fy.js":12533,"./ga":55796,"./ga.js":55796,"./gd":50847,"./gd.js":50847,"./gl":60439,"./gl.js":60439,"./gom-deva":46514,"./gom-deva.js":46514,"./gom-latn":66525,"./gom-latn.js":66525,"./gu":34232,"./gu.js":34232,"./he":50915,"./he.js":50915,"./hi":22095,"./hi.js":22095,"./hr":10762,"./hr.js":10762,"./hu":88275,"./hu.js":88275,"./hy-am":73094,"./hy-am.js":73094,"./id":27769,"./id.js":27769,"./is":99676,"./is.js":99676,"./it":74313,"./it-ch":25141,"./it-ch.js":25141,"./it.js":74313,"./ja":11985,"./ja.js":11985,"./jv":53908,"./jv.js":53908,"./ka":32808,"./ka.js":32808,"./kk":33930,"./kk.js":33930,"./km":71532,"./km.js":71532,"./kn":69461,"./kn.js":69461,"./ko":60502,"./ko.js":60502,"./ku":18660,"./ku-kmr":58035,"./ku-kmr.js":58035,"./ku.js":18660,"./ky":83088,"./ky.js":83088,"./lb":65742,"./lb.js":65742,"./lo":25417,"./lo.js":25417,"./lt":64968,"./lt.js":64968,"./lv":41202,"./lv.js":41202,"./me":34438,"./me.js":34438,"./mi":18498,"./mi.js":18498,"./mk":6744,"./mk.js":6744,"./ml":63949,"./ml.js":63949,"./mn":4459,"./mn.js":4459,"./mr":46679,"./mr.js":46679,"./ms":56960,"./ms-my":47483,"./ms-my.js":47483,"./ms.js":56960,"./mt":99989,"./mt.js":99989,"./my":64978,"./my.js":64978,"./nb":88460,"./nb.js":88460,"./ne":23993,"./ne.js":23993,"./nl":95378,"./nl-be":62678,"./nl-be.js":62678,"./nl.js":95378,"./nn":67560,"./nn.js":67560,"./oc-lnc":87060,"./oc-lnc.js":87060,"./pa-in":62187,"./pa-in.js":62187,"./pl":93532,"./pl.js":93532,"./pt":49396,"./pt-br":92485,"./pt-br.js":92485,"./pt.js":49396,"./ro":33179,"./ro.js":33179,"./ru":93797,"./ru.js":93797,"./sd":40675,"./sd.js":40675,"./se":59036,"./se.js":59036,"./si":59160,"./si.js":59160,"./sk":31266,"./sk.js":31266,"./sl":74699,"./sl.js":74699,"./sq":69728,"./sq.js":69728,"./sr":87129,"./sr-cyrl":55e3,"./sr-cyrl.js":55e3,"./sr.js":87129,"./ss":74346,"./ss.js":74346,"./sv":9877,"./sv.js":9877,"./sw":918,"./sw.js":918,"./ta":24787,"./ta.js":24787,"./te":6199,"./te.js":6199,"./tet":91851,"./tet.js":91851,"./tg":33881,"./tg.js":33881,"./th":87828,"./th.js":87828,"./tk":99677,"./tk.js":99677,"./tl-ph":29253,"./tl-ph.js":29253,"./tlh":95586,"./tlh.js":95586,"./tr":17254,"./tr.js":17254,"./tzl":61192,"./tzl.js":61192,"./tzm":69631,"./tzm-latn":72841,"./tzm-latn.js":72841,"./tzm.js":69631,"./ug-cn":71720,"./ug-cn.js":71720,"./uk":28048,"./uk.js":28048,"./ur":86751,"./ur.js":86751,"./uz":96343,"./uz-latn":60513,"./uz-latn.js":60513,"./uz.js":96343,"./vi":44821,"./vi.js":44821,"./x-pseudo":23973,"./x-pseudo.js":23973,"./yo":15e3,"./yo.js":15e3,"./zh-cn":43762,"./zh-cn.js":43762,"./zh-hk":9246,"./zh-hk.js":9246,"./zh-mo":41107,"./zh-mo.js":41107,"./zh-tw":79014,"./zh-tw.js":79014};function o(e){var t=i(e);return n(t)}function i(e){if(!n.o(r,e)){var t=new Error("Cannot find module '"+e+"'");throw t.code="MODULE_NOT_FOUND",t}return r[e]}o.keys=function(){return Object.keys(r)},o.resolve=i,e.exports=o,o.id=35358},52869:(e,t,n)=>{"use strict";n.r(t),n.d(t,{Composite:()=>Fe,CompositeItem:()=>je,FloatingArrow:()=>We,FloatingDelayGroup:()=>lt,FloatingFocusManager:()=>jt,FloatingList:()=>De,FloatingNode:()=>Je,FloatingOverlay:()=>$t,FloatingPortal:()=>Lt,FloatingTree:()=>Xe,arrow:()=>Y,autoPlacement:()=>N,autoUpdate:()=>x.ll,computePosition:()=>x.rD,detectOverflow:()=>x.__,flip:()=>B,getOverflowAncestors:()=>i.v9,hide:()=>F,inline:()=>j,inner:()=>bn,limitShift:()=>I,offset:()=>L,platform:()=>x.iD,safePolygon:()=>En,shift:()=>P,size:()=>R,useClick:()=>zt,useClientPoint:()=>Vt,useDelayGroup:()=>ct,useDelayGroupContext:()=>st,useDismiss:()=>Kt,useFloating:()=>Jt,useFloatingNodeId:()=>Ze,useFloatingParentNodeId:()=>qe,useFloatingPortalNode:()=>Dt,useFloatingRootContext:()=>Zt,useFloatingTree:()=>Ke,useFocus:()=>Xt,useHover:()=>ot,useId:()=>ze,useInnerOffset:()=>_n,useInteractions:()=>rn,useListItem:()=>Le,useListNavigation:()=>un,useMergeRefs:()=>le,useRole:()=>pn,useTransitionStatus:()=>mn,useTransitionStyles:()=>gn,useTypeahead:()=>vn});var r=n(77810),o=n.t(r,2),i=n(61266);function a(e){let t=e.activeElement;for(;null!=(null==(n=t)||null==(n=n.shadowRoot)?void 0:n.activeElement);){var n;t=t.shadowRoot.activeElement}return t}function s(e,t){if(!e||!t)return!1;const n=null==t.getRootNode?void 0:t.getRootNode();if(e.contains(t))return!0;if(n&&(0,i.Ng)(n)){let n=t;for(;n;){if(e===n)return!0;n=n.parentNode||n.host}}return!1}function l(){const e=navigator.userAgentData;return null!=e&&e.platform?e.platform:navigator.platform}function c(){const e=navigator.userAgentData;return e&&Array.isArray(e.brands)?e.brands.map((e=>{let{brand:t,version:n}=e;return t+"/"+n})).join(" "):navigator.userAgent}function u(e){return!(0!==e.mozInputSource||!e.isTrusted)||(f()&&e.pointerType?"click"===e.type&&1===e.buttons:0===e.detail&&!e.pointerType)}function d(e){return!c().includes("jsdom/")&&(!f()&&0===e.width&&0===e.height||f()&&1===e.width&&1===e.height&&0===e.pressure&&0===e.detail&&"mouse"===e.pointerType||e.width<1&&e.height<1&&0===e.pressure&&0===e.detail&&"touch"===e.pointerType)}function p(){return/apple/i.test(navigator.vendor)}function f(){const e=/android/i;return e.test(l())||e.test(c())}function h(){return l().toLowerCase().startsWith("mac")&&!navigator.maxTouchPoints}function m(e,t){const n=["mouse","pen"];return t||n.push("",void 0),n.includes(e)}function g(e){return(null==e?void 0:e.ownerDocument)||document}function v(e,t){if(null==t)return!1;if("composedPath"in e)return e.composedPath().includes(t);const n=e;return null!=n.target&&t.contains(n.target)}function y(e){return"composedPath"in e?e.composedPath()[0]:e.target}const b="input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";function _(e){return(0,i.sb)(e)&&e.matches(b)}function A(e){e.preventDefault(),e.stopPropagation()}function E(e){return!!e&&("combobox"===e.getAttribute("role")&&_(e))}var w=n(80692),x=n(58018),k=n(22483),C="undefined"!=typeof document?r.useLayoutEffect:r.useEffect;function S(e,t){if(e===t)return!0;if(typeof e!=typeof t)return!1;if("function"==typeof e&&e.toString()===t.toString())return!0;let n,r,o;if(e&&t&&"object"==typeof e){if(Array.isArray(e)){if(n=e.length,n!==t.length)return!1;for(r=n;0!=r--;)if(!S(e[r],t[r]))return!1;return!0}if(o=Object.keys(e),n=o.length,n!==Object.keys(t).length)return!1;for(r=n;0!=r--;)if(!{}.hasOwnProperty.call(t,o[r]))return!1;for(r=n;0!=r--;){const n=o[r];if(("_owner"!==n||!e.$$typeof)&&!S(e[n],t[n]))return!1}return!0}return e!=e&&t!=t}function M(e){if("undefined"==typeof window)return 1;return(e.ownerDocument.defaultView||window).devicePixelRatio||1}function T(e,t){const n=M(e);return Math.round(t*n)/n}function O(e){const t=r.useRef(e);return C((()=>{t.current=e})),t}const D=e=>({name:"arrow",options:e,fn(t){const{element:n,padding:r}="function"==typeof e?e(t):e;return n&&(o=n,{}.hasOwnProperty.call(o,"current"))?null!=n.current?(0,x.UE)({element:n.current,padding:r}).fn(t):{}:n?(0,x.UE)({element:n,padding:r}).fn(t):{};var o}}),L=(e,t)=>({...(0,x.cY)(e),options:[e,t]}),P=(e,t)=>({...(0,x.BN)(e),options:[e,t]}),I=(e,t)=>({...(0,x.ER)(e),options:[e,t]}),B=(e,t)=>({...(0,x.UU)(e),options:[e,t]}),R=(e,t)=>({...(0,x.Ej)(e),options:[e,t]}),N=(e,t)=>({...(0,x.RK)(e),options:[e,t]}),F=(e,t)=>({...(0,x.jD)(e),options:[e,t]}),j=(e,t)=>({...(0,x.mG)(e),options:[e,t]}),Y=(e,t)=>({...D(e),options:[e,t]});
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var $=["input:not([inert])","select:not([inert])","textarea:not([inert])","a[href]:not([inert])","button:not([inert])","[tabindex]:not(slot):not([inert])","audio[controls]:not([inert])","video[controls]:not([inert])",'[contenteditable]:not([contenteditable="false"]):not([inert])',"details>summary:first-of-type:not([inert])","details:not([inert])"],H=$.join(","),U="undefined"==typeof Element,z=U?function(){}:Element.prototype.matches||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector,W=!U&&Element.prototype.getRootNode?function(e){var t;return null==e||null===(t=e.getRootNode)||void 0===t?void 0:t.call(e)}:function(e){return null==e?void 0:e.ownerDocument},V=function e(t,n){var r;void 0===n&&(n=!0);var o=null==t||null===(r=t.getAttribute)||void 0===r?void 0:r.call(t,"inert");return""===o||"true"===o||n&&t&&e(t.parentNode)},G=function(e,t,n){if(V(e))return[];var r=Array.prototype.slice.apply(e.querySelectorAll(H));return t&&z.call(e,H)&&r.unshift(e),r=r.filter(n)},Q=function e(t,n,r){for(var o=[],i=Array.from(t);i.length;){var a=i.shift();if(!V(a,!1))if("SLOT"===a.tagName){var s=a.assignedElements(),l=e(s.length?s:a.children,!0,r);r.flatten?o.push.apply(o,l):o.push({scopeParent:a,candidates:l})}else{z.call(a,H)&&r.filter(a)&&(n||!t.includes(a))&&o.push(a);var c=a.shadowRoot||"function"==typeof r.getShadowRoot&&r.getShadowRoot(a),u=!V(c,!1)&&(!r.shadowRootFilter||r.shadowRootFilter(a));if(c&&u){var d=e(!0===c?a.children:c.children,!0,r);r.flatten?o.push.apply(o,d):o.push({scopeParent:a,candidates:d})}else i.unshift.apply(i,a.children)}}return o},q=function(e){return!isNaN(parseInt(e.getAttribute("tabindex"),10))},K=function(e){if(!e)throw new Error("No node provided");return e.tabIndex<0&&(/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName)||function(e){var t,n=null==e||null===(t=e.getAttribute)||void 0===t?void 0:t.call(e,"contenteditable");return""===n||"true"===n}(e))&&!q(e)?0:e.tabIndex},Z=function(e,t){return e.tabIndex===t.tabIndex?e.documentOrder-t.documentOrder:e.tabIndex-t.tabIndex},J=function(e){return"INPUT"===e.tagName},X=function(e){return function(e){return J(e)&&"radio"===e.type}(e)&&!function(e){if(!e.name)return!0;var t,n=e.form||W(e),r=function(e){return n.querySelectorAll('input[type="radio"][name="'+e+'"]')};if("undefined"!=typeof window&&void 0!==window.CSS&&"function"==typeof window.CSS.escape)t=r(window.CSS.escape(e.name));else try{t=r(e.name)}catch(e){return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s",e.message),!1}var o=function(e,t){for(var n=0;n<e.length;n++)if(e[n].checked&&e[n].form===t)return e[n]}(t,e.form);return!o||o===e}(e)},ee=function(e){var t=e.getBoundingClientRect(),n=t.width,r=t.height;return 0===n&&0===r},te=function(e,t){var n=t.displayCheck,r=t.getShadowRoot;if("hidden"===getComputedStyle(e).visibility)return!0;var o=z.call(e,"details>summary:first-of-type")?e.parentElement:e;if(z.call(o,"details:not([open]) *"))return!0;if(n&&"full"!==n&&"legacy-full"!==n){if("non-zero-area"===n)return ee(e)}else{if("function"==typeof r){for(var i=e;e;){var a=e.parentElement,s=W(e);if(a&&!a.shadowRoot&&!0===r(a))return ee(e);e=e.assignedSlot?e.assignedSlot:a||s===e.ownerDocument?a:s.host}e=i}if(function(e){var t,n,r,o,i=e&&W(e),a=null===(t=i)||void 0===t?void 0:t.host,s=!1;if(i&&i!==e)for(s=!!(null!==(n=a)&&void 0!==n&&null!==(r=n.ownerDocument)&&void 0!==r&&r.contains(a)||null!=e&&null!==(o=e.ownerDocument)&&void 0!==o&&o.contains(e));!s&&a;){var l,c,u;s=!(null===(c=a=null===(l=i=W(a))||void 0===l?void 0:l.host)||void 0===c||null===(u=c.ownerDocument)||void 0===u||!u.contains(a))}return s}(e))return!e.getClientRects().length;if("legacy-full"!==n)return!0}return!1},ne=function(e,t){return!(t.disabled||V(t)||function(e){return J(e)&&"hidden"===e.type}(t)||te(t,e)||function(e){return"DETAILS"===e.tagName&&Array.prototype.slice.apply(e.children).some((function(e){return"SUMMARY"===e.tagName}))}(t)||function(e){if(/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))for(var t=e.parentElement;t;){if("FIELDSET"===t.tagName&&t.disabled){for(var n=0;n<t.children.length;n++){var r=t.children.item(n);if("LEGEND"===r.tagName)return!!z.call(t,"fieldset[disabled] *")||!r.contains(e)}return!0}t=t.parentElement}return!1}(t))},re=function(e,t){return!(X(t)||K(t)<0||!ne(e,t))},oe=function(e){var t=parseInt(e.getAttribute("tabindex"),10);return!!(isNaN(t)||t>=0)},ie=function e(t){var n=[],r=[];return t.forEach((function(t,o){var i=!!t.scopeParent,a=i?t.scopeParent:t,s=function(e,t){var n=K(e);return n<0&&t&&!q(e)?0:n}(a,i),l=i?e(t.candidates):a;0===s?i?n.push.apply(n,l):n.push(a):r.push({documentOrder:o,tabIndex:s,item:t,isScope:i,content:l})})),r.sort(Z).reduce((function(e,t){return t.isScope?e.push.apply(e,t.content):e.push(t.content),e}),[]).concat(n)},ae=function(e,t){var n;return n=(t=t||{}).getShadowRoot?Q([e],t.includeContainer,{filter:re.bind(null,t),flatten:!1,getShadowRoot:t.getShadowRoot,shadowRootFilter:oe}):G(e,t.includeContainer,re.bind(null,t)),ie(n)},se=function(e,t){if(t=t||{},!e)throw new Error("No node provided");return!1!==z.call(e,H)&&re(t,e)};function le(e){return r.useMemo((()=>e.every((e=>null==e))?null:t=>{e.forEach((e=>{"function"==typeof e?e(t):null!=e&&(e.current=t)}))}),e)}const ce={...o},ue=ce.useInsertionEffect||(e=>e());function de(e){const t=r.useRef((()=>{0}));return ue((()=>{t.current=e})),r.useCallback((function(){for(var e=arguments.length,n=new Array(e),r=0;r<e;r++)n[r]=arguments[r];return null==t.current?void 0:t.current(...n)}),[])}const pe="ArrowUp",fe="ArrowDown",he="ArrowLeft",me="ArrowRight";function ge(e,t,n){return Math.floor(e/t)!==n}function ve(e,t){return t<0||t>=e.current.length}function ye(e,t){return _e(e,{disabledIndices:t})}function be(e,t){return _e(e,{decrement:!0,startingIndex:e.current.length,disabledIndices:t})}function _e(e,t){let{startingIndex:n=-1,decrement:r=!1,disabledIndices:o,amount:i=1}=void 0===t?{}:t;const a=e.current;let s=n;do{s+=r?-i:i}while(s>=0&&s<=a.length-1&&ke(a,s,o));return s}function Ae(e,t){let{event:n,orientation:r,loop:o,cols:i,disabledIndices:a,minIndex:s,maxIndex:l,prevIndex:c,stopEvent:u=!1}=t,d=c;if(n.key===pe){if(u&&A(n),-1===c)d=l;else if(d=_e(e,{startingIndex:d,amount:i,decrement:!0,disabledIndices:a}),o&&(c-i<s||d<0)){const e=c%i,t=l%i,n=l-(t-e);d=t===e?l:t>e?n:n-i}ve(e,d)&&(d=c)}if(n.key===fe&&(u&&A(n),-1===c?d=s:(d=_e(e,{startingIndex:c,amount:i,disabledIndices:a}),o&&c+i>l&&(d=_e(e,{startingIndex:c%i-i,amount:i,disabledIndices:a}))),ve(e,d)&&(d=c)),"both"===r){const t=(0,w.RI)(c/i);n.key===me&&(u&&A(n),c%i!=i-1?(d=_e(e,{startingIndex:c,disabledIndices:a}),o&&ge(d,i,t)&&(d=_e(e,{startingIndex:c-c%i-1,disabledIndices:a}))):o&&(d=_e(e,{startingIndex:c-c%i-1,disabledIndices:a})),ge(d,i,t)&&(d=c)),n.key===he&&(u&&A(n),c%i!=0?(d=_e(e,{startingIndex:c,decrement:!0,disabledIndices:a}),o&&ge(d,i,t)&&(d=_e(e,{startingIndex:c+(i-c%i),decrement:!0,disabledIndices:a}))):o&&(d=_e(e,{startingIndex:c+(i-c%i),decrement:!0,disabledIndices:a})),ge(d,i,t)&&(d=c));const r=(0,w.RI)(l/i)===t;ve(e,d)&&(d=o&&r?n.key===he?l:_e(e,{startingIndex:c-c%i-1,disabledIndices:a}):c)}return d}function Ee(e,t,n){const r=[];let o=0;return e.forEach(((e,i)=>{let{width:a,height:s}=e,l=!1;for(n&&(o=0);!l;){const e=[];for(let n=0;n<a;n++)for(let r=0;r<s;r++)e.push(o+n+r*t);o%t+a<=t&&e.every((e=>null==r[e]))?(e.forEach((e=>{r[e]=i})),l=!0):o++}})),[...r]}function we(e,t,n,r,o){if(-1===e)return-1;const i=n.indexOf(e),a=t[e];switch(o){case"tl":return i;case"tr":return a?i+a.width-1:i;case"bl":return a?i+(a.height-1)*r:i;case"br":return n.lastIndexOf(e)}}function xe(e,t){return t.flatMap(((t,n)=>e.includes(t)?[n]:[]))}function ke(e,t,n){if(n)return n.includes(t);const r=e[t];return null==r||r.hasAttribute("disabled")||"true"===r.getAttribute("aria-disabled")}let Ce=0;function Se(e,t){void 0===t&&(t={});const{preventScroll:n=!1,cancelPrevious:r=!0,sync:o=!1}=t;r&&cancelAnimationFrame(Ce);const i=()=>null==e?void 0:e.focus({preventScroll:n});o?i():Ce=requestAnimationFrame(i)}var Me="undefined"!=typeof document?r.useLayoutEffect:r.useEffect;function Te(e,t){const n=e.compareDocumentPosition(t);return n&Node.DOCUMENT_POSITION_FOLLOWING||n&Node.DOCUMENT_POSITION_CONTAINED_BY?-1:n&Node.DOCUMENT_POSITION_PRECEDING||n&Node.DOCUMENT_POSITION_CONTAINS?1:0}const Oe=r.createContext({register:()=>{},unregister:()=>{},map:new Map,elementsRef:{current:[]}});function De(e){const{children:t,elementsRef:n,labelsRef:o}=e,[i,a]=r.useState((()=>new Map)),s=r.useCallback((e=>{a((t=>new Map(t).set(e,null)))}),[]),l=r.useCallback((e=>{a((t=>{const n=new Map(t);return n.delete(e),n}))}),[]);return Me((()=>{const e=new Map(i);Array.from(e.keys()).sort(Te).forEach(((t,n)=>{e.set(t,n)})),function(e,t){if(e.size!==t.size)return!1;for(const[n,r]of e.entries())if(r!==t.get(n))return!1;return!0}(i,e)||a(e)}),[i]),r.createElement(Oe.Provider,{value:r.useMemo((()=>({register:s,unregister:l,map:i,elementsRef:n,labelsRef:o})),[s,l,i,n,o])},t)}function Le(e){void 0===e&&(e={});const{label:t}=e,{register:n,unregister:o,map:i,elementsRef:a,labelsRef:s}=r.useContext(Oe),[l,c]=r.useState(null),u=r.useRef(null),d=r.useCallback((e=>{if(u.current=e,null!==l&&(a.current[l]=e,s)){var n;const r=void 0!==t;s.current[l]=r?t:null!=(n=null==e?void 0:e.textContent)?n:null}}),[l,a,s,t]);return Me((()=>{const e=u.current;if(e)return n(e),()=>{o(e)}}),[n,o]),Me((()=>{const e=u.current?i.get(u.current):null;null!=e&&c(e)}),[i]),r.useMemo((()=>({ref:d,index:null==l?-1:l})),[l,d])}function Pe(e,t){return"function"==typeof e?e(t):e?r.cloneElement(e,t):r.createElement("div",t)}const Ie=r.createContext({activeIndex:0,onNavigate:()=>{}}),Be=[he,me],Re=[pe,fe],Ne=[...Be,...Re],Fe=r.forwardRef((function(e,t){const{render:n,orientation:o="both",loop:i=!0,cols:a=1,disabledIndices:s,activeIndex:l,onNavigate:c,itemSizes:u,dense:d=!1,...p}=e,[f,h]=r.useState(0),m=null!=l?l:f,g=de(null!=c?c:h),v=r.useRef([]),y=n&&"function"!=typeof n?n.props:{},b=r.useMemo((()=>({activeIndex:m,onNavigate:g})),[m,g]),_=a>1;const A={...p,...y,ref:t,"aria-orientation":"both"===o?void 0:o,onKeyDown(e){null==p.onKeyDown||p.onKeyDown(e),null==y.onKeyDown||y.onKeyDown(e),function(e){if(!Ne.includes(e.key))return;let t=m;const n=ye(v,s),r=be(v,s);if(_){const l=u||Array.from({length:v.current.length},(()=>({width:1,height:1}))),c=Ee(l,a,d),p=c.findIndex((e=>null!=e&&!ke(v.current,e,s))),f=c.reduce(((e,t,n)=>null==t||ke(v.current,t,s)?e:n),-1);t=c[Ae({current:c.map((e=>e?v.current[e]:null))},{event:e,orientation:o,loop:i,cols:a,disabledIndices:xe([...s||v.current.map(((e,t)=>ke(v.current,t)?t:void 0)),void 0],c),minIndex:p,maxIndex:f,prevIndex:we(m>r?n:m,l,c,a,e.key===fe?"bl":e.key===me?"tr":"tl")})]}const l={horizontal:[me],vertical:[fe],both:[me,fe]}[o],c={horizontal:[he],vertical:[pe],both:[he,pe]}[o],p=_?Ne:{horizontal:Be,vertical:Re,both:Ne}[o];t===m&&[...l,...c].includes(e.key)&&(t=i&&t===r&&l.includes(e.key)?n:i&&t===n&&c.includes(e.key)?r:_e(v,{startingIndex:t,decrement:c.includes(e.key),disabledIndices:s})),t===m||ve(v,t)||(e.stopPropagation(),p.includes(e.key)&&e.preventDefault(),g(t),queueMicrotask((()=>{Se(v.current[t])})))}(e)}};return r.createElement(Ie.Provider,{value:b},r.createElement(De,{elementsRef:v},Pe(n,A)))})),je=r.forwardRef((function(e,t){const{render:n,...o}=e,i=n&&"function"!=typeof n?n.props:{},{activeIndex:a,onNavigate:s}=r.useContext(Ie),{ref:l,index:c}=Le(),u=le([l,t,i.ref]),d=a===c;return Pe(n,{...o,...i,ref:u,tabIndex:d?0:-1,"data-active":d?"":void 0,onFocus(e){null==o.onFocus||o.onFocus(e),null==i.onFocus||i.onFocus(e),s(c)}})}));function Ye(){return Ye=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Ye.apply(this,arguments)}let $e=!1,He=0;const Ue=()=>"floating-ui-"+Math.random().toString(36).slice(2,6)+He++;const ze=ce.useId||function(){const[e,t]=r.useState((()=>$e?Ue():void 0));return Me((()=>{null==e&&t(Ue())}),[]),r.useEffect((()=>{$e=!0}),[]),e};const We=r.forwardRef((function(e,t){const{context:{placement:n,elements:{floating:o},middlewareData:{arrow:i}},width:a=14,height:s=7,tipRadius:l=0,strokeWidth:c=0,staticOffset:u,stroke:d,d:p,style:{transform:f,...h}={},...m}=e;const g=ze();if(!o)return null;const v=2*c,y=v/2,b=a/2*(l/-8+1),_=s/2*l/4,[A,E]=n.split("-"),w=x.iD.isRTL(o),k=!!p,C="top"===A||"bottom"===A,S=u&&"end"===E?"bottom":"top";let M=u&&"end"===E?"right":"left";u&&w&&(M="end"===E?"left":"right");const T=null!=(null==i?void 0:i.x)?u||i.x:"",O=null!=(null==i?void 0:i.y)?u||i.y:"",D=p||"M0,0 H"+a+" L"+(a-b)+","+(s-_)+" Q"+a/2+","+s+" "+b+","+(s-_)+" Z",L={top:k?"rotate(180deg)":"",left:k?"rotate(90deg)":"rotate(-90deg)",bottom:k?"":"rotate(180deg)",right:k?"rotate(-90deg)":"rotate(90deg)"}[A];return r.createElement("svg",Ye({},m,{"aria-hidden":!0,ref:t,width:k?a:a+v,height:a,viewBox:"0 0 "+a+" "+(s>a?s:a),style:{position:"absolute",pointerEvents:"none",[M]:T,[S]:O,[A]:C||k?"100%":"calc(100% - "+v/2+"px)",transform:""+L+(null!=f?f:""),...h}}),v>0&&r.createElement("path",{clipPath:"url(#"+g+")",fill:"none",stroke:d,strokeWidth:v+(p?0:1),d:D}),r.createElement("path",{stroke:v&&!p?m.fill:"none",d:D}),r.createElement("clipPath",{id:g},r.createElement("rect",{x:-y,y:y*(k?-1:1),width:a+v,height:a})))}));function Ve(){const e=new Map;return{emit(t,n){var r;null==(r=e.get(t))||r.forEach((e=>e(n)))},on(t,n){e.set(t,[...e.get(t)||[],n])},off(t,n){var r;e.set(t,(null==(r=e.get(t))?void 0:r.filter((e=>e!==n)))||[])}}}const Ge=r.createContext(null),Qe=r.createContext(null),qe=()=>{var e;return(null==(e=r.useContext(Ge))?void 0:e.id)||null},Ke=()=>r.useContext(Qe);function Ze(e){const t=ze(),n=Ke(),r=qe(),o=e||r;return Me((()=>{const e={id:t,parentId:o};return null==n||n.addNode(e),()=>{null==n||n.removeNode(e)}}),[n,t,o]),t}function Je(e){const{children:t,id:n}=e,o=qe();return r.createElement(Ge.Provider,{value:r.useMemo((()=>({id:n,parentId:o})),[n,o])},t)}function Xe(e){const{children:t}=e,n=r.useRef([]),o=r.useCallback((e=>{n.current=[...n.current,e]}),[]),i=r.useCallback((e=>{n.current=n.current.filter((t=>t!==e))}),[]),a=r.useState((()=>Ve()))[0];return r.createElement(Qe.Provider,{value:r.useMemo((()=>({nodesRef:n,addNode:o,removeNode:i,events:a})),[o,i,a])},t)}function et(e){return"data-floating-ui-"+e}function tt(e){const t=(0,r.useRef)(e);return Me((()=>{t.current=e})),t}const nt=et("safe-polygon");function rt(e,t,n){return n&&!m(n)?0:"number"==typeof e?e:null==e?void 0:e[t]}function ot(e,t){void 0===t&&(t={});const{open:n,onOpenChange:o,dataRef:a,events:l,elements:{domReference:c,floating:u}}=e,{enabled:d=!0,delay:p=0,handleClose:f=null,mouseOnly:h=!1,restMs:v=0,move:y=!0}=t,b=Ke(),_=qe(),A=tt(f),E=tt(p),w=r.useRef(),x=r.useRef(-1),k=r.useRef(),C=r.useRef(-1),S=r.useRef(!0),M=r.useRef(!1),T=r.useRef((()=>{})),O=r.useCallback((()=>{var e;const t=null==(e=a.current.openEvent)?void 0:e.type;return(null==t?void 0:t.includes("mouse"))&&"mousedown"!==t}),[a]);r.useEffect((()=>{if(d)return l.on("openchange",e),()=>{l.off("openchange",e)};function e(e){let{open:t}=e;t||(clearTimeout(x.current),clearTimeout(C.current),S.current=!0)}}),[d,l]),r.useEffect((()=>{if(!d||!A.current||!n)return;function e(e){O()&&o(!1,e,"hover")}const t=g(u).documentElement;return t.addEventListener("mouseleave",e),()=>{t.removeEventListener("mouseleave",e)}}),[u,n,o,d,A,O]);const D=r.useCallback((function(e,t,n){void 0===t&&(t=!0),void 0===n&&(n="hover");const r=rt(E.current,"close",w.current);r&&!k.current?(clearTimeout(x.current),x.current=window.setTimeout((()=>o(!1,e,n)),r)):t&&(clearTimeout(x.current),o(!1,e,n))}),[E,o]),L=de((()=>{T.current(),k.current=void 0})),P=de((()=>{if(M.current){const e=g(u).body;e.style.pointerEvents="",e.removeAttribute(nt),M.current=!1}}));return r.useEffect((()=>{if(d&&(0,i.vq)(c)){const e=c;return n&&e.addEventListener("mouseleave",l),null==u||u.addEventListener("mouseleave",l),y&&e.addEventListener("mousemove",t,{once:!0}),e.addEventListener("mouseenter",t),e.addEventListener("mouseleave",r),()=>{n&&e.removeEventListener("mouseleave",l),null==u||u.removeEventListener("mouseleave",l),y&&e.removeEventListener("mousemove",t),e.removeEventListener("mouseenter",t),e.removeEventListener("mouseleave",r)}}function e(){return!!a.current.openEvent&&["click","mousedown"].includes(a.current.openEvent.type)}function t(e){if(clearTimeout(x.current),S.current=!1,h&&!m(w.current)||v>0&&!rt(E.current,"open"))return;const t=rt(E.current,"open",w.current);t?x.current=window.setTimeout((()=>{o(!0,e,"hover")}),t):o(!0,e,"hover")}function r(t){if(e())return;T.current();const r=g(u);if(clearTimeout(C.current),A.current&&a.current.floatingContext){n||clearTimeout(x.current),k.current=A.current({...a.current.floatingContext,tree:b,x:t.clientX,y:t.clientY,onClose(){P(),L(),D(t,!0,"safe-polygon")}});const e=k.current;return r.addEventListener("mousemove",e),void(T.current=()=>{r.removeEventListener("mousemove",e)})}("touch"!==w.current||!s(u,t.relatedTarget))&&D(t)}function l(t){e()||a.current.floatingContext&&(null==A.current||A.current({...a.current.floatingContext,tree:b,x:t.clientX,y:t.clientY,onClose(){P(),L(),D(t)}})(t))}}),[c,u,d,e,h,v,y,D,L,P,o,n,b,E,A,a]),Me((()=>{var e;if(d&&n&&null!=(e=A.current)&&e.__options.blockPointerEvents&&O()){const e=g(u).body;if(e.setAttribute(nt,""),e.style.pointerEvents="none",M.current=!0,(0,i.vq)(c)&&u){var t;const e=c,n=null==b||null==(t=b.nodesRef.current.find((e=>e.id===_)))||null==(t=t.context)?void 0:t.elements.floating;return n&&(n.style.pointerEvents=""),e.style.pointerEvents="auto",u.style.pointerEvents="auto",()=>{e.style.pointerEvents="",u.style.pointerEvents=""}}}}),[d,n,_,u,c,b,A,O]),Me((()=>{n||(w.current=void 0,L(),P())}),[n,L,P]),r.useEffect((()=>()=>{L(),clearTimeout(x.current),clearTimeout(C.current),P()}),[d,c,L,P]),r.useMemo((()=>{if(!d)return{};function e(e){w.current=e.pointerType}return{reference:{onPointerDown:e,onPointerEnter:e,onMouseMove(e){function t(){S.current||o(!0,e.nativeEvent,"hover")}h&&!m(w.current)||n||0===v||(clearTimeout(C.current),"touch"===w.current?t():C.current=window.setTimeout(t,v))}},floating:{onMouseEnter(){clearTimeout(x.current)},onMouseLeave(e){D(e.nativeEvent,!1)}}}}),[d,h,n,v,o,D])}const it=()=>{},at=r.createContext({delay:0,initialDelay:0,timeoutMs:0,currentId:null,setCurrentId:it,setState:it,isInstantPhase:!1}),st=()=>r.useContext(at);function lt(e){const{children:t,delay:n,timeoutMs:o=0}=e,[i,a]=r.useReducer(((e,t)=>({...e,...t})),{delay:n,timeoutMs:o,initialDelay:n,currentId:null,isInstantPhase:!1}),s=r.useRef(null),l=r.useCallback((e=>{a({currentId:e})}),[]);return Me((()=>{i.currentId?null===s.current?s.current=i.currentId:i.isInstantPhase||a({isInstantPhase:!0}):(i.isInstantPhase&&a({isInstantPhase:!1}),s.current=null)}),[i.currentId,i.isInstantPhase]),r.createElement(at.Provider,{value:r.useMemo((()=>({...i,setState:a,setCurrentId:l})),[i,l])},t)}function ct(e,t){void 0===t&&(t={});const{open:n,onOpenChange:r,floatingId:o}=e,{id:i}=t,a=null!=i?i:o,s=st(),{currentId:l,setCurrentId:c,initialDelay:u,setState:d,timeoutMs:p}=s;return Me((()=>{l&&(d({delay:{open:1,close:rt(u,"close")}}),l!==a&&r(!1))}),[a,r,d,l,u]),Me((()=>{function e(){r(!1),d({delay:u,currentId:null})}if(l&&!n&&l===a){if(p){const t=window.setTimeout(e,p);return()=>{clearTimeout(t)}}e()}}),[n,d,l,a,r,u,p]),Me((()=>{c!==it&&n&&c(a)}),[n,c,a]),s}function ut(e,t){let n=e.filter((e=>{var n;return e.parentId===t&&(null==(n=e.context)?void 0:n.open)})),r=n;for(;r.length;)r=e.filter((e=>{var t;return null==(t=r)?void 0:t.some((t=>{var n;return e.parentId===t.id&&(null==(n=e.context)?void 0:n.open)}))})),n=n.concat(r);return n}let dt=new WeakMap,pt=new WeakSet,ft={},ht=0;const mt=()=>"undefined"!=typeof HTMLElement&&"inert"in HTMLElement.prototype,gt=e=>e&&(e.host||gt(e.parentNode)),vt=(e,t)=>t.map((t=>{if(e.contains(t))return t;const n=gt(t);return e.contains(n)?n:null})).filter((e=>null!=e));function yt(e,t,n){void 0===t&&(t=!1),void 0===n&&(n=!1);const r=g(e[0]).body;return function(e,t,n,r){const o="data-floating-ui-inert",a=r?"inert":n?"aria-hidden":null,s=vt(t,e),l=new Set,c=new Set(s),u=[];ft[o]||(ft[o]=new WeakMap);const d=ft[o];return s.forEach((function e(t){t&&!l.has(t)&&(l.add(t),t.parentNode&&e(t.parentNode))})),function e(t){t&&!c.has(t)&&[].forEach.call(t.children,(t=>{if("script"!==(0,i.mq)(t))if(l.has(t))e(t);else{const e=a?t.getAttribute(a):null,n=null!==e&&"false"!==e,r=(dt.get(t)||0)+1,i=(d.get(t)||0)+1;dt.set(t,r),d.set(t,i),u.push(t),1===r&&n&&pt.add(t),1===i&&t.setAttribute(o,""),!n&&a&&t.setAttribute(a,"true")}}))}(t),l.clear(),ht++,()=>{u.forEach((e=>{const t=(dt.get(e)||0)-1,n=(d.get(e)||0)-1;dt.set(e,t),d.set(e,n),t||(!pt.has(e)&&a&&e.removeAttribute(a),pt.delete(e)),n||e.removeAttribute(o)})),ht--,ht||(dt=new WeakMap,dt=new WeakMap,pt=new WeakSet,ft={})}}(e.concat(Array.from(r.querySelectorAll("[aria-live]"))),r,t,n)}const bt=()=>({getShadowRoot:!0,displayCheck:"function"==typeof ResizeObserver&&ResizeObserver.toString().includes("[native code]")?"full":"none"});function _t(e,t){const n=ae(e,bt());"prev"===t&&n.reverse();const r=n.indexOf(a(g(e)));return n.slice(r+1)[0]}function At(){return _t(document.body,"next")}function Et(){return _t(document.body,"prev")}function wt(e,t){const n=t||e.currentTarget,r=e.relatedTarget;return!r||!s(n,r)}function xt(e){ae(e,bt()).forEach((e=>{e.dataset.tabindex=e.getAttribute("tabindex")||"",e.setAttribute("tabindex","-1")}))}function kt(e){e.querySelectorAll("[data-tabindex]").forEach((e=>{const t=e.dataset.tabindex;delete e.dataset.tabindex,t?e.setAttribute("tabindex",t):e.removeAttribute("tabindex")}))}const Ct={border:0,clip:"rect(0 0 0 0)",height:"1px",margin:"-1px",overflow:"hidden",padding:0,position:"fixed",whiteSpace:"nowrap",width:"1px",top:0,left:0};function St(e){"Tab"===e.key&&(e.target,clearTimeout(undefined))}const Mt=r.forwardRef((function(e,t){const[n,o]=r.useState();Me((()=>(p()&&o("button"),document.addEventListener("keydown",St),()=>{document.removeEventListener("keydown",St)})),[]);const i={ref:t,tabIndex:0,role:n,"aria-hidden":!n||void 0,[et("focus-guard")]:"",style:Ct};return r.createElement("span",Ye({},e,i))})),Tt=r.createContext(null),Ot=et("portal");function Dt(e){void 0===e&&(e={});const{id:t,root:n}=e,o=ze(),a=Pt(),[s,l]=r.useState(null),c=r.useRef(null);return Me((()=>()=>{null==s||s.remove(),queueMicrotask((()=>{c.current=null}))}),[s]),Me((()=>{if(!o)return;if(c.current)return;const e=t?document.getElementById(t):null;if(!e)return;const n=document.createElement("div");n.id=o,n.setAttribute(Ot,""),e.appendChild(n),c.current=n,l(n)}),[t,o]),Me((()=>{if(!o)return;if(c.current)return;let e=n||(null==a?void 0:a.portalNode);e&&!(0,i.vq)(e)&&(e=e.current),e=e||document.body;let r=null;t&&(r=document.createElement("div"),r.id=t,e.appendChild(r));const s=document.createElement("div");s.id=o,s.setAttribute(Ot,""),e=r||e,e.appendChild(s),c.current=s,l(s)}),[t,n,o,a]),s}function Lt(e){const{children:t,id:n,root:o=null,preserveTabOrder:i=!0}=e,a=Dt({id:n,root:o}),[s,l]=r.useState(null),c=r.useRef(null),u=r.useRef(null),d=r.useRef(null),p=r.useRef(null),f=!!s&&!s.modal&&s.open&&i&&!(!o&&!a);return r.useEffect((()=>{if(a&&i&&(null==s||!s.modal))return a.addEventListener("focusin",e,!0),a.addEventListener("focusout",e,!0),()=>{a.removeEventListener("focusin",e,!0),a.removeEventListener("focusout",e,!0)};function e(e){if(a&&wt(e)){("focusin"===e.type?kt:xt)(a)}}}),[a,i,null==s?void 0:s.modal]),r.createElement(Tt.Provider,{value:r.useMemo((()=>({preserveTabOrder:i,beforeOutsideRef:c,afterOutsideRef:u,beforeInsideRef:d,afterInsideRef:p,portalNode:a,setFocusManagerState:l})),[i,a])},f&&a&&r.createElement(Mt,{"data-type":"outside",ref:c,onFocus:e=>{if(wt(e,a)){var t;null==(t=d.current)||t.focus()}else{const e=Et()||(null==s?void 0:s.refs.domReference.current);null==e||e.focus()}}}),f&&a&&r.createElement("span",{"aria-owns":a.id,style:Ct}),a&&(0,k.createPortal)(t,a),f&&a&&r.createElement(Mt,{"data-type":"outside",ref:u,onFocus:e=>{if(wt(e,a)){var t;null==(t=p.current)||t.focus()}else{const t=At()||(null==s?void 0:s.refs.domReference.current);null==t||t.focus(),(null==s?void 0:s.closeOnFocusOut)&&(null==s||s.onOpenChange(!1,e.nativeEvent))}}}))}const Pt=()=>r.useContext(Tt),It=20;let Bt=[];function Rt(e){Bt=Bt.filter((e=>e.isConnected));let t=e;if(t&&"body"!==(0,i.mq)(t)){if(!se(t,bt())){const e=ae(t,bt())[0];e&&(t=e)}Bt.push(t),Bt.length>It&&(Bt=Bt.slice(-It))}}function Nt(){return Bt.slice().reverse().find((e=>e.isConnected))}const Ft=r.forwardRef((function(e,t){return r.createElement("button",Ye({},e,{type:"button",ref:t,tabIndex:-1,style:Ct}))}));function jt(e){const{context:t,children:n,disabled:o=!1,order:l=["content"],guards:c=!0,initialFocus:p=0,returnFocus:f=!0,modal:h=!0,visuallyHiddenDismiss:m=!1,closeOnFocusOut:v=!0}=e,{open:b,refs:_,nodeId:w,onOpenChange:x,events:k,dataRef:C,elements:{domReference:S,floating:M}}=t,T="number"==typeof p&&p<0,O=E(S)&&T,D=!mt()||c,L=tt(l),P=tt(p),I=tt(f),B=Ke(),R=Pt(),N=r.useRef(null),F=r.useRef(null),j=r.useRef(!1),Y=r.useRef(!1),$=null!=R,H=r.useCallback((function(e){return void 0===e&&(e=M),e?ae(e,bt()):[]}),[M]),U=r.useCallback((e=>{const t=H(e);return L.current.map((e=>S&&"reference"===e?S:M&&"floating"===e?M:t)).filter(Boolean).flat()}),[S,M,L,H]);function z(e){return!o&&m&&h?r.createElement(Ft,{ref:"start"===e?N:F,onClick:e=>x(!1,e.nativeEvent)},"string"==typeof m?m:"Dismiss"):null}r.useEffect((()=>{if(o||!h)return;function e(e){if("Tab"===e.key){s(M,a(g(M)))&&0===H().length&&!O&&A(e);const t=U(),n=y(e);"reference"===L.current[0]&&n===S&&(A(e),e.shiftKey?Se(t[t.length-1]):Se(t[1])),"floating"===L.current[1]&&n===M&&e.shiftKey&&(A(e),Se(t[0]))}}const t=g(M);return t.addEventListener("keydown",e),()=>{t.removeEventListener("keydown",e)}}),[o,S,M,h,L,O,H,U]),r.useEffect((()=>{if(!o&&v)return M&&(0,i.sb)(S)?(S.addEventListener("focusout",t),S.addEventListener("pointerdown",e),!h&&M.addEventListener("focusout",t),()=>{S.removeEventListener("focusout",t),S.removeEventListener("pointerdown",e),!h&&M.removeEventListener("focusout",t)}):void 0;function e(){Y.current=!0,setTimeout((()=>{Y.current=!1}))}function t(e){const t=e.relatedTarget;queueMicrotask((()=>{const n=!(s(S,t)||s(M,t)||s(t,M)||s(null==R?void 0:R.portalNode,t)||null!=t&&t.hasAttribute(et("focus-guard"))||B&&(ut(B.nodesRef.current,w).find((e=>{var n,r;return s(null==(n=e.context)?void 0:n.elements.floating,t)||s(null==(r=e.context)?void 0:r.elements.domReference,t)}))||function(e,t){var n;let r=[],o=null==(n=e.find((e=>e.id===t)))?void 0:n.parentId;for(;o;){const t=e.find((e=>e.id===o));o=null==t?void 0:t.parentId,t&&(r=r.concat(t))}return r}(B.nodesRef.current,w).find((e=>{var n,r;return(null==(n=e.context)?void 0:n.elements.floating)===t||(null==(r=e.context)?void 0:r.elements.domReference)===t}))));t&&n&&!Y.current&&t!==Nt()&&(j.current=!0,x(!1,e))}))}}),[o,S,M,h,w,B,R,x,v]),r.useEffect((()=>{var e;if(o)return;const t=Array.from((null==R||null==(e=R.portalNode)?void 0:e.querySelectorAll("["+et("portal")+"]"))||[]);if(M){const e=[M,...t,N.current,F.current,L.current.includes("reference")||O?S:null].filter((e=>null!=e)),n=h||O?yt(e,D,!D):yt(e);return()=>{n()}}}),[o,S,M,h,L,R,O,D]),Me((()=>{if(o||!M)return;const e=a(g(M));queueMicrotask((()=>{const t=U(M),n=P.current,r=("number"==typeof n?t[n]:n.current)||M,o=s(M,e);T||o||!b||Se(r,{preventScroll:r===M})}))}),[o,b,M,T,U,P]),Me((()=>{if(o||!M)return;let e=!1;const t=g(M),n=a(t);let r=C.current.openEvent;function l(t){let{open:n,reason:o,event:i,nested:a}=t;n&&(r=i),"escape-key"===o&&_.domReference.current&&Rt(_.domReference.current),"hover"===o&&"mouseleave"===i.type&&(j.current=!0),"outside-press"===o&&(a?(j.current=!1,e=!0):j.current=!(u(i)||d(i)))}return Rt(n),k.on("openchange",l),()=>{k.off("openchange",l);const n=a(t),o=s(M,n)||B&&ut(B.nodesRef.current,w).some((e=>{var t;return s(null==(t=e.context)?void 0:t.elements.floating,n)}));(o||r&&["click","mousedown"].includes(r.type))&&_.domReference.current&&Rt(_.domReference.current);const c=Nt();I.current&&!j.current&&(0,i.sb)(c)&&(c===n||n===t.body||o)&&Se(c,{cancelPrevious:!1,preventScroll:e})}}),[o,M,I,C,_,k,B,w]),Me((()=>{if(!o&&R)return R.setFocusManagerState({modal:h,closeOnFocusOut:v,open:b,onOpenChange:x,refs:_}),()=>{R.setFocusManagerState(null)}}),[o,R,h,b,x,_,v]),Me((()=>{if(o||!M||"function"!=typeof MutationObserver||T)return;const e=()=>{const e=M.getAttribute("tabindex");L.current.includes("floating")||a(g(M))!==_.domReference.current&&0===H().length?"0"!==e&&M.setAttribute("tabindex","0"):"-1"!==e&&M.setAttribute("tabindex","-1")};e();const t=new MutationObserver(e);return t.observe(M,{childList:!0,subtree:!0,attributes:!0}),()=>{t.disconnect()}}),[o,M,_,L,H,T]);const W=!o&&D&&($||h);return r.createElement(r.Fragment,null,W&&r.createElement(Mt,{"data-type":"inside",ref:null==R?void 0:R.beforeInsideRef,onFocus:e=>{if(h){const e=U();Se("reference"===l[0]?e[0]:e[e.length-1])}else if(null!=R&&R.preserveTabOrder&&R.portalNode)if(j.current=!1,wt(e,R.portalNode)){const e=At()||S;null==e||e.focus()}else{var t;null==(t=R.beforeOutsideRef.current)||t.focus()}}}),!O&&z("start"),n,z("end"),W&&r.createElement(Mt,{"data-type":"inside",ref:null==R?void 0:R.afterInsideRef,onFocus:e=>{if(h)Se(U()[0]);else if(null!=R&&R.preserveTabOrder&&R.portalNode)if(v&&(j.current=!0),wt(e,R.portalNode)){const e=Et()||S;null==e||e.focus()}else{var t;null==(t=R.afterOutsideRef.current)||t.focus()}}}))}const Yt=new Set,$t=r.forwardRef((function(e,t){const{lockScroll:n=!1,...o}=e,i=ze();return Me((()=>{if(!n)return;Yt.add(i);const e=/iP(hone|ad|od)|iOS/.test(l()),t=document.body.style,r=Math.round(document.documentElement.getBoundingClientRect().left)+document.documentElement.scrollLeft?"paddingLeft":"paddingRight",o=window.innerWidth-document.documentElement.clientWidth,a=t.left?parseFloat(t.left):window.pageXOffset,s=t.top?parseFloat(t.top):window.pageYOffset;if(t.overflow="hidden",o&&(t[r]=o+"px"),e){var c,u;const e=(null==(c=window.visualViewport)?void 0:c.offsetLeft)||0,n=(null==(u=window.visualViewport)?void 0:u.offsetTop)||0;Object.assign(t,{position:"fixed",top:-(s-Math.floor(n))+"px",left:-(a-Math.floor(e))+"px",right:"0"})}return()=>{Yt.delete(i),0===Yt.size&&(Object.assign(t,{overflow:"",[r]:""}),e&&(Object.assign(t,{position:"",top:"",left:"",right:""}),window.scrollTo(a,s)))}}),[i,n]),r.createElement("div",Ye({ref:t},o,{style:{position:"fixed",overflow:"auto",top:0,right:0,bottom:0,left:0,...o.style}}))}));function Ht(e){return(0,i.sb)(e.target)&&"BUTTON"===e.target.tagName}function Ut(e){return _(e)}function zt(e,t){void 0===t&&(t={});const{open:n,onOpenChange:o,dataRef:i,elements:{domReference:a}}=e,{enabled:s=!0,event:l="click",toggle:c=!0,ignoreMouse:u=!1,keyboardHandlers:d=!0}=t,p=r.useRef(),f=r.useRef(!1);return r.useMemo((()=>s?{reference:{onPointerDown(e){p.current=e.pointerType},onMouseDown(e){0===e.button&&(m(p.current,!0)&&u||"click"!==l&&(!n||!c||i.current.openEvent&&"mousedown"!==i.current.openEvent.type?(e.preventDefault(),o(!0,e.nativeEvent,"click")):o(!1,e.nativeEvent,"click")))},onClick(e){"mousedown"===l&&p.current?p.current=void 0:m(p.current,!0)&&u||(!n||!c||i.current.openEvent&&"click"!==i.current.openEvent.type?o(!0,e.nativeEvent,"click"):o(!1,e.nativeEvent,"click"))},onKeyDown(e){p.current=void 0,e.defaultPrevented||!d||Ht(e)||(" "!==e.key||Ut(a)||(e.preventDefault(),f.current=!0),"Enter"===e.key&&o(!n||!c,e.nativeEvent,"click"))},onKeyUp(e){e.defaultPrevented||!d||Ht(e)||Ut(a)||" "===e.key&&f.current&&(f.current=!1,o(!n||!c,e.nativeEvent,"click"))}}}:{}),[s,i,l,u,d,a,c,n,o])}function Wt(e){return null!=e&&null!=e.clientX}function Vt(e,t){void 0===t&&(t={});const{open:n,dataRef:o,elements:{floating:a,domReference:l},refs:c}=e,{enabled:u=!0,axis:d="both",x:p=null,y:f=null}=t,h=r.useRef(!1),g=r.useRef(null),[v,b]=r.useState(),[_,A]=r.useState([]),E=de(((e,t)=>{h.current||o.current.openEvent&&!Wt(o.current.openEvent)||c.setPositionReference(function(e,t){let n=null,r=null,o=!1;return{contextElement:e||void 0,getBoundingClientRect(){var i;const a=(null==e?void 0:e.getBoundingClientRect())||{width:0,height:0,x:0,y:0},s="x"===t.axis||"both"===t.axis,l="y"===t.axis||"both"===t.axis,c=["mouseenter","mousemove"].includes((null==(i=t.dataRef.current.openEvent)?void 0:i.type)||"")&&"touch"!==t.pointerType;let u=a.width,d=a.height,p=a.x,f=a.y;return null==n&&t.x&&s&&(n=a.x-t.x),null==r&&t.y&&l&&(r=a.y-t.y),p-=n||0,f-=r||0,u=0,d=0,!o||c?(u="y"===t.axis?a.width:0,d="x"===t.axis?a.height:0,p=s&&null!=t.x?t.x:p,f=l&&null!=t.y?t.y:f):o&&!c&&(d="x"===t.axis?a.height:d,u="y"===t.axis?a.width:u),o=!0,{width:u,height:d,x:p,y:f,top:f,right:p+u,bottom:f+d,left:p}}}}(l,{x:e,y:t,axis:d,dataRef:o,pointerType:v}))})),w=de((e=>{null==p&&null==f&&(n?g.current||A([]):E(e.clientX,e.clientY))})),x=m(v)?a:n,k=r.useCallback((()=>{if(!x||!u||null!=p||null!=f)return;const e=(0,i.zk)(a);function t(n){const r=y(n);s(a,r)?(e.removeEventListener("mousemove",t),g.current=null):E(n.clientX,n.clientY)}if(!o.current.openEvent||Wt(o.current.openEvent)){e.addEventListener("mousemove",t);const n=()=>{e.removeEventListener("mousemove",t),g.current=null};return g.current=n,n}c.setPositionReference(l)}),[x,u,p,f,a,o,c,l,E]);return r.useEffect((()=>k()),[k,_]),r.useEffect((()=>{u&&!a&&(h.current=!1)}),[u,a]),r.useEffect((()=>{!u&&n&&(h.current=!0)}),[u,n]),Me((()=>{!u||null==p&&null==f||(h.current=!1,E(p,f))}),[u,p,f,E]),r.useMemo((()=>{if(!u)return{};function e(e){let{pointerType:t}=e;b(t)}return{reference:{onPointerDown:e,onPointerEnter:e,onMouseMove:w,onMouseEnter:w}}}),[u,w])}const Gt={pointerdown:"onPointerDown",mousedown:"onMouseDown",click:"onClick"},Qt={pointerdown:"onPointerDownCapture",mousedown:"onMouseDownCapture",click:"onClickCapture"},qt=e=>{var t,n;return{escapeKey:"boolean"==typeof e?e:null!=(t=null==e?void 0:e.escapeKey)&&t,outsidePress:"boolean"==typeof e?e:null==(n=null==e?void 0:e.outsidePress)||n}};function Kt(e,t){void 0===t&&(t={});const{open:n,onOpenChange:o,elements:{reference:a,domReference:l,floating:c},dataRef:u}=e,{enabled:d=!0,escapeKey:p=!0,outsidePress:f=!0,outsidePressEvent:h="pointerdown",referencePress:m=!1,referencePressEvent:b="pointerdown",ancestorScroll:_=!1,bubbles:A,capture:E}=t,w=Ke(),x=de("function"==typeof f?f:()=>!1),k="function"==typeof f?x:f,C=r.useRef(!1),S=r.useRef(!1),{escapeKey:M,outsidePress:T}=qt(A),{escapeKey:O,outsidePress:D}=qt(E),L=de((e=>{var t;if(!n||!d||!p||"Escape"!==e.key)return;const r=null==(t=u.current.floatingContext)?void 0:t.nodeId,i=w?ut(w.nodesRef.current,r):[];if(!M&&(e.stopPropagation(),i.length>0)){let e=!0;if(i.forEach((t=>{var n;null==(n=t.context)||!n.open||t.context.dataRef.current.__escapeKeyBubbles||(e=!1)})),!e)return}o(!1,function(e){return"nativeEvent"in e}(e)?e.nativeEvent:e,"escape-key")})),P=de((e=>{var t;const n=()=>{var t;L(e),null==(t=y(e))||t.removeEventListener("keydown",n)};null==(t=y(e))||t.addEventListener("keydown",n)})),I=de((e=>{var t;const n=C.current;C.current=!1;const r=S.current;if(S.current=!1,"click"===h&&r)return;if(n)return;if("function"==typeof k&&!k(e))return;const a=y(e),d="["+et("inert")+"]",p=g(c).querySelectorAll(d);let f=(0,i.vq)(a)?a:null;for(;f&&!(0,i.eu)(f);){const e=(0,i.$4)(f);if((0,i.eu)(e)||!(0,i.vq)(e))break;f=e}if(p.length&&(0,i.vq)(a)&&!a.matches("html,body")&&!s(a,c)&&Array.from(p).every((e=>!s(f,e))))return;if((0,i.sb)(a)&&c){const t=a.clientWidth>0&&a.scrollWidth>a.clientWidth,n=a.clientHeight>0&&a.scrollHeight>a.clientHeight;let r=n&&e.offsetX>a.clientWidth;if(n){"rtl"===(0,i.L9)(a).direction&&(r=e.offsetX<=a.offsetWidth-a.clientWidth)}if(r||t&&e.offsetY>a.clientHeight)return}const m=null==(t=u.current.floatingContext)?void 0:t.nodeId,b=w&&ut(w.nodesRef.current,m).some((t=>{var n;return v(e,null==(n=t.context)?void 0:n.elements.floating)}));if(v(e,c)||v(e,l)||b)return;const _=w?ut(w.nodesRef.current,m):[];if(_.length>0){let e=!0;if(_.forEach((t=>{var n;null==(n=t.context)||!n.open||t.context.dataRef.current.__outsidePressBubbles||(e=!1)})),!e)return}o(!1,e,"outside-press")})),B=de((e=>{var t;const n=()=>{var t;I(e),null==(t=y(e))||t.removeEventListener(h,n)};null==(t=y(e))||t.addEventListener(h,n)}));return r.useEffect((()=>{if(!n||!d)return;function e(e){o(!1,e,"ancestor-scroll")}u.current.__escapeKeyBubbles=M,u.current.__outsidePressBubbles=T;const t=g(c);p&&t.addEventListener("keydown",O?P:L,O),k&&t.addEventListener(h,D?B:I,D);let r=[];return _&&((0,i.vq)(l)&&(r=(0,i.v9)(l)),(0,i.vq)(c)&&(r=r.concat((0,i.v9)(c))),!(0,i.vq)(a)&&a&&a.contextElement&&(r=r.concat((0,i.v9)(a.contextElement)))),r=r.filter((e=>{var n;return e!==(null==(n=t.defaultView)?void 0:n.visualViewport)})),r.forEach((t=>{t.addEventListener("scroll",e,{passive:!0})})),()=>{p&&t.removeEventListener("keydown",O?P:L,O),k&&t.removeEventListener(h,D?B:I,D),r.forEach((t=>{t.removeEventListener("scroll",e)}))}}),[u,c,l,a,p,k,h,n,o,_,d,M,T,L,O,P,I,D,B]),r.useEffect((()=>{C.current=!1}),[k,h]),r.useMemo((()=>d?{reference:{onKeyDown:L,[Gt[b]]:e=>{m&&o(!1,e.nativeEvent,"reference-press")}},floating:{onKeyDown:L,onMouseDown(){S.current=!0},onMouseUp(){S.current=!0},[Qt[h]]:()=>{C.current=!0}}}:{}),[d,m,h,b,o,L])}function Zt(e){const{open:t=!1,onOpenChange:n,elements:o}=e,i=ze(),a=r.useRef({}),[s]=r.useState((()=>Ve())),l=null!=qe();const[c,u]=r.useState(o.reference),d=de(((e,t,r)=>{a.current.openEvent=e?t:void 0,s.emit("openchange",{open:e,event:t,reason:r,nested:l}),null==n||n(e,t,r)})),p=r.useMemo((()=>({setPositionReference:u})),[]),f=r.useMemo((()=>({reference:c||o.reference||null,floating:o.floating||null,domReference:o.reference})),[c,o.reference,o.floating]);return r.useMemo((()=>({dataRef:a,open:t,onOpenChange:d,elements:f,events:s,floatingId:i,refs:p})),[t,d,f,s,i,p])}function Jt(e){void 0===e&&(e={});const{nodeId:t}=e,n=Zt({...e,elements:{reference:null,floating:null,...e.elements}}),o=e.rootContext||n,a=o.elements,[s,l]=r.useState(null),[c,u]=r.useState(null),d=(null==a?void 0:a.reference)||s,p=r.useRef(null),f=Ke();Me((()=>{d&&(p.current=d)}),[d]);const h=function(e){void 0===e&&(e={});const{placement:t="bottom",strategy:n="absolute",middleware:o=[],platform:i,elements:{reference:a,floating:s}={},transform:l=!0,whileElementsMounted:c,open:u}=e,[d,p]=r.useState({x:0,y:0,strategy:n,placement:t,middlewareData:{},isPositioned:!1}),[f,h]=r.useState(o);S(f,o)||h(o);const[m,g]=r.useState(null),[v,y]=r.useState(null),b=r.useCallback((e=>{e!==w.current&&(w.current=e,g(e))}),[]),_=r.useCallback((e=>{e!==D.current&&(D.current=e,y(e))}),[]),A=a||m,E=s||v,w=r.useRef(null),D=r.useRef(null),L=r.useRef(d),P=null!=c,I=O(c),B=O(i),R=r.useCallback((()=>{if(!w.current||!D.current)return;const e={placement:t,strategy:n,middleware:f};B.current&&(e.platform=B.current),(0,x.rD)(w.current,D.current,e).then((e=>{const t={...e,isPositioned:!0};N.current&&!S(L.current,t)&&(L.current=t,k.flushSync((()=>{p(t)})))}))}),[f,t,n,B]);C((()=>{!1===u&&L.current.isPositioned&&(L.current.isPositioned=!1,p((e=>({...e,isPositioned:!1}))))}),[u]);const N=r.useRef(!1);C((()=>(N.current=!0,()=>{N.current=!1})),[]),C((()=>{if(A&&(w.current=A),E&&(D.current=E),A&&E){if(I.current)return I.current(A,E,R);R()}}),[A,E,R,I,P]);const F=r.useMemo((()=>({reference:w,floating:D,setReference:b,setFloating:_})),[b,_]),j=r.useMemo((()=>({reference:A,floating:E})),[A,E]),Y=r.useMemo((()=>{const e={position:n,left:0,top:0};if(!j.floating)return e;const t=T(j.floating,d.x),r=T(j.floating,d.y);return l?{...e,transform:"translate("+t+"px, "+r+"px)",...M(j.floating)>=1.5&&{willChange:"transform"}}:{position:n,left:t,top:r}}),[n,l,j.floating,d.x,d.y]);return r.useMemo((()=>({...d,update:R,refs:F,elements:j,floatingStyles:Y})),[d,R,F,j,Y])}({...e,elements:{...a,...c&&{reference:c}}}),m=r.useCallback((e=>{const t=(0,i.vq)(e)?{getBoundingClientRect:()=>e.getBoundingClientRect(),contextElement:e}:e;u(t),h.refs.setReference(t)}),[h.refs]),g=r.useCallback((e=>{((0,i.vq)(e)||null===e)&&(p.current=e,l(e)),((0,i.vq)(h.refs.reference.current)||null===h.refs.reference.current||null!==e&&!(0,i.vq)(e))&&h.refs.setReference(e)}),[h.refs]),v=r.useMemo((()=>({...h.refs,setReference:g,setPositionReference:m,domReference:p})),[h.refs,g,m]),y=r.useMemo((()=>({...h.elements,domReference:d})),[h.elements,d]),b=r.useMemo((()=>({...h,...o,refs:v,elements:y,nodeId:t})),[h,v,y,t,o]);return Me((()=>{o.dataRef.current.floatingContext=b;const e=null==f?void 0:f.nodesRef.current.find((e=>e.id===t));e&&(e.context=b)})),r.useMemo((()=>({...h,context:b,refs:v,elements:y})),[h,v,y,b])}function Xt(e,t){void 0===t&&(t={});const{open:n,onOpenChange:o,events:l,dataRef:c,elements:{domReference:u}}=e,{enabled:f=!0,visibleOnly:m=!0}=t,v=r.useRef(!1),b=r.useRef(),A=r.useRef(!0);return r.useEffect((()=>{if(!f)return;const e=(0,i.zk)(u);function t(){!n&&(0,i.sb)(u)&&u===a(g(u))&&(v.current=!0)}function r(){A.current=!0}return e.addEventListener("blur",t),e.addEventListener("keydown",r,!0),()=>{e.removeEventListener("blur",t),e.removeEventListener("keydown",r,!0)}}),[u,n,f]),r.useEffect((()=>{if(f)return l.on("openchange",e),()=>{l.off("openchange",e)};function e(e){let{reason:t}=e;"reference-press"!==t&&"escape-key"!==t||(v.current=!0)}}),[l,f]),r.useEffect((()=>()=>{clearTimeout(b.current)}),[]),r.useMemo((()=>f?{reference:{onPointerDown(e){d(e.nativeEvent)||(A.current=!1)},onMouseLeave(){v.current=!1},onFocus(e){if(v.current)return;const t=y(e.nativeEvent);if(m&&(0,i.vq)(t))try{if(p()&&h())throw Error();if(!t.matches(":focus-visible"))return}catch(e){if(!A.current&&!_(t))return}o(!0,e.nativeEvent,"focus")},onBlur(e){v.current=!1;const t=e.relatedTarget,n=(0,i.vq)(t)&&t.hasAttribute(et("focus-guard"))&&"outside"===t.getAttribute("data-type");b.current=window.setTimeout((()=>{var r;const i=a(u?u.ownerDocument:document);(t||i!==u)&&(s(null==(r=c.current.floatingContext)?void 0:r.refs.floating.current,i)||s(u,i)||n||o(!1,e.nativeEvent,"focus"))}))}}}:{}),[f,m,c,u,o])}const en="active",tn="selected";function nn(e,t,n){const r=new Map,o="item"===n;let i=e;if(o&&e){const{[en]:t,[tn]:n,...r}=e;i=r}return{..."floating"===n&&{tabIndex:-1},...i,...t.map((t=>{const r=t?t[n]:null;return"function"==typeof r?e?r(e):null:r})).concat(e).reduce(((e,t)=>t?(Object.entries(t).forEach((t=>{let[n,i]=t;var a;o&&[en,tn].includes(n)||(0===n.indexOf("on")?(r.has(n)||r.set(n,[]),"function"==typeof i&&(null==(a=r.get(n))||a.push(i),e[n]=function(){for(var e,t=arguments.length,o=new Array(t),i=0;i<t;i++)o[i]=arguments[i];return null==(e=r.get(n))?void 0:e.map((e=>e(...o))).find((e=>void 0!==e))})):e[n]=i)})),e):e),{})}}function rn(e){void 0===e&&(e=[]);const t=e,n=r.useCallback((t=>nn(t,e,"reference")),t),o=r.useCallback((t=>nn(t,e,"floating")),t),i=r.useCallback((t=>nn(t,e,"item")),e.map((e=>null==e?void 0:e.item)));return r.useMemo((()=>({getReferenceProps:n,getFloatingProps:o,getItemProps:i})),[n,o,i])}let on=!1;function an(e,t,n){switch(e){case"vertical":return t;case"horizontal":return n;default:return t||n}}function sn(e,t){return an(t,e===pe||e===fe,e===he||e===me)}function ln(e,t,n){return an(t,e===fe,n?e===he:e===me)||"Enter"===e||" "===e||""===e}function cn(e,t,n){return an(t,n?e===me:e===he,e===pe)}function un(e,t){const{open:n,onOpenChange:o,elements:{domReference:l,floating:c}}=e,{listRef:f,activeIndex:m,onNavigate:v=(()=>{}),enabled:y=!0,selectedIndex:b=null,allowEscape:_=!1,loop:w=!1,nested:x=!1,rtl:k=!1,virtual:C=!1,focusItemOnOpen:S="auto",focusItemOnHover:M=!0,openOnArrowKeyDown:T=!0,disabledIndices:O,orientation:D="vertical",cols:L=1,scrollItemIntoView:P=!0,virtualItemRef:I,itemSizes:B,dense:R=!1}=t;const N=qe(),F=Ke(),j=de(v),Y=r.useRef(S),$=r.useRef(null!=b?b:-1),H=r.useRef(null),U=r.useRef(!0),z=r.useRef(j),W=r.useRef(!!c),V=r.useRef(!1),G=r.useRef(!1),Q=tt(O),q=tt(n),K=tt(P),Z=tt(c),J=tt(b),[X,ee]=r.useState(),[te,ne]=r.useState(),re=de((function(e,t,n){function r(e){C?(ee(e.id),null==F||F.events.emit("virtualfocus",e),I&&(I.current=e)):Se(e,{preventScroll:!0,sync:!(!h()||!p())&&(on||V.current)})}void 0===n&&(n=!1);const o=e.current[t.current];o&&r(o),requestAnimationFrame((()=>{const i=e.current[t.current]||o;if(!i)return;o||r(i);const a=K.current;a&&ie&&(n||!U.current)&&(null==i.scrollIntoView||i.scrollIntoView("boolean"==typeof a?{block:"nearest",inline:"nearest"}:a))}))}));Me((()=>{document.createElement("div").focus({get preventScroll(){return on=!0,!1}})}),[]),Me((()=>{y&&(n&&c?Y.current&&null!=b&&(G.current=!0,$.current=b,j(b)):W.current&&($.current=-1,z.current(null)))}),[y,n,c,b,j]),Me((()=>{if(y&&n&&c)if(null==m){if(V.current=!1,null!=J.current)return;if(W.current&&($.current=-1,re(f,$)),!W.current&&Y.current&&(null!=H.current||!0===Y.current&&null==H.current)){let e=0;const t=()=>{if(null==f.current[0]){if(e<2){(e?requestAnimationFrame:queueMicrotask)(t)}e++}else $.current=null==H.current||ln(H.current,D,k)||x?ye(f,Q.current):be(f,Q.current),H.current=null,j($.current)};t()}}else ve(f,m)||($.current=m,re(f,$,G.current),G.current=!1)}),[y,n,c,m,J,x,f,D,k,j,re,Q]),Me((()=>{var e;if(!y||c||!F||C||!W.current)return;const t=F.nodesRef.current,n=null==(e=t.find((e=>e.id===N)))||null==(e=e.context)?void 0:e.elements.floating,r=a(g(c)),o=t.some((e=>e.context&&s(e.context.elements.floating,r)));n&&!o&&U.current&&n.focus({preventScroll:!0})}),[y,c,F,N,C]),Me((()=>{if(y&&F&&C&&!N)return F.events.on("virtualfocus",e),()=>{F.events.off("virtualfocus",e)};function e(e){ne(e.id),I&&(I.current=e)}}),[y,F,C,N,I]),Me((()=>{z.current=j,W.current=!!c})),Me((()=>{n||(H.current=null)}),[n]);const oe=null!=m,ie=r.useMemo((()=>{function e(e){if(!n)return;const t=f.current.indexOf(e);-1!==t&&j(t)}return{onFocus(t){let{currentTarget:n}=t;e(n)},onClick:e=>{let{currentTarget:t}=e;return t.focus({preventScroll:!0})},...M&&{onMouseMove(t){let{currentTarget:n}=t;e(n)},onPointerLeave(e){let{pointerType:t}=e;U.current&&"touch"!==t&&($.current=-1,re(f,$),j(null),C||Se(Z.current,{preventScroll:!0}))}}}}),[n,Z,re,M,f,j,C]);return r.useMemo((()=>{if(!y)return{};const e=Q.current;function t(t){if(U.current=!1,V.current=!0,!q.current&&t.currentTarget===Z.current)return;if(x&&cn(t.key,D,k))return A(t),o(!1,t.nativeEvent,"list-navigation"),void((0,i.sb)(l)&&!C&&l.focus());const r=$.current,s=ye(f,e),c=be(f,e);if("Home"===t.key&&(A(t),$.current=s,j($.current)),"End"===t.key&&(A(t),$.current=c,j($.current)),L>1){const n=B||Array.from({length:f.current.length},(()=>({width:1,height:1}))),r=Ee(n,L,R),o=r.findIndex((t=>null!=t&&!ke(f.current,t,e))),i=r.reduce(((t,n,r)=>null==n||ke(f.current,n,e)?t:r),-1);if($.current=r[Ae({current:r.map((e=>null!=e?f.current[e]:null))},{event:t,orientation:D,loop:w,cols:L,disabledIndices:xe([...e||f.current.map(((e,t)=>ke(f.current,t)?t:void 0)),void 0],r),minIndex:o,maxIndex:i,prevIndex:we($.current>c?s:$.current,n,r,L,t.key===fe?"bl":t.key===me?"tr":"tl"),stopEvent:!0})],j($.current),"both"===D)return}if(sn(t.key,D)){if(A(t),n&&!C&&a(t.currentTarget.ownerDocument)===t.currentTarget)return $.current=ln(t.key,D,k)?s:c,void j($.current);ln(t.key,D,k)?$.current=w?r>=c?_&&r!==f.current.length?-1:s:_e(f,{startingIndex:r,disabledIndices:e}):Math.min(c,_e(f,{startingIndex:r,disabledIndices:e})):$.current=w?r<=s?_&&-1!==r?f.current.length:c:_e(f,{startingIndex:r,decrement:!0,disabledIndices:e}):Math.max(s,_e(f,{startingIndex:r,decrement:!0,disabledIndices:e})),ve(f,$.current)?j(null):j($.current)}}function r(e){"auto"===S&&u(e.nativeEvent)&&(Y.current=!0)}const s=C&&n&&oe&&{"aria-activedescendant":te||X},c=f.current.find((e=>(null==e?void 0:e.id)===X));return{reference:{...s,onKeyDown(r){U.current=!1;const i=0===r.key.indexOf("Arrow"),a=function(e,t,n){return an(t,n?e===he:e===me,e===fe)}(r.key,D,k),s=cn(r.key,D,k),l=sn(r.key,D),u=(x?a:l)||"Enter"===r.key||""===r.key.trim();if(C&&n){const e=null==F?void 0:F.nodesRef.current.find((e=>null==e.parentId)),n=F&&e?function(e,t){let n,r=-1;return function t(o,i){i>r&&(n=o,r=i),ut(e,o).forEach((e=>{t(e.id,i+1)}))}(t,0),e.find((e=>e.id===n))}(F.nodesRef.current,e.id):null;if(i&&n&&I){const e=new KeyboardEvent("keydown",{key:r.key,bubbles:!0});if(a||s){var d,p;const t=(null==(d=n.context)?void 0:d.elements.domReference)===r.currentTarget,o=s&&!t?null==(p=n.context)?void 0:p.elements.domReference:a?c:null;o&&(A(r),o.dispatchEvent(e),ne(void 0))}var h;if(l&&n.context)if(n.context.open&&n.parentId&&r.currentTarget!==n.context.elements.domReference)return A(r),void(null==(h=n.context.elements.domReference)||h.dispatchEvent(e))}return t(r)}(n||T||!i)&&(u&&(H.current=x&&l?null:r.key),x?a&&(A(r),n?($.current=ye(f,e),j($.current)):o(!0,r.nativeEvent,"list-navigation")):l&&(null!=b&&($.current=b),A(r),!n&&T?o(!0,r.nativeEvent,"list-navigation"):t(r),n&&j($.current)))},onFocus(){n&&!C&&j(null)},onPointerDown:function(e){Y.current=S,"auto"===S&&d(e.nativeEvent)&&(Y.current=!0)},onMouseDown:r,onClick:r},floating:{"aria-orientation":"both"===D?void 0:D,...!E(l)&&s,onKeyDown:t,onPointerMove(){U.current=!0}},item:ie}}),[l,Z,X,te,Q,q,f,y,D,k,C,n,oe,x,b,T,_,L,w,S,j,o,ie,F,I,B,R])}const dn=new Map([["select","listbox"],["combobox","listbox"],["label",!1]]);function pn(e,t){var n;void 0===t&&(t={});const{open:o,floatingId:i}=e,{enabled:a=!0,role:s="dialog"}=t,l=null!=(n=dn.get(s))?n:s,c=ze(),u=null!=qe();return r.useMemo((()=>{if(!a)return{};const e={id:i,...l&&{role:l}};return"tooltip"===l||"label"===s?{reference:{["aria-"+("label"===s?"labelledby":"describedby")]:o?i:void 0},floating:e}:{reference:{"aria-expanded":o?"true":"false","aria-haspopup":"alertdialog"===l?"dialog":l,"aria-controls":o?i:void 0,..."listbox"===l&&{role:"combobox"},..."menu"===l&&{id:c},..."menu"===l&&u&&{role:"menuitem"},..."select"===s&&{"aria-autocomplete":"none"},..."combobox"===s&&{"aria-autocomplete":"list"}},floating:{...e,..."menu"===l&&{"aria-labelledby":c}},item(e){let{active:t,selected:n}=e;const r={role:"option",...t&&{id:i+"-option"}};switch(s){case"select":return{...r,"aria-selected":t&&n};case"combobox":return{...r,...t&&{"aria-selected":!0}}}return{}}}}),[a,s,l,o,i,c,u])}const fn=e=>e.replace(/[A-Z]+(?![a-z])|[A-Z]/g,((e,t)=>(t?"-":"")+e.toLowerCase()));function hn(e,t){return"function"==typeof e?e(t):e}function mn(e,t){void 0===t&&(t={});const{open:n,elements:{floating:o}}=e,{duration:i=250}=t,a=("number"==typeof i?i:i.close)||0,[s,l]=r.useState("unmounted"),c=function(e,t){const[n,o]=r.useState(e);return e&&!n&&o(!0),r.useEffect((()=>{if(!e&&n){const e=setTimeout((()=>o(!1)),t);return()=>clearTimeout(e)}}),[e,n,t]),n}(n,a);return c||"close"!==s||l("unmounted"),Me((()=>{if(o){if(n){l("initial");const e=requestAnimationFrame((()=>{l("open")}));return()=>{cancelAnimationFrame(e)}}l("close")}}),[n,o]),{isMounted:c,status:s}}function gn(e,t){void 0===t&&(t={});const{initial:n={opacity:0},open:o,close:i,common:a,duration:s=250}=t,l=e.placement,c=l.split("-")[0],u=r.useMemo((()=>({side:c,placement:l})),[c,l]),d="number"==typeof s,p=(d?s:s.open)||0,f=(d?s:s.close)||0,[h,m]=r.useState((()=>({...hn(a,u),...hn(n,u)}))),{isMounted:g,status:v}=mn(e,{duration:s}),y=tt(n),b=tt(o),_=tt(i),A=tt(a);return Me((()=>{const e=hn(y.current,u),t=hn(_.current,u),n=hn(A.current,u),r=hn(b.current,u)||Object.keys(e).reduce(((e,t)=>(e[t]="",e)),{});if("initial"===v&&m((t=>({transitionProperty:t.transitionProperty,...n,...e}))),"open"===v&&m({transitionProperty:Object.keys(r).map(fn).join(","),transitionDuration:p+"ms",...n,...r}),"close"===v){const r=t||e;m({transitionProperty:Object.keys(r).map(fn).join(","),transitionDuration:f+"ms",...n,...r})}}),[f,_,y,b,A,p,v,u]),{isMounted:g,styles:h}}function vn(e,t){var n;const{open:o,dataRef:i}=e,{listRef:a,activeIndex:s,onMatch:l,onTypingChange:c,enabled:u=!0,findMatch:d=null,resetMs:p=750,ignoreKeys:f=[],selectedIndex:h=null}=t,m=r.useRef(),g=r.useRef(""),v=r.useRef(null!=(n=null!=h?h:s)?n:-1),y=r.useRef(null),b=de(l),_=de(c),E=tt(d),w=tt(f);return Me((()=>{o&&(clearTimeout(m.current),y.current=null,g.current="")}),[o]),Me((()=>{var e;o&&""===g.current&&(v.current=null!=(e=null!=h?h:s)?e:-1)}),[o,h,s]),r.useMemo((()=>{if(!u)return{};function e(e){e?i.current.typing||(i.current.typing=e,_(e)):i.current.typing&&(i.current.typing=e,_(e))}function t(e,t,n){const r=E.current?E.current(t,n):t.find((e=>0===(null==e?void 0:e.toLocaleLowerCase().indexOf(n.toLocaleLowerCase()))));return r?e.indexOf(r):-1}function n(n){const r=a.current;if(g.current.length>0&&" "!==g.current[0]&&(-1===t(r,r,g.current)?e(!1):" "===n.key&&A(n)),null==r||w.current.includes(n.key)||1!==n.key.length||n.ctrlKey||n.metaKey||n.altKey)return;o&&" "!==n.key&&(A(n),e(!0));r.every((e=>{var t,n;return!e||(null==(t=e[0])?void 0:t.toLocaleLowerCase())!==(null==(n=e[1])?void 0:n.toLocaleLowerCase())}))&&g.current===n.key&&(g.current="",v.current=y.current),g.current+=n.key,clearTimeout(m.current),m.current=setTimeout((()=>{g.current="",v.current=y.current,e(!1)}),p);const i=v.current,s=t(r,[...r.slice((i||0)+1),...r.slice(0,(i||0)+1)],g.current);-1!==s?(b(s),y.current=s):" "!==n.key&&(g.current="",e(!1))}return{reference:{onKeyDown:n},floating:{onKeyDown:n,onKeyUp(t){" "===t.key&&e(!1)}}}}),[u,o,i,a,p,w,E,b,_])}function yn(e,t){return{...e,rects:{...e.rects,floating:{...e.rects.floating,height:t}}}}const bn=e=>({name:"inner",options:e,async fn(t){const{listRef:n,overflowRef:r,onFallbackChange:o,offset:i=0,index:a=0,minItemsVisible:s=4,referenceOverflowThreshold:l=0,scrollRef:c,...u}=e,{rects:d,elements:{floating:p}}=t,f=n.current[a];if(!f)return{};const h={...t,...await L(-f.offsetTop-p.clientTop-d.reference.height/2-f.offsetHeight/2-i).fn(t)},m=(null==c?void 0:c.current)||p,g=await(0,x.__)(yn(h,m.scrollHeight),u),v=await(0,x.__)(h,{...u,elementContext:"reference"}),y=Math.max(0,g.top),b=h.y+y,_=Math.max(0,m.scrollHeight-y-Math.max(0,g.bottom));return m.style.maxHeight=_+"px",m.scrollTop=y,o&&(m.offsetHeight<f.offsetHeight*Math.min(s,n.current.length-1)-1||v.top>=-l||v.bottom>=-l?(0,k.flushSync)((()=>o(!0))):(0,k.flushSync)((()=>o(!1)))),r&&(r.current=await(0,x.__)(yn({...h,y:b},m.offsetHeight),u)),{y:b}}});function _n(e,t){const{open:n,elements:o}=e,{enabled:i=!0,overflowRef:a,scrollRef:s,onChange:l}=t,u=de(l),d=r.useRef(!1),p=r.useRef(null),f=r.useRef(null);return r.useEffect((()=>{if(!i)return;function e(e){if(e.ctrlKey||!t||null==a.current)return;const n=e.deltaY,r=a.current.top>=-.5,o=a.current.bottom>=-.5,i=t.scrollHeight-t.clientHeight,s=n<0?-1:1,l=n<0?"max":"min";t.scrollHeight<=t.clientHeight||(!r&&n>0||!o&&n<0?(e.preventDefault(),(0,k.flushSync)((()=>{u((e=>e+Math[l](n,i*s)))}))):/firefox/i.test(c())&&(t.scrollTop+=n))}const t=(null==s?void 0:s.current)||o.floating;return n&&t?(t.addEventListener("wheel",e),requestAnimationFrame((()=>{p.current=t.scrollTop,null!=a.current&&(f.current={...a.current})})),()=>{p.current=null,f.current=null,t.removeEventListener("wheel",e)}):void 0}),[i,n,o.floating,a,s,u]),r.useMemo((()=>i?{floating:{onKeyDown(){d.current=!0},onWheel(){d.current=!1},onPointerMove(){d.current=!1},onScroll(){const e=(null==s?void 0:s.current)||o.floating;if(a.current&&e&&d.current){if(null!==p.current){const t=e.scrollTop-p.current;(a.current.bottom<-.5&&t<-1||a.current.top<-.5&&t>1)&&(0,k.flushSync)((()=>u((e=>e+t))))}requestAnimationFrame((()=>{p.current=e.scrollTop}))}}}}:{}),[i,a,o.floating,s,u])}function An(e,t){const[n,r]=e;let o=!1;const i=t.length;for(let e=0,a=i-1;e<i;a=e++){const[i,s]=t[e]||[0,0],[l,c]=t[a]||[0,0];s>=r!=c>=r&&n<=(l-i)*(r-s)/(c-s)+i&&(o=!o)}return o}function En(e){void 0===e&&(e={});const{buffer:t=.5,blockPointerEvents:n=!1,requireIntent:r=!0}=e;let o,a=!1,l=null,c=null,u=performance.now();const d=e=>{let{x:n,y:d,placement:p,elements:f,onClose:h,nodeId:m,tree:g}=e;return function(e){function v(){clearTimeout(o),h()}if(clearTimeout(o),!f.domReference||!f.floating||null==p||null==n||null==d)return;const{clientX:b,clientY:_}=e,A=[b,_],E=y(e),w="mouseleave"===e.type,x=s(f.floating,E),k=s(f.domReference,E),C=f.domReference.getBoundingClientRect(),S=f.floating.getBoundingClientRect(),M=p.split("-")[0],T=n>S.right-S.width/2,O=d>S.bottom-S.height/2,D=function(e,t){return e[0]>=t.x&&e[0]<=t.x+t.width&&e[1]>=t.y&&e[1]<=t.y+t.height}(A,C),L=S.width>C.width,P=S.height>C.height,I=(L?C:S).left,B=(L?C:S).right,R=(P?C:S).top,N=(P?C:S).bottom;if(x&&(a=!0,!w))return;if(k&&(a=!1),k&&!w)return void(a=!0);if(w&&(0,i.vq)(e.relatedTarget)&&s(f.floating,e.relatedTarget))return;if(g&&ut(g.nodesRef.current,m).some((e=>{let{context:t}=e;return null==t?void 0:t.open})))return;if("top"===M&&d>=C.bottom-1||"bottom"===M&&d<=C.top+1||"left"===M&&n>=C.right-1||"right"===M&&n<=C.left+1)return v();let F=[];switch(M){case"top":F=[[I,C.top+1],[I,S.bottom-1],[B,S.bottom-1],[B,C.top+1]];break;case"bottom":F=[[I,S.top+1],[I,C.bottom-1],[B,C.bottom-1],[B,S.top+1]];break;case"left":F=[[S.right-1,N],[S.right-1,R],[C.left+1,R],[C.left+1,N]];break;case"right":F=[[C.right-1,N],[C.right-1,R],[S.left+1,R],[S.left+1,N]]}if(!An([b,_],F)){if(a&&!D)return v();if(!w&&r){const t=function(e,t){const n=performance.now(),r=n-u;if(null===l||null===c||0===r)return l=e,c=t,u=n,null;const o=e-l,i=t-c,a=Math.sqrt(o*o+i*i);return l=e,c=t,u=n,a/r}(e.clientX,e.clientY);if(null!==t&&t<.1)return v()}An([b,_],function(e){let[n,r]=e;switch(M){case"top":return[[L?n+t/2:T?n+4*t:n-4*t,r+t+1],[L?n-t/2:T?n+4*t:n-4*t,r+t+1],...[[S.left,T||L?S.bottom-t:S.top],[S.right,T?L?S.bottom-t:S.top:S.bottom-t]]];case"bottom":return[[L?n+t/2:T?n+4*t:n-4*t,r-t],[L?n-t/2:T?n+4*t:n-4*t,r-t],...[[S.left,T||L?S.top+t:S.bottom],[S.right,T?L?S.top+t:S.bottom:S.top+t]]];case"left":{const e=[n+t+1,P?r+t/2:O?r+4*t:r-4*t],o=[n+t+1,P?r-t/2:O?r+4*t:r-4*t];return[...[[O||P?S.right-t:S.left,S.top],[O?P?S.right-t:S.left:S.right-t,S.bottom]],e,o]}case"right":return[[n-t,P?r+t/2:O?r+4*t:r-4*t],[n-t,P?r-t/2:O?r+4*t:r-4*t],...[[O||P?S.left+t:S.right,S.top],[O?P?S.left+t:S.right:S.left+t,S.bottom]]]}}([n,d]))?!a&&r&&(o=window.setTimeout(v,40)):v()}}};return d.__options={blockPointerEvents:n},d}},42412:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.loadAssets=void 0;const r=n(83113);t.loadAssets=function({contents:e,scale:t},n){const o=e.filter((e=>"image"===e.type&&!!e.image.url)).map((e=>{const o=e.image,i=(0,r.sizeImage)(o.clippingMask.width,o.clippingMask.height,e.width*t,e.height*t),a=i.width*o.width/o.clippingMask.width,s=i.height*o.height/o.clippingMask.height;return n.hasImage(o.url,{width:a,height:s})?null:n.loadImage(o.url,{width:a,height:s})})).filter((e=>null!==e));return{loaded:0===o.length,loadPromise:Promise.all(o)}}},18035:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.drawContents=void 0;const r=n(83113);t.drawContents=function(e,{contents:t},n){t.forEach((t=>{if("image"===t.type)!function(e,t,n){const o=n.getImage(t.image.url);if(!(0,r.isValidImage)(o))return void(0,r.drawLoadingAnimation)(e,t);const i=o.width/t.image.width,a=t.image.rotation%2==1;if(e.save(),e.translate(t.x,t.y),t.image.rotation){const n=t.width/2,r=t.height/2;e.translate(n,r),e.rotate(-t.image.rotation*Math.PI/2),e.translate(a?-r:-n,a?-n:-r)}(0,r.drawImage)(e,o,t.image.clippingMask.x*i,t.image.clippingMask.y*i,t.image.clippingMask.width*i,t.image.clippingMask.height*i,0,0,a?t.height:t.width,a?t.width:t.height),e.restore()}(e,t,n)}))}},29572:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.drawDebug=void 0;const r=n(18083);t.drawDebug=function(e,t){const n=e.getContext("2d");return n?((0,r.drawContents)(n,t),{loaded:!0,loadPromise:Promise.resolve()}):{loaded:!1,loadPromise:Promise.resolve()}}},18083:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.drawContents=void 0;const r=n(83113);t.drawContents=function(e,{contents:t,scale:n}){const o=(0,r.adjustScale)(e);e.save(),e.lineWidth=2*o/n,e.strokeStyle="blue",t.forEach((t=>{e.strokeRect(t.x,t.y,t.width,t.height)})),e.lineWidth=1*o/n,e.strokeStyle="green",t.forEach((t=>{if("image"===t.type){const n=t.image.rotation%2==1,r=n?t.height/t.image.clippingMask.width:t.width/t.image.clippingMask.width,o=n?t.width/t.image.clippingMask.height:t.height/t.image.clippingMask.height;if(e.save(),e.translate(t.x,t.y),t.image.rotation){const r=t.width/2,o=t.height/2;e.translate(r,o),e.rotate(-t.image.rotation*Math.PI/2),e.translate(n?-o:-r,n?-r:-o)}e.strokeRect(-t.image.clippingMask.x*r,-t.image.clippingMask.y*o,t.image.width*r,t.image.height*o),e.restore()}})),e.restore()}},45051:function(e,t,n){"use strict";var r=this&&this.__createBinding||(Object.create?function(e,t,n,r){void 0===r&&(r=n);var o=Object.getOwnPropertyDescriptor(t,n);o&&!("get"in o?!t.__esModule:o.writable||o.configurable)||(o={enumerable:!0,get:function(){return t[n]}}),Object.defineProperty(e,r,o)}:function(e,t,n,r){void 0===r&&(r=n),e[r]=t[n]}),o=this&&this.__exportStar||function(e,t){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(t,n)||r(t,e,n)};Object.defineProperty(t,"__esModule",{value:!0}),o(n(29572),t)},39284:(e,t)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.drawImage=t.drawLoadingAnimation=t.isValidImage=t.adjustScale=t.sizeImage=void 0,t.sizeImage=function(e,t,n,r){const o=e/t,i=n/r,a=o>i?r*o:n,s=o>i?r:n/o;return{x:(n-a)/2,y:(r-s)/2,width:a,height:s}},t.adjustScale=function(e){return e.canvas.clientWidth?e.canvas.width/e.canvas.clientWidth:1},t.isValidImage=function(e){return!!e&&e.width>0&&e.height>0},t.drawLoadingAnimation=function(e,t){const n=Date.now(),r=t.width/3,o=1200,i=n%1700;if(e.fillStyle="#E5E5E5",e.fillRect(t.x,t.y,t.width,t.height),i<=o){const n=t.x-r+(t.width+r)*i/o,a=e.createLinearGradient(n,0,n+r,0);if(a.addColorStop(0,"#E5E5E5"),a.addColorStop(.5,"#D9D9D9"),a.addColorStop(1,"#E5E5E5"),e.fillStyle=a,n<t.x+t.width){const o=Math.max(t.x,n);let i=Math.min(r,t.width+t.x-n);n-t.x<0&&(i=r+(n-t.x)),e.fillRect(o,t.y,i,t.height)}}},t.drawImage=function(e,t,n,r,o,i,a,s,l,c){const u=Math.max(0,n),d=Math.max(0,r),p=Math.min(o,o+n,t.width-u),f=Math.min(i,i+r,t.height-d);if(p<=0||f<=0)return;const h=a+l-l*(Math.min(o,o+n)/o),m=s+c-c*(Math.min(i,i+r)/i),g=l*p/o,v=c*f/i;e.drawImage(t,u,d,p,f,h,m,g,v)}},83113:function(e,t,n){"use strict";var r=this&&this.__createBinding||(Object.create?function(e,t,n,r){void 0===r&&(r=n);var o=Object.getOwnPropertyDescriptor(t,n);o&&!("get"in o?!t.__esModule:o.writable||o.configurable)||(o={enumerable:!0,get:function(){return t[n]}}),Object.defineProperty(e,r,o)}:function(e,t,n,r){void 0===r&&(r=n),e[r]=t[n]}),o=this&&this.__exportStar||function(e,t){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(t,n)||r(t,e,n)};Object.defineProperty(t,"__esModule",{value:!0}),o(n(39284),t)},13019:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.createPresenter=void 0;const r=n(45051),o=n(42412),i=n(18035),a=n(55380),s=n(17547);t.createPresenter=function(e){return Object.freeze({assetCache:e,renderDebug:function(e,t){return(0,r.drawDebug)(e,t),!0},renderProof:async function(t,n){const r=t.getContext("2d");return r?(await(0,o.loadAssets)(n,e).loadPromise,(0,i.drawContents)(r,n,e),!0):(console.warn("Failed to retrieve context"),!1)},renderProofSync:function(t,n){const r=t.getContext("2d");if(!r)return{loaded:!1};const a=(0,o.loadAssets)(n,e).loaded;return(0,i.drawContents)(r,n,e),{loaded:a}},renderProduct:async function(t,n){const r=t.getContext("2d");return r?(await Promise.all([(0,o.loadAssets)(n,e).loadPromise,(0,a.loadAssets)(n,e).loadPromise]),(0,i.drawContents)(r,n,e),(0,s.drawProductMask)(r,n,e),!0):(console.warn("Failed to retrieve context"),!1)},renderProductSync:function(t,n){const r=t.getContext("2d");if(!r)return{loaded:!1};const l=(0,o.loadAssets)(n,e).loaded,c=(0,a.loadAssets)(n,e).loaded;return(0,i.drawContents)(r,n,e),(0,s.drawProductMask)(r,n,e),{loaded:l&&c}}})}},55380:(e,t)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.loadAssets=void 0,t.loadAssets=function({width:e,height:t,productMasks:n,scale:r},o){const i=e*r,a=t*r,s=["multiplyImageUrl","clipImageUrl","overImageUrl"].reduce(((e,t)=>{const r=n[t];return!r||o.hasImage(r,{width:i,height:a})?e:[...e,o.loadImage(r,{width:i,height:a})]}),[]);return{loaded:0===s.length,loadPromise:Promise.all(s)}}},17547:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.drawProductMask=void 0;const r=n(83113),o={multiplyImageUrl:"multiply",clipImageUrl:"destination-in",overImageUrl:"source-over"};t.drawProductMask=function(e,{product:t,productMasks:n,contents:i},a){["multiplyImageUrl","clipImageUrl","overImageUrl"].forEach((s=>{const l=n[s];if(!l)return;const c=a.getImage(l);if((0,r.isValidImage)(c)){e.save(),e.translate(t.x,t.y),e.globalCompositeOperation=o[s];const n=i[0].image;n.width/n.height>1?(e.translate(t.width/2,t.height/2),e.rotate(Math.PI/2),e.translate(-t.height/2,-t.width/2),e.drawImage(c,0,0,t.height,t.width)):e.drawImage(c,0,0,t.width,t.height),e.restore()}}))}},23598:function(e,t,n){"use strict";var r=this&&this.__createBinding||(Object.create?function(e,t,n,r){void 0===r&&(r=n);var o=Object.getOwnPropertyDescriptor(t,n);o&&!("get"in o?!t.__esModule:o.writable||o.configurable)||(o={enumerable:!0,get:function(){return t[n]}}),Object.defineProperty(e,r,o)}:function(e,t,n,r){void 0===r&&(r=n),e[r]=t[n]}),o=this&&this.__exportStar||function(e,t){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(t,n)||r(t,e,n)};Object.defineProperty(t,"__esModule",{value:!0}),o(n(13019),t)},83652:(e,t)=>{"use strict";const n={setOnLoadError:e=>{},setOnLoaderStart:e=>{}},r={"account-onboarding":{setFullTermsOfServiceUrl:e=>{},setRecipientTermsOfServiceUrl:e=>{},setPrivacyPolicyUrl:e=>{},setSkipTermsOfServiceCollection:e=>{},setCollectionOptions:e=>{},setOnExit:e=>{},setOnStepChange:e=>{}},"account-management":{setCollectionOptions:e=>{}},"notification-banner":{setCollectionOptions:e=>{},setOnNotificationsChange:e=>{}},payments:{setDefaultFilters:e=>{}},"payment-details":{setPayment:e=>{},setOnClose:e=>{}},"tax-settings":{setHideProductTaxCodeSelector:e=>{},setDisplayHeadOfficeCountries:e=>{},setOnTaxSettingsUpdated:e=>{}},"tax-registrations":{setOnAfterTaxRegistrationAdded:e=>{},setDisplayCountries:e=>{}}},o={"account-onboarding":"stripe-connect-account-onboarding",payments:"stripe-connect-payments","payment-details":"stripe-connect-payment-details",payouts:"stripe-connect-payouts","payouts-list":"stripe-connect-payouts-list",balances:"stripe-connect-balances","account-management":"stripe-connect-account-management","notification-banner":"stripe-connect-notification-banner",documents:"stripe-connect-documents","tax-registrations":"stripe-connect-tax-registrations","tax-settings":"stripe-connect-tax-settings"},i="loadConnect was called but an existing Connect.js script already exists in the document; existing script parameters will be used",a="https://connect-js.stripe.com/v1.0/connect.js";let s=null;const l=()=>(null!==s||(s=new Promise(((e,t)=>{if("undefined"!=typeof window)if(window.StripeConnect&&console.warn(i),window.StripeConnect){const t=u(window.StripeConnect);e(t)}else try{let n=document.querySelectorAll(`script[src="${a}"]`)[0]||document.querySelectorAll('script[src="https://connect-js.stripe.com/v0.1/connect.js"]')[0]||null;n?console.warn(i):n||(n=(()=>{const e=document.createElement("script");if(e.src=a,!document.head)throw new Error("Expected document.head not to be null. Connect.js requires a <head> element.");return document.head.appendChild(e),e})()),n.addEventListener("load",(()=>{if(window.StripeConnect){const t=u(window.StripeConnect);e(t)}else t(new Error("Connect.js did not load the necessary objects"))})),n.addEventListener("error",(()=>{t(new Error("Failed to load Connect.js"))}))}catch(e){t(e)}else t("ConnectJS won't load when rendering code in the server - it can only be loaded on a browser. This error is expected when loading ConnectJS in SSR environments, like NextJS. It will have no impact in the UI, however if you wish to avoid it, you can switch to the `pure` version of the connect.js loader: https://github.com/stripe/connect-js#importing-loadconnect-without-side-effects.")}))),s),c=(e,t)=>{var i;const a=(()=>{try{return t.fetchClientSecret()}catch(e){return Promise.reject(e)}})(),s=null!==(i=t.metaOptions)&&void 0!==i?i:{},l=e.then((e=>e.initialize(Object.assign(Object.assign({},t),{metaOptions:Object.assign(Object.assign({},s),{eagerClientSecretPromise:a})}))));return{create:e=>{let t=o[e];t||(t=e);const i=document.createElement(t),a=(e=>e in r)(e)?r[e]:{},s=Object.assign(Object.assign({},a),n);for(const e in s)i[e]=function(t){l.then((()=>{this[`${e}InternalOnly`](t)}))};return l.then((t=>{if(!i.isConnected&&!i.setConnector){const e=i.style.display;i.style.display="none",document.body.appendChild(i),document.body.removeChild(i),i.style.display=e}if(!i||!i.setConnector)throw new Error(`Element ${e} was not transformed into a custom element. Are you using a documented component? See https://docs.stripe.com/connect/supported-embedded-components for a list of supported components`);i.setConnector(t.connect)})),i},update:e=>{l.then((t=>{t.update(e)}))},debugInstance:()=>l,logout:()=>l.then((e=>e.logout()))}},u=e=>{window.StripeConnect=window.StripeConnect||{},window.StripeConnect.optimizedLoading=!0;return{initialize:t=>{var n;const r=null!==(n=t.metaOptions)&&void 0!==n?n:{};return e.init(Object.assign(Object.assign({},t),{metaOptions:Object.assign(Object.assign({},r),{sdk:!0,sdkOptions:{sdkVersion:"3.3.18"}})}))}}};t.loadConnectAndInitialize=e=>{const t=l();if(null==e)throw new Error("You must provide required parameters to initialize Connect");return c(t,e)}},45205:(e,t,n)=>{e.exports=n(83652)},47816:function(e,t,n){!function(e,t){"use strict";function n(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function r(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?n(Object(r),!0).forEach((function(t){i(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):n(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function o(e){return o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},o(e)}function i(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}function s(e,t){if(null==e)return{};var n,r,o=a(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}function l(e,t){return c(e)||u(e,t)||d(e,t)||f()}function c(e){if(Array.isArray(e))return e}function u(e,t){var n=e&&("undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"]);if(null!=n){var r,o,i=[],a=!0,s=!1;try{for(n=n.call(e);!(a=(r=n.next()).done)&&(i.push(r.value),!t||i.length!==t);a=!0);}catch(e){s=!0,o=e}finally{try{a||null==n.return||n.return()}finally{if(s)throw o}}return i}}function d(e,t){if(e){if("string"==typeof e)return p(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?p(e,t):void 0}}function p(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function f(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function h(e){return e&&e.__esModule&&Object.prototype.hasOwnProperty.call(e,"default")?e.default:e}var m,g,v,y,b={exports:{}};function _(){return g?m:(g=1,m="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED")}function A(){if(y)return v;y=1;var e=_();function t(){}function n(){}return n.resetWarningCache=t,v=function(){function r(t,n,r,o,i,a){if(a!==e){var s=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw s.name="Invariant Violation",s}}function o(){return r}r.isRequired=r;var i={array:r,bool:r,func:r,number:r,object:r,string:r,symbol:r,any:r,arrayOf:o,element:r,elementType:r,instanceOf:o,node:r,objectOf:o,oneOf:o,oneOfType:o,shape:o,exact:o,checkPropTypes:n,resetWarningCache:t};return i.PropTypes=i,i}}b.exports=A()();var E=h(b.exports),w=function(e,n,r){var o=!!r,i=t.useRef(r);t.useEffect((function(){i.current=r}),[r]),t.useEffect((function(){if(!o||!e)return function(){};var t=function(){i.current&&i.current.apply(i,arguments)};return e.on(n,t),function(){e.off(n,t)}}),[o,n,e,i])},x=function(e){var n=t.useRef(e);return t.useEffect((function(){n.current=e}),[e]),n.current},k=function(e){return null!==e&&"object"===o(e)},C=function(e){return k(e)&&"function"==typeof e.then},S=function(e){return k(e)&&"function"==typeof e.elements&&"function"==typeof e.createToken&&"function"==typeof e.createPaymentMethod&&"function"==typeof e.confirmCardPayment},M="[object Object]",T=function e(t,n){if(!k(t)||!k(n))return t===n;var r=Array.isArray(t);if(r!==Array.isArray(n))return!1;var o=Object.prototype.toString.call(t)===M;if(o!==(Object.prototype.toString.call(n)===M))return!1;if(!o&&!r)return t===n;var i=Object.keys(t),a=Object.keys(n);if(i.length!==a.length)return!1;for(var s={},l=0;l<i.length;l+=1)s[i[l]]=!0;for(var c=0;c<a.length;c+=1)s[a[c]]=!0;var u=Object.keys(s);if(u.length!==i.length)return!1;var d=t,p=n,f=function(t){return e(d[t],p[t])};return u.every(f)},O=function(e,t,n){return k(e)?Object.keys(e).reduce((function(o,a){var s=!k(t)||!T(e[a],t[a]);return n.includes(a)?(s&&console.warn("Unsupported prop change: options.".concat(a," is not a mutable property.")),o):s?r(r({},o||{}),{},i({},a,e[a])):o}),null):null},D="Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.",L=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:D;if(null===e||S(e))return e;throw new Error(t)},P=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:D;if(C(e))return{tag:"async",stripePromise:Promise.resolve(e).then((function(e){return L(e,t)}))};var n=L(e,t);return null===n?{tag:"empty"}:{tag:"sync",stripe:n}},I=function(e){e&&e._registerWrapper&&e.registerAppInfo&&(e._registerWrapper({name:"react-stripe-js",version:"2.7.0"}),e.registerAppInfo({name:"react-stripe-js",version:"2.7.0",url:"https://stripe.com/docs/stripe-js/react"}))},B=t.createContext(null);B.displayName="ElementsContext";var R=function(e,t){if(!e)throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(t," in an <Elements> provider."));return e},N=function(e){var n=e.stripe,r=e.options,o=e.children,i=t.useMemo((function(){return P(n)}),[n]),a=l(t.useState((function(){return{stripe:"sync"===i.tag?i.stripe:null,elements:"sync"===i.tag?i.stripe.elements(r):null}})),2),s=a[0],c=a[1];t.useEffect((function(){var e=!0,t=function(e){c((function(t){return t.stripe?t:{stripe:e,elements:e.elements(r)}}))};return"async"!==i.tag||s.stripe?"sync"!==i.tag||s.stripe||t(i.stripe):i.stripePromise.then((function(n){n&&e&&t(n)})),function(){e=!1}}),[i,s,r]);var u=x(n);t.useEffect((function(){null!==u&&u!==n&&console.warn("Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.")}),[u,n]);var d=x(r);return t.useEffect((function(){if(s.elements){var e=O(r,d,["clientSecret","fonts"]);e&&s.elements.update(e)}}),[r,d,s.elements]),t.useEffect((function(){I(s.stripe)}),[s.stripe]),t.createElement(B.Provider,{value:s},o)};N.propTypes={stripe:E.any,options:E.object};var F=function(e){var n=t.useContext(B);return R(n,e)},j=function(){return F("calls useElements()").elements},Y=function(e){return(0,e.children)(F("mounts <ElementsConsumer>"))};Y.propTypes={children:E.func.isRequired};var $=["on","session"],H=t.createContext(null);H.displayName="CustomCheckoutSdkContext";var U=function(e,t){if(!e)throw new Error("Could not find CustomCheckoutProvider context; You need to wrap the part of your app that ".concat(t," in an <CustomCheckoutProvider> provider."));return e},z=t.createContext(null);z.displayName="CustomCheckoutContext";var W=function(e,t){if(!e)return null;e.on,e.session;var n=s(e,$);return r(r({},n),t||e.session())},V="Invalid prop `stripe` supplied to `CustomCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.",G=function(e){var n=e.stripe,r=e.options,o=e.children,i=t.useMemo((function(){return P(n,V)}),[n]),a=l(t.useState(null),2),s=a[0],c=a[1],u=l(t.useState((function(){return{stripe:"sync"===i.tag?i.stripe:null,customCheckoutSdk:null}})),2),d=u[0],p=u[1],f=function(e,t){p((function(n){return n.stripe&&n.customCheckoutSdk?n:{stripe:e,customCheckoutSdk:t}}))},h=t.useRef(!1);t.useEffect((function(){var e=!0;return"async"!==i.tag||d.stripe?"sync"===i.tag&&i.stripe&&!h.current&&(h.current=!0,i.stripe.initCustomCheckout(r).then((function(e){e&&(f(i.stripe,e),e.on("change",c))}))):i.stripePromise.then((function(t){t&&e&&!h.current&&(h.current=!0,t.initCustomCheckout(r).then((function(e){e&&(f(t,e),e.on("change",c))})))})),function(){e=!1}}),[i,d,r,c]);var m=x(n);t.useEffect((function(){null!==m&&m!==n&&console.warn("Unsupported prop change on CustomCheckoutProvider: You cannot change the `stripe` prop after setting it.")}),[m,n]);var g=x(r);t.useEffect((function(){var e,t;if(d.customCheckoutSdk){!r.clientSecret||k(g)||T(r.clientSecret,g.clientSecret)||console.warn("Unsupported prop change: options.client_secret is not a mutable property.");var n=null==g||null===(e=g.elementsOptions)||void 0===e?void 0:e.appearance,o=null==r||null===(t=r.elementsOptions)||void 0===t?void 0:t.appearance;o&&!T(o,n)&&d.customCheckoutSdk.changeAppearance(o)}}),[r,g,d.customCheckoutSdk]),t.useEffect((function(){I(d.stripe)}),[d.stripe]);var v=t.useMemo((function(){return W(d.customCheckoutSdk,s)}),[d.customCheckoutSdk,s]);return d.customCheckoutSdk?t.createElement(H.Provider,{value:d},t.createElement(z.Provider,{value:v},o)):null};G.propTypes={stripe:E.any,options:E.shape({clientSecret:E.string.isRequired,elementsOptions:E.object}).isRequired};var Q=function(e){var n=t.useContext(H);return U(n,e)},q=function(e){var n=t.useContext(H),r=t.useContext(B);if(n&&r)throw new Error("You cannot wrap the part of your app that ".concat(e," in both <CustomCheckoutProvider> and <Elements> providers."));return n?U(n,e):R(r,e)},K=function(){Q("calls useCustomCheckout()");var e=t.useContext(z);if(!e)throw new Error("Could not find CustomCheckout Context; You need to wrap the part of your app that calls useCustomCheckout() in an <CustomCheckoutProvider> provider.");return e},Z=function(e){return e.charAt(0).toUpperCase()+e.slice(1)},J=function(e,n){var r="".concat(Z(e),"Element"),o=n?function(e){q("mounts <".concat(r,">"));var n=e.id,o=e.className;return t.createElement("div",{id:n,className:o})}:function(n){var o,i=n.id,a=n.className,s=n.options,c=void 0===s?{}:s,u=n.onBlur,d=n.onFocus,p=n.onReady,f=n.onChange,h=n.onEscape,m=n.onClick,g=n.onLoadError,v=n.onLoaderStart,y=n.onNetworksChange,b=n.onConfirm,_=n.onCancel,A=n.onShippingAddressChange,E=n.onShippingRateChange,k=q("mounts <".concat(r,">")),C="elements"in k?k.elements:null,S="customCheckoutSdk"in k?k.customCheckoutSdk:null,M=l(t.useState(null),2),T=M[0],D=M[1],L=t.useRef(null),P=t.useRef(null);w(T,"blur",u),w(T,"focus",d),w(T,"escape",h),w(T,"click",m),w(T,"loaderror",g),w(T,"loaderstart",v),w(T,"networkschange",y),w(T,"confirm",b),w(T,"cancel",_),w(T,"shippingaddresschange",A),w(T,"shippingratechange",E),w(T,"change",f),p&&(o="expressCheckout"===e?p:function(){p(T)}),w(T,"ready",o),t.useLayoutEffect((function(){if(null===L.current&&null!==P.current&&(C||S)){var t=null;S?t=S.createElement(e,c):C&&(t=C.create(e,c)),L.current=t,D(t),t&&t.mount(P.current)}}),[C,S,c]);var I=x(c);return t.useEffect((function(){if(L.current){var e=O(c,I,["paymentRequest"]);e&&L.current.update(e)}}),[c,I]),t.useLayoutEffect((function(){return function(){if(L.current&&"function"==typeof L.current.destroy)try{L.current.destroy(),L.current=null}catch(e){}}}),[]),t.createElement("div",{id:i,className:a,ref:P})};return o.propTypes={id:E.string,className:E.string,onChange:E.func,onBlur:E.func,onFocus:E.func,onReady:E.func,onEscape:E.func,onClick:E.func,onLoadError:E.func,onLoaderStart:E.func,onNetworksChange:E.func,onConfirm:E.func,onCancel:E.func,onShippingAddressChange:E.func,onShippingRateChange:E.func,options:E.object},o.displayName=r,o.__elementType=e,o},X="undefined"==typeof window,ee=t.createContext(null);ee.displayName="EmbeddedCheckoutProviderContext";var te=function(){var e=t.useContext(ee);if(!e)throw new Error("<EmbeddedCheckout> must be used within <EmbeddedCheckoutProvider>");return e},ne="Invalid prop `stripe` supplied to `EmbeddedCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.",re=function(e){var n=e.stripe,r=e.options,o=e.children,i=t.useMemo((function(){return P(n,ne)}),[n]),a=t.useRef(null),s=t.useRef(null),c=l(t.useState({embeddedCheckout:null}),2),u=c[0],d=c[1];t.useEffect((function(){if(!s.current&&!a.current){var e=function(e){s.current||a.current||(s.current=e,a.current=s.current.initEmbeddedCheckout(r).then((function(e){d({embeddedCheckout:e})})))};"async"!==i.tag||s.current||!r.clientSecret&&!r.fetchClientSecret?"sync"!==i.tag||s.current||!r.clientSecret&&!r.fetchClientSecret||e(i.stripe):i.stripePromise.then((function(t){t&&e(t)}))}}),[i,r,u,s]),t.useEffect((function(){return function(){u.embeddedCheckout?(a.current=null,u.embeddedCheckout.destroy()):a.current&&a.current.then((function(){a.current=null,u.embeddedCheckout&&u.embeddedCheckout.destroy()}))}}),[u.embeddedCheckout]),t.useEffect((function(){I(s)}),[s]);var p=x(n);t.useEffect((function(){null!==p&&p!==n&&console.warn("Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the `stripe` prop after setting it.")}),[p,n]);var f=x(r);return t.useEffect((function(){null!=f&&(null!=r?(void 0===r.clientSecret&&void 0===r.fetchClientSecret&&console.warn("Invalid props passed to EmbeddedCheckoutProvider: You must provide one of either `options.fetchClientSecret` or `options.clientSecret`."),null!=f.clientSecret&&r.clientSecret!==f.clientSecret&&console.warn("Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the client secret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead."),null!=f.fetchClientSecret&&r.fetchClientSecret!==f.fetchClientSecret&&console.warn("Unsupported prop change on EmbeddedCheckoutProvider: You cannot change fetchClientSecret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead."),null!=f.onComplete&&r.onComplete!==f.onComplete&&console.warn("Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onComplete option after setting it.")):console.warn("Unsupported prop change on EmbeddedCheckoutProvider: You cannot unset options after setting them."))}),[f,r]),t.createElement(ee.Provider,{value:u},o)},oe=function(e){var n=e.id,r=e.className,o=te().embeddedCheckout,i=t.useRef(!1),a=t.useRef(null);return t.useLayoutEffect((function(){return!i.current&&o&&null!==a.current&&(o.mount(a.current),i.current=!0),function(){if(i.current&&o)try{o.unmount(),i.current=!1}catch(e){}}}),[o]),t.createElement("div",{ref:a,id:n,className:r})},ie=function(e){var n=e.id,r=e.className;return te(),t.createElement("div",{id:n,className:r})},ae=X?ie:oe,se=function(){return q("calls useStripe()").stripe},le=J("auBankAccount",X),ce=J("card",X),ue=J("cardNumber",X),de=J("cardExpiry",X),pe=J("cardCvc",X),fe=J("fpxBank",X),he=J("iban",X),me=J("idealBank",X),ge=J("p24Bank",X),ve=J("epsBank",X),ye=J("payment",X),be=J("expressCheckout",X),_e=J("paymentRequestButton",X),Ae=J("linkAuthentication",X),Ee=J("address",X),we=J("shippingAddress",X),xe=J("paymentMethodMessaging",X),ke=J("affirmMessage",X),Ce=J("afterpayClearpayMessage",X);e.AddressElement=Ee,e.AffirmMessageElement=ke,e.AfterpayClearpayMessageElement=Ce,e.AuBankAccountElement=le,e.CardCvcElement=pe,e.CardElement=ce,e.CardExpiryElement=de,e.CardNumberElement=ue,e.CustomCheckoutProvider=G,e.Elements=N,e.ElementsConsumer=Y,e.EmbeddedCheckout=ae,e.EmbeddedCheckoutProvider=re,e.EpsBankElement=ve,e.ExpressCheckoutElement=be,e.FpxBankElement=fe,e.IbanElement=he,e.IdealBankElement=me,e.LinkAuthenticationElement=Ae,e.P24BankElement=ge,e.PaymentElement=ye,e.PaymentMethodMessagingElement=xe,e.PaymentRequestButtonElement=_e,e.ShippingAddressElement=we,e.useCustomCheckout=K,e.useElements=j,e.useStripe=se}(t,n(77810))},78128:e=>{var t;e.exports=function(){function e(t,n,r){function o(a,s){if(!n[a]){if(!t[a]){if(i)return i(a,!0);var l=new Error("Cannot find module '"+a+"'");throw l.code="MODULE_NOT_FOUND",l}var c=n[a]={exports:{}};t[a][0].call(c.exports,(function(e){return o(t[a][1][e]||e)}),c,c.exports,e,t,n,r)}return n[a].exports}for(var i=void 0,a=0;a<r.length;a++)o(r[a]);return o}return e}()({1:[function(e,t,n){"use strict";var r=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(n,"__esModule",{value:!0}),n.PromiseGlobal=void 0;var o=r(e("promise-polyfill")),i="undefined"!=typeof Promise?Promise:o.default;n.PromiseGlobal=i},{"promise-polyfill":68}],2:[function(e,t,n){"use strict";var r=e("./lib/promise"),o={};function i(e){var t,n=JSON.stringify(e);if(!e.forceScriptReload&&(t=o[n]))return t;var i=document.createElement("script"),a=e.dataAttributes||{},s=e.container||document.head;return i.src=e.src,i.id=e.id||"",i.async=!0,e.crossorigin&&i.setAttribute("crossorigin",""+e.crossorigin),Object.keys(a).forEach((function(e){i.setAttribute("data-"+e,""+a[e])})),t=new r.PromiseGlobal((function(t,n){i.addEventListener("load",(function(){t(i)})),i.addEventListener("error",(function(){n(new Error(e.src+" failed to load."))})),i.addEventListener("abort",(function(){n(new Error(e.src+" has aborted."))})),s.appendChild(i)})),o[n]=t,t}i.clearCache=function(){o={}},t.exports=i},{"./lib/promise":1}],3:[function(e,t,n){t.exports=e("./dist/load-script")},{"./dist/load-script":2}],4:[function(e,t,n){"use strict";t.exports=function(e){return e=e||window.navigator.userAgent,/Android/i.test(e)}},{}],5:[function(e,t,n){"use strict";t.exports=function(e){return e=e||window.navigator.userAgent,/CrOS/i.test(e)}},{}],6:[function(e,t,n){"use strict";var r=e("./is-edge"),o=e("./is-samsung"),i=e("./is-duckduckgo"),a=e("./is-opera"),s=e("./is-silk");t.exports=function(e){return!(-1===(e=e||window.navigator.userAgent).indexOf("Chrome")&&-1===e.indexOf("CriOS")||r(e)||o(e)||i(e)||a(e)||s(e))}},{"./is-duckduckgo":7,"./is-edge":8,"./is-opera":18,"./is-samsung":19,"./is-silk":20}],7:[function(e,t,n){"use strict";t.exports=function(e){return-1!==(e=e||window.navigator.userAgent).indexOf("DuckDuckGo/")}},{}],8:[function(e,t,n){"use strict";t.exports=function(e){return-1!==(e=e||window.navigator.userAgent).indexOf("Edge/")}},{}],9:[function(e,t,n){"use strict";t.exports=function(e){return e=e||window.navigator.userAgent,/Firefox/i.test(e)}},{}],10:[function(e,t,n){"use strict";t.exports=function(e){return-1!==(e=e||window.navigator.userAgent).indexOf("MSIE 9")}},{}],11:[function(e,t,n){"use strict";t.exports=function(e){return e=e||window.navigator.userAgent,/FxiOS/i.test(e)}},{}],12:[function(e,t,n){"use strict";var r=e("./is-ios");function o(e){return/\bGSA\b/.test(e)}t.exports=function(e){return e=e||window.navigator.userAgent,r(e)&&o(e)}},{"./is-ios":16}],13:[function(e,t,n){"use strict";var r=e("./is-ios"),o=e("./is-ios-firefox"),i=/webkit/i;function a(e){return i.test(e)}function s(e){return e.indexOf("CriOS")>-1}function l(e){return e.indexOf("FBAN")>-1}t.exports=function(e){return e=e||window.navigator.userAgent,r(e)&&a(e)&&!s(e)&&!o(e)&&!l(e)}},{"./is-ios":16,"./is-ios-firefox":11}],14:[function(e,t,n){"use strict";var r=e("./is-ios"),o=e("./is-ios-google-search-app");t.exports=function(e){return e=e||window.navigator.userAgent,!!r(e)&&(!!o(e)||/.+AppleWebKit(?!.*Safari)/i.test(e))}},{"./is-ios":16,"./is-ios-google-search-app":12}],15:[function(e,t,n){"use strict";var r=e("./is-ios-webview");t.exports=function(e,t){return t=void 0!==t?t:window.statusbar.visible,r(e)&&t}},{"./is-ios-webview":14}],16:[function(e,t,n){"use strict";var r=e("./is-ipados");t.exports=function(e,t,n){void 0===t&&(t=!0),e=e||window.navigator.userAgent;var o=/iPhone|iPod|iPad/i.test(e);return t?o||r(e,n):o}},{"./is-ipados":17}],17:[function(e,t,n){"use strict";t.exports=function(e,t){return e=e||window.navigator.userAgent,t=t||window.document,/Mac|iPad/i.test(e)&&"ontouchend"in t}},{}],18:[function(e,t,n){"use strict";t.exports=function(e){return-1!==(e=e||window.navigator.userAgent).indexOf("OPR/")||-1!==e.indexOf("Opera/")||-1!==e.indexOf("OPT/")}},{}],19:[function(e,t,n){"use strict";t.exports=function(e){return e=e||window.navigator.userAgent,/SamsungBrowser/i.test(e)}},{}],20:[function(e,t,n){"use strict";t.exports=function(e){return-1!==(e=e||window.navigator.userAgent).indexOf("Silk/")}},{}],21:[function(e,t,n){"use strict";var r=48,o=e("./is-android"),i=e("./is-ios-firefox"),a=e("./is-ios-webview"),s=e("./is-chrome"),l=e("./is-samsung"),c=e("./is-duckduckgo");function u(e){var t=(e=e||window.navigator.userAgent).match(/CriOS\/(\d+)\./);return!!t&&parseInt(t[1],10)<r}function d(e){return(e=e||window.navigator.userAgent).indexOf("Opera Mini")>-1}function p(e){var t=/Version\/[\d.]+/i;return e=e||window.navigator.userAgent,!!o(e)&&t.test(e)&&!d(e)&&!c(e)}function f(e){return!s(e)&&!l(e)&&/samsung/i.test(e)}t.exports=function(e){return e=e||window.navigator.userAgent,!(a(e)||i(e)||p(e)||d(e)||u(e)||f(e))}},{"./is-android":4,"./is-chrome":6,"./is-duckduckgo":7,"./is-ios-firefox":11,"./is-ios-webview":14,"./is-samsung":19}],22:[function(e,t,n){t.exports=e("./dist/is-android")},{"./dist/is-android":4}],23:[function(e,t,n){t.exports=e("./dist/is-chrome-os")},{"./dist/is-chrome-os":5}],24:[function(e,t,n){t.exports=e("./dist/is-chrome")},{"./dist/is-chrome":6}],25:[function(e,t,n){t.exports=e("./dist/is-firefox")},{"./dist/is-firefox":9}],26:[function(e,t,n){t.exports=e("./dist/is-ie9")},{"./dist/is-ie9":10}],27:[function(e,t,n){t.exports=e("./dist/is-ios-safari")},{"./dist/is-ios-safari":13}],28:[function(e,t,n){t.exports=e("./dist/is-ios-webview")},{"./dist/is-ios-webview":14}],29:[function(e,t,n){t.exports=e("./dist/is-ios-wkwebview")},{"./dist/is-ios-wkwebview":15}],30:[function(e,t,n){t.exports=e("./dist/is-ios")},{"./dist/is-ios":16}],31:[function(e,t,n){t.exports=e("./dist/is-samsung")},{"./dist/is-samsung":19}],32:[function(e,t,n){t.exports=e("./dist/supports-popups")},{"./dist/supports-popups":21}],33:[function(e,t,n){"use strict";var r=function(){function e(){this._events={}}return e.prototype.on=function(e,t){this._events[e]?this._events[e].push(t):this._events[e]=[t]},e.prototype.off=function(e,t){var n=this._events[e];if(n){var r=n.indexOf(t);n.splice(r,1)}},e.prototype._emit=function(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];var r=this._events[e];r&&r.forEach((function(e){e.apply(void 0,t)}))},e.prototype.hasListener=function(e){var t=this._events[e];return!!t&&t.length>0},e.createChild=function(t){t.prototype=Object.create(e.prototype,{constructor:t})},e}();t.exports=r},{}],34:[function(e,t,n){"use strict";var r="undefined"!=typeof Promise?Promise:null,o=function(){function e(t){var n=this;"function"!=typeof t?(this._promise=new e.Promise((function(e,t){n._resolveFunction=e,n._rejectFunction=t})),t=t||{},this._onResolve=t.onResolve||e.defaultOnResolve,this._onReject=t.onReject||e.defaultOnReject,e.shouldCatchExceptions(t)&&this._promise.catch((function(){})),this._resetState()):this._promise=new e.Promise(t)}return e.defaultOnResolve=function(t){return e.Promise.resolve(t)},e.defaultOnReject=function(t){return e.Promise.reject(t)},e.setPromise=function(t){e.Promise=t},e.shouldCatchExceptions=function(t){return t.hasOwnProperty("suppressUnhandledPromiseMessage")?Boolean(t.suppressUnhandledPromiseMessage):Boolean(e.suppressUnhandledPromiseMessage)},e.all=function(t){return e.Promise.all(t)},e.allSettled=function(t){return e.Promise.allSettled(t)},e.race=function(t){return e.Promise.race(t)},e.reject=function(t){return e.Promise.reject(t)},e.resolve=function(t){return e.Promise.resolve(t)},e.prototype.then=function(){for(var e,t=[],n=0;n<arguments.length;n++)t[n]=arguments[n];return(e=this._promise).then.apply(e,t)},e.prototype.catch=function(){for(var e,t=[],n=0;n<arguments.length;n++)t[n]=arguments[n];return(e=this._promise).catch.apply(e,t)},e.prototype.resolve=function(t){var n=this;return this.isFulfilled||(this._setResolved(),e.Promise.resolve().then((function(){return n._onResolve(t)})).then((function(e){n._resolveFunction(e)})).catch((function(e){n._resetState(),n.reject(e)}))),this},e.prototype.reject=function(t){var n=this;return this.isFulfilled||(this._setRejected(),e.Promise.resolve().then((function(){return n._onReject(t)})).then((function(e){n._setResolved(),n._resolveFunction(e)})).catch((function(e){return n._rejectFunction(e)}))),this},e.prototype._resetState=function(){this.isFulfilled=!1,this.isResolved=!1,this.isRejected=!1},e.prototype._setResolved=function(){this.isFulfilled=!0,this.isResolved=!0,this.isRejected=!1},e.prototype._setRejected=function(){this.isFulfilled=!0,this.isResolved=!1,this.isRejected=!0},e.Promise=r,e}();t.exports=o},{}],35:[function(e,t,n){"use strict";var r=e("./lib/set-attributes"),o=e("./lib/default-attributes"),i=e("./lib/assign");t.exports=function(e){void 0===e&&(e={});var t=document.createElement("iframe"),n=i.assign({},o.defaultAttributes,e);return n.style&&"string"!=typeof n.style&&(i.assign(t.style,n.style),delete n.style),r.setAttributes(t,n),t.getAttribute("id")||(t.id=t.name),t}},{"./lib/assign":36,"./lib/default-attributes":37,"./lib/set-attributes":38}],36:[function(e,t,n){"use strict";function r(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];return t.forEach((function(t){"object"==typeof t&&Object.keys(t).forEach((function(n){e[n]=t[n]}))})),e}Object.defineProperty(n,"__esModule",{value:!0}),n.assign=void 0,n.assign=r},{}],37:[function(e,t,n){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.defaultAttributes=void 0,n.defaultAttributes={src:"about:blank",frameBorder:0,allowtransparency:!0,scrolling:"no"}},{}],38:[function(e,t,n){"use strict";function r(e,t){for(var n in t)if(t.hasOwnProperty(n)){var r=t[n];null==r?e.removeAttribute(n):e.setAttribute(n,r)}}Object.defineProperty(n,"__esModule",{value:!0}),n.setAttributes=void 0,n.setAttributes=r},{}],39:[function(e,t,n){"use strict";function r(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,(function(e){var t=16*Math.random()|0;return("x"===e?t:3&t|8).toString(16)}))}t.exports=r},{}],40:[function(e,t,n){"use strict";function r(e){return function(){for(var t=[],n=0;n<arguments.length;n++)t[n]=arguments[n];setTimeout((function(){try{e.apply(void 0,t)}catch(e){console.log("Error in callback function"),console.log(e)}}),1)}}Object.defineProperty(n,"__esModule",{value:!0}),n.deferred=r},{}],41:[function(e,t,n){"use strict";function r(e){var t=!1;return function(){for(var n=[],r=0;r<arguments.length;r++)n[r]=arguments[r];t||(t=!0,e.apply(void 0,n))}}Object.defineProperty(n,"__esModule",{value:!0}),n.once=r},{}],42:[function(e,t,n){"use strict";function r(e,t){if(!t)return e;e.then((function(e){return t(null,e)})).catch((function(e){return t(e)}))}Object.defineProperty(n,"__esModule",{value:!0}),n.promiseOrCallback=r},{}],43:[function(e,t,n){"use strict";var r=e("./lib/deferred"),o=e("./lib/once"),i=e("./lib/promise-or-callback");function a(e){return function(){for(var t,n=[],a=0;a<arguments.length;a++)n[a]=arguments[a];return"function"==typeof n[n.length-1]&&(t=n.pop(),t=o.once(r.deferred(t))),i.promiseOrCallback(e.apply(this,n),t)}}a.wrapPrototype=function(e,t){void 0===t&&(t={});var n=t.ignoreMethods||[],r=!0===t.transformPrivateMethods;return Object.getOwnPropertyNames(e.prototype).filter((function(t){var o,i="constructor"!==t&&"function"==typeof e.prototype[t],a=-1===n.indexOf(t);return o=!!r||"_"!==t.charAt(0),i&&o&&a})).forEach((function(t){var n=e.prototype[t];e.prototype[t]=a(n)})),e},t.exports=a},{"./lib/deferred":40,"./lib/once":41,"./lib/promise-or-callback":42}],44:[function(e,t,n){"use strict";var r=this&&this.__assign||function(){return r=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e},r.apply(this,arguments)},o=e("./lib/card-types"),i=e("./lib/add-matching-cards-to-results"),a=e("./lib/is-valid-input-type"),s=e("./lib/find-best-match"),l=e("./lib/clone"),c={},u={VISA:"visa",MASTERCARD:"mastercard",AMERICAN_EXPRESS:"american-express",DINERS_CLUB:"diners-club",DISCOVER:"discover",JCB:"jcb",UNIONPAY:"unionpay",MAESTRO:"maestro",ELO:"elo",MIR:"mir",HIPER:"hiper",HIPERCARD:"hipercard"},d=[u.VISA,u.MASTERCARD,u.AMERICAN_EXPRESS,u.DINERS_CLUB,u.DISCOVER,u.JCB,u.UNIONPAY,u.MAESTRO,u.ELO,u.MIR,u.HIPER,u.HIPERCARD],p=l.clone(d);function f(e){return c[e]||o[e]}function h(){return p.map((function(e){return l.clone(f(e))}))}function m(e,t){void 0===t&&(t=!1);var n=p.indexOf(e);if(!t&&-1===n)throw new Error('"'+e+'" is not a supported card type.');return n}function g(e){var t=[];if(!a.isValidInputType(e))return t;if(0===e.length)return h();p.forEach((function(n){var r=f(n);i.addMatchingCardsToResults(e,r,t)}));var n=s.findBestMatch(t);return n?[n]:t}g.getTypeInfo=function(e){return l.clone(f(e))},g.removeCard=function(e){var t=m(e);p.splice(t,1)},g.addCard=function(e){var t=m(e.type,!0);c[e.type]=e,-1===t&&p.push(e.type)},g.updateCard=function(e,t){var n=c[e]||o[e];if(!n)throw new Error('"'+e+"\" is not a recognized type. Use `addCard` instead.'");if(t.type&&n.type!==t.type)throw new Error("Cannot overwrite type parameter.");var i=l.clone(n);i=r(r({},i),t),c[i.type]=i},g.changeOrder=function(e,t){var n=m(e);p.splice(n,1),p.splice(t,0,e)},g.resetModifications=function(){p=l.clone(d),c={}},g.types=u,t.exports=g},{"./lib/add-matching-cards-to-results":45,"./lib/card-types":46,"./lib/clone":47,"./lib/find-best-match":48,"./lib/is-valid-input-type":49}],45:[function(e,t,n){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.addMatchingCardsToResults=void 0;var r=e("./clone"),o=e("./matches");function i(e,t,n){var i,a;for(i=0;i<t.patterns.length;i++){var s=t.patterns[i];if(o.matches(e,s)){var l=r.clone(t);a=Array.isArray(s)?String(s[0]).length:String(s).length,e.length>=a&&(l.matchStrength=a),n.push(l);break}}}n.addMatchingCardsToResults=i},{"./clone":47,"./matches":50}],46:[function(e,t,n){"use strict";var r={visa:{niceType:"Visa",type:"visa",patterns:[4],gaps:[4,8,12],lengths:[16,18,19],code:{name:"CVV",size:3}},mastercard:{niceType:"Mastercard",type:"mastercard",patterns:[[51,55],[2221,2229],[223,229],[23,26],[270,271],2720],gaps:[4,8,12],lengths:[16],code:{name:"CVC",size:3}},"american-express":{niceType:"American Express",type:"american-express",patterns:[34,37],gaps:[4,10],lengths:[15],code:{name:"CID",size:4}},"diners-club":{niceType:"Diners Club",type:"diners-club",patterns:[[300,305],36,38,39],gaps:[4,10],lengths:[14,16,19],code:{name:"CVV",size:3}},discover:{niceType:"Discover",type:"discover",patterns:[6011,[644,649],65],gaps:[4,8,12],lengths:[16,19],code:{name:"CID",size:3}},jcb:{niceType:"JCB",type:"jcb",patterns:[2131,1800,[3528,3589]],gaps:[4,8,12],lengths:[16,17,18,19],code:{name:"CVV",size:3}},unionpay:{niceType:"UnionPay",type:"unionpay",patterns:[620,[624,626],[62100,62182],[62184,62187],[62185,62197],[62200,62205],[622010,622999],622018,[622019,622999],[62207,62209],[622126,622925],[623,626],6270,6272,6276,[627700,627779],[627781,627799],[6282,6289],6291,6292,810,[8110,8131],[8132,8151],[8152,8163],[8164,8171]],gaps:[4,8,12],lengths:[14,15,16,17,18,19],code:{name:"CVN",size:3}},maestro:{niceType:"Maestro",type:"maestro",patterns:[493698,[5e5,504174],[504176,506698],[506779,508999],[56,59],63,67,6],gaps:[4,8,12],lengths:[12,13,14,15,16,17,18,19],code:{name:"CVC",size:3}},elo:{niceType:"Elo",type:"elo",patterns:[401178,401179,438935,457631,457632,431274,451416,457393,504175,[506699,506778],[509e3,509999],627780,636297,636368,[650031,650033],[650035,650051],[650405,650439],[650485,650538],[650541,650598],[650700,650718],[650720,650727],[650901,650978],[651652,651679],[655e3,655019],[655021,655058]],gaps:[4,8,12],lengths:[16],code:{name:"CVE",size:3}},mir:{niceType:"Mir",type:"mir",patterns:[[2200,2204]],gaps:[4,8,12],lengths:[16,17,18,19],code:{name:"CVP2",size:3}},hiper:{niceType:"Hiper",type:"hiper",patterns:[637095,63737423,63743358,637568,637599,637609,637612],gaps:[4,8,12],lengths:[16],code:{name:"CVC",size:3}},hipercard:{niceType:"Hipercard",type:"hipercard",patterns:[606282],gaps:[4,8,12],lengths:[16],code:{name:"CVC",size:3}}};t.exports=r},{}],47:[function(e,t,n){"use strict";function r(e){return e?JSON.parse(JSON.stringify(e)):null}Object.defineProperty(n,"__esModule",{value:!0}),n.clone=void 0,n.clone=r},{}],48:[function(e,t,n){"use strict";function r(e){var t=e.filter((function(e){return e.matchStrength})).length;return t>0&&t===e.length}function o(e){return r(e)?e.reduce((function(e,t){return e?Number(e.matchStrength)<Number(t.matchStrength)?t:e:t})):null}Object.defineProperty(n,"__esModule",{value:!0}),n.findBestMatch=void 0,n.findBestMatch=o},{}],49:[function(e,t,n){"use strict";function r(e){return"string"==typeof e||e instanceof String}Object.defineProperty(n,"__esModule",{value:!0}),n.isValidInputType=void 0,n.isValidInputType=r},{}],50:[function(e,t,n){"use strict";function r(e,t,n){var r=String(t).length,o=e.substr(0,r),i=parseInt(o,10);return t=parseInt(String(t).substr(0,o.length),10),n=parseInt(String(n).substr(0,o.length),10),i>=t&&i<=n}function o(e,t){return(t=String(t)).substring(0,e.length)===e.substring(0,t.length)}function i(e,t){return Array.isArray(t)?r(e,t[0],t[1]):o(e,t)}Object.defineProperty(n,"__esModule",{value:!0}),n.matches=void 0,n.matches=i},{}],51:[function(e,t,n){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.Framebus=void 0;var r=e("./lib"),o="undefined"!=typeof window&&window.Promise,i=function(){function e(e){void 0===e&&(e={}),this.origin=e.origin||"*",this.channel=e.channel||"",this.verifyDomain=e.verifyDomain,this.targetFrames=e.targetFrames||[],this.limitBroadcastToFramesArray=Boolean(e.targetFrames),this.isDestroyed=!1,this.listeners=[],this.hasAdditionalChecksForOnListeners=Boolean(this.verifyDomain||this.limitBroadcastToFramesArray)}return e.setPromise=function(t){e.Promise=t},e.target=function(t){return new e(t)},e.prototype.addTargetFrame=function(e){this.limitBroadcastToFramesArray&&this.targetFrames.push(e)},e.prototype.include=function(e){return null!=e&&null!=e.Window&&e.constructor===e.Window&&(r.childWindows.push(e),!0)},e.prototype.target=function(t){return e.target(t)},e.prototype.emit=function(e,t,n){if(this.isDestroyed)return!1;var o=this.origin;if(e=this.namespaceEvent(e),(0,r.isntString)(e))return!1;if((0,r.isntString)(o))return!1;"function"==typeof t&&(n=t,t=void 0);var i=(0,r.packagePayload)(e,o,t,n);return!!i&&(this.limitBroadcastToFramesArray?this.targetFramesAsWindows().forEach((function(e){(0,r.sendMessage)(e,i,o)})):(0,r.broadcast)(i,{origin:o,frame:window.top||window.self}),!0)},e.prototype.emitAsPromise=function(t,n){var r=this;return new e.Promise((function(e,o){r.emit(t,n,(function(t){e(t)}))||o(new Error('Listener not added for "'.concat(t,'"')))}))},e.prototype.on=function(e,t){if(this.isDestroyed)return!1;var n=this,o=this.origin,i=t;return e=this.namespaceEvent(e),!(0,r.subscriptionArgsInvalid)(e,i,o)&&(this.hasAdditionalChecksForOnListeners&&(i=function(){for(var e=[],r=0;r<arguments.length;r++)e[r]=arguments[r];n.passesVerifyDomainCheck(this&&this.origin)&&n.hasMatchingTargetFrame(this&&this.source)&&t.apply(void 0,e)}),this.listeners.push({eventName:e,handler:i,originalHandler:t}),r.subscribers[o]=r.subscribers[o]||{},r.subscribers[o][e]=r.subscribers[o][e]||[],r.subscribers[o][e].push(i),!0)},e.prototype.off=function(e,t){var n=t;if(this.isDestroyed)return!1;if(this.verifyDomain)for(var o=0;o<this.listeners.length;o++){var i=this.listeners[o];i.originalHandler===t&&(n=i.handler)}e=this.namespaceEvent(e);var a=this.origin;if((0,r.subscriptionArgsInvalid)(e,n,a))return!1;var s=r.subscribers[a]&&r.subscribers[a][e];if(!s)return!1;for(o=0;o<s.length;o++)if(s[o]===n)return s.splice(o,1),!0;return!1},e.prototype.teardown=function(){if(!this.isDestroyed){this.isDestroyed=!0;for(var e=0;e<this.listeners.length;e++){var t=this.listeners[e];this.off(t.eventName,t.handler)}this.listeners.length=0}},e.prototype.passesVerifyDomainCheck=function(e){return!this.verifyDomain||this.checkOrigin(e)},e.prototype.targetFramesAsWindows=function(){return this.limitBroadcastToFramesArray?this.targetFrames.map((function(e){return e instanceof HTMLIFrameElement?e.contentWindow:e})).filter((function(e){return e})):[]},e.prototype.hasMatchingTargetFrame=function(e){if(!this.limitBroadcastToFramesArray)return!0;var t=this.targetFramesAsWindows().find((function(t){return t===e}));return Boolean(t)},e.prototype.checkOrigin=function(e){var t,n=document.createElement("a");return n.href=location.href,t="https:"===n.protocol?n.host.replace(/:443$/,""):"http:"===n.protocol?n.host.replace(/:80$/,""):n.host,n.protocol+"//"+t===e||!this.verifyDomain||this.verifyDomain(e)},e.prototype.namespaceEvent=function(e){return this.channel?"".concat(this.channel,":").concat(e):e},e.Promise=o,e}();n.Framebus=i},{"./lib":59}],52:[function(e,t,n){"use strict";var r=e("./lib"),o=e("./framebus");(0,r.attach)(),t.exports=o.Framebus},{"./framebus":51,"./lib":59}],53:[function(e,t,n){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.detach=n.attach=void 0;var r=e("./"),o=!1;function i(){o||"undefined"==typeof window||(o=!0,window.addEventListener("message",r.onMessage,!1))}function a(){o=!1,window.removeEventListener("message",r.onMessage,!1)}n.attach=i,n.detach=a},{"./":59}],54:[function(e,t,n){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.broadcastToChildWindows=void 0;var r=e("./");function o(e,t,n){for(var o=r.childWindows.length-1;o>=0;o--){var i=r.childWindows[o];i.closed?r.childWindows.splice(o,1):n!==i&&(0,r.broadcast)(e,{origin:t,frame:i.top})}}n.broadcastToChildWindows=o},{"./":59}],55:[function(e,t,n){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.broadcast=void 0;var r=e("./");function o(e,t){var n,i=0,a=t.origin,s=t.frame;try{for(s.postMessage(e,a),(0,r.hasOpener)(s)&&s.opener.top!==window.top&&o(e,{origin:a,frame:s.opener.top});n=s.frames[i];)o(e,{origin:a,frame:n}),i++}catch(e){}}n.broadcast=o},{"./":59}],56:[function(e,t,n){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.subscribers=n.childWindows=n.prefix=void 0,n.prefix="/*framebus*/",n.childWindows=[],n.subscribers={}},{}],57:[function(e,t,n){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.dispatch=void 0;var r=e("./");function o(e,t,n,o,i){if(r.subscribers[e]&&r.subscribers[e][t]){var a=[];n&&a.push(n),o&&a.push(o);for(var s=0;s<r.subscribers[e][t].length;s++)r.subscribers[e][t][s].apply(i,a)}}n.dispatch=o},{"./":59}],58:[function(e,t,n){"use strict";function r(e){return e.top===e&&null!=e.opener&&e.opener!==e&&!0!==e.opener.closed}Object.defineProperty(n,"__esModule",{value:!0}),n.hasOpener=void 0,n.hasOpener=r},{}],59:[function(e,t,n){"use strict";var r=this&&this.__createBinding||(Object.create?function(e,t,n,r){void 0===r&&(r=n);var o=Object.getOwnPropertyDescriptor(t,n);o&&!("get"in o?!t.__esModule:o.writable||o.configurable)||(o={enumerable:!0,get:function(){return t[n]}}),Object.defineProperty(e,r,o)}:function(e,t,n,r){void 0===r&&(r=n),e[r]=t[n]}),o=this&&this.__exportStar||function(e,t){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(t,n)||r(t,e,n)};Object.defineProperty(n,"__esModule",{value:!0}),o(e("./attach"),n),o(e("./broadcast-to-child-windows"),n),o(e("./broadcast"),n),o(e("./constants"),n),o(e("./dispatch"),n),o(e("./has-opener"),n),o(e("./is-not-string"),n),o(e("./message"),n),o(e("./package-payload"),n),o(e("./send-message"),n),o(e("./subscribe-replier"),n),o(e("./subscription-args-invalid"),n),o(e("./types"),n),o(e("./unpack-payload"),n)},{"./attach":53,"./broadcast":55,"./broadcast-to-child-windows":54,"./constants":56,"./dispatch":57,"./has-opener":58,"./is-not-string":60,"./message":61,"./package-payload":62,"./send-message":63,"./subscribe-replier":64,"./subscription-args-invalid":65,"./types":66,"./unpack-payload":67}],60:[function(e,t,n){"use strict";function r(e){return"string"!=typeof e}Object.defineProperty(n,"__esModule",{value:!0}),n.isntString=void 0,n.isntString=r},{}],61:[function(e,t,n){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.onMessage=void 0;var r=e("./");function o(e){if(!(0,r.isntString)(e.data)){var t=(0,r.unpackPayload)(e);if(t){var n=t.eventData,o=t.reply;(0,r.dispatch)("*",t.event,n,o,e),(0,r.dispatch)(e.origin,t.event,n,o,e),(0,r.broadcastToChildWindows)(e.data,t.origin,e.source)}}}n.onMessage=o},{"./":59}],62:[function(e,t,n){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.packagePayload=void 0;var r=e("./");function o(e,t,n,o){var i,a={event:e,origin:t};"function"==typeof o&&(a.reply=(0,r.subscribeReplier)(o,t)),a.eventData=n;try{i=r.prefix+JSON.stringify(a)}catch(e){throw new Error("Could not stringify event: ".concat(e.message))}return i}n.packagePayload=o},{"./":59}],63:[function(e,t,n){"use strict";function r(e,t,n){try{e.postMessage(t,n)}catch(e){}}Object.defineProperty(n,"__esModule",{value:!0}),n.sendMessage=void 0,n.sendMessage=r},{}],64:[function(e,t,n){"use strict";var r=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(n,"__esModule",{value:!0}),n.subscribeReplier=void 0;var o=e("../framebus"),i=r(e("@braintree/uuid"));function a(e,t){var n=(0,i.default)();function r(i,a){e(i,a),o.Framebus.target({origin:t}).off(n,r)}return o.Framebus.target({origin:t}).on(n,r),n}n.subscribeReplier=a},{"../framebus":51,"@braintree/uuid":39}],65:[function(e,t,n){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.subscriptionArgsInvalid=void 0;var r=e("./");function o(e,t,n){return!!(0,r.isntString)(e)||"function"!=typeof t||(0,r.isntString)(n)}n.subscriptionArgsInvalid=o},{"./":59}],66:[function(e,t,n){"use strict";Object.defineProperty(n,"__esModule",{value:!0})},{}],67:[function(e,t,n){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.unpackPayload=void 0;var r=e("./");function o(e){var t;if(e.data.slice(0,r.prefix.length)!==r.prefix)return!1;try{t=JSON.parse(e.data.slice(r.prefix.length))}catch(e){return!1}if(t.reply){var n=e.origin,o=e.source,i=t.reply;t.reply=function(e){if(o){var t=(0,r.packagePayload)(i,n,e);t&&o.postMessage(t,n)}}}return t}n.unpackPayload=o},{"./":59}],68:[function(e,t,n){"use strict";function r(e){var t=this.constructor;return this.then((function(n){return t.resolve(e()).then((function(){return n}))}),(function(n){return t.resolve(e()).then((function(){return t.reject(n)}))}))}function o(e){return new this((function(t,n){if(!e||void 0===e.length)return n(new TypeError(typeof e+" "+e+" is not iterable(cannot read property Symbol(Symbol.iterator))"));var r=Array.prototype.slice.call(e);if(0===r.length)return t([]);var o=r.length;function i(e,n){if(n&&("object"==typeof n||"function"==typeof n)){var a=n.then;if("function"==typeof a)return void a.call(n,(function(t){i(e,t)}),(function(n){r[e]={status:"rejected",reason:n},0==--o&&t(r)}))}r[e]={status:"fulfilled",value:n},0==--o&&t(r)}for(var a=0;a<r.length;a++)i(a,r[a])}))}var i=setTimeout;function a(e){return Boolean(e&&void 0!==e.length)}function s(){}function l(e,t){return function(){e.apply(t,arguments)}}function c(e){if(!(this instanceof c))throw new TypeError("Promises must be constructed via new");if("function"!=typeof e)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],m(e,this)}function u(e,t){for(;3===e._state;)e=e._value;0!==e._state?(e._handled=!0,c._immediateFn((function(){var n=1===e._state?t.onFulfilled:t.onRejected;if(null!==n){var r;try{r=n(e._value)}catch(e){return void p(t.promise,e)}d(t.promise,r)}else(1===e._state?d:p)(t.promise,e._value)}))):e._deferreds.push(t)}function d(e,t){try{if(t===e)throw new TypeError("A promise cannot be resolved with itself.");if(t&&("object"==typeof t||"function"==typeof t)){var n=t.then;if(t instanceof c)return e._state=3,e._value=t,void f(e);if("function"==typeof n)return void m(l(n,t),e)}e._state=1,e._value=t,f(e)}catch(t){p(e,t)}}function p(e,t){e._state=2,e._value=t,f(e)}function f(e){2===e._state&&0===e._deferreds.length&&c._immediateFn((function(){e._handled||c._unhandledRejectionFn(e._value)}));for(var t=0,n=e._deferreds.length;t<n;t++)u(e,e._deferreds[t]);e._deferreds=null}function h(e,t,n){this.onFulfilled="function"==typeof e?e:null,this.onRejected="function"==typeof t?t:null,this.promise=n}function m(e,t){var n=!1;try{e((function(e){n||(n=!0,d(t,e))}),(function(e){n||(n=!0,p(t,e))}))}catch(e){if(n)return;n=!0,p(t,e)}}c.prototype.catch=function(e){return this.then(null,e)},c.prototype.then=function(e,t){var n=new this.constructor(s);return u(this,new h(e,t,n)),n},c.prototype.finally=r,c.all=function(e){return new c((function(t,n){if(!a(e))return n(new TypeError("Promise.all accepts an array"));var r=Array.prototype.slice.call(e);if(0===r.length)return t([]);var o=r.length;function i(e,a){try{if(a&&("object"==typeof a||"function"==typeof a)){var s=a.then;if("function"==typeof s)return void s.call(a,(function(t){i(e,t)}),n)}r[e]=a,0==--o&&t(r)}catch(e){n(e)}}for(var s=0;s<r.length;s++)i(s,r[s])}))},c.allSettled=o,c.resolve=function(e){return e&&"object"==typeof e&&e.constructor===c?e:new c((function(t){t(e)}))},c.reject=function(e){return new c((function(t,n){n(e)}))},c.race=function(e){return new c((function(t,n){if(!a(e))return n(new TypeError("Promise.race accepts an array"));for(var r=0,o=e.length;r<o;r++)c.resolve(e[r]).then(t,n)}))},c._immediateFn="function"==typeof setImmediate&&function(e){setImmediate(e)}||function(e){i(e,0)},c._unhandledRejectionFn=function(e){"undefined"!=typeof console&&console&&console.warn("Possible Unhandled Promise Rejection:",e)},t.exports=c},{}],69:[function(e,t,n){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.isIos=n.isIE9=n.isSamsungBrowser=n.isAndroidChrome=n.isKitKatWebview=void 0;var r="undefined"!=typeof window&&window.navigator&&window.navigator.userAgent,o=e("@braintree/browser-detection/is-android"),i=e("@braintree/browser-detection/is-chrome-os"),a=e("@braintree/browser-detection/is-chrome"),s=e("@braintree/browser-detection/is-ios");n.isIos=s;var l=e("@braintree/browser-detection/is-ie9");n.isIE9=l;var c=/Version\/\d\.\d* Chrome\/\d*\.0\.0\.0/;function u(e){return!a(e)&&e.indexOf("Samsung")>-1}function d(e){return void 0===e&&(e=r),o(e)&&c.test(e)}function p(e){return void 0===e&&(e=r),(o(e)||i(e))&&a(e)}function f(e){return void 0===e&&(e=r),/SamsungBrowser/.test(e)||u(e)}n.isKitKatWebview=d,n.isAndroidChrome=p,n.isSamsungBrowser=f},{"@braintree/browser-detection/is-android":22,"@braintree/browser-detection/is-chrome":24,"@braintree/browser-detection/is-chrome-os":23,"@braintree/browser-detection/is-ie9":26,"@braintree/browser-detection/is-ios":30}],70:[function(e,t,n){"use strict";var r=e("./lib/device");t.exports=function(){return!(0,r.isSamsungBrowser)()}},{"./lib/device":69}],71:[function(e,t,n){t.exports=e("./dist/supports-input-formatting")},{"./dist/supports-input-formatting":70}],72:[function(e,t,n){"use strict";var r=e("../lib/braintree-error"),o=e("./errors"),i=e("../lib/assign").assign,a=e("../lib/methods"),s=e("../lib/convert-methods-to-error"),l=e("@braintree/wrap-promise");function c(e){this._client=e.client}c.prototype.getRewardsBalance=function(e){var t,n=e.nonce;return n?(delete(t=i({_meta:{source:"american-express"},paymentMethodNonce:n},e)).nonce,this._client.request({method:"get",endpoint:"payment_methods/amex_rewards_balance",data:t}).catch((function(e){return Promise.reject(new r({type:o.AMEX_NETWORK_ERROR.type,code:o.AMEX_NETWORK_ERROR.code,message:"A network error occurred when getting the American Express rewards balance.",details:{originalError:e}}))}))):Promise.reject(new r({type:o.AMEX_NONCE_REQUIRED.type,code:o.AMEX_NONCE_REQUIRED.code,message:"getRewardsBalance must be called with a nonce."}))},c.prototype.getExpressCheckoutProfile=function(e){return e.nonce?this._client.request({method:"get",endpoint:"payment_methods/amex_express_checkout_cards/"+e.nonce,data:{_meta:{source:"american-express"},paymentMethodNonce:e.nonce}}).catch((function(e){return Promise.reject(new r({type:o.AMEX_NETWORK_ERROR.type,code:o.AMEX_NETWORK_ERROR.code,message:"A network error occurred when getting the American Express Checkout nonce profile.",details:{originalError:e}}))})):Promise.reject(new r({type:o.AMEX_NONCE_REQUIRED.type,code:o.AMEX_NONCE_REQUIRED.code,message:"getExpressCheckoutProfile must be called with a nonce."}))},c.prototype.teardown=function(){return s(this,a(c.prototype)),Promise.resolve()},t.exports=l.wrapPrototype(c)},{"../lib/assign":121,"../lib/braintree-error":124,"../lib/convert-methods-to-error":127,"../lib/methods":155,"./errors":73,"@braintree/wrap-promise":43}],73:[function(e,t,n){"use strict";var r=e("../lib/braintree-error");t.exports={AMEX_NONCE_REQUIRED:{type:r.types.MERCHANT,code:"AMEX_NONCE_REQUIRED"},AMEX_NETWORK_ERROR:{type:r.types.NETWORK,code:"AMEX_NETWORK_ERROR"}}},{"../lib/braintree-error":124}],74:[function(e,t,n){"use strict";var r=e("./american-express"),o=e("../lib/basic-component-verification"),i=e("../lib/create-deferred-client"),a=e("../lib/create-assets-url"),s="3.102.0",l=e("@braintree/wrap-promise");function c(e){var t="American Express";return o.verify({name:t,client:e.client,authorization:e.authorization}).then((function(){return i.create({authorization:e.authorization,client:e.client,debug:e.debug,assetsUrl:a.create(e.authorization),name:t})})).then((function(t){return e.client=t,new r(e)}))}t.exports={create:l(c),VERSION:s}},{"../lib/basic-component-verification":122,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./american-express":72,"@braintree/wrap-promise":43}],75:[function(e,t,n){"use strict";var r=e("../lib/braintree-error"),o=e("../lib/analytics"),i=e("./errors"),a=e("../lib/methods"),s=e("../lib/convert-methods-to-error"),l=e("@braintree/wrap-promise");function c(e){this._instantiatedWithClient=Boolean(!e.useDeferredClient),this._client=e.client,this._createPromise=e.createPromise,this._client&&this._setMerchantIdentifier()}c.prototype._waitForClient=function(){return this._client?Promise.resolve():this._createPromise.then(function(e){this._client=e,this._setMerchantIdentifier()}.bind(this))},c.prototype._setMerchantIdentifier=function(){var e=this._client.getConfiguration().gatewayConfiguration.applePayWeb;e&&Object.defineProperty(this,"merchantIdentifier",{value:e.merchantIdentifier,configurable:!1,writable:!1})},c.prototype.createPaymentRequest=function(e){return this._instantiatedWithClient?this._createPaymentRequestSynchronously(e):this._waitForClient().then(function(){return this._createPaymentRequestSynchronously(e)}.bind(this))},c.prototype._createPaymentRequestSynchronously=function(e){var t=this._client.getConfiguration().gatewayConfiguration.applePayWeb,n={countryCode:t.countryCode,currencyCode:t.currencyCode,merchantCapabilities:t.merchantCapabilities||["supports3DS"],supportedNetworks:t.supportedNetworks.map((function(e){return"mastercard"===e?"masterCard":e}))};return Object.assign({},n,e)},c.prototype.performValidation=function(e){var t=this;return e&&e.validationURL?this._waitForClient().then((function(){var n={validationUrl:e.validationURL,domainName:e.domainName||window.location.hostname,merchantIdentifier:e.merchantIdentifier||t.merchantIdentifier};return null!=e.displayName&&(n.displayName=e.displayName),t._client.request({method:"post",endpoint:"apple_pay_web/sessions",data:{_meta:{source:"apple-pay"},applePayWebSession:n}})})).then((function(e){return o.sendEvent(t._client,"applepay.performValidation.succeeded"),Promise.resolve(e)})).catch((function(e){return o.sendEvent(t._client,"applepay.performValidation.failed"),"CLIENT_REQUEST_ERROR"===e.code?Promise.reject(new r({type:i.APPLE_PAY_MERCHANT_VALIDATION_FAILED.type,code:i.APPLE_PAY_MERCHANT_VALIDATION_FAILED.code,message:i.APPLE_PAY_MERCHANT_VALIDATION_FAILED.message,details:{originalError:e.details.originalError}})):Promise.reject(new r({type:i.APPLE_PAY_MERCHANT_VALIDATION_NETWORK.type,code:i.APPLE_PAY_MERCHANT_VALIDATION_NETWORK.code,message:i.APPLE_PAY_MERCHANT_VALIDATION_NETWORK.message,details:{originalError:e}}))})):Promise.reject(new r(i.APPLE_PAY_VALIDATION_URL_REQUIRED))},c.prototype.tokenize=function(e){var t=this;return e.token?this._waitForClient().then((function(){return t._client.request({method:"post",endpoint:"payment_methods/apple_payment_tokens",data:{_meta:{source:"apple-pay"},applePaymentToken:Object.assign({},e.token,{paymentData:btoa(JSON.stringify(e.token.paymentData))})}})})).then((function(e){return o.sendEvent(t._client,"applepay.tokenize.succeeded"),Promise.resolve(e.applePayCards[0])})).catch((function(e){return o.sendEvent(t._client,"applepay.tokenize.failed"),Promise.reject(new r({type:i.APPLE_PAY_TOKENIZATION.type,code:i.APPLE_PAY_TOKENIZATION.code,message:i.APPLE_PAY_TOKENIZATION.message,details:{originalError:e}}))})):Promise.reject(new r(i.APPLE_PAY_PAYMENT_TOKEN_REQUIRED))},c.prototype.teardown=function(){return s(this,a(c.prototype)),Promise.resolve()},t.exports=l.wrapPrototype(c)},{"../lib/analytics":119,"../lib/braintree-error":124,"../lib/convert-methods-to-error":127,"../lib/methods":155,"./errors":76,"@braintree/wrap-promise":43}],76:[function(e,t,n){"use strict";var r=e("../lib/braintree-error");t.exports={APPLE_PAY_NOT_ENABLED:{type:r.types.MERCHANT,code:"APPLE_PAY_NOT_ENABLED",message:"Apple Pay is not enabled for this merchant."},APPLE_PAY_VALIDATION_URL_REQUIRED:{type:r.types.MERCHANT,code:"APPLE_PAY_VALIDATION_URL_REQUIRED",message:"performValidation must be called with a validationURL."},APPLE_PAY_MERCHANT_VALIDATION_NETWORK:{type:r.types.NETWORK,code:"APPLE_PAY_MERCHANT_VALIDATION_NETWORK",message:"A network error occurred when validating the Apple Pay merchant."},APPLE_PAY_MERCHANT_VALIDATION_FAILED:{type:r.types.MERCHANT,code:"APPLE_PAY_MERCHANT_VALIDATION_FAILED",message:"Make sure you have registered your domain name in the Braintree Control Panel."},APPLE_PAY_PAYMENT_TOKEN_REQUIRED:{type:r.types.MERCHANT,code:"APPLE_PAY_PAYMENT_TOKEN_REQUIRED",message:"tokenize must be called with a payment token."},APPLE_PAY_TOKENIZATION:{type:r.types.NETWORK,code:"APPLE_PAY_TOKENIZATION",message:"A network error occurred when processing the Apple Pay payment."}}},{"../lib/braintree-error":124}],77:[function(e,t,n){"use strict";var r=e("./apple-pay"),o=e("../lib/analytics"),i=e("../lib/braintree-error"),a=e("../lib/basic-component-verification"),s=e("../lib/create-assets-url"),l=e("../lib/create-deferred-client"),c=e("./errors"),u="3.102.0",d=e("@braintree/wrap-promise");function p(e){var t="Apple Pay";return a.verify({name:t,client:e.client,authorization:e.authorization}).then((function(){var n,a=l.create({authorization:e.authorization,client:e.client,debug:e.debug,assetsUrl:s.create(e.authorization),name:t}).then((function(e){return e.getConfiguration().gatewayConfiguration.applePayWeb?(o.sendEvent(e,"applepay.initialized"),e):Promise.reject(new i(c.APPLE_PAY_NOT_ENABLED))}));return e.createPromise=a,n=new r(e),e.useDeferredClient?n:a.then((function(e){return n._client=e,n}))}))}t.exports={create:d(p),VERSION:u}},{"../lib/analytics":119,"../lib/basic-component-verification":122,"../lib/braintree-error":124,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./apple-pay":75,"./errors":76,"@braintree/wrap-promise":43}],78:[function(e,t,n){"use strict";var r=e("./constants").BRAINTREE_VERSION,o=e("./request/graphql"),i=e("./request"),a=e("../lib/is-verified-domain"),s=e("../lib/braintree-error"),l=e("../lib/convert-to-braintree-error"),c=e("./get-configuration").getConfiguration,u=e("../lib/create-authorization-data"),d=e("../lib/add-metadata"),p=e("@braintree/wrap-promise"),f=e("../lib/once"),h=e("../lib/deferred"),m=e("../lib/assign").assign,g=e("../lib/analytics"),v=e("./errors"),y=e("../lib/constants").VERSION,b=e("../lib/constants").GRAPHQL_URLS,_=e("../lib/methods"),A=e("../lib/convert-methods-to-error"),E=e("../lib/assets"),w=e("../lib/constants").FRAUDNET_FNCLS,x=e("../lib/constants").FRAUDNET_SOURCE,k=e("../lib/constants").FRAUDNET_URL,C={};function S(e){var t,n;if(e=e||{},t=JSON.stringify(e),!(n=e.gatewayConfiguration))throw new s(v.CLIENT_MISSING_GATEWAY_CONFIGURATION);if(["assetsUrl","clientApiUrl","configUrl"].forEach((function(e){if(e in n&&!a(n[e]))throw new s({type:v.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.type,code:v.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.code,message:e+" property is on an invalid domain."})})),this.getConfiguration=function(){return JSON.parse(t)},this._request=i,this._configuration=this.getConfiguration(),this._clientApiBaseUrl=n.clientApiUrl+"/v1/",n.graphQL){if(!a(n.graphQL.url))throw new s({type:v.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.type,code:v.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.code,message:"graphQL.url property is on an invalid domain."});this._graphQL=new o({graphQL:n.graphQL})}}function M(e,t){var n;if(-1===e?n=new s(v.CLIENT_REQUEST_TIMEOUT):401===e?n=new s(v.CLIENT_AUTHORIZATION_INVALID):403===e?n=new s(v.CLIENT_AUTHORIZATION_INSUFFICIENT):429===e?n=new s(v.CLIENT_RATE_LIMITED):e>=500?n=new s(v.CLIENT_GATEWAY_NETWORK):(e<200||e>=400)&&(n=l(t,{type:v.CLIENT_REQUEST_ERROR.type,code:v.CLIENT_REQUEST_ERROR.code,message:v.CLIENT_REQUEST_ERROR.message})),n)return n.details=n.details||{},n.details.httpStatus=e,n}function T(e){return{Authorization:"Bearer "+(e.authorizationFingerprint||e.authorization),"Braintree-Version":r}}S.initialize=function(e){var t,n,r=C[e.authorization];if(r)return g.sendEvent(r,"custom.client.load.cached"),r;try{n=u(e.authorization)}catch(e){return Promise.reject(new s(v.CLIENT_INVALID_AUTHORIZATION))}return r=c(n).then((function(n){return e.debug&&(n.isDebug=!0),n.authorization=e.authorization,t=new S(n)})),C[e.authorization]=r,g.sendEvent(r,"custom.client.load.initialized"),r.then((function(e){return g.sendEvent(t,"custom.client.load.succeeded"),e})).catch((function(t){return delete C[e.authorization],Promise.reject(t)}))},S.clearCache=function(){C={}},S.prototype._findOrCreateFraudnetJSON=function(e){var t,n,r,o,i=document.querySelector('script[fncls="'+w+'"]');i||((i=document.body.appendChild(document.createElement("script"))).type="application/json",i.setAttribute("fncls",w)),t=this.getConfiguration(),n={rda_tenant:"bt_card",mid:t.gatewayConfiguration.merchantId},(r=t.authorizationFingerprint)&&r.split("&").forEach((function(e){var t=e.split("=");"customer_id"===t[0]&&t.length>1&&(n.cid=t[1])})),o={f:e.substr(0,32),fp:n,bu:!1,s:x},i.text=JSON.stringify(o)},S.prototype.request=function(e,t){var n=this,r=new Promise((function(t,r){var o,i,a,c,u=Boolean("payment_methods/credit_cards"===e.endpoint&&n.getConfiguration().gatewayConfiguration.creditCards.collectDeviceData);if("graphQLApi"!==e.api&&(e.method?e.endpoint||(o="options.endpoint"):o="options.method"),o)throw new s({type:v.CLIENT_OPTION_REQUIRED.type,code:v.CLIENT_OPTION_REQUIRED.code,message:o+" is required when making a request."});if(i="api"in e?e.api:"clientApi",c={method:e.method,graphQL:n._graphQL,timeout:e.timeout,metadata:n._configuration.analyticsMetadata},"clientApi"===i)a=n._clientApiBaseUrl,c.data=d(n._configuration,e.data);else{if("graphQLApi"!==i)throw new s({type:v.CLIENT_OPTION_INVALID.type,code:v.CLIENT_OPTION_INVALID.code,message:"options.api is invalid."});a=b[n._configuration.gatewayConfiguration.environment],e.endpoint="",c.method="post",c.data=m({clientSdkMetadata:{platform:n._configuration.analyticsMetadata.platform,source:n._configuration.analyticsMetadata.source,integration:n._configuration.analyticsMetadata.integration,sessionId:n._configuration.analyticsMetadata.sessionId,version:y}},e.data),c.headers=T(n._configuration)}c.url=a+e.endpoint,c.sendAnalyticsEvent=function(e){g.sendEvent(n,e)},n._request(c,(function(e,o,a){var s,c;(c=M(a,e))?r(c):"graphQLApi"===i&&o.errors?r(l(o.errors,{type:v.CLIENT_GRAPHQL_REQUEST_ERROR.type,code:v.CLIENT_GRAPHQL_REQUEST_ERROR.code,message:v.CLIENT_GRAPHQL_REQUEST_ERROR.message})):(s=m({_httpStatus:a},o),u&&s.creditCards&&s.creditCards.length>0&&(n._findOrCreateFraudnetJSON(s.creditCards[0].nonce),E.loadScript({src:k,forceScriptReload:!0})),t(s))}))}));return"function"==typeof t?(t=f(h(t)),void r.then((function(e){t(null,e,e._httpStatus)})).catch((function(e){var n=e&&e.details&&e.details.httpStatus;t(e,null,n)}))):r},S.prototype.toJSON=function(){return this.getConfiguration()},S.prototype.getVersion=function(){return y},S.prototype.teardown=p((function(){var e=this;return delete C[e.getConfiguration().authorization],A(e,_(S.prototype)),Promise.resolve()})),t.exports=S},{"../lib/add-metadata":118,"../lib/analytics":119,"../lib/assets":120,"../lib/assign":121,"../lib/braintree-error":124,"../lib/constants":126,"../lib/convert-methods-to-error":127,"../lib/convert-to-braintree-error":128,"../lib/create-authorization-data":130,"../lib/deferred":132,"../lib/is-verified-domain":153,"../lib/methods":155,"../lib/once":156,"./constants":79,"./errors":80,"./get-configuration":81,"./request":92,"./request/graphql":90,"@braintree/wrap-promise":43}],79:[function(e,t,n){"use strict";t.exports={BRAINTREE_VERSION:"2018-05-10"}},{}],80:[function(e,t,n){"use strict";var r=e("../lib/braintree-error");t.exports={CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN:{type:r.types.MERCHANT,code:"CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN"},CLIENT_OPTION_REQUIRED:{type:r.types.MERCHANT,code:"CLIENT_OPTION_REQUIRED"},CLIENT_OPTION_INVALID:{type:r.types.MERCHANT,code:"CLIENT_OPTION_INVALID"},CLIENT_MISSING_GATEWAY_CONFIGURATION:{type:r.types.INTERNAL,code:"CLIENT_MISSING_GATEWAY_CONFIGURATION",message:"Missing gatewayConfiguration."},CLIENT_INVALID_AUTHORIZATION:{type:r.types.MERCHANT,code:"CLIENT_INVALID_AUTHORIZATION",message:"Authorization is invalid. Make sure your client token or tokenization key is valid."},CLIENT_GATEWAY_NETWORK:{type:r.types.NETWORK,code:"CLIENT_GATEWAY_NETWORK",message:"Cannot contact the gateway at this time."},CLIENT_REQUEST_TIMEOUT:{type:r.types.NETWORK,code:"CLIENT_REQUEST_TIMEOUT",message:"Request timed out waiting for a reply."},CLIENT_REQUEST_ERROR:{type:r.types.NETWORK,code:"CLIENT_REQUEST_ERROR",message:"There was a problem with your request."},CLIENT_GRAPHQL_REQUEST_ERROR:{type:r.types.NETWORK,code:"CLIENT_GRAPHQL_REQUEST_ERROR",message:"There was a problem with your request."},CLIENT_RATE_LIMITED:{type:r.types.MERCHANT,code:"CLIENT_RATE_LIMITED",message:"You are being rate-limited; please try again in a few minutes."},CLIENT_AUTHORIZATION_INSUFFICIENT:{type:r.types.MERCHANT,code:"CLIENT_AUTHORIZATION_INSUFFICIENT",message:"The authorization used has insufficient privileges."},CLIENT_AUTHORIZATION_INVALID:{type:r.types.MERCHANT,code:"CLIENT_AUTHORIZATION_INVALID",message:"Either the client token has expired and a new one should be generated or the tokenization key has been deactivated or deleted."}}},{"../lib/braintree-error":124}],81:[function(e,t,n){"use strict";var r=e("../lib/braintree-error"),o=e("@braintree/wrap-promise"),i=e("./request"),a=e("@braintree/uuid"),s=e("../lib/constants"),l=e("./errors"),c=e("./request/graphql"),u=e("../lib/constants").GRAPHQL_URLS,d=e("../lib/is-date-string-before-or-on"),p=e("./constants").BRAINTREE_VERSION;function f(e){return new Promise((function(t,n){var o,f,h,m,g=a(),v={merchantAppId:window.location.host,platform:s.PLATFORM,sdkVersion:s.VERSION,source:s.SOURCE,integration:s.INTEGRATION,integrationType:s.INTEGRATION,sessionId:g};f=e.attrs,h=e.configUrl,f._meta=v,f.braintreeLibraryVersion=s.BRAINTREE_LIBRARY_VERSION,f.configVersion="3",m={url:h,method:"GET",data:f},f.authorizationFingerprint&&e.graphQL?(d(e.graphQL.date,p)&&(m.graphQL=new c({graphQL:{url:e.graphQL.url,features:["configuration"]}})),m.metadata=v):f.tokenizationKey&&(m.graphQL=new c({graphQL:{url:u[e.environment],features:["configuration"]}}),m.metadata=v),i(m,(function(e,i,a){var s;if(e)return s=403===a?l.CLIENT_AUTHORIZATION_INSUFFICIENT:401===a?l.CLIENT_AUTHORIZATION_INVALID:l.CLIENT_GATEWAY_NETWORK,void n(new r({type:s.type,code:s.code,message:s.message,details:{originalError:e}}));o={authorizationType:f.tokenizationKey?"TOKENIZATION_KEY":"CLIENT_TOKEN",authorizationFingerprint:f.authorizationFingerprint,analyticsMetadata:v,gatewayConfiguration:i},t(o)}))}))}t.exports={getConfiguration:o(f)}},{"../lib/braintree-error":124,"../lib/constants":126,"../lib/is-date-string-before-or-on":151,"./constants":79,"./errors":80,"./request":92,"./request/graphql":90,"@braintree/uuid":39,"@braintree/wrap-promise":43}],82:[function(e,t,n){"use strict";var r=e("../lib/braintree-error"),o=e("./client"),i="3.102.0",a=e("@braintree/wrap-promise"),s=e("../lib/errors");function l(e){return e.authorization?o.initialize(e):Promise.reject(new r({type:s.INSTANTIATION_OPTION_REQUIRED.type,code:s.INSTANTIATION_OPTION_REQUIRED.code,message:"options.authorization is required when instantiating a client."}))}t.exports={create:a(l),VERSION:i}},{"../lib/braintree-error":124,"../lib/errors":135,"./client":78,"@braintree/wrap-promise":43}],83:[function(e,t,n){"use strict";var r=e("../../lib/querystring"),o=e("../../lib/assign").assign,i=e("./prep-body"),a=e("./parse-body"),s=e("./xhr"),l=s.isAvailable,c=e("./graphql/request"),u=e("./default-request"),d=1,p=408;function f(e){return!e||e===p}function h(e){var t=!e.data&&e.errors&&e.errors[0]&&e.errors[0].extensions&&e.errors[0].extensions.errorClass;return"UNKNOWN"===t||"INTERNAL"===t}function m(e,t,n){var p,g,v,y,b,_,A,E=e.url,w=e.graphQL,x=e.timeout,k=s.getRequestObject(),C=n,S=Boolean(w&&w.isGraphQLRequest(E,e.data));e.headers=o({"Content-Type":"application/json"},e.headers),E=(v=S?new c(e):new u(e)).getUrl(),y=v.getBody(),b=v.getMethod(),_=v.getHeaders(),"GET"===b&&(E=r.queryify(E,y),y=null),l?k.onreadystatechange=function(){if(4===k.readyState){if(0===k.status&&S)return delete e.graphQL,void m(e,t,n);if(A=a(k.responseText),g=v.adaptResponseBody(A),(p=v.determineStatus(k.status,A))>=400||p<200){if(S&&h(A))return delete e.graphQL,void m(e,t,n);if(t<d&&f(p))return t++,void m(e,t,n);C(g||"error",null,p||500)}else C(null,g,p)}}:(e.headers&&(E=r.queryify(E,_)),k.onload=function(){C(null,a(k.responseText),k.status)},k.onerror=function(){C("error",null,500)},k.onprogress=function(){},k.ontimeout=function(){C("timeout",null,-1)});try{k.open(b,E,!0)}catch(r){if(!S)throw r;return delete e.graphQL,void m(e,t,n)}k.timeout=x,l&&Object.keys(_).forEach((function(e){k.setRequestHeader(e,_[e])}));try{k.send(i(b,y))}catch(e){}}function g(e,t){m(e,0,t)}t.exports={request:g}},{"../../lib/assign":121,"../../lib/querystring":157,"./default-request":84,"./graphql/request":91,"./parse-body":93,"./prep-body":94,"./xhr":95}],84:[function(e,t,n){"use strict";function r(e){this._url=e.url,this._data=e.data,this._method=e.method,this._headers=e.headers}r.prototype.getUrl=function(){return this._url},r.prototype.getBody=function(){return this._data},r.prototype.getMethod=function(){return this._method},r.prototype.getHeaders=function(){return this._headers},r.prototype.adaptResponseBody=function(e){return e},r.prototype.determineStatus=function(e){return e},t.exports=r},{}],85:[function(e,t,n){"use strict";var r=e("./error"),o=e("../../../../lib/assign").assign,i={creditCard:{AMERICAN_EXPRESS:"American Express",DISCOVER:"Discover",INTERNATIONAL_MAESTRO:"Maestro",JCB:"JCB",MASTERCARD:"MasterCard",SOLO:"Solo",UK_MAESTRO:"UK Maestro",UNION_PAY:"UnionPay",VISA:"Visa",ELO:"Elo",HIPER:"Hiper",HIPERCARD:"Hipercard"},applePayWeb:{VISA:"visa",MASTERCARD:"mastercard",DISCOVER:"discover",AMERICAN_EXPRESS:"amex",INTERNATIONAL_MAESTRO:"maestro",ELO:"elo"},visaCheckout:{VISA:"Visa",MASTERCARD:"MasterCard",DISCOVER:"Discover",AMERICAN_EXPRESS:"American Express"},googlePay:{VISA:"visa",MASTERCARD:"mastercard",DISCOVER:"discover",AMERICAN_EXPRESS:"amex",INTERNATIONAL_MAESTRO:"maestro",ELO:"elo"},masterpass:{VISA:"visa",MASTERCARD:"master",DISCOVER:"discover",AMERICAN_EXPRESS:"amex",DINERS:"diners",INTERNATIONAL_MAESTRO:"maestro",JCB:"jcb"}};function a(e,t){return e.data&&!e.errors?s(e,t):r(e)}function s(e,t){var n,r=e.data.clientConfiguration;return n={environment:r.environment.toLowerCase(),clientApiUrl:r.clientApiUrl,assetsUrl:r.assetsUrl,analytics:{url:r.analyticsUrl},merchantId:r.merchantId,venmo:"off"},r.supportedFeatures&&(n.graphQL={url:t._graphQL._config.url,features:r.supportedFeatures.map((function(e){return e.toLowerCase()}))}),r.braintreeApi&&(n.braintreeApi=r.braintreeApi),r.applePayWeb&&(n.applePayWeb=r.applePayWeb,n.applePayWeb.supportedNetworks=l(r.applePayWeb.supportedCardBrands,i.applePayWeb),delete n.applePayWeb.supportedCardBrands),r.ideal&&(n.ideal=r.ideal),r.kount&&(n.kount={kountMerchantId:r.kount.merchantId}),r.creditCard?(n.challenges=r.creditCard.challenges.map((function(e){return e.toLowerCase()})),n.creditCards={supportedCardTypes:l(r.creditCard.supportedCardBrands,i.creditCard)},n.threeDSecureEnabled=r.creditCard.threeDSecureEnabled,n.threeDSecure=r.creditCard.threeDSecure):(n.challenges=[],n.creditCards={supportedCardTypes:[]},n.threeDSecureEnabled=!1),r.googlePay&&(n.androidPay={displayName:r.googlePay.displayName,enabled:!0,environment:r.googlePay.environment.toLowerCase(),googleAuthorizationFingerprint:r.googlePay.googleAuthorization,paypalClientId:r.googlePay.paypalClientId,supportedNetworks:l(r.googlePay.supportedCardBrands,i.googlePay)}),r.venmo&&(n.payWithVenmo={merchantId:r.venmo.merchantId,accessToken:r.venmo.accessToken,environment:r.venmo.environment.toLowerCase(),enrichedCustomerDataEnabled:r.venmo.enrichedCustomerDataEnabled}),r.paypal?(n.paypalEnabled=!0,n.paypal=o({},r.paypal),n.paypal.currencyIsoCode=n.paypal.currencyCode,n.paypal.environment=n.paypal.environment.toLowerCase(),delete n.paypal.currencyCode):n.paypalEnabled=!1,r.unionPay&&(n.unionPay={enabled:!0,merchantAccountId:r.unionPay.merchantAccountId}),r.visaCheckout&&(n.visaCheckout={apikey:r.visaCheckout.apiKey,encryptionKey:r.visaCheckout.encryptionKey,externalClientId:r.visaCheckout.externalClientId,supportedCardTypes:l(r.visaCheckout.supportedCardBrands,i.visaCheckout)}),r.masterpass&&(n.masterpass={merchantCheckoutId:r.masterpass.merchantCheckoutId,supportedNetworks:l(r.masterpass.supportedCardBrands,i.masterpass)}),r.usBankAccount&&(n.usBankAccount={routeId:r.usBankAccount.routeId,plaid:{publicKey:r.usBankAccount.plaidPublicKey}}),n}function l(e,t){return e.reduce((function(e,n){return t.hasOwnProperty(n)?e.concat(t[n]):e}),[])}t.exports=a},{"../../../../lib/assign":121,"./error":87}],86:[function(e,t,n){"use strict";var r=e("./error"),o={AMERICAN_EXPRESS:"American Express",DINERS:"Discover",DISCOVER:"Discover",ELO:"Elo",HIPER:"Hiper",HIPERCARD:"Hipercard",INTERNATIONAL_MAESTRO:"Maestro",JCB:"JCB",MASTERCARD:"MasterCard",UK_MAESTRO:"Maestro",UNION_PAY:"UnionPay",VISA:"Visa"},i={YES:"Yes",NO:"No",UNKNOWN:"Unknown"},a={PSDTWO:"psd2"};function s(e){return e.data&&!e.errors?l(e):r(e)}function l(e){var t,n,r=e.data.tokenizeCreditCard,s=r.creditCard,l=s.last4?s.last4.substr(2,4):"",c=s.binData;return c&&(["commercial","debit","durbinRegulated","healthcare","payroll","prepaid"].forEach((function(e){c[e]?c[e]=i[c[e]]:c[e]="Unknown"})),["issuingBank","countryOfIssuance","productId"].forEach((function(e){c[e]||(c[e]="Unknown")}))),t={creditCards:[{binData:c,consumed:!1,description:l?"ending in "+l:"",nonce:r.token,details:{cardholderName:s.cardholderName,expirationMonth:s.expirationMonth,expirationYear:s.expirationYear,bin:s.bin||"",cardType:o[s.brandCode]||"Unknown",lastFour:s.last4||"",lastTwo:l},type:"CreditCard",threeDSecureInfo:null}]},r.authenticationInsight&&(n=r.authenticationInsight.customerAuthenticationRegulationEnvironment,t.creditCards[0].authenticationInsight={regulationEnvironment:a[n]||n.toLowerCase()}),t}t.exports=s},{"./error":87}],87:[function(e,t,n){"use strict";function r(e){var t=e.errors&&e.errors[0]&&e.errors[0].extensions&&e.errors[0].extensions.errorClass;return"VALIDATION"===t?i(e):t?o(e):{error:{message:"There was a problem serving your request"},fieldErrors:[]}}function o(e){return{error:{message:e.errors[0].message},fieldErrors:[]}}function i(e){var t=a(e.errors);return 0===t.length?{error:{message:e.errors[0].message}}:{error:{message:l(t)},fieldErrors:t}}function a(e){var t=[];return e.forEach((function(e){e.extensions&&e.extensions.inputPath&&s(e.extensions.inputPath.slice(1),e,t)})),t}function s(e,t,n){var r,o=t.extensions.legacyCode,i=e[0];1!==e.length?(n.forEach((function(e){e.field===i&&(r=e)})),r||(r={field:i,fieldErrors:[]},n.push(r)),s(e.slice(1),t,r.fieldErrors)):n.push({code:o,field:i,message:t.message})}function l(e){return{creditCard:"Credit card is invalid"}[e[0].field]}t.exports=r},{}],88:[function(e,t,n){"use strict";var r="query ClientConfiguration {   clientConfiguration {     analyticsUrl     environment     merchantId     assetsUrl     clientApiUrl     creditCard {       supportedCardBrands       challenges       threeDSecureEnabled       threeDSecure {         cardinalAuthenticationJWT       }     }     applePayWeb {       countryCode       currencyCode       merchantIdentifier       supportedCardBrands     }     googlePay {       displayName       supportedCardBrands       environment       googleAuthorization       paypalClientId     }     ideal {       routeId       assetsUrl     }     kount {       merchantId     }     masterpass {       merchantCheckoutId       supportedCardBrands     }     paypal {       displayName       clientId       assetsUrl       environment       environmentNoNetwork       unvettedMerchant       braintreeClientId       billingAgreementsEnabled       merchantAccountId       currencyCode       payeeEmail     }     unionPay {       merchantAccountId     }     usBankAccount {       routeId       plaidPublicKey     }     venmo {       merchantId       accessToken       environment       enrichedCustomerDataEnabled    }     visaCheckout {       apiKey       externalClientId       supportedCardBrands     }     braintreeApi {       accessToken       url     }     supportedFeatures   } }";function o(){return{query:r,operationName:"ClientConfiguration"}}t.exports=o},{}],89:[function(e,t,n){"use strict";var r=e("../../../../lib/assign").assign;function o(e){var t=e.hasAuthenticationInsight,n="mutation TokenizeCreditCard($input: TokenizeCreditCardInput!";return t&&(n+=", $authenticationInsightInput: AuthenticationInsightInput!"),n+=") {   tokenizeCreditCard(input: $input) {     token     creditCard {       bin       brandCode       last4       cardholderName       expirationMonth      expirationYear      binData {         prepaid         healthcare         debit         durbinRegulated         commercial         payroll         issuingBank         countryOfIssuance         productId       }     } ",t&&(n+="    authenticationInsight(input: $authenticationInsightInput) {      customerAuthenticationRegulationEnvironment    }"),n+="  } }"}function i(e,t){var n=e.creditCard,r=n&&n.billingAddress,o=n&&n.expirationDate,i=n&&(n.expirationMonth||o&&o.split("/")[0].trim()),s=n&&(n.expirationYear||o&&o.split("/")[1].trim()),l={input:{creditCard:{number:n&&n.number,expirationMonth:i,expirationYear:s,cvv:n&&n.cvv,cardholderName:n&&n.cardholderName},options:{}}};return t.hasAuthenticationInsight&&(l.authenticationInsightInput={merchantAccountId:e.merchantAccountId}),r&&(l.input.creditCard.billingAddress=r),l.input=a(e,l.input),l}function a(e,t){var n;return e.creditCard&&e.creditCard.options&&"boolean"==typeof e.creditCard.options.validate?n=e.creditCard.options.validate:e.authorizationFingerprint&&e.tokenizationKey||e.authorizationFingerprint?n=!0:e.tokenizationKey&&(n=!1),"boolean"==typeof n&&(t.options=r({validate:n},t.options)),t}function s(e){var t={hasAuthenticationInsight:Boolean(e.authenticationInsight&&e.merchantAccountId)};return{query:o(t),variables:i(e,t),operationName:"TokenizeCreditCard"}}t.exports=s},{"../../../../lib/assign":121}],90:[function(e,t,n){"use strict";var r={tokenize_credit_cards:"payment_methods/credit_cards",configuration:"configuration"},o=["creditCard.options.unionPayEnrollment"];function i(e){this._config=e.graphQL}function a(e){return o.some((function(t){return void 0!==t.split(".").reduce((function(e,t){return e&&e[t]}),e)}))}i.prototype.getGraphQLEndpoint=function(){return this._config.url},i.prototype.isGraphQLRequest=function(e,t){var n,o=this.getClientApiPath(e);return!(!this._isGraphQLEnabled()||!o)&&(n=this._config.features.some((function(e){return r[e]===o})),!a(t)&&n)},i.prototype.getClientApiPath=function(e){var t,n="/client_api/v1/",r=e.split(n);return r.length>1&&(t=r[1].split("?")[0]),t},i.prototype._isGraphQLEnabled=function(){return Boolean(this._config)},t.exports=i},{}],91:[function(e,t,n){"use strict";var r=e("../../constants").BRAINTREE_VERSION,o=e("../../../lib/assign").assign,i=e("../../../lib/snake-case-to-camel-case"),a=e("./generators/credit-card-tokenization"),s=e("./adapters/credit-card-tokenization"),l=e("./generators/configuration"),c=e("./adapters/configuration"),u={"payment_methods/credit_cards":a,configuration:l},d={"payment_methods/credit_cards":s,configuration:c};function p(e){var t=e.graphQL.getClientApiPath(e.url);this._graphQL=e.graphQL,this._data=e.data,this._method=e.method,this._headers=e.headers,this._clientSdkMetadata={source:e.metadata.source,integration:e.metadata.integration,sessionId:e.metadata.sessionId},this._sendAnalyticsEvent=e.sendAnalyticsEvent||Function.prototype,this._generator=u[t],this._adapter=d[t],this._sendAnalyticsEvent("graphql.init")}function f(e,t){return!e&&t.errors[0].message}function h(e){var t={};return Object.keys(e).forEach((function(n){var r=i(n);"object"==typeof e[n]?t[r]=h(e[n]):"number"==typeof e[n]?t[r]=String(e[n]):t[r]=e[n]})),t}p.prototype.getUrl=function(){return this._graphQL.getGraphQLEndpoint()},p.prototype.getBody=function(){var e=h(this._data),t=this._generator(e),n=o({clientSdkMetadata:this._clientSdkMetadata},t);return JSON.stringify(n)},p.prototype.getMethod=function(){return"POST"},p.prototype.getHeaders=function(){var e,t;return this._data.authorizationFingerprint?(this._sendAnalyticsEvent("graphql.authorization-fingerprint"),e=this._data.authorizationFingerprint):(this._sendAnalyticsEvent("graphql.tokenization-key"),e=this._data.tokenizationKey),t={Authorization:"Bearer "+e,"Braintree-Version":r},o({},this._headers,t)},p.prototype.adaptResponseBody=function(e){return this._adapter(e,this)},p.prototype.determineStatus=function(e,t){var n,r;return 200===e?(r=t.errors&&t.errors[0]&&t.errors[0].extensions&&t.errors[0].extensions.errorClass,n=t.data&&!t.errors?200:"VALIDATION"===r?422:"AUTHORIZATION"===r?403:"AUTHENTICATION"===r?401:f(r,t)?403:500):n=e||500,this._sendAnalyticsEvent("graphql.status."+e),this._sendAnalyticsEvent("graphql.determinedStatus."+n),n},t.exports=p},{"../../../lib/assign":121,"../../../lib/snake-case-to-camel-case":159,"../../constants":79,"./adapters/configuration":85,"./adapters/credit-card-tokenization":86,"./generators/configuration":88,"./generators/credit-card-tokenization":89}],92:[function(e,t,n){"use strict";var r=e("../../lib/once"),o=e("./ajax-driver");t.exports=function(e,t){t=r(t||Function.prototype),e.method=(e.method||"GET").toUpperCase(),e.timeout=null==e.timeout?6e4:e.timeout,e.data=e.data||{},o.request(e,t)}},{"../../lib/once":156,"./ajax-driver":83}],93:[function(e,t,n){"use strict";t.exports=function(e){try{e=JSON.parse(e)}catch(e){}return e}},{}],94:[function(e,t,n){"use strict";t.exports=function(e,t){if("string"!=typeof e)throw new Error("Method must be a string");return"get"!==e.toLowerCase()&&null!=t&&(t="string"==typeof t?t:JSON.stringify(t)),t}},{}],95:[function(e,t,n){"use strict";var r="undefined"!=typeof window&&window.XMLHttpRequest&&"withCredentials"in new window.XMLHttpRequest;function o(){return r?new window.XMLHttpRequest:new window.XDomainRequest}t.exports={isAvailable:r,getRequestObject:o}},{}],96:[function(e,t,n){"use strict";var r=e("../lib/braintree-error");t.exports={DATA_COLLECTOR_KOUNT_NOT_ENABLED:{type:r.types.MERCHANT,code:"DATA_COLLECTOR_KOUNT_NOT_ENABLED",message:"Kount is not enabled for this merchant."},DATA_COLLECTOR_KOUNT_ERROR:{type:r.types.MERCHANT,code:"DATA_COLLECTOR_KOUNT_ERROR"},DATA_COLLECTOR_REQUIRES_CREATE_OPTIONS:{type:r.types.MERCHANT,code:"DATA_COLLECTOR_REQUIRES_CREATE_OPTIONS",message:"Data Collector must be created with Kount and/or PayPal."}}},{"../lib/braintree-error":124}],97:[function(e,t,n){"use strict";var r,o=e("../lib/constants").FRAUDNET_FNCLS,i=e("../lib/constants").FRAUDNET_SOURCE,a=e("../lib/constants").FRAUDNET_URL,s=e("../lib/assets").loadScript;function l(e){var t=new u;return!(e=e||{}).sessionId&&r?(t.sessionId=r,Promise.resolve(t)):t.initialize(e)}function c(){r=null}function u(){}function d(e){e&&e.parentNode&&e.parentNode.removeChild(e)}function p(){var e,t="";for(e=0;e<32;e++)t+=Math.floor(16*Math.random()).toString(16);return t}function f(e){return"https://b.stats.paypal.com/counter.cgi?i=127.0.0.1&p="+e+"&t="+(new Date).getTime()/1e3+"&a=14"}function h(e,t,n){var r=document.body.appendChild(document.createElement("script")),a={f:e,s:i,b:t};return"production"!==n&&(a.sandbox=!0),r.type="application/json",r.setAttribute("fncls",o),r.text=JSON.stringify(a),r}u.prototype.initialize=function(e){var t=e.environment,n=this;return this.sessionId=e.sessionId||p(),e.sessionId||(r=this.sessionId),this._beaconId=f(this.sessionId),this._parameterBlock=h(this.sessionId,this._beaconId,t),s({src:a}).then((function(e){return n._thirdPartyBlock=e,n})).catch((function(){return null}))},u.prototype.teardown=function(){d(document.querySelector('iframe[title="ppfniframe"]')),d(document.querySelector('iframe[title="pbf"]')),d(this._parameterBlock),d(this._thirdPartyBlock)},t.exports={setup:l,clearSessionIdCache:c}},{"../lib/assets":120,"../lib/constants":126}],98:[function(e,t,n){"use strict";var r=e("./kount"),o=e("./fraudnet"),i=e("../lib/braintree-error"),a=e("../lib/basic-component-verification"),s=e("../lib/create-deferred-client"),l=e("../lib/create-assets-url"),c=e("../lib/methods"),u=e("../lib/convert-methods-to-error"),d="3.102.0",p=e("@braintree/wrap-promise"),f=e("./errors");function h(e){var t,n="Data Collector",c={_instances:[]};return a.verify({name:n,client:e.client,authorization:e.authorization}).then((function(){return c._instantiatedWithAClient=!e.useDeferredClient,c._createPromise=s.create({authorization:e.authorization,client:e.client,debug:e.debug,assetsUrl:l.create(e.authorization),name:n}).then((function(n){var o,a=n.getConfiguration();if(!0===e.kount&&a.gatewayConfiguration.kount){try{o=r.setup({environment:a.gatewayConfiguration.environment,merchantId:a.gatewayConfiguration.kount.kountMerchantId})}catch(e){return Promise.reject(new i({type:f.DATA_COLLECTOR_KOUNT_ERROR.type,code:f.DATA_COLLECTOR_KOUNT_ERROR.code,message:e.message}))}t=o.deviceData,c._instances.push(o)}else t={};return Promise.resolve(n)})).then((function(n){return o.setup({sessionId:e.riskCorrelationId||e.clientMetadataId||e.correlationId,environment:n.getConfiguration().gatewayConfiguration.environment}).then((function(e){e&&(t.correlation_id=e.sessionId,c._instances.push(e))}))})).then((function(){return 0===c._instances.length?Promise.reject(new i(f.DATA_COLLECTOR_REQUIRES_CREATE_OPTIONS)):(c.deviceData=JSON.stringify(t),c.rawDeviceData=t,c)})),c.teardown=m(c),c.getDeviceData=g(c),c._instantiatedWithAClient?c._createPromise:c}))}function m(e){return p((function(){return e._createPromise.then((function(){e._instances.forEach((function(e){e&&e.teardown()})),u(e,c(e))}))}))}function g(e){return p((function(t){return t=t||{},e._createPromise.then((function(){return t.raw?Promise.resolve(e.rawDeviceData):Promise.resolve(e.deviceData)}))}))}t.exports={create:p(h),VERSION:d}},{"../lib/basic-component-verification":122,"../lib/braintree-error":124,"../lib/convert-methods-to-error":127,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"../lib/methods":155,"./errors":96,"./fraudnet":97,"./kount":99,"@braintree/wrap-promise":43}],99:[function(e,t,n){"use strict";var r=e("./vendor/sjcl"),o=e("../lib/camel-case-to-snake-case"),i="https://assets.qa.braintreepayments.com/data",a="braintreeDataFrame-",s={development:i,qa:i,sandbox:"https://assets.braintreegateway.com/sandbox/data",production:"https://assets.braintreegateway.com/data"},l={};function c(e){return new u(null!=e?e:{})}function u(e){var t=u.getCachedDeviceData(e.merchantId);if(t)return this.deviceData=t,void(this._isCached=!0);this._currentEnvironment=this._initializeEnvironment(e),r.random.startCollectors(),this._deviceSessionId=this._generateDeviceSessionId(),this.deviceData=this._getDeviceData(),u.setCachedDeviceData(e.merchantId,this.deviceData),this._iframe=this._setupIFrame()}u.getCachedDeviceData=function(e){return l[e]},u.setCachedDeviceData=function(e,t){l[e]=t},u.prototype.teardown=function(){this._isCached||(r.random.stopCollectors(),this._removeIframe())},u.prototype._removeIframe=function(){this._iframe.parentNode.removeChild(this._iframe)},u.prototype._getDeviceData=function(){return o({deviceSessionId:this._deviceSessionId,fraudMerchantId:this._currentEnvironment.id})},u.prototype._generateDeviceSessionId=function(){var e;return e=r.random.randomWords(4,0),r.codec.hex.fromBits(e)},u.prototype._setupIFrame=function(){var e,t,n=this;return e="?m="+this._currentEnvironment.id+"&s="+this._deviceSessionId,(t=document.createElement("iframe")).width=1,t.id=a+this._deviceSessionId,t.height=1,t.frameBorder=0,t.scrolling="no",t.style.position="fixed",t.style.left="-999999px",t.style.top="-999999px",t.title="Braintree-Kount-iframe",t.setAttribute("aria-hidden","true"),document.body.appendChild(t),setTimeout((function(){t.src=n._currentEnvironment.url+"/logo.htm"+e,t.innerHTML='<img src="'+n._currentEnvironment.url+"/logo.gif"+e+'" alt="" />'}),10),t},u.prototype._initializeEnvironment=function(e){var t=s[e.environment];if(null==t)throw new Error(e.environment+" is not a valid environment for kount.environment");return{url:t,name:e.environment,id:e.merchantId}},t.exports={setup:c,Kount:u,environmentUrls:s}},{"../lib/camel-case-to-snake-case":125,"./vendor/sjcl":100}],100:[function(e,n,r){"use strict";var o={cipher:{},hash:{},keyexchange:{},mode:{},misc:{},codec:{},exception:{corrupt:function(e){this.toString=function(){return"CORRUPT: "+this.message},this.message=e},invalid:function(e){this.toString=function(){return"INVALID: "+this.message},this.message=e},bug:function(e){this.toString=function(){return"BUG: "+this.message},this.message=e},notReady:function(e){this.toString=function(){return"NOT READY: "+this.message},this.message=e}}};function i(e,t,n){if(4!==t.length)throw new o.exception.invalid("invalid aes block size");var r=e.b[n],i=t[0]^r[0],a=t[n?3:1]^r[1],s=t[2]^r[2];t=t[n?1:3]^r[3];var l,c,u,d,p=r.length/4-2,f=4,h=[0,0,0,0];e=(l=e.l[n])[0];var m=l[1],g=l[2],v=l[3],y=l[4];for(d=0;d<p;d++)l=e[i>>>24]^m[a>>16&255]^g[s>>8&255]^v[255&t]^r[f],c=e[a>>>24]^m[s>>16&255]^g[t>>8&255]^v[255&i]^r[f+1],u=e[s>>>24]^m[t>>16&255]^g[i>>8&255]^v[255&a]^r[f+2],t=e[t>>>24]^m[i>>16&255]^g[a>>8&255]^v[255&s]^r[f+3],f+=4,i=l,a=c,s=u;for(d=0;4>d;d++)h[n?3&-d:d]=y[i>>>24]<<24^y[a>>16&255]<<16^y[s>>8&255]<<8^y[255&t]^r[f++],l=i,i=a,a=s,s=t,t=l;return h}function a(e,t){var n,r,o,i=e.u,a=e.b,s=i[0],l=i[1],c=i[2],u=i[3],d=i[4],p=i[5],f=i[6],h=i[7];for(n=0;64>n;n++)16>n?r=t[n]:(r=t[n+1&15],o=t[n+14&15],r=t[15&n]=(r>>>7^r>>>18^r>>>3^r<<25^r<<14)+(o>>>17^o>>>19^o>>>10^o<<15^o<<13)+t[15&n]+t[n+9&15]|0),r=r+h+(d>>>6^d>>>11^d>>>25^d<<26^d<<21^d<<7)+(f^d&(p^f))+a[n],h=f,f=p,p=d,d=u+r|0,u=c,c=l,s=r+((l=s)&c^u&(l^c))+(l>>>2^l>>>13^l>>>22^l<<30^l<<19^l<<10)|0;i[0]=i[0]+s|0,i[1]=i[1]+l|0,i[2]=i[2]+c|0,i[3]=i[3]+u|0,i[4]=i[4]+d|0,i[5]=i[5]+p|0,i[6]=i[6]+f|0,i[7]=i[7]+h|0}function s(e,t){var n,r=o.random.B[e],i=[];for(n in r)r.hasOwnProperty(n)&&i.push(r[n]);for(n=0;n<i.length;n++)i[n](t)}function l(e,t){"undefined"!=typeof window&&window.performance&&"function"==typeof window.performance.now?e.addEntropy(window.performance.now(),t,"loadtime"):e.addEntropy((new Date).valueOf(),t,"loadtime")}function c(e){e.b=u(e).concat(u(e)),e.C=new o.cipher.aes(e.b)}function u(e){for(var t=0;4>t&&(e.g[t]=e.g[t]+1|0,!e.g[t]);t++);return e.C.encrypt(e.g)}function d(e,t){return function(){t.apply(e,arguments)}}o.cipher.aes=function(e){this.l[0][0][0]||this.G();var t,n,r,i,a=this.l[0][4],s=this.l[1],l=1;if(4!==(t=e.length)&&6!==t&&8!==t)throw new o.exception.invalid("invalid aes key size");for(this.b=[r=e.slice(0),i=[]],e=t;e<4*t+28;e++)n=r[e-1],(0==e%t||8===t&&4==e%t)&&(n=a[n>>>24]<<24^a[n>>16&255]<<16^a[n>>8&255]<<8^a[255&n],0==e%t&&(n=n<<8^n>>>24^l<<24,l=l<<1^283*(l>>7))),r[e]=r[e-t]^n;for(t=0;e;t++,e--)n=r[3&t?e:e-4],i[t]=4>=e||4>t?n:s[0][a[n>>>24]]^s[1][a[n>>16&255]]^s[2][a[n>>8&255]]^s[3][a[255&n]]},o.cipher.aes.prototype={encrypt:function(e){return i(this,e,0)},decrypt:function(e){return i(this,e,1)},l:[[[],[],[],[],[]],[[],[],[],[],[]]],G:function(){var e,t,n,r,o,i,a,s=this.l[0],l=this.l[1],c=s[4],u=l[4],d=[],p=[];for(e=0;256>e;e++)p[(d[e]=e<<1^283*(e>>7))^e]=e;for(t=n=0;!c[t];t^=r||1,n=p[n]||1)for(i=(i=n^n<<1^n<<2^n<<3^n<<4)>>8^255&i^99,c[t]=i,u[i]=t,a=16843009*(o=d[e=d[r=d[t]]])^65537*e^257*r^16843008*t,o=257*d[i]^16843008*i,e=0;4>e;e++)s[e][t]=o=o<<24^o>>>8,l[e][i]=a=a<<24^a>>>8;for(e=0;5>e;e++)s[e]=s[e].slice(0),l[e]=l[e].slice(0)}},o.bitArray={bitSlice:function(e,t,n){return e=o.bitArray.M(e.slice(t/32),32-(31&t)).slice(1),void 0===n?e:o.bitArray.clamp(e,n-t)},extract:function(e,t,n){var r=Math.floor(-t-n&31);return(-32&(t+n-1^t)?e[t/32|0]<<32-r^e[t/32+1|0]>>>r:e[t/32|0]>>>r)&(1<<n)-1},concat:function(e,t){if(0===e.length||0===t.length)return e.concat(t);var n=e[e.length-1],r=o.bitArray.getPartial(n);return 32===r?e.concat(t):o.bitArray.M(t,r,0|n,e.slice(0,e.length-1))},bitLength:function(e){var t=e.length;return 0===t?0:32*(t-1)+o.bitArray.getPartial(e[t-1])},clamp:function(e,t){if(32*e.length<t)return e;var n=(e=e.slice(0,Math.ceil(t/32))).length;return t&=31,0<n&&t&&(e[n-1]=o.bitArray.partial(t,e[n-1]&2147483648>>t-1,1)),e},partial:function(e,t,n){return 32===e?t:(n?0|t:t<<32-e)+1099511627776*e},getPartial:function(e){return Math.round(e/1099511627776)||32},equal:function(e,t){if(o.bitArray.bitLength(e)!==o.bitArray.bitLength(t))return!1;var n,r=0;for(n=0;n<e.length;n++)r|=e[n]^t[n];return 0===r},M:function(e,t,n,r){var i;for(i=0,void 0===r&&(r=[]);32<=t;t-=32)r.push(n),n=0;if(0===t)return r.concat(e);for(i=0;i<e.length;i++)r.push(n|e[i]>>>t),n=e[i]<<32-t;return i=e.length?e[e.length-1]:0,e=o.bitArray.getPartial(i),r.push(o.bitArray.partial(t+e&31,32<t+e?n:r.pop(),1)),r},Y:function(e,t){return[e[0]^t[0],e[1]^t[1],e[2]^t[2],e[3]^t[3]]},byteswapM:function(e){var t,n;for(t=0;t<e.length;++t)n=e[t],e[t]=n>>>24|n>>>8&65280|(65280&n)<<8|n<<24;return e}},o.codec.utf8String={fromBits:function(e){var t,n,r="",i=o.bitArray.bitLength(e);for(t=0;t<i/8;t++)!(3&t)&&(n=e[t/4]),r+=String.fromCharCode(n>>>8>>>8>>>8),n<<=8;return decodeURIComponent(escape(r))},toBits:function(e){e=unescape(encodeURIComponent(e));var t,n=[],r=0;for(t=0;t<e.length;t++)r=r<<8|e.charCodeAt(t),!(3&~t)&&(n.push(r),r=0);return 3&t&&n.push(o.bitArray.partial(8*(3&t),r)),n}},o.codec.hex={fromBits:function(e){var t,n="";for(t=0;t<e.length;t++)n+=(0xf00000000000+(0|e[t])).toString(16).substr(4);return n.substr(0,o.bitArray.bitLength(e)/4)},toBits:function(e){var t,n,r=[];for(n=(e=e.replace(/\s|0x/g,"")).length,e+="00000000",t=0;t<e.length;t+=8)r.push(0^parseInt(e.substr(t,8),16));return o.bitArray.clamp(r,4*n)}},o.hash.sha256=function(e){this.b[0]||this.G(),e?(this.u=e.u.slice(0),this.o=e.o.slice(0),this.h=e.h):this.reset()},o.hash.sha256.hash=function(e){return(new o.hash.sha256).update(e).finalize()},o.hash.sha256.prototype={blockSize:512,reset:function(){return this.u=this.K.slice(0),this.o=[],this.h=0,this},update:function(e){"string"==typeof e&&(e=o.codec.utf8String.toBits(e));var t,n=this.o=o.bitArray.concat(this.o,e);if(t=this.h,9007199254740991<(e=this.h=t+o.bitArray.bitLength(e)))throw new o.exception.invalid("Cannot hash more than 2^53 - 1 bits");if("undefined"!=typeof Uint32Array){var r=new Uint32Array(n),i=0;for(t=512+t-(512+t&511);t<=e;t+=512)a(this,r.subarray(16*i,16*(i+1))),i+=1;n.splice(0,16*i)}else for(t=512+t-(512+t&511);t<=e;t+=512)a(this,n.splice(0,16));return this},finalize:function(){var e,t=this.o,n=this.u;for(e=(t=o.bitArray.concat(t,[o.bitArray.partial(1,1)])).length+2;15&e;e++)t.push(0);for(t.push(Math.floor(this.h/4294967296)),t.push(0|this.h);t.length;)a(this,t.splice(0,16));return this.reset(),n},K:[],b:[],G:function(){function e(e){return 4294967296*(e-Math.floor(e))|0}for(var t,n,r=0,o=2;64>r;o++){for(n=!0,t=2;t*t<=o;t++)if(0==o%t){n=!1;break}n&&(8>r&&(this.K[r]=e(Math.pow(o,.5))),this.b[r]=e(Math.pow(o,1/3)),r++)}}},o.prng=function(e){this.c=[new o.hash.sha256],this.i=[0],this.H=0,this.v={},this.F=0,this.J={},this.L=this.f=this.j=this.T=0,this.b=[0,0,0,0,0,0,0,0],this.g=[0,0,0,0],this.C=void 0,this.D=e,this.s=!1,this.B={progress:{},seeded:{}},this.m=this.S=0,this.w=1,this.A=2,this.O=65536,this.I=[0,48,64,96,128,192,256,384,512,768,1024],this.P=3e4,this.N=80},o.prng.prototype={randomWords:function(e,t){var n,r,i=[];if((n=this.isReady(t))===this.m)throw new o.exception.notReady("generator isn't seeded");if(n&this.A){n=!(n&this.w),r=[];var a,s=0;for(this.L=r[0]=(new Date).valueOf()+this.P,a=0;16>a;a++)r.push(4294967296*Math.random()|0);for(a=0;a<this.c.length&&(r=r.concat(this.c[a].finalize()),s+=this.i[a],this.i[a]=0,n||!(this.H&1<<a));a++);for(this.H>=1<<this.c.length&&(this.c.push(new o.hash.sha256),this.i.push(0)),this.f-=s,s>this.j&&(this.j=s),this.H++,this.b=o.hash.sha256.hash(this.b.concat(r)),this.C=new o.cipher.aes(this.b),n=0;4>n&&(this.g[n]=this.g[n]+1|0,!this.g[n]);n++);}for(n=0;n<e;n+=4)0==(n+1)%this.O&&c(this),r=u(this),i.push(r[0],r[1],r[2],r[3]);return c(this),i.slice(0,e)},setDefaultParanoia:function(e,t){if(0===e&&"Setting paranoia=0 will ruin your security; use it only for testing"!==t)throw new o.exception.invalid("Setting paranoia=0 will ruin your security; use it only for testing");this.D=e},addEntropy:function(e,t,n){n=n||"user";var r,i,a=(new Date).valueOf(),l=this.v[n],c=this.isReady(),u=0;switch(void 0===(r=this.J[n])&&(r=this.J[n]=this.T++),void 0===l&&(l=this.v[n]=0),this.v[n]=(this.v[n]+1)%this.c.length,typeof e){case"number":void 0===t&&(t=1),this.c[l].update([r,this.F++,1,t,a,1,0|e]);break;case"object":if("[object Uint32Array]"===(n=Object.prototype.toString.call(e))){for(i=[],n=0;n<e.length;n++)i.push(e[n]);e=i}else for("[object Array]"!==n&&(u=1),n=0;n<e.length&&!u;n++)"number"!=typeof e[n]&&(u=1);if(!u){if(void 0===t)for(n=t=0;n<e.length;n++)for(i=e[n];0<i;)t++,i>>>=1;this.c[l].update([r,this.F++,2,t,a,e.length].concat(e))}break;case"string":void 0===t&&(t=e.length),this.c[l].update([r,this.F++,3,t,a,e.length]),this.c[l].update(e);break;default:u=1}if(u)throw new o.exception.bug("random: addEntropy only supports number, array of numbers or string");this.i[l]+=t,this.f+=t,c===this.m&&(this.isReady()!==this.m&&s("seeded",Math.max(this.j,this.f)),s("progress",this.getProgress()))},isReady:function(e){return e=this.I[void 0!==e?e:this.D],this.j&&this.j>=e?this.i[0]>this.N&&(new Date).valueOf()>this.L?this.A|this.w:this.w:this.f>=e?this.A|this.m:this.m},getProgress:function(e){return e=this.I[e||this.D],this.j>=e||this.f>e?1:this.f/e},startCollectors:function(){if(!this.s){if(this.a={loadTimeCollector:d(this,this.V),mouseCollector:d(this,this.W),keyboardCollector:d(this,this.U),accelerometerCollector:d(this,this.R),touchCollector:d(this,this.X)},window.addEventListener)window.addEventListener("load",this.a.loadTimeCollector,!1),window.addEventListener("mousemove",this.a.mouseCollector,!1),window.addEventListener("keypress",this.a.keyboardCollector,!1),window.addEventListener("devicemotion",this.a.accelerometerCollector,!1),window.addEventListener("touchmove",this.a.touchCollector,!1);else{if(!document.attachEvent)throw new o.exception.bug("can't attach event");document.attachEvent("onload",this.a.loadTimeCollector),document.attachEvent("onmousemove",this.a.mouseCollector),document.attachEvent("keypress",this.a.keyboardCollector)}this.s=!0}},stopCollectors:function(){this.s&&(window.removeEventListener?(window.removeEventListener("load",this.a.loadTimeCollector,!1),window.removeEventListener("mousemove",this.a.mouseCollector,!1),window.removeEventListener("keypress",this.a.keyboardCollector,!1),window.removeEventListener("devicemotion",this.a.accelerometerCollector,!1),window.removeEventListener("touchmove",this.a.touchCollector,!1)):document.detachEvent&&(document.detachEvent("onload",this.a.loadTimeCollector),document.detachEvent("onmousemove",this.a.mouseCollector),document.detachEvent("keypress",this.a.keyboardCollector)),this.s=!1)},addEventListener:function(e,t){this.B[e][this.S++]=t},removeEventListener:function(e,t){var n,r,o=this.B[e],i=[];for(r in o)o.hasOwnProperty(r)&&o[r]===t&&i.push(r);for(n=0;n<i.length;n++)delete o[r=i[n]]},U:function(){l(this,1)},W:function(e){var t,n;try{t=e.x||e.clientX||e.offsetX||0,n=e.y||e.clientY||e.offsetY||0}catch(e){n=t=0}0!=t&&0!=n&&this.addEntropy([t,n],2,"mouse"),l(this,0)},X:function(e){e=e.touches[0]||e.changedTouches[0],this.addEntropy([e.pageX||e.clientX,e.pageY||e.clientY],1,"touch"),l(this,0)},V:function(){l(this,2)},R:function(e){if(e=e.accelerationIncludingGravity.x||e.accelerationIncludingGravity.y||e.accelerationIncludingGravity.z,window.orientation){var t=window.orientation;"number"==typeof t&&this.addEntropy(t,1,"accelerometer")}e&&this.addEntropy(e,2,"accelerometer"),l(this,0)}},o.random=new o.prng(6);e:try{var p,f,h,m;if(m=void 0!==n&&n.exports){var g;try{g=e("crypto")}catch(e){g=null}m=f=g}if(m&&f.randomBytes)p=f.randomBytes(128),p=new Uint32Array(new Uint8Array(p).buffer),o.random.addEntropy(p,1024,"crypto['randomBytes']");else if("undefined"!=typeof window&&"undefined"!=typeof Uint32Array){if(h=new Uint32Array(32),window.crypto&&window.crypto.getRandomValues)window.crypto.getRandomValues(h);else{if(!window.msCrypto||!window.msCrypto.getRandomValues)break e;window.msCrypto.getRandomValues(h)}o.random.addEntropy(h,1024,"crypto['getRandomValues']")}}catch(e){"undefined"!=typeof window&&window.console&&(console.log("There was an error collecting entropy from the browser:"),console.log(e))}void 0!==n&&n.exports&&(n.exports=o),"function"==typeof t&&t([],(function(){return o}))},{crypto:void 0}],101:[function(e,t,n){"use strict";var r=e("../lib/braintree-error");t.exports={GOOGLE_PAYMENT_NOT_ENABLED:{type:r.types.MERCHANT,code:"GOOGLE_PAYMENT_NOT_ENABLED",message:"Google Pay is not enabled for this merchant."},GOOGLE_PAYMENT_GATEWAY_ERROR:{code:"GOOGLE_PAYMENT_GATEWAY_ERROR",message:"There was an error when tokenizing the Google Pay payment method.",type:r.types.UNKNOWN},GOOGLE_PAYMENT_UNSUPPORTED_VERSION:{code:"GOOGLE_PAYMENT_UNSUPPORTED_VERSION",type:r.types.MERCHANT}}},{"../lib/braintree-error":124}],102:[function(e,t,n){"use strict";var r=e("../lib/analytics"),o=e("../lib/assign").assign,i=e("../lib/convert-methods-to-error"),a=e("../lib/find"),s=e("../lib/generate-google-pay-configuration"),l=e("../lib/braintree-error"),c=e("./errors"),u=e("../lib/methods"),d=e("@braintree/wrap-promise"),p={1:"_createV1PaymentDataRequest",2:"_createV2PaymentDataRequest"};function f(e){if(this._createPromise=e.createPromise,this._client=e.client,this._useDeferredClient=e.useDeferredClient,this._googlePayVersion=e.googlePayVersion||1,this._googleMerchantId=e.googleMerchantId,this._isUnsupportedGooglePayAPIVersion())throw new l({code:c.GOOGLE_PAYMENT_UNSUPPORTED_VERSION.code,message:"The Braintree SDK does not support Google Pay version "+this._googlePayVersion+". Please upgrade the version of your Braintree SDK and contact support if this error persists.",type:c.GOOGLE_PAYMENT_UNSUPPORTED_VERSION.type})}function h(e,t){Object.keys(t).forEach((function(n){"object"==typeof t[n]?e[n]=o({},t[n],e[n]):e[n]=e[n]||t[n]}))}f.prototype._waitForClient=function(){return this._client?Promise.resolve():this._createPromise.then(function(e){this._client=e}.bind(this))},f.prototype._isUnsupportedGooglePayAPIVersion=function(){return!(this._googlePayVersion in p)},f.prototype._getDefaultConfig=function(){return this._defaultConfig||(this._defaultConfig=s(this._client.getConfiguration(),this._googlePayVersion,this._googleMerchantId)),this._defaultConfig},f.prototype._createV1PaymentDataRequest=function(e){var t=this._getDefaultConfig(),n=e.cardRequirements&&e.cardRequirements.allowedCardNetworks,r=t.cardRequirements.allowedCardNetworks,i=n||r;return(e=o({},t,e)).cardRequirements.allowedCardNetworks=i,e},f.prototype._createV2PaymentDataRequest=function(e){var t=this._getDefaultConfig();return e.allowedPaymentMethods&&e.allowedPaymentMethods.forEach((function(e){var n=a(t.allowedPaymentMethods,"type",e.type);n&&h(e,n)})),e=o({},t,e)},f.prototype.createPaymentDataRequest=function(e){return this._useDeferredClient?this._waitForClient().then(function(){return this._createPaymentDataRequestSyncronously(e)}.bind(this)):this._createPaymentDataRequestSyncronously(e)},f.prototype._createPaymentDataRequestSyncronously=function(e){var t=o({},e),n=this._googlePayVersion,i=p[n];return r.sendEvent(this._createPromise,"google-payment.v"+n+".createPaymentDataRequest"),this[i](t)},f.prototype.parseResponse=function(e){var t=this;return Promise.resolve().then((function(){var n,o=2===e.apiVersion?e.paymentMethodData.tokenizationData.token:e.paymentMethodToken.token,i=JSON.parse(o),a=i.error;return a?Promise.reject(a):(r.sendEvent(t._createPromise,"google-payment.parseResponse.succeeded"),i.paypalAccounts?(n=i.paypalAccounts[0],r.sendEvent(t._createPromise,"google-payment.parseResponse.succeeded.paypal"),Promise.resolve({nonce:n.nonce,type:n.type,description:n.description})):(n=i.androidPayCards[0],r.sendEvent(t._createPromise,"google-payment.parseResponse.succeeded.google-payment"),Promise.resolve({nonce:n.nonce,type:n.type,description:n.description,details:{cardType:n.details.cardType,lastFour:n.details.lastFour,lastTwo:n.details.lastTwo,isNetworkTokenized:n.details.isNetworkTokenized,bin:n.details.bin},binData:n.binData})))})).catch((function(e){return r.sendEvent(t._createPromise,"google-payment.parseResponse.failed"),Promise.reject(new l({code:c.GOOGLE_PAYMENT_GATEWAY_ERROR.code,message:c.GOOGLE_PAYMENT_GATEWAY_ERROR.message,type:c.GOOGLE_PAYMENT_GATEWAY_ERROR.type,details:{originalError:e}}))}))},f.prototype.teardown=function(){return i(this,u(f.prototype)),Promise.resolve()},t.exports=d.wrapPrototype(f)},{"../lib/analytics":119,"../lib/assign":121,"../lib/braintree-error":124,"../lib/convert-methods-to-error":127,"../lib/find":137,"../lib/generate-google-pay-configuration":149,"../lib/methods":155,"./errors":101,"@braintree/wrap-promise":43}],103:[function(e,t,n){"use strict";var r=e("./google-payment"),o=e("../lib/braintree-error"),i=e("../lib/create-assets-url"),a=e("../lib/create-deferred-client"),s=e("../lib/basic-component-verification"),l=e("@braintree/wrap-promise"),c="3.102.0",u=e("./errors");function d(e){var t="Google Pay";return s.verify({name:t,client:e.client,authorization:e.authorization}).then((function(){var n,s;return n=a.create({authorization:e.authorization,client:e.client,debug:e.debug,assetsUrl:i.create(e.authorization),name:t}).then((function(t){var n=t.getConfiguration();return e.client=t,n.gatewayConfiguration.androidPay?t:Promise.reject(new o(u.GOOGLE_PAYMENT_NOT_ENABLED))})),e.createPromise=n,s=new r(e),e.useDeferredClient?s:n.then((function(e){return s._client=e,s}))}))}t.exports={create:l(d),VERSION:c}},{"../lib/basic-component-verification":122,"../lib/braintree-error":124,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./errors":101,"./google-payment":102,"@braintree/wrap-promise":43}],104:[function(e,t,n){"use strict";var r=e("../../lib/braintree-error"),o=e("../shared/errors"),i=e("../shared/constants").allowedAttributes;function a(e,t){var n;return i.hasOwnProperty(e)?null==t||s(e,t)||(n=new r({type:o.HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED.type,code:o.HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED.code,message:'Value "'+t+'" is not allowed for "'+e+'" attribute.'})):n=new r({type:o.HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED.type,code:o.HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED.code,message:'The "'+e+'" attribute is not supported in Hosted Fields.'}),n}function s(e,t){return"string"===i[e]?"string"==typeof t||"number"==typeof t:"boolean"===i[e]&&("true"===String(t)||"false"===String(t))}t.exports=a},{"../../lib/braintree-error":124,"../shared/constants":112,"../shared/errors":113}],105:[function(e,t,n){"use strict";var r=e("../shared/constants"),o=e("../../lib/use-min");t.exports=function(e,t,n){return e+"/web/"+r.VERSION+"/html/hosted-fields-frame"+o(n)+".html#"+t}},{"../../lib/use-min":160,"../shared/constants":112}],106:[function(e,t,n){"use strict";var r=e("../shared/constants").navigationDirections,o=e("../shared/browser-detection"),i=e("../shared/focus-intercept"),a=e("../shared/find-parent-tags"),s=["INPUT","SELECT","TEXTAREA"],l=["hidden","button","reset","submit","checkbox","radio","file"];function c(e){return o.hasSoftwareKeyboard()?s.indexOf(e.tagName)>-1&&l.indexOf(e.type)<0:"hidden"!==e.type}function u(e,t){switch(e){case r.BACK:return{checkIndexBounds:function(e){return e<0},indexChange:-1};case r.FORWARD:return{checkIndexBounds:function(e){return e>t-1},indexChange:1}}return{}}function d(e){var t,n;for(t=0;t<e.length;t++)if(c(n=e[t]))return n;return null}t.exports={removeExtraFocusElements:function(e,t){var n=Array.prototype.slice.call(e.elements);[d(n),d(n.reverse())].forEach((function(e){e&&i.matchFocusElement(e.getAttribute("id"))&&t(e.getAttribute("id"))}))},createFocusChangeHandler:function(e,t){return function(n){var r,o,s,l,d=document.getElementById("bt-"+n.field+"-"+n.direction+"-"+e);if(d)if(s=a(d,"form")[0],document.forms.length<1||!s)t.onRemoveFocusIntercepts();else{r=(s=[].slice.call(s.elements)).indexOf(d),l=u(n.direction,s.length);do{if(r+=l.indexChange,l.checkIndexBounds(r))return;o=s[r]}while(!c(o));i.matchFocusElement(o.getAttribute("id"))?t.onTriggerInputFocus(o.getAttribute("data-braintree-type")):o.focus()}}}}},{"../shared/browser-detection":111,"../shared/constants":112,"../shared/find-parent-tags":114,"../shared/focus-intercept":115}],107:[function(e,t,n){"use strict";var r=e("../shared/constants").allowedStyles;t.exports=function(e){var t,n=document.createElement("input"),o={};return"."===e[0]&&(e=e.substring(1)),n.className=e,n.style.display="none !important",n.style.position="fixed !important",n.style.left="-99999px !important",n.style.top="-99999px !important",document.body.appendChild(n),t=window.getComputedStyle(n),r.forEach((function(e){var n=t[e];n&&(o[e]=n)})),document.body.removeChild(n),o}},{"../shared/constants":112}],108:[function(e,t,n){"use strict";var r=e("../../lib/assign").assign,o=e("../../lib/create-assets-url"),i=e("../../lib/is-verified-domain"),a=e("../../lib/destructor"),s=e("@braintree/iframer"),l=e("framebus"),c=e("../../lib/create-deferred-client"),u=e("../../lib/braintree-error"),d=e("./compose-url"),p=e("./get-styles-from-class"),f=e("../shared/constants"),h=e("../shared/errors"),m=e("../../lib/constants").INTEGRATION_TIMEOUT_MS,g=e("@braintree/uuid"),v=e("../shared/find-parent-tags"),y=e("../shared/browser-detection"),b=f.events,_=e("@braintree/event-emitter"),A=e("./inject-frame"),E=e("../../lib/analytics"),w=f.allowedFields,x=e("../../lib/methods"),k=e("../../lib/shadow"),C=e("../../lib/find-root-node"),S=e("../../lib/convert-methods-to-error"),M=e("../../lib/errors"),T=e("../shared/get-card-types"),O=e("./attribute-validation-error"),D=e("@braintree/wrap-promise"),L=e("./focus-change"),P=e("../shared/focus-intercept").destroy,I=5;function B(e){return function(t){var n,r=t.merchantPayload,o=r.emittedBy,i=e[o].containerElement;Object.keys(r.fields).forEach((function(t){r.fields[t].container=e[t].containerElement})),n=r.fields[o],i.classList.toggle(f.externalClasses.FOCUSED,n.isFocused),i.classList.toggle(f.externalClasses.VALID,n.isValid),i.classList.toggle(f.externalClasses.INVALID,!n.isPotentiallyValid),this._state={cards:r.cards,fields:r.fields},this._emit(t.type,r)}}function R(e){var t=e.getBoundingClientRect(),n=Math.floor(t.height/2),r=Math.floor(t.width/2);return t.top<(window.innerHeight-n||document.documentElement.clientHeight-n)&&t.right>r&&t.bottom>n&&t.left<(window.innerWidth-r||document.documentElement.clientWidth-r)}function N(e){var t,n,v,y,w,C=this,O={},D={},I=[],R=g();if(this._merchantConfigurationOptions=r({},e),e.client?(v=(n=e.client.getConfiguration()).gatewayConfiguration.assetsUrl,y=n.isDebug):(v=o.create(e.authorization),y=Boolean(e.isDebug)),this._clientPromise=c.create({client:e.client,authorization:e.authorization,debug:y,assetsUrl:v,name:"Hosted Fields"}),w=d(v,R,y),!e.fields||0===Object.keys(e.fields).length)throw new u({type:M.INSTANTIATION_OPTION_REQUIRED.type,code:M.INSTANTIATION_OPTION_REQUIRED.code,message:"options.fields is required when instantiating Hosted Fields."});_.call(this),this._injectedNodes=[],this._destructor=new a,this._fields=O,this._state={fields:{},cards:T("")},this._bus=new l({channel:R,verifyDomain:i,targetFrames:[window]}),this._destructor.registerFunctionForTeardown((function(){C._bus.teardown()})),e.client?E.sendEvent(this._clientPromise,"custom.hosted-fields.initialized"):E.sendEvent(this._clientPromise,"custom.hosted-fields.initialized.deferred-client"),Object.keys(e.fields).forEach(function(t){var n,r,o,i,a;if(!f.allowedFields.hasOwnProperty(t))throw new u({type:h.HOSTED_FIELDS_INVALID_FIELD_KEY.type,code:h.HOSTED_FIELDS_INVALID_FIELD_KEY.code,message:'"'+t+'" is not a valid field.'});if("string"==typeof(r=(n=e.fields[t]).container||n.selector)&&(r=document.querySelector(r)),!r||1!==r.nodeType)throw new u({type:h.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.type,code:h.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.code,message:h.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.message,details:{fieldSelector:n.selector,fieldContainer:n.container,fieldKey:t}});if(r.querySelector('iframe[name^="braintree-"]'))throw new u({type:h.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.type,code:h.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.code,message:h.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.message,details:{fieldSelector:n.selector,fieldContainer:n.container,fieldKey:t}});if(o=r,k.isShadowElement(o)&&(o=k.transformToSlot(o,"height: 100%")),n.maxlength&&"number"!=typeof n.maxlength)throw new u({type:h.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.type,code:h.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.code,message:"The value for maxlength must be a number.",details:{fieldKey:t}});if(n.minlength&&"number"!=typeof n.minlength)throw new u({type:h.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.type,code:h.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.code,message:"The value for minlength must be a number.",details:{fieldKey:t}});i=s({type:t,name:"braintree-hosted-field-"+t,style:f.defaultIFrameStyle,title:n.iframeTitle||"Secure Credit Card Frame - "+f.allowedFields[t].label}),this._bus.addTargetFrame(i),this._injectedNodes.push.apply(this._injectedNodes,A(R,i,o,(function(){C.focus(t)}))),this._setupLabelFocus(t,r),O[t]={frameElement:i,containerElement:r},a=new Promise((function(e){D[t]=e})),I.push(a),this._state.fields[t]={isEmpty:!0,isValid:!1,isPotentiallyValid:!0,isFocused:!1,container:r},setTimeout((function(){i.src=w}),0)}.bind(this)),this._merchantConfigurationOptions.styles&&Object.keys(this._merchantConfigurationOptions.styles).forEach((function(e){var t=C._merchantConfigurationOptions.styles[e];"string"==typeof t&&(C._merchantConfigurationOptions.styles[e]=p(t))})),this._bus.on(b.REMOVE_FOCUS_INTERCEPTS,(function(e){P(e&&e.id)})),this._bus.on(b.TRIGGER_FOCUS_CHANGE,L.createFocusChangeHandler(R,{onRemoveFocusIntercepts:function(e){C._bus.emit(b.REMOVE_FOCUS_INTERCEPTS,{id:e})},onTriggerInputFocus:function(e){C.focus(e)}})),this._bus.on(b.READY_FOR_CLIENT,(function(e){C._clientPromise.then((function(t){e(t)}))})),this._bus.on(b.CARD_FORM_ENTRY_HAS_BEGUN,(function(){E.sendEvent(C._clientPromise,"hosted-fields.input.started")})),this._bus.on(b.BIN_AVAILABLE,(function(e){C._emit("binAvailable",{bin:e})})),t=setTimeout((function(){E.sendEvent(C._clientPromise,"custom.hosted-fields.load.timed-out"),C._emit("timeout")}),m),Promise.all(I).then((function(e){var n=e[0];clearTimeout(t),n(F(C._merchantConfigurationOptions)),C._cleanUpFocusIntercepts(),C._emit("ready")})),this._bus.on(b.FRAME_READY,(function(e,t){D[e.field](t)})),this._bus.on(b.INPUT_EVENT,B(O).bind(this)),this._destructor.registerFunctionForTeardown((function(){var e,t,n;for(e=0;e<C._injectedNodes.length;e++)(n=(t=C._injectedNodes[e]).parentNode).removeChild(t),n.classList.remove(f.externalClasses.FOCUSED,f.externalClasses.INVALID,f.externalClasses.VALID)})),this._destructor.registerFunctionForTeardown((function(){P()})),this._destructor.registerFunctionForTeardown((function(){var e=x(N.prototype).concat(x(_.prototype));S(C,e)}))}function F(e){var t=r({},e);return t.fields=r({},t.fields),Object.keys(t.fields).forEach((function(e){t.fields[e]=r({},t.fields[e]),delete t.fields[e].container})),t}_.createChild(N),N.prototype._setupLabelFocus=function(e,t){var n,r,o=this,i=C(t);if(null!=t.id){for(n=Array.prototype.slice.call(document.querySelectorAll('label[for="'+t.id+'"]')),i!==document&&(n=n.concat(Array.prototype.slice.call(i.querySelectorAll('label[for="'+t.id+'"]')))),n=(n=n.concat(v(t,"label"))).filter((function(e,t,n){return n.indexOf(e)===t})),r=0;r<n.length;r++)n[r].addEventListener("click",a,!1);this._destructor.registerFunctionForTeardown((function(){for(r=0;r<n.length;r++)n[r].removeEventListener("click",a,!1)}))}function a(){o.focus(e)}},N.prototype._getAnyFieldContainer=function(){var e=this;return Object.keys(this._fields).reduce((function(t,n){return t||e._fields[n].containerElement}),null)},N.prototype._cleanUpFocusIntercepts=function(){var e,t;document.forms.length<1?this._bus.emit(b.REMOVE_FOCUS_INTERCEPTS):(e=this._getAnyFieldContainer(),(t=v(e,"form")[0])?L.removeExtraFocusElements(t,function(e){this._bus.emit(b.REMOVE_FOCUS_INTERCEPTS,{id:e})}.bind(this)):this._bus.emit(b.REMOVE_FOCUS_INTERCEPTS))},N.prototype._attachInvalidFieldContainersToError=function(e){e.details&&e.details.invalidFieldKeys&&e.details.invalidFieldKeys.length>0&&(e.details.invalidFields={},e.details.invalidFieldKeys.forEach(function(t){e.details.invalidFields[t]=this._fields[t].containerElement}.bind(this)))},N.prototype.getChallenges=function(){return this._clientPromise.then((function(e){return e.getConfiguration().gatewayConfiguration.challenges}))},N.prototype.getSupportedCardTypes=function(){return this._clientPromise.then((function(e){return e.getConfiguration().gatewayConfiguration.creditCards.supportedCardTypes.map((function(e){return"MasterCard"===e?"Mastercard":e}))}))},N.prototype.teardown=function(){var e=this;return new Promise((function(t,n){e._destructor.teardown((function(r){E.sendEvent(e._clientPromise,"custom.hosted-fields.teardown-completed"),r?n(r):t()}))}))},N.prototype.tokenize=function(e){var t=this;return e||(e={}),new Promise((function(n,r){t._bus.emit(b.TOKENIZATION_REQUEST,e,(function(e){var o=e[0],i=e[1];o?(t._attachInvalidFieldContainersToError(o),r(new u(o))):n(i)}))}))},N.prototype.addClass=function(e,t){var n;return w.hasOwnProperty(e)?this._fields.hasOwnProperty(e)?this._bus.emit(b.ADD_CLASS,{field:e,classname:t}):n=new u({type:h.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,code:h.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,message:'Cannot add class to "'+e+'" field because it is not part of the current Hosted Fields options.'}):n=new u({type:h.HOSTED_FIELDS_FIELD_INVALID.type,code:h.HOSTED_FIELDS_FIELD_INVALID.code,message:'"'+e+'" is not a valid field. You must use a valid field option when adding a class.'}),n?Promise.reject(n):Promise.resolve()},N.prototype.removeClass=function(e,t){var n;return w.hasOwnProperty(e)?this._fields.hasOwnProperty(e)?this._bus.emit(b.REMOVE_CLASS,{field:e,classname:t}):n=new u({type:h.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,code:h.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,message:'Cannot remove class from "'+e+'" field because it is not part of the current Hosted Fields options.'}):n=new u({type:h.HOSTED_FIELDS_FIELD_INVALID.type,code:h.HOSTED_FIELDS_FIELD_INVALID.code,message:'"'+e+'" is not a valid field. You must use a valid field option when removing a class.'}),n?Promise.reject(n):Promise.resolve()},N.prototype.setAttribute=function(e){var t,n;return w.hasOwnProperty(e.field)?this._fields.hasOwnProperty(e.field)?(t=O(e.attribute,e.value))?n=t:this._bus.emit(b.SET_ATTRIBUTE,{field:e.field,attribute:e.attribute,value:e.value}):n=new u({type:h.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,code:h.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,message:'Cannot set attribute for "'+e.field+'" field because it is not part of the current Hosted Fields options.'}):n=new u({type:h.HOSTED_FIELDS_FIELD_INVALID.type,code:h.HOSTED_FIELDS_FIELD_INVALID.code,message:'"'+e.field+'" is not a valid field. You must use a valid field option when setting an attribute.'}),n?Promise.reject(n):Promise.resolve()},N.prototype.setMonthOptions=function(e){var t,n=this,r=this._merchantConfigurationOptions.fields;return r.expirationMonth?r.expirationMonth.select||(t="Expiration month field must be a select element."):t="Expiration month field must exist to use setMonthOptions.",t?Promise.reject(new u({type:h.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.type,code:h.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.code,message:t})):new Promise((function(t){n._bus.emit(b.SET_MONTH_OPTIONS,e,t)}))},N.prototype.setMessage=function(e){this._bus.emit(b.SET_MESSAGE,{field:e.field,message:e.message})},N.prototype.removeAttribute=function(e){var t,n;return w.hasOwnProperty(e.field)?this._fields.hasOwnProperty(e.field)?(t=O(e.attribute))?n=t:this._bus.emit(b.REMOVE_ATTRIBUTE,{field:e.field,attribute:e.attribute}):n=new u({type:h.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,code:h.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,message:'Cannot remove attribute for "'+e.field+'" field because it is not part of the current Hosted Fields options.'}):n=new u({type:h.HOSTED_FIELDS_FIELD_INVALID.type,code:h.HOSTED_FIELDS_FIELD_INVALID.code,message:'"'+e.field+'" is not a valid field. You must use a valid field option when removing an attribute.'}),n?Promise.reject(n):Promise.resolve()},N.prototype.setPlaceholder=function(e,t){return this.setAttribute({field:e,attribute:"placeholder",value:t})},N.prototype.clear=function(e){var t;return w.hasOwnProperty(e)?this._fields.hasOwnProperty(e)?this._bus.emit(b.CLEAR_FIELD,{field:e}):t=new u({type:h.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,code:h.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,message:'Cannot clear "'+e+'" field because it is not part of the current Hosted Fields options.'}):t=new u({type:h.HOSTED_FIELDS_FIELD_INVALID.type,code:h.HOSTED_FIELDS_FIELD_INVALID.code,message:'"'+e+'" is not a valid field. You must use a valid field option when clearing a field.'}),t?Promise.reject(t):Promise.resolve()},N.prototype.focus=function(e){var t,n=this._fields[e];return w.hasOwnProperty(e)?this._fields.hasOwnProperty(e)?(n.frameElement.focus(),this._bus.emit(b.TRIGGER_INPUT_FOCUS,{field:e}),y.isIos()&&setTimeout((function(){R(n.containerElement)||n.containerElement.scrollIntoView()}),I)):t=new u({type:h.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,code:h.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,message:'Cannot focus "'+e+'" field because it is not part of the current Hosted Fields options.'}):t=new u({type:h.HOSTED_FIELDS_FIELD_INVALID.type,code:h.HOSTED_FIELDS_FIELD_INVALID.code,message:'"'+e+'" is not a valid field. You must use a valid field option when focusing a field.'}),t?Promise.reject(t):Promise.resolve()},N.prototype.getState=function(){return this._state},t.exports=D.wrapPrototype(N)},{"../../lib/analytics":119,"../../lib/assign":121,"../../lib/braintree-error":124,"../../lib/constants":126,"../../lib/convert-methods-to-error":127,"../../lib/create-assets-url":129,"../../lib/create-deferred-client":131,"../../lib/destructor":133,"../../lib/errors":135,"../../lib/find-root-node":136,"../../lib/is-verified-domain":153,"../../lib/methods":155,"../../lib/shadow":158,"../shared/browser-detection":111,"../shared/constants":112,"../shared/errors":113,"../shared/find-parent-tags":114,"../shared/focus-intercept":115,"../shared/get-card-types":116,"./attribute-validation-error":104,"./compose-url":105,"./focus-change":106,"./get-styles-from-class":107,"./inject-frame":109,"@braintree/event-emitter":33,"@braintree/iframer":35,"@braintree/uuid":39,"@braintree/wrap-promise":43,framebus:52}],109:[function(e,t,n){"use strict";var r=e("../shared/focus-intercept"),o=e("../shared/constants").navigationDirections;t.exports=function(e,t,n,i){var a=t.getAttribute("type"),s=document.createElement("div"),l=document.createDocumentFragment(),c=r.generate(e,a,o.BACK,i),u=r.generate(e,a,o.FORWARD,i);return s.style.clear="both",l.appendChild(c),l.appendChild(t),l.appendChild(u),l.appendChild(s),n.appendChild(l),[t,s]}},{"../shared/constants":112,"../shared/focus-intercept":115}],110:[function(e,t,n){"use strict";var r=e("./external/hosted-fields"),o=e("../lib/basic-component-verification"),i=e("./shared/errors"),a=e("restricted-input/supports-input-formatting"),s=e("@braintree/wrap-promise"),l=e("../lib/braintree-error"),c="3.102.0";function u(e){return o.verify({name:"Hosted Fields",authorization:e.authorization,client:e.client}).then((function(){var t=new r(e);return new Promise((function(e,n){t.on("ready",(function(){e(t)})),t.on("timeout",(function(){n(new l(i.HOSTED_FIELDS_TIMEOUT))}))}))}))}t.exports={supportsInputFormatting:a,create:s(u),VERSION:c}},{"../lib/basic-component-verification":122,"../lib/braintree-error":124,"./external/hosted-fields":108,"./shared/errors":113,"@braintree/wrap-promise":43,"restricted-input/supports-input-formatting":71}],111:[function(e,t,n){"use strict";var r=e("@braintree/browser-detection/is-android"),o=e("@braintree/browser-detection/is-chrome-os"),i=e("@braintree/browser-detection/is-ios"),a=e("@braintree/browser-detection/is-chrome");function s(){return r()||o()||i()}function l(){return a()&&i()}t.exports={isAndroid:r,isChromeOS:o,isChromeIos:l,isFirefox:e("@braintree/browser-detection/is-firefox"),isIos:i,isIosWebview:e("@braintree/browser-detection/is-ios-webview"),hasSoftwareKeyboard:s}},{"@braintree/browser-detection/is-android":22,"@braintree/browser-detection/is-chrome":24,"@braintree/browser-detection/is-chrome-os":23,"@braintree/browser-detection/is-firefox":25,"@braintree/browser-detection/is-ios":30,"@braintree/browser-detection/is-ios-webview":28}],112:[function(e,t,n){"use strict";var r=e("../../lib/enumerate"),o=e("./errors"),i={VERSION:"3.102.0",maxExpirationYearAge:19,externalEvents:{FOCUS:"focus",BLUR:"blur",EMPTY:"empty",NOT_EMPTY:"notEmpty",VALIDITY_CHANGE:"validityChange",CARD_TYPE_CHANGE:"cardTypeChange"},defaultMaxLengths:{number:19,postalCode:8,expirationDate:7,expirationMonth:2,expirationYear:4,cvv:3},externalClasses:{FOCUSED:"braintree-hosted-fields-focused",INVALID:"braintree-hosted-fields-invalid",VALID:"braintree-hosted-fields-valid"},navigationDirections:{BACK:"before",FORWARD:"after"},defaultIFrameStyle:{border:"none",width:"100%",height:"100%",float:"left"},tokenizationErrorCodes:{81724:o.HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE,81736:o.HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED},allowedStyles:["-moz-appearance","-moz-box-shadow","-moz-osx-font-smoothing","-moz-tap-highlight-color","-moz-transition","-webkit-appearance","-webkit-box-shadow","-webkit-font-smoothing","-webkit-tap-highlight-color","-webkit-transition","appearance","box-shadow","color","direction","font","font-family","font-size","font-size-adjust","font-stretch","font-style","font-variant","font-variant-alternates","font-variant-caps","font-variant-east-asian","font-variant-ligatures","font-variant-numeric","font-weight","letter-spacing","line-height","margin","margin-top","margin-right","margin-bottom","margin-left","opacity","outline","padding","padding-top","padding-right","padding-bottom","padding-left","text-align","text-shadow","transition"],allowedFields:{cardholderName:{name:"cardholder-name",label:"Cardholder Name"},number:{name:"credit-card-number",label:"Credit Card Number"},cvv:{name:"cvv",label:"CVV"},expirationDate:{name:"expiration",label:"Expiration Date"},expirationMonth:{name:"expiration-month",label:"Expiration Month"},expirationYear:{name:"expiration-year",label:"Expiration Year"},postalCode:{name:"postal-code",label:"Postal Code"}},allowedAttributes:{"aria-invalid":"boolean","aria-required":"boolean",disabled:"boolean",placeholder:"string"},autocompleteMappings:{"cardholder-name":"cc-name","credit-card-number":"cc-number",expiration:"cc-exp","expiration-month":"cc-exp-month","expiration-year":"cc-exp-year",cvv:"cc-csc","postal-code":"billing postal-code"}};i.events=r(["ADD_CLASS","AUTOFILL_DATA_AVAILABLE","BIN_AVAILABLE","CARD_FORM_ENTRY_HAS_BEGUN","CLEAR_FIELD","CONFIGURATION","FRAME_READY","INPUT_EVENT","READY_FOR_CLIENT","REMOVE_ATTRIBUTE","REMOVE_CLASS","REMOVE_FOCUS_INTERCEPTS","SET_ATTRIBUTE","SET_MESSAGE","SET_MONTH_OPTIONS","TOKENIZATION_REQUEST","TRIGGER_FOCUS_CHANGE","TRIGGER_INPUT_FOCUS","VALIDATE_STRICT"],"hosted-fields:"),t.exports=i},{"../../lib/enumerate":134,"./errors":113}],113:[function(e,t,n){"use strict";var r=e("../../lib/braintree-error");t.exports={HOSTED_FIELDS_TIMEOUT:{type:r.types.UNKNOWN,code:"HOSTED_FIELDS_TIMEOUT",message:"Hosted Fields timed out when attempting to set up."},HOSTED_FIELDS_INVALID_FIELD_KEY:{type:r.types.MERCHANT,code:"HOSTED_FIELDS_INVALID_FIELD_KEY"},HOSTED_FIELDS_INVALID_FIELD_SELECTOR:{type:r.types.MERCHANT,code:"HOSTED_FIELDS_INVALID_FIELD_SELECTOR",message:"Selector does not reference a valid DOM node."},HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME:{type:r.types.MERCHANT,code:"HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME",message:"Element already contains a Braintree iframe."},HOSTED_FIELDS_FIELD_INVALID:{type:r.types.MERCHANT,code:"HOSTED_FIELDS_FIELD_INVALID"},HOSTED_FIELDS_FIELD_NOT_PRESENT:{type:r.types.MERCHANT,code:"HOSTED_FIELDS_FIELD_NOT_PRESENT"},HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR:{type:r.types.NETWORK,code:"HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR",message:"A tokenization network error occurred."},HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE:{type:r.types.CUSTOMER,code:"HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE",message:"This credit card already exists in the merchant's vault."},HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED:{type:r.types.CUSTOMER,code:"HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED",message:"CVV verification failed during tokenization."},HOSTED_FIELDS_FAILED_TOKENIZATION:{type:r.types.CUSTOMER,code:"HOSTED_FIELDS_FAILED_TOKENIZATION",message:"The supplied card data failed tokenization."},HOSTED_FIELDS_FIELDS_EMPTY:{type:r.types.CUSTOMER,code:"HOSTED_FIELDS_FIELDS_EMPTY",message:"All fields are empty. Cannot tokenize empty card fields."},HOSTED_FIELDS_FIELDS_INVALID:{type:r.types.CUSTOMER,code:"HOSTED_FIELDS_FIELDS_INVALID",message:"Some payment input fields are invalid. Cannot tokenize invalid card fields."},HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED:{type:r.types.MERCHANT,code:"HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED"},HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED:{type:r.types.MERCHANT,code:"HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED"},HOSTED_FIELDS_FIELD_PROPERTY_INVALID:{type:r.types.MERCHANT,code:"HOSTED_FIELDS_FIELD_PROPERTY_INVALID"}}},{"../../lib/braintree-error":124}],114:[function(e,t,n){"use strict";function r(e,t){for(var n=e.parentNode,r=[];null!=n;)null!=n.tagName&&n.tagName.toLowerCase()===t&&r.push(n),n=n.parentNode;return r}t.exports=r},{}],115:[function(e,t,n){"use strict";var r=e("./browser-detection"),o=e("./constants"),i=Object.keys(o.allowedFields),a=o.navigationDirections,s={generate:function(e,t,n,o){var i=document.createElement("input"),a={border:"none !important",display:"block !important",height:"1px !important",left:"-1px !important",opacity:"0 !important",position:"absolute !important",top:"-1px !important",width:"1px !important"};return r.hasSoftwareKeyboard()||r.isFirefox()?(i.setAttribute("aria-hidden","true"),i.setAttribute("autocomplete","off"),i.setAttribute("data-braintree-direction",n),i.setAttribute("data-braintree-type",t),i.setAttribute("id","bt-"+t+"-"+n+"-"+e),i.setAttribute("style",JSON.stringify(a).replace(/[{}"]/g,"").replace(/,/g,";")),i.classList.add("focus-intercept"),i.addEventListener("focus",(function(e){o(e),r.hasSoftwareKeyboard()||i.blur()})),i):document.createDocumentFragment()},destroy:function(e){var t;e?t=[document.getElementById(e)]:(t=document.querySelectorAll("[data-braintree-direction]"),t=[].slice.call(t)),t.forEach((function(e){e&&1===e.nodeType&&s.matchFocusElement(e.getAttribute("id"))&&e.parentNode.removeChild(e)}))},matchFocusElement:function(e){var t,n,r,o;return!!e&&!((t=e.split("-")).length<4)&&(n="bt"===t[0],r=i.indexOf(t[1])>-1,o=t[2]===a.BACK||t[2]===a.FORWARD,Boolean(n&&r&&o))}};t.exports=s},{"./browser-detection":111,"./constants":112}],116:[function(e,t,n){"use strict";var r=e("credit-card-type");t.exports=function(e){var t=r(e);return t.forEach((function(e){"mastercard"===e.type&&(e.type="master-card")})),t}},{"credit-card-type":44}],117:[function(e,t,n){"use strict";var r=e("./american-express"),o=e("./apple-pay"),i=e("./client"),a=e("./data-collector"),s=e("./hosted-fields"),l=e("./local-payment"),c=e("./masterpass"),u=e("./payment-request"),d=e("./paypal"),p=e("./paypal-checkout"),f=e("./google-payment"),h=e("./sepa"),m=e("./three-d-secure"),g=e("./unionpay"),v=e("./us-bank-account"),y=e("./vault-manager"),b=e("./venmo"),_=e("./visa-checkout"),A=e("./preferred-payment-methods"),E="3.102.0";t.exports={americanExpress:r,applePay:o,client:i,dataCollector:a,hostedFields:s,localPayment:l,masterpass:c,googlePayment:f,paymentRequest:u,paypal:d,paypalCheckout:p,threeDSecure:m,unionpay:g,usBankAccount:v,vaultManager:y,venmo:b,visaCheckout:_,sepa:h,preferredPaymentMethods:A,VERSION:E}},{"./american-express":74,"./apple-pay":77,"./client":82,"./data-collector":98,"./google-payment":103,"./hosted-fields":110,"./local-payment":164,"./masterpass":167,"./payment-request":172,"./paypal":179,"./paypal-checkout":176,"./preferred-payment-methods":182,"./sepa":186,"./three-d-secure":198,"./unionpay":202,"./us-bank-account":208,"./vault-manager":211,"./venmo":216,"./visa-checkout":226}],118:[function(e,t,n){"use strict";var r=e("./create-authorization-data"),o=e("./json-clone"),i=e("./constants");function a(e,t){var n,a=t?o(t):{},s=r(e.authorization).attrs,l=o(e.analyticsMetadata);for(n in a.braintreeLibraryVersion=i.BRAINTREE_LIBRARY_VERSION,a._meta)a._meta.hasOwnProperty(n)&&(l[n]=a._meta[n]);return a._meta=l,s.tokenizationKey?a.tokenizationKey=s.tokenizationKey:a.authorizationFingerprint=s.authorizationFingerprint,a}t.exports=a},{"./constants":126,"./create-authorization-data":130,"./json-clone":154}],119:[function(e,t,n){"use strict";var r=e("./constants"),o=e("./add-metadata");function i(e,t,n){var i=Date.now();return Promise.resolve(e).then((function(e){var a=Date.now(),s=e.getConfiguration(),l=e._request,c=s.gatewayConfiguration.analytics.url,u={analytics:[{kind:r.ANALYTICS_PREFIX+t,isAsync:Math.floor(a/1e3)!==Math.floor(i/1e3),timestamp:i}]};l({url:c,method:"post",data:o(s,u),timeout:r.ANALYTICS_REQUEST_TIMEOUT_MS},n)})).catch((function(e){n&&n(e)}))}t.exports={sendEvent:i}},{"./add-metadata":118,"./constants":126}],120:[function(e,t,n){"use strict";var r=e("@braintree/asset-loader/load-script");t.exports={loadScript:r}},{"@braintree/asset-loader/load-script":3}],121:[function(e,t,n){"use strict";var r="function"==typeof Object.assign?Object.assign:o;function o(e){var t,n,r;for(t=1;t<arguments.length;t++)for(r in n=arguments[t])n.hasOwnProperty(r)&&(e[r]=n[r]);return e}t.exports={assign:r,_assign:o}},{}],122:[function(e,t,n){"use strict";var r=e("./braintree-error"),o=e("./errors"),i="3.102.0";function a(e){var t,n,a;return e?(a=e.name,t=e.client,n=e.authorization,t||n?n||t.getVersion()===i?Promise.resolve():Promise.reject(new r({type:o.INCOMPATIBLE_VERSIONS.type,code:o.INCOMPATIBLE_VERSIONS.code,message:"Client (version "+t.getVersion()+") and "+a+" (version "+i+") components must be from the same SDK version."})):Promise.reject(new r({type:o.INSTANTIATION_OPTION_REQUIRED.type,code:o.INSTANTIATION_OPTION_REQUIRED.code,message:"options.client is required when instantiating "+a+"."}))):Promise.reject(new r({type:o.INVALID_USE_OF_INTERNAL_FUNCTION.type,code:o.INVALID_USE_OF_INTERNAL_FUNCTION.code,message:"Options must be passed to basicComponentVerification function."}))}t.exports={verify:a}},{"./braintree-error":124,"./errors":135}],123:[function(e,t,n){"use strict";var r=e("./once");function o(e,t){0===e.length?(e(),t(null)):e(t)}t.exports=function(e,t){var n,i=e.length,a=i,s=r(t);if(0!==i)for(n=0;n<i;n++)o(e[n],l);else s(null);function l(e){e?s(e):0==(a-=1)&&s(null)}}},{"./once":156}],124:[function(e,t,n){"use strict";var r=e("./enumerate");function o(e){if(!o.types.hasOwnProperty(e.type))throw new Error(e.type+" is not a valid type.");if(!e.code)throw new Error("Error code required.");if(!e.message)throw new Error("Error message required.");this.name="BraintreeError",this.code=e.code,this.message=e.message,this.type=e.type,this.details=e.details}o.prototype=Object.create(Error.prototype),o.prototype.constructor=o,o.types=r(["CUSTOMER","MERCHANT","NETWORK","INTERNAL","UNKNOWN"]),o.findRootError=function(e){return e instanceof o&&e.details&&e.details.originalError?o.findRootError(e.details.originalError):e},t.exports=o},{"./enumerate":134}],125:[function(e,t,n){"use strict";function r(e){return e.replace(/([a-z\d])([A-Z])/g,"$1_$2").replace(/([A-Z]+)([A-Z][a-z\d]+)/g,"$1_$2").toLowerCase()}t.exports=function(e){return Object.keys(e).reduce((function(t,n){return t[r(n)]=e[n],t}),{})}},{}],126:[function(e,t,n){"use strict";var r="3.102.0",o="web",i={production:"https://api.braintreegateway.com:443",sandbox:"https://api.sandbox.braintreegateway.com:443"},a={production:"https://assets.braintreegateway.com",sandbox:"https://assets.braintreegateway.com"},s={production:"https://payments.braintree-api.com/graphql",sandbox:"https://payments.sandbox.braintree-api.com/graphql"};t.exports={ANALYTICS_PREFIX:o+".",ANALYTICS_REQUEST_TIMEOUT_MS:2e3,ASSETS_URLS:a,CLIENT_API_URLS:i,FRAUDNET_SOURCE:"BRAINTREE_SIGNIN",FRAUDNET_FNCLS:"fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99",FRAUDNET_URL:"https://c.paypal.com/da/r/fb.js",BUS_CONFIGURATION_REQUEST_EVENT:"BUS_CONFIGURATION_REQUEST",GRAPHQL_URLS:s,INTEGRATION_TIMEOUT_MS:6e4,VERSION:r,INTEGRATION:"custom",SOURCE:"client",PLATFORM:o,BRAINTREE_LIBRARY_VERSION:"braintree/"+o+"/"+r}},{}],127:[function(e,t,n){"use strict";var r=e("./braintree-error"),o=e("./errors");t.exports=function(e,t){t.forEach((function(t){e[t]=function(){throw new r({type:o.METHOD_CALLED_AFTER_TEARDOWN.type,code:o.METHOD_CALLED_AFTER_TEARDOWN.code,message:t+" cannot be called after teardown."})}}))}},{"./braintree-error":124,"./errors":135}],128:[function(e,t,n){"use strict";var r=e("./braintree-error");function o(e,t){return e instanceof r?e:new r({type:t.type,code:t.code,message:t.message,details:{originalError:e}})}t.exports=o},{"./braintree-error":124}],129:[function(e,t,n){"use strict";var r=e("./constants").ASSETS_URLS;function o(e){return r.production}t.exports={create:o}},{"./constants":126}],130:[function(e,t,n){"use strict";var r=e("../lib/vendor/polyfill").atob,o=e("../lib/constants").CLIENT_API_URLS;function i(e){return/^[a-zA-Z0-9]+_[a-zA-Z0-9]+_[a-zA-Z0-9_]+$/.test(e)}function a(e){var t=e.split("_"),n=t[0];return{merchantId:t.slice(2).join("_"),environment:n}}function s(e){var t,n,s={attrs:{},configUrl:""};return i(e)?(n=a(e),s.environment=n.environment,s.attrs.tokenizationKey=e,s.configUrl=o[n.environment]+"/merchants/"+n.merchantId+"/client_api/v1/configuration"):(t=JSON.parse(r(e)),s.environment=t.environment,s.attrs.authorizationFingerprint=t.authorizationFingerprint,s.configUrl=t.configUrl,s.graphQL=t.graphQL),s}t.exports=s},{"../lib/constants":126,"../lib/vendor/polyfill":161}],131:[function(e,t,n){"use strict";var r=e("./braintree-error"),o=e("./assets"),i=e("./errors"),a="3.102.0";function s(e){var t=Promise.resolve();return e.client?Promise.resolve(e.client):(window.braintree&&window.braintree.client||(t=o.loadScript({src:e.assetsUrl+"/web/"+a+"/js/client.min.js"}).catch((function(e){return Promise.reject(new r({type:i.CLIENT_SCRIPT_FAILED_TO_LOAD.type,code:i.CLIENT_SCRIPT_FAILED_TO_LOAD.code,message:i.CLIENT_SCRIPT_FAILED_TO_LOAD.message,details:{originalError:e}}))}))),t.then((function(){return window.braintree.client.VERSION!==a?Promise.reject(new r({type:i.INCOMPATIBLE_VERSIONS.type,code:i.INCOMPATIBLE_VERSIONS.code,message:"Client (version "+window.braintree.client.VERSION+") and "+e.name+" (version "+a+") components must be from the same SDK version."})):window.braintree.client.create({authorization:e.authorization,debug:e.debug})})))}t.exports={create:s}},{"./assets":120,"./braintree-error":124,"./errors":135}],132:[function(e,t,n){"use strict";t.exports=function(e){return function(){var t=arguments;setTimeout((function(){e.apply(null,t)}),1)}}},{}],133:[function(e,t,n){"use strict";var r=e("./batch-execute-functions");function o(){this._teardownRegistry=[],this._isTearingDown=!1}o.prototype.registerFunctionForTeardown=function(e){"function"==typeof e&&this._teardownRegistry.push(e)},o.prototype.teardown=function(e){this._isTearingDown?e(new Error("Destructor is already tearing down")):(this._isTearingDown=!0,r(this._teardownRegistry,function(t){this._teardownRegistry=[],this._isTearingDown=!1,"function"==typeof e&&e(t)}.bind(this)))},t.exports=o},{"./batch-execute-functions":123}],134:[function(e,t,n){"use strict";function r(e,t){return t=null==t?"":t,e.reduce((function(e,n){return e[n]=t+n,e}),{})}t.exports=r},{}],135:[function(e,t,n){"use strict";var r=e("./braintree-error");t.exports={INVALID_USE_OF_INTERNAL_FUNCTION:{type:r.types.INTERNAL,code:"INVALID_USE_OF_INTERNAL_FUNCTION"},INSTANTIATION_OPTION_REQUIRED:{type:r.types.MERCHANT,code:"INSTANTIATION_OPTION_REQUIRED"},INCOMPATIBLE_VERSIONS:{type:r.types.MERCHANT,code:"INCOMPATIBLE_VERSIONS"},CLIENT_SCRIPT_FAILED_TO_LOAD:{type:r.types.NETWORK,code:"CLIENT_SCRIPT_FAILED_TO_LOAD",message:"Braintree client script could not be loaded."},METHOD_CALLED_AFTER_TEARDOWN:{type:r.types.MERCHANT,code:"METHOD_CALLED_AFTER_TEARDOWN"}}},{"./braintree-error":124}],136:[function(e,t,n){"use strict";t.exports=function(e){for(;e.parentNode;)e=e.parentNode;return e}},{}],137:[function(e,t,n){"use strict";t.exports=function(e,t,n){var r;for(r=0;r<e.length;r++)if(e[r].hasOwnProperty(t)&&e[r][t]===n)return e[r];return null}},{}],138:[function(e,t,n){"use strict";var r=e("./strategies/popup"),o=e("./strategies/popup-bridge"),i=e("./strategies/modal"),a=e("framebus"),s=e("../shared/events"),l=e("../shared/errors"),c=e("../shared/constants"),u=e("@braintree/uuid"),d=e("@braintree/iframer"),p=e("../../braintree-error"),f=e("../shared/browser-detection"),h=e("./../../assign").assign,m=e("../../constants").BUS_CONFIGURATION_REQUEST_EVENT,g=["name","dispatchFrameUrl","openFrameUrl"];function v(){}function y(e){if(!e)throw new Error("Valid configuration is required");if(g.forEach((function(t){if(!e.hasOwnProperty(t))throw new Error("A valid frame "+t+" must be provided")})),!/^[\w_]+$/.test(e.name))throw new Error("A valid frame name must be provided")}function b(e){y(e),this._serviceId=u().replace(/-/g,""),this._options={name:e.name+"_"+this._serviceId,dispatchFrameUrl:e.dispatchFrameUrl,openFrameUrl:e.openFrameUrl,height:e.height,width:e.width,top:e.top,left:e.left},this.state=e.state||{},this._bus=new a({channel:this._serviceId}),this._setBusEvents()}b.prototype.initialize=function(e){var t=function(){e(),this._bus.off(s.DISPATCH_FRAME_READY,t)}.bind(this);this._bus.on(s.DISPATCH_FRAME_READY,t),this._writeDispatchFrame()},b.prototype._writeDispatchFrame=function(){var e=c.DISPATCH_FRAME_NAME+"_"+this._serviceId,t=this._options.dispatchFrameUrl;this._dispatchFrame=d({"aria-hidden":!0,name:e,title:e,src:t,class:c.DISPATCH_FRAME_CLASS,height:0,width:0,style:{position:"absolute",left:"-9999px"}}),document.body.appendChild(this._dispatchFrame)},b.prototype._setBusEvents=function(){this._bus.on(s.DISPATCH_FRAME_REPORT,function(e,t){this._onCompleteCallback&&this._onCompleteCallback.call(null,e.err,e.payload),this._frame.close(),this._onCompleteCallback=null,t&&t()}.bind(this)),this._bus.on(m,function(e){e(this.state)}.bind(this))},b.prototype.open=function(e,t){if(e=e||{},this._frame=this._getFrameForEnvironment(e),this._frame.initialize(t),!(this._frame instanceof o)){if(h(this.state,e.state),this._onCompleteCallback=t,this._frame.open(),this.isFrameClosed())return this._cleanupFrame(),void(t&&t(new p(l.FRAME_SERVICE_FRAME_OPEN_FAILED)));this._pollForPopupClose()}},b.prototype.redirect=function(e){this._frame&&!this.isFrameClosed()&&this._frame.redirect(e)},b.prototype.close=function(){this.isFrameClosed()||this._frame.close()},b.prototype.focus=function(){this.isFrameClosed()||this._frame.focus()},b.prototype.createHandler=function(e){return e=e||{},{close:function(){e.beforeClose&&e.beforeClose(),this.close()}.bind(this),focus:function(){e.beforeFocus&&e.beforeFocus(),this.focus()}.bind(this)}},b.prototype.createNoopHandler=function(){return{close:v,focus:v}},b.prototype.teardown=function(){this.close(),this._dispatchFrame.parentNode.removeChild(this._dispatchFrame),this._dispatchFrame=null,this._cleanupFrame()},b.prototype.isFrameClosed=function(){return null==this._frame||this._frame.isClosed()},b.prototype._cleanupFrame=function(){this._frame=null,clearInterval(this._popupInterval),this._popupInterval=null},b.prototype._pollForPopupClose=function(){return this._popupInterval=setInterval(function(){this.isFrameClosed()&&(this._cleanupFrame(),this._onCompleteCallback&&this._onCompleteCallback(new p(l.FRAME_SERVICE_FRAME_CLOSED)))}.bind(this),c.POPUP_POLL_INTERVAL),this._popupInterval},b.prototype._getFrameForEnvironment=function(e){var t=f.supportsPopups(),n=Boolean(window.popupBridge),a=h({},this._options,e);return n?new o(a):t?new r(a):new i(a)},t.exports=b},{"../../braintree-error":124,"../../constants":126,"../shared/browser-detection":145,"../shared/constants":146,"../shared/errors":147,"../shared/events":148,"./../../assign":121,"./strategies/modal":140,"./strategies/popup":143,"./strategies/popup-bridge":141,"@braintree/iframer":35,"@braintree/uuid":39,framebus:52}],139:[function(e,t,n){"use strict";var r=e("./frame-service");t.exports={create:function(e,t){var n=new r(e);n.initialize((function(){t(n)}))}}},{"./frame-service":138}],140:[function(e,t,n){"use strict";var r=e("@braintree/iframer"),o=e("../../../assign").assign,i=e("../../shared/browser-detection"),a={position:"fixed",top:0,left:0,bottom:0,padding:0,margin:0,border:0,outline:"none",zIndex:20001,background:"#FFFFFF"};function s(){}function l(e){this._closed=null,this._frame=null,this._options=e||{},this._container=this._options.container||document.body}l.prototype.initialize=s,l.prototype.open=function(){var e={src:this._options.openFrameUrl,name:this._options.name,scrolling:"yes",height:"100%",width:"100%",style:o({},a),title:"Lightbox Frame"};i.isIos()?(i.isIosWKWebview()&&(this._lockScrolling(),e.style={}),this._el=document.createElement("div"),o(this._el.style,a,{height:"100%",width:"100%",overflow:"auto","-webkit-overflow-scrolling":"touch"}),this._frame=r(e),this._el.appendChild(this._frame)):this._el=this._frame=r(e),this._closed=!1,this._container.appendChild(this._el)},l.prototype.focus=s,l.prototype.close=function(){this._container.removeChild(this._el),this._frame=null,this._closed=!0,i.isIosWKWebview()&&this._unlockScrolling()},l.prototype.isClosed=function(){return Boolean(this._closed)},l.prototype.redirect=function(e){this._frame.src=e},l.prototype._unlockScrolling=function(){document.body.style.overflow=this._savedBodyProperties.overflowStyle,document.body.style.position=this._savedBodyProperties.positionStyle,window.scrollTo(this._savedBodyProperties.left,this._savedBodyProperties.top),delete this._savedBodyProperties},l.prototype._lockScrolling=function(){var e=document.documentElement;this._savedBodyProperties={left:(window.pageXOffset||e.scrollLeft)-(e.clientLeft||0),top:(window.pageYOffset||e.scrollTop)-(e.clientTop||0),overflowStyle:document.body.style.overflow,positionStyle:document.body.style.position},document.body.style.overflow="hidden",document.body.style.position="fixed",window.scrollTo(0,0)},t.exports=l},{"../../../assign":121,"../../shared/browser-detection":145,"@braintree/iframer":35}],141:[function(e,t,n){"use strict";var r=e("../../../braintree-error"),o=e("../../shared/errors");function i(){}function a(e){this._closed=null,this._options=e}a.prototype.initialize=function(e){var t=this;window.popupBridge.onComplete=function(n,i){var a=!i&&!n;t._closed=!0,n||a?e(new r(o.FRAME_SERVICE_FRAME_CLOSED)):e(null,i)}},a.prototype.open=function(e){var t;t=(e=e||{}).openFrameUrl||this._options.openFrameUrl,this._closed=!1,window.popupBridge.open(t)},a.prototype.focus=i,a.prototype.close=i,a.prototype.isClosed=function(){return Boolean(this._closed)},a.prototype.redirect=function(e){this.open({openFrameUrl:e})},t.exports=a},{"../../../braintree-error":124,"../../shared/errors":147}],142:[function(e,t,n){"use strict";var r=e("../../../shared/constants"),o=e("./position");function i(e,t,n){return void 0!==t?t:o[e](n)}t.exports=function(e){var t=e.height||r.DEFAULT_POPUP_HEIGHT,n=e.width||r.DEFAULT_POPUP_WIDTH,o=i("top",e.top,t),a=i("left",e.left,n);return[r.POPUP_BASE_OPTIONS,"height="+t,"width="+n,"top="+o,"left="+a].join(",")}},{"../../../shared/constants":146,"./position":144}],143:[function(e,t,n){"use strict";var r=e("./compose-options");function o(){}function i(e){this._frame=null,this._options=e||{}}i.prototype.initialize=o,i.prototype.open=function(){this._frame=window.open(this._options.openFrameUrl,this._options.name,r(this._options))},i.prototype.focus=function(){this._frame.focus()},i.prototype.close=function(){this._frame.closed||this._frame.close()},i.prototype.isClosed=function(){return!this._frame||Boolean(this._frame.closed)},i.prototype.redirect=function(e){this._frame.location.href=e},t.exports=i},{"./compose-options":142}],144:[function(e,t,n){"use strict";function r(e){return i(window.outerHeight||document.documentElement.clientHeight,e,null==window.screenY?window.screenTop:window.screenY)}function o(e){return i(window.outerWidth||document.documentElement.clientWidth,e,null==window.screenX?window.screenLeft:window.screenX)}function i(e,t,n){return(e-t)/2+n}t.exports={top:r,left:o,center:i}},{}],145:[function(e,t,n){"use strict";t.exports={isIos:e("@braintree/browser-detection/is-ios"),isIosWKWebview:e("@braintree/browser-detection/is-ios-wkwebview"),supportsPopups:e("@braintree/browser-detection/supports-popups")}},{"@braintree/browser-detection/is-ios":30,"@braintree/browser-detection/is-ios-wkwebview":29,"@braintree/browser-detection/supports-popups":32}],146:[function(e,t,n){"use strict";t.exports={DISPATCH_FRAME_NAME:"dispatch",DISPATCH_FRAME_CLASS:"braintree-dispatch-frame",POPUP_BASE_OPTIONS:"resizable,scrollbars",DEFAULT_POPUP_WIDTH:450,DEFAULT_POPUP_HEIGHT:535,POPUP_POLL_INTERVAL:100,POPUP_CLOSE_TIMEOUT:100}},{}],147:[function(e,t,n){"use strict";var r=e("../../braintree-error");t.exports={FRAME_SERVICE_FRAME_CLOSED:{type:r.types.INTERNAL,code:"FRAME_SERVICE_FRAME_CLOSED",message:"Frame closed before tokenization could occur."},FRAME_SERVICE_FRAME_OPEN_FAILED:{type:r.types.INTERNAL,code:"FRAME_SERVICE_FRAME_OPEN_FAILED",message:"Frame failed to open."}}},{"../../braintree-error":124}],148:[function(e,t,n){"use strict";var r=e("../../enumerate");t.exports=r(["DISPATCH_FRAME_READY","DISPATCH_FRAME_REPORT"],"frameService:")},{"../../enumerate":134}],149:[function(e,t,n){"use strict";var r="3.102.0",o=e("./assign").assign;function i(e,t){var n=e.analyticsMetadata,i={gateway:"braintree","braintree:merchantId":e.gatewayConfiguration.merchantId,"braintree:apiVersion":"v1","braintree:sdkVersion":r,"braintree:metadata":JSON.stringify({source:n.source,integration:n.integration,sessionId:n.sessionId,version:r,platform:n.platform})};return o({},i,t)}t.exports=function(e,t,n){var r,o,a=e.gatewayConfiguration.androidPay,s="production"===e.gatewayConfiguration.environment?"PRODUCTION":"TEST";return 2===t?(r={apiVersion:2,apiVersionMinor:0,environment:s,allowedPaymentMethods:[{type:"CARD",parameters:{allowedAuthMethods:["PAN_ONLY","CRYPTOGRAM_3DS"],allowedCardNetworks:a.supportedNetworks.map((function(e){return e.toUpperCase()}))},tokenizationSpecification:{type:"PAYMENT_GATEWAY",parameters:i(e,{"braintree:authorizationFingerprint":a.googleAuthorizationFingerprint})}}]},n&&(r.merchantInfo={merchantId:n}),a.paypalClientId&&(o={type:"PAYPAL",parameters:{purchase_context:{purchase_units:[{payee:{client_id:a.paypalClientId},recurring_payment:!0}]}},tokenizationSpecification:{type:"PAYMENT_GATEWAY",parameters:i(e,{"braintree:paypalClientId":a.paypalClientId})}},r.allowedPaymentMethods.push(o))):(r={environment:s,allowedPaymentMethods:["CARD","TOKENIZED_CARD"],paymentMethodTokenizationParameters:{tokenizationType:"PAYMENT_GATEWAY",parameters:i(e,{"braintree:authorizationFingerprint":a.googleAuthorizationFingerprint})},cardRequirements:{allowedCardNetworks:a.supportedNetworks.map((function(e){return e.toUpperCase()}))}},"TOKENIZATION_KEY"===e.authorizationType&&(r.paymentMethodTokenizationParameters.parameters["braintree:clientKey"]=e.authorization),n&&(r.merchantId=n),t&&(r.apiVersion=t)),r}},{"./assign":121}],150:[function(e,t,n){"use strict";t.exports=function(e){e=e||window;try{return e.self!==e.top}catch(e){return!0}}},{}],151:[function(e,t,n){"use strict";function r(e){var t=e.split("-");return new Date(t[0],t[1],t[2])}function o(e,t){return r(e)<=r(t)}t.exports=o},{}],152:[function(e,t,n){"use strict";function r(e){return"https:"===(e=e||window.location.protocol)}t.exports={isHTTPS:r}},{}],153:[function(e,t,n){"use strict";var r,o={"paypal.com":1,"braintreepayments.com":1,"braintreegateway.com":1,"braintree-api.com":1};function i(e){return e.split(".").slice(-2).join(".")}function a(e){var t;return e=e.toLowerCase(),!!/^https:/.test(e)&&((r=r||document.createElement("a")).href=e,t=i(r.hostname),o.hasOwnProperty(t))}t.exports=a},{}],154:[function(e,t,n){"use strict";t.exports=function(e){return JSON.parse(JSON.stringify(e))}},{}],155:[function(e,t,n){"use strict";t.exports=function(e){return Object.keys(e).filter((function(t){return"function"==typeof e[t]}))}},{}],156:[function(e,t,n){"use strict";function r(e){var t=!1;return function(){t||(t=!0,e.apply(null,arguments))}}t.exports=r},{}],157:[function(e,t,n){"use strict";function r(e){var t;for(t in e)if(e.hasOwnProperty(t))return!0;return!1}function o(e){return e&&"object"==typeof e&&"number"==typeof e.length&&"[object Array]"===Object.prototype.toString.call(e)||!1}function i(e){return e=e||window.location.href,/\?/.test(e)}function a(e){return i(e=e||window.location.href)?(e.split("?")[1]||"").replace(/#.*$/,"").split("&").reduce((function(e,t){var n=t.split("="),r=decodeURIComponent(n[0]),o=decodeURIComponent(n[1]);return e[r]=o,e}),{}):{}}function s(e,t){var n,r,i,a=[];for(i in e)e.hasOwnProperty(i)&&(r=e[i],n=t?o(e)?t+"[]":t+"["+i+"]":i,"object"==typeof r?a.push(s(r,n)):a.push(encodeURIComponent(n)+"="+encodeURIComponent(r)));return a.join("&")}function l(e,t){return e=e||"",null!=t&&"object"==typeof t&&r(t)&&(e+=-1===e.indexOf("?")?"?":"",e+=-1!==e.indexOf("=")?"&":"",e+=s(t)),e}t.exports={parse:a,stringify:s,queryify:l,hasQueryParams:i}},{}],158:[function(e,t,n){"use strict";var r=e("@braintree/uuid"),o=e("./find-root-node");function i(e){return"[object ShadowRoot]"===(e=o(e)).toString()}function a(e){return i(e=o(e))?e.host:null}function s(e,t){var n=o(e).querySelector("style"),l=a(e),c="shadow-slot-"+r(),u=document.createElement("slot"),d=document.createElement("div");return u.setAttribute("name",c),e.appendChild(u),d.setAttribute("slot",c),l.appendChild(d),t&&(n||(n=document.createElement("style"),e.appendChild(n)),n.sheet.insertRule('::slotted([slot="'+c+'"]) { '+t+" }")),i(l)?s(d,t):d}t.exports={isShadowElement:i,getShadowHost:a,transformToSlot:s}},{"./find-root-node":136,"@braintree/uuid":39}],159:[function(e,t,n){"use strict";t.exports=function(e){return-1===e.indexOf("_")?e:e.toLowerCase().replace(/(\_\w)/g,(function(e){return e[1].toUpperCase()}))}},{}],160:[function(e,t,n){"use strict";function r(e){return e?"":".min"}t.exports=r},{}],161:[function(e,t,n){"use strict";var r="function"==typeof atob?atob:o;function o(e){var t,n,r,o,i,a,s="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",l="";if(!new RegExp("^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})([=]{1,2})?$").test(e))throw new Error("Non base64 encoded input passed to window.atob polyfill");a=0;do{t=(63&s.indexOf(e.charAt(a++)))<<2|(o=s.indexOf(e.charAt(a++)))>>4&3,n=(15&o)<<4|(i=s.indexOf(e.charAt(a++)))>>2&15,r=(3&i)<<6|63&s.indexOf(e.charAt(a++)),l+=String.fromCharCode(t)+(n?String.fromCharCode(n):"")+(r?String.fromCharCode(r):"")}while(a<e.length);return l}t.exports={atob:function(e){return r.call(window,e)},_atob:o}},{}],162:[function(e,t,n){"use strict";t.exports={REQUIRED_OPTIONS_FOR_START_PAYMENT:["givenName","surname","currencyCode","onPaymentStart","paymentType","amount","fallback"],REQUIRED_OPTIONS_FOR_PAY_UPON_INVOICE_PAYMENT_TYPE:["givenName","surname","currencyCode","onPaymentStart","paymentType","amount","address","billingAddress","birthDate","email","locale","customerServiceInstructions","correlationId","phone","phoneCountryCode","lineItems"],REQUIRED_OPTIONS_FOR_ADDRESS:["streetAddress","locality","postalCode","countryCode"],REQUIRED_OPTIONS_FOR_LINE_ITEMS:["category","name","quantity","unitAmount","unitTaxAmount"],REQUIRED_OPTIONS_FOR_BLIK_SEAMLESS_PAYMENT_TYPE:["givenName","surname","currencyCode","onPaymentStart","paymentType","amount"],REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_LEVEL_0:["authCode"],REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_FIRST:["authCode","consumerReference","aliasLabel"],REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_SUBSEQUENT:["consumerReference","aliasKey"]}},{}],163:[function(e,t,n){"use strict";var r=e("../../lib/frame-service/external"),o=e("../../lib/braintree-error"),i=e("../../lib/use-min"),a="3.102.0",s=e("../../lib/constants").INTEGRATION_TIMEOUT_MS,l=e("../../lib/analytics"),c=e("../../lib/methods"),u=e("../../lib/convert-methods-to-error"),d=e("../../lib/convert-to-braintree-error"),p=e("@braintree/extended-promise"),f=e("../../lib/querystring"),h=e("@braintree/wrap-promise"),m=e("./constants"),g=e("../shared/errors"),v=1282,y=720;function b(e){this._client=e.client,this._assetsUrl=e.client.getConfiguration().gatewayConfiguration.assetsUrl+"/web/"+a,this._isDebug=e.client.getConfiguration().isDebug,this._loadingFrameUrl=this._assetsUrl+"/html/local-payment-landing-frame"+i(this._isDebug)+".html",this._authorizationInProgress=!1,this._paymentType="unknown",this._merchantAccountId=e.merchantAccountId}function _(e){var t=e.blikOptions||{},n="string"==typeof e.paymentType?e.paymentType.toLowerCase():e.paymentType;return"pay_upon_invoice"===n||"blik"===n&&(t.hasOwnProperty("level_0")||t.hasOwnProperty("oneClick"))}function A(e){var t,n;for(t=0;t<m.REQUIRED_OPTIONS_FOR_ADDRESS.length;t++)if(n=m.REQUIRED_OPTIONS_FOR_ADDRESS[t],!e.hasOwnProperty(n))return n;return!1}function E(e){var t,n,r,o;for(n=0;n<e.length;n++)for(r=e[n],t=0;t<m.REQUIRED_OPTIONS_FOR_LINE_ITEMS.length;t++)if(o=m.REQUIRED_OPTIONS_FOR_LINE_ITEMS[t],!r.hasOwnProperty(o))return o;return!1}function w(e){var t,n,r,o=e.blikOptions||{};for(t=0;t<m.REQUIRED_OPTIONS_FOR_BLIK_SEAMLESS_PAYMENT_TYPE.length;t++)if(n=m.REQUIRED_OPTIONS_FOR_BLIK_SEAMLESS_PAYMENT_TYPE[t],!e.hasOwnProperty(n))return n;if(o.hasOwnProperty("level_0")){for(t=0;t<m.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_LEVEL_0.length;t++)if(n=m.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_LEVEL_0[t],!o.level_0.hasOwnProperty(n))return"blikOptions.level_0."+n}else if(o.hasOwnProperty("oneClick"))if((r=o.oneClick||{}).hasOwnProperty("aliasKey")){for(t=0;t<m.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_SUBSEQUENT.length;t++)if(n=m.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_SUBSEQUENT[t],!r.hasOwnProperty(n))return"blikOptions.oneClick."+n}else for(t=0;t<m.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_FIRST.length;t++)if(n=m.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_FIRST[t],!r.hasOwnProperty(n))return"blikOptions.oneClick."+n;return!1}function x(e){var t,n,r,o,i;if(!e)return!0;if(_(e)){if("pay_upon_invoice"===(i=e.paymentType||"").toLowerCase())for(t=0;t<m.REQUIRED_OPTIONS_FOR_PAY_UPON_INVOICE_PAYMENT_TYPE.length;t++){if(n=m.REQUIRED_OPTIONS_FOR_PAY_UPON_INVOICE_PAYMENT_TYPE[t],!e.hasOwnProperty(n))return n;if("address"===n||"billingAddress"===n){if(r=A(e[n]))return n+"."+r}else if("lineItems"===n&&(o=E(e[n])))return n+"."+o}else if("blik"===i.toLowerCase())return w(e)}else{for(t=0;t<m.REQUIRED_OPTIONS_FOR_START_PAYMENT.length;t++)if(n=m.REQUIRED_OPTIONS_FOR_START_PAYMENT[t],!e.hasOwnProperty(n))return n;if(!e.fallback.url)return"fallback.url";if(!e.fallback.buttonText)return"fallback.buttonText";if(!0===e.recurrent&&!e.customerId)return"customerId"}return!1}p.suppressUnhandledPromiseMessage=!0,b.prototype._initialize=function(){var e=this,t=this._client,n=setTimeout((function(){l.sendEvent(t,"local-payment.load.timed-out")}),s);return new Promise((function(o){r.create({name:"localpaymentlandingpage",dispatchFrameUrl:e._assetsUrl+"/html/dispatch-frame"+i(e._isDebug)+".html",openFrameUrl:e._loadingFrameUrl},(function(r){e._frameService=r,clearTimeout(n),l.sendEvent(t,"local-payment.load.succeeded"),o(e)}))}))},b.prototype.startPayment=function(e){var t,n,r,a,s,c,u,h,m,b=this,A=this._frameService._serviceId;return(t=x(e))?(n=new o(g.LOCAL_PAYMENT_START_PAYMENT_MISSING_REQUIRED_OPTION),"string"==typeof t&&(n.details="Missing required '"+t+"' option."),Promise.reject(n)):(h=e.windowOptions||{},r=e.address||{},a=e.fallback||{},u=e.billingAddress||{},s={amount:e.amount,bic:e.bic,billingAddress:{line1:u.streetAddress,line2:u.extendedAddress,city:u.locality,state:u.region,postalCode:u.postalCode,countryCode:u.countryCode},birthDate:e.birthDate,blikOptions:e.blikOptions,cancelUrl:f.queryify(b._assetsUrl+"/html/local-payment-redirect-frame"+i(b._isDebug)+".html",{channel:A,r:a.cancelUrl||a.url,t:a.cancelButtonText||a.buttonText,c:1}),city:r.locality,correlationId:e.correlationId,countryCode:r.countryCode,currencyIsoCode:e.currencyCode,discountAmount:e.discountAmount,experienceProfile:{brandName:e.displayName,customerServiceInstructions:e.customerServiceInstructions,locale:e.locale,noShipping:!e.shippingAddressRequired},firstName:e.givenName,fundingSource:e.paymentType,intent:"sale",lastName:e.surname,line1:r.streetAddress,line2:r.extendedAddress,lineItems:e.lineItems,merchantAccountId:b._merchantAccountId,merchantOrPartnerCustomerId:e.customerId,payerEmail:e.email,paymentTypeCountryCode:e.paymentTypeCountryCode,phone:e.phone,phoneCountryCode:e.phoneCountryCode,postalCode:r.postalCode,recurrent:e.recurrent,returnUrl:f.queryify(b._assetsUrl+"/html/local-payment-redirect-frame"+i(b._isDebug)+".html",{channel:A,r:a.url,t:a.buttonText}),shippingAmount:e.shippingAmount,state:r.region},b._paymentType=e.paymentType.toLowerCase(),b._authorizationInProgress?(l.sendEvent(b._client,b._paymentType+".local-payment.start-payment.error.already-opened"),Promise.reject(new o(g.LOCAL_PAYMENT_ALREADY_IN_PROGRESS))):(b._authorizationInProgress=!0,c=new p,_(e)||(b._startPaymentCallback=b._createStartPaymentCallback((function(e){c.resolve(e)}),(function(e){c.reject(e)})),b._frameService.open({width:h.width||v,height:h.height||y},b._startPaymentCallback)),b._client.request({method:"post",endpoint:"local_payments/create",data:s}).then((function(t){var n=t.paymentResource.redirectUrl;l.sendEvent(b._client,b._paymentType+".local-payment.start-payment.opened"),b._startPaymentOptions=e,_(e)?(b._authorizationInProgress=!1,"string"==typeof n&&n.length?c.reject(new o(g.LOCAL_PAYMENT_START_PAYMENT_DEFERRED_PAYMENT_FAILED)):(m=e.onPaymentStart({paymentId:t.paymentResource.paymentToken}))instanceof Promise?m.then((function(){c.resolve()})):c.resolve()):e.onPaymentStart({paymentId:t.paymentResource.paymentToken},(function(){b._frameService.redirect(t.paymentResource.redirectUrl)}))})).catch((function(e){var t=e.details&&e.details.httpStatus;b._frameService.close(),b._authorizationInProgress=!1,422!==t?c.reject(d(e,{type:g.LOCAL_PAYMENT_START_PAYMENT_FAILED.type,code:g.LOCAL_PAYMENT_START_PAYMENT_FAILED.code,message:g.LOCAL_PAYMENT_START_PAYMENT_FAILED.message})):c.reject(new o({type:g.LOCAL_PAYMENT_INVALID_PAYMENT_OPTION.type,code:g.LOCAL_PAYMENT_INVALID_PAYMENT_OPTION.code,message:g.LOCAL_PAYMENT_INVALID_PAYMENT_OPTION.message,details:{originalError:e}}))})),c))},b.prototype.tokenize=function(e){var t=this,n=this._client;return(e=e||f.parse()).queryItems&&(e=e.queryItems),e.c||e.wasCanceled?Promise.reject(new o({type:g.LOCAL_PAYMENT_CANCELED.type,code:g.LOCAL_PAYMENT_CANCELED.code,message:g.LOCAL_PAYMENT_CANCELED.message,details:{originalError:{errorcode:e.errorcode,token:e.btLpToken}}})):e.errorcode?Promise.reject(new o({type:g.LOCAL_PAYMENT_START_PAYMENT_FAILED.type,code:g.LOCAL_PAYMENT_START_PAYMENT_FAILED.code,message:g.LOCAL_PAYMENT_START_PAYMENT_FAILED.message,details:{originalError:{errorcode:e.errorcode,token:e.btLpToken}}})):n.request({endpoint:"payment_methods/paypal_accounts",method:"post",data:this._formatTokenizeData(e)}).then((function(e){var r=t._formatTokenizePayload(e);return window.popupBridge?l.sendEvent(n,t._paymentType+".local-payment.tokenization.success-popupbridge"):l.sendEvent(n,t._paymentType+".local-payment.tokenization.success"),r})).catch((function(e){return l.sendEvent(n,t._paymentType+".local-payment.tokenization.failed"),Promise.reject(d(e,{type:g.LOCAL_PAYMENT_TOKENIZATION_FAILED.type,code:g.LOCAL_PAYMENT_TOKENIZATION_FAILED.code,message:g.LOCAL_PAYMENT_TOKENIZATION_FAILED.message}))}))},b.prototype.closeWindow=function(){this._authoriztionInProgress&&l.sendEvent(this._client,this._paymentType+".local-payment.start-payment.closed.by-merchant"),this._frameService.close()},b.prototype.focusWindow=function(){this._frameService.focus()},b.prototype._createStartPaymentCallback=function(e,t){var n=this,r=this._client;return function(i,a){if(n._authorizationInProgress=!1,i)if("FRAME_SERVICE_FRAME_CLOSED"===i.code){if(a&&"processing_error"===a.errorcode)return l.sendEvent(r,n._paymentType+".local-payment.failed-in-window"),void t(new o(g.LOCAL_PAYMENT_START_PAYMENT_FAILED));l.sendEvent(r,n._paymentType+".local-payment.tokenization.closed.by-user"),t(new o(g.LOCAL_PAYMENT_WINDOW_CLOSED))}else i.code&&i.code.indexOf("FRAME_SERVICE_FRAME_OPEN_FAILED")>-1&&t(new o({code:g.LOCAL_PAYMENT_WINDOW_OPEN_FAILED.code,type:g.LOCAL_PAYMENT_WINDOW_OPEN_FAILED.type,message:g.LOCAL_PAYMENT_WINDOW_OPEN_FAILED.message,details:{originalError:i}}));else a&&(window.popupBridge||n._frameService.redirect(n._loadingFrameUrl),n.tokenize(a).then(e).catch(t).then((function(){n._frameService.close()})))}},b.prototype._formatTokenizePayload=function(e){var t,n={};return e.paypalAccounts&&(n=e.paypalAccounts[0]),t={nonce:n.nonce,details:{},type:n.type},n.details&&(n.details.payerInfo&&(t.details=n.details.payerInfo),n.details.correlationId&&(t.correlationId=n.details.correlationId)),t},b.prototype.hasTokenizationParams=function(){var e=f.parse();return!!e.errorcode||Boolean(e.btLpToken&&e.btLpPaymentId&&e.btLpPayerId)},b.prototype._formatTokenizeData=function(e){var t=this._client.getConfiguration().gatewayConfiguration;return{merchantAccountId:this._merchantAccountId,paypalAccount:{correlationId:e.btLpToken||e.token,paymentToken:e.btLpPaymentId||e.paymentId,payerId:e.btLpPayerId||e.PayerID,unilateral:t.paypal.unvettedMerchant,intent:"sale"}}},b.prototype.teardown=function(){var e=this;return e._frameService.teardown(),u(e,c(b.prototype)),l.sendEvent(e._client,"local-payment.teardown-completed"),Promise.resolve()},t.exports=h.wrapPrototype(b)},{"../../lib/analytics":119,"../../lib/braintree-error":124,"../../lib/constants":126,"../../lib/convert-methods-to-error":127,"../../lib/convert-to-braintree-error":128,"../../lib/frame-service/external":139,"../../lib/methods":155,"../../lib/querystring":157,"../../lib/use-min":160,"../shared/errors":165,"./constants":162,"@braintree/extended-promise":34,"@braintree/wrap-promise":43}],164:[function(e,t,n){"use strict";var r=e("../lib/analytics"),o=e("../lib/basic-component-verification"),i=e("../lib/create-deferred-client"),a=e("../lib/create-assets-url"),s=e("./external/local-payment"),l="3.102.0",c=e("@braintree/wrap-promise"),u=e("../lib/braintree-error"),d=e("./shared/errors");function p(e){var t="Local Payment";return o.verify({name:t,client:e.client,authorization:e.authorization}).then((function(){return i.create({authorization:e.authorization,client:e.client,debug:e.debug,assetsUrl:a.create(e.authorization),name:t})})).then((function(t){var n=t.getConfiguration();return e.client=t,!0!==n.gatewayConfiguration.paypalEnabled?Promise.reject(new u(d.LOCAL_PAYMENT_NOT_ENABLED)):(r.sendEvent(t,"local-payment.initialized"),new s(e)._initialize())}))}t.exports={create:c(p),VERSION:l}},{"../lib/analytics":119,"../lib/basic-component-verification":122,"../lib/braintree-error":124,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./external/local-payment":163,"./shared/errors":165,"@braintree/wrap-promise":43}],165:[function(e,t,n){"use strict";var r=e("../../lib/braintree-error");t.exports={LOCAL_PAYMENT_NOT_ENABLED:{type:r.types.MERCHANT,code:"LOCAL_PAYMENT_NOT_ENABLED",message:"LocalPayment is not enabled for this merchant."},LOCAL_PAYMENT_ALREADY_IN_PROGRESS:{type:r.types.MERCHANT,code:"LOCAL_PAYMENT_ALREADY_IN_PROGRESS",message:"LocalPayment payment is already in progress."},LOCAL_PAYMENT_CANCELED:{type:r.types.CUSTOMER,code:"LOCAL_PAYMENT_CANCELED",message:"Customer canceled the LocalPayment before authorizing."},LOCAL_PAYMENT_WINDOW_CLOSED:{type:r.types.CUSTOMER,code:"LOCAL_PAYMENT_WINDOW_CLOSED",message:"Customer closed LocalPayment window before authorizing."},LOCAL_PAYMENT_WINDOW_OPEN_FAILED:{type:r.types.MERCHANT,code:"LOCAL_PAYMENT_WINDOW_OPEN_FAILED",message:"LocalPayment window failed to open; make sure startPayment was called in response to a user action."},LOCAL_PAYMENT_START_PAYMENT_FAILED:{type:r.types.NETWORK,code:"LOCAL_PAYMENT_START_PAYMENT_FAILED",message:"LocalPayment startPayment failed."},LOCAL_PAYMENT_START_PAYMENT_MISSING_REQUIRED_OPTION:{type:r.types.MERCHANT,code:"LOCAL_PAYMENT_START_PAYMENT_MISSING_REQUIRED_OPTION",message:"Missing required option for startPayment."},LOCAL_PAYMENT_START_PAYMENT_DEFERRED_PAYMENT_FAILED:{type:r.types.UNKNOWN,code:"LOCAL_PAYMENT_START_PAYMENT_DEFERRED_PAYMENT_FAILED",message:"LocalPayment startPayment deferred payment failed."},LOCAL_PAYMENT_TOKENIZATION_FAILED:{type:r.types.NETWORK,code:"LOCAL_PAYMENT_TOKENIZATION_FAILED",message:"Could not tokenize user's local payment method."},LOCAL_PAYMENT_INVALID_PAYMENT_OPTION:{type:r.types.MERCHANT,code:"LOCAL_PAYMENT_INVALID_PAYMENT_OPTION",message:"Local payment options are invalid."}}},{"../../lib/braintree-error":124}],166:[function(e,t,n){"use strict";var r=e("../../lib/frame-service/external"),o=e("../../lib/braintree-error"),i=e("../shared/errors"),a="3.102.0",s=e("../../lib/methods"),l=e("@braintree/wrap-promise"),c=e("../../lib/analytics"),u=e("../../lib/convert-methods-to-error"),d=e("../../lib/convert-to-braintree-error"),p=e("../shared/constants"),f=e("../../lib/constants").INTEGRATION_TIMEOUT_MS;function h(e){var t=e.client.getConfiguration();this._client=e.client,this._assetsUrl=t.gatewayConfiguration.assetsUrl+"/web/"+a,this._isDebug=t.isDebug,this._authInProgress=!1,window.popupBridge&&"function"==typeof window.popupBridge.getReturnUrlPrefix?this._callbackUrl=window.popupBridge.getReturnUrlPrefix()+"return":this._callbackUrl=this._assetsUrl+"/html/redirect-frame"+(this._isDebug?"":".min")+".html"}function m(e){return[e.oauth_verifier,e.oauth_token,e.checkout_resource_url].some((function(e){return null==e||"null"===e}))}function g(e){var t,n;for(t=0;t<p.REQUIRED_OPTIONS_FOR_TOKENIZE.length;t++)if(n=p.REQUIRED_OPTIONS_FOR_TOKENIZE[t],!e.hasOwnProperty(n))return!0;return!1}h.prototype._initialize=function(){var e=this;return new Promise((function(t){var n=setTimeout((function(){c.sendEvent(e._client,"masterpass.load.timed-out")}),f);r.create({name:p.LANDING_FRAME_NAME,height:p.POPUP_HEIGHT,width:p.POPUP_WIDTH,dispatchFrameUrl:e._assetsUrl+"/html/dispatch-frame"+(e._isDebug?"":".min")+".html",openFrameUrl:e._assetsUrl+"/html/masterpass-landing-frame"+(e._isDebug?"":".min")+".html"},(function(r){e._frameService=r,clearTimeout(n),c.sendEvent(e._client,"masterpass.load.succeeded"),t(e)}))}))},h.prototype.tokenize=function(e){var t=this;return!e||g(e)?Promise.reject(new o(i.MASTERPASS_TOKENIZE_MISSING_REQUIRED_OPTION)):t._authInProgress?Promise.reject(new o(i.MASTERPASS_TOKENIZATION_ALREADY_IN_PROGRESS)):new Promise((function(n,r){t._navigateFrameToLoadingPage(e).catch(r),t._frameService.open(e.frameOptions,t._createFrameOpenHandler(n,r))}))},h.prototype._navigateFrameToLoadingPage=function(e){var t=this;return this._authInProgress=!0,this._client.request({method:"post",endpoint:"masterpass/request_token",data:{requestToken:{originUrl:window.location.protocol+"//"+window.location.hostname,subtotal:e.subtotal,currencyCode:e.currencyCode,callbackUrl:this._callbackUrl}}}).then((function(n){var r,o=t._assetsUrl+"/html/masterpass-loading-frame"+(t._isDebug?"":".min")+".html?",i=t._client.getConfiguration().gatewayConfiguration,a=e.config||{};r={environment:i.environment,requestToken:n.requestToken,callbackUrl:t._callbackUrl,merchantCheckoutId:i.masterpass.merchantCheckoutId,allowedCardTypes:i.masterpass.supportedNetworks,version:p.MASTERPASS_VERSION},Object.keys(a).forEach((function(e){"function"!=typeof a[e]&&(r[e]=a[e])})),o+=Object.keys(r).map((function(e){return e+"="+r[e]})).join("&"),t._frameService.redirect(o)})).catch((function(e){var n=e.details&&e.details.httpStatus;return t._closeWindow(),422===n?Promise.reject(d(e,i.MASTERPASS_INVALID_PAYMENT_OPTION)):Promise.reject(d(e,i.MASTERPASS_FLOW_FAILED))}))},h.prototype._createFrameOpenHandler=function(e,t){var n=this;return window.popupBridge?function(r,a){return n._authInProgress=!1,r?(c.sendEvent(n._client,"masterpass.tokenization.closed-popupbridge.by-user"),void t(d(r,i.MASTERPASS_POPUP_CLOSED))):a.queryItems?void n._tokenizeMasterpass(a.queryItems).then(e).catch(t):(c.sendEvent(n._client,"masterpass.tokenization.failed-popupbridge"),void t(new o(i.MASTERPASS_FLOW_FAILED)))}:function(r,a){if(r)return n._authInProgress=!1,"FRAME_SERVICE_FRAME_CLOSED"===r.code?(c.sendEvent(n._client,"masterpass.tokenization.closed.by-user"),void t(new o(i.MASTERPASS_POPUP_CLOSED))):r.code&&r.code.indexOf("FRAME_SERVICE_FRAME_OPEN_FAILED")>-1?(c.sendEvent(n._client,"masterpass.tokenization.failed.to-open"),void t(new o({code:i.MASTERPASS_POPUP_OPEN_FAILED.code,type:i.MASTERPASS_POPUP_OPEN_FAILED.type,message:i.MASTERPASS_POPUP_OPEN_FAILED.message,details:{originalError:r}}))):(c.sendEvent(n._client,"masterpass.tokenization.failed"),n._closeWindow(),void t(d(r,i.MASTERPASS_FLOW_FAILED)));n._tokenizeMasterpass(a).then(e).catch(t)}},h.prototype._tokenizeMasterpass=function(e){var t=this;return"success"!==e.mpstatus?(c.sendEvent(t._client,"masterpass.tokenization.closed.by-user"),t._closeWindow(),Promise.reject(new o(i.MASTERPASS_POPUP_CLOSED))):m(e)?(c.sendEvent(t._client,"masterpass.tokenization.closed.missing-payload"),t._closeWindow(),Promise.reject(new o(i.MASTERPASS_POPUP_MISSING_REQUIRED_PARAMETERS))):t._client.request({endpoint:"payment_methods/masterpass_cards",method:"post",data:{masterpassCard:{checkoutResourceUrl:e.checkout_resource_url,requestToken:e.oauth_token,verifierToken:e.oauth_verifier}}}).then((function(e){return t._closeWindow(),window.popupBridge?c.sendEvent(t._client,"masterpass.tokenization.success-popupbridge"):c.sendEvent(t._client,"masterpass.tokenization.success"),e.masterpassCards[0]})).catch((function(e){return t._closeWindow(),window.popupBridge?c.sendEvent(t._client,"masterpass.tokenization.failed-popupbridge"):c.sendEvent(t._client,"masterpass.tokenization.failed"),Promise.reject(d(e,i.MASTERPASS_ACCOUNT_TOKENIZATION_FAILED))}))},h.prototype._closeWindow=function(){this._authInProgress=!1,this._frameService.close()},h.prototype.teardown=function(){var e=this;return new Promise((function(t){e._frameService.teardown(),u(e,s(h.prototype)),c.sendEvent(e._client,"masterpass.teardown-completed"),t()}))},t.exports=l.wrapPrototype(h)},{"../../lib/analytics":119,"../../lib/braintree-error":124,"../../lib/constants":126,"../../lib/convert-methods-to-error":127,"../../lib/convert-to-braintree-error":128,"../../lib/frame-service/external":139,"../../lib/methods":155,"../shared/constants":169,"../shared/errors":170,"@braintree/wrap-promise":43}],167:[function(e,t,n){"use strict";var r=e("../lib/braintree-error"),o=e("../lib/basic-component-verification"),i=e("./shared/browser-detection"),a=e("./external/masterpass"),s=e("../lib/create-deferred-client"),l=e("../lib/create-assets-url"),c="3.102.0",u=e("./shared/errors"),d=e("@braintree/wrap-promise");function p(e){var t="Masterpass";return o.verify({name:t,client:e.client,authorization:e.authorization}).then((function(){return f()?Promise.resolve():Promise.reject(new r(u.MASTERPASS_BROWSER_NOT_SUPPORTED))})).then((function(){return s.create({authorization:e.authorization,client:e.client,debug:e.debug,assetsUrl:l.create(e.authorization),name:t})})).then((function(t){return e.client=t,e.client.getConfiguration().gatewayConfiguration.masterpass?new a(e)._initialize():Promise.reject(new r(u.MASTERPASS_NOT_ENABLED))}))}function f(){return Boolean(window.popupBridge||i.supportsPopups())}t.exports={create:d(p),isSupported:f,VERSION:c}},{"../lib/basic-component-verification":122,"../lib/braintree-error":124,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./external/masterpass":166,"./shared/browser-detection":168,"./shared/errors":170,"@braintree/wrap-promise":43}],168:[function(e,t,n){"use strict";t.exports={supportsPopups:e("@braintree/browser-detection/supports-popups")}},{"@braintree/browser-detection/supports-popups":32}],169:[function(e,t,n){"use strict";t.exports={LANDING_FRAME_NAME:"braintreemasterpasslanding",POPUP_WIDTH:450,POPUP_HEIGHT:660,MASTERPASS_VERSION:"v6",REQUIRED_OPTIONS_FOR_TOKENIZE:["subtotal","currencyCode"]}},{}],170:[function(e,t,n){"use strict";var r=e("../../lib/braintree-error");t.exports={MASTERPASS_BROWSER_NOT_SUPPORTED:{type:r.types.CUSTOMER,code:"MASTERPASS_BROWSER_NOT_SUPPORTED",message:"Browser is not supported."},MASTERPASS_NOT_ENABLED:{type:r.types.MERCHANT,code:"MASTERPASS_NOT_ENABLED",message:"Masterpass is not enabled for this merchant."},MASTERPASS_TOKENIZE_MISSING_REQUIRED_OPTION:{type:r.types.MERCHANT,code:"MASTERPASS_TOKENIZE_MISSING_REQUIRED_OPTION",message:"Missing required option for tokenize."},MASTERPASS_TOKENIZATION_ALREADY_IN_PROGRESS:{type:r.types.MERCHANT,code:"MASTERPASS_TOKENIZATION_ALREADY_IN_PROGRESS",message:"Masterpass tokenization is already in progress."},MASTERPASS_ACCOUNT_TOKENIZATION_FAILED:{type:r.types.NETWORK,code:"MASTERPASS_ACCOUNT_TOKENIZATION_FAILED",message:"Could not tokenize user's Masterpass account."},MASTERPASS_POPUP_OPEN_FAILED:{type:r.types.MERCHANT,code:"MASTERPASS_POPUP_OPEN_FAILED",message:"Masterpass popup failed to open. Make sure to tokenize in response to a user action, such as a click."},MASTERPASS_POPUP_MISSING_REQUIRED_PARAMETERS:{type:r.types.MERCHANT,code:"MASTERPASS_POPUP_MISSING_REQUIRED_PARAMETERS",message:"Masterpass popup failed to return all required parameters needed to continue tokenization."},MASTERPASS_POPUP_CLOSED:{type:r.types.CUSTOMER,code:"MASTERPASS_POPUP_CLOSED",message:"Customer closed Masterpass popup before authorizing."},MASTERPASS_INVALID_PAYMENT_OPTION:{type:r.types.MERCHANT,code:"MASTERPASS_INVALID_PAYMENT_OPTION",message:"Masterpass payment options are invalid."},MASTERPASS_FLOW_FAILED:{type:r.types.NETWORK,code:"MASTERPASS_FLOW_FAILED",message:"Could not initialize Masterpass flow."}}},{"../../lib/braintree-error":124}],171:[function(e,t,n){"use strict";var r=e("../../lib/analytics"),o=e("../../lib/assign").assign,i=e("framebus"),a=e("../../lib/convert-methods-to-error"),s=e("../../lib/generate-google-pay-configuration"),l=e("@braintree/iframer"),c=e("@braintree/uuid"),u=e("../../lib/use-min"),d=e("../../lib/methods"),p=e("@braintree/event-emitter"),f=e("../../lib/braintree-error"),h="3.102.0",m=e("../shared/constants"),g=m.events,v=m.errors,y=e("@braintree/wrap-promise"),b={Visa:"visa",MasterCard:"mastercard","American Express":"amex","Diners Club":"diners",Discover:"discover",JCB:"jcb",UnionPay:"unionpay",Maestro:"maestro"},_="18278000977346790994";function A(e,t,n){return e+"/web/"+h+"/html/payment-request-frame"+u(n)+".html#"+t}function E(e){var t=e.enabledPaymentMethods||{};p.call(this),this._componentId=c(),this._client=e.client,this._enabledPaymentMethods={basicCard:!1!==t.basicCard,googlePay:!1!==t.googlePay},this._googlePayVersion=2===e.googlePayVersion?2:1,this._googleMerchantId=_,this._supportedPaymentMethods=this._constructDefaultSupportedPaymentMethods(),this._defaultSupportedPaymentMethods=Object.keys(this._supportedPaymentMethods).map(function(e){return this._supportedPaymentMethods[e]}.bind(this)),this._bus=new i({channel:this._componentId})}p.createChild(E),E.prototype._constructDefaultSupportedPaymentMethods=function(){var e=this._client.getConfiguration(),t=e.gatewayConfiguration.androidPay,n=e.gatewayConfiguration.creditCards,r={};return this._enabledPaymentMethods.basicCard&&n&&n.supportedCardTypes.length>0&&(r.basicCard={supportedMethods:"basic-card",data:{supportedNetworks:n.supportedCardTypes.reduce((function(e,t){return t in b&&e.push(b[t]),e}),[])}}),this._enabledPaymentMethods.googlePay&&t&&t.enabled&&(r.googlePay={supportedMethods:"https://google.com/pay",data:s(e,this._googlePayVersion,this._googleMerchantId)}),r},E.prototype.initialize=function(){var e=this._client.getConfiguration(),t=this;return this._frame=l({allowPaymentRequest:!0,name:"braintree-payment-request-frame",class:"braintree-payment-request-frame",height:0,width:0,style:{position:"absolute",left:"-9999px"},title:"Secure Payment Frame"}),0===this._defaultSupportedPaymentMethods.length?Promise.reject(new f(v.PAYMENT_REQUEST_NO_VALID_SUPPORTED_PAYMENT_METHODS)):new Promise((function(n){t._bus.on(g.FRAME_READY,(function(e){e(t._client)})),t._bus.on(g.FRAME_CAN_MAKE_REQUESTS,(function(){r.sendEvent(t._client,"payment-request.initialized"),t._bus.on(g.SHIPPING_ADDRESS_CHANGE,(function(e){var n={target:{shippingAddress:e},updateWith:function(e){t._bus.emit(g.UPDATE_SHIPPING_ADDRESS,e)}};t._emit("shippingAddressChange",n),t._emit("shippingaddresschange",n)})),t._bus.on(g.SHIPPING_OPTION_CHANGE,(function(e){var n={target:{shippingOption:e},updateWith:function(e){t._bus.emit(g.UPDATE_SHIPPING_OPTION,e)}};t._emit("shippingOptionChange",n),t._emit("shippingoptionchange",n)})),n(t)})),t._frame.src=A(e.gatewayConfiguration.assetsUrl,t._componentId,e.isDebug),document.body.appendChild(t._frame)}))},E.prototype.createSupportedPaymentMethodsConfiguration=function(e,t){var n;if(!e)throw new f(v.PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_MUST_INCLUDE_TYPE);if(!this._enabledPaymentMethods[e])throw new f(v.PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_TYPE_NOT_ENABLED);return(n=o({},this._supportedPaymentMethods[e])).data=o({},n.data,t),n},E.prototype.tokenize=function(e){var t=this;return new Promise((function(n,o){t._bus.emit(g.PAYMENT_REQUEST_INITIALIZED,{supportedPaymentMethods:e.supportedPaymentMethods||t._defaultSupportedPaymentMethods,details:e.details,options:e.options},(function(e){var i=e[0],a=e[1];i?o(t._formatTokenizationError(i)):(r.sendEvent(t._client,"payment-request.tokenize.succeeded"),n({nonce:a.nonce,type:a.type,description:a.description,details:{rawPaymentResponse:a.details.rawPaymentResponse,cardType:a.details.cardType,lastFour:a.details.lastFour,lastTwo:a.details.lastTwo},binData:a.binData}))}))}))},E.prototype.canMakePayment=function(e){var t,n=this;return window.PaymentRequest?e.supportedPaymentMethods&&(e.supportedPaymentMethods.forEach((function(e){var n=e.supportedMethods;n in m.SUPPORTED_METHODS||(t=n)})),t)?Promise.reject(new f({type:v.PAYMENT_REQUEST_UNSUPPORTED_PAYMENT_METHOD.type,code:v.PAYMENT_REQUEST_UNSUPPORTED_PAYMENT_METHOD.code,message:t+" is not a supported payment method."})):new Promise((function(t,o){n._bus.emit(g.CAN_MAKE_PAYMENT,{supportedPaymentMethods:e.supportedPaymentMethods||n._defaultSupportedPaymentMethods,details:e.details,options:e.options},(function(e){var i=e[0],a=e[1];i?o(n._formatCanMakePaymentError(i)):(r.sendEvent(n._client,"payment-request.can-make-payment."+a),t(a))}))})):(r.sendEvent(n._client,"payment-request.can-make-payment.not-available"),Promise.resolve(!1))},E.prototype.teardown=function(){return this._bus.teardown(),this._frame.parentNode.removeChild(this._frame),a(this,d(E.prototype)),r.sendEvent(this._client,"payment-request.teardown-completed"),Promise.resolve()},E.prototype._formatTokenizationError=function(e){var t;switch(e.name){case"AbortError":return t=new f({type:v.PAYMENT_REQUEST_CANCELED.type,code:v.PAYMENT_REQUEST_CANCELED.code,message:v.PAYMENT_REQUEST_CANCELED.message,details:{originalError:e}}),r.sendEvent(this._client,"payment-request.tokenize.canceled"),t;case"PAYMENT_REQUEST_INITIALIZATION_FAILED":t=new f({type:v.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.type,code:v.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.code,message:v.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.message,details:{originalError:e}});break;case"BRAINTREE_GATEWAY_GOOGLE_PAYMENT_TOKENIZATION_ERROR":t=new f({type:v.PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE.type,code:v.PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE.code,message:v.PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE.message,details:{originalError:e}});break;case"BRAINTREE_GATEWAY_GOOGLE_PAYMENT_PARSING_ERROR":t=new f({type:v.PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR.type,code:v.PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR.code,message:v.PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR.message,details:{originalError:e}});break;default:t=new f({code:v.PAYMENT_REQUEST_NOT_COMPLETED.code,type:e.type||f.types.CUSTOMER,message:v.PAYMENT_REQUEST_NOT_COMPLETED.message,details:{originalError:e}})}return r.sendEvent(this._client,"payment-request.tokenize.failed"),t},E.prototype._formatCanMakePaymentError=function(e){var t;switch(e.name){case"PAYMENT_REQUEST_INITIALIZATION_FAILED":t=new f({type:v.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.type,code:v.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.code,message:v.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.message,details:{originalError:e}});break;case"NotAllowedError":t=new f({type:v.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED.type,code:v.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED.code,message:v.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED.message,details:{originalError:e}});break;default:t=new f({code:v.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED.code,type:v.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED.type,message:v.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED.message,details:{originalError:e}})}return r.sendEvent(this._client,"payment-request.can-make-payment.failed"),t},t.exports=y.wrapPrototype(E)},{"../../lib/analytics":119,"../../lib/assign":121,"../../lib/braintree-error":124,"../../lib/convert-methods-to-error":127,"../../lib/generate-google-pay-configuration":149,"../../lib/methods":155,"../../lib/use-min":160,"../shared/constants":173,"@braintree/event-emitter":33,"@braintree/iframer":35,"@braintree/uuid":39,"@braintree/wrap-promise":43,framebus:52}],172:[function(e,t,n){"use strict";var r=e("./external/payment-request"),o=e("../lib/basic-component-verification"),i=e("../lib/create-deferred-client"),a=e("../lib/create-assets-url"),s=e("@braintree/wrap-promise"),l="3.102.0";function c(e){var t="Payment Request";return o.verify({name:t,client:e.client,authorization:e.authorization}).then((function(){return i.create({authorization:e.authorization,client:e.client,debug:e.debug,assetsUrl:a.create(e.authorization),name:t})})).then((function(t){return e.client=t,new r(e).initialize()}))}t.exports={create:s(c),VERSION:l}},{"../lib/basic-component-verification":122,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./external/payment-request":171,"@braintree/wrap-promise":43}],173:[function(e,t,n){"use strict";var r=e("../../lib/enumerate"),o=e("./errors"),i={};i.events=r(["CAN_MAKE_PAYMENT","FRAME_READY","FRAME_CAN_MAKE_REQUESTS","PAYMENT_REQUEST_INITIALIZED","SHIPPING_ADDRESS_CHANGE","UPDATE_SHIPPING_ADDRESS","SHIPPING_OPTION_CHANGE","UPDATE_SHIPPING_OPTION"],"payment-request:"),i.errors=o,i.SUPPORTED_METHODS={"basic-card":!0,"https://google.com/pay":!0},t.exports=i},{"../../lib/enumerate":134,"./errors":174}],174:[function(e,t,n){"use strict";var r=e("../../lib/braintree-error");t.exports={PAYMENT_REQUEST_NO_VALID_SUPPORTED_PAYMENT_METHODS:{type:r.types.MERCHANT,code:"PAYMENT_REQUEST_NO_VALID_SUPPORTED_PAYMENT_METHODS",message:"There are no supported payment methods associated with this account."},PAYMENT_REQUEST_CANCELED:{type:r.types.CUSTOMER,code:"PAYMENT_REQUEST_CANCELED",message:"Payment request was canceled."},PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED:{type:r.types.MERCHANT,code:"PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED",message:"Something went wrong when configuring the payment request."},PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED:{type:r.types.UNKNOWN,code:"PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED",message:"Something went wrong when calling `canMakePayment`"},PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED:{type:r.types.MERCHANT,code:"PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED",message:"Something went wrong when calling `canMakePayment`. Most likely, `canMakePayment` was called multiple times with different supportedMethods configurations."},PAYMENT_REQUEST_UNSUPPORTED_PAYMENT_METHOD:{type:r.types.MERCHANT,code:"PAYMENT_REQUEST_UNSUPPORTED_PAYMENT_METHOD"},PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE:{type:r.types.MERCHANT,code:"PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE",message:"Something went wrong when tokenizing the Google Pay card."},PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR:{type:r.types.UNKNOWN,code:"PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR",message:"Something went wrong when tokenizing the Google Pay card."},PAYMENT_REQUEST_NOT_COMPLETED:{code:"PAYMENT_REQUEST_NOT_COMPLETED",message:"Payment request could not be completed."},PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_MUST_INCLUDE_TYPE:{type:r.types.MERCHANT,code:"PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_MUST_INCLUDE_TYPE",message:"createSupportedPaymentMethodsConfiguration must include a type parameter."},PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_TYPE_NOT_ENABLED:{type:r.types.MERCHANT,code:"PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_TYPE_NOT_ENABLED",message:"createSupportedPaymentMethodsConfiguration type parameter must be valid or enabled."}}},{"../../lib/braintree-error":124}],175:[function(e,t,n){"use strict";var r=e("../lib/braintree-error");t.exports={PAYPAL_NOT_ENABLED:{type:r.types.MERCHANT,code:"PAYPAL_NOT_ENABLED",message:"PayPal is not enabled for this merchant."},PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED:{type:r.types.MERCHANT,code:"PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED",message:"A linked PayPal Sandbox account is required to use PayPal Checkout in Sandbox. See https://developer.paypal.com/braintree/docs/guides/paypal/testing-go-live#linked-paypal-testing for details on linking your PayPal sandbox with Braintree."},PAYPAL_ACCOUNT_TOKENIZATION_FAILED:{type:r.types.NETWORK,code:"PAYPAL_ACCOUNT_TOKENIZATION_FAILED",message:"Could not tokenize user's PayPal account."},PAYPAL_FLOW_FAILED:{type:r.types.NETWORK,code:"PAYPAL_FLOW_FAILED",message:"Could not initialize PayPal flow."},PAYPAL_FLOW_OPTION_REQUIRED:{type:r.types.MERCHANT,code:"PAYPAL_FLOW_OPTION_REQUIRED",message:"PayPal flow property is invalid or missing."},PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED:{type:r.types.MERCHANT,code:"PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED"},PAYPAL_START_VAULT_INITIATED_CHECKOUT_SETUP_FAILED:{type:r.types.NETWORK,code:"PAYPAL_START_VAULT_INITIATED_CHECKOUT_SETUP_FAILED",message:"Something went wrong when setting up the checkout workflow."},PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED:{type:r.types.MERCHANT,code:"PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED",message:"PayPal popup failed to open, make sure to initiate the vault checkout in response to a user action."},PAYPAL_START_VAULT_INITIATED_CHECKOUT_CANCELED:{type:r.types.CUSTOMER,code:"PAYPAL_START_VAULT_INITIATED_CHECKOUT_CANCELED",message:"Customer closed PayPal popup before authorizing."},PAYPAL_START_VAULT_INITIATED_CHECKOUT_IN_PROGRESS:{type:r.types.MERCHANT,code:"PAYPAL_START_VAULT_INITIATED_CHECKOUT_IN_PROGRESS",message:"Vault initiated checkout already in progress."},PAYPAL_INVALID_PAYMENT_OPTION:{type:r.types.MERCHANT,code:"PAYPAL_INVALID_PAYMENT_OPTION",message:"PayPal payment options are invalid."},PAYPAL_MISSING_REQUIRED_OPTION:{type:r.types.MERCHANT,code:"PAYPAL_MISSING_REQUIRED_OPTION",message:"Missing required option."}}},{"../lib/braintree-error":124}],176:[function(e,t,n){"use strict";var r=e("../lib/basic-component-verification"),o=e("@braintree/wrap-promise"),i=e("./paypal-checkout"),a="3.102.0";function s(e){var t="PayPal Checkout";return r.verify({name:t,client:e.client,authorization:e.authorization}).then((function(){return new i(e)._initialize(e)}))}function l(){return!0}t.exports={create:o(s),isSupported:l,VERSION:a}},{"../lib/basic-component-verification":122,"./paypal-checkout":177,"@braintree/wrap-promise":43}],177:[function(e,t,n){"use strict";var r=e("../lib/analytics"),o=e("../lib/assign").assign,i=e("../lib/create-deferred-client"),a=e("../lib/create-assets-url"),s=e("@braintree/extended-promise"),l=e("@braintree/wrap-promise"),c=e("../lib/braintree-error"),u=e("../lib/convert-to-braintree-error"),d=e("./errors"),p=e("../paypal/shared/constants"),f=e("../lib/frame-service/external"),h=e("../lib/create-authorization-data"),m=e("../lib/methods"),g=e("../lib/use-min"),v=e("../lib/convert-methods-to-error"),y=e("../lib/querystring"),b="3.102.0",_=e("../lib/constants").INTEGRATION_TIMEOUT_MS,A=["amount","currency","vaultInitiatedCheckoutPaymentMethodToken"],E="https://www.{ENV}paypal.com/smart/buttons/preload";function w(e){this._merchantAccountId=e.merchantAccountId,this._autoSetDataUserIdToken=Boolean(e.autoSetDataUserIdToken)}s.suppressUnhandledPromiseMessage=!0,w.prototype._initialize=function(e){var t;return e.client?(t=e.client.getConfiguration(),this._authorizationInformation={fingerprint:t.authorizationFingerprint,environment:t.gatewayConfiguration.environment}):(t=h(e.authorization),this._authorizationInformation={fingerprint:t.attrs.authorizationFingerprint,environment:t.environment}),this._clientPromise=i.create({authorization:e.authorization,client:e.client,debug:e.debug,assetsUrl:a.create(e.authorization),name:"PayPal Checkout"}).then(function(e){return this._configuration=e.getConfiguration(),this._merchantAccountId||(this._configuration.gatewayConfiguration.paypalEnabled?!0===this._configuration.gatewayConfiguration.paypal.environmentNoNetwork&&(this._setupError=new c(d.PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED)):this._setupError=new c(d.PAYPAL_NOT_ENABLED)),this._setupError?Promise.reject(this._setupError):(r.sendEvent(e,"paypal-checkout.initialized"),this._frameServicePromise=this._setupFrameService(e),e)}.bind(this)),e.client?this._clientPromise.then(function(){return this}.bind(this)):Promise.resolve(this)},w.prototype._setupFrameService=function(e){var t=new s,n=e.getConfiguration(),o=setTimeout((function(){r.sendEvent(e,"paypal-checkout.frame-service.timed-out"),t.reject(new c(d.PAYPAL_START_VAULT_INITIATED_CHECKOUT_SETUP_FAILED))}),_);return this._assetsUrl=n.gatewayConfiguration.paypal.assetsUrl+"/web/"+b,this._isDebug=n.isDebug,this._loadingFrameUrl=this._assetsUrl+"/html/paypal-landing-frame"+g(this._isDebug)+".html",f.create({name:"braintreepaypallanding",dispatchFrameUrl:this._assetsUrl+"/html/dispatch-frame"+g(this._isDebug)+".html",openFrameUrl:this._loadingFrameUrl},function(e){this._frameService=e,clearTimeout(o),t.resolve()}.bind(this)),t},w.prototype.createPayment=function(e){return e&&p.FLOW_ENDPOINTS.hasOwnProperty(e.flow)?(r.sendEvent(this._clientPromise,"paypal-checkout.createPayment"),this._createPaymentResource(e).then((function(t){return"checkout"===e.flow?y.parse(t.paymentResource.redirectUrl).token:t.agreementSetup.tokenId}))):Promise.reject(new c(d.PAYPAL_FLOW_OPTION_REQUIRED))},w.prototype._createPaymentResource=function(e,t){var n=this,o="paypal_hermes/"+p.FLOW_ENDPOINTS[e.flow];return delete this.intentFromCreatePayment,t=t||{},!0===e.offerCredit&&r.sendEvent(this._clientPromise,"paypal-checkout.credit.offered"),this._clientPromise.then((function(r){return r.request({endpoint:o,method:"post",data:n._formatPaymentResourceData(e,t)}).then((function(t){return n.intentFromCreatePayment=e.intent,t}))})).catch((function(e){return n._setupError?Promise.reject(n._setupError):422===(e.details&&e.details.httpStatus)?Promise.reject(new c({type:d.PAYPAL_INVALID_PAYMENT_OPTION.type,code:d.PAYPAL_INVALID_PAYMENT_OPTION.code,message:d.PAYPAL_INVALID_PAYMENT_OPTION.message,details:{originalError:e}})):Promise.reject(u(e,{type:d.PAYPAL_FLOW_FAILED.type,code:d.PAYPAL_FLOW_FAILED.code,message:d.PAYPAL_FLOW_FAILED.message}))}))},w.prototype.updatePayment=function(e){var t=this,n="paypal_hermes/patch_payment_resource";return!e||this._hasMissingOption(e,p.REQUIRED_OPTIONS)?(r.sendEvent(t._clientPromise,"paypal-checkout.updatePayment.missing-options"),Promise.reject(new c(d.PAYPAL_MISSING_REQUIRED_OPTION))):this._verifyConsistentCurrency(e)?(r.sendEvent(this._clientPromise,"paypal-checkout.updatePayment"),this._clientPromise.then((function(r){return r.request({endpoint:n,method:"post",data:t._formatUpdatePaymentData(e)})})).catch((function(e){return 422===(e.details&&e.details.httpStatus)?(r.sendEvent(t._clientPromise,"paypal-checkout.updatePayment.invalid"),Promise.reject(new c({type:d.PAYPAL_INVALID_PAYMENT_OPTION.type,code:d.PAYPAL_INVALID_PAYMENT_OPTION.code,message:d.PAYPAL_INVALID_PAYMENT_OPTION.message,details:{originalError:e}}))):(r.sendEvent(t._clientPromise,"paypal-checkout.updatePayment."+d.PAYPAL_FLOW_FAILED.code),Promise.reject(u(e,{type:d.PAYPAL_FLOW_FAILED.type,code:d.PAYPAL_FLOW_FAILED.code,message:d.PAYPAL_FLOW_FAILED.message})))}))):(r.sendEvent(t._clientPromise,"paypal-checkout.updatePayment.inconsistent-currencies"),Promise.reject(new c({type:d.PAYPAL_INVALID_PAYMENT_OPTION.type,code:d.PAYPAL_INVALID_PAYMENT_OPTION.code,message:d.PAYPAL_INVALID_PAYMENT_OPTION.message,details:{originalError:new Error("One or more shipping option currencies differ from checkout currency.")}})))},w.prototype.startVaultInitiatedCheckout=function(e){var t,n=this;return this._vaultInitiatedCheckoutInProgress?(r.sendEvent(this._clientPromise,"paypal-checkout.startVaultInitiatedCheckout.error.already-in-progress"),Promise.reject(new c(d.PAYPAL_START_VAULT_INITIATED_CHECKOUT_IN_PROGRESS))):(A.forEach((function(n){e.hasOwnProperty(n)||(t=n)})),t?Promise.reject(new c({type:d.PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED.type,code:d.PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED.code,message:"Required param "+t+" is missing."})):(this._vaultInitiatedCheckoutInProgress=!0,this._addModalBackdrop(e),e=o({},e,{flow:"checkout"}),r.sendEvent(this._clientPromise,"paypal-checkout.startVaultInitiatedCheckout.started"),this._waitForVaultInitiatedCheckoutDependencies().then((function(){var t=new s,r=n._createPaymentResource(e,{returnUrl:n._constructVaultCheckutUrl("redirect-frame"),cancelUrl:n._constructVaultCheckutUrl("cancel-frame")}).then((function(e){var r=e.paymentResource.redirectUrl;return n._frameService.redirect(r),t}));return n._frameService.open({},n._createFrameServiceCallback(t)),r})).catch((function(e){return n._vaultInitiatedCheckoutInProgress=!1,n._removeModalBackdrop(),"FRAME_SERVICE_FRAME_CLOSED"===e.code?(r.sendEvent(n._clientPromise,"paypal-checkout.startVaultInitiatedCheckout.canceled.by-customer"),Promise.reject(new c(d.PAYPAL_START_VAULT_INITIATED_CHECKOUT_CANCELED))):(n._frameService&&n._frameService.close(),e.code&&e.code.indexOf("FRAME_SERVICE_FRAME_OPEN_FAILED")>-1?(r.sendEvent(n._clientPromise,"paypal-checkout.startVaultInitiatedCheckout.failed.popup-not-opened"),Promise.reject(new c({code:d.PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED.code,type:d.PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED.type,message:d.PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED.message,details:{originalError:e}}))):Promise.reject(e))})).then((function(e){return n._frameService.close(),n._vaultInitiatedCheckoutInProgress=!1,n._removeModalBackdrop(),r.sendEvent(n._clientPromise,"paypal-checkout.startVaultInitiatedCheckout.succeeded"),Promise.resolve(e)}))))},w.prototype._addModalBackdrop=function(e){e.optOutOfModalBackdrop||(this._modalBackdrop||(this._modalBackdrop=document.createElement("div"),this._modalBackdrop.setAttribute("data-braintree-paypal-vault-initiated-checkout-modal",!0),this._modalBackdrop.style.position="fixed",this._modalBackdrop.style.top=0,this._modalBackdrop.style.bottom=0,this._modalBackdrop.style.left=0,this._modalBackdrop.style.right=0,this._modalBackdrop.style.zIndex=9999,this._modalBackdrop.style.background="black",this._modalBackdrop.style.opacity="0.7",this._modalBackdrop.addEventListener("click",function(){this.focusVaultInitiatedCheckoutWindow()}.bind(this))),document.body.appendChild(this._modalBackdrop))},w.prototype._removeModalBackdrop=function(){this._modalBackdrop&&this._modalBackdrop.parentNode&&this._modalBackdrop.parentNode.removeChild(this._modalBackdrop)},w.prototype.closeVaultInitiatedCheckoutWindow=function(){return this._vaultInitiatedCheckoutInProgress&&r.sendEvent(this._clientPromise,"paypal-checkout.startVaultInitiatedCheckout.canceled.by-merchant"),this._waitForVaultInitiatedCheckoutDependencies().then(function(){this._frameService.close()}.bind(this))},w.prototype.focusVaultInitiatedCheckoutWindow=function(){return this._waitForVaultInitiatedCheckoutDependencies().then(function(){this._frameService.focus()}.bind(this))},w.prototype._createFrameServiceCallback=function(e){var t=this;return function(n,r){n?e.reject(n):r&&(t._frameService.redirect(t._loadingFrameUrl),t.tokenizePayment({paymentToken:r.token,payerID:r.PayerID,paymentID:r.paymentId,orderID:r.orderId}).then((function(t){e.resolve(t)})).catch((function(t){e.reject(t)})))}},w.prototype._waitForVaultInitiatedCheckoutDependencies=function(){var e=this;return this._clientPromise.then((function(){return e._frameServicePromise}))},w.prototype._constructVaultCheckutUrl=function(e){var t=this._frameService._serviceId;return this._assetsUrl+"/html/"+e+g(this._isDebug)+".html?channel="+t},w.prototype.tokenizePayment=function(e){var t,n=this,o=!0,i={flow:e.billingToken&&!e.paymentID?"vault":"checkout",intent:e.intent||this.intentFromCreatePayment},a={ecToken:e.paymentToken,billingToken:e.billingToken,payerId:e.payerID,paymentId:e.paymentID,orderId:e.orderID,shippingOptionsId:e.shippingOptionsId};return e.hasOwnProperty("vault")&&(o=e.vault),i.vault=o,r.sendEvent(this._clientPromise,"paypal-checkout.tokenization.started"),this._clientPromise.then((function(e){return e.request({endpoint:"payment_methods/paypal_accounts",method:"post",data:n._formatTokenizeData(i,a)})})).then((function(e){return t=n._formatTokenizePayload(e),r.sendEvent(n._clientPromise,"paypal-checkout.tokenization.success"),t.creditFinancingOffered&&r.sendEvent(n._clientPromise,"paypal-checkout.credit.accepted"),t})).catch((function(e){return n._setupError?Promise.reject(n._setupError):(r.sendEvent(n._clientPromise,"paypal-checkout.tokenization.failed"),Promise.reject(u(e,{type:d.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.type,code:d.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.code,message:d.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.message})))}))},w.prototype.getClientId=function(){return this._clientPromise.then((function(e){return e.getConfiguration().gatewayConfiguration.paypal.clientId}))},w.prototype.loadPayPalSDK=function(e){var t,n=new s,r=e&&e.dataAttributes||{},i=r["user-id-token"]||r["data-user-id-token"];return i||(i=this._authorizationInformation.fingerprint&&this._authorizationInformation.fingerprint.split("?")[0]),this._paypalScript=document.createElement("script"),delete(e=o({},{components:"buttons"},e)).dataAttributes,e.vault?e.intent=e.intent||"tokenize":(e.intent=e.intent||"authorize",e.currency=e.currency||"USD"),t="https://www.paypal.com/sdk/js?",this._paypalScript.onload=function(){n.resolve()},Object.keys(r).forEach(function(e){this._paypalScript.setAttribute("data-"+e.replace(/^data\-/,""),r[e])}.bind(this)),(e["client-id"]?Promise.resolve(e["client-id"]):this.getClientId()).then(function(n){e["client-id"]=n,this._autoSetDataUserIdToken&&i&&(this._paypalScript.setAttribute("data-user-id-token",i),this._attachPreloadPixel({id:n,userIdToken:i,amount:r.amount,currency:e.currency,merchantId:e["merchant-id"]})),this._paypalScript.src=y.queryify(t,e),document.head.insertBefore(this._paypalScript,document.head.firstElementChild)}.bind(this)),n.then(function(){return this}.bind(this))},w.prototype._attachPreloadPixel=function(e){var t,n=e.id,r=e.userIdToken,o="production"===this._authorizationInformation.environment?"":"sandbox.",i=E.replace("{ENV}",o),a={"client-id":n,"user-id-token":r};e.amount&&(a.amount=e.amount),e.currency&&(a.currency=e.currency),e.merchantId&&(a["merchant-id"]=e.merchantId),(t=new XMLHttpRequest).open("GET",y.queryify(i,a)),t.send()},w.prototype._formatPaymentResourceData=function(e,t){var n,r=this._configuration.gatewayConfiguration,o=e.intent,i={returnUrl:t.returnUrl||"https://www.paypal.com/checkoutnow/error",cancelUrl:t.cancelUrl||"https://www.paypal.com/checkoutnow/error",offerPaypalCredit:!0===e.offerCredit,merchantAccountId:this._merchantAccountId,experienceProfile:{brandName:e.displayName||r.paypal.displayName,localeCode:e.locale,noShipping:(!e.enableShippingAddress).toString(),addressOverride:!1===e.shippingAddressEditable,landingPageType:e.landingPageType},shippingOptions:e.shippingOptions};if("checkout"===e.flow){for(n in i.amount=e.amount,i.currencyIsoCode=e.currency,i.requestBillingAgreement=e.requestBillingAgreement,o&&("capture"===o&&(o="sale"),i.intent=o),e.hasOwnProperty("lineItems")&&(i.lineItems=e.lineItems),e.hasOwnProperty("vaultInitiatedCheckoutPaymentMethodToken")&&(i.vaultInitiatedCheckoutPaymentMethodToken=e.vaultInitiatedCheckoutPaymentMethodToken),e.hasOwnProperty("shippingOptions")&&(i.shippingOptions=e.shippingOptions),e.shippingAddressOverride)e.shippingAddressOverride.hasOwnProperty(n)&&(i[n]=e.shippingAddressOverride[n]);e.hasOwnProperty("billingAgreementDetails")&&(i.billingAgreementDetails=e.billingAgreementDetails)}else i.shippingAddress=e.shippingAddressOverride,e.billingAgreementDescription&&(i.description=e.billingAgreementDescription);return this._riskCorrelationId=e.riskCorrelationId,e.riskCorrelationId&&(i.correlationId=this._riskCorrelationId),i},w.prototype._verifyConsistentCurrency=function(e){return!(e.currency&&e.hasOwnProperty("shippingOptions")&&Array.isArray(e.shippingOptions))||e.shippingOptions.every((function(t){return t.amount&&t.amount.currency&&e.currency.toLowerCase()===t.amount.currency.toLowerCase()}))},w.prototype._hasMissingOption=function(e,t){var n,r;if(t=t||[],!e.hasOwnProperty("amount")&&!e.hasOwnProperty("lineItems"))return!0;for(n=0;n<t.length;n++)if(r=t[n],!e.hasOwnProperty(r))return!0;return!1},w.prototype._formatUpdatePaymentData=function(e){var t=this,n={merchantAccountId:this._merchantAccountId,paymentId:e.paymentId||e.orderId,currencyIsoCode:e.currency};return e.hasOwnProperty("amount")&&(n.amount=e.amount),e.hasOwnProperty("lineItems")&&(n.lineItems=e.lineItems),e.hasOwnProperty("shippingOptions")&&(n.shippingOptions=e.shippingOptions),e.hasOwnProperty("amountBreakdown")&&(n.amountBreakdown=e.amountBreakdown),e.hasOwnProperty("shippingAddress")&&(r.sendEvent(t._clientPromise,"paypal-checkout.updatePayment.shippingAddress.provided.by-the-merchant"),n.line1=e.shippingAddress.line1,e.shippingAddress.hasOwnProperty("line2")&&(n.line2=e.shippingAddress.line2),n.city=e.shippingAddress.city,n.state=e.shippingAddress.state,n.postalCode=e.shippingAddress.postalCode,n.countryCode=e.shippingAddress.countryCode,e.shippingAddress.hasOwnProperty("phone")&&(n.phone=e.shippingAddress.phone),e.shippingAddress.hasOwnProperty("recipientName")&&(n.recipientName=e.shippingAddress.recipientName)),n},w.prototype._formatTokenizeData=function(e,t){var n=this._configuration,r=n.gatewayConfiguration,o="TOKENIZATION_KEY"===n.authorizationType,i="vault"===e.flow,a={paypalAccount:{correlationId:this._riskCorrelationId||t.billingToken||t.ecToken,options:{validate:i&&!o&&e.vault}}};return i?a.paypalAccount.billingAgreementToken=t.billingToken:(a.paypalAccount.paymentToken=t.paymentId||t.orderId,a.paypalAccount.payerId=t.payerId,a.paypalAccount.unilateral=r.paypal.unvettedMerchant,e.intent&&(a.paypalAccount.intent=e.intent)),this._merchantAccountId&&(a.merchantAccountId=this._merchantAccountId),a},w.prototype._formatTokenizePayload=function(e){var t,n={};return e.paypalAccounts&&(n=e.paypalAccounts[0]),t={nonce:n.nonce,details:{},type:n.type},n.details&&n.details.payerInfo&&(t.details=n.details.payerInfo),n.details&&n.details.creditFinancingOffered&&(t.creditFinancingOffered=n.details.creditFinancingOffered),n.details&&n.details.shippingOptionId&&(t.shippingOptionId=n.details.shippingOptionId),n.details&&n.details.cobrandedCardLabel&&(t.cobrandedCardLabel=n.details.cobrandedCardLabel),t},w.prototype.teardown=function(){var e=this;return v(this,m(w.prototype)),this._paypalScript&&this._paypalScript.parentNode&&this._paypalScript.parentNode.removeChild(this._paypalScript),this._frameServicePromise.catch((function(){})).then((function(){return e._frameService?e._frameService.teardown():Promise.resolve()}))},t.exports=l.wrapPrototype(w)},{"../lib/analytics":119,"../lib/assign":121,"../lib/braintree-error":124,"../lib/constants":126,"../lib/convert-methods-to-error":127,"../lib/convert-to-braintree-error":128,"../lib/create-assets-url":129,"../lib/create-authorization-data":130,"../lib/create-deferred-client":131,"../lib/frame-service/external":139,"../lib/methods":155,"../lib/querystring":157,"../lib/use-min":160,"../paypal/shared/constants":180,"./errors":175,"@braintree/extended-promise":34,"@braintree/wrap-promise":43}],178:[function(e,t,n){"use strict";var r=e("../../lib/frame-service/external"),o=e("../../lib/braintree-error"),i=e("../../lib/convert-to-braintree-error"),a=e("../../lib/use-min"),s=e("../../lib/once"),l="3.102.0",c=e("../shared/constants"),u=e("../../lib/constants").INTEGRATION_TIMEOUT_MS,d=e("../../lib/analytics"),p=e("../../lib/methods"),f=e("../../lib/deferred"),h=e("../shared/errors"),m=e("../../lib/convert-methods-to-error"),g=e("../../lib/querystring"),v=e("@braintree/wrap-promise");function y(e){this._client=e.client,this._assetsUrl=e.client.getConfiguration().gatewayConfiguration.paypal.assetsUrl+"/web/"+l,this._isDebug=e.client.getConfiguration().isDebug,this._loadingFrameUrl=this._assetsUrl+"/html/paypal-landing-frame"+a(this._isDebug)+".html",this._authorizationInProgress=!1}y.prototype._initialize=function(){var e=this,t=this._client,n=setTimeout((function(){d.sendEvent(t,"paypal.load.timed-out")}),u);return new Promise((function(o){r.create({name:c.LANDING_FRAME_NAME,dispatchFrameUrl:e._assetsUrl+"/html/dispatch-frame"+a(e._isDebug)+".html",openFrameUrl:e._loadingFrameUrl},(function(r){e._frameService=r,clearTimeout(n),d.sendEvent(t,"paypal.load.succeeded"),o(e)}))}))},y.prototype.tokenize=function(e,t){var n,r,i=this,a=this._client;return t&&(t=s(f(t))),e&&c.FLOW_ENDPOINTS.hasOwnProperty(e.flow)?(n=new Promise((function(t,n){i._authorizationInProgress?(d.sendEvent(a,"paypal.tokenization.error.already-opened"),n(new o(h.PAYPAL_TOKENIZATION_REQUEST_ACTIVE))):(i._authorizationInProgress=!0,window.popupBridge||d.sendEvent(a,"paypal.tokenization.opened"),!0===e.offerCredit&&d.sendEvent(a,"paypal.credit.offered"),!0===e.offerPayLater&&d.sendEvent(a,"paypal.paylater.offered"),i._navigateFrameToAuth(e).catch(n),i._frameService.open({},i._createFrameServiceCallback(e,t,n)))})),t?(n.then((function(e){t(null,e)})).catch(t),this._frameService.createHandler({beforeClose:function(){d.sendEvent(a,"paypal.tokenization.closed.by-merchant")}})):n):(r=new o(h.PAYPAL_FLOW_OPTION_REQUIRED),t?(t(r),this._frameService.createNoopHandler()):Promise.reject(r))},y.prototype._createFrameServiceCallback=function(e,t,n){var r=this,i=this._client;return window.popupBridge?function(a,s){var l=s&&s.path&&"/cancel"===s.path.substring(0,7);r._authorizationInProgress=!1,a||l?(d.sendEvent(i,"paypal.tokenization.closed-popupbridge.by-user"),n(new o(h.PAYPAL_POPUP_CLOSED))):s&&r._tokenizePayPal(e,s.queryItems).then(t).catch(n)}:function(a,s){r._authorizationInProgress=!1,a?"FRAME_SERVICE_FRAME_CLOSED"===a.code?(d.sendEvent(i,"paypal.tokenization.closed.by-user"),n(new o(h.PAYPAL_POPUP_CLOSED))):a.code&&a.code.indexOf("FRAME_SERVICE_FRAME_OPEN_FAILED")>-1&&n(new o({code:h.PAYPAL_POPUP_OPEN_FAILED.code,type:h.PAYPAL_POPUP_OPEN_FAILED.type,message:h.PAYPAL_POPUP_OPEN_FAILED.message,details:{originalError:a}})):s&&r._tokenizePayPal(e,s).then(t).catch(n)}},y.prototype._tokenizePayPal=function(e,t){var n=this,r=this._client;return window.popupBridge||this._frameService.redirect(this._loadingFrameUrl),r.request({endpoint:"payment_methods/paypal_accounts",method:"post",data:this._formatTokenizeData(e,t)}).then((function(e){var t=n._formatTokenizePayload(e);return window.popupBridge?d.sendEvent(r,"paypal.tokenization.success-popupbridge"):d.sendEvent(r,"paypal.tokenization.success"),t.creditFinancingOffered&&d.sendEvent(r,"paypal.credit.accepted"),n._frameService.close(),t})).catch((function(e){return window.popupBridge?d.sendEvent(r,"paypal.tokenization.failed-popupbridge"):d.sendEvent(r,"paypal.tokenization.failed"),n._frameService.close(),Promise.reject(i(e,{type:h.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.type,code:h.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.code,message:h.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.message}))}))},y.prototype._formatTokenizePayload=function(e){var t,n={};return e.paypalAccounts&&(n=e.paypalAccounts[0]),t={nonce:n.nonce,details:{},type:n.type},n.details&&n.details.payerInfo&&(t.details=n.details.payerInfo),n.details&&n.details.creditFinancingOffered&&(t.creditFinancingOffered=n.details.creditFinancingOffered),t},y.prototype._formatTokenizeData=function(e,t){var n=this._client.getConfiguration(),r=n.gatewayConfiguration,o="TOKENIZATION_KEY"===n.authorizationType,i={paypalAccount:{correlationId:t.ba_token||t.token,options:{validate:"vault"===e.flow&&!o}}};return t.ba_token?i.paypalAccount.billingAgreementToken=t.ba_token:(i.paypalAccount.paymentToken=t.paymentId,i.paypalAccount.payerId=t.PayerID,i.paypalAccount.unilateral=r.paypal.unvettedMerchant,e.hasOwnProperty("intent")&&(i.paypalAccount.intent=e.intent)),i},y.prototype._navigateFrameToAuth=function(e){var t=this,n=this._client,r="paypal_hermes/"+c.FLOW_ENDPOINTS[e.flow];return n.request({endpoint:r,method:"post",data:this._formatPaymentResourceData(e)}).then((function(r){var o;o="checkout"===e.flow?r.paymentResource.redirectUrl:r.agreementSetup.approvalUrl,"commit"===e.useraction&&(o=g.queryify(o,{useraction:"commit"})),window.popupBridge&&d.sendEvent(n,"paypal.tokenization.opened-popupbridge"),t._frameService.redirect(o)})).catch((function(e){var n=e.details&&e.details.httpStatus;return t._frameService.close(),t._authorizationInProgress=!1,422===n?Promise.reject(new o({type:h.PAYPAL_INVALID_PAYMENT_OPTION.type,code:h.PAYPAL_INVALID_PAYMENT_OPTION.code,message:h.PAYPAL_INVALID_PAYMENT_OPTION.message,details:{originalError:e}})):Promise.reject(i(e,{type:h.PAYPAL_FLOW_FAILED.type,code:h.PAYPAL_FLOW_FAILED.code,message:h.PAYPAL_FLOW_FAILED.message}))}))},y.prototype._formatPaymentResourceData=function(e){var t,n=this._client.getConfiguration().gatewayConfiguration,r=this._frameService._serviceId,o={returnUrl:n.paypal.assetsUrl+"/web/"+l+"/html/redirect-frame"+a(this._isDebug)+".html?channel="+r,cancelUrl:n.paypal.assetsUrl+"/web/"+l+"/html/cancel-frame"+a(this._isDebug)+".html?channel="+r,offerPaypalCredit:!0===e.offerCredit,offerPayLater:!0===e.offerPayLater,experienceProfile:{brandName:e.displayName||n.paypal.displayName,localeCode:e.locale,noShipping:(!e.enableShippingAddress).toString(),addressOverride:!1===e.shippingAddressEditable,landingPageType:e.landingPageType}};if(window.popupBridge&&"function"==typeof window.popupBridge.getReturnUrlPrefix&&(o.returnUrl=window.popupBridge.getReturnUrlPrefix()+"return",o.cancelUrl=window.popupBridge.getReturnUrlPrefix()+"cancel"),"checkout"===e.flow)for(t in o.amount=e.amount,o.currencyIsoCode=e.currency,e.hasOwnProperty("intent")&&(o.intent=e.intent),e.shippingAddressOverride)e.shippingAddressOverride.hasOwnProperty(t)&&(o[t]=e.shippingAddressOverride[t]);else o.shippingAddress=e.shippingAddressOverride,e.billingAgreementDescription&&(o.description=e.billingAgreementDescription);return o},y.prototype.closeWindow=function(){this._authorizationInProgress&&d.sendEvent(this._client,"paypal.tokenize.closed.by-merchant"),this._frameService.close()},y.prototype.focusWindow=function(){this._frameService.focus()},y.prototype.teardown=v((function(){var e=this;return e._frameService.teardown(),m(e,p(y.prototype)),d.sendEvent(e._client,"paypal.teardown-completed"),Promise.resolve()})),t.exports=y},{"../../lib/analytics":119,"../../lib/braintree-error":124,"../../lib/constants":126,"../../lib/convert-methods-to-error":127,"../../lib/convert-to-braintree-error":128,"../../lib/deferred":132,"../../lib/frame-service/external":139,"../../lib/methods":155,"../../lib/once":156,"../../lib/querystring":157,"../../lib/use-min":160,"../shared/constants":180,"../shared/errors":181,"@braintree/wrap-promise":43}],179:[function(e,t,n){"use strict";var r=e("../lib/analytics"),o=e("../lib/basic-component-verification"),i=e("../lib/create-deferred-client"),a=e("../lib/create-assets-url"),s=e("../lib/braintree-error"),l=e("./shared/errors"),c=e("./external/paypal"),u="3.102.0",d=e("@braintree/wrap-promise");function p(e){var t="PayPal";return o.verify({name:t,client:e.client,authorization:e.authorization}).then((function(){return i.create({authorization:e.authorization,client:e.client,debug:e.debug,assetsUrl:a.create(e.authorization),name:t})})).then((function(t){var n=t.getConfiguration();return e.client=t,!0!==n.gatewayConfiguration.paypalEnabled?Promise.reject(new s(l.PAYPAL_NOT_ENABLED)):(r.sendEvent(e.client,"paypal.initialized"),new c(e)._initialize())}))}function f(){return!0}t.exports={create:d(p),isSupported:f,VERSION:u}},{"../lib/analytics":119,"../lib/basic-component-verification":122,"../lib/braintree-error":124,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./external/paypal":178,"./shared/errors":181,"@braintree/wrap-promise":43}],180:[function(e,t,n){"use strict";t.exports={LANDING_FRAME_NAME:"braintreepaypallanding",FLOW_ENDPOINTS:{checkout:"create_payment_resource",vault:"setup_billing_agreement"},REQUIRED_OPTIONS:["paymentId","currency"]}},{}],181:[function(e,t,n){"use strict";var r=e("../../lib/braintree-error");t.exports={PAYPAL_NOT_ENABLED:{type:r.types.MERCHANT,code:"PAYPAL_NOT_ENABLED",message:"PayPal is not enabled for this merchant."},PAYPAL_TOKENIZATION_REQUEST_ACTIVE:{type:r.types.MERCHANT,code:"PAYPAL_TOKENIZATION_REQUEST_ACTIVE",message:"Another tokenization request is active."},PAYPAL_ACCOUNT_TOKENIZATION_FAILED:{type:r.types.NETWORK,code:"PAYPAL_ACCOUNT_TOKENIZATION_FAILED",message:"Could not tokenize user's PayPal account."},PAYPAL_FLOW_FAILED:{type:r.types.NETWORK,code:"PAYPAL_FLOW_FAILED",message:"Could not initialize PayPal flow."},PAYPAL_FLOW_OPTION_REQUIRED:{type:r.types.MERCHANT,code:"PAYPAL_FLOW_OPTION_REQUIRED",message:"PayPal flow property is invalid or missing."},PAYPAL_POPUP_OPEN_FAILED:{type:r.types.MERCHANT,code:"PAYPAL_POPUP_OPEN_FAILED",message:"PayPal popup failed to open, make sure to tokenize in response to a user action."},PAYPAL_POPUP_CLOSED:{type:r.types.CUSTOMER,code:"PAYPAL_POPUP_CLOSED",message:"Customer closed PayPal popup before authorizing."},PAYPAL_INVALID_PAYMENT_OPTION:{type:r.types.MERCHANT,code:"PAYPAL_INVALID_PAYMENT_OPTION",message:"PayPal payment options are invalid."}}},{"../../lib/braintree-error":124}],182:[function(e,t,n){"use strict";var r=e("@braintree/wrap-promise"),o=e("../lib/basic-component-verification"),i=e("./preferred-payment-methods"),a="3.102.0";function s(e){var t="PreferredPaymentMethods";return o.verify({name:t,client:e.client,authorization:e.authorization}).then((function(){return(new i).initialize(e)}))}t.exports={create:r(s),VERSION:a}},{"../lib/basic-component-verification":122,"./preferred-payment-methods":183,"@braintree/wrap-promise":43}],183:[function(e,t,n){"use strict";var r=e("@braintree/wrap-promise"),o=e("../lib/analytics"),i=e("../lib/create-assets-url"),a=e("../lib/create-deferred-client");function s(){}s.prototype.initialize=function(e){var t=this;return this._clientPromise=a.create({authorization:e.authorization,client:e.client,debug:e.debug,assetsUrl:i.create(e.authorization),name:"PreferredPaymentMethods"}).catch((function(e){return t._setupError=e,Promise.reject(e)})),o.sendEvent(this._clientPromise,"preferred-payment-methods.initialized"),Promise.resolve(this)},s.prototype.fetchPreferredPaymentMethods=function(){var e,t=this;return this._clientPromise.then((function(t){return(e=t).request({api:"graphQLApi",data:{query:"query PreferredPaymentMethods { preferredPaymentMethods { paypalPreferred venmoPreferred } }"}})})).then((function(t){var n=t.data.preferredPaymentMethods.paypalPreferred,r=t.data.preferredPaymentMethods.venmoPreferred;return o.sendEvent(e,"preferred-payment-methods.paypal.api-detected."+n),o.sendEvent(e,"preferred-payment-methods.venmo.api-detected."+r),{paypalPreferred:n,venmoPreferred:r}})).catch((function(){return t._setupError?Promise.reject(t._setupError):(o.sendEvent(e,"preferred-payment-methods.api-error"),{paypalPreferred:!1,venmoPreferred:!1})}))},t.exports=r.wrapPrototype(s)},{"../lib/analytics":119,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"@braintree/wrap-promise":43}],184:[function(e,t,n){"use strict";var r=e("../../lib/braintree-error"),o=e("../shared/errors"),i=e("../../lib/frame-service/external"),a=e("../../lib/analytics"),s=e("../../lib/use-min"),l=e("../shared/constants").BILLING_ADDRESS_OPTIONS,c=e("../../lib/snake-case-to-camel-case"),u=400,d=570;function p(e,t){var n={sepa_debit:{account_holder_name:t.accountHolderName,billing_address:{country_code:t.countryCode},iban:t.iban,merchant_or_partner_customer_id:t.customerId,mandate_type:t.mandateType},locale:t.locale,cancel_url:t.cancelUrl,return_url:t.returnUrl,merchant_account_id:t.merchantAccountId};return t.billingAddress&&l.forEach((function(e){var r=c(e);r in t.billingAddress&&(n.sepa_debit.billing_address[e]=t.billingAddress[r])})),e.request({api:"clientApi",method:"post",endpoint:"sepa_debit",data:n}).then((function(e){var t=e.message.body.sepaDebitAccount;if(!t)throw new r(o.SEPA_CREATE_MANDATE_FAILED);return{approvalUrl:t.approvalUrl,last4:t.last4,bankReferenceToken:t.bankReferenceToken}})).catch((function(){throw new r(o.SEPA_CREATE_MANDATE_FAILED)}))}function f(e,t){var n="sepadirectdebit",l=t.assetsUrl+"/html",c=t.debug||!1;return new Promise((function(p,f){var v=g();i.create({name:n,dispatchFrameUrl:l+"/dispatch-frame"+s(c)+".html",openFrameUrl:l+"/sepa-landing-frame"+s(c)+".html",top:v.top,left:v.left,height:d,width:u},(function(n){a.sendEvent(e,"sepa.popup.initialized"),n.open({},(function(e,t){return h(t)?(n.close(),p()):m(t,e)?(n.close(),f(new r(o.SEPA_CUSTOMER_CANCELED))):(n.close(),f(new r(o.SEPA_TOKENIZATION_FAILED)))})),n.redirect(t.approvalUrl)}))}))}function h(e){return e&&e.success}function m(e,t){return e&&e.cancel||t&&"FRAME_SERVICE_FRAME_CLOSED"===t.code}function g(){return{top:Math.round((window.outerHeight-d)/2)+window.screenTop,left:Math.round((window.outerWidth-u)/2)+window.screenLeft}}function v(e,t){var n={sepa_debit_account:{last_4:t.last4,merchant_or_partner_customer_id:t.customerId,bank_reference_token:t.bankReferenceToken,mandate_type:t.mandateType},merchant_account_id:t.merchantAccountId};return e.request({api:"clientApi",method:"post",endpoint:"payment_methods/sepa_debit_accounts",data:n}).then((function(e){if(!e.nonce)throw new r(o.SEPA_TRANSACTION_FAILED);return{nonce:e.nonce,ibanLastFour:t.last4,customerId:t.customerId,mandateType:t.mandateType}})).catch((function(){throw new r(o.SEPA_TRANSACTION_FAILED)}))}t.exports={createMandate:p,openPopup:f,handleApproval:v,POPUP_WIDTH:u,POPUP_HEIGHT:d}},{"../../lib/analytics":119,"../../lib/braintree-error":124,"../../lib/frame-service/external":139,"../../lib/snake-case-to-camel-case":159,"../../lib/use-min":160,"../shared/constants":187,"../shared/errors":188}],185:[function(e,t,n){"use strict";var r=e("@braintree/wrap-promise"),o=e("../../lib/braintree-error"),i=e("../shared/errors"),a=e("../shared/constants"),s=e("./mandate"),l=e("../shared/has-missing-option"),c=e("../../lib/analytics"),u="3.102.0",d=e("../../lib/assign").assign;function p(e){var t=e.client.getConfiguration();this._client=e.client,this._assetsUrl=t.gatewayConfiguration.assetsUrl+"/web/"+u,this._isDebug=t.isDebug,this._returnUrl=this._assetsUrl+"/html/redirect-frame.html?success=1",this._cancelUrl=this._assetsUrl+"/html/redirect-frame.html?cancel=1",c.sendEvent(this._client,"sepa.component.initialized")}p.prototype.tokenize=function(e){var t=this,n=d({cancelUrl:t._cancelUrl,returnUrl:t._returnUrl},e);return!e||l(e,a.REQUIRED_OPTIONS)?(c.sendEvent(t._client,"sepa.input-validation.missing-options"),Promise.reject(new o(i.SEPA_TOKENIZE_MISSING_REQUIRED_OPTION))):a.MANDATE_TYPE_ENUM.includes(e.mandateType)?s.createMandate(t._client,n).then((function(n){return c.sendEvent(t._client,"sepa.create-mandate.success"),e.last4=n.last4,e.bankReferenceToken=n.bankReferenceToken,s.openPopup(t._client,{approvalUrl:n.approvalUrl,assetsUrl:t._assetsUrl})})).then((function(){return c.sendEvent(t._client,"sepa.mandate.approved"),s.handleApproval(t._client,{bankReferenceToken:e.bankReferenceToken,last4:e.last4,customerId:e.customerId,mandateType:e.mandateType,merchantAccountId:e.merchantAccountId})})).then((function(e){return c.sendEvent(t._client,"sepa.tokenization.success"),Promise.resolve(e)})).catch((function(e){return c.sendEvent(t._client,"sepa."+e.details+".failed"),Promise.reject(e)})):(c.sendEvent(t._client,"sepa.input-validation.invalid-mandate"),Promise.reject(new o(i.SEPA_INVALID_MANDATE_TYPE)))},t.exports=r.wrapPrototype(p)},{"../../lib/analytics":119,"../../lib/assign":121,"../../lib/braintree-error":124,"../shared/constants":187,"../shared/errors":188,"../shared/has-missing-option":189,"./mandate":184,"@braintree/wrap-promise":43}],186:[function(e,t,n){"use strict";var r=e("../lib/analytics"),o=e("./external/sepa"),i=e("../lib/create-assets-url"),a=e("../lib/create-deferred-client"),s=e("../lib/basic-component-verification"),l=e("@braintree/wrap-promise"),c="3.102.0";function u(e){var t="SEPA";return s.verify({name:t,client:e.client,authorization:e.authorization}).then((function(){return a.create({authorization:e.authorization,client:e.client,debug:e.debug,assetsUrl:i.create(e.authorization),name:t})})).then((function(t){return e.client=t,r.sendEvent(e.client,"sepa.client.initialized"),new o(e)}))}t.exports={create:l(u),VERSION:c}},{"../lib/analytics":119,"../lib/basic-component-verification":122,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./external/sepa":185,"@braintree/wrap-promise":43}],187:[function(e,t,n){"use strict";t.exports={REQUIRED_OPTIONS:["iban","merchantAccountId","mandateType","customerId","accountHolderName","countryCode"],BILLING_ADDRESS_OPTIONS:["address_line_1","address_line_2","admin_area_1","admin_area_2","postal_code"],MANDATE_TYPE_ENUM:["ONE_OFF","RECURRENT"]}},{}],188:[function(e,t,n){"use strict";var r=e("../../lib/braintree-error");t.exports={SEPA_CREATE_MANDATE_FAILED:{type:r.types.MERCHANT,code:"SEPA_CREATE_MANDATE_FAILED",message:"SEPA create mandate failed.",details:"create-mandate"},SEPA_CUSTOMER_CANCELED:{type:r.types.CUSTOMER,code:"SEPA_CUSTOMER_CANCELED",message:"User canceled SEPA authorization",details:"customer-canceled"},SEPA_INVALID_MANDATE_TYPE:{type:r.types.MERCHANT,code:"SEPA_INVALID_MANDATE_TYPE",message:"SEPA mandate type is invalid"},SEPA_TOKENIZATION_FAILED:{type:r.types.UNKNOWN,code:"SEPA_TOKENIZATION_FAILED",message:"SEPA encountered a problem",details:"open-popup"},SEPA_TOKENIZE_MISSING_REQUIRED_OPTION:{type:r.types.MERCHANT,code:"SEPA_TOKENIZE_MISSING_REQUIRED_OPTION",message:"Missing required option for tokenize."},SEPA_TRANSACTION_FAILED:{type:r.types.UNKNOWN,code:"SEPA_TRANSACTION_FAILED",message:"SEPA transaction failed",details:"handle-approval"}}},{"../../lib/braintree-error":124}],189:[function(e,t,n){"use strict";function r(e,t){var n,r;for(t=t||[],n=0;n<t.length;n++)if(r=t[n],!e.hasOwnProperty(r))return!0;return!1}t.exports=r},{}],190:[function(e,t,n){"use strict";var r=e("../../../lib/assign").assign,o=e("../../../lib/analytics"),i=e("../../../lib/braintree-error"),a=e("../../../lib/is-verified-domain"),s=e("@braintree/extended-promise"),l=e("@braintree/event-emitter"),c=e("../../shared/errors"),u=e("@braintree/iframer"),d=e("framebus"),p=e("../../shared/constants"),f=e("@braintree/uuid"),h=e("../../shared/events"),m=e("../../../lib/use-min"),g=e("../../../lib/constants").BUS_CONFIGURATION_REQUEST_EVENT,v="3.102.0",y=400,b=400;function _(e){l.call(this),this._client=e.client,this._createPromise=e.createPromise,this._createOptions=e,this._client?(this._isDebug=this._client.getConfiguration().isDebug,this._assetsUrl=this._client.getConfiguration().gatewayConfiguration.assetsUrl):(this._isDebug=Boolean(e.isDebug),this._assetsUrl=e.assetsUrl),this._assetsUrl=this._assetsUrl+"/web/"+v}s.suppressUnhandledPromiseMessage=!0,l.createChild(_),_.prototype._waitForClient=function(){return this._client?Promise.resolve():this._createPromise.then(function(e){this._client=e}.bind(this))},_.prototype.setUpEventListeners=function(){throw new i(c.THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED)},_.prototype.verifyCard=function(e,t){var n,r,i=this;return t=t||{},(r=this._checkForVerifyCardError(e,t))?Promise.reject(r):(this._verifyCardInProgress=!0,n=this._formatVerifyCardOptions(e),this._formatLookupData(n).then((function(e){return o.sendEvent(i._createPromise,"three-d-secure.verification-flow.started"),i._performLookup(n.nonce,e)})).then((function(e){return o.sendEvent(i._createPromise,"three-d-secure.verification-flow.3ds-version."+e.lookup.threeDSecureVersion),i._onLookupComplete(e,n)})).then((function(e){return i.initializeChallengeWithLookupResponse(e,n)})).then((function(e){return i._resetVerificationState(),o.sendEvent(i._createPromise,"three-d-secure.verification-flow.completed"),e})).catch((function(e){return i._resetVerificationState(),o.sendEvent(i._createPromise,"three-d-secure.verification-flow.failed"),Promise.reject(e)})))},_.prototype._checkForFrameworkSpecificVerifyCardErrors=function(){throw new i(c.THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED)},_.prototype._presentChallenge=function(){throw new i(c.THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED)},_.prototype.prepareLookup=function(){throw new i(c.THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED)},_.prototype._resetVerificationState=function(){this._verifyCardInProgress=!1,this._verifyCardPromisePlus=null,"function"==typeof this._reloadThreeDSecure&&this._reloadThreeDSecure()},_.prototype._performLookup=function(e,t){var n=this,r="payment_methods/"+e+"/three_d_secure/lookup";return this._waitForClient().then((function(){return n._client.request({endpoint:r,method:"post",data:t}).catch((function(e){var t,r=e&&e.details&&e.details.httpStatus,a="three-d-secure.verification-flow.lookup-failed";return 404===r?(t=c.THREEDS_LOOKUP_TOKENIZED_CARD_NOT_FOUND_ERROR,a+=".404"):422===r?(t=c.THREEDS_LOOKUP_VALIDATION_ERROR,a+=".422"):t=c.THREEDS_LOOKUP_ERROR,o.sendEvent(n._createPromise,a),Promise.reject(new i({type:t.type,code:t.code,message:t.message,details:{originalError:e}}))}))}))},_.prototype._checkForVerifyCardError=function(e,t){var n;return!0===this._verifyCardInProgress?new i(c.THREEDS_AUTHENTICATION_IN_PROGRESS):(e.nonce?e.amount||(n="an amount"):n="a nonce",n||(n=this._checkForFrameworkSpecificVerifyCardErrors(e,t)),n?new i({type:c.THREEDS_MISSING_VERIFY_CARD_OPTION.type,code:c.THREEDS_MISSING_VERIFY_CARD_OPTION.code,message:"verifyCard options must include "+n+"."}):null)},_.prototype.initializeChallengeWithLookupResponse=function(e,t){var n=this;return t=t||{},this._lookupPaymentMethod=e.paymentMethod,n._verifyCardPromisePlus=n._verifyCardPromisePlus||new s,n._handleLookupResponse(e,t),n._verifyCardPromisePlus.then((function(e){return o.sendEvent(n._createPromise,"three-d-secure.verification-flow.liability-shifted."+String(e.liabilityShifted)),o.sendEvent(n._createPromise,"three-d-secure.verification-flow.liability-shift-possible."+String(e.liabilityShiftPossible)),e}))},_.prototype._handleLookupResponse=function(e,t){var n,r=Boolean(e.lookup&&e.lookup.acsUrl);o.sendEvent(this._createPromise,"three-d-secure.verification-flow.challenge-presented."+String(r)),r?this._presentChallenge(e,t):((n=this._formatAuthResponse(e.paymentMethod,e.threeDSecureInfo)).verificationDetails=e.threeDSecureInfo,this._verifyCardPromisePlus.resolve(n))},_.prototype._onLookupComplete=function(e){return this._lookupPaymentMethod=e.paymentMethod,this._verifyCardPromisePlus=new s,Promise.resolve(e)},_.prototype._formatAuthResponse=function(e,t){return{nonce:e.nonce,type:e.type,binData:e.binData,details:e.details,description:e.description&&e.description.replace(/\+/g," "),liabilityShifted:t&&t.liabilityShifted,liabilityShiftPossible:t&&t.liabilityShiftPossible,threeDSecureInfo:e.threeDSecureInfo}},_.prototype._formatVerifyCardOptions=function(e){return r({},e)},_.prototype._formatLookupData=function(e){var t={amount:e.amount};return!0===e.collectDeviceData&&(t.browserColorDepth=window.screen.colorDepth,t.browserJavaEnabled=window.navigator.javaEnabled(),t.browserJavascriptEnabled=!0,t.browserLanguage=window.navigator.language,t.browserScreenHeight=window.screen.height,t.browserScreenWidth=window.screen.width,t.browserTimeZone=(new Date).getTimezoneOffset(),t.deviceChannel="Browser"),Promise.resolve(t)},_.prototype._handleV1AuthResponse=function(e){var t=JSON.parse(e.auth_response);t.success?this._verifyCardPromisePlus.resolve(this._formatAuthResponse(t.paymentMethod,t.threeDSecureInfo)):t.threeDSecureInfo&&t.threeDSecureInfo.liabilityShiftPossible?this._verifyCardPromisePlus.resolve(this._formatAuthResponse(this._lookupPaymentMethod,t.threeDSecureInfo)):this._verifyCardPromisePlus.reject(new i({type:i.types.UNKNOWN,code:"UNKNOWN_AUTH_RESPONSE",message:t.error.message}))},_.prototype.cancelVerifyCard=function(){var e,t;return this._verifyCardInProgress=!1,this._lookupPaymentMethod?(t=this._lookupPaymentMethod.threeDSecureInfo,e=r({},this._lookupPaymentMethod,{liabilityShiftPossible:t&&t.liabilityShiftPossible,liabilityShifted:t&&t.liabilityShifted,verificationDetails:t&&t.verificationDetails}),Promise.resolve(e)):Promise.reject(new i(c.THREEDS_NO_VERIFICATION_PAYLOAD))},_.prototype._setupV1Bus=function(e){var t=this._client.getConfiguration(),n=window.location.href.split("#")[0],r=e.lookupResponse,o=f(),i=new d({channel:o,verifyDomain:a}),s=this._assetsUrl+"/html/three-d-secure-authentication-complete-frame.html?channel="+encodeURIComponent(o)+"&";return i.on(g,(function(o){o({clientConfiguration:t,nonce:e.nonce,acsUrl:r.acsUrl,pareq:r.pareq,termUrl:r.termUrl+"&three_d_secure_version="+v+"&authentication_complete_base_url="+encodeURIComponent(s),md:r.md,parentUrl:n})})),i.on(h.AUTHENTICATION_COMPLETE,e.handleAuthResponse),i},_.prototype._setupV1Iframe=function(e){var t=this._assetsUrl+"/html/three-d-secure-bank-frame"+m(this._isDebug)+".html?showLoader="+e.showLoader;return u({src:t,height:y,width:b,name:p.LANDING_FRAME_NAME+"_"+this._v1Bus.channel,title:"3D Secure Authorization Frame"})},_.prototype._setupV1Elements=function(e){this._v1Bus=this._setupV1Bus(e),this._v1Iframe=this._setupV1Iframe(e)},_.prototype._teardownV1Elements=function(){this._v1Bus&&(this._v1Bus.teardown(),this._v1Bus=null),this._v1Iframe&&this._v1Iframe.parentNode&&(this._v1Iframe.parentNode.removeChild(this._v1Iframe),this._v1Iframe=null),this._onV1Keyup&&(document.removeEventListener("keyup",this._onV1Keyup),this._onV1Keyup=null)},_.prototype.teardown=function(){return o.sendEvent(this._createPromise,"three-d-secure.teardown-completed"),this._teardownV1Elements(),Promise.resolve()},t.exports=_},{"../../../lib/analytics":119,"../../../lib/assign":121,"../../../lib/braintree-error":124,"../../../lib/constants":126,"../../../lib/is-verified-domain":153,"../../../lib/use-min":160,"../../shared/constants":199,"../../shared/errors":200,"../../shared/events":201,"@braintree/event-emitter":33,"@braintree/extended-promise":34,"@braintree/iframer":35,"@braintree/uuid":39,framebus:52}],191:[function(e,t,n){"use strict";var r=e("./songbird");function o(e){r.call(this,e)}o.prototype=Object.create(r.prototype,{constructor:r}),o.prototype._createV1IframeModalElement=function(e){var t=document.createElement("div");return t.innerHTML='<div class="modal fade in" tabindex="-1" role="dialog" aria-labelledby="CCAFrameModal-label" aria-hidden="true" style="display: block;"><div class="modal-dialog" style="width:440px;z-index:999999;"><div class="modal-content"><div class="modal-body" data-braintree-v1-fallback-iframe-container><button type="button" data-braintree-v1-fallback-close-button class="close" data-dismiss="modal" aria-hidden="true">×</button></div></div></div><div data-braintree-v1-fallback-backdrop style="position: fixed;cursor: pointer;z-index: 999998;top: 0;left: 0;width: 100%;height: 100%;"></div></div>',t.querySelector("[data-braintree-v1-fallback-iframe-container]").appendChild(e),t},o.prototype._createCardinalConfigurationOptions=function(e){var t=r.prototype._createCardinalConfigurationOptions.call(this,e);return t.payment.framework="bootstrap3",t},t.exports=o},{"./songbird":196}],192:[function(e,t,n){"use strict";var r=e("./songbird");function o(e){r.call(this,e)}o.prototype=Object.create(r.prototype,{constructor:r}),o.prototype._createV1IframeModalElement=function(e){var t=document.createElement("div"),n=Boolean(this._createOptions&&this._createOptions.cardinalSDKConfig&&this._createOptions.cardinalSDKConfig.payment&&this._createOptions.cardinalSDKConfig.payment.displayExitButton);return t.innerHTML='<div style="position: fixed;z-index: 999999;top: 50%;left: 50%;padding: 24px 20px;transform: translate(-50%,-50%);border-radius: 2px;background: #fff;max-width: 100%;overflow: auto;"><div><button data-braintree-v1-fallback-close-button style="font-family: Helvetica,Arial,sans-serif;font-size: 25px;line-height: 12px;position: absolute;top: 2px;right: 0px;cursor: pointer;color: #999;border: 0;outline: none;background: none;" onMouseOver="this.style.color=\'#000\'" onMouseOut="this.style.color=\'#999\'">×</button></div><div data-braintree-v1-fallback-iframe-container style="height: 400px;"></div></div><div data-braintree-v1-fallback-backdrop style="position: fixed;z-index: 999998;cursor: pointer;top: 0;left: 0;width: 100%;height: 100%;transition: opacity 1ms ease;background: rgba(0,0,0,.6);"></div>',n||(t.querySelector("[data-braintree-v1-fallback-close-button]").style.display="none"),t.querySelector("[data-braintree-v1-fallback-iframe-container]").appendChild(e),t},t.exports=o},{"./songbird":196}],193:[function(e,t,n){"use strict";var r=e("./legacy"),o=e("./cardinal-modal"),i=e("./bootstrap3-modal"),a=e("./inline-iframe");t.exports={legacy:r,"cardinal-modal":o,"bootstrap3-modal":i,"inline-iframe":a}},{"./bootstrap3-modal":191,"./cardinal-modal":192,"./inline-iframe":194,"./legacy":195}],194:[function(e,t,n){"use strict";var r=e("./songbird"),o=e("../../../lib/braintree-error"),i=e("../../shared/errors"),a=e("../../../lib/enumerate");function s(e){r.call(this,e)}s.prototype=Object.create(r.prototype,{constructor:r}),s.events=a(["AUTHENTICATION_IFRAME_AVAILABLE"],"inline-iframe-framework:"),s.prototype.setUpEventListeners=function(e){r.prototype.setUpEventListeners.call(this,e),this.on(s.events.AUTHENTICATION_IFRAME_AVAILABLE,(function(t,n){e("authentication-iframe-available",t,n)}))},s.prototype._createCardinalConfigurationOptions=function(e){var t=r.prototype._createCardinalConfigurationOptions.call(this,e);return t.payment.framework="inline",t},s.prototype._addV1IframeToPage=function(){this._emit(s.events.AUTHENTICATION_IFRAME_AVAILABLE,{element:this._v1Modal},(function(){}))},s.prototype._setupFrameworkSpecificListeners=function(){this.setCardinalListener("ui.inline.setup",this._onInlineSetup.bind(this))},s.prototype._onInlineSetup=function(e,t,n,r){var a,l;e&&t?("CCA"!==t.paymentType||"suppress"!==t.data.mode&&"static"!==t.data.mode)&&(l=!0):l=!0,l?r(new o(i.THREEDS_INLINE_IFRAME_DETAILS_INCORRECT)):((a=document.createElement("div")).innerHTML=e,"suppress"===t.data.mode?(a.style.display="none",document.body.appendChild(a),n()):"static"===t.data.mode&&this._emit(s.events.AUTHENTICATION_IFRAME_AVAILABLE,{element:a},(function(){n()})))},t.exports=s},{"../../../lib/braintree-error":124,"../../../lib/enumerate":134,"../../shared/errors":200,"./songbird":196}],195:[function(e,t,n){"use strict";var r=e("./base"),o=e("../../../lib/deferred");function i(e){r.call(this,e)}i.prototype=Object.create(r.prototype,{constructor:i}),i.prototype.setUpEventListeners=function(){},i.prototype.transformV1CustomerBillingAddress=function(e){return e.billingAddress.line1=e.billingAddress.streetAddress,e.billingAddress.line2=e.billingAddress.extendedAddress,e.billingAddress.city=e.billingAddress.locality,e.billingAddress.state=e.billingAddress.region,e.billingAddress.countryCode=e.billingAddress.countryCodeAlpha2,delete e.billingAddress.streetAddress,delete e.billingAddress.extendedAddress,delete e.billingAddress.locality,delete e.billingAddress.region,delete e.billingAddress.countryCodeAlpha2,e},i.prototype._createIframe=function(e){var t=this;return this._setupV1Elements({nonce:e.nonce,lookupResponse:e.lookupResponse,showLoader:e.showLoader,handleAuthResponse:function(n){t._handleAuthResponse(n,e)}}),this._v1Iframe},i.prototype._handleAuthResponse=function(e,t){this._v1Bus.teardown(),t.removeFrame(),o(function(){this._handleV1AuthResponse(e)}.bind(this))()},i.prototype._checkForFrameworkSpecificVerifyCardErrors=function(e){var t;return"function"!=typeof e.addFrame?t="an addFrame function":"function"!=typeof e.removeFrame&&(t="a removeFrame function"),t},i.prototype._formatVerifyCardOptions=function(e){var t=r.prototype._formatVerifyCardOptions.call(this,e);return t.addFrame=o(e.addFrame),t.removeFrame=o(e.removeFrame),t.showLoader=!1!==e.showLoader,t},i.prototype._formatLookupData=function(e){var t=this;return r.prototype._formatLookupData.call(this,e).then((function(n){return e.customer&&e.customer.billingAddress&&(n.customer=t.transformV1CustomerBillingAddress(e.customer)),n}))},i.prototype._presentChallenge=function(e,t){t.addFrame(null,this._createIframe({showLoader:t.showLoader,lookupResponse:e.lookup,nonce:e.paymentMethod.nonce,removeFrame:t.removeFrame}))},t.exports=i},{"../../../lib/deferred":132,"./base":190}],196:[function(e,t,n){"use strict";var r=e("./base"),o=e("../../../lib/assign").assign,i=e("../../../lib/deferred"),a=e("../../../lib/braintree-error"),s=e("../../../lib/convert-to-braintree-error"),l=e("../../../lib/analytics"),c=e("../../../lib/assets"),u=e("../../shared/errors"),d=e("../../../lib/enumerate"),p=e("../../shared/constants"),f=e("@braintree/extended-promise"),h=e("../../../lib/constants").INTEGRATION_TIMEOUT_MS,m=e("../../../lib/constants").PLATFORM,g="3.102.0",v="01",y=["ui.close","ui.render","ui.renderHidden","ui.loading.close","ui.loading.render"],b=["low_value","transaction_risk_analysis"];function _(e){r.call(this,e),this._songbirdInitFailed=!1,this._clientMetadata={requestedThreeDSecureVersion:"2",sdkVersion:m+"/"+g},this.originalSetupOptions=e,this._getDfReferenceIdPromisePlus=new f,this.setupSongbird(e),this._cardinalEvents=[]}function A(e,t,n){t[n+"Line1"]=e.streetAddress,t[n+"Line2"]=e.extendedAddress,t[n+"Line3"]=e.line3,t[n+"City"]=e.locality,t[n+"State"]=e.region,t[n+"PostalCode"]=e.postalCode,t[n+"CountryCode"]=e.countryCodeAlpha2}f.suppressUnhandledPromiseMessage=!0,_.prototype=Object.create(r.prototype,{constructor:_}),_.events=d(["LOOKUP_COMPLETE","CUSTOMER_CANCELED","UI.CLOSE","UI.RENDER","UI.RENDERHIDDEN","UI.LOADING.CLOSE","UI.LOADING.RENDER"],"songbird-framework:"),_.prototype.setUpEventListeners=function(e){this.on(_.events.LOOKUP_COMPLETE,(function(t,n){e("lookup-complete",t,n)})),this.on(_.events.CUSTOMER_CANCELED,(function(){e("customer-canceled")})),this.on(_.events["UI.CLOSE"],(function(){e("authentication-modal-close")})),this.on(_.events["UI.RENDER"],(function(){e("authentication-modal-render")})),this.on(_.events["UI.RENDERHIDDEN"],(function(){e("authentication-modal-render-hidden")})),this.on(_.events["UI.LOADING.CLOSE"],(function(){e("authentication-modal-loader-close")})),this.on(_.events["UI.LOADING.RENDER"],(function(){e("authentication-modal-loader-render")}))},_.prototype.prepareLookup=function(e){var t=o({},e),n=this;return this.getDfReferenceId().then((function(e){t.dfReferenceId=e})).then((function(){return n._triggerCardinalBinProcess(e.bin)})).catch((function(){})).then((function(){return n._waitForClient()})).then((function(){return t.clientMetadata=n._clientMetadata,t.authorizationFingerprint=n._client.getConfiguration().authorizationFingerprint,t.braintreeLibraryVersion="braintree/web/"+g,t}))},_.prototype.initializeChallengeWithLookupResponse=function(e,t){return this.setupSongbird().then(function(){return r.prototype.initializeChallengeWithLookupResponse.call(this,e,t)}.bind(this))},_.prototype.handleSongbirdError=function(e){this._songbirdInitFailed=!0,this._removeSongbirdListeners(),l.sendEvent(this._createPromise,"three-d-secure.cardinal-sdk.songbird-error."+e),this._songbirdPromise&&this._songbirdPromise.resolve()},_.prototype._triggerCardinalBinProcess=function(e){var t=this,n=Date.now();return window.Cardinal.trigger("bin.process",e).then((function(e){t._clientMetadata.issuerDeviceDataCollectionTimeElapsed=Date.now()-n,t._clientMetadata.issuerDeviceDataCollectionResult=e&&e.Status}))},_.prototype.transformBillingAddress=function(e,t){return t&&(A(t,e,"billing"),e.billingPhoneNumber=t.phoneNumber,e.billingGivenName=t.givenName,e.billingSurname=t.surname),e},_.prototype.transformShippingAddress=function(e){var t=e.shippingAddress;return t&&(A(t,e,"shipping"),delete e.shippingAddress),e},_.prototype._createV1IframeModalElement=function(e){var t=document.createElement("div");return t.innerHTML='<div data-braintree-v1-fallback-iframe-container="true" style="height: 400px;"></div>',t.querySelector('[data-braintree-v1-fallback-iframe-container="true"]').appendChild(e),t},_.prototype._createV1IframeModal=function(e){var t=this._createV1IframeModalElement(e),n=t.querySelector("[data-braintree-v1-fallback-close-button]"),r=t.querySelector("[data-braintree-v1-fallback-backdrop]"),o=this;function i(){t.parentNode.removeChild(t),o.cancelVerifyCard(u.THREEDS_CARDINAL_SDK_CANCELED),document.removeEventListener("keyup",o._onV1Keyup),o._onV1Keyup=null}return this._onV1Keyup=function(e){"Escape"===e.key&&t.parentNode&&i()},n&&n.addEventListener("click",i),r&&r.addEventListener("click",i),document.addEventListener("keyup",this._onV1Keyup),t},_.prototype._addV1IframeToPage=function(){document.body.appendChild(this._v1Modal)},_.prototype.setupSongbird=function(e){var t=this,n=Date.now();return this._songbirdPromise||(e=e||{},this._songbirdPromise=new f,this._v2SetupFailureReason="reason-unknown",t._loadCardinalScript(e).then((function(){return window.Cardinal?t._configureCardinalSdk({setupOptions:e,setupStartTime:n}):(t._v2SetupFailureReason="cardinal-global-unavailable",Promise.reject(new a(u.THREEDS_CARDINAL_SDK_SETUP_FAILED)))})).catch((function(e){var n=s(e,{type:u.THREEDS_CARDINAL_SDK_SETUP_FAILED.type,code:u.THREEDS_CARDINAL_SDK_SETUP_FAILED.code,message:u.THREEDS_CARDINAL_SDK_SETUP_FAILED.message});t._getDfReferenceIdPromisePlus.reject(n),window.clearTimeout(t._songbirdSetupTimeoutReference),l.sendEvent(t._client,"three-d-secure.cardinal-sdk.init.setup-failed"),t.handleSongbirdError("cardinal-sdk-setup-failed."+t._v2SetupFailureReason)}))),this._songbirdPromise},_.prototype._configureCardinalSdk=function(e){var t=this;return this._waitForClient().then((function(){return t._client.getConfiguration().gatewayConfiguration.threeDSecure})).then((function(n){var r=n.cardinalAuthenticationJWT,o=e.setupOptions,i=e.setupStartTime,a=t._createCardinalConfigurationOptions(o);y.forEach((function(e){t.setCardinalListener(e,(function(){t._emit(_.events[e.toUpperCase()])}))})),t.setCardinalListener("payments.setupComplete",t._createPaymentsSetupCompleteCallback()),t._setupFrameworkSpecificListeners(),window.Cardinal.configure(a),window.Cardinal.setup("init",{jwt:r}),t._clientMetadata.cardinalDeviceDataCollectionTimeElapsed=Date.now()-i,t.setCardinalListener("payments.validated",t._createPaymentsValidatedCallback())})).catch((function(e){return t._v2SetupFailureReason="cardinal-configuration-threw-error",Promise.reject(e)}))},_.prototype.setCardinalListener=function(e,t){this._cardinalEvents.push(e),window.Cardinal.on(e,t)},_.prototype._setupFrameworkSpecificListeners=function(){},_.prototype._createCardinalConfigurationOptions=function(e){var t=e.cardinalSDKConfig||{},n=t.payment||{};return!t.logging&&e.loggingEnabled&&(t.logging={level:"verbose"}),t.payment={},n.hasOwnProperty("displayLoading")&&(t.payment.displayLoading=n.displayLoading),n.hasOwnProperty("displayExitButton")&&(t.payment.displayExitButton=n.displayExitButton),t},_.prototype._loadCardinalScript=function(e){var t=this;return this._waitForClient().then((function(){var n=t._getCardinalScriptSource();return t._songbirdSetupTimeoutReference=window.setTimeout((function(){l.sendEvent(t._client,"three-d-secure.cardinal-sdk.init.setup-timeout"),t.handleSongbirdError("cardinal-sdk-setup-timeout")}),e.timeout||h),c.loadScript({src:n})})).catch((function(e){return t._v2SetupFailureReason="songbird-js-failed-to-load",Promise.reject(s(e,u.THREEDS_CARDINAL_SDK_SCRIPT_LOAD_FAILED))}))},_.prototype._getCardinalScriptSource=function(){var e=this._client.getConfiguration().gatewayConfiguration;return e&&"production"===e.environment?p.CARDINAL_SCRIPT_SOURCE.production:p.CARDINAL_SCRIPT_SOURCE.sandbox},_.prototype._createPaymentsSetupCompleteCallback=function(){var e=this;return function(t){e._getDfReferenceIdPromisePlus.resolve(t.sessionId),window.clearTimeout(e._songbirdSetupTimeoutReference),l.sendEvent(e._createPromise,"three-d-secure.cardinal-sdk.init.setup-completed"),e._songbirdPromise.resolve()}},_.prototype.getDfReferenceId=function(){return this._getDfReferenceIdPromisePlus},_.prototype._performJWTValidation=function(e,t){var n=this,r=this._lookupPaymentMethod.nonce,o="payment_methods/"+r+"/three_d_secure/authenticate_from_jwt",i=e&&e.Payment&&e.Payment.ExtendedData&&e.Payment.ExtendedData.ChallengeCancel;return i&&(l.sendEvent(this._createPromise,"three-d-secure.verification-flow.cardinal-sdk.cancel-code."+i),i===v&&this._emit(_.events.CUSTOMER_CANCELED)),l.sendEvent(this._createPromise,"three-d-secure.verification-flow.upgrade-payment-method.started"),this._waitForClient().then((function(){return n._client.request({method:"post",endpoint:o,data:{jwt:t,paymentMethodNonce:r}})})).then((function(t){var r=t.paymentMethod||n._lookupPaymentMethod,o=n._formatAuthResponse(r,t.threeDSecureInfo);return o.rawCardinalSDKVerificationData=e,l.sendEvent(n._client,"three-d-secure.verification-flow.upgrade-payment-method.succeeded"),Promise.resolve(o)})).catch((function(e){var t=new a({type:u.THREEDS_JWT_AUTHENTICATION_FAILED.type,code:u.THREEDS_JWT_AUTHENTICATION_FAILED.code,message:u.THREEDS_JWT_AUTHENTICATION_FAILED.message,details:{originalError:e}});return l.sendEvent(n._client,"three-d-secure.verification-flow.upgrade-payment-method.errored"),Promise.reject(t)}))},_.prototype._createPaymentsValidatedCallback=function(){var e=this;return function(t,n){var r;if(l.sendEvent(e._createPromise,"three-d-secure.verification-flow.cardinal-sdk.action-code."+t.ActionCode.toLowerCase()),e._verifyCardPromisePlus)switch(t.ActionCode){case"SUCCESS":case"NOACTION":case"FAILURE":e._performJWTValidation(t,n).then((function(t){e._verifyCardPromisePlus.resolve(t)})).catch((function(t){e._verifyCardPromisePlus.reject(t)}));break;case"ERROR":switch(l.sendEvent(e._createPromise,"three-d-secure.verification-flow.cardinal-sdk-error."+t.ErrorNumber),t.ErrorNumber){case 10001:case 10002:r=new a(u.THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT);break;case 10003:case 10007:case 10009:r=new a(u.THREEDS_CARDINAL_SDK_RESPONSE_TIMEDOUT);break;case 10005:case 10006:r=new a(u.THREEDS_CARDINAL_SDK_BAD_CONFIG);break;case 10008:case 10010:r=new a(u.THREEDS_CARDINAL_SDK_BAD_JWT);break;case 10011:l.sendEvent(e._createPromise,"three-d-secure.verification-flow.canceled"),r=new a(u.THREEDS_CARDINAL_SDK_CANCELED);break;default:r=new a(u.THREEDS_CARDINAL_SDK_ERROR)}r.details={originalError:{code:t.ErrorNumber,description:t.ErrorDescription}},e._verifyCardPromisePlus.reject(r)}else e.handleSongbirdError("cardinal-sdk-setup-error.number-"+t.ErrorNumber)}},_.prototype._checkForVerifyCardError=function(e,t){return e.bin?r.prototype._checkForVerifyCardError.call(this,e,t):new a({type:u.THREEDS_MISSING_VERIFY_CARD_OPTION.type,code:u.THREEDS_MISSING_VERIFY_CARD_OPTION.code,message:"verifyCard options must include a BIN."})},_.prototype._checkForFrameworkSpecificVerifyCardErrors=function(e,t){var n;return"function"==typeof e.onLookupComplete||t.ignoreOnLookupCompleteRequirement||(n="an onLookupComplete function"),n},_.prototype._formatVerifyCardOptions=function(e){var t=r.prototype._formatVerifyCardOptions.call(this,e),n=t.additionalInformation||{};return n=this.transformBillingAddress(n,e.billingAddress),n=this.transformShippingAddress(n),e.onLookupComplete&&(t.onLookupComplete=i(e.onLookupComplete)),e.email&&(n.email=e.email),e.mobilePhoneNumber&&(n.mobilePhoneNumber=e.mobilePhoneNumber),t.additionalInformation=n,t},_.prototype._onLookupComplete=function(e,t){var n=this;return r.prototype._onLookupComplete.call(this,e).then((function(e){return new Promise((function(r,o){function i(){r(e)}e.requiresUserAuthentication=Boolean(e.lookup&&e.lookup.acsUrl),n._verifyCardPromisePlus.catch(o),t.onLookupComplete?t.onLookupComplete(e,i):n._emit(_.events.LOOKUP_COMPLETE,e,i)}))}))},_.prototype._presentChallenge=function(e){!this._songbirdInitFailed&&e.lookup.transactionId&&window.Cardinal.continue("cca",{AcsUrl:e.lookup.acsUrl,Payload:e.lookup.pareq},{OrderDetails:{TransactionId:e.lookup.transactionId}})},_.prototype._formatLookupData=function(e){var t=this;return r.prototype._formatLookupData.call(this,e).then((function(n){if(n.additionalInfo=e.additionalInformation,e.accountType&&(n.accountType=e.accountType),e.challengeRequested&&(n.challengeRequested=e.challengeRequested),e.requestedExemptionType){if(!b.includes(e.requestedExemptionType))throw new a({code:u.THREEDS_REQUESTED_EXEMPTION_TYPE_INVALID.code,type:u.THREEDS_REQUESTED_EXEMPTION_TYPE_INVALID.type,message:"requestedExemptionType `"+e.requestedExemptionType+"` is not a valid exemption. The accepted values are: `"+b.join("`, `")+"`"});n.requestedExemptionType=e.requestedExemptionType}return e.customFields&&(n.customFields=e.customFields),e.dataOnlyRequested&&(n.dataOnlyRequested=e.dataOnlyRequested),e.exemptionRequested&&(n.exemptionRequested=e.exemptionRequested),e.requestVisaDAF&&(n.requestVisaDAF=e.requestVisaDAF),e.bin&&(n.bin=e.bin),null!=e.cardAdd&&(n.cardAdd=e.cardAdd),null!=e.cardAddChallengeRequested&&(n.cardAdd=e.cardAddChallengeRequested),e.merchantName&&(n.merchantName=e.merchantName),t.prepareLookup(n)}))},_.prototype.cancelVerifyCard=function(e){var t=this;return r.prototype.cancelVerifyCard.call(this).then((function(n){return t._verifyCardPromisePlus&&(e=e||new a(u.THREEDS_VERIFY_CARD_CANCELED_BY_MERCHANT),t._verifyCardPromisePlus.reject(e)),n}))},_.prototype._removeSongbirdListeners=function(){this._cardinalEvents.forEach((function(e){window.Cardinal.off(e)})),this._cardinalEvents=[]},_.prototype.teardown=function(){return window.Cardinal&&this._removeSongbirdListeners(),r.prototype.teardown.call(this)},_.prototype._reloadThreeDSecure=function(){var e=this,t=Date.now();return e.teardown().then((function(){e._configureCardinalSdk({setupOptions:e.originalSetupOptions,setupStartTime:t})}))},t.exports=_},{"../../../lib/analytics":119,"../../../lib/assets":120,"../../../lib/assign":121,"../../../lib/braintree-error":124,"../../../lib/constants":126,"../../../lib/convert-to-braintree-error":128,"../../../lib/deferred":132,"../../../lib/enumerate":134,"../../shared/constants":199,"../../shared/errors":200,"./base":190,"@braintree/extended-promise":34}],197:[function(e,t,n){"use strict";var r=e("@braintree/wrap-promise"),o=e("../../lib/methods"),i=e("../../lib/convert-methods-to-error"),a=e("@braintree/event-emitter"),s=e("./frameworks");function l(e){var t=this,n=s[e.framework];a.call(this),this._framework=new n(e),this._framework.setUpEventListeners((function(){t._emit.apply(t,arguments)}))}a.createChild(l),l.prototype.verifyCard=function(e){var t;return this.hasListener("lookup-complete")&&(t={ignoreOnLookupCompleteRequirement:!0}),this._framework.verifyCard(e,t)},l.prototype.initializeChallengeWithLookupResponse=function(e){return"string"==typeof e&&(e=JSON.parse(e)),this._framework.initializeChallengeWithLookupResponse(e)},l.prototype.prepareLookup=function(e){return this._framework.prepareLookup(e).then((function(e){return JSON.stringify(e)}))},l.prototype.cancelVerifyCard=function(){return this._framework.cancelVerifyCard()},l.prototype.teardown=function(){var e=o(l.prototype).concat(o(a.prototype));return i(this,e),this._framework.teardown()},t.exports=r.wrapPrototype(l)},{"../../lib/convert-methods-to-error":127,"../../lib/methods":155,"./frameworks":193,"@braintree/event-emitter":33,"@braintree/wrap-promise":43}],198:[function(e,t,n){"use strict";var r=e("./external/three-d-secure"),o=e("../lib/is-https").isHTTPS,i=e("../lib/basic-component-verification"),a=e("../lib/create-deferred-client"),s=e("../lib/create-assets-url"),l=e("../lib/braintree-error"),c=e("../lib/analytics"),u=e("./shared/errors"),d="3.102.0",p=e("@braintree/wrap-promise");function f(e){var t="3D Secure",n=h(e);return i.verify({name:t,client:e.client,authorization:e.authorization}).then((function(){var i=s.create(e.authorization),d=a.create({authorization:e.authorization,client:e.client,debug:e.debug,assetsUrl:i,name:t}).then((function(t){var r,i=t.getConfiguration(),a=i.gatewayConfiguration;return e.client=t,a.threeDSecureEnabled||(r=u.THREEDS_NOT_ENABLED),"TOKENIZATION_KEY"===i.authorizationType&&(r=u.THREEDS_CAN_NOT_USE_TOKENIZATION_KEY),"production"===a.environment&&!o()&&(r=u.THREEDS_HTTPS_REQUIRED),"legacy"===n||a.threeDSecure&&a.threeDSecure.cardinalAuthenticationJWT||(c.sendEvent(e.client,"three-d-secure.initialization.failed.missing-cardinalAuthenticationJWT"),r=u.THREEDS_NOT_ENABLED_FOR_V2),r?Promise.reject(new l(r)):(c.sendEvent(e.client,"three-d-secure.initialized"),t)})),p=new r({client:e.client,assetsUrl:i,createPromise:d,loggingEnabled:e.loggingEnabled,cardinalSDKConfig:e.cardinalSDKConfig,framework:n});return e.client?d.then((function(){return p})):p}))}function h(e){var t=String(e.version||"");if(!t||"1"===t)throw new l({code:u.THREEDS_UNSUPPORTED_VERSION.code,type:u.THREEDS_UNSUPPORTED_VERSION.type,message:u.THREEDS_UNSUPPORTED_VERSION.message});switch(t){case"2":case"2-cardinal-modal":return"cardinal-modal";case"2-bootstrap3-modal":return"bootstrap3-modal";case"2-inline-iframe":return"inline-iframe";default:throw new l({code:u.THREEDS_UNRECOGNIZED_VERSION.code,type:u.THREEDS_UNRECOGNIZED_VERSION.type,message:"Version `"+e.version+"` is not a recognized version. You may need to update the version of your Braintree SDK to support this version."})}}t.exports={create:p(f),VERSION:d}},{"../lib/analytics":119,"../lib/basic-component-verification":122,"../lib/braintree-error":124,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"../lib/is-https":152,"./external/three-d-secure":197,"./shared/errors":200,"@braintree/wrap-promise":43}],199:[function(e,t,n){"use strict";t.exports={LANDING_FRAME_NAME:"braintreethreedsecurelanding",CARDINAL_SCRIPT_SOURCE:{production:"https://songbird.cardinalcommerce.com/edge/v1/songbird.js",sandbox:"https://songbirdstag.cardinalcommerce.com/edge/v1/songbird.js"}}},{}],200:[function(e,t,n){"use strict";var r=e("../../lib/braintree-error");t.exports={THREEDS_NOT_ENABLED:{type:r.types.MERCHANT,code:"THREEDS_NOT_ENABLED",message:"3D Secure is not enabled for this merchant."},THREEDS_CAN_NOT_USE_TOKENIZATION_KEY:{type:r.types.MERCHANT,code:"THREEDS_CAN_NOT_USE_TOKENIZATION_KEY",message:"3D Secure can not use a tokenization key for authorization."},THREEDS_HTTPS_REQUIRED:{type:r.types.MERCHANT,code:"THREEDS_HTTPS_REQUIRED",message:"3D Secure requires HTTPS."},THREEDS_NOT_ENABLED_FOR_V2:{type:r.types.MERCHANT,code:"THREEDS_NOT_ENABLED_FOR_V2",message:"3D Secure version 2 is not enabled for this merchant. Contact Braintree Support for assistance at https://help.braintreepayments.com/"},THREEDS_UNRECOGNIZED_VERSION:{type:r.types.MERCHANT,code:"THREEDS_UNRECOGNIZED_VERSION"},THREEDS_CARDINAL_SDK_SETUP_FAILED:{type:r.types.UNKNOWN,code:"THREEDS_CARDINAL_SDK_SETUP_FAILED",message:"Something went wrong setting up Cardinal's Songbird.js library."},THREEDS_CARDINAL_SDK_SCRIPT_LOAD_FAILED:{type:r.types.NETWORK,code:"THREEDS_CARDINAL_SDK_SCRIPT_LOAD_FAILED",message:"Cardinal's Songbird.js library could not be loaded."},THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT:{type:r.types.UNKNOWN,code:"THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT",message:"Cardinal's Songbird.js took too long to setup."},THREEDS_CARDINAL_SDK_RESPONSE_TIMEDOUT:{type:r.types.UNKNOWN,code:"THREEDS_CARDINAL_SDK_RESPONSE_TIMEDOUT",message:"Cardinal's API took too long to respond."},THREEDS_CARDINAL_SDK_BAD_CONFIG:{type:r.types.MERCHANT,code:"THREEDS_CARDINAL_SDK_BAD_CONFIG",message:"JWT or other required field missing. Please check your setup configuration."},THREEDS_CARDINAL_SDK_BAD_JWT:{type:r.types.MERCHANT,code:"THREEDS_CARDINAL_SDK_BAD_JWT",message:"Cardinal JWT missing or malformed. Please check your setup configuration."},THREEDS_CARDINAL_SDK_ERROR:{type:r.types.UNKNOWN,code:"THREEDS_CARDINAL_SDK_ERROR",message:"A general error has occurred with Cardinal. See description for more information."},THREEDS_CARDINAL_SDK_CANCELED:{type:r.types.CUSTOMER,code:"THREEDS_CARDINAL_SDK_CANCELED",message:"Canceled by user."},THREEDS_VERIFY_CARD_CANCELED_BY_MERCHANT:{type:r.types.MERCHANT,code:"THREEDS_VERIFY_CARD_CANCELED_BY_MERCHANT",message:"3D Secure verfication canceled by merchant."},THREEDS_AUTHENTICATION_IN_PROGRESS:{type:r.types.MERCHANT,code:"THREEDS_AUTHENTICATION_IN_PROGRESS",message:"Cannot call verifyCard while existing authentication is in progress."},THREEDS_MISSING_VERIFY_CARD_OPTION:{type:r.types.MERCHANT,code:"THREEDS_MISSING_VERIFY_CARD_OPTION"},THREEDS_JWT_AUTHENTICATION_FAILED:{type:r.types.UNKNOWN,code:"THREEDS_JWT_AUTHENTICATION_FAILED",message:"Something went wrong authenticating the JWT from Cardinal"},THREEDS_LOOKUP_TOKENIZED_CARD_NOT_FOUND_ERROR:{type:r.types.MERCHANT,code:"THREEDS_LOOKUP_TOKENIZED_CARD_NOT_FOUND_ERROR",message:"Either the payment method nonce passed to `verifyCard` does not exist, or it was already consumed"},THREEDS_LOOKUP_VALIDATION_ERROR:{type:r.types.CUSTOMER,code:"THREEDS_LOOKUP_VALIDATION_ERROR",message:"The data passed in `verifyCard` did not pass validation checks. See details for more info"},THREEDS_LOOKUP_ERROR:{type:r.types.UNKNOWN,code:"THREEDS_LOOKUP_ERROR",message:"Something went wrong during the 3D Secure lookup"},THREEDS_INLINE_IFRAME_DETAILS_INCORRECT:{type:r.types.UNKNOWN,code:"THREEDS_INLINE_IFRAME_DETAILS_INCORRECT",message:"Something went wrong when attempting to add the authentication iframe to the page."},THREEDS_NO_VERIFICATION_PAYLOAD:{type:r.types.MERCHANT,code:"THREEDS_NO_VERIFICATION_PAYLOAD",message:"No verification payload available."},THREEDS_TERM_URL_REQUIRES_BRAINTREE_DOMAIN:{type:r.types.INTERNAL,code:"THREEDS_TERM_URL_REQUIRES_BRAINTREE_DOMAIN",message:"Term Url must be on a Braintree domain."},THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED:{type:r.types.INTERNAL,code:"THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED",message:"Method not implemented for this framework."},THREEDS_REQUESTED_EXEMPTION_TYPE_INVALID:{type:r.types.MERCHANT,code:"THREEDS_REQUESTED_EXEMPTION_TYPE_INVALID",message:"Requested Exemption Type is invalid."},THREEDS_UNSUPPORTED_VERSION:{type:r.types.MERCHANT,code:"THREEDS_UNSUPPORTED_VERSION",message:"3D Secure `1` is deprecated and no longer supported. See available versions at https://braintree.github.io/braintree-web/current/module-braintree-web_three-d-secure.html#.create"}}},{"../../lib/braintree-error":124}],201:[function(e,t,n){"use strict";var r=e("../../lib/enumerate");t.exports=r(["AUTHENTICATION_COMPLETE"],"threedsecure:")},{"../../lib/enumerate":134}],202:[function(e,t,n){"use strict";var r=e("./shared/unionpay"),o=e("../lib/basic-component-verification"),i=e("../lib/braintree-error"),a=e("../lib/create-deferred-client"),s=e("../lib/create-assets-url"),l=e("../lib/analytics"),c=e("./shared/errors"),u="3.102.0",d=e("@braintree/wrap-promise");function p(e){var t="UnionPay";return o.verify({name:t,client:e.client,authorization:e.authorization}).then((function(){return a.create({authorization:e.authorization,client:e.client,debug:e.debug,assetsUrl:s.create(e.authorization),name:t})})).then((function(t){var n=t.getConfiguration();return e.client=t,n.gatewayConfiguration.unionPay&&!0===n.gatewayConfiguration.unionPay.enabled?(l.sendEvent(e.client,"unionpay.initialized"),new r(e)):Promise.reject(new i(c.UNIONPAY_NOT_ENABLED))}))}t.exports={create:d(p),VERSION:u}},{"../lib/analytics":119,"../lib/basic-component-verification":122,"../lib/braintree-error":124,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./shared/errors":204,"./shared/unionpay":205,"@braintree/wrap-promise":43}],203:[function(e,t,n){"use strict";var r=e("../../lib/enumerate");t.exports={events:r(["HOSTED_FIELDS_FETCH_CAPABILITIES","HOSTED_FIELDS_ENROLL","HOSTED_FIELDS_TOKENIZE"],"union-pay:"),HOSTED_FIELDS_FRAME_NAME:"braintreeunionpayhostedfields"}},{"../../lib/enumerate":134}],204:[function(e,t,n){"use strict";var r=e("../../lib/braintree-error");t.exports={UNIONPAY_NOT_ENABLED:{type:r.types.MERCHANT,code:"UNIONPAY_NOT_ENABLED",message:"UnionPay is not enabled for this merchant."},UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID:{type:r.types.MERCHANT,code:"UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID",message:"Found an invalid Hosted Fields instance. Please use a valid Hosted Fields instance."},UNIONPAY_HOSTED_FIELDS_INSTANCE_REQUIRED:{type:r.types.MERCHANT,code:"UNIONPAY_HOSTED_FIELDS_INSTANCE_REQUIRED",message:"Could not find the Hosted Fields instance."},UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED:{type:r.types.MERCHANT,code:"UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED",message:"A card or a Hosted Fields instance is required. Please supply a card or a Hosted Fields instance."},UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES:{type:r.types.MERCHANT,code:"UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES",message:"Please supply either a card or a Hosted Fields instance, not both."},UNIONPAY_EXPIRATION_DATE_INCOMPLETE:{type:r.types.MERCHANT,code:"UNIONPAY_EXPIRATION_DATE_INCOMPLETE",message:"You must supply expiration month and year or neither."},UNIONPAY_ENROLLMENT_CUSTOMER_INPUT_INVALID:{type:r.types.CUSTOMER,code:"UNIONPAY_ENROLLMENT_CUSTOMER_INPUT_INVALID",message:"Enrollment failed due to user input error."},UNIONPAY_ENROLLMENT_NETWORK_ERROR:{type:r.types.NETWORK,code:"UNIONPAY_ENROLLMENT_NETWORK_ERROR",message:"Could not enroll UnionPay card."},UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR:{type:r.types.NETWORK,code:"UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR",message:"Could not fetch card capabilities."},UNIONPAY_TOKENIZATION_NETWORK_ERROR:{type:r.types.NETWORK,code:"UNIONPAY_TOKENIZATION_NETWORK_ERROR",message:"A tokenization network error occurred."},UNIONPAY_MISSING_MOBILE_PHONE_DATA:{type:r.types.MERCHANT,code:"UNIONPAY_MISSING_MOBILE_PHONE_DATA",message:"A `mobile` with `countryCode` and `number` is required."},UNIONPAY_FAILED_TOKENIZATION:{type:r.types.CUSTOMER,code:"UNIONPAY_FAILED_TOKENIZATION",message:"The supplied card data failed tokenization."}}},{"../../lib/braintree-error":124}],205:[function(e,t,n){"use strict";var r=e("../../lib/analytics"),o=e("../../lib/braintree-error"),i=e("framebus"),a=e("./constants"),s=e("../../lib/is-verified-domain"),l=e("../../lib/use-min"),c=e("../../lib/convert-methods-to-error"),u=e("./errors"),d=a.events,p=e("@braintree/iframer"),f=e("../../lib/methods"),h="3.102.0",m=e("@braintree/uuid"),g=e("@braintree/wrap-promise"),v=e("../../lib/constants").BUS_CONFIGURATION_REQUEST_EVENT;function y(e){this._options=e}y.prototype.fetchCapabilities=function(e){var t=this,n=this._options.client,i=e.card?e.card.number:null,a=e.hostedFields;return i&&a?Promise.reject(new o(u.UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES)):i?n.request({method:"get",endpoint:"payment_methods/credit_cards/capabilities",data:{_meta:{source:"unionpay"},creditCard:{number:i}}}).then((function(e){return r.sendEvent(n,"unionpay.capabilities-received"),e})).catch((function(e){var t=e.details&&e.details.httpStatus;return r.sendEvent(n,"unionpay.capabilities-failed"),403===t?Promise.reject(e):Promise.reject(new o({type:u.UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR.type,code:u.UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR.code,message:u.UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR.message,details:{originalError:e}}))})):a?a._bus?t._initializeHostedFields().then((function(){return new Promise((function(e,n){t._bus.emit(d.HOSTED_FIELDS_FETCH_CAPABILITIES,{hostedFields:a},(function(t){t.err?n(new o(t.err)):e(t.payload)}))}))})):Promise.reject(new o(u.UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID)):Promise.reject(new o(u.UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED))},y.prototype.enroll=function(e){var t,n=this,i=this._options.client,a=e.card,s=e.mobile,l=e.hostedFields;if(!s)return Promise.reject(new o(u.UNIONPAY_MISSING_MOBILE_PHONE_DATA));if(l)return l._bus?a?Promise.reject(new o(u.UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES)):new Promise((function(e,t){n._initializeHostedFields().then((function(){n._bus.emit(d.HOSTED_FIELDS_ENROLL,{hostedFields:l,mobile:s},(function(n){n.err?t(new o(n.err)):e(n.payload)}))}))})):Promise.reject(new o(u.UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID));if(a&&a.number){if(t={_meta:{source:"unionpay"},unionPayEnrollment:{number:a.number,mobileCountryCode:s.countryCode,mobileNumber:s.number}},a.expirationDate)t.unionPayEnrollment.expirationDate=a.expirationDate;else if(a.expirationMonth||a.expirationYear){if(!a.expirationMonth||!a.expirationYear)return Promise.reject(new o(u.UNIONPAY_EXPIRATION_DATE_INCOMPLETE));t.unionPayEnrollment.expirationYear=a.expirationYear,t.unionPayEnrollment.expirationMonth=a.expirationMonth}return i.request({method:"post",endpoint:"union_pay_enrollments",data:t}).then((function(e){return r.sendEvent(i,"unionpay.enrollment-succeeded"),{enrollmentId:e.unionPayEnrollmentId,smsCodeRequired:e.smsCodeRequired}})).catch((function(e){var t,n=e.details&&e.details.httpStatus;return 403===n?t=e:n<500?(t=new o(u.UNIONPAY_ENROLLMENT_CUSTOMER_INPUT_INVALID)).details={originalError:e}:(t=new o(u.UNIONPAY_ENROLLMENT_NETWORK_ERROR)).details={originalError:e},r.sendEvent(i,"unionpay.enrollment-failed"),Promise.reject(t)}))}return Promise.reject(new o(u.UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED))},y.prototype.tokenize=function(e){var t,n=this,i=this._options.client,a=e.card,s=e.hostedFields;return a&&s?Promise.reject(new o(u.UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES)):a?(t={_meta:{source:"unionpay"},creditCard:{number:e.card.number,options:{unionPayEnrollment:{id:e.enrollmentId}}}},e.smsCode&&(t.creditCard.options.unionPayEnrollment.smsCode=e.smsCode),a.expirationDate?t.creditCard.expirationDate=a.expirationDate:a.expirationMonth&&a.expirationYear&&(t.creditCard.expirationYear=a.expirationYear,t.creditCard.expirationMonth=a.expirationMonth),e.card.cvv&&(t.creditCard.cvv=e.card.cvv),i.request({method:"post",endpoint:"payment_methods/credit_cards",data:t}).then((function(e){var t=e.creditCards[0];return delete t.consumed,delete t.threeDSecureInfo,r.sendEvent(i,"unionpay.nonce-received"),t})).catch((function(e){var t,n=e.details&&e.details.httpStatus;return r.sendEvent(i,"unionpay.nonce-failed"),403===n?t=e:n<500?(t=new o(u.UNIONPAY_FAILED_TOKENIZATION)).details={originalError:e}:(t=new o(u.UNIONPAY_TOKENIZATION_NETWORK_ERROR)).details={originalError:e},Promise.reject(t)}))):s?s._bus?new Promise((function(t,r){n._initializeHostedFields().then((function(){n._bus.emit(d.HOSTED_FIELDS_TOKENIZE,e,(function(e){e.err?r(new o(e.err)):t(e.payload)}))}))})):Promise.reject(new o(u.UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID)):Promise.reject(new o(u.UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED))},y.prototype.teardown=function(){return this._bus&&(this._hostedFieldsFrame.parentNode.removeChild(this._hostedFieldsFrame),this._bus.teardown()),c(this,f(y.prototype)),Promise.resolve()},y.prototype._initializeHostedFields=function(){var e,t,n=m(),r=this;return this._hostedFieldsInitializePromise||(this._hostedFieldsInitializePromise=new Promise((function(o){e=r._options.client.getConfiguration().gatewayConfiguration.assetsUrl,t=r._options.client.getConfiguration().isDebug,r._bus=new i({channel:n,verifyDomain:s}),r._hostedFieldsFrame=p({name:a.HOSTED_FIELDS_FRAME_NAME+"_"+n,src:e+"/web/"+h+"/html/unionpay-hosted-fields-frame"+l(t)+".html",height:0,width:0}),r._bus.on(v,(function(e){e(r._options.client),o()})),document.body.appendChild(r._hostedFieldsFrame)}))),this._hostedFieldsInitializePromise},t.exports=g.wrapPrototype(y)},{"../../lib/analytics":119,"../../lib/braintree-error":124,"../../lib/constants":126,"../../lib/convert-methods-to-error":127,"../../lib/is-verified-domain":153,"../../lib/methods":155,"../../lib/use-min":160,"./constants":203,"./errors":204,"@braintree/iframer":35,"@braintree/uuid":39,"@braintree/wrap-promise":43,framebus:52}],206:[function(e,t,n){"use strict";t.exports={PLAID_LINK_JS:"https://cdn.plaid.com/link/v2/stable/link-initialize.js"}},{}],207:[function(e,t,n){"use strict";var r=e("../lib/braintree-error");t.exports={US_BANK_ACCOUNT_OPTION_REQUIRED:{type:r.types.MERCHANT,code:"US_BANK_ACCOUNT_OPTION_REQUIRED"},US_BANK_ACCOUNT_MUTUALLY_EXCLUSIVE_OPTIONS:{type:r.types.MERCHANT,code:"US_BANK_ACCOUNT_MUTUALLY_EXCLUSIVE_OPTIONS"},US_BANK_ACCOUNT_LOGIN_LOAD_FAILED:{type:r.types.NETWORK,code:"US_BANK_ACCOUNT_LOGIN_LOAD_FAILED",message:"Bank login flow failed to load."},US_BANK_ACCOUNT_LOGIN_CLOSED:{type:r.types.CUSTOMER,code:"US_BANK_ACCOUNT_LOGIN_CLOSED",message:"Customer closed bank login flow before authorizing."},US_BANK_ACCOUNT_LOGIN_REQUEST_ACTIVE:{type:r.types.MERCHANT,code:"US_BANK_ACCOUNT_LOGIN_REQUEST_ACTIVE",message:"Another bank login tokenization request is active."},US_BANK_ACCOUNT_TOKENIZATION_NETWORK_ERROR:{type:r.types.NETWORK,code:"US_BANK_ACCOUNT_TOKENIZATION_NETWORK_ERROR",message:"A tokenization network error occurred."},US_BANK_ACCOUNT_FAILED_TOKENIZATION:{type:r.types.CUSTOMER,code:"US_BANK_ACCOUNT_FAILED_TOKENIZATION",message:"The supplied data failed tokenization."},US_BANK_ACCOUNT_NOT_ENABLED:{type:r.types.MERCHANT,code:"US_BANK_ACCOUNT_NOT_ENABLED",message:"US bank account is not enabled."},US_BANK_ACCOUNT_BANK_LOGIN_NOT_ENABLED:{type:r.types.MERCHANT,code:"US_BANK_ACCOUNT_BANK_LOGIN_NOT_ENABLED",message:"Bank login is not enabled."}}},{"../lib/braintree-error":124}],208:[function(e,t,n){"use strict";var r=e("../lib/basic-component-verification"),o=e("../lib/braintree-error"),i=e("../lib/create-deferred-client"),a=e("../lib/create-assets-url"),s=e("./errors"),l=e("./us-bank-account"),c="3.102.0",u=e("@braintree/wrap-promise");function d(e){var t="US Bank Account";return r.verify({name:t,client:e.client,authorization:e.authorization}).then((function(){return i.create({authorization:e.authorization,client:e.client,debug:e.debug,assetsUrl:a.create(e.authorization),name:t})})).then((function(t){return e.client=t,e.client.getConfiguration().gatewayConfiguration.usBankAccount?new l(e):Promise.reject(new o(s.US_BANK_ACCOUNT_NOT_ENABLED))}))}t.exports={create:u(d),VERSION:c}},{"../lib/basic-component-verification":122,"../lib/braintree-error":124,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./errors":207,"./us-bank-account":209,"@braintree/wrap-promise":43}],209:[function(e,t,n){"use strict";var r=e("../lib/braintree-error"),o=e("./constants"),i=e("./errors"),a=e("../lib/errors"),s=e("../lib/analytics"),l=e("../lib/once"),c=e("../lib/convert-methods-to-error"),u=e("../lib/methods"),d=e("@braintree/wrap-promise"),p=_("UsBankAccount"),f=_("UsBankLogin");function h(e){this._client=e.client,this._isTokenizingBankLogin=!1,s.sendEvent(this._client,"usbankaccount.initialized")}function m(e){var t,n=e.details&&e.details.httpStatus;return(t=new r(401===n?a.BRAINTREE_API_ACCESS_RESTRICTED:n<500?i.US_BANK_ACCOUNT_FAILED_TOKENIZATION:i.US_BANK_ACCOUNT_TOKENIZATION_NETWORK_ERROR)).details={originalError:e},t}function g(e,t){var n=e.data[t].paymentMethod,r="US bank account ending in - "+n.details.last4;return{nonce:n.id,details:{},description:r,type:"us_bank_account"}}function v(e,t){function n(){var e=this.readyState;e&&"loaded"!==e&&"complete"!==e||(a(),t(null,window.Plaid))}function o(){e.parentNode.removeChild(e),t(new r(i.US_BANK_ACCOUNT_LOGIN_LOAD_FAILED))}function a(){e.removeEventListener("error",o),e.removeEventListener("load",n),e.removeEventListener("readystatechange",n)}e.addEventListener("error",o),e.addEventListener("load",n),e.addEventListener("readystatechange",n)}function y(e){return{streetAddress:e.streetAddress,extendedAddress:e.extendedAddress,city:e.locality,state:e.region,zipCode:e.postalCode}}function b(e,t){"personal"===t.ownershipType?e.individualOwner={firstName:t.firstName,lastName:t.lastName}:"business"===t.ownershipType&&(e.businessOwner={businessName:t.businessName})}function _(e){return"mutation Tokenize"+e+"($input: Tokenize"+e+"Input!) {  tokenize"+e+"(input: $input) {    paymentMethod {      id      details {        ... on UsBankAccountDetails {          last4        }      }    }  }}"}h.prototype.tokenize=function(e){return(e=e||{}).mandateText?e.bankDetails&&e.bankLogin?Promise.reject(new r({type:i.US_BANK_ACCOUNT_MUTUALLY_EXCLUSIVE_OPTIONS.type,code:i.US_BANK_ACCOUNT_MUTUALLY_EXCLUSIVE_OPTIONS.code,message:"tokenize must be called with bankDetails or bankLogin, not both."})):e.bankDetails?this._tokenizeBankDetails(e):e.bankLogin?this._tokenizeBankLogin(e):Promise.reject(new r({type:i.US_BANK_ACCOUNT_OPTION_REQUIRED.type,code:i.US_BANK_ACCOUNT_OPTION_REQUIRED.code,message:"tokenize must be called with bankDetails or bankLogin."})):Promise.reject(new r({type:i.US_BANK_ACCOUNT_OPTION_REQUIRED.type,code:i.US_BANK_ACCOUNT_OPTION_REQUIRED.code,message:"mandateText property is required."}))},h.prototype._tokenizeBankDetails=function(e){var t=this._client,n=e.bankDetails,r={achMandate:e.mandateText,routingNumber:n.routingNumber,accountNumber:n.accountNumber,accountType:n.accountType.toUpperCase(),billingAddress:y(n.billingAddress||{})};return b(r,n),t.request({api:"graphQLApi",data:{query:p,variables:{input:{usBankAccount:r}}}}).then((function(e){return s.sendEvent(t,"usbankaccount.bankdetails.tokenization.succeeded"),Promise.resolve(g(e,"tokenizeUsBankAccount"))})).catch((function(e){var n=m(e);return s.sendEvent(t,"usbankaccount.bankdetails.tokenization.failed"),Promise.reject(n)}))},h.prototype._tokenizeBankLogin=function(e){var t=this,n=this._client,o=n.getConfiguration().gatewayConfiguration,a="production"===o.environment,l=o.usBankAccount.plaid;return e.bankLogin.displayName?l?this._isTokenizingBankLogin?Promise.reject(new r(i.US_BANK_ACCOUNT_LOGIN_REQUEST_ACTIVE)):(this._isTokenizingBankLogin=!0,new Promise((function(o,c){t._loadPlaid((function(u,d){u?c(u):(d.create({clientName:e.bankLogin.displayName,apiVersion:"v2",env:a?"production":"sandbox",key:l.publicKey,product:"auth",selectAccount:!0,onExit:function(){t._isTokenizingBankLogin=!1,s.sendEvent(n,"usbankaccount.banklogin.tokenization.closed.by-user"),c(new r(i.US_BANK_ACCOUNT_LOGIN_CLOSED))},onSuccess:function(r,i){var l=e.bankLogin,u={publicToken:r,accountId:a?i.account_id:"plaid_account_id",accountType:i.account.subtype.toUpperCase(),achMandate:e.mandateText,billingAddress:y(l.billingAddress||{})};b(u,l),n.request({api:"graphQLApi",data:{query:f,variables:{input:{usBankLogin:u}}}}).then((function(e){t._isTokenizingBankLogin=!1,s.sendEvent(n,"usbankaccount.banklogin.tokenization.succeeded"),o(g(e,"tokenizeUsBankLogin"))})).catch((function(e){var r;t._isTokenizingBankLogin=!1,r=m(e),s.sendEvent(n,"usbankaccount.banklogin.tokenization.failed"),c(r)}))}}).open(),s.sendEvent(n,"usbankaccount.banklogin.tokenization.started"))}))}))):Promise.reject(new r(i.US_BANK_ACCOUNT_BANK_LOGIN_NOT_ENABLED)):Promise.reject(new r({type:i.US_BANK_ACCOUNT_OPTION_REQUIRED.type,code:i.US_BANK_ACCOUNT_OPTION_REQUIRED.code,message:"displayName property is required when using bankLogin."}))},h.prototype._loadPlaid=function(e){var t,n;e=l(e),window.Plaid?e(null,window.Plaid):(t=document.querySelector('script[src="'+o.PLAID_LINK_JS+'"]'))?v(t,e):((n=document.createElement("script")).src=o.PLAID_LINK_JS,n.async=!0,v(n,e),document.body.appendChild(n),this._plaidScript=n)},h.prototype.teardown=function(){return this._plaidScript&&document.body.removeChild(this._plaidScript),c(this,u(h.prototype)),Promise.resolve()},t.exports=d.wrapPrototype(h)},{"../lib/analytics":119,"../lib/braintree-error":124,"../lib/convert-methods-to-error":127,"../lib/errors":135,"../lib/methods":155,"../lib/once":156,"./constants":206,"./errors":207,"@braintree/wrap-promise":43}],210:[function(e,t,n){"use strict";var r=e("../lib/braintree-error");t.exports={VAULT_MANAGER_DELETE_PAYMENT_METHOD_NONCE_REQUIRES_CLIENT_TOKEN:{type:r.types.MERCHANT,code:"VAULT_MANAGER_DELETE_PAYMENT_METHOD_NONCE_REQUIRES_CLIENT_TOKEN",message:"A client token with a customer id must be used to delete a payment method nonce."},VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND:{type:r.types.MERCHANT,code:"VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND"},VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR:{type:r.types.UNKNOWN,code:"VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR"}}},{"../lib/braintree-error":124}],211:[function(e,t,n){"use strict";var r=e("../lib/basic-component-verification"),o=e("../lib/create-deferred-client"),i=e("../lib/create-assets-url"),a=e("./vault-manager"),s="3.102.0",l=e("@braintree/wrap-promise");function c(e){var t="Vault Manager";return r.verify({name:t,client:e.client,authorization:e.authorization}).then((function(){return new a({createPromise:o.create({authorization:e.authorization,client:e.client,debug:e.debug,assetsUrl:i.create(e.authorization),name:t})})}))}t.exports={create:l(c),VERSION:s}},{"../lib/basic-component-verification":122,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./vault-manager":212,"@braintree/wrap-promise":43}],212:[function(e,t,n){"use strict";var r=e("../lib/analytics"),o=e("../lib/braintree-error"),i=e("./errors"),a=e("../lib/convert-methods-to-error"),s=e("../lib/methods"),l=e("@braintree/wrap-promise"),c="mutation DeletePaymentMethodFromSingleUseToken($input: DeletePaymentMethodFromSingleUseTokenInput!) {  deletePaymentMethodFromSingleUseToken(input: $input) {    clientMutationId  }}";function u(e){this._createPromise=e.createPromise}function d(e){var t={nonce:e.nonce,default:e.default,details:e.details,hasSubscription:e.hasSubscription,type:e.type};return e.description&&(t.description=e.description),e.binData&&(t.binData=e.binData),t}u.prototype.fetchPaymentMethods=function(e){var t;return t=!0===(e=e||{}).defaultFirst?1:0,this._createPromise.then((function(e){return e.request({endpoint:"payment_methods",method:"get",data:{defaultFirst:t}})})).then(function(e){return r.sendEvent(this._createPromise,"vault-manager.fetch-payment-methods.succeeded"),e.paymentMethods.map(d)}.bind(this))},u.prototype.deletePaymentMethod=function(e){return this._createPromise.then((function(t){return"CLIENT_TOKEN"===t.getConfiguration().authorizationType?t.request({api:"graphQLApi",data:{query:c,variables:{input:{singleUseTokenId:e}},operationName:"DeletePaymentMethodFromSingleUseToken"}}).then((function(){r.sendEvent(t,"vault-manager.delete-payment-method.succeeded")})).catch((function(n){var a,s=n.details.originalError;return r.sendEvent(t,"vault-manager.delete-payment-method.failed"),s[0]&&"NOT_FOUND"===s[0].extensions.errorClass&&(a=new o({type:i.VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND.type,code:i.VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND.code,message:"A payment method for payment method nonce `"+e+"` could not be found.",details:{originalError:s}})),a||(a=new o({type:i.VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR.type,code:i.VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR.code,message:"An unknown error occured when attempting to delete the payment method assocaited with the payment method nonce `"+e+"`.",details:{originalError:s}})),Promise.reject(a)})):Promise.reject(new o(i.VAULT_MANAGER_DELETE_PAYMENT_METHOD_NONCE_REQUIRES_CLIENT_TOKEN))}))},u.prototype.teardown=function(){return a(this,s(u.prototype)),Promise.resolve()},t.exports=l.wrapPrototype(u)},{"../lib/analytics":119,"../lib/braintree-error":124,"../lib/convert-methods-to-error":127,"../lib/methods":155,"./errors":210,"@braintree/wrap-promise":43}],213:[function(e,t,n){"use strict";var r=(this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}})(e("./venmo-desktop"));t.exports=function(e){return new r.default(e).initialize()}},{"./venmo-desktop":215}],214:[function(e,t,n){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.VENMO_PAYMENT_CONTEXT_STATUS_QUERY=n.LEGACY_VENMO_PAYMENT_CONTEXT_STATUS_QUERY=n.UPDATE_PAYMENT_CONTEXT_QUERY=n.LEGACY_UPDATE_PAYMENT_CONTEXT_QUERY=n.CREATE_PAYMENT_CONTEXT_QUERY=n.LEGACY_CREATE_PAYMENT_CONTEXT_QUERY=void 0,n.LEGACY_CREATE_PAYMENT_CONTEXT_QUERY="mutation CreateVenmoQRCodePaymentContext($input: CreateVenmoQRCodePaymentContextInput!) {\n  createVenmoQRCodePaymentContext(input: $input) {\n    clientMutationId\n    venmoQRCodePaymentContext {\n      id\n      merchantId\n      createdAt\n      expiresAt\n    }\n  }\n}",n.CREATE_PAYMENT_CONTEXT_QUERY="mutation CreateVenmoPaymentContext($input: CreateVenmoPaymentContextInput!) {\n  createVenmoPaymentContext(input: $input) {\n    clientMutationId\n    venmoPaymentContext {\n      id\n      merchantId\n      createdAt\n      expiresAt\n    }\n  }\n}",n.LEGACY_UPDATE_PAYMENT_CONTEXT_QUERY="mutation UpdateVenmoQRCodePaymentContext($input: UpdateVenmoQRCodePaymentContextInput!) {\n  updateVenmoQRCodePaymentContext(input: $input) {\n    clientMutationId\n  }\n}",n.UPDATE_PAYMENT_CONTEXT_QUERY="mutation UpdateVenmoPaymentContextStatus($input: UpdateVenmoPaymentContextStatusInput!) {\n  updateVenmoPaymentContextStatus(input: $input) {\n    clientMutationId\n  }\n}",n.LEGACY_VENMO_PAYMENT_CONTEXT_STATUS_QUERY="query PaymentContext($id: ID!) {\n  node(id: $id) {\n    ... on VenmoQRCodePaymentContext {\n      status\n      paymentMethodId\n      userName\n    }\n  }\n}",n.VENMO_PAYMENT_CONTEXT_STATUS_QUERY="query PaymentContext($id: ID!) {\n  node(id: $id) {\n    ... on VenmoPaymentContext {\n      status\n      paymentMethodId\n      userName\n      payerInfo {\n        firstName\n        lastName\n        phoneNumber\n        email\n        externalId\n        userName\n        billingAddress {\n          fullName\n          addressLine1\n          addressLine2\n          adminArea1\n          adminArea2\n          postalCode\n          countryCode\n        }\n        shippingAddress {\n          fullName\n          addressLine1\n          addressLine2\n          adminArea1\n          adminArea2\n          postalCode\n          countryCode\n        }\n      }\n    }\n  }\n}"},{}],215:[function(e,t,n){"use strict";var r=this&&this.__assign||function(){return r=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e},r.apply(this,arguments)},o=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(n,"__esModule",{value:!0});var i=o(e("framebus")),a=o(e("@braintree/iframer")),s=o(e("@braintree/uuid")),l=e("../shared/events"),c=e("./queries"),u=1e3,d=2e3,p=function(){function e(e){this.isHidden=!0,this.env=e.environment,this.id=s.default(),this.profileId=e.profileId,this.displayName=e.displayName,this.paymentMethodUsage=e.paymentMethodUsage,this.shouldUseLegacyQRCodeMutation=!this.paymentMethodUsage;var t=e.url+"#"+this.env+"_"+this.id;this.bus=new i.default({channel:this.id,verifyDomain:e.verifyDomain,targetFrames:[]}),this.apiRequest=e.apiRequest,this.sendEvent=e.sendEvent,this.Promise=e.Promise,this.alertBox=document.createElement("div"),this.alertBox.setAttribute("data-venmo-desktop-id",this.id),this.alertBox.setAttribute("role","alert"),this.alertBox.style.position="fixed",this.alertBox.style.display="none",this.alertBox.style.height="1px",this.alertBox.style.width="1px",this.alertBox.style.overflow="hidden",this.alertBox.style.zIndex="0",this.iframe=a.default({src:t,name:"venmo-desktop-iframe",style:{display:"none",position:"fixed",top:"0",bottom:"0",right:"0",left:"0",height:"100%",width:"100%",zIndex:"9999999"},title:"Venmo Desktop"}),this.bus.addTargetFrame(this.iframe)}return e.prototype.initialize=function(){var e=this;return new this.Promise((function(t){e.bus.on(l.VENMO_DESKTOP_IFRAME_READY,(function(){t(e)})),e.bus.on(l.VENMO_DESKTOP_REQUEST_NEW_QR_CODE,(function(){e.sendEvent("venmo.tokenize.desktop.restarted-from-error-view"),e.startPolling()})),document.body.appendChild(e.iframe),document.body.appendChild(e.alertBox)}))},e.prototype.launchDesktopFlow=function(){var e=this;this.isHidden=!1;var t=new this.Promise((function(t,n){e.launchDesktopPromiseRejectFunction=n;var r=function(){e.bus.off(l.VENMO_DESKTOP_CUSTOMER_CANCELED,i),e.bus.off(l.VENMO_DESKTOP_UNKNOWN_ERROR,o)},o=function(t){r(),e.sendEvent("venmo.tokenize.desktop.unknown-error"),n({allowUIToHandleError:!1,reason:"UNKNOWN_ERROR",err:t})},i=function(){r(),e.updateVenmoDesktopPaymentContext("CANCELED"),e.sendEvent("venmo.tokenize.desktop.status-change.canceled-from-modal"),n({allowUIToHandleError:!1,reason:"CUSTOMER_CANCELED"})};e.completedHandler=function(e){r(),t(e)},e.bus.on(l.VENMO_DESKTOP_CUSTOMER_CANCELED,i),e.bus.on(l.VENMO_DESKTOP_UNKNOWN_ERROR,o)}));return this.iframe.style.display="block",this.setAlert("Generating a QR code, get your Venmo app ready"),this.iframe.focus(),this.startPolling(),t.then((function(t){return delete e.venmoContextId,delete e.launchDesktopPromiseRejectFunction,t})).catch((function(t){return delete e.venmoContextId,delete e.launchDesktopPromiseRejectFunction,e.Promise.reject(t)}))},e.prototype.triggerCompleted=function(e){var t=this;this.isHidden||setTimeout((function(){t.completedHandler&&t.completedHandler(e),delete t.completedHandler}),d)},e.prototype.triggerRejected=function(e){this.launchDesktopPromiseRejectFunction&&this.launchDesktopPromiseRejectFunction(e)},e.prototype.hideDesktopFlow=function(){this.setAlert(""),this.iframe.style.display="none",this.bus.emit(l.VENMO_DESKTOP_CLOSED_FROM_PARENT),this.isHidden=!0},e.prototype.displayError=function(e){this.isHidden||(this.bus.emit(l.VENMO_DESKTOP_DISPLAY_ERROR,{message:e}),this.setAlert(e))},e.prototype.displayQRCode=function(e,t){this.isHidden||(this.bus.emit(l.VENMO_DESKTOP_DISPLAY_QR_CODE,{id:e,merchantId:t}),this.setAlert("To scan the QR code, open your Venmo app"))},e.prototype.authorize=function(){this.isHidden||(this.bus.emit(l.VENMO_DESKTOP_AUTHORIZE),this.setAlert("Venmo account authorized"))},e.prototype.authorizing=function(){this.isHidden||(this.bus.emit(l.VENMO_DESKTOP_AUTHORIZING),this.setAlert("Authorize on your Venmo app"))},e.prototype.startPolling=function(){var e=this;return this.createVenmoDesktopPaymentContext().then((function(t){var n=new Date(t.expiresAt).getTime()-new Date(t.createdAt).getTime(),r=Date.now()+n;return e.displayQRCode(t.id,t.merchantId),e.pollForStatusChange(t.status,r)})).then((function(t){if(t){var n=t.userName||"";n="@"+n.replace("@",""),e.triggerCompleted({paymentMethodNonce:t.paymentMethodId,username:n,payerInfo:t.payerInfo,id:e.venmoContextId||""})}})).catch((function(t){t.allowUIToHandleError||(e.sendEvent("venmo.tokenize.desktop.unhandled-error"),e.triggerRejected(t))}))},e.prototype.pollForStatusChange=function(e,t){var n=this;return this.venmoContextId?Date.now()>t?this.updateVenmoDesktopPaymentContext("EXPIRED").then((function(){return n.displayError("Something went wrong"),n.sendEvent("venmo.tokenize.desktop.status-change.sdk-timeout"),n.Promise.reject({allowUIToHandleError:!0,reason:"TIMEOUT"})})):this.lookupVenmoDesktopPaymentContext().then((function(r){if(!n.venmoContextId||!r)return n.Promise.resolve();var o=r.status;if(o!==e)switch(e=o,n.sendEvent("venmo.tokenize.desktop.status-change."+e.toLowerCase()),e){case"CREATED":break;case"EXPIRED":case"FAILED":case"CANCELED":var i="CANCELED"===e?"The authorization was canceled":"Something went wrong";return n.displayError(i),n.Promise.reject({allowUIToHandleError:!0,reason:e});case"SCANNED":n.authorizing();break;case"APPROVED":return n.authorize(),n.Promise.resolve(r)}return new n.Promise((function(r,o){setTimeout((function(){n.pollForStatusChange(e,t).then(r).catch(o)}),u)}))})):this.Promise.resolve()},e.prototype.teardown=function(){this.bus.teardown(),this.iframe.parentNode&&this.iframe.parentNode.removeChild(this.iframe),this.alertBox.parentNode&&this.alertBox.parentNode.removeChild(this.alertBox)},e.prototype.setAlert=function(e){this.alertBox.style.display=e?"block":"none",this.alertBox.textContent=e},e.prototype.createPaymentContextFromGraphqlLegacyQRCodeMutation=function(e){return this.apiRequest(c.LEGACY_CREATE_PAYMENT_CONTEXT_QUERY,{input:{environment:this.env,intent:e}}).then((function(e){return e.createVenmoQRCodePaymentContext.venmoQRCodePaymentContext}))},e.prototype.createPaymentContextFromGraphQL=function(e){var t={intent:e,paymentMethodUsage:this.paymentMethodUsage,customerClient:"DESKTOP"};return this.profileId&&(t.merchantProfileId=this.profileId),this.displayName&&(t.displayName=this.displayName),this.apiRequest(c.CREATE_PAYMENT_CONTEXT_QUERY,{input:t}).then((function(e){return e.createVenmoPaymentContext.venmoPaymentContext}))},e.prototype.createVenmoDesktopPaymentContext=function(){var e=this;return(this.shouldUseLegacyQRCodeMutation?this.createPaymentContextFromGraphqlLegacyQRCodeMutation("PAY_FROM_APP"):this.createPaymentContextFromGraphQL("PAY_FROM_APP")).then((function(t){e.venmoContextId=t.id;var n=e.profileId||t.merchantId;return{id:t.id,status:t.status,merchantId:n,createdAt:t.createdAt,expiresAt:t.expiresAt}}))},e.prototype.updateVenmoDesktopPaymentContext=function(e,t){if(void 0===t&&(t={}),!this.venmoContextId)return this.Promise.resolve();var n={input:r({id:this.venmoContextId,status:e},t)},o=this.shouldUseLegacyQRCodeMutation?c.LEGACY_UPDATE_PAYMENT_CONTEXT_QUERY:c.UPDATE_PAYMENT_CONTEXT_QUERY;return this.apiRequest(o,n).then((function(){}))},e.prototype.lookupVenmoDesktopPaymentContext=function(){if(!this.venmoContextId)return this.Promise.resolve();var e=this.shouldUseLegacyQRCodeMutation?c.LEGACY_VENMO_PAYMENT_CONTEXT_STATUS_QUERY:c.VENMO_PAYMENT_CONTEXT_STATUS_QUERY;return this.apiRequest(e,{id:this.venmoContextId}).then((function(e){return e.node}))},e}();n.default=p},{"../shared/events":220,"./queries":214,"@braintree/iframer":35,"@braintree/uuid":39,framebus:52}],216:[function(e,t,n){"use strict";var r=e("../lib/analytics"),o=e("../lib/basic-component-verification"),i=e("../lib/create-deferred-client"),a=e("../lib/create-assets-url"),s=e("./shared/errors"),l=e("@braintree/wrap-promise"),c=e("../lib/braintree-error"),u=e("./venmo"),d=e("./shared/supports-venmo"),p="3.102.0";function f(e){var t="Venmo";return o.verify({name:t,client:e.client,authorization:e.authorization}).then((function(){var n,o;return e.profileId&&"string"!=typeof e.profileId?Promise.reject(new c(s.VENMO_INVALID_PROFILE_ID)):e.deepLinkReturnUrl&&"string"!=typeof e.deepLinkReturnUrl?Promise.reject(new c(s.VENMO_INVALID_DEEP_LINK_RETURN_URL)):(n=i.create({authorization:e.authorization,client:e.client,debug:e.debug,assetsUrl:a.create(e.authorization),name:t}).then((function(t){var n=t.getConfiguration();return e.client=t,n.gatewayConfiguration.payWithVenmo?t:Promise.reject(new c(s.VENMO_NOT_ENABLED))})),e.createPromise=n,o=new u(e),r.sendEvent(n,"venmo.initialized"),n.then((function(){return o})))}))}function h(e){return d.isBrowserSupported(e)}t.exports={create:l(f),isBrowserSupported:h,VERSION:p}},{"../lib/analytics":119,"../lib/basic-component-verification":122,"../lib/braintree-error":124,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./shared/errors":219,"./shared/supports-venmo":222,"./venmo":224,"@braintree/wrap-promise":43}],217:[function(e,t,n){"use strict";var r=e("@braintree/browser-detection/is-android"),o=e("@braintree/browser-detection/is-chrome"),i=e("@braintree/browser-detection/is-ios"),a=e("@braintree/browser-detection/is-ios-safari"),s=e("@braintree/browser-detection/is-ios-webview"),l=e("@braintree/browser-detection/is-samsung");function c(){return r()&&window.navigator.userAgent.toLowerCase().indexOf("wv")>-1}function u(){return!!i()&&(s()||!a())}function d(){var e=window.navigator.userAgent.toLowerCase();return e.indexOf("huawei")>-1&&e.indexOf("fban")>-1||!!r()&&(e.indexOf("fb_iab")>-1||e.indexOf("instagram")>-1)}function p(){return i()&&o()}t.exports={isAndroid:r,isAndroidWebview:c,isChrome:o,isIos:i,isIosChrome:p,isSamsung:l,isIosSafari:a,isIosWebview:s,isFacebookOwnedBrowserOnAndroid:d,doesNotSupportWindowOpenInIos:u}},{"@braintree/browser-detection/is-android":22,"@braintree/browser-detection/is-chrome":24,"@braintree/browser-detection/is-ios":30,"@braintree/browser-detection/is-ios-safari":27,"@braintree/browser-detection/is-ios-webview":28,"@braintree/browser-detection/is-samsung":31}],218:[function(e,t,n){"use strict";t.exports={DOCUMENT_VISIBILITY_CHANGE_EVENT_DELAY:500,DEFAULT_PROCESS_RESULTS_DELAY:1e3,VENMO_APP_OR_MOBILE_AUTH_URL:"https://venmo.com/go/checkout",VENMO_MOBILE_APP_AUTH_ONLY_URL:"https://venmo.com/braintree/checkout",VENMO_WEB_LOGIN_URL:"https://account.venmo.com/go/web"}},{}],219:[function(e,t,n){"use strict";var r=e("../../lib/braintree-error");t.exports={VENMO_NOT_ENABLED:{type:r.types.MERCHANT,code:"VENMO_NOT_ENABLED",message:"Venmo is not enabled for this merchant."},VENMO_TOKENIZATION_REQUEST_ACTIVE:{type:r.types.MERCHANT,code:"VENMO_TOKENIZATION_REQUEST_ACTIVE",message:"Another tokenization request is active."},VENMO_TOKENIZATION_REQUEST_NOT_ACTIVE:{type:r.types.MERCHANT,code:"VENMO_TOKENIZATION_REQUEST_NOT_ACTIVE",message:"No tokenization in progress."},VENMO_APP_FAILED:{type:r.types.UNKNOWN,code:"VENMO_APP_FAILED",message:"Venmo app encountered a problem."},VENMO_APP_CANCELED:{type:r.types.CUSTOMER,code:"VENMO_APP_CANCELED",message:"Venmo app authorization was canceled."},VENMO_CANCELED:{type:r.types.CUSTOMER,code:"VENMO_CANCELED",message:"User canceled Venmo authorization, or Venmo app is not available."},VENMO_CUSTOMER_CANCELED:{type:r.types.CUSTOMER,code:"VENMO_CUSTOMER_CANCELED",message:"User canceled Venmo authorization."},VENMO_NETWORK_ERROR:{type:r.types.NETWORK,code:"VENMO_NETWORK_ERROR",message:"Something went wrong making the request"},VENMO_DESKTOP_CANCELED:{type:r.types.CUSTOMER,code:"VENMO_DESKTOP_CANCELED",message:"User canceled Venmo authorization by closing the Venmo Desktop modal."},VENMO_TOKENIZATION_CANCELED_BY_MERCHANT:{type:r.types.MERCHANT,code:"VENMO_TOKENIZATION_CANCELED_BY_MERCHANT",message:"The Venmo tokenization was canceled by the merchant."},VENMO_DESKTOP_UNKNOWN_ERROR:{type:r.types.UNKNOWN,code:"VENMO_DESKTOP_UNKNOWN_ERROR",message:"Something went wrong with the Venmo Desktop flow."},VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED:{type:r.types.NETWORK,code:"VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED",message:"Something went wrong creating the Venmo Payment Context."},VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR:{type:r.types.UNKNOWN,code:"VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR",message:"Something went wrong during mobile polling."},VENMO_MOBILE_POLLING_TOKENIZATION_EXPIRED:{type:r.types.CUSTOMER,code:"VENMO_MOBILE_POLLING_TOKENIZATION_EXPIRED",message:"The Venmo authorization request is expired."},VENMO_MOBILE_POLLING_TOKENIZATION_CANCELED:{type:r.types.CUSTOMER,code:"VENMO_MOBILE_POLLING_TOKENIZATION_CANCELED",message:"The Venmo authorization was canceled"},VENMO_MOBILE_POLLING_TOKENIZATION_TIMEOUT:{type:r.types.CUSTOMER,code:"VENMO_MOBILE_POLLING_TOKENIZATION_TIMEOUT",message:"Customer took too long to authorize Venmo payment."},VENMO_MOBILE_POLLING_TOKENIZATION_FAILED:{type:r.types.UNKNOWN,code:"VENMO_MOBILE_POLLING_TOKENIZATION_FAILED",message:"The Venmo authorization failed."},VENMO_INVALID_PROFILE_ID:{type:r.types.MERCHANT,code:"VENMO_INVALID_PROFILE_ID",message:"Venmo profile ID is invalid."},VENMO_INVALID_DEEP_LINK_RETURN_URL:{type:r.types.MERCHANT,code:"VENMO_INVALID_DEEP_LINK_RETURN_URL",message:"Venmo deep link return URL is invalid."},VENMO_TOKENIZATION_FAILED:{type:r.types.UNKNOWN,code:"VENMO_TOKENIZATION_FAILED",message:"Venmo encountered a problem"},VENMO_ECD_DISABLED:{type:r.types.MERCHANT,code:"ECD_DISABLED",message:"Cannot collect customer data when ECD is disabled. Enable this feature in the Control Panel to collect this data."}}},{"../../lib/braintree-error":124}],220:[function(e,t,n){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.VENMO_DESKTOP_UNKNOWN_ERROR=n.VENMO_DESKTOP_REQUEST_NEW_QR_CODE=n.VENMO_DESKTOP_CLOSED_FROM_PARENT=n.VENMO_DESKTOP_IFRAME_READY=n.VENMO_DESKTOP_DISPLAY_QR_CODE=n.VENMO_DESKTOP_DISPLAY_ERROR=n.VENMO_DESKTOP_CUSTOMER_CANCELED=n.VENMO_DESKTOP_AUTHORIZING=n.VENMO_DESKTOP_AUTHORIZE=n.VENMO_DESKTOP_AUTHORIZATION_TIMED_OUT=void 0,n.VENMO_DESKTOP_AUTHORIZATION_TIMED_OUT="VENMO_DESKTOP_AUTHORIZATION_TIMED_OUT",n.VENMO_DESKTOP_AUTHORIZE="VENMO_DESKTOP_AUTHORIZE",n.VENMO_DESKTOP_AUTHORIZING="VENMO_DESKTOP_AUTHORIZING",n.VENMO_DESKTOP_CUSTOMER_CANCELED="VENMO_DESKTOP_CUSTOMER_CANCELED",n.VENMO_DESKTOP_DISPLAY_ERROR="VENMO_DESKTOP_DISPLAY_ERROR",n.VENMO_DESKTOP_DISPLAY_QR_CODE="VENMO_DESKTOP_DISPLAY_QR_CODE",n.VENMO_DESKTOP_IFRAME_READY="VENMO_DESKTOP_IFRAME_READY",n.VENMO_DESKTOP_CLOSED_FROM_PARENT="VENMO_DESKTOP_CLOSED_FROM_PARENT",n.VENMO_DESKTOP_REQUEST_NEW_QR_CODE="VENMO_DESKTOP_REQUEST_NEW_QR_CODE",n.VENMO_DESKTOP_UNKNOWN_ERROR="VENMO_DESKTOP_UNKNOWN_ERROR"},{}],221:[function(e,t,n){"use strict";var r=e("./constants");function o(e){return e.useAllowDesktopWebLogin?r.VENMO_WEB_LOGIN_URL:e.mobileWebFallBack?r.VENMO_APP_OR_MOBILE_AUTH_URL:r.VENMO_MOBILE_APP_AUTH_ONLY_URL}t.exports=o},{"./constants":218}],222:[function(e,t,n){"use strict";var r=e("./browser-detection"),o=e("../../lib/in-iframe");function i(e){var t,n,i,a=r.isAndroid(),s=a||r.isIos(),l=a&&r.isChrome(),c=r.isIosSafari()||l;return t=!0===((e=e||{}).allowDesktopWebLogin||e.allowDesktop),n=!e.hasOwnProperty("allowNewBrowserTab")||e.allowNewBrowserTab,i=!e.hasOwnProperty("allowWebviews")||e.allowWebviews,!((!n||o())&&r.isIosChrome()||r.isFacebookOwnedBrowserOnAndroid()||r.isSamsung())&&!(!i&&(r.isAndroidWebview()||r.isIosWebview()))&&(s?n?s:c:t)}t.exports={isBrowserSupported:i}},{"../../lib/in-iframe":150,"./browser-detection":217}],223:[function(e,t,n){"use strict";var r=e("../../lib/frame-service/external"),o=e("../../lib/use-min"),i=e("@braintree/extended-promise"),a=e("../shared/errors"),s=e("../../lib/braintree-error"),l="3.102.0",c='<svg width="198" height="58" viewBox="0 0 198 58" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M43.0702 13.6572C44.1935 15.4585 44.6999 17.3139 44.6999 19.6576C44.6999 27.1328 38.1277 36.8436 32.7935 43.6625H20.6099L15.7236 15.2939L26.3917 14.3105L28.9751 34.4966C31.389 30.6783 34.3678 24.6779 34.3678 20.587C34.3678 18.3477 33.9727 16.8225 33.3553 15.5666L43.0702 13.6572Z" fill="white"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M56.8965 26.1491C58.8596 26.1491 63.8018 25.2772 63.8018 22.5499C63.8018 21.2402 62.8481 20.587 61.7242 20.587C59.7579 20.587 57.1776 22.8763 56.8965 26.1491ZM56.6715 31.5506C56.6715 34.8807 58.5787 36.1873 61.107 36.1873C63.8603 36.1873 66.4966 35.534 69.923 33.8433L68.6324 42.3523C66.2183 43.4976 62.4559 44.2617 58.8039 44.2617C49.5403 44.2617 46.2249 38.8071 46.2249 31.9879C46.2249 23.1496 51.6179 13.765 62.7365 13.765C68.858 13.765 72.2809 17.0949 72.2809 21.7317C72.2815 29.2066 62.4005 31.4965 56.6715 31.5506Z" fill="white"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M103.067 20.3142C103.067 21.4052 102.897 22.9875 102.727 24.0216L99.5262 43.6622H89.1385L92.0585 25.658C92.1139 25.1696 92.284 24.1865 92.284 23.6411C92.284 22.3314 91.4414 22.0047 90.4282 22.0047C89.0826 22.0047 87.7337 22.6042 86.8354 23.0418L83.5234 43.6625H73.0772L77.8495 14.257H86.8908L87.0052 16.6041C89.1382 15.2404 91.9469 13.7656 95.932 13.7656C101.212 13.765 103.067 16.3845 103.067 20.3142Z" fill="white"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M133.906 16.9841C136.881 14.9131 139.69 13.765 143.563 13.765C148.897 13.765 150.753 16.3845 150.753 20.3142C150.753 21.4052 150.583 22.9875 150.413 24.0216L147.216 43.6622H136.825L139.801 25.2774C139.855 24.786 139.971 24.1865 139.971 23.8063C139.971 22.3317 139.128 22.0047 138.115 22.0047C136.824 22.0047 135.535 22.5501 134.577 23.0418L131.266 43.6625H120.878L123.854 25.2777C123.908 24.7863 124.02 24.1868 124.02 23.8065C124.02 22.332 123.177 22.0049 122.167 22.0049C120.819 22.0049 119.473 22.6045 118.574 23.0421L115.26 43.6628H104.817L109.589 14.2573H118.52L118.8 16.7122C120.878 15.241 123.684 13.7662 127.446 13.7662C130.704 13.765 132.837 15.129 133.906 16.9841Z" fill="white"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M171.426 25.5502C171.426 23.1496 170.808 21.513 168.956 21.513C164.857 21.513 164.015 28.55 164.015 32.1498C164.015 34.8807 164.802 36.5709 166.653 36.5709C170.528 36.5709 171.426 29.1497 171.426 25.5502ZM153.458 31.7152C153.458 22.442 158.511 13.765 170.136 13.765C178.896 13.765 182.098 18.7854 182.098 25.7148C182.098 34.8805 177.099 44.3723 165.194 44.3723C156.378 44.3723 153.458 38.7525 153.458 31.7152Z" fill="white"/>\n</svg>',u="Tap cancel payment to cancel and return to the business. Continue payment will relaunch the payment window.",d=400,p=570,f={backdrop:"venmo-desktop-web-backdrop",backdropHidden:"venmo-desktop-web-backdrop.hidden",backdropContainer:"venmo-backdrop-container",cancelButton:"venmo-popup-cancel-button",continueButton:"venmo-popup-continue-button",message:"venmo-message",instructions:"venmo-instructions",venmoLogo:"venmo-full-logo"};function h(e){var t=e.frameServiceInstance,n=e.venmoUrl,r=e.checkForStatusChange,o=e.cancelTokenization,l=e.checkPaymentContextStatus,c=new i;return document.getElementById(f.continueButton).addEventListener("click",(function(){t.focus()})),document.getElementById(f.cancelButton).addEventListener("click",(function(){t.close(),o(),g()})),t.open({},(function(e){var n=1;e?c.reject(e):r(n).then((function(e){c.resolve(e)})).catch((function(e){l().then((function(t){"CREATED"===t.status?c.reject(new s(a.VENMO_CUSTOMER_CANCELED)):c.reject(e)}))})),t.close(),g()})),t.redirect(n),c}function m(){return{top:Math.round((window.outerHeight-p)/2)+window.screenTop,left:Math.round((window.outerWidth-d)/2)+window.screenLeft}}function g(){document.getElementById("venmo-desktop-web-backdrop").classList.add("hidden")}function v(){var e=["#"+f.backdropHidden+" {","display: none;","}","#"+f.backdrop+" {","z-index: 3141592632;","cursor: pointer;","position: fixed;","top: 0;","left: 0;","bottom: 0;","width: 100%;","background: rgba(0, 0, 0, 0.8);","}"],t=["#"+f.backdropContainer+" {","display: flex;","align-content: center;","justify-content: center;","align-items: center;","width: 100%;","height: 100%;","flex-direction: column;","}"],n=["#"+f.cancelButton+" {","height: 24px;","width: 380px;","font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;","font-style: normal;","font-weight: 700;","font-size: 18px;","line-height: 24px;","text-align: center;","background-color: transparent;","border: none;","color: #FFFFFF;","margin-top: 28px;","}"],r=["#"+f.continueButton+" {","width: 400px;","height: 50px;","background: #0074DE;","border-radius: 24px;","border: none;","font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;","font-style: normal;","font-weight: 700;","font-size: 18px;","color: #FFFFFF;","margin-top: 44px;","}"],o=["#"+f.message+" {","font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;","font-style: normal;","font-weight: 500;","font-size: 24px;","line-height: 32px;","text-align: center;","color: #FFFFFF;","margin-top: 32px;","}"],i=["#"+f.instructions+" {","font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;","font-style: normal;","font-weight: 400;","font-size: 16px;","line-height: 20px;","text-align: center;","color: #FFFFFF;","margin-top: 16px;","width: 400px;","}"];return e.concat(t,n,r,o,i).join("\n")}function y(){var e,t,n,r,o,i,a,s,l=document.getElementById(f.backdrop);l?l.classList.remove("hidden"):(e=document.createElement("style"),t=document.createElement("div"),n=document.createElement("div"),r=document.createElement("div"),o=document.createElement("div"),i=document.createElement("div"),a=document.createElement("button"),s=document.createElement("button"),e.id="venmo-desktop-web__injected-styles",e.innerHTML=v(),t.id=f.backdrop,n.id=f.backdropContainer,r.id=f.venmoLogo,r.innerHTML=c,o.id=f.message,o.innerText="What would you like to do?",i.id=f.instructions,i.innerText=u,a.id=f.continueButton,a.innerText="Continue payment",s.id=f.cancelButton,s.innerText="Cancel payment",document.head.appendChild(e),n.appendChild(r),n.appendChild(o),n.appendChild(i),n.appendChild(a),n.appendChild(s),t.appendChild(n),document.body.appendChild(t),t.addEventListener("click",(function(e){e.stopPropagation()})))}function b(e){return y(),h(e)}function _(e){var t=new i,n="venmoDesktopWebLogin",a=e.assetsUrl,s=e.debug||!1,c=m(),u=a+"/web/"+l+"/html";return r.create({name:n,dispatchFrameUrl:u+"/dispatch-frame"+o(s)+".html",openFrameUrl:u+"/venmo-landing-frame"+o(s)+".html",top:c.top,left:c.left,height:p,width:d},(function(e){t.resolve(e)})),t}i.suppressUnhandledPromiseMessage=!0,t.exports={runWebLogin:b,openPopup:h,setupDesktopWebLogin:_,POPUP_WIDTH:d,POPUP_HEIGHT:p}},{"../../lib/braintree-error":124,"../../lib/frame-service/external":139,"../../lib/use-min":160,"../shared/errors":219,"@braintree/extended-promise":34}],224:[function(e,t,n){"use strict";var r=e("../lib/analytics"),o=e("./shared/supports-venmo"),i=e("./shared/browser-detection"),a=e("./shared/constants"),s=e("./shared/errors"),l=e("../lib/querystring"),c=e("../lib/is-verified-domain"),u=e("../lib/methods"),d=e("../lib/convert-methods-to-error"),p=e("@braintree/wrap-promise"),f=e("../lib/braintree-error"),h=e("../lib/in-iframe"),m=e("@braintree/extended-promise"),g=e("./shared/get-venmo-url"),v=e("./shared/web-login-backdrop"),y=e("../lib/snake-case-to-camel-case"),b=e("./external/"),_=e("./external/queries"),A="3.102.0",E=250,w=3e5;function x(e){var t=this;this._allowDesktopWebLogin=e.allowDesktopWebLogin||!1,this._mobileWebFallBack=e.mobileWebFallBack||!1,this._createPromise=e.createPromise,this._allowNewBrowserTab=!1!==e.allowNewBrowserTab,this._allowWebviews=!1!==e.allowWebviews,this._allowDesktop=!0===e.allowDesktop,this._useRedirectForIOS=!0===e.useRedirectForIOS,this._profileId=e.profileId,this._displayName=e.displayName,this._deepLinkReturnUrl=e.deepLinkReturnUrl,this._ignoreHistoryChanges=e.ignoreHistoryChanges,this._paymentMethodUsage=(e.paymentMethodUsage||"").toUpperCase(),this._shouldUseLegacyFlow=!this._paymentMethodUsage,this._requireManualReturn=!0===e.requireManualReturn,this._useDesktopQRFlow=this._allowDesktop&&this._isDesktop()&&!this._allowDesktopWebLogin,this._useAllowDesktopWebLogin=this._allowDesktopWebLogin&&this._isDesktop(),this._cannotHaveReturnUrls=h()||this._requireManualReturn,this._allowAndroidRecreation=!1!==e.allowAndroidRecreation,this._maxRetryCount=3,this._collectCustomerBillingAddress=e.collectCustomerBillingAddress||!1,this._collectCustomerShippingAddress=e.collectCustomerShippingAddress||!1,this._isFinalAmount=e.isFinalAmount||!1,this._lineItems=e.lineItems,this._subTotalAmount=e.subTotalAmount,this._discountAmount=e.discountAmount,this._taxAmount=e.taxAmount,this._shippingAmount=e.shippingAmount,this._totalAmount=e.totalAmount,this._shouldCreateVenmoPaymentContext=this._cannotHaveReturnUrls||!this._shouldUseLegacyFlow,r.sendEvent(this._createPromise,"venmo.desktop-flow.configured."+String(Boolean(this._allowDesktop))),this.hasTokenizationResult()?r.sendEvent(this._createPromise,"venmo.appswitch.return-in-new-tab"):this._useDesktopQRFlow?this._createPromise=this._createPromise.then((function(e){var n=e.getConfiguration().gatewayConfiguration;return b({url:n.assetsUrl+"/web/"+A+"/html/venmo-desktop-frame.html",environment:"production"===n.environment?"PRODUCTION":"SANDBOX",profileId:t._profileId||n.payWithVenmo.merchantId,paymentMethodUsage:t._paymentMethodUsage,displayName:t._displayName,Promise,apiRequest:function(t,n){return e.request({api:"graphQLApi",data:{query:t,variables:n}}).then((function(e){return e.data}))},sendEvent:function(e){r.sendEvent(t._createPromise,e)},verifyDomain:c}).then((function(n){return t._venmoDesktopInstance=n,r.sendEvent(t._createPromise,"venmo.desktop-flow.presented"),e})).catch((function(){return r.sendEvent(t._createPromise,"venmo.desktop-flow.setup-failed"),t._useDesktopQRFlow=!1,e}))})):this._shouldCreateVenmoPaymentContext&&(this._mobilePollingInterval=E,this._mobilePollingExpiresThreshold=w,this._createPromise=this._createPromise.then((function(e){var n,o,i=t._cannotHaveReturnUrls?"manual-return":"mobile-payment-context",a=e.getConfiguration();return o=v.setupDesktopWebLogin({assetsUrl:a.gatewayConfiguration.assetsUrl,debug:a.isDebug}).then((function(e){t._frameServiceInstance=e})).catch((function(e){return e})),t._mobilePollingContextEnvironment=a.gatewayConfiguration.environment.toUpperCase(),n=t._createVenmoPaymentContext(e).then((function(){return r.sendEvent(t._createPromise,"venmo."+i+".presented"),e})).catch((function(e){return r.sendEvent(t._createPromise,"venmo."+i+".setup-failed"),Promise.reject(new f({type:s.VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED.type,code:s.VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED.code,message:k(e)?e.details.originalError[0].message:s.VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED.message,details:{originalError:e}}))})),m.all([o,n]).then((function(e){var t=e[1];return Promise.resolve(t)})).catch((function(e){return Promise.reject(e)}))})))}function k(e){return e.details&&e.details.originalError&&e.details.originalError[0]&&e.details.originalError[0].extensions&&"VALIDATION"===e.details.originalError[0].extensions.errorClass&&"user_error"===e.details.originalError[0].extensions.errorType}function C(e){var t=(e||window.location.hash.substring(1)).split("&").reduce((function(e,t){var n=t.split("="),r=decodeURIComponent(n[0]).replace(/\W/g,""),o=y(r),i=decodeURIComponent(n[1]);return e[o]=i,e}),{});return t.resourceId&&(t.id=t.resourceId),t}function S(e){return"@"+(e=e||"").replace("@","")}function M(e){var t={nonce:e.paymentMethodNonce,type:"VenmoAccount",details:{username:S(e.username),paymentContextId:e.id}};return e.payerInfo&&(t.details.payerInfo=e.payerInfo,t.details.payerInfo.userName=S(e.payerInfo.userName)),t}function T(){var e;return void 0!==window.document.hidden?e="visibilitychange":void 0!==window.document.msHidden?e="msvisibilitychange":void 0!==window.document.webkitHidden&&(e="webkitvisibilitychange"),e}function O(){return window.navigator.platform&&/iPhone|iPad|iPod/.test(window.navigator.platform)}m.suppressUnhandledPromiseMessage=!0,x.prototype._createVenmoPaymentContext=function(e,t){var n,r,o=this,i=e.getConfiguration().gatewayConfiguration.payWithVenmo,a=!1,l=o._useAllowDesktopWebLogin?"NATIVE_WEB":"MOBILE_WEB";if(!this._shouldCreateVenmoPaymentContext)return Promise.resolve();if(this._shouldUseLegacyFlow)n=e.request({api:"graphQLApi",data:{query:_.LEGACY_CREATE_PAYMENT_CONTEXT_QUERY,variables:{input:{environment:this._mobilePollingContextEnvironment,intent:"PAY_FROM_APP"}}}}).then((function(e){return e.data.createVenmoQRCodePaymentContext.venmoQRCodePaymentContext}));else{if((this._collectCustomerBillingAddress||this._collectCustomerShippingAddress)&&!i.enrichedCustomerDataEnabled)return Promise.reject(new f(s.VENMO_ECD_DISABLED));this._lineItems&&this._lineItems.forEach((function(e){e.unitTaxAmount=e.unitTaxAmount||"0"})),r={subTotalAmount:this._subTotalAmount,discountAmount:this._discountAmount,taxAmount:this._taxAmount,shippingAmount:this._shippingAmount,totalAmount:this._totalAmount,lineItems:this._lineItems},a=Object.keys(r).some((function(e){return void 0!==r[e]})),n=e.request({api:"graphQLApi",data:{query:_.CREATE_PAYMENT_CONTEXT_QUERY,variables:{input:{paymentMethodUsage:this._paymentMethodUsage,intent:"CONTINUE",customerClient:l,isFinalAmount:this._isFinalAmount,displayName:this._displayName,paysheetDetails:{collectCustomerBillingAddress:this._collectCustomerBillingAddress,collectCustomerShippingAddress:this._collectCustomerShippingAddress,transactionDetails:a?r:void 0}}}}}).then((function(e){return e.data.createVenmoPaymentContext.venmoPaymentContext}))}return n.then((function(n){var r=.6666*(new Date(n.expiresAt)-new Date(n.createdAt));clearTimeout(o._refreshPaymentContextTimeout),o._refreshPaymentContextTimeout=setTimeout((function(){o._tokenizationInProgress||o._createVenmoPaymentContext(e,!0)}),r),t&&o._tokenizationInProgress||(o._venmoPaymentContextStatus=n.status,o._venmoPaymentContextId=n.id)}))},x.prototype.appSwitch=function(e){this._deepLinkReturnUrl?O()?(r.sendEvent(this._createPromise,"venmo.appswitch.start.ios-webview"),window.location.href=e):window.popupBridge&&"function"==typeof window.popupBridge.open?(r.sendEvent(this._createPromise,"venmo.appswitch.start.popup-bridge"),window.popupBridge.open(e)):(r.sendEvent(this._createPromise,"venmo.appswitch.start.webview"),window.open(e)):(r.sendEvent(this._createPromise,"venmo.appswitch.start.browser"),i.doesNotSupportWindowOpenInIos()||this._shouldUseRedirectStrategy()?window.location.href=e:window.open(e))},x.prototype.getUrl=function(){return this._createPromise.then(function(e){var t=e.getConfiguration(),n={},r=this._deepLinkReturnUrl||window.location.href.replace(window.location.hash,""),o=t.gatewayConfiguration.payWithVenmo,i=t.analyticsMetadata,a=o.accessToken,s={_meta:{version:i.sdkVersion,integration:i.integration,platform:i.platform,sessionId:i.sessionId}};return this._isDebug=t.isDebug,this._assetsUrl=t.gatewayConfiguration.assetsUrl,r=r.replace(/#*$/,""),this._venmoPaymentContextId&&(this._shouldUseLegacyFlow?a+="|pcid:"+this._venmoPaymentContextId:n.resource_id=this._venmoPaymentContextId),this._shouldIncludeReturnUrls()||this._useAllowDesktopWebLogin?(this._useAllowDesktopWebLogin&&(r=this._assetsUrl+"/web/"+A+"/html/redirect-frame.html"),n["x-success"]=r+"#venmoSuccess=1",n["x-cancel"]=r+"#venmoCancel=1",n["x-error"]=r+"#venmoError=1"):(n["x-success"]="NOOP",n["x-cancel"]="NOOP",n["x-error"]="NOOP"),this._allowAndroidRecreation?n.allowAndroidRecreation=1:n.allowAndroidRecreation=0,n.ua=window.navigator.userAgent,n.braintree_merchant_id=this._profileId||o.merchantId,n.braintree_access_token=a,n.braintree_environment=o.environment,n.braintree_sdk_data=btoa(JSON.stringify(s)),g({useAllowDesktopWebLogin:this._useAllowDesktopWebLogin,mobileWebFallBack:this._mobileWebFallBack})+"?"+l.stringify(n)}.bind(this))},x.prototype.isBrowserSupported=function(){return o.isBrowserSupported({allowNewBrowserTab:this._allowNewBrowserTab,allowWebviews:this._allowWebviews,allowDesktop:this._allowDesktop,allowDesktopWebLogin:this._allowDesktopWebLogin})},x.prototype.hasTokenizationResult=function(){return this._hasTokenizationResult()},x.prototype._hasTokenizationResult=function(e){var t=C(e);return void 0!==(t.venmoSuccess||t.venmoError||t.venmoCancel)},x.prototype._shouldIncludeReturnUrls=function(){return!!this._deepLinkReturnUrl||!this._cannotHaveReturnUrls},x.prototype._isDesktop=function(){return!(i.isIos()||i.isAndroid())},x.prototype.tokenize=function(e){var t=this;return e=e||{},!0===this._tokenizationInProgress?Promise.reject(new f(s.VENMO_TOKENIZATION_REQUEST_ACTIVE)):(this._tokenizationInProgress=!0,(this._useDesktopQRFlow?this._tokenizeForDesktopQRFlow(e):this._useAllowDesktopWebLogin?this._tokenizeWebLoginWithRedirect():this._cannotHaveReturnUrls?this._tokenizeForMobileWithManualReturn():this._tokenizeForMobileWithHashChangeListeners(e)).then((function(e){return t._createPromise.then((function(e){return t._createVenmoPaymentContext(e)})).then((function(){return t._tokenizationInProgress=!1,M(e)}))})).catch((function(e){return t._createPromise.then((function(e){return t._createVenmoPaymentContext(e)})).then((function(){return t._tokenizationInProgress=!1,Promise.reject(e)}))})))},x.prototype.cancelTokenization=function(){return this._tokenizationInProgress?(this._removeVisibilityEventListener(),this._tokenizePromise&&this._tokenizePromise.reject(new f(s.VENMO_TOKENIZATION_CANCELED_BY_MERCHANT)),Promise.all([this._cancelMobilePaymentContext(),this._cancelVenmoDesktopContext()])):Promise.reject(new f(s.VENMO_TOKENIZATION_REQUEST_NOT_ACTIVE))},x.prototype._tokenizeWebLoginWithRedirect=function(){var e=this;return r.sendEvent(e._createPromise,"venmo.tokenize.web-login.start"),this._tokenizePromise=new m,this.getUrl().then((function(t){return v.runWebLogin({checkForStatusChange:e._checkPaymentContextStatusAndProcessResult.bind(e),cancelTokenization:e.cancelTokenization.bind(e),frameServiceInstance:e._frameServiceInstance,venmoUrl:t,debug:e._isDebug,checkPaymentContextStatus:e._checkPaymentContextStatus.bind(e)}).then((function(t){r.sendEvent(e._createPromise,"venmo.tokenize.web-login.success"),e._tokenizePromise.resolve({paymentMethodNonce:t.paymentMethodId,username:t.userName,payerInfo:t.payerInfo,id:e._venmoPaymentContextId})})).catch((function(t){r.sendEvent(e._createPromise,"venmo.tokenize.web-login.failure"),e._tokenizePromise.reject(t)})),e._tokenizePromise}))},x.prototype._queryPaymentContextStatus=function(e){var t=this;return this._createPromise.then((function(n){var r=t._shouldUseLegacyFlow?_.LEGACY_VENMO_PAYMENT_CONTEXT_STATUS_QUERY:_.VENMO_PAYMENT_CONTEXT_STATUS_QUERY;return n.request({api:"graphQLApi",data:{query:r,variables:{id:e}}})})).then((function(e){return e.data.node}))},x.prototype._checkPaymentContextStatusAndProcessResult=function(e){var t=this;return t._checkPaymentContextStatus().then((function(n){var o=n.status;if(o!==t._venmoPaymentContextStatus)switch(t._venmoPaymentContextStatus=o,r.sendEvent(t._createPromise,"venmo.tokenize.web-login.status-change"),o){case"APPROVED":return Promise.resolve(n);case"CANCELED":return Promise.reject(new f(s.VENMO_CUSTOMER_CANCELED));case"FAILED":return Promise.reject(new f(s.VENMO_TOKENIZATION_FAILED))}return new Promise((function(n,r){return e<t._maxRetryCount?(e++,t._checkPaymentContextStatusAndProcessResult(e).then(n).catch(r)):r(new f(s.VENMO_TOKENIZATION_FAILED))}))}))},x.prototype._checkPaymentContextStatus=function(){var e=this;return e._queryPaymentContextStatus(e._venmoPaymentContextId).catch((function(e){return Promise.reject(new f({type:s.VENMO_NETWORK_ERROR.type,code:s.VENMO_NETWORK_ERROR.code,message:s.VENMO_NETWORK_ERROR.message,details:e}))})).then((function(e){return Promise.resolve(e)}))},x.prototype._pollForStatusChange=function(){var e=this;return Date.now()>e._mobilePollingContextExpiresIn?Promise.reject(new f(s.VENMO_MOBILE_POLLING_TOKENIZATION_TIMEOUT)):this._queryPaymentContextStatus(this._venmoPaymentContextId).catch((function(e){return Promise.reject(new f({type:s.VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR.type,code:s.VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR.code,message:s.VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR.message,details:{originalError:e}}))})).then((function(t){var n=t.status;if(n!==e._venmoPaymentContextStatus)switch(e._venmoPaymentContextStatus=n,r.sendEvent(e._createPromise,"venmo.tokenize.manual-return.status-change."+n.toLowerCase()),n){case"EXPIRED":case"FAILED":case"CANCELED":return Promise.reject(new f(s["VENMO_MOBILE_POLLING_TOKENIZATION_"+n]));case"APPROVED":return Promise.resolve(t)}return new Promise((function(t,n){setTimeout((function(){e._pollForStatusChange().then(t).catch(n)}),e._mobilePollingInterval)}))}))},x.prototype._tokenizeForMobileWithManualReturn=function(){var e=this;return r.sendEvent(this._createPromise,"venmo.tokenize.manual-return.start"),this._mobilePollingContextExpiresIn=Date.now()+this._mobilePollingExpiresThreshold,this._tokenizePromise=new m,this._pollForStatusChange().then((function(t){r.sendEvent(e._createPromise,"venmo.tokenize.manual-return.success"),e._tokenizePromise.resolve({paymentMethodNonce:t.paymentMethodId,username:t.userName,payerInfo:t.payerInfo,id:e._venmoPaymentContextId})})).catch((function(t){r.sendEvent(e._createPromise,"venmo.tokenize.manual-return.failure"),e._tokenizePromise.reject(t)})),this.getUrl().then((function(t){return e.appSwitch(t),e._tokenizePromise}))},x.prototype._shouldUseRedirectStrategy=function(){return!!i.isIos()&&(!0===this._mobileWebFallBack||this._useRedirectForIOS)},x.prototype._tokenizeForMobileWithHashChangeListeners=function(e){var t,n,o=this;if(this.hasTokenizationResult())return this.processHashChangeFlowResults();function i(e){var t;o.processHashChangeFlowResults(e).catch((function(e){t=e})).then((function(e){o._ignoreHistoryChanges||window.location.hash===o._previousHash||(window.location.hash=o._previousHash),o._removeVisibilityEventListener(),t?o._tokenizePromise.reject(t):o._tokenizePromise.resolve(e),delete o._tokenizePromise}))}return r.sendEvent(this._createPromise,"venmo.tokenize.mobile.start"),this._tokenizePromise=new m,this._previousHash=window.location.hash,this._onHashChangeListener=function(e){var r=e.newURL.split("#")[1];o._hasTokenizationResult(r)&&(t=!0,clearTimeout(n),i(r))},window.addEventListener("hashchange",this._onHashChangeListener,!1),this._visibilityChangeListener=function(){var r=e.processResultsDelay||a.DEFAULT_PROCESS_RESULTS_DELAY;window.document.hidden||t||(n=setTimeout(i,r))},this.getUrl().then((function(e){return o.appSwitch(e),setTimeout((function(){window.document.addEventListener(T(),o._visibilityChangeListener)}),a.DOCUMENT_VISIBILITY_CHANGE_EVENT_DELAY),o._tokenizePromise}))},x.prototype._tokenizeForDesktopQRFlow=function(){var e=this;return r.sendEvent(this._createPromise,"venmo.tokenize.desktop.start"),this._tokenizePromise=new m,this._createPromise.then((function(){return e._venmoDesktopInstance.launchDesktopFlow()})).then((function(t){e._venmoDesktopInstance.hideDesktopFlow(),r.sendEvent(e._createPromise,"venmo.tokenize.desktop.success"),e._tokenizePromise.resolve(t)})).catch((function(t){r.sendEvent(e._createPromise,"venmo.tokenize.desktop.failure"),e._venmoDesktopInstance&&e._venmoDesktopInstance.hideDesktopFlow(),t&&"CUSTOMER_CANCELED"===t.reason?e._tokenizePromise.reject(new f(s.VENMO_DESKTOP_CANCELED)):e._tokenizePromise.reject(new f({type:s.VENMO_DESKTOP_UNKNOWN_ERROR.type,code:s.VENMO_DESKTOP_UNKNOWN_ERROR.code,message:s.VENMO_DESKTOP_UNKNOWN_ERROR.message,details:{originalError:t}}))})),this._tokenizePromise},x.prototype._cancelMobilePaymentContext=function(){var e=this;return this._createPromise.then((function(t){var n;return e._venmoPaymentContextId?(n=e._shouldUseLegacyFlow?_.LEGACY_UPDATE_PAYMENT_CONTEXT_QUERY:_.UPDATE_PAYMENT_CONTEXT_QUERY,t.request({api:"graphQLApi",data:{query:n,variables:{input:{id:e._venmoPaymentContextId,status:"CANCELED"}}}})):Promise.resolve()}))},x.prototype._cancelVenmoDesktopContext=function(){var e=this;return this._createPromise.then((function(){return e._venmoDesktopInstance&&e._venmoDesktopInstance.updateVenmoDesktopPaymentContext("CANCELED"),Promise.resolve()}))},x.prototype.teardown=function(){var e=this;return this._removeVisibilityEventListener(),this._createPromise.then(function(){e._venmoDesktopInstance&&e._venmoDesktopInstance.teardown(),clearTimeout(e._refreshPaymentContextTimeout),e._cancelMobilePaymentContext(),d(this,u(x.prototype))}.bind(this))},x.prototype._removeVisibilityEventListener=function(){window.removeEventListener("hashchange",this._onHashChangeListener),window.document.removeEventListener(T(),this._visibilityChangeListener),delete this._visibilityChangeListener,delete this._onHashChangeListener},x.prototype.processHashChangeFlowResults=function(e){var t=this,n=C(e);return new Promise((function(e,o){t._shouldUseLegacyFlow?n.venmoSuccess?(r.sendEvent(t._createPromise,"venmo.appswitch.handle.success"),e(n)):n.venmoError?(r.sendEvent(t._createPromise,"venmo.appswitch.handle.error"),o(new f({type:s.VENMO_APP_FAILED.type,code:s.VENMO_APP_FAILED.code,message:s.VENMO_APP_FAILED.message,details:{originalError:{message:decodeURIComponent(n.errorMessage),code:n.errorCode}}}))):n.venmoCancel?(r.sendEvent(t._createPromise,"venmo.appswitch.handle.cancel"),o(new f(s.VENMO_APP_CANCELED))):(r.sendEvent(t._createPromise,"venmo.appswitch.cancel-or-unavailable"),o(new f(s.VENMO_CANCELED))):t._pollForStatusChange().then((function(n){return r.sendEvent(t._createPromise,"venmo.appswitch.handle.payment-context-status-query.success"),e({paymentMethodNonce:n.paymentMethodId,username:n.userName,payerInfo:n.payerInfo,id:t._venmoPaymentContextId})})).catch((function(i){i.type===s.VENMO_MOBILE_POLLING_TOKENIZATION_CANCELED.type&&o(i),r.sendEvent(t._createPromise,"venmo.process-results.payment-context-status-query-failed"),e(n)})),t._clearFragmentParameters()}))},x.prototype._clearFragmentParameters=function(){this._ignoreHistoryChanges||"function"==typeof window.history.replaceState&&window.location.hash&&history.pushState({},"",window.location.href.slice(0,window.location.href.indexOf("#")))},t.exports=p.wrapPrototype(x)},{"../lib/analytics":119,"../lib/braintree-error":124,"../lib/convert-methods-to-error":127,"../lib/in-iframe":150,"../lib/is-verified-domain":153,"../lib/methods":155,"../lib/querystring":157,"../lib/snake-case-to-camel-case":159,"./external/":213,"./external/queries":214,"./shared/browser-detection":217,"./shared/constants":218,"./shared/errors":219,"./shared/get-venmo-url":221,"./shared/supports-venmo":222,"./shared/web-login-backdrop":223,"@braintree/extended-promise":34,"@braintree/wrap-promise":43}],225:[function(e,t,n){"use strict";var r=e("../lib/braintree-error");t.exports={VISA_CHECKOUT_NOT_ENABLED:{type:r.types.MERCHANT,code:"VISA_CHECKOUT_NOT_ENABLED",message:"Visa Checkout is not enabled for this merchant."},VISA_CHECKOUT_INIT_OPTIONS_REQUIRED:{type:r.types.MERCHANT,code:"VISA_CHECKOUT_INIT_OPTIONS_REQUIRED",message:"initOptions requires an object."},VISA_CHECKOUT_PAYMENT_REQUIRED:{type:r.types.MERCHANT,code:"VISA_CHECKOUT_PAYMENT_REQUIRED",message:"tokenize requires callid, encKey, and encPaymentData."},VISA_CHECKOUT_TOKENIZATION:{type:r.types.NETWORK,code:"VISA_CHECKOUT_TOKENIZATION",message:"A network error occurred when processing the Visa Checkout payment."}}},{"../lib/braintree-error":124}],226:[function(e,t,n){"use strict";var r=e("../lib/basic-component-verification"),o=e("../lib/braintree-error"),i=e("../lib/create-deferred-client"),a=e("../lib/create-assets-url"),s=e("./visa-checkout"),l=e("../lib/analytics"),c=e("./errors"),u="3.102.0",d=e("@braintree/wrap-promise");function p(e){var t="Visa Checkout";return r.verify({name:t,client:e.client,authorization:e.authorization}).then((function(){return i.create({authorization:e.authorization,client:e.client,debug:e.debug,assetsUrl:a.create(e.authorization),name:t})})).then((function(t){return e.client=t,e.client.getConfiguration().gatewayConfiguration.visaCheckout?(l.sendEvent(e.client,"visacheckout.initialized"),new s(e)):Promise.reject(new o(c.VISA_CHECKOUT_NOT_ENABLED))}))}t.exports={create:d(p),VERSION:u}},{"../lib/analytics":119,"../lib/basic-component-verification":122,"../lib/braintree-error":124,"../lib/create-assets-url":129,"../lib/create-deferred-client":131,"./errors":225,"./visa-checkout":227,"@braintree/wrap-promise":43}],227:[function(e,t,n){"use strict";var r=e("../lib/braintree-error"),o=e("../lib/analytics"),i=e("./errors"),a=e("../lib/json-clone"),s=e("../lib/methods"),l=e("../lib/convert-methods-to-error"),c=e("@braintree/wrap-promise"),u={Visa:"VISA",MasterCard:"MASTERCARD",Discover:"DISCOVER","American Express":"AMEX"};function d(e){this._client=e.client}function p(e){return e.reduce((function(e,t){return u.hasOwnProperty(t)?e.concat(u[t]):e}),[])}d.prototype.createInitOptions=function(e){var t,n=this._client.getConfiguration().gatewayConfiguration,o=n.visaCheckout;if(!e)throw new r(i.VISA_CHECKOUT_INIT_OPTIONS_REQUIRED);return(t=a(e)).apikey=t.apikey||o.apikey,t.encryptionKey=o.encryptionKey,t.externalClientId=t.externalClientId||o.externalClientId,t.settings=t.settings||{},t.settings.dataLevel="FULL",t.settings.payment=t.settings.payment||{},t.settings.payment.cardBrands||(t.settings.payment.cardBrands=p(n.visaCheckout.supportedCardTypes)),t},d.prototype.tokenize=function(e){var t=this;return e.callid&&e.encKey&&e.encPaymentData?this._client.request({method:"post",endpoint:"payment_methods/visa_checkout_cards",data:{_meta:{source:"visa-checkout"},visaCheckoutCard:{callId:e.callid,encryptedPaymentData:e.encPaymentData,encryptedKey:e.encKey}}}).then((function(e){return o.sendEvent(t._client,"visacheckout.tokenize.succeeded"),e.visaCheckoutCards[0]})).catch((function(e){return o.sendEvent(t._client,"visacheckout.tokenize.failed"),Promise.reject(new r({type:i.VISA_CHECKOUT_TOKENIZATION.type,code:i.VISA_CHECKOUT_TOKENIZATION.code,message:i.VISA_CHECKOUT_TOKENIZATION.message,details:{originalError:e}}))})):Promise.reject(new r(i.VISA_CHECKOUT_PAYMENT_REQUIRED))},d.prototype.teardown=function(){return l(this,s(d.prototype)),Promise.resolve()},t.exports=c.wrapPrototype(d)},{"../lib/analytics":119,"../lib/braintree-error":124,"../lib/convert-methods-to-error":127,"../lib/json-clone":154,"../lib/methods":155,"./errors":225,"@braintree/wrap-promise":43}]},{},[117])(117)},84538:e=>{function t(e){var n,r,o="";if("string"==typeof e||"number"==typeof e)o+=e;else if("object"==typeof e)if(Array.isArray(e)){var i=e.length;for(n=0;n<i;n++)e[n]&&(r=t(e[n]))&&(o&&(o+=" "),o+=r)}else for(r in e)e[r]&&(o&&(o+=" "),o+=r);return o}function n(){for(var e,n,r=0,o="",i=arguments.length;r<i;r++)(e=arguments[r])&&(n=t(e))&&(o&&(o+=" "),o+=n);return o}e.exports=n,e.exports.clsx=n},81364:e=>{"use strict";e.exports=function(e){var t=[];return t.toString=function(){return this.map((function(t){var n="",r=void 0!==t[5];return t[4]&&(n+="@supports (".concat(t[4],") {")),t[2]&&(n+="@media ".concat(t[2]," {")),r&&(n+="@layer".concat(t[5].length>0?" ".concat(t[5]):""," {")),n+=e(t),r&&(n+="}"),t[2]&&(n+="}"),t[4]&&(n+="}"),n})).join("")},t.i=function(e,n,r,o,i){"string"==typeof e&&(e=[[null,e,void 0]]);var a={};if(r)for(var s=0;s<this.length;s++){var l=this[s][0];null!=l&&(a[l]=!0)}for(var c=0;c<e.length;c++){var u=[].concat(e[c]);r&&a[u[0]]||(void 0!==i&&(void 0===u[5]||(u[1]="@layer".concat(u[5].length>0?" ".concat(u[5]):""," {").concat(u[1],"}")),u[5]=i),n&&(u[2]?(u[1]="@media ".concat(u[2]," {").concat(u[1],"}"),u[2]=n):u[2]=n),o&&(u[4]?(u[1]="@supports (".concat(u[4],") {").concat(u[1],"}"),u[4]=o):u[4]="".concat(o)),t.push(u))}},t}},83615:e=>{"use strict";e.exports=function(e,t){return t||(t={}),e?(e=String(e.__esModule?e.default:e),/^['"].*['"]$/.test(e)&&(e=e.slice(1,-1)),t.hash&&(e+=t.hash),/["'() \t\n]|(%20)/.test(e)||t.needQuotes?'"'.concat(e.replace(/"/g,'\\"').replace(/\n/g,"\\n"),'"'):e):e}},15516:e=>{"use strict";e.exports=function(e){var t=e[1],n=e[3];if(!n)return t;if("function"==typeof btoa){var r=btoa(unescape(encodeURIComponent(JSON.stringify(n)))),o="sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(r),i="/*# ".concat(o," */");return[t].concat([i]).join("\n")}return[t].join("\n")}},4719:e=>{"use strict";var t=Array.isArray,n=Object.keys,r=Object.prototype.hasOwnProperty,o="undefined"!=typeof Element;function i(e,a){if(e===a)return!0;if(e&&a&&"object"==typeof e&&"object"==typeof a){var s,l,c,u=t(e),d=t(a);if(u&&d){if((l=e.length)!=a.length)return!1;for(s=l;0!=s--;)if(!i(e[s],a[s]))return!1;return!0}if(u!=d)return!1;var p=e instanceof Date,f=a instanceof Date;if(p!=f)return!1;if(p&&f)return e.getTime()==a.getTime();var h=e instanceof RegExp,m=a instanceof RegExp;if(h!=m)return!1;if(h&&m)return e.toString()==a.toString();var g=n(e);if((l=g.length)!==n(a).length)return!1;for(s=l;0!=s--;)if(!r.call(a,g[s]))return!1;if(o&&e instanceof Element&&a instanceof Element)return e===a;for(s=l;0!=s--;)if(!("_owner"===(c=g[s])&&e.$$typeof||i(e[c],a[c])))return!1;return!0}return e!=e&&a!=a}e.exports=function(e,t){try{return i(e,t)}catch(e){if(e.message&&e.message.match(/stack|recursion/i)||-2146828260===e.number)return console.warn("Warning: react-fast-compare does not handle circular references.",e.name,e.message),!1;throw e}}},1880:(e,t,n)=>{"use strict";var r=n(41178),o={childContextTypes:!0,contextType:!0,contextTypes:!0,defaultProps:!0,displayName:!0,getDefaultProps:!0,getDerivedStateFromError:!0,getDerivedStateFromProps:!0,mixins:!0,propTypes:!0,type:!0},i={name:!0,length:!0,prototype:!0,caller:!0,callee:!0,arguments:!0,arity:!0},a={$$typeof:!0,compare:!0,defaultProps:!0,displayName:!0,propTypes:!0,type:!0},s={};function l(e){return r.isMemo(e)?a:s[e.$$typeof]||o}s[r.ForwardRef]={$$typeof:!0,render:!0,defaultProps:!0,displayName:!0,propTypes:!0},s[r.Memo]=a;var c=Object.defineProperty,u=Object.getOwnPropertyNames,d=Object.getOwnPropertySymbols,p=Object.getOwnPropertyDescriptor,f=Object.getPrototypeOf,h=Object.prototype;e.exports=function e(t,n,r){if("string"!=typeof n){if(h){var o=f(n);o&&o!==h&&e(t,o,r)}var a=u(n);d&&(a=a.concat(d(n)));for(var s=l(t),m=l(n),g=0;g<a.length;++g){var v=a[g];if(!(i[v]||r&&r[v]||m&&m[v]||s&&s[v])){var y=p(n,v);try{c(t,v,y)}catch(e){}}}}return t}},32950:(e,t)=>{"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var n="function"==typeof Symbol&&Symbol.for,r=n?Symbol.for("react.element"):60103,o=n?Symbol.for("react.portal"):60106,i=n?Symbol.for("react.fragment"):60107,a=n?Symbol.for("react.strict_mode"):60108,s=n?Symbol.for("react.profiler"):60114,l=n?Symbol.for("react.provider"):60109,c=n?Symbol.for("react.context"):60110,u=n?Symbol.for("react.async_mode"):60111,d=n?Symbol.for("react.concurrent_mode"):60111,p=n?Symbol.for("react.forward_ref"):60112,f=n?Symbol.for("react.suspense"):60113,h=n?Symbol.for("react.suspense_list"):60120,m=n?Symbol.for("react.memo"):60115,g=n?Symbol.for("react.lazy"):60116,v=n?Symbol.for("react.block"):60121,y=n?Symbol.for("react.fundamental"):60117,b=n?Symbol.for("react.responder"):60118,_=n?Symbol.for("react.scope"):60119;function A(e){if("object"==typeof e&&null!==e){var t=e.$$typeof;switch(t){case r:switch(e=e.type){case u:case d:case i:case s:case a:case f:return e;default:switch(e=e&&e.$$typeof){case c:case p:case g:case m:case l:return e;default:return t}}case o:return t}}}function E(e){return A(e)===d}t.AsyncMode=u,t.ConcurrentMode=d,t.ContextConsumer=c,t.ContextProvider=l,t.Element=r,t.ForwardRef=p,t.Fragment=i,t.Lazy=g,t.Memo=m,t.Portal=o,t.Profiler=s,t.StrictMode=a,t.Suspense=f,t.isAsyncMode=function(e){return E(e)||A(e)===u},t.isConcurrentMode=E,t.isContextConsumer=function(e){return A(e)===c},t.isContextProvider=function(e){return A(e)===l},t.isElement=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===r},t.isForwardRef=function(e){return A(e)===p},t.isFragment=function(e){return A(e)===i},t.isLazy=function(e){return A(e)===g},t.isMemo=function(e){return A(e)===m},t.isPortal=function(e){return A(e)===o},t.isProfiler=function(e){return A(e)===s},t.isStrictMode=function(e){return A(e)===a},t.isSuspense=function(e){return A(e)===f},t.isValidElementType=function(e){return"string"==typeof e||"function"==typeof e||e===i||e===d||e===s||e===a||e===f||e===h||"object"==typeof e&&null!==e&&(e.$$typeof===g||e.$$typeof===m||e.$$typeof===l||e.$$typeof===c||e.$$typeof===p||e.$$typeof===y||e.$$typeof===b||e.$$typeof===_||e.$$typeof===v)},t.typeOf=A},41178:(e,t,n)=>{"use strict";e.exports=n(32950)},49739:(e,t,n)=>{e=n.nmd(e);var r="__lodash_hash_undefined__",o=9007199254740991,i="[object Arguments]",a="[object Boolean]",s="[object Date]",l="[object Function]",c="[object GeneratorFunction]",u="[object Map]",d="[object Number]",p="[object Object]",f="[object Promise]",h="[object RegExp]",m="[object Set]",g="[object String]",v="[object Symbol]",y="[object WeakMap]",b="[object ArrayBuffer]",_="[object DataView]",A="[object Float32Array]",E="[object Float64Array]",w="[object Int8Array]",x="[object Int16Array]",k="[object Int32Array]",C="[object Uint8Array]",S="[object Uint8ClampedArray]",M="[object Uint16Array]",T="[object Uint32Array]",O=/\w*$/,D=/^\[object .+?Constructor\]$/,L=/^(?:0|[1-9]\d*)$/,P={};P[i]=P["[object Array]"]=P[b]=P[_]=P[a]=P[s]=P[A]=P[E]=P[w]=P[x]=P[k]=P[u]=P[d]=P[p]=P[h]=P[m]=P[g]=P[v]=P[C]=P[S]=P[M]=P[T]=!0,P["[object Error]"]=P[l]=P[y]=!1;var I="object"==typeof n.g&&n.g&&n.g.Object===Object&&n.g,B="object"==typeof self&&self&&self.Object===Object&&self,R=I||B||Function("return this")(),N=t&&!t.nodeType&&t,F=N&&e&&!e.nodeType&&e,j=F&&F.exports===N;function Y(e,t){return e.set(t[0],t[1]),e}function $(e,t){return e.add(t),e}function H(e,t,n,r){var o=-1,i=e?e.length:0;for(r&&i&&(n=e[++o]);++o<i;)n=t(n,e[o],o,e);return n}function U(e){var t=!1;if(null!=e&&"function"!=typeof e.toString)try{t=!!(e+"")}catch(e){}return t}function z(e){var t=-1,n=Array(e.size);return e.forEach((function(e,r){n[++t]=[r,e]})),n}function W(e,t){return function(n){return e(t(n))}}function V(e){var t=-1,n=Array(e.size);return e.forEach((function(e){n[++t]=e})),n}var G,Q=Array.prototype,q=Function.prototype,K=Object.prototype,Z=R["__core-js_shared__"],J=(G=/[^.]+$/.exec(Z&&Z.keys&&Z.keys.IE_PROTO||""))?"Symbol(src)_1."+G:"",X=q.toString,ee=K.hasOwnProperty,te=K.toString,ne=RegExp("^"+X.call(ee).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),re=j?R.Buffer:void 0,oe=R.Symbol,ie=R.Uint8Array,ae=W(Object.getPrototypeOf,Object),se=Object.create,le=K.propertyIsEnumerable,ce=Q.splice,ue=Object.getOwnPropertySymbols,de=re?re.isBuffer:void 0,pe=W(Object.keys,Object),fe=Fe(R,"DataView"),he=Fe(R,"Map"),me=Fe(R,"Promise"),ge=Fe(R,"Set"),ve=Fe(R,"WeakMap"),ye=Fe(Object,"create"),be=Ue(fe),_e=Ue(he),Ae=Ue(me),Ee=Ue(ge),we=Ue(ve),xe=oe?oe.prototype:void 0,ke=xe?xe.valueOf:void 0;function Ce(e){var t=-1,n=e?e.length:0;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}function Se(e){var t=-1,n=e?e.length:0;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}function Me(e){var t=-1,n=e?e.length:0;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}function Te(e){this.__data__=new Se(e)}function Oe(e,t){var n=We(e)||function(e){return function(e){return function(e){return!!e&&"object"==typeof e}(e)&&Ve(e)}(e)&&ee.call(e,"callee")&&(!le.call(e,"callee")||te.call(e)==i)}(e)?function(e,t){for(var n=-1,r=Array(e);++n<e;)r[n]=t(n);return r}(e.length,String):[],r=n.length,o=!!r;for(var a in e)!t&&!ee.call(e,a)||o&&("length"==a||$e(a,r))||n.push(a);return n}function De(e,t,n){var r=e[t];ee.call(e,t)&&ze(r,n)&&(void 0!==n||t in e)||(e[t]=n)}function Le(e,t){for(var n=e.length;n--;)if(ze(e[n][0],t))return n;return-1}function Pe(e,t,n,r,o,f,y){var D;if(r&&(D=f?r(e,o,f,y):r(e)),void 0!==D)return D;if(!qe(e))return e;var L=We(e);if(L){if(D=function(e){var t=e.length,n=e.constructor(t);t&&"string"==typeof e[0]&&ee.call(e,"index")&&(n.index=e.index,n.input=e.input);return n}(e),!t)return function(e,t){var n=-1,r=e.length;t||(t=Array(r));for(;++n<r;)t[n]=e[n];return t}(e,D)}else{var I=Ye(e),B=I==l||I==c;if(Ge(e))return function(e,t){if(t)return e.slice();var n=new e.constructor(e.length);return e.copy(n),n}(e,t);if(I==p||I==i||B&&!f){if(U(e))return f?e:{};if(D=function(e){return"function"!=typeof e.constructor||He(e)?{}:(t=ae(e),qe(t)?se(t):{});var t}(B?{}:e),!t)return function(e,t){return Re(e,je(e),t)}(e,function(e,t){return e&&Re(t,Ke(t),e)}(D,e))}else{if(!P[I])return f?e:{};D=function(e,t,n,r){var o=e.constructor;switch(t){case b:return Be(e);case a:case s:return new o(+e);case _:return function(e,t){var n=t?Be(e.buffer):e.buffer;return new e.constructor(n,e.byteOffset,e.byteLength)}(e,r);case A:case E:case w:case x:case k:case C:case S:case M:case T:return function(e,t){var n=t?Be(e.buffer):e.buffer;return new e.constructor(n,e.byteOffset,e.length)}(e,r);case u:return function(e,t,n){var r=t?n(z(e),!0):z(e);return H(r,Y,new e.constructor)}(e,r,n);case d:case g:return new o(e);case h:return function(e){var t=new e.constructor(e.source,O.exec(e));return t.lastIndex=e.lastIndex,t}(e);case m:return function(e,t,n){var r=t?n(V(e),!0):V(e);return H(r,$,new e.constructor)}(e,r,n);case v:return i=e,ke?Object(ke.call(i)):{}}var i}(e,I,Pe,t)}}y||(y=new Te);var R=y.get(e);if(R)return R;if(y.set(e,D),!L)var N=n?function(e){return function(e,t,n){var r=t(e);return We(e)?r:function(e,t){for(var n=-1,r=t.length,o=e.length;++n<r;)e[o+n]=t[n];return e}(r,n(e))}(e,Ke,je)}(e):Ke(e);return function(e,t){for(var n=-1,r=e?e.length:0;++n<r&&!1!==t(e[n],n,e););}(N||e,(function(o,i){N&&(o=e[i=o]),De(D,i,Pe(o,t,n,r,i,e,y))})),D}function Ie(e){return!(!qe(e)||(t=e,J&&J in t))&&(Qe(e)||U(e)?ne:D).test(Ue(e));var t}function Be(e){var t=new e.constructor(e.byteLength);return new ie(t).set(new ie(e)),t}function Re(e,t,n,r){n||(n={});for(var o=-1,i=t.length;++o<i;){var a=t[o],s=r?r(n[a],e[a],a,n,e):void 0;De(n,a,void 0===s?e[a]:s)}return n}function Ne(e,t){var n,r,o=e.__data__;return("string"==(r=typeof(n=t))||"number"==r||"symbol"==r||"boolean"==r?"__proto__"!==n:null===n)?o["string"==typeof t?"string":"hash"]:o.map}function Fe(e,t){var n=function(e,t){return null==e?void 0:e[t]}(e,t);return Ie(n)?n:void 0}Ce.prototype.clear=function(){this.__data__=ye?ye(null):{}},Ce.prototype.delete=function(e){return this.has(e)&&delete this.__data__[e]},Ce.prototype.get=function(e){var t=this.__data__;if(ye){var n=t[e];return n===r?void 0:n}return ee.call(t,e)?t[e]:void 0},Ce.prototype.has=function(e){var t=this.__data__;return ye?void 0!==t[e]:ee.call(t,e)},Ce.prototype.set=function(e,t){return this.__data__[e]=ye&&void 0===t?r:t,this},Se.prototype.clear=function(){this.__data__=[]},Se.prototype.delete=function(e){var t=this.__data__,n=Le(t,e);return!(n<0)&&(n==t.length-1?t.pop():ce.call(t,n,1),!0)},Se.prototype.get=function(e){var t=this.__data__,n=Le(t,e);return n<0?void 0:t[n][1]},Se.prototype.has=function(e){return Le(this.__data__,e)>-1},Se.prototype.set=function(e,t){var n=this.__data__,r=Le(n,e);return r<0?n.push([e,t]):n[r][1]=t,this},Me.prototype.clear=function(){this.__data__={hash:new Ce,map:new(he||Se),string:new Ce}},Me.prototype.delete=function(e){return Ne(this,e).delete(e)},Me.prototype.get=function(e){return Ne(this,e).get(e)},Me.prototype.has=function(e){return Ne(this,e).has(e)},Me.prototype.set=function(e,t){return Ne(this,e).set(e,t),this},Te.prototype.clear=function(){this.__data__=new Se},Te.prototype.delete=function(e){return this.__data__.delete(e)},Te.prototype.get=function(e){return this.__data__.get(e)},Te.prototype.has=function(e){return this.__data__.has(e)},Te.prototype.set=function(e,t){var n=this.__data__;if(n instanceof Se){var r=n.__data__;if(!he||r.length<199)return r.push([e,t]),this;n=this.__data__=new Me(r)}return n.set(e,t),this};var je=ue?W(ue,Object):function(){return[]},Ye=function(e){return te.call(e)};function $e(e,t){return!!(t=null==t?o:t)&&("number"==typeof e||L.test(e))&&e>-1&&e%1==0&&e<t}function He(e){var t=e&&e.constructor;return e===("function"==typeof t&&t.prototype||K)}function Ue(e){if(null!=e){try{return X.call(e)}catch(e){}try{return e+""}catch(e){}}return""}function ze(e,t){return e===t||e!=e&&t!=t}(fe&&Ye(new fe(new ArrayBuffer(1)))!=_||he&&Ye(new he)!=u||me&&Ye(me.resolve())!=f||ge&&Ye(new ge)!=m||ve&&Ye(new ve)!=y)&&(Ye=function(e){var t=te.call(e),n=t==p?e.constructor:void 0,r=n?Ue(n):void 0;if(r)switch(r){case be:return _;case _e:return u;case Ae:return f;case Ee:return m;case we:return y}return t});var We=Array.isArray;function Ve(e){return null!=e&&function(e){return"number"==typeof e&&e>-1&&e%1==0&&e<=o}(e.length)&&!Qe(e)}var Ge=de||function(){return!1};function Qe(e){var t=qe(e)?te.call(e):"";return t==l||t==c}function qe(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function Ke(e){return Ve(e)?Oe(e):function(e){if(!He(e))return pe(e);var t=[];for(var n in Object(e))ee.call(e,n)&&"constructor"!=n&&t.push(n);return t}(e)}e.exports=function(e){return Pe(e,!0,!0)}},71124:(e,t,n)=>{e=n.nmd(e);var r="__lodash_hash_undefined__",o=9007199254740991,i="[object Arguments]",a="[object AsyncFunction]",s="[object Function]",l="[object GeneratorFunction]",c="[object Null]",u="[object Object]",d="[object Proxy]",p="[object Undefined]",f=/^\[object .+?Constructor\]$/,h=/^(?:0|[1-9]\d*)$/,m={};m["[object Float32Array]"]=m["[object Float64Array]"]=m["[object Int8Array]"]=m["[object Int16Array]"]=m["[object Int32Array]"]=m["[object Uint8Array]"]=m["[object Uint8ClampedArray]"]=m["[object Uint16Array]"]=m["[object Uint32Array]"]=!0,m[i]=m["[object Array]"]=m["[object ArrayBuffer]"]=m["[object Boolean]"]=m["[object DataView]"]=m["[object Date]"]=m["[object Error]"]=m[s]=m["[object Map]"]=m["[object Number]"]=m[u]=m["[object RegExp]"]=m["[object Set]"]=m["[object String]"]=m["[object WeakMap]"]=!1;var g="object"==typeof n.g&&n.g&&n.g.Object===Object&&n.g,v="object"==typeof self&&self&&self.Object===Object&&self,y=g||v||Function("return this")(),b=t&&!t.nodeType&&t,_=b&&e&&!e.nodeType&&e,A=_&&_.exports===b,E=A&&g.process,w=function(){try{var e=_&&_.require&&_.require("util").types;return e||E&&E.binding&&E.binding("util")}catch(e){}}(),x=w&&w.isTypedArray;var k,C,S,M=Array.prototype,T=Function.prototype,O=Object.prototype,D=y["__core-js_shared__"],L=T.toString,P=O.hasOwnProperty,I=(k=/[^.]+$/.exec(D&&D.keys&&D.keys.IE_PROTO||""))?"Symbol(src)_1."+k:"",B=O.toString,R=L.call(Object),N=RegExp("^"+L.call(P).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),F=A?y.Buffer:void 0,j=y.Symbol,Y=y.Uint8Array,$=F?F.allocUnsafe:void 0,H=(C=Object.getPrototypeOf,S=Object,function(e){return C(S(e))}),U=Object.create,z=O.propertyIsEnumerable,W=M.splice,V=j?j.toStringTag:void 0,G=function(){try{var e=be(Object,"defineProperty");return e({},"",{}),e}catch(e){}}(),Q=F?F.isBuffer:void 0,q=Math.max,K=Date.now,Z=be(y,"Map"),J=be(Object,"create"),X=function(){function e(){}return function(t){if(!De(t))return{};if(U)return U(t);e.prototype=t;var n=new e;return e.prototype=void 0,n}}();function ee(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}function te(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}function ne(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}function re(e){var t=this.__data__=new te(e);this.size=t.size}function oe(e,t){var n=Ce(e),r=!n&&ke(e),o=!n&&!r&&Me(e),i=!n&&!r&&!o&&Pe(e),a=n||r||o||i,s=a?function(e,t){for(var n=-1,r=Array(e);++n<e;)r[n]=t(n);return r}(e.length,String):[],l=s.length;for(var c in e)!t&&!P.call(e,c)||a&&("length"==c||o&&("offset"==c||"parent"==c)||i&&("buffer"==c||"byteLength"==c||"byteOffset"==c)||_e(c,l))||s.push(c);return s}function ie(e,t,n){(void 0!==n&&!xe(e[t],n)||void 0===n&&!(t in e))&&le(e,t,n)}function ae(e,t,n){var r=e[t];P.call(e,t)&&xe(r,n)&&(void 0!==n||t in e)||le(e,t,n)}function se(e,t){for(var n=e.length;n--;)if(xe(e[n][0],t))return n;return-1}function le(e,t,n){"__proto__"==t&&G?G(e,t,{configurable:!0,enumerable:!0,value:n,writable:!0}):e[t]=n}ee.prototype.clear=function(){this.__data__=J?J(null):{},this.size=0},ee.prototype.delete=function(e){var t=this.has(e)&&delete this.__data__[e];return this.size-=t?1:0,t},ee.prototype.get=function(e){var t=this.__data__;if(J){var n=t[e];return n===r?void 0:n}return P.call(t,e)?t[e]:void 0},ee.prototype.has=function(e){var t=this.__data__;return J?void 0!==t[e]:P.call(t,e)},ee.prototype.set=function(e,t){var n=this.__data__;return this.size+=this.has(e)?0:1,n[e]=J&&void 0===t?r:t,this},te.prototype.clear=function(){this.__data__=[],this.size=0},te.prototype.delete=function(e){var t=this.__data__,n=se(t,e);return!(n<0)&&(n==t.length-1?t.pop():W.call(t,n,1),--this.size,!0)},te.prototype.get=function(e){var t=this.__data__,n=se(t,e);return n<0?void 0:t[n][1]},te.prototype.has=function(e){return se(this.__data__,e)>-1},te.prototype.set=function(e,t){var n=this.__data__,r=se(n,e);return r<0?(++this.size,n.push([e,t])):n[r][1]=t,this},ne.prototype.clear=function(){this.size=0,this.__data__={hash:new ee,map:new(Z||te),string:new ee}},ne.prototype.delete=function(e){var t=ye(this,e).delete(e);return this.size-=t?1:0,t},ne.prototype.get=function(e){return ye(this,e).get(e)},ne.prototype.has=function(e){return ye(this,e).has(e)},ne.prototype.set=function(e,t){var n=ye(this,e),r=n.size;return n.set(e,t),this.size+=n.size==r?0:1,this},re.prototype.clear=function(){this.__data__=new te,this.size=0},re.prototype.delete=function(e){var t=this.__data__,n=t.delete(e);return this.size=t.size,n},re.prototype.get=function(e){return this.__data__.get(e)},re.prototype.has=function(e){return this.__data__.has(e)},re.prototype.set=function(e,t){var n=this.__data__;if(n instanceof te){var r=n.__data__;if(!Z||r.length<199)return r.push([e,t]),this.size=++n.size,this;n=this.__data__=new ne(r)}return n.set(e,t),this.size=n.size,this};var ce,ue=function(e,t,n){for(var r=-1,o=Object(e),i=n(e),a=i.length;a--;){var s=i[ce?a:++r];if(!1===t(o[s],s,o))break}return e};function de(e){return null==e?void 0===e?p:c:V&&V in Object(e)?function(e){var t=P.call(e,V),n=e[V];try{e[V]=void 0;var r=!0}catch(e){}var o=B.call(e);r&&(t?e[V]=n:delete e[V]);return o}(e):function(e){return B.call(e)}(e)}function pe(e){return Le(e)&&de(e)==i}function fe(e){return!(!De(e)||function(e){return!!I&&I in e}(e))&&(Te(e)?N:f).test(function(e){if(null!=e){try{return L.call(e)}catch(e){}try{return e+""}catch(e){}}return""}(e))}function he(e){if(!De(e))return function(e){var t=[];if(null!=e)for(var n in Object(e))t.push(n);return t}(e);var t=Ae(e),n=[];for(var r in e)("constructor"!=r||!t&&P.call(e,r))&&n.push(r);return n}function me(e,t,n,r,o){e!==t&&ue(t,(function(i,a){if(o||(o=new re),De(i))!function(e,t,n,r,o,i,a){var s=Ee(e,n),l=Ee(t,n),c=a.get(l);if(c)return void ie(e,n,c);var d=i?i(s,l,n+"",e,t,a):void 0,p=void 0===d;if(p){var f=Ce(l),h=!f&&Me(l),m=!f&&!h&&Pe(l);d=l,f||h||m?Ce(s)?d=s:Le(_=s)&&Se(_)?d=function(e,t){var n=-1,r=e.length;t||(t=Array(r));for(;++n<r;)t[n]=e[n];return t}(s):h?(p=!1,d=function(e,t){if(t)return e.slice();var n=e.length,r=$?$(n):new e.constructor(n);return e.copy(r),r}(l,!0)):m?(p=!1,g=l,v=!0?(y=g.buffer,b=new y.constructor(y.byteLength),new Y(b).set(new Y(y)),b):g.buffer,d=new g.constructor(v,g.byteOffset,g.length)):d=[]:function(e){if(!Le(e)||de(e)!=u)return!1;var t=H(e);if(null===t)return!0;var n=P.call(t,"constructor")&&t.constructor;return"function"==typeof n&&n instanceof n&&L.call(n)==R}(l)||ke(l)?(d=s,ke(s)?d=function(e){return function(e,t,n,r){var o=!n;n||(n={});var i=-1,a=t.length;for(;++i<a;){var s=t[i],l=r?r(n[s],e[s],s,n,e):void 0;void 0===l&&(l=e[s]),o?le(n,s,l):ae(n,s,l)}return n}(e,Ie(e))}(s):De(s)&&!Te(s)||(d=function(e){return"function"!=typeof e.constructor||Ae(e)?{}:X(H(e))}(l))):p=!1}var g,v,y,b;var _;p&&(a.set(l,d),o(d,l,r,i,a),a.delete(l));ie(e,n,d)}(e,t,a,n,me,r,o);else{var s=r?r(Ee(e,a),i,a+"",e,t,o):void 0;void 0===s&&(s=i),ie(e,a,s)}}),Ie)}function ge(e,t){return we(function(e,t,n){return t=q(void 0===t?e.length-1:t,0),function(){for(var r=arguments,o=-1,i=q(r.length-t,0),a=Array(i);++o<i;)a[o]=r[t+o];o=-1;for(var s=Array(t+1);++o<t;)s[o]=r[o];return s[t]=n(a),function(e,t,n){switch(n.length){case 0:return e.call(t);case 1:return e.call(t,n[0]);case 2:return e.call(t,n[0],n[1]);case 3:return e.call(t,n[0],n[1],n[2])}return e.apply(t,n)}(e,this,s)}}(e,t,Ne),e+"")}var ve=G?function(e,t){return G(e,"toString",{configurable:!0,enumerable:!1,value:(n=t,function(){return n}),writable:!0});var n}:Ne;function ye(e,t){var n,r,o=e.__data__;return("string"==(r=typeof(n=t))||"number"==r||"symbol"==r||"boolean"==r?"__proto__"!==n:null===n)?o["string"==typeof t?"string":"hash"]:o.map}function be(e,t){var n=function(e,t){return null==e?void 0:e[t]}(e,t);return fe(n)?n:void 0}function _e(e,t){var n=typeof e;return!!(t=null==t?o:t)&&("number"==n||"symbol"!=n&&h.test(e))&&e>-1&&e%1==0&&e<t}function Ae(e){var t=e&&e.constructor;return e===("function"==typeof t&&t.prototype||O)}function Ee(e,t){if(("constructor"!==t||"function"!=typeof e[t])&&"__proto__"!=t)return e[t]}var we=function(e){var t=0,n=0;return function(){var r=K(),o=16-(r-n);if(n=r,o>0){if(++t>=800)return arguments[0]}else t=0;return e.apply(void 0,arguments)}}(ve);function xe(e,t){return e===t||e!=e&&t!=t}var ke=pe(function(){return arguments}())?pe:function(e){return Le(e)&&P.call(e,"callee")&&!z.call(e,"callee")},Ce=Array.isArray;function Se(e){return null!=e&&Oe(e.length)&&!Te(e)}var Me=Q||function(){return!1};function Te(e){if(!De(e))return!1;var t=de(e);return t==s||t==l||t==a||t==d}function Oe(e){return"number"==typeof e&&e>-1&&e%1==0&&e<=o}function De(e){var t=typeof e;return null!=e&&("object"==t||"function"==t)}function Le(e){return null!=e&&"object"==typeof e}var Pe=x?function(e){return function(t){return e(t)}}(x):function(e){return Le(e)&&Oe(e.length)&&!!m[de(e)]};function Ie(e){return Se(e)?oe(e,!0):he(e)}var Be,Re=(Be=function(e,t,n){me(e,t,n)},ge((function(e,t){var n=-1,r=t.length,o=r>1?t[r-1]:void 0,i=r>2?t[2]:void 0;for(o=Be.length>3&&"function"==typeof o?(r--,o):void 0,i&&function(e,t,n){if(!De(n))return!1;var r=typeof t;return!!("number"==r?Se(n)&&_e(t,n.length):"string"==r&&t in n)&&xe(n[t],e)}(t[0],t[1],i)&&(o=r<3?void 0:o,r=1),e=Object(e);++n<r;){var a=t[n];a&&Be(e,a,n,o)}return e})));function Ne(e){return e}e.exports=Re},19692:(e,t,n)=>{e=n.nmd(e);var r="__lodash_hash_undefined__",o=9007199254740991,i="[object Arguments]",a="[object AsyncFunction]",s="[object Function]",l="[object GeneratorFunction]",c="[object Null]",u="[object Object]",d="[object Proxy]",p="[object Undefined]",f=/^\[object .+?Constructor\]$/,h=/^(?:0|[1-9]\d*)$/,m={};m["[object Float32Array]"]=m["[object Float64Array]"]=m["[object Int8Array]"]=m["[object Int16Array]"]=m["[object Int32Array]"]=m["[object Uint8Array]"]=m["[object Uint8ClampedArray]"]=m["[object Uint16Array]"]=m["[object Uint32Array]"]=!0,m[i]=m["[object Array]"]=m["[object ArrayBuffer]"]=m["[object Boolean]"]=m["[object DataView]"]=m["[object Date]"]=m["[object Error]"]=m[s]=m["[object Map]"]=m["[object Number]"]=m[u]=m["[object RegExp]"]=m["[object Set]"]=m["[object String]"]=m["[object WeakMap]"]=!1;var g="object"==typeof n.g&&n.g&&n.g.Object===Object&&n.g,v="object"==typeof self&&self&&self.Object===Object&&self,y=g||v||Function("return this")(),b=t&&!t.nodeType&&t,_=b&&e&&!e.nodeType&&e,A=_&&_.exports===b,E=A&&g.process,w=function(){try{var e=_&&_.require&&_.require("util").types;return e||E&&E.binding&&E.binding("util")}catch(e){}}(),x=w&&w.isTypedArray;var k,C,S,M=Array.prototype,T=Function.prototype,O=Object.prototype,D=y["__core-js_shared__"],L=T.toString,P=O.hasOwnProperty,I=(k=/[^.]+$/.exec(D&&D.keys&&D.keys.IE_PROTO||""))?"Symbol(src)_1."+k:"",B=O.toString,R=L.call(Object),N=RegExp("^"+L.call(P).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),F=A?y.Buffer:void 0,j=y.Symbol,Y=y.Uint8Array,$=F?F.allocUnsafe:void 0,H=(C=Object.getPrototypeOf,S=Object,function(e){return C(S(e))}),U=Object.create,z=O.propertyIsEnumerable,W=M.splice,V=j?j.toStringTag:void 0,G=function(){try{var e=be(Object,"defineProperty");return e({},"",{}),e}catch(e){}}(),Q=F?F.isBuffer:void 0,q=Math.max,K=Date.now,Z=be(y,"Map"),J=be(Object,"create"),X=function(){function e(){}return function(t){if(!De(t))return{};if(U)return U(t);e.prototype=t;var n=new e;return e.prototype=void 0,n}}();function ee(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}function te(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}function ne(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}function re(e){var t=this.__data__=new te(e);this.size=t.size}function oe(e,t){var n=Ce(e),r=!n&&ke(e),o=!n&&!r&&Me(e),i=!n&&!r&&!o&&Pe(e),a=n||r||o||i,s=a?function(e,t){for(var n=-1,r=Array(e);++n<e;)r[n]=t(n);return r}(e.length,String):[],l=s.length;for(var c in e)!t&&!P.call(e,c)||a&&("length"==c||o&&("offset"==c||"parent"==c)||i&&("buffer"==c||"byteLength"==c||"byteOffset"==c)||_e(c,l))||s.push(c);return s}function ie(e,t,n){(void 0!==n&&!xe(e[t],n)||void 0===n&&!(t in e))&&le(e,t,n)}function ae(e,t,n){var r=e[t];P.call(e,t)&&xe(r,n)&&(void 0!==n||t in e)||le(e,t,n)}function se(e,t){for(var n=e.length;n--;)if(xe(e[n][0],t))return n;return-1}function le(e,t,n){"__proto__"==t&&G?G(e,t,{configurable:!0,enumerable:!0,value:n,writable:!0}):e[t]=n}ee.prototype.clear=function(){this.__data__=J?J(null):{},this.size=0},ee.prototype.delete=function(e){var t=this.has(e)&&delete this.__data__[e];return this.size-=t?1:0,t},ee.prototype.get=function(e){var t=this.__data__;if(J){var n=t[e];return n===r?void 0:n}return P.call(t,e)?t[e]:void 0},ee.prototype.has=function(e){var t=this.__data__;return J?void 0!==t[e]:P.call(t,e)},ee.prototype.set=function(e,t){var n=this.__data__;return this.size+=this.has(e)?0:1,n[e]=J&&void 0===t?r:t,this},te.prototype.clear=function(){this.__data__=[],this.size=0},te.prototype.delete=function(e){var t=this.__data__,n=se(t,e);return!(n<0)&&(n==t.length-1?t.pop():W.call(t,n,1),--this.size,!0)},te.prototype.get=function(e){var t=this.__data__,n=se(t,e);return n<0?void 0:t[n][1]},te.prototype.has=function(e){return se(this.__data__,e)>-1},te.prototype.set=function(e,t){var n=this.__data__,r=se(n,e);return r<0?(++this.size,n.push([e,t])):n[r][1]=t,this},ne.prototype.clear=function(){this.size=0,this.__data__={hash:new ee,map:new(Z||te),string:new ee}},ne.prototype.delete=function(e){var t=ye(this,e).delete(e);return this.size-=t?1:0,t},ne.prototype.get=function(e){return ye(this,e).get(e)},ne.prototype.has=function(e){return ye(this,e).has(e)},ne.prototype.set=function(e,t){var n=ye(this,e),r=n.size;return n.set(e,t),this.size+=n.size==r?0:1,this},re.prototype.clear=function(){this.__data__=new te,this.size=0},re.prototype.delete=function(e){var t=this.__data__,n=t.delete(e);return this.size=t.size,n},re.prototype.get=function(e){return this.__data__.get(e)},re.prototype.has=function(e){return this.__data__.has(e)},re.prototype.set=function(e,t){var n=this.__data__;if(n instanceof te){var r=n.__data__;if(!Z||r.length<199)return r.push([e,t]),this.size=++n.size,this;n=this.__data__=new ne(r)}return n.set(e,t),this.size=n.size,this};var ce,ue=function(e,t,n){for(var r=-1,o=Object(e),i=n(e),a=i.length;a--;){var s=i[ce?a:++r];if(!1===t(o[s],s,o))break}return e};function de(e){return null==e?void 0===e?p:c:V&&V in Object(e)?function(e){var t=P.call(e,V),n=e[V];try{e[V]=void 0;var r=!0}catch(e){}var o=B.call(e);r&&(t?e[V]=n:delete e[V]);return o}(e):function(e){return B.call(e)}(e)}function pe(e){return Le(e)&&de(e)==i}function fe(e){return!(!De(e)||function(e){return!!I&&I in e}(e))&&(Te(e)?N:f).test(function(e){if(null!=e){try{return L.call(e)}catch(e){}try{return e+""}catch(e){}}return""}(e))}function he(e){if(!De(e))return function(e){var t=[];if(null!=e)for(var n in Object(e))t.push(n);return t}(e);var t=Ae(e),n=[];for(var r in e)("constructor"!=r||!t&&P.call(e,r))&&n.push(r);return n}function me(e,t,n,r,o){e!==t&&ue(t,(function(i,a){if(o||(o=new re),De(i))!function(e,t,n,r,o,i,a){var s=Ee(e,n),l=Ee(t,n),c=a.get(l);if(c)return void ie(e,n,c);var d=i?i(s,l,n+"",e,t,a):void 0,p=void 0===d;if(p){var f=Ce(l),h=!f&&Me(l),m=!f&&!h&&Pe(l);d=l,f||h||m?Ce(s)?d=s:Le(_=s)&&Se(_)?d=function(e,t){var n=-1,r=e.length;t||(t=Array(r));for(;++n<r;)t[n]=e[n];return t}(s):h?(p=!1,d=function(e,t){if(t)return e.slice();var n=e.length,r=$?$(n):new e.constructor(n);return e.copy(r),r}(l,!0)):m?(p=!1,g=l,v=!0?(y=g.buffer,b=new y.constructor(y.byteLength),new Y(b).set(new Y(y)),b):g.buffer,d=new g.constructor(v,g.byteOffset,g.length)):d=[]:function(e){if(!Le(e)||de(e)!=u)return!1;var t=H(e);if(null===t)return!0;var n=P.call(t,"constructor")&&t.constructor;return"function"==typeof n&&n instanceof n&&L.call(n)==R}(l)||ke(l)?(d=s,ke(s)?d=function(e){return function(e,t,n,r){var o=!n;n||(n={});var i=-1,a=t.length;for(;++i<a;){var s=t[i],l=r?r(n[s],e[s],s,n,e):void 0;void 0===l&&(l=e[s]),o?le(n,s,l):ae(n,s,l)}return n}(e,Ie(e))}(s):De(s)&&!Te(s)||(d=function(e){return"function"!=typeof e.constructor||Ae(e)?{}:X(H(e))}(l))):p=!1}var g,v,y,b;var _;p&&(a.set(l,d),o(d,l,r,i,a),a.delete(l));ie(e,n,d)}(e,t,a,n,me,r,o);else{var s=r?r(Ee(e,a),i,a+"",e,t,o):void 0;void 0===s&&(s=i),ie(e,a,s)}}),Ie)}function ge(e,t){return we(function(e,t,n){return t=q(void 0===t?e.length-1:t,0),function(){for(var r=arguments,o=-1,i=q(r.length-t,0),a=Array(i);++o<i;)a[o]=r[t+o];o=-1;for(var s=Array(t+1);++o<t;)s[o]=r[o];return s[t]=n(a),function(e,t,n){switch(n.length){case 0:return e.call(t);case 1:return e.call(t,n[0]);case 2:return e.call(t,n[0],n[1]);case 3:return e.call(t,n[0],n[1],n[2])}return e.apply(t,n)}(e,this,s)}}(e,t,Ne),e+"")}var ve=G?function(e,t){return G(e,"toString",{configurable:!0,enumerable:!1,value:(n=t,function(){return n}),writable:!0});var n}:Ne;function ye(e,t){var n,r,o=e.__data__;return("string"==(r=typeof(n=t))||"number"==r||"symbol"==r||"boolean"==r?"__proto__"!==n:null===n)?o["string"==typeof t?"string":"hash"]:o.map}function be(e,t){var n=function(e,t){return null==e?void 0:e[t]}(e,t);return fe(n)?n:void 0}function _e(e,t){var n=typeof e;return!!(t=null==t?o:t)&&("number"==n||"symbol"!=n&&h.test(e))&&e>-1&&e%1==0&&e<t}function Ae(e){var t=e&&e.constructor;return e===("function"==typeof t&&t.prototype||O)}function Ee(e,t){if(("constructor"!==t||"function"!=typeof e[t])&&"__proto__"!=t)return e[t]}var we=function(e){var t=0,n=0;return function(){var r=K(),o=16-(r-n);if(n=r,o>0){if(++t>=800)return arguments[0]}else t=0;return e.apply(void 0,arguments)}}(ve);function xe(e,t){return e===t||e!=e&&t!=t}var ke=pe(function(){return arguments}())?pe:function(e){return Le(e)&&P.call(e,"callee")&&!z.call(e,"callee")},Ce=Array.isArray;function Se(e){return null!=e&&Oe(e.length)&&!Te(e)}var Me=Q||function(){return!1};function Te(e){if(!De(e))return!1;var t=de(e);return t==s||t==l||t==a||t==d}function Oe(e){return"number"==typeof e&&e>-1&&e%1==0&&e<=o}function De(e){var t=typeof e;return null!=e&&("object"==t||"function"==t)}function Le(e){return null!=e&&"object"==typeof e}var Pe=x?function(e){return function(t){return e(t)}}(x):function(e){return Le(e)&&Oe(e.length)&&!!m[de(e)]};function Ie(e){return Se(e)?oe(e,!0):he(e)}var Be,Re=(Be=function(e,t,n,r){me(e,t,n,r)},ge((function(e,t){var n=-1,r=t.length,o=r>1?t[r-1]:void 0,i=r>2?t[2]:void 0;for(o=Be.length>3&&"function"==typeof o?(r--,o):void 0,i&&function(e,t,n){if(!De(n))return!1;var r=typeof t;return!!("number"==r?Se(n)&&_e(t,n.length):"string"==r&&t in n)&&xe(n[t],e)}(t[0],t[1],i)&&(o=r<3?void 0:o,r=1),e=Object(e);++n<r;){var a=t[n];a&&Be(e,a,n,o)}return e})));function Ne(e){return e}e.exports=Re},37230:(e,t,n)=>{var r=n(33984)(n(29107),"DataView");e.exports=r},83435:(e,t,n)=>{var r=n(26890),o=n(49484),i=n(37215),a=n(87811),s=n(90747);function l(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}l.prototype.clear=r,l.prototype.delete=o,l.prototype.get=i,l.prototype.has=a,l.prototype.set=s,e.exports=l},95217:(e,t,n)=>{var r=n(74412),o=n(28522),i=n(50469),a=n(61161),s=n(81441);function l(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}l.prototype.clear=r,l.prototype.delete=o,l.prototype.get=i,l.prototype.has=a,l.prototype.set=s,e.exports=l},75661:(e,t,n)=>{var r=n(33984)(n(29107),"Map");e.exports=r},53287:(e,t,n)=>{var r=n(28206),o=n(89768),i=n(26827),a=n(70663),s=n(25135);function l(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}l.prototype.clear=r,l.prototype.delete=o,l.prototype.get=i,l.prototype.has=a,l.prototype.set=s,e.exports=l},29102:(e,t,n)=>{var r=n(33984)(n(29107),"Promise");e.exports=r},5963:(e,t,n)=>{var r=n(33984)(n(29107),"Set");e.exports=r},71641:(e,t,n)=>{var r=n(53287),o=n(62486),i=n(9361);function a(e){var t=-1,n=null==e?0:e.length;for(this.__data__=new r;++t<n;)this.add(e[t])}a.prototype.add=a.prototype.push=o,a.prototype.has=i,e.exports=a},16435:(e,t,n)=>{var r=n(95217),o=n(28658),i=n(63844),a=n(56503),s=n(31563),l=n(10259);function c(e){var t=this.__data__=new r(e);this.size=t.size}c.prototype.clear=o,c.prototype.delete=i,c.prototype.get=a,c.prototype.has=s,c.prototype.set=l,e.exports=c},96711:(e,t,n)=>{var r=n(29107).Symbol;e.exports=r},59282:(e,t,n)=>{var r=n(29107).Uint8Array;e.exports=r},70469:(e,t,n)=>{var r=n(33984)(n(29107),"WeakMap");e.exports=r},43928:e=>{e.exports=function(e,t){for(var n=-1,r=null==e?0:e.length,o=0,i=[];++n<r;){var a=e[n];t(a,n,e)&&(i[o++]=a)}return i}},97137:(e,t,n)=>{var r=n(85410),o=n(2382),i=n(62003),a=n(31262),s=n(62615),l=n(89221),c=Object.prototype.hasOwnProperty;e.exports=function(e,t){var n=i(e),u=!n&&o(e),d=!n&&!u&&a(e),p=!n&&!u&&!d&&l(e),f=n||u||d||p,h=f?r(e.length,String):[],m=h.length;for(var g in e)!t&&!c.call(e,g)||f&&("length"==g||d&&("offset"==g||"parent"==g)||p&&("buffer"==g||"byteLength"==g||"byteOffset"==g)||s(g,m))||h.push(g);return h}},14:e=>{e.exports=function(e,t){for(var n=-1,r=null==e?0:e.length,o=Array(r);++n<r;)o[n]=t(e[n],n,e);return o}},60562:e=>{e.exports=function(e,t){for(var n=-1,r=t.length,o=e.length;++n<r;)e[o+n]=t[n];return e}},35528:e=>{e.exports=function(e,t,n,r){var o=-1,i=null==e?0:e.length;for(r&&i&&(n=e[++o]);++o<i;)n=t(n,e[o],o,e);return n}},19854:e=>{e.exports=function(e,t){for(var n=-1,r=null==e?0:e.length;++n<r;)if(t(e[n],n,e))return!0;return!1}},13627:e=>{e.exports=function(e){return e.split("")}},46479:e=>{var t=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;e.exports=function(e){return e.match(t)||[]}},24767:(e,t,n)=>{var r=n(98330);e.exports=function(e,t){for(var n=e.length;n--;)if(r(e[n][0],t))return n;return-1}},69330:(e,t,n)=>{var r=n(73009);e.exports=function(e,t,n){"__proto__"==t&&r?r(e,t,{configurable:!0,enumerable:!0,value:n,writable:!0}):e[t]=n}},91595:(e,t,n)=>{var r=n(50951)();e.exports=r},10427:(e,t,n)=>{var r=n(91595),o=n(65304);e.exports=function(e,t){return e&&r(e,t,o)}},384:(e,t,n)=>{var r=n(34275),o=n(48059);e.exports=function(e,t){for(var n=0,i=(t=r(t,e)).length;null!=e&&n<i;)e=e[o(t[n++])];return n&&n==i?e:void 0}},68821:(e,t,n)=>{var r=n(60562),o=n(62003);e.exports=function(e,t,n){var i=t(e);return o(e)?i:r(i,n(e))}},36522:(e,t,n)=>{var r=n(96711),o=n(10905),i=n(42588),a=r?r.toStringTag:void 0;e.exports=function(e){return null==e?void 0===e?"[object Undefined]":"[object Null]":a&&a in Object(e)?o(e):i(e)}},88772:e=>{var t=Object.prototype.hasOwnProperty;e.exports=function(e,n){return null!=e&&t.call(e,n)}},86571:e=>{e.exports=function(e,t){return null!=e&&t in Object(e)}},82744:(e,t,n)=>{var r=n(36522),o=n(52620);e.exports=function(e){return o(e)&&"[object Arguments]"==r(e)}},39336:(e,t,n)=>{var r=n(1894),o=n(52620);e.exports=function e(t,n,i,a,s){return t===n||(null==t||null==n||!o(t)&&!o(n)?t!=t&&n!=n:r(t,n,i,a,e,s))}},1894:(e,t,n)=>{var r=n(16435),o=n(81505),i=n(39620),a=n(70439),s=n(70695),l=n(62003),c=n(31262),u=n(89221),d="[object Arguments]",p="[object Array]",f="[object Object]",h=Object.prototype.hasOwnProperty;e.exports=function(e,t,n,m,g,v){var y=l(e),b=l(t),_=y?p:s(e),A=b?p:s(t),E=(_=_==d?f:_)==f,w=(A=A==d?f:A)==f,x=_==A;if(x&&c(e)){if(!c(t))return!1;y=!0,E=!1}if(x&&!E)return v||(v=new r),y||u(e)?o(e,t,n,m,g,v):i(e,t,_,n,m,g,v);if(!(1&n)){var k=E&&h.call(e,"__wrapped__"),C=w&&h.call(t,"__wrapped__");if(k||C){var S=k?e.value():e,M=C?t.value():t;return v||(v=new r),g(S,M,n,m,v)}}return!!x&&(v||(v=new r),a(e,t,n,m,g,v))}},84253:(e,t,n)=>{var r=n(16435),o=n(39336);e.exports=function(e,t,n,i){var a=n.length,s=a,l=!i;if(null==e)return!s;for(e=Object(e);a--;){var c=n[a];if(l&&c[2]?c[1]!==e[c[0]]:!(c[0]in e))return!1}for(;++a<s;){var u=(c=n[a])[0],d=e[u],p=c[1];if(l&&c[2]){if(void 0===d&&!(u in e))return!1}else{var f=new r;if(i)var h=i(d,p,u,e,t,f);if(!(void 0===h?o(p,d,3,i,f):h))return!1}}return!0}},62249:(e,t,n)=>{var r=n(78148),o=n(71398),i=n(95603),a=n(41543),s=/^\[object .+?Constructor\]$/,l=Function.prototype,c=Object.prototype,u=l.toString,d=c.hasOwnProperty,p=RegExp("^"+u.call(d).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");e.exports=function(e){return!(!i(e)||o(e))&&(r(e)?p:s).test(a(e))}},45387:(e,t,n)=>{var r=n(36522),o=n(17164),i=n(52620),a={};a["[object Float32Array]"]=a["[object Float64Array]"]=a["[object Int8Array]"]=a["[object Int16Array]"]=a["[object Int32Array]"]=a["[object Uint8Array]"]=a["[object Uint8ClampedArray]"]=a["[object Uint16Array]"]=a["[object Uint32Array]"]=!0,a["[object Arguments]"]=a["[object Array]"]=a["[object ArrayBuffer]"]=a["[object Boolean]"]=a["[object DataView]"]=a["[object Date]"]=a["[object Error]"]=a["[object Function]"]=a["[object Map]"]=a["[object Number]"]=a["[object Object]"]=a["[object RegExp]"]=a["[object Set]"]=a["[object String]"]=a["[object WeakMap]"]=!1,e.exports=function(e){return i(e)&&o(e.length)&&!!a[r(e)]}},77675:(e,t,n)=>{var r=n(95141),o=n(8476),i=n(1686),a=n(62003),s=n(97093);e.exports=function(e){return"function"==typeof e?e:null==e?i:"object"==typeof e?a(e)?o(e[0],e[1]):r(e):s(e)}},96794:(e,t,n)=>{var r=n(26165),o=n(56132),i=Object.prototype.hasOwnProperty;e.exports=function(e){if(!r(e))return o(e);var t=[];for(var n in Object(e))i.call(e,n)&&"constructor"!=n&&t.push(n);return t}},95141:(e,t,n)=>{var r=n(84253),o=n(98418),i=n(93591);e.exports=function(e){var t=o(e);return 1==t.length&&t[0][2]?i(t[0][0],t[0][1]):function(n){return n===e||r(n,e,t)}}},8476:(e,t,n)=>{var r=n(39336),o=n(81214),i=n(98765),a=n(35456),s=n(57030),l=n(93591),c=n(48059);e.exports=function(e,t){return a(e)&&s(t)?l(c(e),t):function(n){var a=o(n,e);return void 0===a&&a===t?i(n,e):r(t,a,3)}}},31171:e=>{e.exports=function(e){return function(t){return null==t?void 0:t[e]}}},44589:(e,t,n)=>{var r=n(384);e.exports=function(e){return function(t){return r(t,e)}}},19390:e=>{e.exports=function(e){return function(t){return null==e?void 0:e[t]}}},74198:e=>{e.exports=function(e,t,n){var r=-1,o=e.length;t<0&&(t=-t>o?0:o+t),(n=n>o?o:n)<0&&(n+=o),o=t>n?0:n-t>>>0,t>>>=0;for(var i=Array(o);++r<o;)i[r]=e[r+t];return i}},85410:e=>{e.exports=function(e,t){for(var n=-1,r=Array(e);++n<e;)r[n]=t(n);return r}},38354:(e,t,n)=>{var r=n(96711),o=n(14),i=n(62003),a=n(96596),s=r?r.prototype:void 0,l=s?s.toString:void 0;e.exports=function e(t){if("string"==typeof t)return t;if(i(t))return o(t,e)+"";if(a(t))return l?l.call(t):"";var n=t+"";return"0"==n&&1/t==-1/0?"-0":n}},22347:e=>{e.exports=function(e){return function(t){return e(t)}}},27585:e=>{e.exports=function(e,t){return e.has(t)}},34275:(e,t,n)=>{var r=n(62003),o=n(35456),i=n(25240),a=n(47060);e.exports=function(e,t){return r(e)?e:o(e,t)?[e]:i(a(e))}},29304:(e,t,n)=>{var r=n(74198);e.exports=function(e,t,n){var o=e.length;return n=void 0===n?o:n,!t&&n>=o?e:r(e,t,n)}},53887:(e,t,n)=>{var r=n(29107)["__core-js_shared__"];e.exports=r},50951:e=>{e.exports=function(e){return function(t,n,r){for(var o=-1,i=Object(t),a=r(t),s=a.length;s--;){var l=a[e?s:++o];if(!1===n(i[l],l,i))break}return t}}},11709:(e,t,n)=>{var r=n(29304),o=n(34188),i=n(62562),a=n(47060);e.exports=function(e){return function(t){t=a(t);var n=o(t)?i(t):void 0,s=n?n[0]:t.charAt(0),l=n?r(n,1).join(""):t.slice(1);return s[e]()+l}}},29449:(e,t,n)=>{var r=n(35528),o=n(38426),i=n(14715),a=RegExp("['’]","g");e.exports=function(e){return function(t){return r(i(o(t).replace(a,"")),e,"")}}},86385:(e,t,n)=>{var r=n(19390)({À:"A",Á:"A",Â:"A",Ã:"A",Ä:"A",Å:"A",à:"a",á:"a",â:"a",ã:"a",ä:"a",å:"a",Ç:"C",ç:"c",Ð:"D",ð:"d",È:"E",É:"E",Ê:"E",Ë:"E",è:"e",é:"e",ê:"e",ë:"e",Ì:"I",Í:"I",Î:"I",Ï:"I",ì:"i",í:"i",î:"i",ï:"i",Ñ:"N",ñ:"n",Ò:"O",Ó:"O",Ô:"O",Õ:"O",Ö:"O",Ø:"O",ò:"o",ó:"o",ô:"o",õ:"o",ö:"o",ø:"o",Ù:"U",Ú:"U",Û:"U",Ü:"U",ù:"u",ú:"u",û:"u",ü:"u",Ý:"Y",ý:"y",ÿ:"y",Æ:"Ae",æ:"ae",Þ:"Th",þ:"th",ß:"ss",Ā:"A",Ă:"A",Ą:"A",ā:"a",ă:"a",ą:"a",Ć:"C",Ĉ:"C",Ċ:"C",Č:"C",ć:"c",ĉ:"c",ċ:"c",č:"c",Ď:"D",Đ:"D",ď:"d",đ:"d",Ē:"E",Ĕ:"E",Ė:"E",Ę:"E",Ě:"E",ē:"e",ĕ:"e",ė:"e",ę:"e",ě:"e",Ĝ:"G",Ğ:"G",Ġ:"G",Ģ:"G",ĝ:"g",ğ:"g",ġ:"g",ģ:"g",Ĥ:"H",Ħ:"H",ĥ:"h",ħ:"h",Ĩ:"I",Ī:"I",Ĭ:"I",Į:"I",İ:"I",ĩ:"i",ī:"i",ĭ:"i",į:"i",ı:"i",Ĵ:"J",ĵ:"j",Ķ:"K",ķ:"k",ĸ:"k",Ĺ:"L",Ļ:"L",Ľ:"L",Ŀ:"L",Ł:"L",ĺ:"l",ļ:"l",ľ:"l",ŀ:"l",ł:"l",Ń:"N",Ņ:"N",Ň:"N",Ŋ:"N",ń:"n",ņ:"n",ň:"n",ŋ:"n",Ō:"O",Ŏ:"O",Ő:"O",ō:"o",ŏ:"o",ő:"o",Ŕ:"R",Ŗ:"R",Ř:"R",ŕ:"r",ŗ:"r",ř:"r",Ś:"S",Ŝ:"S",Ş:"S",Š:"S",ś:"s",ŝ:"s",ş:"s",š:"s",Ţ:"T",Ť:"T",Ŧ:"T",ţ:"t",ť:"t",ŧ:"t",Ũ:"U",Ū:"U",Ŭ:"U",Ů:"U",Ű:"U",Ų:"U",ũ:"u",ū:"u",ŭ:"u",ů:"u",ű:"u",ų:"u",Ŵ:"W",ŵ:"w",Ŷ:"Y",ŷ:"y",Ÿ:"Y",Ź:"Z",Ż:"Z",Ž:"Z",ź:"z",ż:"z",ž:"z",Ĳ:"IJ",ĳ:"ij",Œ:"Oe",œ:"oe",ŉ:"'n",ſ:"s"});e.exports=r},73009:(e,t,n)=>{var r=n(33984),o=function(){try{var e=r(Object,"defineProperty");return e({},"",{}),e}catch(e){}}();e.exports=o},81505:(e,t,n)=>{var r=n(71641),o=n(19854),i=n(27585);e.exports=function(e,t,n,a,s,l){var c=1&n,u=e.length,d=t.length;if(u!=d&&!(c&&d>u))return!1;var p=l.get(e),f=l.get(t);if(p&&f)return p==t&&f==e;var h=-1,m=!0,g=2&n?new r:void 0;for(l.set(e,t),l.set(t,e);++h<u;){var v=e[h],y=t[h];if(a)var b=c?a(y,v,h,t,e,l):a(v,y,h,e,t,l);if(void 0!==b){if(b)continue;m=!1;break}if(g){if(!o(t,(function(e,t){if(!i(g,t)&&(v===e||s(v,e,n,a,l)))return g.push(t)}))){m=!1;break}}else if(v!==y&&!s(v,y,n,a,l)){m=!1;break}}return l.delete(e),l.delete(t),m}},39620:(e,t,n)=>{var r=n(96711),o=n(59282),i=n(98330),a=n(81505),s=n(95483),l=n(85841),c=r?r.prototype:void 0,u=c?c.valueOf:void 0;e.exports=function(e,t,n,r,c,d,p){switch(n){case"[object DataView]":if(e.byteLength!=t.byteLength||e.byteOffset!=t.byteOffset)return!1;e=e.buffer,t=t.buffer;case"[object ArrayBuffer]":return!(e.byteLength!=t.byteLength||!d(new o(e),new o(t)));case"[object Boolean]":case"[object Date]":case"[object Number]":return i(+e,+t);case"[object Error]":return e.name==t.name&&e.message==t.message;case"[object RegExp]":case"[object String]":return e==t+"";case"[object Map]":var f=s;case"[object Set]":var h=1&r;if(f||(f=l),e.size!=t.size&&!h)return!1;var m=p.get(e);if(m)return m==t;r|=2,p.set(e,t);var g=a(f(e),f(t),r,c,d,p);return p.delete(e),g;case"[object Symbol]":if(u)return u.call(e)==u.call(t)}return!1}},70439:(e,t,n)=>{var r=n(85760),o=Object.prototype.hasOwnProperty;e.exports=function(e,t,n,i,a,s){var l=1&n,c=r(e),u=c.length;if(u!=r(t).length&&!l)return!1;for(var d=u;d--;){var p=c[d];if(!(l?p in t:o.call(t,p)))return!1}var f=s.get(e),h=s.get(t);if(f&&h)return f==t&&h==e;var m=!0;s.set(e,t),s.set(t,e);for(var g=l;++d<u;){var v=e[p=c[d]],y=t[p];if(i)var b=l?i(y,v,p,t,e,s):i(v,y,p,e,t,s);if(!(void 0===b?v===y||a(v,y,n,i,s):b)){m=!1;break}g||(g="constructor"==p)}if(m&&!g){var _=e.constructor,A=t.constructor;_==A||!("constructor"in e)||!("constructor"in t)||"function"==typeof _&&_ instanceof _&&"function"==typeof A&&A instanceof A||(m=!1)}return s.delete(e),s.delete(t),m}},62718:(e,t,n)=>{var r="object"==typeof n.g&&n.g&&n.g.Object===Object&&n.g;e.exports=r},85760:(e,t,n)=>{var r=n(68821),o=n(26806),i=n(65304);e.exports=function(e){return r(e,i,o)}},56929:(e,t,n)=>{var r=n(19732);e.exports=function(e,t){var n=e.__data__;return r(t)?n["string"==typeof t?"string":"hash"]:n.map}},98418:(e,t,n)=>{var r=n(57030),o=n(65304);e.exports=function(e){for(var t=o(e),n=t.length;n--;){var i=t[n],a=e[i];t[n]=[i,a,r(a)]}return t}},33984:(e,t,n)=>{var r=n(62249),o=n(11074);e.exports=function(e,t){var n=o(e,t);return r(n)?n:void 0}},10905:(e,t,n)=>{var r=n(96711),o=Object.prototype,i=o.hasOwnProperty,a=o.toString,s=r?r.toStringTag:void 0;e.exports=function(e){var t=i.call(e,s),n=e[s];try{e[s]=void 0;var r=!0}catch(e){}var o=a.call(e);return r&&(t?e[s]=n:delete e[s]),o}},26806:(e,t,n)=>{var r=n(43928),o=n(40119),i=Object.prototype.propertyIsEnumerable,a=Object.getOwnPropertySymbols,s=a?function(e){return null==e?[]:(e=Object(e),r(a(e),(function(t){return i.call(e,t)})))}:o;e.exports=s},70695:(e,t,n)=>{var r=n(37230),o=n(75661),i=n(29102),a=n(5963),s=n(70469),l=n(36522),c=n(41543),u="[object Map]",d="[object Promise]",p="[object Set]",f="[object WeakMap]",h="[object DataView]",m=c(r),g=c(o),v=c(i),y=c(a),b=c(s),_=l;(r&&_(new r(new ArrayBuffer(1)))!=h||o&&_(new o)!=u||i&&_(i.resolve())!=d||a&&_(new a)!=p||s&&_(new s)!=f)&&(_=function(e){var t=l(e),n="[object Object]"==t?e.constructor:void 0,r=n?c(n):"";if(r)switch(r){case m:return h;case g:return u;case v:return d;case y:return p;case b:return f}return t}),e.exports=_},11074:e=>{e.exports=function(e,t){return null==e?void 0:e[t]}},32248:(e,t,n)=>{var r=n(34275),o=n(2382),i=n(62003),a=n(62615),s=n(17164),l=n(48059);e.exports=function(e,t,n){for(var c=-1,u=(t=r(t,e)).length,d=!1;++c<u;){var p=l(t[c]);if(!(d=null!=e&&n(e,p)))break;e=e[p]}return d||++c!=u?d:!!(u=null==e?0:e.length)&&s(u)&&a(p,u)&&(i(e)||o(e))}},34188:e=>{var t=RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");e.exports=function(e){return t.test(e)}},30784:e=>{var t=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;e.exports=function(e){return t.test(e)}},26890:(e,t,n)=>{var r=n(26060);e.exports=function(){this.__data__=r?r(null):{},this.size=0}},49484:e=>{e.exports=function(e){var t=this.has(e)&&delete this.__data__[e];return this.size-=t?1:0,t}},37215:(e,t,n)=>{var r=n(26060),o=Object.prototype.hasOwnProperty;e.exports=function(e){var t=this.__data__;if(r){var n=t[e];return"__lodash_hash_undefined__"===n?void 0:n}return o.call(t,e)?t[e]:void 0}},87811:(e,t,n)=>{var r=n(26060),o=Object.prototype.hasOwnProperty;e.exports=function(e){var t=this.__data__;return r?void 0!==t[e]:o.call(t,e)}},90747:(e,t,n)=>{var r=n(26060);e.exports=function(e,t){var n=this.__data__;return this.size+=this.has(e)?0:1,n[e]=r&&void 0===t?"__lodash_hash_undefined__":t,this}},62615:e=>{var t=/^(?:0|[1-9]\d*)$/;e.exports=function(e,n){var r=typeof e;return!!(n=null==n?9007199254740991:n)&&("number"==r||"symbol"!=r&&t.test(e))&&e>-1&&e%1==0&&e<n}},35456:(e,t,n)=>{var r=n(62003),o=n(96596),i=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,a=/^\w*$/;e.exports=function(e,t){if(r(e))return!1;var n=typeof e;return!("number"!=n&&"symbol"!=n&&"boolean"!=n&&null!=e&&!o(e))||(a.test(e)||!i.test(e)||null!=t&&e in Object(t))}},19732:e=>{e.exports=function(e){var t=typeof e;return"string"==t||"number"==t||"symbol"==t||"boolean"==t?"__proto__"!==e:null===e}},71398:(e,t,n)=>{var r,o=n(53887),i=(r=/[^.]+$/.exec(o&&o.keys&&o.keys.IE_PROTO||""))?"Symbol(src)_1."+r:"";e.exports=function(e){return!!i&&i in e}},26165:e=>{var t=Object.prototype;e.exports=function(e){var n=e&&e.constructor;return e===("function"==typeof n&&n.prototype||t)}},57030:(e,t,n)=>{var r=n(95603);e.exports=function(e){return e==e&&!r(e)}},74412:e=>{e.exports=function(){this.__data__=[],this.size=0}},28522:(e,t,n)=>{var r=n(24767),o=Array.prototype.splice;e.exports=function(e){var t=this.__data__,n=r(t,e);return!(n<0)&&(n==t.length-1?t.pop():o.call(t,n,1),--this.size,!0)}},50469:(e,t,n)=>{var r=n(24767);e.exports=function(e){var t=this.__data__,n=r(t,e);return n<0?void 0:t[n][1]}},61161:(e,t,n)=>{var r=n(24767);e.exports=function(e){return r(this.__data__,e)>-1}},81441:(e,t,n)=>{var r=n(24767);e.exports=function(e,t){var n=this.__data__,o=r(n,e);return o<0?(++this.size,n.push([e,t])):n[o][1]=t,this}},28206:(e,t,n)=>{var r=n(83435),o=n(95217),i=n(75661);e.exports=function(){this.size=0,this.__data__={hash:new r,map:new(i||o),string:new r}}},89768:(e,t,n)=>{var r=n(56929);e.exports=function(e){var t=r(this,e).delete(e);return this.size-=t?1:0,t}},26827:(e,t,n)=>{var r=n(56929);e.exports=function(e){return r(this,e).get(e)}},70663:(e,t,n)=>{var r=n(56929);e.exports=function(e){return r(this,e).has(e)}},25135:(e,t,n)=>{var r=n(56929);e.exports=function(e,t){var n=r(this,e),o=n.size;return n.set(e,t),this.size+=n.size==o?0:1,this}},95483:e=>{e.exports=function(e){var t=-1,n=Array(e.size);return e.forEach((function(e,r){n[++t]=[r,e]})),n}},93591:e=>{e.exports=function(e,t){return function(n){return null!=n&&(n[e]===t&&(void 0!==t||e in Object(n)))}}},30874:(e,t,n)=>{var r=n(61894);e.exports=function(e){var t=r(e,(function(e){return 500===n.size&&n.clear(),e})),n=t.cache;return t}},26060:(e,t,n)=>{var r=n(33984)(Object,"create");e.exports=r},56132:(e,t,n)=>{var r=n(70889)(Object.keys,Object);e.exports=r},18315:(e,t,n)=>{e=n.nmd(e);var r=n(62718),o=t&&!t.nodeType&&t,i=o&&e&&!e.nodeType&&e,a=i&&i.exports===o&&r.process,s=function(){try{var e=i&&i.require&&i.require("util").types;return e||a&&a.binding&&a.binding("util")}catch(e){}}();e.exports=s},42588:e=>{var t=Object.prototype.toString;e.exports=function(e){return t.call(e)}},70889:e=>{e.exports=function(e,t){return function(n){return e(t(n))}}},29107:(e,t,n)=>{var r=n(62718),o="object"==typeof self&&self&&self.Object===Object&&self,i=r||o||Function("return this")();e.exports=i},62486:e=>{e.exports=function(e){return this.__data__.set(e,"__lodash_hash_undefined__"),this}},9361:e=>{e.exports=function(e){return this.__data__.has(e)}},85841:e=>{e.exports=function(e){var t=-1,n=Array(e.size);return e.forEach((function(e){n[++t]=e})),n}},28658:(e,t,n)=>{var r=n(95217);e.exports=function(){this.__data__=new r,this.size=0}},63844:e=>{e.exports=function(e){var t=this.__data__,n=t.delete(e);return this.size=t.size,n}},56503:e=>{e.exports=function(e){return this.__data__.get(e)}},31563:e=>{e.exports=function(e){return this.__data__.has(e)}},10259:(e,t,n)=>{var r=n(95217),o=n(75661),i=n(53287);e.exports=function(e,t){var n=this.__data__;if(n instanceof r){var a=n.__data__;if(!o||a.length<199)return a.push([e,t]),this.size=++n.size,this;n=this.__data__=new i(a)}return n.set(e,t),this.size=n.size,this}},62562:(e,t,n)=>{var r=n(13627),o=n(34188),i=n(29712);e.exports=function(e){return o(e)?i(e):r(e)}},25240:(e,t,n)=>{var r=n(30874),o=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,i=/\\(\\)?/g,a=r((function(e){var t=[];return 46===e.charCodeAt(0)&&t.push(""),e.replace(o,(function(e,n,r,o){t.push(r?o.replace(i,"$1"):n||e)})),t}));e.exports=a},48059:(e,t,n)=>{var r=n(96596);e.exports=function(e){if("string"==typeof e||r(e))return e;var t=e+"";return"0"==t&&1/e==-1/0?"-0":t}},41543:e=>{var t=Function.prototype.toString;e.exports=function(e){if(null!=e){try{return t.call(e)}catch(e){}try{return e+""}catch(e){}}return""}},29712:e=>{var t="\\ud800-\\udfff",n="["+t+"]",r="[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",o="\\ud83c[\\udffb-\\udfff]",i="[^"+t+"]",a="(?:\\ud83c[\\udde6-\\uddff]){2}",s="[\\ud800-\\udbff][\\udc00-\\udfff]",l="(?:"+r+"|"+o+")"+"?",c="[\\ufe0e\\ufe0f]?",u=c+l+("(?:\\u200d(?:"+[i,a,s].join("|")+")"+c+l+")*"),d="(?:"+[i+r+"?",r,a,s,n].join("|")+")",p=RegExp(o+"(?="+o+")|"+d+u,"g");e.exports=function(e){return e.match(p)||[]}},70567:e=>{var t="\\ud800-\\udfff",n="\\u2700-\\u27bf",r="a-z\\xdf-\\xf6\\xf8-\\xff",o="A-Z\\xc0-\\xd6\\xd8-\\xde",i="\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",a="["+i+"]",s="\\d+",l="["+n+"]",c="["+r+"]",u="[^"+t+i+s+n+r+o+"]",d="(?:\\ud83c[\\udde6-\\uddff]){2}",p="[\\ud800-\\udbff][\\udc00-\\udfff]",f="["+o+"]",h="(?:"+c+"|"+u+")",m="(?:"+f+"|"+u+")",g="(?:['’](?:d|ll|m|re|s|t|ve))?",v="(?:['’](?:D|LL|M|RE|S|T|VE))?",y="(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?",b="[\\ufe0e\\ufe0f]?",_=b+y+("(?:\\u200d(?:"+["[^"+t+"]",d,p].join("|")+")"+b+y+")*"),A="(?:"+[l,d,p].join("|")+")"+_,E=RegExp([f+"?"+c+"+"+g+"(?="+[a,f,"$"].join("|")+")",m+"+"+v+"(?="+[a,f+h,"$"].join("|")+")",f+"?"+h+"+"+g,f+"+"+v,"\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])","\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",s,A].join("|"),"g");e.exports=function(e){return e.match(E)||[]}},66036:(e,t,n)=>{var r=n(88314),o=n(29449)((function(e,t,n){return t=t.toLowerCase(),e+(n?r(t):t)}));e.exports=o},88314:(e,t,n)=>{var r=n(47060),o=n(67290);e.exports=function(e){return o(r(e).toLowerCase())}},38426:(e,t,n)=>{var r=n(86385),o=n(47060),i=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,a=RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]","g");e.exports=function(e){return(e=o(e))&&e.replace(i,r).replace(a,"")}},98330:e=>{e.exports=function(e,t){return e===t||e!=e&&t!=t}},81214:(e,t,n)=>{var r=n(384);e.exports=function(e,t,n){var o=null==e?void 0:r(e,t);return void 0===o?n:o}},25930:(e,t,n)=>{var r=n(88772),o=n(32248);e.exports=function(e,t){return null!=e&&o(e,t,r)}},98765:(e,t,n)=>{var r=n(86571),o=n(32248);e.exports=function(e,t){return null!=e&&o(e,t,r)}},1686:e=>{e.exports=function(e){return e}},2382:(e,t,n)=>{var r=n(82744),o=n(52620),i=Object.prototype,a=i.hasOwnProperty,s=i.propertyIsEnumerable,l=r(function(){return arguments}())?r:function(e){return o(e)&&a.call(e,"callee")&&!s.call(e,"callee")};e.exports=l},62003:e=>{var t=Array.isArray;e.exports=t},86316:(e,t,n)=>{var r=n(78148),o=n(17164);e.exports=function(e){return null!=e&&o(e.length)&&!r(e)}},31262:(e,t,n)=>{e=n.nmd(e);var r=n(29107),o=n(72125),i=t&&!t.nodeType&&t,a=i&&e&&!e.nodeType&&e,s=a&&a.exports===i?r.Buffer:void 0,l=(s?s.isBuffer:void 0)||o;e.exports=l},78148:(e,t,n)=>{var r=n(36522),o=n(95603);e.exports=function(e){if(!o(e))return!1;var t=r(e);return"[object Function]"==t||"[object GeneratorFunction]"==t||"[object AsyncFunction]"==t||"[object Proxy]"==t}},17164:e=>{e.exports=function(e){return"number"==typeof e&&e>-1&&e%1==0&&e<=9007199254740991}},95603:e=>{e.exports=function(e){var t=typeof e;return null!=e&&("object"==t||"function"==t)}},52620:e=>{e.exports=function(e){return null!=e&&"object"==typeof e}},96596:(e,t,n)=>{var r=n(36522),o=n(52620);e.exports=function(e){return"symbol"==typeof e||o(e)&&"[object Symbol]"==r(e)}},89221:(e,t,n)=>{var r=n(45387),o=n(22347),i=n(18315),a=i&&i.isTypedArray,s=a?o(a):r;e.exports=s},65304:(e,t,n)=>{var r=n(97137),o=n(96794),i=n(86316);e.exports=function(e){return i(e)?r(e):o(e)}},79832:(e,t,n)=>{var r=n(69330),o=n(10427),i=n(77675);e.exports=function(e,t){var n={};return t=i(t,3),o(e,(function(e,o,i){r(n,t(e,o,i),e)})),n}},36146:(e,t,n)=>{var r=n(69330),o=n(10427),i=n(77675);e.exports=function(e,t){var n={};return t=i(t,3),o(e,(function(e,o,i){r(n,o,t(e,o,i))})),n}},61894:(e,t,n)=>{var r=n(53287);function o(e,t){if("function"!=typeof e||null!=t&&"function"!=typeof t)throw new TypeError("Expected a function");var n=function(){var r=arguments,o=t?t.apply(this,r):r[0],i=n.cache;if(i.has(o))return i.get(o);var a=e.apply(this,r);return n.cache=i.set(o,a)||i,a};return n.cache=new(o.Cache||r),n}o.Cache=r,e.exports=o},97093:(e,t,n)=>{var r=n(31171),o=n(44589),i=n(35456),a=n(48059);e.exports=function(e){return i(e)?r(a(e)):o(e)}},88774:(e,t,n)=>{var r=n(29449)((function(e,t,n){return e+(n?"_":"")+t.toLowerCase()}));e.exports=r},40119:e=>{e.exports=function(){return[]}},72125:e=>{e.exports=function(){return!1}},47060:(e,t,n)=>{var r=n(38354);e.exports=function(e){return null==e?"":r(e)}},67290:(e,t,n)=>{var r=n(11709)("toUpperCase");e.exports=r},14715:(e,t,n)=>{var r=n(46479),o=n(30784),i=n(47060),a=n(70567);e.exports=function(e,t,n){return e=i(e),void 0===(t=n?void 0:t)?o(e)?a(e):r(e):e.match(t)||[]}},19183:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("af",{months:"Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember".split("_"),monthsShort:"Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des".split("_"),weekdays:"Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag".split("_"),weekdaysShort:"Son_Maa_Din_Woe_Don_Vry_Sat".split("_"),weekdaysMin:"So_Ma_Di_Wo_Do_Vr_Sa".split("_"),meridiemParse:/vm|nm/i,isPM:function(e){return/^nm$/i.test(e)},meridiem:function(e,t,n){return e<12?n?"vm":"VM":n?"nm":"NM"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Vandag om] LT",nextDay:"[Môre om] LT",nextWeek:"dddd [om] LT",lastDay:"[Gister om] LT",lastWeek:"[Laas] dddd [om] LT",sameElse:"L"},relativeTime:{future:"oor %s",past:"%s gelede",s:"'n paar sekondes",ss:"%d sekondes",m:"'n minuut",mm:"%d minute",h:"'n uur",hh:"%d ure",d:"'n dag",dd:"%d dae",M:"'n maand",MM:"%d maande",y:"'n jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?"ste":"de")},week:{dow:1,doy:4}})}(n(41655))},47214:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t=function(e){return 0===e?0:1===e?1:2===e?2:e%100>=3&&e%100<=10?3:e%100>=11?4:5},n={s:["أقل من ثانية","ثانية واحدة",["ثانيتان","ثانيتين"],"%d ثوان","%d ثانية","%d ثانية"],m:["أقل من دقيقة","دقيقة واحدة",["دقيقتان","دقيقتين"],"%d دقائق","%d دقيقة","%d دقيقة"],h:["أقل من ساعة","ساعة واحدة",["ساعتان","ساعتين"],"%d ساعات","%d ساعة","%d ساعة"],d:["أقل من يوم","يوم واحد",["يومان","يومين"],"%d أيام","%d يومًا","%d يوم"],M:["أقل من شهر","شهر واحد",["شهران","شهرين"],"%d أشهر","%d شهرا","%d شهر"],y:["أقل من عام","عام واحد",["عامان","عامين"],"%d أعوام","%d عامًا","%d عام"]},r=function(e){return function(r,o,i,a){var s=t(r),l=n[e][t(r)];return 2===s&&(l=l[o?0:1]),l.replace(/%d/i,r)}},o=["جانفي","فيفري","مارس","أفريل","ماي","جوان","جويلية","أوت","سبتمبر","أكتوبر","نوفمبر","ديسمبر"];e.defineLocale("ar-dz",{months:o,monthsShort:o,weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/‏M/‏YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/ص|م/,isPM:function(e){return"م"===e},meridiem:function(e,t,n){return e<12?"ص":"م"},calendar:{sameDay:"[اليوم عند الساعة] LT",nextDay:"[غدًا عند الساعة] LT",nextWeek:"dddd [عند الساعة] LT",lastDay:"[أمس عند الساعة] LT",lastWeek:"dddd [عند الساعة] LT",sameElse:"L"},relativeTime:{future:"بعد %s",past:"منذ %s",s:r("s"),ss:r("s"),m:r("m"),mm:r("m"),h:r("h"),hh:r("h"),d:r("d"),dd:r("d"),M:r("M"),MM:r("M"),y:r("y"),yy:r("y")},postformat:function(e){return e.replace(/,/g,"،")},week:{dow:0,doy:4}})}(n(41655))},40830:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("ar-kw",{months:"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),monthsShort:"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),weekdays:"الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",ss:"%d ثانية",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},week:{dow:0,doy:12}})}(n(41655))},68899:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9",0:"0"},n=function(e){return 0===e?0:1===e?1:2===e?2:e%100>=3&&e%100<=10?3:e%100>=11?4:5},r={s:["أقل من ثانية","ثانية واحدة",["ثانيتان","ثانيتين"],"%d ثوان","%d ثانية","%d ثانية"],m:["أقل من دقيقة","دقيقة واحدة",["دقيقتان","دقيقتين"],"%d دقائق","%d دقيقة","%d دقيقة"],h:["أقل من ساعة","ساعة واحدة",["ساعتان","ساعتين"],"%d ساعات","%d ساعة","%d ساعة"],d:["أقل من يوم","يوم واحد",["يومان","يومين"],"%d أيام","%d يومًا","%d يوم"],M:["أقل من شهر","شهر واحد",["شهران","شهرين"],"%d أشهر","%d شهرا","%d شهر"],y:["أقل من عام","عام واحد",["عامان","عامين"],"%d أعوام","%d عامًا","%d عام"]},o=function(e){return function(t,o,i,a){var s=n(t),l=r[e][n(t)];return 2===s&&(l=l[o?0:1]),l.replace(/%d/i,t)}},i=["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"];e.defineLocale("ar-ly",{months:i,monthsShort:i,weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/‏M/‏YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/ص|م/,isPM:function(e){return"م"===e},meridiem:function(e,t,n){return e<12?"ص":"م"},calendar:{sameDay:"[اليوم عند الساعة] LT",nextDay:"[غدًا عند الساعة] LT",nextWeek:"dddd [عند الساعة] LT",lastDay:"[أمس عند الساعة] LT",lastWeek:"dddd [عند الساعة] LT",sameElse:"L"},relativeTime:{future:"بعد %s",past:"منذ %s",s:o("s"),ss:o("s"),m:o("m"),mm:o("m"),h:o("h"),hh:o("h"),d:o("d"),dd:o("d"),M:o("M"),MM:o("M"),y:o("y"),yy:o("y")},preparse:function(e){return e.replace(/،/g,",")},postformat:function(e){return e.replace(/\d/g,(function(e){return t[e]})).replace(/,/g,"،")},week:{dow:6,doy:12}})}(n(41655))},77258:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("ar-ma",{months:"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),monthsShort:"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",ss:"%d ثانية",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},week:{dow:1,doy:4}})}(n(41655))},19121:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={1:"١",2:"٢",3:"٣",4:"٤",5:"٥",6:"٦",7:"٧",8:"٨",9:"٩",0:"٠"},n={"١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","٠":"0"};e.defineLocale("ar-ps",{months:"كانون الثاني_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_تشري الأوّل_تشرين الثاني_كانون الأوّل".split("_"),monthsShort:"ك٢_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_ت١_ت٢_ك١".split("_"),weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/ص|م/,isPM:function(e){return"م"===e},meridiem:function(e,t,n){return e<12?"ص":"م"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",ss:"%d ثانية",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},preparse:function(e){return e.replace(/[٣٤٥٦٧٨٩٠]/g,(function(e){return n[e]})).split("").reverse().join("").replace(/[١٢](?![\u062a\u0643])/g,(function(e){return n[e]})).split("").reverse().join("").replace(/،/g,",")},postformat:function(e){return e.replace(/\d/g,(function(e){return t[e]})).replace(/,/g,"،")},week:{dow:0,doy:6}})}(n(41655))},64096:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={1:"١",2:"٢",3:"٣",4:"٤",5:"٥",6:"٦",7:"٧",8:"٨",9:"٩",0:"٠"},n={"١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","٠":"0"};e.defineLocale("ar-sa",{months:"يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),monthsShort:"يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/ص|م/,isPM:function(e){return"م"===e},meridiem:function(e,t,n){return e<12?"ص":"م"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",ss:"%d ثانية",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},preparse:function(e){return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g,(function(e){return n[e]})).replace(/،/g,",")},postformat:function(e){return e.replace(/\d/g,(function(e){return t[e]})).replace(/,/g,"،")},week:{dow:0,doy:6}})}(n(41655))},97826:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("ar-tn",{months:"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),monthsShort:"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",ss:"%d ثانية",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},week:{dow:1,doy:4}})}(n(41655))},31035:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={1:"١",2:"٢",3:"٣",4:"٤",5:"٥",6:"٦",7:"٧",8:"٨",9:"٩",0:"٠"},n={"١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","٠":"0"},r=function(e){return 0===e?0:1===e?1:2===e?2:e%100>=3&&e%100<=10?3:e%100>=11?4:5},o={s:["أقل من ثانية","ثانية واحدة",["ثانيتان","ثانيتين"],"%d ثوان","%d ثانية","%d ثانية"],m:["أقل من دقيقة","دقيقة واحدة",["دقيقتان","دقيقتين"],"%d دقائق","%d دقيقة","%d دقيقة"],h:["أقل من ساعة","ساعة واحدة",["ساعتان","ساعتين"],"%d ساعات","%d ساعة","%d ساعة"],d:["أقل من يوم","يوم واحد",["يومان","يومين"],"%d أيام","%d يومًا","%d يوم"],M:["أقل من شهر","شهر واحد",["شهران","شهرين"],"%d أشهر","%d شهرا","%d شهر"],y:["أقل من عام","عام واحد",["عامان","عامين"],"%d أعوام","%d عامًا","%d عام"]},i=function(e){return function(t,n,i,a){var s=r(t),l=o[e][r(t)];return 2===s&&(l=l[n?0:1]),l.replace(/%d/i,t)}},a=["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"];e.defineLocale("ar",{months:a,monthsShort:a,weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/‏M/‏YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/ص|م/,isPM:function(e){return"م"===e},meridiem:function(e,t,n){return e<12?"ص":"م"},calendar:{sameDay:"[اليوم عند الساعة] LT",nextDay:"[غدًا عند الساعة] LT",nextWeek:"dddd [عند الساعة] LT",lastDay:"[أمس عند الساعة] LT",lastWeek:"dddd [عند الساعة] LT",sameElse:"L"},relativeTime:{future:"بعد %s",past:"منذ %s",s:i("s"),ss:i("s"),m:i("m"),mm:i("m"),h:i("h"),hh:i("h"),d:i("d"),dd:i("d"),M:i("M"),MM:i("M"),y:i("y"),yy:i("y")},preparse:function(e){return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g,(function(e){return n[e]})).replace(/،/g,",")},postformat:function(e){return e.replace(/\d/g,(function(e){return t[e]})).replace(/,/g,"،")},week:{dow:6,doy:12}})}(n(41655))},20051:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={1:"-inci",5:"-inci",8:"-inci",70:"-inci",80:"-inci",2:"-nci",7:"-nci",20:"-nci",50:"-nci",3:"-üncü",4:"-üncü",100:"-üncü",6:"-ncı",9:"-uncu",10:"-uncu",30:"-uncu",60:"-ıncı",90:"-ıncı"};e.defineLocale("az",{months:"yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr".split("_"),monthsShort:"yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek".split("_"),weekdays:"Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə".split("_"),weekdaysShort:"Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən".split("_"),weekdaysMin:"Bz_BE_ÇA_Çə_CA_Cü_Şə".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[bugün saat] LT",nextDay:"[sabah saat] LT",nextWeek:"[gələn həftə] dddd [saat] LT",lastDay:"[dünən] LT",lastWeek:"[keçən həftə] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s sonra",past:"%s əvvəl",s:"bir neçə saniyə",ss:"%d saniyə",m:"bir dəqiqə",mm:"%d dəqiqə",h:"bir saat",hh:"%d saat",d:"bir gün",dd:"%d gün",M:"bir ay",MM:"%d ay",y:"bir il",yy:"%d il"},meridiemParse:/gecə|səhər|gündüz|axşam/,isPM:function(e){return/^(gündüz|axşam)$/.test(e)},meridiem:function(e,t,n){return e<4?"gecə":e<12?"səhər":e<17?"gündüz":"axşam"},dayOfMonthOrdinalParse:/\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,ordinal:function(e){if(0===e)return e+"-ıncı";var n=e%10,r=e%100-n,o=e>=100?100:null;return e+(t[n]||t[r]||t[o])},week:{dow:1,doy:7}})}(n(41655))},23813:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
function t(e,t){var n=e.split("_");return t%10==1&&t%100!=11?n[0]:t%10>=2&&t%10<=4&&(t%100<10||t%100>=20)?n[1]:n[2]}function n(e,n,r){return"m"===r?n?"хвіліна":"хвіліну":"h"===r?n?"гадзіна":"гадзіну":e+" "+t({ss:n?"секунда_секунды_секунд":"секунду_секунды_секунд",mm:n?"хвіліна_хвіліны_хвілін":"хвіліну_хвіліны_хвілін",hh:n?"гадзіна_гадзіны_гадзін":"гадзіну_гадзіны_гадзін",dd:"дзень_дні_дзён",MM:"месяц_месяцы_месяцаў",yy:"год_гады_гадоў"}[r],+e)}e.defineLocale("be",{months:{format:"студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня".split("_"),standalone:"студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань".split("_")},monthsShort:"студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж".split("_"),weekdays:{format:"нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу".split("_"),standalone:"нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота".split("_"),isFormat:/\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/},weekdaysShort:"нд_пн_ат_ср_чц_пт_сб".split("_"),weekdaysMin:"нд_пн_ат_ср_чц_пт_сб".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY г.",LLL:"D MMMM YYYY г., HH:mm",LLLL:"dddd, D MMMM YYYY г., HH:mm"},calendar:{sameDay:"[Сёння ў] LT",nextDay:"[Заўтра ў] LT",lastDay:"[Учора ў] LT",nextWeek:function(){return"[У] dddd [ў] LT"},lastWeek:function(){switch(this.day()){case 0:case 3:case 5:case 6:return"[У мінулую] dddd [ў] LT";case 1:case 2:case 4:return"[У мінулы] dddd [ў] LT"}},sameElse:"L"},relativeTime:{future:"праз %s",past:"%s таму",s:"некалькі секунд",m:n,mm:n,h:n,hh:n,d:"дзень",dd:n,M:"месяц",MM:n,y:"год",yy:n},meridiemParse:/ночы|раніцы|дня|вечара/,isPM:function(e){return/^(дня|вечара)$/.test(e)},meridiem:function(e,t,n){return e<4?"ночы":e<12?"раніцы":e<17?"дня":"вечара"},dayOfMonthOrdinalParse:/\d{1,2}-(і|ы|га)/,ordinal:function(e,t){switch(t){case"M":case"d":case"DDD":case"w":case"W":return e%10!=2&&e%10!=3||e%100==12||e%100==13?e+"-ы":e+"-і";case"D":return e+"-га";default:return e}},week:{dow:1,doy:7}})}(n(41655))},64323:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("bg",{months:"януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември".split("_"),monthsShort:"яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек".split("_"),weekdays:"неделя_понеделник_вторник_сряда_четвъртък_петък_събота".split("_"),weekdaysShort:"нед_пон_вто_сря_чет_пет_съб".split("_"),weekdaysMin:"нд_пн_вт_ср_чт_пт_сб".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[Днес в] LT",nextDay:"[Утре в] LT",nextWeek:"dddd [в] LT",lastDay:"[Вчера в] LT",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return"[Миналата] dddd [в] LT";case 1:case 2:case 4:case 5:return"[Миналия] dddd [в] LT"}},sameElse:"L"},relativeTime:{future:"след %s",past:"преди %s",s:"няколко секунди",ss:"%d секунди",m:"минута",mm:"%d минути",h:"час",hh:"%d часа",d:"ден",dd:"%d дена",w:"седмица",ww:"%d седмици",M:"месец",MM:"%d месеца",y:"година",yy:"%d години"},dayOfMonthOrdinalParse:/\d{1,2}-(ев|ен|ти|ви|ри|ми)/,ordinal:function(e){var t=e%10,n=e%100;return 0===e?e+"-ев":0===n?e+"-ен":n>10&&n<20?e+"-ти":1===t?e+"-ви":2===t?e+"-ри":7===t||8===t?e+"-ми":e+"-ти"},week:{dow:1,doy:7}})}(n(41655))},57837:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("bm",{months:"Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo".split("_"),monthsShort:"Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des".split("_"),weekdays:"Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri".split("_"),weekdaysShort:"Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib".split("_"),weekdaysMin:"Ka_Nt_Ta_Ar_Al_Ju_Si".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"MMMM [tile] D [san] YYYY",LLL:"MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm",LLLL:"dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm"},calendar:{sameDay:"[Bi lɛrɛ] LT",nextDay:"[Sini lɛrɛ] LT",nextWeek:"dddd [don lɛrɛ] LT",lastDay:"[Kunu lɛrɛ] LT",lastWeek:"dddd [tɛmɛnen lɛrɛ] LT",sameElse:"L"},relativeTime:{future:"%s kɔnɔ",past:"a bɛ %s bɔ",s:"sanga dama dama",ss:"sekondi %d",m:"miniti kelen",mm:"miniti %d",h:"lɛrɛ kelen",hh:"lɛrɛ %d",d:"tile kelen",dd:"tile %d",M:"kalo kelen",MM:"kalo %d",y:"san kelen",yy:"san %d"},week:{dow:1,doy:4}})}(n(41655))},25959:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={1:"১",2:"২",3:"৩",4:"৪",5:"৫",6:"৬",7:"৭",8:"৮",9:"৯",0:"০"},n={"১":"1","২":"2","৩":"3","৪":"4","৫":"5","৬":"6","৭":"7","৮":"8","৯":"9","০":"0"};e.defineLocale("bn-bd",{months:"জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর".split("_"),monthsShort:"জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে".split("_"),weekdays:"রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার".split("_"),weekdaysShort:"রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি".split("_"),weekdaysMin:"রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি".split("_"),longDateFormat:{LT:"A h:mm সময়",LTS:"A h:mm:ss সময়",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm সময়",LLLL:"dddd, D MMMM YYYY, A h:mm সময়"},calendar:{sameDay:"[আজ] LT",nextDay:"[আগামীকাল] LT",nextWeek:"dddd, LT",lastDay:"[গতকাল] LT",lastWeek:"[গত] dddd, LT",sameElse:"L"},relativeTime:{future:"%s পরে",past:"%s আগে",s:"কয়েক সেকেন্ড",ss:"%d সেকেন্ড",m:"এক মিনিট",mm:"%d মিনিট",h:"এক ঘন্টা",hh:"%d ঘন্টা",d:"এক দিন",dd:"%d দিন",M:"এক মাস",MM:"%d মাস",y:"এক বছর",yy:"%d বছর"},preparse:function(e){return e.replace(/[১২৩৪৫৬৭৮৯০]/g,(function(e){return n[e]}))},postformat:function(e){return e.replace(/\d/g,(function(e){return t[e]}))},meridiemParse:/রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,meridiemHour:function(e,t){return 12===e&&(e=0),"রাত"===t?e<4?e:e+12:"ভোর"===t||"সকাল"===t?e:"দুপুর"===t?e>=3?e:e+12:"বিকাল"===t||"সন্ধ্যা"===t?e+12:void 0},meridiem:function(e,t,n){return e<4?"রাত":e<6?"ভোর":e<12?"সকাল":e<15?"দুপুর":e<18?"বিকাল":e<20?"সন্ধ্যা":"রাত"},week:{dow:0,doy:6}})}(n(41655))},75780:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={1:"১",2:"২",3:"৩",4:"৪",5:"৫",6:"৬",7:"৭",8:"৮",9:"৯",0:"০"},n={"১":"1","২":"2","৩":"3","৪":"4","৫":"5","৬":"6","৭":"7","৮":"8","৯":"9","০":"0"};e.defineLocale("bn",{months:"জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর".split("_"),monthsShort:"জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে".split("_"),weekdays:"রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার".split("_"),weekdaysShort:"রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি".split("_"),weekdaysMin:"রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি".split("_"),longDateFormat:{LT:"A h:mm সময়",LTS:"A h:mm:ss সময়",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm সময়",LLLL:"dddd, D MMMM YYYY, A h:mm সময়"},calendar:{sameDay:"[আজ] LT",nextDay:"[আগামীকাল] LT",nextWeek:"dddd, LT",lastDay:"[গতকাল] LT",lastWeek:"[গত] dddd, LT",sameElse:"L"},relativeTime:{future:"%s পরে",past:"%s আগে",s:"কয়েক সেকেন্ড",ss:"%d সেকেন্ড",m:"এক মিনিট",mm:"%d মিনিট",h:"এক ঘন্টা",hh:"%d ঘন্টা",d:"এক দিন",dd:"%d দিন",M:"এক মাস",MM:"%d মাস",y:"এক বছর",yy:"%d বছর"},preparse:function(e){return e.replace(/[১২৩৪৫৬৭৮৯০]/g,(function(e){return n[e]}))},postformat:function(e){return e.replace(/\d/g,(function(e){return t[e]}))},meridiemParse:/রাত|সকাল|দুপুর|বিকাল|রাত/,meridiemHour:function(e,t){return 12===e&&(e=0),"রাত"===t&&e>=4||"দুপুর"===t&&e<5||"বিকাল"===t?e+12:e},meridiem:function(e,t,n){return e<4?"রাত":e<10?"সকাল":e<17?"দুপুর":e<20?"বিকাল":"রাত"},week:{dow:0,doy:6}})}(n(41655))},81451:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={1:"༡",2:"༢",3:"༣",4:"༤",5:"༥",6:"༦",7:"༧",8:"༨",9:"༩",0:"༠"},n={"༡":"1","༢":"2","༣":"3","༤":"4","༥":"5","༦":"6","༧":"7","༨":"8","༩":"9","༠":"0"};e.defineLocale("bo",{months:"ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ".split("_"),monthsShort:"ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12".split("_"),monthsShortRegex:/^(ཟླ་\d{1,2})/,monthsParseExact:!0,weekdays:"གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་".split("_"),weekdaysShort:"ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་".split("_"),weekdaysMin:"ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm",LLLL:"dddd, D MMMM YYYY, A h:mm"},calendar:{sameDay:"[དི་རིང] LT",nextDay:"[སང་ཉིན] LT",nextWeek:"[བདུན་ཕྲག་རྗེས་མ], LT",lastDay:"[ཁ་སང] LT",lastWeek:"[བདུན་ཕྲག་མཐའ་མ] dddd, LT",sameElse:"L"},relativeTime:{future:"%s ལ་",past:"%s སྔན་ལ",s:"ལམ་སང",ss:"%d སྐར་ཆ།",m:"སྐར་མ་གཅིག",mm:"%d སྐར་མ",h:"ཆུ་ཚོད་གཅིག",hh:"%d ཆུ་ཚོད",d:"ཉིན་གཅིག",dd:"%d ཉིན་",M:"ཟླ་བ་གཅིག",MM:"%d ཟླ་བ",y:"ལོ་གཅིག",yy:"%d ལོ"},preparse:function(e){return e.replace(/[༡༢༣༤༥༦༧༨༩༠]/g,(function(e){return n[e]}))},postformat:function(e){return e.replace(/\d/g,(function(e){return t[e]}))},meridiemParse:/མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,meridiemHour:function(e,t){return 12===e&&(e=0),"མཚན་མོ"===t&&e>=4||"ཉིན་གུང"===t&&e<5||"དགོང་དག"===t?e+12:e},meridiem:function(e,t,n){return e<4?"མཚན་མོ":e<10?"ཞོགས་ཀས":e<17?"ཉིན་གུང":e<20?"དགོང་དག":"མཚན་མོ"},week:{dow:0,doy:6}})}(n(41655))},76480:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
function t(e,t,n){return e+" "+o({mm:"munutenn",MM:"miz",dd:"devezh"}[n],e)}function n(e){switch(r(e)){case 1:case 3:case 4:case 5:case 9:return e+" bloaz";default:return e+" vloaz"}}function r(e){return e>9?r(e%10):e}function o(e,t){return 2===t?i(e):e}function i(e){var t={m:"v",b:"v",d:"z"};return void 0===t[e.charAt(0)]?e:t[e.charAt(0)]+e.substring(1)}var a=[/^gen/i,/^c[ʼ\']hwe/i,/^meu/i,/^ebr/i,/^mae/i,/^(mez|eve)/i,/^gou/i,/^eos/i,/^gwe/i,/^her/i,/^du/i,/^ker/i],s=/^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,l=/^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,c=/^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,u=[/^sul/i,/^lun/i,/^meurzh/i,/^merc[ʼ\']her/i,/^yaou/i,/^gwener/i,/^sadorn/i],d=[/^Sul/i,/^Lun/i,/^Meu/i,/^Mer/i,/^Yao/i,/^Gwe/i,/^Sad/i],p=[/^Su/i,/^Lu/i,/^Me([^r]|$)/i,/^Mer/i,/^Ya/i,/^Gw/i,/^Sa/i];e.defineLocale("br",{months:"Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu".split("_"),monthsShort:"Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker".split("_"),weekdays:"Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn".split("_"),weekdaysShort:"Sul_Lun_Meu_Mer_Yao_Gwe_Sad".split("_"),weekdaysMin:"Su_Lu_Me_Mer_Ya_Gw_Sa".split("_"),weekdaysParse:p,fullWeekdaysParse:u,shortWeekdaysParse:d,minWeekdaysParse:p,monthsRegex:s,monthsShortRegex:s,monthsStrictRegex:l,monthsShortStrictRegex:c,monthsParse:a,longMonthsParse:a,shortMonthsParse:a,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [a viz] MMMM YYYY",LLL:"D [a viz] MMMM YYYY HH:mm",LLLL:"dddd, D [a viz] MMMM YYYY HH:mm"},calendar:{sameDay:"[Hiziv da] LT",nextDay:"[Warcʼhoazh da] LT",nextWeek:"dddd [da] LT",lastDay:"[Decʼh da] LT",lastWeek:"dddd [paset da] LT",sameElse:"L"},relativeTime:{future:"a-benn %s",past:"%s ʼzo",s:"un nebeud segondennoù",ss:"%d eilenn",m:"ur vunutenn",mm:t,h:"un eur",hh:"%d eur",d:"un devezh",dd:t,M:"ur miz",MM:t,y:"ur bloaz",yy:n},dayOfMonthOrdinalParse:/\d{1,2}(añ|vet)/,ordinal:function(e){return e+(1===e?"añ":"vet")},week:{dow:1,doy:4},meridiemParse:/a.m.|g.m./,isPM:function(e){return"g.m."===e},meridiem:function(e,t,n){return e<12?"a.m.":"g.m."}})}(n(41655))},91607:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
function t(e,t,n,r){if("m"===n)return t?"jedna minuta":r?"jednu minutu":"jedne minute"}function n(e,t,n){var r=e+" ";switch(n){case"ss":return r+=1===e?"sekunda":2===e||3===e||4===e?"sekunde":"sekundi";case"mm":return r+=1===e?"minuta":2===e||3===e||4===e?"minute":"minuta";case"h":return"jedan sat";case"hh":return r+=1===e?"sat":2===e||3===e||4===e?"sata":"sati";case"dd":return r+=1===e?"dan":"dana";case"MM":return r+=1===e?"mjesec":2===e||3===e||4===e?"mjeseca":"mjeseci";case"yy":return r+=1===e?"godina":2===e||3===e||4===e?"godine":"godina"}}e.defineLocale("bs",{months:"januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._čet._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_če_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[jučer u] LT",lastWeek:function(){switch(this.day()){case 0:case 3:return"[prošlu] dddd [u] LT";case 6:return"[prošle] [subote] [u] LT";case 1:case 2:case 4:case 5:return"[prošli] dddd [u] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"par sekundi",ss:n,m:t,mm:n,h:n,hh:n,d:"dan",dd:n,M:"mjesec",MM:n,y:"godinu",yy:n},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})}(n(41655))},23232:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("ca",{months:{standalone:"gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split("_"),format:"de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split("_"),isFormat:/D[oD]?(\s)+MMMM/},monthsShort:"gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.".split("_"),monthsParseExact:!0,weekdays:"diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte".split("_"),weekdaysShort:"dg._dl._dt._dc._dj._dv._ds.".split("_"),weekdaysMin:"dg_dl_dt_dc_dj_dv_ds".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [de] YYYY",ll:"D MMM YYYY",LLL:"D MMMM [de] YYYY [a les] H:mm",lll:"D MMM YYYY, H:mm",LLLL:"dddd D MMMM [de] YYYY [a les] H:mm",llll:"ddd D MMM YYYY, H:mm"},calendar:{sameDay:function(){return"[avui a "+(1!==this.hours()?"les":"la")+"] LT"},nextDay:function(){return"[demà a "+(1!==this.hours()?"les":"la")+"] LT"},nextWeek:function(){return"dddd [a "+(1!==this.hours()?"les":"la")+"] LT"},lastDay:function(){return"[ahir a "+(1!==this.hours()?"les":"la")+"] LT"},lastWeek:function(){return"[el] dddd [passat a "+(1!==this.hours()?"les":"la")+"] LT"},sameElse:"L"},relativeTime:{future:"d'aquí %s",past:"fa %s",s:"uns segons",ss:"%d segons",m:"un minut",mm:"%d minuts",h:"una hora",hh:"%d hores",d:"un dia",dd:"%d dies",M:"un mes",MM:"%d mesos",y:"un any",yy:"%d anys"},dayOfMonthOrdinalParse:/\d{1,2}(r|n|t|è|a)/,ordinal:function(e,t){var n=1===e?"r":2===e?"n":3===e?"r":4===e?"t":"è";return"w"!==t&&"W"!==t||(n="a"),e+n},week:{dow:1,doy:4}})}(n(41655))},91034:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={standalone:"leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec".split("_"),format:"ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince".split("_"),isFormat:/DD?[o.]?(\[[^\[\]]*\]|\s)+MMMM/},n="led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro".split("_"),r=[/^led/i,/^úno/i,/^bře/i,/^dub/i,/^kvě/i,/^(čvn|červen$|června)/i,/^(čvc|červenec|července)/i,/^srp/i,/^zář/i,/^říj/i,/^lis/i,/^pro/i],o=/^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;function i(e){return e>1&&e<5&&1!=~~(e/10)}function a(e,t,n,r){var o=e+" ";switch(n){case"s":return t||r?"pár sekund":"pár sekundami";case"ss":return t||r?o+(i(e)?"sekundy":"sekund"):o+"sekundami";case"m":return t?"minuta":r?"minutu":"minutou";case"mm":return t||r?o+(i(e)?"minuty":"minut"):o+"minutami";case"h":return t?"hodina":r?"hodinu":"hodinou";case"hh":return t||r?o+(i(e)?"hodiny":"hodin"):o+"hodinami";case"d":return t||r?"den":"dnem";case"dd":return t||r?o+(i(e)?"dny":"dní"):o+"dny";case"M":return t||r?"měsíc":"měsícem";case"MM":return t||r?o+(i(e)?"měsíce":"měsíců"):o+"měsíci";case"y":return t||r?"rok":"rokem";case"yy":return t||r?o+(i(e)?"roky":"let"):o+"lety"}}e.defineLocale("cs",{months:t,monthsShort:n,monthsRegex:o,monthsShortRegex:o,monthsStrictRegex:/^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,monthsShortStrictRegex:/^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,monthsParse:r,longMonthsParse:r,shortMonthsParse:r,weekdays:"neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota".split("_"),weekdaysShort:"ne_po_út_st_čt_pá_so".split("_"),weekdaysMin:"ne_po_út_st_čt_pá_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd D. MMMM YYYY H:mm",l:"D. M. YYYY"},calendar:{sameDay:"[dnes v] LT",nextDay:"[zítra v] LT",nextWeek:function(){switch(this.day()){case 0:return"[v neděli v] LT";case 1:case 2:return"[v] dddd [v] LT";case 3:return"[ve středu v] LT";case 4:return"[ve čtvrtek v] LT";case 5:return"[v pátek v] LT";case 6:return"[v sobotu v] LT"}},lastDay:"[včera v] LT",lastWeek:function(){switch(this.day()){case 0:return"[minulou neděli v] LT";case 1:case 2:return"[minulé] dddd [v] LT";case 3:return"[minulou středu v] LT";case 4:case 5:return"[minulý] dddd [v] LT";case 6:return"[minulou sobotu v] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"před %s",s:a,ss:a,m:a,mm:a,h:a,hh:a,d:a,dd:a,M:a,MM:a,y:a,yy:a},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})}(n(41655))},54213:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("cv",{months:"кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав".split("_"),monthsShort:"кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш".split("_"),weekdays:"вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун".split("_"),weekdaysShort:"выр_тун_ытл_юн_кӗҫ_эрн_шӑм".split("_"),weekdaysMin:"вр_тн_ыт_юн_кҫ_эр_шм".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]",LLL:"YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm",LLLL:"dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm"},calendar:{sameDay:"[Паян] LT [сехетре]",nextDay:"[Ыран] LT [сехетре]",lastDay:"[Ӗнер] LT [сехетре]",nextWeek:"[Ҫитес] dddd LT [сехетре]",lastWeek:"[Иртнӗ] dddd LT [сехетре]",sameElse:"L"},relativeTime:{future:function(e){return e+(/сехет$/i.exec(e)?"рен":/ҫул$/i.exec(e)?"тан":"ран")},past:"%s каялла",s:"пӗр-ик ҫеккунт",ss:"%d ҫеккунт",m:"пӗр минут",mm:"%d минут",h:"пӗр сехет",hh:"%d сехет",d:"пӗр кун",dd:"%d кун",M:"пӗр уйӑх",MM:"%d уйӑх",y:"пӗр ҫул",yy:"%d ҫул"},dayOfMonthOrdinalParse:/\d{1,2}-мӗш/,ordinal:"%d-мӗш",week:{dow:1,doy:7}})}(n(41655))},95800:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("cy",{months:"Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr".split("_"),monthsShort:"Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag".split("_"),weekdays:"Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn".split("_"),weekdaysShort:"Sul_Llun_Maw_Mer_Iau_Gwe_Sad".split("_"),weekdaysMin:"Su_Ll_Ma_Me_Ia_Gw_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Heddiw am] LT",nextDay:"[Yfory am] LT",nextWeek:"dddd [am] LT",lastDay:"[Ddoe am] LT",lastWeek:"dddd [diwethaf am] LT",sameElse:"L"},relativeTime:{future:"mewn %s",past:"%s yn ôl",s:"ychydig eiliadau",ss:"%d eiliad",m:"munud",mm:"%d munud",h:"awr",hh:"%d awr",d:"diwrnod",dd:"%d diwrnod",M:"mis",MM:"%d mis",y:"blwyddyn",yy:"%d flynedd"},dayOfMonthOrdinalParse:/\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,ordinal:function(e){var t="";return e>20?t=40===e||50===e||60===e||80===e||100===e?"fed":"ain":e>0&&(t=["","af","il","ydd","ydd","ed","ed","ed","fed","fed","fed","eg","fed","eg","eg","fed","eg","eg","fed","eg","fed"][e]),e+t},week:{dow:1,doy:4}})}(n(41655))},40739:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("da",{months:"januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),weekdays:"søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),weekdaysShort:"søn_man_tir_ons_tor_fre_lør".split("_"),weekdaysMin:"sø_ma_ti_on_to_fr_lø".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd [d.] D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[i dag kl.] LT",nextDay:"[i morgen kl.] LT",nextWeek:"på dddd [kl.] LT",lastDay:"[i går kl.] LT",lastWeek:"[i] dddd[s kl.] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s siden",s:"få sekunder",ss:"%d sekunder",m:"et minut",mm:"%d minutter",h:"en time",hh:"%d timer",d:"en dag",dd:"%d dage",M:"en måned",MM:"%d måneder",y:"et år",yy:"%d år"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})}(n(41655))},82181:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
function t(e,t,n,r){var o={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],w:["eine Woche","einer Woche"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return t?o[n][0]:o[n][1]}e.defineLocale("de-at",{months:"Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:t,mm:"%d Minuten",h:t,hh:"%d Stunden",d:t,dd:t,w:t,ww:"%d Wochen",M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})}(n(41655))},61339:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
function t(e,t,n,r){var o={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],w:["eine Woche","einer Woche"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return t?o[n][0]:o[n][1]}e.defineLocale("de-ch",{months:"Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:t,mm:"%d Minuten",h:t,hh:"%d Stunden",d:t,dd:t,w:t,ww:"%d Wochen",M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})}(n(41655))},66951:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
function t(e,t,n,r){var o={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],w:["eine Woche","einer Woche"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return t?o[n][0]:o[n][1]}e.defineLocale("de",{months:"Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:t,mm:"%d Minuten",h:t,hh:"%d Stunden",d:t,dd:t,w:t,ww:"%d Wochen",M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})}(n(41655))},16938:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t=["ޖެނުއަރީ","ފެބްރުއަރީ","މާރިޗު","އޭޕްރީލު","މޭ","ޖޫން","ޖުލައި","އޯގަސްޓު","ސެޕްޓެމްބަރު","އޮކްޓޯބަރު","ނޮވެމްބަރު","ޑިސެމްބަރު"],n=["އާދިއްތަ","ހޯމަ","އަންގާރަ","ބުދަ","ބުރާސްފަތި","ހުކުރު","ހޮނިހިރު"];e.defineLocale("dv",{months:t,monthsShort:t,weekdays:n,weekdaysShort:n,weekdaysMin:"އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/M/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/މކ|މފ/,isPM:function(e){return"މފ"===e},meridiem:function(e,t,n){return e<12?"މކ":"މފ"},calendar:{sameDay:"[މިއަދު] LT",nextDay:"[މާދަމާ] LT",nextWeek:"dddd LT",lastDay:"[އިއްޔެ] LT",lastWeek:"[ފާއިތުވި] dddd LT",sameElse:"L"},relativeTime:{future:"ތެރޭގައި %s",past:"ކުރިން %s",s:"ސިކުންތުކޮޅެއް",ss:"d% ސިކުންތު",m:"މިނިޓެއް",mm:"މިނިޓު %d",h:"ގަޑިއިރެއް",hh:"ގަޑިއިރު %d",d:"ދުވަހެއް",dd:"ދުވަސް %d",M:"މަހެއް",MM:"މަސް %d",y:"އަހަރެއް",yy:"އަހަރު %d"},preparse:function(e){return e.replace(/،/g,",")},postformat:function(e){return e.replace(/,/g,"،")},week:{dow:7,doy:12}})}(n(41655))},59573:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
function t(e){return"undefined"!=typeof Function&&e instanceof Function||"[object Function]"===Object.prototype.toString.call(e)}e.defineLocale("el",{monthsNominativeEl:"Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος".split("_"),monthsGenitiveEl:"Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου".split("_"),months:function(e,t){return e?"string"==typeof t&&/D/.test(t.substring(0,t.indexOf("MMMM")))?this._monthsGenitiveEl[e.month()]:this._monthsNominativeEl[e.month()]:this._monthsNominativeEl},monthsShort:"Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ".split("_"),weekdays:"Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο".split("_"),weekdaysShort:"Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ".split("_"),weekdaysMin:"Κυ_Δε_Τρ_Τε_Πε_Πα_Σα".split("_"),meridiem:function(e,t,n){return e>11?n?"μμ":"ΜΜ":n?"πμ":"ΠΜ"},isPM:function(e){return"μ"===(e+"").toLowerCase()[0]},meridiemParse:/[ΠΜ]\.?Μ?\.?/i,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendarEl:{sameDay:"[Σήμερα {}] LT",nextDay:"[Αύριο {}] LT",nextWeek:"dddd [{}] LT",lastDay:"[Χθες {}] LT",lastWeek:function(){return 6===this.day()?"[το προηγούμενο] dddd [{}] LT":"[την προηγούμενη] dddd [{}] LT"},sameElse:"L"},calendar:function(e,n){var r=this._calendarEl[e],o=n&&n.hours();return t(r)&&(r=r.apply(n)),r.replace("{}",o%12==1?"στη":"στις")},relativeTime:{future:"σε %s",past:"%s πριν",s:"λίγα δευτερόλεπτα",ss:"%d δευτερόλεπτα",m:"ένα λεπτό",mm:"%d λεπτά",h:"μία ώρα",hh:"%d ώρες",d:"μία μέρα",dd:"%d μέρες",M:"ένας μήνας",MM:"%d μήνες",y:"ένας χρόνος",yy:"%d χρόνια"},dayOfMonthOrdinalParse:/\d{1,2}η/,ordinal:"%dη",week:{dow:1,doy:4}})}(n(41655))},62458:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("en-au",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10;return e+(1==~~(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th")},week:{dow:0,doy:4}})}(n(41655))},51816:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("en-ca",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"YYYY-MM-DD",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10;return e+(1==~~(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th")}})}(n(41655))},8069:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("en-gb",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10;return e+(1==~~(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th")},week:{dow:1,doy:4}})}(n(41655))},15586:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("en-ie",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10;return e+(1==~~(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th")},week:{dow:1,doy:4}})}(n(41655))},60009:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("en-il",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10;return e+(1==~~(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th")}})}(n(41655))},51207:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("en-in",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10;return e+(1==~~(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th")},week:{dow:0,doy:6}})}(n(41655))},83724:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("en-nz",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10;return e+(1==~~(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th")},week:{dow:1,doy:4}})}(n(41655))},24334:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("en-sg",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10;return e+(1==~~(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th")},week:{dow:1,doy:4}})}(n(41655))},1292:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("eo",{months:"januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro".split("_"),monthsShort:"jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec".split("_"),weekdays:"dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato".split("_"),weekdaysShort:"dim_lun_mard_merk_ĵaŭ_ven_sab".split("_"),weekdaysMin:"di_lu_ma_me_ĵa_ve_sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"[la] D[-an de] MMMM, YYYY",LLL:"[la] D[-an de] MMMM, YYYY HH:mm",LLLL:"dddd[n], [la] D[-an de] MMMM, YYYY HH:mm",llll:"ddd, [la] D[-an de] MMM, YYYY HH:mm"},meridiemParse:/[ap]\.t\.m/i,isPM:function(e){return"p"===e.charAt(0).toLowerCase()},meridiem:function(e,t,n){return e>11?n?"p.t.m.":"P.T.M.":n?"a.t.m.":"A.T.M."},calendar:{sameDay:"[Hodiaŭ je] LT",nextDay:"[Morgaŭ je] LT",nextWeek:"dddd[n je] LT",lastDay:"[Hieraŭ je] LT",lastWeek:"[pasintan] dddd[n je] LT",sameElse:"L"},relativeTime:{future:"post %s",past:"antaŭ %s",s:"kelkaj sekundoj",ss:"%d sekundoj",m:"unu minuto",mm:"%d minutoj",h:"unu horo",hh:"%d horoj",d:"unu tago",dd:"%d tagoj",M:"unu monato",MM:"%d monatoj",y:"unu jaro",yy:"%d jaroj"},dayOfMonthOrdinalParse:/\d{1,2}a/,ordinal:"%da",week:{dow:1,doy:7}})}(n(41655))},61452:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),n="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),r=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],o=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;e.defineLocale("es-do",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,r){return e?/-MMM-/.test(r)?n[e.month()]:t[e.month()]:t},monthsRegex:o,monthsShortRegex:o,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:r,longMonthsParse:r,shortMonthsParse:r,weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY h:mm A",LLLL:"dddd, D [de] MMMM [de] YYYY h:mm A"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[mañana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",w:"una semana",ww:"%d semanas",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})}(n(41655))},94444:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),n="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),r=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],o=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;e.defineLocale("es-mx",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,r){return e?/-MMM-/.test(r)?n[e.month()]:t[e.month()]:t},monthsRegex:o,monthsShortRegex:o,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:r,longMonthsParse:r,shortMonthsParse:r,weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[mañana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",w:"una semana",ww:"%d semanas",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:0,doy:4},invalidDate:"Fecha inválida"})}(n(41655))},81285:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),n="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),r=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],o=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;e.defineLocale("es-us",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,r){return e?/-MMM-/.test(r)?n[e.month()]:t[e.month()]:t},monthsRegex:o,monthsShortRegex:o,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:r,longMonthsParse:r,shortMonthsParse:r,weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"MM/DD/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY h:mm A",LLLL:"dddd, D [de] MMMM [de] YYYY h:mm A"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[mañana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",w:"una semana",ww:"%d semanas",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:0,doy:6}})}(n(41655))},66328:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),n="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),r=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],o=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;e.defineLocale("es",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,r){return e?/-MMM-/.test(r)?n[e.month()]:t[e.month()]:t},monthsRegex:o,monthsShortRegex:o,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:r,longMonthsParse:r,shortMonthsParse:r,weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[mañana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",w:"una semana",ww:"%d semanas",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4},invalidDate:"Fecha inválida"})}(n(41655))},7181:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
function t(e,t,n,r){var o={s:["mõne sekundi","mõni sekund","paar sekundit"],ss:[e+"sekundi",e+"sekundit"],m:["ühe minuti","üks minut"],mm:[e+" minuti",e+" minutit"],h:["ühe tunni","tund aega","üks tund"],hh:[e+" tunni",e+" tundi"],d:["ühe päeva","üks päev"],M:["kuu aja","kuu aega","üks kuu"],MM:[e+" kuu",e+" kuud"],y:["ühe aasta","aasta","üks aasta"],yy:[e+" aasta",e+" aastat"]};return t?o[n][2]?o[n][2]:o[n][1]:r?o[n][0]:o[n][1]}e.defineLocale("et",{months:"jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember".split("_"),monthsShort:"jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets".split("_"),weekdays:"pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev".split("_"),weekdaysShort:"P_E_T_K_N_R_L".split("_"),weekdaysMin:"P_E_T_K_N_R_L".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[Täna,] LT",nextDay:"[Homme,] LT",nextWeek:"[Järgmine] dddd LT",lastDay:"[Eile,] LT",lastWeek:"[Eelmine] dddd LT",sameElse:"L"},relativeTime:{future:"%s pärast",past:"%s tagasi",s:t,ss:t,m:t,mm:t,h:t,hh:t,d:t,dd:"%d päeva",M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})}(n(41655))},62830:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("eu",{months:"urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua".split("_"),monthsShort:"urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.".split("_"),monthsParseExact:!0,weekdays:"igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata".split("_"),weekdaysShort:"ig._al._ar._az._og._ol._lr.".split("_"),weekdaysMin:"ig_al_ar_az_og_ol_lr".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY[ko] MMMM[ren] D[a]",LLL:"YYYY[ko] MMMM[ren] D[a] HH:mm",LLLL:"dddd, YYYY[ko] MMMM[ren] D[a] HH:mm",l:"YYYY-M-D",ll:"YYYY[ko] MMM D[a]",lll:"YYYY[ko] MMM D[a] HH:mm",llll:"ddd, YYYY[ko] MMM D[a] HH:mm"},calendar:{sameDay:"[gaur] LT[etan]",nextDay:"[bihar] LT[etan]",nextWeek:"dddd LT[etan]",lastDay:"[atzo] LT[etan]",lastWeek:"[aurreko] dddd LT[etan]",sameElse:"L"},relativeTime:{future:"%s barru",past:"duela %s",s:"segundo batzuk",ss:"%d segundo",m:"minutu bat",mm:"%d minutu",h:"ordu bat",hh:"%d ordu",d:"egun bat",dd:"%d egun",M:"hilabete bat",MM:"%d hilabete",y:"urte bat",yy:"%d urte"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})}(n(41655))},19565:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={1:"۱",2:"۲",3:"۳",4:"۴",5:"۵",6:"۶",7:"۷",8:"۸",9:"۹",0:"۰"},n={"۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","۰":"0"};e.defineLocale("fa",{months:"ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر".split("_"),monthsShort:"ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر".split("_"),weekdays:"یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه".split("_"),weekdaysShort:"یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه".split("_"),weekdaysMin:"ی_د_س_چ_پ_ج_ش".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},meridiemParse:/قبل از ظهر|بعد از ظهر/,isPM:function(e){return/بعد از ظهر/.test(e)},meridiem:function(e,t,n){return e<12?"قبل از ظهر":"بعد از ظهر"},calendar:{sameDay:"[امروز ساعت] LT",nextDay:"[فردا ساعت] LT",nextWeek:"dddd [ساعت] LT",lastDay:"[دیروز ساعت] LT",lastWeek:"dddd [پیش] [ساعت] LT",sameElse:"L"},relativeTime:{future:"در %s",past:"%s پیش",s:"چند ثانیه",ss:"%d ثانیه",m:"یک دقیقه",mm:"%d دقیقه",h:"یک ساعت",hh:"%d ساعت",d:"یک روز",dd:"%d روز",M:"یک ماه",MM:"%d ماه",y:"یک سال",yy:"%d سال"},preparse:function(e){return e.replace(/[۰-۹]/g,(function(e){return n[e]})).replace(/،/g,",")},postformat:function(e){return e.replace(/\d/g,(function(e){return t[e]})).replace(/,/g,"،")},dayOfMonthOrdinalParse:/\d{1,2}م/,ordinal:"%dم",week:{dow:6,doy:12}})}(n(41655))},85541:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t="nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän".split(" "),n=["nolla","yhden","kahden","kolmen","neljän","viiden","kuuden",t[7],t[8],t[9]];function r(e,t,n,r){var i="";switch(n){case"s":return r?"muutaman sekunnin":"muutama sekunti";case"ss":i=r?"sekunnin":"sekuntia";break;case"m":return r?"minuutin":"minuutti";case"mm":i=r?"minuutin":"minuuttia";break;case"h":return r?"tunnin":"tunti";case"hh":i=r?"tunnin":"tuntia";break;case"d":return r?"päivän":"päivä";case"dd":i=r?"päivän":"päivää";break;case"M":return r?"kuukauden":"kuukausi";case"MM":i=r?"kuukauden":"kuukautta";break;case"y":return r?"vuoden":"vuosi";case"yy":i=r?"vuoden":"vuotta"}return i=o(e,r)+" "+i}function o(e,r){return e<10?r?n[e]:t[e]:e}e.defineLocale("fi",{months:"tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split("_"),monthsShort:"tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu".split("_"),weekdays:"sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split("_"),weekdaysShort:"su_ma_ti_ke_to_pe_la".split("_"),weekdaysMin:"su_ma_ti_ke_to_pe_la".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD.MM.YYYY",LL:"Do MMMM[ta] YYYY",LLL:"Do MMMM[ta] YYYY, [klo] HH.mm",LLLL:"dddd, Do MMMM[ta] YYYY, [klo] HH.mm",l:"D.M.YYYY",ll:"Do MMM YYYY",lll:"Do MMM YYYY, [klo] HH.mm",llll:"ddd, Do MMM YYYY, [klo] HH.mm"},calendar:{sameDay:"[tänään] [klo] LT",nextDay:"[huomenna] [klo] LT",nextWeek:"dddd [klo] LT",lastDay:"[eilen] [klo] LT",lastWeek:"[viime] dddd[na] [klo] LT",sameElse:"L"},relativeTime:{future:"%s päästä",past:"%s sitten",s:r,ss:r,m:r,mm:r,h:r,hh:r,d:r,dd:r,M:r,MM:r,y:r,yy:r},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})}(n(41655))},65661:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("fil",{months:"Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),monthsShort:"Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),weekdays:"Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),weekdaysShort:"Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),weekdaysMin:"Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"MM/D/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY HH:mm",LLLL:"dddd, MMMM DD, YYYY HH:mm"},calendar:{sameDay:"LT [ngayong araw]",nextDay:"[Bukas ng] LT",nextWeek:"LT [sa susunod na] dddd",lastDay:"LT [kahapon]",lastWeek:"LT [noong nakaraang] dddd",sameElse:"L"},relativeTime:{future:"sa loob ng %s",past:"%s ang nakalipas",s:"ilang segundo",ss:"%d segundo",m:"isang minuto",mm:"%d minuto",h:"isang oras",hh:"%d oras",d:"isang araw",dd:"%d araw",M:"isang buwan",MM:"%d buwan",y:"isang taon",yy:"%d taon"},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}})}(n(41655))},26087:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("fo",{months:"januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),weekdays:"sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur".split("_"),weekdaysShort:"sun_mán_týs_mik_hós_frí_ley".split("_"),weekdaysMin:"su_má_tý_mi_hó_fr_le".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D. MMMM, YYYY HH:mm"},calendar:{sameDay:"[Í dag kl.] LT",nextDay:"[Í morgin kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[Í gjár kl.] LT",lastWeek:"[síðstu] dddd [kl] LT",sameElse:"L"},relativeTime:{future:"um %s",past:"%s síðani",s:"fá sekund",ss:"%d sekundir",m:"ein minuttur",mm:"%d minuttir",h:"ein tími",hh:"%d tímar",d:"ein dagur",dd:"%d dagar",M:"ein mánaður",MM:"%d mánaðir",y:"eitt ár",yy:"%d ár"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})}(n(41655))},96581:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("fr-ca",{months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd’hui à] LT",nextDay:"[Demain à] LT",nextWeek:"dddd [à] LT",lastDay:"[Hier à] LT",lastWeek:"dddd [dernier à] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|e)/,ordinal:function(e,t){switch(t){default:case"M":case"Q":case"D":case"DDD":case"d":return e+(1===e?"er":"e");case"w":case"W":return e+(1===e?"re":"e")}}})}(n(41655))},81294:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("fr-ch",{months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd’hui à] LT",nextDay:"[Demain à] LT",nextWeek:"dddd [à] LT",lastDay:"[Hier à] LT",lastWeek:"dddd [dernier à] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|e)/,ordinal:function(e,t){switch(t){default:case"M":case"Q":case"D":case"DDD":case"d":return e+(1===e?"er":"e");case"w":case"W":return e+(1===e?"re":"e")}},week:{dow:1,doy:4}})}(n(41655))},25396:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t=/^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,n=/(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,r=/(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,o=[/^janv/i,/^févr/i,/^mars/i,/^avr/i,/^mai/i,/^juin/i,/^juil/i,/^août/i,/^sept/i,/^oct/i,/^nov/i,/^déc/i];e.defineLocale("fr",{months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),monthsRegex:r,monthsShortRegex:r,monthsStrictRegex:t,monthsShortStrictRegex:n,monthsParse:o,longMonthsParse:o,shortMonthsParse:o,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd’hui à] LT",nextDay:"[Demain à] LT",nextWeek:"dddd [à] LT",lastDay:"[Hier à] LT",lastWeek:"dddd [dernier à] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",w:"une semaine",ww:"%d semaines",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|)/,ordinal:function(e,t){switch(t){case"D":return e+(1===e?"er":"");default:case"M":case"Q":case"DDD":case"d":return e+(1===e?"er":"e");case"w":case"W":return e+(1===e?"re":"e")}},week:{dow:1,doy:4}})}(n(41655))},12533:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t="jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.".split("_"),n="jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_");e.defineLocale("fy",{months:"jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber".split("_"),monthsShort:function(e,r){return e?/-MMM-/.test(r)?n[e.month()]:t[e.month()]:t},monthsParseExact:!0,weekdays:"snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon".split("_"),weekdaysShort:"si._mo._ti._wo._to._fr._so.".split("_"),weekdaysMin:"Si_Mo_Ti_Wo_To_Fr_So".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[hjoed om] LT",nextDay:"[moarn om] LT",nextWeek:"dddd [om] LT",lastDay:"[juster om] LT",lastWeek:"[ôfrûne] dddd [om] LT",sameElse:"L"},relativeTime:{future:"oer %s",past:"%s lyn",s:"in pear sekonden",ss:"%d sekonden",m:"ien minút",mm:"%d minuten",h:"ien oere",hh:"%d oeren",d:"ien dei",dd:"%d dagen",M:"ien moanne",MM:"%d moannen",y:"ien jier",yy:"%d jierren"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?"ste":"de")},week:{dow:1,doy:4}})}(n(41655))},55796:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t=["Eanáir","Feabhra","Márta","Aibreán","Bealtaine","Meitheamh","Iúil","Lúnasa","Meán Fómhair","Deireadh Fómhair","Samhain","Nollaig"],n=["Ean","Feabh","Márt","Aib","Beal","Meith","Iúil","Lún","M.F.","D.F.","Samh","Noll"],r=["Dé Domhnaigh","Dé Luain","Dé Máirt","Dé Céadaoin","Déardaoin","Dé hAoine","Dé Sathairn"],o=["Domh","Luan","Máirt","Céad","Déar","Aoine","Sath"],i=["Do","Lu","Má","Cé","Dé","A","Sa"];e.defineLocale("ga",{months:t,monthsShort:n,monthsParseExact:!0,weekdays:r,weekdaysShort:o,weekdaysMin:i,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Inniu ag] LT",nextDay:"[Amárach ag] LT",nextWeek:"dddd [ag] LT",lastDay:"[Inné ag] LT",lastWeek:"dddd [seo caite] [ag] LT",sameElse:"L"},relativeTime:{future:"i %s",past:"%s ó shin",s:"cúpla soicind",ss:"%d soicind",m:"nóiméad",mm:"%d nóiméad",h:"uair an chloig",hh:"%d uair an chloig",d:"lá",dd:"%d lá",M:"mí",MM:"%d míonna",y:"bliain",yy:"%d bliain"},dayOfMonthOrdinalParse:/\d{1,2}(d|na|mh)/,ordinal:function(e){return e+(1===e?"d":e%10==2?"na":"mh")},week:{dow:1,doy:4}})}(n(41655))},50847:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t=["Am Faoilleach","An Gearran","Am Màrt","An Giblean","An Cèitean","An t-Ògmhios","An t-Iuchar","An Lùnastal","An t-Sultain","An Dàmhair","An t-Samhain","An Dùbhlachd"],n=["Faoi","Gear","Màrt","Gibl","Cèit","Ògmh","Iuch","Lùn","Sult","Dàmh","Samh","Dùbh"],r=["Didòmhnaich","Diluain","Dimàirt","Diciadain","Diardaoin","Dihaoine","Disathairne"],o=["Did","Dil","Dim","Dic","Dia","Dih","Dis"],i=["Dò","Lu","Mà","Ci","Ar","Ha","Sa"];e.defineLocale("gd",{months:t,monthsShort:n,monthsParseExact:!0,weekdays:r,weekdaysShort:o,weekdaysMin:i,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[An-diugh aig] LT",nextDay:"[A-màireach aig] LT",nextWeek:"dddd [aig] LT",lastDay:"[An-dè aig] LT",lastWeek:"dddd [seo chaidh] [aig] LT",sameElse:"L"},relativeTime:{future:"ann an %s",past:"bho chionn %s",s:"beagan diogan",ss:"%d diogan",m:"mionaid",mm:"%d mionaidean",h:"uair",hh:"%d uairean",d:"latha",dd:"%d latha",M:"mìos",MM:"%d mìosan",y:"bliadhna",yy:"%d bliadhna"},dayOfMonthOrdinalParse:/\d{1,2}(d|na|mh)/,ordinal:function(e){return e+(1===e?"d":e%10==2?"na":"mh")},week:{dow:1,doy:4}})}(n(41655))},60439:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("gl",{months:"xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro".split("_"),monthsShort:"xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"domingo_luns_martes_mércores_xoves_venres_sábado".split("_"),weekdaysShort:"dom._lun._mar._mér._xov._ven._sáb.".split("_"),weekdaysMin:"do_lu_ma_mé_xo_ve_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoxe "+(1!==this.hours()?"ás":"á")+"] LT"},nextDay:function(){return"[mañá "+(1!==this.hours()?"ás":"á")+"] LT"},nextWeek:function(){return"dddd ["+(1!==this.hours()?"ás":"a")+"] LT"},lastDay:function(){return"[onte "+(1!==this.hours()?"á":"a")+"] LT"},lastWeek:function(){return"[o] dddd [pasado "+(1!==this.hours()?"ás":"a")+"] LT"},sameElse:"L"},relativeTime:{future:function(e){return 0===e.indexOf("un")?"n"+e:"en "+e},past:"hai %s",s:"uns segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"unha hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})}(n(41655))},46514:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
function t(e,t,n,r){var o={s:["थोडया सॅकंडांनी","थोडे सॅकंड"],ss:[e+" सॅकंडांनी",e+" सॅकंड"],m:["एका मिणटान","एक मिनूट"],mm:[e+" मिणटांनी",e+" मिणटां"],h:["एका वरान","एक वर"],hh:[e+" वरांनी",e+" वरां"],d:["एका दिसान","एक दीस"],dd:[e+" दिसांनी",e+" दीस"],M:["एका म्हयन्यान","एक म्हयनो"],MM:[e+" म्हयन्यानी",e+" म्हयने"],y:["एका वर्सान","एक वर्स"],yy:[e+" वर्सांनी",e+" वर्सां"]};return r?o[n][0]:o[n][1]}e.defineLocale("gom-deva",{months:{standalone:"जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर".split("_"),format:"जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या".split("_"),isFormat:/MMMM(\s)+D[oD]?/},monthsShort:"जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.".split("_"),monthsParseExact:!0,weekdays:"आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार".split("_"),weekdaysShort:"आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.".split("_"),weekdaysMin:"आ_सो_मं_बु_ब्रे_सु_शे".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"A h:mm [वाजतां]",LTS:"A h:mm:ss [वाजतां]",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY A h:mm [वाजतां]",LLLL:"dddd, MMMM Do, YYYY, A h:mm [वाजतां]",llll:"ddd, D MMM YYYY, A h:mm [वाजतां]"},calendar:{sameDay:"[आयज] LT",nextDay:"[फाल्यां] LT",nextWeek:"[फुडलो] dddd[,] LT",lastDay:"[काल] LT",lastWeek:"[फाटलो] dddd[,] LT",sameElse:"L"},relativeTime:{future:"%s",past:"%s आदीं",s:t,ss:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\d{1,2}(वेर)/,ordinal:function(e,t){return"D"===t?e+"वेर":e},week:{dow:0,doy:3},meridiemParse:/राती|सकाळीं|दनपारां|सांजे/,meridiemHour:function(e,t){return 12===e&&(e=0),"राती"===t?e<4?e:e+12:"सकाळीं"===t?e:"दनपारां"===t?e>12?e:e+12:"सांजे"===t?e+12:void 0},meridiem:function(e,t,n){return e<4?"राती":e<12?"सकाळीं":e<16?"दनपारां":e<20?"सांजे":"राती"}})}(n(41655))},66525:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
function t(e,t,n,r){var o={s:["thoddea sekondamni","thodde sekond"],ss:[e+" sekondamni",e+" sekond"],m:["eka mintan","ek minut"],mm:[e+" mintamni",e+" mintam"],h:["eka voran","ek vor"],hh:[e+" voramni",e+" voram"],d:["eka disan","ek dis"],dd:[e+" disamni",e+" dis"],M:["eka mhoinean","ek mhoino"],MM:[e+" mhoineamni",e+" mhoine"],y:["eka vorsan","ek voros"],yy:[e+" vorsamni",e+" vorsam"]};return r?o[n][0]:o[n][1]}e.defineLocale("gom-latn",{months:{standalone:"Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr".split("_"),format:"Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea".split("_"),isFormat:/MMMM(\s)+D[oD]?/},monthsShort:"Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split("_"),weekdaysShort:"Ait._Som._Mon._Bud._Bre._Suk._Son.".split("_"),weekdaysMin:"Ai_Sm_Mo_Bu_Br_Su_Sn".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"A h:mm [vazta]",LTS:"A h:mm:ss [vazta]",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY A h:mm [vazta]",LLLL:"dddd, MMMM Do, YYYY, A h:mm [vazta]",llll:"ddd, D MMM YYYY, A h:mm [vazta]"},calendar:{sameDay:"[Aiz] LT",nextDay:"[Faleam] LT",nextWeek:"[Fuddlo] dddd[,] LT",lastDay:"[Kal] LT",lastWeek:"[Fattlo] dddd[,] LT",sameElse:"L"},relativeTime:{future:"%s",past:"%s adim",s:t,ss:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\d{1,2}(er)/,ordinal:function(e,t){return"D"===t?e+"er":e},week:{dow:0,doy:3},meridiemParse:/rati|sokallim|donparam|sanje/,meridiemHour:function(e,t){return 12===e&&(e=0),"rati"===t?e<4?e:e+12:"sokallim"===t?e:"donparam"===t?e>12?e:e+12:"sanje"===t?e+12:void 0},meridiem:function(e,t,n){return e<4?"rati":e<12?"sokallim":e<16?"donparam":e<20?"sanje":"rati"}})}(n(41655))},34232:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={1:"૧",2:"૨",3:"૩",4:"૪",5:"૫",6:"૬",7:"૭",8:"૮",9:"૯",0:"૦"},n={"૧":"1","૨":"2","૩":"3","૪":"4","૫":"5","૬":"6","૭":"7","૮":"8","૯":"9","૦":"0"};e.defineLocale("gu",{months:"જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર".split("_"),monthsShort:"જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.".split("_"),monthsParseExact:!0,weekdays:"રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર".split("_"),weekdaysShort:"રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ".split("_"),weekdaysMin:"ર_સો_મં_બુ_ગુ_શુ_શ".split("_"),longDateFormat:{LT:"A h:mm વાગ્યે",LTS:"A h:mm:ss વાગ્યે",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm વાગ્યે",LLLL:"dddd, D MMMM YYYY, A h:mm વાગ્યે"},calendar:{sameDay:"[આજ] LT",nextDay:"[કાલે] LT",nextWeek:"dddd, LT",lastDay:"[ગઇકાલે] LT",lastWeek:"[પાછલા] dddd, LT",sameElse:"L"},relativeTime:{future:"%s મા",past:"%s પહેલા",s:"અમુક પળો",ss:"%d સેકંડ",m:"એક મિનિટ",mm:"%d મિનિટ",h:"એક કલાક",hh:"%d કલાક",d:"એક દિવસ",dd:"%d દિવસ",M:"એક મહિનો",MM:"%d મહિનો",y:"એક વર્ષ",yy:"%d વર્ષ"},preparse:function(e){return e.replace(/[૧૨૩૪૫૬૭૮૯૦]/g,(function(e){return n[e]}))},postformat:function(e){return e.replace(/\d/g,(function(e){return t[e]}))},meridiemParse:/રાત|બપોર|સવાર|સાંજ/,meridiemHour:function(e,t){return 12===e&&(e=0),"રાત"===t?e<4?e:e+12:"સવાર"===t?e:"બપોર"===t?e>=10?e:e+12:"સાંજ"===t?e+12:void 0},meridiem:function(e,t,n){return e<4?"રાત":e<10?"સવાર":e<17?"બપોર":e<20?"સાંજ":"રાત"},week:{dow:0,doy:6}})}(n(41655))},50915:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("he",{months:"ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר".split("_"),monthsShort:"ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳".split("_"),weekdays:"ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת".split("_"),weekdaysShort:"א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳".split("_"),weekdaysMin:"א_ב_ג_ד_ה_ו_ש".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [ב]MMMM YYYY",LLL:"D [ב]MMMM YYYY HH:mm",LLLL:"dddd, D [ב]MMMM YYYY HH:mm",l:"D/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY HH:mm",llll:"ddd, D MMM YYYY HH:mm"},calendar:{sameDay:"[היום ב־]LT",nextDay:"[מחר ב־]LT",nextWeek:"dddd [בשעה] LT",lastDay:"[אתמול ב־]LT",lastWeek:"[ביום] dddd [האחרון בשעה] LT",sameElse:"L"},relativeTime:{future:"בעוד %s",past:"לפני %s",s:"מספר שניות",ss:"%d שניות",m:"דקה",mm:"%d דקות",h:"שעה",hh:function(e){return 2===e?"שעתיים":e+" שעות"},d:"יום",dd:function(e){return 2===e?"יומיים":e+" ימים"},M:"חודש",MM:function(e){return 2===e?"חודשיים":e+" חודשים"},y:"שנה",yy:function(e){return 2===e?"שנתיים":e%10==0&&10!==e?e+" שנה":e+" שנים"}},meridiemParse:/אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,isPM:function(e){return/^(אחה"צ|אחרי הצהריים|בערב)$/.test(e)},meridiem:function(e,t,n){return e<5?"לפנות בוקר":e<10?"בבוקר":e<12?n?'לפנה"צ':"לפני הצהריים":e<18?n?'אחה"צ':"אחרי הצהריים":"בערב"}})}(n(41655))},22095:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={1:"१",2:"२",3:"३",4:"४",5:"५",6:"६",7:"७",8:"८",9:"९",0:"०"},n={"१":"1","२":"2","३":"3","४":"4","५":"5","६":"6","७":"7","८":"8","९":"9","०":"0"},r=[/^जन/i,/^फ़र|फर/i,/^मार्च/i,/^अप्रै/i,/^मई/i,/^जून/i,/^जुल/i,/^अग/i,/^सितं|सित/i,/^अक्टू/i,/^नव|नवं/i,/^दिसं|दिस/i],o=[/^जन/i,/^फ़र/i,/^मार्च/i,/^अप्रै/i,/^मई/i,/^जून/i,/^जुल/i,/^अग/i,/^सित/i,/^अक्टू/i,/^नव/i,/^दिस/i];e.defineLocale("hi",{months:{format:"जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर".split("_"),standalone:"जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर".split("_")},monthsShort:"जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.".split("_"),weekdays:"रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार".split("_"),weekdaysShort:"रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि".split("_"),weekdaysMin:"र_सो_मं_बु_गु_शु_श".split("_"),longDateFormat:{LT:"A h:mm बजे",LTS:"A h:mm:ss बजे",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm बजे",LLLL:"dddd, D MMMM YYYY, A h:mm बजे"},monthsParse:r,longMonthsParse:r,shortMonthsParse:o,monthsRegex:/^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,monthsShortRegex:/^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,monthsStrictRegex:/^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,monthsShortStrictRegex:/^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,calendar:{sameDay:"[आज] LT",nextDay:"[कल] LT",nextWeek:"dddd, LT",lastDay:"[कल] LT",lastWeek:"[पिछले] dddd, LT",sameElse:"L"},relativeTime:{future:"%s में",past:"%s पहले",s:"कुछ ही क्षण",ss:"%d सेकंड",m:"एक मिनट",mm:"%d मिनट",h:"एक घंटा",hh:"%d घंटे",d:"एक दिन",dd:"%d दिन",M:"एक महीने",MM:"%d महीने",y:"एक वर्ष",yy:"%d वर्ष"},preparse:function(e){return e.replace(/[१२३४५६७८९०]/g,(function(e){return n[e]}))},postformat:function(e){return e.replace(/\d/g,(function(e){return t[e]}))},meridiemParse:/रात|सुबह|दोपहर|शाम/,meridiemHour:function(e,t){return 12===e&&(e=0),"रात"===t?e<4?e:e+12:"सुबह"===t?e:"दोपहर"===t?e>=10?e:e+12:"शाम"===t?e+12:void 0},meridiem:function(e,t,n){return e<4?"रात":e<10?"सुबह":e<17?"दोपहर":e<20?"शाम":"रात"},week:{dow:0,doy:6}})}(n(41655))},10762:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
function t(e,t,n){var r=e+" ";switch(n){case"ss":return r+=1===e?"sekunda":2===e||3===e||4===e?"sekunde":"sekundi";case"m":return t?"jedna minuta":"jedne minute";case"mm":return r+=1===e?"minuta":2===e||3===e||4===e?"minute":"minuta";case"h":return t?"jedan sat":"jednog sata";case"hh":return r+=1===e?"sat":2===e||3===e||4===e?"sata":"sati";case"dd":return r+=1===e?"dan":"dana";case"MM":return r+=1===e?"mjesec":2===e||3===e||4===e?"mjeseca":"mjeseci";case"yy":return r+=1===e?"godina":2===e||3===e||4===e?"godine":"godina"}}e.defineLocale("hr",{months:{format:"siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca".split("_"),standalone:"siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split("_")},monthsShort:"sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._čet._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_če_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"Do MMMM YYYY",LLL:"Do MMMM YYYY H:mm",LLLL:"dddd, Do MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[jučer u] LT",lastWeek:function(){switch(this.day()){case 0:return"[prošlu] [nedjelju] [u] LT";case 3:return"[prošlu] [srijedu] [u] LT";case 6:return"[prošle] [subote] [u] LT";case 1:case 2:case 4:case 5:return"[prošli] dddd [u] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"par sekundi",ss:t,m:t,mm:t,h:t,hh:t,d:"dan",dd:t,M:"mjesec",MM:t,y:"godinu",yy:t},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})}(n(41655))},88275:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t="vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton".split(" ");function n(e,t,n,r){var o=e;switch(n){case"s":return r||t?"néhány másodperc":"néhány másodperce";case"ss":return o+(r||t)?" másodperc":" másodperce";case"m":return"egy"+(r||t?" perc":" perce");case"mm":return o+(r||t?" perc":" perce");case"h":return"egy"+(r||t?" óra":" órája");case"hh":return o+(r||t?" óra":" órája");case"d":return"egy"+(r||t?" nap":" napja");case"dd":return o+(r||t?" nap":" napja");case"M":return"egy"+(r||t?" hónap":" hónapja");case"MM":return o+(r||t?" hónap":" hónapja");case"y":return"egy"+(r||t?" év":" éve");case"yy":return o+(r||t?" év":" éve")}return""}function r(e){return(e?"":"[múlt] ")+"["+t[this.day()]+"] LT[-kor]"}e.defineLocale("hu",{months:"január_február_március_április_május_június_július_augusztus_szeptember_október_november_december".split("_"),monthsShort:"jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat".split("_"),weekdaysShort:"vas_hét_kedd_sze_csüt_pén_szo".split("_"),weekdaysMin:"v_h_k_sze_cs_p_szo".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"YYYY.MM.DD.",LL:"YYYY. MMMM D.",LLL:"YYYY. MMMM D. H:mm",LLLL:"YYYY. MMMM D., dddd H:mm"},meridiemParse:/de|du/i,isPM:function(e){return"u"===e.charAt(1).toLowerCase()},meridiem:function(e,t,n){return e<12?!0===n?"de":"DE":!0===n?"du":"DU"},calendar:{sameDay:"[ma] LT[-kor]",nextDay:"[holnap] LT[-kor]",nextWeek:function(){return r.call(this,!0)},lastDay:"[tegnap] LT[-kor]",lastWeek:function(){return r.call(this,!1)},sameElse:"L"},relativeTime:{future:"%s múlva",past:"%s",s:n,ss:n,m:n,mm:n,h:n,hh:n,d:n,dd:n,M:n,MM:n,y:n,yy:n},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})}(n(41655))},73094:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("hy-am",{months:{format:"հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի".split("_"),standalone:"հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր".split("_")},monthsShort:"հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ".split("_"),weekdays:"կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ".split("_"),weekdaysShort:"կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ".split("_"),weekdaysMin:"կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY թ.",LLL:"D MMMM YYYY թ., HH:mm",LLLL:"dddd, D MMMM YYYY թ., HH:mm"},calendar:{sameDay:"[այսօր] LT",nextDay:"[վաղը] LT",lastDay:"[երեկ] LT",nextWeek:function(){return"dddd [օրը ժամը] LT"},lastWeek:function(){return"[անցած] dddd [օրը ժամը] LT"},sameElse:"L"},relativeTime:{future:"%s հետո",past:"%s առաջ",s:"մի քանի վայրկյան",ss:"%d վայրկյան",m:"րոպե",mm:"%d րոպե",h:"ժամ",hh:"%d ժամ",d:"օր",dd:"%d օր",M:"ամիս",MM:"%d ամիս",y:"տարի",yy:"%d տարի"},meridiemParse:/գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,isPM:function(e){return/^(ցերեկվա|երեկոյան)$/.test(e)},meridiem:function(e){return e<4?"գիշերվա":e<12?"առավոտվա":e<17?"ցերեկվա":"երեկոյան"},dayOfMonthOrdinalParse:/\d{1,2}|\d{1,2}-(ին|րդ)/,ordinal:function(e,t){switch(t){case"DDD":case"w":case"W":case"DDDo":return 1===e?e+"-ին":e+"-րդ";default:return e}},week:{dow:1,doy:7}})}(n(41655))},27769:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("id",{months:"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split("_"),monthsShort:"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des".split("_"),weekdays:"Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),weekdaysShort:"Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),weekdaysMin:"Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|siang|sore|malam/,meridiemHour:function(e,t){return 12===e&&(e=0),"pagi"===t?e:"siang"===t?e>=11?e:e+12:"sore"===t||"malam"===t?e+12:void 0},meridiem:function(e,t,n){return e<11?"pagi":e<15?"siang":e<19?"sore":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Besok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kemarin pukul] LT",lastWeek:"dddd [lalu pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lalu",s:"beberapa detik",ss:"%d detik",m:"semenit",mm:"%d menit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:0,doy:6}})}(n(41655))},99676:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
function t(e){return e%100==11||e%10!=1}function n(e,n,r,o){var i=e+" ";switch(r){case"s":return n||o?"nokkrar sekúndur":"nokkrum sekúndum";case"ss":return t(e)?i+(n||o?"sekúndur":"sekúndum"):i+"sekúnda";case"m":return n?"mínúta":"mínútu";case"mm":return t(e)?i+(n||o?"mínútur":"mínútum"):n?i+"mínúta":i+"mínútu";case"hh":return t(e)?i+(n||o?"klukkustundir":"klukkustundum"):i+"klukkustund";case"d":return n?"dagur":o?"dag":"degi";case"dd":return t(e)?n?i+"dagar":i+(o?"daga":"dögum"):n?i+"dagur":i+(o?"dag":"degi");case"M":return n?"mánuður":o?"mánuð":"mánuði";case"MM":return t(e)?n?i+"mánuðir":i+(o?"mánuði":"mánuðum"):n?i+"mánuður":i+(o?"mánuð":"mánuði");case"y":return n||o?"ár":"ári";case"yy":return t(e)?i+(n||o?"ár":"árum"):i+(n||o?"ár":"ári")}}e.defineLocale("is",{months:"janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember".split("_"),monthsShort:"jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des".split("_"),weekdays:"sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur".split("_"),weekdaysShort:"sun_mán_þri_mið_fim_fös_lau".split("_"),weekdaysMin:"Su_Má_Þr_Mi_Fi_Fö_La".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] H:mm",LLLL:"dddd, D. MMMM YYYY [kl.] H:mm"},calendar:{sameDay:"[í dag kl.] LT",nextDay:"[á morgun kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[í gær kl.] LT",lastWeek:"[síðasta] dddd [kl.] LT",sameElse:"L"},relativeTime:{future:"eftir %s",past:"fyrir %s síðan",s:n,ss:n,m:n,mm:n,h:"klukkustund",hh:n,d:n,dd:n,M:n,MM:n,y:n,yy:n},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})}(n(41655))},25141:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("it-ch",{months:"gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),monthsShort:"gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),weekdays:"domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),weekdaysShort:"dom_lun_mar_mer_gio_ven_sab".split("_"),weekdaysMin:"do_lu_ma_me_gi_ve_sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Oggi alle] LT",nextDay:"[Domani alle] LT",nextWeek:"dddd [alle] LT",lastDay:"[Ieri alle] LT",lastWeek:function(){return 0===this.day()?"[la scorsa] dddd [alle] LT":"[lo scorso] dddd [alle] LT"},sameElse:"L"},relativeTime:{future:function(e){return(/^[0-9].+$/.test(e)?"tra":"in")+" "+e},past:"%s fa",s:"alcuni secondi",ss:"%d secondi",m:"un minuto",mm:"%d minuti",h:"un'ora",hh:"%d ore",d:"un giorno",dd:"%d giorni",M:"un mese",MM:"%d mesi",y:"un anno",yy:"%d anni"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})}(n(41655))},74313:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("it",{months:"gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),monthsShort:"gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),weekdays:"domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),weekdaysShort:"dom_lun_mar_mer_gio_ven_sab".split("_"),weekdaysMin:"do_lu_ma_me_gi_ve_sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:function(){return"[Oggi a"+(this.hours()>1?"lle ":0===this.hours()?" ":"ll'")+"]LT"},nextDay:function(){return"[Domani a"+(this.hours()>1?"lle ":0===this.hours()?" ":"ll'")+"]LT"},nextWeek:function(){return"dddd [a"+(this.hours()>1?"lle ":0===this.hours()?" ":"ll'")+"]LT"},lastDay:function(){return"[Ieri a"+(this.hours()>1?"lle ":0===this.hours()?" ":"ll'")+"]LT"},lastWeek:function(){return 0===this.day()?"[La scorsa] dddd [a"+(this.hours()>1?"lle ":0===this.hours()?" ":"ll'")+"]LT":"[Lo scorso] dddd [a"+(this.hours()>1?"lle ":0===this.hours()?" ":"ll'")+"]LT"},sameElse:"L"},relativeTime:{future:"tra %s",past:"%s fa",s:"alcuni secondi",ss:"%d secondi",m:"un minuto",mm:"%d minuti",h:"un'ora",hh:"%d ore",d:"un giorno",dd:"%d giorni",w:"una settimana",ww:"%d settimane",M:"un mese",MM:"%d mesi",y:"un anno",yy:"%d anni"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})}(n(41655))},11985:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("ja",{eras:[{since:"2019-05-01",offset:1,name:"令和",narrow:"㋿",abbr:"R"},{since:"1989-01-08",until:"2019-04-30",offset:1,name:"平成",narrow:"㍻",abbr:"H"},{since:"1926-12-25",until:"1989-01-07",offset:1,name:"昭和",narrow:"㍼",abbr:"S"},{since:"1912-07-30",until:"1926-12-24",offset:1,name:"大正",narrow:"㍽",abbr:"T"},{since:"1873-01-01",until:"1912-07-29",offset:6,name:"明治",narrow:"㍾",abbr:"M"},{since:"0001-01-01",until:"1873-12-31",offset:1,name:"西暦",narrow:"AD",abbr:"AD"},{since:"0000-12-31",until:-1/0,offset:1,name:"紀元前",narrow:"BC",abbr:"BC"}],eraYearOrdinalRegex:/(元|\d+)年/,eraYearOrdinalParse:function(e,t){return"元"===t[1]?1:parseInt(t[1]||e,10)},months:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split("_"),weekdaysShort:"日_月_火_水_木_金_土".split("_"),weekdaysMin:"日_月_火_水_木_金_土".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY年M月D日",LLL:"YYYY年M月D日 HH:mm",LLLL:"YYYY年M月D日 dddd HH:mm",l:"YYYY/MM/DD",ll:"YYYY年M月D日",lll:"YYYY年M月D日 HH:mm",llll:"YYYY年M月D日(ddd) HH:mm"},meridiemParse:/午前|午後/i,isPM:function(e){return"午後"===e},meridiem:function(e,t,n){return e<12?"午前":"午後"},calendar:{sameDay:"[今日] LT",nextDay:"[明日] LT",nextWeek:function(e){return e.week()!==this.week()?"[来週]dddd LT":"dddd LT"},lastDay:"[昨日] LT",lastWeek:function(e){return this.week()!==e.week()?"[先週]dddd LT":"dddd LT"},sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}日/,ordinal:function(e,t){switch(t){case"y":return 1===e?"元年":e+"年";case"d":case"D":case"DDD":return e+"日";default:return e}},relativeTime:{future:"%s後",past:"%s前",s:"数秒",ss:"%d秒",m:"1分",mm:"%d分",h:"1時間",hh:"%d時間",d:"1日",dd:"%d日",M:"1ヶ月",MM:"%dヶ月",y:"1年",yy:"%d年"}})}(n(41655))},53908:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("jv",{months:"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember".split("_"),monthsShort:"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des".split("_"),weekdays:"Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu".split("_"),weekdaysShort:"Min_Sen_Sel_Reb_Kem_Jem_Sep".split("_"),weekdaysMin:"Mg_Sn_Sl_Rb_Km_Jm_Sp".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/enjing|siyang|sonten|ndalu/,meridiemHour:function(e,t){return 12===e&&(e=0),"enjing"===t?e:"siyang"===t?e>=11?e:e+12:"sonten"===t||"ndalu"===t?e+12:void 0},meridiem:function(e,t,n){return e<11?"enjing":e<15?"siyang":e<19?"sonten":"ndalu"},calendar:{sameDay:"[Dinten puniko pukul] LT",nextDay:"[Mbenjang pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kala wingi pukul] LT",lastWeek:"dddd [kepengker pukul] LT",sameElse:"L"},relativeTime:{future:"wonten ing %s",past:"%s ingkang kepengker",s:"sawetawis detik",ss:"%d detik",m:"setunggal menit",mm:"%d menit",h:"setunggal jam",hh:"%d jam",d:"sedinten",dd:"%d dinten",M:"sewulan",MM:"%d wulan",y:"setaun",yy:"%d taun"},week:{dow:1,doy:7}})}(n(41655))},32808:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("ka",{months:"იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი".split("_"),monthsShort:"იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ".split("_"),weekdays:{standalone:"კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი".split("_"),format:"კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს".split("_"),isFormat:/(წინა|შემდეგ)/},weekdaysShort:"კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ".split("_"),weekdaysMin:"კვ_ორ_სა_ოთ_ხუ_პა_შა".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[დღეს] LT[-ზე]",nextDay:"[ხვალ] LT[-ზე]",lastDay:"[გუშინ] LT[-ზე]",nextWeek:"[შემდეგ] dddd LT[-ზე]",lastWeek:"[წინა] dddd LT-ზე",sameElse:"L"},relativeTime:{future:function(e){return e.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,(function(e,t,n){return"ი"===n?t+"ში":t+n+"ში"}))},past:function(e){return/(წამი|წუთი|საათი|დღე|თვე)/.test(e)?e.replace(/(ი|ე)$/,"ის წინ"):/წელი/.test(e)?e.replace(/წელი$/,"წლის წინ"):e},s:"რამდენიმე წამი",ss:"%d წამი",m:"წუთი",mm:"%d წუთი",h:"საათი",hh:"%d საათი",d:"დღე",dd:"%d დღე",M:"თვე",MM:"%d თვე",y:"წელი",yy:"%d წელი"},dayOfMonthOrdinalParse:/0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,ordinal:function(e){return 0===e?e:1===e?e+"-ლი":e<20||e<=100&&e%20==0||e%100==0?"მე-"+e:e+"-ე"},week:{dow:1,doy:7}})}(n(41655))},33930:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={0:"-ші",1:"-ші",2:"-ші",3:"-ші",4:"-ші",5:"-ші",6:"-шы",7:"-ші",8:"-ші",9:"-шы",10:"-шы",20:"-шы",30:"-шы",40:"-шы",50:"-ші",60:"-шы",70:"-ші",80:"-ші",90:"-шы",100:"-ші"};e.defineLocale("kk",{months:"қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан".split("_"),monthsShort:"қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел".split("_"),weekdays:"жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі".split("_"),weekdaysShort:"жек_дүй_сей_сәр_бей_жұм_сен".split("_"),weekdaysMin:"жк_дй_сй_ср_бй_жм_сн".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Бүгін сағат] LT",nextDay:"[Ертең сағат] LT",nextWeek:"dddd [сағат] LT",lastDay:"[Кеше сағат] LT",lastWeek:"[Өткен аптаның] dddd [сағат] LT",sameElse:"L"},relativeTime:{future:"%s ішінде",past:"%s бұрын",s:"бірнеше секунд",ss:"%d секунд",m:"бір минут",mm:"%d минут",h:"бір сағат",hh:"%d сағат",d:"бір күн",dd:"%d күн",M:"бір ай",MM:"%d ай",y:"бір жыл",yy:"%d жыл"},dayOfMonthOrdinalParse:/\d{1,2}-(ші|шы)/,ordinal:function(e){var n=e%10,r=e>=100?100:null;return e+(t[e]||t[n]||t[r])},week:{dow:1,doy:7}})}(n(41655))},71532:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={1:"១",2:"២",3:"៣",4:"៤",5:"៥",6:"៦",7:"៧",8:"៨",9:"៩",0:"០"},n={"១":"1","២":"2","៣":"3","៤":"4","៥":"5","៦":"6","៧":"7","៨":"8","៩":"9","០":"0"};e.defineLocale("km",{months:"មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ".split("_"),monthsShort:"មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ".split("_"),weekdays:"អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍".split("_"),weekdaysShort:"អា_ច_អ_ព_ព្រ_សុ_ស".split("_"),weekdaysMin:"អា_ច_អ_ព_ព្រ_សុ_ស".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},meridiemParse:/ព្រឹក|ល្ងាច/,isPM:function(e){return"ល្ងាច"===e},meridiem:function(e,t,n){return e<12?"ព្រឹក":"ល្ងាច"},calendar:{sameDay:"[ថ្ងៃនេះ ម៉ោង] LT",nextDay:"[ស្អែក ម៉ោង] LT",nextWeek:"dddd [ម៉ោង] LT",lastDay:"[ម្សិលមិញ ម៉ោង] LT",lastWeek:"dddd [សប្តាហ៍មុន] [ម៉ោង] LT",sameElse:"L"},relativeTime:{future:"%sទៀត",past:"%sមុន",s:"ប៉ុន្មានវិនាទី",ss:"%d វិនាទី",m:"មួយនាទី",mm:"%d នាទី",h:"មួយម៉ោង",hh:"%d ម៉ោង",d:"មួយថ្ងៃ",dd:"%d ថ្ងៃ",M:"មួយខែ",MM:"%d ខែ",y:"មួយឆ្នាំ",yy:"%d ឆ្នាំ"},dayOfMonthOrdinalParse:/ទី\d{1,2}/,ordinal:"ទី%d",preparse:function(e){return e.replace(/[១២៣៤៥៦៧៨៩០]/g,(function(e){return n[e]}))},postformat:function(e){return e.replace(/\d/g,(function(e){return t[e]}))},week:{dow:1,doy:4}})}(n(41655))},69461:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={1:"೧",2:"೨",3:"೩",4:"೪",5:"೫",6:"೬",7:"೭",8:"೮",9:"೯",0:"೦"},n={"೧":"1","೨":"2","೩":"3","೪":"4","೫":"5","೬":"6","೭":"7","೮":"8","೯":"9","೦":"0"};e.defineLocale("kn",{months:"ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್".split("_"),monthsShort:"ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ".split("_"),monthsParseExact:!0,weekdays:"ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ".split("_"),weekdaysShort:"ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ".split("_"),weekdaysMin:"ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm",LLLL:"dddd, D MMMM YYYY, A h:mm"},calendar:{sameDay:"[ಇಂದು] LT",nextDay:"[ನಾಳೆ] LT",nextWeek:"dddd, LT",lastDay:"[ನಿನ್ನೆ] LT",lastWeek:"[ಕೊನೆಯ] dddd, LT",sameElse:"L"},relativeTime:{future:"%s ನಂತರ",past:"%s ಹಿಂದೆ",s:"ಕೆಲವು ಕ್ಷಣಗಳು",ss:"%d ಸೆಕೆಂಡುಗಳು",m:"ಒಂದು ನಿಮಿಷ",mm:"%d ನಿಮಿಷ",h:"ಒಂದು ಗಂಟೆ",hh:"%d ಗಂಟೆ",d:"ಒಂದು ದಿನ",dd:"%d ದಿನ",M:"ಒಂದು ತಿಂಗಳು",MM:"%d ತಿಂಗಳು",y:"ಒಂದು ವರ್ಷ",yy:"%d ವರ್ಷ"},preparse:function(e){return e.replace(/[೧೨೩೪೫೬೭೮೯೦]/g,(function(e){return n[e]}))},postformat:function(e){return e.replace(/\d/g,(function(e){return t[e]}))},meridiemParse:/ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,meridiemHour:function(e,t){return 12===e&&(e=0),"ರಾತ್ರಿ"===t?e<4?e:e+12:"ಬೆಳಿಗ್ಗೆ"===t?e:"ಮಧ್ಯಾಹ್ನ"===t?e>=10?e:e+12:"ಸಂಜೆ"===t?e+12:void 0},meridiem:function(e,t,n){return e<4?"ರಾತ್ರಿ":e<10?"ಬೆಳಿಗ್ಗೆ":e<17?"ಮಧ್ಯಾಹ್ನ":e<20?"ಸಂಜೆ":"ರಾತ್ರಿ"},dayOfMonthOrdinalParse:/\d{1,2}(ನೇ)/,ordinal:function(e){return e+"ನೇ"},week:{dow:0,doy:6}})}(n(41655))},60502:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("ko",{months:"1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),monthsShort:"1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),weekdays:"일요일_월요일_화요일_수요일_목요일_금요일_토요일".split("_"),weekdaysShort:"일_월_화_수_목_금_토".split("_"),weekdaysMin:"일_월_화_수_목_금_토".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"YYYY.MM.DD.",LL:"YYYY년 MMMM D일",LLL:"YYYY년 MMMM D일 A h:mm",LLLL:"YYYY년 MMMM D일 dddd A h:mm",l:"YYYY.MM.DD.",ll:"YYYY년 MMMM D일",lll:"YYYY년 MMMM D일 A h:mm",llll:"YYYY년 MMMM D일 dddd A h:mm"},calendar:{sameDay:"오늘 LT",nextDay:"내일 LT",nextWeek:"dddd LT",lastDay:"어제 LT",lastWeek:"지난주 dddd LT",sameElse:"L"},relativeTime:{future:"%s 후",past:"%s 전",s:"몇 초",ss:"%d초",m:"1분",mm:"%d분",h:"한 시간",hh:"%d시간",d:"하루",dd:"%d일",M:"한 달",MM:"%d달",y:"일 년",yy:"%d년"},dayOfMonthOrdinalParse:/\d{1,2}(일|월|주)/,ordinal:function(e,t){switch(t){case"d":case"D":case"DDD":return e+"일";case"M":return e+"월";case"w":case"W":return e+"주";default:return e}},meridiemParse:/오전|오후/,isPM:function(e){return"오후"===e},meridiem:function(e,t,n){return e<12?"오전":"오후"}})}(n(41655))},58035:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
function t(e,t,n,r){var o={s:["çend sanîye","çend sanîyeyan"],ss:[e+" sanîye",e+" sanîyeyan"],m:["deqîqeyek","deqîqeyekê"],mm:[e+" deqîqe",e+" deqîqeyan"],h:["saetek","saetekê"],hh:[e+" saet",e+" saetan"],d:["rojek","rojekê"],dd:[e+" roj",e+" rojan"],w:["hefteyek","hefteyekê"],ww:[e+" hefte",e+" hefteyan"],M:["mehek","mehekê"],MM:[e+" meh",e+" mehan"],y:["salek","salekê"],yy:[e+" sal",e+" salan"]};return t?o[n][0]:o[n][1]}function n(e){var t=(e=""+e).substring(e.length-1),n=e.length>1?e.substring(e.length-2):"";return 12==n||13==n||"2"!=t&&"3"!=t&&"50"!=n&&"70"!=t&&"80"!=t?"ê":"yê"}e.defineLocale("ku-kmr",{months:"Rêbendan_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Cotmeh_Mijdar_Berfanbar".split("_"),monthsShort:"Rêb_Sib_Ada_Nîs_Gul_Hez_Tîr_Teb_Îlo_Cot_Mij_Ber".split("_"),monthsParseExact:!0,weekdays:"Yekşem_Duşem_Sêşem_Çarşem_Pêncşem_În_Şemî".split("_"),weekdaysShort:"Yek_Du_Sê_Çar_Pên_În_Şem".split("_"),weekdaysMin:"Ye_Du_Sê_Ça_Pê_În_Şe".split("_"),meridiem:function(e,t,n){return e<12?n?"bn":"BN":n?"pn":"PN"},meridiemParse:/bn|BN|pn|PN/,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"Do MMMM[a] YYYY[an]",LLL:"Do MMMM[a] YYYY[an] HH:mm",LLLL:"dddd, Do MMMM[a] YYYY[an] HH:mm",ll:"Do MMM[.] YYYY[an]",lll:"Do MMM[.] YYYY[an] HH:mm",llll:"ddd[.], Do MMM[.] YYYY[an] HH:mm"},calendar:{sameDay:"[Îro di saet] LT [de]",nextDay:"[Sibê di saet] LT [de]",nextWeek:"dddd [di saet] LT [de]",lastDay:"[Duh di saet] LT [de]",lastWeek:"dddd[a borî di saet] LT [de]",sameElse:"L"},relativeTime:{future:"di %s de",past:"berî %s",s:t,ss:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,w:t,ww:t,M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\d{1,2}(?:yê|ê|\.)/,ordinal:function(e,t){var r=t.toLowerCase();return r.includes("w")||r.includes("m")?e+".":e+n(e)},week:{dow:1,doy:4}})}(n(41655))},18660:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={1:"١",2:"٢",3:"٣",4:"٤",5:"٥",6:"٦",7:"٧",8:"٨",9:"٩",0:"٠"},n={"١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","٠":"0"},r=["کانونی دووەم","شوبات","ئازار","نیسان","ئایار","حوزەیران","تەمموز","ئاب","ئەیلوول","تشرینی یەكەم","تشرینی دووەم","كانونی یەکەم"];e.defineLocale("ku",{months:r,monthsShort:r,weekdays:"یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌".split("_"),weekdaysShort:"یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌".split("_"),weekdaysMin:"ی_د_س_چ_پ_ه_ش".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},meridiemParse:/ئێواره‌|به‌یانی/,isPM:function(e){return/ئێواره‌/.test(e)},meridiem:function(e,t,n){return e<12?"به‌یانی":"ئێواره‌"},calendar:{sameDay:"[ئه‌مرۆ كاتژمێر] LT",nextDay:"[به‌یانی كاتژمێر] LT",nextWeek:"dddd [كاتژمێر] LT",lastDay:"[دوێنێ كاتژمێر] LT",lastWeek:"dddd [كاتژمێر] LT",sameElse:"L"},relativeTime:{future:"له‌ %s",past:"%s",s:"چه‌ند چركه‌یه‌ك",ss:"چركه‌ %d",m:"یه‌ك خوله‌ك",mm:"%d خوله‌ك",h:"یه‌ك كاتژمێر",hh:"%d كاتژمێر",d:"یه‌ك ڕۆژ",dd:"%d ڕۆژ",M:"یه‌ك مانگ",MM:"%d مانگ",y:"یه‌ك ساڵ",yy:"%d ساڵ"},preparse:function(e){return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g,(function(e){return n[e]})).replace(/،/g,",")},postformat:function(e){return e.replace(/\d/g,(function(e){return t[e]})).replace(/,/g,"،")},week:{dow:6,doy:12}})}(n(41655))},83088:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={0:"-чү",1:"-чи",2:"-чи",3:"-чү",4:"-чү",5:"-чи",6:"-чы",7:"-чи",8:"-чи",9:"-чу",10:"-чу",20:"-чы",30:"-чу",40:"-чы",50:"-чү",60:"-чы",70:"-чи",80:"-чи",90:"-чу",100:"-чү"};e.defineLocale("ky",{months:"январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_"),monthsShort:"янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек".split("_"),weekdays:"Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби".split("_"),weekdaysShort:"Жек_Дүй_Шей_Шар_Бей_Жум_Ише".split("_"),weekdaysMin:"Жк_Дй_Шй_Шр_Бй_Жм_Иш".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Бүгүн саат] LT",nextDay:"[Эртең саат] LT",nextWeek:"dddd [саат] LT",lastDay:"[Кечээ саат] LT",lastWeek:"[Өткөн аптанын] dddd [күнү] [саат] LT",sameElse:"L"},relativeTime:{future:"%s ичинде",past:"%s мурун",s:"бирнече секунд",ss:"%d секунд",m:"бир мүнөт",mm:"%d мүнөт",h:"бир саат",hh:"%d саат",d:"бир күн",dd:"%d күн",M:"бир ай",MM:"%d ай",y:"бир жыл",yy:"%d жыл"},dayOfMonthOrdinalParse:/\d{1,2}-(чи|чы|чү|чу)/,ordinal:function(e){var n=e%10,r=e>=100?100:null;return e+(t[e]||t[n]||t[r])},week:{dow:1,doy:7}})}(n(41655))},65742:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
function t(e,t,n,r){var o={m:["eng Minutt","enger Minutt"],h:["eng Stonn","enger Stonn"],d:["een Dag","engem Dag"],M:["ee Mount","engem Mount"],y:["ee Joer","engem Joer"]};return t?o[n][0]:o[n][1]}function n(e){return o(e.substr(0,e.indexOf(" ")))?"a "+e:"an "+e}function r(e){return o(e.substr(0,e.indexOf(" ")))?"viru "+e:"virun "+e}function o(e){if(e=parseInt(e,10),isNaN(e))return!1;if(e<0)return!0;if(e<10)return 4<=e&&e<=7;if(e<100){var t=e%10;return o(0===t?e/10:t)}if(e<1e4){for(;e>=10;)e/=10;return o(e)}return o(e/=1e3)}e.defineLocale("lb",{months:"Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg".split("_"),weekdaysShort:"So._Mé._Dë._Më._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mé_Dë_Më_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm [Auer]",LTS:"H:mm:ss [Auer]",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm [Auer]",LLLL:"dddd, D. MMMM YYYY H:mm [Auer]"},calendar:{sameDay:"[Haut um] LT",sameElse:"L",nextDay:"[Muer um] LT",nextWeek:"dddd [um] LT",lastDay:"[Gëschter um] LT",lastWeek:function(){switch(this.day()){case 2:case 4:return"[Leschten] dddd [um] LT";default:return"[Leschte] dddd [um] LT"}}},relativeTime:{future:n,past:r,s:"e puer Sekonnen",ss:"%d Sekonnen",m:t,mm:"%d Minutten",h:t,hh:"%d Stonnen",d:t,dd:"%d Deeg",M:t,MM:"%d Méint",y:t,yy:"%d Joer"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})}(n(41655))},25417:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("lo",{months:"ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ".split("_"),monthsShort:"ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ".split("_"),weekdays:"ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ".split("_"),weekdaysShort:"ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ".split("_"),weekdaysMin:"ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"ວັນdddd D MMMM YYYY HH:mm"},meridiemParse:/ຕອນເຊົ້າ|ຕອນແລງ/,isPM:function(e){return"ຕອນແລງ"===e},meridiem:function(e,t,n){return e<12?"ຕອນເຊົ້າ":"ຕອນແລງ"},calendar:{sameDay:"[ມື້ນີ້ເວລາ] LT",nextDay:"[ມື້ອື່ນເວລາ] LT",nextWeek:"[ວັນ]dddd[ໜ້າເວລາ] LT",lastDay:"[ມື້ວານນີ້ເວລາ] LT",lastWeek:"[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT",sameElse:"L"},relativeTime:{future:"ອີກ %s",past:"%sຜ່ານມາ",s:"ບໍ່ເທົ່າໃດວິນາທີ",ss:"%d ວິນາທີ",m:"1 ນາທີ",mm:"%d ນາທີ",h:"1 ຊົ່ວໂມງ",hh:"%d ຊົ່ວໂມງ",d:"1 ມື້",dd:"%d ມື້",M:"1 ເດືອນ",MM:"%d ເດືອນ",y:"1 ປີ",yy:"%d ປີ"},dayOfMonthOrdinalParse:/(ທີ່)\d{1,2}/,ordinal:function(e){return"ທີ່"+e}})}(n(41655))},64968:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={ss:"sekundė_sekundžių_sekundes",m:"minutė_minutės_minutę",mm:"minutės_minučių_minutes",h:"valanda_valandos_valandą",hh:"valandos_valandų_valandas",d:"diena_dienos_dieną",dd:"dienos_dienų_dienas",M:"mėnuo_mėnesio_mėnesį",MM:"mėnesiai_mėnesių_mėnesius",y:"metai_metų_metus",yy:"metai_metų_metus"};function n(e,t,n,r){return t?"kelios sekundės":r?"kelių sekundžių":"kelias sekundes"}function r(e,t,n,r){return t?i(n)[0]:r?i(n)[1]:i(n)[2]}function o(e){return e%10==0||e>10&&e<20}function i(e){return t[e].split("_")}function a(e,t,n,a){var s=e+" ";return 1===e?s+r(e,t,n[0],a):t?s+(o(e)?i(n)[1]:i(n)[0]):a?s+i(n)[1]:s+(o(e)?i(n)[1]:i(n)[2])}e.defineLocale("lt",{months:{format:"sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio".split("_"),standalone:"sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis".split("_"),isFormat:/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/},monthsShort:"sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),weekdays:{format:"sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį".split("_"),standalone:"sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis".split("_"),isFormat:/dddd HH:mm/},weekdaysShort:"Sek_Pir_Ant_Tre_Ket_Pen_Šeš".split("_"),weekdaysMin:"S_P_A_T_K_Pn_Š".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY [m.] MMMM D [d.]",LLL:"YYYY [m.] MMMM D [d.], HH:mm [val.]",LLLL:"YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",l:"YYYY-MM-DD",ll:"YYYY [m.] MMMM D [d.]",lll:"YYYY [m.] MMMM D [d.], HH:mm [val.]",llll:"YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]"},calendar:{sameDay:"[Šiandien] LT",nextDay:"[Rytoj] LT",nextWeek:"dddd LT",lastDay:"[Vakar] LT",lastWeek:"[Praėjusį] dddd LT",sameElse:"L"},relativeTime:{future:"po %s",past:"prieš %s",s:n,ss:a,m:r,mm:a,h:r,hh:a,d:r,dd:a,M:r,MM:a,y:r,yy:a},dayOfMonthOrdinalParse:/\d{1,2}-oji/,ordinal:function(e){return e+"-oji"},week:{dow:1,doy:4}})}(n(41655))},41202:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={ss:"sekundes_sekundēm_sekunde_sekundes".split("_"),m:"minūtes_minūtēm_minūte_minūtes".split("_"),mm:"minūtes_minūtēm_minūte_minūtes".split("_"),h:"stundas_stundām_stunda_stundas".split("_"),hh:"stundas_stundām_stunda_stundas".split("_"),d:"dienas_dienām_diena_dienas".split("_"),dd:"dienas_dienām_diena_dienas".split("_"),M:"mēneša_mēnešiem_mēnesis_mēneši".split("_"),MM:"mēneša_mēnešiem_mēnesis_mēneši".split("_"),y:"gada_gadiem_gads_gadi".split("_"),yy:"gada_gadiem_gads_gadi".split("_")};function n(e,t,n){return n?t%10==1&&t%100!=11?e[2]:e[3]:t%10==1&&t%100!=11?e[0]:e[1]}function r(e,r,o){return e+" "+n(t[o],e,r)}function o(e,r,o){return n(t[o],e,r)}function i(e,t){return t?"dažas sekundes":"dažām sekundēm"}e.defineLocale("lv",{months:"janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris".split("_"),monthsShort:"jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec".split("_"),weekdays:"svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena".split("_"),weekdaysShort:"Sv_P_O_T_C_Pk_S".split("_"),weekdaysMin:"Sv_P_O_T_C_Pk_S".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY.",LL:"YYYY. [gada] D. MMMM",LLL:"YYYY. [gada] D. MMMM, HH:mm",LLLL:"YYYY. [gada] D. MMMM, dddd, HH:mm"},calendar:{sameDay:"[Šodien pulksten] LT",nextDay:"[Rīt pulksten] LT",nextWeek:"dddd [pulksten] LT",lastDay:"[Vakar pulksten] LT",lastWeek:"[Pagājušā] dddd [pulksten] LT",sameElse:"L"},relativeTime:{future:"pēc %s",past:"pirms %s",s:i,ss:r,m:o,mm:r,h:o,hh:r,d:o,dd:r,M:o,MM:r,y:o,yy:r},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})}(n(41655))},34438:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={words:{ss:["sekund","sekunda","sekundi"],m:["jedan minut","jednog minuta"],mm:["minut","minuta","minuta"],h:["jedan sat","jednog sata"],hh:["sat","sata","sati"],dd:["dan","dana","dana"],MM:["mjesec","mjeseca","mjeseci"],yy:["godina","godine","godina"]},correctGrammaticalCase:function(e,t){return 1===e?t[0]:e>=2&&e<=4?t[1]:t[2]},translate:function(e,n,r){var o=t.words[r];return 1===r.length?n?o[0]:o[1]:e+" "+t.correctGrammaticalCase(e,o)}};e.defineLocale("me",{months:"januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._čet._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_če_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sjutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[juče u] LT",lastWeek:function(){return["[prošle] [nedjelje] [u] LT","[prošlog] [ponedjeljka] [u] LT","[prošlog] [utorka] [u] LT","[prošle] [srijede] [u] LT","[prošlog] [četvrtka] [u] LT","[prošlog] [petka] [u] LT","[prošle] [subote] [u] LT"][this.day()]},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"nekoliko sekundi",ss:t.translate,m:t.translate,mm:t.translate,h:t.translate,hh:t.translate,d:"dan",dd:t.translate,M:"mjesec",MM:t.translate,y:"godinu",yy:t.translate},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})}(n(41655))},18498:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("mi",{months:"Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea".split("_"),monthsShort:"Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki".split("_"),monthsRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,monthsStrictRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,monthsShortRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,monthsShortStrictRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,weekdays:"Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei".split("_"),weekdaysShort:"Ta_Ma_Tū_We_Tāi_Pa_Hā".split("_"),weekdaysMin:"Ta_Ma_Tū_We_Tāi_Pa_Hā".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [i] HH:mm",LLLL:"dddd, D MMMM YYYY [i] HH:mm"},calendar:{sameDay:"[i teie mahana, i] LT",nextDay:"[apopo i] LT",nextWeek:"dddd [i] LT",lastDay:"[inanahi i] LT",lastWeek:"dddd [whakamutunga i] LT",sameElse:"L"},relativeTime:{future:"i roto i %s",past:"%s i mua",s:"te hēkona ruarua",ss:"%d hēkona",m:"he meneti",mm:"%d meneti",h:"te haora",hh:"%d haora",d:"he ra",dd:"%d ra",M:"he marama",MM:"%d marama",y:"he tau",yy:"%d tau"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})}(n(41655))},6744:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("mk",{months:"јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември".split("_"),monthsShort:"јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек".split("_"),weekdays:"недела_понеделник_вторник_среда_четврток_петок_сабота".split("_"),weekdaysShort:"нед_пон_вто_сре_чет_пет_саб".split("_"),weekdaysMin:"нe_пo_вт_ср_че_пе_сa".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[Денес во] LT",nextDay:"[Утре во] LT",nextWeek:"[Во] dddd [во] LT",lastDay:"[Вчера во] LT",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return"[Изминатата] dddd [во] LT";case 1:case 2:case 4:case 5:return"[Изминатиот] dddd [во] LT"}},sameElse:"L"},relativeTime:{future:"за %s",past:"пред %s",s:"неколку секунди",ss:"%d секунди",m:"една минута",mm:"%d минути",h:"еден час",hh:"%d часа",d:"еден ден",dd:"%d дена",M:"еден месец",MM:"%d месеци",y:"една година",yy:"%d години"},dayOfMonthOrdinalParse:/\d{1,2}-(ев|ен|ти|ви|ри|ми)/,ordinal:function(e){var t=e%10,n=e%100;return 0===e?e+"-ев":0===n?e+"-ен":n>10&&n<20?e+"-ти":1===t?e+"-ви":2===t?e+"-ри":7===t||8===t?e+"-ми":e+"-ти"},week:{dow:1,doy:7}})}(n(41655))},63949:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("ml",{months:"ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ".split("_"),monthsShort:"ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.".split("_"),monthsParseExact:!0,weekdays:"ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച".split("_"),weekdaysShort:"ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി".split("_"),weekdaysMin:"ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ".split("_"),longDateFormat:{LT:"A h:mm -നു",LTS:"A h:mm:ss -നു",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm -നു",LLLL:"dddd, D MMMM YYYY, A h:mm -നു"},calendar:{sameDay:"[ഇന്ന്] LT",nextDay:"[നാളെ] LT",nextWeek:"dddd, LT",lastDay:"[ഇന്നലെ] LT",lastWeek:"[കഴിഞ്ഞ] dddd, LT",sameElse:"L"},relativeTime:{future:"%s കഴിഞ്ഞ്",past:"%s മുൻപ്",s:"അൽപ നിമിഷങ്ങൾ",ss:"%d സെക്കൻഡ്",m:"ഒരു മിനിറ്റ്",mm:"%d മിനിറ്റ്",h:"ഒരു മണിക്കൂർ",hh:"%d മണിക്കൂർ",d:"ഒരു ദിവസം",dd:"%d ദിവസം",M:"ഒരു മാസം",MM:"%d മാസം",y:"ഒരു വർഷം",yy:"%d വർഷം"},meridiemParse:/രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,meridiemHour:function(e,t){return 12===e&&(e=0),"രാത്രി"===t&&e>=4||"ഉച്ച കഴിഞ്ഞ്"===t||"വൈകുന്നേരം"===t?e+12:e},meridiem:function(e,t,n){return e<4?"രാത്രി":e<12?"രാവിലെ":e<17?"ഉച്ച കഴിഞ്ഞ്":e<20?"വൈകുന്നേരം":"രാത്രി"}})}(n(41655))},4459:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
function t(e,t,n,r){switch(n){case"s":return t?"хэдхэн секунд":"хэдхэн секундын";case"ss":return e+(t?" секунд":" секундын");case"m":case"mm":return e+(t?" минут":" минутын");case"h":case"hh":return e+(t?" цаг":" цагийн");case"d":case"dd":return e+(t?" өдөр":" өдрийн");case"M":case"MM":return e+(t?" сар":" сарын");case"y":case"yy":return e+(t?" жил":" жилийн");default:return e}}e.defineLocale("mn",{months:"Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар".split("_"),monthsShort:"1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар".split("_"),monthsParseExact:!0,weekdays:"Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба".split("_"),weekdaysShort:"Ням_Дав_Мяг_Лха_Пүр_Баа_Бям".split("_"),weekdaysMin:"Ня_Да_Мя_Лх_Пү_Ба_Бя".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY оны MMMMын D",LLL:"YYYY оны MMMMын D HH:mm",LLLL:"dddd, YYYY оны MMMMын D HH:mm"},meridiemParse:/ҮӨ|ҮХ/i,isPM:function(e){return"ҮХ"===e},meridiem:function(e,t,n){return e<12?"ҮӨ":"ҮХ"},calendar:{sameDay:"[Өнөөдөр] LT",nextDay:"[Маргааш] LT",nextWeek:"[Ирэх] dddd LT",lastDay:"[Өчигдөр] LT",lastWeek:"[Өнгөрсөн] dddd LT",sameElse:"L"},relativeTime:{future:"%s дараа",past:"%s өмнө",s:t,ss:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\d{1,2} өдөр/,ordinal:function(e,t){switch(t){case"d":case"D":case"DDD":return e+" өдөр";default:return e}}})}(n(41655))},46679:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={1:"१",2:"२",3:"३",4:"४",5:"५",6:"६",7:"७",8:"८",9:"९",0:"०"},n={"१":"1","२":"2","३":"3","४":"4","५":"5","६":"6","७":"7","८":"8","९":"9","०":"0"};function r(e,t,n,r){var o="";if(t)switch(n){case"s":o="काही सेकंद";break;case"ss":o="%d सेकंद";break;case"m":o="एक मिनिट";break;case"mm":o="%d मिनिटे";break;case"h":o="एक तास";break;case"hh":o="%d तास";break;case"d":o="एक दिवस";break;case"dd":o="%d दिवस";break;case"M":o="एक महिना";break;case"MM":o="%d महिने";break;case"y":o="एक वर्ष";break;case"yy":o="%d वर्षे"}else switch(n){case"s":o="काही सेकंदां";break;case"ss":o="%d सेकंदां";break;case"m":o="एका मिनिटा";break;case"mm":o="%d मिनिटां";break;case"h":o="एका तासा";break;case"hh":o="%d तासां";break;case"d":o="एका दिवसा";break;case"dd":o="%d दिवसां";break;case"M":o="एका महिन्या";break;case"MM":o="%d महिन्यां";break;case"y":o="एका वर्षा";break;case"yy":o="%d वर्षां"}return o.replace(/%d/i,e)}e.defineLocale("mr",{months:"जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर".split("_"),monthsShort:"जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.".split("_"),monthsParseExact:!0,weekdays:"रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार".split("_"),weekdaysShort:"रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि".split("_"),weekdaysMin:"र_सो_मं_बु_गु_शु_श".split("_"),longDateFormat:{LT:"A h:mm वाजता",LTS:"A h:mm:ss वाजता",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm वाजता",LLLL:"dddd, D MMMM YYYY, A h:mm वाजता"},calendar:{sameDay:"[आज] LT",nextDay:"[उद्या] LT",nextWeek:"dddd, LT",lastDay:"[काल] LT",lastWeek:"[मागील] dddd, LT",sameElse:"L"},relativeTime:{future:"%sमध्ये",past:"%sपूर्वी",s:r,ss:r,m:r,mm:r,h:r,hh:r,d:r,dd:r,M:r,MM:r,y:r,yy:r},preparse:function(e){return e.replace(/[१२३४५६७८९०]/g,(function(e){return n[e]}))},postformat:function(e){return e.replace(/\d/g,(function(e){return t[e]}))},meridiemParse:/पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,meridiemHour:function(e,t){return 12===e&&(e=0),"पहाटे"===t||"सकाळी"===t?e:"दुपारी"===t||"सायंकाळी"===t||"रात्री"===t?e>=12?e:e+12:void 0},meridiem:function(e,t,n){return e>=0&&e<6?"पहाटे":e<12?"सकाळी":e<17?"दुपारी":e<20?"सायंकाळी":"रात्री"},week:{dow:0,doy:6}})}(n(41655))},47483:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("ms-my",{months:"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),weekdays:"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),weekdaysShort:"Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),weekdaysMin:"Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(e,t){return 12===e&&(e=0),"pagi"===t?e:"tengahari"===t?e>=11?e:e+12:"petang"===t||"malam"===t?e+12:void 0},meridiem:function(e,t,n){return e<11?"pagi":e<15?"tengahari":e<19?"petang":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Esok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kelmarin pukul] LT",lastWeek:"dddd [lepas pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lepas",s:"beberapa saat",ss:"%d saat",m:"seminit",mm:"%d minit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}})}(n(41655))},56960:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("ms",{months:"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),weekdays:"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),weekdaysShort:"Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),weekdaysMin:"Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(e,t){return 12===e&&(e=0),"pagi"===t?e:"tengahari"===t?e>=11?e:e+12:"petang"===t||"malam"===t?e+12:void 0},meridiem:function(e,t,n){return e<11?"pagi":e<15?"tengahari":e<19?"petang":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Esok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kelmarin pukul] LT",lastWeek:"dddd [lepas pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lepas",s:"beberapa saat",ss:"%d saat",m:"seminit",mm:"%d minit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}})}(n(41655))},99989:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("mt",{months:"Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru".split("_"),monthsShort:"Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ".split("_"),weekdays:"Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt".split("_"),weekdaysShort:"Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib".split("_"),weekdaysMin:"Ħa_Tn_Tl_Er_Ħa_Ġi_Si".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Illum fil-]LT",nextDay:"[Għada fil-]LT",nextWeek:"dddd [fil-]LT",lastDay:"[Il-bieraħ fil-]LT",lastWeek:"dddd [li għadda] [fil-]LT",sameElse:"L"},relativeTime:{future:"f’ %s",past:"%s ilu",s:"ftit sekondi",ss:"%d sekondi",m:"minuta",mm:"%d minuti",h:"siegħa",hh:"%d siegħat",d:"ġurnata",dd:"%d ġranet",M:"xahar",MM:"%d xhur",y:"sena",yy:"%d sni"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})}(n(41655))},64978:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={1:"၁",2:"၂",3:"၃",4:"၄",5:"၅",6:"၆",7:"၇",8:"၈",9:"၉",0:"၀"},n={"၁":"1","၂":"2","၃":"3","၄":"4","၅":"5","၆":"6","၇":"7","၈":"8","၉":"9","၀":"0"};e.defineLocale("my",{months:"ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ".split("_"),monthsShort:"ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ".split("_"),weekdays:"တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ".split("_"),weekdaysShort:"နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ".split("_"),weekdaysMin:"နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[ယနေ.] LT [မှာ]",nextDay:"[မနက်ဖြန်] LT [မှာ]",nextWeek:"dddd LT [မှာ]",lastDay:"[မနေ.က] LT [မှာ]",lastWeek:"[ပြီးခဲ့သော] dddd LT [မှာ]",sameElse:"L"},relativeTime:{future:"လာမည့် %s မှာ",past:"လွန်ခဲ့သော %s က",s:"စက္ကန်.အနည်းငယ်",ss:"%d စက္ကန့်",m:"တစ်မိနစ်",mm:"%d မိနစ်",h:"တစ်နာရီ",hh:"%d နာရီ",d:"တစ်ရက်",dd:"%d ရက်",M:"တစ်လ",MM:"%d လ",y:"တစ်နှစ်",yy:"%d နှစ်"},preparse:function(e){return e.replace(/[၁၂၃၄၅၆၇၈၉၀]/g,(function(e){return n[e]}))},postformat:function(e){return e.replace(/\d/g,(function(e){return t[e]}))},week:{dow:1,doy:4}})}(n(41655))},88460:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("nb",{months:"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split("_"),monthsParseExact:!0,weekdays:"søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),weekdaysShort:"sø._ma._ti._on._to._fr._lø.".split("_"),weekdaysMin:"sø_ma_ti_on_to_fr_lø".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] HH:mm",LLLL:"dddd D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[i dag kl.] LT",nextDay:"[i morgen kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[i går kl.] LT",lastWeek:"[forrige] dddd [kl.] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s siden",s:"noen sekunder",ss:"%d sekunder",m:"ett minutt",mm:"%d minutter",h:"én time",hh:"%d timer",d:"én dag",dd:"%d dager",w:"én uke",ww:"%d uker",M:"én måned",MM:"%d måneder",y:"ett år",yy:"%d år"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})}(n(41655))},23993:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={1:"१",2:"२",3:"३",4:"४",5:"५",6:"६",7:"७",8:"८",9:"९",0:"०"},n={"१":"1","२":"2","३":"3","४":"4","५":"5","६":"6","७":"7","८":"8","९":"9","०":"0"};e.defineLocale("ne",{months:"जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर".split("_"),monthsShort:"जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.".split("_"),monthsParseExact:!0,weekdays:"आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार".split("_"),weekdaysShort:"आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.".split("_"),weekdaysMin:"आ._सो._मं._बु._बि._शु._श.".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"Aको h:mm बजे",LTS:"Aको h:mm:ss बजे",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, Aको h:mm बजे",LLLL:"dddd, D MMMM YYYY, Aको h:mm बजे"},preparse:function(e){return e.replace(/[१२३४५६७८९०]/g,(function(e){return n[e]}))},postformat:function(e){return e.replace(/\d/g,(function(e){return t[e]}))},meridiemParse:/राति|बिहान|दिउँसो|साँझ/,meridiemHour:function(e,t){return 12===e&&(e=0),"राति"===t?e<4?e:e+12:"बिहान"===t?e:"दिउँसो"===t?e>=10?e:e+12:"साँझ"===t?e+12:void 0},meridiem:function(e,t,n){return e<3?"राति":e<12?"बिहान":e<16?"दिउँसो":e<20?"साँझ":"राति"},calendar:{sameDay:"[आज] LT",nextDay:"[भोलि] LT",nextWeek:"[आउँदो] dddd[,] LT",lastDay:"[हिजो] LT",lastWeek:"[गएको] dddd[,] LT",sameElse:"L"},relativeTime:{future:"%sमा",past:"%s अगाडि",s:"केही क्षण",ss:"%d सेकेण्ड",m:"एक मिनेट",mm:"%d मिनेट",h:"एक घण्टा",hh:"%d घण्टा",d:"एक दिन",dd:"%d दिन",M:"एक महिना",MM:"%d महिना",y:"एक बर्ष",yy:"%d बर्ष"},week:{dow:0,doy:6}})}(n(41655))},62678:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t="jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),n="jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),r=[/^jan/i,/^feb/i,/^(maart|mrt\.?)$/i,/^apr/i,/^mei$/i,/^jun[i.]?$/i,/^jul[i.]?$/i,/^aug/i,/^sep/i,/^okt/i,/^nov/i,/^dec/i],o=/^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;e.defineLocale("nl-be",{months:"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),monthsShort:function(e,r){return e?/-MMM-/.test(r)?n[e.month()]:t[e.month()]:t},monthsRegex:o,monthsShortRegex:o,monthsStrictRegex:/^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,monthsShortStrictRegex:/^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,monthsParse:r,longMonthsParse:r,shortMonthsParse:r,weekdays:"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),weekdaysShort:"zo._ma._di._wo._do._vr._za.".split("_"),weekdaysMin:"zo_ma_di_wo_do_vr_za".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[vandaag om] LT",nextDay:"[morgen om] LT",nextWeek:"dddd [om] LT",lastDay:"[gisteren om] LT",lastWeek:"[afgelopen] dddd [om] LT",sameElse:"L"},relativeTime:{future:"over %s",past:"%s geleden",s:"een paar seconden",ss:"%d seconden",m:"één minuut",mm:"%d minuten",h:"één uur",hh:"%d uur",d:"één dag",dd:"%d dagen",M:"één maand",MM:"%d maanden",y:"één jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?"ste":"de")},week:{dow:1,doy:4}})}(n(41655))},95378:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t="jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),n="jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),r=[/^jan/i,/^feb/i,/^(maart|mrt\.?)$/i,/^apr/i,/^mei$/i,/^jun[i.]?$/i,/^jul[i.]?$/i,/^aug/i,/^sep/i,/^okt/i,/^nov/i,/^dec/i],o=/^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;e.defineLocale("nl",{months:"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),monthsShort:function(e,r){return e?/-MMM-/.test(r)?n[e.month()]:t[e.month()]:t},monthsRegex:o,monthsShortRegex:o,monthsStrictRegex:/^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,monthsShortStrictRegex:/^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,monthsParse:r,longMonthsParse:r,shortMonthsParse:r,weekdays:"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),weekdaysShort:"zo._ma._di._wo._do._vr._za.".split("_"),weekdaysMin:"zo_ma_di_wo_do_vr_za".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[vandaag om] LT",nextDay:"[morgen om] LT",nextWeek:"dddd [om] LT",lastDay:"[gisteren om] LT",lastWeek:"[afgelopen] dddd [om] LT",sameElse:"L"},relativeTime:{future:"over %s",past:"%s geleden",s:"een paar seconden",ss:"%d seconden",m:"één minuut",mm:"%d minuten",h:"één uur",hh:"%d uur",d:"één dag",dd:"%d dagen",w:"één week",ww:"%d weken",M:"één maand",MM:"%d maanden",y:"één jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?"ste":"de")},week:{dow:1,doy:4}})}(n(41655))},67560:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("nn",{months:"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split("_"),monthsParseExact:!0,weekdays:"sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag".split("_"),weekdaysShort:"su._må._ty._on._to._fr._lau.".split("_"),weekdaysMin:"su_må_ty_on_to_fr_la".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] H:mm",LLLL:"dddd D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[I dag klokka] LT",nextDay:"[I morgon klokka] LT",nextWeek:"dddd [klokka] LT",lastDay:"[I går klokka] LT",lastWeek:"[Føregåande] dddd [klokka] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s sidan",s:"nokre sekund",ss:"%d sekund",m:"eit minutt",mm:"%d minutt",h:"ein time",hh:"%d timar",d:"ein dag",dd:"%d dagar",w:"ei veke",ww:"%d veker",M:"ein månad",MM:"%d månader",y:"eit år",yy:"%d år"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})}(n(41655))},87060:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("oc-lnc",{months:{standalone:"genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre".split("_"),format:"de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split("_"),isFormat:/D[oD]?(\s)+MMMM/},monthsShort:"gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte".split("_"),weekdaysShort:"dg._dl._dm._dc._dj._dv._ds.".split("_"),weekdaysMin:"dg_dl_dm_dc_dj_dv_ds".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [de] YYYY",ll:"D MMM YYYY",LLL:"D MMMM [de] YYYY [a] H:mm",lll:"D MMM YYYY, H:mm",LLLL:"dddd D MMMM [de] YYYY [a] H:mm",llll:"ddd D MMM YYYY, H:mm"},calendar:{sameDay:"[uèi a] LT",nextDay:"[deman a] LT",nextWeek:"dddd [a] LT",lastDay:"[ièr a] LT",lastWeek:"dddd [passat a] LT",sameElse:"L"},relativeTime:{future:"d'aquí %s",past:"fa %s",s:"unas segondas",ss:"%d segondas",m:"una minuta",mm:"%d minutas",h:"una ora",hh:"%d oras",d:"un jorn",dd:"%d jorns",M:"un mes",MM:"%d meses",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(r|n|t|è|a)/,ordinal:function(e,t){var n=1===e?"r":2===e?"n":3===e?"r":4===e?"t":"è";return"w"!==t&&"W"!==t||(n="a"),e+n},week:{dow:1,doy:4}})}(n(41655))},62187:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={1:"੧",2:"੨",3:"੩",4:"੪",5:"੫",6:"੬",7:"੭",8:"੮",9:"੯",0:"੦"},n={"੧":"1","੨":"2","੩":"3","੪":"4","੫":"5","੬":"6","੭":"7","੮":"8","੯":"9","੦":"0"};e.defineLocale("pa-in",{months:"ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ".split("_"),monthsShort:"ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ".split("_"),weekdays:"ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ".split("_"),weekdaysShort:"ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ".split("_"),weekdaysMin:"ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ".split("_"),longDateFormat:{LT:"A h:mm ਵਜੇ",LTS:"A h:mm:ss ਵਜੇ",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm ਵਜੇ",LLLL:"dddd, D MMMM YYYY, A h:mm ਵਜੇ"},calendar:{sameDay:"[ਅਜ] LT",nextDay:"[ਕਲ] LT",nextWeek:"[ਅਗਲਾ] dddd, LT",lastDay:"[ਕਲ] LT",lastWeek:"[ਪਿਛਲੇ] dddd, LT",sameElse:"L"},relativeTime:{future:"%s ਵਿੱਚ",past:"%s ਪਿਛਲੇ",s:"ਕੁਝ ਸਕਿੰਟ",ss:"%d ਸਕਿੰਟ",m:"ਇਕ ਮਿੰਟ",mm:"%d ਮਿੰਟ",h:"ਇੱਕ ਘੰਟਾ",hh:"%d ਘੰਟੇ",d:"ਇੱਕ ਦਿਨ",dd:"%d ਦਿਨ",M:"ਇੱਕ ਮਹੀਨਾ",MM:"%d ਮਹੀਨੇ",y:"ਇੱਕ ਸਾਲ",yy:"%d ਸਾਲ"},preparse:function(e){return e.replace(/[੧੨੩੪੫੬੭੮੯੦]/g,(function(e){return n[e]}))},postformat:function(e){return e.replace(/\d/g,(function(e){return t[e]}))},meridiemParse:/ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,meridiemHour:function(e,t){return 12===e&&(e=0),"ਰਾਤ"===t?e<4?e:e+12:"ਸਵੇਰ"===t?e:"ਦੁਪਹਿਰ"===t?e>=10?e:e+12:"ਸ਼ਾਮ"===t?e+12:void 0},meridiem:function(e,t,n){return e<4?"ਰਾਤ":e<10?"ਸਵੇਰ":e<17?"ਦੁਪਹਿਰ":e<20?"ਸ਼ਾਮ":"ਰਾਤ"},week:{dow:0,doy:6}})}(n(41655))},93532:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t="styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień".split("_"),n="stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia".split("_"),r=[/^sty/i,/^lut/i,/^mar/i,/^kwi/i,/^maj/i,/^cze/i,/^lip/i,/^sie/i,/^wrz/i,/^paź/i,/^lis/i,/^gru/i];function o(e){return e%10<5&&e%10>1&&~~(e/10)%10!=1}function i(e,t,n){var r=e+" ";switch(n){case"ss":return r+(o(e)?"sekundy":"sekund");case"m":return t?"minuta":"minutę";case"mm":return r+(o(e)?"minuty":"minut");case"h":return t?"godzina":"godzinę";case"hh":return r+(o(e)?"godziny":"godzin");case"ww":return r+(o(e)?"tygodnie":"tygodni");case"MM":return r+(o(e)?"miesiące":"miesięcy");case"yy":return r+(o(e)?"lata":"lat")}}e.defineLocale("pl",{months:function(e,r){return e?/D MMMM/.test(r)?n[e.month()]:t[e.month()]:t},monthsShort:"sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru".split("_"),monthsParse:r,longMonthsParse:r,shortMonthsParse:r,weekdays:"niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota".split("_"),weekdaysShort:"ndz_pon_wt_śr_czw_pt_sob".split("_"),weekdaysMin:"Nd_Pn_Wt_Śr_Cz_Pt_So".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Dziś o] LT",nextDay:"[Jutro o] LT",nextWeek:function(){switch(this.day()){case 0:return"[W niedzielę o] LT";case 2:return"[We wtorek o] LT";case 3:return"[W środę o] LT";case 6:return"[W sobotę o] LT";default:return"[W] dddd [o] LT"}},lastDay:"[Wczoraj o] LT",lastWeek:function(){switch(this.day()){case 0:return"[W zeszłą niedzielę o] LT";case 3:return"[W zeszłą środę o] LT";case 6:return"[W zeszłą sobotę o] LT";default:return"[W zeszły] dddd [o] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"%s temu",s:"kilka sekund",ss:i,m:i,mm:i,h:i,hh:i,d:"1 dzień",dd:"%d dni",w:"tydzień",ww:i,M:"miesiąc",MM:i,y:"rok",yy:i},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})}(n(41655))},92485:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("pt-br",{months:"janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),monthsShort:"jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),weekdays:"domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado".split("_"),weekdaysShort:"dom_seg_ter_qua_qui_sex_sáb".split("_"),weekdaysMin:"do_2ª_3ª_4ª_5ª_6ª_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY [às] HH:mm",LLLL:"dddd, D [de] MMMM [de] YYYY [às] HH:mm"},calendar:{sameDay:"[Hoje às] LT",nextDay:"[Amanhã às] LT",nextWeek:"dddd [às] LT",lastDay:"[Ontem às] LT",lastWeek:function(){return 0===this.day()||6===this.day()?"[Último] dddd [às] LT":"[Última] dddd [às] LT"},sameElse:"L"},relativeTime:{future:"em %s",past:"há %s",s:"poucos segundos",ss:"%d segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",M:"um mês",MM:"%d meses",y:"um ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",invalidDate:"Data inválida"})}(n(41655))},49396:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("pt",{months:"janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),monthsShort:"jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),weekdays:"Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado".split("_"),weekdaysShort:"Dom_Seg_Ter_Qua_Qui_Sex_Sáb".split("_"),weekdaysMin:"Do_2ª_3ª_4ª_5ª_6ª_Sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY HH:mm",LLLL:"dddd, D [de] MMMM [de] YYYY HH:mm"},calendar:{sameDay:"[Hoje às] LT",nextDay:"[Amanhã às] LT",nextWeek:"dddd [às] LT",lastDay:"[Ontem às] LT",lastWeek:function(){return 0===this.day()||6===this.day()?"[Último] dddd [às] LT":"[Última] dddd [às] LT"},sameElse:"L"},relativeTime:{future:"em %s",past:"há %s",s:"segundos",ss:"%d segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",w:"uma semana",ww:"%d semanas",M:"um mês",MM:"%d meses",y:"um ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})}(n(41655))},33179:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
function t(e,t,n){var r=" ";return(e%100>=20||e>=100&&e%100==0)&&(r=" de "),e+r+{ss:"secunde",mm:"minute",hh:"ore",dd:"zile",ww:"săptămâni",MM:"luni",yy:"ani"}[n]}e.defineLocale("ro",{months:"ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie".split("_"),monthsShort:"ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"duminică_luni_marți_miercuri_joi_vineri_sâmbătă".split("_"),weekdaysShort:"Dum_Lun_Mar_Mie_Joi_Vin_Sâm".split("_"),weekdaysMin:"Du_Lu_Ma_Mi_Jo_Vi_Sâ".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[azi la] LT",nextDay:"[mâine la] LT",nextWeek:"dddd [la] LT",lastDay:"[ieri la] LT",lastWeek:"[fosta] dddd [la] LT",sameElse:"L"},relativeTime:{future:"peste %s",past:"%s în urmă",s:"câteva secunde",ss:t,m:"un minut",mm:t,h:"o oră",hh:t,d:"o zi",dd:t,w:"o săptămână",ww:t,M:"o lună",MM:t,y:"un an",yy:t},week:{dow:1,doy:7}})}(n(41655))},93797:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
function t(e,t){var n=e.split("_");return t%10==1&&t%100!=11?n[0]:t%10>=2&&t%10<=4&&(t%100<10||t%100>=20)?n[1]:n[2]}function n(e,n,r){return"m"===r?n?"минута":"минуту":e+" "+t({ss:n?"секунда_секунды_секунд":"секунду_секунды_секунд",mm:n?"минута_минуты_минут":"минуту_минуты_минут",hh:"час_часа_часов",dd:"день_дня_дней",ww:"неделя_недели_недель",MM:"месяц_месяца_месяцев",yy:"год_года_лет"}[r],+e)}var r=[/^янв/i,/^фев/i,/^мар/i,/^апр/i,/^ма[йя]/i,/^июн/i,/^июл/i,/^авг/i,/^сен/i,/^окт/i,/^ноя/i,/^дек/i];e.defineLocale("ru",{months:{format:"января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split("_"),standalone:"январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_")},monthsShort:{format:"янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.".split("_"),standalone:"янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.".split("_")},weekdays:{standalone:"воскресенье_понедельник_вторник_среда_четверг_пятница_суббота".split("_"),format:"воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу".split("_"),isFormat:/\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/},weekdaysShort:"вс_пн_вт_ср_чт_пт_сб".split("_"),weekdaysMin:"вс_пн_вт_ср_чт_пт_сб".split("_"),monthsParse:r,longMonthsParse:r,shortMonthsParse:r,monthsRegex:/^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,monthsShortRegex:/^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,monthsStrictRegex:/^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,monthsShortStrictRegex:/^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY г.",LLL:"D MMMM YYYY г., H:mm",LLLL:"dddd, D MMMM YYYY г., H:mm"},calendar:{sameDay:"[Сегодня, в] LT",nextDay:"[Завтра, в] LT",lastDay:"[Вчера, в] LT",nextWeek:function(e){if(e.week()===this.week())return 2===this.day()?"[Во] dddd, [в] LT":"[В] dddd, [в] LT";switch(this.day()){case 0:return"[В следующее] dddd, [в] LT";case 1:case 2:case 4:return"[В следующий] dddd, [в] LT";case 3:case 5:case 6:return"[В следующую] dddd, [в] LT"}},lastWeek:function(e){if(e.week()===this.week())return 2===this.day()?"[Во] dddd, [в] LT":"[В] dddd, [в] LT";switch(this.day()){case 0:return"[В прошлое] dddd, [в] LT";case 1:case 2:case 4:return"[В прошлый] dddd, [в] LT";case 3:case 5:case 6:return"[В прошлую] dddd, [в] LT"}},sameElse:"L"},relativeTime:{future:"через %s",past:"%s назад",s:"несколько секунд",ss:n,m:n,mm:n,h:"час",hh:n,d:"день",dd:n,w:"неделя",ww:n,M:"месяц",MM:n,y:"год",yy:n},meridiemParse:/ночи|утра|дня|вечера/i,isPM:function(e){return/^(дня|вечера)$/.test(e)},meridiem:function(e,t,n){return e<4?"ночи":e<12?"утра":e<17?"дня":"вечера"},dayOfMonthOrdinalParse:/\d{1,2}-(й|го|я)/,ordinal:function(e,t){switch(t){case"M":case"d":case"DDD":return e+"-й";case"D":return e+"-го";case"w":case"W":return e+"-я";default:return e}},week:{dow:1,doy:4}})}(n(41655))},40675:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t=["جنوري","فيبروري","مارچ","اپريل","مئي","جون","جولاءِ","آگسٽ","سيپٽمبر","آڪٽوبر","نومبر","ڊسمبر"],n=["آچر","سومر","اڱارو","اربع","خميس","جمع","ڇنڇر"];e.defineLocale("sd",{months:t,monthsShort:t,weekdays:n,weekdaysShort:n,weekdaysMin:n,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd، D MMMM YYYY HH:mm"},meridiemParse:/صبح|شام/,isPM:function(e){return"شام"===e},meridiem:function(e,t,n){return e<12?"صبح":"شام"},calendar:{sameDay:"[اڄ] LT",nextDay:"[سڀاڻي] LT",nextWeek:"dddd [اڳين هفتي تي] LT",lastDay:"[ڪالهه] LT",lastWeek:"[گزريل هفتي] dddd [تي] LT",sameElse:"L"},relativeTime:{future:"%s پوء",past:"%s اڳ",s:"چند سيڪنڊ",ss:"%d سيڪنڊ",m:"هڪ منٽ",mm:"%d منٽ",h:"هڪ ڪلاڪ",hh:"%d ڪلاڪ",d:"هڪ ڏينهن",dd:"%d ڏينهن",M:"هڪ مهينو",MM:"%d مهينا",y:"هڪ سال",yy:"%d سال"},preparse:function(e){return e.replace(/،/g,",")},postformat:function(e){return e.replace(/,/g,"،")},week:{dow:1,doy:4}})}(n(41655))},59036:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("se",{months:"ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu".split("_"),monthsShort:"ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov".split("_"),weekdays:"sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat".split("_"),weekdaysShort:"sotn_vuos_maŋ_gask_duor_bear_láv".split("_"),weekdaysMin:"s_v_m_g_d_b_L".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"MMMM D. [b.] YYYY",LLL:"MMMM D. [b.] YYYY [ti.] HH:mm",LLLL:"dddd, MMMM D. [b.] YYYY [ti.] HH:mm"},calendar:{sameDay:"[otne ti] LT",nextDay:"[ihttin ti] LT",nextWeek:"dddd [ti] LT",lastDay:"[ikte ti] LT",lastWeek:"[ovddit] dddd [ti] LT",sameElse:"L"},relativeTime:{future:"%s geažes",past:"maŋit %s",s:"moadde sekunddat",ss:"%d sekunddat",m:"okta minuhta",mm:"%d minuhtat",h:"okta diimmu",hh:"%d diimmut",d:"okta beaivi",dd:"%d beaivvit",M:"okta mánnu",MM:"%d mánut",y:"okta jahki",yy:"%d jagit"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})}(n(41655))},59160:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("si",{months:"ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්".split("_"),monthsShort:"ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ".split("_"),weekdays:"ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා".split("_"),weekdaysShort:"ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන".split("_"),weekdaysMin:"ඉ_ස_අ_බ_බ්‍ර_සි_සෙ".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"a h:mm",LTS:"a h:mm:ss",L:"YYYY/MM/DD",LL:"YYYY MMMM D",LLL:"YYYY MMMM D, a h:mm",LLLL:"YYYY MMMM D [වැනි] dddd, a h:mm:ss"},calendar:{sameDay:"[අද] LT[ට]",nextDay:"[හෙට] LT[ට]",nextWeek:"dddd LT[ට]",lastDay:"[ඊයේ] LT[ට]",lastWeek:"[පසුගිය] dddd LT[ට]",sameElse:"L"},relativeTime:{future:"%sකින්",past:"%sකට පෙර",s:"තත්පර කිහිපය",ss:"තත්පර %d",m:"මිනිත්තුව",mm:"මිනිත්තු %d",h:"පැය",hh:"පැය %d",d:"දිනය",dd:"දින %d",M:"මාසය",MM:"මාස %d",y:"වසර",yy:"වසර %d"},dayOfMonthOrdinalParse:/\d{1,2} වැනි/,ordinal:function(e){return e+" වැනි"},meridiemParse:/පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,isPM:function(e){return"ප.ව."===e||"පස් වරු"===e},meridiem:function(e,t,n){return e>11?n?"ප.ව.":"පස් වරු":n?"පෙ.ව.":"පෙර වරු"}})}(n(41655))},31266:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t="január_február_marec_apríl_máj_jún_júl_august_september_október_november_december".split("_"),n="jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec".split("_");function r(e){return e>1&&e<5}function o(e,t,n,o){var i=e+" ";switch(n){case"s":return t||o?"pár sekúnd":"pár sekundami";case"ss":return t||o?i+(r(e)?"sekundy":"sekúnd"):i+"sekundami";case"m":return t?"minúta":o?"minútu":"minútou";case"mm":return t||o?i+(r(e)?"minúty":"minút"):i+"minútami";case"h":return t?"hodina":o?"hodinu":"hodinou";case"hh":return t||o?i+(r(e)?"hodiny":"hodín"):i+"hodinami";case"d":return t||o?"deň":"dňom";case"dd":return t||o?i+(r(e)?"dni":"dní"):i+"dňami";case"M":return t||o?"mesiac":"mesiacom";case"MM":return t||o?i+(r(e)?"mesiace":"mesiacov"):i+"mesiacmi";case"y":return t||o?"rok":"rokom";case"yy":return t||o?i+(r(e)?"roky":"rokov"):i+"rokmi"}}e.defineLocale("sk",{months:t,monthsShort:n,weekdays:"nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota".split("_"),weekdaysShort:"ne_po_ut_st_št_pi_so".split("_"),weekdaysMin:"ne_po_ut_st_št_pi_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd D. MMMM YYYY H:mm"},calendar:{sameDay:"[dnes o] LT",nextDay:"[zajtra o] LT",nextWeek:function(){switch(this.day()){case 0:return"[v nedeľu o] LT";case 1:case 2:return"[v] dddd [o] LT";case 3:return"[v stredu o] LT";case 4:return"[vo štvrtok o] LT";case 5:return"[v piatok o] LT";case 6:return"[v sobotu o] LT"}},lastDay:"[včera o] LT",lastWeek:function(){switch(this.day()){case 0:return"[minulú nedeľu o] LT";case 1:case 2:case 4:case 5:return"[minulý] dddd [o] LT";case 3:return"[minulú stredu o] LT";case 6:return"[minulú sobotu o] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"pred %s",s:o,ss:o,m:o,mm:o,h:o,hh:o,d:o,dd:o,M:o,MM:o,y:o,yy:o},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})}(n(41655))},74699:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
function t(e,t,n,r){var o=e+" ";switch(n){case"s":return t||r?"nekaj sekund":"nekaj sekundami";case"ss":return o+=1===e?t?"sekundo":"sekundi":2===e?t||r?"sekundi":"sekundah":e<5?t||r?"sekunde":"sekundah":"sekund";case"m":return t?"ena minuta":"eno minuto";case"mm":return o+=1===e?t?"minuta":"minuto":2===e?t||r?"minuti":"minutama":e<5?t||r?"minute":"minutami":t||r?"minut":"minutami";case"h":return t?"ena ura":"eno uro";case"hh":return o+=1===e?t?"ura":"uro":2===e?t||r?"uri":"urama":e<5?t||r?"ure":"urami":t||r?"ur":"urami";case"d":return t||r?"en dan":"enim dnem";case"dd":return o+=1===e?t||r?"dan":"dnem":2===e?t||r?"dni":"dnevoma":t||r?"dni":"dnevi";case"M":return t||r?"en mesec":"enim mesecem";case"MM":return o+=1===e?t||r?"mesec":"mesecem":2===e?t||r?"meseca":"mesecema":e<5?t||r?"mesece":"meseci":t||r?"mesecev":"meseci";case"y":return t||r?"eno leto":"enim letom";case"yy":return o+=1===e?t||r?"leto":"letom":2===e?t||r?"leti":"letoma":e<5?t||r?"leta":"leti":t||r?"let":"leti"}}e.defineLocale("sl",{months:"januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december".split("_"),monthsShort:"jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota".split("_"),weekdaysShort:"ned._pon._tor._sre._čet._pet._sob.".split("_"),weekdaysMin:"ne_po_to_sr_če_pe_so".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD. MM. YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danes ob] LT",nextDay:"[jutri ob] LT",nextWeek:function(){switch(this.day()){case 0:return"[v] [nedeljo] [ob] LT";case 3:return"[v] [sredo] [ob] LT";case 6:return"[v] [soboto] [ob] LT";case 1:case 2:case 4:case 5:return"[v] dddd [ob] LT"}},lastDay:"[včeraj ob] LT",lastWeek:function(){switch(this.day()){case 0:return"[prejšnjo] [nedeljo] [ob] LT";case 3:return"[prejšnjo] [sredo] [ob] LT";case 6:return"[prejšnjo] [soboto] [ob] LT";case 1:case 2:case 4:case 5:return"[prejšnji] dddd [ob] LT"}},sameElse:"L"},relativeTime:{future:"čez %s",past:"pred %s",s:t,ss:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})}(n(41655))},69728:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("sq",{months:"Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor".split("_"),monthsShort:"Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj".split("_"),weekdays:"E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë".split("_"),weekdaysShort:"Die_Hën_Mar_Mër_Enj_Pre_Sht".split("_"),weekdaysMin:"D_H_Ma_Më_E_P_Sh".split("_"),weekdaysParseExact:!0,meridiemParse:/PD|MD/,isPM:function(e){return"M"===e.charAt(0)},meridiem:function(e,t,n){return e<12?"PD":"MD"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Sot në] LT",nextDay:"[Nesër në] LT",nextWeek:"dddd [në] LT",lastDay:"[Dje në] LT",lastWeek:"dddd [e kaluar në] LT",sameElse:"L"},relativeTime:{future:"në %s",past:"%s më parë",s:"disa sekonda",ss:"%d sekonda",m:"një minutë",mm:"%d minuta",h:"një orë",hh:"%d orë",d:"një ditë",dd:"%d ditë",M:"një muaj",MM:"%d muaj",y:"një vit",yy:"%d vite"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})}(n(41655))},55e3:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={words:{ss:["секунда","секунде","секунди"],m:["један минут","једног минута"],mm:["минут","минута","минута"],h:["један сат","једног сата"],hh:["сат","сата","сати"],d:["један дан","једног дана"],dd:["дан","дана","дана"],M:["један месец","једног месеца"],MM:["месец","месеца","месеци"],y:["једну годину","једне године"],yy:["годину","године","година"]},correctGrammaticalCase:function(e,t){return e%10>=1&&e%10<=4&&(e%100<10||e%100>=20)?e%10==1?t[0]:t[1]:t[2]},translate:function(e,n,r,o){var i,a=t.words[r];return 1===r.length?"y"===r&&n?"једна година":o||n?a[0]:a[1]:(i=t.correctGrammaticalCase(e,a),"yy"===r&&n&&"годину"===i?e+" година":e+" "+i)}};e.defineLocale("sr-cyrl",{months:"јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар".split("_"),monthsShort:"јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.".split("_"),monthsParseExact:!0,weekdays:"недеља_понедељак_уторак_среда_четвртак_петак_субота".split("_"),weekdaysShort:"нед._пон._уто._сре._чет._пет._суб.".split("_"),weekdaysMin:"не_по_ут_ср_че_пе_су".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D. M. YYYY.",LL:"D. MMMM YYYY.",LLL:"D. MMMM YYYY. H:mm",LLLL:"dddd, D. MMMM YYYY. H:mm"},calendar:{sameDay:"[данас у] LT",nextDay:"[сутра у] LT",nextWeek:function(){switch(this.day()){case 0:return"[у] [недељу] [у] LT";case 3:return"[у] [среду] [у] LT";case 6:return"[у] [суботу] [у] LT";case 1:case 2:case 4:case 5:return"[у] dddd [у] LT"}},lastDay:"[јуче у] LT",lastWeek:function(){return["[прошле] [недеље] [у] LT","[прошлог] [понедељка] [у] LT","[прошлог] [уторка] [у] LT","[прошле] [среде] [у] LT","[прошлог] [четвртка] [у] LT","[прошлог] [петка] [у] LT","[прошле] [суботе] [у] LT"][this.day()]},sameElse:"L"},relativeTime:{future:"за %s",past:"пре %s",s:"неколико секунди",ss:t.translate,m:t.translate,mm:t.translate,h:t.translate,hh:t.translate,d:t.translate,dd:t.translate,M:t.translate,MM:t.translate,y:t.translate,yy:t.translate},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})}(n(41655))},87129:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={words:{ss:["sekunda","sekunde","sekundi"],m:["jedan minut","jednog minuta"],mm:["minut","minuta","minuta"],h:["jedan sat","jednog sata"],hh:["sat","sata","sati"],d:["jedan dan","jednog dana"],dd:["dan","dana","dana"],M:["jedan mesec","jednog meseca"],MM:["mesec","meseca","meseci"],y:["jednu godinu","jedne godine"],yy:["godinu","godine","godina"]},correctGrammaticalCase:function(e,t){return e%10>=1&&e%10<=4&&(e%100<10||e%100>=20)?e%10==1?t[0]:t[1]:t[2]},translate:function(e,n,r,o){var i,a=t.words[r];return 1===r.length?"y"===r&&n?"jedna godina":o||n?a[0]:a[1]:(i=t.correctGrammaticalCase(e,a),"yy"===r&&n&&"godinu"===i?e+" godina":e+" "+i)}};e.defineLocale("sr",{months:"januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sre._čet._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_če_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D. M. YYYY.",LL:"D. MMMM YYYY.",LLL:"D. MMMM YYYY. H:mm",LLLL:"dddd, D. MMMM YYYY. H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedelju] [u] LT";case 3:return"[u] [sredu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[juče u] LT",lastWeek:function(){return["[prošle] [nedelje] [u] LT","[prošlog] [ponedeljka] [u] LT","[prošlog] [utorka] [u] LT","[prošle] [srede] [u] LT","[prošlog] [četvrtka] [u] LT","[prošlog] [petka] [u] LT","[prošle] [subote] [u] LT"][this.day()]},sameElse:"L"},relativeTime:{future:"za %s",past:"pre %s",s:"nekoliko sekundi",ss:t.translate,m:t.translate,mm:t.translate,h:t.translate,hh:t.translate,d:t.translate,dd:t.translate,M:t.translate,MM:t.translate,y:t.translate,yy:t.translate},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})}(n(41655))},74346:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("ss",{months:"Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split("_"),monthsShort:"Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo".split("_"),weekdays:"Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo".split("_"),weekdaysShort:"Lis_Umb_Lsb_Les_Lsi_Lsh_Umg".split("_"),weekdaysMin:"Li_Us_Lb_Lt_Ls_Lh_Ug".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Namuhla nga] LT",nextDay:"[Kusasa nga] LT",nextWeek:"dddd [nga] LT",lastDay:"[Itolo nga] LT",lastWeek:"dddd [leliphelile] [nga] LT",sameElse:"L"},relativeTime:{future:"nga %s",past:"wenteka nga %s",s:"emizuzwana lomcane",ss:"%d mzuzwana",m:"umzuzu",mm:"%d emizuzu",h:"lihora",hh:"%d emahora",d:"lilanga",dd:"%d emalanga",M:"inyanga",MM:"%d tinyanga",y:"umnyaka",yy:"%d iminyaka"},meridiemParse:/ekuseni|emini|entsambama|ebusuku/,meridiem:function(e,t,n){return e<11?"ekuseni":e<15?"emini":e<19?"entsambama":"ebusuku"},meridiemHour:function(e,t){return 12===e&&(e=0),"ekuseni"===t?e:"emini"===t?e>=11?e:e+12:"entsambama"===t||"ebusuku"===t?0===e?0:e+12:void 0},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:"%d",week:{dow:1,doy:4}})}(n(41655))},9877:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("sv",{months:"januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),weekdays:"söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag".split("_"),weekdaysShort:"sön_mån_tis_ons_tor_fre_lör".split("_"),weekdaysMin:"sö_må_ti_on_to_fr_lö".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [kl.] HH:mm",LLLL:"dddd D MMMM YYYY [kl.] HH:mm",lll:"D MMM YYYY HH:mm",llll:"ddd D MMM YYYY HH:mm"},calendar:{sameDay:"[Idag] LT",nextDay:"[Imorgon] LT",lastDay:"[Igår] LT",nextWeek:"[På] dddd LT",lastWeek:"[I] dddd[s] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"för %s sedan",s:"några sekunder",ss:"%d sekunder",m:"en minut",mm:"%d minuter",h:"en timme",hh:"%d timmar",d:"en dag",dd:"%d dagar",M:"en månad",MM:"%d månader",y:"ett år",yy:"%d år"},dayOfMonthOrdinalParse:/\d{1,2}(\:e|\:a)/,ordinal:function(e){var t=e%10;return e+(1==~~(e%100/10)?":e":1===t||2===t?":a":":e")},week:{dow:1,doy:4}})}(n(41655))},918:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("sw",{months:"Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des".split("_"),weekdays:"Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi".split("_"),weekdaysShort:"Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos".split("_"),weekdaysMin:"J2_J3_J4_J5_Al_Ij_J1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"hh:mm A",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[leo saa] LT",nextDay:"[kesho saa] LT",nextWeek:"[wiki ijayo] dddd [saat] LT",lastDay:"[jana] LT",lastWeek:"[wiki iliyopita] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s baadaye",past:"tokea %s",s:"hivi punde",ss:"sekunde %d",m:"dakika moja",mm:"dakika %d",h:"saa limoja",hh:"masaa %d",d:"siku moja",dd:"siku %d",M:"mwezi mmoja",MM:"miezi %d",y:"mwaka mmoja",yy:"miaka %d"},week:{dow:1,doy:7}})}(n(41655))},24787:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={1:"௧",2:"௨",3:"௩",4:"௪",5:"௫",6:"௬",7:"௭",8:"௮",9:"௯",0:"௦"},n={"௧":"1","௨":"2","௩":"3","௪":"4","௫":"5","௬":"6","௭":"7","௮":"8","௯":"9","௦":"0"};e.defineLocale("ta",{months:"ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்".split("_"),monthsShort:"ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்".split("_"),weekdays:"ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை".split("_"),weekdaysShort:"ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி".split("_"),weekdaysMin:"ஞா_தி_செ_பு_வி_வெ_ச".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, HH:mm",LLLL:"dddd, D MMMM YYYY, HH:mm"},calendar:{sameDay:"[இன்று] LT",nextDay:"[நாளை] LT",nextWeek:"dddd, LT",lastDay:"[நேற்று] LT",lastWeek:"[கடந்த வாரம்] dddd, LT",sameElse:"L"},relativeTime:{future:"%s இல்",past:"%s முன்",s:"ஒரு சில விநாடிகள்",ss:"%d விநாடிகள்",m:"ஒரு நிமிடம்",mm:"%d நிமிடங்கள்",h:"ஒரு மணி நேரம்",hh:"%d மணி நேரம்",d:"ஒரு நாள்",dd:"%d நாட்கள்",M:"ஒரு மாதம்",MM:"%d மாதங்கள்",y:"ஒரு வருடம்",yy:"%d ஆண்டுகள்"},dayOfMonthOrdinalParse:/\d{1,2}வது/,ordinal:function(e){return e+"வது"},preparse:function(e){return e.replace(/[௧௨௩௪௫௬௭௮௯௦]/g,(function(e){return n[e]}))},postformat:function(e){return e.replace(/\d/g,(function(e){return t[e]}))},meridiemParse:/யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,meridiem:function(e,t,n){return e<2?" யாமம்":e<6?" வைகறை":e<10?" காலை":e<14?" நண்பகல்":e<18?" எற்பாடு":e<22?" மாலை":" யாமம்"},meridiemHour:function(e,t){return 12===e&&(e=0),"யாமம்"===t?e<2?e:e+12:"வைகறை"===t||"காலை"===t||"நண்பகல்"===t&&e>=10?e:e+12},week:{dow:0,doy:6}})}(n(41655))},6199:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("te",{months:"జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్".split("_"),monthsShort:"జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.".split("_"),monthsParseExact:!0,weekdays:"ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం".split("_"),weekdaysShort:"ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని".split("_"),weekdaysMin:"ఆ_సో_మం_బు_గు_శు_శ".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm",LLLL:"dddd, D MMMM YYYY, A h:mm"},calendar:{sameDay:"[నేడు] LT",nextDay:"[రేపు] LT",nextWeek:"dddd, LT",lastDay:"[నిన్న] LT",lastWeek:"[గత] dddd, LT",sameElse:"L"},relativeTime:{future:"%s లో",past:"%s క్రితం",s:"కొన్ని క్షణాలు",ss:"%d సెకన్లు",m:"ఒక నిమిషం",mm:"%d నిమిషాలు",h:"ఒక గంట",hh:"%d గంటలు",d:"ఒక రోజు",dd:"%d రోజులు",M:"ఒక నెల",MM:"%d నెలలు",y:"ఒక సంవత్సరం",yy:"%d సంవత్సరాలు"},dayOfMonthOrdinalParse:/\d{1,2}వ/,ordinal:"%dవ",meridiemParse:/రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,meridiemHour:function(e,t){return 12===e&&(e=0),"రాత్రి"===t?e<4?e:e+12:"ఉదయం"===t?e:"మధ్యాహ్నం"===t?e>=10?e:e+12:"సాయంత్రం"===t?e+12:void 0},meridiem:function(e,t,n){return e<4?"రాత్రి":e<10?"ఉదయం":e<17?"మధ్యాహ్నం":e<20?"సాయంత్రం":"రాత్రి"},week:{dow:0,doy:6}})}(n(41655))},91851:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("tet",{months:"Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru".split("_"),monthsShort:"Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),weekdays:"Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu".split("_"),weekdaysShort:"Dom_Seg_Ters_Kua_Kint_Sest_Sab".split("_"),weekdaysMin:"Do_Seg_Te_Ku_Ki_Ses_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Ohin iha] LT",nextDay:"[Aban iha] LT",nextWeek:"dddd [iha] LT",lastDay:"[Horiseik iha] LT",lastWeek:"dddd [semana kotuk] [iha] LT",sameElse:"L"},relativeTime:{future:"iha %s",past:"%s liuba",s:"segundu balun",ss:"segundu %d",m:"minutu ida",mm:"minutu %d",h:"oras ida",hh:"oras %d",d:"loron ida",dd:"loron %d",M:"fulan ida",MM:"fulan %d",y:"tinan ida",yy:"tinan %d"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10;return e+(1==~~(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th")},week:{dow:1,doy:4}})}(n(41655))},33881:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={0:"-ум",1:"-ум",2:"-юм",3:"-юм",4:"-ум",5:"-ум",6:"-ум",7:"-ум",8:"-ум",9:"-ум",10:"-ум",12:"-ум",13:"-ум",20:"-ум",30:"-юм",40:"-ум",50:"-ум",60:"-ум",70:"-ум",80:"-ум",90:"-ум",100:"-ум"};e.defineLocale("tg",{months:{format:"январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри".split("_"),standalone:"январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр".split("_")},monthsShort:"янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек".split("_"),weekdays:"якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе".split("_"),weekdaysShort:"яшб_дшб_сшб_чшб_пшб_ҷум_шнб".split("_"),weekdaysMin:"яш_дш_сш_чш_пш_ҷм_шб".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Имрӯз соати] LT",nextDay:"[Фардо соати] LT",lastDay:"[Дирӯз соати] LT",nextWeek:"dddd[и] [ҳафтаи оянда соати] LT",lastWeek:"dddd[и] [ҳафтаи гузашта соати] LT",sameElse:"L"},relativeTime:{future:"баъди %s",past:"%s пеш",s:"якчанд сония",m:"як дақиқа",mm:"%d дақиқа",h:"як соат",hh:"%d соат",d:"як рӯз",dd:"%d рӯз",M:"як моҳ",MM:"%d моҳ",y:"як сол",yy:"%d сол"},meridiemParse:/шаб|субҳ|рӯз|бегоҳ/,meridiemHour:function(e,t){return 12===e&&(e=0),"шаб"===t?e<4?e:e+12:"субҳ"===t?e:"рӯз"===t?e>=11?e:e+12:"бегоҳ"===t?e+12:void 0},meridiem:function(e,t,n){return e<4?"шаб":e<11?"субҳ":e<16?"рӯз":e<19?"бегоҳ":"шаб"},dayOfMonthOrdinalParse:/\d{1,2}-(ум|юм)/,ordinal:function(e){var n=e%10,r=e>=100?100:null;return e+(t[e]||t[n]||t[r])},week:{dow:1,doy:7}})}(n(41655))},87828:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("th",{months:"มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม".split("_"),monthsShort:"ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.".split("_"),monthsParseExact:!0,weekdays:"อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์".split("_"),weekdaysShort:"อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์".split("_"),weekdaysMin:"อา._จ._อ._พ._พฤ._ศ._ส.".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY เวลา H:mm",LLLL:"วันddddที่ D MMMM YYYY เวลา H:mm"},meridiemParse:/ก่อนเที่ยง|หลังเที่ยง/,isPM:function(e){return"หลังเที่ยง"===e},meridiem:function(e,t,n){return e<12?"ก่อนเที่ยง":"หลังเที่ยง"},calendar:{sameDay:"[วันนี้ เวลา] LT",nextDay:"[พรุ่งนี้ เวลา] LT",nextWeek:"dddd[หน้า เวลา] LT",lastDay:"[เมื่อวานนี้ เวลา] LT",lastWeek:"[วัน]dddd[ที่แล้ว เวลา] LT",sameElse:"L"},relativeTime:{future:"อีก %s",past:"%sที่แล้ว",s:"ไม่กี่วินาที",ss:"%d วินาที",m:"1 นาที",mm:"%d นาที",h:"1 ชั่วโมง",hh:"%d ชั่วโมง",d:"1 วัน",dd:"%d วัน",w:"1 สัปดาห์",ww:"%d สัปดาห์",M:"1 เดือน",MM:"%d เดือน",y:"1 ปี",yy:"%d ปี"}})}(n(41655))},99677:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={1:"'inji",5:"'inji",8:"'inji",70:"'inji",80:"'inji",2:"'nji",7:"'nji",20:"'nji",50:"'nji",3:"'ünji",4:"'ünji",100:"'ünji",6:"'njy",9:"'unjy",10:"'unjy",30:"'unjy",60:"'ynjy",90:"'ynjy"};e.defineLocale("tk",{months:"Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr".split("_"),monthsShort:"Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek".split("_"),weekdays:"Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe".split("_"),weekdaysShort:"Ýek_Duş_Siş_Çar_Pen_Ann_Şen".split("_"),weekdaysMin:"Ýk_Dş_Sş_Çr_Pn_An_Şn".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[bugün sagat] LT",nextDay:"[ertir sagat] LT",nextWeek:"[indiki] dddd [sagat] LT",lastDay:"[düýn] LT",lastWeek:"[geçen] dddd [sagat] LT",sameElse:"L"},relativeTime:{future:"%s soň",past:"%s öň",s:"birnäçe sekunt",m:"bir minut",mm:"%d minut",h:"bir sagat",hh:"%d sagat",d:"bir gün",dd:"%d gün",M:"bir aý",MM:"%d aý",y:"bir ýyl",yy:"%d ýyl"},ordinal:function(e,n){switch(n){case"d":case"D":case"Do":case"DD":return e;default:if(0===e)return e+"'unjy";var r=e%10,o=e%100-r,i=e>=100?100:null;return e+(t[r]||t[o]||t[i])}},week:{dow:1,doy:7}})}(n(41655))},29253:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("tl-ph",{months:"Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),monthsShort:"Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),weekdays:"Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),weekdaysShort:"Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),weekdaysMin:"Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"MM/D/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY HH:mm",LLLL:"dddd, MMMM DD, YYYY HH:mm"},calendar:{sameDay:"LT [ngayong araw]",nextDay:"[Bukas ng] LT",nextWeek:"LT [sa susunod na] dddd",lastDay:"LT [kahapon]",lastWeek:"LT [noong nakaraang] dddd",sameElse:"L"},relativeTime:{future:"sa loob ng %s",past:"%s ang nakalipas",s:"ilang segundo",ss:"%d segundo",m:"isang minuto",mm:"%d minuto",h:"isang oras",hh:"%d oras",d:"isang araw",dd:"%d araw",M:"isang buwan",MM:"%d buwan",y:"isang taon",yy:"%d taon"},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}})}(n(41655))},95586:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t="pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut".split("_");function n(e){var t=e;return t=-1!==e.indexOf("jaj")?t.slice(0,-3)+"leS":-1!==e.indexOf("jar")?t.slice(0,-3)+"waQ":-1!==e.indexOf("DIS")?t.slice(0,-3)+"nem":t+" pIq"}function r(e){var t=e;return t=-1!==e.indexOf("jaj")?t.slice(0,-3)+"Hu’":-1!==e.indexOf("jar")?t.slice(0,-3)+"wen":-1!==e.indexOf("DIS")?t.slice(0,-3)+"ben":t+" ret"}function o(e,t,n,r){var o=i(e);switch(n){case"ss":return o+" lup";case"mm":return o+" tup";case"hh":return o+" rep";case"dd":return o+" jaj";case"MM":return o+" jar";case"yy":return o+" DIS"}}function i(e){var n=Math.floor(e%1e3/100),r=Math.floor(e%100/10),o=e%10,i="";return n>0&&(i+=t[n]+"vatlh"),r>0&&(i+=(""!==i?" ":"")+t[r]+"maH"),o>0&&(i+=(""!==i?" ":"")+t[o]),""===i?"pagh":i}e.defineLocale("tlh",{months:"tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’".split("_"),monthsShort:"jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’".split("_"),monthsParseExact:!0,weekdays:"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),weekdaysShort:"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),weekdaysMin:"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[DaHjaj] LT",nextDay:"[wa’leS] LT",nextWeek:"LLL",lastDay:"[wa’Hu’] LT",lastWeek:"LLL",sameElse:"L"},relativeTime:{future:n,past:r,s:"puS lup",ss:o,m:"wa’ tup",mm:o,h:"wa’ rep",hh:o,d:"wa’ jaj",dd:o,M:"wa’ jar",MM:o,y:"wa’ DIS",yy:o},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})}(n(41655))},17254:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t={1:"'inci",5:"'inci",8:"'inci",70:"'inci",80:"'inci",2:"'nci",7:"'nci",20:"'nci",50:"'nci",3:"'üncü",4:"'üncü",100:"'üncü",6:"'ncı",9:"'uncu",10:"'uncu",30:"'uncu",60:"'ıncı",90:"'ıncı"};e.defineLocale("tr",{months:"Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık".split("_"),monthsShort:"Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara".split("_"),weekdays:"Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi".split("_"),weekdaysShort:"Paz_Pzt_Sal_Çar_Per_Cum_Cmt".split("_"),weekdaysMin:"Pz_Pt_Sa_Ça_Pe_Cu_Ct".split("_"),meridiem:function(e,t,n){return e<12?n?"öö":"ÖÖ":n?"ös":"ÖS"},meridiemParse:/öö|ÖÖ|ös|ÖS/,isPM:function(e){return"ös"===e||"ÖS"===e},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[bugün saat] LT",nextDay:"[yarın saat] LT",nextWeek:"[gelecek] dddd [saat] LT",lastDay:"[dün] LT",lastWeek:"[geçen] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s sonra",past:"%s önce",s:"birkaç saniye",ss:"%d saniye",m:"bir dakika",mm:"%d dakika",h:"bir saat",hh:"%d saat",d:"bir gün",dd:"%d gün",w:"bir hafta",ww:"%d hafta",M:"bir ay",MM:"%d ay",y:"bir yıl",yy:"%d yıl"},ordinal:function(e,n){switch(n){case"d":case"D":case"Do":case"DD":return e;default:if(0===e)return e+"'ıncı";var r=e%10,o=e%100-r,i=e>=100?100:null;return e+(t[r]||t[o]||t[i])}},week:{dow:1,doy:7}})}(n(41655))},61192:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
function t(e,t,n,r){var o={s:["viensas secunds","'iensas secunds"],ss:[e+" secunds",e+" secunds"],m:["'n míut","'iens míut"],mm:[e+" míuts",e+" míuts"],h:["'n þora","'iensa þora"],hh:[e+" þoras",e+" þoras"],d:["'n ziua","'iensa ziua"],dd:[e+" ziuas",e+" ziuas"],M:["'n mes","'iens mes"],MM:[e+" mesen",e+" mesen"],y:["'n ar","'iens ar"],yy:[e+" ars",e+" ars"]};return r||t?o[n][0]:o[n][1]}e.defineLocale("tzl",{months:"Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar".split("_"),monthsShort:"Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec".split("_"),weekdays:"Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi".split("_"),weekdaysShort:"Súl_Lún_Mai_Már_Xhú_Vié_Sát".split("_"),weekdaysMin:"Sú_Lú_Ma_Má_Xh_Vi_Sá".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD.MM.YYYY",LL:"D. MMMM [dallas] YYYY",LLL:"D. MMMM [dallas] YYYY HH.mm",LLLL:"dddd, [li] D. MMMM [dallas] YYYY HH.mm"},meridiemParse:/d\'o|d\'a/i,isPM:function(e){return"d'o"===e.toLowerCase()},meridiem:function(e,t,n){return e>11?n?"d'o":"D'O":n?"d'a":"D'A"},calendar:{sameDay:"[oxhi à] LT",nextDay:"[demà à] LT",nextWeek:"dddd [à] LT",lastDay:"[ieiri à] LT",lastWeek:"[sür el] dddd [lasteu à] LT",sameElse:"L"},relativeTime:{future:"osprei %s",past:"ja%s",s:t,ss:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})}(n(41655))},72841:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("tzm-latn",{months:"innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir".split("_"),monthsShort:"innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir".split("_"),weekdays:"asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),weekdaysShort:"asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),weekdaysMin:"asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[asdkh g] LT",nextDay:"[aska g] LT",nextWeek:"dddd [g] LT",lastDay:"[assant g] LT",lastWeek:"dddd [g] LT",sameElse:"L"},relativeTime:{future:"dadkh s yan %s",past:"yan %s",s:"imik",ss:"%d imik",m:"minuḍ",mm:"%d minuḍ",h:"saɛa",hh:"%d tassaɛin",d:"ass",dd:"%d ossan",M:"ayowr",MM:"%d iyyirn",y:"asgas",yy:"%d isgasn"},week:{dow:6,doy:12}})}(n(41655))},69631:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("tzm",{months:"ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ".split("_"),monthsShort:"ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ".split("_"),weekdays:"ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),weekdaysShort:"ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),weekdaysMin:"ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[ⴰⵙⴷⵅ ⴴ] LT",nextDay:"[ⴰⵙⴽⴰ ⴴ] LT",nextWeek:"dddd [ⴴ] LT",lastDay:"[ⴰⵚⴰⵏⵜ ⴴ] LT",lastWeek:"dddd [ⴴ] LT",sameElse:"L"},relativeTime:{future:"ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s",past:"ⵢⴰⵏ %s",s:"ⵉⵎⵉⴽ",ss:"%d ⵉⵎⵉⴽ",m:"ⵎⵉⵏⵓⴺ",mm:"%d ⵎⵉⵏⵓⴺ",h:"ⵙⴰⵄⴰ",hh:"%d ⵜⴰⵙⵙⴰⵄⵉⵏ",d:"ⴰⵙⵙ",dd:"%d oⵙⵙⴰⵏ",M:"ⴰⵢoⵓⵔ",MM:"%d ⵉⵢⵢⵉⵔⵏ",y:"ⴰⵙⴳⴰⵙ",yy:"%d ⵉⵙⴳⴰⵙⵏ"},week:{dow:6,doy:12}})}(n(41655))},71720:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("ug-cn",{months:"يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر".split("_"),monthsShort:"يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر".split("_"),weekdays:"يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە".split("_"),weekdaysShort:"يە_دۈ_سە_چا_پە_جۈ_شە".split("_"),weekdaysMin:"يە_دۈ_سە_چا_پە_جۈ_شە".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY-يىلىM-ئاينىڭD-كۈنى",LLL:"YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm",LLLL:"dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm"},meridiemParse:/يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,meridiemHour:function(e,t){return 12===e&&(e=0),"يېرىم كېچە"===t||"سەھەر"===t||"چۈشتىن بۇرۇن"===t?e:"چۈشتىن كېيىن"===t||"كەچ"===t?e+12:e>=11?e:e+12},meridiem:function(e,t,n){var r=100*e+t;return r<600?"يېرىم كېچە":r<900?"سەھەر":r<1130?"چۈشتىن بۇرۇن":r<1230?"چۈش":r<1800?"چۈشتىن كېيىن":"كەچ"},calendar:{sameDay:"[بۈگۈن سائەت] LT",nextDay:"[ئەتە سائەت] LT",nextWeek:"[كېلەركى] dddd [سائەت] LT",lastDay:"[تۆنۈگۈن] LT",lastWeek:"[ئالدىنقى] dddd [سائەت] LT",sameElse:"L"},relativeTime:{future:"%s كېيىن",past:"%s بۇرۇن",s:"نەچچە سېكونت",ss:"%d سېكونت",m:"بىر مىنۇت",mm:"%d مىنۇت",h:"بىر سائەت",hh:"%d سائەت",d:"بىر كۈن",dd:"%d كۈن",M:"بىر ئاي",MM:"%d ئاي",y:"بىر يىل",yy:"%d يىل"},dayOfMonthOrdinalParse:/\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,ordinal:function(e,t){switch(t){case"d":case"D":case"DDD":return e+"-كۈنى";case"w":case"W":return e+"-ھەپتە";default:return e}},preparse:function(e){return e.replace(/،/g,",")},postformat:function(e){return e.replace(/,/g,"،")},week:{dow:1,doy:7}})}(n(41655))},28048:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
function t(e,t){var n=e.split("_");return t%10==1&&t%100!=11?n[0]:t%10>=2&&t%10<=4&&(t%100<10||t%100>=20)?n[1]:n[2]}function n(e,n,r){return"m"===r?n?"хвилина":"хвилину":"h"===r?n?"година":"годину":e+" "+t({ss:n?"секунда_секунди_секунд":"секунду_секунди_секунд",mm:n?"хвилина_хвилини_хвилин":"хвилину_хвилини_хвилин",hh:n?"година_години_годин":"годину_години_годин",dd:"день_дні_днів",MM:"місяць_місяці_місяців",yy:"рік_роки_років"}[r],+e)}function r(e,t){var n={nominative:"неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота".split("_"),accusative:"неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу".split("_"),genitive:"неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи".split("_")};return!0===e?n.nominative.slice(1,7).concat(n.nominative.slice(0,1)):e?n[/(\[[ВвУу]\]) ?dddd/.test(t)?"accusative":/\[?(?:минулої|наступної)? ?\] ?dddd/.test(t)?"genitive":"nominative"][e.day()]:n.nominative}function o(e){return function(){return e+"о"+(11===this.hours()?"б":"")+"] LT"}}e.defineLocale("uk",{months:{format:"січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня".split("_"),standalone:"січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень".split("_")},monthsShort:"січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд".split("_"),weekdays:r,weekdaysShort:"нд_пн_вт_ср_чт_пт_сб".split("_"),weekdaysMin:"нд_пн_вт_ср_чт_пт_сб".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY р.",LLL:"D MMMM YYYY р., HH:mm",LLLL:"dddd, D MMMM YYYY р., HH:mm"},calendar:{sameDay:o("[Сьогодні "),nextDay:o("[Завтра "),lastDay:o("[Вчора "),nextWeek:o("[У] dddd ["),lastWeek:function(){switch(this.day()){case 0:case 3:case 5:case 6:return o("[Минулої] dddd [").call(this);case 1:case 2:case 4:return o("[Минулого] dddd [").call(this)}},sameElse:"L"},relativeTime:{future:"за %s",past:"%s тому",s:"декілька секунд",ss:n,m:n,mm:n,h:"годину",hh:n,d:"день",dd:n,M:"місяць",MM:n,y:"рік",yy:n},meridiemParse:/ночі|ранку|дня|вечора/,isPM:function(e){return/^(дня|вечора)$/.test(e)},meridiem:function(e,t,n){return e<4?"ночі":e<12?"ранку":e<17?"дня":"вечора"},dayOfMonthOrdinalParse:/\d{1,2}-(й|го)/,ordinal:function(e,t){switch(t){case"M":case"d":case"DDD":case"w":case"W":return e+"-й";case"D":return e+"-го";default:return e}},week:{dow:1,doy:7}})}(n(41655))},86751:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
var t=["جنوری","فروری","مارچ","اپریل","مئی","جون","جولائی","اگست","ستمبر","اکتوبر","نومبر","دسمبر"],n=["اتوار","پیر","منگل","بدھ","جمعرات","جمعہ","ہفتہ"];e.defineLocale("ur",{months:t,monthsShort:t,weekdays:n,weekdaysShort:n,weekdaysMin:n,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd، D MMMM YYYY HH:mm"},meridiemParse:/صبح|شام/,isPM:function(e){return"شام"===e},meridiem:function(e,t,n){return e<12?"صبح":"شام"},calendar:{sameDay:"[آج بوقت] LT",nextDay:"[کل بوقت] LT",nextWeek:"dddd [بوقت] LT",lastDay:"[گذشتہ روز بوقت] LT",lastWeek:"[گذشتہ] dddd [بوقت] LT",sameElse:"L"},relativeTime:{future:"%s بعد",past:"%s قبل",s:"چند سیکنڈ",ss:"%d سیکنڈ",m:"ایک منٹ",mm:"%d منٹ",h:"ایک گھنٹہ",hh:"%d گھنٹے",d:"ایک دن",dd:"%d دن",M:"ایک ماہ",MM:"%d ماہ",y:"ایک سال",yy:"%d سال"},preparse:function(e){return e.replace(/،/g,",")},postformat:function(e){return e.replace(/,/g,"،")},week:{dow:1,doy:4}})}(n(41655))},60513:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("uz-latn",{months:"Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr".split("_"),monthsShort:"Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek".split("_"),weekdays:"Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba".split("_"),weekdaysShort:"Yak_Dush_Sesh_Chor_Pay_Jum_Shan".split("_"),weekdaysMin:"Ya_Du_Se_Cho_Pa_Ju_Sha".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"D MMMM YYYY, dddd HH:mm"},calendar:{sameDay:"[Bugun soat] LT [da]",nextDay:"[Ertaga] LT [da]",nextWeek:"dddd [kuni soat] LT [da]",lastDay:"[Kecha soat] LT [da]",lastWeek:"[O'tgan] dddd [kuni soat] LT [da]",sameElse:"L"},relativeTime:{future:"Yaqin %s ichida",past:"Bir necha %s oldin",s:"soniya",ss:"%d soniya",m:"bir daqiqa",mm:"%d daqiqa",h:"bir soat",hh:"%d soat",d:"bir kun",dd:"%d kun",M:"bir oy",MM:"%d oy",y:"bir yil",yy:"%d yil"},week:{dow:1,doy:7}})}(n(41655))},96343:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("uz",{months:"январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр".split("_"),monthsShort:"янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек".split("_"),weekdays:"Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба".split("_"),weekdaysShort:"Якш_Душ_Сеш_Чор_Пай_Жум_Шан".split("_"),weekdaysMin:"Як_Ду_Се_Чо_Па_Жу_Ша".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"D MMMM YYYY, dddd HH:mm"},calendar:{sameDay:"[Бугун соат] LT [да]",nextDay:"[Эртага] LT [да]",nextWeek:"dddd [куни соат] LT [да]",lastDay:"[Кеча соат] LT [да]",lastWeek:"[Утган] dddd [куни соат] LT [да]",sameElse:"L"},relativeTime:{future:"Якин %s ичида",past:"Бир неча %s олдин",s:"фурсат",ss:"%d фурсат",m:"бир дакика",mm:"%d дакика",h:"бир соат",hh:"%d соат",d:"бир кун",dd:"%d кун",M:"бир ой",MM:"%d ой",y:"бир йил",yy:"%d йил"},week:{dow:1,doy:7}})}(n(41655))},44821:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("vi",{months:"tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12".split("_"),monthsShort:"Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12".split("_"),monthsParseExact:!0,weekdays:"chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy".split("_"),weekdaysShort:"CN_T2_T3_T4_T5_T6_T7".split("_"),weekdaysMin:"CN_T2_T3_T4_T5_T6_T7".split("_"),weekdaysParseExact:!0,meridiemParse:/sa|ch/i,isPM:function(e){return/^ch$/i.test(e)},meridiem:function(e,t,n){return e<12?n?"sa":"SA":n?"ch":"CH"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [năm] YYYY",LLL:"D MMMM [năm] YYYY HH:mm",LLLL:"dddd, D MMMM [năm] YYYY HH:mm",l:"DD/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY HH:mm",llll:"ddd, D MMM YYYY HH:mm"},calendar:{sameDay:"[Hôm nay lúc] LT",nextDay:"[Ngày mai lúc] LT",nextWeek:"dddd [tuần tới lúc] LT",lastDay:"[Hôm qua lúc] LT",lastWeek:"dddd [tuần trước lúc] LT",sameElse:"L"},relativeTime:{future:"%s tới",past:"%s trước",s:"vài giây",ss:"%d giây",m:"một phút",mm:"%d phút",h:"một giờ",hh:"%d giờ",d:"một ngày",dd:"%d ngày",w:"một tuần",ww:"%d tuần",M:"một tháng",MM:"%d tháng",y:"một năm",yy:"%d năm"},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}})}(n(41655))},23973:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("x-pseudo",{months:"J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér".split("_"),monthsShort:"J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc".split("_"),monthsParseExact:!0,weekdays:"S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý".split("_"),weekdaysShort:"S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát".split("_"),weekdaysMin:"S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[T~ódá~ý át] LT",nextDay:"[T~ómó~rró~w át] LT",nextWeek:"dddd [át] LT",lastDay:"[Ý~ést~érdá~ý át] LT",lastWeek:"[L~ást] dddd [át] LT",sameElse:"L"},relativeTime:{future:"í~ñ %s",past:"%s á~gó",s:"á ~féw ~sécó~ñds",ss:"%d s~écóñ~ds",m:"á ~míñ~úté",mm:"%d m~íñú~tés",h:"á~ñ hó~úr",hh:"%d h~óúrs",d:"á ~dáý",dd:"%d d~áýs",M:"á ~móñ~th",MM:"%d m~óñt~hs",y:"á ~ýéár",yy:"%d ý~éárs"},dayOfMonthOrdinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var t=e%10;return e+(1==~~(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th")},week:{dow:1,doy:4}})}(n(41655))},15e3:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("yo",{months:"Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀".split("_"),monthsShort:"Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀".split("_"),weekdays:"Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta".split("_"),weekdaysShort:"Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá".split("_"),weekdaysMin:"Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Ònì ni] LT",nextDay:"[Ọ̀la ni] LT",nextWeek:"dddd [Ọsẹ̀ tón'bọ] [ni] LT",lastDay:"[Àna ni] LT",lastWeek:"dddd [Ọsẹ̀ tólọ́] [ni] LT",sameElse:"L"},relativeTime:{future:"ní %s",past:"%s kọjá",s:"ìsẹjú aayá die",ss:"aayá %d",m:"ìsẹjú kan",mm:"ìsẹjú %d",h:"wákati kan",hh:"wákati %d",d:"ọjọ́ kan",dd:"ọjọ́ %d",M:"osù kan",MM:"osù %d",y:"ọdún kan",yy:"ọdún %d"},dayOfMonthOrdinalParse:/ọjọ́\s\d{1,2}/,ordinal:"ọjọ́ %d",week:{dow:1,doy:4}})}(n(41655))},43762:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("zh-cn",{months:"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),weekdaysShort:"周日_周一_周二_周三_周四_周五_周六".split("_"),weekdaysMin:"日_一_二_三_四_五_六".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY年M月D日",LLL:"YYYY年M月D日Ah点mm分",LLLL:"YYYY年M月D日ddddAh点mm分",l:"YYYY/M/D",ll:"YYYY年M月D日",lll:"YYYY年M月D日 HH:mm",llll:"YYYY年M月D日dddd HH:mm"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(e,t){return 12===e&&(e=0),"凌晨"===t||"早上"===t||"上午"===t?e:"下午"===t||"晚上"===t?e+12:e>=11?e:e+12},meridiem:function(e,t,n){var r=100*e+t;return r<600?"凌晨":r<900?"早上":r<1130?"上午":r<1230?"中午":r<1800?"下午":"晚上"},calendar:{sameDay:"[今天]LT",nextDay:"[明天]LT",nextWeek:function(e){return e.week()!==this.week()?"[下]dddLT":"[本]dddLT"},lastDay:"[昨天]LT",lastWeek:function(e){return this.week()!==e.week()?"[上]dddLT":"[本]dddLT"},sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(日|月|周)/,ordinal:function(e,t){switch(t){case"d":case"D":case"DDD":return e+"日";case"M":return e+"月";case"w":case"W":return e+"周";default:return e}},relativeTime:{future:"%s后",past:"%s前",s:"几秒",ss:"%d 秒",m:"1 分钟",mm:"%d 分钟",h:"1 小时",hh:"%d 小时",d:"1 天",dd:"%d 天",w:"1 周",ww:"%d 周",M:"1 个月",MM:"%d 个月",y:"1 年",yy:"%d 年"},week:{dow:1,doy:4}})}(n(41655))},9246:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("zh-hk",{months:"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),weekdaysShort:"週日_週一_週二_週三_週四_週五_週六".split("_"),weekdaysMin:"日_一_二_三_四_五_六".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY年M月D日",LLL:"YYYY年M月D日 HH:mm",LLLL:"YYYY年M月D日dddd HH:mm",l:"YYYY/M/D",ll:"YYYY年M月D日",lll:"YYYY年M月D日 HH:mm",llll:"YYYY年M月D日dddd HH:mm"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(e,t){return 12===e&&(e=0),"凌晨"===t||"早上"===t||"上午"===t?e:"中午"===t?e>=11?e:e+12:"下午"===t||"晚上"===t?e+12:void 0},meridiem:function(e,t,n){var r=100*e+t;return r<600?"凌晨":r<900?"早上":r<1200?"上午":1200===r?"中午":r<1800?"下午":"晚上"},calendar:{sameDay:"[今天]LT",nextDay:"[明天]LT",nextWeek:"[下]ddddLT",lastDay:"[昨天]LT",lastWeek:"[上]ddddLT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(日|月|週)/,ordinal:function(e,t){switch(t){case"d":case"D":case"DDD":return e+"日";case"M":return e+"月";case"w":case"W":return e+"週";default:return e}},relativeTime:{future:"%s後",past:"%s前",s:"幾秒",ss:"%d 秒",m:"1 分鐘",mm:"%d 分鐘",h:"1 小時",hh:"%d 小時",d:"1 天",dd:"%d 天",M:"1 個月",MM:"%d 個月",y:"1 年",yy:"%d 年"}})}(n(41655))},41107:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("zh-mo",{months:"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),weekdaysShort:"週日_週一_週二_週三_週四_週五_週六".split("_"),weekdaysMin:"日_一_二_三_四_五_六".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"YYYY年M月D日",LLL:"YYYY年M月D日 HH:mm",LLLL:"YYYY年M月D日dddd HH:mm",l:"D/M/YYYY",ll:"YYYY年M月D日",lll:"YYYY年M月D日 HH:mm",llll:"YYYY年M月D日dddd HH:mm"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(e,t){return 12===e&&(e=0),"凌晨"===t||"早上"===t||"上午"===t?e:"中午"===t?e>=11?e:e+12:"下午"===t||"晚上"===t?e+12:void 0},meridiem:function(e,t,n){var r=100*e+t;return r<600?"凌晨":r<900?"早上":r<1130?"上午":r<1230?"中午":r<1800?"下午":"晚上"},calendar:{sameDay:"[今天] LT",nextDay:"[明天] LT",nextWeek:"[下]dddd LT",lastDay:"[昨天] LT",lastWeek:"[上]dddd LT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(日|月|週)/,ordinal:function(e,t){switch(t){case"d":case"D":case"DDD":return e+"日";case"M":return e+"月";case"w":case"W":return e+"週";default:return e}},relativeTime:{future:"%s內",past:"%s前",s:"幾秒",ss:"%d 秒",m:"1 分鐘",mm:"%d 分鐘",h:"1 小時",hh:"%d 小時",d:"1 天",dd:"%d 天",M:"1 個月",MM:"%d 個月",y:"1 年",yy:"%d 年"}})}(n(41655))},79014:function(e,t,n){!function(e){"use strict";
//! moment.js locale configuration
e.defineLocale("zh-tw",{months:"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),weekdaysShort:"週日_週一_週二_週三_週四_週五_週六".split("_"),weekdaysMin:"日_一_二_三_四_五_六".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY年M月D日",LLL:"YYYY年M月D日 HH:mm",LLLL:"YYYY年M月D日dddd HH:mm",l:"YYYY/M/D",ll:"YYYY年M月D日",lll:"YYYY年M月D日 HH:mm",llll:"YYYY年M月D日dddd HH:mm"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(e,t){return 12===e&&(e=0),"凌晨"===t||"早上"===t||"上午"===t?e:"中午"===t?e>=11?e:e+12:"下午"===t||"晚上"===t?e+12:void 0},meridiem:function(e,t,n){var r=100*e+t;return r<600?"凌晨":r<900?"早上":r<1130?"上午":r<1230?"中午":r<1800?"下午":"晚上"},calendar:{sameDay:"[今天] LT",nextDay:"[明天] LT",nextWeek:"[下]dddd LT",lastDay:"[昨天] LT",lastWeek:"[上]dddd LT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(日|月|週)/,ordinal:function(e,t){switch(t){case"d":case"D":case"DDD":return e+"日";case"M":return e+"月";case"w":case"W":return e+"週";default:return e}},relativeTime:{future:"%s後",past:"%s前",s:"幾秒",ss:"%d 秒",m:"1 分鐘",mm:"%d 分鐘",h:"1 小時",hh:"%d 小時",d:"1 天",dd:"%d 天",M:"1 個月",MM:"%d 個月",y:"1 年",yy:"%d 年"}})}(n(41655))},41655:function(e,t,n){(e=n.nmd(e)).exports=function(){"use strict";var t,r;function o(){return t.apply(null,arguments)}function i(e){t=e}function a(e){return e instanceof Array||"[object Array]"===Object.prototype.toString.call(e)}function s(e){return null!=e&&"[object Object]"===Object.prototype.toString.call(e)}function l(e,t){return Object.prototype.hasOwnProperty.call(e,t)}function c(e){if(Object.getOwnPropertyNames)return 0===Object.getOwnPropertyNames(e).length;var t;for(t in e)if(l(e,t))return!1;return!0}function u(e){return void 0===e}function d(e){return"number"==typeof e||"[object Number]"===Object.prototype.toString.call(e)}function p(e){return e instanceof Date||"[object Date]"===Object.prototype.toString.call(e)}function f(e,t){var n,r=[],o=e.length;for(n=0;n<o;++n)r.push(t(e[n],n));return r}function h(e,t){for(var n in t)l(t,n)&&(e[n]=t[n]);return l(t,"toString")&&(e.toString=t.toString),l(t,"valueOf")&&(e.valueOf=t.valueOf),e}function m(e,t,n,r){return qn(e,t,n,r,!0).utc()}function g(){return{empty:!1,unusedTokens:[],unusedInput:[],overflow:-2,charsLeftOver:0,nullInput:!1,invalidEra:null,invalidMonth:null,invalidFormat:!1,userInvalidated:!1,iso:!1,parsedDateParts:[],era:null,meridiem:null,rfc2822:!1,weekdayMismatch:!1}}function v(e){return null==e._pf&&(e._pf=g()),e._pf}function y(e){var t=null,n=!1,o=e._d&&!isNaN(e._d.getTime());return o&&(t=v(e),n=r.call(t.parsedDateParts,(function(e){return null!=e})),o=t.overflow<0&&!t.empty&&!t.invalidEra&&!t.invalidMonth&&!t.invalidWeekday&&!t.weekdayMismatch&&!t.nullInput&&!t.invalidFormat&&!t.userInvalidated&&(!t.meridiem||t.meridiem&&n),e._strict&&(o=o&&0===t.charsLeftOver&&0===t.unusedTokens.length&&void 0===t.bigHour)),null!=Object.isFrozen&&Object.isFrozen(e)?o:(e._isValid=o,e._isValid)}function b(e){var t=m(NaN);return null!=e?h(v(t),e):v(t).userInvalidated=!0,t}r=Array.prototype.some?Array.prototype.some:function(e){var t,n=Object(this),r=n.length>>>0;for(t=0;t<r;t++)if(t in n&&e.call(this,n[t],t,n))return!0;return!1};var _=o.momentProperties=[],A=!1;function E(e,t){var n,r,o,i=_.length;if(u(t._isAMomentObject)||(e._isAMomentObject=t._isAMomentObject),u(t._i)||(e._i=t._i),u(t._f)||(e._f=t._f),u(t._l)||(e._l=t._l),u(t._strict)||(e._strict=t._strict),u(t._tzm)||(e._tzm=t._tzm),u(t._isUTC)||(e._isUTC=t._isUTC),u(t._offset)||(e._offset=t._offset),u(t._pf)||(e._pf=v(t)),u(t._locale)||(e._locale=t._locale),i>0)for(n=0;n<i;n++)u(o=t[r=_[n]])||(e[r]=o);return e}function w(e){E(this,e),this._d=new Date(null!=e._d?e._d.getTime():NaN),this.isValid()||(this._d=new Date(NaN)),!1===A&&(A=!0,o.updateOffset(this),A=!1)}function x(e){return e instanceof w||null!=e&&null!=e._isAMomentObject}function k(e){!1===o.suppressDeprecationWarnings&&"undefined"!=typeof console&&console.warn&&console.warn("Deprecation warning: "+e)}function C(e,t){var n=!0;return h((function(){if(null!=o.deprecationHandler&&o.deprecationHandler(null,e),n){var r,i,a,s=[],c=arguments.length;for(i=0;i<c;i++){if(r="","object"==typeof arguments[i]){for(a in r+="\n["+i+"] ",arguments[0])l(arguments[0],a)&&(r+=a+": "+arguments[0][a]+", ");r=r.slice(0,-2)}else r=arguments[i];s.push(r)}k(e+"\nArguments: "+Array.prototype.slice.call(s).join("")+"\n"+(new Error).stack),n=!1}return t.apply(this,arguments)}),t)}var S,M={};function T(e,t){null!=o.deprecationHandler&&o.deprecationHandler(e,t),M[e]||(k(t),M[e]=!0)}function O(e){return"undefined"!=typeof Function&&e instanceof Function||"[object Function]"===Object.prototype.toString.call(e)}function D(e){var t,n;for(n in e)l(e,n)&&(O(t=e[n])?this[n]=t:this["_"+n]=t);this._config=e,this._dayOfMonthOrdinalParseLenient=new RegExp((this._dayOfMonthOrdinalParse.source||this._ordinalParse.source)+"|"+/\d{1,2}/.source)}function L(e,t){var n,r=h({},e);for(n in t)l(t,n)&&(s(e[n])&&s(t[n])?(r[n]={},h(r[n],e[n]),h(r[n],t[n])):null!=t[n]?r[n]=t[n]:delete r[n]);for(n in e)l(e,n)&&!l(t,n)&&s(e[n])&&(r[n]=h({},r[n]));return r}function P(e){null!=e&&this.set(e)}o.suppressDeprecationWarnings=!1,o.deprecationHandler=null,S=Object.keys?Object.keys:function(e){var t,n=[];for(t in e)l(e,t)&&n.push(t);return n};var I={sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"};function B(e,t,n){var r=this._calendar[e]||this._calendar.sameElse;return O(r)?r.call(t,n):r}function R(e,t,n){var r=""+Math.abs(e),o=t-r.length;return(e>=0?n?"+":"":"-")+Math.pow(10,Math.max(0,o)).toString().substr(1)+r}var N=/(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,F=/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,j={},Y={};function $(e,t,n,r){var o=r;"string"==typeof r&&(o=function(){return this[r]()}),e&&(Y[e]=o),t&&(Y[t[0]]=function(){return R(o.apply(this,arguments),t[1],t[2])}),n&&(Y[n]=function(){return this.localeData().ordinal(o.apply(this,arguments),e)})}function H(e){return e.match(/\[[\s\S]/)?e.replace(/^\[|\]$/g,""):e.replace(/\\/g,"")}function U(e){var t,n,r=e.match(N);for(t=0,n=r.length;t<n;t++)Y[r[t]]?r[t]=Y[r[t]]:r[t]=H(r[t]);return function(t){var o,i="";for(o=0;o<n;o++)i+=O(r[o])?r[o].call(t,e):r[o];return i}}function z(e,t){return e.isValid()?(t=W(t,e.localeData()),j[t]=j[t]||U(t),j[t](e)):e.localeData().invalidDate()}function W(e,t){var n=5;function r(e){return t.longDateFormat(e)||e}for(F.lastIndex=0;n>=0&&F.test(e);)e=e.replace(F,r),F.lastIndex=0,n-=1;return e}var V={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"};function G(e){var t=this._longDateFormat[e],n=this._longDateFormat[e.toUpperCase()];return t||!n?t:(this._longDateFormat[e]=n.match(N).map((function(e){return"MMMM"===e||"MM"===e||"DD"===e||"dddd"===e?e.slice(1):e})).join(""),this._longDateFormat[e])}var Q="Invalid date";function q(){return this._invalidDate}var K="%d",Z=/\d{1,2}/;function J(e){return this._ordinal.replace("%d",e)}var X={future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",w:"a week",ww:"%d weeks",M:"a month",MM:"%d months",y:"a year",yy:"%d years"};function ee(e,t,n,r){var o=this._relativeTime[n];return O(o)?o(e,t,n,r):o.replace(/%d/i,e)}function te(e,t){var n=this._relativeTime[e>0?"future":"past"];return O(n)?n(t):n.replace(/%s/i,t)}var ne={D:"date",dates:"date",date:"date",d:"day",days:"day",day:"day",e:"weekday",weekdays:"weekday",weekday:"weekday",E:"isoWeekday",isoweekdays:"isoWeekday",isoweekday:"isoWeekday",DDD:"dayOfYear",dayofyears:"dayOfYear",dayofyear:"dayOfYear",h:"hour",hours:"hour",hour:"hour",ms:"millisecond",milliseconds:"millisecond",millisecond:"millisecond",m:"minute",minutes:"minute",minute:"minute",M:"month",months:"month",month:"month",Q:"quarter",quarters:"quarter",quarter:"quarter",s:"second",seconds:"second",second:"second",gg:"weekYear",weekyears:"weekYear",weekyear:"weekYear",GG:"isoWeekYear",isoweekyears:"isoWeekYear",isoweekyear:"isoWeekYear",w:"week",weeks:"week",week:"week",W:"isoWeek",isoweeks:"isoWeek",isoweek:"isoWeek",y:"year",years:"year",year:"year"};function re(e){return"string"==typeof e?ne[e]||ne[e.toLowerCase()]:void 0}function oe(e){var t,n,r={};for(n in e)l(e,n)&&(t=re(n))&&(r[t]=e[n]);return r}var ie={date:9,day:11,weekday:11,isoWeekday:11,dayOfYear:4,hour:13,millisecond:16,minute:14,month:8,quarter:7,second:15,weekYear:1,isoWeekYear:1,week:5,isoWeek:5,year:1};function ae(e){var t,n=[];for(t in e)l(e,t)&&n.push({unit:t,priority:ie[t]});return n.sort((function(e,t){return e.priority-t.priority})),n}var se,le=/\d/,ce=/\d\d/,ue=/\d{3}/,de=/\d{4}/,pe=/[+-]?\d{6}/,fe=/\d\d?/,he=/\d\d\d\d?/,me=/\d\d\d\d\d\d?/,ge=/\d{1,3}/,ve=/\d{1,4}/,ye=/[+-]?\d{1,6}/,be=/\d+/,_e=/[+-]?\d+/,Ae=/Z|[+-]\d\d:?\d\d/gi,Ee=/Z|[+-]\d\d(?::?\d\d)?/gi,we=/[+-]?\d+(\.\d{1,3})?/,xe=/[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,ke=/^[1-9]\d?/,Ce=/^([1-9]\d|\d)/;function Se(e,t,n){se[e]=O(t)?t:function(e,r){return e&&n?n:t}}function Me(e,t){return l(se,e)?se[e](t._strict,t._locale):new RegExp(Te(e))}function Te(e){return Oe(e.replace("\\","").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,(function(e,t,n,r,o){return t||n||r||o})))}function Oe(e){return e.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&")}function De(e){return e<0?Math.ceil(e)||0:Math.floor(e)}function Le(e){var t=+e,n=0;return 0!==t&&isFinite(t)&&(n=De(t)),n}se={};var Pe={};function Ie(e,t){var n,r,o=t;for("string"==typeof e&&(e=[e]),d(t)&&(o=function(e,n){n[t]=Le(e)}),r=e.length,n=0;n<r;n++)Pe[e[n]]=o}function Be(e,t){Ie(e,(function(e,n,r,o){r._w=r._w||{},t(e,r._w,r,o)}))}function Re(e,t,n){null!=t&&l(Pe,e)&&Pe[e](t,n._a,n,e)}function Ne(e){return e%4==0&&e%100!=0||e%400==0}var Fe=0,je=1,Ye=2,$e=3,He=4,Ue=5,ze=6,We=7,Ve=8;function Ge(e){return Ne(e)?366:365}$("Y",0,0,(function(){var e=this.year();return e<=9999?R(e,4):"+"+e})),$(0,["YY",2],0,(function(){return this.year()%100})),$(0,["YYYY",4],0,"year"),$(0,["YYYYY",5],0,"year"),$(0,["YYYYYY",6,!0],0,"year"),Se("Y",_e),Se("YY",fe,ce),Se("YYYY",ve,de),Se("YYYYY",ye,pe),Se("YYYYYY",ye,pe),Ie(["YYYYY","YYYYYY"],Fe),Ie("YYYY",(function(e,t){t[Fe]=2===e.length?o.parseTwoDigitYear(e):Le(e)})),Ie("YY",(function(e,t){t[Fe]=o.parseTwoDigitYear(e)})),Ie("Y",(function(e,t){t[Fe]=parseInt(e,10)})),o.parseTwoDigitYear=function(e){return Le(e)+(Le(e)>68?1900:2e3)};var Qe,qe=Ze("FullYear",!0);function Ke(){return Ne(this.year())}function Ze(e,t){return function(n){return null!=n?(Xe(this,e,n),o.updateOffset(this,t),this):Je(this,e)}}function Je(e,t){if(!e.isValid())return NaN;var n=e._d,r=e._isUTC;switch(t){case"Milliseconds":return r?n.getUTCMilliseconds():n.getMilliseconds();case"Seconds":return r?n.getUTCSeconds():n.getSeconds();case"Minutes":return r?n.getUTCMinutes():n.getMinutes();case"Hours":return r?n.getUTCHours():n.getHours();case"Date":return r?n.getUTCDate():n.getDate();case"Day":return r?n.getUTCDay():n.getDay();case"Month":return r?n.getUTCMonth():n.getMonth();case"FullYear":return r?n.getUTCFullYear():n.getFullYear();default:return NaN}}function Xe(e,t,n){var r,o,i,a,s;if(e.isValid()&&!isNaN(n)){switch(r=e._d,o=e._isUTC,t){case"Milliseconds":return void(o?r.setUTCMilliseconds(n):r.setMilliseconds(n));case"Seconds":return void(o?r.setUTCSeconds(n):r.setSeconds(n));case"Minutes":return void(o?r.setUTCMinutes(n):r.setMinutes(n));case"Hours":return void(o?r.setUTCHours(n):r.setHours(n));case"Date":return void(o?r.setUTCDate(n):r.setDate(n));case"FullYear":break;default:return}i=n,a=e.month(),s=29!==(s=e.date())||1!==a||Ne(i)?s:28,o?r.setUTCFullYear(i,a,s):r.setFullYear(i,a,s)}}function et(e){return O(this[e=re(e)])?this[e]():this}function tt(e,t){if("object"==typeof e){var n,r=ae(e=oe(e)),o=r.length;for(n=0;n<o;n++)this[r[n].unit](e[r[n].unit])}else if(O(this[e=re(e)]))return this[e](t);return this}function nt(e,t){return(e%t+t)%t}function rt(e,t){if(isNaN(e)||isNaN(t))return NaN;var n=nt(t,12);return e+=(t-n)/12,1===n?Ne(e)?29:28:31-n%7%2}Qe=Array.prototype.indexOf?Array.prototype.indexOf:function(e){var t;for(t=0;t<this.length;++t)if(this[t]===e)return t;return-1},$("M",["MM",2],"Mo",(function(){return this.month()+1})),$("MMM",0,0,(function(e){return this.localeData().monthsShort(this,e)})),$("MMMM",0,0,(function(e){return this.localeData().months(this,e)})),Se("M",fe,ke),Se("MM",fe,ce),Se("MMM",(function(e,t){return t.monthsShortRegex(e)})),Se("MMMM",(function(e,t){return t.monthsRegex(e)})),Ie(["M","MM"],(function(e,t){t[je]=Le(e)-1})),Ie(["MMM","MMMM"],(function(e,t,n,r){var o=n._locale.monthsParse(e,r,n._strict);null!=o?t[je]=o:v(n).invalidMonth=e}));var ot="January_February_March_April_May_June_July_August_September_October_November_December".split("_"),it="Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),at=/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,st=xe,lt=xe;function ct(e,t){return e?a(this._months)?this._months[e.month()]:this._months[(this._months.isFormat||at).test(t)?"format":"standalone"][e.month()]:a(this._months)?this._months:this._months.standalone}function ut(e,t){return e?a(this._monthsShort)?this._monthsShort[e.month()]:this._monthsShort[at.test(t)?"format":"standalone"][e.month()]:a(this._monthsShort)?this._monthsShort:this._monthsShort.standalone}function dt(e,t,n){var r,o,i,a=e.toLocaleLowerCase();if(!this._monthsParse)for(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[],r=0;r<12;++r)i=m([2e3,r]),this._shortMonthsParse[r]=this.monthsShort(i,"").toLocaleLowerCase(),this._longMonthsParse[r]=this.months(i,"").toLocaleLowerCase();return n?"MMM"===t?-1!==(o=Qe.call(this._shortMonthsParse,a))?o:null:-1!==(o=Qe.call(this._longMonthsParse,a))?o:null:"MMM"===t?-1!==(o=Qe.call(this._shortMonthsParse,a))||-1!==(o=Qe.call(this._longMonthsParse,a))?o:null:-1!==(o=Qe.call(this._longMonthsParse,a))||-1!==(o=Qe.call(this._shortMonthsParse,a))?o:null}function pt(e,t,n){var r,o,i;if(this._monthsParseExact)return dt.call(this,e,t,n);for(this._monthsParse||(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[]),r=0;r<12;r++){if(o=m([2e3,r]),n&&!this._longMonthsParse[r]&&(this._longMonthsParse[r]=new RegExp("^"+this.months(o,"").replace(".","")+"$","i"),this._shortMonthsParse[r]=new RegExp("^"+this.monthsShort(o,"").replace(".","")+"$","i")),n||this._monthsParse[r]||(i="^"+this.months(o,"")+"|^"+this.monthsShort(o,""),this._monthsParse[r]=new RegExp(i.replace(".",""),"i")),n&&"MMMM"===t&&this._longMonthsParse[r].test(e))return r;if(n&&"MMM"===t&&this._shortMonthsParse[r].test(e))return r;if(!n&&this._monthsParse[r].test(e))return r}}function ft(e,t){if(!e.isValid())return e;if("string"==typeof t)if(/^\d+$/.test(t))t=Le(t);else if(!d(t=e.localeData().monthsParse(t)))return e;var n=t,r=e.date();return r=r<29?r:Math.min(r,rt(e.year(),n)),e._isUTC?e._d.setUTCMonth(n,r):e._d.setMonth(n,r),e}function ht(e){return null!=e?(ft(this,e),o.updateOffset(this,!0),this):Je(this,"Month")}function mt(){return rt(this.year(),this.month())}function gt(e){return this._monthsParseExact?(l(this,"_monthsRegex")||yt.call(this),e?this._monthsShortStrictRegex:this._monthsShortRegex):(l(this,"_monthsShortRegex")||(this._monthsShortRegex=st),this._monthsShortStrictRegex&&e?this._monthsShortStrictRegex:this._monthsShortRegex)}function vt(e){return this._monthsParseExact?(l(this,"_monthsRegex")||yt.call(this),e?this._monthsStrictRegex:this._monthsRegex):(l(this,"_monthsRegex")||(this._monthsRegex=lt),this._monthsStrictRegex&&e?this._monthsStrictRegex:this._monthsRegex)}function yt(){function e(e,t){return t.length-e.length}var t,n,r,o,i=[],a=[],s=[];for(t=0;t<12;t++)n=m([2e3,t]),r=Oe(this.monthsShort(n,"")),o=Oe(this.months(n,"")),i.push(r),a.push(o),s.push(o),s.push(r);i.sort(e),a.sort(e),s.sort(e),this._monthsRegex=new RegExp("^("+s.join("|")+")","i"),this._monthsShortRegex=this._monthsRegex,this._monthsStrictRegex=new RegExp("^("+a.join("|")+")","i"),this._monthsShortStrictRegex=new RegExp("^("+i.join("|")+")","i")}function bt(e,t,n,r,o,i,a){var s;return e<100&&e>=0?(s=new Date(e+400,t,n,r,o,i,a),isFinite(s.getFullYear())&&s.setFullYear(e)):s=new Date(e,t,n,r,o,i,a),s}function _t(e){var t,n;return e<100&&e>=0?((n=Array.prototype.slice.call(arguments))[0]=e+400,t=new Date(Date.UTC.apply(null,n)),isFinite(t.getUTCFullYear())&&t.setUTCFullYear(e)):t=new Date(Date.UTC.apply(null,arguments)),t}function At(e,t,n){var r=7+t-n;return-(7+_t(e,0,r).getUTCDay()-t)%7+r-1}function Et(e,t,n,r,o){var i,a,s=1+7*(t-1)+(7+n-r)%7+At(e,r,o);return s<=0?a=Ge(i=e-1)+s:s>Ge(e)?(i=e+1,a=s-Ge(e)):(i=e,a=s),{year:i,dayOfYear:a}}function wt(e,t,n){var r,o,i=At(e.year(),t,n),a=Math.floor((e.dayOfYear()-i-1)/7)+1;return a<1?r=a+xt(o=e.year()-1,t,n):a>xt(e.year(),t,n)?(r=a-xt(e.year(),t,n),o=e.year()+1):(o=e.year(),r=a),{week:r,year:o}}function xt(e,t,n){var r=At(e,t,n),o=At(e+1,t,n);return(Ge(e)-r+o)/7}function kt(e){return wt(e,this._week.dow,this._week.doy).week}$("w",["ww",2],"wo","week"),$("W",["WW",2],"Wo","isoWeek"),Se("w",fe,ke),Se("ww",fe,ce),Se("W",fe,ke),Se("WW",fe,ce),Be(["w","ww","W","WW"],(function(e,t,n,r){t[r.substr(0,1)]=Le(e)}));var Ct={dow:0,doy:6};function St(){return this._week.dow}function Mt(){return this._week.doy}function Tt(e){var t=this.localeData().week(this);return null==e?t:this.add(7*(e-t),"d")}function Ot(e){var t=wt(this,1,4).week;return null==e?t:this.add(7*(e-t),"d")}function Dt(e,t){return"string"!=typeof e?e:isNaN(e)?"number"==typeof(e=t.weekdaysParse(e))?e:null:parseInt(e,10)}function Lt(e,t){return"string"==typeof e?t.weekdaysParse(e)%7||7:isNaN(e)?null:e}function Pt(e,t){return e.slice(t,7).concat(e.slice(0,t))}$("d",0,"do","day"),$("dd",0,0,(function(e){return this.localeData().weekdaysMin(this,e)})),$("ddd",0,0,(function(e){return this.localeData().weekdaysShort(this,e)})),$("dddd",0,0,(function(e){return this.localeData().weekdays(this,e)})),$("e",0,0,"weekday"),$("E",0,0,"isoWeekday"),Se("d",fe),Se("e",fe),Se("E",fe),Se("dd",(function(e,t){return t.weekdaysMinRegex(e)})),Se("ddd",(function(e,t){return t.weekdaysShortRegex(e)})),Se("dddd",(function(e,t){return t.weekdaysRegex(e)})),Be(["dd","ddd","dddd"],(function(e,t,n,r){var o=n._locale.weekdaysParse(e,r,n._strict);null!=o?t.d=o:v(n).invalidWeekday=e})),Be(["d","e","E"],(function(e,t,n,r){t[r]=Le(e)}));var It="Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),Bt="Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),Rt="Su_Mo_Tu_We_Th_Fr_Sa".split("_"),Nt=xe,Ft=xe,jt=xe;function Yt(e,t){var n=a(this._weekdays)?this._weekdays:this._weekdays[e&&!0!==e&&this._weekdays.isFormat.test(t)?"format":"standalone"];return!0===e?Pt(n,this._week.dow):e?n[e.day()]:n}function $t(e){return!0===e?Pt(this._weekdaysShort,this._week.dow):e?this._weekdaysShort[e.day()]:this._weekdaysShort}function Ht(e){return!0===e?Pt(this._weekdaysMin,this._week.dow):e?this._weekdaysMin[e.day()]:this._weekdaysMin}function Ut(e,t,n){var r,o,i,a=e.toLocaleLowerCase();if(!this._weekdaysParse)for(this._weekdaysParse=[],this._shortWeekdaysParse=[],this._minWeekdaysParse=[],r=0;r<7;++r)i=m([2e3,1]).day(r),this._minWeekdaysParse[r]=this.weekdaysMin(i,"").toLocaleLowerCase(),this._shortWeekdaysParse[r]=this.weekdaysShort(i,"").toLocaleLowerCase(),this._weekdaysParse[r]=this.weekdays(i,"").toLocaleLowerCase();return n?"dddd"===t?-1!==(o=Qe.call(this._weekdaysParse,a))?o:null:"ddd"===t?-1!==(o=Qe.call(this._shortWeekdaysParse,a))?o:null:-1!==(o=Qe.call(this._minWeekdaysParse,a))?o:null:"dddd"===t?-1!==(o=Qe.call(this._weekdaysParse,a))||-1!==(o=Qe.call(this._shortWeekdaysParse,a))||-1!==(o=Qe.call(this._minWeekdaysParse,a))?o:null:"ddd"===t?-1!==(o=Qe.call(this._shortWeekdaysParse,a))||-1!==(o=Qe.call(this._weekdaysParse,a))||-1!==(o=Qe.call(this._minWeekdaysParse,a))?o:null:-1!==(o=Qe.call(this._minWeekdaysParse,a))||-1!==(o=Qe.call(this._weekdaysParse,a))||-1!==(o=Qe.call(this._shortWeekdaysParse,a))?o:null}function zt(e,t,n){var r,o,i;if(this._weekdaysParseExact)return Ut.call(this,e,t,n);for(this._weekdaysParse||(this._weekdaysParse=[],this._minWeekdaysParse=[],this._shortWeekdaysParse=[],this._fullWeekdaysParse=[]),r=0;r<7;r++){if(o=m([2e3,1]).day(r),n&&!this._fullWeekdaysParse[r]&&(this._fullWeekdaysParse[r]=new RegExp("^"+this.weekdays(o,"").replace(".","\\.?")+"$","i"),this._shortWeekdaysParse[r]=new RegExp("^"+this.weekdaysShort(o,"").replace(".","\\.?")+"$","i"),this._minWeekdaysParse[r]=new RegExp("^"+this.weekdaysMin(o,"").replace(".","\\.?")+"$","i")),this._weekdaysParse[r]||(i="^"+this.weekdays(o,"")+"|^"+this.weekdaysShort(o,"")+"|^"+this.weekdaysMin(o,""),this._weekdaysParse[r]=new RegExp(i.replace(".",""),"i")),n&&"dddd"===t&&this._fullWeekdaysParse[r].test(e))return r;if(n&&"ddd"===t&&this._shortWeekdaysParse[r].test(e))return r;if(n&&"dd"===t&&this._minWeekdaysParse[r].test(e))return r;if(!n&&this._weekdaysParse[r].test(e))return r}}function Wt(e){if(!this.isValid())return null!=e?this:NaN;var t=Je(this,"Day");return null!=e?(e=Dt(e,this.localeData()),this.add(e-t,"d")):t}function Vt(e){if(!this.isValid())return null!=e?this:NaN;var t=(this.day()+7-this.localeData()._week.dow)%7;return null==e?t:this.add(e-t,"d")}function Gt(e){if(!this.isValid())return null!=e?this:NaN;if(null!=e){var t=Lt(e,this.localeData());return this.day(this.day()%7?t:t-7)}return this.day()||7}function Qt(e){return this._weekdaysParseExact?(l(this,"_weekdaysRegex")||Zt.call(this),e?this._weekdaysStrictRegex:this._weekdaysRegex):(l(this,"_weekdaysRegex")||(this._weekdaysRegex=Nt),this._weekdaysStrictRegex&&e?this._weekdaysStrictRegex:this._weekdaysRegex)}function qt(e){return this._weekdaysParseExact?(l(this,"_weekdaysRegex")||Zt.call(this),e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex):(l(this,"_weekdaysShortRegex")||(this._weekdaysShortRegex=Ft),this._weekdaysShortStrictRegex&&e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex)}function Kt(e){return this._weekdaysParseExact?(l(this,"_weekdaysRegex")||Zt.call(this),e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex):(l(this,"_weekdaysMinRegex")||(this._weekdaysMinRegex=jt),this._weekdaysMinStrictRegex&&e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex)}function Zt(){function e(e,t){return t.length-e.length}var t,n,r,o,i,a=[],s=[],l=[],c=[];for(t=0;t<7;t++)n=m([2e3,1]).day(t),r=Oe(this.weekdaysMin(n,"")),o=Oe(this.weekdaysShort(n,"")),i=Oe(this.weekdays(n,"")),a.push(r),s.push(o),l.push(i),c.push(r),c.push(o),c.push(i);a.sort(e),s.sort(e),l.sort(e),c.sort(e),this._weekdaysRegex=new RegExp("^("+c.join("|")+")","i"),this._weekdaysShortRegex=this._weekdaysRegex,this._weekdaysMinRegex=this._weekdaysRegex,this._weekdaysStrictRegex=new RegExp("^("+l.join("|")+")","i"),this._weekdaysShortStrictRegex=new RegExp("^("+s.join("|")+")","i"),this._weekdaysMinStrictRegex=new RegExp("^("+a.join("|")+")","i")}function Jt(){return this.hours()%12||12}function Xt(){return this.hours()||24}function en(e,t){$(e,0,0,(function(){return this.localeData().meridiem(this.hours(),this.minutes(),t)}))}function tn(e,t){return t._meridiemParse}function nn(e){return"p"===(e+"").toLowerCase().charAt(0)}$("H",["HH",2],0,"hour"),$("h",["hh",2],0,Jt),$("k",["kk",2],0,Xt),$("hmm",0,0,(function(){return""+Jt.apply(this)+R(this.minutes(),2)})),$("hmmss",0,0,(function(){return""+Jt.apply(this)+R(this.minutes(),2)+R(this.seconds(),2)})),$("Hmm",0,0,(function(){return""+this.hours()+R(this.minutes(),2)})),$("Hmmss",0,0,(function(){return""+this.hours()+R(this.minutes(),2)+R(this.seconds(),2)})),en("a",!0),en("A",!1),Se("a",tn),Se("A",tn),Se("H",fe,Ce),Se("h",fe,ke),Se("k",fe,ke),Se("HH",fe,ce),Se("hh",fe,ce),Se("kk",fe,ce),Se("hmm",he),Se("hmmss",me),Se("Hmm",he),Se("Hmmss",me),Ie(["H","HH"],$e),Ie(["k","kk"],(function(e,t,n){var r=Le(e);t[$e]=24===r?0:r})),Ie(["a","A"],(function(e,t,n){n._isPm=n._locale.isPM(e),n._meridiem=e})),Ie(["h","hh"],(function(e,t,n){t[$e]=Le(e),v(n).bigHour=!0})),Ie("hmm",(function(e,t,n){var r=e.length-2;t[$e]=Le(e.substr(0,r)),t[He]=Le(e.substr(r)),v(n).bigHour=!0})),Ie("hmmss",(function(e,t,n){var r=e.length-4,o=e.length-2;t[$e]=Le(e.substr(0,r)),t[He]=Le(e.substr(r,2)),t[Ue]=Le(e.substr(o)),v(n).bigHour=!0})),Ie("Hmm",(function(e,t,n){var r=e.length-2;t[$e]=Le(e.substr(0,r)),t[He]=Le(e.substr(r))})),Ie("Hmmss",(function(e,t,n){var r=e.length-4,o=e.length-2;t[$e]=Le(e.substr(0,r)),t[He]=Le(e.substr(r,2)),t[Ue]=Le(e.substr(o))}));var rn=/[ap]\.?m?\.?/i,on=Ze("Hours",!0);function an(e,t,n){return e>11?n?"pm":"PM":n?"am":"AM"}var sn,ln={calendar:I,longDateFormat:V,invalidDate:Q,ordinal:K,dayOfMonthOrdinalParse:Z,relativeTime:X,months:ot,monthsShort:it,week:Ct,weekdays:It,weekdaysMin:Rt,weekdaysShort:Bt,meridiemParse:rn},cn={},un={};function dn(e,t){var n,r=Math.min(e.length,t.length);for(n=0;n<r;n+=1)if(e[n]!==t[n])return n;return r}function pn(e){return e?e.toLowerCase().replace("_","-"):e}function fn(e){for(var t,n,r,o,i=0;i<e.length;){for(t=(o=pn(e[i]).split("-")).length,n=(n=pn(e[i+1]))?n.split("-"):null;t>0;){if(r=mn(o.slice(0,t).join("-")))return r;if(n&&n.length>=t&&dn(o,n)>=t-1)break;t--}i++}return sn}function hn(e){return!(!e||!e.match("^[^/\\\\]*$"))}function mn(t){var r=null;if(void 0===cn[t]&&e&&e.exports&&hn(t))try{r=sn._abbr,n(35358)("./"+t),gn(r)}catch(e){cn[t]=null}return cn[t]}function gn(e,t){var n;return e&&((n=u(t)?bn(e):vn(e,t))?sn=n:"undefined"!=typeof console&&console.warn&&console.warn("Locale "+e+" not found. Did you forget to load it?")),sn._abbr}function vn(e,t){if(null!==t){var n,r=ln;if(t.abbr=e,null!=cn[e])T("defineLocaleOverride","use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."),r=cn[e]._config;else if(null!=t.parentLocale)if(null!=cn[t.parentLocale])r=cn[t.parentLocale]._config;else{if(null==(n=mn(t.parentLocale)))return un[t.parentLocale]||(un[t.parentLocale]=[]),un[t.parentLocale].push({name:e,config:t}),null;r=n._config}return cn[e]=new P(L(r,t)),un[e]&&un[e].forEach((function(e){vn(e.name,e.config)})),gn(e),cn[e]}return delete cn[e],null}function yn(e,t){if(null!=t){var n,r,o=ln;null!=cn[e]&&null!=cn[e].parentLocale?cn[e].set(L(cn[e]._config,t)):(null!=(r=mn(e))&&(o=r._config),t=L(o,t),null==r&&(t.abbr=e),(n=new P(t)).parentLocale=cn[e],cn[e]=n),gn(e)}else null!=cn[e]&&(null!=cn[e].parentLocale?(cn[e]=cn[e].parentLocale,e===gn()&&gn(e)):null!=cn[e]&&delete cn[e]);return cn[e]}function bn(e){var t;if(e&&e._locale&&e._locale._abbr&&(e=e._locale._abbr),!e)return sn;if(!a(e)){if(t=mn(e))return t;e=[e]}return fn(e)}function _n(){return S(cn)}function An(e){var t,n=e._a;return n&&-2===v(e).overflow&&(t=n[je]<0||n[je]>11?je:n[Ye]<1||n[Ye]>rt(n[Fe],n[je])?Ye:n[$e]<0||n[$e]>24||24===n[$e]&&(0!==n[He]||0!==n[Ue]||0!==n[ze])?$e:n[He]<0||n[He]>59?He:n[Ue]<0||n[Ue]>59?Ue:n[ze]<0||n[ze]>999?ze:-1,v(e)._overflowDayOfYear&&(t<Fe||t>Ye)&&(t=Ye),v(e)._overflowWeeks&&-1===t&&(t=We),v(e)._overflowWeekday&&-1===t&&(t=Ve),v(e).overflow=t),e}var En=/^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,wn=/^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,xn=/Z|[+-]\d\d(?::?\d\d)?/,kn=[["YYYYYY-MM-DD",/[+-]\d{6}-\d\d-\d\d/],["YYYY-MM-DD",/\d{4}-\d\d-\d\d/],["GGGG-[W]WW-E",/\d{4}-W\d\d-\d/],["GGGG-[W]WW",/\d{4}-W\d\d/,!1],["YYYY-DDD",/\d{4}-\d{3}/],["YYYY-MM",/\d{4}-\d\d/,!1],["YYYYYYMMDD",/[+-]\d{10}/],["YYYYMMDD",/\d{8}/],["GGGG[W]WWE",/\d{4}W\d{3}/],["GGGG[W]WW",/\d{4}W\d{2}/,!1],["YYYYDDD",/\d{7}/],["YYYYMM",/\d{6}/,!1],["YYYY",/\d{4}/,!1]],Cn=[["HH:mm:ss.SSSS",/\d\d:\d\d:\d\d\.\d+/],["HH:mm:ss,SSSS",/\d\d:\d\d:\d\d,\d+/],["HH:mm:ss",/\d\d:\d\d:\d\d/],["HH:mm",/\d\d:\d\d/],["HHmmss.SSSS",/\d\d\d\d\d\d\.\d+/],["HHmmss,SSSS",/\d\d\d\d\d\d,\d+/],["HHmmss",/\d\d\d\d\d\d/],["HHmm",/\d\d\d\d/],["HH",/\d\d/]],Sn=/^\/?Date\((-?\d+)/i,Mn=/^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,Tn={UT:0,GMT:0,EDT:-240,EST:-300,CDT:-300,CST:-360,MDT:-360,MST:-420,PDT:-420,PST:-480};function On(e){var t,n,r,o,i,a,s=e._i,l=En.exec(s)||wn.exec(s),c=kn.length,u=Cn.length;if(l){for(v(e).iso=!0,t=0,n=c;t<n;t++)if(kn[t][1].exec(l[1])){o=kn[t][0],r=!1!==kn[t][2];break}if(null==o)return void(e._isValid=!1);if(l[3]){for(t=0,n=u;t<n;t++)if(Cn[t][1].exec(l[3])){i=(l[2]||" ")+Cn[t][0];break}if(null==i)return void(e._isValid=!1)}if(!r&&null!=i)return void(e._isValid=!1);if(l[4]){if(!xn.exec(l[4]))return void(e._isValid=!1);a="Z"}e._f=o+(i||"")+(a||""),Hn(e)}else e._isValid=!1}function Dn(e,t,n,r,o,i){var a=[Ln(e),it.indexOf(t),parseInt(n,10),parseInt(r,10),parseInt(o,10)];return i&&a.push(parseInt(i,10)),a}function Ln(e){var t=parseInt(e,10);return t<=49?2e3+t:t<=999?1900+t:t}function Pn(e){return e.replace(/\([^()]*\)|[\n\t]/g," ").replace(/(\s\s+)/g," ").replace(/^\s\s*/,"").replace(/\s\s*$/,"")}function In(e,t,n){return!e||Bt.indexOf(e)===new Date(t[0],t[1],t[2]).getDay()||(v(n).weekdayMismatch=!0,n._isValid=!1,!1)}function Bn(e,t,n){if(e)return Tn[e];if(t)return 0;var r=parseInt(n,10),o=r%100;return(r-o)/100*60+o}function Rn(e){var t,n=Mn.exec(Pn(e._i));if(n){if(t=Dn(n[4],n[3],n[2],n[5],n[6],n[7]),!In(n[1],t,e))return;e._a=t,e._tzm=Bn(n[8],n[9],n[10]),e._d=_t.apply(null,e._a),e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),v(e).rfc2822=!0}else e._isValid=!1}function Nn(e){var t=Sn.exec(e._i);null===t?(On(e),!1===e._isValid&&(delete e._isValid,Rn(e),!1===e._isValid&&(delete e._isValid,e._strict?e._isValid=!1:o.createFromInputFallback(e)))):e._d=new Date(+t[1])}function Fn(e,t,n){return null!=e?e:null!=t?t:n}function jn(e){var t=new Date(o.now());return e._useUTC?[t.getUTCFullYear(),t.getUTCMonth(),t.getUTCDate()]:[t.getFullYear(),t.getMonth(),t.getDate()]}function Yn(e){var t,n,r,o,i,a=[];if(!e._d){for(r=jn(e),e._w&&null==e._a[Ye]&&null==e._a[je]&&$n(e),null!=e._dayOfYear&&(i=Fn(e._a[Fe],r[Fe]),(e._dayOfYear>Ge(i)||0===e._dayOfYear)&&(v(e)._overflowDayOfYear=!0),n=_t(i,0,e._dayOfYear),e._a[je]=n.getUTCMonth(),e._a[Ye]=n.getUTCDate()),t=0;t<3&&null==e._a[t];++t)e._a[t]=a[t]=r[t];for(;t<7;t++)e._a[t]=a[t]=null==e._a[t]?2===t?1:0:e._a[t];24===e._a[$e]&&0===e._a[He]&&0===e._a[Ue]&&0===e._a[ze]&&(e._nextDay=!0,e._a[$e]=0),e._d=(e._useUTC?_t:bt).apply(null,a),o=e._useUTC?e._d.getUTCDay():e._d.getDay(),null!=e._tzm&&e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),e._nextDay&&(e._a[$e]=24),e._w&&void 0!==e._w.d&&e._w.d!==o&&(v(e).weekdayMismatch=!0)}}function $n(e){var t,n,r,o,i,a,s,l,c;null!=(t=e._w).GG||null!=t.W||null!=t.E?(i=1,a=4,n=Fn(t.GG,e._a[Fe],wt(Kn(),1,4).year),r=Fn(t.W,1),((o=Fn(t.E,1))<1||o>7)&&(l=!0)):(i=e._locale._week.dow,a=e._locale._week.doy,c=wt(Kn(),i,a),n=Fn(t.gg,e._a[Fe],c.year),r=Fn(t.w,c.week),null!=t.d?((o=t.d)<0||o>6)&&(l=!0):null!=t.e?(o=t.e+i,(t.e<0||t.e>6)&&(l=!0)):o=i),r<1||r>xt(n,i,a)?v(e)._overflowWeeks=!0:null!=l?v(e)._overflowWeekday=!0:(s=Et(n,r,o,i,a),e._a[Fe]=s.year,e._dayOfYear=s.dayOfYear)}function Hn(e){if(e._f!==o.ISO_8601)if(e._f!==o.RFC_2822){e._a=[],v(e).empty=!0;var t,n,r,i,a,s,l,c=""+e._i,u=c.length,d=0;for(l=(r=W(e._f,e._locale).match(N)||[]).length,t=0;t<l;t++)i=r[t],(n=(c.match(Me(i,e))||[])[0])&&((a=c.substr(0,c.indexOf(n))).length>0&&v(e).unusedInput.push(a),c=c.slice(c.indexOf(n)+n.length),d+=n.length),Y[i]?(n?v(e).empty=!1:v(e).unusedTokens.push(i),Re(i,n,e)):e._strict&&!n&&v(e).unusedTokens.push(i);v(e).charsLeftOver=u-d,c.length>0&&v(e).unusedInput.push(c),e._a[$e]<=12&&!0===v(e).bigHour&&e._a[$e]>0&&(v(e).bigHour=void 0),v(e).parsedDateParts=e._a.slice(0),v(e).meridiem=e._meridiem,e._a[$e]=Un(e._locale,e._a[$e],e._meridiem),null!==(s=v(e).era)&&(e._a[Fe]=e._locale.erasConvertYear(s,e._a[Fe])),Yn(e),An(e)}else Rn(e);else On(e)}function Un(e,t,n){var r;return null==n?t:null!=e.meridiemHour?e.meridiemHour(t,n):null!=e.isPM?((r=e.isPM(n))&&t<12&&(t+=12),r||12!==t||(t=0),t):t}function zn(e){var t,n,r,o,i,a,s=!1,l=e._f.length;if(0===l)return v(e).invalidFormat=!0,void(e._d=new Date(NaN));for(o=0;o<l;o++)i=0,a=!1,t=E({},e),null!=e._useUTC&&(t._useUTC=e._useUTC),t._f=e._f[o],Hn(t),y(t)&&(a=!0),i+=v(t).charsLeftOver,i+=10*v(t).unusedTokens.length,v(t).score=i,s?i<r&&(r=i,n=t):(null==r||i<r||a)&&(r=i,n=t,a&&(s=!0));h(e,n||t)}function Wn(e){if(!e._d){var t=oe(e._i),n=void 0===t.day?t.date:t.day;e._a=f([t.year,t.month,n,t.hour,t.minute,t.second,t.millisecond],(function(e){return e&&parseInt(e,10)})),Yn(e)}}function Vn(e){var t=new w(An(Gn(e)));return t._nextDay&&(t.add(1,"d"),t._nextDay=void 0),t}function Gn(e){var t=e._i,n=e._f;return e._locale=e._locale||bn(e._l),null===t||void 0===n&&""===t?b({nullInput:!0}):("string"==typeof t&&(e._i=t=e._locale.preparse(t)),x(t)?new w(An(t)):(p(t)?e._d=t:a(n)?zn(e):n?Hn(e):Qn(e),y(e)||(e._d=null),e))}function Qn(e){var t=e._i;u(t)?e._d=new Date(o.now()):p(t)?e._d=new Date(t.valueOf()):"string"==typeof t?Nn(e):a(t)?(e._a=f(t.slice(0),(function(e){return parseInt(e,10)})),Yn(e)):s(t)?Wn(e):d(t)?e._d=new Date(t):o.createFromInputFallback(e)}function qn(e,t,n,r,o){var i={};return!0!==t&&!1!==t||(r=t,t=void 0),!0!==n&&!1!==n||(r=n,n=void 0),(s(e)&&c(e)||a(e)&&0===e.length)&&(e=void 0),i._isAMomentObject=!0,i._useUTC=i._isUTC=o,i._l=n,i._i=e,i._f=t,i._strict=r,Vn(i)}function Kn(e,t,n,r){return qn(e,t,n,r,!1)}o.createFromInputFallback=C("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",(function(e){e._d=new Date(e._i+(e._useUTC?" UTC":""))})),o.ISO_8601=function(){},o.RFC_2822=function(){};var Zn=C("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",(function(){var e=Kn.apply(null,arguments);return this.isValid()&&e.isValid()?e<this?this:e:b()})),Jn=C("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",(function(){var e=Kn.apply(null,arguments);return this.isValid()&&e.isValid()?e>this?this:e:b()}));function Xn(e,t){var n,r;if(1===t.length&&a(t[0])&&(t=t[0]),!t.length)return Kn();for(n=t[0],r=1;r<t.length;++r)t[r].isValid()&&!t[r][e](n)||(n=t[r]);return n}function er(){return Xn("isBefore",[].slice.call(arguments,0))}function tr(){return Xn("isAfter",[].slice.call(arguments,0))}var nr=function(){return Date.now?Date.now():+new Date},rr=["year","quarter","month","week","day","hour","minute","second","millisecond"];function or(e){var t,n,r=!1,o=rr.length;for(t in e)if(l(e,t)&&(-1===Qe.call(rr,t)||null!=e[t]&&isNaN(e[t])))return!1;for(n=0;n<o;++n)if(e[rr[n]]){if(r)return!1;parseFloat(e[rr[n]])!==Le(e[rr[n]])&&(r=!0)}return!0}function ir(){return this._isValid}function ar(){return Tr(NaN)}function sr(e){var t=oe(e),n=t.year||0,r=t.quarter||0,o=t.month||0,i=t.week||t.isoWeek||0,a=t.day||0,s=t.hour||0,l=t.minute||0,c=t.second||0,u=t.millisecond||0;this._isValid=or(t),this._milliseconds=+u+1e3*c+6e4*l+1e3*s*60*60,this._days=+a+7*i,this._months=+o+3*r+12*n,this._data={},this._locale=bn(),this._bubble()}function lr(e){return e instanceof sr}function cr(e){return e<0?-1*Math.round(-1*e):Math.round(e)}function ur(e,t,n){var r,o=Math.min(e.length,t.length),i=Math.abs(e.length-t.length),a=0;for(r=0;r<o;r++)(n&&e[r]!==t[r]||!n&&Le(e[r])!==Le(t[r]))&&a++;return a+i}function dr(e,t){$(e,0,0,(function(){var e=this.utcOffset(),n="+";return e<0&&(e=-e,n="-"),n+R(~~(e/60),2)+t+R(~~e%60,2)}))}dr("Z",":"),dr("ZZ",""),Se("Z",Ee),Se("ZZ",Ee),Ie(["Z","ZZ"],(function(e,t,n){n._useUTC=!0,n._tzm=fr(Ee,e)}));var pr=/([\+\-]|\d\d)/gi;function fr(e,t){var n,r,o=(t||"").match(e);return null===o?null:0===(r=60*(n=((o[o.length-1]||[])+"").match(pr)||["-",0,0])[1]+Le(n[2]))?0:"+"===n[0]?r:-r}function hr(e,t){var n,r;return t._isUTC?(n=t.clone(),r=(x(e)||p(e)?e.valueOf():Kn(e).valueOf())-n.valueOf(),n._d.setTime(n._d.valueOf()+r),o.updateOffset(n,!1),n):Kn(e).local()}function mr(e){return-Math.round(e._d.getTimezoneOffset())}function gr(e,t,n){var r,i=this._offset||0;if(!this.isValid())return null!=e?this:NaN;if(null!=e){if("string"==typeof e){if(null===(e=fr(Ee,e)))return this}else Math.abs(e)<16&&!n&&(e*=60);return!this._isUTC&&t&&(r=mr(this)),this._offset=e,this._isUTC=!0,null!=r&&this.add(r,"m"),i!==e&&(!t||this._changeInProgress?Ir(this,Tr(e-i,"m"),1,!1):this._changeInProgress||(this._changeInProgress=!0,o.updateOffset(this,!0),this._changeInProgress=null)),this}return this._isUTC?i:mr(this)}function vr(e,t){return null!=e?("string"!=typeof e&&(e=-e),this.utcOffset(e,t),this):-this.utcOffset()}function yr(e){return this.utcOffset(0,e)}function br(e){return this._isUTC&&(this.utcOffset(0,e),this._isUTC=!1,e&&this.subtract(mr(this),"m")),this}function _r(){if(null!=this._tzm)this.utcOffset(this._tzm,!1,!0);else if("string"==typeof this._i){var e=fr(Ae,this._i);null!=e?this.utcOffset(e):this.utcOffset(0,!0)}return this}function Ar(e){return!!this.isValid()&&(e=e?Kn(e).utcOffset():0,(this.utcOffset()-e)%60==0)}function Er(){return this.utcOffset()>this.clone().month(0).utcOffset()||this.utcOffset()>this.clone().month(5).utcOffset()}function wr(){if(!u(this._isDSTShifted))return this._isDSTShifted;var e,t={};return E(t,this),(t=Gn(t))._a?(e=t._isUTC?m(t._a):Kn(t._a),this._isDSTShifted=this.isValid()&&ur(t._a,e.toArray())>0):this._isDSTShifted=!1,this._isDSTShifted}function xr(){return!!this.isValid()&&!this._isUTC}function kr(){return!!this.isValid()&&this._isUTC}function Cr(){return!!this.isValid()&&this._isUTC&&0===this._offset}o.updateOffset=function(){};var Sr=/^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,Mr=/^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;function Tr(e,t){var n,r,o,i=e,a=null;return lr(e)?i={ms:e._milliseconds,d:e._days,M:e._months}:d(e)||!isNaN(+e)?(i={},t?i[t]=+e:i.milliseconds=+e):(a=Sr.exec(e))?(n="-"===a[1]?-1:1,i={y:0,d:Le(a[Ye])*n,h:Le(a[$e])*n,m:Le(a[He])*n,s:Le(a[Ue])*n,ms:Le(cr(1e3*a[ze]))*n}):(a=Mr.exec(e))?(n="-"===a[1]?-1:1,i={y:Or(a[2],n),M:Or(a[3],n),w:Or(a[4],n),d:Or(a[5],n),h:Or(a[6],n),m:Or(a[7],n),s:Or(a[8],n)}):null==i?i={}:"object"==typeof i&&("from"in i||"to"in i)&&(o=Lr(Kn(i.from),Kn(i.to)),(i={}).ms=o.milliseconds,i.M=o.months),r=new sr(i),lr(e)&&l(e,"_locale")&&(r._locale=e._locale),lr(e)&&l(e,"_isValid")&&(r._isValid=e._isValid),r}function Or(e,t){var n=e&&parseFloat(e.replace(",","."));return(isNaN(n)?0:n)*t}function Dr(e,t){var n={};return n.months=t.month()-e.month()+12*(t.year()-e.year()),e.clone().add(n.months,"M").isAfter(t)&&--n.months,n.milliseconds=+t-+e.clone().add(n.months,"M"),n}function Lr(e,t){var n;return e.isValid()&&t.isValid()?(t=hr(t,e),e.isBefore(t)?n=Dr(e,t):((n=Dr(t,e)).milliseconds=-n.milliseconds,n.months=-n.months),n):{milliseconds:0,months:0}}function Pr(e,t){return function(n,r){var o;return null===r||isNaN(+r)||(T(t,"moment()."+t+"(period, number) is deprecated. Please use moment()."+t+"(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."),o=n,n=r,r=o),Ir(this,Tr(n,r),e),this}}function Ir(e,t,n,r){var i=t._milliseconds,a=cr(t._days),s=cr(t._months);e.isValid()&&(r=null==r||r,s&&ft(e,Je(e,"Month")+s*n),a&&Xe(e,"Date",Je(e,"Date")+a*n),i&&e._d.setTime(e._d.valueOf()+i*n),r&&o.updateOffset(e,a||s))}Tr.fn=sr.prototype,Tr.invalid=ar;var Br=Pr(1,"add"),Rr=Pr(-1,"subtract");function Nr(e){return"string"==typeof e||e instanceof String}function Fr(e){return x(e)||p(e)||Nr(e)||d(e)||Yr(e)||jr(e)||null==e}function jr(e){var t,n,r=s(e)&&!c(e),o=!1,i=["years","year","y","months","month","M","days","day","d","dates","date","D","hours","hour","h","minutes","minute","m","seconds","second","s","milliseconds","millisecond","ms"],a=i.length;for(t=0;t<a;t+=1)n=i[t],o=o||l(e,n);return r&&o}function Yr(e){var t=a(e),n=!1;return t&&(n=0===e.filter((function(t){return!d(t)&&Nr(e)})).length),t&&n}function $r(e){var t,n,r=s(e)&&!c(e),o=!1,i=["sameDay","nextDay","lastDay","nextWeek","lastWeek","sameElse"];for(t=0;t<i.length;t+=1)n=i[t],o=o||l(e,n);return r&&o}function Hr(e,t){var n=e.diff(t,"days",!0);return n<-6?"sameElse":n<-1?"lastWeek":n<0?"lastDay":n<1?"sameDay":n<2?"nextDay":n<7?"nextWeek":"sameElse"}function Ur(e,t){1===arguments.length&&(arguments[0]?Fr(arguments[0])?(e=arguments[0],t=void 0):$r(arguments[0])&&(t=arguments[0],e=void 0):(e=void 0,t=void 0));var n=e||Kn(),r=hr(n,this).startOf("day"),i=o.calendarFormat(this,r)||"sameElse",a=t&&(O(t[i])?t[i].call(this,n):t[i]);return this.format(a||this.localeData().calendar(i,this,Kn(n)))}function zr(){return new w(this)}function Wr(e,t){var n=x(e)?e:Kn(e);return!(!this.isValid()||!n.isValid())&&("millisecond"===(t=re(t)||"millisecond")?this.valueOf()>n.valueOf():n.valueOf()<this.clone().startOf(t).valueOf())}function Vr(e,t){var n=x(e)?e:Kn(e);return!(!this.isValid()||!n.isValid())&&("millisecond"===(t=re(t)||"millisecond")?this.valueOf()<n.valueOf():this.clone().endOf(t).valueOf()<n.valueOf())}function Gr(e,t,n,r){var o=x(e)?e:Kn(e),i=x(t)?t:Kn(t);return!!(this.isValid()&&o.isValid()&&i.isValid())&&("("===(r=r||"()")[0]?this.isAfter(o,n):!this.isBefore(o,n))&&(")"===r[1]?this.isBefore(i,n):!this.isAfter(i,n))}function Qr(e,t){var n,r=x(e)?e:Kn(e);return!(!this.isValid()||!r.isValid())&&("millisecond"===(t=re(t)||"millisecond")?this.valueOf()===r.valueOf():(n=r.valueOf(),this.clone().startOf(t).valueOf()<=n&&n<=this.clone().endOf(t).valueOf()))}function qr(e,t){return this.isSame(e,t)||this.isAfter(e,t)}function Kr(e,t){return this.isSame(e,t)||this.isBefore(e,t)}function Zr(e,t,n){var r,o,i;if(!this.isValid())return NaN;if(!(r=hr(e,this)).isValid())return NaN;switch(o=6e4*(r.utcOffset()-this.utcOffset()),t=re(t)){case"year":i=Jr(this,r)/12;break;case"month":i=Jr(this,r);break;case"quarter":i=Jr(this,r)/3;break;case"second":i=(this-r)/1e3;break;case"minute":i=(this-r)/6e4;break;case"hour":i=(this-r)/36e5;break;case"day":i=(this-r-o)/864e5;break;case"week":i=(this-r-o)/6048e5;break;default:i=this-r}return n?i:De(i)}function Jr(e,t){if(e.date()<t.date())return-Jr(t,e);var n=12*(t.year()-e.year())+(t.month()-e.month()),r=e.clone().add(n,"months");return-(n+(t-r<0?(t-r)/(r-e.clone().add(n-1,"months")):(t-r)/(e.clone().add(n+1,"months")-r)))||0}function Xr(){return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")}function eo(e){if(!this.isValid())return null;var t=!0!==e,n=t?this.clone().utc():this;return n.year()<0||n.year()>9999?z(n,t?"YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"):O(Date.prototype.toISOString)?t?this.toDate().toISOString():new Date(this.valueOf()+60*this.utcOffset()*1e3).toISOString().replace("Z",z(n,"Z")):z(n,t?"YYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYY-MM-DD[T]HH:mm:ss.SSSZ")}function to(){if(!this.isValid())return"moment.invalid(/* "+this._i+" */)";var e,t,n,r,o="moment",i="";return this.isLocal()||(o=0===this.utcOffset()?"moment.utc":"moment.parseZone",i="Z"),e="["+o+'("]',t=0<=this.year()&&this.year()<=9999?"YYYY":"YYYYYY",n="-MM-DD[T]HH:mm:ss.SSS",r=i+'[")]',this.format(e+t+n+r)}function no(e){e||(e=this.isUtc()?o.defaultFormatUtc:o.defaultFormat);var t=z(this,e);return this.localeData().postformat(t)}function ro(e,t){return this.isValid()&&(x(e)&&e.isValid()||Kn(e).isValid())?Tr({to:this,from:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()}function oo(e){return this.from(Kn(),e)}function io(e,t){return this.isValid()&&(x(e)&&e.isValid()||Kn(e).isValid())?Tr({from:this,to:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()}function ao(e){return this.to(Kn(),e)}function so(e){var t;return void 0===e?this._locale._abbr:(null!=(t=bn(e))&&(this._locale=t),this)}o.defaultFormat="YYYY-MM-DDTHH:mm:ssZ",o.defaultFormatUtc="YYYY-MM-DDTHH:mm:ss[Z]";var lo=C("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",(function(e){return void 0===e?this.localeData():this.locale(e)}));function co(){return this._locale}var uo=1e3,po=60*uo,fo=60*po,ho=3506328*fo;function mo(e,t){return(e%t+t)%t}function go(e,t,n){return e<100&&e>=0?new Date(e+400,t,n)-ho:new Date(e,t,n).valueOf()}function vo(e,t,n){return e<100&&e>=0?Date.UTC(e+400,t,n)-ho:Date.UTC(e,t,n)}function yo(e){var t,n;if(void 0===(e=re(e))||"millisecond"===e||!this.isValid())return this;switch(n=this._isUTC?vo:go,e){case"year":t=n(this.year(),0,1);break;case"quarter":t=n(this.year(),this.month()-this.month()%3,1);break;case"month":t=n(this.year(),this.month(),1);break;case"week":t=n(this.year(),this.month(),this.date()-this.weekday());break;case"isoWeek":t=n(this.year(),this.month(),this.date()-(this.isoWeekday()-1));break;case"day":case"date":t=n(this.year(),this.month(),this.date());break;case"hour":t=this._d.valueOf(),t-=mo(t+(this._isUTC?0:this.utcOffset()*po),fo);break;case"minute":t=this._d.valueOf(),t-=mo(t,po);break;case"second":t=this._d.valueOf(),t-=mo(t,uo)}return this._d.setTime(t),o.updateOffset(this,!0),this}function bo(e){var t,n;if(void 0===(e=re(e))||"millisecond"===e||!this.isValid())return this;switch(n=this._isUTC?vo:go,e){case"year":t=n(this.year()+1,0,1)-1;break;case"quarter":t=n(this.year(),this.month()-this.month()%3+3,1)-1;break;case"month":t=n(this.year(),this.month()+1,1)-1;break;case"week":t=n(this.year(),this.month(),this.date()-this.weekday()+7)-1;break;case"isoWeek":t=n(this.year(),this.month(),this.date()-(this.isoWeekday()-1)+7)-1;break;case"day":case"date":t=n(this.year(),this.month(),this.date()+1)-1;break;case"hour":t=this._d.valueOf(),t+=fo-mo(t+(this._isUTC?0:this.utcOffset()*po),fo)-1;break;case"minute":t=this._d.valueOf(),t+=po-mo(t,po)-1;break;case"second":t=this._d.valueOf(),t+=uo-mo(t,uo)-1}return this._d.setTime(t),o.updateOffset(this,!0),this}function _o(){return this._d.valueOf()-6e4*(this._offset||0)}function Ao(){return Math.floor(this.valueOf()/1e3)}function Eo(){return new Date(this.valueOf())}function wo(){var e=this;return[e.year(),e.month(),e.date(),e.hour(),e.minute(),e.second(),e.millisecond()]}function xo(){var e=this;return{years:e.year(),months:e.month(),date:e.date(),hours:e.hours(),minutes:e.minutes(),seconds:e.seconds(),milliseconds:e.milliseconds()}}function ko(){return this.isValid()?this.toISOString():null}function Co(){return y(this)}function So(){return h({},v(this))}function Mo(){return v(this).overflow}function To(){return{input:this._i,format:this._f,locale:this._locale,isUTC:this._isUTC,strict:this._strict}}function Oo(e,t){var n,r,i,a=this._eras||bn("en")._eras;for(n=0,r=a.length;n<r;++n)switch("string"==typeof a[n].since&&(i=o(a[n].since).startOf("day"),a[n].since=i.valueOf()),typeof a[n].until){case"undefined":a[n].until=1/0;break;case"string":i=o(a[n].until).startOf("day").valueOf(),a[n].until=i.valueOf()}return a}function Do(e,t,n){var r,o,i,a,s,l=this.eras();for(e=e.toUpperCase(),r=0,o=l.length;r<o;++r)if(i=l[r].name.toUpperCase(),a=l[r].abbr.toUpperCase(),s=l[r].narrow.toUpperCase(),n)switch(t){case"N":case"NN":case"NNN":if(a===e)return l[r];break;case"NNNN":if(i===e)return l[r];break;case"NNNNN":if(s===e)return l[r]}else if([i,a,s].indexOf(e)>=0)return l[r]}function Lo(e,t){var n=e.since<=e.until?1:-1;return void 0===t?o(e.since).year():o(e.since).year()+(t-e.offset)*n}function Po(){var e,t,n,r=this.localeData().eras();for(e=0,t=r.length;e<t;++e){if(n=this.clone().startOf("day").valueOf(),r[e].since<=n&&n<=r[e].until)return r[e].name;if(r[e].until<=n&&n<=r[e].since)return r[e].name}return""}function Io(){var e,t,n,r=this.localeData().eras();for(e=0,t=r.length;e<t;++e){if(n=this.clone().startOf("day").valueOf(),r[e].since<=n&&n<=r[e].until)return r[e].narrow;if(r[e].until<=n&&n<=r[e].since)return r[e].narrow}return""}function Bo(){var e,t,n,r=this.localeData().eras();for(e=0,t=r.length;e<t;++e){if(n=this.clone().startOf("day").valueOf(),r[e].since<=n&&n<=r[e].until)return r[e].abbr;if(r[e].until<=n&&n<=r[e].since)return r[e].abbr}return""}function Ro(){var e,t,n,r,i=this.localeData().eras();for(e=0,t=i.length;e<t;++e)if(n=i[e].since<=i[e].until?1:-1,r=this.clone().startOf("day").valueOf(),i[e].since<=r&&r<=i[e].until||i[e].until<=r&&r<=i[e].since)return(this.year()-o(i[e].since).year())*n+i[e].offset;return this.year()}function No(e){return l(this,"_erasNameRegex")||zo.call(this),e?this._erasNameRegex:this._erasRegex}function Fo(e){return l(this,"_erasAbbrRegex")||zo.call(this),e?this._erasAbbrRegex:this._erasRegex}function jo(e){return l(this,"_erasNarrowRegex")||zo.call(this),e?this._erasNarrowRegex:this._erasRegex}function Yo(e,t){return t.erasAbbrRegex(e)}function $o(e,t){return t.erasNameRegex(e)}function Ho(e,t){return t.erasNarrowRegex(e)}function Uo(e,t){return t._eraYearOrdinalRegex||be}function zo(){var e,t,n,r,o,i=[],a=[],s=[],l=[],c=this.eras();for(e=0,t=c.length;e<t;++e)n=Oe(c[e].name),r=Oe(c[e].abbr),o=Oe(c[e].narrow),a.push(n),i.push(r),s.push(o),l.push(n),l.push(r),l.push(o);this._erasRegex=new RegExp("^("+l.join("|")+")","i"),this._erasNameRegex=new RegExp("^("+a.join("|")+")","i"),this._erasAbbrRegex=new RegExp("^("+i.join("|")+")","i"),this._erasNarrowRegex=new RegExp("^("+s.join("|")+")","i")}function Wo(e,t){$(0,[e,e.length],0,t)}function Vo(e){return Jo.call(this,e,this.week(),this.weekday()+this.localeData()._week.dow,this.localeData()._week.dow,this.localeData()._week.doy)}function Go(e){return Jo.call(this,e,this.isoWeek(),this.isoWeekday(),1,4)}function Qo(){return xt(this.year(),1,4)}function qo(){return xt(this.isoWeekYear(),1,4)}function Ko(){var e=this.localeData()._week;return xt(this.year(),e.dow,e.doy)}function Zo(){var e=this.localeData()._week;return xt(this.weekYear(),e.dow,e.doy)}function Jo(e,t,n,r,o){var i;return null==e?wt(this,r,o).year:(t>(i=xt(e,r,o))&&(t=i),Xo.call(this,e,t,n,r,o))}function Xo(e,t,n,r,o){var i=Et(e,t,n,r,o),a=_t(i.year,0,i.dayOfYear);return this.year(a.getUTCFullYear()),this.month(a.getUTCMonth()),this.date(a.getUTCDate()),this}function ei(e){return null==e?Math.ceil((this.month()+1)/3):this.month(3*(e-1)+this.month()%3)}$("N",0,0,"eraAbbr"),$("NN",0,0,"eraAbbr"),$("NNN",0,0,"eraAbbr"),$("NNNN",0,0,"eraName"),$("NNNNN",0,0,"eraNarrow"),$("y",["y",1],"yo","eraYear"),$("y",["yy",2],0,"eraYear"),$("y",["yyy",3],0,"eraYear"),$("y",["yyyy",4],0,"eraYear"),Se("N",Yo),Se("NN",Yo),Se("NNN",Yo),Se("NNNN",$o),Se("NNNNN",Ho),Ie(["N","NN","NNN","NNNN","NNNNN"],(function(e,t,n,r){var o=n._locale.erasParse(e,r,n._strict);o?v(n).era=o:v(n).invalidEra=e})),Se("y",be),Se("yy",be),Se("yyy",be),Se("yyyy",be),Se("yo",Uo),Ie(["y","yy","yyy","yyyy"],Fe),Ie(["yo"],(function(e,t,n,r){var o;n._locale._eraYearOrdinalRegex&&(o=e.match(n._locale._eraYearOrdinalRegex)),n._locale.eraYearOrdinalParse?t[Fe]=n._locale.eraYearOrdinalParse(e,o):t[Fe]=parseInt(e,10)})),$(0,["gg",2],0,(function(){return this.weekYear()%100})),$(0,["GG",2],0,(function(){return this.isoWeekYear()%100})),Wo("gggg","weekYear"),Wo("ggggg","weekYear"),Wo("GGGG","isoWeekYear"),Wo("GGGGG","isoWeekYear"),Se("G",_e),Se("g",_e),Se("GG",fe,ce),Se("gg",fe,ce),Se("GGGG",ve,de),Se("gggg",ve,de),Se("GGGGG",ye,pe),Se("ggggg",ye,pe),Be(["gggg","ggggg","GGGG","GGGGG"],(function(e,t,n,r){t[r.substr(0,2)]=Le(e)})),Be(["gg","GG"],(function(e,t,n,r){t[r]=o.parseTwoDigitYear(e)})),$("Q",0,"Qo","quarter"),Se("Q",le),Ie("Q",(function(e,t){t[je]=3*(Le(e)-1)})),$("D",["DD",2],"Do","date"),Se("D",fe,ke),Se("DD",fe,ce),Se("Do",(function(e,t){return e?t._dayOfMonthOrdinalParse||t._ordinalParse:t._dayOfMonthOrdinalParseLenient})),Ie(["D","DD"],Ye),Ie("Do",(function(e,t){t[Ye]=Le(e.match(fe)[0])}));var ti=Ze("Date",!0);function ni(e){var t=Math.round((this.clone().startOf("day")-this.clone().startOf("year"))/864e5)+1;return null==e?t:this.add(e-t,"d")}$("DDD",["DDDD",3],"DDDo","dayOfYear"),Se("DDD",ge),Se("DDDD",ue),Ie(["DDD","DDDD"],(function(e,t,n){n._dayOfYear=Le(e)})),$("m",["mm",2],0,"minute"),Se("m",fe,Ce),Se("mm",fe,ce),Ie(["m","mm"],He);var ri=Ze("Minutes",!1);$("s",["ss",2],0,"second"),Se("s",fe,Ce),Se("ss",fe,ce),Ie(["s","ss"],Ue);var oi,ii,ai=Ze("Seconds",!1);for($("S",0,0,(function(){return~~(this.millisecond()/100)})),$(0,["SS",2],0,(function(){return~~(this.millisecond()/10)})),$(0,["SSS",3],0,"millisecond"),$(0,["SSSS",4],0,(function(){return 10*this.millisecond()})),$(0,["SSSSS",5],0,(function(){return 100*this.millisecond()})),$(0,["SSSSSS",6],0,(function(){return 1e3*this.millisecond()})),$(0,["SSSSSSS",7],0,(function(){return 1e4*this.millisecond()})),$(0,["SSSSSSSS",8],0,(function(){return 1e5*this.millisecond()})),$(0,["SSSSSSSSS",9],0,(function(){return 1e6*this.millisecond()})),Se("S",ge,le),Se("SS",ge,ce),Se("SSS",ge,ue),oi="SSSS";oi.length<=9;oi+="S")Se(oi,be);function si(e,t){t[ze]=Le(1e3*("0."+e))}for(oi="S";oi.length<=9;oi+="S")Ie(oi,si);function li(){return this._isUTC?"UTC":""}function ci(){return this._isUTC?"Coordinated Universal Time":""}ii=Ze("Milliseconds",!1),$("z",0,0,"zoneAbbr"),$("zz",0,0,"zoneName");var ui=w.prototype;function di(e){return Kn(1e3*e)}function pi(){return Kn.apply(null,arguments).parseZone()}function fi(e){return e}ui.add=Br,ui.calendar=Ur,ui.clone=zr,ui.diff=Zr,ui.endOf=bo,ui.format=no,ui.from=ro,ui.fromNow=oo,ui.to=io,ui.toNow=ao,ui.get=et,ui.invalidAt=Mo,ui.isAfter=Wr,ui.isBefore=Vr,ui.isBetween=Gr,ui.isSame=Qr,ui.isSameOrAfter=qr,ui.isSameOrBefore=Kr,ui.isValid=Co,ui.lang=lo,ui.locale=so,ui.localeData=co,ui.max=Jn,ui.min=Zn,ui.parsingFlags=So,ui.set=tt,ui.startOf=yo,ui.subtract=Rr,ui.toArray=wo,ui.toObject=xo,ui.toDate=Eo,ui.toISOString=eo,ui.inspect=to,"undefined"!=typeof Symbol&&null!=Symbol.for&&(ui[Symbol.for("nodejs.util.inspect.custom")]=function(){return"Moment<"+this.format()+">"}),ui.toJSON=ko,ui.toString=Xr,ui.unix=Ao,ui.valueOf=_o,ui.creationData=To,ui.eraName=Po,ui.eraNarrow=Io,ui.eraAbbr=Bo,ui.eraYear=Ro,ui.year=qe,ui.isLeapYear=Ke,ui.weekYear=Vo,ui.isoWeekYear=Go,ui.quarter=ui.quarters=ei,ui.month=ht,ui.daysInMonth=mt,ui.week=ui.weeks=Tt,ui.isoWeek=ui.isoWeeks=Ot,ui.weeksInYear=Ko,ui.weeksInWeekYear=Zo,ui.isoWeeksInYear=Qo,ui.isoWeeksInISOWeekYear=qo,ui.date=ti,ui.day=ui.days=Wt,ui.weekday=Vt,ui.isoWeekday=Gt,ui.dayOfYear=ni,ui.hour=ui.hours=on,ui.minute=ui.minutes=ri,ui.second=ui.seconds=ai,ui.millisecond=ui.milliseconds=ii,ui.utcOffset=gr,ui.utc=yr,ui.local=br,ui.parseZone=_r,ui.hasAlignedHourOffset=Ar,ui.isDST=Er,ui.isLocal=xr,ui.isUtcOffset=kr,ui.isUtc=Cr,ui.isUTC=Cr,ui.zoneAbbr=li,ui.zoneName=ci,ui.dates=C("dates accessor is deprecated. Use date instead.",ti),ui.months=C("months accessor is deprecated. Use month instead",ht),ui.years=C("years accessor is deprecated. Use year instead",qe),ui.zone=C("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",vr),ui.isDSTShifted=C("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",wr);var hi=P.prototype;function mi(e,t,n,r){var o=bn(),i=m().set(r,t);return o[n](i,e)}function gi(e,t,n){if(d(e)&&(t=e,e=void 0),e=e||"",null!=t)return mi(e,t,n,"month");var r,o=[];for(r=0;r<12;r++)o[r]=mi(e,r,n,"month");return o}function vi(e,t,n,r){"boolean"==typeof e?(d(t)&&(n=t,t=void 0),t=t||""):(n=t=e,e=!1,d(t)&&(n=t,t=void 0),t=t||"");var o,i=bn(),a=e?i._week.dow:0,s=[];if(null!=n)return mi(t,(n+a)%7,r,"day");for(o=0;o<7;o++)s[o]=mi(t,(o+a)%7,r,"day");return s}function yi(e,t){return gi(e,t,"months")}function bi(e,t){return gi(e,t,"monthsShort")}function _i(e,t,n){return vi(e,t,n,"weekdays")}function Ai(e,t,n){return vi(e,t,n,"weekdaysShort")}function Ei(e,t,n){return vi(e,t,n,"weekdaysMin")}hi.calendar=B,hi.longDateFormat=G,hi.invalidDate=q,hi.ordinal=J,hi.preparse=fi,hi.postformat=fi,hi.relativeTime=ee,hi.pastFuture=te,hi.set=D,hi.eras=Oo,hi.erasParse=Do,hi.erasConvertYear=Lo,hi.erasAbbrRegex=Fo,hi.erasNameRegex=No,hi.erasNarrowRegex=jo,hi.months=ct,hi.monthsShort=ut,hi.monthsParse=pt,hi.monthsRegex=vt,hi.monthsShortRegex=gt,hi.week=kt,hi.firstDayOfYear=Mt,hi.firstDayOfWeek=St,hi.weekdays=Yt,hi.weekdaysMin=Ht,hi.weekdaysShort=$t,hi.weekdaysParse=zt,hi.weekdaysRegex=Qt,hi.weekdaysShortRegex=qt,hi.weekdaysMinRegex=Kt,hi.isPM=nn,hi.meridiem=an,gn("en",{eras:[{since:"0001-01-01",until:1/0,offset:1,name:"Anno Domini",narrow:"AD",abbr:"AD"},{since:"0000-12-31",until:-1/0,offset:1,name:"Before Christ",narrow:"BC",abbr:"BC"}],dayOfMonthOrdinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var t=e%10;return e+(1===Le(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th")}}),o.lang=C("moment.lang is deprecated. Use moment.locale instead.",gn),o.langData=C("moment.langData is deprecated. Use moment.localeData instead.",bn);var wi=Math.abs;function xi(){var e=this._data;return this._milliseconds=wi(this._milliseconds),this._days=wi(this._days),this._months=wi(this._months),e.milliseconds=wi(e.milliseconds),e.seconds=wi(e.seconds),e.minutes=wi(e.minutes),e.hours=wi(e.hours),e.months=wi(e.months),e.years=wi(e.years),this}function ki(e,t,n,r){var o=Tr(t,n);return e._milliseconds+=r*o._milliseconds,e._days+=r*o._days,e._months+=r*o._months,e._bubble()}function Ci(e,t){return ki(this,e,t,1)}function Si(e,t){return ki(this,e,t,-1)}function Mi(e){return e<0?Math.floor(e):Math.ceil(e)}function Ti(){var e,t,n,r,o,i=this._milliseconds,a=this._days,s=this._months,l=this._data;return i>=0&&a>=0&&s>=0||i<=0&&a<=0&&s<=0||(i+=864e5*Mi(Di(s)+a),a=0,s=0),l.milliseconds=i%1e3,e=De(i/1e3),l.seconds=e%60,t=De(e/60),l.minutes=t%60,n=De(t/60),l.hours=n%24,a+=De(n/24),s+=o=De(Oi(a)),a-=Mi(Di(o)),r=De(s/12),s%=12,l.days=a,l.months=s,l.years=r,this}function Oi(e){return 4800*e/146097}function Di(e){return 146097*e/4800}function Li(e){if(!this.isValid())return NaN;var t,n,r=this._milliseconds;if("month"===(e=re(e))||"quarter"===e||"year"===e)switch(t=this._days+r/864e5,n=this._months+Oi(t),e){case"month":return n;case"quarter":return n/3;case"year":return n/12}else switch(t=this._days+Math.round(Di(this._months)),e){case"week":return t/7+r/6048e5;case"day":return t+r/864e5;case"hour":return 24*t+r/36e5;case"minute":return 1440*t+r/6e4;case"second":return 86400*t+r/1e3;case"millisecond":return Math.floor(864e5*t)+r;default:throw new Error("Unknown unit "+e)}}function Pi(e){return function(){return this.as(e)}}var Ii=Pi("ms"),Bi=Pi("s"),Ri=Pi("m"),Ni=Pi("h"),Fi=Pi("d"),ji=Pi("w"),Yi=Pi("M"),$i=Pi("Q"),Hi=Pi("y"),Ui=Ii;function zi(){return Tr(this)}function Wi(e){return e=re(e),this.isValid()?this[e+"s"]():NaN}function Vi(e){return function(){return this.isValid()?this._data[e]:NaN}}var Gi=Vi("milliseconds"),Qi=Vi("seconds"),qi=Vi("minutes"),Ki=Vi("hours"),Zi=Vi("days"),Ji=Vi("months"),Xi=Vi("years");function ea(){return De(this.days()/7)}var ta=Math.round,na={ss:44,s:45,m:45,h:22,d:26,w:null,M:11};function ra(e,t,n,r,o){return o.relativeTime(t||1,!!n,e,r)}function oa(e,t,n,r){var o=Tr(e).abs(),i=ta(o.as("s")),a=ta(o.as("m")),s=ta(o.as("h")),l=ta(o.as("d")),c=ta(o.as("M")),u=ta(o.as("w")),d=ta(o.as("y")),p=i<=n.ss&&["s",i]||i<n.s&&["ss",i]||a<=1&&["m"]||a<n.m&&["mm",a]||s<=1&&["h"]||s<n.h&&["hh",s]||l<=1&&["d"]||l<n.d&&["dd",l];return null!=n.w&&(p=p||u<=1&&["w"]||u<n.w&&["ww",u]),(p=p||c<=1&&["M"]||c<n.M&&["MM",c]||d<=1&&["y"]||["yy",d])[2]=t,p[3]=+e>0,p[4]=r,ra.apply(null,p)}function ia(e){return void 0===e?ta:"function"==typeof e&&(ta=e,!0)}function aa(e,t){return void 0!==na[e]&&(void 0===t?na[e]:(na[e]=t,"s"===e&&(na.ss=t-1),!0))}function sa(e,t){if(!this.isValid())return this.localeData().invalidDate();var n,r,o=!1,i=na;return"object"==typeof e&&(t=e,e=!1),"boolean"==typeof e&&(o=e),"object"==typeof t&&(i=Object.assign({},na,t),null!=t.s&&null==t.ss&&(i.ss=t.s-1)),r=oa(this,!o,i,n=this.localeData()),o&&(r=n.pastFuture(+this,r)),n.postformat(r)}var la=Math.abs;function ca(e){return(e>0)-(e<0)||+e}function ua(){if(!this.isValid())return this.localeData().invalidDate();var e,t,n,r,o,i,a,s,l=la(this._milliseconds)/1e3,c=la(this._days),u=la(this._months),d=this.asSeconds();return d?(e=De(l/60),t=De(e/60),l%=60,e%=60,n=De(u/12),u%=12,r=l?l.toFixed(3).replace(/\.?0+$/,""):"",o=d<0?"-":"",i=ca(this._months)!==ca(d)?"-":"",a=ca(this._days)!==ca(d)?"-":"",s=ca(this._milliseconds)!==ca(d)?"-":"",o+"P"+(n?i+n+"Y":"")+(u?i+u+"M":"")+(c?a+c+"D":"")+(t||e||l?"T":"")+(t?s+t+"H":"")+(e?s+e+"M":"")+(l?s+r+"S":"")):"P0D"}var da=sr.prototype;return da.isValid=ir,da.abs=xi,da.add=Ci,da.subtract=Si,da.as=Li,da.asMilliseconds=Ii,da.asSeconds=Bi,da.asMinutes=Ri,da.asHours=Ni,da.asDays=Fi,da.asWeeks=ji,da.asMonths=Yi,da.asQuarters=$i,da.asYears=Hi,da.valueOf=Ui,da._bubble=Ti,da.clone=zi,da.get=Wi,da.milliseconds=Gi,da.seconds=Qi,da.minutes=qi,da.hours=Ki,da.days=Zi,da.weeks=ea,da.months=Ji,da.years=Xi,da.humanize=sa,da.toISOString=ua,da.toString=ua,da.toJSON=ua,da.locale=so,da.localeData=co,da.toIsoString=C("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",ua),da.lang=lo,$("X",0,0,"unix"),$("x",0,0,"valueOf"),Se("x",_e),Se("X",we),Ie("X",(function(e,t,n){n._d=new Date(1e3*parseFloat(e))})),Ie("x",(function(e,t,n){n._d=new Date(Le(e))})),
//! moment.js
o.version="2.30.1",i(Kn),o.fn=ui,o.min=er,o.max=tr,o.now=nr,o.utc=m,o.unix=di,o.months=yi,o.isDate=p,o.locale=gn,o.invalid=b,o.duration=Tr,o.isMoment=x,o.weekdays=_i,o.parseZone=pi,o.localeData=bn,o.isDuration=lr,o.monthsShort=bi,o.weekdaysMin=Ei,o.defineLocale=vn,o.updateLocale=yn,o.locales=_n,o.weekdaysShort=Ai,o.normalizeUnits=re,o.relativeTimeRounding=ia,o.relativeTimeThreshold=aa,o.calendarFormat=Hr,o.prototype=ui,o.HTML5_FMT={DATETIME_LOCAL:"YYYY-MM-DDTHH:mm",DATETIME_LOCAL_SECONDS:"YYYY-MM-DDTHH:mm:ss",DATETIME_LOCAL_MS:"YYYY-MM-DDTHH:mm:ss.SSS",DATE:"YYYY-MM-DD",TIME:"HH:mm",TIME_SECONDS:"HH:mm:ss",TIME_MS:"HH:mm:ss.SSS",WEEK:"GGGG-[W]WW",MONTH:"YYYY-MM"},o}()},70628:(e,t,n)=>{"use strict";var r=n(54067);function o(){}function i(){}i.resetWarningCache=o,e.exports=function(){function e(e,t,n,o,i,a){if(a!==r){var s=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw s.name="Invariant Violation",s}}function t(){return e}e.isRequired=e;var n={array:e,bigint:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:i,resetWarningCache:o};return n.PropTypes=n,n}},75826:(e,t,n)=>{e.exports=n(70628)()},54067:e=>{"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},41882:e=>{"use strict";function t(e){this._maxSize=e,this.clear()}t.prototype.clear=function(){this._size=0,this._values=Object.create(null)},t.prototype.get=function(e){return this._values[e]},t.prototype.set=function(e,t){return this._size>=this._maxSize&&this.clear(),e in this._values||this._size++,this._values[e]=t};var n=/[^.^\]^[]+|(?=\[\]|\.\.)/g,r=/^\d+$/,o=/^\d/,i=/[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,a=/^\s*(['"]?)(.*?)(\1)\s*$/,s=new t(512),l=new t(512),c=new t(512);function u(e){return s.get(e)||s.set(e,d(e).map((function(e){return e.replace(a,"$2")})))}function d(e){return e.match(n)||[""]}function p(e){return"string"==typeof e&&e&&-1!==["'",'"'].indexOf(e.charAt(0))}function f(e){return!p(e)&&(function(e){return e.match(o)&&!e.match(r)}(e)||function(e){return i.test(e)}(e))}e.exports={Cache:t,split:d,normalizePath:u,setter:function(e){var t=u(e);return l.get(e)||l.set(e,(function(e,n){for(var r=0,o=t.length,i=e;r<o-1;){var a=t[r];if("__proto__"===a||"constructor"===a||"prototype"===a)return e;i=i[t[r++]]}i[t[r]]=n}))},getter:function(e,t){var n=u(e);return c.get(e)||c.set(e,(function(e){for(var r=0,o=n.length;r<o;){if(null==e&&t)return;e=e[n[r++]]}return e}))},join:function(e){return e.reduce((function(e,t){return e+(p(t)||r.test(t)?"["+t+"]":(e?".":"")+t)}),"")},forEach:function(e,t,n){!function(e,t,n){var r,o,i,a,s=e.length;for(o=0;o<s;o++)(r=e[o])&&(f(r)&&(r='"'+r+'"'),i=!(a=p(r))&&/^\d+$/.test(r),t.call(n,r,a,i,o,e))}(Array.isArray(e)?e:d(e),t,n)}}},87504:function(e,t,n){
/*!
  react-datepicker v6.9.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/
!function(e,t,n,r,o,i,a,s,l,c,u,d,p,f,h,m,g,v,y,b,_,A,E,w,x,k,C,S,M,T,O,D,L,P,I,B,R,N,F,j,Y,$,H,U,z,W,V,G,Q,q,K,Z,J,X,ee,te,ne,re,oe,ie,ae,se,le,ce,ue,de){"use strict";function pe(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var fe=pe(t),he=pe(le),me=pe(ce);function ge(e,t,n){return t=Me(t),function(e,t){if(t&&("object"==typeof t||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e)}(e,ve()?Reflect.construct(t,n||[],Me(e).constructor):t.apply(e,n))}function ve(){try{var e=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(e){}return(ve=function(){return!!e})()}function ye(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function be(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?ye(Object(n),!0).forEach((function(t){ke(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):ye(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function _e(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}function Ae(e){return Ae="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},Ae(e)}function Ee(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function we(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,_e(r.key),r)}}function xe(e,t,n){return t&&we(e.prototype,t),n&&we(e,n),Object.defineProperty(e,"prototype",{writable:!1}),e}function ke(e,t,n){return(t=_e(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function Ce(){return Ce=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Ce.apply(this,arguments)}function Se(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&Te(e,t)}function Me(e){return Me=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},Me(e)}function Te(e,t){return Te=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},Te(e,t)}function Oe(e){return function(e){if(Array.isArray(e))return De(e)}(e)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||function(e,t){if(e){if("string"==typeof e)return De(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?De(e,t):void 0}}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function De(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var Le=12,Pe=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function Ie(e){var t=e?"string"==typeof e||e instanceof String?ae.parseISO(e):oe.toDate(e):new Date;return Be(t)?t:null}function Be(e,t){return t=t||new Date("1/1/1000"),i.isValid(e)&&!ne.isBefore(e,t)}function Re(e,t,n){if("en"===n)return a.format(e,t,{useAdditionalWeekYearTokens:!0,useAdditionalDayOfYearTokens:!0});var r=Ze(n);return n&&!r&&console.warn('A locale object was not found for the provided string ["'.concat(n,'"].')),!r&&Ke()&&Ze(Ke())&&(r=Ze(Ke())),a.format(e,t,{locale:r||null,useAdditionalWeekYearTokens:!0,useAdditionalDayOfYearTokens:!0})}function Ne(e,t){var n=t.dateFormat,r=t.locale;return e&&Re(e,Array.isArray(n)?n[0]:n,r)||""}function Fe(e,t){var n=t.hour,r=void 0===n?0:n,o=t.minute,i=void 0===o?0:o,a=t.second,s=void 0===a?0:a;return D.setHours(O.setMinutes(T.setSeconds(e,s),i),r)}function je(e,t,n){var r=Ze(t||Ke());return H.startOfWeek(e,{locale:r,weekStartsOn:n})}function Ye(e){return U.startOfMonth(e)}function $e(e){return W.startOfYear(e)}function He(e){return z.startOfQuarter(e)}function Ue(){return $.startOfDay(Ie())}function ze(e,t){return e&&t?X.isSameYear(e,t):!e&&!t}function We(e,t){return e&&t?J.isSameMonth(e,t):!e&&!t}function Ve(e,t){return e&&t?ee.isSameQuarter(e,t):!e&&!t}function Ge(e,t){return e&&t?Z.isSameDay(e,t):!e&&!t}function Qe(e,t){return e&&t?K.isEqual(e,t):!e&&!t}function qe(e,t,n){var r,o=$.startOfDay(t),i=V.endOfDay(n);try{r=re.isWithinInterval(e,{start:o,end:i})}catch(e){r=!1}return r}function Ke(){return("undefined"!=typeof window?window:globalThis).__localeId__}function Ze(e){if("string"==typeof e){var t="undefined"!=typeof window?window:globalThis;return t.__localeData__?t.__localeData__[e]:null}return e}function Je(e,t){return Re(L.setMonth(Ie(),e),"LLLL",t)}function Xe(e,t){return Re(L.setMonth(Ie(),e),"LLL",t)}function et(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.minDate,r=t.maxDate,o=t.excludeDates,i=t.excludeDateIntervals,a=t.includeDates,s=t.includeDateIntervals,l=t.filterDate;return lt(e,{minDate:n,maxDate:r})||o&&o.some((function(t){return Ge(e,t.date?t.date:t)}))||i&&i.some((function(t){var n=t.start,r=t.end;return re.isWithinInterval(e,{start:n,end:r})}))||a&&!a.some((function(t){return Ge(e,t)}))||s&&!s.some((function(t){var n=t.start,r=t.end;return re.isWithinInterval(e,{start:n,end:r})}))||l&&!l(Ie(e))||!1}function tt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.excludeDates,r=t.excludeDateIntervals;return r&&r.length>0?r.some((function(t){var n=t.start,r=t.end;return re.isWithinInterval(e,{start:n,end:r})})):n&&n.some((function(t){return Ge(e,t.date?t.date:t)}))||!1}function nt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.minDate,r=t.maxDate,o=t.excludeDates,i=t.includeDates,a=t.filterDate;return lt(e,{minDate:U.startOfMonth(n),maxDate:Q.endOfMonth(r)})||o&&o.some((function(t){return We(e,t)}))||i&&!i.some((function(t){return We(e,t)}))||a&&!a(Ie(e))||!1}function rt(e,t,n,r){var o=S.getYear(e),i=k.getMonth(e),a=S.getYear(t),s=k.getMonth(t),l=S.getYear(r);return o===a&&o===l?i<=n&&n<=s:o<a?l===o&&i<=n||l===a&&s>=n||l<a&&l>o:void 0}function ot(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.minDate,r=t.maxDate,o=t.excludeDates,i=t.includeDates,a=t.filterDate;return lt(e,{minDate:n,maxDate:r})||o&&o.some((function(t){return Ve(e,t)}))||i&&!i.some((function(t){return Ve(e,t)}))||a&&!a(Ie(e))||!1}function it(e,t,n){if(!i.isValid(t)||!i.isValid(n))return!1;var r=S.getYear(t),o=S.getYear(n);return r<=e&&o>=e}function at(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.minDate,r=t.maxDate,o=t.excludeDates,i=t.includeDates,a=t.filterDate,s=new Date(e,0,1);return lt(s,{minDate:W.startOfYear(n),maxDate:q.endOfYear(r)})||o&&o.some((function(e){return ze(s,e)}))||i&&!i.some((function(e){return ze(s,e)}))||a&&!a(Ie(s))||!1}function st(e,t,n,r){var o=S.getYear(e),i=C.getQuarter(e),a=S.getYear(t),s=C.getQuarter(t),l=S.getYear(r);return o===a&&o===l?i<=n&&n<=s:o<a?l===o&&i<=n||l===a&&s>=n||l<a&&l>o:void 0}function lt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.minDate,r=t.maxDate;return n&&N.differenceInCalendarDays(e,n)<0||r&&N.differenceInCalendarDays(e,r)>0}function ct(e,t){return t.some((function(t){return A.getHours(t)===A.getHours(e)&&_.getMinutes(t)===_.getMinutes(e)&&b.getSeconds(t)===b.getSeconds(e)}))}function ut(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.excludeTimes,r=t.includeTimes,o=t.filterTime;return n&&ct(e,n)||r&&!ct(e,r)||o&&!o(e)||!1}function dt(e,t){var n=t.minTime,r=t.maxTime;if(!n||!r)throw new Error("Both minTime and maxTime props required");var o=Ie();o=D.setHours(o,A.getHours(e)),o=O.setMinutes(o,_.getMinutes(e)),o=T.setSeconds(o,b.getSeconds(e));var i=Ie();i=D.setHours(i,A.getHours(n)),i=O.setMinutes(i,_.getMinutes(n)),i=T.setSeconds(i,b.getSeconds(n));var a,s=Ie();s=D.setHours(s,A.getHours(r)),s=O.setMinutes(s,_.getMinutes(r)),s=T.setSeconds(s,b.getSeconds(r));try{a=!re.isWithinInterval(o,{start:i,end:s})}catch(e){a=!1}return a}function pt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.minDate,r=t.includeDates,o=g.subMonths(e,1);return n&&F.differenceInCalendarMonths(n,o)>0||r&&r.every((function(e){return F.differenceInCalendarMonths(e,o)>0}))||!1}function ft(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.maxDate,r=t.includeDates,o=d.addMonths(e,1);return n&&F.differenceInCalendarMonths(o,n)>0||r&&r.every((function(e){return F.differenceInCalendarMonths(o,e)>0}))||!1}function ht(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.minDate,r=t.includeDates,o=y.subYears(e,1);return n&&j.differenceInCalendarYears(n,o)>0||r&&r.every((function(e){return j.differenceInCalendarYears(e,o)>0}))||!1}function mt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.maxDate,r=t.includeDates,o=f.addYears(e,1);return n&&j.differenceInCalendarYears(o,n)>0||r&&r.every((function(e){return j.differenceInCalendarYears(o,e)>0}))||!1}function gt(e){var t=e.minDate,n=e.includeDates;if(n&&t){var r=n.filter((function(e){return N.differenceInCalendarDays(e,t)>=0}));return B.min(r)}return n?B.min(n):t}function vt(e){var t=e.maxDate,n=e.includeDates;if(n&&t){var r=n.filter((function(e){return N.differenceInCalendarDays(e,t)<=0}));return R.max(r)}return n?R.max(n):t}function yt(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--highlighted",n=new Map,r=0,i=e.length;r<i;r++){var a=e[r];if(o.isDate(a)){var s=Re(a,"MM.dd.yyyy"),l=n.get(s)||[];l.includes(t)||(l.push(t),n.set(s,l))}else if("object"===Ae(a)){var c=Object.keys(a),u=c[0],d=a[c[0]];if("string"==typeof u&&d.constructor===Array)for(var p=0,f=d.length;p<f;p++){var h=Re(d[p],"MM.dd.yyyy"),m=n.get(h)||[];m.includes(u)||(m.push(u),n.set(h,m))}}}return n}function bt(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--holidays",n=new Map;return e.forEach((function(e){var r=e.date,i=e.holidayName;if(o.isDate(r)){var a=Re(r,"MM.dd.yyyy"),s=n.get(a)||{};if(!("className"in s)||s.className!==t||(l=s.holidayNames,c=[i],l.length!==c.length||!l.every((function(e,t){return e===c[t]})))){var l,c;s.className=t;var u=s.holidayNames;s.holidayNames=u?[].concat(Oe(u),[i]):[i],n.set(a,s)}}})),n}function _t(e,t,n,r,o){for(var i=o.length,a=[],c=0;c<i;c++){var u=e;u=l.addHours(u,A.getHours(o[c])),u=s.addMinutes(u,_.getMinutes(o[c])),u=se.addSeconds(u,b.getSeconds(o[c]));var d=s.addMinutes(e,(n+1)*r);te.isAfter(u,t)&&ne.isBefore(u,d)&&a.push(o[c])}return a}function At(e){return e<10?"0".concat(e):"".concat(e)}function Et(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Le,n=Math.ceil(S.getYear(e)/t)*t;return{startPeriod:n-(t-1),endPeriod:n}}function wt(e){var t=e.getSeconds(),n=e.getMilliseconds();return oe.toDate(e.getTime()-1e3*t-n)}function xt(e){if(!o.isDate(e))throw new Error("Invalid date");var t=new Date(e);return t.setHours(0,0,0,0),t}function kt(e,t){if(!o.isDate(e)||!o.isDate(t))throw new Error("Invalid date received");var n=xt(e),r=xt(t);return ne.isBefore(n,r)}function Ct(e){return" "===e.key}function St(e,t,n,r){for(var o=[],i=0;i<2*t+1;i++){var a=e+t-i,s=!0;n&&(s=S.getYear(n)<=a),r&&s&&(s=S.getYear(r)>=a),s&&o.push(a)}return o}var Mt=function(e){function n(e){var r;Ee(this,n),ke(r=ge(this,n,[e]),"renderOptions",(function(){var e=r.props.year,t=r.state.yearsList.map((function(t){return fe.default.createElement("div",{className:e===t?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:t,onClick:r.onChange.bind(r,t),"aria-selected":e===t?"true":void 0},e===t?fe.default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",t)})),n=r.props.minDate?S.getYear(r.props.minDate):null,o=r.props.maxDate?S.getYear(r.props.maxDate):null;return o&&r.state.yearsList.find((function(e){return e===o}))||t.unshift(fe.default.createElement("div",{className:"react-datepicker__year-option",key:"upcoming",onClick:r.incrementYears},fe.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),n&&r.state.yearsList.find((function(e){return e===n}))||t.push(fe.default.createElement("div",{className:"react-datepicker__year-option",key:"previous",onClick:r.decrementYears},fe.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),t})),ke(r,"onChange",(function(e){r.props.onChange(e)})),ke(r,"handleClickOutside",(function(){r.props.onCancel()})),ke(r,"shiftYears",(function(e){var t=r.state.yearsList.map((function(t){return t+e}));r.setState({yearsList:t})})),ke(r,"incrementYears",(function(){return r.shiftYears(1)})),ke(r,"decrementYears",(function(){return r.shiftYears(-1)}));var o=e.yearDropdownItemNumber,i=e.scrollableYearDropdown,a=o||(i?10:5);return r.state={yearsList:St(r.props.year,a,r.props.minDate,r.props.maxDate)},r.dropdownRef=t.createRef(),r}return Se(n,e),xe(n,[{key:"componentDidMount",value:function(){var e=this.dropdownRef.current;if(e){var t=e.children?Array.from(e.children):null,n=t?t.find((function(e){return e.ariaSelected})):null;e.scrollTop=n?n.offsetTop+(n.clientHeight-e.clientHeight)/2:(e.scrollHeight-e.clientHeight)/2}}},{key:"render",value:function(){var e=r.clsx({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return fe.default.createElement("div",{className:e,ref:this.dropdownRef},this.renderOptions())}}])}(fe.default.Component),Tt=he.default(Mt),Ot=function(e){function t(){var e;Ee(this,t);for(var n=arguments.length,r=new Array(n),o=0;o<n;o++)r[o]=arguments[o];return ke(e=ge(this,t,[].concat(r)),"state",{dropdownVisible:!1}),ke(e,"renderSelectOptions",(function(){for(var t=e.props.minDate?S.getYear(e.props.minDate):1900,n=e.props.maxDate?S.getYear(e.props.maxDate):2100,r=[],o=t;o<=n;o++)r.push(fe.default.createElement("option",{key:o,value:o},o));return r})),ke(e,"onSelectChange",(function(t){e.onChange(t.target.value)})),ke(e,"renderSelectMode",(function(){return fe.default.createElement("select",{value:e.props.year,className:"react-datepicker__year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),ke(e,"renderReadView",(function(t){return fe.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(t){return e.toggleDropdown(t)}},fe.default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),fe.default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},e.props.year))})),ke(e,"renderDropdown",(function(){return fe.default.createElement(Tt,{key:"dropdown",year:e.props.year,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableYearDropdown:e.props.scrollableYearDropdown,yearDropdownItemNumber:e.props.yearDropdownItemNumber})})),ke(e,"renderScrollMode",(function(){var t=e.state.dropdownVisible,n=[e.renderReadView(!t)];return t&&n.unshift(e.renderDropdown()),n})),ke(e,"onChange",(function(t){e.toggleDropdown(),t!==e.props.year&&e.props.onChange(t)})),ke(e,"toggleDropdown",(function(t){e.setState({dropdownVisible:!e.state.dropdownVisible},(function(){e.props.adjustDateOnChange&&e.handleYearChange(e.props.date,t)}))})),ke(e,"handleYearChange",(function(t,n){e.onSelect(t,n),e.setOpen()})),ke(e,"onSelect",(function(t,n){e.props.onSelect&&e.props.onSelect(t,n)})),ke(e,"setOpen",(function(){e.props.setOpen&&e.props.setOpen(!0)})),e}return Se(t,e),xe(t,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return fe.default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},e)}}])}(fe.default.Component),Dt=function(e){function t(){var e;Ee(this,t);for(var n=arguments.length,r=new Array(n),o=0;o<n;o++)r[o]=arguments[o];return ke(e=ge(this,t,[].concat(r)),"isSelectedMonth",(function(t){return e.props.month===t})),ke(e,"renderOptions",(function(){return e.props.monthNames.map((function(t,n){return fe.default.createElement("div",{className:e.isSelectedMonth(n)?"react-datepicker__month-option react-datepicker__month-option--selected_month":"react-datepicker__month-option",key:t,onClick:e.onChange.bind(e,n),"aria-selected":e.isSelectedMonth(n)?"true":void 0},e.isSelectedMonth(n)?fe.default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",t)}))})),ke(e,"onChange",(function(t){return e.props.onChange(t)})),ke(e,"handleClickOutside",(function(){return e.props.onCancel()})),e}return Se(t,e),xe(t,[{key:"render",value:function(){return fe.default.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}])}(fe.default.Component),Lt=he.default(Dt),Pt=function(e){function t(){var e;Ee(this,t);for(var n=arguments.length,r=new Array(n),o=0;o<n;o++)r[o]=arguments[o];return ke(e=ge(this,t,[].concat(r)),"state",{dropdownVisible:!1}),ke(e,"renderSelectOptions",(function(e){return e.map((function(e,t){return fe.default.createElement("option",{key:t,value:t},e)}))})),ke(e,"renderSelectMode",(function(t){return fe.default.createElement("select",{value:e.props.month,className:"react-datepicker__month-select",onChange:function(t){return e.onChange(t.target.value)}},e.renderSelectOptions(t))})),ke(e,"renderReadView",(function(t,n){return fe.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:e.toggleDropdown},fe.default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),fe.default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},n[e.props.month]))})),ke(e,"renderDropdown",(function(t){return fe.default.createElement(Lt,{key:"dropdown",month:e.props.month,monthNames:t,onChange:e.onChange,onCancel:e.toggleDropdown})})),ke(e,"renderScrollMode",(function(t){var n=e.state.dropdownVisible,r=[e.renderReadView(!n,t)];return n&&r.unshift(e.renderDropdown(t)),r})),ke(e,"onChange",(function(t){e.toggleDropdown(),t!==e.props.month&&e.props.onChange(t)})),ke(e,"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return Se(t,e),xe(t,[{key:"render",value:function(){var e,t=this,n=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return Xe(e,t.props.locale)}:function(e){return Je(e,t.props.locale)});switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode(n);break;case"select":e=this.renderSelectMode(n)}return fe.default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},e)}}])}(fe.default.Component);function It(e,t){for(var n=[],r=Ye(e),o=Ye(t);!te.isAfter(r,o);)n.push(Ie(r)),r=d.addMonths(r,1);return n}var Bt=function(e){function t(e){var n;return Ee(this,t),ke(n=ge(this,t,[e]),"renderOptions",(function(){return n.state.monthYearsList.map((function(e){var t=M.getTime(e),r=ze(n.props.date,e)&&We(n.props.date,e);return fe.default.createElement("div",{className:r?"react-datepicker__month-year-option--selected_month-year":"react-datepicker__month-year-option",key:t,onClick:n.onChange.bind(n,t),"aria-selected":r?"true":void 0},r?fe.default.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",Re(e,n.props.dateFormat,n.props.locale))}))})),ke(n,"onChange",(function(e){return n.props.onChange(e)})),ke(n,"handleClickOutside",(function(){n.props.onCancel()})),n.state={monthYearsList:It(n.props.minDate,n.props.maxDate)},n}return Se(t,e),xe(t,[{key:"render",value:function(){var e=r.clsx({"react-datepicker__month-year-dropdown":!0,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return fe.default.createElement("div",{className:e},this.renderOptions())}}])}(fe.default.Component),Rt=he.default(Bt),Nt=function(e){function t(){var e;Ee(this,t);for(var n=arguments.length,r=new Array(n),o=0;o<n;o++)r[o]=arguments[o];return ke(e=ge(this,t,[].concat(r)),"state",{dropdownVisible:!1}),ke(e,"renderSelectOptions",(function(){for(var t=Ye(e.props.minDate),n=Ye(e.props.maxDate),r=[];!te.isAfter(t,n);){var o=M.getTime(t);r.push(fe.default.createElement("option",{key:o,value:o},Re(t,e.props.dateFormat,e.props.locale))),t=d.addMonths(t,1)}return r})),ke(e,"onSelectChange",(function(t){e.onChange(t.target.value)})),ke(e,"renderSelectMode",(function(){return fe.default.createElement("select",{value:M.getTime(Ye(e.props.date)),className:"react-datepicker__month-year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),ke(e,"renderReadView",(function(t){var n=Re(e.props.date,e.props.dateFormat,e.props.locale);return fe.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:function(t){return e.toggleDropdown(t)}},fe.default.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),fe.default.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},n))})),ke(e,"renderDropdown",(function(){return fe.default.createElement(Rt,{key:"dropdown",date:e.props.date,dateFormat:e.props.dateFormat,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableMonthYearDropdown:e.props.scrollableMonthYearDropdown,locale:e.props.locale})})),ke(e,"renderScrollMode",(function(){var t=e.state.dropdownVisible,n=[e.renderReadView(!t)];return t&&n.unshift(e.renderDropdown()),n})),ke(e,"onChange",(function(t){e.toggleDropdown();var n=Ie(parseInt(t));ze(e.props.date,n)&&We(e.props.date,n)||e.props.onChange(n)})),ke(e,"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return Se(t,e),xe(t,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return fe.default.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},e)}}])}(fe.default.Component),Ft=function(e){function t(){var e;Ee(this,t);for(var n=arguments.length,o=new Array(n),i=0;i<n;i++)o[i]=arguments[i];return ke(e=ge(this,t,[].concat(o)),"dayEl",fe.default.createRef()),ke(e,"handleClick",(function(t){!e.isDisabled()&&e.props.onClick&&e.props.onClick(t)})),ke(e,"handleMouseEnter",(function(t){!e.isDisabled()&&e.props.onMouseEnter&&e.props.onMouseEnter(t)})),ke(e,"handleOnKeyDown",(function(t){" "===t.key&&(t.preventDefault(),t.key="Enter"),e.props.handleOnKeyDown(t)})),ke(e,"isSameDay",(function(t){return Ge(e.props.day,t)})),ke(e,"isKeyboardSelected",(function(){var t;return!e.props.disabledKeyboardNavigation&&!(e.props.selectsMultiple?null===(t=e.props.selectedDates)||void 0===t?void 0:t.some((function(t){return e.isSameDayOrWeek(t)})):e.isSameDayOrWeek(e.props.selected))&&e.isSameDayOrWeek(e.props.preSelection)})),ke(e,"isDisabled",(function(){return et(e.props.day,e.props)})),ke(e,"isExcluded",(function(){return tt(e.props.day,e.props)})),ke(e,"isStartOfWeek",(function(){return Ge(e.props.day,je(e.props.day,e.props.locale,e.props.calendarStartDay))})),ke(e,"isSameWeek",(function(t){return e.props.showWeekPicker&&Ge(t,je(e.props.day,e.props.locale,e.props.calendarStartDay))})),ke(e,"isSameDayOrWeek",(function(t){return e.isSameDay(t)||e.isSameWeek(t)})),ke(e,"getHighLightedClass",(function(){var t=e.props,n=t.day,r=t.highlightDates;if(!r)return!1;var o=Re(n,"MM.dd.yyyy");return r.get(o)})),ke(e,"getHolidaysClass",(function(){var t=e.props,n=t.day,r=t.holidays;if(!r)return!1;var o=Re(n,"MM.dd.yyyy");return r.has(o)?[r.get(o).className]:void 0})),ke(e,"isInRange",(function(){var t=e.props,n=t.day,r=t.startDate,o=t.endDate;return!(!r||!o)&&qe(n,r,o)})),ke(e,"isInSelectingRange",(function(){var t,n=e.props,r=n.day,o=n.selectsStart,i=n.selectsEnd,a=n.selectsRange,s=n.selectsDisabledDaysInRange,l=n.startDate,c=n.endDate,u=null!==(t=e.props.selectingDate)&&void 0!==t?t:e.props.preSelection;return!(!(o||i||a)||!u||!s&&e.isDisabled())&&(o&&c&&(ne.isBefore(u,c)||Qe(u,c))?qe(r,u,c):(i&&l&&(te.isAfter(u,l)||Qe(u,l))||!(!a||!l||c||!te.isAfter(u,l)&&!Qe(u,l)))&&qe(r,l,u))})),ke(e,"isSelectingRangeStart",(function(){var t;if(!e.isInSelectingRange())return!1;var n=e.props,r=n.day,o=n.startDate,i=n.selectsStart,a=null!==(t=e.props.selectingDate)&&void 0!==t?t:e.props.preSelection;return Ge(r,i?a:o)})),ke(e,"isSelectingRangeEnd",(function(){var t;if(!e.isInSelectingRange())return!1;var n=e.props,r=n.day,o=n.endDate,i=n.selectsEnd,a=n.selectsRange,s=null!==(t=e.props.selectingDate)&&void 0!==t?t:e.props.preSelection;return Ge(r,i||a?s:o)})),ke(e,"isRangeStart",(function(){var t=e.props,n=t.day,r=t.startDate,o=t.endDate;return!(!r||!o)&&Ge(r,n)})),ke(e,"isRangeEnd",(function(){var t=e.props,n=t.day,r=t.startDate,o=t.endDate;return!(!r||!o)&&Ge(o,n)})),ke(e,"isWeekend",(function(){var t=E.getDay(e.props.day);return 0===t||6===t})),ke(e,"isAfterMonth",(function(){return void 0!==e.props.month&&(e.props.month+1)%12===k.getMonth(e.props.day)})),ke(e,"isBeforeMonth",(function(){return void 0!==e.props.month&&(k.getMonth(e.props.day)+1)%12===e.props.month})),ke(e,"isCurrentDay",(function(){return e.isSameDay(Ie())})),ke(e,"isSelected",(function(){var t;return e.props.selectsMultiple?null===(t=e.props.selectedDates)||void 0===t?void 0:t.some((function(t){return e.isSameDayOrWeek(t)})):e.isSameDayOrWeek(e.props.selected)})),ke(e,"getClassNames",(function(t){var n,o=e.props.dayClassName?e.props.dayClassName(t):void 0;return r.clsx("react-datepicker__day",o,"react-datepicker__day--"+Re(e.props.day,"ddd",n),{"react-datepicker__day--disabled":e.isDisabled(),"react-datepicker__day--excluded":e.isExcluded(),"react-datepicker__day--selected":e.isSelected(),"react-datepicker__day--keyboard-selected":e.isKeyboardSelected(),"react-datepicker__day--range-start":e.isRangeStart(),"react-datepicker__day--range-end":e.isRangeEnd(),"react-datepicker__day--in-range":e.isInRange(),"react-datepicker__day--in-selecting-range":e.isInSelectingRange(),"react-datepicker__day--selecting-range-start":e.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":e.isSelectingRangeEnd(),"react-datepicker__day--today":e.isCurrentDay(),"react-datepicker__day--weekend":e.isWeekend(),"react-datepicker__day--outside-month":e.isAfterMonth()||e.isBeforeMonth()},e.getHighLightedClass("react-datepicker__day--highlighted"),e.getHolidaysClass())})),ke(e,"getAriaLabel",(function(){var t=e.props,n=t.day,r=t.ariaLabelPrefixWhenEnabled,o=void 0===r?"Choose":r,i=t.ariaLabelPrefixWhenDisabled,a=void 0===i?"Not available":i,s=e.isDisabled()||e.isExcluded()?a:o;return"".concat(s," ").concat(Re(n,"PPPP",e.props.locale))})),ke(e,"getTitle",(function(){var t=e.props,n=t.day,r=t.holidays,o=void 0===r?new Map:r,i=t.excludeDates,a=Re(n,"MM.dd.yyyy"),s=[];return o.has(a)&&s.push.apply(s,Oe(o.get(a).holidayNames)),e.isExcluded()&&s.push(null==i?void 0:i.filter((function(e){return Ge(e.date?e.date:e,n)})).map((function(e){return e.message}))),s.join(", ")})),ke(e,"getTabIndex",(function(t,n){var r=t||e.props.selected,o=n||e.props.preSelection;return(!e.props.showWeekPicker||!e.props.showWeekNumber&&e.isStartOfWeek())&&(e.isKeyboardSelected()||e.isSameDay(r)&&Ge(o,r))?0:-1})),ke(e,"handleFocusDay",(function(){var t,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=!1;0===e.getTabIndex()&&!n.isInputFocused&&e.isSameDay(e.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(r=!0),e.props.inline&&!e.props.shouldFocusDayInline&&(r=!1),e.props.containerRef&&e.props.containerRef.current&&e.props.containerRef.current.contains(document.activeElement)&&document.activeElement.classList.contains("react-datepicker__day")&&(r=!0),e.props.monthShowsDuplicateDaysEnd&&e.isAfterMonth()&&(r=!1),e.props.monthShowsDuplicateDaysStart&&e.isBeforeMonth()&&(r=!1)),r&&(null===(t=e.dayEl.current)||void 0===t||t.focus({preventScroll:!0}))})),ke(e,"renderDayContents",(function(){return e.props.monthShowsDuplicateDaysEnd&&e.isAfterMonth()||e.props.monthShowsDuplicateDaysStart&&e.isBeforeMonth()?null:e.props.renderDayContents?e.props.renderDayContents(w.getDate(e.props.day),e.props.day):w.getDate(e.props.day)})),ke(e,"render",(function(){return fe.default.createElement("div",{ref:e.dayEl,className:e.getClassNames(e.props.day),onKeyDown:e.handleOnKeyDown,onClick:e.handleClick,onMouseEnter:e.props.usePointerEvent?void 0:e.handleMouseEnter,onPointerEnter:e.props.usePointerEvent?e.handleMouseEnter:void 0,tabIndex:e.getTabIndex(),"aria-label":e.getAriaLabel(),role:"option",title:e.getTitle(),"aria-disabled":e.isDisabled(),"aria-current":e.isCurrentDay()?"date":void 0,"aria-selected":e.isSelected()||e.isInRange()},e.renderDayContents(),""!==e.getTitle()&&fe.default.createElement("span",{className:"overlay"},e.getTitle()))})),e}return Se(t,e),xe(t,[{key:"componentDidMount",value:function(){this.handleFocusDay()}},{key:"componentDidUpdate",value:function(e){this.handleFocusDay(e)}}])}(fe.default.Component),jt=function(e){function t(){var e;Ee(this,t);for(var n=arguments.length,r=new Array(n),o=0;o<n;o++)r[o]=arguments[o];return ke(e=ge(this,t,[].concat(r)),"weekNumberEl",fe.default.createRef()),ke(e,"handleClick",(function(t){e.props.onClick&&e.props.onClick(t)})),ke(e,"handleOnKeyDown",(function(t){" "===t.key&&(t.preventDefault(),t.key="Enter"),e.props.handleOnKeyDown(t)})),ke(e,"isKeyboardSelected",(function(){return!e.props.disabledKeyboardNavigation&&!Ge(e.props.date,e.props.selected)&&Ge(e.props.date,e.props.preSelection)})),ke(e,"getTabIndex",(function(){return e.props.showWeekPicker&&e.props.showWeekNumber&&(e.isKeyboardSelected()||Ge(e.props.date,e.props.selected)&&Ge(e.props.preSelection,e.props.selected))?0:-1})),ke(e,"handleFocusWeekNumber",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=!1;0===e.getTabIndex()&&!t.isInputFocused&&Ge(e.props.date,e.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(n=!0),e.props.inline&&!e.props.shouldFocusDayInline&&(n=!1),e.props.containerRef&&e.props.containerRef.current&&e.props.containerRef.current.contains(document.activeElement)&&document.activeElement&&document.activeElement.classList.contains("react-datepicker__week-number")&&(n=!0)),n&&e.weekNumberEl.current&&e.weekNumberEl.current.focus({preventScroll:!0})})),e}return Se(t,e),xe(t,[{key:"componentDidMount",value:function(){this.handleFocusWeekNumber()}},{key:"componentDidUpdate",value:function(e){this.handleFocusWeekNumber(e)}},{key:"render",value:function(){var e=this.props,t=e.weekNumber,n=e.ariaLabelPrefix,o=void 0===n?"week ":n,i=e.onClick,a={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!i,"react-datepicker__week-number--selected":!!i&&Ge(this.props.date,this.props.selected),"react-datepicker__week-number--keyboard-selected":this.isKeyboardSelected()};return fe.default.createElement("div",{ref:this.weekNumberEl,className:r.clsx(a),"aria-label":"".concat(o," ").concat(this.props.weekNumber),onClick:this.handleClick,onKeyDown:this.handleOnKeyDown,tabIndex:this.getTabIndex()},t)}}],[{key:"defaultProps",get:function(){return{ariaLabelPrefix:"week "}}}])}(fe.default.Component),Yt=function(e){function t(){var e;Ee(this,t);for(var n=arguments.length,r=new Array(n),o=0;o<n;o++)r[o]=arguments[o];return ke(e=ge(this,t,[].concat(r)),"handleDayClick",(function(t,n){e.props.onDayClick&&e.props.onDayClick(t,n)})),ke(e,"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),ke(e,"handleWeekClick",(function(t,n,r){"function"==typeof e.props.onWeekSelect&&e.props.onWeekSelect(t,n,r),e.props.showWeekPicker&&e.handleDayClick(t,r),e.props.shouldCloseOnSelect&&e.props.setOpen(!1)})),ke(e,"formatWeekNumber",(function(t){return e.props.formatWeekNumber?e.props.formatWeekNumber(t):function(e,t){var n=t&&Ze(t)||Ke()&&Ze(Ke());return x.getISOWeek(e,n?{locale:n}:null)}(t)})),ke(e,"renderDays",(function(){var t=e.startOfWeek(),n=[],r=e.formatWeekNumber(t);if(e.props.showWeekNumber){var o=e.props.onWeekSelect||e.props.showWeekPicker?e.handleWeekClick.bind(e,t,r):void 0;n.push(fe.default.createElement(jt,{key:"W",weekNumber:r,date:t,onClick:o,selected:e.props.selected,preSelection:e.props.preSelection,ariaLabelPrefix:e.props.ariaLabelPrefix,showWeekPicker:e.props.showWeekPicker,showWeekNumber:e.props.showWeekNumber,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef}))}return n.concat([0,1,2,3,4,5,6].map((function(n){var r=c.addDays(t,n);return fe.default.createElement(Ft,{ariaLabelPrefixWhenEnabled:e.props.chooseDayAriaLabelPrefix,ariaLabelPrefixWhenDisabled:e.props.disabledDayAriaLabelPrefix,key:r.valueOf(),day:r,month:e.props.month,onClick:e.handleDayClick.bind(e,r),usePointerEvent:e.props.usePointerEvent,onMouseEnter:e.handleDayMouseEnter.bind(e,r),minDate:e.props.minDate,maxDate:e.props.maxDate,calendarStartDay:e.props.calendarStartDay,excludeDates:e.props.excludeDates,excludeDateIntervals:e.props.excludeDateIntervals,includeDates:e.props.includeDates,includeDateIntervals:e.props.includeDateIntervals,highlightDates:e.props.highlightDates,holidays:e.props.holidays,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,selectsRange:e.props.selectsRange,showWeekPicker:e.props.showWeekPicker,showWeekNumber:e.props.showWeekNumber,selectsDisabledDaysInRange:e.props.selectsDisabledDaysInRange,selectsMultiple:e.props.selectsMultiple,selectedDates:e.props.selectedDates,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,renderDayContents:e.props.renderDayContents,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef,inline:e.props.inline,shouldFocusDayInline:e.props.shouldFocusDayInline,monthShowsDuplicateDaysEnd:e.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:e.props.monthShowsDuplicateDaysStart,locale:e.props.locale})})))})),ke(e,"startOfWeek",(function(){return je(e.props.day,e.props.locale,e.props.calendarStartDay)})),ke(e,"isKeyboardSelected",(function(){return!e.props.disabledKeyboardNavigation&&!Ge(e.startOfWeek(),e.props.selected)&&Ge(e.startOfWeek(),e.props.preSelection)})),e}return Se(t,e),xe(t,[{key:"render",value:function(){var e={"react-datepicker__week":!0,"react-datepicker__week--selected":Ge(this.startOfWeek(),this.props.selected),"react-datepicker__week--keyboard-selected":this.isKeyboardSelected()};return fe.default.createElement("div",{className:r.clsx(e)},this.renderDays())}}],[{key:"defaultProps",get:function(){return{shouldCloseOnSelect:!0}}}])}(fe.default.Component),$t="two_columns",Ht="three_columns",Ut="four_columns",zt=ke(ke(ke({},$t,{grid:[[0,1],[2,3],[4,5],[6,7],[8,9],[10,11]],verticalNavigationOffset:2}),Ht,{grid:[[0,1,2],[3,4,5],[6,7,8],[9,10,11]],verticalNavigationOffset:3}),Ut,{grid:[[0,1,2,3],[4,5,6,7],[8,9,10,11]],verticalNavigationOffset:4});function Wt(e,t){return e?Ut:t?$t:Ht}var Vt=function(e){function t(){var e;Ee(this,t);for(var n=arguments.length,o=new Array(n),i=0;i<n;i++)o[i]=arguments[i];return ke(e=ge(this,t,[].concat(o)),"MONTH_REFS",Oe(Array(12)).map((function(){return fe.default.createRef()}))),ke(e,"QUARTER_REFS",Oe(Array(4)).map((function(){return fe.default.createRef()}))),ke(e,"isDisabled",(function(t){return et(t,e.props)})),ke(e,"isExcluded",(function(t){return tt(t,e.props)})),ke(e,"handleDayClick",(function(t,n){e.props.onDayClick&&e.props.onDayClick(t,n,e.props.orderInDisplay)})),ke(e,"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),ke(e,"handleMouseLeave",(function(){e.props.onMouseLeave&&e.props.onMouseLeave()})),ke(e,"isRangeStartMonth",(function(t){var n=e.props,r=n.day,o=n.startDate,i=n.endDate;return!(!o||!i)&&We(L.setMonth(r,t),o)})),ke(e,"isRangeStartQuarter",(function(t){var n=e.props,r=n.day,o=n.startDate,i=n.endDate;return!(!o||!i)&&Ve(P.setQuarter(r,t),o)})),ke(e,"isRangeEndMonth",(function(t){var n=e.props,r=n.day,o=n.startDate,i=n.endDate;return!(!o||!i)&&We(L.setMonth(r,t),i)})),ke(e,"isRangeEndQuarter",(function(t){var n=e.props,r=n.day,o=n.startDate,i=n.endDate;return!(!o||!i)&&Ve(P.setQuarter(r,t),i)})),ke(e,"isInSelectingRangeMonth",(function(t){var n,r=e.props,o=r.day,i=r.selectsStart,a=r.selectsEnd,s=r.selectsRange,l=r.startDate,c=r.endDate,u=null!==(n=e.props.selectingDate)&&void 0!==n?n:e.props.preSelection;return!(!(i||a||s)||!u)&&(i&&c?rt(u,c,t,o):(a&&l||!(!s||!l||c))&&rt(l,u,t,o))})),ke(e,"isSelectingMonthRangeStart",(function(t){var n;if(!e.isInSelectingRangeMonth(t))return!1;var r=e.props,o=r.day,i=r.startDate,a=r.selectsStart,s=L.setMonth(o,t),l=null!==(n=e.props.selectingDate)&&void 0!==n?n:e.props.preSelection;return We(s,a?l:i)})),ke(e,"isSelectingMonthRangeEnd",(function(t){var n;if(!e.isInSelectingRangeMonth(t))return!1;var r=e.props,o=r.day,i=r.endDate,a=r.selectsEnd,s=r.selectsRange,l=L.setMonth(o,t),c=null!==(n=e.props.selectingDate)&&void 0!==n?n:e.props.preSelection;return We(l,a||s?c:i)})),ke(e,"isInSelectingRangeQuarter",(function(t){var n,r=e.props,o=r.day,i=r.selectsStart,a=r.selectsEnd,s=r.selectsRange,l=r.startDate,c=r.endDate,u=null!==(n=e.props.selectingDate)&&void 0!==n?n:e.props.preSelection;return!(!(i||a||s)||!u)&&(i&&c?st(u,c,t,o):(a&&l||!(!s||!l||c))&&st(l,u,t,o))})),ke(e,"isWeekInMonth",(function(t){var n=e.props.day,r=c.addDays(t,6);return We(t,n)||We(r,n)})),ke(e,"isCurrentMonth",(function(e,t){return S.getYear(e)===S.getYear(Ie())&&t===k.getMonth(Ie())})),ke(e,"isCurrentQuarter",(function(e,t){return S.getYear(e)===S.getYear(Ie())&&t===C.getQuarter(Ie())})),ke(e,"isSelectedMonth",(function(e,t,n){return k.getMonth(n)===t&&S.getYear(e)===S.getYear(n)})),ke(e,"isSelectedQuarter",(function(e,t,n){return C.getQuarter(e)===t&&S.getYear(e)===S.getYear(n)})),ke(e,"renderWeeks",(function(){for(var t=[],n=e.props.fixedHeight,r=0,o=!1,i=je(Ye(e.props.day),e.props.locale,e.props.calendarStartDay),a=e.props.showWeekPicker?je(e.props.selected,e.props.locale,e.props.calendarStartDay):e.props.selected,s=e.props.showWeekPicker?je(e.props.preSelection,e.props.locale,e.props.calendarStartDay):e.props.preSelection;t.push(fe.default.createElement(Yt,{ariaLabelPrefix:e.props.weekAriaLabelPrefix,chooseDayAriaLabelPrefix:e.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:e.props.disabledDayAriaLabelPrefix,key:r,day:i,month:k.getMonth(e.props.day),onDayClick:e.handleDayClick,usePointerEvent:e.props.usePointerEvent,onDayMouseEnter:e.handleDayMouseEnter,onWeekSelect:e.props.onWeekSelect,formatWeekNumber:e.props.formatWeekNumber,locale:e.props.locale,minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,excludeDateIntervals:e.props.excludeDateIntervals,includeDates:e.props.includeDates,includeDateIntervals:e.props.includeDateIntervals,inline:e.props.inline,shouldFocusDayInline:e.props.shouldFocusDayInline,highlightDates:e.props.highlightDates,holidays:e.props.holidays,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:s,selected:a,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,selectsRange:e.props.selectsRange,selectsDisabledDaysInRange:e.props.selectsDisabledDaysInRange,selectsMultiple:e.props.selectsMultiple,selectedDates:e.props.selectedDates,showWeekNumber:e.props.showWeekNumbers,showWeekPicker:e.props.showWeekPicker,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,setOpen:e.props.setOpen,shouldCloseOnSelect:e.props.shouldCloseOnSelect,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,renderDayContents:e.props.renderDayContents,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef,calendarStartDay:e.props.calendarStartDay,monthShowsDuplicateDaysEnd:e.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:e.props.monthShowsDuplicateDaysStart})),!o;){r++,i=u.addWeeks(i,1);var l=n&&r>=6,c=!n&&!e.isWeekInMonth(i);if(l||c){if(!e.props.peekNextMonth)break;o=!0}}return t})),ke(e,"onMonthClick",(function(t,n){var r=L.setMonth(e.props.day,n);nt(r,e.props)||e.handleDayClick(Ye(r),t)})),ke(e,"onMonthMouseEnter",(function(t){var n=L.setMonth(e.props.day,t);nt(n,e.props)||e.handleDayMouseEnter(Ye(n))})),ke(e,"handleMonthNavigation",(function(t,n){e.isDisabled(n)||e.isExcluded(n)||(e.props.setPreSelection(n),e.MONTH_REFS[t].current&&e.MONTH_REFS[t].current.focus())})),ke(e,"onMonthKeyDown",(function(t,n){var r=e.props,o=r.selected,i=r.preSelection,a=r.disabledKeyboardNavigation,s=r.showTwoColumnMonthYearPicker,l=r.showFourColumnMonthYearPicker,c=r.setPreSelection,u=r.handleOnMonthKeyDown,p=t.key;if("Tab"!==p&&t.preventDefault(),!a){var f=Wt(l,s),h=zt[f].verticalNavigationOffset,m=zt[f].grid;switch(p){case"Enter":e.onMonthClick(t,n),c(o);break;case"ArrowRight":e.handleMonthNavigation(11===n?0:n+1,d.addMonths(i,1));break;case"ArrowLeft":e.handleMonthNavigation(0===n?11:n-1,g.subMonths(i,1));break;case"ArrowUp":e.handleMonthNavigation(m[0].includes(n)?n+12-h:n-h,g.subMonths(i,h));break;case"ArrowDown":e.handleMonthNavigation(m[m.length-1].includes(n)?n-12+h:n+h,d.addMonths(i,h))}}u&&u(t)})),ke(e,"onQuarterClick",(function(t,n){var r=P.setQuarter(e.props.day,n);ot(r,e.props)||e.handleDayClick(He(r),t)})),ke(e,"onQuarterMouseEnter",(function(t){var n=P.setQuarter(e.props.day,t);ot(n,e.props)||e.handleDayMouseEnter(He(n))})),ke(e,"handleQuarterNavigation",(function(t,n){e.isDisabled(n)||e.isExcluded(n)||(e.props.setPreSelection(n),e.QUARTER_REFS[t-1].current&&e.QUARTER_REFS[t-1].current.focus())})),ke(e,"onQuarterKeyDown",(function(t,n){var r=t.key;if(!e.props.disabledKeyboardNavigation)switch(r){case"Enter":e.onQuarterClick(t,n),e.props.setPreSelection(e.props.selected);break;case"ArrowRight":e.handleQuarterNavigation(4===n?1:n+1,p.addQuarters(e.props.preSelection,1));break;case"ArrowLeft":e.handleQuarterNavigation(1===n?4:n-1,v.subQuarters(e.props.preSelection,1))}})),ke(e,"isMonthDisabled",(function(t){var n=e.props,r=n.day,o=n.minDate,i=n.maxDate,a=n.excludeDates,s=n.includeDates,l=L.setMonth(r,t);return(o||i||a||s)&&nt(l,e.props)})),ke(e,"getMonthClassNames",(function(t){var n=e.props,o=n.day,i=n.startDate,a=n.endDate,s=n.selected,l=n.preSelection,c=n.monthClassName,u=c?c(L.setMonth(o,t)):void 0;return r.clsx("react-datepicker__month-text","react-datepicker__month-".concat(t),u,{"react-datepicker__month-text--disabled":e.isMonthDisabled(t),"react-datepicker__month-text--selected":e.isSelectedMonth(o,t,s),"react-datepicker__month-text--keyboard-selected":!e.props.disabledKeyboardNavigation&&e.isSelectedMonth(o,t,l),"react-datepicker__month-text--in-selecting-range":e.isInSelectingRangeMonth(t),"react-datepicker__month-text--in-range":rt(i,a,t,o),"react-datepicker__month-text--range-start":e.isRangeStartMonth(t),"react-datepicker__month-text--range-end":e.isRangeEndMonth(t),"react-datepicker__month-text--selecting-range-start":e.isSelectingMonthRangeStart(t),"react-datepicker__month-text--selecting-range-end":e.isSelectingMonthRangeEnd(t),"react-datepicker__month-text--today":e.isCurrentMonth(o,t)})})),ke(e,"getTabIndex",(function(t){var n=k.getMonth(e.props.preSelection);return e.props.disabledKeyboardNavigation||t!==n?"-1":"0"})),ke(e,"getQuarterTabIndex",(function(t){var n=C.getQuarter(e.props.preSelection);return e.props.disabledKeyboardNavigation||t!==n?"-1":"0"})),ke(e,"getAriaLabel",(function(t){var n=e.props,r=n.chooseDayAriaLabelPrefix,o=void 0===r?"Choose":r,i=n.disabledDayAriaLabelPrefix,a=void 0===i?"Not available":i,s=n.day,l=n.locale,c=L.setMonth(s,t),u=e.isDisabled(c)||e.isExcluded(c)?a:o;return"".concat(u," ").concat(Re(c,"MMMM yyyy",l))})),ke(e,"getQuarterClassNames",(function(t){var n=e.props,o=n.day,i=n.startDate,a=n.endDate,s=n.selected,l=n.minDate,c=n.maxDate,u=n.preSelection,d=n.disabledKeyboardNavigation;return r.clsx("react-datepicker__quarter-text","react-datepicker__quarter-".concat(t),{"react-datepicker__quarter-text--disabled":(l||c)&&ot(P.setQuarter(o,t),e.props),"react-datepicker__quarter-text--selected":e.isSelectedQuarter(o,t,s),"react-datepicker__quarter-text--keyboard-selected":!d&&e.isSelectedQuarter(o,t,u),"react-datepicker__quarter-text--in-selecting-range":e.isInSelectingRangeQuarter(t),"react-datepicker__quarter-text--in-range":st(i,a,t,o),"react-datepicker__quarter-text--range-start":e.isRangeStartQuarter(t),"react-datepicker__quarter-text--range-end":e.isRangeEndQuarter(t)})})),ke(e,"getMonthContent",(function(t){var n=e.props,r=n.showFullMonthYearPicker,o=n.renderMonthContent,i=n.locale,a=n.day,s=Xe(t,i),l=Je(t,i);return o?o(t,s,l,a):r?l:s})),ke(e,"getQuarterContent",(function(t){var n=e.props,r=n.renderQuarterContent,o=function(e,t){return Re(P.setQuarter(Ie(),e),"QQQ",t)}(t,n.locale);return r?r(t,o):o})),ke(e,"renderMonths",(function(){var t=e.props,n=t.showTwoColumnMonthYearPicker,r=t.showFourColumnMonthYearPicker,o=t.day,i=t.selected;return zt[Wt(r,n)].grid.map((function(t,n){return fe.default.createElement("div",{className:"react-datepicker__month-wrapper",key:n},t.map((function(t,n){return fe.default.createElement("div",{ref:e.MONTH_REFS[t],key:n,onClick:function(n){e.onMonthClick(n,t)},onKeyDown:function(n){Ct(n)&&(n.preventDefault(),n.key="Enter"),e.onMonthKeyDown(n,t)},onMouseEnter:e.props.usePointerEvent?void 0:function(){return e.onMonthMouseEnter(t)},onPointerEnter:e.props.usePointerEvent?function(){return e.onMonthMouseEnter(t)}:void 0,tabIndex:e.getTabIndex(t),className:e.getMonthClassNames(t),"aria-disabled":e.isMonthDisabled(t),role:"option","aria-label":e.getAriaLabel(t),"aria-current":e.isCurrentMonth(o,t)?"date":void 0,"aria-selected":e.isSelectedMonth(o,t,i)},e.getMonthContent(t))})))}))})),ke(e,"renderQuarters",(function(){var t=e.props,n=t.day,r=t.selected;return fe.default.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map((function(t,o){return fe.default.createElement("div",{key:o,ref:e.QUARTER_REFS[o],role:"option",onClick:function(n){e.onQuarterClick(n,t)},onKeyDown:function(n){e.onQuarterKeyDown(n,t)},onMouseEnter:e.props.usePointerEvent?void 0:function(){return e.onQuarterMouseEnter(t)},onPointerEnter:e.props.usePointerEvent?function(){return e.onQuarterMouseEnter(t)}:void 0,className:e.getQuarterClassNames(t),"aria-selected":e.isSelectedQuarter(n,t,r),tabIndex:e.getQuarterTabIndex(t),"aria-current":e.isCurrentQuarter(n,t)?"date":void 0},e.getQuarterContent(t))})))})),ke(e,"getClassNames",(function(){var t=e.props,n=t.selectingDate,o=t.selectsStart,i=t.selectsEnd,a=t.showMonthYearPicker,s=t.showQuarterYearPicker,l=t.showWeekPicker;return r.clsx("react-datepicker__month",{"react-datepicker__month--selecting-range":n&&(o||i)},{"react-datepicker__monthPicker":a},{"react-datepicker__quarterPicker":s},{"react-datepicker__weekPicker":l})})),e}return Se(t,e),xe(t,[{key:"render",value:function(){var e=this.props,t=e.showMonthYearPicker,n=e.showQuarterYearPicker,r=e.day,o=e.ariaLabelPrefix,i=void 0===o?"Month ":o,a=i?i.trim()+" ":"";return fe.default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.props.usePointerEvent?void 0:this.handleMouseLeave,onPointerLeave:this.props.usePointerEvent?this.handleMouseLeave:void 0,"aria-label":"".concat(a).concat(Re(r,"MMMM, yyyy",this.props.locale)),role:"listbox"},t?this.renderMonths():n?this.renderQuarters():this.renderWeeks())}}])}(fe.default.Component),Gt=function(e){function t(){var e;Ee(this,t);for(var n=arguments.length,r=new Array(n),o=0;o<n;o++)r[o]=arguments[o];return ke(e=ge(this,t,[].concat(r)),"state",{height:null}),ke(e,"scrollToTheSelectedTime",(function(){requestAnimationFrame((function(){e.list&&(e.list.scrollTop=e.centerLi&&t.calcCenterPosition(e.props.monthRef?e.props.monthRef.clientHeight-e.header.clientHeight:e.list.clientHeight,e.centerLi))}))})),ke(e,"handleClick",(function(t){(e.props.minTime||e.props.maxTime)&&dt(t,e.props)||(e.props.excludeTimes||e.props.includeTimes||e.props.filterTime)&&ut(t,e.props)||e.props.onChange(t)})),ke(e,"isSelectedTime",(function(t){return e.props.selected&&(n=t,wt(e.props.selected).getTime()===wt(n).getTime());var n})),ke(e,"isDisabledTime",(function(t){return(e.props.minTime||e.props.maxTime)&&dt(t,e.props)||(e.props.excludeTimes||e.props.includeTimes||e.props.filterTime)&&ut(t,e.props)})),ke(e,"liClasses",(function(t){var n=["react-datepicker__time-list-item",e.props.timeClassName?e.props.timeClassName(t):void 0];return e.isSelectedTime(t)&&n.push("react-datepicker__time-list-item--selected"),e.isDisabledTime(t)&&n.push("react-datepicker__time-list-item--disabled"),e.props.injectTimes&&(3600*A.getHours(t)+60*_.getMinutes(t)+se.getSeconds(t))%(60*e.props.intervals)!=0&&n.push("react-datepicker__time-list-item--injected"),n.join(" ")})),ke(e,"handleOnKeyDown",(function(t,n){" "===t.key&&(t.preventDefault(),t.key="Enter"),"ArrowUp"!==t.key&&"ArrowLeft"!==t.key||!t.target.previousSibling||(t.preventDefault(),t.target.previousSibling.focus()),"ArrowDown"!==t.key&&"ArrowRight"!==t.key||!t.target.nextSibling||(t.preventDefault(),t.target.nextSibling.focus()),"Enter"===t.key&&e.handleClick(n),e.props.handleOnKeyDown(t)})),ke(e,"renderTimes",(function(){for(var t,n=[],r=e.props.format?e.props.format:"p",o=e.props.intervals,i=e.props.selected||e.props.openToDate||Ie(),a=(t=i,$.startOfDay(t)),l=e.props.injectTimes&&e.props.injectTimes.sort((function(e,t){return e-t})),c=60*function(e){var t=new Date(e.getFullYear(),e.getMonth(),e.getDate()),n=new Date(e.getFullYear(),e.getMonth(),e.getDate(),24);return Math.round((+n-+t)/36e5)}(i),u=c/o,d=0;d<u;d++){var p=s.addMinutes(a,d*o);if(n.push(p),l){var f=_t(a,p,d,o,l);n=n.concat(f)}}var h=n.reduce((function(e,t){return t.getTime()<=i.getTime()?t:e}),n[0]);return n.map((function(t,n){return fe.default.createElement("li",{key:n,onClick:e.handleClick.bind(e,t),className:e.liClasses(t),ref:function(n){t===h&&(e.centerLi=n)},onKeyDown:function(n){e.handleOnKeyDown(n,t)},tabIndex:t===h?0:-1,role:"option","aria-selected":e.isSelectedTime(t)?"true":void 0,"aria-disabled":e.isDisabledTime(t)?"true":void 0},Re(t,r,e.props.locale))}))})),e}return Se(t,e),xe(t,[{key:"componentDidMount",value:function(){this.scrollToTheSelectedTime(),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight})}},{key:"render",value:function(){var e=this,t=this.state.height;return fe.default.createElement("div",{className:"react-datepicker__time-container ".concat(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},fe.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly?"react-datepicker__header--time--only":""),ref:function(t){e.header=t}},fe.default.createElement("div",{className:"react-datepicker-time__header"},this.props.timeCaption)),fe.default.createElement("div",{className:"react-datepicker__time"},fe.default.createElement("div",{className:"react-datepicker__time-box"},fe.default.createElement("ul",{className:"react-datepicker__time-list",ref:function(t){e.list=t},style:t?{height:t}:{},role:"listbox","aria-label":this.props.timeCaption},this.renderTimes()))))}}],[{key:"defaultProps",get:function(){return{intervals:30,onTimeChange:function(){},todayButton:null,timeCaption:"Time"}}}])}(fe.default.Component);ke(Gt,"calcCenterPosition",(function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)}));var Qt=function(e){function t(e){var n;return Ee(this,t),ke(n=ge(this,t,[e]),"YEAR_REFS",Oe(Array(n.props.yearItemNumber)).map((function(){return fe.default.createRef()}))),ke(n,"isDisabled",(function(e){return et(e,n.props)})),ke(n,"isExcluded",(function(e){return tt(e,n.props)})),ke(n,"selectingDate",(function(){var e;return null!==(e=n.props.selectingDate)&&void 0!==e?e:n.props.preSelection})),ke(n,"updateFocusOnPaginate",(function(e){var t=function(){this.YEAR_REFS[e].current.focus()}.bind(n);window.requestAnimationFrame(t)})),ke(n,"handleYearClick",(function(e,t){n.props.onDayClick&&n.props.onDayClick(e,t)})),ke(n,"handleYearNavigation",(function(e,t){var r=n.props,o=r.date,i=r.yearItemNumber,a=Et(o,i).startPeriod;n.isDisabled(t)||n.isExcluded(t)||(n.props.setPreSelection(t),e-a<0?n.updateFocusOnPaginate(i-(a-e)):e-a>=i?n.updateFocusOnPaginate(Math.abs(i-(e-a))):n.YEAR_REFS[e-a].current.focus())})),ke(n,"isSameDay",(function(e,t){return Ge(e,t)})),ke(n,"isCurrentYear",(function(e){return e===S.getYear(Ie())})),ke(n,"isRangeStart",(function(e){return n.props.startDate&&n.props.endDate&&ze(I.setYear(Ie(),e),n.props.startDate)})),ke(n,"isRangeEnd",(function(e){return n.props.startDate&&n.props.endDate&&ze(I.setYear(Ie(),e),n.props.endDate)})),ke(n,"isInRange",(function(e){return it(e,n.props.startDate,n.props.endDate)})),ke(n,"isInSelectingRange",(function(e){var t=n.props,r=t.selectsStart,o=t.selectsEnd,i=t.selectsRange,a=t.startDate,s=t.endDate;return!(!(r||o||i)||!n.selectingDate())&&(r&&s?it(e,n.selectingDate(),s):(o&&a||!(!i||!a||s))&&it(e,a,n.selectingDate()))})),ke(n,"isSelectingRangeStart",(function(e){if(!n.isInSelectingRange(e))return!1;var t=n.props,r=t.startDate,o=t.selectsStart;return ze(I.setYear(Ie(),e),o?n.selectingDate():r)})),ke(n,"isSelectingRangeEnd",(function(e){if(!n.isInSelectingRange(e))return!1;var t=n.props,r=t.endDate,o=t.selectsEnd,i=t.selectsRange;return ze(I.setYear(Ie(),e),o||i?n.selectingDate():r)})),ke(n,"isKeyboardSelected",(function(e){var t=$e(I.setYear(n.props.date,e));return!n.props.disabledKeyboardNavigation&&!n.props.inline&&!Ge(t,$e(n.props.selected))&&Ge(t,$e(n.props.preSelection))})),ke(n,"onYearClick",(function(e,t){var r=n.props.date;n.handleYearClick($e(I.setYear(r,t)),e)})),ke(n,"onYearKeyDown",(function(e,t){var r=e.key,o=n.props,i=o.date,a=o.yearItemNumber,s=o.handleOnKeyDown;if("Tab"!==r&&e.preventDefault(),!n.props.disabledKeyboardNavigation)switch(r){case"Enter":n.onYearClick(e,t),n.props.setPreSelection(n.props.selected);break;case"ArrowRight":n.handleYearNavigation(t+1,f.addYears(n.props.preSelection,1));break;case"ArrowLeft":n.handleYearNavigation(t-1,y.subYears(n.props.preSelection,1));break;case"ArrowUp":var l=Et(i,a).startPeriod,c=3,u=t-c;if(u<l){var d=a%c;t>=l&&t<l+d?c=d:c+=d,u=t-c}n.handleYearNavigation(u,y.subYears(n.props.preSelection,c));break;case"ArrowDown":var p=Et(i,a).endPeriod,h=3,m=t+h;if(m>p){var g=a%h;t<=p&&t>p-g?h=g:h+=g,m=t+h}n.handleYearNavigation(m,f.addYears(n.props.preSelection,h))}s&&s(e)})),ke(n,"getYearClassNames",(function(e){var t=n.props,o=t.date,i=t.minDate,a=t.maxDate,s=t.selected,l=t.excludeDates,c=t.includeDates,u=t.filterDate,d=t.yearClassName;return r.clsx("react-datepicker__year-text","react-datepicker__year-".concat(e),d?d(I.setYear(o,e)):void 0,{"react-datepicker__year-text--selected":e===S.getYear(s),"react-datepicker__year-text--disabled":(i||a||l||c||u)&&at(e,n.props),"react-datepicker__year-text--keyboard-selected":n.isKeyboardSelected(e),"react-datepicker__year-text--range-start":n.isRangeStart(e),"react-datepicker__year-text--range-end":n.isRangeEnd(e),"react-datepicker__year-text--in-range":n.isInRange(e),"react-datepicker__year-text--in-selecting-range":n.isInSelectingRange(e),"react-datepicker__year-text--selecting-range-start":n.isSelectingRangeStart(e),"react-datepicker__year-text--selecting-range-end":n.isSelectingRangeEnd(e),"react-datepicker__year-text--today":n.isCurrentYear(e)})})),ke(n,"getYearTabIndex",(function(e){return n.props.disabledKeyboardNavigation?"-1":e===S.getYear(n.props.preSelection)?"0":"-1"})),ke(n,"getYearContainerClassNames",(function(){var e=n.props,t=e.selectingDate,o=e.selectsStart,i=e.selectsEnd,a=e.selectsRange;return r.clsx("react-datepicker__year",{"react-datepicker__year--selecting-range":t&&(o||i||a)})})),ke(n,"getYearContent",(function(e){return n.props.renderYearContent?n.props.renderYearContent(e):e})),n}return Se(t,e),xe(t,[{key:"render",value:function(){for(var e=this,t=[],n=this.props,r=n.date,o=n.yearItemNumber,i=n.onYearMouseEnter,a=n.onYearMouseLeave,s=Et(r,o),l=s.startPeriod,c=s.endPeriod,u=function(n){t.push(fe.default.createElement("div",{ref:e.YEAR_REFS[n-l],onClick:function(t){e.onYearClick(t,n)},onKeyDown:function(t){Ct(t)&&(t.preventDefault(),t.key="Enter"),e.onYearKeyDown(t,n)},tabIndex:e.getYearTabIndex(n),className:e.getYearClassNames(n),onMouseEnter:e.props.usePointerEvent?void 0:function(e){return i(e,n)},onPointerEnter:e.props.usePointerEvent?function(e){return i(e,n)}:void 0,onMouseLeave:e.props.usePointerEvent?void 0:function(e){return a(e,n)},onPointerLeave:e.props.usePointerEvent?function(e){return a(e,n)}:void 0,key:n,"aria-current":e.isCurrentYear(n)?"date":void 0},e.getYearContent(n)))},d=l;d<=c;d++)u(d);return fe.default.createElement("div",{className:this.getYearContainerClassNames()},fe.default.createElement("div",{className:"react-datepicker__year-wrapper",onMouseLeave:this.props.usePointerEvent?void 0:this.props.clearSelectingDate,onPointerLeave:this.props.usePointerEvent?this.props.clearSelectingDate:void 0},t))}}])}(fe.default.Component),qt=function(e){function t(e){var n;return Ee(this,t),ke(n=ge(this,t,[e]),"onTimeChange",(function(e){n.setState({time:e});var t=n.props.date,r=t instanceof Date&&!isNaN(t)?t:new Date;r.setHours(e.split(":")[0]),r.setMinutes(e.split(":")[1]),n.props.onChange(r)})),ke(n,"renderTimeInput",(function(){var e=n.state.time,t=n.props,r=t.date,o=t.timeString,i=t.customTimeInput;return i?fe.default.cloneElement(i,{date:r,value:e,onChange:n.onTimeChange}):fe.default.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",required:!0,value:e,onChange:function(e){n.onTimeChange(e.target.value||o)}})})),n.state={time:n.props.timeString},n}return Se(t,e),xe(t,[{key:"render",value:function(){return fe.default.createElement("div",{className:"react-datepicker__input-time-container"},fe.default.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),fe.default.createElement("div",{className:"react-datepicker-time__input-container"},fe.default.createElement("div",{className:"react-datepicker-time__input"},this.renderTimeInput())))}}],[{key:"getDerivedStateFromProps",value:function(e,t){return e.timeString!==t.time?{time:e.timeString}:null}}])}(fe.default.Component);function Kt(e){var t=e.showTimeSelectOnly,n=void 0!==t&&t,r=e.showTime,o=void 0!==r&&r,i=e.className,a=e.children,s=n?"Choose Time":"Choose Date".concat(o?" and Time":"");return fe.default.createElement("div",{className:i,role:"dialog","aria-label":s,"aria-modal":"true"},a)}var Zt,Jt=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],Xt=function(e){function t(e){var n;return Ee(this,t),ke(n=ge(this,t,[e]),"handleClickOutside",(function(e){n.props.onClickOutside(e)})),ke(n,"setClickOutsideRef",(function(){return n.containerRef.current})),ke(n,"handleDropdownFocus",(function(e){(function(){var e=((arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}).className||"").split(/\s+/);return Jt.some((function(t){return e.indexOf(t)>=0}))})(e.target)&&n.props.onDropdownFocus()})),ke(n,"getDateInView",(function(){var e=n.props,t=e.preSelection,r=e.selected,o=e.openToDate,i=gt(n.props),a=vt(n.props),s=Ie();return o||r||t||(i&&ne.isBefore(s,i)?i:a&&te.isAfter(s,a)?a:s)})),ke(n,"increaseMonth",(function(){n.setState((function(e){var t=e.date;return{date:d.addMonths(t,1)}}),(function(){return n.handleMonthChange(n.state.date)}))})),ke(n,"decreaseMonth",(function(){n.setState((function(e){var t=e.date;return{date:g.subMonths(t,1)}}),(function(){return n.handleMonthChange(n.state.date)}))})),ke(n,"handleDayClick",(function(e,t,r){n.props.onSelect(e,t,r),n.props.setPreSelection&&n.props.setPreSelection(e)})),ke(n,"handleDayMouseEnter",(function(e){n.setState({selectingDate:e}),n.props.onDayMouseEnter&&n.props.onDayMouseEnter(e)})),ke(n,"handleMonthMouseLeave",(function(){n.setState({selectingDate:null}),n.props.onMonthMouseLeave&&n.props.onMonthMouseLeave()})),ke(n,"handleYearMouseEnter",(function(e,t){n.setState({selectingDate:I.setYear(Ie(),t)}),n.props.onYearMouseEnter&&n.props.onYearMouseEnter(e,t)})),ke(n,"handleYearMouseLeave",(function(e,t){n.props.onYearMouseLeave&&n.props.onYearMouseLeave(e,t)})),ke(n,"handleYearChange",(function(e){n.props.onYearChange&&(n.props.onYearChange(e),n.setState({isRenderAriaLiveMessage:!0})),n.props.adjustDateOnChange&&(n.props.onSelect&&n.props.onSelect(e),n.props.setOpen&&n.props.setOpen(!0)),n.props.setPreSelection&&n.props.setPreSelection(e)})),ke(n,"handleMonthChange",(function(e){n.handleCustomMonthChange(e),n.props.adjustDateOnChange&&(n.props.onSelect&&n.props.onSelect(e),n.props.setOpen&&n.props.setOpen(!0)),n.props.setPreSelection&&n.props.setPreSelection(e)})),ke(n,"handleCustomMonthChange",(function(e){n.props.onMonthChange&&(n.props.onMonthChange(e),n.setState({isRenderAriaLiveMessage:!0}))})),ke(n,"handleMonthYearChange",(function(e){n.handleYearChange(e),n.handleMonthChange(e)})),ke(n,"changeYear",(function(e){n.setState((function(t){var n=t.date;return{date:I.setYear(n,e)}}),(function(){return n.handleYearChange(n.state.date)}))})),ke(n,"changeMonth",(function(e){n.setState((function(t){var n=t.date;return{date:L.setMonth(n,e)}}),(function(){return n.handleMonthChange(n.state.date)}))})),ke(n,"changeMonthYear",(function(e){n.setState((function(t){var n=t.date;return{date:I.setYear(L.setMonth(n,k.getMonth(e)),S.getYear(e))}}),(function(){return n.handleMonthYearChange(n.state.date)}))})),ke(n,"header",(function(){var e=je(arguments.length>0&&void 0!==arguments[0]?arguments[0]:n.state.date,n.props.locale,n.props.calendarStartDay),t=[];return n.props.showWeekNumbers&&t.push(fe.default.createElement("div",{key:"W",className:"react-datepicker__day-name"},n.props.weekLabel||"#")),t.concat([0,1,2,3,4,5,6].map((function(t){var o=c.addDays(e,t),i=n.formatWeekday(o,n.props.locale),a=n.props.weekDayClassName?n.props.weekDayClassName(o):void 0;return fe.default.createElement("div",{key:t,"aria-label":Re(o,"EEEE",n.props.locale),className:r.clsx("react-datepicker__day-name",a)},i)})))})),ke(n,"formatWeekday",(function(e,t){return n.props.formatWeekDay?function(e,t,n){return t(Re(e,"EEEE",n))}(e,n.props.formatWeekDay,t):n.props.useWeekdaysShort?function(e,t){return Re(e,"EEE",t)}(e,t):function(e,t){return Re(e,"EEEEEE",t)}(e,t)})),ke(n,"decreaseYear",(function(){n.setState((function(e){var t=e.date;return{date:y.subYears(t,n.props.showYearPicker?n.props.yearItemNumber:1)}}),(function(){return n.handleYearChange(n.state.date)}))})),ke(n,"clearSelectingDate",(function(){n.setState({selectingDate:null})})),ke(n,"renderPreviousButton",(function(){if(!n.props.renderCustomHeader){var e;switch(!0){case n.props.showMonthYearPicker:e=ht(n.state.date,n.props);break;case n.props.showYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.minDate,r=t.yearItemNumber,o=void 0===r?Le:r,i=Et($e(y.subYears(e,o)),o).endPeriod,a=n&&S.getYear(n);return a&&a>i||!1}(n.state.date,n.props);break;case n.props.showQuarterYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.minDate,r=t.includeDates,o=W.startOfYear(e),i=v.subQuarters(o,1);return n&&Y.differenceInCalendarQuarters(n,i)>0||r&&r.every((function(e){return Y.differenceInCalendarQuarters(e,i)>0}))||!1}(n.state.date,n.props);break;default:e=pt(n.state.date,n.props)}if((n.props.forceShowMonthNavigation||n.props.showDisabledMonthNavigation||!e)&&!n.props.showTimeSelectOnly){var t=["react-datepicker__navigation","react-datepicker__navigation--previous"],r=n.decreaseMonth;(n.props.showMonthYearPicker||n.props.showQuarterYearPicker||n.props.showYearPicker)&&(r=n.decreaseYear),e&&n.props.showDisabledMonthNavigation&&(t.push("react-datepicker__navigation--previous--disabled"),r=null);var o=n.props.showMonthYearPicker||n.props.showQuarterYearPicker||n.props.showYearPicker,i=n.props,a=i.previousMonthButtonLabel,s=i.previousYearButtonLabel,l=n.props,c=l.previousMonthAriaLabel,u=void 0===c?"string"==typeof a?a:"Previous Month":c,d=l.previousYearAriaLabel,p=void 0===d?"string"==typeof s?s:"Previous Year":d;return fe.default.createElement("button",{type:"button",className:t.join(" "),onClick:r,onKeyDown:n.props.handleOnKeyDown,"aria-label":o?p:u},fe.default.createElement("span",{className:["react-datepicker__navigation-icon","react-datepicker__navigation-icon--previous"].join(" ")},o?n.props.previousYearButtonLabel:n.props.previousMonthButtonLabel))}}})),ke(n,"increaseYear",(function(){n.setState((function(e){var t=e.date;return{date:f.addYears(t,n.props.showYearPicker?n.props.yearItemNumber:1)}}),(function(){return n.handleYearChange(n.state.date)}))})),ke(n,"renderNextButton",(function(){if(!n.props.renderCustomHeader){var e;switch(!0){case n.props.showMonthYearPicker:e=mt(n.state.date,n.props);break;case n.props.showYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.maxDate,r=t.yearItemNumber,o=void 0===r?Le:r,i=Et(f.addYears(e,o),o).startPeriod,a=n&&S.getYear(n);return a&&a<i||!1}(n.state.date,n.props);break;case n.props.showQuarterYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.maxDate,r=t.includeDates,o=q.endOfYear(e),i=p.addQuarters(o,1);return n&&Y.differenceInCalendarQuarters(i,n)>0||r&&r.every((function(e){return Y.differenceInCalendarQuarters(i,e)>0}))||!1}(n.state.date,n.props);break;default:e=ft(n.state.date,n.props)}if((n.props.forceShowMonthNavigation||n.props.showDisabledMonthNavigation||!e)&&!n.props.showTimeSelectOnly){var t=["react-datepicker__navigation","react-datepicker__navigation--next"];n.props.showTimeSelect&&t.push("react-datepicker__navigation--next--with-time"),n.props.todayButton&&t.push("react-datepicker__navigation--next--with-today-button");var r=n.increaseMonth;(n.props.showMonthYearPicker||n.props.showQuarterYearPicker||n.props.showYearPicker)&&(r=n.increaseYear),e&&n.props.showDisabledMonthNavigation&&(t.push("react-datepicker__navigation--next--disabled"),r=null);var o=n.props.showMonthYearPicker||n.props.showQuarterYearPicker||n.props.showYearPicker,i=n.props,a=i.nextMonthButtonLabel,s=i.nextYearButtonLabel,l=n.props,c=l.nextMonthAriaLabel,u=void 0===c?"string"==typeof a?a:"Next Month":c,d=l.nextYearAriaLabel,h=void 0===d?"string"==typeof s?s:"Next Year":d;return fe.default.createElement("button",{type:"button",className:t.join(" "),onClick:r,onKeyDown:n.props.handleOnKeyDown,"aria-label":o?h:u},fe.default.createElement("span",{className:["react-datepicker__navigation-icon","react-datepicker__navigation-icon--next"].join(" ")},o?n.props.nextYearButtonLabel:n.props.nextMonthButtonLabel))}}})),ke(n,"renderCurrentMonth",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:n.state.date,t=["react-datepicker__current-month"];return n.props.showYearDropdown&&t.push("react-datepicker__current-month--hasYearDropdown"),n.props.showMonthDropdown&&t.push("react-datepicker__current-month--hasMonthDropdown"),n.props.showMonthYearDropdown&&t.push("react-datepicker__current-month--hasMonthYearDropdown"),fe.default.createElement("div",{className:t.join(" ")},Re(e,n.props.dateFormat,n.props.locale))})),ke(n,"renderYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showYearDropdown&&!e)return fe.default.createElement(Ot,{adjustDateOnChange:n.props.adjustDateOnChange,date:n.state.date,onSelect:n.props.onSelect,setOpen:n.props.setOpen,dropdownMode:n.props.dropdownMode,onChange:n.changeYear,minDate:n.props.minDate,maxDate:n.props.maxDate,year:S.getYear(n.state.date),scrollableYearDropdown:n.props.scrollableYearDropdown,yearDropdownItemNumber:n.props.yearDropdownItemNumber})})),ke(n,"renderMonthDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showMonthDropdown&&!e)return fe.default.createElement(Pt,{dropdownMode:n.props.dropdownMode,locale:n.props.locale,onChange:n.changeMonth,month:k.getMonth(n.state.date),useShortMonthInDropdown:n.props.useShortMonthInDropdown})})),ke(n,"renderMonthYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showMonthYearDropdown&&!e)return fe.default.createElement(Nt,{dropdownMode:n.props.dropdownMode,locale:n.props.locale,dateFormat:n.props.dateFormat,onChange:n.changeMonthYear,minDate:n.props.minDate,maxDate:n.props.maxDate,date:n.state.date,scrollableMonthYearDropdown:n.props.scrollableMonthYearDropdown})})),ke(n,"handleTodayButtonClick",(function(e){n.props.onSelect(Ue(),e),n.props.setPreSelection&&n.props.setPreSelection(Ue())})),ke(n,"renderTodayButton",(function(){if(n.props.todayButton&&!n.props.showTimeSelectOnly)return fe.default.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return n.handleTodayButtonClick(e)}},n.props.todayButton)})),ke(n,"renderDefaultHeader",(function(e){var t=e.monthDate,r=e.i;return fe.default.createElement("div",{className:"react-datepicker__header ".concat(n.props.showTimeSelect?"react-datepicker__header--has-time-select":"")},n.renderCurrentMonth(t),fe.default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(n.props.dropdownMode),onFocus:n.handleDropdownFocus},n.renderMonthDropdown(0!==r),n.renderMonthYearDropdown(0!==r),n.renderYearDropdown(0!==r)),fe.default.createElement("div",{className:"react-datepicker__day-names"},n.header(t)))})),ke(n,"renderCustomHeader",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.monthDate,r=e.i;if(n.props.showTimeSelect&&!n.state.monthContainer||n.props.showTimeSelectOnly)return null;var o=pt(n.state.date,n.props),i=ft(n.state.date,n.props),a=ht(n.state.date,n.props),s=mt(n.state.date,n.props),l=!n.props.showMonthYearPicker&&!n.props.showQuarterYearPicker&&!n.props.showYearPicker;return fe.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:n.props.onDropdownFocus},n.props.renderCustomHeader(be(be({},n.state),{},{customHeaderCount:r,monthDate:t,changeMonth:n.changeMonth,changeYear:n.changeYear,decreaseMonth:n.decreaseMonth,increaseMonth:n.increaseMonth,decreaseYear:n.decreaseYear,increaseYear:n.increaseYear,prevMonthButtonDisabled:o,nextMonthButtonDisabled:i,prevYearButtonDisabled:a,nextYearButtonDisabled:s})),l&&fe.default.createElement("div",{className:"react-datepicker__day-names"},n.header(t)))})),ke(n,"renderYearHeader",(function(e){var t=e.monthDate,r=n.props,o=r.showYearPicker,i=Et(t,r.yearItemNumber),a=i.startPeriod,s=i.endPeriod;return fe.default.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},o?"".concat(a," - ").concat(s):S.getYear(t))})),ke(n,"renderHeader",(function(e){switch(!0){case void 0!==n.props.renderCustomHeader:return n.renderCustomHeader(e);case n.props.showMonthYearPicker||n.props.showQuarterYearPicker||n.props.showYearPicker:return n.renderYearHeader(e);default:return n.renderDefaultHeader(e)}})),ke(n,"renderMonths",(function(){var e;if(!n.props.showTimeSelectOnly&&!n.props.showYearPicker){for(var t=[],r=n.props.showPreviousMonths?n.props.monthsShown-1:0,o=n.props.showMonthYearPicker||n.props.showQuarterYearPicker?f.addYears(n.state.date,r):g.subMonths(n.state.date,r),i=null!==(e=n.props.monthSelectedIn)&&void 0!==e?e:r,a=0;a<n.props.monthsShown;++a){var s=a-i+r,l=n.props.showMonthYearPicker||n.props.showQuarterYearPicker?f.addYears(o,s):d.addMonths(o,s),c="month-".concat(a),u=a<n.props.monthsShown-1,p=a>0;t.push(fe.default.createElement("div",{key:c,ref:function(e){n.monthContainer=e},className:"react-datepicker__month-container"},n.renderHeader({monthDate:l,i:a}),fe.default.createElement(Vt,{chooseDayAriaLabelPrefix:n.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:n.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:n.props.weekAriaLabelPrefix,ariaLabelPrefix:n.props.monthAriaLabelPrefix,onChange:n.changeMonthYear,day:l,dayClassName:n.props.dayClassName,calendarStartDay:n.props.calendarStartDay,monthClassName:n.props.monthClassName,onDayClick:n.handleDayClick,handleOnKeyDown:n.props.handleOnDayKeyDown,handleOnMonthKeyDown:n.props.handleOnKeyDown,usePointerEvent:n.props.usePointerEvent,onDayMouseEnter:n.handleDayMouseEnter,onMouseLeave:n.handleMonthMouseLeave,onWeekSelect:n.props.onWeekSelect,orderInDisplay:a,formatWeekNumber:n.props.formatWeekNumber,locale:n.props.locale,minDate:n.props.minDate,maxDate:n.props.maxDate,excludeDates:n.props.excludeDates,excludeDateIntervals:n.props.excludeDateIntervals,highlightDates:n.props.highlightDates,holidays:n.props.holidays,selectingDate:n.state.selectingDate,includeDates:n.props.includeDates,includeDateIntervals:n.props.includeDateIntervals,inline:n.props.inline,shouldFocusDayInline:n.props.shouldFocusDayInline,fixedHeight:n.props.fixedHeight,filterDate:n.props.filterDate,preSelection:n.props.preSelection,setPreSelection:n.props.setPreSelection,selected:n.props.selected,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,selectsRange:n.props.selectsRange,selectsDisabledDaysInRange:n.props.selectsDisabledDaysInRange,selectsMultiple:n.props.selectsMultiple,selectedDates:n.props.selectedDates,showWeekNumbers:n.props.showWeekNumbers,startDate:n.props.startDate,endDate:n.props.endDate,peekNextMonth:n.props.peekNextMonth,setOpen:n.props.setOpen,shouldCloseOnSelect:n.props.shouldCloseOnSelect,renderDayContents:n.props.renderDayContents,renderMonthContent:n.props.renderMonthContent,renderQuarterContent:n.props.renderQuarterContent,renderYearContent:n.props.renderYearContent,disabledKeyboardNavigation:n.props.disabledKeyboardNavigation,showMonthYearPicker:n.props.showMonthYearPicker,showFullMonthYearPicker:n.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:n.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:n.props.showFourColumnMonthYearPicker,showYearPicker:n.props.showYearPicker,showQuarterYearPicker:n.props.showQuarterYearPicker,showWeekPicker:n.props.showWeekPicker,isInputFocused:n.props.isInputFocused,containerRef:n.containerRef,monthShowsDuplicateDaysEnd:u,monthShowsDuplicateDaysStart:p})))}return t}})),ke(n,"renderYears",(function(){if(!n.props.showTimeSelectOnly)return n.props.showYearPicker?fe.default.createElement("div",{className:"react-datepicker__year--container"},n.renderHeader({monthDate:n.state.date}),fe.default.createElement(Qt,Ce({onDayClick:n.handleDayClick,selectingDate:n.state.selectingDate,clearSelectingDate:n.clearSelectingDate,date:n.state.date},n.props,{onYearMouseEnter:n.handleYearMouseEnter,onYearMouseLeave:n.handleYearMouseLeave}))):void 0})),ke(n,"renderTimeSection",(function(){if(n.props.showTimeSelect&&(n.state.monthContainer||n.props.showTimeSelectOnly))return fe.default.createElement(Gt,{selected:n.props.selected,openToDate:n.props.openToDate,onChange:n.props.onTimeChange,timeClassName:n.props.timeClassName,format:n.props.timeFormat,includeTimes:n.props.includeTimes,intervals:n.props.timeIntervals,minTime:n.props.minTime,maxTime:n.props.maxTime,excludeTimes:n.props.excludeTimes,filterTime:n.props.filterTime,timeCaption:n.props.timeCaption,todayButton:n.props.todayButton,showMonthDropdown:n.props.showMonthDropdown,showMonthYearDropdown:n.props.showMonthYearDropdown,showYearDropdown:n.props.showYearDropdown,withPortal:n.props.withPortal,monthRef:n.state.monthContainer,injectTimes:n.props.injectTimes,locale:n.props.locale,handleOnKeyDown:n.props.handleOnKeyDown,showTimeSelectOnly:n.props.showTimeSelectOnly})})),ke(n,"renderInputTimeSection",(function(){var e=new Date(n.props.selected),t=Be(e)&&Boolean(n.props.selected)?"".concat(At(e.getHours()),":").concat(At(e.getMinutes())):"";if(n.props.showTimeInput)return fe.default.createElement(qt,{date:e,timeString:t,timeInputLabel:n.props.timeInputLabel,onChange:n.props.onTimeChange,customTimeInput:n.props.customTimeInput})})),ke(n,"renderAriaLiveRegion",(function(){var e,t=Et(n.state.date,n.props.yearItemNumber),r=t.startPeriod,o=t.endPeriod;return e=n.props.showYearPicker?"".concat(r," - ").concat(o):n.props.showMonthYearPicker||n.props.showQuarterYearPicker?S.getYear(n.state.date):"".concat(Je(k.getMonth(n.state.date),n.props.locale)," ").concat(S.getYear(n.state.date)),fe.default.createElement("span",{role:"alert","aria-live":"polite",className:"react-datepicker__aria-live"},n.state.isRenderAriaLiveMessage&&e)})),ke(n,"renderChildren",(function(){if(n.props.children)return fe.default.createElement("div",{className:"react-datepicker__children-container"},n.props.children)})),n.containerRef=fe.default.createRef(),n.state={date:n.getDateInView(),selectingDate:null,monthContainer:null,isRenderAriaLiveMessage:!1},n}return Se(t,e),xe(t,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}))}},{key:"componentDidUpdate",value:function(e){var t=this;if(!this.props.preSelection||Ge(this.props.preSelection,e.preSelection)&&this.props.monthSelectedIn===e.monthSelectedIn)this.props.openToDate&&!Ge(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate});else{var n=!We(this.state.date,this.props.preSelection);this.setState({date:this.props.preSelection},(function(){return n&&t.handleCustomMonthChange(t.state.date)}))}}},{key:"render",value:function(){var e=this.props.container||Kt;return fe.default.createElement("div",{style:{display:"contents"},ref:this.containerRef},fe.default.createElement(e,{className:r.clsx("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly}),showTime:this.props.showTimeSelect||this.props.showTimeInput,showTimeSelectOnly:this.props.showTimeSelectOnly},this.renderAriaLiveRegion(),this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderYears(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.renderChildren()))}}],[{key:"defaultProps",get:function(){return{onDropdownFocus:function(){},monthsShown:1,forceShowMonthNavigation:!1,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",customTimeInput:null,yearItemNumber:Le}}}])}(fe.default.Component),en=function(e){var t=e.icon,n=e.className,r=void 0===n?"":n,o=e.onClick,i="react-datepicker__calendar-icon";return fe.default.isValidElement(t)?fe.default.cloneElement(t,{className:"".concat(t.props.className||""," ").concat(i," ").concat(r),onClick:function(e){"function"==typeof t.props.onClick&&t.props.onClick(e),"function"==typeof o&&o(e)}}):"string"==typeof t?fe.default.createElement("i",{className:"".concat(i," ").concat(t," ").concat(r),"aria-hidden":"true",onClick:o}):fe.default.createElement("svg",{className:"".concat(i," ").concat(r),xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 448 512",onClick:o},fe.default.createElement("path",{d:"M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"}))},tn=function(e){function t(e){var n;return Ee(this,t),(n=ge(this,t,[e])).el=document.createElement("div"),n}return Se(t,e),xe(t,[{key:"componentDidMount",value:function(){this.portalRoot=(this.props.portalHost||document).getElementById(this.props.portalId),this.portalRoot||(this.portalRoot=document.createElement("div"),this.portalRoot.setAttribute("id",this.props.portalId),(this.props.portalHost||document.body).appendChild(this.portalRoot)),this.portalRoot.appendChild(this.el)}},{key:"componentWillUnmount",value:function(){this.portalRoot.removeChild(this.el)}},{key:"render",value:function(){return me.default.createPortal(this.props.children,this.el)}}])}(fe.default.Component),nn=function(e){return!e.disabled&&-1!==e.tabIndex},rn=function(e){function t(e){var n;return Ee(this,t),ke(n=ge(this,t,[e]),"getTabChildren",(function(){return Array.prototype.slice.call(n.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"),1,-1).filter(nn)})),ke(n,"handleFocusStart",(function(){var e=n.getTabChildren();e&&e.length>1&&e[e.length-1].focus()})),ke(n,"handleFocusEnd",(function(){var e=n.getTabChildren();e&&e.length>1&&e[0].focus()})),n.tabLoopRef=fe.default.createRef(),n}return Se(t,e),xe(t,[{key:"render",value:function(){return this.props.enableTabLoop?fe.default.createElement("div",{className:"react-datepicker__tab-loop",ref:this.tabLoopRef},fe.default.createElement("div",{className:"react-datepicker__tab-loop__start",tabIndex:"0",onFocus:this.handleFocusStart}),this.props.children,fe.default.createElement("div",{className:"react-datepicker__tab-loop__end",tabIndex:"0",onFocus:this.handleFocusEnd})):this.props.children}}],[{key:"defaultProps",get:function(){return{enableTabLoop:!0}}}])}(fe.default.Component),on=function(e){function t(){return Ee(this,t),ge(this,t,arguments)}return Se(t,e),xe(t,[{key:"render",value:function(){var e,t=this.props,n=t.className,o=t.wrapperClassName,i=t.hidePopper,a=t.popperComponent,s=t.targetComponent,l=t.enableTabLoop,c=t.popperOnKeyDown,u=t.portalId,d=t.portalHost,p=t.popperProps,f=t.showArrow;if(!i){var h=r.clsx("react-datepicker-popper",n);e=fe.default.createElement(rn,{enableTabLoop:l},fe.default.createElement("div",{ref:p.refs.setFloating,style:p.floatingStyles,className:h,"data-placement":p.placement,onKeyDown:c},a,f&&fe.default.createElement(ue.FloatingArrow,{ref:p.arrowRef,context:p.context,fill:"currentColor",strokeWidth:1,height:8,width:16,style:{transform:"translateY(-1px)"},className:"react-datepicker__triangle"})))}this.props.popperContainer&&(e=fe.default.createElement(this.props.popperContainer,{},e)),u&&!i&&(e=fe.default.createElement(tn,{portalId:u,portalHost:d},e));var m=r.clsx("react-datepicker-wrapper",o);return fe.default.createElement(fe.default.Fragment,null,fe.default.createElement("div",{ref:p.refs.setReference,className:m},s),e)}}],[{key:"defaultProps",get:function(){return{hidePopper:!0}}}])}(fe.default.Component),an=(Zt=on,function(e){var t=be(be({},e),{},{popperModifiers:e.popperModifiers||[],popperProps:e.popperProps||{},hidePopper:"boolean"!=typeof e.hidePopper||e.hidePopper}),n=fe.default.useRef(),r=ue.useFloating(be({open:!t.hidePopper,whileElementsMounted:ue.autoUpdate,placement:t.popperPlacement,middleware:[ue.flip({padding:15}),ue.offset(10),ue.arrow({element:n})].concat(Oe(t.popperModifiers))},t.popperProps));return fe.default.createElement(Zt,Ce({},t,{popperProps:be(be({},r),{},{arrowRef:n})}))}),sn="react-datepicker-ignore-onclickoutside",ln=he.default(Xt),cn="Date input not valid.",un=function(e){function t(e){var n;return Ee(this,t),ke(n=ge(this,t,[e]),"getPreSelection",(function(){return n.props.openToDate?n.props.openToDate:n.props.selectsEnd&&n.props.startDate?n.props.startDate:n.props.selectsStart&&n.props.endDate?n.props.endDate:Ie()})),ke(n,"modifyHolidays",(function(){var e;return null===(e=n.props.holidays)||void 0===e?void 0:e.reduce((function(e,t){var n=new Date(t.date);return i.isValid(n)?[].concat(Oe(e),[be(be({},t),{},{date:n})]):e}),[])})),ke(n,"calcInitialState",(function(){var e,t=n.getPreSelection(),r=gt(n.props),o=vt(n.props),i=r&&ne.isBefore(t,$.startOfDay(r))?r:o&&te.isAfter(t,V.endOfDay(o))?o:t;return{open:n.props.startOpen||!1,preventFocus:!1,preSelection:null!==(e=n.props.selectsRange?n.props.startDate:n.props.selected)&&void 0!==e?e:i,highlightDates:yt(n.props.highlightDates),focused:!1,shouldFocusDayInline:!1,isRenderAriaLiveMessage:!1}})),ke(n,"clearPreventFocusTimeout",(function(){n.preventFocusTimeout&&clearTimeout(n.preventFocusTimeout)})),ke(n,"setFocus",(function(){n.input&&n.input.focus&&n.input.focus({preventScroll:!0})})),ke(n,"setBlur",(function(){n.input&&n.input.blur&&n.input.blur(),n.cancelFocusInput()})),ke(n,"setOpen",(function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];n.setState({open:e,preSelection:e&&n.state.open?n.state.preSelection:n.calcInitialState().preSelection,lastPreSelectChange:pn},(function(){e||n.setState((function(e){return{focused:!!t&&e.focused}}),(function(){!t&&n.setBlur(),n.setState({inputValue:null})}))}))})),ke(n,"inputOk",(function(){return o.isDate(n.state.preSelection)})),ke(n,"isCalendarOpen",(function(){return void 0===n.props.open?n.state.open&&!n.props.disabled&&!n.props.readOnly:n.props.open})),ke(n,"handleFocus",(function(e){n.state.preventFocus||(n.props.onFocus(e),n.props.preventOpenOnFocus||n.props.readOnly||n.setOpen(!0)),n.setState({focused:!0})})),ke(n,"sendFocusBackToInput",(function(){n.preventFocusTimeout&&n.clearPreventFocusTimeout(),n.setState({preventFocus:!0},(function(){n.preventFocusTimeout=setTimeout((function(){n.setFocus(),n.setState({preventFocus:!1})}))}))})),ke(n,"cancelFocusInput",(function(){clearTimeout(n.inputFocusTimeout),n.inputFocusTimeout=null})),ke(n,"deferFocusInput",(function(){n.cancelFocusInput(),n.inputFocusTimeout=setTimeout((function(){return n.setFocus()}),1)})),ke(n,"handleDropdownFocus",(function(){n.cancelFocusInput()})),ke(n,"handleBlur",(function(e){(!n.state.open||n.props.withPortal||n.props.showTimeInput)&&n.props.onBlur(e),n.setState({focused:!1})})),ke(n,"handleCalendarClickOutside",(function(e){n.props.inline||n.setOpen(!1),n.props.onClickOutside(e),n.props.withPortal&&e.preventDefault()})),ke(n,"handleChange",(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var o=t[0];if(!n.props.onChangeRaw||(n.props.onChangeRaw.apply(n,t),"function"==typeof o.isDefaultPrevented&&!o.isDefaultPrevented())){n.setState({inputValue:o.target.value,lastPreSelectChange:dn});var i,s,l,c,u,d,p,f,h=(i=o.target.value,s=n.props.dateFormat,l=n.props.locale,c=n.props.strictParsing,u=n.props.minDate,d=null,p=Ze(l)||Ze(Ke()),f=!0,Array.isArray(s)?(s.forEach((function(e){var t=ie.parse(i,e,new Date,{locale:p,useAdditionalWeekYearTokens:!0,useAdditionalDayOfYearTokens:!0});c&&(f=Be(t,u)&&i===Re(t,e,l)),Be(t,u)&&f&&(d=t)})),d):(d=ie.parse(i,s,new Date,{locale:p,useAdditionalWeekYearTokens:!0,useAdditionalDayOfYearTokens:!0}),c?f=Be(d)&&i===Re(d,s,l):Be(d)||(s=s.match(Pe).map((function(e){var t=e[0];if("p"===t||"P"===t){var n=a.longFormatters[t];return p?n(e,p.formatLong):t}return e})).join(""),i.length>0&&(d=ie.parse(i,s.slice(0,i.length),new Date,{useAdditionalWeekYearTokens:!0,useAdditionalDayOfYearTokens:!0})),Be(d)||(d=new Date(i))),Be(d)&&f?d:null));n.props.showTimeSelectOnly&&n.props.selected&&h&&!Ge(h,n.props.selected)&&(h=de.set(n.props.selected,{hours:A.getHours(h),minutes:_.getMinutes(h),seconds:b.getSeconds(h)})),!h&&o.target.value||n.setSelected(h,o,!0)}})),ke(n,"handleSelect",(function(e,t,r){if(n.props.shouldCloseOnSelect&&!n.props.showTimeSelect&&n.sendFocusBackToInput(),n.props.onChangeRaw&&n.props.onChangeRaw(t),n.setSelected(e,t,!1,r),n.props.showDateSelect&&n.setState({isRenderAriaLiveMessage:!0}),!n.props.shouldCloseOnSelect||n.props.showTimeSelect)n.setPreSelection(e);else if(!n.props.inline){n.props.selectsRange||n.setOpen(!1);var o=n.props,i=o.startDate,a=o.endDate;!i||a||!n.props.swapRange&&kt(e,i)||n.setOpen(!1)}})),ke(n,"setSelected",(function(e,t,r,o){var i=e;if(n.props.showYearPicker){if(null!==i&&at(S.getYear(i),n.props))return}else if(n.props.showMonthYearPicker){if(null!==i&&nt(i,n.props))return}else if(null!==i&&et(i,n.props))return;var a=n.props,s=a.onChange,l=a.selectsRange,c=a.startDate,u=a.endDate,d=a.selectsMultiple,p=a.selectedDates,f=a.minTime,h=a.swapRange;if(!Qe(n.props.selected,i)||n.props.allowSameDay||l||d)if(null!==i&&(!n.props.selected||r&&(n.props.showTimeSelect||n.props.showTimeSelectOnly||n.props.showTimeInput)||(i=Fe(i,{hour:A.getHours(n.props.selected),minute:_.getMinutes(n.props.selected),second:b.getSeconds(n.props.selected)})),r||!n.props.showTimeSelect&&!n.props.showTimeSelectOnly||f&&(i=Fe(i,{hour:f.getHours(),minute:f.getMinutes(),second:f.getSeconds()})),n.props.inline||n.setState({preSelection:i}),n.props.focusSelectedMonth||n.setState({monthSelectedIn:o})),l){var m=c&&u;c||u?c&&!u&&(null===i?s([null,null],t):kt(i,c)?s(h?[i,c]:[i,null],t):s([c,i],t)):s([i,null],t),m&&s([i,null],t)}else d?null!=p&&p.length?p.some((function(e){return Ge(e,i)}))?s(p.filter((function(e){return!Ge(e,i)})),t):s([].concat(Oe(p),[i]),t):s([i],t):s(i,t);r||(n.props.onSelect(i,t),n.setState({inputValue:null}))})),ke(n,"setPreSelection",(function(e){var t=void 0!==n.props.minDate,r=void 0!==n.props.maxDate,o=!0;if(e){var i=$.startOfDay(e);if(t&&r)o=qe(e,n.props.minDate,n.props.maxDate);else if(t){var a=$.startOfDay(n.props.minDate);o=te.isAfter(e,a)||Qe(i,a)}else if(r){var s=V.endOfDay(n.props.maxDate);o=ne.isBefore(e,s)||Qe(i,s)}}o&&n.setState({preSelection:e})})),ke(n,"toggleCalendar",(function(){n.setOpen(!n.state.open)})),ke(n,"handleTimeChange",(function(e){var t=n.props.selected?n.props.selected:n.getPreSelection(),r=n.props.selected?e:Fe(t,{hour:A.getHours(e),minute:_.getMinutes(e)});n.setState({preSelection:r}),n.props.onChange(r),n.props.shouldCloseOnSelect&&(n.sendFocusBackToInput(),n.setOpen(!1)),n.props.showTimeInput&&n.setOpen(!0),(n.props.showTimeSelectOnly||n.props.showTimeSelect)&&n.setState({isRenderAriaLiveMessage:!0}),n.setState({inputValue:null})})),ke(n,"onInputClick",(function(){n.props.disabled||n.props.readOnly||n.setOpen(!0),n.props.onInputClick()})),ke(n,"onInputKeyDown",(function(e){n.props.onKeyDown(e);var t=e.key;if(n.state.open||n.props.inline||n.props.preventOpenOnFocus){if(n.state.open){if("ArrowDown"===t||"ArrowUp"===t){e.preventDefault();var r=n.props.showWeekPicker&&n.props.showWeekNumbers?'.react-datepicker__week-number[tabindex="0"]':n.props.showFullMonthYearPicker||n.props.showMonthYearPicker?'.react-datepicker__month-text[tabindex="0"]':'.react-datepicker__day[tabindex="0"]',o=n.calendar.componentNode&&n.calendar.componentNode.querySelector(r);return void(o&&o.focus({preventScroll:!0}))}var i=Ie(n.state.preSelection);"Enter"===t?(e.preventDefault(),n.inputOk()&&n.state.lastPreSelectChange===pn?(n.handleSelect(i,e),!n.props.shouldCloseOnSelect&&n.setPreSelection(i)):n.setOpen(!1)):"Escape"===t?(e.preventDefault(),n.sendFocusBackToInput(),n.setOpen(!1)):"Tab"===t&&n.setOpen(!1),n.inputOk()||n.props.onInputError({code:1,msg:cn})}}else"ArrowDown"!==t&&"ArrowUp"!==t&&"Enter"!==t||n.onInputClick()})),ke(n,"onPortalKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),n.setState({preventFocus:!0},(function(){n.setOpen(!1),setTimeout((function(){n.setFocus(),n.setState({preventFocus:!1})}))})))})),ke(n,"onDayKeyDown",(function(e){n.props.onKeyDown(e);var t,r=e.key,o=e.shiftKey,i=Ie(n.state.preSelection);if("Enter"===r)e.preventDefault(),n.handleSelect(i,e),!n.props.shouldCloseOnSelect&&n.setPreSelection(i);else if("Escape"===r)e.preventDefault(),n.setOpen(!1),n.inputOk()||n.props.onInputError({code:1,msg:cn});else if(!n.props.disabledKeyboardNavigation){var a;switch(r){case"ArrowLeft":a=n.props.showWeekPicker?m.subWeeks(i,1):h.subDays(i,1);break;case"ArrowRight":a=n.props.showWeekPicker?u.addWeeks(i,1):c.addDays(i,1);break;case"ArrowUp":a=m.subWeeks(i,1);break;case"ArrowDown":a=u.addWeeks(i,1);break;case"PageUp":a=o?y.subYears(i,1):g.subMonths(i,1);break;case"PageDown":a=o?f.addYears(i,1):d.addMonths(i,1);break;case"Home":a=je(i,n.props.locale,n.props.calendarStartDay);break;case"End":t=i,a=G.endOfWeek(t);break;default:a=null}if(!a)return void(n.props.onInputError&&n.props.onInputError({code:1,msg:cn}));if(e.preventDefault(),n.setState({lastPreSelectChange:pn}),n.props.adjustDateOnChange&&n.setSelected(a),n.setPreSelection(a),n.props.inline){var s=k.getMonth(i),l=k.getMonth(a),p=S.getYear(i),v=S.getYear(a);s!==l||p!==v?n.setState({shouldFocusDayInline:!0}):n.setState({shouldFocusDayInline:!1})}}})),ke(n,"onPopperKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),n.sendFocusBackToInput())})),ke(n,"onClearClick",(function(e){e&&e.preventDefault&&e.preventDefault(),n.sendFocusBackToInput(),n.props.selectsRange?n.props.onChange([null,null],e):n.props.onChange(null,e),n.setState({inputValue:null})})),ke(n,"clear",(function(){n.onClearClick()})),ke(n,"onScroll",(function(e){"boolean"==typeof n.props.closeOnScroll&&n.props.closeOnScroll?e.target!==document&&e.target!==document.documentElement&&e.target!==document.body||n.setOpen(!1):"function"==typeof n.props.closeOnScroll&&n.props.closeOnScroll(e)&&n.setOpen(!1)})),ke(n,"renderCalendar",(function(){return n.props.inline||n.isCalendarOpen()?fe.default.createElement(ln,{ref:function(e){n.calendar=e},locale:n.props.locale,calendarStartDay:n.props.calendarStartDay,chooseDayAriaLabelPrefix:n.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:n.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:n.props.weekAriaLabelPrefix,monthAriaLabelPrefix:n.props.monthAriaLabelPrefix,adjustDateOnChange:n.props.adjustDateOnChange,setOpen:n.setOpen,shouldCloseOnSelect:n.props.shouldCloseOnSelect,dateFormat:n.props.dateFormatCalendar,useWeekdaysShort:n.props.useWeekdaysShort,formatWeekDay:n.props.formatWeekDay,dropdownMode:n.props.dropdownMode,selected:n.props.selected,preSelection:n.state.preSelection,onSelect:n.handleSelect,onWeekSelect:n.props.onWeekSelect,openToDate:n.props.openToDate,minDate:n.props.minDate,maxDate:n.props.maxDate,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,selectsRange:n.props.selectsRange,selectsMultiple:n.props.selectsMultiple,selectedDates:n.props.selectedDates,startDate:n.props.startDate,endDate:n.props.endDate,excludeDates:n.props.excludeDates,excludeDateIntervals:n.props.excludeDateIntervals,filterDate:n.props.filterDate,onClickOutside:n.handleCalendarClickOutside,formatWeekNumber:n.props.formatWeekNumber,highlightDates:n.state.highlightDates,holidays:bt(n.modifyHolidays()),includeDates:n.props.includeDates,includeDateIntervals:n.props.includeDateIntervals,includeTimes:n.props.includeTimes,injectTimes:n.props.injectTimes,inline:n.props.inline,shouldFocusDayInline:n.state.shouldFocusDayInline,peekNextMonth:n.props.peekNextMonth,showMonthDropdown:n.props.showMonthDropdown,showPreviousMonths:n.props.showPreviousMonths,useShortMonthInDropdown:n.props.useShortMonthInDropdown,showMonthYearDropdown:n.props.showMonthYearDropdown,showWeekNumbers:n.props.showWeekNumbers,showYearDropdown:n.props.showYearDropdown,withPortal:n.props.withPortal,forceShowMonthNavigation:n.props.forceShowMonthNavigation,showDisabledMonthNavigation:n.props.showDisabledMonthNavigation,scrollableYearDropdown:n.props.scrollableYearDropdown,scrollableMonthYearDropdown:n.props.scrollableMonthYearDropdown,todayButton:n.props.todayButton,weekLabel:n.props.weekLabel,outsideClickIgnoreClass:sn,fixedHeight:n.props.fixedHeight,monthsShown:n.props.monthsShown,monthSelectedIn:n.state.monthSelectedIn,onDropdownFocus:n.handleDropdownFocus,onMonthChange:n.props.onMonthChange,onYearChange:n.props.onYearChange,dayClassName:n.props.dayClassName,weekDayClassName:n.props.weekDayClassName,monthClassName:n.props.monthClassName,timeClassName:n.props.timeClassName,showDateSelect:n.props.showDateSelect,showTimeSelect:n.props.showTimeSelect,showTimeSelectOnly:n.props.showTimeSelectOnly,onTimeChange:n.handleTimeChange,timeFormat:n.props.timeFormat,timeIntervals:n.props.timeIntervals,minTime:n.props.minTime,maxTime:n.props.maxTime,excludeTimes:n.props.excludeTimes,filterTime:n.props.filterTime,timeCaption:n.props.timeCaption,className:n.props.calendarClassName,container:n.props.calendarContainer,yearItemNumber:n.props.yearItemNumber,yearDropdownItemNumber:n.props.yearDropdownItemNumber,previousMonthAriaLabel:n.props.previousMonthAriaLabel,previousMonthButtonLabel:n.props.previousMonthButtonLabel,nextMonthAriaLabel:n.props.nextMonthAriaLabel,nextMonthButtonLabel:n.props.nextMonthButtonLabel,previousYearAriaLabel:n.props.previousYearAriaLabel,previousYearButtonLabel:n.props.previousYearButtonLabel,nextYearAriaLabel:n.props.nextYearAriaLabel,nextYearButtonLabel:n.props.nextYearButtonLabel,timeInputLabel:n.props.timeInputLabel,disabledKeyboardNavigation:n.props.disabledKeyboardNavigation,renderCustomHeader:n.props.renderCustomHeader,popperProps:n.props.popperProps,renderDayContents:n.props.renderDayContents,renderMonthContent:n.props.renderMonthContent,renderQuarterContent:n.props.renderQuarterContent,renderYearContent:n.props.renderYearContent,onDayMouseEnter:n.props.onDayMouseEnter,onMonthMouseLeave:n.props.onMonthMouseLeave,onYearMouseEnter:n.props.onYearMouseEnter,onYearMouseLeave:n.props.onYearMouseLeave,selectsDisabledDaysInRange:n.props.selectsDisabledDaysInRange,showTimeInput:n.props.showTimeInput,showMonthYearPicker:n.props.showMonthYearPicker,showFullMonthYearPicker:n.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:n.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:n.props.showFourColumnMonthYearPicker,showYearPicker:n.props.showYearPicker,showQuarterYearPicker:n.props.showQuarterYearPicker,showWeekPicker:n.props.showWeekPicker,excludeScrollbar:n.props.excludeScrollbar,handleOnKeyDown:n.props.onKeyDown,handleOnDayKeyDown:n.onDayKeyDown,isInputFocused:n.state.focused,customTimeInput:n.props.customTimeInput,setPreSelection:n.setPreSelection,usePointerEvent:n.props.usePointerEvent,yearClassName:n.props.yearClassName},n.props.children):null})),ke(n,"renderAriaLiveRegion",(function(){var e,t=n.props,r=t.dateFormat,o=t.locale,i=n.props.showTimeInput||n.props.showTimeSelect?"PPPPp":"PPPP";return e=n.props.selectsRange?"Selected start date: ".concat(Ne(n.props.startDate,{dateFormat:i,locale:o}),". ").concat(n.props.endDate?"End date: "+Ne(n.props.endDate,{dateFormat:i,locale:o}):""):n.props.showTimeSelectOnly?"Selected time: ".concat(Ne(n.props.selected,{dateFormat:r,locale:o})):n.props.showYearPicker?"Selected year: ".concat(Ne(n.props.selected,{dateFormat:"yyyy",locale:o})):n.props.showMonthYearPicker?"Selected month: ".concat(Ne(n.props.selected,{dateFormat:"MMMM yyyy",locale:o})):n.props.showQuarterYearPicker?"Selected quarter: ".concat(Ne(n.props.selected,{dateFormat:"yyyy, QQQ",locale:o})):"Selected date: ".concat(Ne(n.props.selected,{dateFormat:i,locale:o})),fe.default.createElement("span",{role:"alert","aria-live":"polite",className:"react-datepicker__aria-live"},e)})),ke(n,"renderDateInput",(function(){var e,t=r.clsx(n.props.className,ke({},sn,n.state.open)),o=n.props.customInput||fe.default.createElement("input",{type:"text"}),i=n.props.customInputRef||"ref",a="string"==typeof n.props.value?n.props.value:"string"==typeof n.state.inputValue?n.state.inputValue:n.props.selectsRange?function(e,t,n){if(!e)return"";var r=Ne(e,n),o=t?Ne(t,n):"";return"".concat(r," - ").concat(o)}(n.props.startDate,n.props.endDate,n.props):n.props.selectsMultiple?function(e,t){if(null==e||!e.length)return"";var n=Ne(e[0],t);if(1===e.length)return n;if(2===e.length){var r=Ne(e[1],t);return"".concat(n,", ").concat(r)}var o=e.length-1;return"".concat(n," (+").concat(o,")")}(n.props.selectedDates,n.props):Ne(n.props.selected,n.props);return fe.default.cloneElement(o,(ke(ke(ke(ke(ke(ke(ke(ke(ke(ke(e={},i,(function(e){n.input=e})),"value",a),"onBlur",n.handleBlur),"onChange",n.handleChange),"onClick",n.onInputClick),"onFocus",n.handleFocus),"onKeyDown",n.onInputKeyDown),"id",n.props.id),"name",n.props.name),"form",n.props.form),ke(ke(ke(ke(ke(ke(ke(ke(ke(ke(e,"autoFocus",n.props.autoFocus),"placeholder",n.props.placeholderText),"disabled",n.props.disabled),"autoComplete",n.props.autoComplete),"className",r.clsx(o.props.className,t)),"title",n.props.title),"readOnly",n.props.readOnly),"required",n.props.required),"tabIndex",n.props.tabIndex),"aria-describedby",n.props.ariaDescribedBy),ke(ke(ke(e,"aria-invalid",n.props.ariaInvalid),"aria-labelledby",n.props.ariaLabelledBy),"aria-required",n.props.ariaRequired)))})),ke(n,"renderClearButton",(function(){var e=n.props,t=e.isClearable,o=e.disabled,i=e.selected,a=e.startDate,s=e.endDate,l=e.clearButtonTitle,c=e.clearButtonClassName,u=void 0===c?"":c,d=e.ariaLabelClose,p=void 0===d?"Close":d,f=e.selectedDates;return t&&(null!=i||null!=a||null!=s||null!=f&&f.length)?fe.default.createElement("button",{type:"button",className:r.clsx("react-datepicker__close-icon",u,{"react-datepicker__close-icon--disabled":o}),disabled:o,"aria-label":p,onClick:n.onClearClick,title:l,tabIndex:-1}):null})),n.state=n.calcInitialState(),n.preventFocusTimeout=null,n}return Se(t,e),xe(t,[{key:"componentDidMount",value:function(){window.addEventListener("scroll",this.onScroll,!0)}},{key:"componentDidUpdate",value:function(e,t){var n,r;e.inline&&(n=e.selected,r=this.props.selected,n&&r?k.getMonth(n)!==k.getMonth(r)||S.getYear(n)!==S.getYear(r):n!==r)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:yt(this.props.highlightDates)}),t.focused||Qe(e.selected,this.props.selected)||this.setState({inputValue:null}),t.open!==this.state.open&&(!1===t.open&&!0===this.state.open&&this.props.onCalendarOpen(),!0===t.open&&!1===this.state.open&&this.props.onCalendarClose())}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout(),window.removeEventListener("scroll",this.onScroll,!0)}},{key:"renderInputContainer",value:function(){var e=this.props,t=e.showIcon,n=e.icon,r=e.calendarIconClassname,o=e.toggleCalendarOnIconClick,i=this.state.open;return fe.default.createElement("div",{className:"react-datepicker__input-container".concat(t?" react-datepicker__view-calendar-icon":"")},t&&fe.default.createElement(en,Ce({icon:n,className:"".concat(r," ").concat(i&&"react-datepicker-ignore-onclickoutside")},o?{onClick:this.toggleCalendar}:null)),this.state.isRenderAriaLiveMessage&&this.renderAriaLiveRegion(),this.renderDateInput(),this.renderClearButton())}},{key:"render",value:function(){var e=this.renderCalendar();if(this.props.inline)return e;if(this.props.withPortal){var t=this.state.open?fe.default.createElement(rn,{enableTabLoop:this.props.enableTabLoop},fe.default.createElement("div",{className:"react-datepicker__portal",tabIndex:-1,onKeyDown:this.onPortalKeyDown},e)):null;return this.state.open&&this.props.portalId&&(t=fe.default.createElement(tn,{portalId:this.props.portalId,portalHost:this.props.portalHost},t)),fe.default.createElement("div",null,this.renderInputContainer(),t)}return fe.default.createElement(an,{className:this.props.popperClassName,wrapperClassName:this.props.wrapperClassName,hidePopper:!this.isCalendarOpen(),portalId:this.props.portalId,portalHost:this.props.portalHost,popperModifiers:this.props.popperModifiers,targetComponent:this.renderInputContainer(),popperContainer:this.props.popperContainer,popperComponent:e,popperPlacement:this.props.popperPlacement,popperProps:this.props.popperProps,popperOnKeyDown:this.onPopperKeyDown,enableTabLoop:this.props.enableTabLoop,showArrow:this.props.showPopperArrow})}}],[{key:"defaultProps",get:function(){return{allowSameDay:!1,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onInputClick:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},onCalendarOpen:function(){},onCalendarClose:function(){},preventOpenOnFocus:!1,onYearChange:function(){},onInputError:function(){},monthsShown:1,readOnly:!1,withPortal:!1,selectsDisabledDaysInRange:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,showTimeInput:!1,showPreviousMonths:!1,showMonthYearPicker:!1,showFullMonthYearPicker:!1,showTwoColumnMonthYearPicker:!1,showFourColumnMonthYearPicker:!1,showYearPicker:!1,showQuarterYearPicker:!1,showWeekPicker:!1,strictParsing:!1,swapRange:!1,timeIntervals:30,timeCaption:"Time",previousMonthAriaLabel:"Previous Month",previousMonthButtonLabel:"Previous Month",nextMonthAriaLabel:"Next Month",nextMonthButtonLabel:"Next Month",previousYearAriaLabel:"Previous Year",previousYearButtonLabel:"Previous Year",nextYearAriaLabel:"Next Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",enableTabLoop:!0,yearItemNumber:Le,focusSelectedMonth:!1,showPopperArrow:!0,excludeScrollbar:!0,customTimeInput:null,calendarStartDay:void 0,toggleCalendarOnIconClick:!1,usePointerEvent:!1}}}])}(fe.default.Component),dn="input",pn="navigate";e.CalendarContainer=Kt,e.default=un,e.getDefaultLocale=Ke,e.registerLocale=function(e,t){var n="undefined"!=typeof window?window:globalThis;n.__localeData__||(n.__localeData__={}),n.__localeData__[e]=t},e.setDefaultLocale=function(e){("undefined"!=typeof window?window:globalThis).__localeId__=e},Object.defineProperty(e,"__esModule",{value:!0})}(t,n(77810),n(75826),n(84538),n(92671),n(95609),n(50644),n(24099),n(5833),n(64951),n(58235),n(39711),n(3045),n(3112),n(79342),n(2352),n(386),n(94772),n(28359),n(8662),n(36826),n(23396),n(10877),n(15523),n(67206),n(17633),n(37115),n(51802),n(16090),n(44874),n(38838),n(3080),n(72101),n(51143),n(27566),n(68607),n(1346),n(80466),n(69022),n(13155),n(61480),n(80658),n(1922),n(56234),n(39944),n(79687),n(1841),n(21927),n(54605),n(50582),n(79307),n(59655),n(35627),n(38892),n(14637),n(40977),n(34212),n(31109),n(40546),n(26184),n(54935),n(68863),n(94934),n(22483),n(52869),n(97595))},81806:(e,t)=>{"use strict";t.addLeadingZeros=function(e,t){const n=e<0?"-":"",r=Math.abs(e).toString().padStart(t,"0");return n+r}},51095:(e,t,n)=>{"use strict";Object.defineProperty(t,"defaultLocale",{enumerable:!0,get:function(){return r.enUS}});var r=n(71640)},59567:(e,t)=>{"use strict";t.getDefaultOptions=function(){return n},t.setDefaultOptions=function(e){n=e};let n={}},95447:(e,t,n)=>{"use strict";t.formatters=void 0;var r=n(1793),o=n(67206),i=n(13579),a=n(32859),s=n(43918),l=n(81806),c=n(87193);const u="midnight",d="noon",p="morning",f="afternoon",h="evening",m="night";t.formatters={G:function(e,t,n){const r=e.getFullYear()>0?1:0;switch(t){case"G":case"GG":case"GGG":return n.era(r,{width:"abbreviated"});case"GGGGG":return n.era(r,{width:"narrow"});default:return n.era(r,{width:"wide"})}},y:function(e,t,n){if("yo"===t){const t=e.getFullYear(),r=t>0?t:1-t;return n.ordinalNumber(r,{unit:"year"})}return c.lightFormatters.y(e,t)},Y:function(e,t,n,r){const o=(0,s.getWeekYear)(e,r),i=o>0?o:1-o;if("YY"===t){const e=i%100;return(0,l.addLeadingZeros)(e,2)}return"Yo"===t?n.ordinalNumber(i,{unit:"year"}):(0,l.addLeadingZeros)(i,t.length)},R:function(e,t){const n=(0,i.getISOWeekYear)(e);return(0,l.addLeadingZeros)(n,t.length)},u:function(e,t){const n=e.getFullYear();return(0,l.addLeadingZeros)(n,t.length)},Q:function(e,t,n){const r=Math.ceil((e.getMonth()+1)/3);switch(t){case"Q":return String(r);case"QQ":return(0,l.addLeadingZeros)(r,2);case"Qo":return n.ordinalNumber(r,{unit:"quarter"});case"QQQ":return n.quarter(r,{width:"abbreviated",context:"formatting"});case"QQQQQ":return n.quarter(r,{width:"narrow",context:"formatting"});default:return n.quarter(r,{width:"wide",context:"formatting"})}},q:function(e,t,n){const r=Math.ceil((e.getMonth()+1)/3);switch(t){case"q":return String(r);case"qq":return(0,l.addLeadingZeros)(r,2);case"qo":return n.ordinalNumber(r,{unit:"quarter"});case"qqq":return n.quarter(r,{width:"abbreviated",context:"standalone"});case"qqqqq":return n.quarter(r,{width:"narrow",context:"standalone"});default:return n.quarter(r,{width:"wide",context:"standalone"})}},M:function(e,t,n){const r=e.getMonth();switch(t){case"M":case"MM":return c.lightFormatters.M(e,t);case"Mo":return n.ordinalNumber(r+1,{unit:"month"});case"MMM":return n.month(r,{width:"abbreviated",context:"formatting"});case"MMMMM":return n.month(r,{width:"narrow",context:"formatting"});default:return n.month(r,{width:"wide",context:"formatting"})}},L:function(e,t,n){const r=e.getMonth();switch(t){case"L":return String(r+1);case"LL":return(0,l.addLeadingZeros)(r+1,2);case"Lo":return n.ordinalNumber(r+1,{unit:"month"});case"LLL":return n.month(r,{width:"abbreviated",context:"standalone"});case"LLLLL":return n.month(r,{width:"narrow",context:"standalone"});default:return n.month(r,{width:"wide",context:"standalone"})}},w:function(e,t,n,r){const o=(0,a.getWeek)(e,r);return"wo"===t?n.ordinalNumber(o,{unit:"week"}):(0,l.addLeadingZeros)(o,t.length)},I:function(e,t,n){const r=(0,o.getISOWeek)(e);return"Io"===t?n.ordinalNumber(r,{unit:"week"}):(0,l.addLeadingZeros)(r,t.length)},d:function(e,t,n){return"do"===t?n.ordinalNumber(e.getDate(),{unit:"date"}):c.lightFormatters.d(e,t)},D:function(e,t,n){const o=(0,r.getDayOfYear)(e);return"Do"===t?n.ordinalNumber(o,{unit:"dayOfYear"}):(0,l.addLeadingZeros)(o,t.length)},E:function(e,t,n){const r=e.getDay();switch(t){case"E":case"EE":case"EEE":return n.day(r,{width:"abbreviated",context:"formatting"});case"EEEEE":return n.day(r,{width:"narrow",context:"formatting"});case"EEEEEE":return n.day(r,{width:"short",context:"formatting"});default:return n.day(r,{width:"wide",context:"formatting"})}},e:function(e,t,n,r){const o=e.getDay(),i=(o-r.weekStartsOn+8)%7||7;switch(t){case"e":return String(i);case"ee":return(0,l.addLeadingZeros)(i,2);case"eo":return n.ordinalNumber(i,{unit:"day"});case"eee":return n.day(o,{width:"abbreviated",context:"formatting"});case"eeeee":return n.day(o,{width:"narrow",context:"formatting"});case"eeeeee":return n.day(o,{width:"short",context:"formatting"});default:return n.day(o,{width:"wide",context:"formatting"})}},c:function(e,t,n,r){const o=e.getDay(),i=(o-r.weekStartsOn+8)%7||7;switch(t){case"c":return String(i);case"cc":return(0,l.addLeadingZeros)(i,t.length);case"co":return n.ordinalNumber(i,{unit:"day"});case"ccc":return n.day(o,{width:"abbreviated",context:"standalone"});case"ccccc":return n.day(o,{width:"narrow",context:"standalone"});case"cccccc":return n.day(o,{width:"short",context:"standalone"});default:return n.day(o,{width:"wide",context:"standalone"})}},i:function(e,t,n){const r=e.getDay(),o=0===r?7:r;switch(t){case"i":return String(o);case"ii":return(0,l.addLeadingZeros)(o,t.length);case"io":return n.ordinalNumber(o,{unit:"day"});case"iii":return n.day(r,{width:"abbreviated",context:"formatting"});case"iiiii":return n.day(r,{width:"narrow",context:"formatting"});case"iiiiii":return n.day(r,{width:"short",context:"formatting"});default:return n.day(r,{width:"wide",context:"formatting"})}},a:function(e,t,n){const r=e.getHours()/12>=1?"pm":"am";switch(t){case"a":case"aa":return n.dayPeriod(r,{width:"abbreviated",context:"formatting"});case"aaa":return n.dayPeriod(r,{width:"abbreviated",context:"formatting"}).toLowerCase();case"aaaaa":return n.dayPeriod(r,{width:"narrow",context:"formatting"});default:return n.dayPeriod(r,{width:"wide",context:"formatting"})}},b:function(e,t,n){const r=e.getHours();let o;switch(o=12===r?d:0===r?u:r/12>=1?"pm":"am",t){case"b":case"bb":return n.dayPeriod(o,{width:"abbreviated",context:"formatting"});case"bbb":return n.dayPeriod(o,{width:"abbreviated",context:"formatting"}).toLowerCase();case"bbbbb":return n.dayPeriod(o,{width:"narrow",context:"formatting"});default:return n.dayPeriod(o,{width:"wide",context:"formatting"})}},B:function(e,t,n){const r=e.getHours();let o;switch(o=r>=17?h:r>=12?f:r>=4?p:m,t){case"B":case"BB":case"BBB":return n.dayPeriod(o,{width:"abbreviated",context:"formatting"});case"BBBBB":return n.dayPeriod(o,{width:"narrow",context:"formatting"});default:return n.dayPeriod(o,{width:"wide",context:"formatting"})}},h:function(e,t,n){if("ho"===t){let t=e.getHours()%12;return 0===t&&(t=12),n.ordinalNumber(t,{unit:"hour"})}return c.lightFormatters.h(e,t)},H:function(e,t,n){return"Ho"===t?n.ordinalNumber(e.getHours(),{unit:"hour"}):c.lightFormatters.H(e,t)},K:function(e,t,n){const r=e.getHours()%12;return"Ko"===t?n.ordinalNumber(r,{unit:"hour"}):(0,l.addLeadingZeros)(r,t.length)},k:function(e,t,n){let r=e.getHours();return 0===r&&(r=24),"ko"===t?n.ordinalNumber(r,{unit:"hour"}):(0,l.addLeadingZeros)(r,t.length)},m:function(e,t,n){return"mo"===t?n.ordinalNumber(e.getMinutes(),{unit:"minute"}):c.lightFormatters.m(e,t)},s:function(e,t,n){return"so"===t?n.ordinalNumber(e.getSeconds(),{unit:"second"}):c.lightFormatters.s(e,t)},S:function(e,t){return c.lightFormatters.S(e,t)},X:function(e,t,n){const r=e.getTimezoneOffset();if(0===r)return"Z";switch(t){case"X":return v(r);case"XXXX":case"XX":return y(r);default:return y(r,":")}},x:function(e,t,n){const r=e.getTimezoneOffset();switch(t){case"x":return v(r);case"xxxx":case"xx":return y(r);default:return y(r,":")}},O:function(e,t,n){const r=e.getTimezoneOffset();switch(t){case"O":case"OO":case"OOO":return"GMT"+g(r,":");default:return"GMT"+y(r,":")}},z:function(e,t,n){const r=e.getTimezoneOffset();switch(t){case"z":case"zz":case"zzz":return"GMT"+g(r,":");default:return"GMT"+y(r,":")}},t:function(e,t,n){const r=Math.trunc(e.getTime()/1e3);return(0,l.addLeadingZeros)(r,t.length)},T:function(e,t,n){const r=e.getTime();return(0,l.addLeadingZeros)(r,t.length)}};function g(e,t=""){const n=e>0?"-":"+",r=Math.abs(e),o=Math.trunc(r/60),i=r%60;return 0===i?n+String(o):n+String(o)+t+(0,l.addLeadingZeros)(i,2)}function v(e,t){if(e%60==0){return(e>0?"-":"+")+(0,l.addLeadingZeros)(Math.abs(e)/60,2)}return y(e,t)}function y(e,t=""){const n=e>0?"-":"+",r=Math.abs(e);return n+(0,l.addLeadingZeros)(Math.trunc(r/60),2)+t+(0,l.addLeadingZeros)(r%60,2)}},87193:(e,t,n)=>{"use strict";t.lightFormatters=void 0;var r=n(81806);t.lightFormatters={y(e,t){const n=e.getFullYear(),o=n>0?n:1-n;return(0,r.addLeadingZeros)("yy"===t?o%100:o,t.length)},M(e,t){const n=e.getMonth();return"M"===t?String(n+1):(0,r.addLeadingZeros)(n+1,2)},d:(e,t)=>(0,r.addLeadingZeros)(e.getDate(),t.length),a(e,t){const n=e.getHours()/12>=1?"pm":"am";switch(t){case"a":case"aa":return n.toUpperCase();case"aaa":return n;case"aaaaa":return n[0];default:return"am"===n?"a.m.":"p.m."}},h:(e,t)=>(0,r.addLeadingZeros)(e.getHours()%12||12,t.length),H:(e,t)=>(0,r.addLeadingZeros)(e.getHours(),t.length),m:(e,t)=>(0,r.addLeadingZeros)(e.getMinutes(),t.length),s:(e,t)=>(0,r.addLeadingZeros)(e.getSeconds(),t.length),S(e,t){const n=t.length,o=e.getMilliseconds(),i=Math.trunc(o*Math.pow(10,n-3));return(0,r.addLeadingZeros)(i,t.length)}}},96873:(e,t)=>{"use strict";t.longFormatters=void 0;const n=(e,t)=>{switch(e){case"P":return t.date({width:"short"});case"PP":return t.date({width:"medium"});case"PPP":return t.date({width:"long"});default:return t.date({width:"full"})}},r=(e,t)=>{switch(e){case"p":return t.time({width:"short"});case"pp":return t.time({width:"medium"});case"ppp":return t.time({width:"long"});default:return t.time({width:"full"})}};t.longFormatters={p:r,P:(e,t)=>{const o=e.match(/(P+)(p+)?/)||[],i=o[1],a=o[2];if(!a)return n(e,t);let s;switch(i){case"P":s=t.dateTime({width:"short"});break;case"PP":s=t.dateTime({width:"medium"});break;case"PPP":s=t.dateTime({width:"long"});break;default:s=t.dateTime({width:"full"})}return s.replace("{{date}}",n(i,t)).replace("{{time}}",r(a,t))}}},58277:(e,t)=>{"use strict";t.getRoundingMethod=function(e){return t=>{const n=(e?Math[e]:Math.trunc)(t);return 0===n?0:n}}},73121:(e,t,n)=>{"use strict";t.getTimezoneOffsetInMilliseconds=function(e){const t=(0,r.toDate)(e),n=new Date(Date.UTC(t.getFullYear(),t.getMonth(),t.getDate(),t.getHours(),t.getMinutes(),t.getSeconds(),t.getMilliseconds()));return n.setUTCFullYear(t.getFullYear()),+e-+n};var r=n(40546)},49048:(e,t)=>{"use strict";t.isProtectedDayOfYearToken=function(e){return n.test(e)},t.isProtectedWeekYearToken=function(e){return r.test(e)},t.warnOrThrowProtectedError=function(e,t,n){const r=function(e,t,n){const r="Y"===e[0]?"years":"days of the month";return`Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`}(e,t,n);if(console.warn(r),o.includes(e))throw new RangeError(r)};const n=/^D+$/,r=/^Y+$/,o=["D","DD","YY","YYYY"]},34932:(e,t,n)=>{"use strict";t.add=function(e,t){const{years:n=0,months:s=0,weeks:l=0,days:c=0,hours:u=0,minutes:d=0,seconds:p=0}=t,f=(0,a.toDate)(e),h=s||n?(0,o.addMonths)(f,s+12*n):f,m=c||l?(0,r.addDays)(h,c+7*l):h,g=1e3*(p+60*(d+60*u));return(0,i.constructFrom)(e,m.getTime()+g)};var r=n(64951),o=n(39711),i=n(70722),a=n(40546)},62105:(e,t,n)=>{"use strict";t.addBusinessDays=function(e,t){const n=(0,s.toDate)(e),l=(0,a.isWeekend)(n);if(isNaN(t))return(0,r.constructFrom)(e,NaN);const c=n.getHours(),u=t<0?-1:1,d=Math.trunc(t/5);n.setDate(n.getDate()+7*d);let p=Math.abs(t%5);for(;p>0;)n.setDate(n.getDate()+u),(0,a.isWeekend)(n)||(p-=1);l&&(0,a.isWeekend)(n)&&0!==t&&((0,o.isSaturday)(n)&&n.setDate(n.getDate()+(u<0?2:-1)),(0,i.isSunday)(n)&&n.setDate(n.getDate()+(u<0?1:-2)));return n.setHours(c),n};var r=n(70722),o=n(60384),i=n(70247),a=n(69198),s=n(40546)},64951:(e,t,n)=>{"use strict";t.addDays=function(e,t){const n=(0,r.toDate)(e);if(isNaN(t))return(0,o.constructFrom)(e,NaN);if(!t)return n;return n.setDate(n.getDate()+t),n};var r=n(40546),o=n(70722)},5833:(e,t,n)=>{"use strict";t.addHours=function(e,t){return(0,r.addMilliseconds)(e,t*o.millisecondsInHour)};var r=n(69098),o=n(76994)},80081:(e,t,n)=>{"use strict";t.addISOWeekYears=function(e,t){return(0,o.setISOWeekYear)(e,(0,r.getISOWeekYear)(e)+t)};var r=n(13579),o=n(84375)},69098:(e,t,n)=>{"use strict";t.addMilliseconds=function(e,t){const n=+(0,r.toDate)(e);return(0,o.constructFrom)(e,n+t)};var r=n(40546),o=n(70722)},24099:(e,t,n)=>{"use strict";t.addMinutes=function(e,t){return(0,r.addMilliseconds)(e,t*o.millisecondsInMinute)};var r=n(69098),o=n(76994)},39711:(e,t,n)=>{"use strict";t.addMonths=function(e,t){const n=(0,r.toDate)(e);if(isNaN(t))return(0,o.constructFrom)(e,NaN);if(!t)return n;const i=n.getDate(),a=(0,o.constructFrom)(e,n.getTime());a.setMonth(n.getMonth()+t+1,0);const s=a.getDate();return i>=s?a:(n.setFullYear(a.getFullYear(),a.getMonth(),i),n)};var r=n(40546),o=n(70722)},3045:(e,t,n)=>{"use strict";t.addQuarters=function(e,t){const n=3*t;return(0,r.addMonths)(e,n)};var r=n(39711)},39603:(e,t,n)=>{"use strict";t.addSeconds=function(e,t){return(0,r.addMilliseconds)(e,1e3*t)};var r=n(69098)},58235:(e,t,n)=>{"use strict";t.addWeeks=function(e,t){const n=7*t;return(0,r.addDays)(e,n)};var r=n(64951)},3112:(e,t,n)=>{"use strict";t.addYears=function(e,t){return(0,r.addMonths)(e,12*t)};var r=n(39711)},47572:(e,t,n)=>{"use strict";t.areIntervalsOverlapping=function(e,t,n){const[o,i]=[+(0,r.toDate)(e.start),+(0,r.toDate)(e.end)].sort(((e,t)=>e-t)),[a,s]=[+(0,r.toDate)(t.start),+(0,r.toDate)(t.end)].sort(((e,t)=>e-t));return n?.inclusive?o<=s&&a<=i:o<s&&a<i};var r=n(40546)},46504:(e,t,n)=>{"use strict";t.clamp=function(e,t){return(0,o.min)([(0,r.max)([e,t.start]),t.end])};var r=n(1346),o=n(68607)},40163:(e,t,n)=>{"use strict";t.closestIndexTo=function(e,t){const n=(0,r.toDate)(e);if(isNaN(Number(n)))return NaN;const o=n.getTime();let i,a;return t.forEach((function(e,t){const n=(0,r.toDate)(e);if(isNaN(Number(n)))return i=NaN,void(a=NaN);const s=Math.abs(o-n.getTime());(null==i||s<a)&&(i=t,a=s)})),i};var r=n(40546)},96485:(e,t,n)=>{"use strict";t.closestTo=function(e,t){const n=(0,o.toDate)(e);if(isNaN(Number(n)))return(0,r.constructFrom)(e,NaN);const i=n.getTime();let a,s;return t.forEach((t=>{const n=(0,o.toDate)(t);if(isNaN(Number(n)))return a=(0,r.constructFrom)(e,NaN),void(s=NaN);const l=Math.abs(i-n.getTime());(null==a||l<s)&&(a=n,s=l)})),a};var r=n(70722),o=n(40546)},55155:(e,t,n)=>{"use strict";t.compareAsc=function(e,t){const n=(0,r.toDate)(e),o=(0,r.toDate)(t),i=n.getTime()-o.getTime();return i<0?-1:i>0?1:i};var r=n(40546)},47769:(e,t,n)=>{"use strict";t.compareDesc=function(e,t){const n=(0,r.toDate)(e),o=(0,r.toDate)(t),i=n.getTime()-o.getTime();return i>0?-1:i<0?1:i};var r=n(40546)},76994:(e,t)=>{"use strict";t.secondsInYear=t.secondsInWeek=t.secondsInQuarter=t.secondsInMonth=t.secondsInMinute=t.secondsInHour=t.secondsInDay=t.quartersInYear=t.monthsInYear=t.monthsInQuarter=t.minutesInYear=t.minutesInMonth=t.minutesInHour=t.minutesInDay=t.minTime=t.millisecondsInWeek=t.millisecondsInSecond=t.millisecondsInMinute=t.millisecondsInHour=t.millisecondsInDay=t.maxTime=t.daysInYear=t.daysInWeek=void 0;t.daysInWeek=7;const n=t.daysInYear=365.2425,r=t.maxTime=24*Math.pow(10,8)*60*60*1e3,o=(t.minTime=-r,t.millisecondsInWeek=6048e5,t.millisecondsInDay=864e5,t.millisecondsInMinute=6e4,t.millisecondsInHour=36e5,t.millisecondsInSecond=1e3,t.minutesInYear=525600,t.minutesInMonth=43200,t.minutesInDay=1440,t.minutesInHour=60,t.monthsInQuarter=3,t.monthsInYear=12,t.quartersInYear=4,t.secondsInHour=3600),i=(t.secondsInMinute=60,t.secondsInDay=24*o),a=(t.secondsInWeek=7*i,t.secondsInYear=i*n),s=t.secondsInMonth=a/12;t.secondsInQuarter=3*s},70722:(e,t)=>{"use strict";t.constructFrom=function(e,t){return e instanceof Date?new e.constructor(t):new Date(t)}},73536:(e,t,n)=>{"use strict";t.constructNow=function(e){return(0,r.constructFrom)(e,Date.now())};var r=n(70722)},1068:(e,t,n)=>{"use strict";t.daysToWeeks=function(e){const t=e/r.daysInWeek,n=Math.trunc(t);return 0===n?0:n};var r=n(76994)},14950:(e,t,n)=>{"use strict";t.differenceInBusinessDays=function(e,t){const n=(0,l.toDate)(e);let c=(0,l.toDate)(t);if(!(0,a.isValid)(n)||!(0,a.isValid)(c))return NaN;const u=(0,o.differenceInCalendarDays)(n,c),d=u<0?-1:1,p=Math.trunc(u/7);let f=5*p;c=(0,r.addDays)(c,7*p);for(;!(0,i.isSameDay)(n,c);)f+=(0,s.isWeekend)(c)?0:d,c=(0,r.addDays)(c,d);return 0===f?0:f};var r=n(64951),o=n(80466),i=n(59655),a=n(95609),s=n(69198),l=n(40546)},80466:(e,t,n)=>{"use strict";t.differenceInCalendarDays=function(e,t){const n=(0,o.startOfDay)(e),a=(0,o.startOfDay)(t),s=+n-(0,i.getTimezoneOffsetInMilliseconds)(n),l=+a-(0,i.getTimezoneOffsetInMilliseconds)(a);return Math.round((s-l)/r.millisecondsInDay)};var r=n(76994),o=n(80658),i=n(73121)},32660:(e,t,n)=>{"use strict";t.differenceInCalendarISOWeekYears=function(e,t){return(0,r.getISOWeekYear)(e)-(0,r.getISOWeekYear)(t)};var r=n(13579)},73023:(e,t,n)=>{"use strict";t.differenceInCalendarISOWeeks=function(e,t){const n=(0,o.startOfISOWeek)(e),a=(0,o.startOfISOWeek)(t),s=+n-(0,i.getTimezoneOffsetInMilliseconds)(n),l=+a-(0,i.getTimezoneOffsetInMilliseconds)(a);return Math.round((s-l)/r.millisecondsInWeek)};var r=n(76994),o=n(51145),i=n(73121)},69022:(e,t,n)=>{"use strict";t.differenceInCalendarMonths=function(e,t){const n=(0,r.toDate)(e),o=(0,r.toDate)(t),i=n.getFullYear()-o.getFullYear(),a=n.getMonth()-o.getMonth();return 12*i+a};var r=n(40546)},61480:(e,t,n)=>{"use strict";t.differenceInCalendarQuarters=function(e,t){const n=(0,o.toDate)(e),i=(0,o.toDate)(t),a=n.getFullYear()-i.getFullYear(),s=(0,r.getQuarter)(n)-(0,r.getQuarter)(i);return 4*a+s};var r=n(37115),o=n(40546)},66412:(e,t,n)=>{"use strict";t.differenceInCalendarWeeks=function(e,t,n){const a=(0,o.startOfWeek)(e,n),s=(0,o.startOfWeek)(t,n),l=+a-(0,i.getTimezoneOffsetInMilliseconds)(a),c=+s-(0,i.getTimezoneOffsetInMilliseconds)(s);return Math.round((l-c)/r.millisecondsInWeek)};var r=n(76994),o=n(1922),i=n(73121)},13155:(e,t,n)=>{"use strict";t.differenceInCalendarYears=function(e,t){const n=(0,r.toDate)(e),o=(0,r.toDate)(t);return n.getFullYear()-o.getFullYear()};var r=n(40546)},69932:(e,t,n)=>{"use strict";t.differenceInDays=function(e,t){const n=(0,o.toDate)(e),a=(0,o.toDate)(t),s=i(n,a),l=Math.abs((0,r.differenceInCalendarDays)(n,a));n.setDate(n.getDate()-s*l);const c=Number(i(n,a)===-s),u=s*(l-c);return 0===u?0:u};var r=n(80466),o=n(40546);function i(e,t){const n=e.getFullYear()-t.getFullYear()||e.getMonth()-t.getMonth()||e.getDate()-t.getDate()||e.getHours()-t.getHours()||e.getMinutes()-t.getMinutes()||e.getSeconds()-t.getSeconds()||e.getMilliseconds()-t.getMilliseconds();return n<0?-1:n>0?1:n}},59672:(e,t,n)=>{"use strict";t.differenceInHours=function(e,t,n){const a=(0,i.differenceInMilliseconds)(e,t)/o.millisecondsInHour;return(0,r.getRoundingMethod)(n?.roundingMethod)(a)};var r=n(58277),o=n(76994),i=n(67869)},43794:(e,t,n)=>{"use strict";t.differenceInISOWeekYears=function(e,t){let n=(0,a.toDate)(e);const s=(0,a.toDate)(t),l=(0,r.compareAsc)(n,s),c=Math.abs((0,o.differenceInCalendarISOWeekYears)(n,s));n=(0,i.subISOWeekYears)(n,l*c);const u=Number((0,r.compareAsc)(n,s)===-l),d=l*(c-u);return 0===d?0:d};var r=n(55155),o=n(32660),i=n(35584),a=n(40546)},67869:(e,t,n)=>{"use strict";t.differenceInMilliseconds=function(e,t){return+(0,r.toDate)(e)-+(0,r.toDate)(t)};var r=n(40546)},29414:(e,t,n)=>{"use strict";t.differenceInMinutes=function(e,t,n){const a=(0,i.differenceInMilliseconds)(e,t)/o.millisecondsInMinute;return(0,r.getRoundingMethod)(n?.roundingMethod)(a)};var r=n(58277),o=n(76994),i=n(67869)},67872:(e,t,n)=>{"use strict";t.differenceInMonths=function(e,t){const n=(0,a.toDate)(e),s=(0,a.toDate)(t),l=(0,r.compareAsc)(n,s),c=Math.abs((0,o.differenceInCalendarMonths)(n,s));let u;if(c<1)u=0;else{1===n.getMonth()&&n.getDate()>27&&n.setDate(30),n.setMonth(n.getMonth()-l*c);let t=(0,r.compareAsc)(n,s)===-l;(0,i.isLastDayOfMonth)((0,a.toDate)(e))&&1===c&&1===(0,r.compareAsc)(e,s)&&(t=!1),u=l*(c-Number(t))}return 0===u?0:u};var r=n(55155),o=n(69022),i=n(91920),a=n(40546)},40962:(e,t,n)=>{"use strict";t.differenceInQuarters=function(e,t,n){const i=(0,o.differenceInMonths)(e,t)/3;return(0,r.getRoundingMethod)(n?.roundingMethod)(i)};var r=n(58277),o=n(67872)},57338:(e,t,n)=>{"use strict";t.differenceInSeconds=function(e,t,n){const i=(0,o.differenceInMilliseconds)(e,t)/1e3;return(0,r.getRoundingMethod)(n?.roundingMethod)(i)};var r=n(58277),o=n(67869)},5962:(e,t,n)=>{"use strict";t.differenceInWeeks=function(e,t,n){const i=(0,o.differenceInDays)(e,t)/7;return(0,r.getRoundingMethod)(n?.roundingMethod)(i)};var r=n(58277),o=n(69932)},5909:(e,t,n)=>{"use strict";t.differenceInYears=function(e,t){const n=(0,i.toDate)(e),a=(0,i.toDate)(t),s=(0,r.compareAsc)(n,a),l=Math.abs((0,o.differenceInCalendarYears)(n,a));n.setFullYear(1584),a.setFullYear(1584);const c=(0,r.compareAsc)(n,a)===-s,u=s*(l-+c);return 0===u?0:u};var r=n(55155),o=n(13155),i=n(40546)},6786:(e,t,n)=>{"use strict";t.eachDayOfInterval=function(e,t){const n=(0,r.toDate)(e.start),o=(0,r.toDate)(e.end);let i=+n>+o;const a=i?+n:+o,s=i?o:n;s.setHours(0,0,0,0);let l=t?.step??1;if(!l)return[];l<0&&(l=-l,i=!i);const c=[];for(;+s<=a;)c.push((0,r.toDate)(s)),s.setDate(s.getDate()+l),s.setHours(0,0,0,0);return i?c.reverse():c};var r=n(40546)},97076:(e,t,n)=>{"use strict";t.eachHourOfInterval=function(e,t){const n=(0,o.toDate)(e.start),i=(0,o.toDate)(e.end);let a=+n>+i;const s=a?+n:+i;let l=a?i:n;l.setMinutes(0,0,0);let c=t?.step??1;if(!c)return[];c<0&&(c=-c,a=!a);const u=[];for(;+l<=s;)u.push((0,o.toDate)(l)),l=(0,r.addHours)(l,c);return a?u.reverse():u};var r=n(5833),o=n(40546)},48006:(e,t,n)=>{"use strict";t.eachMinuteOfInterval=function(e,t){const n=(0,o.startOfMinute)((0,i.toDate)(e.start)),a=(0,i.toDate)(e.end);let s=+n>+a;const l=s?+n:+a;let c=s?a:n,u=t?.step??1;if(!u)return[];u<0&&(u=-u,s=!s);const d=[];for(;+c<=l;)d.push((0,i.toDate)(c)),c=(0,r.addMinutes)(c,u);return s?d.reverse():d};var r=n(24099),o=n(99462),i=n(40546)},42274:(e,t,n)=>{"use strict";t.eachMonthOfInterval=function(e,t){const n=(0,r.toDate)(e.start),o=(0,r.toDate)(e.end);let i=+n>+o;const a=i?+n:+o,s=i?o:n;s.setHours(0,0,0,0),s.setDate(1);let l=t?.step??1;if(!l)return[];l<0&&(l=-l,i=!i);const c=[];for(;+s<=a;)c.push((0,r.toDate)(s)),s.setMonth(s.getMonth()+l);return i?c.reverse():c};var r=n(40546)},67660:(e,t,n)=>{"use strict";t.eachQuarterOfInterval=function(e,t){const n=(0,i.toDate)(e.start),a=(0,i.toDate)(e.end);let s=+n>+a;const l=s?+(0,o.startOfQuarter)(n):+(0,o.startOfQuarter)(a);let c=s?(0,o.startOfQuarter)(a):(0,o.startOfQuarter)(n),u=t?.step??1;if(!u)return[];u<0&&(u=-u,s=!s);const d=[];for(;+c<=l;)d.push((0,i.toDate)(c)),c=(0,r.addQuarters)(c,u);return s?d.reverse():d};var r=n(3045),o=n(39944),i=n(40546)},62602:(e,t,n)=>{"use strict";t.eachWeekOfInterval=function(e,t){const n=(0,i.toDate)(e.start),a=(0,i.toDate)(e.end);let s=+n>+a;const l=s?(0,o.startOfWeek)(a,t):(0,o.startOfWeek)(n,t),c=s?(0,o.startOfWeek)(n,t):(0,o.startOfWeek)(a,t);l.setHours(15),c.setHours(15);const u=+c.getTime();let d=l,p=t?.step??1;if(!p)return[];p<0&&(p=-p,s=!s);const f=[];for(;+d<=u;)d.setHours(0),f.push((0,i.toDate)(d)),d=(0,r.addWeeks)(d,p),d.setHours(15);return s?f.reverse():f};var r=n(58235),o=n(1922),i=n(40546)},82389:(e,t,n)=>{"use strict";t.eachWeekendOfInterval=function(e){const t=(0,r.eachDayOfInterval)(e),n=[];let i=0;for(;i<t.length;){const e=t[i++];(0,o.isWeekend)(e)&&n.push(e)}return n};var r=n(6786),o=n(69198)},21004:(e,t,n)=>{"use strict";t.eachWeekendOfMonth=function(e){const t=(0,i.startOfMonth)(e),n=(0,o.endOfMonth)(e);return(0,r.eachWeekendOfInterval)({start:t,end:n})};var r=n(82389),o=n(54605),i=n(56234)},95865:(e,t,n)=>{"use strict";t.eachWeekendOfYear=function(e){const t=(0,i.startOfYear)(e),n=(0,o.endOfYear)(e);return(0,r.eachWeekendOfInterval)({start:t,end:n})};var r=n(82389),o=n(50582),i=n(79687)},35223:(e,t,n)=>{"use strict";t.eachYearOfInterval=function(e,t){const n=(0,r.toDate)(e.start),o=(0,r.toDate)(e.end);let i=+n>+o;const a=i?+n:+o,s=i?o:n;s.setHours(0,0,0,0),s.setMonth(0,1);let l=t?.step??1;if(!l)return[];l<0&&(l=-l,i=!i);const c=[];for(;+s<=a;)c.push((0,r.toDate)(s)),s.setFullYear(s.getFullYear()+l);return i?c.reverse():c};var r=n(40546)},1841:(e,t,n)=>{"use strict";t.endOfDay=function(e){const t=(0,r.toDate)(e);return t.setHours(23,59,59,999),t};var r=n(40546)},71403:(e,t,n)=>{"use strict";t.endOfDecade=function(e){const t=(0,r.toDate)(e),n=t.getFullYear(),o=9+10*Math.floor(n/10);return t.setFullYear(o,11,31),t.setHours(23,59,59,999),t};var r=n(40546)},28837:(e,t,n)=>{"use strict";t.endOfHour=function(e){const t=(0,r.toDate)(e);return t.setMinutes(59,59,999),t};var r=n(40546)},79970:(e,t,n)=>{"use strict";t.endOfISOWeek=function(e){return(0,r.endOfWeek)(e,{weekStartsOn:1})};var r=n(21927)},95167:(e,t,n)=>{"use strict";t.endOfISOWeekYear=function(e){const t=(0,r.getISOWeekYear)(e),n=(0,i.constructFrom)(e,0);n.setFullYear(t+1,0,4),n.setHours(0,0,0,0);const a=(0,o.startOfISOWeek)(n);return a.setMilliseconds(a.getMilliseconds()-1),a};var r=n(13579),o=n(51145),i=n(70722)},70011:(e,t,n)=>{"use strict";t.endOfMinute=function(e){const t=(0,r.toDate)(e);return t.setSeconds(59,999),t};var r=n(40546)},54605:(e,t,n)=>{"use strict";t.endOfMonth=function(e){const t=(0,r.toDate)(e),n=t.getMonth();return t.setFullYear(t.getFullYear(),n+1,0),t.setHours(23,59,59,999),t};var r=n(40546)},93039:(e,t,n)=>{"use strict";t.endOfQuarter=function(e){const t=(0,r.toDate)(e),n=t.getMonth(),o=n-n%3+3;return t.setMonth(o,0),t.setHours(23,59,59,999),t};var r=n(40546)},91975:(e,t,n)=>{"use strict";t.endOfSecond=function(e){const t=(0,r.toDate)(e);return t.setMilliseconds(999),t};var r=n(40546)},77550:(e,t,n)=>{"use strict";t.endOfToday=function(){return(0,r.endOfDay)(Date.now())};var r=n(1841)},84272:(e,t)=>{"use strict";t.endOfTomorrow=function(){const e=new Date,t=e.getFullYear(),n=e.getMonth(),r=e.getDate(),o=new Date(0);return o.setFullYear(t,n,r+1),o.setHours(23,59,59,999),o}},21927:(e,t,n)=>{"use strict";t.endOfWeek=function(e,t){const n=(0,o.getDefaultOptions)(),i=t?.weekStartsOn??t?.locale?.options?.weekStartsOn??n.weekStartsOn??n.locale?.options?.weekStartsOn??0,a=(0,r.toDate)(e),s=a.getDay(),l=6+(s<i?-7:0)-(s-i);return a.setDate(a.getDate()+l),a.setHours(23,59,59,999),a};var r=n(40546),o=n(59567)},50582:(e,t,n)=>{"use strict";t.endOfYear=function(e){const t=(0,r.toDate)(e),n=t.getFullYear();return t.setFullYear(n+1,0,0),t.setHours(23,59,59,999),t};var r=n(40546)},85319:(e,t)=>{"use strict";t.endOfYesterday=function(){const e=new Date,t=e.getFullYear(),n=e.getMonth(),r=e.getDate(),o=new Date(0);return o.setFullYear(t,n,r-1),o.setHours(23,59,59,999),o}},50644:(e,t,n)=>{"use strict";t.format=t.formatDate=function(e,t,n){const p=(0,o.getDefaultOptions)(),f=n?.locale??p.locale??r.defaultLocale,g=n?.firstWeekContainsDate??n?.locale?.options?.firstWeekContainsDate??p.firstWeekContainsDate??p.locale?.options?.firstWeekContainsDate??1,v=n?.weekStartsOn??n?.locale?.options?.weekStartsOn??p.weekStartsOn??p.locale?.options?.weekStartsOn??0,y=(0,c.toDate)(e);if(!(0,l.isValid)(y))throw new RangeError("Invalid time value");let b=t.match(d).map((e=>{const t=e[0];if("p"===t||"P"===t){return(0,a.longFormatters[t])(e,f.formatLong)}return e})).join("").match(u).map((e=>{if("''"===e)return{isToken:!1,value:"'"};const t=e[0];if("'"===t)return{isToken:!1,value:m(e)};if(i.formatters[t])return{isToken:!0,value:e};if(t.match(h))throw new RangeError("Format string contains an unescaped latin alphabet character `"+t+"`");return{isToken:!1,value:e}}));f.localize.preprocessor&&(b=f.localize.preprocessor(y,b));const _={firstWeekContainsDate:g,weekStartsOn:v,locale:f};return b.map((r=>{if(!r.isToken)return r.value;const o=r.value;(!n?.useAdditionalWeekYearTokens&&(0,s.isProtectedWeekYearToken)(o)||!n?.useAdditionalDayOfYearTokens&&(0,s.isProtectedDayOfYearToken)(o))&&(0,s.warnOrThrowProtectedError)(o,t,String(e));return(0,i.formatters[o[0]])(y,o,f.localize,_)})).join("")},Object.defineProperty(t,"formatters",{enumerable:!0,get:function(){return i.formatters}}),Object.defineProperty(t,"longFormatters",{enumerable:!0,get:function(){return a.longFormatters}});var r=n(51095),o=n(59567),i=n(95447),a=n(96873),s=n(49048),l=n(95609),c=n(40546);const u=/[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,d=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,p=/^'([^]*?)'?$/,f=/''/g,h=/[a-zA-Z]/;function m(e){const t=e.match(p);return t?t[1].replace(f,"'"):e}},63455:(e,t,n)=>{"use strict";t.formatDistance=function(e,t,n){const d=(0,c.getDefaultOptions)(),p=n?.locale??d.locale??l.defaultLocale,f=(0,r.compareAsc)(e,t);if(isNaN(f))throw new RangeError("Invalid time value");const h=Object.assign({},n,{addSuffix:n?.addSuffix,comparison:f});let m,g;f>0?(m=(0,s.toDate)(t),g=(0,s.toDate)(e)):(m=(0,s.toDate)(e),g=(0,s.toDate)(t));const v=(0,a.differenceInSeconds)(g,m),y=((0,u.getTimezoneOffsetInMilliseconds)(g)-(0,u.getTimezoneOffsetInMilliseconds)(m))/1e3,b=Math.round((v-y)/60);let _;if(b<2)return n?.includeSeconds?v<5?p.formatDistance("lessThanXSeconds",5,h):v<10?p.formatDistance("lessThanXSeconds",10,h):v<20?p.formatDistance("lessThanXSeconds",20,h):v<40?p.formatDistance("halfAMinute",0,h):v<60?p.formatDistance("lessThanXMinutes",1,h):p.formatDistance("xMinutes",1,h):0===b?p.formatDistance("lessThanXMinutes",1,h):p.formatDistance("xMinutes",b,h);if(b<45)return p.formatDistance("xMinutes",b,h);if(b<90)return p.formatDistance("aboutXHours",1,h);if(b<o.minutesInDay){const e=Math.round(b/60);return p.formatDistance("aboutXHours",e,h)}if(b<2520)return p.formatDistance("xDays",1,h);if(b<o.minutesInMonth){const e=Math.round(b/o.minutesInDay);return p.formatDistance("xDays",e,h)}if(b<2*o.minutesInMonth)return _=Math.round(b/o.minutesInMonth),p.formatDistance("aboutXMonths",_,h);if(_=(0,i.differenceInMonths)(g,m),_<12){const e=Math.round(b/o.minutesInMonth);return p.formatDistance("xMonths",e,h)}{const e=_%12,t=Math.trunc(_/12);return e<3?p.formatDistance("aboutXYears",t,h):e<9?p.formatDistance("overXYears",t,h):p.formatDistance("almostXYears",t+1,h)}};var r=n(55155),o=n(76994),i=n(67872),a=n(57338),s=n(40546),l=n(51095),c=n(59567),u=n(73121)},56822:(e,t,n)=>{"use strict";t.formatDistanceStrict=function(e,t,n){const u=(0,o.getDefaultOptions)(),d=n?.locale??u.locale??r.defaultLocale,p=(0,s.compareAsc)(e,t);if(isNaN(p))throw new RangeError("Invalid time value");const f=Object.assign({},n,{addSuffix:n?.addSuffix,comparison:p});let h,m;p>0?(h=(0,c.toDate)(t),m=(0,c.toDate)(e)):(h=(0,c.toDate)(e),m=(0,c.toDate)(t));const g=(0,i.getRoundingMethod)(n?.roundingMethod??"round"),v=m.getTime()-h.getTime(),y=v/l.millisecondsInMinute,b=(0,a.getTimezoneOffsetInMilliseconds)(m)-(0,a.getTimezoneOffsetInMilliseconds)(h),_=(v-b)/l.millisecondsInMinute,A=n?.unit;let E;E=A||(y<1?"second":y<60?"minute":y<l.minutesInDay?"hour":_<l.minutesInMonth?"day":_<l.minutesInYear?"month":"year");if("second"===E){const e=g(v/1e3);return d.formatDistance("xSeconds",e,f)}if("minute"===E){const e=g(y);return d.formatDistance("xMinutes",e,f)}if("hour"===E){const e=g(y/60);return d.formatDistance("xHours",e,f)}if("day"===E){const e=g(_/l.minutesInDay);return d.formatDistance("xDays",e,f)}if("month"===E){const e=g(_/l.minutesInMonth);return 12===e&&"month"!==A?d.formatDistance("xYears",1,f):d.formatDistance("xMonths",e,f)}{const e=g(_/l.minutesInYear);return d.formatDistance("xYears",e,f)}};var r=n(51095),o=n(59567),i=n(58277),a=n(73121),s=n(55155),l=n(76994),c=n(40546)},76064:(e,t,n)=>{"use strict";t.formatDistanceToNow=function(e,t){return(0,o.formatDistance)(e,(0,r.constructNow)(e),t)};var r=n(73536),o=n(63455)},51457:(e,t,n)=>{"use strict";t.formatDistanceToNowStrict=function(e,t){return(0,r.formatDistanceStrict)(e,(0,o.constructNow)(e),t)};var r=n(56822),o=n(73536)},59760:(e,t,n)=>{"use strict";t.formatDuration=function(e,t){const n=(0,o.getDefaultOptions)(),a=t?.locale??n.locale??r.defaultLocale,s=t?.format??i,l=t?.zero??!1,c=t?.delimiter??" ";if(!a.formatDistance)return"";return s.reduce(((t,n)=>{const r=`x${n.replace(/(^.)/,(e=>e.toUpperCase()))}`,o=e[n];return void 0!==o&&(l||e[n])?t.concat(a.formatDistance(r,o)):t}),[]).join(c)};var r=n(51095),o=n(59567);const i=["years","months","weeks","days","hours","minutes","seconds"]},42995:(e,t,n)=>{"use strict";t.formatISO=function(e,t){const n=(0,r.toDate)(e);if(isNaN(n.getTime()))throw new RangeError("Invalid time value");const i=t?.format??"extended",a=t?.representation??"complete";let s="",l="";const c="extended"===i?"-":"",u="extended"===i?":":"";if("time"!==a){const e=(0,o.addLeadingZeros)(n.getDate(),2),t=(0,o.addLeadingZeros)(n.getMonth()+1,2);s=`${(0,o.addLeadingZeros)(n.getFullYear(),4)}${c}${t}${c}${e}`}if("date"!==a){const e=n.getTimezoneOffset();if(0!==e){const t=Math.abs(e);l=`${e<0?"+":"-"}${(0,o.addLeadingZeros)(Math.trunc(t/60),2)}:${(0,o.addLeadingZeros)(t%60,2)}`}else l="Z";s=`${s}${""===s?"":"T"}${[(0,o.addLeadingZeros)(n.getHours(),2),(0,o.addLeadingZeros)(n.getMinutes(),2),(0,o.addLeadingZeros)(n.getSeconds(),2)].join(u)}${l}`}return s};var r=n(40546),o=n(81806)},29338:(e,t,n)=>{"use strict";t.formatISO9075=function(e,t){const n=(0,o.toDate)(e);if(!(0,r.isValid)(n))throw new RangeError("Invalid time value");const a=t?.format??"extended",s=t?.representation??"complete";let l="";const c="extended"===a?"-":"",u="extended"===a?":":"";if("time"!==s){const e=(0,i.addLeadingZeros)(n.getDate(),2),t=(0,i.addLeadingZeros)(n.getMonth()+1,2);l=`${(0,i.addLeadingZeros)(n.getFullYear(),4)}${c}${t}${c}${e}`}if("date"!==s){l=`${l}${""===l?"":" "}${(0,i.addLeadingZeros)(n.getHours(),2)}${u}${(0,i.addLeadingZeros)(n.getMinutes(),2)}${u}${(0,i.addLeadingZeros)(n.getSeconds(),2)}`}return l};var r=n(95609),o=n(40546),i=n(81806)},23459:(e,t)=>{"use strict";t.formatISODuration=function(e){const{years:t=0,months:n=0,days:r=0,hours:o=0,minutes:i=0,seconds:a=0}=e;return`P${t}Y${n}M${r}DT${o}H${i}M${a}S`}},82293:(e,t,n)=>{"use strict";t.formatRFC3339=function(e,t){const n=(0,o.toDate)(e);if(!(0,r.isValid)(n))throw new RangeError("Invalid time value");const a=t?.fractionDigits??0,s=(0,i.addLeadingZeros)(n.getDate(),2),l=(0,i.addLeadingZeros)(n.getMonth()+1,2),c=n.getFullYear(),u=(0,i.addLeadingZeros)(n.getHours(),2),d=(0,i.addLeadingZeros)(n.getMinutes(),2),p=(0,i.addLeadingZeros)(n.getSeconds(),2);let f="";if(a>0){const e=n.getMilliseconds(),t=Math.trunc(e*Math.pow(10,a-3));f="."+(0,i.addLeadingZeros)(t,a)}let h="";const m=n.getTimezoneOffset();if(0!==m){const e=Math.abs(m);h=`${m<0?"+":"-"}${(0,i.addLeadingZeros)(Math.trunc(e/60),2)}:${(0,i.addLeadingZeros)(e%60,2)}`}else h="Z";return`${c}-${l}-${s}T${u}:${d}:${p}${f}${h}`};var r=n(95609),o=n(40546),i=n(81806)},11826:(e,t,n)=>{"use strict";t.formatRFC7231=function(e){const t=(0,o.toDate)(e);if(!(0,r.isValid)(t))throw new RangeError("Invalid time value");const n=a[t.getUTCDay()],l=(0,i.addLeadingZeros)(t.getUTCDate(),2),c=s[t.getUTCMonth()],u=t.getUTCFullYear(),d=(0,i.addLeadingZeros)(t.getUTCHours(),2),p=(0,i.addLeadingZeros)(t.getUTCMinutes(),2),f=(0,i.addLeadingZeros)(t.getUTCSeconds(),2);return`${n}, ${l} ${c} ${u} ${d}:${p}:${f} GMT`};var r=n(95609),o=n(40546),i=n(81806);const a=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],s=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]},81084:(e,t,n)=>{"use strict";t.formatRelative=function(e,t,n){const l=(0,i.toDate)(e),c=(0,i.toDate)(t),u=(0,s.getDefaultOptions)(),d=n?.locale??u.locale??a.defaultLocale,p=n?.weekStartsOn??n?.locale?.options?.weekStartsOn??u.weekStartsOn??u.locale?.options?.weekStartsOn??0,f=(0,r.differenceInCalendarDays)(l,c);if(isNaN(f))throw new RangeError("Invalid time value");let h;h=f<-6?"other":f<-1?"lastWeek":f<0?"yesterday":f<1?"today":f<2?"tomorrow":f<7?"nextWeek":"other";const m=d.formatRelative(h,l,c,{locale:d,weekStartsOn:p});return(0,o.format)(l,m,{locale:d,weekStartsOn:p})};var r=n(80466),o=n(50644),i=n(40546),a=n(51095),s=n(59567)},87300:(e,t,n)=>{"use strict";t.fromUnixTime=function(e){return(0,r.toDate)(1e3*e)};var r=n(40546)},15523:(e,t,n)=>{"use strict";t.getDate=function(e){const t=(0,r.toDate)(e);return t.getDate()};var r=n(40546)},10877:(e,t,n)=>{"use strict";t.getDay=function(e){const t=(0,r.toDate)(e);return t.getDay()};var r=n(40546)},1793:(e,t,n)=>{"use strict";t.getDayOfYear=function(e){const t=(0,i.toDate)(e),n=(0,r.differenceInCalendarDays)(t,(0,o.startOfYear)(t));return n+1};var r=n(80466),o=n(79687),i=n(40546)},17113:(e,t,n)=>{"use strict";t.getDaysInMonth=function(e){const t=(0,r.toDate)(e),n=t.getFullYear(),i=t.getMonth(),a=(0,o.constructFrom)(e,0);return a.setFullYear(n,i+1,0),a.setHours(0,0,0,0),a.getDate()};var r=n(40546),o=n(70722)},31698:(e,t,n)=>{"use strict";t.getDaysInYear=function(e){const t=(0,o.toDate)(e);if("Invalid Date"===String(new Date(t)))return NaN;return(0,r.isLeapYear)(t)?366:365};var r=n(65424),o=n(40546)},49239:(e,t,n)=>{"use strict";t.getDecade=function(e){const t=(0,r.toDate)(e).getFullYear();return 10*Math.floor(t/10)};var r=n(40546)},33854:(e,t,n)=>{"use strict";t.getDefaultOptions=function(){return Object.assign({},(0,r.getDefaultOptions)())};var r=n(59567)},23396:(e,t,n)=>{"use strict";t.getHours=function(e){const t=(0,r.toDate)(e);return t.getHours()};var r=n(40546)},39278:(e,t,n)=>{"use strict";t.getISODay=function(e){let t=(0,r.toDate)(e).getDay();0===t&&(t=7);return t};var r=n(40546)},67206:(e,t,n)=>{"use strict";t.getISOWeek=function(e){const t=(0,a.toDate)(e),n=+(0,o.startOfISOWeek)(t)-+(0,i.startOfISOWeekYear)(t);return Math.round(n/r.millisecondsInWeek)+1};var r=n(76994),o=n(51145),i=n(18992),a=n(40546)},13579:(e,t,n)=>{"use strict";t.getISOWeekYear=function(e){const t=(0,i.toDate)(e),n=t.getFullYear(),a=(0,r.constructFrom)(e,0);a.setFullYear(n+1,0,4),a.setHours(0,0,0,0);const s=(0,o.startOfISOWeek)(a),l=(0,r.constructFrom)(e,0);l.setFullYear(n,0,4),l.setHours(0,0,0,0);const c=(0,o.startOfISOWeek)(l);return t.getTime()>=s.getTime()?n+1:t.getTime()>=c.getTime()?n:n-1};var r=n(70722),o=n(51145),i=n(40546)},13907:(e,t,n)=>{"use strict";t.getISOWeeksInYear=function(e){const t=(0,i.startOfISOWeekYear)(e),n=+(0,i.startOfISOWeekYear)((0,r.addWeeks)(t,60))-+t;return Math.round(n/o.millisecondsInWeek)};var r=n(58235),o=n(76994),i=n(18992)},54025:(e,t,n)=>{"use strict";t.getMilliseconds=function(e){const t=(0,r.toDate)(e);return t.getMilliseconds()};var r=n(40546)},36826:(e,t,n)=>{"use strict";t.getMinutes=function(e){const t=(0,r.toDate)(e);return t.getMinutes()};var r=n(40546)},17633:(e,t,n)=>{"use strict";t.getMonth=function(e){const t=(0,r.toDate)(e);return t.getMonth()};var r=n(40546)},30612:(e,t,n)=>{"use strict";t.getOverlappingDaysInIntervals=function(e,t){const[n,a]=[+(0,i.toDate)(e.start),+(0,i.toDate)(e.end)].sort(((e,t)=>e-t)),[s,l]=[+(0,i.toDate)(t.start),+(0,i.toDate)(t.end)].sort(((e,t)=>e-t));if(!(n<l&&s<a))return 0;const c=s<n?n:s,u=c-(0,r.getTimezoneOffsetInMilliseconds)(c),d=l>a?a:l,p=d-(0,r.getTimezoneOffsetInMilliseconds)(d);return Math.ceil((p-u)/o.millisecondsInDay)};var r=n(73121),o=n(76994),i=n(40546)},37115:(e,t,n)=>{"use strict";t.getQuarter=function(e){const t=(0,r.toDate)(e);return Math.trunc(t.getMonth()/3)+1};var r=n(40546)},8662:(e,t,n)=>{"use strict";t.getSeconds=function(e){const t=(0,r.toDate)(e);return t.getSeconds()};var r=n(40546)},16090:(e,t,n)=>{"use strict";t.getTime=function(e){const t=(0,r.toDate)(e);return t.getTime()};var r=n(40546)},87648:(e,t,n)=>{"use strict";t.getUnixTime=function(e){return Math.trunc(+(0,r.toDate)(e)/1e3)};var r=n(40546)},32859:(e,t,n)=>{"use strict";t.getWeek=function(e,t){const n=(0,a.toDate)(e),s=+(0,o.startOfWeek)(n,t)-+(0,i.startOfWeekYear)(n,t);return Math.round(s/r.millisecondsInWeek)+1};var r=n(76994),o=n(1922),i=n(6559),a=n(40546)},20782:(e,t,n)=>{"use strict";t.getWeekOfMonth=function(e,t){const n=(0,a.getDefaultOptions)(),s=t?.weekStartsOn??t?.locale?.options?.weekStartsOn??n.weekStartsOn??n.locale?.options?.weekStartsOn??0,l=(0,r.getDate)(e);if(isNaN(l))return NaN;const c=(0,o.getDay)((0,i.startOfMonth)(e));let u=s-c;u<=0&&(u+=7);const d=l-u;return Math.ceil(d/7)+1};var r=n(15523),o=n(10877),i=n(56234),a=n(59567)},43918:(e,t,n)=>{"use strict";t.getWeekYear=function(e,t){const n=(0,i.toDate)(e),s=n.getFullYear(),l=(0,a.getDefaultOptions)(),c=t?.firstWeekContainsDate??t?.locale?.options?.firstWeekContainsDate??l.firstWeekContainsDate??l.locale?.options?.firstWeekContainsDate??1,u=(0,r.constructFrom)(e,0);u.setFullYear(s+1,0,c),u.setHours(0,0,0,0);const d=(0,o.startOfWeek)(u,t),p=(0,r.constructFrom)(e,0);p.setFullYear(s,0,c),p.setHours(0,0,0,0);const f=(0,o.startOfWeek)(p,t);return n.getTime()>=d.getTime()?s+1:n.getTime()>=f.getTime()?s:s-1};var r=n(70722),o=n(1922),i=n(40546),a=n(59567)},79807:(e,t,n)=>{"use strict";t.getWeeksInMonth=function(e,t){return(0,r.differenceInCalendarWeeks)((0,o.lastDayOfMonth)(e),(0,i.startOfMonth)(e),t)+1};var r=n(66412),o=n(39064),i=n(56234)},51802:(e,t,n)=>{"use strict";t.getYear=function(e){return(0,r.toDate)(e).getFullYear()};var r=n(40546)},1951:(e,t,n)=>{"use strict";t.hoursToMilliseconds=function(e){return Math.trunc(e*r.millisecondsInHour)};var r=n(76994)},41136:(e,t,n)=>{"use strict";t.hoursToMinutes=function(e){return Math.trunc(e*r.minutesInHour)};var r=n(76994)},63464:(e,t,n)=>{"use strict";t.hoursToSeconds=function(e){return Math.trunc(e*r.secondsInHour)};var r=n(76994)},68863:(e,t,n)=>{"use strict";var r=n(34932);Object.keys(r).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===r[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return r[e]}}))}));var o=n(62105);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var i=n(64951);Object.keys(i).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===i[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}}))}));var a=n(5833);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}));var s=n(80081);Object.keys(s).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===s[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return s[e]}}))}));var l=n(69098);Object.keys(l).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===l[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return l[e]}}))}));var c=n(24099);Object.keys(c).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===c[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return c[e]}}))}));var u=n(39711);Object.keys(u).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===u[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return u[e]}}))}));var d=n(3045);Object.keys(d).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===d[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return d[e]}}))}));var p=n(39603);Object.keys(p).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===p[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return p[e]}}))}));var f=n(58235);Object.keys(f).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===f[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return f[e]}}))}));var h=n(3112);Object.keys(h).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===h[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return h[e]}}))}));var m=n(47572);Object.keys(m).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===m[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return m[e]}}))}));var g=n(46504);Object.keys(g).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===g[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return g[e]}}))}));var v=n(40163);Object.keys(v).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===v[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return v[e]}}))}));var y=n(96485);Object.keys(y).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===y[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return y[e]}}))}));var b=n(55155);Object.keys(b).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===b[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return b[e]}}))}));var _=n(47769);Object.keys(_).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===_[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return _[e]}}))}));var A=n(70722);Object.keys(A).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===A[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return A[e]}}))}));var E=n(73536);Object.keys(E).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===E[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return E[e]}}))}));var w=n(1068);Object.keys(w).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===w[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return w[e]}}))}));var x=n(14950);Object.keys(x).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===x[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return x[e]}}))}));var k=n(80466);Object.keys(k).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===k[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return k[e]}}))}));var C=n(32660);Object.keys(C).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===C[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return C[e]}}))}));var S=n(73023);Object.keys(S).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===S[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return S[e]}}))}));var M=n(69022);Object.keys(M).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===M[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return M[e]}}))}));var T=n(61480);Object.keys(T).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===T[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return T[e]}}))}));var O=n(66412);Object.keys(O).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===O[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return O[e]}}))}));var D=n(13155);Object.keys(D).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===D[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return D[e]}}))}));var L=n(69932);Object.keys(L).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===L[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return L[e]}}))}));var P=n(59672);Object.keys(P).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===P[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return P[e]}}))}));var I=n(43794);Object.keys(I).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===I[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return I[e]}}))}));var B=n(67869);Object.keys(B).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===B[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return B[e]}}))}));var R=n(29414);Object.keys(R).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===R[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return R[e]}}))}));var N=n(67872);Object.keys(N).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===N[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return N[e]}}))}));var F=n(40962);Object.keys(F).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===F[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return F[e]}}))}));var j=n(57338);Object.keys(j).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===j[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return j[e]}}))}));var Y=n(5962);Object.keys(Y).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Y[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Y[e]}}))}));var $=n(5909);Object.keys($).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===$[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return $[e]}}))}));var H=n(6786);Object.keys(H).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===H[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return H[e]}}))}));var U=n(97076);Object.keys(U).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===U[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return U[e]}}))}));var z=n(48006);Object.keys(z).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===z[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return z[e]}}))}));var W=n(42274);Object.keys(W).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===W[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return W[e]}}))}));var V=n(67660);Object.keys(V).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===V[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return V[e]}}))}));var G=n(62602);Object.keys(G).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===G[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return G[e]}}))}));var Q=n(82389);Object.keys(Q).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Q[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Q[e]}}))}));var q=n(21004);Object.keys(q).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===q[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return q[e]}}))}));var K=n(95865);Object.keys(K).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===K[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return K[e]}}))}));var Z=n(35223);Object.keys(Z).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Z[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Z[e]}}))}));var J=n(1841);Object.keys(J).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===J[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return J[e]}}))}));var X=n(71403);Object.keys(X).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===X[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return X[e]}}))}));var ee=n(28837);Object.keys(ee).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===ee[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return ee[e]}}))}));var te=n(79970);Object.keys(te).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===te[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return te[e]}}))}));var ne=n(95167);Object.keys(ne).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===ne[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return ne[e]}}))}));var re=n(70011);Object.keys(re).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===re[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return re[e]}}))}));var oe=n(54605);Object.keys(oe).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===oe[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return oe[e]}}))}));var ie=n(93039);Object.keys(ie).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===ie[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return ie[e]}}))}));var ae=n(91975);Object.keys(ae).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===ae[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return ae[e]}}))}));var se=n(77550);Object.keys(se).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===se[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return se[e]}}))}));var le=n(84272);Object.keys(le).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===le[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return le[e]}}))}));var ce=n(21927);Object.keys(ce).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===ce[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return ce[e]}}))}));var ue=n(50582);Object.keys(ue).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===ue[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return ue[e]}}))}));var de=n(85319);Object.keys(de).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===de[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return de[e]}}))}));var pe=n(50644);Object.keys(pe).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===pe[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return pe[e]}}))}));var fe=n(63455);Object.keys(fe).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===fe[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return fe[e]}}))}));var he=n(56822);Object.keys(he).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===he[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return he[e]}}))}));var me=n(76064);Object.keys(me).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===me[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return me[e]}}))}));var ge=n(51457);Object.keys(ge).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===ge[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return ge[e]}}))}));var ve=n(59760);Object.keys(ve).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===ve[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return ve[e]}}))}));var ye=n(42995);Object.keys(ye).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===ye[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return ye[e]}}))}));var be=n(29338);Object.keys(be).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===be[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return be[e]}}))}));var _e=n(23459);Object.keys(_e).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===_e[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return _e[e]}}))}));var Ae=n(82293);Object.keys(Ae).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Ae[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Ae[e]}}))}));var Ee=n(11826);Object.keys(Ee).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Ee[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Ee[e]}}))}));var we=n(81084);Object.keys(we).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===we[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return we[e]}}))}));var xe=n(87300);Object.keys(xe).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===xe[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return xe[e]}}))}));var ke=n(15523);Object.keys(ke).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===ke[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return ke[e]}}))}));var Ce=n(10877);Object.keys(Ce).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Ce[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Ce[e]}}))}));var Se=n(1793);Object.keys(Se).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Se[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Se[e]}}))}));var Me=n(17113);Object.keys(Me).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Me[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Me[e]}}))}));var Te=n(31698);Object.keys(Te).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Te[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Te[e]}}))}));var Oe=n(49239);Object.keys(Oe).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Oe[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Oe[e]}}))}));var De=n(33854);Object.keys(De).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===De[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return De[e]}}))}));var Le=n(23396);Object.keys(Le).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Le[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Le[e]}}))}));var Pe=n(39278);Object.keys(Pe).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Pe[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Pe[e]}}))}));var Ie=n(67206);Object.keys(Ie).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Ie[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Ie[e]}}))}));var Be=n(13579);Object.keys(Be).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Be[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Be[e]}}))}));var Re=n(13907);Object.keys(Re).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Re[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Re[e]}}))}));var Ne=n(54025);Object.keys(Ne).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Ne[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Ne[e]}}))}));var Fe=n(36826);Object.keys(Fe).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Fe[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Fe[e]}}))}));var je=n(17633);Object.keys(je).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===je[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return je[e]}}))}));var Ye=n(30612);Object.keys(Ye).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Ye[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Ye[e]}}))}));var $e=n(37115);Object.keys($e).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===$e[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return $e[e]}}))}));var He=n(8662);Object.keys(He).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===He[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return He[e]}}))}));var Ue=n(16090);Object.keys(Ue).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Ue[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Ue[e]}}))}));var ze=n(87648);Object.keys(ze).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===ze[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return ze[e]}}))}));var We=n(32859);Object.keys(We).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===We[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return We[e]}}))}));var Ve=n(20782);Object.keys(Ve).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Ve[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Ve[e]}}))}));var Ge=n(43918);Object.keys(Ge).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Ge[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Ge[e]}}))}));var Qe=n(79807);Object.keys(Qe).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Qe[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Qe[e]}}))}));var qe=n(51802);Object.keys(qe).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===qe[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return qe[e]}}))}));var Ke=n(1951);Object.keys(Ke).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Ke[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Ke[e]}}))}));var Ze=n(41136);Object.keys(Ze).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Ze[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Ze[e]}}))}));var Je=n(63464);Object.keys(Je).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Je[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Je[e]}}))}));var Xe=n(82158);Object.keys(Xe).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Xe[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Xe[e]}}))}));var et=n(83555);Object.keys(et).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===et[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return et[e]}}))}));var tt=n(75483);Object.keys(tt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===tt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return tt[e]}}))}));var nt=n(40764);Object.keys(nt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===nt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return nt[e]}}))}));var rt=n(40977);Object.keys(rt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===rt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return rt[e]}}))}));var ot=n(34212);Object.keys(ot).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===ot[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return ot[e]}}))}));var it=n(92671);Object.keys(it).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===it[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return it[e]}}))}));var at=n(79307);Object.keys(at).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===at[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return at[e]}}))}));var st=n(36179);Object.keys(st).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===st[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return st[e]}}))}));var lt=n(74354);Object.keys(lt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===lt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return lt[e]}}))}));var ct=n(81464);Object.keys(ct).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===ct[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return ct[e]}}))}));var ut=n(8944);Object.keys(ut).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===ut[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return ut[e]}}))}));var dt=n(91920);Object.keys(dt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===dt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return dt[e]}}))}));var pt=n(65424);Object.keys(pt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===pt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return pt[e]}}))}));var ft=n(5870);Object.keys(ft).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===ft[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return ft[e]}}))}));var ht=n(3123);Object.keys(ht).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===ht[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return ht[e]}}))}));var mt=n(1655);Object.keys(mt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===mt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return mt[e]}}))}));var gt=n(59655);Object.keys(gt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===gt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return gt[e]}}))}));var vt=n(78391);Object.keys(vt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===vt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return vt[e]}}))}));var yt=n(60320);Object.keys(yt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===yt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return yt[e]}}))}));var bt=n(60161);Object.keys(bt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===bt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return bt[e]}}))}));var _t=n(39361);Object.keys(_t).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===_t[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return _t[e]}}))}));var At=n(35627);Object.keys(At).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===At[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return At[e]}}))}));var Et=n(14637);Object.keys(Et).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Et[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Et[e]}}))}));var wt=n(42273);Object.keys(wt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===wt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return wt[e]}}))}));var xt=n(76105);Object.keys(xt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===xt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return xt[e]}}))}));var kt=n(38892);Object.keys(kt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===kt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return kt[e]}}))}));var Ct=n(60384);Object.keys(Ct).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Ct[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Ct[e]}}))}));var St=n(70247);Object.keys(St).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===St[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return St[e]}}))}));var Mt=n(36401);Object.keys(Mt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Mt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Mt[e]}}))}));var Tt=n(92550);Object.keys(Tt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Tt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Tt[e]}}))}));var Ot=n(71583);Object.keys(Ot).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Ot[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Ot[e]}}))}));var Dt=n(21409);Object.keys(Dt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Dt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Dt[e]}}))}));var Lt=n(19323);Object.keys(Lt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Lt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Lt[e]}}))}));var Pt=n(52307);Object.keys(Pt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Pt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Pt[e]}}))}));var It=n(8667);Object.keys(It).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===It[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return It[e]}}))}));var Bt=n(13114);Object.keys(Bt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Bt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Bt[e]}}))}));var Rt=n(64137);Object.keys(Rt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Rt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Rt[e]}}))}));var Nt=n(60974);Object.keys(Nt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Nt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Nt[e]}}))}));var Ft=n(80304);Object.keys(Ft).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Ft[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Ft[e]}}))}));var jt=n(28136);Object.keys(jt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===jt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return jt[e]}}))}));var Yt=n(95609);Object.keys(Yt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Yt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Yt[e]}}))}));var $t=n(46999);Object.keys($t).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===$t[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return $t[e]}}))}));var Ht=n(69198);Object.keys(Ht).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Ht[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Ht[e]}}))}));var Ut=n(31109);Object.keys(Ut).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Ut[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Ut[e]}}))}));var zt=n(13255);Object.keys(zt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===zt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return zt[e]}}))}));var Wt=n(6828);Object.keys(Wt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Wt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Wt[e]}}))}));var Vt=n(57199);Object.keys(Vt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Vt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Vt[e]}}))}));var Gt=n(2813);Object.keys(Gt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Gt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Gt[e]}}))}));var Qt=n(39064);Object.keys(Qt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Qt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Qt[e]}}))}));var qt=n(36774);Object.keys(qt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===qt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return qt[e]}}))}));var Kt=n(84972);Object.keys(Kt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Kt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Kt[e]}}))}));var Zt=n(25733);Object.keys(Zt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Zt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Zt[e]}}))}));var Jt=n(20032);Object.keys(Jt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Jt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Jt[e]}}))}));var Xt=n(1346);Object.keys(Xt).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Xt[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Xt[e]}}))}));var en=n(75325);Object.keys(en).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===en[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return en[e]}}))}));var tn=n(93569);Object.keys(tn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===tn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return tn[e]}}))}));var nn=n(19627);Object.keys(nn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===nn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return nn[e]}}))}));var rn=n(84472);Object.keys(rn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===rn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return rn[e]}}))}));var on=n(68607);Object.keys(on).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===on[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return on[e]}}))}));var an=n(71336);Object.keys(an).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===an[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return an[e]}}))}));var sn=n(71949);Object.keys(sn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===sn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return sn[e]}}))}));var ln=n(35882);Object.keys(ln).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===ln[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return ln[e]}}))}));var cn=n(41924);Object.keys(cn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===cn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return cn[e]}}))}));var un=n(51223);Object.keys(un).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===un[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return un[e]}}))}));var dn=n(19614);Object.keys(dn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===dn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return dn[e]}}))}));var pn=n(64133);Object.keys(pn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===pn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return pn[e]}}))}));var fn=n(54546);Object.keys(fn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===fn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return fn[e]}}))}));var hn=n(49433);Object.keys(hn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===hn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return hn[e]}}))}));var mn=n(9626);Object.keys(mn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===mn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return mn[e]}}))}));var gn=n(78668);Object.keys(gn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===gn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return gn[e]}}))}));var vn=n(58791);Object.keys(vn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===vn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return vn[e]}}))}));var yn=n(15468);Object.keys(yn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===yn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return yn[e]}}))}));var bn=n(26184);Object.keys(bn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===bn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return bn[e]}}))}));var _n=n(54935);Object.keys(_n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===_n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return _n[e]}}))}));var An=n(27978);Object.keys(An).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===An[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return An[e]}}))}));var En=n(63226);Object.keys(En).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===En[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return En[e]}}))}));var wn=n(31345);Object.keys(wn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===wn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return wn[e]}}))}));var xn=n(13006);Object.keys(xn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===xn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return xn[e]}}))}));var kn=n(63549);Object.keys(kn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===kn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return kn[e]}}))}));var Cn=n(21358);Object.keys(Cn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Cn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Cn[e]}}))}));var Sn=n(83472);Object.keys(Sn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Sn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Sn[e]}}))}));var Mn=n(47131);Object.keys(Mn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Mn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Mn[e]}}))}));var Tn=n(11088);Object.keys(Tn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Tn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Tn[e]}}))}));var On=n(90396);Object.keys(On).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===On[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return On[e]}}))}));var Dn=n(23697);Object.keys(Dn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Dn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Dn[e]}}))}));var Ln=n(46367);Object.keys(Ln).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Ln[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Ln[e]}}))}));var Pn=n(38669);Object.keys(Pn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Pn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Pn[e]}}))}));var In=n(86292);Object.keys(In).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===In[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return In[e]}}))}));var Bn=n(70585);Object.keys(Bn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Bn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Bn[e]}}))}));var Rn=n(29226);Object.keys(Rn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Rn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Rn[e]}}))}));var Nn=n(97595);Object.keys(Nn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Nn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Nn[e]}}))}));var Fn=n(8423);Object.keys(Fn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Fn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Fn[e]}}))}));var jn=n(4889);Object.keys(jn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===jn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return jn[e]}}))}));var Yn=n(91493);Object.keys(Yn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Yn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Yn[e]}}))}));var $n=n(76986);Object.keys($n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===$n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return $n[e]}}))}));var Hn=n(3080);Object.keys(Hn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Hn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Hn[e]}}))}));var Un=n(43338);Object.keys(Un).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Un[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Un[e]}}))}));var zn=n(75018);Object.keys(zn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===zn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return zn[e]}}))}));var Wn=n(84375);Object.keys(Wn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Wn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Wn[e]}}))}));var Vn=n(20813);Object.keys(Vn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Vn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Vn[e]}}))}));var Gn=n(38838);Object.keys(Gn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Gn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Gn[e]}}))}));var Qn=n(72101);Object.keys(Qn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Qn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Qn[e]}}))}));var qn=n(51143);Object.keys(qn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===qn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return qn[e]}}))}));var Kn=n(44874);Object.keys(Kn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Kn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Kn[e]}}))}));var Zn=n(86431);Object.keys(Zn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Zn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Zn[e]}}))}));var Jn=n(31610);Object.keys(Jn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Jn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Jn[e]}}))}));var Xn=n(27566);Object.keys(Xn).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Xn[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Xn[e]}}))}));var er=n(80658);Object.keys(er).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===er[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return er[e]}}))}));var tr=n(4566);Object.keys(tr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===tr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return tr[e]}}))}));var nr=n(40512);Object.keys(nr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===nr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return nr[e]}}))}));var rr=n(51145);Object.keys(rr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===rr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return rr[e]}}))}));var or=n(18992);Object.keys(or).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===or[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return or[e]}}))}));var ir=n(99462);Object.keys(ir).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===ir[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return ir[e]}}))}));var ar=n(56234);Object.keys(ar).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===ar[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return ar[e]}}))}));var sr=n(39944);Object.keys(sr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===sr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return sr[e]}}))}));var lr=n(36530);Object.keys(lr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===lr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return lr[e]}}))}));var cr=n(61005);Object.keys(cr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===cr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return cr[e]}}))}));var ur=n(76594);Object.keys(ur).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===ur[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return ur[e]}}))}));var dr=n(1922);Object.keys(dr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===dr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return dr[e]}}))}));var pr=n(6559);Object.keys(pr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===pr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return pr[e]}}))}));var fr=n(79687);Object.keys(fr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===fr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return fr[e]}}))}));var hr=n(2696);Object.keys(hr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===hr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return hr[e]}}))}));var mr=n(57089);Object.keys(mr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===mr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return mr[e]}}))}));var gr=n(67572);Object.keys(gr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===gr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return gr[e]}}))}));var vr=n(79342);Object.keys(vr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===vr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return vr[e]}}))}));var yr=n(89806);Object.keys(yr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===yr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return yr[e]}}))}));var br=n(35584);Object.keys(br).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===br[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return br[e]}}))}));var _r=n(75799);Object.keys(_r).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===_r[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return _r[e]}}))}));var Ar=n(11851);Object.keys(Ar).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Ar[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Ar[e]}}))}));var Er=n(386);Object.keys(Er).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Er[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Er[e]}}))}));var wr=n(94772);Object.keys(wr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===wr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return wr[e]}}))}));var xr=n(3923);Object.keys(xr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===xr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return xr[e]}}))}));var kr=n(2352);Object.keys(kr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===kr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return kr[e]}}))}));var Cr=n(28359);Object.keys(Cr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Cr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Cr[e]}}))}));var Sr=n(40546);Object.keys(Sr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Sr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Sr[e]}}))}));var Mr=n(77640);Object.keys(Mr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Mr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Mr[e]}}))}));var Tr=n(39160);Object.keys(Tr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Tr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Tr[e]}}))}));var Or=n(7111);Object.keys(Or).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Or[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Or[e]}}))}));var Dr=n(5167);Object.keys(Dr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Dr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Dr[e]}}))}));var Lr=n(73109);Object.keys(Lr).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===Lr[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return Lr[e]}}))}))},82158:(e,t,n)=>{"use strict";t.interval=function(e,t,n){const o=(0,r.toDate)(e);if(isNaN(+o))throw new TypeError("Start date is invalid");const i=(0,r.toDate)(t);if(isNaN(+i))throw new TypeError("End date is invalid");if(n?.assertPositive&&+o>+i)throw new TypeError("End date must be after start date");return{start:o,end:i}};var r=n(40546)},83555:(e,t,n)=>{"use strict";t.intervalToDuration=function(e){const t=(0,u.toDate)(e.start),n=(0,u.toDate)(e.end),d={},p=(0,c.differenceInYears)(n,t);p&&(d.years=p);const f=(0,r.add)(t,{years:d.years}),h=(0,s.differenceInMonths)(n,f);h&&(d.months=h);const m=(0,r.add)(f,{months:d.months}),g=(0,o.differenceInDays)(n,m);g&&(d.days=g);const v=(0,r.add)(m,{days:d.days}),y=(0,i.differenceInHours)(n,v);y&&(d.hours=y);const b=(0,r.add)(v,{hours:d.hours}),_=(0,a.differenceInMinutes)(n,b);_&&(d.minutes=_);const A=(0,r.add)(b,{minutes:d.minutes}),E=(0,l.differenceInSeconds)(n,A);E&&(d.seconds=E);return d};var r=n(34932),o=n(69932),i=n(59672),a=n(29414),s=n(67872),l=n(57338),c=n(5909),u=n(40546)},75483:(e,t,n)=>{"use strict";t.intlFormat=function(e,t,n){let o;i=t,void 0===i||"locale"in i?n=t:o=t;var i;return new Intl.DateTimeFormat(n?.locale,o).format((0,r.toDate)(e))};var r=n(40546)},40764:(e,t,n)=>{"use strict";t.intlFormatDistance=function(e,t,n){let f,h=0;const m=(0,p.toDate)(e),g=(0,p.toDate)(t);if(n?.unit)f=n?.unit,"second"===f?h=(0,d.differenceInSeconds)(m,g):"minute"===f?h=(0,u.differenceInMinutes)(m,g):"hour"===f?h=(0,c.differenceInHours)(m,g):"day"===f?h=(0,o.differenceInCalendarDays)(m,g):"week"===f?h=(0,s.differenceInCalendarWeeks)(m,g):"month"===f?h=(0,i.differenceInCalendarMonths)(m,g):"quarter"===f?h=(0,a.differenceInCalendarQuarters)(m,g):"year"===f&&(h=(0,l.differenceInCalendarYears)(m,g));else{const e=(0,d.differenceInSeconds)(m,g);Math.abs(e)<r.secondsInMinute?(h=(0,d.differenceInSeconds)(m,g),f="second"):Math.abs(e)<r.secondsInHour?(h=(0,u.differenceInMinutes)(m,g),f="minute"):Math.abs(e)<r.secondsInDay&&Math.abs((0,o.differenceInCalendarDays)(m,g))<1?(h=(0,c.differenceInHours)(m,g),f="hour"):Math.abs(e)<r.secondsInWeek&&(h=(0,o.differenceInCalendarDays)(m,g))&&Math.abs(h)<7?f="day":Math.abs(e)<r.secondsInMonth?(h=(0,s.differenceInCalendarWeeks)(m,g),f="week"):Math.abs(e)<r.secondsInQuarter?(h=(0,i.differenceInCalendarMonths)(m,g),f="month"):Math.abs(e)<r.secondsInYear&&(0,a.differenceInCalendarQuarters)(m,g)<4?(h=(0,a.differenceInCalendarQuarters)(m,g),f="quarter"):(h=(0,l.differenceInCalendarYears)(m,g),f="year")}return new Intl.RelativeTimeFormat(n?.locale,{localeMatcher:n?.localeMatcher,numeric:n?.numeric||"auto",style:n?.style}).format(h,f)};var r=n(76994),o=n(80466),i=n(69022),a=n(61480),s=n(66412),l=n(13155),c=n(59672),u=n(29414),d=n(57338),p=n(40546)},40977:(e,t,n)=>{"use strict";t.isAfter=function(e,t){const n=(0,r.toDate)(e),o=(0,r.toDate)(t);return n.getTime()>o.getTime()};var r=n(40546)},34212:(e,t,n)=>{"use strict";t.isBefore=function(e,t){const n=(0,r.toDate)(e),o=(0,r.toDate)(t);return+n<+o};var r=n(40546)},92671:(e,t)=>{"use strict";t.isDate=function(e){return e instanceof Date||"object"==typeof e&&"[object Date]"===Object.prototype.toString.call(e)}},79307:(e,t,n)=>{"use strict";t.isEqual=function(e,t){const n=(0,r.toDate)(e),o=(0,r.toDate)(t);return+n==+o};var r=n(40546)},36179:(e,t)=>{"use strict";t.isExists=function(e,t,n){const r=new Date(e,t,n);return r.getFullYear()===e&&r.getMonth()===t&&r.getDate()===n}},74354:(e,t,n)=>{"use strict";t.isFirstDayOfMonth=function(e){return 1===(0,r.toDate)(e).getDate()};var r=n(40546)},81464:(e,t,n)=>{"use strict";t.isFriday=function(e){return 5===(0,r.toDate)(e).getDay()};var r=n(40546)},8944:(e,t,n)=>{"use strict";t.isFuture=function(e){return+(0,r.toDate)(e)>Date.now()};var r=n(40546)},91920:(e,t,n)=>{"use strict";t.isLastDayOfMonth=function(e){const t=(0,i.toDate)(e);return+(0,r.endOfDay)(t)==+(0,o.endOfMonth)(t)};var r=n(1841),o=n(54605),i=n(40546)},65424:(e,t,n)=>{"use strict";t.isLeapYear=function(e){const t=(0,r.toDate)(e).getFullYear();return t%400==0||t%4==0&&t%100!=0};var r=n(40546)},5870:(e,t,n)=>{"use strict";t.isMatch=function(e,t,n){return(0,r.isValid)((0,o.parse)(e,t,new Date,n))};var r=n(95609),o=n(26184)},3123:(e,t,n)=>{"use strict";t.isMonday=function(e){return 1===(0,r.toDate)(e).getDay()};var r=n(40546)},1655:(e,t,n)=>{"use strict";t.isPast=function(e){return+(0,r.toDate)(e)<Date.now()};var r=n(40546)},59655:(e,t,n)=>{"use strict";t.isSameDay=function(e,t){const n=(0,r.startOfDay)(e),o=(0,r.startOfDay)(t);return+n==+o};var r=n(80658)},78391:(e,t,n)=>{"use strict";t.isSameHour=function(e,t){const n=(0,r.startOfHour)(e),o=(0,r.startOfHour)(t);return+n==+o};var r=n(40512)},60320:(e,t,n)=>{"use strict";t.isSameISOWeek=function(e,t){return(0,r.isSameWeek)(e,t,{weekStartsOn:1})};var r=n(76105)},60161:(e,t,n)=>{"use strict";t.isSameISOWeekYear=function(e,t){const n=(0,r.startOfISOWeekYear)(e),o=(0,r.startOfISOWeekYear)(t);return+n==+o};var r=n(18992)},39361:(e,t,n)=>{"use strict";t.isSameMinute=function(e,t){const n=(0,r.startOfMinute)(e),o=(0,r.startOfMinute)(t);return+n==+o};var r=n(99462)},35627:(e,t,n)=>{"use strict";t.isSameMonth=function(e,t){const n=(0,r.toDate)(e),o=(0,r.toDate)(t);return n.getFullYear()===o.getFullYear()&&n.getMonth()===o.getMonth()};var r=n(40546)},14637:(e,t,n)=>{"use strict";t.isSameQuarter=function(e,t){const n=(0,r.startOfQuarter)(e),o=(0,r.startOfQuarter)(t);return+n==+o};var r=n(39944)},42273:(e,t,n)=>{"use strict";t.isSameSecond=function(e,t){const n=(0,r.startOfSecond)(e),o=(0,r.startOfSecond)(t);return+n==+o};var r=n(36530)},76105:(e,t,n)=>{"use strict";t.isSameWeek=function(e,t,n){const o=(0,r.startOfWeek)(e,n),i=(0,r.startOfWeek)(t,n);return+o==+i};var r=n(1922)},38892:(e,t,n)=>{"use strict";t.isSameYear=function(e,t){const n=(0,r.toDate)(e),o=(0,r.toDate)(t);return n.getFullYear()===o.getFullYear()};var r=n(40546)},60384:(e,t,n)=>{"use strict";t.isSaturday=function(e){return 6===(0,r.toDate)(e).getDay()};var r=n(40546)},70247:(e,t,n)=>{"use strict";t.isSunday=function(e){return 0===(0,r.toDate)(e).getDay()};var r=n(40546)},36401:(e,t,n)=>{"use strict";t.isThisHour=function(e){return(0,o.isSameHour)(e,(0,r.constructNow)(e))};var r=n(73536),o=n(78391)},92550:(e,t,n)=>{"use strict";t.isThisISOWeek=function(e){return(0,o.isSameISOWeek)(e,(0,r.constructNow)(e))};var r=n(73536),o=n(60320)},71583:(e,t,n)=>{"use strict";t.isThisMinute=function(e){return(0,o.isSameMinute)(e,(0,r.constructNow)(e))};var r=n(73536),o=n(39361)},21409:(e,t,n)=>{"use strict";t.isThisMonth=function(e){return(0,o.isSameMonth)(e,(0,r.constructNow)(e))};var r=n(73536),o=n(35627)},19323:(e,t,n)=>{"use strict";t.isThisQuarter=function(e){return(0,o.isSameQuarter)(e,(0,r.constructNow)(e))};var r=n(73536),o=n(14637)},52307:(e,t,n)=>{"use strict";t.isThisSecond=function(e){return(0,o.isSameSecond)(e,(0,r.constructNow)(e))};var r=n(73536),o=n(42273)},8667:(e,t,n)=>{"use strict";t.isThisWeek=function(e,t){return(0,o.isSameWeek)(e,(0,r.constructNow)(e),t)};var r=n(73536),o=n(76105)},13114:(e,t,n)=>{"use strict";t.isThisYear=function(e){return(0,o.isSameYear)(e,(0,r.constructNow)(e))};var r=n(73536),o=n(38892)},64137:(e,t,n)=>{"use strict";t.isThursday=function(e){return 4===(0,r.toDate)(e).getDay()};var r=n(40546)},60974:(e,t,n)=>{"use strict";t.isToday=function(e){return(0,o.isSameDay)(e,(0,r.constructNow)(e))};var r=n(73536),o=n(59655)},80304:(e,t,n)=>{"use strict";t.isTomorrow=function(e){return(0,i.isSameDay)(e,(0,r.addDays)((0,o.constructNow)(e),1))};var r=n(64951),o=n(73536),i=n(59655)},28136:(e,t,n)=>{"use strict";t.isTuesday=function(e){return 2===(0,r.toDate)(e).getDay()};var r=n(40546)},95609:(e,t,n)=>{"use strict";t.isValid=function(e){if(!(0,r.isDate)(e)&&"number"!=typeof e)return!1;const t=(0,o.toDate)(e);return!isNaN(Number(t))};var r=n(92671),o=n(40546)},46999:(e,t,n)=>{"use strict";t.isWednesday=function(e){return 3===(0,r.toDate)(e).getDay()};var r=n(40546)},69198:(e,t,n)=>{"use strict";t.isWeekend=function(e){const t=(0,r.toDate)(e).getDay();return 0===t||6===t};var r=n(40546)},31109:(e,t,n)=>{"use strict";t.isWithinInterval=function(e,t){const n=+(0,r.toDate)(e),[o,i]=[+(0,r.toDate)(t.start),+(0,r.toDate)(t.end)].sort(((e,t)=>e-t));return n>=o&&n<=i};var r=n(40546)},13255:(e,t,n)=>{"use strict";t.isYesterday=function(e){return(0,o.isSameDay)(e,(0,i.subDays)((0,r.constructNow)(e),1))};var r=n(73536),o=n(59655),i=n(79342)},6828:(e,t,n)=>{"use strict";t.lastDayOfDecade=function(e){const t=(0,r.toDate)(e),n=t.getFullYear(),o=9+10*Math.floor(n/10);return t.setFullYear(o+1,0,0),t.setHours(0,0,0,0),t};var r=n(40546)},57199:(e,t,n)=>{"use strict";t.lastDayOfISOWeek=function(e){return(0,r.lastDayOfWeek)(e,{weekStartsOn:1})};var r=n(84972)},2813:(e,t,n)=>{"use strict";t.lastDayOfISOWeekYear=function(e){const t=(0,r.getISOWeekYear)(e),n=(0,i.constructFrom)(e,0);n.setFullYear(t+1,0,4),n.setHours(0,0,0,0);const a=(0,o.startOfISOWeek)(n);return a.setDate(a.getDate()-1),a};var r=n(13579),o=n(51145),i=n(70722)},39064:(e,t,n)=>{"use strict";t.lastDayOfMonth=function(e){const t=(0,r.toDate)(e),n=t.getMonth();return t.setFullYear(t.getFullYear(),n+1,0),t.setHours(0,0,0,0),t};var r=n(40546)},36774:(e,t,n)=>{"use strict";t.lastDayOfQuarter=function(e){const t=(0,r.toDate)(e),n=t.getMonth(),o=n-n%3+3;return t.setMonth(o,0),t.setHours(0,0,0,0),t};var r=n(40546)},84972:(e,t,n)=>{"use strict";t.lastDayOfWeek=function(e,t){const n=(0,o.getDefaultOptions)(),i=t?.weekStartsOn??t?.locale?.options?.weekStartsOn??n.weekStartsOn??n.locale?.options?.weekStartsOn??0,a=(0,r.toDate)(e),s=a.getDay(),l=6+(s<i?-7:0)-(s-i);return a.setHours(0,0,0,0),a.setDate(a.getDate()+l),a};var r=n(40546),o=n(59567)},25733:(e,t,n)=>{"use strict";t.lastDayOfYear=function(e){const t=(0,r.toDate)(e),n=t.getFullYear();return t.setFullYear(n+1,0,0),t.setHours(0,0,0,0),t};var r=n(40546)},20032:(e,t,n)=>{"use strict";t.lightFormat=function(e,t){const n=(0,o.toDate)(e);if(!(0,r.isValid)(n))throw new RangeError("Invalid time value");const u=t.match(a);if(!u)return"";return u.map((e=>{if("''"===e)return"'";const t=e[0];if("'"===t)return function(e){const t=e.match(s);if(!t)return e;return t[1].replace(l,"'")}(e);const r=i.lightFormatters[t];if(r)return r(n,e);if(t.match(c))throw new RangeError("Format string contains an unescaped latin alphabet character `"+t+"`");return e})).join("")},Object.defineProperty(t,"lightFormatters",{enumerable:!0,get:function(){return i.lightFormatters}});var r=n(95609),o=n(40546),i=n(87193);const a=/(\w)\1*|''|'(''|[^'])+('|$)|./g,s=/^'([^]*?)'?$/,l=/''/g,c=/[a-zA-Z]/},32618:(e,t)=>{"use strict";t.buildFormatLongFn=function(e){return(t={})=>{const n=t.width?String(t.width):e.defaultWidth;return e.formats[n]||e.formats[e.defaultWidth]}}},8788:(e,t)=>{"use strict";t.buildLocalizeFn=function(e){return(t,n)=>{let r;if("formatting"===(n?.context?String(n.context):"standalone")&&e.formattingValues){const t=e.defaultFormattingWidth||e.defaultWidth,o=n?.width?String(n.width):t;r=e.formattingValues[o]||e.formattingValues[t]}else{const t=e.defaultWidth,o=n?.width?String(n.width):e.defaultWidth;r=e.values[o]||e.values[t]}return r[e.argumentCallback?e.argumentCallback(t):t]}}},14102:(e,t)=>{"use strict";t.buildMatchFn=function(e){return(t,n={})=>{const r=n.width,o=r&&e.matchPatterns[r]||e.matchPatterns[e.defaultMatchWidth],i=t.match(o);if(!i)return null;const a=i[0],s=r&&e.parsePatterns[r]||e.parsePatterns[e.defaultParseWidth],l=Array.isArray(s)?function(e,t){for(let n=0;n<e.length;n++)if(t(e[n]))return n;return}(s,(e=>e.test(a))):function(e,t){for(const n in e)if(Object.prototype.hasOwnProperty.call(e,n)&&t(e[n]))return n;return}(s,(e=>e.test(a)));let c;c=e.valueCallback?e.valueCallback(l):l,c=n.valueCallback?n.valueCallback(c):c;return{value:c,rest:t.slice(a.length)}}}},73754:(e,t)=>{"use strict";t.buildMatchPatternFn=function(e){return(t,n={})=>{const r=t.match(e.matchPattern);if(!r)return null;const o=r[0],i=t.match(e.parsePattern);if(!i)return null;let a=e.valueCallback?e.valueCallback(i[0]):i[0];a=n.valueCallback?n.valueCallback(a):a;return{value:a,rest:t.slice(o.length)}}}},71640:(e,t,n)=>{"use strict";t.enUS=void 0;var r=n(9570),o=n(40291),i=n(85629),a=n(88461),s=n(93081);t.enUS={code:"en-US",formatDistance:r.formatDistance,formatLong:o.formatLong,formatRelative:i.formatRelative,localize:a.localize,match:s.match,options:{weekStartsOn:0,firstWeekContainsDate:1}}},9570:(e,t)=>{"use strict";t.formatDistance=void 0;const n={lessThanXSeconds:{one:"less than a second",other:"less than {{count}} seconds"},xSeconds:{one:"1 second",other:"{{count}} seconds"},halfAMinute:"half a minute",lessThanXMinutes:{one:"less than a minute",other:"less than {{count}} minutes"},xMinutes:{one:"1 minute",other:"{{count}} minutes"},aboutXHours:{one:"about 1 hour",other:"about {{count}} hours"},xHours:{one:"1 hour",other:"{{count}} hours"},xDays:{one:"1 day",other:"{{count}} days"},aboutXWeeks:{one:"about 1 week",other:"about {{count}} weeks"},xWeeks:{one:"1 week",other:"{{count}} weeks"},aboutXMonths:{one:"about 1 month",other:"about {{count}} months"},xMonths:{one:"1 month",other:"{{count}} months"},aboutXYears:{one:"about 1 year",other:"about {{count}} years"},xYears:{one:"1 year",other:"{{count}} years"},overXYears:{one:"over 1 year",other:"over {{count}} years"},almostXYears:{one:"almost 1 year",other:"almost {{count}} years"}};t.formatDistance=(e,t,r)=>{let o;const i=n[e];return o="string"==typeof i?i:1===t?i.one:i.other.replace("{{count}}",t.toString()),r?.addSuffix?r.comparison&&r.comparison>0?"in "+o:o+" ago":o}},40291:(e,t,n)=>{"use strict";t.formatLong=void 0;var r=n(32618);t.formatLong={date:(0,r.buildFormatLongFn)({formats:{full:"EEEE, MMMM do, y",long:"MMMM do, y",medium:"MMM d, y",short:"MM/dd/yyyy"},defaultWidth:"full"}),time:(0,r.buildFormatLongFn)({formats:{full:"h:mm:ss a zzzz",long:"h:mm:ss a z",medium:"h:mm:ss a",short:"h:mm a"},defaultWidth:"full"}),dateTime:(0,r.buildFormatLongFn)({formats:{full:"{{date}} 'at' {{time}}",long:"{{date}} 'at' {{time}}",medium:"{{date}}, {{time}}",short:"{{date}}, {{time}}"},defaultWidth:"full"})}},85629:(e,t)=>{"use strict";t.formatRelative=void 0;const n={lastWeek:"'last' eeee 'at' p",yesterday:"'yesterday at' p",today:"'today at' p",tomorrow:"'tomorrow at' p",nextWeek:"eeee 'at' p",other:"P"};t.formatRelative=(e,t,r,o)=>n[e]},88461:(e,t,n)=>{"use strict";t.localize=void 0;var r=n(8788);t.localize={ordinalNumber:(e,t)=>{const n=Number(e),r=n%100;if(r>20||r<10)switch(r%10){case 1:return n+"st";case 2:return n+"nd";case 3:return n+"rd"}return n+"th"},era:(0,r.buildLocalizeFn)({values:{narrow:["B","A"],abbreviated:["BC","AD"],wide:["Before Christ","Anno Domini"]},defaultWidth:"wide"}),quarter:(0,r.buildLocalizeFn)({values:{narrow:["1","2","3","4"],abbreviated:["Q1","Q2","Q3","Q4"],wide:["1st quarter","2nd quarter","3rd quarter","4th quarter"]},defaultWidth:"wide",argumentCallback:e=>e-1}),month:(0,r.buildLocalizeFn)({values:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],abbreviated:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],wide:["January","February","March","April","May","June","July","August","September","October","November","December"]},defaultWidth:"wide"}),day:(0,r.buildLocalizeFn)({values:{narrow:["S","M","T","W","T","F","S"],short:["Su","Mo","Tu","We","Th","Fr","Sa"],abbreviated:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],wide:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},defaultWidth:"wide"}),dayPeriod:(0,r.buildLocalizeFn)({values:{narrow:{am:"a",pm:"p",midnight:"mi",noon:"n",morning:"morning",afternoon:"afternoon",evening:"evening",night:"night"},abbreviated:{am:"AM",pm:"PM",midnight:"midnight",noon:"noon",morning:"morning",afternoon:"afternoon",evening:"evening",night:"night"},wide:{am:"a.m.",pm:"p.m.",midnight:"midnight",noon:"noon",morning:"morning",afternoon:"afternoon",evening:"evening",night:"night"}},defaultWidth:"wide",formattingValues:{narrow:{am:"a",pm:"p",midnight:"mi",noon:"n",morning:"in the morning",afternoon:"in the afternoon",evening:"in the evening",night:"at night"},abbreviated:{am:"AM",pm:"PM",midnight:"midnight",noon:"noon",morning:"in the morning",afternoon:"in the afternoon",evening:"in the evening",night:"at night"},wide:{am:"a.m.",pm:"p.m.",midnight:"midnight",noon:"noon",morning:"in the morning",afternoon:"in the afternoon",evening:"in the evening",night:"at night"}},defaultFormattingWidth:"wide"})}},93081:(e,t,n)=>{"use strict";t.match=void 0;var r=n(14102),o=n(73754);t.match={ordinalNumber:(0,o.buildMatchPatternFn)({matchPattern:/^(\d+)(th|st|nd|rd)?/i,parsePattern:/\d+/i,valueCallback:e=>parseInt(e,10)}),era:(0,r.buildMatchFn)({matchPatterns:{narrow:/^(b|a)/i,abbreviated:/^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,wide:/^(before christ|before common era|anno domini|common era)/i},defaultMatchWidth:"wide",parsePatterns:{any:[/^b/i,/^(a|c)/i]},defaultParseWidth:"any"}),quarter:(0,r.buildMatchFn)({matchPatterns:{narrow:/^[1234]/i,abbreviated:/^q[1234]/i,wide:/^[1234](th|st|nd|rd)? quarter/i},defaultMatchWidth:"wide",parsePatterns:{any:[/1/i,/2/i,/3/i,/4/i]},defaultParseWidth:"any",valueCallback:e=>e+1}),month:(0,r.buildMatchFn)({matchPatterns:{narrow:/^[jfmasond]/i,abbreviated:/^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,wide:/^(january|february|march|april|may|june|july|august|september|october|november|december)/i},defaultMatchWidth:"wide",parsePatterns:{narrow:[/^j/i,/^f/i,/^m/i,/^a/i,/^m/i,/^j/i,/^j/i,/^a/i,/^s/i,/^o/i,/^n/i,/^d/i],any:[/^ja/i,/^f/i,/^mar/i,/^ap/i,/^may/i,/^jun/i,/^jul/i,/^au/i,/^s/i,/^o/i,/^n/i,/^d/i]},defaultParseWidth:"any"}),day:(0,r.buildMatchFn)({matchPatterns:{narrow:/^[smtwf]/i,short:/^(su|mo|tu|we|th|fr|sa)/i,abbreviated:/^(sun|mon|tue|wed|thu|fri|sat)/i,wide:/^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i},defaultMatchWidth:"wide",parsePatterns:{narrow:[/^s/i,/^m/i,/^t/i,/^w/i,/^t/i,/^f/i,/^s/i],any:[/^su/i,/^m/i,/^tu/i,/^w/i,/^th/i,/^f/i,/^sa/i]},defaultParseWidth:"any"}),dayPeriod:(0,r.buildMatchFn)({matchPatterns:{narrow:/^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,any:/^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i},defaultMatchWidth:"any",parsePatterns:{any:{am:/^a/i,pm:/^p/i,midnight:/^mi/i,noon:/^no/i,morning:/morning/i,afternoon:/afternoon/i,evening:/evening/i,night:/night/i}},defaultParseWidth:"any"})}},1346:(e,t,n)=>{"use strict";t.max=function(e){let t;return e.forEach((function(e){const n=(0,r.toDate)(e);(void 0===t||t<n||isNaN(Number(n)))&&(t=n)})),t||new Date(NaN)};var r=n(40546)},75325:(e,t,n)=>{"use strict";t.milliseconds=function({years:e,months:t,weeks:n,days:o,hours:i,minutes:a,seconds:s}){let l=0;e&&(l+=e*r.daysInYear);t&&(l+=t*(r.daysInYear/12));n&&(l+=7*n);o&&(l+=o);let c=24*l*60*60;i&&(c+=60*i*60);a&&(c+=60*a);s&&(c+=s);return Math.trunc(1e3*c)};var r=n(76994)},93569:(e,t,n)=>{"use strict";t.millisecondsToHours=function(e){const t=e/r.millisecondsInHour;return Math.trunc(t)};var r=n(76994)},19627:(e,t,n)=>{"use strict";t.millisecondsToMinutes=function(e){const t=e/r.millisecondsInMinute;return Math.trunc(t)};var r=n(76994)},84472:(e,t,n)=>{"use strict";t.millisecondsToSeconds=function(e){const t=e/r.millisecondsInSecond;return Math.trunc(t)};var r=n(76994)},68607:(e,t,n)=>{"use strict";t.min=function(e){let t;return e.forEach((e=>{const n=(0,r.toDate)(e);(!t||t>n||isNaN(+n))&&(t=n)})),t||new Date(NaN)};var r=n(40546)},71336:(e,t,n)=>{"use strict";t.minutesToHours=function(e){const t=e/r.minutesInHour;return Math.trunc(t)};var r=n(76994)},71949:(e,t,n)=>{"use strict";t.minutesToMilliseconds=function(e){return Math.trunc(e*r.millisecondsInMinute)};var r=n(76994)},35882:(e,t,n)=>{"use strict";t.minutesToSeconds=function(e){return Math.trunc(e*r.secondsInMinute)};var r=n(76994)},41924:(e,t,n)=>{"use strict";t.monthsToQuarters=function(e){const t=e/r.monthsInQuarter;return Math.trunc(t)};var r=n(76994)},51223:(e,t,n)=>{"use strict";t.monthsToYears=function(e){const t=e/r.monthsInYear;return Math.trunc(t)};var r=n(76994)},19614:(e,t,n)=>{"use strict";t.nextDay=function(e,t){let n=t-(0,o.getDay)(e);n<=0&&(n+=7);return(0,r.addDays)(e,n)};var r=n(64951),o=n(10877)},64133:(e,t,n)=>{"use strict";t.nextFriday=function(e){return(0,r.nextDay)(e,5)};var r=n(19614)},54546:(e,t,n)=>{"use strict";t.nextMonday=function(e){return(0,r.nextDay)(e,1)};var r=n(19614)},49433:(e,t,n)=>{"use strict";t.nextSaturday=function(e){return(0,r.nextDay)(e,6)};var r=n(19614)},9626:(e,t,n)=>{"use strict";t.nextSunday=function(e){return(0,r.nextDay)(e,0)};var r=n(19614)},78668:(e,t,n)=>{"use strict";t.nextThursday=function(e){return(0,r.nextDay)(e,4)};var r=n(19614)},58791:(e,t,n)=>{"use strict";t.nextTuesday=function(e){return(0,r.nextDay)(e,2)};var r=n(19614)},15468:(e,t,n)=>{"use strict";t.nextWednesday=function(e){return(0,r.nextDay)(e,3)};var r=n(19614)},26184:(e,t,n)=>{"use strict";Object.defineProperty(t,"longFormatters",{enumerable:!0,get:function(){return s.longFormatters}}),t.parse=function(e,t,n,v){const y=(0,o.getDefaultOptions)(),b=v?.locale??y.locale??i.defaultLocale,_=v?.firstWeekContainsDate??v?.locale?.options?.firstWeekContainsDate??y.firstWeekContainsDate??y.locale?.options?.firstWeekContainsDate??1,A=v?.weekStartsOn??v?.locale?.options?.weekStartsOn??y.weekStartsOn??y.locale?.options?.weekStartsOn??0;if(""===t)return""===e?(0,a.toDate)(n):(0,r.constructFrom)(n,NaN);const E={firstWeekContainsDate:_,weekStartsOn:A,locale:b},w=[new u.DateToSystemTimezoneSetter],x=t.match(p).map((e=>{const t=e[0];if(t in s.longFormatters){return(0,s.longFormatters[t])(e,b.formatLong)}return e})).join("").match(d),k=[];for(let o of x){!v?.useAdditionalWeekYearTokens&&(0,l.isProtectedWeekYearToken)(o)&&(0,l.warnOrThrowProtectedError)(o,t,e),!v?.useAdditionalDayOfYearTokens&&(0,l.isProtectedDayOfYearToken)(o)&&(0,l.warnOrThrowProtectedError)(o,t,e);const i=o[0],a=c.parsers[i];if(a){const{incompatibleTokens:t}=a;if(Array.isArray(t)){const e=k.find((e=>t.includes(e.token)||e.token===i));if(e)throw new RangeError(`The format string mustn't contain \`${e.fullToken}\` and \`${o}\` at the same time`)}else if("*"===a.incompatibleTokens&&k.length>0)throw new RangeError(`The format string mustn't contain \`${o}\` and any other token at the same time`);k.push({token:i,fullToken:o});const s=a.run(e,o,b.match,E);if(!s)return(0,r.constructFrom)(n,NaN);w.push(s.setter),e=s.rest}else{if(i.match(g))throw new RangeError("Format string contains an unescaped latin alphabet character `"+i+"`");if("''"===o?o="'":"'"===i&&(o=o.match(f)[1].replace(h,"'")),0!==e.indexOf(o))return(0,r.constructFrom)(n,NaN);e=e.slice(o.length)}}if(e.length>0&&m.test(e))return(0,r.constructFrom)(n,NaN);const C=w.map((e=>e.priority)).sort(((e,t)=>t-e)).filter(((e,t,n)=>n.indexOf(e)===t)).map((e=>w.filter((t=>t.priority===e)).sort(((e,t)=>t.subPriority-e.subPriority)))).map((e=>e[0]));let S=(0,a.toDate)(n);if(isNaN(S.getTime()))return(0,r.constructFrom)(n,NaN);const M={};for(const e of C){if(!e.validate(S,E))return(0,r.constructFrom)(n,NaN);const t=e.set(S,M,E);Array.isArray(t)?(S=t[0],Object.assign(M,t[1])):S=t}return(0,r.constructFrom)(n,S)},Object.defineProperty(t,"parsers",{enumerable:!0,get:function(){return c.parsers}});var r=n(70722),o=n(33854),i=n(51095),a=n(40546),s=n(96873),l=n(49048),c=n(41360),u=n(24593);const d=/[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,p=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,f=/^'([^]*?)'?$/,h=/''/g,m=/\S/,g=/[a-zA-Z]/},17061:(e,t,n)=>{"use strict";t.Parser=void 0;var r=n(24593);t.Parser=class{run(e,t,n,o){const i=this.parse(e,t,n,o);return i?{setter:new r.ValueSetter(i.value,this.validate,this.set,this.priority,this.subPriority),rest:i.rest}:null}validate(e,t,n){return!0}}},24593:(e,t,n)=>{"use strict";t.ValueSetter=t.Setter=t.DateToSystemTimezoneSetter=void 0;var r=n(77640),o=n(70722);class i{subPriority=0;validate(e,t){return!0}}t.Setter=i;t.ValueSetter=class extends i{constructor(e,t,n,r,o){super(),this.value=e,this.validateValue=t,this.setValue=n,this.priority=r,o&&(this.subPriority=o)}validate(e,t){return this.validateValue(e,this.value,t)}set(e,t,n){return this.setValue(e,t,this.value,n)}};t.DateToSystemTimezoneSetter=class extends i{priority=10;subPriority=-1;set(e,t){return t.timestampIsSet?e:(0,o.constructFrom)(e,(0,r.transpose)(e,Date))}}},23727:(e,t)=>{"use strict";t.timezonePatterns=t.numericPatterns=void 0;t.numericPatterns={month:/^(1[0-2]|0?\d)/,date:/^(3[0-1]|[0-2]?\d)/,dayOfYear:/^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,week:/^(5[0-3]|[0-4]?\d)/,hour23h:/^(2[0-3]|[0-1]?\d)/,hour24h:/^(2[0-4]|[0-1]?\d)/,hour11h:/^(1[0-1]|0?\d)/,hour12h:/^(1[0-2]|0?\d)/,minute:/^[0-5]?\d/,second:/^[0-5]?\d/,singleDigit:/^\d/,twoDigits:/^\d{1,2}/,threeDigits:/^\d{1,3}/,fourDigits:/^\d{1,4}/,anyDigitsSigned:/^-?\d+/,singleDigitSigned:/^-?\d/,twoDigitsSigned:/^-?\d{1,2}/,threeDigitsSigned:/^-?\d{1,3}/,fourDigitsSigned:/^-?\d{1,4}/},t.timezonePatterns={basicOptionalMinutes:/^([+-])(\d{2})(\d{2})?|Z/,basic:/^([+-])(\d{2})(\d{2})|Z/,basicOptionalSeconds:/^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,extended:/^([+-])(\d{2}):(\d{2})|Z/,extendedOptionalSeconds:/^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/}},41360:(e,t,n)=>{"use strict";t.parsers=void 0;var r=n(89450),o=n(67189),i=n(92358),a=n(70188),s=n(12568),l=n(6844),c=n(85481),u=n(94054),d=n(84183),p=n(66255),f=n(63481),h=n(83500),m=n(19766),g=n(85730),v=n(99851),y=n(45052),b=n(50217),_=n(56069),A=n(1497),E=n(31615),w=n(19083),x=n(59564),k=n(22917),C=n(58234),S=n(24880),M=n(14100),T=n(80679),O=n(35892),D=n(75098),L=n(87289),P=n(28382);t.parsers={G:new r.EraParser,y:new o.YearParser,Y:new i.LocalWeekYearParser,R:new a.ISOWeekYearParser,u:new s.ExtendedYearParser,Q:new l.QuarterParser,q:new c.StandAloneQuarterParser,M:new u.MonthParser,L:new d.StandAloneMonthParser,w:new p.LocalWeekParser,I:new f.ISOWeekParser,d:new h.DateParser,D:new m.DayOfYearParser,E:new g.DayParser,e:new v.LocalDayParser,c:new y.StandAloneLocalDayParser,i:new b.ISODayParser,a:new _.AMPMParser,b:new A.AMPMMidnightParser,B:new E.DayPeriodParser,h:new w.Hour1to12Parser,H:new x.Hour0to23Parser,K:new k.Hour0To11Parser,k:new C.Hour1To24Parser,m:new S.MinuteParser,s:new M.SecondParser,S:new T.FractionOfSecondParser,X:new O.ISOTimezoneWithZParser,x:new D.ISOTimezoneParser,t:new L.TimestampSecondsParser,T:new P.TimestampMillisecondsParser}},1497:(e,t,n)=>{"use strict";t.AMPMMidnightParser=void 0;var r=n(17061),o=n(19673);class i extends r.Parser{priority=80;parse(e,t,n){switch(t){case"b":case"bb":case"bbb":return n.dayPeriod(e,{width:"abbreviated",context:"formatting"})||n.dayPeriod(e,{width:"narrow",context:"formatting"});case"bbbbb":return n.dayPeriod(e,{width:"narrow",context:"formatting"});default:return n.dayPeriod(e,{width:"wide",context:"formatting"})||n.dayPeriod(e,{width:"abbreviated",context:"formatting"})||n.dayPeriod(e,{width:"narrow",context:"formatting"})}}set(e,t,n){return e.setHours((0,o.dayPeriodEnumToHours)(n),0,0,0),e}incompatibleTokens=["a","B","H","k","t","T"]}t.AMPMMidnightParser=i},56069:(e,t,n)=>{"use strict";t.AMPMParser=void 0;var r=n(17061),o=n(19673);class i extends r.Parser{priority=80;parse(e,t,n){switch(t){case"a":case"aa":case"aaa":return n.dayPeriod(e,{width:"abbreviated",context:"formatting"})||n.dayPeriod(e,{width:"narrow",context:"formatting"});case"aaaaa":return n.dayPeriod(e,{width:"narrow",context:"formatting"});default:return n.dayPeriod(e,{width:"wide",context:"formatting"})||n.dayPeriod(e,{width:"abbreviated",context:"formatting"})||n.dayPeriod(e,{width:"narrow",context:"formatting"})}}set(e,t,n){return e.setHours((0,o.dayPeriodEnumToHours)(n),0,0,0),e}incompatibleTokens=["b","B","H","k","t","T"]}t.AMPMParser=i},83500:(e,t,n)=>{"use strict";t.DateParser=void 0;var r=n(23727),o=n(17061),i=n(19673);const a=[31,28,31,30,31,30,31,31,30,31,30,31],s=[31,29,31,30,31,30,31,31,30,31,30,31];class l extends o.Parser{priority=90;subPriority=1;parse(e,t,n){switch(t){case"d":return(0,i.parseNumericPattern)(r.numericPatterns.date,e);case"do":return n.ordinalNumber(e,{unit:"date"});default:return(0,i.parseNDigits)(t.length,e)}}validate(e,t){const n=e.getFullYear(),r=(0,i.isLeapYearIndex)(n),o=e.getMonth();return r?t>=1&&t<=s[o]:t>=1&&t<=a[o]}set(e,t,n){return e.setDate(n),e.setHours(0,0,0,0),e}incompatibleTokens=["Y","R","q","Q","w","I","D","i","e","c","t","T"]}t.DateParser=l},19766:(e,t,n)=>{"use strict";t.DayOfYearParser=void 0;var r=n(23727),o=n(17061),i=n(19673);class a extends o.Parser{priority=90;subpriority=1;parse(e,t,n){switch(t){case"D":case"DD":return(0,i.parseNumericPattern)(r.numericPatterns.dayOfYear,e);case"Do":return n.ordinalNumber(e,{unit:"date"});default:return(0,i.parseNDigits)(t.length,e)}}validate(e,t){const n=e.getFullYear();return(0,i.isLeapYearIndex)(n)?t>=1&&t<=366:t>=1&&t<=365}set(e,t,n){return e.setMonth(0,n),e.setHours(0,0,0,0),e}incompatibleTokens=["Y","R","q","Q","M","L","w","I","d","E","i","e","c","t","T"]}t.DayOfYearParser=a},85730:(e,t,n)=>{"use strict";t.DayParser=void 0;var r=n(4889),o=n(17061);class i extends o.Parser{priority=90;parse(e,t,n){switch(t){case"E":case"EE":case"EEE":return n.day(e,{width:"abbreviated",context:"formatting"})||n.day(e,{width:"short",context:"formatting"})||n.day(e,{width:"narrow",context:"formatting"});case"EEEEE":return n.day(e,{width:"narrow",context:"formatting"});case"EEEEEE":return n.day(e,{width:"short",context:"formatting"})||n.day(e,{width:"narrow",context:"formatting"});default:return n.day(e,{width:"wide",context:"formatting"})||n.day(e,{width:"abbreviated",context:"formatting"})||n.day(e,{width:"short",context:"formatting"})||n.day(e,{width:"narrow",context:"formatting"})}}validate(e,t){return t>=0&&t<=6}set(e,t,n,o){return(e=(0,r.setDay)(e,n,o)).setHours(0,0,0,0),e}incompatibleTokens=["D","i","e","c","t","T"]}t.DayParser=i},31615:(e,t,n)=>{"use strict";t.DayPeriodParser=void 0;var r=n(17061),o=n(19673);class i extends r.Parser{priority=80;parse(e,t,n){switch(t){case"B":case"BB":case"BBB":return n.dayPeriod(e,{width:"abbreviated",context:"formatting"})||n.dayPeriod(e,{width:"narrow",context:"formatting"});case"BBBBB":return n.dayPeriod(e,{width:"narrow",context:"formatting"});default:return n.dayPeriod(e,{width:"wide",context:"formatting"})||n.dayPeriod(e,{width:"abbreviated",context:"formatting"})||n.dayPeriod(e,{width:"narrow",context:"formatting"})}}set(e,t,n){return e.setHours((0,o.dayPeriodEnumToHours)(n),0,0,0),e}incompatibleTokens=["a","b","t","T"]}t.DayPeriodParser=i},89450:(e,t,n)=>{"use strict";t.EraParser=void 0;var r=n(17061);class o extends r.Parser{priority=140;parse(e,t,n){switch(t){case"G":case"GG":case"GGG":return n.era(e,{width:"abbreviated"})||n.era(e,{width:"narrow"});case"GGGGG":return n.era(e,{width:"narrow"});default:return n.era(e,{width:"wide"})||n.era(e,{width:"abbreviated"})||n.era(e,{width:"narrow"})}}set(e,t,n){return t.era=n,e.setFullYear(n,0,1),e.setHours(0,0,0,0),e}incompatibleTokens=["R","u","t","T"]}t.EraParser=o},12568:(e,t,n)=>{"use strict";t.ExtendedYearParser=void 0;var r=n(17061),o=n(19673);class i extends r.Parser{priority=130;parse(e,t){return"u"===t?(0,o.parseNDigitsSigned)(4,e):(0,o.parseNDigitsSigned)(t.length,e)}set(e,t,n){return e.setFullYear(n,0,1),e.setHours(0,0,0,0),e}incompatibleTokens=["G","y","Y","R","w","I","i","e","c","t","T"]}t.ExtendedYearParser=i},80679:(e,t,n)=>{"use strict";t.FractionOfSecondParser=void 0;var r=n(17061),o=n(19673);class i extends r.Parser{priority=30;parse(e,t){return(0,o.mapValue)((0,o.parseNDigits)(t.length,e),(e=>Math.trunc(e*Math.pow(10,3-t.length))))}set(e,t,n){return e.setMilliseconds(n),e}incompatibleTokens=["t","T"]}t.FractionOfSecondParser=i},22917:(e,t,n)=>{"use strict";t.Hour0To11Parser=void 0;var r=n(23727),o=n(17061),i=n(19673);class a extends o.Parser{priority=70;parse(e,t,n){switch(t){case"K":return(0,i.parseNumericPattern)(r.numericPatterns.hour11h,e);case"Ko":return n.ordinalNumber(e,{unit:"hour"});default:return(0,i.parseNDigits)(t.length,e)}}validate(e,t){return t>=0&&t<=11}set(e,t,n){return e.getHours()>=12&&n<12?e.setHours(n+12,0,0,0):e.setHours(n,0,0,0),e}incompatibleTokens=["h","H","k","t","T"]}t.Hour0To11Parser=a},59564:(e,t,n)=>{"use strict";t.Hour0to23Parser=void 0;var r=n(23727),o=n(17061),i=n(19673);class a extends o.Parser{priority=70;parse(e,t,n){switch(t){case"H":return(0,i.parseNumericPattern)(r.numericPatterns.hour23h,e);case"Ho":return n.ordinalNumber(e,{unit:"hour"});default:return(0,i.parseNDigits)(t.length,e)}}validate(e,t){return t>=0&&t<=23}set(e,t,n){return e.setHours(n,0,0,0),e}incompatibleTokens=["a","b","h","K","k","t","T"]}t.Hour0to23Parser=a},58234:(e,t,n)=>{"use strict";t.Hour1To24Parser=void 0;var r=n(23727),o=n(17061),i=n(19673);class a extends o.Parser{priority=70;parse(e,t,n){switch(t){case"k":return(0,i.parseNumericPattern)(r.numericPatterns.hour24h,e);case"ko":return n.ordinalNumber(e,{unit:"hour"});default:return(0,i.parseNDigits)(t.length,e)}}validate(e,t){return t>=1&&t<=24}set(e,t,n){const r=n<=24?n%24:n;return e.setHours(r,0,0,0),e}incompatibleTokens=["a","b","h","H","K","t","T"]}t.Hour1To24Parser=a},19083:(e,t,n)=>{"use strict";t.Hour1to12Parser=void 0;var r=n(23727),o=n(17061),i=n(19673);class a extends o.Parser{priority=70;parse(e,t,n){switch(t){case"h":return(0,i.parseNumericPattern)(r.numericPatterns.hour12h,e);case"ho":return n.ordinalNumber(e,{unit:"hour"});default:return(0,i.parseNDigits)(t.length,e)}}validate(e,t){return t>=1&&t<=12}set(e,t,n){const r=e.getHours()>=12;return r&&n<12?e.setHours(n+12,0,0,0):r||12!==n?e.setHours(n,0,0,0):e.setHours(0,0,0,0),e}incompatibleTokens=["H","K","k","t","T"]}t.Hour1to12Parser=a},50217:(e,t,n)=>{"use strict";t.ISODayParser=void 0;var r=n(43338),o=n(17061),i=n(19673);class a extends o.Parser{priority=90;parse(e,t,n){const r=e=>0===e?7:e;switch(t){case"i":case"ii":return(0,i.parseNDigits)(t.length,e);case"io":return n.ordinalNumber(e,{unit:"day"});case"iii":return(0,i.mapValue)(n.day(e,{width:"abbreviated",context:"formatting"})||n.day(e,{width:"short",context:"formatting"})||n.day(e,{width:"narrow",context:"formatting"}),r);case"iiiii":return(0,i.mapValue)(n.day(e,{width:"narrow",context:"formatting"}),r);case"iiiiii":return(0,i.mapValue)(n.day(e,{width:"short",context:"formatting"})||n.day(e,{width:"narrow",context:"formatting"}),r);default:return(0,i.mapValue)(n.day(e,{width:"wide",context:"formatting"})||n.day(e,{width:"abbreviated",context:"formatting"})||n.day(e,{width:"short",context:"formatting"})||n.day(e,{width:"narrow",context:"formatting"}),r)}}validate(e,t){return t>=1&&t<=7}set(e,t,n){return(e=(0,r.setISODay)(e,n)).setHours(0,0,0,0),e}incompatibleTokens=["y","Y","u","q","Q","M","L","w","d","D","E","e","c","t","T"]}t.ISODayParser=a},75098:(e,t,n)=>{"use strict";t.ISOTimezoneParser=void 0;var r=n(70722),o=n(73121),i=n(23727),a=n(17061),s=n(19673);class l extends a.Parser{priority=10;parse(e,t){switch(t){case"x":return(0,s.parseTimezonePattern)(i.timezonePatterns.basicOptionalMinutes,e);case"xx":return(0,s.parseTimezonePattern)(i.timezonePatterns.basic,e);case"xxxx":return(0,s.parseTimezonePattern)(i.timezonePatterns.basicOptionalSeconds,e);case"xxxxx":return(0,s.parseTimezonePattern)(i.timezonePatterns.extendedOptionalSeconds,e);default:return(0,s.parseTimezonePattern)(i.timezonePatterns.extended,e)}}set(e,t,n){return t.timestampIsSet?e:(0,r.constructFrom)(e,e.getTime()-(0,o.getTimezoneOffsetInMilliseconds)(e)-n)}incompatibleTokens=["t","T","X"]}t.ISOTimezoneParser=l},35892:(e,t,n)=>{"use strict";t.ISOTimezoneWithZParser=void 0;var r=n(70722),o=n(73121),i=n(23727),a=n(17061),s=n(19673);class l extends a.Parser{priority=10;parse(e,t){switch(t){case"X":return(0,s.parseTimezonePattern)(i.timezonePatterns.basicOptionalMinutes,e);case"XX":return(0,s.parseTimezonePattern)(i.timezonePatterns.basic,e);case"XXXX":return(0,s.parseTimezonePattern)(i.timezonePatterns.basicOptionalSeconds,e);case"XXXXX":return(0,s.parseTimezonePattern)(i.timezonePatterns.extendedOptionalSeconds,e);default:return(0,s.parseTimezonePattern)(i.timezonePatterns.extended,e)}}set(e,t,n){return t.timestampIsSet?e:(0,r.constructFrom)(e,e.getTime()-(0,o.getTimezoneOffsetInMilliseconds)(e)-n)}incompatibleTokens=["t","T","x"]}t.ISOTimezoneWithZParser=l},63481:(e,t,n)=>{"use strict";t.ISOWeekParser=void 0;var r=n(75018),o=n(51145),i=n(23727),a=n(17061),s=n(19673);class l extends a.Parser{priority=100;parse(e,t,n){switch(t){case"I":return(0,s.parseNumericPattern)(i.numericPatterns.week,e);case"Io":return n.ordinalNumber(e,{unit:"week"});default:return(0,s.parseNDigits)(t.length,e)}}validate(e,t){return t>=1&&t<=53}set(e,t,n){return(0,o.startOfISOWeek)((0,r.setISOWeek)(e,n))}incompatibleTokens=["y","Y","u","q","Q","M","L","w","d","D","e","c","t","T"]}t.ISOWeekParser=l},70188:(e,t,n)=>{"use strict";t.ISOWeekYearParser=void 0;var r=n(51145),o=n(70722),i=n(17061),a=n(19673);class s extends i.Parser{priority=130;parse(e,t){return"R"===t?(0,a.parseNDigitsSigned)(4,e):(0,a.parseNDigitsSigned)(t.length,e)}set(e,t,n){const i=(0,o.constructFrom)(e,0);return i.setFullYear(n,0,4),i.setHours(0,0,0,0),(0,r.startOfISOWeek)(i)}incompatibleTokens=["G","y","Y","u","Q","q","M","L","w","d","D","e","c","t","T"]}t.ISOWeekYearParser=s},99851:(e,t,n)=>{"use strict";t.LocalDayParser=void 0;var r=n(4889),o=n(17061),i=n(19673);class a extends o.Parser{priority=90;parse(e,t,n,r){const o=e=>{const t=7*Math.floor((e-1)/7);return(e+r.weekStartsOn+6)%7+t};switch(t){case"e":case"ee":return(0,i.mapValue)((0,i.parseNDigits)(t.length,e),o);case"eo":return(0,i.mapValue)(n.ordinalNumber(e,{unit:"day"}),o);case"eee":return n.day(e,{width:"abbreviated",context:"formatting"})||n.day(e,{width:"short",context:"formatting"})||n.day(e,{width:"narrow",context:"formatting"});case"eeeee":return n.day(e,{width:"narrow",context:"formatting"});case"eeeeee":return n.day(e,{width:"short",context:"formatting"})||n.day(e,{width:"narrow",context:"formatting"});default:return n.day(e,{width:"wide",context:"formatting"})||n.day(e,{width:"abbreviated",context:"formatting"})||n.day(e,{width:"short",context:"formatting"})||n.day(e,{width:"narrow",context:"formatting"})}}validate(e,t){return t>=0&&t<=6}set(e,t,n,o){return(e=(0,r.setDay)(e,n,o)).setHours(0,0,0,0),e}incompatibleTokens=["y","R","u","q","Q","M","L","I","d","D","E","i","c","t","T"]}t.LocalDayParser=a},66255:(e,t,n)=>{"use strict";t.LocalWeekParser=void 0;var r=n(86431),o=n(1922),i=n(23727),a=n(17061),s=n(19673);class l extends a.Parser{priority=100;parse(e,t,n){switch(t){case"w":return(0,s.parseNumericPattern)(i.numericPatterns.week,e);case"wo":return n.ordinalNumber(e,{unit:"week"});default:return(0,s.parseNDigits)(t.length,e)}}validate(e,t){return t>=1&&t<=53}set(e,t,n,i){return(0,o.startOfWeek)((0,r.setWeek)(e,n,i),i)}incompatibleTokens=["y","R","u","q","Q","M","L","I","d","D","i","t","T"]}t.LocalWeekParser=l},92358:(e,t,n)=>{"use strict";t.LocalWeekYearParser=void 0;var r=n(43918),o=n(1922),i=n(17061),a=n(19673);class s extends i.Parser{priority=130;parse(e,t,n){const r=e=>({year:e,isTwoDigitYear:"YY"===t});switch(t){case"Y":return(0,a.mapValue)((0,a.parseNDigits)(4,e),r);case"Yo":return(0,a.mapValue)(n.ordinalNumber(e,{unit:"year"}),r);default:return(0,a.mapValue)((0,a.parseNDigits)(t.length,e),r)}}validate(e,t){return t.isTwoDigitYear||t.year>0}set(e,t,n,i){const s=(0,r.getWeekYear)(e,i);if(n.isTwoDigitYear){const t=(0,a.normalizeTwoDigitYear)(n.year,s);return e.setFullYear(t,0,i.firstWeekContainsDate),e.setHours(0,0,0,0),(0,o.startOfWeek)(e,i)}const l="era"in t&&1!==t.era?1-n.year:n.year;return e.setFullYear(l,0,i.firstWeekContainsDate),e.setHours(0,0,0,0),(0,o.startOfWeek)(e,i)}incompatibleTokens=["y","R","u","Q","q","M","L","I","d","D","i","t","T"]}t.LocalWeekYearParser=s},24880:(e,t,n)=>{"use strict";t.MinuteParser=void 0;var r=n(23727),o=n(17061),i=n(19673);class a extends o.Parser{priority=60;parse(e,t,n){switch(t){case"m":return(0,i.parseNumericPattern)(r.numericPatterns.minute,e);case"mo":return n.ordinalNumber(e,{unit:"minute"});default:return(0,i.parseNDigits)(t.length,e)}}validate(e,t){return t>=0&&t<=59}set(e,t,n){return e.setMinutes(n,0,0),e}incompatibleTokens=["t","T"]}t.MinuteParser=a},94054:(e,t,n)=>{"use strict";t.MonthParser=void 0;var r=n(23727),o=n(17061),i=n(19673);class a extends o.Parser{incompatibleTokens=["Y","R","q","Q","L","w","I","D","i","e","c","t","T"];priority=110;parse(e,t,n){const o=e=>e-1;switch(t){case"M":return(0,i.mapValue)((0,i.parseNumericPattern)(r.numericPatterns.month,e),o);case"MM":return(0,i.mapValue)((0,i.parseNDigits)(2,e),o);case"Mo":return(0,i.mapValue)(n.ordinalNumber(e,{unit:"month"}),o);case"MMM":return n.month(e,{width:"abbreviated",context:"formatting"})||n.month(e,{width:"narrow",context:"formatting"});case"MMMMM":return n.month(e,{width:"narrow",context:"formatting"});default:return n.month(e,{width:"wide",context:"formatting"})||n.month(e,{width:"abbreviated",context:"formatting"})||n.month(e,{width:"narrow",context:"formatting"})}}validate(e,t){return t>=0&&t<=11}set(e,t,n){return e.setMonth(n,1),e.setHours(0,0,0,0),e}}t.MonthParser=a},6844:(e,t,n)=>{"use strict";t.QuarterParser=void 0;var r=n(17061),o=n(19673);class i extends r.Parser{priority=120;parse(e,t,n){switch(t){case"Q":case"QQ":return(0,o.parseNDigits)(t.length,e);case"Qo":return n.ordinalNumber(e,{unit:"quarter"});case"QQQ":return n.quarter(e,{width:"abbreviated",context:"formatting"})||n.quarter(e,{width:"narrow",context:"formatting"});case"QQQQQ":return n.quarter(e,{width:"narrow",context:"formatting"});default:return n.quarter(e,{width:"wide",context:"formatting"})||n.quarter(e,{width:"abbreviated",context:"formatting"})||n.quarter(e,{width:"narrow",context:"formatting"})}}validate(e,t){return t>=1&&t<=4}set(e,t,n){return e.setMonth(3*(n-1),1),e.setHours(0,0,0,0),e}incompatibleTokens=["Y","R","q","M","L","w","I","d","D","i","e","c","t","T"]}t.QuarterParser=i},14100:(e,t,n)=>{"use strict";t.SecondParser=void 0;var r=n(23727),o=n(17061),i=n(19673);class a extends o.Parser{priority=50;parse(e,t,n){switch(t){case"s":return(0,i.parseNumericPattern)(r.numericPatterns.second,e);case"so":return n.ordinalNumber(e,{unit:"second"});default:return(0,i.parseNDigits)(t.length,e)}}validate(e,t){return t>=0&&t<=59}set(e,t,n){return e.setSeconds(n,0),e}incompatibleTokens=["t","T"]}t.SecondParser=a},45052:(e,t,n)=>{"use strict";t.StandAloneLocalDayParser=void 0;var r=n(4889),o=n(17061),i=n(19673);class a extends o.Parser{priority=90;parse(e,t,n,r){const o=e=>{const t=7*Math.floor((e-1)/7);return(e+r.weekStartsOn+6)%7+t};switch(t){case"c":case"cc":return(0,i.mapValue)((0,i.parseNDigits)(t.length,e),o);case"co":return(0,i.mapValue)(n.ordinalNumber(e,{unit:"day"}),o);case"ccc":return n.day(e,{width:"abbreviated",context:"standalone"})||n.day(e,{width:"short",context:"standalone"})||n.day(e,{width:"narrow",context:"standalone"});case"ccccc":return n.day(e,{width:"narrow",context:"standalone"});case"cccccc":return n.day(e,{width:"short",context:"standalone"})||n.day(e,{width:"narrow",context:"standalone"});default:return n.day(e,{width:"wide",context:"standalone"})||n.day(e,{width:"abbreviated",context:"standalone"})||n.day(e,{width:"short",context:"standalone"})||n.day(e,{width:"narrow",context:"standalone"})}}validate(e,t){return t>=0&&t<=6}set(e,t,n,o){return(e=(0,r.setDay)(e,n,o)).setHours(0,0,0,0),e}incompatibleTokens=["y","R","u","q","Q","M","L","I","d","D","E","i","e","t","T"]}t.StandAloneLocalDayParser=a},84183:(e,t,n)=>{"use strict";t.StandAloneMonthParser=void 0;var r=n(23727),o=n(17061),i=n(19673);class a extends o.Parser{priority=110;parse(e,t,n){const o=e=>e-1;switch(t){case"L":return(0,i.mapValue)((0,i.parseNumericPattern)(r.numericPatterns.month,e),o);case"LL":return(0,i.mapValue)((0,i.parseNDigits)(2,e),o);case"Lo":return(0,i.mapValue)(n.ordinalNumber(e,{unit:"month"}),o);case"LLL":return n.month(e,{width:"abbreviated",context:"standalone"})||n.month(e,{width:"narrow",context:"standalone"});case"LLLLL":return n.month(e,{width:"narrow",context:"standalone"});default:return n.month(e,{width:"wide",context:"standalone"})||n.month(e,{width:"abbreviated",context:"standalone"})||n.month(e,{width:"narrow",context:"standalone"})}}validate(e,t){return t>=0&&t<=11}set(e,t,n){return e.setMonth(n,1),e.setHours(0,0,0,0),e}incompatibleTokens=["Y","R","q","Q","M","w","I","D","i","e","c","t","T"]}t.StandAloneMonthParser=a},85481:(e,t,n)=>{"use strict";t.StandAloneQuarterParser=void 0;var r=n(17061),o=n(19673);class i extends r.Parser{priority=120;parse(e,t,n){switch(t){case"q":case"qq":return(0,o.parseNDigits)(t.length,e);case"qo":return n.ordinalNumber(e,{unit:"quarter"});case"qqq":return n.quarter(e,{width:"abbreviated",context:"standalone"})||n.quarter(e,{width:"narrow",context:"standalone"});case"qqqqq":return n.quarter(e,{width:"narrow",context:"standalone"});default:return n.quarter(e,{width:"wide",context:"standalone"})||n.quarter(e,{width:"abbreviated",context:"standalone"})||n.quarter(e,{width:"narrow",context:"standalone"})}}validate(e,t){return t>=1&&t<=4}set(e,t,n){return e.setMonth(3*(n-1),1),e.setHours(0,0,0,0),e}incompatibleTokens=["Y","R","Q","M","L","w","I","d","D","i","e","c","t","T"]}t.StandAloneQuarterParser=i},28382:(e,t,n)=>{"use strict";t.TimestampMillisecondsParser=void 0;var r=n(70722),o=n(17061),i=n(19673);class a extends o.Parser{priority=20;parse(e){return(0,i.parseAnyDigitsSigned)(e)}set(e,t,n){return[(0,r.constructFrom)(e,n),{timestampIsSet:!0}]}incompatibleTokens="*"}t.TimestampMillisecondsParser=a},87289:(e,t,n)=>{"use strict";t.TimestampSecondsParser=void 0;var r=n(70722),o=n(17061),i=n(19673);class a extends o.Parser{priority=40;parse(e){return(0,i.parseAnyDigitsSigned)(e)}set(e,t,n){return[(0,r.constructFrom)(e,1e3*n),{timestampIsSet:!0}]}incompatibleTokens="*"}t.TimestampSecondsParser=a},67189:(e,t,n)=>{"use strict";t.YearParser=void 0;var r=n(17061),o=n(19673);class i extends r.Parser{priority=130;incompatibleTokens=["Y","R","u","w","I","i","e","c","t","T"];parse(e,t,n){const r=e=>({year:e,isTwoDigitYear:"yy"===t});switch(t){case"y":return(0,o.mapValue)((0,o.parseNDigits)(4,e),r);case"yo":return(0,o.mapValue)(n.ordinalNumber(e,{unit:"year"}),r);default:return(0,o.mapValue)((0,o.parseNDigits)(t.length,e),r)}}validate(e,t){return t.isTwoDigitYear||t.year>0}set(e,t,n){const r=e.getFullYear();if(n.isTwoDigitYear){const t=(0,o.normalizeTwoDigitYear)(n.year,r);return e.setFullYear(t,0,1),e.setHours(0,0,0,0),e}const i="era"in t&&1!==t.era?1-n.year:n.year;return e.setFullYear(i,0,1),e.setHours(0,0,0,0),e}}t.YearParser=i},19673:(e,t,n)=>{"use strict";t.dayPeriodEnumToHours=function(e){switch(e){case"morning":return 4;case"evening":return 17;case"pm":case"noon":case"afternoon":return 12;default:return 0}},t.isLeapYearIndex=function(e){return e%400==0||e%4==0&&e%100!=0},t.mapValue=function(e,t){if(!e)return e;return{value:t(e.value),rest:e.rest}},t.normalizeTwoDigitYear=function(e,t){const n=t>0,r=n?t:1-t;let o;if(r<=50)o=e||100;else{const t=r+50;o=e+100*Math.trunc(t/100)-(e>=t%100?100:0)}return n?o:1-o},t.parseAnyDigitsSigned=function(e){return i(o.numericPatterns.anyDigitsSigned,e)},t.parseNDigits=function(e,t){switch(e){case 1:return i(o.numericPatterns.singleDigit,t);case 2:return i(o.numericPatterns.twoDigits,t);case 3:return i(o.numericPatterns.threeDigits,t);case 4:return i(o.numericPatterns.fourDigits,t);default:return i(new RegExp("^\\d{1,"+e+"}"),t)}},t.parseNDigitsSigned=function(e,t){switch(e){case 1:return i(o.numericPatterns.singleDigitSigned,t);case 2:return i(o.numericPatterns.twoDigitsSigned,t);case 3:return i(o.numericPatterns.threeDigitsSigned,t);case 4:return i(o.numericPatterns.fourDigitsSigned,t);default:return i(new RegExp("^-?\\d{1,"+e+"}"),t)}},t.parseNumericPattern=i,t.parseTimezonePattern=function(e,t){const n=t.match(e);if(!n)return null;if("Z"===n[0])return{value:0,rest:t.slice(1)};const o="+"===n[1]?1:-1,i=n[2]?parseInt(n[2],10):0,a=n[3]?parseInt(n[3],10):0,s=n[5]?parseInt(n[5],10):0;return{value:o*(i*r.millisecondsInHour+a*r.millisecondsInMinute+s*r.millisecondsInSecond),rest:t.slice(n[0].length)}};var r=n(76994),o=n(23727);function i(e,t){const n=t.match(e);return n?{value:parseInt(n[0],10),rest:t.slice(n[0].length)}:null}},54935:(e,t,n)=>{"use strict";t.parseISO=function(e,t){const n=t?.additionalDigits??2,p=function(e){const t={},n=e.split(o.dateTimeDelimiter);let r;if(n.length>2)return t;/:/.test(n[0])?r=n[0]:(t.date=n[0],r=n[1],o.timeZoneDelimiter.test(t.date)&&(t.date=e.split(o.timeZoneDelimiter)[0],r=e.substr(t.date.length,e.length)));if(r){const e=o.timezone.exec(r);e?(t.time=r.replace(e[1],""),t.timezone=e[1]):t.time=r}return t}(e);let f;if(p.date){const e=function(e,t){const n=new RegExp("^(?:(\\d{4}|[+-]\\d{"+(4+t)+"})|(\\d{2}|[+-]\\d{"+(2+t)+"})$)"),r=e.match(n);if(!r)return{year:NaN,restDateString:""};const o=r[1]?parseInt(r[1]):null,i=r[2]?parseInt(r[2]):null;return{year:null===i?o:100*i,restDateString:e.slice((r[1]||r[2]).length)}}(p.date,n);f=function(e,t){if(null===t)return new Date(NaN);const n=e.match(i);if(!n)return new Date(NaN);const r=!!n[4],o=l(n[1]),a=l(n[2])-1,s=l(n[3]),c=l(n[4]),p=l(n[5])-1;if(r)return function(e,t,n){return t>=1&&t<=53&&n>=0&&n<=6}(0,c,p)?function(e,t,n){const r=new Date(0);r.setUTCFullYear(e,0,4);const o=r.getUTCDay()||7,i=7*(t-1)+n+1-o;return r.setUTCDate(r.getUTCDate()+i),r}(t,c,p):new Date(NaN);{const e=new Date(0);return function(e,t,n){return t>=0&&t<=11&&n>=1&&n<=(u[t]||(d(e)?29:28))}(t,a,s)&&function(e,t){return t>=1&&t<=(d(e)?366:365)}(t,o)?(e.setUTCFullYear(t,a,Math.max(o,s)),e):new Date(NaN)}}(e.restDateString,e.year)}if(!f||isNaN(f.getTime()))return new Date(NaN);const h=f.getTime();let m,g=0;if(p.time&&(g=function(e){const t=e.match(a);if(!t)return NaN;const n=c(t[1]),o=c(t[2]),i=c(t[3]);if(!function(e,t,n){if(24===e)return 0===t&&0===n;return n>=0&&n<60&&t>=0&&t<60&&e>=0&&e<25}(n,o,i))return NaN;return n*r.millisecondsInHour+o*r.millisecondsInMinute+1e3*i}(p.time),isNaN(g)))return new Date(NaN);if(!p.timezone){const e=new Date(h+g),t=new Date(0);return t.setFullYear(e.getUTCFullYear(),e.getUTCMonth(),e.getUTCDate()),t.setHours(e.getUTCHours(),e.getUTCMinutes(),e.getUTCSeconds(),e.getUTCMilliseconds()),t}if(m=function(e){if("Z"===e)return 0;const t=e.match(s);if(!t)return 0;const n="+"===t[1]?-1:1,o=parseInt(t[2]),i=t[3]&&parseInt(t[3])||0;if(!function(e,t){return t>=0&&t<=59}(0,i))return NaN;return n*(o*r.millisecondsInHour+i*r.millisecondsInMinute)}(p.timezone),isNaN(m))return new Date(NaN);return new Date(h+g+m)};var r=n(76994);const o={dateTimeDelimiter:/[T ]/,timeZoneDelimiter:/[Z ]/i,timezone:/([Z+-].*)$/},i=/^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/,a=/^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/,s=/^([+-])(\d{2})(?::?(\d{2}))?$/;function l(e){return e?parseInt(e):1}function c(e){return e&&parseFloat(e.replace(",","."))||0}const u=[31,null,31,30,31,30,31,31,30,31,30,31];function d(e){return e%400==0||e%4==0&&e%100!=0}},27978:(e,t)=>{"use strict";t.parseJSON=function(e){const t=e.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);if(t)return new Date(Date.UTC(+t[1],+t[2]-1,+t[3],+t[4]-(+t[9]||0)*("-"==t[8]?-1:1),+t[5]-(+t[10]||0)*("-"==t[8]?-1:1),+t[6],+((t[7]||"0")+"00").substring(0,3)));return new Date(NaN)}},63226:(e,t,n)=>{"use strict";t.previousDay=function(e,t){let n=(0,r.getDay)(e)-t;n<=0&&(n+=7);return(0,o.subDays)(e,n)};var r=n(10877),o=n(79342)},31345:(e,t,n)=>{"use strict";t.previousFriday=function(e){return(0,r.previousDay)(e,5)};var r=n(63226)},13006:(e,t,n)=>{"use strict";t.previousMonday=function(e){return(0,r.previousDay)(e,1)};var r=n(63226)},63549:(e,t,n)=>{"use strict";t.previousSaturday=function(e){return(0,r.previousDay)(e,6)};var r=n(63226)},21358:(e,t,n)=>{"use strict";t.previousSunday=function(e){return(0,r.previousDay)(e,0)};var r=n(63226)},83472:(e,t,n)=>{"use strict";t.previousThursday=function(e){return(0,r.previousDay)(e,4)};var r=n(63226)},47131:(e,t,n)=>{"use strict";t.previousTuesday=function(e){return(0,r.previousDay)(e,2)};var r=n(63226)},11088:(e,t,n)=>{"use strict";t.previousWednesday=function(e){return(0,r.previousDay)(e,3)};var r=n(63226)},90396:(e,t,n)=>{"use strict";t.quartersToMonths=function(e){return Math.trunc(e*r.monthsInQuarter)};var r=n(76994)},23697:(e,t,n)=>{"use strict";t.quartersToYears=function(e){const t=e/r.quartersInYear;return Math.trunc(t)};var r=n(76994)},46367:(e,t,n)=>{"use strict";t.roundToNearestHours=function(e,t){const n=t?.nearestTo??1;if(n<1||n>12)return(0,o.constructFrom)(e,NaN);const a=(0,i.toDate)(e),s=a.getMinutes()/60,l=a.getSeconds()/60/60,c=a.getMilliseconds()/1e3/60/60,u=a.getHours()+s+l+c,d=t?.roundingMethod??"round",p=(0,r.getRoundingMethod)(d)(u/n)*n,f=(0,o.constructFrom)(e,a);return f.setHours(p,0,0,0),f};var r=n(58277),o=n(70722),i=n(40546)},38669:(e,t,n)=>{"use strict";t.roundToNearestMinutes=function(e,t){const n=t?.nearestTo??1;if(n<1||n>30)return(0,o.constructFrom)(e,NaN);const a=(0,i.toDate)(e),s=a.getSeconds()/60,l=a.getMilliseconds()/1e3/60,c=a.getMinutes()+s+l,u=t?.roundingMethod??"round",d=(0,r.getRoundingMethod)(u)(c/n)*n,p=(0,o.constructFrom)(e,a);return p.setMinutes(d,0,0),p};var r=n(58277),o=n(70722),i=n(40546)},86292:(e,t,n)=>{"use strict";t.secondsToHours=function(e){const t=e/r.secondsInHour;return Math.trunc(t)};var r=n(76994)},70585:(e,t,n)=>{"use strict";t.secondsToMilliseconds=function(e){return e*r.millisecondsInSecond};var r=n(76994)},29226:(e,t,n)=>{"use strict";t.secondsToMinutes=function(e){const t=e/r.secondsInMinute;return Math.trunc(t)};var r=n(76994)},97595:(e,t,n)=>{"use strict";t.set=function(e,t){let n=(0,i.toDate)(e);if(isNaN(+n))return(0,r.constructFrom)(e,NaN);null!=t.year&&n.setFullYear(t.year);null!=t.month&&(n=(0,o.setMonth)(n,t.month));null!=t.date&&n.setDate(t.date);null!=t.hours&&n.setHours(t.hours);null!=t.minutes&&n.setMinutes(t.minutes);null!=t.seconds&&n.setSeconds(t.seconds);null!=t.milliseconds&&n.setMilliseconds(t.milliseconds);return n};var r=n(70722),o=n(72101),i=n(40546)},8423:(e,t,n)=>{"use strict";t.setDate=function(e,t){const n=(0,r.toDate)(e);return n.setDate(t),n};var r=n(40546)},4889:(e,t,n)=>{"use strict";t.setDay=function(e,t,n){const a=(0,i.getDefaultOptions)(),s=n?.weekStartsOn??n?.locale?.options?.weekStartsOn??a.weekStartsOn??a.locale?.options?.weekStartsOn??0,l=(0,o.toDate)(e),c=l.getDay(),u=(t%7+7)%7,d=7-s,p=t<0||t>6?t-(c+d)%7:(u+d)%7-(c+d)%7;return(0,r.addDays)(l,p)};var r=n(64951),o=n(40546),i=n(59567)},91493:(e,t,n)=>{"use strict";t.setDayOfYear=function(e,t){const n=(0,r.toDate)(e);return n.setMonth(0),n.setDate(t),n};var r=n(40546)},76986:(e,t,n)=>{"use strict";t.setDefaultOptions=function(e){const t={},n=(0,r.getDefaultOptions)();for(const e in n)Object.prototype.hasOwnProperty.call(n,e)&&(t[e]=n[e]);for(const n in e)Object.prototype.hasOwnProperty.call(e,n)&&(void 0===e[n]?delete t[n]:t[n]=e[n]);(0,r.setDefaultOptions)(t)};var r=n(59567)},3080:(e,t,n)=>{"use strict";t.setHours=function(e,t){const n=(0,r.toDate)(e);return n.setHours(t),n};var r=n(40546)},43338:(e,t,n)=>{"use strict";t.setISODay=function(e,t){const n=(0,i.toDate)(e),a=(0,o.getISODay)(n),s=t-a;return(0,r.addDays)(n,s)};var r=n(64951),o=n(39278),i=n(40546)},75018:(e,t,n)=>{"use strict";t.setISOWeek=function(e,t){const n=(0,o.toDate)(e),i=(0,r.getISOWeek)(n)-t;return n.setDate(n.getDate()-7*i),n};var r=n(67206),o=n(40546)},84375:(e,t,n)=>{"use strict";t.setISOWeekYear=function(e,t){let n=(0,a.toDate)(e);const s=(0,o.differenceInCalendarDays)(n,(0,i.startOfISOWeekYear)(n)),l=(0,r.constructFrom)(e,0);return l.setFullYear(t,0,4),l.setHours(0,0,0,0),n=(0,i.startOfISOWeekYear)(l),n.setDate(n.getDate()+s),n};var r=n(70722),o=n(80466),i=n(18992),a=n(40546)},20813:(e,t,n)=>{"use strict";t.setMilliseconds=function(e,t){const n=(0,r.toDate)(e);return n.setMilliseconds(t),n};var r=n(40546)},38838:(e,t,n)=>{"use strict";t.setMinutes=function(e,t){const n=(0,r.toDate)(e);return n.setMinutes(t),n};var r=n(40546)},72101:(e,t,n)=>{"use strict";t.setMonth=function(e,t){const n=(0,i.toDate)(e),a=n.getFullYear(),s=n.getDate(),l=(0,r.constructFrom)(e,0);l.setFullYear(a,t,15),l.setHours(0,0,0,0);const c=(0,o.getDaysInMonth)(l);return n.setMonth(t,Math.min(s,c)),n};var r=n(70722),o=n(17113),i=n(40546)},51143:(e,t,n)=>{"use strict";t.setQuarter=function(e,t){const n=(0,o.toDate)(e),i=Math.trunc(n.getMonth()/3)+1,a=t-i;return(0,r.setMonth)(n,n.getMonth()+3*a)};var r=n(72101),o=n(40546)},44874:(e,t,n)=>{"use strict";t.setSeconds=function(e,t){const n=(0,r.toDate)(e);return n.setSeconds(t),n};var r=n(40546)},86431:(e,t,n)=>{"use strict";t.setWeek=function(e,t,n){const i=(0,o.toDate)(e),a=(0,r.getWeek)(i,n)-t;return i.setDate(i.getDate()-7*a),i};var r=n(32859),o=n(40546)},31610:(e,t,n)=>{"use strict";t.setWeekYear=function(e,t,n){const l=(0,s.getDefaultOptions)(),c=n?.firstWeekContainsDate??n?.locale?.options?.firstWeekContainsDate??l.firstWeekContainsDate??l.locale?.options?.firstWeekContainsDate??1;let u=(0,a.toDate)(e);const d=(0,o.differenceInCalendarDays)(u,(0,i.startOfWeekYear)(u,n)),p=(0,r.constructFrom)(e,0);return p.setFullYear(t,0,c),p.setHours(0,0,0,0),u=(0,i.startOfWeekYear)(p,n),u.setDate(u.getDate()+d),u};var r=n(70722),o=n(80466),i=n(6559),a=n(40546),s=n(59567)},27566:(e,t,n)=>{"use strict";t.setYear=function(e,t){const n=(0,o.toDate)(e);if(isNaN(+n))return(0,r.constructFrom)(e,NaN);return n.setFullYear(t),n};var r=n(70722),o=n(40546)},80658:(e,t,n)=>{"use strict";t.startOfDay=function(e){const t=(0,r.toDate)(e);return t.setHours(0,0,0,0),t};var r=n(40546)},4566:(e,t,n)=>{"use strict";t.startOfDecade=function(e){const t=(0,r.toDate)(e),n=t.getFullYear(),o=10*Math.floor(n/10);return t.setFullYear(o,0,1),t.setHours(0,0,0,0),t};var r=n(40546)},40512:(e,t,n)=>{"use strict";t.startOfHour=function(e){const t=(0,r.toDate)(e);return t.setMinutes(0,0,0),t};var r=n(40546)},51145:(e,t,n)=>{"use strict";t.startOfISOWeek=function(e){return(0,r.startOfWeek)(e,{weekStartsOn:1})};var r=n(1922)},18992:(e,t,n)=>{"use strict";t.startOfISOWeekYear=function(e){const t=(0,r.getISOWeekYear)(e),n=(0,i.constructFrom)(e,0);return n.setFullYear(t,0,4),n.setHours(0,0,0,0),(0,o.startOfISOWeek)(n)};var r=n(13579),o=n(51145),i=n(70722)},99462:(e,t,n)=>{"use strict";t.startOfMinute=function(e){const t=(0,r.toDate)(e);return t.setSeconds(0,0),t};var r=n(40546)},56234:(e,t,n)=>{"use strict";t.startOfMonth=function(e){const t=(0,r.toDate)(e);return t.setDate(1),t.setHours(0,0,0,0),t};var r=n(40546)},39944:(e,t,n)=>{"use strict";t.startOfQuarter=function(e){const t=(0,r.toDate)(e),n=t.getMonth(),o=n-n%3;return t.setMonth(o,1),t.setHours(0,0,0,0),t};var r=n(40546)},36530:(e,t,n)=>{"use strict";t.startOfSecond=function(e){const t=(0,r.toDate)(e);return t.setMilliseconds(0),t};var r=n(40546)},61005:(e,t,n)=>{"use strict";t.startOfToday=function(){return(0,r.startOfDay)(Date.now())};var r=n(80658)},76594:(e,t)=>{"use strict";t.startOfTomorrow=function(){const e=new Date,t=e.getFullYear(),n=e.getMonth(),r=e.getDate(),o=new Date(0);return o.setFullYear(t,n,r+1),o.setHours(0,0,0,0),o}},1922:(e,t,n)=>{"use strict";t.startOfWeek=function(e,t){const n=(0,o.getDefaultOptions)(),i=t?.weekStartsOn??t?.locale?.options?.weekStartsOn??n.weekStartsOn??n.locale?.options?.weekStartsOn??0,a=(0,r.toDate)(e),s=a.getDay(),l=(s<i?7:0)+s-i;return a.setDate(a.getDate()-l),a.setHours(0,0,0,0),a};var r=n(40546),o=n(59567)},6559:(e,t,n)=>{"use strict";t.startOfWeekYear=function(e,t){const n=(0,a.getDefaultOptions)(),s=t?.firstWeekContainsDate??t?.locale?.options?.firstWeekContainsDate??n.firstWeekContainsDate??n.locale?.options?.firstWeekContainsDate??1,l=(0,o.getWeekYear)(e,t),c=(0,r.constructFrom)(e,0);c.setFullYear(l,0,s),c.setHours(0,0,0,0);return(0,i.startOfWeek)(c,t)};var r=n(70722),o=n(43918),i=n(1922),a=n(59567)},79687:(e,t,n)=>{"use strict";t.startOfYear=function(e){const t=(0,r.toDate)(e),n=(0,o.constructFrom)(e,0);return n.setFullYear(t.getFullYear(),0,1),n.setHours(0,0,0,0),n};var r=n(40546),o=n(70722)},2696:(e,t)=>{"use strict";t.startOfYesterday=function(){const e=new Date,t=e.getFullYear(),n=e.getMonth(),r=e.getDate(),o=new Date(0);return o.setFullYear(t,n,r-1),o.setHours(0,0,0,0),o}},57089:(e,t,n)=>{"use strict";t.sub=function(e,t){const{years:n=0,months:a=0,weeks:s=0,days:l=0,hours:c=0,minutes:u=0,seconds:d=0}=t,p=(0,o.subMonths)(e,a+12*n),f=(0,r.subDays)(p,l+7*s),h=1e3*(d+60*(u+60*c));return(0,i.constructFrom)(e,f.getTime()-h)};var r=n(79342),o=n(386),i=n(70722)},67572:(e,t,n)=>{"use strict";t.subBusinessDays=function(e,t){return(0,r.addBusinessDays)(e,-t)};var r=n(62105)},79342:(e,t,n)=>{"use strict";t.subDays=function(e,t){return(0,r.addDays)(e,-t)};var r=n(64951)},89806:(e,t,n)=>{"use strict";t.subHours=function(e,t){return(0,r.addHours)(e,-t)};var r=n(5833)},35584:(e,t,n)=>{"use strict";t.subISOWeekYears=function(e,t){return(0,r.addISOWeekYears)(e,-t)};var r=n(80081)},75799:(e,t,n)=>{"use strict";t.subMilliseconds=function(e,t){return(0,r.addMilliseconds)(e,-t)};var r=n(69098)},11851:(e,t,n)=>{"use strict";t.subMinutes=function(e,t){return(0,r.addMinutes)(e,-t)};var r=n(24099)},386:(e,t,n)=>{"use strict";t.subMonths=function(e,t){return(0,r.addMonths)(e,-t)};var r=n(39711)},94772:(e,t,n)=>{"use strict";t.subQuarters=function(e,t){return(0,r.addQuarters)(e,-t)};var r=n(3045)},3923:(e,t,n)=>{"use strict";t.subSeconds=function(e,t){return(0,r.addSeconds)(e,-t)};var r=n(39603)},2352:(e,t,n)=>{"use strict";t.subWeeks=function(e,t){return(0,r.addWeeks)(e,-t)};var r=n(58235)},28359:(e,t,n)=>{"use strict";t.subYears=function(e,t){return(0,r.addYears)(e,-t)};var r=n(3112)},40546:(e,t)=>{"use strict";t.toDate=function(e){const t=Object.prototype.toString.call(e);return e instanceof Date||"object"==typeof e&&"[object Date]"===t?new e.constructor(+e):"number"==typeof e||"[object Number]"===t||"string"==typeof e||"[object String]"===t?new Date(e):new Date(NaN)}},77640:(e,t,n)=>{"use strict";t.transpose=function(e,t){const n=t instanceof Date?(0,r.constructFrom)(t,0):new t(0);return n.setFullYear(e.getFullYear(),e.getMonth(),e.getDate()),n.setHours(e.getHours(),e.getMinutes(),e.getSeconds(),e.getMilliseconds()),n};var r=n(70722)},39160:(e,t,n)=>{"use strict";t.weeksToDays=function(e){return Math.trunc(e*r.daysInWeek)};var r=n(76994)},7111:(e,t,n)=>{"use strict";t.yearsToDays=function(e){return Math.trunc(e*r.daysInYear)};var r=n(76994)},5167:(e,t,n)=>{"use strict";t.yearsToMonths=function(e){return Math.trunc(e*r.monthsInYear)};var r=n(76994)},73109:(e,t,n)=>{"use strict";t.yearsToQuarters=function(e){return Math.trunc(e*r.quartersInYear)};var r=n(76994)},37045:(e,t,n)=>{"use strict";
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var r=n(77810),o=n(82328);function i(e){for(var t="https://reactjs.org/docs/error-decoder.html?invariant="+e,n=1;n<arguments.length;n++)t+="&args[]="+encodeURIComponent(arguments[n]);return"Minified React error #"+e+"; visit "+t+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var a=new Set,s={};function l(e,t){c(e,t),c(e+"Capture",t)}function c(e,t){for(s[e]=t,e=0;e<t.length;e++)a.add(t[e])}var u=!("undefined"==typeof window||void 0===window.document||void 0===window.document.createElement),d=Object.prototype.hasOwnProperty,p=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,f={},h={};function m(e,t,n,r,o,i,a){this.acceptsBooleans=2===t||3===t||4===t,this.attributeName=r,this.attributeNamespace=o,this.mustUseProperty=n,this.propertyName=e,this.type=t,this.sanitizeURL=i,this.removeEmptyString=a}var g={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach((function(e){g[e]=new m(e,0,!1,e,null,!1,!1)})),[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach((function(e){var t=e[0];g[t]=new m(t,1,!1,e[1],null,!1,!1)})),["contentEditable","draggable","spellCheck","value"].forEach((function(e){g[e]=new m(e,2,!1,e.toLowerCase(),null,!1,!1)})),["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach((function(e){g[e]=new m(e,2,!1,e,null,!1,!1)})),"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach((function(e){g[e]=new m(e,3,!1,e.toLowerCase(),null,!1,!1)})),["checked","multiple","muted","selected"].forEach((function(e){g[e]=new m(e,3,!0,e,null,!1,!1)})),["capture","download"].forEach((function(e){g[e]=new m(e,4,!1,e,null,!1,!1)})),["cols","rows","size","span"].forEach((function(e){g[e]=new m(e,6,!1,e,null,!1,!1)})),["rowSpan","start"].forEach((function(e){g[e]=new m(e,5,!1,e.toLowerCase(),null,!1,!1)}));var v=/[\-:]([a-z])/g;function y(e){return e[1].toUpperCase()}function b(e,t,n,r){var o=g.hasOwnProperty(t)?g[t]:null;(null!==o?0!==o.type:r||!(2<t.length)||"o"!==t[0]&&"O"!==t[0]||"n"!==t[1]&&"N"!==t[1])&&(function(e,t,n,r){if(null==t||function(e,t,n,r){if(null!==n&&0===n.type)return!1;switch(typeof t){case"function":case"symbol":return!0;case"boolean":return!r&&(null!==n?!n.acceptsBooleans:"data-"!==(e=e.toLowerCase().slice(0,5))&&"aria-"!==e);default:return!1}}(e,t,n,r))return!0;if(r)return!1;if(null!==n)switch(n.type){case 3:return!t;case 4:return!1===t;case 5:return isNaN(t);case 6:return isNaN(t)||1>t}return!1}(t,n,o,r)&&(n=null),r||null===o?function(e){return!!d.call(h,e)||!d.call(f,e)&&(p.test(e)?h[e]=!0:(f[e]=!0,!1))}(t)&&(null===n?e.removeAttribute(t):e.setAttribute(t,""+n)):o.mustUseProperty?e[o.propertyName]=null===n?3!==o.type&&"":n:(t=o.attributeName,r=o.attributeNamespace,null===n?e.removeAttribute(t):(n=3===(o=o.type)||4===o&&!0===n?"":""+n,r?e.setAttributeNS(r,t,n):e.setAttribute(t,n))))}"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach((function(e){var t=e.replace(v,y);g[t]=new m(t,1,!1,e,null,!1,!1)})),"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach((function(e){var t=e.replace(v,y);g[t]=new m(t,1,!1,e,"http://www.w3.org/1999/xlink",!1,!1)})),["xml:base","xml:lang","xml:space"].forEach((function(e){var t=e.replace(v,y);g[t]=new m(t,1,!1,e,"http://www.w3.org/XML/1998/namespace",!1,!1)})),["tabIndex","crossOrigin"].forEach((function(e){g[e]=new m(e,1,!1,e.toLowerCase(),null,!1,!1)})),g.xlinkHref=new m("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1),["src","href","action","formAction"].forEach((function(e){g[e]=new m(e,1,!1,e.toLowerCase(),null,!0,!0)}));var _=r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,A=Symbol.for("react.element"),E=Symbol.for("react.portal"),w=Symbol.for("react.fragment"),x=Symbol.for("react.strict_mode"),k=Symbol.for("react.profiler"),C=Symbol.for("react.provider"),S=Symbol.for("react.context"),M=Symbol.for("react.forward_ref"),T=Symbol.for("react.suspense"),O=Symbol.for("react.suspense_list"),D=Symbol.for("react.memo"),L=Symbol.for("react.lazy");Symbol.for("react.scope"),Symbol.for("react.debug_trace_mode");var P=Symbol.for("react.offscreen");Symbol.for("react.legacy_hidden"),Symbol.for("react.cache"),Symbol.for("react.tracing_marker");var I=Symbol.iterator;function B(e){return null===e||"object"!=typeof e?null:"function"==typeof(e=I&&e[I]||e["@@iterator"])?e:null}var R,N=Object.assign;function F(e){if(void 0===R)try{throw Error()}catch(e){var t=e.stack.trim().match(/\n( *(at )?)/);R=t&&t[1]||""}return"\n"+R+e}var j=!1;function Y(e,t){if(!e||j)return"";j=!0;var n=Error.prepareStackTrace;Error.prepareStackTrace=void 0;try{if(t)if(t=function(){throw Error()},Object.defineProperty(t.prototype,"props",{set:function(){throw Error()}}),"object"==typeof Reflect&&Reflect.construct){try{Reflect.construct(t,[])}catch(e){var r=e}Reflect.construct(e,[],t)}else{try{t.call()}catch(e){r=e}e.call(t.prototype)}else{try{throw Error()}catch(e){r=e}e()}}catch(t){if(t&&r&&"string"==typeof t.stack){for(var o=t.stack.split("\n"),i=r.stack.split("\n"),a=o.length-1,s=i.length-1;1<=a&&0<=s&&o[a]!==i[s];)s--;for(;1<=a&&0<=s;a--,s--)if(o[a]!==i[s]){if(1!==a||1!==s)do{if(a--,0>--s||o[a]!==i[s]){var l="\n"+o[a].replace(" at new "," at ");return e.displayName&&l.includes("<anonymous>")&&(l=l.replace("<anonymous>",e.displayName)),l}}while(1<=a&&0<=s);break}}}finally{j=!1,Error.prepareStackTrace=n}return(e=e?e.displayName||e.name:"")?F(e):""}function $(e){switch(e.tag){case 5:return F(e.type);case 16:return F("Lazy");case 13:return F("Suspense");case 19:return F("SuspenseList");case 0:case 2:case 15:return e=Y(e.type,!1);case 11:return e=Y(e.type.render,!1);case 1:return e=Y(e.type,!0);default:return""}}function H(e){if(null==e)return null;if("function"==typeof e)return e.displayName||e.name||null;if("string"==typeof e)return e;switch(e){case w:return"Fragment";case E:return"Portal";case k:return"Profiler";case x:return"StrictMode";case T:return"Suspense";case O:return"SuspenseList"}if("object"==typeof e)switch(e.$$typeof){case S:return(e.displayName||"Context")+".Consumer";case C:return(e._context.displayName||"Context")+".Provider";case M:var t=e.render;return(e=e.displayName)||(e=""!==(e=t.displayName||t.name||"")?"ForwardRef("+e+")":"ForwardRef"),e;case D:return null!==(t=e.displayName||null)?t:H(e.type)||"Memo";case L:t=e._payload,e=e._init;try{return H(e(t))}catch(e){}}return null}function U(e){var t=e.type;switch(e.tag){case 24:return"Cache";case 9:return(t.displayName||"Context")+".Consumer";case 10:return(t._context.displayName||"Context")+".Provider";case 18:return"DehydratedFragment";case 11:return e=(e=t.render).displayName||e.name||"",t.displayName||(""!==e?"ForwardRef("+e+")":"ForwardRef");case 7:return"Fragment";case 5:return t;case 4:return"Portal";case 3:return"Root";case 6:return"Text";case 16:return H(t);case 8:return t===x?"StrictMode":"Mode";case 22:return"Offscreen";case 12:return"Profiler";case 21:return"Scope";case 13:return"Suspense";case 19:return"SuspenseList";case 25:return"TracingMarker";case 1:case 0:case 17:case 2:case 14:case 15:if("function"==typeof t)return t.displayName||t.name||null;if("string"==typeof t)return t}return null}function z(e){switch(typeof e){case"boolean":case"number":case"string":case"undefined":case"object":return e;default:return""}}function W(e){var t=e.type;return(e=e.nodeName)&&"input"===e.toLowerCase()&&("checkbox"===t||"radio"===t)}function V(e){e._valueTracker||(e._valueTracker=function(e){var t=W(e)?"checked":"value",n=Object.getOwnPropertyDescriptor(e.constructor.prototype,t),r=""+e[t];if(!e.hasOwnProperty(t)&&void 0!==n&&"function"==typeof n.get&&"function"==typeof n.set){var o=n.get,i=n.set;return Object.defineProperty(e,t,{configurable:!0,get:function(){return o.call(this)},set:function(e){r=""+e,i.call(this,e)}}),Object.defineProperty(e,t,{enumerable:n.enumerable}),{getValue:function(){return r},setValue:function(e){r=""+e},stopTracking:function(){e._valueTracker=null,delete e[t]}}}}(e))}function G(e){if(!e)return!1;var t=e._valueTracker;if(!t)return!0;var n=t.getValue(),r="";return e&&(r=W(e)?e.checked?"true":"false":e.value),(e=r)!==n&&(t.setValue(e),!0)}function Q(e){if(void 0===(e=e||("undefined"!=typeof document?document:void 0)))return null;try{return e.activeElement||e.body}catch(t){return e.body}}function q(e,t){var n=t.checked;return N({},t,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=n?n:e._wrapperState.initialChecked})}function K(e,t){var n=null==t.defaultValue?"":t.defaultValue,r=null!=t.checked?t.checked:t.defaultChecked;n=z(null!=t.value?t.value:n),e._wrapperState={initialChecked:r,initialValue:n,controlled:"checkbox"===t.type||"radio"===t.type?null!=t.checked:null!=t.value}}function Z(e,t){null!=(t=t.checked)&&b(e,"checked",t,!1)}function J(e,t){Z(e,t);var n=z(t.value),r=t.type;if(null!=n)"number"===r?(0===n&&""===e.value||e.value!=n)&&(e.value=""+n):e.value!==""+n&&(e.value=""+n);else if("submit"===r||"reset"===r)return void e.removeAttribute("value");t.hasOwnProperty("value")?ee(e,t.type,n):t.hasOwnProperty("defaultValue")&&ee(e,t.type,z(t.defaultValue)),null==t.checked&&null!=t.defaultChecked&&(e.defaultChecked=!!t.defaultChecked)}function X(e,t,n){if(t.hasOwnProperty("value")||t.hasOwnProperty("defaultValue")){var r=t.type;if(!("submit"!==r&&"reset"!==r||void 0!==t.value&&null!==t.value))return;t=""+e._wrapperState.initialValue,n||t===e.value||(e.value=t),e.defaultValue=t}""!==(n=e.name)&&(e.name=""),e.defaultChecked=!!e._wrapperState.initialChecked,""!==n&&(e.name=n)}function ee(e,t,n){"number"===t&&Q(e.ownerDocument)===e||(null==n?e.defaultValue=""+e._wrapperState.initialValue:e.defaultValue!==""+n&&(e.defaultValue=""+n))}var te=Array.isArray;function ne(e,t,n,r){if(e=e.options,t){t={};for(var o=0;o<n.length;o++)t["$"+n[o]]=!0;for(n=0;n<e.length;n++)o=t.hasOwnProperty("$"+e[n].value),e[n].selected!==o&&(e[n].selected=o),o&&r&&(e[n].defaultSelected=!0)}else{for(n=""+z(n),t=null,o=0;o<e.length;o++){if(e[o].value===n)return e[o].selected=!0,void(r&&(e[o].defaultSelected=!0));null!==t||e[o].disabled||(t=e[o])}null!==t&&(t.selected=!0)}}function re(e,t){if(null!=t.dangerouslySetInnerHTML)throw Error(i(91));return N({},t,{value:void 0,defaultValue:void 0,children:""+e._wrapperState.initialValue})}function oe(e,t){var n=t.value;if(null==n){if(n=t.children,t=t.defaultValue,null!=n){if(null!=t)throw Error(i(92));if(te(n)){if(1<n.length)throw Error(i(93));n=n[0]}t=n}null==t&&(t=""),n=t}e._wrapperState={initialValue:z(n)}}function ie(e,t){var n=z(t.value),r=z(t.defaultValue);null!=n&&((n=""+n)!==e.value&&(e.value=n),null==t.defaultValue&&e.defaultValue!==n&&(e.defaultValue=n)),null!=r&&(e.defaultValue=""+r)}function ae(e){var t=e.textContent;t===e._wrapperState.initialValue&&""!==t&&null!==t&&(e.value=t)}function se(e){switch(e){case"svg":return"http://www.w3.org/2000/svg";case"math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function le(e,t){return null==e||"http://www.w3.org/1999/xhtml"===e?se(t):"http://www.w3.org/2000/svg"===e&&"foreignObject"===t?"http://www.w3.org/1999/xhtml":e}var ce,ue,de=(ue=function(e,t){if("http://www.w3.org/2000/svg"!==e.namespaceURI||"innerHTML"in e)e.innerHTML=t;else{for((ce=ce||document.createElement("div")).innerHTML="<svg>"+t.valueOf().toString()+"</svg>",t=ce.firstChild;e.firstChild;)e.removeChild(e.firstChild);for(;t.firstChild;)e.appendChild(t.firstChild)}},"undefined"!=typeof MSApp&&MSApp.execUnsafeLocalFunction?function(e,t,n,r){MSApp.execUnsafeLocalFunction((function(){return ue(e,t)}))}:ue);function pe(e,t){if(t){var n=e.firstChild;if(n&&n===e.lastChild&&3===n.nodeType)return void(n.nodeValue=t)}e.textContent=t}var fe={animationIterationCount:!0,aspectRatio:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},he=["Webkit","ms","Moz","O"];function me(e,t,n){return null==t||"boolean"==typeof t||""===t?"":n||"number"!=typeof t||0===t||fe.hasOwnProperty(e)&&fe[e]?(""+t).trim():t+"px"}function ge(e,t){for(var n in e=e.style,t)if(t.hasOwnProperty(n)){var r=0===n.indexOf("--"),o=me(n,t[n],r);"float"===n&&(n="cssFloat"),r?e.setProperty(n,o):e[n]=o}}Object.keys(fe).forEach((function(e){he.forEach((function(t){t=t+e.charAt(0).toUpperCase()+e.substring(1),fe[t]=fe[e]}))}));var ve=N({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});function ye(e,t){if(t){if(ve[e]&&(null!=t.children||null!=t.dangerouslySetInnerHTML))throw Error(i(137,e));if(null!=t.dangerouslySetInnerHTML){if(null!=t.children)throw Error(i(60));if("object"!=typeof t.dangerouslySetInnerHTML||!("__html"in t.dangerouslySetInnerHTML))throw Error(i(61))}if(null!=t.style&&"object"!=typeof t.style)throw Error(i(62))}}function be(e,t){if(-1===e.indexOf("-"))return"string"==typeof t.is;switch(e){case"annotation-xml":case"color-profile":case"font-face":case"font-face-src":case"font-face-uri":case"font-face-format":case"font-face-name":case"missing-glyph":return!1;default:return!0}}var _e=null;function Ae(e){return(e=e.target||e.srcElement||window).correspondingUseElement&&(e=e.correspondingUseElement),3===e.nodeType?e.parentNode:e}var Ee=null,we=null,xe=null;function ke(e){if(e=_o(e)){if("function"!=typeof Ee)throw Error(i(280));var t=e.stateNode;t&&(t=Eo(t),Ee(e.stateNode,e.type,t))}}function Ce(e){we?xe?xe.push(e):xe=[e]:we=e}function Se(){if(we){var e=we,t=xe;if(xe=we=null,ke(e),t)for(e=0;e<t.length;e++)ke(t[e])}}function Me(e,t){return e(t)}function Te(){}var Oe=!1;function De(e,t,n){if(Oe)return e(t,n);Oe=!0;try{return Me(e,t,n)}finally{Oe=!1,(null!==we||null!==xe)&&(Te(),Se())}}function Le(e,t){var n=e.stateNode;if(null===n)return null;var r=Eo(n);if(null===r)return null;n=r[t];e:switch(t){case"onClick":case"onClickCapture":case"onDoubleClick":case"onDoubleClickCapture":case"onMouseDown":case"onMouseDownCapture":case"onMouseMove":case"onMouseMoveCapture":case"onMouseUp":case"onMouseUpCapture":case"onMouseEnter":(r=!r.disabled)||(r=!("button"===(e=e.type)||"input"===e||"select"===e||"textarea"===e)),e=!r;break e;default:e=!1}if(e)return null;if(n&&"function"!=typeof n)throw Error(i(231,t,typeof n));return n}var Pe=!1;if(u)try{var Ie={};Object.defineProperty(Ie,"passive",{get:function(){Pe=!0}}),window.addEventListener("test",Ie,Ie),window.removeEventListener("test",Ie,Ie)}catch(ue){Pe=!1}function Be(e,t,n,r,o,i,a,s,l){var c=Array.prototype.slice.call(arguments,3);try{t.apply(n,c)}catch(e){this.onError(e)}}var Re=!1,Ne=null,Fe=!1,je=null,Ye={onError:function(e){Re=!0,Ne=e}};function $e(e,t,n,r,o,i,a,s,l){Re=!1,Ne=null,Be.apply(Ye,arguments)}function He(e){var t=e,n=e;if(e.alternate)for(;t.return;)t=t.return;else{e=t;do{!!(4098&(t=e).flags)&&(n=t.return),e=t.return}while(e)}return 3===t.tag?n:null}function Ue(e){if(13===e.tag){var t=e.memoizedState;if(null===t&&(null!==(e=e.alternate)&&(t=e.memoizedState)),null!==t)return t.dehydrated}return null}function ze(e){if(He(e)!==e)throw Error(i(188))}function We(e){return null!==(e=function(e){var t=e.alternate;if(!t){if(null===(t=He(e)))throw Error(i(188));return t!==e?null:e}for(var n=e,r=t;;){var o=n.return;if(null===o)break;var a=o.alternate;if(null===a){if(null!==(r=o.return)){n=r;continue}break}if(o.child===a.child){for(a=o.child;a;){if(a===n)return ze(o),e;if(a===r)return ze(o),t;a=a.sibling}throw Error(i(188))}if(n.return!==r.return)n=o,r=a;else{for(var s=!1,l=o.child;l;){if(l===n){s=!0,n=o,r=a;break}if(l===r){s=!0,r=o,n=a;break}l=l.sibling}if(!s){for(l=a.child;l;){if(l===n){s=!0,n=a,r=o;break}if(l===r){s=!0,r=a,n=o;break}l=l.sibling}if(!s)throw Error(i(189))}}if(n.alternate!==r)throw Error(i(190))}if(3!==n.tag)throw Error(i(188));return n.stateNode.current===n?e:t}(e))?Ve(e):null}function Ve(e){if(5===e.tag||6===e.tag)return e;for(e=e.child;null!==e;){var t=Ve(e);if(null!==t)return t;e=e.sibling}return null}var Ge=o.unstable_scheduleCallback,Qe=o.unstable_cancelCallback,qe=o.unstable_shouldYield,Ke=o.unstable_requestPaint,Ze=o.unstable_now,Je=o.unstable_getCurrentPriorityLevel,Xe=o.unstable_ImmediatePriority,et=o.unstable_UserBlockingPriority,tt=o.unstable_NormalPriority,nt=o.unstable_LowPriority,rt=o.unstable_IdlePriority,ot=null,it=null;var at=Math.clz32?Math.clz32:function(e){return e>>>=0,0===e?32:31-(st(e)/lt|0)|0},st=Math.log,lt=Math.LN2;var ct=64,ut=4194304;function dt(e){switch(e&-e){case 1:return 1;case 2:return 2;case 4:return 4;case 8:return 8;case 16:return 16;case 32:return 32;case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:return 4194240&e;case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:return 130023424&e;case 134217728:return 134217728;case 268435456:return 268435456;case 536870912:return 536870912;case 1073741824:return 1073741824;default:return e}}function pt(e,t){var n=e.pendingLanes;if(0===n)return 0;var r=0,o=e.suspendedLanes,i=e.pingedLanes,a=268435455&n;if(0!==a){var s=a&~o;0!==s?r=dt(s):0!==(i&=a)&&(r=dt(i))}else 0!==(a=n&~o)?r=dt(a):0!==i&&(r=dt(i));if(0===r)return 0;if(0!==t&&t!==r&&!(t&o)&&((o=r&-r)>=(i=t&-t)||16===o&&4194240&i))return t;if(4&r&&(r|=16&n),0!==(t=e.entangledLanes))for(e=e.entanglements,t&=r;0<t;)o=1<<(n=31-at(t)),r|=e[n],t&=~o;return r}function ft(e,t){switch(e){case 1:case 2:case 4:return t+250;case 8:case 16:case 32:case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:return t+5e3;default:return-1}}function ht(e){return 0!==(e=-1073741825&e.pendingLanes)?e:1073741824&e?1073741824:0}function mt(){var e=ct;return!(4194240&(ct<<=1))&&(ct=64),e}function gt(e){for(var t=[],n=0;31>n;n++)t.push(e);return t}function vt(e,t,n){e.pendingLanes|=t,536870912!==t&&(e.suspendedLanes=0,e.pingedLanes=0),(e=e.eventTimes)[t=31-at(t)]=n}function yt(e,t){var n=e.entangledLanes|=t;for(e=e.entanglements;n;){var r=31-at(n),o=1<<r;o&t|e[r]&t&&(e[r]|=t),n&=~o}}var bt=0;function _t(e){return 1<(e&=-e)?4<e?268435455&e?16:536870912:4:1}var At,Et,wt,xt,kt,Ct=!1,St=[],Mt=null,Tt=null,Ot=null,Dt=new Map,Lt=new Map,Pt=[],It="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");function Bt(e,t){switch(e){case"focusin":case"focusout":Mt=null;break;case"dragenter":case"dragleave":Tt=null;break;case"mouseover":case"mouseout":Ot=null;break;case"pointerover":case"pointerout":Dt.delete(t.pointerId);break;case"gotpointercapture":case"lostpointercapture":Lt.delete(t.pointerId)}}function Rt(e,t,n,r,o,i){return null===e||e.nativeEvent!==i?(e={blockedOn:t,domEventName:n,eventSystemFlags:r,nativeEvent:i,targetContainers:[o]},null!==t&&(null!==(t=_o(t))&&Et(t)),e):(e.eventSystemFlags|=r,t=e.targetContainers,null!==o&&-1===t.indexOf(o)&&t.push(o),e)}function Nt(e){var t=bo(e.target);if(null!==t){var n=He(t);if(null!==n)if(13===(t=n.tag)){if(null!==(t=Ue(n)))return e.blockedOn=t,void kt(e.priority,(function(){wt(n)}))}else if(3===t&&n.stateNode.current.memoizedState.isDehydrated)return void(e.blockedOn=3===n.tag?n.stateNode.containerInfo:null)}e.blockedOn=null}function Ft(e){if(null!==e.blockedOn)return!1;for(var t=e.targetContainers;0<t.length;){var n=qt(e.domEventName,e.eventSystemFlags,t[0],e.nativeEvent);if(null!==n)return null!==(t=_o(n))&&Et(t),e.blockedOn=n,!1;var r=new(n=e.nativeEvent).constructor(n.type,n);_e=r,n.target.dispatchEvent(r),_e=null,t.shift()}return!0}function jt(e,t,n){Ft(e)&&n.delete(t)}function Yt(){Ct=!1,null!==Mt&&Ft(Mt)&&(Mt=null),null!==Tt&&Ft(Tt)&&(Tt=null),null!==Ot&&Ft(Ot)&&(Ot=null),Dt.forEach(jt),Lt.forEach(jt)}function $t(e,t){e.blockedOn===t&&(e.blockedOn=null,Ct||(Ct=!0,o.unstable_scheduleCallback(o.unstable_NormalPriority,Yt)))}function Ht(e){function t(t){return $t(t,e)}if(0<St.length){$t(St[0],e);for(var n=1;n<St.length;n++){var r=St[n];r.blockedOn===e&&(r.blockedOn=null)}}for(null!==Mt&&$t(Mt,e),null!==Tt&&$t(Tt,e),null!==Ot&&$t(Ot,e),Dt.forEach(t),Lt.forEach(t),n=0;n<Pt.length;n++)(r=Pt[n]).blockedOn===e&&(r.blockedOn=null);for(;0<Pt.length&&null===(n=Pt[0]).blockedOn;)Nt(n),null===n.blockedOn&&Pt.shift()}var Ut=_.ReactCurrentBatchConfig,zt=!0;function Wt(e,t,n,r){var o=bt,i=Ut.transition;Ut.transition=null;try{bt=1,Gt(e,t,n,r)}finally{bt=o,Ut.transition=i}}function Vt(e,t,n,r){var o=bt,i=Ut.transition;Ut.transition=null;try{bt=4,Gt(e,t,n,r)}finally{bt=o,Ut.transition=i}}function Gt(e,t,n,r){if(zt){var o=qt(e,t,n,r);if(null===o)zr(e,t,r,Qt,n),Bt(e,r);else if(function(e,t,n,r,o){switch(t){case"focusin":return Mt=Rt(Mt,e,t,n,r,o),!0;case"dragenter":return Tt=Rt(Tt,e,t,n,r,o),!0;case"mouseover":return Ot=Rt(Ot,e,t,n,r,o),!0;case"pointerover":var i=o.pointerId;return Dt.set(i,Rt(Dt.get(i)||null,e,t,n,r,o)),!0;case"gotpointercapture":return i=o.pointerId,Lt.set(i,Rt(Lt.get(i)||null,e,t,n,r,o)),!0}return!1}(o,e,t,n,r))r.stopPropagation();else if(Bt(e,r),4&t&&-1<It.indexOf(e)){for(;null!==o;){var i=_o(o);if(null!==i&&At(i),null===(i=qt(e,t,n,r))&&zr(e,t,r,Qt,n),i===o)break;o=i}null!==o&&r.stopPropagation()}else zr(e,t,r,null,n)}}var Qt=null;function qt(e,t,n,r){if(Qt=null,null!==(e=bo(e=Ae(r))))if(null===(t=He(e)))e=null;else if(13===(n=t.tag)){if(null!==(e=Ue(t)))return e;e=null}else if(3===n){if(t.stateNode.current.memoizedState.isDehydrated)return 3===t.tag?t.stateNode.containerInfo:null;e=null}else t!==e&&(e=null);return Qt=e,null}function Kt(e){switch(e){case"cancel":case"click":case"close":case"contextmenu":case"copy":case"cut":case"auxclick":case"dblclick":case"dragend":case"dragstart":case"drop":case"focusin":case"focusout":case"input":case"invalid":case"keydown":case"keypress":case"keyup":case"mousedown":case"mouseup":case"paste":case"pause":case"play":case"pointercancel":case"pointerdown":case"pointerup":case"ratechange":case"reset":case"resize":case"seeked":case"submit":case"touchcancel":case"touchend":case"touchstart":case"volumechange":case"change":case"selectionchange":case"textInput":case"compositionstart":case"compositionend":case"compositionupdate":case"beforeblur":case"afterblur":case"beforeinput":case"blur":case"fullscreenchange":case"focus":case"hashchange":case"popstate":case"select":case"selectstart":return 1;case"drag":case"dragenter":case"dragexit":case"dragleave":case"dragover":case"mousemove":case"mouseout":case"mouseover":case"pointermove":case"pointerout":case"pointerover":case"scroll":case"toggle":case"touchmove":case"wheel":case"mouseenter":case"mouseleave":case"pointerenter":case"pointerleave":return 4;case"message":switch(Je()){case Xe:return 1;case et:return 4;case tt:case nt:return 16;case rt:return 536870912;default:return 16}default:return 16}}var Zt=null,Jt=null,Xt=null;function en(){if(Xt)return Xt;var e,t,n=Jt,r=n.length,o="value"in Zt?Zt.value:Zt.textContent,i=o.length;for(e=0;e<r&&n[e]===o[e];e++);var a=r-e;for(t=1;t<=a&&n[r-t]===o[i-t];t++);return Xt=o.slice(e,1<t?1-t:void 0)}function tn(e){var t=e.keyCode;return"charCode"in e?0===(e=e.charCode)&&13===t&&(e=13):e=t,10===e&&(e=13),32<=e||13===e?e:0}function nn(){return!0}function rn(){return!1}function on(e){function t(t,n,r,o,i){for(var a in this._reactName=t,this._targetInst=r,this.type=n,this.nativeEvent=o,this.target=i,this.currentTarget=null,e)e.hasOwnProperty(a)&&(t=e[a],this[a]=t?t(o):o[a]);return this.isDefaultPrevented=(null!=o.defaultPrevented?o.defaultPrevented:!1===o.returnValue)?nn:rn,this.isPropagationStopped=rn,this}return N(t.prototype,{preventDefault:function(){this.defaultPrevented=!0;var e=this.nativeEvent;e&&(e.preventDefault?e.preventDefault():"unknown"!=typeof e.returnValue&&(e.returnValue=!1),this.isDefaultPrevented=nn)},stopPropagation:function(){var e=this.nativeEvent;e&&(e.stopPropagation?e.stopPropagation():"unknown"!=typeof e.cancelBubble&&(e.cancelBubble=!0),this.isPropagationStopped=nn)},persist:function(){},isPersistent:nn}),t}var an,sn,ln,cn={eventPhase:0,bubbles:0,cancelable:0,timeStamp:function(e){return e.timeStamp||Date.now()},defaultPrevented:0,isTrusted:0},un=on(cn),dn=N({},cn,{view:0,detail:0}),pn=on(dn),fn=N({},dn,{screenX:0,screenY:0,clientX:0,clientY:0,pageX:0,pageY:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,getModifierState:kn,button:0,buttons:0,relatedTarget:function(e){return void 0===e.relatedTarget?e.fromElement===e.srcElement?e.toElement:e.fromElement:e.relatedTarget},movementX:function(e){return"movementX"in e?e.movementX:(e!==ln&&(ln&&"mousemove"===e.type?(an=e.screenX-ln.screenX,sn=e.screenY-ln.screenY):sn=an=0,ln=e),an)},movementY:function(e){return"movementY"in e?e.movementY:sn}}),hn=on(fn),mn=on(N({},fn,{dataTransfer:0})),gn=on(N({},dn,{relatedTarget:0})),vn=on(N({},cn,{animationName:0,elapsedTime:0,pseudoElement:0})),yn=N({},cn,{clipboardData:function(e){return"clipboardData"in e?e.clipboardData:window.clipboardData}}),bn=on(yn),_n=on(N({},cn,{data:0})),An={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},En={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},wn={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function xn(e){var t=this.nativeEvent;return t.getModifierState?t.getModifierState(e):!!(e=wn[e])&&!!t[e]}function kn(){return xn}var Cn=N({},dn,{key:function(e){if(e.key){var t=An[e.key]||e.key;if("Unidentified"!==t)return t}return"keypress"===e.type?13===(e=tn(e))?"Enter":String.fromCharCode(e):"keydown"===e.type||"keyup"===e.type?En[e.keyCode]||"Unidentified":""},code:0,location:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,repeat:0,locale:0,getModifierState:kn,charCode:function(e){return"keypress"===e.type?tn(e):0},keyCode:function(e){return"keydown"===e.type||"keyup"===e.type?e.keyCode:0},which:function(e){return"keypress"===e.type?tn(e):"keydown"===e.type||"keyup"===e.type?e.keyCode:0}}),Sn=on(Cn),Mn=on(N({},fn,{pointerId:0,width:0,height:0,pressure:0,tangentialPressure:0,tiltX:0,tiltY:0,twist:0,pointerType:0,isPrimary:0})),Tn=on(N({},dn,{touches:0,targetTouches:0,changedTouches:0,altKey:0,metaKey:0,ctrlKey:0,shiftKey:0,getModifierState:kn})),On=on(N({},cn,{propertyName:0,elapsedTime:0,pseudoElement:0})),Dn=N({},fn,{deltaX:function(e){return"deltaX"in e?e.deltaX:"wheelDeltaX"in e?-e.wheelDeltaX:0},deltaY:function(e){return"deltaY"in e?e.deltaY:"wheelDeltaY"in e?-e.wheelDeltaY:"wheelDelta"in e?-e.wheelDelta:0},deltaZ:0,deltaMode:0}),Ln=on(Dn),Pn=[9,13,27,32],In=u&&"CompositionEvent"in window,Bn=null;u&&"documentMode"in document&&(Bn=document.documentMode);var Rn=u&&"TextEvent"in window&&!Bn,Nn=u&&(!In||Bn&&8<Bn&&11>=Bn),Fn=String.fromCharCode(32),jn=!1;function Yn(e,t){switch(e){case"keyup":return-1!==Pn.indexOf(t.keyCode);case"keydown":return 229!==t.keyCode;case"keypress":case"mousedown":case"focusout":return!0;default:return!1}}function $n(e){return"object"==typeof(e=e.detail)&&"data"in e?e.data:null}var Hn=!1;var Un={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function zn(e){var t=e&&e.nodeName&&e.nodeName.toLowerCase();return"input"===t?!!Un[e.type]:"textarea"===t}function Wn(e,t,n,r){Ce(r),0<(t=Vr(t,"onChange")).length&&(n=new un("onChange","change",null,n,r),e.push({event:n,listeners:t}))}var Vn=null,Gn=null;function Qn(e){Fr(e,0)}function qn(e){if(G(Ao(e)))return e}function Kn(e,t){if("change"===e)return t}var Zn=!1;if(u){var Jn;if(u){var Xn="oninput"in document;if(!Xn){var er=document.createElement("div");er.setAttribute("oninput","return;"),Xn="function"==typeof er.oninput}Jn=Xn}else Jn=!1;Zn=Jn&&(!document.documentMode||9<document.documentMode)}function tr(){Vn&&(Vn.detachEvent("onpropertychange",nr),Gn=Vn=null)}function nr(e){if("value"===e.propertyName&&qn(Gn)){var t=[];Wn(t,Gn,e,Ae(e)),De(Qn,t)}}function rr(e,t,n){"focusin"===e?(tr(),Gn=n,(Vn=t).attachEvent("onpropertychange",nr)):"focusout"===e&&tr()}function or(e){if("selectionchange"===e||"keyup"===e||"keydown"===e)return qn(Gn)}function ir(e,t){if("click"===e)return qn(t)}function ar(e,t){if("input"===e||"change"===e)return qn(t)}var sr="function"==typeof Object.is?Object.is:function(e,t){return e===t&&(0!==e||1/e==1/t)||e!=e&&t!=t};function lr(e,t){if(sr(e,t))return!0;if("object"!=typeof e||null===e||"object"!=typeof t||null===t)return!1;var n=Object.keys(e),r=Object.keys(t);if(n.length!==r.length)return!1;for(r=0;r<n.length;r++){var o=n[r];if(!d.call(t,o)||!sr(e[o],t[o]))return!1}return!0}function cr(e){for(;e&&e.firstChild;)e=e.firstChild;return e}function ur(e,t){var n,r=cr(e);for(e=0;r;){if(3===r.nodeType){if(n=e+r.textContent.length,e<=t&&n>=t)return{node:r,offset:t-e};e=n}e:{for(;r;){if(r.nextSibling){r=r.nextSibling;break e}r=r.parentNode}r=void 0}r=cr(r)}}function dr(e,t){return!(!e||!t)&&(e===t||(!e||3!==e.nodeType)&&(t&&3===t.nodeType?dr(e,t.parentNode):"contains"in e?e.contains(t):!!e.compareDocumentPosition&&!!(16&e.compareDocumentPosition(t))))}function pr(){for(var e=window,t=Q();t instanceof e.HTMLIFrameElement;){try{var n="string"==typeof t.contentWindow.location.href}catch(e){n=!1}if(!n)break;t=Q((e=t.contentWindow).document)}return t}function fr(e){var t=e&&e.nodeName&&e.nodeName.toLowerCase();return t&&("input"===t&&("text"===e.type||"search"===e.type||"tel"===e.type||"url"===e.type||"password"===e.type)||"textarea"===t||"true"===e.contentEditable)}function hr(e){var t=pr(),n=e.focusedElem,r=e.selectionRange;if(t!==n&&n&&n.ownerDocument&&dr(n.ownerDocument.documentElement,n)){if(null!==r&&fr(n))if(t=r.start,void 0===(e=r.end)&&(e=t),"selectionStart"in n)n.selectionStart=t,n.selectionEnd=Math.min(e,n.value.length);else if((e=(t=n.ownerDocument||document)&&t.defaultView||window).getSelection){e=e.getSelection();var o=n.textContent.length,i=Math.min(r.start,o);r=void 0===r.end?i:Math.min(r.end,o),!e.extend&&i>r&&(o=r,r=i,i=o),o=ur(n,i);var a=ur(n,r);o&&a&&(1!==e.rangeCount||e.anchorNode!==o.node||e.anchorOffset!==o.offset||e.focusNode!==a.node||e.focusOffset!==a.offset)&&((t=t.createRange()).setStart(o.node,o.offset),e.removeAllRanges(),i>r?(e.addRange(t),e.extend(a.node,a.offset)):(t.setEnd(a.node,a.offset),e.addRange(t)))}for(t=[],e=n;e=e.parentNode;)1===e.nodeType&&t.push({element:e,left:e.scrollLeft,top:e.scrollTop});for("function"==typeof n.focus&&n.focus(),n=0;n<t.length;n++)(e=t[n]).element.scrollLeft=e.left,e.element.scrollTop=e.top}}var mr=u&&"documentMode"in document&&11>=document.documentMode,gr=null,vr=null,yr=null,br=!1;function _r(e,t,n){var r=n.window===n?n.document:9===n.nodeType?n:n.ownerDocument;br||null==gr||gr!==Q(r)||("selectionStart"in(r=gr)&&fr(r)?r={start:r.selectionStart,end:r.selectionEnd}:r={anchorNode:(r=(r.ownerDocument&&r.ownerDocument.defaultView||window).getSelection()).anchorNode,anchorOffset:r.anchorOffset,focusNode:r.focusNode,focusOffset:r.focusOffset},yr&&lr(yr,r)||(yr=r,0<(r=Vr(vr,"onSelect")).length&&(t=new un("onSelect","select",null,t,n),e.push({event:t,listeners:r}),t.target=gr)))}function Ar(e,t){var n={};return n[e.toLowerCase()]=t.toLowerCase(),n["Webkit"+e]="webkit"+t,n["Moz"+e]="moz"+t,n}var Er={animationend:Ar("Animation","AnimationEnd"),animationiteration:Ar("Animation","AnimationIteration"),animationstart:Ar("Animation","AnimationStart"),transitionend:Ar("Transition","TransitionEnd")},wr={},xr={};function kr(e){if(wr[e])return wr[e];if(!Er[e])return e;var t,n=Er[e];for(t in n)if(n.hasOwnProperty(t)&&t in xr)return wr[e]=n[t];return e}u&&(xr=document.createElement("div").style,"AnimationEvent"in window||(delete Er.animationend.animation,delete Er.animationiteration.animation,delete Er.animationstart.animation),"TransitionEvent"in window||delete Er.transitionend.transition);var Cr=kr("animationend"),Sr=kr("animationiteration"),Mr=kr("animationstart"),Tr=kr("transitionend"),Or=new Map,Dr="abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");function Lr(e,t){Or.set(e,t),l(t,[e])}for(var Pr=0;Pr<Dr.length;Pr++){var Ir=Dr[Pr];Lr(Ir.toLowerCase(),"on"+(Ir[0].toUpperCase()+Ir.slice(1)))}Lr(Cr,"onAnimationEnd"),Lr(Sr,"onAnimationIteration"),Lr(Mr,"onAnimationStart"),Lr("dblclick","onDoubleClick"),Lr("focusin","onFocus"),Lr("focusout","onBlur"),Lr(Tr,"onTransitionEnd"),c("onMouseEnter",["mouseout","mouseover"]),c("onMouseLeave",["mouseout","mouseover"]),c("onPointerEnter",["pointerout","pointerover"]),c("onPointerLeave",["pointerout","pointerover"]),l("onChange","change click focusin focusout input keydown keyup selectionchange".split(" ")),l("onSelect","focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")),l("onBeforeInput",["compositionend","keypress","textInput","paste"]),l("onCompositionEnd","compositionend focusout keydown keypress keyup mousedown".split(" ")),l("onCompositionStart","compositionstart focusout keydown keypress keyup mousedown".split(" ")),l("onCompositionUpdate","compositionupdate focusout keydown keypress keyup mousedown".split(" "));var Br="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),Rr=new Set("cancel close invalid load scroll toggle".split(" ").concat(Br));function Nr(e,t,n){var r=e.type||"unknown-event";e.currentTarget=n,function(e,t,n,r,o,a,s,l,c){if($e.apply(this,arguments),Re){if(!Re)throw Error(i(198));var u=Ne;Re=!1,Ne=null,Fe||(Fe=!0,je=u)}}(r,t,void 0,e),e.currentTarget=null}function Fr(e,t){t=!!(4&t);for(var n=0;n<e.length;n++){var r=e[n],o=r.event;r=r.listeners;e:{var i=void 0;if(t)for(var a=r.length-1;0<=a;a--){var s=r[a],l=s.instance,c=s.currentTarget;if(s=s.listener,l!==i&&o.isPropagationStopped())break e;Nr(o,s,c),i=l}else for(a=0;a<r.length;a++){if(l=(s=r[a]).instance,c=s.currentTarget,s=s.listener,l!==i&&o.isPropagationStopped())break e;Nr(o,s,c),i=l}}}if(Fe)throw e=je,Fe=!1,je=null,e}function jr(e,t){var n=t[go];void 0===n&&(n=t[go]=new Set);var r=e+"__bubble";n.has(r)||(Ur(t,e,2,!1),n.add(r))}function Yr(e,t,n){var r=0;t&&(r|=4),Ur(n,e,r,t)}var $r="_reactListening"+Math.random().toString(36).slice(2);function Hr(e){if(!e[$r]){e[$r]=!0,a.forEach((function(t){"selectionchange"!==t&&(Rr.has(t)||Yr(t,!1,e),Yr(t,!0,e))}));var t=9===e.nodeType?e:e.ownerDocument;null===t||t[$r]||(t[$r]=!0,Yr("selectionchange",!1,t))}}function Ur(e,t,n,r){switch(Kt(t)){case 1:var o=Wt;break;case 4:o=Vt;break;default:o=Gt}n=o.bind(null,t,n,e),o=void 0,!Pe||"touchstart"!==t&&"touchmove"!==t&&"wheel"!==t||(o=!0),r?void 0!==o?e.addEventListener(t,n,{capture:!0,passive:o}):e.addEventListener(t,n,!0):void 0!==o?e.addEventListener(t,n,{passive:o}):e.addEventListener(t,n,!1)}function zr(e,t,n,r,o){var i=r;if(!(1&t||2&t||null===r))e:for(;;){if(null===r)return;var a=r.tag;if(3===a||4===a){var s=r.stateNode.containerInfo;if(s===o||8===s.nodeType&&s.parentNode===o)break;if(4===a)for(a=r.return;null!==a;){var l=a.tag;if((3===l||4===l)&&((l=a.stateNode.containerInfo)===o||8===l.nodeType&&l.parentNode===o))return;a=a.return}for(;null!==s;){if(null===(a=bo(s)))return;if(5===(l=a.tag)||6===l){r=i=a;continue e}s=s.parentNode}}r=r.return}De((function(){var r=i,o=Ae(n),a=[];e:{var s=Or.get(e);if(void 0!==s){var l=un,c=e;switch(e){case"keypress":if(0===tn(n))break e;case"keydown":case"keyup":l=Sn;break;case"focusin":c="focus",l=gn;break;case"focusout":c="blur",l=gn;break;case"beforeblur":case"afterblur":l=gn;break;case"click":if(2===n.button)break e;case"auxclick":case"dblclick":case"mousedown":case"mousemove":case"mouseup":case"mouseout":case"mouseover":case"contextmenu":l=hn;break;case"drag":case"dragend":case"dragenter":case"dragexit":case"dragleave":case"dragover":case"dragstart":case"drop":l=mn;break;case"touchcancel":case"touchend":case"touchmove":case"touchstart":l=Tn;break;case Cr:case Sr:case Mr:l=vn;break;case Tr:l=On;break;case"scroll":l=pn;break;case"wheel":l=Ln;break;case"copy":case"cut":case"paste":l=bn;break;case"gotpointercapture":case"lostpointercapture":case"pointercancel":case"pointerdown":case"pointermove":case"pointerout":case"pointerover":case"pointerup":l=Mn}var u=!!(4&t),d=!u&&"scroll"===e,p=u?null!==s?s+"Capture":null:s;u=[];for(var f,h=r;null!==h;){var m=(f=h).stateNode;if(5===f.tag&&null!==m&&(f=m,null!==p&&(null!=(m=Le(h,p))&&u.push(Wr(h,m,f)))),d)break;h=h.return}0<u.length&&(s=new l(s,c,null,n,o),a.push({event:s,listeners:u}))}}if(!(7&t)){if(l="mouseout"===e||"pointerout"===e,(!(s="mouseover"===e||"pointerover"===e)||n===_e||!(c=n.relatedTarget||n.fromElement)||!bo(c)&&!c[mo])&&(l||s)&&(s=o.window===o?o:(s=o.ownerDocument)?s.defaultView||s.parentWindow:window,l?(l=r,null!==(c=(c=n.relatedTarget||n.toElement)?bo(c):null)&&(c!==(d=He(c))||5!==c.tag&&6!==c.tag)&&(c=null)):(l=null,c=r),l!==c)){if(u=hn,m="onMouseLeave",p="onMouseEnter",h="mouse","pointerout"!==e&&"pointerover"!==e||(u=Mn,m="onPointerLeave",p="onPointerEnter",h="pointer"),d=null==l?s:Ao(l),f=null==c?s:Ao(c),(s=new u(m,h+"leave",l,n,o)).target=d,s.relatedTarget=f,m=null,bo(o)===r&&((u=new u(p,h+"enter",c,n,o)).target=f,u.relatedTarget=d,m=u),d=m,l&&c)e:{for(p=c,h=0,f=u=l;f;f=Gr(f))h++;for(f=0,m=p;m;m=Gr(m))f++;for(;0<h-f;)u=Gr(u),h--;for(;0<f-h;)p=Gr(p),f--;for(;h--;){if(u===p||null!==p&&u===p.alternate)break e;u=Gr(u),p=Gr(p)}u=null}else u=null;null!==l&&Qr(a,s,l,u,!1),null!==c&&null!==d&&Qr(a,d,c,u,!0)}if("select"===(l=(s=r?Ao(r):window).nodeName&&s.nodeName.toLowerCase())||"input"===l&&"file"===s.type)var g=Kn;else if(zn(s))if(Zn)g=ar;else{g=or;var v=rr}else(l=s.nodeName)&&"input"===l.toLowerCase()&&("checkbox"===s.type||"radio"===s.type)&&(g=ir);switch(g&&(g=g(e,r))?Wn(a,g,n,o):(v&&v(e,s,r),"focusout"===e&&(v=s._wrapperState)&&v.controlled&&"number"===s.type&&ee(s,"number",s.value)),v=r?Ao(r):window,e){case"focusin":(zn(v)||"true"===v.contentEditable)&&(gr=v,vr=r,yr=null);break;case"focusout":yr=vr=gr=null;break;case"mousedown":br=!0;break;case"contextmenu":case"mouseup":case"dragend":br=!1,_r(a,n,o);break;case"selectionchange":if(mr)break;case"keydown":case"keyup":_r(a,n,o)}var y;if(In)e:{switch(e){case"compositionstart":var b="onCompositionStart";break e;case"compositionend":b="onCompositionEnd";break e;case"compositionupdate":b="onCompositionUpdate";break e}b=void 0}else Hn?Yn(e,n)&&(b="onCompositionEnd"):"keydown"===e&&229===n.keyCode&&(b="onCompositionStart");b&&(Nn&&"ko"!==n.locale&&(Hn||"onCompositionStart"!==b?"onCompositionEnd"===b&&Hn&&(y=en()):(Jt="value"in(Zt=o)?Zt.value:Zt.textContent,Hn=!0)),0<(v=Vr(r,b)).length&&(b=new _n(b,e,null,n,o),a.push({event:b,listeners:v}),y?b.data=y:null!==(y=$n(n))&&(b.data=y))),(y=Rn?function(e,t){switch(e){case"compositionend":return $n(t);case"keypress":return 32!==t.which?null:(jn=!0,Fn);case"textInput":return(e=t.data)===Fn&&jn?null:e;default:return null}}(e,n):function(e,t){if(Hn)return"compositionend"===e||!In&&Yn(e,t)?(e=en(),Xt=Jt=Zt=null,Hn=!1,e):null;switch(e){case"paste":default:return null;case"keypress":if(!(t.ctrlKey||t.altKey||t.metaKey)||t.ctrlKey&&t.altKey){if(t.char&&1<t.char.length)return t.char;if(t.which)return String.fromCharCode(t.which)}return null;case"compositionend":return Nn&&"ko"!==t.locale?null:t.data}}(e,n))&&(0<(r=Vr(r,"onBeforeInput")).length&&(o=new _n("onBeforeInput","beforeinput",null,n,o),a.push({event:o,listeners:r}),o.data=y))}Fr(a,t)}))}function Wr(e,t,n){return{instance:e,listener:t,currentTarget:n}}function Vr(e,t){for(var n=t+"Capture",r=[];null!==e;){var o=e,i=o.stateNode;5===o.tag&&null!==i&&(o=i,null!=(i=Le(e,n))&&r.unshift(Wr(e,i,o)),null!=(i=Le(e,t))&&r.push(Wr(e,i,o))),e=e.return}return r}function Gr(e){if(null===e)return null;do{e=e.return}while(e&&5!==e.tag);return e||null}function Qr(e,t,n,r,o){for(var i=t._reactName,a=[];null!==n&&n!==r;){var s=n,l=s.alternate,c=s.stateNode;if(null!==l&&l===r)break;5===s.tag&&null!==c&&(s=c,o?null!=(l=Le(n,i))&&a.unshift(Wr(n,l,s)):o||null!=(l=Le(n,i))&&a.push(Wr(n,l,s))),n=n.return}0!==a.length&&e.push({event:t,listeners:a})}var qr=/\r\n?/g,Kr=/\u0000|\uFFFD/g;function Zr(e){return("string"==typeof e?e:""+e).replace(qr,"\n").replace(Kr,"")}function Jr(e,t,n){if(t=Zr(t),Zr(e)!==t&&n)throw Error(i(425))}function Xr(){}var eo=null,to=null;function no(e,t){return"textarea"===e||"noscript"===e||"string"==typeof t.children||"number"==typeof t.children||"object"==typeof t.dangerouslySetInnerHTML&&null!==t.dangerouslySetInnerHTML&&null!=t.dangerouslySetInnerHTML.__html}var ro="function"==typeof setTimeout?setTimeout:void 0,oo="function"==typeof clearTimeout?clearTimeout:void 0,io="function"==typeof Promise?Promise:void 0,ao="function"==typeof queueMicrotask?queueMicrotask:void 0!==io?function(e){return io.resolve(null).then(e).catch(so)}:ro;function so(e){setTimeout((function(){throw e}))}function lo(e,t){var n=t,r=0;do{var o=n.nextSibling;if(e.removeChild(n),o&&8===o.nodeType)if("/$"===(n=o.data)){if(0===r)return e.removeChild(o),void Ht(t);r--}else"$"!==n&&"$?"!==n&&"$!"!==n||r++;n=o}while(n);Ht(t)}function co(e){for(;null!=e;e=e.nextSibling){var t=e.nodeType;if(1===t||3===t)break;if(8===t){if("$"===(t=e.data)||"$!"===t||"$?"===t)break;if("/$"===t)return null}}return e}function uo(e){e=e.previousSibling;for(var t=0;e;){if(8===e.nodeType){var n=e.data;if("$"===n||"$!"===n||"$?"===n){if(0===t)return e;t--}else"/$"===n&&t++}e=e.previousSibling}return null}var po=Math.random().toString(36).slice(2),fo="__reactFiber$"+po,ho="__reactProps$"+po,mo="__reactContainer$"+po,go="__reactEvents$"+po,vo="__reactListeners$"+po,yo="__reactHandles$"+po;function bo(e){var t=e[fo];if(t)return t;for(var n=e.parentNode;n;){if(t=n[mo]||n[fo]){if(n=t.alternate,null!==t.child||null!==n&&null!==n.child)for(e=uo(e);null!==e;){if(n=e[fo])return n;e=uo(e)}return t}n=(e=n).parentNode}return null}function _o(e){return!(e=e[fo]||e[mo])||5!==e.tag&&6!==e.tag&&13!==e.tag&&3!==e.tag?null:e}function Ao(e){if(5===e.tag||6===e.tag)return e.stateNode;throw Error(i(33))}function Eo(e){return e[ho]||null}var wo=[],xo=-1;function ko(e){return{current:e}}function Co(e){0>xo||(e.current=wo[xo],wo[xo]=null,xo--)}function So(e,t){xo++,wo[xo]=e.current,e.current=t}var Mo={},To=ko(Mo),Oo=ko(!1),Do=Mo;function Lo(e,t){var n=e.type.contextTypes;if(!n)return Mo;var r=e.stateNode;if(r&&r.__reactInternalMemoizedUnmaskedChildContext===t)return r.__reactInternalMemoizedMaskedChildContext;var o,i={};for(o in n)i[o]=t[o];return r&&((e=e.stateNode).__reactInternalMemoizedUnmaskedChildContext=t,e.__reactInternalMemoizedMaskedChildContext=i),i}function Po(e){return null!=(e=e.childContextTypes)}function Io(){Co(Oo),Co(To)}function Bo(e,t,n){if(To.current!==Mo)throw Error(i(168));So(To,t),So(Oo,n)}function Ro(e,t,n){var r=e.stateNode;if(t=t.childContextTypes,"function"!=typeof r.getChildContext)return n;for(var o in r=r.getChildContext())if(!(o in t))throw Error(i(108,U(e)||"Unknown",o));return N({},n,r)}function No(e){return e=(e=e.stateNode)&&e.__reactInternalMemoizedMergedChildContext||Mo,Do=To.current,So(To,e),So(Oo,Oo.current),!0}function Fo(e,t,n){var r=e.stateNode;if(!r)throw Error(i(169));n?(e=Ro(e,t,Do),r.__reactInternalMemoizedMergedChildContext=e,Co(Oo),Co(To),So(To,e)):Co(Oo),So(Oo,n)}var jo=null,Yo=!1,$o=!1;function Ho(e){null===jo?jo=[e]:jo.push(e)}function Uo(){if(!$o&&null!==jo){$o=!0;var e=0,t=bt;try{var n=jo;for(bt=1;e<n.length;e++){var r=n[e];do{r=r(!0)}while(null!==r)}jo=null,Yo=!1}catch(t){throw null!==jo&&(jo=jo.slice(e+1)),Ge(Xe,Uo),t}finally{bt=t,$o=!1}}return null}var zo=[],Wo=0,Vo=null,Go=0,Qo=[],qo=0,Ko=null,Zo=1,Jo="";function Xo(e,t){zo[Wo++]=Go,zo[Wo++]=Vo,Vo=e,Go=t}function ei(e,t,n){Qo[qo++]=Zo,Qo[qo++]=Jo,Qo[qo++]=Ko,Ko=e;var r=Zo;e=Jo;var o=32-at(r)-1;r&=~(1<<o),n+=1;var i=32-at(t)+o;if(30<i){var a=o-o%5;i=(r&(1<<a)-1).toString(32),r>>=a,o-=a,Zo=1<<32-at(t)+o|n<<o|r,Jo=i+e}else Zo=1<<i|n<<o|r,Jo=e}function ti(e){null!==e.return&&(Xo(e,1),ei(e,1,0))}function ni(e){for(;e===Vo;)Vo=zo[--Wo],zo[Wo]=null,Go=zo[--Wo],zo[Wo]=null;for(;e===Ko;)Ko=Qo[--qo],Qo[qo]=null,Jo=Qo[--qo],Qo[qo]=null,Zo=Qo[--qo],Qo[qo]=null}var ri=null,oi=null,ii=!1,ai=null;function si(e,t){var n=Dc(5,null,null,0);n.elementType="DELETED",n.stateNode=t,n.return=e,null===(t=e.deletions)?(e.deletions=[n],e.flags|=16):t.push(n)}function li(e,t){switch(e.tag){case 5:var n=e.type;return null!==(t=1!==t.nodeType||n.toLowerCase()!==t.nodeName.toLowerCase()?null:t)&&(e.stateNode=t,ri=e,oi=co(t.firstChild),!0);case 6:return null!==(t=""===e.pendingProps||3!==t.nodeType?null:t)&&(e.stateNode=t,ri=e,oi=null,!0);case 13:return null!==(t=8!==t.nodeType?null:t)&&(n=null!==Ko?{id:Zo,overflow:Jo}:null,e.memoizedState={dehydrated:t,treeContext:n,retryLane:1073741824},(n=Dc(18,null,null,0)).stateNode=t,n.return=e,e.child=n,ri=e,oi=null,!0);default:return!1}}function ci(e){return!(!(1&e.mode)||128&e.flags)}function ui(e){if(ii){var t=oi;if(t){var n=t;if(!li(e,t)){if(ci(e))throw Error(i(418));t=co(n.nextSibling);var r=ri;t&&li(e,t)?si(r,n):(e.flags=-4097&e.flags|2,ii=!1,ri=e)}}else{if(ci(e))throw Error(i(418));e.flags=-4097&e.flags|2,ii=!1,ri=e}}}function di(e){for(e=e.return;null!==e&&5!==e.tag&&3!==e.tag&&13!==e.tag;)e=e.return;ri=e}function pi(e){if(e!==ri)return!1;if(!ii)return di(e),ii=!0,!1;var t;if((t=3!==e.tag)&&!(t=5!==e.tag)&&(t="head"!==(t=e.type)&&"body"!==t&&!no(e.type,e.memoizedProps)),t&&(t=oi)){if(ci(e))throw fi(),Error(i(418));for(;t;)si(e,t),t=co(t.nextSibling)}if(di(e),13===e.tag){if(!(e=null!==(e=e.memoizedState)?e.dehydrated:null))throw Error(i(317));e:{for(e=e.nextSibling,t=0;e;){if(8===e.nodeType){var n=e.data;if("/$"===n){if(0===t){oi=co(e.nextSibling);break e}t--}else"$"!==n&&"$!"!==n&&"$?"!==n||t++}e=e.nextSibling}oi=null}}else oi=ri?co(e.stateNode.nextSibling):null;return!0}function fi(){for(var e=oi;e;)e=co(e.nextSibling)}function hi(){oi=ri=null,ii=!1}function mi(e){null===ai?ai=[e]:ai.push(e)}var gi=_.ReactCurrentBatchConfig;function vi(e,t,n){if(null!==(e=n.ref)&&"function"!=typeof e&&"object"!=typeof e){if(n._owner){if(n=n._owner){if(1!==n.tag)throw Error(i(309));var r=n.stateNode}if(!r)throw Error(i(147,e));var o=r,a=""+e;return null!==t&&null!==t.ref&&"function"==typeof t.ref&&t.ref._stringRef===a?t.ref:(t=function(e){var t=o.refs;null===e?delete t[a]:t[a]=e},t._stringRef=a,t)}if("string"!=typeof e)throw Error(i(284));if(!n._owner)throw Error(i(290,e))}return e}function yi(e,t){throw e=Object.prototype.toString.call(t),Error(i(31,"[object Object]"===e?"object with keys {"+Object.keys(t).join(", ")+"}":e))}function bi(e){return(0,e._init)(e._payload)}function _i(e){function t(t,n){if(e){var r=t.deletions;null===r?(t.deletions=[n],t.flags|=16):r.push(n)}}function n(n,r){if(!e)return null;for(;null!==r;)t(n,r),r=r.sibling;return null}function r(e,t){for(e=new Map;null!==t;)null!==t.key?e.set(t.key,t):e.set(t.index,t),t=t.sibling;return e}function o(e,t){return(e=Pc(e,t)).index=0,e.sibling=null,e}function a(t,n,r){return t.index=r,e?null!==(r=t.alternate)?(r=r.index)<n?(t.flags|=2,n):r:(t.flags|=2,n):(t.flags|=1048576,n)}function s(t){return e&&null===t.alternate&&(t.flags|=2),t}function l(e,t,n,r){return null===t||6!==t.tag?((t=Nc(n,e.mode,r)).return=e,t):((t=o(t,n)).return=e,t)}function c(e,t,n,r){var i=n.type;return i===w?d(e,t,n.props.children,r,n.key):null!==t&&(t.elementType===i||"object"==typeof i&&null!==i&&i.$$typeof===L&&bi(i)===t.type)?((r=o(t,n.props)).ref=vi(e,t,n),r.return=e,r):((r=Ic(n.type,n.key,n.props,null,e.mode,r)).ref=vi(e,t,n),r.return=e,r)}function u(e,t,n,r){return null===t||4!==t.tag||t.stateNode.containerInfo!==n.containerInfo||t.stateNode.implementation!==n.implementation?((t=Fc(n,e.mode,r)).return=e,t):((t=o(t,n.children||[])).return=e,t)}function d(e,t,n,r,i){return null===t||7!==t.tag?((t=Bc(n,e.mode,r,i)).return=e,t):((t=o(t,n)).return=e,t)}function p(e,t,n){if("string"==typeof t&&""!==t||"number"==typeof t)return(t=Nc(""+t,e.mode,n)).return=e,t;if("object"==typeof t&&null!==t){switch(t.$$typeof){case A:return(n=Ic(t.type,t.key,t.props,null,e.mode,n)).ref=vi(e,null,t),n.return=e,n;case E:return(t=Fc(t,e.mode,n)).return=e,t;case L:return p(e,(0,t._init)(t._payload),n)}if(te(t)||B(t))return(t=Bc(t,e.mode,n,null)).return=e,t;yi(e,t)}return null}function f(e,t,n,r){var o=null!==t?t.key:null;if("string"==typeof n&&""!==n||"number"==typeof n)return null!==o?null:l(e,t,""+n,r);if("object"==typeof n&&null!==n){switch(n.$$typeof){case A:return n.key===o?c(e,t,n,r):null;case E:return n.key===o?u(e,t,n,r):null;case L:return f(e,t,(o=n._init)(n._payload),r)}if(te(n)||B(n))return null!==o?null:d(e,t,n,r,null);yi(e,n)}return null}function h(e,t,n,r,o){if("string"==typeof r&&""!==r||"number"==typeof r)return l(t,e=e.get(n)||null,""+r,o);if("object"==typeof r&&null!==r){switch(r.$$typeof){case A:return c(t,e=e.get(null===r.key?n:r.key)||null,r,o);case E:return u(t,e=e.get(null===r.key?n:r.key)||null,r,o);case L:return h(e,t,n,(0,r._init)(r._payload),o)}if(te(r)||B(r))return d(t,e=e.get(n)||null,r,o,null);yi(t,r)}return null}function m(o,i,s,l){for(var c=null,u=null,d=i,m=i=0,g=null;null!==d&&m<s.length;m++){d.index>m?(g=d,d=null):g=d.sibling;var v=f(o,d,s[m],l);if(null===v){null===d&&(d=g);break}e&&d&&null===v.alternate&&t(o,d),i=a(v,i,m),null===u?c=v:u.sibling=v,u=v,d=g}if(m===s.length)return n(o,d),ii&&Xo(o,m),c;if(null===d){for(;m<s.length;m++)null!==(d=p(o,s[m],l))&&(i=a(d,i,m),null===u?c=d:u.sibling=d,u=d);return ii&&Xo(o,m),c}for(d=r(o,d);m<s.length;m++)null!==(g=h(d,o,m,s[m],l))&&(e&&null!==g.alternate&&d.delete(null===g.key?m:g.key),i=a(g,i,m),null===u?c=g:u.sibling=g,u=g);return e&&d.forEach((function(e){return t(o,e)})),ii&&Xo(o,m),c}function g(o,s,l,c){var u=B(l);if("function"!=typeof u)throw Error(i(150));if(null==(l=u.call(l)))throw Error(i(151));for(var d=u=null,m=s,g=s=0,v=null,y=l.next();null!==m&&!y.done;g++,y=l.next()){m.index>g?(v=m,m=null):v=m.sibling;var b=f(o,m,y.value,c);if(null===b){null===m&&(m=v);break}e&&m&&null===b.alternate&&t(o,m),s=a(b,s,g),null===d?u=b:d.sibling=b,d=b,m=v}if(y.done)return n(o,m),ii&&Xo(o,g),u;if(null===m){for(;!y.done;g++,y=l.next())null!==(y=p(o,y.value,c))&&(s=a(y,s,g),null===d?u=y:d.sibling=y,d=y);return ii&&Xo(o,g),u}for(m=r(o,m);!y.done;g++,y=l.next())null!==(y=h(m,o,g,y.value,c))&&(e&&null!==y.alternate&&m.delete(null===y.key?g:y.key),s=a(y,s,g),null===d?u=y:d.sibling=y,d=y);return e&&m.forEach((function(e){return t(o,e)})),ii&&Xo(o,g),u}return function e(r,i,a,l){if("object"==typeof a&&null!==a&&a.type===w&&null===a.key&&(a=a.props.children),"object"==typeof a&&null!==a){switch(a.$$typeof){case A:e:{for(var c=a.key,u=i;null!==u;){if(u.key===c){if((c=a.type)===w){if(7===u.tag){n(r,u.sibling),(i=o(u,a.props.children)).return=r,r=i;break e}}else if(u.elementType===c||"object"==typeof c&&null!==c&&c.$$typeof===L&&bi(c)===u.type){n(r,u.sibling),(i=o(u,a.props)).ref=vi(r,u,a),i.return=r,r=i;break e}n(r,u);break}t(r,u),u=u.sibling}a.type===w?((i=Bc(a.props.children,r.mode,l,a.key)).return=r,r=i):((l=Ic(a.type,a.key,a.props,null,r.mode,l)).ref=vi(r,i,a),l.return=r,r=l)}return s(r);case E:e:{for(u=a.key;null!==i;){if(i.key===u){if(4===i.tag&&i.stateNode.containerInfo===a.containerInfo&&i.stateNode.implementation===a.implementation){n(r,i.sibling),(i=o(i,a.children||[])).return=r,r=i;break e}n(r,i);break}t(r,i),i=i.sibling}(i=Fc(a,r.mode,l)).return=r,r=i}return s(r);case L:return e(r,i,(u=a._init)(a._payload),l)}if(te(a))return m(r,i,a,l);if(B(a))return g(r,i,a,l);yi(r,a)}return"string"==typeof a&&""!==a||"number"==typeof a?(a=""+a,null!==i&&6===i.tag?(n(r,i.sibling),(i=o(i,a)).return=r,r=i):(n(r,i),(i=Nc(a,r.mode,l)).return=r,r=i),s(r)):n(r,i)}}var Ai=_i(!0),Ei=_i(!1),wi=ko(null),xi=null,ki=null,Ci=null;function Si(){Ci=ki=xi=null}function Mi(e){var t=wi.current;Co(wi),e._currentValue=t}function Ti(e,t,n){for(;null!==e;){var r=e.alternate;if((e.childLanes&t)!==t?(e.childLanes|=t,null!==r&&(r.childLanes|=t)):null!==r&&(r.childLanes&t)!==t&&(r.childLanes|=t),e===n)break;e=e.return}}function Oi(e,t){xi=e,Ci=ki=null,null!==(e=e.dependencies)&&null!==e.firstContext&&(!!(e.lanes&t)&&(bs=!0),e.firstContext=null)}function Di(e){var t=e._currentValue;if(Ci!==e)if(e={context:e,memoizedValue:t,next:null},null===ki){if(null===xi)throw Error(i(308));ki=e,xi.dependencies={lanes:0,firstContext:e}}else ki=ki.next=e;return t}var Li=null;function Pi(e){null===Li?Li=[e]:Li.push(e)}function Ii(e,t,n,r){var o=t.interleaved;return null===o?(n.next=n,Pi(t)):(n.next=o.next,o.next=n),t.interleaved=n,Bi(e,r)}function Bi(e,t){e.lanes|=t;var n=e.alternate;for(null!==n&&(n.lanes|=t),n=e,e=e.return;null!==e;)e.childLanes|=t,null!==(n=e.alternate)&&(n.childLanes|=t),n=e,e=e.return;return 3===n.tag?n.stateNode:null}var Ri=!1;function Ni(e){e.updateQueue={baseState:e.memoizedState,firstBaseUpdate:null,lastBaseUpdate:null,shared:{pending:null,interleaved:null,lanes:0},effects:null}}function Fi(e,t){e=e.updateQueue,t.updateQueue===e&&(t.updateQueue={baseState:e.baseState,firstBaseUpdate:e.firstBaseUpdate,lastBaseUpdate:e.lastBaseUpdate,shared:e.shared,effects:e.effects})}function ji(e,t){return{eventTime:e,lane:t,tag:0,payload:null,callback:null,next:null}}function Yi(e,t,n){var r=e.updateQueue;if(null===r)return null;if(r=r.shared,2&Ml){var o=r.pending;return null===o?t.next=t:(t.next=o.next,o.next=t),r.pending=t,Bi(e,n)}return null===(o=r.interleaved)?(t.next=t,Pi(r)):(t.next=o.next,o.next=t),r.interleaved=t,Bi(e,n)}function $i(e,t,n){if(null!==(t=t.updateQueue)&&(t=t.shared,4194240&n)){var r=t.lanes;n|=r&=e.pendingLanes,t.lanes=n,yt(e,n)}}function Hi(e,t){var n=e.updateQueue,r=e.alternate;if(null!==r&&n===(r=r.updateQueue)){var o=null,i=null;if(null!==(n=n.firstBaseUpdate)){do{var a={eventTime:n.eventTime,lane:n.lane,tag:n.tag,payload:n.payload,callback:n.callback,next:null};null===i?o=i=a:i=i.next=a,n=n.next}while(null!==n);null===i?o=i=t:i=i.next=t}else o=i=t;return n={baseState:r.baseState,firstBaseUpdate:o,lastBaseUpdate:i,shared:r.shared,effects:r.effects},void(e.updateQueue=n)}null===(e=n.lastBaseUpdate)?n.firstBaseUpdate=t:e.next=t,n.lastBaseUpdate=t}function Ui(e,t,n,r){var o=e.updateQueue;Ri=!1;var i=o.firstBaseUpdate,a=o.lastBaseUpdate,s=o.shared.pending;if(null!==s){o.shared.pending=null;var l=s,c=l.next;l.next=null,null===a?i=c:a.next=c,a=l;var u=e.alternate;null!==u&&((s=(u=u.updateQueue).lastBaseUpdate)!==a&&(null===s?u.firstBaseUpdate=c:s.next=c,u.lastBaseUpdate=l))}if(null!==i){var d=o.baseState;for(a=0,u=c=l=null,s=i;;){var p=s.lane,f=s.eventTime;if((r&p)===p){null!==u&&(u=u.next={eventTime:f,lane:0,tag:s.tag,payload:s.payload,callback:s.callback,next:null});e:{var h=e,m=s;switch(p=t,f=n,m.tag){case 1:if("function"==typeof(h=m.payload)){d=h.call(f,d,p);break e}d=h;break e;case 3:h.flags=-65537&h.flags|128;case 0:if(null==(p="function"==typeof(h=m.payload)?h.call(f,d,p):h))break e;d=N({},d,p);break e;case 2:Ri=!0}}null!==s.callback&&0!==s.lane&&(e.flags|=64,null===(p=o.effects)?o.effects=[s]:p.push(s))}else f={eventTime:f,lane:p,tag:s.tag,payload:s.payload,callback:s.callback,next:null},null===u?(c=u=f,l=d):u=u.next=f,a|=p;if(null===(s=s.next)){if(null===(s=o.shared.pending))break;s=(p=s).next,p.next=null,o.lastBaseUpdate=p,o.shared.pending=null}}if(null===u&&(l=d),o.baseState=l,o.firstBaseUpdate=c,o.lastBaseUpdate=u,null!==(t=o.shared.interleaved)){o=t;do{a|=o.lane,o=o.next}while(o!==t)}else null===i&&(o.shared.lanes=0);Rl|=a,e.lanes=a,e.memoizedState=d}}function zi(e,t,n){if(e=t.effects,t.effects=null,null!==e)for(t=0;t<e.length;t++){var r=e[t],o=r.callback;if(null!==o){if(r.callback=null,r=n,"function"!=typeof o)throw Error(i(191,o));o.call(r)}}}var Wi={},Vi=ko(Wi),Gi=ko(Wi),Qi=ko(Wi);function qi(e){if(e===Wi)throw Error(i(174));return e}function Ki(e,t){switch(So(Qi,t),So(Gi,e),So(Vi,Wi),e=t.nodeType){case 9:case 11:t=(t=t.documentElement)?t.namespaceURI:le(null,"");break;default:t=le(t=(e=8===e?t.parentNode:t).namespaceURI||null,e=e.tagName)}Co(Vi),So(Vi,t)}function Zi(){Co(Vi),Co(Gi),Co(Qi)}function Ji(e){qi(Qi.current);var t=qi(Vi.current),n=le(t,e.type);t!==n&&(So(Gi,e),So(Vi,n))}function Xi(e){Gi.current===e&&(Co(Vi),Co(Gi))}var ea=ko(0);function ta(e){for(var t=e;null!==t;){if(13===t.tag){var n=t.memoizedState;if(null!==n&&(null===(n=n.dehydrated)||"$?"===n.data||"$!"===n.data))return t}else if(19===t.tag&&void 0!==t.memoizedProps.revealOrder){if(128&t.flags)return t}else if(null!==t.child){t.child.return=t,t=t.child;continue}if(t===e)break;for(;null===t.sibling;){if(null===t.return||t.return===e)return null;t=t.return}t.sibling.return=t.return,t=t.sibling}return null}var na=[];function ra(){for(var e=0;e<na.length;e++)na[e]._workInProgressVersionPrimary=null;na.length=0}var oa=_.ReactCurrentDispatcher,ia=_.ReactCurrentBatchConfig,aa=0,sa=null,la=null,ca=null,ua=!1,da=!1,pa=0,fa=0;function ha(){throw Error(i(321))}function ma(e,t){if(null===t)return!1;for(var n=0;n<t.length&&n<e.length;n++)if(!sr(e[n],t[n]))return!1;return!0}function ga(e,t,n,r,o,a){if(aa=a,sa=t,t.memoizedState=null,t.updateQueue=null,t.lanes=0,oa.current=null===e||null===e.memoizedState?Xa:es,e=n(r,o),da){a=0;do{if(da=!1,pa=0,25<=a)throw Error(i(301));a+=1,ca=la=null,t.updateQueue=null,oa.current=ts,e=n(r,o)}while(da)}if(oa.current=Ja,t=null!==la&&null!==la.next,aa=0,ca=la=sa=null,ua=!1,t)throw Error(i(300));return e}function va(){var e=0!==pa;return pa=0,e}function ya(){var e={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};return null===ca?sa.memoizedState=ca=e:ca=ca.next=e,ca}function ba(){if(null===la){var e=sa.alternate;e=null!==e?e.memoizedState:null}else e=la.next;var t=null===ca?sa.memoizedState:ca.next;if(null!==t)ca=t,la=e;else{if(null===e)throw Error(i(310));e={memoizedState:(la=e).memoizedState,baseState:la.baseState,baseQueue:la.baseQueue,queue:la.queue,next:null},null===ca?sa.memoizedState=ca=e:ca=ca.next=e}return ca}function _a(e,t){return"function"==typeof t?t(e):t}function Aa(e){var t=ba(),n=t.queue;if(null===n)throw Error(i(311));n.lastRenderedReducer=e;var r=la,o=r.baseQueue,a=n.pending;if(null!==a){if(null!==o){var s=o.next;o.next=a.next,a.next=s}r.baseQueue=o=a,n.pending=null}if(null!==o){a=o.next,r=r.baseState;var l=s=null,c=null,u=a;do{var d=u.lane;if((aa&d)===d)null!==c&&(c=c.next={lane:0,action:u.action,hasEagerState:u.hasEagerState,eagerState:u.eagerState,next:null}),r=u.hasEagerState?u.eagerState:e(r,u.action);else{var p={lane:d,action:u.action,hasEagerState:u.hasEagerState,eagerState:u.eagerState,next:null};null===c?(l=c=p,s=r):c=c.next=p,sa.lanes|=d,Rl|=d}u=u.next}while(null!==u&&u!==a);null===c?s=r:c.next=l,sr(r,t.memoizedState)||(bs=!0),t.memoizedState=r,t.baseState=s,t.baseQueue=c,n.lastRenderedState=r}if(null!==(e=n.interleaved)){o=e;do{a=o.lane,sa.lanes|=a,Rl|=a,o=o.next}while(o!==e)}else null===o&&(n.lanes=0);return[t.memoizedState,n.dispatch]}function Ea(e){var t=ba(),n=t.queue;if(null===n)throw Error(i(311));n.lastRenderedReducer=e;var r=n.dispatch,o=n.pending,a=t.memoizedState;if(null!==o){n.pending=null;var s=o=o.next;do{a=e(a,s.action),s=s.next}while(s!==o);sr(a,t.memoizedState)||(bs=!0),t.memoizedState=a,null===t.baseQueue&&(t.baseState=a),n.lastRenderedState=a}return[a,r]}function wa(){}function xa(e,t){var n=sa,r=ba(),o=t(),a=!sr(r.memoizedState,o);if(a&&(r.memoizedState=o,bs=!0),r=r.queue,Ra(Sa.bind(null,n,r,e),[e]),r.getSnapshot!==t||a||null!==ca&&1&ca.memoizedState.tag){if(n.flags|=2048,Da(9,Ca.bind(null,n,r,o,t),void 0,null),null===Tl)throw Error(i(349));30&aa||ka(n,t,o)}return o}function ka(e,t,n){e.flags|=16384,e={getSnapshot:t,value:n},null===(t=sa.updateQueue)?(t={lastEffect:null,stores:null},sa.updateQueue=t,t.stores=[e]):null===(n=t.stores)?t.stores=[e]:n.push(e)}function Ca(e,t,n,r){t.value=n,t.getSnapshot=r,Ma(t)&&Ta(e)}function Sa(e,t,n){return n((function(){Ma(t)&&Ta(e)}))}function Ma(e){var t=e.getSnapshot;e=e.value;try{var n=t();return!sr(e,n)}catch(e){return!0}}function Ta(e){var t=Bi(e,1);null!==t&&nc(t,e,1,-1)}function Oa(e){var t=ya();return"function"==typeof e&&(e=e()),t.memoizedState=t.baseState=e,e={pending:null,interleaved:null,lanes:0,dispatch:null,lastRenderedReducer:_a,lastRenderedState:e},t.queue=e,e=e.dispatch=Qa.bind(null,sa,e),[t.memoizedState,e]}function Da(e,t,n,r){return e={tag:e,create:t,destroy:n,deps:r,next:null},null===(t=sa.updateQueue)?(t={lastEffect:null,stores:null},sa.updateQueue=t,t.lastEffect=e.next=e):null===(n=t.lastEffect)?t.lastEffect=e.next=e:(r=n.next,n.next=e,e.next=r,t.lastEffect=e),e}function La(){return ba().memoizedState}function Pa(e,t,n,r){var o=ya();sa.flags|=e,o.memoizedState=Da(1|t,n,void 0,void 0===r?null:r)}function Ia(e,t,n,r){var o=ba();r=void 0===r?null:r;var i=void 0;if(null!==la){var a=la.memoizedState;if(i=a.destroy,null!==r&&ma(r,a.deps))return void(o.memoizedState=Da(t,n,i,r))}sa.flags|=e,o.memoizedState=Da(1|t,n,i,r)}function Ba(e,t){return Pa(8390656,8,e,t)}function Ra(e,t){return Ia(2048,8,e,t)}function Na(e,t){return Ia(4,2,e,t)}function Fa(e,t){return Ia(4,4,e,t)}function ja(e,t){return"function"==typeof t?(e=e(),t(e),function(){t(null)}):null!=t?(e=e(),t.current=e,function(){t.current=null}):void 0}function Ya(e,t,n){return n=null!=n?n.concat([e]):null,Ia(4,4,ja.bind(null,t,e),n)}function $a(){}function Ha(e,t){var n=ba();t=void 0===t?null:t;var r=n.memoizedState;return null!==r&&null!==t&&ma(t,r[1])?r[0]:(n.memoizedState=[e,t],e)}function Ua(e,t){var n=ba();t=void 0===t?null:t;var r=n.memoizedState;return null!==r&&null!==t&&ma(t,r[1])?r[0]:(e=e(),n.memoizedState=[e,t],e)}function za(e,t,n){return 21&aa?(sr(n,t)||(n=mt(),sa.lanes|=n,Rl|=n,e.baseState=!0),t):(e.baseState&&(e.baseState=!1,bs=!0),e.memoizedState=n)}function Wa(e,t){var n=bt;bt=0!==n&&4>n?n:4,e(!0);var r=ia.transition;ia.transition={};try{e(!1),t()}finally{bt=n,ia.transition=r}}function Va(){return ba().memoizedState}function Ga(e,t,n){var r=tc(e);if(n={lane:r,action:n,hasEagerState:!1,eagerState:null,next:null},qa(e))Ka(t,n);else if(null!==(n=Ii(e,t,n,r))){nc(n,e,r,ec()),Za(n,t,r)}}function Qa(e,t,n){var r=tc(e),o={lane:r,action:n,hasEagerState:!1,eagerState:null,next:null};if(qa(e))Ka(t,o);else{var i=e.alternate;if(0===e.lanes&&(null===i||0===i.lanes)&&null!==(i=t.lastRenderedReducer))try{var a=t.lastRenderedState,s=i(a,n);if(o.hasEagerState=!0,o.eagerState=s,sr(s,a)){var l=t.interleaved;return null===l?(o.next=o,Pi(t)):(o.next=l.next,l.next=o),void(t.interleaved=o)}}catch(e){}null!==(n=Ii(e,t,o,r))&&(nc(n,e,r,o=ec()),Za(n,t,r))}}function qa(e){var t=e.alternate;return e===sa||null!==t&&t===sa}function Ka(e,t){da=ua=!0;var n=e.pending;null===n?t.next=t:(t.next=n.next,n.next=t),e.pending=t}function Za(e,t,n){if(4194240&n){var r=t.lanes;n|=r&=e.pendingLanes,t.lanes=n,yt(e,n)}}var Ja={readContext:Di,useCallback:ha,useContext:ha,useEffect:ha,useImperativeHandle:ha,useInsertionEffect:ha,useLayoutEffect:ha,useMemo:ha,useReducer:ha,useRef:ha,useState:ha,useDebugValue:ha,useDeferredValue:ha,useTransition:ha,useMutableSource:ha,useSyncExternalStore:ha,useId:ha,unstable_isNewReconciler:!1},Xa={readContext:Di,useCallback:function(e,t){return ya().memoizedState=[e,void 0===t?null:t],e},useContext:Di,useEffect:Ba,useImperativeHandle:function(e,t,n){return n=null!=n?n.concat([e]):null,Pa(4194308,4,ja.bind(null,t,e),n)},useLayoutEffect:function(e,t){return Pa(4194308,4,e,t)},useInsertionEffect:function(e,t){return Pa(4,2,e,t)},useMemo:function(e,t){var n=ya();return t=void 0===t?null:t,e=e(),n.memoizedState=[e,t],e},useReducer:function(e,t,n){var r=ya();return t=void 0!==n?n(t):t,r.memoizedState=r.baseState=t,e={pending:null,interleaved:null,lanes:0,dispatch:null,lastRenderedReducer:e,lastRenderedState:t},r.queue=e,e=e.dispatch=Ga.bind(null,sa,e),[r.memoizedState,e]},useRef:function(e){return e={current:e},ya().memoizedState=e},useState:Oa,useDebugValue:$a,useDeferredValue:function(e){return ya().memoizedState=e},useTransition:function(){var e=Oa(!1),t=e[0];return e=Wa.bind(null,e[1]),ya().memoizedState=e,[t,e]},useMutableSource:function(){},useSyncExternalStore:function(e,t,n){var r=sa,o=ya();if(ii){if(void 0===n)throw Error(i(407));n=n()}else{if(n=t(),null===Tl)throw Error(i(349));30&aa||ka(r,t,n)}o.memoizedState=n;var a={value:n,getSnapshot:t};return o.queue=a,Ba(Sa.bind(null,r,a,e),[e]),r.flags|=2048,Da(9,Ca.bind(null,r,a,n,t),void 0,null),n},useId:function(){var e=ya(),t=Tl.identifierPrefix;if(ii){var n=Jo;t=":"+t+"R"+(n=(Zo&~(1<<32-at(Zo)-1)).toString(32)+n),0<(n=pa++)&&(t+="H"+n.toString(32)),t+=":"}else t=":"+t+"r"+(n=fa++).toString(32)+":";return e.memoizedState=t},unstable_isNewReconciler:!1},es={readContext:Di,useCallback:Ha,useContext:Di,useEffect:Ra,useImperativeHandle:Ya,useInsertionEffect:Na,useLayoutEffect:Fa,useMemo:Ua,useReducer:Aa,useRef:La,useState:function(){return Aa(_a)},useDebugValue:$a,useDeferredValue:function(e){return za(ba(),la.memoizedState,e)},useTransition:function(){return[Aa(_a)[0],ba().memoizedState]},useMutableSource:wa,useSyncExternalStore:xa,useId:Va,unstable_isNewReconciler:!1},ts={readContext:Di,useCallback:Ha,useContext:Di,useEffect:Ra,useImperativeHandle:Ya,useInsertionEffect:Na,useLayoutEffect:Fa,useMemo:Ua,useReducer:Ea,useRef:La,useState:function(){return Ea(_a)},useDebugValue:$a,useDeferredValue:function(e){var t=ba();return null===la?t.memoizedState=e:za(t,la.memoizedState,e)},useTransition:function(){return[Ea(_a)[0],ba().memoizedState]},useMutableSource:wa,useSyncExternalStore:xa,useId:Va,unstable_isNewReconciler:!1};function ns(e,t){if(e&&e.defaultProps){for(var n in t=N({},t),e=e.defaultProps)void 0===t[n]&&(t[n]=e[n]);return t}return t}function rs(e,t,n,r){n=null==(n=n(r,t=e.memoizedState))?t:N({},t,n),e.memoizedState=n,0===e.lanes&&(e.updateQueue.baseState=n)}var os={isMounted:function(e){return!!(e=e._reactInternals)&&He(e)===e},enqueueSetState:function(e,t,n){e=e._reactInternals;var r=ec(),o=tc(e),i=ji(r,o);i.payload=t,null!=n&&(i.callback=n),null!==(t=Yi(e,i,o))&&(nc(t,e,o,r),$i(t,e,o))},enqueueReplaceState:function(e,t,n){e=e._reactInternals;var r=ec(),o=tc(e),i=ji(r,o);i.tag=1,i.payload=t,null!=n&&(i.callback=n),null!==(t=Yi(e,i,o))&&(nc(t,e,o,r),$i(t,e,o))},enqueueForceUpdate:function(e,t){e=e._reactInternals;var n=ec(),r=tc(e),o=ji(n,r);o.tag=2,null!=t&&(o.callback=t),null!==(t=Yi(e,o,r))&&(nc(t,e,r,n),$i(t,e,r))}};function is(e,t,n,r,o,i,a){return"function"==typeof(e=e.stateNode).shouldComponentUpdate?e.shouldComponentUpdate(r,i,a):!t.prototype||!t.prototype.isPureReactComponent||(!lr(n,r)||!lr(o,i))}function as(e,t,n){var r=!1,o=Mo,i=t.contextType;return"object"==typeof i&&null!==i?i=Di(i):(o=Po(t)?Do:To.current,i=(r=null!=(r=t.contextTypes))?Lo(e,o):Mo),t=new t(n,i),e.memoizedState=null!==t.state&&void 0!==t.state?t.state:null,t.updater=os,e.stateNode=t,t._reactInternals=e,r&&((e=e.stateNode).__reactInternalMemoizedUnmaskedChildContext=o,e.__reactInternalMemoizedMaskedChildContext=i),t}function ss(e,t,n,r){e=t.state,"function"==typeof t.componentWillReceiveProps&&t.componentWillReceiveProps(n,r),"function"==typeof t.UNSAFE_componentWillReceiveProps&&t.UNSAFE_componentWillReceiveProps(n,r),t.state!==e&&os.enqueueReplaceState(t,t.state,null)}function ls(e,t,n,r){var o=e.stateNode;o.props=n,o.state=e.memoizedState,o.refs={},Ni(e);var i=t.contextType;"object"==typeof i&&null!==i?o.context=Di(i):(i=Po(t)?Do:To.current,o.context=Lo(e,i)),o.state=e.memoizedState,"function"==typeof(i=t.getDerivedStateFromProps)&&(rs(e,t,i,n),o.state=e.memoizedState),"function"==typeof t.getDerivedStateFromProps||"function"==typeof o.getSnapshotBeforeUpdate||"function"!=typeof o.UNSAFE_componentWillMount&&"function"!=typeof o.componentWillMount||(t=o.state,"function"==typeof o.componentWillMount&&o.componentWillMount(),"function"==typeof o.UNSAFE_componentWillMount&&o.UNSAFE_componentWillMount(),t!==o.state&&os.enqueueReplaceState(o,o.state,null),Ui(e,n,o,r),o.state=e.memoizedState),"function"==typeof o.componentDidMount&&(e.flags|=4194308)}function cs(e,t){try{var n="",r=t;do{n+=$(r),r=r.return}while(r);var o=n}catch(e){o="\nError generating stack: "+e.message+"\n"+e.stack}return{value:e,source:t,stack:o,digest:null}}function us(e,t,n){return{value:e,source:null,stack:null!=n?n:null,digest:null!=t?t:null}}function ds(e,t){try{console.error(t.value)}catch(e){setTimeout((function(){throw e}))}}var ps="function"==typeof WeakMap?WeakMap:Map;function fs(e,t,n){(n=ji(-1,n)).tag=3,n.payload={element:null};var r=t.value;return n.callback=function(){zl||(zl=!0,Wl=r),ds(0,t)},n}function hs(e,t,n){(n=ji(-1,n)).tag=3;var r=e.type.getDerivedStateFromError;if("function"==typeof r){var o=t.value;n.payload=function(){return r(o)},n.callback=function(){ds(0,t)}}var i=e.stateNode;return null!==i&&"function"==typeof i.componentDidCatch&&(n.callback=function(){ds(0,t),"function"!=typeof r&&(null===Vl?Vl=new Set([this]):Vl.add(this));var e=t.stack;this.componentDidCatch(t.value,{componentStack:null!==e?e:""})}),n}function ms(e,t,n){var r=e.pingCache;if(null===r){r=e.pingCache=new ps;var o=new Set;r.set(t,o)}else void 0===(o=r.get(t))&&(o=new Set,r.set(t,o));o.has(n)||(o.add(n),e=kc.bind(null,e,t,n),t.then(e,e))}function gs(e){do{var t;if((t=13===e.tag)&&(t=null===(t=e.memoizedState)||null!==t.dehydrated),t)return e;e=e.return}while(null!==e);return null}function vs(e,t,n,r,o){return 1&e.mode?(e.flags|=65536,e.lanes=o,e):(e===t?e.flags|=65536:(e.flags|=128,n.flags|=131072,n.flags&=-52805,1===n.tag&&(null===n.alternate?n.tag=17:((t=ji(-1,1)).tag=2,Yi(n,t,1))),n.lanes|=1),e)}var ys=_.ReactCurrentOwner,bs=!1;function _s(e,t,n,r){t.child=null===e?Ei(t,null,n,r):Ai(t,e.child,n,r)}function As(e,t,n,r,o){n=n.render;var i=t.ref;return Oi(t,o),r=ga(e,t,n,r,i,o),n=va(),null===e||bs?(ii&&n&&ti(t),t.flags|=1,_s(e,t,r,o),t.child):(t.updateQueue=e.updateQueue,t.flags&=-2053,e.lanes&=~o,zs(e,t,o))}function Es(e,t,n,r,o){if(null===e){var i=n.type;return"function"!=typeof i||Lc(i)||void 0!==i.defaultProps||null!==n.compare||void 0!==n.defaultProps?((e=Ic(n.type,null,r,t,t.mode,o)).ref=t.ref,e.return=t,t.child=e):(t.tag=15,t.type=i,ws(e,t,i,r,o))}if(i=e.child,!(e.lanes&o)){var a=i.memoizedProps;if((n=null!==(n=n.compare)?n:lr)(a,r)&&e.ref===t.ref)return zs(e,t,o)}return t.flags|=1,(e=Pc(i,r)).ref=t.ref,e.return=t,t.child=e}function ws(e,t,n,r,o){if(null!==e){var i=e.memoizedProps;if(lr(i,r)&&e.ref===t.ref){if(bs=!1,t.pendingProps=r=i,!(e.lanes&o))return t.lanes=e.lanes,zs(e,t,o);131072&e.flags&&(bs=!0)}}return Cs(e,t,n,r,o)}function xs(e,t,n){var r=t.pendingProps,o=r.children,i=null!==e?e.memoizedState:null;if("hidden"===r.mode)if(1&t.mode){if(!(1073741824&n))return e=null!==i?i.baseLanes|n:n,t.lanes=t.childLanes=1073741824,t.memoizedState={baseLanes:e,cachePool:null,transitions:null},t.updateQueue=null,So(Pl,Ll),Ll|=e,null;t.memoizedState={baseLanes:0,cachePool:null,transitions:null},r=null!==i?i.baseLanes:n,So(Pl,Ll),Ll|=r}else t.memoizedState={baseLanes:0,cachePool:null,transitions:null},So(Pl,Ll),Ll|=n;else null!==i?(r=i.baseLanes|n,t.memoizedState=null):r=n,So(Pl,Ll),Ll|=r;return _s(e,t,o,n),t.child}function ks(e,t){var n=t.ref;(null===e&&null!==n||null!==e&&e.ref!==n)&&(t.flags|=512,t.flags|=2097152)}function Cs(e,t,n,r,o){var i=Po(n)?Do:To.current;return i=Lo(t,i),Oi(t,o),n=ga(e,t,n,r,i,o),r=va(),null===e||bs?(ii&&r&&ti(t),t.flags|=1,_s(e,t,n,o),t.child):(t.updateQueue=e.updateQueue,t.flags&=-2053,e.lanes&=~o,zs(e,t,o))}function Ss(e,t,n,r,o){if(Po(n)){var i=!0;No(t)}else i=!1;if(Oi(t,o),null===t.stateNode)Us(e,t),as(t,n,r),ls(t,n,r,o),r=!0;else if(null===e){var a=t.stateNode,s=t.memoizedProps;a.props=s;var l=a.context,c=n.contextType;"object"==typeof c&&null!==c?c=Di(c):c=Lo(t,c=Po(n)?Do:To.current);var u=n.getDerivedStateFromProps,d="function"==typeof u||"function"==typeof a.getSnapshotBeforeUpdate;d||"function"!=typeof a.UNSAFE_componentWillReceiveProps&&"function"!=typeof a.componentWillReceiveProps||(s!==r||l!==c)&&ss(t,a,r,c),Ri=!1;var p=t.memoizedState;a.state=p,Ui(t,r,a,o),l=t.memoizedState,s!==r||p!==l||Oo.current||Ri?("function"==typeof u&&(rs(t,n,u,r),l=t.memoizedState),(s=Ri||is(t,n,s,r,p,l,c))?(d||"function"!=typeof a.UNSAFE_componentWillMount&&"function"!=typeof a.componentWillMount||("function"==typeof a.componentWillMount&&a.componentWillMount(),"function"==typeof a.UNSAFE_componentWillMount&&a.UNSAFE_componentWillMount()),"function"==typeof a.componentDidMount&&(t.flags|=4194308)):("function"==typeof a.componentDidMount&&(t.flags|=4194308),t.memoizedProps=r,t.memoizedState=l),a.props=r,a.state=l,a.context=c,r=s):("function"==typeof a.componentDidMount&&(t.flags|=4194308),r=!1)}else{a=t.stateNode,Fi(e,t),s=t.memoizedProps,c=t.type===t.elementType?s:ns(t.type,s),a.props=c,d=t.pendingProps,p=a.context,"object"==typeof(l=n.contextType)&&null!==l?l=Di(l):l=Lo(t,l=Po(n)?Do:To.current);var f=n.getDerivedStateFromProps;(u="function"==typeof f||"function"==typeof a.getSnapshotBeforeUpdate)||"function"!=typeof a.UNSAFE_componentWillReceiveProps&&"function"!=typeof a.componentWillReceiveProps||(s!==d||p!==l)&&ss(t,a,r,l),Ri=!1,p=t.memoizedState,a.state=p,Ui(t,r,a,o);var h=t.memoizedState;s!==d||p!==h||Oo.current||Ri?("function"==typeof f&&(rs(t,n,f,r),h=t.memoizedState),(c=Ri||is(t,n,c,r,p,h,l)||!1)?(u||"function"!=typeof a.UNSAFE_componentWillUpdate&&"function"!=typeof a.componentWillUpdate||("function"==typeof a.componentWillUpdate&&a.componentWillUpdate(r,h,l),"function"==typeof a.UNSAFE_componentWillUpdate&&a.UNSAFE_componentWillUpdate(r,h,l)),"function"==typeof a.componentDidUpdate&&(t.flags|=4),"function"==typeof a.getSnapshotBeforeUpdate&&(t.flags|=1024)):("function"!=typeof a.componentDidUpdate||s===e.memoizedProps&&p===e.memoizedState||(t.flags|=4),"function"!=typeof a.getSnapshotBeforeUpdate||s===e.memoizedProps&&p===e.memoizedState||(t.flags|=1024),t.memoizedProps=r,t.memoizedState=h),a.props=r,a.state=h,a.context=l,r=c):("function"!=typeof a.componentDidUpdate||s===e.memoizedProps&&p===e.memoizedState||(t.flags|=4),"function"!=typeof a.getSnapshotBeforeUpdate||s===e.memoizedProps&&p===e.memoizedState||(t.flags|=1024),r=!1)}return Ms(e,t,n,r,i,o)}function Ms(e,t,n,r,o,i){ks(e,t);var a=!!(128&t.flags);if(!r&&!a)return o&&Fo(t,n,!1),zs(e,t,i);r=t.stateNode,ys.current=t;var s=a&&"function"!=typeof n.getDerivedStateFromError?null:r.render();return t.flags|=1,null!==e&&a?(t.child=Ai(t,e.child,null,i),t.child=Ai(t,null,s,i)):_s(e,t,s,i),t.memoizedState=r.state,o&&Fo(t,n,!0),t.child}function Ts(e){var t=e.stateNode;t.pendingContext?Bo(0,t.pendingContext,t.pendingContext!==t.context):t.context&&Bo(0,t.context,!1),Ki(e,t.containerInfo)}function Os(e,t,n,r,o){return hi(),mi(o),t.flags|=256,_s(e,t,n,r),t.child}var Ds,Ls,Ps,Is,Bs={dehydrated:null,treeContext:null,retryLane:0};function Rs(e){return{baseLanes:e,cachePool:null,transitions:null}}function Ns(e,t,n){var r,o=t.pendingProps,a=ea.current,s=!1,l=!!(128&t.flags);if((r=l)||(r=(null===e||null!==e.memoizedState)&&!!(2&a)),r?(s=!0,t.flags&=-129):null!==e&&null===e.memoizedState||(a|=1),So(ea,1&a),null===e)return ui(t),null!==(e=t.memoizedState)&&null!==(e=e.dehydrated)?(1&t.mode?"$!"===e.data?t.lanes=8:t.lanes=1073741824:t.lanes=1,null):(l=o.children,e=o.fallback,s?(o=t.mode,s=t.child,l={mode:"hidden",children:l},1&o||null===s?s=Rc(l,o,0,null):(s.childLanes=0,s.pendingProps=l),e=Bc(e,o,n,null),s.return=t,e.return=t,s.sibling=e,t.child=s,t.child.memoizedState=Rs(n),t.memoizedState=Bs,e):Fs(t,l));if(null!==(a=e.memoizedState)&&null!==(r=a.dehydrated))return function(e,t,n,r,o,a,s){if(n)return 256&t.flags?(t.flags&=-257,js(e,t,s,r=us(Error(i(422))))):null!==t.memoizedState?(t.child=e.child,t.flags|=128,null):(a=r.fallback,o=t.mode,r=Rc({mode:"visible",children:r.children},o,0,null),(a=Bc(a,o,s,null)).flags|=2,r.return=t,a.return=t,r.sibling=a,t.child=r,1&t.mode&&Ai(t,e.child,null,s),t.child.memoizedState=Rs(s),t.memoizedState=Bs,a);if(!(1&t.mode))return js(e,t,s,null);if("$!"===o.data){if(r=o.nextSibling&&o.nextSibling.dataset)var l=r.dgst;return r=l,js(e,t,s,r=us(a=Error(i(419)),r,void 0))}if(l=!!(s&e.childLanes),bs||l){if(null!==(r=Tl)){switch(s&-s){case 4:o=2;break;case 16:o=8;break;case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:o=32;break;case 536870912:o=268435456;break;default:o=0}0!==(o=o&(r.suspendedLanes|s)?0:o)&&o!==a.retryLane&&(a.retryLane=o,Bi(e,o),nc(r,e,o,-1))}return mc(),js(e,t,s,r=us(Error(i(421))))}return"$?"===o.data?(t.flags|=128,t.child=e.child,t=Sc.bind(null,e),o._reactRetry=t,null):(e=a.treeContext,oi=co(o.nextSibling),ri=t,ii=!0,ai=null,null!==e&&(Qo[qo++]=Zo,Qo[qo++]=Jo,Qo[qo++]=Ko,Zo=e.id,Jo=e.overflow,Ko=t),t=Fs(t,r.children),t.flags|=4096,t)}(e,t,l,o,r,a,n);if(s){s=o.fallback,l=t.mode,r=(a=e.child).sibling;var c={mode:"hidden",children:o.children};return 1&l||t.child===a?(o=Pc(a,c)).subtreeFlags=14680064&a.subtreeFlags:((o=t.child).childLanes=0,o.pendingProps=c,t.deletions=null),null!==r?s=Pc(r,s):(s=Bc(s,l,n,null)).flags|=2,s.return=t,o.return=t,o.sibling=s,t.child=o,o=s,s=t.child,l=null===(l=e.child.memoizedState)?Rs(n):{baseLanes:l.baseLanes|n,cachePool:null,transitions:l.transitions},s.memoizedState=l,s.childLanes=e.childLanes&~n,t.memoizedState=Bs,o}return e=(s=e.child).sibling,o=Pc(s,{mode:"visible",children:o.children}),!(1&t.mode)&&(o.lanes=n),o.return=t,o.sibling=null,null!==e&&(null===(n=t.deletions)?(t.deletions=[e],t.flags|=16):n.push(e)),t.child=o,t.memoizedState=null,o}function Fs(e,t){return(t=Rc({mode:"visible",children:t},e.mode,0,null)).return=e,e.child=t}function js(e,t,n,r){return null!==r&&mi(r),Ai(t,e.child,null,n),(e=Fs(t,t.pendingProps.children)).flags|=2,t.memoizedState=null,e}function Ys(e,t,n){e.lanes|=t;var r=e.alternate;null!==r&&(r.lanes|=t),Ti(e.return,t,n)}function $s(e,t,n,r,o){var i=e.memoizedState;null===i?e.memoizedState={isBackwards:t,rendering:null,renderingStartTime:0,last:r,tail:n,tailMode:o}:(i.isBackwards=t,i.rendering=null,i.renderingStartTime=0,i.last=r,i.tail=n,i.tailMode=o)}function Hs(e,t,n){var r=t.pendingProps,o=r.revealOrder,i=r.tail;if(_s(e,t,r.children,n),2&(r=ea.current))r=1&r|2,t.flags|=128;else{if(null!==e&&128&e.flags)e:for(e=t.child;null!==e;){if(13===e.tag)null!==e.memoizedState&&Ys(e,n,t);else if(19===e.tag)Ys(e,n,t);else if(null!==e.child){e.child.return=e,e=e.child;continue}if(e===t)break e;for(;null===e.sibling;){if(null===e.return||e.return===t)break e;e=e.return}e.sibling.return=e.return,e=e.sibling}r&=1}if(So(ea,r),1&t.mode)switch(o){case"forwards":for(n=t.child,o=null;null!==n;)null!==(e=n.alternate)&&null===ta(e)&&(o=n),n=n.sibling;null===(n=o)?(o=t.child,t.child=null):(o=n.sibling,n.sibling=null),$s(t,!1,o,n,i);break;case"backwards":for(n=null,o=t.child,t.child=null;null!==o;){if(null!==(e=o.alternate)&&null===ta(e)){t.child=o;break}e=o.sibling,o.sibling=n,n=o,o=e}$s(t,!0,n,null,i);break;case"together":$s(t,!1,null,null,void 0);break;default:t.memoizedState=null}else t.memoizedState=null;return t.child}function Us(e,t){!(1&t.mode)&&null!==e&&(e.alternate=null,t.alternate=null,t.flags|=2)}function zs(e,t,n){if(null!==e&&(t.dependencies=e.dependencies),Rl|=t.lanes,!(n&t.childLanes))return null;if(null!==e&&t.child!==e.child)throw Error(i(153));if(null!==t.child){for(n=Pc(e=t.child,e.pendingProps),t.child=n,n.return=t;null!==e.sibling;)e=e.sibling,(n=n.sibling=Pc(e,e.pendingProps)).return=t;n.sibling=null}return t.child}function Ws(e,t){if(!ii)switch(e.tailMode){case"hidden":t=e.tail;for(var n=null;null!==t;)null!==t.alternate&&(n=t),t=t.sibling;null===n?e.tail=null:n.sibling=null;break;case"collapsed":n=e.tail;for(var r=null;null!==n;)null!==n.alternate&&(r=n),n=n.sibling;null===r?t||null===e.tail?e.tail=null:e.tail.sibling=null:r.sibling=null}}function Vs(e){var t=null!==e.alternate&&e.alternate.child===e.child,n=0,r=0;if(t)for(var o=e.child;null!==o;)n|=o.lanes|o.childLanes,r|=14680064&o.subtreeFlags,r|=14680064&o.flags,o.return=e,o=o.sibling;else for(o=e.child;null!==o;)n|=o.lanes|o.childLanes,r|=o.subtreeFlags,r|=o.flags,o.return=e,o=o.sibling;return e.subtreeFlags|=r,e.childLanes=n,t}function Gs(e,t,n){var r=t.pendingProps;switch(ni(t),t.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return Vs(t),null;case 1:case 17:return Po(t.type)&&Io(),Vs(t),null;case 3:return r=t.stateNode,Zi(),Co(Oo),Co(To),ra(),r.pendingContext&&(r.context=r.pendingContext,r.pendingContext=null),null!==e&&null!==e.child||(pi(t)?t.flags|=4:null===e||e.memoizedState.isDehydrated&&!(256&t.flags)||(t.flags|=1024,null!==ai&&(ac(ai),ai=null))),Ls(e,t),Vs(t),null;case 5:Xi(t);var o=qi(Qi.current);if(n=t.type,null!==e&&null!=t.stateNode)Ps(e,t,n,r,o),e.ref!==t.ref&&(t.flags|=512,t.flags|=2097152);else{if(!r){if(null===t.stateNode)throw Error(i(166));return Vs(t),null}if(e=qi(Vi.current),pi(t)){r=t.stateNode,n=t.type;var a=t.memoizedProps;switch(r[fo]=t,r[ho]=a,e=!!(1&t.mode),n){case"dialog":jr("cancel",r),jr("close",r);break;case"iframe":case"object":case"embed":jr("load",r);break;case"video":case"audio":for(o=0;o<Br.length;o++)jr(Br[o],r);break;case"source":jr("error",r);break;case"img":case"image":case"link":jr("error",r),jr("load",r);break;case"details":jr("toggle",r);break;case"input":K(r,a),jr("invalid",r);break;case"select":r._wrapperState={wasMultiple:!!a.multiple},jr("invalid",r);break;case"textarea":oe(r,a),jr("invalid",r)}for(var l in ye(n,a),o=null,a)if(a.hasOwnProperty(l)){var c=a[l];"children"===l?"string"==typeof c?r.textContent!==c&&(!0!==a.suppressHydrationWarning&&Jr(r.textContent,c,e),o=["children",c]):"number"==typeof c&&r.textContent!==""+c&&(!0!==a.suppressHydrationWarning&&Jr(r.textContent,c,e),o=["children",""+c]):s.hasOwnProperty(l)&&null!=c&&"onScroll"===l&&jr("scroll",r)}switch(n){case"input":V(r),X(r,a,!0);break;case"textarea":V(r),ae(r);break;case"select":case"option":break;default:"function"==typeof a.onClick&&(r.onclick=Xr)}r=o,t.updateQueue=r,null!==r&&(t.flags|=4)}else{l=9===o.nodeType?o:o.ownerDocument,"http://www.w3.org/1999/xhtml"===e&&(e=se(n)),"http://www.w3.org/1999/xhtml"===e?"script"===n?((e=l.createElement("div")).innerHTML="<script><\/script>",e=e.removeChild(e.firstChild)):"string"==typeof r.is?e=l.createElement(n,{is:r.is}):(e=l.createElement(n),"select"===n&&(l=e,r.multiple?l.multiple=!0:r.size&&(l.size=r.size))):e=l.createElementNS(e,n),e[fo]=t,e[ho]=r,Ds(e,t,!1,!1),t.stateNode=e;e:{switch(l=be(n,r),n){case"dialog":jr("cancel",e),jr("close",e),o=r;break;case"iframe":case"object":case"embed":jr("load",e),o=r;break;case"video":case"audio":for(o=0;o<Br.length;o++)jr(Br[o],e);o=r;break;case"source":jr("error",e),o=r;break;case"img":case"image":case"link":jr("error",e),jr("load",e),o=r;break;case"details":jr("toggle",e),o=r;break;case"input":K(e,r),o=q(e,r),jr("invalid",e);break;case"option":default:o=r;break;case"select":e._wrapperState={wasMultiple:!!r.multiple},o=N({},r,{value:void 0}),jr("invalid",e);break;case"textarea":oe(e,r),o=re(e,r),jr("invalid",e)}for(a in ye(n,o),c=o)if(c.hasOwnProperty(a)){var u=c[a];"style"===a?ge(e,u):"dangerouslySetInnerHTML"===a?null!=(u=u?u.__html:void 0)&&de(e,u):"children"===a?"string"==typeof u?("textarea"!==n||""!==u)&&pe(e,u):"number"==typeof u&&pe(e,""+u):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(s.hasOwnProperty(a)?null!=u&&"onScroll"===a&&jr("scroll",e):null!=u&&b(e,a,u,l))}switch(n){case"input":V(e),X(e,r,!1);break;case"textarea":V(e),ae(e);break;case"option":null!=r.value&&e.setAttribute("value",""+z(r.value));break;case"select":e.multiple=!!r.multiple,null!=(a=r.value)?ne(e,!!r.multiple,a,!1):null!=r.defaultValue&&ne(e,!!r.multiple,r.defaultValue,!0);break;default:"function"==typeof o.onClick&&(e.onclick=Xr)}switch(n){case"button":case"input":case"select":case"textarea":r=!!r.autoFocus;break e;case"img":r=!0;break e;default:r=!1}}r&&(t.flags|=4)}null!==t.ref&&(t.flags|=512,t.flags|=2097152)}return Vs(t),null;case 6:if(e&&null!=t.stateNode)Is(e,t,e.memoizedProps,r);else{if("string"!=typeof r&&null===t.stateNode)throw Error(i(166));if(n=qi(Qi.current),qi(Vi.current),pi(t)){if(r=t.stateNode,n=t.memoizedProps,r[fo]=t,(a=r.nodeValue!==n)&&null!==(e=ri))switch(e.tag){case 3:Jr(r.nodeValue,n,!!(1&e.mode));break;case 5:!0!==e.memoizedProps.suppressHydrationWarning&&Jr(r.nodeValue,n,!!(1&e.mode))}a&&(t.flags|=4)}else(r=(9===n.nodeType?n:n.ownerDocument).createTextNode(r))[fo]=t,t.stateNode=r}return Vs(t),null;case 13:if(Co(ea),r=t.memoizedState,null===e||null!==e.memoizedState&&null!==e.memoizedState.dehydrated){if(ii&&null!==oi&&1&t.mode&&!(128&t.flags))fi(),hi(),t.flags|=98560,a=!1;else if(a=pi(t),null!==r&&null!==r.dehydrated){if(null===e){if(!a)throw Error(i(318));if(!(a=null!==(a=t.memoizedState)?a.dehydrated:null))throw Error(i(317));a[fo]=t}else hi(),!(128&t.flags)&&(t.memoizedState=null),t.flags|=4;Vs(t),a=!1}else null!==ai&&(ac(ai),ai=null),a=!0;if(!a)return 65536&t.flags?t:null}return 128&t.flags?(t.lanes=n,t):((r=null!==r)!==(null!==e&&null!==e.memoizedState)&&r&&(t.child.flags|=8192,1&t.mode&&(null===e||1&ea.current?0===Il&&(Il=3):mc())),null!==t.updateQueue&&(t.flags|=4),Vs(t),null);case 4:return Zi(),Ls(e,t),null===e&&Hr(t.stateNode.containerInfo),Vs(t),null;case 10:return Mi(t.type._context),Vs(t),null;case 19:if(Co(ea),null===(a=t.memoizedState))return Vs(t),null;if(r=!!(128&t.flags),null===(l=a.rendering))if(r)Ws(a,!1);else{if(0!==Il||null!==e&&128&e.flags)for(e=t.child;null!==e;){if(null!==(l=ta(e))){for(t.flags|=128,Ws(a,!1),null!==(r=l.updateQueue)&&(t.updateQueue=r,t.flags|=4),t.subtreeFlags=0,r=n,n=t.child;null!==n;)e=r,(a=n).flags&=14680066,null===(l=a.alternate)?(a.childLanes=0,a.lanes=e,a.child=null,a.subtreeFlags=0,a.memoizedProps=null,a.memoizedState=null,a.updateQueue=null,a.dependencies=null,a.stateNode=null):(a.childLanes=l.childLanes,a.lanes=l.lanes,a.child=l.child,a.subtreeFlags=0,a.deletions=null,a.memoizedProps=l.memoizedProps,a.memoizedState=l.memoizedState,a.updateQueue=l.updateQueue,a.type=l.type,e=l.dependencies,a.dependencies=null===e?null:{lanes:e.lanes,firstContext:e.firstContext}),n=n.sibling;return So(ea,1&ea.current|2),t.child}e=e.sibling}null!==a.tail&&Ze()>Hl&&(t.flags|=128,r=!0,Ws(a,!1),t.lanes=4194304)}else{if(!r)if(null!==(e=ta(l))){if(t.flags|=128,r=!0,null!==(n=e.updateQueue)&&(t.updateQueue=n,t.flags|=4),Ws(a,!0),null===a.tail&&"hidden"===a.tailMode&&!l.alternate&&!ii)return Vs(t),null}else 2*Ze()-a.renderingStartTime>Hl&&1073741824!==n&&(t.flags|=128,r=!0,Ws(a,!1),t.lanes=4194304);a.isBackwards?(l.sibling=t.child,t.child=l):(null!==(n=a.last)?n.sibling=l:t.child=l,a.last=l)}return null!==a.tail?(t=a.tail,a.rendering=t,a.tail=t.sibling,a.renderingStartTime=Ze(),t.sibling=null,n=ea.current,So(ea,r?1&n|2:1&n),t):(Vs(t),null);case 22:case 23:return dc(),r=null!==t.memoizedState,null!==e&&null!==e.memoizedState!==r&&(t.flags|=8192),r&&1&t.mode?!!(1073741824&Ll)&&(Vs(t),6&t.subtreeFlags&&(t.flags|=8192)):Vs(t),null;case 24:case 25:return null}throw Error(i(156,t.tag))}function Qs(e,t){switch(ni(t),t.tag){case 1:return Po(t.type)&&Io(),65536&(e=t.flags)?(t.flags=-65537&e|128,t):null;case 3:return Zi(),Co(Oo),Co(To),ra(),65536&(e=t.flags)&&!(128&e)?(t.flags=-65537&e|128,t):null;case 5:return Xi(t),null;case 13:if(Co(ea),null!==(e=t.memoizedState)&&null!==e.dehydrated){if(null===t.alternate)throw Error(i(340));hi()}return 65536&(e=t.flags)?(t.flags=-65537&e|128,t):null;case 19:return Co(ea),null;case 4:return Zi(),null;case 10:return Mi(t.type._context),null;case 22:case 23:return dc(),null;default:return null}}Ds=function(e,t){for(var n=t.child;null!==n;){if(5===n.tag||6===n.tag)e.appendChild(n.stateNode);else if(4!==n.tag&&null!==n.child){n.child.return=n,n=n.child;continue}if(n===t)break;for(;null===n.sibling;){if(null===n.return||n.return===t)return;n=n.return}n.sibling.return=n.return,n=n.sibling}},Ls=function(){},Ps=function(e,t,n,r){var o=e.memoizedProps;if(o!==r){e=t.stateNode,qi(Vi.current);var i,a=null;switch(n){case"input":o=q(e,o),r=q(e,r),a=[];break;case"select":o=N({},o,{value:void 0}),r=N({},r,{value:void 0}),a=[];break;case"textarea":o=re(e,o),r=re(e,r),a=[];break;default:"function"!=typeof o.onClick&&"function"==typeof r.onClick&&(e.onclick=Xr)}for(u in ye(n,r),n=null,o)if(!r.hasOwnProperty(u)&&o.hasOwnProperty(u)&&null!=o[u])if("style"===u){var l=o[u];for(i in l)l.hasOwnProperty(i)&&(n||(n={}),n[i]="")}else"dangerouslySetInnerHTML"!==u&&"children"!==u&&"suppressContentEditableWarning"!==u&&"suppressHydrationWarning"!==u&&"autoFocus"!==u&&(s.hasOwnProperty(u)?a||(a=[]):(a=a||[]).push(u,null));for(u in r){var c=r[u];if(l=null!=o?o[u]:void 0,r.hasOwnProperty(u)&&c!==l&&(null!=c||null!=l))if("style"===u)if(l){for(i in l)!l.hasOwnProperty(i)||c&&c.hasOwnProperty(i)||(n||(n={}),n[i]="");for(i in c)c.hasOwnProperty(i)&&l[i]!==c[i]&&(n||(n={}),n[i]=c[i])}else n||(a||(a=[]),a.push(u,n)),n=c;else"dangerouslySetInnerHTML"===u?(c=c?c.__html:void 0,l=l?l.__html:void 0,null!=c&&l!==c&&(a=a||[]).push(u,c)):"children"===u?"string"!=typeof c&&"number"!=typeof c||(a=a||[]).push(u,""+c):"suppressContentEditableWarning"!==u&&"suppressHydrationWarning"!==u&&(s.hasOwnProperty(u)?(null!=c&&"onScroll"===u&&jr("scroll",e),a||l===c||(a=[])):(a=a||[]).push(u,c))}n&&(a=a||[]).push("style",n);var u=a;(t.updateQueue=u)&&(t.flags|=4)}},Is=function(e,t,n,r){n!==r&&(t.flags|=4)};var qs=!1,Ks=!1,Zs="function"==typeof WeakSet?WeakSet:Set,Js=null;function Xs(e,t){var n=e.ref;if(null!==n)if("function"==typeof n)try{n(null)}catch(n){xc(e,t,n)}else n.current=null}function el(e,t,n){try{n()}catch(n){xc(e,t,n)}}var tl=!1;function nl(e,t,n){var r=t.updateQueue;if(null!==(r=null!==r?r.lastEffect:null)){var o=r=r.next;do{if((o.tag&e)===e){var i=o.destroy;o.destroy=void 0,void 0!==i&&el(t,n,i)}o=o.next}while(o!==r)}}function rl(e,t){if(null!==(t=null!==(t=t.updateQueue)?t.lastEffect:null)){var n=t=t.next;do{if((n.tag&e)===e){var r=n.create;n.destroy=r()}n=n.next}while(n!==t)}}function ol(e){var t=e.ref;if(null!==t){var n=e.stateNode;e.tag,e=n,"function"==typeof t?t(e):t.current=e}}function il(e){var t=e.alternate;null!==t&&(e.alternate=null,il(t)),e.child=null,e.deletions=null,e.sibling=null,5===e.tag&&(null!==(t=e.stateNode)&&(delete t[fo],delete t[ho],delete t[go],delete t[vo],delete t[yo])),e.stateNode=null,e.return=null,e.dependencies=null,e.memoizedProps=null,e.memoizedState=null,e.pendingProps=null,e.stateNode=null,e.updateQueue=null}function al(e){return 5===e.tag||3===e.tag||4===e.tag}function sl(e){e:for(;;){for(;null===e.sibling;){if(null===e.return||al(e.return))return null;e=e.return}for(e.sibling.return=e.return,e=e.sibling;5!==e.tag&&6!==e.tag&&18!==e.tag;){if(2&e.flags)continue e;if(null===e.child||4===e.tag)continue e;e.child.return=e,e=e.child}if(!(2&e.flags))return e.stateNode}}function ll(e,t,n){var r=e.tag;if(5===r||6===r)e=e.stateNode,t?8===n.nodeType?n.parentNode.insertBefore(e,t):n.insertBefore(e,t):(8===n.nodeType?(t=n.parentNode).insertBefore(e,n):(t=n).appendChild(e),null!=(n=n._reactRootContainer)||null!==t.onclick||(t.onclick=Xr));else if(4!==r&&null!==(e=e.child))for(ll(e,t,n),e=e.sibling;null!==e;)ll(e,t,n),e=e.sibling}function cl(e,t,n){var r=e.tag;if(5===r||6===r)e=e.stateNode,t?n.insertBefore(e,t):n.appendChild(e);else if(4!==r&&null!==(e=e.child))for(cl(e,t,n),e=e.sibling;null!==e;)cl(e,t,n),e=e.sibling}var ul=null,dl=!1;function pl(e,t,n){for(n=n.child;null!==n;)fl(e,t,n),n=n.sibling}function fl(e,t,n){if(it&&"function"==typeof it.onCommitFiberUnmount)try{it.onCommitFiberUnmount(ot,n)}catch(e){}switch(n.tag){case 5:Ks||Xs(n,t);case 6:var r=ul,o=dl;ul=null,pl(e,t,n),dl=o,null!==(ul=r)&&(dl?(e=ul,n=n.stateNode,8===e.nodeType?e.parentNode.removeChild(n):e.removeChild(n)):ul.removeChild(n.stateNode));break;case 18:null!==ul&&(dl?(e=ul,n=n.stateNode,8===e.nodeType?lo(e.parentNode,n):1===e.nodeType&&lo(e,n),Ht(e)):lo(ul,n.stateNode));break;case 4:r=ul,o=dl,ul=n.stateNode.containerInfo,dl=!0,pl(e,t,n),ul=r,dl=o;break;case 0:case 11:case 14:case 15:if(!Ks&&(null!==(r=n.updateQueue)&&null!==(r=r.lastEffect))){o=r=r.next;do{var i=o,a=i.destroy;i=i.tag,void 0!==a&&(2&i||4&i)&&el(n,t,a),o=o.next}while(o!==r)}pl(e,t,n);break;case 1:if(!Ks&&(Xs(n,t),"function"==typeof(r=n.stateNode).componentWillUnmount))try{r.props=n.memoizedProps,r.state=n.memoizedState,r.componentWillUnmount()}catch(e){xc(n,t,e)}pl(e,t,n);break;case 21:pl(e,t,n);break;case 22:1&n.mode?(Ks=(r=Ks)||null!==n.memoizedState,pl(e,t,n),Ks=r):pl(e,t,n);break;default:pl(e,t,n)}}function hl(e){var t=e.updateQueue;if(null!==t){e.updateQueue=null;var n=e.stateNode;null===n&&(n=e.stateNode=new Zs),t.forEach((function(t){var r=Mc.bind(null,e,t);n.has(t)||(n.add(t),t.then(r,r))}))}}function ml(e,t){var n=t.deletions;if(null!==n)for(var r=0;r<n.length;r++){var o=n[r];try{var a=e,s=t,l=s;e:for(;null!==l;){switch(l.tag){case 5:ul=l.stateNode,dl=!1;break e;case 3:case 4:ul=l.stateNode.containerInfo,dl=!0;break e}l=l.return}if(null===ul)throw Error(i(160));fl(a,s,o),ul=null,dl=!1;var c=o.alternate;null!==c&&(c.return=null),o.return=null}catch(e){xc(o,t,e)}}if(12854&t.subtreeFlags)for(t=t.child;null!==t;)gl(t,e),t=t.sibling}function gl(e,t){var n=e.alternate,r=e.flags;switch(e.tag){case 0:case 11:case 14:case 15:if(ml(t,e),vl(e),4&r){try{nl(3,e,e.return),rl(3,e)}catch(t){xc(e,e.return,t)}try{nl(5,e,e.return)}catch(t){xc(e,e.return,t)}}break;case 1:ml(t,e),vl(e),512&r&&null!==n&&Xs(n,n.return);break;case 5:if(ml(t,e),vl(e),512&r&&null!==n&&Xs(n,n.return),32&e.flags){var o=e.stateNode;try{pe(o,"")}catch(t){xc(e,e.return,t)}}if(4&r&&null!=(o=e.stateNode)){var a=e.memoizedProps,s=null!==n?n.memoizedProps:a,l=e.type,c=e.updateQueue;if(e.updateQueue=null,null!==c)try{"input"===l&&"radio"===a.type&&null!=a.name&&Z(o,a),be(l,s);var u=be(l,a);for(s=0;s<c.length;s+=2){var d=c[s],p=c[s+1];"style"===d?ge(o,p):"dangerouslySetInnerHTML"===d?de(o,p):"children"===d?pe(o,p):b(o,d,p,u)}switch(l){case"input":J(o,a);break;case"textarea":ie(o,a);break;case"select":var f=o._wrapperState.wasMultiple;o._wrapperState.wasMultiple=!!a.multiple;var h=a.value;null!=h?ne(o,!!a.multiple,h,!1):f!==!!a.multiple&&(null!=a.defaultValue?ne(o,!!a.multiple,a.defaultValue,!0):ne(o,!!a.multiple,a.multiple?[]:"",!1))}o[ho]=a}catch(t){xc(e,e.return,t)}}break;case 6:if(ml(t,e),vl(e),4&r){if(null===e.stateNode)throw Error(i(162));o=e.stateNode,a=e.memoizedProps;try{o.nodeValue=a}catch(t){xc(e,e.return,t)}}break;case 3:if(ml(t,e),vl(e),4&r&&null!==n&&n.memoizedState.isDehydrated)try{Ht(t.containerInfo)}catch(t){xc(e,e.return,t)}break;case 4:default:ml(t,e),vl(e);break;case 13:ml(t,e),vl(e),8192&(o=e.child).flags&&(a=null!==o.memoizedState,o.stateNode.isHidden=a,!a||null!==o.alternate&&null!==o.alternate.memoizedState||($l=Ze())),4&r&&hl(e);break;case 22:if(d=null!==n&&null!==n.memoizedState,1&e.mode?(Ks=(u=Ks)||d,ml(t,e),Ks=u):ml(t,e),vl(e),8192&r){if(u=null!==e.memoizedState,(e.stateNode.isHidden=u)&&!d&&1&e.mode)for(Js=e,d=e.child;null!==d;){for(p=Js=d;null!==Js;){switch(h=(f=Js).child,f.tag){case 0:case 11:case 14:case 15:nl(4,f,f.return);break;case 1:Xs(f,f.return);var m=f.stateNode;if("function"==typeof m.componentWillUnmount){r=f,n=f.return;try{t=r,m.props=t.memoizedProps,m.state=t.memoizedState,m.componentWillUnmount()}catch(e){xc(r,n,e)}}break;case 5:Xs(f,f.return);break;case 22:if(null!==f.memoizedState){Al(p);continue}}null!==h?(h.return=f,Js=h):Al(p)}d=d.sibling}e:for(d=null,p=e;;){if(5===p.tag){if(null===d){d=p;try{o=p.stateNode,u?"function"==typeof(a=o.style).setProperty?a.setProperty("display","none","important"):a.display="none":(l=p.stateNode,s=null!=(c=p.memoizedProps.style)&&c.hasOwnProperty("display")?c.display:null,l.style.display=me("display",s))}catch(t){xc(e,e.return,t)}}}else if(6===p.tag){if(null===d)try{p.stateNode.nodeValue=u?"":p.memoizedProps}catch(t){xc(e,e.return,t)}}else if((22!==p.tag&&23!==p.tag||null===p.memoizedState||p===e)&&null!==p.child){p.child.return=p,p=p.child;continue}if(p===e)break e;for(;null===p.sibling;){if(null===p.return||p.return===e)break e;d===p&&(d=null),p=p.return}d===p&&(d=null),p.sibling.return=p.return,p=p.sibling}}break;case 19:ml(t,e),vl(e),4&r&&hl(e);case 21:}}function vl(e){var t=e.flags;if(2&t){try{e:{for(var n=e.return;null!==n;){if(al(n)){var r=n;break e}n=n.return}throw Error(i(160))}switch(r.tag){case 5:var o=r.stateNode;32&r.flags&&(pe(o,""),r.flags&=-33),cl(e,sl(e),o);break;case 3:case 4:var a=r.stateNode.containerInfo;ll(e,sl(e),a);break;default:throw Error(i(161))}}catch(t){xc(e,e.return,t)}e.flags&=-3}4096&t&&(e.flags&=-4097)}function yl(e,t,n){Js=e,bl(e,t,n)}function bl(e,t,n){for(var r=!!(1&e.mode);null!==Js;){var o=Js,i=o.child;if(22===o.tag&&r){var a=null!==o.memoizedState||qs;if(!a){var s=o.alternate,l=null!==s&&null!==s.memoizedState||Ks;s=qs;var c=Ks;if(qs=a,(Ks=l)&&!c)for(Js=o;null!==Js;)l=(a=Js).child,22===a.tag&&null!==a.memoizedState?El(o):null!==l?(l.return=a,Js=l):El(o);for(;null!==i;)Js=i,bl(i,t,n),i=i.sibling;Js=o,qs=s,Ks=c}_l(e)}else 8772&o.subtreeFlags&&null!==i?(i.return=o,Js=i):_l(e)}}function _l(e){for(;null!==Js;){var t=Js;if(8772&t.flags){var n=t.alternate;try{if(8772&t.flags)switch(t.tag){case 0:case 11:case 15:Ks||rl(5,t);break;case 1:var r=t.stateNode;if(4&t.flags&&!Ks)if(null===n)r.componentDidMount();else{var o=t.elementType===t.type?n.memoizedProps:ns(t.type,n.memoizedProps);r.componentDidUpdate(o,n.memoizedState,r.__reactInternalSnapshotBeforeUpdate)}var a=t.updateQueue;null!==a&&zi(t,a,r);break;case 3:var s=t.updateQueue;if(null!==s){if(n=null,null!==t.child)switch(t.child.tag){case 5:case 1:n=t.child.stateNode}zi(t,s,n)}break;case 5:var l=t.stateNode;if(null===n&&4&t.flags){n=l;var c=t.memoizedProps;switch(t.type){case"button":case"input":case"select":case"textarea":c.autoFocus&&n.focus();break;case"img":c.src&&(n.src=c.src)}}break;case 6:case 4:case 12:case 19:case 17:case 21:case 22:case 23:case 25:break;case 13:if(null===t.memoizedState){var u=t.alternate;if(null!==u){var d=u.memoizedState;if(null!==d){var p=d.dehydrated;null!==p&&Ht(p)}}}break;default:throw Error(i(163))}Ks||512&t.flags&&ol(t)}catch(e){xc(t,t.return,e)}}if(t===e){Js=null;break}if(null!==(n=t.sibling)){n.return=t.return,Js=n;break}Js=t.return}}function Al(e){for(;null!==Js;){var t=Js;if(t===e){Js=null;break}var n=t.sibling;if(null!==n){n.return=t.return,Js=n;break}Js=t.return}}function El(e){for(;null!==Js;){var t=Js;try{switch(t.tag){case 0:case 11:case 15:var n=t.return;try{rl(4,t)}catch(e){xc(t,n,e)}break;case 1:var r=t.stateNode;if("function"==typeof r.componentDidMount){var o=t.return;try{r.componentDidMount()}catch(e){xc(t,o,e)}}var i=t.return;try{ol(t)}catch(e){xc(t,i,e)}break;case 5:var a=t.return;try{ol(t)}catch(e){xc(t,a,e)}}}catch(e){xc(t,t.return,e)}if(t===e){Js=null;break}var s=t.sibling;if(null!==s){s.return=t.return,Js=s;break}Js=t.return}}var wl,xl=Math.ceil,kl=_.ReactCurrentDispatcher,Cl=_.ReactCurrentOwner,Sl=_.ReactCurrentBatchConfig,Ml=0,Tl=null,Ol=null,Dl=0,Ll=0,Pl=ko(0),Il=0,Bl=null,Rl=0,Nl=0,Fl=0,jl=null,Yl=null,$l=0,Hl=1/0,Ul=null,zl=!1,Wl=null,Vl=null,Gl=!1,Ql=null,ql=0,Kl=0,Zl=null,Jl=-1,Xl=0;function ec(){return 6&Ml?Ze():-1!==Jl?Jl:Jl=Ze()}function tc(e){return 1&e.mode?2&Ml&&0!==Dl?Dl&-Dl:null!==gi.transition?(0===Xl&&(Xl=mt()),Xl):0!==(e=bt)?e:e=void 0===(e=window.event)?16:Kt(e.type):1}function nc(e,t,n,r){if(50<Kl)throw Kl=0,Zl=null,Error(i(185));vt(e,n,r),2&Ml&&e===Tl||(e===Tl&&(!(2&Ml)&&(Nl|=n),4===Il&&sc(e,Dl)),rc(e,r),1===n&&0===Ml&&!(1&t.mode)&&(Hl=Ze()+500,Yo&&Uo()))}function rc(e,t){var n=e.callbackNode;!function(e,t){for(var n=e.suspendedLanes,r=e.pingedLanes,o=e.expirationTimes,i=e.pendingLanes;0<i;){var a=31-at(i),s=1<<a,l=o[a];-1===l?s&n&&!(s&r)||(o[a]=ft(s,t)):l<=t&&(e.expiredLanes|=s),i&=~s}}(e,t);var r=pt(e,e===Tl?Dl:0);if(0===r)null!==n&&Qe(n),e.callbackNode=null,e.callbackPriority=0;else if(t=r&-r,e.callbackPriority!==t){if(null!=n&&Qe(n),1===t)0===e.tag?function(e){Yo=!0,Ho(e)}(lc.bind(null,e)):Ho(lc.bind(null,e)),ao((function(){!(6&Ml)&&Uo()})),n=null;else{switch(_t(r)){case 1:n=Xe;break;case 4:n=et;break;case 16:default:n=tt;break;case 536870912:n=rt}n=Tc(n,oc.bind(null,e))}e.callbackPriority=t,e.callbackNode=n}}function oc(e,t){if(Jl=-1,Xl=0,6&Ml)throw Error(i(327));var n=e.callbackNode;if(Ec()&&e.callbackNode!==n)return null;var r=pt(e,e===Tl?Dl:0);if(0===r)return null;if(30&r||r&e.expiredLanes||t)t=gc(e,r);else{t=r;var o=Ml;Ml|=2;var a=hc();for(Tl===e&&Dl===t||(Ul=null,Hl=Ze()+500,pc(e,t));;)try{yc();break}catch(t){fc(e,t)}Si(),kl.current=a,Ml=o,null!==Ol?t=0:(Tl=null,Dl=0,t=Il)}if(0!==t){if(2===t&&(0!==(o=ht(e))&&(r=o,t=ic(e,o))),1===t)throw n=Bl,pc(e,0),sc(e,r),rc(e,Ze()),n;if(6===t)sc(e,r);else{if(o=e.current.alternate,!(30&r||function(e){for(var t=e;;){if(16384&t.flags){var n=t.updateQueue;if(null!==n&&null!==(n=n.stores))for(var r=0;r<n.length;r++){var o=n[r],i=o.getSnapshot;o=o.value;try{if(!sr(i(),o))return!1}catch(e){return!1}}}if(n=t.child,16384&t.subtreeFlags&&null!==n)n.return=t,t=n;else{if(t===e)break;for(;null===t.sibling;){if(null===t.return||t.return===e)return!0;t=t.return}t.sibling.return=t.return,t=t.sibling}}return!0}(o)||(t=gc(e,r),2===t&&(a=ht(e),0!==a&&(r=a,t=ic(e,a))),1!==t)))throw n=Bl,pc(e,0),sc(e,r),rc(e,Ze()),n;switch(e.finishedWork=o,e.finishedLanes=r,t){case 0:case 1:throw Error(i(345));case 2:case 5:Ac(e,Yl,Ul);break;case 3:if(sc(e,r),(130023424&r)===r&&10<(t=$l+500-Ze())){if(0!==pt(e,0))break;if(((o=e.suspendedLanes)&r)!==r){ec(),e.pingedLanes|=e.suspendedLanes&o;break}e.timeoutHandle=ro(Ac.bind(null,e,Yl,Ul),t);break}Ac(e,Yl,Ul);break;case 4:if(sc(e,r),(4194240&r)===r)break;for(t=e.eventTimes,o=-1;0<r;){var s=31-at(r);a=1<<s,(s=t[s])>o&&(o=s),r&=~a}if(r=o,10<(r=(120>(r=Ze()-r)?120:480>r?480:1080>r?1080:1920>r?1920:3e3>r?3e3:4320>r?4320:1960*xl(r/1960))-r)){e.timeoutHandle=ro(Ac.bind(null,e,Yl,Ul),r);break}Ac(e,Yl,Ul);break;default:throw Error(i(329))}}}return rc(e,Ze()),e.callbackNode===n?oc.bind(null,e):null}function ic(e,t){var n=jl;return e.current.memoizedState.isDehydrated&&(pc(e,t).flags|=256),2!==(e=gc(e,t))&&(t=Yl,Yl=n,null!==t&&ac(t)),e}function ac(e){null===Yl?Yl=e:Yl.push.apply(Yl,e)}function sc(e,t){for(t&=~Fl,t&=~Nl,e.suspendedLanes|=t,e.pingedLanes&=~t,e=e.expirationTimes;0<t;){var n=31-at(t),r=1<<n;e[n]=-1,t&=~r}}function lc(e){if(6&Ml)throw Error(i(327));Ec();var t=pt(e,0);if(!(1&t))return rc(e,Ze()),null;var n=gc(e,t);if(0!==e.tag&&2===n){var r=ht(e);0!==r&&(t=r,n=ic(e,r))}if(1===n)throw n=Bl,pc(e,0),sc(e,t),rc(e,Ze()),n;if(6===n)throw Error(i(345));return e.finishedWork=e.current.alternate,e.finishedLanes=t,Ac(e,Yl,Ul),rc(e,Ze()),null}function cc(e,t){var n=Ml;Ml|=1;try{return e(t)}finally{0===(Ml=n)&&(Hl=Ze()+500,Yo&&Uo())}}function uc(e){null!==Ql&&0===Ql.tag&&!(6&Ml)&&Ec();var t=Ml;Ml|=1;var n=Sl.transition,r=bt;try{if(Sl.transition=null,bt=1,e)return e()}finally{bt=r,Sl.transition=n,!(6&(Ml=t))&&Uo()}}function dc(){Ll=Pl.current,Co(Pl)}function pc(e,t){e.finishedWork=null,e.finishedLanes=0;var n=e.timeoutHandle;if(-1!==n&&(e.timeoutHandle=-1,oo(n)),null!==Ol)for(n=Ol.return;null!==n;){var r=n;switch(ni(r),r.tag){case 1:null!=(r=r.type.childContextTypes)&&Io();break;case 3:Zi(),Co(Oo),Co(To),ra();break;case 5:Xi(r);break;case 4:Zi();break;case 13:case 19:Co(ea);break;case 10:Mi(r.type._context);break;case 22:case 23:dc()}n=n.return}if(Tl=e,Ol=e=Pc(e.current,null),Dl=Ll=t,Il=0,Bl=null,Fl=Nl=Rl=0,Yl=jl=null,null!==Li){for(t=0;t<Li.length;t++)if(null!==(r=(n=Li[t]).interleaved)){n.interleaved=null;var o=r.next,i=n.pending;if(null!==i){var a=i.next;i.next=o,r.next=a}n.pending=r}Li=null}return e}function fc(e,t){for(;;){var n=Ol;try{if(Si(),oa.current=Ja,ua){for(var r=sa.memoizedState;null!==r;){var o=r.queue;null!==o&&(o.pending=null),r=r.next}ua=!1}if(aa=0,ca=la=sa=null,da=!1,pa=0,Cl.current=null,null===n||null===n.return){Il=1,Bl=t,Ol=null;break}e:{var a=e,s=n.return,l=n,c=t;if(t=Dl,l.flags|=32768,null!==c&&"object"==typeof c&&"function"==typeof c.then){var u=c,d=l,p=d.tag;if(!(1&d.mode||0!==p&&11!==p&&15!==p)){var f=d.alternate;f?(d.updateQueue=f.updateQueue,d.memoizedState=f.memoizedState,d.lanes=f.lanes):(d.updateQueue=null,d.memoizedState=null)}var h=gs(s);if(null!==h){h.flags&=-257,vs(h,s,l,0,t),1&h.mode&&ms(a,u,t),c=u;var m=(t=h).updateQueue;if(null===m){var g=new Set;g.add(c),t.updateQueue=g}else m.add(c);break e}if(!(1&t)){ms(a,u,t),mc();break e}c=Error(i(426))}else if(ii&&1&l.mode){var v=gs(s);if(null!==v){!(65536&v.flags)&&(v.flags|=256),vs(v,s,l,0,t),mi(cs(c,l));break e}}a=c=cs(c,l),4!==Il&&(Il=2),null===jl?jl=[a]:jl.push(a),a=s;do{switch(a.tag){case 3:a.flags|=65536,t&=-t,a.lanes|=t,Hi(a,fs(0,c,t));break e;case 1:l=c;var y=a.type,b=a.stateNode;if(!(128&a.flags||"function"!=typeof y.getDerivedStateFromError&&(null===b||"function"!=typeof b.componentDidCatch||null!==Vl&&Vl.has(b)))){a.flags|=65536,t&=-t,a.lanes|=t,Hi(a,hs(a,l,t));break e}}a=a.return}while(null!==a)}_c(n)}catch(e){t=e,Ol===n&&null!==n&&(Ol=n=n.return);continue}break}}function hc(){var e=kl.current;return kl.current=Ja,null===e?Ja:e}function mc(){0!==Il&&3!==Il&&2!==Il||(Il=4),null===Tl||!(268435455&Rl)&&!(268435455&Nl)||sc(Tl,Dl)}function gc(e,t){var n=Ml;Ml|=2;var r=hc();for(Tl===e&&Dl===t||(Ul=null,pc(e,t));;)try{vc();break}catch(t){fc(e,t)}if(Si(),Ml=n,kl.current=r,null!==Ol)throw Error(i(261));return Tl=null,Dl=0,Il}function vc(){for(;null!==Ol;)bc(Ol)}function yc(){for(;null!==Ol&&!qe();)bc(Ol)}function bc(e){var t=wl(e.alternate,e,Ll);e.memoizedProps=e.pendingProps,null===t?_c(e):Ol=t,Cl.current=null}function _c(e){var t=e;do{var n=t.alternate;if(e=t.return,32768&t.flags){if(null!==(n=Qs(n,t)))return n.flags&=32767,void(Ol=n);if(null===e)return Il=6,void(Ol=null);e.flags|=32768,e.subtreeFlags=0,e.deletions=null}else if(null!==(n=Gs(n,t,Ll)))return void(Ol=n);if(null!==(t=t.sibling))return void(Ol=t);Ol=t=e}while(null!==t);0===Il&&(Il=5)}function Ac(e,t,n){var r=bt,o=Sl.transition;try{Sl.transition=null,bt=1,function(e,t,n,r){do{Ec()}while(null!==Ql);if(6&Ml)throw Error(i(327));n=e.finishedWork;var o=e.finishedLanes;if(null===n)return null;if(e.finishedWork=null,e.finishedLanes=0,n===e.current)throw Error(i(177));e.callbackNode=null,e.callbackPriority=0;var a=n.lanes|n.childLanes;if(function(e,t){var n=e.pendingLanes&~t;e.pendingLanes=t,e.suspendedLanes=0,e.pingedLanes=0,e.expiredLanes&=t,e.mutableReadLanes&=t,e.entangledLanes&=t,t=e.entanglements;var r=e.eventTimes;for(e=e.expirationTimes;0<n;){var o=31-at(n),i=1<<o;t[o]=0,r[o]=-1,e[o]=-1,n&=~i}}(e,a),e===Tl&&(Ol=Tl=null,Dl=0),!(2064&n.subtreeFlags)&&!(2064&n.flags)||Gl||(Gl=!0,Tc(tt,(function(){return Ec(),null}))),a=!!(15990&n.flags),!!(15990&n.subtreeFlags)||a){a=Sl.transition,Sl.transition=null;var s=bt;bt=1;var l=Ml;Ml|=4,Cl.current=null,function(e,t){if(eo=zt,fr(e=pr())){if("selectionStart"in e)var n={start:e.selectionStart,end:e.selectionEnd};else e:{var r=(n=(n=e.ownerDocument)&&n.defaultView||window).getSelection&&n.getSelection();if(r&&0!==r.rangeCount){n=r.anchorNode;var o=r.anchorOffset,a=r.focusNode;r=r.focusOffset;try{n.nodeType,a.nodeType}catch(e){n=null;break e}var s=0,l=-1,c=-1,u=0,d=0,p=e,f=null;t:for(;;){for(var h;p!==n||0!==o&&3!==p.nodeType||(l=s+o),p!==a||0!==r&&3!==p.nodeType||(c=s+r),3===p.nodeType&&(s+=p.nodeValue.length),null!==(h=p.firstChild);)f=p,p=h;for(;;){if(p===e)break t;if(f===n&&++u===o&&(l=s),f===a&&++d===r&&(c=s),null!==(h=p.nextSibling))break;f=(p=f).parentNode}p=h}n=-1===l||-1===c?null:{start:l,end:c}}else n=null}n=n||{start:0,end:0}}else n=null;for(to={focusedElem:e,selectionRange:n},zt=!1,Js=t;null!==Js;)if(e=(t=Js).child,1028&t.subtreeFlags&&null!==e)e.return=t,Js=e;else for(;null!==Js;){t=Js;try{var m=t.alternate;if(1024&t.flags)switch(t.tag){case 0:case 11:case 15:case 5:case 6:case 4:case 17:break;case 1:if(null!==m){var g=m.memoizedProps,v=m.memoizedState,y=t.stateNode,b=y.getSnapshotBeforeUpdate(t.elementType===t.type?g:ns(t.type,g),v);y.__reactInternalSnapshotBeforeUpdate=b}break;case 3:var _=t.stateNode.containerInfo;1===_.nodeType?_.textContent="":9===_.nodeType&&_.documentElement&&_.removeChild(_.documentElement);break;default:throw Error(i(163))}}catch(e){xc(t,t.return,e)}if(null!==(e=t.sibling)){e.return=t.return,Js=e;break}Js=t.return}m=tl,tl=!1}(e,n),gl(n,e),hr(to),zt=!!eo,to=eo=null,e.current=n,yl(n,e,o),Ke(),Ml=l,bt=s,Sl.transition=a}else e.current=n;if(Gl&&(Gl=!1,Ql=e,ql=o),a=e.pendingLanes,0===a&&(Vl=null),function(e){if(it&&"function"==typeof it.onCommitFiberRoot)try{it.onCommitFiberRoot(ot,e,void 0,!(128&~e.current.flags))}catch(e){}}(n.stateNode),rc(e,Ze()),null!==t)for(r=e.onRecoverableError,n=0;n<t.length;n++)o=t[n],r(o.value,{componentStack:o.stack,digest:o.digest});if(zl)throw zl=!1,e=Wl,Wl=null,e;!!(1&ql)&&0!==e.tag&&Ec(),a=e.pendingLanes,1&a?e===Zl?Kl++:(Kl=0,Zl=e):Kl=0,Uo()}(e,t,n,r)}finally{Sl.transition=o,bt=r}return null}function Ec(){if(null!==Ql){var e=_t(ql),t=Sl.transition,n=bt;try{if(Sl.transition=null,bt=16>e?16:e,null===Ql)var r=!1;else{if(e=Ql,Ql=null,ql=0,6&Ml)throw Error(i(331));var o=Ml;for(Ml|=4,Js=e.current;null!==Js;){var a=Js,s=a.child;if(16&Js.flags){var l=a.deletions;if(null!==l){for(var c=0;c<l.length;c++){var u=l[c];for(Js=u;null!==Js;){var d=Js;switch(d.tag){case 0:case 11:case 15:nl(8,d,a)}var p=d.child;if(null!==p)p.return=d,Js=p;else for(;null!==Js;){var f=(d=Js).sibling,h=d.return;if(il(d),d===u){Js=null;break}if(null!==f){f.return=h,Js=f;break}Js=h}}}var m=a.alternate;if(null!==m){var g=m.child;if(null!==g){m.child=null;do{var v=g.sibling;g.sibling=null,g=v}while(null!==g)}}Js=a}}if(2064&a.subtreeFlags&&null!==s)s.return=a,Js=s;else e:for(;null!==Js;){if(2048&(a=Js).flags)switch(a.tag){case 0:case 11:case 15:nl(9,a,a.return)}var y=a.sibling;if(null!==y){y.return=a.return,Js=y;break e}Js=a.return}}var b=e.current;for(Js=b;null!==Js;){var _=(s=Js).child;if(2064&s.subtreeFlags&&null!==_)_.return=s,Js=_;else e:for(s=b;null!==Js;){if(2048&(l=Js).flags)try{switch(l.tag){case 0:case 11:case 15:rl(9,l)}}catch(e){xc(l,l.return,e)}if(l===s){Js=null;break e}var A=l.sibling;if(null!==A){A.return=l.return,Js=A;break e}Js=l.return}}if(Ml=o,Uo(),it&&"function"==typeof it.onPostCommitFiberRoot)try{it.onPostCommitFiberRoot(ot,e)}catch(e){}r=!0}return r}finally{bt=n,Sl.transition=t}}return!1}function wc(e,t,n){e=Yi(e,t=fs(0,t=cs(n,t),1),1),t=ec(),null!==e&&(vt(e,1,t),rc(e,t))}function xc(e,t,n){if(3===e.tag)wc(e,e,n);else for(;null!==t;){if(3===t.tag){wc(t,e,n);break}if(1===t.tag){var r=t.stateNode;if("function"==typeof t.type.getDerivedStateFromError||"function"==typeof r.componentDidCatch&&(null===Vl||!Vl.has(r))){t=Yi(t,e=hs(t,e=cs(n,e),1),1),e=ec(),null!==t&&(vt(t,1,e),rc(t,e));break}}t=t.return}}function kc(e,t,n){var r=e.pingCache;null!==r&&r.delete(t),t=ec(),e.pingedLanes|=e.suspendedLanes&n,Tl===e&&(Dl&n)===n&&(4===Il||3===Il&&(130023424&Dl)===Dl&&500>Ze()-$l?pc(e,0):Fl|=n),rc(e,t)}function Cc(e,t){0===t&&(1&e.mode?(t=ut,!(130023424&(ut<<=1))&&(ut=4194304)):t=1);var n=ec();null!==(e=Bi(e,t))&&(vt(e,t,n),rc(e,n))}function Sc(e){var t=e.memoizedState,n=0;null!==t&&(n=t.retryLane),Cc(e,n)}function Mc(e,t){var n=0;switch(e.tag){case 13:var r=e.stateNode,o=e.memoizedState;null!==o&&(n=o.retryLane);break;case 19:r=e.stateNode;break;default:throw Error(i(314))}null!==r&&r.delete(t),Cc(e,n)}function Tc(e,t){return Ge(e,t)}function Oc(e,t,n,r){this.tag=e,this.key=n,this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null,this.index=0,this.ref=null,this.pendingProps=t,this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null,this.mode=r,this.subtreeFlags=this.flags=0,this.deletions=null,this.childLanes=this.lanes=0,this.alternate=null}function Dc(e,t,n,r){return new Oc(e,t,n,r)}function Lc(e){return!(!(e=e.prototype)||!e.isReactComponent)}function Pc(e,t){var n=e.alternate;return null===n?((n=Dc(e.tag,t,e.key,e.mode)).elementType=e.elementType,n.type=e.type,n.stateNode=e.stateNode,n.alternate=e,e.alternate=n):(n.pendingProps=t,n.type=e.type,n.flags=0,n.subtreeFlags=0,n.deletions=null),n.flags=14680064&e.flags,n.childLanes=e.childLanes,n.lanes=e.lanes,n.child=e.child,n.memoizedProps=e.memoizedProps,n.memoizedState=e.memoizedState,n.updateQueue=e.updateQueue,t=e.dependencies,n.dependencies=null===t?null:{lanes:t.lanes,firstContext:t.firstContext},n.sibling=e.sibling,n.index=e.index,n.ref=e.ref,n}function Ic(e,t,n,r,o,a){var s=2;if(r=e,"function"==typeof e)Lc(e)&&(s=1);else if("string"==typeof e)s=5;else e:switch(e){case w:return Bc(n.children,o,a,t);case x:s=8,o|=8;break;case k:return(e=Dc(12,n,t,2|o)).elementType=k,e.lanes=a,e;case T:return(e=Dc(13,n,t,o)).elementType=T,e.lanes=a,e;case O:return(e=Dc(19,n,t,o)).elementType=O,e.lanes=a,e;case P:return Rc(n,o,a,t);default:if("object"==typeof e&&null!==e)switch(e.$$typeof){case C:s=10;break e;case S:s=9;break e;case M:s=11;break e;case D:s=14;break e;case L:s=16,r=null;break e}throw Error(i(130,null==e?e:typeof e,""))}return(t=Dc(s,n,t,o)).elementType=e,t.type=r,t.lanes=a,t}function Bc(e,t,n,r){return(e=Dc(7,e,r,t)).lanes=n,e}function Rc(e,t,n,r){return(e=Dc(22,e,r,t)).elementType=P,e.lanes=n,e.stateNode={isHidden:!1},e}function Nc(e,t,n){return(e=Dc(6,e,null,t)).lanes=n,e}function Fc(e,t,n){return(t=Dc(4,null!==e.children?e.children:[],e.key,t)).lanes=n,t.stateNode={containerInfo:e.containerInfo,pendingChildren:null,implementation:e.implementation},t}function jc(e,t,n,r,o){this.tag=t,this.containerInfo=e,this.finishedWork=this.pingCache=this.current=this.pendingChildren=null,this.timeoutHandle=-1,this.callbackNode=this.pendingContext=this.context=null,this.callbackPriority=0,this.eventTimes=gt(0),this.expirationTimes=gt(-1),this.entangledLanes=this.finishedLanes=this.mutableReadLanes=this.expiredLanes=this.pingedLanes=this.suspendedLanes=this.pendingLanes=0,this.entanglements=gt(0),this.identifierPrefix=r,this.onRecoverableError=o,this.mutableSourceEagerHydrationData=null}function Yc(e,t,n,r,o,i,a,s,l){return e=new jc(e,t,n,s,l),1===t?(t=1,!0===i&&(t|=8)):t=0,i=Dc(3,null,null,t),e.current=i,i.stateNode=e,i.memoizedState={element:r,isDehydrated:n,cache:null,transitions:null,pendingSuspenseBoundaries:null},Ni(i),e}function $c(e){if(!e)return Mo;e:{if(He(e=e._reactInternals)!==e||1!==e.tag)throw Error(i(170));var t=e;do{switch(t.tag){case 3:t=t.stateNode.context;break e;case 1:if(Po(t.type)){t=t.stateNode.__reactInternalMemoizedMergedChildContext;break e}}t=t.return}while(null!==t);throw Error(i(171))}if(1===e.tag){var n=e.type;if(Po(n))return Ro(e,n,t)}return t}function Hc(e,t,n,r,o,i,a,s,l){return(e=Yc(n,r,!0,e,0,i,0,s,l)).context=$c(null),n=e.current,(i=ji(r=ec(),o=tc(n))).callback=null!=t?t:null,Yi(n,i,o),e.current.lanes=o,vt(e,o,r),rc(e,r),e}function Uc(e,t,n,r){var o=t.current,i=ec(),a=tc(o);return n=$c(n),null===t.context?t.context=n:t.pendingContext=n,(t=ji(i,a)).payload={element:e},null!==(r=void 0===r?null:r)&&(t.callback=r),null!==(e=Yi(o,t,a))&&(nc(e,o,a,i),$i(e,o,a)),a}function zc(e){return(e=e.current).child?(e.child.tag,e.child.stateNode):null}function Wc(e,t){if(null!==(e=e.memoizedState)&&null!==e.dehydrated){var n=e.retryLane;e.retryLane=0!==n&&n<t?n:t}}function Vc(e,t){Wc(e,t),(e=e.alternate)&&Wc(e,t)}wl=function(e,t,n){if(null!==e)if(e.memoizedProps!==t.pendingProps||Oo.current)bs=!0;else{if(!(e.lanes&n||128&t.flags))return bs=!1,function(e,t,n){switch(t.tag){case 3:Ts(t),hi();break;case 5:Ji(t);break;case 1:Po(t.type)&&No(t);break;case 4:Ki(t,t.stateNode.containerInfo);break;case 10:var r=t.type._context,o=t.memoizedProps.value;So(wi,r._currentValue),r._currentValue=o;break;case 13:if(null!==(r=t.memoizedState))return null!==r.dehydrated?(So(ea,1&ea.current),t.flags|=128,null):n&t.child.childLanes?Ns(e,t,n):(So(ea,1&ea.current),null!==(e=zs(e,t,n))?e.sibling:null);So(ea,1&ea.current);break;case 19:if(r=!!(n&t.childLanes),128&e.flags){if(r)return Hs(e,t,n);t.flags|=128}if(null!==(o=t.memoizedState)&&(o.rendering=null,o.tail=null,o.lastEffect=null),So(ea,ea.current),r)break;return null;case 22:case 23:return t.lanes=0,xs(e,t,n)}return zs(e,t,n)}(e,t,n);bs=!!(131072&e.flags)}else bs=!1,ii&&1048576&t.flags&&ei(t,Go,t.index);switch(t.lanes=0,t.tag){case 2:var r=t.type;Us(e,t),e=t.pendingProps;var o=Lo(t,To.current);Oi(t,n),o=ga(null,t,r,e,o,n);var a=va();return t.flags|=1,"object"==typeof o&&null!==o&&"function"==typeof o.render&&void 0===o.$$typeof?(t.tag=1,t.memoizedState=null,t.updateQueue=null,Po(r)?(a=!0,No(t)):a=!1,t.memoizedState=null!==o.state&&void 0!==o.state?o.state:null,Ni(t),o.updater=os,t.stateNode=o,o._reactInternals=t,ls(t,r,e,n),t=Ms(null,t,r,!0,a,n)):(t.tag=0,ii&&a&&ti(t),_s(null,t,o,n),t=t.child),t;case 16:r=t.elementType;e:{switch(Us(e,t),e=t.pendingProps,r=(o=r._init)(r._payload),t.type=r,o=t.tag=function(e){if("function"==typeof e)return Lc(e)?1:0;if(null!=e){if((e=e.$$typeof)===M)return 11;if(e===D)return 14}return 2}(r),e=ns(r,e),o){case 0:t=Cs(null,t,r,e,n);break e;case 1:t=Ss(null,t,r,e,n);break e;case 11:t=As(null,t,r,e,n);break e;case 14:t=Es(null,t,r,ns(r.type,e),n);break e}throw Error(i(306,r,""))}return t;case 0:return r=t.type,o=t.pendingProps,Cs(e,t,r,o=t.elementType===r?o:ns(r,o),n);case 1:return r=t.type,o=t.pendingProps,Ss(e,t,r,o=t.elementType===r?o:ns(r,o),n);case 3:e:{if(Ts(t),null===e)throw Error(i(387));r=t.pendingProps,o=(a=t.memoizedState).element,Fi(e,t),Ui(t,r,null,n);var s=t.memoizedState;if(r=s.element,a.isDehydrated){if(a={element:r,isDehydrated:!1,cache:s.cache,pendingSuspenseBoundaries:s.pendingSuspenseBoundaries,transitions:s.transitions},t.updateQueue.baseState=a,t.memoizedState=a,256&t.flags){t=Os(e,t,r,n,o=cs(Error(i(423)),t));break e}if(r!==o){t=Os(e,t,r,n,o=cs(Error(i(424)),t));break e}for(oi=co(t.stateNode.containerInfo.firstChild),ri=t,ii=!0,ai=null,n=Ei(t,null,r,n),t.child=n;n;)n.flags=-3&n.flags|4096,n=n.sibling}else{if(hi(),r===o){t=zs(e,t,n);break e}_s(e,t,r,n)}t=t.child}return t;case 5:return Ji(t),null===e&&ui(t),r=t.type,o=t.pendingProps,a=null!==e?e.memoizedProps:null,s=o.children,no(r,o)?s=null:null!==a&&no(r,a)&&(t.flags|=32),ks(e,t),_s(e,t,s,n),t.child;case 6:return null===e&&ui(t),null;case 13:return Ns(e,t,n);case 4:return Ki(t,t.stateNode.containerInfo),r=t.pendingProps,null===e?t.child=Ai(t,null,r,n):_s(e,t,r,n),t.child;case 11:return r=t.type,o=t.pendingProps,As(e,t,r,o=t.elementType===r?o:ns(r,o),n);case 7:return _s(e,t,t.pendingProps,n),t.child;case 8:case 12:return _s(e,t,t.pendingProps.children,n),t.child;case 10:e:{if(r=t.type._context,o=t.pendingProps,a=t.memoizedProps,s=o.value,So(wi,r._currentValue),r._currentValue=s,null!==a)if(sr(a.value,s)){if(a.children===o.children&&!Oo.current){t=zs(e,t,n);break e}}else for(null!==(a=t.child)&&(a.return=t);null!==a;){var l=a.dependencies;if(null!==l){s=a.child;for(var c=l.firstContext;null!==c;){if(c.context===r){if(1===a.tag){(c=ji(-1,n&-n)).tag=2;var u=a.updateQueue;if(null!==u){var d=(u=u.shared).pending;null===d?c.next=c:(c.next=d.next,d.next=c),u.pending=c}}a.lanes|=n,null!==(c=a.alternate)&&(c.lanes|=n),Ti(a.return,n,t),l.lanes|=n;break}c=c.next}}else if(10===a.tag)s=a.type===t.type?null:a.child;else if(18===a.tag){if(null===(s=a.return))throw Error(i(341));s.lanes|=n,null!==(l=s.alternate)&&(l.lanes|=n),Ti(s,n,t),s=a.sibling}else s=a.child;if(null!==s)s.return=a;else for(s=a;null!==s;){if(s===t){s=null;break}if(null!==(a=s.sibling)){a.return=s.return,s=a;break}s=s.return}a=s}_s(e,t,o.children,n),t=t.child}return t;case 9:return o=t.type,r=t.pendingProps.children,Oi(t,n),r=r(o=Di(o)),t.flags|=1,_s(e,t,r,n),t.child;case 14:return o=ns(r=t.type,t.pendingProps),Es(e,t,r,o=ns(r.type,o),n);case 15:return ws(e,t,t.type,t.pendingProps,n);case 17:return r=t.type,o=t.pendingProps,o=t.elementType===r?o:ns(r,o),Us(e,t),t.tag=1,Po(r)?(e=!0,No(t)):e=!1,Oi(t,n),as(t,r,o),ls(t,r,o,n),Ms(null,t,r,!0,e,n);case 19:return Hs(e,t,n);case 22:return xs(e,t,n)}throw Error(i(156,t.tag))};var Gc="function"==typeof reportError?reportError:function(e){console.error(e)};function Qc(e){this._internalRoot=e}function qc(e){this._internalRoot=e}function Kc(e){return!(!e||1!==e.nodeType&&9!==e.nodeType&&11!==e.nodeType)}function Zc(e){return!(!e||1!==e.nodeType&&9!==e.nodeType&&11!==e.nodeType&&(8!==e.nodeType||" react-mount-point-unstable "!==e.nodeValue))}function Jc(){}function Xc(e,t,n,r,o){var i=n._reactRootContainer;if(i){var a=i;if("function"==typeof o){var s=o;o=function(){var e=zc(a);s.call(e)}}Uc(t,a,e,o)}else a=function(e,t,n,r,o){if(o){if("function"==typeof r){var i=r;r=function(){var e=zc(a);i.call(e)}}var a=Hc(t,r,e,0,null,!1,0,"",Jc);return e._reactRootContainer=a,e[mo]=a.current,Hr(8===e.nodeType?e.parentNode:e),uc(),a}for(;o=e.lastChild;)e.removeChild(o);if("function"==typeof r){var s=r;r=function(){var e=zc(l);s.call(e)}}var l=Yc(e,0,!1,null,0,!1,0,"",Jc);return e._reactRootContainer=l,e[mo]=l.current,Hr(8===e.nodeType?e.parentNode:e),uc((function(){Uc(t,l,n,r)})),l}(n,t,e,o,r);return zc(a)}qc.prototype.render=Qc.prototype.render=function(e){var t=this._internalRoot;if(null===t)throw Error(i(409));Uc(e,t,null,null)},qc.prototype.unmount=Qc.prototype.unmount=function(){var e=this._internalRoot;if(null!==e){this._internalRoot=null;var t=e.containerInfo;uc((function(){Uc(null,e,null,null)})),t[mo]=null}},qc.prototype.unstable_scheduleHydration=function(e){if(e){var t=xt();e={blockedOn:null,target:e,priority:t};for(var n=0;n<Pt.length&&0!==t&&t<Pt[n].priority;n++);Pt.splice(n,0,e),0===n&&Nt(e)}},At=function(e){switch(e.tag){case 3:var t=e.stateNode;if(t.current.memoizedState.isDehydrated){var n=dt(t.pendingLanes);0!==n&&(yt(t,1|n),rc(t,Ze()),!(6&Ml)&&(Hl=Ze()+500,Uo()))}break;case 13:uc((function(){var t=Bi(e,1);if(null!==t){var n=ec();nc(t,e,1,n)}})),Vc(e,1)}},Et=function(e){if(13===e.tag){var t=Bi(e,134217728);if(null!==t)nc(t,e,134217728,ec());Vc(e,134217728)}},wt=function(e){if(13===e.tag){var t=tc(e),n=Bi(e,t);if(null!==n)nc(n,e,t,ec());Vc(e,t)}},xt=function(){return bt},kt=function(e,t){var n=bt;try{return bt=e,t()}finally{bt=n}},Ee=function(e,t,n){switch(t){case"input":if(J(e,n),t=n.name,"radio"===n.type&&null!=t){for(n=e;n.parentNode;)n=n.parentNode;for(n=n.querySelectorAll("input[name="+JSON.stringify(""+t)+'][type="radio"]'),t=0;t<n.length;t++){var r=n[t];if(r!==e&&r.form===e.form){var o=Eo(r);if(!o)throw Error(i(90));G(r),J(r,o)}}}break;case"textarea":ie(e,n);break;case"select":null!=(t=n.value)&&ne(e,!!n.multiple,t,!1)}},Me=cc,Te=uc;var eu={usingClientEntryPoint:!1,Events:[_o,Ao,Eo,Ce,Se,cc]},tu={findFiberByHostInstance:bo,bundleType:0,version:"18.3.1",rendererPackageName:"react-dom"},nu={bundleType:tu.bundleType,version:tu.version,rendererPackageName:tu.rendererPackageName,rendererConfig:tu.rendererConfig,overrideHookState:null,overrideHookStateDeletePath:null,overrideHookStateRenamePath:null,overrideProps:null,overridePropsDeletePath:null,overridePropsRenamePath:null,setErrorHandler:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:_.ReactCurrentDispatcher,findHostInstanceByFiber:function(e){return null===(e=We(e))?null:e.stateNode},findFiberByHostInstance:tu.findFiberByHostInstance||function(){return null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null,reconcilerVersion:"18.3.1-next-f1338f8080-20240426"};if("undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__){var ru=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!ru.isDisabled&&ru.supportsFiber)try{ot=ru.inject(nu),it=ru}catch(ue){}}t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=eu,t.createPortal=function(e,t){var n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!Kc(t))throw Error(i(200));return function(e,t,n){var r=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:E,key:null==r?null:""+r,children:e,containerInfo:t,implementation:n}}(e,t,null,n)},t.createRoot=function(e,t){if(!Kc(e))throw Error(i(299));var n=!1,r="",o=Gc;return null!=t&&(!0===t.unstable_strictMode&&(n=!0),void 0!==t.identifierPrefix&&(r=t.identifierPrefix),void 0!==t.onRecoverableError&&(o=t.onRecoverableError)),t=Yc(e,1,!1,null,0,n,0,r,o),e[mo]=t.current,Hr(8===e.nodeType?e.parentNode:e),new Qc(t)},t.findDOMNode=function(e){if(null==e)return null;if(1===e.nodeType)return e;var t=e._reactInternals;if(void 0===t){if("function"==typeof e.render)throw Error(i(188));throw e=Object.keys(e).join(","),Error(i(268,e))}return e=null===(e=We(t))?null:e.stateNode},t.flushSync=function(e){return uc(e)},t.hydrate=function(e,t,n){if(!Zc(t))throw Error(i(200));return Xc(null,e,t,!0,n)},t.hydrateRoot=function(e,t,n){if(!Kc(e))throw Error(i(405));var r=null!=n&&n.hydratedSources||null,o=!1,a="",s=Gc;if(null!=n&&(!0===n.unstable_strictMode&&(o=!0),void 0!==n.identifierPrefix&&(a=n.identifierPrefix),void 0!==n.onRecoverableError&&(s=n.onRecoverableError)),t=Hc(t,null,e,1,null!=n?n:null,o,0,a,s),e[mo]=t.current,Hr(e),r)for(e=0;e<r.length;e++)o=(o=(n=r[e])._getVersion)(n._source),null==t.mutableSourceEagerHydrationData?t.mutableSourceEagerHydrationData=[n,o]:t.mutableSourceEagerHydrationData.push(n,o);return new qc(t)},t.render=function(e,t,n){if(!Zc(t))throw Error(i(200));return Xc(null,e,t,!1,n)},t.unmountComponentAtNode=function(e){if(!Zc(e))throw Error(i(40));return!!e._reactRootContainer&&(uc((function(){Xc(null,null,e,!1,(function(){e._reactRootContainer=null,e[mo]=null}))})),!0)},t.unstable_batchedUpdates=cc,t.unstable_renderSubtreeIntoContainer=function(e,t,n,r){if(!Zc(n))throw Error(i(200));if(null==e||void 0===e._reactInternals)throw Error(i(38));return Xc(e,t,n,!1,r)},t.version="18.3.1-next-f1338f8080-20240426"},94140:(e,t,n)=>{"use strict";var r=n(22483);t.H=r.createRoot,r.hydrateRoot},22483:(e,t,n)=>{"use strict";!function e(){if("undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__&&"function"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE)try{__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e)}catch(e){console.error(e)}}(),e.exports=n(37045)},32169:e=>{var t="undefined"!=typeof Element,n="function"==typeof Map,r="function"==typeof Set,o="function"==typeof ArrayBuffer&&!!ArrayBuffer.isView;function i(e,a){if(e===a)return!0;if(e&&a&&"object"==typeof e&&"object"==typeof a){if(e.constructor!==a.constructor)return!1;var s,l,c,u;if(Array.isArray(e)){if((s=e.length)!=a.length)return!1;for(l=s;0!=l--;)if(!i(e[l],a[l]))return!1;return!0}if(n&&e instanceof Map&&a instanceof Map){if(e.size!==a.size)return!1;for(u=e.entries();!(l=u.next()).done;)if(!a.has(l.value[0]))return!1;for(u=e.entries();!(l=u.next()).done;)if(!i(l.value[1],a.get(l.value[0])))return!1;return!0}if(r&&e instanceof Set&&a instanceof Set){if(e.size!==a.size)return!1;for(u=e.entries();!(l=u.next()).done;)if(!a.has(l.value[0]))return!1;return!0}if(o&&ArrayBuffer.isView(e)&&ArrayBuffer.isView(a)){if((s=e.length)!=a.length)return!1;for(l=s;0!=l--;)if(e[l]!==a[l])return!1;return!0}if(e.constructor===RegExp)return e.source===a.source&&e.flags===a.flags;if(e.valueOf!==Object.prototype.valueOf&&"function"==typeof e.valueOf&&"function"==typeof a.valueOf)return e.valueOf()===a.valueOf();if(e.toString!==Object.prototype.toString&&"function"==typeof e.toString&&"function"==typeof a.toString)return e.toString()===a.toString();if((s=(c=Object.keys(e)).length)!==Object.keys(a).length)return!1;for(l=s;0!=l--;)if(!Object.prototype.hasOwnProperty.call(a,c[l]))return!1;if(t&&e instanceof Element)return!1;for(l=s;0!=l--;)if(("_owner"!==c[l]&&"__v"!==c[l]&&"__o"!==c[l]||!e.$$typeof)&&!i(e[c[l]],a[c[l]]))return!1;return!0}return e!=e&&a!=a}e.exports=function(e,t){try{return i(e,t)}catch(e){if((e.message||"").match(/stack|recursion/i))return console.warn("react-fast-compare cannot handle circular refs"),!1;throw e}}},94934:(e,t,n)=>{"use strict";n.r(t),n.d(t,{IGNORE_CLASS_NAME:()=>h,default:()=>g});var r=n(77810),o=n(22483);function i(e,t){return i=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e},i(e,t)}function a(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function s(e,t,n){return e===t||(e.correspondingElement?e.correspondingElement.classList.contains(n):e.classList.contains(n))}var l,c,u=(void 0===l&&(l=0),function(){return++l}),d={},p={},f=["touchstart","touchmove"],h="ignore-react-onclickoutside";function m(e,t){var n={};return-1!==f.indexOf(t)&&c&&(n.passive=!e.props.preventDefault),n}const g=function(e,t){var n,l,f=e.displayName||e.name||"Component";return l=n=function(n){var l,h;function g(e){var r;return(r=n.call(this,e)||this).__outsideClickHandler=function(e){if("function"!=typeof r.__clickOutsideHandlerProp){var t=r.getInstance();if("function"!=typeof t.props.handleClickOutside){if("function"!=typeof t.handleClickOutside)throw new Error("WrappedComponent: "+f+" lacks a handleClickOutside(event) function for processing outside click events.");t.handleClickOutside(e)}else t.props.handleClickOutside(e)}else r.__clickOutsideHandlerProp(e)},r.__getComponentNode=function(){var e=r.getInstance();return t&&"function"==typeof t.setClickOutsideRef?t.setClickOutsideRef()(e):"function"==typeof e.setClickOutsideRef?e.setClickOutsideRef():(0,o.findDOMNode)(e)},r.enableOnClickOutside=function(){if("undefined"!=typeof document&&!p[r._uid]){void 0===c&&(c=function(){if("undefined"!=typeof window&&"function"==typeof window.addEventListener){var e=!1,t=Object.defineProperty({},"passive",{get:function(){e=!0}}),n=function(){};return window.addEventListener("testPassiveEventSupport",n,t),window.removeEventListener("testPassiveEventSupport",n,t),e}}()),p[r._uid]=!0;var e=r.props.eventTypes;e.forEach||(e=[e]),d[r._uid]=function(e){var t;null!==r.componentNode&&(r.initTimeStamp>e.timeStamp||(r.props.preventDefault&&e.preventDefault(),r.props.stopPropagation&&e.stopPropagation(),r.props.excludeScrollbar&&(t=e,document.documentElement.clientWidth<=t.clientX||document.documentElement.clientHeight<=t.clientY)||function(e,t,n){if(e===t)return!0;for(;e.parentNode||e.host;){if(e.parentNode&&s(e,t,n))return!0;e=e.parentNode||e.host}return e}(e.composed&&e.composedPath&&e.composedPath().shift()||e.target,r.componentNode,r.props.outsideClickIgnoreClass)===document&&r.__outsideClickHandler(e)))},e.forEach((function(e){document.addEventListener(e,d[r._uid],m(a(r),e))}))}},r.disableOnClickOutside=function(){delete p[r._uid];var e=d[r._uid];if(e&&"undefined"!=typeof document){var t=r.props.eventTypes;t.forEach||(t=[t]),t.forEach((function(t){return document.removeEventListener(t,e,m(a(r),t))})),delete d[r._uid]}},r.getRef=function(e){return r.instanceRef=e},r._uid=u(),r.initTimeStamp=performance.now(),r}h=n,(l=g).prototype=Object.create(h.prototype),l.prototype.constructor=l,i(l,h);var v=g.prototype;return v.getInstance=function(){if(e.prototype&&!e.prototype.isReactComponent)return this;var t=this.instanceRef;return t.getInstance?t.getInstance():t},v.componentDidMount=function(){if("undefined"!=typeof document&&document.createElement){var e=this.getInstance();if(t&&"function"==typeof t.handleClickOutside&&(this.__clickOutsideHandlerProp=t.handleClickOutside(e),"function"!=typeof this.__clickOutsideHandlerProp))throw new Error("WrappedComponent: "+f+" lacks a function for processing outside click events specified by the handleClickOutside config option.");this.componentNode=this.__getComponentNode(),this.props.disableOnClickOutside||this.enableOnClickOutside()}},v.componentDidUpdate=function(){this.componentNode=this.__getComponentNode()},v.componentWillUnmount=function(){this.disableOnClickOutside()},v.render=function(){var t=this.props;t.excludeScrollbar;var n=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["excludeScrollbar"]);return e.prototype&&e.prototype.isReactComponent?n.ref=this.getRef:n.wrappedRef=this.getRef,n.disableOnClickOutside=this.disableOnClickOutside,n.enableOnClickOutside=this.enableOnClickOutside,(0,r.createElement)(e,n)},g}(r.Component),n.displayName="OnClickOutside("+f+")",n.defaultProps={eventTypes:["mousedown","touchstart"],excludeScrollbar:t&&t.excludeScrollbar||!1,outsideClickIgnoreClass:h,preventDefault:!1,stopPropagation:!1},n.getClass=function(){return e.getClass?e.getClass():e},l}},57871:function(e,t,n){!function(e,t){"use strict";function n(e,t,n,r,o,i,a){try{var s=e[i](a),l=s.value}catch(e){return void n(e)}s.done?t(l):Promise.resolve(l).then(r,o)}function r(e){return function(){var t=this,r=arguments;return new Promise((function(o,i){var a=e.apply(t,r);function s(e){n(a,o,i,s,l,"next",e)}function l(e){n(a,o,i,s,l,"throw",e)}s(void 0)}))}}function o(){return(o=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}function i(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}function a(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}t=t&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t;var s={init:"init"},l=function(e){var t=e.value;return void 0===t?"":t},c=function(){return t.createElement(t.Fragment,null," ")},u={Cell:l,width:150,minWidth:0,maxWidth:Number.MAX_SAFE_INTEGER};function d(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return t.reduce((function(e,t){var n=t.style,r=t.className;return e=o({},e,{},i(t,["style","className"])),n&&(e.style=e.style?o({},e.style||{},{},n||{}):n),r&&(e.className=e.className?e.className+" "+r:r),""===e.className&&delete e.className,e}),{})}var p=function(e,t){return void 0===t&&(t={}),function(n){return void 0===n&&(n={}),[].concat(e,[n]).reduce((function(e,r){return function e(t,n,r){return"function"==typeof n?e({},n(t,r)):Array.isArray(n)?d.apply(void 0,[t].concat(n)):d(t,n)}(e,r,o({},t,{userProps:n}))}),{})}},f=function(e,t,n,r){return void 0===n&&(n={}),e.reduce((function(e,t){return t(e,n)}),t)},h=function(e,t,n){return void 0===n&&(n={}),e.forEach((function(e){e(t,n)}))};function m(e,t,n,r){e.findIndex((function(e){return e.pluginName===n})),t.forEach((function(t){e.findIndex((function(e){return e.pluginName===t}))}))}function g(e,t){return"function"==typeof e?e(t):e}function v(e){var n=t.useRef();return n.current=e,t.useCallback((function(){return n.current}),[])}var y="undefined"!=typeof document?t.useLayoutEffect:t.useEffect;function b(e,n){var r=t.useRef(!1);y((function(){r.current&&e(),r.current=!0}),n)}function _(e,t,n){return void 0===n&&(n={}),function(r,i){void 0===i&&(i={});var a="string"==typeof r?t[r]:r;if(void 0===a)throw console.info(t),new Error("Renderer Error ☝️");return A(a,o({},e,{column:t},n,{},i))}}function A(e,n){return function(e){return"function"==typeof e&&(t=Object.getPrototypeOf(e)).prototype&&t.prototype.isReactComponent;var t}(r=e)||"function"==typeof r||function(e){return"object"==typeof e&&"symbol"==typeof e.$$typeof&&["react.memo","react.forward_ref"].includes(e.$$typeof.description)}(r)?t.createElement(e,n):e;var r}function E(e,t,n){return void 0===n&&(n=0),e.map((function(e){return x(e=o({},e,{parent:t,depth:n})),e.columns&&(e.columns=E(e.columns,e,n+1)),e}))}function w(e){return O(e,"columns")}function x(e){var t=e.id,n=e.accessor,r=e.Header;if("string"==typeof n){t=t||n;var o=n.split(".");n=function(e){return function(e,t,n){if(!t)return e;var r,o="function"==typeof t?t:JSON.stringify(t),i=S.get(o)||function(){var e=function(e){return function e(t,n){if(void 0===n&&(n=[]),Array.isArray(t))for(var r=0;r<t.length;r+=1)e(t[r],n);else n.push(t);return n}(e).map((function(e){return String(e).replace(".","_")})).join(".").replace(R,".").replace(N,"").split(".")}(t);return S.set(o,e),e}();try{r=i.reduce((function(e,t){return e[t]}),e)}catch(e){}return void 0!==r?r:n}(e,o)}}if(!t&&"string"==typeof r&&r&&(t=r),!t&&e.columns)throw console.error(e),new Error('A column ID (or unique "Header" value) is required!');if(!t)throw console.error(e),new Error("A column ID (or string accessor) is required!");return Object.assign(e,{id:t,accessor:n}),e}function k(e,t){if(!t)throw new Error;return Object.assign(e,o({Header:c,Footer:c},u,{},t,{},e)),Object.assign(e,{originalWidth:e.width}),e}function C(e,t,n){void 0===n&&(n=function(){return{}});for(var r=[],i=e,a=0,s=function(){return a++},l=function(){var e={headers:[]},a=[],l=i.some((function(e){return e.parent}));i.forEach((function(r){var i,c=[].concat(a).reverse()[0];l&&(i=r.parent?o({},r.parent,{originalId:r.parent.id,id:r.parent.id+"_"+s(),headers:[r]},n(r)):k(o({originalId:r.id+"_placeholder",id:r.id+"_placeholder_"+s(),placeholderOf:r,headers:[r]},n(r)),t),c&&c.originalId===i.originalId?c.headers.push(r):a.push(i)),e.headers.push(r)})),r.push(e),i=a};i.length;)l();return r.reverse()}var S=new Map;function M(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];for(var r=0;r<t.length;r+=1)if(void 0!==t[r])return t[r]}function T(e){if("function"==typeof e)return e}function O(e,t){var n=[];return function e(r){r.forEach((function(r){r[t]?e(r[t]):n.push(r)}))}(e),n}function D(e,t){var n=t.manualExpandedKey,r=t.expanded,o=t.expandSubRows,i=void 0===o||o,a=[];return e.forEach((function(e){return function e(t,o){void 0===o&&(o=!0),t.isExpanded=t.original&&t.original[n]||r[t.id],t.canExpand=t.subRows&&!!t.subRows.length,o&&a.push(t),t.subRows&&t.subRows.length&&t.isExpanded&&t.subRows.forEach((function(t){return e(t,i)}))}(e)})),a}function L(e,t,n){return T(e)||t[e]||n[e]||n.text}function P(e,t,n){return e?e(t,n):void 0===t}function I(){throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.")}var B=null,R=/\[/g,N=/\]/g,F=function(e){return o({role:"table"},e)},j=function(e){return o({role:"rowgroup"},e)},Y=function(e,t){var n=t.column;return o({key:"header_"+n.id,colSpan:n.totalVisibleHeaderCount,role:"columnheader"},e)},$=function(e,t){var n=t.column;return o({key:"footer_"+n.id,colSpan:n.totalVisibleHeaderCount},e)},H=function(e,t){return o({key:"headerGroup_"+t.index,role:"row"},e)},U=function(e,t){return o({key:"footerGroup_"+t.index},e)},z=function(e,t){return o({key:"row_"+t.row.id,role:"row"},e)},W=function(e,t){var n=t.cell;return o({key:"cell_"+n.row.id+"_"+n.column.id,role:"cell"},e)};function V(){return{useOptions:[],stateReducers:[],useControlledState:[],columns:[],columnsDeps:[],allColumns:[],allColumnsDeps:[],accessValue:[],materializedColumns:[],materializedColumnsDeps:[],useInstanceAfterData:[],visibleColumns:[],visibleColumnsDeps:[],headerGroups:[],headerGroupsDeps:[],useInstanceBeforeDimensions:[],useInstance:[],prepareRow:[],getTableProps:[F],getTableBodyProps:[j],getHeaderGroupProps:[H],getFooterGroupProps:[U],getHeaderProps:[Y],getFooterProps:[$],getRowProps:[z],getCellProps:[W],useFinalInstance:[]}}s.resetHiddenColumns="resetHiddenColumns",s.toggleHideColumn="toggleHideColumn",s.setHiddenColumns="setHiddenColumns",s.toggleHideAllColumns="toggleHideAllColumns";var G=function(e){e.getToggleHiddenProps=[Q],e.getToggleHideAllColumnsProps=[q],e.stateReducers.push(K),e.useInstanceBeforeDimensions.push(Z),e.headerGroupsDeps.push((function(e,t){var n=t.instance;return[].concat(e,[n.state.hiddenColumns])})),e.useInstance.push(J)};G.pluginName="useColumnVisibility";var Q=function(e,t){var n=t.column;return[e,{onChange:function(e){n.toggleHidden(!e.target.checked)},style:{cursor:"pointer"},checked:n.isVisible,title:"Toggle Column Visible"}]},q=function(e,t){var n=t.instance;return[e,{onChange:function(e){n.toggleHideAllColumns(!e.target.checked)},style:{cursor:"pointer"},checked:!n.allColumnsHidden&&!n.state.hiddenColumns.length,title:"Toggle All Columns Hidden",indeterminate:!n.allColumnsHidden&&n.state.hiddenColumns.length}]};function K(e,t,n,r){if(t.type===s.init)return o({hiddenColumns:[]},e);if(t.type===s.resetHiddenColumns)return o({},e,{hiddenColumns:r.initialState.hiddenColumns||[]});if(t.type===s.toggleHideColumn){var i=(void 0!==t.value?t.value:!e.hiddenColumns.includes(t.columnId))?[].concat(e.hiddenColumns,[t.columnId]):e.hiddenColumns.filter((function(e){return e!==t.columnId}));return o({},e,{hiddenColumns:i})}return t.type===s.setHiddenColumns?o({},e,{hiddenColumns:g(t.value,e.hiddenColumns)}):t.type===s.toggleHideAllColumns?o({},e,{hiddenColumns:(void 0!==t.value?t.value:!e.hiddenColumns.length)?r.allColumns.map((function(e){return e.id})):[]}):void 0}function Z(e){var n=e.headers,r=e.state.hiddenColumns;t.useRef(!1).current;var o=0;n.forEach((function(e){return o+=function e(t,n){t.isVisible=n&&!r.includes(t.id);var o=0;return t.headers&&t.headers.length?t.headers.forEach((function(n){return o+=e(n,t.isVisible)})):o=t.isVisible?1:0,t.totalVisibleHeaderCount=o,o}(e,!0)}))}function J(e){var n=e.columns,r=e.flatHeaders,o=e.dispatch,i=e.allColumns,a=e.getHooks,l=e.state.hiddenColumns,c=e.autoResetHiddenColumns,u=void 0===c||c,d=v(e),f=i.length===l.length,h=t.useCallback((function(e,t){return o({type:s.toggleHideColumn,columnId:e,value:t})}),[o]),m=t.useCallback((function(e){return o({type:s.setHiddenColumns,value:e})}),[o]),g=t.useCallback((function(e){return o({type:s.toggleHideAllColumns,value:e})}),[o]),y=p(a().getToggleHideAllColumnsProps,{instance:d()});r.forEach((function(e){e.toggleHidden=function(t){o({type:s.toggleHideColumn,columnId:e.id,value:t})},e.getToggleHiddenProps=p(a().getToggleHiddenProps,{instance:d(),column:e})}));var _=v(u);b((function(){_()&&o({type:s.resetHiddenColumns})}),[o,n]),Object.assign(e,{allColumnsHidden:f,toggleHideColumn:h,setHiddenColumns:m,toggleHideAllColumns:g,getToggleHideAllColumnsProps:y})}var X={},ee={},te=function(e,t,n){return e},ne=function(e,t){return e.subRows||[]},re=function(e,t,n){return""+(n?[n.id,t].join("."):t)},oe=function(e){return e};function ie(e){var t=e.initialState,n=void 0===t?X:t,r=e.defaultColumn,a=void 0===r?ee:r,s=e.getSubRows,l=void 0===s?ne:s,c=e.getRowId,u=void 0===c?re:c,d=e.stateReducer,p=void 0===d?te:d,f=e.useControlledState,h=void 0===f?oe:f;return o({},i(e,["initialState","defaultColumn","getSubRows","getRowId","stateReducer","useControlledState"]),{initialState:n,defaultColumn:a,getSubRows:l,getRowId:u,stateReducer:p,useControlledState:h})}function ae(e,t){void 0===t&&(t=0);var n=0,r=0,o=0,i=0;return e.forEach((function(e){var a=e.headers;if(e.totalLeft=t,a&&a.length){var s=ae(a,t),l=s[0],c=s[1],u=s[2],d=s[3];e.totalMinWidth=l,e.totalWidth=c,e.totalMaxWidth=u,e.totalFlexWidth=d}else e.totalMinWidth=e.minWidth,e.totalWidth=Math.min(Math.max(e.minWidth,e.width),e.maxWidth),e.totalMaxWidth=e.maxWidth,e.totalFlexWidth=e.canResize?e.totalWidth:0;e.isVisible&&(t+=e.totalWidth,n+=e.totalMinWidth,r+=e.totalWidth,o+=e.totalMaxWidth,i+=e.totalFlexWidth)})),[n,r,o,i]}function se(e){var t=e.data,n=e.rows,r=e.flatRows,o=e.rowsById,i=e.column,a=e.getRowId,s=e.getSubRows,l=e.accessValueHooks,c=e.getInstance;t.forEach((function(e,u){return function e(n,u,d,p,h){void 0===d&&(d=0);var m=n,g=a(n,u,p),v=o[g];if(v)v.subRows&&v.originalSubRows.forEach((function(t,n){return e(t,n,d+1,v)}));else if((v={id:g,original:m,index:u,depth:d,cells:[{}]}).cells.map=I,v.cells.filter=I,v.cells.forEach=I,v.cells[0].getCellProps=I,v.values={},h.push(v),r.push(v),o[g]=v,v.originalSubRows=s(n,u),v.originalSubRows){var y=[];v.originalSubRows.forEach((function(t,n){return e(t,n,d+1,v,y)})),v.subRows=y}i.accessor&&(v.values[i.id]=i.accessor(n,u,v,h,t)),v.values[i.id]=f(l,v.values[i.id],{row:v,column:i,instance:c()})}(e,u,0,void 0,n)}))}s.resetExpanded="resetExpanded",s.toggleRowExpanded="toggleRowExpanded",s.toggleAllRowsExpanded="toggleAllRowsExpanded";var le=function(e){e.getToggleAllRowsExpandedProps=[ce],e.getToggleRowExpandedProps=[ue],e.stateReducers.push(de),e.useInstance.push(pe),e.prepareRow.push(fe)};le.pluginName="useExpanded";var ce=function(e,t){var n=t.instance;return[e,{onClick:function(e){n.toggleAllRowsExpanded()},style:{cursor:"pointer"},title:"Toggle All Rows Expanded"}]},ue=function(e,t){var n=t.row;return[e,{onClick:function(){n.toggleRowExpanded()},style:{cursor:"pointer"},title:"Toggle Row Expanded"}]};function de(e,t,n,r){if(t.type===s.init)return o({expanded:{}},e);if(t.type===s.resetExpanded)return o({},e,{expanded:r.initialState.expanded||{}});if(t.type===s.toggleAllRowsExpanded){var l=t.value,c=r.rowsById,u=Object.keys(c).length===Object.keys(e.expanded).length;if(void 0!==l?l:!u){var d={};return Object.keys(c).forEach((function(e){d[e]=!0})),o({},e,{expanded:d})}return o({},e,{expanded:{}})}if(t.type===s.toggleRowExpanded){var p,f=t.id,h=t.value,m=e.expanded[f],g=void 0!==h?h:!m;if(!m&&g)return o({},e,{expanded:o({},e.expanded,(p={},p[f]=!0,p))});if(m&&!g){var v=e.expanded;return v[f],o({},e,{expanded:i(v,[f].map(a))})}return e}}function pe(e){var n=e.data,r=e.rows,o=e.rowsById,i=e.manualExpandedKey,a=void 0===i?"expanded":i,l=e.paginateExpandedRows,c=void 0===l||l,u=e.expandSubRows,d=void 0===u||u,f=e.autoResetExpanded,h=void 0===f||f,g=e.getHooks,y=e.plugins,_=e.state.expanded,A=e.dispatch;m(y,["useSortBy","useGroupBy","usePivotColumns","useGlobalFilter"],"useExpanded");var E=v(h),w=Boolean(Object.keys(o).length&&Object.keys(_).length);w&&Object.keys(o).some((function(e){return!_[e]}))&&(w=!1),b((function(){E()&&A({type:s.resetExpanded})}),[A,n]);var x=t.useCallback((function(e,t){A({type:s.toggleRowExpanded,id:e,value:t})}),[A]),k=t.useCallback((function(e){return A({type:s.toggleAllRowsExpanded,value:e})}),[A]),C=t.useMemo((function(){return c?D(r,{manualExpandedKey:a,expanded:_,expandSubRows:d}):r}),[c,r,a,_,d]),S=t.useMemo((function(){return function(e){var t=0;return Object.keys(e).forEach((function(e){var n=e.split(".");t=Math.max(t,n.length)})),t}(_)}),[_]),M=v(e),T=p(g().getToggleAllRowsExpandedProps,{instance:M()});Object.assign(e,{preExpandedRows:r,expandedRows:C,rows:C,expandedDepth:S,isAllRowsExpanded:w,toggleRowExpanded:x,toggleAllRowsExpanded:k,getToggleAllRowsExpandedProps:T})}function fe(e,t){var n=t.instance.getHooks,r=t.instance;e.toggleRowExpanded=function(t){return r.toggleRowExpanded(e.id,t)},e.getToggleRowExpandedProps=p(n().getToggleRowExpandedProps,{instance:r,row:e})}var he=function(e,t,n){return e.filter((function(e){return t.some((function(t){var r=e.values[t];return String(r).toLowerCase().includes(String(n).toLowerCase())}))}))};he.autoRemove=function(e){return!e};var me=function(e,t,n){return e.filter((function(e){return t.some((function(t){var r=e.values[t];return void 0===r||String(r).toLowerCase()===String(n).toLowerCase()}))}))};me.autoRemove=function(e){return!e};var ge=function(e,t,n){return e.filter((function(e){return t.some((function(t){var r=e.values[t];return void 0===r||String(r)===String(n)}))}))};ge.autoRemove=function(e){return!e};var ve=function(e,t,n){return e.filter((function(e){return t.some((function(t){return e.values[t].includes(n)}))}))};ve.autoRemove=function(e){return!e||!e.length};var ye=function(e,t,n){return e.filter((function(e){return t.some((function(t){var r=e.values[t];return r&&r.length&&n.every((function(e){return r.includes(e)}))}))}))};ye.autoRemove=function(e){return!e||!e.length};var be=function(e,t,n){return e.filter((function(e){return t.some((function(t){var r=e.values[t];return r&&r.length&&n.some((function(e){return r.includes(e)}))}))}))};be.autoRemove=function(e){return!e||!e.length};var _e=function(e,t,n){return e.filter((function(e){return t.some((function(t){var r=e.values[t];return n.includes(r)}))}))};_e.autoRemove=function(e){return!e||!e.length};var Ae=function(e,t,n){return e.filter((function(e){return t.some((function(t){return e.values[t]===n}))}))};Ae.autoRemove=function(e){return void 0===e};var Ee=function(e,t,n){return e.filter((function(e){return t.some((function(t){return e.values[t]==n}))}))};Ee.autoRemove=function(e){return null==e};var we=function(e,t,n){var r=n||[],o=r[0],i=r[1];if((o="number"==typeof o?o:-1/0)>(i="number"==typeof i?i:1/0)){var a=o;o=i,i=a}return e.filter((function(e){return t.some((function(t){var n=e.values[t];return n>=o&&n<=i}))}))};we.autoRemove=function(e){return!e||"number"!=typeof e[0]&&"number"!=typeof e[1]};var xe=Object.freeze({__proto__:null,text:he,exactText:me,exactTextCase:ge,includes:ve,includesAll:ye,includesSome:be,includesValue:_e,exact:Ae,equals:Ee,between:we});s.resetFilters="resetFilters",s.setFilter="setFilter",s.setAllFilters="setAllFilters";var ke=function(e){e.stateReducers.push(Ce),e.useInstance.push(Se)};function Ce(e,t,n,r){if(t.type===s.init)return o({filters:[]},e);if(t.type===s.resetFilters)return o({},e,{filters:r.initialState.filters||[]});if(t.type===s.setFilter){var i=t.columnId,a=t.filterValue,l=r.allColumns,c=r.filterTypes,u=l.find((function(e){return e.id===i}));if(!u)throw new Error("React-Table: Could not find a column with id: "+i);var d=L(u.filter,c||{},xe),p=e.filters.find((function(e){return e.id===i})),f=g(a,p&&p.value);return P(d.autoRemove,f,u)?o({},e,{filters:e.filters.filter((function(e){return e.id!==i}))}):o({},e,p?{filters:e.filters.map((function(e){return e.id===i?{id:i,value:f}:e}))}:{filters:[].concat(e.filters,[{id:i,value:f}])})}if(t.type===s.setAllFilters){var h=t.filters,m=r.allColumns,v=r.filterTypes;return o({},e,{filters:g(h,e.filters).filter((function(e){var t=m.find((function(t){return t.id===e.id}));return!P(L(t.filter,v||{},xe).autoRemove,e.value,t)}))})}}function Se(e){var n=e.data,r=e.rows,o=e.flatRows,i=e.rowsById,a=e.allColumns,l=e.filterTypes,c=e.manualFilters,u=e.defaultCanFilter,d=void 0!==u&&u,p=e.disableFilters,f=e.state.filters,h=e.dispatch,m=e.autoResetFilters,g=void 0===m||m,y=t.useCallback((function(e,t){h({type:s.setFilter,columnId:e,filterValue:t})}),[h]),_=t.useCallback((function(e){h({type:s.setAllFilters,filters:e})}),[h]);a.forEach((function(e){var t=e.id,n=e.accessor,r=e.defaultCanFilter,o=e.disableFilters;e.canFilter=n?M(!0!==o&&void 0,!0!==p&&void 0,!0):M(r,d,!1),e.setFilter=function(t){return y(e.id,t)};var i=f.find((function(e){return e.id===t}));e.filterValue=i&&i.value}));var A=t.useMemo((function(){if(c||!f.length)return[r,o,i];var e=[],t={};return[function n(r,o){void 0===o&&(o=0);var i=r;return(i=f.reduce((function(e,t){var n=t.id,r=t.value,i=a.find((function(e){return e.id===n}));if(!i)return e;0===o&&(i.preFilteredRows=e);var s=L(i.filter,l||{},xe);return s?(i.filteredRows=s(e,[n],r),i.filteredRows):(console.warn("Could not find a valid 'column.filter' for column with the ID: "+i.id+"."),e)}),r)).forEach((function(r){e.push(r),t[r.id]=r,r.subRows&&(r.subRows=r.subRows&&r.subRows.length>0?n(r.subRows,o+1):r.subRows)})),i}(r),e,t]}),[c,f,r,o,i,a,l]),E=A[0],w=A[1],x=A[2];t.useMemo((function(){a.filter((function(e){return!f.find((function(t){return t.id===e.id}))})).forEach((function(e){e.preFilteredRows=E,e.filteredRows=E}))}),[E,f,a]);var k=v(g);b((function(){k()&&h({type:s.resetFilters})}),[h,c?null:n]),Object.assign(e,{preFilteredRows:r,preFilteredFlatRows:o,preFilteredRowsById:i,filteredRows:E,filteredFlatRows:w,filteredRowsById:x,rows:E,flatRows:w,rowsById:x,setFilter:y,setAllFilters:_})}ke.pluginName="useFilters",s.resetGlobalFilter="resetGlobalFilter",s.setGlobalFilter="setGlobalFilter";var Me=function(e){e.stateReducers.push(Te),e.useInstance.push(Oe)};function Te(e,t,n,r){if(t.type===s.resetGlobalFilter)return o({},e,{globalFilter:r.initialState.globalFilter||void 0});if(t.type===s.setGlobalFilter){var a=t.filterValue,l=r.userFilterTypes,c=L(r.globalFilter,l||{},xe),u=g(a,e.globalFilter);return P(c.autoRemove,u)?(e.globalFilter,i(e,["globalFilter"])):o({},e,{globalFilter:u})}}function Oe(e){var n=e.data,r=e.rows,o=e.flatRows,i=e.rowsById,a=e.allColumns,l=e.filterTypes,c=e.globalFilter,u=e.manualGlobalFilter,d=e.state.globalFilter,p=e.dispatch,f=e.autoResetGlobalFilter,h=void 0===f||f,m=e.disableGlobalFilter,g=t.useCallback((function(e){p({type:s.setGlobalFilter,filterValue:e})}),[p]),y=t.useMemo((function(){if(u||void 0===d)return[r,o,i];var e=[],t={},n=L(c,l||{},xe);if(!n)return console.warn("Could not find a valid 'globalFilter' option."),r;a.forEach((function(e){var t=e.disableGlobalFilter;e.canFilter=M(!0!==t&&void 0,!0!==m&&void 0,!0)}));var s=a.filter((function(e){return!0===e.canFilter}));return[function r(o){return(o=n(o,s.map((function(e){return e.id})),d)).forEach((function(n){e.push(n),t[n.id]=n,n.subRows=n.subRows&&n.subRows.length?r(n.subRows):n.subRows})),o}(r),e,t]}),[u,d,c,l,a,r,o,i,m]),_=y[0],A=y[1],E=y[2],w=v(h);b((function(){w()&&p({type:s.resetGlobalFilter})}),[p,u?null:n]),Object.assign(e,{preGlobalFilteredRows:r,preGlobalFilteredFlatRows:o,preGlobalFilteredRowsById:i,globalFilteredRows:_,globalFilteredFlatRows:A,globalFilteredRowsById:E,rows:_,flatRows:A,rowsById:E,setGlobalFilter:g,disableGlobalFilter:m})}function De(e,t){return t.reduce((function(e,t){return e+("number"==typeof t?t:0)}),0)}Me.pluginName="useGlobalFilter";var Le=Object.freeze({__proto__:null,sum:De,min:function(e){var t=e[0]||0;return e.forEach((function(e){"number"==typeof e&&(t=Math.min(t,e))})),t},max:function(e){var t=e[0]||0;return e.forEach((function(e){"number"==typeof e&&(t=Math.max(t,e))})),t},minMax:function(e){var t=e[0]||0,n=e[0]||0;return e.forEach((function(e){"number"==typeof e&&(t=Math.min(t,e),n=Math.max(n,e))})),t+".."+n},average:function(e){return De(0,e)/e.length},median:function(e){if(!e.length)return null;var t=Math.floor(e.length/2),n=[].concat(e).sort((function(e,t){return e-t}));return e.length%2!=0?n[t]:(n[t-1]+n[t])/2},unique:function(e){return Array.from(new Set(e).values())},uniqueCount:function(e){return new Set(e).size},count:function(e){return e.length}}),Pe=[],Ie={};s.resetGroupBy="resetGroupBy",s.setGroupBy="setGroupBy",s.toggleGroupBy="toggleGroupBy";var Be=function(e){e.getGroupByToggleProps=[Re],e.stateReducers.push(Ne),e.visibleColumnsDeps.push((function(e,t){var n=t.instance;return[].concat(e,[n.state.groupBy])})),e.visibleColumns.push(Fe),e.useInstance.push(Ye),e.prepareRow.push($e)};Be.pluginName="useGroupBy";var Re=function(e,t){var n=t.header;return[e,{onClick:n.canGroupBy?function(e){e.persist(),n.toggleGroupBy()}:void 0,style:{cursor:n.canGroupBy?"pointer":void 0},title:"Toggle GroupBy"}]};function Ne(e,t,n,r){if(t.type===s.init)return o({groupBy:[]},e);if(t.type===s.resetGroupBy)return o({},e,{groupBy:r.initialState.groupBy||[]});if(t.type===s.setGroupBy)return o({},e,{groupBy:t.value});if(t.type===s.toggleGroupBy){var i=t.columnId,a=t.value,l=void 0!==a?a:!e.groupBy.includes(i);return o({},e,l?{groupBy:[].concat(e.groupBy,[i])}:{groupBy:e.groupBy.filter((function(e){return e!==i}))})}}function Fe(e,t){var n=t.instance.state.groupBy,r=n.map((function(t){return e.find((function(e){return e.id===t}))})).filter(Boolean),o=e.filter((function(e){return!n.includes(e.id)}));return(e=[].concat(r,o)).forEach((function(e){e.isGrouped=n.includes(e.id),e.groupedIndex=n.indexOf(e.id)})),e}var je={};function Ye(e){var n=e.data,r=e.rows,i=e.flatRows,a=e.rowsById,l=e.allColumns,c=e.flatHeaders,u=e.groupByFn,d=void 0===u?He:u,f=e.manualGroupBy,h=e.aggregations,g=void 0===h?je:h,y=e.plugins,_=e.state.groupBy,A=e.dispatch,E=e.autoResetGroupBy,w=void 0===E||E,x=e.disableGroupBy,k=e.defaultCanGroupBy,C=e.getHooks;m(y,["useColumnOrder","useFilters"],"useGroupBy");var S=v(e);l.forEach((function(t){var n=t.accessor,r=t.defaultGroupBy,o=t.disableGroupBy;t.canGroupBy=n?M(t.canGroupBy,!0!==o&&void 0,!0!==x&&void 0,!0):M(t.canGroupBy,r,k,!1),t.canGroupBy&&(t.toggleGroupBy=function(){return e.toggleGroupBy(t.id)}),t.Aggregated=t.Aggregated||t.Cell}));var T=t.useCallback((function(e,t){A({type:s.toggleGroupBy,columnId:e,value:t})}),[A]),D=t.useCallback((function(e){A({type:s.setGroupBy,value:e})}),[A]);c.forEach((function(e){e.getGroupByToggleProps=p(C().getGroupByToggleProps,{instance:S(),header:e})}));var L=t.useMemo((function(){if(f||!_.length)return[r,i,a,Pe,Ie,i,a];var e=_.filter((function(e){return l.find((function(t){return t.id===e}))})),t=[],n={},s=[],c={},u=[],p={},h=function r(i,a,f){if(void 0===a&&(a=0),a===e.length)return i.map((function(e){return o({},e,{depth:a})}));var h=e[a],m=d(i,h);return Object.entries(m).map((function(o,i){var d=o[0],m=o[1],v=h+":"+d,y=r(m,a+1,v=f?f+">"+v:v),b=a?O(m,"leafRows"):m,_=function(t,n,r){var o={};return l.forEach((function(i){if(e.includes(i.id))o[i.id]=n[0]?n[0].values[i.id]:null;else{var a="function"==typeof i.aggregate?i.aggregate:g[i.aggregate]||Le[i.aggregate];if(a){var s=n.map((function(e){return e.values[i.id]})),l=t.map((function(e){var t=e.values[i.id];if(!r&&i.aggregateValue){var n="function"==typeof i.aggregateValue?i.aggregateValue:g[i.aggregateValue]||Le[i.aggregateValue];if(!n)throw console.info({column:i}),new Error("React Table: Invalid column.aggregateValue option for column listed above");t=n(t,e,i)}return t}));o[i.id]=a(l,s)}else{if(i.aggregate)throw console.info({column:i}),new Error("React Table: Invalid column.aggregate option for column listed above");o[i.id]=null}}})),o}(b,m,a),A={id:v,isGrouped:!0,groupByID:h,groupByVal:d,values:_,subRows:y,leafRows:b,depth:a,index:i};return y.forEach((function(e){t.push(e),n[e.id]=e,e.isGrouped?(s.push(e),c[e.id]=e):(u.push(e),p[e.id]=e)})),A}))}(r);return h.forEach((function(e){t.push(e),n[e.id]=e,e.isGrouped?(s.push(e),c[e.id]=e):(u.push(e),p[e.id]=e)})),[h,t,n,s,c,u,p]}),[f,_,r,i,a,l,g,d]),P=L[0],I=L[1],B=L[2],R=L[3],N=L[4],F=L[5],j=L[6],Y=v(w);b((function(){Y()&&A({type:s.resetGroupBy})}),[A,f?null:n]),Object.assign(e,{preGroupedRows:r,preGroupedFlatRow:i,preGroupedRowsById:a,groupedRows:P,groupedFlatRows:I,groupedRowsById:B,onlyGroupedFlatRows:R,onlyGroupedRowsById:N,nonGroupedFlatRows:F,nonGroupedRowsById:j,rows:P,flatRows:I,rowsById:B,toggleGroupBy:T,setGroupBy:D})}function $e(e){e.allCells.forEach((function(t){var n;t.isGrouped=t.column.isGrouped&&t.column.id===e.groupByID,t.isPlaceholder=!t.isGrouped&&t.column.isGrouped,t.isAggregated=!t.isGrouped&&!t.isPlaceholder&&(null==(n=e.subRows)?void 0:n.length)}))}function He(e,t){return e.reduce((function(e,n,r){var o=""+n.values[t];return e[o]=Array.isArray(e[o])?e[o]:[],e[o].push(n),e}),{})}var Ue=/([0-9]+)/gm;function ze(e,t){return e===t?0:e>t?1:-1}function We(e,t,n){return[e.values[n],t.values[n]]}function Ve(e){return"number"==typeof e?isNaN(e)||e===1/0||e===-1/0?"":String(e):"string"==typeof e?e:""}var Ge=Object.freeze({__proto__:null,alphanumeric:function(e,t,n){var r=We(e,t,n),o=r[0],i=r[1];for(o=Ve(o),i=Ve(i),o=o.split(Ue).filter(Boolean),i=i.split(Ue).filter(Boolean);o.length&&i.length;){var a=o.shift(),s=i.shift(),l=parseInt(a,10),c=parseInt(s,10),u=[l,c].sort();if(isNaN(u[0])){if(a>s)return 1;if(s>a)return-1}else{if(isNaN(u[1]))return isNaN(l)?-1:1;if(l>c)return 1;if(c>l)return-1}}return o.length-i.length},datetime:function(e,t,n){var r=We(e,t,n),o=r[0],i=r[1];return ze(o=o.getTime(),i=i.getTime())},basic:function(e,t,n){var r=We(e,t,n);return ze(r[0],r[1])},string:function(e,t,n){var r=We(e,t,n),o=r[0],i=r[1];for(o=o.split("").filter(Boolean),i=i.split("").filter(Boolean);o.length&&i.length;){var a=o.shift(),s=i.shift(),l=a.toLowerCase(),c=s.toLowerCase();if(l>c)return 1;if(c>l)return-1;if(a>s)return 1;if(s>a)return-1}return o.length-i.length},number:function(e,t,n){var r=We(e,t,n),o=r[0],i=r[1],a=/[^0-9.]/gi;return ze(o=Number(String(o).replace(a,"")),i=Number(String(i).replace(a,"")))}});s.resetSortBy="resetSortBy",s.setSortBy="setSortBy",s.toggleSortBy="toggleSortBy",s.clearSortBy="clearSortBy",u.sortType="alphanumeric",u.sortDescFirst=!1;var Qe=function(e){e.getSortByToggleProps=[qe],e.stateReducers.push(Ke),e.useInstance.push(Ze)};Qe.pluginName="useSortBy";var qe=function(e,t){var n=t.instance,r=t.column,o=n.isMultiSortEvent,i=void 0===o?function(e){return e.shiftKey}:o;return[e,{onClick:r.canSort?function(e){e.persist(),r.toggleSortBy(void 0,!n.disableMultiSort&&i(e))}:void 0,style:{cursor:r.canSort?"pointer":void 0},title:r.canSort?"Toggle SortBy":void 0}]};function Ke(e,t,n,r){if(t.type===s.init)return o({sortBy:[]},e);if(t.type===s.resetSortBy)return o({},e,{sortBy:r.initialState.sortBy||[]});if(t.type===s.clearSortBy)return o({},e,{sortBy:e.sortBy.filter((function(e){return e.id!==t.columnId}))});if(t.type===s.setSortBy)return o({},e,{sortBy:t.sortBy});if(t.type===s.toggleSortBy){var i,a=t.columnId,l=t.desc,c=t.multi,u=r.allColumns,d=r.disableMultiSort,p=r.disableSortRemove,f=r.disableMultiRemove,h=r.maxMultiSortColCount,m=void 0===h?Number.MAX_SAFE_INTEGER:h,g=e.sortBy,v=u.find((function(e){return e.id===a})).sortDescFirst,y=g.find((function(e){return e.id===a})),b=g.findIndex((function(e){return e.id===a})),_=null!=l,A=[];return"toggle"!=(i=!d&&c?y?"toggle":"add":b!==g.length-1||1!==g.length?"replace":y?"toggle":"replace")||p||_||c&&f||!(y&&y.desc&&!v||!y.desc&&v)||(i="remove"),"replace"===i?A=[{id:a,desc:_?l:v}]:"add"===i?(A=[].concat(g,[{id:a,desc:_?l:v}])).splice(0,A.length-m):"toggle"===i?A=g.map((function(e){return e.id===a?o({},e,{desc:_?l:!y.desc}):e})):"remove"===i&&(A=g.filter((function(e){return e.id!==a}))),o({},e,{sortBy:A})}}function Ze(e){var n=e.data,r=e.rows,o=e.flatRows,i=e.allColumns,a=e.orderByFn,l=void 0===a?Je:a,c=e.sortTypes,u=e.manualSortBy,d=e.defaultCanSort,f=e.disableSortBy,h=e.flatHeaders,g=e.state.sortBy,y=e.dispatch,_=e.plugins,A=e.getHooks,E=e.autoResetSortBy,w=void 0===E||E;m(_,["useFilters","useGlobalFilter","useGroupBy","usePivotColumns"],"useSortBy");var x=t.useCallback((function(e){y({type:s.setSortBy,sortBy:e})}),[y]),k=t.useCallback((function(e,t,n){y({type:s.toggleSortBy,columnId:e,desc:t,multi:n})}),[y]),C=v(e);h.forEach((function(e){var t=e.accessor,n=e.canSort,r=e.disableSortBy,o=e.id,i=t?M(!0!==r&&void 0,!0!==f&&void 0,!0):M(d,n,!1);e.canSort=i,e.canSort&&(e.toggleSortBy=function(t,n){return k(e.id,t,n)},e.clearSortBy=function(){y({type:s.clearSortBy,columnId:e.id})}),e.getSortByToggleProps=p(A().getSortByToggleProps,{instance:C(),column:e});var a=g.find((function(e){return e.id===o}));e.isSorted=!!a,e.sortedIndex=g.findIndex((function(e){return e.id===o})),e.isSortedDesc=e.isSorted?a.desc:void 0}));var S=t.useMemo((function(){if(u||!g.length)return[r,o];var e=[],t=g.filter((function(e){return i.find((function(t){return t.id===e.id}))}));return[function n(r){var o=l(r,t.map((function(e){var t=i.find((function(t){return t.id===e.id}));if(!t)throw new Error("React-Table: Could not find a column with id: "+e.id+" while sorting");var n=t.sortType,r=T(n)||(c||{})[n]||Ge[n];if(!r)throw new Error("React-Table: Could not find a valid sortType of '"+n+"' for column '"+e.id+"'.");return function(t,n){return r(t,n,e.id,e.desc)}})),t.map((function(e){var t=i.find((function(t){return t.id===e.id}));return t&&t.sortInverted?e.desc:!e.desc})));return o.forEach((function(t){e.push(t),t.subRows&&0!==t.subRows.length&&(t.subRows=n(t.subRows))})),o}(r),e]}),[u,g,r,o,i,l,c]),O=S[0],D=S[1],L=v(w);b((function(){L()&&y({type:s.resetSortBy})}),[u?null:n]),Object.assign(e,{preSortedRows:r,preSortedFlatRows:o,sortedRows:O,sortedFlatRows:D,rows:O,flatRows:D,setSortBy:x,toggleSortBy:k})}function Je(e,t,n){return[].concat(e).sort((function(e,r){for(var o=0;o<t.length;o+=1){var i=t[o],a=!1===n[o]||"desc"===n[o],s=i(e,r);if(0!==s)return a?-s:s}return n[0]?e.index-r.index:r.index-e.index}))}s.resetPage="resetPage",s.gotoPage="gotoPage",s.setPageSize="setPageSize";var Xe=function(e){e.stateReducers.push(et),e.useInstance.push(tt)};function et(e,t,n,r){if(t.type===s.init)return o({pageSize:10,pageIndex:0},e);if(t.type===s.resetPage)return o({},e,{pageIndex:r.initialState.pageIndex||0});if(t.type===s.gotoPage){var i=r.pageCount,a=r.page,l=g(t.pageIndex,e.pageIndex),c=!1;return l>e.pageIndex?c=-1===i?a.length>=e.pageSize:l<i:l<e.pageIndex&&(c=l>-1),c?o({},e,{pageIndex:l}):e}if(t.type===s.setPageSize){var u=t.pageSize,d=e.pageSize*e.pageIndex;return o({},e,{pageIndex:Math.floor(d/u),pageSize:u})}}function tt(e){var n=e.rows,r=e.autoResetPage,o=void 0===r||r,i=e.manualExpandedKey,a=void 0===i?"expanded":i,l=e.plugins,c=e.pageCount,u=e.paginateExpandedRows,d=void 0===u||u,p=e.expandSubRows,f=void 0===p||p,h=e.state,g=h.pageSize,y=h.pageIndex,_=h.expanded,A=h.globalFilter,E=h.filters,w=h.groupBy,x=h.sortBy,k=e.dispatch,C=e.data,S=e.manualPagination;m(l,["useGlobalFilter","useFilters","useGroupBy","useSortBy","useExpanded"],"usePagination");var M=v(o);b((function(){M()&&k({type:s.resetPage})}),[k,S?null:C,A,E,w,x]);var T=S?c:Math.ceil(n.length/g),O=t.useMemo((function(){return T>0?[].concat(new Array(T)).fill(null).map((function(e,t){return t})):[]}),[T]),L=t.useMemo((function(){var e;if(S)e=n;else{var t=g*y,r=t+g;e=n.slice(t,r)}return d?e:D(e,{manualExpandedKey:a,expanded:_,expandSubRows:f})}),[f,_,a,S,y,g,d,n]),P=y>0,I=-1===T?L.length>=g:y<T-1,B=t.useCallback((function(e){k({type:s.gotoPage,pageIndex:e})}),[k]),R=t.useCallback((function(){return B((function(e){return e-1}))}),[B]),N=t.useCallback((function(){return B((function(e){return e+1}))}),[B]),F=t.useCallback((function(e){k({type:s.setPageSize,pageSize:e})}),[k]);Object.assign(e,{pageOptions:O,pageCount:T,page:L,canPreviousPage:P,canNextPage:I,gotoPage:B,previousPage:R,nextPage:N,setPageSize:F})}Xe.pluginName="usePagination",s.resetPivot="resetPivot",s.togglePivot="togglePivot";var nt=function(e){e.getPivotToggleProps=[ot],e.stateReducers.push(it),e.useInstanceAfterData.push(at),e.allColumns.push(st),e.accessValue.push(lt),e.materializedColumns.push(ct),e.materializedColumnsDeps.push(ut),e.visibleColumns.push(dt),e.visibleColumnsDeps.push(pt),e.useInstance.push(ft),e.prepareRow.push(ht)};nt.pluginName="usePivotColumns";var rt=[],ot=function(e,t){var n=t.header;return[e,{onClick:n.canPivot?function(e){e.persist(),n.togglePivot()}:void 0,style:{cursor:n.canPivot?"pointer":void 0},title:"Toggle Pivot"}]};function it(e,t,n,r){if(t.type===s.init)return o({pivotColumns:rt},e);if(t.type===s.resetPivot)return o({},e,{pivotColumns:r.initialState.pivotColumns||rt});if(t.type===s.togglePivot){var i=t.columnId,a=t.value,l=void 0!==a?a:!e.pivotColumns.includes(i);return o({},e,l?{pivotColumns:[].concat(e.pivotColumns,[i])}:{pivotColumns:e.pivotColumns.filter((function(e){return e!==i}))})}}function at(e){e.allColumns.forEach((function(t){t.isPivotSource=e.state.pivotColumns.includes(t.id)}))}function st(e,t){var n=t.instance;return e.forEach((function(e){e.isPivotSource=n.state.pivotColumns.includes(e.id),e.uniqueValues=new Set})),e}function lt(e,t){var n=t.column;return n.uniqueValues&&void 0!==e&&n.uniqueValues.add(e),e}function ct(e,t){var n=t.instance,r=n.allColumns,i=n.state;if(!i.pivotColumns.length||!i.groupBy||!i.groupBy.length)return e;var a=i.pivotColumns.map((function(e){return r.find((function(t){return t.id===e}))})).filter(Boolean),s=r.filter((function(e){return!e.isPivotSource&&!i.groupBy.includes(e.id)&&!i.pivotColumns.includes(e.id)})),l=w(function e(t,n,r){void 0===t&&(t=0),void 0===r&&(r=[]);var i=a[t];return i?Array.from(i.uniqueValues).sort().map((function(a){var s=o({},i,{Header:i.PivotHeader||"string"==typeof i.header?i.Header+": "+a:a,isPivotGroup:!0,parent:n,depth:t,id:n?n.id+"."+i.id+"."+a:i.id+"."+a,pivotValue:a});return s.columns=e(t+1,s,[].concat(r,[function(e){return e.values[i.id]===a}])),s})):s.map((function(e){return o({},e,{canPivot:!1,isPivoted:!0,parent:n,depth:t,id:""+(n?n.id+"."+e.id:e.id),accessor:function(t,n,o){if(r.every((function(e){return e(o)})))return o.values[e.id]}})}))}());return[].concat(e,l)}function ut(e,t){var n=t.instance.state,r=n.pivotColumns,o=n.groupBy;return[].concat(e,[r,o])}function dt(e,t){var n=t.instance.state;return e=e.filter((function(e){return!e.isPivotSource})),n.pivotColumns.length&&n.groupBy&&n.groupBy.length&&(e=e.filter((function(e){return e.isGrouped||e.isPivoted}))),e}function pt(e,t){var n=t.instance;return[].concat(e,[n.state.pivotColumns,n.state.groupBy])}function ft(e){var t=e.columns,n=e.allColumns,r=e.flatHeaders,o=e.getHooks,i=e.plugins,a=e.dispatch,l=e.autoResetPivot,c=void 0===l||l,u=e.manaulPivot,d=e.disablePivot,f=e.defaultCanPivot;m(i,["useGroupBy"],"usePivotColumns");var h=v(e);n.forEach((function(t){var n=t.accessor,r=t.defaultPivot,o=t.disablePivot;t.canPivot=n?M(t.canPivot,!0!==o&&void 0,!0!==d&&void 0,!0):M(t.canPivot,r,f,!1),t.canPivot&&(t.togglePivot=function(){return e.togglePivot(t.id)}),t.Aggregated=t.Aggregated||t.Cell})),r.forEach((function(e){e.getPivotToggleProps=p(o().getPivotToggleProps,{instance:h(),header:e})}));var g=v(c);b((function(){g()&&a({type:s.resetPivot})}),[a,u?null:t]),Object.assign(e,{togglePivot:function(e,t){a({type:s.togglePivot,columnId:e,value:t})}})}function ht(e){e.allCells.forEach((function(e){e.isPivoted=e.column.isPivoted}))}s.resetSelectedRows="resetSelectedRows",s.toggleAllRowsSelected="toggleAllRowsSelected",s.toggleRowSelected="toggleRowSelected",s.toggleAllPageRowsSelected="toggleAllPageRowsSelected";var mt=function(e){e.getToggleRowSelectedProps=[gt],e.getToggleAllRowsSelectedProps=[vt],e.getToggleAllPageRowsSelectedProps=[yt],e.stateReducers.push(bt),e.useInstance.push(_t),e.prepareRow.push(At)};mt.pluginName="useRowSelect";var gt=function(e,t){var n=t.instance,r=t.row,o=n.manualRowSelectedKey,i=void 0===o?"isSelected":o;return[e,{onChange:function(e){r.toggleRowSelected(e.target.checked)},style:{cursor:"pointer"},checked:!(!r.original||!r.original[i])||r.isSelected,title:"Toggle Row Selected",indeterminate:r.isSomeSelected}]},vt=function(e,t){var n=t.instance;return[e,{onChange:function(e){n.toggleAllRowsSelected(e.target.checked)},style:{cursor:"pointer"},checked:n.isAllRowsSelected,title:"Toggle All Rows Selected",indeterminate:Boolean(!n.isAllRowsSelected&&Object.keys(n.state.selectedRowIds).length)}]},yt=function(e,t){var n=t.instance;return[e,{onChange:function(e){n.toggleAllPageRowsSelected(e.target.checked)},style:{cursor:"pointer"},checked:n.isAllPageRowsSelected,title:"Toggle All Current Page Rows Selected",indeterminate:Boolean(!n.isAllPageRowsSelected&&n.page.some((function(e){var t=e.id;return n.state.selectedRowIds[t]})))}]};function bt(e,t,n,r){if(t.type===s.init)return o({selectedRowIds:{}},e);if(t.type===s.resetSelectedRows)return o({},e,{selectedRowIds:r.initialState.selectedRowIds||{}});if(t.type===s.toggleAllRowsSelected){var i=t.value,a=r.isAllRowsSelected,l=r.rowsById,c=r.nonGroupedRowsById,u=void 0===c?l:c,d=void 0!==i?i:!a,p=Object.assign({},e.selectedRowIds);return d?Object.keys(u).forEach((function(e){p[e]=!0})):Object.keys(u).forEach((function(e){delete p[e]})),o({},e,{selectedRowIds:p})}if(t.type===s.toggleRowSelected){var f=t.id,h=t.value,m=r.rowsById,g=r.selectSubRows,v=void 0===g||g,y=r.getSubRows,b=e.selectedRowIds[f],_=void 0!==h?h:!b;if(b===_)return e;var A=o({},e.selectedRowIds);return function e(t){var n=m[t];if(n&&(n.isGrouped||(_?A[t]=!0:delete A[t]),v&&y(n)))return y(n).forEach((function(t){return e(t.id)}))}(f),o({},e,{selectedRowIds:A})}if(t.type===s.toggleAllPageRowsSelected){var E=t.value,w=r.page,x=r.rowsById,k=r.selectSubRows,C=void 0===k||k,S=r.isAllPageRowsSelected,M=r.getSubRows,T=void 0!==E?E:!S,O=o({},e.selectedRowIds);return w.forEach((function(e){return function e(t){var n=x[t];if(n.isGrouped||(T?O[t]=!0:delete O[t]),C&&M(n))return M(n).forEach((function(t){return e(t.id)}))}(e.id)})),o({},e,{selectedRowIds:O})}return e}function _t(e){var n=e.data,r=e.rows,o=e.getHooks,i=e.plugins,a=e.rowsById,l=e.nonGroupedRowsById,c=void 0===l?a:l,u=e.autoResetSelectedRows,d=void 0===u||u,f=e.state.selectedRowIds,h=e.selectSubRows,g=void 0===h||h,y=e.dispatch,_=e.page,A=e.getSubRows;m(i,["useFilters","useGroupBy","useSortBy","useExpanded","usePagination"],"useRowSelect");var E=t.useMemo((function(){var e=[];return r.forEach((function(t){var n=g?function e(t,n,r){if(n[t.id])return!0;var o=r(t);if(o&&o.length){var i=!0,a=!1;return o.forEach((function(t){a&&!i||(e(t,n,r)?a=!0:i=!1)})),!!i||!!a&&null}return!1}(t,f,A):!!f[t.id];t.isSelected=!!n,t.isSomeSelected=null===n,n&&e.push(t)})),e}),[r,g,f,A]),w=Boolean(Object.keys(c).length&&Object.keys(f).length),x=w;w&&Object.keys(c).some((function(e){return!f[e]}))&&(w=!1),w||_&&_.length&&_.some((function(e){var t=e.id;return!f[t]}))&&(x=!1);var k=v(d);b((function(){k()&&y({type:s.resetSelectedRows})}),[y,n]);var C=t.useCallback((function(e){return y({type:s.toggleAllRowsSelected,value:e})}),[y]),S=t.useCallback((function(e){return y({type:s.toggleAllPageRowsSelected,value:e})}),[y]),M=t.useCallback((function(e,t){return y({type:s.toggleRowSelected,id:e,value:t})}),[y]),T=v(e),O=p(o().getToggleAllRowsSelectedProps,{instance:T()}),D=p(o().getToggleAllPageRowsSelectedProps,{instance:T()});Object.assign(e,{selectedFlatRows:E,isAllRowsSelected:w,isAllPageRowsSelected:x,toggleRowSelected:M,toggleAllRowsSelected:C,getToggleAllRowsSelectedProps:O,getToggleAllPageRowsSelectedProps:D,toggleAllPageRowsSelected:S})}function At(e,t){var n=t.instance;e.toggleRowSelected=function(t){return n.toggleRowSelected(e.id,t)},e.getToggleRowSelectedProps=p(n.getHooks().getToggleRowSelectedProps,{instance:n,row:e})}var Et=function(e){return{}},wt=function(e){return{}};s.setRowState="setRowState",s.setCellState="setCellState",s.resetRowState="resetRowState";var xt=function(e){e.stateReducers.push(kt),e.useInstance.push(Ct),e.prepareRow.push(St)};function kt(e,t,n,r){var i=r.initialRowStateAccessor,a=void 0===i?Et:i,l=r.initialCellStateAccessor,c=void 0===l?wt:l,u=r.rowsById;if(t.type===s.init)return o({rowState:{}},e);if(t.type===s.resetRowState)return o({},e,{rowState:r.initialState.rowState||{}});if(t.type===s.setRowState){var d,p=t.rowId,f=t.value,h=void 0!==e.rowState[p]?e.rowState[p]:a(u[p]);return o({},e,{rowState:o({},e.rowState,(d={},d[p]=g(f,h),d))})}if(t.type===s.setCellState){var m,v,y,b,_,A=t.rowId,E=t.columnId,w=t.value,x=void 0!==e.rowState[A]?e.rowState[A]:a(u[A]),k=void 0!==(null==x||null==(m=x.cellState)?void 0:m[E])?x.cellState[E]:c(null==(v=u[A])||null==(y=v.cells)?void 0:y.find((function(e){return e.column.id===E})));return o({},e,{rowState:o({},e.rowState,(_={},_[A]=o({},x,{cellState:o({},x.cellState||{},(b={},b[E]=g(w,k),b))}),_))})}}function Ct(e){var n=e.autoResetRowState,r=void 0===n||n,o=e.data,i=e.dispatch,a=t.useCallback((function(e,t){return i({type:s.setRowState,rowId:e,value:t})}),[i]),l=t.useCallback((function(e,t,n){return i({type:s.setCellState,rowId:e,columnId:t,value:n})}),[i]),c=v(r);b((function(){c()&&i({type:s.resetRowState})}),[o]),Object.assign(e,{setRowState:a,setCellState:l})}function St(e,t){var n=t.instance,r=n.initialRowStateAccessor,o=void 0===r?Et:r,i=n.initialCellStateAccessor,a=void 0===i?wt:i,s=n.state.rowState;e&&(e.state=void 0!==s[e.id]?s[e.id]:o(e),e.setState=function(t){return n.setRowState(e.id,t)},e.cells.forEach((function(t){e.state.cellState||(e.state.cellState={}),t.state=void 0!==e.state.cellState[t.column.id]?e.state.cellState[t.column.id]:a(t),t.setState=function(r){return n.setCellState(e.id,t.column.id,r)}})))}xt.pluginName="useRowState",s.resetColumnOrder="resetColumnOrder",s.setColumnOrder="setColumnOrder";var Mt=function(e){e.stateReducers.push(Tt),e.visibleColumnsDeps.push((function(e,t){var n=t.instance;return[].concat(e,[n.state.columnOrder])})),e.visibleColumns.push(Ot),e.useInstance.push(Dt)};function Tt(e,t,n,r){return t.type===s.init?o({columnOrder:[]},e):t.type===s.resetColumnOrder?o({},e,{columnOrder:r.initialState.columnOrder||[]}):t.type===s.setColumnOrder?o({},e,{columnOrder:g(t.columnOrder,e.columnOrder)}):void 0}function Ot(e,t){var n=t.instance.state.columnOrder;if(!n||!n.length)return e;for(var r=[].concat(n),o=[].concat(e),i=[],a=function(){var e=r.shift(),t=o.findIndex((function(t){return t.id===e}));t>-1&&i.push(o.splice(t,1)[0])};o.length&&r.length;)a();return[].concat(i,o)}function Dt(e){var n=e.dispatch;e.setColumnOrder=t.useCallback((function(e){return n({type:s.setColumnOrder,columnOrder:e})}),[n])}Mt.pluginName="useColumnOrder",u.canResize=!0,s.columnStartResizing="columnStartResizing",s.columnResizing="columnResizing",s.columnDoneResizing="columnDoneResizing",s.resetResize="resetResize";var Lt=function(e){e.getResizerProps=[Pt],e.getHeaderProps.push({style:{position:"relative"}}),e.stateReducers.push(It),e.useInstance.push(Rt),e.useInstanceBeforeDimensions.push(Bt)},Pt=function(e,t){var n=t.instance,r=t.header,o=n.dispatch,i=function(e,t){var n=!1;if("touchstart"===e.type){if(e.touches&&e.touches.length>1)return;n=!0}var r,i,a=function(e){var t=[];return function e(n){n.columns&&n.columns.length&&n.columns.map(e),t.push(n)}(e),t}(t).map((function(e){return[e.id,e.totalWidth]})),l=n?Math.round(e.touches[0].clientX):e.clientX,c=function(){window.cancelAnimationFrame(r),r=null,o({type:s.columnDoneResizing})},u=function(){window.cancelAnimationFrame(r),r=null,o({type:s.columnResizing,clientX:i})},d=function(e){i=e,r||(r=window.requestAnimationFrame(u))},p={mouse:{moveEvent:"mousemove",moveHandler:function(e){return d(e.clientX)},upEvent:"mouseup",upHandler:function(e){document.removeEventListener("mousemove",p.mouse.moveHandler),document.removeEventListener("mouseup",p.mouse.upHandler),c()}},touch:{moveEvent:"touchmove",moveHandler:function(e){return e.cancelable&&(e.preventDefault(),e.stopPropagation()),d(e.touches[0].clientX),!1},upEvent:"touchend",upHandler:function(e){document.removeEventListener(p.touch.moveEvent,p.touch.moveHandler),document.removeEventListener(p.touch.upEvent,p.touch.moveHandler),c()}}},f=n?p.touch:p.mouse,h=!!function(){if("boolean"==typeof B)return B;var e=!1;try{var t={get passive(){return e=!0,!1}};window.addEventListener("test",null,t),window.removeEventListener("test",null,t)}catch(t){e=!1}return B=e}()&&{passive:!1};document.addEventListener(f.moveEvent,f.moveHandler,h),document.addEventListener(f.upEvent,f.upHandler,h),o({type:s.columnStartResizing,columnId:t.id,columnWidth:t.totalWidth,headerIdWidths:a,clientX:l})};return[e,{onMouseDown:function(e){return e.persist()||i(e,r)},onTouchStart:function(e){return e.persist()||i(e,r)},style:{cursor:"col-resize"},draggable:!1,role:"separator"}]};function It(e,t){if(t.type===s.init)return o({columnResizing:{columnWidths:{}}},e);if(t.type===s.resetResize)return o({},e,{columnResizing:{columnWidths:{}}});if(t.type===s.columnStartResizing){var n=t.clientX,r=t.columnId,i=t.columnWidth,a=t.headerIdWidths;return o({},e,{columnResizing:o({},e.columnResizing,{startX:n,headerIdWidths:a,columnWidth:i,isResizingColumn:r})})}if(t.type===s.columnResizing){var l=t.clientX,c=e.columnResizing,u=c.startX,d=c.columnWidth,p=c.headerIdWidths,f=(l-u)/d,h={};return(void 0===p?[]:p).forEach((function(e){var t=e[0],n=e[1];h[t]=Math.max(n+n*f,0)})),o({},e,{columnResizing:o({},e.columnResizing,{columnWidths:o({},e.columnResizing.columnWidths,{},h)})})}return t.type===s.columnDoneResizing?o({},e,{columnResizing:o({},e.columnResizing,{startX:null,isResizingColumn:null})}):void 0}Lt.pluginName="useResizeColumns";var Bt=function(e){var t=e.flatHeaders,n=e.disableResizing,r=e.getHooks,o=e.state.columnResizing,i=v(e);t.forEach((function(e){var t=M(!0!==e.disableResizing&&void 0,!0!==n&&void 0,!0);e.canResize=t,e.width=o.columnWidths[e.id]||e.originalWidth||e.width,e.isResizing=o.isResizingColumn===e.id,t&&(e.getResizerProps=p(r().getResizerProps,{instance:i(),header:e}))}))};function Rt(e){var n=e.plugins,r=e.dispatch,o=e.autoResetResize,i=void 0===o||o,a=e.columns;m(n,["useAbsoluteLayout"],"useResizeColumns");var l=v(i);b((function(){l()&&r({type:s.resetResize})}),[a]);var c=t.useCallback((function(){return r({type:s.resetResize})}),[r]);Object.assign(e,{resetResizing:c})}var Nt={position:"absolute",top:0},Ft=function(e){e.getTableBodyProps.push(jt),e.getRowProps.push(jt),e.getHeaderGroupProps.push(jt),e.getFooterGroupProps.push(jt),e.getHeaderProps.push((function(e,t){var n=t.column;return[e,{style:o({},Nt,{left:n.totalLeft+"px",width:n.totalWidth+"px"})}]})),e.getCellProps.push((function(e,t){var n=t.cell;return[e,{style:o({},Nt,{left:n.column.totalLeft+"px",width:n.column.totalWidth+"px"})}]})),e.getFooterProps.push((function(e,t){var n=t.column;return[e,{style:o({},Nt,{left:n.totalLeft+"px",width:n.totalWidth+"px"})}]}))};Ft.pluginName="useAbsoluteLayout";var jt=function(e,t){return[e,{style:{position:"relative",width:t.instance.totalColumnsWidth+"px"}}]},Yt={display:"inline-block",boxSizing:"border-box"},$t=function(e,t){return[e,{style:{display:"flex",width:t.instance.totalColumnsWidth+"px"}}]},Ht=function(e){e.getRowProps.push($t),e.getHeaderGroupProps.push($t),e.getFooterGroupProps.push($t),e.getHeaderProps.push((function(e,t){var n=t.column;return[e,{style:o({},Yt,{width:n.totalWidth+"px"})}]})),e.getCellProps.push((function(e,t){var n=t.cell;return[e,{style:o({},Yt,{width:n.column.totalWidth+"px"})}]})),e.getFooterProps.push((function(e,t){var n=t.column;return[e,{style:o({},Yt,{width:n.totalWidth+"px"})}]}))};function Ut(e){e.getTableProps.push(zt),e.getRowProps.push(Wt),e.getHeaderGroupProps.push(Wt),e.getFooterGroupProps.push(Wt),e.getHeaderProps.push(Vt),e.getCellProps.push(Gt),e.getFooterProps.push(Qt)}Ht.pluginName="useBlockLayout",Ut.pluginName="useFlexLayout";var zt=function(e,t){return[e,{style:{minWidth:t.instance.totalColumnsMinWidth+"px"}}]},Wt=function(e,t){return[e,{style:{display:"flex",flex:"1 0 auto",minWidth:t.instance.totalColumnsMinWidth+"px"}}]},Vt=function(e,t){var n=t.column;return[e,{style:{boxSizing:"border-box",flex:n.totalFlexWidth?n.totalFlexWidth+" 0 auto":void 0,minWidth:n.totalMinWidth+"px",width:n.totalWidth+"px"}}]},Gt=function(e,t){var n=t.cell;return[e,{style:{boxSizing:"border-box",flex:n.column.totalFlexWidth+" 0 auto",minWidth:n.column.totalMinWidth+"px",width:n.column.totalWidth+"px"}}]},Qt=function(e,t){var n=t.column;return[e,{style:{boxSizing:"border-box",flex:n.totalFlexWidth?n.totalFlexWidth+" 0 auto":void 0,minWidth:n.totalMinWidth+"px",width:n.totalWidth+"px"}}]};function qt(e){e.stateReducers.push(Xt),e.getTableProps.push(Kt),e.getHeaderProps.push(Zt),e.getRowProps.push(Jt)}s.columnStartResizing="columnStartResizing",s.columnResizing="columnResizing",s.columnDoneResizing="columnDoneResizing",s.resetResize="resetResize",qt.pluginName="useGridLayout";var Kt=function(e,t){var n=t.instance;return[e,{style:{display:"grid",gridTemplateColumns:n.visibleColumns.map((function(e){var t;return n.state.gridLayout.columnWidths[e.id]?n.state.gridLayout.columnWidths[e.id]+"px":(null==(t=n.state.columnResizing)?void 0:t.isResizingColumn)?n.state.gridLayout.startWidths[e.id]+"px":"number"==typeof e.width?e.width+"px":e.width})).join(" ")}}]},Zt=function(e,t){var n=t.column;return[e,{id:"header-cell-"+n.id,style:{position:"sticky",gridColumn:"span "+n.totalVisibleHeaderCount}}]},Jt=function(e,t){var n=t.row;return n.isExpanded?[e,{style:{gridColumn:"1 / "+(n.cells.length+1)}}]:[e,{}]};function Xt(e,t,n,r){if(t.type===s.init)return o({gridLayout:{columnWidths:{}}},e);if(t.type===s.resetResize)return o({},e,{gridLayout:{columnWidths:{}}});if(t.type===s.columnStartResizing){var i=t.columnId,a=t.headerIdWidths,l=en(i);if(void 0!==l){var c=r.visibleColumns.reduce((function(e,t){var n;return o({},e,((n={})[t.id]=en(t.id),n))}),{}),u=r.visibleColumns.reduce((function(e,t){var n;return o({},e,((n={})[t.id]=t.minWidth,n))}),{}),d=r.visibleColumns.reduce((function(e,t){var n;return o({},e,((n={})[t.id]=t.maxWidth,n))}),{}),p=a.map((function(e){var t=e[0];return[t,en(t)]}));return o({},e,{gridLayout:o({},e.gridLayout,{startWidths:c,minWidths:u,maxWidths:d,headerIdGridWidths:p,columnWidth:l})})}return e}if(t.type===s.columnResizing){var f=t.clientX,h=e.columnResizing.startX,m=e.gridLayout,g=m.columnWidth,v=m.minWidths,y=m.maxWidths,b=m.headerIdGridWidths,_=(f-h)/g,A={};return(void 0===b?[]:b).forEach((function(e){var t=e[0],n=e[1];A[t]=Math.min(Math.max(v[t],n+n*_),y[t])})),o({},e,{gridLayout:o({},e.gridLayout,{columnWidths:o({},e.gridLayout.columnWidths,{},A)})})}return t.type===s.columnDoneResizing?o({},e,{gridLayout:o({},e.gridLayout,{startWidths:{},minWidths:{},maxWidths:{}})}):void 0}function en(e){var t,n=null==(t=document.getElementById("header-cell-"+e))?void 0:t.offsetWidth;if(void 0!==n)return n}e._UNSTABLE_usePivotColumns=nt,e.actions=s,e.defaultColumn=u,e.defaultGroupByFn=He,e.defaultOrderByFn=Je,e.defaultRenderer=l,e.emptyRenderer=c,e.ensurePluginOrder=m,e.flexRender=A,e.functionalUpdate=g,e.loopHooks=h,e.makePropGetter=p,e.makeRenderer=_,e.reduceHooks=f,e.safeUseLayoutEffect=y,e.useAbsoluteLayout=Ft,e.useAsyncDebounce=function(e,n){void 0===n&&(n=0);var o=t.useRef({}),i=v(e),a=v(n);return t.useCallback(function(){var e=r(regeneratorRuntime.mark((function e(){var t,n,s,l=arguments;return regeneratorRuntime.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:for(t=l.length,n=new Array(t),s=0;s<t;s++)n[s]=l[s];return o.current.promise||(o.current.promise=new Promise((function(e,t){o.current.resolve=e,o.current.reject=t}))),o.current.timeout&&clearTimeout(o.current.timeout),o.current.timeout=setTimeout(r(regeneratorRuntime.mark((function e(){return regeneratorRuntime.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return delete o.current.timeout,e.prev=1,e.t0=o.current,e.next=5,i().apply(void 0,n);case 5:e.t1=e.sent,e.t0.resolve.call(e.t0,e.t1),e.next=12;break;case 9:e.prev=9,e.t2=e.catch(1),o.current.reject(e.t2);case 12:return e.prev=12,delete o.current.promise,e.finish(12);case 15:case"end":return e.stop()}}),e,null,[[1,9,12,15]])}))),a()),e.abrupt("return",o.current.promise);case 5:case"end":return e.stop()}}),e)})));return function(){return e.apply(this,arguments)}}(),[i,a])},e.useBlockLayout=Ht,e.useColumnOrder=Mt,e.useExpanded=le,e.useFilters=ke,e.useFlexLayout=Ut,e.useGetLatest=v,e.useGlobalFilter=Me,e.useGridLayout=qt,e.useGroupBy=Be,e.useMountedLayoutEffect=b,e.usePagination=Xe,e.useResizeColumns=Lt,e.useRowSelect=mt,e.useRowState=xt,e.useSortBy=Qe,e.useTable=function(e){for(var n=arguments.length,r=new Array(n>1?n-1:0),i=1;i<n;i++)r[i-1]=arguments[i];e=ie(e),r=[G].concat(r);var a=v(t.useRef({}).current);Object.assign(a(),o({},e,{plugins:r,hooks:V()})),r.filter(Boolean).forEach((function(e){e(a().hooks)}));var l=v(a().hooks);a().getHooks=l,delete a().hooks,Object.assign(a(),f(l().useOptions,ie(e)));var c=a(),u=c.data,d=c.columns,m=c.initialState,g=c.defaultColumn,y=c.getSubRows,b=c.getRowId,A=c.stateReducer,S=c.useControlledState,M=v(A),T=t.useCallback((function(e,t){if(!t.type)throw console.info({action:t}),new Error("Unknown Action 👆");return[].concat(l().stateReducers,Array.isArray(M())?M():[M()]).reduce((function(n,r){return r(n,t,e,a())||n}),e)}),[l,M,a]),O=t.useReducer(T,void 0,(function(){return T(m,{type:s.init})})),D=O[0],L=O[1],P=f([].concat(l().useControlledState,[S]),D,{instance:a()});Object.assign(a(),{state:P,dispatch:L});var I=t.useMemo((function(){return E(f(l().columns,d,{instance:a()}))}),[l,a,d].concat(f(l().columnsDeps,[],{instance:a()})));a().columns=I;var B=t.useMemo((function(){return f(l().allColumns,w(I),{instance:a()}).map(x)}),[I,l,a].concat(f(l().allColumnsDeps,[],{instance:a()})));a().allColumns=B;var R=t.useMemo((function(){for(var e=[],t=[],n={},r=[].concat(B);r.length;){var o=r.shift();se({data:u,rows:e,flatRows:t,rowsById:n,column:o,getRowId:b,getSubRows:y,accessValueHooks:l().accessValue,getInstance:a})}return[e,t,n]}),[B,u,b,y,l,a]),N=R[0],F=R[1],j=R[2];Object.assign(a(),{rows:N,initialRows:[].concat(N),flatRows:F,rowsById:j}),h(l().useInstanceAfterData,a());var Y=t.useMemo((function(){return f(l().visibleColumns,B,{instance:a()}).map((function(e){return k(e,g)}))}),[l,B,a,g].concat(f(l().visibleColumnsDeps,[],{instance:a()})));B=t.useMemo((function(){var e=[].concat(Y);return B.forEach((function(t){e.find((function(e){return e.id===t.id}))||e.push(t)})),e}),[B,Y]),a().allColumns=B;var $=t.useMemo((function(){return f(l().headerGroups,C(Y,g),a())}),[l,Y,g,a].concat(f(l().headerGroupsDeps,[],{instance:a()})));a().headerGroups=$;var H=t.useMemo((function(){return $.length?$[0].headers:[]}),[$]);a().headers=H,a().flatHeaders=$.reduce((function(e,t){return[].concat(e,t.headers)}),[]),h(l().useInstanceBeforeDimensions,a());var U=Y.filter((function(e){return e.isVisible})).map((function(e){return e.id})).sort().join("_");Y=t.useMemo((function(){return Y.filter((function(e){return e.isVisible}))}),[Y,U]),a().visibleColumns=Y;var z=ae(H),W=z[0],Q=z[1],q=z[2];return a().totalColumnsMinWidth=W,a().totalColumnsWidth=Q,a().totalColumnsMaxWidth=q,h(l().useInstance,a()),[].concat(a().flatHeaders,a().allColumns).forEach((function(e){e.render=_(a(),e),e.getHeaderProps=p(l().getHeaderProps,{instance:a(),column:e}),e.getFooterProps=p(l().getFooterProps,{instance:a(),column:e})})),a().headerGroups=t.useMemo((function(){return $.filter((function(e,t){return e.headers=e.headers.filter((function(e){return e.headers?function e(t){return t.filter((function(t){return t.headers?e(t.headers):t.isVisible})).length}(e.headers):e.isVisible})),!!e.headers.length&&(e.getHeaderGroupProps=p(l().getHeaderGroupProps,{instance:a(),headerGroup:e,index:t}),e.getFooterGroupProps=p(l().getFooterGroupProps,{instance:a(),headerGroup:e,index:t}),!0)}))}),[$,a,l]),a().footerGroups=[].concat(a().headerGroups).reverse(),a().prepareRow=t.useCallback((function(e){e.getRowProps=p(l().getRowProps,{instance:a(),row:e}),e.allCells=B.map((function(t){var n=e.values[t.id],r={column:t,row:e,value:n};return r.getCellProps=p(l().getCellProps,{instance:a(),cell:r}),r.render=_(a(),t,{row:e,cell:r,value:n}),r})),e.cells=Y.map((function(t){return e.allCells.find((function(e){return e.column.id===t.id}))})),h(l().prepareRow,e,{instance:a()})}),[l,a,B,Y]),a().getTableProps=p(l().getTableProps,{instance:a()}),a().getTableBodyProps=p(l().getTableBodyProps,{instance:a()}),h(l().useFinalInstance,a()),a()},Object.defineProperty(e,"__esModule",{value:!0})}(t,n(77810))},96575:(e,t,n)=>{e.exports=n(57871)},13394:(e,t,n)=>{"use strict";
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var r=n(77810),o=Symbol.for("react.element"),i=Symbol.for("react.fragment"),a=Object.prototype.hasOwnProperty,s=r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,l={key:!0,ref:!0,__self:!0,__source:!0};function c(e,t,n){var r,i={},c=null,u=null;for(r in void 0!==n&&(c=""+n),void 0!==t.key&&(c=""+t.key),void 0!==t.ref&&(u=t.ref),t)a.call(t,r)&&!l.hasOwnProperty(r)&&(i[r]=t[r]);if(e&&e.defaultProps)for(r in t=e.defaultProps)void 0===i[r]&&(i[r]=t[r]);return{$$typeof:o,type:e,key:c,ref:u,props:i,_owner:s.current}}t.Fragment=i,t.jsx=c,t.jsxs=c},55677:(e,t)=>{"use strict";
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var n=Symbol.for("react.element"),r=Symbol.for("react.portal"),o=Symbol.for("react.fragment"),i=Symbol.for("react.strict_mode"),a=Symbol.for("react.profiler"),s=Symbol.for("react.provider"),l=Symbol.for("react.context"),c=Symbol.for("react.forward_ref"),u=Symbol.for("react.suspense"),d=Symbol.for("react.memo"),p=Symbol.for("react.lazy"),f=Symbol.iterator;var h={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},m=Object.assign,g={};function v(e,t,n){this.props=e,this.context=t,this.refs=g,this.updater=n||h}function y(){}function b(e,t,n){this.props=e,this.context=t,this.refs=g,this.updater=n||h}v.prototype.isReactComponent={},v.prototype.setState=function(e,t){if("object"!=typeof e&&"function"!=typeof e&&null!=e)throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");this.updater.enqueueSetState(this,e,t,"setState")},v.prototype.forceUpdate=function(e){this.updater.enqueueForceUpdate(this,e,"forceUpdate")},y.prototype=v.prototype;var _=b.prototype=new y;_.constructor=b,m(_,v.prototype),_.isPureReactComponent=!0;var A=Array.isArray,E=Object.prototype.hasOwnProperty,w={current:null},x={key:!0,ref:!0,__self:!0,__source:!0};function k(e,t,r){var o,i={},a=null,s=null;if(null!=t)for(o in void 0!==t.ref&&(s=t.ref),void 0!==t.key&&(a=""+t.key),t)E.call(t,o)&&!x.hasOwnProperty(o)&&(i[o]=t[o]);var l=arguments.length-2;if(1===l)i.children=r;else if(1<l){for(var c=Array(l),u=0;u<l;u++)c[u]=arguments[u+2];i.children=c}if(e&&e.defaultProps)for(o in l=e.defaultProps)void 0===i[o]&&(i[o]=l[o]);return{$$typeof:n,type:e,key:a,ref:s,props:i,_owner:w.current}}function C(e){return"object"==typeof e&&null!==e&&e.$$typeof===n}var S=/\/+/g;function M(e,t){return"object"==typeof e&&null!==e&&null!=e.key?function(e){var t={"=":"=0",":":"=2"};return"$"+e.replace(/[=:]/g,(function(e){return t[e]}))}(""+e.key):t.toString(36)}function T(e,t,o,i,a){var s=typeof e;"undefined"!==s&&"boolean"!==s||(e=null);var l=!1;if(null===e)l=!0;else switch(s){case"string":case"number":l=!0;break;case"object":switch(e.$$typeof){case n:case r:l=!0}}if(l)return a=a(l=e),e=""===i?"."+M(l,0):i,A(a)?(o="",null!=e&&(o=e.replace(S,"$&/")+"/"),T(a,t,o,"",(function(e){return e}))):null!=a&&(C(a)&&(a=function(e,t){return{$$typeof:n,type:e.type,key:t,ref:e.ref,props:e.props,_owner:e._owner}}(a,o+(!a.key||l&&l.key===a.key?"":(""+a.key).replace(S,"$&/")+"/")+e)),t.push(a)),1;if(l=0,i=""===i?".":i+":",A(e))for(var c=0;c<e.length;c++){var u=i+M(s=e[c],c);l+=T(s,t,o,u,a)}else if(u=function(e){return null===e||"object"!=typeof e?null:"function"==typeof(e=f&&e[f]||e["@@iterator"])?e:null}(e),"function"==typeof u)for(e=u.call(e),c=0;!(s=e.next()).done;)l+=T(s=s.value,t,o,u=i+M(s,c++),a);else if("object"===s)throw t=String(e),Error("Objects are not valid as a React child (found: "+("[object Object]"===t?"object with keys {"+Object.keys(e).join(", ")+"}":t)+"). If you meant to render a collection of children, use an array instead.");return l}function O(e,t,n){if(null==e)return e;var r=[],o=0;return T(e,r,"","",(function(e){return t.call(n,e,o++)})),r}function D(e){if(-1===e._status){var t=e._result;(t=t()).then((function(t){0!==e._status&&-1!==e._status||(e._status=1,e._result=t)}),(function(t){0!==e._status&&-1!==e._status||(e._status=2,e._result=t)})),-1===e._status&&(e._status=0,e._result=t)}if(1===e._status)return e._result.default;throw e._result}var L={current:null},P={transition:null},I={ReactCurrentDispatcher:L,ReactCurrentBatchConfig:P,ReactCurrentOwner:w};function B(){throw Error("act(...) is not supported in production builds of React.")}t.Children={map:O,forEach:function(e,t,n){O(e,(function(){t.apply(this,arguments)}),n)},count:function(e){var t=0;return O(e,(function(){t++})),t},toArray:function(e){return O(e,(function(e){return e}))||[]},only:function(e){if(!C(e))throw Error("React.Children.only expected to receive a single React element child.");return e}},t.Component=v,t.Fragment=o,t.Profiler=a,t.PureComponent=b,t.StrictMode=i,t.Suspense=u,t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=I,t.act=B,t.cloneElement=function(e,t,r){if(null==e)throw Error("React.cloneElement(...): The argument must be a React element, but you passed "+e+".");var o=m({},e.props),i=e.key,a=e.ref,s=e._owner;if(null!=t){if(void 0!==t.ref&&(a=t.ref,s=w.current),void 0!==t.key&&(i=""+t.key),e.type&&e.type.defaultProps)var l=e.type.defaultProps;for(c in t)E.call(t,c)&&!x.hasOwnProperty(c)&&(o[c]=void 0===t[c]&&void 0!==l?l[c]:t[c])}var c=arguments.length-2;if(1===c)o.children=r;else if(1<c){l=Array(c);for(var u=0;u<c;u++)l[u]=arguments[u+2];o.children=l}return{$$typeof:n,type:e.type,key:i,ref:a,props:o,_owner:s}},t.createContext=function(e){return(e={$$typeof:l,_currentValue:e,_currentValue2:e,_threadCount:0,Provider:null,Consumer:null,_defaultValue:null,_globalName:null}).Provider={$$typeof:s,_context:e},e.Consumer=e},t.createElement=k,t.createFactory=function(e){var t=k.bind(null,e);return t.type=e,t},t.createRef=function(){return{current:null}},t.forwardRef=function(e){return{$$typeof:c,render:e}},t.isValidElement=C,t.lazy=function(e){return{$$typeof:p,_payload:{_status:-1,_result:e},_init:D}},t.memo=function(e,t){return{$$typeof:d,type:e,compare:void 0===t?null:t}},t.startTransition=function(e){var t=P.transition;P.transition={};try{e()}finally{P.transition=t}},t.unstable_act=B,t.useCallback=function(e,t){return L.current.useCallback(e,t)},t.useContext=function(e){return L.current.useContext(e)},t.useDebugValue=function(){},t.useDeferredValue=function(e){return L.current.useDeferredValue(e)},t.useEffect=function(e,t){return L.current.useEffect(e,t)},t.useId=function(){return L.current.useId()},t.useImperativeHandle=function(e,t,n){return L.current.useImperativeHandle(e,t,n)},t.useInsertionEffect=function(e,t){return L.current.useInsertionEffect(e,t)},t.useLayoutEffect=function(e,t){return L.current.useLayoutEffect(e,t)},t.useMemo=function(e,t){return L.current.useMemo(e,t)},t.useReducer=function(e,t,n){return L.current.useReducer(e,t,n)},t.useRef=function(e){return L.current.useRef(e)},t.useState=function(e){return L.current.useState(e)},t.useSyncExternalStore=function(e,t,n){return L.current.useSyncExternalStore(e,t,n)},t.useTransition=function(){return L.current.useTransition()},t.version="18.3.1"},77810:(e,t,n)=>{"use strict";e.exports=n(55677)},64922:(e,t,n)=>{"use strict";e.exports=n(13394)},21613:(e,t)=>{"use strict";
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */function n(e,t){var n=e.length;e.push(t);e:for(;0<n;){var r=n-1>>>1,o=e[r];if(!(0<i(o,t)))break e;e[r]=t,e[n]=o,n=r}}function r(e){return 0===e.length?null:e[0]}function o(e){if(0===e.length)return null;var t=e[0],n=e.pop();if(n!==t){e[0]=n;e:for(var r=0,o=e.length,a=o>>>1;r<a;){var s=2*(r+1)-1,l=e[s],c=s+1,u=e[c];if(0>i(l,n))c<o&&0>i(u,l)?(e[r]=u,e[c]=n,r=c):(e[r]=l,e[s]=n,r=s);else{if(!(c<o&&0>i(u,n)))break e;e[r]=u,e[c]=n,r=c}}}return t}function i(e,t){var n=e.sortIndex-t.sortIndex;return 0!==n?n:e.id-t.id}if("object"==typeof performance&&"function"==typeof performance.now){var a=performance;t.unstable_now=function(){return a.now()}}else{var s=Date,l=s.now();t.unstable_now=function(){return s.now()-l}}var c=[],u=[],d=1,p=null,f=3,h=!1,m=!1,g=!1,v="function"==typeof setTimeout?setTimeout:null,y="function"==typeof clearTimeout?clearTimeout:null,b="undefined"!=typeof setImmediate?setImmediate:null;function _(e){for(var t=r(u);null!==t;){if(null===t.callback)o(u);else{if(!(t.startTime<=e))break;o(u),t.sortIndex=t.expirationTime,n(c,t)}t=r(u)}}function A(e){if(g=!1,_(e),!m)if(null!==r(c))m=!0,P(E);else{var t=r(u);null!==t&&I(A,t.startTime-e)}}function E(e,n){m=!1,g&&(g=!1,y(C),C=-1),h=!0;var i=f;try{for(_(n),p=r(c);null!==p&&(!(p.expirationTime>n)||e&&!T());){var a=p.callback;if("function"==typeof a){p.callback=null,f=p.priorityLevel;var s=a(p.expirationTime<=n);n=t.unstable_now(),"function"==typeof s?p.callback=s:p===r(c)&&o(c),_(n)}else o(c);p=r(c)}if(null!==p)var l=!0;else{var d=r(u);null!==d&&I(A,d.startTime-n),l=!1}return l}finally{p=null,f=i,h=!1}}"undefined"!=typeof navigator&&void 0!==navigator.scheduling&&void 0!==navigator.scheduling.isInputPending&&navigator.scheduling.isInputPending.bind(navigator.scheduling);var w,x=!1,k=null,C=-1,S=5,M=-1;function T(){return!(t.unstable_now()-M<S)}function O(){if(null!==k){var e=t.unstable_now();M=e;var n=!0;try{n=k(!0,e)}finally{n?w():(x=!1,k=null)}}else x=!1}if("function"==typeof b)w=function(){b(O)};else if("undefined"!=typeof MessageChannel){var D=new MessageChannel,L=D.port2;D.port1.onmessage=O,w=function(){L.postMessage(null)}}else w=function(){v(O,0)};function P(e){k=e,x||(x=!0,w())}function I(e,n){C=v((function(){e(t.unstable_now())}),n)}t.unstable_IdlePriority=5,t.unstable_ImmediatePriority=1,t.unstable_LowPriority=4,t.unstable_NormalPriority=3,t.unstable_Profiling=null,t.unstable_UserBlockingPriority=2,t.unstable_cancelCallback=function(e){e.callback=null},t.unstable_continueExecution=function(){m||h||(m=!0,P(E))},t.unstable_forceFrameRate=function(e){0>e||125<e?console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"):S=0<e?Math.floor(1e3/e):5},t.unstable_getCurrentPriorityLevel=function(){return f},t.unstable_getFirstCallbackNode=function(){return r(c)},t.unstable_next=function(e){switch(f){case 1:case 2:case 3:var t=3;break;default:t=f}var n=f;f=t;try{return e()}finally{f=n}},t.unstable_pauseExecution=function(){},t.unstable_requestPaint=function(){},t.unstable_runWithPriority=function(e,t){switch(e){case 1:case 2:case 3:case 4:case 5:break;default:e=3}var n=f;f=e;try{return t()}finally{f=n}},t.unstable_scheduleCallback=function(e,o,i){var a=t.unstable_now();switch("object"==typeof i&&null!==i?i="number"==typeof(i=i.delay)&&0<i?a+i:a:i=a,e){case 1:var s=-1;break;case 2:s=250;break;case 5:s=1073741823;break;case 4:s=1e4;break;default:s=5e3}return e={id:d++,callback:o,priorityLevel:e,startTime:i,expirationTime:s=i+s,sortIndex:-1},i>a?(e.sortIndex=i,n(u,e),null===r(c)&&e===r(u)&&(g?(y(C),C=-1):g=!0,I(A,i-a))):(e.sortIndex=s,n(c,e),m||h||(m=!0,P(E))),e},t.unstable_shouldYield=T,t.unstable_wrapCallback=function(e){var t=f;return function(){var n=f;f=t;try{return e.apply(this,arguments)}finally{f=n}}}},82328:(e,t,n)=>{"use strict";e.exports=n(21613)},47110:function(e,t,n){var r,o;/*! smooth-scroll v16.1.3 | (c) 2020 Chris Ferdinandi | MIT License | http://github.com/cferdinandi/smooth-scroll */window.Element&&!Element.prototype.closest&&(Element.prototype.closest=function(e){var t,n=(this.document||this.ownerDocument).querySelectorAll(e),r=this;do{for(t=n.length;0<=--t&&n.item(t)!==r;);}while(t<0&&(r=r.parentElement));return r}),function(){function e(e,t){t=t||{bubbles:!1,cancelable:!1,detail:void 0};var n=document.createEvent("CustomEvent");return n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),n}"function"!=typeof window.CustomEvent&&(e.prototype=window.Event.prototype,window.CustomEvent=e)}(),function(){for(var e=0,t=["ms","moz","webkit","o"],n=0;n<t.length&&!window.requestAnimationFrame;++n)window.requestAnimationFrame=window[t[n]+"RequestAnimationFrame"],window.cancelAnimationFrame=window[t[n]+"CancelAnimationFrame"]||window[t[n]+"CancelRequestAnimationFrame"];window.requestAnimationFrame||(window.requestAnimationFrame=function(t,n){var r=(new Date).getTime(),o=Math.max(0,16-(r-e)),i=window.setTimeout((function(){t(r+o)}),o);return e=r+o,i}),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(e){clearTimeout(e)})}(),o=void 0!==n.g?n.g:"undefined"!=typeof window?window:this,r=function(){return function(e){"use strict";var t={ignore:"[data-scroll-ignore]",header:null,topOnEmptyHash:!0,speed:500,speedAsDuration:!1,durationMax:null,durationMin:null,clip:!0,offset:0,easing:"easeInOutCubic",customEasing:null,updateURL:!0,popstate:!0,emitEvents:!0},n=function(){var e={};return Array.prototype.forEach.call(arguments,(function(t){for(var n in t){if(!t.hasOwnProperty(n))return;e[n]=t[n]}})),e},r=function(e){"#"===e.charAt(0)&&(e=e.substr(1));for(var t,n=String(e),r=n.length,o=-1,i="",a=n.charCodeAt(0);++o<r;){if(0===(t=n.charCodeAt(o)))throw new InvalidCharacterError("Invalid character: the input contains U+0000.");i+=1<=t&&t<=31||127==t||0===o&&48<=t&&t<=57||1===o&&48<=t&&t<=57&&45===a?"\\"+t.toString(16)+" ":128<=t||45===t||95===t||48<=t&&t<=57||65<=t&&t<=90||97<=t&&t<=122?n.charAt(o):"\\"+n.charAt(o)}return"#"+i},o=function(){return Math.max(document.body.scrollHeight,document.documentElement.scrollHeight,document.body.offsetHeight,document.documentElement.offsetHeight,document.body.clientHeight,document.documentElement.clientHeight)},i=function(t){return t?(n=t,parseInt(e.getComputedStyle(n).height,10)+t.offsetTop):0;var n},a=function(t,n,r){0===t&&document.body.focus(),r||(t.focus(),document.activeElement!==t&&(t.setAttribute("tabindex","-1"),t.focus(),t.style.outline="none"),e.scrollTo(0,n))},s=function(t,n,r,o){if(n.emitEvents&&"function"==typeof e.CustomEvent){var i=new CustomEvent(t,{bubbles:!0,detail:{anchor:r,toggle:o}});document.dispatchEvent(i)}};return function(l,c){var u,d,p,f,h={cancelScroll:function(e){cancelAnimationFrame(f),f=null,e||s("scrollCancel",u)},animateScroll:function(r,l,c){h.cancelScroll();var d=n(u||t,c||{}),m="[object Number]"===Object.prototype.toString.call(r),g=m||!r.tagName?null:r;if(m||g){var v=e.pageYOffset;d.header&&!p&&(p=document.querySelector(d.header));var y,b,_,A,E,w,x,k,C=i(p),S=m?r:function(t,n,r,i){var a=0;if(t.offsetParent)for(;a+=t.offsetTop,t=t.offsetParent;);return a=Math.max(a-n-r,0),i&&(a=Math.min(a,o()-e.innerHeight)),a}(g,C,parseInt("function"==typeof d.offset?d.offset(r,l):d.offset,10),d.clip),M=S-v,T=o(),O=0,D=(y=M,_=(b=d).speedAsDuration?b.speed:Math.abs(y/1e3*b.speed),b.durationMax&&_>b.durationMax?b.durationMax:b.durationMin&&_<b.durationMin?b.durationMin:parseInt(_,10)),L=function(t){var n,o,i;A||(A=t),O+=t-A,w=v+M*(o=E=1<(E=0===D?0:O/D)?1:E,"easeInQuad"===(n=d).easing&&(i=o*o),"easeOutQuad"===n.easing&&(i=o*(2-o)),"easeInOutQuad"===n.easing&&(i=o<.5?2*o*o:(4-2*o)*o-1),"easeInCubic"===n.easing&&(i=o*o*o),"easeOutCubic"===n.easing&&(i=--o*o*o+1),"easeInOutCubic"===n.easing&&(i=o<.5?4*o*o*o:(o-1)*(2*o-2)*(2*o-2)+1),"easeInQuart"===n.easing&&(i=o*o*o*o),"easeOutQuart"===n.easing&&(i=1- --o*o*o*o),"easeInOutQuart"===n.easing&&(i=o<.5?8*o*o*o*o:1-8*--o*o*o*o),"easeInQuint"===n.easing&&(i=o*o*o*o*o),"easeOutQuint"===n.easing&&(i=1+--o*o*o*o*o),"easeInOutQuint"===n.easing&&(i=o<.5?16*o*o*o*o*o:1+16*--o*o*o*o*o),n.customEasing&&(i=n.customEasing(o)),i||o),e.scrollTo(0,Math.floor(w)),function(t,n){var o=e.pageYOffset;if(t==n||o==n||(v<n&&e.innerHeight+o)>=T)return h.cancelScroll(!0),a(r,n,m),s("scrollStop",d,r,l),!(f=A=null)}(w,S)||(f=e.requestAnimationFrame(L),A=t)};0===e.pageYOffset&&e.scrollTo(0,0),x=r,k=d,m||history.pushState&&k.updateURL&&history.pushState({smoothScroll:JSON.stringify(k),anchor:x.id},document.title,x===document.documentElement?"#top":"#"+x.id),"matchMedia"in e&&e.matchMedia("(prefers-reduced-motion)").matches?a(r,Math.floor(S),!1):(s("scrollStart",d,r,l),h.cancelScroll(!0),e.requestAnimationFrame(L))}}},m=function(t){if(!t.defaultPrevented&&!(0!==t.button||t.metaKey||t.ctrlKey||t.shiftKey)&&"closest"in t.target&&(d=t.target.closest(l))&&"a"===d.tagName.toLowerCase()&&!t.target.closest(u.ignore)&&d.hostname===e.location.hostname&&d.pathname===e.location.pathname&&/#/.test(d.href)){var n,o;try{n=r(decodeURIComponent(d.hash))}catch(t){n=r(d.hash)}if("#"===n){if(!u.topOnEmptyHash)return;o=document.documentElement}else o=document.querySelector(n);(o=o||"#top"!==n?o:document.documentElement)&&(t.preventDefault(),function(t){if(history.replaceState&&t.updateURL&&!history.state){var n=e.location.hash;n=n||"",history.replaceState({smoothScroll:JSON.stringify(t),anchor:n||e.pageYOffset},document.title,n||e.location.href)}}(u),h.animateScroll(o,d))}},g=function(e){if(null!==history.state&&history.state.smoothScroll&&history.state.smoothScroll===JSON.stringify(u)){var t=history.state.anchor;"string"==typeof t&&t&&!(t=document.querySelector(r(history.state.anchor)))||h.animateScroll(t,null,{updateURL:!1})}};return h.destroy=function(){u&&(document.removeEventListener("click",m,!1),e.removeEventListener("popstate",g,!1),h.cancelScroll(),f=p=d=u=null)},function(){if(!("querySelector"in document&&"addEventListener"in e&&"requestAnimationFrame"in e&&"closest"in e.Element.prototype))throw"Smooth Scroll: This browser does not support the required JavaScript methods and browser APIs.";h.destroy(),u=n(t,c||{}),p=u.header?document.querySelector(u.header):null,document.addEventListener("click",m,!1),u.updateURL&&u.popstate&&e.addEventListener("popstate",g,!1)}(),h}}(o)}.apply(t,[]),void 0===r||(e.exports=r)},38025:e=>{var t;!function(){var n={settings:{},post:function(e){return new r("post",e)},get:function(e){return new r("get",e)},request:function(e,t){return new r(e,t)}},r=function(e,t){var r={method:e,url:"",before:function(){},success:function(){},error:function(){},data:!1,async:!0,headers:{}};this.p=this.extend(r,t),this.p=this.extend(this.p,n.settings),this.p.method=this.p.method.toUpperCase(),this.prepareData(),this.xhr=new XMLHttpRequest,this.xhr.open(this.p.method,this.p.url,this.p.async),this.setHeaders(),!1!==("function"!=typeof this.p.before||this.p.before(this.xhr))&&this.send()};r.prototype={extend:function(e,t){return t&&Object.keys(t).forEach((function(n){e[n]=t[n]})),e},prepareData:function(){if(-1===["POST","PUT"].indexOf(this.p.method)||this.isFormData()||(this.p.headers["Content-Type"]="application/x-www-form-urlencoded"),"object"!=typeof this.p.data||this.isFormData()||(this.p.data=this.toParams(this.p.data)),"GET"===this.p.method){var e=-1!==this.p.url.search(/\?/)?"&":"?";this.p.url=this.p.data?this.p.url+e+this.p.data:this.p.url}},setHeaders:function(){this.xhr.setRequestHeader("X-Requested-With",this.p.headers["X-Requested-With"]||"XMLHttpRequest"),Object.keys(this.p.headers).forEach(function(e){this.xhr.setRequestHeader(e,this.p.headers[e])}.bind(this))},isFormData:function(){return void 0!==window.FormData&&this.p.data instanceof window.FormData},isComplete:function(){return!(this.xhr.status<200||this.xhr.status>=300&&304!==this.xhr.status)},send:function(){this.p.async?(this.xhr.onload=this.loaded.bind(this),this.xhr.send(this.p.data)):(this.xhr.send(this.p.data),this.loaded.call(this))},loaded:function(){var e;this.isComplete()?(e=this.parseResponse(),"function"==typeof this.p.success&&this.p.success(e,this.xhr)):(e=this.parseResponse(),"function"==typeof this.p.error&&this.p.error(e,this.xhr,this.xhr.status))},parseResponse:function(){var e=this.xhr.response,t=this.parseJson(e);return t||e},parseJson:function(e){try{var t=JSON.parse(e);if(t&&"object"==typeof t)return t}catch(e){return!1}return!1},toParams:function(e){return Object.keys(e).map((function(t){return encodeURIComponent(t)+"="+encodeURIComponent(e[t])})).join("&")}};var o=[0],i="data"+(new Date).getTime(),a=function(e,t){return this.parse(e,t)};a.ready=function(e){document.addEventListener("DOMContentLoaded",e)},a.prototype={get length(){return this.nodes.length},parse:function(e,t){var n;if(e){if(e instanceof a)return this.nodes=e.nodes,e;n=/^\s*<(\w+|!)[^>]*>/.test(e)?this.create(e):"string"!=typeof e?e.nodeType&&11===e.nodeType?e.childNodes:e.nodeType||this._isWindowNode(e)?[e]:e:this._query(e,t)}else n=[];this.nodes=this._slice(n)},create:function(e){if(/^<(\w+)\s*\/?>(?:<\/\1>|)$/.test(e))return[document.createElement(RegExp.$1)];var t=[],n=document.createElement("div");n.innerHTML=e;for(var r=0,o=n.childNodes.length;r<o;r++)t.push(n.childNodes[r]);return t},dataset:function(e,t){return this.each((function(n){o[this.dataindex(n.get())][e]=t}))},dataget:function(e){return o[this.dataindex(this.get())][e]},dataindex:function(e){var t=e[i],n=o.length;return t||(t=n,e&&(e[i]=n),o[t]={}),t},add:function(e){return this.nodes=this.nodes.concat(this._array(e)),this},get:function(e){return this.nodes[e||0]||!1},getAll:function(){return this.nodes},eq:function(e){return new a(this.nodes[e])},first:function(){return new a(this.nodes[0])},last:function(){return new a(this.nodes[this.nodes.length-1])},contents:function(){return this.get().childNodes},each:function(e){for(var t=this.nodes.length,n=0;n<t;n++)e.call(this,new a(this.nodes[n]),n);return this},is:function(e){return this.filter(e).length>0},filter:function(e){var t;return void 0===e?this:(t="function"==typeof e?function(t){return e(new a(t))}:function(t){return e&&e.nodeType||e instanceof Node?e===t:(t.matches=t.matches||t.msMatchesSelector||t.webkitMatchesSelector,1===t.nodeType&&t.matches(e||"*"))},new a(this.nodes.filter.call(this.nodes,t)))},not:function(e){return this.filter((function(t){return!new a(t).is(e||!0)}))},find:function(e){var t=[];return this.each((function(n){for(var r=n.get(),o=this._query(e,r),i=0;i<o.length;i++)t.push(o[i])})),new a(t)},children:function(e){var t=[];return this.each((function(e){var n=e.get();if(n.children)for(var r=n.children,o=0;o<r.length;o++)t.push(r[o])})),new a(t).filter(e)},parent:function(e){var t=this.get(),n=!!t.parentNode&&t.parentNode;return n?new a(n).filter(e):new a},parents:function(e,t){t=this._context(t);var n=[];return this.each((function(r){for(var o=r.get().parentNode;o&&o!==t;)e?new a(o).is(e)&&n.push(o):n.push(o),o=o.parentNode})),new a(n)},closest:function(e,t){t=this._context(t);var n=[],r=e&&e.nodeType;return this.each((function(o){var i=o.get();do{if(i&&(r&&i===e||new a(i).is(e)))return n.push(i)}while((i=i.parentNode)&&i!==t)})),new a(n)},next:function(e){return this._sibling(e,"nextSibling")},nextElement:function(e){return this._sibling(e,"nextElementSibling")},prev:function(e){return this._sibling(e,"previousSibling")},prevElement:function(e){return this._sibling(e,"previousElementSibling")},css:function(e,t){if(void 0===t&&"object"!=typeof e){var n=this.get();return"width"===e||"height"===e?n.style?this._getHeightOrWidth(e)+"px":void 0:n.style?getComputedStyle(n,null)[e]:void 0}return this.each((function(n){var r=n.get(),o={};for(var i in"object"==typeof e?o=e:o[e]=t,o)r.style&&(r.style[i]=o[i])}))},attr:function(e,t,n){if(n=n?"data-":"",void 0===t&&"object"!=typeof e){var r=this.get();return r&&3!==r.nodeType?"checked"===e?r.checked:this._boolean(r.getAttribute(n+e)):void 0}return this.each((function(r){var o=r.get(),i={};for(var a in"object"==typeof e?i=e:i[e]=t,i)3!==o.nodeType&&("checked"===a?o.checked=i[a]:o.setAttribute(n+a,i[a]))}))},data:function(e,t){if(void 0===e||!0===e){var n=/^data-(.+)$/,r=this.get().attributes,o={},i=function(e){return e[1].toUpperCase()};for(var a in r)if(r[a]&&n.test(r[a].nodeName)){var s=r[a].nodeName.match(n)[1],l=r[a].value;!0!==e&&(s=s.replace(/-([a-z])/g,i)),l=-1!==l.search(/^{/)?this._object(l):this._number(l)?parseFloat(l):this._boolean(l),o[s]=l}return o}return this.attr(e,t,!0)},val:function(e){if(void 0===e){var t=this.get();return t.type&&"checkbox"===t.type?t.checked:t.value}return this.each((function(t){var n=t.get();n.type&&"checkbox"===n.type?n.checked=e:n.value=e}))},removeAttr:function(e){return this.each((function(t){var n=t.get();e.split(" ").forEach((function(e){3!==n.nodeType&&n.removeAttribute(e)}))}))},addClass:function(e){return this._eachClass(e,"add")},removeClass:function(e){return this._eachClass(e,"remove")},toggleClass:function(e){return this._eachClass(e,"toggle")},hasClass:function(e){var t=this.get();return!!t.classList&&t.classList.contains(e)},empty:function(){return this.each((function(e){e.get().innerHTML=""}))},html:function(e){return void 0===e?this.get().innerHTML||"":this.empty().append(e)},text:function(e){return void 0===e?this.get().textContent||"":this.each((function(t){t.get().textContent=e}))},after:function(e){return this._inject(e,(function(e,t){if("string"==typeof e)t.insertAdjacentHTML("afterend",e);else if(null!==t.parentNode)for(var n=e instanceof Node?[e]:this._array(e).reverse(),r=0;r<n.length;r++)t.parentNode.insertBefore(n[r],t.nextSibling);return t}))},before:function(e){return this._inject(e,(function(e,t){if("string"==typeof e)t.insertAdjacentHTML("beforebegin",e);else for(var n=e instanceof Node?[e]:this._array(e),r=0;r<n.length;r++)t.parentNode.insertBefore(n[r],t);return t}))},append:function(e){return this._inject(e,(function(e,t){if("string"==typeof e||"number"==typeof e)t.insertAdjacentHTML("beforeend",e);else for(var n=e instanceof Node?[e]:this._array(e),r=0;r<n.length;r++)t.appendChild(n[r]);return t}))},prepend:function(e){return this._inject(e,(function(e,t){if("string"==typeof e||"number"==typeof e)t.insertAdjacentHTML("afterbegin",e);else for(var n=e instanceof Node?[e]:this._array(e).reverse(),r=0;r<n.length;r++)t.insertBefore(n[r],t.firstChild);return t}))},wrap:function(e){return this._inject(e,(function(e,t){var n="string"==typeof e||"number"==typeof e?this.create(e)[0]:e instanceof Node?e:this._array(e)[0];return t.parentNode&&t.parentNode.insertBefore(n,t),n.appendChild(t),n}))},unwrap:function(){return this.each((function(e){for(var t=e.get(),n=document.createDocumentFragment();t.firstChild;){var r=t.removeChild(t.firstChild);n.appendChild(r)}t.parentNode.replaceChild(n,t)}))},replaceWith:function(e){return this._inject(e,(function(e,t){for(var n=document.createDocumentFragment(),r="string"==typeof e||"number"==typeof e?this.create(e):e instanceof Node?[e]:this._array(e),o=0;o<r.length;o++)n.appendChild(r[o]);var i=n.childNodes[0];return t.parentNode&&t.parentNode.replaceChild(n,t),i}))},remove:function(){return this.each((function(e){var t=e.get();t.parentNode&&t.parentNode.removeChild(t)}))},clone:function(e){var t=[];return this.each((function(n){var r=n.get(),o=this._clone(r);e&&(o=this._cloneEvents(r,o)),t.push(o)})),new a(t)},show:function(){return this.each(function(e){var t=e.get();if(t.style&&this._hasDisplayNone(t)){var n=t.getAttribute("domTargetShow");t.style.display=n||"block",t.removeAttribute("domTargetShow")}}.bind(this))},hide:function(){return this.each((function(e){var t=e.get();if(t.style&&!this._hasDisplayNone(t)){var n=t.style.display;"block"!==n&&t.setAttribute("domTargetShow",n),t.style.display="none"}}))},scrollTop:function(e){var t=this.get(),n=this._isWindowNode(t),r=9===t.nodeType?t.scrollingElement||t.body.parentNode||t.body||t.documentElement:t;return void 0!==e?(e=parseInt(e),void(n?t.scrollTo(0,e):r.scrollTop=e)):n?t.pageYOffset:r.scrollTop},offset:function(){return this._getPos("offset")},position:function(){return this._getPos("position")},width:function(e){return void 0!==e?this.css("width",parseInt(e)+"px"):this._getSize("width","Width")},height:function(e){return void 0!==e?this.css("height",parseInt(e)+"px"):this._getSize("height","Height")},outerWidth:function(){return this._getSize("width","Width","outer")},outerHeight:function(){return this._getSize("height","Height","outer")},innerWidth:function(){return this._getSize("width","Width","inner")},innerHeight:function(){return this._getSize("height","Height","inner")},click:function(){return this._trigger("click")},focus:function(){return this._trigger("focus")},blur:function(){return this._trigger("blur")},on:function(e,t,n){return this.each((function(r){for(var o=r.get(),i=e.split(" "),a=0;a<i.length;a++){var s=this._getEventName(i[a]),l=this._getEventNamespace(i[a]);t=n?this._getOneHandler(t,e):t,o.addEventListener(s,t),o._e=o._e||{},o._e[l]=o._e[l]||{},o._e[l][s]=o._e[l][s]||[],o._e[l][s].push(t)}}))},one:function(e,t){return this.on(e,t,!0)},off:function(e,t){var n=function(e,t,n){return e===n},r=function(e,t,n,r){return t===r},o=function(e,t,n,r){return e===n&&t===r},i=function(){return!0};return void 0===e?this.each((function(e){this._offEvent(e.get(),!1,!1,t,i)})):this.each((function(i){for(var a=i.get(),s=e.split(" "),l=0;l<s.length;l++){var c=this._getEventName(s[l]),u=this._getEventNamespace(s[l]);"_events"===u?this._offEvent(a,c,u,t,n):c||"_events"===u?this._offEvent(a,c,u,t,o):this._offEvent(a,c,u,t,r)}}))},serialize:function(e){for(var t={},n=this.get().elements,r=0;r<n.length;r++){var o=n[r];if((!/(checkbox|radio)/.test(o.type)||o.checked)&&(o.name&&!o.disabled&&"file"!==o.type)){if("select-multiple"===o.type)for(var i=0;i<o.options.length;i++){var a=o.options[i];a.selected&&(t[o.name]=a.value)}t[o.name]=this._number(o.value)?parseFloat(o.value):this._boolean(o.value)}}return e?t:this._params(t)},scroll:function(){this.get().scrollIntoView({behavior:"smooth"})},fadeIn:function(e,t){var n=this._anim(e,t,500);return this.each((function(e){e.css({display:"block",opacity:0,animation:"fadeIn "+n.speed+"s ease-in-out"}).removeClass("hidden"),e.one("animationend",(function(){e.css({opacity:"",animation:""}),n.fn&&n.fn(e)}))}))},fadeOut:function(e,t){var n=this._anim(e,t,300);return this.each((function(e){e.css({opacity:1,animation:"fadeOut "+n.speed+"s ease-in-out"}),e.one("animationend",(function(){e.css({display:"none",opacity:"",animation:""}),n.fn&&n.fn(e)}))}))},slideUp:function(e,t){var n=this._anim(e,t,300);return this.each((function(e){e.height(e.height()),e.css({overflow:"hidden",animation:"slideUp "+n.speed+"s ease-out"}),e.one("animationend",(function(){e.css({display:"none",height:"",animation:""}),n.fn&&n.fn(e)}))}))},slideDown:function(e,t){var n=this._anim(e,t,400);return this.each((function(e){e.height(e.height()),e.css({display:"block",overflow:"hidden",animation:"slideDown "+n.speed+"s ease-in-out"}).removeClass("hidden"),e.one("animationend",(function(){e.css({overflow:"",height:"",animation:""}),n.fn&&n.fn(e)}))}))},_queryContext:function(e,t){return 3!==(t=this._context(t)).nodeType&&"function"==typeof t.querySelectorAll?t.querySelectorAll(e):[]},_query:function(e,t){var n=document;if(t)return this._queryContext(e,t);if(/^[.#]?[\w-]*$/.test(e)){if("#"===e[0]){var r=n.getElementById(e.slice(1));return r?[r]:[]}return"."===e[0]?n.getElementsByClassName(e.slice(1)):n.getElementsByTagName(e)}return n.querySelectorAll(e)},_context:function(e){return e?"string"==typeof e?document.querySelector(e):e:document},_sibling:function(e,t){var n,r=e&&e.nodeType;return this.each((function(o){var i=o.get();do{if((i=i[t])&&(r&&i===e||new a(i).is(e)))return void(n=i)}while(i)})),new a(n)},_slice:function(e){return e&&0!==e.length?e.length?[].slice.call(e.nodes||e):[e]:[]},_array:function(e){if(void 0===e)return[];if(e instanceof NodeList){for(var t=[],n=0;n<e.length;n++)t[n]=e[n];return t}return e instanceof a?e.nodes:e},_object:function(e){var t=e.replace(/(\w+:)|(\w+ :)/g,(function(e){return'"'+e.substring(0,e.length-1)+'":'}));return JSON.parse(t)},_params:function(e){var t="";return Object.keys(e).forEach(function(n){t+="&"+this._encodeUri(n)+"="+this._encodeUri(e[n])}.bind(this)),t.replace(/^&/,"")},_boolean:function(e){return"true"===e||"false"!==e&&e},_number:function(e){return!isNaN(e)&&!isNaN(parseFloat(e))},_inject:function(e,t){for(var n=this.nodes.length,r=[];n--;){var o="function"==typeof e?e.call(this,this.nodes[n]):e,i=0===n?o:this._clone(o),s=t.call(this,i,this.nodes[n]);s&&(s.dom?r.push(s.get()):r.push(s))}return new a(r)},_clone:function(e){if(void 0!==e)return"string"==typeof e?e:e instanceof Node||e.nodeType?e.cloneNode(!0):"length"in e?[].map.call(this._array(e),(function(e){return e.cloneNode(!0)})):void 0},_cloneEvents:function(e,t){var n=e._e;if(n)for(var r in t._e=n,n._events)if(n._events.hasOwnProperty(r))for(var o=0;o<n._events[r].length;o++)t.addEventListener(r,n._events[r][o]);return t},_trigger:function(e){var t=this.get();return t&&3!==t.nodeType&&t[e](),this},_encodeUri:function(e){return encodeURIComponent(e).replace(/!/g,"%21").replace(/'/g,"%27").replace(/\(/g,"%28").replace(/\)/g,"%29").replace(/\*/g,"%2A").replace(/%20/g,"+")},_getSize:function(e,t){var n=this.get(),r=0;return r=3===n.nodeType?0:9===n.nodeType?this._getDocSize(n,t):this._isWindowNode(n)?window["inner"+t]:this._getHeightOrWidth(e),Math.round(r)},_getDocSize:function(e,t){var n=e.body,r=e.documentElement;return Math.max(n["scroll"+t],n["offset"+t],r["client"+t],r["scroll"+t],r["offset"+t])},_getPos:function(e){var t=this.get(),n={top:0,left:0};if(3===t.nodeType||this._isWindowNode(t)||9===t.nodeType)return n;if("position"===e)return{top:t.offsetTop,left:t.offsetLeft};if("offset"===e){var r=t.getBoundingClientRect(),o=t.ownerDocument,i=o.documentElement,a=o.defaultView;return{top:r.top+a.pageYOffset-i.clientTop,left:r.left+a.pageXOffset-i.clientLeft}}return n},_getHeightOrWidth:function(e,t){var n=e.charAt(0).toUpperCase()+e.slice(1),r=t||"offset",o=0,i=this.get(),a=getComputedStyle(i,null),s=this.parents().filter((function(e){var t=e.get();return 1===t.nodeType&&"none"===getComputedStyle(t,null).display&&t}));if("none"===a.display&&s.add(i),0!==s.length){var l="visibility: hidden !important; display: block !important;",c=[];s.each((function(e){var t=e.attr("style");null!==t&&c.push(t),e.attr("style",null!==t?t+";"+l:l)})),o=i[r+n],s.each((function(e,t){void 0===c[t]?e.removeAttr("style"):e.attr("style",c[t])}))}else o=i[r+n];return o},_eachClass:function(e,t){return this.each((function(n){if(e){var r=n.get();e.split(" ").forEach((function(e){r.classList&&r.classList[t](e)}))}}))},_getOneHandler:function(e,t){var n=this;return function(){e.apply(this,arguments),n.off(t)}},_getEventNamespace:function(e){var t=e.split("."),n=t[1]?t[1]:"_events";return t[2]?n+t[2]:n},_getEventName:function(e){return e.split(".")[0]},_offEvent:function(e,t,n,r,o){for(var i in e._e)if(e._e.hasOwnProperty(i))for(var a in e._e[i])if(o(a,i,t,n))for(var s=e._e[i][a],l=0;l<s.length;l++)void 0!==r&&s[l].toString()!==r.toString()||(e.removeEventListener(a,s[l]),e._e[i][a].splice(l,1),0===e._e[i][a].length&&delete e._e[i][a],0===Object.keys(e._e[i]).length&&delete e._e[i])},_hasDisplayNone:function(e){return"none"===e.style.display||"none"===(e.currentStyle?e.currentStyle.display:getComputedStyle(e,null).display)},_anim:function(e,t,n){return"function"==typeof e?(t=e,e=n):e=e||n,{fn:t,speed:e/1e3}},_isWindowNode:function(e){return e===window||e.parent&&e.parent===window}};var s=0,l=function(e,t){return c(e,t)},c=function(e,t){var n;return u.dom(e).each((function(e){(n=e.dataget(u.namespace))||(n=new d(e,t,s),e.dataset(u.namespace,n),u.instances[s]=n,s++)})),n},u=l;u.dom=function(e,t){return new a(e,t)},u.ajax=n,u.instances=[],u.namespace="redactorx",u.prefix="rx",u.version="1.3.7",u.settings={},u.lang={},u._mixins={},u._repository={},u._subscribe={},u.keycodes={BACKSPACE:8,DELETE:46,UP:38,DOWN:40,ENTER:13,SPACE:32,ESC:27,TAB:9,CTRL:17,META:91,SHIFT:16,ALT:18,RIGHT:39,LEFT:37},u.add=function(e,t,n){if(n.translations&&(u.lang=u.extend(!0,u.lang,n.translations)),n.defaults){var r={};r[t]=n.defaults,u.opts=u.extend(!0,u.opts,r)}if("mixin"===e)u._mixins[t]=n;else{if(n.subscribe)for(var o in n.subscribe)if(n.subscribe.hasOwnProperty(o))for(var i=o.split(","),a=0;a<i.length;a++){var s=i[a].trim();void 0===u._subscribe[s]&&(u._subscribe[s]=[]),u._subscribe[s].push({module:t,func:n.subscribe[o]})}var l=function(){};if(l.prototype=n,n.mixins)for(var c=0;c<n.mixins.length;c++)u.inherit(l,u._mixins[n.mixins[c]]);u._repository[t]={type:e,proto:l,obj:n}}},u.extend=function(){var e={},t=!1,n=0,r=arguments.length;"[object Boolean]"===Object.prototype.toString.call(arguments[0])&&(t=arguments[0],n++);for(var o=function(n){for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t&&"[object Object]"===Object.prototype.toString.call(n[r])?e[r]=u.extend(!0,e[r],n[r]):e[r]=n[r])};n<r;n++){o(arguments[n])}return e},u.error=function(e){throw e},u.inherit=function(e,t){var n=function(){};n.prototype=t;var r=new n;for(var o in e.prototype)e.prototype.__lookupGetter__(o)?r.__defineGetter__(o,e.prototype.__lookupGetter__(o)):r[o]=e.prototype[o];return e.prototype=r,e.prototype.super=t,e},u.addLang=function(e,t){void 0===u.lang[e]&&(u.lang[e]={}),u.lang[e]=u.extend(!0,u.lang[e],t)},l.opts={plugins:[],content:!1,placeholder:!1,classes:!1,draggable:!1,editor:{classname:"content",focus:!1,sync:!0,drop:!0,lang:"en",add:"top",https:!1,enterKey:!0,scrollTarget:window,direction:"ltr",spellcheck:!0,grammarly:!1,notranslate:!1,reloadmarker:!0,minHeight:"40px",maxHeight:!1},codemirrorSrc:!1,codemirror:!1,source:!0,autosave:{url:!1,name:!1,data:!1,method:"post"},state:{limit:100},clean:{comments:!1,enter:!0,enterinline:!1},tab:{key:!0,spaces:!1},link:{size:30,nofollow:!1,target:!1},tooltip:{context:!0},topbar:!0,context:!1,control:!1,reorder:!1,buttons:{addbar:["paragraph","image","embed","table","quote","pre","line"],context:["bold","italic","deleted","code","link"],topbar:["shortcut"],editor:["add","html","format"],toolbar:!1,tags:{b:["bold"],strong:["bold"],i:["italic"],em:["italic"],del:["deleted"],u:["underline"],a:["link"]},types:!1,icons:!1,hidden:{}},addbar:{add:{},hide:[]},toolbar:{hide:[],sticky:!0,stickyMinHeight:200,stickyTopOffset:0},paste:{clean:!0,autoparse:!0,paragraphize:!0,plaintext:!1,linkTarget:!1,images:!0,links:!0,keepClass:[],keepStyle:[],keepAttrs:["td","th"],formTags:["form","input","button","select","textarea","legend","fieldset"],blockTags:["pre","h1","h2","h3","h4","h5","h6","table","tbody","thead","tfoot","th","tr","td","ul","ol","li","blockquote","p","hr","figure","iframe","figcaption","address"],inlineTags:["a","svg","img","br","strong","ins","code","del","span","samp","kbd","sup","sub","mark","var","cite","small","b","u","em","i","abbr"]},image:{states:!0,upload:!1,url:!0,select:!1,name:"file",data:!1,drop:!0,multiple:!0,clipboard:!0,types:["image/*"],tag:"figure",newtab:!1,link:!0,width:!1},noneditable:{classname:"noneditable"},embed:{responsive:"embed-responsive",script:!0,checkbox:!0},pre:{template:"<pre></pre>",spaces:4},line:!0,table:{template:"<table><tr><td></td><td></td></tr><tr><td></td><td></td></tr></table>",nowrap:"nowrap"},quote:{template:"<blockquote><p>Quote...</p><p><cite>Author Attribution</cite></p></blockquote>"},format:["p","h1","h2","h3","ul","ol"],formatAdd:!1,shortcutsRemove:!1,shortcutsBase:{"meta+z":"## shortcuts.meta-z ##","meta+shift+z":"## shortcuts.meta-shift-z ##","meta+a":"## shortcuts.meta-a ##"},shortcuts:{"ctrl+shift+o, meta+shift+o":{title:"## shortcuts.meta-shift-o ##",name:"meta+shift+o",command:"addbar.popup"},"ctrl+shift+d, meta+shift+d":{title:"## shortcuts.meta-shift-d ##",name:"meta+shift+d",command:"block.duplicate"},"ctrl+shift+up, meta+shift+up":{title:"## shortcuts.meta-shift-up ##",name:"meta+shift+&uarr;",command:"block.moveUp"},"ctrl+shift+down, meta+shift+down":{title:"## shortcuts.meta-shift-down ##",name:"meta+shift+&darr;",command:"block.moveDown"},"ctrl+shift+m, meta+shift+m":{title:"## shortcuts.meta-shift-m ##",name:"meta+shift+m",command:"inline.removeFormat"},"ctrl+b, meta+b":{title:"## shortcuts.meta-b ##",name:"meta+b",command:"inline.set",params:{tag:"b"}},"ctrl+i, meta+i":{title:"## shortcuts.meta-i ##",name:"meta+i",command:"inline.set",params:{tag:"i"}},"ctrl+u, meta+u":{title:"## shortcuts.meta-u ##",name:"meta+u",command:"inline.set",params:{tag:"u"}},"ctrl+h, meta+h":{title:"## shortcuts.meta-h ##",name:"meta+h",command:"inline.set",params:{tag:"sup"}},"ctrl+l, meta+l":{title:"## shortcuts.meta-l ##",name:"meta+l",command:"inline.set",params:{tag:"sub"}},"ctrl+alt+0, meta+alt+0":{title:"## shortcuts.meta-alt-0 ##",name:"meta+alt+0",command:"block.format",params:{tag:"p"}},"ctrl+alt+1, meta+alt+1":{title:"## shortcuts.meta-alt-1 ##",name:"meta+alt+1",command:"block.format",params:{tag:"h1"}},"ctrl+alt+2, meta+alt+2":{title:"## shortcuts.meta-alt-2 ##",name:"meta+alt+2",command:"block.format",params:{tag:"h2"}},"ctrl+alt+3, meta+alt+3":{title:"## shortcuts.meta-alt-3 ##",name:"meta+alt+3",command:"block.format",params:{tag:"h3"}},"ctrl+alt+4, meta+alt+4":{title:"## shortcuts.meta-alt-4 ##",name:"meta+alt+4",command:"block.format",params:{tag:"h4"}},"ctrl+alt+5, meta+alt+5":{title:"## shortcuts.meta-alt-5 ##",name:"meta+alt+5",command:"block.format",params:{tag:"h5"}},"ctrl+alt+6, meta+alt+6":{title:"## shortcuts.meta-alt-6 ##",name:"meta+alt+6",command:"block.format",params:{tag:"h6"}},"ctrl+shift+7, meta+shift+7":{title:"## shortcuts.meta-shift-7 ##",name:"meta+shift+7",command:"block.format",params:{tag:"ol"}},"ctrl+shift+8, meta+shift+8":{title:"## shortcuts.meta-shift-8 ##",name:"meta+shift+8",command:"block.format",params:{tag:"ul"}},"ctrl+], meta+]":{title:"## shortcuts.meta-indent ##",name:"meta+]",command:"list.indent"},"ctrl+[, meta+[":{title:"## shortcuts.meta-outdent ##",name:"meta+[",command:"list.outdent"},"ctrl+k, meta+k":{title:"## shortcuts.meta-k ##",name:"meta+k",command:"link.format"}},paddingControl:"24px 26px",paddingNormal:"20px",buttonsObj:{add:{title:"## buttons.add ##",command:"addbar.popup"},html:{title:"## buttons.html ##",command:"source.toggle"},format:{title:"## buttons.format ##",command:"format.popup"},duplicate:{title:"## buttons.duplicate ##",command:"block.duplicate"},trash:{title:"## buttons.delete ##",command:"block.remove"},undo:{title:"## buttons.undo ##",command:"state.undo"},redo:{title:"## buttons.redo ##",command:"state.redo"},shortcut:{title:"## buttons.shortcuts ##",command:"shortcut.popup"},bold:{title:"## buttons.bold ##",command:"inline.set",params:{tag:"b"}},italic:{title:"## buttons.italic ##",command:"inline.set",params:{tag:"i"}},deleted:{title:"## buttons.deleted ##",command:"inline.set",params:{tag:"del"}},code:{title:"## buttons.code ##",command:"inline.set",params:{tag:"code"}},link:{title:"## buttons.link ##",command:"link.popup"},mark:{title:"## buttons.mark ##",command:"inline.set",params:{tag:"mark"}},sub:{title:"## buttons.subscript ##",command:"inline.set",params:{tag:"sub"}},sup:{title:"## buttons.superscript ##",command:"inline.set",params:{tag:"sup"}},kbd:{title:"## buttons.shortcut ##",command:"inline.set",params:{tag:"kbd"}},paragraph:{title:"## blocks.paragraph ##",command:"block.add",params:{name:"paragraph"}},image:{title:"## blocks.image ##",command:"image.popup",observer:"image.observe"},embed:{title:"## blocks.embed ##",command:"embed.popup",observer:"embed.observe"},"table-tune":{title:"## buttons.column-settings ##",command:"table.cellSetting",icon:"tune"},indent:{title:"## buttons.indent ##",command:"list.indent"},outdent:{title:"## buttons.outdent ##",command:"list.outdent"},line:{title:"## blocks.line ##",command:"block.add",observer:"block.observe",params:{name:"line"}},table:{title:"## blocks.table ##",command:"table.add",observer:"table.observe",params:{name:"table"}},quote:{title:"## blocks.quote ##",command:"block.add",observer:"block.observe",params:{name:"quote"}},pre:{title:"## blocks.pre ##",command:"block.add",observer:"block.observe",params:{name:"pre"}}},formatObj:{p:{title:"## format.p ##",type:"paragraph",shortcut:"Ctrl+Alt+0"},h1:{title:'<span style="font-size: 20px; font-weight: bold;">## format.h1 ##</span>',type:"heading",shortcut:"Ctrl+Alt+1"},h2:{title:'<span style="font-size: 16px; font-weight: bold;">## format.h2 ##</span>',type:"heading",shortcut:"Ctrl+Alt+2"},h3:{title:'<span style="font-weight: bold;">## format.h3 ##</span>',type:"heading",shortcut:"Ctrl+Alt+3"},h4:{title:'<span style="font-weight: bold;">## format.h4 ##</span>',type:"heading",shortcut:"Ctrl+Alt+4"},h5:{title:'<span style="font-weight: bold;">## format.h5 ##</span>',type:"heading",shortcut:"Ctrl+Alt+5"},h6:{title:'<span style="font-weight: bold;">## format.h6 ##</span>',type:"heading",shortcut:"Ctrl+Alt+6"},ol:{title:"1. ## format.ol ##",type:"list",shortcut:"Ctrl+Shift+7"},ul:{title:"&bull; ## format.ul ##",type:"list",shortcut:"Ctrl+Shift+8"},address:{title:"<em>## format.address ##</em>",type:"address"},dl:{title:"## format.dl ##",type:"dlist"}},markerChar:"\ufeff",containers:{main:["toolbar","editor","source","statusbar"]},tags:{denied:["font","html","head","link","title","body","meta","applet","marquee"],incode:["!DOCTYPE","!doctype","html","head","link","title","body","meta","textarea","style"],form:["form","input","button","select","textarea","legend","fieldset"],inline:["a","svg","span","strong","strike","b","u","em","i","code","del","ins","samp","kbd","sup","sub","mark","var","cite","small","abbr"],block:["pre","hr","ul","ol","li","p","h1","h2","h3","h4","h5","h6","dl","dt","dd","div","table","tbody","thead","tfoot","tr","th","td","blockquote","output","figcaption","figure","address","main","section","header","footer","aside","article","iframe"],parser:["pre","hr","ul","ol","p","h1","h2","h3","h4","h5","h6","table","address","blockquote","figure","iframe","form","dl","div","section","header","footer","article","main","aside"]},bsmodal:!1,regex:{youtube:/^https?\:\/\/(?:www\.youtube(?:\-nocookie)?\.com\/|m\.youtube\.com\/|youtube\.com\/)?(?:ytscreeningroom\?vi?=|youtu\.be\/|vi?\/|user\/.+\/u\/\w{1,2}\/|embed\/|watch\?(?:.*\&)?vi?=|\&vi?=|\?(?:.*\&)?vi?=)([^#\&\?\n\/<>"']*)/gi,vimeo:/(http|https)?:\/\/(?:www.|player.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:\/[a-zA-Z0-9_-]+)?/gi,imageurl:/((https?|www)[^\s]+\.)(jpe?g|png|gif)(\?[^\s-]+)?/gi,url:/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z\u00F0-\u02AF0-9()!@:%_+.~#?&//=]*)/gi,aurl1:/(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim,aurl2:/(^|[^\/])(www\.[\S]+(\b|$))/gim}},l.lang.en={accessibility:{"help-label":"Rich text editor"},placeholders:{figcaption:"Type caption (optional)"},popup:{back:"Back",link:"Link",add:"Add",image:"Image","add-image":"Add Image"},shortcuts:{"meta-a":"Select all","meta-z":"Undo","meta-shift-z":"Redo","meta-shift-m":"Remove inline format","meta-b":"Bold","meta-i":"Italic","meta-u":"Underline","meta-h":"Superscript","meta-l":"Subscript","meta-k":"Link","meta-alt-0":"Normal text","meta-alt-1":"Heading 1","meta-alt-2":"Heading 2","meta-alt-3":"Heading 3","meta-alt-4":"Heading 4","meta-alt-5":"Heading 5","meta-alt-6":"Heading 6","meta-shift-7":"Ordered List","meta-shift-8":"Unordered List","meta-indent":"Indent","meta-outdent":"Outdent","meta-shift-backspace":"Delete","meta-shift-o":"Add","meta-shift-d":"Duplicate","meta-shift-up":"Move up","meta-shift-down":"Move down"},buttons:{add:"Add",html:"HTML",format:"Format",bold:"Bold",italic:"Italic",deleted:"Deleted",link:"Link",list:"List",image:"Image",indent:"Indent",outdent:"Outdent",embed:"Embed",table:"Table",insert:"Insert",save:"Save",cancel:"Cancel",delete:"Delete",duplicate:"Duplicate",shortcut:"Shortcuts",underline:"Underline",undo:"Undo",redo:"Redo",code:"Code",mark:"Mark",subscript:"Subscript",superscript:"Superscript",kbd:"Shortcut","column-settings":"Column settings"},blocks:{text:"Text",paragraph:"Paragraph",image:"Image",embed:"Embed",line:"Line",table:"Table",quote:"Quote",pre:"Code",address:"Address"},format:{p:"Normal Text",h1:"Heading 1",h2:"Heading 2",h3:"Heading 3",h4:"Heading 4",h5:"Heading 5",h6:"Heading 6",address:"Address",ul:"Unordered List",ol:"Ordered List",dl:"Definition List"},embed:{embed:"Embed",caption:"Caption",description:"Paste any embed/html code or enter the url (vimeo or youtube video only)","responsive-video":"Responsive video"},image:{or:"or","alt-text":"Alt Text",link:"Link",width:"Width",caption:"Caption","link-in-new-tab":"Open link in new tab","url-placeholder":"Paste url of image...","upload-new-placeholder":"Drag to upload a new image<br>or click to select"},link:{link:"Link","edit-link":"Edit Link",unlink:"Unlink","link-in-new-tab":"Open link in new tab",text:"Text",url:"URL"},table:{width:"Width",nowrap:"Nowrap",column:"Column","add-head":"Add head","remove-head":"Remove head","add-row-below":"Add row below","add-row-above":"Add row above","remove-row":"Remove row","add-column-after":"Add column after","add-column-before":"Add column before","remove-column":"Remove column","delete-table":"Delete table"}};var d=function(e,t,n){for(var r=["keycodes","prefix","dom","ajax","_repository","_subscribe"],o=0;o<r.length;o++)this[r[o]]=u[r[o]];this.uuid=n,this.$win=this.dom(window),this.$doc=this.dom(document),this.$body=this.dom("body"),this.$element=e,this.app=this,this.initialSettings=t,this._initer=["setting","lang"],this._priority=["container","editor","state","accessibility"],this._plugins=[],this.started=!1,this.start()};d.prototype={start:function(e){this.isTextarea()&&(this.isStarted()||(e&&(this.initialSettings=e),this._initCore(),this._plugins=this.setting.get("plugins"),this.broadcast("app.before.start"),this._initModules(),this._initPlugins(),this._startPriority(),this._startModules(),this._startPlugins(),this.started=!0,this.broadcast("app.start"),this._loadModulesAndPlugins()))},isStarted:function(){return this.started},isTextarea:function(){return"TEXTAREA"===this.$element.get().tagName},stop:function(){this.isStopped()||(this.broadcast("app.before.stop"),this._stopPlugins(),this._stopPriority(),this._stopModules(),this.started=!1,this.broadcast("app.stop"))},isStopped:function(){return!this.started},destroy:function(){clearTimeout(this.app.sync.typingTimer),this.stop(),this.broadcast("app.destroy"),this.$element.dataset(u.namespace,!1);var e=u.instances.indexOf(this.uuid);e>-1&&u.instances.splice(e,1)},broadcast:function(e,t){var n=t instanceof d.Event?t:new d.Event(e,t);if(void 0!==this._subscribe[e])for(var r=this._subscribe[e],o=0;o<r.length;o++){var i=this[r[o].module];i&&r[o].func.call(i,n)}var a=this.setting.has("subscribe")?this.setting.get("subscribe"):{};return"function"==typeof a[e]&&a[e].call(this,n),n},broadcastParams:function(e,t){return this.broadcast(e,t).getAll()},broadcastHtml:function(e,t){return this.broadcast(e,{html:t}).get("html")},create:function(e){void 0===this._repository[e]&&u.error('The class "'+e+'" does not exist.');var t=[].slice.call(arguments,1),n=new this._repository[e].proto;n._name=e,n.app=this;for(var r,o=["uuid","prefix","dom","ajax"],i=0;i<o.length;i++)n[o[i]]=this[o[i]];return this.lang&&(n.lang=this.lang),this.opts&&(n.opts=this.opts),n.init&&(r=n.init.apply(n,t)),r||n},api:function(e){for(var t=[].slice.call(arguments,1),n=e.split("."),r=n.pop(),o=this,i=0;i<n.length;i++)o=o[n[i]];if(o&&"function"==typeof o[r])return o[r].apply(o,t)},_initCore:function(){for(var e=0;e<this._initer.length;e++)this[this._initer[e]]=this.create(this._initer[e]);this.setting&&(this.opts=this.setting.dump())},_initModules:function(){for(var e in this._repository)"module"===this._repository[e].type&&-1===this._initer.indexOf(e)&&(this[e]=this.create(e))},_initPlugins:function(){var e=this.setting.get("plugins");for(var t in this._repository)"plugin"===this._repository[t].type&&-1!==e.indexOf(t)&&(this[t]=this.create(t))},_startPriority:function(){for(var e=0;e<this._priority.length;e++)this._call(this[this._priority[e]],"start")},_startModules:function(){this._iterate("module","start")},_startPlugins:function(){this._iterate("plugin","start")},_stopPriority:function(){for(var e=this._priority.slice().reverse(),t=0;t<e.length;t++)this._call(this[e[t]],"stop")},_stopModules:function(){this._iterate("module","stop")},_stopPlugins:function(){this._iterate("plugin","stop")},_loadModulesAndPlugins:function(){this._iterate("module","load"),this._iterate("plugin","load")},_iterate:function(e,t){for(var n in this._repository)if(this._repository.hasOwnProperty(n)){var r="module"===e?"load"===t||-1===this._priority.indexOf(n):-1!==this._plugins.indexOf(n);this._repository[n].type===e&&r&&this._call(this[n],t)}},_call:function(e,t){"function"==typeof e[t]&&e[t].apply(e)}},d.Event=function(e,t){this.name=e,this.params=void 0===t?{}:t,this.stopped=!1},d.Event.prototype={is:function(e){if(!Array.isArray(e))return this.get(e);for(var t=0;t<e.length;t++)if(this.params[e[t]])return!0},has:function(e){return void 0!==this.params[e]},getAll:function(){return this.params},get:function(e){return this.params[e]},set:function(e,t){this.params[e]=t},stop:function(){this.stopped=!0},isStopped:function(){return this.stopped}},l.add("mixin","block",{defaults:{id:{getter:"getId",setter:"setId"},html:{getter:"getHtml",setter:"setHtml"}},init:function(e,t){this.$block=e?this.dom(e):this.create(t),this._build(t),this._buildData(),this._render()},isType:function(e){return-1!==(Array.isArray(e)?e:[e]).indexOf(this.type)},isBlock:function(){return!0},isEditable:function(){return void 0!==this.editable&&!0===this.editable},isFigcaption:function(){return"figcaption"===this.type},isSecondLevel:function(){return-1!==["quoteitem","row","cell"].indexOf(this.type)},isNested:function(){return-1!==["quote","table"].indexOf(this.type)},isFirstLevel:function(){return this.$block.attr("data-"+this.prefix+"-first-level")},isAllSelected:function(){return!this.isEditable()||this.app.selection.isAll(this.$block)},isEmpty:function(){var e=this.$block.text();return""===(e=this._cleanEmpty(e))},isCaretStart:function(){if("pre"===this.getType())return this.app.caret.is(this.$block,"start",!1,!1);if("list"===this.getType()){var e=this.app.selection.getCurrent();return 0===this.dom(e).closest("li").prev().length&&this.app.caret.is(this.$block,"start")}return!this.isEditable()||this.app.caret.is(this.$block,"start")},isCaretEnd:function(){return"pre"===this.getType()?this.app.caret.is(this.$block,"end",!1,!1):"address"===this.getType()?this.app.caret.is(this.$block,"end",!1,!0,!1):!this.isEditable()||this.app.caret.is(this.$block,"end")},isAllowedButton:function(e,t){var n=this.getType();if(void 0!==this.opts.buttons.hidden[n]){var r=this.opts.buttons.hidden[n];if(Array.isArray(r)&&-1!==r.indexOf(e))return!1}if(void 0===t.blocks)return!0;var o=t.blocks;if(o.except&&-1!==o.except.indexOf(n))return!1;if(o.all){if(!0===o.all||"all"===o.all)return!0;if("editable"===o.all&&-1!==["heading","paragraph","list","address","quote","table"].indexOf(n))return!0;if("first-level"===o.all&&this.isFirstLevel())return!0;if("noneditable"===o.all&&-1!==["image","embed","layer","line"].indexOf(n))return!0}return!(!Array.isArray(o.types)||-1===o.types.indexOf(n))},getData:function(e){var t={};return Object.keys(this.data).forEach(function(e){t[e]=this[this.data[e].getter].apply(this)}.bind(this)),e?t[e]:t},getOffset:function(){return this.$block.offset()},getType:function(){return this.type},getTag:function(){return!!this.$block&&this.$block.get().tagName.toLowerCase()},getBlock:function(){return this.$block},getHtml:function(){return this.$block.html()},getPlainText:function(){var e=this.$block.html();return this.app.content.getTextFromHtml(e,{nl:!0})},getOuterHtml:function(){return this.$block.get().outerHTML},getFirstLevel:function(){var e=this.$block.closest("[data-"+this.prefix+"-first-level]");return 0!==e.length&&e.dataget("instance")},getParent:function(e){e=e?"="+e:"";var t=this.$block.parent().closest("[data-"+this.prefix+"-type"+e+"]");return 0!==t.length&&t.dataget("instance")},getNext:function(e){e=e?"="+e:"";var t=this.$block.nextElement();return!(0===t.length||!t.is("[data-"+this.prefix+"-type"+e+"]"))&&t.dataget("instance")},getPrev:function(e){e=e?"="+e:"";var t=this.$block.prevElement();return!(0===t.length||!t.is("[data-"+this.prefix+"-type"+e+"]"))&&t.dataget("instance")},getChildFirst:function(e){e=e?"="+e:"";var t=this.$block.find("[data-"+this.prefix+"-type"+e+"]").first();return 0!==t.length&&t.dataget("instance")},getChildLast:function(e){e=e?"="+e:"";var t=this.$block.find("[data-"+this.prefix+"-type"+e+"]").last();return 0!==t.length&&t.dataget("instance")},getId:function(){return this.$block.attr("id")},getCaption:function(){var e=this.$block.find("figcaption");return 0!==e.length?e.html().trim():""},setData:function(e){for(var t in e)this.data[t]&&this[this.data[t].setter].call(this,e[t])},setEmpty:function(){this.$block.html("")},setSelectAll:function(){this.isEditable()&&this.app.selection.select(this.$block)},setHtml:function(e){this.$block.html(e)},setId:function(e){""===e?this.$block.removeAttr("id"):this.$block.attr("id",e)},setCaption:function(e){if(""===e)this.$block.find("figcaption").remove();else{var t=this.$block.find("figcaption");0===t.length&&((t=this.dom("<figcaption>")).attr("data-placeholder",this.lang.get("placeholders.figcaption")),this.$block.append(t),this.app.create("block.figcaption",t)),t.html(e)}},setClassFromObj:function(e,t){this._removeObjClasses(e);var n=e[t];"none"===n&&!1===n||this.$block.addClass(n)},setCaret:function(e){this.app.caret.set(this.$block,e)},moveUp:function(){var e=this.getPrev();e&&this._move(e,"before")},moveDown:function(){var e=this.getNext();e&&this._move(e,"after")},remove:function(e){var t=this.getType();this.$block.remove(),e&&this.app.broadcast("block.remove",{type:t})},appendNext:function(){var e=this.getNext();if(e.isEmpty())e.remove();else{if(this.isEmpty())return this.remove(),void this.app.block.set(e,"start");var t=e.getHtml(),n=this.getType(),r=e.getType(),o=!0,i=!0;if("pre"===n&&"pre"!==r&&(t=e.getPlainText()),"list"===r)if("list"===n){var a=e.getBlock().children();this.$block.append(a),o=!1,i=!0}else t=this._appendListHtml(e.getBlock(),t),i=e.isEmpty();if(o){var s=this.app.selection.getTopInline();s&&this.app.caret.set(s,"after"),this.app.insertion.insertHtml(t,"start")}i&&e.remove()}},appendToPrev:function(){var e=this.getPrev();if(this.isEmpty())return this.remove(),void this.app.block.set(e,"end");if(e.isEmpty())e.remove();else{var t=e.getType(),n=this.getHtml(),r=this.getType(),o=!0,i=!0;if("pre"!==r&&"pre"===t&&(n=this.getPlainText()),"list"===r)if("list"===t){var a=this.getBlock().children();this.app.block.set(e,"end"),e.getBlock().append(a),o=!1,i=!0}else n=this._appendListHtml(this.getBlock(),n),i=this.isEmpty();if(o){this.app.block.set(e,"end");var s=this.app.selection.getTopInline();s&&this.app.caret.set(s,"after"),this.app.insertion.insertHtml(n,"start")}i&&this.remove()}},insertEmpty:function(e){return(e=e||{}).instance=this.app.block.create(),this.insert(e)},insert:function(e){var t=u.extend({},{instance:!1,position:"after",caret:!1,remove:!0,type:"input"},e),n=t.instance.getBlock();return"list"===t.instance.getType()&&"list"===this.getType()?this.app.insertion.insertListToList(n,this.$block,t.caret):("split"===t.position?this.app.element.split(this.$block).before(n):this.$block[t.position](n),t.remove&&this.isEditable()&&this.isEmpty()&&this.remove()),this.app.editor.build(),t.caret&&this.app.block.set(t.instance,t.caret),this.app.toolbar.observe(),this.app.context.observe(),this.app.broadcast("block.add",{instance:t.instance,type:t.type}),t.instance},change:function(e,t){var n=e.getBlock();this.$block.after(n),this.$block.remove(),this.app.editor.build(),this.app.block.set(e),!1!==t&&this.app.broadcast("block.change",{instance:e})},duplicate:function(e){var t=this.getType(),n=this.$block.clone();return n.removeClass(this.prefix+"-block-focus"),e&&n.html(""),this.app.create("block."+t,n)},duplicateEmpty:function(){return this.duplicate(!0)},_build:function(e){this.build&&this.build(e)},_buildData:function(){this.data||(this.data={}),this.data=u.extend({},!0,this.defaults,this.data)},_buildItems:function(e,t){var n=this.$block.find(e);0!==n.length&&n.each(function(e){this.app.create("block."+t,e)}.bind(this))},_buildCaption:function(){"figure"===this.getTag()&&this.$block.find("figcaption").attr("data-placeholder",this.lang.get("placeholders.figcaption"))},_render:function(){this._renderEdit()},_renderEdit:function(){this.$block.dataset("instance",this),this.$block.attr("data-"+this.prefix+"-type",this.getType()),void 0!==this.editable&&!1===this.editable?this.$block.attr("contenteditable",!1):"figcaption"===this.type&&this.$block.attr("contenteditable",!0)},_cleanEmpty:function(e){return e=(e=-1!==(e=this.app.utils.removeInvisibleChars(e)).search(/^<br\s?\/?>$/)?"":e).replace(/\n/g,"")},_appendListHtml:function(e,t){var n=e.find("li").first();return t=(t=(t=n.html().trim()).replace(/<\/li>/gi,"</li><br>")).replace(/<(ul|ol)/gi,"<br><$1"),t=(t=(t=this.app.content.removeTags(t,["ul","ol","li"])).trim()).replace(/<br\s?\/?>$/gi,""),n.remove(),t},_move:function(e,t){var n=this;n.isNested()&&(n=n.getFirst()),(this.isEditable()||this.isNested())&&this.app.selection.save(n.getBlock()),e.getBlock()[t](this.$block),this.app.block.set(n,!1,!0),(this.isEditable()||this.isNested())&&this.app.selection.restore(!1)},_removeObjClasses:function(e){var t=this._buildObjClasses(e);this.$block.removeClass(t.join(" ")),this.app.element.removeEmptyAttrs(this.$block,["class"])},_buildObjClasses:function(e){var t=[];for(var n in e)e[n]&&t.push(e[n]);return t}}),l.add("mixin","tool",{init:function(e,t,n,r){this.name=e,this.setter=n.get("setter"),this.popup=n,this.data=r,this.obj=this._observe(t),this.obj&&this._build()},getElement:function(){return this.$tool},getInput:function(){return this.$input},getValue:function(){return this.$input.val().trim()},setValue:function(e){this.$input.val(e)},setFocus:function(){this.$input.focus()},trigger:function(e){this.setValue(e),this.setter&&this.app.api(this.setter,this.popup)},_build:function(){this._buildTool(),this._buildLabel(),this._buildInputElement(),this._buildInput(),this._buildEvent(),this._has("placeholder")&&this.$input.attr("placeholder",this.lang.parse(this.obj.placeholder)),this._has("width")&&this.$input.css("width",this.obj.width),this._has("classname")&&this.$input.addClass(this.obj.classname)},_buildInputElement:function(){this.$input=this.dom("<"+this._getInputParam("tag")+">").addClass(this.prefix+this._getInputParam("classname")),this.$input.attr({name:this.name,type:this._getInputParam("type"),"data-type":this.type}),this.$input.dataset("instance",this)},_buildInput:function(){},_buildEvent:function(){if(-1===["segment"].indexOf(this.type)&&this.setter){var e="checkbox"===this.type||"select"===this.type?"change":"keydown blur";e="number"===this.type?e+" change":e,this.$input.on(e,this._catchSetter.bind(this))}},_buildTool:function(){this.$tool=this.dom("<div>").addClass(this.prefix+"-form-item").dataset("instance",this)},_buildLabel:function(){"checkbox"!==this.type&&this._has("label")&&(this.$label=this.dom("<label>").addClass(this.prefix+"-form-label").html(this.lang.parse(this.obj.label)),this.$tool.append(this.$label))},_getInputParam:function(e){return this.input&&void 0!==this.input[e]?this.input[e]:""},_get:function(e){return this.obj[e]},_has:function(e){return Object.prototype.hasOwnProperty.call(this.obj,e)},_observe:function(e){return Object.prototype.hasOwnProperty.call(e,"observer")&&(e=this.app.api(e.observer,e,this.name)),e},_catchSetter:function(e){"keydown"===e.type&&13!==e.which||("keydown"===e.type&&e.preventDefault(),this.app.api(this.setter,this.popup))}}),l.add("module","accessibility",{start:function(){this._buildRole(),this._buildLabel()},_buildRole:function(){this.app.editor.getEditor().attr({"aria-labelledby":this.prefix+"-voice",role:"presentation"})},_buildLabel:function(){var e=this.lang.get("accessibility.help-label"),t=this._createLabel(e);this.app.container.get("main").prepend(t)},_createLabel:function(e){var t=this.dom("<span />").addClass(this.prefix+"-voice-label");return t.attr({id:this.prefix+"-voice-"+this.uuid,"aria-hidden":!1}),t.html(e),t}}),l.add("module","lang",{init:function(){this.langKey=this.app.setting.get("editor.lang"),this.vars=this._build()},get:function(e){var t=this._get(e,this.vars);return void 0===t&&"en"!==this.langKey&&(t=this._get(e,u.lang.en)),void 0===t?"":t},parse:function(e){if("string"!=typeof e)return e;var t=e.match(/## (.*?) ##/g);if(t)for(var n=0;n<t.length;n++){var r=t[n].replace(/^##\s/g,"").replace(/\s##$/g,"");e=e.replace(t[n],this.get(r))}return e},_get:function(e,t){var n=e.split(".");return 1===n.length?t[e]:void 0!==t[n[0]]?t[n[0]][n[1]]:void 0},_build:function(){var e=u.lang.en;return"en"!==this.langKey&&(e="undefined"!==u.lang[this.langKey]?u.lang[this.langKey]:e),e}}),l.add("module","setting",{init:function(){this.opts=this._build()},dump:function(){return this.opts},has:function(e){var t=e.split(".");return 1===t.length?void 0!==this.opts[e]:void 0!==this.opts[t[0]]&&void 0!==this.opts[t[1]]},set:function(e,t,n){void 0===this.opts[e]&&(this.opts[e]={}),void 0===n?this.opts[e]=t:this.opts[e][t]=n},get:function(e){var t=e.split(".");return 1===t.length?this.opts[e]:void 0!==this.opts[t[0]]?this.opts[t[0]][t[1]]:void 0},_build:function(){var e=u.extend(!0,{},u.opts,this.app.initialSettings);return e=u.extend(!0,e,u.settings)}}),l.add("module","element",{is:function(e,t,n){var r=!1,o="text"===t?e:this._getNode(e);return"inline"===t?r=this._isElement(o)&&this._isInlineTag(o.tagName,n):"blocks"===t?r=this._isElement(o)&&o.hasAttribute("data-"+this.prefix+"-type"):"blocks-first"===t?r=this._isElement(o)&&o.hasAttribute("data-"+this.prefix+"-first-level"):"block"===t?r=this._isElement(o)&&this._isBlockTag(o.tagName,n):"element"===t?r=this._isElement(o):"text"===t?r="string"==typeof o&&!/^\s*<(\w+|!)[^>]*>/.test(o)||this.isTextNode(o):"list"===t?r=this._isElement(o)&&-1!==["ul","ol"].indexOf(o.tagName.toLowerCase()):"heading"===t&&(r=this._isElement(o)&&-1!==["h1","h2","h3","h4","h5","h6"].indexOf(o.tagName.toLowerCase())),r},isEmptyOrImageInline:function(e){var t=this.dom(e).get();if(!t||3===t.nodeType)return!1;var n=t.tagName.toLowerCase(),r="false"===t.getAttribute("contenteditable"),o=this.is(t,"inline");return!!(o&&this.isEmpty(t)||o&&r||-1!==["svg","img"].indexOf(n))},isEmpty:function(e){var t=this._getNode(e);return!!t&&(3===t.nodeType?""===t.textContent.trim().replace(/\n/,""):""===t.innerHTML)},isTag:function(e,t){return this._getNode(e).tagName.toLowerCase()===t},isTextNode:function(e){var t=this._getNode(e);return t&&t.nodeType&&3===t.nodeType},isVisible:function(e){var t=this._getNode(e);return!!(t.offsetWidth||t.offsetHeight||t.getClientRects().length)},isScrollVisible:function(e){var t=this.app.scroll.getTarget(),n=this.dom(e),r=t.scrollTop()+t.height();return n.offset().top<=r},getFirstLevel:function(e){return this.dom(e).closest("[data-"+this.prefix+"-first-level]")},getDataBlock:function(e){return this.dom(e).closest("[data-"+this.prefix+"-type]")},getType:function(e){return this.dom(e).attr("data-"+this.prefix+"-type")},getAllInlines:function(e){for(var t=[],n=e;n;)this.is(n,"inline")&&t.push(n),n=n.parentNode;return t},getClosest:function(e,t){return this.dom(e).closest(this.getTypesSelector(t))},getParents:function(e,t){return this.dom(e).parents(this.getTypesSelector(t))},getChildren:function(e,t){return this.dom(e).find(this.getTypesSelector(t))},getTypesSelector:function(e){return"[data-"+this.prefix+"-type="+e.join("],[data-"+this.prefix+"-type=")+"]"},hasClass:function(e,t){t="string"==typeof t?[t]:t;for(var n=this.dom(e),r=t.length,o=0,i=0;i<r;i++)n.hasClass(t[i])&&o++;return r===o},scrollTo:function(e,t){if(!this.isScrollVisible(e)){t=t||60;var n=e.offset(),r=this.app.scroll.getTarget(),o=n.top-t;r.scrollTop(o),setTimeout((function(){r.scrollTop(o)}),1)}},replaceToTag:function(e,t,n){return this.dom(e).replaceWith(function(e){var r=this.dom("<"+t+">");if(n||r.append(e.innerHTML),e.attributes)for(var o=e.attributes,i=0;i<o.length;i++)r.attr(o[i].nodeName,o[i].value);if(n)for(;e.childNodes.length>0;)r.append(this.dom(e.firstChild));return r}.bind(this))},split:function(e){var t=this.dom(e),n=(e=t.get()).tagName.toLowerCase(),r=this.app.content.extractHtmlFromCaret(e);r.nodeType&&11===r.nodeType&&(r=this.dom(r.childNodes));var o=this.dom("<"+n+" />");(o=this.cloneAttrs(e,o)).append(r),t.after(o);var i=t.children().last();if(this.is(i,"inline")){var a=i.html();""===(a=this.app.utils.removeInvisibleChars(a))&&i.remove()}var s=this.getType(o);return s&&this.app.create("block."+s,o,!0),""===t.html()&&t.remove(),o},cloneEmpty:function(e){var t=this.dom(e).get().tagName.toLowerCase();return this.dom("<"+t+">")},cloneAttrs:function(e,t){for(var n=this.dom(t),r=this._getNode(e).attributes,o=r.length;o--;){var i=r[o];n.attr(i.name,i.value)}return n},getAttrs:function(e){var t=this._getNode(e),n={};if(null!=t.attributes&&t.attributes.length)for(var r=0;r<t.attributes.length;r++){var o=t.attributes[r].nodeValue;o=this._isNumber(o)?parseFloat(o):this._getBooleanFromStr(o),n[t.attributes[r].nodeName]=o}return n},removeEmptyAttrs:function(e,t){var n=this.dom(e),r=t.join(" "),o=!1;return void 0===n.attr(r)||null===n.attr(r)?o=!0:""===n.attr(r)&&(n.removeAttr(r),o=!0),o},getBlocks:function(e,t,n){var r=this._getNode(e).childNodes,o=[],i=t||this.opts.tags.parser;n&&(i=this.app.utils.extendArray(i,n));for(var a=0;a<r.length;a++)1===r[a].nodeType&&-1!==i.indexOf(r[a].tagName.toLowerCase())&&o.push(r[a]);return o},hasBlocks:function(e){return 0!==this.getBlocks(e).length},hasTextSiblings:function(e){var t=this._getNode(e),n=t.previousSibling&&3===t.previousSibling.nodeType&&!this.isEmpty(t.previousSibling),r=t.nextSibling&&3===t.nextSibling.nodeType&&!this.isEmpty(t.nextSibling);return n||r},_getNode:function(e){return this.dom(e).get()},_getBooleanFromStr:function(e){return"true"===e||"false"!==e&&e},_isBlockTag:function(e,t){return-1!==this.app.utils.extendArray(this.opts.tags.block,t).indexOf(e.toLowerCase())},_isInlineTag:function(e,t){return-1!==this.app.utils.extendArray(this.opts.tags.inline,t).indexOf(e.toLowerCase())},_isElement:function(e){return e&&e.nodeType&&1===e.nodeType},_isTag:function(e){return void 0!==e&&e},_isNumber:function(e){return!isNaN(e)&&!isNaN(parseFloat(e))}}),l.add("module","paragraphizer",{init:function(){this.remStart="#####replace",this.remEnd="#####";this.tags=this.opts.tags.parser.concat(["form","audio","figcaption","object","style","script","iframe","select","input","textarea","button","option","map","area","math","fieldset","legend","hgroup","nav","details","menu","summary"])},paragraphize:function(e){var t=[],n=[];e=this._storeTags(e,t),e=(e=this.app.content.storeComments(e,n)).trim();for(var r="",o=(e=(e=(e=(e=(e=(e=this._trimLinks(e)).replace(/xparagraphmarkerz(?:\r\n|\r|\n)$/g,"")).replace(/xparagraphmarkerz$/g,"")).replace(/xparagraphmarkerz(?:\r\n|\r|\n)/g,"\n")).replace(/xparagraphmarkerz/g,"\n")).replace(/[\n]+/g,"\n")).split("\n"),i=0;i<o.length;i++)r+="<p>"+o[i].trim()+"</"+"p>\n";return e=(e=(e=(e=r.replace(/\n$/,"")).replace(new RegExp("<p>\\s+#####","gi"),"#####")).replace(new RegExp("<p>#####","gi"),"#####")).replace(new RegExp("#####</p>","gi"),"#####"),e=this._restoreTags(e,t),e=(e=(e=(e=(e=(e=this.app.content.restoreComments(e,n)).replace(/<(p|h1|h2|h3|h4|h5|h6|li|td|th)(.*?)>[\s\n]*<\/\1>/gi,"<$1$2></$1>")).replace(/<p(.*?)><\/?br\s?\/?><\/p>/gi,"<p$1></p>")).replace(/<div(.*?)><\/?br\s?\/?><\/div>/gi,"<div$1></div>")).replace(/<\/?br\s?\/?><\/div>/gi,"</div>")).replace(/<\/?br\s?\/?><\/li>/gi,"</li>")},_storeTags:function(e,t){return this.app.utils.wrap(e,function(e){e.find(this.tags.join(", ")).each(function(e,n){this._replaceTag(e,n,t)}.bind(this))}.bind(this))},_restoreTags:function(e,t){for(var n=0;n<t.length;n++){var r=t[n].replace(/\$/gi,"&#36;");e=e.replace(this.remStart+n+this.remEnd,r)}return e},_replaceTag:function(e,t,n){var r=e.get(),o=document.createTextNode(this.remStart+t+this.remEnd+"xparagraphmarkerz");n.push(r.outerHTML),r.parentNode.replaceChild(o,r)},_trimLinks:function(e){return this.app.utils.wrap(e,function(e){e.find("a").each(this._trimLink.bind(this))}.bind(this))},_trimLink:function(e){e.html(e.html().trim())}}),l.add("module","utils",{isMobile:function(){return/(iPhone|iPad|iPod|Android)/.test(navigator.userAgent)},createInvisibleChar:function(){return document.createTextNode(this.opts.markerChar)},searchInvisibleChars:function(e){return e.search(/^\uFEFF$/g)},removeInvisibleChars:function(e){return e.replace(/\uFEFF/g,"")},wrap:function(e,t){var n=this.dom("<div>").html(e);return t(n),e=n.html(),n.remove(),e},extendArray:function(e,t){if(e=e.concat(e),t)for(var n=0;n<t.length;n++)e.push(t[n]);return e},removeFromArrayByValue:function(e,t){var n;t=Array.isArray(t)?t:[t];for(var r=0;r<t.length;r++)(n=e.indexOf(t[r]))>-1&&e.splice(n,1);return e},sumOfArray:function(e){return e.reduce((function(e,t){return parseInt(e)+parseInt(t)}),0)},getObjectIndex:function(e,t){return Object.keys(e).indexOf(t)},insertToObject:function(e,t,n,r){return Object.keys(n).reduce((function(o,i,a){return a===r&&(o[e]=t),o[i]=n[i],o}),{})},getRandomId:function(){for(var e="",t="abcdefghijklmnopqrstuvwxyz0123456789",n=0;n<12;n++)e+=t.charAt(Math.floor(36*Math.random()));return e},escapeRegExp:function(e){return e.replace(/[-/\\^$*+?.()|[\]{}]/g,"\\$&")},capitalize:function(e){return(e=e.toLowerCase()).charAt(0).toUpperCase()+e.slice(1)},extendData:function(e,t){for(var n in t)e="elements"===n?this._extendDataElements(e,t[n]):this._setData(e,n,t[n]);return e},_extendDataElements:function(e,t){return this.dom(t).each(function(t){if("FORM"===t.get().tagName){var n=t.serialize(!0);Object.keys(n).forEach(function(t){e=this._setData(e,t,n[t])}.bind(this))}else{var r=t.attr("name")?t.attr("name"):t.attr("id");e=this._setData(e,r,t.val())}}.bind(this)),e},_setData:function(e,t,n){return e instanceof FormData?e.append(t,n):e[t]=n,e}}),l.add("module","scroll",{init:function(){this.scrolltop=!1},save:function(){this.scrolltop=this.getTarget().scrollTop()},restore:function(){!1!==this.scrolltop&&(this.getTarget().scrollTop(this.scrolltop),this.scrolltop=!1)},isTarget:function(){return this.opts.editor.scrollTarget!==window},getTarget:function(){return this.dom(this.opts.editor.scrollTarget)}}),l.add("module","autosave",{send:function(){this.opts.autosave.url&&this._sending()},_getName:function(){return this.opts.autosave.name?this.opts.autosave.name:this.app.$element.attr("name")||"content"+this.uuid},_sending:function(){var e=this._getName(),t={};t[e]=this.app.$element.val(),t=this.app.utils.extendData(t,this.opts.autosave.data),this.ajax.request(this.opts.autosave.method,{url:this.opts.autosave.url,data:t,before:function(n){if(this.app.broadcast("autosave.before.send",{xhr:n,name:e,data:t}).isStopped())return!1}.bind(this),success:function(n){this._complete(n,e,t)}.bind(this)})},_complete:function(e,t,n){var r=e&&e.error?"autosave.error":"autosave.send";this.app.broadcast(r,{name:t,data:n,response:e})}}),l.add("module","progress",{stop:function(){this.hide()},show:function(){this.hide(),this.$progress=this.dom("<div>").addClass(this.prefix+"-editor-progress"),this.$progress.attr("id",this.prefix+"-progress"),this.$progressBar=this.dom("<span>"),this.$progress.append(this.$progressBar),this.app.$body.append(this.$progress)},hide:function(){this.app.$body.find("#"+this.prefix+"-progress").remove()}}),l.add("module","clipboard",{getContent:function(e){var t=this.isPlainText(e)?"text/plain":"text/html",n=e.getData(t);return"text/plain"===t?this.app.content.escapeHtml(n):n},setContent:function(e,t,n){var r=e.clipboardData;t=this.app.parser.unparse(t),t='<meta type="'+this.prefix+'-editor"/>'+t,n=n||this.app.content.getTextFromHtml(t,{nl:!0}),r.setData("text/html",t),r.setData("text/plain",n)},isPlainText:function(e){var t=e.getData("text/plain"),n=e.getData("text/html");return(!n||""===n.trim())&&null!==t}}),l.add("module","fragment",{build:function(e){return this.is(e)?e:this.create(e)},insert:function(e){var t=this.app.selection.get();if(t.range){if(t.collapsed){var n=t.range.startContainer;3!==n.nodeType&&"BR"===n.tagName&&n.parentNode.removeChild(n)}else t.range.deleteContents();e.frag?t.range.insertNode(e.frag):t.range.insertNode(e)}},createContainer:function(e){var t=this.dom("<div>");return"string"==typeof e?t.html(e):t.append(this.dom(e).clone(!0)),t.get()},create:function(e){for(var t,n,r,o="string"==typeof e?this.createContainer(e):e,i=document.createDocumentFragment(),a=[],s=0;t=o.firstChild;){s++;var l=i.appendChild(t);1===s&&(n=l),a.push(l),r=l}return{frag:i,first:n,last:r,nodes:a}},is:function(e){return"object"==typeof e&&e.frag}}),l.add("module","button",{init:function(e,t,n,r){if("object"==typeof e)this.name=e.name,this.obj=t,this._buildFromElement(e.element);else if(e){this.type=r||!1,this.name=e;var o=this._observe(t);this.obj=void 0===o?t:o,this.obj&&this._build(e,n)}},setColor:function(e,t){var n=e.getName();if("background"===n||"text-color"===n){var r="background"===n?"background-color":"color";this.setBackground(t[r])}},isButton:function(){return!0},isAddbar:function(){return this._has("addbar")},isControl:function(){return this._has("control")},getName:function(){return this.name},getTitle:function(){return this.title},getParams:function(){return!!this._has("params")&&this.obj.params},getOffset:function(){return this.$button.offset()},getDimension:function(){return{width:this.$button.width(),height:this.$button.height()}},getElement:function(){return this.$button},setBackground:function(e){this._background("add",e)},resetBackground:function(){this._background("remove","")},_has:function(e){return Object.prototype.hasOwnProperty.call(this.obj,e)},_observe:function(e){return Object.prototype.hasOwnProperty.call(e,"observer")&&(e=this.app.api(e.observer,e,this.name)),e},_background:function(e,t){var n="remove"===e?"removeClass":"addClass";this.$icon[n](this.prefix+"-button-icon-color").css({"background-color":t,color:""!==t?this.app.color.invert(t):""})},_buildFromElement:function(e){this.$button=this.dom(e),this.$button.addClass(this.prefix+"-button-target"),this._buildData()},_build:function(e,t){this._buildTitle(),this._buildElement(),this._buildIcon(),this._buildData(t)},_buildData:function(e){this.$button.attr({tabindex:"-1","data-name":this.name,"data-command":this.obj.command||!1}),this.$button.dataset("instance",this);var t=this._has("command")?"_catch":"_stop";this.$button.on("click."+this.prefix+"-button",this[t].bind(this)),this.$button.on("dragstart."+this.prefix+"-button",(function(e){e.preventDefault()})),e&&(this._buildTooltip(),this._buildBackground(),this._buildPosition(e))},_buildTitle:function(){this.title=void 0!==this.obj.title?this.lang.parse(this.obj.title):""},_buildElement:function(){this.$button=this.dom('<a href="#"></a>'),this.$button.addClass(this.prefix+"-button "+this.prefix+"-button-target"),this.type&&this.$button.addClass(this.prefix+"-button-"+this.type),this._has("classname")&&this.$button.addClass(this.obj.classname)},_buildIcon:function(){var e=this._has("icon"),t='<span class="'+this.prefix+"-icon-"+this.name+'"></span>';this.$icon=this._buildIconElement(),e&&!0!==this.obj.icon&&(t=-1!==this.obj.icon.search(/</)?this.obj.icon:'<span class="'+this.prefix+"-icon-"+this.obj.icon+'"></span>'),this.opts.buttons.icons&&void 0!==this.opts.buttons.icons[this.name]&&(t=this.opts.buttons.icons[this.name]),this.$icon.append(t),this.$button.append(this.$icon)},_buildIconElement:function(){return this.dom("<span>").addClass(this.prefix+"-button-icon")},_buildTooltip:function(){("toolbar"===this.type||"context"===this.type&&this.opts.tooltip.context)&&this.app.tooltip.build(this.$button,this.title)},_buildBackground:function(){this._has("background")&&this.setBackground(this.obj.background)},_buildPosition:function(e){if(this._has("position")){var t=this.obj.position;if("first"===t)e.prepend(this.$button);else if("object"==typeof t){var n=Object.prototype.hasOwnProperty.call(t,"after")?"after":"before",r=t[n],o=this._findPositionElement(r,e);o?o[n](this.$button):e.append(this.$button)}}else e.append(this.$button)},_findPositionElement:function(e,t){var n;if(Array.isArray(e))for(var r=0;r<e.length&&0===(n=t.find("[data-name="+e[r]+"]")).length;r++);else n=t.find("[data-name="+e+"]");return 0!==n.length?n:0},_stop:function(e){e.preventDefault(),e.stopPropagation()},_catch:function(e){e.preventDefault(),e.stopPropagation();var t=this.dom(e.target).closest("."+this.prefix+"-button-target");if(!t.hasClass("disable")){this.app.editor.setFocus();var n=t.attr("data-command"),r=t.attr("data-name"),o=t.dataget("instance");this.app.api(n,this.getParams(),o,r,e),this.app.tooltip.close()}}}),l.add("module","tooltip",{init:function(){this.classname=this.prefix+"-tooltip",this.eventname=this.prefix+"-button-"+this.uuid},stop:function(){this.close()},build:function(e,t){(t=this._cleanTitle(t))&&(e.attr("data-tooltip",t),e.on("mouseover."+this.eventname,this.open.bind(this)),e.on("mouseout."+this.eventname,this.close.bind(this)))},open:function(e){var t=this._getButton(e);this.app.popup.isOpen()||t.hasClass("disable")||(this.$tooltip=this._create(t),this._setPosition(t),this._fixBSModal(),this.app.$body.append(this.$tooltip))},close:function(){this.app.$body.find("."+this.classname).remove()},_create:function(e){return this.dom("<span>").addClass(this.classname).html(e.attr("data-tooltip"))},_cleanTitle:function(e){return!!e&&e.replace(/(<([^>]+)>)/gi,"")},_setPosition:function(e){var t=e.offset(),n=e.height();this.$tooltip.css({top:t.top+n+"px",left:t.left+"px"})},_fixBSModal:function(){this.opts.bsmodal&&this.$tooltip.css("z-index",1060)},_getButton:function(e){return this.dom(e.target).closest("."+this.prefix+"-button-target")}}),l.add("module","codemirror",{init:function(){this.cm=!1},create:function(e){if(this.is()){var n="object"==typeof this.opts.codemirror?this.opts.codemirror:{},r=this.opts.codemirrorSrc?this.opts.codemirrorSrc:t;return this.cm=r.fromTextArea(this.dom(e.el).get(),n),e.height&&this.cm.setSize(null,e.height),e.focus&&this.cm.focus(),this.cm}},destroy:function(){this.cm&&(this.cm.toTextArea(),this.cm=!1)},is:function(){return this.opts.codemirror},val:function(e){return this.is()&&this.cm&&(e=this.cm.getValue()),e}}),l.add("class","upload",{defaults:{type:"image",box:!1,url:!1,cover:!0,name:"file",data:!1,multiple:!0,placeholder:!1,hidden:!0,target:!1,success:!1,error:!1,remove:!1,trigger:!1,input:!1},init:function(e,t,n){this.eventname=this.prefix+"-upload",e&&this._build(e,t,n)},send:function(e,t,n,r){this.p=this._buildParams(n,r),this._send(e,t)},complete:function(e,t){this._complete(e,t)},setImage:function(e){this.p.input||(this.$image&&this.$image.remove(),this.$remove&&this.$remove.remove(),""===e?this.$placeholder.show():(this.$placeholder.hide(),this._buildImage(e),this.p.remove&&this._buildRemove()))},_build:function(e,t,n){this.p=this._buildParams(t,n),this.$element=this.dom(e),"INPUT"===this.$element.get().tagName?this._buildByInput():this._buildByBox()},_buildImage:function(e){this.$image=this.dom("<img>"),this.$image.attr("src",e),this.$box.append(this.$image),!1===this.p.input&&(this.$box.off("click."+this.eventname),this.$image.on("click."+this.eventname,this._click.bind(this)))},_buildRemove:function(){this.$remove=this.dom("<span>"),this.$remove.addClass(this.prefix+"-upload-remove"),this.$remove.on("click",this._removeImage.bind(this)),this.$box.append(this.$remove)},_buildParams:function(e,t){return e=u.extend(!0,this.defaults,e),t&&(e.trigger=t),e},_buildByInput:function(){this.$input=this.$element,this.p.box?(this._buildBox(),this._buildPlaceholder()):this.p.input=!0,this._buildAccept(),this._buildMultiple(),this._buildEvents()},_buildByBox:function(){this._buildInput(),this._buildAccept(),this._buildMultiple(),this._buildBox(),this._buildPlaceholder(),this._buildEvents()},_buildBox:function(){this.$box=this.dom("<div>").addClass(this.prefix+"-form-upload-box"),this.$element.before(this.$box),!1===this.p.cover&&this.$box.addClass(this.prefix+"-form-upload-cover-off"),this.p.hidden&&this.$element.hide()},_buildPlaceholder:function(){this.p.placeholder&&(this.$placeholder=this.dom("<span>").addClass(this.prefix+"-form-upload-placeholder"),this.$placeholder.html(this.p.placeholder),this.$box.append(this.$placeholder))},_buildInput:function(){this.$input=this.dom("<input>"),this.$input.attr("type","file"),this.$input.attr("name",this._getUploadParam()),this.$input.hide(),this.$element.before(this.$input)},_buildAccept:function(){if("image"===this.p.type){var e=this.opts.image.types.join(",");this.$input.attr("accept",e)}},_buildMultiple:function(){"image"===this.p.type&&(this.p.multiple?this.$input.attr("multiple","multiple"):this.$input.removeAttr("multiple"))},_buildEvents:function(){this.$input.on("change."+this.eventname+"-"+this.uuid,this._change.bind(this)),!1===this.p.input&&(this.$box.on("click."+this.eventname,this._click.bind(this)),this.$box.on("drop."+this.eventname,this._drop.bind(this)),this.$box.on("dragover."+this.eventname,this._dragover.bind(this)),this.$box.on("dragleave."+this.eventname,this._dragleave.bind(this)))},_buildData:function(e,t,n){if("single"===this.p.multiple)n.append(e,t[0]);else if(this.p.multiple)for(var r=0;r<t.length;r++)n.append(e+"[]",t[r]);else n.append(e+"[]",t[0]);return n},_removeImage:function(e){e&&(e.preventDefault(),e.stopPropagation()),this.$image&&this.$image.remove(),this.$remove&&this.$remove.remove(),this.$placeholder.show(),!1===this.p.input&&this.$box.on("click."+this.eventname,this._click.bind(this)),e&&this.app.api(this.p.remove,e)},_getUploadParam:function(){return this.p.name},_click:function(e){e.preventDefault(),this.$input.click()},_change:function(e){this._send(e,this.$input.get().files)},_drop:function(e){e.preventDefault(),this._send(e)},_dragover:function(e){return e.preventDefault(),this._setStatus("hover"),!1},_dragleave:function(e){return e.preventDefault(),this._removeStatus(),!1},_setStatus:function(e){!this.p.input&&this.p.box&&(this._removeStatus(),this.$box.addClass(this.prefix+"-form-upload-"+e))},_removeStatus:function(){if(!this.p.input&&this.p.box)for(var e=["hover","error"],t=0;t<e.length;t++)this.$box.removeClass(this.prefix+"-form-upload-"+e[t])},_send:function(e,t){t=t||e.dataTransfer.files;var n=new FormData,r=this._getUploadParam();n=this._buildData(r,t,n),n=this.app.utils.extendData(n,this.p.data),this._sendData(e,t,n)},_sendData:function(e,t,n){"function"==typeof this.p.url?this.p.url.call(this.app,this,{data:n,files:t,e}):(this.app.progress.show(),this.ajax.post({url:this.p.url,data:n,before:function(r){if(this.app.broadcast("upload.before.send",{xhr:r,data:n,files:t,e}).isStopped())return this.app.progress.hide(),!1}.bind(this),success:function(t){this._complete(t,e)}.bind(this),error:function(t){this._complete(t,e)}.bind(this)}))},_complete:function(e,t){e&&e.error?(this._setStatus("error"),this.p.error&&(this.app.broadcast("upload.error",{response:e}),this.app.api(this.p.error,e,t))):(this._removeStatus(),this._trigger(e),this.p.success&&(this.app.broadcast("upload.complete",{response:e}),this.app.api(this.p.success,e,t))),setTimeout(function(){this.app.progress.hide()}.bind(this),500)},_trigger:function(e){if(this.p.trigger&&e&&e.url){var t=this.p.trigger.instance;t[this.p.trigger.method].call(t,e.url)}}}),l.add("module","statusbar",{init:function(){this.classname=this.prefix+"-statusbar"},start:function(){this._build()},add:function(e,t){return this.update(e,t)},update:function(e,t){var n=this.get(e);return 0===n.length&&(n=this._buildItem(e)),n.html(t)},get:function(e){var t=e?"[data-name="+e+"]":"[data-name]";return this.$statusbar.find(t)},remove:function(e){this.get(e).remove()},clear:function(){this.$statusbar.html("")},_build:function(){this.$statusbar=this.dom("<div>").attr("dir",this.opts.editor.direction),this.$statusbar.addClass(this.classname+" "+this.classname+"-"+this.uuid),this.app.container.get("statusbar").append(this.$statusbar)},_buildItem:function(e){var t=this.dom("<span>").addClass(this.classname+"-item");return t.attr("data-name",e),this.$statusbar.append(t),t}}),l.add("module","container",{init:function(){this.blurclass=this.prefix+"-in-blur",this.focusclass=this.prefix+"-in-focus"},start:function(){this._buildMain(),this._buildContainers(this.$main,this.opts.containers.main),this._buildBSModal()},stop:function(){this.$main.remove()},get:function(e){return this["$"+e]},setFocus:function(){this.$main.removeClass(this.blurclass).addClass(this.focusclass)},setBlur:function(){this.$main.removeClass(this.focusclass).addClass(this.blurclass)},isFocus:function(){return this.$main.hasClass(this.focusclass)},_buildMain:function(){this.$main=this.dom("<div>").attr(this.prefix+"-uuid",this.uuid),this.$main.addClass(this.prefix+"-container "+this.prefix+"-container-"+this.uuid),this.app.$element.after(this.$main)},_buildContainers:function(e,t){for(var n=0;n<t.length;n++){var r=t[n],o="$"+r;this[o]=this._createContainer(r),void 0!==this.opts.containers[r]&&this._buildContainers(this[o],this.opts.containers[r]),e.append(this[o])}},_buildBSModal:function(){this.opts.bsmodal=0!==this.$main.closest(".modal-dialog").length},_createContainer:function(e){return this.dom("<div>").addClass(this.prefix+"-"+e+"-container")}}),l.add("module","shortcut",{init:function(){if(this.opts.shortcutsRemove)for(var e=this.opts.shortcutsRemove,t=0;t<e.length;t++)this.remove(e[t]);this.shortcuts=this.opts.shortcuts,this.hotkeys={8:"backspace",9:"tab",10:"return",13:"return",16:"shift",17:"ctrl",18:"alt",19:"pause",20:"capslock",27:"esc",32:"space",33:"pageup",34:"pagedown",35:"end",36:"home",37:"left",38:"up",39:"right",40:"down",45:"insert",46:"del",59:";",61:"=",96:"0",97:"1",98:"2",99:"3",100:"4",101:"5",102:"6",103:"7",104:"8",105:"9",106:"*",107:"+",109:"-",110:".",111:"/",112:"f1",113:"f2",114:"f3",115:"f4",116:"f5",117:"f6",118:"f7",119:"f8",120:"f9",121:"f10",122:"f11",123:"f12",144:"numlock",145:"scroll",173:"-",186:";",187:"=",188:",",189:"-",190:".",191:"/",192:"`",219:"[",220:"\\",221:"]",222:"'"},this.hotkeysShiftNums={"`":"~",1:"!",2:"@",3:"#",4:"$",5:"%",6:"^",7:"&",8:"*",9:"(",0:")","-":"_","=":"+",";":": ","'":'"',",":"<",".":">","/":"?","\\":"|"}},add:function(e,t){this.shortcuts[e]=t},remove:function(e){this.opts.shortcutsBase=this._remove(e,this.opts.shortcutsBase),this.opts.shortcuts=this._remove(e,this.opts.shortcuts)},popup:function(e,t){var n=/(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)?"<b>&#8984;</b>":"ctrl",r={},o=0;o=this._buildPopupItems(r,o,this.opts.shortcutsBase,n,"base"),this._buildPopupItems(r,o,this.opts.shortcuts,n),this.app.popup.create("shortcuts",{width:"360px",items:r}),this.app.popup.open({button:t})},handle:function(e){if(this.triggered=!1,!1===this.shortcuts)return!e.ctrlKey&&!e.metaKey||66!==e.which&&73!==e.which||e.preventDefault(),!0;if(e.ctrlKey||e.metaKey||e.shoftKey||e.altKey)for(var t in this.shortcuts)this.shortcuts.hasOwnProperty(t)&&this._build(e,t,this.shortcuts[t]);return this.triggered},_buildPopupItems:function(e,t,n,r,o){for(var i in n)if(n.hasOwnProperty(i)){for(var a=this.dom("<div>").addClass(this.prefix+"-popup-shortcut-item"),s="base"===o?n[i]:n[i].title,l=this.dom("<span>").addClass(this.prefix+"-popup-shortcut-title").html(this.lang.parse(s)),c=this.dom("<span>").addClass(this.prefix+"-popup-shortcut-kbd"),u=("base"===o?i.replace("meta",r):n[i].name.replace("meta",r)).split("+"),d=0;d<u.length;d++)u[d]="<span>"+u[d]+"</span>";c.html(u.join("+")),a.append(l),a.append(c),e[t]={html:a},t++}return t},_build:function(e,t,n){for(var r=t.split(","),o=r.length,i=0;i<o;i++)"string"!=typeof r[i]||Object.prototype.hasOwnProperty.call(n,"trigger")||this._handler(e,r[i].trim(),n)},_handler:function(e,t,n){t=t.toLowerCase().split(" ");for(var r=this.hotkeys[e.keyCode],o=91!==e.which&&String.fromCharCode(e.which).toLowerCase(),i="",a={},s=["meta","ctrl","alt","shift"],l=0;l<s.length;l++){var c=s[l];e[c+"Key"]&&r!==c&&(i+=c+"+")}93===e.keyCode&&(i+="meta+"),r&&(a[i+r]=!0),o&&(a[i+o]=!0,a[i+this.hotkeysShiftNums[o]]=!0,"shift+"===i&&(a[this.hotkeysShiftNums[o]]=!0));for(var u=t.length,d=0;d<u;d++)if(a[t[d]])return e.preventDefault(),this.triggered=!0,void this.app.api(n.command,n.params,e)},_remove:function(e,t){return Object.keys(t).reduce((function(n,r){return r!==e&&(n[r]=t[r]),n}),{})}}),l.add("module","offset",{get:function(e){e=this._getEl(e);var t=this.app.editor.getWinNode().getSelection(),n=!1;if(t&&t.rangeCount>0){var r=t.getRangeAt(0);if(e.contains(t.anchorNode)){var o=r.cloneRange();o.selectNodeContents(e),o.setEnd(r.startContainer,r.startOffset);var i=o.toString().length;n={start:i,end:i+r.toString().length}}}return n},set:function(e,t){!1===t&&(t={start:0,end:0}),e=this._getEl(e);var n,r=0,o=this.app.editor.getDocNode().createRange(),i=[e],a=!1,s=!1;for(o.setStart(e,0),o.collapse(!0);!s&&(n=i.pop());)if(3===n.nodeType){var l=r+n.length;!a&&t.start>=r&&t.start<=l&&(o.setStart(n,t.start-r),a=!0),a&&t.end>=r&&t.end<=l&&(o.setEnd(n,t.end-r),s=!0),r=l}else for(var c=n.childNodes.length;c--;)i.push(n.childNodes[c]);this.app.selection.setRange(o)},_getEl:function(e){return e?this.dom(e).get():this.app.editor.getLayout().get()}}),l.add("module","marker",{build:function(e){var t=this.dom("<span>").attr("id","selection-marker-"+e);return t.addClass(this.prefix+"-selection-marker"),t.html(this.opts.markerChar),t.get()},insert:function(){this.remove();var e=this.app.selection.get(),t=!e.collapsed;if(e.range){var n=this.build("start"),r=this.build("end"),o=e.range.cloneRange();t&&(o.collapse(!1),o.insertNode(r)),o.setStart(e.range.startContainer,e.range.startOffset),o.collapse(!0),o.insertNode(n),e.range.setStartAfter(n),t&&e.range.setEndBefore(r),this.app.selection.setRange(e.range)}},restore:function(){var e=this.find("start"),t=this.find("end"),n=this.app.selection.get(),r=n.range?n.range:this.app.editor.getDocNode().createRange();if(e){var o=!!t&&t.previousSibling,i=e.nextSibling;i=(!i||3!==i.nodeType||""!==i.textContent.replace(/[\n\t]/g,""))&&i,t?i&&"selection-marker-end"===i.id?this._restoreInject(r,e):o&&i?(r.selectNodeContents(o),r.collapse(!1),r.setStart(i,0)):o&&!i?(r.selectNodeContents(o),r.collapse(!1),r.setStartAfter(e)):(r.setStartAfter(e),r.setEndBefore(t)):i?(r.selectNodeContents(i),r.collapse(!0)):this._restoreInject(r,e),this.app.selection.setRange(r);var a=e&&t?2:1,s=this.app.offset.get();s={start:s.start-a,end:s.end-a},e&&e.parentNode.removeChild(e),t&&t.parentNode.removeChild(t),this.app.editor.setWinFocus(),this.app.offset.set(!1,s)}},find:function(e){var t=this.app.editor.getLayout().find("#selection-marker-"+e);return 0!==t.length&&t.get()},remove:function(){var e=this.find("start"),t=this.find("end");e&&e.parentNode.removeChild(e),t&&t.parentNode.removeChild(t)},_restoreInject:function(e,t){var n=this.app.utils.createInvisibleChar();this.dom(t).after(n),e.selectNodeContents(n),e.collapse(!1)}}),l.add("module","state",{init:function(){this.started=!1,this.storage=!1,this.state=!1,this.passed=!0,this.undoStorage=[],this.redoStorage=[]},load:function(){this.clear(),this.trigger(!0)},stop:function(){this.clear()},clear:function(){this.storage=!1,this.state=!1,this.passed=!0,this.undoStorage=[],this.redoStorage=[]},get:function(){return this.undoStorage},add:function(e){e&&(e.ctrlKey||e.metaKey||this._isUndo(e)||this._isRedo(e))||!this.app.observer.trigger||(this.state=this._createState(),!1===this.started&&(this._setState(this.state,0),this.started=!0))},trigger:function(e){if(this.passed){var t=this._createState();this.state?t=this.state:this.state||e||(t=this.storage,this.started=!0),this._addState(t),this.storage=this._createState(),this.state=!1}},listen:function(e){return this._isUndo(e)?(e.preventDefault(),this.undo(),!0):this._isRedo(e)?(e.preventDefault(),this.redo(),!0):void(this.passed=!0)},undo:function(){if(this._hasUndo()){this.passed=!1;var e=this._getUndo();this._setRedo();var t=this.app.parser.parse(e[0]);this.app.editor.getLayout().html(t.children()),this._rebuild(e,"undo");var n=this.app.block.get(),r=!(!n||!n.isEditable())&&n.getBlock();this.app.offset.set(r,e[1])}},redo:function(){if(this._hasRedo()){this.passed=!1;var e=this.redoStorage.pop();this._addState(e);var t=this.app.parser.parse(e[0]);this.app.editor.getLayout().html(t.children()),this._rebuild(e,"redo");var n=this.app.block.get(),r=!(!n||!n.isEditable())&&n.getBlock();this.app.offset.set(r,e[1])}},_rebuild:function(e,t){this.app.editor.build(),this.app.editor.getLayout().find("."+this.prefix+"-block-state").each(function(e){this.app.block.set(e)}.bind(this)),this.app.broadcast("state."+t,{html:e[0],offset:e[1]})},_isUndo:function(e){var t=e.which;return(e.ctrlKey||e.metaKey)&&90===t&&!e.shiftKey&&!e.altKey},_isRedo:function(e){var t=e.which;return(e.ctrlKey||e.metaKey)&&(90===t&&e.shiftKey||89===t&&!e.shiftKey)&&!e.altKey},_hasUndo:function(){return 0!==this.undoStorage.length},_hasRedo:function(){return 0!==this.redoStorage.length},_getUndo:function(){return 1===this.undoStorage.length?this.undoStorage[0]:this.undoStorage.pop()},_createState:function(){var e=this.app.editor.getLayout().html();e=this.app.utils.wrap(e,function(e){e.find("."+this.prefix+"-block-focus").addClass(this.prefix+"-block-state")}.bind(this));var t=this.app.block.get(),n=!(!t||!t.isEditable())&&t.getBlock();return{html:this.app.parser.unparse(e,!0),offset:this.app.offset.get(n)}},_setState:function(e,t){this.undoStorage[t]=[e.html,e.offset]},_addState:function(e){var t=this.undoStorage[this.undoStorage.length-1];void 0===t||t[0]!==e.html?(this.undoStorage.push([e.html,e.offset]),this._removeOverStorage()):t[1]=e.offset},_setRedo:function(){var e=this._createState();this.redoStorage.push([e.html,e.offset]),this.redoStorage=this.redoStorage.slice(0,this.opts.state.limit)},_removeOverStorage:function(){this.undoStorage.length>this.opts.state.limit&&(this.undoStorage=this.undoStorage.slice(0,this.undoStorage.length-this.opts.state.limit))}}),l.add("module","sync",{build:function(){this.syncedHtml=this.app.$element.val()},trigger:function(){this.opts.editor.sync&&(this.typingTimer&&clearTimeout(this.typingTimer),this.typingTimer=setTimeout(function(){var e=this._getHtml();this.is(e)&&this._sync(e)}.bind(this),300))},invoke:function(){var e=this._getHtml();this.syncedHtml=e,this._sync(e)},is:function(e){var t=!1;return this.syncedHtml!==e&&(this.syncedHtml=e,t=!0),t},_getHtml:function(){var e=this.app.editor.getLayout().html();return this.app.parser.unparse(e)},_sync:function(e){var t=this.app.broadcast("editor.before.change",{html:e});t.isStopped()||(this.app.$element.val(t.get("html")),this.app.autosave.send(),this.app.state.trigger(),this.app.broadcast("editor.change",t))}}),l.add("module","placeholder",{start:function(){this.placeholder=!1,this.$layout=this.app.editor.getLayout(),this._build()},handleClick:function(e){this.dom(e.target).hasClass(this.prefix+"-placeholder")&&(e.preventDefault(),e.stopPropagation(),this.app.editor.setFocus("start"))},trigger:function(){this.placeholder&&this.app.editor.isEmpty(!0)?this.show():this.hide()},toggle:function(){this.observerTimer&&clearTimeout(this.observerTimer),this.observerTimer=setTimeout(this.trigger.bind(this),10)},show:function(){this.$layout.addClass(this.prefix+"-placeholder")},hide:function(){this.$layout.removeClass(this.prefix+"-placeholder")},change:function(e){this.opts.placeholder=e,this._rebuild(),this.app.editor.isEmpty(!0)&&this.app.editor.setEmpty()},_build:function(){this._rebuild(),this.toggle()},_rebuild:function(){var e=this.opts.placeholder,t=this.app.$element.attr("placeholder");(!1!==e||t)&&(this.$layout.attr("placeholder",!1!==e?e:t),this.placeholder=!0)}}),l.add("module","list",{indent:function(){var e=this.app.selection.get(),t=this.app.selection.getBlock(),n=this.dom(t),r=n.prevElement(),o=r.get(),i=e.collapsed&&t&&o&&"LI"===o.tagName;if(this.app.selection.save(t),i){var a=(r=this.dom(o)).children("ul, ol"),s=n.closest("ul, ol");if(0!==a.length)a.append(n);else{var l=s.get().tagName.toLowerCase(),c=this.dom("<"+l+">");c.append(n),r.append(c)}}return this.app.selection.restore(),i},outdent:function(){var e=this.app.selection.get(),t=this.app.selection.getBlock(),n=this.dom(t),r=!1;if(e.collapsed&&t){var o,i,a=n.parent(),s=a.closest("li"),l=n.prevElement(),c=n.nextElement(),u=l.get(),d=c.get(),p=!1===u,f=!1!==u&&!1!==d;if(this.app.selection.save(t),0!==s.length){if(f){o=this._getAllNext(n.get()),i=this.dom("<"+a.get().tagName.toLowerCase()+">");for(var h=0;h<o.length;h++)i.append(o[h]);s.after(n),n.append(i)}else s.after(n),0===a.children().length?a.remove():p&&n.append(a);r=!0}this.app.selection.restore()}return r},_getAllNext:function(e){for(var t=[];e;){if(!(e=this.dom(e).nextElement().get()))return t;t.push(e)}return t}}),l.add("module","cleaner",{cleanHtml:function(e){e=this.app.broadcastHtml("editor.before.clean",e);var t={},n=this.opts.paste.blockTags.concat(this.opts.paste.inlineTags).concat(this.opts.paste.formTags),r=this._isPages(e),o=this._isHtmlMsWord(e),i=this._isEditor(e);e=this.app.content.store(e,"embed",t,0),e=this.app.content.removeDoctype(e),e=(e=this.app.content.removeTags(e,this.opts.tags.denied)).trim(),e=this.app.content.removeComments(e),e=this.app.content.removeTagsWithContent(e,["script","style"]),e=r?this._cleanPages(e):e,e=o?e:this._cleanGDocs(e),e=this._encodePhp(e),e=this.app.content.removeTagsExcept(e,n),e=o?this._cleanMsWord(e):e;var a=!1;if(!i&&this.app.event.pasteEvent&&(e=this.app.content.restore(e,"embed",t),a=!0),!i){var s=0!==this.opts.paste.keepClass.length?this.opts.paste.keepClass.join(","):"",l=0!==this.opts.paste.keepAttrs.length?this.opts.paste.keepAttrs.join(","):"";e=this.app.utils.wrap(e,(function(e){var t=e.find("*");t.not(s).removeAttr("class"),t.not(l).each((function(e){for(var t=e.get(),n=t.attributes,r=n.length-1;r>=0;r--){var o=n[r].name;"class"!==o&&"dir"!==o&&-1===o.search(/^data-/)&&(("IMG"!==t.tagName||"src"!==o&&"alt"!==o)&&("A"!==t.tagName||"href"!==o&&"target"!==o)&&t.removeAttribute(o))}}))}))}return a||(e=this.app.content.restore(e,"embed",t)),e=i?this.app.content.cacheStyle(e):this.app.content.removeStyleAttr(e),e=(e=(e=(e=(e=(e=this.app.content.removeEmptyInlines(e)).replace(/<figure[^>]*><\/figure>/gi,"")).replace(/<p>&nbsp;<\/p>/gi,"<p></p>")).replace(/<p><br\s?\/?><\/p>/gi,"<p></p>")).replace(/^<li/gi,"<ul><li")).replace(/<\/li>$/gi,"</li></ul>"),(o||r)&&(e=(e=e.replace(/<p><\/p>/gi,"")).replace(/<p>\s<\/p>/gi,"")),e=this.app.utils.wrap(e,function(e){e.find(".Apple-converted-space").unwrap(),e.find("ul, ol").each(this._placeListToItem.bind(this)),e.find("li p").unwrap()}.bind(this)),this.app.broadcastHtml("editor.clean",e)},_encodePhp:function(e){return e=(e=(e=e.replace("<?php","&lt;?php")).replace("<?","&lt;?")).replace("?>","?&gt;")},_isEditor:function(e){return e.match(new RegExp('meta\\stype="'+this.prefix+'-editor"',"i"))},_isHtmlMsWord:function(e){return e.match(/class="?Mso|style="[^"]*\bmso-|style='[^'']*\bmso-|w:WordDocument/i)},_isPages:function(e){return e.match(/name="Generator"\scontent="Cocoa\sHTML\sWriter"/i)},_placeListToItem:function(e){var t=e.get(),n=t.previousSibling;if(n&&"LI"===n.tagName){var r=this.dom(n);r.find("p").unwrap(),r.append(t)}},_cleanPages:function(e){return e=(e=e.replace(/\sclass="s[0-9]"/gi,"")).replace(/\sclass="p[0-9]"/gi,"")},_cleanGDocs:function(e){return e=(e=(e=(e=(e=e.replace(/<b\sid="internal-source-marker(.*?)">([\w\W]*?)<\/b>/gi,"$2")).replace(/<b(.*?)id="docs-internal-guid(.*?)">([\w\W]*?)<\/b>/gi,"$3")).replace(/<span[^>]*(font-style:\s?italic;\s?font-weight:\s?(bold|600|700)|font-weight:\s?(bold|600|700);\s?font-style:\s?italic)[^>]*>([\w\W]*?)<\/span>/gi,"<b><i>$4</i></b>")).replace(/<span[^>]*font-style:\s?italic[^>]*>([\w\W]*?)<\/span>/gi,"<i>$1</i>")).replace(/<span[^>]*font-weight:\s?(bold|600|700)[^>]*>([\w\W]*?)<\/span>/gi,"<b>$2</b>")},_cleanMsWord:function(e){e=(e=(e=(e=(e=(e=e.replace(/<!--[\s\S]+?-->/gi,"")).trim()).replace(/<(!|script[^>]*>.*?<\/script(?=[>\s])|\/?(\?xml(:\w+)?|meta|link|style|\w:\w+)(?=[\s/>]))[^>]*>/gi,"")).replace(/<(\/?)s>/gi,"<$1strike>")).replace(/&nbsp;/gi," ")).replace(/<span\s+style\s*=\s*"\s*mso-spacerun\s*:\s*yes\s*;?\s*"\s*>([\s\u00a0]*)<\/span>/gi,(function(e,t){return t.length>0?t.replace(/./," ").slice(Math.floor(t.length/2)).split("").join(" "):""}));for(var t="",n=(e=(e=(e=(e=(e=(e=this.app.utils.wrap(e,function(e){e.find("p").each((function(e){var t=/mso-list:\w+ \w+([0-9]+)/.exec(e.attr("style"));t&&e.attr("data-listLevel",parseInt(t[1],10))})),this._parseWordLists(e),e.find("[align]").removeAttr("align"),e.find("[name]").removeAttr("name"),e.find("span").each((function(e){var t=e.attr("style");/mso-list:Ignore/.exec(t)?e.remove():e.unwrap()})),e.find("[style]").removeAttr("style"),e.find("[class^='Mso']").removeAttr("class"),e.find("a").filter((function(e){return!e.attr("href")})).unwrap()}.bind(this))).replace(/<p><img(.*?)>/gi,"<p><img$1></p><p>")).replace(/<p[^>]*><\/p>/gi,"")).replace(/<li>·/gi,"<li>")).trim()).replace(/\/(p|ul|ol|h1|h2|h3|h4|h5|h6|blockquote)>\s+<(p|ul|ol|h1|h2|h3|h4|h5|h6|blockquote)/gi,"/$1>\n<$2")).split(/\n/),r=0;r<n.length;r++){var o=""!==n[r]&&-1===n[r].search(/>$/)?" ":"\n";t+=n[r]+o}return t=t.trim()},_parseWordLists:function(e){var t=0,n=null,r=null,o=null;e.find("p").each(function(e){var i=e.attr("data-listLevel");if(null===i&&e.hasClass("MsoListParagraphCxSpMiddle")&&(i=1),null!==i){var a=e.text(),s=/^\s*\w+\./.test(a)?"<ol></ol>":"<ul></ul>";if(e.hasClass("MsoListParagraphCxSpFirst")||e.hasClass("MsoNormal")?(r=this.dom(s),e.before(r)):i>t&&0!==t&&(o=this.dom(s),n.append(o),r=o),i<t)for(var l=t-i+1,c=0;c<l;c++)r=r.parent();e.find("span").first().unwrap(),n=this.dom("<li>"+e.html().trim()+"</li>"),null===r&&(e.before(s),r=e.prev()),r.append(n),e.remove(),t=i}else r=null,t=0}.bind(this))}}),l.add("module","tidy",{init:function(){},parse:function(e){e=this.app.content.encodeAttrSings(e);var t=["li"],n=["li"];this.lineBefore=new RegExp("^<(/?"+t.join("|/?")+"|"+n.join("|")+")[ >]"),this.lineAfter=new RegExp("^<(/?"+t.join("|/?")+"|/"+n.join("|/")+")[ >]"),this.newLevel=new RegExp("^</?("+["p","ul","ol","li","div","h1","h2","h3","h4","h5","h6","blockquote","figure","figcaption","table","thead","tbody","tfoot","tr","td","th","dl","dt","dd"].join("|")+")[ >]");var r=0,o=e.length,i=0,a=null,s=null,l="",c="",u="";for(this.cleanlevel=0;r<o;r++){if(i=r,-1===e.substr(r).indexOf("<"))return c+=e.substr(r),this.finish(c);for(;i<o&&"<"!==e.charAt(i);)i++;for(r!==i&&((u=e.substr(r,i-r)).match(/^\s{2,}$/g)||("\n"===c.charAt(c.length-1)?c+=this.getTabs():"\n"===u.charAt(0)&&(c+="\n"+this.getTabs(),u=u.replace(/^\s+/,"")),c+=u)),a=i;i<o&&">"!==e.charAt(i);)i++;var d;if(r=i,"!--"===(l=e.substr(a,i-a)).substr(1,3)){if(!l.match(/--$/)){for(;"--\x3e"!==e.substr(i,3);)i++;i+=2,l=e.substr(a,i-a),r=i}"\n"!==c.charAt(c.length-1)&&(c+="\n"),c+=this.getTabs(),c+=l+">\n"}else"!"===l[1]?c=this.placeTag(l+">",c):"?"===l[1]?c+=l+">\n":d===l.match(/^<(script|style|pre)/i)?(d[1]=d[1].toLowerCase(),l=this.cleanTag(l),c=this.placeTag(l,c),(s=String(e.substr(r+1)).toLowerCase().indexOf("</"+d[1]))&&(u=e.substr(r+1,s),r+=s,c+=u)):(l=this.cleanTag(l),c=this.placeTag(l,c))}return this.finish(c)},getTabs:function(){for(var e="",t=0;t<this.cleanlevel;t++)e+="    ";return e},finish:function(e){return e=(e=(e=(e=(e=(e=(e=e.replace(/\n\s*\n/g,"\n")).replace(/^[\s\n]*/,"")).replace(/[\s\n]*$/,"")).replace(/<li(.*?)>[\s\n]*/gi,"<li$1>")).replace(/<(p|h1|h2|h3|h4|h5|h6|li|td|th)(.*?)>[\s\n]*<\/\1>/gi,"<$1$2></$1>")).replace(/[\s\n]*<\/li>/gi,"</li>")).replace(/<script(.*?)>\n<\/script>/gi,"<script$1><\/script>"),e=this.app.content.decodeAttrSings(e),this.cleanlevel=0,e},cleanTag:function(e){var t,n="",r="";for((e=(e=(e=e.replace(/\n/g," ")).replace(/\s{2,}/g," ")).replace(/^\s+|\s+$/g," ")).match(/\/$/)&&(r="/",e=e.replace(/\/+$/,""));t=/\s*([^= ]+)(?:=((['"']).*?\3|[^ ]+))?/.exec(e);)t[2]?n+=t[1].toLowerCase()+"="+t[2]:t[1]&&(n+=t[1].toLowerCase()),n+=" ",e=e.substr(t[0].length);return n.replace(/\s*$/,"")+r+">"},placeTag:function(e,t){var n=e.match(this.newLevel);return(e.match(this.lineBefore)||n)&&(t=t.replace(/\s*$/,""),t+="\n"),n&&"/"===e.charAt(1)&&this.cleanlevel--,"\n"===t.charAt(t.length-1)&&(t+=this.getTabs()),n&&"/"!==e.charAt(1)&&this.cleanlevel++,t+=e,(e.match(this.lineAfter)||e.match(this.newLevel))&&(t=t.replace(/ *$/,""),t+="\n"),t}}),l.add("module","source",{start:function(){this.eventname=this.prefix+"-source-events",this._build()},toggle:function(){this.is()?this.close():this.open()},is:function(){return"none"!==this.app.container.get("source").css("display")},open:function(){this.app.broadcast("source.before.open");var e=this.app.editor.getContent();e=this.app.tidy.parse(e);var t=this.app.container.get("editor").height();this.$source.height(t),this.$source.val(e),this.$source.on("focus."+this.eventname,this._handleFocus.bind(this)),this.$source.on("input."+this.eventname,this._handleChanges.bind(this)),this.$source.on("keydown."+this.eventname,this.app.input.handleTextareaTab.bind(this)),this.app.editor.unselectAll(),this.app.container.get("editor").hide(),this.app.container.get("source").show();var n=this.app.codemirror.create({el:this.$source,height:t,focus:!0});n&&(n.on("change",this._handleChanges.bind(this)),n.on("focus",this._handleFocus.bind(this))),this.app.editor.disableUI(),this.app.toolbar.setToggled("html"),this.app.broadcast("source.open")},close:function(){this.app.broadcast("source.before.close");var e=this.getContent();this.app.codemirror.destroy(),this.$source.off("."+this.eventname),this.app.container.get("source").hide(),this.app.container.get("editor").show(),this.app.editor.setContent({html:e,caret:"start"}),this.app.editor.enableUI(),this.app.toolbar.unsetToggled("html"),this.app.broadcast("source.close")},update:function(e){var t=this.app.editor.isTextarea()?"val":"html";this.app.$element[t](e)},getContent:function(){var e=this.$source.val();return e=this.app.codemirror.val(e)},_build:function(){this.opts.source&&(this.$source=this.dom("<textarea>").addClass(this.prefix+"-source"),this.$source.attr("data-gramm_editor",!1),this.app.container.get("source").append(this.$source))},_handleFocus:function(){this.app.editor.setFocus()},_handleChanges:function(e){var t=this.getContent();this.update(t),this.app.broadcast("source.change",{e})}}),l.add("module","content",{init:function(){this._selectors={code:["pre","code"],embed:["figure"],noneditable:["."+this.opts.noneditable.classname],images:["img"],links:["a"]}},paragraphize:function(e){return this.app.paragraphizer.paragraphize(e)},encodeEntities:function(e){return this.decodeEntities(e).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;")},encodeCode:function(e){return e=(e=(e=(e=(e=(e=(e=(e=this.encodeAttrSings(e)).replace(/<\s/gi,"&lt; ")).replace(/<([^>]+)</gi,"&lt;$1<")).replace(/<(.*?)>/gi,"xtagstartz$1xtagendz")).replace(/xtagstartzpre(.*?)xtagendz/g,"<pre$1>")).replace(/xtagstartzcode(.*?)xtagendz/g,"<code$1>")).replace(/xtagstartz\/codextagendz/g,"</code>")).replace(/xtagstartz\/prextagendz/g,"</pre>"),e=(e=(e=this._encodeCode(e)).replace(/xtagstartz([\w\W]*?)xtagendz/g,"<$1>")).replace(/xtagstartz\/(.*?)xtagendz/g,"</$1>"),e=this.decodeAttrSings(e)},encodeAttrSings:function(e){var t=e.match(/="(.*?)"/g);if(null!==t)for(var n=0;n<t.length;n++)if(-1===t[n].search(/^"</)&&-1===t[n].search(/>"$/)){var r=t[n].replace(">","xmoresignz");r=r.replace("<","xlesssignz"),e=e.replace(t[n],r)}return e},decodeAttrSings:function(e){return e=(e=e.replace(/xmoresignz/gi,">")).replace(/xlesssignz/gi,"<")},decodeEntities:function(e){return String(e).replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&quot;/g,'"').replace(/&amp;/g,"&")},decodeHref:function(e){var t=e.match(new RegExp('(href=".*?)(&amp;)(.*?">)',"g"));if(null!==t)for(var n=0;n<t.length;n++)e=e.replace(t[n],t[n].replace(/&amp;/g,"&"));return e},sanitize:function(e){return e=this.app.utils.wrap(e,function(e){e.find("[src]").each(this._sanitizeSrc),e.find("a").each(this._sanitizeHref),e.find("a,b,i,strong,em,svg,img,details,audio").each(this._sanitizeEvents)}.bind(this))},escapeHtml:function(e){return e.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#039;")},store:function(e,t,n,r){for(var o=this._selectors[t],i=0;i<o.length;i++){var a=this._getElementsFromHtml(e,o[i]);e=this._store(e,t,a,n,r)}return e},restore:function(e,t,n){if(void 0===n[t])return e;for(var r=0;r<n[t].length;r++)e=e.replace("####_"+t+r+"_####",n[t][r]);return e},storeComments:function(e,t){var n=e.match(new RegExp("\x3c!--([\\w\\W]*?)--\x3e","gi"));if(null===n)return e;for(var r=0;r<n.length;r++)e=e.replace(n[r],"#####xstarthtmlcommentzz"+r+"xendhtmlcommentzz#####"),t.push(n[r]);return e},restoreComments:function(e,t){for(var n=0;n<t.length;n++){var r=t[n].replace(/\$/gi,"&#36;");e=e.replace("#####xstarthtmlcommentzz"+n+"xendhtmlcommentzz#####",r)}return e},cacheStyle:function(e){var t=this.opts.tags.block.join(",")+",img,"+this.opts.tags.inline.join(",");return this.app.utils.wrap(e,function(e){e.find(t).each(this._cacheStyle.bind(this))}.bind(this))},recacheStyle:function(e){return this.app.utils.wrap(e,function(e){e.find("[data-"+this.prefix+"-style-cache]").each(this._recacheStyle.bind(this))}.bind(this))},fixListMargin:function(e){var t=parseInt(e.css("margin-left"));if(0!==t){var n=parseInt(e.css("padding-left"));e.css({"margin-left":0,"padding-left":n+t+"px"}),e.attr(this.prefix+"-list-left",t)}},unfixListMargin:function(e){e.attr(this.prefix+"-list-left")&&(e.css({"padding-left":"","margin-left":""}),e.removeAttr(this.prefix+"-list-left"))},addNofollow:function(e){return this.opts.link.nofollow?this.app.utils.wrap(e,(function(e){e.find("a").attr("rel","nofollow")})):e},addHttps:function(e){return this.opts.editor.https?e=(e=(e=e.replace('href="http://','href="https://')).replace('src="http://','src="https://')).replace('srcset="http://','srcset="https://'):e},addSpaceToBlocks:function(e){return e.replace(/<\/(div|li|dt|dd|td|p|H[1-6])>\n?/gi,"</$1> ")},addBrToBlocks:function(e){return e.replace(/<\/(div|li|dt|dd|td|p|H[1-6])>\n?/gi,"</$1><br>")},addPredefinedTagClass:function(e){var t=e.get().tagName.toLowerCase(),n=void 0!==this.opts.classes.tags?this.opts.classes.tags:this.opts.classes;void 0!==n[t]&&e.addClass(n[t])},addPredefinedBlockClass:function(e){var t=e.attr("data-"+this.prefix+"-type"),n=this.opts.classes.blocks;void 0!==n[t]&&e.addClass(n[t])},getPredefinedBlocks:function(){var e=[];return Object.keys(this.opts.classes.blocks).forEach((function(t){e.push(t)})),e},getPredefinedTags:function(){var e=[],t=void 0!==this.opts.classes.tags?this.opts.classes.tags:this.opts.classes;return Object.keys(t).forEach((function(t){e.push(t)})),e},getText:function(e){var t="";if(3===e.nodeType)t=e.nodeValue;else{for(var n=0;n<e.childNodes.length;n++)t+=this.getText(e.childNodes[n]);var r=1===e.nodeType?getComputedStyle(e).getPropertyValue("display"):"";(r.match(/^block/)||r.match(/list/)||"BR"===e.tagName||"HR"===e.tagName)&&(t+="\n")}return t},getTextFromHtml:function(e,t){var n={};t=u.extend({},{br:!1,nl:!1,trimlines:!0,images:!1,links:!1},t),e=this.store(e,"code",n,0),e=t.links?this.store(e,"links",n,0):e,e=(e=(e=(e=(e=(e=(e=(e=(e=t.images?this.store(e,"images",n,0):e).replace(/<(ul|ol)>\s+<li>/gi,"<$1><li>")).replace(/<li[^>]*>\n/gi,"<li$1>")).replace(/<p[^>]*>(\s+|)<\/p>/gi,"xemptyz")).replace(/<!--[\s\S]*?-->/gi,"")).replace(/<style[\s\S]*?style>/gi,"")).replace(/<script[\s\S]*?script>/gi,"")).replace(/<\/(div|li|dt|dd|td|p|H[1-6])>\n?/gi,"</$1>\n")).replace(/&(lt|gt);/gi,"x$1z");var r=this.dom("<div>").html(e);if(e=this.getText(r.get()),t.trimlines){for(var o="",i=e.split("\n"),a=0;a<i.length;a++)o+=i[a].trim()+"\n";e=o}return e=(e=(e=e.replace(/[\n]+/g,"\n")).replace("xemptyz","\n")).replace(/x(lt|gt)z/gi,"&$1;"),e=t.br?(e=e.replace(/\n/g,"<br>\n")).replace(/<br\s?\/?>\n?$/gi,""):t.nl?e:e.replace(/\n/gi," "),e=this.restore(e,"code",n),e=t.links?this.restore(e,"links",n):e,e=(e=(e=(e=(e=t.images?this.restore(e,"images",n):e).replace(/<pre[^>]*>/g,"")).replace(/<code[^>]*>/g,"")).replace(/<\/pre>\n?/g,"")).replace(/<\/code>/g,""),t.images||(e=(e=e.replace(/<img[\s\S]*?>/gi,"")).replace(/<a[^>]*>(\s+|)<\/a>/gi,"")),e.trim()},extractHtmlFromCaret:function(e){var t=this.dom(e).get(),n=this.app.selection.getRange();if(n){var r=n.cloneRange();return r.selectNodeContents(t),r.setStart(n.endContainer,n.endOffset),r.extractContents()}},isEmptyHtml:function(e,t){return e=e.trim(),e=(e=(e=(e=(e=(e=(e=(e=(e=this.app.utils.removeInvisibleChars(e)).replace(/^&nbsp;$/gi,"1")).replace(/&nbsp;/gi,"")).replace(/<\/?br\s?\/?>/g,"")).replace(/\s/g,"")).replace(/^<p>\s\S<\/p>$/i,"")).replace(/<hr(.*?[^>])>$/i,"hr")).replace(/<iframe(.*?[^>])>$/i,"iframe")).replace(/<source(.*?[^>])>$/i,"source"),e=this.removeComments(e),""===(e=(e=(e=(e=t?e.replace(/<p[^>]*><\/p>/gi,""):e).replace(/<[^/>]><\/[^>]+>/gi,"")).replace(/<[^/>]><\/[^>]+>/gi,"")).trim())},isLine:function(e){var t=document.createElement("div");return t.innerHTML=e,0===this.dom(t).find(this.opts.tags.block.join(",")+",img").length},removeDoctype:function(e){return e.replace(new RegExp("<!doctype[^>]*>","gi"),"")},removeComments:function(e){return e.replace(/<!--[\s\S]*?-->\n?/g,"")},removeTags:function(e,t){var n=t?/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi:/(<([^>]+)>)/gi,r=t?function(e,n){return-1===t.indexOf(n.toLowerCase())?e:""}:"";return e.replace(n,r)},removeTagsExcept:function(e,t){if(void 0===t)return e.replace(/(<([^>]+)>)/gi,"");return e.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi,(function(e,n){return-1===t.indexOf(n.toLowerCase())?"":e}))},removeTagsWithContent:function(e,t){return this.app.utils.wrap(e,(function(e){e.find(t.join(",")).remove()}))},removeMarkers:function(e){return this.app.utils.wrap(e,function(e){e.find("."+this.prefix+"-plus-button").remove(),e.find("."+this.prefix+"pastemarker").removeClass(this.prefix+"pastemarker"),e.find("."+this.prefix+"pasteitems").removeClass(this.prefix+"pasteitems"),e.find("."+this.prefix+"-selection-marker").remove()}.bind(this))},removeEmptySpans:function(e){return this.app.utils.wrap(e,function(e){e.find("span").each(this._removeEmptySpan.bind(this))}.bind(this))},removeEmptyInlines:function(e){return this.app.utils.wrap(e,function(e){e.find(this.opts.tags.inline.join(",")).each(this._removeEmptyTag.bind(this))}.bind(this))},removeEmptyAttrs:function(e,t){return this.app.utils.wrap(e,(function(e){for(var n=0;n<t.length;n++)e.find("["+t[n]+'=""]').removeAttr(t[n])}))},removeBlockTags:function(e,t,n){var r=this.opts.tags.block.concat();return n&&(r=this.app.utils.removeFromArrayByValue(r,n)),t&&(t=t?this.app.utils.extendArray(r,t):r),this.removeTags(e,t)},removeBlockTagsInside:function(e,t){return this.blockListTags=this.app.utils.removeFromArrayByValue(this.opts.tags.block.concat(),["ul","ol","li"]),this.app.utils.wrap(e,function(e){e.find(t.join(",")).each(this._removeBlockTagsInside.bind(this))}.bind(this))},removeInlineStyles:function(e){var t=this.app.utils.removeFromArrayByValue(this.opts.tags.inline,"a");return this.app.utils.wrap(e,(function(e){e.find(t.join(",")).removeAttr("style")}))},removeStyleAttr:function(e,t){return t=t||"",this.app.utils.wrap(e,function(e){e.find("*").not("[data-"+this.prefix+"-style-cache]"+t).removeAttr("style")}.bind(this))},_cacheStyle:function(e){var t="data-"+this.prefix+"-style-cache",n=e.attr("style");n?(n=n.replace(/"/g,""),e.attr(t,n)):n&&""!==n||e.removeAttr(t)},_recacheStyle:function(e){var t="data-"+this.prefix+"-style-cache",n=e.attr(t);e.attr("style",n).removeAttr(t)},_cleanEmpty:function(e){return e=e.trim(),e=(e=(e=this.app.utils.removeInvisibleChars(e)).replace(/<\/?br\s?\/?>/g,"")).replace(/\s/g,"")},_removeEmptySpan:function(e){0===e.get().attributes.length&&e.unwrap()},_removeEmptyTag:function(e){var t=e.html().trim();0===e.get().attributes.length&&""===t&&e.unwrap()},_removeBlockTagsInside:function(e){var t="LI"===e.get().tagName?this.blockListTags:this.opts.tags.block;e.find(t.join(",")).append("<br>").unwrap()},_store:function(e,t,n,r,o){if(!n)return e;void 0===r[t]&&(r[t]=[]);for(var i=0;i<n.length;i++)r[t][o]=n[i],e=e.replace(n[i],"####_"+t+o+"_####"),o++;return e},_getElementsFromHtml:function(e,t){var n=[];return this.dom("<div>").html(e).find(t).each((function(e){n.push(e.get().outerHTML)})),n},_sanitizeSrc:function(e){var t=e.get(),n=t.getAttribute("src");(-1!==n.search(/^javascript:/i)||"IMG"!==t.tagName&&-1!==n.search(/^data:/i))&&t.setAttribute("src","")},_sanitizeHref:function(e){var t=e.get(),n=t.getAttribute("href");n&&-1!==n.search(/^javascript:/i)&&t.setAttribute("href","")},_sanitizeEvents:function(e){e.removeAttr("onload onerror ontoggle onwheel onmouseover oncopy")},_encodeCode:function(e){return this.app.utils.wrap(e,function(e){e.find("pre code, pre, code").each(this._encodeNode.bind(this))}.bind(this))},_encodeNode:function(e){var t=e.get(),n=t.firstChild,r=t.innerHTML;if("PRE"!==t.tagName||!n||"CODE"!==n.tagName){r=(r=r.replace(/xtagstartz/g,"<")).replace(/xtagendz/g,">");var o=this.decodeEntities(r);t.textContent=this._encodeNodeHtml(o)}},_encodeNodeHtml:function(e){return e=e.replace(/&nbsp;/g," ").replace(/<br\s?\/?>/g,"\n"),e=this.opts.code.spaces?e.replace(/\t/g,new Array(this.opts.code.spaces+1).join(" ")):e}}),l.add("module","autoparse",{parse:function(e){if(!this.opts.paste.autoparse)return e;var t=this.app.block.get(),n=[];e=this.app.content.storeComments(e,n),e=this.app.content.removeDoctype(e);var r,o=["figure","html","form","pre","div","span","video","object","iframe","code","a","img","link","script"],i=["div","img","html","span"],a=[],s=0;for(r=0;r<o.length;r++){var l=-1!==i.indexOf(o[r])?"<"+o[r]+"[^>]*>":"<"+o[r]+"[^>]*>([\\w\\W]*?)</"+o[r]+">",c=e.match(new RegExp(l,"gi"));if(null!==c)for(var u=0;u<c.length;u++)e=e.replace(c[u],"#####replaceparse"+s+"#####"),a.push(c[u]),s++}if(!(e=e.replace("&amp;","&")).match(this.opts.regex.aurl1)&&!e.match(this.opts.regex.aurl2)||e.match(this.opts.regex.imageurl)||(e=this._formatLinks(e)),e.match(this.opts.regex.imageurl)){var d=e.match(this.opts.regex.imageurl);for(r=0;r<d.length;r++)e=e.replace(d[r],this._splitBlock(t,'<img src="'+d[r]+'">'))}return e=this._restoreReplaced(a,e),e=this.app.content.restoreComments(e,n),e=this._restoreReplaced(a,e)},_splitBlock:function(e,t){return e?t="\n"+t+"\n":t},_formatLinks:function(e){var t=!1!==this.opts.paste.linkTarget?' target="'+this.opts.paste.linkTarget+'"':"",n=this.opts.editor.https?"https":"http",r=this;return e=(e=e.replace(this.opts.regex.aurl1,(function(e){return'<a href="'+e+'"'+t+">"+r._subLinkText(e)+"</a>"}))).replace(this.opts.regex.aurl2,(function(e,o,i){return o+'<a href="'+n+"://"+i+'"'+t+">"+r._subLinkText(i)+"</a>"}))},_subLinkText:function(e){return e=-1===(e=e.length>this.opts.link.size?e.substring(0,this.opts.link.size)+"...":e).search("%")?decodeURIComponent(e):e},_restoreReplaced:function(e,t){for(var n=0;n<e.length;n++)t=t.replace("#####replaceparse"+n+"#####",e[n]);return t}}),l.add("module","caret",{set:function(e,t){var n=this.dom(e).get(),r=this.app.editor.getDocNode().createRange();n&&this._isInPage(n)&&(this.app.editor.setWinFocus(),this._isInline(n)&&this._isNon(n)&&("start"===t?t="before":"end"===t&&(t="after")),this[{start:"_setStart",end:"_setEnd",before:"_setBefore",after:"_setAfter"}[t]](r,n),this.app.selection.setRange(r))},is:function(e,t,n,r,o){var i=this.dom(e).get(),a=this.app.editor.getWinNode().getSelection(),s=!1;if(!i||!a.isCollapsed)return s;var l=this._getPosition(i,r,o),c=this._getSize(i,n,r);return"end"===t?s=l===c:"start"===t&&(s=0===l),s},_setStart:function(e,t){e.setStart(t,0),e.collapse(!0);var n=this._getInlineInside(t);n&&(e=this._setStartInline(e,n)),this._isInline(t)&&this._insertInvisibleNode(e)},_setStartInline:function(e,t){var n=this.app.element.getAllInlines(t)[0];e.selectNodeContents(n),e.collapse(!0)},_setEnd:function(e,t){var n=1===t.nodeType&&t.lastChild;n&&this._isInline(n)&&(t=n),e.selectNodeContents(t),e.collapse(!1)},_setBefore:function(e,t){e.setStartBefore(t),e.collapse(!0),this._isInline(t)&&this._insertInvisibleNode(e,t)},_setAfter:function(e,t){e.setStartAfter(t),e.collapse(!0);var n=3!==t.nodeType&&t.tagName.toLowerCase();(this._isInline(t)||"br"===n||"svg"===n)&&this._insertInvisibleNode(e)},_insertInvisibleNode:function(e,t){var n=this.app.utils.createInvisibleChar();return t?t.parentNode.insertBefore(n,t):e.insertNode(n),e.selectNodeContents(n),e.collapse(!1),n},_getInlineInside:function(e){var t=e.firstChild;if(this._isInline(t)){for(var n=t.firstChild;n;){if(this._isInline(n))return n;n=n.firstChild}return t}},_getSize:function(e,t,n){var r,o=3===e.nodeType;if(t&&0!==t.length){var i=this.dom(e).clone();i.find(t.join(",")).remove(),r=i.html().trim()}else r=o?e.textContent:e.innerHTML,r=o||!1===n?r:r.trim();return this._trimmed(r,o,n).length},_getPosition:function(e,t,n){var r=this.app.editor.getWinNode().getSelection().getRangeAt(0),o=r.cloneRange(),i=document.createElement("div"),a=3===e.nodeType;o.selectNodeContents(e),o.setEnd(r.endContainer,r.endOffset),i.appendChild(o.cloneContents());var s=a||!1===t?i.innerHTML:i.innerHTML.trim(),l=-1!==s.search(/<\/?br\s?\/?>$/g)?1:0;return!1===n&&(l=0),(s=this._trimmed(s,a,t)).length+l},_trimmed:function(e,t,n){return!1===n?e=e.replace(/\n$/g,""):(""===(e=(e=(e=this.app.utils.removeInvisibleChars(e)).replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi,"")).replace(/\s+/g," "))||t||(e=e.replace(/\s$/,"")),e)},_isInline:function(e){return this.app.element.is(e,"inline")},_isInPage:function(e){var t=!1,n=this.app.editor.getDocNode();return e&&e.nodeType&&(t=e!==n.body&&n.body.contains(e)),t},_isNon:function(e){return"false"===e.getAttribute("contenteditable")}}),l.add("module","selection",{init:function(){this.savedSelection=!1,this.savedMarker=!1,this.savedPosition=!1,this.savedRange=!1},get:function(){var e=this._getSelection(),t=this._getRange(e),n=this._getCurrent(e);return{selection:e,range:t,collapsed:this._getCollapsed(e,t),current:n,parent:this._getParent(n)}},getRange:function(){return this._getRange(this.get().selection)},getNodes:function(e){var t=this.get(),n=e&&(e.type&&"inline"===e.type||e.tags&&-1!==e.tags.indexOf("a")),r=n?"_getAllRangeNodes":"_getRangeNodes",o=[];return(o=this.app.editor.isAllSelected()?this.app.editor.getLayout().children().getAll():t.selection&&t.range?this[r](t.range):o).length>0?this._filterNodes(o,t.range,n,e):o},getCurrent:function(){var e=this._getSelection();return this._getCurrent(e)},getParent:function(){var e=this.getCurrent();return this._getParent(e)},getElement:function(e){return this._getElement(e,"element")},getInline:function(e){return this._getElement(e,"inline")},getTopInline:function(e){for(var t=e?this.dom(e).get():this.getCurrent(),n=[];t&&this._getElement(t,"inline");)n.push(t),t=t.parentNode;return n[n.length-1]},getDataBlock:function(e){var t=this._getSelection(),n=e||this._getCurrent(t);if(n)for(n=this.dom(n).get();n;){if(1===n.nodeType&&n.getAttribute("data-"+this.prefix+"-type"))return this.dom(n);n=n.parentNode}return this.dom()},getBlock:function(e){return this._getElement(e,"block")},getText:function(e,t){var n=this.get(),r=!1;if(!n.selection)return!1;if(e&&n.range){t=void 0===t?1:t;var o=this.app.editor.getLayout().get(),i=n.range.cloneRange();"before"===e?(i.collapse(!0),i.setStart(o,0),r=i.toString().slice(-t)):"after"===e&&(i.selectNodeContents(o),i.setStart(n.range.endContainer,n.range.endOffset),r=i.toString().slice(0,t))}else r=n.selection?n.selection.toString():"";return r},getHtml:function(){var e="",t=this.get();if(t.selection){var n=t.range.cloneContents(),r=document.createElement("div");r.appendChild(n),e=(e=r.innerHTML).replace(/<p><\/p>$/i,"")}return e},getPosition:function(){var e=this.getRange(),t={top:0,left:0,width:0,height:0};if(this.app.editor.getWinNode().getSelection&&e.getBoundingClientRect){var n=(e=e.cloneRange()).startOffset-1;e.setStart(e.startContainer,n<0?0:n);var r=e.getBoundingClientRect();t={top:r.top,bottom:r.bottom,left:r.left,width:r.right-r.left,height:r.bottom-r.top}}return t},set:function(e,t){e&&(e.removeAllRanges(),e.addRange(t))},setRange:function(e){this.set(this.app.editor.getWinNode().getSelection(),e)},is:function(e){if(void 0===e)return this.get().selection;for(var t=this.dom(e).get(),n=this.getNodes(),r=0;r<n.length;r++)if(n[r]===t)return!0;return!1},isCollapsed:function(){var e=this.get();return this._getCollapsed(e.selection,e.range)},isIn:function(e){var t=this.dom(e).get(),n=this.getCurrent();return!(!n||!t)&&t.contains(n)},isAll:function(e){var t=!e,n=e?this.dom(e).get():this.app.editor.getLayout().get(),r=this.app.editor.getWinNode().getSelection(),o=this._getRange(r),i=!!t||this.is(n);return!r.isCollapsed&&(!!i&&(void 0!==n.textContent&&n.textContent.trim().length===o.toString().trim().length))},select:function(e){var t=e?this.dom(e).get():this.app.editor.getLayout().get(),n=this.app.editor.getDocNode().createRange();n.selectNodeContents(t),this.setRange(n)},removeAllRanges:function(){var e=this._getSelection();e&&e.removeAllRanges()},deleteContents:function(){var e=this.getRange();!this.isCollapsed()&&e&&e.deleteContents()},collapse:function(e){e=e||"start";var t=this.get();t.selection&&!t.collapsed&&("start"===e?t.selection.collapseToStart():t.selection.collapseToEnd())},save:function(e){if(!e){var t=this.app.block.get();e=t?t.getBlock():this.app.editor.getLayout()}this.savedSelection={el:e,offset:this.app.offset.get(e)}},restore:function(e){if(!this.savedMarker&&this.savedSelection){this.app.editor.setWinFocus();var t=this.savedSelection.el;this.dom(t).dataget("instance")&&!1!==e&&this.app.block.set(t),t&&(t.focus(),this.app.offset.set(t,this.savedSelection.offset)),this.savedSelection=!1}},saveMarker:function(){this.savedMarker=!0,this.app.marker.insert()},restoreMarker:function(){this.app.marker.restore(),this.savedMarker=!1,this.savedSelection=!1},_getSelection:function(){return this.app.editor.getSelection()},_getRange:function(e){return!!e&&(e.rangeCount>0&&e.getRangeAt(0))},_getCurrent:function(e){return!!e&&e.anchorNode},_getParent:function(e){return!!e&&e.parentNode},_getElement:function(e,t){var n=this._getSelection();if(n){var r=e||this._getCurrent(n);for(r=this.dom(r).get();r;){if(this.app.element.is(r,t))return r;r=r.parentNode}}return!1},_getCollapsed:function(e,t){var n=!1;return(e&&e.isCollapsed||t&&0===t.toString().length)&&(n=!0),n},_getNextNode:function(e){if(e.firstChild)return e.firstChild;for(;e;){if(e.nextSibling)return e.nextSibling;e=e.parentNode}},_getRangeNodes:function(e,t){var n,r=e.startContainer.childNodes[e.startOffset]||e.startContainer,o=e.endContainer.childNodes[e.endOffset]||e.endContainer,i=e.commonAncestorContainer,a=[];if(t){for(this.app.editor.isLayout(r)||a.push(r),n=r.parentNode;n&&!this.app.editor.isLayout(n)&&(a.push(n),n!==i);n=n.parentNode);for(a.reverse(),n=r;n&&(3===n.nodeType||0!==this.dom(n.parentNode).closest(i).length)&&(a.push(n),n!==o);n=this._getNextNode(n));}else for(3===r.nodeType&&a.push(this.getBlock(r)),n=r;n&&n!==i&&(3===n.nodeType||0!==this.dom(n.parentNode).closest(i).length)&&(a.push(n),n!==o);n=this._getNextNode(n));return a},_getAllRangeNodes:function(e){return this._getRangeNodes(e,!0)},_filterNodes:function(e,t,n,r){var o=this.getText();o=o?o.replace(/[-[\]/{}()*+?.\\^$|]/g,"\\$&"):"";for(var i=[],a=0;a<e.length;a++){var s=!0;this.app.editor.isLayout(e[a])&&(s=!1),r&&(s=r.types?this._filterByTypes(s,r,e[a]):s,s=r.selected?this._filterBySelected(s,r,e[a],t,o):s,s=r.type?this._filterByType(s,r,e[a],n):s,s=r.tags?this._filterByTags(s,r,e[a]):s),s&&i.push(e[a])}var l=[];if(r&&("blocks"===r.type||"blocks-first"===r.type)){for(var c=0;c<i.length;c++){var u;"blocks-first"===r.type?u=this.app.element.is(i[c],"blocks-first")?i[c]:this.app.element.getFirstLevel(i[c]).get():"blocks"===r.type&&(u=this.app.element.is(i[c],"blocks")?i[c]:this.app.element.getDataBlock(i[c]).get()),this._isInNodesArray(l,u)||l.push(u)}i=l}return i},_filterByTypes:function(e,t,n){var r;return!0===t.types?(r=this.app.element.getType(n))||(e=!1):(r=this.app.element.getType(n),-1===t.types.indexOf(r)&&(e=!1)),e},_filterByType:function(e,t,n,r){var o=t.type;return"blocks"!==o&&"blocks-first"!==o||(o="block"),r?t.links?this.app.element.is(n,o)||(e=!1):(1===n.nodeType&&"A"===n.tagName||!this.app.element.is(n,o))&&(e=!1):this.app.element.is(n,o)||(e=!1),e},_filterByTags:function(e,t,n){var r=void 0!==n.tagName;return r?r&&-1===t.tags.indexOf(n.tagName.toLowerCase())&&(e=!1):e=!1,e},_filterBySelected:function(e,t,n,r,o){return!0!==t.selected||this._containsNodeText(r,n)?"inside"===t.selected&&(1===n.nodeType&&"A"===n.tagName?e=!0:this._isTextSelected(n,o)||(e=!1)):e=!1,e},_isTextSelected:function(e,t){var n=9!==e.nodeType?this.app.utils.removeInvisibleChars(e.textContent):"";return t===n||-1!==n.search(t)||-1!==t.search(new RegExp("^"+this.app.utils.escapeRegExp(n)+"$"))},_isBackwards:function(){var e=!1,t=this.get();if(t&&!t.collapsed){var n=this.app.editor.getDocNode().createRange();n.setStart(t.selection.anchorNode,t.selection.anchorOffset),n.setEnd(t.selection.focusNode,t.selection.focusOffset),e=n.collapsed,n.detach()}return e},_containsNodeText:function(e,t){for(var n,r,o,i=this.app.editor.getDocNode().createTreeWalker(t,NodeFilter.SHOW_TEXT,{acceptNode:function(e){return NodeFilter.FILTER_ACCEPT}},!1);o=i.nextNode();)n||(n=o),r=o;var a=e.cloneRange();return n?(a.setStart(n,0),a.setEnd(r,r.length)):a.selectNodeContents(t),e.compareBoundaryPoints(Range.START_TO_START,a)<1&&e.compareBoundaryPoints(Range.END_TO_END,a)>-1},_isInNodesArray:function(e,t){return-1!==e.indexOf(t)}}),l.add("module","inline",{removeFormat:function(){this.app.popup.close();var e=this.app.block.get().getBlock();this.app.selection.save(e);for(var t=this.app.selection.getNodes({type:"inline"}),n=0;n<t.length;n++){var r=this.dom(t[n]);r.attr("data-"+this.prefix+"-type")||r.unwrap()}this.app.selection.restore(),this.app.editor.observeUI()},set:function(e){this.app.popup.isOpen()&&this.app.popup.close(),this.params=e;var t=[];return t=this.app.selection.get().collapsed?this.formatCollapsed():this.formatUncollapsed(),this.app.editor.observeUI(),this.app.broadcast("inline.format",{nodes:t}),this.app.sync.trigger(),t},formatCollapsed:function(){var e,t=this.app.selection.getInline(),n=this.dom(t),r=this._getParamsTags(),o=this._isSameTag(t,r),i=!(!this.params||!this.params.caret)&&this.params.caret;if(t)if(this.app.content.isEmptyHtml(t.innerHTML))if(o)this.app.caret.set(t,i||"after"),n.remove();else{var a=this.app.element.replaceToTag(t,this.params.tag);this.app.caret.set(a,i||"start")}else if(o){var s=t;if(this.app.caret.is(t,"end"))i="after";else{var l=this.app.content.extractHtmlFromCaret(t),c=this.dom("<"+this.params.tag+" />");c=this.app.element.cloneAttrs(t,c),n.after(c.append(l)),s=c}this.app.caret.set(s,i||"before")}else e=this._insertInline(this.params.tag,i);else e=this._insertInline(this.params.tag,i);if(e&&this.params&&void 0!==this.params.attr){var u=this.dom(e);Object.keys(this.params.attr).forEach(function(e){u.attr(e,this.params.attr[e])}.bind(this))}return e||[]},formatUncollapsed:function(){var e=this.app.block.get(),t=this._getBlock(e);this.app.selection.save(),this._convertTags("u",e),this._convertTags("del",e),this.app.selection.restore();var n=this.app.selection.getNodes({type:"inline"});this.app.selection.save(),this._convertToStrike(n),this.app.selection.restore(),this.app.selection.save(),this.app.editor.getDocNode().execCommand("strikethrough");var r=this._revertToInlines(e);this.app.selection.restore();for(var o=[],i=this.app.selection.getText(),a=0;a<r.length;a++)this._isInSelection(r[a],i)&&o.push(r[a]);if(this._clearEmptyStyle(),this.params&&void 0!==this.params.attr)for(var s=0;s<o.length;s++)this._applyAttrs(o[s]);if(1===t.length&&t.get().normalize(),this.app.selection.save(),this._revertTags("u",e),this._revertTags("del",e),this.app.selection.restore(),this.params&&this.params.caret){var l=o[o.length-1];this.app.caret.set(l,this.params.caret)}return o},_applyAttrs:function(e){Object.keys(this.params.attr).forEach(function(t){e.setAttribute(t,this.params.attr[t])}.bind(this))},_clearEmptyStyle:function(){for(var e=this.app.selection.getNodes({type:"inline"}),t=0;t<e.length;t++){this._clearEmptyStyleAttr(e[t]);var n=e[t].childNodes;if(n)for(var r=0;r<n.length;r++)this._clearEmptyStyleAttr(n[r])}},_clearEmptyStyleAttr:function(e){3!==e.nodeType&&""===e.getAttribute("style")&&e.removeAttribute("style")},_isSameTag:function(e,t){return e&&-1!==t.indexOf(e.tagName.toLowerCase())},_isInSelection:function(e,t){var n=this.app.utils.removeInvisibleChars(e.textContent);return-1!==t.search(new RegExp(this.app.utils.escapeRegExp(n)))},_insertInline:function(e,t){return this.app.insertion.insertNode(document.createElement(e),t||"start")},_convertTags:function(e,t){this.params.tag!==e&&this._getBlock(t).find(e).each(function(t){this.app.element.replaceToTag(t,"span").addClass(this.prefix+"-convertable-"+e)}.bind(this))},_revertTags:function(e,t){this._getBlock(t).find("span."+this.prefix+"-convertable-"+e).each(function(t){var n=this.app.element.replaceToTag(t,e);n.removeClass(this.prefix+"-convertable-"+e),this.app.element.removeEmptyAttrs(n,["class"])&&n.removeAttr("class")}.bind(this))},_convertToStrike:function(e){for(var t=this._getParamsTags(),n=0;n<e.length;n++){var r=e[n],o=this.dom(r),i=e[n].tagName.toLowerCase();-1!==t.indexOf(i)&&this._replaceToStrike(o)}},_getParamsTags:function(){var e=[this.params.tag];return"b"===this.params.tag||"strong"===this.params.tag?e=["b","strong"]:"i"!==this.params.tag&&"em"!==this.params.tag||(e=["i","em"]),e},_replaceToStrike:function(e){e.replaceWith(function(){return this.dom("<strike>").append(e.html())}.bind(this))},_revertToInlines:function(e){var t=[];return this._getBlock(e).find("strike").each(function(e){var n=this.app.element.replaceToTag(e,this.params.tag);t.push(n.get())}.bind(this)),t},_getBlock:function(e){return this.app.editor.isBlocksSelection()?this.dom(this.app.blocks.getSelectedBlocks()):e.getBlock()}}),l.add("module","popup",{init:function(){this.stack=!1,this.stacks=[],this.name=!1,this.supername=!1,this.autoclose=!0,this.control=!1,this.saved=!1},start:function(){this._build(),this._buildDepth()},stop:function(){this._stopEvents(),this._stop()},stopStack:function(){this._stopEvents(),this.app.toolbar.unsetToggled(),this.$popup.removeAttr("data-"+this.prefix+"-popup-name"),this.$popup.removeClass("open")},isOpen:function(e){var t=this.$popup.hasClass("open");return e?this._getName()===e&&t:t},create:function(e,t){return this.isOpen(e)||(this._reset(),this.name=e,this.supername=e,this.stack=this._createStack(e,t)),this.stack},add:function(e,t){return this._createStack(e,t,!0)},setStack:function(e){this.stack=e,this.name=e.getName()},setData:function(e){this.stack.setData(e)},setFocus:function(e){this.stack.setFocus(e)},setWidth:function(e){this.stack.setWidth(e)},getName:function(){return this.name},getElement:function(){return this.$popup},getButton:function(){return this.button},getStack:function(e){return e?this.stacks[e]:this.stack},getBody:function(){return this.stack.getBody()},getItems:function(){return this.stack.getItems()},getFooter:function(){return this.stack.getFooter()},getFooterPrimary:function(){return this.stack.getFooterPrimary()},getTool:function(e){return this.stack.getTool(e)},getInput:function(e){return this.stack.getInput(e)},getFormItem:function(e){return this.stack.getFormItem(e)},getData:function(e){return this.stack.getData(e)},open:function(e){this.isOpen()?this.isOpen(this.supername)?(this.saved=!0,this.close(!1)):(this.saved=!0,this.close(!1),this._open(e,!1)):(this.saved=!1,this._open(e))},openStack:function(e){var t=this.getStack(e),n={};this.stack&&this.stack.isCollapsed()&&(n={collapse:!0},this.removeStack(this.stack)),t.open(n)},close:function(e,t){if(!1===this.autoclose)if(!0===e);else if(!t)return;this.isOpen()&&(e&&this._isPopupTarget(e)||(this._stopEvents(),this._resetToolbarToggledButton(),!1!==e&&!1===this.saved&&(this.app.scroll.save(),this.app.selection.restore(),this.app.scroll.restore()),this.$popup.hide(),this._closed()))},closeStacks:function(){for(var e in this.stacks)"object"==typeof this.stacks[e]&&this.stacks[e].close()},removeStack:function(e){var t=e.getName();delete this.stacks[t],this.$popup.find("[data-"+this.prefix+"-stack-name="+t+"]").remove()},updatePosition:function(e){this._buildPosition(e),this._buildHeight()},resize:function(){var e=this.$popup.attr("data-width"),t=this.app.editor.getWidth();if("100%"!==e&&parseInt(e)<t)return;this.$popup.css("width",t+"px")},_build:function(){this.$popup=this.dom("<div>").addClass(this.prefix+"-popup "+this.prefix+"-popup-"+this.uuid),this.$popup.hide(),this.$popup.attr("dir",this.opts.editor.direction),this.app.$body.append(this.$popup)},_buildDepth:function(){this.opts.bsmodal&&this.$popup.css("z-index",1061)},_buildButton:function(e){e&&(this.button=!!Object.prototype.hasOwnProperty.call(e,"button")&&e.button)},_buildControl:function(e){e&&(this.control=!!Object.prototype.hasOwnProperty.call(e,"control")&&e.control)},_buildName:function(){this.$popup.attr("data-"+this.prefix+"-popup-name",this.name),this.$popup.addClass(this.prefix+"-popup-"+this.name)},_buildHeader:function(){this.header=this.app.create("popup.header",this)},_buildHeight:function(){var e,t,n=this.app.scroll.getTarget(),r=this.$popup.offset();this.app.scroll.isTarget()?(t=r.top-n.offset().top,e=n.height()-parseInt(n.css("border-bottom-width"))):(t=r.top-n.scrollTop(),e=n.height());var o=e-t-10;this.$popup.css("max-height",o+"px")},_buildPosition:function(){var e;e=this._isButton()&&this.button.isControl()||this._isControl()?this._buildPositionControl():this._isButton()?this._buildPositionButton():this._buildPositionModal(),this.$popup.css({top:e.top-1+"px",left:e.left+"px"})},_buildPositionButton:function(){var e=this.app.editor.getRect(),t=this.button.getOffset(),n=this.button.getDimension(),r=this.$popup.width(),o={};return this._isToolbarButton()||this._isTopbarButton()?(o={top:t.top+n.height,left:t.left}).left+r>e.right&&(o.left=t.left+n.width-r):(o={top:t.top+e.top+n.height,left:t.left+e.left+n.width/2-r/2}).left+r>e.right&&(o.left=e.left+e.width-r),(o.left<e.left||o.left<0)&&(o.left=e.left),o},_buildPositionControl:function(){var e=this.app.block.get();e.isSecondLevel()&&(e=e.getFirstLevel());var t=e.getBlock().offset();return{top:t.top,left:t.left}},_buildPositionModal:function(){var e,t,n;if(this.opts.toolbar){var r=this.app.container.get("toolbar"),o=r.height();t=(e=r.offset()).top+o,n=e.left}else{var i=this.app.block.get();i.isSecondLevel()&&(i=i.getFirstLevel()),t=(e=i.getBlock().offset()).top,n=e.left}return{top:t,left:n}},_getName:function(){return this.$popup.attr("data-"+this.prefix+"-popup-name")},_setToolbarToggledButton:function(){if(this.app.toolbar.unsetToggled(),this._isToolbarButton()){var e=this.button.getName();this.app.toolbar.setToggled(e)}},_createStack:function(e,t,n){Object.prototype.hasOwnProperty.call(t,"collapse")&&!1===t.collapse&&(n=!1),Object.prototype.hasOwnProperty.call(t,"autoclose")&&(this.autoclose=t.autoclose);var r=this.app.create("popup.stack",e,t,n,this);return this.stacks[e]=r,r},_open:function(e,t){this._buildButton(e),this._buildControl(e),this._buildName(),this._buildHeader(),this.app.broadcast("popup.before.open").isStopped()?this.stopStack():(this._setToolbarToggledButton(),this._startEvents(),!1!==t&&this.app.editor.isPopupSelection()&&this.app.selection.save(),this.stack=this._findActiveStack(),this.stack.open(e,!1,!1),this._buildPosition(),!1===t?(this.$popup.show(),this._opened()):this.$popup.fadeIn(100,this._opened.bind(this)))},_opened:function(){this._buildHeight(),this.$popup.addClass("open"),this.app.broadcast("popup.open"),this.stack.renderFocus()},_closed:function(){var e="data-"+this.prefix+"-popup-name",t=this.$popup.attr(e);this.$popup.removeAttr(e),this.$popup.removeClass("open "+this.prefix+"-popup-"+t),this.saved=!1,this.app.broadcast("popup.close")},_isPopupTarget:function(e){return 0!==this.dom(e.target).closest("."+this.prefix+"-popup").length},_isButton:function(){return this.button},_isControl:function(){return this.control},_isToolbarButton:function(){return this.button&&("toolbar"===this.button.type||"context"===this.button.type)},_isTopbarButton:function(){return this.button&&"topbar"===this.button.type},_findActiveStack:function(){for(var e in this.stacks)"object"==typeof this.stacks[e]&&this.stacks[e].isActive()&&(this.stack=this.stacks[e]);return this.stack},_reset:function(){this.button=!1,this.control=!1,this.autoclose=!0,this.stack=!1,this.stacks=[],this.$popup.html(""),this.$popup.removeClass("has-footer has-items has-form")},_resetToolbarToggledButton:function(){if(this.button){var e=this.button.getName();this.app.toolbar.unsetToggled(e)}},_startEvents:function(){var e=this.prefix+"-popup";this.app.scroll.getTarget().on("resize."+e+" scroll."+e,this.updatePosition.bind(this))},_stopEvents:function(){this.app.scroll.getTarget().off("."+this.prefix+"-popup")},_stop:function(){this.$popup&&this.$popup.remove()}}),l.add("class","popup.item",{defaults:{container:!1,title:!1,html:!1,toggle:!0,active:!1,divider:!1,remover:!1,classname:!1,params:!1,instance:!1,observer:!1,command:!1},init:function(e,t,n){this.popup=e,this.name=t,this.params=this._buildParams(n),this._build(),this._buildContainer(),this._buildIcon(),this._buildTitle(),this._buildImage(),this._buildShortcut(),this._buildActive(),this._buildHidden(),this._buildDivider(),this._buildCommand(),this._buildRemover()},getPopup:function(){return this.popup},getName:function(){return this.name},getParams:function(){return this.params.params},getElement:function(){return this.$item},getInstance:function(){return this.params.instance},isControl:function(){return this.params.control},_build:function(){this.$item=this.params.html?this.dom(this.params.html):this.dom("<div>"),this.$item.addClass(this.prefix+"-popup-item "+this.prefix+"-popup-stack-item"),this.$item.attr({"data-name":this.name})},_buildContainer:function(){this.params.container&&this.$item.addClass(this.prefix+"-popup-item-container")},_buildTitle:function(){this.params.title&&(this.$title=this.dom("<span>").addClass(this.prefix+"-popup-item-title"),this.$title.html(this.lang.parse(this.params.title)),this.$item.append(this.$title))},_buildImage:function(){this.params.image&&(this.$image=this.dom("<span>").addClass(this.prefix+"-popup-item-image"),this.$image.html(this.params.image),this.$item.append(this.$image))},_buildIcon:function(){this.params.icon&&(this.$icon=this.dom("<span>").addClass(this.prefix+"-popup-item-icon"),this.opts.buttons.icons&&void 0!==this.opts.buttons.icons[this.name]?this.$icon.html(this.opts.buttons.icons[this.name]):!0===this.params.icon?this.$icon.addClass(this.prefix+"-icon-"+this.name):-1!==this.params.icon.search(/</)?this.$icon.html(this.params.icon):this.$icon.addClass(this.prefix+"-icon-"+this.params.icon),this.$item.append(this.$icon))},_buildShortcut:function(){if(this.params.shortcut){var e=/(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)?"<b>&#8984;</b>":"ctrl";e=this.params.shortcut.replace("Ctrl",e),this.$shortcut=this.dom("<span>").addClass(this.prefix+"-popup-item-shortcut"),this.$shortcut.html(e),this.$item.append(this.$shortcut)}},_buildParams:function(e){return u.extend({},!0,this.defaults,e)},_buildActive:function(){this.params.active&&this.$item.addClass("active")},_buildHidden:function(){this.params.hidden&&this.$item.addClass(this.prefix+"-popup-item-hidden")},_buildDivider:function(){this.params.divider&&this.$item.addClass(this.prefix+"-popup-item-divider-"+this.params.divider)},_buildCommand:function(){this.params.command&&(this.$item.on("click."+this.prefix+"-popup-item-"+this.uuid,this._catch.bind(this)),this.$item.attr("data-command",this.params.command))},_buildRemover:function(){if(this.params.title&&this.params.remover){var e=this.dom("<span>").addClass(this.prefix+"-popup-item-trash "+this.prefix+"-icon-trash");e.attr("data-command",this.params.remover),e.on("click."+this.prefix+"-popup-item-"+this.uuid,this._catchRemover.bind(this)),this.$item.append(e)}},_catchRemover:function(e){e.preventDefault(),e.stopPropagation();var t=this.dom(e.target).closest("."+this.prefix+"-popup-stack-item"),n=this.dom(e.target).closest("."+this.prefix+"-popup-item-trash").attr("data-command"),r=t.attr("data-name");this.app.api(n,this,r),t.fadeOut(200,(function(e){e.remove()}))},_catch:function(e){e.preventDefault(),e.stopPropagation();var t=this.dom(e.target).closest("."+this.prefix+"-popup-stack-item"),n=t.attr("data-name"),r=t.attr("data-command");this.popup.$items.find("."+this.prefix+"-popup-stack-item").removeClass("active"),this.params.toggle&&t.addClass("active"),this.app.api(r,this.getParams(),this,n,e)}}),l.add("class","popup.stack",{defaults:{active:!1,title:!1,type:!1,width:!1,setter:!1,getter:!1,builder:!1,observer:!1,instance:!1,collapse:!1,form:!1,items:!1,focus:!1,footer:!1},init:function(e,t,n,r){this.defaultWidth="240px",this.popup=r,this.name=e,this.tools={},this.data=!1,this.items=!1,this.formitems=!1,this.params=u.extend({},!0,this.defaults,t),n&&(this.params.collapse=!0),this._build(),this._observe()},set:function(e,t){this.params[e]=t},setData:function(e){this.data=e},setFocus:function(e){void 0!==this.tools[e]&&this.tools[e].setFocus()},setWidth:function(e){var t=this.app.popup.getElement();t.attr("data-width",e),"100%"===e&&(e=this.app.editor.getWidth()+"px"),t.css("width",e),this.app.$win.on("resize."+this.prefix+"-popup-"+this.uuid,this.popup.resize.bind(this.popup)),this.popup.resize()},setItemsData:function(e){this.items=e},get:function(e){return this.params[e]},getElement:function(){return this.$stack},getName:function(){return this.name},getBody:function(){return this.$body},getInstance:function(){return this.get("instance")},getItemsData:function(){return this.items},getItems:function(){return this.$items},getFooter:function(){return this.$footer},getFooterPrimary:function(){return this.$footer.find("."+this.prefix+"-form-button-primary")},getTool:function(e){return void 0!==this.tools[e]&&this.tools[e]},getInput:function(e){var t=this.getTool(e);return t?t.getInput():this.dom()},getFormItem:function(e){var t=this.getTool(e);return t?t.getInput().closest("."+this.prefix+"-form-item"):this.dom()},getData:function(e){var t;return e?void 0!==this.tools[e]&&(t=this.tools[e].getValue()):(t={},Object.keys(this.tools).forEach(function(e){t[e]=this.tools[e].getValue()}.bind(this))),t},hasForm:function(){return this.formitems},hasFooter:function(){return 0!==this.footerbuttons},hasItems:function(){return!1!==this.items},isCollapsed:function(){return this.get("collapse")},isActive:function(){return this.get("active")},open:function(e,t,n){if((e&&e.focus&&this.set("focus",e.focus),this.popup.closeStacks(),this.app.popup.setStack(this),!1!==n)&&this.app.broadcast("popup.before.open").isStopped())return void this.popup.stopStack();e&&e.collapse?(this._buildItems(),this._renderItems()):this.render(),this.popup.header.render(this.popup.stacks),this.popup.header.setActive(this),this.$stack.show(),this._renderWidth(),!1!==t&&this.renderFocus(),!1!==n&&this.app.broadcast("popup.open")},close:function(){this.$stack.hide()},collapse:function(){var e=this._getPrev();this.isCollapsed()&&this.popup.removeStack(this),e.open({collapse:!0})},render:function(){this._renderType(),this._renderItems(),this._renderForm(),this._renderFooter(),this._renderEnv()},renderFocus:function(){this.get("focus")&&this.setFocus(this.get("focus"))},_observe:function(){this.params.observer&&this.app.api(this.params.observer,this)},_getPrev:function(){var e;for(var t in this.popup.stacks)if(this.popup.stacks.hasOwnProperty(t)){if(t===this.name)return e;e=this.popup.stacks[t]}},_build:function(){this._buildElement(),this._buildBody(),this._buildFooter(),this._buildParams()},_buildElement:function(){this.$stack=this.dom("<div>").addClass(this.prefix+"-popup-stack "+this.prefix+"-popup-stack-"+this.name),this.$stack.hide(),this.$stack.attr("data-"+this.prefix+"-stack-name",this.name),this.popup.getElement().append(this.$stack)},_buildBody:function(){this.$body=this.dom("<div>").addClass(this.prefix+"-popup-body"),this.$stack.append(this.$body)},_buildFooter:function(){this.$footer=this.dom("<div>").addClass(this.prefix+"-popup-footer"),this.$stack.append(this.$footer)},_buildParams:function(){this.params.width=this.params.width?this.params.width:this.defaultWidth,this.params.setter=!!this.params.setter&&this.params.setter,this.params.getter=!!this.params.getter&&this.params.getter,this.data=!!this.params.getter&&this.app.api(this.params.getter,this),this._buildItems()},_buildItems:function(){this.params.builder?this.items=this.app.api(this.params.builder,this):this.params.items&&(this.items=this.params.items)},_renderWidth:function(){this.setWidth(this.get("width"))},_renderType:function(){this.$stack.removeClass(this.prefix+"-popup-type-grid");var e=this.get("type");e&&this.$stack.addClass(this.prefix+"-popup-type-"+e)},_renderItems:function(){if(this.items)for(var e in this.$items?this.$items.html(""):(this.$items=this.dom("<div>").addClass(this.prefix+"-popup-items"),this.$body.append(this.$items)),this.items)if(this.items.hasOwnProperty(e)){if(Object.prototype.hasOwnProperty.call(this.items[e],"observer")&&this.items[e].observer){var t=this.app.api(this.items[e].observer,this.items[e],e,this);void 0!==t&&(this.items[e]=t)}if(!1===this.items[e])continue;var n=this.app.create("popup.item",this,e,this.items[e]).getElement();this._renderItemPosition(this.$items,n,this.items[e])}},_renderItemPosition:function(e,t,n){if(n.position){var r=n.position;if("first"===r)e.prepend(t);else if("object"==typeof r){var o=Object.prototype.hasOwnProperty.call(r,"after")?"after":"before",i=r[o],a=this._findPositionElement(i,e);a?a[o](t):e.append(t)}}else e.append(t)},_renderEnv:function(){var e=this.popup.getElement();e.removeClass("has-footer has-items has-form"),this.hasForm()&&e.addClass("has-form"),this.hasFooter()&&e.addClass("has-footer"),this.hasItems()&&e.addClass("has-items")},_renderForm:function(){this.formitems=this.get("form"),this.formitems&&(this.$form?this.$form.html(""):(this.$form=this.dom("<form>").addClass(this.prefix+"-popup-form"),this.$body.append(this.$form)),this._renderTools(),this._renderData(),this.$form.find("input[type=text],input[type=url],input[type=email]").on("keydown."+this.prefix+"-popup",function(e){if(13===e.which)return e.preventDefault(),!1}.bind(this)))},_renderTools:function(){Object.keys(this.formitems).forEach(function(e){this._renderTool(e,this.formitems[e])}.bind(this))},_renderTool:function(e,t){var n=this.app.create("tool."+t.type,e,t,this,this.data),r=n.getElement();r&&(this.tools[e]=n,this.$form.append(r))},_renderData:function(){if(this.data)for(var e in this.data)void 0!==this.tools[e]&&this.tools[e].setValue(this.data[e])},_renderFooter:function(){this.footerbuttons=0;var e=this.get("footer");if(e)for(var t in this.$footer.html(""),e)if(e.hasOwnProperty(t)){if(!1===e[t])continue;var n=this.app.create("popup.button",t,this,e[t]);this.$footer.append(n.getElement()),this.footerbuttons++}},_findPositionElement:function(e,t){var n;if(Array.isArray(e))for(var r=0;r<e.length&&0===(n=t.find("[data-name="+e[r]+"]")).length;r++);else n=t.find("[data-name="+e+"]");return 0!==n.length?n:0}}),l.add("class","popup.button",{init:function(e,t,n){this.name=e,this.obj=n,this.popup=t,this.$button=this.dom("<button>").addClass(this.prefix+"-form-button"),this.$button.attr("data-name",this.name),this.$button.html(this.lang.parse(this.obj.title)),this.$button.dataset("instance",this),this._has("type")&&this.$button.addClass(this.prefix+"-form-button-"+this.obj.type),this._has("classname")&&this.$button.addClass(this.obj.classname),this._has("fullwidth")&&this.$button.addClass(this.prefix+"-form-button-fullwidth"),this._has("right")&&this.$button.addClass(this.prefix+"-form-button-push-right"),this.$button.on("click."+this.prefix+"-popup-button"+this.uuid,this._catch.bind(this))},getName:function(){return this.name},getElement:function(){return this.$button},invokeCommand:function(){this._invoke()},_has:function(e){return Object.prototype.hasOwnProperty.call(this.obj,e)},_catch:function(e){e.preventDefault(),e.stopPropagation(),this._has("command")?this._invoke(e):this._has("close")&&this.app.popup.close()},_invoke:function(e){this.app.api(this.obj.command,this.popup,this.name,e)}}),l.add("class","popup.header",{init:function(e){this.popup=e,this._build()},setActive:function(e){this.$headerbox.find("."+this.prefix+"-popup-header-item").removeClass("active"),this.$headerbox.find("[data-"+this.prefix+"-name="+e.getName()+"]").addClass("active")},render:function(e){this._reset(),this._buildItems(e)>0&&this._buildClose()},_build:function(){this.$header=this.dom("<div>").addClass(this.prefix+"-popup-header"),this.$headerbox=this.dom("<div>").addClass(this.prefix+"-popup-header-box"),this.$header.append(this.$headerbox),this.popup.getElement().prepend(this.$header)},_buildClose:function(){var e=this.dom("<span>").addClass(this.prefix+"-popup-close");e.one("click",this._catchClose.bind(this)),this.$header.append(e)},_buildItems:function(e){var t=Object.keys(e).length,n=0,r=0;for(var o in e)if(e.hasOwnProperty(o)){if("object"!=typeof e[o])continue;r++;var i=e[o].get("title");i?(n++,this._buildItem(e[o],i,t)):1===r&&t>1&&(n++,this._buildItem(e[o],"## popup.back ##",t))}return n},_buildItem:function(e,t,n){var r=n>1,o=r?this.dom("<a>").attr("href","#"):this.dom("<span>");r&&(o.dataset("stack",e),o.addClass(this.prefix+"-popup-header-item-link"),o.on("click",this._catchStack.bind(this))),o.attr("data-"+this.prefix+"-name",e.getName()),o.addClass(this.prefix+"-popup-header-item"),o.html(this.lang.parse(t)),this.$headerbox.append(o)},_reset:function(){this.$headerbox.html(""),this.$header.find("."+this.prefix+"-popup-close").remove()},_catchStack:function(e){e.preventDefault(),e.stopPropagation();var t=this.dom(e.target).dataget("stack"),n=this.app.popup.getStack();n.isCollapsed()&&this.app.popup.removeStack(n),t.open()},_catchClose:function(e){e.preventDefault(),e.stopPropagation(),this.popup.close()}}),l.add("module","editor",{start:function(){this._buildEditor(),this._buildBlurClass(),this._buildOptions(),this._buildContent()},stop:function(){this.app.$element.show()},load:function(){this._setFocusOnStart()},build:function(){this.app.blocks.build(),this.app.embed.build(),this.app.image.observeStates(),this.app.parser.buildPredefinedClasses(),this.app.broadcast("editor.build")},isEditor:function(e){return this.dom(e).get()===this.$editor.get()},isLayout:function(e){return this.isEditor(e)},isTextarea:function(){return!1===this.opts.content},isFocus:function(){return this.app.container.isFocus()},isAllSelected:function(){return this._classSelect("has")},isEmpty:function(e){return!(this.app.blocks.getFirstLevel().length>1)&&this.app.content.isEmptyHtml(this.$editor.html(),e)},isPopupSelection:function(){return!this.app.blocks.isMeta()},isBlocksSelection:function(){return this.app.blocks.isMeta()||this.app.blocks.is()||this.app.editor.isAllSelected()},addButton:function(e,t){this.opts.buttonsObj[e]=t,this.opts.buttons.editor.push(e)},selectAll:function(){if(!this.isAllSelected()){this._classSelect("add"),this.app.block.unset(),this.app.blocks.unset(),this.app.toolbar.build(),this.app.control.close(),this.app.context.close();var e=this.app.blocks.getLast(),t=!1;e&&"layer"===e.getType()&&(t=e.getBlock()).attr("contenteditable",!0),this.app.selection.select(),this.app.broadcast("editor.select"),t&&setTimeout((function(){t.attr("contenteditable",!1)}),0)}},unselectAll:function(){this.isAllSelected()&&(this.unsetSelectAll(),this.app.block.unset(),this.app.blocks.unset(),this.app.broadcast("editor.unselect"))},unsetSelectAll:function(){this._classSelect("remove")},observeBlocks:function(e){this.blocks=[];var t=this.app.blocks.getSelectedBlock(e);this.app.editor.setFocus();var n=this.app.blocks.getSelectedBlocks();if(1===n.length)this.app.block.set(t);else if(this.app.selection.isAll()){var r=this.app.blocks.getBlocks(),o=this.app.selection.getNodes({type:"blocks-first"});r.length===o.length?this.app.editor.selectAll():this.blocksSelection(n)}else n.length>1?this.blocksSelection(n):this.app.block.set(t)},blocksSelection:function(e){this.app.block.unset(),this.app.blocks.set(e),this.app.toolbar.build()},insertContent:function(e){this.app.insertion.insertContent(e)},setContent:function(e){this.app.insertion.setContent(e)},setEmpty:function(){this.app.insertion.setContent({html:""})},setWinFocus:function(){},setFocus:function(e){if(e){var t=!0===e?"start":e,n="start"===t?this.app.blocks.getFirst():this.app.blocks.getLast();this.app.block.set(n,t)}else{if(this.isFocus())return;for(var r=0;r<u.instances.length;r++)u.instances[r]!==this.app&&u.instances[r].editor.setBlur();this.app.container.setFocus(),this.app.broadcast("editor.focus")}},setBlur:function(e){this.isFocus()&&(this.$editor.get&&(this.app.broadcast("editor.before.blur",{e}).isStopped()?e&&e.preventDefault():(this.app.container.setBlur(),this.app.selection.removeAllRanges(),this.app.source.is()||(this.app.block.unset(),this.app.blocks.unset(),this.app.popup.close(!1),this.app.context.close(),this.app.control.close(),this.app.toolbar.build()),this.app.broadcast("editor.blur",{e}))))},getContent:function(e){var t="";return this.app.source.is()?t=this.app.source.getContent():(t=this._getContent(),t=e?this.app.tidy.parse(t):t),t=this.app.content.decodeHref(t)},getSelection:function(){var e=this.getWinNode().getSelection();if(e.rangeCount>0){var t=e.anchorNode;return 0!==this.dom(t).closest("."+this.prefix+"-container-"+this.uuid).length&&e}return!1},getWinNode:function(){return this.app.$win.get()},getDocNode:function(){return this.app.$doc.get()},getEditor:function(){return this.$editor},getLayout:function(){return this.getEditor()},getWidth:function(){var e=this.getEditor(),t=parseInt(e.css("padding-left")),n=parseInt(e.css("padding-right"));return e.width()-t-n},getRect:function(){var e=this.$editor.offset(),t=this.$editor.width(),n=this.$editor.height(),r=Math.round(e.top),o=Math.round(e.left);return{top:r,left:o,bottom:r+n,right:o+t,width:t,height:n}},getButtonsFromArr:function(e){var t={};if(!Array.isArray(e)&&"object"==typeof e)return e;if(e)for(var n=u.extend(!0,{},this.opts.buttonsObj),r=0;r<e.length;r++){var o=e[r];void 0!==n[o]&&(t[o]=n[o])}return t},observeUI:function(){this.app.toolbar.observe(),this.app.context.observe()},enableUI:function(){this.app.toolbar.enable(),this.app.toolbar.enableSticky()},disableUI:function(){this.app.popup.close(),this.app.control.close(),this.app.context.close(),this.app.toolbar.disable(),this.app.toolbar.disableSticky()},_buildEditor:function(){this.app.$element.hide(),this.$editor=this.dom("<div>"),this.$editor.addClass(this.prefix+"-editor "+this.prefix+"-reset "+this.prefix+"-"+this.opts.editor.classname),this.$editor.attr("contenteditable",!0);var e=this.opts.paddingNormal;(this.opts.control||this.opts.reorder)&&(e=this.opts.paddingControl),this.$editor.css("padding",e),this.app.container.get("editor").append(this.$editor)},_buildBlurClass:function(){this.app.container.setBlur()},_buildOptions:function(){var e=this.$editor,t=this.opts.editor;this.opts.code=this.opts.pre,e.attr("dir",t.direction),t.minHeight&&e.css("min-height",t.minHeight),t.maxHeight&&e.css({"max-height":t.maxHeight,overflow:"auto"}),t.notranslate&&e.addClass("notranslate"),t.spellcheck||e.attr("spellcheck",!1),t.grammarly||e.attr("data-gramm_editor",!1)},_buildContent:function(){var e=this._getContentValue();e=this.app.broadcastHtml("editor.before.load",e);var t=this.app.parser.parse(e,!0,!0);this.$editor.html(t.get().childNodes);var n=this.app.parser.unparse(this.$editor.html());this.app.$element.val(n),this._load()},_buildDraggable:function(){this.app.$body.find("[data-"+this.prefix+"-drop-id]").each(function(e){e.attr("draggable",!0),e.on("dragstart",function(e){var t=this.dom(e.target).attr("data-"+this.prefix+"-drop-id");e.dataTransfer.setData("item",t)}.bind(this))}.bind(this))},_load:function(){this.app.blocks.build(),this.app.event.build(),this.app.observer.build(),this.app.embed.build(),this.app.sync.build(),this.app.image.observeStates(),this._buildDraggable(),this.app.broadcast("editor.load")},_getContent:function(){var e=this.$editor.html();return e=this.app.parser.unparse(e)},_getContentValue:function(){return this.opts.content?this.opts.content:this.app.$element.val()},_setFocusOnStart:function(){this.opts.editor.focus&&(this.setFocus(),this.setFocus(this.opts.editor.focus))},_classSelect:function(e){return this.$editor[e+"Class"](this.prefix+"-select-all")}}),l.add("module","parser",{build:function(e){return this.$layout=this.dom("<div>"),this.$layout.html(e),this.$layout.find("[data-"+this.prefix+"-type]").each(this._build.bind(this)),this.$layout},buildPredefinedClasses:function(e){if(this.opts.classes){e=e||this.app.editor.getEditor();var t=this.app.content,n=!0,r=!1;if(void 0!==this.opts.classes.blocks&&(r=!0,void 0===this.opts.classes.tags&&(n=!1)),n&&e.find(t.getPredefinedTags().join(",")).each(t.addPredefinedTagClass.bind(this)),r){var o=t.getPredefinedBlocks(),i="data-"+this.prefix+"-type",a="["+i+"="+o.join("],["+i+"=")+"]";e.find(a).each(t.addPredefinedBlockClass.bind(this))}}},parse:function(e,t,n){return e=e.trim(),e=this.app.broadcastHtml("editor.before.parse",e),this.app.content.isEmptyHtml(e)?e=this.app.block.createHtml():(e=this._clean(e,n),e=this._parse(e)),e=this.app.broadcastHtml("editor.parse",e),!1!==t?this.build(e):e},parseLine:function(e,t){return" "===e?e="&nbsp;":(e=(e=this.app.broadcastHtml("editor.before.parse",e)).replace(/\r?\n/g,"<br>"),e=this.app.content.encodeCode(e),e=this.app.content.sanitize(e),e=this.app.content.removeEmptySpans(e),e=this.app.content.addHttps(e),e=this.app.broadcastHtml("editor.parse",e)),!1!==t?this.build(e):e},unparse:function(e,t){var n={},r=this.app.content;return e=e.trim(),e=this.app.broadcastHtml("editor.before.unparse",e),r.isEmptyHtml(e)?"":(e=this._revertForms(e),e=this._revertFrames(e),e=r.store(e,"embed",n,0),e=r.addNofollow(e),e=r.removeMarkers(e),e=this.app.utils.removeInvisibleChars(e),e=r.recacheStyle(e),e=r.restore(e,"embed",n),e=r.removeEmptyAttrs(e,["style","class","rel","alt","title"]),e=this._unparseAllTags(e),e=this._unparseDataType(e,t),e=r.removeEmptyAttrs(e,["style","class","rel","alt","title"]),this.opts.classes&&(e=this.app.utils.wrap(e,this.buildPredefinedClasses.bind(this))),"<p></p>"===e&&(e=""),this.app.broadcastHtml("editor.unparse",e))},_build:function(e){var t=e.attr("data-"+this.prefix+"-type");this.app.create("block."+t,e)},_clean:function(e,t){var n={},r=[],o=this.app.content;return e=(e=o.storeComments(e,r)).replace(/¤t/gi,"&current"),t&&this.app.editor.isTextarea()&&(e=o.encodeCode(e)),e=o.sanitize(e),e=this._convertForms(e),e=this._convertFrames(e),e=o.store(e,"embed",n,0),e=o.removeTags(e,this.opts.tags.denied),e=o.removeDoctype(e),e=o.removeTagsWithContent(e,["script","style"]),e=o.removeEmptySpans(e),e=o.addHttps(e),e=o.removeBlockTagsInside(e,["th","td","li","dt","dd","address"]),e=o.cacheStyle(e),e=o.restore(e,"embed",n),e=o.restoreComments(e,r),this.opts.clean.comments&&(e=o.removeComments(e)),e=o.isEmptyHtml(e)?this.app.block.createHtml():o.paragraphize(e)},_parse:function(e){return this.app.utils.wrap(e,function(e){for(var t=this.app.element.getBlocks(e),n=0;n<t.length;n++)this._parseHtml(t[n]);this.buildPredefinedClasses(e)}.bind(this))},_parseHtml:function(e){var t=e.tagName.toLowerCase(),n=this.dom(e),r=this._parseType(n,t);r&&(n.attr("data-"+this.prefix+"-type",r),"image"===r&&t!==this.opts.image.tag&&(n=this.app.element.replaceToTag(n,this.opts.image.tag,!0)))},_parseType:function(e,t){return e.attr("data-"+this.prefix+"-type")?e.attr("data-"+this.prefix+"-type"):this._parseTypeByTag(e,t)},_parseTypeByTag:function(e,t){var n;switch(t){case"p":n="paragraph",this._isImageBlock(e,"p")&&(n="image");break;case"figure":n="embed",this._isImageBlock(e,"figure")?n="image":this._hasChild(e,"pre")?n="pre":this._hasChild(e,"blockquote")&&(n="quote");break;case"div":n="layer",this._isImageBlock(e,"div")&&(n="image");break;case"h1":case"h2":case"h3":case"h4":case"h5":case"h6":n="heading";break;case"blockquote":n="quote";break;case"table":n="table";break;case"pre":n="pre";break;case"hr":n="line";break;case"dl":n="dlist";break;case"address":n="address";break;case"ul":case"ol":n="list";break;default:n="layer"}return n},_isImageBlock:function(e,t){var n=e.find("img");if(0!==n.length&&("div"!==t||0===n.closest("figure").length)){var r=n,o=n.parent(),i=0!==o.length&&o.get().tagName;if(!i||"A"!==i&&"SPAN"!==i){if(i&&o.get()!==e.get())return}else r=o;if(0===r.prevElement().length&&("figure"===t||0===r.nextElement().length))return!0}},_hasChild:function(e,t){if("pre"===t){if(0!==e.find("pre").length)return!0}else if("blockquote"===t){var n=e.find("blockquote");if(0===e.find("script").length&&0!==n.length)return!0}},_unparseAllTags:function(e){return this.app.utils.wrap(e,function(e){e.find("*").removeAttr("contenteditable data-gramm_editor"),this.opts.image.states||e.find("img").removeAttr("data-image")}.bind(this))},_unparseDataType:function(e,t){return this.app.utils.wrap(e,function(e){var n=e.find("[data-"+this.prefix+"-type]");!0!==t&&n.removeClass(this.prefix+"-block-state"),n.removeAttr("tabindex data-"+this.prefix+"-parsed data-"+this.prefix+"-first-level"),n.removeClass(this.prefix+"-block-focus "+this.prefix+"-block-multiple-focus "+this.prefix+"-block-multiple-hover "+this.prefix+"-editable-pause"),n.removeClass(this.prefix+"-nowrap"),n.each(this._unparseByType.bind(this)),n.removeAttr("data-"+this.prefix+"-type"),e.find("figcaption").removeAttr("data-"+this.prefix+"-type data-placeholder").each(this.app.content._removeEmptyTag.bind(this))}.bind(this))},_unparseByType:function(e){var t=e.attr("data-"+this.prefix+"-type");"embed"===t?this._unparseEmbed(e):"list"===t&&this._unparseList(e)},_unparseEmbed:function(e){var t,n=decodeURI(e.attr("data-embed-code")),r=e.find("."+this.opts.embed.responsive),o=e.find("figcaption");0!==o.length&&(t=o.clone(),o.remove()),0===r.length?e.html(n):r.html(n),t&&e.append(t),e.removeAttr("data-embed-code")},_unparseList:function(e){this.app.content.unfixListMargin(e)},_convertFrames:function(e){return this.app.utils.wrap(e,function(e){e.find("iframe").each(this._convertFrame.bind(this))}.bind(this))},_convertFrame:function(e){0===e.closest("figure").length&&(e.wrap("<figure>"),e.parent().addClass(this.prefix+"-figure-iframe"))},_convertForms:function(e){return this.app.utils.wrap(e,function(e){e.find("form").each(this._convertForm.bind(this))}.bind(this))},_convertForm:function(e){this.app.element.replaceToTag(e,"div").addClass(this.prefix+"-div-form")},_revertFrames:function(e){return this.app.utils.wrap(e,function(e){e.find("."+this.prefix+"-figure-iframe").each(this._revertFrame.bind(this))}.bind(this))},_revertFrame:function(e){0!==e.find("figcaption").length?e.removeClass(this.prefix+"-figure-iframe"):e.unwrap()},_revertForms:function(e){return this.app.utils.wrap(e,function(e){e.find("."+this.prefix+"-div-form").each(this._revertForm.bind(this))}.bind(this))},_revertForm:function(e){this.app.element.replaceToTag(e,"form").removeClass(this.prefix+"-div-form")}}),l.add("module","blocks",{init:function(){this.selected=[],this.focusclass=this.prefix+"-block-meta-focus"},start:function(){this.$editor=this.app.editor.getEditor()},build:function(){this._buildFirstLevel()},is:function(){return this.selected.length>0},isMeta:function(){return this.getSelected().length>0},set:function(e){this.selected=e},setMeta:function(e){e=e.closest("[data-"+this.prefix+"-first-level]"),this.app.block.unset(),this._classFocus(e,"add"),this.app.toolbar.build(),setTimeout(function(){this.app.selection.removeAllRanges()}.bind(this),0)},unset:function(){this._classFocus(this.getFirstLevel(),"remove"),this.selected=[]},getBlocks:function(){return this.$editor.find("[data-"+this.prefix+"-type]")},getFirstLevel:function(){return this.$editor.find("[data-"+this.prefix+"-first-level]")},getFirst:function(){return this.getBlocks().first().dataget("instance")},getLast:function(){return this.getBlocks().last().dataget("instance")},getFirstSelected:function(){return this.getSelected().first().dataget("instance")},getLastSelected:function(){return this.getSelected().last().dataget("instance")},getSelected:function(){return this.$editor.find("."+this.focusclass)},getSelectedBlocks:function(e){var t=this.app.selection.getNodes({type:"blocks-first"});if("editable"===e){for(var n=[],r=0;r<t.length;r++){var o=this.dom(t[r]).dataget("instance").getType();-1!==["paragraph","heading","list","address"].indexOf(o)&&n.push(t[r])}t=n}return t},getSelectedBlock:function(e){var t=this.app.selection.getDataBlock();return e&&0===t.length&&(t=this.app.element.getDataBlock(e.target)),t},getFirstSelectedBlock:function(){return this.selected.length>0&&this.selected[0]},getLastSelectedBlock:function(){return this.selected.length>0&&this.selected[this.selected.length-1]},removeSelected:function(e){var t,n=this.getLastSelected();!1!==e&&n&&(t=n.getNext()),this.getSelected().each(this._removeSelectedBlock.bind(this)),t&&this.app.block.set(t,"start")},_buildFirstLevel:function(){var e="data-"+this.prefix+"-first-level",t=this.app.editor.getEditor();t.find("["+e+"]").removeAttr(e),t.children("[data-"+this.prefix+"-type]").attr(e,!0)},_removeSelectedBlock:function(e){e.dataget("instance").remove({traverse:!1})},_classFocus:function(e,t){return e[t+"Class"](this.focusclass)}}),l.add("module","event",{init:function(){this.trigger=!0,this.imageDrag=!1,this.dragoverEvent=!1,this.isPopupMouseUp=!1,this.isEditorMouseUp=!1,this.isBlockMouseUp=!1,this.pasteEvent=!1,this.events={editor:["click","touchstart","mouseover","mouseup","mousedown","keyup","drop","dragstart","dragover","dragleave"],doc:["keydown","mousedown","mouseup","click","paste","cut","copy"],win:["focus"]}},build:function(){this.$editor=this.app.editor.getEditor(),this._buildPreventLinks(),this._buildEvents()},run:function(){this._buildEvents()},pause:function(){this._pauseEvents()},onmouseover:function(e){this.app.broadcast("editor.mouseover",{e})},ontouchstart:function(e){this.app.state.add(e)},onclick:function(e){this.app.broadcast("editor.click",{e}),this._isEditorClick(e)&&!this.isBlockMouseUp&&this._setByClick(e),3===e.detail&&setTimeout(function(){this._setBlockFocus(e,!0)}.bind(this),0)},onmouseup:function(e){this.trigger&&(!this.isEditorMouseUp&&this._isEditorClick(e)||setTimeout(function(){this._observeBlockFocus(e),this.isEditorMouseUp=!1,this.app.broadcast("editor.mouseup",{e})}.bind(this),0))},onmousedown:function(e){this.app.placeholder.handleClick(e),this._isEditorClick(e)?this.isBlockMouseUp=!1:(this.isBlockMouseUp=!0,this._setCaretInline(e),this.isEditorMouseUp=!0,this.app.state.add(e),this.app.broadcast("editor.mousedown",{e}))},onkeyup:function(e){if(this.app.broadcast("editor.keyup",this._buildEventKeysObj(e)).isStopped())return e.preventDefault();var t=e.which;if(t===this.app.keycodes.DOWN||t===this.app.keycodes.UP){var n=this.app.selection.getDataBlock();0===n.length||this.app.block.is(n)||this.app.block.set(n)}t===this.app.keycodes.BACKSPACE&&this.app.editor.isEmpty()&&this.app.editor.setEmpty(),t!==this.app.keycodes.TAB||this.app.block.is()||this._setBlock(e)},ondrop:function(e){if(!this.opts.editor.drop)return e.preventDefault();var t;if(this.app.broadcast("editor.drop",{e}).isStopped())return e.preventDefault();var n=e.dataTransfer,r=n.getData("item");if(""!==r)e.preventDefault(),(t=this.opts.draggable&&void 0!==this.opts.draggable[r]?this.opts.draggable[r]:(t=this.dom("[data-"+this.prefix+"-drop-item="+r+"]").html()).trim())&&this._drop(e,t,"after",!1);else if(this.opts.image&&this.opts.image.upload&&null!==n.files&&n.files.length>0)e.preventDefault(),this.app.image.drop(e,n);else{t=""===(t=n.getData("text/html")).trim()?n.getData("Text"):t;var o=this._drop(e,t);if(this.imageDrag&&0!==o.instances.length)o.instances[0].change(this.imageDrag,!1)}this._removeDragPlaceholder(),this.imageDrag=!1,this.app.observer.trigger=!0},ondragstart:function(e){var t=this._getBlock(e.target);0!==t.length&&"image"===this.app.element.getType(t)&&(this.imageDrag=t.dataget("instance")),this.app.broadcast("editor.dragstart",{e})},ondragover:function(e){if(e.preventDefault(),this.dragoverEvent=!0,this.app.observer.trigger=!1,this._removeDragPlaceholder(),-1!==e.dataTransfer.types.indexOf("item")){var t=this._getBlockFirst(e.target);if(0!==t.length){var n=this.dom("<div>").addClass(this.prefix+"-draggable-placeholder");t.after(n)}}this.app.broadcast("editor.dragover",{e})},ondragleave:function(e){e.preventDefault(),this.dragoverEvent=!0,this.app.observer.trigger=!0,this._removeDragPlaceholder(),this.app.broadcast("editor.dragleave",{e})},onwinfocus:function(){var e=this.app.block.get();!e||e.isEditable()||setTimeout(function(){this.app.selection.removeAllRanges()}.bind(this),0)},ondocpaste:function(e){this._isFocusEditor()&&this._paste(e)},ondoccopy:function(e){this._isFocusEditor()&&this._copy(e)},ondoccut:function(e){this._isFocusEditor()&&this._cut(e)},ondockeydown:function(e){if(this.app.popup.isOpen()){if(this._isEnter(e)){var t=this.app.popup.getStack();if(!1!==t.hasForm()&&"TEXTAREA"!==e.target.tagName)return e.preventDefault(),void t.getFooterPrimary().dataget("instance").invokeCommand()}this._isEsc(e)&&this.app.popup.close(!1)}if(!this._isOutsideEditor(e)&&this.app.editor.isFocus()&&!this.app.popup.isOpen()&&!this.app.source.is()){var n=this.app.broadcast("editor.keydown",this._buildEventKeysObj(e));if(n.isStopped())return e.preventDefault();if(!1===this.opts.editor.enterKey&&13===e.which)return void e.preventDefault();if(this.app.state.listen(e))return;if(this._isEsc(e)&&(this.app.block.unset(),this.app.selection.removeAllRanges()),this.app.shortcut.handle(e))return;this.app.input.handle(n)}},ondocmousedown:function(e){this.isPopupMouseUp=0!==this.dom(e.target).closest("."+this.prefix+"-popup-"+this.uuid).length,this.app.broadcast("editor.docmousedown",{e})},ondocmouseup:function(e){this.app.selection.is()&&!this.app.editor.isFocus()&&this._observeBlockFocus(e),this.app.broadcast("editor.docmouseup",{e})},ondocclick:function(e){if(!this.app.popup.isOpen()||!this._isEditorContainer(e))return!this._isOutsideEditor(e)||!1===this.trigger||void(this.isEditorMouseUp?this.isEditorMouseUp=!1:(this.app.popup.isOpen()?!1===this.isPopupMouseUp&&this.app.popup.close(!1):this.app.editor.setBlur(e),this.app.broadcast("editor.docclick",{e})));this.app.popup.close(!1)},_buildPreventLinks:function(){var e=this.prefix+"-prevent-events";this.$editor.on("click."+e+" dblclick."+e,this._preventLinks.bind(this))},_buildEventKeysObj:function(e){var t=e.which,n=[this.app.keycodes.UP,this.app.keycodes.DOWN,this.app.keycodes.LEFT,this.app.keycodes.RIGHT],r=!e.ctrlKey&&!e.metaKey&&(t>=48&&t<=57||t>=65&&t<=90),o=this.app.keycodes;return{e,key:t,ctrl:e.ctrlKey||e.metaKey,shift:e.shiftKey,alt:e.altKey,select:(e.ctrlKey||e.metaKey)&&!e.altKey&&65===t,enter:t===o.ENTER,space:t===o.SPACE,esc:t===o.ESC,tab:!(t!==o.TAB||e.shiftKey||e.altKey||e.ctrlKey||e.metaKey),delete:t===o.DELETE,backspace:t===o.BACKSPACE,alpha:r,arrow:-1!==n.indexOf(t),left:t===o.LEFT,right:t===o.RIGHT,up:t===o.UP,down:t===o.DOWN,"left-right":t===o.LEFT||t===o.RIGHT,"up-left":t===o.UP||t===o.LEFT,"down-right":t===o.DOWN||t===o.RIGHT}},_buildEvents:function(){var e=this.prefix+"-events";this._buildTargetEvents(this.$editor,this.events.editor,e,""),this._buildTargetEvents(this.app.$doc,this.events.doc,e,"doc"),this._buildTargetEvents(this.app.$win,this.events.win,e,"win")},_buildTargetEvents:function(e,t,n,r){for(var o=0;o<t.length;o++)e.on(t[o]+"."+n,this["on"+r+t[o]].bind(this))},_pauseEvents:function(){var e=this.prefix+"-events";this.$editor.off("."+e),this.app.$doc.off("."+e),this.app.$win.off("."+e)},_preventLinks:function(e){0!==this.dom(e.target).closest("a").length&&e.preventDefault()},_isEditorClick:function(e){if(this.app.editor.isEditor(e.target))return e.preventDefault(),!0},_isEsc:function(e){return e.which===this.app.keycodes.ESC},_isEnter:function(e){return e.which===this.app.keycodes.ENTER},_isEditorContainer:function(e){return 0!==this.dom(e.target).closest("."+this.prefix+"-container-"+this.uuid).length},_isOutsideEditor:function(e){return 0===this.dom(e.target).closest("."+this.prefix+["-container-","-popup-","-toolbar-","-control-"].join(this.uuid+",."+this.prefix)+this.uuid).length},_isFocusEditor:function(){return!this.app.popup.isOpen()&&!this.app.source.is()&&(this.app.block.is()||this.app.blocks.is()||this.app.blocks.isMeta()||this.app.editor.isAllSelected())},_removeDragPlaceholder:function(){this.app.editor.getEditor().find("."+this.prefix+"-draggable-placeholder").remove()},_getBlock:function(e){return this.dom(e).closest("[data-"+this.prefix+"-type]")},_getBlockFirst:function(e){return this.dom(e).closest("[data-"+this.prefix+"-first-level]")},_observeBlockFocus:function(e){this.app.selection.isCollapsed()?this._setBlockFocus(e):this.app.editor.observeBlocks(e),this.app.toolbar.observe(),this.app.state.add(e)},_setByClick:function(e){var t=this.app.blocks.getFirstLevel(),n=[];t.each((function(e){var t=e.get().getBoundingClientRect();n.push([t.x,t.y,t.y+t.height])}));var r=[],o=!1;n.forEach((function(t,n){var i=parseInt(e.clientY),a=parseInt(e.clientX);if(t[1]<i&&i<t[2])o=n;else{var s=Math.hypot(t[0]-a,t[1]-i);r.push(parseInt(s))}}));var i=!1!==o?o:r.indexOf(Math.min.apply(Math,r)),a=t.eq(i);this.app.block.set(a.dataget("instance"),"start"),this.app.editor.setFocus()},_setBlock:function(e){this.app.editor.setFocus();var t=e?this._getBlock(e.target):this.app.selection.getDataBlock(),n=!1;0===t.length&&(t=this.app.blocks.getFirst(),n="start"),this.app.block.set(t,n)},_setBlockFocus:function(e,t){var n=this._getBlock(e.target);0!==n.length&&(this.app.editor.setFocus(),t&&this.app.selection.select(n),this.app.block.set(n))},_setCaretInline:function(e){var t=this.app.block.get(),n=!1;t&&t.isEditable()&&(this.app.element.isEmptyOrImageInline(e.target)?this.app.caret.set(e.target,"after"):this.app.selection.isCollapsed()&&"CODE"===e.target.tagName&&(n=!0,setTimeout(function(){var t=this.app.selection.getElement();t&&n&&"CODE"!==t.tagName&&(this.app.caret.set(e.target,"start"),n=!1)}.bind(this),1)))},_drop:function(e,t,n,r){var o="after"===n?"getFirstLevel":"getDataBlock",i=this.app.element[o](e.target);i=0===i.length?this.app.blocks.getFirst():i,this.app.block.set(i),n||this.app.insertion.insertPoint(e);var a=!0,s=!0,l=this.app.block.get(),c=this.app.editor.isAllSelected();if(l&&"pre"===l.getType()&&!c&&(a=!1,s=!1,t=this.app.content.getTextFromHtml(t,{nl:!0,trimlines:!1})),!1===r&&(a=!1,t=this.app.autoparse.parse(t)),""!==t)return t=a?this.app.autoparse.parse(t):t,this.app.insertion.insertContent({html:t,clean:a,parse:s,position:n})},_paste:function(e){e.preventDefault();var t=e.clipboardData;if(!this.app.image.insertFromClipboard(t)){var n=t.getData("URL"),r=this.app.clipboard.getContent(t);this.pasteEvent=!0;var o=this.app.broadcast("editor.before.paste",{e,html:r});if(o.isStopped())this.pasteEvent=!1;else{r=o.get("html"),r=n&&""!==n?n:r;var i=this.app.block.get(),a=!0,s=!0,l=this.app.editor.isAllSelected();if(this.opts.paste.plaintext?(a=!1,s=!1,r=this.app.content.getTextFromHtml(r,{br:!0})):i&&"pre"===i.getType()&&!l?(a=!1,s=!1,r=this.app.content.getTextFromHtml(r,{nl:!0,trimlines:!1})):this.opts.paste.clean||(a=!1),r=this.opts.paste.links?r:this.app.content.removeTags(r,["a"]),""!==(r=this.opts.paste.images?r:this.app.content.removeTags(r,["img"]))){var c=t.getData("text/rtf");if(c){var u=this._findLocalImages(r);r=this._replaceLocalImages(r,u,this._extractImagesFromRtf(c))}r=a?this.app.autoparse.parse(r):r;var d=this.app.insertion.insertContent({html:r,clean:a,parse:s});this.opts.image.upload&&this.app.image.parseInserted(d),this.app.placeholder.toggle(),this.app.broadcast("editor.paste",d),this.pasteEvent=!1}else this.pasteEvent=!1}}},_copy:function(e){this._action(e,"copy")},_cut:function(e){this._action(e,"cut")},_action:function(e,t){var n=!1,r={},o=this.app.block.get();if(!(o&&o.isEditable()&&this.app.selection.isCollapsed())){this.app.blocks.isMeta()&&(o=this.app.blocks.getLastSelected()),e.preventDefault(),this.app.editor.isAllSelected()?r={html:this.app.editor.getLayout().html(),remove:"all"}:this.app.blocks.is()?r={html:this.app.selection.getHtml(),remove:"content"}:o&&o.isEditable()?r=this._copyFromEditable(t,o):o&&(r=this._copyFromNonEditable(t,o));var i=this.app.broadcast("editor.before."+t,{e,html:r.html});i.isStopped()||("cut"===t&&this._cutDeleteContent(r),n=i.get("html"),n=this.app.clipboard.setContent(e,n),this.app.broadcastHtml("editor."+t,n))}},_cutDeleteContent:function(e){"instance"===e.remove?(e.instance.remove(!0),this.app.control.close()):"all"===e.remove?this.app.editor.setEmpty():!1!==e.remove&&this.app.selection.deleteContents()},_copyFromEditable:function(e,t){var n=t.getType(),r=this.app.selection.getHtml(),o="content";if("figcaption"===n||"cell"===n)o="content";else if(t.isAllSelected())r=t.getOuterHtml(),o="instance";else if("list"===n){var i=t.getTag();-1!==(r=this.app.selection.getHtml()).search(/<li/gi)&&(-1===r.search(/^<li/g)&&(r="<li>"+r+"</li>"),r="<"+i+">"+r+"</"+i+">")}return{html:r,remove:o,instance:t}},_copyFromNonEditable:function(e,t){var n=t.getOuterHtml(),r=!1;return"cut"!==e||t.isSecondLevel()||(r="instance"),{html:n,remove:r,instance:t}},_findLocalImages:function(e){var t=[];return this.app.utils.wrap(e,(function(e){e.find("img").each((function(e){-1!==e.attr("src").search(/^file:\/\//)&&t.push(e.attr("src"))}))})),t},_extractImagesFromRtf:function(e){if(!e)return[];var t=/{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/,n=new RegExp("(?:("+t.source+"))([\\da-fA-F\\s]+)\\}","g"),r=e.match(n);if(!r)return[];for(var o=[],i=0;i<r.length;i++){var a=!1;-1!==r[i].indexOf("\\pngblip")?a="image/png":-1!==r[i].indexOf("\\jpegblip")&&(a="image/jpeg"),a&&o.push({hex:r[i].replace(t,"").replace(/[^\da-fA-F]/g,""),type:a})}return o},_convertHexToBase64:function(e){return btoa(e.match(/\w{2}/g).map((function(e){return String.fromCharCode(parseInt(e,16))})).join(""))},_replaceLocalImages:function(e,t,n){if(t.length===n.length)for(var r=0;r<t.length;r++){var o="data:"+n[r].type+";base64,"+this._convertHexToBase64(n[r].hex);e=e.replace(new RegExp('src="'+t[r]+'"',"g"),'src="'+o+'"')}return e}}),l.add("module","block",{init:function(){this.instance=!1,this.$block=!1},create:function(e){var t=this.app.create("block.paragraph");return e&&t.getBlock().html(e),t},createHtml:function(e){return this.create(e).getOuterHtml()},is:function(e){return e?this._isBlockActive(e):this.get()},isType:function(e){if(this.is())return this.get().isType(e)},get:function(){return this.instance},set:function(e,t,n){e&&(e.isBlock&&(e=e.isNested()?t&&"end"===t?e.getLast().getBlock():e.getFirst().getBlock():e.getBlock()),this.app.blocks.unset(),this.app.editor.unsetSelectAll(),!0!==n&&this._isBlockActive(e)||(this.unset(),this.instance=this._getInstance(e),this.$block=this.instance.getBlock(),this.$block.addClass(this.prefix+"-block-focus"),this._setCaret(t),this.app.toolbar.build(),this.app.control.build(),this.app.broadcast("block.set")))},unset:function(){this.instance&&(this.$block.removeClass(this.prefix+"-block-focus"),this.instance=!1,this.$block=!1,this.app.popup.close(),this.app.control.close(),this.app.context.close(),this.app.broadcast("block.unset"))},observe:function(e,t){if(-1!==["line","quote","pre"].indexOf(t)&&!this.opts[t])return!1},format:function(e){this.app.format.set(e)},add:function(e){this.app.popup.close();var t=this.get();this.app.blocks.isMeta()&&(t=this.app.blocks.getLastSelected()),e.type&&"image"===e.type&&t&&"cell"===t.getType()&&(t=t.getParent("table"));var n,r="after";if(e&&e.template)return t||(r=this.opts.editor.add),void this.app.insertion.insertContent({html:e.template,position:r});n=e.instance?e.instance:this.app.create("block."+e.name,e.source),t?(t.isSecondLevel()&&(t=t.getFirstLevel()),t.isEditable()&&(r=e&&e.position?e.position:this.app.insertion.detectPosition(t.getBlock(),!1))):"top"===this.opts.editor.add?(t=this.app.blocks.getFirst(),r="before"):(t=this.app.blocks.getLast(),r="after");var o=!0;if(t){var i=t.getType();"paragraph"===e.name&&-1!==["paragraph","heading"].indexOf(i)&&(o=!1)}return t.insert({instance:n,caret:e.caret?e.caret:"end",position:r,remove:o,type:"add"}),n},change:function(e){var t=this._getCurrentInstance();t&&t.change(e)},duplicate:function(){if(this.app.popup.close(),this.is()){var e=this.get();e.isSecondLevel()&&(e=e.getFirstLevel());var t=e.duplicate(),n=e.insert({instance:t,caret:"start",type:"duplicate"});return this.app.broadcast("block.duplicate",{instance:n}),n}},remove:function(e){var t;this.app.popup.close();var n=this.get();if(n){n.isSecondLevel()&&(n=n.getFirstLevel());var r=n.getType();if("image"===r&&(t={url:n.getSrc(),id:n.getId()}),!e||void 0===e.tarverse||!1!==e.tarverse){var o=n.getNext(),i=n.getPrev();n.remove(),o?this.app.block.set(o,"start"):i?this.app.block.set(i,"end"):this.unset()}else this.unset(),n.remove();"image"===r&&this.app.broadcast("image.remove",t),this.app.broadcast("block.remove",{type:r}),this.app.editor.isEmpty()&&this.app.editor.setEmpty()}},moveUp:function(){var e=this._getCurrentInstance();e&&(e.isSecondLevel()&&(e=e.getFirstLevel()),e.moveUp())},moveDown:function(){var e=this._getCurrentInstance();e&&(e.isSecondLevel()&&(e=e.getFirstLevel()),e.moveDown())},getData:function(){if(this.is())return this.get().getData()},setData:function(e){if(this.is()){var t=e.getData();this.get().setData(t)}},_isBlockActive:function(e){return this.instance&&this.dom(e).get()===this.$block.get()},_getCurrentInstance:function(){var e;return this.app.blocks.isMeta()?e=this.app.blocks.getLastSelected():this.is()&&(e=this.get()),e},_getInstance:function(e){return this.dom(e).dataget("instance")},_setCaret:function(e){var t=this.instance.getType(),n=this.get();-1!==["embed","image","line","layer"].indexOf(t)?(this.app.scroll.save(),this.$block.attr("tabindex","-1"),this.$block.focus(),setTimeout(function(){this.app.selection.removeAllRanges()}.bind(this),1),this.app.scroll.restore()):n.isEditable()&&e&&this.instance.setCaret(e)}}),l.add("module","observer",{init:function(){this.observer=!1,this.trigger=!0},build:function(){if(window.MutationObserver){var e=this.app.editor.getEditor().get();this.observer=this._build(e),this.observer.observe(e,{attributes:!0,subtree:!0,childList:!0,characterData:!0,characterDataOldValue:!0})}},stop:function(){this.observer&&this.observer.disconnect(),this.trigger=!0},isButtons:function(){return!this.app.blocks.isMeta()&&!this.app.editor.isAllSelected()&&!(!this.opts.buttons.tags&&!this.opts.buttons.types)},buildButtons:function(e,t){for(var n,r=this.app.block.get(),o=!!r&&r.getType(),i=!!r&&r.getTag(),a=this.app.selection.getNodes({type:"inline",selected:"inside",links:!0}),s=this._getObservedTags(i,a),l=[],c=0;c<s.length;c++)(n=e[s[c]])&&(l=l.concat(n));return o&&(n=t[o])&&(l=l.concat(n)),l},buildActiveButtons:function(e){var t={};for(var n in t.tags=this.opts.buttons.tags?this.opts.buttons.tags:{},t.types=this.opts.buttons.types?this.opts.buttons.types:{},e)if(e.hasOwnProperty(n)){var r=e[n].active;r&&(this._buildActiveButton(n,r.tags,t.tags),this._buildActiveButton(n,r.types,t.types))}return t},_build:function(e){var t=this;return new MutationObserver((function(n){t._observe(n[n.length-1],e)}))},_observe:function(e,t){"attributes"===e.type&&e.target===t||this.trigger&&(this.app.broadcast("observer.change"),this.app.placeholder.toggle(),this.app.sync.trigger())},_buildActiveButton:function(e,t,n){if(t){for(var r=0;r<t.length;r++){var o=t[r];n[o]?n[o].push(e):n[o]=[e]}return n}},_getObservedTags:function(e,t){var n=[];if(e&&n.push(e),t.length>0)for(var r=0;r<t.length;r++)n.push(t[r].tagName.toLowerCase());return n}}),l.add("module","input",{handle:function(e){var t=e.get("e"),n=e.get("key");if(!this._doSelectAll(t,e))if(e.is("enter")&&e.is("shift"))this.handleShiftEnter(t,n,e);else if(e.is("enter"))this.handleEnter(t,n,e);else if(e.is("space")&&e.is("shift"))this.handleShiftSpace(t,n,e);else if(e.is("space"))this.handleSpace(t,n,e);else if(e.is("tab")&&this.opts.tab.key)this.handleTab(t,n,e);else if(e.is("arrow")){if(e.is("ctrl")&&e.is("up"))return void this.handleArrowCtrl(t,n,e);if(e.is(["shift","alt","ctrl"]))return;this.handleArrow(t,n,e)}else e.is(["delete","backspace"])&&this.handleDelete(t,n,e)},handleDelete:function(e,t,n){var r,o=this.app.block.get(),i=n.is("backspace"),a=n.is("delete");if(this.app.editor.isEmpty(!0))e.preventDefault();else{if(this.app.blocks.isMeta())return e.preventDefault(),void this.app.blocks.removeSelected();if(this.app.blocks.is()){e.preventDefault();var s=this.app.blocks.getFirstSelectedBlock(),l=this.dom(s);return this.app.selection.deleteContents(),this.app.block.set(l,"end"),void this.app.block.get().appendNext()}if(!this._deleteInsideSelection(e)){if(!o)return e.preventDefault(),void this.app.selection.deleteContents();if(!(o&&o.isEditable()&&this._trimInvisibleChar(e,n.is("backspace")?"left":"right",a))){var c=this.app.selection.getInline();if(c&&1===c.innerHTML.length)return e.preventDefault(),void(c.innerHTML="");if(!o.handleDelete||!o.handleDelete(e,t,n)){var u=o.getNext(),d=o.getPrev();if(o.isEditable()){if(o.isEditable()){if(o.isAllSelected())return e.preventDefault(),o.setEmpty(),this.app.caret.set(o.getBlock(),"start"),void this.app.toolbar.observe();if(o.isSecondLevel()||o.isFigcaption())return;if(a&&u&&o.isCaretEnd())return e.preventDefault(),void(u.isEditable()?"pre"===u.getType()?(this.app.blocks.setMeta(u.getBlock()),o.isEmpty()&&o.remove(!0)):o.appendNext():(u.isNested()?this.app.blocks.setMeta(u.getBlock()):this.app.block.set(u),o.isEmpty()&&o.remove(!0)));if(i&&d&&o.isCaretStart())return e.preventDefault(),void(d.isEditable()?"pre"===d.getType()?(this.app.blocks.setMeta(d.getBlock()),o.isEmpty()&&o.remove(!0)):(o.appendToPrev(),this.app.control.updatePosition()):(d.isNested()?this.app.blocks.setMeta(d.getBlock()):this.app.block.set(d),o.isEmpty()&&o.remove(!0)));if(!this.app.selection.isCollapsed())return e.preventDefault(),void this.app.selection.deleteContents()}}else e.preventDefault(),"image"===o.getType()&&(r={url:o.getSrc(),id:o.getId()}),o.remove(!0),"image"===o.getType()&&this.app.broadcast("image.remove",r),u?this.app.block.set(u,"start"):d?this.app.block.set(d,"end"):this.app.editor.isEmpty()?this.app.editor.setEmpty():this.app.block.unset()}}}}},handleArrowCtrl:function(e,t,n){this.app.editor.unselectAll(),this.app.selection.removeAllRanges(),this.app.editor.setFocus("start")},handleArrow:function(e,t,n){var r=this.app.block.get();if(this.app.editor.isAllSelected()){e.preventDefault();var o=n.is("down-right")?this.app.blocks.getLast():this.app.blocks.getFirst(),i=n.is("down-right")?"end":"start";return this.app.editor.unselectAll(),this.app.selection.removeAllRanges(),void this.app.block.set(o,i)}if(!this.app.blocks.is()){if(this.app.blocks.isMeta())return r=this.app.blocks.getLastSelected(),void this._doArrow(e,n,r);if(r.isEditable()){var a=this.app.selection.getTopInline();if(n.is("right")&&a&&"CODE"===a.tagName){var s=this.app.caret.is(a,"end"),l=this.app.caret.is(r.getBlock(),"end");if(s&&l)return e.preventDefault(),void this.app.caret.set(a,"after")}}r.isEditable()&&this._trimInvisibleChar(e,n.is("left")?"left":"right")||r.handleArrow&&r.handleArrow(e,t,n)||this._doArrow(e,n,r)}},handleTab:function(e,t,n){var r,o=this.app.block.get();if(this.app.blocks.isMeta())return e.preventDefault(),void((r=(o=this.app.blocks.getLastSelected()).getNext())&&this.app.block.set(r,"start"));if(this.app.blocks.is()){var i=this.app.blocks.getLastSelectedBlock();(o=this.dom(i).dataget("instance")).isSecondLevel()&&(o=o.getFirstLevel())}if(!o.handleTab||!o.handleTab(e,t,n))if(this.opts.tab.spaces&&o.isEditable()){e.preventDefault();var a=this.opts.tab.spaces,s=document.createTextNode(Array(a+1).join(" "));this.app.insertion.insertNode(s,"end")}else e.preventDefault(),(r=o.getNext())&&this.app.block.set(r,"start")},handleShiftSpace:function(e){var t=this.app.block.get();if(this.app.blocks.isMeta())e.preventDefault();else{if(this.app.blocks.is()){e.preventDefault();var n=this.app.blocks.getFirstSelectedBlock(),r=this.dom(n);return this.app.selection.deleteContents(),this.app.caret.set(r,"end"),void this.app.insertion.insertHtml("&nbsp;","end")}if(t.isEditable()){if(t.isAllSelected())return e.preventDefault(),void t.setEmpty();if("pre"!==t.getType())return e.preventDefault(),void this.app.insertion.insertHtml("&nbsp;","end")}}},handleSpace:function(e,t,n){var r=this.app.block.get();if(this.app.blocks.isMeta())return e.preventDefault(),this.app.blocks.getLastSelected().insertEmpty({position:"after",caret:"start"}),void this.app.blocks.removeSelected(!1);if(this.app.blocks.is()){var o=this.app.blocks.getFirstSelectedBlock(),i=this.dom(o);return this.app.selection.deleteContents(),void this.app.caret.set(i,"end")}return r.handleSpace&&r.handleSpace(e,t,n)?void 0:r.isEditable()&&r.isAllSelected()?(e.preventDefault(),void r.setEmpty()):void(r.isEditable()||(e.preventDefault(),r.insertEmpty({position:"after",caret:"start"}),r.remove(!0)))},handleShiftEnter:function(e){if(this.app.blocks.isMeta())e.preventDefault();else{if(this.app.blocks.is()){e.preventDefault();var t=this.app.blocks.getFirstSelectedBlock(),n=this.dom(t);return this.app.selection.deleteContents(),this.app.caret.set(n,"end"),void this.app.insertion.insertBreakline()}if(!this._deleteInsideSelection(e)){var r=this.app.block.get();r.isEditable()?(e.preventDefault(),this.app.insertion.insertBreakline()):(e.preventDefault(),r.insertEmpty({position:"after",caret:"start"}))}}},handleEnter:function(e,t,n){if(this.app.blocks.isMeta())return e.preventDefault(),void this.app.blocks.getLastSelected().insertEmpty({position:"after",caret:"start"});if(this.app.blocks.is())return e.preventDefault(),void this.app.selection.deleteContents();if(!this._deleteInsideSelection(e)){var r=this.app.block.get();if(r.isEditable()){if(r.isAllSelected())return e.preventDefault(),void r.setEmpty();if(!this.app.selection.isCollapsed())return e.preventDefault(),void("pre"===r.getType()?this.app.insertion.insertNewline():this.app.insertion.insertBreakline())}r.isEditable()||(e.preventDefault(),r.insertEmpty({position:"after",caret:"start"})),r.handleEnter&&r.handleEnter(e,t,n)}},handleTextareaTab:function(e){if(9!==e.keyCode)return!0;e.preventDefault();var t=e.target,n=t.value,r=t.selectionStart;t.value=n.substring(0,r)+"    "+n.substring(t.selectionEnd),t.selectionStart=t.selectionEnd=r+4},_deleteInsideSelection:function(e){if(!this.app.selection.isCollapsed()){var t=this.app.selection.getNodes({type:"blocks"});if(t.length>1)return e.preventDefault(),this.app.selection.deleteContents(),this.app.caret.set(t[0],"end"),!0}return!1},_doSelectAll:function(e,t){return this._isAllSelected(t)?(this._setEditorEmpty(e,t),!0):t.is("select")?(e.preventDefault(),this.app.editor.selectAll(),!0):void 0},_doArrow:function(e,t,n){var r,o,i=n.getType(),a=["pre","line","image","embed","layer"];if(t.is("up-left")&&n.isCaretStart()){if(o="end",!(r=n.getPrev())&&-1!==a.indexOf(i))return void this.app.insertion.insertEmptyBlock({position:"before",caret:"start"})}else if(t.is("down-right")&&n.isCaretEnd()&&(o="start",!(r=n.getNext())&&-1!==a.indexOf(i)))return void this.app.insertion.insertEmptyBlock({position:"after",caret:"start"});r&&(e.preventDefault(),this.app.block.set(r,o))},_isAllSelected:function(e){return this.app.editor.isAllSelected()&&e.is(["enter","delete","backspace","alpha","space"])},_setEditorEmpty:function(e,t){t.is(["alpha","space"])||e.preventDefault(),this.app.editor.setEmpty()},_trimInvisibleChar:function(e,t,n){var r,o="left"===t?"before":"after",i=this.app.selection.get(),a=this._isInvisibleChar(o);if(a&&"left"===t)r=i.current,this.dom(r).replaceWith(r.textContent.replace(/\uFEFF/g,""));else if(a&&n&&i.current&&i.current.nextSibling)r=i.current.nextSibling,this.dom(r).replaceWith(r.textContent.replace(/\uFEFF/g,""));else if(a&&"right"===t){e.preventDefault();var s=this.app.offset.get();return this.app.offset.set(!1,{start:s.start+1,end:s.end+1}),!0}},_isInvisibleChar:function(e){var t=this.app.selection.get(),n=this.app.selection.getText(e);return t.current&&3===t.current.nodeType&&0===this.app.utils.searchInvisibleChars(n)}}),l.add("module","insertion",{init:function(){this._clear()},start:function(){this.win=this.app.$win.get(),this.doc=this.app.$doc.get()},getFirstInserted:function(){return this.inserted.instances[0]},getLastInserted:function(){var e=this.inserted.instances.length,t=this.inserted.instances[e-1];return t&&t.isFigcaption()&&(t=t.getFigure()),t},getInserted:function(){return this.inserted},setContent:function(e){this._insert(e,"set");var t=this.getInserted();return this.inserted=!1,t},insertContent:function(e){this._insert(e,"insert");var t=this.getInserted();return this.inserted=!1,t},insertEmptyBlock:function(e){e||(e={}),e.html=this.app.block.createHtml(),this._insert(e,"insert");var t=this.getInserted();return this.inserted=!1,this.app.broadcast("block.add",{instance:t.instances[0],type:"input"}),t},insertNewline:function(e,t){var n=t?"\n\n":"\n";return this._insertFragment({node:document.createTextNode(n)},e||"after")},insertPoint:function(e){var t,n=this.app.utils.createInvisibleChar(),r=e.clientX,o=e.clientY;if(this.doc.caretPositionFromPoint){var i=this.doc.caretPositionFromPoint(r,o);(t=this.doc.getSelection().getRangeAt(0)).setStart(i.offsetNode,i.offset),t.collapse(!0),t.insertNode(n)}else this.doc.caretRangeFromPoint&&(t=this.doc.caretRangeFromPoint(r,o)).insertNode(n);this.app.caret.set(n,"after")},insertBreakline:function(e){var t=this.app.selection.getNodes({type:"inline"});return this.app.selection.isCollapsed()&&0!==t.length?this._splitInline(t,document.createElement("br")):this._insertFragment({node:document.createElement("br")},e||"after")},insertNode:function(e,t,n){if(n){var r=this.app.selection.getNodes({type:"inline"});if(0!==r.length)return this._splitInline(r,e)}return this._insertFragment({node:this.dom(e).get()},t)},insertHtml:function(e,t){return this._insertFragment({html:e},t)},insertText:function(e,t){var n=this.app.block.get();if(!(n&&!n.isEditable()||this.app.blocks.isMeta())){var r,o=this.win.getSelection();if(o.getRangeAt&&o.rangeCount){e=this.app.content.getTextFromHtml(e,{nl:!0}),r=document.createTextNode(e);var i=o.getRangeAt(0);i.deleteContents(),i.insertNode(r),t=t||"end",this.app.caret.set(r,t)}return r}this.insertContent({html:e,caret:t})},insertListToList:function(e,t,n){var r=e.find("li"),o=r.last();r.addClass(this.prefix+"-pasteitems"),o.addClass(this.prefix+"-pastemarker");var i=e.children(),a=this.dom(this.app.selection.getBlock()),s=this.app.caret.is(t,"start"),l=this.app.caret.is(t,"end"),c=this.app.caret.is(a,"start"),u=this.app.caret.is(a,"end",["ul","ol"]),d=this.app.content.isEmptyHtml(a.html());if(s)d&&a.remove(),t.prepend(i);else if(l)d&&a.remove(),t.append(i);else if(d)a.after(i),a.remove();else if(c)a.before(i);else if(u){var p=a.find("ul, ol");0!==p.length?p.prepend(i):a.after(i)}else this.app.element.split(a).before(i);var f=this.prefix+"-pastemarker",h=this.prefix+"-pasteitems";return n&&(o=this.app.editor.getEditor().find("."+f).removeClass(f),this.app.caret.set(o,"end")),this.app.editor.getEditor().find("."+h).removeClass(h)},detectPosition:function(e,t){if(t)return t;var n=this.app.caret.is(e,"start");return t=this.app.caret.is(e,"end")?"after":n?"before":"split"},_insert:function(e,t){this.html=e.html,this.html=this.app.broadcastHtml("editor.before.insert",this.html),this.isParse=void 0===e.parse||e.parse,this.isClean=void 0!==e.clean&&e.clean,this.isCaret=void 0===e.caret||e.caret,this.isPosition=void 0!==e.position&&e.position,this.isCurrent=void 0!==e.current&&e.current,"set"===t||this.app.editor.isAllSelected()?this._setContent():this._insertContent(),this.app.broadcast("editor.insert",this.inserted)},_insertContent:function(){var e,t,n=this.isCurrent?this.isCurrent:this.app.block.get(),r=!1,o=!1;if(this._checkEmpty(),this._checkLine(),this.app.blocks.isMeta()||this.app.blocks.is()){if(this.isEmpty)return;var i;if(this.isLine&&(this.html=this.app.block.createHtml(this.html)),this._clean(),this._parse(),this._parseBuild(),e=this._buildParsedNodes(),this.app.blocks.is()){if(!(i=this.app.blocks.getLastSelectedBlock()))return;n=(t=this.dom(i)).dataget("instance"),this.app.selection.deleteContents(),this._insertToEditable(n,t,e)}else{(i=this.app.blocks.getLastSelected()).getBlock().after(e),this.app.blocks.removeSelected(!1)}}else if(!n||this.isPosition){if(this.isEmpty)return;this.isLine&&(this.html=this.app.block.createHtml(this.html)),this._clean(),this._parse(),this._parseBuild(),e=this._buildParsedNodes();"top"===this.isPosition||!this.isPosition&&"top"===this.opts.editor.add?(n=this.app.blocks.getFirst(),r="before"):n&&-1!==["after","before","append"].indexOf(this.isPosition)?r=this.isPosition:(n=this.app.blocks.getLast(),r="after"),(t=n.getBlock())[r](e)}else if(this._isListToList(n)){this.app.selection.deleteContents(),this._clean(),this._parse(),this._parseBuild(),t=n.getBlock();var a=this.$parsed.children().first();this.$nodes=this.insertListToList(a,t,"end"),this.isCaret=!1}else{if(!n)return;if(n.isEditable()){if(this.isEmpty)return;this._clean(),this._cleanSpecial(n),this.isLine?this._parseLine():this._parse(),this._parseBuild(),n.isEmpty()?(o=!0,r="after"):this.app.selection.deleteContents(),e=this._buildParsedNodes(),t=n.getBlock(),this._insertToEditable(n,t,e,r,o)}else{if(r="after",this.isEmpty)return;this.isLine&&(this.html=this.app.block.createHtml(this.html)),this._clean(),this.isLine?this._parseLine():this._parse(),this._parseBuild(),e=this._buildParsedNodes(),(t=n.getBlock())[r](e)}}this._buildInserted(),this._buildEditor(),this._buildCaret()},_insertToEditable:function(e,t,n,r,o){this.isLine?(this.$nodes=this._insertFragment({fragment:this.$parsed.get()},"end"),this.isCaret=!1):(this.app.content.isEmptyHtml(t.html())?(r="after",o=!0):r=this.detectPosition(t,r),"split"===r?this.app.element.split(t).before(n):t[r](n),o&&e.remove())},_insertFragment:function(e,t){var n;if(e.html||e.fragment?(n=this.app.fragment.build(e.html||e.fragment),this.app.fragment.insert(n)):this.app.fragment.insert(e.node),t){var r=e.node?e.node:"start"===t?n.first:n.last;this.app.caret.set(r,t)}return e.node?this.dom(e.node):this.dom(n.nodes)},_setContent:function(){this._checkEmpty(),this._checkLine(),this.isEmpty?this.html=this.app.block.createHtml():this.isLine&&(this.html=this.app.block.createHtml(this.html)),this._clean(),this._parse(),this._parseBuild();var e=this._buildParsedNodes();this.app.editor.unsetSelectAll(),this.app.editor.getEditor().html("").append(e),this.isEmpty&&this.app.broadcast("editor.empty"),this._buildInserted(),this._buildEditor(),this._buildCaret(),this.app.broadcast("editor.set",this.inserted)},_splitInline:function(e,t){var n=this.app.element.split(e[0]);return n.before(t),""===n.html()&&n.remove(),this.dom(t)},_buildEditor:function(){this.app.placeholder.trigger(),this.app.editor.build(),this.app.editor.setFocus(),this.app.toolbar.observe(),this.app.context.observe()},_buildCaret:function(){if(this.isCaret){var e,t="end";"start"===this.isCaret?(e=this.getFirstInserted(),t="start"):e=this.getLastInserted(),e&&this.app.block.set(e,t)}},_buildInserted:function(){this.inserted={$nodes:this.$nodes,instances:[]},this.inserted.$nodes.each(this._buildInstance.bind(this))},_buildInstance:function(e){var t=e.dataget("instance");t&&this.inserted.instances.push(t)},_buildParsedNodes:function(){return this.$parsed.get().childNodes},_clear:function(){this.html=!1,this.isLine=!1,this.isEmpty=!1,this.isSplit=!1,this.isClean=!1,this.isParse=!0,this.isCaret=!0,this.isCurrent=!1,this.isPosition=!1},_clean:function(){this.isClean&&(this.html=this.app.cleaner.cleanHtml(this.html))},_cleanSpecial:function(e){var t,n,r=e.getType();-1!==["cell","address","figcaption","quoteitem"].indexOf(r)?t=!0:"list"===r&&(t=!0,n=["ul","ol","li"]),t&&(this.isLine=!0,this.html=this.app.content.addBrToBlocks(this.html),this.html=this.app.content.removeBlockTags(this.html,undefined,n),this.html=this.html.replace(/<br\s?\/?>\n?$/gi,""))},_parse:function(){this.isParse&&(this.html=this.app.parser.parse(this.html,!1))},_parseLine:function(){this.isParse&&(this.html=this.app.parser.parseLine(this.html,!1))},_parseBuild:function(){this.$parsed=this.app.parser.build(this.html),this.$nodes=this.$parsed.children()},_checkEmpty:function(){this.isEmpty=this.app.content.isEmptyHtml(this.html)},_checkLine:function(){this.isLine=this.app.content.isLine(this.html)},_isListToList:function(e){var t=e.getBlock().attr("data-"+this.prefix+"-type"),n=this.dom("<div>").html(this.html);return n.find("meta").remove(),n.find("b").unwrap(),n=n.children().first(),"list"===t&&0!==n.length&&-1!==["ul","ol"].indexOf(n.get().tagName.toLowerCase())}}),l.add("module","toolbar",{init:function(){this.eventname=this.prefix+"-toolbar",this.activeClass="active",this.toggledClass="toggled",this.disableClass="disable",this.customButtons={},this.aTags={},this.aTypes={}},start:function(){this.$container=this.app.container.get("toolbar"),this.opts.toolbar&&(this._build(),this._buildSticky())},load:function(){this.opts.toolbar&&(this._buildActiveButtons(),this.app.block.get()||(this.$toolbar.html(""),this._buildButtons()))},stop:function(){this.opts.toolbar&&(this.$toolbar.remove(),this.customButtons={},this.editorButtons={})},build:function(){if(this.opts.toolbar){var e=this.app.block.get();e&&e.isSecondLevel()&&(e=e.getFirstLevel());var t=this.app.editor.getButtonsFromArr(this.opts.buttons.editor);e&&e.toolbar&&(t=this.app.editor.getButtonsFromArr(e.toolbar)),this.$toolbar.html("");var n=this._createButtons(t,e);e||this._checkIntialToolbar(n)}},observe:function(){if(this.opts.toolbar&&(this.unsetActive(),this.app.observer.isButtons())){var e=this.app.observer.buildButtons(this.aTags,this.aTypes);this._setActiveKeys(e)}},getElement:function(){return this.$toolbar},get:function(e){return this._findButton(e)},add:function(e,t){this.customButtons[e]=t},setActive:function(e){this.opts.toolbar&&(this._findButtons().removeClass(this.activeClass),this._findButton(e).removeClass(this.disableClass).addClass(this.activeClass))},setToggled:function(e){this.opts.toolbar&&(this._findButtons().removeClass(this.toggledClass),this._findButton(e).removeClass(this.disableClass).addClass(this.toggledClass))},unsetActive:function(e){this.opts.toolbar&&(e?this._findButton(e):this._findButtons()).removeClass(this.activeClass)},unsetToggled:function(e){this.opts.toolbar&&(e?this._findButton(e):this._findButtons()).removeClass(this.toggledClass)},enable:function(){this.opts.toolbar&&this._findButtons().removeClass(this.disableClass)},disable:function(){this.opts.toolbar&&this._findButtons().removeClass(this.toggledClass).removeClass(this.activeClass).addClass(this.disableClass)},disableSticky:function(){var e=this.app.container.get("toolbar");e.removeClass(this.prefix+"-toolbar-sticky"),e.css("top","")},enableSticky:function(){if(this.opts.toolbar.sticky){var e=this.app.container.get("toolbar");e.addClass(this.prefix+"-toolbar-sticky"),e.css("top",this.opts.toolbar.stickyTopOffset+"px")}},isSticky:function(){var e=this.app.container.get("toolbar"),t=this.app.container.get("main"),n=t.offset().top+parseInt(t.css("border-top-width")),r=e.offset().top;return r>n||r<n},_build:function(){this.$toolbar=this.dom("<div>").addClass(this.prefix+"-toolbar"),this.$container.append(this.$toolbar),this.$container.addClass("is-"+this.prefix+"-toolbar")},_buildSticky:function(){this.opts.toolbar.sticky&&(this._toggleSticky("add",this.opts.toolbar.stickyTopOffset+"px"),this._startEvent())},_buildButtons:function(){var e=this.app.editor.getButtonsFromArr(this.opts.buttons.editor),t=this._createButtons(e);this._checkIntialToolbar(t)},_buildActiveButtons:function(){var e=this.app.observer.buildActiveButtons(this.customButtons);this.aTags=e.tags,this.aTypes=e.types},_checkIntialToolbar:function(e){if(0===e&&!this.opts.topbar){var t=this.app.blocks.getFirst(),n=this.app.editor.getButtonsFromArr(t.toolbar);this.$toolbar.html(""),this._createButtons(n,t),this.disable()}},_findButtons:function(){return this.$toolbar.find("."+this.prefix+"-button-toolbar")},_findButton:function(e){return this.$toolbar.find("[data-name="+e+"]")},_createButtons:function(e,t){var n=e;t&&(n=u.extend(!0,{},e,this.customButtons));var r=0;for(var o in n)if(n.hasOwnProperty(o)){if("add"===o&&!this.opts.addbar)continue;if("html"===o&&!this.opts.source)continue;if("format"===o&&!this.opts.format)continue;if(t&&!t.isAllowedButton(o,n[o]))continue;if(this._isHidden(o))continue;this.app.create("button",o,n[o],this.$toolbar,"toolbar"),r++}return r},_isHidden:function(e){return-1!==this.opts.toolbar.hide.indexOf(e)},_setActiveKeys:function(e){for(var t=0;t<e.length;t++)this._findButton(e[t]).addClass(this.activeClass)},_getObservedTags:function(e,t){var n=[];if(e&&n.push(e),t.length>0)for(var r=0;r<t.length;r++)n.push(t[r].tagName.toLowerCase());return n},_toggleSticky:function(e,t){var n="remove"===e?"removeClass":"addClass";this.$container[n](this.prefix+"-toolbar-sticky"),this.$container.css("top",t)},_startEvent:function(){this.app.scroll.getTarget().on("scroll."+this.eventname,this._observeSticky.bind(this))},_stopEvent:function(){this.app.scroll.getTarget().off("."+this.eventname)},_observeSticky:function(){if(this.app.source.is())this.$container.css("top",0);else{var e=this.app.scroll.getTarget(),t=this.app.scroll.isTarget()?parseInt(e.css("padding-top")):0;this.$container.css("top",0-t+this.opts.toolbar.stickyTopOffset+"px"),this.isSticky()?this.app.broadcast("toolbar.sticky"):this.app.broadcast("toolbar.static")}}}),l.add("module","addbar",{init:function(){this.custom={}},popup:function(e,t){if(this.opts.addbar){this.app.popup.create("addbar",{width:"380px",items:this.buildItems()});var n=t.isButton||t.isControl?{button:t}:{};this.app.popup.open(n)}},add:function(e,t){this.custom[e]=t,this.custom[e].container=!0,this.custom[e].addbar=!0,this.custom[e].command=t.command?t.command:"block.add",t.template&&(this.custom[e].params={template:t.template})},buildItems:function(){for(var e={},t=this.opts.buttons.addbar,n=u.extend(!0,{},this.opts.buttonsObj),r=0;r<t.length;r++){var o=t[r];this._isHidden(o)||(e[o]=n[o],e[o].container=!0,e[o].addbar=!0,e[o].icon=!0)}for(var i in this.opts.addbar.add)if(this.opts.addbar.add.hasOwnProperty(i)){if(this._isHidden(i))continue;e[i]=this.opts.addbar.add[i],e[i].container=!0,e[i].addbar=!0,e[i].command="block.add",e[i].params={template:this.opts.addbar.add[i].template}}return e=u.extend(!0,{},e,this.custom)},_isHidden:function(e){return-1!==this.opts.addbar.hide.indexOf(e)}}),l.add("module","format",{popup:function(e,t){for(var n=this.app.block.get(),r=!!n&&n.getBlock(),o=!!n&&n.getTag(),i=this.opts.format,a={},s=0;s<i.length;s++){var l=i[s];a[l]={title:this.opts.formatObj[l].title,params:{tag:l},command:"block.format",shortcut:this.opts.formatObj[l].shortcut}}if(this.opts.formatAdd){var c=this.opts.formatAdd;Object.keys(c).forEach((function(e){a[e]={title:c[e].title,params:c[e].params,command:"block.format"}}))}var u=this._isActiveFormat(r,o,a);u&&(a[u].active=!0),this.app.popup.create("format",{width:"300px",items:a}),this.app.popup.open({button:t})},set:function(e){if(this.app.popup.close(),!this.app.blocks.isMeta()){var t={type:this.opts.formatObj[e.tag].type,tag:e.tag,classname:e.classname||!1},n=this.app.blocks.getSelectedBlocks("editable"),r=this.app.block.get();r?this.setSingle(r,t,e):0!==n.length&&this.setMultiple(n,t,e)}},setSingle:function(e,t){var n,r=e.isEmpty(),o=!!r&&"start";this.tag=e.getTag(),this.type=e.getType(),this.$block=e.getBlock(),r||this.app.selection.saveMarker(),this._isSameTag(t)&&(t=this._checkSameFormat(this.$block,t)),t&&(this._isListToText(t,"list")?n=this._formatListToText(t):this._isListToText(t,"dlist")?n=this._formatListToText(t,!0):this._isTextToList(t,"list")?this._formatTextToList(t,!1,o):this._isTextToList(t,"dlist")?this._formatTextToList(t,!0,o):this._replaceTo(e,t,o)),r||this.app.selection.restoreMarker(),n&&this.app.block.unset(),e=this.app.block.get(),this.app.editor.build(),this.app.broadcast("block.format",{instance:e})},setMultiple:function(e,t){var n,r,o,i;this.app.selection.saveMarker(),this._isListTag(t.tag)&&this._isMultipleParagraphs()&&(i=(n=this.app.create("block."+t.type,!1,{tag:t.tag})).getBlock(),this.dom(e[0]).before(i));for(var a=0;a<e.length;a++){var s,l;if((o=e[a].tagName.toLowerCase())!==t.tag)if(i)s=this.dom("<li>").html(e[a].innerHTML),i.append(s),this.dom(e[a]).remove(),this._setStyleAndClass(i,t);else if(!this._isListTag(o)&&this._isListTag(t.tag))r=(n=this.app.create("block."+t.type,!1,{tag:t.tag})).getBlock(),s=this.dom("<li>").html(e[a].innerHTML),r.append(s),(l=this.dom(e[a])).after(r),l.remove(),this._setStyleAndClass(r,t);else if(this._isListTag(o)&&!this._isListTag(t.tag)){var c=(l=this.dom(e[a])).find("li");c.find("ul, ol").each((function(e){e.parent().after(e)})),c.find("ul, ol").unwrap(),c.each(function(e){var n=this.dom("<"+t.tag+">");n.html(e.html()),e.remove(),this.app.create("block."+t.type,n),l.before(n),this._setStyleAndClass(n,t)}.bind(this)),l.remove()}else n=this._replaceToBlock(e[a],t)}this.app.selection.restoreMarker(),i&&this.app.block.set(i),this.app.editor.build(),this.app.editor.unsetSelectAll(),this.app.broadcast("block.format",{instance:n})},_isListTag:function(e){return-1!==["ul","ol"].indexOf(e)},_isSameTag:function(e){return this.tag===e.tag&&this.type===e.type},_isMultipleParagraphs:function(){var e=this.app.blocks.getSelectedBlocks(),t=["P","ADDRESS","H1","H2","H3","H4","H5","H6"];if(e.length>1){for(var n=0,r=0;r<e.length;r++)-1===t.indexOf(e[r].tagName)&&n++;if(0===n)return!0}return!1},_checkSameFormat:function(e,t){var n=this.app.element.hasClass(e,t.classname);return!t.classname||n?this._buildDefaultFormat():t},_buildDefaultFormat:function(){return{type:"paragraph",tag:"p",classname:!1}},_formatListToText:function(e,t){var n=t?this._getDlistItems():this._getListItems();return this._createItems(n,e),this.$block.remove(),n},_formatTextToList:function(e,t,n){var r=this.app.create("block."+e.type,"<"+e.tag+">").getBlock();if(t&&"list"===this.type){var o=0;this._getListItems().each(function(e){var t=0===o?"dt":"dd",n=this.dom("<"+t+">").html(e.html());o="dt"===t?1:0,r.append(n)}.bind(this))}else if(t||"dlist"!==this.type){var i=t?"<dt>":"<li>",a=this.dom(i).html(this.$block.html());r.append(a)}else this._getDlistItems().each(function(e){var t=this.dom("<li>").html(e.html());r.append(t)}.bind(this));this.app.create("block."+e.type,r),this.$block.after(r),this.$block.remove(),this._setStyleAndClass(r,e),this.app.block.set(r,n)},_replaceTo:function(e,t,n){var r=e.getBlock(),o=(e=this._replaceToBlock(r,t)).getBlock();this.app.block.set(o,n)},_replaceToBlock:function(e,t){var n=this.app.element.replaceToTag(e,t.tag);return this._setStyleAndClass(n,t),this.app.create("block."+t.type,n)},_createItems:function(e,t){e.each(function(e){var n=this.dom("<"+t.tag+">");n.html(e.html()),e.remove(),this.app.create("block."+t.type,n),this.$block.before(n),this._setStyleAndClass(n,t)}.bind(this))},_isListToText:function(e,t){return this.type===t&&-1!==["heading","address","paragraph"].indexOf(e.type)},_isTextToList:function(e,t){var n="list"===t?"dlist":"list";return e.type===t&&-1!==["heading","address","paragraph",n].indexOf(this.type)},_isActiveFormat:function(e,t,n){if(e){var r;for(var o in n)if(n.hasOwnProperty(o)){var i=n[o].params.classname||!1;t===n[o].params.tag&&(i?i&&this.app.element.hasClass(e,i)&&(r=o):r=o)}return r}},_setStyleAndClass:function(e,t){e.removeAttr("style class data-"+this.prefix+"-style-cache"),t.classname&&e.addClass(t.classname)},_getListItems:function(){var e=this.$block.find("li");return e.find("ul, ol").each((function(e){e.parent().after(e)})),e.find("ul, ol").unwrap(),e},_getDlistItems:function(){return this.$block.find("dt, dd")}}),l.add("module","embed",{popups:{add:{title:"## embed.embed ##",width:"100%",form:{embed:{type:"textarea",label:"## embed.description ##",rows:6},caption:{type:"input",label:"## embed.caption ##"},responsive:{type:"checkbox",text:"## embed.responsive-video ##"}},footer:{insert:{title:"## buttons.insert ##",command:"embed.insert",type:"primary"},cancel:{title:"## buttons.cancel ##",command:"popup.close"}}},edit:{title:"## embed.embed ##",width:"100%",form:{embed:{type:"textarea",label:"## embed.description ##",rows:6},caption:{type:"input",label:"## embed.caption ##"},responsive:{type:"checkbox",text:"## embed.responsive-video ##"}},footer:{save:{title:"## buttons.save ##",command:"embed.save",type:"primary"},remove:{title:"## buttons.delete ##",command:"embed.remove",type:"danger",right:!0},cancel:{title:"## buttons.cancel ##",command:"popup.close"}}}},build:function(e){e?this._callScripts(e):this._findScripts()},observe:function(e,t,n){if(!this.opts.embed)return!1;var r=this.app.block.get();return n&&"addbar"===n.getName()?e.command="embed.popup":r&&"embed"===r.getType()&&(e.command="embed.edit"),e},popup:function(){this.app.popup.create("embed",this.popups.add),this.app.popup.open({focus:"embed"}),this.opts.embed.checkbox&&this.app.popup.getInput("responsive").attr("checked",!0),this._buildCodemirror()},edit:function(e){var t=this.app.block.get(),n={embed:t.getEmbedCode(),caption:t.getCaption(),responsive:t.isResponsive()};this.app.popup.create("embed",this.popups.edit),this.app.popup.setData(n),this.app.popup.open({focus:"embed"}),this._buildCodemirror()},insert:function(){this.app.popup.close();var e=this.app.popup.getData(),t=this._getEmbedCode(e);if(""!==t){var n=this._createInstance(e,t);this.app.block.add({instance:n})}},save:function(){this.app.popup.close();var e=this.app.block.get(),t=this.app.popup.getData(),n=this._getEmbedCode(t);if(""!==n){var r=this._createInstance(t,n,e);this._isNeedToChange(t,r,e)&&this.app.block.change(r)}else this.app.block.remove()},remove:function(){this.app.popup.close(),this.app.block.remove()},_buildCodemirror:function(){var e=this.app.popup.getInput("embed");this.app.codemirror.create({el:e,height:"200px",focus:!0}),this.app.popup.updatePosition()},_findScripts:function(){var e=this.app.editor.getEditor().find("[data-"+this.prefix+"-type=embed]").find("script").getAll();this.build.call(this,e)},_callScripts:function(e){for(var t=0;t<e.length;t++)if(""!==e[t].src){var n=e[t].src;this.app.$doc.find('head script[src="'+n+'"]').remove();var r=this.dom("<script>").attr({src:n,async:!0,defer:"true"});r.on("load",function(){if(-1!==n.search("instagram")){var r=this.app.$win.get();r.instgrm&&r.instgrm.Embeds.process()}this.build(e.slice(t+1))}.bind(this));var o=this.app.$doc.get().getElementsByTagName("head")[0];o&&o.appendChild(r.get())}},_getEmbedCode:function(e){var t=e.embed.trim();return t=this.app.codemirror.val(t),t=this._removeScript(t),t=this.app.content.sanitize(t),t=this._isHtmlString(t)||""===t?t:this._parseUrl(t)},_removeScript:function(e){return this.opts.embed.script||(e=this.app.content.removeTagsWithContent(e,["script"])),e},_createInstance:function(e,t,n){var r;n?(r=n.duplicate().getBlock()).html(t):r=this._isFigure(t)?t:"<figure>"+t+"</figure>";var o=this.app.create("block.embed",r);return o.setCaption(e.caption),e.responsive&&o.addResponsive(),o},_parseUrl:function(e){var t='<iframe width="560" height="315" src="',n='" frameborder="0" allowfullscreen></iframe>';if(e.match(this.opts.regex.youtube)){var r="//www.youtube.com";return-1!==e.search("youtube-nocookie.com")&&(r="//www.youtube-nocookie.com"),t+e.replace(this.opts.regex.youtube,r+"/embed/$1")+n}return e.match(this.opts.regex.vimeo)?t+e.replace(this.opts.regex.vimeo,"//player.vimeo.com/video/$2")+n:e},_isNeedToChange:function(e,t,n){return n.getEmbedCode()!==t.getEmbedCode()||(e.responsive!==n.isResponsive()||(e.caption!==n.getCaption()||void 0))},_isHtmlString:function(e){return/^\s*<(\w+|!)[^>]*>/.test(e)},_isFigure:function(e){return/^<figure/.test(e)}}),l.add("module","image",{popups:{add:{title:"## popup.add-image ##",width:"100%"},edit:{title:"## popup.image ##",width:"100%",getter:"block.getData",form:{width:{type:"input",width:"100px",label:"## image.width ##",observer:"image.observeImageWidth"},alt:{type:"input",label:"## image.alt-text ##"},caption:{type:"input",label:"## image.caption ##",observer:"image.observeImageCaption"},link:{type:"input",label:"## image.link ##",observer:"image.observeImageLink"},target:{type:"checkbox",text:"## image.link-in-new-tab ##",observer:"image.observeImageLink"}},footer:{save:{title:"## buttons.save ##",command:"image.save",type:"primary"},remove:{title:"## buttons.delete ##",command:"image.remove",type:"danger",right:!0},cancel:{title:"## buttons.cancel ##",command:"popup.close"}}}},init:function(){this.dataStates=[]},popup:function(){this.app.popup.create("image",this.popups.add);var e=this.app.popup.getBody();this._createImageByUrl(e),this._createOrSection(e),this._createUploadBox(e),this._createSelectBox(e),this.app.popup.open()},edit:function(e){this.app.popup.create("image-edit",this.popups.edit),this._buildEditUpload(),this.app.popup.open()},observe:function(e,t,n){if(!this.isImagePopup())return!1;var r=this.app.block.get();return n&&"addbar"===n.getName()?e.command="image.popup":r&&"image"===r.getType()&&(e.command="image.edit"),e},observeStates:function(){this._findImages().each(this._addImageState.bind(this))},observeImageLink:function(e){return!!this.opts.image.link&&e},observeImageCaption:function(e){var t=this.app.block.get();return!(!t||"figure"!==t.getTag())&&e},observeImageWidth:function(e){return!!this.opts.image.width&&e},isImagePopup:function(){return!1!==this.opts.image},paste:function(e,t){var n={url:this.opts.image.upload,name:this.opts.image.name,data:this.opts.image.data,multiple:this.opts.image.multiple,success:"image.insertFromBlob",error:"image.error"};this.app.create("upload").send(t,[e],n)},parseInserted:function(e){var t=this,n=[],r={url:this.opts.image.upload,name:this.opts.image.name,data:this.opts.image.data,multiple:!0,success:"image.insertFromInserted",error:"image.error"};this.pasteInsertedImages=[],this.resolved=[];for(var o,i,a,s,l=0,c=function(){if(o=e.instances[u],"image"===o.getType())if(-1!==(i=o.getSrc()).search(/^data:/i))a=t._dataURLtoFile(i,"image"+u),n.push(a),t.pasteInsertedImages.push(o);else if(-1!==i.search(/^blob:/i)){l++,t.pasteInsertedImages.push(o),s=t,function(e,t){var n=new XMLHttpRequest;n.open("GET",e,!0),n.responseType="blob",n.onload=function(e){if(200==n.status){var r=n.response,o=new File([r],"image"+t,{type:"image/png"});s.resolved.push(o)}},n.send()}(i,u)}},u=0;u<e.instances.length;u++)c();if(0!==l)var d=setInterval(function(){this.resolved.length===l&&(clearInterval(d),this.app.create("upload").send(!1,this.resolved,r))}.bind(this),100);0!==n.length&&this.app.create("upload").send(!1,n,r)},drop:function(e,t){for(var n=[],r=0;r<t.files.length;r++){var o=t.files[r]||t.items[r].getAsFile();o&&n.push(o)}var i={url:this.opts.image.upload,name:this.opts.image.name,data:this.opts.image.data,multiple:this.opts.image.multiple,success:"image.insertByDrop",error:"image.error"};if(n.length>0){var a=this.dom(e.target).closest("[data-"+this.prefix+"-type]");0!==a.length&&this.app.block.set(a),this.app.create("upload").send(e,n,i)}},insertFromClipboard:function(e){var t=e.getData("text/plain")||e.getData("text/html");if(""===(t=t.trim())){for(var n=e.items,r=null,o=0;o<n.length;o++)0===n[o].type.indexOf("image")&&(r=n[o].getAsFile());return null!==r?(this.paste(r),!0):void 0}},insertFromBlob:function(e){this.insert(e)},insertByDrop:function(e,t){if(this.app.block.is()){var n=this.app.block.get(),r=t.target,o=n.getType();if("card"===o&&r&&"IMG"===r.tagName&&n.hasImage()||"image"===o)return void this.change(e);t&&"card"!==o&&n.isEditable()&&this.app.insertion.insertPoint(t)}this.insert(e)},insertByUpload:function(e){this.insert(e)},insertByUrl:function(e){e.preventDefault();var t=this.$urlinput.val();if(""!==t.trim()){var n={file:{url:t,id:this.app.utils.getRandomId()}};this.insert(n)}},insertFromSelect:function(e){e.preventDefault();for(var t=this.dom(e.target),n={url:t.attr("data-url")},r=["id","alt","caption","link","width","height"],o=0;o<r.length;o++){var i=t.attr("data-"+r[o]);null!==i&&(n[r[o]]=i)}this.insert({file:n},!0)},insertFromInserted:function(e){var t=0;for(var n in e)e.hasOwnProperty(n)&&(this.pasteInsertedImages[t].setImage(e[n]),t++)},changeClone:function(e){for(var t in e)if(e.hasOwnProperty(t)){this.$imageclone.attr("src",e[t].url);break}this.change(e,!1)},change:function(e,t){!1!==t&&this.app.popup.close();var n=this.app.block.get();for(var r in e)if(e.hasOwnProperty(r))return n.setImage(e[r]),this.app.broadcast("image.change",e[r]),void this.app.broadcast("image.upload",{instance:n,data:e[r]});this.app.parser.buildPredefinedClasses()},save:function(e){this.app.popup.close(),this.app.block.setData(e)},insert:function(e,t){this.app.popup.close(),this.imageslen=0,this.imagescount=0;var n=this.opts.image.tag;for(var r in e)if(e.hasOwnProperty(r)){var o=this.dom("<"+n+">"),i=this._createImageFromResponseItem(e[r]);o.append(i);var a=this.app.create("block.image",o);if(this.app.block.add({instance:a,type:"image"}),Object.prototype.hasOwnProperty.call(e[r],"caption")){var s=this.dom("<figcaption>").html(e[r].caption);a.$block.append(s),this.app.create("block.figcaption",s)}var l=t?"select":"upload";this.app.broadcast("image."+l,{instance:a,data:e[r]}),this.$last=a.getBlock(),this.imageslen++}},remove:function(){this.app.popup.close(),this.app.block.remove()},error:function(e){this.app.broadcast("image.upload.error",{response:e})},getStates:function(){var e=this._findImages();for(var t in this.dataStates)if(this.dataStates.hasOwnProperty(t)){var n=this.dataStates[t],r=e.is('[data-image="'+n.id+'"]');this._setImageState(n.id,r)}return this.dataStates},createUploadBox:function(e,t){if(e){var n=this.dom("<div>");return t.append(n),n}},createSelectBox:function(e,t,n){if(e)if(this.$selectbox=this._createImagesBox(t),"object"==typeof e)this._parseList(e,n);else{var r=this.opts.editor.reloadmarker?{d:(new Date).getTime()}:{};this.ajax.get({url:e,data:r,success:function(e){this._parseList(e,n)}.bind(this)})}},_findImages:function(){return this.app.editor.getEditor().find("[data-image]")},_addImageState:function(e){var t=e.attr("data-image");this.dataStates[t]={type:"image",status:!0,url:e.attr("src"),$img:e,id:t}},_setImageState:function(e,t){this.dataStates[e].status=t},_checkImageLoad:function(){this.imagescount++,this.imagescount===this.imageslen&&(this.app.block.unset(),this.app.block.set(this.$last))},_buildEditUpload:function(){if(this.opts.image.upload){var e=this.app.block.get(),t=this.app.popup.getBody(),n=this._createFormItem();n.addClass(this.prefix+"-form-item-edit-image-box"),this.$imageclone=e.getImage().clone(),this.$imageclone.removeAttr("width height style");var r=this.dom("<div>").addClass(this.prefix+"-form-item-image");r.append(this.$imageclone),n.append(r),this.$upload=this.dom("<div>"),n.append(this.$upload),t.prepend(n),this._buildUpload(this.$upload,"image.changeClone")}},_buildUpload:function(e,t){if(this.opts.image.upload){var n={box:!0,placeholder:this.lang.get("image.upload-new-placeholder"),url:this.opts.image.upload,name:this.opts.image.name,data:this.opts.image.data,multiple:this.opts.image.multiple,success:t,error:"image.error"};this.app.create("upload",e,n)}},_createSelectBox:function(e){this.createSelectBox(this.opts.image.select,e,"image.insertFromSelect")},_createUploadBox:function(e){this.$upload=this.createUploadBox(this.opts.image.upload,e),this._buildUpload(this.$upload,"image.insertByUpload")},_createImageFromResponseItem:function(e){for(var t=this.dom("<img>").attr("src",e.url).one("load",this._checkImageLoad.bind(this)),n=t,r=["id","alt","width","height"],o=0;o<r.length;o++)Object.prototype.hasOwnProperty.call(e,r[o])&&n.attr(r[o],e[r[o]]);if(Object.prototype.hasOwnProperty.call(e,"id")&&n.attr("data-image",e.id),Object.prototype.hasOwnProperty.call(e,"2x")&&n.attr("srcset",e["2x"]+" 2x"),Object.prototype.hasOwnProperty.call(e,"link")){var i=this.dom("<a>");i.attr("href",e.link),t.wrap(i),n=i}return n},_createImagesBox:function(e){var t=this.dom("<div>").addClass(this.prefix+"-popup-images-box");return e.append(t),t},_createOrSection:function(e){if(this.opts.image.url&&(this.opts.image.upload||this.opts.image.select)){var t=this.dom("<div>").addClass(this.prefix+"-popup-image-section-or");t.html(this.lang.get("image.or")),e.append(t)}},_createImageByUrl:function(e){if(this.opts.image.url){var t=this._createFormItem();this.$urlinput=this._createUrlInput(),this.$urlbutton=this._createUrlButton(),t.append(this.$urlinput),t.append(this.$urlbutton),e.append(t),this.$urlinput.focus()}},_createFormItem:function(){return this.dom("<div>").addClass(this.prefix+"-form-container-flex")},_createUrlInput:function(){var e=this.dom("<input>").addClass(this.prefix+"-form-input");return e.attr("placeholder",this.lang.get("image.url-placeholder")),e},_createUrlButton:function(){var e=this.dom("<button>").addClass(this.prefix+"-form-button "+this.prefix+"-form-button-primary");return e.html(this.lang.get("buttons.insert")),e.one("click",this.insertByUrl.bind(this)),e},_parseList:function(e,t){for(var n in e)if(e.hasOwnProperty(n)){var r=e[n];if("object"!=typeof r)continue;var o=this.dom("<img>"),i=r.thumb?r.thumb:r.url;o.addClass(this.prefix+"-popup-event"),o.attr("src",i),o.attr("data-url",r.url),o.attr("data-callback",t);for(var a=["id","alt","caption","link","width","height"],s=0;s<a.length;s++)Object.prototype.hasOwnProperty.call(r,a[s])&&o.attr("data-"+a[s],r[a[s]]);o.on("click."+this.prefix+"-popup-event-"+this.uuid,function(e){var t=this.dom(e.target).attr("data-callback");this.app.api(t,e)}.bind(this)),this.$selectbox.append(o)}},_dataURLtoFile:function(e,t){for(var n=e.split(","),r=n[0].match(/:(.*?);/)[1],o=atob(n[1]),i=o.length,a=new Uint8Array(i);i--;)a[i]=o.charCodeAt(i);return new File([a],t,{type:r})}}),l.add("module","link",{popups:{format:{items:{format:{title:"## link.link ##",command:"link.format",shortcut:"Ctrl+k"},unlink:{title:"## link.unlink ##",command:"link.unlink"}}},change:{items:{edit:{title:"## link.edit-link ##",command:"link.format",shortcut:"Ctrl+k"},unlink:{title:"## link.unlink ##",command:"link.unlink"}}},create:{title:"## popup.link ##",width:"600px",form:{text:{type:"input",label:"## link.text ##"},url:{type:"input",label:"## link.url ##"},target:{type:"checkbox",text:"## link.link-in-new-tab ##"}},footer:{insert:{title:"## buttons.insert ##",command:"link.insert",type:"primary"},cancel:{title:"## buttons.cancel ##",command:"popup.close"}}},edit:{title:"## popup.link ##",width:"600px",form:{text:{type:"input",label:"## link.text ##"},url:{type:"input",label:"## link.url ##"},target:{type:"checkbox",text:"## link.link-in-new-tab ##"}},footer:{save:{title:"## buttons.save ##",command:"link.save",type:"primary"},cancel:{title:"## buttons.cancel ##",command:"popup.close"}}}},popup:function(e,t){var n=0===this.getLink().length?"format":"change";this.app.popup.create("link-items",this.popups[n]),this.app.popup.open({button:t})},format:function(e){this.app.selection.restore();var t=this.getLink(),n=0!==t.length,r=this.app.selection.getText();this.app.selection.save();var o=n?"edit":"create";this.app.popup.create("link",this.popups[o]);var i={};n?(i={text:t.text(),url:t.attr("href"),target:t.attr("target")||this.opts.link.target},i=this._encodeUrl(i)):i={text:r,target:this.opts.link.target},this.app.popup.setData(i);var a=n?{focus:"url"}:{focus:r?"url":"text"};this.app.popup.open(a)},insert:function(){this.app.popup.close();var e=this.app.inline.set({tag:"a",caret:"after"}),t=this.dom(e);this._save(t,"add")},save:function(){this.app.popup.close();var e=this.getLink();this._save(e,"change")},unlink:function(){this.app.popup.close();var e=this.app.selection.getNodes({tags:["a"]});if(0!==e.length){for(var t=0;t<e.length;t++){var n=this.dom(e[t]);this.app.broadcast("link.remove",{url:n.attr("href"),text:n.text()}),n.unwrap()}this.app.toolbar.observe(),this.app.context.observe()}},getLink:function(){var e=this.app.selection.getNodes({tags:["a"]});return 0!==e.length?this.dom(e[0]):this.dom()},_save:function(e,t){var n=this.app.popup.getData();n=this._cleanUrl(n),""!==(n=this._encodeUrl(n)).url?(n=this._setUrl(e,n),1===e.length&&(n=this._setText(e,n)),(n=this._setTarget(e,n)).element=e,this.app.broadcast("link."+t,n)):e.unwrap()},_cleanUrl:function(e){return e.url=this.app.content.escapeHtml(e.url),e.url=-1!==e.url.search(/^javascript:/i)?"":e.url,e},_encodeUrl:function(e){return e.url=e.url?e.url.replace(/&amp;/g,"&"):"",e},_setUrl:function(e,t){return e.attr("href",t.url),t},_setText:function(e,t){return t.text=""===t.text?t.url:t.text,e.text(t.text),t},_setTarget:function(e,t){return t.target?e.attr("target","_blank"):e.removeAttr("target"),t}}),l.add("module","table",{popups:{cell:{title:"## table.column ##",width:"300px",form:{width:{type:"input",label:"## table.width ##"},nowrap:{type:"checkbox",text:"## table.nowrap ##"}},footer:{insert:{title:"## buttons.save ##",command:"table.save",type:"primary"},cancel:{title:"## buttons.cancel ##",command:"popup.close"}}}},items:{addhead:{title:"## table.add-head ##",command:"table.addHead"},addcolumnafter:{title:"## table.add-column-after ##",command:"table.addColumnAfter"},addcolumnbefore:{title:"## table.add-column-before ##",command:"table.addColumnBefore"},addrowbelow:{title:"## table.add-row-below ##",command:"table.addRowBelow"},addrowabove:{title:"## table.add-row-above ##",command:"table.addRowAbove"},removehead:{title:"## table.remove-head ##",command:"table.removeHead",divider:"top"},removecolumn:{title:"## table.remove-column ##",command:"table.removeColumn"},removerow:{title:"## table.remove-row ##",command:"table.removeRow"},removetable:{title:"## table.delete-table ##",command:"table.removeTable",divider:"top"}},add:function(){var e=this.app.block.add({name:"table",source:this.opts.table.template,caret:"start"}).getFirstCell();e&&this.app.caret.set(e.getBlock(),"start")},observe:function(e,t,n){if(!this.opts.table)return!1;var r=this.app.block.get();return n&&"addbar"===n.getName()?e.command="table.add":r&&r.isType(["table","cell"])&&(e.command="table.popup"),e},popup:function(e,t){this.app.popup.create("table",{items:this.items}),this.app.popup.open({button:t})},addHead:function(){var e=this.app.block.get().getTable().getBlock();this.removeHead();var t=e.find("tr").first().children("td, th").length,n=this.dom("<thead>"),r=this._buildRow(!1,t,"<th>");n.append(r),e.prepend(n),this.app.block.set(r.children("td, th").first(),"start")},addRowBelow:function(){this._addRow("below")},addRowAbove:function(){this._addRow("above")},addColumnBefore:function(){this._addColumn("before")},addColumnAfter:function(){this._addColumn("after")},removeTable:function(){this.app.popup.close(),this.app.block.remove()},removeHead:function(){this.app.popup.close();var e=this.app.block.get().getTable(),t=e.getBlock().find("thead");0!==t.length&&t.remove(),e.getFirst().setCaret("start")},removeRow:function(){this.app.popup.close(),this.app.control.close();var e=this.app.block.get(),t=e.getTable(),n=e.getRow(),r=n.getBlock().closest("thead");0!==r.length?(r.remove(),t.getFirst().setCaret("start")):n.remove()},removeColumn:function(){this.app.popup.close(),this.app.control.close();var e=this.app.block.get().getBlock(),t=e.closest("table"),n=e.closest("tr"),r=0;n.find("td, th").each((function(t,n){t.get()===e.get()&&(r=n)})),t.find("tr").each(function(e){var t=e.find("td, th").get(r);this.dom(t).remove()}.bind(this))},cellSetting:function(e,t){var n=this.app.block.get();this.app.popup.create("cell",this.popups.cell).setData({width:n.getWidth(),nowrap:n.getNowrap()}),this.app.popup.open({button:t,focus:"width"})},save:function(e){this.app.popup.close();var t=e.getData(),n=this.app.block.get();""!==t.width&&n.setWidth(t.width),n.setNowrap(t.nowrap)},_addColumn:function(e){this.app.popup.close();var t=this.app.block.get().getBlock(),n=t.closest("table"),r=t.closest("tr"),o=0;r.find("td, th").each((function(e,n){e.get()===t.get()&&(o=n)}));var i,a=0;n.find("tr").each((function(e,t){e.get()===r.get()&&(a=t)})),n.find("tr").each(function(t,n){var r=t.find("td, th").get(o),s=this.dom(r),l=s.clone();l.html(""),this.app.create("block.cell",l),a===n&&(i=l),s[e](l)}.bind(this)),i&&this.app.block.set(i,"start")},_addRow:function(e){this.app.popup.close();var t="below"===e?"after":"before",n=this.app.block.get().getBlock(),r=n.closest("tr"),o=n.closest("thead"),i=r.children("td, th").length,a=this._buildRow(r,i,"<td>");0!==o.length?o.after(a):r[t](a),this.app.block.set(a.find("td, th").first(),"start")},_buildRow:function(e,t,n){if(!1===e){e=this.dom("<tr>");for(var r=0;r<t;r++){var o=this.dom(n);this.app.create("block.cell",o),e.append(o)}}else(e=e.clone()).find("td, th").html("");return this.app.create("block.row",e),e.find("td, th").each(function(e){this.app.create("block.cell",e)}.bind(this)),e}}),l.add("module","context",{init:function(){this.customButtons={},this.activeClass="active",this.eventname="."+this.prefix+"-context",this.aTags={},this.aTypes={},this.clickOffset=!1},start:function(){this.opts.context&&this._build()},stop:function(){this.app.scroll.isTarget()&&this.app.scroll.getTarget().off(this.eventname),this.opts.context&&this.$context.remove()},isOpen:function(){this.$context.hasClass("open")},close:function(){this.opts.context&&this._close()},add:function(e,t){this.customButtons[e]=t},observe:function(){this.opts.context&&this._observe()},_doOpen:function(e){!1===this.opts.context||this.app.utils.isMobile()||setTimeout(function(){if(this._isSelection())this._open(e);else{if(this._isInstance()&&this.clickOffset&&this.clickOffset.x===e.pageX&&this.clickOffset.y===e.pageY)return this.clickOffset=!1,void this._open(e);this._close(),this.clickOffset={x:e.pageX,y:e.pageY}}}.bind(this),0)},_open:function(e){this.$context.html(""),this._buildButtons(),this._buildCustomButtons(),this._buildActiveButtons(),this._buildPosition(e),this._buildEvents(),this._observe()},_close:function(){this.$context.removeClass("open"),this.$context.hide(),this.app.editor.getEditor().off(this.eventname),this.app.scroll.isTarget()&&this.app.scroll.getTarget().off(this.eventname)},_isSelection:function(){return!this.app.blocks.is()&&(this._isInstance()&&this.app.selection.is()&&!this.app.selection.isCollapsed())},_isInstance:function(){var e=this.app.block.get(),t=e&&e.isEditable(),n=e&&"pre"!==e.getType();return t&&n},_scroll:function(){var e=this.app.selection.getPosition().bottom+this.app.$doc.scrollTop();if(this.$context.css("top",e+2+"px"),this.app.scroll.isTarget()){var t=this.app.scroll.getTarget(),n=t.offset().top+t.height(),r=t.offset().top;e+this.$context.height()>n||r>e?this.$context.hide():this.$context.show()}},_build:function(){this.$context=this.dom("<div>").addClass(this.prefix+"-context "+this.prefix+"-context-"+this.uuid).hide(),this.app.$body.append(this.$context),this.app.editor.getEditor().on("mouseup."+this.prefix+"-context-up",this._doOpen.bind(this))},_buildButtons:function(){for(var e=this.opts.buttons.context,t=u.extend(!0,{},this.opts.buttonsObj),n=0;n<e.length;n++){var r=e[n],o=t[r];this.app.create("button",r,o,this.$context,"context")}},_buildCustomButtons:function(){var e=this.customButtons;for(var t in e)e.hasOwnProperty(t)&&this.app.create("button",t,e[t],this.$context,"context")},_buildPosition:function(e){var t=this.$context.width(),n=this.app.editor.getRect(),r=this.app.selection.getPosition(),o=e.pageX-t/2,i=r.bottom+this.app.$doc.scrollTop();o<n.left&&(o=n.left+4),o+t>n.right&&(o=n.right-t-4),this.$context.css({left:o+"px",top:i+2+"px"}),this.$context.addClass("open"),this.$context.show()},_buildEvents:function(){var e=this.app.editor.getEditor();e.on("mousedown"+this.eventname,this._close.bind(this)),e.on("keydown"+this.eventname,this._close.bind(this)),this.app.scroll.isTarget()&&this.app.scroll.getTarget().on("scroll"+this.eventname,this._scroll.bind(this))},_buildActiveButtons:function(){var e=this.app.observer.buildActiveButtons(this.customButtons);this.aTags=e.tags,this.aTypes=e.types},_observe:function(){if(this._unsetActive(),this.app.observer.isButtons()){var e=this.app.observer.buildButtons(this.aTags,this.aTypes);this._setActiveKeys(e)}},_setActiveKeys:function(e){for(var t=0;t<e.length;t++)this._findButton(e[t]).addClass(this.activeClass)},_unsetActive:function(){this._findButtons().removeClass(this.activeClass)},_findButtons:function(){return this.$context.find("."+this.prefix+"-button-context")},_findButton:function(e){return this.$context.find("[data-name="+e+"]")}}),l.add("module","topbar",{init:function(){this.activeClass="active",this.toggledClass="disable",this.disableClass="disable",this.customButtons={}},start:function(){this._isTopbar()&&this._build()},load:function(){this._buildButtons()},get:function(e){return this._findButton(e)},add:function(e,t){this.customButtons[e]=t},setToggled:function(e){this._isTopbar()&&(this._findButtons().removeClass(this.toggledClass),this._findButton(e).addClass(this.toggledClass))},unsetToggled:function(e){this._isTopbar()&&(e?this._findButton(e):this._findButtons()).removeClass(this.toggledClass)},enable:function(){this._isTopbar()&&this._findButtons().removeClass(this.disableClass)},disable:function(){this._isTopbar()&&this._findButtons().removeClass(this.toggledClass).removeClass(this.activeClass).addClass(this.disableClass)},_isTopbar:function(){return this.opts.topbar},_build:function(){this.$topbar=this.dom("<div>").addClass(this.prefix+"-topbar"),this.app.container.get("toolbar").append(this.$topbar)},_buildButtons:function(){var e=this.app.editor.getButtonsFromArr(this.opts.buttons.topbar);for(var t in e=u.extend(!0,{},e,this.customButtons),this.opts.topbar.add&&(e=u.extend(!0,{},e,this.opts.topbar.add)),e)if(e.hasOwnProperty(t)){if(this.opts.topbar.hide&&-1!==this.opts.topbar.hide.indexOf(t))continue;this.app.create("button",t,e[t],this.$topbar,"topbar")}},_findButtons:function(){return this.$topbar.find("."+this.prefix+"-button-topbar")},_findButton:function(e){return this.$topbar.find("[data-name="+e+"]")}}),l.add("module","control",{init:function(){this.instance=!1,this.customItems={},this.eventName=this.prefix+"-control"},start:function(){this._build()},stop:function(){this._isControl()&&this.$control.remove(),this.instance=!1},getElement:function(){return this.$control},add:function(e,t){this.customItems[e]=t},build:function(){if(this._isControl()){var e=this.app.block.get();e.isFigcaption()||(e.isSecondLevel()&&(e=e.getFirstLevel()),e?this.open(e):this.close())}},open:function(e){if(this._isControl())if(this.instance=e,this.instance){this.$control.show(),this.updatePosition();var t=this.app.scroll.getTarget();t.on("resize."+this.eventName,this.updatePosition.bind(this)),t.on("scroll."+this.eventName,this.updatePosition.bind(this)),this.$button.off("."+this.prefix+"-control-button"),this.app.$win.off("."+this.prefix+"-control-button"),this.opts.control&&this.$button.on("click."+this.prefix+"-control-button",this._click.bind(this)),this.opts.reorder&&this.$button.on("mousedown."+this.prefix+"-control-button touchstart."+this.prefix+"-control-button",this._press.bind(this))}else this.close()},close:function(){if(this._isControl()){if(this.$control.hide(),this.instance){var e=this.instance.getBlock();this.app.content.unfixListMargin(e)}this.app.scroll.getTarget().off("."+this.eventName),this.instance=!1}},updatePosition:function(){if(this._isControl())if(this.instance){if("list"===this.instance.getType()){var e=this.instance.getBlock();this.app.content.fixListMargin(e)}var t=this.instance.isEditable(),n=this.instance.getOffset(),r=this.$control.width(),o=t?-3:4,i=n.top-o-0,a=n.left-r-4;if(this.$control.show(),this.app.scroll.isTarget()){var s=this.app.scroll.getTarget(),l=s.offset().top+s.height(),c=s.offset().top;(i+this.$control.height()>l||c>i)&&this.$control.hide()}this.$control.css({top:i+"px",left:a+"px"})}else this.close()},_isControl:function(){return this.opts.control||this.opts.reorder},_click:function(e){e.preventDefault(),e.stopPropagation();var t={},n={};for(var r in t=this.app.editor.getButtonsFromArr(this.instance.control),t=u.extend(!0,{},t,this.customItems))this.instance.isAllowedButton(r,t[r])&&(n[r]=t[r],n[r].icon=!t[r].icon||t[r].icon,n[r].control=!0);this.app.popup.create("control",{items:n}),this.app.context.close(),this.app.popup.open({control:this.$button})},_press:function(e){e.preventDefault(),e.stopPropagation(),setTimeout(function(){this.app.$win.on("mouseup."+this.prefix+"-control-button touchend."+this.prefix+"-control-button",this._release.bind(this)),this.app.$win.on("mousemove."+this.prefix+"-control-button touchmove."+this.prefix+"-control-button",this._move.bind(this))}.bind(this),0)},_release:function(e){this.$button.removeClass(this.prefix+"-handle"),this.app.$win.off("."+this.prefix+"-control-button"),this.app.observer.trigger=!0,this.app.event.trigger=!1,this.oldY=0,this.dragging=!1,this._trashDragItem(),this.updatePosition(),this.$control.show(),setTimeout(function(){this.app.block.set(this.instance,"start",!0),this.app.event.trigger=!0}.bind(this),2)},_move:function(e){if(e.preventDefault(),!this.$button.hasClass(this.prefix+"-handle")){var t=this.instance.getBlock().get();this.$button.addClass(this.prefix+"-handle"),this.dragging=!0,this.$dragItem=this._makeDragItem(t,e.target),this.$control.hide()}var n=!1,r=0===this.oldY?0:this.oldY-e.pageY;r>0?n="up":r<0&&(n="down"),this._moveItem(this.$dragItem,r),this.oldY=e.pageY;var o=e.pageY,i=this.app.editor.getRect(),a=this.app.$doc.scrollTop(),s=a>i.top?a+40:i.top+40,l=this.app.$win.height()+a-40,c=i.top,u=i.top+this.app.editor.getEditor().height();if(this.app.scroll.isTarget()){var d=this.app.scroll.getTarget(),p=d.offset();c=p.top,s=a>i.top?p.top+40:s,l=(u=p.top+d.height())-40}"up"===n&&o<s&&o>c?this._scroll(-10):"down"===n&&o>l&&o<u&&this._scroll(10);for(var f=this.app.editor.getEditor().children(),h=f.length,m=0;m<h;m++){var g=f.eq(m).get();g!==this.$clickItem.get()&&(this._isOver(this.dom(g))&&this._swapItems(g))}},_build:function(){this.$control=this.dom("<div>").addClass(this.prefix+"-control "+this.prefix+"-control-"+this.uuid).hide(),this.$button=this.dom("<span>").addClass(this.prefix+"-icon-sort "+this.prefix+"-button "+this.prefix+"-button-control"),this.$control.append(this.$button),this.opts.bsmodal&&this.$control.css("z-index",1060),this.app.$body.append(this.$control)},_isOver:function(e){var t=this.$dragItem.offset().top,n=e.offset(),r=e.height();return t>n.top&&t<n.top+r},_scroll:function(e){var t=this.app.scroll.isTarget()?this.app.scroll.getTarget():this.app.$win,n=t.scrollTop();t.scrollTop(n+e)},_swapItems:function(e){var t=this.$dragItem.offset().top,n=this.$clickItem,r=this.dom(e),o=r.offset(),i=r.height()/2;r[i+o.top>t?"before":"after"](n)},_moveItem:function(e,t){var n=e.offset().top;n-=t,e.css("top",n+"px"),this.$control.css("top",n+"px")},_makeDragItem:function(e){this._trashDragItem();var t=this.dom(e),n=t.offset();this.$clickItem=t,this.$clickItem.addClass(this.prefix+"-drag-active");var r=t.clone();r.removeClass(this.prefix+"-drag-active "+this.prefix+"-element-active"),r.css({"font-family":t.css("font-family"),"font-size":t.css("font-size"),"line-height":t.css("line-height"),margin:0,padding:0});var o=this.dom("<div>").addClass(this.prefix+"-dragging");return o.append(r),o.css({opacity:.95,position:"absolute","z-index":999,left:n.left+"px",top:n.top+"px",width:t.width()+"px"}),this.app.$body.append(o),o},_trashDragItem:function(){this.$dragItem&&this.$clickItem&&(this.$clickItem.removeClass(this.prefix+"-drag-active"),this.$clickItem=null,this.$dragItem.remove(),this.$dragItem=null)}}),l.add("class","tool.checkbox",{mixins:["tool"],type:"checkbox",input:{tag:"input",type:"checkbox",classname:"-form-checkbox"},getValue:function(){return this.$input.val()},_buildInput:function(){if(this.$box=this.dom("<label>").addClass(this.prefix+"-form-checkbox-item"),this.$box.append(this.$input),this._has("text")){var e=this.dom("<span>").html(this.lang.parse(this.obj.text));this.$box.append(e)}this.$tool.append(this.$box)}}),l.add("class","tool.input",{mixins:["tool"],type:"input",input:{tag:"input",type:"text",classname:"-form-input"},_buildInput:function(){this.$tool.append(this.$input)}}),l.add("class","tool.number",{mixins:["tool"],type:"number",input:{tag:"input",type:"number",classname:"-form-input"},_buildInput:function(){this.$input.attr("min",0).css("max-width","65px"),this.$tool.append(this.$input)}}),l.add("class","tool.segment",{mixins:["tool"],type:"segment",input:{tag:"input",type:"hidden",classname:"-form-input"},setValue:function(e){this.$segment.find("."+this.prefix+"-form-segment-item").removeClass("active"),this.$segment.find("[data-segment="+e+"]").addClass("active"),this.$input.val(e)},_buildInput:function(){this.$segment=this.dom("<div>").addClass(this.prefix+"-form-segment");var e=this.obj.segments;for(var t in e)if(e.hasOwnProperty(t)){var n=this.dom("<span>").addClass(this.prefix+"-form-segment-item");n.attr("data-segment",t).on("click",this._catchSegment.bind(this)),Object.prototype.hasOwnProperty.call(e[t],"icon")?n.html(e[t].icon):n.addClass(this.prefix+"-icon-"+e[t].prefix+"-"+t),this.$segment.append(n)}this.$segment.append(this.$input),this.$tool.append(this.$segment)},_catchSegment:function(e){e.preventDefault(),e.stopPropagation();var t=this.dom(e.target).closest("."+this.prefix+"-form-segment-item"),n=t.attr("data-segment");this.$segment.find("."+this.prefix+"-form-segment-item").removeClass("active"),t.addClass("active"),this.$input.val(n),this.app.api(this.setter,this.popup)}}),l.add("class","tool.select",{mixins:["tool"],type:"select",input:{tag:"select",classname:"-form-select"},_buildInput:function(){for(var e in this.obj.options)if(this.obj.options.hasOwnProperty(e)){var t=this.dom("<option>");t.val(e),t.html(this.lang.parse(this.obj.options[e])),this.$input.append(t)}this.$tool.append(this.$input)}}),l.add("class","tool.textarea",{mixins:["tool"],type:"textarea",input:{tag:"textarea",classname:"-form-textarea"},setFocus:function(){this.$input.focus(),this.$input.get().setSelectionRange(0,0),this.$input.scrollTop(0)},_buildInput:function(){this._has("rows")&&this.$input.attr("rows",this._get("rows")),this.$input.attr("data-gramm_editor",!1),this.$tool.append(this.$input)}}),l.add("class","tool.upload",{mixins:["tool"],type:"upload",input:{tag:"input",type:"hidden",classname:"-form-input"},setValue:function(e){e=e||"",this.upload&&this.upload.setImage(e),this.$input.val(e)},_buildInput:function(){this.$tool.append(this.$input),this._buildUpload()},_buildUpload:function(){this.$upload=this.dom("<input>").attr("type","file"),this.$tool.append(this.$upload);var e={};this._has("trigger")&&this._get("trigger")&&(e={instance:this,method:"trigger"}),this.upload=this.app.create("upload",this.$upload,this.obj.upload,e)}}),l.add("block","block.address",{mixins:["block"],type:"address",editable:!0,toolbar:{add:{title:"## buttons.add ##",command:"addbar.popup"},html:{title:"## buttons.html ##",command:"source.toggle"},format:{title:"## buttons.format ##",command:"format.popup"},bold:{title:"## buttons.bold ##",command:"inline.set",params:{tag:"b"}},italic:{title:"## buttons.italic ##",command:"inline.set",params:{tag:"i"}},deleted:{title:"## buttons.deleted ##",command:"inline.set",params:{tag:"del"}},link:{title:"## buttons.link ##",command:"link.popup"}},control:{add:{title:"## buttons.add ##",command:"addbar.popup"},format:{title:"## buttons.format ##",command:"format.popup"},duplicate:{title:"## buttons.duplicate ##",command:"block.duplicate"},trash:{title:"## buttons.delete ##",command:"block.remove"}},create:function(){return this.dom("<address>")},handleEnter:function(e){if(e.preventDefault(),this.isEmpty()||this.isCaretEnd()){var t=this.getBlock(),n=t.children(),r=n.length,o=n.eq(r-1),i=n.eq(r-2),a=t.html().trim();if(-1!==(a=this.app.utils.removeInvisibleChars(a)).search(/<br\s?\/?>$/))return i.remove(),o.remove(),void this.insertEmpty({position:"after",caret:"start"})}return this.app.insertion.insertBreakline(),!0}}),l.add("block","block.cell",{mixins:["block"],type:"cell",editable:!0,create:function(){return this.dom("<td>")},getTable:function(){return this.getParent("table")},getRow:function(){return this.getParent("row")},getNextCell:function(){var e=this.getNext();if(!e){var t=this.getParent("row");if(t){var n=t.getNextRow();n&&(e=n.getChildFirst("cell"))}}return e},getPrevCell:function(){var e=this.getPrev();if(!e){var t=this.getParent("row");if(t){var n=t.getPrevRow();n&&(e=n.getChildLast("cell"))}}return e},getWidth:function(){var e=this.$block.attr("width");return e||""},getNowrap:function(){return this.$block.hasClass(this.prefix+"-nowrap")},setWidth:function(e){this._eachCell((function(t){""===e?t.removeAttr("width"):(e=-1!==e.search("%")?e:e.replace("px",""),t.attr("width",e))}))},setNowrap:function(e){this._eachCell(function(t){var n=this.opts.table.nowrap+" "+this.prefix+"-nowrap";e?t.addClass(n):t.removeClass(n)}.bind(this))},handleArrow:function(e,t,n){var r,o,i=this.getTable(),a=i.getBlock(),s=this.app.caret.is(a,"start"),l=this.app.caret.is(a,"end");return n.is("up-left")&&s?(e.preventDefault(),(r=i.getPrev())?this.app.block.set(r,"end"):this.app.insertion.insertEmptyBlock({current:i,position:"before",caret:"start"}),!0):n.is("down-right")&&l?(e.preventDefault(),(o=i.getNext())?this.app.block.set(o,"start"):this.app.insertion.insertEmptyBlock({current:i,position:"after",caret:"start"}),!0):n.is("up-left")&&this.isCaretStart()?(e.preventDefault(),((r=this.getPrevCell())||(r=this.getFirstLevel().getPrev()))&&this.app.block.set(r,"end"),!0):n.is("down-right")&&this.isCaretEnd()?(e.preventDefault(),((o=this.getNextCell())||(o=this.getFirstLevel().getNext()))&&this.app.block.set(o,"start"),!0):void 0},handleTab:function(e){e.preventDefault();var t=this.getNextCell();return(t||(t=this.getFirstLevel().getNext()))&&this.app.block.set(t,"start"),!0},handleEnter:function(e){return e.preventDefault(),this.app.insertion.insertBreakline(),!0},_eachCell:function(e){var t=0,n=this.$block.closest("table");this.$block.closest("tr").find("td, th").each(function(e,n){e.get()===this.$block.get()&&(t=n)}.bind(this)),n.find("tr").each(function(n){var r=n.find("td, th").get(t),o=this.dom(r);e(o)}.bind(this))}}),l.add("block","block.pre",{mixins:["block"],type:"pre",editable:!0,toolbar:{add:{title:"## buttons.add ##",command:"addbar.popup"},html:{title:"## buttons.html ##",command:"source.toggle"}},control:{add:{title:"## buttons.add ##",command:"addbar.popup"},duplicate:{title:"## buttons.duplicate ##",command:"block.duplicate"},trash:{title:"## buttons.delete ##",command:"block.remove"}},create:function(){return this.dom(this.opts.pre.template)},build:function(){this._buildCaption(),this._buildItems("figcaption","figcaption")},handleTab:function(e){e.preventDefault();var t=this.opts.pre.spaces,n=document.createTextNode(Array(t+1).join(" "));return this.app.insertion.insertNode(n,"end"),!0},handleEnter:function(e){e.preventDefault();var t=this.$block.html().search(/\n$/);return this.isCaretEnd()&&-1===t?this.app.insertion.insertNewline("after",!0):this.app.insertion.insertNewline(),!0}}),l.add("block","block.embed",{mixins:["block"],type:"embed",editable:!1,toolbar:{add:{title:"## buttons.add ##",command:"addbar.popup"},html:{title:"## buttons.html ##",command:"source.toggle"},embed:{title:"## blocks.embed ##",command:"embed.popup",observer:"embed.observe"}},control:{add:{title:"## buttons.add ##",command:"addbar.popup"},duplicate:{title:"## buttons.duplicate ##",command:"block.duplicate"},trash:{title:"## buttons.delete ##",command:"block.remove"}},create:function(){return this.dom("<figure>")},build:function(){this._buildCaption(),this._buildItems("figcaption","figcaption"),this._buildEmbedCode()},addResponsive:function(){var e=this.dom("<div>").addClass(this.opts.embed.responsive),t=this.$block.find("figcaption"),n=t.clone(),r=this.getEmbedCode();t.remove(),e.html(r),this.$block.html("").append(e),0!==n.length&&(this.app.create("block.figcaption",n),this.$block.append(n)),this._buildEmbedCode()},removeResponsive:function(){this.$block.find(this._getEmbedClass()).unwrap()},getEmbedCode:function(){return decodeURI(this.$block.attr("data-embed-code"))},isResponsive:function(){return 0!==this.$block.find(this._getEmbedClass()).length},_buildEmbedCode:function(){var e=this.$block.clone();e.find(this._getEmbedClass()).unwrap(),e.find("figcaption").remove();var t=e.html().trim();this.$block.attr("data-embed-code",encodeURI(t))},_getEmbedClass:function(){return"."+this.opts.embed.responsive.replace(/ +/g,".")}}),l.add("block","block.figcaption",{mixins:["block"],type:"figcaption",editable:!0,toolbar:{bold:{title:"## buttons.bold ##",command:"inline.set",params:{tag:"b"}},italic:{title:"## buttons.italic ##",command:"inline.set",params:{tag:"i"}},deleted:{title:"## buttons.deleted ##",command:"inline.set",params:{tag:"del"}},link:{title:"## buttons.link ##",command:"link.popup"}},create:function(){return this.dom("<figcaption>")},getFigure:function(){return this.$block.closest("figure").dataget("instance")},handleArrow:function(e,t,n){if(n.is("up-left")&&this.isCaretStart()||n.is("down-right")&&this.isCaretEnd()){e.preventDefault();var r=this.getFigure();return this.app.block.set(r),!0}},handleTab:function(e){e.preventDefault();var t=this.getFigure();return this.app.block.set(t),!0},handleEnter:function(e){return e.preventDefault(),this.isEmpty()||this.isCaretEnd()||this.isCaretStart()||this.app.insertion.insertBreakline(),!0}}),l.add("block","block.heading",{mixins:["block"],type:"heading",editable:!0,toolbar:{add:{title:"## buttons.add ##",command:"addbar.popup"},html:{title:"## buttons.html ##",command:"source.toggle"},format:{title:"## buttons.format ##",command:"format.popup"},bold:{title:"## buttons.bold ##",command:"inline.set",params:{tag:"b"}},italic:{title:"## buttons.italic ##",command:"inline.set",params:{tag:"i"}},deleted:{title:"## buttons.deleted ##",command:"inline.set",params:{tag:"del"}},link:{title:"## buttons.link ##",command:"link.popup"}},control:{add:{title:"## buttons.add ##",command:"addbar.popup"},format:{title:"## buttons.format ##",command:"format.popup"},duplicate:{title:"## buttons.duplicate ##",command:"block.duplicate"},trash:{title:"## buttons.delete ##",command:"block.remove"}},create:function(){return this.dom("<h2>")},getTitle:function(){var e=this.lang.get("headings"),t=this.getTag(),n=this.$block.attr("data-title");return void 0!==e[t]?e[t]:n},handleEnter:function(e){if(e.preventDefault(),this.isEmpty()||this.isCaretEnd())this.insertEmpty({position:"after",caret:"start",remove:!1});else if(this.isCaretStart())this.insert({instance:this.duplicateEmpty(),position:"before"});else{var t=this.getBlock(),n=this.app.element.split(t);this.app.block.set(n,"start")}return!0}}),l.add("block","block.image",{mixins:["block"],type:"image",editable:!1,toolbar:{add:{title:"## buttons.add ##",command:"addbar.popup"},html:{title:"## buttons.html ##",command:"source.toggle"},image:{title:"## blocks.image ##",command:"image.popup",observer:"image.observe"}},control:{add:{title:"## buttons.add ##",command:"addbar.popup"},duplicate:{title:"## buttons.duplicate ##",command:"block.duplicate"},trash:{title:"## buttons.delete ##",command:"block.remove"}},create:function(){return this.dom("<"+this.opts.image.tag+">")},build:function(){this._buildCaption(),this._buildItems("figcaption","figcaption"),this.data={alt:{getter:"getAlt",setter:"setAlt"},width:{getter:"getWidth",setter:"setWidth"},link:{getter:"getLinkUrl",setter:"setLinkUrl"},target:{getter:"getTarget",setter:"setTarget"},caption:{getter:"getCaption",setter:"setCaption"}}},getImage:function(){return this.$block.find("img").eq(0)},getSrc:function(){return this.getImage().attr("src")},getId:function(){return this.getImage().attr("data-image")},getLink:function(){var e=this.getImage().parent();return e="A"===e.get().tagName&&e},getWidth:function(){var e=this.getImage(),t=e.css("width"),n=e.attr("width");return n&&-1!==n.search(/%/)&&(t=n),t},getAlt:function(){var e=this.getImage().attr("alt");return e||""},getLinkUrl:function(){var e=this.getLink();return e?e.attr("href"):""},getTarget:function(){var e=this.getLink();return e?e.attr("target"):this.opts.image.newtab},setWidth:function(e){var t=this.getImage();if(""===(e=e.trim()))t.removeAttr("width");else{var n=-1!==e.search(/%/),r=n?e:parseInt(e),o=t.width()/t.height();if(n)t.removeAttr("height"),t.attr({width:r});else{var i=Math.round(r/o);t.attr({width:r,height:i})}}t.css({width:e,"max-width":e}),this.app.broadcast("image.width",{image:t,width:e})},setAlt:function(e){var t=this.getImage();e=e.replace(/"/g,"'"),t.attr("alt",e)},setTarget:function(e){var t=this.getLink();t&&(e?t.attr("target","_blank"):t.removeAttr("target"))},setLinkUrl:function(e){var t=this.getLink();if(t){if(""===e)return this.removeLink(),void this.app.broadcast("image.unlink",{instance:this});t.attr("href",e)}else if(!t){if(""===e)return;var n=this.getImage();t=this.dom("<a>"),n.wrap(t),t.attr("href",e)}this.app.broadcast("image.link",{instance:this,link:t})},setImage:function(e){var t=this.getImage();t.attr("src",e.url),Object.prototype.hasOwnProperty.call(e,"id")&&t.attr("data-image",e.id),Object.prototype.hasOwnProperty.call(e,"2x")&&t.attr("srcset",e["2x"]+" 2x")},removeLink:function(){var e=this.getLink();e&&e.unwrap()}}),l.add("block","block.line",{mixins:["block"],type:"line",editable:!1,toolbar:{add:{title:"## buttons.add ##",command:"addbar.popup"},html:{title:"## buttons.html ##",command:"source.toggle"}},control:{add:{title:"## buttons.add ##",command:"addbar.popup"},format:{title:"## buttons.format ##",command:"format.popup"},duplicate:{title:"## buttons.duplicate ##",command:"block.duplicate"},trash:{title:"## buttons.delete ##",command:"block.remove"}},create:function(){return this.dom("<hr>")}}),l.add("block","block.list",{mixins:["block"],type:"list",editable:!0,toolbar:{add:{title:"## buttons.add ##",command:"addbar.popup"},html:{title:"## buttons.html ##",command:"source.toggle"},format:{title:"## buttons.format ##",command:"format.popup"},bold:{title:"## buttons.bold ##",command:"inline.set",params:{tag:"b"}},italic:{title:"## buttons.italic ##",command:"inline.set",params:{tag:"i"}},deleted:{title:"## buttons.deleted ##",command:"inline.set",params:{tag:"del"}},indent:{title:"## buttons.indent ##",command:"list.indent"},outdent:{title:"## buttons.outdent ##",command:"list.outdent"},link:{title:"## buttons.link ##",command:"link.popup"}},control:{add:{title:"## buttons.add ##",command:"addbar.popup"},format:{title:"## buttons.format ##",command:"format.popup"},duplicate:{title:"## buttons.duplicate ##",command:"block.duplicate"},trash:{title:"## buttons.delete ##",command:"block.remove"}},create:function(e){return e&&e.tag?this.dom("<"+e.tag+">"):this.dom("<ul>")},setCaret:function(e){var t=this.$block;"start"===e?t=this.$block.find("li").first():"end"===e&&(t=this.$block.find("li").last()),this.app.caret.set(t,e)},setEmpty:function(){this.$block.html("");var e=this.dom("<li>");this.$block.append(e),this.app.caret.set(e,"start")},isEmpty:function(){var e=this.$block.html();e=this._cleanEmpty(e);var t=this.$block.find("li");return 0===t.length?""===(e=e.trim()):1===t.length&&(e=t.eq(0).html(),""===(e=this._cleanEmpty(e)))},handleTab:function(e){var t=this.app.selection.getBlock(),n=this.app.caret.is(t,"start");if(this.app.element.isEmpty(t)&&(e.preventDefault(),this.app.list.indent()))return!0;if(!this.isCaretStart()&&!this.isCaretEnd()){if(this.opts.tab.spaces&&!n)return;return e.preventDefault(),this.app.list.indent(),!0}var r=this.getNext();if(r)return e.preventDefault(),this.app.block.set(r,"start"),!0},handleEnter:function(e){var t,n,r,o;if(e.preventDefault(),this.isEmpty()||this.isCaretEnd()){if(r=this.app.selection.getBlock(),n=this.dom(r),o=this.app.content.isEmptyHtml(r.innerHTML))return n.remove(),this.insertEmpty({position:"after",caret:"start"}),!0;t=this.dom("<li>"),this.app.element.cloneAttrs(r,t),this.dom(r).after(t),this.app.caret.set(t,"start")}else if(this.isCaretStart())t=this.dom("<li>"),r=this.app.selection.getBlock(),this.app.element.cloneAttrs(r,t),this.dom(r).before(t);else{r=this.app.selection.getBlock(),n=this.dom(r),o=this.app.content.isEmptyHtml(r.innerHTML);var i=this.app.caret.is(r,"start"),a=this.app.caret.is(r,"end",["ul","ol"]);if(t=this.dom("<li>"),this.app.element.cloneAttrs(r,t),o)n.after(t),this.app.caret.set(t,"start");else if(i)n.before(t);else if(a){var s=n.find("ul, ol").first();0!==s.length?(t.append(this.app.utils.createInvisibleChar()),t.append(s),n.after(t)):n.after(t),this.app.caret.set(t,"start")}else{var l=this.app.element.split(r);this.app.caret.set(l,"start")}}return!0}}),l.add("block","block.paragraph",{mixins:["block"],type:"paragraph",editable:!0,toolbar:{add:{title:"## buttons.add ##",command:"addbar.popup"},html:{title:"## buttons.html ##",command:"source.toggle"},format:{title:"## buttons.format ##",command:"format.popup"},bold:{title:"## buttons.bold ##",command:"inline.set",params:{tag:"b"}},italic:{title:"## buttons.italic ##",command:"inline.set",params:{tag:"i"}},deleted:{title:"## buttons.deleted ##",command:"inline.set",params:{tag:"del"}},link:{title:"## buttons.link ##",command:"link.popup"}},control:{add:{title:"## buttons.add ##",command:"addbar.popup"},format:{title:"## buttons.format ##",command:"format.popup"},duplicate:{title:"## buttons.duplicate ##",command:"block.duplicate"},trash:{title:"## buttons.delete ##",command:"block.remove"}},create:function(){return this.dom("<p>")},handleEnter:function(e){var t;if(e.preventDefault(),this.isEmpty()||this.isCaretEnd()){if(t=this.app.block.create(),this.opts.clean.enter||(t=this.duplicateEmpty()).getBlock().removeAttr("id"),!this.opts.clean.enterinline){var n=this.app.selection.getInline();if(n){for(var r,o=this.app.element.getAllInlines(n),i=0;i<o.length;i++)if(0===i)(r=o[i].cloneNode()).removeAttribute("id"),r.innerHTML="";else{var a=o[i].cloneNode();a.removeAttribute("id"),a.innerHTML="",r.appendChild(a)}t=this.app.block.create(r.outerHTML)}}this.insert({instance:t,position:"after",caret:"start",remove:!1})}else if(this.isCaretStart())(t=this.duplicate()).getBlock().html(""),this.insert({instance:t,position:"before"});else{var s=this.getBlock(),l=this.app.element.split(s);this.app.block.set(l,"start")}return!0}}),l.add("block","block.quote",{mixins:["block"],type:"quote",toolbar:{add:{title:"## buttons.add ##",command:"addbar.popup"},html:{title:"## buttons.html ##",command:"source.toggle"},bold:{title:"## buttons.bold ##",command:"inline.set",params:{tag:"b"}},italic:{title:"## buttons.italic ##",command:"inline.set",params:{tag:"i"}},deleted:{title:"## buttons.deleted ##",command:"inline.set",params:{tag:"del"}},link:{title:"## buttons.link ##",command:"link.popup"}},control:{add:{title:"## buttons.add ##",command:"addbar.popup"},duplicate:{title:"## buttons.duplicate ##",command:"block.duplicate"},trash:{title:"## buttons.delete ##",command:"block.remove"}},create:function(){return this.dom(this.opts.quote.template)},build:function(){this._buildCaption(),this._buildItems("p","quoteitem"),this._buildItems("figcaption","figcaption")},getLast:function(){return this._getLast()},getFirst:function(){return this._getFirst()},getFirstElement:function(){return this._getFirst().getBlock()},_getFirst:function(){return this.$block.find("p").first().dataget("instance")},_getLast:function(){return this.$block.find("p").last().dataget("instance")}}),l.add("block","block.quoteitem",{mixins:["block"],type:"quoteitem",editable:!0,create:function(){return this.dom("<p>")},getBlockquote:function(){return this.$block.closest("blockquote").dataget("instance")},handleArrow:function(e,t,n){var r=this.getBlockquote(),o=r.getBlock();if(0!==o.length){var i=this.app.caret.is(o,"start"),a=this.app.caret.is(o,"end");if(n.is("up-left")&&i){e.preventDefault();var s=this.getFirstLevel().getPrev();return s?this.app.block.set(s,"end"):this.app.insertion.insertEmptyBlock({current:r,position:"before",caret:"start"}),!0}if(n.is("down-right")&&a){e.preventDefault();var l=this.getFirstLevel().getNext();return l?this.app.block.set(l,"start"):this.app.insertion.insertEmptyBlock({current:r,position:"after",caret:"start"}),!0}}},handleTab:function(e){e.preventDefault();var t=this.getNext();return t?(this.app.block.set(t,"start"),!0):((t=this.getFirstLevel().getNext())&&this.app.block.set(t,"start"),!0)},handleEnter:function(e){e.preventDefault();var t=this.app.create("block.quoteitem");if(this.isEmpty()||this.isCaretEnd())this.insert({instance:t,position:"after",caret:"start"});else if(this.isCaretStart())this.insert({instance:t,position:"before"});else{var n=this.getBlock(),r=this.app.element.split(n);this.app.block.set(r,"start")}return!0}}),l.add("block","block.row",{mixins:["block"],type:"row",create:function(){return this.dom("<tr>")},getNextRow:function(){var e=this.getNext(),t=this.$block.parent();return e||"TABLE"===t.get().tagName||(e=t.nextElement().find("tr").first().dataget("instance")),e},getPrevRow:function(){var e=this.getPrev(),t=this.$block.parent();return e||"TABLE"===t.get().tagName||(e=t.prevElement().find("tr").last().dataget("instance")),e}}),l.add("block","block.table",{mixins:["block"],type:"table",toolbar:{add:{title:"## buttons.add ##",command:"addbar.popup"},html:{title:"## buttons.html ##",command:"source.toggle"},table:{title:"## blocks.table ##",command:"table.add",observer:"table.observe",params:{name:"table"}},bold:{title:"## buttons.bold ##",command:"inline.set",params:{tag:"b"}},italic:{title:"## buttons.italic ##",command:"inline.set",params:{tag:"i"}},deleted:{title:"## buttons.deleted ##",command:"inline.set",params:{tag:"del"}},link:{title:"## buttons.link ##",command:"link.popup"},tune:{title:"## buttons.column-settings ##",command:"table.cellSetting"}},control:{add:{title:"## buttons.add ##",command:"addbar.popup"},table:{title:"## blocks.table ##",command:"table.add",observer:"table.observe",params:{name:"table"}},tune:{title:"## buttons.column-settings ##",command:"table.cellSetting",icon:"tune"},duplicate:{title:"## buttons.duplicate ##",command:"block.duplicate"},trash:{title:"## buttons.delete ##",command:"block.remove"}},create:function(){return this.dom(this.opts.table.template)},build:function(){this._buildItems("tr","row"),this._buildItems("td, th","cell"),this._buildNowrap()},getLast:function(){return this.getLastCell()},getFirst:function(){return this.getFirstCell()},getFirstElement:function(){return this.getFirstCell().getBlock()},getFirstCell:function(){var e=this.$block.find("th, td").first();if(0!==e.length)return e.dataget("instance")},getLastCell:function(){var e=this.$block.find("th, td").last();if(0!==e.length)return e.dataget("instance")},_buildNowrap:function(){this.$block.find("th, td").each(function(e){e.hasClass(this.opts.table.nowrap)&&e.addClass(this.prefix+"-nowrap")}.bind(this))}}),l.add("block","block.layer",{mixins:["block"],type:"layer",editable:!1,toolbar:{add:{title:"## buttons.add ##",command:"addbar.popup"},html:{title:"## buttons.html ##",command:"source.toggle"}},control:{add:{title:"## buttons.add ##",command:"addbar.popup"},duplicate:{title:"## buttons.duplicate ##",command:"block.duplicate"},trash:{title:"## buttons.delete ##",command:"block.remove"}}}),l.add("block","block.dlist",{mixins:["block"],type:"dlist",editable:!0,toolbar:{add:{title:"## buttons.add ##",command:"addbar.popup"},html:{title:"## buttons.html ##",command:"source.toggle"},format:{title:"## buttons.format ##",command:"format.popup"},bold:{title:"## buttons.bold ##",command:"inline.set",params:{tag:"b"}},italic:{title:"## buttons.italic ##",command:"inline.set",params:{tag:"i"}},deleted:{title:"## buttons.deleted ##",command:"inline.set",params:{tag:"del"}},link:{title:"## buttons.link ##",command:"link.popup"}},control:{add:{title:"## buttons.add ##",command:"addbar.popup"},format:{title:"## buttons.format ##",command:"format.popup"},duplicate:{title:"## buttons.duplicate ##",command:"block.duplicate"},trash:{title:"## buttons.delete ##",command:"block.remove"}},create:function(){return this.dom("<dl>")},getPlainText:function(e){var t="",n=this.$block.find("dt, dd"),r=n.length;return n.each((function(n,o){var i=e?"<br>":"";o===r&&(i=""),t+=n.html()+i})),t},setEmpty:function(){this.$block.html("");var e=this.dom("<dt>");this.$block.append(e),this.app.caret.set(e,"start")},isEmpty:function(){var e=this.$block.html();e=this._cleanEmpty(e);var t=this.$block.find("dt, dd");return 0===t.length?""===(e=e.trim()):1===t.length&&(e=t.eq(0).html(),""===(e=this._cleanEmpty(e)))},handleEnter:function(e,t,n){if(e.preventDefault(),this.isEmpty()||this.isCaretEnd()){var r,o=this.app.selection.getBlock(),i=this.dom(o),a=o.tagName.toLowerCase(),s=this.app.content.isEmptyHtml(o.innerHTML);if("dt"===a&&s)return i.remove(),this.insertEmpty({position:"after",caret:"start"}),!0;r="dt"===a?this.dom("<dd>"):this.dom("<dt>"),this.dom(o).after(r),this.app.caret.set(r,"start")}else{if(this.isCaretStart())return!0;this.app.insertion.insertBreakline()}return!0}}),window.RedactorX=l,window.addEventListener("load",(function(){l("[data-redactorx]")})),e.exports&&(e.exports=l,e.exports.RedactorX=l)}()},11382:function(e,t,n){!function(e,t){"use strict";function n(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function r(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?n(Object(r),!0).forEach((function(t){i(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):n(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function o(e){return o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},o(e)}function i(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){return s(e)||l(e,t)||c(e,t)||d()}function s(e){if(Array.isArray(e))return e}function l(e,t){var n=e&&("undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"]);if(null!=n){var r,o,i=[],a=!0,s=!1;try{for(n=n.call(e);!(a=(r=n.next()).done)&&(i.push(r.value),!t||i.length!==t);a=!0);}catch(e){s=!0,o=e}finally{try{a||null==n.return||n.return()}finally{if(s)throw o}}return i}}function c(e,t){if(e){if("string"==typeof e)return u(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?u(e,t):void 0}}function u(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function d(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function p(e,t){return e(t={exports:{}},t.exports),t.exports}t=t&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t;var f="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";function h(){}function m(){}m.resetWarningCache=h;var g=function(){function e(e,t,n,r,o,i){if(i!==f){var a=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw a.name="Invariant Violation",a}}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:m,resetWarningCache:h};return n.PropTypes=n,n},v=p((function(e){e.exports=g()})),y=function(e){var n=t.useRef(e);return t.useEffect((function(){n.current=e}),[e]),n.current},b=function(e){return null!==e&&"object"===o(e)},_=function(e){return b(e)&&"function"==typeof e.then},A=function(e){return b(e)&&"function"==typeof e.elements&&"function"==typeof e.createToken&&"function"==typeof e.createPaymentMethod&&"function"==typeof e.confirmCardPayment},E="[object Object]",w=function e(t,n){if(!b(t)||!b(n))return t===n;var r=Array.isArray(t);if(r!==Array.isArray(n))return!1;var o=Object.prototype.toString.call(t)===E;if(o!==(Object.prototype.toString.call(n)===E))return!1;if(!o&&!r)return t===n;var i=Object.keys(t),a=Object.keys(n);if(i.length!==a.length)return!1;for(var s={},l=0;l<i.length;l+=1)s[i[l]]=!0;for(var c=0;c<a.length;c+=1)s[a[c]]=!0;var u=Object.keys(s);if(u.length!==i.length)return!1;var d=t,p=n,f=function(t){return e(d[t],p[t])};return u.every(f)},x=function(e,t,n){return b(e)?Object.keys(e).reduce((function(o,a){var s=!b(t)||!w(e[a],t[a]);return n.includes(a)?(s&&console.warn("Unsupported prop change: options.".concat(a," is not a mutable property.")),o):s?r(r({},o||{}),{},i({},a,e[a])):o}),null):null},k="Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.",C=function(e){if(null===e||A(e))return e;throw new Error(k)},S=function(e){if(_(e))return{tag:"async",stripePromise:Promise.resolve(e).then(C)};var t=C(e);return null===t?{tag:"empty"}:{tag:"sync",stripe:t}},M=t.createContext(null);M.displayName="ElementsContext";var T=function(e,t){if(!e)throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(t," in an <Elements> provider."));return e},O=t.createContext(null);O.displayName="CartElementContext";var D=function(e,t){if(!e)throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(t," in an <Elements> provider."));return e},L=function(e){var n=e.stripe,r=e.options,o=e.children,i=t.useMemo((function(){return S(n)}),[n]),s=a(t.useState(null),2),l=s[0],c=s[1],u=a(t.useState(null),2),d=u[0],p=u[1],f=a(t.useState((function(){return{stripe:"sync"===i.tag?i.stripe:null,elements:"sync"===i.tag?i.stripe.elements(r):null}})),2),h=f[0],m=f[1];t.useEffect((function(){var e=!0,t=function(e){m((function(t){return t.stripe?t:{stripe:e,elements:e.elements(r)}}))};return"async"!==i.tag||h.stripe?"sync"!==i.tag||h.stripe||t(i.stripe):i.stripePromise.then((function(n){n&&e&&t(n)})),function(){e=!1}}),[i,h,r]);var g=y(n);t.useEffect((function(){null!==g&&g!==n&&console.warn("Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.")}),[g,n]);var v=y(r);return t.useEffect((function(){if(h.elements){var e=x(r,v,["clientSecret","fonts"]);e&&h.elements.update(e)}}),[r,v,h.elements]),t.useEffect((function(){var e=h.stripe;e&&e._registerWrapper&&e.registerAppInfo&&(e._registerWrapper({name:"react-stripe-js",version:"1.16.5"}),e.registerAppInfo({name:"react-stripe-js",version:"1.16.5",url:"https://stripe.com/docs/stripe-js/react"}))}),[h.stripe]),t.createElement(M.Provider,{value:h},t.createElement(O.Provider,{value:{cart:l,setCart:c,cartState:d,setCartState:p}},o))};L.propTypes={stripe:v.any,options:v.object};var P=function(e){var n=t.useContext(M);return T(n,e)},I=function(e){var n=t.useContext(O);return D(n,e)},B=function(){return P("calls useElements()").elements},R=function(){return P("calls useStripe()").stripe},N=function(){return I("calls useCartElement()").cart},F=function(){return I("calls useCartElementState()").cartState},j=function(e){return(0,e.children)(P("mounts <ElementsConsumer>"))};j.propTypes={children:v.func.isRequired};var Y=function(e,n,r){var o=!!r,i=t.useRef(r);t.useEffect((function(){i.current=r}),[r]),t.useEffect((function(){if(!o||!e)return function(){};var t=function(){i.current&&i.current.apply(i,arguments)};return e.on(n,t),function(){e.off(n,t)}}),[o,n,e,i])},$=function(e){return e.charAt(0).toUpperCase()+e.slice(1)},H=function(e,n){var r="".concat($(e),"Element"),o=n?function(e){P("mounts <".concat(r,">")),I("mounts <".concat(r,">"));var n=e.id,o=e.className;return t.createElement("div",{id:n,className:o})}:function(n){var o,i=n.id,s=n.className,l=n.options,c=void 0===l?{}:l,u=n.onBlur,d=n.onFocus,p=n.onReady,f=n.onChange,h=n.onEscape,m=n.onClick,g=n.onLoadError,v=n.onLoaderStart,b=n.onNetworksChange,_=n.onCheckout,A=n.onLineItemClick,E=n.onConfirm,w=n.onCancel,k=n.onShippingAddressChange,C=n.onShippingRateChange,S=P("mounts <".concat(r,">")).elements,M=a(t.useState(null),2),T=M[0],O=M[1],D=t.useRef(null),L=t.useRef(null),B=I("mounts <".concat(r,">")),R=B.setCart,N=B.setCartState;Y(T,"blur",u),Y(T,"focus",d),Y(T,"escape",h),Y(T,"click",m),Y(T,"loaderror",g),Y(T,"loaderstart",v),Y(T,"networkschange",b),Y(T,"lineitemclick",A),Y(T,"confirm",E),Y(T,"cancel",w),Y(T,"shippingaddresschange",k),Y(T,"shippingratechange",C),"cart"===e?o=function(e){N(e),p&&p(e)}:p&&(o="payButton"===e?p:function(){p(T)}),Y(T,"ready",o),Y(T,"change","cart"===e?function(e){N(e),f&&f(e)}:f),Y(T,"checkout","cart"===e?function(e){N(e),_&&_(e)}:_),t.useLayoutEffect((function(){if(null===D.current&&S&&null!==L.current){var t=S.create(e,c);"cart"===e&&R&&R(t),D.current=t,O(t),t.mount(L.current)}}),[S,c,R]);var F=y(c);return t.useEffect((function(){if(D.current){var e=x(c,F,["paymentRequest"]);e&&D.current.update(e)}}),[c,F]),t.useLayoutEffect((function(){return function(){D.current&&(D.current.destroy(),D.current=null)}}),[]),t.createElement("div",{id:i,className:s,ref:L})};return o.propTypes={id:v.string,className:v.string,onChange:v.func,onBlur:v.func,onFocus:v.func,onReady:v.func,onEscape:v.func,onClick:v.func,onLoadError:v.func,onLoaderStart:v.func,onNetworksChange:v.func,onCheckout:v.func,onLineItemClick:v.func,onConfirm:v.func,onCancel:v.func,onShippingAddressChange:v.func,onShippingRateChange:v.func,options:v.object},o.displayName=r,o.__elementType=e,o},U="undefined"==typeof window,z=H("auBankAccount",U),W=H("card",U),V=H("cardNumber",U),G=H("cardExpiry",U),Q=H("cardCvc",U),q=H("fpxBank",U),K=H("iban",U),Z=H("idealBank",U),J=H("p24Bank",U),X=H("epsBank",U),ee=H("payment",U),te=H("payButton",U),ne=H("paymentRequestButton",U),re=H("linkAuthentication",U),oe=H("address",U),ie=H("shippingAddress",U),ae=H("cart",U),se=H("paymentMethodMessaging",U),le=H("affirmMessage",U),ce=H("afterpayClearpayMessage",U);e.AddressElement=oe,e.AffirmMessageElement=le,e.AfterpayClearpayMessageElement=ce,e.AuBankAccountElement=z,e.CardCvcElement=Q,e.CardElement=W,e.CardExpiryElement=G,e.CardNumberElement=V,e.CartElement=ae,e.Elements=L,e.ElementsConsumer=j,e.EpsBankElement=X,e.FpxBankElement=q,e.IbanElement=K,e.IdealBankElement=Z,e.LinkAuthenticationElement=re,e.P24BankElement=J,e.PayButtonElement=te,e.PaymentElement=ee,e.PaymentMethodMessagingElement=se,e.PaymentRequestButtonElement=ne,e.ShippingAddressElement=ie,e.useCartElement=N,e.useCartElementState=F,e.useElements=B,e.useStripe=R,Object.defineProperty(e,"__esModule",{value:!0})}(t,n(77810))},86209:(e,t)=>{"use strict";function n(e){return n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},n(e)}var r,o="https://js.stripe.com/v3",i=/^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/,a="loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used",s=null,l=function(e){return null!==s||(s=new Promise((function(t,n){if("undefined"!=typeof window&&"undefined"!=typeof document)if(window.Stripe&&e&&console.warn(a),window.Stripe)t(window.Stripe);else try{var r=function(){for(var e=document.querySelectorAll('script[src^="'.concat(o,'"]')),t=0;t<e.length;t++){var n=e[t];if(i.test(n.src))return n}return null}();r&&e?console.warn(a):r||(r=function(e){var t=e&&!e.advancedFraudSignals?"?advancedFraudSignals=false":"",n=document.createElement("script");n.src="".concat(o).concat(t);var r=document.head||document.body;if(!r)throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");return r.appendChild(n),n}(e)),r.addEventListener("load",(function(){window.Stripe?t(window.Stripe):n(new Error("Stripe.js not available"))})),r.addEventListener("error",(function(){n(new Error("Failed to load Stripe.js"))}))}catch(e){return void n(e)}else t(null)}))),s},c=function(e){var t="invalid load parameters; expected object of shape\n\n    {advancedFraudSignals: boolean}\n\nbut received\n\n    ".concat(JSON.stringify(e),"\n");if(null===e||"object"!==n(e))throw new Error(t);if(1===Object.keys(e).length&&"boolean"==typeof e.advancedFraudSignals)return e;throw new Error(t)},u=!1,d=function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];u=!0;var o=Date.now();return l(r).then((function(e){return function(e,t,n){if(null===e)return null;var r=e.apply(void 0,t);return function(e,t){e&&e._registerWrapper&&e._registerWrapper({name:"stripe-js",version:"1.54.2",startTime:t})}(r,n),r}(e,t,o)}))};d.setLoadParameters=function(e){if(u&&r){var t=c(e);if(Object.keys(t).reduce((function(t,n){var o;return t&&e[n]===(null===(o=r)||void 0===o?void 0:o[n])}),!0))return}if(u)throw new Error("You cannot change load parameters after calling loadStripe");r=c(e)},t.loadStripe=d},85946:(e,t,n)=>{e.exports=n(86209)},46186:e=>{"use strict";var t=[];function n(e){for(var n=-1,r=0;r<t.length;r++)if(t[r].identifier===e){n=r;break}return n}function r(e,r){for(var i={},a=[],s=0;s<e.length;s++){var l=e[s],c=r.base?l[0]+r.base:l[0],u=i[c]||0,d="".concat(c," ").concat(u);i[c]=u+1;var p=n(d),f={css:l[1],media:l[2],sourceMap:l[3],supports:l[4],layer:l[5]};if(-1!==p)t[p].references++,t[p].updater(f);else{var h=o(f,r);r.byIndex=s,t.splice(s,0,{identifier:d,updater:h,references:1})}a.push(d)}return a}function o(e,t){var n=t.domAPI(t);n.update(e);return function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap&&t.supports===e.supports&&t.layer===e.layer)return;n.update(e=t)}else n.remove()}}e.exports=function(e,o){var i=r(e=e||[],o=o||{});return function(e){e=e||[];for(var a=0;a<i.length;a++){var s=n(i[a]);t[s].references--}for(var l=r(e,o),c=0;c<i.length;c++){var u=n(i[c]);0===t[u].references&&(t[u].updater(),t.splice(u,1))}i=l}}},27433:e=>{"use strict";var t={};e.exports=function(e,n){var r=function(e){if(void 0===t[e]){var n=document.querySelector(e);if(window.HTMLIFrameElement&&n instanceof window.HTMLIFrameElement)try{n=n.contentDocument.head}catch(e){n=null}t[e]=n}return t[e]}(e);if(!r)throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");r.appendChild(n)}},8990:e=>{"use strict";e.exports=function(e){var t=document.createElement("style");return e.setAttributes(t,e.attributes),e.insert(t,e.options),t}},88626:(e,t,n)=>{"use strict";e.exports=function(e){var t=n.nc;t&&e.setAttribute("nonce",t)}},82155:e=>{"use strict";e.exports=function(e){if("undefined"==typeof document)return{update:function(){},remove:function(){}};var t=e.insertStyleElement(e);return{update:function(n){!function(e,t,n){var r="";n.supports&&(r+="@supports (".concat(n.supports,") {")),n.media&&(r+="@media ".concat(n.media," {"));var o=void 0!==n.layer;o&&(r+="@layer".concat(n.layer.length>0?" ".concat(n.layer):""," {")),r+=n.css,o&&(r+="}"),n.media&&(r+="}"),n.supports&&(r+="}");var i=n.sourceMap;i&&"undefined"!=typeof btoa&&(r+="\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i))))," */")),t.styleTagTransform(r,e,t.options)}(t,e,n)},remove:function(){!function(e){if(null===e.parentNode)return!1;e.parentNode.removeChild(e)}(t)}}}},89827:e=>{"use strict";e.exports=function(e,t){if(t.styleSheet)t.styleSheet.cssText=e;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(e))}}},30171:e=>{function t(e,t){var n=e.length,r=new Array(n),o={},i=n,a=function(e){for(var t=new Map,n=0,r=e.length;n<r;n++){var o=e[n];t.has(o[0])||t.set(o[0],new Set),t.has(o[1])||t.set(o[1],new Set),t.get(o[0]).add(o[1])}return t}(t),s=function(e){for(var t=new Map,n=0,r=e.length;n<r;n++)t.set(e[n],n);return t}(e);for(t.forEach((function(e){if(!s.has(e[0])||!s.has(e[1]))throw new Error("Unknown node. There is an unknown node in the supplied edges.")}));i--;)o[i]||l(e[i],i,new Set);return r;function l(e,t,i){if(i.has(e)){var c;try{c=", node was:"+JSON.stringify(e)}catch(e){c=""}throw new Error("Cyclic dependency"+c)}if(!s.has(e))throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: "+JSON.stringify(e));if(!o[t]){o[t]=!0;var u=a.get(e)||new Set;if(t=(u=Array.from(u)).length){i.add(e);do{var d=u[--t];l(d,s.get(d),i)}while(t);i.delete(e)}r[--n]=e}}}e.exports=function(e){return t(function(e){for(var t=new Set,n=0,r=e.length;n<r;n++){var o=e[n];t.add(o[0]),t.add(o[1])}return Array.from(t)}(e),e)},e.exports.array=t},19543:(e,t,n)=>{"use strict";t.Ay=void 0;var r=n(35178);Object.defineProperty(t,"Ay",{enumerable:!0,get:function(){return r.default}})},35178:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.useMediaLayout=t.useMedia=t.mockMediaQueryList=void 0;var r=n(77810),o=n(15488);t.mockMediaQueryList={media:"",matches:!1,onchange:o.noop,addListener:o.noop,removeListener:o.noop,addEventListener:o.noop,removeEventListener:o.noop,dispatchEvent:function(e){return!0}};var i=function(e){return function(n,i){void 0===i&&(i=!1);var a=r.useState(i),s=a[0],l=a[1],c=o.queryObjectToString(n);return e((function(){var e=!0,n="undefined"==typeof window?t.mockMediaQueryList:window.matchMedia(c),r=function(){e&&l(Boolean(n.matches))};return n.addListener(r),l(n.matches),function(){e=!1,n.removeListener(r)}}),[c]),s}};t.useMedia=i(r.useEffect),t.useMediaLayout=i(r.useLayoutEffect),t.default=t.useMedia},16471:(e,t)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(e){return e.replace(/[A-Z]/g,(function(e){return"-"+e.toLowerCase()})).toLowerCase()}},15488:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.noop=t.queryObjectToString=t.camelToHyphen=void 0;var r=n(16471);Object.defineProperty(t,"camelToHyphen",{enumerable:!0,get:function(){return r.default}});var o=n(48747);Object.defineProperty(t,"queryObjectToString",{enumerable:!0,get:function(){return o.default}});var i=n(24438);Object.defineProperty(t,"noop",{enumerable:!0,get:function(){return i.default}})},24438:(e,t)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(){}},48747:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(16471);t.default=function(e){return"string"==typeof e?e:Object.entries(e).map((function(e){var t=e[0],n=e[1],o=r.default(t),i=n;return"boolean"==typeof i?i?o:"not "+o:("number"==typeof i&&/[height|width]$/.test(o)&&(i+="px"),"("+o+": "+i+")")})).join(" and ")}},88348:e=>{"use strict";e.exports="data:application/x-font-ttf;charset=utf-8;base64,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"},11269:e=>{"use strict";e.exports='data:image/svg+xml;utf8,<svg height="10" viewBox="0 0 9 10" width="9" xmlns="http://www.w3.org/2000/svg"><path fill="rgba%280, 0, 0, .6%29" d="m3.27162899.66658308.8-.70211699 4 3.51058495-.8.70211699-3.2-2.80846796-3.2 2.80846796-.8-.70211699zm0 8.59576602-3.2-2.80846795.8-.70211699 3.2 2.80846796 3.2-2.80846796.8.70211699-4 3.51058494z" /></svg>'},88696:e=>{e.exports=function(e,t){this.v=e,this.k=t},e.exports.__esModule=!0,e.exports.default=e.exports},11461:(e,t,n)=>{var r=n(86918);function o(){
/*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
var t,n,i="function"==typeof Symbol?Symbol:{},a=i.iterator||"@@iterator",s=i.toStringTag||"@@toStringTag";function l(e,o,i,a){var s=o&&o.prototype instanceof u?o:u,l=Object.create(s.prototype);return r(l,"_invoke",function(e,r,o){var i,a,s,l=0,u=o||[],d=!1,p={p:0,n:0,v:t,a:f,f:f.bind(t,4),d:function(e,n){return i=e,a=0,s=t,p.n=n,c}};function f(e,r){for(a=e,s=r,n=0;!d&&l&&!o&&n<u.length;n++){var o,i=u[n],f=p.p,h=i[2];e>3?(o=h===r)&&(s=i[(a=i[4])?5:(a=3,3)],i[4]=i[5]=t):i[0]<=f&&((o=e<2&&f<i[1])?(a=0,p.v=r,p.n=i[1]):f<h&&(o=e<3||i[0]>r||r>h)&&(i[4]=e,i[5]=r,p.n=h,a=0))}if(o||e>1)return c;throw d=!0,r}return function(o,u,h){if(l>1)throw TypeError("Generator is already running");for(d&&1===u&&f(u,h),a=u,s=h;(n=a<2?t:s)||!d;){i||(a?a<3?(a>1&&(p.n=-1),f(a,s)):p.n=s:p.v=s);try{if(l=2,i){if(a||(o="next"),n=i[o]){if(!(n=n.call(i,s)))throw TypeError("iterator result is not an object");if(!n.done)return n;s=n.value,a<2&&(a=0)}else 1===a&&(n=i.return)&&n.call(i),a<2&&(s=TypeError("The iterator does not provide a '"+o+"' method"),a=1);i=t}else if((n=(d=p.n<0)?s:e.call(r,p))!==c)break}catch(e){i=t,a=1,s=e}finally{l=1}}return{value:n,done:d}}}(e,i,a),!0),l}var c={};function u(){}function d(){}function p(){}n=Object.getPrototypeOf;var f=[][a]?n(n([][a]())):(r(n={},a,(function(){return this})),n),h=p.prototype=u.prototype=Object.create(f);function m(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,p):(e.__proto__=p,r(e,s,"GeneratorFunction")),e.prototype=Object.create(h),e}return d.prototype=p,r(h,"constructor",p),r(p,"constructor",d),d.displayName="GeneratorFunction",r(p,s,"GeneratorFunction"),r(h),r(h,s,"Generator"),r(h,a,(function(){return this})),r(h,"toString",(function(){return"[object Generator]"})),(e.exports=o=function(){return{w:l,m}},e.exports.__esModule=!0,e.exports.default=e.exports)()}e.exports=o,e.exports.__esModule=!0,e.exports.default=e.exports},5217:(e,t,n)=>{var r=n(91115);e.exports=function(e,t,n,o,i){var a=r(e,t,n,o,i);return a.next().then((function(e){return e.done?e.value:a.next()}))},e.exports.__esModule=!0,e.exports.default=e.exports},91115:(e,t,n)=>{var r=n(11461),o=n(21907);e.exports=function(e,t,n,i,a){return new o(r().w(e,t,n,i),a||Promise)},e.exports.__esModule=!0,e.exports.default=e.exports},21907:(e,t,n)=>{var r=n(88696),o=n(86918);e.exports=function e(t,n){function i(e,o,a,s){try{var l=t[e](o),c=l.value;return c instanceof r?n.resolve(c.v).then((function(e){i("next",e,a,s)}),(function(e){i("throw",e,a,s)})):n.resolve(c).then((function(e){l.value=e,a(l)}),(function(e){return i("throw",e,a,s)}))}catch(e){s(e)}}var a;this.next||(o(e.prototype),o(e.prototype,"function"==typeof Symbol&&Symbol.asyncIterator||"@asyncIterator",(function(){return this}))),o(this,"_invoke",(function(e,t,r){function o(){return new n((function(t,n){i(e,r,t,n)}))}return a=a?a.then(o,o):o()}),!0)},e.exports.__esModule=!0,e.exports.default=e.exports},86918:e=>{function t(n,r,o,i){var a=Object.defineProperty;try{a({},"",{})}catch(n){a=0}e.exports=t=function(e,n,r,o){function i(n,r){t(e,n,(function(e){return this._invoke(n,r,e)}))}n?a?a(e,n,{value:r,enumerable:!o,configurable:!o,writable:!o}):e[n]=r:(i("next",0),i("throw",1),i("return",2))},e.exports.__esModule=!0,e.exports.default=e.exports,t(n,r,o,i)}e.exports=t,e.exports.__esModule=!0,e.exports.default=e.exports},41697:e=>{e.exports=function(e){var t=Object(e),n=[];for(var r in t)n.unshift(r);return function e(){for(;n.length;)if((r=n.pop())in t)return e.value=r,e.done=!1,e;return e.done=!0,e}},e.exports.__esModule=!0,e.exports.default=e.exports},58541:(e,t,n)=>{var r=n(88696),o=n(11461),i=n(5217),a=n(91115),s=n(21907),l=n(41697),c=n(97735);function u(){"use strict";var t=o(),n=t.m(u),d=(Object.getPrototypeOf?Object.getPrototypeOf(n):n.__proto__).constructor;function p(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===d||"GeneratorFunction"===(t.displayName||t.name))}var f={throw:1,return:2,break:3,continue:3};function h(e){var t,n;return function(r){t||(t={stop:function(){return n(r.a,2)},catch:function(){return r.v},abrupt:function(e,t){return n(r.a,f[e],t)},delegateYield:function(e,o,i){return t.resultName=o,n(r.d,c(e),i)},finish:function(e){return n(r.f,e)}},n=function(e,n,o){r.p=t.prev,r.n=t.next;try{return e(n,o)}finally{t.next=r.n}}),t.resultName&&(t[t.resultName]=r.v,t.resultName=void 0),t.sent=r.v,t.next=r.n;try{return e.call(this,t)}finally{r.p=t.prev,r.n=t.next}}}return(e.exports=u=function(){return{wrap:function(e,n,r,o){return t.w(h(e),n,r,o&&o.reverse())},isGeneratorFunction:p,mark:t.m,awrap:function(e,t){return new r(e,t)},AsyncIterator:s,async:function(e,t,n,r,o){return(p(t)?a:i)(h(e),t,n,r,o)},keys:l,values:c}},e.exports.__esModule=!0,e.exports.default=e.exports)()}e.exports=u,e.exports.__esModule=!0,e.exports.default=e.exports},97735:(e,t,n)=>{var r=n(12990).default;e.exports=function(e){if(null!=e){var t=e["function"==typeof Symbol&&Symbol.iterator||"@@iterator"],n=0;if(t)return t.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length))return{next:function(){return e&&n>=e.length&&(e=void 0),{value:e&&e[n++],done:!e}}}}throw new TypeError(r(e)+" is not iterable")},e.exports.__esModule=!0,e.exports.default=e.exports},12990:e=>{function t(n){return e.exports=t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports.__esModule=!0,e.exports.default=e.exports,t(n)}e.exports=t,e.exports.__esModule=!0,e.exports.default=e.exports},70232:(e,t,n)=>{var r=n(58541)();e.exports=r;try{regeneratorRuntime=r}catch(e){"object"==typeof globalThis?globalThis.regeneratorRuntime=r:Function("r","regeneratorRuntime = r")(r)}},86838:(e,t)=>{var n;
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/!function(){"use strict";var r={}.hasOwnProperty;function o(){for(var e="",t=0;t<arguments.length;t++){var n=arguments[t];n&&(e=a(e,i(n)))}return e}function i(e){if("string"==typeof e||"number"==typeof e)return e;if("object"!=typeof e)return"";if(Array.isArray(e))return o.apply(null,e);if(e.toString!==Object.prototype.toString&&!e.toString.toString().includes("[native code]"))return e.toString();var t="";for(var n in e)r.call(e,n)&&e[n]&&(t=a(t,n));return t}function a(e,t){return t?e?e+" "+t:e+t:e}e.exports?(o.default=o,e.exports=o):void 0===(n=function(){return o}.apply(t,[]))||(e.exports=n)}()}},r={};function o(e){var t=r[e];if(void 0!==t)return t.exports;var i=r[e]={id:e,loaded:!1,exports:{}};return n[e].call(i.exports,i,i.exports,o),i.loaded=!0,i.exports}o.m=n,o.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return o.d(t,{a:t}),t},t=Object.getPrototypeOf?e=>Object.getPrototypeOf(e):e=>e.__proto__,o.t=function(n,r){if(1&r&&(n=this(n)),8&r)return n;if("object"==typeof n&&n){if(4&r&&n.__esModule)return n;if(16&r&&"function"==typeof n.then)return n}var i=Object.create(null);o.r(i);var a={};e=e||[null,t({}),t([]),t(t)];for(var s=2&r&&n;"object"==typeof s&&!~e.indexOf(s);s=t(s))Object.getOwnPropertyNames(s).forEach((e=>a[e]=()=>n[e]));return a.default=()=>n,o.d(i,a),i},o.d=(e,t)=>{for(var n in t)o.o(t,n)&&!o.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},o.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(e){if("object"==typeof window)return window}}(),o.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),o.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},o.nmd=e=>(e.paths=[],e.children||(e.children=[]),e),(()=>{var e;o.g.importScripts&&(e=o.g.location+"");var t=o.g.document;if(!e&&t&&(t.currentScript&&(e=t.currentScript.src),!e)){var n=t.getElementsByTagName("script");if(n.length)for(var r=n.length-1;r>-1&&(!e||!/^http(s?):/.test(e));)e=n[r--].src}if(!e)throw new Error("Automatic publicPath is not supported in this browser");e=e.replace(/#.*$/,"").replace(/\?.*$/,"").replace(/\/[^\/]+$/,"/"),o.p=e+"../"})(),o.b=document.baseURI||self.location.href,o.nc=void 0,(()=>{"use strict";function e(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}function t(t,n){if(null==t)return{};var r,o,i=e(t,n);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(t);for(o=0;o<a.length;o++)r=a[o],-1===n.indexOf(r)&&{}.propertyIsEnumerable.call(t,r)&&(i[r]=t[r])}return i}function n(){return n=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},n.apply(null,arguments)}var r=o(94140),i=o(77810),a=o.t(i,2),s=function(e){return e.Development="development",e.Production="production",e.Staging="staging",e}({});var l="test",c=l;const u=function(){return c};function d(e){if(Array.isArray(e))return e}function p(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=Array(t);n<t;n++)r[n]=e[n];return r}function f(e,t){if(e){if("string"==typeof e)return p(e,t);var n={}.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?p(e,t):void 0}}function h(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function m(e,t){return d(e)||function(e,t){var n=null==e?null:"undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(null!=n){var r,o,i,a,s=[],l=!0,c=!1;try{if(i=(n=n.call(e)).next,0===t){if(Object(n)!==n)return;l=!1}else for(;!(l=(r=i.call(n)).done)&&(s.push(r.value),s.length!==t);l=!0);}catch(e){c=!0,o=e}finally{try{if(!l&&null!=n.return&&(a=n.return(),Object(a)!==a))return}finally{if(c)throw o}}return s}}(e,t)||f(e,t)||h()}var g=(...e)=>e.filter(Boolean).join(" ");function v(e){const t=typeof e;return null!=e&&("object"===t||"function"===t)&&!Array.isArray(e)}var y=e=>{const{condition:t,message:n}=e};function b(e,...t){return _(e)?e(...t):e}var _=e=>"function"==typeof e,A=e=>e?"":void 0,E=e=>!!e||void 0;function w(...e){return function(t){e.some((e=>(null==e||e(t),null==t?void 0:t.defaultPrevented)))}}function x(...e){return function(t){e.forEach((e=>{null==e||e(t)}))}}var k=o(19692),C=o.n(k),S=e=>"string"==typeof e?e.replace(/!(important)?$/,"").trim():e,M=(e,t)=>n=>{const r=String(t),o=(e=>/!(important)?$/.test(e))(r),i=S(r),a=e?`${e}.${i}`:i;let s=v(n.__cssMap)&&a in n.__cssMap?n.__cssMap[a].varRef:t;return s=S(s),o?`${s} !important`:s};function T(e){const{scale:t,transform:n,compose:r}=e;return(e,o)=>{var i;const a=M(t,e)(o);let s=null!=(i=null==n?void 0:n(a,o))?i:a;return r&&(s=r(s,o)),s}}var O=(...e)=>t=>e.reduce(((e,t)=>t(e)),t);function D(e,t){return n=>{const r={property:n,scale:e};return r.transform=T({scale:e,transform:t}),r}}var L=({rtl:e,ltr:t})=>n=>"rtl"===n.direction?e:t;var P=["rotate(var(--chakra-rotate, 0))","scaleX(var(--chakra-scale-x, 1))","scaleY(var(--chakra-scale-y, 1))","skewX(var(--chakra-skew-x, 0))","skewY(var(--chakra-skew-y, 0))"];var I={"--chakra-blur":"var(--chakra-empty,/*!*/ /*!*/)","--chakra-brightness":"var(--chakra-empty,/*!*/ /*!*/)","--chakra-contrast":"var(--chakra-empty,/*!*/ /*!*/)","--chakra-grayscale":"var(--chakra-empty,/*!*/ /*!*/)","--chakra-hue-rotate":"var(--chakra-empty,/*!*/ /*!*/)","--chakra-invert":"var(--chakra-empty,/*!*/ /*!*/)","--chakra-saturate":"var(--chakra-empty,/*!*/ /*!*/)","--chakra-sepia":"var(--chakra-empty,/*!*/ /*!*/)","--chakra-drop-shadow":"var(--chakra-empty,/*!*/ /*!*/)",filter:["var(--chakra-blur)","var(--chakra-brightness)","var(--chakra-contrast)","var(--chakra-grayscale)","var(--chakra-hue-rotate)","var(--chakra-invert)","var(--chakra-saturate)","var(--chakra-sepia)","var(--chakra-drop-shadow)"].join(" ")},B={backdropFilter:["var(--chakra-backdrop-blur)","var(--chakra-backdrop-brightness)","var(--chakra-backdrop-contrast)","var(--chakra-backdrop-grayscale)","var(--chakra-backdrop-hue-rotate)","var(--chakra-backdrop-invert)","var(--chakra-backdrop-opacity)","var(--chakra-backdrop-saturate)","var(--chakra-backdrop-sepia)"].join(" "),"--chakra-backdrop-blur":"var(--chakra-empty,/*!*/ /*!*/)","--chakra-backdrop-brightness":"var(--chakra-empty,/*!*/ /*!*/)","--chakra-backdrop-contrast":"var(--chakra-empty,/*!*/ /*!*/)","--chakra-backdrop-grayscale":"var(--chakra-empty,/*!*/ /*!*/)","--chakra-backdrop-hue-rotate":"var(--chakra-empty,/*!*/ /*!*/)","--chakra-backdrop-invert":"var(--chakra-empty,/*!*/ /*!*/)","--chakra-backdrop-opacity":"var(--chakra-empty,/*!*/ /*!*/)","--chakra-backdrop-saturate":"var(--chakra-empty,/*!*/ /*!*/)","--chakra-backdrop-sepia":"var(--chakra-empty,/*!*/ /*!*/)"};var R={"row-reverse":{space:"--chakra-space-x-reverse",divide:"--chakra-divide-x-reverse"},"column-reverse":{space:"--chakra-space-y-reverse",divide:"--chakra-divide-y-reverse"}},N={"to-t":"to top","to-tr":"to top right","to-r":"to right","to-br":"to bottom right","to-b":"to bottom","to-bl":"to bottom left","to-l":"to left","to-tl":"to top left"},F=new Set(Object.values(N)),j=new Set(["none","-moz-initial","inherit","initial","revert","unset"]),Y=e=>e.trim();var $=e=>"string"==typeof e&&e.includes("(")&&e.includes(")");var H=e=>t=>`${e}(${t})`,U={filter:e=>"auto"!==e?e:I,backdropFilter:e=>"auto"!==e?e:B,ring:e=>function(e){return{"--chakra-ring-offset-shadow":"var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)","--chakra-ring-shadow":"var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)","--chakra-ring-width":e,boxShadow:["var(--chakra-ring-offset-shadow)","var(--chakra-ring-shadow)","var(--chakra-shadow, 0 0 #0000)"].join(", ")}}(U.px(e)),bgClip:e=>"text"===e?{color:"transparent",backgroundClip:"text"}:{backgroundClip:e},transform:e=>"auto"===e?["translateX(var(--chakra-translate-x, 0))","translateY(var(--chakra-translate-y, 0))",...P].join(" "):"auto-gpu"===e?["translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",...P].join(" "):e,vh:e=>"$100vh"===e?"var(--chakra-vh)":e,px(e){if(null==e)return e;const{unitless:t}=(e=>{const t=parseFloat(e.toString()),n=e.toString().replace(String(t),"");return{unitless:!n,value:t,unit:n}})(e);return t||"number"==typeof e?`${e}px`:e},fraction:e=>"number"!=typeof e||e>1?e:100*e+"%",float:(e,t)=>"rtl"===t.direction?{left:"right",right:"left"}[e]:e,degree(e){if(function(e){return/^var\(--.+\)$/.test(e)}(e)||null==e)return e;const t="string"==typeof e&&!e.endsWith("deg");return"number"==typeof e||t?`${e}deg`:e},gradient:(e,t)=>function(e,t){if(null==e||j.has(e))return e;if(!$(e)&&!j.has(e))return`url('${e}')`;const n=/(^[a-z-A-Z]+)\((.*)\)/g.exec(e),r=null==n?void 0:n[1],o=null==n?void 0:n[2];if(!r||!o)return e;const i=r.includes("-gradient")?r:`${r}-gradient`,[a,...s]=o.split(",").map(Y).filter(Boolean);if(0===(null==s?void 0:s.length))return e;const l=a in N?N[a]:a;return s.unshift(l),`${i}(${s.map((e=>{if(F.has(e))return e;const n=e.indexOf(" "),[r,o]=-1!==n?[e.substr(0,n),e.substr(n+1)]:[e],i=$(o)?o:o&&o.split(" "),a=`colors.${r}`,s=a in t.__cssMap?t.__cssMap[a].varRef:r;return i?[s,...Array.isArray(i)?i:[i]].join(" "):s})).join(", ")})`}(e,null!=t?t:{}),blur:H("blur"),opacity:H("opacity"),brightness:H("brightness"),contrast:H("contrast"),dropShadow:H("drop-shadow"),grayscale:H("grayscale"),hueRotate:e=>H("hue-rotate")(U.degree(e)),invert:H("invert"),saturate:H("saturate"),sepia:H("sepia"),bgImage(e){if(null==e)return e;return $(e)||j.has(e)?e:`url(${e})`},outline(e){const t="0"===String(e)||"none"===String(e);return null!==e&&t?{outline:"2px solid transparent",outlineOffset:"2px"}:{outline:e}},flexDirection(e){var t;const{space:n,divide:r}=null!=(t=R[e])?t:{},o={flexDirection:e};return n&&(o[n]=1),r&&(o[r]=1),o}},z={borderWidths:D("borderWidths"),borderStyles:D("borderStyles"),colors:D("colors"),borders:D("borders"),gradients:D("gradients",U.gradient),radii:D("radii",U.px),space:D("space",O(U.vh,U.px)),spaceT:D("space",O(U.vh,U.px)),degreeT:e=>({property:e,transform:U.degree}),prop:(e,t,n)=>({property:e,scale:t,...t&&{transform:T({scale:t,transform:n})}}),propT:(e,t)=>({property:e,transform:t}),sizes:D("sizes",O(U.vh,U.px)),sizesT:D("sizes",O(U.vh,U.fraction)),shadows:D("shadows"),logical:function(e){const{property:t,scale:n,transform:r}=e;return{scale:n,property:L(t),transform:n?T({scale:n,compose:r}):r}},blur:D("blur",U.blur)},W={background:z.colors("background"),backgroundColor:z.colors("backgroundColor"),backgroundImage:z.gradients("backgroundImage"),backgroundSize:!0,backgroundPosition:!0,backgroundRepeat:!0,backgroundAttachment:!0,backgroundClip:{transform:U.bgClip},bgSize:z.prop("backgroundSize"),bgPosition:z.prop("backgroundPosition"),bg:z.colors("background"),bgColor:z.colors("backgroundColor"),bgPos:z.prop("backgroundPosition"),bgRepeat:z.prop("backgroundRepeat"),bgAttachment:z.prop("backgroundAttachment"),bgGradient:z.gradients("backgroundImage"),bgClip:{transform:U.bgClip}};Object.assign(W,{bgImage:W.backgroundImage,bgImg:W.backgroundImage});var V={border:z.borders("border"),borderWidth:z.borderWidths("borderWidth"),borderStyle:z.borderStyles("borderStyle"),borderColor:z.colors("borderColor"),borderRadius:z.radii("borderRadius"),borderTop:z.borders("borderTop"),borderBlockStart:z.borders("borderBlockStart"),borderTopLeftRadius:z.radii("borderTopLeftRadius"),borderStartStartRadius:z.logical({scale:"radii",property:{ltr:"borderTopLeftRadius",rtl:"borderTopRightRadius"}}),borderEndStartRadius:z.logical({scale:"radii",property:{ltr:"borderBottomLeftRadius",rtl:"borderBottomRightRadius"}}),borderTopRightRadius:z.radii("borderTopRightRadius"),borderStartEndRadius:z.logical({scale:"radii",property:{ltr:"borderTopRightRadius",rtl:"borderTopLeftRadius"}}),borderEndEndRadius:z.logical({scale:"radii",property:{ltr:"borderBottomRightRadius",rtl:"borderBottomLeftRadius"}}),borderRight:z.borders("borderRight"),borderInlineEnd:z.borders("borderInlineEnd"),borderBottom:z.borders("borderBottom"),borderBlockEnd:z.borders("borderBlockEnd"),borderBottomLeftRadius:z.radii("borderBottomLeftRadius"),borderBottomRightRadius:z.radii("borderBottomRightRadius"),borderLeft:z.borders("borderLeft"),borderInlineStart:{property:"borderInlineStart",scale:"borders"},borderInlineStartRadius:z.logical({scale:"radii",property:{ltr:["borderTopLeftRadius","borderBottomLeftRadius"],rtl:["borderTopRightRadius","borderBottomRightRadius"]}}),borderInlineEndRadius:z.logical({scale:"radii",property:{ltr:["borderTopRightRadius","borderBottomRightRadius"],rtl:["borderTopLeftRadius","borderBottomLeftRadius"]}}),borderX:z.borders(["borderLeft","borderRight"]),borderInline:z.borders("borderInline"),borderY:z.borders(["borderTop","borderBottom"]),borderBlock:z.borders("borderBlock"),borderTopWidth:z.borderWidths("borderTopWidth"),borderBlockStartWidth:z.borderWidths("borderBlockStartWidth"),borderTopColor:z.colors("borderTopColor"),borderBlockStartColor:z.colors("borderBlockStartColor"),borderTopStyle:z.borderStyles("borderTopStyle"),borderBlockStartStyle:z.borderStyles("borderBlockStartStyle"),borderBottomWidth:z.borderWidths("borderBottomWidth"),borderBlockEndWidth:z.borderWidths("borderBlockEndWidth"),borderBottomColor:z.colors("borderBottomColor"),borderBlockEndColor:z.colors("borderBlockEndColor"),borderBottomStyle:z.borderStyles("borderBottomStyle"),borderBlockEndStyle:z.borderStyles("borderBlockEndStyle"),borderLeftWidth:z.borderWidths("borderLeftWidth"),borderInlineStartWidth:z.borderWidths("borderInlineStartWidth"),borderLeftColor:z.colors("borderLeftColor"),borderInlineStartColor:z.colors("borderInlineStartColor"),borderLeftStyle:z.borderStyles("borderLeftStyle"),borderInlineStartStyle:z.borderStyles("borderInlineStartStyle"),borderRightWidth:z.borderWidths("borderRightWidth"),borderInlineEndWidth:z.borderWidths("borderInlineEndWidth"),borderRightColor:z.colors("borderRightColor"),borderInlineEndColor:z.colors("borderInlineEndColor"),borderRightStyle:z.borderStyles("borderRightStyle"),borderInlineEndStyle:z.borderStyles("borderInlineEndStyle"),borderTopRadius:z.radii(["borderTopLeftRadius","borderTopRightRadius"]),borderBottomRadius:z.radii(["borderBottomLeftRadius","borderBottomRightRadius"]),borderLeftRadius:z.radii(["borderTopLeftRadius","borderBottomLeftRadius"]),borderRightRadius:z.radii(["borderTopRightRadius","borderBottomRightRadius"])};Object.assign(V,{rounded:V.borderRadius,roundedTop:V.borderTopRadius,roundedTopLeft:V.borderTopLeftRadius,roundedTopRight:V.borderTopRightRadius,roundedTopStart:V.borderStartStartRadius,roundedTopEnd:V.borderStartEndRadius,roundedBottom:V.borderBottomRadius,roundedBottomLeft:V.borderBottomLeftRadius,roundedBottomRight:V.borderBottomRightRadius,roundedBottomStart:V.borderEndStartRadius,roundedBottomEnd:V.borderEndEndRadius,roundedLeft:V.borderLeftRadius,roundedRight:V.borderRightRadius,roundedStart:V.borderInlineStartRadius,roundedEnd:V.borderInlineEndRadius,borderStart:V.borderInlineStart,borderEnd:V.borderInlineEnd,borderTopStartRadius:V.borderStartStartRadius,borderTopEndRadius:V.borderStartEndRadius,borderBottomStartRadius:V.borderEndStartRadius,borderBottomEndRadius:V.borderEndEndRadius,borderStartRadius:V.borderInlineStartRadius,borderEndRadius:V.borderInlineEndRadius,borderStartWidth:V.borderInlineStartWidth,borderEndWidth:V.borderInlineEndWidth,borderStartColor:V.borderInlineStartColor,borderEndColor:V.borderInlineEndColor,borderStartStyle:V.borderInlineStartStyle,borderEndStyle:V.borderInlineEndStyle});var G={color:z.colors("color"),textColor:z.colors("color"),fill:z.colors("fill"),stroke:z.colors("stroke")},Q={boxShadow:z.shadows("boxShadow"),mixBlendMode:!0,blendMode:z.prop("mixBlendMode"),backgroundBlendMode:!0,bgBlendMode:z.prop("backgroundBlendMode"),opacity:!0};Object.assign(Q,{shadow:Q.boxShadow});var q={filter:{transform:U.filter},blur:z.blur("--chakra-blur"),brightness:z.propT("--chakra-brightness",U.brightness),contrast:z.propT("--chakra-contrast",U.contrast),hueRotate:z.propT("--chakra-hue-rotate",U.hueRotate),invert:z.propT("--chakra-invert",U.invert),saturate:z.propT("--chakra-saturate",U.saturate),dropShadow:z.propT("--chakra-drop-shadow",U.dropShadow),backdropFilter:{transform:U.backdropFilter},backdropBlur:z.blur("--chakra-backdrop-blur"),backdropBrightness:z.propT("--chakra-backdrop-brightness",U.brightness),backdropContrast:z.propT("--chakra-backdrop-contrast",U.contrast),backdropHueRotate:z.propT("--chakra-backdrop-hue-rotate",U.hueRotate),backdropInvert:z.propT("--chakra-backdrop-invert",U.invert),backdropSaturate:z.propT("--chakra-backdrop-saturate",U.saturate)},K={alignItems:!0,alignContent:!0,justifyItems:!0,justifyContent:!0,flexWrap:!0,flexDirection:{transform:U.flexDirection},flex:!0,flexFlow:!0,flexGrow:!0,flexShrink:!0,flexBasis:z.sizes("flexBasis"),justifySelf:!0,alignSelf:!0,order:!0,placeItems:!0,placeContent:!0,placeSelf:!0,gap:z.space("gap"),rowGap:z.space("rowGap"),columnGap:z.space("columnGap")};Object.assign(K,{flexDir:K.flexDirection});var Z={gridGap:z.space("gridGap"),gridColumnGap:z.space("gridColumnGap"),gridRowGap:z.space("gridRowGap"),gridColumn:!0,gridRow:!0,gridAutoFlow:!0,gridAutoColumns:!0,gridColumnStart:!0,gridColumnEnd:!0,gridRowStart:!0,gridRowEnd:!0,gridAutoRows:!0,gridTemplate:!0,gridTemplateColumns:!0,gridTemplateRows:!0,gridTemplateAreas:!0,gridArea:!0},J={appearance:!0,cursor:!0,resize:!0,userSelect:!0,pointerEvents:!0,outline:{transform:U.outline},outlineOffset:!0,outlineColor:z.colors("outlineColor")},X={width:z.sizesT("width"),inlineSize:z.sizesT("inlineSize"),height:z.sizes("height"),blockSize:z.sizes("blockSize"),boxSize:z.sizes(["width","height"]),minWidth:z.sizes("minWidth"),minInlineSize:z.sizes("minInlineSize"),minHeight:z.sizes("minHeight"),minBlockSize:z.sizes("minBlockSize"),maxWidth:z.sizes("maxWidth"),maxInlineSize:z.sizes("maxInlineSize"),maxHeight:z.sizes("maxHeight"),maxBlockSize:z.sizes("maxBlockSize"),overflow:!0,overflowX:!0,overflowY:!0,overscrollBehavior:!0,overscrollBehaviorX:!0,overscrollBehaviorY:!0,display:!0,aspectRatio:!0,hideFrom:{scale:"breakpoints",transform:(e,t)=>{var n,r,o;const i=`@media screen and (min-width: ${null!=(o=null==(r=null==(n=t.__breakpoints)?void 0:n.get(e))?void 0:r.minW)?o:e})`;return{[i]:{display:"none"}}}},hideBelow:{scale:"breakpoints",transform:(e,t)=>{var n,r,o;const i=`@media screen and (max-width: ${null!=(o=null==(r=null==(n=t.__breakpoints)?void 0:n.get(e))?void 0:r._minW)?o:e})`;return{[i]:{display:"none"}}}},verticalAlign:!0,boxSizing:!0,boxDecorationBreak:!0,float:z.propT("float",U.float),objectFit:!0,objectPosition:!0,visibility:!0,isolation:!0};Object.assign(X,{w:X.width,h:X.height,minW:X.minWidth,maxW:X.maxWidth,minH:X.minHeight,maxH:X.maxHeight,overscroll:X.overscrollBehavior,overscrollX:X.overscrollBehaviorX,overscrollY:X.overscrollBehaviorY});var ee={listStyleType:!0,listStylePosition:!0,listStylePos:z.prop("listStylePosition"),listStyleImage:!0,listStyleImg:z.prop("listStyleImage")};var te=(e=>{const t=new WeakMap;return(n,r,o,i)=>{if(void 0===n)return e(n,r,o);t.has(n)||t.set(n,new Map);const a=t.get(n);if(a.has(r))return a.get(r);const s=e(n,r,o,i);return a.set(r,s),s}})((function(e,t,n,r){const o="string"==typeof t?t.split("."):[t];for(r=0;r<o.length&&e;r+=1)e=e[o[r]];return void 0===e?n:e})),ne={border:"0px",clip:"rect(0, 0, 0, 0)",width:"1px",height:"1px",margin:"-1px",padding:"0px",overflow:"hidden",whiteSpace:"nowrap",position:"absolute"},re={position:"static",width:"auto",height:"auto",clip:"auto",padding:"0",margin:"0",overflow:"visible",whiteSpace:"normal"},oe=(e,t,n)=>{const r={},o=te(e,t,{});for(const e in o){e in n&&null!=n[e]||(r[e]=o[e])}return r},ie={srOnly:{transform:e=>!0===e?ne:"focusable"===e?re:{}},layerStyle:{processResult:!0,transform:(e,t,n)=>oe(t,`layerStyles.${e}`,n)},textStyle:{processResult:!0,transform:(e,t,n)=>oe(t,`textStyles.${e}`,n)},apply:{processResult:!0,transform:(e,t,n)=>oe(t,e,n)}},ae={position:!0,pos:z.prop("position"),zIndex:z.prop("zIndex","zIndices"),inset:z.spaceT("inset"),insetX:z.spaceT(["left","right"]),insetInline:z.spaceT("insetInline"),insetY:z.spaceT(["top","bottom"]),insetBlock:z.spaceT("insetBlock"),top:z.spaceT("top"),insetBlockStart:z.spaceT("insetBlockStart"),bottom:z.spaceT("bottom"),insetBlockEnd:z.spaceT("insetBlockEnd"),left:z.spaceT("left"),insetInlineStart:z.logical({scale:"space",property:{ltr:"left",rtl:"right"}}),right:z.spaceT("right"),insetInlineEnd:z.logical({scale:"space",property:{ltr:"right",rtl:"left"}})};Object.assign(ae,{insetStart:ae.insetInlineStart,insetEnd:ae.insetInlineEnd});var se={ring:{transform:U.ring},ringColor:z.colors("--chakra-ring-color"),ringOffset:z.prop("--chakra-ring-offset-width"),ringOffsetColor:z.colors("--chakra-ring-offset-color"),ringInset:z.prop("--chakra-ring-inset")},le={margin:z.spaceT("margin"),marginTop:z.spaceT("marginTop"),marginBlockStart:z.spaceT("marginBlockStart"),marginRight:z.spaceT("marginRight"),marginInlineEnd:z.spaceT("marginInlineEnd"),marginBottom:z.spaceT("marginBottom"),marginBlockEnd:z.spaceT("marginBlockEnd"),marginLeft:z.spaceT("marginLeft"),marginInlineStart:z.spaceT("marginInlineStart"),marginX:z.spaceT(["marginInlineStart","marginInlineEnd"]),marginInline:z.spaceT("marginInline"),marginY:z.spaceT(["marginTop","marginBottom"]),marginBlock:z.spaceT("marginBlock"),padding:z.space("padding"),paddingTop:z.space("paddingTop"),paddingBlockStart:z.space("paddingBlockStart"),paddingRight:z.space("paddingRight"),paddingBottom:z.space("paddingBottom"),paddingBlockEnd:z.space("paddingBlockEnd"),paddingLeft:z.space("paddingLeft"),paddingInlineStart:z.space("paddingInlineStart"),paddingInlineEnd:z.space("paddingInlineEnd"),paddingX:z.space(["paddingInlineStart","paddingInlineEnd"]),paddingInline:z.space("paddingInline"),paddingY:z.space(["paddingTop","paddingBottom"]),paddingBlock:z.space("paddingBlock")};Object.assign(le,{m:le.margin,mt:le.marginTop,mr:le.marginRight,me:le.marginInlineEnd,marginEnd:le.marginInlineEnd,mb:le.marginBottom,ml:le.marginLeft,ms:le.marginInlineStart,marginStart:le.marginInlineStart,mx:le.marginX,my:le.marginY,p:le.padding,pt:le.paddingTop,py:le.paddingY,px:le.paddingX,pb:le.paddingBottom,pl:le.paddingLeft,ps:le.paddingInlineStart,paddingStart:le.paddingInlineStart,pr:le.paddingRight,pe:le.paddingInlineEnd,paddingEnd:le.paddingInlineEnd});var ce={textDecorationColor:z.colors("textDecorationColor"),textDecoration:!0,textDecor:{property:"textDecoration"},textDecorationLine:!0,textDecorationStyle:!0,textDecorationThickness:!0,textUnderlineOffset:!0,textShadow:z.shadows("textShadow")},ue={clipPath:!0,transform:z.propT("transform",U.transform),transformOrigin:!0,translateX:z.spaceT("--chakra-translate-x"),translateY:z.spaceT("--chakra-translate-y"),skewX:z.degreeT("--chakra-skew-x"),skewY:z.degreeT("--chakra-skew-y"),scaleX:z.prop("--chakra-scale-x"),scaleY:z.prop("--chakra-scale-y"),scale:z.prop(["--chakra-scale-x","--chakra-scale-y"]),rotate:z.degreeT("--chakra-rotate")},de={transition:!0,transitionDelay:!0,animation:!0,willChange:!0,transitionDuration:z.prop("transitionDuration","transition.duration"),transitionProperty:z.prop("transitionProperty","transition.property"),transitionTimingFunction:z.prop("transitionTimingFunction","transition.easing")},pe={fontFamily:z.prop("fontFamily","fonts"),fontSize:z.prop("fontSize","fontSizes",U.px),fontWeight:z.prop("fontWeight","fontWeights"),lineHeight:z.prop("lineHeight","lineHeights"),letterSpacing:z.prop("letterSpacing","letterSpacings"),textAlign:!0,fontStyle:!0,textIndent:!0,wordBreak:!0,overflowWrap:!0,textOverflow:!0,textTransform:!0,whiteSpace:!0,isTruncated:{transform(e){if(!0===e)return{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}},noOfLines:{static:{overflow:"hidden",textOverflow:"ellipsis",display:"-webkit-box",WebkitBoxOrient:"vertical",WebkitLineClamp:"var(--chakra-line-clamp)"},property:"--chakra-line-clamp"}},fe={scrollBehavior:!0,scrollSnapAlign:!0,scrollSnapStop:!0,scrollSnapType:!0,scrollMargin:z.spaceT("scrollMargin"),scrollMarginTop:z.spaceT("scrollMarginTop"),scrollMarginBottom:z.spaceT("scrollMarginBottom"),scrollMarginLeft:z.spaceT("scrollMarginLeft"),scrollMarginRight:z.spaceT("scrollMarginRight"),scrollMarginX:z.spaceT(["scrollMarginLeft","scrollMarginRight"]),scrollMarginY:z.spaceT(["scrollMarginTop","scrollMarginBottom"]),scrollPadding:z.spaceT("scrollPadding"),scrollPaddingTop:z.spaceT("scrollPaddingTop"),scrollPaddingBottom:z.spaceT("scrollPaddingBottom"),scrollPaddingLeft:z.spaceT("scrollPaddingLeft"),scrollPaddingRight:z.spaceT("scrollPaddingRight"),scrollPaddingX:z.spaceT(["scrollPaddingLeft","scrollPaddingRight"]),scrollPaddingY:z.spaceT(["scrollPaddingTop","scrollPaddingBottom"])};function he(e){return v(e)&&e.reference?e.reference:String(e)}var me=(e,...t)=>t.map(he).join(` ${e} `).replace(/calc/g,""),ge=(...e)=>`calc(${me("+",...e)})`,ve=(...e)=>`calc(${me("-",...e)})`,ye=(...e)=>`calc(${me("*",...e)})`,be=(...e)=>`calc(${me("/",...e)})`,_e=e=>{const t=he(e);return null==t||Number.isNaN(parseFloat(t))?ye(t,-1):String(t).startsWith("-")?String(t).slice(1):`-${t}`},Ae=Object.assign((e=>({add:(...t)=>Ae(ge(e,...t)),subtract:(...t)=>Ae(ve(e,...t)),multiply:(...t)=>Ae(ye(e,...t)),divide:(...t)=>Ae(be(e,...t)),negate:()=>Ae(_e(e)),toString:()=>e.toString()})),{add:ge,subtract:ve,multiply:ye,divide:be,negate:_e});function Ee(e){return function(e){return e.replace(/[!-,/:-@[-^`{-~]/g,"\\$&")}(function(e){if(e.includes("\\."))return e;const t=!Number.isInteger(parseFloat(e.toString()));return t?e.replace(".","\\."):e}(function(e,t="-"){return e.replace(/\s+/g,t)}(e.toString())))}function we(e,t){return`var(${e}${t?`, ${t}`:""})`}function xe(e,t=""){return Ee(`--${function(e,t=""){return[t,e].filter(Boolean).join("-")}(e,t)}`)}function ke(e,t,n){const r=xe(e,n);return{variable:r,reference:we(r,t)}}function Ce(e){const t=null==e?0:e.length;return t?e[t-1]:void 0}function Se(e){if(null==e)return e;const{unitless:t}=function(e){const t=parseFloat(e.toString()),n=e.toString().replace(String(t),"");return{unitless:!n,value:t,unit:n}}(e);return t||"number"==typeof e?`${e}px`:e}var Me=(e,t)=>parseInt(e[1],10)>parseInt(t[1],10)?1:-1,Te=e=>Object.fromEntries(Object.entries(e).sort(Me));function Oe(e){const t=Te(e);return Object.assign(Object.values(t),t)}function De(e){var t;if(!e)return e;e=null!=(t=Se(e))?t:e;return"number"==typeof e?`${e+-.02}`:e.replace(/(\d+\.?\d*)/u,(e=>`${parseFloat(e)+-.02}`))}function Le(e,t){const n=["@media screen"];return e&&n.push("and",`(min-width: ${Se(e)})`),t&&n.push("and",`(max-width: ${Se(t)})`),n.join(" ")}function Pe(e){var t;if(!e)return null;e.base=null!=(t=e.base)?t:"0px";const n=Oe(e),r=Object.entries(e).sort(Me).map((([e,t],n,r)=>{var o;let[,i]=null!=(o=r[n+1])?o:[];return i=parseFloat(i)>0?De(i):void 0,{_minW:De(t),breakpoint:e,minW:t,maxW:i,maxWQuery:Le(null,i),minWQuery:Le(t),minMaxQuery:Le(t,i)}})),o=function(e){const t=Object.keys(Te(e));return new Set(t)}(e),i=Array.from(o.values());return{keys:o,normalized:n,isResponsive(e){const t=Object.keys(e);return t.length>0&&t.every((e=>o.has(e)))},asObject:Te(e),asArray:Oe(e),details:r,get:e=>r.find((t=>t.breakpoint===e)),media:[null,...n.map((e=>Le(e))).slice(1)],toArrayValue(e){if(!v(e))throw new Error("toArrayValue: value must be an object");const t=i.map((t=>{var n;return null!=(n=e[t])?n:null}));for(;null===Ce(t);)t.pop();return t},toObjectValue(e){if(!Array.isArray(e))throw new Error("toObjectValue: value must be an array");return e.reduce(((e,t,n)=>{const r=i[n];return null!=r&&null!=t&&(e[r]=t),e}),{})}}}var Ie=(e,t)=>`${e}:hover ${t}, ${e}[data-hover] ${t}`,Be=(e,t)=>`${e}:focus ${t}, ${e}[data-focus] ${t}`,Re=(e,t)=>`${e}:focus-visible ${t}`,Ne=(e,t)=>`${e}:focus-within ${t}`,Fe=(e,t)=>`${e}:active ${t}, ${e}[data-active] ${t}`,je=(e,t)=>`${e}:disabled ${t}, ${e}[data-disabled] ${t}`,Ye=(e,t)=>`${e}:invalid ${t}, ${e}[data-invalid] ${t}`,$e=(e,t)=>`${e}:checked ${t}, ${e}[data-checked] ${t}`,He=(e,t)=>`${e}:placeholder-shown ${t}`,Ue=e=>We((t=>e(t,"&")),"[role=group]","[data-group]",".group"),ze=e=>We((t=>e(t,"~ &")),"[data-peer]",".peer"),We=(e,...t)=>t.map(e).join(", "),Ve={_hover:"&:hover, &[data-hover]",_active:"&:active, &[data-active]",_focus:"&:focus, &[data-focus]",_highlighted:"&[data-highlighted]",_focusWithin:"&:focus-within",_focusVisible:"&:focus-visible, &[data-focus-visible]",_disabled:"&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",_readOnly:"&[aria-readonly=true], &[readonly], &[data-readonly]",_before:"&::before",_after:"&::after",_empty:"&:empty",_expanded:"&[aria-expanded=true], &[data-expanded]",_checked:"&[aria-checked=true], &[data-checked]",_grabbed:"&[aria-grabbed=true], &[data-grabbed]",_pressed:"&[aria-pressed=true], &[data-pressed]",_invalid:"&[aria-invalid=true], &[data-invalid]",_valid:"&[data-valid], &[data-state=valid]",_loading:"&[data-loading], &[aria-busy=true]",_selected:"&[aria-selected=true], &[data-selected]",_hidden:"&[hidden], &[data-hidden]",_autofill:"&:-webkit-autofill",_even:"&:nth-of-type(even)",_odd:"&:nth-of-type(odd)",_first:"&:first-of-type",_firstLetter:"&::first-letter",_last:"&:last-of-type",_notFirst:"&:not(:first-of-type)",_notLast:"&:not(:last-of-type)",_visited:"&:visited",_activeLink:"&[aria-current=page]",_activeStep:"&[aria-current=step]",_indeterminate:"&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",_groupHover:Ue(Ie),_peerHover:ze(Ie),_groupFocus:Ue(Be),_peerFocus:ze(Be),_groupFocusVisible:Ue(Re),_peerFocusVisible:ze(Re),_groupActive:Ue(Fe),_peerActive:ze(Fe),_groupDisabled:Ue(je),_peerDisabled:ze(je),_groupInvalid:Ue(Ye),_peerInvalid:ze(Ye),_groupChecked:Ue($e),_peerChecked:ze($e),_groupFocusWithin:Ue(Ne),_peerFocusWithin:ze(Ne),_peerPlaceholderShown:ze(He),_placeholder:"&::placeholder",_placeholderShown:"&:placeholder-shown",_fullScreen:"&:fullscreen",_selection:"&::selection",_rtl:"[dir=rtl] &, &[dir=rtl]",_ltr:"[dir=ltr] &, &[dir=ltr]",_mediaDark:"@media (prefers-color-scheme: dark)",_mediaReduceMotion:"@media (prefers-reduced-motion: reduce)",_dark:".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",_light:".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",_horizontal:"&[data-orientation=horizontal]",_vertical:"&[data-orientation=vertical]"},Ge=Object.keys(Ve);function Qe(e,t){return ke(String(e).replace(/\./g,"-"),void 0,t)}function qe(e,t,n={}){const{stop:r,getKey:o}=n;return function e(n,i=[]){var a;if(function(e){return"object"==typeof e&&null!=e&&!Array.isArray(e)}(n)||Array.isArray(n)){const s={};for(const[l,c]of Object.entries(n)){const u=null!=(a=null==o?void 0:o(l))?a:l,d=[...i,u];if(null==r?void 0:r(n,d))return t(n,i);s[u]=e(c,d)}return s}return t(n,i)}(e)}var Ke=["colors","borders","borderWidths","borderStyles","fonts","fontSizes","fontWeights","gradients","letterSpacings","lineHeights","radii","space","shadows","sizes","zIndices","transition","blur","breakpoints"];var Ze=e=>Ge.includes(e)||"default"===e;function Je(e){var t;const n=function(e){const{__cssMap:t,__cssVars:n,__breakpoints:r,...o}=e;return o}(e),r=function(e){return function(e,t){const n={};for(const r of t)r in e&&(n[r]=e[r]);return n}(e,Ke)}(n),o=function(e){return e.semanticTokens}(n),i=function({tokens:e,semanticTokens:t}){const n={};return qe(e,((e,t)=>{null!=e&&(n[t.join(".")]={isSemantic:!1,value:e})})),qe(t,((e,t)=>{null!=e&&(n[t.join(".")]={isSemantic:!0,value:e})}),{stop:e=>Object.keys(e).every(Ze)}),n}({tokens:r,semanticTokens:o}),a=null==(t=n.config)?void 0:t.cssVarPrefix,{cssMap:s,cssVars:l}=function(e,t){let n={};const r={};for(const[o,i]of Object.entries(e)){const{isSemantic:a,value:s}=i,{variable:l,reference:c}=Qe(o,null==t?void 0:t.cssVarPrefix);if(!a){if(o.startsWith("space")){const e=o.split("."),[t,...n]=e,i=`${t}.-${n.join(".")}`,a=Ae.negate(s),u=Ae.negate(c);r[i]={value:a,var:l,varRef:u}}n[l]=s,r[o]={value:s,var:l,varRef:c};continue}const u=n=>{const r=[String(o).split(".")[0],n].join(".");if(!e[r])return n;const{reference:i}=Qe(r,null==t?void 0:t.cssVarPrefix);return i},d=v(s)?s:{default:s};n=C()(n,Object.entries(d).reduce(((e,[t,n])=>{var r,o;if(!n)return e;const i=u(`${n}`);return"default"===t?(e[l]=i,e):(e[null!=(o=null==(r=Ve)?void 0:r[t])?o:t]={[l]:i},e)}),{})),r[o]={value:c,var:l,varRef:c}}return{cssVars:n,cssMap:r}}(i,{cssVarPrefix:a});return Object.assign(n,{__cssVars:{"--chakra-ring-inset":"var(--chakra-empty,/*!*/ /*!*/)","--chakra-ring-offset-width":"0px","--chakra-ring-offset-color":"#fff","--chakra-ring-color":"rgba(66, 153, 225, 0.6)","--chakra-ring-offset-shadow":"0 0 #0000","--chakra-ring-shadow":"0 0 #0000","--chakra-space-x-reverse":"0","--chakra-space-y-reverse":"0",...l},__cssMap:s,__breakpoints:Pe(n.breakpoints)}),n}var Xe=C()({},W,V,G,K,X,q,se,J,Z,ie,ae,Q,le,fe,pe,ce,ue,ee,de),et=Object.assign({},le,X,K,Z,ae),tt=Object.keys(et),nt=[...Object.keys(Xe),...Ge],rt={...Xe,...Ve},ot=e=>e in rt;var it=(e,t)=>e.startsWith("--")&&"string"==typeof t&&!function(e){return/^var\(--.+\)$/.test(e)}(t),at=(e,t)=>{var n,r;if(null==t)return t;const o=t=>{var n,r;return null==(r=null==(n=e.__cssMap)?void 0:n[t])?void 0:r.varRef},i=e=>{var t;return null!=(t=o(e))?t:e},[a,s]=function(e){const t=[];let n="",r=!1;for(let o=0;o<e.length;o++){const i=e[o];"("===i?(r=!0,n+=i):")"===i?(r=!1,n+=i):","!==i||r?n+=i:(t.push(n),n="")}return n=n.trim(),n&&t.push(n),t}(t);return t=null!=(r=null!=(n=o(a))?n:i(s))?r:i(t)};function st(e){const{configs:t={},pseudos:n={},theme:r}=e,o=(e,i=!1)=>{var a,s,l;const c=b(e,r),u=(e=>t=>{if(!t.__breakpoints)return e;const{isResponsive:n,toArrayValue:r,media:o}=t.__breakpoints,i={};for(const a in e){let s=b(e[a],t);if(null==s)continue;if(s=v(s)&&n(s)?r(s):s,!Array.isArray(s)){i[a]=s;continue}const l=s.slice(0,o.length).length;for(let e=0;e<l;e+=1){const t=null==o?void 0:o[e];t?(i[t]=i[t]||{},null!=s[e]&&(i[t][a]=s[e])):i[a]=s[e]}}return i})(c)(r);let d={};for(let e in u){let p=b(u[e],r);e in n&&(e=n[e]),it(e,p)&&(p=at(r,p));let f=t[e];if(!0===f&&(f={property:e}),v(p)){d[e]=null!=(a=d[e])?a:{},d[e]=C()({},d[e],o(p,!0));continue}let h=null!=(l=null==(s=null==f?void 0:f.transform)?void 0:s.call(f,p,r,c))?l:p;h=(null==f?void 0:f.processResult)?o(h,!0):h;const m=b(null==f?void 0:f.property,r);if(!i&&(null==f?void 0:f.static)){const e=b(f.static,r);d=C()({},d,e)}if(m&&Array.isArray(m))for(const e of m)d[e]=h;else m?"&"===m&&v(h)?d=C()({},d,h):d[m]=h:v(h)?d=C()({},d,h):d[e]=h}return d};return o}var lt=e=>t=>st({theme:t,pseudos:Ve,configs:Xe})(e);function ct(e){return{definePartsStyle:e=>e,defineMultiStyleConfig:t=>({parts:e,...t})}}function ut(e,t){for(let n=t+1;n<e.length;n++)if(null!=e[n])return n;return-1}function dt(e){const t=e.__breakpoints;return function(e,n,r,o){var i,a;if(!t)return;const s={},l=function(e,t){return Array.isArray(e)?e:v(e)?t(e):null!=e?[e]:void 0}(r,t.toArrayValue);if(!l)return s;const c=l.length,u=1===c,d=!!e.parts;for(let r=0;r<c;r++){const c=t.details[r],p=t.details[ut(l,r)],f=Le(c.minW,null==p?void 0:p._minW),h=b(null==(i=e[n])?void 0:i[l[r]],o);h&&(d?null==(a=e.parts)||a.forEach((e=>{C()(s,{[e]:u?h[e]:{[f]:h[e]}})})):d?s[f]=h:u?C()(s,h):s[f]=h)}return s}}function pt(e){return function(e,t=[]){const n=Object.assign({},e);for(const e of t)e in n&&delete n[e];return n}(e,["styleConfig","size","variant","colorScheme"])}var ft=new Set([...nt,"textStyle","layerStyle","apply","noOfLines","focusBorderColor","errorBorderColor","as","__css","css","sx"]),ht=new Set(["htmlWidth","htmlHeight","htmlSize","htmlTranslate"]);function mt(e){return ht.has(e)||!ft.has(e)}var gt=(0,i.createContext)({});function vt(){const e=(0,i.useContext)(gt);if(void 0===e)throw new Error("useColorMode must be used within a ColorModeProvider");return e}gt.displayName="ColorModeContext";var yt=(e=>{const t=new WeakMap;return(n,r,o,i)=>{if(void 0===n)return e(n,r,o);t.has(n)||t.set(n,new Map);const a=t.get(n);if(a.has(r))return a.get(r);const s=e(n,r,o,i);return a.set(r,s),s}})((function(e,t,n,r){const o="string"==typeof t?t.split("."):[t];for(r=0;r<o.length&&e;r+=1)e=e[o[r]];return void 0===e?n:e}));function bt(e,t){const n={};return Object.keys(e).forEach((r=>{const o=e[r];t(o,r,e)&&(n[r]=o)})),n}var _t=e=>bt(e,(e=>null!=e));function At(e,...t){return"function"==typeof e?e(...t):e}function Et(...e){return function(t){e.some((e=>(null==e||e(t),null==t?void 0:t.defaultPrevented)))}}function wt(e){var t=Object.create(null);return function(n){return void 0===t[n]&&(t[n]=e(n)),t[n]}}var xt=/^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,kt=wt((function(e){return xt.test(e)||111===e.charCodeAt(0)&&110===e.charCodeAt(1)&&e.charCodeAt(2)<91}));var Ct=function(){function e(e){var t=this;this._insertTag=function(e){var n;n=0===t.tags.length?t.insertionPoint?t.insertionPoint.nextSibling:t.prepend?t.container.firstChild:t.before:t.tags[t.tags.length-1].nextSibling,t.container.insertBefore(e,n),t.tags.push(e)},this.isSpeedy=void 0===e.speedy||e.speedy,this.tags=[],this.ctr=0,this.nonce=e.nonce,this.key=e.key,this.container=e.container,this.prepend=e.prepend,this.insertionPoint=e.insertionPoint,this.before=null}var t=e.prototype;return t.hydrate=function(e){e.forEach(this._insertTag)},t.insert=function(e){this.ctr%(this.isSpeedy?65e3:1)==0&&this._insertTag(function(e){var t=document.createElement("style");return t.setAttribute("data-emotion",e.key),void 0!==e.nonce&&t.setAttribute("nonce",e.nonce),t.appendChild(document.createTextNode("")),t.setAttribute("data-s",""),t}(this));var t=this.tags[this.tags.length-1];if(this.isSpeedy){var n=function(e){if(e.sheet)return e.sheet;for(var t=0;t<document.styleSheets.length;t++)if(document.styleSheets[t].ownerNode===e)return document.styleSheets[t]}(t);try{n.insertRule(e,n.cssRules.length)}catch(e){0}}else t.appendChild(document.createTextNode(e));this.ctr++},t.flush=function(){this.tags.forEach((function(e){return e.parentNode&&e.parentNode.removeChild(e)})),this.tags=[],this.ctr=0},e}(),St=Math.abs,Mt=String.fromCharCode,Tt=Object.assign;function Ot(e){return e.trim()}function Dt(e,t,n){return e.replace(t,n)}function Lt(e,t){return e.indexOf(t)}function Pt(e,t){return 0|e.charCodeAt(t)}function It(e,t,n){return e.slice(t,n)}function Bt(e){return e.length}function Rt(e){return e.length}function Nt(e,t){return t.push(e),e}var Ft=1,jt=1,Yt=0,$t=0,Ht=0,Ut="";function zt(e,t,n,r,o,i,a){return{value:e,root:t,parent:n,type:r,props:o,children:i,line:Ft,column:jt,length:a,return:""}}function Wt(e,t){return Tt(zt("",null,null,"",null,null,0),e,{length:-e.length},t)}function Vt(){return Ht=$t>0?Pt(Ut,--$t):0,jt--,10===Ht&&(jt=1,Ft--),Ht}function Gt(){return Ht=$t<Yt?Pt(Ut,$t++):0,jt++,10===Ht&&(jt=1,Ft++),Ht}function Qt(){return Pt(Ut,$t)}function qt(){return $t}function Kt(e,t){return It(Ut,e,t)}function Zt(e){switch(e){case 0:case 9:case 10:case 13:case 32:return 5;case 33:case 43:case 44:case 47:case 62:case 64:case 126:case 59:case 123:case 125:return 4;case 58:return 3;case 34:case 39:case 40:case 91:return 2;case 41:case 93:return 1}return 0}function Jt(e){return Ft=jt=1,Yt=Bt(Ut=e),$t=0,[]}function Xt(e){return Ut="",e}function en(e){return Ot(Kt($t-1,rn(91===e?e+2:40===e?e+1:e)))}function tn(e){for(;(Ht=Qt())&&Ht<33;)Gt();return Zt(e)>2||Zt(Ht)>3?"":" "}function nn(e,t){for(;--t&&Gt()&&!(Ht<48||Ht>102||Ht>57&&Ht<65||Ht>70&&Ht<97););return Kt(e,qt()+(t<6&&32==Qt()&&32==Gt()))}function rn(e){for(;Gt();)switch(Ht){case e:return $t;case 34:case 39:34!==e&&39!==e&&rn(Ht);break;case 40:41===e&&rn(e);break;case 92:Gt()}return $t}function on(e,t){for(;Gt()&&e+Ht!==57&&(e+Ht!==84||47!==Qt()););return"/*"+Kt(t,$t-1)+"*"+Mt(47===e?e:Gt())}function an(e){for(;!Zt(Qt());)Gt();return Kt(e,$t)}var sn="-ms-",ln="-moz-",cn="-webkit-",un="comm",dn="rule",pn="decl",fn="@keyframes";function hn(e,t){for(var n="",r=Rt(e),o=0;o<r;o++)n+=t(e[o],o,e,t)||"";return n}function mn(e,t,n,r){switch(e.type){case"@layer":if(e.children.length)break;case"@import":case pn:return e.return=e.return||e.value;case un:return"";case fn:return e.return=e.value+"{"+hn(e.children,r)+"}";case dn:e.value=e.props.join(",")}return Bt(n=hn(e.children,r))?e.return=e.value+"{"+n+"}":""}function gn(e){return Xt(vn("",null,null,null,[""],e=Jt(e),0,[0],e))}function vn(e,t,n,r,o,i,a,s,l){for(var c=0,u=0,d=a,p=0,f=0,h=0,m=1,g=1,v=1,y=0,b="",_=o,A=i,E=r,w=b;g;)switch(h=y,y=Gt()){case 40:if(108!=h&&58==Pt(w,d-1)){-1!=Lt(w+=Dt(en(y),"&","&\f"),"&\f")&&(v=-1);break}case 34:case 39:case 91:w+=en(y);break;case 9:case 10:case 13:case 32:w+=tn(h);break;case 92:w+=nn(qt()-1,7);continue;case 47:switch(Qt()){case 42:case 47:Nt(bn(on(Gt(),qt()),t,n),l);break;default:w+="/"}break;case 123*m:s[c++]=Bt(w)*v;case 125*m:case 59:case 0:switch(y){case 0:case 125:g=0;case 59+u:-1==v&&(w=Dt(w,/\f/g,"")),f>0&&Bt(w)-d&&Nt(f>32?_n(w+";",r,n,d-1):_n(Dt(w," ","")+";",r,n,d-2),l);break;case 59:w+=";";default:if(Nt(E=yn(w,t,n,c,u,o,s,b,_=[],A=[],d),i),123===y)if(0===u)vn(w,t,E,E,_,i,d,s,A);else switch(99===p&&110===Pt(w,3)?100:p){case 100:case 108:case 109:case 115:vn(e,E,E,r&&Nt(yn(e,E,E,0,0,o,s,b,o,_=[],d),A),o,A,d,s,r?_:A);break;default:vn(w,E,E,E,[""],A,0,s,A)}}c=u=f=0,m=v=1,b=w="",d=a;break;case 58:d=1+Bt(w),f=h;default:if(m<1)if(123==y)--m;else if(125==y&&0==m++&&125==Vt())continue;switch(w+=Mt(y),y*m){case 38:v=u>0?1:(w+="\f",-1);break;case 44:s[c++]=(Bt(w)-1)*v,v=1;break;case 64:45===Qt()&&(w+=en(Gt())),p=Qt(),u=d=Bt(b=w+=an(qt())),y++;break;case 45:45===h&&2==Bt(w)&&(m=0)}}return i}function yn(e,t,n,r,o,i,a,s,l,c,u){for(var d=o-1,p=0===o?i:[""],f=Rt(p),h=0,m=0,g=0;h<r;++h)for(var v=0,y=It(e,d+1,d=St(m=a[h])),b=e;v<f;++v)(b=Ot(m>0?p[v]+" "+y:Dt(y,/&\f/g,p[v])))&&(l[g++]=b);return zt(e,t,n,0===o?dn:s,l,c,u)}function bn(e,t,n){return zt(e,t,n,un,Mt(Ht),It(e,2,-2),0)}function _n(e,t,n,r){return zt(e,t,n,pn,It(e,0,r),It(e,r+1,-1),r)}var An=function(e,t,n){for(var r=0,o=0;r=o,o=Qt(),38===r&&12===o&&(t[n]=1),!Zt(o);)Gt();return Kt(e,$t)},En=function(e,t){return Xt(function(e,t){var n=-1,r=44;do{switch(Zt(r)){case 0:38===r&&12===Qt()&&(t[n]=1),e[n]+=An($t-1,t,n);break;case 2:e[n]+=en(r);break;case 4:if(44===r){e[++n]=58===Qt()?"&\f":"",t[n]=e[n].length;break}default:e[n]+=Mt(r)}}while(r=Gt());return e}(Jt(e),t))},wn=new WeakMap,xn=function(e){if("rule"===e.type&&e.parent&&!(e.length<1)){for(var t=e.value,n=e.parent,r=e.column===n.column&&e.line===n.line;"rule"!==n.type;)if(!(n=n.parent))return;if((1!==e.props.length||58===t.charCodeAt(0)||wn.get(n))&&!r){wn.set(e,!0);for(var o=[],i=En(t,o),a=n.props,s=0,l=0;s<i.length;s++)for(var c=0;c<a.length;c++,l++)e.props[l]=o[s]?i[s].replace(/&\f/g,a[c]):a[c]+" "+i[s]}}},kn=function(e){if("decl"===e.type){var t=e.value;108===t.charCodeAt(0)&&98===t.charCodeAt(2)&&(e.return="",e.value="")}};function Cn(e,t){switch(function(e,t){return 45^Pt(e,0)?(((t<<2^Pt(e,0))<<2^Pt(e,1))<<2^Pt(e,2))<<2^Pt(e,3):0}(e,t)){case 5103:return cn+"print-"+e+e;case 5737:case 4201:case 3177:case 3433:case 1641:case 4457:case 2921:case 5572:case 6356:case 5844:case 3191:case 6645:case 3005:case 6391:case 5879:case 5623:case 6135:case 4599:case 4855:case 4215:case 6389:case 5109:case 5365:case 5621:case 3829:return cn+e+e;case 5349:case 4246:case 4810:case 6968:case 2756:return cn+e+ln+e+sn+e+e;case 6828:case 4268:return cn+e+sn+e+e;case 6165:return cn+e+sn+"flex-"+e+e;case 5187:return cn+e+Dt(e,/(\w+).+(:[^]+)/,cn+"box-$1$2"+sn+"flex-$1$2")+e;case 5443:return cn+e+sn+"flex-item-"+Dt(e,/flex-|-self/,"")+e;case 4675:return cn+e+sn+"flex-line-pack"+Dt(e,/align-content|flex-|-self/,"")+e;case 5548:return cn+e+sn+Dt(e,"shrink","negative")+e;case 5292:return cn+e+sn+Dt(e,"basis","preferred-size")+e;case 6060:return cn+"box-"+Dt(e,"-grow","")+cn+e+sn+Dt(e,"grow","positive")+e;case 4554:return cn+Dt(e,/([^-])(transform)/g,"$1"+cn+"$2")+e;case 6187:return Dt(Dt(Dt(e,/(zoom-|grab)/,cn+"$1"),/(image-set)/,cn+"$1"),e,"")+e;case 5495:case 3959:return Dt(e,/(image-set\([^]*)/,cn+"$1$`$1");case 4968:return Dt(Dt(e,/(.+:)(flex-)?(.*)/,cn+"box-pack:$3"+sn+"flex-pack:$3"),/s.+-b[^;]+/,"justify")+cn+e+e;case 4095:case 3583:case 4068:case 2532:return Dt(e,/(.+)-inline(.+)/,cn+"$1$2")+e;case 8116:case 7059:case 5753:case 5535:case 5445:case 5701:case 4933:case 4677:case 5533:case 5789:case 5021:case 4765:if(Bt(e)-1-t>6)switch(Pt(e,t+1)){case 109:if(45!==Pt(e,t+4))break;case 102:return Dt(e,/(.+:)(.+)-([^]+)/,"$1"+cn+"$2-$3$1"+ln+(108==Pt(e,t+3)?"$3":"$2-$3"))+e;case 115:return~Lt(e,"stretch")?Cn(Dt(e,"stretch","fill-available"),t)+e:e}break;case 4949:if(115!==Pt(e,t+1))break;case 6444:switch(Pt(e,Bt(e)-3-(~Lt(e,"!important")&&10))){case 107:return Dt(e,":",":"+cn)+e;case 101:return Dt(e,/(.+:)([^;!]+)(;|!.+)?/,"$1"+cn+(45===Pt(e,14)?"inline-":"")+"box$3$1"+cn+"$2$3$1"+sn+"$2box$3")+e}break;case 5936:switch(Pt(e,t+11)){case 114:return cn+e+sn+Dt(e,/[svh]\w+-[tblr]{2}/,"tb")+e;case 108:return cn+e+sn+Dt(e,/[svh]\w+-[tblr]{2}/,"tb-rl")+e;case 45:return cn+e+sn+Dt(e,/[svh]\w+-[tblr]{2}/,"lr")+e}return cn+e+sn+e+e}return e}var Sn=[function(e,t,n,r){if(e.length>-1&&!e.return)switch(e.type){case pn:e.return=Cn(e.value,e.length);break;case fn:return hn([Wt(e,{value:Dt(e.value,"@","@"+cn)})],r);case dn:if(e.length)return function(e,t){return e.map(t).join("")}(e.props,(function(t){switch(function(e,t){return(e=t.exec(e))?e[0]:e}(t,/(::plac\w+|:read-\w+)/)){case":read-only":case":read-write":return hn([Wt(e,{props:[Dt(t,/:(read-\w+)/,":-moz-$1")]})],r);case"::placeholder":return hn([Wt(e,{props:[Dt(t,/:(plac\w+)/,":"+cn+"input-$1")]}),Wt(e,{props:[Dt(t,/:(plac\w+)/,":-moz-$1")]}),Wt(e,{props:[Dt(t,/:(plac\w+)/,sn+"input-$1")]})],r)}return""}))}}],Mn=function(e){var t=e.key;if("css"===t){var n=document.querySelectorAll("style[data-emotion]:not([data-s])");Array.prototype.forEach.call(n,(function(e){-1!==e.getAttribute("data-emotion").indexOf(" ")&&(document.head.appendChild(e),e.setAttribute("data-s",""))}))}var r=e.stylisPlugins||Sn;var o,i,a={},s=[];o=e.container||document.head,Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="'+t+' "]'),(function(e){for(var t=e.getAttribute("data-emotion").split(" "),n=1;n<t.length;n++)a[t[n]]=!0;s.push(e)}));var l,c,u,d,p=[mn,(d=function(e){l.insert(e)},function(e){e.root||(e=e.return)&&d(e)})],f=(c=[xn,kn].concat(r,p),u=Rt(c),function(e,t,n,r){for(var o="",i=0;i<u;i++)o+=c[i](e,t,n,r)||"";return o});i=function(e,t,n,r){l=n,function(e){hn(gn(e),f)}(e?e+"{"+t.styles+"}":t.styles),r&&(h.inserted[t.name]=!0)};var h={key:t,sheet:new Ct({key:t,container:o,nonce:e.nonce,speedy:e.speedy,prepend:e.prepend,insertionPoint:e.insertionPoint}),nonce:e.nonce,inserted:a,registered:{},insert:i};return h.sheet.hydrate(s),h},Tn=function(e){var t=new WeakMap;return function(n){if(t.has(n))return t.get(n);var r=e(n);return t.set(n,r),r}};function On(e,t,n){var r="";return n.split(" ").forEach((function(n){void 0!==e[n]?t.push(e[n]+";"):n&&(r+=n+" ")})),r}var Dn=function(e,t,n){var r=e.key+"-"+t.name;!1===n&&void 0===e.registered[r]&&(e.registered[r]=t.styles)},Ln=function(e,t,n){Dn(e,t,n);var r=e.key+"-"+t.name;if(void 0===e.inserted[t.name]){var o=t;do{e.insert(t===o?"."+r:"",o,e.sheet,!0),o=o.next}while(void 0!==o)}};var Pn={animationIterationCount:1,aspectRatio:1,borderImageOutset:1,borderImageSlice:1,borderImageWidth:1,boxFlex:1,boxFlexGroup:1,boxOrdinalGroup:1,columnCount:1,columns:1,flex:1,flexGrow:1,flexPositive:1,flexShrink:1,flexNegative:1,flexOrder:1,gridRow:1,gridRowEnd:1,gridRowSpan:1,gridRowStart:1,gridColumn:1,gridColumnEnd:1,gridColumnSpan:1,gridColumnStart:1,msGridRow:1,msGridRowSpan:1,msGridColumn:1,msGridColumnSpan:1,fontWeight:1,lineHeight:1,opacity:1,order:1,orphans:1,scale:1,tabSize:1,widows:1,zIndex:1,zoom:1,WebkitLineClamp:1,fillOpacity:1,floodOpacity:1,stopOpacity:1,strokeDasharray:1,strokeDashoffset:1,strokeMiterlimit:1,strokeOpacity:1,strokeWidth:1};function In(e){var t=Object.create(null);return function(n){return void 0===t[n]&&(t[n]=e(n)),t[n]}}var Bn=!1,Rn=/[A-Z]|^ms/g,Nn=/_EMO_([^_]+?)_([^]*?)_EMO_/g,Fn=function(e){return 45===e.charCodeAt(1)},jn=function(e){return null!=e&&"boolean"!=typeof e},Yn=In((function(e){return Fn(e)?e:e.replace(Rn,"-$&").toLowerCase()})),$n=function(e,t){switch(e){case"animation":case"animationName":if("string"==typeof t)return t.replace(Nn,(function(e,t,n){return zn={name:t,styles:n,next:zn},t}))}return 1===Pn[e]||Fn(e)||"number"!=typeof t||0===t?t:t+"px"},Hn="Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";function Un(e,t,n){if(null==n)return"";var r=n;if(void 0!==r.__emotion_styles)return r;switch(typeof n){case"boolean":return"";case"object":var o=n;if(1===o.anim)return zn={name:o.name,styles:o.styles,next:zn},o.name;var i=n;if(void 0!==i.styles){var a=i.next;if(void 0!==a)for(;void 0!==a;)zn={name:a.name,styles:a.styles,next:zn},a=a.next;return i.styles+";"}return function(e,t,n){var r="";if(Array.isArray(n))for(var o=0;o<n.length;o++)r+=Un(e,t,n[o])+";";else for(var i in n){var a=n[i];if("object"!=typeof a){var s=a;null!=t&&void 0!==t[s]?r+=i+"{"+t[s]+"}":jn(s)&&(r+=Yn(i)+":"+$n(i,s)+";")}else{if("NO_COMPONENT_SELECTOR"===i&&Bn)throw new Error(Hn);if(!Array.isArray(a)||"string"!=typeof a[0]||null!=t&&void 0!==t[a[0]]){var l=Un(e,t,a);switch(i){case"animation":case"animationName":r+=Yn(i)+":"+l+";";break;default:r+=i+"{"+l+"}"}}else for(var c=0;c<a.length;c++)jn(a[c])&&(r+=Yn(i)+":"+$n(i,a[c])+";")}}return r}(e,t,n);case"function":if(void 0!==e){var s=zn,l=n(e);return zn=s,Un(e,t,l)}}var c=n;if(null==t)return c;var u=t[c];return void 0!==u?u:c}var zn,Wn=/label:\s*([^\s;{]+)\s*(;|$)/g;function Vn(e,t,n){if(1===e.length&&"object"==typeof e[0]&&null!==e[0]&&void 0!==e[0].styles)return e[0];var r=!0,o="";zn=void 0;var i=e[0];null==i||void 0===i.raw?(r=!1,o+=Un(n,t,i)):o+=i[0];for(var a=1;a<e.length;a++){if(o+=Un(n,t,e[a]),r)o+=i[a]}Wn.lastIndex=0;for(var s,l="";null!==(s=Wn.exec(o));)l+="-"+s[1];var c=function(e){for(var t,n=0,r=0,o=e.length;o>=4;++r,o-=4)t=1540483477*(65535&(t=255&e.charCodeAt(r)|(255&e.charCodeAt(++r))<<8|(255&e.charCodeAt(++r))<<16|(255&e.charCodeAt(++r))<<24))+(59797*(t>>>16)<<16),n=1540483477*(65535&(t^=t>>>24))+(59797*(t>>>16)<<16)^1540483477*(65535&n)+(59797*(n>>>16)<<16);switch(o){case 3:n^=(255&e.charCodeAt(r+2))<<16;case 2:n^=(255&e.charCodeAt(r+1))<<8;case 1:n=1540483477*(65535&(n^=255&e.charCodeAt(r)))+(59797*(n>>>16)<<16)}return(((n=1540483477*(65535&(n^=n>>>13))+(59797*(n>>>16)<<16))^n>>>15)>>>0).toString(36)}(o)+l;return{name:c,styles:o,next:zn}}var Gn=!!a.useInsertionEffect&&a.useInsertionEffect,Qn=Gn||function(e){return e()},qn=Gn||i.useLayoutEffect,Kn={}.hasOwnProperty,Zn=i.createContext("undefined"!=typeof HTMLElement?Mn({key:"css"}):null);Zn.Provider;var Jn=function(e){return(0,i.forwardRef)((function(t,n){var r=(0,i.useContext)(Zn);return e(t,r,n)}))};var Xn=i.createContext({});var er=Tn((function(e){return Tn((function(t){return function(e,t){return"function"==typeof t?t(e):n({},e,t)}(e,t)}))})),tr=function(e){var t=i.useContext(Xn);return e.theme!==t&&(t=er(t)(e.theme)),i.createElement(Xn.Provider,{value:t},e.children)};var nr="__EMOTION_TYPE_PLEASE_DO_NOT_USE__",rr=function(e){var t=e.cache,n=e.serialized,r=e.isStringTag;return Dn(t,n,r),Qn((function(){return Ln(t,n,r)})),null},or=Jn((function(e,t,n){var r=e.css;"string"==typeof r&&void 0!==t.registered[r]&&(r=t.registered[r]);var o=e[nr],a=[r],s="";"string"==typeof e.className?s=On(t.registered,a,e.className):null!=e.className&&(s=e.className+" ");var l=Vn(a,void 0,i.useContext(Xn));s+=t.key+"-"+l.name;var c={};for(var u in e)Kn.call(e,u)&&"css"!==u&&u!==nr&&(c[u]=e[u]);return c.ref=n,c.className=s,i.createElement(i.Fragment,null,i.createElement(rr,{cache:t,serialized:l,isStringTag:"string"==typeof o}),i.createElement(o,c))}));var ir,ar=or,sr=kt,lr=function(e){return"theme"!==e},cr=function(e){return"string"==typeof e&&e.charCodeAt(0)>96?sr:lr},ur=function(e,t,n){var r;if(t){var o=t.shouldForwardProp;r=e.__emotion_forwardProp&&o?function(t){return e.__emotion_forwardProp(t)&&o(t)}:o}return"function"!=typeof r&&n&&(r=e.__emotion_forwardProp),r},dr=function(e){var t=e.cache,n=e.serialized,r=e.isStringTag;return Dn(t,n,r),Qn((function(){return Ln(t,n,r)})),null},pr=function e(t,r){var o,a,s=t.__emotion_real===t,l=s&&t.__emotion_base||t;void 0!==r&&(o=r.label,a=r.target);var c=ur(t,r,s),u=c||cr(l),d=!u("as");return function(){var p=arguments,f=s&&void 0!==t.__emotion_styles?t.__emotion_styles.slice(0):[];if(void 0!==o&&f.push("label:"+o+";"),null==p[0]||void 0===p[0].raw)f.push.apply(f,p);else{0,f.push(p[0][0]);for(var h=p.length,m=1;m<h;m++)f.push(p[m],p[0][m])}var g=Jn((function(e,t,n){var r=d&&e.as||l,o="",s=[],p=e;if(null==e.theme){for(var h in p={},e)p[h]=e[h];p.theme=i.useContext(Xn)}"string"==typeof e.className?o=On(t.registered,s,e.className):null!=e.className&&(o=e.className+" ");var m=Vn(f.concat(s),t.registered,p);o+=t.key+"-"+m.name,void 0!==a&&(o+=" "+a);var g=d&&void 0===c?cr(r):u,v={};for(var y in e)d&&"as"===y||g(y)&&(v[y]=e[y]);return v.className=o,v.ref=n,i.createElement(i.Fragment,null,i.createElement(dr,{cache:t,serialized:m,isStringTag:"string"==typeof r}),i.createElement(r,v))}));return g.displayName=void 0!==o?o:"Styled("+("string"==typeof l?l:l.displayName||l.name||"Component")+")",g.defaultProps=t.defaultProps,g.__emotion_real=g,g.__emotion_base=l,g.__emotion_styles=f,g.__emotion_forwardProp=c,Object.defineProperty(g,"toString",{value:function(){return"."+a}}),g.withComponent=function(t,o){return e(t,n({},r,o,{shouldForwardProp:ur(g,o,!0)})).apply(void 0,f)},g}},fr=pr.bind();["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","tspan"].forEach((function(e){fr[e]=fr(e)}));var hr=null!=(ir=fr.default)?ir:fr,mr=({baseStyle:e})=>t=>{const{theme:n,css:r,__css:o,sx:i,...a}=t,s=bt(a,((e,t)=>ot(t))),l=function(e,...t){if(null==e)throw new TypeError("Cannot convert undefined or null to object");const n={...e};for(const e of t)if(null!=e)for(const t in e)Object.prototype.hasOwnProperty.call(e,t)&&(t in n&&delete n[t],n[t]=e[t]);return n}({},o,At(e,t),_t(s),i),c=lt(l)(t.theme);return r?[c,r]:c};function gr(e,t){const{baseStyle:n,...r}=null!=t?t:{};r.shouldForwardProp||(r.shouldForwardProp=mt);const o=mr({baseStyle:n}),a=hr(e,r)(o);return i.forwardRef((function(e,t){const{colorMode:n,forced:r}=vt();return i.createElement(a,{ref:t,"data-theme":r?n:void 0,...e})}))}var vr=function(){const e=new Map;return new Proxy(gr,{apply:(e,t,n)=>gr(...n),get:(t,n)=>(e.has(n)||e.set(n,gr(n)),e.get(n))})}();function yr(e){return(0,i.forwardRef)(e)}var br=o(64922),_r=vr("div");_r.displayName="Box";var Ar=yr((function(e,t){const{size:n,centerContent:r=!0,...o}=e,i=r?{display:"flex",alignItems:"center",justifyContent:"center"}:{};return(0,br.jsx)(_r,{ref:t,boxSize:n,__css:{...i,flexShrink:0,flexGrow:0},...o})}));Ar.displayName="Square";var Er=yr((function(e,t){const{size:n,...r}=e;return(0,br.jsx)(Ar,{size:n,ref:t,borderRadius:"9999px",...r})}));Er.displayName="Circle";var wr=yr((function(e,t){const{direction:n,align:r,justify:o,wrap:i,basis:a,grow:s,shrink:l,...c}=e,u={display:"flex",flexDirection:n,alignItems:r,justifyContent:o,flexWrap:i,flexBasis:a,flexGrow:s,flexShrink:l};return(0,br.jsx)(vr.div,{ref:t,__css:u,...c})}));function xr(e={}){const{name:t,strict:n=!0,hookName:r="useContext",providerName:o="Provider",errorMessage:a,defaultValue:s}=e,l=(0,i.createContext)(s);return l.displayName=t,[l.Provider,function e(){var t;const s=(0,i.useContext)(l);if(!s&&n){const n=new Error(null!=a?a:`${r} returned \`undefined\`. Seems you forgot to wrap component within ${o}`);throw n.name="ContextError",null==(t=Error.captureStackTrace)||t.call(Error,n,e),n}return s},l]}wr.displayName="Flex";var[kr,Cr]=xr({strict:!1,name:"ButtonGroupContext"});function Sr(e){const{children:t,className:n,...r}=e,o=(0,i.isValidElement)(t)?(0,i.cloneElement)(t,{"aria-hidden":!0,focusable:!1}):t,a=g("chakra-button__icon",n);return(0,br.jsx)(vr.span,{display:"inline-flex",alignSelf:"center",flexShrink:0,...r,className:a,children:o})}Sr.displayName="ButtonIcon";o(1880);var Mr=function(e,t){var n=arguments;if(null==t||!Kn.call(t,"css"))return i.createElement.apply(void 0,n);var r=n.length,o=new Array(r);o[0]=ar,o[1]=function(e,t){var n={};for(var r in t)Kn.call(t,r)&&(n[r]=t[r]);return n[nr]=e,n}(e,t);for(var a=2;a<r;a++)o[a]=n[a];return i.createElement.apply(null,o)},Tr=Jn((function(e,t){var n=Vn([e.styles],void 0,i.useContext(Xn)),r=i.useRef();return qn((function(){var e=t.key+"-global",o=new t.sheet.constructor({key:e,nonce:t.sheet.nonce,container:t.sheet.container,speedy:t.sheet.isSpeedy}),i=!1,a=document.querySelector('style[data-emotion="'+e+" "+n.name+'"]');return t.sheet.tags.length&&(o.before=t.sheet.tags[0]),null!==a&&(i=!0,a.setAttribute("data-emotion",e),o.hydrate([a])),r.current=[o,i],function(){o.flush()}}),[t]),qn((function(){var e=r.current,o=e[0];if(e[1])e[1]=!1;else{if(void 0!==n.next&&Ln(t,n.next,!0),o.tags.length){var i=o.tags[o.tags.length-1].nextElementSibling;o.before=i,o.flush()}t.insert("",n,o,!1)}}),[t,n.name]),null}));function Or(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return Vn(t)}var Dr=function(){var e=Or.apply(void 0,arguments),t="animation-"+e.name;return{name:t,styles:"@keyframes "+t+"{"+e.styles+"}",anim:1,toString:function(){return"_EMO_"+this.name+"_"+this.styles+"_EMO_"}}};function Lr(){const e=(0,i.useContext)(Xn);if(!e)throw Error("useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`");return e}function Pr(){return{...vt(),theme:Lr()}}function Ir(e,t,n){const r=Lr();return function(e,t,n){const r=Array.isArray(t)?t:[t],o=Array.isArray(n)?n:[n];return n=>{const i=o.filter(Boolean),a=r.map(((t,r)=>{var o,a;if("breakpoints"===e)return function(e,t,n){var r,o;if(null==t)return t;const i=t=>{var n,r;return null==(r=null==(n=e.__breakpoints)?void 0:n.asArray)?void 0:r[t]};return null!=(o=null!=(r=i(t))?r:i(n))?o:n}(n,t,null!=(o=i[r])?o:t);return function(e,t,n){var r,o;if(null==t)return t;const i=t=>{var n,r;return null==(r=null==(n=e.__cssMap)?void 0:n[t])?void 0:r.value};return null!=(o=null!=(r=i(t))?r:i(n))?o:n}(n,`${e}.${t}`,null!=(a=i[r])?a:t)}));return Array.isArray(t)?a:a[0]}}(e,t,n)(r)}var Br=o(32169),Rr=o.n(Br);function Nr(e,t={}){var n;const{styleConfig:r,...o}=t,{theme:a,colorMode:s}=Pr(),l=e?yt(a,`components.${e}`):void 0,c=r||l,u=C()({theme:a,colorMode:s},null!=(n=null==c?void 0:c.defaultProps)?n:{},_t(function(e,t){const n={};return Object.keys(e).forEach((r=>{t.includes(r)||(n[r]=e[r])})),n}(o,["children"]))),d=(0,i.useRef)({});if(c){const e=function(e){return t=>{var n;const{variant:r,size:o,theme:i}=t,a=dt(i);return C()({},b(null!=(n=e.baseStyle)?n:{},t),a(e,"sizes",o,t),a(e,"variants",r,t))}}(c),t=e(u);Rr()(d.current,t)||(d.current=t)}return d.current}function Fr(e,t={}){return Nr(e,t)}function jr(e,t={}){return Nr(e,t)}var Yr=Dr({"0%":{transform:"rotate(0deg)"},"100%":{transform:"rotate(360deg)"}}),$r=yr(((e,t)=>{const n=Fr("Spinner",e),{label:r="Loading...",thickness:o="2px",speed:i="0.45s",emptyColor:a="transparent",className:s,...l}=pt(e),c=g("chakra-spinner",s),u={display:"inline-block",borderColor:"currentColor",borderStyle:"solid",borderRadius:"99999px",borderWidth:o,borderBottomColor:a,borderLeftColor:a,animation:`${Yr} ${i} linear infinite`,...n};return(0,br.jsx)(vr.div,{ref:t,__css:u,className:c,...l,children:r&&(0,br.jsx)(vr.span,{srOnly:!0,children:r})})}));function Hr(e){const{label:t,placement:n,spacing:r="0.5rem",children:o=(0,br.jsx)($r,{color:"currentColor",width:"1em",height:"1em"}),className:a,__css:s,...l}=e,c=g("chakra-button__spinner",a),u="start"===n?"marginEnd":"marginStart",d=(0,i.useMemo)((()=>({display:"flex",alignItems:"center",position:t?"relative":"absolute",[u]:t?r:0,fontSize:"1em",lineHeight:"normal",...s})),[s,t,u,r]);return(0,br.jsx)(vr.div,{className:c,...l,__css:d,children:o})}function Ur(...e){return t=>{e.forEach((e=>{!function(e,t){if(null!=e)if("function"!=typeof e)try{e.current=t}catch(n){throw new Error(`Cannot assign value '${t}' to ref '${e}'`)}else e(t)}(e,t)}))}}function zr(...e){return(0,i.useMemo)((()=>Ur(...e)),e)}$r.displayName="Spinner",Hr.displayName="ButtonSpinner";var Wr=yr(((e,t)=>{const n=Cr(),r=Fr("Button",{...n,...e}),{isDisabled:o=(null==n?void 0:n.isDisabled),isLoading:a,isActive:s,children:l,leftIcon:c,rightIcon:u,loadingText:d,iconSpacing:p="0.5rem",type:f,spinner:h,spinnerPlacement:m="start",className:v,as:y,...b}=pt(e),_=(0,i.useMemo)((()=>{const e={...null==r?void 0:r._focus,zIndex:1};return{display:"inline-flex",appearance:"none",alignItems:"center",justifyContent:"center",userSelect:"none",position:"relative",whiteSpace:"nowrap",verticalAlign:"middle",outline:"none",...r,...!!n&&{_focus:e}}}),[r,n]),{ref:E,type:w}=function(e){const[t,n]=(0,i.useState)(!e),r=(0,i.useCallback)((e=>{e&&n("BUTTON"===e.tagName)}),[]);return{ref:r,type:t?"button":void 0}}(y),x={rightIcon:u,leftIcon:c,iconSpacing:p,children:l};return(0,br.jsxs)(vr.button,{ref:zr(t,E),as:y,type:null!=f?f:w,"data-active":A(s),"data-loading":A(a),__css:_,className:g("chakra-button",v),...b,disabled:o||a,children:[a&&"start"===m&&(0,br.jsx)(Hr,{className:"chakra-button__spinner--start",label:d,placement:"start",spacing:p,children:h}),a?d||(0,br.jsx)(vr.span,{opacity:0,children:(0,br.jsx)(Vr,{...x})}):(0,br.jsx)(Vr,{...x}),a&&"end"===m&&(0,br.jsx)(Hr,{className:"chakra-button__spinner--end",label:d,placement:"end",spacing:p,children:h})]})}));function Vr(e){const{leftIcon:t,rightIcon:n,children:r,iconSpacing:o}=e;return(0,br.jsxs)(br.Fragment,{children:[t&&(0,br.jsx)(Sr,{marginEnd:o,children:t}),r,n&&(0,br.jsx)(Sr,{marginStart:o,children:n})]})}Wr.displayName="Button";var Gr=yr(((e,t)=>{const{icon:n,children:r,isRound:o,"aria-label":a,...s}=e,l=n||r,c=(0,i.isValidElement)(l)?(0,i.cloneElement)(l,{"aria-hidden":!0,focusable:!1}):null;return(0,br.jsx)(Wr,{padding:"0",borderRadius:o?"full":void 0,ref:t,"aria-label":a,...s,children:c})}));function Qr(e){const t=Object.assign({},e);for(let e in t)void 0===t[e]&&delete t[e];return t}Gr.displayName="IconButton";var qr=yr((function(e,t){const n=Fr("Text",e),{className:r,align:o,decoration:i,casing:a,...s}=pt(e),l=Qr({textAlign:e.align,textDecoration:e.decoration,textTransform:e.casing});return(0,br.jsx)(vr.p,{ref:t,className:g("chakra-text",e.className),...l,...s,__css:n})}));qr.displayName="Text";var Kr=yr((function(e,t){const n=Fr("Link",e),{className:r,isExternal:o,...i}=pt(e);return(0,br.jsx)(vr.a,{target:o?"_blank":void 0,rel:o?"noopener":void 0,ref:t,className:g("chakra-link",r),...i,__css:n})}));Kr.displayName="Link";var Zr=o(22483),Jr=o(75826),Xr=o.n(Jr);function eo(){return eo=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},eo.apply(this,arguments)}function to(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}var no=(0,i.forwardRef)((function(e,t){var n=e.color,r=void 0===n?"currentColor":n,o=e.size,a=void 0===o?24:o,s=to(e,["color","size"]);return i.createElement("svg",eo({ref:t,xmlns:"http://www.w3.org/2000/svg",width:a,height:a,viewBox:"0 0 24 24",fill:"none",stroke:r,strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"},s),i.createElement("line",{x1:"18",y1:"6",x2:"6",y2:"18"}),i.createElement("line",{x1:"6",y1:"6",x2:"18",y2:"18"}))}));no.propTypes={color:Xr().string,size:Xr().oneOfType([Xr().string,Xr().number])},no.displayName="X";const ro=no;function oo(){return oo=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},oo.apply(this,arguments)}function io(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}var ao=(0,i.forwardRef)((function(e,t){var n=e.color,r=void 0===n?"currentColor":n,o=e.size,a=void 0===o?24:o,s=io(e,["color","size"]);return i.createElement("svg",oo({ref:t,xmlns:"http://www.w3.org/2000/svg",width:a,height:a,viewBox:"0 0 24 24",fill:"none",stroke:r,strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"},s),i.createElement("path",{d:"M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"}),i.createElement("path",{d:"M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"}))}));ao.propTypes={color:Xr().string,size:Xr().oneOfType([Xr().string,Xr().number])},ao.displayName="Edit";const so=ao;function lo(){return lo=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},lo.apply(this,arguments)}function co(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}var uo=(0,i.forwardRef)((function(e,t){var n=e.color,r=void 0===n?"currentColor":n,o=e.size,a=void 0===o?24:o,s=co(e,["color","size"]);return i.createElement("svg",lo({ref:t,xmlns:"http://www.w3.org/2000/svg",width:a,height:a,viewBox:"0 0 24 24",fill:"none",stroke:r,strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"},s),i.createElement("circle",{cx:"12",cy:"12",r:"10"}),i.createElement("polyline",{points:"12 6 12 12 16 14"}))}));uo.propTypes={color:Xr().string,size:Xr().oneOfType([Xr().string,Xr().number])},uo.displayName="Clock";const po=uo;function fo(){return fo=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},fo.apply(this,arguments)}function ho(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}var mo=(0,i.forwardRef)((function(e,t){var n=e.color,r=void 0===n?"currentColor":n,o=e.size,a=void 0===o?24:o,s=ho(e,["color","size"]);return i.createElement("svg",fo({ref:t,xmlns:"http://www.w3.org/2000/svg",width:a,height:a,viewBox:"0 0 24 24",fill:"none",stroke:r,strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"},s),i.createElement("polyline",{points:"4 14 10 14 10 20"}),i.createElement("polyline",{points:"20 10 14 10 14 4"}),i.createElement("line",{x1:"14",y1:"10",x2:"21",y2:"3"}),i.createElement("line",{x1:"3",y1:"21",x2:"10",y2:"14"}))}));mo.propTypes={color:Xr().string,size:Xr().oneOfType([Xr().string,Xr().number])},mo.displayName="Minimize2";const go=mo;function vo(){return vo=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},vo.apply(this,arguments)}function yo(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}var bo=(0,i.forwardRef)((function(e,t){var n=e.color,r=void 0===n?"currentColor":n,o=e.size,a=void 0===o?24:o,s=yo(e,["color","size"]);return i.createElement("svg",vo({ref:t,xmlns:"http://www.w3.org/2000/svg",width:a,height:a,viewBox:"0 0 24 24",fill:"none",stroke:r,strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"},s),i.createElement("polyline",{points:"15 3 21 3 21 9"}),i.createElement("polyline",{points:"9 21 3 21 3 15"}),i.createElement("line",{x1:"21",y1:"3",x2:"14",y2:"10"}),i.createElement("line",{x1:"3",y1:"21",x2:"10",y2:"14"}))}));bo.propTypes={color:Xr().string,size:Xr().oneOfType([Xr().string,Xr().number])},bo.displayName="Maximize2";const _o=bo;var Ao=(0,i.createContext)({translate:e=>e}),Eo=Ao.Consumer;function wo(e){var{children:t,translate:n}=e,r={translate:n};return Mr(Ao.Provider,{value:r},t)}function xo(){return(0,i.useContext)(Ao).translate}var ko=function(e){return e.Studio="studio",e}(ko||{}),Co=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=xo();return(0,i.useCallback)((function(n){for(var r=So(e,n)?n:e+"."+n,o=arguments.length,i=new Array(o>1?o-1:0),a=1;a<o;a++)i[a-1]=arguments[a];return t.apply(void 0,[r].concat(i))}),[e,t])},So=function(e,t){return!e.length||0===t.indexOf(ko.Studio+".")},Mo="poppy-session-id";var To={baseUrl:null,iframeSrc:null};function Oo(e){var t=e.isOpen,n=e.onInitialized,r=m((0,i.useState)((function(){return To.iframeSrc})),2),o=r[0],a=r[1],s=(0,i.useRef)(!1),l=function(){if(To.baseUrl){var e=function(){try{return localStorage.getItem(Mo)}catch(e){return null}}(),t=e?To.baseUrl+"/"+e:To.baseUrl;To.iframeSrc=t,a(t),null==n||n()}else console.error("[Poppy] iframeBaseUrl is not set — setAssistantIframeUrl() was never called. Check that assistant.iframe_url is configured in config.ini and the bootstrap is running.")};(0,i.useEffect)((function(){!t||o||s.current||(s.current=!0,l())}),[t,o,n]);var c=o?new URL(o).origin:null;return{iframeSrc:o,iframeOrigin:c}}function Do(e,t,n,r,o,i,a){try{var s=e[i](a),l=s.value}catch(e){return void n(e)}s.done?t(l):Promise.resolve(l).then(r,o)}function Lo(e){return function(){var t=this,n=arguments;return new Promise((function(r,o){var i=e.apply(t,n);function a(e){Do(i,r,o,a,s,"next",e)}function s(e){Do(i,r,o,a,s,"throw",e)}a(void 0)}))}}var Po=o(70232),Io=o.n(Po),Bo={defer:!1},Ro={},No=function(e){return e.Json="application/json",e.ProblemJson="application/problem+json",e.SpJson="application/vnd.shootproof+json",e}({}),Fo=function(e){return e.DELETE="DELETE",e.GET="GET",e.PATCH="PATCH",e.POST="POST",e.PUT="PUT",e}({}),jo=function(e){return n({},e,e.method&&{method:e.method.toUpperCase()})},Yo=function(e){return e===Fo.GET};function $o(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:n({},Bo),r=t.defer;delete t.defer;var o=m((0,i.useState)(!r),2),a=o[0],s=o[1],l=(0,i.useRef)(t),c=(0,i.useCallback)(function(){var t=Lo(Io().mark((function t(r){var o,i,a,s,l,c,u,d,p;return Io().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return o=r.method,i=void 0===o?Fo.GET:o,[Fo.PATCH,Fo.POST,Fo.PUT,Fo.DELETE].some((function(e){return e===i}))&&r.data&&(a=r.data,s={"Content-Type":No.SpJson},a&&(r.body=JSON.stringify(a),delete r.data),r.headers=n({},s,r.headers||{})),t.prev=3,c=r.search,u=new URL(r.url?e?e+"/"+r.url:r.url:e),r.url&&delete r.url,c&&(Object.entries(c).forEach((function(e){var t=m(e,2),n=t[0],r=t[1];return u.searchParams.set(n,r)})),delete r.search),t.next=10,fetch(u.href,r);case 10:l=t.sent,t.next=16;break;case 13:t.prev=13,t.t0=t.catch(3),l={status:500};case 16:if(d=l.status,![No.Json,No.ProblemJson,No.SpJson].includes(l.headers.get("Content-Type"))){t.next=23;break}return t.next=20,l.json();case 20:t.t1=t.sent,t.next=24;break;case 23:t.t1={response:l};case 24:return p=t.t1,t.abrupt("return",n({},p,{status:d}));case 26:case"end":return t.stop()}}),t,null,[[3,13]])})));return function(e){return t.apply(this,arguments)}}(),[e]),u=t.fetchOnUrlChange,d=void 0!==u&&u,p=m((0,i.useState)(!1),2),f=p[0],h=p[1],g=m((0,i.useState)(!r),2),v=g[0],y=g[1],b=m((0,i.useState)(jo(l.current)),2),_=b[0],A=b[1],E=(0,i.useCallback)(Lo(Io().mark((function e(){var t,r,o=arguments;return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return t=o.length>0&&void 0!==o[0]?o[0]:{},r=new Promise((function(e){C.current=e})),setTimeout((function(){var e=n({},l.current,t);(l.current.data||t.data)&&(e.data=n({},l.current.data,t.data)),(l.current.headers||t.headers)&&(e.headers=n({},l.current.headers,t.headers)),A(jo(e)),s(!0),h(!0)})),e.next=5,r;case 5:return e.abrupt("return",e.sent);case 6:case"end":return e.stop()}}),e)}))),[]),w=m((0,i.useState)(null),2),x=w[0],k=w[1],C=(0,i.useRef)();return r=r&&!f,(0,i.useEffect)((function(){var t=!1;if(a){var n,r=_.method,o=void 0===r?Fo.GET:r,i=Yo(o);delete _.fetchOnUrlChange,y(!0),k(null),i?(n=Ro[e])||(n=c(_),Ro[e]=n):n=c(_),n.then((function(e){t||(s(!1),k(e),y(!1),C.current&&C.current(e))})).catch((function(){t||(s(!1),k(null),y(!1),C.current&&C.current(null))})).finally((function(){i&&delete Ro[e]}))}return function(){t=!0}}),[a,c,_,e]),(0,i.useEffect)((function(){s(!r)}),[r]),(0,i.useEffect)((function(){var e=_.method;(!e||Yo(e)||d)&&s(!r)}),[r,d,_,e]),{response:x,loading:v,performFetch:E}}var Ho="",Uo="https://api.shootproof.com";function zo(e,t){return $o(String(new URL("studio/"+e,Uo)),n({},t,{headers:n({Authorization:Ho},(null==t?void 0:t.headers)||{})}))}var Wo="poppy_session_token",Vo=33e5;function Go(){try{var e=sessionStorage.getItem(Wo);if(!e)return null;var t=JSON.parse(e),n=t.token,r=t.ts;return Date.now()-r<Vo?n:null}catch(e){return null}}function Qo(e){try{sessionStorage.setItem(Wo,JSON.stringify({token:e,ts:Date.now()}))}catch(e){}}const qo=function(e){var t=e.iframeOrigin,n=e.onIframeReady,r=e.onTokenRefreshed,o=e.refreshToken,a=e.setPoppyState,s=(0,i.useCallback)((function(e){var i,s,l,c,u;if(t&&e.origin===t)if("POPPY_IFRAME_READY"===(null===(i=e.data)||void 0===i?void 0:i.type))n();else if("TOKEN_EXPIRED"===(null===(s=e.data)||void 0===s?void 0:s.type))o().then((function(e){e&&r(e)}));else if("CHAT_LOADED"===(null===(l=e.data)||void 0===l?void 0:l.type)){var d,p=(null!==(d=e.data.payload)&&void 0!==d?d:{}).sessionId;p&&function(e){try{localStorage.setItem(Mo,e)}catch(e){}}(p)}else if("ZIA_STATE_UPDATE"===(null===(c=e.data)||void 0===c?void 0:c.type)){var f;a(null!==(f=e.data.payload)&&void 0!==f?f:{})}else if("NAVIGATE_TO"===(null===(u=e.data)||void 0===u?void 0:u.type)){var h,m=(null!==(h=e.data.payload)&&void 0!==h?h:{}).url;if(m){var g=m.startsWith("/")?""+window.location.origin+m:m.startsWith("http")?m:window.location.origin+"/"+m;try{new URL(g).origin===window.location.origin&&(window.location.href=g)}catch(e){}}}}),[t,o,n,r,a]);(0,i.useEffect)((function(){return window.addEventListener("message",s),function(){return window.removeEventListener("message",s)}}),[s])};var Ko="poppy_panel_position";function Zo(e,t,n){return Math.min(Math.max(e,t),n)}function Jo(e,t){var n=(0,i.useState)((function(){return function(e,t){try{var n=sessionStorage.getItem(Ko);if(n){var r=JSON.parse(n);return{x:Zo(r.x,0,window.innerWidth-100),y:Zo(r.y,0,window.innerHeight-100)}}}catch(e){}return{x:e,y:t}}(e,t)})),r=m(n,2),o=r[0],a=r[1];(0,i.useEffect)((function(){sessionStorage.setItem(Ko,JSON.stringify(o))}),[o]);var s=(0,i.useRef)(null),l=(0,i.useCallback)((function(e){e.currentTarget.setPointerCapture(e.pointerId),s.current={mx:e.clientX,my:e.clientY,px:o.x,py:o.y}}),[o]),c=(0,i.useCallback)((function(e,t,n){if(s.current){var r=Zo(s.current.px+e.clientX-s.current.mx,0,window.innerWidth-t),o=Zo(s.current.py+e.clientY-s.current.my,0,window.innerHeight-n);a({x:r,y:o})}}),[]),u=(0,i.useCallback)((function(){s.current=null}),[]);return{pos:o,setPos:a,onPointerDown:l,onPointerMove:c,onPointerUp:u}}var Xo=320,ei=320,ti="poppy_panel_size";function ni(e,t,n){return Math.min(Math.max(e,t),n)}function ri(e,t,n){var r=(0,i.useState)((function(){return function(e,t){try{var n=sessionStorage.getItem(ti);if(n){var r=JSON.parse(n);return{w:ni(r.w,Xo,window.innerWidth),h:ni(r.h,ei,window.innerHeight)}}}catch(e){}return{w:e,h:t}}(e,t)})),o=m(r,2),a=o[0],s=o[1];(0,i.useEffect)((function(){sessionStorage.setItem(ti,JSON.stringify(a))}),[a]);var l=(0,i.useRef)(null),c=(0,i.useCallback)((function(e,t,n){e.stopPropagation(),e.currentTarget.setPointerCapture(e.pointerId),l.current={mx:e.clientX,my:e.clientY,sw:a.w,sh:a.h,px:n.x,py:n.y,dir:t}}),[a]),u=(0,i.useCallback)((function(e){if(l.current){var t=l.current,r=t.mx,o=t.my,i=t.sw,a=t.sh,c=t.px,u=t.py,d=t.dir,p=e.clientX-r,f=e.clientY-o,h=i,m=a,g=c,v=u;d.includes("e")&&(h=ni(i+p,Xo,window.innerWidth-c)),d.includes("w")&&(g=c+i-(h=ni(i-p,Xo,c+i))),d.includes("s")&&(m=ni(a+f,ei,window.innerHeight-u)),d.includes("n")&&(v=u+a-(m=ni(a-f,ei,u+a))),s({w:h,h:m}),g===c&&v===u||n({x:g,y:v})}}),[n]),d=(0,i.useCallback)((function(){l.current=null}),[]);return{size:a,setSize:s,onPointerDown:c,onPointerMove:u,onPointerUp:d}}const oi=function(e){var t=e.isOpen,r=e.onClose,o=Co("studio.assistant"),a=(0,i.useRef)(null),s=m((0,i.useState)(!1),2),l=s[0],c=s[1],u=m((0,i.useState)(!1),2),d=u[0],p=u[1],f=m((0,i.useState)({isHistoryDialogOpen:!1,currentPath:""}),2),h=f[0],g=f[1],v=Jo(window.innerWidth-600-16,75),y=ri(600,550,v.setPos),b=(0,i.useRef)(v.pos);b.current=v.pos;var _=(0,i.useRef)(y.size);_.current=y.size,(0,i.useEffect)((function(){if(!d)return window.addEventListener("resize",e),function(){return window.removeEventListener("resize",e)};function e(){var e=window.innerWidth,t=window.innerHeight,n=_.current,r=n.w,o=n.h,i=b.current,a=i.x,s=i.y,l=Math.max(Xo,Math.min(r,e)),c=Math.max(ei,Math.min(o,t)),u=Math.max(0,Math.min(a,e-l)),d=Math.max(0,Math.min(s,t-c));l===r&&c===o||y.setSize({w:l,h:c}),u===a&&d===s||v.setPos({x:u,y:d})}}),[d,y.setSize,v.setPos]);var A=(0,i.useCallback)((function(){c(!1)}),[]),E=Oo({isOpen:t,onInitialized:A}),w=E.iframeSrc,x=E.iframeOrigin,k=function(){var e=m((0,i.useState)(Go),1)[0],t=m((0,i.useState)(null),2),n=t[0],r=t[1],o=m((0,i.useState)(null),2),a=o[0],s=o[1],l=zo("assistant/session",{defer:!0,method:Fo.POST}),c=l.loading,u=l.performFetch,d=(0,i.useCallback)(Lo(Io().mark((function t(){var n;return Io().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,u();case 2:if(200!==(null==(n=t.sent)?void 0:n.status)||!n.token){t.next=8;break}return Qo(n.token),r(n.token),s(null),t.abrupt("return",n.token);case 8:return n&&200!==n.status&&!e&&s({status:n.status}),t.abrupt("return",null);case 10:case"end":return t.stop()}}),t)}))),[u,e]);return{sessionToken:null!=n?n:e,loading:c,error:a,refreshToken:d}}(),C=k.sessionToken,S=k.loading,M=k.error,T=k.refreshToken,O=(0,i.useRef)(!1);(0,i.useEffect)((function(){t&&!O.current&&(O.current=!0,T())}),[t,T]);var D=function(e){var t=e.iframeRef,n=e.iframeOrigin,r=e.iframeReady,o=(0,i.useCallback)((function(e){var r;n&&(null===(r=t.current)||void 0===r||null===(r=r.contentWindow)||void 0===r||r.postMessage(e,n))}),[n,t]),a=(0,i.useCallback)((function(){o({type:"PAGE_CONTEXT_UPDATE",payload:{pageUrl:window.location.href,pagePath:window.location.pathname,pageTitle:document.title}})}),[o]),s=(0,i.useCallback)((function(){o({type:"START_NEW_CONVERSATION"})}),[o]),l=(0,i.useCallback)((function(){o({type:"OPEN_CHAT_HISTORY"})}),[o]);return(0,i.useEffect)((function(){if(r)return window.addEventListener("popstate",a),window.addEventListener("hashchange",a),function(){window.removeEventListener("popstate",a),window.removeEventListener("hashchange",a)}}),[r,a]),{postToPoppy:o,postPageContext:a,startNewChat:s,openChatHistory:l}}({iframeRef:a,iframeOrigin:x,iframeReady:l}),L=D.startNewChat,P=D.openChatHistory,I=D.postToPoppy,B=D.postPageContext,R=(0,i.useCallback)((function(){c(!0),C&&I({type:"SET_AUTH_TOKEN",token:C}),B()}),[C,I,B]),N=(0,i.useCallback)((function(e){I({type:"SET_AUTH_TOKEN",token:e})}),[I]);qo({iframeOrigin:x,onIframeReady:R,onTokenRefreshed:N,refreshToken:T,setPoppyState:g});var F=To.baseUrl?new URL(To.baseUrl).pathname:null,j=!F||h.currentPath!==F||h.isHistoryDialogOpen,Y=d?{bottom:0,left:0,right:0,top:0}:{left:v.pos.x,top:v.pos.y,width:y.size.w,height:y.size.h},$=function(e){return n({position:"absolute",zIndex:1},"n"===e&&{top:0,left:12,right:12,height:6,cursor:"n-resize"},"ne"===e&&{top:0,right:0,width:12,height:12,cursor:"ne-resize"},"e"===e&&{top:12,right:0,bottom:12,width:6,cursor:"e-resize"},"se"===e&&{bottom:0,right:0,width:12,height:12,cursor:"se-resize"},"s"===e&&{bottom:0,left:12,right:12,height:6,cursor:"s-resize"},"sw"===e&&{bottom:0,left:0,width:12,height:12,cursor:"sw-resize"},"w"===e&&{top:12,left:0,bottom:12,width:6,cursor:"w-resize"},"nw"===e&&{top:0,left:0,width:12,height:12,cursor:"nw-resize"})};return Zr.createPortal(i.createElement(_r,{display:t?"flex":"none",flexDirection:"column",position:"fixed",zIndex:9e3,border:d?void 0:"1px solid #e2e8f0",borderRadius:d?void 0:"8px",boxShadow:"0 8px 30px rgba(0,0,0,0.18)",style:Y,onPointerMove:d?void 0:y.onPointerMove,onPointerUp:d?void 0:y.onPointerUp},i.createElement(wr,{alignItems:"center",bg:"#f7f7f7",flexShrink:0,justifyContent:"space-between",px:3,py:2,style:{cursor:d?"default":"move"},onPointerDown:d?void 0:function(e){e.target.closest("button")||v.onPointerDown(e)},onPointerMove:d?void 0:function(e){return v.onPointerMove(e,y.size.w,y.size.h)},onPointerUp:d?void 0:v.onPointerUp},i.createElement(Gr,{"aria-label":o("buttons.close"),icon:i.createElement(ro,{size:18}),onClick:r,variant:"ghost",size:"sm",color:"gray.600"}),i.createElement(wr,{alignItems:"center",gap:1},j&&i.createElement(Gr,{"aria-label":o("buttons.newChat"),icon:i.createElement(so,{size:18}),isDisabled:!l,onClick:L,variant:"ghost",size:"sm",color:"gray.600"}),i.createElement(Gr,{"aria-label":o("buttons.history"),icon:i.createElement(po,{size:18}),isDisabled:!l,onClick:P,variant:"ghost",size:"sm",color:"gray.600"}),i.createElement(Gr,{"aria-label":o(d?"buttons.restoreSize":"buttons.fullscreen"),icon:d?i.createElement(go,{size:18}):i.createElement(_o,{size:18}),onClick:function(){return p((function(e){return!e}))},variant:"ghost",size:"sm",color:"gray.600"}))),i.createElement(_r,{flex:1,overflow:"hidden",position:"relative"},S&&i.createElement(wr,{alignItems:"center",bottom:0,color:"gray.500",fontSize:"sm",justifyContent:"center",left:0,p:4,position:"absolute",right:0,textAlign:"center",top:0},o("loading")),M&&i.createElement(wr,{alignItems:"center",bottom:0,color:"gray.500",fontSize:"sm",justifyContent:"center",left:0,p:4,position:"absolute",right:0,textAlign:"center",top:0},o("error")),!M&&w&&i.createElement("iframe",{ref:a,src:w,style:{border:"none",display:"block",height:"100%",width:"100%",visibility:l?"visible":"hidden"},title:"Poppy"})),i.createElement(wr,{alignItems:"center",bg:"#f7f7f7",borderRadius:"0 0 4px 4px",flexShrink:0,flexDirection:"column",px:3,py:"6px"},i.createElement(qr,{color:"gray.500",fontSize:"11px",fontWeight:500,lineHeight:1.4,m:0,textAlign:"center"},o("footerText"),i.createElement(Kr,{href:"https://help.shootproof.com/hc/en-us/articles/38513280675991-Poppy-Usage-Guidelines",rel:"noopener noreferrer",target:"_blank",color:"blue.500",ml:1,fontSize:"11px"},o("learnMore")))),!d&&["nw","n","ne","e","se","s","sw","w"].map((function(e){return i.createElement("div",{key:e,style:$(e),onPointerDown:function(t){return y.onPointerDown(t,e,v.pos)}})}))),document.body)};var ii={property:{common:"background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",colors:"background-color, border-color, color, fill, stroke",dimensions:"width, height",position:"left, right, top, bottom",background:"background-color, background-image, background-position"},easing:{"ease-in":"cubic-bezier(0.4, 0, 1, 1)","ease-out":"cubic-bezier(0, 0, 0.2, 1)","ease-in-out":"cubic-bezier(0.4, 0, 0.2, 1)"},duration:{"ultra-fast":"50ms",faster:"100ms",fast:"150ms",normal:"200ms",slow:"300ms",slower:"400ms","ultra-slow":"500ms"}},ai={hide:-1,auto:"auto",base:0,docked:10,dropdown:1e3,sticky:1100,banner:1200,overlay:1300,modal:1400,popover:1500,skipLink:1600,toast:1700,tooltip:1800},si={none:0,"1px":"1px solid","2px":"2px solid","4px":"4px solid","8px":"8px solid"},li={base:"0em",sm:"30em",md:"48em",lg:"62em",xl:"80em","2xl":"96em"},ci={transparent:"transparent",current:"currentColor",black:"#000000",white:"#FFFFFF",whiteAlpha:{50:"rgba(255, 255, 255, 0.04)",100:"rgba(255, 255, 255, 0.06)",200:"rgba(255, 255, 255, 0.08)",300:"rgba(255, 255, 255, 0.16)",400:"rgba(255, 255, 255, 0.24)",500:"rgba(255, 255, 255, 0.36)",600:"rgba(255, 255, 255, 0.48)",700:"rgba(255, 255, 255, 0.64)",800:"rgba(255, 255, 255, 0.80)",900:"rgba(255, 255, 255, 0.92)"},blackAlpha:{50:"rgba(0, 0, 0, 0.04)",100:"rgba(0, 0, 0, 0.06)",200:"rgba(0, 0, 0, 0.08)",300:"rgba(0, 0, 0, 0.16)",400:"rgba(0, 0, 0, 0.24)",500:"rgba(0, 0, 0, 0.36)",600:"rgba(0, 0, 0, 0.48)",700:"rgba(0, 0, 0, 0.64)",800:"rgba(0, 0, 0, 0.80)",900:"rgba(0, 0, 0, 0.92)"},gray:{50:"#F7FAFC",100:"#EDF2F7",200:"#E2E8F0",300:"#CBD5E0",400:"#A0AEC0",500:"#718096",600:"#4A5568",700:"#2D3748",800:"#1A202C",900:"#171923"},red:{50:"#FFF5F5",100:"#FED7D7",200:"#FEB2B2",300:"#FC8181",400:"#F56565",500:"#E53E3E",600:"#C53030",700:"#9B2C2C",800:"#822727",900:"#63171B"},orange:{50:"#FFFAF0",100:"#FEEBC8",200:"#FBD38D",300:"#F6AD55",400:"#ED8936",500:"#DD6B20",600:"#C05621",700:"#9C4221",800:"#7B341E",900:"#652B19"},yellow:{50:"#FFFFF0",100:"#FEFCBF",200:"#FAF089",300:"#F6E05E",400:"#ECC94B",500:"#D69E2E",600:"#B7791F",700:"#975A16",800:"#744210",900:"#5F370E"},green:{50:"#F0FFF4",100:"#C6F6D5",200:"#9AE6B4",300:"#68D391",400:"#48BB78",500:"#38A169",600:"#2F855A",700:"#276749",800:"#22543D",900:"#1C4532"},teal:{50:"#E6FFFA",100:"#B2F5EA",200:"#81E6D9",300:"#4FD1C5",400:"#38B2AC",500:"#319795",600:"#2C7A7B",700:"#285E61",800:"#234E52",900:"#1D4044"},blue:{50:"#ebf8ff",100:"#bee3f8",200:"#90cdf4",300:"#63b3ed",400:"#4299e1",500:"#3182ce",600:"#2b6cb0",700:"#2c5282",800:"#2a4365",900:"#1A365D"},cyan:{50:"#EDFDFD",100:"#C4F1F9",200:"#9DECF9",300:"#76E4F7",400:"#0BC5EA",500:"#00B5D8",600:"#00A3C4",700:"#0987A0",800:"#086F83",900:"#065666"},purple:{50:"#FAF5FF",100:"#E9D8FD",200:"#D6BCFA",300:"#B794F4",400:"#9F7AEA",500:"#805AD5",600:"#6B46C1",700:"#553C9A",800:"#44337A",900:"#322659"},pink:{50:"#FFF5F7",100:"#FED7E2",200:"#FBB6CE",300:"#F687B3",400:"#ED64A6",500:"#D53F8C",600:"#B83280",700:"#97266D",800:"#702459",900:"#521B41"},linkedin:{50:"#E8F4F9",100:"#CFEDFB",200:"#9BDAF3",300:"#68C7EC",400:"#34B3E4",500:"#00A0DC",600:"#008CC9",700:"#0077B5",800:"#005E93",900:"#004471"},facebook:{50:"#E8F4F9",100:"#D9DEE9",200:"#B7C2DA",300:"#6482C0",400:"#4267B2",500:"#385898",600:"#314E89",700:"#29487D",800:"#223B67",900:"#1E355B"},messenger:{50:"#D0E6FF",100:"#B9DAFF",200:"#A2CDFF",300:"#7AB8FF",400:"#2E90FF",500:"#0078FF",600:"#0063D1",700:"#0052AC",800:"#003C7E",900:"#002C5C"},whatsapp:{50:"#dffeec",100:"#b9f5d0",200:"#90edb3",300:"#65e495",400:"#3cdd78",500:"#22c35e",600:"#179848",700:"#0c6c33",800:"#01421c",900:"#001803"},twitter:{50:"#E5F4FD",100:"#C8E9FB",200:"#A8DCFA",300:"#83CDF7",400:"#57BBF5",500:"#1DA1F2",600:"#1A94DA",700:"#1681BF",800:"#136B9E",900:"#0D4D71"},telegram:{50:"#E3F2F9",100:"#C5E4F3",200:"#A2D4EC",300:"#7AC1E4",400:"#47A9DA",500:"#0088CC",600:"#007AB8",700:"#006BA1",800:"#005885",900:"#003F5E"}},ui={none:"0",sm:"0.125rem",base:"0.25rem",md:"0.375rem",lg:"0.5rem",xl:"0.75rem","2xl":"1rem","3xl":"1.5rem",full:"9999px"},di={xs:"0 0 0 1px rgba(0, 0, 0, 0.05)",sm:"0 1px 2px 0 rgba(0, 0, 0, 0.05)",base:"0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",md:"0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",lg:"0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",xl:"0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)","2xl":"0 25px 50px -12px rgba(0, 0, 0, 0.25)",outline:"0 0 0 3px rgba(66, 153, 225, 0.6)",inner:"inset 0 2px 4px 0 rgba(0,0,0,0.06)",none:"none","dark-lg":"rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"},pi={none:0,sm:"4px",base:"8px",md:"12px",lg:"16px",xl:"24px","2xl":"40px","3xl":"64px"},fi={letterSpacings:{tighter:"-0.05em",tight:"-0.025em",normal:"0",wide:"0.025em",wider:"0.05em",widest:"0.1em"},lineHeights:{normal:"normal",none:1,shorter:1.25,short:1.375,base:1.5,tall:1.625,taller:"2",3:".75rem",4:"1rem",5:"1.25rem",6:"1.5rem",7:"1.75rem",8:"2rem",9:"2.25rem",10:"2.5rem"},fontWeights:{hairline:100,thin:200,light:300,normal:400,medium:500,semibold:600,bold:700,extrabold:800,black:900},fonts:{heading:'-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',body:'-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',mono:'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'},fontSizes:{"3xs":"0.45rem","2xs":"0.625rem",xs:"0.75rem",sm:"0.875rem",md:"1rem",lg:"1.125rem",xl:"1.25rem","2xl":"1.5rem","3xl":"1.875rem","4xl":"2.25rem","5xl":"3rem","6xl":"3.75rem","7xl":"4.5rem","8xl":"6rem","9xl":"8rem"}},hi={px:"1px",.5:"0.125rem",1:"0.25rem",1.5:"0.375rem",2:"0.5rem",2.5:"0.625rem",3:"0.75rem",3.5:"0.875rem",4:"1rem",5:"1.25rem",6:"1.5rem",7:"1.75rem",8:"2rem",9:"2.25rem",10:"2.5rem",12:"3rem",14:"3.5rem",16:"4rem",20:"5rem",24:"6rem",28:"7rem",32:"8rem",36:"9rem",40:"10rem",44:"11rem",48:"12rem",52:"13rem",56:"14rem",60:"15rem",64:"16rem",72:"18rem",80:"20rem",96:"24rem"},mi={...hi,max:"max-content",min:"min-content",full:"100%","3xs":"14rem","2xs":"16rem",xs:"20rem",sm:"24rem",md:"28rem",lg:"32rem",xl:"36rem","2xl":"42rem","3xl":"48rem","4xl":"56rem","5xl":"64rem","6xl":"72rem","7xl":"80rem","8xl":"90rem",prose:"60ch",container:{sm:"640px",md:"768px",lg:"1024px",xl:"1280px"}},gi={breakpoints:li,zIndices:ai,radii:ui,blur:pi,colors:ci,...fi,sizes:mi,shadows:di,space:hi,borders:si,transition:ii},{defineMultiStyleConfig:vi,definePartsStyle:yi}=ct(["stepper","step","title","description","indicator","separator","icon","number"]),bi=ke("stepper-indicator-size"),_i=ke("stepper-icon-size"),Ai=ke("stepper-title-font-size"),Ei=ke("stepper-description-font-size"),wi=ke("stepper-accent-color"),xi=yi((({colorScheme:e})=>({stepper:{display:"flex",justifyContent:"space-between",gap:"4","&[data-orientation=vertical]":{flexDirection:"column",alignItems:"flex-start"},"&[data-orientation=horizontal]":{flexDirection:"row",alignItems:"center"},[wi.variable]:`colors.${e}.500`,_dark:{[wi.variable]:`colors.${e}.200`}},title:{fontSize:Ai.reference,fontWeight:"medium"},description:{fontSize:Ei.reference,color:"chakra-subtle-text"},number:{fontSize:Ai.reference},step:{flexShrink:0,position:"relative",display:"flex",gap:"2","&[data-orientation=horizontal]":{alignItems:"center"},flex:"1","&:last-of-type:not([data-stretch])":{flex:"initial"}},icon:{flexShrink:0,width:_i.reference,height:_i.reference},indicator:{flexShrink:0,borderRadius:"full",width:bi.reference,height:bi.reference,display:"flex",justifyContent:"center",alignItems:"center","&[data-status=active]":{borderWidth:"2px",borderColor:wi.reference},"&[data-status=complete]":{bg:wi.reference,color:"chakra-inverse-text"},"&[data-status=incomplete]":{borderWidth:"2px"}},separator:{bg:"chakra-border-color",flex:"1","&[data-status=complete]":{bg:wi.reference},"&[data-orientation=horizontal]":{width:"100%",height:"2px",marginStart:"2"},"&[data-orientation=vertical]":{width:"2px",position:"absolute",height:"100%",maxHeight:`calc(100% - ${bi.reference} - 8px)`,top:`calc(${bi.reference} + 4px)`,insetStart:`calc(${bi.reference} / 2 - 1px)`}}}))),ki=vi({baseStyle:xi,sizes:{xs:yi({stepper:{[bi.variable]:"sizes.4",[_i.variable]:"sizes.3",[Ai.variable]:"fontSizes.xs",[Ei.variable]:"fontSizes.xs"}}),sm:yi({stepper:{[bi.variable]:"sizes.6",[_i.variable]:"sizes.4",[Ai.variable]:"fontSizes.sm",[Ei.variable]:"fontSizes.xs"}}),md:yi({stepper:{[bi.variable]:"sizes.8",[_i.variable]:"sizes.5",[Ai.variable]:"fontSizes.md",[Ei.variable]:"fontSizes.sm"}}),lg:yi({stepper:{[bi.variable]:"sizes.10",[_i.variable]:"sizes.6",[Ai.variable]:"fontSizes.lg",[Ei.variable]:"fontSizes.md"}})},defaultProps:{size:"md",colorScheme:"blue"}});function Ci(e,t={}){let n=!1;function r(t){const n=`chakra-${(["container","root"].includes(null!=t?t:"")?[e]:[e,t]).filter(Boolean).join("__")}`;return{className:n,selector:`.${n}`,toString:()=>t}}return{parts:function(...o){!function(){if(n)throw new Error("[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?");n=!0}();for(const e of o)t[e]=r(e);return Ci(e,t)},toPart:r,extend:function(...n){for(const e of n)e in t||(t[e]=r(e));return Ci(e,t)},selectors:function(){return Object.fromEntries(Object.entries(t).map((([e,t])=>[e,t.selector])))},classnames:function(){return Object.fromEntries(Object.entries(t).map((([e,t])=>[e,t.className])))},get keys(){return Object.keys(t)},__type:{}}}var Si=Ci("accordion").parts("root","container","button","panel").extend("icon"),Mi=Ci("alert").parts("title","description","container").extend("icon","spinner"),Ti=Ci("avatar").parts("label","badge","container").extend("excessLabel","group"),Oi=Ci("breadcrumb").parts("link","item","container").extend("separator"),Di=(Ci("button").parts(),Ci("checkbox").parts("control","icon","container").extend("label")),Li=(Ci("progress").parts("track","filledTrack").extend("label"),Ci("drawer").parts("overlay","dialogContainer","dialog").extend("header","closeButton","body","footer")),Pi=Ci("editable").parts("preview","input","textarea"),Ii=Ci("form").parts("container","requiredIndicator","helperText"),Bi=Ci("formError").parts("text","icon"),Ri=Ci("input").parts("addon","field","element","group"),Ni=Ci("list").parts("container","item","icon"),Fi=Ci("menu").parts("button","list","item").extend("groupTitle","icon","command","divider"),ji=Ci("modal").parts("overlay","dialogContainer","dialog").extend("header","closeButton","body","footer"),Yi=Ci("numberinput").parts("root","field","stepperGroup","stepper"),$i=(Ci("pininput").parts("field"),Ci("popover").parts("content","header","body","footer").extend("popper","arrow","closeButton")),Hi=Ci("progress").parts("label","filledTrack","track"),Ui=Ci("radio").parts("container","control","label"),zi=Ci("select").parts("field","icon"),Wi=Ci("slider").parts("container","track","thumb","filledTrack","mark"),Vi=Ci("stat").parts("container","label","helpText","number","icon"),Gi=Ci("switch").parts("container","track","thumb","label"),Qi=Ci("table").parts("table","thead","tbody","tr","th","td","tfoot","caption"),qi=Ci("tabs").parts("root","tab","tablist","tabpanel","tabpanels","indicator"),Ki=Ci("tag").parts("container","label","closeButton"),Zi=Ci("card").parts("container","header","body","footer"),Ji=Ci("stepper").parts("stepper","step","title","description","indicator","separator","icon","number");function Xi(e){const t=function(e,t="-"){return e.replace(/\s+/g,t)}(e.toString());return t.includes("\\.")?e:function(e){return!Number.isInteger(parseFloat(e.toString()))}(e)?t.replace(".","\\."):e}function ea(e,t){return`var(${Xi(e)}${t?`, ${t}`:""})`}function ta(e,t=""){return`--${function(e,t=""){return[t,Xi(e)].filter(Boolean).join("-")}(e,t)}`}function na(e,t){const n=ta(e,null==t?void 0:t.prefix);return{variable:n,reference:ea(n,ra(null==t?void 0:t.fallback))}}function ra(e){return"string"==typeof e?e:null==e?void 0:e.reference}function oa(e){return v(e)&&e.reference?e.reference:String(e)}var ia=(e,...t)=>t.map(oa).join(` ${e} `).replace(/calc/g,""),aa=(...e)=>`calc(${ia("+",...e)})`,sa=(...e)=>`calc(${ia("-",...e)})`,la=(...e)=>`calc(${ia("*",...e)})`,ca=(...e)=>`calc(${ia("/",...e)})`,ua=e=>{const t=oa(e);return null==t||Number.isNaN(parseFloat(t))?la(t,-1):String(t).startsWith("-")?String(t).slice(1):`-${t}`},da=Object.assign((e=>({add:(...t)=>da(aa(e,...t)),subtract:(...t)=>da(sa(e,...t)),multiply:(...t)=>da(la(e,...t)),divide:(...t)=>da(ca(e,...t)),negate:()=>da(ua(e)),toString:()=>e.toString()})),{add:aa,subtract:sa,multiply:la,divide:ca,negate:ua}),{defineMultiStyleConfig:pa,definePartsStyle:fa}=ct(Gi.keys),ha=na("switch-track-width"),ma=na("switch-track-height"),ga=na("switch-track-diff"),va=da.subtract(ha,ma),ya=na("switch-thumb-x"),ba=na("switch-bg"),_a=e=>{const{colorScheme:t}=e;return{borderRadius:"full",p:"0.5",width:[ha.reference],height:[ma.reference],transitionProperty:"common",transitionDuration:"fast",[ba.variable]:"colors.gray.300",_dark:{[ba.variable]:"colors.whiteAlpha.400"},_focusVisible:{boxShadow:"outline"},_disabled:{opacity:.4,cursor:"not-allowed"},_checked:{[ba.variable]:`colors.${t}.500`,_dark:{[ba.variable]:`colors.${t}.200`}},bg:ba.reference}},Aa={bg:"white",transitionProperty:"transform",transitionDuration:"normal",borderRadius:"inherit",width:[ma.reference],height:[ma.reference],_checked:{transform:`translateX(${ya.reference})`}},Ea=pa({baseStyle:fa((e=>({container:{[ga.variable]:va,[ya.variable]:ga.reference,_rtl:{[ya.variable]:da(ga).negate().toString()}},track:_a(e),thumb:Aa}))),sizes:{sm:fa({container:{[ha.variable]:"1.375rem",[ma.variable]:"sizes.3"}}),md:fa({container:{[ha.variable]:"1.875rem",[ma.variable]:"sizes.4"}}),lg:fa({container:{[ha.variable]:"2.875rem",[ma.variable]:"sizes.6"}})},defaultProps:{size:"md",colorScheme:"blue"}});function wa(e,t){return n=>"dark"===n.colorMode?t:e}function xa(e){const{orientation:t,vertical:n,horizontal:r}=e;return t?"vertical"===t?n:r:{}}var{defineMultiStyleConfig:ka,definePartsStyle:Ca}=ct(Qi.keys),Sa=Ca({table:{fontVariantNumeric:"lining-nums tabular-nums",borderCollapse:"collapse",width:"full"},th:{fontFamily:"heading",fontWeight:"bold",textTransform:"uppercase",letterSpacing:"wider",textAlign:"start"},td:{textAlign:"start"},caption:{mt:4,fontFamily:"heading",textAlign:"center",fontWeight:"medium"}}),Ma={"&[data-is-numeric=true]":{textAlign:"end"}},Ta=Ca((e=>{const{colorScheme:t}=e;return{th:{color:wa("gray.600","gray.400")(e),borderBottom:"1px",borderColor:wa(`${t}.100`,`${t}.700`)(e),...Ma},td:{borderBottom:"1px",borderColor:wa(`${t}.100`,`${t}.700`)(e),...Ma},caption:{color:wa("gray.600","gray.100")(e)},tfoot:{tr:{"&:last-of-type":{th:{borderBottomWidth:0}}}}}})),Oa=Ca((e=>{const{colorScheme:t}=e;return{th:{color:wa("gray.600","gray.400")(e),borderBottom:"1px",borderColor:wa(`${t}.100`,`${t}.700`)(e),...Ma},td:{borderBottom:"1px",borderColor:wa(`${t}.100`,`${t}.700`)(e),...Ma},caption:{color:wa("gray.600","gray.100")(e)},tbody:{tr:{"&:nth-of-type(odd)":{"th, td":{borderBottomWidth:"1px",borderColor:wa(`${t}.100`,`${t}.700`)(e)},td:{background:wa(`${t}.100`,`${t}.700`)(e)}}}},tfoot:{tr:{"&:last-of-type":{th:{borderBottomWidth:0}}}}}})),Da=ka({baseStyle:Sa,variants:{simple:Ta,striped:Oa,unstyled:{}},sizes:{sm:Ca({th:{px:"4",py:"1",lineHeight:"4",fontSize:"xs"},td:{px:"4",py:"2",fontSize:"sm",lineHeight:"4"},caption:{px:"4",py:"2",fontSize:"xs"}}),md:Ca({th:{px:"6",py:"3",lineHeight:"4",fontSize:"xs"},td:{px:"6",py:"4",lineHeight:"5"},caption:{px:"6",py:"2",fontSize:"sm"}}),lg:Ca({th:{px:"8",py:"4",lineHeight:"5",fontSize:"sm"},td:{px:"8",py:"5",lineHeight:"6"},caption:{px:"6",py:"2",fontSize:"md"}})},defaultProps:{variant:"simple",size:"md",colorScheme:"gray"}});function La(e,t,n){return Math.min(Math.max(e,n),t)}class Pa extends Error{constructor(e){super(`Failed to parse color: "${e}"`)}}var Ia=Pa;function Ba(e){if("string"!=typeof e)throw new Ia(e);if("transparent"===e.trim().toLowerCase())return[0,0,0,0];let t=e.trim();t=Ua.test(e)?function(e){const t=e.toLowerCase().trim(),n=Na[function(e){let t=5381,n=e.length;for(;n;)t=33*t^e.charCodeAt(--n);return(t>>>0)%2341}(t)];if(!n)throw new Ia(e);return`#${n}`}(e):e;const n=ja.exec(t);if(n){const e=Array.from(n).slice(1);return[...e.slice(0,3).map((e=>parseInt(Fa(e,2),16))),parseInt(Fa(e[3]||"f",2),16)/255]}const r=Ya.exec(t);if(r){const e=Array.from(r).slice(1);return[...e.slice(0,3).map((e=>parseInt(e,16))),parseInt(e[3]||"ff",16)/255]}const o=$a.exec(t);if(o){const e=Array.from(o).slice(1);return[...e.slice(0,3).map((e=>parseInt(e,10))),parseFloat(e[3]||"1")]}const i=Ha.exec(t);if(i){const[t,n,r,o]=Array.from(i).slice(1).map(parseFloat);if(La(0,100,n)!==n)throw new Ia(e);if(La(0,100,r)!==r)throw new Ia(e);return[...Wa(t,n,r),Number.isNaN(o)?1:o]}throw new Ia(e)}const Ra=e=>parseInt(e.replace(/_/g,""),36),Na="1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce(((e,t)=>{const n=Ra(t.substring(0,3)),r=Ra(t.substring(3)).toString(16);let o="";for(let e=0;e<6-r.length;e++)o+="0";return e[n]=`${o}${r}`,e}),{});const Fa=(e,t)=>Array.from(Array(t)).map((()=>e)).join(""),ja=new RegExp(`^#${Fa("([a-f0-9])",3)}([a-f0-9])?$`,"i"),Ya=new RegExp(`^#${Fa("([a-f0-9]{2})",3)}([a-f0-9]{2})?$`,"i"),$a=new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${Fa(",\\s*(\\d+)\\s*",2)}(?:,\\s*([\\d.]+))?\\s*\\)$`,"i"),Ha=/^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i,Ua=/^[a-z]+$/i,za=e=>Math.round(255*e),Wa=(e,t,n)=>{let r=n/100;if(0===t)return[r,r,r].map(za);const o=(e%360+360)%360/60,i=(1-Math.abs(2*r-1))*(t/100),a=i*(1-Math.abs(o%2-1));let s=0,l=0,c=0;o>=0&&o<1?(s=i,l=a):o>=1&&o<2?(s=a,l=i):o>=2&&o<3?(l=i,c=a):o>=3&&o<4?(l=a,c=i):o>=4&&o<5?(s=a,c=i):o>=5&&o<6&&(s=i,c=a);const u=r-i/2;return[s+u,l+u,c+u].map(za)};function Va(e,t,n,r){return`rgba(${La(0,255,e).toFixed()}, ${La(0,255,t).toFixed()}, ${La(0,255,n).toFixed()}, ${parseFloat(La(0,1,r).toFixed(3))})`}function Ga(e,t){const[n,r,o,i]=Ba(e);return Va(n,r,o,i-t)}var Qa=(e,t,n)=>{const r=function(e,t,n,r,o){for(t=t.split?t.split("."):t,r=0;r<t.length;r++)e=e?e[t[r]]:o;return e===o?n:e}(e,`colors.${t}`,t);try{return function(e){const[t,n,r,o]=Ba(e);let i=e=>{const t=La(0,255,e).toString(16);return 1===t.length?`0${t}`:t};i(t),i(n),i(r),o<1&&i(Math.round(255*o))}(r),r}catch{return null!=n?n:"#000000"}},qa=e=>t=>{const n=(e=>{const[t,n,r]=Ba(e);return(299*t+587*n+114*r)/1e3})(Qa(t,e));return n<128?"dark":"light"},Ka=(e,t)=>n=>Ga(Qa(n,e),1-t);function Za(e="1rem",t="rgba(255, 255, 255, 0.15)"){return{backgroundImage:`linear-gradient(\n    45deg,\n    ${t} 25%,\n    transparent 25%,\n    transparent 50%,\n    ${t} 50%,\n    ${t} 75%,\n    transparent 75%,\n    transparent\n  )`,backgroundSize:`${e} ${e}`}}function Ja(e){const t=`#${Math.floor(16777215*Math.random()).toString(16).padEnd(6,"0")}`;return e&&(n=e,0!==Object.keys(n).length)?e.string&&e.colors?function(e,t){let n=0;if(0===e.length)return t[0];for(let t=0;t<e.length;t+=1)n=e.charCodeAt(t)+((n<<5)-n),n|=0;return n=(n%t.length+t.length)%t.length,t[n]}(e.string,e.colors):e.string&&!e.colors?function(e){let t=0;if(0===e.length)return t.toString();for(let n=0;n<e.length;n+=1)t=e.charCodeAt(n)+((t<<5)-t),t|=0;let n="#";for(let e=0;e<3;e+=1){n+=`00${(t>>8*e&255).toString(16)}`.substr(-2)}return n}(e.string):e.colors&&!e.string?function(e){return e[Math.floor(Math.random()*e.length)]}(e.colors):t:t;var n}var Xa=ke("tabs-color"),es=ke("tabs-bg"),ts=ke("tabs-border-color"),{defineMultiStyleConfig:ns,definePartsStyle:rs}=ct(qi.keys),os=e=>{const{orientation:t}=e;return{display:"vertical"===t?"flex":"block"}},is=e=>{const{isFitted:t}=e;return{flex:t?1:void 0,transitionProperty:"common",transitionDuration:"normal",_focusVisible:{zIndex:1,boxShadow:"outline"},_disabled:{cursor:"not-allowed",opacity:.4}}},as=e=>{const{align:t="start",orientation:n}=e;return{justifyContent:{end:"flex-end",center:"center",start:"flex-start"}[t],flexDirection:"vertical"===n?"column":"row"}},ss={p:4},ls=rs((e=>({root:os(e),tab:is(e),tablist:as(e),tabpanel:ss}))),cs={sm:rs({tab:{py:1,px:4,fontSize:"sm"}}),md:rs({tab:{fontSize:"md",py:2,px:4}}),lg:rs({tab:{fontSize:"lg",py:3,px:4}})},us=rs((e=>{const{colorScheme:t,orientation:n}=e,r="vertical"===n,o=r?"borderStart":"borderBottom",i=r?"marginStart":"marginBottom";return{tablist:{[o]:"2px solid",borderColor:"inherit"},tab:{[o]:"2px solid",borderColor:"transparent",[i]:"-2px",_selected:{[Xa.variable]:`colors.${t}.600`,_dark:{[Xa.variable]:`colors.${t}.300`},borderColor:"currentColor"},_active:{[es.variable]:"colors.gray.200",_dark:{[es.variable]:"colors.whiteAlpha.300"}},_disabled:{_active:{bg:"none"}},color:Xa.reference,bg:es.reference}}})),ds=rs((e=>{const{colorScheme:t}=e;return{tab:{borderTopRadius:"md",border:"1px solid",borderColor:"transparent",mb:"-1px",[ts.variable]:"transparent",_selected:{[Xa.variable]:`colors.${t}.600`,[ts.variable]:"colors.white",_dark:{[Xa.variable]:`colors.${t}.300`,[ts.variable]:"colors.gray.800"},borderColor:"inherit",borderBottomColor:ts.reference},color:Xa.reference},tablist:{mb:"-1px",borderBottom:"1px solid",borderColor:"inherit"}}})),ps=rs((e=>{const{colorScheme:t}=e;return{tab:{border:"1px solid",borderColor:"inherit",[es.variable]:"colors.gray.50",_dark:{[es.variable]:"colors.whiteAlpha.50"},mb:"-1px",_notLast:{marginEnd:"-1px"},_selected:{[es.variable]:"colors.white",[Xa.variable]:`colors.${t}.600`,_dark:{[es.variable]:"colors.gray.800",[Xa.variable]:`colors.${t}.300`},borderColor:"inherit",borderTopColor:"currentColor",borderBottomColor:"transparent"},color:Xa.reference,bg:es.reference},tablist:{mb:"-1px",borderBottom:"1px solid",borderColor:"inherit"}}})),fs=rs((e=>{const{colorScheme:t,theme:n}=e;return{tab:{borderRadius:"full",fontWeight:"semibold",color:"gray.600",_selected:{color:Qa(n,`${t}.700`),bg:Qa(n,`${t}.100`)}}}})),hs=rs((e=>{const{colorScheme:t}=e;return{tab:{borderRadius:"full",fontWeight:"semibold",[Xa.variable]:"colors.gray.600",_dark:{[Xa.variable]:"inherit"},_selected:{[Xa.variable]:"colors.white",[es.variable]:`colors.${t}.600`,_dark:{[Xa.variable]:"colors.gray.800",[es.variable]:`colors.${t}.300`}},color:Xa.reference,bg:es.reference}}})),ms=ns({baseStyle:ls,sizes:cs,variants:{line:us,enclosed:ds,"enclosed-colored":ps,"soft-rounded":fs,"solid-rounded":hs,unstyled:rs({})},defaultProps:{size:"md",variant:"line",colorScheme:"blue"}}),gs=function(e,t){const n={};for(const r of t)if(Array.isArray(r)){const[t,o]=r;n[t]=ke(`${e}-${t}`,o)}else n[r]=ke(`${e}-${r}`);return n}("badge",["bg","color","shadow"]),vs=e=>{const{colorScheme:t,theme:n}=e,r=Ka(`${t}.500`,.6)(n);return{[gs.bg.variable]:`colors.${t}.500`,[gs.color.variable]:"colors.white",_dark:{[gs.bg.variable]:r,[gs.color.variable]:"colors.whiteAlpha.800"}}},ys=e=>{const{colorScheme:t,theme:n}=e,r=Ka(`${t}.200`,.16)(n);return{[gs.bg.variable]:`colors.${t}.100`,[gs.color.variable]:`colors.${t}.800`,_dark:{[gs.bg.variable]:r,[gs.color.variable]:`colors.${t}.200`}}},bs=e=>{const{colorScheme:t,theme:n}=e,r=Ka(`${t}.200`,.8)(n);return{[gs.color.variable]:`colors.${t}.500`,_dark:{[gs.color.variable]:r},[gs.shadow.variable]:`inset 0 0 0px 1px ${gs.color.reference}`}},_s={baseStyle:{px:1,textTransform:"uppercase",fontSize:"xs",borderRadius:"sm",fontWeight:"bold",bg:gs.bg.reference,color:gs.color.reference,boxShadow:gs.shadow.reference},variants:{solid:vs,subtle:ys,outline:bs},defaultProps:{variant:"subtle",colorScheme:"gray"}},{defineMultiStyleConfig:As,definePartsStyle:Es}=ct(Ki.keys),ws=ke("tag-bg"),xs=ke("tag-color"),ks=ke("tag-shadow"),Cs=ke("tag-min-height"),Ss=ke("tag-min-width"),Ms=ke("tag-font-size"),Ts=ke("tag-padding-inline"),Os=Es({container:{fontWeight:"medium",lineHeight:1.2,outline:0,[xs.variable]:gs.color.reference,[ws.variable]:gs.bg.reference,[ks.variable]:gs.shadow.reference,color:xs.reference,bg:ws.reference,boxShadow:ks.reference,borderRadius:"md",minH:Cs.reference,minW:Ss.reference,fontSize:Ms.reference,px:Ts.reference,_focusVisible:{[ks.variable]:"shadows.outline"}},label:{lineHeight:1.2,overflow:"visible"},closeButton:{fontSize:"lg",w:"5",h:"5",transitionProperty:"common",transitionDuration:"normal",borderRadius:"full",marginStart:"1.5",marginEnd:"-1",opacity:.5,_disabled:{opacity:.4},_focusVisible:{boxShadow:"outline",bg:"rgba(0, 0, 0, 0.14)"},_hover:{opacity:.8},_active:{opacity:1}}}),Ds={sm:Es({container:{[Cs.variable]:"sizes.5",[Ss.variable]:"sizes.5",[Ms.variable]:"fontSizes.xs",[Ts.variable]:"space.2"},closeButton:{marginEnd:"-2px",marginStart:"0.35rem"}}),md:Es({container:{[Cs.variable]:"sizes.6",[Ss.variable]:"sizes.6",[Ms.variable]:"fontSizes.sm",[Ts.variable]:"space.2"}}),lg:Es({container:{[Cs.variable]:"sizes.8",[Ss.variable]:"sizes.8",[Ms.variable]:"fontSizes.md",[Ts.variable]:"space.3"}})},Ls={subtle:Es((e=>{var t;return{container:null==(t=_s.variants)?void 0:t.subtle(e)}})),solid:Es((e=>{var t;return{container:null==(t=_s.variants)?void 0:t.solid(e)}})),outline:Es((e=>{var t;return{container:null==(t=_s.variants)?void 0:t.outline(e)}}))},Ps=As({variants:Ls,baseStyle:Os,sizes:Ds,defaultProps:{size:"md",variant:"subtle",colorScheme:"gray"}}),{definePartsStyle:Is,defineMultiStyleConfig:Bs}=ct(Ri.keys),Rs=ke("input-height"),Ns=ke("input-font-size"),Fs=ke("input-padding"),js=ke("input-border-radius"),Ys=Is({addon:{height:Rs.reference,fontSize:Ns.reference,px:Fs.reference,borderRadius:js.reference},field:{width:"100%",height:Rs.reference,fontSize:Ns.reference,px:Fs.reference,borderRadius:js.reference,minWidth:0,outline:0,position:"relative",appearance:"none",transitionProperty:"common",transitionDuration:"normal",_disabled:{opacity:.4,cursor:"not-allowed"}}}),$s={lg:{[Ns.variable]:"fontSizes.lg",[Fs.variable]:"space.4",[js.variable]:"radii.md",[Rs.variable]:"sizes.12"},md:{[Ns.variable]:"fontSizes.md",[Fs.variable]:"space.4",[js.variable]:"radii.md",[Rs.variable]:"sizes.10"},sm:{[Ns.variable]:"fontSizes.sm",[Fs.variable]:"space.3",[js.variable]:"radii.sm",[Rs.variable]:"sizes.8"},xs:{[Ns.variable]:"fontSizes.xs",[Fs.variable]:"space.2",[js.variable]:"radii.sm",[Rs.variable]:"sizes.6"}},Hs={lg:Is({field:$s.lg,group:$s.lg}),md:Is({field:$s.md,group:$s.md}),sm:Is({field:$s.sm,group:$s.sm}),xs:Is({field:$s.xs,group:$s.xs})};function Us(e){const{focusBorderColor:t,errorBorderColor:n}=e;return{focusBorderColor:t||wa("blue.500","blue.300")(e),errorBorderColor:n||wa("red.500","red.300")(e)}}var zs,Ws,Vs,Gs,Qs,qs,Ks,Zs,Js,Xs,el,tl=Is((e=>{const{theme:t}=e,{focusBorderColor:n,errorBorderColor:r}=Us(e);return{field:{border:"1px solid",borderColor:"inherit",bg:"inherit",_hover:{borderColor:wa("gray.300","whiteAlpha.400")(e)},_readOnly:{boxShadow:"none !important",userSelect:"all"},_invalid:{borderColor:Qa(t,r),boxShadow:`0 0 0 1px ${Qa(t,r)}`},_focusVisible:{zIndex:1,borderColor:Qa(t,n),boxShadow:`0 0 0 1px ${Qa(t,n)}`}},addon:{border:"1px solid",borderColor:wa("inherit","whiteAlpha.50")(e),bg:wa("gray.100","whiteAlpha.300")(e)}}})),nl=Is((e=>{const{theme:t}=e,{focusBorderColor:n,errorBorderColor:r}=Us(e);return{field:{border:"2px solid",borderColor:"transparent",bg:wa("gray.100","whiteAlpha.50")(e),_hover:{bg:wa("gray.200","whiteAlpha.100")(e)},_readOnly:{boxShadow:"none !important",userSelect:"all"},_invalid:{borderColor:Qa(t,r)},_focusVisible:{bg:"transparent",borderColor:Qa(t,n)}},addon:{border:"2px solid",borderColor:"transparent",bg:wa("gray.100","whiteAlpha.50")(e)}}})),rl=Is((e=>{const{theme:t}=e,{focusBorderColor:n,errorBorderColor:r}=Us(e);return{field:{borderBottom:"1px solid",borderColor:"inherit",borderRadius:"0",px:"0",bg:"transparent",_readOnly:{boxShadow:"none !important",userSelect:"all"},_invalid:{borderColor:Qa(t,r),boxShadow:`0px 1px 0px 0px ${Qa(t,r)}`},_focusVisible:{borderColor:Qa(t,n),boxShadow:`0px 1px 0px 0px ${Qa(t,n)}`}},addon:{borderBottom:"2px solid",borderColor:"inherit",borderRadius:"0",px:"0",bg:"transparent"}}})),ol=Bs({baseStyle:Ys,sizes:Hs,variants:{outline:tl,filled:nl,flushed:rl,unstyled:Is({field:{bg:"transparent",px:"0",height:"auto"},addon:{bg:"transparent",px:"0",height:"auto"}})},defaultProps:{size:"md",variant:"outline"}}),il={...null==(zs=ol.baseStyle)?void 0:zs.field,paddingY:"2",minHeight:"20",lineHeight:"short",verticalAlign:"top"},al={outline:e=>{var t,n;return null!=(n=null==(t=ol.variants)?void 0:t.outline(e).field)?n:{}},flushed:e=>{var t,n;return null!=(n=null==(t=ol.variants)?void 0:t.flushed(e).field)?n:{}},filled:e=>{var t,n;return null!=(n=null==(t=ol.variants)?void 0:t.filled(e).field)?n:{}},unstyled:null!=(Vs=null==(Ws=ol.variants)?void 0:Ws.unstyled.field)?Vs:{}},sl={baseStyle:il,sizes:{xs:null!=(Qs=null==(Gs=ol.sizes)?void 0:Gs.xs.field)?Qs:{},sm:null!=(Ks=null==(qs=ol.sizes)?void 0:qs.sm.field)?Ks:{},md:null!=(Js=null==(Zs=ol.sizes)?void 0:Zs.md.field)?Js:{},lg:null!=(el=null==(Xs=ol.sizes)?void 0:Xs.lg.field)?el:{}},variants:al,defaultProps:{size:"md",variant:"outline"}},ll=na("tooltip-bg"),cl=na("tooltip-fg"),ul=na("popper-arrow-bg"),dl={baseStyle:{bg:ll.reference,color:cl.reference,[ll.variable]:"colors.gray.700",[cl.variable]:"colors.whiteAlpha.900",_dark:{[ll.variable]:"colors.gray.300",[cl.variable]:"colors.gray.900"},[ul.variable]:ll.reference,px:"2",py:"0.5",borderRadius:"sm",fontWeight:"medium",fontSize:"sm",boxShadow:"md",maxW:"xs",zIndex:"tooltip"}},{defineMultiStyleConfig:pl,definePartsStyle:fl}=ct(Hi.keys),hl=e=>{const{colorScheme:t,theme:n,isIndeterminate:r,hasStripe:o}=e,i=wa(Za(),Za("1rem","rgba(0,0,0,0.1)"))(e),a=wa(`${t}.500`,`${t}.200`)(e),s=`linear-gradient(\n    to right,\n    transparent 0%,\n    ${Qa(n,a)} 50%,\n    transparent 100%\n  )`;return{...!r&&o&&i,...r?{bgImage:s}:{bgColor:a}}},ml={lineHeight:"1",fontSize:"0.25em",fontWeight:"bold",color:"white"},gl=e=>({bg:wa("gray.100","whiteAlpha.300")(e)}),vl=e=>({transitionProperty:"common",transitionDuration:"slow",...hl(e)}),yl=fl((e=>({label:ml,filledTrack:vl(e),track:gl(e)}))),bl=pl({sizes:{xs:fl({track:{h:"1"}}),sm:fl({track:{h:"2"}}),md:fl({track:{h:"3"}}),lg:fl({track:{h:"4"}})},baseStyle:yl,defaultProps:{size:"md",colorScheme:"blue"}});function _l(e,...t){return"function"==typeof e?e(...t):e}var Al,El,wl,xl,kl,Cl,Sl,Ml,Tl,{definePartsStyle:Ol,defineMultiStyleConfig:Dl}=ct(Di.keys),Ll=ke("checkbox-size"),Pl=e=>{const{colorScheme:t}=e;return{w:Ll.reference,h:Ll.reference,transitionProperty:"box-shadow",transitionDuration:"normal",border:"2px solid",borderRadius:"sm",borderColor:"inherit",color:"white",_checked:{bg:wa(`${t}.500`,`${t}.200`)(e),borderColor:wa(`${t}.500`,`${t}.200`)(e),color:wa("white","gray.900")(e),_hover:{bg:wa(`${t}.600`,`${t}.300`)(e),borderColor:wa(`${t}.600`,`${t}.300`)(e)},_disabled:{borderColor:wa("gray.200","transparent")(e),bg:wa("gray.200","whiteAlpha.300")(e),color:wa("gray.500","whiteAlpha.500")(e)}},_indeterminate:{bg:wa(`${t}.500`,`${t}.200`)(e),borderColor:wa(`${t}.500`,`${t}.200`)(e),color:wa("white","gray.900")(e)},_disabled:{bg:wa("gray.100","whiteAlpha.100")(e),borderColor:wa("gray.100","transparent")(e)},_focusVisible:{boxShadow:"outline"},_invalid:{borderColor:wa("red.500","red.300")(e)}}},Il={_disabled:{cursor:"not-allowed"}},Bl={userSelect:"none",_disabled:{opacity:.4}},Rl={transitionProperty:"transform",transitionDuration:"normal"},Nl=Dl({baseStyle:Ol((e=>({icon:Rl,container:Il,control:_l(Pl,e),label:Bl}))),sizes:{sm:Ol({control:{[Ll.variable]:"sizes.3"},label:{fontSize:"sm"},icon:{fontSize:"3xs"}}),md:Ol({control:{[Ll.variable]:"sizes.4"},label:{fontSize:"md"},icon:{fontSize:"2xs"}}),lg:Ol({control:{[Ll.variable]:"sizes.5"},label:{fontSize:"lg"},icon:{fontSize:"2xs"}})},defaultProps:{size:"md",colorScheme:"blue"}}),{defineMultiStyleConfig:Fl,definePartsStyle:jl}=ct(Ui.keys),Yl=e=>{var t;const n=null==(t=_l(Nl.baseStyle,e))?void 0:t.control;return{...n,borderRadius:"full",_checked:{...null==n?void 0:n._checked,_before:{content:'""',display:"inline-block",pos:"relative",w:"50%",h:"50%",borderRadius:"50%",bg:"currentColor"}}}},$l=jl((e=>{var t,n,r,o;return{label:null==(n=(t=Nl).baseStyle)?void 0:n.call(t,e).label,container:null==(o=(r=Nl).baseStyle)?void 0:o.call(r,e).container,control:Yl(e)}})),Hl=Fl({baseStyle:$l,sizes:{md:jl({control:{w:"4",h:"4"},label:{fontSize:"md"}}),lg:jl({control:{w:"5",h:"5"},label:{fontSize:"lg"}}),sm:jl({control:{width:"3",height:"3"},label:{fontSize:"sm"}})},defaultProps:{size:"md",colorScheme:"blue"}}),{defineMultiStyleConfig:Ul,definePartsStyle:zl}=ct(zi.keys),Wl=ke("select-bg"),Vl={paddingInlineEnd:"8"},Gl=Ul({baseStyle:zl({field:{...null==(Al=ol.baseStyle)?void 0:Al.field,appearance:"none",paddingBottom:"1px",lineHeight:"normal",bg:Wl.reference,[Wl.variable]:"colors.white",_dark:{[Wl.variable]:"colors.gray.700"},"> option, > optgroup":{bg:Wl.reference}},icon:{width:"6",height:"100%",insetEnd:"2",position:"relative",color:"currentColor",fontSize:"xl",_disabled:{opacity:.5}}}),sizes:{lg:{...null==(El=ol.sizes)?void 0:El.lg,field:{...null==(wl=ol.sizes)?void 0:wl.lg.field,...Vl}},md:{...null==(xl=ol.sizes)?void 0:xl.md,field:{...null==(kl=ol.sizes)?void 0:kl.md.field,...Vl}},sm:{...null==(Cl=ol.sizes)?void 0:Cl.sm,field:{...null==(Sl=ol.sizes)?void 0:Sl.sm.field,...Vl}},xs:{...null==(Ml=ol.sizes)?void 0:Ml.xs,field:{...null==(Tl=ol.sizes)?void 0:Tl.xs.field,...Vl},icon:{insetEnd:"1"}}},variants:ol.variants,defaultProps:ol.defaultProps}),Ql=ke("skeleton-start-color"),ql=ke("skeleton-end-color"),Kl={baseStyle:{[Ql.variable]:"colors.gray.100",[ql.variable]:"colors.gray.400",_dark:{[Ql.variable]:"colors.gray.800",[ql.variable]:"colors.gray.600"},background:Ql.reference,borderColor:ql.reference,opacity:.7,borderRadius:"sm"}},Zl=ke("skip-link-bg"),Jl={baseStyle:{borderRadius:"md",fontWeight:"semibold",_focusVisible:{boxShadow:"outline",padding:"4",position:"fixed",top:"6",insetStart:"6",[Zl.variable]:"colors.white",_dark:{[Zl.variable]:"colors.gray.700"},bg:Zl.reference}}},{defineMultiStyleConfig:Xl,definePartsStyle:ec}=ct(Wi.keys),tc=ke("slider-thumb-size"),nc=ke("slider-track-size"),rc=ke("slider-bg"),oc=e=>{const{orientation:t}=e;return{display:"inline-block",position:"relative",cursor:"pointer",_disabled:{opacity:.6,cursor:"default",pointerEvents:"none"},...xa({orientation:t,vertical:{h:"100%"},horizontal:{w:"100%"}})}},ic=e=>({...xa({orientation:e.orientation,horizontal:{h:nc.reference},vertical:{w:nc.reference}}),overflow:"hidden",borderRadius:"sm",[rc.variable]:"colors.gray.200",_dark:{[rc.variable]:"colors.whiteAlpha.200"},_disabled:{[rc.variable]:"colors.gray.300",_dark:{[rc.variable]:"colors.whiteAlpha.300"}},bg:rc.reference}),ac=e=>{const{orientation:t}=e;return{...xa({orientation:t,vertical:{left:"50%",transform:"translateX(-50%)",_active:{transform:"translateX(-50%) scale(1.15)"}},horizontal:{top:"50%",transform:"translateY(-50%)",_active:{transform:"translateY(-50%) scale(1.15)"}}}),w:tc.reference,h:tc.reference,display:"flex",alignItems:"center",justifyContent:"center",position:"absolute",outline:0,zIndex:1,borderRadius:"full",bg:"white",boxShadow:"base",border:"1px solid",borderColor:"transparent",transitionProperty:"transform",transitionDuration:"normal",_focusVisible:{boxShadow:"outline"},_disabled:{bg:"gray.300"}}},sc=e=>{const{colorScheme:t}=e;return{width:"inherit",height:"inherit",[rc.variable]:`colors.${t}.500`,_dark:{[rc.variable]:`colors.${t}.200`},bg:rc.reference}},lc=Xl({baseStyle:ec((e=>({container:oc(e),track:ic(e),thumb:ac(e),filledTrack:sc(e)}))),sizes:{lg:ec({container:{[tc.variable]:"sizes.4",[nc.variable]:"sizes.1"}}),md:ec({container:{[tc.variable]:"sizes.3.5",[nc.variable]:"sizes.1"}}),sm:ec({container:{[tc.variable]:"sizes.2.5",[nc.variable]:"sizes.0.5"}})},defaultProps:{size:"md",colorScheme:"blue"}}),cc=na("spinner-size"),uc={baseStyle:{width:[cc.reference],height:[cc.reference]},sizes:{xs:{[cc.variable]:"sizes.3"},sm:{[cc.variable]:"sizes.4"},md:{[cc.variable]:"sizes.6"},lg:{[cc.variable]:"sizes.8"},xl:{[cc.variable]:"sizes.12"}},defaultProps:{size:"md"}},{defineMultiStyleConfig:dc,definePartsStyle:pc}=ct(Vi.keys),fc=dc({baseStyle:pc({container:{},label:{fontWeight:"medium"},helpText:{opacity:.8,marginBottom:"2"},number:{verticalAlign:"baseline",fontWeight:"semibold"},icon:{marginEnd:1,w:"3.5",h:"3.5",verticalAlign:"middle"}}),sizes:{md:pc({label:{fontSize:"sm"},helpText:{fontSize:"sm"},number:{fontSize:"2xl"}})},defaultProps:{size:"md"}}),hc=ke("kbd-bg"),mc={baseStyle:{[hc.variable]:"colors.gray.100",_dark:{[hc.variable]:"colors.whiteAlpha.100"},bg:hc.reference,borderRadius:"md",borderWidth:"1px",borderBottomWidth:"3px",fontSize:"0.8em",fontWeight:"bold",lineHeight:"normal",px:"0.4em",whiteSpace:"nowrap"}},gc={baseStyle:{transitionProperty:"common",transitionDuration:"fast",transitionTimingFunction:"ease-out",cursor:"pointer",textDecoration:"none",outline:"none",color:"inherit",_hover:{textDecoration:"underline"},_focusVisible:{boxShadow:"outline"}}},{defineMultiStyleConfig:vc,definePartsStyle:yc}=ct(Ni.keys),bc=vc({baseStyle:yc({icon:{marginEnd:"2",display:"inline",verticalAlign:"text-bottom"}})}),{defineMultiStyleConfig:_c,definePartsStyle:Ac}=ct(Fi.keys),Ec=ke("menu-bg"),wc=ke("menu-shadow"),xc=_c({baseStyle:Ac({button:{transitionProperty:"common",transitionDuration:"normal"},list:{[Ec.variable]:"#fff",[wc.variable]:"shadows.sm",_dark:{[Ec.variable]:"colors.gray.700",[wc.variable]:"shadows.dark-lg"},color:"inherit",minW:"3xs",py:"2",zIndex:1,borderRadius:"md",borderWidth:"1px",bg:Ec.reference,boxShadow:wc.reference},item:{py:"1.5",px:"3",transitionProperty:"background",transitionDuration:"ultra-fast",transitionTimingFunction:"ease-in",_focus:{[Ec.variable]:"colors.gray.100",_dark:{[Ec.variable]:"colors.whiteAlpha.100"}},_active:{[Ec.variable]:"colors.gray.200",_dark:{[Ec.variable]:"colors.whiteAlpha.200"}},_expanded:{[Ec.variable]:"colors.gray.100",_dark:{[Ec.variable]:"colors.whiteAlpha.100"}},_disabled:{opacity:.4,cursor:"not-allowed"},bg:Ec.reference},groupTitle:{mx:4,my:2,fontWeight:"semibold",fontSize:"sm"},icon:{display:"inline-flex",alignItems:"center",justifyContent:"center",flexShrink:0},command:{opacity:.6},divider:{border:0,borderBottom:"1px solid",borderColor:"inherit",my:"2",opacity:.6}})}),{defineMultiStyleConfig:kc,definePartsStyle:Cc}=ct(ji.keys),Sc=ke("modal-bg"),Mc=ke("modal-shadow"),Tc={bg:"blackAlpha.600",zIndex:"modal"},Oc=e=>{const{isCentered:t,scrollBehavior:n}=e;return{display:"flex",zIndex:"modal",justifyContent:"center",alignItems:t?"center":"flex-start",overflow:"inside"===n?"hidden":"auto",overscrollBehaviorY:"none"}},Dc=e=>{const{isCentered:t,scrollBehavior:n}=e;return{borderRadius:"md",color:"inherit",my:t?"auto":"16",mx:t?"auto":void 0,zIndex:"modal",maxH:"inside"===n?"calc(100% - 7.5rem)":void 0,[Sc.variable]:"colors.white",[Mc.variable]:"shadows.lg",_dark:{[Sc.variable]:"colors.gray.700",[Mc.variable]:"shadows.dark-lg"},bg:Sc.reference,boxShadow:Mc.reference}},Lc={px:"6",py:"4",fontSize:"xl",fontWeight:"semibold"},Pc={position:"absolute",top:"2",insetEnd:"3"},Ic=e=>{const{scrollBehavior:t}=e;return{px:"6",py:"2",flex:"1",overflow:"inside"===t?"auto":void 0}},Bc={px:"6",py:"4"};function Rc(e){return Cc("full"===e?{dialog:{maxW:"100vw",minH:"$100vh",my:"0",borderRadius:"0"}}:{dialog:{maxW:e}})}var Nc=kc({baseStyle:Cc((e=>({overlay:Tc,dialogContainer:_l(Oc,e),dialog:_l(Dc,e),header:Lc,closeButton:Pc,body:_l(Ic,e),footer:Bc}))),sizes:{xs:Rc("xs"),sm:Rc("sm"),md:Rc("md"),lg:Rc("lg"),xl:Rc("xl"),"2xl":Rc("2xl"),"3xl":Rc("3xl"),"4xl":Rc("4xl"),"5xl":Rc("5xl"),"6xl":Rc("6xl"),full:Rc("full")},defaultProps:{size:"md"}}),{defineMultiStyleConfig:Fc,definePartsStyle:jc}=ct(Yi.keys),Yc=na("number-input-stepper-width"),$c=na("number-input-input-padding"),Hc=da(Yc).add("0.5rem").toString(),Uc=na("number-input-bg"),zc=na("number-input-color"),Wc=na("number-input-border-color"),Vc={[Yc.variable]:"sizes.6",[$c.variable]:Hc},Gc=e=>{var t,n;return null!=(n=null==(t=_l(ol.baseStyle,e))?void 0:t.field)?n:{}},Qc={width:Yc.reference},qc={borderStart:"1px solid",borderStartColor:Wc.reference,color:zc.reference,bg:Uc.reference,[zc.variable]:"colors.chakra-body-text",[Wc.variable]:"colors.chakra-border-color",_dark:{[zc.variable]:"colors.whiteAlpha.800",[Wc.variable]:"colors.whiteAlpha.300"},_active:{[Uc.variable]:"colors.gray.200",_dark:{[Uc.variable]:"colors.whiteAlpha.300"}},_disabled:{opacity:.4,cursor:"not-allowed"}},Kc=jc((e=>{var t;return{root:Vc,field:null!=(t=_l(Gc,e))?t:{},stepperGroup:Qc,stepper:qc}}));function Zc(e){var t,n,r;const o=null==(t=ol.sizes)?void 0:t[e],i={lg:"md",md:"md",sm:"sm",xs:"sm"},a=null!=(r=null==(n=o.field)?void 0:n.fontSize)?r:"md",s=fi.fontSizes[a];return jc({field:{...o.field,paddingInlineEnd:$c.reference,verticalAlign:"top"},stepper:{fontSize:da(s).multiply(.75).toString(),_first:{borderTopEndRadius:i[e]},_last:{borderBottomEndRadius:i[e],mt:"-1px",borderTopWidth:1}}})}var Jc,Xc,eu,tu=Fc({baseStyle:Kc,sizes:{xs:Zc("xs"),sm:Zc("sm"),md:Zc("md"),lg:Zc("lg")},variants:ol.variants,defaultProps:ol.defaultProps}),nu={...null==(Jc=ol.baseStyle)?void 0:Jc.field,textAlign:"center"},ru={lg:{fontSize:"lg",w:12,h:12,borderRadius:"md"},md:{fontSize:"md",w:10,h:10,borderRadius:"md"},sm:{fontSize:"sm",w:8,h:8,borderRadius:"sm"},xs:{fontSize:"xs",w:6,h:6,borderRadius:"sm"}},ou={outline:e=>{var t,n,r;return null!=(r=null==(n=_l(null==(t=ol.variants)?void 0:t.outline,e))?void 0:n.field)?r:{}},flushed:e=>{var t,n,r;return null!=(r=null==(n=_l(null==(t=ol.variants)?void 0:t.flushed,e))?void 0:n.field)?r:{}},filled:e=>{var t,n,r;return null!=(r=null==(n=_l(null==(t=ol.variants)?void 0:t.filled,e))?void 0:n.field)?r:{}},unstyled:null!=(eu=null==(Xc=ol.variants)?void 0:Xc.unstyled.field)?eu:{}},iu={baseStyle:nu,sizes:ru,variants:ou,defaultProps:ol.defaultProps},{defineMultiStyleConfig:au,definePartsStyle:su}=ct($i.keys),lu=na("popper-bg"),cu=na("popper-arrow-bg"),uu=na("popper-arrow-shadow-color"),du=au({baseStyle:su({popper:{zIndex:10},content:{[lu.variable]:"colors.white",bg:lu.reference,[cu.variable]:lu.reference,[uu.variable]:"colors.gray.200",_dark:{[lu.variable]:"colors.gray.700",[uu.variable]:"colors.whiteAlpha.300"},width:"xs",border:"1px solid",borderColor:"inherit",borderRadius:"md",boxShadow:"sm",zIndex:"inherit",_focusVisible:{outline:0,boxShadow:"outline"}},header:{px:3,py:2,borderBottomWidth:"1px"},body:{px:3,py:2},footer:{px:3,py:2,borderTopWidth:"1px"},closeButton:{position:"absolute",borderRadius:"md",top:1,insetEnd:2,padding:2}})}),{definePartsStyle:pu,defineMultiStyleConfig:fu}=ct(Li.keys),hu=ke("drawer-bg"),mu=ke("drawer-box-shadow");function gu(e){return pu("full"===e?{dialog:{maxW:"100vw",h:"100vh"}}:{dialog:{maxW:e}})}var vu={bg:"blackAlpha.600",zIndex:"modal"},yu={display:"flex",zIndex:"modal",justifyContent:"center"},bu=e=>{const{isFullHeight:t}=e;return{...t&&{height:"100vh"},zIndex:"modal",maxH:"100vh",color:"inherit",[hu.variable]:"colors.white",[mu.variable]:"shadows.lg",_dark:{[hu.variable]:"colors.gray.700",[mu.variable]:"shadows.dark-lg"},bg:hu.reference,boxShadow:mu.reference}},_u={px:"6",py:"4",fontSize:"xl",fontWeight:"semibold"},Au={position:"absolute",top:"2",insetEnd:"3"},Eu={px:"6",py:"2",flex:"1",overflow:"auto"},wu={px:"6",py:"4"},xu=fu({baseStyle:pu((e=>({overlay:vu,dialogContainer:yu,dialog:_l(bu,e),header:_u,closeButton:Au,body:Eu,footer:wu}))),sizes:{xs:gu("xs"),sm:gu("md"),md:gu("lg"),lg:gu("2xl"),xl:gu("4xl"),full:gu("full")},defaultProps:{size:"xs"}}),{definePartsStyle:ku,defineMultiStyleConfig:Cu}=ct(Pi.keys),Su=Cu({baseStyle:ku({preview:{borderRadius:"md",py:"1",transitionProperty:"common",transitionDuration:"normal"},input:{borderRadius:"md",py:"1",transitionProperty:"common",transitionDuration:"normal",width:"full",_focusVisible:{boxShadow:"outline"},_placeholder:{opacity:.6}},textarea:{borderRadius:"md",py:"1",transitionProperty:"common",transitionDuration:"normal",width:"full",_focusVisible:{boxShadow:"outline"},_placeholder:{opacity:.6}}})}),{definePartsStyle:Mu,defineMultiStyleConfig:Tu}=ct(Ii.keys),Ou=ke("form-control-color"),Du=Tu({baseStyle:Mu({container:{width:"100%",position:"relative"},requiredIndicator:{marginStart:"1",[Ou.variable]:"colors.red.500",_dark:{[Ou.variable]:"colors.red.300"},color:Ou.reference},helperText:{mt:"2",[Ou.variable]:"colors.gray.600",_dark:{[Ou.variable]:"colors.whiteAlpha.600"},color:Ou.reference,lineHeight:"normal",fontSize:"sm"}})}),{definePartsStyle:Lu,defineMultiStyleConfig:Pu}=ct(Bi.keys),Iu=ke("form-error-color"),Bu=Pu({baseStyle:Lu({text:{[Iu.variable]:"colors.red.500",_dark:{[Iu.variable]:"colors.red.300"},color:Iu.reference,mt:"2",fontSize:"sm",lineHeight:"normal"},icon:{marginEnd:"0.5em",[Iu.variable]:"colors.red.500",_dark:{[Iu.variable]:"colors.red.300"},color:Iu.reference}})}),Ru={baseStyle:{fontSize:"md",marginEnd:"3",mb:"2",fontWeight:"medium",transitionProperty:"common",transitionDuration:"normal",opacity:1,_disabled:{opacity:.4}}},Nu={baseStyle:{fontFamily:"heading",fontWeight:"bold"},sizes:{"4xl":{fontSize:["6xl",null,"7xl"],lineHeight:1},"3xl":{fontSize:["5xl",null,"6xl"],lineHeight:1},"2xl":{fontSize:["4xl",null,"5xl"],lineHeight:[1.2,null,1]},xl:{fontSize:["3xl",null,"4xl"],lineHeight:[1.33,null,1.2]},lg:{fontSize:["2xl",null,"3xl"],lineHeight:[1.33,null,1.2]},md:{fontSize:"xl",lineHeight:1.2},sm:{fontSize:"md",lineHeight:1.2},xs:{fontSize:"sm",lineHeight:1.2}},defaultProps:{size:"xl"}},{defineMultiStyleConfig:Fu,definePartsStyle:ju}=ct(Oi.keys),Yu=ke("breadcrumb-link-decor"),$u=Fu({baseStyle:ju({link:{transitionProperty:"common",transitionDuration:"fast",transitionTimingFunction:"ease-out",outline:"none",color:"inherit",textDecoration:Yu.reference,[Yu.variable]:"none","&:not([aria-current=page])":{cursor:"pointer",_hover:{[Yu.variable]:"underline"},_focusVisible:{boxShadow:"outline"}}}})}),Hu=e=>{const{colorScheme:t,theme:n}=e;if("gray"===t)return{color:wa("gray.800","whiteAlpha.900")(e),_hover:{bg:wa("gray.100","whiteAlpha.200")(e)},_active:{bg:wa("gray.200","whiteAlpha.300")(e)}};const r=Ka(`${t}.200`,.12)(n),o=Ka(`${t}.200`,.24)(n);return{color:wa(`${t}.600`,`${t}.200`)(e),bg:"transparent",_hover:{bg:wa(`${t}.50`,r)(e)},_active:{bg:wa(`${t}.100`,o)(e)}}},Uu=e=>{const{colorScheme:t}=e,n=wa("gray.200","whiteAlpha.300")(e);return{border:"1px solid",borderColor:"gray"===t?n:"currentColor",".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)":{marginEnd:"-1px"},".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)":{marginBottom:"-1px"},..._l(Hu,e)}},zu={yellow:{bg:"yellow.400",color:"black",hoverBg:"yellow.500",activeBg:"yellow.600"},cyan:{bg:"cyan.400",color:"black",hoverBg:"cyan.500",activeBg:"cyan.600"}},Wu=e=>{var t;const{colorScheme:n}=e;if("gray"===n){const t=wa("gray.100","whiteAlpha.200")(e);return{bg:t,color:wa("gray.800","whiteAlpha.900")(e),_hover:{bg:wa("gray.200","whiteAlpha.300")(e),_disabled:{bg:t}},_active:{bg:wa("gray.300","whiteAlpha.400")(e)}}}const{bg:r=`${n}.500`,color:o="white",hoverBg:i=`${n}.600`,activeBg:a=`${n}.700`}=null!=(t=zu[n])?t:{},s=wa(r,`${n}.200`)(e);return{bg:s,color:wa(o,"gray.800")(e),_hover:{bg:wa(i,`${n}.300`)(e),_disabled:{bg:s}},_active:{bg:wa(a,`${n}.400`)(e)}}},Vu=e=>{const{colorScheme:t}=e;return{padding:0,height:"auto",lineHeight:"normal",verticalAlign:"baseline",color:wa(`${t}.500`,`${t}.200`)(e),_hover:{textDecoration:"underline",_disabled:{textDecoration:"none"}},_active:{color:wa(`${t}.700`,`${t}.500`)(e)}}},Gu={baseStyle:{lineHeight:"1.2",borderRadius:"md",fontWeight:"semibold",transitionProperty:"common",transitionDuration:"normal",_focusVisible:{boxShadow:"outline"},_disabled:{opacity:.4,cursor:"not-allowed",boxShadow:"none"},_hover:{_disabled:{bg:"initial"}}},variants:{ghost:Hu,outline:Uu,solid:Wu,link:Vu,unstyled:{bg:"none",color:"inherit",display:"inline",lineHeight:"inherit",m:"0",p:"0"}},sizes:{lg:{h:"12",minW:"12",fontSize:"lg",px:"6"},md:{h:"10",minW:"10",fontSize:"md",px:"4"},sm:{h:"8",minW:"8",fontSize:"sm",px:"3"},xs:{h:"6",minW:"6",fontSize:"xs",px:"2"}},defaultProps:{variant:"solid",size:"md",colorScheme:"gray"}},{definePartsStyle:Qu,defineMultiStyleConfig:qu}=ct(Zi.keys),Ku=ke("card-bg"),Zu=ke("card-padding"),Ju=ke("card-shadow"),Xu=ke("card-radius"),ed=ke("card-border-width","0"),td=ke("card-border-color"),nd=Qu({container:{[Ku.variable]:"colors.chakra-body-bg",backgroundColor:Ku.reference,boxShadow:Ju.reference,borderRadius:Xu.reference,color:"chakra-body-text",borderWidth:ed.reference,borderColor:td.reference},body:{padding:Zu.reference,flex:"1 1 0%"},header:{padding:Zu.reference},footer:{padding:Zu.reference}}),rd={sm:Qu({container:{[Xu.variable]:"radii.base",[Zu.variable]:"space.3"}}),md:Qu({container:{[Xu.variable]:"radii.md",[Zu.variable]:"space.5"}}),lg:Qu({container:{[Xu.variable]:"radii.xl",[Zu.variable]:"space.7"}})},od=qu({baseStyle:nd,variants:{elevated:Qu({container:{[Ju.variable]:"shadows.base",_dark:{[Ku.variable]:"colors.gray.700"}}}),outline:Qu({container:{[ed.variable]:"1px",[td.variable]:"colors.chakra-border-color"}}),filled:Qu({container:{[Ku.variable]:"colors.chakra-subtle-bg"}}),unstyled:{body:{[Zu.variable]:0},header:{[Zu.variable]:0},footer:{[Zu.variable]:0}}},sizes:rd,defaultProps:{variant:"elevated",size:"md"}}),id=na("close-button-size"),ad=na("close-button-bg"),sd={baseStyle:{w:[id.reference],h:[id.reference],borderRadius:"md",transitionProperty:"common",transitionDuration:"normal",_disabled:{opacity:.4,cursor:"not-allowed",boxShadow:"none"},_hover:{[ad.variable]:"colors.blackAlpha.100",_dark:{[ad.variable]:"colors.whiteAlpha.100"}},_active:{[ad.variable]:"colors.blackAlpha.200",_dark:{[ad.variable]:"colors.whiteAlpha.200"}},_focusVisible:{boxShadow:"outline"},bg:ad.reference},sizes:{lg:{[id.variable]:"sizes.10",fontSize:"md"},md:{[id.variable]:"sizes.8",fontSize:"xs"},sm:{[id.variable]:"sizes.6",fontSize:"2xs"}},defaultProps:{size:"md"}},{variants:ld,defaultProps:cd}=_s,ud={baseStyle:{fontFamily:"mono",fontSize:"sm",px:"0.2em",borderRadius:"sm",bg:gs.bg.reference,color:gs.color.reference,boxShadow:gs.shadow.reference},variants:ld,defaultProps:cd},dd={baseStyle:{w:"100%",mx:"auto",maxW:"prose",px:"4"}},pd={baseStyle:{opacity:.6,borderColor:"inherit"},variants:{solid:{borderStyle:"solid"},dashed:{borderStyle:"dashed"}},defaultProps:{variant:"solid"}},{definePartsStyle:fd,defineMultiStyleConfig:hd}=ct(Si.keys),md=hd({baseStyle:fd({container:{borderTopWidth:"1px",borderColor:"inherit",_last:{borderBottomWidth:"1px"}},button:{transitionProperty:"common",transitionDuration:"normal",fontSize:"md",_focusVisible:{boxShadow:"outline"},_hover:{bg:"blackAlpha.50"},_disabled:{opacity:.4,cursor:"not-allowed"},px:"4",py:"2"},panel:{pt:"2",px:"4",pb:"5"},icon:{fontSize:"1.25em"}})}),{definePartsStyle:gd,defineMultiStyleConfig:vd}=ct(Mi.keys),yd=ke("alert-fg"),bd=ke("alert-bg"),_d=gd({container:{bg:bd.reference,px:"4",py:"3"},title:{fontWeight:"bold",lineHeight:"6",marginEnd:"2"},description:{lineHeight:"6"},icon:{color:yd.reference,flexShrink:0,marginEnd:"3",w:"5",h:"6"},spinner:{color:yd.reference,flexShrink:0,marginEnd:"3",w:"5",h:"5"}});function Ad(e){const{theme:t,colorScheme:n}=e;return{light:`colors.${n}.100`,dark:Ka(`${n}.200`,.16)(t)}}var Ed=gd((e=>{const{colorScheme:t}=e,n=Ad(e);return{container:{[yd.variable]:`colors.${t}.600`,[bd.variable]:n.light,_dark:{[yd.variable]:`colors.${t}.200`,[bd.variable]:n.dark}}}})),wd=gd((e=>{const{colorScheme:t}=e,n=Ad(e);return{container:{[yd.variable]:`colors.${t}.600`,[bd.variable]:n.light,_dark:{[yd.variable]:`colors.${t}.200`,[bd.variable]:n.dark},paddingStart:"3",borderStartWidth:"4px",borderStartColor:yd.reference}}})),xd=gd((e=>{const{colorScheme:t}=e,n=Ad(e);return{container:{[yd.variable]:`colors.${t}.600`,[bd.variable]:n.light,_dark:{[yd.variable]:`colors.${t}.200`,[bd.variable]:n.dark},pt:"2",borderTopWidth:"4px",borderTopColor:yd.reference}}})),kd=gd((e=>{const{colorScheme:t}=e;return{container:{[yd.variable]:"colors.white",[bd.variable]:`colors.${t}.600`,_dark:{[yd.variable]:"colors.gray.900",[bd.variable]:`colors.${t}.200`},color:yd.reference}}})),Cd=vd({baseStyle:_d,variants:{subtle:Ed,"left-accent":wd,"top-accent":xd,solid:kd},defaultProps:{variant:"subtle",colorScheme:"blue"}}),{definePartsStyle:Sd,defineMultiStyleConfig:Md}=ct(Ti.keys),Td=ke("avatar-border-color"),Od=ke("avatar-bg"),Dd=ke("avatar-font-size"),Ld=ke("avatar-size"),Pd={borderRadius:"full",border:"0.2em solid",borderColor:Td.reference,[Td.variable]:"white",_dark:{[Td.variable]:"colors.gray.800"}},Id={bg:Od.reference,fontSize:Dd.reference,width:Ld.reference,height:Ld.reference,lineHeight:"1",[Od.variable]:"colors.gray.200",_dark:{[Od.variable]:"colors.whiteAlpha.400"}},Bd=e=>{const{name:t,theme:n}=e,r=t?Ja({string:t}):"colors.gray.400",o=(e=>t=>"dark"===qa(e)(t))(r)(n);let i="white";return o||(i="gray.800"),{bg:Od.reference,fontSize:Dd.reference,color:i,borderColor:Td.reference,verticalAlign:"top",width:Ld.reference,height:Ld.reference,"&:not([data-loaded])":{[Od.variable]:r},[Td.variable]:"colors.white",_dark:{[Td.variable]:"colors.gray.800"}}},Rd={fontSize:Dd.reference,lineHeight:"1"};function Nd(e){const t="100%"!==e?mi[e]:void 0;return Sd({container:{[Ld.variable]:null!=t?t:e,[Dd.variable]:`calc(${null!=t?t:e} / 2.5)`},excessLabel:{[Ld.variable]:null!=t?t:e,[Dd.variable]:`calc(${null!=t?t:e} / 2.5)`}})}var Fd={Accordion:md,Alert:Cd,Avatar:Md({baseStyle:Sd((e=>({badge:_l(Pd,e),excessLabel:_l(Id,e),container:_l(Bd,e),label:Rd}))),sizes:{"2xs":Nd(4),xs:Nd(6),sm:Nd(8),md:Nd(12),lg:Nd(16),xl:Nd(24),"2xl":Nd(32),full:Nd("100%")},defaultProps:{size:"md"}}),Badge:_s,Breadcrumb:$u,Button:Gu,Checkbox:Nl,CloseButton:sd,Code:ud,Container:dd,Divider:pd,Drawer:xu,Editable:Su,Form:Du,FormError:Bu,FormLabel:Ru,Heading:Nu,Input:ol,Kbd:mc,Link:gc,List:bc,Menu:xc,Modal:Nc,NumberInput:tu,PinInput:iu,Popover:du,Progress:bl,Radio:Hl,Select:Gl,Skeleton:Kl,SkipLink:Jl,Slider:lc,Spinner:uc,Stat:fc,Switch:Ea,Table:Da,Tabs:ms,Tag:Ps,Textarea:sl,Tooltip:dl,Card:od,Stepper:ki},jd={colors:{"chakra-body-text":{_light:"gray.800",_dark:"whiteAlpha.900"},"chakra-body-bg":{_light:"white",_dark:"gray.800"},"chakra-border-color":{_light:"gray.200",_dark:"whiteAlpha.300"},"chakra-inverse-text":{_light:"white",_dark:"gray.800"},"chakra-subtle-bg":{_light:"gray.100",_dark:"gray.700"},"chakra-subtle-text":{_light:"gray.600",_dark:"gray.400"},"chakra-placeholder-color":{_light:"gray.500",_dark:"whiteAlpha.400"}}},Yd={global:{body:{fontFamily:"body",color:"chakra-body-text",bg:"chakra-body-bg",transitionProperty:"background-color",transitionDuration:"normal",lineHeight:"base"},"*::placeholder":{color:"chakra-placeholder-color"},"*, *::before, &::after":{borderColor:"chakra-border-color"}}},$d={useSystemColorMode:!1,initialColorMode:"light",cssVarPrefix:"chakra"},Hd={semanticTokens:jd,direction:"ltr",...gi,components:Fd,styles:Yd,config:$d},Ud={semanticTokens:jd,direction:"ltr",components:{},...gi,styles:Yd,config:$d},zd=["borders","breakpoints","colors","components","config","direction","fonts","fontSizes","fontWeights","letterSpacings","lineHeights","radii","shadows","sizes","space","styles","transition","zIndices"];function Wd(e){return"function"==typeof e}var Vd=e=>function(...t){let n=[...t],r=t[t.length-1];var o;return v(o=r)&&zd.every((e=>Object.prototype.hasOwnProperty.call(o,e)))&&n.length>1?n=n.slice(0,n.length-1):r=e,function(...e){return t=>e.reduce(((e,t)=>t(e)),t)}(...n.map((e=>t=>Wd(e)?e(t):function(...e){return C()({},...e,Qd)}(t,e))))(r)},Gd=Vd(Hd);Vd(Ud);function Qd(e,t,n,r){if((Wd(e)||Wd(t))&&Object.prototype.hasOwnProperty.call(r,n))return(...n)=>{const r=Wd(e)?e(...n):e,o=Wd(t)?t(...n):t;return C()({},r,o,Qd)}}const qd=Lr;var Kd=["smallSize","variant"];function Zd(){return Zd=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Zd.apply(null,arguments)}var Jd=function(e){return e.Danger="danger",e.Neutral="neutral",e.Warning="warning",e}({}),Xd=pr(wr,{shouldForwardProp:e=>"smallSize"!==e,target:"e1fitew00"})((e=>{var{theme:t,smallSize:n,variant:r}=e;return"\n        align-items: center;\n        border-left-width: 4px;\n        border-radius: 4px;\n        padding:  "+(n?"0 20px 0 16px":"18px 20px 18px 16px")+";\n\n        p {\n            color: "+t.colors.gray[600]+";\n            margin-bottom: 0;\n        }\n\n        svg {\n            color: "+t.components.Banner.variants[r].svg.color+";\n        }\n    "}),"");const ep=e=>{var{smallSize:t,variant:n=Jd.Neutral}=e,r=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,Kd),{components:o}=qd(),{Banner:i}=o,{[n]:a}=i.variants,{backgroundColor:s,border:l}=a;return Mr(Xd,Zd({backgroundColor:s,smallSize:t,border:l,"data-testid":"sp-ui-banner",variant:n},r))};var tp=function(e){return e.Active="active",e.Checked="checked",e.Default="default",e.Disabled="disabled",e.Focus="focus",e.Hover="hover",e.Invalid="invalid",e.Loaded="loaded",e.Loading="loading",e.Selected="selected",e.Valid="valid",e.Unselected="Unselected",e}({}),np=function(e,t,n){var{isDisabled:r=!1,isInvalid:o=!1,isFocused:i=!1,isHovered:a=!1}=t;void 0===n&&(n="TextInput");var{[tp.Disabled]:{backgroundColor:s},[tp.Invalid]:{borderColor:l},[tp.Focus]:{borderColor:c},[tp.Hover]:{borderColor:u},backgroundColor:d,borderColor:p,color:f,fontSize:h,fontWeight:m,placeholderColor:g,smallScreen:v}=e.components[n].baseStyle;return{backgroundColor:r?s:d,borderColor:r?p:o?l:i?c:a?u:p,color:f,fontSize:h,fontStyles:"\n            color: "+f+";\n            font-weight: "+m+";\n            font-weight: "+m+";\n            "+("\n        font-size: "+h+";\n\n        "+e.responsive.smallScreenOnly("\n            font-size: "+v.fontSize+";\n        ")+"\n    ")+";\n\n            &::placeholder {\n                color: "+g+";\n            }\n        ",fontWeight:m,placeholderColor:g,smallScreen:v}},rp=["children","isDisabled","loadedText","loadingText","onClick","type","variant"];function op(){return op=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},op.apply(null,arguments)}function ip(e,t,n,r,o,i,a){try{var s=e[i](a),l=s.value}catch(e){return void n(e)}s.done?t(l):Promise.resolve(l).then(r,o)}var ap=function(e){return Mr("svg",e,Mr("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M.14 13.52a.513.513 0 010-.71l.7-.71c.19-.2.51-.2.7 0l1.07 1.1 3.72-5c.16-.22.47-.27.69-.1l.78.61c.22.17.26.49.1.71L3.16 15.8c-.18.24-.53.27-.74.05L.14 13.52z",fill:"currentColor"}))};ap.defaultProps={viewBox:"0 0 8 24",fill:"none",xmlns:"http://www.w3.org/2000/svg"};var sp=function(e){return e.Primary="primary",e.Secondary="secondary",e.Tertiary="tertiary",e.Dismissive="dismissive",e.Destructive="destructive",e}({}),lp=pr("div",{target:"ewn0wqi2"})((e=>{var{count:t,index:n}=e,r=.225*t;return"\n        @keyframes fade-in-out {\n            0% {\n                opacity: 1;\n            }\n            33% {\n                opacity: 0.5;\n            }\n            66% {\n                opacity: 0.5;\n            }\n            100% {\n                opacity: 1;\n            }\n        }\n\n        animation: fade-in-out "+(r+"s")+" linear "+(.225*n-r+"s")+" infinite;\n        background-color: currentColor;\n        border-radius: 4px;\n        height: 4px;\n        margin-right: 2px;\n        width: 4px;\n\n        &:last-of-type {\n            margin-right: 0;\n        }\n    "}),""),cp=pr(wr,{target:"ewn0wqi1"})((e=>{var{width:t="8px"}=e,n="0.2s";return"\n        @keyframes pulse {\n            0% {\n                transform: scale(1);\n            }\n            50% {\n                transform: scale(1.5);\n            }\n            100% {\n                transform: scale(1);\n            }\n        }\n\n        @keyframes unveil {\n            0% {\n                margin-right: "+t+";\n                opacity: 0.5;\n                width: 0;\n            }\n            100% {\n                margin-right: 0;\n                opacity: 1;\n                width: "+t+";\n            }\n        }\n\n        animation: pulse 0.5s ease-in-out "+n+", unveil "+n+" linear;\n        height: 24px;\n        justify-content: flex-start;\n        margin-bottom: -4px;\n        margin-top: -4px;\n        overflow: hidden;\n        width: "+t+";\n\n        > * {\n            min-width: "+t+";\n            width: "+t+";\n        }\n    "}),""),up=e=>{var{loaded:t}=e;return Mr(wr,{marginRight:"8px"},t?Mr(cp,null,Mr(ap,null)):Array.from(Array(3)).map(((e,t)=>Mr(lp,{count:3,index:t,key:t}))))},dp=pr(Wr,{shouldForwardProp:e=>"buttonRef"!==e&&"componentState"!==e&&"buttonVariant"!==e,target:"ewn0wqi0"})((e=>{var{buttonVariant:t,componentState:n,theme:r}=e,{[t]:o}=r.components.Button.variants,{[tp.Default]:i,[tp.Hover]:a,[tp.Loaded]:s,[tp.Loading]:l}=o;return"\n        background-color: "+i.backgroundColor+";\n        border-color: "+i.borderColor+";\n        border-radius: 2px;\n        border-width: 1px;\n        color: "+i.color+";\n        font-size: "+r.fontSizes.sm+";\n        font-weight: "+r.fontWeights.normal+";\n        height: auto;\n        line-height: 16px;\n        padding: 8px 16px;\n        text-align: center;\n        white-space: normal;\n        width: auto;\n\n        &:active {\n            background-color: "+a.backgroundColor+";\n            border-color: "+a.borderColor+";\n            color: "+a.color+";\n        }\n\n        &:hover {\n            background-color: "+a.backgroundColor+";\n            border-color: "+a.borderColor+";\n            color: "+a.color+";\n            cursor: pointer;\n        }\n\n        &:hover[disabled] {\n            background: "+i.backgroundColor+";\n            border-color: "+i.borderColor+";\n        }\n\n        "+(n===tp.Loaded?"\n                    background-color: "+s.backgroundColor+";\n                    border-color: "+s.borderColor+";\n                    color: "+s.color+";\n                    pointer-events: none;\n                ":"")+"\n\n        "+(n===tp.Loading?"\n                    background-color: "+l.backgroundColor+";\n                    border-color: "+l.borderColor+";\n                    pointer-events: none;\n                ":"")+"\n    "}),""),pp=(0,i.forwardRef)(((e,t)=>{var{children:n,isDisabled:r,loadedText:o,loadingText:a,onClick:s,type:l="submit",variant:c=sp.Primary}=e,u=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,rp),[d,p]=(0,i.useState)(!1),[f,h]=(0,i.useState)(!1),m=d?tp.Loaded:f?tp.Loading:void 0,g=Boolean(o)&&d,v=Boolean(a)&&f,y=function(){var e,t=(e=function*(e){e&&e.stopPropagation(),s&&(yield s(e)),b&&setTimeout((()=>{_.isRendered&&(p(!0),h(!1))}))},function(){var t=this,n=arguments;return new Promise((function(r,o){var i=e.apply(t,n);function a(e){ip(i,r,o,a,s,"next",e)}function s(e){ip(i,r,o,a,s,"throw",e)}a(void 0)}))});return function(e){return t.apply(this,arguments)}}(),b=o||a,_={isRendered:!0};return(0,i.useEffect)((()=>(d&&(o?setTimeout((()=>{_.isRendered&&p(!1)}),1450):_.isRendered&&p(!1)),()=>{_.isRendered=!1})),[_.isRendered,d,o]),Mr(dp,op({buttonRef:t,buttonVariant:c,componentState:m,"data-testid":"sp-ui-button",isDisabled:r,marginBottom:"0",onClick:e=>{b&&(p(!1),h(!0)),y(e)},type:l},u),(g||v)&&Mr(up,{loaded:g}),d&&o?o:f&&a?a:n)}));pp.propTypes={buttonRef:Xr().any,children:Xr().oneOfType([Xr().arrayOf(Xr().node),Xr().node]),isDisabled:Xr().bool,loadedText:Xr().string,loadingText:Xr().string,onClick:Xr().func,type:Xr().oneOf(["submit","reset","button"]),variant:Xr().oneOf([sp.Destructive,sp.Dismissive,sp.Primary,sp.Secondary,sp.Tertiary])},pp.displayName="Button";const fp=pp;var hp=function(e){return Mr("svg",e,Mr("path",{d:"M13.6625 12.2325L17.2025 15.7725C17.5925 16.1625 17.5925 16.7925 17.2025 17.1825C16.8125 17.5725 16.1825 17.5725 15.7925 17.1825L12.2425 13.6525L8.7025 17.1925C8.3125 17.5825 7.6825 17.5825 7.2925 17.1925C6.9025 16.8025 6.9025 16.1725 7.2925 15.7825L10.8325 12.2425L7.2925 8.7025C6.9025 8.3125 6.9025 7.6825 7.2925 7.2925C7.6825 6.9025 8.3125 6.9025 8.7025 7.2925L12.2425 10.8325L15.7825 7.2925C16.1725 6.9025 16.8025 6.9025 17.1925 7.2925C17.5825 7.6825 17.5825 8.3125 17.1925 8.7025L13.6625 12.2325Z"}))};hp.defaultProps={width:"24",height:"24",fill:"none",xmlns:"http://www.w3.org/2000/svg"};var mp=function(e){return Mr("svg",e,Mr("path",{d:"M8.4125 11.0125H18.0025C18.5525 11.0125 19.0025 11.4625 19.0025 12.0025C19.0025 12.5425 18.5525 12.9925 18.0025 12.9925H8.4125L11.2325 15.8025C11.6225 16.1925 11.6225 16.8225 11.2325 17.2125C10.8425 17.6025 10.2125 17.6025 9.8225 17.2125L5.2925 12.7025C4.9025 12.3125 4.9025 11.6825 5.2925 11.2925L9.8225 6.78249C10.2125 6.39249 10.8425 6.39249 11.2325 6.78249C11.6225 7.17249 11.6225 7.80249 11.2325 8.19249L8.4125 11.0125Z"}))};mp.defaultProps={width:"24",height:"24",fill:"none",xmlns:"http://www.w3.org/2000/svg"};var gp=function(e){return Mr("svg",e,Mr("path",{d:"M12.8254 15.0259H11.037V14.0989C11.037 13.7686 11.0688 13.4703 11.1323 13.1933C11.1958 12.9269 11.2804 12.6925 11.4074 12.4688C11.5344 12.2451 11.672 12.0426 11.8413 11.8402C12.0106 11.6377 12.2116 11.4353 12.4233 11.2329L13.1323 10.5616C13.4074 10.3272 13.6402 10.0609 13.8307 9.77321C14.0106 9.48554 14.1058 9.11263 14.1058 8.66514C14.1058 8.04718 13.9153 7.55708 13.5238 7.19482C13.1323 6.83257 12.6349 6.65145 12.0212 6.65145C11.3862 6.65145 10.8783 6.85388 10.4974 7.26941C10.1164 7.68493 9.89418 8.17504 9.83069 8.76103L8 8.54795C8.07407 7.99391 8.2328 7.50381 8.47619 7.05632C8.71958 6.60883 9.01587 6.23592 9.38624 5.9376C9.75661 5.63927 10.1693 5.39422 10.6349 5.2344C11.1005 5.07458 11.6085 5 12.1376 5C12.6667 5 13.1746 5.07458 13.6296 5.2344C14.0847 5.39422 14.5079 5.61796 14.8571 5.91629C15.2169 6.21461 15.4921 6.58752 15.6931 7.03501C15.8942 7.47184 16 7.98326 16 8.5586C16 8.96347 15.9577 9.32572 15.8624 9.6347C15.7778 9.94368 15.6508 10.2207 15.4921 10.4658C15.3333 10.7108 15.1534 10.9452 14.9206 11.1689C14.6878 11.382 14.4444 11.6058 14.1799 11.8402C13.9259 12.0533 13.7143 12.2451 13.5344 12.4262C13.3545 12.6073 13.2169 12.7778 13.1111 12.9589C13.0053 13.14 12.9312 13.3318 12.8889 13.5556C12.8466 13.7686 12.8254 14.0457 12.8254 14.3653V15.0259ZM13.3016 17.7321C13.3016 18.0624 13.1852 18.3607 12.9418 18.6164C12.6984 18.8721 12.3915 19 12.0212 19C11.6614 19 11.3651 18.8721 11.1111 18.6271C10.8677 18.382 10.7407 18.0837 10.7407 17.7534C10.7407 17.4125 10.8571 17.1142 11.1005 16.8584C11.3439 16.6134 11.6508 16.4855 12.0212 16.4855C12.3915 16.4855 12.6984 16.6027 12.9418 16.8478C13.1852 17.0928 13.3016 17.3912 13.3016 17.7321Z"}))};gp.defaultProps={width:"24",height:"24",fill:"none",xmlns:"http://www.w3.org/2000/svg"};var vp=function(e){return e.Back="back",e.Close="close",e.Help="help",e}({});var yp=function(e){return e.Fullscreen="fullscreen",e.Large="large",e.Small="small",e}({}),bp=function(e){return e.Default="default",e.FullWidth="full-width",e}({});function _p(e={}){const{onChange:t,value:n,defaultValue:r,name:o,isDisabled:a,isFocusable:s,isNative:l,...c}=e,[u,d]=(0,i.useState)(r||""),p=void 0!==n,f=p?n:u,h=(0,i.useRef)(null),m=(0,i.useCallback)((()=>{const e=h.current;if(!e)return;let t="input:not(:disabled):checked";const n=e.querySelector(t);if(n)return void n.focus();t="input:not(:disabled)";const r=e.querySelector(t);null==r||r.focus()}),[]),g=(0,i.useId)(),y=o||`radio-${g}`,b=(0,i.useCallback)((e=>{const n=function(e){return e&&v(e)&&v(e.target)}(e)?e.target.value:e;p||d(n),null==t||t(String(n))}),[t,p]);return{getRootProps:(0,i.useCallback)(((e={},t=null)=>({...e,ref:Ur(t,h),role:"radiogroup"})),[]),getRadioProps:(0,i.useCallback)(((e={},t=null)=>{const n=l?"checked":"isChecked";return{...e,ref:t,name:y,[n]:null!=f?e.value===f:void 0,onChange(e){b(e)},"data-radiogroup":!0}}),[l,y,b,f]),name:y,ref:h,focus:m,setValue:d,value:f,onChange:b,isDisabled:a,isFocusable:s,htmlProps:c}}var[Ap,Ep]=xr({name:"RadioGroupContext",strict:!1}),wp=yr(((e,t)=>{const{colorScheme:n,size:r,variant:o,children:a,className:s,isDisabled:l,isFocusable:c,...u}=e,{value:d,onChange:p,getRootProps:f,name:h,htmlProps:m}=_p(u),v=(0,i.useMemo)((()=>({name:h,size:r,onChange:p,colorScheme:n,value:d,variant:o,isDisabled:l,isFocusable:c})),[h,r,p,n,d,o,l,c]);return(0,br.jsx)(Ap,{value:v,children:(0,br.jsx)(vr.div,{...f(m,t),className:g("chakra-radio-group",s),children:a})})}));wp.displayName="RadioGroup";var[xp,kp]=xr({name:"FormControlStylesContext",errorMessage:"useFormControlStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<FormControl />\" "}),[Cp,Sp]=xr({strict:!1,name:"FormControlContext"});var Mp=yr((function(e,t){const n=jr("Form",e),r=pt(e),{getRootProps:o,htmlProps:a,...s}=function(e){const{id:t,isRequired:n,isInvalid:r,isDisabled:o,isReadOnly:a,...s}=e,l=(0,i.useId)(),c=t||`field-${l}`,u=`${c}-label`,d=`${c}-feedback`,p=`${c}-helptext`,[f,h]=(0,i.useState)(!1),[m,g]=(0,i.useState)(!1),[v,y]=(0,i.useState)(!1),b=(0,i.useCallback)(((e={},t=null)=>({id:p,...e,ref:Ur(t,(e=>{e&&g(!0)}))})),[p]),_=(0,i.useCallback)(((e={},t=null)=>({...e,ref:t,"data-focus":A(v),"data-disabled":A(o),"data-invalid":A(r),"data-readonly":A(a),id:void 0!==e.id?e.id:u,htmlFor:void 0!==e.htmlFor?e.htmlFor:c})),[c,o,v,r,a,u]),E=(0,i.useCallback)(((e={},t=null)=>({id:d,...e,ref:Ur(t,(e=>{e&&h(!0)})),"aria-live":"polite"})),[d]),w=(0,i.useCallback)(((e={},t=null)=>({...e,...s,ref:t,role:"group","data-focus":A(v),"data-disabled":A(o),"data-invalid":A(r),"data-readonly":A(a)})),[s,o,v,r,a]),x=(0,i.useCallback)(((e={},t=null)=>({...e,ref:t,role:"presentation","aria-hidden":!0,children:e.children||"*"})),[]);return{isRequired:!!n,isInvalid:!!r,isReadOnly:!!a,isDisabled:!!o,isFocused:!!v,onFocus:()=>y(!0),onBlur:()=>y(!1),hasFeedbackText:f,setHasFeedbackText:h,hasHelpText:m,setHasHelpText:g,id:c,labelId:u,feedbackId:d,helpTextId:p,htmlProps:s,getHelpTextProps:b,getErrorMessageProps:E,getRootProps:w,getLabelProps:_,getRequiredIndicatorProps:x}}(r),l=g("chakra-form-control",e.className);return(0,br.jsx)(Cp,{value:s,children:(0,br.jsx)(xp,{value:n,children:(0,br.jsx)(vr.div,{...o({},t),className:l,__css:n.container})})})}));Mp.displayName="FormControl";var Tp=yr((function(e,t){const n=Sp(),r=kp(),o=g("chakra-form__helper-text",e.className);return(0,br.jsx)(vr.div,{...null==n?void 0:n.getHelpTextProps(e,t),__css:r.helperText,className:o})}));Tp.displayName="FormHelperText";var Op=()=>"undefined"!=typeof document;var Dp=!1,Lp=null,Pp=!1,Ip=!1,Bp=new Set;function Rp(e,t){Bp.forEach((n=>n(e,t)))}var Np="undefined"!=typeof window&&null!=window.navigator&&/^Mac/.test(window.navigator.platform);function Fp(e){var t;Pp=!0,(t=e).metaKey||!Np&&t.altKey||t.ctrlKey||"Control"===t.key||"Shift"===t.key||"Meta"===t.key||(Lp="keyboard",Rp("keyboard",e))}function jp(e){if(Lp="pointer","mousedown"===e.type||"pointerdown"===e.type){Pp=!0;const t=e.composedPath?e.composedPath()[0]:e.target;let n=!1;try{n=t.matches(":focus-visible")}catch{}if(n)return;Rp("pointer",e)}}function Yp(e){var t;(0===(t=e).mozInputSource&&t.isTrusted||0===t.detail&&!t.pointerType)&&(Pp=!0,Lp="virtual")}function $p(e){e.target!==window&&e.target!==document&&(Pp||Ip||(Lp="virtual",Rp("virtual",e)),Pp=!1,Ip=!1)}function Hp(){Pp=!1,Ip=!0}function Up(){return"pointer"!==Lp}function zp(){if(!Op()||Dp)return;const{focus:e}=HTMLElement.prototype;HTMLElement.prototype.focus=function(...t){Pp=!0,e.apply(this,t)},document.addEventListener("keydown",Fp,!0),document.addEventListener("keyup",Fp,!0),document.addEventListener("click",Yp,!0),window.addEventListener("focus",$p,!0),window.addEventListener("blur",Hp,!1),"undefined"!=typeof PointerEvent?(document.addEventListener("pointerdown",jp,!0),document.addEventListener("pointermove",jp,!0),document.addEventListener("pointerup",jp,!0)):(document.addEventListener("mousedown",jp,!0),document.addEventListener("mousemove",jp,!0),document.addEventListener("mouseup",jp,!0)),Dp=!0}function Wp(e){zp(),e(Up());const t=()=>e(Up());return Bp.add(t),()=>{Bp.delete(t)}}var Vp={border:"0",clip:"rect(0, 0, 0, 0)",height:"1px",width:"1px",margin:"-1px",padding:"0",overflow:"hidden",whiteSpace:"nowrap",position:"absolute"};function Gp(e){e.preventDefault(),e.stopPropagation()}var Qp=yr(((e,t)=>{var n;const r=Ep(),{onChange:o,value:a}=e,s=jr("Radio",{...r,...e}),l=pt(e),{spacing:c="0.5rem",children:u,isDisabled:d=(null==r?void 0:r.isDisabled),isFocusable:p=(null==r?void 0:r.isFocusable),inputProps:f,...h}=l;let m=e.isChecked;null!=(null==r?void 0:r.value)&&null!=a&&(m=r.value===a);let g=o;(null==r?void 0:r.onChange)&&null!=a&&(g=x(r.onChange,o));const v=null!=(n=null==e?void 0:e.name)?n:null==r?void 0:r.name,{getInputProps:y,getCheckboxProps:b,getLabelProps:_,getRootProps:k,htmlProps:C}=function(e={}){const{defaultChecked:t,isChecked:n,isFocusable:r,isDisabled:o,isReadOnly:a,isRequired:s,onChange:l,isInvalid:c,name:u,value:d,id:p,"data-radiogroup":f,"aria-describedby":h,...m}=e,g=`radio-${(0,i.useId)()}`,v=Sp(),y=Ep();let b=!v||y||f?g:v.id;b=null!=p?p:b;const _=null!=o?o:null==v?void 0:v.isDisabled,x=null!=a?a:null==v?void 0:v.isReadOnly,k=null!=s?s:null==v?void 0:v.isRequired,C=null!=c?c:null==v?void 0:v.isInvalid,[S,M]=(0,i.useState)(!1),[T,O]=(0,i.useState)(!1),[D,L]=(0,i.useState)(!1),[P,I]=(0,i.useState)(!1),[B,R]=(0,i.useState)(Boolean(t)),N=void 0!==n,F=N?n:B;(0,i.useEffect)((()=>Wp(M)),[]);const j=(0,i.useCallback)((e=>{x||_?e.preventDefault():(N||R(e.target.checked),null==l||l(e))}),[N,_,x,l]),Y=(0,i.useCallback)((e=>{" "===e.key&&I(!0)}),[I]),$=(0,i.useCallback)((e=>{" "===e.key&&I(!1)}),[I]),H=(0,i.useCallback)(((e={},t=null)=>({...e,ref:t,"data-active":A(P),"data-hover":A(D),"data-disabled":A(_),"data-invalid":A(C),"data-checked":A(F),"data-focus":A(T),"data-focus-visible":A(T&&S),"data-readonly":A(x),"aria-hidden":!0,onMouseDown:w(e.onMouseDown,(()=>I(!0))),onMouseUp:w(e.onMouseUp,(()=>I(!1))),onMouseEnter:w(e.onMouseEnter,(()=>L(!0))),onMouseLeave:w(e.onMouseLeave,(()=>L(!1)))})),[P,D,_,C,F,T,x,S]),{onFocus:U,onBlur:z}=null!=v?v:{},W=(0,i.useCallback)(((e={},t=null)=>{const n=_&&!r;return{...e,id:b,ref:t,type:"radio",name:u,value:d,onChange:w(e.onChange,j),onBlur:w(z,e.onBlur,(()=>O(!1))),onFocus:w(U,e.onFocus,(()=>O(!0))),onKeyDown:w(e.onKeyDown,Y),onKeyUp:w(e.onKeyUp,$),checked:F,disabled:n,readOnly:x,required:k,"aria-invalid":E(C),"aria-disabled":E(n),"aria-required":E(k),"data-readonly":A(x),"aria-describedby":h,style:Vp}}),[_,r,b,u,d,j,z,U,Y,$,F,x,k,C,h]);return{state:{isInvalid:C,isFocused:T,isChecked:F,isActive:P,isHovered:D,isDisabled:_,isReadOnly:x,isRequired:k},getCheckboxProps:H,getRadioProps:H,getInputProps:W,getLabelProps:(e={},t=null)=>({...e,ref:t,onMouseDown:w(e.onMouseDown,Gp),"data-disabled":A(_),"data-checked":A(F),"data-invalid":A(C)}),getRootProps:(e,t=null)=>({...e,ref:t,"data-disabled":A(_),"data-checked":A(F),"data-invalid":A(C)}),htmlProps:m}}({...h,isChecked:m,isFocusable:p,isDisabled:d,onChange:g,name:v}),[S,M]=function(e,t){const n={},r={};for(const[o,i]of Object.entries(e))t.includes(o)?n[o]=i:r[o]=i;return[n,r]}(C,tt),T=b(M),O=y(f,t),D=_(),L=Object.assign({},S,k()),P={display:"inline-flex",alignItems:"center",verticalAlign:"top",cursor:"pointer",position:"relative",...s.container},I={display:"inline-flex",alignItems:"center",justifyContent:"center",flexShrink:0,...s.control},B={userSelect:"none",marginStart:c,...s.label};return(0,br.jsxs)(vr.label,{className:"chakra-radio",...L,__css:P,children:[(0,br.jsx)("input",{className:"chakra-radio__input",...O}),(0,br.jsx)(vr.span,{className:"chakra-radio__control",...T,__css:I}),u&&(0,br.jsx)(vr.span,{className:"chakra-radio__label",...D,__css:B,children:u})]})}));Qp.displayName="Radio";var qp=e=>(0,br.jsx)(vr.div,{className:"chakra-stack__item",...e,__css:{display:"inline-block",flex:"0 0 auto",minWidth:0,...e.__css}});qp.displayName="StackItem";var Kp=Object.freeze(["base","sm","md","lg","xl","2xl"]);function Zp(e){return i.Children.toArray(e).filter((e=>(0,i.isValidElement)(e)))}var Jp=yr(((e,t)=>{const{isInline:n,direction:r,align:o,justify:a,spacing:s="0.5rem",wrap:l,children:c,divider:u,className:d,shouldWrapChildren:p,...f}=e,h=n?"row":null!=r?r:"column",m=(0,i.useMemo)((()=>function(e){const{spacing:t,direction:n}=e,r={column:{my:t,mx:0,borderLeftWidth:0,borderBottomWidth:"1px"},"column-reverse":{my:t,mx:0,borderLeftWidth:0,borderBottomWidth:"1px"},row:{mx:t,my:0,borderLeftWidth:"1px",borderBottomWidth:0},"row-reverse":{mx:t,my:0,borderLeftWidth:"1px",borderBottomWidth:0}};return{"&":(o=n,i=e=>r[e],Array.isArray(o)?o.map((e=>null===e?null:i(e))):v(o)?Object.keys(o).reduce(((e,t)=>(e[t]=i(o[t]),e)),{}):null!=o?i(o):null)};var o,i}({spacing:s,direction:h})),[s,h]),y=!!u,b=!p&&!y,_=(0,i.useMemo)((()=>{const e=Zp(c);return b?e:e.map(((t,n)=>{const r=void 0!==t.key?t.key:n,o=n+1===e.length,a=p?(0,br.jsx)(qp,{children:t},r):t;if(!y)return a;const s=(0,i.cloneElement)(u,{__css:m}),l=o?null:s;return(0,br.jsxs)(i.Fragment,{children:[a,l]},r)}))}),[u,m,y,b,p,c]),A=g("chakra-stack",d);return(0,br.jsx)(vr.div,{ref:t,display:"flex",alignItems:o,justifyContent:a,flexDirection:h,flexWrap:l,gap:y?void 0:s,className:A,...f,children:_})}));Jp.displayName="Stack";var Xp=yr((function(e,t){var n;const r=Fr("FormLabel",e),o=pt(e),{className:i,children:a,requiredIndicator:s=(0,br.jsx)(ef,{}),optionalIndicator:l=null,...c}=o,u=Sp(),d=null!=(n=null==u?void 0:u.getLabelProps(c,t))?n:{ref:t,...c};return(0,br.jsxs)(vr.label,{...d,className:g("chakra-form__label",o.className),__css:{display:"block",textAlign:"start",...r},children:[a,(null==u?void 0:u.isRequired)?s:l]})}));Xp.displayName="FormLabel";var ef=yr((function(e,t){const n=Sp(),r=kp();if(!(null==n?void 0:n.isRequired))return null;const o=g("chakra-form__required-indicator",e.className);return(0,br.jsx)(vr.span,{...null==n?void 0:n.getRequiredIndicatorProps(e,t),__css:r.requiredIndicator,className:o})}));ef.displayName="RequiredIndicator";var tf={exit:{scale:.85,opacity:0,transition:{opacity:{duration:.15,easings:"easeInOut"},scale:{duration:.2,easings:"easeInOut"}}},enter:{scale:1,opacity:1,transition:{opacity:{easings:"easeOut",duration:.2},scale:{duration:.2,ease:[.175,.885,.4,1.1]}}}};function nf(e){return null!=e&&"object"==typeof e&&"nodeType"in e&&e.nodeType===Node.ELEMENT_NODE}function rf(e){var t;if(!nf(e))return!1;return e instanceof(null!=(t=e.ownerDocument.defaultView)?t:window).HTMLElement}function of(e){return nf(e)?e.ownerDocument:document}function af(e){return["html","body","#document"].includes(e.localName)?e.ownerDocument.body:rf(e)&&function(e){const t=e.ownerDocument.defaultView||window,{overflow:n,overflowX:r,overflowY:o}=t.getComputedStyle(e);return/auto|scroll|overlay|hidden/.test(n+o+r)}(e)?e:af(function(e){return"html"===e.localName?e:e.assignedSlot||e.parentElement||e.ownerDocument.documentElement}(e))}var sf=(e,t)=>({var:e,varRef:t?`var(${e}, ${t})`:`var(${e})`}),lf={arrowShadowColor:sf("--popper-arrow-shadow-color"),arrowSize:sf("--popper-arrow-size","8px"),arrowSizeHalf:sf("--popper-arrow-size-half"),arrowBg:sf("--popper-arrow-bg"),transformOrigin:sf("--popper-transform-origin"),arrowOffset:sf("--popper-arrow-offset")};var cf={top:"bottom center","top-start":"bottom left","top-end":"bottom right",bottom:"top center","bottom-start":"top left","bottom-end":"top right",left:"right center","left-start":"right top","left-end":"right bottom",right:"left center","right-start":"left top","right-end":"left bottom"},uf={scroll:!0,resize:!0};function df(e){let t;return t="object"==typeof e?{enabled:!0,options:{...uf,...e}}:{enabled:e,options:uf},t}var pf={name:"matchWidth",enabled:!0,phase:"beforeWrite",requires:["computeStyles"],fn:({state:e})=>{e.styles.popper.width=`${e.rects.reference.width}px`},effect:({state:e})=>()=>{const t=e.elements.reference;e.elements.popper.style.width=`${t.offsetWidth}px`}},ff={name:"transformOrigin",enabled:!0,phase:"write",fn:({state:e})=>{hf(e)},effect:({state:e})=>()=>{hf(e)}},hf=e=>{var t;e.elements.popper.style.setProperty(lf.transformOrigin.var,(t=e.placement,cf[t]))},mf={name:"positionArrow",enabled:!0,phase:"afterWrite",fn:({state:e})=>{gf(e)}},gf=e=>{var t;if(!e.placement)return;const n=vf(e.placement);if((null==(t=e.elements)?void 0:t.arrow)&&n){Object.assign(e.elements.arrow.style,{[n.property]:n.value,width:lf.arrowSize.varRef,height:lf.arrowSize.varRef,zIndex:-1});const t={[lf.arrowSizeHalf.var]:`calc(${lf.arrowSize.varRef} / 2 - 1px)`,[lf.arrowOffset.var]:`calc(${lf.arrowSizeHalf.varRef} * -1)`};for(const n in t)e.elements.arrow.style.setProperty(n,t[n])}},vf=e=>e.startsWith("top")?{property:"bottom",value:lf.arrowOffset.varRef}:e.startsWith("bottom")?{property:"top",value:lf.arrowOffset.varRef}:e.startsWith("left")?{property:"right",value:lf.arrowOffset.varRef}:e.startsWith("right")?{property:"left",value:lf.arrowOffset.varRef}:void 0,yf={name:"innerArrow",enabled:!0,phase:"main",requires:["arrow"],fn:({state:e})=>{bf(e)},effect:({state:e})=>()=>{bf(e)}},bf=e=>{if(!e.elements.arrow)return;const t=e.elements.arrow.querySelector("[data-popper-arrow-inner]");if(!t)return;const n=(r=e.placement).includes("top")?"1px 1px 0px 0 var(--popper-arrow-shadow-color)":r.includes("bottom")?"-1px -1px 0px 0 var(--popper-arrow-shadow-color)":r.includes("right")?"-1px 1px 0px 0 var(--popper-arrow-shadow-color)":r.includes("left")?"1px -1px 0px 0 var(--popper-arrow-shadow-color)":void 0;var r;n&&t.style.setProperty("--popper-arrow-default-shadow",n),Object.assign(t.style,{transform:"rotate(45deg)",background:lf.arrowBg.varRef,top:0,left:0,width:"100%",height:"100%",position:"absolute",zIndex:"inherit",boxShadow:"var(--popper-arrow-shadow, var(--popper-arrow-default-shadow))"})},_f={"start-start":{ltr:"left-start",rtl:"right-start"},"start-end":{ltr:"left-end",rtl:"right-end"},"end-start":{ltr:"right-start",rtl:"left-start"},"end-end":{ltr:"right-end",rtl:"left-end"},start:{ltr:"left",rtl:"right"},end:{ltr:"right",rtl:"left"}},Af={"auto-start":"auto-end","auto-end":"auto-start","top-start":"top-end","top-end":"top-start","bottom-start":"bottom-end","bottom-end":"bottom-start"};function Ef(e){if(null==e)return window;if("[object Window]"!==e.toString()){var t=e.ownerDocument;return t&&t.defaultView||window}return e}function wf(e){return e instanceof Ef(e).Element||e instanceof Element}function xf(e){return e instanceof Ef(e).HTMLElement||e instanceof HTMLElement}function kf(e){return"undefined"!=typeof ShadowRoot&&(e instanceof Ef(e).ShadowRoot||e instanceof ShadowRoot)}var Cf=Math.max,Sf=Math.min,Mf=Math.round;function Tf(){var e=navigator.userAgentData;return null!=e&&e.brands&&Array.isArray(e.brands)?e.brands.map((function(e){return e.brand+"/"+e.version})).join(" "):navigator.userAgent}function Of(){return!/^((?!chrome|android).)*safari/i.test(Tf())}function Df(e,t,n){void 0===t&&(t=!1),void 0===n&&(n=!1);var r=e.getBoundingClientRect(),o=1,i=1;t&&xf(e)&&(o=e.offsetWidth>0&&Mf(r.width)/e.offsetWidth||1,i=e.offsetHeight>0&&Mf(r.height)/e.offsetHeight||1);var a=(wf(e)?Ef(e):window).visualViewport,s=!Of()&&n,l=(r.left+(s&&a?a.offsetLeft:0))/o,c=(r.top+(s&&a?a.offsetTop:0))/i,u=r.width/o,d=r.height/i;return{width:u,height:d,top:c,right:l+u,bottom:c+d,left:l,x:l,y:c}}function Lf(e){var t=Ef(e);return{scrollLeft:t.pageXOffset,scrollTop:t.pageYOffset}}function Pf(e){return e?(e.nodeName||"").toLowerCase():null}function If(e){return((wf(e)?e.ownerDocument:e.document)||window.document).documentElement}function Bf(e){return Df(If(e)).left+Lf(e).scrollLeft}function Rf(e){return Ef(e).getComputedStyle(e)}function Nf(e){var t=Rf(e),n=t.overflow,r=t.overflowX,o=t.overflowY;return/auto|scroll|overlay|hidden/.test(n+o+r)}function Ff(e,t,n){void 0===n&&(n=!1);var r=xf(t),o=xf(t)&&function(e){var t=e.getBoundingClientRect(),n=Mf(t.width)/e.offsetWidth||1,r=Mf(t.height)/e.offsetHeight||1;return 1!==n||1!==r}(t),i=If(t),a=Df(e,o,n),s={scrollLeft:0,scrollTop:0},l={x:0,y:0};return(r||!r&&!n)&&(("body"!==Pf(t)||Nf(i))&&(s=function(e){return e!==Ef(e)&&xf(e)?{scrollLeft:(t=e).scrollLeft,scrollTop:t.scrollTop}:Lf(e);var t}(t)),xf(t)?((l=Df(t,!0)).x+=t.clientLeft,l.y+=t.clientTop):i&&(l.x=Bf(i))),{x:a.left+s.scrollLeft-l.x,y:a.top+s.scrollTop-l.y,width:a.width,height:a.height}}function jf(e){var t=Df(e),n=e.offsetWidth,r=e.offsetHeight;return Math.abs(t.width-n)<=1&&(n=t.width),Math.abs(t.height-r)<=1&&(r=t.height),{x:e.offsetLeft,y:e.offsetTop,width:n,height:r}}function Yf(e){return"html"===Pf(e)?e:e.assignedSlot||e.parentNode||(kf(e)?e.host:null)||If(e)}function $f(e){return["html","body","#document"].indexOf(Pf(e))>=0?e.ownerDocument.body:xf(e)&&Nf(e)?e:$f(Yf(e))}function Hf(e,t){var n;void 0===t&&(t=[]);var r=$f(e),o=r===(null==(n=e.ownerDocument)?void 0:n.body),i=Ef(r),a=o?[i].concat(i.visualViewport||[],Nf(r)?r:[]):r,s=t.concat(a);return o?s:s.concat(Hf(Yf(a)))}function Uf(e){return["table","td","th"].indexOf(Pf(e))>=0}function zf(e){return xf(e)&&"fixed"!==Rf(e).position?e.offsetParent:null}function Wf(e){for(var t=Ef(e),n=zf(e);n&&Uf(n)&&"static"===Rf(n).position;)n=zf(n);return n&&("html"===Pf(n)||"body"===Pf(n)&&"static"===Rf(n).position)?t:n||function(e){var t=/firefox/i.test(Tf());if(/Trident/i.test(Tf())&&xf(e)&&"fixed"===Rf(e).position)return null;var n=Yf(e);for(kf(n)&&(n=n.host);xf(n)&&["html","body"].indexOf(Pf(n))<0;){var r=Rf(n);if("none"!==r.transform||"none"!==r.perspective||"paint"===r.contain||-1!==["transform","perspective"].indexOf(r.willChange)||t&&"filter"===r.willChange||t&&r.filter&&"none"!==r.filter)return n;n=n.parentNode}return null}(e)||t}var Vf="top",Gf="bottom",Qf="right",qf="left",Kf="auto",Zf=[Vf,Gf,Qf,qf],Jf="start",Xf="end",eh="clippingParents",th="viewport",nh="popper",rh="reference",oh=Zf.reduce((function(e,t){return e.concat([t+"-"+Jf,t+"-"+Xf])}),[]),ih=[].concat(Zf,[Kf]).reduce((function(e,t){return e.concat([t,t+"-"+Jf,t+"-"+Xf])}),[]),ah=["beforeRead","read","afterRead","beforeMain","main","afterMain","beforeWrite","write","afterWrite"];function sh(e){var t=new Map,n=new Set,r=[];function o(e){n.add(e.name),[].concat(e.requires||[],e.requiresIfExists||[]).forEach((function(e){if(!n.has(e)){var r=t.get(e);r&&o(r)}})),r.push(e)}return e.forEach((function(e){t.set(e.name,e)})),e.forEach((function(e){n.has(e.name)||o(e)})),r}var lh={placement:"bottom",modifiers:[],strategy:"absolute"};function ch(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return!t.some((function(e){return!(e&&"function"==typeof e.getBoundingClientRect)}))}function uh(e){void 0===e&&(e={});var t=e,n=t.defaultModifiers,r=void 0===n?[]:n,o=t.defaultOptions,i=void 0===o?lh:o;return function(e,t,n){void 0===n&&(n=i);var o,a,s={placement:"bottom",orderedModifiers:[],options:Object.assign({},lh,i),modifiersData:{},elements:{reference:e,popper:t},attributes:{},styles:{}},l=[],c=!1,u={state:s,setOptions:function(n){var o="function"==typeof n?n(s.options):n;d(),s.options=Object.assign({},i,s.options,o),s.scrollParents={reference:wf(e)?Hf(e):e.contextElement?Hf(e.contextElement):[],popper:Hf(t)};var a=function(e){var t=sh(e);return ah.reduce((function(e,n){return e.concat(t.filter((function(e){return e.phase===n})))}),[])}(function(e){var t=e.reduce((function(e,t){var n=e[t.name];return e[t.name]=n?Object.assign({},n,t,{options:Object.assign({},n.options,t.options),data:Object.assign({},n.data,t.data)}):t,e}),{});return Object.keys(t).map((function(e){return t[e]}))}([].concat(r,s.options.modifiers)));return s.orderedModifiers=a.filter((function(e){return e.enabled})),s.orderedModifiers.forEach((function(e){var t=e.name,n=e.options,r=void 0===n?{}:n,o=e.effect;if("function"==typeof o){var i=o({state:s,name:t,instance:u,options:r}),a=function(){};l.push(i||a)}})),u.update()},forceUpdate:function(){if(!c){var e=s.elements,t=e.reference,n=e.popper;if(ch(t,n)){s.rects={reference:Ff(t,Wf(n),"fixed"===s.options.strategy),popper:jf(n)},s.reset=!1,s.placement=s.options.placement,s.orderedModifiers.forEach((function(e){return s.modifiersData[e.name]=Object.assign({},e.data)}));for(var r=0;r<s.orderedModifiers.length;r++)if(!0!==s.reset){var o=s.orderedModifiers[r],i=o.fn,a=o.options,l=void 0===a?{}:a,d=o.name;"function"==typeof i&&(s=i({state:s,options:l,name:d,instance:u})||s)}else s.reset=!1,r=-1}}},update:(o=function(){return new Promise((function(e){u.forceUpdate(),e(s)}))},function(){return a||(a=new Promise((function(e){Promise.resolve().then((function(){a=void 0,e(o())}))}))),a}),destroy:function(){d(),c=!0}};if(!ch(e,t))return u;function d(){l.forEach((function(e){return e()})),l=[]}return u.setOptions(n).then((function(e){!c&&n.onFirstUpdate&&n.onFirstUpdate(e)})),u}}var dh={passive:!0};const ph={name:"eventListeners",enabled:!0,phase:"write",fn:function(){},effect:function(e){var t=e.state,n=e.instance,r=e.options,o=r.scroll,i=void 0===o||o,a=r.resize,s=void 0===a||a,l=Ef(t.elements.popper),c=[].concat(t.scrollParents.reference,t.scrollParents.popper);return i&&c.forEach((function(e){e.addEventListener("scroll",n.update,dh)})),s&&l.addEventListener("resize",n.update,dh),function(){i&&c.forEach((function(e){e.removeEventListener("scroll",n.update,dh)})),s&&l.removeEventListener("resize",n.update,dh)}},data:{}};function fh(e){return e.split("-")[0]}function hh(e){return e.split("-")[1]}function mh(e){return["top","bottom"].indexOf(e)>=0?"x":"y"}function gh(e){var t,n=e.reference,r=e.element,o=e.placement,i=o?fh(o):null,a=o?hh(o):null,s=n.x+n.width/2-r.width/2,l=n.y+n.height/2-r.height/2;switch(i){case Vf:t={x:s,y:n.y-r.height};break;case Gf:t={x:s,y:n.y+n.height};break;case Qf:t={x:n.x+n.width,y:l};break;case qf:t={x:n.x-r.width,y:l};break;default:t={x:n.x,y:n.y}}var c=i?mh(i):null;if(null!=c){var u="y"===c?"height":"width";switch(a){case Jf:t[c]=t[c]-(n[u]/2-r[u]/2);break;case Xf:t[c]=t[c]+(n[u]/2-r[u]/2)}}return t}const vh={name:"popperOffsets",enabled:!0,phase:"read",fn:function(e){var t=e.state,n=e.name;t.modifiersData[n]=gh({reference:t.rects.reference,element:t.rects.popper,strategy:"absolute",placement:t.placement})},data:{}};var yh={top:"auto",right:"auto",bottom:"auto",left:"auto"};function bh(e){var t,n=e.popper,r=e.popperRect,o=e.placement,i=e.variation,a=e.offsets,s=e.position,l=e.gpuAcceleration,c=e.adaptive,u=e.roundOffsets,d=e.isFixed,p=a.x,f=void 0===p?0:p,h=a.y,m=void 0===h?0:h,g="function"==typeof u?u({x:f,y:m}):{x:f,y:m};f=g.x,m=g.y;var v=a.hasOwnProperty("x"),y=a.hasOwnProperty("y"),b=qf,_=Vf,A=window;if(c){var E=Wf(n),w="clientHeight",x="clientWidth";if(E===Ef(n)&&"static"!==Rf(E=If(n)).position&&"absolute"===s&&(w="scrollHeight",x="scrollWidth"),o===Vf||(o===qf||o===Qf)&&i===Xf)_=Gf,m-=(d&&E===A&&A.visualViewport?A.visualViewport.height:E[w])-r.height,m*=l?1:-1;if(o===qf||(o===Vf||o===Gf)&&i===Xf)b=Qf,f-=(d&&E===A&&A.visualViewport?A.visualViewport.width:E[x])-r.width,f*=l?1:-1}var k,C=Object.assign({position:s},c&&yh),S=!0===u?function(e,t){var n=e.x,r=e.y,o=t.devicePixelRatio||1;return{x:Mf(n*o)/o||0,y:Mf(r*o)/o||0}}({x:f,y:m},Ef(n)):{x:f,y:m};return f=S.x,m=S.y,l?Object.assign({},C,((k={})[_]=y?"0":"",k[b]=v?"0":"",k.transform=(A.devicePixelRatio||1)<=1?"translate("+f+"px, "+m+"px)":"translate3d("+f+"px, "+m+"px, 0)",k)):Object.assign({},C,((t={})[_]=y?m+"px":"",t[b]=v?f+"px":"",t.transform="",t))}const _h={name:"computeStyles",enabled:!0,phase:"beforeWrite",fn:function(e){var t=e.state,n=e.options,r=n.gpuAcceleration,o=void 0===r||r,i=n.adaptive,a=void 0===i||i,s=n.roundOffsets,l=void 0===s||s,c={placement:fh(t.placement),variation:hh(t.placement),popper:t.elements.popper,popperRect:t.rects.popper,gpuAcceleration:o,isFixed:"fixed"===t.options.strategy};null!=t.modifiersData.popperOffsets&&(t.styles.popper=Object.assign({},t.styles.popper,bh(Object.assign({},c,{offsets:t.modifiersData.popperOffsets,position:t.options.strategy,adaptive:a,roundOffsets:l})))),null!=t.modifiersData.arrow&&(t.styles.arrow=Object.assign({},t.styles.arrow,bh(Object.assign({},c,{offsets:t.modifiersData.arrow,position:"absolute",adaptive:!1,roundOffsets:l})))),t.attributes.popper=Object.assign({},t.attributes.popper,{"data-popper-placement":t.placement})},data:{}};const Ah={name:"applyStyles",enabled:!0,phase:"write",fn:function(e){var t=e.state;Object.keys(t.elements).forEach((function(e){var n=t.styles[e]||{},r=t.attributes[e]||{},o=t.elements[e];xf(o)&&Pf(o)&&(Object.assign(o.style,n),Object.keys(r).forEach((function(e){var t=r[e];!1===t?o.removeAttribute(e):o.setAttribute(e,!0===t?"":t)})))}))},effect:function(e){var t=e.state,n={popper:{position:t.options.strategy,left:"0",top:"0",margin:"0"},arrow:{position:"absolute"},reference:{}};return Object.assign(t.elements.popper.style,n.popper),t.styles=n,t.elements.arrow&&Object.assign(t.elements.arrow.style,n.arrow),function(){Object.keys(t.elements).forEach((function(e){var r=t.elements[e],o=t.attributes[e]||{},i=Object.keys(t.styles.hasOwnProperty(e)?t.styles[e]:n[e]).reduce((function(e,t){return e[t]="",e}),{});xf(r)&&Pf(r)&&(Object.assign(r.style,i),Object.keys(o).forEach((function(e){r.removeAttribute(e)})))}))}},requires:["computeStyles"]};const Eh={name:"offset",enabled:!0,phase:"main",requires:["popperOffsets"],fn:function(e){var t=e.state,n=e.options,r=e.name,o=n.offset,i=void 0===o?[0,0]:o,a=ih.reduce((function(e,n){return e[n]=function(e,t,n){var r=fh(e),o=[qf,Vf].indexOf(r)>=0?-1:1,i="function"==typeof n?n(Object.assign({},t,{placement:e})):n,a=i[0],s=i[1];return a=a||0,s=(s||0)*o,[qf,Qf].indexOf(r)>=0?{x:s,y:a}:{x:a,y:s}}(n,t.rects,i),e}),{}),s=a[t.placement],l=s.x,c=s.y;null!=t.modifiersData.popperOffsets&&(t.modifiersData.popperOffsets.x+=l,t.modifiersData.popperOffsets.y+=c),t.modifiersData[r]=a}};var wh={left:"right",right:"left",bottom:"top",top:"bottom"};function xh(e){return e.replace(/left|right|bottom|top/g,(function(e){return wh[e]}))}var kh={start:"end",end:"start"};function Ch(e){return e.replace(/start|end/g,(function(e){return kh[e]}))}function Sh(e,t){var n=t.getRootNode&&t.getRootNode();if(e.contains(t))return!0;if(n&&kf(n)){var r=t;do{if(r&&e.isSameNode(r))return!0;r=r.parentNode||r.host}while(r)}return!1}function Mh(e){return Object.assign({},e,{left:e.x,top:e.y,right:e.x+e.width,bottom:e.y+e.height})}function Th(e,t,n){return t===th?Mh(function(e,t){var n=Ef(e),r=If(e),o=n.visualViewport,i=r.clientWidth,a=r.clientHeight,s=0,l=0;if(o){i=o.width,a=o.height;var c=Of();(c||!c&&"fixed"===t)&&(s=o.offsetLeft,l=o.offsetTop)}return{width:i,height:a,x:s+Bf(e),y:l}}(e,n)):wf(t)?function(e,t){var n=Df(e,!1,"fixed"===t);return n.top=n.top+e.clientTop,n.left=n.left+e.clientLeft,n.bottom=n.top+e.clientHeight,n.right=n.left+e.clientWidth,n.width=e.clientWidth,n.height=e.clientHeight,n.x=n.left,n.y=n.top,n}(t,n):Mh(function(e){var t,n=If(e),r=Lf(e),o=null==(t=e.ownerDocument)?void 0:t.body,i=Cf(n.scrollWidth,n.clientWidth,o?o.scrollWidth:0,o?o.clientWidth:0),a=Cf(n.scrollHeight,n.clientHeight,o?o.scrollHeight:0,o?o.clientHeight:0),s=-r.scrollLeft+Bf(e),l=-r.scrollTop;return"rtl"===Rf(o||n).direction&&(s+=Cf(n.clientWidth,o?o.clientWidth:0)-i),{width:i,height:a,x:s,y:l}}(If(e)))}function Oh(e,t,n,r){var o="clippingParents"===t?function(e){var t=Hf(Yf(e)),n=["absolute","fixed"].indexOf(Rf(e).position)>=0&&xf(e)?Wf(e):e;return wf(n)?t.filter((function(e){return wf(e)&&Sh(e,n)&&"body"!==Pf(e)})):[]}(e):[].concat(t),i=[].concat(o,[n]),a=i[0],s=i.reduce((function(t,n){var o=Th(e,n,r);return t.top=Cf(o.top,t.top),t.right=Sf(o.right,t.right),t.bottom=Sf(o.bottom,t.bottom),t.left=Cf(o.left,t.left),t}),Th(e,a,r));return s.width=s.right-s.left,s.height=s.bottom-s.top,s.x=s.left,s.y=s.top,s}function Dh(e){return Object.assign({},{top:0,right:0,bottom:0,left:0},e)}function Lh(e,t){return t.reduce((function(t,n){return t[n]=e,t}),{})}function Ph(e,t){void 0===t&&(t={});var n=t,r=n.placement,o=void 0===r?e.placement:r,i=n.strategy,a=void 0===i?e.strategy:i,s=n.boundary,l=void 0===s?eh:s,c=n.rootBoundary,u=void 0===c?th:c,d=n.elementContext,p=void 0===d?nh:d,f=n.altBoundary,h=void 0!==f&&f,m=n.padding,g=void 0===m?0:m,v=Dh("number"!=typeof g?g:Lh(g,Zf)),y=p===nh?rh:nh,b=e.rects.popper,_=e.elements[h?y:p],A=Oh(wf(_)?_:_.contextElement||If(e.elements.popper),l,u,a),E=Df(e.elements.reference),w=gh({reference:E,element:b,strategy:"absolute",placement:o}),x=Mh(Object.assign({},b,w)),k=p===nh?x:E,C={top:A.top-k.top+v.top,bottom:k.bottom-A.bottom+v.bottom,left:A.left-k.left+v.left,right:k.right-A.right+v.right},S=e.modifiersData.offset;if(p===nh&&S){var M=S[o];Object.keys(C).forEach((function(e){var t=[Qf,Gf].indexOf(e)>=0?1:-1,n=[Vf,Gf].indexOf(e)>=0?"y":"x";C[e]+=M[n]*t}))}return C}const Ih={name:"flip",enabled:!0,phase:"main",fn:function(e){var t=e.state,n=e.options,r=e.name;if(!t.modifiersData[r]._skip){for(var o=n.mainAxis,i=void 0===o||o,a=n.altAxis,s=void 0===a||a,l=n.fallbackPlacements,c=n.padding,u=n.boundary,d=n.rootBoundary,p=n.altBoundary,f=n.flipVariations,h=void 0===f||f,m=n.allowedAutoPlacements,g=t.options.placement,v=fh(g),y=l||(v===g||!h?[xh(g)]:function(e){if(fh(e)===Kf)return[];var t=xh(e);return[Ch(e),t,Ch(t)]}(g)),b=[g].concat(y).reduce((function(e,n){return e.concat(fh(n)===Kf?function(e,t){void 0===t&&(t={});var n=t,r=n.placement,o=n.boundary,i=n.rootBoundary,a=n.padding,s=n.flipVariations,l=n.allowedAutoPlacements,c=void 0===l?ih:l,u=hh(r),d=u?s?oh:oh.filter((function(e){return hh(e)===u})):Zf,p=d.filter((function(e){return c.indexOf(e)>=0}));0===p.length&&(p=d);var f=p.reduce((function(t,n){return t[n]=Ph(e,{placement:n,boundary:o,rootBoundary:i,padding:a})[fh(n)],t}),{});return Object.keys(f).sort((function(e,t){return f[e]-f[t]}))}(t,{placement:n,boundary:u,rootBoundary:d,padding:c,flipVariations:h,allowedAutoPlacements:m}):n)}),[]),_=t.rects.reference,A=t.rects.popper,E=new Map,w=!0,x=b[0],k=0;k<b.length;k++){var C=b[k],S=fh(C),M=hh(C)===Jf,T=[Vf,Gf].indexOf(S)>=0,O=T?"width":"height",D=Ph(t,{placement:C,boundary:u,rootBoundary:d,altBoundary:p,padding:c}),L=T?M?Qf:qf:M?Gf:Vf;_[O]>A[O]&&(L=xh(L));var P=xh(L),I=[];if(i&&I.push(D[S]<=0),s&&I.push(D[L]<=0,D[P]<=0),I.every((function(e){return e}))){x=C,w=!1;break}E.set(C,I)}if(w)for(var B=function(e){var t=b.find((function(t){var n=E.get(t);if(n)return n.slice(0,e).every((function(e){return e}))}));if(t)return x=t,"break"},R=h?3:1;R>0;R--){if("break"===B(R))break}t.placement!==x&&(t.modifiersData[r]._skip=!0,t.placement=x,t.reset=!0)}},requiresIfExists:["offset"],data:{_skip:!1}};function Bh(e,t,n){return Cf(e,Sf(t,n))}const Rh={name:"preventOverflow",enabled:!0,phase:"main",fn:function(e){var t=e.state,n=e.options,r=e.name,o=n.mainAxis,i=void 0===o||o,a=n.altAxis,s=void 0!==a&&a,l=n.boundary,c=n.rootBoundary,u=n.altBoundary,d=n.padding,p=n.tether,f=void 0===p||p,h=n.tetherOffset,m=void 0===h?0:h,g=Ph(t,{boundary:l,rootBoundary:c,padding:d,altBoundary:u}),v=fh(t.placement),y=hh(t.placement),b=!y,_=mh(v),A="x"===_?"y":"x",E=t.modifiersData.popperOffsets,w=t.rects.reference,x=t.rects.popper,k="function"==typeof m?m(Object.assign({},t.rects,{placement:t.placement})):m,C="number"==typeof k?{mainAxis:k,altAxis:k}:Object.assign({mainAxis:0,altAxis:0},k),S=t.modifiersData.offset?t.modifiersData.offset[t.placement]:null,M={x:0,y:0};if(E){if(i){var T,O="y"===_?Vf:qf,D="y"===_?Gf:Qf,L="y"===_?"height":"width",P=E[_],I=P+g[O],B=P-g[D],R=f?-x[L]/2:0,N=y===Jf?w[L]:x[L],F=y===Jf?-x[L]:-w[L],j=t.elements.arrow,Y=f&&j?jf(j):{width:0,height:0},$=t.modifiersData["arrow#persistent"]?t.modifiersData["arrow#persistent"].padding:{top:0,right:0,bottom:0,left:0},H=$[O],U=$[D],z=Bh(0,w[L],Y[L]),W=b?w[L]/2-R-z-H-C.mainAxis:N-z-H-C.mainAxis,V=b?-w[L]/2+R+z+U+C.mainAxis:F+z+U+C.mainAxis,G=t.elements.arrow&&Wf(t.elements.arrow),Q=G?"y"===_?G.clientTop||0:G.clientLeft||0:0,q=null!=(T=null==S?void 0:S[_])?T:0,K=P+V-q,Z=Bh(f?Sf(I,P+W-q-Q):I,P,f?Cf(B,K):B);E[_]=Z,M[_]=Z-P}if(s){var J,X="x"===_?Vf:qf,ee="x"===_?Gf:Qf,te=E[A],ne="y"===A?"height":"width",re=te+g[X],oe=te-g[ee],ie=-1!==[Vf,qf].indexOf(v),ae=null!=(J=null==S?void 0:S[A])?J:0,se=ie?re:te-w[ne]-x[ne]-ae+C.altAxis,le=ie?te+w[ne]+x[ne]-ae-C.altAxis:oe,ce=f&&ie?function(e,t,n){var r=Bh(e,t,n);return r>n?n:r}(se,te,le):Bh(f?se:re,te,f?le:oe);E[A]=ce,M[A]=ce-te}t.modifiersData[r]=M}},requiresIfExists:["offset"]};const Nh={name:"arrow",enabled:!0,phase:"main",fn:function(e){var t,n=e.state,r=e.name,o=e.options,i=n.elements.arrow,a=n.modifiersData.popperOffsets,s=fh(n.placement),l=mh(s),c=[qf,Qf].indexOf(s)>=0?"height":"width";if(i&&a){var u=function(e,t){return Dh("number"!=typeof(e="function"==typeof e?e(Object.assign({},t.rects,{placement:t.placement})):e)?e:Lh(e,Zf))}(o.padding,n),d=jf(i),p="y"===l?Vf:qf,f="y"===l?Gf:Qf,h=n.rects.reference[c]+n.rects.reference[l]-a[l]-n.rects.popper[c],m=a[l]-n.rects.reference[l],g=Wf(i),v=g?"y"===l?g.clientHeight||0:g.clientWidth||0:0,y=h/2-m/2,b=u[p],_=v-d[c]-u[f],A=v/2-d[c]/2+y,E=Bh(b,A,_),w=l;n.modifiersData[r]=((t={})[w]=E,t.centerOffset=E-A,t)}},effect:function(e){var t=e.state,n=e.options.element,r=void 0===n?"[data-popper-arrow]":n;null!=r&&("string"!=typeof r||(r=t.elements.popper.querySelector(r)))&&Sh(t.elements.popper,r)&&(t.elements.arrow=r)},requires:["popperOffsets"],requiresIfExists:["preventOverflow"]};function Fh(e,t,n){return void 0===n&&(n={x:0,y:0}),{top:e.top-t.height-n.y,right:e.right-t.width+n.x,bottom:e.bottom-t.height+n.y,left:e.left-t.width-n.x}}function jh(e){return[Vf,Qf,Gf,qf].some((function(t){return e[t]>=0}))}const Yh={name:"hide",enabled:!0,phase:"main",requiresIfExists:["preventOverflow"],fn:function(e){var t=e.state,n=e.name,r=t.rects.reference,o=t.rects.popper,i=t.modifiersData.preventOverflow,a=Ph(t,{elementContext:"reference"}),s=Ph(t,{altBoundary:!0}),l=Fh(a,r),c=Fh(s,o,i),u=jh(l),d=jh(c);t.modifiersData[n]={referenceClippingOffsets:l,popperEscapeOffsets:c,isReferenceHidden:u,hasPopperEscaped:d},t.attributes.popper=Object.assign({},t.attributes.popper,{"data-popper-reference-hidden":u,"data-popper-escaped":d})}};var $h=uh({defaultModifiers:[ph,vh,_h,Ah,Eh,Ih,Rh,Nh,Yh]});function Hh(e={}){const{enabled:t=!0,modifiers:n,placement:r="bottom",strategy:o="absolute",arrowPadding:a=8,eventListeners:s=!0,offset:l,gutter:c=8,flip:u=!0,boundary:d="clippingParents",preventOverflow:p=!0,matchWidth:f,direction:h="ltr"}=e,m=(0,i.useRef)(null),g=(0,i.useRef)(null),v=(0,i.useRef)(null),y=function(e,t="ltr"){var n,r;const o=(null==(n=_f[e])?void 0:n[t])||e;return"ltr"===t?o:null!=(r=Af[e])?r:o}(r,h),b=(0,i.useRef)((()=>{})),_=(0,i.useCallback)((()=>{var e;t&&m.current&&g.current&&(null==(e=b.current)||e.call(b),v.current=$h(m.current,g.current,{placement:y,modifiers:[yf,mf,ff,{...pf,enabled:!!f},{name:"eventListeners",...df(s)},{name:"arrow",options:{padding:a}},{name:"offset",options:{offset:null!=l?l:[0,c]}},{name:"flip",enabled:!!u,options:{padding:8}},{name:"preventOverflow",enabled:!!p,options:{boundary:d}},...null!=n?n:[]],strategy:o}),v.current.forceUpdate(),b.current=v.current.destroy)}),[y,t,n,f,s,a,l,c,u,p,d,o]);(0,i.useEffect)((()=>()=>{var e;m.current||g.current||(null==(e=v.current)||e.destroy(),v.current=null)}),[]);const A=(0,i.useCallback)((e=>{m.current=e,_()}),[_]),E=(0,i.useCallback)(((e={},t=null)=>({...e,ref:Ur(A,t)})),[A]),w=(0,i.useCallback)((e=>{g.current=e,_()}),[_]),x=(0,i.useCallback)(((e={},t=null)=>({...e,ref:Ur(w,t),style:{...e.style,position:o,minWidth:f?void 0:"max-content",inset:"0 auto auto 0"}})),[o,w,f]),k=(0,i.useCallback)(((e={},t=null)=>{const{size:n,shadowColor:r,bg:o,style:i,...a}=e;return{...a,ref:t,"data-popper-arrow":"",style:Uh(e)}}),[]),C=(0,i.useCallback)(((e={},t=null)=>({...e,ref:t,"data-popper-arrow-inner":""})),[]);return{update(){var e;null==(e=v.current)||e.update()},forceUpdate(){var e;null==(e=v.current)||e.forceUpdate()},transformOrigin:lf.transformOrigin.varRef,referenceRef:A,popperRef:w,getPopperProps:x,getArrowProps:k,getArrowInnerProps:C,getReferenceProps:E}}function Uh(e){const{size:t,shadowColor:n,bg:r,style:o}=e,i={...o,position:"absolute"};return t&&(i["--popper-arrow-size"]=t),n&&(i["--popper-arrow-shadow-color"]=n),r&&(i["--popper-arrow-bg"]=r),i}function zh(e,t=[]){const n=(0,i.useRef)(e);return(0,i.useEffect)((()=>{n.current=e})),(0,i.useCallback)(((...e)=>{var t;return null==(t=n.current)?void 0:t.call(n,...e)}),t)}function Wh(e={}){const{onClose:t,onOpen:n,isOpen:r,id:o}=e,a=zh(n),s=zh(t),[l,c]=(0,i.useState)(e.defaultIsOpen||!1),u=void 0!==r?r:l,d=void 0!==r,p=(0,i.useId)(),f=null!=o?o:`disclosure-${p}`,h=(0,i.useCallback)((()=>{d||c(!1),null==s||s()}),[d,s]),m=(0,i.useCallback)((()=>{d||c(!0),null==a||a()}),[d,a]),g=(0,i.useCallback)((()=>{u?h():m()}),[u,m,h]);return{isOpen:u,onOpen:m,onClose:h,onToggle:g,isControlled:d,getButtonProps:function(e={}){return{...e,"aria-expanded":u,"aria-controls":f,onClick(t){var n;null==(n=e.onClick)||n.call(e,t),g()}}},getDisclosureProps:function(e={}){return{...e,hidden:!u,id:f}}}}function Vh(e,t,n,r){const o=zh(n);return(0,i.useEffect)((()=>{const i="function"==typeof e?e():null!=e?e:document;if(n&&i)return i.addEventListener(t,o,r),()=>{i.removeEventListener(t,o,r)}}),[t,e,r,o,n]),()=>{const n="function"==typeof e?e():null!=e?e:document;null==n||n.removeEventListener(t,o,r)}}var Gh=e=>{var t;return(null==(t=e.current)?void 0:t.ownerDocument)||document},Qh=e=>{var t,n;return(null==(n=null==(t=e.current)?void 0:t.ownerDocument)?void 0:n.defaultView)||window};function qh(e={}){const{openDelay:t=0,closeDelay:n=0,closeOnClick:r=!0,closeOnMouseDown:o,closeOnScroll:a,closeOnPointerDown:s=o,closeOnEsc:l=!0,onOpen:c,onClose:u,placement:d,id:p,isOpen:f,defaultIsOpen:h,arrowSize:m=10,arrowShadowColor:g,arrowPadding:v,modifiers:y,isDisabled:b,gutter:_,offset:A,direction:E,...x}=e,{isOpen:k,onOpen:C,onClose:S}=Wh({isOpen:f,defaultIsOpen:h,onOpen:c,onClose:u}),{referenceRef:M,getPopperProps:T,getArrowInnerProps:O,getArrowProps:D}=Hh({enabled:k,placement:d,arrowPadding:v,modifiers:y,gutter:_,offset:A,direction:E}),L=(0,i.useId)(),P=`tooltip-${null!=p?p:L}`,I=(0,i.useRef)(null),B=(0,i.useRef)(),R=(0,i.useCallback)((()=>{B.current&&(clearTimeout(B.current),B.current=void 0)}),[]),N=(0,i.useRef)(),F=(0,i.useCallback)((()=>{N.current&&(clearTimeout(N.current),N.current=void 0)}),[]),j=(0,i.useCallback)((()=>{F(),S()}),[S,F]),Y=function(e,t){return(0,i.useEffect)((()=>{const n=Gh(e);return n.addEventListener(Kh,t),()=>n.removeEventListener(Kh,t)}),[t,e]),()=>{const t=Gh(e),n=Qh(e);t.dispatchEvent(new n.CustomEvent(Kh))}}(I,j),$=(0,i.useCallback)((()=>{if(!b&&!B.current){k&&Y();const e=Qh(I);B.current=e.setTimeout(C,t)}}),[Y,b,k,C,t]),H=(0,i.useCallback)((()=>{R();const e=Qh(I);N.current=e.setTimeout(j,n)}),[n,j,R]),U=(0,i.useCallback)((()=>{k&&r&&H()}),[r,H,k]),z=(0,i.useCallback)((()=>{k&&s&&H()}),[s,H,k]),W=(0,i.useCallback)((e=>{k&&"Escape"===e.key&&H()}),[k,H]);Vh((()=>Gh(I)),"keydown",l?W:void 0),Vh((()=>{if(!a)return null;const e=I.current;if(!e)return null;const t=af(e);return"body"===t.localName?Qh(I):t}),"scroll",(()=>{k&&a&&j()}),{passive:!0,capture:!0}),(0,i.useEffect)((()=>{b&&(R(),k&&S())}),[b,k,S,R]),(0,i.useEffect)((()=>()=>{R(),F()}),[R,F]),Vh((()=>I.current),"pointerleave",H);const V=(0,i.useCallback)(((e={},t=null)=>({...e,ref:Ur(I,t,M),onPointerEnter:w(e.onPointerEnter,(e=>{"touch"!==e.pointerType&&$()})),onClick:w(e.onClick,U),onPointerDown:w(e.onPointerDown,z),onFocus:w(e.onFocus,$),onBlur:w(e.onBlur,H),"aria-describedby":k?P:void 0})),[$,H,z,k,P,U,M]),G=(0,i.useCallback)(((e={},t=null)=>T({...e,style:{...e.style,[lf.arrowSize.var]:m?`${m}px`:void 0,[lf.arrowShadowColor.var]:g}},t)),[T,m,g]),Q=(0,i.useCallback)(((e={},t=null)=>{const n={...e.style,position:"relative",transformOrigin:lf.transformOrigin.varRef};return{ref:t,...x,...e,id:P,role:"tooltip",style:n}}),[x,P]);return{isOpen:k,show:$,hide:H,getTriggerProps:V,getTooltipProps:Q,getTooltipPositionerProps:G,getArrowProps:D,getArrowInnerProps:O}}var Kh="chakra-ui:close-tooltip";var[Zh,Jh]=xr({strict:!1,name:"PortalManagerContext"});function Xh(e){const{children:t,zIndex:n}=e;return(0,br.jsx)(Zh,{value:{zIndex:n},children:t})}Xh.displayName="PortalManager";var em=Boolean(null==globalThis?void 0:globalThis.document)?i.useLayoutEffect:i.useEffect,[tm,nm]=xr({strict:!1,name:"PortalContext"}),rm="chakra-portal",om=e=>(0,br.jsx)("div",{className:"chakra-portal-zIndex",style:{position:"absolute",zIndex:e.zIndex,top:0,left:0,right:0},children:e.children}),im=e=>{const{appendToParentPortal:t,children:n}=e,[r,o]=(0,i.useState)(null),a=(0,i.useRef)(null),[,s]=(0,i.useState)({});(0,i.useEffect)((()=>s({})),[]);const l=nm(),c=Jh();em((()=>{if(!r)return;const e=r.ownerDocument,n=t&&null!=l?l:e.body;if(!n)return;a.current=e.createElement("div"),a.current.className=rm,n.appendChild(a.current),s({});const o=a.current;return()=>{n.contains(o)&&n.removeChild(o)}}),[r]);const u=(null==c?void 0:c.zIndex)?(0,br.jsx)(om,{zIndex:null==c?void 0:c.zIndex,children:n}):n;return a.current?(0,Zr.createPortal)((0,br.jsx)(tm,{value:a.current,children:u}),a.current):(0,br.jsx)("span",{ref:e=>{e&&o(e)}})},am=e=>{const{children:t,containerRef:n,appendToParentPortal:r}=e,o=n.current,a=null!=o?o:"undefined"!=typeof window?document.body:void 0,s=(0,i.useMemo)((()=>{const e=null==o?void 0:o.ownerDocument.createElement("div");return e&&(e.className=rm),e}),[o]),[,l]=(0,i.useState)({});return em((()=>l({})),[]),em((()=>{if(s&&a)return a.appendChild(s),()=>{a.removeChild(s)}}),[s,a]),a&&s?(0,Zr.createPortal)((0,br.jsx)(tm,{value:r?s:null,children:t}),s):null};function sm(e){const t={appendToParentPortal:!0,...e},{containerRef:n,...r}=t;return n?(0,br.jsx)(am,{containerRef:n,...r}):(0,br.jsx)(im,{...r})}sm.className=rm,sm.selector=".chakra-portal",sm.displayName="Portal";const lm=["transformPerspective","x","y","z","translateX","translateY","translateZ","scale","scaleX","scaleY","rotate","rotateX","rotateY","rotateZ","skew","skewX","skewY"],cm=(()=>new Set(lm))(),um=(e,t,n)=>n>t?t:n<e?e:n,dm={test:e=>"number"==typeof e,parse:parseFloat,transform:e=>e},pm={...dm,transform:e=>um(0,1,e)},fm={...dm,default:1},hm=e=>Math.round(1e5*e)/1e5,mm=/-?(?:\d+(?:\.\d+)?|\.\d+)/gu;const gm=/^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu,vm=(e,t)=>n=>Boolean("string"==typeof n&&gm.test(n)&&n.startsWith(e)||t&&!function(e){return null==e}(n)&&Object.prototype.hasOwnProperty.call(n,t)),ym=(e,t,n)=>r=>{if("string"!=typeof r)return r;const[o,i,a,s]=r.match(mm);return{[e]:parseFloat(o),[t]:parseFloat(i),[n]:parseFloat(a),alpha:void 0!==s?parseFloat(s):1}},bm={...dm,transform:e=>Math.round((e=>um(0,255,e))(e))},_m={test:vm("rgb","red"),parse:ym("red","green","blue"),transform:({red:e,green:t,blue:n,alpha:r=1})=>"rgba("+bm.transform(e)+", "+bm.transform(t)+", "+bm.transform(n)+", "+hm(pm.transform(r))+")"};const Am={test:vm("#"),parse:function(e){let t="",n="",r="",o="";return e.length>5?(t=e.substring(1,3),n=e.substring(3,5),r=e.substring(5,7),o=e.substring(7,9)):(t=e.substring(1,2),n=e.substring(2,3),r=e.substring(3,4),o=e.substring(4,5),t+=t,n+=n,r+=r,o+=o),{red:parseInt(t,16),green:parseInt(n,16),blue:parseInt(r,16),alpha:o?parseInt(o,16)/255:1}},transform:_m.transform},Em=e=>({test:t=>"string"==typeof t&&t.endsWith(e)&&1===t.split(" ").length,parse:parseFloat,transform:t=>`${t}${e}`}),wm=Em("deg"),xm=Em("%"),km=Em("px"),Cm=Em("vh"),Sm=Em("vw"),Mm=(()=>({...xm,parse:e=>xm.parse(e)/100,transform:e=>xm.transform(100*e)}))(),Tm={test:vm("hsl","hue"),parse:ym("hue","saturation","lightness"),transform:({hue:e,saturation:t,lightness:n,alpha:r=1})=>"hsla("+Math.round(e)+", "+xm.transform(hm(t))+", "+xm.transform(hm(n))+", "+hm(pm.transform(r))+")"},Om={test:e=>_m.test(e)||Am.test(e)||Tm.test(e),parse:e=>_m.test(e)?_m.parse(e):Tm.test(e)?Tm.parse(e):Am.parse(e),transform:e=>"string"==typeof e?e:e.hasOwnProperty("red")?_m.transform(e):Tm.transform(e),getAnimatableNone:e=>{const t=Om.parse(e);return t.alpha=0,Om.transform(t)}},Dm=/(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;const Lm="number",Pm="color",Im="var",Bm="var(",Rm="${}",Nm=/var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;function Fm(e){const t=e.toString(),n=[],r={color:[],number:[],var:[]},o=[];let i=0;const a=t.replace(Nm,(e=>(Om.test(e)?(r.color.push(i),o.push(Pm),n.push(Om.parse(e))):e.startsWith(Bm)?(r.var.push(i),o.push(Im),n.push(e)):(r.number.push(i),o.push(Lm),n.push(parseFloat(e))),++i,Rm))).split(Rm);return{values:n,split:a,indexes:r,types:o}}function jm({split:e,types:t}){const n=e.length;return r=>{let o="";for(let i=0;i<n;i++)if(o+=e[i],void 0!==r[i]){const e=t[i];o+=e===Lm?hm(r[i]):e===Pm?Om.transform(r[i]):r[i]}return o}}const Ym=(e,t)=>"number"==typeof e?t?.trim().endsWith("/")?e:0:(e=>"number"==typeof e?0:Om.test(e)?Om.getAnimatableNone(e):e)(e);const $m={test:function(e){return isNaN(e)&&"string"==typeof e&&(e.match(mm)?.length||0)+(e.match(Dm)?.length||0)>0},parse:function(e){return Fm(e).values},createTransformer:function(e){return jm(Fm(e))},getAnimatableNone:function(e){const t=Fm(e);return jm(t)(t.values.map(((e,n)=>Ym(e,t.split[n]))))}},Hm=new Set(["brightness","contrast","saturate","opacity"]);function Um(e){const[t,n]=e.slice(0,-1).split("(");if("drop-shadow"===t)return e;const[r]=n.match(mm)||[];if(!r)return e;const o=n.replace(r,"");let i=Hm.has(t)?1:0;return r!==n&&(i*=100),t+"("+i+o+")"}const zm=/\b([a-z-]*)\(.*?\)/gu,Wm={...$m,getAnimatableNone:e=>{const t=e.match(zm);return t?t.map(Um).join(" "):e}},Vm={...$m,getAnimatableNone:e=>{const t=$m.parse(e);return $m.createTransformer(e)(t.map((e=>"number"==typeof e?0:"object"==typeof e?{...e,alpha:1}:e)))}},Gm={...dm,transform:Math.round},Qm={borderWidth:km,borderTopWidth:km,borderRightWidth:km,borderBottomWidth:km,borderLeftWidth:km,borderRadius:km,borderTopLeftRadius:km,borderTopRightRadius:km,borderBottomRightRadius:km,borderBottomLeftRadius:km,width:km,maxWidth:km,height:km,maxHeight:km,top:km,right:km,bottom:km,left:km,inset:km,insetBlock:km,insetBlockStart:km,insetBlockEnd:km,insetInline:km,insetInlineStart:km,insetInlineEnd:km,padding:km,paddingTop:km,paddingRight:km,paddingBottom:km,paddingLeft:km,paddingBlock:km,paddingBlockStart:km,paddingBlockEnd:km,paddingInline:km,paddingInlineStart:km,paddingInlineEnd:km,margin:km,marginTop:km,marginRight:km,marginBottom:km,marginLeft:km,marginBlock:km,marginBlockStart:km,marginBlockEnd:km,marginInline:km,marginInlineStart:km,marginInlineEnd:km,fontSize:km,backgroundPositionX:km,backgroundPositionY:km,...{rotate:wm,rotateX:wm,rotateY:wm,rotateZ:wm,scale:fm,scaleX:fm,scaleY:fm,scaleZ:fm,skew:wm,skewX:wm,skewY:wm,distance:km,translateX:km,translateY:km,translateZ:km,x:km,y:km,z:km,perspective:km,transformPerspective:km,opacity:pm,originX:Mm,originY:Mm,originZ:km},zIndex:Gm,fillOpacity:pm,strokeOpacity:pm,numOctaves:Gm},qm={...Qm,color:Om,backgroundColor:Om,outlineColor:Om,fill:Om,stroke:Om,borderColor:Om,borderTopColor:Om,borderRightColor:Om,borderBottomColor:Om,borderLeftColor:Om,filter:Wm,WebkitFilter:Wm,mask:Vm,WebkitMask:Vm},Km=e=>qm[e],Zm=()=>({x:{translate:0,scale:1,origin:0,originPoint:0},y:{translate:0,scale:1,origin:0,originPoint:0}}),Jm=()=>({x:{min:0,max:0},y:{min:0,max:0}}),Xm=e=>Boolean(e&&e.getVelocity),eg=new Set(["width","height","top","left","right","bottom",...lm]),tg=e=>t=>t.test(e),ng=[dm,km,xm,wm,Sm,Cm,{test:e=>"auto"===e,parse:e=>e}],rg=e=>ng.find(tg(e));let og=()=>{},ig=()=>{};const ag=e=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e),sg=e=>t=>"string"==typeof t&&t.startsWith(e),lg=sg("--"),cg=sg("var(--"),ug=e=>!!cg(e)&&dg.test(e.split("/*")[0].trim()),dg=/var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;function pg(e){return"string"==typeof e&&e.split("/*")[0].includes("var(--")}const fg=/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;function hg(e,t,n=1){ig(n<=4,`Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`,"max-css-var-depth");const[r,o]=function(e){const t=fg.exec(e);if(!t)return[,];const[,n,r,o]=t;return[`--${n??r}`,o]}(e);if(!r)return;const i=window.getComputedStyle(t).getPropertyValue(r);if(i){const e=i.trim();return ag(e)?parseFloat(e):e}return ug(o)?hg(o,t,n+1):o}const mg=e=>180*e/Math.PI,gg=e=>{const t=mg(Math.atan2(e[1],e[0]));return yg(t)},vg={x:4,y:5,translateX:4,translateY:5,scaleX:0,scaleY:3,scale:e=>(Math.abs(e[0])+Math.abs(e[3]))/2,rotate:gg,rotateZ:gg,skewX:e=>mg(Math.atan(e[1])),skewY:e=>mg(Math.atan(e[2])),skew:e=>(Math.abs(e[1])+Math.abs(e[2]))/2},yg=e=>((e%=360)<0&&(e+=360),e),bg=e=>Math.sqrt(e[0]*e[0]+e[1]*e[1]),_g=e=>Math.sqrt(e[4]*e[4]+e[5]*e[5]),Ag={x:12,y:13,z:14,translateX:12,translateY:13,translateZ:14,scaleX:bg,scaleY:_g,scale:e=>(bg(e)+_g(e))/2,rotateX:e=>yg(mg(Math.atan2(e[6],e[5]))),rotateY:e=>yg(mg(Math.atan2(-e[2],e[0]))),rotateZ:gg,rotate:gg,skewX:e=>mg(Math.atan(e[4])),skewY:e=>mg(Math.atan(e[1])),skew:e=>(Math.abs(e[1])+Math.abs(e[4]))/2};function Eg(e){return e.includes("scale")?1:0}function wg(e,t){if(!e||"none"===e)return Eg(t);const n=e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);let r,o;if(n)r=Ag,o=n;else{const t=e.match(/^matrix\(([-\d.e\s,]+)\)$/u);r=vg,o=t}if(!o)return Eg(t);const i=r[t],a=o[1].split(",").map(xg);return"function"==typeof i?i(a):a[i]}function xg(e){return parseFloat(e.trim())}const kg=e=>e===dm||e===km,Cg=new Set(["x","y","z"]),Sg=lm.filter((e=>!Cg.has(e)));const Mg={width:({x:e},{paddingLeft:t="0",paddingRight:n="0",boxSizing:r})=>{const o=e.max-e.min;return"border-box"===r?o:o-parseFloat(t)-parseFloat(n)},height:({y:e},{paddingTop:t="0",paddingBottom:n="0",boxSizing:r})=>{const o=e.max-e.min;return"border-box"===r?o:o-parseFloat(t)-parseFloat(n)},top:(e,{top:t})=>parseFloat(t),left:(e,{left:t})=>parseFloat(t),bottom:({y:e},{top:t})=>parseFloat(t)+(e.max-e.min),right:({x:e},{left:t})=>parseFloat(t)+(e.max-e.min),x:(e,{transform:t})=>wg(t,"x"),y:(e,{transform:t})=>wg(t,"y")};Mg.translateX=Mg.x,Mg.translateY=Mg.y;const Tg=e=>e,Og={},Dg=["setup","read","resolveKeyframes","preUpdate","update","preRender","render","postRender"],Lg={value:null,addProjectionMetrics:null};function Pg(e,t){let n=!1,r=!0;const o={delta:0,timestamp:0,isProcessing:!1},i=()=>n=!0,a=Dg.reduce(((e,n)=>(e[n]=function(e,t){let n=new Set,r=new Set,o=!1,i=!1;const a=new WeakSet;let s={delta:0,timestamp:0,isProcessing:!1},l=0;function c(t){a.has(t)&&(u.schedule(t),e()),l++,t(s)}const u={schedule:(e,t=!1,i=!1)=>{const s=i&&o?n:r;return t&&a.add(e),s.add(e),e},cancel:e=>{r.delete(e),a.delete(e)},process:e=>{if(s=e,o)return void(i=!0);o=!0;const a=n;n=r,r=a,n.forEach(c),t&&Lg.value&&Lg.value.frameloop[t].push(l),l=0,n.clear(),o=!1,i&&(i=!1,u.process(e))}};return u}(i,t?n:void 0),e)),{}),{setup:s,read:l,resolveKeyframes:c,preUpdate:u,update:d,preRender:p,render:f,postRender:h}=a,m=()=>{const i=Og.useManualTiming,a=i?o.timestamp:performance.now();n=!1,i||(o.delta=r?1e3/60:Math.max(Math.min(a-o.timestamp,40),1)),o.timestamp=a,o.isProcessing=!0,s.process(o),l.process(o),c.process(o),u.process(o),d.process(o),p.process(o),f.process(o),h.process(o),o.isProcessing=!1,n&&t&&(r=!1,e(m))};return{schedule:Dg.reduce(((t,i)=>{const s=a[i];return t[i]=(t,i=!1,a=!1)=>(n||(n=!0,r=!0,o.isProcessing||e(m)),s.schedule(t,i,a)),t}),{}),cancel:e=>{for(let t=0;t<Dg.length;t++)a[Dg[t]].cancel(e)},state:o,steps:a}}const{schedule:Ig,cancel:Bg,state:Rg,steps:Ng}=Pg("undefined"!=typeof requestAnimationFrame?requestAnimationFrame:Tg,!0),Fg=new Set;let jg=!1,Yg=!1,$g=!1;function Hg(){if(Yg){const e=Array.from(Fg).filter((e=>e.needsMeasurement)),t=new Set(e.map((e=>e.element))),n=new Map;t.forEach((e=>{const t=function(e){const t=[];return Sg.forEach((n=>{const r=e.getValue(n);void 0!==r&&(t.push([n,r.get()]),r.set(n.startsWith("scale")?1:0))})),t}(e);t.length&&(n.set(e,t),e.render())})),e.forEach((e=>e.measureInitialState())),t.forEach((e=>{e.render();const t=n.get(e);t&&t.forEach((([t,n])=>{e.getValue(t)?.set(n)}))})),e.forEach((e=>e.measureEndState())),e.forEach((e=>{void 0!==e.suspendedScrollY&&window.scrollTo(0,e.suspendedScrollY)}))}Yg=!1,jg=!1,Fg.forEach((e=>e.complete($g))),Fg.clear()}function Ug(){Fg.forEach((e=>{e.readKeyframes(),e.needsMeasurement&&(Yg=!0)}))}class zg{constructor(e,t,n,r,o,i=!1){this.state="pending",this.isAsync=!1,this.needsMeasurement=!1,this.unresolvedKeyframes=[...e],this.onComplete=t,this.name=n,this.motionValue=r,this.element=o,this.isAsync=i}scheduleResolve(){this.state="scheduled",this.isAsync?(Fg.add(this),jg||(jg=!0,Ig.read(Ug),Ig.resolveKeyframes(Hg))):(this.readKeyframes(),this.complete())}readKeyframes(){const{unresolvedKeyframes:e,name:t,element:n,motionValue:r}=this;if(null===e[0]){const o=r?.get(),i=e[e.length-1];if(void 0!==o)e[0]=o;else if(n&&t){const r=n.readValue(t,i);null!=r&&(e[0]=r)}void 0===e[0]&&(e[0]=i),r&&void 0===o&&r.set(e[0])}!function(e){for(let t=1;t<e.length;t++)e[t]??(e[t]=e[t-1])}(e)}setFinalKeyframe(){}measureInitialState(){}renderEndStyles(){}measureEndState(){}complete(e=!1){this.state="complete",this.onComplete(this.unresolvedKeyframes,this.finalKeyframe,e),Fg.delete(this)}cancel(){"scheduled"===this.state&&(Fg.delete(this),this.state="pending")}resume(){"pending"===this.state&&this.scheduleResolve()}}const Wg=e=>/^0[^.\s]+$/u.test(e);const Vg=new Set([Wm,Vm]);function Gg(e,t){let n=Km(e);return Vg.has(n)||(n=$m),n.getAnimatableNone?n.getAnimatableNone(t):void 0}const Qg=new Set(["auto","none","0"]);class qg extends zg{constructor(e,t,n,r,o){super(e,t,n,r,o,!0)}readKeyframes(){const{unresolvedKeyframes:e,element:t,name:n}=this;if(!t||!t.current)return;super.readKeyframes();for(let n=0;n<e.length;n++){let r=e[n];if("string"==typeof r&&(r=r.trim(),ug(r))){const o=hg(r,t.current);void 0!==o&&(e[n]=o),n===e.length-1&&(this.finalKeyframe=r)}}if(this.resolveNoneKeyframes(),!eg.has(n)||2!==e.length)return;const[r,o]=e,i=rg(r),a=rg(o);if(pg(r)!==pg(o)&&Mg[n])this.needsMeasurement=!0;else if(i!==a)if(kg(i)&&kg(a))for(let t=0;t<e.length;t++){const n=e[t];"string"==typeof n&&(e[t]=parseFloat(n))}else Mg[n]&&(this.needsMeasurement=!0)}resolveNoneKeyframes(){const{unresolvedKeyframes:e,name:t}=this,n=[];for(let t=0;t<e.length;t++)(null===e[t]||("number"==typeof(r=e[t])?0===r:null===r||"none"===r||"0"===r||Wg(r)))&&n.push(t);var r;n.length&&function(e,t,n){let r,o=0;for(;o<e.length&&!r;){const t=e[o];"string"==typeof t&&!Qg.has(t)&&Fm(t).values.length&&(r=e[o]),o++}if(r&&n)for(const o of t)e[o]=Gg(n,r)}(e,n,t)}measureInitialState(){const{element:e,unresolvedKeyframes:t,name:n}=this;if(!e||!e.current)return;"height"===n&&(this.suspendedScrollY=window.pageYOffset),this.measuredOrigin=Mg[n](e.measureViewportBox(),window.getComputedStyle(e.current)),t[0]=this.measuredOrigin;const r=t[t.length-1];void 0!==r&&e.getValue(n,r).jump(r,!1)}measureEndState(){const{element:e,name:t,unresolvedKeyframes:n}=this;if(!e||!e.current)return;const r=e.getValue(t);r&&r.jump(this.measuredOrigin,!1);const o=n.length-1,i=n[o];n[o]=Mg[t](e.measureViewportBox(),window.getComputedStyle(e.current)),null!==i&&void 0===this.finalKeyframe&&(this.finalKeyframe=i),this.removedTransforms?.length&&this.removedTransforms.forEach((([t,n])=>{e.getValue(t).set(n)})),this.resolveNoneKeyframes()}}const Kg=e=>1e3*e,Zg=e=>e/1e3;function Jg(e,t){-1===e.indexOf(t)&&e.push(t)}function Xg(e,t){const n=e.indexOf(t);n>-1&&e.splice(n,1)}class ev{constructor(){this.subscriptions=[]}add(e){return Jg(this.subscriptions,e),()=>Xg(this.subscriptions,e)}notify(e,t,n){const r=this.subscriptions.length;if(r)if(1===r)this.subscriptions[0](e,t,n);else for(let o=0;o<r;o++){const r=this.subscriptions[o];r&&r(e,t,n)}}getSize(){return this.subscriptions.length}clear(){this.subscriptions.length=0}}function tv(e,t,n){(e=>e.startsWith("--"))(t)?e.style.setProperty(t,n):e.style[t]=n}function nv(e){let t;return()=>(void 0===t&&(t=e()),t)}const rv={};function ov(e,t){const n=nv(e);return()=>rv[t]??n()}const iv=ov((()=>void 0!==window.ScrollTimeline),"scrollTimeline"),av=e=>null!==e;function sv(e,{repeat:t,repeatType:n="loop"},r,o=1){const i=e.filter(av),a=o<0||t&&"loop"!==n&&t%2==1?0:i.length-1;return a&&void 0!==r?r:i[a]}class lv{constructor(){this.updateFinished()}get finished(){return this._finished}updateFinished(){this._finished=new Promise((e=>{this.resolve=e}))}notifyFinished(){this.resolve()}then(e,t){return this.finished.then(e,t)}}const cv={layout:0,mainThread:0,waapi:0},uv=e=>Array.isArray(e)&&"number"==typeof e[0],dv=ov((()=>{try{document.createElement("div").animate({opacity:0},{easing:"linear(0, 1)"})}catch(e){return!1}return!0}),"linearEasing"),pv=(e,t,n=10)=>{let r="";const o=Math.max(Math.round(t/n),2);for(let t=0;t<o;t++)r+=Math.round(1e4*e(t/(o-1)))/1e4+", ";return`linear(${r.substring(0,r.length-2)})`},fv=([e,t,n,r])=>`cubic-bezier(${e}, ${t}, ${n}, ${r})`,hv={linear:"linear",ease:"ease",easeIn:"ease-in",easeOut:"ease-out",easeInOut:"ease-in-out",circIn:fv([0,.65,.55,1]),circOut:fv([.55,0,1,.45]),backIn:fv([.31,.01,.66,-.59]),backOut:fv([.33,1.53,.69,.99])};function mv(e,t){return e?"function"==typeof e?dv()?pv(e,t):"ease-out":uv(e)?fv(e):Array.isArray(e)?e.map((e=>mv(e,t)||hv.easeOut)):hv[e]:void 0}function gv(e,t,n,{delay:r=0,duration:o=300,repeat:i=0,repeatType:a="loop",ease:s="easeOut",times:l}={},c=void 0){const u={[t]:n};l&&(u.offset=l);const d=mv(s,o);Array.isArray(d)&&(u.easing=d),Lg.value&&cv.waapi++;const p={delay:r,duration:o,easing:Array.isArray(d)?"linear":d,fill:"both",iterations:i+1,direction:"reverse"===a?"alternate":"normal"};c&&(p.pseudoElement=c);const f=e.animate(u,p);return Lg.value&&f.finished.finally((()=>{cv.waapi--})),f}function vv(e){return"function"==typeof e&&"applyToOptions"in e}class yv extends lv{constructor(e){if(super(),this.finishedTime=null,this.isStopped=!1,this.manualStartTime=null,!e)return;const{element:t,name:n,keyframes:r,pseudoElement:o,allowFlatten:i=!1,finalKeyframe:a,onComplete:s}=e;this.isPseudoElement=Boolean(o),this.allowFlatten=i,this.options=e,ig("string"!=typeof e.type,'Mini animate() doesn\'t support "type" as a string.',"mini-spring");const l=function({type:e,...t}){return vv(e)&&dv()?e.applyToOptions(t):(t.duration??(t.duration=300),t.ease??(t.ease="easeOut"),t)}(e);this.animation=gv(t,n,r,l,o),!1===l.autoplay&&this.animation.pause(),this.animation.onfinish=()=>{if(this.finishedTime=this.time,!o){const e=sv(r,this.options,a,this.speed);this.updateMotionValue&&this.updateMotionValue(e),tv(t,n,e),this.animation.cancel()}s?.(),this.notifyFinished()}}play(){this.isStopped||(this.manualStartTime=null,this.animation.play(),"finished"===this.state&&this.updateFinished())}pause(){this.animation.pause()}complete(){this.animation.finish?.()}cancel(){try{this.animation.cancel()}catch(e){}}stop(){if(this.isStopped)return;this.isStopped=!0;const{state:e}=this;"idle"!==e&&"finished"!==e&&(this.updateMotionValue?this.updateMotionValue():this.commitStyles(),this.isPseudoElement||this.cancel())}commitStyles(){const e=this.options?.element;!this.isPseudoElement&&e?.isConnected&&this.animation.commitStyles?.()}get duration(){const e=this.animation.effect?.getComputedTiming?.().duration||0;return Zg(Number(e))}get iterationDuration(){const{delay:e=0}=this.options||{};return this.duration+Zg(e)}get time(){return Zg(Number(this.animation.currentTime)||0)}set time(e){const t=null!==this.finishedTime;this.manualStartTime=null,this.finishedTime=null,this.animation.currentTime=Kg(e),t&&this.animation.pause()}get speed(){return this.animation.playbackRate}set speed(e){e<0&&(this.finishedTime=null),this.animation.playbackRate=e}get state(){return null!==this.finishedTime?"finished":this.animation.playState}get startTime(){return this.manualStartTime??Number(this.animation.startTime)}set startTime(e){this.manualStartTime=this.animation.startTime=e}attachTimeline({timeline:e,rangeStart:t,rangeEnd:n,observe:r}){return this.allowFlatten&&this.animation.effect?.updateTiming({easing:"linear"}),this.animation.onfinish=null,e&&iv()?(this.animation.timeline=e,t&&(this.animation.rangeStart=t),n&&(this.animation.rangeEnd=n),Tg):r(this)}}const bv=new Set(["opacity","clipPath","filter","transform"]),{schedule:_v,cancel:Av}=Pg(queueMicrotask,!1);let Ev;function wv(){Ev=void 0}const xv={now:()=>(void 0===Ev&&xv.set(Rg.isProcessing||Og.useManualTiming?Rg.timestamp:performance.now()),Ev),set:e=>{Ev=e,queueMicrotask(wv)}};function kv(e,t){return t?e*(1e3/t):0}const Cv={current:void 0};class Sv{constructor(e,t={}){this.canTrackVelocity=null,this.events={},this.updateAndNotify=e=>{const t=xv.now();if(this.updatedAt!==t&&this.setPrevFrameValue(),this.prev=this.current,this.setCurrent(e),this.current!==this.prev&&(this.events.change?.notify(this.current),this.dependents))for(const e of this.dependents)e.dirty()},this.hasAnimated=!1,this.setCurrent(e),this.owner=t.owner}setCurrent(e){var t;this.current=e,this.updatedAt=xv.now(),null===this.canTrackVelocity&&void 0!==e&&(this.canTrackVelocity=(t=this.current,!isNaN(parseFloat(t))))}setPrevFrameValue(e=this.current){this.prevFrameValue=e,this.prevUpdatedAt=this.updatedAt}onChange(e){return this.on("change",e)}on(e,t){this.events[e]||(this.events[e]=new ev);const n=this.events[e].add(t);return"change"===e?()=>{n(),Ig.read((()=>{this.events.change.getSize()||this.stop()}))}:n}clearListeners(){for(const e in this.events)this.events[e].clear()}attach(e,t){this.passiveEffect=e,this.stopPassiveEffect=t}set(e){this.passiveEffect?this.passiveEffect(e,this.updateAndNotify):this.updateAndNotify(e)}setWithVelocity(e,t,n){this.set(t),this.prev=void 0,this.prevFrameValue=e,this.prevUpdatedAt=this.updatedAt-n}jump(e,t=!0){this.updateAndNotify(e),this.prev=e,this.prevUpdatedAt=this.prevFrameValue=void 0,t&&this.stop(),this.stopPassiveEffect&&this.stopPassiveEffect()}dirty(){this.events.change?.notify(this.current)}addDependent(e){this.dependents||(this.dependents=new Set),this.dependents.add(e)}removeDependent(e){this.dependents&&this.dependents.delete(e)}get(){return Cv.current&&Cv.current.push(this),this.current}getPrevious(){return this.prev}getVelocity(){const e=xv.now();if(!this.canTrackVelocity||void 0===this.prevFrameValue||e-this.updatedAt>30)return 0;const t=Math.min(this.updatedAt-this.prevUpdatedAt,30);return kv(parseFloat(this.current)-parseFloat(this.prevFrameValue),t)}start(e){return this.stop(),new Promise((t=>{this.hasAnimated=!0,this.animation=e(t),this.events.animationStart&&this.events.animationStart.notify()})).then((()=>{this.events.animationComplete&&this.events.animationComplete.notify(),this.clearAnimation()}))}stop(){this.animation&&(this.animation.stop(),this.events.animationCancel&&this.events.animationCancel.notify()),this.clearAnimation()}isAnimating(){return!!this.animation}clearAnimation(){delete this.animation}destroy(){this.dependents?.clear(),this.events.destroy?.notify(),this.clearListeners(),this.stop(),this.stopPassiveEffect&&this.stopPassiveEffect()}}function Mv(e,t){return new Sv(e,t)}const Tv=[...ng,Om,$m],Ov=new WeakMap;function Dv(e){return null!==e&&"object"==typeof e&&"function"==typeof e.start}function Lv(e){return"string"==typeof e||Array.isArray(e)}const Pv=["animate","whileInView","whileFocus","whileHover","whileTap","whileDrag","exit"],Iv=["initial",...Pv];function Bv(e){return Dv(e.animate)||Iv.some((t=>Lv(e[t])))}function Rv(e){return Boolean(Bv(e)||e.variants)}const Nv={current:null},Fv={current:!1},jv="undefined"!=typeof window;function Yv(e){const t=[{},{}];return e?.values.forEach(((e,n)=>{t[0][n]=e.get(),t[1][n]=e.getVelocity()})),t}function $v(e,t,n,r){if("function"==typeof t){const[o,i]=Yv(r);t=t(void 0!==n?n:e.custom,o,i)}if("string"==typeof t&&(t=e.variants&&e.variants[t]),"function"==typeof t){const[o,i]=Yv(r);t=t(void 0!==n?n:e.custom,o,i)}return t}const Hv=["AnimationStart","AnimationComplete","Update","BeforeLayoutMeasure","LayoutMeasure","LayoutAnimationStart","LayoutAnimationComplete"];let Uv={};function zv(e){Uv=e}class Wv{scrapeMotionValuesFromProps(e,t,n){return{}}constructor({parent:e,props:t,presenceContext:n,reducedMotionConfig:r,skipAnimations:o,blockInitialAnimation:i,visualState:a},s={}){this.current=null,this.children=new Set,this.isVariantNode=!1,this.isControllingVariants=!1,this.shouldReduceMotion=null,this.shouldSkipAnimations=!1,this.values=new Map,this.KeyframeResolver=zg,this.features={},this.valueSubscriptions=new Map,this.prevMotionValues={},this.hasBeenMounted=!1,this.events={},this.propEventSubscriptions={},this.notifyUpdate=()=>this.notify("Update",this.latestValues),this.render=()=>{this.current&&(this.triggerBuild(),this.renderInstance(this.current,this.renderState,this.props.style,this.projection))},this.renderScheduledAt=0,this.scheduleRender=()=>{const e=xv.now();this.renderScheduledAt<e&&(this.renderScheduledAt=e,Ig.render(this.render,!1,!0))};const{latestValues:l,renderState:c}=a;this.latestValues=l,this.baseTarget={...l},this.initialValues=t.initial?{...l}:{},this.renderState=c,this.parent=e,this.props=t,this.presenceContext=n,this.depth=e?e.depth+1:0,this.reducedMotionConfig=r,this.skipAnimationsConfig=o,this.options=s,this.blockInitialAnimation=Boolean(i),this.isControllingVariants=Bv(t),this.isVariantNode=Rv(t),this.isVariantNode&&(this.variantChildren=new Set),this.manuallyAnimateOnMount=Boolean(e&&e.current);const{willChange:u,...d}=this.scrapeMotionValuesFromProps(t,{},this);for(const e in d){const t=d[e];void 0!==l[e]&&Xm(t)&&t.set(l[e])}}mount(e){if(this.hasBeenMounted)for(const e in this.initialValues)this.values.get(e)?.jump(this.initialValues[e]),this.latestValues[e]=this.initialValues[e];this.current=e,Ov.set(e,this),this.projection&&!this.projection.instance&&this.projection.mount(e),this.parent&&this.isVariantNode&&!this.isControllingVariants&&(this.removeFromVariantTree=this.parent.addVariantChild(this)),this.values.forEach(((e,t)=>this.bindToMotionValue(t,e))),"never"===this.reducedMotionConfig?this.shouldReduceMotion=!1:"always"===this.reducedMotionConfig?this.shouldReduceMotion=!0:(Fv.current||function(){if(Fv.current=!0,jv)if(window.matchMedia){const e=window.matchMedia("(prefers-reduced-motion)"),t=()=>Nv.current=e.matches;e.addEventListener("change",t),t()}else Nv.current=!1}(),this.shouldReduceMotion=Nv.current),this.shouldSkipAnimations=this.skipAnimationsConfig??!1,this.parent?.addChild(this),this.update(this.props,this.presenceContext),this.hasBeenMounted=!0}unmount(){this.projection&&this.projection.unmount(),Bg(this.notifyUpdate),Bg(this.render),this.valueSubscriptions.forEach((e=>e())),this.valueSubscriptions.clear(),this.removeFromVariantTree&&this.removeFromVariantTree(),this.parent?.removeChild(this);for(const e in this.events)this.events[e].clear();for(const e in this.features){const t=this.features[e];t&&(t.unmount(),t.isMounted=!1)}this.current=null}addChild(e){this.children.add(e),this.enteringChildren??(this.enteringChildren=new Set),this.enteringChildren.add(e)}removeChild(e){this.children.delete(e),this.enteringChildren&&this.enteringChildren.delete(e)}bindToMotionValue(e,t){if(this.valueSubscriptions.has(e)&&this.valueSubscriptions.get(e)(),t.accelerate&&bv.has(e)&&this.current instanceof HTMLElement){const{factory:n,keyframes:r,times:o,ease:i,duration:a}=t.accelerate,s=new yv({element:this.current,name:e,keyframes:r,times:o,ease:i,duration:Kg(a)}),l=n(s);return void this.valueSubscriptions.set(e,(()=>{l(),s.cancel()}))}const n=cm.has(e);n&&this.onBindTransform&&this.onBindTransform();const r=t.on("change",(t=>{this.latestValues[e]=t,this.props.onUpdate&&Ig.preRender(this.notifyUpdate),n&&this.projection&&(this.projection.isTransformDirty=!0),this.scheduleRender()}));let o;"undefined"!=typeof window&&window.MotionCheckAppearSync&&(o=window.MotionCheckAppearSync(this,e,t)),this.valueSubscriptions.set(e,(()=>{r(),o&&o(),t.owner&&t.stop()}))}sortNodePosition(e){return this.current&&this.sortInstanceNodePosition&&this.type===e.type?this.sortInstanceNodePosition(this.current,e.current):0}updateFeatures(){let e="animation";for(e in Uv){const t=Uv[e];if(!t)continue;const{isEnabled:n,Feature:r}=t;if(!this.features[e]&&r&&n(this.props)&&(this.features[e]=new r(this)),this.features[e]){const t=this.features[e];t.isMounted?t.update():(t.mount(),t.isMounted=!0)}}}triggerBuild(){this.build(this.renderState,this.latestValues,this.props)}measureViewportBox(){return this.current?this.measureInstanceViewportBox(this.current,this.props):Jm()}getStaticValue(e){return this.latestValues[e]}setStaticValue(e,t){this.latestValues[e]=t}update(e,t){(e.transformTemplate||this.props.transformTemplate)&&this.scheduleRender(),this.prevProps=this.props,this.props=e,this.prevPresenceContext=this.presenceContext,this.presenceContext=t;for(let t=0;t<Hv.length;t++){const n=Hv[t];this.propEventSubscriptions[n]&&(this.propEventSubscriptions[n](),delete this.propEventSubscriptions[n]);const r=e["on"+n];r&&(this.propEventSubscriptions[n]=this.on(n,r))}this.prevMotionValues=function(e,t,n){for(const r in t){const o=t[r],i=n[r];if(Xm(o))e.addValue(r,o);else if(Xm(i))e.addValue(r,Mv(o,{owner:e}));else if(i!==o)if(e.hasValue(r)){const t=e.getValue(r);!0===t.liveStyle?t.jump(o):t.hasAnimated||t.set(o)}else{const t=e.getStaticValue(r);e.addValue(r,Mv(void 0!==t?t:o,{owner:e}))}}for(const r in n)void 0===t[r]&&e.removeValue(r);return t}(this,this.scrapeMotionValuesFromProps(e,this.prevProps||{},this),this.prevMotionValues),this.handleChildMotionValue&&this.handleChildMotionValue()}getProps(){return this.props}getVariant(e){return this.props.variants?this.props.variants[e]:void 0}getDefaultTransition(){return this.props.transition}getTransformPagePoint(){return this.props.transformPagePoint}getClosestVariantNode(){return this.isVariantNode?this:this.parent?this.parent.getClosestVariantNode():void 0}addVariantChild(e){const t=this.getClosestVariantNode();if(t)return t.variantChildren&&t.variantChildren.add(e),()=>t.variantChildren.delete(e)}addValue(e,t){const n=this.values.get(e);t!==n&&(n&&this.removeValue(e),this.bindToMotionValue(e,t),this.values.set(e,t),this.latestValues[e]=t.get())}removeValue(e){this.values.delete(e);const t=this.valueSubscriptions.get(e);t&&(t(),this.valueSubscriptions.delete(e)),delete this.latestValues[e],this.removeValueFromRenderState(e,this.renderState)}hasValue(e){return this.values.has(e)}getValue(e,t){if(this.props.values&&this.props.values[e])return this.props.values[e];let n=this.values.get(e);return void 0===n&&void 0!==t&&(n=Mv(null===t?void 0:t,{owner:this}),this.addValue(e,n)),n}readValue(e,t){let n=void 0===this.latestValues[e]&&this.current?this.getBaseTargetFromProps(this.props,e)??this.readValueFromInstance(this.current,e,this.options):this.latestValues[e];return null!=n&&("string"==typeof n&&(ag(n)||Wg(n))?n=parseFloat(n):!(e=>Tv.find(tg(e)))(n)&&$m.test(t)&&(n=Gg(e,t)),this.setBaseTarget(e,Xm(n)?n.get():n)),Xm(n)?n.get():n}setBaseTarget(e,t){this.baseTarget[e]=t}getBaseTarget(e){const{initial:t}=this.props;let n;if("string"==typeof t||"object"==typeof t){const r=$v(this.props,t,this.presenceContext?.custom);r&&(n=r[e])}if(t&&void 0!==n)return n;const r=this.getBaseTargetFromProps(this.props,e);return void 0===r||Xm(r)?void 0!==this.initialValues[e]&&void 0===n?void 0:this.baseTarget[e]:r}on(e,t){return this.events[e]||(this.events[e]=new ev),this.events[e].add(t)}notify(e,...t){this.events[e]&&this.events[e].notify(...t)}scheduleRenderMicrotask(){_v.render(this.render)}}class Vv extends Wv{constructor(){super(...arguments),this.KeyframeResolver=qg}sortInstanceNodePosition(e,t){return 2&e.compareDocumentPosition(t)?1:-1}getBaseTargetFromProps(e,t){const n=e.style;return n?n[t]:void 0}removeValueFromRenderState(e,{vars:t,style:n}){delete t[e],delete n[e]}handleChildMotionValue(){this.childSubscription&&(this.childSubscription(),delete this.childSubscription);const{children:e}=this.props;Xm(e)&&(this.childSubscription=e.on("change",(e=>{this.current&&(this.current.textContent=`${e}`)})))}}function Gv(e){return e.replace(/([A-Z])/g,(e=>`-${e.toLowerCase()}`))}const Qv=(e,t)=>t&&"number"==typeof e?t.transform(e):e,qv={x:"translateX",y:"translateY",z:"translateZ",transformPerspective:"perspective"},Kv=lm.length;function Zv(e,t,n){const{style:r,vars:o,transformOrigin:i}=e;let a=!1,s=!1;for(const e in t){const n=t[e];if(cm.has(e))a=!0;else if(lg(e))o[e]=n;else{const t=Qv(n,Qm[e]);e.startsWith("origin")?(s=!0,i[e]=t):r[e]=t}}if(t.transform||(a||n?r.transform=function(e,t,n){let r="",o=!0;for(let i=0;i<Kv;i++){const a=lm[i],s=e[a];if(void 0===s)continue;let l=!0;if("number"==typeof s)l=s===(a.startsWith("scale")?1:0);else{const e=parseFloat(s);l=a.startsWith("scale")?1===e:0===e}if(!l||n){const e=Qv(s,Qm[a]);l||(o=!1,r+=`${qv[a]||a}(${e}) `),n&&(t[a]=e)}}return r=r.trim(),n?r=n(t,o?"":r):o&&(r="none"),r}(t,e.transform,n):r.transform&&(r.transform="none")),s){const{originX:e="50%",originY:t="50%",originZ:n=0}=i;r.transformOrigin=`${e} ${t} ${n}`}}const Jv={offset:"stroke-dashoffset",array:"stroke-dasharray"},Xv={offset:"strokeDashoffset",array:"strokeDasharray"};const ey=["offsetDistance","offsetPath","offsetRotate","offsetAnchor"];function ty(e,{attrX:t,attrY:n,attrScale:r,pathLength:o,pathSpacing:i=1,pathOffset:a=0,...s},l,c,u){if(Zv(e,s,c),l)return void(e.style.viewBox&&(e.attrs.viewBox=e.style.viewBox));e.attrs=e.style,e.style={};const{attrs:d,style:p}=e;d.transform&&(p.transform=d.transform,delete d.transform),(p.transform||d.transformOrigin)&&(p.transformOrigin=d.transformOrigin??"50% 50%",delete d.transformOrigin),p.transform&&(p.transformBox=u?.transformBox??"fill-box",delete d.transformBox);for(const e of ey)void 0!==d[e]&&(p[e]=d[e],delete d[e]);void 0!==t&&(d.x=t),void 0!==n&&(d.y=n),void 0!==r&&(d.scale=r),void 0!==o&&function(e,t,n=1,r=0,o=!0){e.pathLength=1;const i=o?Jv:Xv;e[i.offset]=""+-r,e[i.array]=`${t} ${n}`}(d,o,i,a,!1)}const ny=new Set(["baseFrequency","diffuseConstant","kernelMatrix","kernelUnitLength","keySplines","keyTimes","limitingConeAngle","markerHeight","markerWidth","numOctaves","targetX","targetY","surfaceScale","specularConstant","specularExponent","stdDeviation","tableValues","viewBox","gradientTransform","pathLength","startOffset","textLength","lengthAdjust"]),ry=e=>"string"==typeof e&&"svg"===e.toLowerCase();function oy(e,{style:t,vars:n},r,o){const i=e.style;let a;for(a in t)i[a]=t[a];for(a in o?.applyProjectionStyles(i,r),n)i.setProperty(a,n[a])}function iy(e,t){return t.max===t.min?0:e/(t.max-t.min)*100}const ay={correct:(e,t)=>{if(!t.target)return e;if("string"==typeof e){if(!km.test(e))return e;e=parseFloat(e)}return`${iy(e,t.target.x)}% ${iy(e,t.target.y)}%`}},sy=(e,t,n)=>e+(t-e)*n,ly={correct:(e,{treeScale:t,projectionDelta:n})=>{const r=e,o=$m.parse(e);if(o.length>5)return r;const i=$m.createTransformer(e),a="number"!=typeof o[0]?1:0,s=n.x.scale*t.x,l=n.y.scale*t.y;o[0+a]/=s,o[1+a]/=l;const c=sy(s,l,.5);return"number"==typeof o[2+a]&&(o[2+a]/=c),"number"==typeof o[3+a]&&(o[3+a]/=c),i(o)}},cy={borderRadius:{...ay,applyTo:["borderTopLeftRadius","borderTopRightRadius","borderBottomLeftRadius","borderBottomRightRadius"]},borderTopLeftRadius:ay,borderTopRightRadius:ay,borderBottomLeftRadius:ay,borderBottomRightRadius:ay,boxShadow:ly};function uy(e,{layout:t,layoutId:n}){return cm.has(e)||e.startsWith("origin")||(t||void 0!==n)&&(!!cy[e]||"opacity"===e)}function dy(e,t,n){const r=e.style,o=t?.style,i={};if(!r)return i;for(const t in r)(Xm(r[t])||o&&Xm(o[t])||uy(t,e)||void 0!==n?.getValue(t)?.liveStyle)&&(i[t]=r[t]);return i}function py(e,t,n){const r=dy(e,t,n);for(const n in e)if(Xm(e[n])||Xm(t[n])){r[-1!==lm.indexOf(n)?"attr"+n.charAt(0).toUpperCase()+n.substring(1):n]=e[n]}return r}class fy extends Vv{constructor(){super(...arguments),this.type="svg",this.isSVGTag=!1,this.measureInstanceViewportBox=Jm}getBaseTargetFromProps(e,t){return e[t]}readValueFromInstance(e,t){if(cm.has(t)){const e=Km(t);return e&&e.default||0}return t=ny.has(t)?t:Gv(t),e.getAttribute(t)}scrapeMotionValuesFromProps(e,t,n){return py(e,t,n)}build(e,t,n){ty(e,t,this.isSVGTag,n.transformTemplate,n.style)}renderInstance(e,t,n,r){!function(e,t,n,r){oy(e,t,void 0,r);for(const n in t.attrs)e.setAttribute(ny.has(n)?n:Gv(n),t.attrs[n])}(e,t,0,r)}mount(e){this.isSVGTag=ry(e.tagName),super.mount(e)}}function hy({top:e,left:t,right:n,bottom:r}){return{x:{min:t,max:n},y:{min:e,max:r}}}function my(e){return void 0===e||1===e}function gy({scale:e,scaleX:t,scaleY:n}){return!my(e)||!my(t)||!my(n)}function vy(e){return gy(e)||yy(e)||e.z||e.rotate||e.rotateX||e.rotateY||e.skewX||e.skewY}function yy(e){return by(e.x)||by(e.y)}function by(e){return e&&"0%"!==e}function _y(e,t,n){return n+t*(e-n)}function Ay(e,t,n,r,o){return void 0!==o&&(e=_y(e,o,r)),_y(e,n,r)+t}function Ey(e,t=0,n=1,r,o){e.min=Ay(e.min,t,n,r,o),e.max=Ay(e.max,t,n,r,o)}function wy(e,{x:t,y:n}){Ey(e.x,t.translate,t.scale,t.originPoint),Ey(e.y,n.translate,n.scale,n.originPoint)}const xy=.999999999999,ky=1.0000000000001;function Cy(e,t){e.min+=t,e.max+=t}function Sy(e,t,n,r,o=.5){Ey(e,t,n,sy(e.min,e.max,o),r)}function My(e,t){return"string"==typeof e?parseFloat(e)/100*(t.max-t.min):e}function Ty(e,t,n){const r=n??e;Sy(e.x,My(t.x,r.x),t.scaleX,t.scale,t.originX),Sy(e.y,My(t.y,r.y),t.scaleY,t.scale,t.originY)}function Oy(e,t){return hy(function(e,t){if(!t)return e;const n=t({x:e.left,y:e.top}),r=t({x:e.right,y:e.bottom});return{top:n.y,left:n.x,bottom:r.y,right:r.x}}(e.getBoundingClientRect(),t))}class Dy extends Vv{constructor(){super(...arguments),this.type="html",this.renderInstance=oy}readValueFromInstance(e,t){if(cm.has(t))return this.projection?.isProjecting?Eg(t):((e,t)=>{const{transform:n="none"}=getComputedStyle(e);return wg(n,t)})(e,t);{const r=(n=e,window.getComputedStyle(n)),o=(lg(t)?r.getPropertyValue(t):r[t])||0;return"string"==typeof o?o.trim():o}var n}measureInstanceViewportBox(e,{transformPagePoint:t}){return Oy(e,t)}build(e,t,n){Zv(e,t,n.transformTemplate)}scrapeMotionValuesFromProps(e,t,n){return dy(e,t,n)}}const Ly=["animate","circle","defs","desc","ellipse","g","image","line","filter","marker","mask","metadata","path","pattern","polygon","polyline","rect","stop","switch","symbol","svg","text","tspan","use","view"];function Py(e){return"string"==typeof e&&!e.includes("-")&&!!(Ly.indexOf(e)>-1||/[A-Z]/u.test(e))}const Iy=(e,t)=>t.isSVG??Py(e)?new fy(t):new Dy(t,{allowProjection:e!==i.Fragment}),By=(0,i.createContext)({}),Ry=(0,i.createContext)({strict:!1}),Ny=(0,i.createContext)({transformPagePoint:e=>e,isStatic:!1,reducedMotion:"never"}),Fy=(0,i.createContext)({});function jy(e){const{initial:t,animate:n}=function(e,t){if(Bv(e)){const{initial:t,animate:n}=e;return{initial:!1===t||Lv(t)?t:void 0,animate:Lv(n)?n:void 0}}return!1!==e.inherit?t:{}}(e,(0,i.useContext)(Fy));return(0,i.useMemo)((()=>({initial:t,animate:n})),[Yy(t),Yy(n)])}function Yy(e){return Array.isArray(e)?e.join(" "):e}const $y=()=>({style:{},transform:{},transformOrigin:{},vars:{}});function Hy(e,t,n){for(const r in t)Xm(t[r])||uy(r,n)||(e[r]=t[r])}function Uy(e,t){const n={};return Hy(n,e.style||{},e),Object.assign(n,function({transformTemplate:e},t){return(0,i.useMemo)((()=>{const n=$y();return Zv(n,t,e),Object.assign({},n.vars,n.style)}),[t])}(e,t)),n}function zy(e,t){const n={},r=Uy(e,t);return e.drag&&!1!==e.dragListener&&(n.draggable=!1,r.userSelect=r.WebkitUserSelect=r.WebkitTouchCallout="none",r.touchAction=!0===e.drag?"none":"pan-"+("x"===e.drag?"y":"x")),void 0===e.tabIndex&&(e.onTap||e.onTapStart||e.whileTap)&&(n.tabIndex=0),n.style=r,n}const Wy=()=>({...$y(),attrs:{}});function Vy(e,t,n,r){const o=(0,i.useMemo)((()=>{const n=Wy();return ty(n,t,ry(r),e.transformTemplate,e.style),{...n.attrs,style:{...n.style}}}),[t]);if(e.style){const t={};Hy(t,e.style,e),o.style={...t,...o.style}}return o}const Gy=new Set(["animate","exit","variants","initial","style","values","variants","transition","transformTemplate","custom","inherit","onBeforeLayoutMeasure","onAnimationStart","onAnimationComplete","onUpdate","onDragStart","onDrag","onDragEnd","onMeasureDragConstraints","onDirectionLock","onDragTransitionEnd","_dragX","_dragY","onHoverStart","onHoverEnd","onViewportEnter","onViewportLeave","globalTapTarget","propagate","ignoreStrict","viewport"]);function Qy(e){return e.startsWith("while")||e.startsWith("drag")&&"draggable"!==e||e.startsWith("layout")||e.startsWith("onTap")||e.startsWith("onPan")||e.startsWith("onLayout")||Gy.has(e)}let qy=e=>!Qy(e);try{const e="@emotion/is-prop-valid";"function"==typeof(Ky=o(41984)(e).default)&&(qy=e=>e.startsWith("on")?!Qy(e):Ky(e))}catch{}var Ky;function Zy(e,t,n,{latestValues:r},o,a=!1,s){const l=(s??Py(e)?Vy:zy)(t,r,o,e),c=function(e,t,n){const r={};for(const o in e)"values"===o&&"object"==typeof e.values||Xm(e[o])||(qy(o)||!0===n&&Qy(o)||!t&&!Qy(o)||e.draggable&&o.startsWith("onDrag"))&&(r[o]=e[o]);return r}(t,"string"==typeof e,a),u=e!==i.Fragment?{...c,...l,ref:n}:{},{children:d}=t,p=(0,i.useMemo)((()=>Xm(d)?d.get():d),[d]);return(0,i.createElement)(e,{...u,children:p})}function Jy(e){return Xm(e)?e.get():e}const Xy=(0,i.createContext)(null);function eb(e){const t=(0,i.useRef)(null);return null===t.current&&(t.current=e()),t.current}function tb(e,t,n,r){const o={},i=r(e,{});for(const e in i)o[e]=Jy(i[e]);let{initial:a,animate:s}=e;const l=Bv(e),c=Rv(e);t&&c&&!l&&!1!==e.inherit&&(void 0===a&&(a=t.initial),void 0===s&&(s=t.animate));let u=!!n&&!1===n.initial;u=u||!1===a;const d=u?s:a;if(d&&"boolean"!=typeof d&&!Dv(d)){const t=Array.isArray(d)?d:[d];for(let n=0;n<t.length;n++){const r=$v(e,t[n]);if(r){const{transitionEnd:e,transition:t,...n}=r;for(const e in n){let t=n[e];if(Array.isArray(t)){t=t[u?t.length-1:0]}null!==t&&(o[e]=t)}for(const t in e)o[t]=e[t]}}}return o}const nb=e=>(t,n)=>{const r=(0,i.useContext)(Fy),o=(0,i.useContext)(Xy),a=()=>function({scrapeMotionValuesFromProps:e,createRenderState:t},n,r,o){return{latestValues:tb(n,r,o,e),renderState:t()}}(e,t,r,o);return n?a():eb(a)},rb=nb({scrapeMotionValuesFromProps:dy,createRenderState:$y}),ob=nb({scrapeMotionValuesFromProps:py,createRenderState:Wy}),ib={animation:["animate","variants","whileHover","whileTap","exit","whileInView","whileFocus","whileDrag"],exit:["exit"],drag:["drag","dragControls"],focus:["whileFocus"],hover:["whileHover","onHoverStart","onHoverEnd"],tap:["whileTap","onTap","onTapStart","onTapCancel"],pan:["onPan","onPanStart","onPanSessionStart","onPanEnd"],inView:["whileInView","onViewportEnter","onViewportLeave"],layout:["layout","layoutId"]};let ab=!1;function sb(){return function(){if(ab)return;const e={};for(const t in ib)e[t]={isEnabled:e=>ib[t].some((t=>!!e[t]))};zv(e),ab=!0}(),Uv}const lb=Symbol.for("motionComponentSymbol");function cb(e,t,n){const r=(0,i.useRef)(n);(0,i.useInsertionEffect)((()=>{r.current=n}));const o=(0,i.useRef)(null);return(0,i.useCallback)((n=>{n&&e.onMount?.(n);const i=r.current;if("function"==typeof i)if(n){const e=i(n);"function"==typeof e&&(o.current=e)}else o.current?(o.current(),o.current=null):i(n);else i&&(i.current=n);t&&(n?t.mount(n):t.unmount())}),[t])}const ub="data-"+Gv("framerAppearId"),db=(0,i.createContext)({});function pb(e){return e&&"object"==typeof e&&Object.prototype.hasOwnProperty.call(e,"current")}const fb="undefined"!=typeof window?i.useLayoutEffect:i.useEffect;function hb(e,t,n,r,o,a){const{visualElement:s}=(0,i.useContext)(Fy),l=(0,i.useContext)(Ry),c=(0,i.useContext)(Xy),u=(0,i.useContext)(Ny),d=u.reducedMotion,p=u.skipAnimations,f=(0,i.useRef)(null),h=(0,i.useRef)(!1);r=r||l.renderer,!f.current&&r&&(f.current=r(e,{visualState:t,parent:s,props:n,presenceContext:c,blockInitialAnimation:!!c&&!1===c.initial,reducedMotionConfig:d,skipAnimations:p,isSVG:a}),h.current&&f.current&&(f.current.manuallyAnimateOnMount=!0));const m=f.current,g=(0,i.useContext)(db);!m||m.projection||!o||"html"!==m.type&&"svg"!==m.type||function(e,t,n,r){const{layoutId:o,layout:i,drag:a,dragConstraints:s,layoutScroll:l,layoutRoot:c,layoutAnchor:u,layoutCrossfade:d}=t;e.projection=new n(e.latestValues,t["data-framer-portal-id"]?void 0:mb(e.parent)),e.projection.setOptions({layoutId:o,layout:i,alwaysMeasureLayout:Boolean(a)||s&&pb(s),visualElement:e,animationType:"string"==typeof i?i:"both",initialPromotionConfig:r,crossfade:d,layoutScroll:l,layoutRoot:c,layoutAnchor:u})}(f.current,n,o,g);const v=(0,i.useRef)(!1);(0,i.useInsertionEffect)((()=>{m&&v.current&&m.update(n,c)}));const y=n[ub],b=(0,i.useRef)(Boolean(y)&&"undefined"!=typeof window&&!window.MotionHandoffIsComplete?.(y)&&window.MotionHasOptimisedAnimation?.(y));return fb((()=>{h.current=!0,m&&(v.current=!0,window.MotionIsMounted=!0,m.updateFeatures(),m.scheduleRenderMicrotask(),b.current&&m.animationState&&m.animationState.animateChanges())})),(0,i.useEffect)((()=>{m&&(!b.current&&m.animationState&&m.animationState.animateChanges(),b.current&&(queueMicrotask((()=>{window.MotionHandoffMarkAsComplete?.(y)})),b.current=!1),m.enteringChildren=void 0)})),m}function mb(e){if(e)return!1!==e.options.allowProjection?e.projection:mb(e.parent)}function gb(e,{forwardMotionProps:t=!1,type:n}={},r,o){r&&function(e){const t=sb();for(const n in e)t[n]={...t[n],...e[n]};zv(t)}(r);const a=n?"svg"===n:Py(e),s=a?ob:rb;function l(n,r){let l;const c={...(0,i.useContext)(Ny),...n,layoutId:vb(n)},{isStatic:u}=c,d=jy(n),p=s(n,u);if(!u&&"undefined"!=typeof window){!function(e,t){(0,i.useContext)(Ry).strict;0}();const t=function(e){const t=sb(),{drag:n,layout:r}=t;if(!n&&!r)return{};const o={...n,...r};return{MeasureLayout:n?.isEnabled(e)||r?.isEnabled(e)?o.MeasureLayout:void 0,ProjectionNode:o.ProjectionNode}}(c);l=t.MeasureLayout,d.visualElement=hb(e,p,c,o,t.ProjectionNode,a)}return(0,br.jsxs)(Fy.Provider,{value:d,children:[l&&d.visualElement?(0,br.jsx)(l,{visualElement:d.visualElement,...c}):null,Zy(e,n,cb(p,d.visualElement,r),p,u,t,a)]})}l.displayName=`motion.${"string"==typeof e?e:`create(${e.displayName??e.name??""})`}`;const c=(0,i.forwardRef)(l);return c[lb]=e,c}function vb({layoutId:e}){const t=(0,i.useContext)(By).id;return t&&void 0!==e?t+"-"+e:e}function yb(e,t){if("undefined"==typeof Proxy)return gb;const n=new Map,r=(n,r)=>gb(n,r,e,t);return new Proxy(((e,t)=>r(e,t)),{get:(o,i)=>"create"===i?r:(n.has(i)||n.set(i,gb(i,void 0,e,t)),n.get(i))})}class bb{constructor(e){this.isMounted=!1,this.node=e}update(){}}function _b(e,t,n){const r=e.getProps();return $v(r,t,void 0!==n?n:r.custom,e)}function Ab(e,t){if(e?.inherit&&t){const{inherit:n,...r}=e;return{...t,...r}}return e}function Eb(e,t){const n=e?.[t]??e?.default??e;return n!==e?Ab(n,e):n}const wb=e=>Array.isArray(e);function xb(e,t,n){e.hasValue(t)?e.getValue(t).set(n):e.addValue(t,Mv(n))}function kb(e){return wb(e)?e[e.length-1]||0:e}function Cb(e,t){const n=e.getValue("willChange");if(r=n,Boolean(Xm(r)&&r.add))return n.add(t);if(!n&&Og.WillChange){const n=new Og.WillChange("auto");e.addValue("willChange",n),n.add(t)}var r}function Sb(e){return e.props[ub]}const Mb=(e,t)=>n=>t(e(n)),Tb=(...e)=>e.reduce(Mb);function Ob(e,t,n){return n<0&&(n+=1),n>1&&(n-=1),n<1/6?e+6*(t-e)*n:n<.5?t:n<2/3?e+(t-e)*(2/3-n)*6:e}function Db(e,t){return n=>n>0?t:e}const Lb=(e,t,n)=>{const r=e*e,o=n*(t*t-r)+r;return o<0?0:Math.sqrt(o)},Pb=[Am,_m,Tm];function Ib(e){const t=(e=>Pb.find((t=>t.test(e))))(e);if(og(Boolean(t),`'${e}' is not an animatable color. Use the equivalent color code instead.`,"color-not-animatable"),!Boolean(t))return!1;let n=t.parse(e);return t===Tm&&(n=function({hue:e,saturation:t,lightness:n,alpha:r}){e/=360,n/=100;let o=0,i=0,a=0;if(t/=100){const r=n<.5?n*(1+t):n+t-n*t,s=2*n-r;o=Ob(s,r,e+1/3),i=Ob(s,r,e),a=Ob(s,r,e-1/3)}else o=i=a=n;return{red:Math.round(255*o),green:Math.round(255*i),blue:Math.round(255*a),alpha:r}}(n)),n}const Bb=(e,t)=>{const n=Ib(e),r=Ib(t);if(!n||!r)return Db(e,t);const o={...n};return e=>(o.red=Lb(n.red,r.red,e),o.green=Lb(n.green,r.green,e),o.blue=Lb(n.blue,r.blue,e),o.alpha=sy(n.alpha,r.alpha,e),_m.transform(o))},Rb=new Set(["none","hidden"]);function Nb(e,t){return n=>sy(e,t,n)}function Fb(e){return"number"==typeof e?Nb:"string"==typeof e?ug(e)?Db:Om.test(e)?Bb:$b:Array.isArray(e)?jb:"object"==typeof e?Om.test(e)?Bb:Yb:Db}function jb(e,t){const n=[...e],r=n.length,o=e.map(((e,n)=>Fb(e)(e,t[n])));return e=>{for(let t=0;t<r;t++)n[t]=o[t](e);return n}}function Yb(e,t){const n={...e,...t},r={};for(const o in n)void 0!==e[o]&&void 0!==t[o]&&(r[o]=Fb(e[o])(e[o],t[o]));return e=>{for(const t in r)n[t]=r[t](e);return n}}const $b=(e,t)=>{const n=$m.createTransformer(t),r=Fm(e),o=Fm(t);return r.indexes.var.length===o.indexes.var.length&&r.indexes.color.length===o.indexes.color.length&&r.indexes.number.length>=o.indexes.number.length?Rb.has(e)&&!o.values.length||Rb.has(t)&&!r.values.length?function(e,t){return Rb.has(e)?n=>n<=0?e:t:n=>n>=1?t:e}(e,t):Tb(jb(function(e,t){const n=[],r={color:0,var:0,number:0};for(let o=0;o<t.values.length;o++){const i=t.types[o],a=e.indexes[i][r[i]],s=e.values[a]??0;n[o]=s,r[i]++}return n}(r,o),o.values),n):(og(!0,`Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`,"complex-values-different"),Db(e,t))};function Hb(e,t,n){if("number"==typeof e&&"number"==typeof t&&"number"==typeof n)return sy(e,t,n);return Fb(e)(e,t)}const Ub=e=>{const t=({timestamp:t})=>e(t);return{start:(e=!0)=>Ig.update(t,e),stop:()=>Bg(t),now:()=>Rg.isProcessing?Rg.timestamp:xv.now()}},zb=2e4;function Wb(e){let t=0;let n=e.next(t);for(;!n.done&&t<zb;)t+=50,n=e.next(t);return t>=zb?1/0:t}const Vb={stiffness:100,damping:10,mass:1,velocity:0,duration:800,bounce:.3,visualDuration:.3,restSpeed:{granular:.01,default:2},restDelta:{granular:.005,default:.5},minDuration:.01,maxDuration:10,minDamping:.05,maxDamping:1};function Gb(e,t){return e*Math.sqrt(1-t*t)}const Qb=12;const qb=.001;function Kb({duration:e=Vb.duration,bounce:t=Vb.bounce,velocity:n=Vb.velocity,mass:r=Vb.mass}){let o,i;og(e<=Kg(Vb.maxDuration),"Spring duration must be 10 seconds or less","spring-duration-limit");let a=1-t;a=um(Vb.minDamping,Vb.maxDamping,a),e=um(Vb.minDuration,Vb.maxDuration,Zg(e)),a<1?(o=t=>{const r=t*a,o=r*e,i=r-n,s=Gb(t,a),l=Math.exp(-o);return qb-i/s*l},i=t=>{const r=t*a*e,i=r*n+n,s=Math.pow(a,2)*Math.pow(t,2)*e,l=Math.exp(-r),c=Gb(Math.pow(t,2),a);return(-o(t)+qb>0?-1:1)*((i-s)*l)/c}):(o=t=>Math.exp(-t*e)*((t-n)*e+1)-qb,i=t=>Math.exp(-t*e)*(e*e*(n-t)));const s=function(e,t,n){let r=n;for(let n=1;n<Qb;n++)r-=e(r)/t(r);return r}(o,i,5/e);if(e=Kg(e),isNaN(s))return{stiffness:Vb.stiffness,damping:Vb.damping,duration:e};{const t=Math.pow(s,2)*r;return{stiffness:t,damping:2*a*Math.sqrt(r*t),duration:e}}}const Zb=["duration","bounce"],Jb=["stiffness","damping","mass"];function Xb(e,t){return t.some((t=>void 0!==e[t]))}function e_(e=Vb.visualDuration,t=Vb.bounce){const n="object"!=typeof e?{visualDuration:e,keyframes:[0,1],bounce:t}:e;let{restSpeed:r,restDelta:o}=n;const i=n.keyframes[0],a=n.keyframes[n.keyframes.length-1],s={done:!1,value:i},{stiffness:l,damping:c,mass:u,duration:d,velocity:p,isResolvedFromDuration:f}=function(e){let t={velocity:Vb.velocity,stiffness:Vb.stiffness,damping:Vb.damping,mass:Vb.mass,isResolvedFromDuration:!1,...e};if(!Xb(e,Jb)&&Xb(e,Zb))if(t.velocity=0,e.visualDuration){const n=e.visualDuration,r=2*Math.PI/(1.2*n),o=r*r,i=2*um(.05,1,1-(e.bounce||0))*Math.sqrt(o);t={...t,mass:Vb.mass,stiffness:o,damping:i}}else{const n=Kb({...e,velocity:0});t={...t,...n,mass:Vb.mass},t.isResolvedFromDuration=!0}return t}({...n,velocity:-Zg(n.velocity||0)}),h=p||0,m=c/(2*Math.sqrt(l*u)),g=a-i,v=Zg(Math.sqrt(l/u)),y=Math.abs(g)<5;let b,_,A,E,w,x;if(r||(r=y?Vb.restSpeed.granular:Vb.restSpeed.default),o||(o=y?Vb.restDelta.granular:Vb.restDelta.default),m<1)A=Gb(v,m),E=(h+m*v*g)/A,b=e=>{const t=Math.exp(-m*v*e);return a-t*(E*Math.sin(A*e)+g*Math.cos(A*e))},w=m*v*E+g*A,x=m*v*g-E*A,_=e=>Math.exp(-m*v*e)*(w*Math.sin(A*e)+x*Math.cos(A*e));else if(1===m){b=e=>a-Math.exp(-v*e)*(g+(h+v*g)*e);const e=h+v*g;_=t=>Math.exp(-v*t)*(v*e*t-h)}else{const e=v*Math.sqrt(m*m-1);b=t=>{const n=Math.exp(-m*v*t),r=Math.min(e*t,300);return a-n*((h+m*v*g)*Math.sinh(r)+e*g*Math.cosh(r))/e};const t=(h+m*v*g)/e,n=m*v*t-g*e,r=m*v*g-t*e;_=t=>{const o=Math.exp(-m*v*t),i=Math.min(e*t,300);return o*(n*Math.sinh(i)+r*Math.cosh(i))}}const k={calculatedDuration:f&&d||null,velocity:e=>Kg(_(e)),next:e=>{if(!f&&m<1){const t=Math.exp(-m*v*e),n=Math.sin(A*e),i=Math.cos(A*e),l=a-t*(E*n+g*i),c=Kg(t*(w*n+x*i));return s.done=Math.abs(c)<=r&&Math.abs(a-l)<=o,s.value=s.done?a:l,s}const t=b(e);if(f)s.done=e>=d;else{const n=Kg(_(e));s.done=Math.abs(n)<=r&&Math.abs(a-t)<=o}return s.value=s.done?a:t,s},toString:()=>{const e=Math.min(Wb(k),zb),t=pv((t=>k.next(e*t).value),e,30);return e+"ms "+t},toTransition:()=>{}};return k}e_.applyToOptions=e=>{const t=function(e,t=100,n){const r=n({...e,keyframes:[0,t]}),o=Math.min(Wb(r),zb);return{type:"keyframes",ease:e=>r.next(o*e).value/t,duration:Zg(o)}}(e,100,e_);return e.ease=t.ease,e.duration=Kg(t.duration),e.type="keyframes",e};const t_=5;function n_(e,t,n){const r=Math.max(t-t_,0);return kv(n-e(r),t-r)}function r_({keyframes:e,velocity:t=0,power:n=.8,timeConstant:r=325,bounceDamping:o=10,bounceStiffness:i=500,modifyTarget:a,min:s,max:l,restDelta:c=.5,restSpeed:u}){const d=e[0],p={done:!1,value:d},f=e=>void 0===s?l:void 0===l||Math.abs(s-e)<Math.abs(l-e)?s:l;let h=n*t;const m=d+h,g=void 0===a?m:a(m);g!==m&&(h=g-d);const v=e=>-h*Math.exp(-e/r),y=e=>g+v(e),b=e=>{const t=v(e),n=y(e);p.done=Math.abs(t)<=c,p.value=p.done?g:n};let _,A;const E=e=>{(e=>void 0!==s&&e<s||void 0!==l&&e>l)(p.value)&&(_=e,A=e_({keyframes:[p.value,f(p.value)],velocity:n_(y,e,p.value),damping:o,stiffness:i,restDelta:c,restSpeed:u}))};return E(0),{calculatedDuration:null,next:e=>{let t=!1;return A||void 0!==_||(t=!0,b(e),E(e)),void 0!==_&&e>=_?A.next(e-_):(!t&&b(e),p)}}}const o_=(e,t,n)=>(((1-3*n+3*t)*e+(3*n-6*t))*e+3*t)*e,i_=1e-7,a_=12;function s_(e,t,n,r){if(e===t&&n===r)return Tg;const o=t=>function(e,t,n,r,o){let i,a,s=0;do{a=t+(n-t)/2,i=o_(a,r,o)-e,i>0?n=a:t=a}while(Math.abs(i)>i_&&++s<a_);return a}(t,0,1,e,n);return e=>0===e||1===e?e:o_(o(e),t,r)}const l_=s_(.42,0,1,1),c_=s_(0,0,.58,1),u_=s_(.42,0,.58,1),d_=e=>t=>t<=.5?e(2*t)/2:(2-e(2*(1-t)))/2,p_=e=>t=>1-e(1-t),f_=s_(.33,1.53,.69,.99),h_=p_(f_),m_=d_(h_),g_=e=>e>=1?1:(e*=2)<1?.5*h_(e):.5*(2-Math.pow(2,-10*(e-1))),v_=e=>1-Math.sin(Math.acos(e)),y_=p_(v_),b_=d_(v_),__={linear:Tg,easeIn:l_,easeInOut:u_,easeOut:c_,circIn:v_,circInOut:b_,circOut:y_,backIn:h_,backInOut:m_,backOut:f_,anticipate:g_},A_=e=>{if(uv(e)){ig(4===e.length,"Cubic bezier arrays must contain four numerical values.","cubic-bezier-length");const[t,n,r,o]=e;return s_(t,n,r,o)}return"string"==typeof e?(ig(void 0!==__[e],`Invalid easing type '${e}'`,"invalid-easing-type"),__[e]):e},E_=(e,t,n)=>{const r=t-e;return 0===r?1:(n-e)/r};function w_(e,t,{clamp:n=!0,ease:r,mixer:o}={}){const i=e.length;if(ig(i===t.length,"Both input and output ranges must be the same length","range-length"),1===i)return()=>t[0];if(2===i&&t[0]===t[1])return()=>t[1];const a=e[0]===e[1];e[0]>e[i-1]&&(e=[...e].reverse(),t=[...t].reverse());const s=function(e,t,n){const r=[],o=n||Og.mix||Hb,i=e.length-1;for(let n=0;n<i;n++){let i=o(e[n],e[n+1]);if(t){const e=Array.isArray(t)?t[n]||Tg:t;i=Tb(e,i)}r.push(i)}return r}(t,r,o),l=s.length,c=n=>{if(a&&n<e[0])return t[0];let r=0;if(l>1)for(;r<e.length-2&&!(n<e[r+1]);r++);const o=E_(e[r],e[r+1],n);return s[r](o)};return n?t=>c(um(e[0],e[i-1],t)):c}function x_(e){const t=[0];return function(e,t){const n=e[e.length-1];for(let r=1;r<=t;r++){const o=E_(0,t,r);e.push(sy(n,1,o))}}(t,e.length-1),t}function k_({duration:e=300,keyframes:t,times:n,ease:r="easeInOut"}){const o=(e=>Array.isArray(e)&&"number"!=typeof e[0])(r)?r.map(A_):A_(r),i={done:!1,value:t[0]},a=function(e,t){return e.map((e=>e*t))}(n&&n.length===t.length?n:x_(t),e),s=w_(a,t,{ease:Array.isArray(o)?o:(l=t,c=o,l.map((()=>c||u_)).splice(0,l.length-1))});var l,c;return{calculatedDuration:e,next:t=>(i.value=s(t),i.done=t>=e,i)}}const C_={decay:r_,inertia:r_,tween:k_,keyframes:k_,spring:e_};function S_(e){"string"==typeof e.type&&(e.type=C_[e.type])}const M_=e=>e/100;class T_ extends lv{constructor(e){super(),this.state="idle",this.startTime=null,this.isStopped=!1,this.currentTime=0,this.holdTime=null,this.playbackSpeed=1,this.delayState={done:!1,value:void 0},this.stop=()=>{const{motionValue:e}=this.options;e&&e.updatedAt!==xv.now()&&this.tick(xv.now()),this.isStopped=!0,"idle"!==this.state&&(this.teardown(),this.options.onStop?.())},cv.mainThread++,this.options=e,this.initAnimation(),this.play(),!1===e.autoplay&&this.pause()}initAnimation(){const{options:e}=this;S_(e);const{type:t=k_,repeat:n=0,repeatDelay:r=0,repeatType:o,velocity:i=0}=e;let{keyframes:a}=e;const s=t||k_;s!==k_&&"number"!=typeof a[0]&&(this.mixKeyframes=Tb(M_,Hb(a[0],a[1])),a=[0,100]);const l=s({...e,keyframes:a});"mirror"===o&&(this.mirroredGenerator=s({...e,keyframes:[...a].reverse(),velocity:-i})),null===l.calculatedDuration&&(l.calculatedDuration=Wb(l));const{calculatedDuration:c}=l;this.calculatedDuration=c,this.resolvedDuration=c+r,this.totalDuration=this.resolvedDuration*(n+1)-r,this.generator=l}updateTime(e){const t=Math.round(e-this.startTime)*this.playbackSpeed;null!==this.holdTime?this.currentTime=this.holdTime:this.currentTime=t}tick(e,t=!1){const{generator:n,totalDuration:r,mixKeyframes:o,mirroredGenerator:i,resolvedDuration:a,calculatedDuration:s}=this;if(null===this.startTime)return n.next(0);const{delay:l=0,keyframes:c,repeat:u,repeatType:d,repeatDelay:p,type:f,onUpdate:h,finalKeyframe:m}=this.options;this.speed>0?this.startTime=Math.min(this.startTime,e):this.speed<0&&(this.startTime=Math.min(e-r/this.speed,this.startTime)),t?this.currentTime=e:this.updateTime(e);const g=this.currentTime-l*(this.playbackSpeed>=0?1:-1),v=this.playbackSpeed>=0?g<0:g>r;this.currentTime=Math.max(g,0),"finished"===this.state&&null===this.holdTime&&(this.currentTime=r);let y,b=this.currentTime,_=n;if(u){const e=Math.min(this.currentTime,r)/a;let t=Math.floor(e),n=e%1;!n&&e>=1&&(n=1),1===n&&t--,t=Math.min(t,u+1);Boolean(t%2)&&("reverse"===d?(n=1-n,p&&(n-=p/a)):"mirror"===d&&(_=i)),b=um(0,1,n)*a}v?(this.delayState.value=c[0],y=this.delayState):y=_.next(b),o&&!v&&(y.value=o(y.value));let{done:A}=y;v||null===s||(A=this.playbackSpeed>=0?this.currentTime>=r:this.currentTime<=0);const E=null===this.holdTime&&("finished"===this.state||"running"===this.state&&A);return E&&f!==r_&&(y.value=sv(c,this.options,m,this.speed)),h&&h(y.value),E&&this.finish(),y}then(e,t){return this.finished.then(e,t)}get duration(){return Zg(this.calculatedDuration)}get iterationDuration(){const{delay:e=0}=this.options||{};return this.duration+Zg(e)}get time(){return Zg(this.currentTime)}set time(e){e=Kg(e),this.currentTime=e,null===this.startTime||null!==this.holdTime||0===this.playbackSpeed?this.holdTime=e:this.driver&&(this.startTime=this.driver.now()-e/this.playbackSpeed),this.driver?this.driver.start(!1):(this.startTime=0,this.state="paused",this.holdTime=e,this.tick(e))}getGeneratorVelocity(){const e=this.currentTime;if(e<=0)return this.options.velocity||0;if(this.generator.velocity)return this.generator.velocity(e);return n_((e=>this.generator.next(e).value),e,this.generator.next(e).value)}get speed(){return this.playbackSpeed}set speed(e){const t=this.playbackSpeed!==e;t&&this.driver&&this.updateTime(xv.now()),this.playbackSpeed=e,t&&this.driver&&(this.time=Zg(this.currentTime))}play(){if(this.isStopped)return;const{driver:e=Ub,startTime:t}=this.options;this.driver||(this.driver=e((e=>this.tick(e)))),this.options.onPlay?.();const n=this.driver.now();"finished"===this.state?(this.updateFinished(),this.startTime=n):null!==this.holdTime?this.startTime=n-this.holdTime:this.startTime||(this.startTime=t??n),"finished"===this.state&&this.speed<0&&(this.startTime+=this.calculatedDuration),this.holdTime=null,this.state="running",this.driver.start()}pause(){this.state="paused",this.updateTime(xv.now()),this.holdTime=this.currentTime}complete(){"running"!==this.state&&this.play(),this.state="finished",this.holdTime=null}finish(){this.notifyFinished(),this.teardown(),this.state="finished",this.options.onComplete?.()}cancel(){this.holdTime=null,this.startTime=0,this.tick(0),this.teardown(),this.options.onCancel?.()}teardown(){this.state="idle",this.stopDriver(),this.startTime=this.holdTime=null,cv.mainThread--}stopDriver(){this.driver&&(this.driver.stop(),this.driver=void 0)}sample(e){return this.startTime=0,this.tick(e,!0)}attachTimeline(e){return this.options.allowFlatten&&(this.options.type="keyframes",this.options.ease="linear",this.initAnimation()),this.driver?.stop(),e.observe(this)}}const O_={anticipate:g_,backInOut:m_,circInOut:b_};function D_(e){"string"==typeof e.ease&&e.ease in O_&&(e.ease=O_[e.ease])}class L_ extends yv{constructor(e){D_(e),S_(e),super(e),void 0!==e.startTime&&!1!==e.autoplay&&(this.startTime=e.startTime),this.options=e}updateMotionValue(e){const{motionValue:t,onUpdate:n,onComplete:r,element:o,...i}=this.options;if(!t)return;if(void 0!==e)return void t.set(e);const a=new T_({...i,autoplay:!1}),s=Math.max(10,xv.now()-this.startTime),l=um(0,10,s-10),c=a.sample(s).value,{name:u}=this.options;o&&u&&tv(o,u,c),t.setWithVelocity(a.sample(Math.max(0,s-l)).value,c,l),a.stop()}}const P_=(e,t)=>"zIndex"!==t&&(!("number"!=typeof e&&!Array.isArray(e))||!("string"!=typeof e||!$m.test(e)&&"0"!==e||e.startsWith("url(")));function I_(e){e.duration=0,e.type="keyframes"}const B_=/^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;const R_=new Set(["color","backgroundColor","outlineColor","fill","stroke","borderColor","borderTopColor","borderRightColor","borderBottomColor","borderLeftColor"]),N_=nv((()=>Object.hasOwnProperty.call(Element.prototype,"animate")));function F_(e){const{motionValue:t,name:n,repeatDelay:r,repeatType:o,damping:i,type:a,keyframes:s}=e,l=t?.owner?.current;if(!(l instanceof HTMLElement))return!1;const{onUpdate:c,transformTemplate:u}=t.owner.getProps();return N_()&&n&&(bv.has(n)||R_.has(n)&&function(e){for(let t=0;t<e.length;t++)if("string"==typeof e[t]&&B_.test(e[t]))return!0;return!1}(s))&&("transform"!==n||!u)&&!c&&!r&&"mirror"!==o&&0!==i&&"inertia"!==a}class j_ extends lv{constructor({autoplay:e=!0,delay:t=0,type:n="keyframes",repeat:r=0,repeatDelay:o=0,repeatType:i="loop",keyframes:a,name:s,motionValue:l,element:c,...u}){super(),this.stop=()=>{this._animation&&(this._animation.stop(),this.stopTimeline?.()),this.keyframeResolver?.cancel()},this.createdAt=xv.now();const d={autoplay:e,delay:t,type:n,repeat:r,repeatDelay:o,repeatType:i,name:s,motionValue:l,element:c,...u},p=c?.KeyframeResolver||zg;this.keyframeResolver=new p(a,((e,t,n)=>this.onKeyframesResolved(e,t,d,!n)),s,l,c),this.keyframeResolver?.scheduleResolve()}onKeyframesResolved(e,t,n,r){this.keyframeResolver=void 0;const{name:o,type:i,velocity:a,delay:s,isHandoff:l,onUpdate:c}=n;this.resolvedAt=xv.now();let u=!0;(function(e,t,n,r){const o=e[0];if(null===o)return!1;if("display"===t||"visibility"===t)return!0;const i=e[e.length-1],a=P_(o,t),s=P_(i,t);return og(a===s,`You are trying to animate ${t} from "${o}" to "${i}". "${a?i:o}" is not an animatable value.`,"value-not-animatable"),!(!a||!s)&&(function(e){const t=e[0];if(1===e.length)return!0;for(let n=0;n<e.length;n++)if(e[n]!==t)return!0}(e)||("spring"===n||vv(n))&&r)})(e,o,i,a)||(u=!1,!Og.instantAnimations&&s||c?.(sv(e,n,t)),e[0]=e[e.length-1],I_(n),n.repeat=0);const d={startTime:r?this.resolvedAt&&this.resolvedAt-this.createdAt>40?this.resolvedAt:this.createdAt:void 0,finalKeyframe:t,...n,keyframes:e},p=u&&!l&&F_(d),f=d.motionValue?.owner?.current;let h;if(p)try{h=new L_({...d,element:f})}catch{h=new T_(d)}else h=new T_(d);h.finished.then((()=>{this.notifyFinished()})).catch(Tg),this.pendingTimeline&&(this.stopTimeline=h.attachTimeline(this.pendingTimeline),this.pendingTimeline=void 0),this._animation=h}get finished(){return this._animation?this.animation.finished:this._finished}then(e,t){return this.finished.finally(e).then((()=>{}))}get animation(){return this._animation||(this.keyframeResolver?.resume(),$g=!0,Ug(),Hg(),$g=!1),this._animation}get duration(){return this.animation.duration}get iterationDuration(){return this.animation.iterationDuration}get time(){return this.animation.time}set time(e){this.animation.time=e}get speed(){return this.animation.speed}get state(){return this.animation.state}set speed(e){this.animation.speed=e}get startTime(){return this.animation.startTime}attachTimeline(e){return this._animation?this.stopTimeline=this.animation.attachTimeline(e):this.pendingTimeline=e,()=>this.stop()}play(){this.animation.play()}pause(){this.animation.pause()}complete(){this.animation.complete()}cancel(){this._animation&&this.animation.cancel(),this.keyframeResolver?.cancel()}}const Y_={type:"spring",stiffness:500,damping:25,restSpeed:10},$_={type:"keyframes",duration:.8},H_={type:"keyframes",ease:[.25,.1,.35,1],duration:.3},U_=(e,{keyframes:t})=>t.length>2?$_:cm.has(e)?e.startsWith("scale")?{type:"spring",stiffness:550,damping:0===t[1]?2*Math.sqrt(550):30,restSpeed:10}:Y_:H_,z_=new Set(["when","delay","delayChildren","staggerChildren","staggerDirection","repeat","repeatType","repeatDelay","from","elapsed"]);const W_=(e,t,n,r={},o,i)=>a=>{const s=Eb(r,e)||{},l=s.delay||r.delay||0;let{elapsed:c=0}=r;c-=Kg(l);const u={keyframes:Array.isArray(n)?n:[null,n],ease:"easeOut",velocity:t.getVelocity(),...s,delay:-c,onUpdate:e=>{t.set(e),s.onUpdate&&s.onUpdate(e)},onComplete:()=>{a(),s.onComplete&&s.onComplete()},name:e,motionValue:t,element:i?void 0:o};(function(e){for(const t in e)if(!z_.has(t))return!0;return!1})(s)||Object.assign(u,U_(e,u)),u.duration&&(u.duration=Kg(u.duration)),u.repeatDelay&&(u.repeatDelay=Kg(u.repeatDelay)),void 0!==u.from&&(u.keyframes[0]=u.from);let d=!1;if((!1===u.type||0===u.duration&&!u.repeatDelay)&&(I_(u),0===u.delay&&(d=!0)),(Og.instantAnimations||Og.skipAnimations||o?.shouldSkipAnimations)&&(d=!0,I_(u),u.delay=0),u.allowFlatten=!s.type&&!s.ease,d&&!i&&void 0!==t.get()){const e=sv(u.keyframes,s);if(void 0!==e)return void Ig.update((()=>{u.onUpdate(e),u.onComplete()}))}return s.isSync?new T_(u):new j_(u)};function V_({protectedKeys:e,needsAnimating:t},n){const r=e.hasOwnProperty(n)&&!0!==t[n];return t[n]=!1,r}function G_(e,t,{delay:n=0,transitionOverride:r,type:o}={}){let{transition:i,transitionEnd:a,...s}=t;const l=e.getDefaultTransition();i=i?Ab(i,l):l;const c=i?.reduceMotion;r&&(i=r);const u=[],d=o&&e.animationState&&e.animationState.getState()[o];for(const t in s){const r=e.getValue(t,e.latestValues[t]??null),o=s[t];if(void 0===o||d&&V_(d,t))continue;const a={delay:n,...Eb(i||{},t)},l=r.get();if(void 0!==l&&!r.isAnimating()&&!Array.isArray(o)&&o===l&&!a.velocity){Ig.update((()=>r.set(o)));continue}let p=!1;if(window.MotionHandoffAnimation){const n=Sb(e);if(n){const e=window.MotionHandoffAnimation(n,t,Ig);null!==e&&(a.startTime=e,p=!0)}}Cb(e,t);const f=c??e.shouldReduceMotion;r.start(W_(t,r,o,f&&eg.has(t)?{type:!1}:a,e,p));const h=r.animation;h&&u.push(h)}if(a){const t=()=>Ig.update((()=>{a&&function(e,t){const n=_b(e,t);let{transitionEnd:r={},transition:o={},...i}=n||{};i={...i,...r};for(const t in i)xb(e,t,kb(i[t]))}(e,a)}));u.length?Promise.all(u).then(t):t()}return u}function Q_(e,t,n,r=0,o=1){const i=Array.from(e).sort(((e,t)=>e.sortNodePosition(t))).indexOf(t),a=e.size,s=(a-1)*r;return"function"==typeof n?n(i,a):1===o?i*r:s-i*r}function q_(e,t,n={}){const r=_b(e,t,"exit"===n.type?e.presenceContext?.custom:void 0);let{transition:o=e.getDefaultTransition()||{}}=r||{};n.transitionOverride&&(o=n.transitionOverride);const i=r?()=>Promise.all(G_(e,r,n)):()=>Promise.resolve(),a=e.variantChildren&&e.variantChildren.size?(r=0)=>{const{delayChildren:i=0,staggerChildren:a,staggerDirection:s}=o;return function(e,t,n=0,r=0,o=0,i=1,a){const s=[];for(const l of e.variantChildren)l.notify("AnimationStart",t),s.push(q_(l,t,{...a,delay:n+("function"==typeof r?0:r)+Q_(e.variantChildren,l,r,o,i)}).then((()=>l.notify("AnimationComplete",t))));return Promise.all(s)}(e,t,r,i,a,s,n)}:()=>Promise.resolve(),{when:s}=o;if(s){const[e,t]="beforeChildren"===s?[i,a]:[a,i];return e().then((()=>t()))}return Promise.all([i(),a(n.delay)])}const K_=Iv.length;function Z_(e){if(!e)return;if(!e.isControllingVariants){const t=e.parent&&Z_(e.parent)||{};return void 0!==e.props.initial&&(t.initial=e.props.initial),t}const t={};for(let n=0;n<K_;n++){const r=Iv[n],o=e.props[r];(Lv(o)||!1===o)&&(t[r]=o)}return t}function J_(e,t){if(!Array.isArray(t))return!1;const n=t.length;if(n!==e.length)return!1;for(let r=0;r<n;r++)if(t[r]!==e[r])return!1;return!0}const X_=[...Pv].reverse(),eA=Pv.length;function tA(e){return t=>Promise.all(t.map((({animation:t,options:n})=>function(e,t,n={}){let r;if(e.notify("AnimationStart",t),Array.isArray(t)){const o=t.map((t=>q_(e,t,n)));r=Promise.all(o)}else if("string"==typeof t)r=q_(e,t,n);else{const o="function"==typeof t?_b(e,t,n.custom):t;r=Promise.all(G_(e,o,n))}return r.then((()=>{e.notify("AnimationComplete",t)}))}(e,t,n))))}function nA(e){let t=tA(e),n=iA(),r=!0,o=!1;const i=t=>(n,r)=>{const o=_b(e,r,"exit"===t?e.presenceContext?.custom:void 0);if(o){const{transition:e,transitionEnd:t,...r}=o;n={...n,...r,...t}}return n};function a(a){const{props:s}=e,l=Z_(e.parent)||{},c=[],u=new Set;let d={},p=1/0;for(let t=0;t<eA;t++){const f=X_[t],h=n[f],m=void 0!==s[f]?s[f]:l[f],g=Lv(m),v=f===a?h.isActive:null;!1===v&&(p=t);let y=m===l[f]&&m!==s[f]&&g;if(y&&(r||o)&&e.manuallyAnimateOnMount&&(y=!1),h.protectedKeys={...d},!h.isActive&&null===v||!m&&!h.prevProp||Dv(m)||"boolean"==typeof m)continue;if("exit"===f&&h.isActive&&!0!==v){h.prevResolvedValues&&(d={...d,...h.prevResolvedValues});continue}const b=rA(h.prevProp,m);let _=b||f===a&&h.isActive&&!y&&g||t>p&&g,A=!1;const E=Array.isArray(m)?m:[m];let w=E.reduce(i(f),{});!1===v&&(w={});const{prevResolvedValues:x={}}=h,k={...x,...w},C=t=>{_=!0,u.has(t)&&(A=!0,u.delete(t)),h.needsAnimating[t]=!0;const n=e.getValue(t);n&&(n.liveStyle=!1)};for(const e in k){const t=w[e],n=x[e];if(d.hasOwnProperty(e))continue;let r=!1;r=wb(t)&&wb(n)?!J_(t,n):t!==n,r?null!=t?C(e):u.add(e):void 0!==t&&u.has(e)?C(e):h.protectedKeys[e]=!0}h.prevProp=m,h.prevResolvedValues=w,h.isActive&&(d={...d,...w}),(r||o)&&e.blockInitialAnimation&&(_=!1);const S=y&&b;_&&(!S||A)&&c.push(...E.map((t=>{const n={type:f};if("string"==typeof t&&(r||o)&&!S&&e.manuallyAnimateOnMount&&e.parent){const{parent:r}=e,o=_b(r,t);if(r.enteringChildren&&o){const{delayChildren:t}=o.transition||{};n.delay=Q_(r.enteringChildren,e,t)}}return{animation:t,options:n}})))}if(u.size){const t={};if("boolean"!=typeof s.initial){const n=_b(e,Array.isArray(s.initial)?s.initial[0]:s.initial);n&&n.transition&&(t.transition=n.transition)}u.forEach((n=>{const r=e.getBaseTarget(n),o=e.getValue(n);o&&(o.liveStyle=!0),t[n]=r??null})),c.push({animation:t})}let f=Boolean(c.length);return!r||!1!==s.initial&&s.initial!==s.animate||e.manuallyAnimateOnMount||(f=!1),r=!1,o=!1,f?t(c):Promise.resolve()}return{animateChanges:a,setActive:function(t,r){if(n[t].isActive===r)return Promise.resolve();e.variantChildren?.forEach((e=>e.animationState?.setActive(t,r))),n[t].isActive=r;const o=a(t);for(const e in n)n[e].protectedKeys={};return o},setAnimateFunction:function(n){t=n(e)},getState:()=>n,reset:()=>{n=iA(),o=!0}}}function rA(e,t){return"string"==typeof t?t!==e:!!Array.isArray(t)&&!J_(t,e)}function oA(e=!1){return{isActive:e,protectedKeys:{},needsAnimating:{},prevResolvedValues:{}}}function iA(){return{animate:oA(!0),whileInView:oA(),whileHover:oA(),whileTap:oA(),whileDrag:oA(),whileFocus:oA(),exit:oA()}}let aA=0;const sA={animation:{Feature:class extends bb{constructor(e){super(e),e.animationState||(e.animationState=nA(e))}updateAnimationControlsSubscription(){const{animate:e}=this.node.getProps();Dv(e)&&(this.unmountControls=e.subscribe(this.node))}mount(){this.updateAnimationControlsSubscription()}update(){const{animate:e}=this.node.getProps(),{animate:t}=this.node.prevProps||{};e!==t&&this.updateAnimationControlsSubscription()}unmount(){this.node.animationState.reset(),this.unmountControls?.()}}},exit:{Feature:class extends bb{constructor(){super(...arguments),this.id=aA++,this.isExitComplete=!1}update(){if(!this.node.presenceContext)return;const{isPresent:e,onExitComplete:t}=this.node.presenceContext,{isPresent:n}=this.node.prevPresenceContext||{};if(!this.node.animationState||e===n)return;if(e&&!1===n){if(this.isExitComplete){const{initial:e,custom:t}=this.node.getProps();if("string"==typeof e){const n=_b(this.node,e,t);if(n){const{transition:e,transitionEnd:t,...r}=n;for(const e in r)this.node.getValue(e)?.jump(r[e])}}this.node.animationState.reset(),this.node.animationState.animateChanges()}else this.node.animationState.setActive("exit",!1);return void(this.isExitComplete=!1)}const r=this.node.animationState.setActive("exit",!e);t&&!e&&r.then((()=>{this.isExitComplete=!0,t(this.id)}))}mount(){const{register:e,onExitComplete:t}=this.node.presenceContext||{};t&&t(this.id),e&&(this.unmount=e(this.id))}unmount(){}}}},lA={x:!1,y:!1};function cA(){return lA.x||lA.y}function uA(e){return[e("x"),e("y")]}const dA=.9999,pA=1.0001,fA=-.01,hA=.01;function mA(e){return e.max-e.min}function gA(e,t,n,r=.5){e.origin=r,e.originPoint=sy(t.min,t.max,e.origin),e.scale=mA(n)/mA(t),e.translate=sy(n.min,n.max,e.origin)-e.originPoint,(e.scale>=dA&&e.scale<=pA||isNaN(e.scale))&&(e.scale=1),(e.translate>=fA&&e.translate<=hA||isNaN(e.translate))&&(e.translate=0)}function vA(e,t,n,r){gA(e.x,t.x,n.x,r?r.originX:void 0),gA(e.y,t.y,n.y,r?r.originY:void 0)}function yA(e,t,n,r=0){const o=r?sy(n.min,n.max,r):n.min;e.min=o+t.min,e.max=e.min+mA(t)}function bA(e,t,n,r=0){const o=r?sy(n.min,n.max,r):n.min;e.min=t.min-o,e.max=e.min+mA(t)}function _A(e,t,n,r){bA(e.x,t.x,n.x,r?.x),bA(e.y,t.y,n.y,r?.y)}const AA=new Set(["BUTTON","INPUT","SELECT","TEXTAREA","A"]);const EA=new Set(["INPUT","SELECT","TEXTAREA"]);function wA(e,t,n,r={passive:!0}){return e.addEventListener(t,n,r),()=>e.removeEventListener(t,n)}function xA(e){return"object"==typeof e&&null!==e}function kA(e){return xA(e)&&"ownerSVGElement"in e}function CA(e,t,n){if(null==e)return[];if(e instanceof EventTarget)return[e];if("string"==typeof e){let r=document;t&&(r=t.current);const o=n?.[e]??r.querySelectorAll(e);return o?Array.from(o):[]}return Array.from(e).filter((e=>null!=e))}const SA=new WeakMap;let MA;const TA=(e,t,n)=>(r,o)=>o&&o[0]?o[0][e+"Size"]:kA(r)&&"getBBox"in r?r.getBBox()[t]:r[n],OA=TA("inline","width","offsetWidth"),DA=TA("block","height","offsetHeight");function LA({target:e,borderBoxSize:t}){SA.get(e)?.forEach((n=>{n(e,{get width(){return OA(e,t)},get height(){return DA(e,t)}})}))}function PA(e){e.forEach(LA)}function IA(e,t){MA||"undefined"!=typeof ResizeObserver&&(MA=new ResizeObserver(PA));const n=CA(e);return n.forEach((e=>{let n=SA.get(e);n||(n=new Set,SA.set(e,n)),n.add(t),MA?.observe(e)})),()=>{n.forEach((e=>{const n=SA.get(e);n?.delete(t),n?.size||MA?.unobserve(e)}))}}const BA=new Set;let RA;function NA(e){return BA.add(e),RA||(RA=()=>{const e={get width(){return window.innerWidth},get height(){return window.innerHeight}};BA.forEach((t=>t(e)))},window.addEventListener("resize",RA)),()=>{BA.delete(e),BA.size||"function"!=typeof RA||(window.removeEventListener("resize",RA),RA=void 0)}}function FA(e,t){return"function"==typeof e?NA(e):IA(e,t)}const jA=e=>"mouse"===e.pointerType?"number"!=typeof e.button||e.button<=0:!1!==e.isPrimary;function YA(e){return{point:{x:e.pageX,y:e.pageY}}}function $A(e,t,n,r){return wA(e,t,(e=>t=>jA(t)&&e(t,YA(t)))(n),r)}const HA=({current:e})=>e?e.ownerDocument.defaultView:null,UA=(e,t)=>Math.abs(e-t);const zA=new Set(["auto","scroll"]);class WA{constructor(e,t,{transformPagePoint:n,contextWindow:r=window,dragSnapToOrigin:o=!1,distanceThreshold:i=3,element:a}={}){if(this.startEvent=null,this.lastMoveEvent=null,this.lastMoveEventInfo=null,this.lastRawMoveEventInfo=null,this.handlers={},this.contextWindow=window,this.scrollPositions=new Map,this.removeScrollListeners=null,this.onElementScroll=e=>{this.handleScroll(e.target)},this.onWindowScroll=()=>{this.handleScroll(window)},this.updatePoint=()=>{if(!this.lastMoveEvent||!this.lastMoveEventInfo)return;this.lastRawMoveEventInfo&&(this.lastMoveEventInfo=VA(this.lastRawMoveEventInfo,this.transformPagePoint));const e=QA(this.lastMoveEventInfo,this.history),t=null!==this.startEvent,n=function(e,t){const n=UA(e.x,t.x),r=UA(e.y,t.y);return Math.sqrt(n**2+r**2)}(e.offset,{x:0,y:0})>=this.distanceThreshold;if(!t&&!n)return;const{point:r}=e,{timestamp:o}=Rg;this.history.push({...r,timestamp:o});const{onStart:i,onMove:a}=this.handlers;t||(i&&i(this.lastMoveEvent,e),this.startEvent=this.lastMoveEvent),a&&a(this.lastMoveEvent,e)},this.handlePointerMove=(e,t)=>{this.lastMoveEvent=e,this.lastRawMoveEventInfo=t,this.lastMoveEventInfo=VA(t,this.transformPagePoint),Ig.update(this.updatePoint,!0)},this.handlePointerUp=(e,t)=>{this.end();const{onEnd:n,onSessionEnd:r,resumeAnimation:o}=this.handlers;if(!this.dragSnapToOrigin&&this.startEvent||o&&o(),!this.lastMoveEvent||!this.lastMoveEventInfo)return;const i=QA("pointercancel"===e.type?this.lastMoveEventInfo:VA(t,this.transformPagePoint),this.history);this.startEvent&&n&&n(e,i),r&&r(e,i)},!jA(e))return;this.dragSnapToOrigin=o,this.handlers=t,this.transformPagePoint=n,this.distanceThreshold=i,this.contextWindow=r||window;const s=VA(YA(e),this.transformPagePoint),{point:l}=s,{timestamp:c}=Rg;this.history=[{...l,timestamp:c}];const{onSessionStart:u}=t;u&&u(e,QA(s,this.history)),this.removeListeners=Tb($A(this.contextWindow,"pointermove",this.handlePointerMove),$A(this.contextWindow,"pointerup",this.handlePointerUp),$A(this.contextWindow,"pointercancel",this.handlePointerUp)),a&&this.startScrollTracking(a)}startScrollTracking(e){let t=e.parentElement;for(;t;){const e=getComputedStyle(t);(zA.has(e.overflowX)||zA.has(e.overflowY))&&this.scrollPositions.set(t,{x:t.scrollLeft,y:t.scrollTop}),t=t.parentElement}this.scrollPositions.set(window,{x:window.scrollX,y:window.scrollY}),window.addEventListener("scroll",this.onElementScroll,{capture:!0}),window.addEventListener("scroll",this.onWindowScroll),this.removeScrollListeners=()=>{window.removeEventListener("scroll",this.onElementScroll,{capture:!0}),window.removeEventListener("scroll",this.onWindowScroll)}}handleScroll(e){const t=this.scrollPositions.get(e);if(!t)return;const n=e===window,r=n?{x:window.scrollX,y:window.scrollY}:{x:e.scrollLeft,y:e.scrollTop},o=r.x-t.x,i=r.y-t.y;0===o&&0===i||(n?this.lastMoveEventInfo&&(this.lastMoveEventInfo.point.x+=o,this.lastMoveEventInfo.point.y+=i):this.history.length>0&&(this.history[0].x-=o,this.history[0].y-=i),this.scrollPositions.set(e,r),Ig.update(this.updatePoint,!0))}updateHandlers(e){this.handlers=e}end(){this.removeListeners&&this.removeListeners(),this.removeScrollListeners&&this.removeScrollListeners(),this.scrollPositions.clear(),Bg(this.updatePoint)}}function VA(e,t){return t?{point:t(e.point)}:e}function GA(e,t){return{x:e.x-t.x,y:e.y-t.y}}function QA({point:e},t){return{point:e,delta:GA(e,KA(t)),offset:GA(e,qA(t)),velocity:ZA(t,.1)}}function qA(e){return e[0]}function KA(e){return e[e.length-1]}function ZA(e,t){if(e.length<2)return{x:0,y:0};let n=e.length-1,r=null;const o=KA(e);for(;n>=0&&(r=e[n],!(o.timestamp-r.timestamp>Kg(t)));)n--;if(!r)return{x:0,y:0};r===e[0]&&e.length>2&&o.timestamp-r.timestamp>2*Kg(t)&&(r=e[1]);const i=Zg(o.timestamp-r.timestamp);if(0===i)return{x:0,y:0};const a={x:(o.x-r.x)/i,y:(o.y-r.y)/i};return a.x===1/0&&(a.x=0),a.y===1/0&&(a.y=0),a}function JA(e,t,n){return{min:void 0!==t?e.min+t:void 0,max:void 0!==n?e.max+n-(e.max-e.min):void 0}}function XA(e,t){let n=t.min-e.min,r=t.max-e.max;return t.max-t.min<e.max-e.min&&([n,r]=[r,n]),{min:n,max:r}}const eE=.35;function tE(e,t,n){return{min:nE(e,t),max:nE(e,n)}}function nE(e,t){return"number"==typeof e?e:e[t]||0}const rE=new WeakMap;class oE{constructor(e){this.openDragLock=null,this.isDragging=!1,this.currentDirection=null,this.originPoint={x:0,y:0},this.constraints=!1,this.hasMutatedConstraints=!1,this.elastic=Jm(),this.latestPointerEvent=null,this.latestPanInfo=null,this.visualElement=e}start(e,{snapToCursor:t=!1,distanceThreshold:n}={}){const{presenceContext:r}=this.visualElement;if(r&&!1===r.isPresent)return;const{dragSnapToOrigin:o}=this.getProps();this.panSession=new WA(e,{onSessionStart:e=>{t&&this.snapToCursor(YA(e).point),this.stopAnimation()},onStart:(e,t)=>{const{drag:n,dragPropagation:r,onDragStart:o}=this.getProps();if(n&&!r&&(this.openDragLock&&this.openDragLock(),this.openDragLock="x"===(i=n)||"y"===i?lA[i]?null:(lA[i]=!0,()=>{lA[i]=!1}):lA.x||lA.y?null:(lA.x=lA.y=!0,()=>{lA.x=lA.y=!1}),!this.openDragLock))return;var i;this.latestPointerEvent=e,this.latestPanInfo=t,this.isDragging=!0,this.currentDirection=null,this.resolveConstraints(),this.visualElement.projection&&(this.visualElement.projection.isAnimationBlocked=!0,this.visualElement.projection.target=void 0),uA((e=>{let t=this.getAxisMotionValue(e).get()||0;if(xm.test(t)){const{projection:n}=this.visualElement;if(n&&n.layout){const r=n.layout.layoutBox[e];if(r){t=mA(r)*(parseFloat(t)/100)}}}this.originPoint[e]=t})),o&&Ig.update((()=>o(e,t)),!1,!0),Cb(this.visualElement,"transform");const{animationState:a}=this.visualElement;a&&a.setActive("whileDrag",!0)},onMove:(e,t)=>{this.latestPointerEvent=e,this.latestPanInfo=t;const{dragPropagation:n,dragDirectionLock:r,onDirectionLock:o,onDrag:i}=this.getProps();if(!n&&!this.openDragLock)return;const{offset:a}=t;if(r&&null===this.currentDirection)return this.currentDirection=function(e,t=10){let n=null;Math.abs(e.y)>t?n="y":Math.abs(e.x)>t&&(n="x");return n}(a),void(null!==this.currentDirection&&o&&o(this.currentDirection));this.updateAxis("x",t.point,a),this.updateAxis("y",t.point,a),this.visualElement.render(),i&&Ig.update((()=>i(e,t)),!1,!0)},onSessionEnd:(e,t)=>{this.latestPointerEvent=e,this.latestPanInfo=t,this.stop(e,t),this.latestPointerEvent=null,this.latestPanInfo=null},resumeAnimation:()=>{const{dragSnapToOrigin:e}=this.getProps();(e||this.constraints)&&this.startAnimation({x:0,y:0})}},{transformPagePoint:this.visualElement.getTransformPagePoint(),dragSnapToOrigin:o,distanceThreshold:n,contextWindow:HA(this.visualElement),element:this.visualElement.current})}stop(e,t){const n=e||this.latestPointerEvent,r=t||this.latestPanInfo,o=this.isDragging;if(this.cancel(),!o||!r||!n)return;const{velocity:i}=r;this.startAnimation(i);const{onDragEnd:a}=this.getProps();a&&Ig.postRender((()=>a(n,r)))}cancel(){this.isDragging=!1;const{projection:e,animationState:t}=this.visualElement;e&&(e.isAnimationBlocked=!1),this.endPanSession();const{dragPropagation:n}=this.getProps();!n&&this.openDragLock&&(this.openDragLock(),this.openDragLock=null),t&&t.setActive("whileDrag",!1)}endPanSession(){this.panSession&&this.panSession.end(),this.panSession=void 0}updateAxis(e,t,n){const{drag:r}=this.getProps();if(!n||!aE(e,r,this.currentDirection))return;const o=this.getAxisMotionValue(e);let i=this.originPoint[e]+n[e];this.constraints&&this.constraints[e]&&(i=function(e,{min:t,max:n},r){return void 0!==t&&e<t?e=r?sy(t,e,r.min):Math.max(e,t):void 0!==n&&e>n&&(e=r?sy(n,e,r.max):Math.min(e,n)),e}(i,this.constraints[e],this.elastic[e])),o.set(i)}resolveConstraints(){const{dragConstraints:e,dragElastic:t}=this.getProps(),n=this.visualElement.projection&&!this.visualElement.projection.layout?this.visualElement.projection.measure(!1):this.visualElement.projection?.layout,r=this.constraints;e&&pb(e)?this.constraints||(this.constraints=this.resolveRefConstraints()):this.constraints=!(!e||!n)&&function(e,{top:t,left:n,bottom:r,right:o}){return{x:JA(e.x,n,o),y:JA(e.y,t,r)}}(n.layoutBox,e),this.elastic=function(e=eE){return!1===e?e=0:!0===e&&(e=eE),{x:tE(e,"left","right"),y:tE(e,"top","bottom")}}(t),r!==this.constraints&&!pb(e)&&n&&this.constraints&&!this.hasMutatedConstraints&&uA((e=>{!1!==this.constraints&&this.getAxisMotionValue(e)&&(this.constraints[e]=function(e,t){const n={};return void 0!==t.min&&(n.min=t.min-e.min),void 0!==t.max&&(n.max=t.max-e.min),n}(n.layoutBox[e],this.constraints[e]))}))}resolveRefConstraints(){const{dragConstraints:e,onMeasureDragConstraints:t}=this.getProps();if(!e||!pb(e))return!1;const n=e.current;ig(null!==n,"If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.","drag-constraints-ref");const{projection:r}=this.visualElement;if(!r||!r.layout)return!1;const o=function(e,t,n){const r=Oy(e,n),{scroll:o}=t;return o&&(Cy(r.x,o.offset.x),Cy(r.y,o.offset.y)),r}(n,r.root,this.visualElement.getTransformPagePoint());let i=function(e,t){return{x:XA(e.x,t.x),y:XA(e.y,t.y)}}(r.layout.layoutBox,o);if(t){const e=t(function({x:e,y:t}){return{top:t.min,right:e.max,bottom:t.max,left:e.min}}(i));this.hasMutatedConstraints=!!e,e&&(i=hy(e))}return i}startAnimation(e){const{drag:t,dragMomentum:n,dragElastic:r,dragTransition:o,dragSnapToOrigin:i,onDragTransitionEnd:a}=this.getProps(),s=this.constraints||{},l=uA((a=>{if(!aE(a,t,this.currentDirection))return;let l=s&&s[a]||{};!0!==i&&i!==a||(l={min:0,max:0});const c=r?200:1e6,u=r?40:1e7,d={type:"inertia",velocity:n?e[a]:0,bounceStiffness:c,bounceDamping:u,timeConstant:750,restDelta:1,restSpeed:10,...o,...l};return this.startAxisValueAnimation(a,d)}));return Promise.all(l).then(a)}startAxisValueAnimation(e,t){const n=this.getAxisMotionValue(e);return Cb(this.visualElement,e),n.start(W_(e,n,0,t,this.visualElement,!1))}stopAnimation(){uA((e=>this.getAxisMotionValue(e).stop()))}getAxisMotionValue(e){const t=`_drag${e.toUpperCase()}`,n=this.visualElement.getProps(),r=n[t];return r||this.visualElement.getValue(e,(n.initial?n.initial[e]:void 0)||0)}snapToCursor(e){uA((t=>{const{drag:n}=this.getProps();if(!aE(t,n,this.currentDirection))return;const{projection:r}=this.visualElement,o=this.getAxisMotionValue(t);if(r&&r.layout){const{min:n,max:i}=r.layout.layoutBox[t],a=o.get()||0;o.set(e[t]-sy(n,i,.5)+a)}}))}scalePositionWithinConstraints(){if(!this.visualElement.current)return;const{drag:e,dragConstraints:t}=this.getProps(),{projection:n}=this.visualElement;if(!pb(t)||!n||!this.constraints)return;this.stopAnimation();const r={x:0,y:0};uA((e=>{const t=this.getAxisMotionValue(e);if(t&&!1!==this.constraints){const n=t.get();r[e]=function(e,t){let n=.5;const r=mA(e),o=mA(t);return o>r?n=E_(t.min,t.max-r,e.min):r>o&&(n=E_(e.min,e.max-o,t.min)),um(0,1,n)}({min:n,max:n},this.constraints[e])}}));const{transformTemplate:o}=this.visualElement.getProps();this.visualElement.current.style.transform=o?o({},""):"none",n.root&&n.root.updateScroll(),n.updateLayout(),this.constraints=!1,this.resolveConstraints(),uA((t=>{if(!aE(t,e,null))return;const n=this.getAxisMotionValue(t),{min:o,max:i}=this.constraints[t];n.set(sy(o,i,r[t]))})),this.visualElement.render()}addListeners(){if(!this.visualElement.current)return;rE.set(this.visualElement,this);const e=this.visualElement.current,t=$A(e,"pointerdown",(t=>{const{drag:n,dragListener:r=!0}=this.getProps(),o=t.target,i=o!==e&&function(e){return EA.has(e.tagName)||!0===e.isContentEditable}(o);n&&r&&!i&&this.start(t)}));let n;const r=()=>{const{dragConstraints:t}=this.getProps();pb(t)&&t.current&&(this.constraints=this.resolveRefConstraints(),n||(n=function(e,t,n){const r=FA(e,iE(n)),o=FA(t,iE(n));return()=>{r(),o()}}(e,t.current,(()=>this.scalePositionWithinConstraints()))))},{projection:o}=this.visualElement,i=o.addEventListener("measure",r);o&&!o.layout&&(o.root&&o.root.updateScroll(),o.updateLayout()),Ig.read(r);const a=wA(window,"resize",(()=>this.scalePositionWithinConstraints())),s=o.addEventListener("didUpdate",(({delta:e,hasLayoutChanged:t})=>{this.isDragging&&t&&(uA((t=>{const n=this.getAxisMotionValue(t);n&&(this.originPoint[t]+=e[t].translate,n.set(n.get()+e[t].translate))})),this.visualElement.render())}));return()=>{a(),t(),i(),s&&s(),n&&n()}}getProps(){const e=this.visualElement.getProps(),{drag:t=!1,dragDirectionLock:n=!1,dragPropagation:r=!1,dragConstraints:o=!1,dragElastic:i=eE,dragMomentum:a=!0}=e;return{...e,drag:t,dragDirectionLock:n,dragPropagation:r,dragConstraints:o,dragElastic:i,dragMomentum:a}}}function iE(e){let t=!0;return()=>{t?t=!1:e()}}function aE(e,t,n){return!(!0!==t&&t!==e||null!==n&&n!==e)}const sE=e=>(t,n)=>{e&&Ig.update((()=>e(t,n)),!1,!0)};const lE={hasAnimatedSinceResize:!0,hasEverUpdated:!1};function cE(e=!0){const t=(0,i.useContext)(Xy);if(null===t)return[!0,null];const{isPresent:n,onExitComplete:r,register:o}=t,a=(0,i.useId)();(0,i.useEffect)((()=>{if(e)return o(a)}),[e]);const s=(0,i.useCallback)((()=>e&&r&&r(a)),[a,r,e]);return!n&&r?[!1,s]:[!0]}function uE(){return null===(e=(0,i.useContext)(Xy))||e.isPresent;var e}let dE=!1;class pE extends i.Component{componentDidMount(){const{visualElement:e,layoutGroup:t,switchLayoutGroup:n,layoutId:r}=this.props,{projection:o}=e;o&&(t.group&&t.group.add(o),n&&n.register&&r&&n.register(o),dE&&o.root.didUpdate(),o.addEventListener("animationComplete",(()=>{this.safeToRemove()})),o.setOptions({...o.options,layoutDependency:this.props.layoutDependency,onExitComplete:()=>this.safeToRemove()})),lE.hasEverUpdated=!0}getSnapshotBeforeUpdate(e){const{layoutDependency:t,visualElement:n,drag:r,isPresent:o}=this.props,{projection:i}=n;return i?(i.isPresent=o,e.layoutDependency!==t&&i.setOptions({...i.options,layoutDependency:t}),dE=!0,r||e.layoutDependency!==t||void 0===t||e.isPresent!==o?i.willUpdate():this.safeToRemove(),e.isPresent!==o&&(o?i.promote():i.relegate()||Ig.postRender((()=>{const e=i.getStack();e&&e.members.length||this.safeToRemove()}))),null):null}componentDidUpdate(){const{visualElement:e,layoutAnchor:t}=this.props,{projection:n}=e;n&&(n.options.layoutAnchor=t,n.root.didUpdate(),_v.postRender((()=>{!n.currentAnimation&&n.isLead()&&this.safeToRemove()})))}componentWillUnmount(){const{visualElement:e,layoutGroup:t,switchLayoutGroup:n}=this.props,{projection:r}=e;dE=!0,r&&(r.scheduleCheckAfterUnmount(),t&&t.group&&t.group.remove(r),n&&n.deregister&&n.deregister(r))}safeToRemove(){const{safeToRemove:e}=this.props;e&&e()}render(){return null}}function fE(e){const[t,n]=cE(),r=(0,i.useContext)(By);return(0,br.jsx)(pE,{...e,layoutGroup:r,switchLayoutGroup:(0,i.useContext)(db),isPresent:t,safeToRemove:n})}function hE(e,t){const n=xv.now(),r=({timestamp:o})=>{const i=o-n;i>=t&&(Bg(r),e(i-t))};return Ig.setup(r,!0),()=>Bg(r)}const mE=["borderTopLeftRadius","borderTopRightRadius","borderBottomLeftRadius","borderBottomRightRadius"],gE=mE.length,vE=e=>"string"==typeof e?parseFloat(e):e,yE=e=>"number"==typeof e||km.test(e);function bE(e,t){return void 0!==e[t]?e[t]:e.borderRadius}const _E=EE(0,.5,y_),AE=EE(.5,.95,Tg);function EE(e,t,n){return r=>r<e?0:r>t?1:n(E_(e,t,r))}function wE(e,t){e.min=t.min,e.max=t.max}function xE(e,t){wE(e.x,t.x),wE(e.y,t.y)}function kE(e,t){e.translate=t.translate,e.scale=t.scale,e.originPoint=t.originPoint,e.origin=t.origin}function CE(e,t,n,r,o){return e=_y(e-=t,1/n,r),void 0!==o&&(e=_y(e,1/o,r)),e}function SE(e,t,[n,r,o],i,a){!function(e,t=0,n=1,r=.5,o,i=e,a=e){xm.test(t)&&(t=parseFloat(t),t=sy(a.min,a.max,t/100)-a.min);if("number"!=typeof t)return;let s=sy(i.min,i.max,r);e===i&&(s-=t),e.min=CE(e.min,t,n,s,o),e.max=CE(e.max,t,n,s,o)}(e,t[n],t[r],t[o],t.scale,i,a)}const ME=["x","scaleX","originX"],TE=["y","scaleY","originY"];function OE(e,t,n,r){SE(e.x,t,ME,n?n.x:void 0,r?r.x:void 0),SE(e.y,t,TE,n?n.y:void 0,r?r.y:void 0)}function DE(e){return 0===e.translate&&1===e.scale}function LE(e){return DE(e.x)&&DE(e.y)}function PE(e,t){return e.min===t.min&&e.max===t.max}function IE(e,t){return Math.round(e.min)===Math.round(t.min)&&Math.round(e.max)===Math.round(t.max)}function BE(e,t){return IE(e.x,t.x)&&IE(e.y,t.y)}function RE(e){return mA(e.x)/mA(e.y)}function NE(e,t){return e.translate===t.translate&&e.scale===t.scale&&e.originPoint===t.originPoint}class FE{constructor(){this.members=[]}add(e){Jg(this.members,e);for(let t=this.members.length-1;t>=0;t--){const n=this.members[t];if(n===e||n===this.lead||n===this.prevLead)continue;const r=n.instance;r&&!1!==r.isConnected||n.snapshot||(Xg(this.members,n),n.unmount())}e.scheduleRender()}remove(e){if(Xg(this.members,e),e===this.prevLead&&(this.prevLead=void 0),e===this.lead){const e=this.members[this.members.length-1];e&&this.promote(e)}}relegate(e){for(let t=this.members.indexOf(e)-1;t>=0;t--){const e=this.members[t];if(!1!==e.isPresent&&!1!==e.instance?.isConnected)return this.promote(e),!0}return!1}promote(e,t){const n=this.lead;if(e!==n&&(this.prevLead=n,this.lead=e,e.show(),n)){n.updateSnapshot(),e.scheduleRender();const{layoutDependency:r}=n.options,{layoutDependency:o}=e.options;void 0!==r&&r===o||(e.resumeFrom=n,t&&(n.preserveOpacity=!0),n.snapshot&&(e.snapshot=n.snapshot,e.snapshot.latestValues=n.animationValues||n.latestValues),e.root?.isUpdating&&(e.isLayoutDirty=!0)),!1===e.options.crossfade&&n.hide()}}exitAnimationComplete(){this.members.forEach((e=>{e.options.onExitComplete?.(),e.resumingFrom?.options.onExitComplete?.()}))}scheduleRender(){this.members.forEach((e=>e.instance&&e.scheduleRender(!1)))}removeLeadSnapshot(){this.lead?.snapshot&&(this.lead.snapshot=void 0)}}const jE=(e,t)=>e.depth-t.depth;class YE{constructor(){this.children=[],this.isDirty=!1}add(e){Jg(this.children,e),this.isDirty=!0}remove(e){Xg(this.children,e),this.isDirty=!0}forEach(e){this.isDirty&&this.children.sort(jE),this.isDirty=!1,this.children.forEach(e)}}const $E={nodes:0,calculatedTargetDeltas:0,calculatedProjections:0},HE=["","X","Y","Z"];let UE=0;function zE(e,t,n,r){const{latestValues:o}=t;o[e]&&(n[e]=o[e],t.setStaticValue(e,0),r&&(r[e]=0))}function WE(e){if(e.hasCheckedOptimisedAppear=!0,e.root===e)return;const{visualElement:t}=e.options;if(!t)return;const n=Sb(t);if(window.MotionHasOptimisedAnimation(n,"transform")){const{layout:t,layoutId:r}=e.options;window.MotionCancelOptimisedAnimation(n,"transform",Ig,!(t||r))}const{parent:r}=e;r&&!r.hasCheckedOptimisedAppear&&WE(r)}function VE({attachResizeListener:e,defaultParent:t,measureScroll:n,checkIsScrollRoot:r,resetTransform:o}){return class{constructor(e={},n=t?.()){this.id=UE++,this.animationId=0,this.animationCommitId=0,this.children=new Set,this.options={},this.isTreeAnimating=!1,this.isAnimationBlocked=!1,this.isLayoutDirty=!1,this.isProjectionDirty=!1,this.isSharedProjectionDirty=!1,this.isTransformDirty=!1,this.updateManuallyBlocked=!1,this.updateBlockedByResize=!1,this.isUpdating=!1,this.isSVG=!1,this.needsReset=!1,this.shouldResetTransform=!1,this.hasCheckedOptimisedAppear=!1,this.treeScale={x:1,y:1},this.eventHandlers=new Map,this.hasTreeAnimated=!1,this.layoutVersion=0,this.updateScheduled=!1,this.scheduleUpdate=()=>this.update(),this.projectionUpdateScheduled=!1,this.checkUpdateFailed=()=>{this.isUpdating&&(this.isUpdating=!1,this.clearAllSnapshots())},this.updateProjection=()=>{this.projectionUpdateScheduled=!1,Lg.value&&($E.nodes=$E.calculatedTargetDeltas=$E.calculatedProjections=0),this.nodes.forEach(qE),this.nodes.forEach(ow),this.nodes.forEach(iw),this.nodes.forEach(KE),Lg.addProjectionMetrics&&Lg.addProjectionMetrics($E)},this.resolvedRelativeTargetAt=0,this.linkedParentVersion=0,this.hasProjected=!1,this.isVisible=!0,this.animationProgress=0,this.sharedNodes=new Map,this.latestValues=e,this.root=n?n.root||n:this,this.path=n?[...n.path,n]:[],this.parent=n,this.depth=n?n.depth+1:0;for(let e=0;e<this.path.length;e++)this.path[e].shouldResetTransform=!0;this.root===this&&(this.nodes=new YE)}addEventListener(e,t){return this.eventHandlers.has(e)||this.eventHandlers.set(e,new ev),this.eventHandlers.get(e).add(t)}notifyListeners(e,...t){const n=this.eventHandlers.get(e);n&&n.notify(...t)}hasListeners(e){return this.eventHandlers.has(e)}mount(t){if(this.instance)return;var n;this.isSVG=kA(t)&&!(kA(n=t)&&"svg"===n.tagName),this.instance=t;const{layoutId:r,layout:o,visualElement:i}=this.options;if(i&&!i.current&&i.mount(t),this.root.nodes.add(this),this.parent&&this.parent.children.add(this),this.root.hasTreeAnimated&&(o||r)&&(this.isLayoutDirty=!0),e){let n,r=0;const o=()=>this.root.updateBlockedByResize=!1;Ig.read((()=>{r=window.innerWidth})),e(t,(()=>{const e=window.innerWidth;e!==r&&(r=e,this.root.updateBlockedByResize=!0,n&&n(),n=hE(o,250),lE.hasAnimatedSinceResize&&(lE.hasAnimatedSinceResize=!1,this.nodes.forEach(rw)))}))}r&&this.root.registerSharedNode(r,this),!1!==this.options.animate&&i&&(r||o)&&this.addEventListener("didUpdate",(({delta:e,hasLayoutChanged:t,hasRelativeLayoutChanged:n,layout:r})=>{if(this.isTreeAnimationBlocked())return this.target=void 0,void(this.relativeTarget=void 0);const o=this.options.transition||i.getDefaultTransition()||dw,{onLayoutAnimationStart:a,onLayoutAnimationComplete:s}=i.getProps(),l=!this.targetLayout||!BE(this.targetLayout,r),c=!t&&n;if(this.options.layoutRoot||this.resumeFrom||c||t&&(l||!this.currentAnimation)){this.resumeFrom&&(this.resumingFrom=this.resumeFrom,this.resumingFrom.resumingFrom=void 0);const t={...Eb(o,"layout"),onPlay:a,onComplete:s};(i.shouldReduceMotion||this.options.layoutRoot)&&(t.delay=0,t.type=!1),this.startAnimation(t),this.setAnimationOrigin(e,c)}else t||rw(this),this.isLead()&&this.options.onExitComplete&&this.options.onExitComplete();this.targetLayout=r}))}unmount(){this.options.layoutId&&this.willUpdate(),this.root.nodes.remove(this);const e=this.getStack();e&&e.remove(this),this.parent&&this.parent.children.delete(this),this.instance=void 0,this.eventHandlers.clear(),Bg(this.updateProjection)}blockUpdate(){this.updateManuallyBlocked=!0}unblockUpdate(){this.updateManuallyBlocked=!1}isUpdateBlocked(){return this.updateManuallyBlocked||this.updateBlockedByResize}isTreeAnimationBlocked(){return this.isAnimationBlocked||this.parent&&this.parent.isTreeAnimationBlocked()||!1}startUpdate(){this.isUpdateBlocked()||(this.isUpdating=!0,this.nodes&&this.nodes.forEach(aw),this.animationId++)}getTransformTemplate(){const{visualElement:e}=this.options;return e&&e.getProps().transformTemplate}willUpdate(e=!0){if(this.root.hasTreeAnimated=!0,this.root.isUpdateBlocked())return void(this.options.onExitComplete&&this.options.onExitComplete());if(window.MotionCancelOptimisedAnimation&&!this.hasCheckedOptimisedAppear&&WE(this),!this.root.isUpdating&&this.root.startUpdate(),this.isLayoutDirty)return;this.isLayoutDirty=!0;for(let e=0;e<this.path.length;e++){const t=this.path[e];t.shouldResetTransform=!0,"string"!=typeof t.latestValues.x&&"string"!=typeof t.latestValues.y||(t.isLayoutDirty=!0),t.updateScroll("snapshot"),t.options.layoutRoot&&t.willUpdate(!1)}const{layoutId:t,layout:n}=this.options;if(void 0===t&&!n)return;const r=this.getTransformTemplate();this.prevTransformTemplateValue=r?r(this.latestValues,""):void 0,this.updateSnapshot(),e&&this.notifyListeners("willUpdate")}update(){this.updateScheduled=!1;if(this.isUpdateBlocked()){const e=this.updateBlockedByResize;return this.unblockUpdate(),this.updateBlockedByResize=!1,this.clearAllSnapshots(),e&&this.nodes.forEach(XE),void this.nodes.forEach(JE)}if(this.animationId<=this.animationCommitId)return void this.nodes.forEach(ew);this.animationCommitId=this.animationId,this.isUpdating?(this.isUpdating=!1,this.nodes.forEach(tw),this.nodes.forEach(nw),this.nodes.forEach(GE),this.nodes.forEach(QE)):this.nodes.forEach(ew),this.clearAllSnapshots();const e=xv.now();Rg.delta=um(0,1e3/60,e-Rg.timestamp),Rg.timestamp=e,Rg.isProcessing=!0,Ng.update.process(Rg),Ng.preRender.process(Rg),Ng.render.process(Rg),Rg.isProcessing=!1}didUpdate(){this.updateScheduled||(this.updateScheduled=!0,_v.read(this.scheduleUpdate))}clearAllSnapshots(){this.nodes.forEach(ZE),this.sharedNodes.forEach(sw)}scheduleUpdateProjection(){this.projectionUpdateScheduled||(this.projectionUpdateScheduled=!0,Ig.preRender(this.updateProjection,!1,!0))}scheduleCheckAfterUnmount(){Ig.postRender((()=>{this.isLayoutDirty?this.root.didUpdate():this.root.checkUpdateFailed()}))}updateSnapshot(){!this.snapshot&&this.instance&&(this.snapshot=this.measure(),!this.snapshot||mA(this.snapshot.measuredBox.x)||mA(this.snapshot.measuredBox.y)||(this.snapshot=void 0))}updateLayout(){if(!this.instance)return;if(this.updateScroll(),!(this.options.alwaysMeasureLayout&&this.isLead()||this.isLayoutDirty))return;if(this.resumeFrom&&!this.resumeFrom.instance)for(let e=0;e<this.path.length;e++){this.path[e].updateScroll()}const e=this.layout;this.layout=this.measure(!1),this.layoutVersion++,this.layoutCorrected||(this.layoutCorrected=Jm()),this.isLayoutDirty=!1,this.projectionDelta=void 0,this.notifyListeners("measure",this.layout.layoutBox);const{visualElement:t}=this.options;t&&t.notify("LayoutMeasure",this.layout.layoutBox,e?e.layoutBox:void 0)}updateScroll(e="measure"){let t=Boolean(this.options.layoutScroll&&this.instance);if(this.scroll&&this.scroll.animationId===this.root.animationId&&this.scroll.phase===e&&(t=!1),t&&this.instance){const t=r(this.instance);this.scroll={animationId:this.root.animationId,phase:e,isRoot:t,offset:n(this.instance),wasRoot:this.scroll?this.scroll.isRoot:t}}}resetTransform(){if(!o)return;const e=this.isLayoutDirty||this.shouldResetTransform||this.options.alwaysMeasureLayout,t=this.projectionDelta&&!LE(this.projectionDelta),n=this.getTransformTemplate(),r=n?n(this.latestValues,""):void 0,i=r!==this.prevTransformTemplateValue;e&&this.instance&&(t||vy(this.latestValues)||i)&&(o(this.instance,r),this.shouldResetTransform=!1,this.scheduleRender())}measure(e=!0){const t=this.measurePageBox();let n=this.removeElementScroll(t);var r;return e&&(n=this.removeTransform(n)),hw((r=n).x),hw(r.y),{animationId:this.root.animationId,measuredBox:t,layoutBox:n,latestValues:{},source:this.id}}measurePageBox(){const{visualElement:e}=this.options;if(!e)return Jm();const t=e.measureViewportBox();if(!(this.scroll?.wasRoot||this.path.some(gw))){const{scroll:e}=this.root;e&&(Cy(t.x,e.offset.x),Cy(t.y,e.offset.y))}return t}removeElementScroll(e){const t=Jm();if(xE(t,e),this.scroll?.wasRoot)return t;for(let n=0;n<this.path.length;n++){const r=this.path[n],{scroll:o,options:i}=r;r!==this.root&&o&&i.layoutScroll&&(o.wasRoot&&xE(t,e),Cy(t.x,o.offset.x),Cy(t.y,o.offset.y))}return t}applyTransform(e,t=!1,n){const r=n||Jm();xE(r,e);for(let e=0;e<this.path.length;e++){const n=this.path[e];!t&&n.options.layoutScroll&&n.scroll&&n!==n.root&&(Cy(r.x,-n.scroll.offset.x),Cy(r.y,-n.scroll.offset.y)),vy(n.latestValues)&&Ty(r,n.latestValues,n.layout?.layoutBox)}return vy(this.latestValues)&&Ty(r,this.latestValues,this.layout?.layoutBox),r}removeTransform(e){const t=Jm();xE(t,e);for(let e=0;e<this.path.length;e++){const n=this.path[e];if(!vy(n.latestValues))continue;let r;n.instance&&(gy(n.latestValues)&&n.updateSnapshot(),r=Jm(),xE(r,n.measurePageBox())),OE(t,n.latestValues,n.snapshot?.layoutBox,r)}return vy(this.latestValues)&&OE(t,this.latestValues),t}setTargetDelta(e){this.targetDelta=e,this.root.scheduleUpdateProjection(),this.isProjectionDirty=!0}setOptions(e){this.options={...this.options,...e,crossfade:void 0===e.crossfade||e.crossfade}}clearMeasurements(){this.scroll=void 0,this.layout=void 0,this.snapshot=void 0,this.prevTransformTemplateValue=void 0,this.targetDelta=void 0,this.target=void 0,this.isLayoutDirty=!1}forceRelativeParentToResolveTarget(){this.relativeParent&&this.relativeParent.resolvedRelativeTargetAt!==Rg.timestamp&&this.relativeParent.resolveTargetDelta(!0)}resolveTargetDelta(e=!1){const t=this.getLead();this.isProjectionDirty||(this.isProjectionDirty=t.isProjectionDirty),this.isTransformDirty||(this.isTransformDirty=t.isTransformDirty),this.isSharedProjectionDirty||(this.isSharedProjectionDirty=t.isSharedProjectionDirty);const n=Boolean(this.resumingFrom)||this!==t;if(!(e||n&&this.isSharedProjectionDirty||this.isProjectionDirty||this.parent?.isProjectionDirty||this.attemptToResolveRelativeTarget||this.root.updateBlockedByResize))return;const{layout:r,layoutId:o}=this.options;if(!this.layout||!r&&!o)return;this.resolvedRelativeTargetAt=Rg.timestamp;const i=this.getClosestProjectingParent();var a,s,l,c;(i&&this.linkedParentVersion!==i.layoutVersion&&!i.options.layoutRoot&&this.removeRelativeTarget(),this.targetDelta||this.relativeTarget||(!1!==this.options.layoutAnchor&&i&&i.layout?this.createRelativeTarget(i,this.layout.layoutBox,i.layout.layoutBox):this.removeRelativeTarget()),this.relativeTarget||this.targetDelta)&&(this.target||(this.target=Jm(),this.targetWithTransforms=Jm()),this.relativeTarget&&this.relativeTargetOrigin&&this.relativeParent&&this.relativeParent.target?(this.forceRelativeParentToResolveTarget(),a=this.target,s=this.relativeTarget,l=this.relativeParent.target,c=this.options.layoutAnchor||void 0,yA(a.x,s.x,l.x,c?.x),yA(a.y,s.y,l.y,c?.y)):this.targetDelta?(Boolean(this.resumingFrom)?this.applyTransform(this.layout.layoutBox,!1,this.target):xE(this.target,this.layout.layoutBox),wy(this.target,this.targetDelta)):xE(this.target,this.layout.layoutBox),this.attemptToResolveRelativeTarget&&(this.attemptToResolveRelativeTarget=!1,!1!==this.options.layoutAnchor&&i&&Boolean(i.resumingFrom)===Boolean(this.resumingFrom)&&!i.options.layoutScroll&&i.target&&1!==this.animationProgress?this.createRelativeTarget(i,this.target,i.target):this.relativeParent=this.relativeTarget=void 0),Lg.value&&$E.calculatedTargetDeltas++)}getClosestProjectingParent(){if(this.parent&&!gy(this.parent.latestValues)&&!yy(this.parent.latestValues))return this.parent.isProjecting()?this.parent:this.parent.getClosestProjectingParent()}isProjecting(){return Boolean((this.relativeTarget||this.targetDelta||this.options.layoutRoot)&&this.layout)}createRelativeTarget(e,t,n){this.relativeParent=e,this.linkedParentVersion=e.layoutVersion,this.forceRelativeParentToResolveTarget(),this.relativeTarget=Jm(),this.relativeTargetOrigin=Jm(),_A(this.relativeTargetOrigin,t,n,this.options.layoutAnchor||void 0),xE(this.relativeTarget,this.relativeTargetOrigin)}removeRelativeTarget(){this.relativeParent=this.relativeTarget=void 0}calcProjection(){const e=this.getLead(),t=Boolean(this.resumingFrom)||this!==e;let n=!0;if((this.isProjectionDirty||this.parent?.isProjectionDirty)&&(n=!1),t&&(this.isSharedProjectionDirty||this.isTransformDirty)&&(n=!1),this.resolvedRelativeTargetAt===Rg.timestamp&&(n=!1),n)return;const{layout:r,layoutId:o}=this.options;if(this.isTreeAnimating=Boolean(this.parent&&this.parent.isTreeAnimating||this.currentAnimation||this.pendingAnimation),this.isTreeAnimating||(this.targetDelta=this.relativeTarget=void 0),!this.layout||!r&&!o)return;xE(this.layoutCorrected,this.layout.layoutBox);const i=this.treeScale.x,a=this.treeScale.y;!function(e,t,n,r=!1){const o=n.length;if(!o)return;let i,a;t.x=t.y=1;for(let s=0;s<o;s++){i=n[s],a=i.projectionDelta;const{visualElement:o}=i.options;o&&o.props.style&&"contents"===o.props.style.display||(r&&i.options.layoutScroll&&i.scroll&&i!==i.root&&(Cy(e.x,-i.scroll.offset.x),Cy(e.y,-i.scroll.offset.y)),a&&(t.x*=a.x.scale,t.y*=a.y.scale,wy(e,a)),r&&vy(i.latestValues)&&Ty(e,i.latestValues,i.layout?.layoutBox))}t.x<ky&&t.x>xy&&(t.x=1),t.y<ky&&t.y>xy&&(t.y=1)}(this.layoutCorrected,this.treeScale,this.path,t),!e.layout||e.target||1===this.treeScale.x&&1===this.treeScale.y||(e.target=e.layout.layoutBox,e.targetWithTransforms=Jm());const{target:s}=e;s?(this.projectionDelta&&this.prevProjectionDelta?(kE(this.prevProjectionDelta.x,this.projectionDelta.x),kE(this.prevProjectionDelta.y,this.projectionDelta.y)):this.createProjectionDeltas(),vA(this.projectionDelta,this.layoutCorrected,s,this.latestValues),this.treeScale.x===i&&this.treeScale.y===a&&NE(this.projectionDelta.x,this.prevProjectionDelta.x)&&NE(this.projectionDelta.y,this.prevProjectionDelta.y)||(this.hasProjected=!0,this.scheduleRender(),this.notifyListeners("projectionUpdate",s)),Lg.value&&$E.calculatedProjections++):this.prevProjectionDelta&&(this.createProjectionDeltas(),this.scheduleRender())}hide(){this.isVisible=!1}show(){this.isVisible=!0}scheduleRender(e=!0){if(this.options.visualElement?.scheduleRender(),e){const e=this.getStack();e&&e.scheduleRender()}this.resumingFrom&&!this.resumingFrom.instance&&(this.resumingFrom=void 0)}createProjectionDeltas(){this.prevProjectionDelta=Zm(),this.projectionDelta=Zm(),this.projectionDeltaWithTransform=Zm()}setAnimationOrigin(e,t=!1){const n=this.snapshot,r=n?n.latestValues:{},o={...this.latestValues},i=Zm();this.relativeParent&&this.relativeParent.options.layoutRoot||(this.relativeTarget=this.relativeTargetOrigin=void 0),this.attemptToResolveRelativeTarget=!t;const a=Jm(),s=(n?n.source:void 0)!==(this.layout?this.layout.source:void 0),l=this.getStack(),c=!l||l.members.length<=1,u=Boolean(s&&!c&&!0===this.options.crossfade&&!this.path.some(uw));let d;this.animationProgress=0,this.mixTargetDelta=t=>{const n=t/1e3;lw(i.x,e.x,n),lw(i.y,e.y,n),this.setTargetDelta(i),this.relativeTarget&&this.relativeTargetOrigin&&this.layout&&this.relativeParent&&this.relativeParent.layout&&(_A(a,this.layout.layoutBox,this.relativeParent.layout.layoutBox,this.options.layoutAnchor||void 0),function(e,t,n,r){cw(e.x,t.x,n.x,r),cw(e.y,t.y,n.y,r)}(this.relativeTarget,this.relativeTargetOrigin,a,n),d&&function(e,t){return PE(e.x,t.x)&&PE(e.y,t.y)}(this.relativeTarget,d)&&(this.isProjectionDirty=!1),d||(d=Jm()),xE(d,this.relativeTarget)),s&&(this.animationValues=o,function(e,t,n,r,o,i){o?(e.opacity=sy(0,n.opacity??1,_E(r)),e.opacityExit=sy(t.opacity??1,0,AE(r))):i&&(e.opacity=sy(t.opacity??1,n.opacity??1,r));for(let o=0;o<gE;o++){const i=mE[o];let a=bE(t,i),s=bE(n,i);void 0===a&&void 0===s||(a||(a=0),s||(s=0),0===a||0===s||yE(a)===yE(s)?(e[i]=Math.max(sy(vE(a),vE(s),r),0),(xm.test(s)||xm.test(a))&&(e[i]+="%")):e[i]=s)}(t.rotate||n.rotate)&&(e.rotate=sy(t.rotate||0,n.rotate||0,r))}(o,r,this.latestValues,n,u,c)),this.root.scheduleUpdateProjection(),this.scheduleRender(),this.animationProgress=n},this.mixTargetDelta(this.options.layoutRoot?1e3:0)}startAnimation(e){this.notifyListeners("animationStart"),this.currentAnimation?.stop(),this.resumingFrom?.currentAnimation?.stop(),this.pendingAnimation&&(Bg(this.pendingAnimation),this.pendingAnimation=void 0),this.pendingAnimation=Ig.update((()=>{lE.hasAnimatedSinceResize=!0,cv.layout++,this.motionValue||(this.motionValue=Mv(0)),this.motionValue.jump(0,!1),this.currentAnimation=function(e,t,n){const r=Xm(e)?e:Mv(e);return r.start(W_("",r,t,n)),r.animation}(this.motionValue,[0,1e3],{...e,velocity:0,isSync:!0,onUpdate:t=>{this.mixTargetDelta(t),e.onUpdate&&e.onUpdate(t)},onStop:()=>{cv.layout--},onComplete:()=>{cv.layout--,e.onComplete&&e.onComplete(),this.completeAnimation()}}),this.resumingFrom&&(this.resumingFrom.currentAnimation=this.currentAnimation),this.pendingAnimation=void 0}))}completeAnimation(){this.resumingFrom&&(this.resumingFrom.currentAnimation=void 0,this.resumingFrom.preserveOpacity=void 0);const e=this.getStack();e&&e.exitAnimationComplete(),this.resumingFrom=this.currentAnimation=this.animationValues=void 0,this.notifyListeners("animationComplete")}finishAnimation(){this.currentAnimation&&(this.mixTargetDelta&&this.mixTargetDelta(1e3),this.currentAnimation.stop()),this.completeAnimation()}applyTransformsToTarget(){const e=this.getLead();let{targetWithTransforms:t,target:n,layout:r,latestValues:o}=e;if(t&&n&&r){if(this!==e&&this.layout&&r&&mw(this.options.animationType,this.layout.layoutBox,r.layoutBox)){n=this.target||Jm();const t=mA(this.layout.layoutBox.x);n.x.min=e.target.x.min,n.x.max=n.x.min+t;const r=mA(this.layout.layoutBox.y);n.y.min=e.target.y.min,n.y.max=n.y.min+r}xE(t,n),Ty(t,o),vA(this.projectionDeltaWithTransform,this.layoutCorrected,t,o)}}registerSharedNode(e,t){this.sharedNodes.has(e)||this.sharedNodes.set(e,new FE);this.sharedNodes.get(e).add(t);const n=t.options.initialPromotionConfig;t.promote({transition:n?n.transition:void 0,preserveFollowOpacity:n&&n.shouldPreserveFollowOpacity?n.shouldPreserveFollowOpacity(t):void 0})}isLead(){const e=this.getStack();return!e||e.lead===this}getLead(){const{layoutId:e}=this.options;return e&&this.getStack()?.lead||this}getPrevLead(){const{layoutId:e}=this.options;return e?this.getStack()?.prevLead:void 0}getStack(){const{layoutId:e}=this.options;if(e)return this.root.sharedNodes.get(e)}promote({needsReset:e,transition:t,preserveFollowOpacity:n}={}){const r=this.getStack();r&&r.promote(this,n),e&&(this.projectionDelta=void 0,this.needsReset=!0),t&&this.setOptions({transition:t})}relegate(){const e=this.getStack();return!!e&&e.relegate(this)}resetSkewAndRotation(){const{visualElement:e}=this.options;if(!e)return;let t=!1;const{latestValues:n}=e;if((n.z||n.rotate||n.rotateX||n.rotateY||n.rotateZ||n.skewX||n.skewY)&&(t=!0),!t)return;const r={};n.z&&zE("z",e,r,this.animationValues);for(let t=0;t<HE.length;t++)zE(`rotate${HE[t]}`,e,r,this.animationValues),zE(`skew${HE[t]}`,e,r,this.animationValues);e.render();for(const t in r)e.setStaticValue(t,r[t]),this.animationValues&&(this.animationValues[t]=r[t]);e.scheduleRender()}applyProjectionStyles(e,t){if(!this.instance||this.isSVG)return;if(!this.isVisible)return void(e.visibility="hidden");const n=this.getTransformTemplate();if(this.needsReset)return this.needsReset=!1,e.visibility="",e.opacity="",e.pointerEvents=Jy(t?.pointerEvents)||"",void(e.transform=n?n(this.latestValues,""):"none");const r=this.getLead();if(!this.projectionDelta||!this.layout||!r.target)return this.options.layoutId&&(e.opacity=void 0!==this.latestValues.opacity?this.latestValues.opacity:1,e.pointerEvents=Jy(t?.pointerEvents)||""),void(this.hasProjected&&!vy(this.latestValues)&&(e.transform=n?n({},""):"none",this.hasProjected=!1));e.visibility="";const o=r.animationValues||r.latestValues;this.applyTransformsToTarget();let i=function(e,t,n){let r="";const o=e.x.translate/t.x,i=e.y.translate/t.y,a=n?.z||0;if((o||i||a)&&(r=`translate3d(${o}px, ${i}px, ${a}px) `),1===t.x&&1===t.y||(r+=`scale(${1/t.x}, ${1/t.y}) `),n){const{transformPerspective:e,rotate:t,rotateX:o,rotateY:i,skewX:a,skewY:s}=n;e&&(r=`perspective(${e}px) ${r}`),t&&(r+=`rotate(${t}deg) `),o&&(r+=`rotateX(${o}deg) `),i&&(r+=`rotateY(${i}deg) `),a&&(r+=`skewX(${a}deg) `),s&&(r+=`skewY(${s}deg) `)}const s=e.x.scale*t.x,l=e.y.scale*t.y;return 1===s&&1===l||(r+=`scale(${s}, ${l})`),r||"none"}(this.projectionDeltaWithTransform,this.treeScale,o);n&&(i=n(o,i)),e.transform=i;const{x:a,y:s}=this.projectionDelta;e.transformOrigin=`${100*a.origin}% ${100*s.origin}% 0`,r.animationValues?e.opacity=r===this?o.opacity??this.latestValues.opacity??1:this.preserveOpacity?this.latestValues.opacity:o.opacityExit:e.opacity=r===this?void 0!==o.opacity?o.opacity:"":void 0!==o.opacityExit?o.opacityExit:0;for(const t in cy){if(void 0===o[t])continue;const{correct:n,applyTo:a,isCSSVariable:s}=cy[t],l="none"===i?o[t]:n(o[t],r);if(a){const t=a.length;for(let n=0;n<t;n++)e[a[n]]=l}else s?this.options.visualElement.renderState.vars[t]=l:e[t]=l}this.options.layoutId&&(e.pointerEvents=r===this?Jy(t?.pointerEvents)||"":"none")}clearSnapshot(){this.resumeFrom=this.snapshot=void 0}resetTree(){this.root.nodes.forEach((e=>e.currentAnimation?.stop())),this.root.nodes.forEach(JE),this.root.sharedNodes.clear()}}}function GE(e){e.updateLayout()}function QE(e){const t=e.resumeFrom?.snapshot||e.snapshot;if(e.isLead()&&e.layout&&t&&e.hasListeners("didUpdate")){const{layoutBox:n,measuredBox:r}=e.layout,{animationType:o}=e.options,i=t.source!==e.layout.source;if("size"===o)uA((e=>{const r=i?t.measuredBox[e]:t.layoutBox[e],o=mA(r);r.min=n[e].min,r.max=r.min+o}));else if("x"===o||"y"===o){const e="x"===o?"y":"x";wE(i?t.measuredBox[e]:t.layoutBox[e],n[e])}else mw(o,t.layoutBox,n)&&uA((r=>{const o=i?t.measuredBox[r]:t.layoutBox[r],a=mA(n[r]);o.max=o.min+a,e.relativeTarget&&!e.currentAnimation&&(e.isProjectionDirty=!0,e.relativeTarget[r].max=e.relativeTarget[r].min+a)}));const a=Zm();vA(a,n,t.layoutBox);const s=Zm();i?vA(s,e.applyTransform(r,!0),t.measuredBox):vA(s,n,t.layoutBox);const l=!LE(a);let c=!1;if(!e.resumeFrom){const r=e.getClosestProjectingParent();if(r&&!r.resumeFrom){const{snapshot:o,layout:i}=r;if(o&&i){const a=e.options.layoutAnchor||void 0,s=Jm();_A(s,t.layoutBox,o.layoutBox,a);const l=Jm();_A(l,n,i.layoutBox,a),BE(s,l)||(c=!0),r.options.layoutRoot&&(e.relativeTarget=l,e.relativeTargetOrigin=s,e.relativeParent=r)}}}e.notifyListeners("didUpdate",{layout:n,snapshot:t,delta:s,layoutDelta:a,hasLayoutChanged:l,hasRelativeLayoutChanged:c})}else if(e.isLead()){const{onExitComplete:t}=e.options;t&&t()}e.options.transition=void 0}function qE(e){Lg.value&&$E.nodes++,e.parent&&(e.isProjecting()||(e.isProjectionDirty=e.parent.isProjectionDirty),e.isSharedProjectionDirty||(e.isSharedProjectionDirty=Boolean(e.isProjectionDirty||e.parent.isProjectionDirty||e.parent.isSharedProjectionDirty)),e.isTransformDirty||(e.isTransformDirty=e.parent.isTransformDirty))}function KE(e){e.isProjectionDirty=e.isSharedProjectionDirty=e.isTransformDirty=!1}function ZE(e){e.clearSnapshot()}function JE(e){e.clearMeasurements()}function XE(e){e.isLayoutDirty=!0,e.updateLayout()}function ew(e){e.isLayoutDirty=!1}function tw(e){e.isAnimationBlocked&&e.layout&&!e.isLayoutDirty&&(e.snapshot=e.layout,e.isLayoutDirty=!0)}function nw(e){const{visualElement:t}=e.options;t&&t.getProps().onBeforeLayoutMeasure&&t.notify("BeforeLayoutMeasure"),e.resetTransform()}function rw(e){e.finishAnimation(),e.targetDelta=e.relativeTarget=e.target=void 0,e.isProjectionDirty=!0}function ow(e){e.resolveTargetDelta()}function iw(e){e.calcProjection()}function aw(e){e.resetSkewAndRotation()}function sw(e){e.removeLeadSnapshot()}function lw(e,t,n){e.translate=sy(t.translate,0,n),e.scale=sy(t.scale,1,n),e.origin=t.origin,e.originPoint=t.originPoint}function cw(e,t,n,r){e.min=sy(t.min,n.min,r),e.max=sy(t.max,n.max,r)}function uw(e){return e.animationValues&&void 0!==e.animationValues.opacityExit}const dw={duration:.45,ease:[.4,0,.1,1]},pw=e=>"undefined"!=typeof navigator&&navigator.userAgent&&navigator.userAgent.toLowerCase().includes(e),fw=pw("applewebkit/")&&!pw("chrome/")?Math.round:Tg;function hw(e){e.min=fw(e.min),e.max=fw(e.max)}function mw(e,t,n){return"position"===e||"preserve-aspect"===e&&(r=RE(t),o=RE(n),i=.2,!(Math.abs(r-o)<=i));var r,o,i}function gw(e){return e!==e.root&&e.scroll?.wasRoot}const vw=VE({attachResizeListener:(e,t)=>wA(e,"resize",t),measureScroll:()=>({x:document.documentElement.scrollLeft||document.body?.scrollLeft||0,y:document.documentElement.scrollTop||document.body?.scrollTop||0}),checkIsScrollRoot:()=>!0}),yw={current:void 0},bw=VE({measureScroll:e=>({x:e.scrollLeft,y:e.scrollTop}),defaultParent:()=>{if(!yw.current){const e=new vw({});e.mount(window),e.setOptions({layoutScroll:!0}),yw.current=e}return yw.current},resetTransform:(e,t)=>{e.style.transform=void 0!==t?t:"none"},checkIsScrollRoot:e=>Boolean("fixed"===window.getComputedStyle(e).position)}),_w={pan:{Feature:class extends bb{constructor(){super(...arguments),this.removePointerDownListener=Tg}onPointerDown(e){this.session=new WA(e,this.createPanHandlers(),{transformPagePoint:this.node.getTransformPagePoint(),contextWindow:HA(this.node)})}createPanHandlers(){const{onPanSessionStart:e,onPanStart:t,onPan:n,onPanEnd:r}=this.node.getProps();return{onSessionStart:sE(e),onStart:sE(t),onMove:sE(n),onEnd:(e,t)=>{delete this.session,r&&Ig.postRender((()=>r(e,t)))}}}mount(){this.removePointerDownListener=$A(this.node.current,"pointerdown",(e=>this.onPointerDown(e)))}update(){this.session&&this.session.updateHandlers(this.createPanHandlers())}unmount(){this.removePointerDownListener(),this.session&&this.session.end()}}},drag:{Feature:class extends bb{constructor(e){super(e),this.removeGroupControls=Tg,this.removeListeners=Tg,this.controls=new oE(e)}mount(){const{dragControls:e}=this.node.getProps();e&&(this.removeGroupControls=e.subscribe(this.controls)),this.removeListeners=this.controls.addListeners()||Tg}update(){const{dragControls:e}=this.node.getProps(),{dragControls:t}=this.node.prevProps||{};e!==t&&(this.removeGroupControls(),e&&(this.removeGroupControls=e.subscribe(this.controls)))}unmount(){this.removeGroupControls(),this.removeListeners(),this.controls.isDragging||this.controls.endPanSession()}},ProjectionNode:bw,MeasureLayout:fE}};function Aw(e,t){const n=CA(e),r=new AbortController;return[n,{passive:!0,...t,signal:r.signal},()=>r.abort()]}function Ew(e,t,n={}){const[r,o,i]=Aw(e,n);return r.forEach((e=>{let n,r=!1,i=!1;const a=t=>{n&&(n(t),n=void 0),e.removeEventListener("pointerleave",l)},s=e=>{r=!1,window.removeEventListener("pointerup",s),window.removeEventListener("pointercancel",s),i&&(i=!1,a(e))},l=e=>{"touch"!==e.pointerType&&(r?i=!0:a(e))};e.addEventListener("pointerenter",(r=>{if("touch"===r.pointerType||cA())return;i=!1;const a=t(e,r);"function"==typeof a&&(n=a,e.addEventListener("pointerleave",l,o))}),o),e.addEventListener("pointerdown",(()=>{r=!0,window.addEventListener("pointerup",s,o),window.addEventListener("pointercancel",s,o)}),o)})),i}function ww(e,t,n){const{props:r}=e;e.animationState&&r.whileHover&&e.animationState.setActive("whileHover","Start"===n);const o=r["onHover"+n];o&&Ig.postRender((()=>o(t,YA(t))))}function xw(e){return xA(e)&&"offsetHeight"in e&&!("ownerSVGElement"in e)}const kw=(e,t)=>!!t&&(e===t||kw(e,t.parentElement)),Cw=new WeakSet;function Sw(e){return t=>{"Enter"===t.key&&e(t)}}function Mw(e,t){e.dispatchEvent(new PointerEvent("pointer"+t,{isPrimary:!0,bubbles:!0}))}function Tw(e){return jA(e)&&!cA()}const Ow=new WeakSet;function Dw(e,t,n={}){const[r,o,i]=Aw(e,n),a=e=>{const r=e.currentTarget;if(!Tw(e))return;if(Ow.has(e))return;Cw.add(r),n.stopPropagation&&Ow.add(e);const i=t(r,e),a=(e,t)=>{window.removeEventListener("pointerup",s),window.removeEventListener("pointercancel",l),Cw.has(r)&&Cw.delete(r),Tw(e)&&"function"==typeof i&&i(e,{success:t})},s=e=>{a(e,r===window||r===document||n.useGlobalTarget||kw(r,e.target))},l=e=>{a(e,!1)};window.addEventListener("pointerup",s,o),window.addEventListener("pointercancel",l,o)};return r.forEach((e=>{var t;(n.useGlobalTarget?window:e).addEventListener("pointerdown",a,o),xw(e)&&(e.addEventListener("focus",(e=>((e,t)=>{const n=e.currentTarget;if(!n)return;const r=Sw((()=>{if(Cw.has(n))return;Mw(n,"down");const e=Sw((()=>{Mw(n,"up")}));n.addEventListener("keyup",e,t),n.addEventListener("blur",(()=>Mw(n,"cancel")),t)}));n.addEventListener("keydown",r,t),n.addEventListener("blur",(()=>n.removeEventListener("keydown",r)),t)})(e,o))),t=e,AA.has(t.tagName)||!0===t.isContentEditable||e.hasAttribute("tabindex")||(e.tabIndex=0))})),i}function Lw(e,t,n){const{props:r}=e;if(e.current instanceof HTMLButtonElement&&e.current.disabled)return;e.animationState&&r.whileTap&&e.animationState.setActive("whileTap","Start"===n);const o=r["onTap"+("End"===n?"":n)];o&&Ig.postRender((()=>o(t,YA(t))))}const Pw=new WeakMap,Iw=new WeakMap,Bw=e=>{const t=Pw.get(e.target);t&&t(e)},Rw=e=>{e.forEach(Bw)};function Nw(e,t,n){const r=function({root:e,...t}){const n=e||document;Iw.has(n)||Iw.set(n,{});const r=Iw.get(n),o=JSON.stringify(t);return r[o]||(r[o]=new IntersectionObserver(Rw,{root:e,...t})),r[o]}(t);return Pw.set(e,n),r.observe(e),()=>{Pw.delete(e),r.unobserve(e)}}const Fw={some:0,all:1};const jw={inView:{Feature:class extends bb{constructor(){super(...arguments),this.hasEnteredView=!1,this.isInView=!1}startObserver(){this.stopObserver?.();const{viewport:e={}}=this.node.getProps(),{root:t,margin:n,amount:r="some",once:o}=e,i={root:t?t.current:void 0,rootMargin:n,threshold:"number"==typeof r?r:Fw[r]};this.stopObserver=Nw(this.node.current,i,(e=>{const{isIntersecting:t}=e;if(this.isInView===t)return;if(this.isInView=t,o&&!t&&this.hasEnteredView)return;t&&(this.hasEnteredView=!0),this.node.animationState&&this.node.animationState.setActive("whileInView",t);const{onViewportEnter:n,onViewportLeave:r}=this.node.getProps(),i=t?n:r;i&&i(e)}))}mount(){this.startObserver()}update(){if("undefined"==typeof IntersectionObserver)return;const{props:e,prevProps:t}=this.node,n=["amount","margin","root"].some(function({viewport:e={}},{viewport:t={}}={}){return n=>e[n]!==t[n]}(e,t));n&&this.startObserver()}unmount(){this.stopObserver?.(),this.hasEnteredView=!1,this.isInView=!1}}},tap:{Feature:class extends bb{mount(){const{current:e}=this.node;if(!e)return;const{globalTapTarget:t,propagate:n}=this.node.props;this.unmount=Dw(e,((e,t)=>(Lw(this.node,t,"Start"),(e,{success:t})=>Lw(this.node,e,t?"End":"Cancel"))),{useGlobalTarget:t,stopPropagation:!1===n?.tap})}unmount(){}}},focus:{Feature:class extends bb{constructor(){super(...arguments),this.isActive=!1}onFocus(){let e=!1;try{e=this.node.current.matches(":focus-visible")}catch(t){e=!0}e&&this.node.animationState&&(this.node.animationState.setActive("whileFocus",!0),this.isActive=!0)}onBlur(){this.isActive&&this.node.animationState&&(this.node.animationState.setActive("whileFocus",!1),this.isActive=!1)}mount(){this.unmount=Tb(wA(this.node.current,"focus",(()=>this.onFocus())),wA(this.node.current,"blur",(()=>this.onBlur())))}unmount(){}}},hover:{Feature:class extends bb{mount(){const{current:e}=this.node;e&&(this.unmount=Ew(e,((e,t)=>(ww(this.node,t,"Start"),e=>ww(this.node,e,"End")))))}unmount(){}}}},Yw=yb({...sA,...jw,..._w,...{layout:{ProjectionNode:bw,MeasureLayout:fE}}},Iy);function $w(e,t){if("function"==typeof e)return e(t);null!=e&&(e.current=t)}function Hw(...e){return i.useCallback(function(...e){return t=>{let n=!1;const r=e.map((e=>{const r=$w(e,t);return n||"function"!=typeof r||(n=!0),r}));if(n)return()=>{for(let t=0;t<r.length;t++){const n=r[t];"function"==typeof n?n():$w(e[t],null)}}}}(...e),e)}class Uw extends i.Component{getSnapshotBeforeUpdate(e){const t=this.props.childRef.current;if(xw(t)&&e.isPresent&&!this.props.isPresent&&!1!==this.props.pop){const e=t.offsetParent,n=xw(e)&&e.offsetWidth||0,r=xw(e)&&e.offsetHeight||0,o=getComputedStyle(t),i=this.props.sizeRef.current;i.height=parseFloat(o.height),i.width=parseFloat(o.width),i.top=t.offsetTop,i.left=t.offsetLeft,i.right=n-i.width-i.left,i.bottom=r-i.height-i.top}return null}componentDidUpdate(){}render(){return this.props.children}}function zw({children:e,isPresent:t,anchorX:n,anchorY:r,root:o,pop:a}){const s=(0,i.useId)(),l=(0,i.useRef)(null),c=(0,i.useRef)({width:0,height:0,top:0,left:0,right:0,bottom:0}),{nonce:u}=(0,i.useContext)(Ny),d=e.props?.ref??e?.ref,p=Hw(l,d);return(0,i.useInsertionEffect)((()=>{const{width:e,height:i,top:d,left:p,right:f,bottom:h}=c.current;if(t||!1===a||!l.current||!e||!i)return;const m="left"===n?`left: ${p}`:`right: ${f}`,g="bottom"===r?`bottom: ${h}`:`top: ${d}`;l.current.dataset.motionPopId=s;const v=document.createElement("style");u&&(v.nonce=u);const y=o??document.head;return y.appendChild(v),v.sheet&&v.sheet.insertRule(`\n          [data-motion-pop-id="${s}"] {\n            position: absolute !important;\n            width: ${e}px !important;\n            height: ${i}px !important;\n            ${m}px !important;\n            ${g}px !important;\n          }\n        `),()=>{l.current?.removeAttribute("data-motion-pop-id"),y.contains(v)&&y.removeChild(v)}}),[t]),(0,br.jsx)(Uw,{isPresent:t,childRef:l,sizeRef:c,pop:a,children:!1===a?e:i.cloneElement(e,{ref:p})})}const Ww=({children:e,initial:t,isPresent:n,onExitComplete:r,custom:o,presenceAffectsLayout:a,mode:s,anchorX:l,anchorY:c,root:u})=>{const d=eb(Vw),p=(0,i.useId)();let f=!0,h=(0,i.useMemo)((()=>(f=!1,{id:p,initial:t,isPresent:n,custom:o,onExitComplete:e=>{d.set(e,!0);for(const e of d.values())if(!e)return;r&&r()},register:e=>(d.set(e,!1),()=>d.delete(e))})),[n,d,r]);return a&&f&&(h={...h}),(0,i.useMemo)((()=>{d.forEach(((e,t)=>d.set(t,!1)))}),[n]),i.useEffect((()=>{!n&&!d.size&&r&&r()}),[n]),e=(0,br.jsx)(zw,{pop:"popLayout"===s,isPresent:n,anchorX:l,anchorY:c,root:u,children:e}),(0,br.jsx)(Xy.Provider,{value:h,children:e})};function Vw(){return new Map}const Gw=e=>e.key||"";function Qw(e){const t=[];return i.Children.forEach(e,(e=>{(0,i.isValidElement)(e)&&t.push(e)})),t}const qw=({children:e,custom:t,initial:n=!0,onExitComplete:r,presenceAffectsLayout:o=!0,mode:a="sync",propagate:s=!1,anchorX:l="left",anchorY:c="top",root:u})=>{const[d,p]=cE(s),f=(0,i.useMemo)((()=>Qw(e)),[e]),h=s&&!d?[]:f.map(Gw),m=(0,i.useRef)(!0),g=(0,i.useRef)(f),v=eb((()=>new Map)),y=(0,i.useRef)(new Set),[b,_]=(0,i.useState)(f),[A,E]=(0,i.useState)(f);fb((()=>{m.current=!1,g.current=f;for(let e=0;e<A.length;e++){const t=Gw(A[e]);h.includes(t)?(v.delete(t),y.current.delete(t)):!0!==v.get(t)&&v.set(t,!1)}}),[A,h.length,h.join("-")]);const w=[];if(f!==b){let e=[...f];for(let t=0;t<A.length;t++){const n=A[t],r=Gw(n);h.includes(r)||(e.splice(t,0,n),w.push(n))}return"wait"===a&&w.length&&(e=w),E(Qw(e)),_(f),null}const{forceRender:x}=(0,i.useContext)(By);return(0,br.jsx)(br.Fragment,{children:A.map((e=>{const i=Gw(e),b=!(s&&!d)&&(f===A||h.includes(i));return(0,br.jsx)(Ww,{isPresent:b,initial:!(m.current&&!n)&&void 0,custom:t,presenceAffectsLayout:o,mode:a,root:u,onExitComplete:b?void 0:()=>{if(y.current.has(i))return;if(!v.has(i))return;y.current.add(i),v.set(i,!0);let e=!0;v.forEach((t=>{t||(e=!1)})),e&&(x?.(),E(g.current),s&&p?.(),r&&r())},anchorX:l,anchorY:c,children:e},i)}))})};var Kw=vr(Yw.div),Zw=yr(((e,t)=>{var n,r;const o=Fr("Tooltip",e),a=pt(e),s=Lr(),{children:l,label:c,shouldWrapChildren:u,"aria-label":d,hasArrow:p,bg:f,portalProps:h,background:m,backgroundColor:g,bgColor:v,motionProps:y,...b}=a,_=null!=(r=null!=(n=null!=m?m:g)?n:f)?r:v;if(_){o.bg=_;const e=function(e,t,n){var r,o,i;return null!=(i=null==(o=null==(r=e.__cssMap)?void 0:r[`${t}.${n}`])?void 0:o.varRef)?i:n}(s,"colors",_);o[lf.arrowBg.var]=e}const A=qh({...b,direction:s.direction});let E;if("string"==typeof l||u)E=(0,br.jsx)(vr.span,{display:"inline-block",tabIndex:0,...A.getTriggerProps(),children:l});else{const e=i.Children.only(l);E=(0,i.cloneElement)(e,A.getTriggerProps(e.props,e.ref))}const w=!!d,x=A.getTooltipProps({},t),k=w?function(e,t=[]){const n=Object.assign({},e);for(const e of t)e in n&&delete n[e];return n}(x,["role","id"]):x,C=function(e,t){const n={};for(const r of t)r in e&&(n[r]=e[r]);return n}(x,["role","id"]);return c?(0,br.jsxs)(br.Fragment,{children:[E,(0,br.jsx)(qw,{children:A.isOpen&&(0,br.jsx)(sm,{...h,children:(0,br.jsx)(vr.div,{...A.getTooltipPositionerProps(),__css:{zIndex:o.zIndex,pointerEvents:"none"},children:(0,br.jsxs)(Kw,{variants:tf,initial:"exit",animate:"enter",exit:"exit",...y,...k,__css:o,children:[c,w&&(0,br.jsx)(vr.span,{srOnly:!0,...C,children:d}),p&&(0,br.jsx)(vr.div,{"data-popper-arrow":!0,className:"chakra-tooltip__arrow-wrapper",children:(0,br.jsx)(vr.div,{"data-popper-arrow-inner":!0,className:"chakra-tooltip__arrow",__css:{bg:o.bg}})})]})})})})]}):(0,br.jsx)(br.Fragment,{children:l})}));Zw.displayName="Tooltip";var Jw=["children","placement","shouldWrapChildren","tooltipLabel"],Xw=["placement","tooltipLabel"];function ex(){return ex=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},ex.apply(null,arguments)}function tx(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}var nx=e=>{var{children:t,placement:n="top",shouldWrapChildren:r=!1,tooltipLabel:o}=e,a=tx(e,Jw),s=qd(),{arrowShadowColor:l,color:c,shadowColor:u}=s.components.Tooltip.baseStyle({}),d={bg:"white",boxShadow:"0px 0 5px "+u,borderRadius:"3px",color:c,fontSize:""+s.fontSizes.md,fontWeight:""+s.fontWeights.normal,maxW:"300px",padding:"13px 16px"},p="string"==typeof o?o:"";return Mr(i.Fragment,null,o?Mr(Zw,ex({"aria-label":p,"data-testid":"sp-ui-tooltip",arrowShadowColor:l,hasArrow:!0,label:o,placement:n,shouldWrapChildren:r},d,a),t):Mr(i.Fragment,null,t))};const rx=nx;function ox(){return ox=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},ox.apply(null,arguments)}var ix=function(e){return Mr("svg",e,Mr("circle",{cx:"6.5",cy:"6.5",r:"6",stroke:"currentColor"}),Mr("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M6 6h1v1.8h.5V9h-2V7.8H6V6.6h-.5V5.5H7V6zm0-3h1v1.2H6V6z",fill:"currentColor"}))};ix.defaultProps={height:"24",width:"24",viewBox:"0 0 13 13",fill:"none",xmlns:"http://www.w3.org/2000/svg"};var ax=pr(ix,{target:"e14omeq80"})((e=>{var{theme:t}=e;return"\n        color: "+t.components.InfoIcon.baseStyle.color+";\n        height: 20px;\n        width: 20px;\n    "}),""),sx=function(e,t){return void 0===t&&(t=!1),n=>{var{placement:r,tooltipLabel:o}=n,i=tx(n,Xw),a=Mr(e,i);return Mr(nx,{placement:r,shouldWrapChildren:t,tooltipLabel:o},a)}}((e=>Mr(ax,ox({"data-testid":"sp-ui-info-icon"},e))),!0);const lx=sx;var cx=["children"];function ux(){return ux=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},ux.apply(null,arguments)}var dx=pr(qr,{target:"etx65yp0"})((e=>{var{theme:t}=e;return"\n        color: "+t.fontColor.default+";\n        font-size: "+t.fontSizes.md+";\n        font-weight: "+t.fontWeights.normal+";\n        line-height: "+t.lineHeights.md+";\n    "}),""),px=yr(((e,t)=>{var{children:n}=e,r=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,cx);return Mr(dx,ux({as:"span"},r,{ref:t}),n)}));const fx=px;var hx=["children","tooltipLabel"],mx=["children"],gx=["children"];function vx(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}var yx=pr(Xp,{target:"e1z2cn32"})((e=>{var{theme:{components:{Label:{baseStyle:t}},fonts:n}}=e;return"\n        color: "+t.color+";\n        display: inline-block;\n        font-family: "+n.body+";\n        font-size: "+t.fontSize+";\n        font-weight: "+t.fontWeight+";\n        line-height: "+t.lineHeight+";\n        margin-bottom: "+t.marginBottom+";\n        padding: 0;\n        white-space: nowrap;\n\n        svg {\n            display: inline;\n            height: 12px;\n            margin-top: -1px;\n            width: 12px;\n        }\n    "}),""),bx=e=>{var{children:t}=e,n=vx(e,mx);return Mr(_x,n,t)},_x=pr(fx,{target:"e1z2cn31"})((e=>{var{theme:{components:{LabelSubtext:{baseStyle:t}},fonts:n}}=e;return"\n        color: "+t.color+";\n        display: block;\n        font-family: "+n.body+";\n        line-height: "+t.lineHeight+";\n    "}),""),Ax=e=>{var{children:t}=e,n=vx(e,gx);return Mr(Ex,n,t)},Ex=pr(Xp,{target:"e1z2cn30"})((e=>{var{theme:{components:{LabelError:{baseStyle:t}},fonts:n}}=e;return"\n        color: "+t.color+";\n        display: block;\n        font-family: "+n.body+";\n        font-size: "+t.fontSize+";\n        font-weight: "+t.fontWeight+";\n    "}),"");const wx=e=>{var{children:t,tooltipLabel:n}=e,r=vx(e,hx);return Mr(yx,r,t,n&&Mr(i.Fragment,null," ",Mr(lx,{tooltipLabel:n})))};var xx=["children","isDisabled"];function kx(){return kx=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},kx.apply(null,arguments)}var Cx=pr(Kr,{target:"emu0z200"})((e=>{var{theme:t}=e;return"\n        color: "+t.colors.blue[400]+";\n        font-size: "+t.fontSizes.md+";\n        font-weight: "+t.fontWeights.medium+";\n        line-height: "+t.lineHeights.md+";\n        transition: all 0.2s ease;\n\n        &:hover {\n            color: "+t.colors.blue[300]+";\n            cursor: pointer;\n            text-decoration: none;\n        }\n\n        &[disabled] {\n            opacity: 0.5;\n            pointer-events: none;\n        }\n    "}),"");const Sx=e=>{var{children:t,isDisabled:n=!1}=e,r=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,xx);return Mr(Cx,kx({disabled:n?"disabled":void 0},r),t)};var Mx=["children","maxLineCount"];var Tx=pr(_r,{target:"e1ukig910"})({name:"pn36cr",styles:"-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden;word-break:break-word"});const Ox=e=>{var{children:t,maxLineCount:n}=e,r=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,Mx),o=(0,i.useCallback)((()=>{var{current:e}=d;if(e){var{clientHeight:t,scrollHeight:n}=e;s(n>t)}}),[]),[a,s]=(0,i.useState)(!1),[l,c]=(0,i.useState)(!1),u=n&&!l?{WebkitLineClamp:n}:{},d=(0,i.useRef)(null);return(0,i.useEffect)((()=>(window.addEventListener("resize",o),()=>window.removeEventListener("resize",o))),[o,n]),(0,i.useLayoutEffect)((()=>{o()}),[o,t]),Mr(_r,r,n?Mr(i.Fragment,null,Mr(Tx,{as:"span",ref:d,style:u},t),a&&Mr(Eo,null,(e=>{var{translate:t}=e;return Mr(Sx,{onClick:()=>c(!l)},t(l?"spUi.common.text.p.showLess":"spUi.common.text.p.showMore"))}))):t)};var Dx=["children","maxLineCount"];var Lx=pr(qr,{target:"e1d7mcsi0"})((e=>{var{theme:t}=e;return"\n        color: "+t.fontColor.default+";\n        font-family: "+t.fonts.body+";\n        font-size: "+t.fontSizes.md+";\n        font-weight: "+t.fontWeights.normal+";\n        line-height: "+t.lineHeights.md+";\n        margin-bottom: "+t.space[4]+";\n    "}),"");const Px=e=>{var{children:t,maxLineCount:n}=e,r=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,Dx);return Mr(Ox,{maxLineCount:n},Mr(Lx,r,t))};function Ix(){return Ix=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Ix.apply(null,arguments)}var Bx=function(e){return e.Bordered="border",e.Default="default",e}({}),Rx=pr(Qp,{target:"esg30rq3"})((e=>{var{theme:t}=e,{customStyle:n}=t.components.RadioGroup;return"\n        background-color: white !important;\n        border: 1px solid;\n        border-color: "+n.input.borderColor+" !important;\n        border-radius: 100%;\n        box-shadow: none !important;\n        cursor: pointer;\n        color: "+n.input.color+" !important;\n\n        &[data-checked]::before {\n            color: "+n.input.color+";\n            height: 8px;\n            width: 8px;\n        }\n\n        + span {\n            align-items: center;\n            color: "+t.components.Label.baseStyle.color+";\n            cursor: pointer;\n            display: flex;\n            margin-left: 12px;\n\n            > span {\n                margin-left: 6px;\n\n                svg {\n                    height: 13px;\n                    width: 13px;\n                }\n            }\n        }\n    "}),""),Nx=pr(_r,{target:"esg30rq2"})({name:"13feash",styles:"padding-left:28px"}),Fx=pr(bx,{target:"esg30rq1"})({name:"u943i3",styles:"margin-bottom:11px"}),jx=pr(Px,{target:"esg30rq0"})((e=>{var{theme:t}=e,{customStyle:n}=t.components.RadioGroup;return"\n        color: "+n.content.color+";\n    "}),"");const Yx=e=>{var{name:t,onChange:n,radioOptions:r,value:o,variant:a=Bx.Default}=e,{components:s}=qd(),{RadioGroup:l}=s,{spacing:c}=l.customStyle,{[a]:u}=l.variants,d=e=>{var{target:t}=e,{value:o}=t,i=r.find((e=>{var{value:t}=e;return t===o}));e.stopPropagation(),f(o),n&&n(e,i)},[p,f]=(0,i.useState)(r[0].value);return(0,i.useEffect)((()=>{o&&f(o)}),[o]),Mr(Jp,{"data-testid":"sp-ui-radio-group",spacing:c},r.map(((e,n)=>{var{contentWhenSelected:r,description:o,helperText:i,infoTooltip:a,isDisabled:s,value:l}=e,c=l===p,{radio:f}=u,h=Object.assign({},f,c?f[tp.Checked]:{});return delete h.checked,Mr(_r,Ix({key:n},h,{as:"label"}),Mr(Rx,{"data-testid":"sp-ui-radio-option-"+t+"-"+n,isChecked:c,isDisabled:Boolean(s),name:t,onChange:d,value:l},o,a&&Mr(lx,{tooltipLabel:a})),Mr(Nx,null,i&&Mr(Fx,null,i),c&&("string"==typeof r?Mr(jx,null,r):r)))})))};var $x,Hx=["tooltipPlacement","statusPillText","tooltipLabel","variant"];function Ux(){return Ux=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Ux.apply(null,arguments)}var zx=function(e){return e.Danger="danger",e.Neutral="neutral",e.Success="success",e.Warning="warning",e}({}),Wx=pr(_r,{target:"e18j13hh0"})((e=>{var{theme:t,variant:n}=e,{[n]:r}=t.components.StatusPill.variants,{backgroundColor:o,color:i}=r;return"\n        background-color: "+o+";\n        border-radius: 20px;\n        color: "+i+";\n        display: inline-block;\n        font-size: "+t.fontSizes.sm+";\n        padding: 3px 12px 3px 12px;\n        text-align: center;\n        white-space: nowrap;\n\n        "+t.responsive.smallScreenOnly($x||($x=function(e,t){return t||(t=e.slice(0)),e.raw=t,e}(["\n            padding: 1px 12px 1px 12px;\n        "])))+"\n    "}),"");const Vx=e=>{var{tooltipPlacement:t,statusPillText:n,tooltipLabel:r,variant:o=zx.Neutral}=e,i=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,Hx);return Mr(rx,{placement:t,tooltipLabel:r},Mr(Wx,Ux({variant:o},i,{"data-testid":"sp-ui-status-pill"}),n))};function Gx(e){const{isDisabled:t,isInvalid:n,isReadOnly:r,isRequired:o,...i}=Qx(e);return{...i,disabled:t,readOnly:r,required:o,"aria-invalid":E(n),"aria-required":E(o),"aria-readonly":E(r)}}function Qx(e){var t,n,r;const o=Sp(),{id:i,disabled:a,readOnly:s,required:l,isRequired:c,isInvalid:u,isReadOnly:d,isDisabled:p,onFocus:f,onBlur:h,...m}=e,g=e["aria-describedby"]?[e["aria-describedby"]]:[];return(null==o?void 0:o.hasFeedbackText)&&(null==o?void 0:o.isInvalid)&&g.push(o.feedbackId),(null==o?void 0:o.hasHelpText)&&g.push(o.helpTextId),{...m,"aria-describedby":g.join(" ")||void 0,id:null!=i?i:null==o?void 0:o.id,isDisabled:null!=(t=null!=a?a:p)?t:null==o?void 0:o.isDisabled,isReadOnly:null!=(n=null!=s?s:d)?n:null==o?void 0:o.isReadOnly,isRequired:null!=(r=null!=l?l:c)?r:null==o?void 0:o.isRequired,isInvalid:null!=u?u:null==o?void 0:o.isInvalid,onFocus:w(null==o?void 0:o.onFocus,f),onBlur:w(null==o?void 0:o.onBlur,h)}}function qx(e,t){const n=(0,i.useRef)(!1),r=(0,i.useRef)(!1);(0,i.useEffect)((()=>{if(n.current&&r.current)return e();r.current=!0}),t),(0,i.useEffect)((()=>(n.current=!0,()=>{n.current=!1})),[])}var Kx={border:"0",clip:"rect(0, 0, 0, 0)",height:"1px",width:"1px",margin:"-1px",padding:"0",overflow:"hidden",whiteSpace:"nowrap",position:"absolute"};function Zx(e={}){const t=Qx(e),{isDisabled:n,isReadOnly:r,isRequired:o,isInvalid:a,id:s,onBlur:l,onFocus:c,"aria-describedby":u}=t,{defaultChecked:d,isChecked:p,isFocusable:f,onChange:h,isIndeterminate:m,name:g,value:v,tabIndex:y,"aria-label":b,"aria-labelledby":_,"aria-invalid":E,...x}=e,k=function(e,t=[]){const n=Object.assign({},e);for(const e of t)e in n&&delete n[e];return n}(x,["isDisabled","isReadOnly","isRequired","isInvalid","id","onBlur","onFocus","aria-describedby"]),C=zh(h),S=zh(l),M=zh(c),[T,O]=(0,i.useState)(!1),[D,L]=(0,i.useState)(!1),[P,I]=(0,i.useState)(!1),[B,R]=(0,i.useState)(!1);(0,i.useEffect)((()=>Wp(O)),[]);const N=(0,i.useRef)(null),[F,j]=(0,i.useState)(!0),[Y,$]=(0,i.useState)(!!d),H=void 0!==p,U=H?p:Y,z=(0,i.useCallback)((e=>{r||n?e.preventDefault():(H||$(U?e.target.checked:!!m||e.target.checked),null==C||C(e))}),[r,n,U,H,m,C]);em((()=>{N.current&&(N.current.indeterminate=Boolean(m))}),[m]),qx((()=>{n&&L(!1)}),[n,L]),em((()=>{const e=N.current;if(!(null==e?void 0:e.form))return;const t=()=>{$(!!d)};return e.form.addEventListener("reset",t),()=>{var n;return null==(n=e.form)?void 0:n.removeEventListener("reset",t)}}),[]);const W=n&&!f,V=(0,i.useCallback)((e=>{" "===e.key&&R(!0)}),[R]),G=(0,i.useCallback)((e=>{" "===e.key&&R(!1)}),[R]);em((()=>{if(!N.current)return;N.current.checked!==U&&$(N.current.checked)}),[N.current]);const Q=(0,i.useCallback)(((e={},t=null)=>({...e,ref:t,"data-active":A(B),"data-hover":A(P),"data-checked":A(U),"data-focus":A(D),"data-focus-visible":A(D&&T),"data-indeterminate":A(m),"data-disabled":A(n),"data-invalid":A(a),"data-readonly":A(r),"aria-hidden":!0,onMouseDown:w(e.onMouseDown,(e=>{D&&e.preventDefault(),R(!0)})),onMouseUp:w(e.onMouseUp,(()=>R(!1))),onMouseEnter:w(e.onMouseEnter,(()=>I(!0))),onMouseLeave:w(e.onMouseLeave,(()=>I(!1)))})),[B,U,n,D,T,P,m,a,r]),q=(0,i.useCallback)(((e={},t=null)=>({...e,ref:t,"data-active":A(B),"data-hover":A(P),"data-checked":A(U),"data-focus":A(D),"data-focus-visible":A(D&&T),"data-indeterminate":A(m),"data-disabled":A(n),"data-invalid":A(a),"data-readonly":A(r)})),[B,U,n,D,T,P,m,a,r]),K=(0,i.useCallback)(((e={},t=null)=>({...k,...e,ref:Ur(t,(e=>{e&&j("LABEL"===e.tagName)})),onClick:w(e.onClick,(()=>{var e;F||(null==(e=N.current)||e.click(),requestAnimationFrame((()=>{var e;null==(e=N.current)||e.focus({preventScroll:!0})})))})),"data-disabled":A(n),"data-checked":A(U),"data-invalid":A(a)})),[k,n,U,a,F]),Z=(0,i.useCallback)(((e={},t=null)=>({...e,ref:Ur(N,t),type:"checkbox",name:g,value:v,id:s,tabIndex:y,onChange:w(e.onChange,z),onBlur:w(e.onBlur,S,(()=>L(!1))),onFocus:w(e.onFocus,M,(()=>L(!0))),onKeyDown:w(e.onKeyDown,V),onKeyUp:w(e.onKeyUp,G),required:o,checked:U,disabled:W,readOnly:r,"aria-label":b,"aria-labelledby":_,"aria-invalid":E?Boolean(E):a,"aria-describedby":u,"aria-disabled":n,style:Kx})),[g,v,s,z,S,M,V,G,o,U,W,r,b,_,E,a,u,n,y]),J=(0,i.useCallback)(((e={},t=null)=>({...e,ref:t,onMouseDown:w(e.onMouseDown,Jx),"data-disabled":A(n),"data-checked":A(U),"data-invalid":A(a)})),[U,n,a]);return{state:{isInvalid:a,isFocused:D,isChecked:U,isActive:B,isHovered:P,isIndeterminate:m,isDisabled:n,isReadOnly:r,isRequired:o},getRootProps:K,getCheckboxProps:Q,getIndicatorProps:q,getInputProps:Z,getLabelProps:J,htmlProps:k}}function Jx(e){e.preventDefault(),e.stopPropagation()}var Xx=yr((function(e,t){const n=jr("Switch",e),{spacing:r="0.5rem",children:o,...a}=pt(e),{getIndicatorProps:s,getInputProps:l,getCheckboxProps:c,getRootProps:u,getLabelProps:d}=Zx(a),p=(0,i.useMemo)((()=>({display:"inline-block",position:"relative",verticalAlign:"middle",lineHeight:0,...n.container})),[n.container]),f=(0,i.useMemo)((()=>({display:"inline-flex",flexShrink:0,justifyContent:"flex-start",boxSizing:"content-box",cursor:"pointer",...n.track})),[n.track]),h=(0,i.useMemo)((()=>({userSelect:"none",marginStart:r,...n.label})),[r,n.label]);return(0,br.jsxs)(vr.label,{...u(),className:g("chakra-switch",e.className),__css:p,children:[(0,br.jsx)("input",{className:"chakra-switch__input",...l({},t)}),(0,br.jsx)(vr.span,{...c(),className:"chakra-switch__track",__css:f,children:(0,br.jsx)(vr.span,{__css:n.thumb,className:"chakra-switch__thumb",...s()})}),o&&(0,br.jsx)(vr.span,{className:"chakra-switch__label",...d(),__css:h,children:o})]})}));Xx.displayName="Switch";var ek=["defaultIsToggled","isDisabled","isToggled","label","name","onBlur","onChange","onFocus","subtext","value","variant"];function tk(){return tk=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},tk.apply(null,arguments)}var nk=function(e){return e.Large="large",e}({}),rk=pr(Xx,{target:"e1pi340z2"})((e=>{var{theme:t,variant:n}=e,{baseStyle:r,variants:o}=t.components.ToggleSwitch;return"\n        margin-right: 8px;\n        margin-top: 2px;\n\n        div[aria-hidden] {\n            height: "+r.height+";\n            padding: 0;\n            position: relative;\n            width: "+r.width+";\n\n            & > div {\n                background-color: "+r.throw.backgroundColor+";\n                border: 1px solid "+r.throw.borderColor+";\n                height: "+r.throw.size+";\n                position: absolute;\n                width: "+r.throw.size+";\n            }\n        }\n\n        "+(n===nk.Large&&"\n            margin-right: 8px;\n            padding-top: 8px;\n\n            span[data-checked] {\n                background: #FFFFFF;\n            }\n\n            span[data-checked] span {\n                background: "+o[nk.Large].backgroundColor+";\n                transform: translateX(100%);\n            }\n\n            span:not(span span) {\n                background: #FFFFFF;\n                box-shadow: -8px 8px 16px "+t.utility.convertHexToRgba("#9FB0B7",.5)+";\n                height: 33px;\n                width: 68px;\n            }\n\n            span[data-focus] {\n                box-shadow: -8px 8px 16px "+t.utility.convertHexToRgba("#9FB0B7",.5)+";\n            }\n\n            span span {\n                background: "+o[nk.Large].backgroundColor+";\n                height: 33px;\n                width: 33px;\n            }\n        ")+"\n    "}),""),ok=pr(wx,{target:"e1pi340z1"})((e=>{var{theme:t}=e;return"color: "+t.components.ToggleSwitch.baseStyle.disabledLabelColor}),""),ik=pr(Xp,{target:"e1pi340z0"})({name:"1y05nzg",styles:"align-items:top;display:flex"});const ak=e=>{var{defaultIsToggled:t,isDisabled:n,isToggled:r,label:o,name:i,onBlur:a,onChange:s,onFocus:l,subtext:c,value:u,variant:d}=e,p=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,ek),f=o||c;return Mr(Mp,null,Mr(ik,tk({"data-testid":"sp-ui-toggle-switch",htmlFor:i},p),Mr(rk,{"data-testid":"sp-ui-toggle-switch-chakra",defaultChecked:t,id:i,isChecked:r,isDisabled:n,name:i,onChange:s,onBlur:a,onFocus:l,value:u,variant:d}),f&&Mr(_r,{"data-testid":"sp-ui-toggle-switch-label-column"},o&&Mr(n?ok:wx,{"data-testid":"sp-ui-toggle-switch-label",htmlFor:i},o),c&&Mr(bx,{"data-testid":"sp-ui-toggle-switch-subtext"},c))))};var sk=function(e){return e.Dark="dark",e.Light="light",e}(sk||{});function lk(e,t){void 0===t&&(t=1);var[,n,r,o,i,a,s]=Array.from(e),l=parseInt(""+a+s,16),c=parseInt(""+o+i,16);return t>1?t=1:t<0&&(t=0),"rgba("+parseInt(""+n+r,16)+","+c+","+l+","+t+")"}var ck={blue:{100:"#D3EFF8",200:"#A7DFF1",300:"#7BCEEA",400:"#49BDE4",500:"#23AEDC",600:"#1C8BB0",700:"#156884"},navy:{100:"#69ACC3",200:"#4797B2",300:"#39788D",400:"#2A5969",500:"#1B3A45",600:"#0D1B20",700:"#000000"},green:{100:"#CFEACF",200:"#ACDAAC",300:"#89CA89",400:"#66BA66",500:"#4AA34A",600:"#3A803A",700:"#2A5D2A"},orange:{100:"#FDE19C",200:"#FDD269",300:"#FCC337",400:"#FBB405",500:"#CA9003",600:"#986D02",700:"#654902"},red:{100:"#FFE9EA",200:"#FFB6B9",300:"#FF8389",400:"#FF5058",500:"#FF1D27",600:"#E9000B",700:"#B60008"},gray:{100:"#F6F8F9",200:"#D9E0E3",300:"#BCC8CD",400:"#9FB0B7",500:"#8298A1",600:"#677F89",700:"#51646C"},boxShadow:"0 4px 16px rgba(159, 176, 183, 0.3)"},uk={sm:"12px",md:"14px",lg:"18px",xl:"22px","2xl":"26px"},dk={light:"300",medium:"500",normal:"normal"},pk={sm:"20px",md:"24px",lg:"24px",xl:"24px","2xl":"32px"},fk={backgroundColor:"#FFFFFF",borderColor:ck.gray[200],color:ck.gray[500],fontSize:uk.md,fontWeight:dk.light,lineHeight:pk.md,placeholderColor:ck.gray[400],smallScreen:{fontSize:"16px"},[tp.Disabled]:{backgroundColor:ck.gray[100]},[tp.Focus]:{borderColor:ck.blue[400]},[tp.Invalid]:{borderColor:ck.red[400]},[tp.Hover]:{borderColor:ck.gray[400]}},hk={Banner:{variants:{[Jd.Danger]:{backgroundColor:lk(ck.red[100],.1),border:"1px solid "+ck.red[600],svg:{color:ck.red[600]}},[Jd.Neutral]:{backgroundColor:lk(ck.blue[100],.1),border:"1px solid "+ck.blue[600],svg:{color:ck.blue[600]}},[Jd.Warning]:{backgroundColor:lk(ck.orange[100],.1),border:"1px solid "+ck.orange[400],svg:{color:ck.orange[400]}}}},Button:{variants:{[sp.Primary]:{[tp.Default]:{backgroundColor:ck.blue[400],borderColor:ck.blue[400],color:"#FFFFFF"},[tp.Hover]:{backgroundColor:ck.blue[700],borderColor:ck.blue[700],color:"#FFFFFF"},[tp.Loaded]:{backgroundColor:ck.green[500],borderColor:ck.green[500],color:"#FFFFFF"},[tp.Loading]:{backgroundColor:ck.blue[700],borderColor:ck.blue[700]}},[sp.Secondary]:{[tp.Default]:{backgroundColor:ck.gray[100],borderColor:ck.gray[200],color:ck.gray[600]},[tp.Hover]:{backgroundColor:ck.gray[200],borderColor:ck.gray[300],color:ck.gray[600]},[tp.Loaded]:{backgroundColor:ck.green[500],borderColor:ck.green[500],color:"#FFFFFF"},[tp.Loading]:{backgroundColor:ck.gray[200],borderColor:ck.gray[300]}},[sp.Tertiary]:{[tp.Default]:{backgroundColor:"#FFFFFF",borderColor:ck.gray[200],color:ck.blue[400]},[tp.Hover]:{backgroundColor:"#FFFFFF",borderColor:ck.gray[300],color:ck.blue[700]},[tp.Loaded]:{backgroundColor:ck.green[500],borderColor:ck.green[500],color:"#FFFFFF"},[tp.Loading]:{backgroundColor:"#FFFFFF",borderColor:ck.gray[300]}},[sp.Dismissive]:{[tp.Default]:{backgroundColor:"#FFFFFF",borderColor:"transparent",color:ck.gray[600]},[tp.Hover]:{backgroundColor:ck.gray[100],borderColor:"transparent",color:ck.gray[600]},[tp.Loaded]:{backgroundColor:ck.green[500],borderColor:ck.green[500],color:"#FFFFFF"},[tp.Loading]:{backgroundColor:ck.gray[100]}},[sp.Destructive]:{[tp.Default]:{backgroundColor:ck.red[400],borderColor:ck.red[400],color:"#FFFFFF"},[tp.Hover]:{backgroundColor:ck.red[700],borderColor:ck.red[700],color:"#FFFFFF"},[tp.Loaded]:{backgroundColor:ck.green[500],borderColor:ck.green[500],color:"#FFFFFF"},[tp.Loading]:{backgroundColor:ck.red[700],borderColor:ck.red[700]}}}},ButtonGroup:{baseStyle:{activeColor:ck.blue[500],backgroundColor:"transparent",inactiveColor:ck.gray[200]}},Checkbox:{customStyle:{backgroundColor:ck.gray[100],borderColor:ck.gray[400],checkColor:ck.blue[400],checkWidth:"8px",width:"16px",[tp.Disabled]:{backgroundColor:ck.gray[100],borderColor:ck.gray[200],checkColor:ck.blue[100]}}},CheckoutForm:{baseStyle:{accentColor:ck.blue[500],emptyBorderColor:"#DDE2E5",fontPairingId:1,headingColor:ck.gray[400],inputBorderColor:"#B3C1C6",inputBorderColorError:ck.red[400],inputPlaceholderColor:ck.gray[400],linkColor:ck.blue[400]},variants:{[sk.Dark]:{backgroundColor:"#2D2D2D",completedInputBorderColor:"#DDE2E5",inputBackgroundColor:"#242424",inputTextColor:ck.gray[100],secondaryColor:"#242424",selectBorderColor:"#DDE2E5"},[sk.Light]:{backgroundColor:ck.gray[100],completedInputBorderColor:"#B3C1C6",inputBackgroundColor:ck.gray[100],inputTextColor:"#A5A5A5",secondaryColor:"#FFFFFF",selectBorderColor:"#DDE2E5"}}},CircleButton:{variants:{[vp.Back]:{[tp.Default]:{borderColor:ck.blue[200],fill:ck.blue[400]}},[vp.Close]:{[tp.Default]:{borderColor:ck.blue[200],fill:ck.blue[400]}},[vp.Help]:{[tp.Default]:{borderColor:ck.gray[200],fill:ck.gray[400]}}}},DatePicker:{baseStyle:{borderColor:ck.gray[200],dayColor:ck.gray[700],dayDisabledColor:ck.gray[300],dayHeaderColor:ck.gray[500],monthColor:ck.gray[600],monthDisabledColor:ck.gray[300],navigationButtonColor:ck.blue[400],rangeBackgroundColor:ck.blue[100],rangeColor:ck.blue[700],selectedColor:ck.blue[400]}},EditableTable:{baseStyle:{cell:{[tp.Default]:{borderColor:ck.gray[300],color:ck.gray[700]},[tp.Disabled]:{color:ck.gray[500]}},column:{[tp.Default]:{headerTextColor:ck.navy[400]}},row:{[tp.Default]:{backgroundColorEven:"white",backgroundColorOdd:ck.gray[100]},[tp.Selected]:{backgroundColorSelected:ck.navy[100]}}}},FormElement:{baseStyle:{marginBottom:"0px"}},InfoIcon:{baseStyle:{color:ck.blue[600]}},Label:{baseStyle:{color:ck.navy[400],fontSize:uk.md,fontWeight:dk.medium,lineHeight:pk.md,marginBottom:"4px"}},LabelError:{baseStyle:{color:ck.red[400],fontSize:uk.sm,fontWeight:dk.light,lineHeight:pk.sm}},LabelSubtext:{baseStyle:{color:ck.gray[500],lineHeight:"20px"}},Menu:{baseStyle:()=>({borderColor:ck.gray[200],menuItem:{color:ck.gray[600],fontWeight:dk.normal},menuItemActive:{color:ck.blue[600]},menuItemHover:{backgroundColor:ck.gray[100]}})},Modal:{variants:{[yp.Small]:{body:{backgroundColor:"#FFFFFF",maxWidth:"initial",paddingBottom:"24px",paddingTop:"16px",variants:{[bp.Default]:{},[bp.FullWidth]:{maxWidth:"100%",paddingBottom:0,paddingTop:0,paddingLeft:0,paddingRight:0}}},borderBottom:"none",borderRadius:"3px",header:{borderBottom:"none"},height:"auto",marginBottom:"60px",marginTop:"60px",maxWidth:"454px",minHeight:"initial",paddingLeft:"40px",paddingRight:"40px"},[yp.Large]:{body:{backgroundColor:"#FFFFFF",maxWidth:"initial",paddingBottom:"24px",paddingTop:"16px",variants:{[bp.Default]:{},[bp.FullWidth]:{maxWidth:"100%",paddingBottom:0,paddingTop:0,paddingLeft:0,paddingRight:0}}},borderRadius:"3px",header:{borderBottom:"1px solid "+ck.gray[200]},height:"inherit",marginBottom:"60px",marginTop:"60px",maxWidth:"75%",minHeight:"80vh",paddingLeft:"24px",paddingRight:"24px"},[yp.Fullscreen]:{body:{backgroundColor:"#FFFFFF",maxWidth:"800px",paddingBottom:"24px",paddingTop:"16px",variants:{[bp.Default]:{},[bp.FullWidth]:{maxWidth:"100%",paddingBottom:0,paddingTop:0,paddingLeft:0,paddingRight:0}}},borderRadius:"0",header:{borderBottom:"none"},height:"100%",marginBottom:"0",marginTop:"0",maxWidth:"100%",minHeight:"100vh",paddingLeft:"24px",paddingRight:"24px"}}},OnboardingStepper:{baseStyle:{backgroundColor:ck.gray[100],completeBackgroundColor:ck.green[500],completeCheckColor:Hd.colors.white,countSmallScreenFontSize:Hd.fontSizes.sm,label:{activeFontWeight:Hd.fontWeights.medium,fontWeight:Hd.fontWeights.normal,smallScreen:{fontSize:"16px",fontWeight:Hd.fontWeights.medium}},lineBackgroundColor:ck.gray[200],stepIcon:{activeTextFontWeight:Hd.fontWeights.medium,circleStroke:ck.navy[500],textFontWeight:Hd.fontWeights.normal}}},OptionBox:{baseStyle:{[tp.Selected]:{borderWidth:"2px",borderColor:ck.blue[400],boxShadow:ck.boxShadow,padding:"39px"},[tp.Default]:{borderWidth:"1px",borderColor:ck.gray[200],padding:"40px"}}},OrderSummary:{baseStyle:{accentColor:ck.blue[400],fontPairingId:1}},Pagination:{baseStyle:{borderColor:ck.gray[200],buttonColor:ck.blue[400],pageCountColor:ck.gray[600],[tp.Disabled]:{borderColor:ck.gray[200],buttonColor:ck.gray[200],pageCountColor:ck.gray[200]}}},RadioGroup:{customStyle:{content:{color:ck.navy[700]},input:{borderColor:ck.gray[400],color:ck.blue[400]},spacing:"12px"},variants:{[Bx.Bordered]:{radio:{border:"1px solid "+ck.gray[200],borderRadius:"4px",cursor:"pointer",lineHeight:"16px",padding:"16px",[tp.Checked]:{border:"2px solid "+ck.blue[400]}}},[Bx.Default]:{radio:{lineHeight:"24px"}}}},RadioTileGroup:{baseStyle:{background:"#FFFFFF",boxShadow:"1px 3px 10px 1px "+ck.gray[200],borderColor:ck.gray[400],color:ck.navy[400],selectedBorder:"2px solid "+ck.blue[400],[tp.Disabled]:{backgroundColor:ck.gray[100]}}},ResponsiveNav:{baseStyle:{borderColor:ck.gray[200],burgerMenu:{color:ck.gray[600]},navLink:{color:ck.gray[600],fontWeight:dk.normal},navLinkActive:{color:ck.blue[600]},smallScreenNav:{closeButton:{color:"#FFFFFF"},accordionHeader:{color:ck.navy[400]},accordionItem:{fontSize:uk.md,fontWeight:dk.normal,lineHeight:pk.md}}}},Select:{baseStyle:()=>({backgroundColor:"none",borderColor:ck.gray[200],optionBackgroundColor:"#FFFFFF",optionColor:ck.gray[600],optionFontSize:uk.md,placeholderColor:ck.gray[600],placeholderFontSize:uk.md,singleValueFontSize:uk.md,valueColor:ck.gray[600],[tp.Disabled]:{placeholderColor:ck.gray[400],valueColor:ck.gray[400]},[tp.Hover]:{optionColor:"#FFFFFF",optionBackgroundColor:ck.blue[400]},[tp.Invalid]:{borderColor:ck.red[400]}})},SelectChecklist:{baseStyle:{backgroundColor:ck.gray[100],backgroundColorMobile:"#FFFFFF",borderColor:ck.gray[200],optionBackgroundColor:"#FFFFFF",optionColor:ck.gray[600],optionFontSize:uk.md,placeholderColor:ck.navy[400],placeholderFontSize:uk.md,placeholderFontSizeMobile:uk.lg,singleValueFontSize:uk.md,valueColor:ck.gray[600],[tp.Disabled]:{placeholderColor:ck.gray[400],valueColor:ck.gray[400]},[tp.Hover]:{optionColor:"#FFFFFF",optionBackgroundColor:ck.blue[400]},[tp.Invalid]:{borderColor:ck.red[400]}}},StatusPill:{variants:{[zx.Danger]:{backgroundColor:lk(ck.red[200],.5),color:ck.gray[700]},[zx.Neutral]:{backgroundColor:lk(ck.gray[200],.5),color:ck.gray[700]},[zx.Success]:{backgroundColor:lk(ck.green[200],.5),color:ck.gray[700]},[zx.Warning]:{backgroundColor:lk(ck.orange[200],.5),color:ck.gray[700]}}},TabControl:{baseStyle:{borderColor:ck.gray[200],color:ck.blue[400],fontSize:uk.sm,lineHeight:pk.sm,[tp.Selected]:{borderColor:ck.navy[500],color:ck.navy[500]}}},Table:{baseStyle:{borderColor:ck.gray[200],borderRadius:"4px"}},TextArea:{baseStyle:fk},TextInput:{baseStyle:fk},ToggleSwitch:{baseStyle:{disabledLabelColor:ck.gray[400],height:"12px",throw:{backgroundColor:ck.gray[100],borderColor:ck.gray[500],size:"20px"},width:"32px"},variants:{[nk.Large]:{backgroundColor:ck.blue[400]}}},Tooltip:{baseStyle:()=>({arrowShadowColor:"rgba(42, 89, 89, 0.3)",color:ck.gray[700],shadowColor:"rgba(42, 89, 89, 0.4)"})}},{md:mk,lg:gk,xl:vk}={base:"0",sm:"480",md:"768",lg:"1200",xl:"1900","2xl":"2400"},yk={extraLargeScreenOnly:e=>"\n        @media only screen and (min-width: "+(Number(vk)+1)+"px) {\n            "+e+"\n        }\n    ",largeScreenDown:e=>"\n        @media only screen and (max-width: "+vk+"px) {\n            "+e+"\n        }\n    ",largeScreenOnly:e=>"\n        @media only screen and (min-width: "+(Number(gk)+1)+"px) and (max-width: "+vk+"px) {\n            "+e+"\n        }\n    ",largeScreenUp:e=>"\n        @media only screen and (min-width: "+(Number(gk)+1)+"px) {\n            "+e+"\n        }\n    ",mediumScreenDown:e=>"\n        @media only screen and (max-width: "+gk+"px) {\n            "+e+"\n        }\n    ",mediumScreenOnly:e=>"\n        @media only screen and (min-width: "+(Number(mk)+1)+"px) and (max-width: "+gk+"px) {\n            "+e+"\n        }\n    ",mediumScreenUp:e=>"\n        @media only screen and (min-width: "+(Number(mk)+1)+"px) {\n            "+e+"\n        }\n    ",smallScreenOnly:e=>"\n        @media only screen and (max-width: "+mk+"px) {\n            "+e+"\n        }\n    "};const bk=Gd({breakpoints:{base:"0px",sm:"480px",md:"768px",lg:"1200px",xl:"1900px","2xl":"2400px"},colors:ck,components:hk,fontColor:{default:ck.navy[400]},fonts:{body:"azo-sans-web, Helvetica, Arial, sans-serif",heading:"azo-sans-web, Helvetica, Arial, sans-serif",mono:"azo-sans-web, Helvetica, Arial, sans-serif"},fontSizes:uk,fontWeights:dk,gutters:{sm:"10px",md:"20px"},lineHeights:pk,responsive:yk,rowMaxWidth:"1440px",spacing:{sm:"4px",md:"8px",lg:"12px",xl:"14px"},styles:{global:()=>({body:{bg:null,color:null,fontFamily:null,lineHeight:null,transition:null},"*::placeholder":{color:null},"*, *::before, &::after":{borderColor:null,wordWrap:null}})},utility:{convertHexToRgba:lk},zIndices:{modal:2e3}});var _k=o(71124),Ak=o.n(_k);const Ek=(e,t)=>Ak()(t||bk,e);var wk=String.raw,xk=wk`
  :root,
  :host {
    --chakra-vh: 100vh;
  }

  @supports (height: -webkit-fill-available) {
    :root,
    :host {
      --chakra-vh: -webkit-fill-available;
    }
  }

  @supports (height: -moz-fill-available) {
    :root,
    :host {
      --chakra-vh: -moz-fill-available;
    }
  }

  @supports (height: 100dvh) {
    :root,
    :host {
      --chakra-vh: 100dvh;
    }
  }
`,kk=()=>(0,br.jsx)(Tr,{styles:xk}),Ck=({scope:e=""})=>(0,br.jsx)(Tr,{styles:wk`
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }

      body {
        position: relative;
        min-height: 100%;
        margin: 0;
        font-feature-settings: "kern";
      }

      ${e} :where(*, *::before, *::after) {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
        word-wrap: break-word;
      }

      main {
        display: block;
      }

      ${e} hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }

      ${e} :where(pre, code, kbd,samp) {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }

      ${e} a {
        background-color: transparent;
        color: inherit;
        text-decoration: inherit;
      }

      ${e} abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      ${e} :where(b, strong) {
        font-weight: bold;
      }

      ${e} small {
        font-size: 80%;
      }

      ${e} :where(sub,sup) {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }

      ${e} sub {
        bottom: -0.25em;
      }

      ${e} sup {
        top: -0.5em;
      }

      ${e} img {
        border-style: none;
      }

      ${e} :where(button, input, optgroup, select, textarea) {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }

      ${e} :where(button, input) {
        overflow: visible;
      }

      ${e} :where(button, select) {
        text-transform: none;
      }

      ${e} :where(
          button::-moz-focus-inner,
          [type="button"]::-moz-focus-inner,
          [type="reset"]::-moz-focus-inner,
          [type="submit"]::-moz-focus-inner
        ) {
        border-style: none;
        padding: 0;
      }

      ${e} fieldset {
        padding: 0.35em 0.75em 0.625em;
      }

      ${e} legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      ${e} progress {
        vertical-align: baseline;
      }

      ${e} textarea {
        overflow: auto;
      }

      ${e} :where([type="checkbox"], [type="radio"]) {
        box-sizing: border-box;
        padding: 0;
      }

      ${e} input[type="number"]::-webkit-inner-spin-button,
      ${e} input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      ${e} input[type="number"] {
        -moz-appearance: textfield;
      }

      ${e} input[type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }

      ${e} input[type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }

      ${e} ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }

      ${e} details {
        display: block;
      }

      ${e} summary {
        display: list-item;
      }

      template {
        display: none;
      }

      [hidden] {
        display: none !important;
      }

      ${e} :where(
          blockquote,
          dl,
          dd,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          hr,
          figure,
          p,
          pre
        ) {
        margin: 0;
      }

      ${e} button {
        background: transparent;
        padding: 0;
      }

      ${e} fieldset {
        margin: 0;
        padding: 0;
      }

      ${e} :where(ol, ul) {
        margin: 0;
        padding: 0;
      }

      ${e} textarea {
        resize: vertical;
      }

      ${e} :where(button, [role="button"]) {
        cursor: pointer;
      }

      ${e} button::-moz-focus-inner {
        border: 0 !important;
      }

      ${e} table {
        border-collapse: collapse;
      }

      ${e} :where(h1, h2, h3, h4, h5, h6) {
        font-size: inherit;
        font-weight: inherit;
      }

      ${e} :where(button, input, optgroup, select, textarea) {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }

      ${e} :where(img, svg, video, canvas, audio, iframe, embed, object) {
        display: block;
      }

      ${e} :where(img, video) {
        max-width: 100%;
        height: auto;
      }

      [data-js-focus-visible]
        :focus:not([data-focus-visible-added]):not(
          [data-focus-visible-disabled]
        ) {
        outline: none;
        box-shadow: none;
      }

      ${e} select::-ms-expand {
        display: none;
      }

      ${xk}
    `});function Sk(e){const{cssVarsRoot:t,theme:n,children:r}=e,o=(0,i.useMemo)((()=>Je(n)),[n]);return(0,br.jsxs)(tr,{theme:o,children:[(0,br.jsx)(Mk,{root:t}),r]})}function Mk({root:e=":host, :root"}){const t=[e,"[data-theme]"].join(",");return(0,br.jsx)(Tr,{styles:e=>({[t]:e.__cssVars})})}var[Tk,Ok]=function(e={}){const{strict:t=!0,errorMessage:n="useContext: `context` is undefined. Seems you forgot to wrap component within the Provider",name:r}=e,o=(0,i.createContext)(void 0);return o.displayName=r,[o.Provider,function e(){var r;const a=(0,i.useContext)(o);if(!a&&t){const t=new Error(n);throw t.name="ContextError",null==(r=Error.captureStackTrace)||r.call(Error,t,e),t}return a},o]}({name:"StylesContext",errorMessage:"useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "});function Dk(){const{colorMode:e}=vt();return(0,br.jsx)(Tr,{styles:t=>{const n=At(yt(t,"styles.global"),{theme:t,colorMode:e});if(!n)return;return lt(n)(t)}})}var Lk={light:"chakra-ui-light",dark:"chakra-ui-dark"};var Pk="chakra-ui-color-mode";var Ik,Bk=(Ik=Pk,{ssr:!1,type:"localStorage",get(e){if(!(null==globalThis?void 0:globalThis.document))return e;let t;try{t=localStorage.getItem(Ik)||e}catch(e){}return t||e},set(e){try{localStorage.setItem(Ik,e)}catch(e){}}});function Rk(e,t){const n=e.match(new RegExp(`(^| )${t}=([^;]+)`));return null==n?void 0:n[2]}function Nk(e,t){return{ssr:!!t,type:"cookie",get:n=>t?Rk(t,e):(null==globalThis?void 0:globalThis.document)&&Rk(document.cookie,e)||n,set(t){document.cookie=`${e}=${t}; max-age=31536000; path=/`}}}Nk(Pk);var Fk=()=>{};function jk(e,t){return"cookie"===e.type&&e.ssr?e.get(t):t}function Yk(e){const{value:t,children:n,options:{useSystemColorMode:r,initialColorMode:o,disableTransitionOnChange:a}={},colorModeManager:s=Bk}=e,l="dark"===o?"dark":"light",[c,u]=(0,i.useState)((()=>jk(s,l))),[d,p]=(0,i.useState)((()=>jk(s))),{getSystemTheme:f,setClassName:h,setDataset:m,addListener:g}=(0,i.useMemo)((()=>function(e={}){const{preventTransition:t=!0}=e,n={setDataset:e=>{const r=t?n.preventTransition():void 0;document.documentElement.dataset.theme=e,document.documentElement.style.colorScheme=e,null==r||r()},setClassName(e){document.body.classList.add(e?Lk.dark:Lk.light),document.body.classList.remove(e?Lk.light:Lk.dark)},query:()=>window.matchMedia("(prefers-color-scheme: dark)"),getSystemTheme(e){var t;return(null!=(t=n.query().matches)?t:"dark"===e)?"dark":"light"},addListener(e){const t=n.query(),r=t=>{e(t.matches?"dark":"light")};return"function"==typeof t.addListener?t.addListener(r):t.addEventListener("change",r),()=>{"function"==typeof t.removeListener?t.removeListener(r):t.removeEventListener("change",r)}},preventTransition(){const e=document.createElement("style");return e.appendChild(document.createTextNode("*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}")),document.head.appendChild(e),()=>{window.getComputedStyle(document.body),requestAnimationFrame((()=>{requestAnimationFrame((()=>{document.head.removeChild(e)}))}))}}};return n}({preventTransition:a})),[a]),v="system"!==o||c?c:d,y=(0,i.useCallback)((e=>{const t="system"===e?f():e;u(t),h("dark"===t),m(t),s.set(t)}),[s,f,h,m]);em((()=>{"system"===o&&p(f())}),[]),(0,i.useEffect)((()=>{const e=s.get();y(e||("system"!==o?l:"system"))}),[s,l,o,y]);const b=(0,i.useCallback)((()=>{y("dark"===v?"light":"dark")}),[v,y]);(0,i.useEffect)((()=>{if(r)return g(y)}),[r,g,y]);const _=(0,i.useMemo)((()=>({colorMode:null!=t?t:v,toggleColorMode:t?Fk:b,setColorMode:t?Fk:y,forced:void 0!==t})),[v,b,y,t]);return(0,br.jsx)(gt.Provider,{value:_,children:n})}Yk.displayName="ColorModeProvider";var $k=(0,i.createContext)({getDocument:()=>document,getWindow:()=>window});function Hk(e){const{children:t,environment:n,disabled:r}=e,o=(0,i.useRef)(null),a=(0,i.useMemo)((()=>n||{getDocument:()=>{var e,t;return null!=(t=null==(e=o.current)?void 0:e.ownerDocument)?t:document},getWindow:()=>{var e,t;return null!=(t=null==(e=o.current)?void 0:e.ownerDocument.defaultView)?t:window}}),[n]),s=!r||!n;return(0,br.jsxs)($k.Provider,{value:a,children:[t,s&&(0,br.jsx)("span",{id:"__chakra_env",hidden:!0,ref:o})]})}$k.displayName="EnvironmentContext",Hk.displayName="EnvironmentProvider";var Uk=e=>{const{children:t,colorModeManager:n,portalZIndex:r,resetScope:o,resetCSS:i=!0,theme:a={},environment:s,cssVarsRoot:l,disableEnvironment:c,disableGlobalStyle:u}=e,d=(0,br.jsx)(Hk,{environment:s,disabled:c,children:t});return(0,br.jsx)(Sk,{theme:a,cssVarsRoot:l,children:(0,br.jsxs)(Yk,{colorModeManager:n,options:a.config,children:[i?(0,br.jsx)(Ck,{scope:o}):(0,br.jsx)(kk,{}),!u&&(0,br.jsx)(Dk,{}),r?(0,br.jsx)(Xh,{zIndex:r,children:d}):d]})})},zk=(e,t)=>e.find((e=>e.id===t));function Wk(e,t){const n=Vk(e,t);return{position:n,index:n?e[n].findIndex((e=>e.id===t)):-1}}function Vk(e,t){for(const[n,r]of Object.entries(e))if(zk(r,t))return n}function Gk(e){return{position:"fixed",zIndex:"var(--toast-z-index, 5500)",pointerEvents:"none",display:"flex",flexDirection:"column",margin:"top"===e||"bottom"===e?"0 auto":void 0,top:e.includes("top")?"env(safe-area-inset-top, 0px)":void 0,bottom:e.includes("bottom")?"env(safe-area-inset-bottom, 0px)":void 0,right:e.includes("left")?void 0:"env(safe-area-inset-right, 0px)",left:e.includes("right")?void 0:"env(safe-area-inset-left, 0px)"}}var Qk={initial:e=>{const{position:t}=e,n=["top","bottom"].includes(t)?"y":"x";let r=["top-right","bottom-right"].includes(t)?1:-1;return"bottom"===t&&(r=1),{opacity:0,[n]:24*r}},animate:{opacity:1,y:0,x:0,scale:1,transition:{duration:.4,ease:[.4,0,.2,1]}},exit:{opacity:0,scale:.85,transition:{duration:.2,ease:[.4,0,1,1]}}},qk=(0,i.memo)((e=>{const{id:t,message:n,onCloseComplete:r,onRequestRemove:o,requestClose:a=!1,position:s="bottom",duration:l=5e3,containerStyle:c,motionVariants:u=Qk,toastSpacing:d="0.5rem"}=e,[p,f]=(0,i.useState)(l),h=uE();qx((()=>{h||null==r||r()}),[h]),qx((()=>{f(l)}),[l]);const m=()=>{h&&o()};(0,i.useEffect)((()=>{h&&a&&o()}),[h,a,o]),function(e,t){const n=zh(e);(0,i.useEffect)((()=>{if(null==t)return;let e=null;return e=window.setTimeout((()=>{n()}),t),()=>{e&&window.clearTimeout(e)}}),[t,n])}(m,p);const g=(0,i.useMemo)((()=>({pointerEvents:"auto",maxWidth:560,minWidth:300,margin:d,...c})),[c,d]),v=(0,i.useMemo)((()=>function(e){let t="center";return e.includes("right")&&(t="flex-end"),e.includes("left")&&(t="flex-start"),{display:"flex",flexDirection:"column",alignItems:t}}(s)),[s]);return(0,br.jsx)(Yw.div,{layout:!0,className:"chakra-toast",variants:u,initial:"initial",animate:"animate",exit:"exit",onHoverStart:()=>f(null),onHoverEnd:()=>f(l),custom:{position:s},style:v,children:(0,br.jsx)(vr.div,{role:"status","aria-atomic":"true",className:"chakra-toast__inner",__css:g,children:b(n,{id:t,onClose:m})})})}));function Kk(e,t){var n;const r=null!=e?e:"bottom",o={"top-start":{ltr:"top-left",rtl:"top-right"},"top-end":{ltr:"top-right",rtl:"top-left"},"bottom-start":{ltr:"bottom-left",rtl:"bottom-right"},"bottom-end":{ltr:"bottom-right",rtl:"bottom-left"}}[r];return null!=(n=null==o?void 0:o[t])?n:r}qk.displayName="ToastComponent";var Zk={path:(0,br.jsxs)("g",{stroke:"currentColor",strokeWidth:"1.5",children:[(0,br.jsx)("path",{strokeLinecap:"round",fill:"none",d:"M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"}),(0,br.jsx)("path",{fill:"currentColor",strokeLinecap:"round",d:"M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"}),(0,br.jsx)("circle",{fill:"none",strokeMiterlimit:"10",cx:"12",cy:"12",r:"11.25"})]}),viewBox:"0 0 24 24"},Jk=yr(((e,t)=>{const{as:n,viewBox:r,color:o="currentColor",focusable:i=!1,children:a,className:s,__css:l,...c}=e,u={ref:t,focusable:i,className:g("chakra-icon",s),__css:{w:"1em",h:"1em",display:"inline-block",lineHeight:"1em",flexShrink:0,color:o,...l,...Fr("Icon",e)}},d=null!=r?r:Zk.viewBox;if(n&&"string"!=typeof n)return(0,br.jsx)(vr.svg,{as:n,...u,...c});const p=null!=a?a:Zk.path;return(0,br.jsx)(vr.svg,{verticalAlign:"middle",viewBox:d,...u,...c,children:p})}));Jk.displayName="Icon";function Xk(e){return(0,br.jsx)(Jk,{viewBox:"0 0 24 24",...e,children:(0,br.jsx)("path",{fill:"currentColor",d:"M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"})})}var[eC,tC]=xr({name:"AlertContext",hookName:"useAlertContext",providerName:"<Alert />"}),[nC,rC]=xr({name:"AlertStylesContext",hookName:"useAlertStyles",providerName:"<Alert />"}),oC={info:{icon:function(e){return(0,br.jsx)(Jk,{viewBox:"0 0 24 24",...e,children:(0,br.jsx)("path",{fill:"currentColor",d:"M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"})})},colorScheme:"blue"},warning:{icon:Xk,colorScheme:"orange"},success:{icon:function(e){return(0,br.jsx)(Jk,{viewBox:"0 0 24 24",...e,children:(0,br.jsx)("path",{fill:"currentColor",d:"M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"})})},colorScheme:"green"},error:{icon:Xk,colorScheme:"red"},loading:{icon:$r,colorScheme:"blue"}};var iC=yr((function(e,t){var n;const{status:r="info",addRole:o=!0,...i}=pt(e),a=null!=(n=e.colorScheme)?n:function(e){return oC[e].colorScheme}(r),s=jr("Alert",{...e,colorScheme:a}),l={width:"100%",display:"flex",alignItems:"center",position:"relative",overflow:"hidden",...s.container};return(0,br.jsx)(eC,{value:{status:r},children:(0,br.jsx)(nC,{value:s,children:(0,br.jsx)(vr.div,{"data-status":r,role:o?"alert":void 0,ref:t,...i,className:g("chakra-alert",e.className),__css:l})})})}));function aC(e){const{status:t}=tC(),n=function(e){return oC[e].icon}(t),r=rC(),o="loading"===t?r.spinner:r.icon;return(0,br.jsx)(vr.span,{display:"inherit","data-status":t,...e,className:g("chakra-alert__icon",e.className),__css:o,children:e.children||(0,br.jsx)(n,{h:"100%",w:"100%"})})}iC.displayName="Alert",aC.displayName="AlertIcon";var sC=yr((function(e,t){const n=rC(),{status:r}=tC();return(0,br.jsx)(vr.div,{ref:t,"data-status":r,...e,className:g("chakra-alert__title",e.className),__css:n.title})}));sC.displayName="AlertTitle";var lC=yr((function(e,t){const n=rC(),{status:r}=tC(),o={display:"inline",...n.description};return(0,br.jsx)(vr.div,{ref:t,"data-status":r,...e,className:g("chakra-alert__desc",e.className),__css:o})}));function cC(e){return(0,br.jsx)(Jk,{focusable:"false","aria-hidden":!0,...e,children:(0,br.jsx)("path",{fill:"currentColor",d:"M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"})})}lC.displayName="AlertDescription";var uC=yr((function(e,t){const n=Fr("CloseButton",e),{children:r,isDisabled:o,__css:i,...a}=pt(e);return(0,br.jsx)(vr.button,{type:"button","aria-label":"Close",ref:t,disabled:o,__css:{outline:0,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,...n,...i},...a,children:r||(0,br.jsx)(cC,{width:"1em",height:"1em"})})}));uC.displayName="CloseButton";var dC=function(e){let t=e;const n=new Set,r=e=>{t=e(t),n.forEach((e=>e()))};return{getState:()=>t,subscribe:t=>(n.add(t),()=>{r((()=>e)),n.delete(t)}),removeToast:(e,t)=>{r((n=>({...n,[t]:n[t].filter((t=>t.id!=e))})))},notify:(e,t)=>{const n=function(e,t={}){var n,r;pC+=1;const o=null!=(n=t.id)?n:pC,i=null!=(r=t.position)?r:"bottom";return{id:o,message:e,position:i,duration:t.duration,onCloseComplete:t.onCloseComplete,onRequestRemove:()=>dC.removeToast(String(o),i),status:t.status,requestClose:!1,containerStyle:t.containerStyle}}(e,t),{position:o,id:i}=n;return r((e=>{var t,r;const i=o.includes("top")?[n,...null!=(t=e[o])?t:[]]:[...null!=(r=e[o])?r:[],n];return{...e,[o]:i}})),i},update:(e,t)=>{e&&r((n=>{const r={...n},{position:o,index:i}=Wk(r,e);return o&&-1!==i&&(r[o][i]={...r[o][i],...t,message:hC(t)}),r}))},closeAll:({positions:e}={})=>{r((t=>(null!=e?e:["bottom","bottom-right","bottom-left","top","top-left","top-right"]).reduce(((e,n)=>(e[n]=t[n].map((e=>({...e,requestClose:!0}))),e)),{...t})))},close:e=>{r((t=>{const n=Vk(t,e);return n?{...t,[n]:t[n].map((t=>t.id==e?{...t,requestClose:!0}:t))}:t}))},isActive:e=>Boolean(Wk(dC.getState(),e).position)}}({top:[],"top-left":[],"top-right":[],"bottom-left":[],bottom:[],"bottom-right":[]});var pC=0;var fC=e=>{const{status:t,variant:n="solid",id:r,title:o,isClosable:i,onClose:a,description:s,colorScheme:l,icon:c}=e,u=r?{root:`toast-${r}`,title:`toast-${r}-title`,description:`toast-${r}-description`}:void 0;return(0,br.jsxs)(iC,{addRole:!1,status:t,variant:n,id:null==u?void 0:u.root,alignItems:"start",borderRadius:"md",boxShadow:"lg",paddingEnd:8,textAlign:"start",width:"auto",colorScheme:l,children:[(0,br.jsx)(aC,{children:c}),(0,br.jsxs)(vr.div,{flex:"1",maxWidth:"100%",children:[o&&(0,br.jsx)(sC,{id:null==u?void 0:u.title,children:o}),s&&(0,br.jsx)(lC,{id:null==u?void 0:u.description,display:"block",children:s})]}),i&&(0,br.jsx)(uC,{size:"sm",onClick:a,position:"absolute",insetEnd:1,top:1})]})};function hC(e={}){const{render:t,toastComponent:n=fC}=e;return r=>"function"==typeof t?t({...r,...e}):(0,br.jsx)(n,{...r,...e})}var[mC,gC]=xr({name:"ToastOptionsContext",strict:!1}),vC=e=>{const t=(0,i.useSyncExternalStore)(dC.subscribe,dC.getState,dC.getState),{motionVariants:n,component:r=qk,portalProps:o}=e,a=Object.keys(t).map((e=>{const o=t[e];return(0,br.jsx)("div",{role:"region","aria-live":"polite","aria-label":`Notifications-${e}`,id:`chakra-toast-manager-${e}`,style:Gk(e),children:(0,br.jsx)(qw,{initial:!1,children:o.map((e=>(0,br.jsx)(r,{motionVariants:n,...e},e.id)))})},e)}));return(0,br.jsx)(sm,{...o,children:a})},yC=e=>function({children:t,theme:n=e,toastOptions:r,...o}){return(0,br.jsxs)(Uk,{theme:n,...o,children:[(0,br.jsx)(mC,{value:null==r?void 0:r.defaultOptions,children:t}),(0,br.jsx)(vC,{...r})]})},bC=yC(Hd);yC(Ud);const _C=e=>{var{baseTheme:t=bk,children:n,resetCSS:r=!0,partialTheme:o}=e,i=Ek(o,t);return Mr(bC,{resetCSS:r,theme:i},n)};class AC extends i.Component{constructor(e){super(e),this.state={error:!1},this.props.onInit&&this.props.onInit()}componentDidCatch(e){(this.props.onError||this.onDefaultError)(e)}onDefaultError(e){var t=window.TrackJS;t?t.isInstalled()?t.track(e):console.error("TrackJS not installed!"):console.error("TrackJS not found!")}render(){var e=this.props.fallbackContent?this.props.fallbackContent:"Something went wrong!";return this.state.error?Mr(wr,null,e):this.props.children}}function EC(e,t){void 0===t&&(t={});var{errorBoundaryProps:n={},partialTheme:r={},translateService:o=(e=>e)}=t,i=t=>Mr(AC,n,Mr(_C,{resetCSS:!1,partialTheme:r},Mr(wo,{translate:o},Mr(e,t)))),a=e.displayName||e.name;return i.displayName="withCommon"+a,i}function wC(e){return wC="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},wC(e)}function xC(e){var t=function(e,t){if("object"!=wC(e)||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=wC(r))return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==wC(t)?t:t+""}function kC(e,t,n){return(t=xC(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var CC,SC=[],MC="ResizeObserver loop completed with undelivered notifications.";!function(e){e.BORDER_BOX="border-box",e.CONTENT_BOX="content-box",e.DEVICE_PIXEL_CONTENT_BOX="device-pixel-content-box"}(CC||(CC={}));var TC,OC=function(e){return Object.freeze(e)},DC=function(e,t){this.inlineSize=e,this.blockSize=t,OC(this)},LC=function(){function e(e,t,n,r){return this.x=e,this.y=t,this.width=n,this.height=r,this.top=this.y,this.left=this.x,this.bottom=this.top+this.height,this.right=this.left+this.width,OC(this)}return e.prototype.toJSON=function(){var e=this;return{x:e.x,y:e.y,top:e.top,right:e.right,bottom:e.bottom,left:e.left,width:e.width,height:e.height}},e.fromRect=function(t){return new e(t.x,t.y,t.width,t.height)},e}(),PC=function(e){return e instanceof SVGElement&&"getBBox"in e},IC=function(e){if(PC(e)){var t=e.getBBox(),n=t.width,r=t.height;return!n&&!r}var o=e,i=o.offsetWidth,a=o.offsetHeight;return!(i||a||e.getClientRects().length)},BC=function(e){var t;if(e instanceof Element)return!0;var n=null===(t=null==e?void 0:e.ownerDocument)||void 0===t?void 0:t.defaultView;return!!(n&&e instanceof n.Element)},RC="undefined"!=typeof window?window:{},NC=new WeakMap,FC=/auto|scroll/,jC=/^tb|vertical/,YC=/msie|trident/i.test(RC.navigator&&RC.navigator.userAgent),$C=function(e){return parseFloat(e||"0")},HC=function(e,t,n){return void 0===e&&(e=0),void 0===t&&(t=0),void 0===n&&(n=!1),new DC((n?t:e)||0,(n?e:t)||0)},UC=OC({devicePixelContentBoxSize:HC(),borderBoxSize:HC(),contentBoxSize:HC(),contentRect:new LC(0,0,0,0)}),zC=function(e,t){if(void 0===t&&(t=!1),NC.has(e)&&!t)return NC.get(e);if(IC(e))return NC.set(e,UC),UC;var n=getComputedStyle(e),r=PC(e)&&e.ownerSVGElement&&e.getBBox(),o=!YC&&"border-box"===n.boxSizing,i=jC.test(n.writingMode||""),a=!r&&FC.test(n.overflowY||""),s=!r&&FC.test(n.overflowX||""),l=r?0:$C(n.paddingTop),c=r?0:$C(n.paddingRight),u=r?0:$C(n.paddingBottom),d=r?0:$C(n.paddingLeft),p=r?0:$C(n.borderTopWidth),f=r?0:$C(n.borderRightWidth),h=r?0:$C(n.borderBottomWidth),m=d+c,g=l+u,v=(r?0:$C(n.borderLeftWidth))+f,y=p+h,b=s?e.offsetHeight-y-e.clientHeight:0,_=a?e.offsetWidth-v-e.clientWidth:0,A=o?m+v:0,E=o?g+y:0,w=r?r.width:$C(n.width)-A-_,x=r?r.height:$C(n.height)-E-b,k=w+m+_+v,C=x+g+b+y,S=OC({devicePixelContentBoxSize:HC(Math.round(w*devicePixelRatio),Math.round(x*devicePixelRatio),i),borderBoxSize:HC(k,C,i),contentBoxSize:HC(w,x,i),contentRect:new LC(d,l,w,x)});return NC.set(e,S),S},WC=function(e,t,n){var r=zC(e,n),o=r.borderBoxSize,i=r.contentBoxSize,a=r.devicePixelContentBoxSize;switch(t){case CC.DEVICE_PIXEL_CONTENT_BOX:return a;case CC.BORDER_BOX:return o;default:return i}},VC=function(e){var t=zC(e);this.target=e,this.contentRect=t.contentRect,this.borderBoxSize=OC([t.borderBoxSize]),this.contentBoxSize=OC([t.contentBoxSize]),this.devicePixelContentBoxSize=OC([t.devicePixelContentBoxSize])},GC=function(e){if(IC(e))return 1/0;for(var t=0,n=e.parentNode;n;)t+=1,n=n.parentNode;return t},QC=function(){var e=1/0,t=[];SC.forEach((function(n){if(0!==n.activeTargets.length){var r=[];n.activeTargets.forEach((function(t){var n=new VC(t.target),o=GC(t.target);r.push(n),t.lastReportedSize=WC(t.target,t.observedBox),o<e&&(e=o)})),t.push((function(){n.callback.call(n.observer,r,n.observer)})),n.activeTargets.splice(0,n.activeTargets.length)}}));for(var n=0,r=t;n<r.length;n++){(0,r[n])()}return e},qC=function(e){SC.forEach((function(t){t.activeTargets.splice(0,t.activeTargets.length),t.skippedTargets.splice(0,t.skippedTargets.length),t.observationTargets.forEach((function(n){n.isActive()&&(GC(n.target)>e?t.activeTargets.push(n):t.skippedTargets.push(n))}))}))},KC=function(){var e,t=0;for(qC(t);SC.some((function(e){return e.activeTargets.length>0}));)t=QC(),qC(t);return SC.some((function(e){return e.skippedTargets.length>0}))&&("function"==typeof ErrorEvent?e=new ErrorEvent("error",{message:MC}):((e=document.createEvent("Event")).initEvent("error",!1,!1),e.message=MC),window.dispatchEvent(e)),t>0},ZC=[],JC=function(e){if(!TC){var t=0,n=document.createTextNode("");new MutationObserver((function(){return ZC.splice(0).forEach((function(e){return e()}))})).observe(n,{characterData:!0}),TC=function(){n.textContent="".concat(t?t--:t++)}}ZC.push(e),TC()},XC=0,eS={attributes:!0,characterData:!0,childList:!0,subtree:!0},tS=["resize","load","transitionend","animationend","animationstart","animationiteration","keyup","keydown","mouseup","mousedown","mouseover","mouseout","blur","focus"],nS=function(e){return void 0===e&&(e=0),Date.now()+e},rS=!1,oS=new(function(){function e(){var e=this;this.stopped=!0,this.listener=function(){return e.schedule()}}return e.prototype.run=function(e){var t=this;if(void 0===e&&(e=250),!rS){rS=!0;var n,r=nS(e);n=function(){var n=!1;try{n=KC()}finally{if(rS=!1,e=r-nS(),!XC)return;n?t.run(1e3):e>0?t.run(e):t.start()}},JC((function(){requestAnimationFrame(n)}))}},e.prototype.schedule=function(){this.stop(),this.run()},e.prototype.observe=function(){var e=this,t=function(){return e.observer&&e.observer.observe(document.body,eS)};document.body?t():RC.addEventListener("DOMContentLoaded",t)},e.prototype.start=function(){var e=this;this.stopped&&(this.stopped=!1,this.observer=new MutationObserver(this.listener),this.observe(),tS.forEach((function(t){return RC.addEventListener(t,e.listener,!0)})))},e.prototype.stop=function(){var e=this;this.stopped||(this.observer&&this.observer.disconnect(),tS.forEach((function(t){return RC.removeEventListener(t,e.listener,!0)})),this.stopped=!0)},e}()),iS=function(e){!XC&&e>0&&oS.start(),!(XC+=e)&&oS.stop()},aS=function(){function e(e,t){this.target=e,this.observedBox=t||CC.CONTENT_BOX,this.lastReportedSize={inlineSize:0,blockSize:0}}return e.prototype.isActive=function(){var e,t=WC(this.target,this.observedBox,!0);return e=this.target,PC(e)||function(e){switch(e.tagName){case"INPUT":if("image"!==e.type)break;case"VIDEO":case"AUDIO":case"EMBED":case"OBJECT":case"CANVAS":case"IFRAME":case"IMG":return!0}return!1}(e)||"inline"!==getComputedStyle(e).display||(this.lastReportedSize=t),this.lastReportedSize.inlineSize!==t.inlineSize||this.lastReportedSize.blockSize!==t.blockSize},e}(),sS=function(e,t){this.activeTargets=[],this.skippedTargets=[],this.observationTargets=[],this.observer=e,this.callback=t},lS=new WeakMap,cS=function(e,t){for(var n=0;n<e.length;n+=1)if(e[n].target===t)return n;return-1},uS=function(){function e(){}return e.connect=function(e,t){var n=new sS(e,t);lS.set(e,n)},e.observe=function(e,t,n){var r=lS.get(e),o=0===r.observationTargets.length;cS(r.observationTargets,t)<0&&(o&&SC.push(r),r.observationTargets.push(new aS(t,n&&n.box)),iS(1),oS.schedule())},e.unobserve=function(e,t){var n=lS.get(e),r=cS(n.observationTargets,t),o=1===n.observationTargets.length;r>=0&&(o&&SC.splice(SC.indexOf(n),1),n.observationTargets.splice(r,1),iS(-1))},e.disconnect=function(e){var t=this,n=lS.get(e);n.observationTargets.slice().forEach((function(n){return t.unobserve(e,n.target)})),n.activeTargets.splice(0,n.activeTargets.length)},e}(),dS=function(){function e(e){if(0===arguments.length)throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");if("function"!=typeof e)throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");uS.connect(this,e)}return e.prototype.observe=function(e,t){if(0===arguments.length)throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");if(!BC(e))throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");uS.observe(this,e,t)},e.prototype.unobserve=function(e){if(0===arguments.length)throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");if(!BC(e))throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");uS.unobserve(this,e)},e.prototype.disconnect=function(){uS.disconnect(this)},e.toString=function(){return"function ResizeObserver () { [polyfill code] }"},e}(),pS=o(23598),fS={},hS=function(e,t){var n=m((0,i.useState)(null),2),r=n[0],o=n[1];return(0,i.useEffect)((function(){if(t)if(t&&t in fS)o((function(e){return e===fS[t]?e:fS[t]}));else{var n=new Image;n.src=t,n.onload=function(){fS[t]=n,o(n)}}else e&&o(e)}),[e,t]),r};function mS(){return(mS=Lo(Io().mark((function e(t){var n;return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=new Image,e.next=3,new Promise((function(e){n.addEventListener("load",(function(){return e()})),n.addEventListener("error",(function(){return e()})),n.src=t,n.complete&&n.naturalWidth>0&&e()}));case 3:return e.abrupt("return",n);case 4:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function gS(){var e={mappedImages:new Map,mappedPromises:new Map},t=e.mappedImages,n=e.mappedPromises;return Object.freeze({loadImage:function(e){var r=n.get(e);if(!r){var o=function(e){return mS.apply(this,arguments)}(e);return o.then((function(n){t.set(e,n)})),n.set(e,o),o}return r},hasImage:function(e){return t.has(e)},getImage:function(e){return t.get(e)||null}})}var vS=.977;function yS(e,t,n){return{left:n.x/e,top:n.y/t,right:(e-(n.x+n.width))/e,bottom:(t-(n.y+n.height))/t}}function bS(e,t,n){return{x:n.left*e,y:n.top*t,width:e-(n.left+n.right)*e,height:t-(n.top+n.bottom)*t}}function _S(e,t,n,r){var o=e/t,i=n/r,a=o>i?t*i:e,s=o>i?t:e/i;return{x:(e-a)/2,y:(t-s)/2,width:a,height:s}}function AS(e,t,r){var o=_S(e.image.width,e.image.height,e.rotation%2==0?t.width:t.height,e.rotation%2==0?t.height:t.width),i=o.width*Math.pow(vS,r),a=o.height*Math.pow(vS,r),s=bS(e.image.width,e.image.height,e.image.clippingMask),l={x:Math.min(e.image.width-i,Math.max(0,s.x+s.width/2-i/2)),y:Math.min(e.image.height-a,Math.max(0,s.y+s.height/2-a/2)),width:i,height:a};return n({},e,{image:n({},e.image,{clippingMask:yS(e.image.width,e.image.height,l)})})}var ES=function(e){var t=e.frame,r=e.previewBackground,o=e.previewEffects,a=e.width,s=e.height,l=e.project,c=e.pageSpecification,u=(0,i.useRef)(null),d=m((0,i.useState)(gS()),1)[0],p=m((0,i.useState)((function(){return(0,pS.createPresenter)(d)})),1)[0],f=window.devicePixelRatio,h=(0,i.useMemo)((function(){return{x:0,y:0,width:l.width,height:l.height,scale:1,contents:[{id:"0",type:"image",x:0,y:0,width:l.width,height:l.height,image:{url:l.image.url,width:l.image.width,height:l.image.height,rotation:l.rotation,clippingMask:{x:l.image.clippingMask.left*l.image.width,y:l.image.clippingMask.top*l.image.height,width:(1-l.image.clippingMask.left-l.image.clippingMask.right)*l.image.width,height:(1-l.image.clippingMask.top-l.image.clippingMask.bottom)*l.image.height}}}],product:c.product,productMasks:n({rotation:4-l.rotation%4},c.productMasks)}}),[l,c]),g=t||{},v=g.frameColor,y=g.frameImageUrl,b=g.frameOverlap,_=g.frameWidth,A=g.matColor,E=g.matHeight,w=g.matOverlap,x=g.matWidth,k=hS(v,y);return(0,i.useLayoutEffect)((function(){var e=u.current;if(e){var t=e.getContext("2d");if(t){var i=0;return function a(){if(t.save(),t.clearRect(0,0,e.width,e.height),t.translate(.5*e.width,.5*e.height),r){var s=r.rotation,l=void 0===s?0:s,c=r.scaleInBackground,u=void 0===c?1:c,f=r.translateX,m=void 0===f?0:f,g=r.translateY,v=void 0===g?0:g;t.translate(m*(e.width/2),v*(e.height/2)),t.rotate(l*Math.PI/180),t.scale(u,u)}var y=h.productMasks.rotation%2==0?h.product.width:h.product.height,C=h.productMasks.rotation%2==0?h.product.height:h.product.width,S="number"==typeof x&&!isNaN(x)&&x>0,M="number"==typeof _&&!isNaN(_)&&_>0,T=y,O=C;S&&M?(T=y+2*(_+x-(w||0)),O=C+2*(_+(null!=E?E:x)-(w||0))):M&&(T=y+2*((_||0)-(b||0)),O=C+2*((_||0)-(b||0)));var D=Math.min(e.width/(T*(M||S?1.15:1)),e.height/(O*(M||S?1.15:1)));t.scale(D,D),h.productMasks.rotation&&t.rotate(-h.productMasks.rotation*Math.PI/2),t.translate(-.5*h.product.width-h.product.x,-.5*h.product.height-h.product.y),(null!=o&&o.blackAndWhite||null!=o&&o.matte)&&(t.filter=(o.blackAndWhite?"grayscale(1)":"")+" "+(o.matte?"brightness(1.05) contrast(0.85)":""));var L=p.renderProductSync(e,n({},h,{scale:D})).loaded;if(_&&k&&kS(t,k,b||0,_,h,D,E||0,w||0,x||0,A),null!=r&&r.dropShadow){t.save(),t.globalCompositeOperation="destination-over";var P=h.productMasks.clipImageUrl?d.getImage(h.productMasks.clipImageUrl):null;wS(t,h.product.width,h.product.height,{shadowOffsetX:0,shadowOffsetY:3,shadowBlur:20,shadowColor:"rgba(0, 0, 0, 0.20)"},P),wS(t,h.product.width,h.product.height,{shadowOffsetX:0,shadowOffsetY:4,shadowBlur:4,shadowColor:"rgba(0, 0, 0, 0.36)"},P),t.restore()}if(null!=o&&o.transparent){t.save();var I=h.product.height/30,B=h.product.width/30;t.fillStyle="rgba(0, 0, 0, 0.20)",t.beginPath(),t.moveTo(0,0),t.lineTo(h.product.width,0),t.lineTo(h.product.width-B,I),t.lineTo(B,I),t.closePath(),t.fill(),t.beginPath(),t.moveTo(0,h.product.height),t.lineTo(h.product.width,h.product.height),t.lineTo(h.product.width-B,h.product.height-I),t.lineTo(B,h.product.height-I),t.closePath(),t.fill(),t.fillStyle="rgba(255, 255, 255, 0.50)",t.beginPath(),t.moveTo(h.product.width,0),t.lineTo(h.product.width-B,I),t.lineTo(h.product.width-B,h.product.height-I),t.lineTo(h.product.width,h.product.height),t.closePath(),t.fill(),t.beginPath(),t.moveTo(0,0),t.lineTo(B,I),t.lineTo(B,h.product.height-I),t.lineTo(0,h.product.height),t.closePath(),t.fill(),t.restore()}if(null!=o&&o.glossy||null!=o&&o.lustre){t.save();var R=function(e,t,n){var r=(125.57+90*n-90)*Math.PI/180,o=Math.sqrt(e*e+t*t);return{startX:e/2-Math.cos(r)*o/2,startY:t/2-Math.sin(r)*o/2,endX:e/2+Math.cos(r)*o/2,endY:t/2+Math.sin(r)*o/2}}(h.product.width,h.product.height,h.productMasks.rotation),N=R.startX,F=R.startY,j=R.endX,Y=R.endY;if(t.globalCompositeOperation="source-atop",o.glossy){var $=t.createLinearGradient(N,F,j,Y);$.addColorStop(.5118,"rgba(255, 255, 255, 0)"),$.addColorStop(.6521,"rgba(255, 255, 255, 0.4)"),$.addColorStop(.7853,"rgba(255, 255, 255, 0)"),t.fillStyle=$,t.fillRect(0,0,h.product.width,h.product.height)}if(o.lustre){var H=t.createLinearGradient(N,F,j,Y);H.addColorStop(.313,"rgba(255, 255, 255, 0)"),H.addColorStop(.6521,"rgba(255, 255, 255, 0.3)"),H.addColorStop(.986,"rgba(255, 255, 255, 0)"),t.fillStyle=H,t.fillRect(0,0,h.product.width,h.product.height)}t.restore()}t.restore(),L||(i=requestAnimationFrame(a))}(),function(){cancelAnimationFrame(i)}}}}),[a,s,d,u,h,p,r,o,c.width,k,b,_,E,w,x,A]),i.createElement("canvas",{ref:u,width:a*f,height:s*f,style:n({},(null==r?void 0:r.backgroundUrl)&&{backgroundImage:'url("'+r.backgroundUrl+'")',backgroundSize:"100%"},{width:a+"px",height:s+"px"})})},wS=function(e,t,n,r,o){e.save();var i=r.shadowOffsetX,a=r.shadowOffsetY,s=r.shadowBlur,l=r.shadowColor;e.shadowOffsetX=i,e.shadowOffsetY=a,e.shadowBlur=s,e.shadowColor=l,o?t>n?(e.translate(t/2,n/2),e.rotate(Math.PI/2),e.translate(-n/2,-t/2),e.drawImage(o,0,0,n,t)):e.drawImage(o,0,0,t,n):e.fillRect(0,0,t,n),e.restore()},xS=function(e,t,n,r,o,i,a,s,l,c){"string"==typeof c||c instanceof String?(e.fillStyle=c,e.fillRect(i,a,s,l)):c instanceof HTMLImageElement&&e.drawImage(c,t,n,r,o,i,a,s,l)},kS=function(e,t,n,r,o,i){var a=arguments.length>6&&void 0!==arguments[6]?arguments[6]:0,s=arguments.length>7&&void 0!==arguments[7]?arguments[7]:0,l=arguments.length>8&&void 0!==arguments[8]?arguments[8]:0,c=arguments.length>9?arguments[9]:void 0;e.save();var u,d,p,f,h,m,g,v,y=!isNaN(l)&&l>0&&!!c,b=r-n,_=l-s,A=a-s,E=y?o.product.width+2*(r+_):o.product.width+2*b,w=y?o.product.height+2*(r+A):o.product.height+2*b,x=Math.max(E,w),k=t instanceof HTMLImageElement?null==t?void 0:t.naturalWidth:1,C=t instanceof HTMLImageElement?null==t?void 0:t.naturalHeight:1,S=k/C,M=Math.max(x,r*S),T=Math.max(r,x/S),O=0+o.product.width,D=0+o.product.height;y?(u=[0-r-_,0-r-A],d=[O+r+_,0-r-A],p=[0-r-_,D+r+A],f=[O+r+_,D+r+A],h=[0-_,0-A],m=[O+_,0-A],g=[0-_,D+A],v=[O+_,D+A],e.save(),e.globalCompositeOperation="destination-over",e.fillStyle=c,e.fillRect.apply(e,h.concat([o.product.width+2*_,o.product.height+2*A])),e.restore()):(u=[0-b,0-b],d=[O+b,0-b],p=[0-b,D+b],f=[O+b,D+b],h=[0+n,0+n],m=[O-n,0+n],g=[0+n,D-n],v=[O-n,D-n]),e.beginPath(),e.moveTo.apply(e,u),e.lineTo.apply(e,d),e.lineTo.apply(e,m),e.lineTo.apply(e,h),e.closePath(),e.clip(),xS.apply(void 0,[e,0,0,k,C].concat(u,[M,T,t])),e.restore(),e.save(),e.beginPath(),e.moveTo.apply(e,p),e.lineTo.apply(e,f),e.lineTo.apply(e,v),e.lineTo.apply(e,g),e.closePath(),e.clip(),xS(e,0,0,k,C,p[0],g[1],M,T,t),e.restore(),e.save(),e.beginPath(),e.moveTo.apply(e,u),e.lineTo.apply(e,h),e.lineTo.apply(e,g),e.lineTo.apply(e,p),e.closePath(),e.clip(),e.translate.apply(e,p),e.rotate(-90*Math.PI/180),xS(e,0,0,k,C,0,0,M,T,t),e.restore(),e.save(),e.beginPath(),e.moveTo.apply(e,m),e.lineTo.apply(e,d),e.lineTo.apply(e,f),e.lineTo.apply(e,v),e.closePath(),e.clip(),e.translate.apply(e,d),e.rotate(90*Math.PI/180),xS(e,0,0,k,C,0,0,M,T,t),e.restore();var L="0, 0, 0",P="255, 255, 255";e.save(),e.translate.apply(e,u),e.fillStyle="rgba("+P+", 0.25)",wS(e,E,1/i,{shadowBlur:.05*r*i,shadowColor:"rgba("+P+", 1)",shadowOffsetX:0,shadowOffsetY:.05*r*i},null),e.restore(),e.save(),e.translate.apply(e,u),e.globalCompositeOperation="destination-over",e.fillStyle="rgba("+L+", 0.36)",wS(e,E,w,{shadowBlur:.05*r*i,shadowColor:"rgba("+L+", 1)",shadowOffsetX:0,shadowOffsetY:.05*r*i},null),e.restore(),e.save(),e.translate.apply(e,u),e.globalCompositeOperation="destination-over",e.fillStyle="rgba("+L+", 0.2)",wS(e,E,w,{shadowBlur:.25*r*i,shadowColor:"rgba("+L+", 1)",shadowOffsetX:0,shadowOffsetY:.035*r*i},null),e.restore(),e.save(),e.translate.apply(e,h),e.fillStyle="rgba(0, 0, 0, 0.3)";var I=y?o.product.width+2*_:o.product.width-2*n;wS(e,I,1/i,{shadowBlur:.04*r*i,shadowColor:"rgba("+L+", 1)",shadowOffsetX:0,shadowOffsetY:.04*r*i},null),e.restore();var B=y?o.product.height+2*A:o.product.height-2*n;e.save(),e.translate.apply(e,h),e.fillStyle="rgba(0, 0, 0, 0.3)",wS(e,1/i,B,{shadowBlur:.04*r*i,shadowColor:"rgba("+L+", 1)",shadowOffsetX:.04*r*i,shadowOffsetY:0},null),e.restore(),e.save(),e.translate.apply(e,m),e.fillStyle="rgba(0, 0, 0, 0.3)",wS(e,1/i,B,{shadowBlur:.04*r*i,shadowColor:"rgba("+L+", 1)",shadowOffsetX:-.04*r*i,shadowOffsetY:0},null),e.restore()};ES.displayName="Preview";const CS=ES;var SS=[-1,8],MS=0,TS=0,OS=90,DS=90;function LS(e,t,n,r){var o=t.getBoundingClientRect(),i=o.left,a=o.top,s=(e.pageX-i)*window.devicePixelRatio,l=(e.pageY-a)*window.devicePixelRatio,c=Math.min((t.width-window.devicePixelRatio*(MS+TS))/r.width,(t.height-window.devicePixelRatio*(OS+DS))/r.height),u=(s-.5*t.width)/c,d=(l-.5*t.height)/c,p=u*Math.cos(n*Math.PI/2)-d*Math.sin(n*Math.PI/2),f=u*Math.sin(n*Math.PI/2)+d*Math.cos(n*Math.PI/2);return{x:p+.5*r.width,y:f+.5*r.height}}var PS=function(e){var t=e.frame,r=e.renderSpecification,o=e.viewport,a=e.isRoundCrop,s=e.onPointerDown,l=e.onPointerMove,c=e.onPointerUp,u=e.onPointerCancel,d=(0,i.useRef)(null),p=(0,i.useRef)(null),f=(0,i.useRef)(gS()),h=m((0,i.useState)((function(){return(0,pS.createPresenter)(f.current)})),1)[0],g=m((0,i.useState)(100),2),v=g[0],y=g[1],b=m((0,i.useState)(100),2),_=b[0],A=b[1],E=t||{},w=E.frameColor,x=E.frameImageUrl,k=E.frameOverlap,C=E.frameWidth,S=E.matColor,M=E.matHeight,T=E.matOverlap,O=E.matWidth,D=hS(w,x);(0,i.useEffect)((function(){var e;return d.current&&(e=new dS((function(){var e=d.current,t=p.current;e&&t&&(y(e.clientWidth),A(e.clientHeight))})),e.observe(d.current)),function(){var t;null===(t=e)||void 0===t||t.disconnect()}}),[]),(0,i.useLayoutEffect)((function(){var e=p.current;if(e){var t=e.getContext("2d");if(t){var i=0;return function s(){t.save(),t.clearRect(0,0,e.width,e.height);var l=Math.min((e.width-window.devicePixelRatio*(MS+TS))/o.width,(e.height-window.devicePixelRatio*(OS+DS))/o.height);t.translate(.5*e.width,.5*e.height),t.scale(l,l),r.productMasks.rotation&&t.rotate(-r.productMasks.rotation*Math.PI/2),t.translate(-.5*o.width-o.x,-.5*o.height-o.y);var c=h.renderProductSync(e,n({},r,{scale:l})).loaded;t.save(),r.contents.forEach((function(n){if(n.ghostImage){var r=n.image.rotation%2==1,o=r?n.height/n.image.clippingMask.width:n.width/n.image.clippingMask.width,i=r?n.width/n.image.clippingMask.height:n.height/n.image.clippingMask.height;if(t.save(),t.translate(n.x,n.y),n.image.rotation){var s=n.width/2,c=n.height/2;t.translate(s,c),t.rotate(-n.image.rotation*Math.PI/2),t.translate(r?-c:-s,r?-s:-c)}var u=f.current.getImage(n.image.url);u&&u.width>0&&u.height>0&&(t.globalAlpha=.45,t.drawImage(u,0,0,u.width,u.height,-n.image.clippingMask.x*o,-n.image.clippingMask.y*i,n.image.width*o,n.image.height*i)),t.restore()}if(n.selected&&(!C||n.ghostImage)){var d=e.width/e.clientWidth/l;t.beginPath(),t.lineWidth=d,t.strokeStyle="white",t.moveTo(n.x+n.width/3,n.y+d),t.lineTo(n.x+n.width/3,n.y+n.height-d),t.moveTo(n.x+2*n.width/3,n.y+d),t.lineTo(n.x+2*n.width/3,n.y+n.height-d),t.moveTo(n.x+d,n.y+n.height/3),t.lineTo(n.x+n.width-d,n.y+n.height/3),t.moveTo(n.x+d,n.y+2*n.height/3),t.lineTo(n.x+n.width-d,n.y+2*n.height/3),t.stroke(),t.lineWidth=2*d,t.strokeStyle="#FF7D73";var p=n.x+d,h=n.y+d,m=n.width-2*d,g=n.height-2*d;if(a){var v=m/2,y=g/2;t.beginPath(),t.ellipse(p+v,h+y,v,y,0,0,2*Math.PI),t.stroke()}else t.strokeRect(p,h,m,g)}})),C&&D&&kS(t,D,null!=k?k:0,C,r,l,M||0,T||0,O||0,S),t.restore(),t.restore(),c||(i=requestAnimationFrame(s))}(),function(){cancelAnimationFrame(i)}}}}),[p,v,_,r,o,a,h,C,k,D,M,T,O,S]);var L=(0,i.useCallback)((function(e){if(0===e.button){var t=p.current;t&&(t.setPointerCapture(e.pointerId),s(e,LS(e,t,r.productMasks.rotation,o)))}}),[s,r.productMasks.rotation,o]),P=(0,i.useCallback)((function(e){p.current&&l(e,LS(e,p.current,r.productMasks.rotation,o))}),[l,r.productMasks.rotation,o]),I=(0,i.useCallback)((function(e){0===e.button&&p.current&&c(e,LS(e,p.current,r.productMasks.rotation,o))}),[c,r.productMasks.rotation,o]);return i.createElement(_r,{position:"absolute",left:"0",right:"0",top:"0",bottom:"0",overflow:"hidden",ref:d},i.createElement("canvas",{ref:p,"data-testid":"sp-ui-editor-canvas",width:v*window.devicePixelRatio,height:_*window.devicePixelRatio,style:{width:v+"px",height:_+"px",touchAction:"none"},onPointerDown:L,onPointerMove:P,onPointerUp:I,onPointerCancel:u}))};PS.displayName="EditorCanvas";const IS=(0,i.memo)(PS);var BS=e=>e?"":void 0,RS=e=>!!e||void 0,NS=(...e)=>e.filter(Boolean).join(" ");function FS(...e){return function(t){e.some((e=>(null==e||e(t),null==t?void 0:t.defaultPrevented)))}}function jS(e){const{orientation:t,vertical:n,horizontal:r}=e;return"vertical"===t?n:r}var YS={width:0,height:0},$S=e=>e||YS;function HS(e){const t=function(e){var t;return null!=(t=e.view)?t:window}(e);return void 0!==t.PointerEvent&&e instanceof t.PointerEvent?!("mouse"!==e.pointerType):e instanceof t.MouseEvent}function US(e){return!!e.touches}function zS(e,t="page"){return US(e)?function(e,t="page"){const n=e.touches[0]||e.changedTouches[0];return{x:n[`${t}X`],y:n[`${t}Y`]}}(e,t):function(e,t="page"){return{x:e[`${t}X`],y:e[`${t}Y`]}}(e,t)}function WS(e,t=!1){function n(t){e(t,{point:zS(t)})}const r=t?function(e){return t=>{const n=HS(t);(!n||n&&0===t.button)&&e(t)}}(n):n;return r}function VS(e,t,n,r){return function(e,t,n,r){return e.addEventListener(t,n,r),()=>{e.removeEventListener(t,n,r)}}(e,t,WS(n,"pointerdown"===t),r)}const GS=1/60*1e3,QS="undefined"!=typeof performance?()=>performance.now():()=>Date.now(),qS="undefined"!=typeof window?e=>window.requestAnimationFrame(e):e=>setTimeout((()=>e(QS())),GS);let KS=!0,ZS=!1,JS=!1;const XS={delta:0,timestamp:0},eM=["read","update","preRender","render","postRender"],tM=eM.reduce(((e,t)=>(e[t]=function(e){let t=[],n=[],r=0,o=!1,i=!1;const a=new WeakSet,s={schedule:(e,i=!1,s=!1)=>{const l=s&&o,c=l?t:n;return i&&a.add(e),-1===c.indexOf(e)&&(c.push(e),l&&o&&(r=t.length)),e},cancel:e=>{const t=n.indexOf(e);-1!==t&&n.splice(t,1),a.delete(e)},process:l=>{if(o)i=!0;else{if(o=!0,[t,n]=[n,t],n.length=0,r=t.length,r)for(let n=0;n<r;n++){const r=t[n];r(l),a.has(r)&&(s.schedule(r),e())}o=!1,i&&(i=!1,s.process(l))}}};return s}((()=>ZS=!0)),e)),{}),nM=eM.reduce(((e,t)=>{const n=tM[t];return e[t]=(e,t=!1,r=!1)=>(ZS||aM(),n.schedule(e,t,r)),e}),{}),rM=eM.reduce(((e,t)=>(e[t]=tM[t].cancel,e)),{}),oM=(eM.reduce(((e,t)=>(e[t]=()=>tM[t].process(XS),e)),{}),e=>tM[e].process(XS)),iM=e=>{ZS=!1,XS.delta=KS?GS:Math.max(Math.min(e-XS.timestamp,40),1),XS.timestamp=e,JS=!0,eM.forEach(oM),JS=!1,ZS&&(KS=!1,qS(iM))},aM=()=>{ZS=!0,KS=!0,JS||qS(iM)},sM=()=>XS,lM=nM;var cM=Object.defineProperty,uM=(e,t,n)=>(((e,t,n)=>{t in e?cM(e,t,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[t]=n})(e,"symbol"!=typeof t?t+"":t,n),n),dM=class{constructor(e,t,n){var r;if(uM(this,"history",[]),uM(this,"startEvent",null),uM(this,"lastEvent",null),uM(this,"lastEventInfo",null),uM(this,"handlers",{}),uM(this,"removeListeners",(()=>{})),uM(this,"threshold",3),uM(this,"win"),uM(this,"updatePoint",(()=>{if(!this.lastEvent||!this.lastEventInfo)return;const e=fM(this.lastEventInfo,this.history),t=null!==this.startEvent,n=function(e,t){if("number"==typeof e&&"number"==typeof t)return gM(e,t);if(vM(e)&&vM(t)){const n=gM(e.x,t.x),r=gM(e.y,t.y);return Math.sqrt(n**2+r**2)}return 0}(e.offset,{x:0,y:0})>=this.threshold;if(!t&&!n)return;const{timestamp:r}=sM();this.history.push({...e.point,timestamp:r});const{onStart:o,onMove:i}=this.handlers;t||(null==o||o(this.lastEvent,e),this.startEvent=this.lastEvent),null==i||i(this.lastEvent,e)})),uM(this,"onPointerMove",((e,t)=>{this.lastEvent=e,this.lastEventInfo=t,lM.update(this.updatePoint,!0)})),uM(this,"onPointerUp",((e,t)=>{const n=fM(t,this.history),{onEnd:r,onSessionEnd:o}=this.handlers;null==o||o(e,n),this.end(),r&&this.startEvent&&(null==r||r(e,n))})),this.win=null!=(r=e.view)?r:window,function(e){return US(e)&&e.touches.length>1}(e))return;this.handlers=t,n&&(this.threshold=n),e.stopPropagation(),e.preventDefault();const o={point:zS(e)},{timestamp:i}=sM();this.history=[{...o.point,timestamp:i}];const{onSessionStart:a}=t;null==a||a(e,fM(o,this.history)),this.removeListeners=function(...e){return t=>e.reduce(((e,t)=>t(e)),t)}(VS(this.win,"pointermove",this.onPointerMove),VS(this.win,"pointerup",this.onPointerUp),VS(this.win,"pointercancel",this.onPointerUp))}updateHandlers(e){this.handlers=e}end(){var e;null==(e=this.removeListeners)||e.call(this),rM.update(this.updatePoint)}};function pM(e,t){return{x:e.x-t.x,y:e.y-t.y}}function fM(e,t){return{point:e.point,delta:pM(e.point,t[t.length-1]),offset:pM(e.point,t[0]),velocity:mM(t,.1)}}var hM=e=>1e3*e;function mM(e,t){if(e.length<2)return{x:0,y:0};let n=e.length-1,r=null;const o=e[e.length-1];for(;n>=0&&(r=e[n],!(o.timestamp-r.timestamp>hM(t)));)n--;if(!r)return{x:0,y:0};const i=(o.timestamp-r.timestamp)/1e3;if(0===i)return{x:0,y:0};const a={x:(o.x-r.x)/i,y:(o.y-r.y)/i};return a.x===1/0&&(a.x=0),a.y===1/0&&(a.y=0),a}function gM(e,t){return Math.abs(e-t)}function vM(e){return"x"in e&&"y"in e}function yM(e){const t=(0,i.useRef)(null);return t.current=e,t}function bM(e){const{value:t,defaultValue:n,onChange:r,shouldUpdate:o=((e,t)=>e!==t)}=e,a=zh(r),s=zh(o),[l,c]=(0,i.useState)(n),u=void 0!==t,d=u?t:l,p=zh((e=>{const t="function"==typeof e?e(d):e;s(d,t)&&(u||c(t),a(t))}),[u,a,d,s]);return[d,p]}var _M=Boolean(null==globalThis?void 0:globalThis.document)?i.useLayoutEffect:i.useEffect;function AM({getNodes:e,observeMutation:t=!0}){const[n,r]=(0,i.useState)([]),[o,a]=(0,i.useState)(0);return _M((()=>{const n=e(),o=n.map(((e,t)=>function(e,t){if(!e)return void t(void 0);t({width:e.offsetWidth,height:e.offsetHeight});const n=new(e.ownerDocument.defaultView??window).ResizeObserver((n=>{if(!Array.isArray(n)||!n.length)return;const[r]=n;let o,i;if("borderBoxSize"in r){const e=r.borderBoxSize,t=Array.isArray(e)?e[0]:e;o=t.inlineSize,i=t.blockSize}else o=e.offsetWidth,i=e.offsetHeight;t({width:o,height:i})}));return n.observe(e,{box:"border-box"}),()=>n.unobserve(e)}(e,(e=>{r((n=>[...n.slice(0,t),e,...n.slice(t+1)]))}))));if(t){const e=n[0];o.push(function(e,t){var n,r;if(!e||!e.parentElement)return;const o=new(null!=(r=null==(n=e.ownerDocument)?void 0:n.defaultView)?r:window).MutationObserver((()=>{t()}));return o.observe(e.parentElement,{childList:!0}),()=>{o.disconnect()}}(e,(()=>{a((e=>e+1))})))}return()=>{o.forEach((e=>{null==e||e()}))}}),[o]),n}function EM(e,t){let n=function(e){const t=parseFloat(e);return"number"!=typeof t||Number.isNaN(t)?0:t}(e);const r=10**(null!=t?t:10);return n=Math.round(n*r)/r,t?n.toFixed(t):n.toString()}function wM(e){if(!Number.isFinite(e))return 0;let t=1,n=0;for(;Math.round(e*t)/t!==e;)t*=10,n+=1;return n}function xM(e,t,n){return 100*(e-t)/(n-t)}function kM(e,t,n){return EM(Math.round((e-t)/n)*n+t,wM(n))}function CM(e,t,n){return null==e?e:(n<t&&console.warn("clamp: max cannot be less than min"),Math.min(Math.max(e,t),n))}function SM(e){var t;const{min:n=0,max:r=100,onChange:o,value:a,defaultValue:s,isReversed:l,direction:c="ltr",orientation:u="horizontal",id:d,isDisabled:p,isReadOnly:f,onChangeStart:h,onChangeEnd:m,step:g=1,getAriaValueText:v,"aria-valuetext":y,"aria-label":b,"aria-labelledby":_,name:A,focusThumbOnChange:E=!0,...w}=e,x=zh(h),k=zh(m),C=zh(v),S=function(e){const{isReversed:t,direction:n,orientation:r}=e;return"ltr"===n||"vertical"===r?t:!t}({isReversed:l,direction:c,orientation:u}),[M,T]=bM({value:a,defaultValue:null!=s?s:TM(n,r),onChange:o}),[O,D]=(0,i.useState)(!1),[L,P]=(0,i.useState)(!1),I=!(p||f),B=(r-n)/10,R=g||(r-n)/100,N=CM(M,n,r),F=xM(S?r-N+n:N,n,r),j="vertical"===u,Y=yM({min:n,max:r,step:g,isDisabled:p,value:N,isInteractive:I,isReversed:S,isVertical:j,eventSource:null,focusThumbOnChange:E,orientation:u}),$=(0,i.useRef)(null),H=(0,i.useRef)(null),U=(0,i.useRef)(null),z=(0,i.useId)(),W=null!=d?d:z,[V,G]=[`slider-thumb-${W}`,`slider-track-${W}`],Q=(0,i.useCallback)((e=>{var t,n;if(!$.current)return;const r=Y.current;r.eventSource="pointer";const o=$.current.getBoundingClientRect(),{clientX:i,clientY:a}=null!=(n=null==(t=e.touches)?void 0:t[0])?n:e;let s=(j?o.bottom-a:i-o.left)/(j?o.height:o.width);S&&(s=1-s);let l=function(e,t,n){return(n-t)*e+t}(s,r.min,r.max);return r.step&&(l=parseFloat(kM(l,r.min,r.step))),l=CM(l,r.min,r.max),l}),[j,S,Y]),q=(0,i.useCallback)((e=>{const t=Y.current;t.isInteractive&&(e=CM(e=parseFloat(kM(e,t.min,R)),t.min,t.max),T(e))}),[R,T,Y]),K=(0,i.useMemo)((()=>({stepUp(e=R){q(S?N-e:N+e)},stepDown(e=R){q(S?N+e:N-e)},reset(){q(s||0)},stepTo(e){q(e)}})),[q,S,N,R,s]),Z=(0,i.useCallback)((e=>{const t=Y.current,n={ArrowRight:()=>K.stepUp(),ArrowUp:()=>K.stepUp(),ArrowLeft:()=>K.stepDown(),ArrowDown:()=>K.stepDown(),PageUp:()=>K.stepUp(B),PageDown:()=>K.stepDown(B),Home:()=>q(t.min),End:()=>q(t.max)}[e.key];n&&(e.preventDefault(),e.stopPropagation(),n(e),t.eventSource="keyboard")}),[K,q,B,Y]),J=null!=(t=null==C?void 0:C(N))?t:y,X=function(e){const[t]=AM({observeMutation:!1,getNodes(){var t;return["object"==typeof(t=e)&&null!==t&&"current"in t?e.current:e]}});return t}(H),{getThumbStyle:ee,rootStyle:te,trackStyle:ne,innerTrackStyle:re}=(0,i.useMemo)((()=>{const e=Y.current,t=null!=X?X:{width:0,height:0};return function(e){const{orientation:t,thumbPercents:n,thumbRects:r,isReversed:o}=e,i="vertical"===t?r.reduce(((e,t)=>$S(e).height>$S(t).height?e:t),YS):r.reduce(((e,t)=>$S(e).width>$S(t).width?e:t),YS),a={position:"relative",touchAction:"none",WebkitTapHighlightColor:"rgba(0,0,0,0)",userSelect:"none",outline:0,...jS({orientation:t,vertical:i?{paddingLeft:i.width/2,paddingRight:i.width/2}:{},horizontal:i?{paddingTop:i.height/2,paddingBottom:i.height/2}:{}})},s={position:"absolute",...jS({orientation:t,vertical:{left:"50%",transform:"translateX(-50%)",height:"100%"},horizontal:{top:"50%",transform:"translateY(-50%)",width:"100%"}})},l=1===n.length,c=[0,o?100-n[0]:n[0]],u=l?c:n;let d=u[0];!l&&o&&(d=100-d);const p=Math.abs(u[u.length-1]-u[0]);return{trackStyle:s,innerTrackStyle:{...s,...jS({orientation:t,vertical:o?{height:`${p}%`,top:`${d}%`}:{height:`${p}%`,bottom:`${d}%`},horizontal:o?{width:`${p}%`,right:`${d}%`}:{width:`${p}%`,left:`${d}%`}})},rootStyle:a,getThumbStyle:e=>{var o;const i=null!=(o=r[e])?o:YS;return{position:"absolute",userSelect:"none",WebkitUserSelect:"none",MozUserSelect:"none",msUserSelect:"none",touchAction:"none",...jS({orientation:t,vertical:{bottom:`calc(${n[e]}% - ${i.height/2}px)`},horizontal:{left:`calc(${n[e]}% - ${i.width/2}px)`}})}}}}({isReversed:S,orientation:e.orientation,thumbRects:[t],thumbPercents:[F]})}),[S,X,F,Y]),oe=(0,i.useCallback)((()=>{Y.current.focusThumbOnChange&&setTimeout((()=>{var e;return null==(e=H.current)?void 0:e.focus()}))}),[Y]);function ie(e){const t=Q(e);null!=t&&t!==Y.current.value&&T(t)}qx((()=>{const e=Y.current;oe(),"keyboard"===e.eventSource&&(null==k||k(e.value))}),[N,k]),function(e,t){const{onPan:n,onPanStart:r,onPanEnd:o,onPanSessionStart:a,onPanSessionEnd:s,threshold:l}=t,c=Boolean(n||r||o||a||s),u=(0,i.useRef)(null),d=yM({onSessionStart:a,onSessionEnd:s,onStart:r,onMove:n,onEnd(e,t){u.current=null,null==o||o(e,t)}});(0,i.useEffect)((()=>{var e;null==(e=u.current)||e.updateHandlers(d.current)})),(0,i.useEffect)((()=>{const t=e.current;if(t&&c)return VS(t,"pointerdown",(function(e){u.current=new dM(e,d.current,l)}))}),[e,c,d,l]),(0,i.useEffect)((()=>()=>{var e;null==(e=u.current)||e.end(),u.current=null}),[])}(U,{onPanSessionStart(e){const t=Y.current;t.isInteractive&&(D(!0),oe(),ie(e),null==x||x(t.value))},onPanSessionEnd(){const e=Y.current;e.isInteractive&&(D(!1),null==k||k(e.value))},onPan(e){Y.current.isInteractive&&ie(e)}});const ae=(0,i.useCallback)(((e={},t=null)=>({...e,...w,ref:Ur(t,U),tabIndex:-1,"aria-disabled":RS(p),"data-focused":BS(L),style:{...e.style,...te}})),[w,p,L,te]),se=(0,i.useCallback)(((e={},t=null)=>({...e,ref:Ur(t,$),id:G,"data-disabled":BS(p),style:{...e.style,...ne}})),[p,G,ne]),le=(0,i.useCallback)(((e={},t=null)=>({...e,ref:t,style:{...e.style,...re}})),[re]),ce=(0,i.useCallback)(((e={},t=null)=>({...e,ref:Ur(t,H),role:"slider",tabIndex:I?0:void 0,id:V,"data-active":BS(O),"aria-valuetext":J,"aria-valuemin":n,"aria-valuemax":r,"aria-valuenow":N,"aria-orientation":u,"aria-disabled":RS(p),"aria-readonly":RS(f),"aria-label":b,"aria-labelledby":b?void 0:_,style:{...e.style,...ee(0)},onKeyDown:FS(e.onKeyDown,Z),onFocus:FS(e.onFocus,(()=>P(!0))),onBlur:FS(e.onBlur,(()=>P(!1)))})),[I,V,O,J,n,r,N,u,p,f,b,_,ee,Z]),ue=(0,i.useCallback)(((e,t=null)=>{const o=!(e.value<n||e.value>r),i=N>=e.value,a=xM(e.value,n,r),s={position:"absolute",pointerEvents:"none",...MM({orientation:u,vertical:{bottom:S?100-a+"%":`${a}%`},horizontal:{left:S?100-a+"%":`${a}%`}})};return{...e,ref:t,role:"presentation","aria-hidden":!0,"data-disabled":BS(p),"data-invalid":BS(!o),"data-highlighted":BS(i),style:{...e.style,...s}}}),[p,S,r,n,u,N]),de=(0,i.useCallback)(((e={},t=null)=>({...e,ref:t,type:"hidden",value:N,name:A})),[A,N]);return{state:{value:N,isFocused:L,isDragging:O},actions:K,getRootProps:ae,getTrackProps:se,getInnerTrackProps:le,getThumbProps:ce,getMarkerProps:ue,getInputProps:de}}function MM(e){const{orientation:t,vertical:n,horizontal:r}=e;return"vertical"===t?n:r}function TM(e,t){return t<e?e:e+(t-e)/2}var[OM,DM]=xr({name:"SliderContext",hookName:"useSliderContext",providerName:"<Slider />"}),[LM,PM]=xr({name:"SliderStylesContext",hookName:"useSliderStyles",providerName:"<Slider />"}),IM=yr(((e,t)=>{var n;const r={...e,orientation:null!=(n=null==e?void 0:e.orientation)?n:"horizontal"},o=jr("Slider",r),i=pt(r),{direction:a}=Lr();i.direction=a;const{getInputProps:s,getRootProps:l,...c}=SM(i),u=l(),d=s({},t);return(0,br.jsx)(OM,{value:c,children:(0,br.jsx)(LM,{value:o,children:(0,br.jsxs)(vr.div,{...u,className:NS("chakra-slider",r.className),__css:o.container,children:[r.children,(0,br.jsx)("input",{...d})]})})})}));IM.displayName="Slider";var BM=yr(((e,t)=>{const{getThumbProps:n}=DM(),r=PM(),o=n(e,t);return(0,br.jsx)(vr.div,{...o,className:NS("chakra-slider__thumb",e.className),__css:r.thumb})}));BM.displayName="SliderThumb";var RM=yr(((e,t)=>{const{getTrackProps:n}=DM(),r=PM(),o=n(e,t);return(0,br.jsx)(vr.div,{...o,className:NS("chakra-slider__track",e.className),__css:r.track})}));RM.displayName="SliderTrack";var NM=yr(((e,t)=>{const{getInnerTrackProps:n}=DM(),r=PM(),o=n(e,t);return(0,br.jsx)(vr.div,{...o,className:NS("chakra-slider__filled-track",e.className),__css:r.filledTrack})}));NM.displayName="SliderFilledTrack";var FM=yr(((e,t)=>{const{getMarkerProps:n}=DM(),r=PM(),o=n(e,t);return(0,br.jsx)(vr.div,{...o,className:NS("chakra-slider__marker",e.className),__css:r.mark})}));FM.displayName="SliderMark";var jM=fr(wr)((function(e){var t=e.theme,n=t.responsive.mediumScreenUp;return"\n        position: absolute;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        height: 88px;\n        align-items: flex-start;\n        padding: "+t.spacing.md+";\n        margin: 0;\n        background-color: white;\n\n        "+n("\n            height: 80px;\n            padding: "+t.gutters.sm+";\n        ")+"\n    "})),YM=fr(wr)((function(e){var t=e.theme,n=t.responsive.mediumScreenUp;return"\n        width: 100%;\n        max-width: 350px;\n        height: 56px;\n        justify-content: space-between;\n        align-items: center;\n        padding: "+t.spacing.md+";\n        margin-left: auto;\n        margin-right: auto;\n\n        "+n("\n          padding: "+t.gutters.sm+";\n        ")+"\n    "})),$M=fr(qr)((function(e){var t=e.theme;return"\n        text-align: right;\n        font-weight: "+t.fontWeights.semibold+";\n        color: "+t.colors.gray[700]+";\n        margin: auto;\n    "})),HM=function(e){var t=e.size,n=e.onSizeChangeEnd,r=e.onSizeChange;return i.createElement(jM,{"data-testid":"sp-ui-editor-editbar"},i.createElement(YM,null,i.createElement(IM,{"aria-label":"Scale Image",onChangeEnd:n,onChange:r,value:t,maxWidth:269},i.createElement(RM,null,i.createElement(NM,null)),i.createElement(BM,null)),i.createElement($M,{"aria-label":"Scale Value",size:"sm"},t,"%")))};HM.displayName="EditorEditbar";const UM=(0,i.memo)(HM);function zM(e,t){return t||(t=e.slice(0)),e.raw=t,e}var WM,VM,GM=yr((function(e,t){const{borderLeftWidth:n,borderBottomWidth:r,borderTopWidth:o,borderRightWidth:i,borderWidth:a,borderStyle:s,borderColor:l,...c}=Fr("Divider",e),{className:u,orientation:d="horizontal",__css:p,...f}=pt(e),h={vertical:{borderLeftWidth:n||i||a||"1px",height:"100%"},horizontal:{borderBottomWidth:r||o||a||"1px",width:"100%"}};return(0,br.jsx)(vr.hr,{ref:t,"aria-orientation":d,...f,__css:{...c,border:"0",borderColor:l,borderStyle:s,...h[d],...p},className:g("chakra-divider",u)})}));GM.displayName="Divider";var QM=["title","titleId"];function qM(){return qM=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},qM.apply(null,arguments)}var KM=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,QM);return i.createElement("svg",qM({width:24,height:24,viewBox:"0 0 24 24",stroke:"#677F89",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,WM||(WM=i.createElement("path",{d:"M9 14L4 9L9 4",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"})),VM||(VM=i.createElement("path",{d:"M20 20V13C20 11.9391 19.5786 10.9217 18.8284 10.1716C18.0783 9.42143 17.0609 9 16 9H4",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"})))},ZM=(0,i.forwardRef)(KM);o.p;var JM,XM,eT=["title","titleId"];function tT(){return tT=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},tT.apply(null,arguments)}var nT=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,eT);return i.createElement("svg",tT({width:24,height:24,viewBox:"0 0 24 24",stroke:"#677F89",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,JM||(JM=i.createElement("path",{d:"M15 14L20 9L15 4",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"})),XM||(XM=i.createElement("path",{d:"M4 20V13C4 11.9391 4.42143 10.9217 5.17157 10.1716C5.92172 9.42143 6.93913 9 8 9H20",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"})))},rT=(0,i.forwardRef)(nT);o.p;var oT,iT,aT,sT=["title","titleId"];function lT(){return lT=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},lT.apply(null,arguments)}var cT=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,sT);return i.createElement("svg",lT({width:24,height:24,viewBox:"0 0 24 24",stroke:"#677F89",fill:"#677F89",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,oT||(oT=i.createElement("rect",{width:12,height:15,transform:"matrix(1 0 0 -1 2 19)",fill:"none",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"})),iT||(iT=i.createElement("path",{d:"M22.5172 16H17.4828C17.3047 16 17.2154 15.7846 17.3414 15.6586L19.8586 13.1414C19.9367 13.0633 20.0633 13.0633 20.1414 13.1414L22.6586 15.6586C22.7846 15.7846 22.6953 16 22.5172 16Z",stroke:"none"})),aT||(aT=i.createElement("path",{d:"M16 23C15.4477 23 15 22.5523 15 22C15 21.4477 15.4477 21 16 21V23ZM16 21H18V23H16V21ZM19 20V16H21V20H19ZM18 21C18.5523 21 19 20.5523 19 20H21C21 21.6569 19.6569 23 18 23V21Z",stroke:"none"})))},uT=(0,i.forwardRef)(cT);o.p;var dT,pT,fT,hT=["title","titleId"];function mT(){return mT=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},mT.apply(null,arguments)}var gT=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,hT);return i.createElement("svg",mT({width:24,height:24,viewBox:"0 0 24 24",stroke:"#677F89",fill:"#677F89",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,dT||(dT=i.createElement("path",{d:"M1 5L1 17H16V5L1 5Z",fill:"none",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"})),pT||(pT=i.createElement("path",{d:"M23.5171 8H18.4828C18.3046 8 18.2154 8.2154 18.3414 8.3414L20.8586 10.8586C20.9367 10.9367 21.0633 10.9367 21.1414 10.8586L23.6585 8.3414C23.7845 8.2154 23.6953 8 23.5171 8Z",stroke:"none"})),fT||(fT=i.createElement("path",{d:"M17 1C16.4477 1 16 1.4477 16 2C16 2.5523 16.4477 3 17 3V1ZM17 3H19V1H17V3ZM20 4V8H22V4H20ZM19 3C19.5523 3 20 3.4477 20 4H22C22 2.3431 20.6568 1 19 1V3Z",stroke:"none"})))},vT=(0,i.forwardRef)(gT);o.p;var yT,bT,_T,AT,ET=["title","titleId"];function wT(){return wT=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},wT.apply(null,arguments)}var xT=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,ET);return i.createElement("svg",wT({width:24,height:24,viewBox:"0 0 24 24",stroke:"#677F89",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,yT||(yT=i.createElement("path",{d:"M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"})),bT||(bT=i.createElement("path",{d:"M21 21L16.65 16.65",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"})),_T||(_T=i.createElement("path",{d:"M11 8V14",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"})),AT||(AT=i.createElement("path",{d:"M8 11H14",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"})))},kT=(0,i.forwardRef)(xT);o.p;var CT,ST,MT,TT=["title","titleId"];function OT(){return OT=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},OT.apply(null,arguments)}var DT=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,TT);return i.createElement("svg",OT({width:24,height:24,viewBox:"0 0 24 24",stroke:"#677F89",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,CT||(CT=i.createElement("path",{d:"M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"})),ST||(ST=i.createElement("path",{d:"M21 21L16.65 16.65",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"})),MT||(MT=i.createElement("path",{d:"M8 11H14",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"})))},LT=(0,i.forwardRef)(DT);o.p;var PT,IT=fr(wr)((function(e){var t=e.theme,n=t.responsive.mediumScreenUp;return"\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        height: 56px;\n        justify-content: space-between;\n        align-items: center;\n        padding: "+t.spacing.sm+";\n        margin: 16px;\n        background-color: white;\n        filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\n\n        "+n(PT||(PT=zM(["\n            width: 396px;\n            margin-left: auto;\n            margin-right: auto;\n        "])))+"\n    "})),BT=fr(Gr)((function(e){return{margin:e.theme.spacing.sm}})),RT=function(e){var t=e.disableEditing,n=e.undoDisabled,r=e.onUndo,o=e.redoDisabled,a=e.onRedo,s=e.rotateDisabled,l=e.showAlternativeRotateIcon,c=e.onRotate,u=e.zoomInDisabled,d=e.onZoomIn,p=e.zoomOutDisabled,f=e.onZoomOut;return i.createElement(IT,{"data-testid":"sp-ui-editor-toolbar"},t?i.createElement(Jp,{spacing:1,direction:"row",align:"center"}):i.createElement(i.Fragment,null,i.createElement(Jp,{spacing:1,direction:"row",align:"center"},i.createElement(BT,{colorScheme:"white","aria-label":"Undo",label:"Undo",icon:i.createElement(ZM,{color:"gray.600"}),isDisabled:n,onClick:r}),i.createElement(BT,{colorScheme:"white","aria-label":"Redo",label:"Redo",icon:i.createElement(rT,{color:"gray.600"}),isDisabled:o,onClick:a})),i.createElement(GM,{orientation:"vertical",color:"gray.200"}),i.createElement(Jp,{spacing:1,direction:"row",align:"center"},i.createElement(BT,{colorScheme:"white","aria-label":"Rotate",icon:l?i.createElement(vT,null):i.createElement(uT,{color:"gray.600"}),isDisabled:s,onClick:c})),i.createElement(GM,{orientation:"vertical",color:"gray.200"})),i.createElement(Jp,{spacing:1,direction:"row",align:"center"},i.createElement(BT,{colorScheme:"white","aria-label":"Zoom Out",icon:i.createElement(LT,{color:"gray.600"}),isDisabled:p,onClick:f}),i.createElement(BT,{colorScheme:"white","aria-label":"Zoom In",icon:i.createElement(kT,{color:"gray.600"}),isDisabled:u,onClick:d})))};RT.displayName="EditorToolbar";const NT=(0,i.memo)(RT);function FT(e,t,n,r,o){var i=arguments.length>5&&void 0!==arguments[5]?arguments[5]:{x:0,y:0},a=e.product.x+(e.product.width+t)/2,s=e.product.y+(e.product.height+n)/2,l=(e.product.width+t)/Math.pow(1.2,SS[0]),c=(e.product.height+n)/Math.pow(1.2,SS[0]),u=e.product.width/Math.pow(1.2,r),d=e.product.height/Math.pow(1.2,r),p=a-.5*l+.5*u,f=s-.5*c+.5*d,h=a+.5*l-u+.5*u,m=s+.5*c-d+.5*d,g=o.x-i.x,v=o.y-i.y;return{x:Math.min(h,Math.max(p,g)),y:Math.min(m,Math.max(f,v))}}function jT(){return{type:"standby",activePointers:new Set}}function YT(e,t){return Math.hypot(e.x-t.x,e.y-t.y)}function $T(e,t){switch(t.type){case"pointerDown":return function(e,t){var n=new Set(e.activePointers);switch(n.add(t.id),e.type){case"standby":return{type:"started",firstPointer:{id:t.id,startPosition:t.position,currentPosition:t.position},project:t.project,zoomCenter:t.zoomCenter,projectPosition:t.projectPosition,selected:t.selected,activePointers:n};case"started":return e.selected?{type:"resize",firstPointer:e.firstPointer,secondPointer:{id:t.id,startPosition:t.position,currentPosition:t.position},adjustZoomCenter:{x:e.firstPointer.startPosition.x,y:e.firstPointer.startPosition.y},startDistance:YT(e.firstPointer.currentPosition,t.position),activePointers:n}:{type:"zoom",firstPointer:{id:t.id,startPosition:t.position,currentPosition:t.position},secondPointer:{id:t.id,startPosition:t.position,currentPosition:t.position},adjustZoomCenter:{x:e.firstPointer.startPosition.x,y:e.firstPointer.startPosition.y},startDistance:YT(e.firstPointer.currentPosition,t.position),activePointers:n}}return e}(e,t);case"pointerMove":return function(e,t){if(!e.activePointers.has(t.id))return e;switch(e.type){case"started":case"pan":case"drag":var r={x:t.position.x-e.firstPointer.startPosition.x,y:t.position.y-e.firstPointer.startPosition.y};switch("started"===e.type?e.selected?"drag":"pan":e.type){case"pan":return n({},e,{type:"pan",firstPointer:n({},e.firstPointer,{currentPosition:t.position}),zoomCenterOffset:r});case"drag":var o=e,i=o.project,a=bS(i.image.width,i.image.height,i.image.clippingMask);if(i.rotation%2==1){var s=[r.y,i.disableRotating?r.x:-r.x];r.x=s[0],r.y=s[1]}var l=a.x-r.x*a.width/i.width,c=a.y-r.y*a.height/i.height,u=n({},a,{x:Math.min(i.image.width-a.width,Math.max(0,l)),y:Math.min(i.image.height-a.height,Math.max(0,c))});return n({},o,{type:"drag",firstPointer:n({},e.firstPointer,{currentPosition:t.position}),cropRectangle:u})}case"zoom":case"resize":return e}return e}(e,t);case"pointerUp":return function(e,t){if(!e.activePointers.has(t.id))return e;var r=new Set(e.activePointers);if(r.delete(t.id),0===r.size)return jT();switch(e.type){case"standby":case"started":return console.warn("DEBUG: This should not happen."),e;case"ended":return n({},e,{activePointers:r});case"pan":case"drag":return r.has(e.firstPointer.id)?n({},e,{activePointers:r}):{type:"ended",activePointers:r};case"zoom":case"resize":return r.has(e.firstPointer.id)&&r.has(e.secondPointer.id)?n({},e,{activePointers:r}):{type:"ended",activePointers:r}}}(e,t);case"pointerCancel":return function(e,t){if(!e.activePointers.has(t.id))return e;var r=new Set(e.activePointers);if(r.delete(t.id),0===r.size)return jT();switch(e.type){case"standby":case"started":return console.warn("DEBUG: This should not happen."),e;case"ended":return n({},e,{activePointers:r});case"pan":case"drag":return r.has(e.firstPointer.id)?n({},e,{activePointers:r}):{type:"ended",activePointers:r};case"zoom":case"resize":return r.has(e.firstPointer.id)&&r.has(e.secondPointer.id)?n({},e,{activePointers:r}):{type:"ended",activePointers:r}}}(e,t)}}var HT=fr(_r)((function(e){return"\nbackground-color: "+e.theme.colors.gray[100]+";\nposition: relative;\nheight: 100%;\n"})),UT=function(e){var t,r,o,a,s,l,c=e.frame,u=e.disableEditing,d=e.disableRotating,p=e.isRoundCrop,f=e.pageSpecification,h=e.project,g=e.onUpdate;h.disableRotating=d;var v=m((0,i.useState)((function(){return[]})),2),y=v[0],b=v[1],_=m((0,i.useState)((function(){return[]})),2),A=_[0],E=_[1],w=m((0,i.useState)(h),2),x=w[0],k=w[1],C=m((0,i.useState)(!1),2),S=C[0],M=C[1],T=(0,i.useState)((function(){return function(e,t){var n=e.image,r=e.rotation,o=n.width,i=n.height,a=bS(o,i,n.clippingMask),s=_S(o,i,r%2==0?t.width:t.height,r%2==0?t.height:t.width),l=a.width/s.width,c=Math.log(l)/Math.log(vS);return Math.round(c)}(x,f)})),O=m(T,2),D=O[0],L=O[1],P=m((0,i.useState)(-1),2),I=P[0],B=P[1],R=m((0,i.useState)((function(){return{x:f.product.x+f.product.width/2,y:f.product.y+f.product.height/2}})),2),N=R[0],F=R[1],j=m((0,i.useState)(jT),2),Y=j[0],$=j[1],H=!0,U=2*((null!==(t=null==c?void 0:c.frameWidth)&&void 0!==t?t:0)-(null!==(r=null==c?void 0:c.frameOverlap)&&void 0!==r?r:0)),z=2*((null!==(o=null==c?void 0:c.matWidth)&&void 0!==o?o:0)-(null!==(a=null==c?void 0:c.matOverlap)&&void 0!==a?a:0)),W=2*((null!==(s=null==c?void 0:c.matHeight)&&void 0!==s?s:0)-(null!==(l=null==c?void 0:c.matOverlap)&&void 0!==l?l:0)),V=(0,i.useCallback)((function(){B(-1),F({x:f.product.x+f.product.width/2,y:f.product.y+f.product.height/2})}),[f.product.height,f.product.width,f.product.x,f.product.y]),G=(0,i.useCallback)((function(e){b((function(t){return t.concat(e)})),E([])}),[b,E]),Q=(0,i.useCallback)((function(){b((function(e){if(0===e.length)return e;var t=e[e.length-1];return k((function(e){return E((function(t){return t.concat(e)})),t})),e.slice(0,-1)})),V()}),[V]),q=(0,i.useCallback)((function(){E((function(e){if(0===e.length)return e;var t=e[e.length-1];return k((function(e){return b((function(t){return t.concat(e)})),t})),e.slice(0,-1)})),V()}),[V]),K=(0,i.useCallback)((function(e){L(e),M(!0),k((function(t){return S||G(t),AS(t,f,e)}))}),[S,f,G]),Z=(0,i.useCallback)((function(e){M(!1),L(e),k((function(t){return AS(t,f,e)}))}),[L,M,k,f]),J=(0,i.useCallback)((function(){k((function(e){G(e);var t=_S(e.image.width,e.image.height,e.rotation%2==1?f.width:f.height,e.rotation%2==1?f.height:f.width);return n({},e,{image:n({},e.image,{clippingMask:yS(e.image.width,e.image.height,t)}),rotation:e.rotation%2==0?3:0})})),L(0),V()}),[V,G,f.width,f.height]),X=(0,i.useCallback)((function(){B((function(e){return e<SS[1]?e+1:e}))}),[B]),ee=(0,i.useCallback)((function(){B((function(e){return e>SS[0]?e-1:e}))}),[B]),te=(0,i.useMemo)((function(){return{x:0,y:0,width:x.width,height:x.height,scale:1,contents:[{id:"0",type:"image",x:0,y:0,width:x.width,height:x.height,image:{url:x.image.url,width:x.image.width,height:x.image.height,rotation:x.rotation,clippingMask:bS(x.image.width,x.image.height,x.image.clippingMask)},selected:H,ghostImage:S||"drag"===Y.type||"resize"===Y.type}],product:f.product,productMasks:n({rotation:4-x.rotation%4},f.productMasks)}}),[x.width,x.height,x.image.url,x.image.width,x.image.height,x.image.clippingMask,x.rotation,H,S,Y.type,f.product,f.productMasks]),ne=(0,i.useMemo)((function(){var e={width:(f.product.width+U+z)/Math.pow(1.2,I),height:(f.product.height+U+W)/Math.pow(1.2,I)};if(x.rotation%2==1){var t=[e.height,e.width];e.width=t[0],e.height=t[1]}var r=FT(f,U+z,U+W,I,N);return n({},e,{x:r.x-.5*e.width,y:r.y-.5*e.height})}),[f,U,z,I,W,x.rotation,N]),re=(0,i.useCallback)((function(e,t){var n=function(e,t,n,r,o,i){return{type:"pointerDown",id:e.pointerId,position:t,projectPosition:n,project:r,zoomCenter:o,selected:i}}(e,t,{x:t.x+ne.x,y:t.y+ne.y},x,N,H);$((function(e){return $T(e,n)}))}),[x,N,ne,H]),oe=(0,i.useCallback)((function(e,t){var r=function(e,t){return{type:"pointerMove",id:e.pointerId,position:t}}(e,t);$((function(e){var t=$T(e,r);if(e!==t)switch(t.type){case"pan":F(FT(f,U+z,U+W,I,t.zoomCenter,t.zoomCenterOffset));break;case"drag":k((function(r){return"started"===e.type&&G(r),n({},r,{image:n({},r.image,{clippingMask:yS(r.image.width,r.image.height,t.cropRectangle)})})}))}return t}))}),[f,U,z,W,I,G]),ie=(0,i.useCallback)((function(e,t){var n=function(e,t){return{type:"pointerUp",id:e.pointerId,position:t}}(e,t);$((function(e){return $T(e,n)}))}),[]),ae=(0,i.useCallback)((function(e){var t=function(e){return{type:"pointerCancel",id:e.pointerId}}(e);$((function(e){return $T(e,t)}))}),[]);(0,i.useEffect)((function(){g&&g(x)}),[x]);var se=x.width===x.height||d;return i.createElement(HT,null,i.createElement(IS,{frame:c,renderSpecification:te,viewport:ne,isRoundCrop:p,onPointerDown:re,onPointerMove:oe,onPointerUp:ie,onPointerCancel:ae}),i.createElement(NT,{disableEditing:u,undoDisabled:0===y.length,onUndo:Q,redoDisabled:0===A.length,onRedo:q,rotateDisabled:se,showAlternativeRotateIcon:x.rotation%2==1,onRotate:J,zoomInDisabled:I===SS[1],onZoomIn:X,zoomOutDisabled:I===SS[0],onZoomOut:ee}),!u&&i.createElement(UM,{size:D,onSizeChangeEnd:Z,onSizeChange:K}))};UT.displayName="Editor";const zT=(0,i.memo)(UT);var WT=Io().mark(GT),VT=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;function GT(e){var t;return Io().wrap((function(n){for(;;)switch(n.prev=n.next){case 0:t=0;case 1:return n.next=4,e+"-"+t;case 4:t++,n.next=1;break;case 7:case"end":return n.stop()}}),WT)}function QT(e){return null==e?void 0:e.replace(/[^0-9A-Za-z\.& ]/g,"").replace(/ /g,"-").toLowerCase()}var qT=function(){};var KT,ZT=function(e){return e.Medium="medium",e.Small="small",e.Square="square",e.Custom="custom",e}({}),JT={CANVAS:"canvas",CARDS:"cards",CUSTOM:"custom",DIGITALS:"digitals",FINE_ART:"fine-art",METALS:"metals",ORNAMENTS:"ornaments",PACKAGES:"packages",PRINTS:"prints",PRODUCTS:"products",ACRYLIC_BLOCKS:"acrylic-blocks",FRAMED_PRINTS:"framed-prints",MATTED_FRAMED_PRINTS:"matted-framed-prints"};kC(kC(kC(kC(kC(kC(kC(kC(kC(kC(KT={},JT.ACRYLIC_BLOCKS,"studio.priceSheet.groupType.acrylicBlock"),JT.CANVAS,"studio.priceSheet.groupType.canvas"),JT.CARDS,"studio.priceSheet.groupType.card"),JT.CUSTOM,"studio.priceSheet.groupType.custom"),JT.DIGITALS,"studio.priceSheet.groupType.digital"),JT.FINE_ART,"studio.priceSheet.groupType.fineArt"),JT.FRAMED_PRINTS,"studio.priceSheet.groupType.framedPrint"),JT.METALS,"studio.priceSheet.groupType.metal"),JT.ORNAMENTS,"studio.priceSheet.groupType.ornament"),JT.PACKAGES,"studio.priceSheet.groupType.package"),kC(kC(kC(KT,JT.PRINTS,"studio.priceSheet.groupType.print"),JT.PRODUCTS,"studio.priceSheet.groupType.product"),JT.MATTED_FRAMED_PRINTS,"studio.priceSheet.groupType.mattedFramedPrint"),new Set([JT.CANVAS,JT.PRINTS,JT.FINE_ART,JT.METALS]);var XT,eO,tO=function(e,t){var n={width:e.width,height:e.height,rotation:0,image:{url:t,width:e.width,height:e.height,clippingMask:{left:0,top:0,right:0,bottom:0}}};return{isRoundCrop:!1,pageSpecification:{width:e.width,height:e.height,product:{x:0,y:0,width:e.width,height:e.height},productMasks:{clipImageUrl:"",frameImageUrl:"",multiplyImageUrl:"",overImageUrl:"",rotation:0}},project:n}},nO=function(e,t,r){var o,i,a=e.crop,s=a.bounds,l=a.end,c=a.start,u=e.productMasks,d=void 0===u?{clipImageUrl:"",frameImageUrl:"",multiplyImageUrl:"",overImageUrl:"",rotation:0}:u,p=function(e,t){return e.width>e.height!=t.width>t.height?n({},t,{width:t.height,height:t.width}):t}(t,s),f=Math.floor(t.width*(l.x-c.x)/100),h=Math.floor(t.height*(l.y-c.y)/100),m={left:c.x/100,top:c.y/100,right:1-l.x/100,bottom:1-l.y/100},g=p.width===p.height||f>=h==p.width>=p.height?0:1,v={width:p.width,height:p.height,rotation:null!==(o=e.rotation)&&void 0!==o?o:g,image:{url:r,width:t.width,height:t.height,clippingMask:m}},y={width:p.width,height:p.height,product:{x:0,y:0,width:p.width,height:p.height},productMasks:d};return{isRoundCrop:(i=e.boundsName,["Button","Round Magnet"].includes(i)),pageSpecification:y,project:v}},rO=["frame","isCentered","item","photo","photoUrl","previewBackground","previewEffects","variant","canvasPadding"],oO=["isCentered","item","photo","photoUrl","previewBackground","previewEffects","variant","padding","frame"],iO=fr(wr,{shouldForwardProp:function(e){return"isCentered"!==e}})((function(e){return"\n        align-items: center;\n        justify-content: center;\n        "+(e.isCentered?"margin: 0 auto;":"")+"\n        max-width: max-content;\n\n        canvas {\n            height: inherit !important;\n            max-width: 100% !important;\n        }\n    "})),aO=kC(kC(kC({},ZT.Medium,{height:423,width:516}),ZT.Small,{height:96,width:144}),ZT.Square,{height:588,width:588}),sO=ZT.Medium,lO=function(e){var r,o=e.frame,a=e.isCentered,s=void 0===a||a,l=e.item,c=e.photo,u=e.photoUrl,d=e.previewBackground,p=e.previewEffects,f=e.variant,h=void 0===f?sO:f,g=e.canvasPadding,v=void 0===g?"0":g,y=t(e,rO),b=function(){var e=(0,i.useRef)(null),t=m((0,i.useState)(),2),n=t[0],r=t[1];return(0,i.useEffect)((function(){var t=new dS((function(){e.current&&r({height:e.current.offsetHeight,width:e.current.offsetWidth})}));return e.current&&t.observe(e.current),function(){t.disconnect()}}),[]),{dimensions:n,ref:e}}(),_=b.dimensions,A=b.ref,E=h===ZT.Custom&&_?_:null!==(r=aO[h])&&void 0!==r?r:aO[sO],w=l.crop?nO(l,c,u):tO(c,u),x=n({},E,{frame:o,padding:v,pageSpecification:w.pageSpecification,project:w.project});return i.createElement(iO,n({ref:A,isCentered:s},y),i.createElement(CS,n({previewBackground:d,previewEffects:p},x)))},cO=function(e){var t=e.disableRotating,r=void 0!==t&&t,o=e.frame,a=e.item,s=e.photo,l=e.photoUrl,c=e.onUpdate,u=void 0===c?qT:c,d=(0,i.useMemo)((function(){return a.crop?nO(a,s,l):tO(s,l)}),[a,s,l]),p=d.isRoundCrop,f=d.pageSpecification,h=d.project;h.rotation=r&&s.height>s.width?1:h.rotation;var m=(0,i.useCallback)((function(e){var t=e.image.clippingMask,r=n({},a.crop,{start:{x:100*t.left,y:100*t.top},end:{x:100-100*t.right,y:100-100*t.bottom},isRotated:e.rotation%2!=0});u(r)}),[a.crop,u]);return i.createElement(zT,{frame:null!=o?o:void 0,disableEditing:!1,disableRotating:r,isRoundCrop:p,project:h,pageSpecification:f,onUpdate:m})},uO=function(e){return e.AccountPaymentRead="account.payment-read",e.AccountPaymentWithdrawal="account.payment-withdrawal",e.AccountRead="account.read",e.AccountUpdate="account.update",e.BookingView="booking.view",e.BookingEdit="booking.edit",e.BrandThemeCreate="brand-theme.create",e.BrandThemeRead="brand-theme.read",e.BrandThemeUpdate="brand-theme.update",e.BrandHomepageUpdate="brand.homepage-update",e.ContactCreate="contact.create",e.ContactRead="contact.read",e.ContactUpdate="contact.update",e.ContractCreate="contract.create",e.ContractRead="contract.read",e.ContractUpdate="contract.update",e.EmailTemplateCreate="email-template.create",e.EmailTemplateRead="email-template.read",e.EmailTemplateUpdate="email-template.update",e.EventDefaultsCreate="event-defaults.create",e.EventDefaultsRead="event-defaults.read",e.EventDefaultsUpdate="event-defaults.update",e.EventPhotoCreate="event-photo.create",e.EventPhotoUpdate="event-photo.update",e.EventCreate="event.create",e.EventDelete="event.delete",e.EventRead="event.read",e.EventUpdate="event.update",e.InvoiceCreate="invoice.create",e.InvoiceRead="invoice.read",e.InvoiceUpdate="invoice.update",e.MobileAppCreate="mobile-app.create",e.MobileAppRead="mobile-app.read",e.MobileAppUpdate="mobile-app.update",e.OrderRead="order.read",e.OrderUpdate="order.update",e.PayRead="pay.read",e.PlaylistRead="playlist.read",e.PlaylistUpdate="playlist.update",e.PriceSheetCreate="price-sheet.create",e.PriceSheetRead="price-sheet.read",e.PriceSheetUpdate="price-sheet.update",e.QuestionnaireEdit="questionnaire.edit",e.QuestionnaireView="questionnaire.view",e.ReportEventVisitorsRead="report.event-visitors-read",e.ReportInvoiceRead="report.invoices-read",e.ReportItemsRead="report.items-read",e.ReportOrdersRead="report.orders-read",e.ReportSalesRead="report.sales-read",e.ToolRead="tool.read",e.WatermarkCreate="watermark.create",e.WatermarkRead="watermark.read",e.WatermarkUpdate="watermark.update",e}({}),dO=(0,i.createContext)({me:null,isRefreshingMe:!1,patchMeSettings:(eO=Lo(Io().mark((function e(){return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",void 0);case 1:case"end":return e.stop()}}),e)}))),function(){return eO.apply(this,arguments)}),refreshMe:(XT=Lo(Io().mark((function e(){return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",void 0);case 1:case"end":return e.stop()}}),e)}))),function(){return XT.apply(this,arguments)})}),pO=function(e){var t=zo("me"),r=t.performFetch,o=t.response,a=t.loading,s=m((0,i.useState)(o),2),l=s[0],c=s[1],u=null!==l&&a,d=zo("me",{defer:!0,method:Fo.PATCH}).performFetch,p=(0,i.useCallback)(function(){var e=Lo(Io().mark((function e(t){return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,d({data:{settings:t}});case 2:case"end":return e.stop()}}),e)})));return function(t){return e.apply(this,arguments)}}(),[d]),f=(0,i.useCallback)(Lo(Io().mark((function e(){return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,r();case 2:case"end":return e.stop()}}),e)}))),[r]);return(0,i.useEffect)((function(){null!==o&&c(o)}),[o]),i.createElement(dO.Provider,n({},e,{value:{isRefreshingMe:u,me:l,patchMeSettings:p,refreshMe:f}}))};function fO(e){var t=function(t){var r=hO(),o=r.isRefreshingMe,a=r.me,s=r.patchMeSettings,l=r.refreshMe;return a?i.createElement(e,n({},t,{isRefreshingMe:o,me:a,patchMeSettings:s,refreshMe:l})):null};return function(e){return i.createElement(pO,null,i.createElement(t,e))}}function hO(e){var t=(0,i.useContext)(dO),n=t.isRefreshingMe,r=t.me,o=t.patchMeSettings,a=t.refreshMe,s=(null!=e?e:{}).refresh,l=void 0!==s&&s;return(0,i.useEffect)((function(){l&&a()}),[l,a]),{isRefreshingMe:n,me:r,patchMeSettings:o,refreshMe:a}}var mO=function(e){return function(e){return!!e&&"object"==typeof e}(e)&&!function(e){var t=Object.prototype.toString.call(e);return"[object RegExp]"===t||"[object Date]"===t||function(e){return e.$$typeof===gO}(e)}(e)};var gO="function"==typeof Symbol&&Symbol.for?Symbol.for("react.element"):60103;function vO(e,t){return!1!==t.clone&&t.isMergeableObject(e)?bO((n=e,Array.isArray(n)?[]:{}),e,t):e;var n}function yO(e,t,n){return e.concat(t).map((function(e){return vO(e,n)}))}function bO(e,t,n){(n=n||{}).arrayMerge=n.arrayMerge||yO,n.isMergeableObject=n.isMergeableObject||mO;var r=Array.isArray(t);return r===Array.isArray(e)?r?n.arrayMerge(e,t,n):function(e,t,n){var r={};return n.isMergeableObject(e)&&Object.keys(e).forEach((function(t){r[t]=vO(e[t],n)})),Object.keys(t).forEach((function(o){n.isMergeableObject(t[o])&&e[o]?r[o]=bO(e[o],t[o],n):r[o]=vO(t[o],n)})),r}(e,t,n):vO(t,n)}bO.all=function(e,t){if(!Array.isArray(e))throw new Error("first argument should be an array");return e.reduce((function(e,n){return bO(e,n,t)}),{})};const _O=bO;const AO="object"==typeof global&&global&&global.Object===Object&&global;var EO="object"==typeof self&&self&&self.Object===Object&&self;const wO=AO||EO||Function("return this")();const xO=wO.Symbol;var kO=Object.prototype,CO=kO.hasOwnProperty,SO=kO.toString,MO=xO?xO.toStringTag:void 0;const TO=function(e){var t=CO.call(e,MO),n=e[MO];try{e[MO]=void 0;var r=!0}catch(e){}var o=SO.call(e);return r&&(t?e[MO]=n:delete e[MO]),o};var OO=Object.prototype.toString;const DO=function(e){return OO.call(e)};var LO=xO?xO.toStringTag:void 0;const PO=function(e){return null==e?void 0===e?"[object Undefined]":"[object Null]":LO&&LO in Object(e)?TO(e):DO(e)};const IO=function(e,t){return function(n){return e(t(n))}};const BO=IO(Object.getPrototypeOf,Object);const RO=function(e){return null!=e&&"object"==typeof e};var NO=Function.prototype,FO=Object.prototype,jO=NO.toString,YO=FO.hasOwnProperty,$O=jO.call(Object);const HO=function(e){if(!RO(e)||"[object Object]"!=PO(e))return!1;var t=BO(e);if(null===t)return!0;var n=YO.call(t,"constructor")&&t.constructor;return"function"==typeof n&&n instanceof n&&jO.call(n)==$O};const UO=function(){this.__data__=[],this.size=0};const zO=function(e,t){return e===t||e!=e&&t!=t};const WO=function(e,t){for(var n=e.length;n--;)if(zO(e[n][0],t))return n;return-1};var VO=Array.prototype.splice;const GO=function(e){var t=this.__data__,n=WO(t,e);return!(n<0)&&(n==t.length-1?t.pop():VO.call(t,n,1),--this.size,!0)};const QO=function(e){var t=this.__data__,n=WO(t,e);return n<0?void 0:t[n][1]};const qO=function(e){return WO(this.__data__,e)>-1};const KO=function(e,t){var n=this.__data__,r=WO(n,e);return r<0?(++this.size,n.push([e,t])):n[r][1]=t,this};function ZO(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}ZO.prototype.clear=UO,ZO.prototype.delete=GO,ZO.prototype.get=QO,ZO.prototype.has=qO,ZO.prototype.set=KO;const JO=ZO;const XO=function(){this.__data__=new JO,this.size=0};const eD=function(e){var t=this.__data__,n=t.delete(e);return this.size=t.size,n};const tD=function(e){return this.__data__.get(e)};const nD=function(e){return this.__data__.has(e)};const rD=function(e){var t=typeof e;return null!=e&&("object"==t||"function"==t)};const oD=function(e){if(!rD(e))return!1;var t=PO(e);return"[object Function]"==t||"[object GeneratorFunction]"==t||"[object AsyncFunction]"==t||"[object Proxy]"==t};const iD=wO["__core-js_shared__"];var aD,sD=(aD=/[^.]+$/.exec(iD&&iD.keys&&iD.keys.IE_PROTO||""))?"Symbol(src)_1."+aD:"";const lD=function(e){return!!sD&&sD in e};var cD=Function.prototype.toString;const uD=function(e){if(null!=e){try{return cD.call(e)}catch(e){}try{return e+""}catch(e){}}return""};var dD=/^\[object .+?Constructor\]$/,pD=Function.prototype,fD=Object.prototype,hD=pD.toString,mD=fD.hasOwnProperty,gD=RegExp("^"+hD.call(mD).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");const vD=function(e){return!(!rD(e)||lD(e))&&(oD(e)?gD:dD).test(uD(e))};const yD=function(e,t){return null==e?void 0:e[t]};const bD=function(e,t){var n=yD(e,t);return vD(n)?n:void 0};const _D=bD(wO,"Map");const AD=bD(Object,"create");const ED=function(){this.__data__=AD?AD(null):{},this.size=0};const wD=function(e){var t=this.has(e)&&delete this.__data__[e];return this.size-=t?1:0,t};var xD=Object.prototype.hasOwnProperty;const kD=function(e){var t=this.__data__;if(AD){var n=t[e];return"__lodash_hash_undefined__"===n?void 0:n}return xD.call(t,e)?t[e]:void 0};var CD=Object.prototype.hasOwnProperty;const SD=function(e){var t=this.__data__;return AD?void 0!==t[e]:CD.call(t,e)};const MD=function(e,t){var n=this.__data__;return this.size+=this.has(e)?0:1,n[e]=AD&&void 0===t?"__lodash_hash_undefined__":t,this};function TD(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}TD.prototype.clear=ED,TD.prototype.delete=wD,TD.prototype.get=kD,TD.prototype.has=SD,TD.prototype.set=MD;const OD=TD;const DD=function(){this.size=0,this.__data__={hash:new OD,map:new(_D||JO),string:new OD}};const LD=function(e){var t=typeof e;return"string"==t||"number"==t||"symbol"==t||"boolean"==t?"__proto__"!==e:null===e};const PD=function(e,t){var n=e.__data__;return LD(t)?n["string"==typeof t?"string":"hash"]:n.map};const ID=function(e){var t=PD(this,e).delete(e);return this.size-=t?1:0,t};const BD=function(e){return PD(this,e).get(e)};const RD=function(e){return PD(this,e).has(e)};const ND=function(e,t){var n=PD(this,e),r=n.size;return n.set(e,t),this.size+=n.size==r?0:1,this};function FD(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}FD.prototype.clear=DD,FD.prototype.delete=ID,FD.prototype.get=BD,FD.prototype.has=RD,FD.prototype.set=ND;const jD=FD;const YD=function(e,t){var n=this.__data__;if(n instanceof JO){var r=n.__data__;if(!_D||r.length<199)return r.push([e,t]),this.size=++n.size,this;n=this.__data__=new jD(r)}return n.set(e,t),this.size=n.size,this};function $D(e){var t=this.__data__=new JO(e);this.size=t.size}$D.prototype.clear=XO,$D.prototype.delete=eD,$D.prototype.get=tD,$D.prototype.has=nD,$D.prototype.set=YD;const HD=$D;const UD=function(e,t){for(var n=-1,r=null==e?0:e.length;++n<r&&!1!==t(e[n],n,e););return e};const zD=function(){try{var e=bD(Object,"defineProperty");return e({},"",{}),e}catch(e){}}();const WD=function(e,t,n){"__proto__"==t&&zD?zD(e,t,{configurable:!0,enumerable:!0,value:n,writable:!0}):e[t]=n};var VD=Object.prototype.hasOwnProperty;const GD=function(e,t,n){var r=e[t];VD.call(e,t)&&zO(r,n)&&(void 0!==n||t in e)||WD(e,t,n)};const QD=function(e,t,n,r){var o=!n;n||(n={});for(var i=-1,a=t.length;++i<a;){var s=t[i],l=r?r(n[s],e[s],s,n,e):void 0;void 0===l&&(l=e[s]),o?WD(n,s,l):GD(n,s,l)}return n};const qD=function(e,t){for(var n=-1,r=Array(e);++n<e;)r[n]=t(n);return r};const KD=function(e){return RO(e)&&"[object Arguments]"==PO(e)};var ZD=Object.prototype,JD=ZD.hasOwnProperty,XD=ZD.propertyIsEnumerable;const eL=KD(function(){return arguments}())?KD:function(e){return RO(e)&&JD.call(e,"callee")&&!XD.call(e,"callee")};const tL=Array.isArray;const nL=function(){return!1};var rL="object"==typeof exports&&exports&&!exports.nodeType&&exports,oL=rL&&"object"==typeof module&&module&&!module.nodeType&&module,iL=oL&&oL.exports===rL?wO.Buffer:void 0;const aL=(iL?iL.isBuffer:void 0)||nL;var sL=/^(?:0|[1-9]\d*)$/;const lL=function(e,t){var n=typeof e;return!!(t=null==t?9007199254740991:t)&&("number"==n||"symbol"!=n&&sL.test(e))&&e>-1&&e%1==0&&e<t};const cL=function(e){return"number"==typeof e&&e>-1&&e%1==0&&e<=9007199254740991};var uL={};uL["[object Float32Array]"]=uL["[object Float64Array]"]=uL["[object Int8Array]"]=uL["[object Int16Array]"]=uL["[object Int32Array]"]=uL["[object Uint8Array]"]=uL["[object Uint8ClampedArray]"]=uL["[object Uint16Array]"]=uL["[object Uint32Array]"]=!0,uL["[object Arguments]"]=uL["[object Array]"]=uL["[object ArrayBuffer]"]=uL["[object Boolean]"]=uL["[object DataView]"]=uL["[object Date]"]=uL["[object Error]"]=uL["[object Function]"]=uL["[object Map]"]=uL["[object Number]"]=uL["[object Object]"]=uL["[object RegExp]"]=uL["[object Set]"]=uL["[object String]"]=uL["[object WeakMap]"]=!1;const dL=function(e){return RO(e)&&cL(e.length)&&!!uL[PO(e)]};const pL=function(e){return function(t){return e(t)}};var fL="object"==typeof exports&&exports&&!exports.nodeType&&exports,hL=fL&&"object"==typeof module&&module&&!module.nodeType&&module,mL=hL&&hL.exports===fL&&AO.process;const gL=function(){try{var e=hL&&hL.require&&hL.require("util").types;return e||mL&&mL.binding&&mL.binding("util")}catch(e){}}();var vL=gL&&gL.isTypedArray;const yL=vL?pL(vL):dL;var bL=Object.prototype.hasOwnProperty;const _L=function(e,t){var n=tL(e),r=!n&&eL(e),o=!n&&!r&&aL(e),i=!n&&!r&&!o&&yL(e),a=n||r||o||i,s=a?qD(e.length,String):[],l=s.length;for(var c in e)!t&&!bL.call(e,c)||a&&("length"==c||o&&("offset"==c||"parent"==c)||i&&("buffer"==c||"byteLength"==c||"byteOffset"==c)||lL(c,l))||s.push(c);return s};var AL=Object.prototype;const EL=function(e){var t=e&&e.constructor;return e===("function"==typeof t&&t.prototype||AL)};const wL=IO(Object.keys,Object);var xL=Object.prototype.hasOwnProperty;const kL=function(e){if(!EL(e))return wL(e);var t=[];for(var n in Object(e))xL.call(e,n)&&"constructor"!=n&&t.push(n);return t};const CL=function(e){return null!=e&&cL(e.length)&&!oD(e)};const SL=function(e){return CL(e)?_L(e):kL(e)};const ML=function(e,t){return e&&QD(t,SL(t),e)};const TL=function(e){var t=[];if(null!=e)for(var n in Object(e))t.push(n);return t};var OL=Object.prototype.hasOwnProperty;const DL=function(e){if(!rD(e))return TL(e);var t=EL(e),n=[];for(var r in e)("constructor"!=r||!t&&OL.call(e,r))&&n.push(r);return n};const LL=function(e){return CL(e)?_L(e,!0):DL(e)};const PL=function(e,t){return e&&QD(t,LL(t),e)};var IL="object"==typeof exports&&exports&&!exports.nodeType&&exports,BL=IL&&"object"==typeof module&&module&&!module.nodeType&&module,RL=BL&&BL.exports===IL?wO.Buffer:void 0,NL=RL?RL.allocUnsafe:void 0;const FL=function(e,t){if(t)return e.slice();var n=e.length,r=NL?NL(n):new e.constructor(n);return e.copy(r),r};const jL=function(e,t){var n=-1,r=e.length;for(t||(t=Array(r));++n<r;)t[n]=e[n];return t};const YL=function(e,t){for(var n=-1,r=null==e?0:e.length,o=0,i=[];++n<r;){var a=e[n];t(a,n,e)&&(i[o++]=a)}return i};const $L=function(){return[]};var HL=Object.prototype.propertyIsEnumerable,UL=Object.getOwnPropertySymbols,zL=UL?function(e){return null==e?[]:(e=Object(e),YL(UL(e),(function(t){return HL.call(e,t)})))}:$L;const WL=zL;const VL=function(e,t){return QD(e,WL(e),t)};const GL=function(e,t){for(var n=-1,r=t.length,o=e.length;++n<r;)e[o+n]=t[n];return e};var QL=Object.getOwnPropertySymbols?function(e){for(var t=[];e;)GL(t,WL(e)),e=BO(e);return t}:$L;const qL=QL;const KL=function(e,t){return QD(e,qL(e),t)};const ZL=function(e,t,n){var r=t(e);return tL(e)?r:GL(r,n(e))};const JL=function(e){return ZL(e,SL,WL)};const XL=function(e){return ZL(e,LL,qL)};const eP=bD(wO,"DataView");const tP=bD(wO,"Promise");const nP=bD(wO,"Set");const rP=bD(wO,"WeakMap");var oP="[object Map]",iP="[object Promise]",aP="[object Set]",sP="[object WeakMap]",lP="[object DataView]",cP=uD(eP),uP=uD(_D),dP=uD(tP),pP=uD(nP),fP=uD(rP),hP=PO;(eP&&hP(new eP(new ArrayBuffer(1)))!=lP||_D&&hP(new _D)!=oP||tP&&hP(tP.resolve())!=iP||nP&&hP(new nP)!=aP||rP&&hP(new rP)!=sP)&&(hP=function(e){var t=PO(e),n="[object Object]"==t?e.constructor:void 0,r=n?uD(n):"";if(r)switch(r){case cP:return lP;case uP:return oP;case dP:return iP;case pP:return aP;case fP:return sP}return t});const mP=hP;var gP=Object.prototype.hasOwnProperty;const vP=function(e){var t=e.length,n=new e.constructor(t);return t&&"string"==typeof e[0]&&gP.call(e,"index")&&(n.index=e.index,n.input=e.input),n};const yP=wO.Uint8Array;const bP=function(e){var t=new e.constructor(e.byteLength);return new yP(t).set(new yP(e)),t};const _P=function(e,t){var n=t?bP(e.buffer):e.buffer;return new e.constructor(n,e.byteOffset,e.byteLength)};var AP=/\w*$/;const EP=function(e){var t=new e.constructor(e.source,AP.exec(e));return t.lastIndex=e.lastIndex,t};var wP=xO?xO.prototype:void 0,xP=wP?wP.valueOf:void 0;const kP=function(e){return xP?Object(xP.call(e)):{}};const CP=function(e,t){var n=t?bP(e.buffer):e.buffer;return new e.constructor(n,e.byteOffset,e.length)};const SP=function(e,t,n){var r=e.constructor;switch(t){case"[object ArrayBuffer]":return bP(e);case"[object Boolean]":case"[object Date]":return new r(+e);case"[object DataView]":return _P(e,n);case"[object Float32Array]":case"[object Float64Array]":case"[object Int8Array]":case"[object Int16Array]":case"[object Int32Array]":case"[object Uint8Array]":case"[object Uint8ClampedArray]":case"[object Uint16Array]":case"[object Uint32Array]":return CP(e,n);case"[object Map]":case"[object Set]":return new r;case"[object Number]":case"[object String]":return new r(e);case"[object RegExp]":return EP(e);case"[object Symbol]":return kP(e)}};var MP=Object.create,TP=function(){function e(){}return function(t){if(!rD(t))return{};if(MP)return MP(t);e.prototype=t;var n=new e;return e.prototype=void 0,n}}();const OP=TP;const DP=function(e){return"function"!=typeof e.constructor||EL(e)?{}:OP(BO(e))};const LP=function(e){return RO(e)&&"[object Map]"==mP(e)};var PP=gL&&gL.isMap;const IP=PP?pL(PP):LP;const BP=function(e){return RO(e)&&"[object Set]"==mP(e)};var RP=gL&&gL.isSet;const NP=RP?pL(RP):BP;var FP="[object Arguments]",jP="[object Function]",YP="[object Object]",$P={};$P[FP]=$P["[object Array]"]=$P["[object ArrayBuffer]"]=$P["[object DataView]"]=$P["[object Boolean]"]=$P["[object Date]"]=$P["[object Float32Array]"]=$P["[object Float64Array]"]=$P["[object Int8Array]"]=$P["[object Int16Array]"]=$P["[object Int32Array]"]=$P["[object Map]"]=$P["[object Number]"]=$P[YP]=$P["[object RegExp]"]=$P["[object Set]"]=$P["[object String]"]=$P["[object Symbol]"]=$P["[object Uint8Array]"]=$P["[object Uint8ClampedArray]"]=$P["[object Uint16Array]"]=$P["[object Uint32Array]"]=!0,$P["[object Error]"]=$P[jP]=$P["[object WeakMap]"]=!1;const HP=function e(t,n,r,o,i,a){var s,l=1&n,c=2&n,u=4&n;if(r&&(s=i?r(t,o,i,a):r(t)),void 0!==s)return s;if(!rD(t))return t;var d=tL(t);if(d){if(s=vP(t),!l)return jL(t,s)}else{var p=mP(t),f=p==jP||"[object GeneratorFunction]"==p;if(aL(t))return FL(t,l);if(p==YP||p==FP||f&&!i){if(s=c||f?{}:DP(t),!l)return c?KL(t,PL(s,t)):VL(t,ML(s,t))}else{if(!$P[p])return i?t:{};s=SP(t,p,l)}}a||(a=new HD);var h=a.get(t);if(h)return h;a.set(t,s),NP(t)?t.forEach((function(o){s.add(e(o,n,r,o,t,a))})):IP(t)&&t.forEach((function(o,i){s.set(i,e(o,n,r,i,t,a))}));var m=d?void 0:(u?c?XL:JL:c?LL:SL)(t);return UD(m||t,(function(o,i){m&&(o=t[i=o]),GD(s,i,e(o,n,r,i,t,a))})),s};const UP=function(e){return HP(e,5)};var zP=o(4719),WP=o.n(zP);const VP=function(e,t){};const GP=function(e){return HP(e,4)};const QP=function(e,t){for(var n=-1,r=null==e?0:e.length,o=Array(r);++n<r;)o[n]=t(e[n],n,e);return o};const qP=function(e){return"symbol"==typeof e||RO(e)&&"[object Symbol]"==PO(e)};function KP(e,t){if("function"!=typeof e||null!=t&&"function"!=typeof t)throw new TypeError("Expected a function");var n=function(){var r=arguments,o=t?t.apply(this,r):r[0],i=n.cache;if(i.has(o))return i.get(o);var a=e.apply(this,r);return n.cache=i.set(o,a)||i,a};return n.cache=new(KP.Cache||jD),n}KP.Cache=jD;const ZP=KP;const JP=function(e){var t=ZP(e,(function(e){return 500===n.size&&n.clear(),e})),n=t.cache;return t};var XP=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,eI=/\\(\\)?/g,tI=JP((function(e){var t=[];return 46===e.charCodeAt(0)&&t.push(""),e.replace(XP,(function(e,n,r,o){t.push(r?o.replace(eI,"$1"):n||e)})),t}));const nI=tI;const rI=function(e){if("string"==typeof e||qP(e))return e;var t=e+"";return"0"==t&&1/e==-1/0?"-0":t};var oI=xO?xO.prototype:void 0,iI=oI?oI.toString:void 0;const aI=function e(t){if("string"==typeof t)return t;if(tL(t))return QP(t,e)+"";if(qP(t))return iI?iI.call(t):"";var n=t+"";return"0"==n&&1/t==-1/0?"-0":n};const sI=function(e){return null==e?"":aI(e)};const lI=function(e){return tL(e)?QP(e,rI):qP(e)?[e]:jL(nI(sI(e)))};function cI(){return cI=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},cI.apply(this,arguments)}function uI(e,t){e.prototype=Object.create(t.prototype),e.prototype.constructor=e,e.__proto__=t}function dI(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}function pI(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}var fI=(0,i.createContext)(void 0);fI.displayName="FormikContext";var hI=fI.Provider;fI.Consumer;function mI(){var e=(0,i.useContext)(fI);return e||VP(!1),e}var gI=function(e){return Array.isArray(e)&&0===e.length},vI=function(e){return"function"==typeof e},yI=function(e){return null!==e&&"object"==typeof e},bI=function(e){return String(Math.floor(Number(e)))===e},_I=function(e){return"[object String]"===Object.prototype.toString.call(e)},AI=function(e){return 0===i.Children.count(e)},EI=function(e){return yI(e)&&vI(e.then)};function wI(e,t,n,r){void 0===r&&(r=0);for(var o=lI(t);e&&r<o.length;)e=e[o[r++]];return r===o.length||e?void 0===e?n:e:n}function xI(e,t,n){for(var r=GP(e),o=r,i=0,a=lI(t);i<a.length-1;i++){var s=a[i],l=wI(e,a.slice(0,i+1));if(l&&(yI(l)||Array.isArray(l)))o=o[s]=GP(l);else{var c=a[i+1];o=o[s]=bI(c)&&Number(c)>=0?[]:{}}}return(0===i?e:o)[a[i]]===n?e:(void 0===n?delete o[a[i]]:o[a[i]]=n,0===i&&void 0===n&&delete r[a[i]],r)}function kI(e,t,n,r){void 0===n&&(n=new WeakMap),void 0===r&&(r={});for(var o=0,i=Object.keys(e);o<i.length;o++){var a=i[o],s=e[a];yI(s)?n.get(s)||(n.set(s,!0),r[a]=Array.isArray(s)?[]:{},kI(s,t,n,r[a])):r[a]=t}return r}var CI={},SI={};function MI(e){var t=e.validateOnChange,n=void 0===t||t,r=e.validateOnBlur,o=void 0===r||r,a=e.validateOnMount,s=void 0!==a&&a,l=e.isInitialValid,c=e.enableReinitialize,u=void 0!==c&&c,d=e.onSubmit,p=dI(e,["validateOnChange","validateOnBlur","validateOnMount","isInitialValid","enableReinitialize","onSubmit"]),f=cI({validateOnChange:n,validateOnBlur:o,validateOnMount:s,onSubmit:d},p),h=(0,i.useRef)(f.initialValues),m=(0,i.useRef)(f.initialErrors||CI),g=(0,i.useRef)(f.initialTouched||SI),v=(0,i.useRef)(f.initialStatus),y=(0,i.useRef)(!1),b=(0,i.useRef)({});(0,i.useEffect)((function(){return y.current=!0,function(){y.current=!1}}),[]);var _=(0,i.useState)(0)[1],A=(0,i.useRef)({values:UP(f.initialValues),errors:UP(f.initialErrors)||CI,touched:UP(f.initialTouched)||SI,status:UP(f.initialStatus),isSubmitting:!1,isValidating:!1,submitCount:0}),E=A.current,w=(0,i.useCallback)((function(e){var t=A.current;A.current=function(e,t){switch(t.type){case"SET_VALUES":return cI({},e,{values:t.payload});case"SET_TOUCHED":return cI({},e,{touched:t.payload});case"SET_ERRORS":return WP()(e.errors,t.payload)?e:cI({},e,{errors:t.payload});case"SET_STATUS":return cI({},e,{status:t.payload});case"SET_ISSUBMITTING":return cI({},e,{isSubmitting:t.payload});case"SET_ISVALIDATING":return cI({},e,{isValidating:t.payload});case"SET_FIELD_VALUE":return cI({},e,{values:xI(e.values,t.payload.field,t.payload.value)});case"SET_FIELD_TOUCHED":return cI({},e,{touched:xI(e.touched,t.payload.field,t.payload.value)});case"SET_FIELD_ERROR":return cI({},e,{errors:xI(e.errors,t.payload.field,t.payload.value)});case"RESET_FORM":return cI({},e,t.payload);case"SET_FORMIK_STATE":return t.payload(e);case"SUBMIT_ATTEMPT":return cI({},e,{touched:kI(e.values,!0),isSubmitting:!0,submitCount:e.submitCount+1});case"SUBMIT_FAILURE":case"SUBMIT_SUCCESS":return cI({},e,{isSubmitting:!1});default:return e}}(t,e),t!==A.current&&_((function(e){return e+1}))}),[]),x=(0,i.useCallback)((function(e,t){return new Promise((function(n,r){var o=f.validate(e,t);null==o?n(CI):EI(o)?o.then((function(e){n(e||CI)}),(function(e){r(e)})):n(o)}))}),[f.validate]),k=(0,i.useCallback)((function(e,t){var n=f.validationSchema,r=vI(n)?n(t):n,o=t&&r.validateAt?r.validateAt(t,e):function(e,t,n,r){void 0===n&&(n=!1);var o=OI(e);return t[n?"validateSync":"validate"](o,{abortEarly:!1,context:r||o})}(e,r);return new Promise((function(e,t){o.then((function(){e(CI)}),(function(n){"ValidationError"===n.name?e(function(e){var t={};if(e.inner){if(0===e.inner.length)return xI(t,e.path,e.message);var n=e.inner,r=Array.isArray(n),o=0;for(n=r?n:n[Symbol.iterator]();;){var i;if(r){if(o>=n.length)break;i=n[o++]}else{if((o=n.next()).done)break;i=o.value}var a=i;wI(t,a.path)||(t=xI(t,a.path,a.message))}}return t}(n)):t(n)}))}))}),[f.validationSchema]),C=(0,i.useCallback)((function(e,t){return new Promise((function(n){return n(b.current[e].validate(t))}))}),[]),S=(0,i.useCallback)((function(e){var t=Object.keys(b.current).filter((function(e){return vI(b.current[e].validate)})),n=t.length>0?t.map((function(t){return C(t,wI(e,t))})):[Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")];return Promise.all(n).then((function(e){return e.reduce((function(e,n,r){return"DO_NOT_DELETE_YOU_WILL_BE_FIRED"===n||n&&(e=xI(e,t[r],n)),e}),{})}))}),[C]),M=(0,i.useCallback)((function(e){return Promise.all([S(e),f.validationSchema?k(e):{},f.validate?x(e):{}]).then((function(e){var t=e[0],n=e[1],r=e[2];return _O.all([t,n,r],{arrayMerge:DI})}))}),[f.validate,f.validationSchema,S,x,k]),T=PI((function(e){return void 0===e&&(e=E.values),w({type:"SET_ISVALIDATING",payload:!0}),M(e).then((function(e){return y.current&&(w({type:"SET_ISVALIDATING",payload:!1}),w({type:"SET_ERRORS",payload:e})),e}))}));(0,i.useEffect)((function(){s&&!0===y.current&&WP()(h.current,f.initialValues)&&T(h.current)}),[s,T]);var O=(0,i.useCallback)((function(e){var t=e&&e.values?e.values:h.current,n=e&&e.errors?e.errors:m.current?m.current:f.initialErrors||{},r=e&&e.touched?e.touched:g.current?g.current:f.initialTouched||{},o=e&&e.status?e.status:v.current?v.current:f.initialStatus;h.current=t,m.current=n,g.current=r,v.current=o;var i=function(){w({type:"RESET_FORM",payload:{isSubmitting:!!e&&!!e.isSubmitting,errors:n,touched:r,status:o,values:t,isValidating:!!e&&!!e.isValidating,submitCount:e&&e.submitCount&&"number"==typeof e.submitCount?e.submitCount:0}})};if(f.onReset){var a=f.onReset(E.values,q);EI(a)?a.then(i):i()}else i()}),[f.initialErrors,f.initialStatus,f.initialTouched,f.onReset]);(0,i.useEffect)((function(){!0!==y.current||WP()(h.current,f.initialValues)||u&&(h.current=f.initialValues,O(),s&&T(h.current))}),[u,f.initialValues,O,s,T]),(0,i.useEffect)((function(){u&&!0===y.current&&!WP()(m.current,f.initialErrors)&&(m.current=f.initialErrors||CI,w({type:"SET_ERRORS",payload:f.initialErrors||CI}))}),[u,f.initialErrors]),(0,i.useEffect)((function(){u&&!0===y.current&&!WP()(g.current,f.initialTouched)&&(g.current=f.initialTouched||SI,w({type:"SET_TOUCHED",payload:f.initialTouched||SI}))}),[u,f.initialTouched]),(0,i.useEffect)((function(){u&&!0===y.current&&!WP()(v.current,f.initialStatus)&&(v.current=f.initialStatus,w({type:"SET_STATUS",payload:f.initialStatus}))}),[u,f.initialStatus,f.initialTouched]);var D=PI((function(e){if(b.current[e]&&vI(b.current[e].validate)){var t=wI(E.values,e),n=b.current[e].validate(t);return EI(n)?(w({type:"SET_ISVALIDATING",payload:!0}),n.then((function(e){return e})).then((function(t){w({type:"SET_FIELD_ERROR",payload:{field:e,value:t}}),w({type:"SET_ISVALIDATING",payload:!1})}))):(w({type:"SET_FIELD_ERROR",payload:{field:e,value:n}}),Promise.resolve(n))}return f.validationSchema?(w({type:"SET_ISVALIDATING",payload:!0}),k(E.values,e).then((function(e){return e})).then((function(t){w({type:"SET_FIELD_ERROR",payload:{field:e,value:wI(t,e)}}),w({type:"SET_ISVALIDATING",payload:!1})}))):Promise.resolve()})),L=(0,i.useCallback)((function(e,t){var n=t.validate;b.current[e]={validate:n}}),[]),P=(0,i.useCallback)((function(e){delete b.current[e]}),[]),I=PI((function(e,t){return w({type:"SET_TOUCHED",payload:e}),(void 0===t?o:t)?T(E.values):Promise.resolve()})),B=(0,i.useCallback)((function(e){w({type:"SET_ERRORS",payload:e})}),[]),R=PI((function(e,t){var r=vI(e)?e(E.values):e;return w({type:"SET_VALUES",payload:r}),(void 0===t?n:t)?T(r):Promise.resolve()})),N=(0,i.useCallback)((function(e,t){w({type:"SET_FIELD_ERROR",payload:{field:e,value:t}})}),[]),F=PI((function(e,t,r){return w({type:"SET_FIELD_VALUE",payload:{field:e,value:t}}),(void 0===r?n:r)?T(xI(E.values,e,t)):Promise.resolve()})),j=(0,i.useCallback)((function(e,t){var n,r=t,o=e;if(!_I(e)){e.persist&&e.persist();var i=e.target?e.target:e.currentTarget,a=i.type,s=i.name,l=i.id,c=i.value,u=i.checked,d=(i.outerHTML,i.options),p=i.multiple;r=t||(s||l),o=/number|range/.test(a)?(n=parseFloat(c),isNaN(n)?"":n):/checkbox/.test(a)?function(e,t,n){if("boolean"==typeof e)return Boolean(t);var r=[],o=!1,i=-1;if(Array.isArray(e))r=e,o=(i=e.indexOf(n))>=0;else if(!n||"true"==n||"false"==n)return Boolean(t);if(t&&n&&!o)return r.concat(n);if(!o)return r;return r.slice(0,i).concat(r.slice(i+1))}(wI(E.values,r),u,c):d&&p?function(e){return Array.from(e).filter((function(e){return e.selected})).map((function(e){return e.value}))}(d):c}r&&F(r,o)}),[F,E.values]),Y=PI((function(e){if(_I(e))return function(t){return j(t,e)};j(e)})),$=PI((function(e,t,n){return void 0===t&&(t=!0),w({type:"SET_FIELD_TOUCHED",payload:{field:e,value:t}}),(void 0===n?o:n)?T(E.values):Promise.resolve()})),H=(0,i.useCallback)((function(e,t){e.persist&&e.persist();var n=e.target,r=n.name,o=n.id,i=(n.outerHTML,t||(r||o));$(i,!0)}),[$]),U=PI((function(e){if(_I(e))return function(t){return H(t,e)};H(e)})),z=(0,i.useCallback)((function(e){vI(e)?w({type:"SET_FORMIK_STATE",payload:e}):w({type:"SET_FORMIK_STATE",payload:function(){return e}})}),[]),W=(0,i.useCallback)((function(e){w({type:"SET_STATUS",payload:e})}),[]),V=(0,i.useCallback)((function(e){w({type:"SET_ISSUBMITTING",payload:e})}),[]),G=PI((function(){return w({type:"SUBMIT_ATTEMPT"}),T().then((function(e){var t=e instanceof Error;if(!t&&0===Object.keys(e).length){var n;try{if(void 0===(n=K()))return}catch(e){throw e}return Promise.resolve(n).then((function(e){return y.current&&w({type:"SUBMIT_SUCCESS"}),e})).catch((function(e){if(y.current)throw w({type:"SUBMIT_FAILURE"}),e}))}if(y.current&&(w({type:"SUBMIT_FAILURE"}),t))throw e}))})),Q=PI((function(e){e&&e.preventDefault&&vI(e.preventDefault)&&e.preventDefault(),e&&e.stopPropagation&&vI(e.stopPropagation)&&e.stopPropagation(),G().catch((function(e){console.warn("Warning: An unhandled error was caught from submitForm()",e)}))})),q={resetForm:O,validateForm:T,validateField:D,setErrors:B,setFieldError:N,setFieldTouched:$,setFieldValue:F,setStatus:W,setSubmitting:V,setTouched:I,setValues:R,setFormikState:z,submitForm:G},K=PI((function(){return d(E.values,q)})),Z=PI((function(e){e&&e.preventDefault&&vI(e.preventDefault)&&e.preventDefault(),e&&e.stopPropagation&&vI(e.stopPropagation)&&e.stopPropagation(),O()})),J=(0,i.useCallback)((function(e){return{value:wI(E.values,e),error:wI(E.errors,e),touched:!!wI(E.touched,e),initialValue:wI(h.current,e),initialTouched:!!wI(g.current,e),initialError:wI(m.current,e)}}),[E.errors,E.touched,E.values]),X=(0,i.useCallback)((function(e){return{setValue:function(t,n){return F(e,t,n)},setTouched:function(t,n){return $(e,t,n)},setError:function(t){return N(e,t)}}}),[F,$,N]),ee=(0,i.useCallback)((function(e){var t=yI(e),n=t?e.name:e,r=wI(E.values,n),o={name:n,value:r,onChange:Y,onBlur:U};if(t){var i=e.type,a=e.value,s=e.as,l=e.multiple;"checkbox"===i?void 0===a?o.checked=!!r:(o.checked=!(!Array.isArray(r)||!~r.indexOf(a)),o.value=a):"radio"===i?(o.checked=r===a,o.value=a):"select"===s&&l&&(o.value=o.value||[],o.multiple=!0)}return o}),[U,Y,E.values]),te=(0,i.useMemo)((function(){return!WP()(h.current,E.values)}),[h.current,E.values]),ne=(0,i.useMemo)((function(){return void 0!==l?te?E.errors&&0===Object.keys(E.errors).length:!1!==l&&vI(l)?l(f):l:E.errors&&0===Object.keys(E.errors).length}),[l,te,E.errors,f]);return cI({},E,{initialValues:h.current,initialErrors:m.current,initialTouched:g.current,initialStatus:v.current,handleBlur:U,handleChange:Y,handleReset:Z,handleSubmit:Q,resetForm:O,setErrors:B,setFormikState:z,setFieldTouched:$,setFieldValue:F,setFieldError:N,setStatus:W,setSubmitting:V,setTouched:I,setValues:R,submitForm:G,validateForm:T,validateField:D,isValid:ne,dirty:te,unregisterField:P,registerField:L,getFieldProps:ee,getFieldMeta:J,getFieldHelpers:X,validateOnBlur:o,validateOnChange:n,validateOnMount:s})}function TI(e){var t=MI(e),n=e.component,r=e.children,o=e.render,a=e.innerRef;return(0,i.useImperativeHandle)(a,(function(){return t})),(0,i.createElement)(hI,{value:t},n?(0,i.createElement)(n,t):o?o(t):r?vI(r)?r(t):AI(r)?null:i.Children.only(r):null)}function OI(e){var t=Array.isArray(e)?[]:{};for(var n in e)if(Object.prototype.hasOwnProperty.call(e,n)){var r=String(n);!0===Array.isArray(e[r])?t[r]=e[r].map((function(e){return!0===Array.isArray(e)||HO(e)?OI(e):""!==e?e:void 0})):HO(e[r])?t[r]=OI(e[r]):t[r]=""!==e[r]?e[r]:void 0}return t}function DI(e,t,n){var r=e.slice();return t.forEach((function(t,o){if(void 0===r[o]){var i=!1!==n.clone&&n.isMergeableObject(t);r[o]=i?_O(Array.isArray(t)?[]:{},t,n):t}else n.isMergeableObject(t)?r[o]=_O(e[o],t,n):-1===e.indexOf(t)&&r.push(t)})),r}var LI="undefined"!=typeof window&&void 0!==window.document&&void 0!==window.document.createElement?i.useLayoutEffect:i.useEffect;function PI(e){var t=(0,i.useRef)(e);return LI((function(){t.current=e})),(0,i.useCallback)((function(){for(var e=arguments.length,n=new Array(e),r=0;r<e;r++)n[r]=arguments[r];return t.current.apply(void 0,n)}),[])}function II(e){var t=mI(),n=t.getFieldProps,r=t.getFieldMeta,o=t.getFieldHelpers,a=t.registerField,s=t.unregisterField,l=yI(e)?e:{name:e},c=l.name,u=l.validate;(0,i.useEffect)((function(){return c&&a(c,{validate:u}),function(){c&&s(c)}}),[a,s,c,u]),c||VP(!1);var d=(0,i.useMemo)((function(){return o(c)}),[o,c]);return[n(l),r(c),d]}var BI=(0,i.forwardRef)((function(e,t){var n=e.action,r=dI(e,["action"]),o=null!=n?n:"#",a=mI(),s=a.handleReset,l=a.handleSubmit;return(0,i.createElement)("form",cI({onSubmit:l,ref:t,onReset:s,action:o},r))}));BI.displayName="Form";var RI=function(e,t,n){var r=NI(e);return r.splice(t,0,n),r},NI=function(e){if(e){if(Array.isArray(e))return[].concat(e);var t=Object.keys(e).map((function(e){return parseInt(e)})).reduce((function(e,t){return t>e?t:e}),0);return Array.from(cI({},e,{length:t+1}))}return[]},FI=function(e,t){var n="function"==typeof e?e:t;return function(e){if(Array.isArray(e)||yI(e)){var t=NI(e);return n(t)}return e}},jI=function(e){function t(t){var n;return(n=e.call(this,t)||this).updateArrayField=function(e,t,r){var o=n.props,i=o.name;(0,o.formik.setFormikState)((function(n){var o=FI(r,e),a=FI(t,e),s=xI(n.values,i,e(wI(n.values,i))),l=r?o(wI(n.errors,i)):void 0,c=t?a(wI(n.touched,i)):void 0;return gI(l)&&(l=void 0),gI(c)&&(c=void 0),cI({},n,{values:s,errors:r?xI(n.errors,i,l):n.errors,touched:t?xI(n.touched,i,c):n.touched})}))},n.push=function(e){return n.updateArrayField((function(t){return[].concat(NI(t),[UP(e)])}),!1,!1)},n.handlePush=function(e){return function(){return n.push(e)}},n.swap=function(e,t){return n.updateArrayField((function(n){return function(e,t,n){var r=NI(e),o=r[t];return r[t]=r[n],r[n]=o,r}(n,e,t)}),!0,!0)},n.handleSwap=function(e,t){return function(){return n.swap(e,t)}},n.move=function(e,t){return n.updateArrayField((function(n){return function(e,t,n){var r=NI(e),o=r[t];return r.splice(t,1),r.splice(n,0,o),r}(n,e,t)}),!0,!0)},n.handleMove=function(e,t){return function(){return n.move(e,t)}},n.insert=function(e,t){return n.updateArrayField((function(n){return RI(n,e,t)}),(function(t){return RI(t,e,null)}),(function(t){return RI(t,e,null)}))},n.handleInsert=function(e,t){return function(){return n.insert(e,t)}},n.replace=function(e,t){return n.updateArrayField((function(n){return function(e,t,n){var r=NI(e);return r[t]=n,r}(n,e,t)}),!1,!1)},n.handleReplace=function(e,t){return function(){return n.replace(e,t)}},n.unshift=function(e){var t=-1;return n.updateArrayField((function(n){var r=n?[e].concat(n):[e];return t=r.length,r}),(function(e){return e?[null].concat(e):[null]}),(function(e){return e?[null].concat(e):[null]})),t},n.handleUnshift=function(e){return function(){return n.unshift(e)}},n.handleRemove=function(e){return function(){return n.remove(e)}},n.handlePop=function(){return function(){return n.pop()}},n.remove=n.remove.bind(pI(n)),n.pop=n.pop.bind(pI(n)),n}uI(t,e);var n=t.prototype;return n.componentDidUpdate=function(e){this.props.validateOnChange&&this.props.formik.validateOnChange&&!WP()(wI(e.formik.values,e.name),wI(this.props.formik.values,this.props.name))&&this.props.formik.validateForm(this.props.formik.values)},n.remove=function(e){var t;return this.updateArrayField((function(n){var r=n?NI(n):[];return t||(t=r[e]),vI(r.splice)&&r.splice(e,1),vI(r.every)&&r.every((function(e){return void 0===e}))?[]:r}),!0,!0),t},n.pop=function(){var e;return this.updateArrayField((function(t){var n=t.slice();return e||(e=n&&n.pop&&n.pop()),n}),!0,!0),e},n.render=function(){var e={push:this.push,pop:this.pop,swap:this.swap,move:this.move,insert:this.insert,replace:this.replace,unshift:this.unshift,remove:this.remove,handlePush:this.handlePush,handlePop:this.handlePop,handleSwap:this.handleSwap,handleMove:this.handleMove,handleInsert:this.handleInsert,handleReplace:this.handleReplace,handleUnshift:this.handleUnshift,handleRemove:this.handleRemove},t=this.props,n=t.component,r=t.render,o=t.children,a=t.name,s=cI({},e,{form:dI(t.formik,["validate","validationSchema"]),name:a});return n?(0,i.createElement)(n,s):r?r(s):o?"function"==typeof o?o(s):AI(o)?null:i.Children.only(o):null},t}(i.Component);jI.defaultProps={validateOnChange:!0};var YI=["children"];function $I(){return $I=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},$I.apply(null,arguments)}var HI=pr(qr,{target:"e12yoo180"})((e=>{var{theme:t}=e;return"\n        color: "+t.fontColor.default+";\n        font-family: "+t.fonts.heading+";\n        font-size: "+t.fontSizes.md+";\n        font-weight: "+t.fontWeights.medium+";\n        line-height: "+t.lineHeights.md+";\n        margin-bottom: "+t.space[4]+";\n    "}),"");const UI=e=>{var{children:t}=e,n=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,YI);return Mr(HI,$I({as:"h5"},n),t)};var zI=Object.defineProperty,WI=(e,t,n)=>(((e,t,n)=>{t in e?zI(e,t,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[t]=n})(e,"symbol"!=typeof t?t+"":t,n),n),VI=new class{constructor(){WI(this,"modals"),this.modals=new Map}add(e){return this.modals.set(e,this.modals.size+1),this.modals.size}remove(e){this.modals.delete(e)}isTopModal(e){return!!e&&this.modals.get(e)===this.modals.size}};function GI(e,t){const[n,r]=(0,i.useState)(0);return(0,i.useEffect)((()=>{const n=e.current;if(n){if(t){const e=VI.add(n);r(e)}return()=>{VI.remove(n),r(0)}}}),[t,e]),n}var QI=function(e){return"undefined"==typeof document?null:(Array.isArray(e)?e[0]:e).ownerDocument.body},qI=new WeakMap,KI=new WeakMap,ZI={},JI=0,XI=function(e){return e&&(e.host||XI(e.parentNode))},eB=function(e,t,n,r){var o=function(e,t){return t.map((function(t){if(e.contains(t))return t;var n=XI(t);return n&&e.contains(n)?n:(console.error("aria-hidden",t,"in not contained inside",e,". Doing nothing"),null)})).filter((function(e){return Boolean(e)}))}(t,Array.isArray(e)?e:[e]);ZI[n]||(ZI[n]=new WeakMap);var i=ZI[n],a=[],s=new Set,l=new Set(o),c=function(e){e&&!s.has(e)&&(s.add(e),c(e.parentNode))};o.forEach(c);var u=function(e){e&&!l.has(e)&&Array.prototype.forEach.call(e.children,(function(e){if(s.has(e))u(e);else try{var t=e.getAttribute(r),o=null!==t&&"false"!==t,l=(qI.get(e)||0)+1,c=(i.get(e)||0)+1;qI.set(e,l),i.set(e,c),a.push(e),1===l&&o&&KI.set(e,!0),1===c&&e.setAttribute(n,"true"),o||e.setAttribute(r,"true")}catch(t){console.error("aria-hidden: cannot operate on ",e,t)}}))};return u(t),s.clear(),JI++,function(){a.forEach((function(e){var t=qI.get(e)-1,o=i.get(e)-1;qI.set(e,t),i.set(e,o),t||(KI.has(e)||e.removeAttribute(r),KI.delete(e)),o||e.removeAttribute(n)})),--JI||(qI=new WeakMap,qI=new WeakMap,KI=new WeakMap,ZI={})}},tB=function(e,t,n){void 0===n&&(n="data-aria-hidden");var r=Array.from(Array.isArray(e)?e:[e]),o=t||QI(e);return o?(r.push.apply(r,Array.from(o.querySelectorAll("[aria-live]"))),eB(r,o,n,"aria-hidden")):function(){return null}};function nB(e){const{isOpen:t,onClose:n,id:r,closeOnOverlayClick:o=!0,closeOnEsc:a=!0,useInert:s=!0,onOverlayClick:l,onEsc:c}=e,u=(0,i.useRef)(null),d=(0,i.useRef)(null),[p,f,h]=function(e,...t){const n=(0,i.useId)(),r=e||n;return(0,i.useMemo)((()=>t.map((e=>`${e}-${r}`))),[r,t])}(r,"chakra-modal","chakra-modal--header","chakra-modal--body");!function(e,t){const n=e.current;(0,i.useEffect)((()=>{if(e.current&&t)return tB(e.current)}),[t,e,n])}(u,t&&s);const m=GI(u,t),g=(0,i.useRef)(null),v=(0,i.useCallback)((e=>{g.current=e.target}),[]),y=(0,i.useCallback)((e=>{"Escape"===e.key&&(e.stopPropagation(),a&&(null==n||n()),null==c||c())}),[a,n,c]),[b,_]=(0,i.useState)(!1),[A,E]=(0,i.useState)(!1),x=(0,i.useCallback)(((e={},t=null)=>({role:"dialog",...e,ref:Ur(t,u),id:p,tabIndex:-1,"aria-modal":!0,"aria-labelledby":b?f:void 0,"aria-describedby":A?h:void 0,onClick:w(e.onClick,(e=>e.stopPropagation()))})),[h,A,p,f,b]),k=(0,i.useCallback)((e=>{e.stopPropagation(),g.current===e.target&&VI.isTopModal(u.current)&&(o&&(null==n||n()),null==l||l())}),[n,o,l]),C=(0,i.useCallback)(((e={},t=null)=>({...e,ref:Ur(t,d),onClick:w(e.onClick,k),onKeyDown:w(e.onKeyDown,y),onMouseDown:w(e.onMouseDown,v)})),[y,v,k]);return{isOpen:t,onClose:n,headerId:f,bodyId:h,setBodyMounted:E,setHeaderMounted:_,dialogRef:u,overlayRef:d,getDialogProps:x,getDialogContainerProps:C,index:m}}var[rB,oB]=xr({name:"ModalStylesContext",errorMessage:"useModalStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Modal />\" "}),[iB,aB]=xr({strict:!0,name:"ModalContext",errorMessage:"useModalContext: `context` is undefined. Seems you forgot to wrap modal components in `<Modal />`"}),sB=e=>{const t={scrollBehavior:"outside",autoFocus:!0,trapFocus:!0,returnFocusOnClose:!0,blockScrollOnMount:!0,allowPinchZoom:!1,motionPreset:"scale",lockFocusAcrossFrames:!0,...e},{portalProps:n,children:r,autoFocus:o,trapFocus:i,initialFocusRef:a,finalFocusRef:s,returnFocusOnClose:l,blockScrollOnMount:c,allowPinchZoom:u,preserveScrollBarGap:d,motionPreset:p,lockFocusAcrossFrames:f,onCloseComplete:h}=t,m=jr("Modal",t),g={...nB(t),autoFocus:o,trapFocus:i,initialFocusRef:a,finalFocusRef:s,returnFocusOnClose:l,blockScrollOnMount:c,allowPinchZoom:u,preserveScrollBarGap:d,motionPreset:p,lockFocusAcrossFrames:f};return(0,br.jsx)(iB,{value:g,children:(0,br.jsx)(rB,{value:m,children:(0,br.jsx)(qw,{onExitComplete:h,children:g.isOpen&&(0,br.jsx)(sm,{...n,children:r})})})})};sB.displayName="Modal";var lB=yr(((e,t)=>{const{className:n,...r}=e,{bodyId:o,setBodyMounted:a}=aB();(0,i.useEffect)((()=>(a(!0),()=>a(!1))),[a]);const s=g("chakra-modal__body",n),l=oB();return(0,br.jsx)(vr.div,{ref:t,className:s,id:o,...r,__css:l.body})}));lB.displayName="ModalBody";var cB=yr(((e,t)=>{const{onClick:n,className:r,...o}=e,{onClose:i}=aB(),a=g("chakra-modal__close-btn",r),s=oB();return(0,br.jsx)(uC,{ref:t,__css:s.closeButton,className:a,onClick:w(n,(e=>{e.stopPropagation(),i()})),...o})}));cB.displayName="ModalCloseButton";var uB={ease:[.25,.1,.25,1],easeIn:[.4,0,1,1],easeOut:[0,0,.2,1],easeInOut:[.4,0,.2,1]},dB={position:{left:0,top:0,bottom:0,width:"100%"},enter:{x:0,y:0},exit:{x:"-100%",y:0}},pB={position:{right:0,top:0,bottom:0,width:"100%"},enter:{x:0,y:0},exit:{x:"100%",y:0}},fB={position:{top:0,left:0,right:0,maxWidth:"100vw"},enter:{x:0,y:0},exit:{x:0,y:"-100%"}},hB={position:{bottom:0,left:0,right:0,maxWidth:"100vw"},enter:{x:0,y:0},exit:{x:0,y:"100%"}};function mB(e){var t;switch(null!=(t=null==e?void 0:e.direction)?t:"right"){case"right":default:return pB;case"left":return dB;case"bottom":return hB;case"top":return fB}}var gB={enter:{duration:.2,ease:uB.easeOut},exit:{duration:.1,ease:uB.easeIn}},vB=(e,t)=>({...e,delay:"number"==typeof t?t:null==t?void 0:t.enter}),yB=(e,t)=>({...e,delay:"number"==typeof t?t:null==t?void 0:t.exit}),bB={initial:({offsetX:e,offsetY:t,transition:n,transitionEnd:r,delay:o})=>{var i;return{opacity:0,x:e,y:t,transition:null!=(i=null==n?void 0:n.exit)?i:yB(gB.exit,o),transitionEnd:null==r?void 0:r.exit}},enter:({transition:e,transitionEnd:t,delay:n})=>{var r;return{opacity:1,x:0,y:0,transition:null!=(r=null==e?void 0:e.enter)?r:vB(gB.enter,n),transitionEnd:null==t?void 0:t.enter}},exit:({offsetY:e,offsetX:t,transition:n,transitionEnd:r,reverse:o,delay:i})=>{var a;const s={x:t,y:e};return{opacity:0,transition:null!=(a=null==n?void 0:n.exit)?a:yB(gB.exit,i),...o?{...s,transitionEnd:null==r?void 0:r.exit}:{transitionEnd:{...s,...null==r?void 0:r.exit}}}}},_B={initial:"initial",animate:"enter",exit:"exit",variants:bB},AB=(0,i.forwardRef)((function(e,t){const{unmountOnExit:n,in:r,reverse:o=!0,className:i,offsetX:a=0,offsetY:s=8,transition:l,transitionEnd:c,delay:u,...d}=e,p=!n||r&&n,f=r||n?"enter":"exit",h={offsetX:a,offsetY:s,reverse:o,transition:l,transitionEnd:c,delay:u};return(0,br.jsx)(qw,{custom:h,children:p&&(0,br.jsx)(Yw.div,{ref:t,className:g("chakra-offset-slide",i),custom:h,..._B,animate:f,...d})})}));AB.displayName="SlideFade";var EB={exit:({reverse:e,initialScale:t,transition:n,transitionEnd:r,delay:o})=>{var i;return{opacity:0,...e?{scale:t,transitionEnd:null==r?void 0:r.exit}:{transitionEnd:{scale:t,...null==r?void 0:r.exit}},transition:null!=(i=null==n?void 0:n.exit)?i:yB(gB.exit,o)}},enter:({transitionEnd:e,transition:t,delay:n})=>{var r;return{opacity:1,scale:1,transition:null!=(r=null==t?void 0:t.enter)?r:vB(gB.enter,n),transitionEnd:null==e?void 0:e.enter}}},wB={initial:"exit",animate:"enter",exit:"exit",variants:EB},xB=(0,i.forwardRef)((function(e,t){const{unmountOnExit:n,in:r,reverse:o=!0,initialScale:i=.95,className:a,transition:s,transitionEnd:l,delay:c,...u}=e,d=!n||r&&n,p=r||n?"enter":"exit",f={initialScale:i,reverse:o,transition:s,transitionEnd:l,delay:c};return(0,br.jsx)(qw,{custom:f,children:d&&(0,br.jsx)(Yw.div,{ref:t,className:g("chakra-offset-slide",a),...wB,animate:p,custom:f,...u})})}));xB.displayName="ScaleFade";var kB={slideInBottom:{..._B,custom:{offsetY:16,reverse:!0}},slideInRight:{..._B,custom:{offsetX:16,reverse:!0}},slideInTop:{..._B,custom:{offsetY:-16,reverse:!0}},slideInLeft:{..._B,custom:{offsetX:-16,reverse:!0}},scale:{...wB,custom:{initialScale:.95,reverse:!0}},none:{}},CB=vr(Yw.section),SB=e=>kB[e||"none"],MB=(0,i.forwardRef)(((e,t)=>{const{preset:n,motionProps:r=SB(n),...o}=e;return(0,br.jsx)(CB,{ref:t,...r,...o})}));MB.displayName="ModalTransition";var TB="data-focus-lock",OB="data-focus-lock-disabled";function DB(e,t){return"function"==typeof e?e(t):e&&(e.current=t),e}var LB="undefined"!=typeof window?i.useLayoutEffect:i.useEffect,PB=new WeakMap;function IB(e,t){var n,r,o,a=(n=t||null,r=function(t){return e.forEach((function(e){return DB(e,t)}))},(o=(0,i.useState)((function(){return{value:n,callback:r,facade:{get current(){return o.value},set current(e){var t=o.value;t!==e&&(o.value=e,o.callback(e,t))}}}}))[0]).callback=r,o.facade);return LB((function(){var t=PB.get(a);if(t){var n=new Set(t),r=new Set(e),o=a.current;n.forEach((function(e){r.has(e)||DB(e,null)})),r.forEach((function(e){n.has(e)||DB(e,o)}))}PB.set(a,e)}),[e]),a}var BB={width:"1px",height:"0px",padding:0,overflow:"hidden",position:"fixed",top:"1px",left:"1px"},RB=function(e){var t=e.children,n=void 0===t?null:t;return i.createElement(i.Fragment,null,i.createElement("div",{key:"guard-first","data-focus-guard":!0,"data-focus-auto-guard":!0,style:BB}),n,n&&i.createElement("div",{key:"guard-last","data-focus-guard":!0,"data-focus-auto-guard":!0,style:BB}))};RB.propTypes={};var NB=function(){return NB=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e},NB.apply(this,arguments)};function FB(e,t){var n={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var o=0;for(r=Object.getOwnPropertySymbols(e);o<r.length;o++)t.indexOf(r[o])<0&&Object.prototype.propertyIsEnumerable.call(e,r[o])&&(n[r[o]]=e[r[o]])}return n}Object.create;Object.create;"function"==typeof SuppressedError&&SuppressedError;function jB(e){return e}function YB(e,t){void 0===t&&(t=jB);var n=[],r=!1,o={read:function(){if(r)throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");return n.length?n[n.length-1]:e},useMedium:function(e){var o=t(e,r);return n.push(o),function(){n=n.filter((function(e){return e!==o}))}},assignSyncMedium:function(e){for(r=!0;n.length;){var t=n;n=[],t.forEach(e)}n={push:function(t){return e(t)},filter:function(){return n}}},assignMedium:function(e){r=!0;var t=[];if(n.length){var o=n;n=[],o.forEach(e),t=n}var i=function(){var n=t;t=[],n.forEach(e)},a=function(){return Promise.resolve().then(i)};a(),n={push:function(e){t.push(e),a()},filter:function(e){return t=t.filter(e),n}}}};return o}function $B(e,t){return void 0===t&&(t=jB),YB(e,t)}function HB(e){void 0===e&&(e={});var t=YB(null);return t.options=NB({async:!0,ssr:!1},e),t}var UB=$B({},(function(e){return{target:e.target,currentTarget:e.currentTarget}})),zB=$B(),WB=$B(),VB=HB({async:!0,ssr:"undefined"!=typeof document}),GB=(0,i.createContext)(void 0),QB=[],qB=i.forwardRef((function(e,t){var r,o=i.useState(),a=o[0],s=o[1],l=i.useRef(),c=i.useRef(!1),u=i.useRef(null),d=i.useState({})[1],p=e.children,f=e.disabled,h=void 0!==f&&f,m=e.noFocusGuards,g=void 0!==m&&m,v=e.persistentFocus,y=void 0!==v&&v,b=e.crossFrame,_=void 0===b||b,A=e.autoFocus,E=void 0===A||A,w=(e.allowTextSelection,e.group),x=e.className,k=e.whiteList,C=e.hasPositiveIndices,S=e.shards,M=void 0===S?QB:S,T=e.as,O=void 0===T?"div":T,D=e.lockProps,L=void 0===D?{}:D,P=e.sideCar,I=e.returnFocus,B=void 0!==I&&I,R=e.focusOptions,N=e.onActivation,F=e.onDeactivation,j=i.useState({})[0],Y=i.useCallback((function(e){var t=e.captureFocusRestore;if(!u.current){var n,r=null==(n=document)?void 0:n.activeElement;u.current=r,r!==document.body&&(u.current=t(r))}l.current&&N&&N(l.current),c.current=!0,d()}),[N]),$=i.useCallback((function(){c.current=!1,F&&F(l.current),d()}),[F]),H=i.useCallback((function(e){var t=u.current;if(t){var n=("function"==typeof t?t():t)||document.body,r="function"==typeof B?B(n):B;if(r){var o="object"==typeof r?r:void 0;u.current=null,e?Promise.resolve().then((function(){return n.focus(o)})):n.focus(o)}}}),[B]),U=i.useCallback((function(e){c.current&&UB.useMedium(e)}),[]),z=zB.useMedium,W=i.useCallback((function(e){l.current!==e&&(l.current=e,s(e))}),[]);var V=n(((r={})[OB]=h&&"disabled",r[TB]=w,r),L),G=!0!==g,Q=G&&"tail"!==g,q=IB([t,W]),K=i.useMemo((function(){return{observed:l,shards:M,enabled:!h,active:c.current}}),[h,c.current,M,a]);return i.createElement(i.Fragment,null,G&&[i.createElement("div",{key:"guard-first","data-focus-guard":!0,tabIndex:h?-1:0,style:BB}),C?i.createElement("div",{key:"guard-nearest","data-focus-guard":!0,tabIndex:h?-1:1,style:BB}):null],!h&&i.createElement(P,{id:j,sideCar:VB,observed:a,disabled:h,persistentFocus:y,crossFrame:_,autoFocus:E,whiteList:k,shards:M,onActivation:Y,onDeactivation:$,returnFocus:H,focusOptions:R}),i.createElement(O,n({ref:q},V,{className:x,onBlur:z,onFocus:U}),i.createElement(GB.Provider,{value:K},p)),Q&&i.createElement("div",{"data-focus-guard":!0,tabIndex:h?-1:0,style:BB}))}));qB.propTypes={};const KB=qB;function ZB(e,t){return ZB=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},ZB(e,t)}const JB=function(e,t){return function(n){var r,o=[];function a(){r=e(o.map((function(e){return e.props}))),t(r)}var s=function(e){function t(){return e.apply(this,arguments)||this}!function(e,t){e.prototype=Object.create(t.prototype),e.prototype.constructor=e,ZB(e,t)}(t,e),t.peek=function(){return r};var s=t.prototype;return s.componentDidMount=function(){o.push(this),a()},s.componentDidUpdate=function(){a()},s.componentWillUnmount=function(){var e=o.indexOf(this);o.splice(e,1),a()},s.render=function(){return i.createElement(n,this.props)},t}(i.PureComponent);return kC(s,"displayName","SideEffect("+function(e){return e.displayName||e.name||"Component"}(n)+")"),s}};var XB=function(e){for(var t=Array(e.length),n=0;n<e.length;++n)t[n]=e[n];return t},eR=function(e){return Array.isArray(e)?e:[e]},tR=function(e){return Array.isArray(e)?e[0]:e},nR=function(e){return e.parentNode&&e.parentNode.nodeType===Node.DOCUMENT_FRAGMENT_NODE?e.parentNode.host:e.parentNode},rR=function(e){return e===document||e&&e.nodeType===Node.DOCUMENT_NODE},oR=function(e,t){return!e||rR(e)||!function(e){if(e.nodeType!==Node.ELEMENT_NODE)return!1;var t=window.getComputedStyle(e,null);return!(!t||!t.getPropertyValue||"none"!==t.getPropertyValue("display")&&"hidden"!==t.getPropertyValue("visibility"))}(e)&&!function(e){return e.hasAttribute("inert")}(e)&&t(nR(e))},iR=function(e,t){var n=e.get(t);if(void 0!==n)return n;var r=oR(t,iR.bind(void 0,e));return e.set(t,r),r},aR=function(e,t){var n=e.get(t);if(void 0!==n)return n;var r=function(e,t){return!(e&&!rR(e))||!!uR(e)&&t(nR(e))}(t,aR.bind(void 0,e));return e.set(t,r),r},sR=function(e){return e.dataset},lR=function(e){return"INPUT"===e.tagName},cR=function(e){return lR(e)&&"radio"===e.type},uR=function(e){var t=e.getAttribute("data-no-autofocus");return![!0,"true",""].includes(t)},dR=function(e){var t;return Boolean(e&&(null===(t=sR(e))||void 0===t?void 0:t.focusGuard))},pR=function(e){return!dR(e)},fR=function(e){return Boolean(e)},hR=function(e,t){var n=Math.max(0,e.tabIndex),r=Math.max(0,t.tabIndex),o=n-r,i=e.index-t.index;if(o){if(!n)return 1;if(!r)return-1}return o||i},mR=function(e,t,n){return XB(e).map((function(e,t){var r=function(e){return e.tabIndex<0&&!e.hasAttribute("tabindex")?0:e.tabIndex}(e);return{node:e,index:t,tabIndex:n&&-1===r?(e.dataset||{}).focusGuard?0:-1:r}})).filter((function(e){return!t||e.tabIndex>=0})).sort(hR)},gR=["button:enabled","select:enabled","textarea:enabled","input:enabled","a[href]","area[href]","summary","iframe","object","embed","audio[controls]","video[controls]","[tabindex]","[contenteditable]","[autofocus]"].join(","),vR="".concat(gR,", [data-focus-guard]"),yR=function(e,t){return XB((e.shadowRoot||e).children).reduce((function(e,n){return e.concat(n.matches(t?vR:gR)?[n]:[],yR(n))}),[])},bR=function(e,t){return e.reduce((function(e,n){var r,o=yR(n,t),i=(r=[]).concat.apply(r,o.map((function(e){return function(e,t){var n;return e instanceof HTMLIFrameElement&&(null===(n=e.contentDocument)||void 0===n?void 0:n.body)?bR([e.contentDocument.body],t):[e]}(e,t)})));return e.concat(i,n.parentNode?XB(n.parentNode.querySelectorAll(gR)).filter((function(e){return e===n})):[])}),[])},_R=function(e,t){return XB(e).filter((function(e){return iR(t,e)})).filter((function(e){return function(e){return!((lR(e)||function(e){return"BUTTON"===e.tagName}(e))&&("hidden"===e.type||e.disabled))}(e)}))},AR=function(e,t){return void 0===t&&(t=new Map),XB(e).filter((function(e){return aR(t,e)}))},ER=function(e,t,n){return mR(_R(bR(e,n),t),!0,n)},wR=function(e,t){return mR(_R(bR(e),t),!1)},xR=function(e,t){return _R((n=e.querySelectorAll("[".concat("data-autofocus-inside","]")),XB(n).map((function(e){return bR([e])})).reduce((function(e,t){return e.concat(t)}),[])),t);var n},kR=function(e,t){return e.shadowRoot?kR(e.shadowRoot,t):!(void 0===Object.getPrototypeOf(e).contains||!Object.getPrototypeOf(e).contains.call(e,t))||XB(e.children).some((function(e){var n;if(e instanceof HTMLIFrameElement){var r=null===(n=e.contentDocument)||void 0===n?void 0:n.body;return!!r&&kR(r,t)}return kR(e,t)}))},CR=function(e){if(void 0===e&&(e=document),e&&e.activeElement){var t=e.activeElement;return t.shadowRoot?CR(t.shadowRoot):t instanceof HTMLIFrameElement&&function(e){try{return e()}catch(e){return}}((function(){return t.contentWindow.document}))?CR(t.contentWindow.document):t}},SR=function(e){return e.parentNode?SR(e.parentNode):e},MR=function(e){return eR(e).filter(Boolean).reduce((function(e,t){var n=t.getAttribute(TB);return e.push.apply(e,n?function(e){for(var t=new Set,n=e.length,r=0;r<n;r+=1)for(var o=r+1;o<n;o+=1){var i=e[r].compareDocumentPosition(e[o]);(i&Node.DOCUMENT_POSITION_CONTAINED_BY)>0&&t.add(o),(i&Node.DOCUMENT_POSITION_CONTAINS)>0&&t.add(r)}return e.filter((function(e,n){return!t.has(n)}))}(XB(SR(t).querySelectorAll("[".concat(TB,'="').concat(n,'"]:not([').concat(OB,'="disabled"])')))):[t]),e}),[])},TR=function(e,t){return void 0===t&&(t=CR(tR(e).ownerDocument)),!(!t||t.dataset&&t.dataset.focusGuard)&&MR(e).some((function(e){return kR(e,t)||function(e,t){return Boolean(XB(e.querySelectorAll("iframe")).some((function(e){return function(e,t){return e===t}(e,t)})))}(e,t)}))},OR=function(e,t){e&&("focus"in e&&e.focus(t),"contentWindow"in e&&e.contentWindow&&e.contentWindow.focus())},DR=function(e,t){return cR(e)&&e.name?function(e,t){return t.filter(cR).filter((function(t){return t.name===e.name})).filter((function(e){return e.checked}))[0]||e}(e,t):e},LR=function(e){return e[0]&&e.length>1?DR(e[0],e):e[0]},PR=function(e,t){return e.indexOf(DR(t,e))},IR="NEW_FOCUS",BR=function(e,t,n,r,o){var i=e.length,a=e[0],s=e[i-1],l=dR(r);if(!(r&&e.indexOf(r)>=0)){var c=void 0!==r?n.indexOf(r):-1,u=o?n.indexOf(o):c,d=o?e.indexOf(o):-1;if(-1===c)return-1!==d?d:IR;if(-1===d)return IR;var p,f,h=c-u,m=n.indexOf(a),g=n.indexOf(s),v=(p=n,f=new Set,p.forEach((function(e){return f.add(DR(e,p))})),p.filter((function(e){return f.has(e)}))),y=(void 0!==r?v.indexOf(r):-1)-(o?v.indexOf(o):c);if(!h&&d>=0)return d;if(0===t.length)return d;var b=PR(e,t[0]),_=PR(e,t[t.length-1]);return c<=m&&l&&Math.abs(h)>1?_:c>=g&&l&&Math.abs(h)>1?b:h&&Math.abs(y)>1?d:c<=m?_:c>g?b:h?Math.abs(h)>1?d:(i+d+h)%i:void 0}},RR=function(e,t,n){var r,o=e.map((function(e){return e.node})),i=AR(o.filter((r=n,function(e){var t,n=null===(t=sR(e))||void 0===t?void 0:t.autofocus;return e.autofocus||void 0!==n&&"false"!==n||r.indexOf(e)>=0})));return i&&i.length?LR(i):LR(AR(t))},NR=function(e,t){return void 0===t&&(t=[]),t.push(e),e.parentNode&&NR(e.parentNode.host||e.parentNode,t),t},FR=function(e,t){for(var n=NR(e),r=NR(t),o=0;o<n.length;o+=1){var i=n[o];if(r.indexOf(i)>=0)return i}return!1},jR=function(e,t,n){var r=eR(e),o=eR(t),i=r[0],a=!1;return o.filter(Boolean).forEach((function(e){a=FR(a||e,e)||a,n.filter(Boolean).forEach((function(e){var t=FR(i,e);t&&(a=!a||kR(t,a)?t:FR(t,a))}))})),a},YR=function(e,t){return e.reduce((function(e,n){return e.concat(xR(n,t))}),[])},$R=function(e,t){var n=CR(eR(e).length>0?document:tR(e).ownerDocument),r=MR(e).filter(pR),o=jR(n||e,e,r),i=new Map,a=wR(r,i),s=a.filter((function(e){var t=e.node;return pR(t)}));if(s[0]){var l,c,u,d=wR([o],i).map((function(e){return e.node})),p=(l=d,c=s,u=new Map,c.forEach((function(e){return u.set(e.node,e)})),l.map((function(e){return u.get(e)})).filter(fR)),f=p.map((function(e){return e.node})),h=p.filter((function(e){return e.tabIndex>=0})).map((function(e){return e.node})),m=BR(f,h,d,n,t);if(m===IR){var g=RR(a,h,YR(r,i))||RR(a,f,YR(r,i));return g?{node:g}:void console.warn("focus-lock: cannot find any node to move focus into")}return void 0===m?m:p[m]}},HR=0,UR=!1,zR=function(e,t,n){void 0===n&&(n={});var r=$R(e,t);if(!UR&&r){if(HR>2)return console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"),UR=!0,void setTimeout((function(){UR=!1}),1);HR++,OR(r.node,n.focusOptions),HR--}},WR=function(e,t,n){void 0===t&&(t={});var r=function(e){return Object.assign({scope:document.body,cycle:!0,onlyTabbable:!0},e)}(t),o=function(e,t,n){if(!e||!t)return console.error("no element or scope given"),{};var r=eR(t);if(r.every((function(t){return!kR(t,e)})))return console.error("Active element is not contained in the scope"),{};var o=n?ER(r,new Map):wR(r,new Map),i=o.findIndex((function(t){return t.node===e}));return-1!==i?{prev:o[i-1],next:o[i+1],first:o[0],last:o[o.length-1]}:void 0}(e,r.scope,r.onlyTabbable);if(o){var i=n(o,r.cycle);i&&OR(i.node,r.focusOptions)}},VR=function(e,t,n){var r,o=function(e,t){var n=t?ER(eR(e),new Map):wR(eR(e),new Map);return{first:n[0],last:n[n.length-1]}}(e,null===(r=t.onlyTabbable)||void 0===r||r),i=o[n];i&&OR(i.node,t.focusOptions)};function GR(e){if(!e)return null;if("undefined"==typeof WeakRef)return function(){return e||null};var t=e?new WeakRef(e):null;return function(){return(null==t?void 0:t.deref())||null}}function QR(e){setTimeout(e,1)}var qR=function(e){return e&&"current"in e?e.current:e},KR=function(){return document&&document.activeElement===document.body||function(e){void 0===e&&(e=document);var t=CR(e);return!!t&&XB(e.querySelectorAll("[".concat("data-no-focus-lock","]"))).some((function(e){return kR(e,t)}))}()},ZR=null,JR=null,XR=null,eN=!1,tN=function(){return!0};function nN(e,t,n,r){var o=null,i=e;do{var a=r[i];if(a.guard)a.node.dataset.focusAutoGuard&&(o=a);else{if(!a.lockItem)break;if(i!==e)return;o=null}}while((i+=n)!==t);o&&(o.node.tabIndex=0)}var rN=function e(t,n,r){return n&&(n.host===t&&(!n.activeElement||r.contains(n.activeElement))||n.parentNode&&e(t,n.parentNode,r))},oN=function(){var e,t=!1;if(ZR){var n=ZR,r=n.observed,o=n.persistentFocus,i=n.autoFocus,a=n.shards,s=n.crossFrame,l=n.focusOptions,c=r||XR&&XR.portaledElement,u=document&&document.activeElement;if(c){var d=[c].concat(a.map(qR).filter(Boolean));if(u&&!function(e){return(ZR.whiteList||tN)(e)}(u)||(o||(s?Boolean(eN):"meanwhile"===eN)||!KR()||!JR&&i)&&(c&&!(TR(d)||u&&function(e,t){return t.some((function(t){return rN(e,t,t)}))}(u,d)||(e=u,XR&&XR.portaledElement===e))&&(document&&!JR&&u&&!i?(u.blur&&u.blur(),document.body.focus()):(t=zR(d,JR,{focusOptions:l}),XR={})),eN=!1,JR=document&&document.activeElement),document&&u!==document.activeElement&&document.querySelector("[data-focus-auto-guard]")){var p=document&&document.activeElement,f=function(e){var t=MR(e).filter(pR),n=jR(e,e,t),r=mR(bR([n],!0),!0,!0),o=bR(t,!1);return r.map((function(e){var t=e.node;return{node:t,index:e.index,lockItem:o.indexOf(t)>=0,guard:dR(t)}}))}(d),h=f.map((function(e){return e.node})).indexOf(p);h>-1&&(f.filter((function(e){var t=e.guard,n=e.node;return t&&n.dataset.focusAutoGuard})).forEach((function(e){return e.node.removeAttribute("tabIndex")})),nN(h,f.length,1,f),nN(h,-1,-1,f))}}}return t},iN=function(e){oN()&&e&&(e.stopPropagation(),e.preventDefault())},aN=function(){return QR(oN)},sN=function(e){var t=e.target,n=e.currentTarget;n.contains(t)||(XR={observerNode:n,portaledElement:t})},lN=function(){eN="just",QR((function(){eN="meanwhile"}))};var cN={moveFocusInside:zR,focusInside:TR,focusNextElement:function(e,t){void 0===t&&(t={}),WR(e,t,(function(e,t){var n=e.next,r=e.first;return n||t&&r}))},focusPrevElement:function(e,t){void 0===t&&(t={}),WR(e,t,(function(e,t){var n=e.prev,r=e.last;return n||t&&r}))},focusFirstElement:function(e,t){void 0===t&&(t={}),VR(e,t,"first")},focusLastElement:function(e,t){void 0===t&&(t={}),VR(e,t,"last")},captureFocusRestore:function(e){var t=function(e){if(!e)return null;for(var t=[],n=e;n&&n!==document.body;)t.push({current:GR(n),parent:GR(n.parentElement),left:GR(n.previousElementSibling),right:GR(n.nextElementSibling)}),n=n.parentElement;return{element:GR(e),stack:t,ownerDocument:e.ownerDocument}}(e);return function(){return function(e){var t,n,r,o,i;if(e)for(var a=e.stack,s=e.ownerDocument,l=new Map,c=0,u=a;c<u.length;c++){var d=u[c],p=null===(t=d.parent)||void 0===t?void 0:t.call(d);if(p&&s.contains(p)){for(var f=null===(n=d.left)||void 0===n?void 0:n.call(d),h=d.current(),m=p.contains(h)?h:void 0,g=null===(r=d.right)||void 0===r?void 0:r.call(d),v=ER([p],l),y=null!==(i=null!==(o=null!=m?m:null==f?void 0:f.nextElementSibling)&&void 0!==o?o:g)&&void 0!==i?i:f;y;){for(var b=0,_=v;b<_.length;b++){var A=_[b];if(null==y?void 0:y.contains(A.node))return A.node}y=y.nextElementSibling}if(v.length)return v[0].node}}}(t)}}};UB.assignSyncMedium(sN),zB.assignMedium(aN),WB.assignMedium((function(e){return e(cN)}));const uN=JB((function(e){return e.filter((function(e){return!e.disabled}))}),(function(e){var t=e.slice(-1)[0];t&&!ZR&&(document.addEventListener("focusin",iN),document.addEventListener("focusout",aN),window.addEventListener("blur",lN));var n=ZR,r=n&&t&&t.id===n.id;ZR=t,n&&!r&&(n.onDeactivation(),e.filter((function(e){return e.id===n.id})).length||n.returnFocus(!t)),t?(JR=null,r&&n.observed===t.observed||t.onActivation(cN),oN(),QR(oN)):(document.removeEventListener("focusin",iN),document.removeEventListener("focusout",aN),window.removeEventListener("blur",lN),JR=null)}))((function(){return null}));var dN=i.forwardRef((function(e,t){return i.createElement(KB,n({sideCar:uN,ref:t},e))})),pN=KB.propTypes||{};pN.sideCar,e(pN,["sideCar"]);dN.propTypes={};const fN=dN;var hN=e=>e.hasAttribute("tabindex"),mN=e=>hN(e)&&-1===e.tabIndex;function gN(e){return!(!e.parentElement||!gN(e.parentElement))||e.hidden}function vN(e){if(!rf(e)||gN(e)||function(e){return!0===Boolean(e.getAttribute("disabled"))||!0===Boolean(e.getAttribute("aria-disabled"))}(e))return!1;const{localName:t}=e;if(["input","select","textarea","button"].indexOf(t)>=0)return!0;const n={a:()=>e.hasAttribute("href"),audio:()=>e.hasAttribute("controls"),video:()=>e.hasAttribute("controls")};return t in n?n[t]():!!function(e){const t=e.getAttribute("contenteditable");return"false"!==t&&null!=t}(e)||hN(e)}var yN,bN=["input:not(:disabled):not([disabled])","select:not(:disabled):not([disabled])","textarea:not(:disabled):not([disabled])","embed","iframe","object","a[href]","area[href]","button:not(:disabled):not([disabled])","[tabindex]","audio[controls]","video[controls]","*[tabindex]:not([aria-disabled])","*[contenteditable]"].join(),_N=e=>e.offsetWidth>0&&e.offsetHeight>0;function AN(e){const t=Array.from(e.querySelectorAll(bN));return t.unshift(e),t.filter((e=>vN(e)&&_N(e)))}var EN=null!=(yN=fN.default)?yN:fN,wN=e=>{const{initialFocusRef:t,finalFocusRef:n,contentRef:r,restoreFocus:o,children:a,isDisabled:s,autoFocus:l,persistentFocus:c,lockFocusAcrossFrames:u}=e,d=(0,i.useCallback)((()=>{if(null==t?void 0:t.current)t.current.focus();else if(null==r?void 0:r.current){0===AN(r.current).length&&requestAnimationFrame((()=>{var e;null==(e=r.current)||e.focus()}))}}),[t,r]),p=(0,i.useCallback)((()=>{var e;null==(e=null==n?void 0:n.current)||e.focus()}),[n]),f=o&&!n;return(0,br.jsx)(EN,{crossFrame:u,persistentFocus:c,autoFocus:l,disabled:s,onActivation:d,onDeactivation:p,returnFocus:f,children:a})};wN.displayName="FocusLock";var xN=function(){return xN=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e},xN.apply(this,arguments)};function kN(e,t){var n={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var o=0;for(r=Object.getOwnPropertySymbols(e);o<r.length;o++)t.indexOf(r[o])<0&&Object.prototype.propertyIsEnumerable.call(e,r[o])&&(n[r[o]]=e[r[o]])}return n}Object.create;function CN(e,t,n){if(n||2===arguments.length)for(var r,o=0,i=t.length;o<i;o++)!r&&o in t||(r||(r=Array.prototype.slice.call(t,0,o)),r[o]=t[o]);return e.concat(r||Array.prototype.slice.call(t))}Object.create;"function"==typeof SuppressedError&&SuppressedError;var SN="right-scroll-bar-position",MN="width-before-scroll-bar",TN=HB(),ON=function(){},DN=i.forwardRef((function(e,t){var n=i.useRef(null),r=i.useState({onScrollCapture:ON,onWheelCapture:ON,onTouchMoveCapture:ON}),o=r[0],a=r[1],s=e.forwardProps,l=e.children,c=e.className,u=e.removeScrollBar,d=e.enabled,p=e.shards,f=e.sideCar,h=e.noIsolation,m=e.inert,g=e.allowPinchZoom,v=e.as,y=void 0===v?"div":v,b=e.gapMode,_=kN(e,["forwardProps","children","className","removeScrollBar","enabled","shards","sideCar","noIsolation","inert","allowPinchZoom","as","gapMode"]),A=f,E=IB([n,t]),w=xN(xN({},_),o);return i.createElement(i.Fragment,null,d&&i.createElement(A,{sideCar:TN,removeScrollBar:u,shards:p,noIsolation:h,inert:m,setCallbacks:a,allowPinchZoom:!!g,lockRef:n,gapMode:b}),s?i.cloneElement(i.Children.only(l),xN(xN({},w),{ref:E})):i.createElement(y,xN({},w,{className:c,ref:E}),l))}));DN.defaultProps={enabled:!0,removeScrollBar:!0,inert:!1},DN.classNames={fullWidth:MN,zeroRight:SN};var LN,PN=function(e){var t=e.sideCar,n=FB(e,["sideCar"]);if(!t)throw new Error("Sidecar: please provide `sideCar` property to import the right car");var r=t.read();if(!r)throw new Error("Sidecar medium not found");return i.createElement(r,NB({},n))};PN.isSideCarExport=!0;function IN(){if(!document)return null;var e=document.createElement("style");e.type="text/css";var t=LN||o.nc;return t&&e.setAttribute("nonce",t),e}var BN=function(){var e=0,t=null;return{add:function(n){0==e&&(t=IN())&&(function(e,t){e.styleSheet?e.styleSheet.cssText=t:e.appendChild(document.createTextNode(t))}(t,n),function(e){(document.head||document.getElementsByTagName("head")[0]).appendChild(e)}(t)),e++},remove:function(){! --e&&t&&(t.parentNode&&t.parentNode.removeChild(t),t=null)}}},RN=function(){var e,t=(e=BN(),function(t,n){i.useEffect((function(){return e.add(t),function(){e.remove()}}),[t&&n])});return function(e){var n=e.styles,r=e.dynamic;return t(n,r),null}},NN={left:0,top:0,right:0,gap:0},FN=function(e){return parseInt(e||"",10)||0},jN=function(e){if(void 0===e&&(e="margin"),"undefined"==typeof window)return NN;var t=function(e){var t=window.getComputedStyle(document.body),n=t["padding"===e?"paddingLeft":"marginLeft"],r=t["padding"===e?"paddingTop":"marginTop"],o=t["padding"===e?"paddingRight":"marginRight"];return[FN(n),FN(r),FN(o)]}(e),n=document.documentElement.clientWidth,r=window.innerWidth;return{left:t[0],top:t[1],right:t[2],gap:Math.max(0,r-n+t[2]-t[0])}},YN=RN(),$N="data-scroll-locked",HN=function(e,t,n,r){var o=e.left,i=e.top,a=e.right,s=e.gap;return void 0===n&&(n="margin"),"\n  .".concat("with-scroll-bars-hidden"," {\n   overflow: hidden ").concat(r,";\n   padding-right: ").concat(s,"px ").concat(r,";\n  }\n  body[").concat($N,"] {\n    overflow: hidden ").concat(r,";\n    overscroll-behavior: contain;\n    ").concat([t&&"position: relative ".concat(r,";"),"margin"===n&&"\n    padding-left: ".concat(o,"px;\n    padding-top: ").concat(i,"px;\n    padding-right: ").concat(a,"px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(s,"px ").concat(r,";\n    "),"padding"===n&&"padding-right: ".concat(s,"px ").concat(r,";")].filter(Boolean).join(""),"\n  }\n  \n  .").concat(SN," {\n    right: ").concat(s,"px ").concat(r,";\n  }\n  \n  .").concat(MN," {\n    margin-right: ").concat(s,"px ").concat(r,";\n  }\n  \n  .").concat(SN," .").concat(SN," {\n    right: 0 ").concat(r,";\n  }\n  \n  .").concat(MN," .").concat(MN," {\n    margin-right: 0 ").concat(r,";\n  }\n  \n  body[").concat($N,"] {\n    ").concat("--removed-body-scroll-bar-size",": ").concat(s,"px;\n  }\n")},UN=function(){var e=parseInt(document.body.getAttribute($N)||"0",10);return isFinite(e)?e:0},zN=function(e){var t=e.noRelative,n=e.noImportant,r=e.gapMode,o=void 0===r?"margin":r;i.useEffect((function(){return document.body.setAttribute($N,(UN()+1).toString()),function(){var e=UN()-1;e<=0?document.body.removeAttribute($N):document.body.setAttribute($N,e.toString())}}),[]);var a=i.useMemo((function(){return jN(o)}),[o]);return i.createElement(YN,{styles:HN(a,!t,o,n?"":"!important")})},WN=!1;if("undefined"!=typeof window)try{var VN=Object.defineProperty({},"passive",{get:function(){return WN=!0,!0}});window.addEventListener("test",VN,VN),window.removeEventListener("test",VN,VN)}catch(e){WN=!1}var GN=!!WN&&{passive:!1},QN=function(e,t){if(!(e instanceof Element))return!1;var n=window.getComputedStyle(e);return"hidden"!==n[t]&&!(n.overflowY===n.overflowX&&!function(e){return"TEXTAREA"===e.tagName}(e)&&"visible"===n[t])},qN=function(e,t){var n=t.ownerDocument,r=t;do{if("undefined"!=typeof ShadowRoot&&r instanceof ShadowRoot&&(r=r.host),KN(e,r)){var o=ZN(e,r);if(o[1]>o[2])return!0}r=r.parentNode}while(r&&r!==n.body);return!1},KN=function(e,t){return"v"===e?function(e){return QN(e,"overflowY")}(t):function(e){return QN(e,"overflowX")}(t)},ZN=function(e,t){return"v"===e?function(e){return[e.scrollTop,e.scrollHeight,e.clientHeight]}(t):function(e){return[e.scrollLeft,e.scrollWidth,e.clientWidth]}(t)},JN=function(e){return"changedTouches"in e?[e.changedTouches[0].clientX,e.changedTouches[0].clientY]:[0,0]},XN=function(e){return[e.deltaX,e.deltaY]},eF=function(e){return e&&"current"in e?e.current:e},tF=function(e){return"\n  .block-interactivity-".concat(e," {pointer-events: none;}\n  .allow-interactivity-").concat(e," {pointer-events: all;}\n")},nF=0,rF=[];function oF(e){for(var t=null;null!==e;)e instanceof ShadowRoot&&(t=e.host,e=e.host),e=e.parentNode;return t}const iF=(aF=function(e){var t=i.useRef([]),n=i.useRef([0,0]),r=i.useRef(),o=i.useState(nF++)[0],a=i.useState(RN)[0],s=i.useRef(e);i.useEffect((function(){s.current=e}),[e]),i.useEffect((function(){if(e.inert){document.body.classList.add("block-interactivity-".concat(o));var t=CN([e.lockRef.current],(e.shards||[]).map(eF),!0).filter(Boolean);return t.forEach((function(e){return e.classList.add("allow-interactivity-".concat(o))})),function(){document.body.classList.remove("block-interactivity-".concat(o)),t.forEach((function(e){return e.classList.remove("allow-interactivity-".concat(o))}))}}}),[e.inert,e.lockRef.current,e.shards]);var l=i.useCallback((function(e,t){if("touches"in e&&2===e.touches.length)return!s.current.allowPinchZoom;var o,i=JN(e),a=n.current,l="deltaX"in e?e.deltaX:a[0]-i[0],c="deltaY"in e?e.deltaY:a[1]-i[1],u=e.target,d=Math.abs(l)>Math.abs(c)?"h":"v";if("touches"in e&&"h"===d&&"range"===u.type)return!1;var p=qN(d,u);if(!p)return!0;if(p?o=d:(o="v"===d?"h":"v",p=qN(d,u)),!p)return!1;if(!r.current&&"changedTouches"in e&&(l||c)&&(r.current=o),!o)return!0;var f=r.current||o;return function(e,t,n,r,o){var i=function(e,t){return"h"===e&&"rtl"===t?-1:1}(e,window.getComputedStyle(t).direction),a=i*r,s=n.target,l=t.contains(s),c=!1,u=a>0,d=0,p=0;do{var f=ZN(e,s),h=f[0],m=f[1]-f[2]-i*h;(h||m)&&KN(e,s)&&(d+=m,p+=h),s=s instanceof ShadowRoot?s.host:s.parentNode}while(!l&&s!==document.body||l&&(t.contains(s)||t===s));return(u&&(o&&Math.abs(d)<1||!o&&a>d)||!u&&(o&&Math.abs(p)<1||!o&&-a>p))&&(c=!0),c}(f,t,e,"h"===f?l:c,!0)}),[]),c=i.useCallback((function(e){var n=e;if(rF.length&&rF[rF.length-1]===a){var r="deltaY"in n?XN(n):JN(n),o=t.current.filter((function(e){return e.name===n.type&&(e.target===n.target||n.target===e.shadowParent)&&function(e,t){return e[0]===t[0]&&e[1]===t[1]}(e.delta,r)}))[0];if(o&&o.should)n.cancelable&&n.preventDefault();else if(!o){var i=(s.current.shards||[]).map(eF).filter(Boolean).filter((function(e){return e.contains(n.target)}));(i.length>0?l(n,i[0]):!s.current.noIsolation)&&n.cancelable&&n.preventDefault()}}}),[]),u=i.useCallback((function(e,n,r,o){var i={name:e,delta:n,target:r,should:o,shadowParent:oF(r)};t.current.push(i),setTimeout((function(){t.current=t.current.filter((function(e){return e!==i}))}),1)}),[]),d=i.useCallback((function(e){n.current=JN(e),r.current=void 0}),[]),p=i.useCallback((function(t){u(t.type,XN(t),t.target,l(t,e.lockRef.current))}),[]),f=i.useCallback((function(t){u(t.type,JN(t),t.target,l(t,e.lockRef.current))}),[]);i.useEffect((function(){return rF.push(a),e.setCallbacks({onScrollCapture:p,onWheelCapture:p,onTouchMoveCapture:f}),document.addEventListener("wheel",c,GN),document.addEventListener("touchmove",c,GN),document.addEventListener("touchstart",d,GN),function(){rF=rF.filter((function(e){return e!==a})),document.removeEventListener("wheel",c,GN),document.removeEventListener("touchmove",c,GN),document.removeEventListener("touchstart",d,GN)}}),[]);var h=e.removeScrollBar,m=e.inert;return i.createElement(i.Fragment,null,m?i.createElement(a,{styles:tF(o)}):null,h?i.createElement(zN,{gapMode:e.gapMode}):null)},TN.useMedium(aF),PN);var aF,sF=i.forwardRef((function(e,t){return i.createElement(DN,xN({},e,{ref:t,sideCar:iF}))}));sF.classNames=DN.classNames;const lF=sF;function cF(e){const{autoFocus:t,trapFocus:n,dialogRef:r,initialFocusRef:o,blockScrollOnMount:a,allowPinchZoom:s,finalFocusRef:l,returnFocusOnClose:c,preserveScrollBarGap:u,lockFocusAcrossFrames:d,isOpen:p}=aB(),[f,h]=cE();(0,i.useEffect)((()=>{!f&&h&&setTimeout(h)}),[f,h]);const m=GI(r,p);return(0,br.jsx)(wN,{autoFocus:t,isDisabled:!n,initialFocusRef:o,finalFocusRef:l,restoreFocus:c,contentRef:r,lockFocusAcrossFrames:d,children:(0,br.jsx)(lF,{removeScrollBar:!u,allowPinchZoom:s,enabled:1===m&&a,forwardProps:!0,children:e.children})})}var uF=yr(((e,t)=>{const{className:n,children:r,containerProps:o,motionProps:i,...a}=e,{getDialogProps:s,getDialogContainerProps:l}=aB(),c=s(a,t),u=l(o),d=g("chakra-modal__content",n),p=oB(),f={display:"flex",flexDirection:"column",position:"relative",width:"100%",outline:0,...p.dialog},h={display:"flex",width:"100vw",height:"$100vh",position:"fixed",left:0,top:0,...p.dialogContainer},{motionPreset:m}=aB();return(0,br.jsx)(cF,{children:(0,br.jsx)(vr.div,{...u,className:"chakra-modal__content-container",tabIndex:-1,__css:h,children:(0,br.jsx)(MB,{preset:m,motionProps:i,className:d,...c,__css:f,children:r})})})}));uF.displayName="ModalContent";var dF=yr(((e,t)=>{const{className:n,...r}=e,{headerId:o,setHeaderMounted:a}=aB();(0,i.useEffect)((()=>(a(!0),()=>a(!1))),[a]);const s=g("chakra-modal__header",n),l={flex:0,...oB().header};return(0,br.jsx)(vr.header,{ref:t,className:s,id:o,...r,__css:l})}));dF.displayName="ModalHeader";var pF=yr(((e,t)=>{const{className:n,...r}=e,o=g("chakra-modal__footer",n),i={display:"flex",alignItems:"center",justifyContent:"flex-end",...oB().footer};return(0,br.jsx)(vr.footer,{ref:t,...r,__css:i,className:o})}));pF.displayName="ModalFooter";var fF={enter:({transition:e,transitionEnd:t,delay:n}={})=>{var r;return{opacity:1,transition:null!=(r=null==e?void 0:e.enter)?r:vB(gB.enter,n),transitionEnd:null==t?void 0:t.enter}},exit:({transition:e,transitionEnd:t,delay:n}={})=>{var r;return{opacity:0,transition:null!=(r=null==e?void 0:e.exit)?r:yB(gB.exit,n),transitionEnd:null==t?void 0:t.exit}}},hF={initial:"exit",animate:"enter",exit:"exit",variants:fF},mF=(0,i.forwardRef)((function(e,t){const{unmountOnExit:n,in:r,className:o,transition:i,transitionEnd:a,delay:s,...l}=e,c=r||n?"enter":"exit",u=!n||r&&n,d={transition:i,transitionEnd:a,delay:s};return(0,br.jsx)(qw,{custom:d,children:u&&(0,br.jsx)(Yw.div,{ref:t,className:g("chakra-fade",o),custom:d,...hF,animate:c,...l})})}));mF.displayName="Fade";var gF=vr(Yw.div),vF=yr(((e,t)=>{const{className:n,transition:r,motionProps:o,...i}=e,a=g("chakra-modal__overlay",n),s={pos:"fixed",left:"0",top:"0",w:"100vw",h:"100vh",...oB().overlay},{motionPreset:l}=aB(),c=o||("none"===l?{}:hF);return(0,br.jsx)(gF,{...c,__css:s,ref:t,className:a,...i})}));vF.displayName="ModalOverlay";const yF=function(e){var t={};return function(n){return void 0===t[n]&&(t[n]=e(n)),t[n]}};var bF=/^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;const _F=yF((function(e){return bF.test(e)||111===e.charCodeAt(0)&&110===e.charCodeAt(1)&&e.charCodeAt(2)<91}));var AF=["children"];function EF(){return EF=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},EF.apply(null,arguments)}var wF=pr(qr,{target:"e70xvew0"})((e=>{var{theme:t}=e;return"\n        color: "+t.fontColor.default+";\n        font-family: "+t.fonts.heading+";\n        font-size: "+t.fontSizes.lg+";\n        font-weight: "+t.fontWeights.normal+";\n        line-height: "+t.lineHeights.lg+";\n        margin-bottom: "+t.space[5]+";\n    "}),"");const xF=e=>{var{children:t}=e,n=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,AF);return Mr(wF,EF({as:"h3"},n),t)};var kF=function(e){return Mr("svg",e,Mr("circle",{cx:"35",cy:"35",r:"33",stroke:"#FF5058",strokeWidth:"3"}),Mr("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M35 18a2 2 0 00-2 2v20a2 2 0 104 0V20a2 2 0 00-2-2zm0 28a2 2 0 100 4 2 2 0 000-4z",fill:"#FF5058"}))};kF.defaultProps={viewBox:"0 0 70 70",fill:"none",xmlns:"http://www.w3.org/2000/svg"};var CF=function(e){return Mr("svg",e,Mr("path",{d:"M14.492 2.907L2.223 23.63c-.79 1.333.172 3.02 1.721 3.02h24.538c1.55 0 2.51-1.687 1.721-3.02L17.934 2.907c-.774-1.308-2.667-1.308-3.442 0z",stroke:"#F29F18",strokeWidth:"2"}),Mr("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M16 11a1 1 0 00-1 1v5a1 1 0 102 0v-5a1 1 0 00-1-1zm0 8a1 1 0 100 2 1 1 0 000-2z",fill:"#F29F18"}))};CF.defaultProps={viewBox:"0 0 32 28",fill:"none",xmlns:"http://www.w3.org/2000/svg"};var SF=function(e){return Mr("svg",e,Mr("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M12.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM12.5 13a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM12.5 19a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",fill:"#9FB0B7"}))};SF.defaultProps={viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg"};var MF=function(e){return Mr("svg",e,Mr("path",{opacity:".349",fillRule:"evenodd",clipRule:"evenodd",d:"M113 26H6C2.686 26 0 23.314 0 20V6C0 2.686 2.686 0 6 0H113C116.314 0 119 2.686 119 6V20C119 23.314 116.314 26 113 26ZM118 6C118 3.239 115.761 1 113 1H6C3.239 1 1 3.239 1 6V20C1 22.761 3.239 25 6 25H113C115.761 25 118 22.761 118 20V6Z",fill:"#424770"}),Mr("path",{opacity:".502",fillRule:"evenodd",clipRule:"evenodd",d:"M60.7 18.437H59.395L60.405 15.943L58.395 10.871H59.774L61.037 14.323L62.31 10.871H63.689L60.7 18.437ZM55.69 16.259C55.238 16.259 54.774 16.091 54.354 15.764V16.133H53.007V8.56601H54.354V11.229C54.774 10.913 55.238 10.745 55.69 10.745C57.1 10.745 58.068 11.881 58.068 13.502C58.068 15.122 57.1 16.259 55.69 16.259ZM55.406 11.902C55.038 11.902 54.669 12.06 54.354 12.376V14.628C54.669 14.943 55.038 15.101 55.406 15.101C56.164 15.101 56.69 14.449 56.69 13.502C56.69 12.555 56.164 11.902 55.406 11.902ZM47.554 15.764C47.144 16.091 46.681 16.259 46.218 16.259C44.818 16.259 43.84 15.122 43.84 13.502C43.84 11.881 44.818 10.745 46.218 10.745C46.681 10.745 47.144 10.913 47.554 11.229V8.56601H48.912V16.133H47.554V15.764ZM47.554 12.376C47.249 12.06 46.881 11.902 46.513 11.902C45.744 11.902 45.218 12.555 45.218 13.502C45.218 14.449 45.744 15.101 46.513 15.101C46.881 15.101 47.249 14.943 47.554 14.628V12.376ZM39.535 13.87C39.619 14.67 40.251 15.217 41.134 15.217C41.619 15.217 42.155 15.038 42.702 14.722V15.849C42.103 16.122 41.503 16.259 40.913 16.259C39.324 16.259 38.209 15.101 38.209 13.46C38.209 11.871 39.303 10.745 40.808 10.745C42.187 10.745 43.123 11.829 43.123 13.375C43.123 13.523 43.123 13.691 43.102 13.87H39.535ZM40.756 11.786C40.103 11.786 39.598 12.271 39.535 12.997H41.829C41.787 12.281 41.356 11.786 40.756 11.786ZM35.988 12.618V16.133H34.641V10.871H35.988V11.397C36.367 10.976 36.83 10.745 37.282 10.745C37.43 10.745 37.577 10.755 37.724 10.797V11.997C37.577 11.955 37.409 11.934 37.251 11.934C36.809 11.934 36.335 12.176 35.988 12.618ZM29.979 13.87C30.063 14.67 30.694 15.217 31.578 15.217C32.062 15.217 32.599 15.038 33.146 14.722V15.849C32.546 16.122 31.946 16.259 31.357 16.259C29.768 16.259 28.653 15.101 28.653 13.46C28.653 11.871 29.747 10.745 31.252 10.745C32.63 10.745 33.567 11.829 33.567 13.375C33.567 13.523 33.567 13.691 33.546 13.87H29.979ZM31.199 11.786C30.547 11.786 30.042 12.271 29.979 12.997H32.273C32.231 12.281 31.799 11.786 31.199 11.786ZM25.274 16.133L24.2 12.555L23.137 16.133H21.927L20.117 10.871H21.464L22.527 14.449L23.59 10.871H24.81L25.873 14.449L26.936 10.871H28.283L26.484 16.133H25.274ZM17.043 16.259C15.454 16.259 14.328 15.112 14.328 13.502C14.328 11.881 15.454 10.745 17.043 10.745C18.632 10.745 19.748 11.881 19.748 13.502C19.748 15.112 18.632 16.259 17.043 16.259ZM17.043 11.871C16.254 11.871 15.707 12.534 15.707 13.502C15.707 14.47 16.254 15.133 17.043 15.133C17.822 15.133 18.369 14.47 18.369 13.502C18.369 12.534 17.822 11.871 17.043 11.871ZM11.128 13.533H9.91805V16.133H8.57104V8.89201H11.128C12.602 8.89201 13.654 9.85001 13.654 11.218C13.654 12.586 12.602 13.533 11.128 13.533ZM10.939 9.98701H9.91805V12.439H10.939C11.718 12.439 12.265 11.944 12.265 11.218C12.265 10.482 11.718 9.98701 10.939 9.98701Z",fill:"#424770"}),Mr("path",{opacity:".502",fillRule:"evenodd",clipRule:"evenodd",d:"M111.116 14.051H105.557C105.684 15.382 106.659 15.774 107.766 15.774C108.893 15.774 109.781 15.536 110.555 15.146V17.433C109.784 17.861 108.765 18.169 107.408 18.169C104.642 18.169 102.704 16.437 102.704 13.013C102.704 10.121 104.348 7.82501 107.049 7.82501C109.746 7.82501 111.154 10.12 111.154 13.028C111.154 13.303 111.129 13.898 111.116 14.051ZM107.031 10.14C106.321 10.14 105.532 10.676 105.532 11.955H108.468C108.468 10.677 107.728 10.14 107.031 10.14ZM98.1079 18.169C97.1139 18.169 96.5069 17.75 96.0989 17.451L96.0929 20.664L93.2539 21.268L93.2529 8.01401H95.7529L95.9009 8.71501C96.2929 8.34901 97.0119 7.82501 98.1249 7.82501C100.119 7.82501 101.997 9.62101 101.997 12.927C101.997 16.535 100.139 18.169 98.1079 18.169ZM97.4459 10.34C96.7949 10.34 96.3859 10.578 96.0899 10.903L96.1069 15.122C96.3829 15.421 96.7799 15.661 97.4459 15.661C98.4959 15.661 99.1999 14.518 99.1999 12.989C99.1999 11.504 98.4849 10.34 97.4459 10.34ZM89.1489 8.01401H91.9989V17.966H89.1489V8.01401ZM89.1489 4.83601L91.9989 4.23001V6.54301L89.1489 7.14901V4.83601ZM86.1099 11.219V17.966H83.2719V8.01401H85.7269L85.9049 8.85301C86.5699 7.63101 87.8969 7.87901 88.2749 8.01501V10.625C87.9139 10.508 86.7809 10.338 86.1099 11.219ZM80.0239 14.475C80.0239 16.148 81.8159 15.627 82.1789 15.482V17.793C81.8009 18.001 81.1149 18.169 80.1869 18.169C78.5019 18.169 77.2369 16.928 77.2369 15.247L77.2499 6.13801L80.0219 5.54801L80.0239 8.01401H82.1799V10.435H80.0239V14.475ZM76.4849 14.959C76.4849 17.003 74.8579 18.169 72.4969 18.169C71.5179 18.169 70.4479 17.979 69.3919 17.525V14.814C70.3449 15.332 71.5589 15.721 72.4999 15.721C73.1329 15.721 73.5889 15.551 73.5889 15.026C73.5889 13.671 69.2729 14.181 69.2729 11.038C69.2729 9.02801 70.8079 7.82501 73.1109 7.82501C74.0519 7.82501 74.9919 7.96901 75.9329 8.34401V11.019C75.0689 10.552 73.9719 10.288 73.1089 10.288C72.5139 10.288 72.1439 10.46 72.1439 10.903C72.1439 12.181 76.4849 11.573 76.4849 14.959Z",fill:"#424770"}))};MF.defaultProps={viewBox:"0 0 119 26",fill:"none",xmlns:"http://www.w3.org/2000/svg"};var TF=function(e){return Mr("svg",e,Mr("path",{d:"M0,6.298v-4.04C0,1.254,1.004,0,2.257,0h4.041L4.543,1.756H2.257c-0.249,0-0.501,0.25-0.501,0.502v2.284L0,6.298z"}),Mr("path",{d:"M6.298,15.956H2.257C1.254,15.956,0,14.952,0,13.697V9.658l1.756,1.756v2.284c0,0.252,0.252,0.503,0.501,0.503h2.286 L6.298,15.956z"}),Mr("path",{d:"M21,9.658v4.039c0,1.004-1.003,2.258-2.257,2.258h-4.04l1.754-1.756h2.286c0.251,0,0.501-0.251,0.501-0.503v-2.284 L21,9.658z"}),Mr("path",{d:"M14.703,0h4.04C19.745,0,21,1.003,21,2.258v4.04l-1.756-1.756V2.258c0-0.253-0.25-0.502-0.501-0.502h-2.286L14.703,0z"}))};TF.defaultProps={xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 21 16"};var OF=["description","heading","subheading"];function DF(){return DF=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},DF.apply(null,arguments)}var LF=pr(wr,{target:"eke90jo2"})({name:"1pe0x24",styles:"width:100%;height:100%;flex-direction:column;justify-content:center;align-items:center;margin:auto 0"}),PF=pr(Px,{target:"eke90jo1"})((e=>{var{theme:t}=e;return"\n        color: "+t.colors.gray[600]+";\n        margin-bottom: 32px;\n    "}),""),IF=pr(TF,{target:"eke90jo0"})((e=>{var{theme:t}=e;return"\n        @keyframes crop-top-left {\n            0%, 100% { fill: "+t.colors.blue[400]+"; }\n            25% { fill: "+t.colors.gray[300]+"; }\n            75% { fill: "+t.colors.gray[300]+"; }\n        }\n\n        @keyframes crop-bottom-right {\n            25%, 75% { fill: "+t.colors.gray[300]+"; }\n            50% { fill: "+t.colors.blue[400]+"; }\n        }\n\n        @keyframes crop-top-right {\n            0%, 50% { fill: "+t.colors.gray[300]+"; }\n            25% { fill: "+t.colors.blue[400]+"; }\n        }\n\n        @keyframes crop-bottom-left {\n            50%, 100% { fill: "+t.colors.gray[300]+"; }\n            75% { fill: "+t.colors.blue[400]+"; }\n        }\n\n        width: 87px;\n        margin: 0 auto;\n        padding-bottom: 40px;\n\n        path {\n            fill: "+t.colors.gray[300]+";\n\n            &:nth-of-type(1) {\n                animation: 1200ms infinite crop-top-left;\n            }\n\n            &:nth-of-type(2) {\n                animation: 1200ms infinite crop-bottom-left;\n            }\n\n            &:nth-of-type(3) {\n                animation: 1200ms infinite crop-bottom-right;\n            }\n\n            &:nth-of-type(4) {\n                animation: 1200ms infinite crop-top-right;\n            }\n        }\n    "}),"");const BF=e=>{var{description:t="Just a moment…",heading:n,subheading:r}=e,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,OF);return Mr(LF,DF({"data-testid":"sp-ui-loading-dialog"},o),n&&Mr(xF,{marginBottom:"16px"},n),r&&Mr(PF,null,r),Mr(IF,null),t&&Mr(Px,null,t))};var RF=()=>null,NF=(0,i.createContext)({body:null,bodyVariant:bp.Default,header:null,primaryButton:null,secondaryButton:null,setLayout:()=>{}}),FF=e=>{var{children:t}=e,[n,r]=(0,i.useState)(null),[o,a]=(0,i.useState)(bp.Default),[s,l]=(0,i.useState)(null),[c,u]=(0,i.useState)(null),[d,p]=(0,i.useState)(null),f=(0,i.useCallback)((e=>{var{body:t,bodyVariant:n,header:o,primaryButton:i,secondaryButton:s}=e;void 0!==t&&r(t),void 0!==n&&a(n),void 0!==o&&l(o),void 0!==i&&u(i),void 0!==s&&p(s)}),[]);return Mr(NF.Provider,{value:{body:n,bodyVariant:o,header:s,primaryButton:c,secondaryButton:d,setLayout:f}},t({body:n,bodyVariant:o,header:s,primaryButton:c,secondaryButton:d}))};function jF(){return(0,i.useContext)(NF)}function YF(e,t){const n=(0,i.useId)();return(0,i.useMemo)((()=>e||[t,n].filter(Boolean).join("-")),[e,t,n])}function $F(){return!("undefined"==typeof window||!window.document||!window.document.createElement)}var HF=$F()?i.useLayoutEffect:i.useEffect;function UF(e,t=[]){const n=(0,i.useRef)(e);return HF((()=>{n.current=e})),(0,i.useCallback)(((...e)=>{var t;return null==(t=n.current)?void 0:t.call(n,...e)}),t)}function zF(e={}){const{onClose:t,onOpen:n,isOpen:r,id:o}=e,a=UF(n),s=UF(t),[l,c]=(0,i.useState)(e.defaultIsOpen||!1),[u,d]=function(e,t){const n=void 0!==e;return[n,n&&void 0!==e?e:t]}(r,l),p=YF(o,"disclosure"),f=(0,i.useCallback)((()=>{u||c(!1),null==s||s()}),[u,s]),h=(0,i.useCallback)((()=>{u||c(!0),null==a||a()}),[u,a]),m=(0,i.useCallback)((()=>{(d?f:h)()}),[d,h,f]);return{isOpen:!!d,onOpen:h,onClose:f,onToggle:m,isControlled:u,getButtonProps:(e={})=>({...e,"aria-expanded":d,"aria-controls":p,onClick:Et(e.onClick,m)}),getDisclosureProps:(e={})=>({...e,hidden:!d,id:p})}}function WF(){return WF=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},WF.apply(null,arguments)}var VF={buttons:{last:"Complete",next:"Continue",previous:"Previous"},progressHeading:(e,t)=>"Step "+e+" of "+t},GF=(0,i.createContext)({activeStep:{content:null,heading:""},goToNextStep:()=>{},goToPreviousStep:()=>{},goToStep:()=>{},isFirstStep:()=>!1,isLastStep:()=>!1,setLoading:e=>e,onLastStepComplete:function(e){return void 0===e&&(e=()=>{}),e()},setState:e=>e,state:{},steps:[],text:VF});function QF(){return(0,i.useContext)(GF)}function qF(e){return t=>{var n=QF();return Mr(e,WF({},n,t))}}function KF(){return KF=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},KF.apply(null,arguments)}var ZF=(0,i.createContext)({close:()=>{},isOpen:!1,open:()=>{}}),JF=e=>{var{children:t}=e,n=ej();return Mr(ZF.Provider,{value:n},t)};function XF(e){return t=>{var n=KF({},(function(e){if(null==e)throw new TypeError("Cannot destructure "+e)}(t),t)),r=(0,i.useContext)(ZF);return Mr(e,KF({},r,n))}}function ej(){var{isOpen:e,onClose:t,onOpen:n}=zF(),{goToStep:r}=QF();return{close:(0,i.useCallback)((()=>{t(),setTimeout((()=>{r(0)}),500)}),[r,t]),isOpen:e,open:n}}var tj=["children"];function nj(){return nj=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},nj.apply(null,arguments)}var rj=pr(qr,{target:"etyy6qb0"})((e=>{var{theme:t}=e;return"\n        color: "+t.fontColor.default+";\n        font-family: "+t.fonts.heading+";\n        font-size: "+t.fontSizes.lg+";\n        font-weight: "+t.fontWeights.light+";\n        line-height: "+t.lineHeights.lg+";\n        margin-bottom: "+t.space[5]+";\n    "}),"");const oj=e=>{var{children:t}=e,n=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,tj);return Mr(rj,nj({as:"h4"},n),t)};var ij;var aj,sj=function(e){return t=>{var{responsive:n}=qd(),{smallScreenOnly:r}=n,o=pr(e,{target:"ewm7yw20"})(r(ij||(ij=function(e,t){return t||(t=e.slice(0)),e.raw=t,e}(["\n                display: none !important;\n            "]))),";");return Mr(o,t)}}(_r);var lj,cj,uj,dj=function(e){return t=>{var{responsive:n}=qd(),{mediumScreenUp:r}=n,o=pr(e,{target:"e1aj63ua0"})(r(aj||(aj=function(e,t){return t||(t=e.slice(0)),e.raw=t,e}(["\n                display: none !important;\n            "]))),";");return Mr(o,t)}}(_r);function pj(e,t){return t||(t=e.slice(0)),e.raw=t,e}var fj=function(e){return Mr("svg",e,Mr("path",{d:"M8.4125 11.0125H18.0025C18.5525 11.0125 19.0025 11.4625 19.0025 12.0025C19.0025 12.5425 18.5525 12.9925 18.0025 12.9925H8.4125L11.2325 15.8025C11.6225 16.1925 11.6225 16.8225 11.2325 17.2125C10.8425 17.6025 10.2125 17.6025 9.8225 17.2125L5.2925 12.7025C4.9025 12.3125 4.9025 11.6825 5.2925 11.2925L9.8225 6.78249C10.2125 6.39249 10.8425 6.39249 11.2325 6.78249C11.6225 7.17249 11.6225 7.80249 11.2325 8.19249L8.4125 11.0125Z"}))};fj.defaultProps={width:"24",height:"24",fill:"none",xmlns:"http://www.w3.org/2000/svg"};var hj,mj=pr(TF,{target:"e100d0tx5"})((e=>{var{theme:t}=e;return"\n        align-self: center;\n        fill: "+t.colors.blue[400]+";\n        height: 20px;\n        margin-right: 17px;\n        width: 26px;\n    "}),""),gj=pr(_r,{target:"e100d0tx4"})((e=>{var{theme:t}=e;return"\n        color: "+t.colors.gray[600]+";\n        cursor: pointer;\n        display: inline-block;\n        margin-bottom: 32px;\n\n        svg {\n            fill: currentColor;\n            height: 24px;\n            width: 24px;\n        }\n\n        &:hover {\n            color: "+t.colors.gray[700]+";\n        }\n\n        "+t.responsive.smallScreenOnly(lj||(lj=pj(["\n            margin-bottom: 0;\n        "])))+"\n    "}),""),vj=pr(oj,{target:"e100d0tx3"})({name:"1ykowef",styles:"margin-bottom:0"}),yj=pr(Px,{target:"e100d0tx2"})((e=>{var{theme:t}=e;return"\n        margin-bottom: 0;\n        margin-top: 16px;\n        color: "+t.colors.gray[600]+";\n\n        "+t.responsive.smallScreenOnly(cj||(cj=pj(["\n            margin-bottom: 16px;\n            margin-left: 16px;\n            margin-top: 0;\n        "])))+"\n    "}),""),bj=pr(fp,{target:"e100d0tx1"})((e=>{var{theme:t}=e;return"\n        "+t.responsive.smallScreenOnly(uj||(uj=pj(["\n            border: none;\n            display: flex;\n            flex: 1;\n            justify-content: left;\n            padding-left: 0;\n        "])))+"\n    "}),""),_j=e=>{var{actionLinkText:t,heading:n,includeShootProofLogo:r,isActionLinkDisabled:o,onActionLink:a,onBack:s,subheading:l,variant:c=yp.Small}=e;return Mr(i.Fragment,null,Mr(sj,null,Mr(Aj,{variant:c},s&&Mr(gj,{"aria-label":"back","data-testid":"sp-ui-modal-back-button",onClick:s},Mr(fj,null)),Mr(wr,null,r&&Mr(mj,null),Mr(vj,{"data-testid":"sp-ui-modal-heading"},n)),l&&Mr(yj,{"data-testid":"sp-ui-modal-subheading"},l))),Mr(dj,null,Mr(wr,{padding:"23px 16px 17px",justifyContent:"flex-start",alignItems:"center"},s&&!a&&Mr(gj,{"aria-label":"back","data-testid":"sp-ui-modal-back-button",onClick:s},Mr(fj,null)),a&&Mr(bj,{isDisabled:o,onClick:a,variant:sp.Tertiary},t),Mr(wr,{flex:"auto",justifyContent:"left"},r&&Mr(mj,null),Mr(vj,{"data-testid":"sp-ui-modal-heading"},n))),l&&Mr(yj,{"data-testid":"sp-ui-modal-subheading"},l)))},Aj=pr(_r,{target:"e100d0tx0"})((e=>{var{theme:t,variant:n}=e,{[n]:r}=t.components.Modal.variants,{paddingLeft:o,paddingRight:i}=r;return"\n        padding: 20px "+i+" 16px "+o+";\n    "}),"");function Ej(e,t,n,r,o,i,a){try{var s=e[i](a),l=s.value}catch(e){return void n(e)}s.done?t(l):Promise.resolve(l).then(r,o)}function wj(e){return function(){var t=this,n=arguments;return new Promise((function(r,o){var i=e.apply(t,n);function a(e){Ej(i,r,o,a,s,"next",e)}function s(e){Ej(i,r,o,a,s,"throw",e)}a(void 0)}))}}var xj,kj,Cj=pr(fp,{target:"eohjei80"})((e=>{var{theme:t}=e;return"\n        "+t.responsive.mediumScreenUp(hj||(hj=function(e,t){return t||(t=e.slice(0)),e.raw=t,e}(["\n            min-width: 182px;\n        "])))+"\n    "}),""),Sj=["children","isDisabled","onClick"];function Mj(){return Mj=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Mj.apply(null,arguments)}function Tj(e,t){return t||(t=e.slice(0)),e.raw=t,e}var Oj=pr(fp,{target:"e115r2r0"})((e=>{var{theme:t}=e;return"\n        "+t.responsive.mediumScreenUp(xj||(xj=Tj(["\n            min-width: 135px;\n        "])))+"\n\n        "+t.responsive.smallScreenOnly(kj||(kj=Tj(["\n            background-color: transparent;\n        "])))+"\n    "}),""),Dj=e=>{var{children:t,isDisabled:n=!1,onClick:r}=e,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,Sj),{close:a}=(0,i.useContext)(ZF);return Mr(Oj,Mj({isDisabled:n,onClick:r||a,variant:sp.Dismissive},o),t)},Lj=qF((e=>{var{activeStep:t}=e;return Mr(i.Fragment,null,t.content)}));function Pj(e,t,n,r,o,i,a){try{var s=e[i](a),l=s.value}catch(e){return void n(e)}s.done?t(l):Promise.resolve(l).then(r,o)}function Ij(e){return function(){var t=this,n=arguments;return new Promise((function(r,o){var i=e.apply(t,n);function a(e){Pj(i,r,o,a,s,"next",e)}function s(e){Pj(i,r,o,a,s,"throw",e)}a(void 0)}))}}var Bj=function(e){return Mr("svg",e,Mr("path",{d:"M1 9l4-4-4-4"}))};Bj.defaultProps={viewBox:"0 0 6 10",fill:"none",xmlns:"http://www.w3.org/2000/svg"};var Rj,Nj=pr(Bj,{target:"e1pcuir85"})({name:"ftiqdx",styles:"height:11px;width:6px"}),Fj=pr(Nj,{target:"e1pcuir84"})({name:"2mdgc5",styles:"transform:rotate(180deg);margin-right:4px;stroke:currentColor"}),jj=pr(Nj,{target:"e1pcuir83"})({name:"469sdg",styles:"margin-left:4px;stroke:currentColor"}),Yj=pr(wr,{target:"e1pcuir82"})((e=>{var{theme:t}=e;return"\n        background: "+t.colors.gray[100]+";\n        border-top: 1px solid "+t.colors.gray[200]+";\n        justify-content: flex-end;\n        padding: 16px 20px;\n        width: 100%;\n    "}),""),$j=pr(fp,{target:"e1pcuir81"})({name:"1tx1l5v",styles:"margin-right:auto"}),Hj=pr(fp,{target:"e1pcuir80"})({name:"r5hahk",styles:"margin-right:20px"}),Uj=qF((e=>{var{activeStep:t,close:n,goToNextStep:r,setLoading:o,goToPreviousStep:a,isFirstStep:s,isLastStep:l,onLastStepComplete:c,state:u,setState:d,text:p}=e,{canGoToNextStep:f=(()=>!0),canGoToPreviousStep:h=(()=>!0),destructive:m,hideButtons:g,loadedText:v,loadingText:y,onNextStep:b,secondaryButton:_,requiredFields:A}=t,[E,w]=(0,i.useState)(!1),{errors:x}=mI()||{},k=()=>!!A&&A.some((e=>Boolean(x[e]))),C=function(){var e=Ij((function*(){y||w(!0),yield c(n)}));return function(){return e.apply(this,arguments)}}(),S=m?sp.Destructive:sp.Primary,M=function(){var e=Ij((function*(){b?(y||w(!0),yield b((()=>{w(!1),r()}),(e=>{var{loading:t,description:n}=e;o({loading:t,description:n})}),u,d)):r()}));return function(){return e.apply(this,arguments)}}();return g?null:Mr(Yj,{"data-testid":"sp-ui-modal-step-buttons"},!s()&&h(u)&&Mr($j,{"data-testid":"sp-ui-modal-step-buttons-previous",isDisabled:E,onClick:a,variant:sp.Tertiary},Mr(Fj,null),p.buttons.previous),!l()&&Mr(fp,{"data-testid":"sp-ui-modal-step-buttons-next",isDisabled:k()||!f(u)||E,loadedText:v,loadingText:y,onClick:M,variant:S},p.buttons.next,Mr(jj,null)),_&&Mr(Hj,{"data-testid":"sp-ui-modal-step-buttons-secondary",variant:sp.Tertiary,onClick:()=>{_&&_.action(),c(n)}},_.text),l()&&Mr(fp,{"data-testid":"sp-ui-modal-step-buttons-last",isDisabled:k()||!f(u)||E,loadedText:v,loadingText:y,onClick:C,variant:S},p.buttons.last))})),zj=pr(_r,{target:"ek8xs973"})((e=>{var{theme:t}=e;return"\n        background: "+t.colors.gray[100]+";\n        border-top: 1px solid "+t.colors.gray[200]+";\n        padding-top: 8px;\n    "}),""),Wj=pr(_r,{target:"ek8xs972"})((e=>{var{theme:t}=e;return"\n        padding-left: 16px;\n        padding-right: 16px;\n        margin-bottom: 10px;\n\n        h5, span {\n            color: "+t.colors.gray[600]+";\n        }\n    "}),""),Vj=pr(_r,{target:"ek8xs971"})((e=>{var{theme:t}=e;return"\n        background: "+t.colors.gray[200]+";\n        height: 4px;\n    "}),""),Gj=pr(Vj,{target:"ek8xs970"})((e=>{var{theme:t}=e;return"\n        background: "+t.colors.green[400]+";\n        transition: width 250ms ease-in-out;\n    "}),""),Qj=qF((e=>{var{activeStep:t,steps:n,text:r}=e,o=n.indexOf(t)+1,{heading:i}=t,{length:a}=n;return Mr(zj,{"data-testid":"sp-ui-modal-step-heading"},Mr(Wj,null,Mr(fx,null,r.progressHeading(o,a)),Mr(UI,null,i)),Mr(Vj,null,Mr(Gj,{style:{width:o/a*100+"%"}})))}));var qj=pr(lB,{shouldForwardProp:e=>!["allowBodyScroll","bodyVariant"].includes(String(e)),target:"eugdkhk4"})((e=>{var{allowBodyScroll:t,bodyVariant:n,theme:r,variant:o}=e,{[o]:i}=r.components.Modal.variants,{body:a,paddingLeft:s,paddingRight:l}=i,{backgroundColor:c,maxWidth:u,paddingBottom:d,paddingTop:p}=a,{[n]:f}=a.variants,h={backgroundColor:c,maxWidth:u,paddingBottom:d,paddingLeft:s,paddingRight:l,paddingTop:p},m=e=>{var t=f[e];return void 0===t?h[e]:t};return"\n        background-color: "+m("backgroundColor")+";\n        margin-left: auto;\n        margin-right: auto;\n        max-width: "+m("maxWidth")+";\n        overflow: "+(t?"auto":"unset")+";\n        padding:\n            "+m("paddingTop")+"\n            "+m("paddingRight")+"\n            "+m("paddingBottom")+"\n            "+m("paddingLeft")+";\n        width: 100%;\n\n        "+r.responsive.smallScreenOnly("\n            max-width: 100%;\n            padding: 0 "+(n===bp.FullWidth?0:16)+"px 16px;\n        ")+"\n    "}),""),Kj=pr(cB,{target:"eugdkhk3"})((e=>{var{theme:t}=e;return"\n        background: white;\n        color: "+t.colors.gray[600]+";\n        height: 24px;\n        padding: 0;\n        right: 20px;\n        top: 21.5px;\n        width: 24px;\n\n        svg {\n            height: 10.5px;\n            stroke: currentColor;\n            width: 10.5px;\n        }\n\n        &:hover {\n            background: none;\n            color: "+t.colors.gray[700]+";\n        }\n\n        &:focus {\n            color: "+t.colors.gray[600]+";\n        }\n\n        "+t.responsive.smallScreenOnly(Rj||(Rj=function(e,t){return t||(t=e.slice(0)),e.raw=t,e}(["\n            right: 16px;\n            top: 24.5px;\n        "])))+"\n    "}),""),Zj=pr(uF,{target:"eugdkhk2"})((e=>{var{theme:t,variant:n}=e,{[n]:r}=t.components.Modal.variants,{borderRadius:o,height:i,marginBottom:a,marginTop:s,maxWidth:l,minHeight:c}=r,u="\n            --vh: "+.01*window.innerHeight+"px;\n            height: calc(var(--vh, 1vh) * 100);\n            margin-bottom: 0;\n            margin-top: 0;\n            max-width: 100%;\n        ";return"\n            border-radius: "+o+";\n            height: "+i+";\n            margin-bottom: "+a+";\n            margin-top: "+s+";\n            max-width: "+l+";\n            min-height: "+c+";\n\n            "+t.responsive.smallScreenOnly(u)+"\n        "}),""),Jj=pr(dF,{target:"eugdkhk1"})((e=>{var{theme:t,variant:n}=e,{[n]:r}=t.components.Modal.variants,{header:o}=r,{borderBottom:i}=o;return"\n            border-bottom: "+i+";\n            padding: 0;\n        "}),""),Xj=pr(pF,{shouldForwardProp:e=>_F(e),target:"eugdkhk0"})((e=>{var{areButtonsCentered:t,primaryButton:n,secondaryButton:r,theme:o,variant:i}=e,a=n&&!r?"none":"block",{[i]:s}=o.components.Modal.variants,{body:l,paddingLeft:c,paddingRight:u}=s,{backgroundColor:d}=l;return"\n        background-color: "+d+";\n        justify-content: "+(t?"center":"flex-end")+";\n        padding-bottom: 28px;\n        padding-left: "+c+";\n        padding-right: "+u+";\n\n        button:last-of-type:not(:first-of-type) {\n            margin-left: 20px;\n            border-radius: 4px;\n        }\n\n        "+o.responsive.smallScreenOnly("\n            background-color: "+o.colors.gray[100]+";\n            border-top: 1px solid "+o.colors.gray[200]+";\n            padding: 16px;\n\n            button {\n                width: 100%;\n            }\n\n            button:first-of-type {\n                display: "+a+";\n            }\n\n            button:last-of-type:not(:first-of-type) {\n                margin-left: 0;\n            }\n\n            button:not(:last-of-type) {\n                margin-right: 20px;\n            }\n        ")+"\n    "}),""),eY=e=>{var{actionLinkText:t,areButtonsCentered:n=!1,children:r,allowBodyScroll:o=!0,closeOnEscape:a=!0,closeOnOverlayClick:s=!0,displayStepCounter:l=!0,heading:c,hideFooter:u=!1,hideSecondaryAction:d=!1,isActionLinkDisabled:p=!1,onActionLink:f,onClose:h=RF,showCloseButton:m=!0,subheading:g,variant:v=yp.Small}=e,{close:y,isOpen:b}=(0,i.useContext)(ZF),{state:_,steps:A}=QF(),E=A&&A.length>0,w=E?Mr(Lj,null):null,x=Mr(i.Fragment,null,(t||c||g)&&Mr(_j,{actionLinkText:t,heading:c,isActionLinkDisabled:p,onActionLink:f,subheading:g,variant:v}),E&&l&&Mr(Qj,null)),k=d?null:Mr(Dj,null,"Cancel");function C(){h(),y()}return Mr(sB,{closeOnEsc:a,closeOnOverlayClick:s,isOpen:b,onClose:C,motionPreset:"scale"},Mr(vF,{"data-testid":"sp-ui-modal-overlay"}),Mr(Zj,{"data-testid":"sp-ui-modal",variant:v},Mr(FF,null,(e=>{var{body:t,bodyVariant:a,header:s,primaryButton:l,secondaryButton:c}=e;return Mr(i.Fragment,null,Mr(Jj,{variant:v},s||x),m&&Mr(Kj,{"data-testid":"sp-ui-modal-close-button"}),_.loading?Mr(BF,{description:_.loadingDescription||""}):Mr(qj,{allowBodyScroll:o,bodyVariant:a,"data-testid":"sp-ui-modal-body",variant:v},t||w),!u&&Mr(i.Fragment,null,!E||l||c?Mr(Xj,{areButtonsCentered:n,className:"sp-ui-modal-footer","data-testid":"sp-ui-modal-footer",primaryButton:l,secondaryButton:c||k,variant:v},c||k,l):Mr(Uj,{close:C})),r)}))))};eY.Body=e=>{var{children:t,variant:n=bp.Default}=e,{setLayout:r}=jF();return(0,i.useEffect)((()=>(r({body:t,bodyVariant:n}),()=>r({body:null,bodyVariant:bp.Default}))),[t,r]),null},eY.Header=e=>{var{setLayout:t}=jF();return(0,i.useEffect)((()=>(t({header:Mr(_j,e)}),()=>t({header:null}))),[e,t]),null},eY.PrimaryButton=e=>{var{children:t,destructive:n=!1,isDisabled:r=!1,loadedText:o,loadingText:a,onClick:s}=e,{close:l}=(0,i.useContext)(ZF),{setLayout:c}=jF();return(0,i.useEffect)((()=>(c({primaryButton:Mr(Cj,{isDisabled:r,loadedText:o,loadingText:a,onClick:wj((function*(){yield s(l)})),variant:n?sp.Destructive:sp.Primary},t)}),()=>c({primaryButton:null}))),[t,l,n,r,o,a,s,c]),null},eY.SecondaryButton=e=>{var{children:t,isDisabled:n=!1,onClick:r}=e,{setLayout:o}=jF();return(0,i.useEffect)((()=>(o({secondaryButton:Mr(Dj,{isDisabled:n,onClick:r},t)}),()=>o({secondaryButton:null}))),[t,n,r,o]),null};var tY=e=>{var{children:t,setClose:n=(()=>{}),setIsOpen:r=(()=>{}),setOpen:o=(()=>{})}=e,{close:a,isOpen:s,open:l}=ej();return(0,i.useEffect)((()=>{n((()=>a))}),[a,n]),(0,i.useEffect)((()=>{r(s)}),[s,r]),(0,i.useEffect)((()=>{o((()=>l))}),[l,o]),Mr(ZF.Provider,{value:{close:a,isOpen:s,open:l}},t)};function nY(e){void 0===e&&(e=eY);var[t,n]=(0,i.useState)((()=>()=>{})),[r,o]=(0,i.useState)(!1),[a,s]=(0,i.useState)((()=>()=>{})),l=(0,i.useCallback)((t=>Mr(tY,{setClose:n,setIsOpen:o,setOpen:s},Mr(e,t))),[]);return l.Body=eY.Body,l.Header=eY.Header,l.PrimaryButton=eY.PrimaryButton,l.SecondaryButton=eY.SecondaryButton,{Modal:l,ModalContextProvider:tY,close:t,isOpen:r,open:a}}var rY=["children","initialValues","onSubmit","validationSchema","noValidate"];function oY(){return oY=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},oY.apply(null,arguments)}const iY=e=>{var{children:t,initialValues:n,onSubmit:r=(()=>{}),validationSchema:o,noValidate:i}=e,a=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,rY);return Mr(TI,oY({initialValues:n,onSubmit:r,validationSchema:o},a),(e=>Mr(BI,{noValidate:i,"data-testid":"sp-ui-form"},t instanceof Function?t(e):t)))},aY={version:4,country_calling_codes:{1:["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],7:["RU","KZ"],20:["EG"],27:["ZA"],30:["GR"],31:["NL"],32:["BE"],33:["FR"],34:["ES"],36:["HU"],39:["IT","VA"],40:["RO"],41:["CH"],43:["AT"],44:["GB","GG","IM","JE"],45:["DK"],46:["SE"],47:["NO","SJ"],48:["PL"],49:["DE"],51:["PE"],52:["MX"],53:["CU"],54:["AR"],55:["BR"],56:["CL"],57:["CO"],58:["VE"],60:["MY"],61:["AU","CC","CX"],62:["ID"],63:["PH"],64:["NZ"],65:["SG"],66:["TH"],81:["JP"],82:["KR"],84:["VN"],86:["CN"],90:["TR"],91:["IN"],92:["PK"],93:["AF"],94:["LK"],95:["MM"],98:["IR"],211:["SS"],212:["MA","EH"],213:["DZ"],216:["TN"],218:["LY"],220:["GM"],221:["SN"],222:["MR"],223:["ML"],224:["GN"],225:["CI"],226:["BF"],227:["NE"],228:["TG"],229:["BJ"],230:["MU"],231:["LR"],232:["SL"],233:["GH"],234:["NG"],235:["TD"],236:["CF"],237:["CM"],238:["CV"],239:["ST"],240:["GQ"],241:["GA"],242:["CG"],243:["CD"],244:["AO"],245:["GW"],246:["IO"],247:["AC"],248:["SC"],249:["SD"],250:["RW"],251:["ET"],252:["SO"],253:["DJ"],254:["KE"],255:["TZ"],256:["UG"],257:["BI"],258:["MZ"],260:["ZM"],261:["MG"],262:["RE","YT"],263:["ZW"],264:["NA"],265:["MW"],266:["LS"],267:["BW"],268:["SZ"],269:["KM"],290:["SH","TA"],291:["ER"],297:["AW"],298:["FO"],299:["GL"],350:["GI"],351:["PT"],352:["LU"],353:["IE"],354:["IS"],355:["AL"],356:["MT"],357:["CY"],358:["FI","AX"],359:["BG"],370:["LT"],371:["LV"],372:["EE"],373:["MD"],374:["AM"],375:["BY"],376:["AD"],377:["MC"],378:["SM"],380:["UA"],381:["RS"],382:["ME"],383:["XK"],385:["HR"],386:["SI"],387:["BA"],389:["MK"],420:["CZ"],421:["SK"],423:["LI"],500:["FK"],501:["BZ"],502:["GT"],503:["SV"],504:["HN"],505:["NI"],506:["CR"],507:["PA"],508:["PM"],509:["HT"],590:["GP","BL","MF"],591:["BO"],592:["GY"],593:["EC"],594:["GF"],595:["PY"],596:["MQ"],597:["SR"],598:["UY"],599:["CW","BQ"],670:["TL"],672:["NF"],673:["BN"],674:["NR"],675:["PG"],676:["TO"],677:["SB"],678:["VU"],679:["FJ"],680:["PW"],681:["WF"],682:["CK"],683:["NU"],685:["WS"],686:["KI"],687:["NC"],688:["TV"],689:["PF"],690:["TK"],691:["FM"],692:["MH"],850:["KP"],852:["HK"],853:["MO"],855:["KH"],856:["LA"],880:["BD"],886:["TW"],960:["MV"],961:["LB"],962:["JO"],963:["SY"],964:["IQ"],965:["KW"],966:["SA"],967:["YE"],968:["OM"],970:["PS"],971:["AE"],972:["IL"],973:["BH"],974:["QA"],975:["BT"],976:["MN"],977:["NP"],992:["TJ"],993:["TM"],994:["AZ"],995:["GE"],996:["KG"],998:["UZ"]},countries:{AC:["247","00","(?:[01589]\\d|[46])\\d{4}",[5,6]],AD:["376","00","(?:1|6\\d)\\d{7}|[135-9]\\d{5}",[6,8,9],[["(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],["(\\d{4})(\\d{4})","$1 $2",["1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]]],AE:["971","00","(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",[5,6,7,8,9,10,11,12],[["(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],["(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],"0"],AF:["93","00","[2-7]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],"0"],AG:["1","011","(?:268|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([457]\\d{6})$|1","268$1",0,"268"],AI:["1","011","(?:264|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2457]\\d{6})$|1","264$1",0,"264"],AL:["355","00","(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",[6,7,8,9],[["(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],"0"],AM:["374","00","(?:[1-489]\\d|55|60|77)\\d{6}",[8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],["(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],"0"],AO:["244","00","[29]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]]],AR:["54","00","(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",[10,11],[["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",1],["(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1",0,"$1 $2 $3-$4"],["(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1",0,"$1 $2 $3-$4"]],"0",0,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?","9$1"],AS:["1","011","(?:[58]\\d\\d|684|900)\\d{7}",[10],0,"1",0,"([267]\\d{6})$|1","684$1",0,"684"],AT:["43","00","1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",[4,5,6,7,8,9,10,11,12,13],[["(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],["(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],["(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],"0"],AU:["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",[5,6,7,8,9,10,12],[["(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],"0",0,"(183[12])|0",0,0,0,[["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",[9]],["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,["163\\d{2,6}",[5,6,7,8,9]],["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],AW:["297","00","(?:[25-79]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]]],AX:["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",[5,6,7,8,9,10,11,12],0,"0",0,0,0,0,"18",0,"00"],AZ:["994","00","365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365[45]|46","1[28]|2|365(?:4|5[02])|46"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],"0"],BA:["387","00","6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],"0"],BB:["1","011","(?:246|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","246$1",0,"246"],BD:["880","00","[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],["(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],"0$1"],["(\\d{4})(\\d{3,6})","$1-$2",["[13-9]|22"],"0$1"],["(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],"0"],BE:["32","00","4\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],"0"],BF:["226","00","[025-7]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]]],BG:["359","00","00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",[6,7,8,9,12],[["(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],"0"],BH:["973","00","[136-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[13679]|8[02-4679]"]]]],BI:["257","00","(?:[267]\\d|31)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]]],BJ:["229","00","[24-689]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-689]"]]]],BL:["590","00","590\\d{6}|(?:69|80|9\\d)\\d{7}",[9],0,"0",0,0,0,0,0,[["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]],BM:["1","011","(?:441|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","441$1",0,"441"],BN:["673","00","[2-578]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]]],BO:["591","00(?:1\\d)?","(?:[2-467]\\d\\d|8001)\\d{5}",[8,9],[["(\\d)(\\d{7})","$1 $2",["[23]|4[46]"]],["(\\d{8})","$1",["[67]"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"]]],"0",0,"0(1\\d)?"],BQ:["599","00","(?:[34]1|7\\d)\\d{5}",[7],0,0,0,0,0,0,"[347]"],BR:["55","00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",[8,9,10,11],[["(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],["(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)"]],"0",0,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2"],BS:["1","011","(?:242|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([3-8]\\d{6})$|1","242$1",0,"242"],BT:["975","00","[17]\\d{7}|[2-8]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]]],BW:["267","00","(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",[7,8,10],[["(\\d{2})(\\d{5})","$1 $2",["90"]],["(\\d{3})(\\d{4})","$1 $2",["[24-6]|3[15-9]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37]"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["8"]]]],BY:["375","810","(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],["(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],"8",0,"0|80?",0,0,0,0,"8~10"],BZ:["501","00","(?:0800\\d|[2-8])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]]],CA:["1","011","(?:[2-8]\\d|90)\\d{8}|3\\d{6}",[7,10],0,"1",0,0,0,0,0,[["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|90[25])[2-9]\\d{6}",[10]],["",[10]],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",[10]],["900[2-9]\\d{6}",[10]],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",[10]],0,["310\\d{4}",[7]],0,["600[2-9]\\d{6}",[10]]]],CC:["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"([59]\\d{7})$|0","8$1",0,0,[["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",[9]],["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],CD:["243","00","[189]\\d{8}|[1-68]\\d{6}",[7,9],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"]],"0"],CF:["236","00","(?:[27]\\d{3}|8776)\\d{4}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]]],CG:["242","00","222\\d{6}|(?:0\\d|80)\\d{7}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]]],CH:["41","00","8\\d{11}|[2-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],"0"],CI:["225","00","[02]\\d{9}",[10],[["(\\d{2})(\\d{2})(\\d)(\\d{5})","$1 $2 $3 $4",["2"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3 $4",["0"]]]],CK:["682","00","[2-578]\\d{4}",[5],[["(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]]],CL:["56","(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0","12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",[9,10,11],[["(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-36]"],"($1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]]],CM:["237","00","[26]\\d{8}|88\\d{6,7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]|88"]]]],CN:["86","00|1(?:[12]\\d|79)\\d\\d00","1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","10(?:10|9[56])|2[0-57-9](?:100|9[56])"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1",1],["(\\d{3})(\\d{7,8})","$1 $2",["9"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",1]],"0",0,"(1(?:[12]\\d|79)\\d\\d)|0",0,0,0,0,"00"],CO:["57","00(?:4(?:[14]4|56)|[579])","(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",[10,11],[["(\\d{3})(\\d{7})","$1 $2",["6"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["3[0-357]|91"]],["(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1",0,"$1 $2 $3"]],"0",0,"0([3579]|4(?:[14]4|56))?"],CR:["506","00","(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",[8,10],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"]]],0,0,"(19(?:0[0-2468]|1[09]|20|66|77|99))"],CU:["53","119","(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",[6,7,8,10],[["(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],["(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["[56]"],"0$1"],["(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],"0"],CV:["238","0","(?:[2-59]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]]],CW:["599","00","(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[3467]"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],0,0,0,0,0,"[69]"],CX:["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"([59]\\d{7})$|0","8$1",0,0,[["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",[9]],["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],CY:["357","00","(?:[279]\\d|[58]0)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]]],CZ:["420","00","(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["96"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]]],DE:["49","00","[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",[4,5,6,7,8,9,10,11,12,13,14,15],[["(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],["(\\d{3})(\\d{3,12})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],["(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],["(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],["(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],["(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["15[03568]","15(?:[0568]|31)"],"0$1"],["(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],["(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],["(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],["(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],"0"],DJ:["253","00","(?:2\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]]],DK:["45","00","[2-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]]],DM:["1","011","(?:[58]\\d\\d|767|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","767$1",0,"767"],DO:["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"8001|8[024]9"],DZ:["213","00","(?:[1-4]|[5-79]\\d|80)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],"0"],EC:["593","00","1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",[8,9,10,11],[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)",0,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],"0"],EE:["372","00","8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],["(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],EG:["20","00","[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",[8,9,10],[["(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],["(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{8})","$1 $2",["1"],"0$1"]],"0"],EH:["212","00","[5-8]\\d{8}",[9],0,"0",0,0,0,0,"528[89]"],ER:["291","00","[178]\\d{6}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],"0"],ES:["34","00","[5-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]]],ET:["251","00","(?:11|[2-579]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-579]"],"0$1"]],"0"],FI:["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",[5,6,7,8,9,10,11,12],[["(\\d{5})","$1",["20[2-59]"],"0$1"],["(\\d{3})(\\d{3,7})","$1 $2",["(?:[1-3]0|[68])0|70[07-9]"],"0$1"],["(\\d{2})(\\d{4,8})","$1 $2",["[14]|2[09]|50|7[135]"],"0$1"],["(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"],["(\\d)(\\d{4,9})","$1 $2",["(?:1[3-79]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"]],"0",0,0,0,0,"1[03-79]|[2-9]",0,"00"],FJ:["679","0(?:0|52)","45\\d{5}|(?:0800\\d|[235-9])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],0,0,0,0,0,0,0,"00"],FK:["500","00","[2-7]\\d{4}",[5]],FM:["691","00","(?:[39]\\d\\d|820)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[389]"]]]],FO:["298","00","[2-9]\\d{5}",[6],[["(\\d{6})","$1",["[2-9]"]]],0,0,"(10(?:01|[12]0|88))"],FR:["33","00","[1-9]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],"0"],GA:["241","00","(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",[7,8],[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"]],0,0,"0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})","$1"],GB:["44","00","[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",[7,9,10],[["(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])","[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],"0",0,0,0,0,0,[["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",[9,10]],["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]],0," x"],GD:["1","011","(?:473|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","473$1",0,"473"],GE:["995","00","(?:[3-57]\\d\\d|800)\\d{6}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],"0"],GF:["594","00","[56]94\\d{6}|(?:80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[56]|9[47]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[89]"],"0$1"]],"0"],GG:["44","00","(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",[7,9,10],0,"0",0,"([25-9]\\d{5})$|0","1481$1",0,0,[["1481[25-9]\\d{5}",[10]],["7(?:(?:781|839)\\d|911[17])\\d{5}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]]],GH:["233","00","(?:[235]\\d{3}|800)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],"0"],GI:["350","00","(?:[25]\\d|60)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["2"]]]],GL:["299","00","(?:19|[2-689]\\d|70)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-9]"]]]],GM:["220","00","[2-9]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],GN:["224","00","722\\d{6}|(?:3|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]]],GP:["590","00","590\\d{6}|(?:69|80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0",0,0,0,0,0,[["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]],GQ:["240","00","222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]]],GR:["30","00","5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",[10,11,12],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]],["(\\d{3})(\\d{3,4})(\\d{5})","$1 $2 $3",["8"]]]],GT:["502","00","80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1 $2",["[2-8]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],GU:["1","011","(?:[58]\\d\\d|671|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","671$1",0,"671"],GW:["245","00","[49]\\d{8}|4\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["40"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]]],GY:["592","001","(?:[2-8]\\d{3}|9008)\\d{3}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],HK:["852","00(?:30|5[09]|[126-9]?)","8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",[5,6,7,8,9,11],[["(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],0,0,0,0,0,0,0,"00"],HN:["504","00","8\\d{10}|[237-9]\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]]],HR:["385","00","(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",[6,7,8,9],[["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6|7[245]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-57]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],"0"],HT:["509","00","(?:[2-489]\\d|55)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-589]"]]]],HU:["36","00","[235-7]\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"06 $1"]],"06"],ID:["62","00[89]","(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",[7,8,9,10,11,12,13],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],["(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],["(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],["(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],["(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],["(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],"0"],IE:["353","00","(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],["(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[78]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["4"],"(0$1)"],["(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],"0"],IL:["972","0(?:0|1[2-9])","1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",[7,8,9,10,11,12],[["(\\d{4})(\\d{3})","$1-$2",["125"]],["(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],["(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],["(\\d{4})(\\d{6})","$1-$2",["159"]],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],"0"],IM:["44","00","1624\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"([25-8]\\d{5})$|0","1624$1",0,"74576|(?:16|7[56])24"],IN:["91","00","(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",[8,9,10,11,12,13],[["(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],0,1],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],0,1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],"0$1",1],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]","1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",1],["(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",1],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],0,1],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],0,1]],"0"],IO:["246","00","3\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["3"]]]],IQ:["964","00","(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],IR:["98","00","[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",[4,5,6,7,10],[["(\\d{4,5})","$1",["96"],"0$1"],["(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],"0"],IS:["354","00|1(?:0(?:01|[12]0)|100)","(?:38\\d|[4-9])\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],0,0,0,0,0,0,0,"00"],IT:["39","00","0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",[6,7,8,9,10,11],[["(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],["(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],["(\\d{4})(\\d{4})","$1 $2",["894"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1(?:44|[679])|[378]|43"]],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]|14"]],["(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],0,0,0,0,0,0,[["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"],["3[2-9]\\d{7,8}|(?:31|43)\\d{8}",[9,10]],["80(?:0\\d{3}|3)\\d{3}",[6,9]],["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",[6,8,9,10]],["1(?:78\\d|99)\\d{6}",[9,10]],0,0,0,["55\\d{8}",[10]],["84(?:[08]\\d{3}|[17])\\d{3}",[6,9]]]],JE:["44","00","1534\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"([0-24-8]\\d{5})$|0","1534$1",0,0,[["1534[0-24-8]\\d{5}"],["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"],["80(?:07(?:35|81)|8901)\\d{4}"],["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"],["701511\\d{4}"],0,["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"],["56\\d{8}"]]],JM:["1","011","(?:[58]\\d\\d|658|900)\\d{7}",[10],0,"1",0,0,0,0,"658|876"],JO:["962","00","(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],JP:["81","010","00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",[8,9,10,11,12,13,14,15,16,17],[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],"0$1"],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"]],"0",0,"(000[259]\\d{6})$|(?:(?:003768)0?)|0","$1"],KE:["254","000","(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",[7,8,9,10],[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0"],KG:["996","00","8\\d{9}|[235-9]\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],["(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],"0"],KH:["855","00[14-9]","1\\d{9}|[1-9]\\d{7,8}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],KI:["686","00","(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",[5,8],0,"0"],KM:["269","00","[3478]\\d{6}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]]],KN:["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","869$1",0,"869"],KP:["850","00|99","85\\d{6}|(?:19\\d|[2-7])\\d{7}",[8,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"]],"0"],KR:["82","00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",[5,6,8,9,10,11,12,13,14],[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1"],["(\\d{4})(\\d{4})","$1-$2",["1"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1"]],"0",0,"0(8(?:[1-46-8]|5\\d\\d))?"],KW:["965","00","18\\d{5}|(?:[2569]\\d|41)\\d{6}",[7,8],[["(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],["(\\d{3})(\\d{5})","$1 $2",["[245]"]]]],KY:["1","011","(?:345|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","345$1",0,"345"],KZ:["7","810","(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",[10,14],0,"8",0,0,0,0,"33|7",0,"8~10"],LA:["856","00","[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[013-9]"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],"0"],LB:["961","00","[27-9]\\d{7}|[13-9]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27-9]"]]],"0"],LC:["1","011","(?:[58]\\d\\d|758|900)\\d{7}",[10],0,"1",0,"([2-8]\\d{6})$|1","758$1",0,"758"],LI:["423","00","[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",[7,9],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2379]|8(?:0[09]|7)","[2379]|8(?:0(?:02|9)|7)"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["69"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],"0",0,"(1001)|0"],LK:["94","00","[1-9]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],"0"],LR:["231","00","(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["4[67]|[56]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-578]"],"0$1"]],"0"],LS:["266","00","(?:[256]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2568]"]]]],LT:["370","00","(?:[3469]\\d|52|[78]0)\\d{6}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["52[0-7]"],"(0-$1)",1],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"0 $1",1],["(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(0-$1)",1],["(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(0-$1)",1]],"0",0,"[08]"],LU:["352","00","35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",[4,5,6,7,8,9,10,11],[["(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]],0,0,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"],LV:["371","00","(?:[268]\\d|90)\\d{6}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[269]|8[01]"]]]],LY:["218","00","[2-9]\\d{8}",[9],[["(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],"0"],MA:["212","00","[5-8]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],["(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"],"0$1"],["(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],["(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],"0",0,0,0,0,0,[["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"],["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}"],["80[0-7]\\d{6}"],["89\\d{7}"],0,0,0,0,["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]],MC:["377","00","(?:[3489]|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],"0"],MD:["373","00","(?:[235-7]\\d|[89]0)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],"0"],ME:["382","00","(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],"0"],MF:["590","00","590\\d{6}|(?:69|80|9\\d)\\d{7}",[9],0,"0",0,0,0,0,0,[["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]],MG:["261","00","[23]\\d{8}",[9],[["(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],"0",0,"([24-9]\\d{6})$|0","20$1"],MH:["692","011","329\\d{4}|(?:[256]\\d|45)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],"1"],MK:["389","00","[2-578]\\d{7}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2|34[47]|4(?:[37]7|5[47]|64)"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],"0"],ML:["223","00","[24-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]]],MM:["95","00","1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",[6,7,8,9,10],[["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],["(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],["(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],"0"],MN:["976","001","[12]\\d{7,9}|[5-9]\\d{7}",[8,9,10],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[5-9]"]],["(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],"0"],MO:["853","00","0800\\d{3}|(?:28|[68]\\d)\\d{6}",[7,8],[["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{4})(\\d{4})","$1 $2",["[268]"]]]],MP:["1","011","[58]\\d{9}|(?:67|90)0\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","670$1",0,"670"],MQ:["596","00","596\\d{6}|(?:69|80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],MR:["222","00","(?:[2-4]\\d\\d|800)\\d{5}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]]],MS:["1","011","(?:[58]\\d\\d|664|900)\\d{7}",[10],0,"1",0,"([34]\\d{6})$|1","664$1",0,"664"],MT:["356","00","3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]]],MU:["230","0(?:0|[24-7]0|3[03])","(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],["(\\d{4})(\\d{4})","$1 $2",["[57]"]],["(\\d{5})(\\d{5})","$1 $2",["8"]]],0,0,0,0,0,0,0,"020"],MV:["960","0(?:0|19)","(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",[7,10],[["(\\d{3})(\\d{4})","$1-$2",["[34679]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],0,0,0,0,0,0,0,"00"],MW:["265","00","(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",[7,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],"0"],MX:["52","0[09]","[2-9]\\d{9}",[10],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"]]],0,0,0,0,0,0,0,"00"],MY:["60","00","1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9]|53)|8","1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1(?:[367]|80)"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],"0"],MZ:["258","00","(?:2|8\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],NA:["264","00","[68]\\d{7,8}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],NC:["687","00","(?:050|[2-57-9]\\d\\d)\\d{3}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[02-57-9]"]]]],NE:["227","00","[027-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]|7[0467]"]]]],NF:["672","00","[13]\\d{5}",[6],[["(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],["(\\d)(\\d{5})","$1 $2",["[13]"]]],0,0,"([0-258]\\d{4})$","3$1"],NG:["234","009","2[0-24-9]\\d{8}|[78]\\d{10,13}|[7-9]\\d{9}|[1-9]\\d{7}|[124-7]\\d{6}",[7,8,10,11,12,13,14],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["78"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-6]|7(?:0[0-689]|[1-79])|8[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["20[129]"],"0$1"],["(\\d{4})(\\d{2})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],["(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],"0"],NI:["505","00","(?:1800|[25-8]\\d{3})\\d{4}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]]],NL:["31","00","(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",[5,6,7,8,9,10,11],[["(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],["(\\d)(\\d{8})","$1 $2",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-578]|91"],"0$1"],["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3",["9"],"0$1"]],"0"],NO:["47","00","(?:0|[2-9]\\d{3})\\d{4}",[5,8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]"]]],0,0,0,0,0,"[02-689]|7[0-8]"],NP:["977","00","(?:1\\d|9)\\d{9}|[1-9]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],["(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],"0$1"],["(\\d{3})(\\d{7})","$1-$2",["9"]]],"0"],NR:["674","00","(?:444|(?:55|8\\d)\\d|666)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[4-68]"]]]],NU:["683","00","(?:[4-7]|888\\d)\\d{3}",[4,7],[["(\\d{3})(\\d{4})","$1 $2",["8"]]]],NZ:["64","0(?:0|161)","[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,8})","$1 $2",["8[1-79]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[036-8]|8|90","50(?:[0367]|88)|8|90"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[589]"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7"],"0$1"]],"0",0,0,0,0,0,0,"00"],OM:["968","00","(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",[7,8,9],[["(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],["(\\d{2})(\\d{6})","$1 $2",["2"]],["(\\d{4})(\\d{4})","$1 $2",["[179]"]]]],PA:["507","00","(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",[7,8,10,11],[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["[68]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]]],PE:["51","00|19(?:1[124]|77|90)00","(?:[14-8]|9\\d)\\d{7}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0",0,0,0,0,0,0,"00"," Anexo "],PF:["689","00","4\\d{5}(?:\\d{2})?|8\\d{7,8}",[6,8,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4|8[7-9]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],PG:["675","00|140[1-3]","(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],["(\\d{4})(\\d{4})","$1 $2",["[78]"]]],0,0,0,0,0,0,0,"00"],PH:["63","00","(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",[6,8,9,10,11,12,13],[["(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],"0"],PK:["92","00","122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,7})","$1 $2 $3",["[89]0"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["1"]],["(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],"(0$1)"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],["(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],["(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],"0"],PL:["48","00","(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",[6,7,8,9,10],[["(\\d{5})","$1",["19"]],["(\\d{3})(\\d{3})","$1 $2",["11|20|64"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]]],PM:["508","00","[45]\\d{5}|(?:708|80\\d)\\d{6}",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[45]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],PR:["1","011","(?:[589]\\d\\d|787)\\d{7}",[10],0,"1",0,0,0,0,"787|939"],PS:["970","00","[2489]2\\d{6}|(?:1\\d|5)\\d{8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2489]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],PT:["351","00","1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["16|[236-9]"]]]],PW:["680","01[12]","(?:[24-8]\\d\\d|345|900)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],PY:["595","00","59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],["(\\d{3})(\\d{6})","$1 $2",["9(?:[5-79]|8[1-7])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],"0"],QA:["974","00","800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",[7,8,9,11],[["(\\d{3})(\\d{4})","$1 $2",["2[16]|8"]],["(\\d{4})(\\d{4})","$1 $2",["[3-7]"]]]],RE:["262","00","(?:26|[689]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"],"0$1"]],"0",0,0,0,0,0,[["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"],["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"],["80\\d{7}"],["89[1-37-9]\\d{6}"],0,0,0,0,["9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}"],["8(?:1[019]|2[0156]|84|90)\\d{6}"]]],RO:["40","00","(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",[6,9],[["(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],["(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[236-9]"],"0$1"]],"0",0,0,0,0,0,0,0," int "],RS:["381","00","38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",[6,7,8,9,10,11,12],[["(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],["(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],"0"],RU:["7","810","8\\d{13}|[347-9]\\d{9}",[10,14],[["(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",1],["(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],"8 ($1)",1],["(\\d{4})(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["8"],"8 ($1)"]],"8",0,0,0,0,"3[04-689]|[489]",0,"8~10"],RW:["250","00","(?:06|[27]\\d\\d|[89]00)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"]],"0"],SA:["966","00","92\\d{7}|(?:[15]|8\\d)\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["9"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],"0"],SB:["677","0[01]","[6-9]\\d{6}|[1-6]\\d{4}",[5,7],[["(\\d{2})(\\d{5})","$1 $2",["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]],SC:["248","010|0[0-2]","800\\d{4}|(?:[249]\\d|64)\\d{5}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],0,0,0,0,0,0,0,"00"],SD:["249","00","[19]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],"0"],SE:["46","00","(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44|9)"],"0$1",0,"$1 $2"],["(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3"],["(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1",0,"$1 $2 $3"],["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3 $4"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1",0,"$1 $2 $3 $4"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1",0,"$1 $2 $3 $4 $5"]],"0"],SG:["65","0[0-3]\\d","(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-9]|[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],["(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],SH:["290","00","(?:[256]\\d|8)\\d{3}",[4,5],0,0,0,0,0,0,"[256]"],SI:["386","00|10(?:22|66|88|99)","[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",[5,6,7,8],[["(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],"0",0,0,0,0,0,0,"00"],SJ:["47","00","0\\d{4}|(?:[489]\\d|79)\\d{6}",[5,8],0,0,0,0,0,0,"79"],SK:["421","00","[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",[6,7,9],[["(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],"0"],SL:["232","00","(?:[237-9]\\d|66)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],"0"],SM:["378","00","(?:0549|[5-7]\\d)\\d{6}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(\\d{4})(\\d{6})","$1 $2",["0"]]],0,0,"([89]\\d{5})$","0549$1"],SN:["221","00","(?:[378]\\d|93)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]]],SO:["252","00","[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",[6,7,8,9],[["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],["(\\d)(\\d{7})","$1 $2",["(?:2|90)4|[67]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[348]|64|79|90"]],["(\\d{2})(\\d{5,7})","$1 $2",["1|28|6[0-35-9]|77|9[2-9]"]]],"0"],SR:["597","00","(?:[2-5]|68|[78]\\d)\\d{5}",[6,7],[["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]]],SS:["211","00","[19]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],"0"],ST:["239","00","(?:22|9\\d)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[29]"]]]],SV:["503","00","[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",[7,8,11],[["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]]],SX:["1","011","7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"(5\\d{6})$|1","721$1",0,"721"],SY:["963","00","[1-39]\\d{8}|[1-5]\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1",1]],"0"],SZ:["268","00","0800\\d{4}|(?:[237]\\d|900)\\d{6}",[8,9],[["(\\d{4})(\\d{4})","$1 $2",["[0237]"]],["(\\d{5})(\\d{4})","$1 $2",["9"]]]],TA:["290","00","8\\d{3}",[4],0,0,0,0,0,0,"8"],TC:["1","011","(?:[58]\\d\\d|649|900)\\d{7}",[10],0,"1",0,"([2-479]\\d{6})$|1","649$1",0,"649"],TD:["235","00|16","(?:22|[69]\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2679]"]]],0,0,0,0,0,0,0,"00"],TG:["228","00","[279]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]]],TH:["66","00[1-9]","(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",[8,9,10,13],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],TJ:["992","810","[0-57-9]\\d{8}",[9],[["(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["44[02-479]|[34]7"]],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3[1-5]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[0-57-9]"]]],0,0,0,0,0,0,0,"8~10"],TK:["690","00","[2-47]\\d{3,6}",[4,5,6,7]],TL:["670","00","7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7"]]]],TM:["993","810","(?:[1-6]\\d|71)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],["(\\d{2})(\\d{6})","$1 $2",["[67]"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],TN:["216","00","[2-57-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]]],TO:["676","00","(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",[5,7],[["(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[5-9]"]]]],TR:["90","00","4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",[7,10,12,13],[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|61[06])","5(?:[0-59]|61[06]1)"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",1],["(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",1]],"0"],TT:["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-46-8]\\d{6})$|1","868$1",0,"868"],TV:["688","00","(?:2|7\\d\\d|90)\\d{4}",[5,6,7],[["(\\d{2})(\\d{3})","$1 $2",["2"]],["(\\d{2})(\\d{4})","$1 $2",["90"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],TW:["886","0(?:0[25-79]|19)","[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",[7,8,9,10,11],[["(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,0,0,"#"],TZ:["255","00[056]","(?:[25-8]\\d|41|90)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["5"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],"0"],UA:["380","00","[89]\\d{9}|[3-9]\\d{8}",[9,10],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])","3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|89|9[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,0,"0~0"],UG:["256","00[057]","800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",[9],[["(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],"0"],US:["1","011","[2-9]\\d{9}|3\\d{6}",[10],[["(\\d{3})(\\d{4})","$1-$2",["310"],0,1],["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],0,1,"$1-$2-$3"]],"1",0,0,0,0,0,[["(?:5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]],UY:["598","0(?:0|1[3-9]\\d)","0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",[6,7,8,9,10,11,12,13],[["(\\d{3})(\\d{3,4})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[49]0|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[124]"]],["(\\d{3})(\\d{3})(\\d{2,4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})","$1 $2 $3 $4",["0"]]],"0",0,0,0,0,0,0,"00"," int. "],UZ:["998","00","(?:20|33|[5-79]\\d|88)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-9]"]]]],VA:["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11],0,0,0,0,0,0,"06698"],VC:["1","011","(?:[58]\\d\\d|784|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","784$1",0,"784"],VE:["58","00","[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",[10],[["(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1"]],"0"],VG:["1","011","(?:284|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-578]\\d{6})$|1","284$1",0,"284"],VI:["1","011","[58]\\d{9}|(?:34|90)0\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","340$1",0,"340"],VN:["84","00","[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",1],["(\\d{4})(\\d{4,6})","$1 $2",["1"],0,1],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["6"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[357-9]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",1]],"0"],VU:["678","00","[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",[5,7],[["(\\d{3})(\\d{4})","$1 $2",["[57-9]"]]]],WF:["681","00","(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[478]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],WS:["685","0","(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",[5,6,7,10],[["(\\d{5})","$1",["[2-5]|6[1-9]"]],["(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],XK:["383","00","2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",[8,9,10,11,12],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2|39"],"0$1"],["(\\d{2})(\\d{7,10})","$1 $2",["3"],"0$1"]],"0"],YE:["967","00","(?:1|7\\d)\\d{7}|[1-7]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7(?:[24-6]|8[0-7])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],"0"],YT:["262","00","(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",[9],0,"0",0,0,0,0,0,[["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"],["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"],["80\\d{7}"],0,0,0,0,0,["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]],ZA:["27","00","[1-79]\\d{8}|8\\d{4,9}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],ZM:["260","00","800\\d{6}|(?:21|63|[79]\\d)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],"0"],ZW:["263","00","2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",[5,6,7,8,9,10],[["(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],["(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],["(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],"0"]},nonGeographic:{800:["800",0,"(?:00|[1-9]\\d)\\d{6}",[8],[["(\\d{4})(\\d{4})","$1 $2",["\\d"]]],0,0,0,0,0,0,[0,0,["(?:00|[1-9]\\d)\\d{6}"]]],808:["808",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,0,["[1-9]\\d{7}"]]],870:["870",0,"7\\d{11}|[35-7]\\d{8}",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[35-7]"]]],0,0,0,0,0,0,[0,["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]],878:["878",0,"10\\d{10}",[12],[["(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["10\\d{10}"]]],881:["881",0,"6\\d{9}|[0-36-9]\\d{8}",[9,10],[["(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-37-9]"]],["(\\d)(\\d{3})(\\d{5,6})","$1 $2 $3",["6"]]],0,0,0,0,0,0,[0,["6\\d{9}|[0-36-9]\\d{8}"]]],882:["882",0,"[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",[7,8,9,10,11,12],[["(\\d{2})(\\d{5})","$1 $2",["16|342"]],["(\\d{2})(\\d{6})","$1 $2",["49"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["1[36]|9"]],["(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["16"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|23|3(?:[15]|4[57])|4|51"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["34"]],["(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-35]"]]],0,0,0,0,0,0,[0,["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",[7,8,9,10,12]],0,0,0,0,0,0,["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]],883:["883",0,"(?:[1-4]\\d|51)\\d{6,10}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,8})","$1 $2 $3",["[14]|2[24-689]|3[02-689]|51[24-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["21"]],["(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["51[13]"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[235]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]],888:["888",0,"\\d{11}",[11],[["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],0,0,0,0,0,0,[0,0,0,0,0,0,["\\d{11}"]]],979:["979",0,"[1359]\\d{8}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],0,0,0,0,0,0,[0,0,0,["[1359]\\d{8}"]]]}};var sY={}.constructor;function lY(e){return null!=e&&e.constructor===sY}function cY(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function uY(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function dY(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){var n=null==e?null:"undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(null==n)return;var r,o,i=[],a=!0,s=!1;try{for(n=n.call(e);!(a=(r=n.next()).done)&&(i.push(r.value),!t||i.length!==t);a=!0);}catch(e){s=!0,o=e}finally{try{a||null==n.return||n.return()}finally{if(s)throw o}}return i}(e,t)||function(e,t){if(!e)return;if("string"==typeof e)return pY(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);"Object"===n&&e.constructor&&(n=e.constructor.name);if("Map"===n||"Set"===n)return Array.from(e);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return pY(e,t)}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function pY(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function fY(e){var t,n,r,o=dY(Array.prototype.slice.call(e),4),i=o[0],a=o[1],s=o[2],l=o[3];if("string"!=typeof i)throw new TypeError("A text for parsing must be a string.");if(t=i,a&&"string"!=typeof a){if(!lY(a))throw new Error("Invalid second argument: ".concat(a));s?(n=a,r=s):r=a}else l?(n=s,r=l):(n=void 0,r=s),a&&(n=function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?cY(Object(n),!0).forEach((function(t){uY(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):cY(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}({defaultCountry:a},n));return{text:t,options:n,metadata:r}}var hY=2,mY=17,gY=3,vY="0-9０-９٠-٩۰-۹",yY="".concat("-‐-―−ー－").concat("／/").concat("．.").concat("  ­​⁠　").concat("()（）［］\\[\\]").concat("~⁓∼～");function bY(e){return bY="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},bY(e)}function _Y(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function AY(e){var t=kY();return function(){var n,r=SY(e);if(t){var o=SY(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return function(e,t){if(t&&("object"===bY(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return EY(e)}(this,n)}}function EY(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function wY(e){var t="function"==typeof Map?new Map:void 0;return wY=function(e){if(null===e||(n=e,-1===Function.toString.call(n).indexOf("[native code]")))return e;var n;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==t){if(t.has(e))return t.get(e);t.set(e,r)}function r(){return xY(e,arguments,SY(this).constructor)}return r.prototype=Object.create(e.prototype,{constructor:{value:r,enumerable:!1,writable:!0,configurable:!0}}),CY(r,e)},wY(e)}function xY(e,t,n){return xY=kY()?Reflect.construct:function(e,t,n){var r=[null];r.push.apply(r,t);var o=new(Function.bind.apply(e,r));return n&&CY(o,n.prototype),o},xY.apply(null,arguments)}function kY(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}function CY(e,t){return CY=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e},CY(e,t)}function SY(e){return SY=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)},SY(e)}var MY=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&CY(e,t)}(i,e);var t,n,r,o=AY(i);function i(e){var t;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,i),t=o.call(this,e),Object.setPrototypeOf(EY(t),i.prototype),t.name=t.constructor.name,t}return t=i,n&&_Y(t.prototype,n),r&&_Y(t,r),Object.defineProperty(t,"prototype",{writable:!1}),t}(wY(Error));function TY(e,t){e=e.split("-"),t=t.split("-");for(var n=e[0].split("."),r=t[0].split("."),o=0;o<3;o++){var i=Number(n[o]),a=Number(r[o]);if(i>a)return 1;if(a>i)return-1;if(!isNaN(i)&&isNaN(a))return 1;if(isNaN(i)&&!isNaN(a))return-1}return e[1]&&t[1]?e[1]>t[1]?1:e[1]<t[1]?-1:0:!e[1]&&t[1]?1:e[1]&&!t[1]?-1:0}function OY(e){return OY="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},OY(e)}function DY(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function LY(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function PY(e,t,n){return t&&LY(e.prototype,t),n&&LY(e,n),Object.defineProperty(e,"prototype",{writable:!1}),e}var IY=" ext. ",BY=/^\d+$/,RY=function(){function e(t){DY(this,e),function(e){if(!e)throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");if(!lY(e)||!lY(e.countries))throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(lY(e)?"an object of shape: { "+Object.keys(e).join(", ")+" }":"a "+HY(e)+": "+e,"."))}(t),this.metadata=t,zY.call(this,t)}return PY(e,[{key:"getCountries",value:function(){return Object.keys(this.metadata.countries).filter((function(e){return"001"!==e}))}},{key:"getCountryMetadata",value:function(e){return this.metadata.countries[e]}},{key:"nonGeographic",value:function(){if(!(this.v1||this.v2||this.v3))return this.metadata.nonGeographic||this.metadata.nonGeographical}},{key:"hasCountry",value:function(e){return void 0!==this.getCountryMetadata(e)}},{key:"hasCallingCode",value:function(e){if(this.getCountryCodesForCallingCode(e))return!0;if(this.nonGeographic()){if(this.nonGeographic()[e])return!0}else{var t=this.countryCallingCodes()[e];if(t&&1===t.length&&"001"===t[0])return!0}}},{key:"isNonGeographicCallingCode",value:function(e){return this.nonGeographic()?!!this.nonGeographic()[e]:!this.getCountryCodesForCallingCode(e)}},{key:"country",value:function(e){return this.selectNumberingPlan(e)}},{key:"selectNumberingPlan",value:function(e,t){if(e&&BY.test(e)&&(t=e,e=null),e&&"001"!==e){if(!this.hasCountry(e))throw new Error("Unknown country: ".concat(e));this.numberingPlan=new NY(this.getCountryMetadata(e),this)}else if(t){if(!this.hasCallingCode(t))throw new Error("Unknown calling code: ".concat(t));this.numberingPlan=new NY(this.getNumberingPlanMetadata(t),this)}else this.numberingPlan=void 0;return this}},{key:"getCountryCodesForCallingCode",value:function(e){var t=this.countryCallingCodes()[e];if(t){if(1===t.length&&3===t[0].length)return;return t}}},{key:"getCountryCodeForCallingCode",value:function(e){var t=this.getCountryCodesForCallingCode(e);if(t)return t[0]}},{key:"getNumberingPlanMetadata",value:function(e){var t=this.getCountryCodeForCallingCode(e);if(t)return this.getCountryMetadata(t);if(this.nonGeographic()){var n=this.nonGeographic()[e];if(n)return n}else{var r=this.countryCallingCodes()[e];if(r&&1===r.length&&"001"===r[0])return this.metadata.countries["001"]}}},{key:"countryCallingCode",value:function(){return this.numberingPlan.callingCode()}},{key:"IDDPrefix",value:function(){return this.numberingPlan.IDDPrefix()}},{key:"defaultIDDPrefix",value:function(){return this.numberingPlan.defaultIDDPrefix()}},{key:"nationalNumberPattern",value:function(){return this.numberingPlan.nationalNumberPattern()}},{key:"possibleLengths",value:function(){return this.numberingPlan.possibleLengths()}},{key:"formats",value:function(){return this.numberingPlan.formats()}},{key:"nationalPrefixForParsing",value:function(){return this.numberingPlan.nationalPrefixForParsing()}},{key:"nationalPrefixTransformRule",value:function(){return this.numberingPlan.nationalPrefixTransformRule()}},{key:"leadingDigits",value:function(){return this.numberingPlan.leadingDigits()}},{key:"hasTypes",value:function(){return this.numberingPlan.hasTypes()}},{key:"type",value:function(e){return this.numberingPlan.type(e)}},{key:"ext",value:function(){return this.numberingPlan.ext()}},{key:"countryCallingCodes",value:function(){return this.v1?this.metadata.country_phone_code_to_countries:this.metadata.country_calling_codes}},{key:"chooseCountryByCountryCallingCode",value:function(e){return this.selectNumberingPlan(e)}},{key:"hasSelectedNumberingPlan",value:function(){return void 0!==this.numberingPlan}}]),e}(),NY=function(){function e(t,n){DY(this,e),this.globalMetadataObject=n,this.metadata=t,zY.call(this,n.metadata)}return PY(e,[{key:"callingCode",value:function(){return this.metadata[0]}},{key:"getDefaultCountryMetadataForRegion",value:function(){return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode())}},{key:"IDDPrefix",value:function(){if(!this.v1&&!this.v2)return this.metadata[1]}},{key:"defaultIDDPrefix",value:function(){if(!this.v1&&!this.v2)return this.metadata[12]}},{key:"nationalNumberPattern",value:function(){return this.v1||this.v2?this.metadata[1]:this.metadata[2]}},{key:"possibleLengths",value:function(){if(!this.v1)return this.metadata[this.v2?2:3]}},{key:"_getFormats",value:function(e){return e[this.v1?2:this.v2?3:4]}},{key:"formats",value:function(){var e=this,t=this._getFormats(this.metadata)||this._getFormats(this.getDefaultCountryMetadataForRegion())||[];return t.map((function(t){return new FY(t,e)}))}},{key:"nationalPrefix",value:function(){return this.metadata[this.v1?3:this.v2?4:5]}},{key:"_getNationalPrefixFormattingRule",value:function(e){return e[this.v1?4:this.v2?5:6]}},{key:"nationalPrefixFormattingRule",value:function(){return this._getNationalPrefixFormattingRule(this.metadata)||this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion())}},{key:"_nationalPrefixForParsing",value:function(){return this.metadata[this.v1?5:this.v2?6:7]}},{key:"nationalPrefixForParsing",value:function(){return this._nationalPrefixForParsing()||this.nationalPrefix()}},{key:"nationalPrefixTransformRule",value:function(){return this.metadata[this.v1?6:this.v2?7:8]}},{key:"_getNationalPrefixIsOptionalWhenFormatting",value:function(){return!!this.metadata[this.v1?7:this.v2?8:9]}},{key:"nationalPrefixIsOptionalWhenFormattingInNationalFormat",value:function(){return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata)||this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion())}},{key:"leadingDigits",value:function(){return this.metadata[this.v1?8:this.v2?9:10]}},{key:"types",value:function(){return this.metadata[this.v1?9:this.v2?10:11]}},{key:"hasTypes",value:function(){return(!this.types()||0!==this.types().length)&&!!this.types()}},{key:"type",value:function(e){if(this.hasTypes()&&$Y(this.types(),e))return new YY($Y(this.types(),e),this)}},{key:"ext",value:function(){return this.v1||this.v2?IY:this.metadata[13]||IY}}]),e}(),FY=function(){function e(t,n){DY(this,e),this._format=t,this.metadata=n}return PY(e,[{key:"pattern",value:function(){return this._format[0]}},{key:"format",value:function(){return this._format[1]}},{key:"leadingDigitsPatterns",value:function(){return this._format[2]||[]}},{key:"nationalPrefixFormattingRule",value:function(){return this._format[3]||this.metadata.nationalPrefixFormattingRule()}},{key:"nationalPrefixIsOptionalWhenFormattingInNationalFormat",value:function(){return!!this._format[4]||this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat()}},{key:"nationalPrefixIsMandatoryWhenFormattingInNationalFormat",value:function(){return this.usesNationalPrefix()&&!this.nationalPrefixIsOptionalWhenFormattingInNationalFormat()}},{key:"usesNationalPrefix",value:function(){return!(!this.nationalPrefixFormattingRule()||jY.test(this.nationalPrefixFormattingRule()))}},{key:"internationalFormat",value:function(){return this._format[5]||this.format()}}]),e}(),jY=/^\(?\$1\)?$/,YY=function(){function e(t,n){DY(this,e),this.type=t,this.metadata=n}return PY(e,[{key:"pattern",value:function(){return this.metadata.v1?this.type:this.type[0]}},{key:"possibleLengths",value:function(){if(!this.metadata.v1)return this.type[1]||this.metadata.possibleLengths()}}]),e}();function $Y(e,t){switch(t){case"FIXED_LINE":return e[0];case"MOBILE":return e[1];case"TOLL_FREE":return e[2];case"PREMIUM_RATE":return e[3];case"PERSONAL_NUMBER":return e[4];case"VOICEMAIL":return e[5];case"UAN":return e[6];case"PAGER":return e[7];case"VOIP":return e[8];case"SHARED_COST":return e[9]}}var HY=function(e){return OY(e)};function UY(e,t){if((t=new RY(t)).hasCountry(e))return t.country(e).countryCallingCode();throw new Error("Unknown country: ".concat(e))}function zY(e){var t=e.version;"number"==typeof t?(this.v1=1===t,this.v2=2===t,this.v3=3===t,this.v4=4===t):t?-1===TY(t,"1.2.0")?this.v2=!0:-1===TY(t,"1.7.35")?this.v3=!0:this.v4=!0:this.v1=!0}var WY=function(e){return"([".concat(vY,"]{1,").concat(e,"})")};function VY(e){var t="[  \\t,]*",n="[:\\.．]?[  \\t,-]*",r="#?",o="[  \\t]*";return";ext="+WY("20")+"|"+(t+"(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)"+n+WY("20")+r)+"|"+(t+"(?:[xｘ#＃~～]|int|ｉｎｔ)"+n+WY("9")+r)+"|"+("[- ]+"+WY("6")+"#")+"|"+(o+"(?:,{2}|;)"+n+WY("15")+r)+"|"+(o+"(?:,)+"+n+WY("9")+r)}var GY="["+vY+"]{"+hY+"}",QY="[+＋]{0,1}(?:["+yY+"]*["+vY+"]){3,}["+yY+vY+"]*",qY=new RegExp("^[+＋]{0,1}(?:["+yY+"]*["+vY+"]){1,2}$","i"),KY=QY+"(?:"+VY()+")?",ZY=new RegExp("^"+GY+"$|^"+KY+"$","i");var JY=new RegExp("(?:"+VY()+")$","i");var XY={0:"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9","０":"0","１":"1","２":"2","３":"3","４":"4","５":"5","６":"6","７":"7","８":"8","９":"9","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9"};function e$(e){return XY[e]}function t$(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(n)return(n=n.call(e)).next.bind(n);if(Array.isArray(e)||(n=function(e,t){if(!e)return;if("string"==typeof e)return n$(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);"Object"===n&&e.constructor&&(n=e.constructor.name);if("Map"===n||"Set"===n)return Array.from(e);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return n$(e,t)}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0;return function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function n$(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function r$(e){for(var t,n="",r=t$(e.split(""));!(t=r()).done;){n+=o$(t.value,n)||""}return n}function o$(e,t,n){return"+"===e?t?void("function"==typeof n&&n("end")):"+":e$(e)}function i$(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(n)return(n=n.call(e)).next.bind(n);if(Array.isArray(e)||(n=function(e,t){if(!e)return;if("string"==typeof e)return a$(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);"Object"===n&&e.constructor&&(n=e.constructor.name);if("Map"===n||"Set"===n)return Array.from(e);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return a$(e,t)}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0;return function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function a$(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function s$(e,t){return l$(e,void 0,t)}function l$(e,t,n){var r=n.type(t),o=r&&r.possibleLengths()||n.possibleLengths();if(!o)return"IS_POSSIBLE";if("FIXED_LINE_OR_MOBILE"===t){if(!n.type("FIXED_LINE"))return l$(e,"MOBILE",n);var i=n.type("MOBILE");i&&(o=function(e,t){for(var n,r=e.slice(),o=i$(t);!(n=o()).done;){var i=n.value;e.indexOf(i)<0&&r.push(i)}return r.sort((function(e,t){return e-t}))}(o,i.possibleLengths()))}else if(t&&!r)return"INVALID_LENGTH";var a=e.length,s=o[0];return s===a?"IS_POSSIBLE":s>a?"TOO_SHORT":o[o.length-1]<a?"TOO_LONG":o.indexOf(a,1)>=0?"IS_POSSIBLE":"INVALID_LENGTH"}function c$(e,t){return"IS_POSSIBLE"===s$(e,t)}function u$(e,t){return e=e||"",new RegExp("^(?:"+t+")$").test(e)}function d$(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(n)return(n=n.call(e)).next.bind(n);if(Array.isArray(e)||(n=function(e,t){if(!e)return;if("string"==typeof e)return p$(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);"Object"===n&&e.constructor&&(n=e.constructor.name);if("Map"===n||"Set"===n)return Array.from(e);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return p$(e,t)}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0;return function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function p$(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var f$=["MOBILE","PREMIUM_RATE","TOLL_FREE","SHARED_COST","VOIP","PERSONAL_NUMBER","PAGER","UAN","VOICEMAIL"];function h$(e,t,n){if(t=t||{},e.country||e.countryCallingCode){(n=new RY(n)).selectNumberingPlan(e.country,e.countryCallingCode);var r=t.v2?e.nationalNumber:e.phone;if(u$(r,n.nationalNumberPattern())){if(m$(r,"FIXED_LINE",n))return n.type("MOBILE")&&""===n.type("MOBILE").pattern()?"FIXED_LINE_OR_MOBILE":n.type("MOBILE")?m$(r,"MOBILE",n)?"FIXED_LINE_OR_MOBILE":"FIXED_LINE":"FIXED_LINE_OR_MOBILE";for(var o,i=d$(f$);!(o=i()).done;){var a=o.value;if(m$(r,a,n))return a}}}}function m$(e,t,n){return!(!(t=n.type(t))||!t.pattern())&&(!(t.possibleLengths()&&t.possibleLengths().indexOf(e.length)<0)&&u$(e,t.pattern()))}function g$(e,t,n){var r=new RY(n).getCountryCodesForCallingCode(e);return r?r.filter((function(e){return function(e,t,n){var r=new RY(n);if(r.selectNumberingPlan(t),r.numberingPlan.possibleLengths().indexOf(e.length)>=0)return!0;return!1}(t,e,n)})):[]}var v$=/(\$\d)/;function y$(e,t,n){var r=n.useInternationalFormat,o=n.withNationalPrefix,i=(n.carrierCode,n.metadata,e.replace(new RegExp(t.pattern()),r?t.internationalFormat():o&&t.nationalPrefixFormattingRule()?t.format().replace(v$,t.nationalPrefixFormattingRule()):t.format()));return r?function(e){return e.replace(new RegExp("[".concat(yY,"]+"),"g")," ").trim()}(i):i}var b$=/^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;function _$(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(n)return(n=n.call(e)).next.bind(n);if(Array.isArray(e)||(n=function(e,t){if(!e)return;if("string"==typeof e)return A$(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);"Object"===n&&e.constructor&&(n=e.constructor.name);if("Map"===n||"Set"===n)return Array.from(e);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return A$(e,t)}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0;return function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function A$(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function E$(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function w$(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?E$(Object(n),!0).forEach((function(t){x$(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):E$(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function x$(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var k$={formatExtension:function(e,t,n){return"".concat(e).concat(n.ext()).concat(t)}};function C$(e,t,n,r){if(n=n?w$(w$({},k$),n):k$,r=new RY(r),e.country&&"001"!==e.country){if(!r.hasCountry(e.country))throw new Error("Unknown country: ".concat(e.country));r.country(e.country)}else{if(!e.countryCallingCode)return e.phone||"";r.selectNumberingPlan(e.countryCallingCode)}var o,i=r.countryCallingCode(),a=n.v2?e.nationalNumber:e.phone;switch(t){case"NATIONAL":return a?M$(o=S$(a,e.carrierCode,"NATIONAL",r,n),e.ext,r,n.formatExtension):"";case"INTERNATIONAL":return a?(o=S$(a,null,"INTERNATIONAL",r,n),M$(o="+".concat(i," ").concat(o),e.ext,r,n.formatExtension)):"+".concat(i);case"E.164":return"+".concat(i).concat(a);case"RFC3966":return function(e){var t=e.number,n=e.ext;if(!t)return"";if("+"!==t[0])throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');return"tel:".concat(t).concat(n?";ext="+n:"")}({number:"+".concat(i).concat(a),ext:e.ext});case"IDD":if(!n.fromCountry)return;var s=function(e,t,n,r,o){var i=UY(r,o.metadata);if(i===n){var a=S$(e,t,"NATIONAL",o);return"1"===n?n+" "+a:a}var s=function(e,t,n){var r=new RY(n);return r.selectNumberingPlan(e,t),r.defaultIDDPrefix()?r.defaultIDDPrefix():b$.test(r.IDDPrefix())?r.IDDPrefix():void 0}(r,void 0,o.metadata);if(s)return"".concat(s," ").concat(n," ").concat(S$(e,null,"INTERNATIONAL",o))}(a,e.carrierCode,i,n.fromCountry,r);return M$(s,e.ext,r,n.formatExtension);default:throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t,'"'))}}function S$(e,t,n,r,o){var i=function(e,t){for(var n,r=_$(e);!(n=r()).done;){var o=n.value;if(o.leadingDigitsPatterns().length>0){var i=o.leadingDigitsPatterns()[o.leadingDigitsPatterns().length-1];if(0!==t.search(i))continue}if(u$(t,o.pattern()))return o}}(r.formats(),e);return i?y$(e,i,{useInternationalFormat:"INTERNATIONAL"===n,withNationalPrefix:!i.nationalPrefixIsOptionalWhenFormattingInNationalFormat()||!o||!1!==o.nationalPrefix,carrierCode:t,metadata:r}):e}function M$(e,t,n,r){return t?r(e,t,n):e}function T$(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function O$(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?T$(Object(n),!0).forEach((function(t){D$(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):T$(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function D$(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function L$(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var P$=function(){function e(t,n,r){if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),!t)throw new TypeError("`country` or `countryCallingCode` not passed");if(!n)throw new TypeError("`nationalNumber` not passed");if(!r)throw new TypeError("`metadata` not passed");var o=function(e,t){var n,r,o=new RY(t);I$(e)?(n=e,o.selectNumberingPlan(n),r=o.countryCallingCode()):r=e;return{country:n,countryCallingCode:r}}(t,r),i=o.country,a=o.countryCallingCode;this.country=i,this.countryCallingCode=a,this.nationalNumber=n,this.number="+"+this.countryCallingCode+this.nationalNumber,this.getMetadata=function(){return r}}var t,n,r;return t=e,n=[{key:"setExt",value:function(e){this.ext=e}},{key:"getPossibleCountries",value:function(){return this.country?[this.country]:g$(this.countryCallingCode,this.nationalNumber,this.getMetadata())}},{key:"isPossible",value:function(){return function(e,t,n){if(void 0===t&&(t={}),n=new RY(n),t.v2){if(!e.countryCallingCode)throw new Error("Invalid phone number object passed");n.selectNumberingPlan(e.countryCallingCode)}else{if(!e.phone)return!1;if(e.country){if(!n.hasCountry(e.country))throw new Error("Unknown country: ".concat(e.country));n.country(e.country)}else{if(!e.countryCallingCode)throw new Error("Invalid phone number object passed");n.selectNumberingPlan(e.countryCallingCode)}}if(n.possibleLengths())return c$(e.phone||e.nationalNumber,n);if(e.countryCallingCode&&n.isNonGeographicCallingCode(e.countryCallingCode))return!0;throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.')}(this,{v2:!0},this.getMetadata())}},{key:"isValid",value:function(){return function(e,t,n){return t=t||{},(n=new RY(n)).selectNumberingPlan(e.country,e.countryCallingCode),n.hasTypes()?void 0!==h$(e,t,n.metadata):u$(t.v2?e.nationalNumber:e.phone,n.nationalNumberPattern())}(this,{v2:!0},this.getMetadata())}},{key:"isNonGeographic",value:function(){return new RY(this.getMetadata()).isNonGeographicCallingCode(this.countryCallingCode)}},{key:"isEqual",value:function(e){return this.number===e.number&&this.ext===e.ext}},{key:"getType",value:function(){return h$(this,{v2:!0},this.getMetadata())}},{key:"format",value:function(e,t){return C$(this,e,t?O$(O$({},t),{},{v2:!0}):{v2:!0},this.getMetadata())}},{key:"formatNational",value:function(e){return this.format("NATIONAL",e)}},{key:"formatInternational",value:function(e){return this.format("INTERNATIONAL",e)}},{key:"getURI",value:function(e){return this.format("RFC3966",e)}}],n&&L$(t.prototype,n),r&&L$(t,r),Object.defineProperty(t,"prototype",{writable:!1}),e}(),I$=function(e){return/^[A-Z]{2}$/.test(e)};var B$=new RegExp("(["+vY+"])");function R$(e,t){var n=function(e,t){if(e&&t.numberingPlan.nationalPrefixForParsing()){var n=new RegExp("^(?:"+t.numberingPlan.nationalPrefixForParsing()+")"),r=n.exec(e);if(r){var o,i,a,s=r.length-1,l=s>0&&r[s];if(t.nationalPrefixTransformRule()&&l)o=e.replace(n,t.nationalPrefixTransformRule()),s>1&&(i=r[1]);else{var c=r[0];o=e.slice(c.length),l&&(i=r[1])}if(l){var u=e.indexOf(r[1]);e.slice(0,u)===t.numberingPlan.nationalPrefix()&&(a=t.numberingPlan.nationalPrefix())}else a=r[0];return{nationalNumber:o,nationalPrefix:a,carrierCode:i}}}return{nationalNumber:e}}(e,t),r=n.carrierCode,o=n.nationalNumber;if(o!==e){if(!function(e,t,n){if(u$(e,n.nationalNumberPattern())&&!u$(t,n.nationalNumberPattern()))return!1;return!0}(e,o,t))return{nationalNumber:e};if(t.possibleLengths()&&!function(e,t){switch(s$(e,t)){case"TOO_SHORT":case"INVALID_LENGTH":return!1;default:return!0}}(o,t))return{nationalNumber:e}}return{nationalNumber:o,carrierCode:r}}function N$(e,t,n,r){if(!e)return{};var o;if("+"!==e[0]){var i=function(e,t,n,r){if(t){var o=new RY(r);o.selectNumberingPlan(t,n);var i=new RegExp(o.IDDPrefix());if(0===e.search(i)){var a=(e=e.slice(e.match(i)[0].length)).match(B$);if(!(a&&null!=a[1]&&a[1].length>0&&"0"===a[1]))return e}}}(e,t,n,r);if(!i||i===e){if(t||n){var a=function(e,t,n,r){var o=t?UY(t,r):n;if(0===e.indexOf(o)){(r=new RY(r)).selectNumberingPlan(t,n);var i=e.slice(o.length),a=R$(i,r).nationalNumber,s=R$(e,r).nationalNumber;if(!u$(s,r.nationalNumberPattern())&&u$(a,r.nationalNumberPattern())||"TOO_LONG"===s$(s,r))return{countryCallingCode:o,number:i}}return{number:e}}(e,t,n,r),s=a.countryCallingCode,l=a.number;if(s)return{countryCallingCodeSource:"FROM_NUMBER_WITHOUT_PLUS_SIGN",countryCallingCode:s,number:l}}return{number:e}}o=!0,e="+"+i}if("0"===e[1])return{};r=new RY(r);for(var c=2;c-1<=gY&&c<=e.length;){var u=e.slice(1,c);if(r.hasCallingCode(u))return r.selectNumberingPlan(u),{countryCallingCodeSource:o?"FROM_NUMBER_WITH_IDD":"FROM_NUMBER_WITH_PLUS_SIGN",countryCallingCode:u,number:e.slice(c)};c++}return{}}function F$(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(n)return(n=n.call(e)).next.bind(n);if(Array.isArray(e)||(n=function(e,t){if(!e)return;if("string"==typeof e)return j$(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);"Object"===n&&e.constructor&&(n=e.constructor.name);if("Map"===n||"Set"===n)return Array.from(e);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return j$(e,t)}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0;return function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function j$(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var Y$=!1;function $$(e,t){var n=t.nationalNumber,r=t.defaultCountry,o=t.metadata;if(Y$&&o.isNonGeographicCallingCode(e))return"001";var i=o.getCountryCodesForCallingCode(e);return i?1===i.length?i[0]:function(e,t){var n=t.countries,r=t.defaultCountry,o=t.metadata;o=new RY(o);for(var i,a=[],s=F$(n);!(i=s()).done;){var l=i.value;if(o.country(l),o.leadingDigits()){if(e&&0===e.search(o.leadingDigits()))return l}else if(h$({phone:e,country:l},void 0,o.metadata)){if(!r)return l;if(l===r)return l;a.push(l)}}if(a.length>0)return a[0]}(n,{countries:i,defaultCountry:r,metadata:o.metadata}):void 0}var H$="+",U$="(["+vY+"]|[\\-\\.\\(\\)]?)",z$=new RegExp("^\\"+H$+U$+"*["+vY+"]"+U$+"*$","g"),W$=new RegExp("^("+("["+vY+"]+((\\-)*["+vY+"])*")+"\\.)*"+("[a-zA-Z]+((\\-)*["+vY+"])*")+"\\.?$","g"),V$="tel:",G$=";phone-context=",Q$=";isub=";function q$(e,t){var n,r=t.extractFormattedPhoneNumber,o=function(e){var t=e.indexOf(G$);if(t<0)return null;var n=t+G$.length;if(n>=e.length)return"";var r=e.indexOf(";",n);return r>=0?e.substring(n,r):e.substring(n)}(e);if(!function(e){return null===e||0!==e.length&&(z$.test(e)||W$.test(e))}(o))throw new MY("NOT_A_NUMBER");if(null===o)n=r(e)||"";else{n="",o.charAt(0)===H$&&(n+=o);var i,a=e.indexOf(V$);i=a>=0?a+V$.length:0;var s=e.indexOf(G$);n+=e.substring(i,s)}var l=n.indexOf(Q$);if(l>0&&(n=n.substring(0,l)),""!==n)return n}var K$,Z$,J$=250,X$=new RegExp("[+＋"+vY+"]"),eH=new RegExp("[^"+vY+"#]+$"),tH=!1;function nH(e,t,n){if(t=t||{},n=new RY(n),t.defaultCountry&&!n.hasCountry(t.defaultCountry)){if(t.v2)throw new MY("INVALID_COUNTRY");throw new Error("Unknown country: ".concat(t.defaultCountry))}var r=function(e,t,n){var r=q$(e,{extractFormattedPhoneNumber:function(e){return function(e,t,n){if(!e)return;if(e.length>J$){if(n)throw new MY("TOO_LONG");return}if(!1===t)return e;var r=e.search(X$);if(r<0)return;return e.slice(r).replace(eH,"")}(e,n,t)}});if(!r)return{};if(!function(e){return e.length>=hY&&ZY.test(e)}(r))return function(e){return qY.test(e)}(r)?{error:"TOO_SHORT"}:{};var o=function(e){var t=e.search(JY);if(t<0)return{};for(var n=e.slice(0,t),r=e.match(JY),o=1;o<r.length;){if(r[o])return{number:n,ext:r[o]};o++}}(r);if(o.ext)return o;return{number:r}}(e,t.v2,t.extract),o=r.number,i=r.ext,a=r.error;if(!o){if(t.v2){if("TOO_SHORT"===a)throw new MY("TOO_SHORT");throw new MY("NOT_A_NUMBER")}return{}}var s=function(e,t,n,r){var o,i=N$(r$(e),t,n,r.metadata),a=i.countryCallingCodeSource,s=i.countryCallingCode,l=i.number;if(s)r.selectNumberingPlan(s);else{if(!l||!t&&!n)return{};r.selectNumberingPlan(t,n),t?o=t:tH&&r.isNonGeographicCallingCode(n)&&(o="001"),s=n||UY(t,r.metadata)}if(!l)return{countryCallingCodeSource:a,countryCallingCode:s};var c=R$(r$(l),r),u=c.nationalNumber,d=c.carrierCode,p=$$(s,{nationalNumber:u,defaultCountry:t,metadata:r});p&&(o=p,"001"===p||r.country(o));return{country:o,countryCallingCode:s,countryCallingCodeSource:a,nationalNumber:u,carrierCode:d}}(o,t.defaultCountry,t.defaultCallingCode,n),l=s.country,c=s.nationalNumber,u=s.countryCallingCode,d=s.countryCallingCodeSource,p=s.carrierCode;if(!n.hasSelectedNumberingPlan()){if(t.v2)throw new MY("INVALID_COUNTRY");return{}}if(!c||c.length<hY){if(t.v2)throw new MY("TOO_SHORT");return{}}if(c.length>mY){if(t.v2)throw new MY("TOO_LONG");return{}}if(t.v2){var f=new P$(u,c,n.metadata);return l&&(f.country=l),p&&(f.carrierCode=p),i&&(f.ext=i),f.__countryCallingCodeSource=d,f}var h=!!(t.extended?n.hasSelectedNumberingPlan():l)&&u$(c,n.nationalNumberPattern());return t.extended?{country:l,countryCallingCode:u,carrierCode:p,valid:h,possible:!!h||!(!0!==t.extended||!n.possibleLengths()||!c$(c,n)),phone:c,ext:i}:h?function(e,t,n){var r={country:e,phone:t};n&&(r.ext=n);return r}(l,c,i):{}}function rH(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function oH(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?rH(Object(n),!0).forEach((function(t){iH(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):rH(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function iH(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function aH(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function sH(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?aH(Object(n),!0).forEach((function(t){lH(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):aH(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function lH(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function cH(e,t,n){t&&t.defaultCountry&&!function(e,t){return t.countries.hasOwnProperty(e)}(t.defaultCountry,n)&&(t=sH(sH({},t),{},{defaultCountry:void 0}));try{return function(e,t,n){return nH(e,oH(oH({},t),{},{v2:!0}),n)}(e,t,n)}catch(e){if(!(e instanceof MY))throw e}}function uH(){var e=fY(arguments);return cH(e.text,e.options,e.metadata)}function dH(){return function(e,t){var n=Array.prototype.slice.call(t);return n.push(aY),e.apply(this,n)}(uH,arguments)}try{K$=Map}catch(V6){}try{Z$=Set}catch(V6){}function pH(e,t,n){if(!e||"object"!=typeof e||"function"==typeof e)return e;if(e.nodeType&&"cloneNode"in e)return e.cloneNode(!0);if(e instanceof Date)return new Date(e.getTime());if(e instanceof RegExp)return new RegExp(e);if(Array.isArray(e))return e.map(fH);if(K$&&e instanceof K$)return new Map(Array.from(e.entries()));if(Z$&&e instanceof Z$)return new Set(Array.from(e.values()));if(e instanceof Object){t.push(e);var r=Object.create(e);for(var o in n.push(r),e){var i=t.findIndex((function(t){return t===e[o]}));r[o]=i>-1?n[i]:pH(e[o],t,n)}return r}return e}function fH(e){return pH(e,[],[])}const hH=Object.prototype.toString,mH=Error.prototype.toString,gH=RegExp.prototype.toString,vH="undefined"!=typeof Symbol?Symbol.prototype.toString:()=>"",yH=/^Symbol\((.*)\)(.*)$/;function bH(e,t=!1){if(null==e||!0===e||!1===e)return""+e;const n=typeof e;if("number"===n)return function(e){return e!=+e?"NaN":0===e&&1/e<0?"-0":""+e}(e);if("string"===n)return t?`"${e}"`:e;if("function"===n)return"[Function "+(e.name||"anonymous")+"]";if("symbol"===n)return vH.call(e).replace(yH,"Symbol($1)");const r=hH.call(e).slice(8,-1);return"Date"===r?isNaN(e.getTime())?""+e:e.toISOString(e):"Error"===r||e instanceof Error?"["+mH.call(e)+"]":"RegExp"===r?gH.call(e):null}function _H(e,t){let n=bH(e,t);return null!==n?n:JSON.stringify(e,(function(e,n){let r=bH(this[e],t);return null!==r?r:n}),2)}let AH={default:"${path} is invalid",required:"${path} is a required field",oneOf:"${path} must be one of the following values: ${values}",notOneOf:"${path} must not be one of the following values: ${values}",notType:({path:e,type:t,value:n,originalValue:r})=>{let o=null!=r&&r!==n,i=`${e} must be a \`${t}\` type, but the final value was: \`${_H(n,!0)}\``+(o?` (cast from the value \`${_H(r,!0)}\`).`:".");return null===n&&(i+='\n If "null" is intended as an empty value be sure to mark the schema as `.nullable()`'),i},defined:"${path} must be defined"},EH={length:"${path} must be exactly ${length} characters",min:"${path} must be at least ${min} characters",max:"${path} must be at most ${max} characters",matches:'${path} must match the following: "${regex}"',email:"${path} must be a valid email",url:"${path} must be a valid URL",uuid:"${path} must be a valid UUID",trim:"${path} must be a trimmed string",lowercase:"${path} must be a lowercase string",uppercase:"${path} must be a upper case string"},wH={min:"${path} must be greater than or equal to ${min}",max:"${path} must be less than or equal to ${max}",lessThan:"${path} must be less than ${less}",moreThan:"${path} must be greater than ${more}",positive:"${path} must be a positive number",negative:"${path} must be a negative number",integer:"${path} must be an integer"},xH={min:"${path} field must be later than ${min}",max:"${path} field must be at earlier than ${max}"},kH={isValue:"${path} field must be ${value}"},CH={noUnknown:"${path} field has unspecified keys: ${unknown}"},SH={min:"${path} field must have at least ${min} items",max:"${path} field must have less than or equal to ${max} items",length:"${path} must have ${length} items"};Object.assign(Object.create(null),{mixed:AH,string:EH,number:wH,date:xH,object:CH,array:SH,boolean:kH});var MH=o(25930),TH=o.n(MH);const OH=e=>e&&e.__isYupSchema__;const DH=class{constructor(e,t){if(this.fn=void 0,this.refs=e,this.refs=e,"function"==typeof t)return void(this.fn=t);if(!TH()(t,"is"))throw new TypeError("`is:` is required for `when()` conditions");if(!t.then&&!t.otherwise)throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");let{is:n,then:r,otherwise:o}=t,i="function"==typeof n?n:(...e)=>e.every((e=>e===n));this.fn=function(...e){let t=e.pop(),n=e.pop(),a=i(...e)?r:o;if(a)return"function"==typeof a?a(n):n.concat(a.resolve(t))}}resolve(e,t){let n=this.refs.map((e=>e.getValue(null==t?void 0:t.value,null==t?void 0:t.parent,null==t?void 0:t.context))),r=this.fn.apply(e,n.concat(e,t));if(void 0===r||r===e)return e;if(!OH(r))throw new TypeError("conditions must return a schema object");return r.resolve(t)}};function LH(e){return null==e?[]:[].concat(e)}function PH(){return PH=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},PH.apply(this,arguments)}let IH=/\$\{\s*(\w+)\s*\}/g;class BH extends Error{static formatError(e,t){const n=t.label||t.path||"this";return n!==t.path&&(t=PH({},t,{path:n})),"string"==typeof e?e.replace(IH,((e,n)=>_H(t[n]))):"function"==typeof e?e(t):e}static isError(e){return e&&"ValidationError"===e.name}constructor(e,t,n,r){super(),this.value=void 0,this.path=void 0,this.type=void 0,this.errors=void 0,this.params=void 0,this.inner=void 0,this.name="ValidationError",this.value=t,this.path=n,this.type=r,this.errors=[],this.inner=[],LH(e).forEach((e=>{BH.isError(e)?(this.errors.push(...e.errors),this.inner=this.inner.concat(e.inner.length?e.inner:e)):this.errors.push(e)})),this.message=this.errors.length>1?`${this.errors.length} errors occurred`:this.errors[0],Error.captureStackTrace&&Error.captureStackTrace(this,BH)}}function RH(e,t){let{endEarly:n,tests:r,args:o,value:i,errors:a,sort:s,path:l}=e,c=(e=>{let t=!1;return(...n)=>{t||(t=!0,e(...n))}})(t),u=r.length;const d=[];if(a=a||[],!u)return a.length?c(new BH(a,i,l)):c(null,i);for(let e=0;e<r.length;e++){(0,r[e])(o,(function(e){if(e){if(!BH.isError(e))return c(e,i);if(n)return e.value=i,c(e,i);d.push(e)}if(--u<=0){if(d.length&&(s&&d.sort(s),a.length&&d.push(...a),a=d),a.length)return void c(new BH(a,i,l),i);c(null,i)}}))}}var NH=o(36146),FH=o.n(NH),jH=o(41882);const YH="$",$H=".";function HH(e,t){return new UH(e,t)}class UH{constructor(e,t={}){if(this.key=void 0,this.isContext=void 0,this.isValue=void 0,this.isSibling=void 0,this.path=void 0,this.getter=void 0,this.map=void 0,"string"!=typeof e)throw new TypeError("ref must be a string, got: "+e);if(this.key=e.trim(),""===e)throw new TypeError("ref must be a non-empty string");this.isContext=this.key[0]===YH,this.isValue=this.key[0]===$H,this.isSibling=!this.isContext&&!this.isValue;let n=this.isContext?YH:this.isValue?$H:"";this.path=this.key.slice(n.length),this.getter=this.path&&(0,jH.getter)(this.path,!0),this.map=t.map}getValue(e,t,n){let r=this.isContext?n:this.isValue?e:t;return this.getter&&(r=this.getter(r||{})),this.map&&(r=this.map(r)),r}cast(e,t){return this.getValue(e,null==t?void 0:t.parent,null==t?void 0:t.context)}resolve(){return this}describe(){return{type:"ref",key:this.key}}toString(){return`Ref(${this.key})`}static isRef(e){return e&&e.__isYupRef}}function zH(){return zH=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},zH.apply(this,arguments)}function WH(e){function t(t,n){let{value:r,path:o="",label:i,options:a,originalValue:s,sync:l}=t,c=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["value","path","label","options","originalValue","sync"]);const{name:u,test:d,params:p,message:f}=e;let{parent:h,context:m}=a;function g(e){return UH.isRef(e)?e.getValue(r,h,m):e}function v(e={}){const t=FH()(zH({value:r,originalValue:s,label:i,path:e.path||o},p,e.params),g),n=new BH(BH.formatError(e.message||f,t),r,t.path,e.type||u);return n.params=t,n}let y,b=zH({path:o,parent:h,type:u,createError:v,resolve:g,options:a,originalValue:s},c);if(l){try{var _;if(y=d.call(b,r,b),"function"==typeof(null==(_=y)?void 0:_.then))throw new Error(`Validation test of type: "${b.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`)}catch(e){return void n(e)}BH.isError(y)?n(y):y?n(null,y):n(v())}else try{Promise.resolve(d.call(b,r,b)).then((e=>{BH.isError(e)?n(e):e?n(null,e):n(v())})).catch(n)}catch(e){n(e)}}return t.OPTIONS=e,t}UH.prototype.__isYupRef=!0;function VH(e,t,n,r=n){let o,i,a;return t?((0,jH.forEach)(t,((s,l,c)=>{let u=l?(e=>e.substr(0,e.length-1).substr(1))(s):s;if((e=e.resolve({context:r,parent:o,value:n})).innerType){let r=c?parseInt(u,10):0;if(n&&r>=n.length)throw new Error(`Yup.reach cannot resolve an array item at index: ${s}, in the path: ${t}. because there is no value at that index. `);o=n,n=n&&n[r],e=e.innerType}if(!c){if(!e.fields||!e.fields[u])throw new Error(`The schema does not contain the path: ${t}. (failed at: ${a} which is a type: "${e._type}")`);o=n,n=n&&n[u],e=e.fields[u]}i=u,a=l?"["+s+"]":"."+s})),{schema:e,parent:o,parentPath:i}):{parent:o,parentPath:t,schema:e}}class GH{constructor(){this.list=void 0,this.refs=void 0,this.list=new Set,this.refs=new Map}get size(){return this.list.size+this.refs.size}describe(){const e=[];for(const t of this.list)e.push(t);for(const[,t]of this.refs)e.push(t.describe());return e}toArray(){return Array.from(this.list).concat(Array.from(this.refs.values()))}resolveAll(e){return this.toArray().reduce(((t,n)=>t.concat(UH.isRef(n)?e(n):n)),[])}add(e){UH.isRef(e)?this.refs.set(e.key,e):this.list.add(e)}delete(e){UH.isRef(e)?this.refs.delete(e.key):this.list.delete(e)}clone(){const e=new GH;return e.list=new Set(this.list),e.refs=new Map(this.refs),e}merge(e,t){const n=this.clone();return e.list.forEach((e=>n.add(e))),e.refs.forEach((e=>n.add(e))),t.list.forEach((e=>n.delete(e))),t.refs.forEach((e=>n.delete(e))),n}}function QH(){return QH=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},QH.apply(this,arguments)}class qH{constructor(e){this.deps=[],this.tests=void 0,this.transforms=void 0,this.conditions=[],this._mutate=void 0,this._typeError=void 0,this._whitelist=new GH,this._blacklist=new GH,this.exclusiveTests=Object.create(null),this.spec=void 0,this.tests=[],this.transforms=[],this.withMutation((()=>{this.typeError(AH.notType)})),this.type=(null==e?void 0:e.type)||"mixed",this.spec=QH({strip:!1,strict:!1,abortEarly:!0,recursive:!0,nullable:!1,presence:"optional"},null==e?void 0:e.spec)}get _type(){return this.type}_typeCheck(e){return!0}clone(e){if(this._mutate)return e&&Object.assign(this.spec,e),this;const t=Object.create(Object.getPrototypeOf(this));return t.type=this.type,t._typeError=this._typeError,t._whitelistError=this._whitelistError,t._blacklistError=this._blacklistError,t._whitelist=this._whitelist.clone(),t._blacklist=this._blacklist.clone(),t.exclusiveTests=QH({},this.exclusiveTests),t.deps=[...this.deps],t.conditions=[...this.conditions],t.tests=[...this.tests],t.transforms=[...this.transforms],t.spec=fH(QH({},this.spec,e)),t}label(e){let t=this.clone();return t.spec.label=e,t}meta(...e){if(0===e.length)return this.spec.meta;let t=this.clone();return t.spec.meta=Object.assign(t.spec.meta||{},e[0]),t}withMutation(e){let t=this._mutate;this._mutate=!0;let n=e(this);return this._mutate=t,n}concat(e){if(!e||e===this)return this;if(e.type!==this.type&&"mixed"!==this.type)throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${e.type}`);let t=this,n=e.clone();const r=QH({},t.spec,n.spec);return n.spec=r,n._typeError||(n._typeError=t._typeError),n._whitelistError||(n._whitelistError=t._whitelistError),n._blacklistError||(n._blacklistError=t._blacklistError),n._whitelist=t._whitelist.merge(e._whitelist,e._blacklist),n._blacklist=t._blacklist.merge(e._blacklist,e._whitelist),n.tests=t.tests,n.exclusiveTests=t.exclusiveTests,n.withMutation((t=>{e.tests.forEach((e=>{t.test(e.OPTIONS)}))})),n.transforms=[...t.transforms,...n.transforms],n}isType(e){return!(!this.spec.nullable||null!==e)||this._typeCheck(e)}resolve(e){let t=this;if(t.conditions.length){let n=t.conditions;t=t.clone(),t.conditions=[],t=n.reduce(((t,n)=>n.resolve(t,e)),t),t=t.resolve(e)}return t}cast(e,t={}){let n=this.resolve(QH({value:e},t)),r=n._cast(e,t);if(void 0!==e&&!1!==t.assert&&!0!==n.isType(r)){let o=_H(e),i=_H(r);throw new TypeError(`The value of ${t.path||"field"} could not be cast to a value that satisfies the schema type: "${n._type}". \n\nattempted value: ${o} \n`+(i!==o?`result of cast: ${i}`:""))}return r}_cast(e,t){let n=void 0===e?e:this.transforms.reduce(((t,n)=>n.call(this,t,e,this)),e);return void 0===n&&(n=this.getDefault()),n}_validate(e,t={},n){let{sync:r,path:o,from:i=[],originalValue:a=e,strict:s=this.spec.strict,abortEarly:l=this.spec.abortEarly}=t,c=e;s||(c=this._cast(c,QH({assert:!1},t)));let u={value:c,path:o,options:t,originalValue:a,schema:this,label:this.spec.label,sync:r,from:i},d=[];this._typeError&&d.push(this._typeError);let p=[];this._whitelistError&&p.push(this._whitelistError),this._blacklistError&&p.push(this._blacklistError),RH({args:u,value:c,path:o,sync:r,tests:d,endEarly:l},(e=>{e?n(e,c):RH({tests:this.tests.concat(p),args:u,path:o,sync:r,value:c,endEarly:l},n)}))}validate(e,t,n){let r=this.resolve(QH({},t,{value:e}));return"function"==typeof n?r._validate(e,t,n):new Promise(((n,o)=>r._validate(e,t,((e,t)=>{e?o(e):n(t)}))))}validateSync(e,t){let n;return this.resolve(QH({},t,{value:e}))._validate(e,QH({},t,{sync:!0}),((e,t)=>{if(e)throw e;n=t})),n}isValid(e,t){return this.validate(e,t).then((()=>!0),(e=>{if(BH.isError(e))return!1;throw e}))}isValidSync(e,t){try{return this.validateSync(e,t),!0}catch(e){if(BH.isError(e))return!1;throw e}}_getDefault(){let e=this.spec.default;return null==e?e:"function"==typeof e?e.call(this):fH(e)}getDefault(e){return this.resolve(e||{})._getDefault()}default(e){if(0===arguments.length)return this._getDefault();return this.clone({default:e})}strict(e=!0){let t=this.clone();return t.spec.strict=e,t}_isPresent(e){return null!=e}defined(e=AH.defined){return this.test({message:e,name:"defined",exclusive:!0,test:e=>void 0!==e})}required(e=AH.required){return this.clone({presence:"required"}).withMutation((t=>t.test({message:e,name:"required",exclusive:!0,test(e){return this.schema._isPresent(e)}})))}notRequired(){let e=this.clone({presence:"optional"});return e.tests=e.tests.filter((e=>"required"!==e.OPTIONS.name)),e}nullable(e=!0){return this.clone({nullable:!1!==e})}transform(e){let t=this.clone();return t.transforms.push(e),t}test(...e){let t;if(t=1===e.length?"function"==typeof e[0]?{test:e[0]}:e[0]:2===e.length?{name:e[0],test:e[1]}:{name:e[0],message:e[1],test:e[2]},void 0===t.message&&(t.message=AH.default),"function"!=typeof t.test)throw new TypeError("`test` is a required parameters");let n=this.clone(),r=WH(t),o=t.exclusive||t.name&&!0===n.exclusiveTests[t.name];if(t.exclusive&&!t.name)throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");return t.name&&(n.exclusiveTests[t.name]=!!t.exclusive),n.tests=n.tests.filter((e=>{if(e.OPTIONS.name===t.name){if(o)return!1;if(e.OPTIONS.test===r.OPTIONS.test)return!1}return!0})),n.tests.push(r),n}when(e,t){Array.isArray(e)||"string"==typeof e||(t=e,e=".");let n=this.clone(),r=LH(e).map((e=>new UH(e)));return r.forEach((e=>{e.isSibling&&n.deps.push(e.key)})),n.conditions.push(new DH(r,t)),n}typeError(e){let t=this.clone();return t._typeError=WH({message:e,name:"typeError",test(e){return!(void 0!==e&&!this.schema.isType(e))||this.createError({params:{type:this.schema._type}})}}),t}oneOf(e,t=AH.oneOf){let n=this.clone();return e.forEach((e=>{n._whitelist.add(e),n._blacklist.delete(e)})),n._whitelistError=WH({message:t,name:"oneOf",test(e){if(void 0===e)return!0;let t=this.schema._whitelist,n=t.resolveAll(this.resolve);return!!n.includes(e)||this.createError({params:{values:t.toArray().join(", "),resolved:n}})}}),n}notOneOf(e,t=AH.notOneOf){let n=this.clone();return e.forEach((e=>{n._blacklist.add(e),n._whitelist.delete(e)})),n._blacklistError=WH({message:t,name:"notOneOf",test(e){let t=this.schema._blacklist,n=t.resolveAll(this.resolve);return!n.includes(e)||this.createError({params:{values:t.toArray().join(", "),resolved:n}})}}),n}strip(e=!0){let t=this.clone();return t.spec.strip=e,t}describe(){const e=this.clone(),{label:t,meta:n}=e.spec,r={meta:n,label:t,type:e.type,oneOf:e._whitelist.describe(),notOneOf:e._blacklist.describe(),tests:e.tests.map((e=>({name:e.OPTIONS.name,params:e.OPTIONS.params}))).filter(((e,t,n)=>n.findIndex((t=>t.name===e.name))===t))};return r}}qH.prototype.__isYupSchema__=!0;for(const e of["validate","validateSync"])qH.prototype[`${e}At`]=function(t,n,r={}){const{parent:o,parentPath:i,schema:a}=VH(this,t,n,r.context);return a[e](o&&o[i],QH({},r,{parent:o,path:t}))};for(const e of["equals","is"])qH.prototype[e]=qH.prototype.oneOf;for(const e of["not","nope"])qH.prototype[e]=qH.prototype.notOneOf;qH.prototype.optional=qH.prototype.notRequired;const KH=qH;function ZH(){return new KH}ZH.prototype=KH.prototype;const JH=e=>null==e;function XH(){return new eU}class eU extends qH{constructor(){super({type:"boolean"}),this.withMutation((()=>{this.transform((function(e){if(!this.isType(e)){if(/^(true|1)$/i.test(String(e)))return!0;if(/^(false|0)$/i.test(String(e)))return!1}return e}))}))}_typeCheck(e){return e instanceof Boolean&&(e=e.valueOf()),"boolean"==typeof e}isTrue(e=kH.isValue){return this.test({message:e,name:"is-value",exclusive:!0,params:{value:"true"},test:e=>JH(e)||!0===e})}isFalse(e=kH.isValue){return this.test({message:e,name:"is-value",exclusive:!0,params:{value:"false"},test:e=>JH(e)||!1===e})}}XH.prototype=eU.prototype;let tU=/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i,nU=/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,rU=/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i,oU=e=>JH(e)||e===e.trim(),iU={}.toString();function aU(){return new sU}class sU extends qH{constructor(){super({type:"string"}),this.withMutation((()=>{this.transform((function(e){if(this.isType(e))return e;if(Array.isArray(e))return e;const t=null!=e&&e.toString?e.toString():e;return t===iU?e:t}))}))}_typeCheck(e){return e instanceof String&&(e=e.valueOf()),"string"==typeof e}_isPresent(e){return super._isPresent(e)&&!!e.length}length(e,t=EH.length){return this.test({message:t,name:"length",exclusive:!0,params:{length:e},test(t){return JH(t)||t.length===this.resolve(e)}})}min(e,t=EH.min){return this.test({message:t,name:"min",exclusive:!0,params:{min:e},test(t){return JH(t)||t.length>=this.resolve(e)}})}max(e,t=EH.max){return this.test({name:"max",exclusive:!0,message:t,params:{max:e},test(t){return JH(t)||t.length<=this.resolve(e)}})}matches(e,t){let n,r,o=!1;return t&&("object"==typeof t?({excludeEmptyString:o=!1,message:n,name:r}=t):n=t),this.test({name:r||"matches",message:n||EH.matches,params:{regex:e},test:t=>JH(t)||""===t&&o||-1!==t.search(e)})}email(e=EH.email){return this.matches(tU,{name:"email",message:e,excludeEmptyString:!0})}url(e=EH.url){return this.matches(nU,{name:"url",message:e,excludeEmptyString:!0})}uuid(e=EH.uuid){return this.matches(rU,{name:"uuid",message:e,excludeEmptyString:!1})}ensure(){return this.default("").transform((e=>null===e?"":e))}trim(e=EH.trim){return this.transform((e=>null!=e?e.trim():e)).test({message:e,name:"trim",test:oU})}lowercase(e=EH.lowercase){return this.transform((e=>JH(e)?e:e.toLowerCase())).test({message:e,name:"string_case",exclusive:!0,test:e=>JH(e)||e===e.toLowerCase()})}uppercase(e=EH.uppercase){return this.transform((e=>JH(e)?e:e.toUpperCase())).test({message:e,name:"string_case",exclusive:!0,test:e=>JH(e)||e===e.toUpperCase()})}}aU.prototype=sU.prototype;function lU(){return new cU}class cU extends qH{constructor(){super({type:"number"}),this.withMutation((()=>{this.transform((function(e){let t=e;if("string"==typeof t){if(t=t.replace(/\s/g,""),""===t)return NaN;t=+t}return this.isType(t)?t:parseFloat(t)}))}))}_typeCheck(e){return e instanceof Number&&(e=e.valueOf()),"number"==typeof e&&!(e=>e!=+e)(e)}min(e,t=wH.min){return this.test({message:t,name:"min",exclusive:!0,params:{min:e},test(t){return JH(t)||t>=this.resolve(e)}})}max(e,t=wH.max){return this.test({message:t,name:"max",exclusive:!0,params:{max:e},test(t){return JH(t)||t<=this.resolve(e)}})}lessThan(e,t=wH.lessThan){return this.test({message:t,name:"max",exclusive:!0,params:{less:e},test(t){return JH(t)||t<this.resolve(e)}})}moreThan(e,t=wH.moreThan){return this.test({message:t,name:"min",exclusive:!0,params:{more:e},test(t){return JH(t)||t>this.resolve(e)}})}positive(e=wH.positive){return this.moreThan(0,e)}negative(e=wH.negative){return this.lessThan(0,e)}integer(e=wH.integer){return this.test({name:"integer",message:e,test:e=>JH(e)||Number.isInteger(e)})}truncate(){return this.transform((e=>JH(e)?e:0|e))}round(e){var t;let n=["ceil","floor","round","trunc"];if("trunc"===(e=(null==(t=e)?void 0:t.toLowerCase())||"round"))return this.truncate();if(-1===n.indexOf(e.toLowerCase()))throw new TypeError("Only valid options for round() are: "+n.join(", "));return this.transform((t=>JH(t)?t:Math[e](t)))}}lU.prototype=cU.prototype;var uU=/^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;let dU=new Date("");function pU(){return new fU}class fU extends qH{constructor(){super({type:"date"}),this.withMutation((()=>{this.transform((function(e){return this.isType(e)?e:(e=function(e){var t,n,r=[1,4,5,6,7,10,11],o=0;if(n=uU.exec(e)){for(var i,a=0;i=r[a];++a)n[i]=+n[i]||0;n[2]=(+n[2]||1)-1,n[3]=+n[3]||1,n[7]=n[7]?String(n[7]).substr(0,3):0,void 0!==n[8]&&""!==n[8]||void 0!==n[9]&&""!==n[9]?("Z"!==n[8]&&void 0!==n[9]&&(o=60*n[10]+n[11],"+"===n[9]&&(o=0-o)),t=Date.UTC(n[1],n[2],n[3],n[4],n[5]+o,n[6],n[7])):t=+new Date(n[1],n[2],n[3],n[4],n[5],n[6],n[7])}else t=Date.parse?Date.parse(e):NaN;return t}(e),isNaN(e)?dU:new Date(e))}))}))}_typeCheck(e){return t=e,"[object Date]"===Object.prototype.toString.call(t)&&!isNaN(e.getTime());var t}prepareParam(e,t){let n;if(UH.isRef(e))n=e;else{let r=this.cast(e);if(!this._typeCheck(r))throw new TypeError(`\`${t}\` must be a Date or a value that can be \`cast()\` to a Date`);n=r}return n}min(e,t=xH.min){let n=this.prepareParam(e,"min");return this.test({message:t,name:"min",exclusive:!0,params:{min:e},test(e){return JH(e)||e>=this.resolve(n)}})}max(e,t=xH.max){let n=this.prepareParam(e,"max");return this.test({message:t,name:"max",exclusive:!0,params:{max:e},test(e){return JH(e)||e<=this.resolve(n)}})}}fU.INVALID_DATE=dU,pU.prototype=fU.prototype,pU.INVALID_DATE=dU;var hU=o(88774),mU=o.n(hU),gU=o(66036),vU=o.n(gU),yU=o(79832),bU=o.n(yU),_U=o(30171),AU=o.n(_U);function EU(e,t){let n=1/0;return e.some(((e,r)=>{var o;if(-1!==(null==(o=t.path)?void 0:o.indexOf(e)))return n=r,!0})),n}function wU(e){return(t,n)=>EU(e,t)-EU(e,n)}function xU(){return xU=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},xU.apply(this,arguments)}let kU=e=>"[object Object]"===Object.prototype.toString.call(e);const CU=wU([]);class SU extends qH{constructor(e){super({type:"object"}),this.fields=Object.create(null),this._sortErrors=CU,this._nodes=[],this._excludedEdges=[],this.withMutation((()=>{this.transform((function(e){if("string"==typeof e)try{e=JSON.parse(e)}catch(t){e=null}return this.isType(e)?e:null})),e&&this.shape(e)}))}_typeCheck(e){return kU(e)||"function"==typeof e}_cast(e,t={}){var n;let r=super._cast(e,t);if(void 0===r)return this.getDefault();if(!this._typeCheck(r))return r;let o=this.fields,i=null!=(n=t.stripUnknown)?n:this.spec.noUnknown,a=this._nodes.concat(Object.keys(r).filter((e=>-1===this._nodes.indexOf(e)))),s={},l=xU({},t,{parent:s,__validating:t.__validating||!1}),c=!1;for(const e of a){let n=o[e],a=TH()(r,e);if(n){let o,i=r[e];l.path=(t.path?`${t.path}.`:"")+e,n=n.resolve({value:i,context:t.context,parent:s});let a="spec"in n?n.spec:void 0,u=null==a?void 0:a.strict;if(null==a?void 0:a.strip){c=c||e in r;continue}o=t.__validating&&u?r[e]:n.cast(r[e],l),void 0!==o&&(s[e]=o)}else a&&!i&&(s[e]=r[e]);s[e]!==r[e]&&(c=!0)}return c?s:r}_validate(e,t={},n){let r=[],{sync:o,from:i=[],originalValue:a=e,abortEarly:s=this.spec.abortEarly,recursive:l=this.spec.recursive}=t;i=[{schema:this,value:a},...i],t.__validating=!0,t.originalValue=a,t.from=i,super._validate(e,t,((e,c)=>{if(e){if(!BH.isError(e)||s)return void n(e,c);r.push(e)}if(!l||!kU(c))return void n(r[0]||null,c);a=a||c;let u=this._nodes.map((e=>(n,r)=>{let o=-1===e.indexOf(".")?(t.path?`${t.path}.`:"")+e:`${t.path||""}["${e}"]`,s=this.fields[e];s&&"validate"in s?s.validate(c[e],xU({},t,{path:o,from:i,strict:!0,parent:c,originalValue:a[e]}),r):r(null)}));RH({sync:o,tests:u,value:c,errors:r,endEarly:s,sort:this._sortErrors,path:t.path},n)}))}clone(e){const t=super.clone(e);return t.fields=xU({},this.fields),t._nodes=this._nodes,t._excludedEdges=this._excludedEdges,t._sortErrors=this._sortErrors,t}concat(e){let t=super.concat(e),n=t.fields;for(let[e,t]of Object.entries(this.fields)){const r=n[e];void 0===r?n[e]=t:r instanceof qH&&t instanceof qH&&(n[e]=t.concat(r))}return t.withMutation((()=>t.shape(n,this._excludedEdges)))}getDefaultFromShape(){let e={};return this._nodes.forEach((t=>{const n=this.fields[t];e[t]="default"in n?n.getDefault():void 0})),e}_getDefault(){return"default"in this.spec?super._getDefault():this._nodes.length?this.getDefaultFromShape():void 0}shape(e,t=[]){let n=this.clone(),r=Object.assign(n.fields,e);return n.fields=r,n._sortErrors=wU(Object.keys(r)),t.length&&(Array.isArray(t[0])||(t=[t]),n._excludedEdges=[...n._excludedEdges,...t]),n._nodes=function(e,t=[]){let n=[],r=new Set,o=new Set(t.map((([e,t])=>`${e}-${t}`)));function i(e,t){let i=(0,jH.split)(e)[0];r.add(i),o.has(`${t}-${i}`)||n.push([t,i])}for(const t in e)if(TH()(e,t)){let n=e[t];r.add(t),UH.isRef(n)&&n.isSibling?i(n.path,t):OH(n)&&"deps"in n&&n.deps.forEach((e=>i(e,t)))}return AU().array(Array.from(r),n).reverse()}(r,n._excludedEdges),n}pick(e){const t={};for(const n of e)this.fields[n]&&(t[n]=this.fields[n]);return this.clone().withMutation((e=>(e.fields={},e.shape(t))))}omit(e){const t=this.clone(),n=t.fields;t.fields={};for(const t of e)delete n[t];return t.withMutation((()=>t.shape(n)))}from(e,t,n){let r=(0,jH.getter)(e,!0);return this.transform((o=>{if(null==o)return o;let i=o;return TH()(o,e)&&(i=xU({},o),n||delete i[e],i[t]=r(o)),i}))}noUnknown(e=!0,t=CH.noUnknown){"string"==typeof e&&(t=e,e=!0);let n=this.test({name:"noUnknown",exclusive:!0,message:t,test(t){if(null==t)return!0;const n=function(e,t){let n=Object.keys(e.fields);return Object.keys(t).filter((e=>-1===n.indexOf(e)))}(this.schema,t);return!e||0===n.length||this.createError({params:{unknown:n.join(", ")}})}});return n.spec.noUnknown=e,n}unknown(e=!0,t=CH.noUnknown){return this.noUnknown(!e,t)}transformKeys(e){return this.transform((t=>t&&bU()(t,((t,n)=>e(n)))))}camelCase(){return this.transformKeys(vU())}snakeCase(){return this.transformKeys(mU())}constantCase(){return this.transformKeys((e=>mU()(e).toUpperCase()))}describe(){let e=super.describe();return e.fields=FH()(this.fields,(e=>e.describe())),e}}function MU(e){return new SU(e)}MU.prototype=SU.prototype;var[TU,OU]=xr({name:"CheckboxGroupContext",strict:!1});function DU(e){return(0,br.jsx)(vr.svg,{width:"1.2em",viewBox:"0 0 12 10",style:{fill:"none",strokeWidth:2,stroke:"currentColor",strokeDasharray:16},...e,children:(0,br.jsx)("polyline",{points:"1.5 6 4.5 9 10.5 1"})})}function LU(e){return(0,br.jsx)(vr.svg,{width:"1.2em",viewBox:"0 0 24 24",style:{stroke:"currentColor",strokeWidth:4},...e,children:(0,br.jsx)("line",{x1:"21",x2:"3",y1:"12",y2:"12"})})}function PU(e){const{isIndeterminate:t,isChecked:n,...r}=e,o=t?LU:DU;return n||t?(0,br.jsx)(vr.div,{style:{display:"flex",alignItems:"center",justifyContent:"center",height:"100%"},children:(0,br.jsx)(o,{...r})}):null}var IU={display:"inline-flex",alignItems:"center",justifyContent:"center",verticalAlign:"top",userSelect:"none",flexShrink:0},BU={cursor:"pointer",display:"inline-flex",alignItems:"center",verticalAlign:"top",position:"relative"},RU=Dr({from:{opacity:0,strokeDashoffset:16,transform:"scale(0.95)"},to:{opacity:1,strokeDashoffset:0,transform:"scale(1)"}}),NU=Dr({from:{opacity:0},to:{opacity:1}}),FU=Dr({from:{transform:"scaleX(0.65)"},to:{transform:"scaleX(1)"}}),jU=yr((function(e,t){const n=OU(),r=jr("Checkbox",{...n,...e}),o=pt(e),{spacing:a="0.5rem",className:s,children:l,iconColor:c,iconSize:u,icon:d=(0,br.jsx)(PU,{}),isChecked:p,isDisabled:f=(null==n?void 0:n.isDisabled),onChange:h,inputProps:m,...v}=o;let y=p;(null==n?void 0:n.value)&&o.value&&(y=n.value.includes(o.value));let b=h;(null==n?void 0:n.onChange)&&o.value&&(b=x(n.onChange,h));const{state:_,getInputProps:A,getCheckboxProps:E,getLabelProps:w,getRootProps:k}=Zx({...v,isDisabled:f,isChecked:y,onChange:b}),C=function(e){const[t,n]=(0,i.useState)(e),[r,o]=(0,i.useState)(!1);return e!==t&&(o(!0),n(e)),r}(_.isChecked),S=(0,i.useMemo)((()=>({animation:C?_.isIndeterminate?`${NU} 20ms linear, ${FU} 200ms linear`:`${RU} 200ms linear`:void 0,fontSize:u,color:c,...r.icon})),[c,u,C,_.isIndeterminate,r.icon]),M=(0,i.cloneElement)(d,{__css:S,isIndeterminate:_.isIndeterminate,isChecked:_.isChecked});return(0,br.jsxs)(vr.label,{__css:{...BU,...r.container},className:g("chakra-checkbox",s),...k(),children:[(0,br.jsx)("input",{className:"chakra-checkbox__input",...A(m,t)}),(0,br.jsx)(vr.span,{__css:{...IU,...r.control},className:"chakra-checkbox__control",...E(),children:M}),l&&(0,br.jsx)(vr.span,{className:"chakra-checkbox__label",...w(),__css:{marginStart:a,...r.label},children:l})]})}));jU.displayName="Checkbox";var YU=["className","defaultChecked","isChecked","isDisabled","label","name","onChange","value"];function $U(){return $U=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},$U.apply(null,arguments)}var HU=pr(jU,{target:"evpuzrf3"})((e=>{var{theme:t}=e,{customStyle:n}=t.components.Checkbox;return'\n        margin-right: 8px;\n        text-align: center;\n\n        input[type="checkbox"] {\n            + span {\n                background-color: '+n.backgroundColor+";\n                border-color: "+n.borderColor+";\n                width: "+n.width+";\n                border-radius: 2px;\n                border-width: 1px;\n\n                svg {\n                    stroke: "+n.checkColor+";\n                    color: "+n.checkColor+";\n                    width: "+n.checkWidth+";\n                }\n            }\n\n            &:checked + span {\n                background-color: "+n.backgroundColor+";\n                border-color: "+n.borderColor+";\n\n                svg {\n                    stroke: "+n.checkColor+";\n                    color: "+n.checkColor+";\n                }\n            }\n\n            &:disabled + span {\n                background-color: "+n[tp.Disabled].backgroundColor+";\n                border-color: "+n.borderColor+";\n\n                svg {\n                    stroke: "+n[tp.Disabled].checkColor+";\n                }\n            }\n\n            &:checked:disabled + span {\n                background-color: "+n[tp.Disabled].backgroundColor+";\n                border-color: "+n[tp.Disabled].borderColor+";\n\n                svg {\n                    stroke: "+n[tp.Disabled].checkColor+";\n                }\n            }\n        }\n\n        &:hover {\n            cursor: pointer;\n        }\n    "}),""),UU=pr(wx,{target:"evpuzrf2"})({name:"14gmjly",styles:"margin:0;pointer-events:none"}),zU=pr(UU,{target:"evpuzrf1"})((e=>{var{theme:t}=e;return"color: "+t.components.ToggleSwitch.baseStyle.disabledLabelColor}),""),WU=pr(Xp,{target:"evpuzrf0"})({name:"zjik7",styles:"display:flex"});const VU=e=>{var{className:t,defaultChecked:n,isChecked:r,isDisabled:o,label:i,name:a,onChange:s,value:l}=e,c=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,YU),u=c.children;return i&&(u=Mr(o?zU:UU,{"data-testid":"sp-ui-checkbox-label"},i)),Mr(Mp,null,Mr(WU,$U({className:t,"data-testid":"sp-ui-checkbox"},c),Mr(HU,$U({"data-testid":"sp-ui-checkbox-chakra",defaultChecked:n,isChecked:r,isDisabled:o,name:a,onChange:s,value:l},c),u)))};var GU=o(41655),QU=o.n(GU),qU=o(87504),KU=o.n(qU),ZU=o(46186),JU=o.n(ZU),XU=o(82155),ez=o.n(XU),tz=o(27433),nz=o.n(tz),rz=o(88626),oz=o.n(rz),iz=o(8990),az=o.n(iz),sz=o(89827),lz=o.n(sz),cz=o(2063),uz={};uz.styleTagTransform=lz(),uz.setAttributes=oz(),uz.insert=nz().bind(null,"head"),uz.domAPI=ez(),uz.insertStyleElement=az();JU()(cz.A,uz);cz.A&&cz.A.locals&&cz.A.locals;var dz=yr((function(e,t){const{htmlSize:n,...r}=e,o=jr("Input",r),i=Gx(pt(r)),a=g("chakra-input",e.className);return(0,br.jsx)(vr.input,{size:n,...i,__css:o.field,ref:t,className:a})}));dz.displayName="Input",dz.id="Input";var[pz,fz]=xr({name:"InputGroupStylesContext",errorMessage:"useInputGroupStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<InputGroup />\" "}),hz=yr((function(e,t){const n=jr("Input",e),{children:r,className:o,...a}=pt(e),s=g("chakra-input__group",o),l={},c=Zp(r),u=n.field;c.forEach((e=>{var t,r;n&&(u&&"InputLeftElement"===e.type.id&&(l.paddingStart=null!=(t=u.height)?t:u.h),u&&"InputRightElement"===e.type.id&&(l.paddingEnd=null!=(r=u.height)?r:u.h),"InputRightAddon"===e.type.id&&(l.borderEndRadius=0),"InputLeftAddon"===e.type.id&&(l.borderStartRadius=0))}));const d=c.map((t=>{var n,r;const o=Qr({size:(null==(n=t.props)?void 0:n.size)||e.size,variant:(null==(r=t.props)?void 0:r.variant)||e.variant});return"Input"!==t.type.id?(0,i.cloneElement)(t,o):(0,i.cloneElement)(t,Object.assign(o,l,t.props))}));return(0,br.jsx)(vr.div,{className:s,ref:t,__css:{width:"100%",display:"flex",position:"relative",isolation:"isolate",...n.group},"data-group":!0,...a,children:(0,br.jsx)(pz,{value:n,children:d})})}));hz.displayName="InputGroup";var mz={left:{marginEnd:"-1px",borderEndRadius:0,borderEndColor:"transparent"},right:{marginStart:"-1px",borderStartRadius:0,borderStartColor:"transparent"}},gz=vr("div",{baseStyle:{flex:"0 0 auto",width:"auto",display:"flex",alignItems:"center",whiteSpace:"nowrap"}}),vz=yr((function(e,t){var n;const{placement:r="left",...o}=e,i=null!=(n=mz[r])?n:{},a=fz();return(0,br.jsx)(gz,{ref:t,...o,__css:{...a.addon,...i}})}));vz.displayName="InputAddon";var yz=yr((function(e,t){return(0,br.jsx)(vz,{ref:t,placement:"left",...e,className:g("chakra-input__left-addon",e.className)})}));yz.displayName="InputLeftAddon",yz.id="InputLeftAddon";var bz=yr((function(e,t){return(0,br.jsx)(vz,{ref:t,placement:"right",...e,className:g("chakra-input__right-addon",e.className)})}));bz.displayName="InputRightAddon",bz.id="InputRightAddon";var _z=o(86838),Az=o.n(_z),Ez=["append","appendOnClick","defaultValue","forceState","id","isDisabled","isRequired","isInvalid","isValid","label","name","onBlur","onChange","onClear","onClick","onKeyDown","prepend","showValidationIcons","type"];function wz(){return wz=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},wz.apply(null,arguments)}var xz=function(e){return Mr("svg",e,Mr("g",{fill:"none",fillRule:"evenodd",transform:"translate(1 1)"},Mr("circle",{cx:"10",cy:"10",r:"10",stroke:"#A5CC9B"}),Mr("path",{fill:"#A5CC9B",d:"M9.416 13.239a.997.997 0 0 1-.707-.293l-2.532-2.532A1 1 0 0 1 7.59 9l1.825 1.825 3.535-3.536a1 1 0 1 1 1.414 1.414l-4.242 4.243a.997.997 0 0 1-.707.293z"})))};xz.defaultProps={xmlns:"http://www.w3.org/2000/svg",width:"22",height:"22","data-testid":"check-success"};var kz=function(e){return Mr("svg",e,Mr("path",{d:"M8.996 6.895l4.633-4.633a.45.45 0 0 0 0-.637L12.144.14a.45.45 0 0 0-.636 0l-4.63 4.63L2.256.132a.45.45 0 0 0-.636 0L.132 1.612a.45.45 0 0 0 0 .636l4.625 4.642-4.613 4.613a.45.45 0 0 0 0 .636l1.485 1.485a.45.45 0 0 0 .637 0l4.61-4.609 4.6 4.616a.45.45 0 0 0 .636.001l1.487-1.48a.45.45 0 0 0 .001-.638l-4.604-4.62"}))};kz.defaultProps={viewBox:"0 0 14 14",xmlns:"http://www.w3.org/2000/svg"};var Cz=pr(Mp,{target:"e1v3nw1d6"})({name:"y67s2w",styles:"border:none;margin:0;min-height:38px;height:auto;position:relative;padding:0;label~svg{top:35px;}"}),Sz=pr(dz,{shouldForwardProp:e=>"hasIcons"!==e,target:"e1v3nw1d5"})((e=>{var{theme:t,isDisabled:n,hasIcons:r}=e,{fontStyles:o}=np(t,{isDisabled:n});return"\n        border: none;\n        border-radius: 0;\n        box-shadow: none;\n        box-sizing: border-box;\n        outline: none;\n        padding: "+(r?"6px 40px 6px 12px":"6px 12px")+";\n        width: 100%;\n        "+o+'\n\n        &[aria-invalid="true"] {\n            box-shadow: none;\n        }\n\n        &:focus,\n        &:hover {\n            border-width: 1px;\n            box-shadow: none;\n        }\n    '}),""),Mz=pr(yz,{shouldForwardProp:e=>_F(e),target:"e1v3nw1d4"})((e=>{var{isDisabled:t,isFocused:n,theme:r}=e,{backgroundColor:o,borderColor:i,color:a}=np(r,{isDisabled:t,isFocused:n});return"\n        background-color: "+o+";\n        border: none;\n        border-radius: 0;\n        color: "+(n?i:a)+";\n        opacity: "+(t?.4:"")+";\n        padding-left: 8px;\n        padding-right: 8px;\n    "}),""),Tz=pr(bz,{shouldForwardProp:e=>_F(e),target:"e1v3nw1d3"})((e=>{var{isDisabled:t,isFocused:n,onClick:r,theme:o}=e,{backgroundColor:i,borderColor:a,color:s}=np(o,{isDisabled:t,isFocused:n});return"\n        background-color: "+i+";\n        border: none;\n        border-radius: 0;\n        color: "+(n?a:s)+";\n        cursor: "+(t?"not-allowed":r?"pointer":"")+";\n        opacity: "+(t?.4:"")+";\n        padding-left: 8px;\n        padding-right: 8px;\n    "}),""),Oz=pr(wr,{target:"e1v3nw1d2"})({name:"h24ubs",styles:"height:auto;padding:0;width:100%"}),Dz=pr(hz,{shouldForwardProp:e=>"isDisabled"!==e&&"isFocused"!==e&&"isHovered"!==e&&"isInvalid"!==e,target:"e1v3nw1d1"})((e=>{var{isDisabled:t,isFocused:n,isHovered:r,isInvalid:o,theme:i}=e,{borderColor:a}=np(i,{isDisabled:t,isHovered:r,isInvalid:o,isFocused:n});return"\n        border-color: "+a+";\n        border-style: solid;\n        border-width: 1px;\n        box-sizing: border-box;\n        border-radius: 3px;\n        overflow: hidden;\n    "}),""),Lz=pr(wr,{target:"e1v3nw1d0"})((e=>{var{theme:t}=e;return"\n        align-items: center;\n        padding-right: 12px;\n        position: absolute;\n        right: 0;\n        top: 0;\n        height: 100%;\n        z-index: 1;\n\n        svg[cursor='pointer'] {\n            color: "+t.colors.gray[600]+";\n\n            &:hover {\n                color: "+t.colors.gray[700]+";\n            }\n        }\n\n        svg:not(:first-of-type) {\n            margin-left: 12px;\n        }\n    "}),"");const Pz=e=>{var{append:t,appendOnClick:n,defaultValue:r="",forceState:o,id:a,isDisabled:s,isRequired:l,isInvalid:c,isValid:u,label:d,name:p,onBlur:f,onChange:h,onClear:m,onClick:g,onKeyDown:v,prepend:y,showValidationIcons:b=!0,type:_="text"}=e,A=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,Ez),[E,w]=(0,i.useState)(r),[x,k]=(0,i.useState)(!1),[C,S]=(0,i.useState)(!1),M=(0,i.useRef)(null),T=C||o===tp.Focus,O=Boolean(b&&c||b&&u||m&&E),D=Az()({"is-invalid":c,"is-valid":u});return Mr(Cz,{"data-testid":"sp-ui-text-input",isRequired:l},d&&Mr(wx,null,d),Mr(Dz,{borderRadius:"3px",className:D,isDisabled:Boolean(s),isFocused:T,isHovered:x,isInvalid:c,onMouseLeave:()=>k(!1),onMouseOver:()=>k(!0),onFocus:()=>S(!0),onBlur:()=>S(!1)},y&&Mr(Mz,{"data-testid":"sp-ui-left-addon",isDisabled:Boolean(s),isFocused:T},y),Mr(Oz,null,Mr(Sz,wz({"data-testid":"sp-ui-text-input-chakra-input",isDisabled:Boolean(s),id:a,isRequired:l,name:p,onBlur:f,onChange:e=>{if(e){var{value:t}=e.target;w(t),e.persist(),h&&h(e)}},onClick:g,onKeyDown:v,ref:M,type:_,value:E,hasIcons:O},A)),O&&Mr(Lz,null,b&&c&&Mr(kF,{"data-testid":"validation-error-icon",height:"22px",width:"22px"}),b&&u&&Mr(xz,{"data-testid":"validation-success-icon"}),m&&E&&Mr(kz,{cursor:"pointer","data-testid":"sp-ui-text-input-clear-button",fill:"currentColor",height:"10px",onClick:e=>{w(""),m(e)},width:"10px"}))),t&&Mr(Tz,{"data-testid":"sp-ui-right-addon",isDisabled:Boolean(s),isFocused:T,onClick:e=>{n?n(e):M.current&&M.current.focus()}},t)))};var Iz=["dateFormat","endDatePlaceholder","id","isDisabled","isInvalid","isValid","max","min","onBlur","onChange","placeholder","selectRange","value"],Bz=["children"];function Rz(){return Rz=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Rz.apply(null,arguments)}function Nz(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}var Fz=function(e){return Mr("svg",e,Mr("path",{clipRule:"evenodd",d:"M18 5.7h-2.5v-.5c.1-.6-.5-1.2-1.2-1.2s-1.2.6-1.2 1.2v2.2c0 .8.6 1.3 1.2 1.3.2 0 .3 0 .4-.1-.2.4-.7.8-1.1.8-.7 0-1.2-.6-1.2-1.2V5.7h-1.8v-.5c0-.6-.6-1.2-1.3-1.2C8.7 4 8 4.6 8 5.2v2.2c0 .8.6 1.3 1.2 1.3.2 0 .3 0 .4-.1-.1.5-.5.8-1 .8-.7 0-1.1-.5-1.1-1.3V5.7H5.9c-.5 0-.9.4-.9.9v11.6c0 .4.4.8.9.8h12.2c.5 0 .9-.4.9-.9V6.6c-.1-.5-.5-.9-1-.9zm-.7 11.2c0 .2-.2.4-.4.4H7c-.2 0-.4-.2-.4-.4v-5.8c0-.2.2-.4.4-.4h9.8c.2 0 .4.2.4.4v5.8h.1z",fill:"currentColor"}))};Fz.defaultProps={viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg"};var jz=function(e){return Mr("svg",e,Mr("path",{clipRule:"evenodd",d:"M4.58227 6.00066L0.292426 1.71082C-0.0982557 1.32014 -0.0972675 0.686511 0.294151 0.295092C0.688298 -0.0990549 1.31941 -0.0970983 1.70988 0.293367L6.67454 5.25803C7.06301 5.6465 7.06423 6.27517 6.67943 6.66709C6.63212 6.7607 6.56927 6.84855 6.49096 6.92686L1.71401 11.7038C1.31882 12.099 0.685569 12.0976 0.294151 11.7062C-0.0999964 11.3121 -0.0961914 10.6791 0.296554 10.2864L4.58227 6.00066Z"}))};jz.defaultProps={fill:"none",viewBox:"0 0 7 12",xmlns:"http://www.w3.org/2000/svg"};var Yz=e=>{var{children:t}=e,n=Nz(e,Bz),{close:r,endDate:o,inline:a,max:s,onChange:l,selectRange:c,setEndDate:u,setStartDate:d,startDate:p}=(0,i.useContext)(Uz),f=xo();return Mr(i.Fragment,null,Mr($z,Rz({"data-testid":"sp-ui-date-picker",inline:a,selectRange:c},n),t,c&&Mr(KU(),{disabledKeyboardNavigation:!0,endDate:o,inline:!0,maxDate:s,minDate:p,onChange:u,renderCustomHeader:zz,renderDayContents:e=>Mr(_r,{className:"sp-ui-date-picker-day"},e),selected:o,selectsEnd:!0,startDate:p,useWeekdaysShort:!0})),c&&Mr(Hz,null,Mr(Sx,{"data-testid":"sp-ui-date-picker-reset-range-button",onClick:()=>{l([null,null]),u(null),d(null)}},f("spUi.common.datePicker.resetRange")),Mr(fp,{"data-testid":"sp-ui-date-picker-apply-range-button",marginLeft:"20px",onClick:()=>{r(),l([p,o]),u(o),d(p)}},f("spUi.common.datePicker.applyRange"))))},$z=pr(_r,{shouldForwardProp:e=>!["arrowProps","inline","selectRange","showPopperArrow"].includes(String(e)),target:"e1mdo3hi6"})((e=>{var{className:t,inline:n,selectRange:r,theme:o}=e,{DatePicker:i}=o.components,{borderColor:a,dayColor:s,dayDisabledColor:l,dayHeaderColor:c,rangeBackgroundColor:u,rangeColor:d,selectedColor:p}=i.baseStyle;return"\n        border-color: "+a+";\n        border-radius: 3px;\n        display: flex;\n        font-family: "+o.fonts.body+";\n        justify-content: space-between;\n        padding: 20px 24px;\n        user-select: none;\n        width: "+(r?"600px":"300px")+";\n\n        "+(n?"\n                    border-bottom: none;\n                    border-right: none;\n                    border-left: none;\n                    width: 100%;\n                ":"")+"\n\n        "+(r?"\n                    border-bottom-left-radius: 0;\n                    border-bottom-right-radius: 0;\n\n                    > div {\n                        width: calc(50% - 13px);\n\n                        ."+t+"__month-container {\n                            width: 100%;\n                        }\n                    }\n                ":"")+"\n\n        ."+t+" {\n            border: none;\n            width: 100%;\n\n            &__day {\n                border-radius: 0;\n                margin: 0 0 4px;\n\n                .sp-ui-date-picker-day {\n                    border-radius: 16px;\n                    color: "+s+";\n                }\n\n                &:hover {\n                    background: none;\n\n                    .sp-ui-date-picker-day {\n                        border: 1px solid "+p+";\n                        border-radius: 16px;\n                        line-height: 30px;\n                    }\n                }\n\n                &--disabled {\n                    cursor: default;\n\n                    .sp-ui-date-picker-day {\n                        color: "+l+";\n                    }\n\n                    &:hover {\n                        .sp-ui-date-picker-day {\n                            border: none;\n                            line-height: 30px;\n                        }\n                    }\n                }\n\n                &--keyboard-selected {\n                    background: none;\n\n                    .sp-ui-date-picker-day {\n                        background: none;\n                        border: 1px solid "+p+";\n                    }\n                }\n\n                &--selected {\n                    background: none;\n\n                    .sp-ui-date-picker-day {\n                        background: "+p+";\n\n                        &:hover {\n                            background: "+p+";\n                        }\n                    }\n                }\n\n                &--in-range, &--in-selecting-range, &--range-end, &--range-start {\n                    background: "+u+";\n\n                    &:hover {\n                        background: "+u+";\n                    }\n\n                    .sp-ui-date-picker-day {\n                        color: "+d+";\n                    }\n                }\n\n                &--selected {\n                    .sp-ui-date-picker-day {\n                        color: #FFFFFF;\n\n                        &:hover {\n                            color: #FFFFFF;\n                        }\n                    }\n                }\n\n                &--outside-month {\n                    visibility: hidden;\n                }\n\n                &--in-range {\n                    border-radius: 0;\n                }\n\n                &--range-end {\n                    border-bottom-right-radius: 18px;\n                    border-top-right-radius: 18px;\n                }\n\n                &--range-start {\n                    border-bottom-left-radius: 18px;\n                    border-top-left-radius: 18px;\n                }\n\n                &--in-selecting-range {\n                    border-radius: 0;\n                }\n\n                &--selecting-range-end {\n                    border-bottom-right-radius: 18px;\n                    border-top-right-radius: 18px;\n\n                    &."+t+"__day--in-range:not(."+t+"__day--range-end) {\n                        border-radius: 0;\n                    }\n                }\n\n                &--selecting-range-start {\n                    border-bottom-left-radius: 18px;\n                    border-top-left-radius: 18px;\n\n                    &."+t+"__day--in-range:not(."+t+"__day--range-start) {\n                        border-radius: 0;\n                    }\n                }\n\n                &--today {\n                    font-weight: initial;\n                }\n            }\n\n            &__day, &__day-name {\n                flex-grow: 1;\n                flex-shrink: 0;\n                outline: none;\n                height: 36px;\n                width: 36px;\n\n                .sp-ui-date-picker-day {\n                    height: 32px;\n                    line-height: 32px;\n                    margin: 2px auto;\n                    width: 32px;\n                }\n\n                &--keyboard-selected {\n                    .sp-ui-date-picker-day {\n                        line-height: 30px;\n                    }\n                }\n            }\n\n            &__day-name {\n                color: "+c+";\n                font-size: 10px;\n                height: 32px;\n                line-height: 32px;\n                margin: 2px auto;\n                width: 32px;\n            }\n\n            &__day-names, &__week {\n                display: flex;\n                justify-content: space-between;\n            }\n\n            &__header {\n                background: white;\n                border-bottom: none;\n                padding-top: 0;\n            }\n\n            &__month {\n                margin: 0;\n            }\n\n            &__month-container {\n                width: "+(r?"calc(50% - 13px)":"100%")+";\n            }\n\n            &__triangle {\n                display: none;\n            }\n        }\n    "}),""),Hz=pr(wr,{target:"e1mdo3hi5"})((e=>{var{theme:t}=e,{DatePicker:n}=t.components,{borderColor:r}=n.baseStyle;return"\n        align-items: center;\n        background: "+t.colors.gray[100]+";\n        border: 1px solid "+r+";\n        border-top: none;\n        border-bottom-left-radius: 3px;\n        border-bottom-right-radius: 3px;\n        justify-content: flex-end;\n        padding: 16px 24px;\n    "}),""),Uz=(0,i.createContext)({close:()=>{},dateFormat:"L",endDate:null,endDatePlaceholder:"",inline:void 0,isInvalid:void 0,isValid:void 0,max:void 0,min:void 0,open:()=>{},onChange:()=>{},selectRange:void 0,setEndDate:()=>{},setStartDate:()=>{},startDate:null,value:void 0}),zz=e=>Mr(Wz,e),Wz=e=>{var{changeMonth:t,changeYear:n,date:r,decreaseMonth:o,increaseMonth:a}=e,[s,l]=(0,i.useState)(!1),c=s?"hidden":"visible",{selectRange:u}=(0,i.useContext)(Uz);return Mr(wr,{alignItems:"center","data-testid":"sp-ui-date-picker-header",justifyContent:"space-between",padding:"0 8px 12px"},Mr(Xz,{"data-testid":"sp-ui-date-picker-previous-month",onClick:o,visibility:c}),Mr(wr,{alignItems:"center"},Mr(wx,null,r.toLocaleDateString("en-US",{month:"long"})," ",r.getFullYear()),!u&&Mr(Zz,{date:r,onChange:e=>{t(e.getMonth()),n(e.getFullYear())},onDatePicker:e=>l(e)})),Mr(Jz,{"data-testid":"sp-ui-date-picker-next-month",onClick:a,visibility:c}))},Vz=(0,i.forwardRef)((function(e,t){var n=Mr(Fz,{height:"24px",width:"24px"}),{dateFormat:r,endDate:o,endDatePlaceholder:a,isInvalid:s,isValid:l,max:c,open:u,selectRange:d,setEndDate:p,startDate:f}=(0,i.useContext)(Uz),[h,m]=(0,i.useState)(""),g=Boolean(Date.parse(h)),v=()=>{if(g){var e=new Date(h);QU()(e).isBefore(f)?p(f):c&&QU()(e).isAfter(c)?p(c):p(e)}else p(null)};return(0,i.useEffect)((()=>{m(o?QU()(o).format(r):"")}),[r,o]),Mr(Gz,{"data-testid":"sp-ui-date-picker-input",ref:t,selectRange:d},Mr(Pz,Rz({append:d?void 0:n,isValid:l,isInvalid:s},e)),d&&Mr(Pz,{append:n,isValid:l,isInvalid:s,onBlur:v,onChange:e=>{var{target:t}=e,{value:n}=t;m(n)},onClick:u,onFocus:u,onKeyDown:e=>{var{which:t}=e;13===t&&v()},placeholder:a,value:h}))})),Gz=pr(wr,{shouldForwardProp:e=>"selectRange"!==e,target:"e1mdo3hi4"})((e=>{var{selectRange:t}=e;return t?"\n                [role='group'] {\n                    &:first-of-type > div {\n                        border-top-right-radius: 0;\n                        border-bottom-right-radius: 0;\n                    }\n\n                    &:last-of-type > div {\n                        border-top-left-radius: 0;\n                        border-bottom-left-radius: 0;\n                    }\n                }\n            ":""}),""),Qz=e=>Mr(qz,Rz({"data-testid":"sp-ui-date-picker-month-year-calendar"},e)),qz=pr(_r,{shouldForwardProp:e=>!["arrowProps","showPopperArrow"].includes(String(e)),target:"e1mdo3hi3"})((e=>{var{className:t,theme:n}=e,{DatePicker:r}=n.components,{monthColor:o,monthDisabledColor:i,selectedColor:a}=r.baseStyle;return"\n        border: none;\n        font-family: "+n.fonts.body+";\n        left: 0;\n        margin-top: 36px;\n        padding: 0;\n        position: absolute;\n        top: 0;\n        width: 100%;\n\n        ."+t+" {\n            &__month-wrapper {\n                display: flex;\n                justify-content: space-between;\n                margin-bottom: 16px;\n            }\n\n            &__month {\n                &-text {\n                    border: 1px solid "+o+";\n                    border-radius: 3px;\n                    color: "+o+";\n                    font-size: 14px;\n                    line-height: 24px;\n                    margin: 0;\n                    outline: none;\n                    padding: 7px 12px;\n                    width: 100px;\n\n                    &:hover {\n                        background: transparent;\n                        border-color: "+a+";\n                        color: "+a+";\n                    }\n\n                    &:nth-of-type(2) {\n                        margin-left: 16px;\n                        margin-right: 16px;\n                    }\n\n                    &--keyboard-selected {\n                        background: transparent;\n\n                        &:hover {\n                            background: transparent;\n                            border-color: "+a+";\n                            color: "+a+";\n                        }\n                    }\n                }\n\n                &--disabled {\n                    border-color: "+i+";\n                    color: "+i+";\n                    cursor: default;\n                }\n\n                &--selected {\n                    background: "+a+";\n                    border-color: "+a+";\n                    color: "+n.colors.white+";\n\n                    &:hover {\n                        background: "+a+";\n                        color: "+n.colors.white+";\n                    }\n                }\n            }\n        }\n    "}),""),Kz=e=>{var{date:t,decreaseYear:n,increaseYear:r}=e;return Mr(wr,{alignItems:"center","data-testid":"sp-ui-date-picker-month-year-header",justifyContent:"space-between",padding:"0 8px 12px"},Mr(Xz,{"data-testid":"sp-ui-date-picker-previous-year",onClick:n}),Mr(wx,null,t.getFullYear()),Mr(Jz,{"data-testid":"sp-ui-date-picker-next-year",onClick:r}))},Zz=e=>{var{date:t,onChange:n,onDatePicker:r}=e,{max:o,min:a}=(0,i.useContext)(Uz),[s,l]=(0,i.useState)(!1);return Mr(i.Fragment,null,Mr(_r,{"data-testid":"sp-ui-date-picker-month-year-picker-toggle",display:"inline-block",cursor:"pointer",marginLeft:"4px",onClick:()=>{r(!s),l(!s)},padding:"8px"},Mr(eW,{transform:"rotate("+(s?"270":"90")+")"})),s&&Mr(KU(),{calendarContainer:Qz,disabledKeyboardNavigation:!0,inline:!0,maxDate:o?QU()(o).endOf("month").toDate():null,minDate:a?QU()(a).startOf("month").toDate():null,onChange:e=>{var t=e||new Date;n(t),r(!1),l(!1)},renderCustomHeader:Kz,selected:t,showMonthYearPicker:!0}))},Jz=pr(jz,{target:"e1mdo3hi2"})((e=>{var{theme:t}=e;return"\n        cursor: pointer;\n        fill: "+t.components.DatePicker.baseStyle.navigationButtonColor+";\n        height: 12px;\n        width: 7px;\n    "}),""),Xz=pr(Jz,{target:"e1mdo3hi1"})({name:"21xn5r",styles:"transform:rotate(180deg)"}),eW=pr(Jz,{target:"e1mdo3hi0"})({name:"12h47gu",styles:"height:8px;width:5px"});const tW=e=>{var{dateFormat:t="L",endDatePlaceholder:n,id:r,isDisabled:o,isInvalid:a,isValid:s,max:l,min:c,onBlur:u=(()=>{}),onChange:d=(()=>{}),placeholder:p,selectRange:f,value:h}=e,m=Nz(e,Iz),g=(0,i.useRef)(),[v,y]=(0,i.useState)(f&&h?h[1]:null),{inline:b}=m,[_,A]=(0,i.useState)(f&&h?h[0]:h||null);return(0,i.useEffect)((()=>{y(f&&h?h[1]:null),A(f&&h?h[0]:h||null)}),[f,h]),Mr(Uz.Provider,{value:{close:()=>{g&&g.current&&g.current.setOpen(!1)},dateFormat:t,endDate:v,endDatePlaceholder:n,inline:b,isInvalid:a,isValid:s,max:l,min:c,open:()=>{g&&g.current&&g.current.setOpen(!0)},onChange:d,selectRange:f,setEndDate:y,setStartDate:A,startDate:_,value:h}},Mr(KU(),Rz({calendarContainer:Yz,customInput:Mr(Vz,null),disabled:o,endDate:v,fixedHeight:!0,id:r,maxDate:f?v:l,minDate:c,onBlur:u,onChange:e=>{A(e),f||d(e)},onClickOutside:()=>{f&&(d([_,v]),A(_),y(v))},placeholderText:p,popperPlacement:"bottom-start",ref:g,renderCustomHeader:zz,renderDayContents:e=>Mr(_r,{className:"sp-ui-date-picker-day"},e),selected:_,selectsStart:f,shouldCloseOnSelect:!f,startDate:_,useWeekdaysShort:!0},m)))};var nW=["h","minH","height","minHeight"],rW=yr(((e,t)=>{const n=Fr("Textarea",e),{className:r,rows:o,...i}=pt(e),a=Gx(i),s=o?function(e,t=[]){const n=Object.assign({},e);for(const e of t)e in n&&delete n[e];return n}(n,nW):n;return(0,br.jsx)(vr.textarea,{ref:t,rows:o,...a,className:g("chakra-textarea",r),__css:s})}));rW.displayName="Textarea";var oW=o(69795),iW={};iW.styleTagTransform=lz(),iW.setAttributes=oz(),iW.insert=nz().bind(null,"head"),iW.domAPI=ez(),iW.insertStyleElement=az();JU()(oW.A,iW);oW.A&&oW.A.locals&&oW.A.locals;var aW=o(38025),sW=o.n(aW);function*lW(e){for(var t=0;;)yield e+"-"+t,t++}var cW=["children","id","isRequired","maxLength","name","onBlur","onChange","placeholder","showCharacterCount","value"];function uW(){return uW=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},uW.apply(null,arguments)}var dW="sp-ui-rich-text-area",pW=pr(wr,{target:"e1cyuyu61"})({name:"1y8686m",styles:"flex-direction:column;b{font-weight:500;}i{text-style:italic;font-weight:unset;}u{text-decoration:underline;font-weight:unset;}strike{text-decoration:line-through;font-weight:unset;}"}),fW=pr(wr,{target:"e1cyuyu60"})((e=>{var{theme:t}=e;return"\n        font-size: "+t.fontSizes.sm+";\n        color: "+t.colors.gray[500]+"\n    "}),""),hW=lW(dW);const mW=e=>{var{children:t,id:n,isRequired:r,maxLength:o=100,name:a,onBlur:s,onChange:l,placeholder:c,showCharacterCount:u,value:d}=e,p=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,cW),[f,h]=(0,i.useState)(0),m=(0,i.useCallback)((e=>{if(l){var t="";e.params.html&&(t=e.params.html),l(t)}}),[l]),[g,v]=(0,i.useState)(null),[y,b]=(0,i.useState)(o-f);if(!n){var{value:_=dW}=hW.next();n=_}return(0,i.useLayoutEffect)((()=>{var e=sW()("#"+n,{buttons:{addbar:["paragraph","line"],context:["line"]},editor:{focus:!1},plugins:["alignment"],shortcutsRemove:["ctrl+h, meta+h","ctrl+l, meta+l"],source:!1,subscribe:{"editor.blur":s,"editor.change":m},tab:{spaces:4}});v(e)}),[m,s]),(0,i.useEffect)((()=>{if(g&&(g.editor&&g.editor.getContent()!==d&&g.editor.setContent({html:d}),u)){var e=d&&g.content?g.content.getTextFromHtml(d):"";h(e.length),b(o-e.length)}}),[g,u,d]),Mr(pW,{"data-testid":"sp-ui-richtextarea"},Mr(rW,uW({"data-testid":"sp-ui-richtextarea-content",id:n,isRequired:r,maxLength:o,name:a,onChange:RF,placeholder:c,resize:"none",value:d},p),t),u&&Mr(fW,{"data-testid":"sp-ui-richtextarea-character-count"},y))};function gW(e){const{viewBox:t="0 0 24 24",d:n,displayName:r,defaultProps:o={}}=e,a=i.Children.toArray(e.path),s=yr(((e,r)=>(0,br.jsx)(Jk,{ref:r,viewBox:t,...o,...e,children:a.length?a:(0,br.jsx)("path",{fill:"currentColor",d:n})})));return s.displayName=r,s}var vW=gW({displayName:"ChevronDownIcon",d:"M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"}),yW=gW({displayName:"SmallAddIcon",viewBox:"0 0 20 20",path:(0,br.jsx)("path",{fill:"currentColor",d:"M14 9h-3V6c0-.55-.45-1-1-1s-1 .45-1 1v3H6c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1z",fillRule:"evenodd"})});function bW(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function _W(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?bW(Object(n),!0).forEach((function(t){kC(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):bW(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var AW=o(58018);const EW=i.useLayoutEffect;var wW=["className","clearValue","cx","getStyles","getClassNames","getValue","hasValue","isMulti","isRtl","options","selectOption","selectProps","setValue","theme"],xW=function(){};function kW(e,t){return t?"-"===t[0]?e+t:e+"__"+t:e}function CW(e,t){for(var n=arguments.length,r=new Array(n>2?n-2:0),o=2;o<n;o++)r[o-2]=arguments[o];var i=[].concat(r);if(t&&e)for(var a in t)t.hasOwnProperty(a)&&t[a]&&i.push("".concat(kW(e,a)));return i.filter((function(e){return e})).map((function(e){return String(e).trim()})).join(" ")}var SW=function(e){return t=e,Array.isArray(t)?e.filter(Boolean):"object"===wC(e)&&null!==e?[e]:[];var t},MW=function(e){return e.className,e.clearValue,e.cx,e.getStyles,e.getClassNames,e.getValue,e.hasValue,e.isMulti,e.isRtl,e.options,e.selectOption,e.selectProps,e.setValue,e.theme,_W({},t(e,wW))},TW=function(e,t,n){var r=e.cx,o=e.getStyles,i=e.getClassNames,a=e.className;return{css:o(t,e),className:r(null!=n?n:{},i(t,e),a)}};function OW(e){return[document.documentElement,document.body,window].indexOf(e)>-1}function DW(e){return OW(e)?window.pageYOffset:e.scrollTop}function LW(e,t){OW(e)?window.scrollTo(0,t):e.scrollTop=t}function PW(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:200,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:xW,o=DW(e),i=t-o,a=0;!function t(){var s=function(e,t,n,r){return n*((e=e/r-1)*e*e+1)+t}(a+=10,o,i,n);LW(e,s),a<n?window.requestAnimationFrame(t):r(e)}()}function IW(e,t){var n=e.getBoundingClientRect(),r=t.getBoundingClientRect(),o=t.offsetHeight/3;r.bottom+o>n.bottom?LW(e,Math.min(t.offsetTop+t.clientHeight-e.offsetHeight+o,e.scrollHeight)):r.top-o<n.top&&LW(e,Math.max(t.offsetTop-o,0))}function BW(){try{return document.createEvent("TouchEvent"),!0}catch(e){return!1}}var RW=!1,NW={get passive(){return RW=!0}},FW="undefined"!=typeof window?window:{};FW.addEventListener&&FW.removeEventListener&&(FW.addEventListener("p",xW,NW),FW.removeEventListener("p",xW,!1));var jW=RW;function YW(e){return null!=e}function $W(e,t,n){return e?t:n}var HW=["children","innerProps"],UW=["children","innerProps"];function zW(e){var t=e.maxHeight,n=e.menuEl,r=e.minHeight,o=e.placement,i=e.shouldScroll,a=e.isFixedPosition,s=e.controlHeight,l=function(e){var t=getComputedStyle(e),n="absolute"===t.position,r=/(auto|scroll)/;if("fixed"===t.position)return document.documentElement;for(var o=e;o=o.parentElement;)if(t=getComputedStyle(o),(!n||"static"!==t.position)&&r.test(t.overflow+t.overflowY+t.overflowX))return o;return document.documentElement}(n),c={placement:"bottom",maxHeight:t};if(!n||!n.offsetParent)return c;var u,d=l.getBoundingClientRect().height,p=n.getBoundingClientRect(),f=p.bottom,h=p.height,m=p.top,g=n.offsetParent.getBoundingClientRect().top,v=a?window.innerHeight:OW(u=l)?window.innerHeight:u.clientHeight,y=DW(l),b=parseInt(getComputedStyle(n).marginBottom,10),_=parseInt(getComputedStyle(n).marginTop,10),A=g-_,E=v-m,w=A+y,x=d-y-m,k=f-v+y+b,C=y+m-_,S=160;switch(o){case"auto":case"bottom":if(E>=h)return{placement:"bottom",maxHeight:t};if(x>=h&&!a)return i&&PW(l,k,S),{placement:"bottom",maxHeight:t};if(!a&&x>=r||a&&E>=r)return i&&PW(l,k,S),{placement:"bottom",maxHeight:a?E-b:x-b};if("auto"===o||a){var M=t,T=a?A:w;return T>=r&&(M=Math.min(T-b-s,t)),{placement:"top",maxHeight:M}}if("bottom"===o)return i&&LW(l,k),{placement:"bottom",maxHeight:t};break;case"top":if(A>=h)return{placement:"top",maxHeight:t};if(w>=h&&!a)return i&&PW(l,C,S),{placement:"top",maxHeight:t};if(!a&&w>=r||a&&A>=r){var O=t;return(!a&&w>=r||a&&A>=r)&&(O=a?A-_:w-_),i&&PW(l,C,S),{placement:"top",maxHeight:O}}return{placement:"bottom",maxHeight:t};default:throw new Error('Invalid placement provided "'.concat(o,'".'))}return c}var WW,VW=function(e){return"auto"===e?"bottom":e},GW=(0,i.createContext)(null),QW=function(e){var t=e.children,n=e.minMenuHeight,r=e.maxMenuHeight,o=e.menuPlacement,a=e.menuPosition,s=e.menuShouldScrollIntoView,l=e.theme,c=((0,i.useContext)(GW)||{}).setPortalPlacement,u=(0,i.useRef)(null),d=m((0,i.useState)(r),2),p=d[0],f=d[1],h=m((0,i.useState)(null),2),g=h[0],v=h[1],y=l.spacing.controlHeight;return EW((function(){var e=u.current;if(e){var t="fixed"===a,i=zW({maxHeight:r,menuEl:e,minHeight:n,placement:o,shouldScroll:s&&!t,isFixedPosition:t,controlHeight:y});f(i.maxHeight),v(i.placement),null==c||c(i.placement)}}),[r,o,a,s,n,c,y]),t({ref:u,placerProps:_W(_W({},e),{},{placement:g||VW(o),maxHeight:p})})},qW=function(e){var t=e.children,r=e.innerRef,o=e.innerProps;return Mr("div",n({},TW(e,"menu",{menu:!0}),{ref:r},o),t)},KW=function(e,t){var n=e.theme,r=n.spacing.baseUnit,o=n.colors;return _W({textAlign:"center"},t?{}:{color:o.neutral40,padding:"".concat(2*r,"px ").concat(3*r,"px")})},ZW=KW,JW=KW,XW=["size"],eV=["innerProps","isRtl","size"];var tV={name:"8mmkcg",styles:"display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"},nV=function(e){var r=e.size,o=t(e,XW);return Mr("svg",n({height:r,width:r,viewBox:"0 0 20 20","aria-hidden":"true",focusable:"false",css:tV},o))},rV=function(e){return Mr(nV,n({size:20},e),Mr("path",{d:"M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"}))},oV=function(e){return Mr(nV,n({size:20},e),Mr("path",{d:"M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"}))},iV=function(e,t){var n=e.isFocused,r=e.theme,o=r.spacing.baseUnit,i=r.colors;return _W({label:"indicatorContainer",display:"flex",transition:"color 150ms"},t?{}:{color:n?i.neutral60:i.neutral20,padding:2*o,":hover":{color:n?i.neutral80:i.neutral40}})},aV=iV,sV=iV,lV=Dr(WW||(WW=function(e,t){return t||(t=e.slice(0)),Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))}(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"]))),cV=function(e){var t=e.delay,n=e.offset;return Mr("span",{css:Or({animation:"".concat(lV," 1s ease-in-out ").concat(t,"ms infinite;"),backgroundColor:"currentColor",borderRadius:"1em",display:"inline-block",marginLeft:n?"1em":void 0,height:"1em",verticalAlign:"top",width:"1em"},"","")})},uV=function(e){var t=e.children,r=e.isDisabled,o=e.isFocused,i=e.innerRef,a=e.innerProps,s=e.menuIsOpen;return Mr("div",n({ref:i},TW(e,"control",{control:!0,"control--is-disabled":r,"control--is-focused":o,"control--menu-is-open":s}),a,{"aria-disabled":r||void 0}),t)},dV=["data"],pV=function(e){var t=e.children,r=e.cx,o=e.getStyles,i=e.getClassNames,a=e.Heading,s=e.headingProps,l=e.innerProps,c=e.label,u=e.theme,d=e.selectProps;return Mr("div",n({},TW(e,"group",{group:!0}),l),Mr(a,n({},s,{selectProps:d,theme:u,getStyles:o,getClassNames:i,cx:r}),c),Mr("div",null,t))},fV=["innerRef","isDisabled","isHidden","inputClassName"],hV={gridArea:"1 / 2",font:"inherit",minWidth:"2px",border:0,margin:0,outline:0,padding:0},mV={flex:"1 1 auto",display:"inline-grid",gridArea:"1 / 1 / 2 / 3",gridTemplateColumns:"0 min-content","&:after":_W({content:'attr(data-value) " "',visibility:"hidden",whiteSpace:"pre"},hV)},gV=function(e){return _W({label:"input",color:"inherit",background:0,opacity:e?0:1,width:"100%"},hV)},vV=function(e){var r=e.cx,o=e.value,i=MW(e),a=i.innerRef,s=i.isDisabled,l=i.isHidden,c=i.inputClassName,u=t(i,fV);return Mr("div",n({},TW(e,"input",{"input-container":!0}),{"data-value":o||""}),Mr("input",n({className:r({input:!0},c),ref:a,style:gV(l),disabled:s},u)))},yV=function(e){var t=e.children,n=e.innerProps;return Mr("div",n,t)};var bV=function(e){var t=e.children,n=e.components,r=e.data,o=e.innerProps,i=e.isDisabled,a=e.removeProps,s=e.selectProps,l=n.Container,c=n.Label,u=n.Remove;return Mr(l,{data:r,innerProps:_W(_W({},TW(e,"multiValue",{"multi-value":!0,"multi-value--is-disabled":i})),o),selectProps:s},Mr(c,{data:r,innerProps:_W({},TW(e,"multiValueLabel",{"multi-value__label":!0})),selectProps:s},t),Mr(u,{data:r,innerProps:_W(_W({},TW(e,"multiValueRemove",{"multi-value__remove":!0})),{},{"aria-label":"Remove ".concat(t||"option")},a),selectProps:s}))},_V=function(e){var t=e.children,r=e.isDisabled,o=e.isFocused,i=e.isSelected,a=e.innerRef,s=e.innerProps;return Mr("div",n({},TW(e,"option",{option:!0,"option--is-disabled":r,"option--is-focused":o,"option--is-selected":i}),{ref:a,"aria-disabled":r},s),t)},AV=function(e){var t=e.children,r=e.isDisabled,o=e.innerProps;return Mr("div",n({},TW(e,"singleValue",{"single-value":!0,"single-value--is-disabled":r}),o),t)},EV={ClearIndicator:function(e){var t=e.children,r=e.innerProps;return Mr("div",n({},TW(e,"clearIndicator",{indicator:!0,"clear-indicator":!0}),r),t||Mr(rV,null))},Control:uV,DropdownIndicator:function(e){var t=e.children,r=e.innerProps;return Mr("div",n({},TW(e,"dropdownIndicator",{indicator:!0,"dropdown-indicator":!0}),r),t||Mr(oV,null))},DownChevron:oV,CrossIcon:rV,Group:pV,GroupHeading:function(e){var r=MW(e);r.data;var o=t(r,dV);return Mr("div",n({},TW(e,"groupHeading",{"group-heading":!0}),o))},IndicatorsContainer:function(e){var t=e.children,r=e.innerProps;return Mr("div",n({},TW(e,"indicatorsContainer",{indicators:!0}),r),t)},IndicatorSeparator:function(e){var t=e.innerProps;return Mr("span",n({},t,TW(e,"indicatorSeparator",{"indicator-separator":!0})))},Input:vV,LoadingIndicator:function(e){var r=e.innerProps,o=e.isRtl,i=e.size,a=void 0===i?4:i,s=t(e,eV);return Mr("div",n({},TW(_W(_W({},s),{},{innerProps:r,isRtl:o,size:a}),"loadingIndicator",{indicator:!0,"loading-indicator":!0}),r),Mr(cV,{delay:0,offset:o}),Mr(cV,{delay:160,offset:!0}),Mr(cV,{delay:320,offset:!o}))},Menu:qW,MenuList:function(e){var t=e.children,r=e.innerProps,o=e.innerRef,i=e.isMulti;return Mr("div",n({},TW(e,"menuList",{"menu-list":!0,"menu-list--is-multi":i}),{ref:o},r),t)},MenuPortal:function(e){var t=e.appendTo,r=e.children,o=e.controlElement,a=e.innerProps,s=e.menuPlacement,l=e.menuPosition,c=(0,i.useRef)(null),u=(0,i.useRef)(null),d=m((0,i.useState)(VW(s)),2),p=d[0],f=d[1],h=(0,i.useMemo)((function(){return{setPortalPlacement:f}}),[]),g=m((0,i.useState)(null),2),v=g[0],y=g[1],b=(0,i.useCallback)((function(){if(o){var e=function(e){var t=e.getBoundingClientRect();return{bottom:t.bottom,height:t.height,left:t.left,right:t.right,top:t.top,width:t.width}}(o),t="fixed"===l?0:window.pageYOffset,n=e[p]+t;n===(null==v?void 0:v.offset)&&e.left===(null==v?void 0:v.rect.left)&&e.width===(null==v?void 0:v.rect.width)||y({offset:n,rect:e})}}),[o,l,p,null==v?void 0:v.offset,null==v?void 0:v.rect.left,null==v?void 0:v.rect.width]);EW((function(){b()}),[b]);var _=(0,i.useCallback)((function(){"function"==typeof u.current&&(u.current(),u.current=null),o&&c.current&&(u.current=(0,AW.ll)(o,c.current,b,{elementResize:"ResizeObserver"in window}))}),[o,b]);EW((function(){_()}),[_]);var A=(0,i.useCallback)((function(e){c.current=e,_()}),[_]);if(!t&&"fixed"!==l||!v)return null;var E=Mr("div",n({ref:A},TW(_W(_W({},e),{},{offset:v.offset,position:l,rect:v.rect}),"menuPortal",{"menu-portal":!0}),a),r);return Mr(GW.Provider,{value:h},t?(0,Zr.createPortal)(E,t):E)},LoadingMessage:function(e){var r=e.children,o=void 0===r?"Loading...":r,i=e.innerProps,a=t(e,UW);return Mr("div",n({},TW(_W(_W({},a),{},{children:o,innerProps:i}),"loadingMessage",{"menu-notice":!0,"menu-notice--loading":!0}),i),o)},NoOptionsMessage:function(e){var r=e.children,o=void 0===r?"No options":r,i=e.innerProps,a=t(e,HW);return Mr("div",n({},TW(_W(_W({},a),{},{children:o,innerProps:i}),"noOptionsMessage",{"menu-notice":!0,"menu-notice--no-options":!0}),i),o)},MultiValue:bV,MultiValueContainer:yV,MultiValueLabel:yV,MultiValueRemove:function(e){var t=e.children,r=e.innerProps;return Mr("div",n({role:"button"},r),t||Mr(rV,{size:14}))},Option:_V,Placeholder:function(e){var t=e.children,r=e.innerProps;return Mr("div",n({},TW(e,"placeholder",{placeholder:!0}),r),t)},SelectContainer:function(e){var t=e.children,r=e.innerProps,o=e.isDisabled,i=e.isRtl;return Mr("div",n({},TW(e,"container",{"--is-disabled":o,"--is-rtl":i}),r),t)},SingleValue:AV,ValueContainer:function(e){var t=e.children,r=e.innerProps,o=e.isMulti,i=e.hasValue;return Mr("div",n({},TW(e,"valueContainer",{"value-container":!0,"value-container--is-multi":o,"value-container--has-value":i}),r),t)}},wV=["defaultInputValue","defaultMenuIsOpen","defaultValue","inputValue","menuIsOpen","onChange","onInputChange","onMenuClose","onMenuOpen","value"];function xV(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,xC(r.key),r)}}function kV(e){return kV=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},kV(e)}function CV(){try{var e=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(e){}return(CV=function(){return!!e})()}function SV(e,t){if(t&&("object"==wC(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e)}function MV(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}function TV(e){return function(e){if(Array.isArray(e))return p(e)}(e)||MV(e)||f(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}var OV=Number.isNaN||function(e){return"number"==typeof e&&e!=e};function DV(e,t){if(e.length!==t.length)return!1;for(var n=0;n<e.length;n++)if(r=e[n],o=t[n],!(r===o||OV(r)&&OV(o)))return!1;var r,o;return!0}for(var LV={name:"7pg0cj-a11yText",styles:"label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"},PV=function(e){return Mr("span",n({css:LV},e))},IV={guidance:function(e){var t=e.isSearchable,n=e.isMulti,r=e.tabSelectsValue,o=e.context,i=e.isInitialFocus;switch(o){case"menu":return"Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(r?", press Tab to select the option and exit the menu":"",".");case"input":return i?"".concat(e["aria-label"]||"Select"," is focused ").concat(t?",type to refine list":"",", press Down to open the menu, ").concat(n?" press left to focus selected values":""):"";case"value":return"Use left and right to toggle between focused values, press Backspace to remove the currently focused value";default:return""}},onChange:function(e){var t=e.action,n=e.label,r=void 0===n?"":n,o=e.labels,i=e.isDisabled;switch(t){case"deselect-option":case"pop-value":case"remove-value":return"option ".concat(r,", deselected.");case"clear":return"All selected options have been cleared.";case"initial-input-focus":return"option".concat(o.length>1?"s":""," ").concat(o.join(","),", selected.");case"select-option":return"option ".concat(r,i?" is disabled. Select another option.":", selected.");default:return""}},onFocus:function(e){var t=e.context,n=e.focused,r=e.options,o=e.label,i=void 0===o?"":o,a=e.selectValue,s=e.isDisabled,l=e.isSelected,c=e.isAppleDevice,u=function(e,t){return e&&e.length?"".concat(e.indexOf(t)+1," of ").concat(e.length):""};if("value"===t&&a)return"value ".concat(i," focused, ").concat(u(a,n),".");if("menu"===t&&c){var d=s?" disabled":"",p="".concat(l?" selected":"").concat(d);return"".concat(i).concat(p,", ").concat(u(r,n),".")}return""},onFilter:function(e){var t=e.inputValue,n=e.resultsMessage;return"".concat(n).concat(t?" for search term "+t:"",".")}},BV=function(e){var t=e.ariaSelection,n=e.focusedOption,r=e.focusedValue,o=e.focusableOptions,a=e.isFocused,s=e.selectValue,l=e.selectProps,c=e.id,u=e.isAppleDevice,d=l.ariaLiveMessages,p=l.getOptionLabel,f=l.inputValue,h=l.isMulti,m=l.isOptionDisabled,g=l.isSearchable,v=l.menuIsOpen,y=l.options,b=l.screenReaderStatus,_=l.tabSelectsValue,A=l.isLoading,E=l["aria-label"],w=l["aria-live"],x=(0,i.useMemo)((function(){return _W(_W({},IV),d||{})}),[d]),k=(0,i.useMemo)((function(){var e,n="";if(t&&x.onChange){var r=t.option,o=t.options,i=t.removedValue,a=t.removedValues,l=t.value,c=i||r||(e=l,Array.isArray(e)?null:e),u=c?p(c):"",d=o||a||void 0,f=d?d.map(p):[],h=_W({isDisabled:c&&m(c,s),label:u,labels:f},t);n=x.onChange(h)}return n}),[t,x,m,s,p]),C=(0,i.useMemo)((function(){var e="",t=n||r,i=!!(n&&s&&s.includes(n));if(t&&x.onFocus){var a={focused:t,label:p(t),isDisabled:m(t,s),isSelected:i,options:o,context:t===n?"menu":"value",selectValue:s,isAppleDevice:u};e=x.onFocus(a)}return e}),[n,r,p,m,x,o,s,u]),S=(0,i.useMemo)((function(){var e="";if(v&&y.length&&!A&&x.onFilter){var t=b({count:o.length});e=x.onFilter({inputValue:f,resultsMessage:t})}return e}),[o,f,v,x,y,b,A]),M="initial-input-focus"===(null==t?void 0:t.action),T=(0,i.useMemo)((function(){var e="";if(x.guidance){var t=r?"value":v?"menu":"input";e=x.guidance({"aria-label":E,context:t,isDisabled:n&&m(n,s),isMulti:h,isSearchable:g,tabSelectsValue:_,isInitialFocus:M})}return e}),[E,n,r,h,m,g,v,x,s,_,M]),O=Mr(i.Fragment,null,Mr("span",{id:"aria-selection"},k),Mr("span",{id:"aria-focused"},C),Mr("span",{id:"aria-results"},S),Mr("span",{id:"aria-guidance"},T));return Mr(i.Fragment,null,Mr(PV,{id:c},M&&O),Mr(PV,{"aria-live":w,"aria-atomic":"false","aria-relevant":"additions text",role:"log"},a&&!M&&O))},RV=[{base:"A",letters:"AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"},{base:"AA",letters:"Ꜳ"},{base:"AE",letters:"ÆǼǢ"},{base:"AO",letters:"Ꜵ"},{base:"AU",letters:"Ꜷ"},{base:"AV",letters:"ꜸꜺ"},{base:"AY",letters:"Ꜽ"},{base:"B",letters:"BⒷＢḂḄḆɃƂƁ"},{base:"C",letters:"CⒸＣĆĈĊČÇḈƇȻꜾ"},{base:"D",letters:"DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"},{base:"DZ",letters:"ǱǄ"},{base:"Dz",letters:"ǲǅ"},{base:"E",letters:"EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"},{base:"F",letters:"FⒻＦḞƑꝻ"},{base:"G",letters:"GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"},{base:"H",letters:"HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"},{base:"I",letters:"IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"},{base:"J",letters:"JⒿＪĴɈ"},{base:"K",letters:"KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"},{base:"L",letters:"LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"},{base:"LJ",letters:"Ǉ"},{base:"Lj",letters:"ǈ"},{base:"M",letters:"MⓂＭḾṀṂⱮƜ"},{base:"N",letters:"NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"},{base:"NJ",letters:"Ǌ"},{base:"Nj",letters:"ǋ"},{base:"O",letters:"OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"},{base:"OI",letters:"Ƣ"},{base:"OO",letters:"Ꝏ"},{base:"OU",letters:"Ȣ"},{base:"P",letters:"PⓅＰṔṖƤⱣꝐꝒꝔ"},{base:"Q",letters:"QⓆＱꝖꝘɊ"},{base:"R",letters:"RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"},{base:"S",letters:"SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"},{base:"T",letters:"TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"},{base:"TZ",letters:"Ꜩ"},{base:"U",letters:"UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"},{base:"V",letters:"VⓋＶṼṾƲꝞɅ"},{base:"VY",letters:"Ꝡ"},{base:"W",letters:"WⓌＷẀẂŴẆẄẈⱲ"},{base:"X",letters:"XⓍＸẊẌ"},{base:"Y",letters:"YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"},{base:"Z",letters:"ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"},{base:"a",letters:"aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"},{base:"aa",letters:"ꜳ"},{base:"ae",letters:"æǽǣ"},{base:"ao",letters:"ꜵ"},{base:"au",letters:"ꜷ"},{base:"av",letters:"ꜹꜻ"},{base:"ay",letters:"ꜽ"},{base:"b",letters:"bⓑｂḃḅḇƀƃɓ"},{base:"c",letters:"cⓒｃćĉċčçḉƈȼꜿↄ"},{base:"d",letters:"dⓓｄḋďḍḑḓḏđƌɖɗꝺ"},{base:"dz",letters:"ǳǆ"},{base:"e",letters:"eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"},{base:"f",letters:"fⓕｆḟƒꝼ"},{base:"g",letters:"gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"},{base:"h",letters:"hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"},{base:"hv",letters:"ƕ"},{base:"i",letters:"iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"},{base:"j",letters:"jⓙｊĵǰɉ"},{base:"k",letters:"kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"},{base:"l",letters:"lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"},{base:"lj",letters:"ǉ"},{base:"m",letters:"mⓜｍḿṁṃɱɯ"},{base:"n",letters:"nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"},{base:"nj",letters:"ǌ"},{base:"o",letters:"oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"},{base:"oi",letters:"ƣ"},{base:"ou",letters:"ȣ"},{base:"oo",letters:"ꝏ"},{base:"p",letters:"pⓟｐṕṗƥᵽꝑꝓꝕ"},{base:"q",letters:"qⓠｑɋꝗꝙ"},{base:"r",letters:"rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"},{base:"s",letters:"sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"},{base:"t",letters:"tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"},{base:"tz",letters:"ꜩ"},{base:"u",letters:"uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"},{base:"v",letters:"vⓥｖṽṿʋꝟʌ"},{base:"vy",letters:"ꝡ"},{base:"w",letters:"wⓦｗẁẃŵẇẅẘẉⱳ"},{base:"x",letters:"xⓧｘẋẍ"},{base:"y",letters:"yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"},{base:"z",letters:"zⓩｚźẑżžẓẕƶȥɀⱬꝣ"}],NV=new RegExp("["+RV.map((function(e){return e.letters})).join("")+"]","g"),FV={},jV=0;jV<RV.length;jV++)for(var YV=RV[jV],$V=0;$V<YV.letters.length;$V++)FV[YV.letters[$V]]=YV.base;var HV=function(e){return e.replace(NV,(function(e){return FV[e]}))},UV=function(e,t){void 0===t&&(t=DV);var n=null;function r(){for(var r=[],o=0;o<arguments.length;o++)r[o]=arguments[o];if(n&&n.lastThis===this&&t(r,n.lastArgs))return n.lastResult;var i=e.apply(this,r);return n={lastResult:i,lastArgs:r,lastThis:this},i}return r.clear=function(){n=null},r}(HV),zV=function(e){return e.replace(/^\s+|\s+$/g,"")},WV=function(e){return"".concat(e.label," ").concat(e.value)},VV=["innerRef"];function GV(e){var r=e.innerRef,o=function(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Object.entries(e).filter((function(e){var t=m(e,1)[0];return!n.includes(t)}));return o.reduce((function(e,t){var n=m(t,2),r=n[0],o=n[1];return e[r]=o,e}),{})}(t(e,VV),"onExited","in","enter","exit","appear");return Mr("input",n({ref:r},o,{css:Or({label:"dummyInput",background:0,border:0,caretColor:"transparent",fontSize:"inherit",gridArea:"1 / 1 / 2 / 3",outline:0,padding:0,width:1,color:"transparent",left:-100,opacity:0,position:"relative",transform:"scale(.01)"},"","")}))}var QV=function(e){e.cancelable&&e.preventDefault(),e.stopPropagation()};var qV=["boxSizing","height","overflow","paddingRight","position"],KV={boxSizing:"border-box",overflow:"hidden",position:"relative",height:"100%"};function ZV(e){e.preventDefault()}function JV(e){e.stopPropagation()}function XV(){var e=this.scrollTop,t=this.scrollHeight,n=e+this.offsetHeight;0===e?this.scrollTop=1:n===t&&(this.scrollTop=e-1)}function eG(){return"ontouchstart"in window||navigator.maxTouchPoints}var tG=!("undefined"==typeof window||!window.document||!window.document.createElement),nG=0,rG={capture:!1,passive:!1};var oG=function(e){var t=e.target;return t.ownerDocument.activeElement&&t.ownerDocument.activeElement.blur()},iG={name:"1kfdb0e",styles:"position:fixed;left:0;bottom:0;right:0;top:0"};function aG(e){var t=e.children,n=e.lockEnabled,r=e.captureEnabled,o=function(e){var t=e.isEnabled,n=e.onBottomArrive,r=e.onBottomLeave,o=e.onTopArrive,a=e.onTopLeave,s=(0,i.useRef)(!1),l=(0,i.useRef)(!1),c=(0,i.useRef)(0),u=(0,i.useRef)(null),d=(0,i.useCallback)((function(e,t){if(null!==u.current){var i=u.current,c=i.scrollTop,d=i.scrollHeight,p=i.clientHeight,f=u.current,h=t>0,m=d-p-c,g=!1;m>t&&s.current&&(r&&r(e),s.current=!1),h&&l.current&&(a&&a(e),l.current=!1),h&&t>m?(n&&!s.current&&n(e),f.scrollTop=d,g=!0,s.current=!0):!h&&-t>c&&(o&&!l.current&&o(e),f.scrollTop=0,g=!0,l.current=!0),g&&QV(e)}}),[n,r,o,a]),p=(0,i.useCallback)((function(e){d(e,e.deltaY)}),[d]),f=(0,i.useCallback)((function(e){c.current=e.changedTouches[0].clientY}),[]),h=(0,i.useCallback)((function(e){var t=c.current-e.changedTouches[0].clientY;d(e,t)}),[d]),m=(0,i.useCallback)((function(e){if(e){var t=!!jW&&{passive:!1};e.addEventListener("wheel",p,t),e.addEventListener("touchstart",f,t),e.addEventListener("touchmove",h,t)}}),[h,f,p]),g=(0,i.useCallback)((function(e){e&&(e.removeEventListener("wheel",p,!1),e.removeEventListener("touchstart",f,!1),e.removeEventListener("touchmove",h,!1))}),[h,f,p]);return(0,i.useEffect)((function(){if(t){var e=u.current;return m(e),function(){g(e)}}}),[t,m,g]),function(e){u.current=e}}({isEnabled:void 0===r||r,onBottomArrive:e.onBottomArrive,onBottomLeave:e.onBottomLeave,onTopArrive:e.onTopArrive,onTopLeave:e.onTopLeave}),a=function(e){var t=e.isEnabled,n=e.accountForScrollbars,r=void 0===n||n,o=(0,i.useRef)({}),a=(0,i.useRef)(null),s=(0,i.useCallback)((function(e){if(tG){var t=document.body,n=t&&t.style;if(r&&qV.forEach((function(e){var t=n&&n[e];o.current[e]=t})),r&&nG<1){var i=parseInt(o.current.paddingRight,10)||0,a=document.body?document.body.clientWidth:0,s=window.innerWidth-a+i||0;Object.keys(KV).forEach((function(e){var t=KV[e];n&&(n[e]=t)})),n&&(n.paddingRight="".concat(s,"px"))}t&&eG()&&(t.addEventListener("touchmove",ZV,rG),e&&(e.addEventListener("touchstart",XV,rG),e.addEventListener("touchmove",JV,rG))),nG+=1}}),[r]),l=(0,i.useCallback)((function(e){if(tG){var t=document.body,n=t&&t.style;nG=Math.max(nG-1,0),r&&nG<1&&qV.forEach((function(e){var t=o.current[e];n&&(n[e]=t)})),t&&eG()&&(t.removeEventListener("touchmove",ZV,rG),e&&(e.removeEventListener("touchstart",XV,rG),e.removeEventListener("touchmove",JV,rG)))}}),[r]);return(0,i.useEffect)((function(){if(t){var e=a.current;return s(e),function(){l(e)}}}),[t,s,l]),function(e){a.current=e}}({isEnabled:n});return Mr(i.Fragment,null,n&&Mr("div",{onClick:oG,css:iG}),t((function(e){o(e),a(e)})))}var sG={name:"1a0ro4n-requiredInput",styles:"label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"},lG=function(e){var t=e.name,n=e.onFocus;return Mr("input",{required:!0,name:t,tabIndex:-1,"aria-hidden":"true",onFocus:n,css:sG,value:"",onChange:function(){}})};function cG(e){var t;return"undefined"!=typeof window&&null!=window.navigator&&e.test((null===(t=window.navigator.userAgentData)||void 0===t?void 0:t.platform)||window.navigator.platform)}function uG(){return cG(/^Mac/i)}function dG(){return cG(/^iPhone/i)||cG(/^iPad/i)||uG()&&navigator.maxTouchPoints>1}var pG={clearIndicator:sV,container:function(e){var t=e.isDisabled;return{label:"container",direction:e.isRtl?"rtl":void 0,pointerEvents:t?"none":void 0,position:"relative"}},control:function(e,t){var n=e.isDisabled,r=e.isFocused,o=e.theme,i=o.colors,a=o.borderRadius;return _W({label:"control",alignItems:"center",cursor:"default",display:"flex",flexWrap:"wrap",justifyContent:"space-between",minHeight:o.spacing.controlHeight,outline:"0 !important",position:"relative",transition:"all 100ms"},t?{}:{backgroundColor:n?i.neutral5:i.neutral0,borderColor:n?i.neutral10:r?i.primary:i.neutral20,borderRadius:a,borderStyle:"solid",borderWidth:1,boxShadow:r?"0 0 0 1px ".concat(i.primary):void 0,"&:hover":{borderColor:r?i.primary:i.neutral30}})},dropdownIndicator:aV,group:function(e,t){var n=e.theme.spacing;return t?{}:{paddingBottom:2*n.baseUnit,paddingTop:2*n.baseUnit}},groupHeading:function(e,t){var n=e.theme,r=n.colors,o=n.spacing;return _W({label:"group",cursor:"default",display:"block"},t?{}:{color:r.neutral40,fontSize:"75%",fontWeight:500,marginBottom:"0.25em",paddingLeft:3*o.baseUnit,paddingRight:3*o.baseUnit,textTransform:"uppercase"})},indicatorsContainer:function(){return{alignItems:"center",alignSelf:"stretch",display:"flex",flexShrink:0}},indicatorSeparator:function(e,t){var n=e.isDisabled,r=e.theme,o=r.spacing.baseUnit,i=r.colors;return _W({label:"indicatorSeparator",alignSelf:"stretch",width:1},t?{}:{backgroundColor:n?i.neutral10:i.neutral20,marginBottom:2*o,marginTop:2*o})},input:function(e,t){var n=e.isDisabled,r=e.value,o=e.theme,i=o.spacing,a=o.colors;return _W(_W({visibility:n?"hidden":"visible",transform:r?"translateZ(0)":""},mV),t?{}:{margin:i.baseUnit/2,paddingBottom:i.baseUnit/2,paddingTop:i.baseUnit/2,color:a.neutral80})},loadingIndicator:function(e,t){var n=e.isFocused,r=e.size,o=e.theme,i=o.colors,a=o.spacing.baseUnit;return _W({label:"loadingIndicator",display:"flex",transition:"color 150ms",alignSelf:"center",fontSize:r,lineHeight:1,marginRight:r,textAlign:"center",verticalAlign:"middle"},t?{}:{color:n?i.neutral60:i.neutral20,padding:2*a})},loadingMessage:JW,menu:function(e,t){var n,r=e.placement,o=e.theme,i=o.borderRadius,a=o.spacing,s=o.colors;return _W((kC(n={label:"menu"},function(e){return e?{bottom:"top",top:"bottom"}[e]:"bottom"}(r),"100%"),kC(n,"position","absolute"),kC(n,"width","100%"),kC(n,"zIndex",1),n),t?{}:{backgroundColor:s.neutral0,borderRadius:i,boxShadow:"0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",marginBottom:a.menuGutter,marginTop:a.menuGutter})},menuList:function(e,t){var n=e.maxHeight,r=e.theme.spacing.baseUnit;return _W({maxHeight:n,overflowY:"auto",position:"relative",WebkitOverflowScrolling:"touch"},t?{}:{paddingBottom:r,paddingTop:r})},menuPortal:function(e){var t=e.rect,n=e.offset,r=e.position;return{left:t.left,position:r,top:n,width:t.width,zIndex:1}},multiValue:function(e,t){var n=e.theme,r=n.spacing,o=n.borderRadius,i=n.colors;return _W({label:"multiValue",display:"flex",minWidth:0},t?{}:{backgroundColor:i.neutral10,borderRadius:o/2,margin:r.baseUnit/2})},multiValueLabel:function(e,t){var n=e.theme,r=n.borderRadius,o=n.colors,i=e.cropWithEllipsis;return _W({overflow:"hidden",textOverflow:i||void 0===i?"ellipsis":void 0,whiteSpace:"nowrap"},t?{}:{borderRadius:r/2,color:o.neutral80,fontSize:"85%",padding:3,paddingLeft:6})},multiValueRemove:function(e,t){var n=e.theme,r=n.spacing,o=n.borderRadius,i=n.colors,a=e.isFocused;return _W({alignItems:"center",display:"flex"},t?{}:{borderRadius:o/2,backgroundColor:a?i.dangerLight:void 0,paddingLeft:r.baseUnit,paddingRight:r.baseUnit,":hover":{backgroundColor:i.dangerLight,color:i.danger}})},noOptionsMessage:ZW,option:function(e,t){var n=e.isDisabled,r=e.isFocused,o=e.isSelected,i=e.theme,a=i.spacing,s=i.colors;return _W({label:"option",cursor:"default",display:"block",fontSize:"inherit",width:"100%",userSelect:"none",WebkitTapHighlightColor:"rgba(0, 0, 0, 0)"},t?{}:{backgroundColor:o?s.primary:r?s.primary25:"transparent",color:n?s.neutral20:o?s.neutral0:"inherit",padding:"".concat(2*a.baseUnit,"px ").concat(3*a.baseUnit,"px"),":active":{backgroundColor:n?void 0:o?s.primary:s.primary50}})},placeholder:function(e,t){var n=e.theme,r=n.spacing,o=n.colors;return _W({label:"placeholder",gridArea:"1 / 1 / 2 / 3"},t?{}:{color:o.neutral50,marginLeft:r.baseUnit/2,marginRight:r.baseUnit/2})},singleValue:function(e,t){var n=e.isDisabled,r=e.theme,o=r.spacing,i=r.colors;return _W({label:"singleValue",gridArea:"1 / 1 / 2 / 3",maxWidth:"100%",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"},t?{}:{color:n?i.neutral40:i.neutral80,marginLeft:o.baseUnit/2,marginRight:o.baseUnit/2})},valueContainer:function(e,t){var n=e.theme.spacing,r=e.isMulti,o=e.hasValue,i=e.selectProps.controlShouldRenderValue;return _W({alignItems:"center",display:r&&o&&i?"flex":"grid",flex:1,flexWrap:"wrap",WebkitOverflowScrolling:"touch",position:"relative",overflow:"hidden"},t?{}:{padding:"".concat(n.baseUnit/2,"px ").concat(2*n.baseUnit,"px")})}};var fG={borderRadius:4,colors:{primary:"#2684FF",primary75:"#4C9AFF",primary50:"#B2D4FF",primary25:"#DEEBFF",danger:"#DE350B",dangerLight:"#FFBDAD",neutral0:"hsl(0, 0%, 100%)",neutral5:"hsl(0, 0%, 95%)",neutral10:"hsl(0, 0%, 90%)",neutral20:"hsl(0, 0%, 80%)",neutral30:"hsl(0, 0%, 70%)",neutral40:"hsl(0, 0%, 60%)",neutral50:"hsl(0, 0%, 50%)",neutral60:"hsl(0, 0%, 40%)",neutral70:"hsl(0, 0%, 30%)",neutral80:"hsl(0, 0%, 20%)",neutral90:"hsl(0, 0%, 10%)"},spacing:{baseUnit:4,controlHeight:38,menuGutter:8}},hG={"aria-live":"polite",backspaceRemovesValue:!0,blurInputOnSelect:BW(),captureMenuScroll:!BW(),classNames:{},closeMenuOnSelect:!0,closeMenuOnScroll:!1,components:{},controlShouldRenderValue:!0,escapeClearsValue:!1,filterOption:function(e){return function(t,n){if(t.data.__isNew__)return!0;var r=_W({ignoreCase:!0,ignoreAccents:!0,stringify:WV,trim:!0,matchFrom:"any"},e),o=r.ignoreCase,i=r.ignoreAccents,a=r.stringify,s=r.trim,l=r.matchFrom,c=s?zV(n):n,u=s?zV(a(t)):a(t);return o&&(c=c.toLowerCase(),u=u.toLowerCase()),i&&(c=UV(c),u=HV(u)),"start"===l?u.substr(0,c.length)===c:u.indexOf(c)>-1}}(),formatGroupLabel:function(e){return e.label},getOptionLabel:function(e){return e.label},getOptionValue:function(e){return e.value},isDisabled:!1,isLoading:!1,isMulti:!1,isRtl:!1,isSearchable:!0,isOptionDisabled:function(e){return!!e.isDisabled},loadingMessage:function(){return"Loading..."},maxMenuHeight:300,minMenuHeight:140,menuIsOpen:!1,menuPlacement:"bottom",menuPosition:"absolute",menuShouldBlockScroll:!1,menuShouldScrollIntoView:!function(){try{return/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)}catch(e){return!1}}(),noOptionsMessage:function(){return"No options"},openMenuOnFocus:!1,openMenuOnClick:!0,options:[],pageSize:5,placeholder:"Select...",screenReaderStatus:function(e){var t=e.count;return"".concat(t," result").concat(1!==t?"s":""," available")},styles:{},tabIndex:0,tabSelectsValue:!0,unstyled:!1};function mG(e,t,n,r){return{type:"option",data:t,isDisabled:wG(e,t,n),isSelected:xG(e,t,n),label:AG(e,t),value:EG(e,t),index:r}}function gG(e,t){return e.options.map((function(n,r){if("options"in n){var o=n.options.map((function(n,r){return mG(e,n,t,r)})).filter((function(t){return bG(e,t)}));return o.length>0?{type:"group",data:n,options:o,index:r}:void 0}var i=mG(e,n,t,r);return bG(e,i)?i:void 0})).filter(YW)}function vG(e){return e.reduce((function(e,t){return"group"===t.type?e.push.apply(e,TV(t.options.map((function(e){return e.data})))):e.push(t.data),e}),[])}function yG(e,t){return e.reduce((function(e,n){return"group"===n.type?e.push.apply(e,TV(n.options.map((function(e){return{data:e.data,id:"".concat(t,"-").concat(n.index,"-").concat(e.index)}})))):e.push({data:n.data,id:"".concat(t,"-").concat(n.index)}),e}),[])}function bG(e,t){var n=e.inputValue,r=void 0===n?"":n,o=t.data,i=t.isSelected,a=t.label,s=t.value;return(!CG(e)||!i)&&kG(e,{label:a,value:s,data:o},r)}var _G=function(e,t){var n;return(null===(n=e.find((function(e){return e.data===t})))||void 0===n?void 0:n.id)||null},AG=function(e,t){return e.getOptionLabel(t)},EG=function(e,t){return e.getOptionValue(t)};function wG(e,t,n){return"function"==typeof e.isOptionDisabled&&e.isOptionDisabled(t,n)}function xG(e,t,n){if(n.indexOf(t)>-1)return!0;if("function"==typeof e.isOptionSelected)return e.isOptionSelected(t,n);var r=EG(e,t);return n.some((function(t){return EG(e,t)===r}))}function kG(e,t,n){return!e.filterOption||e.filterOption(t,n)}var CG=function(e){var t=e.hideSelectedOptions,n=e.isMulti;return void 0===t?n:t},SG=1,MG=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&ZB(e,t)}(r,e);var t=function(e){var t=CV();return function(){var n,r=kV(e);if(t){var o=kV(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return SV(this,n)}}(r);function r(e){var n;if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,r),(n=t.call(this,e)).state={ariaSelection:null,focusedOption:null,focusedOptionId:null,focusableOptionsWithIds:[],focusedValue:null,inputIsHidden:!1,isFocused:!1,selectValue:[],clearFocusValueOnUpdate:!1,prevWasFocused:!1,inputIsHiddenAfterUpdate:void 0,prevProps:void 0,instancePrefix:""},n.blockOptionHover=!1,n.isComposing=!1,n.commonProps=void 0,n.initialTouchX=0,n.initialTouchY=0,n.openAfterFocus=!1,n.scrollToFocusedOptionOnUpdate=!1,n.userIsDragging=void 0,n.isAppleDevice=uG()||dG(),n.controlRef=null,n.getControlRef=function(e){n.controlRef=e},n.focusedOptionRef=null,n.getFocusedOptionRef=function(e){n.focusedOptionRef=e},n.menuListRef=null,n.getMenuListRef=function(e){n.menuListRef=e},n.inputRef=null,n.getInputRef=function(e){n.inputRef=e},n.focus=n.focusInput,n.blur=n.blurInput,n.onChange=function(e,t){var r=n.props,o=r.onChange,i=r.name;t.name=i,n.ariaOnChange(e,t),o(e,t)},n.setValue=function(e,t,r){var o=n.props,i=o.closeMenuOnSelect,a=o.isMulti,s=o.inputValue;n.onInputChange("",{action:"set-value",prevInputValue:s}),i&&(n.setState({inputIsHiddenAfterUpdate:!a}),n.onMenuClose()),n.setState({clearFocusValueOnUpdate:!0}),n.onChange(e,{action:t,option:r})},n.selectOption=function(e){var t=n.props,r=t.blurInputOnSelect,o=t.isMulti,i=t.name,a=n.state.selectValue,s=o&&n.isOptionSelected(e,a),l=n.isOptionDisabled(e,a);if(s){var c=n.getOptionValue(e);n.setValue(a.filter((function(e){return n.getOptionValue(e)!==c})),"deselect-option",e)}else{if(l)return void n.ariaOnChange(e,{action:"select-option",option:e,name:i});o?n.setValue([].concat(TV(a),[e]),"select-option",e):n.setValue(e,"select-option")}r&&n.blurInput()},n.removeValue=function(e){var t=n.props.isMulti,r=n.state.selectValue,o=n.getOptionValue(e),i=r.filter((function(e){return n.getOptionValue(e)!==o})),a=$W(t,i,i[0]||null);n.onChange(a,{action:"remove-value",removedValue:e}),n.focusInput()},n.clearValue=function(){var e=n.state.selectValue;n.onChange($W(n.props.isMulti,[],null),{action:"clear",removedValues:e})},n.popValue=function(){var e=n.props.isMulti,t=n.state.selectValue,r=t[t.length-1],o=t.slice(0,t.length-1),i=$W(e,o,o[0]||null);n.onChange(i,{action:"pop-value",removedValue:r})},n.getFocusedOptionId=function(e){return _G(n.state.focusableOptionsWithIds,e)},n.getFocusableOptionsWithIds=function(){return yG(gG(n.props,n.state.selectValue),n.getElementId("option"))},n.getValue=function(){return n.state.selectValue},n.cx=function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return CW.apply(void 0,[n.props.classNamePrefix].concat(t))},n.getOptionLabel=function(e){return AG(n.props,e)},n.getOptionValue=function(e){return EG(n.props,e)},n.getStyles=function(e,t){var r=n.props.unstyled,o=pG[e](t,r);o.boxSizing="border-box";var i=n.props.styles[e];return i?i(o,t):o},n.getClassNames=function(e,t){var r,o;return null===(r=(o=n.props.classNames)[e])||void 0===r?void 0:r.call(o,t)},n.getElementId=function(e){return"".concat(n.state.instancePrefix,"-").concat(e)},n.getComponents=function(){return e=n.props,_W(_W({},EV),e.components);var e},n.buildCategorizedOptions=function(){return gG(n.props,n.state.selectValue)},n.getCategorizedOptions=function(){return n.props.menuIsOpen?n.buildCategorizedOptions():[]},n.buildFocusableOptions=function(){return vG(n.buildCategorizedOptions())},n.getFocusableOptions=function(){return n.props.menuIsOpen?n.buildFocusableOptions():[]},n.ariaOnChange=function(e,t){n.setState({ariaSelection:_W({value:e},t)})},n.onMenuMouseDown=function(e){0===e.button&&(e.stopPropagation(),e.preventDefault(),n.focusInput())},n.onMenuMouseMove=function(e){n.blockOptionHover=!1},n.onControlMouseDown=function(e){if(!e.defaultPrevented){var t=n.props.openMenuOnClick;n.state.isFocused?n.props.menuIsOpen?"INPUT"!==e.target.tagName&&"TEXTAREA"!==e.target.tagName&&n.onMenuClose():t&&n.openMenu("first"):(t&&(n.openAfterFocus=!0),n.focusInput()),"INPUT"!==e.target.tagName&&"TEXTAREA"!==e.target.tagName&&e.preventDefault()}},n.onDropdownIndicatorMouseDown=function(e){if(!(e&&"mousedown"===e.type&&0!==e.button||n.props.isDisabled)){var t=n.props,r=t.isMulti,o=t.menuIsOpen;n.focusInput(),o?(n.setState({inputIsHiddenAfterUpdate:!r}),n.onMenuClose()):n.openMenu("first"),e.preventDefault()}},n.onClearIndicatorMouseDown=function(e){e&&"mousedown"===e.type&&0!==e.button||(n.clearValue(),e.preventDefault(),n.openAfterFocus=!1,"touchend"===e.type?n.focusInput():setTimeout((function(){return n.focusInput()})))},n.onScroll=function(e){"boolean"==typeof n.props.closeMenuOnScroll?e.target instanceof HTMLElement&&OW(e.target)&&n.props.onMenuClose():"function"==typeof n.props.closeMenuOnScroll&&n.props.closeMenuOnScroll(e)&&n.props.onMenuClose()},n.onCompositionStart=function(){n.isComposing=!0},n.onCompositionEnd=function(){n.isComposing=!1},n.onTouchStart=function(e){var t=e.touches,r=t&&t.item(0);r&&(n.initialTouchX=r.clientX,n.initialTouchY=r.clientY,n.userIsDragging=!1)},n.onTouchMove=function(e){var t=e.touches,r=t&&t.item(0);if(r){var o=Math.abs(r.clientX-n.initialTouchX),i=Math.abs(r.clientY-n.initialTouchY);n.userIsDragging=o>5||i>5}},n.onTouchEnd=function(e){n.userIsDragging||(n.controlRef&&!n.controlRef.contains(e.target)&&n.menuListRef&&!n.menuListRef.contains(e.target)&&n.blurInput(),n.initialTouchX=0,n.initialTouchY=0)},n.onControlTouchEnd=function(e){n.userIsDragging||n.onControlMouseDown(e)},n.onClearIndicatorTouchEnd=function(e){n.userIsDragging||n.onClearIndicatorMouseDown(e)},n.onDropdownIndicatorTouchEnd=function(e){n.userIsDragging||n.onDropdownIndicatorMouseDown(e)},n.handleInputChange=function(e){var t=n.props.inputValue,r=e.currentTarget.value;n.setState({inputIsHiddenAfterUpdate:!1}),n.onInputChange(r,{action:"input-change",prevInputValue:t}),n.props.menuIsOpen||n.onMenuOpen()},n.onInputFocus=function(e){n.props.onFocus&&n.props.onFocus(e),n.setState({inputIsHiddenAfterUpdate:!1,isFocused:!0}),(n.openAfterFocus||n.props.openMenuOnFocus)&&n.openMenu("first"),n.openAfterFocus=!1},n.onInputBlur=function(e){var t=n.props.inputValue;n.menuListRef&&n.menuListRef.contains(document.activeElement)?n.inputRef.focus():(n.props.onBlur&&n.props.onBlur(e),n.onInputChange("",{action:"input-blur",prevInputValue:t}),n.onMenuClose(),n.setState({focusedValue:null,isFocused:!1}))},n.onOptionHover=function(e){if(!n.blockOptionHover&&n.state.focusedOption!==e){var t=n.getFocusableOptions().indexOf(e);n.setState({focusedOption:e,focusedOptionId:t>-1?n.getFocusedOptionId(e):null})}},n.shouldHideSelectedOptions=function(){return CG(n.props)},n.onValueInputFocus=function(e){e.preventDefault(),e.stopPropagation(),n.focus()},n.onKeyDown=function(e){var t=n.props,r=t.isMulti,o=t.backspaceRemovesValue,i=t.escapeClearsValue,a=t.inputValue,s=t.isClearable,l=t.isDisabled,c=t.menuIsOpen,u=t.onKeyDown,d=t.tabSelectsValue,p=t.openMenuOnFocus,f=n.state,h=f.focusedOption,m=f.focusedValue,g=f.selectValue;if(!(l||"function"==typeof u&&(u(e),e.defaultPrevented))){switch(n.blockOptionHover=!0,e.key){case"ArrowLeft":if(!r||a)return;n.focusValue("previous");break;case"ArrowRight":if(!r||a)return;n.focusValue("next");break;case"Delete":case"Backspace":if(a)return;if(m)n.removeValue(m);else{if(!o)return;r?n.popValue():s&&n.clearValue()}break;case"Tab":if(n.isComposing)return;if(e.shiftKey||!c||!d||!h||p&&n.isOptionSelected(h,g))return;n.selectOption(h);break;case"Enter":if(229===e.keyCode)break;if(c){if(!h)return;if(n.isComposing)return;n.selectOption(h);break}return;case"Escape":c?(n.setState({inputIsHiddenAfterUpdate:!1}),n.onInputChange("",{action:"menu-close",prevInputValue:a}),n.onMenuClose()):s&&i&&n.clearValue();break;case" ":if(a)return;if(!c){n.openMenu("first");break}if(!h)return;n.selectOption(h);break;case"ArrowUp":c?n.focusOption("up"):n.openMenu("last");break;case"ArrowDown":c?n.focusOption("down"):n.openMenu("first");break;case"PageUp":if(!c)return;n.focusOption("pageup");break;case"PageDown":if(!c)return;n.focusOption("pagedown");break;case"Home":if(!c)return;n.focusOption("first");break;case"End":if(!c)return;n.focusOption("last");break;default:return}e.preventDefault()}},n.state.instancePrefix="react-select-"+(n.props.instanceId||++SG),n.state.selectValue=SW(e.value),e.menuIsOpen&&n.state.selectValue.length){var o=n.getFocusableOptionsWithIds(),i=n.buildFocusableOptions(),a=i.indexOf(n.state.selectValue[0]);n.state.focusableOptionsWithIds=o,n.state.focusedOption=i[a],n.state.focusedOptionId=_G(o,i[a])}return n}return function(e,t,n){t&&xV(e.prototype,t),n&&xV(e,n),Object.defineProperty(e,"prototype",{writable:!1})}(r,[{key:"componentDidMount",value:function(){this.startListeningComposition(),this.startListeningToTouch(),this.props.closeMenuOnScroll&&document&&document.addEventListener&&document.addEventListener("scroll",this.onScroll,!0),this.props.autoFocus&&this.focusInput(),this.props.menuIsOpen&&this.state.focusedOption&&this.menuListRef&&this.focusedOptionRef&&IW(this.menuListRef,this.focusedOptionRef)}},{key:"componentDidUpdate",value:function(e){var t=this.props,n=t.isDisabled,r=t.menuIsOpen,o=this.state.isFocused;(o&&!n&&e.isDisabled||o&&r&&!e.menuIsOpen)&&this.focusInput(),o&&n&&!e.isDisabled?this.setState({isFocused:!1},this.onMenuClose):o||n||!e.isDisabled||this.inputRef!==document.activeElement||this.setState({isFocused:!0}),this.menuListRef&&this.focusedOptionRef&&this.scrollToFocusedOptionOnUpdate&&(IW(this.menuListRef,this.focusedOptionRef),this.scrollToFocusedOptionOnUpdate=!1)}},{key:"componentWillUnmount",value:function(){this.stopListeningComposition(),this.stopListeningToTouch(),document.removeEventListener("scroll",this.onScroll,!0)}},{key:"onMenuOpen",value:function(){this.props.onMenuOpen()}},{key:"onMenuClose",value:function(){this.onInputChange("",{action:"menu-close",prevInputValue:this.props.inputValue}),this.props.onMenuClose()}},{key:"onInputChange",value:function(e,t){this.props.onInputChange(e,t)}},{key:"focusInput",value:function(){this.inputRef&&this.inputRef.focus()}},{key:"blurInput",value:function(){this.inputRef&&this.inputRef.blur()}},{key:"openMenu",value:function(e){var t=this,n=this.state,r=n.selectValue,o=n.isFocused,i=this.buildFocusableOptions(),a="first"===e?0:i.length-1;if(!this.props.isMulti){var s=i.indexOf(r[0]);s>-1&&(a=s)}this.scrollToFocusedOptionOnUpdate=!(o&&this.menuListRef),this.setState({inputIsHiddenAfterUpdate:!1,focusedValue:null,focusedOption:i[a],focusedOptionId:this.getFocusedOptionId(i[a])},(function(){return t.onMenuOpen()}))}},{key:"focusValue",value:function(e){var t=this.state,n=t.selectValue,r=t.focusedValue;if(this.props.isMulti){this.setState({focusedOption:null});var o=n.indexOf(r);r||(o=-1);var i=n.length-1,a=-1;if(n.length){switch(e){case"previous":a=0===o?0:-1===o?i:o-1;break;case"next":o>-1&&o<i&&(a=o+1)}this.setState({inputIsHidden:-1!==a,focusedValue:n[a]})}}}},{key:"focusOption",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"first",t=this.props.pageSize,n=this.state.focusedOption,r=this.getFocusableOptions();if(r.length){var o=0,i=r.indexOf(n);n||(i=-1),"up"===e?o=i>0?i-1:r.length-1:"down"===e?o=(i+1)%r.length:"pageup"===e?(o=i-t)<0&&(o=0):"pagedown"===e?(o=i+t)>r.length-1&&(o=r.length-1):"last"===e&&(o=r.length-1),this.scrollToFocusedOptionOnUpdate=!0,this.setState({focusedOption:r[o],focusedValue:null,focusedOptionId:this.getFocusedOptionId(r[o])})}}},{key:"getTheme",value:function(){return this.props.theme?"function"==typeof this.props.theme?this.props.theme(fG):_W(_W({},fG),this.props.theme):fG}},{key:"getCommonProps",value:function(){var e=this.clearValue,t=this.cx,n=this.getStyles,r=this.getClassNames,o=this.getValue,i=this.selectOption,a=this.setValue,s=this.props,l=s.isMulti,c=s.isRtl,u=s.options;return{clearValue:e,cx:t,getStyles:n,getClassNames:r,getValue:o,hasValue:this.hasValue(),isMulti:l,isRtl:c,options:u,selectOption:i,selectProps:s,setValue:a,theme:this.getTheme()}}},{key:"hasValue",value:function(){return this.state.selectValue.length>0}},{key:"hasOptions",value:function(){return!!this.getFocusableOptions().length}},{key:"isClearable",value:function(){var e=this.props,t=e.isClearable,n=e.isMulti;return void 0===t?n:t}},{key:"isOptionDisabled",value:function(e,t){return wG(this.props,e,t)}},{key:"isOptionSelected",value:function(e,t){return xG(this.props,e,t)}},{key:"filterOption",value:function(e,t){return kG(this.props,e,t)}},{key:"formatOptionLabel",value:function(e,t){if("function"==typeof this.props.formatOptionLabel){var n=this.props.inputValue,r=this.state.selectValue;return this.props.formatOptionLabel(e,{context:t,inputValue:n,selectValue:r})}return this.getOptionLabel(e)}},{key:"formatGroupLabel",value:function(e){return this.props.formatGroupLabel(e)}},{key:"startListeningComposition",value:function(){document&&document.addEventListener&&(document.addEventListener("compositionstart",this.onCompositionStart,!1),document.addEventListener("compositionend",this.onCompositionEnd,!1))}},{key:"stopListeningComposition",value:function(){document&&document.removeEventListener&&(document.removeEventListener("compositionstart",this.onCompositionStart),document.removeEventListener("compositionend",this.onCompositionEnd))}},{key:"startListeningToTouch",value:function(){document&&document.addEventListener&&(document.addEventListener("touchstart",this.onTouchStart,!1),document.addEventListener("touchmove",this.onTouchMove,!1),document.addEventListener("touchend",this.onTouchEnd,!1))}},{key:"stopListeningToTouch",value:function(){document&&document.removeEventListener&&(document.removeEventListener("touchstart",this.onTouchStart),document.removeEventListener("touchmove",this.onTouchMove),document.removeEventListener("touchend",this.onTouchEnd))}},{key:"renderInput",value:function(){var e=this.props,t=e.isDisabled,r=e.isSearchable,o=e.inputId,a=e.inputValue,s=e.tabIndex,l=e.form,c=e.menuIsOpen,u=e.required,d=this.getComponents().Input,p=this.state,f=p.inputIsHidden,h=p.ariaSelection,m=this.commonProps,g=o||this.getElementId("input"),v=_W(_W(_W({"aria-autocomplete":"list","aria-expanded":c,"aria-haspopup":!0,"aria-errormessage":this.props["aria-errormessage"],"aria-invalid":this.props["aria-invalid"],"aria-label":this.props["aria-label"],"aria-labelledby":this.props["aria-labelledby"],"aria-required":u,role:"combobox","aria-activedescendant":this.isAppleDevice?void 0:this.state.focusedOptionId||""},c&&{"aria-controls":this.getElementId("listbox")}),!r&&{"aria-readonly":!0}),this.hasValue()?"initial-input-focus"===(null==h?void 0:h.action)&&{"aria-describedby":this.getElementId("live-region")}:{"aria-describedby":this.getElementId("placeholder")});return r?i.createElement(d,n({},m,{autoCapitalize:"none",autoComplete:"off",autoCorrect:"off",id:g,innerRef:this.getInputRef,isDisabled:t,isHidden:f,onBlur:this.onInputBlur,onChange:this.handleInputChange,onFocus:this.onInputFocus,spellCheck:"false",tabIndex:s,form:l,type:"text",value:a},v)):i.createElement(GV,n({id:g,innerRef:this.getInputRef,onBlur:this.onInputBlur,onChange:xW,onFocus:this.onInputFocus,disabled:t,tabIndex:s,inputMode:"none",form:l,value:""},v))}},{key:"renderPlaceholderOrValue",value:function(){var e=this,t=this.getComponents(),r=t.MultiValue,o=t.MultiValueContainer,a=t.MultiValueLabel,s=t.MultiValueRemove,l=t.SingleValue,c=t.Placeholder,u=this.commonProps,d=this.props,p=d.controlShouldRenderValue,f=d.isDisabled,h=d.isMulti,m=d.inputValue,g=d.placeholder,v=this.state,y=v.selectValue,b=v.focusedValue,_=v.isFocused;if(!this.hasValue()||!p)return m?null:i.createElement(c,n({},u,{key:"placeholder",isDisabled:f,isFocused:_,innerProps:{id:this.getElementId("placeholder")}}),g);if(h)return y.map((function(t,l){var c=t===b,d="".concat(e.getOptionLabel(t),"-").concat(e.getOptionValue(t));return i.createElement(r,n({},u,{components:{Container:o,Label:a,Remove:s},isFocused:c,isDisabled:f,key:d,index:l,removeProps:{onClick:function(){return e.removeValue(t)},onTouchEnd:function(){return e.removeValue(t)},onMouseDown:function(e){e.preventDefault()}},data:t}),e.formatOptionLabel(t,"value"))}));if(m)return null;var A=y[0];return i.createElement(l,n({},u,{data:A,isDisabled:f}),this.formatOptionLabel(A,"value"))}},{key:"renderClearIndicator",value:function(){var e=this.getComponents().ClearIndicator,t=this.commonProps,r=this.props,o=r.isDisabled,a=r.isLoading,s=this.state.isFocused;if(!this.isClearable()||!e||o||!this.hasValue()||a)return null;var l={onMouseDown:this.onClearIndicatorMouseDown,onTouchEnd:this.onClearIndicatorTouchEnd,"aria-hidden":"true"};return i.createElement(e,n({},t,{innerProps:l,isFocused:s}))}},{key:"renderLoadingIndicator",value:function(){var e=this.getComponents().LoadingIndicator,t=this.commonProps,r=this.props,o=r.isDisabled,a=r.isLoading,s=this.state.isFocused;if(!e||!a)return null;return i.createElement(e,n({},t,{innerProps:{"aria-hidden":"true"},isDisabled:o,isFocused:s}))}},{key:"renderIndicatorSeparator",value:function(){var e=this.getComponents(),t=e.DropdownIndicator,r=e.IndicatorSeparator;if(!t||!r)return null;var o=this.commonProps,a=this.props.isDisabled,s=this.state.isFocused;return i.createElement(r,n({},o,{isDisabled:a,isFocused:s}))}},{key:"renderDropdownIndicator",value:function(){var e=this.getComponents().DropdownIndicator;if(!e)return null;var t=this.commonProps,r=this.props.isDisabled,o=this.state.isFocused,a={onMouseDown:this.onDropdownIndicatorMouseDown,onTouchEnd:this.onDropdownIndicatorTouchEnd,"aria-hidden":"true"};return i.createElement(e,n({},t,{innerProps:a,isDisabled:r,isFocused:o}))}},{key:"renderMenu",value:function(){var e=this,t=this.getComponents(),r=t.Group,o=t.GroupHeading,a=t.Menu,s=t.MenuList,l=t.MenuPortal,c=t.LoadingMessage,u=t.NoOptionsMessage,d=t.Option,p=this.commonProps,f=this.state.focusedOption,h=this.props,m=h.captureMenuScroll,g=h.inputValue,v=h.isLoading,y=h.loadingMessage,b=h.minMenuHeight,_=h.maxMenuHeight,A=h.menuIsOpen,E=h.menuPlacement,w=h.menuPosition,x=h.menuPortalTarget,k=h.menuShouldBlockScroll,C=h.menuShouldScrollIntoView,S=h.noOptionsMessage,M=h.onMenuScrollToTop,T=h.onMenuScrollToBottom;if(!A)return null;var O,D=function(t,r){var o=t.type,a=t.data,s=t.isDisabled,l=t.isSelected,c=t.label,u=t.value,h=f===a,m=s?void 0:function(){return e.onOptionHover(a)},g=s?void 0:function(){return e.selectOption(a)},v="".concat(e.getElementId("option"),"-").concat(r),y={id:v,onClick:g,onMouseMove:m,onMouseOver:m,tabIndex:-1,role:"option","aria-selected":e.isAppleDevice?void 0:l};return i.createElement(d,n({},p,{innerProps:y,data:a,isDisabled:s,isSelected:l,key:v,label:c,type:o,value:u,isFocused:h,innerRef:h?e.getFocusedOptionRef:void 0}),e.formatOptionLabel(t.data,"menu"))};if(this.hasOptions())O=this.getCategorizedOptions().map((function(t){if("group"===t.type){var a=t.data,s=t.options,l=t.index,c="".concat(e.getElementId("group"),"-").concat(l),u="".concat(c,"-heading");return i.createElement(r,n({},p,{key:c,data:a,options:s,Heading:o,headingProps:{id:u,data:t.data},label:e.formatGroupLabel(t.data)}),t.options.map((function(e){return D(e,"".concat(l,"-").concat(e.index))})))}if("option"===t.type)return D(t,"".concat(t.index))}));else if(v){var L=y({inputValue:g});if(null===L)return null;O=i.createElement(c,p,L)}else{var P=S({inputValue:g});if(null===P)return null;O=i.createElement(u,p,P)}var I={minMenuHeight:b,maxMenuHeight:_,menuPlacement:E,menuPosition:w,menuShouldScrollIntoView:C},B=i.createElement(QW,n({},p,I),(function(t){var r=t.ref,o=t.placerProps,l=o.placement,c=o.maxHeight;return i.createElement(a,n({},p,I,{innerRef:r,innerProps:{onMouseDown:e.onMenuMouseDown,onMouseMove:e.onMenuMouseMove},isLoading:v,placement:l}),i.createElement(aG,{captureEnabled:m,onTopArrive:M,onBottomArrive:T,lockEnabled:k},(function(t){return i.createElement(s,n({},p,{innerRef:function(n){e.getMenuListRef(n),t(n)},innerProps:{role:"listbox","aria-multiselectable":p.isMulti,id:e.getElementId("listbox")},isLoading:v,maxHeight:c,focusedOption:f}),O)})))}));return x||"fixed"===w?i.createElement(l,n({},p,{appendTo:x,controlElement:this.controlRef,menuPlacement:E,menuPosition:w}),B):B}},{key:"renderFormField",value:function(){var e=this,t=this.props,n=t.delimiter,r=t.isDisabled,o=t.isMulti,a=t.name,s=t.required,l=this.state.selectValue;if(s&&!this.hasValue()&&!r)return i.createElement(lG,{name:a,onFocus:this.onValueInputFocus});if(a&&!r){if(o){if(n){var c=l.map((function(t){return e.getOptionValue(t)})).join(n);return i.createElement("input",{name:a,type:"hidden",value:c})}var u=l.length>0?l.map((function(t,n){return i.createElement("input",{key:"i-".concat(n),name:a,type:"hidden",value:e.getOptionValue(t)})})):i.createElement("input",{name:a,type:"hidden",value:""});return i.createElement("div",null,u)}var d=l[0]?this.getOptionValue(l[0]):"";return i.createElement("input",{name:a,type:"hidden",value:d})}}},{key:"renderLiveRegion",value:function(){var e=this.commonProps,t=this.state,r=t.ariaSelection,o=t.focusedOption,a=t.focusedValue,s=t.isFocused,l=t.selectValue,c=this.getFocusableOptions();return i.createElement(BV,n({},e,{id:this.getElementId("live-region"),ariaSelection:r,focusedOption:o,focusedValue:a,isFocused:s,selectValue:l,focusableOptions:c,isAppleDevice:this.isAppleDevice}))}},{key:"render",value:function(){var e=this.getComponents(),t=e.Control,r=e.IndicatorsContainer,o=e.SelectContainer,a=e.ValueContainer,s=this.props,l=s.className,c=s.id,u=s.isDisabled,d=s.menuIsOpen,p=this.state.isFocused,f=this.commonProps=this.getCommonProps();return i.createElement(o,n({},f,{className:l,innerProps:{id:c,onKeyDown:this.onKeyDown},isDisabled:u,isFocused:p}),this.renderLiveRegion(),i.createElement(t,n({},f,{innerRef:this.getControlRef,innerProps:{onMouseDown:this.onControlMouseDown,onTouchEnd:this.onControlTouchEnd},isDisabled:u,isFocused:p,menuIsOpen:d}),i.createElement(a,n({},f,{isDisabled:u}),this.renderPlaceholderOrValue(),this.renderInput()),i.createElement(r,n({},f,{isDisabled:u}),this.renderClearIndicator(),this.renderLoadingIndicator(),this.renderIndicatorSeparator(),this.renderDropdownIndicator())),this.renderMenu(),this.renderFormField())}}],[{key:"getDerivedStateFromProps",value:function(e,t){var n=t.prevProps,r=t.clearFocusValueOnUpdate,o=t.inputIsHiddenAfterUpdate,i=t.ariaSelection,a=t.isFocused,s=t.prevWasFocused,l=t.instancePrefix,c=e.options,u=e.value,d=e.menuIsOpen,p=e.inputValue,f=e.isMulti,h=SW(u),m={};if(n&&(u!==n.value||c!==n.options||d!==n.menuIsOpen||p!==n.inputValue)){var g=d?function(e,t){return vG(gG(e,t))}(e,h):[],v=d?yG(gG(e,h),"".concat(l,"-option")):[],y=r?function(e,t){var n=e.focusedValue,r=e.selectValue.indexOf(n);if(r>-1){if(t.indexOf(n)>-1)return n;if(r<t.length)return t[r]}return null}(t,h):null,b=function(e,t){var n=e.focusedOption;return n&&t.indexOf(n)>-1?n:t[0]}(t,g);m={selectValue:h,focusedOption:b,focusedOptionId:_G(v,b),focusableOptionsWithIds:v,focusedValue:y,clearFocusValueOnUpdate:!1}}var _=null!=o&&e!==n?{inputIsHidden:o,inputIsHiddenAfterUpdate:void 0}:{},A=i,E=a&&s;return a&&!E&&(A={value:$W(f,h,h[0]||null),options:h,action:"initial-input-focus"},E=!s),"initial-input-focus"===(null==i?void 0:i.action)&&(A=null),_W(_W(_W({},m),_),{},{prevProps:e,ariaSelection:A,prevWasFocused:E})}}]),r}(i.Component);MG.defaultProps=hG;var TG=(0,i.forwardRef)((function(e,r){var o=function(e){var n=e.defaultInputValue,r=void 0===n?"":n,o=e.defaultMenuIsOpen,a=void 0!==o&&o,s=e.defaultValue,l=void 0===s?null:s,c=e.inputValue,u=e.menuIsOpen,d=e.onChange,p=e.onInputChange,f=e.onMenuClose,h=e.onMenuOpen,g=e.value,v=t(e,wV),y=m((0,i.useState)(void 0!==c?c:r),2),b=y[0],_=y[1],A=m((0,i.useState)(void 0!==u?u:a),2),E=A[0],w=A[1],x=m((0,i.useState)(void 0!==g?g:l),2),k=x[0],C=x[1],S=(0,i.useCallback)((function(e,t){"function"==typeof d&&d(e,t),C(e)}),[d]),M=(0,i.useCallback)((function(e,t){var n;"function"==typeof p&&(n=p(e,t)),_(void 0!==n?n:e)}),[p]),T=(0,i.useCallback)((function(){"function"==typeof h&&h(),w(!0)}),[h]),O=(0,i.useCallback)((function(){"function"==typeof f&&f(),w(!1)}),[f]),D=void 0!==c?c:b,L=void 0!==u?u:E,P=void 0!==g?g:k;return _W(_W({},v),{},{inputValue:D,menuIsOpen:L,onChange:S,onInputChange:M,onMenuClose:O,onMenuOpen:T,value:P})}(e);return i.createElement(MG,n({ref:r},o))})),OG=TG,DG=["children"];function LG(){return LG=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},LG.apply(null,arguments)}var PG=pr(_r,{target:"erzqsty0"})((e=>{var{theme:t}=e;return"\n        position: relative;\n        width: 100%;\n        max-width: "+t.rowMaxWidth+";\n        margin: 0 auto;\n        margin-bottom: 16px;\n    "}),""),IG=e=>{var{children:t}=e,n=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,DG);return Mr(PG,LG({"data-testid":"sp-ui-row"},n),t)};const BG=IG;var RG=["createOptionLabel","onCreateOption"],NG=["children","selectProps"],FG=["inputValueMatcher","controlStyles","createOptionLabel","isClearable","isDisabled","isInvalid","name","onBlur","onChange","onCreateOption","options","placeholder","value"];function jG(){return jG=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},jG.apply(null,arguments)}function YG(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}var $G=(e,t)=>{var{value:n}=e.find((e=>{var{label:n}=e;return n.toLowerCase()===t.toLowerCase()}))||{value:null};return n},HG=e=>Mr(EV.DropdownIndicator,e,Mr(vW,{width:"24px",height:"24px",transform:e.selectProps.menuIsOpen&&"rotate(180deg)"})),UG=pr(IG,{target:"evpg22m0"})((e=>{var{theme:t}=e,{borderColor:n}=t.components.Select.baseStyle({});return"\n        max-width: none;\n        display: flex;\n        align-items: center;\n        border-top: 1px solid "+n+";\n        cursor: pointer;\n        font-weight: bold;\n        padding: "+t.gutters.sm+";\n        color: "+t.colors.blue[400]+";\n    "}),""),zG=e=>{var{children:t,selectProps:{createOptionLabel:n="Create New",onCreateOption:r}}=e,o=YG(e.selectProps,RG),i=YG(e,NG);return Mr(EV.Menu,jG({selectProps:o},i),t,Mr(UG,{onClick:r},Mr(yW,{width:"20px",height:"20px"}),n))};const WG=e=>{var{inputValueMatcher:t=$G,controlStyles:n,createOptionLabel:r,isClearable:o,isDisabled:a,isInvalid:s,name:l="",onBlur:c,onChange:u,onCreateOption:d,options:p=[],placeholder:f,value:h}=e,m=YG(e,FG),{components:{Select:g}}=qd(),v=g.baseStyle({}),y={container:e=>jG({},e,{":focus":{outline:"0"},boxShadow:"none"}),control:e=>jG({},e,{"&:focus":{borderColor:v.borderColor},":hover":{borderColor:s?v[tp.Invalid].borderColor:v.borderColor},backgroundColor:v.backgroundColor,borderColor:s?v[tp.Invalid].borderColor:v.borderColor,borderRadius:"3px",boxShadow:"none",height:"40px"},n),dropdownIndicator:e=>jG({},e,{padding:"7px 8px"}),indicatorsContainer:e=>jG({},e,{height:"auto",padding:"0",width:"auto"}),indicatorSeparator:e=>jG({},e,{backgroundColor:"none"}),input:e=>jG({},e,{color:v.placeholderColor,input:{fontSize:"16px !important",opacity:"1 !important"}}),menu:e=>jG({},e,{borderRadius:"3px",marginTop:"4px"}),option:e=>jG({},e,{":hover":{backgroundColor:v[tp.Hover].optionBackgroundColor,color:v[tp.Hover].optionColor},backgroundColor:v.optionBackgroundColor,color:v.optionColor,fontSize:v.optionFontSize}),placeholder:(e,t)=>jG({},e,{color:t.selectProps.isDisabled?v[tp.Disabled].placeholderColor:v.placeholderColor,fontSize:v.placeholderFontSize}),singleValue:(e,t)=>jG({},e,{color:t.selectProps.isDisabled?v[tp.Disabled].valueColor:v.valueColor,fontSize:v.singleValueFontSize}),valueContainer:e=>jG({},e,{height:"100%",padding:"3px 8px"})},b=(0,i.useRef)();var _={DropdownIndicator:HG};return void 0!==d&&(_.Menu=zG),Mr(_r,{"data-testid":"sp-ui-select",className:"sp-ui-select"},Mr(OG,jG({className:"react-select",classNamePrefix:"react-select",components:_,createOptionLabel:r,isClearable:o,isDisabled:a,name:l,onBlur:c,onInputChange:function(e,n){var{action:r}=n;if(e&&t&&u&&"input-change"===r){var o=t(p,e);o&&b&&b.current&&(b.current.select.selectOption({label:l,value:o}),b.current.select.setState({isFocused:!1}))}},onChange:function(e){if(u){var t=e?e.value:null;u(l,t)}},onCreateOption:d,options:p,placeholder:f,ref:b,styles:y,value:h},m)))};var VG=["children","id","isDisabled","isInvalid","isRequired","maxLength","name","onBlur","onChange","placeholder","showCharacterCount","value"];function GG(){return GG=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},GG.apply(null,arguments)}var QG=pr(wr,{target:"exv8rvr2"})({name:"qdeacm",styles:"flex-direction:column"}),qG=pr(rW,{target:"exv8rvr1"})((e=>{var{isDisabled:t,theme:n}=e,{borderColor:r,fontStyles:o}=np(n,{isDisabled:t},"TextArea");return"\n        border-color: "+r+";\n        height: 131px;\n        "+o+"\n\n        &:active, &:focus {\n            border-color: "+n.colors.gray[400]+";\n            box-shadow: none;\n        }\n    "}),""),KG=pr(wr,{target:"exv8rvr0"})((e=>{var{theme:t}=e;return"\n        font-size: "+t.fontSizes.sm+";\n        color: "+t.colors.gray[500]+"\n    "}),"");const ZG=e=>{var{children:t,id:n,isDisabled:r,isInvalid:o,isRequired:i,maxLength:a=100,name:s,onBlur:l,onChange:c,placeholder:u,showCharacterCount:d,value:p}=e,f=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,VG),h=a-(p?p.length:0);return Mr(QG,{"data-testid":"sp-ui-textarea"},Mr(qG,GG({"data-testid":"sp-ui-textarea-content",id:n,isDisabled:r,isInvalid:o,isRequired:i,maxLength:a,name:s,onBlur:l,onChange:c,placeholder:u,resize:"none",value:p},f),t),d&&Mr(KG,{"data-testid":"sp-ui-textarea-character-count"},h))};var JG=["className","defaultValue","elementVariant","isClearable","isDisabled","isRequired","label","labelSubtext","labelTooltipLabel","name","onClear","placeholder","radioOptions","selectOptions","subtext","variant"];function XG(){return XG=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},XG.apply(null,arguments)}var eQ="sp-ui-form-element",tQ=lW(eQ);!function(e,t,n){if(!e||!OH(e.prototype))throw new TypeError("You must provide a yup schema constructor function");if("string"!=typeof t)throw new TypeError("A Method name must be provided");if("function"!=typeof n)throw new TypeError("Method function must be provided");e.prototype[t]=n}(aU,"phoneNumber",(function(e){return this.test((function(t){if(!t)return!0;var{createError:n,path:r}=this,o=dH(t,"US");return!!Boolean(o&&o.isValid())||n({path:r,message:e})}))}));var nQ=pr(wr,{target:"e1y4w0si3"})((e=>{var{theme:t}=e;return"\n        flex-direction: column;\n        justify-content: flex-start;\n        margin-bottom: "+t.components.FormElement.baseStyle.marginBottom+";\n    "}),""),rQ=function(e){return e.Checkbox="checkbox",e.DatePicker="date-picker",e.PhoneInput="phone-input",e.RadioGroup="radio-group",e.RichTextArea="rich-text-area",e.Select="select",e.TextArea="textarea",e.TextInput="text",e.ToggleSwitch="toggle-switch",e}({}),oQ=pr(wx,{shouldForwardProp:e=>"hasSubtext"!==e,target:"e1y4w0si2"})((e=>{var{hasSubtext:t}=e;return"\n        "+(t?"margin-bottom: 1px;":"")+"\n    "}),""),iQ=pr(bx,{target:"e1y4w0si1"})((e=>{var{theme:t}=e,{baseStyle:{marginBottom:n}}=t.components.Label;return"\n        margin-top: -3px;\n        margin-bottom: "+n+";\n    "}),""),aQ=pr(Xp,{target:"e1y4w0si0"})((e=>{var{theme:t}=e;return"\n        color: "+t.colors.gray[500]+";\n        font-weight: "+t.fontWeights.light+";\n        font-size: "+t.fontSizes.sm+";\n    "}),"");const sQ=e=>{var t,{className:n,defaultValue:r,elementVariant:o,isClearable:a,isDisabled:s,isRequired:l,label:c,labelSubtext:u,labelTooltipLabel:d,name:p,onClear:f,placeholder:h="",radioOptions:m=[],selectOptions:g=[],subtext:v,variant:y=rQ.TextInput}=e,b=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,JG),[_,A,E]=II({name:p,value:r}),{setFieldValue:w,submitCount:x}=mI(),{onBlur:k,onChange:C,value:S}=_,{error:M,touched:T}=A,O=Boolean(M),D=(T||x>0)&&O,L=T&&!D,P=(0,i.useMemo)((()=>g.find((e=>e.value===S))),[S,g]),{setValue:I}=E,B=a?e=>{I(""),f&&f(e)}:void 0,{translate:R}=(0,i.useContext)(Ao),{value:N=eQ}=tQ.next(),F=!1,j=!1;switch(y){case rQ.Checkbox:t=Mr(VU,XG({isChecked:Boolean(S),isDisabled:s,label:c,name:p,onChange:C,value:"true"},b)),F=!0;break;case rQ.DatePicker:t=Mr(tW,XG({id:N,isDisabled:s,isInvalid:D,isValid:L,name:p,onBlur:k,onChange:e=>{C({target:{name:p,value:e}})},placeholder:h,value:S},b));break;case rQ.PhoneInput:t=Mr(Pz,XG({defaultValue:r||S,id:N,isDisabled:s,isInvalid:D,isRequired:l,isValid:L,name:p,onBlur:e=>{var{value:t}=e.currentTarget,n=dH(t,"US"),r=n&&n.formatNational()||"";I(r),k(e)},onChange:C,onClear:B,placeholder:h,type:"tel",value:S},b));break;case rQ.RadioGroup:t=Mr(Yx,XG({name:p,onChange:C,radioOptions:m,value:S,variant:o||Bx.Default},b));break;case rQ.RichTextArea:var Y=(0,i.useCallback)((()=>{k({target:{id:N,name:p}})}),[k]),$=(0,i.useCallback)((e=>{w(p,e)}),[w]);t=Mr(mW,XG({id:N,name:p,onBlur:()=>{Y()},onChange:$,placeholder:h,value:S},b));break;case rQ.Select:t=Mr(WG,XG({inputId:N,isClearable:a,isDisabled:s,isInvalid:D,isRequired:l,name:p,onBlur:k,onChange:w,options:g,placeholder:h,value:P},b));break;case rQ.TextArea:t=Mr(ZG,XG({id:N,isDisabled:s,isInvalid:D,name:p,onBlur:k,onChange:C,placeholder:h,value:S},b));break;case rQ.TextInput:t=Mr(Pz,XG({defaultValue:r||S,id:N,isDisabled:s,isInvalid:D,isRequired:l,isValid:L,name:p,onBlur:k,onChange:C,onClear:B,placeholder:h,value:S},b));break;case rQ.ToggleSwitch:t=Mr(ak,XG({isDisabled:s,isToggled:Boolean(S),label:c,name:p,onBlur:k,onChange:C,subtext:v,value:"true"},b)),j=!0;break;default:t=null}return Mr(nQ,{className:n,"data-testid":eQ},Mr(Mp,{id:N},!F&&!j&&c&&Mr(oQ,{hasSubtext:Boolean(u),htmlFor:N,tooltipLabel:d},R(c),l&&"*"),!F&&!j&&u&&Mr(iQ,null,u),t,!j&&v&&Mr(aQ,{htmlFor:N},R(v)),D&&M&&Mr(Ax,{"data-testid":"validation-error-label",htmlFor:N},R(M))))};var lQ,cQ=fr(wr)(lQ||(lQ=zM(["\n    flex-direction: column;\n"]))),uQ=fr(UI)((function(e){return"\n        color: "+e.theme.colors.gray[600]+";\n        font-weight: normal;\n        margin-bottom: 14px;\n        margin-top: 0;\n    "})),dQ=function(e){var t=e.formError,n=m((0,i.useState)(t),2),r=n[0],o=n[1],a=mI(),s=a.isValidating,l=a.setFieldError,c=a.setSubmitting,u=m((0,i.useState)(!1),2),d=u[0],p=u[1];return(0,i.useEffect)((function(){l("code"," "),p(!0),c(!1)}),[t,l,c]),(0,i.useEffect)((function(){d&&s&&o(null)}),[s,d]),r?i.createElement(Ax,{"data-testid":"form-error"},r):null};const pQ=function(e){var t=e.mfaPhone,n=e.onClose,r=void 0===n?qT:n,o=e.onRequestCode,a=e.onDeleteAttempt,s=e.onSuccess,l=void 0===s?qT:s,c=e.shouldOpen,u=xo(),d=MU({code:aU().max(6,u("studio.account.mfa.deleteModal.codeValidation.maxLength")).min(6,u("studio.account.mfa.deleteModal.codeValidation.minLength")).required(u("studio.account.mfa.deleteModal.codeValidation.required"))}),p=nY(),f=p.close,h=p.Modal,g=p.open,v=m((0,i.useState)(null),2),y=v[0],b=v[1],_=m((0,i.useState)(!0),2),A=_[0],E=_[1],w=(0,i.useCallback)((function(e){switch(e.status){case 400:return b(u("studio.account.mfa.deleteModal.codeValidation.invalid"));case 409:b(u("studio.account.mfa.deleteModal.codeValidation.conflict")),setTimeout(l,2e3);default:return b(u("studio.account.mfa.deleteModal.codeValidation.generalError"))}}),[l,u]);return(0,i.useEffect)((function(){return c?g():(f(),E(!0))}),[f,g,c]),i.createElement(iY,{initialValues:{code:""},onSubmit:function(e){var t=e.code;return b(null),a(t).then(l).catch(w)},validateOnMount:!0,validationSchema:d},(function(e){var n=e.isSubmitting,a=e.isValid,s=e.handleSubmit,l=e.setSubmitting;return i.createElement(h,{heading:u("studio.account.mfa.deleteModal.title"),onClose:r},i.createElement(h.SecondaryButton,{onClick:r},u("studio.account.mfa.deleteModal.cancel")),A?i.createElement(i.Fragment,null,i.createElement(h.Body,null,u("studio.account.mfa.deleteModal.warning")),i.createElement(h.PrimaryButton,{onClick:function(){t&&o().catch(w),E(!1)}},u("studio.account.mfa.deleteModal.continue"))):i.createElement(i.Fragment,null,i.createElement(h.Body,null,i.createElement(uQ,{"data-testid":"subheading"},t?i.createElement(i.Fragment,null,u("studio.account.mfa.deleteModal.smsCta")+" ",i.createElement("span",{style:{whiteSpace:"nowrap"}},"(+1) xxx-xxx-"+t.toFixed().slice(-4)+".")):u("studio.account.mfa.deleteModal.appCta")),i.createElement(cQ,null,i.createElement(wr,{alignItems:"flex-start"},i.createElement(_r,{width:"156px"},i.createElement(sQ,{autoComplete:"off",label:u("studio.account.mfa.deleteModal.codeLabel"),name:"code",placeholder:u("studio.account.mfa.deleteModal.codePlaceholder"),showValidationIcons:!1}),y&&i.createElement(dQ,{formError:y}),i.createElement(_r,{margin:"5px 0 0"},i.createElement(Sx,{href:"https://help.shootproof.com/hc/en-us/requests/new",target:"_blank",rel:"noopener noreferrer"},u("studio.account.mfa.deleteModal.helpLink")))),t&&i.createElement(fp,{variant:sp.Tertiary,loadedText:u("studio.account.mfa.deleteModal.sentCode"),loadingText:u("studio.account.mfa.deleteModal.sendingCode"),margin:"28px 15px 0",onClick:function(e){return e.stopPropagation(),b(null),o().catch((function(e){return l(!1),w(e)}))}},u("studio.account.mfa.deleteModal.resendLink"))))),i.createElement(h.PrimaryButton,{destructive:!0,onClick:function(){return s()},isDisabled:!a||n},u("studio.account.mfa.deleteModal.submitButton"))))}))};var fQ=["children"];function hQ(){return hQ=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},hQ.apply(null,arguments)}var mQ=pr(qr,{target:"e144hul20"})((e=>{var{theme:t}=e;return"\n        color: "+t.fontColor.default+";\n        font-family: "+t.fonts.heading+";\n        font-size: "+t.fontSizes.xl+";\n        font-weight: "+t.fontWeights.light+";\n        line-height: "+t.lineHeights.xl+";\n        margin-bottom: "+t.space[6]+";\n    "}),"");const gQ=e=>{var{children:t}=e,n=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,fQ);return Mr(mQ,hQ({as:"h2"},n),t)};var vQ,yQ=["title","titleId"];function bQ(){return bQ=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},bQ.apply(null,arguments)}var _Q=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,yQ);return i.createElement("svg",bQ({xmlns:"http://www.w3.org/2000/svg",width:52,height:52,viewBox:"0 0 52 52",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,vQ||(vQ=i.createElement("g",{fill:"none",fillRule:"evenodd"},i.createElement("path",{fill:"#FFF",d:"M36.812 12.151a14.232 14.232 0 0 0-11.275 5.508C24.807 11.659 19.642 7 13.344 7h-.035c-.09 0-.179.011-.269.013-.29.007-.58.017-.865.043-.24.021-.473.059-.71.094-.132.02-.265.035-.396.059-.277.05-.547.114-.817.182-.078.02-.156.038-.234.06-.302.082-.6.178-.893.281-.029.01-.057.02-.086.032C4.35 9.472 1 13.898 1 19.104v5.107c0 6.684 5.511 12.104 12.31 12.104 3.725 0 7.058-1.635 9.314-4.208v13.19c1.983 0 3.631-5.593 3.99-8.421a12.352 12.352 0 0 0 10.198 5.326 12.35 12.35 0 0 0 10.199-5.326c.358 2.828 2.007 8.422 3.989 8.422V26.104c0-7.706-6.351-13.953-14.188-13.953"}),i.createElement("path",{fill:"#93D8ED",d:"M24.567 16.64C23.842 10.782 19.318 7 13.041 7 7.061 7 2.087 11.125 1 16.582a14.062 14.062 0 0 0 6.474 1.566c4.054 0 7.686-1.706 10.195-4.403 1.366 2.448 2.855 4.187 5.882 4.403 3.027.216 1.741 4.352 1.016-1.507z"}),i.createElement("path",{stroke:"#2A5969",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:2,d:"M16.957 28.424a4.415 4.415 0 0 1-3.676 1.98 4.417 4.417 0 0 1-3.77-2.127"}),i.createElement("path",{fill:"#2A5969",d:"M11.638 22.425a1.597 1.597 0 1 1-3.193 0 1.597 1.597 0 0 1 3.193 0M18.021 22.425a1.596 1.596 0 1 1-3.192 0 1.596 1.596 0 0 1 3.192 0"}),i.createElement("path",{stroke:"#2A5969",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:2,d:"M32.915 34.807a4.414 4.414 0 0 0 3.677 1.98c1.592 0 2.988-.85 3.77-2.127"}),i.createElement("path",{fill:"#2A5969",d:"M38.234 28.809a1.596 1.596 0 1 0 3.192-.002 1.596 1.596 0 0 0-3.192.002M31.851 28.809a1.596 1.596 0 1 0 3.192-.001 1.596 1.596 0 0 0-3.192.001"}),i.createElement("path",{fill:"#F7D687",d:"M36.072 11.988c-7.528.334-13.318 5.493-13.318 14.415V43.56c0 .83 1.08 1.19 1.546.503 1.44-2.123 2.45-6.601 2.45-8.265v-10.62a7.821 7.821 0 0 0 5.192-3.17c.302-.418.894-.498 1.268-.142a12.297 12.297 0 0 0 13.447 2.355V35.797c0 1.665 1.01 6.143 2.45 8.266.466.687 1.546.328 1.546-.503V25.964c0-7.936-6.59-14.329-14.581-13.976"}),i.createElement("path",{stroke:"#2A5969",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:2,d:"M46.671 35.71V23.968a12.312 12.312 0 0 1-4.996 1.06c-3.69 0-6.997-1.627-9.28-4.198a7.896 7.896 0 0 1-5.79 4.11v10.77c0 .263-.026.6-.073.98 2.193 3.269 5.9 5.416 10.106 5.416 4.206 0 7.914-2.147 10.107-5.416a8.318 8.318 0 0 1-.074-.98zM22.575 26.411c0-3.222 1.085-6.183 2.893-8.565C24.75 11.74 19.572 7 13.282 7 6.499 7 1 12.506 1 19.299v5.187c0 6.794 5.5 12.301 12.282 12.301 3.716 0 7.041-1.661 9.293-4.275v-6.1z"}),i.createElement("path",{stroke:"#2A5969",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:2,d:"M25.468 17.926C24.734 11.776 19.527 7 13.178 7 7.13 7 2.1 11.33 1 17.058a13.805 13.805 0 0 0 6.547 1.644c4.1 0 7.774-1.79 10.312-4.622a8.752 8.752 0 0 0 7.073 4.576c.168-.252.353-.49.536-.73z"}),i.createElement("path",{stroke:"#2A5969",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:2,d:"M36.638 12.32c-7.932 0-14.361 6.214-14.361 13.88v19.098c2.272 0 4.113-7.142 4.113-9.338V25.421c2.563-.366 4.732-1.897 5.913-4.02a12.892 12.892 0 0 0 9.48 4.107c1.816 0 3.54-.374 5.104-1.037V35.961c0 2.195 1.841 9.337 4.113 9.337V26.2c0-7.667-6.429-13.882-14.362-13.882z"}))))},AQ=(0,i.forwardRef)(_Q);o.p;var EQ,wQ=["title","titleId"];function xQ(){return xQ=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},xQ.apply(null,arguments)}var kQ=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,wQ);return i.createElement("svg",xQ({xmlns:"http://www.w3.org/2000/svg",width:52,height:52,viewBox:"0 0 52 52",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,EQ||(EQ=i.createElement("g",{fill:"none",fillRule:"evenodd"},i.createElement("path",{fill:"#EFF4F4",d:"M12.396 43.294H4.308l-1.47-18.382 9.558 2.206z"}),i.createElement("path",{fill:"#EFF4F4",d:"M10.19 12.412H6.514c-3.238 3.581-4.105 7.853-3.677 12.5l9.559 2.206c-1.588-3.936-2.373-10.294-2.206-14.706zM5 12h23V9H5z"}),i.createElement("path",{stroke:"#2A5969",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:2,d:"M12.396 43.294H4.308l-1.47-18.382 9.558 2.206z"}),i.createElement("path",{stroke:"#2A5969",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:2,d:"M10.19 12.412H6.514c-3.238 3.581-4.105 7.853-3.677 12.5l9.559 2.206c-1.588-3.936-2.373-10.294-2.206-14.706z"}),i.createElement("path",{fill:"#EFF4F4",d:"M35 41.173L38.057 33l3.448 1.274-2.829 7.634"}),i.createElement("path",{stroke:"#2A5969",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:2,d:"M50.631 42.559h-12.5c-6.617 0-9.559-4.412-14.706-9.559-5.882-5.882-20.588-8.088-20.588-8.088M5 12h23.53V9H5zM13 8v5"}),i.createElement("path",{stroke:"#2A5969",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:2,d:"M34.455 41.824l3.567-9.68 3.449 1.275-3.34 9.14"}),i.createElement("g",null,i.createElement("path",{fill:"#F48E8E",d:"M36.191 17.453c-1.723-1.423-4.29-1.167-5.872.414l-1.7 1.699-1.699-1.7c-1.58-1.58-4.148-1.836-5.872-.413a4.282 4.282 0 0 0-.311 6.338l1.828 1.828 5.27 5.27a1.11 1.11 0 0 0 1.57 0l5.269-5.27 1.829-1.828a4.282 4.282 0 0 0-.312-6.338"}),i.createElement("path",{stroke:"#2A5969",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:2,d:"M37.02 17.254a4.28 4.28 0 0 0-6.054 0l-1.829 1.829-1.83-1.829a4.28 4.28 0 1 0-6.053 6.054l1.83 1.83 6.053 6.053 6.054-6.053v-.001l1.83-1.829a4.28 4.28 0 0 0 0-6.054z"})))))},CQ=(0,i.forwardRef)(kQ);o.p;var SQ,MQ=["title","titleId"];function TQ(){return TQ=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},TQ.apply(null,arguments)}var OQ=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,MQ);return i.createElement("svg",TQ({xmlns:"http://www.w3.org/2000/svg",width:52,height:52,viewBox:"0 0 52 52",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,SQ||(SQ=i.createElement("g",{fill:"none",fillRule:"evenodd"},i.createElement("path",{fill:"#FFF",d:"M13.182 37s-3.236 7.367 1 11c0 0-.871-2.978 2.818-3.372 0 0-3.996-1.651-3.818-7.628M51 17.913L26 8 1 17.913l7.996 3.17v8.175L26 36l17.004-6.742v-8.175z"}),i.createElement("path",{fill:"#EFF4F4",d:"M47.415 17.025l-22.576-8.96a.91.91 0 0 0-.676 0l-22.578 8.96c-.78.31-.78 1.425 0 1.734l5.848 2.321 1.526.583a.933.933 0 0 1 .597.872v6.936c0 .382.23.725.583.866l14.023 5.599c.218.085.46.085.678 0l18.64-7.402a.931.931 0 0 0 .586-.868l-.004-6.943c0-.384.233-.728.587-.868l2.766-1.096c.78-.31.78-1.424 0-1.734"}),i.createElement("path",{stroke:"#2A5969",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:2,d:"M26 28L1 18 26 8l25 10z"}),i.createElement("path",{stroke:"#2A5969",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:2,d:"M26 18l-13 5.194V37"}),i.createElement("path",{stroke:"#2A5969",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:2,d:"M43 22v8.22L26 37 9 30.22V22"}),i.createElement("path",{fill:"#F7D687",d:"M13.182 37s-3.236 7.367 1 11c0 0-.871-2.978 2.818-3.372 0 0-3.996-1.651-3.818-7.628z"}),i.createElement("path",{stroke:"#2A5969",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:2,d:"M13.182 37s-3.236 7.367 1 11c0 0-.871-2.978 2.818-3.372 0 0-3.996-1.651-3.818-7.628z"}),i.createElement("path",{fill:"#FFF",d:"M28 17.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"}),i.createElement("path",{stroke:"#2A5969",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:2,d:"M28 17.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM12 37h3"}))))},DQ=(0,i.forwardRef)(OQ);o.p;var LQ,PQ=["title","titleId"];function IQ(){return IQ=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},IQ.apply(null,arguments)}var BQ=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,PQ);return i.createElement("svg",IQ({xmlns:"http://www.w3.org/2000/svg",width:52,height:52,viewBox:"0 0 52 52",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,LQ||(LQ=i.createElement("g",{fill:"none",fillRule:"evenodd"},i.createElement("path",{fill:"#F7D687",d:"M18.65 13C3.929 21.5 4.5 38.49 4.5 38.49s14.428 8.99 29.15.49c14.723-8.5 14.151-25.49 14.151-25.49S33.373 4.5 18.651 13z"}),i.createElement("path",{stroke:"#2A5969",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:2,d:"M17.65 13C2.929 21.5 3.5 38.49 3.5 38.49s14.428 8.99 29.15.49c14.723-8.5 14.151-25.49 14.151-25.49S32.373 4.5 17.651 13z"}),i.createElement("path",{fill:"#FFF",d:"M5.892 26.633l9.073 15.715c1.5.208 3.1.315 4.776.273L8.044 22.361a29.393 29.393 0 0 0-2.152 4.272z"}),i.createElement("path",{stroke:"#2A5969",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:2,d:"M5.892 26.633l9.073 15.715c1.5.208 3.1.315 4.776.273L8.044 22.361a29.393 29.393 0 0 0-2.152 4.272z"}),i.createElement("path",{fill:"#FFF",d:"M30.56 9.36l11.698 20.26a29.487 29.487 0 0 0 2.152-4.272L35.336 9.633c-1.5-.208-3.1-.315-4.776-.273z"}),i.createElement("path",{stroke:"#2A5969",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:2,d:"M30.56 9.36l11.698 20.26a29.487 29.487 0 0 0 2.152-4.272L35.336 9.633c-1.5-.208-3.1-.315-4.776-.273zM19.954 28.99l10.393-6M22.687 29.722l-2-3.464M26.15 27.722l-2-3.464M29.615 25.722l-2-3.464"}))))},RQ=(0,i.forwardRef)(BQ);o.p;var NQ,FQ=["title","titleId"];function jQ(){return jQ=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},jQ.apply(null,arguments)}var YQ=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,FQ);return i.createElement("svg",jQ({xmlns:"http://www.w3.org/2000/svg",width:52,height:52,viewBox:"0 0 52 52",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,NQ||(NQ=i.createElement("g",{fill:"none",fillRule:"evenodd"},i.createElement("path",{fill:"#FFF",d:"M43.085 42.156c.413 2.34-1.518 4.638-4.312 5.13-2.795.494-5.395-1.005-5.808-3.346-.412-2.341 1.518-4.638 4.312-5.13 2.795-.493 5.395 1.005 5.808 3.346M31.964 9.854L12.23 14.925V9.071l19.733-5.07zM31.908 29.693c.412 2.34-1.519 4.638-4.312 5.13-2.795.494-5.395-1.005-5.808-3.345-.412-2.341 1.518-4.64 4.312-5.131 2.795-.493 5.395 1.005 5.808 3.346M12.175 34.76c.413 2.34-1.518 4.637-4.312 5.13-2.794.493-5.394-1.006-5.807-3.346-.413-2.34 1.517-4.639 4.312-5.13 2.794-.494 5.395 1.004 5.807 3.345"}),i.createElement("path",{fill:"#93D8ED",d:"M43.087 42.157c.412 2.341-1.52 4.638-4.312 5.131-2.795.493-5.395-1.006-5.808-3.347-.413-2.341 1.518-4.638 4.312-5.13 2.795-.493 5.395 1.005 5.808 3.346M31.422 9.84L13.69 14.399a1 1 0 0 1-1.25-.97V9.64a1 1 0 0 1 .752-.968l17.733-4.558a1 1 0 0 1 1.249.969v3.789c0 .457-.31.855-.752.969M31.91 29.695c.412 2.34-1.519 4.638-4.313 5.13-2.794.493-5.395-1.005-5.807-3.346-.413-2.341 1.517-4.638 4.312-5.131 2.794-.492 5.395 1.006 5.807 3.347M12.177 34.761c.413 2.341-1.518 4.638-4.312 5.13-2.794.493-5.395-1.005-5.807-3.346-.413-2.341 1.517-4.638 4.312-5.131 2.794-.492 5.394 1.006 5.807 3.347"}),i.createElement("path",{stroke:"#2A5969",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:2,d:"M43.085 42.156c.413 2.34-1.518 4.638-4.312 5.13-2.795.494-5.395-1.005-5.808-3.346-.412-2.341 1.518-4.638 4.312-5.13 2.795-.493 5.395 1.005 5.808 3.346zM31.964 9.854L12.23 14.925V9.071l19.733-5.07zM43.14 42.68V18.941M31.908 29.693c.412 2.34-1.519 4.638-4.312 5.13-2.795.494-5.395-1.005-5.808-3.345-.412-2.341 1.518-4.64 4.312-5.131 2.795-.493 5.395 1.005 5.808 3.346zM31.964 30.262V6.479M12.175 34.76c.413 2.34-1.518 4.637-4.312 5.13-2.794.493-5.394-1.006-5.807-3.346-.413-2.34 1.517-4.639 4.312-5.13 2.794-.494 5.395 1.004 5.807 3.345zM12.23 35.274V11.545M47.394 35.06s2.648-4.13 1.54-7.95c-1.11-3.821-5.793-3.574-5.793-8.257"}))))},$Q=(0,i.forwardRef)(YQ);o.p;var HQ,UQ=["title","titleId"];function zQ(){return zQ=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},zQ.apply(null,arguments)}var WQ=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,UQ);return i.createElement("svg",zQ({xmlns:"http://www.w3.org/2000/svg",width:52,height:52,viewBox:"0 0 52 52",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,HQ||(HQ=i.createElement("g",{fill:"none",fillRule:"evenodd"},i.createElement("path",{fill:"#FFF",d:"M34.7 47.225a11.789 11.789 0 0 1-10.332-6.106c5.368-2.359 9.12-7.715 9.12-13.955 0-1.173-.144-2.31-.395-3.407a11.796 11.796 0 0 1 1.606-.122c6.514 0 11.795 5.281 11.795 11.795S41.214 47.225 34.7 47.225m-4.659-20.06c0 4.756-2.822 8.845-6.879 10.711a11.877 11.877 0 0 1-.257-2.446c0-4.757 2.822-8.846 6.878-10.71.167.788.258 1.605.258 2.444M18.244 38.96c-6.514 0-11.795-5.28-11.795-11.795 0-6.514 5.281-11.795 11.795-11.795 4.451 0 8.323 2.467 10.331 6.106-5.367 2.36-9.12 7.716-9.12 13.955 0 1.173.144 2.31.395 3.407-.526.072-1.059.122-1.606.122M34.7 20.186c-.952 0-1.88.1-2.784.266-2.484-5.049-7.664-8.532-13.67-8.532C9.824 11.92 3 18.745 3 27.164c0 8.42 6.824 15.244 15.243 15.244.952 0 1.88-.099 2.784-.266 2.483 5.05 7.664 8.532 13.671 8.532 8.42 0 15.244-6.825 15.244-15.244S43.118 20.186 34.7 20.186"}),i.createElement("path",{fill:"#FFF",d:"M10.947 5.656l7.294 6.264 7.295-6.264V5.64L23.102 2H13.38l-2.433 3.64z"}),i.createElement("path",{fill:"#F7D687",d:"M34.11 47.537c-4.447 0-8.316-2.467-10.32-6.105 5.357-2.362 9.101-7.712 9.101-13.944 0-1.166-.142-2.296-.39-3.387v.001a11.84 11.84 0 0 1 1.61-.123c6.504 0 11.777 5.274 11.777 11.78 0 6.505-5.273 11.778-11.778 11.778m-16.46-8.27c-6.506 0-11.779-5.274-11.779-11.779 0-6.506 5.273-11.779 11.78-11.779 4.446 0 8.315 2.467 10.32 6.105-5.358 2.363-9.103 7.712-9.103 13.944 0 1.166.142 2.296.39 3.386-.527.072-1.06.122-1.608.122m4.681-3.508c0-4.742 2.808-8.818 6.847-10.686.162.78.25 1.588.25 2.416 0 4.742-2.808 8.82-6.847 10.686a11.87 11.87 0 0 1-.25-2.416m11.78-15.242c-.955 0-1.884.1-2.789.267-2.483-5.052-7.664-8.537-13.672-8.537-8.418 0-15.242 6.824-15.242 15.242 0 8.418 6.824 15.241 15.242 15.241.953 0 1.883-.098 2.788-.266C22.921 47.515 28.101 51 34.11 51c8.417 0 15.241-6.824 15.241-15.242 0-8.417-6.824-15.242-15.24-15.242"}),i.createElement("path",{fill:"#2A5969",d:"M34.701 49.674c-5.63 0-10.493-3.292-12.803-8.045a14.586 14.586 0 0 1-.583-1.383l-.05-.135a14.223 14.223 0 0 1-.805-4.679A14.25 14.25 0 0 1 28.1 22.82c.008.02.02.038.027.058.176.404.324.818.45 1.24l.023.098c-4.083 2.225-6.677 6.54-6.677 11.216 0 .897.094 1.771.271 2.616v.004c.074.36.17.713.276 1.064.032.108.07.214.104.32.087.264.183.524.287.781.042.104.083.208.128.311.133.305.277.605.435.9.018.036.035.074.054.11.01.016.017.034.027.051.005.01.014.015.02.024 2.182 3.93 6.371 6.598 11.176 6.598 7.047 0 12.78-5.732 12.78-12.779 0-7.046-5.733-12.779-12.78-12.779-.276 0-.558.012-.856.035l-.01-.029a16.12 16.12 0 0 0-.438-1.288c-.014-.037-.023-.075-.038-.113.453-.045.9-.067 1.342-.067 7.854 0 14.242 6.388 14.242 14.241s-6.388 14.242-14.242 14.242zm-15.117-8.339c-.455.046-.9.068-1.343.068-7.852 0-14.24-6.388-14.24-14.24 0-7.854 6.388-14.243 14.24-14.243 5.625 0 10.483 3.285 12.796 8.03.224.458.421.926.592 1.401l.046.125a14.194 14.194 0 0 1 .808 4.686 14.25 14.25 0 0 1-7.64 12.611l-.03-.063a10.631 10.631 0 0 1-.446-1.235c-.01-.03-.016-.065-.025-.097 4.083-2.225 6.678-6.54 6.678-11.216 0-.897-.094-1.77-.27-2.616v-.004a12.324 12.324 0 0 0-.275-1.057c-.035-.116-.075-.229-.113-.344a13.418 13.418 0 0 0-.274-.749c-.046-.112-.09-.224-.139-.336-.13-.297-.27-.59-.424-.877-.02-.04-.04-.084-.062-.124l-.025-.049c-.005-.01-.014-.015-.019-.024-2.183-3.93-6.372-6.599-11.178-6.599-7.046 0-12.778 5.732-12.778 12.78 0 7.045 5.732 12.777 12.778 12.777.276 0 .56-.01.856-.035.004.014.01.026.013.04.127.436.276.861.437 1.282.013.035.022.072.037.108zm3.253-34.679l-4.596 3.946-4.595-3.946h9.191zM13.914 3h8.654l1.097 1.64H12.818L13.914 3zm20.357 21.671c.145-.007.293-.018.43-.018 5.943 0 10.78 4.836 10.78 10.78 0 5.943-4.837 10.778-10.78 10.778-3.686 0-6.94-1.86-8.886-4.69a16.249 16.249 0 0 0 8.668-14.359c0-.849-.085-1.677-.212-2.49zm-15.81 10.761c0 .85.084 1.677.21 2.491-.145.007-.292.017-.43.017-5.943 0-10.778-4.835-10.778-10.778 0-5.944 4.835-10.779 10.778-10.779 3.686 0 6.941 1.861 8.887 4.691a16.248 16.248 0 0 0-8.668 14.358zm5.462 0c0-3.716 1.947-7.159 5.054-9.114.022.28.043.56.043.844 0 3.716-1.947 7.158-5.054 9.114a10.232 10.232 0 0 1-.043-.844zm10.778-16.24c-.717 0-1.463.07-2.217.175a16.269 16.269 0 0 0-11.784-8.24l5.487-4.712a.991.991 0 0 0 .228-.3l.003-.004.007-.019a.996.996 0 0 0 .083-.225c.012-.053.013-.108.016-.162.002-.034.011-.068.01-.103a.999.999 0 0 0-.167-.518l-2.434-3.64a.997.997 0 0 0-.83-.444H13.38a.997.997 0 0 0-.83.444l-2.434 3.64a1.01 1.01 0 0 0-.167.52c0 .032.007.065.01.1.003.054.003.11.015.163.018.08.048.152.084.225l.007.02.003.003a.987.987 0 0 0 .228.3l5.486 4.712C7.993 12.318 2 19.044 2 27.162c0 8.955 7.286 16.241 16.241 16.241.727 0 1.464-.07 2.218-.177 2.763 5.03 8.11 8.448 14.242 8.448 8.956 0 16.242-7.286 16.242-16.242 0-8.955-7.286-16.24-16.242-16.24z"}))))},VQ=(0,i.forwardRef)(WQ);o.p;var GQ=function(){return i.createElement(QQ,{"data-testid":"music-plan-current-plan-pill"},"Current Plan")},QQ=fr(_r)((function(e){var t=e.theme;return"\n        background-color: "+t.colors.blue[400]+";\n        border: solid 2px "+t.colors.blue[400]+";\n        border-radius: 12px;\n        color: "+t.colors.white+";\n        font-size: 10px;\n        left: 50%;\n        line-height: 1.5em;\n        position: absolute;\n        text-align: center;\n        text-transform: uppercase;\n        top: -10px;\n        transform: translate(-50%);\n        width: 134px;\n    "})),qQ=fr(wr,{shouldForwardProp:function(e){return!["isCurrent","isSelected"].includes(String(e))}})((function(e){var t=e.isCurrent,n=e.isSelected,r=e.theme;return"\n        align-items: center;\n        border: solid 2px "+r.colors.gray[200]+";\n        border-radius: 5px;\n        cursor: pointer;\n        flex-direction: column;\n        justify-content: center;\n        margin-bottom: 5px;\n        margin-right: 23.5px;\n        min-height: 160px;\n        min-width: 158px;\n        position: relative;\n        width: 15%;\n\n        "+(t?"background-color: "+r.colors.gray[100]+";":"")+"\n\n        "+(n?"\n                    border: solid 2px "+r.colors.blue[400]+";\n                    box-shadow: 0 4px 30px 0 "+r.colors.gray[200]+";\n                ":"")+"\n\n        &:last-of-type {\n            margin-right: 0;\n        }\n\n        p {\n            color: "+r.colors.gray[500]+";\n            margin-bottom: 0;\n        }\n\n        svg {\n            height: 52px;\n            margin-bottom: 5px;\n            width: 52px;\n        }\n    "}));const KQ=function(e){var t,n=e.isSelected,r=e.musicPlan,o=e.onClick,a=r.isCurrent,s=r.name;switch(r.name){case"Babies, Kids & Family":t=AQ;break;case"Boudoir & Fashion":t=CQ;break;case"High School Seniors":t=DQ;break;case"Sports & Action":t=RQ;break;case"Ultimate (all songs)":t=$Q;break;case"Weddings & Love":t=VQ}return i.createElement(qQ,{"data-testid":"music-plan",isCurrent:a,isSelected:n,onClick:function(){return o(r)}},a&&i.createElement(GQ,null),t&&i.createElement(t,{"data-testid":"music-plan-icon"}),i.createElement(Px,{"data-testid":"music-plan-name"},s))};var ZQ,JQ=function(e){var t=e.canStartTrial,r=e.close,o=e.currentPlan,a=e.initialSelectedPlan,s=e.modalComponent,l=e.moneyBalance,c=e.musicPlans,u=e.onChangePlan,d=function(e,t){var n=e.monthly,r=e.yearly;return(t?n.price:r.price)+" per "+(t?"month":"year")+" + applicable taxes"},p=c.map((function(e,t){return{label:e.name,value:t}})),f=m((0,i.useState)(null),2),h=f[0],g=f[1],v=h?[{label:d(h,!0),value:"monthly"},{label:d(h,!1),value:"yearly"}]:[],y=function(){g(a),E("monthly")},b=h?p.find((function(e){return e.label===h.name})):void 0,_=m((0,i.useState)("monthly"),2),A=_[0],E=_[1],w=null!==h&&h.isCurrent&&(h.isMonthly?"monthly"===A:"yearly"===A),x=v.find((function(e){return e.value===A})),k=o&&h&&o.num_songs>h.num_songs;return(0,i.useEffect)((function(){g(a)}),[a]),i.createElement(s,{heading:"Confirm Plan Change",onClose:y},i.createElement(s.Body,null,t&&i.createElement(Px,{"data-testid":"change-music-plan-modal-can-start-trial-description"},"You are starting your music trial. In 30 days you will begin getting billed for the plan you are in at that time."),o&&i.createElement(_r,{"data-testid":"change-music-plan-modal-current-plan-section"},i.createElement(UI,{"data-testid":"change-music-plan-modal-current-plan-heading"},"Current Music Plan"),i.createElement(Px,{"data-testid":"change-music-plan-modal-current-plan-description"},o.name,i.createElement("br",null)," ",o?o.numberOfSongsFormatted+" songs at "+d(o,o.isMonthly):"")),i.createElement(xF,{"data-testid":"change-music-plan-modal-new-plan-heading"},"New Plan"),i.createElement("label",{"data-testid":"change-music-plan-modal-selected-plan-label",htmlFor:"plan"},"Select New Plan"),i.createElement(WG,{controlStyles:{marginBottom:"8px"},inputId:"plan",name:"plan",onChange:function(e,t){g(c[t])},options:p,value:b}),h&&i.createElement(Px,{"data-testid":"change-music-plan-modal-selected-plan-number-of-songs-description"},"Includes ",h.numberOfSongsFormatted," Songs"),i.createElement("label",{"data-testid":"change-music-plan-modal-selected-plan-period-label",htmlFor:"plan-period"},"Plan Billing"),i.createElement(WG,{controlStyles:{marginBottom:"1em"},inputId:"plan-period",name:"plan-period",onChange:function(e,t){E(t)},options:v,value:x}),l&&i.createElement(Px,{"data-testid":"change-music-plan-modal-money-balance-description"},"Your account currently has a credit of ",l," that will be applied to this bill."),i.createElement(Px,{"data-testid":"change-music-plan-modal-refund-disclaimer"},"Please note that no refunds will be made back to your card if you change your mind. A ShootProof credit is all that can be issued."),k&&i.createElement(Px,{"data-testid":"change-music-plan-modal-playlist-cleared-on-plan-change-warning"},"Note: Changing plan type will clear all songs out of your playlists.")),i.createElement(s.PrimaryButton,{isDisabled:w,onClick:function(){h&&u(n({},h,{isMonthly:"monthly"===A,isYearly:"yearly"===A})),r(),y()}},o?"Yes, Confirm Change":"Yes, Confirm Selection"),i.createElement(s.SecondaryButton,{onClick:function(){r(),y()}},"Close"))},XQ=fr(gQ)(ZQ||(ZQ=zM(["\n    font-size: 36px;\n    line-height: 1em;\n    font-weight: 300;\n"])));const eq=function(e){var t=e.canStartTrial,r=e.moneyBalance,o=e.musicPlans,a=e.onCancelPlan,s=e.onChangePlan,l=nY(),c=l.Modal,u=l.close,d=l.open,p=nY(),f=p.Modal,h=p.close,g=p.open,v=t?"Start Trial":"Change Plan",y=o.find((function(e){return e.isCurrent}))||null,b=function(e){var t=e.isMonthly,n=e.monthly,r=e.yearly;return t?n.display_price+"/mo":r.display_price+"/yr"},_=(y||{}).name,A=i.createElement(Sx,{"data-testid":"music-plan-section-music-page-link",href:"/v3/music"},"music page"),E=m((0,i.useState)(null),2),w=E[0],x=E[1],k=(w||{}).name;return i.createElement(i.Fragment,null,i.createElement(XQ,{"data-testid":"music-plan-section-heading"},"Music Plan"),i.createElement(Px,{"data-testid":"music-plan-section-subheading"},y?i.createElement(i.Fragment,null,"To listen to songs and create playlists for your galleries, please visit the"," ",A,"."):i.createElement(i.Fragment,null,"To preview available songs, please visit the ",A,".")),i.createElement(wr,{flexWrap:"wrap",paddingBottom:"21px"},o.map((function(e,t){return i.createElement(KQ,{isSelected:w===e,key:t,musicPlan:e,onClick:x})}))),i.createElement(Px,{"data-testid":"music-plan-section-music-plans-subtext"},t?!w&&i.createElement(i.Fragment,null,"You have not selected a music plan. Select a music plan above and click the ",i.createElement("strong",null,"“",v,"”")," button to begin your free music trial."):y&&i.createElement(i.Fragment,null,"You are currently in the ",i.createElement("strong",null,"“",_,"”")," music plan billed at ",b(y)," + applicable taxes.",i.createElement("br",null)),w?i.createElement(i.Fragment,null,"You have selected the ",i.createElement("strong",null,"“",k,"”")," music plan (",b(n({},w,{isMonthly:!0}))," or"," ",b(n({},w,{isMonthly:!1}))," + applicable taxes). Click the ",i.createElement("strong",null,"“",v,"”")," button to switch to a different music plan."):t?i.createElement(i.Fragment,null,"Select a music plan above and click the"," ",i.createElement("strong",null,"“",v,"”")," button to switch to a different music plan."):i.createElement(i.Fragment,null,"You have not selected a music plan. Select a music plan above and click the"," ",i.createElement("strong",null,"“",v,"”")," button to purchase a music plan.")),i.createElement(fp,{"data-testid":"music-plan-section-change-plan-button",isDisabled:!w,marginBottom:"1em",minWidth:"148px",onClick:g},v),y&&i.createElement(Px,{"data-testid":"music-plan-section-cancel-plan-section"},"To cancel your music plan,"," ",i.createElement(Sx,{"data-testid":"music-plan-section-cancel-plan-section-link",onClick:d},"click here"),"."),i.createElement(c,{heading:"Cancel Music Plan"},i.createElement(c.Body,null,i.createElement(Px,null,"Are you sure that you want to cancel your plan? All songs in playlists will be removed and ",i.createElement("strong",null,"cannot be undone!"))),i.createElement(c.PrimaryButton,{destructive:!0,onClick:function(){u(),a()}},"Yes, Cancel Plan"),i.createElement(c.SecondaryButton,null,"Keep Plan")),i.createElement(JQ,{canStartTrial:t,close:h,currentPlan:y,initialSelectedPlan:w,modalComponent:f,moneyBalance:r,musicPlans:o,onChangePlan:s}))};var tq=yr((function(e,t){const n=Fr("Heading",e),{className:r,...o}=pt(e);return(0,br.jsx)(vr.h2,{ref:t,className:g("chakra-heading",e.className),...o,__css:n})}));tq.displayName="Heading";var nq=["me"],rq=(0,i.createContext)({hasPermissions:function(){return!1}}),oq=fO((function(e){var r=e.me,o=t(e,nq),a=(0,i.useCallback)((function(e){return[].concat(e).every((function(e){return r.permissions.includes(e)}))}),[r.permissions]);return i.createElement(rq.Provider,n({},o,{value:{hasPermissions:a}}))}));function iq(e,t){var n=function(n){var r=aq().hasPermissions;return t&&!r(t)?null:i.createElement(e,n)};return function(e){return i.createElement(oq,null,i.createElement(n,e))}}function aq(){return{hasPermissions:(0,i.useContext)(rq).hasPermissions}}var sq=function(e){return e.Free="free",e.Monthly="monthly",e.Annually="yearly",e.Both="monthlyOrAnually",e}({}),lq=["children"];function cq(){return cq=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},cq.apply(null,arguments)}var uq=pr(qr,{target:"e3suk160"})((e=>{var{theme:t}=e;return"\n        color: "+t.fontColor.default+";\n        font-family: "+t.fonts.heading+";\n        font-size: "+t.fontSizes["2xl"]+";\n        font-weight: "+t.fontWeights.light+";\n        line-height: "+t.lineHeights["2xl"]+";\n        margin-bottom: "+t.space[7]+";\n    "}),"");const dq=e=>{var{children:t}=e,n=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,lq);return Mr(uq,cq({as:"h1"},n),t)};var pq,fq,hq,mq,gq,vq=fr(UI)((function(e){var t=e.theme;return"\n        color: "+t.colors.navy[500]+";\n        font-size: "+t.fontSizes.sm+";\n        font-weight: "+t.fontWeights.medium+";\n        margin-bottom: 8px;\n    "})),yq=fr.ul((function(e){return"\n        font-size: "+e.theme.fontSizes.sm+";\n        list-style-type: none;\n\n        li {\n            margin-bottom: 14px;\n        }\n    "})),bq=fr(fp,{shouldForwardProp:function(e){return"isDestructive"!==e&&"isPrimaryAction"!==e}})((function(e){var t=e.isDestructive,n=e.isPrimaryAction,r=e.theme;return"\n        border: none;\n        border-radius: 0;\n        height: 32px;\n        margin-top: 10px;\n        width: 100%;\n\n        "+r.responsive.smallScreenOnly(pq||(pq=zM(["\n            height: 40px;\n            margin-top: 20px;\n        "])))+"\n\n        "+(t?"\n                    background-color: #BF303C;\n                    color: "+r.colors.white+";\n\n                    &:hover {\n                        background-color: "+r.colors.red[800]+";\n                        color: "+r.colors.white+";\n                    }\n                ":n?"\n                    background-color: "+r.colors.orange[200]+";\n                    color: "+r.colors.navy[400]+";\n\n                    &:hover {\n                        background-color: "+r.colors.orange[300]+";\n                        color: "+r.colors.navy[400]+";\n                    }\n                ":"\n                    background-color: transparent;\n                    color: "+r.colors.gray[600]+";\n\n                    &:hover {\n                        background-color: transparent;\n                        color: "+r.colors.gray[600]+";\n                        cursor: pointer;\n                    }\n\n                    &:focus {\n                        box-shadow: none;\n                    }\n                ")+"\n    "})),_q=fr(wr,{shouldForwardProp:function(e){return"isCurrent"!==e&&"showPlanFeatures"!==e}})((function(e){var t=e.isCurrent,n=e.showPlanFeatures,r=e.theme;return"\n        color: "+r.colors.navy[500]+";\n        background: "+r.colors.white+";\n        border: 1px solid "+r.colors.gray[200]+";\n        border-radius: 4px;\n        flex-direction: column;\n        font-size: "+r.fontSizes.md+";\n        margin: 0 8px 10px 8px;\n        width: 100%;\n        position: relative;\n\n        "+(t?"\n                    border: 1px solid "+r.colors.blue[400]+";\n                    box-shadow: 1px 3px 10px 1px "+r.colors.gray[200]+";\n                ":"")+"\n\n        "+(n?"min-height: 296px;":"min-height: 240px;")+"\n\n        "+r.responsive.smallScreenOnly(fq||(fq=zM(["\n            height: auto;\n            margin: 0 12px 24px 12px;\n            width: auto;\n        "])))+"\n\n        "+r.responsive.mediumScreenOnly(hq||(hq=zM(["\n            flex-basis: 180px;\n            max-width: 278px;\n\n        "])))+"\n\n        "+r.responsive.largeScreenUp("\n            flex-basis: "+100/3+"%;\n            max-width: 278px;\n        ")+"\n    "})),Aq=fr(wr)(mq||(mq=zM(["\n    flex-direction: column;\n    height: 100%;\n    justify-content: space-between;\n    padding: 20px 9px;\n"]))),Eq=fr(gQ)((function(e){var t=e.theme;return"\n        background-color: "+t.colors.blue[100]+";\n        border-top-left-radius: 4px;\n        border-top-right-radius: 4px;\n        color: "+t.colors.navy[500]+";\n        font-size: "+t.fontSizes.lg+";\n        padding: 22px 0;\n        text-align: center;\n    "})),wq=fr(dq)((function(e){var t=e.theme;return"\n        color: "+t.colors.navy[500]+";\n        font-size: "+t.fontSizes.sm+";\n        margin-bottom: 20px;\n    "})),xq=fr(_r)((function(e){var t=e.theme;return"\n        color: "+t.colors.navy[500]+";\n        font-size: "+t.fontSizes.lg+";\n        margin-bottom: 10px;\n    "})),kq=fr(_r)((function(){return"\n        background-color: #BF303C;\n        width: 90%;\n        margin-left: 5%;\n        position: absolute;\n        text-align: center;\n        border-radius: 2px;\n        top: -20px;\n    "})),Cq=fr(xF)((function(e){return"\n        color: white;\n        font-size: "+e.theme.fontSizes.lg+";\n        margin: 5px 0!important;\n        font-weight: 700;\n    "})),Sq=fr(xF)((function(e){return"\n        color: "+e.theme.colors.gray[600]+";\n        text-decoration: line-through;\n    "})),Mq=fr(Px)((function(e){var t=e.theme;return"\n        color: "+t.colors.navy[500]+";\n        font-size: "+t.fontSizes.sm+";\n        line-height: 24px;\n        margin-bottom: 24px;\n    "})),Tq=fr(Px)((function(e){var t=e.theme;return"\n        background: "+t.colors.blue[400]+";\n        border-radius: 2px;\n        color: "+t.colors.white+";\n        font-size: 16px;\n        font-weight: 700;\n        left: 7px;\n        line-height: 24px;\n        margin-left: auto;\n        margin-right: auto;\n        padding: 2px 15px;\n        position: absolute;\n        right: 7px;\n        text-align: center;\n        top: -15px;\n\n        "+t.responsive.mediumScreenOnly(gq||(gq=zM(["\n            width: 140px;\n        "])))+"\n    "}));const Oq=function(e){var t,n=e.plan,r=e.currentDowngradeUuid,o=e.currentPlanHeading,a=e.handleCancel,s=e.handlePlanSelect,l=e.hasCanceled,c=e.hasStudioUsedBooking,u=e.isBookingCard,d=e.upgradeUuid,p=e.showPlanFeatures,f=e.currentSelectedPlanIndex,h=e.planIndex,m=xo(),g=hO().me,v=null==g||null===(t=g.studio)||void 0===t||null===(t=t.photoPlan)||void 0===t?void 0:t.isInTrial,y=kC(kC(kC(kC({},sq.Annually,"spUi.studio.account.plans.annually"),sq.Free,"spUi.studio.account.plans.free"),sq.Monthly,"spUi.studio.account.plans.monthly"),sq.Both,"spUi.studio.account.plans.monthlyOrAnnually"),b=n.description,_=n.descriptionHeading,A=n.heading,E=n.isCurrent,w=n.photosAllowed,x=n.planPeriod,k=n.price,C=n.promoPrice,S=n.subheading,M=n.uuid,T=!u&&r===M,O=E&&null===d||null!==d&&d===M,D=(u||O)&&l,L="",P=m(D?"spUi.studio.account.plans.wantToResubscribe":"spUi.studio.account.plans.cancelDowngrade"),I=T?"cancel-downgrade-button":"remove-from-cancel-queue-button";return u?l||(L=c&&""===M?m("spUi.studio.account.plans.renewPlan"):x!==sq.Both?m("spUi.studio.account.plans.adjustPlan"):m("spUi.studio.account.plans.startTrial")):O&&v?L=m("spUi.studio.account.plans.subscribe"):O?l||(L=m("spUi.studio.account.plans.currentPlan")):O||(L=m(A===o?C&&"0"!==C?"spUi.studio.account.plans.claimPromo":"spUi.studio.account.plans.switch":void 0!==h&&void 0!==f&&f>h?"spUi.studio.account.plans.downgrade":C&&"0"!==C?"spUi.studio.account.plans.claimPromo":"spUi.studio.account.plans.upgrade")),i.createElement(_q,{"data-testid":"sp-ui-plan",isCurrent:O,showPlanFeatures:p},T&&i.createElement(kq,null,i.createElement(Cq,{"data-testid":"sp-ui-plan-pending-downgrade"},m("spUi.studio.account.plans.pendingPlan"))),D&&i.createElement(kq,null,i.createElement(Cq,{"data-testid":u?"sp-ui-booking-plan-pending-cancelation":"sp-ui-plan-pending-cancelation"},m("spUi.studio.account.plans.pendingCancel"))),25e3===w&&i.createElement(Tq,null,m("spUi.studio.account.plans.mostPopular")),i.createElement(Eq,{"data-testid":"sp-ui-plan-heading"},A),i.createElement(Aq,null,i.createElement(_r,null,""!==S&&i.createElement(Mq,{"data-testid":"sp-ui-plan-subheading"},S),C&&i.createElement(Sq,{"data-testid":"sp-ui-plan-price-promo"},"0"===C?"":k),i.createElement(xq,{"data-testid":"sp-ui-plan-price"},C&&"0"!==C?C:k),i.createElement(wq,{"data-testid":"sp-ui-plan-period",marginBottom:"24px"},m(y[x]).replace("{planPeriod}",y[x])),p&&i.createElement(i.Fragment,null,i.createElement(vq,{"data-testid":"sp-ui-plan-description-heading"},_),i.createElement(yq,{"data-testid":"sp-ui-plan-description-list"},b&&b.map((function(e,t){return i.createElement("li",{key:t},e)}))))),T||D?i.createElement(bq,{"data-testid":I,isDestructive:T,isPrimaryAction:!O||D,onClick:Lo(Io().mark((function e(){return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:a();case 1:case"end":return e.stop()}}),e)})))},P):i.createElement(bq,{"data-gtmid":"plan-select-button","data-testid":"select-"+QT(A)+"-button",isPrimaryAction:!O||v,onClick:function(e){s(n,e)}},L)))};var Dq=fr(_r,{shouldForwardProp:function(e){return"alertType"!==e}})((function(e){var t=e.theme,n=e.alertType;return"\n            margin-top:24px;\n            border-radius: 4px;\n            border: 1px solid "+(n===Bq.ALERT?t.colors.blue[600]:"#FBB405")+";\n            border-left: 5px solid "+(n===Bq.ALERT?t.colors.blue[600]:"#FBB405")+";\n            background-color: "+(n===Bq.ALERT?"#1c8bb01a":"#FBB4051A")+";\n        "})),Lq=fr(fx)((function(e){return"\n        color:  "+e.theme.colors.gray[600]+";\n        font-weight: 400;\n    "})),Pq=fr(fx)((function(){return"\n        font-weight: 700;\n    "})),Iq=fr(_r)((function(){return"\n        margin: 12px 24px;\n    "})),Bq=function(e){return e.ALERT="alert",e.WARNING="warning",e}({}),Rq=function(e){var t=e.alertType,n=e.complianceTexts,r=e.description,o=e.jsNextBillDate,a=e.notice,s=e.onceResolvedText,l=Co("studio.plan.trialCheckout.alertSection"),c=o?o.toLocaleString("default",{month:"long"})+" "+o.toLocaleString("default",{day:"numeric"})+" "+o.toLocaleString("default",{year:"numeric"}):"";return i.createElement(Dq,{alertType:t,"data-testid":"subscription-alert-container"},i.createElement(Iq,null,i.createElement(Lq,null,r,c&&i.createElement(Pq,null,c,".")),a&&i.createElement(i.Fragment,null,i.createElement("br",null),i.createElement(Lq,null,l("downgradeNotice"))),n&&i.createElement(Lq,null,i.createElement("br",null),i.createElement("br",null),l("accountExceeds"),i.createElement("br",null),l("pleaseResolve"),i.createElement("br",null),i.createElement("ul",null,n&&n.map((function(e){return i.createElement("li",{key:"plan-text-"+e},e)}))),s,i.createElement("br",null))))};const Nq=(0,i.memo)(Rq);const Fq=e=>{var{centerHeading:t=!0,children:n,headerText:r,hideSecondaryAction:o=!1,icon:a=Mr(kF,{height:"70px",width:"70px"}),onClose:s=(()=>{}),openSubscribe:l=(()=>{}),primaryAction:c=(()=>{}),primaryActionText:u,secondaryActionText:d,showCloseButton:p=!0}=e,{Modal:f,close:h,open:m}=nY(),g=xo();return(0,i.useEffect)((()=>{l(m,h)}),[h,l,m]),Mr(f,{areButtonsCentered:!c||o,hideSecondaryAction:o,onClose:s,showCloseButton:p},Mr(f.Body,null,Mr(wr,{flexDirection:"column",marginTop:"12px"},Mr(_r,{margin:"0 auto 37px"},a),Mr(dq,{marginBottom:"42px",textAlign:t?"center":"left"},g(r)),Mr(_r,null,n))),!o&&Mr(f.SecondaryButton,{onClick:()=>{s(),h()}},g(d||"Dismiss")),c&&u&&Mr(f.PrimaryButton,{onClick:c},g(u)))};var jq=(0,i.createContext)({inCulDeSac:!1});const Yq=e=>{var{children:t,component:n,enterOnRender:r=!1,onEnter:o=RF,onExit:a=RF}=e,[s,l]=(0,i.useState)(r);return(0,i.useEffect)((()=>{r&&(o(),l(!0))}),[r,o]),Mr(jq.Provider,{value:{inCulDeSac:s}},s?n((()=>{a(),l(!1)})):t((()=>{o(),l(!0)})))};function $q(e,t){void 0===t&&(t={});var n=n=>Mr(_C,{resetCSS:!1,partialTheme:t},Mr(e,n)),r=e.displayName||e.name;return n.displayName="withTheme"+r,n}function Hq(e){return"studio-booking-plan"===e.type}function Uq(e){return"studio-photo-plan"===e.type}var zq,Wq,Vq,Gq,Qq,qq,Kq,Zq,Jq,Xq,eK,tK,nK,rK,oK,iK=function(e,t,n,r,o,i){switch(e){case"booking":if(!n&&!r){var a=new Date;return a.setDate(a.getDate()+30),a}return!n&&r?new Date:n?new Date(n):null;case"photo":return o||i?t?new Date(t):null:new Date;default:return null}},aK=["title","titleId"];function sK(){return sK=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},sK.apply(null,arguments)}var lK=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,aK);return i.createElement("svg",sK({width:225,height:216,viewBox:"0 0 225 216",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,zq||(zq=i.createElement("circle",{opacity:.3,cx:117,cy:108,r:108,fill:"#D3EFF8"})),Wq||(Wq=i.createElement("path",{d:"M119.875 171C154.46 171 182.497 143.018 182.497 108.5C182.497 73.9822 154.46 46 119.875 46C85.2904 46 57.2539 73.9822 57.2539 108.5C57.2539 143.018 85.2904 171 119.875 171Z",fill:"#4AA34A"})),Vq||(Vq=i.createElement("path",{d:"M104.242 114.585L116.644 122.9L134.3 96.5",stroke:"white",strokeWidth:8,strokeMiterlimit:10,strokeLinecap:"round",strokeLinejoin:"round"})),Gq||(Gq=i.createElement("path",{d:"M124.054 188.175H123.473C122.08 188.175 120.92 186.913 120.92 185.398V184.01C120.92 183.505 120.455 183 119.991 183C119.527 183 119.062 183.505 119.062 184.01V185.524C119.062 187.039 117.902 188.301 116.509 188.301H115.929C115.464 188.301 115 188.806 115 189.311C115 189.816 115.464 190.32 115.929 190.32H116.509C117.902 190.32 119.062 191.583 119.062 193.097V194.99C119.062 195.495 119.527 196 119.991 196C120.455 196 120.92 195.495 120.92 194.99V193.097C120.92 191.583 122.08 190.32 123.473 190.32H124.054C124.518 190.32 124.982 189.816 124.982 189.311C125.098 188.553 124.634 188.175 124.054 188.175Z",fill:"#4FBEE3"})),Qq||(Qq=i.createElement("path",{d:"M202.476 98.6755H201.587C199.302 98.6755 197.524 96.9139 197.524 94.649V92.5099C197.524 91.6291 196.889 91 196 91C195.111 91 194.476 91.6291 194.476 92.5099V94.649C194.476 96.9139 192.698 98.6755 190.413 98.6755H189.524C188.635 98.6755 188 99.3046 188 100.185C188 101.066 188.635 101.695 189.524 101.695H190.413C192.698 101.695 194.476 103.457 194.476 105.722V108.49C194.476 109.371 195.111 110 196 110C196.889 110 197.524 109.371 197.524 108.49V105.722C197.524 103.457 199.302 101.695 201.587 101.695H202.476C203.365 101.695 204 101.066 204 100.185C204 99.3046 203.365 98.6755 202.476 98.6755Z",fill:"#FBB405"})),qq||(qq=i.createElement("path",{d:"M63.5714 175.675H62.7381C60.5952 175.675 58.9286 173.914 58.9286 171.649V169.51C58.9286 168.629 58.3333 168 57.5 168C56.6667 168 56.0714 168.629 56.0714 169.51V171.649C56.0714 173.914 54.4048 175.675 52.2619 175.675H51.4286C50.5952 175.675 50 176.305 50 177.185C50 178.066 50.5952 178.695 51.4286 178.695H52.2619C54.4048 178.695 56.0714 180.457 56.0714 182.722V185.49C56.0714 186.371 56.6667 187 57.5 187C58.3333 187 58.9286 186.371 58.9286 185.49V182.722C58.9286 180.457 60.5952 178.695 62.7381 178.695H63.5714C64.4048 178.695 65 178.066 65 177.185C65 176.305 64.4048 175.675 63.5714 175.675Z",fill:"#4AA34A"})),Kq||(Kq=i.createElement("path",{d:"M124.054 28.1748H123.473C122.08 28.1748 120.92 26.9126 120.92 25.3981V24.0097C120.92 23.5049 120.455 23 119.991 23C119.527 23 119.062 23.5049 119.062 24.0097V25.5243C119.062 27.0388 117.902 28.301 116.509 28.301H115.929C115.464 28.301 115 28.8058 115 29.3107C115 29.8155 115.464 30.3204 115.929 30.3204H116.509C117.902 30.3204 119.062 31.5825 119.062 33.0971V34.9903C119.062 35.4951 119.527 36 119.991 36C120.455 36 120.92 35.4951 120.92 34.9903V33.0971C120.92 31.5825 122.08 30.3204 123.473 30.3204H124.054C124.518 30.3204 124.982 29.8155 124.982 29.3107C125.098 28.5534 124.634 28.1748 124.054 28.1748Z",fill:"#4AA34A"})),Zq||(Zq=i.createElement("circle",{cx:139,cy:196,r:7,fill:"#FBB405"})),Jq||(Jq=i.createElement("circle",{cx:43.5,cy:80.5,r:6.5,fill:"#FF5058"})),Xq||(Xq=i.createElement("circle",{cx:100.5,cy:18.5,r:7.5,fill:"#4FBEE3"})),eK||(eK=i.createElement("path",{d:"M170 168C174.583 169.056 184 174.333 185 187",stroke:"#FF1D27",strokeWidth:3,strokeLinecap:"round",strokeLinejoin:"round"})),tK||(tK=i.createElement("path",{d:"M179 52C184.167 52 195.244 49.1662 198.22 37.8311C201.656 24.7425 202.977 22.6932 210 21",stroke:"#4FBEE3",strokeWidth:3,strokeLinecap:"round",strokeLinejoin:"round"})),nK||(nK=i.createElement("path",{d:"M2 150.629C7.46443 151.458 14.0869 151.001 18.9487 148.196C22.4315 146.186 26.3042 143.145 28.2564 139.504C29.8754 136.484 30.1496 133.708 29.1154 130.361C28.3609 127.919 25.4081 124 22.5256 124C20.1184 124 18.3209 125.779 18.3846 128.146C18.4251 129.65 19.3756 131.136 20.359 132.203C21.6673 133.622 23.2458 135.297 24.9615 136.13C26.2179 136.644 27.209 137.35 28.5385 137.701C30.5146 138.223 32.3201 138.105 34.359 137.83C37.5753 137.396 40.8157 135.486 43.4872 133.761C44.6547 133.007 46.3611 131.979 47 130.696",stroke:"#23AEDC",strokeWidth:3,strokeLinecap:"round"})),rK||(rK=i.createElement("circle",{cx:73,cy:21,r:3,fill:"#FBB405"})),oK||(oK=i.createElement("circle",{cx:209,cy:76,r:3,fill:"#FF5058"})))},cK=(0,i.forwardRef)(lK);o.p;var uK,dK,pK=["title","titleId"];function fK(){return fK=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},fK.apply(null,arguments)}var hK=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,pK);return i.createElement("svg",fK({width:152,height:148,viewBox:"0 0 152 148",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,uK||(uK=i.createElement("circle",{cx:76,cy:74,r:58.5,stroke:"#FF5058",strokeWidth:3})),dK||(dK=i.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M75.9997 43.8636C74.0416 43.8636 72.4542 45.451 72.4542 47.4091V82.8636C72.4542 84.8217 74.0416 86.4091 75.9997 86.4091C77.9578 86.4091 79.5451 84.8217 79.5451 82.8636V47.4091C79.5451 45.451 77.9578 43.8636 75.9997 43.8636ZM75.9997 93.5C74.0416 93.5 72.4542 95.0874 72.4542 97.0455C72.4542 99.0036 74.0416 100.591 75.9997 100.591C77.9578 100.591 79.5451 99.0036 79.5451 97.0455C79.5451 95.0874 77.9578 93.5 75.9997 93.5Z",fill:"#FF5058"})))},mK=(0,i.forwardRef)(hK);o.p;const gK=function(e,t,r){var o=Co("studio.plan"),a=m((0,i.useState)(),2),s=a[0],l=a[1],c=zo("booking"===r?"noauth/plan/booking/pricing":"noauth/plan/photo/pricing",{defer:!0}),u=c.performFetch,d=c.response,p=(0,i.useCallback)(function(){var e=Lo(Io().mark((function e(t,r){return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,u({search:n({plan:t},r&&{promo:r})});case 2:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),[u]);return(0,i.useEffect)((function(){if(200===(null==d?void 0:d.status)){var i=d.planId,a=d.promo,s=d.promoError,c=e.find((function(e){return e.uuid===i})),u=s,p=u===o("promoInvalid"),f=!1;if("photo"===r){var h=c&&"band"in c,m=h?c:null,g=h&&"higher-only"===(null==a?void 0:a.planBandRestriction)&&(null==t?void 0:t.band)&&(null==m?void 0:m.band)&&(null==t?void 0:t.band)>=m.band,v=h&&"current-or-higher"===(null==a?void 0:a.planBandRestriction)&&(null==t?void 0:t.band)&&(null==m?void 0:m.band)&&(null==t?void 0:t.band)>m.band,y=t||{},b=y.isFree,_=y.isInTrial,A=(_?["trial"]:[]).concat(b?["free"]:[]).concat(_||b?[]:["paid"]);f=Boolean(a&&!a.photoPlanTypesAllowed.some((function(e){return A.includes(e)})));var E="signup-only"===(null==a?void 0:a.whereItCanBeUsed);u!==o("promoInvalid")&&(f||E?u=o("promoInvalid"):g?u=o("promoRequiresUpgrade"):v&&(u=o("promoRequiresSameOrUpgrade")))}else if("booking"===r){var w="signup-only"===(null==a?void 0:a.whereItCanBeUsed);u!==o("promoInvalid")&&w&&(u=o("promoInvalid"))}l(n({},d,{promoError:u,isPromoAlwaysInvalid:p||f}))}}),[e,t,d,r,o]),{getPlanPricing:p,planPricingInfo:s}};var vK,yK,bK,_K,AK,EK=(0,i.createContext)({allAvailablePlans:[],defaultPlanUuid:void 0,deleteDowngrade:function(){return new Promise((function(){return null}))},getPlanPricing:function(){return new Promise((function(){return null}))},loadingPlans:!1,planPricingInfo:void 0,planType:"photo",postDowngrade:function(){return new Promise((function(){return null}))}}),wK=function(e){var t=e.children,n=e.defaultPlanUuid,r=e.planType,o=hO().me,a=(0,aq().hasPermissions)(uO.AccountRead),s=((null==o?void 0:o.studio)||{}).photoPlan,l=(s||{}).totalActivePhotosCount,c=null!=l?l:1500,u=zo("plan/downgrade",{defer:!0,method:Fo.POST}).performFetch,d=zo("plan/downgrade",{defer:!0,method:Fo.DELETE}).performFetch,p=zo("plan/photo",{defer:!0}),f=p.response,h=p.loading,m=p.performFetch,g=zo("plan/booking",{defer:!0}),v=g.response,y=g.loading,b=g.performFetch,_=(0,i.useMemo)((function(){var e,t;return null!==(e=null==f||null===(t=f.items)||void 0===t?void 0:t.filter((function(e){return e.photosAllowed&&e.photosAllowed>c||n||e.isUnlimited})))&&void 0!==e?e:[]}),[n,f,c]),A=(0,i.useMemo)((function(){var e;return null!==(e=null==v?void 0:v.items)&&void 0!==e?e:[]}),[v]),E="photo"===r?_:A,w=gK(E,s,r),x=w.getPlanPricing,k=w.planPricingInfo;return(0,i.useEffect)((function(){a&&"photo"===r&&m()}),[a,m,r]),(0,i.useEffect)((function(){a&&"booking"===r&&b()}),[a,b,r]),i.createElement(EK.Provider,{value:{allAvailablePlans:E,defaultPlanUuid:n,deleteDowngrade:d,getPlanPricing:x,loadingPlans:h||y,planPricingInfo:k,planType:r,postDowngrade:u}},t)},xK=function(){return(0,i.useContext)(EK)},kK=fr(wr)((function(e){return"\n        flex-direction: column;\n        padding-top: 150px;\n\n        "+e.theme.responsive.smallScreenOnly(vK||(vK=zM(["\n            padding-top: 56px;\n        "])))+"\n    "})),CK=fr(_r)(yK||(yK=zM(["\n    margin-bottom: 36px;\n"]))),SK=fr(fp)((function(e){return"\n        "+e.theme.responsive.mediumScreenUp(bK||(bK=zM(["\n            min-width: 216px;\n        "])))+"\n    "})),MK=fr(_r)((function(e){var t=e.theme;return"\n        max-width: 454px;\n\n        p {\n            color: "+t.colors.navy[600]+";\n            "+t.responsive.smallScreenOnly(_K||(_K=zM(["\n                text-align: center;\n            "])))+"\n        }\n\n        span {\n            font-weight: bold;\n        }\n\n        "+t.responsive.smallScreenOnly(AK||(AK=zM(["\n            padding: 0 16px;\n        "])))+"\n    "}));const TK=function(e){var t=e.onClose,n=e.canDowngrade,r=e.jsNextBillDate,o=e.complianceTexts,a=e.isFree,s=xK().planType,l=Co("studio.plan.trialCheckout.complete"),c=Co("studio.plan.trialCheckout.downgrade"),u=Co("studio.plan.trialCheckout.alertSection");return i.createElement(kK,{alignItems:"center","data-testid":"complete-page-container"},!1===n&&i.createElement(_r,null,i.createElement(mK,{"data-testid":"complete-error-image"})),!1!==n&&i.createElement(CK,null,i.createElement(cK,{"data-testid":"complete-page-image"})),i.createElement(dq,{"data-testid":"heading"},n?c("successfulHeading"):null===n?l("heading"):c("warningHeading")),r&&!1===n&&i.createElement(Nq,{alertType:Bq.WARNING,complianceTexts:o,description:u("paidThrough"),jsNextBillDate:r,onceResolvedText:u("onceResolved")}),!1!==n&&i.createElement(MK,null,i.createElement(Px,{"data-testid":"complete-message",textAlign:"center",padding:"22px 0 12px 0"},"photo"===s&&i.createElement(i.Fragment,null,n&&i.createElement(i.Fragment,null,c("successfulSubHeading"),i.createElement("span",null,null==r?void 0:r.toLocaleDateString(void 0,{year:"numeric",month:"short",day:"numeric"}))),!n&&l("subheading"),i.createElement("br",null),i.createElement("br",null)),!a&&i.createElement(i.Fragment,null,l("cardChargedOn"),i.createElement("span",null,null==r?void 0:r.toLocaleDateString(void 0,{year:"numeric",month:"short",day:"numeric"}))))),null!==n&&i.createElement(MK,null,i.createElement(Px,{"data-testid":"complete-message",padding:"10px 0"},c(n?"successfulEnd":"warningEnd"))),i.createElement(SK,{"data-testid":"complete-close-button",onClick:t},l("closeButton")))};var[OK,DK]=xr({name:"TagStylesContext",errorMessage:"useTagStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Tag />\" "}),LK=yr(((e,t)=>{const n=jr("Tag",e),r=pt(e),o={display:"inline-flex",verticalAlign:"top",alignItems:"center",maxWidth:"100%",...n.container};return(0,br.jsx)(OK,{value:n,children:(0,br.jsx)(vr.span,{ref:t,...r,__css:o})})}));LK.displayName="Tag";var PK=yr(((e,t)=>{const n=DK();return(0,br.jsx)(vr.span,{ref:t,noOfLines:1,...e,__css:n.label})}));PK.displayName="TagLabel",yr(((e,t)=>(0,br.jsx)(Jk,{ref:t,verticalAlign:"top",marginEnd:"0.5rem",...e}))).displayName="TagLeftIcon",yr(((e,t)=>(0,br.jsx)(Jk,{ref:t,verticalAlign:"top",marginStart:"0.5rem",...e}))).displayName="TagRightIcon";var IK=e=>(0,br.jsx)(Jk,{verticalAlign:"inherit",viewBox:"0 0 512 512",...e,children:(0,br.jsx)("path",{fill:"currentColor",d:"M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"})});IK.displayName="TagCloseIcon";var BK=yr(((e,t)=>{const{isDisabled:n,children:r,...o}=e,i={display:"flex",alignItems:"center",justifyContent:"center",outline:"0",...DK().closeButton};return(0,br.jsx)(vr.button,{ref:t,"aria-label":"close",...o,type:"button",disabled:n,__css:i,children:r||(0,br.jsx)(IK,{})})}));BK.displayName="TagCloseButton";var RK=Object.defineProperty,NK=(e,t,n)=>(((e,t,n)=>{t in e?RK(e,t,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[t]=n})(e,"symbol"!=typeof t?t+"":t,n),n);function FK(e){return e.sort(((e,t)=>{const n=e.compareDocumentPosition(t);if(n&Node.DOCUMENT_POSITION_FOLLOWING||n&Node.DOCUMENT_POSITION_CONTAINED_BY)return-1;if(n&Node.DOCUMENT_POSITION_PRECEDING||n&Node.DOCUMENT_POSITION_CONTAINS)return 1;if(n&Node.DOCUMENT_POSITION_DISCONNECTED||n&Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC)throw Error("Cannot sort the given nodes.");return 0}))}function jK(e,t,n){let r=e+1;return n&&r>=t&&(r=0),r}function YK(e,t,n){let r=e-1;return n&&r<0&&(r=t),r}var $K="undefined"!=typeof window?i.useLayoutEffect:i.useEffect,HK=e=>e,UK=class{constructor(){NK(this,"descendants",new Map),NK(this,"register",(e=>{var t;if(null!=e)return"object"==typeof(t=e)&&"nodeType"in t&&t.nodeType===Node.ELEMENT_NODE?this.registerNode(e):t=>{this.registerNode(t,e)}})),NK(this,"unregister",(e=>{this.descendants.delete(e);const t=FK(Array.from(this.descendants.keys()));this.assignIndex(t)})),NK(this,"destroy",(()=>{this.descendants.clear()})),NK(this,"assignIndex",(e=>{this.descendants.forEach((t=>{const n=e.indexOf(t.node);t.index=n,t.node.dataset.index=t.index.toString()}))})),NK(this,"count",(()=>this.descendants.size)),NK(this,"enabledCount",(()=>this.enabledValues().length)),NK(this,"values",(()=>Array.from(this.descendants.values()).sort(((e,t)=>e.index-t.index)))),NK(this,"enabledValues",(()=>this.values().filter((e=>!e.disabled)))),NK(this,"item",(e=>{if(0!==this.count())return this.values()[e]})),NK(this,"enabledItem",(e=>{if(0!==this.enabledCount())return this.enabledValues()[e]})),NK(this,"first",(()=>this.item(0))),NK(this,"firstEnabled",(()=>this.enabledItem(0))),NK(this,"last",(()=>this.item(this.descendants.size-1))),NK(this,"lastEnabled",(()=>{const e=this.enabledValues().length-1;return this.enabledItem(e)})),NK(this,"indexOf",(e=>{var t,n;return e&&null!=(n=null==(t=this.descendants.get(e))?void 0:t.index)?n:-1})),NK(this,"enabledIndexOf",(e=>null==e?-1:this.enabledValues().findIndex((t=>t.node.isSameNode(e))))),NK(this,"next",((e,t=!0)=>{const n=jK(e,this.count(),t);return this.item(n)})),NK(this,"nextEnabled",((e,t=!0)=>{const n=this.item(e);if(!n)return;const r=jK(this.enabledIndexOf(n.node),this.enabledCount(),t);return this.enabledItem(r)})),NK(this,"prev",((e,t=!0)=>{const n=YK(e,this.count()-1,t);return this.item(n)})),NK(this,"prevEnabled",((e,t=!0)=>{const n=this.item(e);if(!n)return;const r=YK(this.enabledIndexOf(n.node),this.enabledCount()-1,t);return this.enabledItem(r)})),NK(this,"registerNode",((e,t)=>{if(!e||this.descendants.has(e))return;const n=FK(Array.from(this.descendants.keys()).concat(e));(null==t?void 0:t.disabled)&&(t.disabled=!!t.disabled);const r={node:e,index:-1,...t};this.descendants.set(e,r),this.assignIndex(n)}))}};var[zK,WK]=xr({name:"DescendantsProvider",errorMessage:"useDescendantsContext must be used within DescendantsProvider"});function VK(){return[HK(zK),()=>HK(WK()),()=>function(){const e=(0,i.useRef)(new UK);return $K((()=>()=>e.current.destroy())),e.current}(),e=>function(e){const t=WK(),[n,r]=(0,i.useState)(-1),o=(0,i.useRef)(null);$K((()=>()=>{o.current&&t.unregister(o.current)}),[]),$K((()=>{if(!o.current)return;const e=Number(o.current.dataset.index);n==e||Number.isNaN(e)||r(e)}));const a=HK(e?t.register(e):t.register);return{descendants:t,index:n,enabledIndex:t.enabledIndexOf(o.current),register:Ur(a,o)}}(e)]}var[GK,QK]=xr({name:"AccordionStylesContext",hookName:"useAccordionStyles",providerName:"<Accordion />"}),[qK,KK]=xr({name:"AccordionItemContext",hookName:"useAccordionItemContext",providerName:"<AccordionItem />"}),[ZK,JK,XK,eZ]=VK(),tZ=yr((function(e,t){const{getButtonProps:n}=KK(),r=n(e,t),o={display:"flex",alignItems:"center",width:"100%",outline:0,...QK().button};return(0,br.jsx)(vr.button,{...r,className:g("chakra-accordion__button",e.className),__css:o})}));function nZ(e){const{onChange:t,defaultIndex:n,index:r,allowMultiple:o,allowToggle:a,...s}=e;!function(e){const t=e.index||e.defaultIndex,n=null!=t&&!Array.isArray(t)&&e.allowMultiple;y({condition:!!n,message:`If 'allowMultiple' is passed, then 'index' or 'defaultIndex' must be an array. You passed: ${typeof t},`})}(e),function(e){y({condition:!(!e.allowMultiple||!e.allowToggle),message:"If 'allowMultiple' is passed, 'allowToggle' will be ignored. Either remove 'allowToggle' or 'allowMultiple' depending on whether you want multiple accordions visible or not"})}(e);const l=XK(),[c,u]=(0,i.useState)(-1);(0,i.useEffect)((()=>()=>{u(-1)}),[]);const[d,p]=bM({value:r,defaultValue:()=>o?null!=n?n:[]:null!=n?n:-1,onChange:t});return{index:d,setIndex:p,htmlProps:s,getAccordionItemProps:e=>{let t=!1;null!==e&&(t=Array.isArray(d)?d.includes(e):d===e);return{isOpen:t,onChange:t=>{if(null!==e)if(o&&Array.isArray(d)){const n=t?d.concat(e):d.filter((t=>t!==e));p(n)}else t?p(e):a&&p(-1)}}},focusedIndex:c,setFocusedIndex:u,descendants:l}}tZ.displayName="AccordionButton";var[rZ,oZ]=xr({name:"AccordionContext",hookName:"useAccordionContext",providerName:"Accordion"});function iZ(e){const{isDisabled:t,isFocusable:n,id:r,...o}=e,{getAccordionItemProps:a,setFocusedIndex:s}=oZ(),l=(0,i.useRef)(null),c=(0,i.useId)(),u=null!=r?r:c,d=`accordion-button-${u}`,p=`accordion-panel-${u}`;!function(e){y({condition:!(!e.isFocusable||e.isDisabled),message:"Using only 'isFocusable', this prop is reserved for situations where you pass 'isDisabled' but you still want the element to receive focus (A11y). Either remove it or pass 'isDisabled' as well.\n    "})}(e);const{register:f,index:h,descendants:m}=eZ({disabled:t&&!n}),{isOpen:g,onChange:v}=a(-1===h?null:h);!function(e){y({condition:e.isOpen&&!!e.isDisabled,message:"Cannot open a disabled accordion item"})}({isOpen:g,isDisabled:t});const b=(0,i.useCallback)((()=>{null==v||v(!g),s(h)}),[h,s,g,v]),_=(0,i.useCallback)((e=>{const t={ArrowDown:()=>{const e=m.nextEnabled(h);null==e||e.node.focus()},ArrowUp:()=>{const e=m.prevEnabled(h);null==e||e.node.focus()},Home:()=>{const e=m.firstEnabled();null==e||e.node.focus()},End:()=>{const e=m.lastEnabled();null==e||e.node.focus()}},n=t[e.key];n&&(e.preventDefault(),n(e))}),[m,h]),A=(0,i.useCallback)((()=>{s(h)}),[s,h]),E=(0,i.useCallback)((function(e={},n=null){return{...e,type:"button",ref:Ur(f,l,n),id:d,disabled:!!t,"aria-expanded":!!g,"aria-controls":p,onClick:w(e.onClick,b),onFocus:w(e.onFocus,A),onKeyDown:w(e.onKeyDown,_)}}),[d,t,g,b,A,_,p,f]),x=(0,i.useCallback)((function(e={},t=null){return{...e,ref:t,role:"region",id:p,"aria-labelledby":d,hidden:!g}}),[d,g,p]);return{isOpen:g,isDisabled:t,isFocusable:n,onOpen:()=>{null==v||v(!0)},onClose:()=>{null==v||v(!1)},getButtonProps:E,getPanelProps:x,htmlProps:o}}function aZ(e){const{isOpen:t,isDisabled:n}=KK(),{reduceMotion:r}=oZ(),o=g("chakra-accordion__icon",e.className),i={opacity:n?.4:1,transform:t?"rotate(-180deg)":void 0,transition:r?void 0:"transform 0.2s",transformOrigin:"center",...QK().icon};return(0,br.jsx)(Jk,{viewBox:"0 0 24 24","aria-hidden":!0,className:o,__css:i,...e,children:(0,br.jsx)("path",{fill:"currentColor",d:"M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"})})}aZ.displayName="AccordionIcon";var sZ=yr((function(e,t){const{children:n,className:r}=e,{htmlProps:o,...a}=iZ(e),s={...QK().container,overflowAnchor:"none"},l=(0,i.useMemo)((()=>a),[a]);return(0,br.jsx)(qK,{value:l,children:(0,br.jsx)(vr.div,{ref:t,...o,className:g("chakra-accordion__item",r),__css:s,children:"function"==typeof n?n({isExpanded:!!a.isOpen,isDisabled:!!a.isDisabled}):n})})}));sZ.displayName="AccordionItem";var lZ={exit:{height:{duration:.2,ease:uB.ease},opacity:{duration:.3,ease:uB.ease}},enter:{height:{duration:.3,ease:uB.ease},opacity:{duration:.4,ease:uB.ease}}},cZ={exit:({animateOpacity:e,startingHeight:t,transition:n,transitionEnd:r,delay:o})=>{var i,a;return{...e&&{opacity:(a=t,null!=a&&parseInt(a.toString(),10)>0?1:0)},height:t,transitionEnd:null==r?void 0:r.exit,transition:null!=(i=null==n?void 0:n.exit)?i:yB(lZ.exit,o)}},enter:({animateOpacity:e,endingHeight:t,transition:n,transitionEnd:r,delay:o})=>{var i;return{...e&&{opacity:1},height:t,transitionEnd:null==r?void 0:r.enter,transition:null!=(i=null==n?void 0:n.enter)?i:vB(lZ.enter,o)}}},uZ=(0,i.forwardRef)(((e,t)=>{const{in:n,unmountOnExit:r,animateOpacity:o=!0,startingHeight:a=0,endingHeight:s="auto",style:l,className:c,transition:u,transitionEnd:d,...p}=e,[f,h]=(0,i.useState)(!1);(0,i.useEffect)((()=>{const e=setTimeout((()=>{h(!0)}));return()=>clearTimeout(e)}),[]),y({condition:Number(a)>0&&!!r,message:"startingHeight and unmountOnExit are mutually exclusive. You can't use them together"});const m=parseFloat(a.toString())>0,v={startingHeight:a,endingHeight:s,animateOpacity:o,transition:f?u:{enter:{duration:0}},transitionEnd:{enter:null==d?void 0:d.enter,exit:r?null==d?void 0:d.exit:{...null==d?void 0:d.exit,display:m?"block":"none"}}},b=!r||n,_=n||r?"enter":"exit";return(0,br.jsx)(qw,{initial:!1,custom:v,children:b&&(0,br.jsx)(Yw.div,{ref:t,...p,className:g("chakra-collapse",c),style:{overflow:"hidden",display:"block",...l},custom:v,variants:cZ,initial:!!r&&"exit",animate:_,exit:"exit"})})}));uZ.displayName="Collapse";var dZ=yr((function(e,t){const{className:n,motionProps:r,...o}=e,{reduceMotion:i}=oZ(),{getPanelProps:a,isOpen:s}=KK(),l=a(o,t),c=g("chakra-accordion__panel",n),u=QK();i||delete l.hidden;const d=(0,br.jsx)(vr.div,{...l,__css:u.panel,className:c});return i?d:(0,br.jsx)(uZ,{in:s,...r,children:d})}));dZ.displayName="AccordionPanel";var pZ=yr((function({children:e,reduceMotion:t,...n},r){const o=jr("Accordion",n),a=pt(n),{htmlProps:s,descendants:l,...c}=nZ(a),u=(0,i.useMemo)((()=>({...c,reduceMotion:!!t})),[c,t]);return(0,br.jsx)(ZK,{value:l,children:(0,br.jsx)(rZ,{value:u,children:(0,br.jsx)(GK,{value:o,children:(0,br.jsx)(vr.div,{ref:r,...s,className:g("chakra-accordion",n.className),__css:o.root,children:e})})})})}));pZ.displayName="Accordion";var fZ=["content"];function hZ(){return hZ=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},hZ.apply(null,arguments)}var mZ=pr(tZ,{target:"ennaxme3"})((e=>{var{theme:t}=e;return"\n        color: "+t.colors.navy[400]+";\n\n        &:focus {\n            box-shadow: none;\n        }\n\n        &:hover {\n            background-color: transparent;\n        }\n    "}),""),gZ=pr(aZ,{target:"ennaxme2"})((e=>{var{theme:t}=e;return"\n        color: "+t.colors.blue[400]+";\n        height: 24px;\n        width: 24px;\n    "}),""),vZ=pr(sZ,{target:"ennaxme1"})((e=>{var{theme:t}=e;return"\n        border-color: "+t.colors.gray[200]+";\n\n        button {\n            font-size: "+t.fontSizes.lg+";\n            font-weight: "+t.fontWeights.normal+";\n            padding: 14px 0;\n        }\n    "}),""),yZ=pr(dZ,{target:"ennaxme0"})({name:"1hcx8jb",styles:"padding:0"});const bZ=e=>{var{content:t}=e,n=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,fZ);return Mr(pZ,hZ({allowMultiple:!0,allowToggle:!0,"data-testid":"sp-ui-accordion"},n),t&&t.map(((e,t)=>Mr(vZ,{key:t},Mr(mZ,null,Mr(_r,{flex:"1",textAlign:"left","data-testid":"accordion-header-"+t},e.title,e.subtitle),Mr(gZ,null)),Mr(yZ,{"data-testid":"accordion-panel-"+t},e.panel)))))};var _Z,AZ=fr(fp)((function(e){return"\n        border: 1px solid "+e.theme.colors.gray[200]+";\n        border-radius: 2px;\n        font-weight: 700;\n        height: 42px;\n        width: 100px;\n    "})),EZ="yearly",wZ=fr(wr)((function(e){return"\n        flex-direction: column;\n        gap: 10px 0;\n        padding-bottom: 10px;\n\n        hr {\n            border-top: 1px solid "+e.theme.colors.gray[200]+";\n            margin: 0;\n        }\n    "})),xZ=fr(bZ)((function(e){return"\n        div {\n            border: none;\n        }\n\n        .chakra-accordion__button {\n            background: transparent;\n            font-size: "+e.theme.fontSizes.md+";\n            padding: 0;\n        }\n    "})),kZ=fr(fx)((function(e){return"\n        color:  "+e.theme.colors.gray[700]+";\n        font-weight: 400;\n    "})),CZ=fr(Pz)((function(){return"\n        height: 40px !important;\n    "})),SZ=fr(_r)((function(e){return"\n        color: "+e.theme.colors.red[400]+";\n        margin-top: 5px;\n    "})),MZ=fr(wx)((function(e){return"\n        color: "+e.theme.colors.navy[700]+";\n    "})),TZ=fr(LK)((function(e){return"\n        background-color: "+e.theme.colors.blue[500]+";\n        color: white;\n        margin: 10px 0 10px 0;\n        width: fit-content;\n    "})),OZ=fr(kZ)((function(e){return"\n        color:  "+e.theme.colors.gray[500]+";\n    "})),DZ=fr(wr)(_Z||(_Z=zM(["\n    justify-content: space-between;\n"]))),LZ=fr(xF)((function(e){return"\n        color: "+e.theme.colors.navy[700]+";\n        margin: 0;\n        padding: 20px 0 0;\n "})),PZ=fr(BK)((function(){return"\n        background: transparent;\n        border: none;\n        color: inherit;\n        padding: 0;\n    "})),IZ=fr(UI)((function(e){return"\n        color:  "+e.theme.colors.gray[700]+";\n        font-weight: 600;\n        margin: 0;\n    "})),BZ=fr(kZ)((function(e){return"\n        font-size: "+e.theme.fontSizes.lg+";\n    "}));const RZ=function(e){var t,n=e.annualizedMonthlyPrice,r=e.billingFrequency,o=e.currencyCode,a=e.isPayingNow,s=void 0!==a&&a,l=e.promo,c=e.promoError,u=e.planName,d=e.planPrice,p=e.onApplyPromo,f=e.showPromo,h=void 0===f||f,g=e.taxData,v=e.onChangePlan,y=m((0,i.useState)((null==l?void 0:l.code)||""),2),b=y[0],_=y[1],A=r===EZ?"yr":"mo",E=m((0,i.useState)(!1),2),w=E[0],x=E[1],k=r===EZ?n:d,C=c?void 0:l,S=null!=C&&C.duration?" ("+C.duration+" "+A+(C.duration>1?"s":"")+")":"",M=void 0!==g&&g.amountToCollect>0,T=C&&null!=g&&g.amountToCollect?C.discountedPrice+(null==g?void 0:g.amountToCollect):C?C.discountedPrice:d&&null!=g&&g.amountToCollect?d+(null==g?void 0:g.amountToCollect):d,O=Co("studio.plan.orderSummary"),D=function(e){return e.toLocaleString("en-US",{style:"currency",currency:o})},L=i.createElement(_r,{paddingLeft:"10px"},k&&k!==d?i.createElement(DZ,null,i.createElement(kZ,null,O("annualSavings")),i.createElement(kZ,null,D(d-k)+"/"+A)):void 0,C&&i.createElement(DZ,null,i.createElement(kZ,null,O("discount")+"  ("+C.code+")"),i.createElement(kZ,null,""+D(C.discountedPrice-d)+S)));return(0,i.useEffect)((function(){C&&x(!0)}),[C]),i.createElement(wZ,{flexDir:"column"},h&&i.createElement(wr,{flexDirection:"column",width:"100%"},i.createElement(MZ,{"data-testid":"promo-code-label",htmlFor:"promo",marginBottom:"1px"},O("promoCodeLabel")),w&&C?i.createElement(TZ,{size:"lg"},i.createElement(PK,{"data-testid":"promo-code-tag-label",fontWeight:700},C.code),i.createElement(PZ,{className:"chakra-tagbutton",opacity:"1",onClick:function(){p&&p(""),_(""),x(!1)}})):i.createElement(wr,{alignItems:"center",gap:"8px"},i.createElement(CZ,{"data-testid":"promo-code-form-element",defaultValue:null==l?void 0:l.code,id:"promo",name:"promo",onChange:function(e){_(e.target.value)},showValidationIcons:!1,value:b}),i.createElement(AZ,{"data-testid":"promo-code-apply",onClick:function(){p&&p(b),x(!0)},variant:sp.Tertiary},O("apply"))),c&&i.createElement(SZ,{"data-testid":"promo-code-error-label"},c)),i.createElement(wr,{justifyContent:"space-between",alignItems:"flex-end"},i.createElement(LZ,{"data-testid":"order-total-label"},O(s?"orderTotalLabel":"subscriptionSummary"))),i.createElement(DZ,null,i.createElement(wr,{alignItems:"center",gap:"8px"},i.createElement(kZ,{"data-testid":"plan-name-label"},u),v&&i.createElement(Sx,{"data-testid":"change-plan-link",onClick:v},O("changePlanLink"))),i.createElement(kZ,{"data-testid":"plan-price-label"},D(k||d)+"/"+A)),C||k&&k!==d?i.createElement(xZ,{content:[{title:"",subtitle:i.createElement(DZ,null,i.createElement(kZ,{"data-testid":"total-discount-label",fontSize:"16px"},O("totalDiscount")),i.createElement(kZ,{"data-testid":"total-discount-amount-label"},Math.round(100*(1-(null!==(t=null==C?void 0:C.discountedPrice)&&void 0!==t?t:d)/(null!=k?k:d)))+"% off")),panel:L}]}):void 0,M&&i.createElement(DZ,null,i.createElement(kZ,{"data-testid":"sales-tax-label"},O("salesTax")+" ("+parseFloat((100*(null==g?void 0:g.rate)).toFixed(3))+"%)"),i.createElement(kZ,{"data-testid":"sales-tax-amount"},""+D(null==g?void 0:g.amountToCollect))),i.createElement("hr",null),i.createElement(DZ,{alignItems:"center"},i.createElement(IZ,{"data-testid":"total-line-label"},O(s?"total":"subscriptionAmount")),i.createElement(BZ,{"data-testid":"total-line-amount-label"},D(T))),C&&C.endDate&&i.createElement(_r,{paddingLeft:"10px"},i.createElement(OZ,{"data-testid":"billing-timeline-label"},O("normalBillingStart")+" "+D(d)+"/"+A+" "+O("plusApplicableTaxes")+" "+O("normalBillingBeginsOn")+" "+new Date(Date.parse(C.endDate)).toLocaleDateString())))};var NZ,FZ,jZ=fr(wr)(NZ||(NZ=zM(["\n    flex-direction: column;\n    font-weight: 600;\n    margin-bottom: 44px;\n\n    label.chakra-radio {\n        align-items: flex-start;\n        width: 100%;\n    }\n\n    .chakra-radio span {\n        margin-top: 6px;\n    }\n\n    span.chakra-radio__label {\n        margin-top: 0;\n        width: 100%;\n    }\n\n    .chakra-radio__label .chakra-text {\n        margin-top: 0;\n    }\n\n    .chakra-stack > div:nth-of-type(2) {\n        padding-top: 20px;\n\n        span {\n            margin-top: 0;\n        }\n\n        h3 {\n            margin-top: 5px;\n        }\n    }\n"]))),YZ=fr(Yx)(FZ||(FZ=zM(["\n    margin: 0;\n"]))),$Z=fr(_r)((function(e){var t=e.theme;return"\n        background: "+t.colors.blue[100]+";\n        border-radius: 26px;\n        padding: 2px 12px;\n\n        span {\n            font-size: 14px;\n            line-height: 24px;\n            color: "+t.colors.navy[700]+";\n        }\n    "})),HZ=fr(wr)((function(e){return"\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 6px;\n\n        span {\n            margin: 0;\n            font-size: 12px;\n            line-height: 15px;\n            text-transform: uppercase;\n            color: "+e.theme.colors.gray[700]+";\n        }\n    "})),UZ=fr(wr)((function(e){return"\n        flex-direction: column;\n        width: 100%;\n\n        h3 {\n            margin: 0;\n            line-height: 18px;\n            letter-spacing: normal;\n        }\n\n        h3, span {\n            color: "+e.theme.colors.navy[700]+";\n        }\n\n        span {\n            letter-spacing: normal;\n        }\n    "})),zZ=function(e){var t=e.description,n=e.discount,r=e.isMonthly,o=e.price,a=Co("studio.plan.trialCheckout.payScreen.billingPeriod");return i.createElement(UZ,{"data-testid":"checkout-billing-period-"+(r?"monthly":"annually")},i.createElement(HZ,null,i.createElement(fx,{"data-testid":"checkout-billing-period-description"},t),n&&i.createElement($Z,null,i.createElement(fx,{"data-testid":"checkout-billing-period-discount"},n+"% "+a("off")))),i.createElement(xF,{"data-testid":"checkout-billing-period-price"},o,"/"+a(r?"month":"year")))},WZ=function(e){var t=e.annualPrice,n=e.disableOptions,r=void 0!==n&&n,o=e.currencyCode,a=e.monthlyPrice,s=e.sameBandPlanId,l=m(II("billingPeriod"),3),c=l[0].value,u=l[2].setValue,d=m(II("planUuid"),3)[2].setValue,p=Co("studio.plan.trialCheckout.payScreen.billingPeriod"),f=function(e){return e.toLocaleString("en-US",{style:"currency",currency:o})};return i.createElement(i.Fragment,null,i.createElement(gQ,{margin:"0 0 20px"},p("heading")),i.createElement(jZ,null,i.createElement(YZ,{name:"billingPeriod",radioOptions:[{description:i.createElement(zZ,{description:p("annual"),discount:VZ(t,a),price:f(t)}),isDisabled:r,value:"yearly"},{description:i.createElement(zZ,{description:p("monthly"),isMonthly:!0,price:f(a)}),isDisabled:r,value:"monthly"}],onChange:function(e,t){u(t.value),d(s)},value:c,variant:Bx.Bordered})))},VZ=function(e,t){if(e&&t)return Math.round(100*(12*t-e)/(12*t)).toString()};const GZ=(0,i.memo)(WZ);var QZ=yr((function(e,t){const{children:n,placeholder:r,className:o,...i}=e;return(0,br.jsxs)(vr.select,{...i,ref:t,className:g("chakra-select",o),children:[r&&(0,br.jsx)("option",{value:"",children:r}),n]})}));QZ.displayName="SelectField";var qZ=yr(((e,t)=>{var n;const r=jr("Select",e),{rootProps:o,placeholder:i,icon:a,color:s,height:l,h:c,minH:u,minHeight:d,iconColor:p,iconSize:f,...h}=pt(e),[m,g]=function(e,t){const n={},r={};for(const[o,i]of Object.entries(e))t.includes(o)?n[o]=i:r[o]=i;return[n,r]}(h,tt),v=Gx(g),y={width:"100%",height:"fit-content",position:"relative",color:s},b={paddingEnd:"2rem",...r.field,_focus:{zIndex:"unset",...null==(n=r.field)?void 0:n._focus}};return(0,br.jsxs)(vr.div,{className:"chakra-select__wrapper",__css:y,...m,...o,children:[(0,br.jsx)(QZ,{ref:t,height:null!=c?c:l,minH:null!=u?u:d,placeholder:i,...v,__css:b,children:e.children}),(0,br.jsx)(JZ,{"data-disabled":A(v.disabled),...(p||s)&&{color:p||s},__css:r.icon,...f&&{fontSize:f},children:a})]})}));qZ.displayName="Select";var KZ=e=>(0,br.jsx)("svg",{viewBox:"0 0 24 24",...e,children:(0,br.jsx)("path",{fill:"currentColor",d:"M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"})}),ZZ=vr("div",{baseStyle:{position:"absolute",display:"inline-flex",alignItems:"center",justifyContent:"center",pointerEvents:"none",top:"50%",transform:"translateY(-50%)"}}),JZ=e=>{const{children:t=(0,br.jsx)(KZ,{}),...n}=e,r=(0,i.cloneElement)(t,{role:"presentation",className:"chakra-select__icon",focusable:!1,"aria-hidden":!0,style:{width:"1em",height:"1em",color:"currentColor"}});return(0,br.jsx)(ZZ,{...n,className:"chakra-select__icon-wrapper",children:(0,i.isValidElement)(t)?r:null})};JZ.displayName="SelectIcon";var[XZ,eJ]=xr({name:"FormErrorStylesContext",errorMessage:"useFormErrorStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<FormError />\" "}),tJ=yr(((e,t)=>{const n=jr("FormError",e),r=pt(e),o=Sp();return(null==o?void 0:o.isInvalid)?(0,br.jsx)(XZ,{value:n,children:(0,br.jsx)(vr.div,{...null==o?void 0:o.getErrorMessageProps(r,t),className:g("chakra-form__error-message",e.className),__css:{display:"flex",alignItems:"center",...n.text}})}):null}));tJ.displayName="FormErrorMessage";var nJ=yr(((e,t)=>{const n=eJ(),r=Sp();if(!(null==r?void 0:r.isInvalid))return null;const o=g("chakra-form__error-icon",e.className);return(0,br.jsx)(Jk,{ref:t,"aria-hidden":!0,...e,__css:n.icon,className:o,children:(0,br.jsx)("path",{fill:"currentColor",d:"M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"})})}));nJ.displayName="FormErrorIcon";var rJ=o(78128),oJ=o.n(rJ),iJ=[{stateProvince:"AL",name:"Alabama"},{stateProvince:"AK",name:"Alaska"},{stateProvince:"AS",name:"American Samoa"},{stateProvince:"AZ",name:"Arizona"},{stateProvince:"AR",name:"Arkansas"},{stateProvince:"AA",name:"Armed Forces - Americas"},{stateProvince:"AE",name:"Armed Forces - Europe"},{stateProvince:"AP",name:"Armed Forces - Pacific"},{stateProvince:"CA",name:"California"},{stateProvince:"CO",name:"Colorado"},{stateProvince:"CT",name:"Connecticut"},{stateProvince:"DE",name:"Delaware"},{stateProvince:"DC",name:"District of Columbia"},{stateProvince:"FM",name:"Federated States of Micronesia"},{stateProvince:"FL",name:"Florida"},{stateProvince:"GA",name:"Georgia"},{stateProvince:"GU",name:"Guam"},{stateProvince:"HI",name:"Hawaii"},{stateProvince:"ID",name:"Idaho"},{stateProvince:"IL",name:"Illinois"},{stateProvince:"IN",name:"Indiana"},{stateProvince:"IA",name:"Iowa"},{stateProvince:"KS",name:"Kansas"},{stateProvince:"KY",name:"Kentucky"},{stateProvince:"LA",name:"Louisiana"},{stateProvince:"ME",name:"Maine"},{stateProvince:"MH",name:"Marshall Islands"},{stateProvince:"MD",name:"Maryland"},{stateProvince:"MA",name:"Massachusetts"},{stateProvince:"MI",name:"Michigan"},{stateProvince:"MN",name:"Minnesota"},{stateProvince:"MS",name:"Mississippi"},{stateProvince:"MO",name:"Missouri"},{stateProvince:"MT",name:"Montana"},{stateProvince:"NE",name:"Nebraska"},{stateProvince:"NV",name:"Nevada"},{stateProvince:"NH",name:"New Hampshire"},{stateProvince:"NJ",name:"New Jersey"},{stateProvince:"NM",name:"New Mexico"},{stateProvince:"NY",name:"New York"},{stateProvince:"NC",name:"North Carolina"},{stateProvince:"ND",name:"North Dakota"},{stateProvince:"MP",name:"Northern Mariana Islands"},{stateProvince:"OH",name:"Ohio"},{stateProvince:"OK",name:"Oklahoma"},{stateProvince:"OR",name:"Oregon"},{stateProvince:"PW",name:"Palau"},{stateProvince:"PA",name:"Pennsylvania"},{stateProvince:"PR",name:"Puerto Rico"},{stateProvince:"RI",name:"Rhode Island"},{stateProvince:"SC",name:"South Carolina"},{stateProvince:"SD",name:"South Dakota"},{stateProvince:"TN",name:"Tennessee"},{stateProvince:"TX",name:"Texas"},{stateProvince:"UT",name:"Utah"},{stateProvince:"VT",name:"Vermont"},{stateProvince:"VI",name:"Virgin Islands"},{stateProvince:"VA",name:"Virginia"},{stateProvince:"WA",name:"Washington"},{stateProvince:"WV",name:"West Virginia"},{stateProvince:"WI",name:"Wisconsin"},{stateProvince:"WY",name:"Wyoming"}],aJ=function(e){return e.Active="active",e.Checked="checked",e.Default="default",e.Disabled="disabled",e.Focus="focus",e.Hover="hover",e.Invalid="invalid",e.Loaded="loaded",e.Loading="loading",e.Selected="selected",e.Valid="valid",e}({}),sJ={primary:{100:"#DBEFFF",200:"#A0CEE9",300:"#4193C1",400:"#0C547D",500:"#0E446D",600:"#002B4C",700:"#00213B"},secondary:{100:"#DAF7FF",200:"#C2F0FF",300:"#ACEBFF",400:"#4FBEE3",500:"#19A0CC",600:"#1E82A2",700:"#0A627D"},success:{100:"#DCFAEC",200:"#84F1BE",300:"#21CF7E",400:"#0B8C50",500:"#077F47",600:"#046437",700:"#085E36"},warning:{100:"#FAEBD1",200:"#FDD269",300:"#FCBE37",400:"#F2A830",500:"#CA7E03",600:"#985F02",700:"#7A4006"},error:{100:"#FCE6E3",200:"#FFB6B9",300:"#FF8389",400:"#C01D0E",500:"#B01304",600:"#9A0E00",700:"#8C1207"},neutral:{100:"#F6F8F8",200:"#EDF1F3",300:"#BCC8CD",400:"#8298A1",500:"#607780",600:"#344146",700:"#141617"},blue:{100:"#D3EFF8",200:"#A7DFF1",300:"#7BCEEA",400:"#49BDE4",500:"#23AEDC",600:"#1C8BB0",700:"#156884"},navy:{100:"#69ACC3",200:"#4797B2",300:"#1280BE",400:"#2A5969",500:"#1B3A45",600:"#002B4C",700:"#00213B"},green:{100:"#CFEACF",200:"#ACDAAC",300:"#89CA89",400:"#66BA66",500:"#4AA34A",600:"#3A803A",700:"#2A5D2A"},orange:{100:"#FDE19C",200:"#FDD269",300:"#FCC337",400:"#FBB405",500:"#CA9003",600:"#986D02",700:"#654902"},red:{100:"#FFE9EA",200:"#FFB6B9",300:"#FF8389",400:"#FF5058",500:"#C01D0E",600:"#E9000B",700:"#B60008"},gray:{100:"#F6F8F9",200:"#D9E0E3",300:"#BCC8CD",400:"#9FB0B7",500:"#8298A1",600:"#677F89",700:"#51646C"}},lJ=n({},sJ,{accent:{sky:sJ.secondary[100],spblue:sJ.secondary[400],spbluedarker:sJ.secondary[500],normalnavy:sJ.primary[400],darknavy:sJ.primary[600],smokegrey:sJ.neutral[100],sandstone:sJ.warning[100],goldenapricot:"#F6B57C",warmhoney:sJ.warning[400],lavender:"#E5EAFD",indigoslate:"#505C8A",softblush:sJ.error[100],coral:"#F09578",clayrust:"#C25C47",moss:"#B2E2A1",fern:"#7AA17A"},boxShadow:"0 4px 16px rgba(159, 176, 183, 0.3)"});const cJ={body:"azo-sans-web, Helvetica, Arial, sans-serif",heading:"azo-sans-web, Helvetica, Arial, sans-serif",mono:"azo-sans-web, Helvetica, Arial, sans-serif"};var uJ=ct(Si.keys),dJ=uJ.definePartsStyle,pJ=function(e){return dJ({container:{border:"none",borderTopWidth:0,borderBottomWidth:0,borderLeftWidth:0,borderRightWidth:0},button:{paddingX:0,paddingY:1,borderBottomWidth:"2px",borderBottomStyle:"solid",borderBottomColor:"accent."+e,paddingBottom:1},panel:{paddingX:0}})},fJ=(0,uJ.defineMultiStyleConfig)({baseStyle:dJ({container:{border:"none",borderTopWidth:0,borderBottomWidth:0,borderLeftWidth:0,borderRightWidth:0},button:{color:"neutral.700",fontSize:"sm",fontWeight:"semibold",textTransform:"uppercase",border:"none",_hover:{background:"transparent"}}}),variants:{spblue:pJ("spblue"),normalnavy:pJ("normalnavy"),darknavy:pJ("darknavy"),sandstone:pJ("sandstone"),goldenapricot:pJ("goldenapricot"),warmhoney:pJ("warmhoney"),softblush:pJ("softblush"),coral:pJ("coral"),clayrust:pJ("clayrust"),smokegrey:pJ("smokegrey"),lavender:pJ("lavender"),indigoslate:pJ("indigoslate"),moss:pJ("moss"),fern:pJ("fern")}}),hJ=ct(Mi.keys),mJ=hJ.definePartsStyle,gJ=(0,hJ.defineMultiStyleConfig)({baseStyle:mJ({container:{borderRadius:"4px",borderStyle:"solid",fontSize:"sm",padding:"12px",gap:"8px"},title:{fontWeight:"semibold",marginBottom:"4px",fontSize:"md"},description:{fontSize:"sm",lineHeight:"1.5"},icon:{width:"20px",height:"20px",flexShrink:0}}),variants:{info:mJ({container:{background:"secondary.100",color:"secondary.700",borderWidth:"1px",borderColor:"secondary.300",borderInlineStartWidth:"4px",borderInlineStartColor:"secondary.300"},icon:{color:"secondary.700"}}),success:mJ({container:{background:"success.100",color:"success.700",borderWidth:"1px",borderColor:"success.300",borderInlineStartWidth:"4px",borderInlineStartColor:"success.300"},icon:{color:"success.700"}}),warning:mJ({container:{background:"warning.100",color:"warning.700",borderWidth:"1px",borderColor:"warning.700",borderInlineStartWidth:"4px",borderInlineStartColor:"warning.700"},icon:{color:"warning.700"}}),error:mJ({container:{background:"error.100",color:"error.700",borderWidth:"1px",borderColor:"error.300",borderInlineStartWidth:"4px",borderInlineStartColor:"error.300"},icon:{color:"error.700"}}),neutral:mJ({container:{background:"neutral.100",color:"neutral.700",borderWidth:"1px",borderColor:"neutral.300",borderInlineStartWidth:"4px",borderInlineStartColor:"neutral.300"},icon:{color:"neutral.700"}})},defaultProps:{variant:"info"}}),vJ={baseStyle:{width:"auto",borderRadius:"8px"},variants:{primary:{backgroundColor:"primary.400",borderColor:"primary.400",color:"white",fontSize:"12px",_hover:{backgroundColor:"primary.500",borderColor:"primary.500",_disabled:{backgroundColor:"primary.500"}}},outline:{backgroundColor:"transparent",borderColor:"primary.400",borderWidth:"1px",color:"primary.400",fontSize:"12px",_hover:{backgroundColor:"neutral.200"}},secondary:{backgroundColor:"transparent",color:"primary.400",fontSize:"12px",_hover:{backgroundColor:"neutral.200"}},destructive:{backgroundColor:"error.400",color:"white",fontSize:"12px",_hover:{backgroundColor:"error.600",_disabled:{backgroundColor:"error.600"}}},ghost:{backgroundColor:"transparent",fontSize:"12px",_hover:{backgroundColor:"neutral.100"}},iconPagination:{color:"neutral.300",height:"20px",minWidth:"unset",padding:0,width:"20px","&.left":{transform:"rotate(180deg)"},"& > svg":{height:"20px",width:"20px"}}}},yJ=ct(Ri.keys),bJ=yJ.definePartsStyle,_J=(0,yJ.defineMultiStyleConfig)({baseStyle:bJ({fontFamily:cJ.heading,field:{fontSize:"16px",color:"neutral.600"},element:{fontSize:"1.2rem",color:"gray.500"}}),variants:{withAddon:bJ({addon:{background:"gray.600",backgroundColor:"gray.600",border:"1px solid",borderColor:"gray.600",borderRadius:"4px",color:"white",fontSize:"16px",height:"inherit",paddingLeft:"10px",paddingRight:"10px"},field:{border:"1px solid",borderColor:"gray.600"}})}}),AJ=ct(Ui.keys),EJ=AJ.definePartsStyle,wJ=(0,AJ.defineMultiStyleConfig)({baseStyle:EJ({control:{color:"primary.400",_checked:{color:"white",borderColor:"primary.400",bg:"primary.400",_hover:{bg:"primary.500",borderColor:"primary.500"}}}})}),xJ=ct(Ji.keys),kJ=xJ.definePartsStyle,CJ=(0,xJ.defineMultiStyleConfig)({baseStyle:kJ({indicator:{'&[data-status="active"]':{borderColor:"primary.400"},'&[data-status="complete"]':{background:"primary.400",borderColor:"primary.400"}},separator:{'&[data-status="complete"]':{background:"primary.400"}}})}),SJ=ct(Gi.keys),MJ=SJ.definePartsStyle,TJ=(0,SJ.defineMultiStyleConfig)({baseStyle:MJ({track:{_checked:{bg:"primary.400"}}})}),OJ=ct(Qi.keys),DJ=OJ.definePartsStyle,LJ=(0,OJ.defineMultiStyleConfig)({baseStyle:DJ({thead:{background:"neutral.200",tr:{"th:first-of-type":{borderTopLeftRadius:"4px"},"th:last-of-type":{borderTopRightRadius:"4px"},th:{color:"neutral.600",fontSize:"14px",paddingY:"18px"}}},tbody:{color:"neutral.600",tr:{_hover:{backgroundColor:"neutral.100"}}}}),variants:{noHover:DJ({tbody:{tr:{_hover:{backgroundColor:"neutral.200"}}}})}}),PJ=ct(Ki.keys),IJ=PJ.definePartsStyle,BJ=(0,PJ.defineMultiStyleConfig)({baseStyle:IJ({container:{fontWeight:"medium",borderRadius:"full",textTransform:"capitalize",verticalAlign:"middle"}}),variants:{status:IJ({container:{fontWeight:"medium",borderRadius:"full",textTransform:"capitalize",px:3,py:1}}),outline:IJ({container:{textTransform:"uppercase"}})},sizes:{xs:IJ({container:{px:1.5,py:1,fontSize:"10px"}}),sm:IJ({container:{px:1.5,py:.5,fontSize:"xs"}}),md:IJ({container:{px:2,py:1,fontSize:"sm"}})}});var RJ="#1280BE",NJ="#0C547D",FJ="768",jJ="1200",YJ="1900",$J={extraLargeScreenOnly:function(e){return"\n  @media only screen and (min-width: "+(Number(YJ)+1)+"px) {\n      "+e+"\n  }\n"},largeScreenDown:function(e){return"\n  @media only screen and (max-width: "+YJ+"px) {\n      "+e+"\n  }\n"},largeScreenOnly:function(e){return"\n  @media only screen and (min-width: "+(Number(jJ)+1)+"px) and (max-width: "+YJ+"px) {\n      "+e+"\n  }\n"},largeScreenUp:function(e){return"\n  @media only screen and (min-width: "+(Number(jJ)+1)+"px) {\n      "+e+"\n  }\n"},mediumScreenDown:function(e){return"\n  @media only screen and (max-width: "+jJ+"px) {\n      "+e+"\n  }\n"},mediumScreenOnly:function(e){return"\n  @media only screen and (min-width: "+(Number(FJ)+1)+"px) and (max-width: "+jJ+"px) {\n      "+e+"\n  }\n"},mediumScreenUp:function(e){return"\n  @media only screen and (min-width: "+(Number(FJ)+1)+"px) {\n      "+e+"\n  }\n"},smallScreenOnly:function(e){return"\n  @media only screen and (max-width: "+FJ+"px) {\n      "+e+"\n  }\n"}},HJ={Accordion:fJ,Alert:gJ,Button:vJ,Checkbox:{baseStyle:{control:{backgroundColor:"white"}},customStyle:kC({backgroundColor:lJ.gray[100],borderColor:lJ.gray[400],checkColor:lJ.blue[400],checkWidth:"8px",width:"16px"},aJ.Disabled,{backgroundColor:lJ.gray[100],borderColor:lJ.gray[200],checkColor:lJ.blue[100]})},DatePicker:{baseStyle:{fontFamily:cJ.heading,backgroundColor:lJ.primary[400],dateColor:"white",headerBackgroundColor:"white",calendarBackgroundColor:"white",popperBackgroundColor:"white",color:lJ.neutral[600],disabledColor:lJ.neutral[300],dayHeaderColor:"#141617",borderColor:lJ.gray[200],borderRadius:"8px",boxShadow:"0 4px 16px rgba(159, 176, 183, 0.3)",padding:"16px",daySize:"36px",dayNameWidth:"36px",dayFontSize:"14px",hoverBackgroundColor:"#EDF1F3",hoverBorderRadius:"33px",weekGap:"4px",weekPadding:"2px 0",dayNamesGap:"4px",headerBorderColor:lJ.gray[200],headerPaddingBottom:"12px",chevronSize:"24px",chevronColor:lJ.neutral[600],monthYearFontSize:"inherit",monthYearFontWeight:"normal",todayButtonColor:lJ.secondary[400]}},Form:{baseStyle:{requiredIndicator:{color:"inherit",margin:0}}},FormErrorMessage:{baseStyle:{color:lJ.red[300],fontWeight:300}},FormHelperText:{baseStyle:{fontWeight:300}},FormLabel:{baseStyle:{fontSize:16,lineHeight:"25px",color:"neutral.600"},sizes:{lg:{fontSize:16}}},Input:_J,Switch:TJ,Menu:{variants:{contextMenu:{button:{height:"24px",padding:0,right:0,top:0,width:"24px"},groupTitle:{color:"neutral.600",marginLeft:"0px",fontSize:"14px",fontWeight:600,lineHeight:"14px",padding:"10px 8px",marginTop:"0px",marginBottom:"0px"},item:{borderRadius:"8px",color:"primary.400",display:"flex",fontSize:"14px",fontWeight:600,lineHeight:"14px",padding:"10px 12px"},divider:{display:"none"},list:{borderRadius:"12px",minW:"unset",padding:"10px",width:"auto",display:"flex",flexDirection:"column",gap:"10px"}}}},Modal:{baseStyle:{header:{color:"neutral.600"}}},Select:{baseStyle:{field:{fontSize:"16px",color:"neutral.600"}}},Stepper:CJ,Radio:wJ,Tabs:{variants:{line:{tab:{color:"neutral.600",_selected:{color:"neutral.600",fontWeight:600,borderColor:"primary.400"}}}}},Text:{baseStyle:{fontFamily:cJ.heading},variants:{error:{color:"red.400"}}},Textarea:{baseStyle:{fontSize:"16px"}},Tooltip:{baseStyle:{background:"primary.600",borderRadius:"8px",color:"white",fontSize:"12px",lineHeight:"12px",fontWeight:300,padding:"6px"},variants:{bold:{textTransform:"uppercase",fontWeight:500,padding:"8px",letterSpacing:"1.4px"},light:{"--popper-arrow-bg":"white",background:"white",color:"gray.700"}}},Table:LJ,Tag:BJ};const UJ=function(){return{colors:lJ,fonts:cJ,fontColor:{default:"inherit"},styles:{global:{body:{color:"gray.600",fontFamily:null,lineHeight:null,transition:null},input:{fontFamily:cJ.body,color:"gray.600"},select:{fontFamily:cJ.body,color:"gray.600"}}},components:HJ,responsive:$J}};var zJ=["collectFullBillingAddressFields","onBlur","setAddressForTaxCalculation","showValidationErrors","showValidationErrorsOnTouched"],WJ=GT("studio-card");const VJ=function(e){var r=e.collectFullBillingAddressFields,o=void 0!==r&&r,a=e.onBlur,s=void 0===a?null:a,c=e.setAddressForTaxCalculation,d=e.showValidationErrors,p=void 0!==d&&d,f=e.showValidationErrorsOnTouched,h=void 0!==f&&f,g=t(e,zJ),v=u(),y=m((0,i.useState)(null),2),b=y[0],_=y[1],A=m((0,i.useState)(),2),E=A[0],w=A[1],x=m((0,i.useState)(null),2),k=x[0],C=x[1],S=m((0,i.useState)(""),2),M=S[0],T=S[1],O=m((0,i.useState)(""),2),D=O[0],L=O[1],P=m((0,i.useState)(""),2),I=P[0],B=P[1],R=m((0,i.useState)(""),2),N=R[0],F=R[1],j=m((0,i.useState)(""),2),Y=j[0],$=j[1],H=UJ().colors,U=Co("studio.common.cardOnFileFormFields"),z=(0,i.useMemo)((function(){return WJ.next().value}),[]),W=m((0,i.useState)(new Set),2),V=W[0],G=W[1],Q=m((0,i.useState)(new Set),2),q=Q[0],K=Q[1],Z=function(e){var t=h&&q.has(e);return(p||t)&&V.has(e)},J=function(e){return b===e?H.blue[400]:Z(e)?H.red[400]:H.gray[200]},X=function(e){_(null),K((function(t){return t.add(e)}))};return(0,i.useEffect)((function(){v===l?w((function(){return function(){return new Promise((function(e){return e("test-nonce")}))}})):0===V.size&&N&&k?(c&&c({street:D+" "+I,city:M,state:Y,zipCode:N}),w((function(){return function(){return new Promise((function(e){k.tokenize({billingAddress:n({postalCode:N},o?{streetAddress:D+" "+I,locality:M,region:Y,countryCodeAlpha2:"US"}:{})}).then((function(t){var n=t.nonce;e(n)}))}))}}))):w(null)}),[v,M,o,k,V,D,I,N,c,Y]),(0,i.useEffect)((function(){s&&void 0!==E&&s(E)}),[s,E]),(0,i.useLayoutEffect)((function(){var e=!0;return v!==l&&oJ().client.create({authorization:v},(function(t,n){oJ().hostedFields.create({client:n,styles:{input:{color:H.gray[500],"font-family":"azo-sans-web, Helvetica, Arial, sans-serif","font-size":"14px",height:"35px",margin:0,padding:"6px 12px"}},fields:{cardholderName:{selector:"#"+z+"-cardholder-name"},cvv:{selector:"#"+z+"-cvv"},expirationDate:{selector:"#"+z+"-expiration-date"},number:{selector:"#"+z+"-number"}}},(function(t,n){e&&n&&(n.on("blur",function(){var e=Lo(Io().mark((function e(t){var n,r;return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:n=t.emittedBy,r=n,_(null),K((function(e){return e.add(r)}));case 4:case"end":return e.stop()}}),e)})));return function(t){return e.apply(this,arguments)}}()),n.on("focus",(function(e){var t=e.emittedBy;_(t)})),n.on("validityChange",(function(e){var t=e.fields,r=Object.entries(t).filter((function(e){return!m(e,2)[1].isValid}));G(new Set(r.map((function(e){return m(e,1)[0]})))),0===r.length?C(n):(w(null),C(null))})))}))})),function(){e=!1}}),[v,z,H]),i.createElement(wr,n({"data-testid":"studio-card-on-file-form-fields",columnGap:"20px",flexWrap:"wrap",rowGap:"24px"},g),i.createElement(_r,{"data-testid":"cardholder-name-form-field",width:"100%"},i.createElement(Xp,{htmlFor:z+"-cardholder-name",fontSize:"14px"},U("cardholderName.label"),"*"),i.createElement(Mp,{border:"1px solid "+J("cardholderName"),borderRadius:"3px",height:"40px",width:"100%",isInvalid:Z("cardholderName")},i.createElement(_r,{height:"100%",id:z+"-cardholder-name"})),Z("cardholderName")&&i.createElement(tJ,null,U("cardholderName.validationError"))),i.createElement(_r,{"data-testid":"card-number-form-field",width:"100%"},i.createElement(Xp,{htmlFor:z+"-number",fontSize:"14px"},U("cardNumber.label"),"*"),i.createElement(Mp,{border:"1px solid "+J("number"),borderRadius:"3px",height:"40px",width:"100%",marginBottom:"0",isInvalid:Z("number")},i.createElement(_r,{height:"100%",id:z+"-number"})),Z("number")&&i.createElement(tJ,null,U("cardNumber.validationError"))),i.createElement(_r,{"data-testid":"expiration-date-form-field",width:"calc(50% - 10px)",fontSize:"14px"},i.createElement(Xp,{htmlFor:z+"-expiration-date",fontSize:"14px"},U("expirationDate.label"),"*"),i.createElement(Mp,{border:"1px solid "+J("expirationDate"),borderRadius:"3px",height:"40px",width:"100%",isInvalid:Z("expirationDate")},i.createElement(_r,{height:"100%",id:z+"-expiration-date"})),Z("expirationDate")&&i.createElement(tJ,null,U("expirationDate.validationError"))),i.createElement(_r,{"data-testid":"cvv-form-field",width:"calc(50% - 10px)",fontSize:"14px"},i.createElement(Xp,{htmlFor:z+"-cvv",fontSize:"14px"},U("cvv.label"),"*"),i.createElement(Mp,{border:"1px solid "+J("cvv"),borderRadius:"3px",height:"40px",width:"100%",isInvalid:Z("cvv")},i.createElement(_r,{height:"100%",id:z+"-cvv"})),Z("cvv")&&i.createElement(tJ,null,U("cvv.validationError"))),o&&i.createElement(i.Fragment,null,i.createElement(_r,{"data-testid":"line-one-form-field",width:"100%",fontSize:"14px"},i.createElement(Xp,{htmlFor:z+"-line-one",fontSize:"14px"},U("lineOne.label"),"*"),i.createElement(Mp,{border:"1px solid "+J("lineOne"),borderRadius:"3px",height:"40px",width:"100%"},i.createElement(dz,{id:z+"-line-one",name:"lineOne",onBlur:function(){return X("lineOne")},onFocus:function(){return _("lineOne")},onChange:function(e){return L(e.target.value)},value:D,color:H.gray[500],fontFamily:"azo-sans-web, Helvetica, Arial, sans-serif",fontSize:"14px",height:"40px",padding:"6px 12px",border:"none",borderRadius:"3px",isInvalid:Z("lineOne"),errorBorderColor:H.red[400],boxShadow:"none !important"})),Z("lineOne")&&i.createElement(tJ,null,U("lineOne.validationError"))),i.createElement(_r,{"data-testid":"line-two-form-field",width:"100%",fontSize:"14px"},i.createElement(Xp,{htmlFor:z+"-line-two",fontSize:"14px"},U("lineTwo.label")),i.createElement(Mp,{border:"1px solid "+J("lineTwo"),borderRadius:"3px",height:"40px",width:"100%"},i.createElement(dz,{id:z+"-line-two",name:"lineTwo",onBlur:function(){return X("lineTwo")},onFocus:function(){return _("lineTwo")},onChange:function(e){return B(e.target.value)},value:I,color:H.gray[500],fontFamily:"azo-sans-web, Helvetica, Arial, sans-serif",fontSize:"14px",height:"40px",padding:"6px 12px",border:"none",borderRadius:"3px",isInvalid:Z("lineTwo"),errorBorderColor:H.red[400],boxShadow:"none !important"}))),i.createElement(_r,{"data-testid":"city-form-field",width:"100%",fontSize:"14px"},i.createElement(Xp,{htmlFor:z+"-city",fontSize:"14px"},U("city.label"),"*"),i.createElement(Mp,{border:"1px solid "+J("city"),borderRadius:"3px",height:"40px",width:"100%"},i.createElement(dz,{id:z+"-city",name:"city",onBlur:function(){return X("city")},onFocus:function(){return _("city")},onChange:function(e){return T(e.target.value)},value:M,color:H.gray[500],fontFamily:"azo-sans-web, Helvetica, Arial, sans-serif",fontSize:"14px",height:"40px",padding:"6px 12px",border:"none",borderRadius:"3px",isInvalid:Z("city"),errorBorderColor:H.red[400],boxShadow:"none !important"})),Z("city")&&i.createElement(tJ,null,U("city.validationError"))),i.createElement(_r,{"data-testid":"city-form-field",width:"calc(50% - 10px)",fontSize:"14px"},i.createElement(Xp,{htmlFor:z+"-state",fontSize:"14px"},U("state.label"),"*"),i.createElement(Mp,{border:"1px solid "+J("state"),borderRadius:"3px",height:"40px",width:"100%"},i.createElement(qZ,{id:z+"-state",name:"state",onBlur:function(){return X("state")},onFocus:function(){return _("state")},onChange:function(e){return $(e.target.value)},value:Y,color:H.gray[500],fontFamily:"azo-sans-web, Helvetica, Arial, sans-serif",fontSize:"14px",height:"40px",border:"none",borderRadius:"3px",isInvalid:Z("state"),errorBorderColor:H.red[400],boxShadow:"none !important"},iJ.map((function(e){return i.createElement("option",{key:e.stateProvince,value:e.stateProvince},e.name)})))))),i.createElement(_r,{"data-testid":"postal-code-form-field",width:"calc(50% - 10px)",fontSize:"14px"},i.createElement(Xp,{htmlFor:z+"-postal-code",fontSize:"14px"},U("postalCode.label"),"*"),i.createElement(Mp,{border:"1px solid "+J("postalCode"),borderRadius:"3px",height:"40px",width:"100%"},i.createElement(dz,{id:z+"-postal-code",name:"postalCode",onBlur:function(){return X("postalCode")},onFocus:function(){return _("postalCode")},onChange:function(e){e.target.value.length<3?G((function(e){return e.add("postalCode")})):G((function(e){return e.delete("postalCode"),e})),F(e.target.value)},value:N,color:H.gray[500],fontFamily:"azo-sans-web, Helvetica, Arial, sans-serif",fontSize:"14px",height:"40px",padding:"6px 12px",border:"none",borderRadius:"3px",isInvalid:Z("postalCode"),errorBorderColor:H.red[400],boxShadow:"none !important"})),Z("postalCode")&&i.createElement(tJ,null,U("postalCode.validationError"))))};var GJ=["collectFullBillingAddressFields","name","setAddressForTaxCalculation"];const QJ=function(e){var r=e.collectFullBillingAddressFields,o=e.name,a=e.setAddressForTaxCalculation,s=t(e,GJ),l=mI(),c=l.setValues,u=l.submitCount;return i.createElement(VJ,n({},s,{collectFullBillingAddressFields:r,setAddressForTaxCalculation:a,onBlur:(0,i.useCallback)((function(e){c((function(t){return n({},t,kC({},o,e))}))}),[o,c]),showValidationErrors:u>0,showValidationErrorsOnTouched:!0}))};var qJ=fr(wr)((function(e){return"\n        border: 1px solid "+e.theme.colors.gray[300]+";\n        border-radius: 4px;\n        justify-content: space-between;\n        padding: 12px 20px;\n    "})),KJ=function(e){var t,n=e.cardOnFile,r=e.currentPlan,o=e.setAddressForTaxCalculation,a=hO().me,s=(null!==(t=null==a?void 0:a.studio)&&void 0!==t?t:{}).country,l=m(II("useCardOnFile"),3),c=l[0].value,u=l[2].setValue,d=Co("studio.plan.trialCheckout.payScreen"),p=Uq(r)&&r.isFree;return i.createElement(i.Fragment,null,i.createElement(gQ,{marginBottom:"24px"},i.createElement(wr,{alignItems:"center",justifyContent:"space-between"},!p&&d("cardOnFileHeading"),n&&!c&&!p&&i.createElement(Sx,{"data-testid":"use-card-on-file-link",onClick:function(){o(null),u(!0)}},d("useCardOnFileLink")))),c&&n&&!p&&i.createElement(qJ,null,i.createElement(fx,null,n.cardType," •••• ",n.last4),i.createElement(Sx,{"data-testid":"update-card-on-file-link",onClick:function(){o(null),u(!1)}},d("updateCardOnFileLink"))),!c&&!p&&i.createElement(QJ,{collectFullBillingAddressFields:"US"===s,name:"creditCardNonce",setAddressForTaxCalculation:o}))};const ZJ=(0,i.memo)(KJ);var JJ=fr(wr)((function(e){var t=e.theme;return"\n        flex-direction: column;\n        width: 100%;\n        margin-bottom: 44px;\n\n        h2 {\n            margin: 0 0 20px;\n            color: "+t.colors.navy[700]+";\n        }\n\n        p {\n            margin: 0;\n            color: "+t.colors.gray[700]+";\n            font-size: 14px;\n            line-height: 20px;\n        }\n    "})),XJ=function(){var e=Co("studio.plan.trialCheckout.payScreen");return i.createElement(JJ,{"data-testid":"switch-to-free-plan-section"},i.createElement(gQ,null,e("switchToFreePlanHeading")),i.createElement(Px,null,e("switchToFreePlanDescription")),i.createElement(Px,{style:{marginTop:"1rem"}},e("noRefundNotice"),i.createElement(Sx,{href:"https://www.shootproof.com/legal/terms-of-use/",target:"_blank",rel:"noopener noreferrer"},e("termsOfUse")),"."))};const eX=(0,i.memo)(XJ);var tX,nX=["title","titleId"];function rX(){return rX=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},rX.apply(null,arguments)}var oX=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,nX);return i.createElement("svg",rX({xmlns:"http://www.w3.org/2000/svg","data-testid":"check-success",viewBox:"0 0 22 22",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,tX||(tX=i.createElement("g",{fill:"none",fillRule:"evenodd",transform:"translate(1 1)"},i.createElement("circle",{cx:10,cy:10,r:10,stroke:"currentColor"}),i.createElement("path",{fill:"currentColor",d:"M9.416 13.239a.997.997 0 01-.707-.293l-2.532-2.532A1 1 0 017.59 9l1.825 1.825 3.535-3.536a1 1 0 111.414 1.414l-4.242 4.243a.997.997 0 01-.707.293z"}))))},iX=(0,i.forwardRef)(oX);o.p;var aX,sX,lX,cX,uX,dX,pX,fX,hX,mX,gX,vX,yX,bX,_X,AX,EX,wX,xX,kX,CX,SX,MX,TX,OX,DX,LX,PX,IX,BX,RX,NX,FX,jX,YX,$X,HX,UX,zX,WX,VX,GX,QX,qX,KX,ZX,JX,XX,e0,t0,n0,r0,o0,i0,a0,s0,l0,c0,u0=["title","titleId"];function d0(){return d0=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},d0.apply(null,arguments)}var p0=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,u0);return i.createElement("svg",d0({width:207,height:169,viewBox:"0 0 207 169",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,aX||(aX=i.createElement("path",{d:"M64.3317 82.0202C68.0022 72.4436 70.5077 61.6157 76.0192 52.9227",stroke:"#19A0CC",strokeWidth:1.01267,strokeLinecap:"round"})),sX||(sX=i.createElement("path",{d:"M74.3672 85.9033C78.9289 82.8504 83.7773 81.1115 88.268 77.9371",stroke:"#19A0CC",strokeWidth:1.01267,strokeLinecap:"round"})),lX||(lX=i.createElement("path",{d:"M84.1797 99.1387C89.3957 100.721 94.5836 102.685 100.083 102.739",stroke:"#19A0CC",strokeWidth:1.01267,strokeLinecap:"round"})),cX||(cX=i.createElement("path",{d:"M8.22266 111.729C14.9069 110.169 21.2429 109.917 27.8663 108.995",stroke:"#19A0CC",strokeWidth:1.01267,strokeLinecap:"round"})),uX||(uX=i.createElement("path",{d:"M19.5 126.837L34.2926 120.873",stroke:"#19A0CC",strokeWidth:1.01267,strokeLinecap:"round"})),dX||(dX=i.createElement("path",{d:"M31.3457 143.352C34.8617 139.176 41.4607 132.584 41.8786 126.822",stroke:"#19A0CC",strokeWidth:1.01267,strokeLinecap:"round"})),pX||(pX=i.createElement("path",{d:"M48.5273 98.3789C48.5273 152.185 106.861 185.813 153.527 158.91C175.185 146.425 188.527 123.35 188.527 98.3789C188.527 44.5732 130.194 10.9445 83.5273 37.8475C61.8692 50.3332 48.5273 73.4076 48.5273 98.3789Z",fill:"#D8ECF3"})),fX||(fX=i.createElement("path",{d:"M94.3984 141.571C94.3984 143.765 126.536 145.136 152.247 144.039C164.179 143.53 171.53 142.589 171.53 141.571C171.53 139.377 139.392 138.006 113.681 139.103C101.749 139.612 94.3984 140.553 94.3984 141.571Z",fill:"#A0CEE9"})),hX||(hX=i.createElement("path",{d:"M83.8516 58.8105C83.8516 53.7267 87.9728 49.6055 93.0566 49.6055H173.108C178.192 49.6055 182.313 53.7267 182.313 58.8105V123.39C182.313 128.473 178.192 132.595 173.108 132.595H93.0566C87.9728 132.595 83.8516 128.473 83.8516 123.39V58.8105Z",fill:"white",stroke:"#002B4C",strokeWidth:1.84102,strokeLinejoin:"round"})),mX||(mX=i.createElement("path",{d:"M182.313 74.9249H83.8516V54.0239C83.8516 51.5835 85.8298 49.6053 88.27 49.6055H177.894C180.335 49.6056 182.313 51.5837 182.313 54.0239V74.9249Z",fill:"#A0CEE9"})),gX||(gX=i.createElement("path",{d:"M182.316 91.8008V126.964C182.316 130.071 179.797 132.59 176.689 132.59H137.305C137.305 132.59 159.809 125.559 182.316 91.8008Z",fill:"white"})),vX||(vX=i.createElement("path",{d:"M182.316 91.8008V126.964C182.316 130.071 179.797 132.59 176.689 132.59H137.305C137.305 132.59 159.809 125.559 182.316 91.8008Z",stroke:"#002B4C",strokeWidth:1.84102,strokeLinejoin:"round"})),yX||(yX=i.createElement("path",{d:"M182.313 74.9249H83.8516V54.0239C83.8516 51.5835 85.8298 49.6053 88.27 49.6055H177.894C180.335 49.6056 182.313 51.5837 182.313 54.0239V74.9249Z",stroke:"#002B4C",strokeWidth:1.84102,strokeLinejoin:"round"})),bX||(bX=i.createElement("path",{d:"M104.952 58.0444C98.4552 58.0441 94.3949 51.0113 97.6433 45.3853C100.892 39.7593 109.013 39.7596 112.261 45.3859C113.001 46.6688 113.391 48.124 113.391 49.6052",stroke:"#002B4C",strokeWidth:1.84102,strokeLinecap:"round",strokeLinejoin:"round"})),_X||(_X=i.createElement("path",{d:"M134.491 58.0444C127.994 58.0441 123.934 51.0113 127.182 45.3853C130.431 39.7593 138.552 39.7596 141.8 45.3859C142.54 46.6688 142.93 48.124 142.93 49.6052",stroke:"#002B4C",strokeWidth:1.84102,strokeLinecap:"round",strokeLinejoin:"round"})),AX||(AX=i.createElement("path",{d:"M164.03 58.0444C157.534 58.0447 153.473 51.0122 156.721 45.3859C159.969 39.7596 168.09 39.7593 171.338 45.3853C172.079 46.6683 172.469 48.1237 172.469 49.6052",stroke:"#002B4C",strokeWidth:1.84102,strokeLinecap:"round",strokeLinejoin:"round"})),EX||(EX=i.createElement("path",{d:"M83.8516 88.9893H182.313",stroke:"#002B4C",strokeWidth:1.84102,strokeLinecap:"round",strokeLinejoin:"round"})),wX||(wX=i.createElement("path",{d:"M83.8516 103.055H142.7",stroke:"#002B4C",strokeWidth:1.84102,strokeLinecap:"round",strokeLinejoin:"round"})),xX||(xX=i.createElement("path",{d:"M83.8516 117.122H142.7",stroke:"#002B4C",strokeWidth:1.84102,strokeLinecap:"round",strokeLinejoin:"round"})),kX||(kX=i.createElement("path",{d:"M103.551 74.9229V132.593",stroke:"#002B4C",strokeWidth:1.84102,strokeLinecap:"round",strokeLinejoin:"round"})),CX||(CX=i.createElement("path",{d:"M123.238 74.9229V132.593",stroke:"#002B4C",strokeWidth:1.84102,strokeLinecap:"round",strokeLinejoin:"round"})),SX||(SX=i.createElement("path",{d:"M142.93 74.9229V94.0105",stroke:"#002B4C",strokeWidth:1.84102,strokeLinecap:"round",strokeLinejoin:"round"})),MX||(MX=i.createElement("path",{d:"M162.617 74.9229V96.5788",stroke:"#002B4C",strokeWidth:1.84102,strokeLinecap:"round",strokeLinejoin:"round"})),TX||(TX=i.createElement("path",{d:"M83.8516 88.9893H103.543V103.055H83.8516V88.9893Z",fill:"#A0CEE9",stroke:"#002B4C",strokeWidth:1.84102,strokeLinejoin:"round"})),OX||(OX=i.createElement("path",{d:"M103.551 117.122H123.242V132.594H103.551V117.122Z",fill:"#A0CEE9",stroke:"#002B4C",strokeWidth:1.84102,strokeLinejoin:"round"})),DX||(DX=i.createElement("path",{d:"M123.238 74.9229H142.93V88.9882H123.238V74.9229Z",fill:"#A0CEE9",stroke:"#002B4C",strokeWidth:1.84102,strokeLinejoin:"round"})),LX||(LX=i.createElement("path",{d:"M182.316 91.8008C159.809 125.559 137.305 132.592 137.305 132.592C143.784 121.263 145.081 107.695 140.865 95.3429C140.565 94.4962 141.293 93.6415 142.177 93.8046C142.204 93.8095 142.23 93.8154 142.257 93.8223C148.752 95.6024 168.352 99.9454 182.316 91.8008Z",fill:"white",stroke:"#002B4C",strokeWidth:1.84102,strokeLinecap:"round",strokeLinejoin:"round"})),PX||(PX=i.createElement("path",{d:"M119.023 66.4824H147.156",stroke:"#002B4C",strokeWidth:1.84102,strokeLinecap:"round",strokeLinejoin:"round"})),IX||(IX=i.createElement("path",{d:"M162.617 66.4824H173.871",stroke:"#002B4C",strokeWidth:1.84102,strokeLinecap:"round",strokeLinejoin:"round"})),BX||(BX=i.createElement("path",{d:"M103.549 66.4824H92.2969",stroke:"#002B4C",strokeWidth:1.84102,strokeLinecap:"round",strokeLinejoin:"round"})),RX||(RX=i.createElement("path",{d:"M91.4916 114.664C89.4073 114.139 88.3321 111.639 87.5419 108.908V102.494C87.5636 100.055 87.1022 97.6371 86.1842 95.3782C85.2662 93.1193 83.9098 91.0647 82.1934 89.3329C80.477 87.6011 78.4345 86.2264 76.1839 85.2883C73.9333 84.3502 71.5192 83.8672 69.0809 83.8672C66.6426 83.8672 64.2285 84.3502 61.9779 85.2883C59.7273 86.2264 57.6848 87.6011 55.9684 89.3329C54.2519 91.0647 52.8956 93.1193 51.9776 95.3782C51.0596 97.6371 50.5981 100.055 50.6199 102.494V108.908C49.8296 111.639 48.7559 114.139 46.6702 114.664C42.7734 115.647 44.7607 120.879 47.124 123.435C48.2592 124.603 49.6228 125.525 51.13 126.143C52.6372 126.761 54.2555 127.062 55.8842 127.028C59.934 129.293 64.4481 130.603 69.0816 130.858C73.7147 130.603 78.2283 129.293 82.2776 127.028C83.9062 127.062 85.5246 126.761 87.0318 126.143C88.5389 125.525 89.9026 124.603 91.0377 123.435C93.3967 120.879 95.3884 115.647 91.4916 114.664Z",fill:"white",stroke:"#002B4C",strokeWidth:1.46883,strokeLinecap:"round",strokeLinejoin:"round"})),NX||(NX=i.createElement("path",{d:"M69.077 128.459C62.7527 128.459 56.6875 130.971 52.2155 135.443C47.7434 139.915 45.2309 145.98 45.2305 152.304V163.843H92.922V152.304C92.922 145.98 90.4097 139.915 85.9379 135.443C81.4661 130.971 75.401 128.459 69.077 128.459Z",fill:"#A0CEE9"})),FX||(FX=i.createElement("path",{d:"M69.077 128.459C62.7527 128.459 56.6875 130.971 52.2155 135.443C47.7434 139.915 45.2309 145.98 45.2305 152.304V163.843H92.922V152.304C92.922 145.98 90.4097 139.915 85.9379 135.443C81.4661 130.971 75.401 128.459 69.077 128.459Z",stroke:"#002B4C",strokeWidth:1.46883,strokeLinecap:"round",strokeLinejoin:"round"})),jX||(jX=i.createElement("path",{d:"M53.6992 152.765V163.843",stroke:"#002B4C",strokeWidth:1.46883,strokeLinecap:"round",strokeLinejoin:"round"})),YX||(YX=i.createElement("path",{d:"M84.4648 152.765V163.843",stroke:"#002B4C",strokeWidth:1.46883,strokeLinecap:"round",strokeLinejoin:"round"})),$X||($X=i.createElement("path",{d:"M69.0792 145.381C75.3761 145.381 80.4935 139.161 80.6139 131.427C78.6837 130.358 76.6138 129.563 74.4639 129.065V123.844H63.6944V129.068C61.5442 129.566 59.4738 130.361 57.543 131.43C57.6619 139.161 62.7823 145.381 69.0792 145.381Z",fill:"white"})),HX||(HX=i.createElement("path",{d:"M58.5273 136.93C60.3208 141.913 64.3689 145.39 69.0765 145.39C73.7841 145.39 77.8322 141.913 79.6256 136.93H58.5273Z",fill:"white",stroke:"#002B4C",strokeWidth:1.46883,strokeLinecap:"round",strokeLinejoin:"round"})),UX||(UX=i.createElement("path",{d:"M69.0792 145.381C75.3761 145.381 80.4935 139.161 80.6139 131.427C78.6837 130.358 76.6138 129.563 74.4639 129.065V123.844H63.6944V129.068C61.5442 129.566 59.4738 130.361 57.543 131.43C57.6619 139.161 62.7823 145.381 69.0792 145.381Z",stroke:"#002B4C",strokeWidth:1.46883,strokeLinecap:"round",strokeLinejoin:"round"})),zX||(zX=i.createElement("path",{d:"M84.4682 106.921V103.074C84.4682 98.9938 82.8473 95.0806 79.9622 92.1955C77.077 89.3103 73.1639 87.6895 69.0837 87.6895C65.0034 87.6895 61.0903 89.3103 58.2051 92.1955C55.32 95.0806 53.6991 98.9938 53.6991 103.074V106.921C53.2894 106.912 52.8821 106.985 52.501 107.135C52.1199 107.286 51.7728 107.511 51.4799 107.798C51.187 108.084 50.9543 108.427 50.7954 108.804C50.6365 109.182 50.5547 109.588 50.5547 109.997C50.5547 110.407 50.6365 110.813 50.7954 111.19C50.9543 111.568 51.187 111.91 51.4799 112.197C51.7728 112.483 52.1199 112.709 52.501 112.859C52.8821 113.01 53.2894 113.083 53.6991 113.074C53.7637 113.074 53.824 113.059 53.8871 113.055C54.4304 116.696 56.2634 120.022 59.0525 122.426C61.8415 124.829 65.401 126.152 69.0829 126.152C72.7649 126.152 76.3244 124.829 79.1134 122.426C81.9024 120.022 83.7354 116.696 84.2787 113.055C84.3434 113.055 84.4036 113.074 84.4682 113.074C85.2725 113.056 86.0379 112.724 86.6005 112.149C87.1631 111.574 87.4782 110.802 87.4782 109.997C87.4782 109.193 87.1631 108.42 86.6005 107.845C86.0379 107.27 85.2725 106.938 84.4682 106.921Z",fill:"white",stroke:"#002B4C",strokeWidth:1.46883,strokeLinecap:"round",strokeLinejoin:"round"})),WX||(WX=i.createElement("path",{d:"M58.3164 113.459C58.3164 113.969 58.519 114.458 58.8796 114.818C59.2401 115.179 59.7292 115.382 60.2391 115.382C60.749 115.382 61.2381 115.179 61.5987 114.818C61.9592 114.458 62.1618 113.969 62.1618 113.459C62.1618 112.949 61.9592 112.46 61.5987 112.099C61.2381 111.739 60.749 111.536 60.2391 111.536C59.7292 111.536 59.2401 111.739 58.8796 112.099C58.519 112.46 58.3164 112.949 58.3164 113.459Z",fill:"#A0CEE9"})),VX||(VX=i.createElement("path",{d:"M76 113.459C76 113.969 76.2026 114.458 76.5631 114.818C76.9237 115.179 77.4128 115.382 77.9227 115.382C78.4326 115.382 78.9217 115.179 79.2822 114.818C79.6428 114.458 79.8454 113.969 79.8454 113.459C79.8454 112.949 79.6428 112.46 79.2822 112.099C78.9217 111.739 78.4326 111.536 77.9227 111.536C77.4128 111.536 76.9237 111.739 76.5631 112.099C76.2026 112.46 76 112.949 76 113.459Z",fill:"#A0CEE9"})),GX||(GX=i.createElement("path",{d:"M73.7028 117.365C72.4635 118.56 70.8092 119.228 69.0877 119.228C67.3663 119.228 65.7119 118.56 64.4727 117.365",stroke:"#002B4C",strokeWidth:1.46883,strokeLinecap:"round",strokeLinejoin:"round"})),QX||(QX=i.createElement("path",{d:"M65.2283 108.46C65.0395 108.003 64.7195 107.613 64.3087 107.338C63.898 107.064 63.4149 106.917 62.9208 106.917C62.4267 106.917 61.9437 107.064 61.5329 107.338C61.1221 107.613 60.8021 108.003 60.6133 108.46",stroke:"#002B4C",strokeWidth:1.46883,strokeLinecap:"round",strokeLinejoin:"round"})),qX||(qX=i.createElement("path",{d:"M77.533 108.46C77.3442 108.003 77.0242 107.613 76.6134 107.338C76.2026 107.064 75.7196 106.917 75.2255 106.917C74.7314 106.917 74.2484 107.064 73.8376 107.338C73.4268 107.613 73.1068 108.003 72.918 108.46",stroke:"#002B4C",strokeWidth:1.46883,strokeLinecap:"round",strokeLinejoin:"round"})),KX||(KX=i.createElement("path",{d:"M69.0731 83.9805C64.1708 83.991 59.4729 85.9461 56.0105 89.4167C52.5482 92.8873 50.6043 97.5898 50.6055 102.492V110.104C50.6059 109.367 50.8987 108.661 51.4195 108.141C51.9404 107.62 52.6466 107.328 53.383 107.328C58.0054 108.11 60.8902 103.124 62.1446 95.4888C67.8598 100.829 83.2003 107.59 84.7514 107.328C85.4877 107.328 86.1938 107.62 86.7144 108.141C87.235 108.661 87.5275 109.367 87.5275 110.104V102.492C87.5287 97.5921 85.5866 92.8916 82.1271 89.4213C78.6676 85.9511 73.9731 83.9945 69.0731 83.9805Z",fill:"white"})),ZX||(ZX=i.createElement("path",{d:"M69.0731 83.9805C64.1708 83.991 59.4729 85.9461 56.0105 89.4167C52.5482 92.8873 50.6043 97.5898 50.6055 102.492V110.104C50.6059 109.367 50.8987 108.661 51.4195 108.141C51.9404 107.62 52.6466 107.328 53.383 107.328C58.0054 108.11 60.8902 103.124 62.1446 95.4888C67.8598 100.829 83.2003 107.59 84.7514 107.328C85.4877 107.328 86.1938 107.62 86.7144 108.141C87.235 108.661 87.5275 109.367 87.5275 110.104V102.492C87.5287 97.5921 85.5866 92.8916 82.1271 89.4213C78.6676 85.9511 73.9731 83.9945 69.0731 83.9805Z",stroke:"#002B4C",strokeWidth:1.46883,strokeLinecap:"round",strokeLinejoin:"round"})),JX||(JX=i.createElement("path",{d:"M56.0039 143.074H82.1565V159.227H56.0039V143.074Z",fill:"white",stroke:"#002B4C",strokeWidth:1.46883,strokeLinecap:"round",strokeLinejoin:"round"})),XX||(XX=i.createElement("path",{d:"M56.0039 146.151H82.1565V156.151H56.0039V146.151Z",fill:"#A0CEE9",stroke:"#002B4C",strokeWidth:1.46883,strokeLinecap:"round",strokeLinejoin:"round"})),e0||(e0=i.createElement("path",{d:"M74.6702 141.017C74.5178 140.71 74.2826 140.45 73.9909 140.269C73.6993 140.087 73.3628 139.99 73.0192 139.989H65.1463C64.8027 139.99 64.4661 140.087 64.1744 140.268C63.8828 140.45 63.6476 140.709 63.4953 141.017C62.6468 142.317 62.1838 143.83 62.1602 145.381V159.227H76.0054V145.381C75.9808 143.83 75.5179 142.317 74.6702 141.017Z",fill:"white",stroke:"#002B4C",strokeWidth:1.46883,strokeLinecap:"round",strokeLinejoin:"round"})),t0||(t0=i.createElement("path",{d:"M62.1602 149.997C62.1602 151.833 62.8895 153.594 64.1877 154.892C65.486 156.19 67.2468 156.919 69.0828 156.919C70.9188 156.919 72.6795 156.19 73.9778 154.892C75.276 153.594 76.0054 151.833 76.0054 149.997C76.0054 148.161 75.276 146.4 73.9778 145.102C72.6795 143.804 70.9188 143.074 69.0828 143.074C67.2468 143.074 65.486 143.804 64.1877 145.102C62.8895 146.4 62.1602 148.161 62.1602 149.997Z",fill:"white",stroke:"#002B4C",strokeWidth:1.46883,strokeLinecap:"round",strokeLinejoin:"round"})),n0||(n0=i.createElement("path",{d:"M65.2305 149.997C65.2305 151.017 65.6356 151.995 66.3568 152.716C67.0779 153.437 68.056 153.842 69.0759 153.842C70.0957 153.842 71.0738 153.437 71.795 152.716C72.5161 151.995 72.9213 151.017 72.9213 149.997C72.9213 148.977 72.5161 147.999 71.795 147.278C71.0738 146.557 70.0957 146.151 69.0759 146.151C68.056 146.151 67.0779 146.557 66.3568 147.278C65.6356 147.999 65.2305 148.977 65.2305 149.997Z",fill:"#A0CEE9"})),r0||(r0=i.createElement("path",{d:"M65.2305 149.997C65.2305 151.017 65.6356 151.995 66.3568 152.716C67.0779 153.437 68.056 153.842 69.0759 153.842C70.0957 153.842 71.0738 153.437 71.795 152.716C72.5161 151.995 72.9213 151.017 72.9213 149.997C72.9213 148.977 72.5161 147.999 71.795 147.278C71.0738 146.557 70.0957 146.151 69.0759 146.151C68.056 146.151 67.0779 146.557 66.3568 147.278C65.6356 147.999 65.2305 148.977 65.2305 149.997Z",stroke:"#002B4C",strokeWidth:1.46883,strokeLinecap:"round",strokeLinejoin:"round"})),o0||(o0=i.createElement("path",{d:"M79.8422 135.692V143.076H76.0027V135.692C76.102 133.854 75.5582 132.04 74.4648 130.56V125.646C76.1122 126.756 77.4634 128.251 78.4007 130.002C79.3379 131.752 79.8328 133.706 79.8422 135.692Z",fill:"#A0CEE9",stroke:"#002B4C",strokeWidth:1.46883,strokeLinecap:"round",strokeLinejoin:"round"})),i0||(i0=i.createElement("path",{d:"M58.3164 135.691V143.075H62.1633V135.691C62.064 133.853 62.6078 132.039 63.7011 130.559V125.646C62.0525 126.754 60.7 128.249 59.7614 130C58.8228 131.75 58.3268 133.704 58.3164 135.691Z",fill:"#A0CEE9",stroke:"#002B4C",strokeWidth:1.46883,strokeLinecap:"round",strokeLinejoin:"round"})),a0||(a0=i.createElement("path",{d:"M164.05 31.7196C169.172 30.0797 181.157 29.8135 188.116 41.8674",stroke:"#19A0CC",strokeWidth:.808584,strokeLinecap:"round"})),s0||(s0=i.createElement("path",{d:"M196.089 13.2229C191.192 15.1168 180.163 16.7689 175.231 8.22591",stroke:"#19A0CC",strokeWidth:.808584,strokeLinecap:"round"})),l0||(l0=i.createElement("path",{d:"M163.878 31.8205C169.718 27.5154 180.164 16.7693 175.232 8.2263",stroke:"#19A0CC",strokeWidth:.808584,strokeLinecap:"round"})),c0||(c0=i.createElement("path",{d:"M196.089 13.2235C190.533 17.749 181.159 29.8136 188.118 41.8675",stroke:"#19A0CC",strokeWidth:.808584,strokeLinecap:"round"})))},f0=(0,i.forwardRef)(p0);o.p;var h0,m0,g0,v0,y0,b0,_0,A0,E0,w0,x0,k0,C0,S0,M0,T0,O0,D0,L0,P0,I0,B0,R0,N0,F0,j0,Y0,$0,H0,U0,z0,W0,V0,G0,Q0,q0,K0,Z0,J0,X0,e1,t1,n1,r1,o1,i1,a1=["title","titleId"];function s1(){return s1=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},s1.apply(null,arguments)}var l1=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,a1);return i.createElement("svg",s1({viewBox:"0 0 180 148",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,h0||(h0=i.createElement("g",{filter:"url(#filter0_d_9_26)"},i.createElement("rect",{x:22,y:18,width:140,height:100,rx:6,fill:"white"}))),m0||(m0=i.createElement("path",{d:"M22 24C22 20.6863 24.6863 18 28 18H156C159.314 18 162 20.6863 162 24V30H22V24Z",fill:"#F6F8F9"})),g0||(g0=i.createElement("circle",{cx:36,cy:24,r:2,fill:"#BCC8CD"})),v0||(v0=i.createElement("circle",{cx:44,cy:24,r:2,fill:"#BCC8CD"})),y0||(y0=i.createElement("circle",{cx:52,cy:24,r:2,fill:"#BCC8CD"})),b0||(b0=i.createElement("rect",{x:30,y:38,width:27,height:33,fill:"#7BCEEA"})),i.createElement("mask",{id:"mask0_9_26",style:{maskType:"alpha"},maskUnits:"userSpaceOnUse",x:30,y:38,width:27,height:33},_0||(_0=i.createElement("rect",{x:30,y:38,width:27,height:33,fill:"#7BCEEA"}))),i.createElement("g",{mask:"url(#mask0_9_26)"},i.createElement("g",{style:{mixBlendMode:"screen"},opacity:.5},A0||(A0=i.createElement("ellipse",{cx:80.501,cy:36.9634,rx:47.2475,ry:24.2851,transform:"rotate(167.002 80.501 36.9634)",fill:"#D3EFF8"})))),E0||(E0=i.createElement("rect",{x:30,y:77,width:27,height:33,fill:"#D3EFF8"})),i.createElement("mask",{id:"mask1_9_26",style:{maskType:"alpha"},maskUnits:"userSpaceOnUse",x:30,y:77,width:27,height:33},w0||(w0=i.createElement("rect",{x:30,y:77,width:27,height:33,fill:"#D3EFF8"}))),x0||(x0=i.createElement("g",{mask:"url(#mask1_9_26)"},i.createElement("ellipse",{cx:59.3719,cy:91.9457,rx:30.5,ry:18,transform:"rotate(140.106 59.3719 91.9457)",fill:"#A7DFF1"}))),k0||(k0=i.createElement("rect",{x:127,y:38,width:27,height:33,fill:"#A7DFF1"})),C0||(C0=i.createElement("rect",{x:64,y:38,width:57,height:33,fill:"#D3EFF8"})),i.createElement("mask",{id:"mask2_9_26",style:{maskType:"alpha"},maskUnits:"userSpaceOnUse",x:64,y:38,width:57,height:33},S0||(S0=i.createElement("rect",{x:64,y:38,width:57,height:33,fill:"#D3EFF8"}))),i.createElement("g",{mask:"url(#mask2_9_26)"},M0||(M0=i.createElement("ellipse",{cx:118.194,cy:51.9763,rx:30.5,ry:24.2851,transform:"rotate(50.1064 118.194 51.9763)",fill:"#A7DFF1"})),i.createElement("g",{style:{mixBlendMode:"screen"},opacity:.5},T0||(T0=i.createElement("ellipse",{cx:80.501,cy:36.9634,rx:47.2475,ry:24.2851,transform:"rotate(167.002 80.501 36.9634)",fill:"#D3EFF8"})))),i.createElement("mask",{id:"mask3_9_26",style:{maskType:"alpha"},maskUnits:"userSpaceOnUse",x:127,y:38,width:27,height:33},O0||(O0=i.createElement("rect",{x:127,y:38,width:27,height:33,fill:"#7BCEEA"}))),D0||(D0=i.createElement("g",{mask:"url(#mask3_9_26)"},i.createElement("ellipse",{cx:118.194,cy:51.9763,rx:30.5,ry:24.2851,transform:"rotate(50.1064 118.194 51.9763)",fill:"#A7DFF1"}))),L0||(L0=i.createElement("rect",{x:64,y:77,width:26,height:33,fill:"#D3EFF8"})),i.createElement("mask",{id:"mask4_9_26",style:{maskType:"alpha"},maskUnits:"userSpaceOnUse",x:64,y:77,width:26,height:33},P0||(P0=i.createElement("rect",{x:64,y:77,width:26,height:33,fill:"#D3EFF8"}))),I0||(I0=i.createElement("g",{mask:"url(#mask4_9_26)"},i.createElement("ellipse",{cx:59.3719,cy:91.9457,rx:30.5,ry:18,transform:"rotate(140.106 59.3719 91.9457)",fill:"#A7DFF1"}))),B0||(B0=i.createElement("path",{d:"M39.927 51.5338C39.2164 51.3454 38.1387 51.2144 37.5842 51.796C35.9755 53.4342 38.3651 57.0792 39.6146 57.8491L39.927 51.5338Z",fill:"#D3EFF8"})),R0||(R0=i.createElement("path",{d:"M51.2032 49.7722C50.9019 48.6538 50.2605 47.6693 49.3766 46.9684C48.4928 46.2675 47.4148 45.8887 46.3067 45.8897H44.3857C43.277 45.886 42.1977 46.2638 41.3133 46.9651C40.4289 47.6663 39.7882 48.6524 39.4892 49.7722C38.0445 55.1865 36.8575 64.3604 45.3462 64.3604C53.8349 64.3604 52.6401 55.1865 51.2032 49.7722Z",fill:"#D3EFF8"})),N0||(N0=i.createElement("path",{d:"M48.0237 55.9375C48.0536 56.0704 48.0895 56.2059 48.1349 56.3425C48.5425 57.5707 48.8653 58.75 47.5713 58.75V58.75",stroke:"#1C8BB0",strokeWidth:.5,strokeLinecap:"round"})),F0||(F0=i.createElement("path",{d:"M35 71C35 69.3431 36.3431 68 38 68H52C53.6569 68 55 69.3431 55 71H35Z",fill:"#0C547D"})),j0||(j0=i.createElement("path",{d:"M47.1856 64H43.8204L43.1507 67.738C43.0639 68.2223 43.3413 68.7051 43.8214 68.8133C44.9265 69.0623 46.0746 69.0622 47.1797 68.813C47.6593 68.7049 47.9366 68.2229 47.8506 67.7388L47.1856 64Z",fill:"#D3EFF8"})),Y0||(Y0=i.createElement("path",{d:"M42.5817 48.9123C43.1702 49.4444 43.9288 49.7232 44.7052 49.6928C45.4816 49.6625 46.2184 49.3251 46.7674 48.7485C47.2023 49.2426 47.7618 49.5973 48.381 49.7713C49.0003 49.9452 49.6539 49.9314 50.266 49.7314C50.7827 49.57 51.2335 49.2329 51.5473 48.7732C51.8612 48.3135 52.0204 47.7573 51.9997 47.1922C51.8747 46.0127 50.8439 45.3165 49.899 44.9479C48.559 44.4236 47.1312 44.1909 45.7026 44.2641C44.2741 44.3374 42.8748 44.7149 41.5899 45.3738C40.2133 46.0122 39.0263 47.028 38.1538 48.3144C37.3729 49.5758 37.6774 51.2959 39.0519 51.5908C40.4263 51.8857 42.1365 50.5505 42.5817 48.9123Z",fill:"#002B4C"})),$0||($0=i.createElement("path",{d:"M38.4667 58.463C37.5481 58.463 36.8034 57.6819 36.8034 56.7183C36.8034 55.7548 37.5481 54.9736 38.4667 54.9736C39.3854 54.9736 40.1301 55.7548 40.1301 56.7183C40.1301 57.6819 39.3854 58.463 38.4667 58.463Z",fill:"#A7DFF1"})),H0||(H0=i.createElement("path",{d:"M38.0446 48.4859C35.8105 48.4859 33.9994 46.5863 33.9994 44.243C33.9994 41.8996 35.8105 40 38.0446 40C40.2787 40 42.0898 41.8996 42.0898 44.243C42.0898 46.5863 40.2787 48.4859 38.0446 48.4859Z",fill:"#002B4C"})),U0||(U0=i.createElement("g",{filter:"url(#filter1_d_9_26)"},i.createElement("rect",{x:96,y:77,width:58,height:32.9383,fill:"#4FBEE3"}))),i.createElement("mask",{id:"mask5_9_26",style:{maskType:"alpha"},maskUnits:"userSpaceOnUse",x:96,y:77,width:58,height:33},z0||(z0=i.createElement("rect",{x:96,y:77,width:58,height:32.9383,fill:"#7BCEEA"}))),i.createElement("g",{mask:"url(#mask5_9_26)"},W0||(W0=i.createElement("ellipse",{cx:137.661,cy:83.6531,rx:36.5185,ry:25.7778,transform:"rotate(23.7623 137.661 83.6531)",fill:"#23AEDC"})),i.createElement("g",{style:{mixBlendMode:"screen"},opacity:.1},V0||(V0=i.createElement("ellipse",{cx:98.1482,cy:69.8324,rx:25.804,ry:35.5737,transform:"rotate(23.7623 98.1482 69.8324)",fill:"#D3EFF8"})))),G0||(G0=i.createElement("path",{d:"M134.504 84.3298C133.577 83.8202 132.541 83.5433 131.484 83.5229C130.952 83.5321 130.439 83.7226 130.028 84.0632C129.618 84.4038 129.335 84.8742 129.225 85.3975C128.547 85.1189 127.792 85.0877 127.093 85.3093C126.393 85.5309 125.793 85.9913 125.396 86.6108C125.019 87.2612 124.866 88.0182 124.96 88.7648C125.054 89.5115 125.39 90.2064 125.916 90.7422C125.235 90.8479 124.605 91.1691 124.119 91.659C123.632 92.1489 123.314 92.7819 123.21 93.4661C123.123 94.1582 123.254 94.8602 123.585 95.4737C123.915 96.0873 124.428 96.5817 125.052 96.8877C124.4 97.8093 124.017 98.8956 123.947 100.024C123.977 101.383 125.535 103.057 126.767 101.887C127.209 102.54 127.887 102.995 128.658 103.154C129.817 103.385 131.019 102.9 132.197 103.021C133.205 103.124 134.353 103.628 135.15 102.979C135.392 102.778 135.567 102.481 135.851 102.342C136.455 102.062 137.246 102.511 137.832 102.602C138.664 102.726 139.512 102.691 140.332 102.499C140.721 102.432 141.083 102.255 141.377 101.99C141.519 101.835 141.613 101.642 141.65 101.434C141.686 101.227 141.663 101.013 141.582 100.819C142.905 100.6 144.251 100.406 145.073 99.1444C145.822 97.9979 145.52 96.1111 144.276 95.6198C144.951 95.2594 145.486 94.6826 145.797 93.9812C146.108 93.2798 146.176 92.4941 145.991 91.7493C145.786 91.019 145.335 90.3831 144.714 89.9504C144.094 89.5176 143.343 89.315 142.591 89.3772C142.856 88.7409 143.011 88.0639 143.05 87.3752C143.065 87.0328 142.993 86.6921 142.841 86.3852C142.689 86.0784 142.461 85.8157 142.18 85.622C141.431 85.1912 140.579 85.5613 139.843 85.7918C140.447 85.5977 139.462 84.1053 139.239 83.9112C138.942 83.6878 138.592 83.5457 138.224 83.4987C137.585 83.3879 136.929 83.421 136.304 83.5957C135.887 83.7292 134.927 84.5118 134.504 84.3298Z",fill:"#A7DFF1"})),Q0||(Q0=i.createElement("path",{d:"M137.951 93.5275C138.501 93.388 139.334 93.291 139.763 93.7217C141.007 94.935 139.159 97.6346 138.193 98.2049L137.951 93.5275Z",fill:"#002B4C"})),q0||(q0=i.createElement("path",{d:"M129.655 90.7505C129.858 89.8834 130.981 89.12 131.579 88.5766C132.178 88.0332 132.907 87.7395 133.657 87.7403H134.958C135.708 87.7374 136.439 88.0303 137.037 88.574C137.636 89.1177 138.07 89.8823 138.272 90.7505C139.25 94.9484 138.621 102.061 132.875 102.061C127.13 102.061 128.682 94.9484 129.655 90.7505Z",fill:"#002B4C"})),K0||(K0=i.createElement("path",{d:"M131.444 95.6172C131.422 95.7116 131.396 95.8077 131.364 95.9046C131.042 96.8666 130.788 97.7653 131.802 97.7653V97.7653",stroke:"#D3EFF8",strokeWidth:.5,strokeLinecap:"round"})),Z0||(Z0=i.createElement("path",{d:"M126.074 109.938C126.074 107.177 128.313 104.926 131.074 104.926H137.543C140.305 104.926 142.543 107.177 142.543 109.938H126.074Z",fill:"#D3EFF8"})),J0||(J0=i.createElement("path",{d:"M132.089 101.226H135.483L136.163 105.093C136.248 105.574 135.973 106.054 135.497 106.164C134.373 106.425 133.203 106.424 132.079 106.164C131.603 106.054 131.329 105.575 131.413 105.094L132.089 101.226Z",fill:"#002B4C"})),X0||(X0=i.createElement("path",{d:"M136.186 90.6373C135.682 91.0354 135.082 91.1949 134.507 91.0834C133.933 90.9718 133.429 90.5976 133.096 90.0369C132.71 90.4178 132.248 90.6654 131.765 90.7514C131.281 90.8374 130.795 90.7583 130.362 90.5231C129.997 90.3265 129.704 89.9845 129.529 89.5514C129.354 89.1183 129.307 88.6187 129.396 88.1318C129.64 87.1264 130.495 86.6452 131.245 86.4305C132.31 86.1218 133.403 86.0756 134.458 86.2946C135.512 86.5136 136.507 86.9932 137.379 87.704C138.321 88.409 139.075 89.4165 139.563 90.622C139.983 91.8047 139.538 93.2504 138.477 93.3542C137.416 93.458 136.313 92.1166 136.186 90.6373Z",fill:"#A7DFF1"})),e1||(e1=i.createElement("path",{d:"M138.605 98.4812C138.012 98.4812 137.531 98.0003 137.531 97.4071C137.531 96.8139 138.012 96.333 138.605 96.333C139.198 96.333 139.679 96.8139 139.679 97.4071C139.679 98.0003 139.198 98.4812 138.605 98.4812Z",fill:"#FDFEFE"})),t1||(t1=i.createElement("circle",{opacity:.7,cx:106.741,cy:87.7409,r:5.01235,fill:"white"})),n1||(n1=i.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M130.475 23.0593C131.186 21.8678 132.464 21.13 133.852 21.1099L153.891 20.8187C155.341 20.7977 156.688 21.5627 157.413 22.8183L174.239 51.9615C175.344 53.8747 174.688 56.321 172.775 57.4256L142.464 74.9256C140.551 76.0302 138.105 75.3747 137 73.4615L120.174 44.3183C119.449 43.0627 119.46 41.5131 120.204 40.2682L130.475 23.0593ZM139.738 35.2035C141.525 34.1716 142.137 31.8863 141.106 30.0991C140.074 28.3119 137.788 27.6995 136.001 28.7314C134.214 29.7632 133.602 32.0485 134.633 33.8358C135.665 35.623 137.951 36.2353 139.738 35.2035Z",fill:"#FFC481"})),r1||(r1=i.createElement("rect",{x:139.928,y:62.5332,width:27,height:4,rx:2,transform:"rotate(-30 139.928 62.5332)",fill:"white"})),o1||(o1=i.createElement("path",{d:"M138.12 32.4006C144.098 28.9488 146.147 21.3039 142.695 15.3253C139.243 9.3466 131.598 7.29816 125.62 10.7499C123.647 11.8888 122.102 13.484 121.042 15.3253",stroke:"#677F89",strokeWidth:2,strokeLinecap:"round"})),i1||(i1=i.createElement("defs",null,i.createElement("filter",{id:"filter0_d_9_26",x:0,y:8,width:180,height:140,filterUnits:"userSpaceOnUse",colorInterpolationFilters:"sRGB"},i.createElement("feFlood",{floodOpacity:0,result:"BackgroundImageFix"}),i.createElement("feColorMatrix",{in:"SourceAlpha",type:"matrix",values:"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",result:"hardAlpha"}),i.createElement("feOffset",{dx:-2,dy:10}),i.createElement("feGaussianBlur",{stdDeviation:10}),i.createElement("feComposite",{in2:"hardAlpha",operator:"out"}),i.createElement("feColorMatrix",{type:"matrix",values:"0 0 0 0 0.317647 0 0 0 0 0.392157 0 0 0 0 0.423529 0 0 0 0.25 0"}),i.createElement("feBlend",{mode:"normal",in2:"BackgroundImageFix",result:"effect1_dropShadow_9_26"}),i.createElement("feBlend",{mode:"normal",in:"SourceGraphic",in2:"effect1_dropShadow_9_26",result:"shape"})),i.createElement("filter",{id:"filter1_d_9_26",x:74,y:67,width:98,height:72.9385,filterUnits:"userSpaceOnUse",colorInterpolationFilters:"sRGB"},i.createElement("feFlood",{floodOpacity:0,result:"BackgroundImageFix"}),i.createElement("feColorMatrix",{in:"SourceAlpha",type:"matrix",values:"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",result:"hardAlpha"}),i.createElement("feOffset",{dx:-2,dy:10}),i.createElement("feGaussianBlur",{stdDeviation:10}),i.createElement("feComposite",{in2:"hardAlpha",operator:"out"}),i.createElement("feColorMatrix",{type:"matrix",values:"0 0 0 0 0.317647 0 0 0 0 0.392157 0 0 0 0 0.423529 0 0 0 0.25 0"}),i.createElement("feBlend",{mode:"normal",in2:"BackgroundImageFix",result:"effect1_dropShadow_9_26"}),i.createElement("feBlend",{mode:"normal",in:"SourceGraphic",in2:"effect1_dropShadow_9_26",result:"shape"})))))},c1=(0,i.forwardRef)(l1);o.p;var u1,d1,p1,f1,h1,m1,g1,v1,y1,b1,_1,A1,E1,w1,x1,k1,C1,S1,M1,T1,O1,D1,L1,P1,I1,B1,R1,N1,F1,j1,Y1,$1,H1,U1,z1,W1,V1,G1,Q1,q1,K1,Z1,J1,X1=["title","titleId"];function e2(){return e2=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},e2.apply(null,arguments)}var t2=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,X1);return i.createElement("svg",e2({fill:"none",xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 240 176",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,u1||(u1=i.createElement("g",{filter:"url(#filter0_d_1767_8925)"},i.createElement("rect",{x:22,y:10,width:180.645,height:129.032,rx:6,fill:"white"}))),d1||(d1=i.createElement("path",{d:"M22 16C22 12.6863 24.6863 10 28 10H196.645C199.959 10 202.645 12.6863 202.645 16V25.4839H22V16Z",fill:"#F6F8F9"})),p1||(p1=i.createElement("circle",{cx:39.4839,cy:17.1613,r:2,fill:"#BCC8CD"})),f1||(f1=i.createElement("circle",{cx:47.4839,cy:17.1613,r:2,fill:"#BCC8CD"})),h1||(h1=i.createElement("circle",{cx:55.4839,cy:17.1613,r:2,fill:"#BCC8CD"})),m1||(m1=i.createElement("rect",{x:32.3228,y:35.8065,width:34.8387,height:42.5806,fill:"#7BCEEA"})),i.createElement("mask",{id:"mask0_1767_8925",style:{maskType:"alpha"},maskUnits:"userSpaceOnUse",x:32,y:35,width:36,height:44},g1||(g1=i.createElement("rect",{x:32.3228,y:35.8068,width:34.8387,height:42.5806,fill:"#7BCEEA"}))),i.createElement("g",{mask:"url(#mask0_1767_8925)"},i.createElement("g",{style:{mixBlendMode:"screen"},opacity:.5},v1||(v1=i.createElement("ellipse",{cx:97.4852,cy:34.4693,rx:60.9646,ry:31.3357,transform:"rotate(167.002 97.4852 34.4693)",fill:"#D3EFF8"})))),y1||(y1=i.createElement("rect",{x:32.3228,y:86.129,width:34.8387,height:42.5806,fill:"#D3EFF8"})),i.createElement("mask",{id:"mask1_1767_8925",style:{maskType:"alpha"},maskUnits:"userSpaceOnUse",x:32,y:86,width:36,height:43},b1||(b1=i.createElement("rect",{x:32.3228,y:86.129,width:34.8387,height:42.5806,fill:"#D3EFF8"}))),_1||(_1=i.createElement("g",{mask:"url(#mask1_1767_8925)"},i.createElement("ellipse",{cx:70.2223,cy:105.413,rx:39.3548,ry:23.2258,transform:"rotate(140.106 70.2223 105.413)",fill:"#A7DFF1"}))),A1||(A1=i.createElement("rect",{x:157.483,y:35.8065,width:34.8387,height:42.5806,fill:"#A7DFF1"})),E1||(E1=i.createElement("rect",{x:76.1934,y:35.8065,width:73.5484,height:42.5806,fill:"#D3EFF8"})),i.createElement("mask",{id:"mask2_1767_8925",style:{maskType:"alpha"},maskUnits:"userSpaceOnUse",x:76,y:35,width:74,height:44},w1||(w1=i.createElement("rect",{x:76.1934,y:35.8065,width:73.5484,height:42.5806,fill:"#D3EFF8"}))),i.createElement("g",{mask:"url(#mask2_1767_8925)"},x1||(x1=i.createElement("ellipse",{cx:146.121,cy:53.8405,rx:39.3548,ry:31.3357,transform:"rotate(50.1064 146.121 53.8405)",fill:"#A7DFF1"})),i.createElement("g",{style:{mixBlendMode:"screen"},opacity:.5},k1||(k1=i.createElement("ellipse",{cx:97.4852,cy:34.4688,rx:60.9646,ry:31.3357,transform:"rotate(167.002 97.4852 34.4688)",fill:"#D3EFF8"})))),i.createElement("mask",{id:"mask3_1767_8925",style:{maskType:"alpha"},maskUnits:"userSpaceOnUse",x:157,y:35,width:36,height:44},C1||(C1=i.createElement("rect",{x:157.484,y:35.8065,width:34.8387,height:42.5806,fill:"#7BCEEA"}))),S1||(S1=i.createElement("g",{mask:"url(#mask3_1767_8925)"},i.createElement("ellipse",{cx:146.122,cy:53.8405,rx:39.3548,ry:31.3357,transform:"rotate(50.1064 146.122 53.8405)",fill:"#A7DFF1"}))),M1||(M1=i.createElement("rect",{x:76.1934,y:86.129,width:33.5484,height:42.5806,fill:"#D3EFF8"})),i.createElement("mask",{id:"mask4_1767_8925",style:{maskType:"alpha"},maskUnits:"userSpaceOnUse",x:76,y:86,width:34,height:43},T1||(T1=i.createElement("rect",{x:76.1934,y:86.129,width:33.5484,height:42.5806,fill:"#D3EFF8"}))),O1||(O1=i.createElement("g",{mask:"url(#mask4_1767_8925)"},i.createElement("ellipse",{cx:70.2223,cy:105.413,rx:39.3548,ry:23.2258,transform:"rotate(140.106 70.2223 105.413)",fill:"#A7DFF1"}))),D1||(D1=i.createElement("g",{filter:"url(#filter1_d_1767_8925)"},i.createElement("rect",{x:117.484,y:86.129,width:104.516,height:59.3548,rx:6,fill:"#4FBEE3"}))),i.createElement("mask",{id:"mask5_1767_8925",style:{maskType:"alpha"},maskUnits:"userSpaceOnUse",x:117,y:86,width:105,height:60},L1||(L1=i.createElement("rect",{x:117.484,y:86.129,width:104.516,height:59.3548,rx:6,fill:"#7BCEEA"}))),i.createElement("g",{mask:"url(#mask5_1767_8925)"},P1||(P1=i.createElement("ellipse",{cx:192.558,cy:94.5137,rx:65.8064,ry:46.4516,transform:"rotate(23.7623 192.558 94.5137)",fill:"#23AEDC"})),i.createElement("g",{style:{mixBlendMode:"screen"},opacity:.1},I1||(I1=i.createElement("ellipse",{cx:121.355,cy:73.2121,rx:46.4988,ry:64.1038,transform:"rotate(23.7623 121.355 73.2121)",fill:"#D3EFF8"})))),B1||(B1=i.createElement("path",{d:"M45.1313 53.2689C44.2144 53.0258 42.8238 52.8567 42.1084 53.6071C40.0326 55.7209 43.1161 60.4242 44.7283 61.4177L45.1313 53.2689Z",fill:"#D3EFF8"})),R1||(R1=i.createElement("path",{d:"M59.6817 50.9963C59.2929 49.5532 58.4654 48.2828 57.3249 47.3785C56.1844 46.4742 54.7934 45.9854 53.3637 45.9866H50.8849C49.4543 45.9819 48.0618 46.4693 46.9206 47.3742C45.7795 48.2791 44.9526 49.5514 44.5669 50.9963C42.7028 57.9825 41.1711 69.8198 52.1243 69.8198C63.0774 69.8198 61.5357 57.9825 59.6817 50.9963Z",fill:"#D3EFF8"})),N1||(N1=i.createElement("path",{d:"M55.5789 58.9516C55.6175 59.1231 55.6638 59.298 55.7223 59.4742C56.2483 61.0589 56.6649 62.5806 54.9952 62.5806V62.5806",stroke:"#1C8BB0",strokeWidth:.5,strokeLinecap:"round"})),F1||(F1=i.createElement("path",{d:"M38.7744 78.3871C38.7744 76.2492 40.5075 74.5161 42.6454 74.5161H60.7099C62.8478 74.5161 64.5809 76.2492 64.5809 78.3871V78.3871H38.7744V78.3871Z",fill:"#0C547D"})),j1||(j1=i.createElement("path",{d:"M54.4975 69.3549H50.1553L49.2474 74.4222C49.1606 74.9066 49.4381 75.3877 49.9152 75.5079C51.4949 75.9061 53.1512 75.906 54.7309 75.5077C55.2076 75.3875 55.485 74.9071 55.3989 74.4231L54.4975 69.3549Z",fill:"#D3EFF8"})),Y1||(Y1=i.createElement("path",{d:"M48.5573 49.8867C49.3167 50.5732 50.2956 50.933 51.2974 50.8938C52.2992 50.8546 53.2499 50.4193 53.9583 49.6753C54.5194 50.3129 55.2413 50.7705 56.0404 50.995C56.8394 51.2195 57.6828 51.2016 58.4726 50.9436C59.1393 50.7353 59.7209 50.3003 60.1259 49.7071C60.531 49.1139 60.7363 48.3963 60.7096 47.6672C60.5484 46.1452 59.2183 45.2469 57.999 44.7712C56.27 44.0947 54.4277 43.7945 52.5844 43.889C50.7412 43.9835 48.9355 44.4707 47.2776 45.3208C45.5014 46.1446 43.9698 47.4553 42.844 49.1151C41.8363 50.7428 42.2293 52.9623 44.0027 53.3428C45.7762 53.7232 47.983 52.0005 48.5573 49.8867Z",fill:"#002B4C"})),$1||($1=i.createElement("path",{d:"M43.2473 62.2101C42.0619 62.2101 41.101 61.2022 41.101 59.9589C41.101 58.7155 42.0619 57.7076 43.2473 57.7076C44.4326 57.7076 45.3936 58.7155 45.3936 59.9589C45.3936 61.2022 44.4326 62.2101 43.2473 62.2101Z",fill:"#A7DFF1"})),H1||(H1=i.createElement("path",{d:"M42.7027 49.3366C39.82 49.3366 37.4831 46.8855 37.4831 43.8619C37.4831 40.8382 39.82 38.3871 42.7027 38.3871C45.5855 38.3871 47.9224 40.8382 47.9224 43.8619C47.9224 46.8855 45.5855 49.3366 42.7027 49.3366Z",fill:"#002B4C"})),U1||(U1=i.createElement("path",{d:"M186.868 99.3375C185.197 98.4192 183.33 97.9203 181.426 97.8835C180.467 97.9001 179.542 98.2434 178.803 98.8571C178.063 99.4708 177.553 100.319 177.356 101.262C176.133 100.759 174.773 100.703 173.513 101.103C172.252 101.502 171.171 102.332 170.456 103.448C169.777 104.62 169.5 105.984 169.67 107.329C169.839 108.675 170.444 109.927 171.392 110.893C170.165 111.083 169.031 111.662 168.154 112.545C167.277 113.428 166.703 114.568 166.516 115.801C166.36 117.048 166.596 118.313 167.191 119.419C167.786 120.525 168.711 121.415 169.836 121.967C168.66 123.628 167.971 125.585 167.844 127.619C167.898 130.067 170.706 133.085 172.926 130.975C173.722 132.153 174.945 132.973 176.333 133.26C178.422 133.675 180.588 132.8 182.71 133.019C184.528 133.205 186.596 134.112 188.032 132.943C188.467 132.582 188.783 132.046 189.295 131.795C190.383 131.292 191.809 132.101 192.864 132.265C194.364 132.487 195.893 132.424 197.37 132.079C198.071 131.957 198.724 131.639 199.253 131.161C199.508 130.881 199.679 130.534 199.744 130.16C199.81 129.786 199.768 129.401 199.623 129.051C202.006 128.657 204.433 128.307 205.913 126.034C207.263 123.967 206.718 120.568 204.476 119.682C205.693 119.033 206.658 117.993 207.218 116.729C207.778 115.465 207.901 114.05 207.567 112.707C207.198 111.392 206.385 110.246 205.267 109.466C204.149 108.686 202.796 108.321 201.44 108.433C201.918 107.286 202.198 106.066 202.267 104.825C202.295 104.208 202.166 103.594 201.892 103.041C201.617 102.489 201.207 102.015 200.7 101.666C199.351 100.89 197.816 101.557 196.488 101.972C197.577 101.622 195.803 98.933 195.4 98.5832C194.865 98.1807 194.235 97.9245 193.572 97.8398C192.419 97.6402 191.237 97.6999 190.111 98.0147C189.36 98.2552 187.629 99.6655 186.868 99.3375Z",fill:"#A7DFF1"})),z1||(z1=i.createElement("path",{d:"M193.08 115.911C194.071 115.66 195.573 115.485 196.345 116.261C198.587 118.448 195.257 123.312 193.516 124.34L193.08 115.911Z",fill:"#002B4C"})),W1||(W1=i.createElement("path",{d:"M178.129 110.908C178.497 109.346 180.52 107.97 181.598 106.991C182.676 106.012 183.991 105.483 185.342 105.484H187.686C189.038 105.479 190.354 106.007 191.433 106.986C192.512 107.966 193.293 109.344 193.658 110.908C195.42 118.473 194.287 131.29 183.933 131.29C173.579 131.29 176.377 118.473 178.129 110.908Z",fill:"#002B4C"})),V1||(V1=i.createElement("path",{d:"M181.355 119.677C181.301 119.909 181.233 120.147 181.142 120.387C180.533 121.975 180.101 123.418 181.798 123.541C181.867 123.546 181.935 123.548 182.001 123.548",stroke:"#D3EFF8",strokeWidth:.5,strokeLinecap:"round"})),G1||(G1=i.createElement("path",{d:"M171.678 141.452C171.678 138.69 173.916 136.452 176.678 136.452H196.355C199.117 136.452 201.355 138.69 201.355 141.452V145.484H171.678V141.452Z",fill:"#D3EFF8"})),Q1||(Q1=i.createElement("path",{d:"M182.516 129.783H188.632L189.976 137.421C190.061 137.903 189.786 138.379 189.316 138.513C186.873 139.208 184.285 139.208 181.842 138.512C181.372 138.379 181.097 137.903 181.181 137.422L182.516 129.783Z",fill:"#002B4C"})),q1||(q1=i.createElement("path",{d:"M189.9 110.704C188.991 111.422 187.909 111.709 186.875 111.508C185.84 111.307 184.931 110.633 184.332 109.622C183.635 110.309 182.804 110.755 181.933 110.91C181.062 111.065 180.186 110.922 179.406 110.499C178.748 110.144 178.219 109.528 177.904 108.748C177.589 107.967 177.504 107.067 177.664 106.189C178.103 104.378 179.644 103.511 180.997 103.124C182.915 102.567 184.884 102.484 186.785 102.879C188.686 103.273 190.477 104.138 192.05 105.419C193.748 106.689 195.106 108.504 195.985 110.677C196.742 112.808 195.94 115.413 194.028 115.6C192.116 115.787 190.128 113.37 189.9 110.704Z",fill:"#A7DFF1"})),K1||(K1=i.createElement("path",{d:"M194.258 124.839C193.189 124.839 192.322 123.972 192.322 122.903C192.322 121.834 193.189 120.968 194.258 120.968C195.327 120.968 196.193 121.834 196.193 122.903C196.193 123.972 195.327 124.839 194.258 124.839Z",fill:"#FDFEFE"})),Z1||(Z1=i.createElement("circle",{opacity:.7,cx:136.839,cy:105.484,r:9.03226,fill:"white"})),J1||(J1=i.createElement("defs",null,i.createElement("filter",{id:"filter0_d_1767_8925",x:0,y:0,width:220.646,height:169.032,filterUnits:"userSpaceOnUse",colorInterpolationFilters:"sRGB"},i.createElement("feFlood",{floodOpacity:0,result:"BackgroundImageFix"}),i.createElement("feColorMatrix",{in:"SourceAlpha",type:"matrix",values:"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",result:"hardAlpha"}),i.createElement("feOffset",{dx:-2,dy:10}),i.createElement("feGaussianBlur",{stdDeviation:10}),i.createElement("feComposite",{in2:"hardAlpha",operator:"out"}),i.createElement("feColorMatrix",{type:"matrix",values:"0 0 0 0 0.317647 0 0 0 0 0.392157 0 0 0 0 0.423529 0 0 0 0.25 0"}),i.createElement("feBlend",{mode:"normal",in2:"BackgroundImageFix",result:"effect1_dropShadow_1767_8925"}),i.createElement("feBlend",{mode:"normal",in:"SourceGraphic",in2:"effect1_dropShadow_1767_8925",result:"shape"})),i.createElement("filter",{id:"filter1_d_1767_8925",x:95.4839,y:76.129,width:144.516,height:99.3549,filterUnits:"userSpaceOnUse",colorInterpolationFilters:"sRGB"},i.createElement("feFlood",{floodOpacity:0,result:"BackgroundImageFix"}),i.createElement("feColorMatrix",{in:"SourceAlpha",type:"matrix",values:"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",result:"hardAlpha"}),i.createElement("feOffset",{dx:-2,dy:10}),i.createElement("feGaussianBlur",{stdDeviation:10}),i.createElement("feComposite",{in2:"hardAlpha",operator:"out"}),i.createElement("feColorMatrix",{type:"matrix",values:"0 0 0 0 0.317647 0 0 0 0 0.392157 0 0 0 0 0.423529 0 0 0 0.25 0"}),i.createElement("feBlend",{mode:"normal",in2:"BackgroundImageFix",result:"effect1_dropShadow_1767_8925"}),i.createElement("feBlend",{mode:"normal",in:"SourceGraphic",in2:"effect1_dropShadow_1767_8925",result:"shape"})))))},n2=(0,i.forwardRef)(t2);o.p;var r2,o2=fr(wr)((function(){return"\n        align-items: flex-start;\n        gap: 9px;\n        margin-bottom: 12px;\n    "})),i2=fr(wr)((function(e){var t=e.theme;return"\n        background: "+t.colors.navy[700]+";\n        height: 260px;\n        padding: 40px;\n        width: 100%;\n\n        "+t.responsive.smallScreenOnly(r2||(r2=zM(["\n            height: auto;\n            margin-bottom: 36px;\n            order: 1;\n            padding: 36px 16px 32px;\n        "])))+"\n\n        h3, h5, p {\n            color: "+t.colors.white+";\n            line-height: 25px;\n        }\n    "})),a2=fr(_r,{shouldForwardProp:function(e){return"hasSaleIcon"!==e}})((function(e){var t=e.hasSaleIcon,n=void 0!==t&&t;return"\n        height: "+(n?194:179)+"px;\n        margin-bottom: -"+(n?42:33)+"px;\n        margin-right: -"+(n?4:18)+"px;\n        width: "+(n?232:240)+"px;\n\n        "+e.theme.responsive.smallScreenOnly("\n            height: "+(n?106:139)+"px;\n            margin-bottom: "+(n?12:-26)+"px;\n            margin-right: -"+(n?1:12)+"px;\n            margin-top: -"+(n?18:8)+"px;\n            width: "+(n?180:186)+"px;\n        ")+"\n\n        svg {\n            width: 100%;\n        }\n    "})),s2=fr(iX)((function(e){var t=e.theme;return"\n        height: 14px;\n        width: 14px;\n\n        circle {\n            stroke: "+t.colors.blue[500]+";\n        }\n\n        path {\n            fill: "+t.colors.blue[500]+";\n        }\n    "})),l2=function(e){var t,n=e.currentPlan,r=e.planPricingInfo,o=(null==r?void 0:r.promo)&&!r.promoError,a=Co("studio.plan.trialCheckout.payScreen.planHeroBox"),s=Hq(n);return i.createElement(i2,{justifyContent:"space-between"},i.createElement(wr,{flexDirection:"column",justifyContent:"space-between"},i.createElement(xF,{"data-testid":"plan-name",margin:"0 0 16px"},s?a("bookingPlan"):n.name),i.createElement(wr,{flex:"1",flexDirection:"column",marginTop:"4px"},null!=r&&r.promo&&!r.promoError&&r.promo.headline?i.createElement(i.Fragment,null,i.createElement(UI,{"data-testid":"promo-headline",marginBottom:0},r.promo.headline),i.createElement(Px,{"data-testid":"promo-description"},r.promo.description)):(t=[],s&&t.push.apply(t,[a("clientBooking"),a("shareAvailability"),a("capturePayments")]),Uq(n)&&!n.isFeatureGated&&(n.isFree?t.push.apply(t,[a("upTo100Photos"),a("fiveMobileApps"),a("noInvoicesOrContracts")]):t.push.apply(t,[a("unlimitedGalleries"),a("accessAllFeatures")]),n.isUnlimited&&t.push(a("freeArchiving"))),t).map((function(e){return i.createElement(o2,{key:e},i.createElement(_r,{minHeight:"14px",minWidth:"14px",marginTop:"5px"},i.createElement(s2,null)),i.createElement(Px,{margin:"1px 0 0 !important"},e))})))),i.createElement(wr,{alignItems:"flex-end",flexDirection:"column"},i.createElement(a2,{hasSaleIcon:o},s?i.createElement(f0,{"data-testid":"booking-icon"}):o?i.createElement(c1,{"data-testid":"hero-window-sale-icon"}):i.createElement(n2,{"data-testid":"hero-window-icon"}))))};const c2=(0,i.memo)(l2);const u2=function(e,t){var r,o,a=hO().me,s=xK().planPricingInfo,l=(a||{}).studio,c=null!=l?l:{},u=c.cardOnFile,d=c.country,p=zo("tax-rate",{defer:!0}),f=p.loading,h=p.performFetch,g=p.response,v=m(II("useCardOnFile"),1)[0].value,y=!!v&&!!g,b=5===(null==e||null===(r=e.zipCode)||void 0===r?void 0:r.length),_=y||!v&&b&&!!g;return(0,i.useEffect)((function(){if("US"===d){var r=void 0!==(null==t?void 0:t.price)&&(null==t?void 0:t.price)>0;if((!(null!=s&&s.planId)||(null==t?void 0:t.uuid)===(null==s?void 0:s.planId))&&r&&(b||u&&v)){var o,i,a=null!==(o=null==s||null===(i=s.promo)||void 0===i?void 0:i.discountedPrice)&&void 0!==o?o:null==t?void 0:t.price;h({search:n({basePrice:a.toString()},u&&v?{}:{city:null==e?void 0:e.city,state:null==e?void 0:e.state,street:null==e?void 0:e.street,zipCode:null==e?void 0:e.zipCode})})}}}),[e,u,d,null==t?void 0:t.price,null==t?void 0:t.uuid,h,b,null==s?void 0:s.planId,null==s||null===(o=s.promo)||void 0===o?void 0:o.discountedPrice,v]),{loadingTaxRate:f,shouldShowTaxLineItem:_,taxRateResponse:g}};var d2,p2,f2,h2,m2,g2,v2,y2,b2=fr(wr)((function(e){return"\n        align-items: center;\n        justify-content: center;\n        padding: 40px 0 20px 0;\n        width: 100%;\n\n        "+e.theme.responsive.smallScreenOnly(d2||(d2=zM(["\n            order: 4;\n            padding-left: 16px;\n            padding-right: 16px;\n        "])))+"\n    "})),_2=fr(wr)((function(e){var t=e.theme;return"\n        height: 100%;\n        justify-content: space-between;\n        width: 100%;\n\n        "+t.responsive.smallScreenOnly(p2||(p2=zM(["\n            flex-direction: column;\n        "])))+"\n\n        h2 {\n            color: "+t.colors.navy[700]+";\n        }\n    "})),A2=fr(_r)((function(e){var t=e.theme;return"\n        "+t.responsive.smallScreenOnly("\n            border-bottom: 1px solid "+t.colors.gray[200]+";\n            margin-bottom: 27px;\n            margin-left: 16px;\n            margin-right: 16px;\n            order: 2;\n            padding-bottom: 36px;\n        ")+"\n    "})),E2=fr(wr)((function(e){return"\n        flex-direction: column;\n        margin-top: 56px;\n        max-width: 490px;\n        width: 100%;\n\n        "+e.theme.responsive.smallScreenOnly(f2||(f2=zM(["\n            display: contents;\n            margin-top: 0;\n            max-width: 100%;\n        "])))+"\n    "})),w2=fr(_r)((function(e){var t=e.theme;return"\n        height: 100%;\n\n        "+t.responsive.mediumScreenUp(h2||(h2=zM(["\n            padding: 30px 40px 0px 40px;\n        "])))+"\n\n        "+t.responsive.smallScreenOnly(m2||(m2=zM(["\n            order: 3;\n            padding-left: 16px;\n            padding-right: 16px;\n        "])))+"\n    "})),x2=fr(wr)((function(e){var t=e.theme;return"\n        background: "+t.colors.white+";\n        border-radius: 12px;\n        box-shadow: -2px 10px 20px rgba(81, 100, 108, 0.1);\n        flex-direction: column;\n        margin: 40px 0 40px 0;\n        max-width: 490px;\n        overflow: hidden;\n        width: 100%;\n\n        "+t.responsive.smallScreenOnly(g2||(g2=zM(["\n            border-radius: 0;\n            display: contents;\n            margin: 0;\n            max-width: 100%;\n        "])))+"\n    "})),k2=fr(wr,{shouldForwardProp:function(e){return"hasGrayBackground"!==e}})((function(e){var t=e.hasGrayBackground,n=void 0!==t&&t,r=e.theme;return"\n        "+(n?"background: "+r.colors.gray[100]:"")+";\n        justify-content: center;\n        overflow-y: auto;\n        width: 100%;\n\n        "+r.responsive.smallScreenOnly(v2||(v2=zM(["\n            display: contents;\n            overflow-y: initial;\n        "])))+"\n    "})),C2=fr(fp)((function(e){return"\n        font-size: 14px;\n        height: 44px;\n        width: 236px;\n\n        "+e.theme.responsive.smallScreenOnly(y2||(y2=zM(["\n            margin-bottom: 27px;\n            width: 100%;\n        "])))+"\n    "}));const S2=function(e){var t=e.enterPlanSelectScreen,n=e.onSubscribe,r=e.isInBookingTrial,o=e.isInTrial,a=e.isFree,s=e.isDowngrade,l=mI().isValid,c=hO().me,u=xK(),d=u.allAvailablePlans,p=u.defaultPlanUuid,f=u.planPricingInfo,h=u.planType,g=(null==c?void 0:c.studio)||{},v=g.cardOnFile,y=g.hasStudioUsedBooking,b=g.photoPlan,_=g.nextBillDate,A=g.nextBookingBillDate,E=m(II("planUuid"),1)[0].value,w=m(II("promoCode"),3)[2].setValue,x=(0,i.useCallback)((function(e){return e&&Hq(e)?d.find((function(t){return t.planPeriod!==e.planPeriod})):d.filter(Uq).find((function(t){return t.band===(null==e?void 0:e.band)&&t.uuid!==E}))}),[d,E]),k=(0,i.useMemo)((function(){return d.find((function(e){return e.uuid===E}))}),[d,E]),C=m(II("useCardOnFile"),1)[0].value,S=iK(h,_,A,y,o,s),M=m((0,i.useState)(v&&C?{street:"",city:"",state:"",zipCode:""}:null),2),T=M[0],O=M[1],D=u2(T,k),L=D.loadingTaxRate,P=D.shouldShowTaxLineItem,I=D.taxRateResponse,B=Co("studio.plan.trialCheckout.payScreen"),R=Co("studio.plan.trialCheckout.alertSection"),N=x(k);if(!k)return null;var F=null==N?void 0:N.price,j=null==N?void 0:N.uuid,Y="yearly"===k.planPeriod?k.price:F,$="monthly"===k.planPeriod?k.price:F,H=$&&12*$,U=Hq(k)&&!y,z=(Uq(k)&&(null==b?void 0:b.isInTrial)||Hq(k)&&r||Hq(k)&&U)&&0!==k.price,W=Y&&$&&j&&(Hq(k)||!k.isFree),V=o||a||!s,G=0===k.price,Q=p&&!V&&S&&Uq(k),q=o&&!v&&"booking"===h;return i.createElement(_2,{"data-testid":"trial-checkout-pay-screen"},i.createElement(k2,{"data-testid":"form"},i.createElement(E2,null,i.createElement(A2,null,W&&i.createElement(GZ,{annualPrice:Y,disableOptions:L,monthlyPrice:$,currencyCode:k.currencyCode,sameBandPlanId:j}),i.createElement(ZJ,{cardOnFile:v,currentPlan:k,setAddressForTaxCalculation:O}),G&&i.createElement(eX,null)),Q&&i.createElement(Nq,{alertType:Bq.ALERT,description:R("paidThrough"),jsNextBillDate:S,notice:R("downgradeNotice")}),q&&i.createElement(Nq,{alertType:Bq.WARNING,description:R("subscribingToBookingAndPhoto")}),i.createElement(b2,null,i.createElement(C2,{"data-testid":G?"switch-to-free-plan-button":"subscribe-button",isDisabled:!l&&0!==$,loadingText:B(G?"switchingToFreePlan":"subscribing"),onClick:n},B(G?"switchToFreePlan":"subscribeNow"))),z&&i.createElement(Px,{textAlign:"center"},B("cardChargedOn"),i.createElement("span",null,null==S?void 0:S.toLocaleDateString(void 0,{year:"numeric",month:"short",day:"numeric"}))))),i.createElement(k2,{hasGrayBackground:!0},k&&i.createElement(x2,null,i.createElement(c2,{currentPlan:k,planPricingInfo:f}),i.createElement(w2,null,i.createElement(RZ,{annualizedMonthlyPrice:H,billingFrequency:k.planPeriod,currencyCode:k.currencyCode,onApplyPromo:w,planName:Hq(k)?B("bookingPlan"):k.name,planPrice:k.price,promo:null==f?void 0:f.promo,promoError:null==f?void 0:f.promoError,showPromo:"photo"===h||"booking"===h,taxData:I&&P?{amountToCollect:null==I?void 0:I.amountToCollect,rate:null==I?void 0:I.rate}:void 0,onChangePlan:Hq(k)?void 0:t})))))};var M2=yr(((e,t)=>(0,br.jsx)(Jp,{align:"center",...e,direction:"column",ref:t})));M2.displayName="VStack";var[T2,O2]=xr({name:"ListStylesContext",errorMessage:"useListStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<List />\" "}),D2=yr((function(e,t){const n=jr("List",e),{children:r,styleType:o="none",stylePosition:i,spacing:a,...s}=pt(e),l=Zp(r),c="& > *:not(style) ~ *:not(style)",u=a?{[c]:{mt:a}}:{};return(0,br.jsx)(T2,{value:n,children:(0,br.jsx)(vr.ul,{ref:t,listStyleType:o,listStylePosition:i,role:"list",__css:{...n.container,...u},...s,children:l})})}));D2.displayName="List",yr(((e,t)=>{const{as:n,...r}=e;return(0,br.jsx)(D2,{ref:t,as:"ol",styleType:"decimal",marginStart:"1em",...r})})).displayName="OrderedList";var L2=yr((function(e,t){const{as:n,...r}=e;return(0,br.jsx)(D2,{ref:t,as:"ul",styleType:"initial",marginStart:"1em",...r})}));L2.displayName="UnorderedList";var P2=yr((function(e,t){const n=O2();return(0,br.jsx)(vr.li,{ref:t,...e,__css:n.item})}));P2.displayName="ListItem";var I2=yr((function(e,t){const n=O2();return(0,br.jsx)(Jk,{ref:t,role:"presentation",...e,__css:n.icon})}));function B2(e){const{leastDestructiveRef:t,...n}=e;return(0,br.jsx)(sB,{...n,initialFocusRef:t})}I2.displayName="ListIcon";var R2=yr(((e,t)=>(0,br.jsx)(uF,{ref:t,role:"alertdialog",...e})));const N2="account-closure-request";function F2(e){if(null==e)throw new TypeError("Cannot destructure "+e)}var j2,Y2,$2=o(49739),H2=o.n($2),U2=Gd(UJ()),z2=Ak()(H2()(bk),U2),W2=null===(j2=bk.styles)||void 0===j2?void 0:j2.global,V2=null===(Y2=U2.styles)||void 0===Y2?void 0:Y2.global,G2=z2.styles&&"object"===wC(z2.styles)?Object.entries(z2.styles).filter((function(e){return"global"!==m(e,1)[0]})):[];z2.styles=n({},Object.fromEntries(G2),{global:function(e){var t,n,r="function"==typeof W2?null!==(t=W2(e))&&void 0!==t?t:{}:W2&&"object"===wC(W2)?W2:{},o="function"==typeof V2?null!==(n=V2(e))&&void 0!==n?n:{}:V2&&"object"===wC(V2)?V2:{};return Ak()({},r,o)}});var Q2=z2,q2=function(){return{theme:Q2}},K2=function(e){return(0,i.memo)((function(t){var r=n({},(F2(t),t)),o=q2().theme;return o?i.createElement(Uk,{cssVarsRoot:"body",resetCSS:!1,theme:o},i.createElement(e,r)):null}))};const Z2=q2;var J2="closing-down",X2="missing-feature",e4="other",t4="switching-providers",n4="technical-issue",r4="too-difficult",o4="too-expensive",i4=[X2,t4,n4],a4=[J2,X2,o4,n4,r4,t4];var s4=kC(kC(kC(kC(kC(kC(kC({},J2,"reasons.closingDown"),X2,"reasons.missingFeature"),e4,"reasons.other"),t4,"reasons.switchingProviders"),n4,"reasons.technicalIssue"),r4,"reasons.tooDifficult"),o4,"reasons.tooExpensive"),l4=kC(kC(kC({},X2,"reasonDetails.missingFeature"),t4,"reasonDetails.switchingProviders"),n4,"reasonDetails.technicalIssue"),c4={as:"span",display:"block",margin:0,mb:0},u4=function(e){var t=e.reason,r=e.reasonDetails,o=e.reasonOther,a=e.randomizedReasons,s=e.onReasonChange,l=e.onReasonDetailsChange,c=e.onReasonOtherChange,u=e.t,d=t?l4[t]:void 0,p=t===t4?"otherDetailsHeaderSwitchingProviders":"otherDetailsHeader";return i.createElement(_r,{"data-testid":"account-closure-survey-step",sx:h4},i.createElement(M2,{spacing:6,align:"stretch"},i.createElement(M2,{spacing:3,align:"stretch"},i.createElement(qr,n({},c4,{color:"neutral.600",fontSize:"md",fontWeight:"600"}),u("surveyHeader")),i.createElement(qr,n({},c4,{color:"neutral.600",fontSize:"md"}),u("surveySubtitle"))),i.createElement(Mp,{margin:0},i.createElement(wp,{"data-testid":"account-closure-reason-radio-group",value:t,onChange:function(e){return s(e)}},i.createElement(M2,{spacing:4,align:"start"},a.map((function(e){return i.createElement(Qp,{key:e,bg:"white","data-testid":"account-closure-reason-"+e+"-radio",size:"lg",spacing:3,sx:m4,value:e},i.createElement(qr,n({},c4,{color:"neutral.600",fontSize:"md"}),u(s4[e])))}))))),t&&i4.includes(t)&&d&&i.createElement(Mp,{isRequired:!0,margin:0},i.createElement(Xp,{color:"neutral.600",fontSize:"md",fontWeight:"medium",marginBottom:2},u(d)),i.createElement(dz,{"data-testid":"account-closure-reason-"+t+"-details-input",maxLength:255,onChange:function(e){return l(e.target.value)},value:r})),i.createElement(Mp,{isRequired:t===e4,margin:0},i.createElement(Xp,{color:"neutral.600",fontSize:"md",fontWeight:"medium",marginBottom:2},u(p)),i.createElement(rW,{"data-testid":"account-closure-reason-other-textarea",maxLength:1e3,onChange:function(e){return c(e.target.value)},placeholder:u("otherDetailsPlaceholder"),value:o}))))},d4=function(e){var t=e.formattedNextBillDate,r=e.isConfirmed,o=e.error,a=e.onConfirmedChange,s=e.t;return i.createElement(_r,{"data-testid":"account-closure-warning-step",sx:h4},i.createElement(M2,{spacing:4,align:"stretch"},i.createElement(qr,n({},c4,{color:"neutral.600",fontSize:"md"}),s("warning")," ",i.createElement(qr,{as:"span",fontWeight:"600"},t)),i.createElement(qr,n({},c4,{color:"error.500",fontSize:"md",fontWeight:"600"}),s("dataWarning")),i.createElement(L2,{color:"neutral.600",fontSize:"md",pl:6,spacing:1,stylePosition:"outside",styleType:"disc",sx:{li:{marginBottom:0}}},i.createElement(P2,null,s("deletePhotos")),i.createElement(P2,null,s("deleteApps")),i.createElement(P2,null,s("deleteSettings"))),i.createElement(qr,n({},c4,{color:"neutral.600",fontSize:"md"}),s("noRefundNotice"),i.createElement(Kr,{color:"secondary.400","data-testid":"account-closure-warning-terms-of-use-link",href:"https://www.shootproof.com/legal/terms-of-use/",isExternal:!0},s("termsOfUse")),"."),o&&i.createElement(qr,n({},c4,{color:"error.500",fontSize:"md",fontWeight:"600"}),o),i.createElement(wr,{align:"center",gap:2},i.createElement(jU,{colorScheme:"primary","data-testid":"account-closure-warning-confirm-checkbox",isChecked:r,onChange:function(e){return a(e.target.checked)},sx:{marginBottom:"0 !important"}}),i.createElement(qr,n({},c4,{color:"neutral.600",fontSize:"md"}),s("confirm")))))},p4=function(e){var t=e.formattedNextBillDate,r=e.t;return i.createElement(_r,{"data-testid":"account-closure-success-step",sx:h4},i.createElement(M2,{spacing:4,align:"stretch"},i.createElement(qr,n({},c4,{color:"neutral.600",fontSize:"md"}),r("success")," ",i.createElement(qr,{as:"span",fontWeight:"600"},t)),i.createElement(qr,n({},c4,{color:"neutral.600",fontSize:"md",fontStyle:"italic"}),r("downloadNotice")," ",i.createElement(qr,{as:"span",fontWeight:"600"},r("downloadExpiry")))))},f4={".account-closure-button":{display:"inline-flex !important",marginBottom:"0 !important",width:"auto !important",span:{color:"inherit !important",fontSize:"inherit !important",fontWeight:"inherit !important",lineHeight:"inherit !important"}},".account-closure-button--primary":{"&:hover:not(:disabled), &:focus:not(:disabled)":{backgroundColor:"var(--chakra-colors-primary-500) !important",borderColor:"var(--chakra-colors-primary-500) !important",color:"white !important"}},".account-closure-button--secondary":{"&:hover:not(:disabled), &:focus:not(:disabled)":{backgroundColor:"var(--chakra-colors-neutral-200) !important",borderColor:"transparent !important",color:"var(--chakra-colors-primary-400) !important"}},".account-closure-button--destructive":{"&:hover:not(:disabled), &:focus:not(:disabled)":{backgroundColor:"var(--chakra-colors-error-600) !important",borderColor:"var(--chakra-colors-error-600) !important",color:"white !important"}},".chakra-modal__close-btn":{"&:hover":{backgroundColor:"transparent !important",color:"var(--chakra-colors-neutral-600) !important"}}},h4={p:{margin:"0 !important",marginBottom:"0 !important"},"label.chakra-radio":{alignItems:"center",display:"flex !important",fontWeight:"normal !important",gap:"12px",marginBottom:"0 !important",color:"var(--chakra-colors-neutral-600)"},".chakra-radio__control":{flexShrink:0,marginTop:"0 !important"},".chakra-radio__label":{margin:"0 !important",paddingInlineStart:"0 !important"},".chakra-radio__label p":{margin:"0 !important"},".chakra-form__label":{color:"var(--chakra-colors-neutral-600)",fontWeight:"600 !important",marginBottom:"8px !important"},".chakra-form__required-indicator":{color:"var(--chakra-colors-error-500)",marginInlineStart:"4px"}},m4={alignItems:"center",gap:"12px",marginBottom:"0 !important"};const g4=K2((function(e){var t=e.isOpen,n=e.onCancelAccount,r=e.onClose,o=m((0,i.useState)("survey"),2),a=o[0],s=o[1],l=m((0,i.useState)(""),2),c=l[0],u=l[1],d=m((0,i.useState)(""),2),p=d[0],f=d[1],h=m((0,i.useState)(""),2),g=h[0],v=h[1],y=m((0,i.useState)([]),2),b=y[0],_=y[1],A=m((0,i.useState)(!1),2),E=A[0],w=A[1],x=m((0,i.useState)(null),2),k=x[0],C=x[1],S=(0,i.useRef)(null),M=Co("studio.account.accountClosureModal"),T=hO().me,O=zo("account-closure-request",{defer:!0,method:Fo.POST}),D=O.performFetch,L=O.loading,P=((null==T?void 0:T.studio)||{}).nextBillDate,I=P?new Date(P).toLocaleDateString(void 0,{year:"numeric",month:"long",day:"numeric"}):"",B=(0,i.useMemo)((function(){return function(e,t,n){return!(!e||i4.includes(e)&&!t.trim()||e===e4&&!n.trim())}(c,p,g)}),[c,p,g]),R=function(){s("survey"),u(""),f(""),v(""),_(function(){for(var e=[].concat(a4),t=[];e.length;){var n=Math.floor(Math.random()*e.length);t.push(e.splice(n,1)[0])}return[].concat(t,[e4])}()),w(!1),C(null)};(0,i.useEffect)((function(){t&&R()}),[t]);var N=function(){r(),R(),"success"===a&&n()},F=function(e){u(e),f(""),C(null)},j=function(){var e=Lo(Io().mark((function e(){var t;return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.prev=0,C(null),e.next=4,D({data:{type:N2,reason:c,reasonDetails:p.trim()||void 0,reasonOther:g.trim()||void 0}});case 4:if(!(!(t=e.sent)||t.status<200||t.status>299)){e.next=7;break}throw new Error("Failed to close account");case 7:s("success"),e.next=14;break;case 10:e.prev=10,e.t0=e.catch(0),console.error("Error closing account:",e.t0),C(M("error"));case 14:case"end":return e.stop()}}),e,null,[[0,10]])})));return function(){return e.apply(this,arguments)}}();return i.createElement(B2,{"data-testid":"account-closure-modal",isCentered:!0,isOpen:t,leastDestructiveRef:S,onClose:N,size:"lg"},i.createElement(vF,null,i.createElement(R2,{mx:4,sx:f4},i.createElement(dF,{fontSize:"xl",fontWeight:"600",color:"neutral.700"},M("title")),i.createElement(cB,{"data-testid":"account-closure-close-button",ref:S,backgroundColor:"transparent",color:"neutral.600",padding:0,_hover:{backgroundColor:"transparent"}}),i.createElement(_r,{"data-testid":"account-closure-modal-content"},i.createElement(lB,null,function(){switch(a){case"survey":return i.createElement(u4,{reason:c,reasonDetails:p,reasonOther:g,randomizedReasons:b,onReasonChange:F,onReasonDetailsChange:f,onReasonOtherChange:v,t:M});case"warning":return i.createElement(d4,{formattedNextBillDate:I,isConfirmed:E,error:k,onConfirmedChange:function(e){w(e),C(null)},t:M});case"success":return i.createElement(p4,{formattedNextBillDate:I,t:M});default:return null}}()),i.createElement(pF,{alignItems:"center",gap:3},function(){switch(a){case"survey":return i.createElement(i.Fragment,null,i.createElement(Wr,{className:"account-closure-button account-closure-button--secondary","data-testid":"account-closure-survey-keep-my-account-button",onClick:N,ref:S,size:"sm",variant:"secondary"},M("keepMyAccount")),i.createElement(Wr,{className:"account-closure-button account-closure-button--primary","data-testid":"account-closure-survey-continue-button",isDisabled:!B,onClick:function(){return s("warning")},size:"sm",variant:"primary"},M("continue")));case"warning":return i.createElement(i.Fragment,null,i.createElement(Wr,{className:"account-closure-button account-closure-button--secondary","data-testid":"account-closure-warning-back-button",onClick:function(){return s("survey")},size:"sm",variant:"secondary"},M("back")),i.createElement(Wr,{className:"account-closure-button account-closure-button--secondary","data-testid":"account-closure-warning-keep-my-account-button",onClick:N,size:"sm",variant:"secondary"},M("keepMyAccount")),i.createElement(Wr,{className:"account-closure-button account-closure-button--destructive","data-testid":"account-closure-warning-close-my-account-button",isDisabled:!E||L,isLoading:L,loadingText:M("submitting"),onClick:j,size:"sm",variant:"destructive"},M("closeMyAccount")));case"success":return i.createElement(Wr,{className:"account-closure-button account-closure-button--secondary","data-testid":"account-closure-success-ok-button",onClick:N,size:"sm",variant:"secondary"},M("ok"));default:return null}}())))))}));const v4=function(e){var t=e.hasCanceled,n=e.onCancelAccount,r=zF(),o=r.isOpen,a=r.onOpen,s=r.onClose,l=Co("studio.account.accountClosureModal");return i.createElement(i.Fragment,null,!t&&i.createElement(qr,{color:"neutral.600",fontSize:"md"},l("linkDescription"),","," ",i.createElement(Kr,{as:"button",color:"secondary.400",fontWeight:"bold",h:"auto",lineHeight:"inherit",minH:"unset",onClick:a,p:0,type:"button"},l("linkText")),"."),i.createElement(g4,{isOpen:o,onCancelAccount:n,onClose:s}))};const y4=$q((function(e){var t=e.onClose,n=e.onResubscribe,r=m((0,i.useState)(null),2),o=r[0],a=r[1],s=Co("studio.account.closeout.newFlow"),l=hO().me,c=zo("account-resubscribe-request",{data:{reason:"other"},defer:!0,method:Fo.POST}),u=c.performFetch,d=c.loading,p=((null==l?void 0:l.studio)||{}).nextBillDate,f=p?new Date(p).toLocaleDateString(void 0,{year:"numeric",month:"long",day:"numeric"}):"",h=function(){t(),a(null)},g=function(){var e=Lo(Io().mark((function e(){var t;return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.prev=0,a(null),e.next=4,u();case 4:if(!(!(t=e.sent)||t.status<200||t.status>299)){e.next=7;break}throw new Error("Failed to resubscribe account");case 7:n(),e.next=13;break;case 10:e.prev=10,e.t0=e.catch(0),a(s("error"));case 13:case"end":return e.stop()}}),e,null,[[0,10]])})));return function(){return e.apply(this,arguments)}}();return i.createElement(eY,{heading:s("resubscribeTitle"),onClose:h},i.createElement(eY.Body,null,i.createElement("p",null,s("resubscribeNotice")," ",i.createElement("strong",null,f)),i.createElement("p",{style:{fontWeight:"bold",marginTop:"1rem"}},s("resubscribePrompt")),o&&i.createElement("p",{style:{color:"red",marginTop:"1rem"}},o)),i.createElement(eY.PrimaryButton,{onClick:g,isDisabled:d},s(d?"submitting":"keepMyAccount")),i.createElement(eY.SecondaryButton,{onClick:h},s("closeMyAccount")))}));var b4,_4,A4,E4,w4,x4,k4=fr(wr)((function(e){var t=e.theme;return"\n        justify-content: center;\n        width: 100%;\n\n        "+t.responsive.smallScreenOnly(b4||(b4=zM(["\n            flex-direction: column-reverse;\n        "])))+"\n\n        "+t.responsive.mediumScreenOnly(_4||(_4=zM(["\n            flex-wrap: wrap;\n        "])))+"\n    "})),C4=fr(wr)(A4||(A4=zM(["\n    flex-direction: column;\n    justify-content: center;\n    position: relative;\n"]))),S4=fr(wr)((function(e){return"\n        background-color: #FFFFFF;\n        justify-content: center;\n        text-align: center;\n        width: 100%;\n\n        "+e.theme.responsive.smallScreenOnly(E4||(E4=zM(["\n            position: sticky;\n            top: 0;\n            z-index: 1;\n        "])))+"\n    "})),M4=fr(wr)(w4||(w4=zM(["\n    align-items: center;\n    align-self: center;\n    justify-content: flex-start;\n    margin-bottom: 35px;\n    width: max-content;\n"]))),T4=fr(_r)((function(e){var t=e.theme;return"\n        color: "+t.colors.navy[500]+";\n        font-size: "+t.fontSizes.lg+";\n        white-space: nowrap;\n\n        &:first-of-type {\n            margin-right: 16px;\n        }\n\n        &:last-of-type {\n            margin-right: 6px;\n        }\n\n        "+t.responsive.smallScreenOnly(x4||(x4=zM(["\n            &:last-of-type {\n                margin-right: 0;\n            }\n        "])))+"\n    "})),O4=fr(wr)((function(e){var t=e.theme,n="\n        display: inline;\n        margin-top: 23px;\n        text-align: center;\n\n        span {\n            font-size: "+t.fontSizes.sm+";\n        }\n    ";return"\n        align-items: center;\n        margin-left: -5px;\n\n        span {\n            color: "+t.colors.blue[400]+";\n            font-size: "+t.fontSizes.md+";\n            white-space: nowrap;\n        }\n\n        "+t.responsive.smallScreenOnly(n)+"\n    "}));const D4=function(e){var t,n,r=e.initialPlanPeriod,o=e.onPlanSelected,a=e.plans,s=e.showAllPlans,l=void 0!==s&&s,c=e.showPlanFeatures,u=void 0===c||c,d=e.downgradePlanUuid,p=e.downgradeToFreePlan,f=void 0!==p&&p,h=e.showAccountClosureLink,g=void 0===h||h,v=hO().me,y=((null==v?void 0:v.studio)||{}).nextBillDate,b=y?new Date(y).toLocaleDateString(void 0,{year:"numeric",month:"long",day:"numeric"}):"",_=nY(H4),A=_.Modal,E=_.close,w=_.open,x=_.isOpen,k=a.find((function(e){return e.isCurrent})),C=zo("plan/downgrade",{defer:!0,method:Fo.GET}),S=C.performFetch,M=C.response,T=zo("plan/downgrade",{defer:!0,method:Fo.DELETE}).performFetch,O=function(){if(0===ee.length||0===le.length)return"0";var e=ee.map((function(e){var t=e.price;return 12*Number(t.slice(1,-3))})),t=le.map((function(e){var t=e.price;return 12*Number(t.slice(1,-3))})),n=e.map((function(e,n){return e>0?(e-t[n])/e*100:0}));return Math.round(Math.max.apply(Math,n)).toString()},D=function(e,t){k&&(F(e.promo),$(e.uuid)),o(e,t)},L=function(){var e=Lo(Io().mark((function e(){return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.prev=0,e.next=3,T();case 3:e.next=8;break;case 5:return e.prev=5,e.t0=e.catch(0),e.abrupt("return");case 8:B(void 0);case 9:case"end":return e.stop()}}),e,null,[[0,5]])})));return function(){return e.apply(this,arguments)}}(),P=m((0,i.useState)(),2),I=P[0],B=P[1],R=m((0,i.useState)(),2),N=R[0],F=R[1],j=m((0,i.useState)(),2),Y=j[0],$=j[1],H=m((0,i.useState)(f),2),U=H[0],z=H[1],W=m((0,i.useState)(),2),V=W[0],G=W[1],Q=m((0,i.useState)(null),2),q=Q[0],K=Q[1],Z=m((0,i.useState)(null!==(t=!(null==v||null===(n=v.studio)||void 0===n||null===(n=n.photoPlan)||void 0===n||!n.isInCancelQueue))&&void 0!==t&&t),2),J=Z[0],X=Z[1];(0,i.useEffect)((function(){404!==(null==M?void 0:M.status)?B(null==M?void 0:M.electedPlanUuid):B(void 0)}),[M]),(0,i.useEffect)((function(){d&&B(d)}),[d]),(0,i.useEffect)((function(){if(U){var e=a.filter((function(e){return e.planPeriod===sq.Free}));z(!1),e[0]&&$(e[0].uuid)}}),[a,U]);var ee=(0,i.useMemo)((function(){return a.filter((function(e){return e.planPeriod!==sq.Annually}))}),[a]),te=(k||{planPeriod:r}).planPeriod,ne=m((0,i.useState)([]),2),re=ne[0],oe=ne[1],ie=a.findIndex((function(e){return e.isCurrent})),ae=a.filter((function(e){return e.planPeriod===sq.Annually})).length;ie>ae-1&&(ie-=ae);var se=xo(),le=(0,i.useMemo)((function(){return a.filter((function(e){return e.planPeriod!==sq.Monthly}))}),[a]);(0,i.useEffect)((function(){Y&&setTimeout((function(){w()}),100)}),[Y,w]),(0,i.useEffect)((function(){l?oe(a):(te!==sq.Monthly&&te!==sq.Free||(oe(ee),G(!1)),te===sq.Annually&&(oe(le),G(!0)))}),[ee,te,a,l,le]);var ce=(0,i.useCallback)((function(){X(!0)}),[]),ue=nY(y4),de=(0,i.useCallback)((function(){X(!1),ue.close()}),[ue]);return i.createElement(i.Fragment,null,i.createElement(C4,{"data-testid":"sp-ui-price-plans"},!l&&i.createElement(S4,null,i.createElement(M4,{"data-testid":"sp-ui-plan-toggle-switch-container"},i.createElement(T4,{"data-testid":"sp-ui-plan-toggle-switch-label"},se("spUi.studio.account.plans.payMonthly")),i.createElement(ak,{isToggled:V,name:"photoPlansToggle",onChange:function(){var e=(re.find((function(e){return e.planPeriod!==sq.Free}))||{}).planPeriod;e!==sq.Monthly&&e!==sq.Free||(oe(le),G(!0)),e===sq.Annually&&(oe(ee),G(!1))},variant:nk.Large}),i.createElement(O4,null,i.createElement(T4,{"data-testid":"sp-ui-plan-toggle-switch-label"},se("spUi.studio.account.plans.payAnnually")),"0"!==O()&&i.createElement(fx,{"data-testid":"sp-ui-plan-toggle-switch-savings"},se("spUi.studio.account.plans.save",{percentageOff:O()}).replace("{percentageOff}",O()))))),J&&i.createElement(Px,null,se("spUi.studio.account.plans.closureNotice")," ",i.createElement("span",{style:{color:"#BF303C",fontWeight:"bold"}},b)),Y&&i.createElement(wK,{defaultPlanUuid:Y,planType:"photo"},i.createElement(A,{onClose:function(){E(),$("")},onCompleteDowngrade:Lo(Io().mark((function e(){return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,S();case 2:case"end":return e.stop()}}),e)}))),onCompleteUpgrade:Lo(Io().mark((function e(){return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:K(Y);case 1:case"end":return e.stop()}}),e)}))),isOpen:x,isMonthly:!V,hasDowngrade:!!I,initialPromoCode:N})),i.createElement(k4,{"data-testid":"sp-ui-plan-container"},re.map((function(e,t){return i.createElement(Oq,{key:t,currentDowngradeUuid:I,currentPlanHeading:null==k?void 0:k.heading,currentSelectedPlanIndex:ie,handlePlanSelect:D,handleCancel:e.isCurrent?ue.open:L,hasCanceled:J,plan:e,planIndex:t,showPlanFeatures:u,upgradeUuid:q})})))),g&&(null==v?void 0:v.isStudioOwner)&&i.createElement(v4,{hasCanceled:J,onCancelAccount:ce}),i.createElement(ue.Modal,{onClose:ue.close,onResubscribe:de}))};var L4,P4,I4=fr(wr)(L4||(L4=zM(["\n    align-items: center;\n    flex-direction: column;\n    flex-wrap: wrap;\n    padding: 60px 24px;\n"]))),B4=fr(BF)((function(){return"\n        margin: 40px 0px;\n    "})),R4=fr(_r,{shouldForwardProp:function(e){return"plansCount"!==e}})((function(e){var t=e.plansCount,n=e.theme;return"\n        align-self: center;\n        max-width: 100%;\n        width: "+(278*t+16*(t-1))+"px;\n\n        "+n.responsive.smallScreenOnly(P4||(P4=zM(["\n            margin-left: 24px;\n            width: 100%;\n        "])))+"\n\n        "+n.responsive.mediumScreenOnly("\n            width: "+(180*t+16*(t-1))+"px;\n            max-width: 720px;\n        ")+"\n    "}));const N4=function(e){var t,r=e.onPlanSelected,o=e.plans,a=e.isInTrialOrIsFree,s=e.isUnlimitedAndRequiresUpgrade,l=e.promoError,c=e.promoWorksYearly,u=e.promoWorksMonthly,d=e.studioPhotoCount,p=e.studioCurrentPhotoPlan,f=m(II("billingPeriod"),3),h=f[0].value,g=f[2].setValue,v=m(II("promoCode"),1)[0].value,y=m(II("planUuid"),3)[2].setValue,b=m((0,i.useState)(!1),2),_=b[0],A=b[1],E=Co("studio.plan.trialCheckout.modal.selectPlan"),w=zo("plan/photo?filterPromoCode="+v,{defer:!0}),x=w.performFetch,k=w.loading,C=w.response;(0,i.useEffect)((function(){v&&x()}),[v,x]);var S=null!==(t=null==C?void 0:C.items.filter((function(e){return e.photosAllowed&&e.photosAllowed>d||e.isUnlimited})))&&void 0!==t?t:[],M=(u&&!c||c&&!u)&&!s&&!_,T=v&&"This promo code is invalid."!==l,O=S,D=a&&d<1500?o:o.filter((function(e){return 2!==e.band})),L=(0,i.useCallback)((function(e){return e.filter((function(e){return!e.isFree})).map((function(e){var t=e.planPeriod,r=E("shortPlanPeriod.monthly"),o=e.price,i=e.promoPrice;t===sq.Annually&&(o/=12,i&&(i/=12));var a=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(e,t){return new Intl.NumberFormat(navigator.language,{style:"currency",currency:t}).format(e)},r=arguments.length>2&&void 0!==arguments[2]&&arguments[2];return n({},e,{description:e.featureList,descriptionHeading:e.featureListHeading,heading:e.name,band:1,isCurrent:!1,planPeriod:e.planPeriod,price:t(e.price,r?e.currencySymbol:e.currencyCode),promoPrice:e.promoPrice?t(e.promoPrice,r?e.currencySymbol:e.currencyCode):null,subheading:e.description})}(n({},e,{price:o,promoPrice:i}));return a.isCurrent=e.uuid===(null==p?void 0:p.uuid),a.price=a.price+"/"+r,a.promoPrice=null===a.promoPrice?null:a.promoPrice+"/"+r,a}))}),[p,E]),P=(0,i.useMemo)((function(){return L(D)}),[L,D]),I=(0,i.useMemo)((function(){return L(O)}),[L,O]);return i.createElement(I4,{"data-testid":"plan-select-screen"},i.createElement(_r,{maxWidth:"720px",width:"100%"},i.createElement(dq,{marginBottom:"24px"},E("heading")),i.createElement(Px,{marginBottom:"40px"},E("description"))),i.createElement(wr,{flexDirection:"column",width:"100%"},k&&i.createElement(B4,{description:""}),!k&&i.createElement(D4,{initialPlanPeriod:h,showAccountClosureLink:!1,onPlanSelected:function(e){var t=e.id,n=o.find((function(e){return e.id===t}));if(n){var i=n.planPeriod,a=n.uuid;g(i),y(a),r()}},plans:_?P:T&&!_?I:P,showAllPlans:M}),T&&!_&&i.createElement(R4,{plansCount:M?I.length:I.length/2},i.createElement(Sx,{"data-testid":"show-all-plans-link",onClick:function(){return A(!0)}},E("showAllPlans")))))};var F4=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};window.trackPendoEvent&&window.trackPendoEvent(e,t)};const j4=function(){var e=hO().me,t=xK(),r=t.allAvailablePlans,o=t.planPricingInfo,a=(0,i.useCallback)((function(t){var i,a,s=t.formValues,l=t.planType,c=s.billingPeriod,u=s.planUuid,d=s.promoCode,p=((null==e?void 0:e.studio)||{}).photoPlan,f=r.find((function(e){return e.uuid===u}));window.dataLayer&&window.dataLayer.push({currency:null==o?void 0:o.currencyCode,event:"AddedCC",final_price:null==o||null===(i=o.promo)||void 0===i?void 0:i.discountedPrice,plan_id:u,plan_billing_period:c,plan_name:null==o?void 0:o.planName,plan_price:null==o?void 0:o.planPrice,platform_account_uuid:null==e?void 0:e.platformAccountId,promo_code:d,revenue:(null==o||null===(a=o.promo)||void 0===a?void 0:a.discountedPrice)||(null==o?void 0:o.planPrice),signup_type:"paid",email:null==e?void 0:e.email});var h=function(e,t,r,o,i){F4(e,n({plan_id:t,plan_name:r,plan_period:o,source:"checkout"},i&&{promo_code:i}))},m="free"===(null==f?void 0:f.planPeriod)?"monthly":c,g=!d||null!=o&&o.promoError?void 0:d;if(null==e||!e.studio.cardOnFile){var v,y,b;if("booking"===l)h("Subscribed",null==e||null===(v=e.studio.photoPlan)||void 0===v?void 0:v.uuid,null==e||null===(y=e.studio.photoPlan)||void 0===y?void 0:y.name,null==e||null===(b=e.studio.photoPlan)||void 0===b?void 0:b.planPeriod);"photo"===l&&h("Subscribed",u,null==o?void 0:o.planName,m,g)}"booking"===l&&null===(null==e?void 0:e.studio.bookingPlan)&&h("Subscribed Booking",u,null==o?void 0:o.planName,m,g),f&&Uq(f)&&p&&Uq(p)&&null!=p&&p.band&&null!=f&&f.band&&p.band!==f.band&&F4("Plan "+(f.band>p.band?"Upgraded":"Downgraded"),{from_plan_band:p.band,from_plan_uuid:p.uuid,from_plan_name:p.name,to_plan_uuid:f.uuid,to_plan_name:f.name,to_plan_band:f.band,source:"checkout"})}),[r,e,o]);return{handleSubscribeTracking:a}};var Y4=function(){var e=xK().getPlanPricing,t=mI().values,n=t.planUuid,r=t.promoCode;return(0,i.useEffect)((function(){e(n,r)}),[e,n,r]),null};function $4(){var e=document.querySelector(".chakra-modal__body");e&&(e.scrollTop=0)}const H4=$q((function(e){var t,r,o=e.onClose,a=e.initialPromoCode,s=e.hasDowngrade,l=e.onCompleteDowngrade,c=void 0===l?null:l,u=e.onCompleteUpgrade,d=void 0===u?null:u,p=e.isOpen,f=void 0===p||p,h=e.isMonthly,g=void 0!==h&&h,v=e.showPlanSelectOnRender,y=void 0!==v&&v,b=xK(),_=b.allAvailablePlans,A=b.defaultPlanUuid,E=b.loadingPlans,w=b.planPricingInfo,x=b.planType,k=b.postDowngrade,C=b.deleteDowngrade,S=m((0,i.useState)(!1),2),M=S[0],T=S[1],O=m((0,i.useState)(null),2),D=O[0],L=O[1],P=zo("studio",{defer:!0,method:Fo.PATCH}).performFetch,I=hO(),B=I.me,R=I.refreshMe,N=j4().handleSubscribeTracking,F=(null==B?void 0:B.studio)||{},j=F.bookingPlan,Y=F.cardOnFile,$=F.hasStudioUsedBooking,H=F.photoPlan,U=F.nextBillDate,z=F.nextBookingBillDate,W=H||{},V=W.isFree,G=W.isInTrial,Q=W.isUnlimited,q=W.uuid,K=W.totalActivePhotosCount,Z=W.isMonthly,J=void 0!==g?g?"monthly":"yearly":"booking"===x?"yearly":Z||V?"monthly":"yearly";if("booking"===x){var X=(null==j?void 0:j.planPeriod)===J?j:_.find((function(e){return e.planPeriod===J}));r=null==X?void 0:X.uuid}else if(A)r=q;else{var ee,te=null==H?void 0:H.band,ne=te?_.find((function(e){return e.band===te&&e.isMonthly===("monthly"===J)})):void 0;r=null!==(ee=null==ne?void 0:ne.uuid)&&void 0!==ee?ee:q}var re=null!=A?A:r,oe=G||V,ie=null!=K?K:1500,ae=(0,i.useCallback)((function(){o(),M&&R()}),[o,R,M]),se=_.find((function(e){return e.uuid===re})),le=Q&&w&&"higher-only"===(null===(t=w.promo)||void 0===t?void 0:t.planBandRestriction),ce={billingPeriod:J,creditCardNonce:null,planUuid:null!=re?re:"",promoCode:a,useCardOnFile:Boolean(Y)},ue=Co("studio.plan.trialCheckout.modal");(0,i.useEffect)((function(){var e;w&&null===D&&L(w&&"higher-only"===(null===(e=w.promo)||void 0===e?void 0:e.planBandRestriction)&&!le)}),[w,D,le]);var de=m((0,i.useState)(qT),2),pe=de[0],fe=de[1],he=m((0,i.useState)(null),2),me=he[0],ge=he[1],ve=m((0,i.useState)(null),2),ye=ve[0],be=ve[1],_e=m((0,i.useState)(qT),2),Ae=_e[0],Ee=_e[1],we=(0,i.useCallback)((function(e,t){Ee((function(){return t})),fe((function(){return e}))}),[]),xe=m((0,i.useState)(ue("errorModal.description")),2),ke=xe[0],Ce=xe[1];if(!se)return null;var Se=Uq(se)&&(null==H?void 0:H.band)&&se.band&&se.band<H.band,Me=iK(x,U,z,$,G,Boolean(Se)),Te=MU().shape({billingPeriod:aU().oneOf(["free","monthly","yearly"]).required(),creditCardNonce:ZH().nullable().when("useCardOnFile",{is:function(e){return!1===e&&(Hq(se)||!se.isFree)},then:ZH().required()}),planUuid:aU().required(),promoCode:aU().nullable(),useCardOnFile:XH().required()}),Oe=function(){var e=Lo(Io().mark((function e(t){var r,o,i,a,l;return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(o=t.creditCardNonce,i=t.planUuid,a=t.promoCode,!A||!Se||G){e.next=9;break}if(!s){e.next=5;break}return e.next=5,C();case 5:return e.next=7,k({data:{plan:i}});case 7:return c&&c(),e.abrupt("return",!0);case 9:if(e.t0=P,e.t1=n,!o){e.next=17;break}return e.next=14,o();case 14:e.t2=e.sent,e.next=18;break;case 17:e.t2=null;case 18:return e.t3=e.t2,e.t4={creditCardNonce:e.t3},e.t5="photo"===x?{photoPlanUuid:i}:{bookingPlanUuid:i},e.t6=a&&!(null!=w&&w.promoError)&&{promoCode:a},e.t7={type:"studio"},e.t8=(0,e.t1)(e.t4,e.t5,e.t6,e.t7),e.t9={data:e.t8},e.next=27,(0,e.t0)(e.t9);case 27:if(200!==(null==(l=e.sent)?void 0:l.status)){e.next=32;break}return N({formValues:t,planType:x}),d&&d(),e.abrupt("return",!0);case 32:return null!=l&&null!==(r=l.info)&&void 0!==r&&null!==(r=r.errors.creditCardNonce)&&void 0!==r&&r.tooManyAttempts&&Ce(ue("errorModal.contactSupport")),pe(),e.abrupt("return",!1);case 35:case"end":return e.stop()}}),e)})));return function(t){return e.apply(this,arguments)}}(),De=function(){var e=Lo(Io().mark((function e(t,n){return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,n();case 2:if(!e.sent){e.next=9;break}return A&&!G&&se&&Se&&(ge(se.canDowngrade),be(se.complianceTexts)),e.next=7,R();case 7:T(!0),setTimeout((function(){t()}),100);case 9:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}();return i.createElement(_C,{partialTheme:{colors:{navy:{700:"#002B4C"}},components:{Modal:{variants:kC({},yp.Fullscreen,{header:{borderBottom:"1px solid "+bk.colors.gray[200]}})}}},resetCSS:!1},f&&i.createElement(TI,{initialValues:ce,onSubmit:Oe,validationSchema:Te,validateOnMount:!0},(function(e){var t=e.submitForm;return i.createElement(i.Fragment,null,i.createElement(Fq,{headerText:"studio.plan.trialCheckout.modal.errorModal.header",hideSecondaryAction:!0,openSubscribe:we,primaryAction:Ae,primaryActionText:"studio.plan.trialCheckout.modal.errorModal.close",showCloseButton:!1},i.createElement(Px,{textAlign:"center"},ke)),i.createElement(eY,{hideFooter:!0,onClose:ae,variant:yp.Fullscreen},i.createElement(Y4,null),i.createElement(Yq,{component:function(){return i.createElement(eY.Body,null,i.createElement(TK,{onClose:ae,canDowngrade:me,complianceTexts:ye,isFree:Uq(se)&&se.isFree,jsNextBillDate:Me}))}},(function(e){return i.createElement(i.Fragment,null,i.createElement(eY.Header,{heading:ue("heading"),includeShootProofLogo:!0}),i.createElement(eY.Body,{variant:bp.FullWidth},E&&i.createElement(BF,{description:""}),!E&&i.createElement(Yq,{component:function(e){var t,n;return i.createElement(N4,{onPlanSelected:function(){e(),$4()},plans:_.filter(Uq),isInTrialOrIsFree:oe,isUnlimitedAndRequiresUpgrade:le,studioCurrentPhotoPlan:H,studioPhotoCount:ie,promoError:null==w?void 0:w.promoError,promoWorksYearly:null==w||null===(t=w.promo)||void 0===t?void 0:t.worksYearly,promoWorksMonthly:null==w||null===(n=w.promo)||void 0===n?void 0:n.worksMonthly})},enterOnRender:y||"photo"===x&&!A&&(Boolean(D)||V)},(function(n){return i.createElement(S2,{onSubscribe:function(){return De(e,t)},isInBookingTrial:null==j?void 0:j.isInBookingTrial,isInTrial:G,isFree:V,isDowngrade:Boolean(Se),enterPlanSelectScreen:function(){n(),$4()}})}))))}))))})))}));const U4=iq((function(){var e,t,n,r,o=xo(),a=hO(),s=a.me,l=a.refreshMe,c=(s||{}).studio,u=(c||{}).bookingPlan,d=zo("plan/booking").response,p=zo("studio",{data:{bookingPlanUuid:null,type:"studio"},defer:!0,method:Fo.PATCH}).performFetch,f=nY(H4),h=f.Modal,m=f.close,g=f.open,v=f.isOpen,y=nY(),b=y.Modal,_=y.close,A=y.open,E=nY(),w=E.Modal,x=E.close,k=E.open,C=function(e,t){return null==e?void 0:e.toLocaleString("en-US",{style:"currency",currency:null!=t?t:"USD"})},S=function(){var e=Lo(Io().mark((function e(){var t;return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,p({data:{bookingPlanUuid:null,type:"studio"}});case 2:200===(null==(t=e.sent)?void 0:t.status)&&l();case 4:case"end":return e.stop()}}),e)})));return function(){return e.apply(this,arguments)}}(),M=function(){var e=Lo(Io().mark((function e(){var t;return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,p({data:{bookingPlanUuid:null==u?void 0:u.uuid,type:"studio"}});case 2:200===(null==(t=e.sent)?void 0:t.status)&&l();case 4:case"end":return e.stop()}}),e)})));return function(){return e.apply(this,arguments)}}(),T=!0===(null==u?void 0:u.isInCancelQueue),O="monthly"===(null==u?void 0:u.planPeriod),D="yearly"===(null==u?void 0:u.planPeriod),L=!0===(null==c?void 0:c.hasStudioUsedBooking),P=u&&!T,I=null==c?void 0:c.photoPlan.isFree,B=null==u?void 0:u.hasOpenContracts,R=null==u?void 0:u.hasOpenInvoices,N="";null==d||d.items.forEach((function(e){"monthly"===e.planPeriod?N+=C(e.price,e.currencyCode)+"/"+o("spUi.studio.account.plans.mo")+" "+o("spUi.studio.account.plans.or")+" ":N+=C(e.price,e.currencyCode)+"/"+o("spUi.studio.account.plans.yr")}));var F="monthly"===(null==u?void 0:u.planPeriod)?sq.Monthly:"yearly"===(null==u?void 0:u.planPeriod)?sq.Annually:sq.Both,j=T&&null!=c&&c.nextBookingBillDate?[o("spUi.studio.account.plans.accessThrough"),new Date(null==c?void 0:c.nextBookingBillDate).toLocaleDateString()]:[""],Y=O?C(null==u?void 0:u.price,u.currencyCode)+"/"+o("spUi.studio.account.plans.mo"):D?C(null==u?void 0:u.price,u.currencyCode)+"/"+o("spUi.studio.account.plans.yr"):N,$=void 0!==(null==u?void 0:u.promoPrice)&&null!==(null==u?void 0:u.promoPrice)?0===u.promoPrice?o("spUi.studio.account.plans.free"):O?C(null!==(e=u.promoPrice)&&void 0!==e?e:void 0,u.currencyCode)+"/"+o("spUi.studio.account.plans.mo"):D?C(null!==(t=u.promoPrice)&&void 0!==t?t:void 0,u.currencyCode)+"/"+o("spUi.studio.account.plans.yr"):void 0:void 0,H=void 0!==(null==u?void 0:u.promoPrice)&&null!==(null==u?void 0:u.promoPrice)&&null!=u&&u.price&&null!=c&&c.bookingPromoCode?{code:c.bookingPromoCode,discountPercent:Math.round(100*(1-u.promoPrice/u.price)),period:u.promoDuration?u.promoDuration+" "+(1===u.promoDuration?O?"month":"year":O?"months":"years"):O?o("spUi.studio.account.plans.mo"):D?o("spUi.studio.account.plans.yr"):"billing period"}:null,U={band:1,description:j,heading:"Booking Plan",isCurrent:!1,id:null!==(n=null==u?void 0:u.id)&&void 0!==n?n:"",planPeriod:F,price:Y,promoPrice:$,subheading:"",uuid:null!==(r=null==u?void 0:u.uuid)&&void 0!==r?r:""},z=u&&!u.isActive,W="1"===new URLSearchParams(window.location.search).get("booking_trial");return(0,i.useEffect)((function(){!L&&W&&g()}),[W,L,g]),i.createElement(i.Fragment,null,i.createElement(wK,{defaultPlanUuid:null==u?void 0:u.uuid,planType:"booking"},i.createElement(h,{onClose:function(){m();var e=new URLSearchParams(window.location.search);e.delete("booking_trial");var t=e.toString();history.pushState({},"",t?"?"+t:window.location.pathname)},isOpen:v,isMonthly:F===sq.Monthly})),i.createElement(tq,{as:"h2",margin:z?"20px 0 10px !important":T?"21px 0 35px !important":"21px 0 !important",fontSize:"36px",lineHeight:"1em",fontWeight:"300"},o("spUi.studio.account.plans.bookingPlan")),z?i.createElement(Px,{"data-testid":""},o("spUi.studio.account.plans.isInCustomPlan"),C(null==u?void 0:u.price,null==u?void 0:u.currencyCode),".",o("spUi.studio.account.plans.toMakeChanges"),i.createElement(Sx,{href:"mailto:support@shootproof.com","data-testid":""},"support@shootproof.com"),"."):i.createElement(i.Fragment,null,i.createElement(Oq,{plan:U,handlePlanSelect:function(){g()},handleCancel:function(){k()},hasCanceled:T,hasStudioUsedBooking:L,isBookingCard:!0,showPlanFeatures:T}),P&&i.createElement(Px,{"data-testid":"booking-plan-section-cancel-plan-section",marginTop:"0",marginBottom:"16px"},o("spUi.studio.account.plans.toCancelBookingPlan"),","," ",i.createElement(Sx,{"data-testid":"booking-plan-section-cancel-plan-section-link",onClick:A},o("spUi.studio.account.plans.clickHere")),"."),H&&i.createElement("span",{className:"promo-text","data-testid":"booking-plan-promo-code"},i.createElement("br",null),i.createElement("span",{className:"promo-indicator"},"‡")," These prices reflect the discount from using the promo code '",H.code,"'.",H.discountPercent>0&&i.createElement(i.Fragment,null," ","This promo has a value of ",H.discountPercent,"% off for ",H.period,".")),i.createElement(b,{heading:o("spUi.studio.account.plans.cancelBookingPlan")},i.createElement(b.Body,null,i.createElement(Px,null,i.createElement("strong",null,o("spUi.studio.account.plans.cancelBookingPlanConfirmation")),o("spUi.studio.account.plans.planCancelInfo")),I&&(B||R)&&i.createElement(Nq,{alertType:Bq.WARNING,complianceTexts:[].concat(B?[o("spUi.studio.account.plans.tooManyContracts")]:[],R?[o("spUi.studio.account.plans.tooManyInvoices")]:[]),description:o("spUi.studio.account.plans.paidThrough"),jsNextBillDate:new Date(c.nextBookingBillDate),onceResolvedText:o("spUi.studio.account.plans.onceResolved")})),i.createElement(b.PrimaryButton,{destructive:!0,onClick:function(){_(),S()}},o("spUi.studio.account.plans.yesCancel")),i.createElement(b.SecondaryButton,null,o("spUi.studio.account.plans.keepPlan"))),i.createElement(w,{heading:o("spUi.studio.account.plans.keepBookingPlan")},i.createElement(w.Body,null,(null==c?void 0:c.nextBookingBillDate)&&i.createElement(Px,null,o("spUi.studio.account.plans.planIsSetToEnd"),new Date(null==c?void 0:c.nextBookingBillDate).toLocaleDateString(),"."),i.createElement(Px,null,o("spUi.studio.account.plans.continueWithBookingPlan"))),i.createElement(w.PrimaryButton,{onClick:function(){x(),M()}},o("spUi.studio.account.plans.yesKeepPlan")),i.createElement(w.SecondaryButton,null,o("spUi.studio.account.plans.cancelPlan")))))}));var z4=o(96575);const W4=e=>{var{initialEndDate:t,initialStartDate:n,onBack:r,onDateRangeSelected:o}=e,[a,s]=(0,i.useState)(t),[l,c]=(0,i.useState)(!0),[u,d]=(0,i.useState)(n),p=xo();return Mr(_r,{"data-testid":"sp-ui-table-date-range-filter-modal-content"},Mr(eY.Header,{onBack:r}),Mr(eY.Body,null,Mr(wr,{alignContent:"stretch",marginBottom:"20px"},Mr(Pz,{forceState:l?tp.Focus:void 0,onFocus:()=>c(!0),onKeyDown:e=>e.preventDefault(),placeholder:p("spUi.common.table.dateRangeFilter.startDatePlaceholder"),value:u?QU()(u).format("L"):""}),Mr(Pz,{forceState:l?void 0:tp.Focus,onFocus:()=>c(!1),onKeyDown:e=>e.preventDefault(),placeholder:p("spUi.common.table.dateRangeFilter.endDatePlaceholder"),value:a?QU()(a).format("L"):""})),Mr(tW,l?{inline:!0,max:a||void 0,onChange:e=>{d(e),c(!1)},value:u}:{inline:!0,min:u||void 0,onChange:e=>{s(e)},value:a})),Mr(eY.PrimaryButton,{onClick:()=>{o([u,a])}},p("spUi.common.table.dateRangeFilter.modal.primaryButton")),Mr(eY.SecondaryButton,{onClick:()=>{s(t),c(!0),d(n)}},p("spUi.common.datePicker.resetRange")))};var V4=e=>(0,br.jsx)(Jk,{viewBox:"0 0 24 24",...e,children:(0,br.jsx)("path",{fill:"currentColor",d:"M21,5H3C2.621,5,2.275,5.214,2.105,5.553C1.937,5.892,1.973,6.297,2.2,6.6l9,12 c0.188,0.252,0.485,0.4,0.8,0.4s0.611-0.148,0.8-0.4l9-12c0.228-0.303,0.264-0.708,0.095-1.047C21.725,5.214,21.379,5,21,5z"})}),G4=e=>(0,br.jsx)(Jk,{viewBox:"0 0 24 24",...e,children:(0,br.jsx)("path",{fill:"currentColor",d:"M12.8,5.4c-0.377-0.504-1.223-0.504-1.6,0l-9,12c-0.228,0.303-0.264,0.708-0.095,1.047 C2.275,18.786,2.621,19,3,19h18c0.379,0,0.725-0.214,0.895-0.553c0.169-0.339,0.133-0.744-0.095-1.047L12.8,5.4z"})});function Q4(e,t,n,r){(0,i.useEffect)((()=>{var o;if(!e.current||!r)return;const i=null!=(o=e.current.ownerDocument.defaultView)?o:window,a=Array.isArray(t)?t:[t],s=new i.MutationObserver((e=>{for(const t of e)"attributes"===t.type&&t.attributeName&&a.includes(t.attributeName)&&n(t)}));return s.observe(e.current,{attributes:!0,attributeFilter:a}),()=>s.disconnect()}))}var q4=50,K4=300;function Z4(e,t){const[n,r]=(0,i.useState)(!1),[o,a]=(0,i.useState)(null),[s,l]=(0,i.useState)(!0),c=(0,i.useRef)(null),u=()=>clearTimeout(c.current);!function(e,t){const n=zh(e);(0,i.useEffect)((()=>{let e=null;const r=()=>n();return null!==t&&(e=window.setInterval(r,t)),()=>{e&&window.clearInterval(e)}}),[t,n])}((()=>{"increment"===o&&e(),"decrement"===o&&t()}),n?q4:null);const d=(0,i.useCallback)((()=>{s&&e(),c.current=setTimeout((()=>{l(!1),r(!0),a("increment")}),K4)}),[e,s]),p=(0,i.useCallback)((()=>{s&&t(),c.current=setTimeout((()=>{l(!1),r(!0),a("decrement")}),K4)}),[t,s]),f=(0,i.useCallback)((()=>{l(!0),r(!1),u()}),[]);return(0,i.useEffect)((()=>()=>u()),[]),{up:d,down:p,stop:f,isSpinning:n}}function J4(e){return parseFloat(e.toString().replace(/[^\w.-]+/g,""))}function X4(e,t){return Math.max(wM(t),wM(e))}function e5(e,t,n){const r=J4(e);if(Number.isNaN(r))return;const o=X4(r,t);return EM(r,null!=n?n:o)}var t5=/^[Ee0-9+\-.]$/;function n5(e){return t5.test(e)}function r5(e={}){const{focusInputOnChange:t=!0,clampValueOnBlur:n=!0,keepWithinRange:r=!0,min:o=Number.MIN_SAFE_INTEGER,max:a=Number.MAX_SAFE_INTEGER,step:s=1,isReadOnly:l,isDisabled:c,isRequired:u,isInvalid:d,pattern:p="[0-9]*(.[0-9]+)?",inputMode:f="decimal",allowMouseWheel:h,id:m,onChange:g,precision:v,name:y,"aria-describedby":b,"aria-label":_,"aria-labelledby":A,onFocus:x,onBlur:k,onInvalid:C,getAriaValueText:S,isValidCharacter:M,format:T,parse:O,...D}=e,L=zh(x),P=zh(k),I=zh(C),B=zh(null!=M?M:n5),R=zh(S),N=function(e={}){const{onChange:t,precision:n,defaultValue:r,value:o,step:a=1,min:s=Number.MIN_SAFE_INTEGER,max:l=Number.MAX_SAFE_INTEGER,keepWithinRange:c=!0}=e,u=zh(t),[d,p]=(0,i.useState)((()=>{var e;return null==r?"":null!=(e=e5(r,a,n))?e:""})),f=void 0!==o,h=f?o:d,m=X4(J4(h),a),g=null!=n?n:m,v=(0,i.useCallback)((e=>{e!==h&&(f||p(e.toString()),null==u||u(e.toString(),J4(e)))}),[u,f,h]),y=(0,i.useCallback)((e=>{let t=e;return c&&(t=CM(t,s,l)),EM(t,g)}),[g,c,l,s]),b=(0,i.useCallback)(((e=a)=>{let t;t=""===h?J4(e):J4(h)+e,t=y(t),v(t)}),[y,a,v,h]),_=(0,i.useCallback)(((e=a)=>{let t;t=""===h?J4(-e):J4(h)-e,t=y(t),v(t)}),[y,a,v,h]),A=(0,i.useCallback)((()=>{var e;let t;t=null==r?"":null!=(e=e5(r,a,n))?e:s,v(t)}),[r,n,a,v,s]),E=(0,i.useCallback)((e=>{var t;const n=null!=(t=e5(e,a,g))?t:s;v(n)}),[g,a,v,s]),w=J4(h);return{isOutOfRange:w>l||w<s,isAtMax:w===l,isAtMin:w===s,precision:g,value:h,valueAsNumber:w,update:v,reset:A,increment:b,decrement:_,clamp:y,cast:E,setValue:p}}(e),{update:F,increment:j,decrement:Y}=N,[$,H]=(0,i.useState)(!1),U=!(l||c),z=(0,i.useRef)(null),W=(0,i.useRef)(null),V=(0,i.useRef)(null),G=(0,i.useRef)(null),Q=(0,i.useCallback)((e=>e.split("").filter(B).join("")),[B]),q=(0,i.useCallback)((e=>{var t;return null!=(t=null==O?void 0:O(e))?t:e}),[O]),K=(0,i.useCallback)((e=>{var t;return(null!=(t=null==T?void 0:T(e))?t:e).toString()}),[T]);qx((()=>{(N.valueAsNumber>a||N.valueAsNumber<o)&&(null==I||I("rangeOverflow",K(N.value),N.valueAsNumber))}),[N.valueAsNumber,N.value,K,I]),em((()=>{if(!z.current)return;if(z.current.value!=N.value){const e=q(z.current.value);N.setValue(Q(e))}}),[q,Q]);const Z=(0,i.useCallback)(((e=s)=>{U&&j(e)}),[j,U,s]),J=(0,i.useCallback)(((e=s)=>{U&&Y(e)}),[Y,U,s]),X=Z4(Z,J);Q4(V,"disabled",X.stop,X.isSpinning),Q4(G,"disabled",X.stop,X.isSpinning);const ee=(0,i.useCallback)((e=>{if(e.nativeEvent.isComposing)return;const t=q(e.currentTarget.value);F(Q(t)),W.current={start:e.currentTarget.selectionStart,end:e.currentTarget.selectionEnd}}),[F,Q,q]),te=(0,i.useCallback)((e=>{var t,n,r;null==L||L(e),W.current&&(e.target.selectionStart=null!=(n=W.current.start)?n:null==(t=e.currentTarget.value)?void 0:t.length,e.currentTarget.selectionEnd=null!=(r=W.current.end)?r:e.currentTarget.selectionStart)}),[L]),ne=(0,i.useCallback)((e=>{if(e.nativeEvent.isComposing)return;(function(e,t){if(null==e.key)return!0;const n=e.ctrlKey||e.altKey||e.metaKey;return!(1===e.key.length&&!n)||t(e.key)})(e,B)||e.preventDefault();const t=re(e)*s,n={ArrowUp:()=>Z(t),ArrowDown:()=>J(t),Home:()=>F(o),End:()=>F(a)}[e.key];n&&(e.preventDefault(),n(e))}),[B,s,Z,J,F,o,a]),re=e=>{let t=1;return(e.metaKey||e.ctrlKey)&&(t=.1),e.shiftKey&&(t=10),t},oe=(0,i.useMemo)((()=>{const e=null==R?void 0:R(N.value);if(null!=e)return e;const t=N.value.toString();return t||void 0}),[N.value,R]),ie=(0,i.useCallback)((()=>{let e=N.value;if(""===N.value)return;/^[eE]/.test(N.value.toString())?N.setValue(""):(N.valueAsNumber<o&&(e=o),N.valueAsNumber>a&&(e=a),N.cast(e))}),[N,a,o]),ae=(0,i.useCallback)((()=>{H(!1),n&&ie()}),[n,H,ie]),se=(0,i.useCallback)((()=>{t&&requestAnimationFrame((()=>{var e;null==(e=z.current)||e.focus()}))}),[t]),le=(0,i.useCallback)((e=>{e.preventDefault(),X.up(),se()}),[se,X]),ce=(0,i.useCallback)((e=>{e.preventDefault(),X.down(),se()}),[se,X]);Vh((()=>z.current),"wheel",(e=>{var t,n;const r=(null!=(n=null==(t=z.current)?void 0:t.ownerDocument)?n:document).activeElement===z.current;if(!h||!r)return;e.preventDefault();const o=re(e)*s,i=Math.sign(e.deltaY);-1===i?Z(o):1===i&&J(o)}),{passive:!1});const ue=(0,i.useCallback)(((e={},t=null)=>{const n=c||r&&N.isAtMax;return{...e,ref:Ur(t,V),role:"button",tabIndex:-1,onPointerDown:w(e.onPointerDown,(e=>{0!==e.button||n||le(e)})),onPointerLeave:w(e.onPointerLeave,X.stop),onPointerUp:w(e.onPointerUp,X.stop),disabled:n,"aria-disabled":E(n)}}),[N.isAtMax,r,le,X.stop,c]),de=(0,i.useCallback)(((e={},t=null)=>{const n=c||r&&N.isAtMin;return{...e,ref:Ur(t,G),role:"button",tabIndex:-1,onPointerDown:w(e.onPointerDown,(e=>{0!==e.button||n||ce(e)})),onPointerLeave:w(e.onPointerLeave,X.stop),onPointerUp:w(e.onPointerUp,X.stop),disabled:n,"aria-disabled":E(n)}}),[N.isAtMin,r,ce,X.stop,c]),pe=(0,i.useCallback)(((e={},t=null)=>{var n,r,i,s;return{name:y,inputMode:f,type:"text",pattern:p,"aria-labelledby":A,"aria-label":_,"aria-describedby":b,id:m,disabled:c,...e,readOnly:null!=(n=e.readOnly)?n:l,"aria-readonly":null!=(r=e.readOnly)?r:l,"aria-required":null!=(i=e.required)?i:u,required:null!=(s=e.required)?s:u,ref:Ur(z,t),value:K(N.value),role:"spinbutton","aria-valuemin":o,"aria-valuemax":a,"aria-valuenow":Number.isNaN(N.valueAsNumber)?void 0:N.valueAsNumber,"aria-invalid":E(null!=d?d:N.isOutOfRange),"aria-valuetext":oe,autoComplete:"off",autoCorrect:"off",onChange:w(e.onChange,ee),onKeyDown:w(e.onKeyDown,ne),onFocus:w(e.onFocus,te,(()=>H(!0))),onBlur:w(e.onBlur,P,ae)}}),[y,f,p,A,_,K,b,m,c,u,l,d,N.value,N.valueAsNumber,N.isOutOfRange,o,a,oe,ee,ne,te,P,ae]);return{value:K(N.value),valueAsNumber:N.valueAsNumber,isFocused:$,isDisabled:c,isReadOnly:l,getIncrementButtonProps:ue,getDecrementButtonProps:de,getInputProps:pe,htmlProps:D}}var[o5,i5]=xr({name:"NumberInputStylesContext",errorMessage:"useNumberInputStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<NumberInput />\" "}),[a5,s5]=xr({name:"NumberInputContext",errorMessage:"useNumberInputContext: `context` is undefined. Seems you forgot to wrap number-input's components within <NumberInput />"}),l5=yr((function(e,t){const n=jr("NumberInput",e),r=Qx(pt(e)),{htmlProps:o,...a}=r5(r),s=(0,i.useMemo)((()=>a),[a]);return(0,br.jsx)(a5,{value:s,children:(0,br.jsx)(o5,{value:n,children:(0,br.jsx)(vr.div,{...o,ref:t,className:g("chakra-numberinput",e.className),__css:{position:"relative",zIndex:0,...n.root}})})})}));l5.displayName="NumberInput";var c5=yr((function(e,t){const n=i5();return(0,br.jsx)(vr.div,{"aria-hidden":!0,ref:t,...e,__css:{display:"flex",flexDirection:"column",position:"absolute",top:"0",insetEnd:"0px",margin:"1px",height:"calc(100% - 2px)",zIndex:1,...n.stepperGroup}})}));c5.displayName="NumberInputStepper";var u5=yr((function(e,t){const{getInputProps:n}=s5(),r=n(e,t),o=i5();return(0,br.jsx)(vr.input,{...r,className:g("chakra-numberinput__field",e.className),__css:{width:"100%",...o.field}})}));u5.displayName="NumberInputField";var d5=vr("div",{baseStyle:{display:"flex",justifyContent:"center",alignItems:"center",flex:1,transitionProperty:"common",transitionDuration:"normal",userSelect:"none",cursor:"pointer",lineHeight:"normal"}}),p5=yr((function(e,t){var n;const r=i5(),{getDecrementButtonProps:o}=s5(),i=o(e,t);return(0,br.jsx)(d5,{...i,__css:r.stepper,children:null!=(n=e.children)?n:(0,br.jsx)(V4,{})})}));p5.displayName="NumberDecrementStepper";var f5=yr((function(e,t){var n;const{getIncrementButtonProps:r}=s5(),o=r(e,t),i=i5();return(0,br.jsx)(d5,{...o,__css:i.stepper,children:null!=(n=e.children)?n:(0,br.jsx)(G4,{})})}));function h5(e,t,n){return Math.min(Math.max(e,t),n)}f5.displayName="NumberIncrementStepper";var m5=["defaultPage","isDisabled","max","min","onChange"];function g5(){return g5=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},g5.apply(null,arguments)}var v5=function(e){return Mr("svg",e,Mr("path",{d:"M.253 6.238l4.82 4.82c.338.338.612.224.612-.257V.45c0-.48-.275-.595-.613-.257L.253 5.013a.868.868 0 000 1.225z"}))};v5.defaultProps={viewBox:"0 0 6 12",xmlns:"http://www.w3.org/2000/svg"};var y5=pr(v5,{target:"eayws952"})({name:"21xn5r",styles:"transform:rotate(180deg)"}),b5=pr(u5,{shouldForwardProp:e=>"isDisabled"!==e,target:"eayws951"})({name:"1d2byrt",styles:"border-radius:3px;height:28px;padding-inline-start:10px;padding-inline-end:10px;text-align:center;width:60px"}),_5=function(e){return e.Next="next",e.Previous="previous",e}({}),A5=e=>{var{direction:t,isDisabled:n=!1,onClick:r}=e,o=qd(),{buttonColor:i}=o.components.Pagination.baseStyle,a=o.components.Pagination.baseStyle[tp.Disabled],{buttonColor:s}=a,l=n?"default":"pointer",c=n?s:i;return t===_5.Previous?Mr(v5,{"data-testid":"sp-ui-pagination-button-"+t,fill:c,cursor:l,height:"12px",onClick:r,width:"6px"}):Mr(y5,{"data-testid":"sp-ui-pagination-button-"+t,fill:c,cursor:l,height:"12px",onClick:r,width:"6px"})},E5=pr(wr,{target:"eayws950"})({name:"1d613a5",styles:"align-items:center;background-color:white;border-radius:3px;display:inline-flex;flex-direction:row;height:40px;justify-content:space-around;width:200px"});const w5=e=>{var{defaultPage:t=1,isDisabled:n=!1,max:r=999,min:o=1,onChange:a}=e,s=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,m5),l=qd(),{borderColor:c,pageCountColor:u}=l.components.Pagination.baseStyle,d=l.components.Pagination.baseStyle[tp.Disabled],{borderColor:p,pageCountColor:f}=d,h=n?f:u,m=n?p:c,[g,v]=(0,i.useState)(t),y=o<g,b=g<r;return(0,i.useEffect)((()=>{void 0===g&&v(t)}),[t,g]),Mr(E5,g5({"data-testid":"sp-ui-pagination",border:"1px solid "+m,cursor:function(){if(n)return"not-allowed";return}()},s),Mr(A5,{direction:_5.Previous,isDisabled:n||!y,onClick:()=>{_(h5(g-1,o,r))}}),Mr(l5,{"data-testid":"sp-ui-pagination-input",clampValueOnBlur:!1,defaultValue:t,isDisabled:n,onBlur:function(e){_(h5(Number(e.target.value),o,r))},onChange:function(e){_(Number(e))},value:g},Mr(b5,{"data-testid":"sp-ui-pagination-input-field",border:"1px solid "+m,borderColor:""+m,maxLength:3})),Mr(px,{color:f+" !important"},"of"),Mr(px,{color:h+" !important"},r),Mr(A5,{direction:_5.Next,isDisabled:n||!b,onClick:()=>{_(h5(g+1,o,r))}}));function _(e){e!==g&&(v(e),a&&(o<=e&&e<=r)&&a(e))}};var x5=(0,i.createContext)({addSelectedValue:()=>{},appliedValues:[],removeAppliedValue:()=>[],removeSelectedValue:()=>{},selectedValues:[],setAppliedValues:()=>{},setSelectedValues:()=>{},values:[]}),k5=e=>{var{children:t,values:n}=e,[r,o]=(0,i.useState)([]),[a,s]=(0,i.useState)([]),l=(0,i.useMemo)((()=>({addSelectedValue:e=>{s([...a||[],e])},appliedValues:r,removeAppliedValue:e=>{var t=r.filter((t=>t!==e));return o(t),t},removeSelectedValue:e=>{s(a.filter((t=>t!==e)))},selectedValues:a,setAppliedValues:()=>o(a),setSelectedValues:s,values:n})),[r,a,n]);return Mr(x5.Provider,{value:l},t)};function C5(){var e=(0,i.useContext)(x5);if(void 0===e)throw new Error("useSelectChecklist must be called within the SelectChecklistProvider");return e}var S5=["label","text","unlinkAction"];function M5(){return M5=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},M5.apply(null,arguments)}var T5=function(e){return Mr("svg",e,Mr("path",{d:"M13.6625 12.2325L17.2025 15.7725C17.5925 16.1625 17.5925 16.7925 17.2025 17.1825C16.8125 17.5725 16.1825 17.5725 15.7925 17.1825L12.2425 13.6525L8.7025 17.1925C8.3125 17.5825 7.6825 17.5825 7.2925 17.1925C6.9025 16.8025 6.9025 16.1725 7.2925 15.7825L10.8325 12.2425L7.2925 8.7025C6.9025 8.3125 6.9025 7.6825 7.2925 7.2925C7.6825 6.9025 8.3125 6.9025 8.7025 7.2925L12.2425 10.8325L15.7825 7.2925C16.1725 6.9025 16.8025 6.9025 17.1925 7.2925C17.5825 7.6825 17.5825 8.3125 17.1925 8.7025L13.6625 12.2325Z"}))};T5.defaultProps={width:"24",height:"24",fill:"none",xmlns:"http://www.w3.org/2000/svg"};var O5=pr(LK,{target:"e1ct9b7j2"})((e=>{var{theme:t}=e;return"\n        background-color: "+t.colors.blue[400]+";\n        margin: 0 "+t.spacing.md+" "+t.spacing.md+" 0;\n\n        &:hover {\n            background-color: "+t.colors.blue[300]+";\n        }\n    "}),""),D5=pr(PK,{target:"e1ct9b7j1"})((()=>"\n        color: white;\n    "),""),L5=pr(T5,{target:"e1ct9b7j0"})((e=>{var{theme:t}=e;return"\n        width: 26px;\n        height: 26px;\n        padding-left: 4px;\n        fill: white;\n\n        &:hover {\n            cursor: pointer;\n            fill: "+t.colors.blue[200]+";\n        }\n    "}),"");const P5=e=>{var{label:t,text:n,unlinkAction:r}=e,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,S5),i=t?t+": "+n:n;return Mr(O5,M5({"data-testid":"sp-ui-tag"},r?{paddingRight:"4px"}:{},o),Mr(D5,{"data-testid":"sp-ui-tag-text"},i),r&&Mr(L5,{onClick:r,"data-testid":"sp-ui-tag-close"}))};var I5=["onUnlinkAction"];function B5(){return B5=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},B5.apply(null,arguments)}var R5=pr(P5,{target:"e1k00gmy0"})({name:"duxdx5",styles:"margin-bottom:0;margin-top:8px"});const N5=e=>{var{onUnlinkAction:t}=e,n=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,I5),{appliedValues:r,removeAppliedValue:o,removeSelectedValue:i}=C5();return r&&r.length>0?Mr(_r,{marginTop:"12px"},r.map(((e,r)=>Mr(R5,B5({key:r,text:e.label,unlinkAction:()=>{return r=o(n=e)||[],i(n),void(t&&t(r,n));var n,r}},n))))):null};function F5(){return F5=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},F5.apply(null,arguments)}var j5=pr(VU,{target:"e1bav4p00"})({name:"awrnie",styles:"align-items:center;flex-direction:row-reverse;justify-content:space-between;margin-bottom:16px;padding-right:0;width:100%;h5{width:100%;}"});const Y5=e=>{var{addSelectedValue:t,removeSelectedValue:n,selectedValues:r,values:o}=C5();return Mr(_r,{"data-testid":"sp-ui-checklist"},o.map(((o,i)=>Mr(j5,F5({key:i,isChecked:r.includes(o),label:o.label,name:o.label,onChange:e=>{((e,r)=>{var{checked:o}=e.target;o?t(r):n(r)})(e,o)},value:o.value},e)))))};var $5,H5=gW({displayName:"ChevronDown",viewBox:"0 0 24 24",path:Mr("path",{fill:"currentColor",d:"M12 16l-6-6h12l-6 6z"})}),U5=gW({displayName:"ChevronDownThin",viewBox:"0 0 24 24",path:Mr("path",{d:"M12.002 13.0543L14.1953 10.861C14.4553 10.601 14.8753 10.601 15.1353 10.861C15.3953 11.121 15.3953 11.541 15.1353 11.801L12.4687 14.4677C12.2087 14.7277 11.7887 14.7277 11.5287 14.4677L8.86199 11.801C8.60199 11.541 8.60199 11.121 8.86199 10.861C9.12199 10.601 9.54199 10.601 9.80199 10.861L12.002 13.0543Z",fill:"#8298A1"})}),z5=(gW({displayName:"IconAddPhotos",viewBox:"0 0 24 24",path:Mr(i.Fragment,null,Mr("path",{d:"M18 11.025V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9.025A5.499 5.499 0 1 0 18 11.025",fill:"#F7F7F7"}),",",Mr("path",{d:"M17.52 21A4.525 4.525 0 0 1 13 16.48a4.525 4.525 0 0 1 4.52-4.521 4.525 4.525 0 0 1 4.52 4.521A4.525 4.525 0 0 1 17.52 21zM3 4h14v6.985A5.518 5.518 0 0 0 12.024 16H3V4zm15 6.983V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9.026A5.519 5.519 0 1 0 18 10.983z",fill:"#9FB0B7"}),",",Mr("path",{d:"M19.5 16H18v-1.5a.5.5 0 0 0-1 0V16h-1.5a.5.5 0 0 0 0 1H17v1.5a.5.5 0 0 0 1 0V17h1.5a.5.5 0 0 0 0-1M12 10a1 1 0 1 0 2 0 1 1 0 0 0-2 0M11 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0M8 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0",fill:"#9FB0B7"}))}),gW({displayName:"IconMoreTools",viewBox:"0 0 24 24",path:Mr("g",{fill:"none",fillRule:"evenodd"},Mr("path",{d:"M18 11.025V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9.025A5.499 5.499 0 1 0 18 11.025",fill:"#F7F7F7"}),Mr("path",{d:"M17.5 21a4.505 4.505 0 0 1-4.5-4.5c0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5-2.019 4.5-4.5 4.5zM7.061 10.354a1.502 1.502 0 0 0-2.122 0L3 12.293V4h14v7.025a5.502 5.502 0 0 0-4.89 4.376l-5.049-5.047zM3 16v-2.293l2.646-2.646a.5.5 0 0 1 .708 0L11.293 16H3zm15-4.975V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9.025A5.499 5.499 0 1 0 18 11.025z",fill:"#9FB0B7"}),Mr("path",{d:"M19.5 16H18v-1.5a.5.5 0 0 0-1 0V16h-1.5a.5.5 0 0 0 0 1H17v1.5a.5.5 0 0 0 1 0V17h1.5a.5.5 0 0 0 0-1M13 10c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m3-2a3 3 0 1 0-6 0 3 3 0 0 0 6 0",fill:"#9FB0B7"}))}),["children","selectProps","clearValue"]),W5=["isSelected","label","setValue","value"],V5=["getValue"],G5=["isInvalid","name","placeholder","onApply","onChange"];function Q5(){return Q5=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Q5.apply(null,arguments)}function q5(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}var K5=e=>Mr(EV.DropdownIndicator,e,Mr(sj,null,Mr(H5,{height:"24px",transform:e.selectProps.menuIsOpen&&"rotate(180deg)",width:"24px"})),Mr(dj,null,Mr(U5,{height:"44px",transform:e.selectProps.menuIsOpen&&"rotate(180deg)",width:"44px"}))),Z5=pr(wr,{target:"e14uc1dq4"})((e=>{var{theme:t}=e,{borderColor:n}=t.components.Select.baseStyle({});return"\n        align-items: center;\n        background-color: "+t.colors.gray[100]+";\n        border-top: 1px solid "+n+";\n        color: "+t.colors.blue[400]+";\n        font-weight: bold;\n        justify-content: space-around;\n        padding: "+t.gutters.sm+";\n\n        button {\n            "+t.responsive.smallScreenOnly($5||($5=function(e,t){return t||(t=e.slice(0)),e.raw=t,e}(["\n                width: 100%;\n            "])))+"\n        }\n    "}),""),J5=e=>{var{children:t,selectProps:n,clearValue:r}=e,o=q5(e,z5);return Mr(EV.Menu,o,t,Mr(Z5,{"data-testid":"sp-ui-select-checklist-menu-footer"},Mr(sj,null,Mr(Sx,{onClick:()=>r()},"Clear All")),Mr(fp,{loadedText:"Applied",loadingText:"Applying",onClick:()=>n.onApply(),type:"button",variant:sp.Primary},"Apply")))},X5=pr(VU,{target:"e14uc1dq3"})({name:"vqx3x2",styles:"margin-bottom:5px"}),e3=pr(VU,{target:"e14uc1dq2"})({name:"100xpxz",styles:"flex-direction:row-reverse;justify-content:space-between;padding-right:0;width:100%;h5{width:100%;}"}),t3=e=>{var{isSelected:t,label:n,setValue:r,value:o}=e,i=q5(e,W5);return Mr(EV.Option,i,Mr(sj,null,Mr(X5,{isChecked:t,label:n,name:"option-checkbox",onChange:r,value:o})),Mr(dj,null,Mr(e3,{isChecked:t,label:n,name:"option-checkbox",onChange:r,value:o})))},n3=pr("span",{target:"e14uc1dq1"})((e=>{var{theme:t}=e;return"\n        display: block;\n        color: "+t.colors.gray[700]+";\n        font-size: "+t.fontSizes.sm+";\n    "}),""),r3=pr(_r,{target:"e14uc1dq0"})((e=>{var{theme:t}=e;return"\n        color: "+t.colors.gray[600]+";\n        font-size: "+t.fontSizes.sm+";\n    "}),""),o3=e=>{var{getValue:t}=e,n=q5(e,V5),r=t();return Mr(EV.Placeholder,n,Mr(sj,null,Mr(r3,null,n.children)),Mr(dj,null,Mr(_r,null,"Filter by "+n.children),Mr(n3,null,r&&r.map((e=>e.label)).join(", "))))};const i3=e=>{var{isInvalid:t,name:n="",placeholder:r,onApply:o,onChange:a}=e,s=q5(e,G5),l=qd(),{selectedValues:c,setAppliedValues:u,setSelectedValues:d,values:p}=C5(),{baseStyle:f}=l.components.SelectChecklist,h={container:e=>Q5({},e,{":focus":{outline:"0"},backgroundColor:"",boxShadow:"none"}),control:e=>Q5({},e,{"&:focus":{borderColor:f.borderColor},":hover":{borderColor:t?f[tp.Invalid].borderColor:f.borderColor},backgroundColor:f.backgroundColor,borderColor:t?f[tp.Invalid].borderColor:f.borderColor,borderRadius:"3px",boxShadow:"none",height:"42px","@media only screen and (max-width: 768px)":{border:"none",backgroundColor:f.backgroundColorMobile,height:"52px"}}),dropdownIndicator:e=>Q5({},e,{padding:"7px 4px 7px 0"}),indicatorsContainer:e=>Q5({},e,{height:"auto",padding:"0",width:"auto","@media only screen and (max-width: 768px)":{width:"30px"}}),indicatorSeparator:e=>Q5({},e,{backgroundColor:"none"}),input:e=>Q5({},e,{color:"transparent"}),menu:e=>Q5({},e,{borderRadius:"3px",marginTop:"4px",minWidth:"240px","@media only screen and (max-width: 768px)":{boxShadow:"none"}}),menuList:e=>Q5({},e,{"@media only screen and (max-width: 768px)":{paddingBottom:"8px"}}),option:e=>Q5({},e,{backgroundColor:f.optionBackgroundColor,color:f.optionColor,fontSize:f.optionFontSize,"@media only screen and (max-width: 768px)":{"&:last-child":{borderColor:f.borderColor,borderStyle:"solid",borderBottomWidth:"1px"}}}),placeholder:(e,t)=>{var{selectProps:n}=t;return Q5({},e,{color:n.isDisabled?f[tp.Disabled].placeholderColor:f.placeholderColor,fontSize:f.placeholderFontSize,position:"unset",transform:"none","@media only screen and (max-width: 768px)":{fontSize:f.placeholderFontSizeMobile}})},singleValue:(e,t)=>{var{selectProps:n}=t;return Q5({},e,{color:n.isDisabled?f[tp.Disabled].valueColor:f.valueColor,fontSize:f.singleValueFontSize})},valueContainer:e=>Q5({},e,{padding:"3px 8px","@media only screen and (max-width: 768px)":{padding:"0"}})};return Mr(i.Fragment,null,Mr(_r,{"data-testid":"sp-ui-select-checklist"},Mr(OG,Q5({className:"react-select",classNamePrefix:"react-select",closeMenuOnSelect:!1,controlShouldRenderValue:!1,components:{DropdownIndicator:K5,Menu:J5,Option:t3,Placeholder:o3},hideSelectedOptions:!1,isClearable:!1,isMulti:!0,name:n,onApply:()=>{o&&o(c),u()},onChange:e=>{d(e||[]),a&&a(e)},options:p,placeholder:r,styles:h,value:c},s))))};var a3,s3,l3,c3,u3,d3,p3,f3,h3,m3=["cardFields","checklistFilterOptions","checklistFilterPlaceholder","columns","data","enableChecklistFilter","enablePagination","initialDateRangeFilterValue","initialSearchValue","isManualSort","isRowSelected","isStickyHeader","onCardClick","onChecklistFilterApply","onDateRangeFilterApplied","onPagination","onSearch","onSearchClear","onSort","pageCount","pageSize","searchPlaceholder"],g3=["cells","fields","rowData"];function v3(){return v3=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},v3.apply(null,arguments)}function y3(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}function b3(e,t){return t||(t=e.slice(0)),e.raw=t,e}var _3=function(e){return Mr("svg",e,Mr("path",{clipRule:"evenodd",d:"M4.58227 6.00066L0.292426 1.71082C-0.0982557 1.32014 -0.0972675 0.686511 0.294151 0.295092C0.688298 -0.0990549 1.31941 -0.0970983 1.70988 0.293367L6.67454 5.25803C7.06301 5.6465 7.06423 6.27517 6.67943 6.66709C6.63212 6.7607 6.56927 6.84855 6.49096 6.92686L1.71401 11.7038C1.31882 12.099 0.685569 12.0976 0.294151 11.7062C-0.0999964 11.3121 -0.0961914 10.6791 0.296554 10.2864L4.58227 6.00066Z"}))};_3.defaultProps={fill:"none",viewBox:"0 0 7 12",xmlns:"http://www.w3.org/2000/svg"};var A3=function(e){return Mr("svg",e,Mr("path",{d:"M5 8.5h5M17 8.5h2",stroke:"#677F89",strokeLinecap:"round"}),Mr("path",{clipRule:"evenodd",d:"M14.5 11a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",stroke:"#677F89",strokeLinecap:"round"}),Mr("path",{d:"M19 15.5h-5M7 15.5H5",stroke:"#677F89",strokeLinecap:"round"}),Mr("path",{clipRule:"evenodd",d:"M9.5 13a2.5 2.5 0 100 5 2.5 2.5 0 000-5z",stroke:"#677F89",strokeLinecap:"round"}))};A3.defaultProps={width:"24",height:"24",fill:"none",xmlns:"http://www.w3.org/2000/svg"};var E3=function(e){return Mr("svg",e,Mr("path",{d:"M6.653 11.346a5.003 5.003 0 007.07 0 5.003 5.003 0 000-7.07 5.003 5.003 0 00-7.07 0 5.003 5.003 0 000 7.07zm-2.07.65a6.986 6.986 0 01.66-9.14 7.007 7.007 0 019.9 0 7.007 7.007 0 010 9.9 7.01 7.01 0 01-9.14.66l-3.59 3.59a.996.996 0 11-1.41-1.41l3.58-3.6z",fill:"currentColor"}))};E3.defaultProps={viewBox:"0 0 18 18",fill:"none",xmlns:"http://www.w3.org/2000/svg"};var w3=function(e){return Mr("svg",e,Mr("path",{d:"M1.121 6.625a.66.66 0 00-.465.191.64.64 0 00-.191.465c0 .192.055.356.191.465L3.91 11c.11.137.274.191.465.191A.64.64 0 004.84 11l3.254-3.254a.66.66 0 00.191-.465c0-.164-.082-.328-.191-.465-.137-.109-.301-.191-.465-.191H1.12zm6.973-2.871c.11.137.191.3.191.465a.66.66 0 01-.191.465.64.64 0 01-.465.191H1.12c-.191 0-.355-.055-.465-.191-.136-.11-.191-.274-.191-.465a.64.64 0 01.191-.465L3.91.5a.66.66 0 01.465-.191c.164 0 .328.082.465.191l3.254 3.254z",fill:"#BCC8CD"}),Mr("path",{d:"M.656 6.816a.66.66 0 01.465-.191H7.63c.164 0 .328.082.465.191.11.137.191.301.191.465a.66.66 0 01-.191.465L4.84 11a.64.64 0 01-.465.191c-.191 0-.355-.054-.465-.191L.656 7.746c-.136-.11-.191-.273-.191-.465a.64.64 0 01.191-.465z",fill:"#156884"}))};w3.defaultProps={width:"9",height:"12",fill:"none",xmlns:"http://www.w3.org/2000/svg"};var x3=function(e){return Mr("svg",e,Mr("path",{d:"M1.121 6.625a.66.66 0 00-.465.191.64.64 0 00-.191.465c0 .192.055.356.191.465L3.91 11c.11.137.274.191.465.191A.64.64 0 004.84 11l3.254-3.254a.66.66 0 00.191-.465c0-.164-.082-.328-.191-.465-.137-.109-.301-.191-.465-.191H1.12zm6.973-2.871c.11.137.191.3.191.465a.66.66 0 01-.191.465.64.64 0 01-.465.191H1.12c-.191 0-.355-.055-.465-.191-.136-.11-.191-.274-.191-.465a.64.64 0 01.191-.465L3.91.5a.66.66 0 01.465-.191c.164 0 .328.082.465.191l3.254 3.254z",fill:"#BCC8CD"}),Mr("path",{d:"M8.094 3.754c.11.137.191.3.191.465a.66.66 0 01-.191.465.64.64 0 01-.465.191H1.12c-.191 0-.355-.055-.465-.191-.136-.11-.191-.274-.191-.465a.64.64 0 01.191-.465L3.91.5a.66.66 0 01.465-.191c.164 0 .328.082.465.191l3.254 3.254z",fill:"#156884"}))};x3.defaultProps={width:"9",height:"12",fill:"none",xmlns:"http://www.w3.org/2000/svg"};var k3=function(e){return Mr("svg",e,Mr("path",{d:"M1.121 6.625a.66.66 0 00-.465.191.64.64 0 00-.191.465c0 .192.055.356.191.465L3.91 11c.11.137.274.191.465.191A.64.64 0 004.84 11l3.254-3.254a.66.66 0 00.191-.465c0-.164-.082-.328-.191-.465-.137-.109-.301-.191-.465-.191H1.12zm6.973-2.871c.11.137.191.3.191.465a.66.66 0 01-.191.465.64.64 0 01-.465.191H1.12c-.191 0-.355-.055-.465-.191-.136-.11-.191-.274-.191-.465a.64.64 0 01.191-.465L3.91.5a.66.66 0 01.465-.191c.164 0 .328.082.465.191l3.254 3.254z",fill:"#BCC8CD"}))};k3.defaultProps={width:"9",height:"12",fill:"none",xmlns:"http://www.w3.org/2000/svg"};var C3=function(e){return Mr("svg",e,Mr("rect",{width:"100%",height:"100%",fill:"#fff"}),Mr("path",{d:"M75.686 21.254c5.923.122 11.778 2.02 15.705 5.693 4.133 3.918 5.992 9.244 8.885 13.959 7.715 12.672 21.767 16.896 34.097 24.732 9.781 6.245 29.206 15.918 23.145 29.202-2.756 6-10.47 8.816-17.565 10.347-7.095 1.53-14.81 2.571-20.114 7.101-4.615 3.918-6.337 9.734-9.437 14.693-5.028 7.959-14.12 13.836-24.177 15.55-25.97 4.53-28.793-19.958-43.878-31.284-4.478-3.367-10.333-4.897-15.774-6.917-16.257-5.816-16.257-20.02-9.782-33.243 7.577-15.366 22.87-26.202 35.475-38.507 3.65-3.551 7.439-7.224 12.398-9.367 3.238-1.347 7.164-2.02 11.022-1.96z",fill:"#F6F8F8"}),Mr("path",{opacity:".5",d:"M42.5 36.833v17h85v-17M42.5 121.833v-17h85v17",stroke:"#002B4C",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}),Mr("path",{fill:"#fff",d:"M42.5 65.167h55.25V93.5H42.5z"}),Mr("path",{d:"M86 65.167H42.5V93.5h41.417",stroke:"#002B4C",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}),Mr("path",{stroke:"#002B4C",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round",d:"M51 73.667h11.333V85H51zM72.25 76.5h10.083M72.25 82.167h9.667"}),Mr("circle",{cx:"116.297",cy:"81.798",transform:"rotate(-30 116.297 81.798)",fill:"#F6F8F8",r:"30.355"}),Mr("path",{d:"M92.914 62.333h38.583v34H87.581l-1.417-16.292 1.958-10.27 4.792-7.438z",fill:"#fff"}),Mr("path",{d:"M92.915 62.333H131.5v34H90.582M86.582 75.5h32.583M86.582 80.75h19.417",stroke:"#002B4C",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}),Mr("circle",{cx:"116.297",cy:"81.798",transform:"rotate(-30 116.297 81.798)",stroke:"#002B4C",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round",r:"30.355"}),Mr("path",{d:"M135 112l3.373 5.842",stroke:"#002B4C",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}),Mr("path",{fill:"#F6F8F8",stroke:"#002B4C",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round",d:"M134.064 119.771l8.762-5.059 19.57 33.896-8.762 5.06z"}))};C3.defaultProps={viewBox:"0 0 170 170",fill:"none",xmlns:"http://www.w3.org/2000/svg"};var S3="date-range",M3=pr(fp,{target:"el95i8i15"})((e=>{var{theme:t}=e;return"\n        font-size: "+t.fontSizes.sm+";\n        font-weight: "+t.fontWeights.normal+";\n        height: 42px;\n        width: 100%;\n\n        svg {\n            margin-right: 5px;\n        }\n    "}),""),T3=pr(wr,{target:"el95i8i14"})((e=>{var{theme:t}=e;return"\n        justify-content: flex-start;\n        margin: 20px 0;\n\n        "+t.responsive.smallScreenOnly(a3||(a3=b3(["\n            justify-content: center;\n        "])))+"\n    "}),""),O3=pr("span",{target:"el95i8i13"})({name:"1szq3rh",styles:"svg{display:inline-block;margin-left:5px;}"}),D3=pr(_r,{shouldForwardProp:e=>"hasCardFields"!==e,target:"el95i8i12"})((e=>{var{theme:t,hasCardFields:n}=e;return"\n        min-width: auto;\n        position: relative;\n\n        "+(n&&t.responsive.smallScreenOnly(s3||(s3=b3(["\n            display: none;\n        "]))))+"\n    "}),""),L3=pr(_r,{shouldForwardProp:e=>"isStickyHeader"!==e&&"hasSearch"!==e,target:"el95i8i11"})((e=>{var{hasSearch:t,selected:n=!1,isStickyHeader:r,theme:o}=e;return"\n        border: 1px solid "+o.components.Table.baseStyle.borderColor+";\n        border-bottom: none;\n        font-size: "+o.fontSizes.md+";\n\n        &:first-of-type {\n            border-bottom: 1px solid "+o.components.Table.baseStyle.borderColor+";\n\n            "+(t?"":"\n                        border-top-left-radius: "+o.components.Table.baseStyle.borderRadius+";\n                        border-top-right-radius: "+o.components.Table.baseStyle.borderRadius+";\n                    ")+"\n        }\n\n        &:last-of-type {\n            border-bottom-left-radius: "+o.components.Table.baseStyle.borderRadius+";\n            border-bottom-right-radius: "+o.components.Table.baseStyle.borderRadius+";\n        }\n\n        &:nth-of-type(2) {\n            border-top: none;\n        }\n\n        "+(n?"\n                    background-color: "+o.utility.convertHexToRgba(o.colors.blue[100],.2)+";\n                    border: 1px solid "+o.colors.blue[500]+";\n\n                    + div {\n                        border-top: none;\n                    }\n\n                    &:nth-of-type(2) {\n                        border-top: 1px solid "+o.colors.blue[500]+";\n                    }\n                ":"\n                    &:last-of-type {\n                        border-bottom: 1px solid "+o.components.Table.baseStyle.borderColor+";\n                    }\n\n                    &:nth-of-type(even) {\n                        background-color: "+o.colors.gray[100]+";\n                    }\n                ")+"\n\n        "+(r?"\n                    background-color: #FFFFFF;\n                    position: sticky;\n                    top: 0;\n                ":"")+"\n    "}),""),P3=pr(wr,{target:"el95i8i10"})((e=>{var{theme:t}=e;return"\n        align-items: center;\n        color: "+t.colors.gray[700]+";\n        margin: 0;\n        padding: 18px;\n\n        &:last-child {\n            border-right: 0;\n        }\n    "}),""),I3=pr(wr,{target:"el95i8i9"})((e=>{var{theme:t}=e;return"\n        align-items: flex-start;\n        color:  "+t.colors.navy[400]+";\n        font-weight: "+t.fontWeights.medium+";\n        margin: 0;\n        padding: 8px 18px;\n\n        &:last-child {\n            border-right: 0;\n        }\n    "}),""),B3=pr(_r,{shouldForwardProp:e=>"isStickyHeader"!==e,target:"el95i8i8"})((e=>{var{isStickyHeader:t}=e;return"\n        "+(t?"":"overflow: hidden;")+";\n    "}),""),R3=e=>{switch(e){case"right":return"flex-end";case"left":default:return"flex-start";case"center":return"center"}},N3=e=>{var{enableDateRangeFilter:t,initialDateRangeFilterValue:n,onApply:r}=e,o="MMM DD, YYYY",{appliedValues:a,selectedValues:s,setAppliedValues:l,setSelectedValues:c,values:u}=C5(),d=((a||[]).find((e=>{var{id:t}=e;return t===S3}))||{}).value,[p,f]=(0,i.useState)([]),h=(e,t)=>(e?QU()(e).format(o):"")+" – "+(t?QU()(t).format(o):""),m=xo(),g=e=>[u.length>0&&{panel:Mr(Y5,null),subtitle:Mr(Px,null,a.filter((e=>{var{id:t}=e;return t!==S3})).map((e=>e.label)).join(", ")),title:m("spUi.common.table.filterModal.accordionTitleOne")},t&&{panel:Mr(_r,{cursor:"pointer",marginBottom:"20px",onClick:e},Mr(_r,{pointerEvents:"none"},Mr(tW,{endDatePlaceholder:m("spUi.common.table.dateRangeFilter.endDatePlaceholder"),placeholder:m("spUi.common.table.dateRangeFilter.startDatePlaceholder"),selectRange:!0,value:[A,b]}))),subtitle:(A||b)&&Mr(Px,null,h(A,b)),title:m("spUi.common.table.filterModal.dateRangeAccordionTitle")}].filter((e=>Boolean(e))),[v=null,y=null]=d||n||[],[b,_]=(0,i.useState)(y),[A,E]=(0,i.useState)(v);return Mr(eY,{actionLinkText:m("spUi.common.table.filterModal.actionLinkText"),heading:m("spUi.common.table.filterModal.heading"),isActionLinkDisabled:0===(s||[]).length,onActionLink:()=>{var[e=null,t=null]=n||[];_(t),E(e),c([])}},Mr(Yq,{component:e=>Mr(W4,{initialEndDate:b,initialStartDate:A,onBack:e,onDateRangeSelected:t=>{var[n,r]=t;_(r),E(n),c([...(s||[]).filter((e=>{var{id:t}=e;return t!==S3})),{id:S3,label:h(n,r),value:[n,r]}]),e()}})},(e=>Mr(i.Fragment,null,Mr(eY.Body,null,Mr(bZ,{content:g(e),index:p,onChange:e=>{f(e)}})),Mr(eY.PrimaryButton,{onClick:e=>{r&&r(s),l(),f([]),e()}},m("spUi.common.table.filterModal.primaryButton"))))))},F3=pr(_r,{target:"el95i8i7"})((e=>{var{theme:t}=e;return"\n        border: 1px solid "+t.components.Table.baseStyle.borderColor+";\n        border-bottom-left-radius: "+t.components.Table.baseStyle.borderRadius+";\n        border-bottom-right-radius: "+t.components.Table.baseStyle.borderRadius+";\n\n        "+t.responsive.smallScreenOnly(l3||(l3=b3(["\n            border-bottom: none;\n            border-left: none;\n            border-right: none;\n        "])))+"\n    "}),""),j3=e=>{var{cells:t,fields:n,rowData:r}=e,o=y3(e,g3),i=n.reduce(((e,t,n)=>(n%2?e[e.length-1].push(t):e.push([t]),e)),[]),a=e=>{if(!e)return null;if("string"==typeof e){var n=t.find((t=>{var{column:n}=t;return n.id===e}));return n?n.render("Cell"):e}return e(r)};return Mr(Y3,v3({alignItems:"center","data-testid":"sp-ui-table-card"},o),Mr(_r,{flex:"1"},i.map(((e,t)=>{var[n,r]=e;return Mr(wr,{alignItems:"center",justifyContent:"space-between",key:t,mb:"10px"},Mr($3,{"data-testid":"sp-ui-table-card-field"},a(n)),Mr($3,{"data-testid":"sp-ui-table-card-field"},a(r)))}))),Mr(_3,{height:"12px",width:"7px"}))},Y3=pr(wr,{target:"el95i8i6"})((e=>{var{theme:t}=e;return"\n        border-top: 1px solid "+t.components.Table.baseStyle.borderColor+";\n        cursor: pointer;\n        padding: 14px 16px 8px;\n\n        &:nth-of-type(even) {\n            background: "+t.colors.gray[100]+";\n        }\n\n        &:last-of-type {\n            border-bottom: 1px solid "+t.components.Table.baseStyle.borderColor+";\n        }\n\n        svg {\n            fill: "+t.colors.gray[500]+";\n            height: 12px;\n            margin-left: 16px;\n            width: 7px;\n        }\n\n        "+t.responsive.mediumScreenUp(c3||(c3=b3(["\n            display: none;\n        "])))+"\n    "}),""),$3=pr(_r,{target:"el95i8i5"})((e=>{var{theme:t}=e;return"\n        color: "+t.colors.gray[700]+";\n        font-size: "+t.fontSizes.md+";\n    "}),""),H3=e=>{var{alignment:t,children:n}=e;return Mr(wr,{justify:R3(t),alignItems:"center",w:"100%"},n)},U3=()=>{var e=xo();return Mr(F3,null,Mr(z3,{"data-testid":"sp-ui-table-no-results"},Mr(C3,{height:"170px",width:"170px"}),Mr(gQ,null,e("spUi.common.table.noResultsHeading")),Mr(Px,null,e("spUi.common.table.noResultsDescription"))))},z3=pr(wr,{target:"el95i8i4"})((e=>{var{theme:t}=e;return"\n        align-items: center;\n        flex-direction: column;\n        padding: 126px 0;\n        margin: 0 auto;\n        width: 298px;\n\n        "+t.responsive.smallScreenOnly(u3||(u3=b3(["\n            padding-bottom: 0;\n            padding-top: 68px;\n        "])))+"\n    "}),""),W3=pr(_r,{target:"el95i8i3"})((e=>{var{theme:t}=e;return"\n        border: 1px solid "+t.components.Table.baseStyle.borderColor+";\n        border-bottom: none;\n        border-top-left-radius: "+t.components.Table.baseStyle.borderRadius+";\n        border-top-right-radius: "+t.components.Table.baseStyle.borderRadius+";\n        padding: 19px 20px 23px;\n\n        "+t.responsive.smallScreenOnly(d3||(d3=b3(["\n            border: none;\n            padding: 24px 0;\n            width: 100%;\n        "])))+"\n    "}),""),V3=pr(_r,{target:"el95i8i2"})((e=>{var{theme:t}=e;return"\n        width: 372px;\n\n        "+t.responsive.smallScreenOnly(p3||(p3=b3(["\n            width: 100%;\n        "])))+"\n    "}),""),G3=()=>Mr(F3,null,Mr(Q3,{description:""})),Q3=pr(BF,{target:"el95i8i1"})((e=>{var{theme:t}=e;return"\n        padding-bottom: 215px;\n        padding-top: 215px;\n\n        "+t.responsive.smallScreenOnly(f3||(f3=b3(["\n            padding-bottom: 155px;\n            padding-top: 155px;\n        "])))+"\n    "}),""),q3=pr(_r,{target:"el95i8i0"})((e=>{var{theme:t}=e;return"\n        margin-right: 16px;\n\n        "+t.responsive.smallScreenOnly(h3||(h3=b3(["\n            margin-right: 8px;\n            width: 100%;\n        "])))+"\n    "}),"");const K3=e=>{var{cardFields:t,checklistFilterOptions:n=[],checklistFilterPlaceholder:r,columns:o,data:a,enableChecklistFilter:s=!1,enablePagination:l=!1,initialDateRangeFilterValue:c,initialSearchValue:u="",isManualSort:d=!0,isRowSelected:p=(()=>!1),isStickyHeader:f=!1,onCardClick:h,onChecklistFilterApply:m=RF,onDateRangeFilterApplied:g,onPagination:v,onSearch:y,onSearchClear:b,onSort:_,pageCount:A,pageSize:E=25,searchPlaceholder:w=""}=e,x=y3(e,m3),{breakpoints:k}=qd(),C=i.useMemo((()=>o.map((e=>v3({},e,{accessor:e.getCellValue||e.id})))),[o]),S=i.useMemo((()=>a),[a]),M=i.useMemo((()=>({width:1})),[]),T=e=>(o.find((t=>{var{id:n}=t;return n===e}))||{}).alignment,{getTableProps:O,gotoPage:D,headerGroups:L,prepareRow:P,rows:I,setHiddenColumns:B,state:{sortBy:R,pageIndex:N}}=(0,z4.useTable)({columns:C,data:S,defaultColumn:M,initialState:{pageIndex:0,pageSize:E},manualPagination:!0,manualSortBy:d,pageCount:A},z4.useResizeColumns,z4.useFlexLayout,z4.useSortBy,z4.usePagination,z4.useRowSelect),[F,j]=(0,i.useState)(c),[Y,$]=(0,i.useState)(!1),H=()=>$(!1),U=xo(),z=(0,i.useRef)(),W=XF((e=>{var{open:t}=e;return Mr(M3,{onClick:t,variant:sp.Secondary},Mr(A3,{"data-testid":"sp-ui-table-filters-icon"}),U("spUi.common.table.filterButton"))}));return(0,i.useLayoutEffect)((()=>{var e=()=>{var{sm:e}=k;z.current&&z.current.offsetWidth<=Number(e.split("px")[0])?B(o.filter((e=>{var{collapsible:t}=e;return t})).map((e=>{var{id:t}=e;return t}))):B([])};return z.current&&(e(),window.addEventListener("resize",e)),()=>window.removeEventListener("resize",e)}),[k,o,B]),(0,i.useEffect)((()=>{_&&($(!0),_(R,H),D(N))}),[D,_,N,R]),(0,i.useEffect)((()=>{v&&($(!0),v({pageIndex:N,pageSize:E},H))}),[v,N,E]),Mr(i.Fragment,null,Mr(k5,{values:n},(s||g||y)&&Mr(W3,null,Mr(wr,null,y&&Mr(q3,null,Mr(iY,{initialValues:{tableSearch:u},onSubmit:e=>{var{tableSearch:t}=e;$(!0),y(t,H)}},(e=>{var{handleSubmit:t}=e;return Mr(V3,null,Mr(sQ,{append:Mr(E3,{height:"16.5px",width:"16.5px"}),appendOnClick:()=>{t()},"data-testid":"sp-ui-table-search",isClearable:!0,isDisabled:Y,name:"tableSearch",onClear:b?()=>{$(!0),b(H)}:void 0,placeholder:w}))}))),g&&Mr(sj,null,Mr(_r,{marginRight:"16px",width:"278px"},Mr(tW,{endDatePlaceholder:U("spUi.common.table.dateRangeFilter.endDatePlaceholder"),placeholder:U("spUi.common.table.dateRangeFilter.startDatePlaceholder"),onChange:e=>{var t=e,n=t.some((e=>Boolean(e)))?t:c;j(n),$(!0),g(n||[],H)},selectRange:!0,value:F}))),s&&Mr(sj,null,Mr(i3,{name:"react-table-checklist-filter",placeholder:r,onApply:e=>{$(!0),m(e,H)}})),(s||g)&&Mr(dj,{flex:"1"},Mr(JF,null,Mr(W,null),Mr(N3,{enableDateRangeFilter:Boolean(g),initialDateRangeFilterValue:c,onApply:e=>{var t=(e||[]).reduce(((e,t)=>{var{id:n,value:r}=t;return n===S3?(g&&g(r,H),e):[...e,t]}),[]);$(!0),m(t,H)}})))),(s||g)&&Mr(i.Fragment,null,Mr(sj,null,Mr(N5,{onUnlinkAction:e=>{$(!0),m(e,H)}})),Mr(dj,null,Mr(N5,{onUnlinkAction:(e,t)=>{var{id:n}=t;$(!0),n===S3&&g&&g(c||[],H),m(e,H)}}))))),Y?Mr(G3,null):0===a.length?Mr(U3,null):Mr(i.Fragment,null,Mr(D3,v3({hasCardFields:Boolean(t),"data-testid":"sp-ui-table",ref:z},O(),x),Mr(B3,{isStickyHeader:f},L.map(((e,t)=>{var{getHeaderGroupProps:n,headers:r}=e;return Mr(L3,v3({},n({}),{"data-testid":"sp-ui-table-header-row",hasSearch:Boolean(y),isStickyHeader:f,key:t}),r.map(((e,t)=>{var{canSort:n,getHeaderProps:r,getSortByToggleProps:o,id:i,isSorted:a,isSortedDesc:s,render:l}=e;return Mr(I3,v3({},r(o()),{"data-testid":"sp-ui-table-header-column",key:t}),Mr(H3,{alignment:T(i)},l("Header"),n&&Mr(O3,{"data-testid":"sp-ui-table-sort-icon"},a?(e=>Mr(e?w3:x3,null))(s):Mr(k3,null))))})))})),I.map(((e,t)=>(P(e),Mr(L3,v3({},e.getRowProps(),{key:t,selected:p(e.original),"data-testid":"sp-ui-table-row"}),e.cells.map(((e,t)=>{var{column:n,getCellProps:r,render:o}=e,{id:i}=n;return Mr(P3,v3({},r(),{"data-testid":"sp-ui-table-column",key:t}),Mr(H3,{alignment:T(i)},o("Cell")))})))))))),t&&h&&I.map(((e,n)=>{var{allCells:r,original:o}=e;return Mr(j3,{cells:r,fields:t,key:n,onClick:()=>h(o),rowData:o})})),l&&Mr(T3,null,Mr(w5,{defaultPage:N+1,max:((e,t,n)=>t||Math.ceil(e.length/n))(S,A,E),onChange:e=>{var t=e?e-1:0;v&&v({pageIndex:N,pageSize:E},H),D(t)}}))))};var Z3,J3=fr(gQ)(Z3||(Z3=zM(["\n    font-size: 36px;\n    line-height: 1em;\n    font-weight: 300;\n"])));const X3=function(e){var t=e.accountCredits,n=e.bills,r=e.onPrintClick,o=e.unbilledUsage,a=e.upcomingBookingPlanDetails,s=e.upcomingPlanDetails,l=e.upcomingMusicPlanDetails,c=[{Header:"Date",disableSortBy:!0,id:"date"},{Header:"Description",disableSortBy:!0,id:"description"},{Header:"Amount",disableSortBy:!0,id:"amount"},{Header:"Status",disableSortBy:!0,id:"status"},{Header:"",disableSortBy:!0,id:"billId",Cell:function(e){return i.createElement(Sx,{"data-testid":"billing-print-link",onClick:function(){return r(e.value)}},"Print")}}];return i.createElement(i.Fragment,null,i.createElement(J3,{"data-testid":"billing-history-section-heading"},"History & Billing"),i.createElement("div",{"data-testid":"billing-history-section-content"},i.createElement("div",{className:"bold","data-testid":"billing-history-section-upcoming-bill-heading"},"Upcoming Bill:"),i.createElement("ul",null,i.createElement("li",{"data-testid":"billing-history-section-upcoming-photo-bill"},s.date+": "+s.amount+" photo plan plus applicable taxes"),l&&i.createElement("li",{"data-testid":"billing-history-section-upcoming-music-bill"},l.date+": "+l.amount+" music plan plus applicable taxes"),a&&i.createElement("li",{"data-testid":"billing-history-section-upcoming-booking-bill"},a.date+": "+a.amount+" booking plan plus applicable taxes"),t&&t.length>0&&i.createElement("li",{"data-testid":"billing-history-section-account-credits-subheading"},"Account Credit:",i.createElement("ul",null,t.map((function(e){return i.createElement("li",{key:e,"data-testid":"billing-history-section-account-credit-element"}," ",e)})))),o&&i.createElement("li",{"data-testid":"billing-history-section-unbilled-usage"},"Unbilled Usage: ",o))),n&&n.length>0&&i.createElement(K3,{columns:c,data:n}))};var e6,t6,n6,r6=function(e){var t=e.onSubmit,r=e.isOpen,o=void 0!==r&&r,a=e.photo,s=e.photoUrl,l=e.item,c=e.frame,u=e.disableRotating,d=xo(),p=nY(),f=p.open,h=p.Modal,g=p.close,v=m((0,i.useState)(l.crop),2),y=v[0],b=v[1],_=(0,i.useCallback)((function(e){b(e)}),[]),A=(0,i.useCallback)((function(){t(y)}),[y,t]);return(0,i.useEffect)((function(){o?f():g()}),[f,g,o]),i.createElement(h,{variant:yp.Fullscreen,showCloseButton:!1,areButtonsCentered:!0,hideSecondaryAction:!1},i.createElement(h.Body,null,i.createElement(cO,{disableRotating:u,item:n({},l,{crop:y}),photo:a,photoUrl:s,frame:c,onUpdate:_}),i.createElement(h.PrimaryButton,{onClick:A},d("Set Crop"))))},o6=function(e,t,n){var o=e(n);(0,r.H)(document.getElementById(t)).render(o)},i6=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:window.Sp;return Object.assign(t.v2ReactBridge,n({},e))},a6=JSON.parse(null!==(e6=null===(t6=document.querySelector("body"))||void 0===t6?void 0:t6.getAttribute("data-translations"))&&void 0!==e6?e6:"{}"),s6=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};try{return e.split(".").reduce((function(e,t){return e[t]}),a6).replace(/{{ ?([A-Za-z0-9]+) ?}}/g,(function(e,n){return t[n]||""}))}catch(t){return e}};var l6=pr(wr,{target:"enoz9p60"})((e=>{var{theme:t}=e;return"\n        margin-top: 20px;\n        min-height: 58vh;\n        justify-content: center;\n\n        "+t.responsive.smallScreenOnly(n6||(n6=function(e,t){return t||(t=e.slice(0)),e.raw=t,e}(["\n            min-height: 100%;\n        "])))+"\n\n        & iframe {\n            height: 100%;\n        }\n    "}),""),c6=function(e){return function(e,t){var n=n=>Mr(wo,{translate:t},Mr(e,n)),r=e.displayName||e.name;return n.displayName="withTranslate"+r,n}(e,s6)},u6=c6($q((e=>{var{errorMessage:t,hasError:n=!1,onReset:r=RF,openSubscribe:o,resetText:a}=e,[s,l]=(0,i.useState)(!1),c=(0,i.useRef)(null),u=()=>{l(!0)},d=()=>{l(!1)},p={close:d,open:u,update:e=>{c.current&&(c.current.innerHTML="",c.current.append(e))}};return(0,i.useEffect)((()=>{o(p)}),[u,o]),Mr(i.Fragment,null,!n&&Mr(sB,{closeOnOverlayClick:!1,isOpen:s,onClose:r},Mr(vF,null),Mr(Zj,{variant:yp.Small},Mr(Jj,{variant:yp.Small}," "),Mr(Kj,{onClick:d}),Mr(lB,null,Mr(l6,{"data-testid":"sp-ui-braintree-challenge-content",ref:c})))),n&&Mr(Fq,{headerText:"Error!",onClose:r,openSubscribe:e=>e(),secondaryActionText:a},Mr(Px,null,t||"Your payment method could not be verified. Please check the information or try a different form of payment.")))})));function d6(e){var t=e.open,n=e.close,r=e.update;return i6({closeBraintreeChallenge:n,openBraintreeChallenge:t,updateBraintreeChallenge:r})}var p6=$q((function(e){var t=e.onPrimaryButtonClick,n=void 0===t?function(){return null}:t,r=e.withOpen,o=nY(),a=o.Modal,s=o.open;return(0,i.useEffect)((function(){r(s)}),[s,r]),i.createElement(a,{heading:"Multiple Brands Not Available in Plan"},i.createElement(a.Body,null,i.createElement(Px,null,"Please upgrade to get access to multiple brands.")),i.createElement(a.PrimaryButton,{onClick:n},"View Plan Options"))})),f6=function(e){return e.Succeeded="succeeded",e.Failed="failed",e}({});Xr().shape({id:Xr().string.isRequired,date:Xr().string.isRequired,grandTotal:Xr().string.isRequired,message:Xr().string,status:Xr().oneOf([f6.Failed,f6.Succeeded]).isRequired}).isRequired;var h6=pr(wr,{target:"e1t2l2xw1"})((e=>{var{theme:t}=e;return"\n        padding: 15px 20px;\n        border: 1px solid "+t.colors.gray[200]+";\n        max-width: 400px;\n    "}),""),m6=pr(fx,{target:"e1t2l2xw0"})({name:"rnnx2x",styles:"font-size:12px"});const g6=e=>{var{order:t}=e,n=xo(),{id:r,date:o,grandTotal:i}=t,a=n("Order")+" "+r,s=n("Order Date")+": "+o;return Mr(h6,{"data-testid":"combine-order-payment-tile"},Mr(wr,{flexDirection:"column",width:"100%"},Mr(wr,{justifyContent:"space-between"},Mr(wx,null,a),Mr(wx,null,i)),Mr(m6,null,s)))};function v6(){return v6=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},v6.apply(null,arguments)}var y6=pr(xF,{target:"e1gcx0qr2"})((e=>{var{theme:t}=e;return"\n        color: "+t.colors.red[500]+";\n        font-size: "+t.fontSizes.md+";\n        font-weight: "+t.fontWeights.bold+";\n        margin-bottom: 8px;\n    "}),""),b6=pr(bx,{target:"e1gcx0qr1"})({name:"5bhc30",styles:"margin-bottom:8px"}),_6=pr(_r,{target:"e1gcx0qr0"})({name:"1xairpr",styles:">div{margin-bottom:16px;}"}),A6=e=>{var{orders:t}=e,n=xo();return Mr(_r,{"data-testid":"combine-orders-failed-section"},Mr(Px,null,n("We could not process payment for "+t.length+" of the orders. They will not be included in the combined order.")),Mr(b6,{as:"p",marginTop:"24px"},"You will need to reach out to your client(s) for an updated payment method."),t.map((e=>Mr(E6,{key:e.id,order:e}))))},E6=e=>{var{order:t}=e;return Mr(wr,{flexDirection:"column",marginY:"22px"},Mr(y6,null,t.message),Mr(g6,{order:t}))},w6=e=>{var{orders:t}=e,n=xo(),r=1===t.length,o=Mr(_r,{marginBottom:"24px"},Mr(b6,{as:"p"},n(r?"The following order was processed successfully.":"The following orders were processed successfully and will be included in the combined order.")),Mr(_6,null,t.map((e=>Mr(g6,{key:e.id,order:e})))));return Mr(bZ,{"data-testid":"combine-orders-successful-section",content:[{title:n("Completed Successfully"),panel:o}]})};const x6=e=>{var{onClose:t,onCombineOrders:n,openSubscribe:r,orders:o}=e,i=xo(),a=o.filter((e=>e.status===f6.Failed)),s=o.filter((e=>e.status===f6.Succeeded)),l=a.length>0,c=s.length>0,u=s.length<2;return Mr(Fq,v6({headerText:"Unable to process payment",onClose:t,openSubscribe:r,secondaryActionText:"Cancel"},u?{}:{primaryAction:n,primaryActionText:"Create Combined Order"}),l&&Mr(A6,{orders:a}),c&&Mr(w6,{orders:s}),u&&Mr(Px,{marginTop:"16px"},i("There must be a minimum of two successfully paid orders to make a combined order.")))};var k6=function(e){return e()},C6=c6($q(x6));const S6=e=>{var{errorMessage:t,onClose:n,openSubscribe:r}=e,o=xo();return Mr(Fq,{headerText:o("Unable to process payment"),openSubscribe:r,onClose:n},Mr(Px,null,o("The payment method could not be processed.")," ",t),Mr(Px,{marginTop:"16px"},o("The payment status of this order is now unpaid. You will need to reach out to your client to update the payment method for this order.")))};var M6=function(e){return e()},T6=c6($q(S6)),O6=["variant","children"],D6={primary:{color:"white",backgroundColor:"primary.400",borderColor:"primary.400",hoverBackgroundColor:"primary.500"},"outline primary":{color:"primary.400",backgroundColor:"transparent",borderColor:"primary.400",borderWidth:"1px",hoverBackgroundColor:"var(--chakra-colors-gray-200)"},secondary:{color:"primary.400",backgroundColor:"transparent",borderColor:"transparent",hoverBackgroundColor:"var(--chakra-colors-gray-200)"},destructive:{color:"white",backgroundColor:"red.500",borderColor:"red.500",hoverBackgroundColor:"red.500"}},L6=function(e,r){var o=e.variant,a=void 0===o?"primary":o,s=e.children,l=t(e,O6),c=D6[a],u=c.color,d=c.backgroundColor,p=c.borderColor,f=c.hoverBackgroundColor;return i.createElement(Wr,n({ref:r,type:"button",color:u,cursor:"pointer",backgroundColor:d,border:"1px solid "+p,height:"36px",fontFamily:"'azo-sans-web', 'Helvetica', 'Arial', sans-serif",fontSize:"12px",lineHeight:"18px",borderRadius:"8px",_hover:{backgroundColor:f,color:u,"&:disabled":{backgroundColor:d}},_focus:{boxShadow:"none"},_focusVisible:{boxShadow:"outline","&:disabled":{backgroundColor:d}},_active:{"&:disabled":{backgroundColor:d}}},l),s)};const P6=(0,i.forwardRef)(L6);const I6=function(e){var t=e.brandId,n=e.email,r=e.eventId,o=e.isOpen,a=e.onClose,s=zo("brand/"+t+"/event/"+r+"/subscription",{method:Fo.POST,data:{email:n,state:"subscribed"},defer:!0}).performFetch,l=Co("studio.event.resubscribeModal");return i.createElement(sB,{isOpen:o,onClose:a,size:"lg"},i.createElement(vF,null),i.createElement(uF,null,i.createElement(dF,null,i.createElement(qr,null,l("heading"))),i.createElement(cB,null),i.createElement(lB,null,i.createElement(qr,null,l("description"))),i.createElement(pF,null,i.createElement(P6,{onClick:a,variant:"secondary"},l("cancel")),i.createElement(P6,{onClick:Lo(Io().mark((function e(){return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,s();case 2:a(),location.reload();case 4:case"end":return e.stop()}}),e)}))),type:"submit",variant:"primary"},l("confirm")))))};const B6=c6(K2((function(e){var t=n({},(F2(e),e)),r=zF({defaultIsOpen:!0}),o=r.isOpen,a=r.onClose;return i.createElement(I6,n({},t,{isOpen:o,onClose:a}))})));var R6=["diagonal","horizontal"],N6='\n<div style="text-align: center; padding: 40px;">\n  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">\n    <circle cx="12" cy="12" r="10"/>\n    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>\n  </svg>\n  <h2 style="margin: 20px 0 10px; font-size: 24px; font-weight: 600;">Screenshot Protection Enabled</h2>\n  <p style="margin: 0; font-size: 16px; opacity: 0.8;">This content is protected. Screenshots are not permitted.</p>\n</div>\n';function F6(){let e="ontouchstart"in window||navigator.maxTouchPoints>0,t=navigator.userAgent.toLowerCase(),n=["android","webos","iphone","ipad","ipod","blackberry","windows phone","opera mini","mobile"].some((e=>t.includes(e))),r=window.innerWidth<768;return e&&(n||r)}var j6=class e{constructor(){this.observer=null,this.selectors=[],this.protectedElements=new Map,this.onElementAdded=null,this.onElementRemoved=null}start(e,t,n){this.selectors=e,this.onElementAdded=t,this.onElementRemoved=n,this.observer=new MutationObserver(this.handleMutations.bind(this)),this.scanAndProtect(document.body),this.observer.observe(document.body,{childList:!0,subtree:!0})}stop(){this.observer?.disconnect(),this.observer=null,this.onElementRemoved&&this.protectedElements.forEach(((e,t)=>{this.onElementRemoved(t,e)})),this.protectedElements.clear(),this.selectors=[],this.onElementAdded=null,this.onElementRemoved=null}matchesAnySelector(e){return this.selectors.some((t=>{try{return e.matches(t)}catch{return!1}}))}getCombinedSelector(){return this.selectors.join(",")}registerProtection(e,t){this.protectedElements.set(e,t)}getProtection(e){return this.protectedElements.get(e)}isProtected(e){return this.protectedElements.has(e)}unregisterProtection(e){this.protectedElements.delete(e)}getProtectedCount(){return this.protectedElements.size}static isOwnElement(t){return!!t.closest(`.${e.CONTAINER_CLASS}`)||t.hasAttribute("data-copydeter-clone")}scanAndProtect(t){if(this.onElementAdded&&0!==this.selectors.length&&!e.isOwnElement(t)){this.matchesAnySelector(t)&&!this.isProtected(t)&&this.onElementAdded(t);try{let n=t.querySelectorAll(this.getCombinedSelector()),r=Array.from(n).filter((t=>!this.isProtected(t)&&!e.isOwnElement(t)));for(let e of r)this.onElementAdded(e)}catch{}}}handleMutations(e){if(this.observer){this.observer.disconnect();try{e.forEach((e=>{Array.from(e.addedNodes).forEach((e=>{e instanceof Element&&this.scanAndProtect(e)})),Array.from(e.removedNodes).forEach((e=>{e instanceof Element&&this.cleanupRemovedElement(e)}))}))}finally{this.observer.observe(document.body,{childList:!0,subtree:!0})}}}cleanupRemovedElement(e){let t=this.protectedElements.get(e);t&&this.onElementRemoved&&(this.onElementRemoved(e,t),this.protectedElements.delete(e));try{let t=e.querySelectorAll(this.getCombinedSelector());Array.from(t).forEach((e=>{let t=this.protectedElements.get(e);t&&this.onElementRemoved&&(this.onElementRemoved(e,t),this.protectedElements.delete(e))}))}catch{}}};j6.CONTAINER_CLASS="copydeter-container";var Y6=j6,$6={macos:[{meta:!0,shift:!0},{meta:!0,ctrl:!0,shift:!0}],windows:[{meta:!0,shift:!0},{ctrl:!0,shift:!0}],linux:[{shift:!0}],unknown:[]};function H6(e,t){if(t.meta&&!e.metaKey||t.ctrl&&!e.ctrlKey||t.shift&&!e.shiftKey||t.alt&&!e.altKey)return!1;let n=(!t.meta||e.metaKey)&&(!t.ctrl||e.ctrlKey)&&(!t.shift||e.shiftKey)&&(!t.alt||e.altKey),r=["Meta","Shift","Control","Alt"].includes(e.key);return n&&r}var U6=class{constructor(e,t=!0){this.overlay=null,this.handleDismiss=()=>{this.hide()},this.handleKeyUp=e=>{e.metaKey||e.ctrlKey&&e.shiftKey?document.addEventListener("keyup",this.handleKeyUp,{once:!0}):this.hide()},this.customHtml=e,this.dismissOnClick=t}show(){this.overlay||(this.overlay=this.createOverlay(),document.body.appendChild(this.overlay),this.dismissOnClick&&document.addEventListener("click",this.handleDismiss,{once:!0}),document.addEventListener("keyup",this.handleKeyUp,{once:!0}))}hide(){this.overlay&&(this.dismissOnClick&&document.removeEventListener("click",this.handleDismiss),document.removeEventListener("keyup",this.handleKeyUp),this.overlay.remove(),this.overlay=null)}destroy(){this.hide()}createOverlay(){let e=document.createElement("div");return e.className="copydeter-screenshot-overlay",e.innerHTML=this.customHtml,Object.assign(e.style,{position:"fixed",top:"0",left:"0",right:"0",bottom:"0",zIndex:"2147483647",display:"flex",alignItems:"center",justifyContent:"center"}),e}},z6=class{constructor(e,t,n,r){this.isListening=!1,this.handleKeyDown=e=>{(function(e,t){let n=$6[t];for(let t of n)if(H6(e,t))return!0;return!1})(e,this.os)&&this.keyboardOverlay.show()},this.handleFocusLost=()=>{this.focusOverlay.show()},this.handleFocusRestored=()=>{this.focusOverlay.hide()},this.handleVisibilityChange=()=>{document.hidden?this.focusOverlay.show():this.focusOverlay.hide()},this.keyboardOverlay=new U6(e,!1),this.focusOverlay=new U6(r??e,!0),this.os=function(){let e=navigator.userAgent.toLowerCase(),t=navigator.platform?.toLowerCase()??"";return t.includes("mac")||e.includes("macintosh")?"macos":t.includes("win")||e.includes("windows")?"windows":t.includes("linux")||e.includes("linux")?"linux":"unknown"}(),this.keyboardEnabled=t,this.focusLevel=n}start(){this.isListening||(this.isListening=!0,this.keyboardEnabled&&document.addEventListener("keydown",this.handleKeyDown,!0),"blur"===this.focusLevel?(window.addEventListener("blur",this.handleFocusLost),window.addEventListener("focus",this.handleFocusRestored)):"visibilitychange"===this.focusLevel&&document.addEventListener("visibilitychange",this.handleVisibilityChange))}stop(){this.isListening&&(this.isListening=!1,document.removeEventListener("keydown",this.handleKeyDown,!0),window.removeEventListener("blur",this.handleFocusLost),window.removeEventListener("focus",this.handleFocusRestored),document.removeEventListener("visibilitychange",this.handleVisibilityChange),this.keyboardOverlay.destroy(),this.focusOverlay.destroy())}},W6={container:"copydeter-container",blurTL:"copydeter-blur-tl",blurBR:"copydeter-blur-br",blurActive:"copydeter-blur-active"},V6={diagonal:{clipPathA:"polygon(0 0, 100% 0, 0 100%)",clipPathB:"polygon(100% 0, 100% 100%, 0 100%)"},horizontal:{clipPathA:"polygon(0 0, 100% 0, 100% 50%, 0 50%)",clipPathB:"polygon(0 50%, 100% 50%, 100% 100%, 0 100%)"}};function G6(e,t="diagonal"){let n=e,r="IMG"===e.tagName,o=V6[t],i=window.getComputedStyle(n),a="absolute"===i.position||"fixed"===i.position,s=i.transform&&"none"!==i.transform;return a&&s?function(e,t,n){let r=document.createElement("div");r.className=W6.container,Object.assign(r.style,{position:"absolute",top:"0",right:"0",bottom:"0",left:"0",overflow:"hidden",pointerEvents:"auto"});let o=e.parentNode;if(!o)return{blurSwapped:!1};o.insertBefore(r,e),r.appendChild(e);let i=Q6(e,t,"tl",!1,!0,n.clipPathA),a=Q6(e,t,"br",!0,!0,n.clipPathB);return r.appendChild(i),r.appendChild(a),{container:r,blurOverlayTL:i,blurOverlayBR:a,blurSwapped:!1}}(n,r,o):function(e,t,n){if(!e.parentNode)return{blurSwapped:!1};let r=Q6(e,t,"tl",!1,!1,n.clipPathA),o=Q6(e,t,"br",!0,!1,n.clipPathB);return e.after(r,o),{blurOverlayTL:r,blurOverlayBR:o,blurSwapped:!1,siblingMode:!0}}(n,r,o)}function Q6(e,t,n,r,o,i){let a;if(t){let t=document.createElement("img");t.src=e.src,t.alt="",t.draggable=!1,a=t}else a=document.createElement("div");return a.className="tl"===n?W6.blurTL:W6.blurBR,a.setAttribute("data-copydeter-clone",""),r&&a.classList.add(W6.blurActive),o?Object.assign(a.style,{clipPath:i,WebkitClipPath:i,pointerEvents:"none",filter:r?"blur(8px)":"none",transition:"filter 0.15s ease"}):Object.assign(a.style,{position:"absolute",top:"0",left:"0",width:"100%",height:"100%",objectFit:e.style.objectFit||"cover",clipPath:i,WebkitClipPath:i,pointerEvents:"none",filter:r?"blur(8px)":"none",transition:"filter 0.15s ease"}),a}function q6(e,t){t?(e.style.filter="blur(8px)",e.classList.add(W6.blurActive)):(e.style.filter="none",e.classList.remove(W6.blurActive))}var K6=!1;function Z6(e){let{container:t}=e,n=t?[t]:(()=>{let t=e.element.parentElement;return t?[t]:[]})();if(0===n.length)return;let r=null,o=!1,i=e=>{null!==r&&(K6&&console.log("[CopyDeter] clearPressTimer:",e),clearTimeout(r),r=null)},a=t=>{K6&&console.log("[CopyDeter] touchStartHandler triggered by",t.type),i("new touchstart"),o=!1,r=setTimeout((()=>{r=null,o=!0,K6&&console.log("[CopyDeter] long-press timer fired, calling swapBlur"),function(e,t=!1){let{blurOverlayTL:n,blurOverlayBR:r,blurSwapped:o}=e;t&&console.log("[CopyDeter] swapBlur called",{blurSwapped:o,hasTL:!!n,hasBR:!!r}),n&&r&&(o?(q6(n,!1),q6(r,!0),e.blurSwapped=!1):(q6(n,!0),q6(r,!1),e.blurSwapped=!0),t&&console.log("[CopyDeter] swapBlur complete",{newBlurSwapped:e.blurSwapped}))}(e,K6)}),400)},s=e=>{if(K6&&console.log("[CopyDeter] touchEndHandler triggered by",e.type,{didLongPress:o}),i("touchend"),o)o=!1;else if(t){let e=t.nextElementSibling;e&&"function"==typeof e.click&&e.click()}},l=e=>{K6&&console.log("[CopyDeter] cancelHandler triggered by",e.type),i("cancel"),o=!1};e.touchStartHandler=a,e.touchEndHandler=s,e.touchCancelHandler=l;for(let e of n)e.addEventListener("touchstart",a,{passive:!0}),e.addEventListener("touchend",s,{passive:!0}),e.addEventListener("touchcancel",l,{passive:!0}),e.addEventListener("mousedown",a),e.addEventListener("mouseup",s),e.addEventListener("mouseleave",l)}var J6=null,X6=null,e9=null,t9=!1,n9=!1;function r9(...e){J6?.debug&&console.log("[CopyDeter]",...e)}function o9(e){if(t9)throw new Error("CopyDeter is already initialized. Call destroy() first to reinitialize.");(function(e){if(!e||"object"!=typeof e)throw new Error("CopyDeter.init() requires a configuration object");let t=e;if("boolean"!=typeof t.screenshotProtectionEnabled)throw new Error("screenshotProtectionEnabled must be a boolean");if("boolean"!=typeof t.mobileProtectionEnabled)throw new Error("mobileProtectionEnabled must be a boolean");if(!Array.isArray(t.targetSelectors))throw new Error("targetSelectors must be an array of CSS selector strings");for(let e of t.targetSelectors){if("string"!=typeof e||""===e.trim())throw new Error("Each targetSelector must be a non-empty string");try{document.querySelector(e)}catch{throw new Error(`Invalid CSS selector: "${e}"`)}}if(void 0!==t.overlayHtml&&"string"!=typeof t.overlayHtml)throw new Error("overlayHtml must be a string if provided");if(void 0!==t.windowFocusOverlayHtml&&"string"!=typeof t.windowFocusOverlayHtml)throw new Error("windowFocusOverlayHtml must be a string if provided");let n=["off","blur","visibilitychange"];if(void 0!==t.windowFocusProtectionLevel&&!n.includes(t.windowFocusProtectionLevel))throw new Error(`windowFocusProtectionLevel must be one of: ${n.join(", ")}`);if(void 0!==t.mobileBlurType&&!R6.includes(t.mobileBlurType))throw new Error(`mobileBlurType must be one of: ${R6.join(", ")}`);if(void 0!==t.forceMobile&&"boolean"!=typeof t.forceMobile)throw new Error("forceMobile must be a boolean if provided");if(void 0!==t.debug&&"boolean"!=typeof t.debug)throw new Error("debug must be a boolean if provided")})(e),J6=function(e){return{...e,overlayHtml:e.overlayHtml??N6,windowFocusOverlayHtml:e.windowFocusOverlayHtml??e.overlayHtml??N6,windowFocusProtectionLevel:e.windowFocusProtectionLevel??"off",mobileBlurType:e.mobileBlurType??"diagonal",forceMobile:e.forceMobile??!1,debug:e.debug??!1}}(e),function(e){K6=e}(J6.debug),r9("Initializing",{isMobile:n9=J6.forceMobile||F6(),forceMobile:J6.forceMobile,isMobileDevice:F6(),screenshotProtectionEnabled:J6.screenshotProtectionEnabled,mobileProtectionEnabled:J6.mobileProtectionEnabled,targetSelectors:J6.targetSelectors}),(J6.screenshotProtectionEnabled||"off"!==J6.windowFocusProtectionLevel)&&((X6=new z6(J6.overlayHtml,J6.screenshotProtectionEnabled,J6.windowFocusProtectionLevel,J6.windowFocusOverlayHtml)).start(),r9("Screenshot listener started",{keyboard:J6.screenshotProtectionEnabled,windowFocus:J6.windowFocusProtectionLevel})),J6.mobileProtectionEnabled&&J6.targetSelectors.length>0&&((e9=new Y6).start(J6.targetSelectors,i9,a9),r9("Element observer started")),t9=!0,r9("Initialization complete")}function i9(e){s9(e)}function a9(e,t){l9(e,t)}function s9(e){if(!e9)return;r9("Protecting element",e);let t=e,n={element:e,blurSwapped:!1};t.draggable=!1;let r=e=>{e.preventDefault(),r9("Drag prevented")};t.addEventListener("dragstart",r),n.dragStartHandler=r;let o=e=>{e.preventDefault(),r9("Context menu prevented")};if(t.addEventListener("contextmenu",o),n.contextMenuHandler=o,n9){r9("Applying mobile blur (isMobile=true)");let t=G6(e,J6?.mobileBlurType);Object.assign(n,t),r9("Blur overlay created",{container:n.container,blurOverlayTL:n.blurOverlayTL,blurOverlayBR:n.blurOverlayBR,containerStyles:n.container?.style.cssText,tlStyles:n.blurOverlayTL?.style.cssText,brStyles:n.blurOverlayBR?.style.cssText}),Z6(n),r9("Touch handlers attached")}else r9("Skipping mobile blur (isMobile=false)");e9.registerProtection(e,n)}function l9(e,t){let n=e;t.dragStartHandler&&n.removeEventListener("dragstart",t.dragStartHandler),n.draggable=!0,t.contextMenuHandler&&n.removeEventListener("contextmenu",t.contextMenuHandler),function(e){let{container:t,touchStartHandler:n,touchEndHandler:r,touchCancelHandler:o}=e,i=t?[t]:(()=>{let t=e.element.parentElement;return t?[t]:[]})();if(0!==i.length){for(let e of i)n&&(e.removeEventListener("touchstart",n),e.removeEventListener("mousedown",n)),r&&(e.removeEventListener("touchend",r),e.removeEventListener("mouseup",r)),o&&(e.removeEventListener("touchcancel",o),e.removeEventListener("mouseleave",o));e.touchStartHandler=void 0,e.touchEndHandler=void 0,e.touchCancelHandler=void 0}}(t),function(e){let{element:t,container:n,blurOverlayTL:r,blurOverlayBR:o}=e;r?.remove(),o?.remove(),!e.siblingMode&&n&&n.parentNode&&(n.parentNode.insertBefore(t,n),n.remove())}(t),e9?.unregisterProtection(e)}function c9(e,t={}){const{ssr:n=!0,fallback:r}=t,{getWindow:o}=function({defer:e}={}){const[,t]=(0,i.useReducer)((e=>e+1),0);return em((()=>{e&&t()}),[e]),(0,i.useContext)($k)}(),a=Array.isArray(e)?e:[e];let s=Array.isArray(r)?r:[r];s=s.filter((e=>null!=e));const[l,c]=(0,i.useState)((()=>a.map(((e,t)=>({media:e,matches:n?!!s[t]:o().matchMedia(e).matches})))));return(0,i.useEffect)((()=>{const e=o();c(a.map((t=>({media:t,matches:e.matchMedia(t).matches}))));const t=a.map((t=>e.matchMedia(t))),n=e=>{c((t=>t.slice().map((t=>t.media===e.media?{...t,matches:e.matches}:t))))};return t.forEach((e=>{"function"==typeof e.addListener?e.addListener(n):e.addEventListener("change",n)})),()=>{t.forEach((e=>{"function"==typeof e.removeListener?e.removeListener(n):e.removeEventListener("change",n)}))}}),[o]),l.map((e=>e.matches))}function u9(e,t){var n;const r=function(e){var t,n;const r=v(e)?e:{fallback:null!=e?e:"base"},o=Lr().__breakpoints.details.map((({minMaxQuery:e,breakpoint:t})=>({breakpoint:t,query:e.replace("@media screen and ","")}))),i=o.map((e=>e.breakpoint===r.fallback)),a=c9(o.map((e=>e.query)),{fallback:i,ssr:r.ssr});return null!=(n=null==(t=o[a.findIndex((e=>1==e))])?void 0:t.breakpoint)?n:r.fallback}(v(t)?t:{fallback:null!=t?t:"base"}),o=Lr();if(!r)return;const i=Array.from((null==(n=o.__breakpoints)?void 0:n.keys)||[]),a=Array.isArray(e)?Object.fromEntries(Object.entries(function(e,t=Kp){const n={};return e.forEach(((e,r)=>{const o=t[r];null!=e&&(n[o]=e)})),n}(e,i)).map((([e,t])=>[e,t]))):e;return function(e,t,n=Kp){let r=Object.keys(e).indexOf(t);if(-1!==r)return e[t];let o=n.indexOf(t);for(;o>=0;){const t=n[o];if(e.hasOwnProperty(t)){r=o;break}o-=1}if(-1!==r)return e[n[r]]}(a,r,i)}var d9={SMALL:3,MEDIUM:20,LARGE:40},p9={HMASON:{SMALL:320,MEDIUM:480,LARGE:640},VMASON:{SMALL:190,MEDIUM:380,LARGE:570}},f9={SMALL:"s",MEDIUM:"m",LARGE:"l"},h9=kC(kC(kC({},f9.SMALL,d9.SMALL),f9.MEDIUM,d9.MEDIUM),f9.LARGE,d9.LARGE),m9={HMASON:kC(kC(kC({},f9.SMALL,p9.HMASON.SMALL),f9.MEDIUM,p9.HMASON.MEDIUM),f9.LARGE,p9.HMASON.LARGE),VMASON:kC(kC(kC({},f9.SMALL,p9.VMASON.SMALL),f9.MEDIUM,p9.VMASON.MEDIUM),f9.LARGE,p9.VMASON.LARGE)},g9={DEVICE:"device",GOOGLE_PHOTOS:"googlePhotos"};const v9={CLIENT_GUTTER_SIZES:d9,CLIENT_THUMBNAIL_GUTTER_MAP:h9,CLIENT_THUMBNAIL_SIZES:p9,CLIENT_THUMBNAIL_SIZE_MAP:m9,CLIENT_THUMBNAIL_SIZE_NAMES:f9,DOWNLOAD_DESTINATION:g9,DOWNLOAD_TYPE:{ALL:"all",ALBUM:"album",PHOTO:"photo",VIDEO:"video"},PACKAGE_SMALL_SCREEN_STATES:{PHOTO_VIEW:"package-small-screen-states-photo-view",PACKAGE_VIEW:"package-small-screen-states-package-view"}};const y9=function(e){var t=e.commonDimension,n=e.containerWidth,r=e.layoutType,o=e.padding,i=e.photos,a=new Map;if("hmason"===r){var s,l=[];i.forEach((function(e){(!s||s.width>=n)&&(l[l.length]=s={width:0,photoDimensionsArray:[]});var r={top:0,left:0,width:t*(e.width/e.height),height:t};s.width+=r.width,s.photoDimensionsArray.push(r),a.set(e.id,r)}));var c=0;l.forEach((function(e){var r=e.width-n+(e.photoDimensionsArray.length-1)*o,i=Math.min(1,1-r/e.width),a=t*i,s=0;e.photoDimensionsArray.forEach((function(e){e.top=c,e.left=s,e.height=a,e.width=e.width*i,s+=e.width+o})),c+=a+o}))}if("vmason"===r){for(var u=t+o,d=Math.ceil(n/u),p=Math.max(2,d),f=n-o*(p-1),h=Math.round(f/p),m=[],g=0,v=0;v<p;v++)m.push({height:0,left:g}),g+=h+o;i.forEach((function(e){var t=m.reduce((function(e,t,n){return m[e].height<=t.height?e:n}),0),n=m[t],r={top:n.height,left:n.left,width:h,height:Math.round(h/e.width*e.height)};a.set(e.id,r),n.height+=r.height+o}))}return a};var b9=yr((function(e,t){const{htmlWidth:n,htmlHeight:r,alt:o,...i}=e;return(0,br.jsx)("img",{width:n,height:r,ref:t,alt:o,...i})}));b9.displayName="NativeImage";function _9(e,t=[]){const n=Object.assign({},e);for(const e of t)e in n&&delete n[e];return n}var A9=yr((function(e,t){const{fallbackSrc:n,fallback:r,src:o,srcSet:a,align:s,fit:l,loading:c,ignoreFallback:u,crossOrigin:d,fallbackStrategy:p="beforeLoadOrError",referrerPolicy:f,...h}=e,m=null!=c||u||!(void 0!==n||void 0!==r),g=function(e){const{loading:t,src:n,srcSet:r,onLoad:o,onError:a,crossOrigin:s,sizes:l,ignoreFallback:c}=e,[u,d]=(0,i.useState)("pending");(0,i.useEffect)((()=>{d(n?"loading":"pending")}),[n]);const p=(0,i.useRef)(),f=(0,i.useCallback)((()=>{if(!n)return;h();const e=new Image;e.src=n,s&&(e.crossOrigin=s),r&&(e.srcset=r),l&&(e.sizes=l),t&&(e.loading=t),e.onload=e=>{h(),d("loaded"),null==o||o(e)},e.onerror=e=>{h(),d("failed"),null==a||a(e)},p.current=e}),[n,s,r,l,o,a,t]),h=()=>{p.current&&(p.current.onload=null,p.current.onerror=null,p.current=null)};return em((()=>{if(!c)return"loading"===u&&f(),()=>{h()}}),[u,f,c]),c?"loaded":u}({...e,crossOrigin:d,ignoreFallback:m}),v=((e,t)=>"loaded"!==e&&"beforeLoadOrError"===t||"failed"===e&&"onError"===t)(g,p),y={ref:t,objectFit:l,objectPosition:s,...m?h:_9(h,["onError","onLoad"])};return v?r||(0,br.jsx)(vr.img,{as:b9,className:"chakra-image__placeholder",src:n,...y}):(0,br.jsx)(vr.img,{as:b9,src:o,srcSet:a,crossOrigin:d,loading:c,referrerPolicy:f,className:"chakra-image",...y})}));A9.displayName="Image";var E9=fr(wr,{shouldForwardProp:function(e){return!["squareCount","squareDimension","squareGutter"].includes(e)}})((function(e){var t=e.squareCount;return"\n        align-items: center;\n        justify-content: space-between;\n        margin: 40px auto;\n        max-width: "+(t*e.squareDimension+(t-1)*e.squareGutter)+"px;\n    "})),w9=fr(_r,{shouldForwardProp:function(e){return!["squareDimension"].includes(e)}})((function(e){var t=e.className,n=e.squareDimension,r=e.theme;return"\n        @keyframes fadeIn {\n            0% {\n                opacity: 0;\n            }\n\n            100% {\n                opacity: 1;\n            }\n        }\n\n        animation: fadeIn 0.8s ease-in-out infinite;\n        "+(!t&&"background: "+r.colors.gray[400])+";\n        height: "+n+"px;\n        width: "+n+"px;\n\n        &:nth-of-type(2) {\n            animation-delay: 0.1s;\n        }\n\n        &:nth-of-type(3) {\n            animation-delay: 0.2s;\n        }\n\n        &:nth-of-type(4) {\n            animation-delay: 0.3s;\n        }\n\n        &:nth-of-type(5) {\n            animation-delay: 0.4s;\n        }\n    "}));const x9=function(e){var t=e.squareClassName;return i.createElement(E9,{className:"loading-indicator","data-testid":"loading-indicator",squareCount:5,squareDimension:10,squareGutter:12},Array.from(Array(5).keys()).map((function(e,n){return i.createElement(w9,{className:t,key:n,squareDimension:10})})))};var k9=function(e){return e.preventDefault()},C9=function(e){var t=e.PhotoOverlayComponent,n=e.isInView,r=e.onClick,o=e.photo,a=e.photoDimensions,s=e.getPhotoOverlayProps,l=(0,i.useCallback)((function(){r&&r(o)}),[r,o]);return i.createElement(_r,{id:"photoId-"+o.id,"data-testid":"photo-grid-item",cursor:"pointer",onClick:l,outline:"1px solid var(--chakra-colors-gray-100)",outlineOffset:"-1px",position:"absolute",top:a.top+"px",left:a.left+"px",width:a.width+"px",height:a.height+"px",visibility:n?"visible":"hidden",sx:{contentVisibility:n?"visible":"hidden"}},n&&i.createElement(i.Fragment,null,o.url?i.createElement(A9,{alt:o.url,"data-testid":"image",src:o.url,onContextMenu:k9,filter:o.filterBlackAndWhite?"grayscale(1)":void 0,position:"absolute",width:"100%",height:"100%"}):i.createElement(wr,{"data-testid":"image-loading",background:"gray.200",sx:{aspectRatio:1}},i.createElement(x9,null)),t&&s&&i.createElement(t,s(o))))};const S9=(0,i.memo)(C9);var M9=["hmason","vmason"];const T9=function(e){var t,n,r,o,a,s=e.PhotoOverlayComponent,l=e.containerElement,c=e.getPhotoOverlayProps,u=e.layoutType,d=e.onPhotoClick,p=e.photos,f=e.scrollToTargetPhoto,h=e.thumbnailGutterWidth,g=e.thumbnailSize;if(!M9.includes(u))throw new Error("PhotoGrid received unexpected layout type: "+u);var v=null!==(t=u9({lg:v9.CLIENT_THUMBNAIL_SIZE_MAP.HMASON[g]}))&&void 0!==t?t:v9.CLIENT_THUMBNAIL_SIZES.HMASON.SMALL,y=null!==(n=u9({lg:v9.CLIENT_THUMBNAIL_SIZE_MAP.VMASON[g]}))&&void 0!==n?n:v9.CLIENT_THUMBNAIL_SIZES.VMASON.MEDIUM,b=null!==(r=u9({lg:v9.CLIENT_THUMBNAIL_GUTTER_MAP[h]}))&&void 0!==r?r:v9.CLIENT_GUTTER_SIZES.SMALL,_=(0,i.useRef)(null),A=m((0,i.useState)(0),2),E=A[0],w=A[1],x=m((0,i.useState)(0),2),k=x[0],C=x[1],S=m((0,i.useState)(),2),M=S[0],T=S[1],O=null!==(o=u9({lg:-.5*k}))&&void 0!==o?o:-k,D=null!==(a=u9({lg:1.5*k}))&&void 0!==a?a:2*k,L=(0,i.useMemo)((function(){return p.reduce((function(e,t){var n=null==M?void 0:M.get(t.id);if(!n)return e;var r=n.top+n.height;return Math.max(r,e)}),0)}),[p,M]);return(0,i.useEffect)((function(){var e=new dS((function(){if(_.current){var e=y9({commonDimension:"hmason"===u?v:y,containerWidth:_.current.offsetWidth,layoutType:u,padding:b,photos:p});T(e)}}));return _.current&&e.observe(_.current),function(){e.disconnect()}}),[v,y,u,b,p]),(0,i.useEffect)((function(){M&&f&&f()}),[M,f]),(0,i.useEffect)((function(){var e=function(){C(window.innerHeight)},t=function(){if(_.current){var e=_.current.getBoundingClientRect().top;w(e)}};return e(),t(),window.addEventListener("resize",e),window.addEventListener("scroll",t),l&&l.addEventListener("scroll",t),function(){window.removeEventListener("resize",e),window.removeEventListener("scroll",t),l&&l.removeEventListener("scroll",t)}}),[l]),i.createElement(_r,{"data-testid":"photo-grid",height:L+"px"},i.createElement(_r,{ref:_,position:"relative"},p.map((function(e){var t=null==M?void 0:M.get(e.id);if(!t)return null;var n=E+t.top,r=n+t.height,o=n<O,a=r>D,l=!o&&!(n>D)||!(r<O)&&!a||o&&a;return i.createElement(S9,{key:e.id,PhotoOverlayComponent:s,isInView:l,onClick:d,photo:e,photoDimensions:t,getPhotoOverlayProps:c})}))))};var O9,D9=function(e){return e.Brandon="brandon",e.Freeland="freeland",e.Baskerville="baskerville",e.Blooming="blooming-elegant",e.BambusaPro="bambusa-pro-regular",e.SBOne="scandiebox-one",e.Roboto="roboto",e.Lato="lato",e.Spectral="spectral",e.Montserrat="montserrat",e.Oswald="oswald",e.Quicksand="quicksand",e.Raleway="raleway",e.Inter="inter",e.Playfair="playfair",e.PtSans="pt-sans",e.RedHatDisplay="red-hat-display",e.Merriweather="merriweather",e.Figtree="figtree",e.Palanquin="palanquin",e.Slabo27px="slabo-27px",e.Sora="sora",e.Cabin="cabin",e.CormorantGaramond="cormorant-garamond",e.Caveat="caveat",e.ShadowsIntoLight="shadows-into-light",e.ReenieBeanie="reenie-beanie",e.BilboSwashCaps="bilbo-swash-caps",e.IndieFlower="indie-flower",e.DancingScript="dancing-script",e.Urbanist="urbanist",e.BarlowSemiCondensed="barlow-semi-condensed",e.BebasNeue="bebas-neue",e.Lora="lora",e}(D9||{}),L9=(kC(kC(kC(kC(kC(kC(kC(kC(kC(kC(O9={},D9.Brandon,{primaryFontFamilies:["Brandon","Arial","Helvetica","sans-serif"],secondaryFontFamilies:["Brandon","Arial","Helvetica","sans-serif"]}),D9.Freeland,{primaryFontFamilies:["ProximaNova","ProximaNova-Regular","Arial","sans-serif"],secondaryFontFamilies:["Freeland","Arial Bold","sans-serif"]}),D9.Baskerville,{primaryFontFamilies:["Baskerville","Baskerville Old Face","Goudy Old Style","Garamond","Times New Roman","Serif"],secondaryFontFamilies:["open-sans","Tahoma","sans-serif"]}),D9.Blooming,{primaryFontFamilies:["open-sans","Tahoma","sans-serif"],secondaryFontFamilies:["blooming-elegant","Times New Roman","Serif"]}),D9.BambusaPro,{primaryFontFamilies:["open-sans","Tahoma","sans-serif"],secondaryFontFamilies:["bambusa-pro-regular","Times New Roman","Serif"]}),D9.SBOne,{primaryFontFamilies:["open-sans","Arial Bold","sans-serif"],secondaryFontFamilies:["scandiebox-one","Times New Roman","serif"]}),D9.Roboto,{primaryFontFamilies:['"Roboto"',"Arial","sans-serif"],secondaryFontFamilies:['"Roboto"',"Arial","sans-serif"]}),D9.Lato,{primaryFontFamilies:['"Lato"',"Arial","sans-serif"],secondaryFontFamilies:['"Lato"',"Arial","sans-serif"]}),D9.Spectral,{primaryFontFamilies:['"Spectral"',"Georgia","serif"],secondaryFontFamilies:['"Spectral"',"Georgia","serif"]}),D9.Montserrat,{primaryFontFamilies:['"Montserrat"',"Arial","sans-serif"],secondaryFontFamilies:['"Montserrat"',"Arial","sans-serif"]}),kC(kC(kC(kC(kC(kC(kC(kC(kC(kC(O9,D9.Oswald,{primaryFontFamilies:['"Oswald"',"Arial","sans-serif"],secondaryFontFamilies:['"Oswald"',"Arial","sans-serif"]}),D9.Quicksand,{primaryFontFamilies:['"Quicksand"',"Arial","sans-serif"],secondaryFontFamilies:['"Quicksand"',"Arial","sans-serif"]}),D9.Raleway,{primaryFontFamilies:['"Raleway"',"Arial","sans-serif"],secondaryFontFamilies:['"Raleway"',"Arial","sans-serif"]}),D9.Inter,{primaryFontFamilies:['"Inter"',"Arial","sans-serif"],secondaryFontFamilies:['"Inter"',"Arial","sans-serif"]}),D9.Playfair,{primaryFontFamilies:['"Playfair Display"',"Georgia","serif"],secondaryFontFamilies:['"Playfair Display"',"Georgia","serif"]}),D9.PtSans,{primaryFontFamilies:['"PT Sans"',"Arial","sans-serif"],secondaryFontFamilies:['"PT Sans"',"Arial","sans-serif"]}),D9.RedHatDisplay,{primaryFontFamilies:['"Red Hat Display"',"Arial","sans-serif"],secondaryFontFamilies:['"Red Hat Display"',"Arial","sans-serif"]}),D9.Merriweather,{primaryFontFamilies:['"Merriweather"',"Georgia","serif"],secondaryFontFamilies:['"Merriweather"',"Georgia","serif"]}),D9.Figtree,{primaryFontFamilies:['"Figtree"',"Arial","sans-serif"],secondaryFontFamilies:['"Figtree"',"Arial","sans-serif"]}),D9.Palanquin,{primaryFontFamilies:['"Palanquin"',"Arial","sans-serif"],secondaryFontFamilies:['"Palanquin"',"Arial","sans-serif"]}),kC(kC(kC(kC(kC(kC(kC(kC(kC(kC(O9,D9.Slabo27px,{primaryFontFamilies:['"Slabo 27px"',"Georgia","serif"],secondaryFontFamilies:['"Slabo 27px"',"Georgia","serif"]}),D9.Sora,{primaryFontFamilies:['"Sora"',"Arial","sans-serif"],secondaryFontFamilies:['"Sora"',"Arial","sans-serif"]}),D9.Cabin,{primaryFontFamilies:['"Cabin"',"Arial","sans-serif"],secondaryFontFamilies:['"Cabin"',"Arial","sans-serif"]}),D9.CormorantGaramond,{primaryFontFamilies:['"Cormorant Garamond"',"Georgia","serif"],secondaryFontFamilies:['"Cormorant Garamond"',"Georgia","serif"]}),D9.Caveat,{primaryFontFamilies:['"Caveat"',"cursive"],secondaryFontFamilies:['"Caveat"',"cursive"]}),D9.ShadowsIntoLight,{primaryFontFamilies:['"Shadows Into Light"',"cursive"],secondaryFontFamilies:['"Shadows Into Light"',"cursive"]}),D9.ReenieBeanie,{primaryFontFamilies:['"Reenie Beanie"',"cursive"],secondaryFontFamilies:['"Reenie Beanie"',"cursive"]}),D9.BilboSwashCaps,{primaryFontFamilies:['"Bilbo Swash Caps"',"cursive"],secondaryFontFamilies:['"Bilbo Swash Caps"',"cursive"]}),D9.IndieFlower,{primaryFontFamilies:['"Indie Flower"',"cursive"],secondaryFontFamilies:['"Indie Flower"',"cursive"]}),D9.DancingScript,{primaryFontFamilies:['"Dancing Script"',"cursive"],secondaryFontFamilies:['"Dancing Script"',"cursive"]}),kC(kC(kC(kC(O9,D9.Urbanist,{primaryFontFamilies:['"Urbanist"',"Arial","sans-serif"],secondaryFontFamilies:['"Urbanist"',"Arial","sans-serif"]}),D9.BarlowSemiCondensed,{primaryFontFamilies:['"Barlow Semi Condensed"',"Arial","sans-serif"],secondaryFontFamilies:['"Barlow Semi Condensed"',"Arial","sans-serif"]}),D9.BebasNeue,{primaryFontFamilies:['"Bebas Neue"',"Arial","sans-serif"],secondaryFontFamilies:['"Bebas Neue"',"Arial","sans-serif"]}),D9.Lora,{primaryFontFamilies:['"Lora"',"Georgia","serif"],secondaryFontFamilies:['"Lora"',"Georgia","serif"]}));function P9(e){return e.join(", ")}var I9=function(e){return["bambusa-pro-regular","blooming-elegant","freeland","scandiebox-one","caveat","shadows-into-light","reenie-beanie","bilbo-swash-caps","indie-flower","dancing-script","playfair"].includes(e)};function B9(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=m(Array.from(e),7),r=n[1],o=n[2],i=n[3],a=n[4],s=n[5],l=n[6],c=parseInt(""+s+l,16),u=parseInt(""+i+a,16);return t>1?t=1:t<0&&(t=0),"rgba("+parseInt(""+r+o,16)+","+u+","+c+","+t+")"}var R9="open-sans, sans-serif";const N9=function(e){var t,n=e.colorScheme,r=e.fontSet,o=e.primaryColor,i=e.secondaryColor,a={primaryFontFamily:P9((t=L9[r]).primaryFontFamilies),secondaryFontFamily:P9(t.secondaryFontFamilies)},s=a.primaryFontFamily,l=a.secondaryFontFamily,c=!I9(r),u=c?s:l,d="brandon"===r?"bold":"normal",p=c?"wider":"initial",f=c?"uppercase":"initial",h="bambusa-pro-regular"===r,m="blooming-elegant"===r,g="light"===n,v="drop-shadow(0px 0px 12px rgba(0,0,0,"+(g?"0.2":"0.8")+"))",y={white:"#FFFFFF",whiteAlpha:{500:"rgba(255, 255, 255, 0.4)",700:"rgba(255, 255, 255, 0.8)"},blackAlpha:{500:"rgba(0, 0, 0, 0.4)",700:"rgba(0, 0, 0, 0.8)"},gray:{25:g?"#F7F9FA":"#1A1A1A",50:g?"rgba(100,100,100,0.1)":"rgba(155,155,155,0.2)",100:g?"rgba(0,0,0,0.1)":"rgba(255,255,255,0.2)",200:"#E0E3E5",300:"#ABB0B2",400:"#6E7173",500:"#494B4C",600:g?"#303233":"#ABB0B2",700:g?"#191717":"#121212"},red:{200:"#FFDEDB",300:"#FFB9B2",400:"#FF7D73",600:"#8C1207",700:"#520700"},neutral:{100:"#F6F8F8",200:"#EDF1F3",300:"#BCC8CD",400:"#8298A1",500:"#607780",600:"#344146",700:"#141617"},background:g?"var(--chakra-colors-white)":"var(--chakra-colors-gray-700)",paper:g?"var(--chakra-colors-white)":"var(--chakra-colors-gray-25)",paperBackground:g?"var(--chakra-colors-gray-25)":"var(--chakra-colors-gray-700)",boxShadow:g?"rgba(0, 0, 0, 0.05)":"rgba(255, 255, 255, 0.04)",modalBackground:g?"white":"var(--chakra-colors-gray-600)",text:g?"var(--chakra-colors-gray-500)":"var(--chakra-colors-white)",darkText:g?"var(--chakra-colors-gray-700)":"var(--chakra-colors-white)",brand:{primary:"#"+o,primaryOverlay:"#"+o+"99",primaryMedium:"#"+o+"20",primaryLight:"#"+o+"10",secondary:"#"+i}};return{colors:y,components:{Alert:{baseStyle:{container:{boxSizing:"border-box",fontFamily:R9},title:{fontWeight:"normal"}}},Badge:{baseStyle:{borderRadius:"full",color:"text",fontFamily:R9,fontSize:"12px",fontWeight:600,padding:"3px 12px",textTransform:"uppercase"}},Button:{baseStyle:{borderRadius:"full",borderStyle:"solid",borderWidth:"1px",cursor:"pointer",fontFamily:R9,fontWeight:"normal",_focus:{boxShadow:"none"},_disabled:{pointerEvents:"none"}},sizes:{md:{fontSize:"md",height:"48px",letterSpacing:"0.5px",lineHeight:"base",px:"20px",py:"12px"}},variants:{primary:{backgroundColor:"brand.primary",borderColor:"brand.primary",color:g?"white":y.gray[700],_active:{backgroundColor:"brand.primary"},_after:{backgroundColor:"transparent",borderRadius:"full",content:'""',height:"full",position:"absolute",transitionDuration:"normal",transitionProperty:"common",width:"full"},_disabled:{opacity:.5},_focus:{color:g?"white":y.gray[700]},_focusVisible:{boxShadow:"var(--chakra-shadows-outline)"},_hover:{backgroundColor:"brand.primary",color:g?"white":y.gray[700],position:"relative",_after:{backgroundColor:y.gray[100]},_disabled:{background:""}}},"secondary dark":{backgroundColor:"transparent",borderColor:y.gray[700],color:y.gray[700],_active:{backgroundColor:y.gray[700]},_disabled:{opacity:.5},_focus:{color:"white",backgroundColor:y.gray[700],borderColor:y.gray[700]},_focusVisible:{boxShadow:"var(--chakra-shadows-outline)"},_hover:{backgroundColor:y.gray[700],borderColor:y.gray[700],color:"white"}},"secondary light":{backgroundColor:"transparent",borderColor:"white",color:"white",_active:{backgroundColor:"white"},_disabled:{opacity:.5},_focus:{color:y.gray[700],backgroundColor:"white",borderColor:"white"},_focusVisible:{boxShadow:"var(--chakra-shadows-outline)"},_hover:{backgroundColor:"white",borderColor:"white",color:y.gray[700]}},ghost:{backgroundColor:"transparent",border:"none",color:"text",fontSize:"sm",lineHeight:"base",paddingX:"16px",_disabled:{opacity:.5},_active:{backgroundColor:"transparent"},_focus:{backgroundColor:"transparent",color:"text"},_focusVisible:{boxShadow:"outline",color:"brand.primary"},_hover:{backgroundColor:"transparent",color:"brand.primary"}},"ghost primary":{backgroundColor:"transparent",border:"none",color:"brand.primary",fontSize:"sm",lineHeight:"base",paddingX:"16px",_disabled:{opacity:.5},_active:{backgroundColor:"transparent"},_focus:{backgroundColor:"transparent",color:"brand.primary"},_focusVisible:{boxShadow:"outline",color:"brand.primary"},_hover:{backgroundColor:"transparent",color:"brand.primary"}},googlePhotos:{color:y.gray[700],border:g?"1px solid gray.700":"none",backgroundColor:"white",_focus:{color:y.gray[700]},_focusVisible:{boxShadow:"var(--chakra-shadows-outline)"},_hover:{backgroundColor:"white",color:y.gray[700]}},"outline primary":{backgroundColor:"transparent",borderColor:"brand.primary",color:"brand.primary",lineHeight:"base",paddingX:"16px",_disabled:{opacity:.5},_active:{backgroundColor:"transparent"},_focus:{backgroundColor:"transparent",color:"brand.primary"},_focusVisible:{boxShadow:"outline",color:"brand.primary"},_hover:{backgroundColor:"brand.primary",color:g?"white":y.gray[700],position:"relative",_after:{backgroundColor:"gray.100"},_disabled:{background:""}}},text:{color:"brand.primary",padding:0,fontWeight:"semibold",fontSize:"14px",backgroundColor:"transparent",border:"none",cursor:"pointer",verticalAlign:"baseline",textDecoration:"underline",_hover:{backgroundColor:"transparent",color:"brand.primary"}}}},Checkbox:{baseStyle:{control:{borderColor:"gray.300",borderWidth:"1px",_checked:{background:"transparent",borderColor:"gray.300",_hover:{background:"transparent",borderColor:"gray.300"}}},icon:{color:"brand.primary"},label:{color:"text",fontFamily:R9,fontWeight:"normal"}},sizes:{xl:{control:{boxSize:26}}},variants:{round:{control:{borderRadius:"100%",color:g?"white":y.gray[700],borderColor:g?"white":y.gray[700],background:"gray.100"," svg":{width:"12px",height:"12px"},_checked:{color:g?"white":y.gray[700],borderColor:g?"white":y.gray[700],background:"brand.primary",_hover:{borderColor:g?"white":y.gray[700],background:"brand.primary"}}}}}},DatePicker:{baseStyle:{fontFamily:"open-sans, sans-serif",backgroundColor:"var(--chakra-colors-brand-primary)",headerBackgroundColor:g?"white":"transparent",calendarBackgroundColor:g?"white":"transparent",popperBackgroundColor:g?"white":"transparent",color:g?"#141617":"white",dateColor:g?"white":"black",disabledColor:g?"#cccccc":"grey",dayHeaderColor:g?"#141617":"white",chevronColor:g?"#141617":"white",borderColor:"gray",borderRadius:"4px",boxShadow:"none",padding:"0",daySize:"42px",dayFontSize:"inherit",hoverBackgroundColor:"none"}},Divider:{baseStyle:{borderWidth:"1px",borderStyle:"solid",borderColor:g?"gray.200":"gray.500"},variants:{dark:{borderColor:y.gray[700]},light:{borderColor:"white"},primary:{borderColor:"brand.primary"}}},Drawer:{baseStyle:{dialog:{backgroundColor:"modalBackground",borderRadius:"20px 20px 0 0",boxShadow:"none",filter:v},closeButton:{marginTop:"-48px",borderRadius:"xl",right:"16px",backgroundColor:g?"whiteAlpha.900":y.gray[600],color:"text",_active:{backgroundColor:g?"whiteAlpha.900":y.gray[600],color:"text"},_hover:{color:"text",boxShadow:"none"},_focus:{color:"text",boxShadow:"none"},_focusVisible:{boxShadow:"outline"}}}},Form:{baseStyle:{container:{fontFamily:R9,paddingBottom:6},requiredIndicator:{color:"inherit",margin:0}}},FormError:{baseStyle:{text:{color:g?"var(--chakra-colors-red-600)":"var(--chakra-colors-red-400)",fontFamily:R9,lineHeight:"shorter",marginTop:"2px"}}},FormLabel:{baseStyle:{color:"text",fontFamily:R9,marginBottom:"2px",marginRight:"6px",fontWeight:"normal"},sizes:{md:{fontSize:"md",lineHeight:"base"}},defaultProps:{size:"md"}},Heading:{sizes:{"3xl":{fontFamily:u,fontSize:c?"3xl":m?"5xl":"4xl",fontWeight:d,letterSpacing:p,lineHeight:c||m?"shorter":"base",textTransform:f},"2xl":{fontFamily:u,fontSize:c?"2xl":m?"4xl":"3xl",fontWeight:d,letterSpacing:p,lineHeight:c||m?"shorter":"base",textTransform:f},xl:{fontFamily:u,fontSize:c?"lg":m?"3xl":"2xl",fontWeight:d,letterSpacing:p,lineHeight:c||m?"shorter":"base",textTransform:f},lg:{fontFamily:R9,fontSize:"lg",fontWeight:"semibold",lineHeight:"short"},md:{fontFamily:R9,fontSize:"md",fontWeight:"semibold",lineHeight:"base"},sm:{fontFamily:u,fontSize:c||h?"16px":m?"xl":"lg",fontWeight:d,letterSpacing:p,lineHeight:c||m?"short":"base",textTransform:f},xs:{fontFamily:R9,fontSize:"sm",letterSpacing:"wider",lineHeight:"short",textTransform:"uppercase"}},variants:{dark:{color:y.gray[700]},light:{color:"white"},primary:{color:"brand.primary"}}},Input:{baseStyle:{field:{boxSizing:"border-box",color:"text",fontFamily:R9,_placeholder:{color:"neutral.300"}},element:{fontFamily:R9,color:"gray.400"}},variants:{outline:{field:{borderColor:"gray.300",transition:"outline .1s ease-in",outlineOffset:"-1px",_focus:{outlineColor:"brand.primary",outlineWidth:"2px",boxShadow:"none"},_hover:{outlineColor:"brand.primary",outlineWidth:"2px"},_invalid:{outlineColor:g?"red.600":"red.400",outlineWidth:"2px",boxShadow:"none"}}}}},Link:{baseStyle:{color:"brand.primary",_active:{color:"brand.primary"},_focus:{color:"brand.primary"},_hover:{color:"brand.primary"},_visited:{color:"brand.primary"}},variants:{googlePhotos:{_focus:{boxShadow:"none"},_focusVisible:{boxShadow:"var(--chakra-shadows-outline)"}}}},List:{baseStyle:{item:{fontFamily:R9}}},Modal:{baseStyle:{body:{bg:"background",borderRadius:{base:"none",lg:"xl"},fontFamily:R9,pb:{base:"24px",lg:"40px"},pt:"40px",px:{base:"26px",lg:"56px"}},closeButton:{color:"text",borderRadius:"full",cursor:"pointer",_active:{backgroundColor:g?"blackAlpha.200":"whiteAlpha.200"},_focus:{color:"text",boxShadow:"none"},_focusVisible:{boxShadow:"outline"},_hover:{color:"text",backgroundColor:g?"gray.100":"gray.600"}},dialog:{bg:"background",borderRadius:{base:"none",lg:"xl"},my:{base:0,lg:"60px"}},header:{fontFamily:R9},overlay:{bg:g?"blackAlpha.600":"whiteAlpha.600"}},sizes:{md:{content:{maxHeight:"calc(100vh - 80px)"},dialog:{height:{base:"full",lg:"auto"},maxWidth:{base:"full",lg:"xl"}}}}},Popover:{baseStyle:{body:{padding:"20px 40px 40px 40px"},content:{backgroundColor:g?"background":"gray.600",border:"none",borderRadius:"xl",filter:v,width:"380px",_focus:{boxShadow:"none"},_focusVisible:{boxShadow:"outline"}}},variants:{small:{body:{padding:"10px 0"},content:{width:"initial"}}}},Radio:{baseStyle:{control:{borderColor:"gray.300",borderWidth:"1px",_checked:{background:"transparent",borderColor:"gray.300",_hover:{background:"transparent",borderColor:"gray.300"},_before:{background:"brand.primary",width:"100%",height:"100%",transform:"scale(0.67)"}}},label:{color:"text",fontFamily:R9}}},Select:{baseStyle:{field:{boxSizing:"border-box",color:"text",fontFamily:R9}},variants:{outline:{field:{borderColor:"gray.300",paddingX:"16px",_focus:{borderColor:"brand.primary",borderWidth:"2px",boxShadow:"none",paddingX:"15px"},_hover:{borderColor:"brand.primary",borderWidth:"2px",paddingX:"15px"},_invalid:{borderColor:g?"red.600":"red.400",borderWidth:"2px",boxShadow:"none",paddingX:"15px"}}}}},Table:{baseStyle:{th:{fontFamily:R9,fontWeight:"600",letterSpacing:"normal",textTransform:"none"},td:{fontFamily:R9,fontWeight:"normal",verticalAlign:"top"}},sizes:{md:{tr:{position:"relative",left:"-12px"},td:{paddingInlineEnd:"12px",paddingInlineStart:"12px"},th:{fontSize:"16px",paddingInlineEnd:"12px",paddingInlineStart:"12px"}}}},Text:{baseStyle:{color:"text",lineHeight:"base",margin:0,fontFamily:R9},variants:{error:{color:g?"red.600":"red.400"}}},Textarea:{baseStyle:{boxSizing:"border-box",color:"text",fontFamily:R9,resize:"vertical",_placeholder:{color:"neutral.300"}},variants:{outline:{borderColor:"gray.300",transition:"outline .1s ease-in",outlineOffset:"-1px",_focus:{outlineColor:"brand.primary",outlineWidth:"2px",boxShadow:"none"},_hover:{outlineColor:"brand.primary",outlineWidth:"2px"},_invalid:{outlineColor:g?"red.600":"red.400",outlineWidth:"2px",boxShadow:"none"}}}},Tooltip:{baseStyle:kC(kC(kC(kC(kC(kC(kC(kC(kC(kC({background:g?"background":"gray.600"},ke("popper-arrow-bg").variable,g?"var(--chakra-colors-white)":"var(--chakra-colors-gray-600)"),"borderRadius","lg"),"boxShadow","none"),"color","text"),"filter",v),"fontFamily",R9),"fontSize","14px"),"lineHeight","tall"),"padding","16px"),"zIndex",1e4)}},filters:{dropShadow:v},fontColor:{default:"text"},fonts:{body:"",heading:"",mono:""},fontSizes:{xs:"12px",sm:"14px",md:"16px",lg:"20px",xl:"24px","2xl":"28px","3xl":"40px","4xl":"44px","5xl":"52px"},isLightColorScheme:g,letterSpacings:{wide:"1px",wider:"2px"},radii:{md:"3px",lg:"4px",xl:"20px"},shadows:{md:"0 0 4px 2px var(--chakra-colors-gray-100)"},sizes:{xs:"320px",sm:"400px",xl:"600px"},utility:{convertHexToRgba:B9}}};const F9=function(e){var t=e.bannerText,n=e.bannerUrl;return i.createElement(_r,{background:"brand.secondary",padding:"10px 5px",textAlign:"center",width:"100%"},i.createElement(qr,{fontSize:"sm",fontWeight:"normal",color:"background",textDecoration:n?"underline":"none"},t))};o.p;o.p;o.p;var j9,Y9,$9,H9,U9=["title","titleId"];function z9(){return z9=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},z9.apply(null,arguments)}var W9=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,U9);return i.createElement("svg",z9({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,j9||(j9=i.createElement("rect",{x:5,y:5,width:6,height:7,stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),Y9||(Y9=i.createElement("rect",{x:14,y:11,width:5,height:8,stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),$9||($9=i.createElement("rect",{x:14,y:5,width:5,height:3,stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),H9||(H9=i.createElement("rect",{x:5,y:15,width:6,height:4,stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})))},V9=(0,i.forwardRef)(W9);o.p;var G9,Q9,q9,K9,Z9=["title","titleId"];function J9(){return J9=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},J9.apply(null,arguments)}var X9=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Z9);return i.createElement("svg",J9({width:24,height:24,viewBox:"0 0 21 21",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,G9||(G9=i.createElement("path",{d:"M8.5 21C9.32843 21 10 20.3284 10 19.5C10 18.6716 9.32843 18 8.5 18C7.67157 18 7 18.6716 7 19.5C7 20.3284 7.67157 21 8.5 21Z",fill:"currentColor"})),Q9||(Q9=i.createElement("path",{d:"M16.5 21C17.3284 21 18 20.3284 18 19.5C18 18.6716 17.3284 18 16.5 18C15.6716 18 15 18.6716 15 19.5C15 20.3284 15.6716 21 16.5 21Z",fill:"currentColor"})),q9||(q9=i.createElement("path",{d:"M1 1H4.45455L6.76909 13.497C6.84807 13.9267 7.06438 14.3127 7.38015 14.5874C7.69593 14.8621 8.09106 15.0081 8.49636 14.9997H16.8909C17.2962 15.0081 17.6913 14.8621 18.0071 14.5874C18.3229 14.3127 18.5392 13.9267 18.6182 13.497L20 5.66655H5.31818",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),K9||(K9=i.createElement("path",{d:"M20 6H6V11L7 14.5H18.5L20 6Z",fill:"currentColor"})))},e8=(0,i.forwardRef)(X9);o.p;o.p;var t8,n8,r8,o8=["title","titleId"];function i8(){return i8=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i8.apply(null,arguments)}var a8=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,o8);return i.createElement("svg",i8({width:24,height:24,viewBox:"0 0 21 21",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,t8||(t8=i.createElement("path",{d:"M8.5 21C9.32843 21 10 20.3284 10 19.5C10 18.6716 9.32843 18 8.5 18C7.67157 18 7 18.6716 7 19.5C7 20.3284 7.67157 21 8.5 21Z",fill:"currentColor"})),n8||(n8=i.createElement("path",{d:"M16.5 21C17.3284 21 18 20.3284 18 19.5C18 18.6716 17.3284 18 16.5 18C15.6716 18 15 18.6716 15 19.5C15 20.3284 15.6716 21 16.5 21Z",fill:"currentColor"})),r8||(r8=i.createElement("path",{d:"M1 1H4.45455L6.76909 13.497C6.84807 13.9267 7.06438 14.3127 7.38015 14.5874C7.69593 14.8621 8.09106 15.0081 8.49636 14.9997H16.8909C17.2962 15.0081 17.6913 14.8621 18.0071 14.5874C18.3229 14.3127 18.5392 13.9267 18.6182 13.497L20 5.66655H5.31818",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})))},s8=(0,i.forwardRef)(a8);o.p;o.p;var l8,c8,u8,d8,p8=["title","titleId"];function f8(){return f8=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},f8.apply(null,arguments)}var h8=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,p8);return i.createElement("svg",f8({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,l8||(l8=i.createElement("rect",{x:5,y:6,width:14,height:12,stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),i.createElement("mask",{id:"mask0_1778_12601",style:{maskType:"alpha"},maskUnits:"userSpaceOnUse",x:12,y:6,width:7,height:12},c8||(c8=i.createElement("rect",{x:12,y:6,width:7,height:12,fill:"#D9D9D9"}))),u8||(u8=i.createElement("g",{mask:"url(#mask0_1778_12601)"},i.createElement("line",{x1:.75,y1:-.75,x2:22.8821,y2:-.75,transform:"matrix(-0.759257 -0.650791 0.759257 -0.650791 28.535 15.3792)",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("line",{x1:.75,y1:-.75,x2:22.8821,y2:-.75,transform:"matrix(-0.759257 -0.650791 0.759257 -0.650791 25.9727 18.0311)",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("line",{x1:.75,y1:-.75,x2:22.8821,y2:-.75,transform:"matrix(-0.759257 -0.650791 0.759257 -0.650791 22.9414 19.9331)",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("line",{x1:.75,y1:-.75,x2:22.8821,y2:-.75,transform:"matrix(-0.759257 -0.650791 0.759257 -0.650791 20.3174 21.8345)",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"}))),d8||(d8=i.createElement("rect",{x:5,y:6,width:7,height:12,stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})))},m8=(0,i.forwardRef)(h8);o.p;o.p;o.p;var g8,v8,y8,b8=["title","titleId"];function _8(){return _8=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},_8.apply(null,arguments)}var A8=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,b8);return i.createElement("svg",_8({width:20,height:20,viewBox:"0 0 20 20",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,g8||(g8=i.createElement("path",{d:"M16.666 2.5H3.33268C2.41221 2.5 1.66602 3.24619 1.66602 4.16667V12.5C1.66602 13.4205 2.41221 14.1667 3.33268 14.1667H16.666C17.5865 14.1667 18.3327 13.4205 18.3327 12.5V4.16667C18.3327 3.24619 17.5865 2.5 16.666 2.5Z",stroke:"#51646C",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),v8||(v8=i.createElement("path",{d:"M6.66602 17.5H13.3327",stroke:"#51646C",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),y8||(y8=i.createElement("path",{d:"M10 14.1667V17.5",stroke:"#51646C",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})))},E8=(0,i.forwardRef)(A8);o.p;o.p;o.p;var w8,x8,k8,C8,S8=["title","titleId"];function M8(){return M8=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},M8.apply(null,arguments)}var T8=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,S8);return i.createElement("svg",M8({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,w8||(w8=i.createElement("path",{d:"M20.5556 1H3.44444C2.09441 1 1 2.09441 1 3.44444V20.5556C1 21.9056 2.09441 23 3.44444 23H20.5556C21.9056 23 23 21.9056 23 20.5556V3.44444C23 2.09441 21.9056 1 20.5556 1Z",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),x8||(x8=i.createElement("path",{d:"M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z",fill:"currentColor",stroke:"currentColor",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"})),k8||(k8=i.createElement("path",{d:"M23 15L16.125 10L1 21",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),C8||(C8=i.createElement("path",{d:"M16 10L1.5 21L3 23H18.5L22.5 22L23 18L22.5 14.5L16 10Z",fill:"currentColor"})))},O8=(0,i.forwardRef)(T8);o.p;var D8,L8,P8,I8=["title","titleId"];function B8(){return B8=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},B8.apply(null,arguments)}var R8=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,I8);return i.createElement("svg",B8({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,D8||(D8=i.createElement("path",{d:"M20.5556 1H3.44444C2.09441 1 1 2.09441 1 3.44444V20.5556C1 21.9056 2.09441 23 3.44444 23H20.5556C21.9056 23 23 21.9056 23 20.5556V3.44444C23 2.09441 21.9056 1 20.5556 1Z",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),L8||(L8=i.createElement("path",{d:"M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z",stroke:"currentColor",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"})),P8||(P8=i.createElement("path",{d:"M23 15L16.125 10L1 21",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})))},N8=(0,i.forwardRef)(R8);o.p;var F8,j8,Y8,$8=["title","titleId"];function H8(){return H8=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},H8.apply(null,arguments)}var U8=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,$8);return i.createElement("svg",H8({width:24,height:24,viewBox:"0 0 22 22",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,F8||(F8=i.createElement("path",{d:"M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z",fill:"currentColor",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),j8||(j8=i.createElement("path",{d:"M11 15V11",stroke:"var(--chakra-colors-background)",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"})),Y8||(Y8=i.createElement("path",{d:"M11 7H11.01",stroke:"var(--chakra-colors-background)",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"})))},z8=(0,i.forwardRef)(U8);o.p;var W8,V8,G8,Q8=["title","titleId"];function q8(){return q8=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},q8.apply(null,arguments)}var K8=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Q8);return i.createElement("svg",q8({width:24,height:24,viewBox:"0 0 22 22",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,W8||(W8=i.createElement("path",{d:"M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),V8||(V8=i.createElement("path",{d:"M11 15V11",stroke:"currentColor",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"})),G8||(G8=i.createElement("path",{d:"M11 7H11.01",stroke:"currentColor",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"})))},Z8=(0,i.forwardRef)(K8);o.p;o.p;var J8,X8,e7=["title","titleId"];function t7(){return t7=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},t7.apply(null,arguments)}var n7=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,e7);return i.createElement("svg",t7({width:20,height:20,viewBox:"0 0 20 20",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,J8||(J8=i.createElement("path",{d:"M14.167 1.66669H5.83366C4.91318 1.66669 4.16699 2.41288 4.16699 3.33335V16.6667C4.16699 17.5872 4.91318 18.3334 5.83366 18.3334H14.167C15.0875 18.3334 15.8337 17.5872 15.8337 16.6667V3.33335C15.8337 2.41288 15.0875 1.66669 14.167 1.66669Z",stroke:"#51646C",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),X8||(X8=i.createElement("path",{d:"M10 15H10.0083",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"})))},r7=(0,i.forwardRef)(n7);o.p;o.p;o.p;var o7=["title","titleId"];function i7(){return i7=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i7.apply(null,arguments)}var a7=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,o7);return i.createElement("svg",i7({viewBox:"0 0 36 40",fill:"none",width:24,height:24,stroke:"currentColor",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,i.createElement("path",{d:"M 34.245 17.49 L 20.683 5.296 L 20.683 12.163 C 16.05 12.216 11.608 14.346 8.255 18.119 C 4.903 21.893 2.892 27.029 2.629 32.486 C 4.854 29.659 7.551 27.403 10.549 25.862 C 13.548 24.322 16.784 23.529 20.055 23.534 L 20.683 23.534 L 20.683 30.37 L 34.245 17.49 Z",stroke:"currentColor",strokeWidth:3,strokeLinecap:"round",strokeLinejoin:"round",style:{}}))},s7=(0,i.forwardRef)(a7);o.p;var l7,c7=["title","titleId"];function u7(){return u7=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u7.apply(null,arguments)}var d7=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,c7);return i.createElement("svg",u7({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,l7||(l7=i.createElement("path",{d:"M7.71387 5.14307L18.8567 12.0002L7.71387 18.8574V5.14307Z",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})))},p7=(0,i.forwardRef)(d7);o.p;var f7,h7=["title","titleId"];function m7(){return m7=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},m7.apply(null,arguments)}var g7=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,h7);return i.createElement("svg",m7({xmlns:"https://www.w3.org/2000/svg",viewBox:"0 0 28 28",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,f7||(f7=i.createElement("path",{d:"M17.366 5.153h3.568V-.049h-3.568c-3.494 0-6.327 2.969-6.327 6.631v3.742H6.934v5.203h4.105V27.95h4.963V15.527h3.658l1.274-5.203h-4.932V6.582c0-.789.61-1.429 1.364-1.429",stroke:"none"})))},v7=(0,i.forwardRef)(g7);o.p;o.p;var y7,b7,_7=["title","titleId"];function A7(){return A7=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},A7.apply(null,arguments)}var E7=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,_7);return i.createElement("svg",A7({viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,y7||(y7=i.createElement("g",{clipPath:"url(#clip0_1435_14533)"},i.createElement("path",{d:"M11.9989 0C5.3896 0 0.0195312 5.37007 0.0195312 11.9793C0.0195312 16.895 2.95241 21.1084 7.20714 22.9673C7.16582 22.1411 7.20714 21.1084 7.41369 20.1996C7.66156 19.2083 8.94208 13.673 8.94208 13.673C8.94208 13.673 8.5703 12.8881 8.5703 11.7728C8.5703 9.99652 9.603 8.67468 10.8835 8.67468C11.9576 8.67468 12.4946 9.50083 12.4946 10.4922C12.4946 11.5662 11.7923 13.2185 11.4205 14.7469C11.1314 16.0275 12.0401 17.0602 13.3207 17.0602C15.5927 17.0602 17.1211 14.1273 17.1211 10.6987C17.1211 8.05498 15.3448 6.11353 12.1228 6.11353C8.48766 6.11353 6.21575 8.83986 6.21575 11.8553C6.21575 12.888 6.50489 13.6316 7.00059 14.2099C7.20714 14.4578 7.24846 14.5817 7.16582 14.8708C7.1245 15.0774 6.95927 15.6144 6.91795 15.8209C6.83531 16.11 6.58749 16.234 6.29834 16.11C4.60472 15.4078 3.86116 13.5902 3.86116 11.5248C3.86116 8.13758 6.7114 4.04808 12.4119 4.04808C16.9971 4.04808 20.0126 7.35274 20.0126 10.9052C20.0126 15.6143 17.4102 19.1255 13.5686 19.1255C12.288 19.1255 11.0488 18.4233 10.6357 17.6385C10.6357 17.6385 9.93347 20.4061 9.80955 20.9431C9.56168 21.8519 9.06599 22.802 8.61162 23.5042C9.68564 23.8347 10.8423 23.9999 11.9989 23.9999C18.6081 23.9999 23.9782 18.6298 23.9782 12.0206C23.9782 5.41129 18.6082 0 11.9989 0Z"}))),b7||(b7=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1435_14533"},i.createElement("rect",{width:24,height:24,fill:"white"})))))},w7=(0,i.forwardRef)(E7);o.p;var x7,k7=["title","titleId"];function C7(){return C7=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},C7.apply(null,arguments)}var S7=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,k7);return i.createElement("svg",C7({xmlns:"https://www.w3.org/2000/svg",viewBox:"0 0 28 28",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,x7||(x7=i.createElement("path",{d:"M0 23.187s6.677 5.09 15.002 1.577c8.325-3.512 10.661-12.979 10.174-16.745 0 0 1.802-.865 2.824-3.054 0 0-2.386.814-3.213.865 0 0 1.899-.916 2.385-3.257 0 0-1.558.967-3.602 1.374 0 0-1.655-2.096-4.284-1.939-2.63.157-6.475 2.142-5.452 7.487 0 0-6.378.203-11.83-6.311 0 0-2.63 4.275 1.752 8.041 0 0-1.502-.101-2.629-.763 0 0-.195 4.733 4.674 6.006 0 0-1.51.407-2.629-.051 0 0 .827 4.122 5.452 4.224 0 0-3.228 3.207-8.624 2.546",stroke:"none"})))},M7=(0,i.forwardRef)(S7);o.p;var T7,O7,D7,L7,P7,I7,B7,R7=["title","titleId"];function N7(){return N7=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},N7.apply(null,arguments)}var F7=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,R7);return i.createElement("svg",N7({width:24,height:24,viewBox:"0 0 26 22",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,T7||(T7=i.createElement("path",{d:"M3 9V13V18C3 19.6569 4.34315 21 6 21H20C21.6569 21 23 19.6569 23 18V13V9",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),O7||(O7=i.createElement("path",{d:"M11 12H8C7.44772 12 7 12.4477 7 13V20C7 20.5523 7.44772 21 8 21H11C11.5523 21 12 20.5523 12 20V13C12 12.4477 11.5523 12 11 12Z",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),D7||(D7=i.createElement("path",{d:"M19 12H16C15.4477 12 15 12.4477 15 13V16C15 16.5523 15.4477 17 16 17H19C19.5523 17 20 16.5523 20 16V13C20 12.4477 19.5523 12 19 12Z",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),L7||(L7=i.createElement("path",{d:"M23.9659 3.15869C23.3783 1.84541 22.0738 1 20.6351 1H18L18.9759 5.36217C18.9919 5.43384 18.9993 5.5071 19.002 5.58049C19.0299 6.336 19.3422 7.05481 19.8787 7.59132C20.4413 8.15393 21.2044 8.47 22 8.47C22.7956 8.47 23.5587 8.15393 24.1213 7.59132V7.59132C25.2196 6.493 24.6721 4.73712 24.0377 3.31931L23.9659 3.15869Z",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),P7||(P7=i.createElement("path",{d:"M17.9805 1H12.9805V5.47C12.9805 6.26565 13.2965 7.02871 13.8591 7.59132C14.4218 8.15393 15.1848 8.47 15.9805 8.47C16.7761 8.47 17.5392 8.15393 18.1018 7.59132C18.6383 7.05481 18.9506 6.336 18.9784 5.58049C18.9811 5.5071 18.9724 5.43384 18.9563 5.36217L17.9805 1Z",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),I7||(I7=i.createElement("path",{d:"M4.95639 1C3.76618 1 2.68708 1.69937 2.20099 2.78579L1.96227 3.31932C1.32791 4.73713 0.78036 6.493 1.87868 7.59132V7.59132C2.44129 8.15393 3.20435 8.47 4 8.47C4.79565 8.47 5.55871 8.15393 6.12132 7.59132C6.65783 7.05481 6.97015 6.336 6.99797 5.58049C7.00067 5.5071 7.00809 5.43384 7.02412 5.36217L8 1H4.95639Z",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),B7||(B7=i.createElement("path",{d:"M13 1H8L7.02412 5.36217C7.00809 5.43384 6.99933 5.5071 7.00203 5.58049C7.02985 6.336 7.34216 7.05481 7.87868 7.59132C8.44129 8.15393 9.20435 8.47 10 8.47C10.7956 8.47 11.5587 8.15393 12.1213 7.59132C12.6839 7.02871 13 6.26565 13 5.47V1Z",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})))},j7=(0,i.forwardRef)(F7);o.p;var Y7,$7,H7,U7,z7,W7,V7,G7=["title","titleId"];function Q7(){return Q7=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Q7.apply(null,arguments)}var q7=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,G7);return i.createElement("svg",Q7({width:24,height:24,viewBox:"0 0 26 22",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Y7||(Y7=i.createElement("path",{d:"M3 9V13V18C3 19.6569 4.34315 21 6 21H20C21.6569 21 23 19.6569 23 18V13V9",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),$7||($7=i.createElement("path",{d:"M11 12H8C7.44772 12 7 12.4477 7 13V20C7 20.5523 7.44772 21 8 21H11C11.5523 21 12 20.5523 12 20V13C12 12.4477 11.5523 12 11 12Z",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),H7||(H7=i.createElement("path",{d:"M19 12H16C15.4477 12 15 12.4477 15 13V16C15 16.5523 15.4477 17 16 17H19C19.5523 17 20 16.5523 20 16V13C20 12.4477 19.5523 12 19 12Z",fill:"currentColor",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),U7||(U7=i.createElement("path",{d:"M23.9659 3.15869C23.3783 1.84541 22.0738 1 20.6351 1H18L18.9759 5.36217C18.9919 5.43384 18.9993 5.5071 19.002 5.58049C19.0299 6.336 19.3422 7.05481 19.8787 7.59132C20.4413 8.15393 21.2044 8.47 22 8.47C22.7956 8.47 23.5587 8.15393 24.1213 7.59132V7.59132C25.2196 6.493 24.6721 4.73712 24.0377 3.31931L23.9659 3.15869Z",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),z7||(z7=i.createElement("path",{d:"M17.98 1H12.98V5.47C12.98 6.26565 13.296 7.02871 13.8587 7.59132C14.4213 8.15393 15.1843 8.47 15.98 8.47C16.7756 8.47 17.5387 8.15393 18.1013 7.59132C18.6378 7.05481 18.9501 6.336 18.9779 5.58049C18.9806 5.5071 18.9719 5.43384 18.9559 5.36217L17.98 1Z",fill:"currentColor",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),W7||(W7=i.createElement("path",{d:"M4.95639 1C3.76618 1 2.68708 1.69937 2.20099 2.78579L1.96227 3.31932C1.32791 4.73713 0.78036 6.493 1.87868 7.59132C2.44129 8.15393 3.20435 8.47 4 8.47C4.79565 8.47 5.55871 8.15393 6.12132 7.59132C6.65783 7.05481 6.97015 6.336 6.99797 5.58049C7.00067 5.5071 7.00809 5.43384 7.02412 5.36217L8 1H4.95639Z",fill:"currentColor",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),V7||(V7=i.createElement("path",{d:"M13 1H8L7.02412 5.36217C7.00809 5.43384 6.99933 5.5071 7.00203 5.58049C7.02985 6.336 7.34216 7.05481 7.87868 7.59132C8.44129 8.15393 9.20435 8.47 10 8.47C10.7956 8.47 11.5587 8.15393 12.1213 7.59132C12.6839 7.02871 13 6.26565 13 5.47V1Z",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})))},K7=(0,i.forwardRef)(q7);o.p;var Z7,J7=["title","titleId"];function X7(){return X7=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},X7.apply(null,arguments)}var eee=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,J7);return i.createElement("svg",X7({width:84,height:35,viewBox:"0 0 84 35",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Z7||(Z7=i.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M83.8462 18.089C83.8462 12.1061 80.9581 7.38517 75.4382 7.38517C69.8951 7.38517 66.5412 12.1061 66.5412 18.0422C66.5412 25.0769 70.5006 28.6292 76.1835 28.6292C78.9551 28.6292 81.0513 27.9982 82.635 27.1101V22.436C81.0513 23.2306 79.2346 23.7213 76.9288 23.7213C74.6697 23.7213 72.6667 22.9267 72.4105 20.169H83.7996C83.7996 19.8652 83.8462 18.6499 83.8462 18.089ZM72.3406 15.8688C72.3406 13.2279 73.9476 12.1294 75.415 12.1294C76.8357 12.1294 78.3496 13.2279 78.3496 15.8688H72.3406ZM57.5511 7.38517C55.2686 7.38517 53.8013 8.46023 52.9861 9.20809L52.6833 7.7591H47.5594V35.0094L53.3821 33.7708L53.4053 27.1569C54.2438 27.7645 55.4782 28.6292 57.5278 28.6292C61.6968 28.6292 65.4932 25.2638 65.4932 17.8553C65.4699 11.0778 61.6269 7.38517 57.5511 7.38517ZM56.1536 23.4876C54.7795 23.4876 53.9643 22.9969 53.4053 22.3892L53.3821 13.7187C53.9876 13.0409 54.8261 12.5735 56.1536 12.5735C58.2731 12.5735 59.7404 14.9573 59.7404 18.0189C59.7404 21.1506 58.2964 23.4876 56.1536 23.4876ZM39.5474 6.00629L45.3934 4.74427V0L39.5474 1.23865V6.00629ZM39.5474 7.78247H45.3934V28.2319H39.5474V7.78247ZM33.2823 9.51191L32.9096 7.78247H27.8788V28.2319H33.7015V14.373C35.0756 12.5735 37.4047 12.9007 38.1267 13.1578V7.78247C37.3814 7.50202 34.6564 6.98786 33.2823 9.51191ZM21.637 2.71101L15.9541 3.92629L15.9308 22.6463C15.9308 26.1052 18.516 28.6526 21.963 28.6526C23.8729 28.6526 25.2703 28.302 26.0389 27.8813V23.1371C25.2936 23.4409 21.6137 24.516 21.6137 21.0571V12.7604H26.0389V7.78247H21.6137L21.637 2.71101ZM5.89252 13.7187C5.89252 12.8072 6.63782 12.4566 7.87222 12.4566C9.64231 12.4566 11.8782 12.9942 13.6483 13.9524V8.46022C11.7152 7.68899 9.80534 7.38517 7.87222 7.38517C3.14423 7.38517 0 9.86247 0 13.9991C0 20.4494 8.85043 19.4211 8.85043 22.2022C8.85043 23.2773 7.9188 23.6279 6.61453 23.6279C4.68141 23.6279 2.21261 22.8333 0.256196 21.7582V27.3204C2.42222 28.2553 4.61154 28.6526 6.61453 28.6526C11.459 28.6526 14.7895 26.2454 14.7895 22.062C14.7662 15.0975 5.89252 16.3362 5.89252 13.7187Z",fill:"#635BFF"})))},tee=(0,i.forwardRef)(eee);o.p;var nee,ree,oee=["title","titleId"];function iee(){return iee=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},iee.apply(null,arguments)}var aee=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,oee);return i.createElement("svg",iee({width:16,height:16,viewBox:"0 0 16 16",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,nee||(nee=i.createElement("mask",{id:"tag-enabled-icon-cut-out"},i.createElement("rect",{x:0,y:0,width:16,height:16,fill:"white"}),i.createElement("path",{d:"M4.54199 4.54175H4.54949",stroke:"black",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"}))),ree||(ree=i.createElement("path",{mask:"url(#tag-enabled-icon-cut-out)",d:"M14.1679 9.08208L9.08917 14.1608C8.9576 14.2926 8.80135 14.397 8.62937 14.4683C8.45739 14.5396 8.27305 14.5763 8.08688 14.5763C7.9007 14.5763 7.71636 14.5396 7.54438 14.4683C7.3724 14.397 7.21615 14.2926 7.08458 14.1608L1 8.08333V1H8.08333L14.1679 7.08458C14.4318 7.35001 14.5799 7.70907 14.5799 8.08333C14.5799 8.4576 14.4318 8.81665 14.1679 9.08208V9.08208Z",fill:"currentColor",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})))},see=(0,i.forwardRef)(aee);o.p;o.p;const lee=function(e){var t=e.isAboutContactVisible,n=e.isAboutMessageVisible,r=e.isAboutPricingVisible,o=e.isAdminModeEnabled,a=e.isHiddenPhotosVisible,s=e.isHomeSecondaryNavVisible,l=e.isLabeledPhotosVisible,c=e.selectedRoute,u=e.selectedUri,d=e.translate,p=(0,i.useMemo)((function(){if(("Home"===c||"Album"===c)&&s){var e=[{href:"home",label:d("albums")},{href:"album/all",label:d("allPhotos")}];return e.some((function(e){return e.href===u}))?e:void 0}if("Special"===c&&o){var i=[{href:"favorites",label:d("favorites")},a&&{href:"hidden",label:d("hidden")},l&&{href:"labels",label:d("labeled")}].filter((function(e){return Boolean(e)}));return i.some((function(e){return e.href===u}))&&i.length>1?i:void 0}if("Info"===c){var p=[t&&{href:"info/contact",label:d("contact")},n&&{href:"info/message",label:d("message")},r&&{href:"info/pricing",label:d("pricing")}].filter((function(e){return Boolean(e)}));return p.length>1?p:void 0}}),[t,n,r,o,a,s,l,c,u,d]),f=null==p?void 0:p.findIndex((function(e){return e.href===u}));return{navTabs:p,navTabsKey:"Album"===c?"Home":c,selectedNavTabIndex:-1===f?0:f}};function cee(){return cee=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},cee.apply(this,arguments)}function uee(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}var dee=(0,i.forwardRef)((function(e,t){var n=e.color,r=void 0===n?"currentColor":n,o=e.size,a=void 0===o?24:o,s=uee(e,["color","size"]);return i.createElement("svg",cee({ref:t,xmlns:"http://www.w3.org/2000/svg",width:a,height:a,viewBox:"0 0 24 24",fill:"none",stroke:r,strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"},s),i.createElement("line",{x1:"19",y1:"12",x2:"5",y2:"12"}),i.createElement("polyline",{points:"12 19 5 12 12 5"}))}));dee.propTypes={color:Xr().string,size:Xr().oneOfType([Xr().string,Xr().number])},dee.displayName="ArrowLeft";const pee=dee;const fee=function(e){var t=e.children,n=e.onClickBack,r=e.parentRouteName,o=e.parentUri,a=e.rightActions,s=e.translateFilter,l=(0,i.useRef)(null),c=(0,i.useRef)(null),u=m((0,i.useState)(),2),d=u[0],p=u[1];return(0,i.useEffect)((function(){var e=new dS((function(){window.requestAnimationFrame((function(){var e,t,n,r;p(Math.max(null!==(e=null===(t=l.current)||void 0===t?void 0:t.offsetWidth)&&void 0!==e?e:0,null!==(n=null===(r=c.current)||void 0===r?void 0:r.offsetWidth)&&void 0!==n?n:0))}))}));return l.current&&e.observe(l.current),c.current&&e.observe(c.current),function(){e.disconnect()}}),[]),i.createElement(wr,{alignItems:"center",backgroundColor:"background",borderBottomColor:"gray.100",borderBottomStyle:"solid",borderBottomWidth:"1px",flexFlow:"row nowrap",height:"60px",justifyContent:"space-between",padding:"16px",position:"relative"},i.createElement(wr,{ref:l,flex:"0 0 "+(void 0===d?"auto":d+"px"),flexFlow:"row nowrap",justifyContent:"flex-start",alignItems:"center"},i.createElement(Kr,{"aria-label":s(r?"Back to "+r:"back"),href:o,onClick:n,color:"text",display:"flex",justifyContent:"center",alignItems:"center",width:"40px",height:"40px",_focus:{color:"text",boxShadow:"none"},_focusVisible:{boxShadow:"outline"},_hover:{color:"brand.primary",textDecoration:"none"},_visited:{color:"text","&:focus":{color:"text"},"&:hover":{color:"brand.primary"}}},i.createElement(pee,null))),i.createElement(wr,{flex:"0 1 auto",flexFlow:"row nowrap",justifyContent:a?"center":"flex-end",alignItems:"center",overflow:"hidden"},t),a&&i.createElement(wr,{ref:c,flex:"0 0 "+(void 0===d?"auto":d+"px"),flexFlow:"row nowrap",justifyContent:"flex-end",alignItems:"center"},a))};function hee(){return hee=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},hee.apply(this,arguments)}function mee(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}var gee=(0,i.forwardRef)((function(e,t){var n=e.color,r=void 0===n?"currentColor":n,o=e.size,a=void 0===o?24:o,s=mee(e,["color","size"]);return i.createElement("svg",hee({ref:t,xmlns:"http://www.w3.org/2000/svg",width:a,height:a,viewBox:"0 0 24 24",fill:"none",stroke:r,strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"},s),i.createElement("line",{x1:"12",y1:"19",x2:"12",y2:"5"}),i.createElement("polyline",{points:"5 12 12 5 19 12"}))}));gee.propTypes={color:Xr().string,size:Xr().oneOfType([Xr().string,Xr().number])},gee.displayName="ArrowUp";const vee=gee;var yee=o(47110),bee=o.n(yee),_ee="56px";const Aee=function(e){var t,n,r=e.isHidden,o=e.translateFilter,a=Lr(),s=null!==(t=u9({lg:"32px"}))&&void 0!==t?t:"16px",l=(0,i.useCallback)((function(){!function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;(new(bee())).animateScroll(e,t,{easing:"easeInOutQuart",speed:500,speedAsDuration:!0})}(0)}),[]);return i.createElement(Gr,{"aria-label":o("backToTop"),background:"background",border:"none",bottom:"calc(-56px - "+s+" - "+s+")",boxShadow:"0 2px 2px 2px var(--chakra-colors-boxShadow)",color:"brand.primary",filter:null===(n=a.filters)||void 0===n?void 0:n.dropShadow,height:_ee,icon:i.createElement(vee,null),isRound:!0,marginY:s,onClick:l,opacity:r?0:1,position:"absolute",right:s,transition:"opacity 0.5s",width:_ee,_focus:{boxShadow:"none",color:"brand.primary"},_focusVisible:{boxShadow:"outline"},_hover:{color:"brand.primary"}})};var Eee=yr((function(e,t){const n=Fr("Badge",e),{className:r,...o}=pt(e);return(0,br.jsx)(vr.span,{ref:t,className:g("chakra-badge",e.className),...o,__css:{display:"inline-block",whiteSpace:"nowrap",verticalAlign:"middle",...n}})}));Eee.displayName="Badge";var wee=["children","count"];const xee=function(e){var r=e.children,o=e.count,a=void 0===o?0:o,s=t(e,wee),l=a>99;return i.createElement(_r,{position:"relative"},r,a>0&&i.createElement(Eee,n({alignItems:"center",background:"brand.secondary",borderColor:"background",borderRadius:l?"40%":"50%",borderStyle:"solid",borderWidth:"1px",color:"background",display:"flex",fontFamily:"open-sans",fontSize:"10px",fontWeight:"normal",height:"16px",justifyContent:"center",padding:0,position:"absolute",right:"-12px",top:"-4px",width:l?"22px":"16px"},s),l?"99+":a))};var kee=["children","isSelected"];const Cee=function(e){var r=e.children,o=e.isSelected,a=t(e,kee);return i.createElement(Kr,n({"aria-current":o?"page":void 0,alignItems:"center",borderBottomColor:o?"brand.primary":"transparent",borderBottomStyle:"solid",borderBottomWidth:"2px",color:o?"brand.primary":"text",display:"flex",fontFamily:"open-sans",fontSize:"16px",fontWeight:o?"semibold":"normal",height:"full",lineHeight:1.5,marginX:"20px",padding:0,_focus:{color:o?"brand.primary":"text"},_focusVisible:{boxShadow:"outline",color:"brand.primary"},_hover:{borderBottomColor:o?"brand.primary":"transparent",borderBottomStyle:"solid",borderBottomWidth:"2px",color:"brand.primary",textDecoration:"none"},_visited:{color:o?"brand.primary":"text","&:focus":{color:o?"brand.primary":"text"},"&:hover":{color:"brand.primary"}}},a),r)};const See=function(e){var t=e.selectedTabIndex,n=void 0===t?0:t,r=e.tabs,o=(0,i.useRef)(null),a=m((0,i.useState)(),2),s=a[0],l=a[1],c=(0,i.useCallback)((function(){o.current&&l({left:o.current.offsetLeft,top:o.current.offsetTop,width:o.current.offsetWidth,height:o.current.offsetHeight})}),[]);(0,i.useEffect)((function(){var e;return o.current&&(e=new dS((function(){window.requestAnimationFrame(c)}))).observe(o.current),function(){var t;null===(t=e)||void 0===t||t.disconnect()}}),[c]),(0,i.useEffect)(c,[n,c]);var u=u9({base:void 0,lg:"brand.primary"});return i.createElement(wr,{as:"nav",gap:"4px",position:"relative"},s&&i.createElement(_r,{role:"presentation",backgroundColor:"brand.primaryLight",borderColor:"brand.primary",borderRadius:"16px",borderStyle:"solid",borderWidth:"1px",position:"absolute",transition:"0.25s left",left:s.left+"px",top:s.top+"px",width:s.width+"px",height:s.height+"px"}),r.map((function(e,t){var r=n===t;return i.createElement(Kr,{key:t,ref:r?o:void 0,href:e.href,"aria-current":r?"page":void 0,borderColor:"transparent",borderRadius:"16px",borderStyle:"solid",borderWidth:"1px",color:"text",fontFamily:"open-sans",fontSize:"16px",fontWeight:r?"semibold":"normal",lineHeight:1.5,paddingLeft:"12px",paddingRight:"12px",_focus:{color:r?"brand.primary":"text"},_focusVisible:{boxShadow:"outline",color:"brand.primary"},_hover:{color:u,textDecoration:"none"},_visited:{color:r?"brand.primary":"text","&:focus":{color:r?"brand.primary":"text"},"&:hover":{color:u}}},e.label)})))};const Mee=function(e){var t=e.text,n=e.variant,r=e.style;return i.createElement(tq,{as:"h2",margin:0,size:"sm",style:r,variant:n},t)};function Tee(){return Tee=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Tee.apply(this,arguments)}function Oee(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}var Dee=(0,i.forwardRef)((function(e,t){var n=e.color,r=void 0===n?"currentColor":n,o=e.size,a=void 0===o?24:o,s=Oee(e,["color","size"]);return i.createElement("svg",Tee({ref:t,xmlns:"http://www.w3.org/2000/svg",width:a,height:a,viewBox:"0 0 24 24",fill:"none",stroke:r,strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"},s),i.createElement("path",{d:"M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"}),i.createElement("line",{x1:"3",y1:"6",x2:"21",y2:"6"}),i.createElement("path",{d:"M16 10a4 4 0 0 1-8 0"}))}));Dee.propTypes={color:Xr().string,size:Xr().oneOfType([Xr().string,Xr().number])},Dee.displayName="ShoppingBag";const Lee=Dee;function Pee(){return Pee=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Pee.apply(this,arguments)}function Iee(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}var Bee=(0,i.forwardRef)((function(e,t){var n=e.color,r=void 0===n?"currentColor":n,o=e.size,a=void 0===o?24:o,s=Iee(e,["color","size"]);return i.createElement("svg",Pee({ref:t,xmlns:"http://www.w3.org/2000/svg",width:a,height:a,viewBox:"0 0 24 24",fill:"none",stroke:r,strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"},s),i.createElement("path",{d:"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"}),i.createElement("polyline",{points:"7 10 12 15 17 10"}),i.createElement("line",{x1:"12",y1:"15",x2:"12",y2:"3"}))}));Bee.propTypes={color:Xr().string,size:Xr().oneOfType([Xr().string,Xr().number])},Bee.displayName="Download";const Ree=Bee;function Nee(){return Nee=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Nee.apply(this,arguments)}function Fee(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}var jee=(0,i.forwardRef)((function(e,t){var n=e.color,r=void 0===n?"currentColor":n,o=e.size,a=void 0===o?24:o,s=Fee(e,["color","size"]);return i.createElement("svg",Nee({ref:t,xmlns:"http://www.w3.org/2000/svg",width:a,height:a,viewBox:"0 0 24 24",fill:"none",stroke:r,strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"},s),i.createElement("line",{x1:"22",y1:"2",x2:"11",y2:"13"}),i.createElement("polygon",{points:"22 2 15 22 11 13 2 9 22 2"}))}));jee.propTypes={color:Xr().string,size:Xr().oneOfType([Xr().string,Xr().number])},jee.displayName="Send";const Yee=jee;function $ee(){return $ee=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},$ee.apply(this,arguments)}function Hee(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}var Uee=(0,i.forwardRef)((function(e,t){var n=e.color,r=void 0===n?"currentColor":n,o=e.size,a=void 0===o?24:o,s=Hee(e,["color","size"]);return i.createElement("svg",$ee({ref:t,xmlns:"http://www.w3.org/2000/svg",width:a,height:a,viewBox:"0 0 24 24",fill:"none",stroke:r,strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"},s),i.createElement("circle",{cx:"12",cy:"12",r:"1"}),i.createElement("circle",{cx:"12",cy:"5",r:"1"}),i.createElement("circle",{cx:"12",cy:"19",r:"1"}))}));Uee.propTypes={color:Xr().string,size:Xr().oneOfType([Xr().string,Xr().number])},Uee.displayName="MoreVertical";const zee=Uee;function Wee(){return Wee=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Wee.apply(this,arguments)}function Vee(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}var Gee=(0,i.forwardRef)((function(e,t){var n=e.color,r=void 0===n?"currentColor":n,o=e.size,a=void 0===o?24:o,s=Vee(e,["color","size"]);return i.createElement("svg",Wee({ref:t,xmlns:"http://www.w3.org/2000/svg",width:a,height:a,viewBox:"0 0 24 24",fill:"none",stroke:r,strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"},s),i.createElement("rect",{x:"5",y:"2",width:"14",height:"20",rx:"2",ry:"2"}),i.createElement("line",{x1:"12",y1:"18",x2:"12.01",y2:"18"}))}));Gee.propTypes={color:Xr().string,size:Xr().oneOfType([Xr().string,Xr().number])},Gee.displayName="Smartphone";const Qee=Gee;var qee,Kee=["title","titleId"];function Zee(){return Zee=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Zee.apply(null,arguments)}var Jee=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Kee);return i.createElement("svg",Zee({width:24,height:24,viewBox:"0 0 59 59",xmlns:"http://www.w3.org/2000/svg","jetway-hooks":"{}",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,qee||(qee=i.createElement("g",{"jetway-hook-id":"D32A0C4D-4437-47B2-A852-7B39F943D3F1"},i.createElement("g",{"jetway-hook-id":"647A0BE8-6A54-4FD3-92E7-3C0C54A07C51",stroke:"none",strokeWidth:1,fill:"none",fillRule:"evenodd"},i.createElement("g",{"jetway-hook-id":"4B4991DA-B6A7-4A61-B064-B6BCDC859944"},i.createElement("g",{"jetway-hook-id":"F7C64F54-09B8-4D6D-9454-F58219AA5601"},i.createElement("g",{"jetway-hook-id":"45B02426-3A5F-49AF-8232-3C1F09D29D37"},i.createElement("path",{"jetway-hook-id":"68097562-43CD-4175-BD0F-8131708A2434",d:"M-3-3h64v64H-3z"}),i.createElement("g",{"jetway-hook-id":"DD923623-943A-45E3-8DE8-A4A4B8A7C198",fillRule:"nonzero"},i.createElement("path",{d:"M14.75 13.41c8.146 0 14.75 6.603 14.75 14.75v1.34H1.34C.6 29.5 0 28.9 0 28.16c0-8.147 6.604-14.75 14.75-14.75z","jetway-hook-id":"B4287B30-9B3D-4F6B-9C01-2A7C2CA23D6F",fill:"#FBBC04"}),i.createElement("path",{d:"M45.59 14.75c0 8.146-6.603 14.75-14.75 14.75H29.5V1.34C29.5.6 30.1 0 30.84 0c8.147 0 14.75 6.604 14.75 14.75z","jetway-hook-id":"5872DD7E-5971-4393-9299-364708D669BC",fill:"#EA4335"}),i.createElement("path",{d:"M44.25 45.59c-8.146 0-14.75-6.603-14.75-14.75V29.5h28.16c.74 0 1.34.6 1.34 1.34 0 8.147-6.604 14.75-14.75 14.75z","jetway-hook-id":"184B2279-6FFE-4CA2-B961-54092B122EB8",fill:"#4285F4"}),i.createElement("path",{d:"M13.41 44.25c0-8.146 6.603-14.75 14.75-14.75h1.34v28.16c0 .74-.6 1.34-1.34 1.34-8.147 0-14.75-6.604-14.75-14.75z","jetway-hook-id":"2AD9C930-A41C-474E-9152-1E50FC2C457C",fill:"#34A853"})))))))))},Xee=(0,i.forwardRef)(Jee);o.p;const ete=function(e){var t=e.disconnectFromGoogle,n=e.googleEmail,r=e.translateFilter,o=m((0,i.useState)(!1),2),a=o[0],s=o[1],l=(0,i.useCallback)(Lo(Io().mark((function e(){return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,t();case 2:s(!0);case 3:case"end":return e.stop()}}),e)}))),[t]);return i.createElement(wr,{alignItems:"center",flexDirection:"column",width:"100%"},i.createElement(qr,{fontSize:"xs",textAlign:"center"},a?r("client.gallery.downloadDestinations.disconnectedFromGooglePhotos"):r("client.gallery.downloadDestinations.connectedToGooglePhotos",{googleEmail:n})),!a&&i.createElement(Kr,{as:"button",type:"button",onClick:l,variant:"googlePhotos"},i.createElement(qr,{fontSize:"sm",fontWeight:"bold",textDecoration:"underline"},r("client.gallery.downloadDestinations.disconnectFromGooglePhotos"))))};var tte=["disabled","fullWidth","isLoading","onClick","text","textLarge","variant"];const nte=function(e){var r=e.disabled,o=e.fullWidth,a=e.isLoading,s=e.onClick,l=e.text,c=e.textLarge,u=void 0===c?l:c,d=e.variant,p=void 0===d?"primary":d,f=t(e,tte),h=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"lg",t=Lr(),r=(0,i.useMemo)((function(){return n({},t.breakpoints,{xl:"1499px"})}),[t]),o=(0,i.useCallback)((function(){var t="only screen and (min-width: calc("+r[e]+" + 1px))";return matchMedia(t).matches}),[e,r]),a=m((0,i.useState)(o),2),s=a[0],l=a[1];return(0,i.useEffect)((function(){var e=function(){l(o())};return window.addEventListener("resize",e),function(){window.removeEventListener("resize",e)}}),[o]),s}(),g=h?u:l;return i.createElement(Wr,n({isDisabled:a||r,isLoading:a,loadingText:a?g:void 0,onClick:a?void 0:s,variant:p,width:o?"full":void 0},f),g)};const rte=function(e){var t=e.isDownloadPhoto,n=e.onDeviceDownloadClick,r=e.onGoogleDownloadClick,o=e.remainingDownloads,a=e.spFreeDigitals,s=e.translateFilter,l=Lr().isLightColorScheme;function c(e,t){return s("client.gallery.downloadDestinations."+e,t)}var u=a.getGoogleEmail();return i.createElement(wr,{direction:"column",alignItems:"center",gap:"16px"},i.createElement(wr,{direction:"column",alignItems:"center",marginBottom:"8px"},i.createElement(qr,{fontSize:"lg",fontWeight:600,color:l?"gray.600":"white"},c(t?"downloadPhoto":"downloadAll")),i.createElement(qr,{fontSize:"sm"},"number"==typeof o?c(1===o?"oneDownload":"downloads",{count:""+o}):c("unlimitedDownloads"))),u&&i.createElement(ete,{disconnectFromGoogle:a.disconnectFromGoogle,googleEmail:u,translateFilter:s}),i.createElement(wr,{direction:"column",alignItems:"center",gap:"8px",width:"100%"},i.createElement(nte,{text:c("saveToGooglePhotos"),variant:"googlePhotos",fullWidth:!0,iconSpacing:"4",leftIcon:i.createElement(Xee,null),onClick:r}),i.createElement(nte,{text:c("myDevice"),variant:"primary",fullWidth:!0,iconSpacing:"4",leftIcon:i.createElement(Qee,null),onClick:n})))};function ote(e,t){var n=e.setDownloadDestination;return{remainingDownloads:(0,e.getRemainingDownloads)(),onDeviceDownloadClick:function(){n(g9.DEVICE),t()},onGoogleDownloadClick:function(){n(g9.GOOGLE_PHOTOS),t()}}}var[ite,ate]=xr(),ste={start:{ltr:"left",rtl:"right"},end:{ltr:"right",rtl:"left"}};function lte(e){var t;const{isOpen:n,onClose:r,placement:o="right",children:i,...a}=e,s=Lr(),l=null==(t=s.components)?void 0:t.Drawer,c=function(e,t){var n,r;if(e)return null!=(r=null==(n=ste[e])?void 0:n[t])?r:e}(o,s.direction);return(0,br.jsx)(ite,{value:{placement:c},children:(0,br.jsx)(sB,{isOpen:n,onClose:r,styleConfig:l,...a,children:i})})}var cte={exit:{duration:.15,ease:uB.easeInOut},enter:{type:"spring",damping:25,stiffness:180}},ute={exit:({direction:e,transition:t,transitionEnd:n,delay:r})=>{var o;const{exit:i}=mB({direction:e});return{...i,transition:null!=(o=null==t?void 0:t.exit)?o:yB(cte.exit,r),transitionEnd:null==n?void 0:n.exit}},enter:({direction:e,transitionEnd:t,transition:n,delay:r})=>{var o;const{enter:i}=mB({direction:e});return{...i,transition:null!=(o=null==n?void 0:n.enter)?o:vB(cte.enter,r),transitionEnd:null==t?void 0:t.enter}}},dte=(0,i.forwardRef)((function(e,t){const{direction:n="right",style:r,unmountOnExit:o,in:i,className:a,transition:s,transitionEnd:l,delay:c,motionProps:u,...d}=e,p=mB({direction:n}),f=Object.assign({position:"fixed"},p.position,r),h=!o||i&&o,m=i||o?"enter":"exit",v={transitionEnd:l,transition:s,direction:n,delay:c};return(0,br.jsx)(qw,{custom:v,children:h&&(0,br.jsx)(Yw.div,{...d,ref:t,initial:"exit",className:g("chakra-slide",a),animate:m,exit:"exit",custom:v,variants:ute,style:f,...u})})}));dte.displayName="Slide";var pte=vr(dte),fte=yr(((e,t)=>{const{className:n,children:r,motionProps:o,containerProps:i,...a}=e,{getDialogProps:s,getDialogContainerProps:l,isOpen:c}=aB(),u=s(a,t),d=l(i),p=g("chakra-modal__content",n),f=oB(),h={display:"flex",flexDirection:"column",position:"relative",width:"100%",outline:0,...f.dialog},m={display:"flex",width:"100vw",height:"$100vh",position:"fixed",left:0,top:0,...f.dialogContainer},{placement:v}=ate();return(0,br.jsx)(cF,{children:(0,br.jsx)(vr.div,{...d,className:"chakra-modal__content-container",__css:m,children:(0,br.jsx)(pte,{motionProps:o,direction:v,in:c,className:p,...u,__css:h,children:r})})})}));fte.displayName="DrawerContent";var hte=["children"],mte=function(e){var t=e.children,n=(0,i.useRef)(null),r=m((0,i.useState)(),2),o=r[0],a=r[1],s=(0,i.useCallback)((function(){n.current&&a(n.current.offsetHeight)}),[]);return(0,i.useEffect)((function(){var e;return s(),n.current&&(e=new dS(s)).observe(n.current),function(){var t;null===(t=e)||void 0===t||t.disconnect()}}),[s]),i.createElement(lB,{flex:"initial",height:void 0===o?"auto":o+"px",padding:0,transition:"height 0.25s"},i.createElement(_r,{padding:"16px",ref:n},t))};const gte=function(e){var r=e.children,o=t(e,hte);return i.createElement(lte,n({placement:"bottom"},o),i.createElement(vF,null),i.createElement(fte,null,i.createElement(cB,null),i.createElement(mte,null,r)))};function vte(){return vte=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},vte.apply(this,arguments)}function yte(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}var bte=(0,i.forwardRef)((function(e,t){var n=e.color,r=void 0===n?"currentColor":n,o=e.size,a=void 0===o?24:o,s=yte(e,["color","size"]);return i.createElement("svg",vte({ref:t,xmlns:"http://www.w3.org/2000/svg",width:a,height:a,viewBox:"0 0 24 24",fill:"none",stroke:r,strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"},s),i.createElement("path",{d:"M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"}),i.createElement("path",{d:"M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"}))}));bte.propTypes={color:Xr().string,size:Xr().oneOfType([Xr().string,Xr().number])},bte.displayName="Link";const _te=bte;function Ate(){return Ate=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Ate.apply(this,arguments)}function Ete(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}var wte=(0,i.forwardRef)((function(e,t){var n=e.color,r=void 0===n?"currentColor":n,o=e.size,a=void 0===o?24:o,s=Ete(e,["color","size"]);return i.createElement("svg",Ate({ref:t,xmlns:"http://www.w3.org/2000/svg",width:a,height:a,viewBox:"0 0 24 24",fill:"none",stroke:r,strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"},s),i.createElement("path",{d:"M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"}))}));wte.propTypes={color:Xr().string,size:Xr().oneOfType([Xr().string,Xr().number])},wte.displayName="Heart";const xte=wte;function kte(){return kte=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},kte.apply(this,arguments)}function Cte(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}var Ste=(0,i.forwardRef)((function(e,t){var n=e.color,r=void 0===n?"currentColor":n,o=e.size,a=void 0===o?24:o,s=Cte(e,["color","size"]);return i.createElement("svg",kte({ref:t,xmlns:"http://www.w3.org/2000/svg",width:a,height:a,viewBox:"0 0 24 24",fill:"none",stroke:r,strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"},s),i.createElement("path",{d:"M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"}),i.createElement("line",{x1:"1",y1:"1",x2:"23",y2:"23"}))}));Ste.propTypes={color:Xr().string,size:Xr().oneOfType([Xr().string,Xr().number])},Ste.displayName="EyeOff";const Mte=Ste;Gd({});var Tte=null;const Ote=function(e){var t,n=e.title,r=e.description,o=e.icon,a=e.iconFill,s=e.onClose,l=Lr();return i.createElement(wr,{background:l.isLightColorScheme?"background":"gray.600",borderRadius:"lg",filter:null===(t=l.filters)||void 0===t?void 0:t.dropShadow,fontFamily:"open-sans, sans-serif",padding:"12px",position:"relative"},o&&i.createElement(wr,{justifyContent:"center",alignItems:"center",height:"24px",paddingX:"4px",marginRight:"12px",color:"brand.primary",borderRadius:"50%",backgroundColor:"brand.primaryLight"},i.createElement(Jk,{as:o,boxSize:"16px",fill:a})),i.createElement(ro,{size:"16px",onClick:s,style:{position:"absolute",right:"16px",top:"16px",cursor:"pointer",color:l.isLightColorScheme?"gray.500":"white"}}),i.createElement(_r,null,n&&i.createElement(qr,{fontWeight:"semibold"},n),r&&i.createElement(qr,null,r)))};const Dte=function(e){var t=e.type,r=e.translateFilter,o=Lr(),a=(0,i.useMemo)((function(){switch(t){case"favorite":return{icon:xte,iconFill:"brand.primary",title:r("photoAddedToFavorites"),description:r("photoAddedToFavoritesDescription")};case"favorites_sent":return{icon:Yee,iconFill:"brand.primary",title:r("favoritePhotosSent"),description:r("favoritePhotosSentDescription")};case"label":return{icon:see,title:r("photoLabeled"),description:r("photoLabeledDescription")};case"hide":return{icon:Mte,title:r("photoHidden"),description:r("photoHiddenDescription")};case"copyLink":return{icon:_te,title:r("copiedLink")};default:throw new Error("Invalid ToastType: "+t)}}),[r,t]);return function(){!function(e,t){!function n(r){Tte?Tte.show(e,t):r||n(!0)}(!1)}(o,i.createElement(Ote,n({onClose:function(){var e;null===(e=Tte)||void 0===e||e.dismiss()}},a)))}};var Lte=["Icon","iconFill"],Pte=function(e){var r=e.Icon,o=e.iconFill,a=t(e,Lte);return i.createElement(Gr,n({border:"none",height:"55px",icon:i.createElement(r,{fill:null!=o?o:"none",height:"24px",width:"24px"}),isRound:!0,width:"55px",_active:{backgroundColor:a.backgroundColor},_focus:{boxShadow:"none",color:a.color},_focusVisible:{boxShadow:"outline"},_hover:{backgroundColor:a.backgroundColor,color:a.color}},a))};const Ite=function(e){var t=e.copyLinkHref,n=e.headingText,r=e.linkHrefs,o=e.onClickLink,a=e.translateFilter,s=Lr(),l=Dte({type:"copyLink",translateFilter:a}),c=(0,i.useCallback)(Lo(Io().mark((function e(){return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!t){e.next=5;break}return e.next=3,navigator.clipboard.writeText(t);case 3:null==o||o(),l();case 5:case"end":return e.stop()}}),e)}))),[t,o,l]);return i.createElement(wr,{alignItems:"center",flexDirection:"column",gap:"24px"},i.createElement(tq,{as:"h3",color:"text",size:"md"},n),i.createElement(wr,{flexFlow:"row wrap",justifyContent:"center",gap:"24px"},(null==r?void 0:r.facebook)&&i.createElement(Pte,{as:Kr,"aria-label":"Facebook",backgroundColor:"#ecf0f8",href:r.facebook,Icon:v7,iconFill:"#4267b2",onClick:o,rel:"noopener noreferrer",target:"_blank"}),(null==r?void 0:r.twitter)&&i.createElement(Pte,{as:Kr,"aria-label":"Twitter",backgroundColor:"#e7f5fd",href:r.twitter,Icon:M7,iconFill:"#1ca0f0",onClick:o,rel:"noopener noreferrer",target:"_blank"}),(null==r?void 0:r.pinterest)&&i.createElement(Pte,{as:Kr,"aria-label":"Pinterest",backgroundColor:"#fee6e9",href:r.pinterest,Icon:w7,iconFill:"#bd061b",onClick:o,rel:"noopener noreferrer",target:"_blank"}),t&&i.createElement(Pte,{"aria-label":a("copyLink"),backgroundColor:s.isLightColorScheme?"gray.100":"gray.200",color:"gray.500",Icon:_te,onClick:c})))};var Bte=["actions","isShareLinksVisible","shareCopyLinkUrl","shareHeadingText","shareUrls","isDownloadDestinationsVisible","isDownloadPhoto","downloadDestinationsProps","onCancel","onClose","spFreeDigitals","translateFilter"];const Rte=function(e){var r=e.actions,o=e.isShareLinksVisible,a=e.shareCopyLinkUrl,s=e.shareHeadingText,l=e.shareUrls,c=e.isDownloadDestinationsVisible,u=e.isDownloadPhoto,d=e.downloadDestinationsProps,p=e.onCancel,f=e.onClose,h=e.spFreeDigitals,m=e.translateFilter,g=t(e,Bte);return i.createElement(gte,n({},g,{onClose:p}),o?i.createElement(_r,{paddingBottom:"24px",paddingTop:"4px"},l&&a?i.createElement(Ite,{copyLinkHref:a,headingText:s,linkHrefs:l,onClickLink:f,translateFilter:m}):i.createElement(x9,null)):c?i.createElement(rte,n({},d,{isDownloadPhoto:u,spFreeDigitals:h,translateFilter:m})):i.createElement(wr,{flexFlow:"column nowrap"},r.map((function(e){return i.createElement(Wr,{key:e.key,role:void 0===e.isToggledOn?void 0:"switch","aria-checked":e.isToggledOn,variant:"ghost",fontSize:"md",height:"48px",justifyContent:"left",letterSpacing:0,isDisabled:e.isDisabled,leftIcon:e.icon,paddingX:"8px",onClick:function(){e.onClick(),e.keepOpen||f()}},e.text)}))))};var Nte=["children"];const Fte=function(e){var n=e.children,r=t(e,Nte);return i.createElement(sB,r,i.createElement(vF,null),i.createElement(uF,null,i.createElement(lB,null,n),i.createElement(cB,null)))};function jte(e){const{isOpen:t,ref:n}=e,[r,o]=(0,i.useState)(t),[a,s]=(0,i.useState)(!1);(0,i.useEffect)((()=>{a||(o(t),s(!0))}),[t,a,r]),Vh((()=>n.current),"animationend",(()=>{o(t)}));return{present:!(!t&&!r),onComplete(){var e;const t=function(e){var t,n;return null!=(n=null==(t=of(e))?void 0:t.defaultView)?n:window}(n.current),r=new t.CustomEvent("animationend",{bubbles:!0});null==(e=n.current)||e.dispatchEvent(r)}}}var Yte=()=>"undefined"!=typeof window;var $te=e=>Yte()&&e.test(function(){var e;const t=navigator.userAgentData;return null!=(e=null==t?void 0:t.platform)?e:navigator.platform}()),Hte=()=>$te(/mac|iphone|ipad|ipod/i)&&(e=>Yte()&&e.test(navigator.vendor))(/apple/i);function Ute(e){const t=e.current;if(!t)return!1;const n=function(e){return of(e).activeElement}(t);return!!n&&(!t.contains(n)&&!(!((r=n)&&rf(r)&&vN(r))||mN(r)));var r}function zte(e,t){const{shouldFocus:n,visible:r,focusRef:o}=t,i=n&&!r;qx((()=>{if(!i)return;if(Ute(e))return;const t=(null==o?void 0:o.current)||e.current;let n;return t?(n=requestAnimationFrame((()=>{t.focus({preventScroll:!0})})),()=>{cancelAnimationFrame(n)}):void 0}),[i,e,o])}var Wte={preventScroll:!0,shouldFocus:!1};function Vte(e){const{wasSelected:t,enabled:n,isSelected:r,mode:o="unmount"}=e;return!n||(!!r||!("keepMounted"!==o||!t))}var Gte={click:"click",hover:"hover"};function Qte(e={}){const{closeOnBlur:t=!0,closeOnEsc:n=!0,initialFocusRef:r,id:o,returnFocusOnClose:a=!0,autoFocus:s=!0,arrowSize:l,arrowShadowColor:c,trigger:u=Gte.click,openDelay:d=200,closeDelay:p=200,isLazy:f,lazyBehavior:h="unmount",computePositionOnMount:m,...g}=e,{isOpen:v,onClose:y,onOpen:b,onToggle:_}=Wh(e),A=(0,i.useRef)(null),E=(0,i.useRef)(null),x=(0,i.useRef)(null),k=(0,i.useRef)(!1),C=(0,i.useRef)(!1);v&&(C.current=!0);const[S,M]=(0,i.useState)(!1),[T,O]=(0,i.useState)(!1),D=(0,i.useId)(),L=null!=o?o:D,[P,I,B,R]=["popover-trigger","popover-content","popover-header","popover-body"].map((e=>`${e}-${L}`)),{referenceRef:N,getArrowProps:F,getPopperProps:j,getArrowInnerProps:Y,forceUpdate:$}=Hh({...g,enabled:v||!!m}),H=jte({isOpen:v,ref:x});!function(e){const{ref:t,elements:n,enabled:r}=e,o=()=>{var e,n;return null!=(n=null==(e=t.current)?void 0:e.ownerDocument)?n:document};Vh(o,"pointerdown",(e=>{if(!Hte()||!r)return;const i=e.target,a=(null!=n?n:[t]).some((e=>{const t="current"in e?e.current:e;return(null==t?void 0:t.contains(i))||t===i}));o().activeElement!==i&&a&&(e.preventDefault(),i.focus())}))}({enabled:v,ref:E}),zte(x,{focusRef:E,visible:v,shouldFocus:a&&u===Gte.click}),function(e,t=Wte){const{focusRef:n,preventScroll:r,shouldFocus:o,visible:a}=t,s="current"in e?e.current:e,l=o&&a,c=(0,i.useRef)(l),u=(0,i.useRef)(a);em((()=>{!u.current&&a&&(c.current=l),u.current=a}),[a,l]);const d=(0,i.useCallback)((()=>{if(a&&s&&c.current&&(c.current=!1,!s.contains(document.activeElement)))if(null==n?void 0:n.current)requestAnimationFrame((()=>{var e;null==(e=n.current)||e.focus({preventScroll:r})}));else{const e=AN(s);e.length>0&&requestAnimationFrame((()=>{e[0].focus({preventScroll:r})}))}}),[a,r,s,n]);qx((()=>{d()}),[d]),Vh(s,"transitionend",d)}(x,{focusRef:r,visible:v,shouldFocus:s&&u===Gte.click});const U=Vte({wasSelected:C.current,enabled:f,mode:h,isSelected:H.present}),z=(0,i.useCallback)(((e={},r=null)=>{const o={...e,style:{...e.style,transformOrigin:lf.transformOrigin.varRef,[lf.arrowSize.var]:l?`${l}px`:void 0,[lf.arrowShadowColor.var]:c},ref:Ur(x,r),children:U?e.children:null,id:I,tabIndex:-1,role:"dialog",onKeyDown:w(e.onKeyDown,(e=>{n&&"Escape"===e.key&&y()})),onBlur:w(e.onBlur,(e=>{const n=Kte(e),r=qte(x.current,n),o=qte(E.current,n);v&&t&&(!r&&!o)&&y()})),"aria-labelledby":S?B:void 0,"aria-describedby":T?R:void 0};return u===Gte.hover&&(o.role="tooltip",o.onMouseEnter=w(e.onMouseEnter,(()=>{k.current=!0})),o.onMouseLeave=w(e.onMouseLeave,(e=>{null!==e.nativeEvent.relatedTarget&&(k.current=!1,setTimeout((()=>y()),p))}))),o}),[U,I,S,B,T,R,u,n,y,v,t,p,c,l]),W=(0,i.useCallback)(((e={},t=null)=>j({...e,style:{visibility:v?"visible":"hidden",...e.style}},t)),[v,j]),V=(0,i.useCallback)(((e,t=null)=>({...e,ref:Ur(t,A,N)})),[A,N]),G=(0,i.useRef)(),Q=(0,i.useRef)(),q=(0,i.useCallback)((e=>{null==A.current&&N(e)}),[N]),K=(0,i.useCallback)(((e={},n=null)=>{const r={...e,ref:Ur(E,n,q),id:P,"aria-haspopup":"dialog","aria-expanded":v,"aria-controls":I};return u===Gte.click&&(r.onClick=w(e.onClick,_)),u===Gte.hover&&(r.onFocus=w(e.onFocus,(()=>{void 0===G.current&&b()})),r.onBlur=w(e.onBlur,(e=>{const n=Kte(e),r=!qte(x.current,n);v&&t&&r&&y()})),r.onKeyDown=w(e.onKeyDown,(e=>{"Escape"===e.key&&y()})),r.onMouseEnter=w(e.onMouseEnter,(()=>{k.current=!0,G.current=window.setTimeout((()=>b()),d)})),r.onMouseLeave=w(e.onMouseLeave,(()=>{k.current=!1,G.current&&(clearTimeout(G.current),G.current=void 0),Q.current=window.setTimeout((()=>{!1===k.current&&y()}),p)}))),r}),[P,v,I,u,q,_,b,t,y,d,p]);(0,i.useEffect)((()=>()=>{G.current&&clearTimeout(G.current),Q.current&&clearTimeout(Q.current)}),[]);const Z=(0,i.useCallback)(((e={},t=null)=>({...e,id:B,ref:Ur(t,(e=>{M(!!e)}))})),[B]),J=(0,i.useCallback)(((e={},t=null)=>({...e,id:R,ref:Ur(t,(e=>{O(!!e)}))})),[R]);return{forceUpdate:$,isOpen:v,onAnimationComplete:H.onComplete,onClose:y,getAnchorProps:V,getArrowProps:F,getArrowInnerProps:Y,getPopoverPositionerProps:W,getPopoverProps:z,getTriggerProps:K,getHeaderProps:Z,getBodyProps:J}}function qte(e,t){return e===t||(null==e?void 0:e.contains(t))}function Kte(e){var t;const n=e.currentTarget.ownerDocument.activeElement;return null!=(t=e.relatedTarget)?t:n}var[Zte,Jte]=xr({name:"PopoverContext",errorMessage:"usePopoverContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Popover />`"}),[Xte,ene]=xr({name:"PopoverStylesContext",errorMessage:"usePopoverStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Popover />\" "});function tne(e){const t=jr("Popover",e),{children:n,...r}=pt(e),o=Qte({...r,direction:Lr().direction});return(0,br.jsx)(Zte,{value:o,children:(0,br.jsx)(Xte,{value:t,children:b(n,{isOpen:o.isOpen,onClose:o.onClose,forceUpdate:o.forceUpdate})})})}function nne(e){const t=i.Children.only(e.children),{getTriggerProps:n}=Jte();return(0,i.cloneElement)(t,n(t.props,t.ref))}function rne(e){if(e)return{enter:{...e.enter,visibility:"visible"},exit:{...e.exit,transitionEnd:{visibility:"hidden"}}}}tne.displayName="Popover",nne.displayName="PopoverTrigger";var one={exit:{opacity:0,scale:.95,transition:{duration:.1,ease:[.4,0,1,1]}},enter:{scale:1,opacity:1,transition:{duration:.15,ease:[0,0,.2,1]}}},ine=vr(Yw.section),ane=yr((function(e,t){const{variants:n=one,...r}=e,{isOpen:o}=Jte();return(0,br.jsx)(ine,{ref:t,variants:rne(n),initial:!1,animate:o?"enter":"exit",...r})}));ane.displayName="PopoverTransition";var sne=yr((function(e,t){const{rootProps:n,motionProps:r,...o}=e,{getPopoverProps:i,getPopoverPositionerProps:a,onAnimationComplete:s}=Jte(),l=ene(),c={position:"relative",display:"flex",flexDirection:"column",...l.content};return(0,br.jsx)(vr.div,{...a(n),__css:l.popper,className:"chakra-popover__popper",children:(0,br.jsx)(ane,{...r,...i(o,t),onAnimationComplete:x(s,o.onAnimationComplete),className:g("chakra-popover__content",e.className),__css:c})})}));sne.displayName="PopoverContent";var lne=yr((function(e,t){const{getBodyProps:n}=Jte(),r=ene();return(0,br.jsx)(vr.div,{...n(e,t),className:g("chakra-popover__body",e.className),__css:r.body})}));lne.displayName="PopoverBody";var cne=["children","triggerElement"];const une=function(e){var r=e.children,o=e.triggerElement,a=t(e,cne);return i.createElement(tne,n({gutter:0},a),i.createElement(nne,null,o),i.createElement(sne,null,i.createElement(lne,null,r)))};function dne(){return dne=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},dne.apply(this,arguments)}function pne(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}var fne=(0,i.forwardRef)((function(e,t){var n=e.color,r=void 0===n?"currentColor":n,o=e.size,a=void 0===o?24:o,s=pne(e,["color","size"]);return i.createElement("svg",dne({ref:t,xmlns:"http://www.w3.org/2000/svg",width:a,height:a,viewBox:"0 0 24 24",fill:"none",stroke:r,strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"},s),i.createElement("path",{d:"M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"}),i.createElement("polyline",{points:"22,6 12,13 2,6"}))}));fne.propTypes={color:Xr().string,size:Xr().oneOfType([Xr().string,Xr().number])},fne.displayName="Mail";const hne=fne;var mne=e=>"checkbox"===e.type,gne=e=>e instanceof Date,vne=e=>null==e;const yne=e=>"object"==typeof e;var bne=e=>!vne(e)&&!Array.isArray(e)&&yne(e)&&!gne(e),_ne=e=>bne(e)&&e.target?mne(e.target)?e.target.checked:e.target.value:e,Ane=(e,t)=>e.has((e=>e.substring(0,e.search(/\.\d+(\.|$)/))||e)(t)),Ene=e=>{const t=e.constructor&&e.constructor.prototype;return bne(t)&&t.hasOwnProperty("isPrototypeOf")},wne="undefined"!=typeof window&&void 0!==window.HTMLElement&&"undefined"!=typeof document;function xne(e){let t;const n=Array.isArray(e);if(e instanceof Date)t=new Date(e);else if(e instanceof Set)t=new Set(e);else{if(wne&&(e instanceof Blob||e instanceof FileList)||!n&&!bne(e))return e;if(t=n?[]:{},n||Ene(e))for(const n in e)e.hasOwnProperty(n)&&(t[n]=xne(e[n]));else t=e}return t}var kne=e=>Array.isArray(e)?e.filter(Boolean):[],Cne=e=>void 0===e,Sne=(e,t,n)=>{if(!t||!bne(e))return n;const r=kne(t.split(/[,[\].]+?/)).reduce(((e,t)=>vne(e)?e:e[t]),e);return Cne(r)||r===e?Cne(e[t])?n:e[t]:r},Mne=e=>"boolean"==typeof e,Tne=e=>/^\w*$/.test(e),One=e=>kne(e.replace(/["|']|\]/g,"").split(/\.|\[/)),Dne=(e,t,n)=>{let r=-1;const o=Tne(t)?[t]:One(t),i=o.length,a=i-1;for(;++r<i;){const t=o[r];let i=n;if(r!==a){const n=e[t];i=bne(n)||Array.isArray(n)?n:isNaN(+o[r+1])?{}:[]}if("__proto__"===t)return;e[t]=i,e=e[t]}return e};const Lne={BLUR:"blur",FOCUS_OUT:"focusout",CHANGE:"change"},Pne={onBlur:"onBlur",onChange:"onChange",onSubmit:"onSubmit",onTouched:"onTouched",all:"all"},Ine="max",Bne="min",Rne="maxLength",Nne="minLength",Fne="pattern",jne="required",Yne="validate",$ne=i.createContext(null),Hne=()=>i.useContext($ne);var Une=(e,t,n,r=!0)=>{const o={defaultValues:t._defaultValues};for(const i in e)Object.defineProperty(o,i,{get:()=>{const o=i;return t._proxyFormState[o]!==Pne.all&&(t._proxyFormState[o]=!r||Pne.all),n&&(n[o]=!0),e[o]}});return o},zne=e=>bne(e)&&!Object.keys(e).length,Wne=(e,t,n,r)=>{n(e);const{name:o,...i}=e;return zne(i)||Object.keys(i).length>=Object.keys(t).length||Object.keys(i).find((e=>t[e]===(!r||Pne.all)))},Vne=e=>Array.isArray(e)?e:[e],Gne=(e,t,n)=>!e||!t||e===t||Vne(e).some((e=>e&&(n?e===t:e.startsWith(t)||t.startsWith(e))));function Qne(e){const t=i.useRef(e);t.current=e,i.useEffect((()=>{const n=!e.disabled&&t.current.subject&&t.current.subject.subscribe({next:t.current.next});return()=>{n&&n.unsubscribe()}}),[e.disabled])}var qne=e=>"string"==typeof e,Kne=(e,t,n,r,o)=>qne(e)?(r&&t.watch.add(e),Sne(n,e,o)):Array.isArray(e)?e.map((e=>(r&&t.watch.add(e),Sne(n,e)))):(r&&(t.watchAll=!0),n);function Zne(e){const t=Hne(),{name:n,disabled:r,control:o=t.control,shouldUnregister:a}=e,s=Ane(o._names.array,n),l=function(e){const t=Hne(),{control:n=t.control,name:r,defaultValue:o,disabled:a,exact:s}=e||{},l=i.useRef(r);l.current=r,Qne({disabled:a,subject:n._subjects.values,next:e=>{Gne(l.current,e.name,s)&&u(xne(Kne(l.current,n._names,e.values||n._formValues,!1,o)))}});const[c,u]=i.useState(n._getWatch(r,o));return i.useEffect((()=>n._removeUnmounted())),c}({control:o,name:n,defaultValue:Sne(o._formValues,n,Sne(o._defaultValues,n,e.defaultValue)),exact:!0}),c=function(e){const t=Hne(),{control:n=t.control,disabled:r,name:o,exact:a}=e||{},[s,l]=i.useState(n._formState),c=i.useRef(!0),u=i.useRef({isDirty:!1,isLoading:!1,dirtyFields:!1,touchedFields:!1,validatingFields:!1,isValidating:!1,isValid:!1,errors:!1}),d=i.useRef(o);return d.current=o,Qne({disabled:r,next:e=>c.current&&Gne(d.current,e.name,a)&&Wne(e,u.current,n._updateFormState)&&l({...n._formState,...e}),subject:n._subjects.state}),i.useEffect((()=>(c.current=!0,u.current.isValid&&n._updateValid(!0),()=>{c.current=!1})),[n]),Une(s,n,u.current,!1)}({control:o,name:n}),u=i.useRef(o.register(n,{...e.rules,value:l,...Mne(e.disabled)?{disabled:e.disabled}:{}}));return i.useEffect((()=>{const e=o._options.shouldUnregister||a,t=(e,t)=>{const n=Sne(o._fields,e);n&&(n._f.mount=t)};if(t(n,!0),e){const e=xne(Sne(o._options.defaultValues,n));Dne(o._defaultValues,n,e),Cne(Sne(o._formValues,n))&&Dne(o._formValues,n,e)}return()=>{(s?e&&!o._state.action:e)?o.unregister(n):t(n,!1)}}),[n,o,s,a]),i.useEffect((()=>{Sne(o._fields,n)&&o._updateDisabledField({disabled:r,fields:o._fields,name:n,value:Sne(o._fields,n)._f.value})}),[r,n,o]),{field:{name:n,value:l,...Mne(r)||c.disabled?{disabled:c.disabled||r}:{},onChange:i.useCallback((e=>u.current.onChange({target:{value:_ne(e),name:n},type:Lne.CHANGE})),[n]),onBlur:i.useCallback((()=>u.current.onBlur({target:{value:Sne(o._formValues,n),name:n},type:Lne.BLUR})),[n,o]),ref:e=>{const t=Sne(o._fields,n);t&&e&&(t._f.ref={focus:()=>e.focus(),select:()=>e.select(),setCustomValidity:t=>e.setCustomValidity(t),reportValidity:()=>e.reportValidity()})}},formState:c,fieldState:Object.defineProperties({},{invalid:{enumerable:!0,get:()=>!!Sne(c.errors,n)},isDirty:{enumerable:!0,get:()=>!!Sne(c.dirtyFields,n)},isTouched:{enumerable:!0,get:()=>!!Sne(c.touchedFields,n)},isValidating:{enumerable:!0,get:()=>!!Sne(c.validatingFields,n)},error:{enumerable:!0,get:()=>Sne(c.errors,n)}})}}const Jne=e=>e.render(Zne(e));var Xne=(e,t,n,r,o)=>t?{...n[e],types:{...n[e]&&n[e].types?n[e].types:{},[r]:o||!0}}:{},ere=e=>({isOnSubmit:!e||e===Pne.onSubmit,isOnBlur:e===Pne.onBlur,isOnChange:e===Pne.onChange,isOnAll:e===Pne.all,isOnTouch:e===Pne.onTouched}),tre=(e,t,n)=>!n&&(t.watchAll||t.watch.has(e)||[...t.watch].some((t=>e.startsWith(t)&&/^\.\w+/.test(e.slice(t.length)))));const nre=(e,t,n,r)=>{for(const o of n||Object.keys(e)){const n=Sne(e,o);if(n){const{_f:e,...i}=n;if(e){if(e.refs&&e.refs[0]&&t(e.refs[0],o)&&!r)break;if(e.ref&&t(e.ref,e.name)&&!r)break;nre(i,t)}else bne(i)&&nre(i,t)}}};var rre=(e,t,n)=>{const r=kne(Sne(e,n));return Dne(r,"root",t[n]),Dne(e,n,r),e},ore=e=>"file"===e.type,ire=e=>"function"==typeof e,are=e=>{if(!wne)return!1;const t=e?e.ownerDocument:0;return e instanceof(t&&t.defaultView?t.defaultView.HTMLElement:HTMLElement)},sre=e=>qne(e),lre=e=>"radio"===e.type,cre=e=>e instanceof RegExp;const ure={value:!1,isValid:!1},dre={value:!0,isValid:!0};var pre=e=>{if(Array.isArray(e)){if(e.length>1){const t=e.filter((e=>e&&e.checked&&!e.disabled)).map((e=>e.value));return{value:t,isValid:!!t.length}}return e[0].checked&&!e[0].disabled?e[0].attributes&&!Cne(e[0].attributes.value)?Cne(e[0].value)||""===e[0].value?dre:{value:e[0].value,isValid:!0}:dre:ure}return ure};const fre={isValid:!1,value:null};var hre=e=>Array.isArray(e)?e.reduce(((e,t)=>t&&t.checked&&!t.disabled?{isValid:!0,value:t.value}:e),fre):fre;function mre(e,t,n="validate"){if(sre(e)||Array.isArray(e)&&e.every(sre)||Mne(e)&&!e)return{type:n,message:sre(e)?e:"",ref:t}}var gre=e=>bne(e)&&!cre(e)?e:{value:e,message:""},vre=async(e,t,n,r,o)=>{const{ref:i,refs:a,required:s,maxLength:l,minLength:c,min:u,max:d,pattern:p,validate:f,name:h,valueAsNumber:m,mount:g,disabled:v}=e._f,y=Sne(t,h);if(!g||v)return{};const b=a?a[0]:i,_=e=>{r&&b.reportValidity&&(b.setCustomValidity(Mne(e)?"":e||""),b.reportValidity())},A={},E=lre(i),w=mne(i),x=E||w,k=(m||ore(i))&&Cne(i.value)&&Cne(y)||are(i)&&""===i.value||""===y||Array.isArray(y)&&!y.length,C=Xne.bind(null,h,n,A),S=(e,t,n,r=Rne,o=Nne)=>{const a=e?t:n;A[h]={type:e?r:o,message:a,ref:i,...C(e?r:o,a)}};if(o?!Array.isArray(y)||!y.length:s&&(!x&&(k||vne(y))||Mne(y)&&!y||w&&!pre(a).isValid||E&&!hre(a).isValid)){const{value:e,message:t}=sre(s)?{value:!!s,message:s}:gre(s);if(e&&(A[h]={type:jne,message:t,ref:b,...C(jne,t)},!n))return _(t),A}if(!(k||vne(u)&&vne(d))){let e,t;const r=gre(d),o=gre(u);if(vne(y)||isNaN(y)){const n=i.valueAsDate||new Date(y),a=e=>new Date((new Date).toDateString()+" "+e),s="time"==i.type,l="week"==i.type;qne(r.value)&&y&&(e=s?a(y)>a(r.value):l?y>r.value:n>new Date(r.value)),qne(o.value)&&y&&(t=s?a(y)<a(o.value):l?y<o.value:n<new Date(o.value))}else{const n=i.valueAsNumber||(y?+y:y);vne(r.value)||(e=n>r.value),vne(o.value)||(t=n<o.value)}if((e||t)&&(S(!!e,r.message,o.message,Ine,Bne),!n))return _(A[h].message),A}if((l||c)&&!k&&(qne(y)||o&&Array.isArray(y))){const e=gre(l),t=gre(c),r=!vne(e.value)&&y.length>+e.value,o=!vne(t.value)&&y.length<+t.value;if((r||o)&&(S(r,e.message,t.message),!n))return _(A[h].message),A}if(p&&!k&&qne(y)){const{value:e,message:t}=gre(p);if(cre(e)&&!y.match(e)&&(A[h]={type:Fne,message:t,ref:i,...C(Fne,t)},!n))return _(t),A}if(f)if(ire(f)){const e=mre(await f(y,t),b);if(e&&(A[h]={...e,...C(Yne,e.message)},!n))return _(e.message),A}else if(bne(f)){let e={};for(const r in f){if(!zne(e)&&!n)break;const o=mre(await f[r](y,t),b,r);o&&(e={...o,...C(r,o.message)},_(o.message),n&&(A[h]=e))}if(!zne(e)&&(A[h]={ref:b,...e},!n))return A}return _(!0),A};function yre(e,t){const n=Array.isArray(t)?t:Tne(t)?[t]:One(t),r=1===n.length?e:function(e,t){const n=t.slice(0,-1).length;let r=0;for(;r<n;)e=Cne(e)?r++:e[t[r++]];return e}(e,n),o=n.length-1,i=n[o];return r&&delete r[i],0!==o&&(bne(r)&&zne(r)||Array.isArray(r)&&function(e){for(const t in e)if(e.hasOwnProperty(t)&&!Cne(e[t]))return!1;return!0}(r))&&yre(e,n.slice(0,-1)),e}var bre=()=>{let e=[];return{get observers(){return e},next:t=>{for(const n of e)n.next&&n.next(t)},subscribe:t=>(e.push(t),{unsubscribe:()=>{e=e.filter((e=>e!==t))}}),unsubscribe:()=>{e=[]}}},_re=e=>vne(e)||!yne(e);function Are(e,t){if(_re(e)||_re(t))return e===t;if(gne(e)&&gne(t))return e.getTime()===t.getTime();const n=Object.keys(e),r=Object.keys(t);if(n.length!==r.length)return!1;for(const o of n){const n=e[o];if(!r.includes(o))return!1;if("ref"!==o){const e=t[o];if(gne(n)&&gne(e)||bne(n)&&bne(e)||Array.isArray(n)&&Array.isArray(e)?!Are(n,e):n!==e)return!1}}return!0}var Ere=e=>"select-multiple"===e.type,wre=e=>lre(e)||mne(e),xre=e=>are(e)&&e.isConnected,kre=e=>{for(const t in e)if(ire(e[t]))return!0;return!1};function Cre(e,t={}){const n=Array.isArray(e);if(bne(e)||n)for(const n in e)Array.isArray(e[n])||bne(e[n])&&!kre(e[n])?(t[n]=Array.isArray(e[n])?[]:{},Cre(e[n],t[n])):vne(e[n])||(t[n]=!0);return t}function Sre(e,t,n){const r=Array.isArray(e);if(bne(e)||r)for(const r in e)Array.isArray(e[r])||bne(e[r])&&!kre(e[r])?Cne(t)||_re(n[r])?n[r]=Array.isArray(e[r])?Cre(e[r],[]):{...Cre(e[r])}:Sre(e[r],vne(t)?{}:t[r],n[r]):n[r]=!Are(e[r],t[r]);return n}var Mre=(e,t)=>Sre(e,t,Cre(t)),Tre=(e,{valueAsNumber:t,valueAsDate:n,setValueAs:r})=>Cne(e)?e:t?""===e?NaN:e?+e:e:n&&qne(e)?new Date(e):r?r(e):e;function Ore(e){const t=e.ref;if(!(e.refs?e.refs.every((e=>e.disabled)):t.disabled))return ore(t)?t.files:lre(t)?hre(e.refs).value:Ere(t)?[...t.selectedOptions].map((({value:e})=>e)):mne(t)?pre(e.refs).value:Tre(Cne(t.value)?e.ref.value:t.value,e)}var Dre=(e,t,n,r)=>{const o={};for(const n of e){const e=Sne(t,n);e&&Dne(o,n,e._f)}return{criteriaMode:n,names:[...e],fields:o,shouldUseNativeValidation:r}},Lre=e=>Cne(e)?e:cre(e)?e.source:bne(e)?cre(e.value)?e.value.source:e.value:e,Pre=e=>e.mount&&(e.required||e.min||e.max||e.maxLength||e.minLength||e.pattern||e.validate);function Ire(e,t,n){const r=Sne(e,n);if(r||Tne(n))return{error:r,name:n};const o=n.split(".");for(;o.length;){const r=o.join("."),i=Sne(t,r),a=Sne(e,r);if(i&&!Array.isArray(i)&&n!==r)return{name:n};if(a&&a.type)return{name:r,error:a};o.pop()}return{name:n}}var Bre=(e,t,n,r,o)=>!o.isOnAll&&(!n&&o.isOnTouch?!(t||e):(n?r.isOnBlur:o.isOnBlur)?!e:!(n?r.isOnChange:o.isOnChange)||e),Rre=(e,t)=>!kne(Sne(e,t)).length&&yre(e,t);const Nre={mode:Pne.onSubmit,reValidateMode:Pne.onChange,shouldFocusError:!0};function Fre(e={}){let t,n={...Nre,...e},r={submitCount:0,isDirty:!1,isLoading:ire(n.defaultValues),isValidating:!1,isSubmitted:!1,isSubmitting:!1,isSubmitSuccessful:!1,isValid:!1,touchedFields:{},dirtyFields:{},validatingFields:{},errors:n.errors||{},disabled:n.disabled||!1},o={},i=(bne(n.defaultValues)||bne(n.values))&&xne(n.defaultValues||n.values)||{},a=n.shouldUnregister?{}:xne(i),s={action:!1,mount:!1,watch:!1},l={mount:new Set,unMount:new Set,array:new Set,watch:new Set},c=0;const u={isDirty:!1,dirtyFields:!1,validatingFields:!1,touchedFields:!1,isValidating:!1,isValid:!1,errors:!1},d={values:bre(),array:bre(),state:bre()},p=ere(n.mode),f=ere(n.reValidateMode),h=n.criteriaMode===Pne.all,m=async e=>{if(u.isValid||e){const e=n.resolver?zne((await _()).errors):await A(o,!0);e!==r.isValid&&d.state.next({isValid:e})}},g=(e,t)=>{(u.isValidating||u.validatingFields)&&((e||Array.from(l.mount)).forEach((e=>{e&&(t?Dne(r.validatingFields,e,t):yre(r.validatingFields,e))})),d.state.next({validatingFields:r.validatingFields,isValidating:!zne(r.validatingFields)}))},v=(e,t,n,r)=>{const l=Sne(o,e);if(l){const o=Sne(a,e,Cne(n)?Sne(i,e):n);Cne(o)||r&&r.defaultChecked||t?Dne(a,e,t?o:Ore(l._f)):x(e,o),s.mount&&m()}},y=(e,t,n,a,s)=>{let l=!1,c=!1;const p={name:e},f=!(!Sne(o,e)||!Sne(o,e)._f.disabled);if(!n||a){u.isDirty&&(c=r.isDirty,r.isDirty=p.isDirty=E(),l=c!==p.isDirty);const n=f||Are(Sne(i,e),t);c=!(f||!Sne(r.dirtyFields,e)),n||f?yre(r.dirtyFields,e):Dne(r.dirtyFields,e,!0),p.dirtyFields=r.dirtyFields,l=l||u.dirtyFields&&c!==!n}if(n){const t=Sne(r.touchedFields,e);t||(Dne(r.touchedFields,e,n),p.touchedFields=r.touchedFields,l=l||u.touchedFields&&t!==n)}return l&&s&&d.state.next(p),l?p:{}},b=(n,o,i,a)=>{const s=Sne(r.errors,n),l=u.isValid&&Mne(o)&&r.isValid!==o;var p;if(e.delayError&&i?(p=()=>((e,t)=>{Dne(r.errors,e,t),d.state.next({errors:r.errors})})(n,i),t=e=>{clearTimeout(c),c=setTimeout(p,e)},t(e.delayError)):(clearTimeout(c),t=null,i?Dne(r.errors,n,i):yre(r.errors,n)),(i?!Are(s,i):s)||!zne(a)||l){const e={...a,...l&&Mne(o)?{isValid:o}:{},errors:r.errors,name:n};r={...r,...e},d.state.next(e)}},_=async e=>{g(e,!0);const t=await n.resolver(a,n.context,Dre(e||l.mount,o,n.criteriaMode,n.shouldUseNativeValidation));return g(e),t},A=async(e,t,o={valid:!0})=>{for(const i in e){const s=e[i];if(s){const{_f:e,...c}=s;if(e){const c=l.array.has(e.name);g([i],!0);const u=await vre(s,a,h,n.shouldUseNativeValidation&&!t,c);if(g([i]),u[e.name]&&(o.valid=!1,t))break;!t&&(Sne(u,e.name)?c?rre(r.errors,u,e.name):Dne(r.errors,e.name,u[e.name]):yre(r.errors,e.name))}c&&await A(c,t,o)}}return o.valid},E=(e,t)=>(e&&t&&Dne(a,e,t),!Are(O(),i)),w=(e,t,n)=>Kne(e,l,{...s.mount?a:Cne(t)?i:qne(e)?{[e]:t}:t},n,t),x=(e,t,n={})=>{const r=Sne(o,e);let i=t;if(r){const n=r._f;n&&(!n.disabled&&Dne(a,e,Tre(t,n)),i=are(n.ref)&&vne(t)?"":t,Ere(n.ref)?[...n.ref.options].forEach((e=>e.selected=i.includes(e.value))):n.refs?mne(n.ref)?n.refs.length>1?n.refs.forEach((e=>(!e.defaultChecked||!e.disabled)&&(e.checked=Array.isArray(i)?!!i.find((t=>t===e.value)):i===e.value))):n.refs[0]&&(n.refs[0].checked=!!i):n.refs.forEach((e=>e.checked=e.value===i)):ore(n.ref)?n.ref.value="":(n.ref.value=i,n.ref.type||d.values.next({name:e,values:{...a}})))}(n.shouldDirty||n.shouldTouch)&&y(e,i,n.shouldTouch,n.shouldDirty,!0),n.shouldValidate&&T(e)},k=(e,t,n)=>{for(const r in t){const i=t[r],a=`${e}.${r}`,s=Sne(o,a);!l.array.has(e)&&_re(i)&&(!s||s._f)||gne(i)?x(a,i,n):k(a,i,n)}},C=(e,t,n={})=>{const c=Sne(o,e),p=l.array.has(e),f=xne(t);Dne(a,e,f),p?(d.array.next({name:e,values:{...a}}),(u.isDirty||u.dirtyFields)&&n.shouldDirty&&d.state.next({name:e,dirtyFields:Mre(i,a),isDirty:E(e,f)})):!c||c._f||vne(f)?x(e,f,n):k(e,f,n),tre(e,l)&&d.state.next({...r}),d.values.next({name:s.mount?e:void 0,values:{...a}})},S=async e=>{s.mount=!0;const i=e.target;let c=i.name,v=!0;const E=Sne(o,c),w=e=>{v=Number.isNaN(e)||e===Sne(a,c,e)};if(E){let s,x;const k=i.type?Ore(E._f):_ne(e),C=e.type===Lne.BLUR||e.type===Lne.FOCUS_OUT,S=!Pre(E._f)&&!n.resolver&&!Sne(r.errors,c)&&!E._f.deps||Bre(C,Sne(r.touchedFields,c),r.isSubmitted,f,p),M=tre(c,l,C);Dne(a,c,k),C?(E._f.onBlur&&E._f.onBlur(e),t&&t(0)):E._f.onChange&&E._f.onChange(e);const O=y(c,k,C,!1),D=!zne(O)||M;if(!C&&d.values.next({name:c,type:e.type,values:{...a}}),S)return u.isValid&&m(),D&&d.state.next({name:c,...M?{}:O});if(!C&&M&&d.state.next({...r}),n.resolver){const{errors:e}=await _([c]);if(w(k),v){const t=Ire(r.errors,o,c),n=Ire(e,o,t.name||c);s=n.error,c=n.name,x=zne(e)}}else g([c],!0),s=(await vre(E,a,h,n.shouldUseNativeValidation))[c],g([c]),w(k),v&&(s?x=!1:u.isValid&&(x=await A(o,!0)));v&&(E._f.deps&&T(E._f.deps),b(c,x,s,O))}},M=(e,t)=>{if(Sne(r.errors,t)&&e.focus)return e.focus(),1},T=async(e,t={})=>{let i,a;const s=Vne(e);if(n.resolver){const t=await(async e=>{const{errors:t}=await _(e);if(e)for(const n of e){const e=Sne(t,n);e?Dne(r.errors,n,e):yre(r.errors,n)}else r.errors=t;return t})(Cne(e)?e:s);i=zne(t),a=e?!s.some((e=>Sne(t,e))):i}else e?(a=(await Promise.all(s.map((async e=>{const t=Sne(o,e);return await A(t&&t._f?{[e]:t}:t)})))).every(Boolean),(a||r.isValid)&&m()):a=i=await A(o);return d.state.next({...!qne(e)||u.isValid&&i!==r.isValid?{}:{name:e},...n.resolver||!e?{isValid:i}:{},errors:r.errors}),t.shouldFocus&&!a&&nre(o,M,e?s:l.mount),a},O=e=>{const t={...s.mount?a:i};return Cne(e)?t:qne(e)?Sne(t,e):e.map((e=>Sne(t,e)))},D=(e,t)=>({invalid:!!Sne((t||r).errors,e),isDirty:!!Sne((t||r).dirtyFields,e),isTouched:!!Sne((t||r).touchedFields,e),isValidating:!!Sne((t||r).validatingFields,e),error:Sne((t||r).errors,e)}),L=(e,t,n)=>{const i=(Sne(o,e,{_f:{}})._f||{}).ref,a=Sne(r.errors,e)||{},{ref:s,message:l,type:c,...u}=a;Dne(r.errors,e,{...u,...t,ref:i}),d.state.next({name:e,errors:r.errors,isValid:!1}),n&&n.shouldFocus&&i&&i.focus&&i.focus()},P=(e,t={})=>{for(const s of e?Vne(e):l.mount)l.mount.delete(s),l.array.delete(s),t.keepValue||(yre(o,s),yre(a,s)),!t.keepError&&yre(r.errors,s),!t.keepDirty&&yre(r.dirtyFields,s),!t.keepTouched&&yre(r.touchedFields,s),!t.keepIsValidating&&yre(r.validatingFields,s),!n.shouldUnregister&&!t.keepDefaultValue&&yre(i,s);d.values.next({values:{...a}}),d.state.next({...r,...t.keepDirty?{isDirty:E()}:{}}),!t.keepIsValid&&m()},I=({disabled:e,name:t,field:n,fields:r,value:o})=>{if(Mne(e)&&s.mount||e){const i=e?void 0:Cne(o)?Ore(n?n._f:Sne(r,t)._f):o;Dne(a,t,i),y(t,i,!1,!1,!0)}},B=(e,t={})=>{let r=Sne(o,e);const a=Mne(t.disabled);return Dne(o,e,{...r||{},_f:{...r&&r._f?r._f:{ref:{name:e}},name:e,mount:!0,...t}}),l.mount.add(e),r?I({field:r,disabled:t.disabled,name:e,value:t.value}):v(e,!0,t.value),{...a?{disabled:t.disabled}:{},...n.progressive?{required:!!t.required,min:Lre(t.min),max:Lre(t.max),minLength:Lre(t.minLength),maxLength:Lre(t.maxLength),pattern:Lre(t.pattern)}:{},name:e,onChange:S,onBlur:S,ref:a=>{if(a){B(e,t),r=Sne(o,e);const n=Cne(a.value)&&a.querySelectorAll&&a.querySelectorAll("input,select,textarea")[0]||a,s=wre(n),l=r._f.refs||[];if(s?l.find((e=>e===n)):n===r._f.ref)return;Dne(o,e,{_f:{...r._f,...s?{refs:[...l.filter(xre),n,...Array.isArray(Sne(i,e))?[{}]:[]],ref:{type:n.type,name:e}}:{ref:n}}}),v(e,!1,void 0,n)}else r=Sne(o,e,{}),r._f&&(r._f.mount=!1),(n.shouldUnregister||t.shouldUnregister)&&(!Ane(l.array,e)||!s.action)&&l.unMount.add(e)}}},R=()=>n.shouldFocusError&&nre(o,M,l.mount),N=(e,t)=>async i=>{let s;i&&(i.preventDefault&&i.preventDefault(),i.persist&&i.persist());let l=xne(a);if(d.state.next({isSubmitting:!0}),n.resolver){const{errors:e,values:t}=await _();r.errors=e,l=t}else await A(o);if(yre(r.errors,"root"),zne(r.errors)){d.state.next({errors:{}});try{await e(l,i)}catch(e){s=e}}else t&&await t({...r.errors},i),R(),setTimeout(R);if(d.state.next({isSubmitted:!0,isSubmitting:!1,isSubmitSuccessful:zne(r.errors)&&!s,submitCount:r.submitCount+1,errors:r.errors}),s)throw s},F=(t,n={})=>{const c=t?xne(t):i,p=xne(c),f=zne(t),h=f?i:p;if(n.keepDefaultValues||(i=c),!n.keepValues){if(n.keepDirtyValues)for(const e of l.mount)Sne(r.dirtyFields,e)?Dne(h,e,Sne(a,e)):C(e,Sne(h,e));else{if(wne&&Cne(t))for(const e of l.mount){const t=Sne(o,e);if(t&&t._f){const e=Array.isArray(t._f.refs)?t._f.refs[0]:t._f.ref;if(are(e)){const t=e.closest("form");if(t){t.reset();break}}}}o={}}a=e.shouldUnregister?n.keepDefaultValues?xne(i):{}:xne(h),d.array.next({values:{...h}}),d.values.next({values:{...h}})}l={mount:n.keepDirtyValues?l.mount:new Set,unMount:new Set,array:new Set,watch:new Set,watchAll:!1,focus:""},s.mount=!u.isValid||!!n.keepIsValid||!!n.keepDirtyValues,s.watch=!!e.shouldUnregister,d.state.next({submitCount:n.keepSubmitCount?r.submitCount:0,isDirty:!f&&(n.keepDirty?r.isDirty:!(!n.keepDefaultValues||Are(t,i))),isSubmitted:!!n.keepIsSubmitted&&r.isSubmitted,dirtyFields:f?[]:n.keepDirtyValues?n.keepDefaultValues&&a?Mre(i,a):r.dirtyFields:n.keepDefaultValues&&t?Mre(i,t):{},touchedFields:n.keepTouched?r.touchedFields:{},errors:n.keepErrors?r.errors:{},isSubmitSuccessful:!!n.keepIsSubmitSuccessful&&r.isSubmitSuccessful,isSubmitting:!1})},j=(e,t)=>F(ire(e)?e(a):e,t);return{control:{register:B,unregister:P,getFieldState:D,handleSubmit:N,setError:L,_executeSchema:_,_getWatch:w,_getDirty:E,_updateValid:m,_removeUnmounted:()=>{for(const e of l.unMount){const t=Sne(o,e);t&&(t._f.refs?t._f.refs.every((e=>!xre(e))):!xre(t._f.ref))&&P(e)}l.unMount=new Set},_updateFieldArray:(e,t=[],n,l,c=!0,p=!0)=>{if(l&&n){if(s.action=!0,p&&Array.isArray(Sne(o,e))){const t=n(Sne(o,e),l.argA,l.argB);c&&Dne(o,e,t)}if(p&&Array.isArray(Sne(r.errors,e))){const t=n(Sne(r.errors,e),l.argA,l.argB);c&&Dne(r.errors,e,t),Rre(r.errors,e)}if(u.touchedFields&&p&&Array.isArray(Sne(r.touchedFields,e))){const t=n(Sne(r.touchedFields,e),l.argA,l.argB);c&&Dne(r.touchedFields,e,t)}u.dirtyFields&&(r.dirtyFields=Mre(i,a)),d.state.next({name:e,isDirty:E(e,t),dirtyFields:r.dirtyFields,errors:r.errors,isValid:r.isValid})}else Dne(a,e,t)},_updateDisabledField:I,_getFieldArray:t=>kne(Sne(s.mount?a:i,t,e.shouldUnregister?Sne(i,t,[]):[])),_reset:F,_resetDefaultValues:()=>ire(n.defaultValues)&&n.defaultValues().then((e=>{j(e,n.resetOptions),d.state.next({isLoading:!1})})),_updateFormState:e=>{r={...r,...e}},_disableForm:e=>{Mne(e)&&(d.state.next({disabled:e}),nre(o,((t,n)=>{const r=Sne(o,n);r&&(t.disabled=r._f.disabled||e,Array.isArray(r._f.refs)&&r._f.refs.forEach((t=>{t.disabled=r._f.disabled||e})))}),0,!1))},_subjects:d,_proxyFormState:u,_setErrors:e=>{r.errors=e,d.state.next({errors:r.errors,isValid:!1})},get _fields(){return o},get _formValues(){return a},get _state(){return s},set _state(e){s=e},get _defaultValues(){return i},get _names(){return l},set _names(e){l=e},get _formState(){return r},set _formState(e){r=e},get _options(){return n},set _options(e){n={...n,...e}}},trigger:T,register:B,handleSubmit:N,watch:(e,t)=>ire(e)?d.values.subscribe({next:n=>e(w(void 0,t),n)}):w(e,t,!0),setValue:C,getValues:O,reset:j,resetField:(e,t={})=>{Sne(o,e)&&(Cne(t.defaultValue)?C(e,xne(Sne(i,e))):(C(e,t.defaultValue),Dne(i,e,xne(t.defaultValue))),t.keepTouched||yre(r.touchedFields,e),t.keepDirty||(yre(r.dirtyFields,e),r.isDirty=t.defaultValue?E(e,xne(Sne(i,e))):E()),t.keepError||(yre(r.errors,e),u.isValid&&m()),d.state.next({...r}))},clearErrors:e=>{e&&Vne(e).forEach((e=>yre(r.errors,e))),d.state.next({errors:e?r.errors:{}})},unregister:P,setError:L,setFocus:(e,t={})=>{const n=Sne(o,e),r=n&&n._f;if(r){const e=r.refs?r.refs[0]:r.ref;e.focus&&(e.focus(),t.shouldSelect&&e.select())}},getFieldState:D}}function jre(e={}){const t=i.useRef(),n=i.useRef(),[r,o]=i.useState({isDirty:!1,isValidating:!1,isLoading:ire(e.defaultValues),isSubmitted:!1,isSubmitting:!1,isSubmitSuccessful:!1,isValid:!1,submitCount:0,dirtyFields:{},touchedFields:{},validatingFields:{},errors:e.errors||{},disabled:e.disabled||!1,defaultValues:ire(e.defaultValues)?void 0:e.defaultValues});t.current||(t.current={...Fre(e),formState:r});const a=t.current.control;return a._options=e,Qne({subject:a._subjects.state,next:e=>{Wne(e,a._proxyFormState,a._updateFormState,!0)&&o({...a._formState})}}),i.useEffect((()=>a._disableForm(e.disabled)),[a,e.disabled]),i.useEffect((()=>{if(a._proxyFormState.isDirty){const e=a._getDirty();e!==r.isDirty&&a._subjects.state.next({isDirty:e})}}),[a,r.isDirty]),i.useEffect((()=>{e.values&&!Are(e.values,n.current)?(a._reset(e.values,a._options.resetOptions),n.current=e.values,o((e=>({...e})))):a._resetDefaultValues()}),[e.values,a]),i.useEffect((()=>{e.errors&&a._setErrors(e.errors)}),[e.errors,a]),i.useEffect((()=>{a._state.mount||(a._updateValid(),a._state.mount=!0),a._state.watch&&(a._state.watch=!1,a._subjects.state.next({...a._formState})),a._removeUnmounted()})),i.useEffect((()=>{e.shouldUnregister&&a._subjects.values.next({values:a._getWatch()})}),[e.shouldUnregister,a]),t.current.formState=Une(r,a),t.current}function Yre(){return Yre=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Yre.apply(this,arguments)}function $re(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}var Hre=(0,i.forwardRef)((function(e,t){var n=e.color,r=void 0===n?"currentColor":n,o=e.size,a=void 0===o?24:o,s=$re(e,["color","size"]);return i.createElement("svg",Yre({ref:t,xmlns:"http://www.w3.org/2000/svg",width:a,height:a,viewBox:"0 0 24 24",fill:"none",stroke:r,strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"},s),i.createElement("circle",{cx:"12",cy:"12",r:"10"}),i.createElement("line",{x1:"12",y1:"8",x2:"12",y2:"12"}),i.createElement("line",{x1:"12",y1:"16",x2:"12.01",y2:"16"}))}));Hre.propTypes={color:Xr().string,size:Xr().oneOfType([Xr().string,Xr().number])},Hre.displayName="AlertCircle";const Ure=Hre;const zre=function(e){var t=e.children;return i.createElement(tJ,null,i.createElement(Ure,{size:"1rem",style:{marginRight:"0.25rem"}}),t)};var Wre=["icon","size"];const Vre=function(e){var r=e.icon,o=e.size,a=void 0===o?"md":o,s=t(e,Wre),l="xl"===a?"20px":"lg"===a?"10px":"6px",c="xl"===a?"42px":"lg"===a?"15px":"8px",u="xl"===a?"55px":"lg"===a?"40px":"24px";return i.createElement(wr,{alignItems:"center",backgroundColor:"brand.primaryLight",borderRadius:"50%",justifyContent:"center",padding:l},i.createElement(wr,{alignItems:"center",backgroundColor:"brand.primaryMedium",borderRadius:"50%",justifyContent:"center",padding:c},i.createElement(Jk,n({width:u,height:u,color:"brand.primary",display:"block",as:r},s))))};const Gre=function(e){var t=e.headerSubText,n=e.modalIcon,r=e.headerText;return i.createElement(wr,{alignItems:"flex-start",flexDirection:"column"},i.createElement(Vre,{icon:n}),i.createElement(tq,{as:"h2",size:"lg",variant:"primary",paddingTop:"16px"},r),t&&i.createElement(qr,{paddingTop:"8px"},t))};const Qre=function(e){var t=e.errors;return t?i.createElement(_r,null,Object.values(t).map((function(e){return i.createElement(qr,{key:e,variant:"error"},e)}))):null};var qre=function(e){var t=e.onSubmit,r=e.onClose,o=e.translate,a=m((0,i.useState)({}),2),s=a[0],l=a[1],c=Dte({type:"favorites_sent",translateFilter:o}),u=u9({base:!0,lg:!1}),d=u9({base:void 0,lg:"300px"}),p=jre({mode:"onTouched"}),f=p.formState,h=f.errors,g=f.isSubmitting,v=f.isValid,y=p.handleSubmit,b=p.register,_=(0,i.useCallback)((function(e){var n=e.fromName,o=e.toEmail,i=e.message;return new Promise((function(e){t(n,o,i,(function(){e(),r(),c()}),(function(t){e(),l(t)}))}))}),[c,r,t]);return i.createElement(wr,{height:"full",flexDirection:"column"},i.createElement(Gre,{modalIcon:hne,headerText:o("shareFavoritesLabel"),headerSubText:o("shareFavoritesSubtext")}),i.createElement(wr,{as:"form",onSubmit:y(_),flexDirection:"column",justifyContent:"space-between",flexGrow:1,paddingTop:"20px"},i.createElement(wr,{flexDirection:"column",flexGrow:1},i.createElement(Mp,{isInvalid:Boolean(h.fromName),isRequired:!0},i.createElement(Xp,null,o("favoritesFromNameLabel")),i.createElement(dz,b("fromName",{required:o("favoritesFromNameRequired")})),h.fromName&&i.createElement(zre,null,h.fromName.message),i.createElement(Qre,{errors:s.from_name})),i.createElement(Mp,{isInvalid:Boolean(h.toEmail),isRequired:!0},i.createElement(Xp,null,o("favoritesToEmailLabel")),i.createElement(dz,b("toEmail",{required:o("emailAddressInvalid"),pattern:{value:VT,message:o("emailAddressInvalid")}})),h.toEmail&&i.createElement(zre,null,h.toEmail.message),i.createElement(Qre,{errors:s.to_email})),i.createElement(Mp,{isInvalid:Boolean(h.message),flexGrow:1,display:"flex",flexDirection:"column"},i.createElement(Xp,null,o("favoritesMessageLabel")),i.createElement(rW,n({},b("message",{required:!1}),{flexGrow:1,height:d,maxHeight:"300px"})),h.message&&i.createElement(zre,null,h.message.message),i.createElement(Qre,{errors:s.message}))),i.createElement(nte,{isDisabled:!v,fullWidth:u,minWidth:232,alignSelf:"center",isLoading:g,text:o("send"),textLarge:o("send"),variant:"primary",type:"submit"})))};const Kre=function(e){var t=e.onSubmit,n=e.isOpen,r=e.onClose,o=e.translate;return i.createElement(Fte,{isOpen:n,onClose:r},i.createElement(qre,{onSubmit:t,onClose:r,translate:o}))};const Zre=function(e){var t=e.isOpen,n=e.onSubmit,r=e.onClose,o=e.translate,a=m((0,i.useState)("input"),2),s=a[0],l=a[1],c=m((0,i.useState)(""),2),u=c[0],d=c[1],p=Dte({type:"favorites_sent",translateFilter:o}),f=u9({base:!0,lg:!1}),h=(0,i.useCallback)((function(){l("input"),r()}),[r,l]),g=(0,i.useCallback)((function(){l("submitting"),n(u,(function(){h(),d(""),p()}))}),[p,h,u,n]);return i.createElement(Fte,{isOpen:t,onClose:h},i.createElement(wr,{flexDirection:"column",height:"full",gap:"24px"},i.createElement(Gre,{modalIcon:Yee,headerText:o("sendFavoritesToPhotographer"),headerSubText:o("sendFavoritesToPhotographerSubtext")}),i.createElement(Mp,{flexGrow:1},i.createElement(Xp,null,o("favoritesMessageLabel")),i.createElement(rW,{height:"300px",value:u,onChange:function(e){d(e.target.value)}})),i.createElement(nte,{fullWidth:f,minWidth:232,alignSelf:"center",isLoading:"submitting"===s,text:o("send"),textLarge:o("send"),variant:"primary",type:"submit",onClick:g})))};var Jre="-2 -2 28 28";const Xre=function(e){var t=e.isLargeScreen,r=e.isOnlySingleActionOnSmallScreen,o=e.actions,a=o.canBuyAll,s=o.buyAll,l=o.canBuyPackage,c=o.buyPackage,u=o.canComparePhotos,d=o.comparePhotos,p=o.canDownloadAll,f=o.downloadAll,h=o.setDownloadDestination,g=o.getRemainingDownloads,v=o.cancelDownload,y=o.canShare,b=o.emailFavorites,_=o.canSendFavoritesToPhotographer,A=o.sendFavoritesToPhotographer,E=o.canStartSlideshow,w=o.startSlideshow,x=e.requiresDownloadDestination,k=e.selectedUri,C=e.shareCopyLinkUrl,S=e.shareUrls,M=e.spFreeDigitals,T=e.translate,O=m((0,i.useState)(),2),D=O[0],L=O[1],P=m((0,i.useState)(!1),2),I=P[0],B=P[1],R=m((0,i.useState)(!1),2),N=R[0],F=R[1];(0,i.useEffect)((function(){x&&L("download destinations")}),[x]);var j=(0,i.useCallback)((function(){f(),x&&L("download destinations")}),[f,x]),Y=function(){var e=[],n=[],o=r?1:2,f="favorites"===k;function h(r){t||e.length<o?t?e.unshift(r):e.push(r):n.unshift(r)}a()&&h({key:"buyAllPhotos",icon:i.createElement(Lee,{width:"24px",viewBox:Jre}),text:T("buyAllPhotos"),onClick:s}),l()&&h({key:"buyPackage",icon:i.createElement(V9,{width:"24px"}),text:T("buyPackage"),onClick:c}),p()&&h({key:"downloadAll",icon:i.createElement(Ree,{width:"24px",viewBox:Jre}),text:T("downloadAll"),keepOpen:x,onClick:j});var m=f?y()&&function(){L("send favorites")}:S&&function(){L("share links")};return m&&h({key:f?"sendFavorites":"share",icon:f?i.createElement(Yee,{width:"24px",viewBox:Jre}):i.createElement(s7,{width:"24px"}),text:T(f?"sendFavorites":"share"),keepOpen:!0,onClick:m}),u()&&h({key:"comparePhotos",icon:i.createElement(m8,{width:"24px"}),text:T("comparePhotos"),onClick:d}),E()&&h({key:"slideshow",icon:i.createElement(p7,{width:"24px",viewBox:"2 0 20 24"}),text:T("slideshow"),onClick:w}),{toolbarActions:e,drawerActions:n}}(),$=Y.toolbarActions,H=Y.drawerActions,U=function(){L(void 0)},z=function(){U(),v()},W=(0,i.useMemo)((function(){var e=[{key:"sendFavoritesToOther",text:T("sendFavoritesToOther"),onClick:function(){return B(!0)}}];return _()&&e.push({key:"sendFavoritesToPhotographer",text:T("sendFavoritesToPhotographer"),onClick:function(){return F(!0)}}),e}),[_,T]);return i.createElement(wr,{flex:"1 1 auto",justifyContent:t?"flex-end":"space-between",width:t?void 0:"100%"},i.createElement(wr,null,$.map((function(e){var n=i.createElement(Wr,{key:e.key,fontSize:t?"sm":"md",leftIcon:e.icon,onClick:e.onClick,padding:"12px",variant:"ghost"},e.text);return"share"===e.key&&t?i.createElement(une,{key:e.key,isOpen:"share links"===D,onClose:U,placement:"bottom",triggerElement:n},i.createElement(Ite,{copyLinkHref:C,headingText:T("shareGallery"),linkHrefs:S,onClickLink:U,translateFilter:T})):"sendFavorites"===e.key&&t?i.createElement(une,{key:e.key,isOpen:"send favorites"===D,onClose:U,placement:"bottom",triggerElement:n,variant:"small"},i.createElement(wr,{flexFlow:"column nowrap"},W.map((function(e){return i.createElement(Wr,{key:e.key,variant:"ghost",justifyContent:"left",onClick:e.onClick},e.text)})))):n}))),H.length>0&&i.createElement(Gr,{icon:i.createElement(zee,null),"aria-label":T("moreActions"),variant:"ghost",onClick:function(){L("actions")}}),!t&&i.createElement(Rte,{actions:"send favorites"===D?W:H,isOpen:void 0!==D,isShareLinksVisible:"share links"===D,onCancel:z,onClose:U,shareCopyLinkUrl:C,shareHeadingText:T("shareGallery"),shareUrls:S,isDownloadDestinationsVisible:"download destinations"===D,downloadDestinationsProps:ote({setDownloadDestination:h,getRemainingDownloads:g},U),spFreeDigitals:M,translateFilter:T}),t&&i.createElement(Fte,{isOpen:"download destinations"===D,onClose:z,size:"sm"},i.createElement(rte,n({},ote({setDownloadDestination:h,getRemainingDownloads:g},U),{spFreeDigitals:M,translateFilter:T}))),y()&&i.createElement(Kre,{isOpen:I,onSubmit:b,onClose:function(){L(void 0),B(!1)},translate:T}),y()&&i.createElement(Zre,{isOpen:N,onSubmit:A,onClose:function(){L(void 0),F(!1)},translate:T}))};const eoe=function(e){var t,n,r,o=e.cartCount,a=void 0===o?0:o,s=e.favoritesCount,l=void 0===s?0:s,c=e.homeLinkHref,u=e.homeLinkLabel,d=e.isAboutContactVisible,p=e.isAboutMessageVisible,f=e.isAboutPricingVisible,h=e.isAboutVisible,m=e.isAdminModeEnabled,g=e.isBackNavVisible,v=e.isCartVisible,y=e.isHiddenPhotosVisible,b=e.isHomeSecondaryNavVisible,_=e.isLabeledPhotosVisible,A=e.isLargeScreen,E=e.isPackageBuilderOpen,w=e.isScrolledDown,x=e.isScrollingDown,k=e.isSearchVisible,C=e.isStoreEnabled,S=e.isToolbarHidden,M=e.toolbarActions,T=e.parentRouteName,O=e.parentUri,D=e.portfolioWebsiteHref,L=e.reloadRoute,P=e.requiresDownloadDestination,I=e.selectedRoute,B=e.selectedUri,R=e.studioName,N=e.shareCopyLinkUrl,F=e.shareUrls,j=e.spFreeDigitals,Y=e.translateFilter,$=null!==(t=u9({base:!1,lg:!0}))&&void 0!==t&&t,H=null!=A?A:$,U=(0,i.useRef)(null),z=(0,i.useRef)(null),W="Home"===I||"Album"===I,V="Store"===I,G="Special"===I,Q="Search"===I,q="Info"===I,K="Cart"===I,Z=lee({isAboutContactVisible:d,isAboutMessageVisible:p,isAboutPricingVisible:f,isAdminModeEnabled:m,isHiddenPhotosVisible:y,isHomeSecondaryNavVisible:b,isLabeledPhotosVisible:_,selectedRoute:I,selectedUri:B,translate:Y}),J=Z.navTabs,X=Z.navTabsKey,ee=Z.selectedNavTabIndex,te=H?J:void 0,ne=!H&&null!=B&&(Boolean(B.match(/album\/[0-9]/g))||B.includes("label/")),re=H?"32px":"8px",oe=H?"16px":"8px",ie=S?null:i.createElement(Xre,{isLargeScreen:H,isOnlySingleActionOnSmallScreen:ne,actions:M,requiresDownloadDestination:P,selectedUri:B,shareCopyLinkUrl:N,shareUrls:F,spFreeDigitals:j,translate:Y});return i.createElement(i.Fragment,null,i.createElement(_r,{ref:U,role:"presentation"}),i.createElement(wr,{flexDirection:"column",position:"sticky",top:(E&&(null===(n=U.current)||void 0===n?void 0:n.offsetTop)||0)-(w&&x&&(null===(r=z.current)||void 0===r?void 0:r.offsetHeight)||0)+"px",transition:"0.5s top",zIndex:3},i.createElement(wr,{ref:z,as:"header",backgroundColor:"background",borderBottomColor:"gray.100",borderBottomStyle:"solid",borderBottomWidth:"1px",flexDirection:"row",gap:"12px",height:H?"80px":"64px",justifyContent:"space-between"},i.createElement(wr,{direction:"row",gap:"12px"},i.createElement(Kr,{href:D||c,target:D?"_blank":void 0,alignSelf:"center",_focus:{boxShadow:"none"},_focusVisible:{boxShadow:"outline"},_hover:{textDecoration:"none"}},i.createElement(_r,{maxWidth:H?"380px":void 0,paddingX:H?"32px":"16px",paddingY:H?"32px":"24px"},i.createElement(Mee,{style:{display:"inline-block",verticalAlign:"baseline"},text:R,variant:"primary"}))),H&&i.createElement(wr,{as:"nav",direction:"row"},i.createElement(Cee,{href:c,isSelected:W},Y(u)),v&&C&&i.createElement(Cee,{href:"store",isSelected:V,onClick:L},Y("store")),i.createElement(Cee,{href:"favorites",isSelected:G,"aria-label":Y("favorites"),"data-testid":"viewFavoritesLink"},i.createElement(xee,{count:l,"data-testid":"favoritesCount"},Y("favorites"))),k&&i.createElement(Cee,{href:"search",isSelected:Q},Y("search")),h&&i.createElement(Cee,{href:"info",isSelected:q},Y("about")))),H&&v&&i.createElement(Cee,{href:"cart",isSelected:K,"aria-label":Y("cart"),height:void 0,marginRight:"32px",padding:"8px"},i.createElement(xee,{count:a},K?i.createElement(e8,{display:"block"}):i.createElement(s8,{display:"block"})))),(te||!S&&!g)&&i.createElement(wr,{alignItems:"center",backgroundColor:"background",borderBottomColor:"gray.100",borderBottomStyle:"solid",borderBottomWidth:"1px",flexDirection:"row",gap:"8px",height:"60px",overflowX:"auto",overflowY:"hidden",paddingLeft:re,paddingRight:oe,paddingY:"16px"},te&&i.createElement(See,{key:X,selectedTabIndex:ee,tabs:te}),ie),g&&void 0!==O&&i.createElement(fee,{parentRouteName:T,parentUri:O,translateFilter:Y},ie),i.createElement(Aee,{isHidden:!w||x,translateFilter:Y})))};var toe=["size","text","variant"];const noe=function(e){var r=e.size,o=e.text,a=e.variant,s=t(e,toe);return i.createElement(tq,n({as:"h1",margin:0,size:"sm"===r?"xl":"md"===r?"2xl":"3xl",variant:a},s),o)};const roe=function(e){var t=e.coverPhoto,n=e.coverPhotoUrl,r=e.label,o=(0,i.useRef)(null),a=m((0,i.useState)(),2),s=a[0],l=a[1],c=m((0,i.useState)(!1),2),u=c[0],d=c[1];return(0,i.useEffect)((function(){var e=new dS((function(){window.requestAnimationFrame((function(){if(o.current){var e=function(e,t,n,r,o){var i,a,s=e/t,l=o.x/100,c=o.y/100,u=n/r;u>s?(i=t*u,a=t):(i=e,a=e/u);var d=e/2-l*(i=Math.round(i)),p=t/2-c*(a=Math.round(a));return d<-1*(i-e)&&(d=-1*(i-e)),p<-1*(a-t)&&(p=-1*(a-t)),d=d>0?0:d,p=p>0?0:p,{height:a,width:i,offsetX:d=Math.round(d),offsetY:p=Math.round(p)}}(o.current.offsetWidth,o.current.offsetHeight,t.width,t.height,t.focalPoint);l(e)}}))}));return o.current&&e.observe(o.current),function(){e.disconnect()}}),[t]),(0,i.useEffect)((function(){var e=new IntersectionObserver((function(t){m(t,1)[0].isIntersecting&&(d(!0),e.disconnect())}));return o.current&&e.observe(o.current),function(){e.disconnect()}}),[]),(0,i.useEffect)((function(){!u&&s&&n&&d(!0)}),[u,s,n]),i.createElement(_r,{ref:o,role:"img","aria-label":r,"data-testid":"gallery-cover-photo",backgroundImage:s&&u&&n?"url("+n+")":"none",backgroundPosition:s&&s.offsetX+"px "+s.offsetY+"px",backgroundSize:s&&s.width+"px "+s.height+"px",width:"100%",height:"100%"})};const ooe=function(e){var t,n=e.caption,r=e.coverPhoto,o=e.headingText,a=e.isLargeScreen,s=null!==(t=u9({base:!1,lg:!0}))&&void 0!==t&&t,l=null!=a?a:s,c=Lr(),u=l?"596px":"292px",d=l?"md":"sm",p=l?"32px":"16px",f=l?"32px":"16px",h=i.createElement(qr,{color:"inherit",fontSize:"12px",letterSpacing:"2px",marginX:f,textTransform:"uppercase"},n);return r?i.createElement(wr,{alignItems:"center",color:"background",flexFlow:"column nowrap",height:u,justifyContent:"center",marginBottom:p,position:"relative",width:"100%"},i.createElement(_r,{height:"100%",position:"absolute",width:"100%",zIndex:-2},i.createElement(roe,{coverPhoto:r,coverPhotoUrl:r.url,label:o+" ("+n+")"})),i.createElement(_r,{background:c.isLightColorScheme?"blackAlpha.500":"whiteAlpha.500",height:"100%",position:"absolute",role:"presentation",width:"100%",zIndex:-1}),i.createElement(noe,{display:"-webkit-box",marginX:f,overflow:"hidden",size:d,sx:{WebkitLineClamp:4,WebkitBoxOrient:"vertical"},text:o,textAlign:"center",variant:c.isLightColorScheme?"light":"dark"}),i.createElement(GM,{marginY:"12px",width:"60px"}),h):i.createElement(wr,{color:"brand.primary",flexFlow:"column nowrap",marginY:"32px"},i.createElement(noe,{marginX:f,size:d,text:o,variant:"primary"}),h)};var ioe=function(e){var t=e.albumCount,n=e.photoCount,r=e.translate;return void 0!==t&&t>0?r(1===t?"oneAlbum":"multipleAlbums",{albumCount:String(t)}):n?r(1===n?"onePhoto":"multiplePhotos",{photoCount:String(n)}):r("zeroPhotos")};const aoe=function(e){var t=e.albumCount,n=e.coverPhoto,r=e.headingText,o=e.isLargeScreen,a=e.photoCount,s=e.translateFilter;return i.createElement(ooe,{caption:ioe({albumCount:t,photoCount:a,translate:s}),coverPhoto:n,headingText:r,isLargeScreen:o})};const soe=function(e){return(0,i.useMemo)((function(){return e?e.urlLarge||e.urlMedium||e.urlSmall:null}),[e])};const loe=function(e){var t=e.albumCount,r=e.coverPhoto,o=e.headingText,a=e.isLargeScreen,s=e.photoCount,l=e.translateFilter,c=soe(r);return i.createElement(aoe,{albumCount:t,coverPhoto:r&&c?n({},r,{url:c}):void 0,headingText:o,isLargeScreen:a,photoCount:s,translateFilter:l})};function coe(){return coe=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},coe.apply(this,arguments)}function uoe(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}var doe=(0,i.forwardRef)((function(e,t){var n=e.color,r=void 0===n?"currentColor":n,o=e.size,a=void 0===o?24:o,s=uoe(e,["color","size"]);return i.createElement("svg",coe({ref:t,xmlns:"http://www.w3.org/2000/svg",width:a,height:a,viewBox:"0 0 24 24",fill:"none",stroke:r,strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"},s),i.createElement("circle",{cx:"11",cy:"11",r:"8"}),i.createElement("line",{x1:"21",y1:"21",x2:"16.65",y2:"16.65"}))}));doe.propTypes={color:Xr().string,size:Xr().oneOfType([Xr().string,Xr().number])},doe.displayName="Search";const poe=doe;var foe=["children","isSelected"];const hoe=function(e){var r=e.children,o=e.isSelected,a=t(e,foe);return i.createElement(Kr,n({"aria-current":o?"page":void 0,alignItems:"center",color:o?"brand.primary":"text",direction:"column",display:"flex",flex:1,flexDirection:"column",fontFamily:"open-sans",fontSize:"12px",gap:"2px",lineHeight:1.33,paddingBottom:"8px",paddingTop:"12px",paddingX:"4px",_focus:{color:o?"brand.primary":"text"},_focusVisible:{boxShadow:"outline",color:"brand.primary"},_hover:{textDecoration:"none",color:o?"brand.primary":"text",stroke:"inherit"},_visited:{color:o?"brand.primary":"text","&:focus":{color:o?"brand.primary":"text"},"&:hover":{color:o?"brand.primary":"text"}}},a),r)};var moe=function(e){var t,n=e.cartCount,r=void 0===n?0:n,o=e.favoritesCount,a=void 0===o?0:o,s=e.homeLinkHref,l=e.homeLinkLabel,c=e.isAboutContactVisible,u=e.isAboutMessageVisible,d=e.isAboutPricingVisible,p=e.isAboutVisible,f=e.isAbsolutePositioned,h=e.isAdminModeEnabled,m=e.isCartVisible,g=e.isHiddenPhotosVisible,v=e.isHomeSecondaryNavVisible,y=e.isLabeledPhotosVisible,b=e.isPackageBuilderOpen,_=e.isSearchVisible,A=e.isStoreEnabled,E=e.reloadRoute,w=e.selectedRoute,x=e.selectedUri,k=e.translateFilter,C="Home"===w||"Album"===w,S="Store"===w,M="Special"===w,T="Search"===w,O="Info"===w,D="Cart"===w,L=lee({isAboutContactVisible:c,isAboutMessageVisible:u,isAboutPricingVisible:d,isAdminModeEnabled:h,isHiddenPhotosVisible:g,isHomeSecondaryNavVisible:v,isLabeledPhotosVisible:y,selectedRoute:w,selectedUri:x,translate:k}),P=L.navTabs,I=L.navTabsKey,B=L.selectedNavTabIndex,R=Lr();return i.createElement(wr,{bottom:b?"92px":0,direction:"column",gap:"8px",position:f?"absolute":"fixed",width:"full",zIndex:1},P&&i.createElement(wr,{alignItems:"center",background:R.isLightColorScheme?"background":"gray.600",borderRadius:"2px",filter:null===(t=R.filters)||void 0===t?void 0:t.dropShadow,flexDirection:"row",justifyContent:"center",marginX:"16px",opacity:.98,padding:"6px"},i.createElement(See,{key:I,selectedTabIndex:B,tabs:P})),i.createElement(wr,{as:"nav",backgroundColor:"background",flexFlow:"row nowrap",paddingX:"16px"},i.createElement(hoe,{href:s,isSelected:C},C?i.createElement(O8,null):i.createElement(N8,null),k(l)),m&&A&&i.createElement(hoe,{href:"store",isSelected:S,onClick:E},S?i.createElement(K7,null):i.createElement(j7,null),k("store")),i.createElement(hoe,{href:"favorites",isSelected:M,"aria-label":k("favorites"),"data-testid":"viewFavoritesLink"},i.createElement(xee,{count:a,"data-testid":"favoritesCount"},i.createElement(xte,{display:"block",fill:M?"currentColor":"none"})),k("favorites")),_&&i.createElement(hoe,{href:"search",isSelected:T},i.createElement(poe,{fill:T?"currentColor":"none"}),k("search")),p&&i.createElement(hoe,{href:"info",isSelected:O},O?i.createElement(z8,null):i.createElement(Z8,null),k("about")),m&&i.createElement(hoe,{href:"cart",isSelected:D,"aria-label":k("cart")},i.createElement(xee,{count:r},D?i.createElement(e8,{display:"block"}):i.createElement(s8,{display:"block"})),k("cart"))))};const goe=moe;
/*! @license DOMPurify 3.3.1 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.3.1/LICENSE */
const{entries:voe,setPrototypeOf:yoe,isFrozen:boe,getPrototypeOf:_oe,getOwnPropertyDescriptor:Aoe}=Object;let{freeze:Eoe,seal:woe,create:xoe}=Object,{apply:koe,construct:Coe}="undefined"!=typeof Reflect&&Reflect;Eoe||(Eoe=function(e){return e}),woe||(woe=function(e){return e}),koe||(koe=function(e,t){for(var n=arguments.length,r=new Array(n>2?n-2:0),o=2;o<n;o++)r[o-2]=arguments[o];return e.apply(t,r)}),Coe||(Coe=function(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return new e(...n)});const Soe=Hoe(Array.prototype.forEach),Moe=Hoe(Array.prototype.lastIndexOf),Toe=Hoe(Array.prototype.pop),Ooe=Hoe(Array.prototype.push),Doe=Hoe(Array.prototype.splice),Loe=Hoe(String.prototype.toLowerCase),Poe=Hoe(String.prototype.toString),Ioe=Hoe(String.prototype.match),Boe=Hoe(String.prototype.replace),Roe=Hoe(String.prototype.indexOf),Noe=Hoe(String.prototype.trim),Foe=Hoe(Object.prototype.hasOwnProperty),joe=Hoe(RegExp.prototype.test),Yoe=($oe=TypeError,function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return Coe($oe,t)});var $oe;function Hoe(e){return function(t){t instanceof RegExp&&(t.lastIndex=0);for(var n=arguments.length,r=new Array(n>1?n-1:0),o=1;o<n;o++)r[o-1]=arguments[o];return koe(e,t,r)}}function Uoe(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:Loe;yoe&&yoe(e,null);let r=t.length;for(;r--;){let o=t[r];if("string"==typeof o){const e=n(o);e!==o&&(boe(t)||(t[r]=e),o=e)}e[o]=!0}return e}function zoe(e){for(let t=0;t<e.length;t++){Foe(e,t)||(e[t]=null)}return e}function Woe(e){const t=xoe(null);for(const[n,r]of voe(e)){Foe(e,n)&&(Array.isArray(r)?t[n]=zoe(r):r&&"object"==typeof r&&r.constructor===Object?t[n]=Woe(r):t[n]=r)}return t}function Voe(e,t){for(;null!==e;){const n=Aoe(e,t);if(n){if(n.get)return Hoe(n.get);if("function"==typeof n.value)return Hoe(n.value)}e=_oe(e)}return function(){return null}}const Goe=Eoe(["a","abbr","acronym","address","area","article","aside","audio","b","bdi","bdo","big","blink","blockquote","body","br","button","canvas","caption","center","cite","code","col","colgroup","content","data","datalist","dd","decorator","del","details","dfn","dialog","dir","div","dl","dt","element","em","fieldset","figcaption","figure","font","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","img","input","ins","kbd","label","legend","li","main","map","mark","marquee","menu","menuitem","meter","nav","nobr","ol","optgroup","option","output","p","picture","pre","progress","q","rp","rt","ruby","s","samp","search","section","select","shadow","slot","small","source","spacer","span","strike","strong","style","sub","summary","sup","table","tbody","td","template","textarea","tfoot","th","thead","time","tr","track","tt","u","ul","var","video","wbr"]),Qoe=Eoe(["svg","a","altglyph","altglyphdef","altglyphitem","animatecolor","animatemotion","animatetransform","circle","clippath","defs","desc","ellipse","enterkeyhint","exportparts","filter","font","g","glyph","glyphref","hkern","image","inputmode","line","lineargradient","marker","mask","metadata","mpath","part","path","pattern","polygon","polyline","radialgradient","rect","stop","style","switch","symbol","text","textpath","title","tref","tspan","view","vkern"]),qoe=Eoe(["feBlend","feColorMatrix","feComponentTransfer","feComposite","feConvolveMatrix","feDiffuseLighting","feDisplacementMap","feDistantLight","feDropShadow","feFlood","feFuncA","feFuncB","feFuncG","feFuncR","feGaussianBlur","feImage","feMerge","feMergeNode","feMorphology","feOffset","fePointLight","feSpecularLighting","feSpotLight","feTile","feTurbulence"]),Koe=Eoe(["animate","color-profile","cursor","discard","font-face","font-face-format","font-face-name","font-face-src","font-face-uri","foreignobject","hatch","hatchpath","mesh","meshgradient","meshpatch","meshrow","missing-glyph","script","set","solidcolor","unknown","use"]),Zoe=Eoe(["math","menclose","merror","mfenced","mfrac","mglyph","mi","mlabeledtr","mmultiscripts","mn","mo","mover","mpadded","mphantom","mroot","mrow","ms","mspace","msqrt","mstyle","msub","msup","msubsup","mtable","mtd","mtext","mtr","munder","munderover","mprescripts"]),Joe=Eoe(["maction","maligngroup","malignmark","mlongdiv","mscarries","mscarry","msgroup","mstack","msline","msrow","semantics","annotation","annotation-xml","mprescripts","none"]),Xoe=Eoe(["#text"]),eie=Eoe(["accept","action","align","alt","autocapitalize","autocomplete","autopictureinpicture","autoplay","background","bgcolor","border","capture","cellpadding","cellspacing","checked","cite","class","clear","color","cols","colspan","controls","controlslist","coords","crossorigin","datetime","decoding","default","dir","disabled","disablepictureinpicture","disableremoteplayback","download","draggable","enctype","enterkeyhint","exportparts","face","for","headers","height","hidden","high","href","hreflang","id","inert","inputmode","integrity","ismap","kind","label","lang","list","loading","loop","low","max","maxlength","media","method","min","minlength","multiple","muted","name","nonce","noshade","novalidate","nowrap","open","optimum","part","pattern","placeholder","playsinline","popover","popovertarget","popovertargetaction","poster","preload","pubdate","radiogroup","readonly","rel","required","rev","reversed","role","rows","rowspan","spellcheck","scope","selected","shape","size","sizes","slot","span","srclang","start","src","srcset","step","style","summary","tabindex","title","translate","type","usemap","valign","value","width","wrap","xmlns","slot"]),tie=Eoe(["accent-height","accumulate","additive","alignment-baseline","amplitude","ascent","attributename","attributetype","azimuth","basefrequency","baseline-shift","begin","bias","by","class","clip","clippathunits","clip-path","clip-rule","color","color-interpolation","color-interpolation-filters","color-profile","color-rendering","cx","cy","d","dx","dy","diffuseconstant","direction","display","divisor","dur","edgemode","elevation","end","exponent","fill","fill-opacity","fill-rule","filter","filterunits","flood-color","flood-opacity","font-family","font-size","font-size-adjust","font-stretch","font-style","font-variant","font-weight","fx","fy","g1","g2","glyph-name","glyphref","gradientunits","gradienttransform","height","href","id","image-rendering","in","in2","intercept","k","k1","k2","k3","k4","kerning","keypoints","keysplines","keytimes","lang","lengthadjust","letter-spacing","kernelmatrix","kernelunitlength","lighting-color","local","marker-end","marker-mid","marker-start","markerheight","markerunits","markerwidth","maskcontentunits","maskunits","max","mask","mask-type","media","method","mode","min","name","numoctaves","offset","operator","opacity","order","orient","orientation","origin","overflow","paint-order","path","pathlength","patterncontentunits","patterntransform","patternunits","points","preservealpha","preserveaspectratio","primitiveunits","r","rx","ry","radius","refx","refy","repeatcount","repeatdur","restart","result","rotate","scale","seed","shape-rendering","slope","specularconstant","specularexponent","spreadmethod","startoffset","stddeviation","stitchtiles","stop-color","stop-opacity","stroke-dasharray","stroke-dashoffset","stroke-linecap","stroke-linejoin","stroke-miterlimit","stroke-opacity","stroke","stroke-width","style","surfacescale","systemlanguage","tabindex","tablevalues","targetx","targety","transform","transform-origin","text-anchor","text-decoration","text-rendering","textlength","type","u1","u2","unicode","values","viewbox","visibility","version","vert-adv-y","vert-origin-x","vert-origin-y","width","word-spacing","wrap","writing-mode","xchannelselector","ychannelselector","x","x1","x2","xmlns","y","y1","y2","z","zoomandpan"]),nie=Eoe(["accent","accentunder","align","bevelled","close","columnsalign","columnlines","columnspan","denomalign","depth","dir","display","displaystyle","encoding","fence","frame","height","href","id","largeop","length","linethickness","lspace","lquote","mathbackground","mathcolor","mathsize","mathvariant","maxsize","minsize","movablelimits","notation","numalign","open","rowalign","rowlines","rowspacing","rowspan","rspace","rquote","scriptlevel","scriptminsize","scriptsizemultiplier","selection","separator","separators","stretchy","subscriptshift","supscriptshift","symmetric","voffset","width","xmlns"]),rie=Eoe(["xlink:href","xml:id","xlink:title","xml:space","xmlns:xlink"]),oie=woe(/\{\{[\w\W]*|[\w\W]*\}\}/gm),iie=woe(/<%[\w\W]*|[\w\W]*%>/gm),aie=woe(/\$\{[\w\W]*/gm),sie=woe(/^data-[\-\w.\u00B7-\uFFFF]+$/),lie=woe(/^aria-[\-\w]+$/),cie=woe(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i),uie=woe(/^(?:\w+script|data):/i),die=woe(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),pie=woe(/^html$/i),fie=woe(/^[a-z][.\w]*(-[.\w]+)+$/i);var hie=Object.freeze({__proto__:null,ARIA_ATTR:lie,ATTR_WHITESPACE:die,CUSTOM_ELEMENT:fie,DATA_ATTR:sie,DOCTYPE_NAME:pie,ERB_EXPR:iie,IS_ALLOWED_URI:cie,IS_SCRIPT_OR_DATA:uie,MUSTACHE_EXPR:oie,TMPLIT_EXPR:aie});const mie=1,gie=3,vie=7,yie=8,bie=9,_ie=function(){return"undefined"==typeof window?null:window};var Aie=function e(){let t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:_ie();const n=t=>e(t);if(n.version="3.3.1",n.removed=[],!t||!t.document||t.document.nodeType!==bie||!t.Element)return n.isSupported=!1,n;let{document:r}=t;const o=r,i=o.currentScript,{DocumentFragment:a,HTMLTemplateElement:s,Node:l,Element:c,NodeFilter:u,NamedNodeMap:d=t.NamedNodeMap||t.MozNamedAttrMap,HTMLFormElement:p,DOMParser:f,trustedTypes:h}=t,m=c.prototype,g=Voe(m,"cloneNode"),v=Voe(m,"remove"),y=Voe(m,"nextSibling"),b=Voe(m,"childNodes"),_=Voe(m,"parentNode");if("function"==typeof s){const e=r.createElement("template");e.content&&e.content.ownerDocument&&(r=e.content.ownerDocument)}let A,E="";const{implementation:w,createNodeIterator:x,createDocumentFragment:k,getElementsByTagName:C}=r,{importNode:S}=o;let M={afterSanitizeAttributes:[],afterSanitizeElements:[],afterSanitizeShadowDOM:[],beforeSanitizeAttributes:[],beforeSanitizeElements:[],beforeSanitizeShadowDOM:[],uponSanitizeAttribute:[],uponSanitizeElement:[],uponSanitizeShadowNode:[]};n.isSupported="function"==typeof voe&&"function"==typeof _&&w&&void 0!==w.createHTMLDocument;const{MUSTACHE_EXPR:T,ERB_EXPR:O,TMPLIT_EXPR:D,DATA_ATTR:L,ARIA_ATTR:P,IS_SCRIPT_OR_DATA:I,ATTR_WHITESPACE:B,CUSTOM_ELEMENT:R}=hie;let{IS_ALLOWED_URI:N}=hie,F=null;const j=Uoe({},[...Goe,...Qoe,...qoe,...Zoe,...Xoe]);let Y=null;const $=Uoe({},[...eie,...tie,...nie,...rie]);let H=Object.seal(xoe(null,{tagNameCheck:{writable:!0,configurable:!1,enumerable:!0,value:null},attributeNameCheck:{writable:!0,configurable:!1,enumerable:!0,value:null},allowCustomizedBuiltInElements:{writable:!0,configurable:!1,enumerable:!0,value:!1}})),U=null,z=null;const W=Object.seal(xoe(null,{tagCheck:{writable:!0,configurable:!1,enumerable:!0,value:null},attributeCheck:{writable:!0,configurable:!1,enumerable:!0,value:null}}));let V=!0,G=!0,Q=!1,q=!0,K=!1,Z=!0,J=!1,X=!1,ee=!1,te=!1,ne=!1,re=!1,oe=!0,ie=!1,ae=!0,se=!1,le={},ce=null;const ue=Uoe({},["annotation-xml","audio","colgroup","desc","foreignobject","head","iframe","math","mi","mn","mo","ms","mtext","noembed","noframes","noscript","plaintext","script","style","svg","template","thead","title","video","xmp"]);let de=null;const pe=Uoe({},["audio","video","img","source","image","track"]);let fe=null;const he=Uoe({},["alt","class","for","id","label","name","pattern","placeholder","role","summary","title","value","style","xmlns"]),me="http://www.w3.org/1998/Math/MathML",ge="http://www.w3.org/2000/svg",ve="http://www.w3.org/1999/xhtml";let ye=ve,be=!1,_e=null;const Ae=Uoe({},[me,ge,ve],Poe);let Ee=Uoe({},["mi","mo","mn","ms","mtext"]),we=Uoe({},["annotation-xml"]);const xe=Uoe({},["title","style","font","a","script"]);let ke=null;const Ce=["application/xhtml+xml","text/html"];let Se=null,Me=null;const Te=r.createElement("form"),Oe=function(e){return e instanceof RegExp||e instanceof Function},De=function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};if(!Me||Me!==e){if(e&&"object"==typeof e||(e={}),e=Woe(e),ke=-1===Ce.indexOf(e.PARSER_MEDIA_TYPE)?"text/html":e.PARSER_MEDIA_TYPE,Se="application/xhtml+xml"===ke?Poe:Loe,F=Foe(e,"ALLOWED_TAGS")?Uoe({},e.ALLOWED_TAGS,Se):j,Y=Foe(e,"ALLOWED_ATTR")?Uoe({},e.ALLOWED_ATTR,Se):$,_e=Foe(e,"ALLOWED_NAMESPACES")?Uoe({},e.ALLOWED_NAMESPACES,Poe):Ae,fe=Foe(e,"ADD_URI_SAFE_ATTR")?Uoe(Woe(he),e.ADD_URI_SAFE_ATTR,Se):he,de=Foe(e,"ADD_DATA_URI_TAGS")?Uoe(Woe(pe),e.ADD_DATA_URI_TAGS,Se):pe,ce=Foe(e,"FORBID_CONTENTS")?Uoe({},e.FORBID_CONTENTS,Se):ue,U=Foe(e,"FORBID_TAGS")?Uoe({},e.FORBID_TAGS,Se):Woe({}),z=Foe(e,"FORBID_ATTR")?Uoe({},e.FORBID_ATTR,Se):Woe({}),le=!!Foe(e,"USE_PROFILES")&&e.USE_PROFILES,V=!1!==e.ALLOW_ARIA_ATTR,G=!1!==e.ALLOW_DATA_ATTR,Q=e.ALLOW_UNKNOWN_PROTOCOLS||!1,q=!1!==e.ALLOW_SELF_CLOSE_IN_ATTR,K=e.SAFE_FOR_TEMPLATES||!1,Z=!1!==e.SAFE_FOR_XML,J=e.WHOLE_DOCUMENT||!1,te=e.RETURN_DOM||!1,ne=e.RETURN_DOM_FRAGMENT||!1,re=e.RETURN_TRUSTED_TYPE||!1,ee=e.FORCE_BODY||!1,oe=!1!==e.SANITIZE_DOM,ie=e.SANITIZE_NAMED_PROPS||!1,ae=!1!==e.KEEP_CONTENT,se=e.IN_PLACE||!1,N=e.ALLOWED_URI_REGEXP||cie,ye=e.NAMESPACE||ve,Ee=e.MATHML_TEXT_INTEGRATION_POINTS||Ee,we=e.HTML_INTEGRATION_POINTS||we,H=e.CUSTOM_ELEMENT_HANDLING||{},e.CUSTOM_ELEMENT_HANDLING&&Oe(e.CUSTOM_ELEMENT_HANDLING.tagNameCheck)&&(H.tagNameCheck=e.CUSTOM_ELEMENT_HANDLING.tagNameCheck),e.CUSTOM_ELEMENT_HANDLING&&Oe(e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)&&(H.attributeNameCheck=e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck),e.CUSTOM_ELEMENT_HANDLING&&"boolean"==typeof e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements&&(H.allowCustomizedBuiltInElements=e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements),K&&(G=!1),ne&&(te=!0),le&&(F=Uoe({},Xoe),Y=[],!0===le.html&&(Uoe(F,Goe),Uoe(Y,eie)),!0===le.svg&&(Uoe(F,Qoe),Uoe(Y,tie),Uoe(Y,rie)),!0===le.svgFilters&&(Uoe(F,qoe),Uoe(Y,tie),Uoe(Y,rie)),!0===le.mathMl&&(Uoe(F,Zoe),Uoe(Y,nie),Uoe(Y,rie))),e.ADD_TAGS&&("function"==typeof e.ADD_TAGS?W.tagCheck=e.ADD_TAGS:(F===j&&(F=Woe(F)),Uoe(F,e.ADD_TAGS,Se))),e.ADD_ATTR&&("function"==typeof e.ADD_ATTR?W.attributeCheck=e.ADD_ATTR:(Y===$&&(Y=Woe(Y)),Uoe(Y,e.ADD_ATTR,Se))),e.ADD_URI_SAFE_ATTR&&Uoe(fe,e.ADD_URI_SAFE_ATTR,Se),e.FORBID_CONTENTS&&(ce===ue&&(ce=Woe(ce)),Uoe(ce,e.FORBID_CONTENTS,Se)),e.ADD_FORBID_CONTENTS&&(ce===ue&&(ce=Woe(ce)),Uoe(ce,e.ADD_FORBID_CONTENTS,Se)),ae&&(F["#text"]=!0),J&&Uoe(F,["html","head","body"]),F.table&&(Uoe(F,["tbody"]),delete U.tbody),e.TRUSTED_TYPES_POLICY){if("function"!=typeof e.TRUSTED_TYPES_POLICY.createHTML)throw Yoe('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');if("function"!=typeof e.TRUSTED_TYPES_POLICY.createScriptURL)throw Yoe('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');A=e.TRUSTED_TYPES_POLICY,E=A.createHTML("")}else void 0===A&&(A=function(e,t){if("object"!=typeof e||"function"!=typeof e.createPolicy)return null;let n=null;const r="data-tt-policy-suffix";t&&t.hasAttribute(r)&&(n=t.getAttribute(r));const o="dompurify"+(n?"#"+n:"");try{return e.createPolicy(o,{createHTML:e=>e,createScriptURL:e=>e})}catch(e){return console.warn("TrustedTypes policy "+o+" could not be created."),null}}(h,i)),null!==A&&"string"==typeof E&&(E=A.createHTML(""));Eoe&&Eoe(e),Me=e}},Le=Uoe({},[...Qoe,...qoe,...Koe]),Pe=Uoe({},[...Zoe,...Joe]),Ie=function(e){Ooe(n.removed,{element:e});try{_(e).removeChild(e)}catch(t){v(e)}},Be=function(e,t){try{Ooe(n.removed,{attribute:t.getAttributeNode(e),from:t})}catch(e){Ooe(n.removed,{attribute:null,from:t})}if(t.removeAttribute(e),"is"===e)if(te||ne)try{Ie(t)}catch(e){}else try{t.setAttribute(e,"")}catch(e){}},Re=function(e){let t=null,n=null;if(ee)e="<remove></remove>"+e;else{const t=Ioe(e,/^[\r\n\t ]+/);n=t&&t[0]}"application/xhtml+xml"===ke&&ye===ve&&(e='<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>'+e+"</body></html>");const o=A?A.createHTML(e):e;if(ye===ve)try{t=(new f).parseFromString(o,ke)}catch(e){}if(!t||!t.documentElement){t=w.createDocument(ye,"template",null);try{t.documentElement.innerHTML=be?E:o}catch(e){}}const i=t.body||t.documentElement;return e&&n&&i.insertBefore(r.createTextNode(n),i.childNodes[0]||null),ye===ve?C.call(t,J?"html":"body")[0]:J?t.documentElement:i},Ne=function(e){return x.call(e.ownerDocument||e,e,u.SHOW_ELEMENT|u.SHOW_COMMENT|u.SHOW_TEXT|u.SHOW_PROCESSING_INSTRUCTION|u.SHOW_CDATA_SECTION,null)},Fe=function(e){return e instanceof p&&("string"!=typeof e.nodeName||"string"!=typeof e.textContent||"function"!=typeof e.removeChild||!(e.attributes instanceof d)||"function"!=typeof e.removeAttribute||"function"!=typeof e.setAttribute||"string"!=typeof e.namespaceURI||"function"!=typeof e.insertBefore||"function"!=typeof e.hasChildNodes)},je=function(e){return"function"==typeof l&&e instanceof l};function Ye(e,t,r){Soe(e,(e=>{e.call(n,t,r,Me)}))}const $e=function(e){let t=null;if(Ye(M.beforeSanitizeElements,e,null),Fe(e))return Ie(e),!0;const r=Se(e.nodeName);if(Ye(M.uponSanitizeElement,e,{tagName:r,allowedTags:F}),Z&&e.hasChildNodes()&&!je(e.firstElementChild)&&joe(/<[/\w!]/g,e.innerHTML)&&joe(/<[/\w!]/g,e.textContent))return Ie(e),!0;if(e.nodeType===vie)return Ie(e),!0;if(Z&&e.nodeType===yie&&joe(/<[/\w]/g,e.data))return Ie(e),!0;if(!(W.tagCheck instanceof Function&&W.tagCheck(r))&&(!F[r]||U[r])){if(!U[r]&&Ue(r)){if(H.tagNameCheck instanceof RegExp&&joe(H.tagNameCheck,r))return!1;if(H.tagNameCheck instanceof Function&&H.tagNameCheck(r))return!1}if(ae&&!ce[r]){const t=_(e)||e.parentNode,n=b(e)||e.childNodes;if(n&&t){for(let r=n.length-1;r>=0;--r){const o=g(n[r],!0);o.__removalCount=(e.__removalCount||0)+1,t.insertBefore(o,y(e))}}}return Ie(e),!0}return e instanceof c&&!function(e){let t=_(e);t&&t.tagName||(t={namespaceURI:ye,tagName:"template"});const n=Loe(e.tagName),r=Loe(t.tagName);return!!_e[e.namespaceURI]&&(e.namespaceURI===ge?t.namespaceURI===ve?"svg"===n:t.namespaceURI===me?"svg"===n&&("annotation-xml"===r||Ee[r]):Boolean(Le[n]):e.namespaceURI===me?t.namespaceURI===ve?"math"===n:t.namespaceURI===ge?"math"===n&&we[r]:Boolean(Pe[n]):e.namespaceURI===ve?!(t.namespaceURI===ge&&!we[r])&&!(t.namespaceURI===me&&!Ee[r])&&!Pe[n]&&(xe[n]||!Le[n]):!("application/xhtml+xml"!==ke||!_e[e.namespaceURI]))}(e)?(Ie(e),!0):"noscript"!==r&&"noembed"!==r&&"noframes"!==r||!joe(/<\/no(script|embed|frames)/i,e.innerHTML)?(K&&e.nodeType===gie&&(t=e.textContent,Soe([T,O,D],(e=>{t=Boe(t,e," ")})),e.textContent!==t&&(Ooe(n.removed,{element:e.cloneNode()}),e.textContent=t)),Ye(M.afterSanitizeElements,e,null),!1):(Ie(e),!0)},He=function(e,t,n){if(oe&&("id"===t||"name"===t)&&(n in r||n in Te))return!1;if(G&&!z[t]&&joe(L,t));else if(V&&joe(P,t));else if(W.attributeCheck instanceof Function&&W.attributeCheck(t,e));else if(!Y[t]||z[t]){if(!(Ue(e)&&(H.tagNameCheck instanceof RegExp&&joe(H.tagNameCheck,e)||H.tagNameCheck instanceof Function&&H.tagNameCheck(e))&&(H.attributeNameCheck instanceof RegExp&&joe(H.attributeNameCheck,t)||H.attributeNameCheck instanceof Function&&H.attributeNameCheck(t,e))||"is"===t&&H.allowCustomizedBuiltInElements&&(H.tagNameCheck instanceof RegExp&&joe(H.tagNameCheck,n)||H.tagNameCheck instanceof Function&&H.tagNameCheck(n))))return!1}else if(fe[t]);else if(joe(N,Boe(n,B,"")));else if("src"!==t&&"xlink:href"!==t&&"href"!==t||"script"===e||0!==Roe(n,"data:")||!de[e]){if(Q&&!joe(I,Boe(n,B,"")));else if(n)return!1}else;return!0},Ue=function(e){return"annotation-xml"!==e&&Ioe(e,R)},ze=function(e){Ye(M.beforeSanitizeAttributes,e,null);const{attributes:t}=e;if(!t||Fe(e))return;const r={attrName:"",attrValue:"",keepAttr:!0,allowedAttributes:Y,forceKeepAttr:void 0};let o=t.length;for(;o--;){const i=t[o],{name:a,namespaceURI:s,value:l}=i,c=Se(a),u=l;let d="value"===a?u:Noe(u);if(r.attrName=c,r.attrValue=d,r.keepAttr=!0,r.forceKeepAttr=void 0,Ye(M.uponSanitizeAttribute,e,r),d=r.attrValue,!ie||"id"!==c&&"name"!==c||(Be(a,e),d="user-content-"+d),Z&&joe(/((--!?|])>)|<\/(style|title|textarea)/i,d)){Be(a,e);continue}if("attributename"===c&&Ioe(d,"href")){Be(a,e);continue}if(r.forceKeepAttr)continue;if(!r.keepAttr){Be(a,e);continue}if(!q&&joe(/\/>/i,d)){Be(a,e);continue}K&&Soe([T,O,D],(e=>{d=Boe(d,e," ")}));const p=Se(e.nodeName);if(He(p,c,d)){if(A&&"object"==typeof h&&"function"==typeof h.getAttributeType)if(s);else switch(h.getAttributeType(p,c)){case"TrustedHTML":d=A.createHTML(d);break;case"TrustedScriptURL":d=A.createScriptURL(d)}if(d!==u)try{s?e.setAttributeNS(s,a,d):e.setAttribute(a,d),Fe(e)?Ie(e):Toe(n.removed)}catch(t){Be(a,e)}}else Be(a,e)}Ye(M.afterSanitizeAttributes,e,null)},We=function e(t){let n=null;const r=Ne(t);for(Ye(M.beforeSanitizeShadowDOM,t,null);n=r.nextNode();)Ye(M.uponSanitizeShadowNode,n,null),$e(n),ze(n),n.content instanceof a&&e(n.content);Ye(M.afterSanitizeShadowDOM,t,null)};return n.sanitize=function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=null,i=null,s=null,c=null;if(be=!e,be&&(e="\x3c!--\x3e"),"string"!=typeof e&&!je(e)){if("function"!=typeof e.toString)throw Yoe("toString is not a function");if("string"!=typeof(e=e.toString()))throw Yoe("dirty is not a string, aborting")}if(!n.isSupported)return e;if(X||De(t),n.removed=[],"string"==typeof e&&(se=!1),se){if(e.nodeName){const t=Se(e.nodeName);if(!F[t]||U[t])throw Yoe("root node is forbidden and cannot be sanitized in-place")}}else if(e instanceof l)r=Re("\x3c!----\x3e"),i=r.ownerDocument.importNode(e,!0),i.nodeType===mie&&"BODY"===i.nodeName||"HTML"===i.nodeName?r=i:r.appendChild(i);else{if(!te&&!K&&!J&&-1===e.indexOf("<"))return A&&re?A.createHTML(e):e;if(r=Re(e),!r)return te?null:re?E:""}r&&ee&&Ie(r.firstChild);const u=Ne(se?e:r);for(;s=u.nextNode();)$e(s),ze(s),s.content instanceof a&&We(s.content);if(se)return e;if(te){if(ne)for(c=k.call(r.ownerDocument);r.firstChild;)c.appendChild(r.firstChild);else c=r;return(Y.shadowroot||Y.shadowrootmode)&&(c=S.call(o,c,!0)),c}let d=J?r.outerHTML:r.innerHTML;return J&&F["!doctype"]&&r.ownerDocument&&r.ownerDocument.doctype&&r.ownerDocument.doctype.name&&joe(pie,r.ownerDocument.doctype.name)&&(d="<!DOCTYPE "+r.ownerDocument.doctype.name+">\n"+d),K&&Soe([T,O,D],(e=>{d=Boe(d,e," ")})),A&&re?A.createHTML(d):d},n.setConfig=function(){De(arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}),X=!0},n.clearConfig=function(){Me=null,X=!1},n.isValidAttribute=function(e,t,n){Me||De({});const r=Se(e),o=Se(t);return He(r,o,n)},n.addHook=function(e,t){"function"==typeof t&&Ooe(M[e],t)},n.removeHook=function(e,t){if(void 0!==t){const n=Moe(M[e],t);return-1===n?void 0:Doe(M[e],n,1)[0]}return Toe(M[e])},n.removeHooks=function(e){M[e]=[]},n.removeAllHooks=function(){M={afterSanitizeAttributes:[],afterSanitizeElements:[],afterSanitizeShadowDOM:[],beforeSanitizeAttributes:[],beforeSanitizeElements:[],beforeSanitizeShadowDOM:[],uponSanitizeAttribute:[],uponSanitizeElement:[],uponSanitizeShadowNode:[]}},n}();const Eie=function(e){var t=e.colorScheme,n=e.logoUrl,r=e.brandName,o=e.isKeyboardTrigger,a=void 0===o||o,s=e.warningTitle,l=e.warningBody,c=e.positionStyle,u=void 0===c?"fixed":c,d="light"===t,p=d?"rgba(255, 255, 255, 0.7)":"rgba(0, 0, 0, 0.7)",f=d?"#000000":"#ffffff",h=d?"1px 1px 2px rgba(255, 255, 255, 0.8)":"2px 2px 4px rgba(0, 0, 0, 0.8)",m=d?"1px 1px 2px rgba(255, 255, 255, 0.8)":"1px 1px 2px rgba(0, 0, 0, 0.8)",g=i.createElement(i.Fragment,null,n?i.createElement("div",{style:{marginBottom:"40px",display:"flex",justifyContent:"center",alignItems:"center"}},i.createElement("img",{alt:r||"",src:n,style:{maxHeight:"220px",maxWidth:"220px",height:"auto",width:"auto",objectFit:"contain"}})):r?i.createElement("div",{style:{marginBottom:"40px",fontSize:"32px",fontWeight:"600",textShadow:m}},r):null,a&&i.createElement(i.Fragment,null,i.createElement("div",{dangerouslySetInnerHTML:{__html:Aie.sanitize(null!=s?s:"")},style:{fontSize:"48px",fontWeight:"bold",textShadow:h,marginBottom:"40px"}}),i.createElement("div",{dangerouslySetInnerHTML:{__html:Aie.sanitize(null!=l?l:"")},style:{fontSize:"24px",maxWidth:"800px",lineHeight:"1.6",textShadow:m}})));return"absolute"===u?i.createElement("div",{style:{position:"absolute",top:0,left:0,right:0,bottom:0,backgroundColor:p,backdropFilter:"blur(10px)",WebkitBackdropFilter:"blur(10px)",color:f,overflowY:"auto",zIndex:999999,textAlign:"center"}},i.createElement("div",{style:{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",minHeight:"100%",padding:"40px"}},g)):i.createElement("div",{style:{position:"fixed",top:0,left:0,right:0,bottom:0,backgroundColor:p,backdropFilter:"blur(10px)",WebkitBackdropFilter:"blur(10px)",color:f,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",zIndex:999999,padding:"40px",textAlign:"center"}},g)};Math.pow(10,7);const wie=function(e){var t=e.durationMs;return i.createElement(i.Fragment,null,i.createElement(_r,{position:"absolute",top:"50%",left:"50%",transform:"translate(-50%, -50%)",width:"60px",height:"60px",pointerEvents:"none"},i.createElement("svg",{width:"60",height:"60",viewBox:"0 0 60 60",xmlns:"http://www.w3.org/2000/svg"},i.createElement("circle",{cx:"30",cy:"30",r:"30",fill:"rgba(255,255,255,0.85)"}),i.createElement("polygon",{points:"24,18 24,42 45,30",fill:"rgba(0,0,0,0.75)"}))),"number"==typeof t&&i.createElement(_r,{position:"absolute",bottom:"8px",left:"8px",bg:"rgba(0, 0, 0, 0.7)",px:"6px",py:"4px",borderRadius:"4px",pointerEvents:"none"},i.createElement(qr,{color:"white",fontSize:"12px",lineHeight:"16px",fontWeight:"normal",whiteSpace:"nowrap"},function(e){var t=Math.round(e),n=Math.floor(t/3600),r=Math.floor(t%3600/60),o=t%60,i=function(e){return String(e).padStart(2,"0")};return n>0?n+":"+i(r)+":"+i(o):r+":"+i(o)}(t/1e3))))};var xie,kie,Cie=["title","titleId"];function Sie(){return Sie=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Sie.apply(null,arguments)}var Mie=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Cie);return i.createElement("svg",Sie({width:40,height:40,viewBox:"0 0 40 40",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,xie||(xie=i.createElement("path",{d:"M26 14L14 26",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),kie||(kie=i.createElement("path",{d:"M14 14L26 26",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})))},Tie=(0,i.forwardRef)(Mie);o.p;var Oie=function(){var e=Lo(Io().mark((function e(t){var n,r,o,i;return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t){e.next=2;break}return e.abrupt("return",null);case 2:if(!(n=t.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?|shorts)\/|.*[?&]v=)|youtu\.be\/)([\w-]{11})/))||!n[1]){e.next=5;break}return e.abrupt("return","https://img.youtube.com/vi/"+n[1]+"/maxresdefault.jpg");case 5:if(!(r=t.match(/vimeo\.com\/(\d+)/))||!r[1]){e.next=22;break}return e.prev=7,e.next=10,fetch("https://vimeo.com/api/oembed.json?url=https://vimeo.com/"+r[1]);case 10:if((o=e.sent).ok){e.next=13;break}return e.abrupt("return",null);case 13:return e.next=15,o.json();case 15:return i=e.sent,e.abrupt("return",i.thumbnail_url);case 19:return e.prev=19,e.t0=e.catch(7),e.abrupt("return",null);case 22:return e.abrupt("return",null);case 23:case"end":return e.stop()}}),e,null,[[7,19]])})));return function(t){return e.apply(this,arguments)}}();const Die=function(e){var t=e.headline,n=e.information,r=e.videoUrl,o=e.isMobile,a=Co("studio.welcome.galleryPreview"),s=Lr(),l=m((0,i.useState)(null),2),c=l[0],u=l[1];return(0,i.useEffect)((function(){var e=!0;return r?Oie(r).then((function(t){e&&u(t)})):u(null),function(){e=!1}}),[r]),i.createElement(i.Fragment,null,i.createElement(_r,{position:"absolute",top:0,left:0,width:"100%",height:"100%",bg:"blackAlpha.600",zIndex:9}),i.createElement(wr,{position:"absolute",top:"50%",left:"50%",transform:"translate(-50%, -50%)",zIndex:10,background:"background",boxShadow:"lg",padding:"4",flexDirection:"column",alignItems:"center",borderRadius:o?"0":"20px",maxHeight:o?"100%":"50%",width:o?"100%":"40%",height:o?"100%":"auto",justifyContent:"space-between"},i.createElement(_r,{position:"absolute",top:"4",right:"4",zIndex:"20",width:"32px",height:"32px",display:"flex",alignItems:"center",justifyContent:"center",borderRadius:"full"},i.createElement(Tie,{color:s.colors.gray[200],"aria-hidden":"true"})),i.createElement(qr,{as:"h2",textAlign:"center",color:"brand.primary",fontSize:"lg",fontWeight:"semibold",margin:"5% 0"},t||a("headlinePlaceholder")),null!==r&&i.createElement(wr,{alignItems:"center",aspectRatio:"3/2",bg:"gray.100",justifyContent:"center",overflow:"hidden",margin:"3% 0",width:"85%"},c?i.createElement("img",{src:c,alt:a("videoPlaceholder"),style:{width:"100%",height:"100%",objectFit:"cover"}}):i.createElement(qr,{fontWeight:"bold"},a("videoPlaceholder"))),null!==n&&i.createElement(_r,{alignSelf:"flex-start",color:"text",fontSize:"md",textAlign:"left",paddingX:o?"0":"4",marginBottom:"auto",overflow:"hidden",sx:{"& p + p":{marginTop:"1em"}},dangerouslySetInnerHTML:{__html:n||a("visitorMessagePlaceholder")}}),i.createElement(Wr,{variant:"primary",fontSize:"sm",height:o?"6%":"8%",marginTop:2,width:o?"100%":"30%"},a("continue"))))};const Lie=function(e){var t=e.containerRef,n=e.isMobile,r=m((0,i.useState)(0),2),o=r[0],a=r[1],s=m((0,i.useState)(1),2),l=s[0],c=s[1],u=n?375:1440,d=(0,i.useCallback)((function(){if(t.current){var e=t.current.offsetWidth/u;c(e);var n=t.current.offsetHeight/e+2;a(n)}}),[t,u]);return(0,i.useEffect)((function(){var e;return d(),t.current&&(e=new dS(d)).observe(t.current),function(){var t;null===(t=e)||void 0===t||t.disconnect()}}),[t,d]),{scale:l,width:u,height:o}};var Pie=fr(wr)((function(e){return"\n        border: 1px solid "+e.theme.colors.gray[400]+";\n        border-radius: 4px;\n    "})),Iie=fr(wr,{shouldForwardProp:function(e){return"isSelected"!==e}})((function(e){var t=e.isSelected,n=e.theme;return"\n            align-items: center;\n            background: "+(t?n.colors.white:n.colors.gray[100])+";\n            cursor: pointer;\n            height: 36px;\n            justify-content: center;\n            width: 36px;\n\n            > svg {\n                fill: "+(t?n.colors.gray[700]:"none")+";\n                stroke: "+(t?n.colors.white:n.colors.gray[700])+";\n            }\n            "}));const Bie=function(e){var t=e.isMobile,n=void 0!==t&&t,r=e.setIsMobile;return i.createElement(Pie,{role:"radiogroup"},i.createElement(Iie,{"data-testid":"toggle-desktop",role:"radio","aria-checked":!n,isSelected:!n,borderTopLeftRadius:"base",borderBottomLeftRadius:"base",onClick:function(){return r(!1)}},i.createElement(E8,null)),i.createElement(Iie,{"data-testid":"toggle-mobile",role:"radio","aria-checked":n,isSelected:n,borderTopRightRadius:"base",borderBottomRightRadius:"base",onClick:function(){return r(!0)}},i.createElement(r7,null)))};var Rie,Nie=["children","isWide","onToggle","previewWindowProps","embedded"],Fie=fr(wr,{shouldForwardProp:function(e){return"isWide"!==e}})((function(e){var t=e.theme;return"\n        align-items: center;\n        flex-direction: column;\n        gap: 40px;\n        height: 90%;\n        position: relative;\n        top: 5%;\n        width: 100%;\n\n        "+(e.isWide?"":t.responsive.smallScreenOnly(Rie||(Rie=zM(["\n                height: 350px;\n            "]))))+"\n    "})),jie=fr(_r,{shouldForwardProp:function(e){return"isMobile"!==e&&"isWide"!==e&&"previewWindowProps"!==e}})((function(e){var t=e.isMobile,n=e.isWide,r=e.theme,o=e.previewWindowProps;return"\n            overflow: hidden;\n            pointer-events: auto;\n            position: relative;\n            user-select: none;\n            width: "+(n?t?35:90:t?30:80)+"%;\n\n            /* Add max-width constraints to prevent previews from becoming too large */\n            max-width: "+(t?"625px":"1725px")+";\n\n            aspect-ratio: "+(t?.56:1.568)+";\n\n            /* Add padding to accommodate shadow */\n            padding: 30px;\n            box-sizing: border-box;\n\n            /* Ensure content fits properly */\n            display: flex;\n            align-items: stretch;\n\n            > * {\n                width: 100%;\n                height: 100%;\n                position: relative;\n            }\n\n            "+(n?"":r.responsive.extraLargeScreenOnly("\n                width: "+(t?25:70)+"%;\n            "))+"\n\n            "+r.responsive.smallScreenOnly("\n                width: "+(t?35:90)+"%;\n            ")+"\n\n            "+(null==o?void 0:o.css)+"\n        "}));const Yie=function(e){var r=e.children,o=e.isWide,a=e.onToggle,s=e.previewWindowProps,l=e.embedded,c=void 0!==l&&l,u=t(e,Nie),d=m((0,i.useState)(!1),2),p=d[0],f=d[1];return(0,i.useLayoutEffect)((function(){null==a||a(!c&&p)}),[p,a,c]),i.createElement(bC,{theme:bk,resetCSS:!1},c?i.createElement(_r,n({w:"100%",h:"100%",minH:"0",position:"relative",display:"flex",flexDirection:"column",overflow:"hidden"},u),i.createElement(_r,n({flex:"1",minH:"0",minW:"0",position:"relative",w:"100%",h:"100%",overflow:"hidden",display:"flex",alignItems:"stretch",justifyContent:"center"},s),r)):i.createElement(Fie,n({},u,{isWide:o}),i.createElement(Bie,{isMobile:p,setIsMobile:f}),i.createElement(jie,n({isMobile:p,isWide:o},s),r)))};var $ie,Hie={disconnectFromGoogle:($ie=Lo(Io().mark((function e(){return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",void 0);case 1:case"end":return e.stop()}}),e)}))),function(){return $ie.apply(this,arguments)}),getGoogleEmail:function(){return null},isTryingToDownloadVideo:function(){return!1}},Uie=function(e){var t=e.isSlideshow,n=e.durationMs;return t?i.createElement(wie,{durationMs:n}):null};const zie=function(e){var t,r,o,a=e.brandName,s=e.brandTheme,l=e.eventName,c=e.images,u=e.isWide,d=e.layoutType,p=void 0===d?"hmason":d,f=e.marketingModal,h=e.thumbnailGutterWidth,g=void 0===h?"s":h,v=e.thumbnailSize,y=void 0===v?"m":v,b=e.bannerText,_=e.bannerUrl,A=e.useCoversAsBanners,E=e.coverPhoto,w=e.scrollable,x=void 0!==w&&w,k=e.embedded,C=void 0!==k&&k,S=e.screenshotDeterrence,M=void 0===S?{}:S,T=M.showDesktopDeterrence,O=void 0!==T&&T,D=M.desktopDeterrenceTitle,L=M.desktopDeterrenceBody,P=M.showMobileDeterrence,I=void 0!==P&&P,B=M.mobileDeterrenceBlurType,R=void 0===B?"horizontal":B,N=(0,i.useRef)(null),F=(0,i.useRef)(null),j=m((0,i.useState)(!1),2),Y=j[0],$=j[1],H=m((0,i.useState)(0),2),U=H[0],z=H[1],W=Lie({containerRef:N,isMobile:Y}),V=W.scale,G=W.width,Q=W.height,q=Co("studio.welcome.galleryPreview"),K=Co("studio.gallery.brandingMenu.screenshotDeterrenceSection"),Z=(0,i.useMemo)((function(){return Gd(N9(s))}),[s]),J=(0,i.useMemo)((function(){var e=new Map;return c.forEach((function(t){var n,r;"event-slideshow"!==(n=(r=t).type)&&"event-album-slideshow"!==n||"active"!==r.photoStatus||e.set(t.id,t.duration)})),e}),[c]),X='a, button, [role="button"], input, select, textarea, .chakra-link, .chakra-button';(0,i.useLayoutEffect)((function(){if(x){var e=F.current;if(e){var t=function(){var t=e.offsetWidth-e.clientWidth;z(t>0?t:0)};return t(),window.addEventListener("resize",t),function(){return window.removeEventListener("resize",t)}}}else z(0)}),[x,G,Q,Y]),(0,i.useEffect)((function(){return I&&Y&&o9({screenshotProtectionEnabled:!1,windowFocusProtectionLevel:"off",mobileProtectionEnabled:!0,mobileBlurType:R,forceMobile:!0,targetSelectors:['#gallery-preview [data-testid="photo-grid-item"] img']}),function(){X6&&(X6.stop(),X6=null),e9&&(e9.stop(),e9=null),J6=null,t9=!1,n9=!1}}),[I,Y,R]);var ee=(0,i.useMemo)((function(){var e,t,n;if(A&&E&&E.displayUrl)return{width:E.width,height:E.height,focalPoint:{x:E.focalPointPercentages.x,y:E.focalPointPercentages.y},urlSmall:null!==(e=E.displayUrl.thumb)&&void 0!==e?e:"",urlMedium:null!==(t=E.displayUrl.medium)&&void 0!==t?t:"",urlLarge:null!==(n=E.displayUrl.large)&&void 0!==n?n:""}}),[A,E]);return i.createElement(Yie,{"data-testid":"gallery-preview",id:"gallery-preview",isWide:u,onToggle:$,embedded:C,previewWindowProps:{boxShadow:C?"none":"0 4px 30px 0 rgba(0, 0, 0, 0.1)",padding:"0 !important",boxSizing:"inherit !important"}},i.createElement(bC,{cssVarsRoot:"#gallery-preview",resetCSS:!1,theme:Z},i.createElement(_r,{w:"100%",h:"100%",minH:"0",minW:"0",position:"relative"},i.createElement(_r,{"data-testid":"preview-window",ref:N,position:"absolute",top:0,left:0,right:0,bottom:0,w:"100%",h:"100%",minH:"0",minW:"0",background:"background"},i.createElement(_r,{height:Q+"px",left:0,position:"absolute",top:0,transform:"scale("+V+")",transformOrigin:"left top",width:G+"px",overflowY:x?"auto":"hidden",overscrollBehavior:x?"contain":void 0,ref:x?F:void 0,sx:kC({},X,{pointerEvents:"none"})},b&&i.createElement(F9,{bannerText:b,bannerUrl:_}),f&&i.createElement(Die,n({},f,{isMobile:Y})),i.createElement(eoe,{cartCount:10,favoritesCount:2,homeLinkHref:"home",homeLinkLabel:"photos",isAboutVisible:!0,isCartVisible:!0,isLargeScreen:!Y,toolbarActions:{canBuyAll:function(){return!0},buyAll:function(){return null},canComparePhotos:function(){return!0},comparePhotos:function(){return null},canDownloadAll:function(){return!0},downloadAll:function(){return null},setDownloadDestination:function(){return null},getRemainingDownloads:function(){return null},cancelDownload:function(){return null},canStartSlideshow:function(){return!0},startSlideshow:function(){return null},canBuyPackage:function(){return!1},buyPackage:function(){return null},canShare:function(){return!1},emailFavorites:function(){return null},canSendFavoritesToPhotographer:function(){return!1},sendFavoritesToPhotographer:function(){return null}},requiresDownloadDestination:!1,selectedRoute:"Home",selectedUri:"home",shareCopyLinkUrl:"mock-url",shareUrls:{},spFreeDigitals:Hie,studioName:a,translateFilter:q}),i.createElement(loe,{headingText:l,isLargeScreen:!Y,coverPhoto:ee,photoCount:c.length,translateFilter:q}),i.createElement(wr,{alignItems:"center",flexDirection:"column",paddingBottom:Y?"108px":"32px",paddingX:Y?"16px":"32px",width:"100%"},i.createElement(_r,{width:"100%"},i.createElement(T9,{layoutType:p,photos:c.map((function(e){var t;return{id:e.id,url:null===(t=e.displayUrl)||void 0===t?void 0:t.medium,filterBlackAndWhite:!1,height:e.height,width:e.width}})),PhotoOverlayComponent:Uie,getPhotoOverlayProps:function(e){return{isSlideshow:J.has(e.id),durationMs:J.get(e.id)}},containerElement:x&&null!==(t=F.current)&&void 0!==t?t:void 0,thumbnailGutterWidth:Y?"s":g,thumbnailSize:y}))),O&&!Y&&i.createElement(Eie,{colorScheme:s.colorScheme,logoUrl:null!==(r=null===(o=s.eventBrandLogo)||void 0===o?void 0:o.displayUrl.original)&&void 0!==r?r:s.logoUrl,brandName:a,isKeyboardTrigger:!0,positionStyle:"absolute",warningTitle:D||K("defaultTitle"),warningBody:L||K("defaultBody")})))),Y&&i.createElement(_r,{height:Q+"px",left:0,position:"absolute",top:0,transform:"scale("+V+")",transformOrigin:"left top",width:"calc("+G+"px - "+U+"px)",zIndex:3,pointerEvents:"none",sx:kC({},X,{pointerEvents:"none"})},i.createElement(goe,{cartCount:10,favoritesCount:2,homeLinkHref:"home",homeLinkLabel:"photos",isAboutVisible:!0,isCartVisible:!0,isAbsolutePositioned:!0,selectedRoute:"Home",selectedUri:"home",translateFilter:q}))))};const Wie=function(e){var t=e.staticUrl;return i.createElement(Tr,{styles:"\n            @font-face {\n                font-family: bambusa-pro-regular;\n                src: url('"+t+"/common/font/BambusaPro_Regular.eot');\n                src: url('"+t+"/common/font/BambusaPro_Regular.eot#iefix') format('embedded-opentype'),\n                    url('"+t+"/common/font/BambusaPro_Regular.woff') format('woff'),\n                    url('"+t+"/common/font/BambusaPro_Regular.woff2') format('woff2'),\n                    url('"+t+"/common/font/BambusaPro_Regular.ttf') format('truetype');\n            }\n\n            @font-face {\n                font-family: blooming-elegant;\n                src: url('"+t+"/common/font/BloomingElegant-Regular.eot');\n                src: url('"+t+"/common/font/BloomingElegant-Regular.eot#iefix') format('embedded-opentype'),\n                    url('"+t+"/common/font/BloomingElegant-Regular.woff') format('woff'),\n                    url('"+t+"/common/font/BloomingElegant-Regular.woff2') format('woff2'),\n                    url('"+t+"/common/font/BloomingElegant-Regular.ttf') format('truetype');\n            }\n\n            @font-face {\n                font-family: brandon;\n                src: url('"+t+"/common/font/BrandonText-Regular.eot');\n                src: url('"+t+"/common/font/BrandonText-Regular.eot?#iefix') format('embedded-opentype'),\n                    url('"+t+"/common/font/BrandonText-Regular.woff2') format('woff2'),\n                    url('"+t+"/common/font/BrandonText-Regular.woff') format('woff'),\n                    url('"+t+"/common/font/BrandonText-Regular.ttf') format('truetype');\n            }\n\n            @font-face {\n                font-family: brandon;\n                font-weight: 700;\n                src: url('"+t+"/common/font/BrandonGrotesque-Bold.eot');\n                src: url('"+t+"/common/font/BrandonGrotesque-Bold.eot?#iefix') format('embedded-opentype'),\n                    url('"+t+"/common/font/BrandonGrotesque-Bold.woff2') format('woff2'),\n                    url('"+t+"/common/font/BrandonGrotesque-Bold.woff') format('woff'),\n                    url('"+t+"/common/font/BrandonGrotesque-Bold.ttf') format('truetype');\n            }\n\n            @font-face {\n                font-family: freeland;\n                src: url('"+t+"/common/font/Freeland.eot');\n                src: url('"+t+"/common/font/Freeland.eot?#iefix') format('embedded-opentype'),\n                    url('"+t+"/common/font/Freeland.woff2') format('woff2'),\n                    url('"+t+"/common/font/Freeland.woff') format('woff'),\n                    url('"+t+"/common/font/Freeland.ttf') format('truetype');\n            }\n\n            @font-face {\n                font-family: open-sans;\n                src: url('"+t+"/common/font/OpenSans-Regular.eot');\n                src: url('"+t+"/common/font/OpenSans-Regular.eot?#iefix') format('embedded-opentype'),\n                    url('"+t+"/common/font/OpenSans-Regular.woff2') format('woff2'),\n                    url('"+t+"/common/font/OpenSans-Regular.woff') format('woff'),\n                    url('"+t+"/common/font/OpenSans-Regular.ttf') format('truetype');\n            }\n\n            @font-face {\n                font-family: open-sans;\n                font-weight: 600;\n                src: url('"+t+"/common/font/OpenSans-SemiBold.eot');\n                src: url('"+t+"/common/font/OpenSans-SemiBold.eot?#iefix') format('embedded-opentype'),\n                    url('"+t+"/common/font/OpenSans-SemiBold.woff2') format('woff2'),\n                    url('"+t+"/common/font/OpenSans-SemiBold.woff') format('woff'),\n                    url('"+t+"/common/font/OpenSans-SemiBold.ttf') format('truetype');\n            }\n\n            @font-face {\n                font-family: open-sans;\n                font-weight: 700;\n                src: url('"+t+"/common/font/OpenSans-Bold.eot');\n                src: url('"+t+"/common/font/OpenSans-Bold.eot?#iefix') format('embedded-opentype'),\n                    url('"+t+"/common/font/OpenSans-Bold.woff2') format('woff2'),\n                    url('"+t+"/common/font/OpenSans-Bold.woff') format('woff'),\n                    url('"+t+"/common/font/OpenSans-Bold.ttf') format('truetype');\n            }\n\n            @font-face {\n                font-family: proxima-nova;\n                src: url('"+t+"/common/font/ProximaNova-Regular.eot');\n                src: url('"+t+"/common/font/ProximaNova-Regular.eot?#iefix') format('embedded-opentype'),\n                    url('"+t+"/common/font/ProximaNova-Regular.woff2') format('woff2'),\n                    url('"+t+"/common/font/ProximaNova-Regular.woff') format('woff'),\n                    url('"+t+"/common/font/ProximaNova-Regular.ttf') format('truetype');\n            }\n\n            @font-face {\n                font-family: proxima-nova;\n                font-weight: 600;\n                src: url('"+t+"/common/font/ProximaNova-SemiBold.eot');\n                src: url('"+t+"/common/font/ProximaNova-SemiBold.eot?#iefix') format('embedded-opentype'),\n                    url('"+t+"/common/font/ProximaNova-SemiBold.woff2') format('woff2'),\n                    url('"+t+"/common/font/ProximaNova-SemiBold.woff') format('woff'),\n                    url('"+t+"/common/font/ProximaNova-SemiBold.ttf') format('truetype');\n            }\n\n            @font-face {\n                font-family: scandiebox-one;\n                src: url('"+t+"/common/font/SBOne-Regular.eot');\n                src: url('"+t+"/common/font/SBOne-Regular.eot#iefix') format('embedded-opentype'),\n                    url('"+t+"/common/font/SBOne-Regular.woff') format('woff'),\n                    url('"+t+"/common/font/SBOne-Regular.woff2') format('woff2'),\n                    url('"+t+"/common/font/SBOne-Regular.ttf') format('truetype');\n            }\n\n            /* Google Fonts - Regular weights only (matching actual font files) */\n            @font-face {\n                font-family: 'Roboto';\n                src: url('"+t+"/common/font/Roboto-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Lato';\n                src: url('"+t+"/common/font/Lato-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Inter';\n                src: url('"+t+"/common/font/Inter-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Montserrat';\n                src: url('"+t+"/common/font/Montserrat-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Spectral';\n                src: url('"+t+"/common/font/Spectral-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Playfair Display';\n                src: url('"+t+"/common/font/PlayfairDisplay-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Dancing Script';\n                src: url('"+t+"/common/font/DancingScript-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Oswald';\n                src: url('"+t+"/common/font/Oswald-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Quicksand';\n                src: url('"+t+"/common/font/Quicksand-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Raleway';\n                src: url('"+t+"/common/font/Raleway-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'PT Sans';\n                src: url('"+t+"/common/font/PTSans-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Red Hat Display';\n                src: url('"+t+"/common/font/RedHatDisplay-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Merriweather';\n                src: url('"+t+"/common/font/Merriweather-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Figtree';\n                src: url('"+t+"/common/font/Figtree-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Palanquin';\n                src: url('"+t+"/common/font/Palanquin-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Slabo 27px';\n                src: url('"+t+"/common/font/Slabo27px-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Sora';\n                src: url('"+t+"/common/font/Sora-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Cabin';\n                src: url('"+t+"/common/font/Cabin-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Cormorant Garamond';\n                src: url('"+t+"/common/font/CormorantGaramond-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Caveat';\n                src: url('"+t+"/common/font/Caveat-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Shadows Into Light';\n                src: url('"+t+"/common/font/ShadowsIntoLight-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Reenie Beanie';\n                src: url('"+t+"/common/font/ReenieBeanie-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Bilbo Swash Caps';\n                src: url('"+t+"/common/font/BilboSwashCaps-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Indie Flower';\n                src: url('"+t+"/common/font/IndieFlower-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Urbanist';\n                src: url('"+t+"/common/font/Urbanist-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Barlow Semi Condensed';\n                src: url('"+t+"/common/font/BarlowSemiCondensed-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Bebas Neue';\n                src: url('"+t+"/common/font/BebasNeue-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n\n            @font-face {\n                font-family: 'Lora';\n                src: url('"+t+"/common/font/Lora-Regular.woff2') format('woff2');\n                font-weight: 400;\n                font-display: swap;\n            }\n        "})};var Vie=c6(zie);const Gie=function(e){return i.createElement(i.Fragment,null,i.createElement(Wie,{staticUrl:window.location.origin.replace("studio","static")}),i.createElement(Vie,e))};var Qie=function(e){e()},qie=c6($q(Fq));function Kie(e){const{theme:t}=Pr(),n=gC();return(0,i.useMemo)((()=>function(e,t){const n=n=>{var r;return{...t,...n,position:Kk(null!=(r=null==n?void 0:n.position)?r:null==t?void 0:t.position,e)}},r=e=>{const t=n(e),r=hC(t);return dC.notify(r,t)};return r.update=(e,t)=>{dC.update(e,n(t))},r.promise=(e,t)=>{const n=r({...t.loading,status:"loading",duration:null});e.then((e=>r.update(n,{status:"success",duration:5e3,...b(t.success,e)}))).catch((e=>r.update(n,{status:"error",duration:5e3,...b(t.error,e)})))},r.closeAll=dC.closeAll,r.close=dC.close,r.isActive=dC.isActive,r}(t.direction,{...n,...e})),[e,t.direction,n])}var Zie=["bodyStyles","children","closeButtonLabel","footerContent","headingContent","isDarkTheme","isOpen","hideCloseButton","size","onClose"];const Jie=function(e){var r=e.bodyStyles,o=e.children,a=e.closeButtonLabel,s=e.footerContent,l=e.headingContent,c=e.isDarkTheme,u=e.isOpen,d=e.hideCloseButton,p=void 0!==d&&d,f=e.size,h=void 0===f?"lg":f,m=e.onClose,g=t(e,Zie);return i.createElement(lte,n({isOpen:u,onClose:m,size:h},g),i.createElement(vF,{"data-testid":"side-panel-overlay"}),i.createElement(fte,{borderRadius:"0","data-testid":"side-panel"},i.createElement(dF,{borderBottomColor:c?"black":"gray.300",borderBottomStyle:"solid",borderBottomWidth:"1px",fontSize:"24px",fontWeight:"normal",height:"60px",paddingX:"20px",paddingY:"12px",zIndex:"2"},i.createElement(wr,{"data-testid":"side-panel-header",alignItems:"center",justifyContent:"space-between"},l,!p&&i.createElement(cB,{"aria-label":a||"Close",color:"inherit","data-testid":"side-panel-close-button",background:"transparent",marginLeft:"auto",marginTop:"0",padding:"8px",position:"inherit",zIndex:"1",_hover:{color:"brand.primary"}}))),i.createElement(lB,{"data-testid":"side-panel-body",id:"side-panel-body",padding:"0px",zIndex:"3",style:r},o),s&&i.createElement(pF,{"data-testid":"side-panel-footer",borderTopColor:c?"black":"gray.200",borderTopStyle:"solid",borderTopWidth:"1px",paddingX:"20px",paddingY:"12px",zIndex:"1"},s)))};function Xie(e={}){const{timeout:t=300,preventDefault:n=(()=>!0)}=e,[r,o]=(0,i.useState)([]),a=(0,i.useRef)(),s=()=>{a.current&&(clearTimeout(a.current),a.current=null)};return(0,i.useEffect)((()=>s),[]),function(e){return i=>{if("Backspace"===i.key){const e=[...r];return e.pop(),void o(e)}if(function(e){const{key:t}=e;return 1===t.length||t.length>1&&/[^a-zA-Z0-9]/.test(t)}(i)){const l=r.concat(i.key);n(i)&&(i.preventDefault(),i.stopPropagation()),o(l),e(l.join("")),s(),a.current=setTimeout((()=>{o([]),a.current=null}),t)}}}}function eae(e){const t=e.target,{tagName:n,isContentEditable:r}=t;return"INPUT"!==n&&"TEXTAREA"!==n&&!0!==r}function tae(e={}){const{ref:t,isDisabled:n,isFocusable:r,clickOnEnter:o=!0,clickOnSpace:a=!0,onMouseDown:s,onMouseUp:l,onClick:c,onKeyDown:u,onKeyUp:d,tabIndex:p,onMouseOver:f,onMouseLeave:h,...m}=e,[g,v]=(0,i.useState)(!0),[y,b]=(0,i.useState)(!1),_=function(){const e=(0,i.useRef)(new Map),t=e.current,n=(0,i.useCallback)(((t,n,r,o)=>{e.current.set(r,{type:n,el:t,options:o}),t.addEventListener(n,r,o)}),[]),r=(0,i.useCallback)(((t,n,r,o)=>{t.removeEventListener(n,r,o),e.current.delete(r)}),[]);return(0,i.useEffect)((()=>()=>{t.forEach(((e,t)=>{r(e.el,e.type,t,e.options)}))}),[r,t]),{add:n,remove:r}}(),E=g?p:p||0,w=n&&!r,x=(0,i.useCallback)((e=>{if(n)return e.stopPropagation(),void e.preventDefault();e.currentTarget.focus(),null==c||c(e)}),[n,c]),k=(0,i.useCallback)((e=>{y&&eae(e)&&(e.preventDefault(),e.stopPropagation(),b(!1),_.remove(document,"keyup",k,!1))}),[y,_]),C=(0,i.useCallback)((e=>{if(null==u||u(e),n||e.defaultPrevented||e.metaKey)return;if(!eae(e.nativeEvent)||g)return;const t=o&&"Enter"===e.key;if(a&&" "===e.key&&(e.preventDefault(),b(!0)),t){e.preventDefault();e.currentTarget.click()}_.add(document,"keyup",k,!1)}),[n,g,u,o,a,_,k]),S=(0,i.useCallback)((e=>{if(null==d||d(e),n||e.defaultPrevented||e.metaKey)return;if(!eae(e.nativeEvent)||g)return;if(a&&" "===e.key){e.preventDefault(),b(!1);e.currentTarget.click()}}),[a,g,n,d]),M=(0,i.useCallback)((e=>{0===e.button&&(b(!1),_.remove(document,"mouseup",M,!1))}),[_]),T=(0,i.useCallback)((e=>{if(0!==e.button)return;if(n)return e.stopPropagation(),void e.preventDefault();g||b(!0);e.currentTarget.focus({preventScroll:!0}),_.add(document,"mouseup",M,!1),null==s||s(e)}),[n,g,s,_,M]),O=(0,i.useCallback)((e=>{0===e.button&&(g||b(!1),null==l||l(e))}),[l,g]),D=(0,i.useCallback)((e=>{n?e.preventDefault():null==f||f(e)}),[n,f]),L=(0,i.useCallback)((e=>{y&&(e.preventDefault(),b(!1)),null==h||h(e)}),[y,h]),P=Ur(t,(e=>{e&&"BUTTON"!==e.tagName&&v(!1)}));return g?{...m,ref:P,type:"button","aria-disabled":w?void 0:n,disabled:w,onClick:x,onMouseDown:s,onMouseUp:l,onKeyUp:d,onKeyDown:u,onMouseOver:f,onMouseLeave:h}:{...m,ref:P,role:"button","data-active":A(y),"aria-disabled":n?"true":void 0,tabIndex:w?void 0:E,onClick:x,onMouseDown:T,onMouseUp:O,onKeyUp:S,onKeyDown:C,onMouseOver:D,onMouseLeave:L}}function nae(e,t){var n;const r=e.target;if(r){if(!rae(r).contains(r))return!1}return!(null==(n=t.current)?void 0:n.contains(r))}function rae(e){var t;return null!=(t=null==e?void 0:e.ownerDocument)?t:document}var[oae,iae,aae,sae]=VK(),[lae,cae]=xr({strict:!1,name:"MenuContext"});function uae(e){var t;return null!=(t=null==e?void 0:e.ownerDocument)?t:document}function dae(e){return uae(e).activeElement===e}function pae(e={}){const{id:t,closeOnSelect:n=!0,closeOnBlur:r=!0,initialFocusRef:o,autoSelect:a=!0,isLazy:s,isOpen:l,defaultIsOpen:c,onClose:u,onOpen:d,placement:p="bottom-start",lazyBehavior:f="unmount",direction:h,computePositionOnMount:m=!1,...g}=e,v=(0,i.useRef)(null),y=(0,i.useRef)(null),b=aae(),_=(0,i.useCallback)((()=>{requestAnimationFrame((()=>{var e;null==(e=v.current)||e.focus({preventScroll:!1})}))}),[]),A=(0,i.useCallback)((()=>{const e=setTimeout((()=>{var e;if(o)null==(e=o.current)||e.focus();else{const e=b.firstEnabled();e&&O(e.index)}}));B.current.add(e)}),[b,o]),E=(0,i.useCallback)((()=>{const e=setTimeout((()=>{const e=b.lastEnabled();e&&O(e.index)}));B.current.add(e)}),[b]),w=(0,i.useCallback)((()=>{null==d||d(),a?A():_()}),[a,A,_,d]),{isOpen:x,onOpen:k,onClose:C,onToggle:S}=Wh({isOpen:l,defaultIsOpen:c,onClose:u,onOpen:w});!function(e){const{ref:t,handler:n,enabled:r=!0}=e,o=zh(n),a=(0,i.useRef)({isPointerDown:!1,ignoreEmulatedMouseEvents:!1}).current;(0,i.useEffect)((()=>{if(!r)return;const e=e=>{nae(e,t)&&(a.isPointerDown=!0)},i=e=>{a.ignoreEmulatedMouseEvents?a.ignoreEmulatedMouseEvents=!1:a.isPointerDown&&n&&nae(e,t)&&(a.isPointerDown=!1,o(e))},s=e=>{a.ignoreEmulatedMouseEvents=!0,n&&a.isPointerDown&&nae(e,t)&&(a.isPointerDown=!1,o(e))},l=rae(t.current);return l.addEventListener("mousedown",e,!0),l.addEventListener("mouseup",i,!0),l.addEventListener("touchstart",e,!0),l.addEventListener("touchend",s,!0),()=>{l.removeEventListener("mousedown",e,!0),l.removeEventListener("mouseup",i,!0),l.removeEventListener("touchstart",e,!0),l.removeEventListener("touchend",s,!0)}}),[n,t,o,a,r])}({enabled:x&&r,ref:v,handler:e=>{var t;(null==(t=y.current)?void 0:t.contains(e.target))||C()}});const M=Hh({...g,enabled:x||m,placement:p,direction:h}),[T,O]=(0,i.useState)(-1);qx((()=>{x||O(-1)}),[x]),zte(v,{focusRef:y,visible:x,shouldFocus:!0});const D=jte({isOpen:x,ref:v}),[L,P]=function(e,...t){const n=(0,i.useId)(),r=e||n;return(0,i.useMemo)((()=>t.map((e=>`${e}-${r}`))),[r,t])}(t,"menu-button","menu-list"),I=(0,i.useCallback)((()=>{k(),_()}),[k,_]),B=(0,i.useRef)(new Set([]));(0,i.useEffect)((()=>{const e=B.current;return()=>{e.forEach((e=>clearTimeout(e))),e.clear()}}),[]);const R=(0,i.useCallback)((()=>{k(),A()}),[A,k]),N=(0,i.useCallback)((()=>{k(),E()}),[k,E]),F=(0,i.useCallback)((()=>{var e,t;const n=uae(v.current),r=null==(e=v.current)?void 0:e.contains(n.activeElement);if(!(x&&!r))return;const o=null==(t=b.item(T))?void 0:t.node;null==o||o.focus({preventScroll:!0})}),[x,T,b]),j=(0,i.useRef)(null);return{openAndFocusMenu:I,openAndFocusFirstItem:R,openAndFocusLastItem:N,onTransitionEnd:F,unstable__animationState:D,descendants:b,popper:M,buttonId:L,menuId:P,forceUpdate:M.forceUpdate,orientation:"vertical",isOpen:x,onToggle:S,onOpen:k,onClose:C,menuRef:v,buttonRef:y,focusedIndex:T,closeOnSelect:n,closeOnBlur:r,autoSelect:a,setFocusedIndex:O,isLazy:s,lazyBehavior:f,initialFocusRef:o,rafId:j}}function fae(e){var t;return function(e){var t;if(!function(e){return null!=e&&"object"==typeof e&&"nodeType"in e&&e.nodeType===Node.ELEMENT_NODE}(e))return!1;const n=null!=(t=e.ownerDocument.defaultView)?t:window;return e instanceof n.HTMLElement}(e)&&!!(null==(t=null==e?void 0:e.getAttribute("role"))?void 0:t.startsWith("menuitem"))}function hae(e={},t=null){const{onMouseEnter:n,onMouseMove:r,onMouseLeave:o,onClick:a,onFocus:s,isDisabled:l,isFocusable:c,closeOnSelect:u,type:d,...p}=e,f=cae(),{setFocusedIndex:h,focusedIndex:m,closeOnSelect:g,onClose:v,menuRef:y,isOpen:b,menuId:_,rafId:A}=f,E=(0,i.useRef)(null),w=`${_}-menuitem-${(0,i.useId)()}`,{index:x,register:k}=sae({disabled:l&&!c}),C=(0,i.useCallback)((e=>{null==n||n(e),l||h(x)}),[h,x,l,n]),S=(0,i.useCallback)((e=>{null==r||r(e),E.current&&!dae(E.current)&&C(e)}),[C,r]),M=(0,i.useCallback)((e=>{null==o||o(e),l||h(-1)}),[h,l,o]),T=(0,i.useCallback)((e=>{null==a||a(e),fae(e.currentTarget)&&(null!=u?u:g)&&v()}),[v,a,g,u]),O=(0,i.useCallback)((e=>{null==s||s(e),h(x)}),[h,s,x]),D=x===m,L=l&&!c;qx((()=>{if(b)return D&&!L&&E.current?(A.current&&cancelAnimationFrame(A.current),A.current=requestAnimationFrame((()=>{var e;null==(e=E.current)||e.focus({preventScroll:!0}),A.current=null}))):y.current&&!dae(y.current)&&y.current.focus({preventScroll:!0}),()=>{A.current&&cancelAnimationFrame(A.current)}}),[D,L,y,b]);const P=tae({onClick:T,onFocus:O,onMouseEnter:C,onMouseMove:S,onMouseLeave:M,ref:Ur(k,E,t),isDisabled:l,isFocusable:c});return{...p,...P,type:null!=d?d:P.type,id:w,role:"menuitem",tabIndex:D?0:-1}}var[mae,gae]=xr({name:"MenuStylesContext",errorMessage:"useMenuStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Menu />\" "}),vae=e=>{const{children:t}=e,n=jr("Menu",e),r=pt(e),{direction:o}=Lr(),{descendants:a,...s}=pae({...r,direction:o}),l=(0,i.useMemo)((()=>s),[s]),{isOpen:c,onClose:u,forceUpdate:d}=l;return(0,br.jsx)(oae,{value:a,children:(0,br.jsx)(lae,{value:l,children:(0,br.jsx)(mae,{value:n,children:b(t,{isOpen:c,onClose:u,forceUpdate:d})})})})};vae.displayName="Menu";var yae=yr(((e,t)=>{const n=gae();return(0,br.jsx)(vr.button,{ref:t,...e,__css:{display:"inline-flex",appearance:"none",alignItems:"center",outline:0,...n.button}})})),bae=yr(((e,t)=>{const{children:n,as:r,...o}=e,a=function(e={},t=null){const n=cae(),{onToggle:r,popper:o,openAndFocusFirstItem:a,openAndFocusLastItem:s}=n,l=(0,i.useCallback)((e=>{const t=e.key,n={Enter:a,ArrowDown:a,ArrowUp:s}[t];n&&(e.preventDefault(),e.stopPropagation(),n(e))}),[a,s]);return{...e,ref:Ur(n.buttonRef,t,o.referenceRef),id:n.buttonId,"data-active":A(n.isOpen),"aria-expanded":n.isOpen,"aria-haspopup":"menu","aria-controls":n.menuId,onClick:w(e.onClick,r),onKeyDown:w(e.onKeyDown,l)}}(o,t),s=r||yae;return(0,br.jsx)(s,{...a,className:g("chakra-menu__menu-button",e.className),children:(0,br.jsx)(vr.span,{__css:{pointerEvents:"none",flex:"1 1 auto",minW:0},children:e.children})})}));bae.displayName="MenuButton";var _ae=yr(((e,t)=>{const n=gae();return(0,br.jsx)(vr.span,{ref:t,...e,__css:n.command,className:"chakra-menu__command"})}));_ae.displayName="MenuCommand";var Aae=yr(((e,t)=>{const{type:n,...r}=e,o=gae(),a=r.as||n?null!=n?n:void 0:"button",s=(0,i.useMemo)((()=>({textDecoration:"none",color:"inherit",userSelect:"none",display:"flex",width:"100%",alignItems:"center",textAlign:"start",flex:"0 0 auto",outline:0,...o.item})),[o.item]);return(0,br.jsx)(vr.button,{ref:t,type:a,...r,__css:s})})),Eae=e=>{const{className:t,children:n,...r}=e,o=gae(),a=i.Children.only(n),s=(0,i.isValidElement)(a)?(0,i.cloneElement)(a,{focusable:"false","aria-hidden":!0,className:g("chakra-menu__icon",a.props.className)}):null,l=g("chakra-menu__icon-wrapper",t);return(0,br.jsx)(vr.span,{className:l,...r,__css:o.icon,children:s})};Eae.displayName="MenuIcon";var wae=yr(((e,t)=>{const{icon:n,iconSpacing:r="0.75rem",command:o,commandSpacing:i="0.75rem",children:a,...s}=e,l=hae(s,t),c=n||o?(0,br.jsx)("span",{style:{pointerEvents:"none",flex:1},children:a}):a;return(0,br.jsxs)(Aae,{...l,className:g("chakra-menu__menuitem",l.className),children:[n&&(0,br.jsx)(Eae,{fontSize:"0.8em",marginEnd:r,children:n}),c,o&&(0,br.jsx)(_ae,{marginStart:i,children:o})]})}));wae.displayName="MenuItem";var xae={enter:{visibility:"visible",opacity:1,scale:1,transition:{duration:.2,ease:[.4,0,.2,1]}},exit:{transitionEnd:{visibility:"hidden"},opacity:0,scale:.8,transition:{duration:.1,easings:"easeOut"}}},kae=vr(Yw.div),Cae=yr((function(e,t){var n,r;const{rootProps:o,motionProps:a,...s}=e,{isOpen:l,onTransitionEnd:c,unstable__animationState:u}=cae(),d=function(e={},t=null){const n=cae();if(!n)throw new Error("useMenuContext: context is undefined. Seems you forgot to wrap component within <Menu>");const{focusedIndex:r,setFocusedIndex:o,menuRef:a,isOpen:s,onClose:l,menuId:c,isLazy:u,lazyBehavior:d,unstable__animationState:p}=n,f=iae(),h=Xie({preventDefault:e=>" "!==e.key&&fae(e.target)}),m=(0,i.useCallback)((e=>{if(!e.currentTarget.contains(e.target))return;const t=e.key,n={Tab:e=>e.preventDefault(),Escape:l,ArrowDown:()=>{const e=f.nextEnabled(r);e&&o(e.index)},ArrowUp:()=>{const e=f.prevEnabled(r);e&&o(e.index)}},i=n[t];if(i)return e.preventDefault(),void i(e);const a=h((e=>{const t=function(e,t,n,r){if(null==t)return r;if(!r)return e.find((e=>n(e).toLowerCase().startsWith(t.toLowerCase())));const o=e.filter((e=>n(e).toLowerCase().startsWith(t.toLowerCase())));if(o.length>0){let t;return o.includes(r)?(t=o.indexOf(r)+1,t===o.length&&(t=0),o[t]):(t=e.indexOf(o[0]),e[t])}return r}(f.values(),e,(e=>{var t,n;return null!=(n=null==(t=null==e?void 0:e.node)?void 0:t.textContent)?n:""}),f.item(r));if(t){const e=f.indexOf(t.node);o(e)}}));fae(e.target)&&a(e)}),[f,r,h,l,o]),g=(0,i.useRef)(!1);s&&(g.current=!0);const v=Vte({wasSelected:g.current,enabled:u,mode:d,isSelected:p.present});return{...e,ref:Ur(a,t),children:v?e.children:null,tabIndex:-1,role:"menu",id:c,style:{...e.style,transformOrigin:"var(--popper-transform-origin)"},"aria-orientation":"vertical",onKeyDown:w(e.onKeyDown,m)}}(s,t),p=function(e={}){const{popper:t,isOpen:n}=cae();return t.getPopperProps({...e,style:{visibility:n?"visible":"hidden",...e.style}})}(o),f=gae();return(0,br.jsx)(vr.div,{...p,__css:{zIndex:null!=(r=e.zIndex)?r:null==(n=f.list)?void 0:n.zIndex},children:(0,br.jsx)(kae,{variants:xae,initial:!1,animate:l?"enter":"exit",__css:{outline:0,...f.list},...a,className:g("chakra-menu__menu-list",d.className),...d,onUpdate:c,onAnimationComplete:x(u.onComplete,d.onAnimationComplete)})})}));Cae.displayName="MenuList";var Sae=["children","items"],Mae=["content"];function Tae(){return Tae=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Tae.apply(null,arguments)}function Oae(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}var Dae=pr(_r,{target:"etp6m5r2"})({name:"13tccqg",styles:"[x-placement='bottom-end']:before{top:-6px;transform:rotate(45deg);}[x-placement='top-end']:before{bottom:-6px;transform:rotate(225deg);}"}),Lae=pr(wae,{shouldForwardProp:e=>"isDestructive"!==e,target:"etp6m5r1"})((e=>{var{isDestructive:t,theme:n}=e;return"\n        color: "+(t?n.colors.red[600]:n.colors.gray[600])+";\n        cursor: pointer;\n        min-height: auto;\n        padding: 0 16px;\n\n        &:focus, &:hover {\n            background: inherit;\n        }\n\n        &:not(:last-of-type) {\n            margin-bottom: 8px;\n        }\n    "}),""),Pae=pr(Cae,{target:"etp6m5r0"})((e=>{var{theme:t}=e;return"\n        border-color: "+t.colors.gray[200]+";\n        margin-right: -5px;\n        min-width: 125px;\n        padding-bottom: 10px;\n        padding-top: 13px;\n\n        &:before {\n            background: white;\n            border: 1px solid "+t.colors.gray[200]+";\n            border-bottom: none;\n            border-right: none;\n            height: 10px;\n            position: absolute;\n            right: 11px;\n            width: 10px;\n        }\n    "}),"");const Iae=e=>{var{children:t,items:n}=e,r=Oae(e,Sae);return Mr(Dae,Tae({"data-testid":"sp-ui-kebab-menu",height:"24px",width:"24px"},r),Mr(vae,{placement:"bottom-end"},Mr(bae,{as:_r,cursor:"pointer"},t||Mr(SF,{"data-testid":"sp-ui-kebab-menu-svg"})),Mr(Pae,{"data-testid":"sp-ui-kebab-menu-list"},n.map(((e,t)=>{var{content:n}=e,r=Oae(e,Mae);return Mr(Lae,Tae({as:fx,"data-testid":"sp-ui-kebab-menu-item-"+t,key:t},r),n)})))))};function Bae(e){var t=(0,i.useCallback)((function(e){return o((function(){return e}))}),[]),n=m((0,i.useState)((function(){return e||qT})),2),r=n[0],o=n[1];return[r,t]}var Rae=fr("div")((function(e){var t=e.theme;return{border:"1px solid "+t.colors.gray[200],borderRadius:"2px",padding:"20px",marginTop:t.spacing.lg}})),Nae=fr(UI)((function(e){return{color:e.theme.colors.gray[700],fontWeight:600,marginBottom:0}})),Fae=fr(wr)({flexDirection:"row",justifyContent:"space-between",alignItems:"center",marginBottom:"20px"}),jae=fr(wr)({marginTop:"10px",flexDirection:"row",justifyContent:"space-between"}),Yae=fr(_r)({textTransform:"uppercase",fontSize:"10px",fontWeight:300}),$ae=fr(Px)({marginBottom:0,fontSize:"14px",textTransform:"capitalize"}),Hae=fr("h3")((function(e){return"\n    font-size: "+e.theme.fontSizes["2xl"]+";\n"}));const Uae=function(e){var t,n=e.accountData,r=e.accountStatus,o=e.handleConnect,a=e.handleDisconnect,s="connected"===r,l=Co("studio.payments.accounts.accountList"),c=m(Bae(),2),u=c[0],d=c[1],p=(null==n?void 0:n.countInvoicesWithVaultedCards)||0,f=s?[{content:l("disconnectAction"),isDestructive:!0,onClick:function(){if("disconnected"!==r)return p?u():a()},"data-testid":"stripe-standard-disconnect"}]:[{content:l("connectAction"),onClick:o,"data-testid":"stripe-standard-connect"}],h=s?zx.Success:zx.Danger,g=l(s?"studio.account.spPay.setupPayments.status.connected":"studio.account.spPay.setupPayments.status.disconnected");return i.createElement(i.Fragment,null,i.createElement(Hae,null,l("settings")),!s&&i.createElement(ep,{marginBottom:"20px",variant:Jd.Warning},i.createElement(wr,{alignItems:"center"},i.createElement(_r,{flexShrink:0,height:"30px",marginRight:"14px",width:"32px"},i.createElement(CF,null)),i.createElement(_r,null,i.createElement(UI,{style:{marginBottom:0}},l("disconnectedBanner.heading")),i.createElement(Px,{whiteSpace:"pre-line"},l("studio.account.stripeStandard.setupPayments.stripeStandardConnected.paymentGatewayNotConnected"),i.createElement("br",null),i.createElement("br",null),i.createElement(Sx,{"data-testid":"setup-stripe-standard-complete-reconnect-text-cta",marginLeft:"4px",onClick:function(e){e.persist(),o()}},l("studio.account.stripeStandard.setupPayments.stripeStandardConnected.connectStripeStandard")))))),i.createElement(Rae,null,i.createElement(Fae,{flexDirection:"column"},i.createElement(Nae,{fontWeight:"semibold"},null!==(t=null==n?void 0:n.statementDescriptor)&&void 0!==t?t:""),i.createElement(wr,null,i.createElement(Vx,{variant:h,statusPillText:g}),i.createElement(Iae,{items:f}))),i.createElement(_r,null,i.createElement(Yae,null,l("payout-schedule")),i.createElement($ae,null,l("payout-schedule-values."+(null==n?void 0:n.payoutSchedule)))),i.createElement(jae,{alignItems:"end"},i.createElement(_r,null,(null==n?void 0:n.bankName)&&(null==n?void 0:n.last4)&&i.createElement(i.Fragment,null,i.createElement(Yae,null,l("default-payout-method")),i.createElement($ae,null,(null==n?void 0:n.bankName)+" •••• "+(null==n?void 0:n.last4)))),i.createElement(Sx,{"data-testid":"setup-stripe-standard-complete-view-account",target:"_blank",href:"https://dashboard.stripe.com/"+(null==n?void 0:n.id)},l("view-account")))),i.createElement(Fq,{centerHeading:!1,headerText:"studio.payments.accounts.accountList.hasNonPaidInvoicesWithAutopayModal.heading",hideSecondaryAction:!1,icon:i.createElement(CF,{height:"78px",width:"78px"}),openSubscribe:d,primaryAction:function(e){e(),a()},primaryActionText:"studio.payments.accounts.accountList.disconnectAction",secondaryActionText:"studio.payments.accounts.accountList.hasNonPaidInvoicesWithAutopayModal.secondaryButton"},i.createElement(Px,{marginBottom:"10px"},l("hasNonPaidInvoicesWithAutopayModal.description"))))};const zae=function(e){var t=e.handleStripeStandardSetup,n=Co("studio.account.stripeStandard.setupPayments.stripeStandardInitialSetup"),r=(hO().me||{}).studio,o=(null!=r&&r.created?new Date(r.created):new Date)>new Date("2024-03-06");return i.createElement(i.Fragment,null,i.createElement(_r,{fontSize:"2xl",fontWeight:"light",marginBottom:"52px"},n("studio.account.spPay.setupPayments.title")),i.createElement(tee,null),i.createElement(qr,{fontSize:"md",fontFamily:"'azo-sans-web', 'Helvetica', 'Arial', sans-serif",marginTop:"20px",marginBottom:"23px"},n("subheading")),i.createElement(Wr,{maxHeight:"34px",minWidth:"105px","data-testid":"setup-stripe-standard-button",onClick:t,borderRadius:"2px",background:"blue.400",variant:"solid",fontWeight:"normal",fontSize:"12px",display:"flex",marginBottom:"25px",color:"white",_hover:{backgroundColor:"blue.700",color:"white"}},n("studio.account.spPay.setupPayments.start-setup")),!o&&i.createElement(Kr,{"data-testid":"view-other-gateways-link",onClick:function(){window.location.replace(new URL("/account/acceptpayments",window.location.origin).toString())},color:"navy.100"},n("viewOtherGateway")))};var Wae,Vae=fr(_r)((function(e){return"\n        border: 1px solid "+e.theme.colors.gray[200]+";\n        border-radius: 2px;\n        padding: 20px;\n        margin-bottom: 14px;\n    "})),Gae=fr(UI)((function(e){return"\n       color: "+e.theme.colors.gray[700]+" !important;\n       font-weight: 600!important;\n       margin-bottom: 0;\n        "})),Qae=fr(wr)(Wae||(Wae=zM(["\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n"]))),qae=fr("h3")((function(e){return"\n    font-size: "+e.theme.fontSizes["2xl"]+";\n"}));const Kae=function(e){var t=e.accountData,n=e.handleFinishSetup,r=(t||{}).statementDescriptor,o=Co("studio.account.spPay");return i.createElement(i.Fragment,null,i.createElement(qae,null,o("studio.account.spPay.setupPayments.title")),i.createElement(Vae,null,i.createElement(Qae,{flexDirection:"column"},i.createElement(Gae,{fontWeight:"semibold"},r),i.createElement(Vx,{variant:zx.Warning,statusPillText:o("setupPayments.status.incomplete")})),i.createElement(Px,{textAlign:"center",maxWidth:"75%",margin:"auto"},o("setupPayments.incompletePanel.subheading"))),i.createElement(_r,{display:"flex",flexDirection:"row",alignItems:"flex-end",justifyContent:"flex-end",gap:2},i.createElement(fp,{"merchantaccount-testid":"setup-payments-incomplete-finish-setup",onClick:n},o("setupPayments.finish-setup"))))};const Zae=function(e){var t=e.isOpen,n=e.onClose,r=e.currentBrandId,o=Kie(),a=Co("studio.account.spPay.setupPayments.account"),s=m((0,i.useState)("loading"),2),l=s[0],c=s[1],u=m((0,i.useState)("true"===new URLSearchParams(window.location.search).get("connected")),2),d=u[0],p=u[1],f=zo("brand/"+r+"/stripe-standard-account",{defer:!0}),h=f.response,g=f.performFetch,v=(0,i.useCallback)((function(){c("loading"),g()}),[g]),y=function(){o({title:a("error"),description:a("error-message"),status:"error",duration:9e3,isClosable:!0})},b=function(){o({title:a("connected"),description:a("connected-message"),status:"success",duration:9e3,isClosable:!0})};d&&(p(!1),b());var _=function(){c("redirect-stripe"),g({data:{},method:"POST"}).then((function(e){e&&(null==e?void 0:e.status)>=200&&(null==e?void 0:e.status)<=299&&e.data?window.location.replace(e.data.url):(y(),c("redirect-stripe"))})).catch((function(){y(),c("redirect-stripe")}))},A=function(){g({data:{},method:"DELETE"}).then((function(e){e&&(null==e?void 0:e.status)>=200&&(null==e?void 0:e.status)<=299?(o({title:a("disconnected"),description:a("disconnected-message"),status:"success",duration:9e3,isClosable:!0}),v()):y()})).catch((function(){y()}))},E=function(){g({data:{status:"connected"},method:"PATCH"}).then((function(e){e&&(null==e?void 0:e.status)>=200&&(null==e?void 0:e.status)<=299?(b(),v()):y()})).catch((function(){y()}))},w=function(){c("redirect-stripe"),g({data:{accountLinks:{status:"created"}},method:"PATCH"}).then((function(e){var t;c("redirect-stripe"),e&&(null==e?void 0:e.status)>=200&&(null==e?void 0:e.status)<=299&&null!==(t=e.accountData)&&void 0!==t&&t.url?window.location.replace(e.accountData.url):(y(),v())})).catch((function(){y(),v()}))};return(0,i.useEffect)((function(){v()}),[v]),(0,i.useEffect)((function(){null!=h&&h.accountStatus&&c(h.accountStatus)}),[h]),i.createElement(Jie,{isOpen:t,onClose:n,size:"lg",bodyStyles:{padding:"48px 20px "}},function(){switch(l){case"connected":case"disconnected":return null!=h&&h.accountData?i.createElement(Uae,{accountData:null==h?void 0:h.accountData,accountStatus:null==h?void 0:h.accountStatus,currentBrandId:r,handleConnect:E,handleDisconnect:A}):i.createElement(BF,null);case"incomplete":return null!=h&&h.accountData?i.createElement(Kae,{accountData:null==h?void 0:h.accountData,handleFinishSetup:w}):i.createElement(BF,null);case"redirect-stripe":return i.createElement(BF,{description:i.createElement(Px,{textAlign:"center"},"Continuing to Stripe.",i.createElement("br",null),"You will be redirected in a just a moment.")});case"unconfigured":return i.createElement(zae,{handleStripeStandardSetup:_});default:return i.createElement(BF,null)}}())};var Jae,Xae,ese=["title","titleId"];function tse(){return tse=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},tse.apply(null,arguments)}var nse=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,ese);return i.createElement("svg",tse({width:24,height:24,viewBox:"0 0 24 24",fill:"none",fillOpacity:0,xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Jae||(Jae=i.createElement("path",{d:"M5.00781 11.9922H19.9978",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})),Xae||(Xae=i.createElement("path",{d:"M11.011 6L5 12.012L11.011 18.024",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})))},rse=(0,i.forwardRef)(nse);o.p;const ose=function(){var e=Co();return i.createElement(wr,{flexDirection:"column",gap:2},i.createElement(tq,{fontSize:"xl",fontWeight:"light",margin:"0"},e("studio.account.acceptCreditCards.spPayNotAvailable")),i.createElement(qr,{fontSize:"l",fontWeight:"light"},e("studio.account.acceptCreditCards.pleaseContactSupport"),i.createElement(Kr,{href:"mailto:support@shootproof.com","data-testid":"",fontSize:"l",fontWeight:"light",color:"blue.500",textDecoration:"none",_hover:{color:"blue.600"}},"support@shootproof.com"),"."))};var ise,ase,sse,lse,cse,use,dse,pse,fse,hse,mse,gse,vse,yse,bse,_se,Ase,Ese,wse,xse,kse,Cse,Sse,Mse,Tse,Ose,Dse=["title","titleId"];function Lse(){return Lse=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Lse.apply(null,arguments)}var Pse=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Dse);return i.createElement("svg",Lse({width:120,height:120,viewBox:"0 0 120 120",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,ise||(ise=i.createElement("path",{d:"M2.85156 67.8496C2.85156 80.58 7.90869 92.789 16.9104 101.791C25.9122 110.792 38.1212 115.85 50.8516 115.85C63.582 115.85 75.7909 110.792 84.7927 101.791C93.7944 92.789 98.8516 80.58 98.8516 67.8496C98.8516 55.1192 93.7944 42.9102 84.7927 33.9085C75.7909 24.9067 63.582 19.8496 50.8516 19.8496C38.1212 19.8496 25.9122 24.9067 16.9104 33.9085C7.90869 42.9102 2.85156 55.1192 2.85156 67.8496Z",fill:"#D8ECF3"})),ase||(ase=i.createElement("path",{d:"M30.3633 106.452C30.3633 106.93 31.7172 107.388 34.1272 107.725C36.5372 108.063 39.8058 108.252 43.2141 108.252C46.6223 108.252 49.891 108.063 52.301 107.725C54.711 107.388 56.0649 106.93 56.0649 106.452C56.0649 105.975 54.711 105.517 52.301 105.18C49.891 104.842 46.6223 104.652 43.2141 104.652C39.8058 104.652 36.5372 104.842 34.1272 105.18C31.7172 105.517 30.3633 105.975 30.3633 106.452Z",fill:"#A0CEE9"})),sse||(sse=i.createElement("path",{d:"M69.5489 9.11955C69.5431 7.79484 69.0115 6.52664 68.0708 5.59387C67.1302 4.66109 65.8576 4.14013 64.5329 4.14555H21.8969C20.5721 4.14013 19.2995 4.66109 18.3589 5.59387C17.4182 6.52664 16.8866 7.79484 16.8809 9.11955V93.6691C16.8866 94.9939 17.4182 96.2621 18.3589 97.1948C19.2995 98.1276 20.5721 98.6486 21.8969 98.6431H64.5329C65.8576 98.6486 67.1302 98.1276 68.0708 97.1948C69.0115 96.2621 69.5431 94.9939 69.5489 93.6691V9.11955Z",fill:"white"})),lse||(lse=i.createElement("path",{d:"M69.5489 9.11955C69.5431 7.79484 69.0115 6.52664 68.0708 5.59387C67.1302 4.66109 65.8576 4.14013 64.5329 4.14555H21.8969C20.5721 4.14013 19.2995 4.66109 18.3589 5.59387C17.4182 6.52664 16.8866 7.79484 16.8809 9.11955V93.6691C16.8866 94.9939 17.4182 96.2621 18.3589 97.1948C19.2995 98.1276 20.5721 98.6486 21.8969 98.6431H64.5329C65.8576 98.6486 67.1302 98.1276 68.0708 97.1948C69.0115 96.2621 69.5431 94.9939 69.5489 93.6691V9.11955ZM64.5149 80.3995C64.5161 80.5561 64.4865 80.7113 64.4277 80.8564C64.3689 81.0014 64.2821 81.1335 64.1722 81.245C64.0622 81.3564 63.9314 81.4451 63.7872 81.506C63.643 81.5668 63.4882 81.5986 63.3317 81.5995H23.0981C22.9416 81.5984 22.7868 81.5665 22.6427 81.5056C22.4985 81.4447 22.3678 81.356 22.2579 81.2446C22.1481 81.1332 22.0612 81.0012 22.0023 80.8562C21.9435 80.7112 21.9138 80.556 21.9149 80.3995V19.2907C21.9138 19.1343 21.9435 18.9791 22.0023 18.8341C22.0612 18.6891 22.1481 18.5571 22.2579 18.4457C22.3678 18.3343 22.4985 18.2456 22.6427 18.1847C22.7868 18.1238 22.9416 18.0918 23.0981 18.0907H63.3317C63.4882 18.0917 63.643 18.1235 63.7872 18.1843C63.9314 18.2452 64.0622 18.3339 64.1722 18.4453C64.2821 18.5568 64.3689 18.6888 64.4277 18.8339C64.4865 18.979 64.5161 19.1342 64.5149 19.2907V80.3995Z",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),cse||(cse=i.createElement("path",{d:"M33.8535 10.368C33.8535 10.6862 33.9811 10.9915 34.2081 11.2165C34.4352 11.4415 34.7432 11.568 35.0643 11.568C35.3854 11.568 35.6934 11.4415 35.9205 11.2165C36.1476 10.9915 36.2751 10.6862 36.2751 10.368C36.2751 10.0497 36.1476 9.74448 35.9205 9.51944C35.6934 9.2944 35.3854 9.16797 35.0643 9.16797C34.7432 9.16797 34.4352 9.2944 34.2081 9.51944C33.9811 9.74448 33.8535 10.0497 33.8535 10.368Z",fill:"#0C547D"})),use||(use=i.createElement("path",{d:"M39.4531 10.3682H50.7391",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),dse||(dse=i.createElement("path",{d:"M39.0137 90.5615C39.0137 91.6658 39.4562 92.725 40.2438 93.5059C41.0315 94.2868 42.0998 94.7255 43.2137 94.7255C44.3276 94.7255 45.3959 94.2868 46.1835 93.5059C46.9712 92.725 47.4137 91.6658 47.4137 90.5615C47.4137 89.4571 46.9712 88.398 46.1835 87.6171C45.3959 86.8362 44.3276 86.3975 43.2137 86.3975C42.0998 86.3975 41.0315 86.8362 40.2438 87.6171C39.4562 88.398 39.0137 89.4571 39.0137 90.5615Z",fill:"white",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),pse||(pse=i.createElement("path",{d:"M64.5141 80.3996C64.5154 80.5561 64.4857 80.7114 64.4269 80.8564C64.3681 81.0015 64.2813 81.1336 64.1714 81.245C64.0615 81.3565 63.9307 81.4452 63.7865 81.506C63.6422 81.5669 63.4874 81.5987 63.3309 81.5996H23.0973C22.9408 81.5985 22.7861 81.5666 22.6419 81.5057C22.4978 81.4448 22.367 81.3561 22.2572 81.2447C22.1473 81.1332 22.0604 81.0013 22.0016 80.8563C21.9427 80.7113 21.913 80.5561 21.9141 80.3996V19.2908C21.913 19.1343 21.9427 18.9792 22.0016 18.8342C22.0604 18.6892 22.1473 18.5572 22.2572 18.4458C22.367 18.3343 22.4978 18.2456 22.6419 18.1847C22.7861 18.1238 22.9408 18.0919 23.0973 18.0908H63.3309C63.4874 18.0918 63.6422 18.1236 63.7865 18.1844C63.9307 18.2453 64.0615 18.334 64.1714 18.4454C64.2813 18.5569 64.3681 18.6889 64.4269 18.834C64.4857 18.9791 64.5154 19.1343 64.5141 19.2908V80.3996Z",fill:"#A0CEE9"})),fse||(fse=i.createElement("path",{d:"M64.5141 80.3996C64.5154 80.5561 64.4857 80.7114 64.4269 80.8564C64.3681 81.0015 64.2813 81.1336 64.1714 81.245C64.0615 81.3565 63.9307 81.4452 63.7865 81.506C63.6422 81.5669 63.4874 81.5987 63.3309 81.5996H23.0973C22.9408 81.5985 22.7861 81.5666 22.6419 81.5057C22.4978 81.4448 22.367 81.3561 22.2572 81.2447C22.1473 81.1332 22.0604 81.0013 22.0016 80.8563C21.9427 80.7113 21.913 80.5561 21.9141 80.3996V19.2908C21.913 19.1343 21.9427 18.9792 22.0016 18.8342C22.0604 18.6892 22.1473 18.5572 22.2572 18.4458C22.367 18.3343 22.4978 18.2456 22.6419 18.1847C22.7861 18.1238 22.9408 18.0919 23.0973 18.0908H63.3309C63.4874 18.0918 63.6422 18.1236 63.7865 18.1844C63.9307 18.2453 64.0615 18.334 64.1714 18.4454C64.2813 18.5569 64.3681 18.6889 64.4269 18.834C64.4857 18.9791 64.5154 19.1343 64.5141 19.2908V80.3996Z",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),hse||(hse=i.createElement("path",{d:"M27.6797 51.9336H60.0797V57.9336H27.6797V51.9336Z",fill:"white",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),mse||(mse=i.createElement("path",{d:"M27.6797 62.7334H60.0797V68.7334H27.6797V62.7334Z",fill:"white",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),gse||(gse=i.createElement("path",{d:"M31.3301 34.1697C31.3301 35.8213 31.6554 37.4566 32.2874 38.9824C32.9194 40.5082 33.8457 41.8945 35.0135 43.0623C36.1813 44.2301 37.5677 45.1565 39.0935 45.7885C40.6192 46.4205 42.2546 46.7458 43.9061 46.7458C45.5576 46.7458 47.1929 46.4205 48.7187 45.7885C50.2445 45.1565 51.6309 44.2301 52.7987 43.0623C53.9664 41.8945 54.8928 40.5082 55.5248 38.9824C56.1568 37.4566 56.4821 35.8213 56.4821 34.1697C56.4821 30.8344 55.1571 27.6356 52.7987 25.2772C50.4402 22.9187 47.2414 21.5938 43.9061 21.5938C40.5707 21.5938 37.372 22.9187 35.0135 25.2772C32.655 27.6356 31.3301 30.8344 31.3301 34.1697Z",fill:"white",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),vse||(vse=i.createElement("path",{d:"M39.8594 33.8782C39.8594 34.9514 40.2857 35.9806 41.0445 36.7394C41.8034 37.4983 42.8326 37.9246 43.9058 37.9246C44.9789 37.9246 46.0082 37.4983 46.767 36.7394C47.5259 35.9806 47.9522 34.9514 47.9522 33.8782V31.855C47.9522 30.7818 47.5259 29.7526 46.767 28.9938C46.0082 28.2349 44.9789 27.8086 43.9058 27.8086C42.8326 27.8086 41.8034 28.2349 41.0445 28.9938C40.2857 29.7526 39.8594 30.7818 39.8594 31.855V33.8782Z",fill:"white",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),yse||(yse=i.createElement("path",{d:"M52.3123 43.523C50.0044 45.597 47.011 46.7443 43.9081 46.7443C40.8052 46.7443 37.8119 45.597 35.5039 43.523C36.1946 41.8652 37.3602 40.4488 38.8541 39.452C40.3479 38.4551 42.1032 37.9224 43.8991 37.9209C45.695 37.9194 47.4512 38.4491 48.9468 39.4433C50.4423 40.4376 51.6104 41.852 52.3039 43.5086",fill:"#D8ECF3"})),bse||(bse=i.createElement("path",{d:"M52.3123 43.523C50.0044 45.597 47.011 46.7443 43.9081 46.7443C40.8052 46.7443 37.8119 45.597 35.5039 43.523C36.1946 41.8652 37.3602 40.4488 38.8541 39.452C40.3479 38.4551 42.1032 37.9224 43.8991 37.9209C45.695 37.9194 47.4512 38.4491 48.9468 39.4433C50.4423 40.4376 51.6104 41.852 52.3039 43.5086",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),_se||(_se=i.createElement("path",{d:"M39.8926 31.3328C39.9988 30.5168 40.3513 29.7525 40.903 29.142C41.4548 28.5314 42.1796 28.1036 42.9807 27.9156C43.7819 27.7276 44.6213 27.7883 45.3871 28.0897C46.1528 28.3911 46.8085 28.9188 47.2666 29.6024C46.3089 30.5309 45.1174 31.1822 43.8188 31.4869C42.5202 31.7917 41.1633 31.7384 39.8926 31.3328Z",fill:"#D8ECF3",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),Ase||(Ase=i.createElement("path",{d:"M81.3658 72.761C81.3658 69.9884 80.2644 67.3292 78.3038 65.3687C76.3432 63.4081 73.6841 62.3066 70.9114 62.3066C68.1388 62.3066 65.4796 63.4081 63.5191 65.3687C61.5585 67.3292 60.457 69.9884 60.457 72.761V84.1202H65.0026V72.7562C65.0026 71.1891 65.6252 69.6862 66.7333 68.5781C67.8414 67.47 69.3443 66.8474 70.9114 66.8474C72.4785 66.8474 73.9815 67.47 75.0896 68.5781C76.1977 69.6862 76.8202 71.1891 76.8202 72.7562V84.1202H81.3658V72.761Z",fill:"white"})),Ese||(Ese=i.createElement("path",{d:"M81.3658 72.761C81.3658 69.9884 80.2644 67.3292 78.3038 65.3687C76.3432 63.4081 73.6841 62.3066 70.9114 62.3066C68.1388 62.3066 65.4796 63.4081 63.5191 65.3687C61.5585 67.3292 60.457 69.9884 60.457 72.761V84.1202H65.0026V72.7562C65.0026 71.1891 65.6252 69.6862 66.7333 68.5781C67.8414 67.47 69.3443 66.8474 70.9114 66.8474C72.4785 66.8474 73.9815 67.47 75.0896 68.5781C76.1977 69.6862 76.8202 71.1891 76.8202 72.7562V84.1202H81.3658V72.761Z",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),wse||(wse=i.createElement("path",{d:"M55.9121 92.7607C55.9121 96.739 57.4925 100.554 60.3055 103.367C63.1186 106.18 66.9339 107.761 70.9121 107.761C74.8904 107.761 78.7057 106.18 81.5187 103.367C84.3318 100.554 85.9121 96.739 85.9121 92.7607C85.9121 88.7825 84.3318 84.9672 81.5187 82.1541C78.7057 79.3411 74.8904 77.7607 70.9121 77.7607C66.9339 77.7607 63.1186 79.3411 60.3055 82.1541C57.4925 84.9672 55.9121 88.7825 55.9121 92.7607Z",fill:"white"})),xse||(xse=i.createElement("path",{d:"M73.1842 91.8623C73.1862 91.4744 73.0888 91.0924 72.9014 90.7528C72.714 90.4132 72.4427 90.1272 72.1135 89.922C71.7843 89.7168 71.408 89.5994 71.0205 89.5807C70.633 89.5621 70.2473 89.643 69.8999 89.8157C69.5525 89.9883 69.2551 90.247 69.036 90.5671C68.8169 90.8872 68.6833 91.2581 68.6481 91.6444C68.6128 92.0307 68.677 92.4196 68.8346 92.7741C68.9922 93.1286 69.2379 93.4368 69.5482 93.6695V96.3971C69.5588 96.7518 69.7071 97.0885 69.9617 97.3356C70.2163 97.5828 70.5572 97.7211 70.912 97.7211C71.2669 97.7211 71.6078 97.5828 71.8624 97.3356C72.117 97.0885 72.2653 96.7518 72.2758 96.3971V93.6695C72.557 93.4594 72.7855 93.1867 72.9432 92.873C73.1008 92.5594 73.1834 92.2134 73.1842 91.8623Z",fill:"#A0CEE9",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),kse||(kse=i.createElement("path",{d:"M90.9304 78.9014L94.1896 80.6918L94.2952 83.483C94.3017 83.6543 94.3525 83.8209 94.4425 83.9668C94.5325 84.1126 94.6588 84.2326 94.809 84.3151C94.9592 84.3976 95.1282 84.4399 95.2995 84.4377C95.4709 84.4355 95.6388 84.389 95.7868 84.3026L98.1988 82.8962L100.479 84.149L100.584 86.9402C100.591 87.1115 100.642 87.2781 100.732 87.4239C100.822 87.5698 100.948 87.6898 101.098 87.7723C101.248 87.8548 101.417 87.8971 101.589 87.8949C101.76 87.8927 101.928 87.8462 102.076 87.7598L104.488 86.3534L106.768 87.6062L106.874 90.3974C106.88 90.5687 106.931 90.7353 107.021 90.8811C107.111 91.027 107.237 91.147 107.387 91.2295C107.538 91.312 107.707 91.3543 107.878 91.3521C108.049 91.3499 108.217 91.3034 108.365 91.217L110.777 89.8106L112.482 90.7478C112.678 90.8545 112.908 90.8799 113.122 90.8186L116.543 89.8238C116.757 89.7617 116.937 89.6172 117.045 89.4221C117.152 89.227 117.178 88.9973 117.116 88.7834L116.121 85.361C116.059 85.1472 115.914 84.9667 115.719 84.8594L94.1668 73.013C94.553 70.6668 94.0973 68.2596 92.8804 66.2169C91.6634 64.1741 89.7635 62.6273 87.5164 61.8499C85.2692 61.0725 82.8197 61.1144 80.6005 61.9684C78.3814 62.8224 76.5355 64.4333 75.3893 66.5166C74.243 68.5998 73.8701 71.0212 74.3364 73.3528C74.8027 75.6844 76.0783 77.7761 77.9377 79.2582C79.7971 80.7403 82.1205 81.5174 84.4974 81.4521C86.8743 81.3868 89.1516 80.4834 90.9268 78.9014H90.9304Z",fill:"white"})),Cse||(Cse=i.createElement("path",{d:"M78.7656 69.7671C78.7656 70.4354 79.0311 71.0764 79.5037 71.549C79.9763 72.0216 80.6173 72.2871 81.2856 72.2871C81.954 72.2871 82.5949 72.0216 83.0675 71.549C83.5401 71.0764 83.8056 70.4354 83.8056 69.7671C83.8056 69.0987 83.5401 68.4578 83.0675 67.9852C82.5949 67.5126 81.954 67.2471 81.2856 67.2471C80.6173 67.2471 79.9763 67.5126 79.5037 67.9852C79.0311 68.4578 78.7656 69.0987 78.7656 69.7671Z",fill:"#D8ECF3",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),Sse||(Sse=i.createElement("path",{d:"M81.1203 70.4951L80.1495 71.0687C76.2867 73.3487 69.9627 71.9795 69.3711 67.0547",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),Mse||(Mse=i.createElement("path",{d:"M71.0566 62.1241C72.3466 61.1566 73.8805 60.5675 75.4864 60.4228C77.0923 60.278 78.7069 60.5833 80.149 61.3045L81.1306 61.7953",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),Tse||(Tse=i.createElement("path",{d:"M55.9121 92.7607C55.9121 96.739 57.4925 100.554 60.3055 103.367C63.1186 106.18 66.9339 107.761 70.9121 107.761C74.8904 107.761 78.7057 106.18 81.5187 103.367C84.3318 100.554 85.9121 96.739 85.9121 92.7607C85.9121 88.7825 84.3318 84.9672 81.5187 82.1541C78.7057 79.3411 74.8904 77.7607 70.9121 77.7607C66.9339 77.7607 63.1186 79.3411 60.3055 82.1541C57.4925 84.9672 55.9121 88.7825 55.9121 92.7607Z",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),Ose||(Ose=i.createElement("path",{d:"M90.9304 78.9014L94.1896 80.6918L94.2952 83.483C94.3017 83.6543 94.3525 83.8209 94.4425 83.9668C94.5325 84.1126 94.6588 84.2326 94.809 84.3151C94.9592 84.3976 95.1282 84.4399 95.2995 84.4377C95.4709 84.4355 95.6388 84.389 95.7868 84.3026L98.1988 82.8962L100.479 84.149L100.584 86.9402C100.591 87.1115 100.642 87.2781 100.732 87.4239C100.822 87.5698 100.948 87.6898 101.098 87.7723C101.248 87.8548 101.417 87.8971 101.589 87.8949C101.76 87.8927 101.928 87.8462 102.076 87.7598L104.488 86.3534L106.768 87.6062L106.874 90.3974C106.88 90.5687 106.931 90.7353 107.021 90.8811C107.111 91.027 107.237 91.147 107.387 91.2295C107.538 91.312 107.707 91.3543 107.878 91.3521C108.049 91.3499 108.217 91.3034 108.365 91.217L110.777 89.8106L112.482 90.7478C112.678 90.8545 112.908 90.8799 113.122 90.8186L116.543 89.8238C116.757 89.7617 116.937 89.6172 117.045 89.4221C117.152 89.227 117.178 88.9973 117.116 88.7834L116.121 85.361C116.059 85.1472 115.914 84.9667 115.719 84.8594L94.1668 73.013C94.553 70.6668 94.0973 68.2596 92.8804 66.2169C91.6634 64.1741 89.7635 62.6273 87.5164 61.8499C85.2692 61.0725 82.8197 61.1144 80.6005 61.9684C78.3814 62.8224 76.5355 64.4333 75.3893 66.5166C74.243 68.5998 73.8701 71.0212 74.3364 73.3528C74.8027 75.6844 76.0783 77.7761 77.9377 79.2582C79.7971 80.7403 82.1205 81.5174 84.4974 81.4521C86.8743 81.3868 89.1516 80.4834 90.9268 78.9014H90.9304Z",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})))},Ise=(0,i.forwardRef)(Pse);o.p;var Bse,Rse,Nse,Fse,jse,Yse,$se,Hse,Use,zse,Wse,Vse,Gse,Qse,qse,Kse,Zse,Jse,Xse,ele=["title","titleId"];function tle(){return tle=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},tle.apply(null,arguments)}var nle=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,ele);return i.createElement("svg",tle({width:120,height:120,viewBox:"0 0 120 120",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Bse||(Bse=i.createElement("path",{d:"M8.45117 64.415C8.45117 77.1454 13.5083 89.3544 22.51 98.3562C31.5118 107.358 43.7208 112.415 56.4512 112.415C69.1816 112.415 81.3906 107.358 90.3923 98.3562C99.394 89.3544 104.451 77.1454 104.451 64.415C104.451 51.6846 99.394 39.4757 90.3923 30.4739C81.3906 21.4722 69.1816 16.415 56.4512 16.415C43.7208 16.415 31.5118 21.4722 22.51 30.4739C13.5083 39.4757 8.45117 51.6846 8.45117 64.415Z",fill:"#D8ECF3"})),Rse||(Rse=i.createElement("path",{d:"M82.0346 92.2478C82.0348 92.9529 81.896 93.6511 81.6263 94.3025C81.3565 94.954 80.9611 95.5459 80.4625 96.0445C79.9639 96.543 79.372 96.9385 78.7206 97.2082C78.0691 97.478 77.3709 97.6168 76.6658 97.6166H48.8258C48.1207 97.6168 47.4225 97.478 46.7711 97.2082C46.1196 96.9385 45.5277 96.543 45.0292 96.0445C44.5306 95.5459 44.1351 94.954 43.8654 94.3025C43.5956 93.6511 43.4569 92.9529 43.457 92.2478V32.5346C43.4573 31.1109 44.0231 29.7456 45.0299 28.7391C46.0368 27.7325 47.4021 27.167 48.8258 27.167H76.6658C78.0897 27.167 79.4553 27.7326 80.4621 28.7395C81.469 29.7463 82.0346 31.1119 82.0346 32.5358V92.2478Z",fill:"white"})),Nse||(Nse=i.createElement("path",{d:"M82.0346 92.2478C82.0348 92.9529 81.896 93.6511 81.6263 94.3025C81.3565 94.954 80.9611 95.5459 80.4625 96.0445C79.9639 96.543 79.372 96.9385 78.7206 97.2082C78.0691 97.478 77.3709 97.6168 76.6658 97.6166H48.8258C48.1207 97.6168 47.4225 97.478 46.7711 97.2082C46.1196 96.9385 45.5277 96.543 45.0292 96.0445C44.5306 95.5459 44.1351 94.954 43.8654 94.3025C43.5956 93.6511 43.4569 92.9529 43.457 92.2478V32.5346C43.4573 31.1109 44.0231 29.7456 45.0299 28.7391C46.0368 27.7325 47.4021 27.167 48.8258 27.167H76.6658C78.0897 27.167 79.4553 27.7326 80.4621 28.7395C81.469 29.7463 82.0346 31.1119 82.0346 32.5358V92.2478Z",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),Fse||(Fse=i.createElement("path",{d:"M46.8105 37.2314H78.6814V86.7146H46.8105V37.2314Z",fill:"#A0CEE9"})),jse||(jse=i.createElement("path",{d:"M46.8105 37.2314H78.6814V86.7146H46.8105V37.2314Z",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),Yse||(Yse=i.createElement("path",{d:"M61.0664 32.1982H70.292",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),$se||($se=i.createElement("path",{d:"M56.0406 31.1553C55.7703 31.1644 55.5142 31.2783 55.3262 31.4727C55.1383 31.6672 55.0332 31.927 55.0332 32.1975C55.0332 32.4679 55.1383 32.7278 55.3262 32.9222C55.5142 33.1167 55.7703 33.2305 56.0406 33.2397C56.3109 33.2305 56.5671 33.1167 56.755 32.9222C56.943 32.7278 57.0481 32.4679 57.0481 32.1975C57.0481 31.927 56.943 31.6672 56.755 31.4727C56.5671 31.2783 56.3109 31.1644 56.0406 31.1553Z",fill:"#0C547D"})),Hse||(Hse=i.createElement("path",{d:"M59.8086 92.1657C59.8086 92.9441 60.1178 93.6907 60.6683 94.2412C61.2187 94.7916 61.9653 95.1009 62.7438 95.1009C63.5223 95.1009 64.2688 94.7916 64.8193 94.2412C65.3697 93.6907 65.679 92.9441 65.679 92.1657C65.679 91.3872 65.3697 90.6406 64.8193 90.0902C64.2688 89.5397 63.5223 89.2305 62.7438 89.2305C61.9653 89.2305 61.2187 89.5397 60.6683 90.0902C60.1178 90.6406 59.8086 91.3872 59.8086 92.1657Z",fill:"white",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),Use||(Use=i.createElement("path",{d:"M46.2305 109.75C46.2305 110.348 47.9704 110.921 51.0674 111.343C54.1645 111.766 58.365 112.003 62.7449 112.003C67.1248 112.003 71.3253 111.766 74.4223 111.343C77.5194 110.921 79.2593 110.348 79.2593 109.75C79.2593 109.153 77.5194 108.58 74.4223 108.158C71.3253 107.735 67.1248 107.498 62.7449 107.498C58.365 107.498 54.1645 107.735 51.0674 108.158C47.9704 108.58 46.2305 109.153 46.2305 109.75Z",fill:"#A0CEE9"})),zse||(zse=i.createElement("path",{d:"M94.9773 43.1016H70.6401C69.4876 43.1019 68.3824 43.5599 67.5675 44.375C66.7527 45.1901 66.2949 46.2954 66.2949 47.448V63.0924C66.2946 63.6632 66.4068 64.2285 66.625 64.7559C66.8432 65.2834 67.1632 65.7627 67.5668 66.1664C67.9703 66.5702 68.4494 66.8905 68.9767 67.109C69.5041 67.3275 70.0693 67.44 70.6401 67.44H72.5805L71.5245 73.248C71.4943 73.4157 71.514 73.5887 71.5812 73.7453C71.6484 73.902 71.7601 74.0354 71.9025 74.1291C72.0449 74.2228 72.2117 74.2726 72.3821 74.2724C72.5526 74.2721 72.7192 74.2217 72.8613 74.1276L82.8921 67.44H94.9773C95.5479 67.44 96.113 67.3276 96.6402 67.1092C97.1673 66.8908 97.6464 66.5708 98.0498 66.1673C98.4533 65.7638 98.7734 65.2848 98.9918 64.7576C99.2101 64.2304 99.3225 63.6654 99.3225 63.0948V47.448C99.3225 46.2954 98.8648 45.1901 98.0499 44.375C97.2351 43.5599 96.1299 43.1019 94.9773 43.1016Z",fill:"white"})),Wse||(Wse=i.createElement("path",{d:"M94.9773 43.1016H70.6401C69.4876 43.1019 68.3824 43.5599 67.5675 44.375C66.7527 45.1901 66.2949 46.2954 66.2949 47.448V63.0924C66.2946 63.6632 66.4068 64.2285 66.625 64.7559C66.8432 65.2834 67.1632 65.7627 67.5668 66.1664C67.9703 66.5702 68.4494 66.8905 68.9767 67.109C69.5041 67.3275 70.0693 67.44 70.6401 67.44H72.5805L71.5245 73.248C71.4943 73.4157 71.514 73.5887 71.5812 73.7453C71.6484 73.902 71.7601 74.0354 71.9025 74.1291C72.0449 74.2228 72.2117 74.2726 72.3821 74.2724C72.5526 74.2721 72.7192 74.2217 72.8613 74.1276L82.8921 67.44H94.9773C95.5479 67.44 96.113 67.3276 96.6402 67.1092C97.1673 66.8908 97.6464 66.5708 98.0498 66.1673C98.4533 65.7638 98.7734 65.2848 98.9918 64.7576C99.2101 64.2304 99.3225 63.6654 99.3225 63.0948V47.448C99.3225 46.2954 98.8648 45.1901 98.0499 44.375C97.2351 43.5599 96.1299 43.1019 94.9773 43.1016Z",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),Vse||(Vse=i.createElement("path",{d:"M89.1523 55.4004C89.1523 55.9778 89.3817 56.5314 89.7899 56.9397C90.1981 57.3479 90.7518 57.5772 91.3291 57.5772C91.9065 57.5772 92.4601 57.3479 92.8684 56.9397C93.2766 56.5314 93.5059 55.9778 93.5059 55.4004C93.5059 54.8231 93.2766 54.2694 92.8684 53.8612C92.4601 53.453 91.9065 53.2236 91.3291 53.2236C90.7518 53.2236 90.1981 53.453 89.7899 53.8612C89.3817 54.2694 89.1523 54.8231 89.1523 55.4004Z",fill:"#A0CEE9",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),Gse||(Gse=i.createElement("path",{d:"M80.8555 55.4004C80.8555 55.9778 81.0848 56.5314 81.493 56.9397C81.9013 57.3479 82.4549 57.5772 83.0323 57.5772C83.6096 57.5772 84.1633 57.3479 84.5715 56.9397C84.9797 56.5314 85.2091 55.9778 85.2091 55.4004C85.2091 54.8231 84.9797 54.2694 84.5715 53.8612C84.1633 53.453 83.6096 53.2236 83.0323 53.2236C82.4549 53.2236 81.9013 53.453 81.493 53.8612C81.0848 54.2694 80.8555 54.8231 80.8555 55.4004Z",fill:"#A0CEE9",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),Qse||(Qse=i.createElement("path",{d:"M72.5586 55.4004C72.5586 55.9778 72.7879 56.5314 73.1962 56.9397C73.6044 57.3479 74.1581 57.5772 74.7354 57.5772C75.3127 57.5772 75.8664 57.3479 76.2746 56.9397C76.6829 56.5314 76.9122 55.9778 76.9122 55.4004C76.9122 54.8231 76.6829 54.2694 76.2746 53.8612C75.8664 53.453 75.3127 53.2236 74.7354 53.2236C74.1581 53.2236 73.6044 53.453 73.1962 53.8612C72.7879 54.2694 72.5586 54.8231 72.5586 55.4004Z",fill:"#A0CEE9",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),qse||(qse=i.createElement("path",{d:"M16.8008 7.58496H51.8024C53.4602 7.58496 55.0502 8.24353 56.2224 9.41578C57.3947 10.588 58.0532 12.1779 58.0532 13.8358V36.3382C58.0529 37.9958 57.3942 39.5854 56.222 40.7574C55.0498 41.9294 53.46 42.5878 51.8024 42.5878H49.0124L50.5316 50.9422C50.5747 51.183 50.5462 51.4312 50.4496 51.6561C50.353 51.8809 50.1926 52.0724 49.9882 52.2069C49.7838 52.3414 49.5444 52.413 49.2997 52.4128C49.0551 52.4126 48.8158 52.3406 48.6116 52.2058L34.1816 42.5878H16.8008C15.98 42.5879 15.1671 42.4264 14.4087 42.1124C13.6502 41.7984 12.961 41.3381 12.3805 40.7578C11.7999 40.1775 11.3394 39.4885 11.0251 38.7301C10.7108 37.9718 10.549 37.159 10.5488 36.3382V13.8358C10.5488 13.0148 10.7105 12.2019 11.0248 11.4434C11.339 10.6849 11.7995 9.99581 12.3801 9.41535C12.9606 8.8349 13.6499 8.37449 14.4084 8.06043C15.1669 7.74637 15.9799 7.5848 16.8008 7.58496Z",fill:"white"})),Kse||(Kse=i.createElement("path",{d:"M16.8008 7.58496H51.8024C53.4602 7.58496 55.0502 8.24353 56.2224 9.41578C57.3947 10.588 58.0532 12.1779 58.0532 13.8358V36.3382C58.0529 37.9958 57.3942 39.5854 56.222 40.7574C55.0498 41.9294 53.46 42.5878 51.8024 42.5878H49.0124L50.5316 50.9422C50.5747 51.183 50.5462 51.4312 50.4496 51.6561C50.353 51.8809 50.1926 52.0724 49.9882 52.2069C49.7838 52.3414 49.5444 52.413 49.2997 52.4128C49.0551 52.4126 48.8158 52.3406 48.6116 52.2058L34.1816 42.5878H16.8008C15.98 42.5879 15.1671 42.4264 14.4087 42.1124C13.6502 41.7984 12.961 41.3381 12.3805 40.7578C11.7999 40.1775 11.3394 39.4885 11.0251 38.7301C10.7108 37.9718 10.549 37.159 10.5488 36.3382V13.8358C10.5488 13.0148 10.7105 12.2019 11.0248 11.4434C11.339 10.6849 11.7995 9.99581 12.3801 9.41535C12.9606 8.8349 13.6499 8.37449 14.4084 8.06043C15.1669 7.74637 15.9799 7.5848 16.8008 7.58496Z",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),Zse||(Zse=i.createElement("path",{d:"M43.0508 25.0867C43.0508 25.75 43.3143 26.3861 43.7832 26.8551C44.2522 27.3241 44.8883 27.5875 45.5516 27.5875C46.2148 27.5875 46.8509 27.3241 47.3199 26.8551C47.7889 26.3861 48.0524 25.75 48.0524 25.0867C48.0524 24.4235 47.7889 23.7874 47.3199 23.3184C46.8509 22.8494 46.2148 22.5859 45.5516 22.5859C44.8883 22.5859 44.2522 22.8494 43.7832 23.3184C43.3143 23.7874 43.0508 24.4235 43.0508 25.0867Z",fill:"#A0CEE9",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),Jse||(Jse=i.createElement("path",{d:"M31.8008 25.0867C31.8008 25.75 32.0643 26.3861 32.5332 26.8551C33.0022 27.3241 33.6383 27.5875 34.3016 27.5875C34.9648 27.5875 35.6009 27.3241 36.0699 26.8551C36.5389 26.3861 36.8024 25.75 36.8024 25.0867C36.8024 24.4235 36.5389 23.7874 36.0699 23.3184C35.6009 22.8494 34.9648 22.5859 34.3016 22.5859C33.6383 22.5859 33.0022 22.8494 32.5332 23.3184C32.0643 23.7874 31.8008 24.4235 31.8008 25.0867Z",fill:"#A0CEE9",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})),Xse||(Xse=i.createElement("path",{d:"M20.5488 25.0867C20.5488 25.75 20.8123 26.3861 21.2813 26.8551C21.7503 27.3241 22.3864 27.5875 23.0496 27.5875C23.7129 27.5875 24.349 27.3241 24.818 26.8551C25.287 26.3861 25.5504 25.75 25.5504 25.0867C25.5504 24.4235 25.287 23.7874 24.818 23.3184C24.349 22.8494 23.7129 22.5859 23.0496 22.5859C22.3864 22.5859 21.7503 22.8494 21.2813 23.3184C20.8123 23.7874 20.5488 24.4235 20.5488 25.0867Z",fill:"#A0CEE9",stroke:"#0C547D",strokeWidth:.8,strokeLinecap:"round",strokeLinejoin:"round"})))},rle=(0,i.forwardRef)(nle);o.p;var ole,ile=fr(wr)((function(e){var t=e.theme;return"\n        color: "+t.colors.navy[400]+";\n        background: #FFFFFF;\n        outline: 1px solid "+t.colors.gray[200]+";\n        border-radius: 4px;\n        min-height: 135px;\n        align-items: center;\n        flex-direction: row;\n        padding: 16px;\n        min-width: 300px;\n        &:hover {\n            cursor: pointer;\n            box-shadow: 1px 3px 10px 1px "+t.colors.gray[200]+";\n        }\n\n        &.is-selected {\n            outline: 2px solid "+t.colors.blue[400]+";\n            box-shadow: 1px 3px 10px 1px "+t.colors.gray[200]+";\n        }\n\n        svg {\n            height: auto;\n            min-width: 120px;\n            margin-right: 16px;\n        }\n    "})),ale=fr(wr)(ole||(ole=zM(["\n    flex-basis: 0;\n    flex-grow: 1;\n    padding: 10px;\n"])));const sle=function(e){var t=e.onContinue,n=Co(),r=[{bodyText:i.createElement(i.Fragment,null,"ShootProof will send you an SMS with a two-factor authentication code when prompted. SMS cannot be delivered outside of the US."),icon:i.createElement(rle,null),title:n("studio.account.mfa.select.smsTitle"),value:"sms"},{bodyText:i.createElement(i.Fragment,null,"Use an application on your phone to get two-factor authentication codes when prompted. We recommend using cloud-based apps such as: 1Password, Authy, LastPass Authenticator, or Microsoft Authenticator."),icon:i.createElement(Ise,null),title:n("studio.account.mfa.select.appTitle"),value:"app"}];return i.createElement(wr,{flexDirection:"column",flexWrap:"wrap",paddingBottom:"50px"},i.createElement(dq,{marginTop:0,style:{color:"#03121B"}},"Let’s protect your account!"),i.createElement(_r,{fontSize:"16px",color:"gray.700"},"We want to ensure that your money stays your money. ShootProof Pay requires you to enable extra security on your ShootProof account by enabling two-factor authentication (2FA)."),i.createElement(UI,null,"Choose Two-Factor Authentication Method"),r.map((function(e){var n=e.bodyText,r=e.icon,o=e.title,a=e.value;return i.createElement(ale,{key:a,size:[12,12,6]},i.createElement(ile,{"data-testid":"mfa-selection-"+a,onClick:function(){return e=a,void(null==t||t(e));var e},onDoubleClick:function(){return null==t?void 0:t(a)}},r,i.createElement(wr,{flexDirection:"column"},i.createElement(UI,null,o),i.createElement(Px,null,n))))})))};var lle,cle,ule="me/mfa";function dle(){var e=zo(ule,{method:"GET",credentials:"include",defer:!0}).performFetch,t=zo(ule,{method:"POST",credentials:"include",defer:!0}).performFetch,n=zo(ule,{method:"PATCH",credentials:"include",defer:!0}).performFetch,r=zo(ule,{method:"DELETE",credentials:"include",defer:!0}).performFetch;return(0,i.useMemo)((function(){return{get:e,create:t,patch:n,deleteMfa:r}}),[e,t,n,r])}var ple=function(){var e=mI(),t=e.submitForm,n=e.values;return(0,i.useEffect)((function(){6===n.code.length&&t()}),[t,n]),null},fle=fr(_r)(lle||(lle=zM(["\n    .chakra-form-control > .chakra-form-control {\n        width: 148px;\n    }\n"]))),hle=fr(_r)((function(e){var t=e.theme;return"\n        hr {\n            border-top: 2px solid "+t.colors.gray[400]+";\n            margin: 35px 0 20px;\n\n            "+t.responsive.mediumScreenUp(cle||(cle=zM(["\n                width: 66%;\n            "])))+"\n        }\n    "})),mle=function(e){var t=e.phone,n=void 0===t?"":t,r=e.formError,o=e.onSubmit,a=xo(),s=MU({phone:aU().phoneNumber("studio.account.mfa.sms.phoneValidation.invalid").required("studio.account.mfa.sms.phoneValidation.required")});return i.createElement(iY,{initialValues:{phone:n},onSubmit:o,validateOnMount:!0,validationSchema:s},(function(e){var t=e.isSubmitting,n=e.isValid,o=e.submitForm;return i.createElement(i.Fragment,null,i.createElement(_r,{width:165,marginBottom:2,marginTop:4},i.createElement(sQ,{label:"studio.account.mfa.sms.enterPhoneNumber",name:"phone",placeholder:"(555) 555-5555",showValidationIcons:!1,variant:rQ.PhoneInput})),i.createElement(fp,{style:{width:"100%",maxWidth:"210px",padding:"10px 16px"},isDisabled:t||!n,loadedText:a("studio.account.mfa.sms.sentCode"),loadingText:a("studio.account.mfa.sms.sendingCode"),onClick:function(){var e=Lo(Io().mark((function e(t){return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return t.preventDefault(),e.next=3,o();case 3:case"end":return e.stop()}}),e)})));return function(t){return e.apply(this,arguments)}}()},a("studio.account.mfa.sms.sendCode")),r&&i.createElement(Ax,{"data-testid":"send-code-form-error"},a(r)))}))};const gle=function(e){var t=e.phone,n=e.onContinue,r=dle(),o=m((0,i.useState)(!1),2),a=o[0],s=o[1],l=MU({code:aU().max(6,"studio.account.mfa.sms.codeValidation.maxLength").min(6,"studio.account.mfa.sms.codeValidation.minLength").required("studio.account.mfa.sms.codeValidation.required")});(0,i.useEffect)((function(){r.get().then((function(e){"pending-activation"===e.mfaStatus&&r.deleteMfa()}))}),[r]);var c=m((0,i.useState)(null),2),u=c[0],d=c[1],p=m((0,i.useState)(null),2),f=p[0],h=p[1],g=m((0,i.useState)(),2),v=g[0],y=g[1],b=xo();return i.createElement(TI,{initialValues:{code:""},onSubmit:function(e){var t=e.code;return new Promise((function(e){s(!0),d(null),r.patch({url:"sms",data:{type:"user-mfa",code:t}}).then((function(t){switch(s(!1),null==t?void 0:t.status){case 400:d("studio.account.mfa.sms.codeValidation.invalid");break;case 429:d("studio.account.mfa.sms.codeValidation.tooManyRequests");break;case 500:d("studio.account.mfa.sms.codeValidation.serviceUnavailable");break;case 409:d(b("studio.account.mfa.sms.codeValidation.notConfigured"));break;case 200:e(),null==n||n()}}))}))},validateOnMount:!0,validationSchema:l},i.createElement(hle,null,i.createElement(dq,{marginTop:0,style:{color:"#03121B"}},"Let’s protect your account!"),i.createElement(_r,{fontSize:"16px",color:"gray.700"},"We want to ensure that your money stays your money. ShootProof Pay requires you to enable extra security on your ShootProof account by enabling two-factor authentication (2FA)."),i.createElement(UI,null,"Set up SMS 2FA*"),i.createElement(_r,{color:"gray.400",mb:1},"Enter your phone number below, and we will send you a 6-digit code when prompted. After you receive it, enter it in the field provided."),i.createElement(mle,{phone:t,formError:v,onSubmit:function(e){var t=e.phone;return new Promise((function(e){var n=Number(t.replace(/[^0-9]/g,"")),o=function(e){if(e)switch(e.status){case 409:d(b("studio.account.mfa.sms.sendCodeForm.conflictValidation"));break;case 429:d(b("studio.account.mfa.sms.tooManyRequestsValidation"));break;case 500:d(b("studio.account.mfa.sms.sendCodeForm.serviceUnavailable"))}};y(void 0),f===n?r.create({url:"sms",data:{type:"user-mfa",mfaPhone:n}}).then((function(t){t&&200===t.status?(h(n),e()):o(t)})):f?function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:qT;r.deleteMfa({url:"sms",data:e?{code:e}:void 0}).then(t)}(f,(function(){r.create({url:"sms",data:{type:"user-mfa",mfaPhone:n}}).then((function(t){t&&200===t.status?(h(n),e()):o(t)}))})):r.create({url:"sms",data:{type:"user-mfa",mfaPhone:n}}).then((function(t){t&&200===t.status?(h(n),e()):o(t)}))}))}}),i.createElement("hr",null),i.createElement(fle,null,i.createElement(ple,null),i.createElement(sQ,{label:"studio.account.mfa.sms.enterCode",labelSubtext:b("studio.account.mfa.sms.enterCodeDescription"),name:"code",isDisabled:a,autoComplete:"off",placeholder:b("studio.account.mfa.sms.enterCodePlaceholderText"),showValidationIcons:!1}),u&&i.createElement(Ax,{"data-testid":"form-error"},b(u)))))};var vle,yle,ble=fr(_r)(vle||(vle=zM(["\n    background-color: #fafafa;\n    width: 100%;\n    height: 100%;\n    max-width: 200px;\n    max-height: 200px;\n    margin: 24px;\n\n    & img {\n        min-width: 200px;\n        min-height: 200px;\n    }\n"]))),_le=function(){var e=mI(),t=e.values,n=e.submitForm;return(0,i.useEffect)((function(){6===t.code.length&&n()}),[t,n]),null},Ale=fr(_r)(yle||(yle=zM(["\n    .chakra-input__group {\n        margin-top: 4px;\n        width: 140px;\n    }\n"])));const Ele=function(e){var t=e.onContinue,n=xo(),r=dle(),o=m((0,i.useState)(""),2),a=o[0],s=o[1],l=(0,i.useCallback)((function(e){e&&e.imageUrl&&v(e.imageUrl)}),[]),c=(0,i.useCallback)((function(){r.create({url:"app",data:{type:"user-mfa"}}).then(l)}),[r,l]),u=function(){var e=Lo(Io().mark((function e(){var o,i,s=arguments;return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=s.length>0&&void 0!==s[0]?s[0]:a,e.next=3,r.patch({url:"app",data:{type:"user-mfa",code:o}});case 3:if(!(i=e.sent)){e.next=14;break}e.t0=i.status,e.next=400===e.t0?8:429===e.t0?10:200===e.t0?12:14;break;case 8:return f(n("studio.account.mfa.app.codeValidation.invalid")),e.abrupt("break",14);case 10:return f(n("studio.account.mfa.app.codeValidation.tooManyRequests")),e.abrupt("break",14);case 12:return null==t||t(),e.abrupt("break",14);case 14:case"end":return e.stop()}}),e)})));return function(){return e.apply(this,arguments)}}(),d=m((0,i.useState)(null),2),p=d[0],f=d[1],h=m((0,i.useState)(),2),g=h[0],v=h[1],y=MU({code:aU().max(6,n("studio.account.mfa.app.codeValidation.maxLength")).min(6,n("studio.account.mfa.app.codeValidation.minLength")).required(n("studio.account.mfa.app.codeValidation.required"))});return(0,i.useEffect)((function(){g||r.get().then((function(e){var t=e,n=t.imageUrl,o=t.mfaStatus;null!==n?v(n):"pending-activation"===o?r.deleteMfa().then(c):null===o&&r.create({url:"app",data:{type:"user-mfa"}}).then(l)}))}),[r,v,l,c,g]),i.createElement(i.Fragment,null,i.createElement(dq,{marginTop:0,style:{color:"#03121B"}},"Let’s protect your account!"),i.createElement(_r,{fontSize:"16px",color:"gray.700"},"We want to ensure that your money stays your money. ShootProof Pay requires you to enable extra security on your ShootProof account by enabling two-factor authentication (2FA)."),i.createElement(UI,null,"Set up Authenticator App 2FA*"),i.createElement(_r,{color:"gray.400",mb:1},"Scan the image below with the two-factor authentication app on your phone."),i.createElement(ble,null,g&&i.createElement("img",{alt:"MFA","data-testid":"mfa-image",src:g})),i.createElement(Ale,null,i.createElement(iY,{initialValues:{code:""},onSubmit:function(e,t){var n=e.code;(0,t.setSubmitting)(!1),f(null),u(n),s(n)},validateOnMount:!0,validationSchema:y},i.createElement(sQ,{autoComplete:"off",label:n("studio.account.mfa.app.enterCode"),labelSubtext:n("studio.account.mfa.app.enterCodeDescription"),name:"code",placeholder:n("studio.account.mfa.app.enterCodePlaceholderText"),showValidationIcons:!1}),p&&i.createElement(Ax,{"data-testid":"form-error"},p),i.createElement(_le,null))))};function wle(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){var n=null==e?null:"undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(null!=n){var r,o,i,a,s=[],l=!0,c=!1;try{if(i=(n=n.call(e)).next,0===t){if(Object(n)!==n)return;l=!1}else for(;!(l=(r=i.call(n)).done)&&(s.push(r.value),s.length!==t);l=!0);}catch(e){c=!0,o=e}finally{try{if(!l&&null!=n.return&&(a=n.return(),Object(a)!==a))return}finally{if(c)throw o}}return s}}(e,t)||function(e,t){if(!e)return;if("string"==typeof e)return xle(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);"Object"===n&&e.constructor&&(n=e.constructor.name);if("Map"===n||"Set"===n)return Array.from(e);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return xle(e,t)}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function xle(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var kle=i.createContext(null);kle.displayName="ConnectComponents";var Cle,Sle=function(e){var t=e.connectInstance,n=e.children;return i.createElement(kle.Provider,{value:{connectInstance:t}},n)},Mle=function(e){var t=wle(i.useState(null),2),n=t[0],r=t[1],o=function(){var e=i.useContext(kle);if(!e)throw new Error("Could not find Components context; You need to wrap the part of your app in an <ConnectComponentsProvider> provider.");return e}().connectInstance,a=i.useRef(null),s=i.createElement("div",{style:{width:"100%"},ref:a});return i.useLayoutEffect((function(){if(null!==a.current&&null===n){var t=o.create(e);if(r(t),null!==t){try{t.setAttribute("reactSdkAnalytics","3.3.19")}catch(e){console.log("Error setting React Sdk version with error message: ",e)}for(;a.current.firstChild;)a.current.removeChild(a.current.firstChild);a.current.appendChild(t)}}}),[o,e]),{wrapper:s,component:n}},Tle=function(e,t,n){i.useEffect((function(){if(e)try{n(e,t)}catch(e){return void console.error("Error when calling setter! ",e)}}),[e,t,n])},Ole=function(e){var t=e.collectionOptions,n=e.onLoadError,r=e.onLoaderStart,o=Mle("account-management"),i=o.wrapper,a=o.component;return Tle(a,t,(function(e,t){return e.setCollectionOptions(t)})),Tle(a,r,(function(e,t){e.setOnLoaderStart(t)})),Tle(a,n,(function(e,t){e.setOnLoadError(t)})),i},Dle=function(e){var t=e.collectionOptions,n=e.onNotificationsChange,r=e.onLoadError,o=e.onLoaderStart,i=Mle("notification-banner"),a=i.wrapper,s=i.component;return Tle(s,t,(function(e,t){return e.setCollectionOptions(t)})),Tle(s,n,(function(e,t){return e.setOnNotificationsChange(t)})),Tle(s,o,(function(e,t){e.setOnLoaderStart(t)})),Tle(s,r,(function(e,t){e.setOnLoadError(t)})),a};!function(e){e.exit="exit",e.close="close",e.instantPayoutCreated="instantpayoutcreated"}(Cle||(Cle={}));var Lle=o(45205),Ple={variables:{colorPrimary:"#0C547D",buttonSecondaryColorBackground:"#FFFFFF",buttonSecondaryColorBorder:"#FFFFFF",buttonSecondaryColorText:"#0C547D",actionPrimaryColorText:"#4FBEE3",actionPrimaryTextDecorationLine:"none",actionPrimaryTextDecorationStyle:"solid",badgeNeutralColorBackground:"#D9E0E3",badgeNeutralColorBorder:"#D9E0E3",badgeSuccessColorBackground:"#E2F2E2",badgeSuccessColorBorder:"#E2F2E2",badgeSuccessColorText:"#51646C",badgeWarningColorBackground:"#FEEDC4",badgeWarningColorBorder:"#FEEDC4",badgeWarningColorText:"#51646C",badgeDangerColorBackground:"#FFE9EA",badgeDangerColorBorder:"#FFE9EA",badgeDangerColorText:"#51646C",buttonBorderRadius:"8px",badgeBorderRadius:"12px",spacingUnit:"12px",headingXlTextTransform:"uppercase",headingLgTextTransform:"uppercase",headingMdTextTransform:"uppercase",headingSmTextTransform:"uppercase",headingXsTextTransform:"uppercase",labelMdTextTransform:"none",labelSmTextTransform:"capitalize"}};const Ile=function(e){var t=e.stripePublishableKey,n=zo("stripe-embedded-account-data",{defer:!0}).performFetch,r=(0,i.useCallback)(Lo(Io().mark((function e(){var t,r;return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,n();case 2:return r=e.sent,e.abrupt("return",null!==(t=null==r?void 0:r.clientSecret)&&void 0!==t?t:"");case 4:case"end":return e.stop()}}),e)}))),[n]);return m((0,i.useState)((function(){return(0,Lle.loadConnectAndInitialize)({publishableKey:t,fetchClientSecret:r,appearance:Ple})})),1)[0]};var Ble,Rle=fr(_r)((function(e){return"\n        border: 1px solid "+e.theme.colors.gray[200]+";\n        border-radius: 2px;\n        padding: 20px;\n        margin-bottom: 14px;\n    "})),Nle=fr(UI)((function(e){return"\n       color: "+e.theme.colors.gray[700]+" !important;\n       font-weight: 600!important;\n       margin-bottom: 0;\n        "})),Fle=fr(wr)(Ble||(Ble=zM(["\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n"]))),jle=fr("h3")((function(e){return"\n    font-size: "+e.theme.fontSizes["2xl"]+";\n"}));const Yle=function(e){var t=e.handleFinishSetup,n=e.handleStartOver,r=e.merchantAccount,o=e.stripePublicKey,a=e.refreshMerchantAccountStatus,s=r.name,l=Co("studio.account.spPay"),c=nY(),u=c.Modal,d=c.open,p=c.close,f=Ile({stripePublishableKey:o}),h=m((0,i.useState)(!0),2),g=h[0],v=h[1],y=m((0,i.useState)(!0),2),b=y[0],_=y[1];return i.createElement(i.Fragment,null,i.createElement(_r,{height:"100%",display:g?"block":"none"},i.createElement(BF,null)),i.createElement(_r,{display:g?"none":"block"},i.createElement(jle,null,l("studio.account.spPay.setupPayments.title")),i.createElement(Rle,null,i.createElement(Fle,{flexDirection:"column"},i.createElement(Nle,{fontWeight:"semibold"},s),i.createElement(Vx,{variant:zx.Warning,statusPillText:l("setupPayments.status.incomplete")})),i.createElement(Px,{textAlign:"center",maxWidth:"75%",margin:"auto"},l("setupPayments.incompletePanel.subheading"))),b&&i.createElement(i.Fragment,null,i.createElement(_r,{display:"flex",flexDirection:"row",alignItems:"flex-end",justifyContent:"flex-end",gap:2},i.createElement(fp,{variant:sp.Dismissive,onClick:d,"merchantaccount-testid":"setup-payments-incomplete-start-over"},l("setupPayments.start-over")),i.createElement(fp,{"merchantaccount-testid":"setup-payments-incomplete-finish-setup",onClick:t},l("setupPayments.finish-setup"))),i.createElement(u,{heading:l("acceptPayments.onboarding.startOver.heading")},i.createElement(u.Body,null,l("acceptPayments.onboarding.startOver.body")),i.createElement(u.PrimaryButton,{destructive:!0,onClick:function(){return n(),p()}},l("acceptPayments.onboarding.startOver.yes")),i.createElement(u.SecondaryButton,null,l("acceptPayments.onboarding.startOver.no")))),i.createElement(Sle,{connectInstance:f},i.createElement(Dle,{onNotificationsChange:function(e){var t=e.total>0;g||t||a();var n,r,o=(n=document.querySelector("stripe-connect-notification-banner"),!!(r=null==n?void 0:n.querySelector("div"))&&parseInt(window.getComputedStyle(r).height)>0);_(!(!g||o)||!(!g||t)),g&&v(!1)}}))))};var $le,Hle=fr(_r)((function(e){return"\n        border: 1px solid "+e.theme.colors.gray[200]+";\n        border-radius: 2px;\n        padding: 20px;\n    "})),Ule=fr(UI)((function(e){return"\n       color: "+e.theme.colors.gray[700]+" !important;\n       font-weight: 600!important;\n       margin-bottom: 0;\n        "})),zle=fr(wr)($le||($le=zM(["\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n"]))),Wle=fr("h3")((function(e){return"\n    font-size: "+e.theme.fontSizes["2xl"]+";\n"})),Vle=fr("h4")((function(e){return"\n    font-size: "+e.theme.fontSizes.xl+";\n"}));const Gle=function(e){var t=e.name,n=e.handleStartOver,r=e.handleVisitStripe,o=nY(),a=o.Modal,s=o.open,l=o.close,c=Co("studio.account.spPay");return i.createElement(i.Fragment,null,i.createElement(Wle,null,c("studio.account.spPay.setupPayments.title")),i.createElement(Vle,{style:{marginTop:50}},c("setupPayments.pendingPanel.subtitle")),i.createElement(Hle,null,i.createElement(zle,{flexDirection:"column"},i.createElement(Ule,{fontWeight:"semibold"},t),i.createElement(Vx,{variant:zx.Neutral,statusPillText:c("setupPayments.status.pending")})),i.createElement(Px,{textAlign:"center"},c("setupPayments.pendingPanel.subheading"))),i.createElement(_r,{display:"flex",flexDirection:"row",alignItems:"flex-end",justifyContent:"flex-end",gap:2,marginTop:5},i.createElement(fp,{variant:sp.Dismissive,onClick:s,"data-testid":"setup-payments-pending-start-over"},c("setupPayments.start-over")),i.createElement(fp,{onClick:r},c("setupPayments.visit-stripe",{stripe:"Stripe"}))),i.createElement(a,{heading:c("acceptPayments.onboarding.startOver.heading")},i.createElement(a.Body,null,c("acceptPayments.onboarding.startOver.body")),i.createElement(a.PrimaryButton,{destructive:!0,onClick:function(){return n(),l()}},c("acceptPayments.onboarding.startOver.yes")),i.createElement(a.SecondaryButton,null,c("acceptPayments.onboarding.startOver.no"))))};var Qle=fr("div")((function(e){var t=e.theme;return{border:"1px solid "+t.colors.gray[200],borderRadius:"2px",padding:"20px",marginTop:t.spacing.lg}})),qle=fr(UI)((function(e){return{color:e.theme.colors.gray[700],fontWeight:600,marginBottom:0}})),Kle=fr(wr)({flexDirection:"row",justifyContent:"space-between",alignItems:"center",marginBottom:"20px"}),Zle=fr(wr)({marginTop:"10px",flexDirection:"row",justifyContent:"space-between"}),Jle=fr(_r)({textTransform:"uppercase",fontSize:"10px",fontWeight:300}),Xle=fr(Px)({marginBottom:0,fontSize:"14px",textTransform:"capitalize"}),ece=fr("h3")((function(e){return"\n    font-size: "+e.theme.fontSizes["2xl"]+";\n"})),tce=function(e){var t=e.onDisconnect,n=function(){var e=Lo(Io().mark((function e(n){return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!t){e.next=3;break}return e.next=3,t();case 3:n();case 4:case"end":return e.stop()}}),e)})));return function(t){return e.apply(this,arguments)}}(),r=Co("studio.payments.accounts.accountList.disconnectModal");return i.createElement(i.Fragment,null,i.createElement(eY.Body,null,i.createElement(Px,{marginBottom:"32px"},r("description1")),i.createElement(Px,null,r("description2"))),i.createElement(eY.PrimaryButton,{destructive:!0,loadedText:r("primaryButton.loaded"),loadingText:r("primaryButton.loading"),onClick:n},r("primaryButton")))};const nce=function(e){var t,n,r,o,a=e.data,s=e.handleConnect,l=e.handleDisconnect,c=e.currentBrandId,u=e.stripePublicKey,d=a.isActive,p=a.name,f=a.payoutScheduleInterval,h=a.payoutAccount,g=a.links,v=Co("studio.payments.accounts.accountList"),y=m((0,i.useState)(!0),2),b=y[0],_=y[1],A=m((0,i.useState)(!1),2),E=A[0],w=A[1],x=nY(),k=x.Modal,C=x.open,S=Ile({stripePublishableKey:u}),M=zo("brand/"+c+"/sp-pay-gateway").response,T=(null==M||null===(t=M.meta)||void 0===t?void 0:t.countInvoicesWithVaultedCards)||0,O=(null==M||null===(n=M.meta)||void 0===n?void 0:n.countPendingLabOrders)||0,D=(null==M||null===(r=M.meta)||void 0===r?void 0:r.hasNegativeTotalBalance)||!1,L=(null==M||null===(o=M.meta)||void 0===o?void 0:o.isDisconnected)||!1,P=m(Bae(),2),I=P[0],B=P[1],R=m(Bae(),2),N=R[0],F=R[1],j=m(Bae(),2),Y=j[0],$=j[1],H=function(e,t){var n=m((0,i.useState)(null!=t?t:null),2),r=n[0],o=n[1],a=(0,i.useCallback)((function(t){o(t),null===t?localStorage.removeItem(e):localStorage.setItem(e,t)}),[e]);return(0,i.useLayoutEffect)((function(){var t=localStorage.getItem(e);null!==t&&o(t)}),[e]),(0,i.useLayoutEffect)((function(){void 0!==t&&null===localStorage.getItem(e)&&localStorage.setItem(e,t)}),[t,e]),(0,i.useLayoutEffect)((function(){var t,n="react-local-storage-observer",r=document.querySelector("html"),i=function(t){t.key===e&&o(t.newValue)},a=document.getElementById(n);return null===a&&((a=document.createElement("iframe")).id=n,a.src="about:blank",a.style.display="none",null==r||r.appendChild(a)),null===(t=a.contentWindow)||void 0===t||t.addEventListener("storage",i),function(){var e;null===(e=a.contentWindow)||void 0===e||e.removeEventListener("storage",i)}}),[e]),[r,a]}("sppay.autoconnected"),U=m(H,2),z=U[0],W=U[1],V=(0,i.useCallback)((function(){F4("Payment Gateway Connected",{type:"SpPay"}),W((new Date).toISOString())}),[W]),G=d?[{content:v("disconnectAction"),isDestructive:!0,onClick:function(){if(!L)return D?I():O?Y():T?N():C()},"data-testid":"setup-payments-complete-disconnect"}]:[{content:v("connectAction"),onClick:s,"data-testid":"setup-payments-complete-reconnect"}],Q=d?zx.Success:zx.Danger,q=v(d?"studio.account.spPay.setupPayments.status.connected":"studio.account.spPay.setupPayments.status.disconnected");(0,i.useEffect)((function(){if(null!=M&&M.meta.created&&(null==M||!M.meta.isDisconnected)){var e=(new Date).getTime()/1e3,t=e-300,n=!!z&&new Date(z).getTime()/1e3;if(!(n&&n>=t&&n<=e))new Date(M.meta.created).getTime()/1e3>t&&V()}}),[M,z,V]);return i.createElement(i.Fragment,null,i.createElement(_r,{height:"100%",display:b?"block":"none"},i.createElement(BF,null)),i.createElement(_r,{display:b?"none":"block"},i.createElement(ece,null,v("settings")),!d&&i.createElement(ep,{marginBottom:"20px",variant:Jd.Warning},i.createElement(wr,{alignItems:"center"},i.createElement(_r,{flexShrink:0,height:"30px",marginRight:"14px",width:"32px"},i.createElement(CF,null)),i.createElement(_r,null,i.createElement(UI,{style:{marginBottom:0}},v("disconnectedBanner.heading")),i.createElement(Px,{whiteSpace:"pre-line"},v("disconnectedBanner.sidePanelDescription"),i.createElement("br",null),i.createElement("br",null),i.createElement(Sx,{"data-testid":"setup-payments-complete-reconnect-text-cta",marginLeft:"4px",onClick:function(e){e.persist(),s()}},v("disconnectedBanner.sidePanelCallToAction")))))),i.createElement(Qle,null,i.createElement(Kle,{flexDirection:"column"},i.createElement(qle,{fontWeight:"semibold"},p),i.createElement(wr,null,i.createElement(Vx,{variant:Q,statusPillText:q}),i.createElement(Iae,{items:G}))),i.createElement(_r,null,i.createElement(Jle,null,v("payout-schedule")),i.createElement(Xle,null,v("payout-schedule-values."+f))),i.createElement(Zle,{alignItems:"end"},i.createElement(_r,null,i.createElement(Jle,null,v("default-payout-method")),i.createElement(Xle,null,(null==h?void 0:h.bankName)+" •••• "+(null==h?void 0:h.last4))),i.createElement(Sx,{"data-testid":"setup-payments-complete-view-account",target:"_blank",href:g["sp-pay"].href},v("view-account")))),i.createElement(_r,{display:E?"block":"none"},i.createElement(Qle,null,i.createElement(Sle,{connectInstance:S},i.createElement(Dle,{onNotificationsChange:function(e){b&&_(!1),e.total>0&&w(!0)}})))),i.createElement(Qle,null,i.createElement(Sle,{connectInstance:S},i.createElement(Ole,null))),i.createElement(k,{heading:v("disconnectModal.heading")},i.createElement(tce,{onDisconnect:l})),i.createElement(Fq,{headerText:v("hasNegativeBalanceModal.heading"),hideSecondaryAction:!0,openSubscribe:B,primaryAction:function(e){e()},primaryActionText:"hasNegativeBalanceModal.primaryButton"},i.createElement(_r,{textAlign:"center"},i.createElement(Px,{marginBottom:"32px"},i.createElement("span",{dangerouslySetInnerHTML:{__html:v("hasNegativeBalanceModal.description")}})))),i.createElement(Fq,{centerHeading:!1,headerText:"studio.payments.accounts.accountList.hasNonPaidInvoicesWithAutopayModal.heading",hideSecondaryAction:!1,icon:i.createElement(CF,{height:"78px",width:"78px"}),openSubscribe:F,primaryAction:function(e){e(),C()},primaryActionText:"studio.payments.accounts.accountList.hasNonPaidInvoicesWithAutopayModal.primaryButton",secondaryActionText:"studio.payments.accounts.accountList.hasNonPaidInvoicesWithAutopayModal.secondaryButton"},i.createElement(Px,{marginBottom:"10px"},v("hasNonPaidInvoicesWithAutopayModal.description"))),i.createElement(Fq,{headerText:v("hasUnapprovedOrdersModal.heading"),hideSecondaryAction:!0,openSubscribe:$,primaryAction:function(e){e()},primaryActionText:"studio.payments.accounts.accountList.hasUnapprovedOrdersModal.primaryButton"},i.createElement(_r,{textAlign:"center"},i.createElement(Px,{marginBottom:"32px"},v("hasUnapprovedOrdersModal.description")),i.createElement(Sx,{onClick:function(){window.open("https://help.shootproof.com/hc/en-us/articles/360060453173","_blank")}},v("hasUnapprovedOrdersModal.learnMoreLink"))))))};var rce,oce,ice,ace,sce=fr(MF)(rce||(rce=zM(["\n    height: 26px;\n    width: 119px;\n"]))),lce=fr(_r)(oce||(oce=zM(["\n    .chakra-input__group {\n        width: 50%;\n    }\n\n    > .chakra-form__label {\n        font-weight: 600;\n        display: inline-block;\n    }\n"]))),cce=fr(L2)(ice||(ice=zM(["\n    list-style-type: disc !important;\n    margin-bottom: 1.5rem;\n    font-size: 14px;\n    color: #51646c;\n"]))),uce=fr(_r)(ace||(ace=zM(["\n    font-size: 14px;\n    line-height: 1rem;\n    font-weight: 600;\n    color: #2a5969;\n\n    a {\n        color: #23aedc;\n        cursor: pointer;\n    }\n"]))),dce={phone:"",terms:!1},pce=MU().shape({phone:aU().required("Phone number is required!").phoneNumber("Enter a valid phone number!"),terms:XH().oneOf([!0],"You must accept the terms and conditions!")}),fce=function(e){var t=e.children,n=mI(),r=n.touched,o=n.isValid;return i.createElement(fp,{maxHeight:34,minWidth:105,type:"submit",variant:sp.Primary,"data-testid":"setup-payments-submit-button",isDisabled:!o||0===Object.keys(r).length},t)};const hce=function(e){var t=e.phone,n=e.handleSubmit,r=Co("studio.account.spPay.setupPayments.initialPanel");return i.createElement(TI,{initialValues:Object.assign({},dce,{phone:t}),validateOnMount:!0,onSubmit:function(e){n(e)},validateOnChange:!0,validationSchema:pce,initialTouched:{phone:Boolean(t)}},i.createElement(BI,null,i.createElement(_r,{marginBottom:"2",display:"flex",justifyContent:"space-between",alignItems:"center"},i.createElement(_r,{fontSize:"2xl",fontWeight:"light"},r("studio.account.spPay.setupPayments.title")),i.createElement(sce,null)),i.createElement(Px,null,r("subheading")),i.createElement(Px,null,r("subheading-list-call")),i.createElement(cce,null,i.createElement(P2,{marginBottom:1},r("list-item-1")),i.createElement(P2,{marginBottom:1},r("list-item-2")),i.createElement(P2,{marginBottom:1},r("list-item-3")),i.createElement(P2,{marginBottom:1},r("list-item-4"))),i.createElement(lce,null,i.createElement(sQ,{label:r("set-up-sms"),isRequired:!0,labelSubtext:r("set-up-sms-description"),name:"phone",placeholder:"(555) 555-5555",variant:rQ.PhoneInput})),i.createElement(sQ,{marginTop:2,marginBottom:3,name:"terms","data-testid":"setup-payments-accepted-terms",variant:rQ.Checkbox},i.createElement(uce,null,r("terms-label")," ",i.createElement("a",{href:"https://www.shootproof.com/legal/terms-of-use",target:"_blank",rel:"noreferrer"},r("terms-link-label")),".")),i.createElement(fce,null,r("studio.account.spPay.setupPayments.start-setup"))))};const mce=function(e){var t,n=e.isOpen,r=e.onClose,o=e.status,a=void 0===o?null:o,s=e.currentBrandId,l=e.me,c=e.stripePublicKey,u=m((0,i.useState)(a),2),d=u[0],p=u[1],f=Kie(),h=Co("studio.account.spPay.setupPayments.account"),g="activated"===(null==l?void 0:l.mfaStatus),v=zo("merchant-account",{defer:!0}),y=v.performFetch,b=v.response,_=v.loading,A=m((0,i.useState)(""),2),E=A[0],w=A[1],x=(0,i.useRef)([]),k=null==b||null===(t=b.merchantAccounts)||void 0===t?void 0:t[0],C=zo("brand/"+s+"/sp-pay-gateway",{defer:!0}),S=C.performFetch,M=C.loading,T=zo("merchant-account",{defer:!0,method:"POST"}).performFetch,O=function(){var e=Lo(Io().mark((function e(t){return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return p("redirect-stripe"),e.next=3,T({data:{values:t}}).then((function(e){e&&(null==e?void 0:e.status)>=200&&(null==e?void 0:e.status)<=299&&window.location.replace(e.url)})).catch((function(){f({title:h("error"),description:h("error-message"),status:"error",duration:9e3,isClosable:!0})}));case 3:case"end":return e.stop()}}),e)})));return function(t){return e.apply(this,arguments)}}(),D=function(){var e=Lo(Io().mark((function e(t){return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!g){e.next=5;break}return e.next=3,O(t);case 3:e.next=8;break;case 5:w(t.phone),x.current.push(null),p("mfa-selection");case 8:case"end":return e.stop()}}),e)})));return function(t){return e.apply(this,arguments)}}(),L=function(){window.location.replace(new URL("/account/acceptpayments/verify/",window.location.origin).toString())},P=zo("merchant-account/"+(null==k?void 0:k.id),{defer:!0}),I=P.performFetch,B=P.loading;(0,i.useEffect)((function(){p(a),n&&y()}),[a,n,y]),(0,i.useEffect)((function(){p(b&&k?k.completionStatus:null)}),[b,k]);var R=function(){S({method:"PUT",data:{merchantAccountId:null==k?void 0:k.id},defer:!0}).then((function(){F4("Payment Gateway Connected",{type:"SpPay"}),f({title:h("connected"),description:h("connected-message"),status:"success",duration:9e3,isClosable:!0}),y()}))},N=function(){I({method:"DELETE",defer:!0}).then((function(){y()}))},F=function(){S({method:"DELETE",defer:!0}).then((function(){f({title:h("disconnected"),description:h("disconnected-message"),status:"success",duration:9e3,isClosable:!0}),y()}))},j=x.current.length?i.createElement(i.Fragment,null,i.createElement(Gr,{icon:i.createElement(rse,null),onClick:function(){if(0!==x.current.length){var e=x.current.pop();p(e)}},"aria-label":"Back",size:"lg",height:9,width:9,minWidth:9,"data-testid":"side-panel-back-button",backgroundColor:"transparent",color:"inherit",padding:"8px",position:"inherit",zIndex:"1",_hover:{backgroundColor:"transparent"},_focus:{outline:"none",border:"none"}})):void 0;return i.createElement(Jie,{isOpen:n,onClose:r,size:"lg",bodyStyles:{padding:"48px 20px "},headingContent:j},_||M||B?i.createElement(BF,null):function(){var e;if(null==l||null===(e=l.studio)||void 0===e||!e.isEligibleToSpPay)return i.createElement(ose,null);switch(d){case"mfa-selection":return i.createElement(sle,{onContinue:function(e){x.current.push("mfa-selection"),p("sms"===e?"mfa-sms":"mfa-app")}});case"mfa-sms":return i.createElement(gle,{phone:E,onContinue:Lo(Io().mark((function e(){return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return F4("2FA Enabled"),e.next=3,O({phone:E,terms:!0});case 3:case"end":return e.stop()}}),e)})))});case"mfa-app":return i.createElement(Ele,{onContinue:Lo(Io().mark((function e(){return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return F4("2FA Enabled"),e.next=3,O({phone:E,terms:!0});case 3:case"end":return e.stop()}}),e)})))});case"redirect-stripe":return i.createElement(BF,{description:i.createElement(Px,{textAlign:"center"},"Continuing to Stripe.",i.createElement("br",null),"You will be redirected in a just a moment.")});case"incomplete":return i.createElement(Yle,{handleFinishSetup:L,handleStartOver:N,merchantAccount:k,stripePublicKey:c,refreshMerchantAccountStatus:y});case"pending":return i.createElement(Gle,{handleStartOver:N,name:k.name,handleVisitStripe:L});case"complete":return i.createElement(nce,{handleConnect:R,handleDisconnect:F,data:k,currentBrandId:s,stripePublicKey:c});default:return i.createElement(hce,{phone:E,handleSubmit:D})}}())};var gce=function(e){var t=e.children,n=qd(),r={baseStyle:{closeButton:{color:n.colors.gray[500],backgroundColor:"transparent",cursor:"pointer",outline:"none","&:focus":{boxShadow:"none"},"&:hover":{color:"gray.500"}}}},o=Gd({styles:{global:{"#chakra-toast-portal > *":{zIndex:"301700 !important"}}},zIndices:{modal:301400,popover:301500,skipLink:301600,toast:301700,tooltip:301800},components:{Drawer:r},config:{initialColorMode:"light",useSystemColorMode:!1},isLightColorScheme:!0},n);return i.createElement(bC,{theme:o,resetCSS:!1,portalZIndex:300001},t)};const vce=$q((function(e){var t=e.me,n="US"!==(null==t?void 0:t.studio.country);return i.createElement(gce,null,n?i.createElement(Zae,e):i.createElement(mce,e))}));var yce=["AR","CL","CO","EC","IL","PH","ZA"];function bce(e){var t,n;return{rules:{".Input:focus":{borderColor:e.colors.blue[500],boxShadow:"0 0 0 1px "+e.colors.blue[500]},".Label":{fontSize:"14px"}},variables:{colorPrimary:e.colors.blue[500],colorText:null!==(t=null===(n=e.fontColor)||void 0===n?void 0:n.default)&&void 0!==t?t:e.colors.navy[400],fontFamily:e.fonts.body,fontSmooth:"auto",fontSizeBase:"14px",gridRowSpacing:"8px"}}}function _ce(e){return[{family:"azo-sans-web",src:'url("'+e+'/common/font/azosans-light.otf")',weight:"lighter"},{family:"azo-sans-web",src:'url("'+e+'/common/font/azosans-medium.otf")',weight:"bold"},{family:"azo-sans-web",src:'url("'+e+'/common/font/azosans.otf")',weight:"normal"}]}var Ace={_autofill:{boxShadow:"rgba(0, 0, 0, 0.03) 0px 1px 1px 0px, rgba(0, 0, 0, 0.02) 0px 3px 6px 0px, 0 0 0 100px rgb(255, 255, 255) inset"},_hover:{},border:"1px solid",borderColor:"#e6e6e6",borderRadius:"5px !important",color:"navy.400",height:"39px"},Ece={color:"navy.400",fontWeight:400,letterSpacing:0,lineHeight:1.15,marginBottom:"4px"},wce="poppy_panel_open",xce=(0,i.createContext)({isOpen:!1,onToggle:function(){},onClose:function(){}}),kce=function(e){var t=e.children,n=m((0,i.useState)((function(){try{return"1"===sessionStorage.getItem(wce)}catch(e){return!1}})),2),r=n[0],o=n[1];return(0,i.useEffect)((function(){try{r?sessionStorage.setItem(wce,"1"):sessionStorage.removeItem(wce)}catch(e){}}),[r]),i.createElement(xce.Provider,{value:{isOpen:r,onToggle:function(){return o((function(e){return!e}))},onClose:function(){return o(!1)}}},t)},Cce=function(){return(0,i.useContext)(xce)};var Sce=function(e){return e.AcceptPayments="/account/acceptpayments",e.AuthorizedApps="/account/authorizedapps",e.Booking="/booking",e.BrandHomepage="/brand/homepage",e.BrandWatermarks="/brand/watermark",e.BrandThemes="/brand/theme",e.ContactInfo="/account/contactinfo",e.Contacts="/contact",e.ContractTemplate="/contract/template",e.Contracts="/contract",e.Dashboard="/dashboard",e.Discounts="/pricing/discount",e.EmailActivity="/email/activity",e.EmailAutomation="/email/automation",e.EmailTemplate="/email/template",e.Galleries="/gallery",e.GalleryAppsForUploading="/gallery/appsforuploading",e.GalleryLoginWidget="/gallery/loginwidget",e.GalleryVisitorsReport="/report/galleryvisitor",e.InvoiceDiscountTemplate="/invoice/discount-template",e.InvoiceItemTemplate="/invoice/item-template",e.InvoicePaymentsReport="/reports/invoicepayment",e.InvoiceTemplate="/invoice/template",e.Invoices="/invoice",e.ItemsReport="/reports/item",e.LogOut="/common/logout",e.MobileApps="/mobileapp",e.Music="/music",e.MusicAbout="/music/about",e.MusicPlaylists="/music/playlists",e.Notifications="/notification",e.Onboarding="/welcome/intro",e.OrderFilesReport="/reports/orderfiles",e.Orders="/order",e.OrdersReport="/reports/order",e.Payments="/payment",e.PlanBilling="/account/planbilling",e.PriceSheets="/price-sheet",e.Questionnaires="/questionnaire",e.Refer="/account/refer",e.SalesReport="/reports/sale",e.Users="/account/user",e}({}),Mce=function(e){return e.Account="account",e.Brand="brand",e.Commerce="commerce",e.Dashboard="dashboard",e.Notifications="notifications",e.Photos="photos",e.Reports="reports",e.Studio="studio",e}({});function Tce(e){return e.altKey||e.ctrlKey||e.shiftKey||e.metaKey}function Oce(e,t){var n,r;return Boolean(e&&(t.href===e||(null===(n=t.otherHrefs)||void 0===n?void 0:n.includes(e))||(null===(r=t.regex)||void 0===r?void 0:r.test(e))))}var Dce=["menuItems"],Lce={externalRoutes:[],menus:[],showNav:!0,setShowNav:qT,openSetupPayments:qT},Pce=(0,i.createContext)(Lce),Ice=function(e){var r=Co("studio.nav"),o=m((0,i.useState)(!1),2),a=o[0],s=o[1],l=hO().me,c=l||{},u=c.isStudioOwner,d=c.studio,p=[Sce.Contacts,Sce.Contracts,Sce.ContractTemplate,Sce.EmailActivity,Sce.EmailAutomation,Sce.EmailTemplate,Sce.GalleryAppsForUploading,Sce.GalleryLoginWidget,Sce.GalleryVisitorsReport,Sce.Music,Sce.MusicAbout,Sce.MusicPlaylists,Sce.MobileApps,Sce.Orders,Sce.Discounts,Sce.PriceSheets],f=m((0,i.useState)(p),2),h=f[0],g=f[1],v=d||{},y=v.country,b=v.hasOrHadLegacySpPayments,_=v.isShootProofPayBlocked,A=aq().hasPermissions,E=!!y&&yce.includes(y);(0,i.useEffect)((function(){var e=new URLSearchParams(window.location.search),t=["shootproof-pay","payments-setup"].includes(e.get("open")||"");s(t)}),[]);var w=(0,i.useCallback)((function(){return{href:E?Sce.AcceptPayments:void 0,name:r("link.acceptPayments"),permissions:uO.AccountPaymentWithdrawal,onClick:E?void 0:function(){return s(!0)},requiresUnblockedStudioOwner:!0,isPaymentsMenuItem:!0}}),[E,r,s]),x=(0,i.useCallback)((function(){E?window.location.assign("/v2/"+e.currentBrandId+Sce.AcceptPayments):s(!0)}),[E,e.currentBrandId]),k=function(e,t){return(0,i.useMemo)((function(){return[{id:Mce.Account,menuItems:[{href:Sce.ContactInfo,name:t("link.contactInfo"),permissions:uO.AccountRead},{href:Sce.Users,name:t("link.users"),permissions:uO.AccountRead},{href:Sce.PlanBilling,name:t("link.planBilling"),permissions:uO.AccountRead},e(),{href:Sce.AuthorizedApps,name:t("link.authorizedApps"),permissions:uO.AccountRead},{href:Sce.Refer,name:t("link.refer")},{addSeparator:!0,href:Sce.Onboarding,name:t("link.onboarding")}],name:t("menu.account")},{buttonHref:Sce.Dashboard,id:Mce.Dashboard,name:t("menu.dashboard")},{id:Mce.Photos,menuItems:[{href:Sce.Galleries,name:t("link.allGalleries"),permissions:uO.EventRead,regex:/^\/gallery\/\d+(?:\/.*)?$/},{href:Sce.GalleryVisitorsReport,name:t("link.galleryVisitorsReport"),permissions:uO.ReportEventVisitorsRead},{href:Sce.Music,name:t("link.musicForGalleries"),permissions:uO.PlaylistRead,otherHrefs:[Sce.MusicPlaylists,Sce.MusicAbout],regex:/\/music(\/.*)?/},{href:Sce.BrandWatermarks,name:t("link.brandWatermarks"),permissions:uO.WatermarkRead},{href:Sce.MobileApps,name:t("link.mobileApps"),permissions:uO.MobileAppRead}],name:t("menu.galleries")},{id:Mce.Commerce,menuItems:[{href:Sce.Orders,name:t("link.orders"),permissions:uO.OrderRead},{href:Sce.AcceptPayments,name:t("link.payments"),permissions:uO.PayRead||uO.AccountPaymentWithdrawal,requiresUSStudio:!0},{href:Sce.Payments,name:t("link.legacyPayments"),permissions:uO.AccountPaymentRead,requiresLegacySpPaymentsUsage:!0},{href:Sce.PriceSheets,name:t("link.priceSheets"),permissions:uO.PriceSheetRead,regex:/\/(price-sheet|pricing\/discount)(\/.*)?/,otherHrefs:[Sce.Discounts]}],name:t("menu.store")},{id:Mce.Studio,menuItems:[{href:Sce.Contacts,name:t("link.clients"),permissions:uO.ContactRead},{href:Sce.Contracts,name:t("link.contracts"),permissions:uO.ContractRead},{href:Sce.Invoices,name:t("link.invoices"),permissions:uO.InvoiceRead,otherHrefs:[Sce.InvoiceItemTemplate,Sce.InvoiceDiscountTemplate,Sce.InvoiceTemplate]},{href:Sce.Questionnaires,name:t("link.questionnaires"),permissions:uO.QuestionnaireView,regex:/\/questionnaire(\/.*)?/},{href:Sce.Booking,name:t("link.booking"),regex:/\/booking(\/.*)?/,permissions:uO.BookingView},{href:Sce.BrandThemes,name:t("link.brandThemes"),permissions:uO.BrandThemeRead},{href:Sce.EmailActivity,name:t("link.email"),permissions:uO.EmailTemplateRead,otherHrefs:[Sce.EmailTemplate,Sce.EmailAutomation]},{href:Sce.BrandHomepage,name:t("link.brandHomepage"),permissions:uO.BrandHomepageUpdate}],name:t("menu.studio")},{id:Mce.Reports,menuItems:[{href:Sce.SalesReport,name:t("link.salesReport"),permissions:uO.ReportSalesRead},{href:Sce.OrdersReport,name:t("link.ordersReport"),permissions:uO.ReportOrdersRead},{href:Sce.OrderFilesReport,name:t("link.orderFilesReport"),permissions:uO.ReportOrdersRead},{href:Sce.ItemsReport,name:t("link.productsReport"),permissions:uO.ReportItemsRead},{href:Sce.InvoicePaymentsReport,name:t("link.invoicesReport"),permissions:uO.ReportInvoiceRead}],name:t("menu.reports")}]}),[e,t])}(w,r),C=(0,i.useCallback)((function(e){var t=e.permissions,n=e.requiresLegacySpPaymentsUsage,r=e.requiresUSStudio,o=e.requiresUnblockedStudioOwner;return!(t&&!A(t))&&((!r&&!n||"US"===y)&&(!(n&&!b)&&!(o&&(!u||_))))}),[A,u,_,y,b]),S=(0,i.useCallback)((function(e){var r=e.menuItems;return n({},t(e,Dce),{menuItems:r?r.filter(C):r})}),[C]),M=(0,i.useCallback)((function(e){var t=e.buttonHref,n=e.menuItems;return Boolean(t)||(n||[]).some(C)}),[C]),T=m((0,i.useState)(!0),2),O=T[0],D=T[1],L=(0,i.useMemo)((function(){return k.filter(M).map(S)}),[k,S,M]),P=zo("merchant-account",{defer:!0}),I=P.performFetch,B=P.response;(0,i.useEffect)((function(){(u||"sp_pay"===(null==d?void 0:d.paymentGatewayType))&&I()}),[I,u,null==d?void 0:d.paymentGatewayType]),(0,i.useEffect)((function(){var e=(null!=B?B:{}).merchantAccounts,t=null==e?void 0:e[0];null!=t&&t.isActive&&function(e){var t=e.links["sp-pay"].href;g((function(e){return[].concat(e,[t])}));var n=R(L);n&&(n.href=t,n.opensInNewTab=!0,n.prependBrandPathToHref=!1,n.isPaymentsMenuItem=!0)}(t)}),[y,L,B]);var R=function(e){var t,n;return(null!==(t=null===(n=e.find((function(e){return e.id===Mce.Commerce})))||void 0===n?void 0:n.menuItems)&&void 0!==t?t:[]).find((function(e){return e.href===Sce.AcceptPayments}))};return i.createElement(Pce.Provider,n({},e,{value:{externalRoutes:h,menus:L,showNav:O,setShowNav:D,openSetupPayments:x}}),e.children,i.createElement(vce,{isOpen:a,onClose:function(){return s(!1)},currentBrandId:e.currentBrandId,me:l,stripePublicKey:e.stripePublicKey}))};const Bce=Pce;var Rce={};const Nce={get:Fce,getHref:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return Fce(e,t).slice(1)},setDefaultParameter:function(e,t){Rce[e]=t}};function Fce(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=(e.match(/\:[A-Za-z0-9\_\-\?]+/g)||[]).reduce(jce,{parameters:t,route:e}),r=n.route,o=n.parameters;if(Object.keys(o).length>0){var i=function(e){var t=Object.keys(e).map((function(t){return function(e,t){if(Array.isArray(t)){var n=t.map((function(e){return e+"&"}));return n.unshift(""),n.join(e+"[]=").slice(0,-1)}return e+"="+encodeURIComponent(t||"")}(t,e[t])}));return"?"+t.join("&")}(o);return""+r+i}return r}function jce(e,t){var n=e.parameters,r=e.route,o=t.replace(/[\:\?]/g,""),i=n[o]||Rce[o];return i&&(r=r.replace(t,encodeURIComponent(i))),(n.hasOwnProperty(o)||function(e){return e.indexOf("?")>=0}(t))&&(r=r.replace(t,"")),delete n[o],{parameters:n,route:r}}var Yce=function(e){var t=(0,i.useCallback)((function(){return a((function(){return!0}))}),[]),n=(0,i.useCallback)((function(){return a((function(){return!1}))}),[]),r=m((0,i.useState)(e),2),o=r[0],a=r[1];return{isTrue:!0===o,setTrue:t,setFalse:n,toggle:(0,i.useCallback)((function(){a((function(e){return!e}))}),[]),value:o}},$ce=new Set;const Hce=function(){return(0,i.useContext)(Bce)};const Uce=function(){var e=location.search;return(0,i.useMemo)((function(){return new URLSearchParams(e)}),[e])};const zce=function(e){var t,n=zo("brand/"+e).response,r=(null!=n?n:{}).isEligibleToManagePlan,o=hO(),i=o.isRefreshingMe,a=o.me,s=(a||{}).studio||{},l=s.hasCreditCardOnFile,c=s.photoPlan,u=s.promoCode,d=(c||{}).isFree||!l,p=Uce(),f=p.get("openCheckout"),h=p.get("openSelectPlan"),m=p.get("promoCode"),g=null!=m?m:u,v=Boolean(m),y=zo("promo/"+m,{defer:!v}).response,b=!(!v||!y)&&(null!==(t=y.isForBookingPlan)&&void 0!==t&&t),_=Boolean(f)||Boolean(h)||Boolean(m),A=!i&&d&&Boolean(a)&&Boolean(r),E=A||Boolean(f||h||m)&&Boolean(r);return{isPromoForBookingPlan:b,openTrialCheckoutModalOnRender:_,openSelectPlanFromQuery:Boolean(h),promoCode:g,promoResponse:y,showUpgradeButton:A,trialCheckoutModalAvailable:E}};var Wce,Vce,Gce,Qce=["title","titleId"];function qce(){return qce=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},qce.apply(null,arguments)}var Kce=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Qce);return i.createElement("svg",qce({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 100 20",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Wce||(Wce=i.createElement("path",{className:"script-name",d:"M7.031 6.963c-1.703-.36-5.117-.648-5.117-1.942 0-1.879 6.171-3.187 9.661-3.187 2.192 0 1.888-1.14 1.303-1.478-.572-.33-3.504-.068-4.349.032-2.22.26-4.019.693-5.849 1.528C1.465 2.471-.788 4.304.298 5.951c.909 1.376 2.936 1.664 4.412 2.013 1.824.43 6.78 1.068 6.78 2.548 0 .899-2.179 1.373-3.833 1.421a18.35 18.35 0 01-5.391-.652c-.706-.197-1.568-.86-1.849-.368-.302.534.216.936.72 1.214 1.549.855 3.729 1.241 5.693 1.241 2.07 0 3.987-.061 5.701-1.18 1.229-.8 1.142-2.769-.117-3.484-1.562-.89-3.487-1.342-5.383-1.741zM53.933 4.387c1.08-1.069 1.209-2.541-.04-3.502-1.343-1.039-4.584-.648-5.24-.536-.651.113-1.698.35-2.396.566-.749.231-1.425.505-1.687.714-.246.197-.41.402-.303.692.081.215.368.283.579.308.21.025.695-.015 1.267-.155-.018.146-.042.386-.073.714-.029.334-.067.71-.113 1.133-.044.424-.088.865-.13 1.331-.045.46-.045.443-.08.839-.032.393-.44 5.824-.463 6.107-.07.914 1.558 1.125 1.646.033.027-.355.433-5.5.486-6.045 3.13-.037 5.821-1.482 6.547-2.199zm-6.439.848l.255-3.171c.816-.176 2.216-.332 2.837-.363 2.082-.104 2.575.97 2.101 1.603-.707.944-2.854 1.888-5.193 1.931zM43.341 10.646c-.453-.238-.499.535-.838.953-.372.46-1.329.695-1.791-.017a2.196 2.196 0 01-.294-.759c-.055-.291-.061-.591-.055-.909.004-.319.021-.59.047-.814.023-.175.054-.406.085-.694.03-.284.065-.595.103-.933.285-.025 1.269-.103 1.406-.116.251-.025.739-.177.744-.707.027-.258-.126-.527-.61-.535-.142-.001-.993-.014-1.39.01.049-.299.177-1.133.204-1.329.127-.895.065-1.327-.708-1.403-.807-.078-1.047.412-1.123.949-.018.13-.152 1.668-.179 1.839l-1.086.039c-.21.012-.401.055-.569.129a1.254 1.254 0 00-.366.227.492.492 0 00-.149.243.876.876 0 00-.058.262c.014.138.054.231.122.28a.781.781 0 00.234.113c.113.024.337.036.673.036h1.085c-.024.438-.051.877-.074 1.32-.021.357-.098.684-.535.919-.188.1-.51.138-.733.114-.273-.03-.595-.05-1.249-.71-.656-.661-1.712-1.016-2.861-.877-.942.115-1.748.545-2.268 1.135-.216.245-.475.382-.793.479-.323.1-.681.081-.98-.013-.36-.111-.594-.332-.67-.401-.014-.013-.093-.092-.193-.184-.631-.746-1.763-1.167-2.989-1.016-1.418.173-2.503 1.03-2.814 2.127-.151.532-.178.747-.354 1.095-.461.913-2.107 1.134-2.254-.189-.034-.291.042-1.679.045-1.822.039-1.55-1.043-1.477-1.245-1.466-.716.039-1.415.86-1.718 1.212-.123.143-.319.263-.31.084.065-1.101.434-4.56.463-4.889.13-1.376-1.839-1.366-1.947-.396-.092.845-.166 1.573-.245 2.356-.087.844-.462 5.379-.449 5.81.034 1.05.773 1.192 1.083 1.172.286-.017.478-.186.666-.38.309-.317.789-1.426.895-1.63.106-.207.163-.356.285-.514a.452.452 0 01.342-.197c.164-.001.253.082.325.341.909 3.228 3.6 2.677 4.679 1.085.746 1.114 2.109 1.396 3.174 1.269 1.053-.13 1.949-.68 2.438-1.35.293-.404.364-.761.407-1.065.46.125 1.19.084 1.568-.095-.03.139-.028.247-.014.366.167 1.4 1.736 2.359 3.494 2.144 1.34-.167 2.673-1.022 2.853-2.416.661.142 1.495.04 1.935-.453-.042.797.22 1.389.397 1.726.173.327.444.687.792.887.35.199.631.313 1.167.313.425 0 .799-.084 1.122-.255a2.12 2.12 0 00.76-.626c.383-.517.738-1.656.318-1.874zM25.932 11.95c-.771.093-1.455-.327-1.532-.939-.075-.614.488-1.186 1.258-1.28.772-.095 1.455.325 1.53.938.075.612-.488 1.187-1.256 1.281zm7.894 0c-.771.093-1.456-.327-1.53-.939-.076-.614.487-1.186 1.256-1.28.772-.095 1.455.325 1.529.938.076.612-.487 1.187-1.255 1.281z"})),Vce||(Vce=i.createElement("path",{className:"script-name",d:"M76.31 10.476c-.354-.167-.507.469-.641.759a1.784 1.784 0 01-1.006.942c-.308.117-1.069.138-1.323-.168a7.083 7.083 0 00-.684-.743l.107-1.148c2.453-2.644 3.331-5.041 3.437-5.374.258-.813.511-2.008-.064-2.619-.77-.818-1.927-.754-2.927-.137-.645.399-1.141 1.151-1.33 2.313-.19 1.163-.471 3.845-.582 4.76l-.027.222a.758.758 0 01-.542.662c-.251.081-.585.081-.893-.004-.282-.08-.58-.308-1.074-.779h-.001c-.651-.646-1.706-1-2.843-.86-1.023.125-1.887.622-2.395 1.291-.007.007-.011.014-.011.014-.102.098-.437.461-1.051.444-.414-.01-.678-.035-1.323-.76-.644-.725-1.754-1.138-2.968-.989-1.61.198-2.814 1.313-2.882 2.578-.011.202-.038.56-.154.798-.089.186-.397.62-.879.62-.398 0-1.042-.456-1.021-1.688.005-.179.01-.83.01-1.106 0-.306-.071-.517-.268-.69-.094-.082-.545-.255-.652-.288a4.985 4.985 0 00-1.796-.215c-.294.024-.813.13-.858.433a8.99 8.99 0 01-1.226 3.36c-.401.65.227 1.042.811.252.382-.518.994-1.559 1.259-2.315.224-.026.52-.02.786.063.122.039.291.147.302.247.013.11.017.281.009.502-.006.227.024.476.084.751.657 2.966 3.669 1.501 4.015.618.754.98 1.894 1.293 3.081 1.148 1.343-.164 2.725-1.089 2.862-2.44.434.12 1.05.136 1.393-.15-.143 1.785 1.739 2.805 3.491 2.59 1.403-.172 2.732-1.144 2.857-2.44.581.146 1.255.126 1.69-.12-.187 2.087-.337 4.062-.327 5.232.013 1.359.317 2.317.699 2.872.381.556.959.967 1.744.898 1.117-.101 1.597-.971 1.777-1.399.244-.58.377-1.966.185-2.67-.078-.286-.341-1.351-.915-2.371 1.207-.27 1.628-.609 1.898-1.042.413-.665.445-1.724.166-1.854zm-17.694 1.499c-.767.095-1.452-.326-1.527-.938-.077-.612.487-1.187 1.256-1.28.77-.095 1.457.325 1.53.938.075.613-.488 1.185-1.259 1.28zm7.745 0c-.767.095-1.453-.326-1.528-.938-.075-.612.488-1.187 1.257-1.28.77-.095 1.455.325 1.53.938.076.613-.487 1.185-1.259 1.28zm7.003-7.704c.221-.918 1.773-1.215 1.349.318-.438 1.581-1.879 3.317-1.879 3.317s.237-2.411.53-3.635zm.331 13.62c-.116.226-.461.422-.713.11-.259-.317-.494-.755-.539-1.513-.077-1.276.012-2.603.054-3.779.226.322.802 1.307.958 1.73.251.686.428 1.29.463 1.839.058.908 0 1.173-.223 1.613z"})),Gce||(Gce=i.createElement("path",{className:"crop",d:"M82.624 5.408V2.065c0-.83.831-1.868 1.867-1.868h3.344L86.383 1.65h-1.892c-.206 0-.415.207-.415.415v1.89l-1.452 1.453zM87.835 13.399h-3.344c-.83 0-1.867-.831-1.867-1.869V8.189l1.453 1.453v1.89c0 .208.209.416.415.416h1.892l1.451 1.451zM100 8.189v3.342c0 .831-.83 1.869-1.868 1.869H94.79l1.452-1.453h1.891c.207 0 .415-.208.415-.416v-1.89L100 8.189zM94.79.197h3.343c.83 0 1.868.83 1.868 1.868v3.343l-1.453-1.453v-1.89a.445.445 0 00-.415-.415h-1.891L94.79.197z"})))},Zce=(0,i.forwardRef)(Kce);o.p;var Jce,Xce,eue,tue=["title","titleId"];function nue(){return nue=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},nue.apply(null,arguments)}var rue=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,tue);return i.createElement("svg",nue({viewBox:"0 0 26 26",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Jce||(Jce=i.createElement("path",{className:"active-cutout keep-stroke",fillRule:"evenodd",clipRule:"evenodd",d:"M13 24.2812C19.6274 24.2812 25 19.1185 25 12.75C25 6.38144 19.6274 1.21872 13 1.21872C6.37258 1.21872 1 6.38144 1 12.75C1 19.1185 6.37258 24.2812 13 24.2812Z",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),Xce||(Xce=i.createElement("path",{d:"M16 10.073C16 8.36718 14.6569 6.98431 13 6.98431C11.3431 6.98431 10 8.36718 10 10.073V11.1026C10 12.8085 11.3431 14.1913 13 14.1913C14.6569 14.1913 16 12.8085 16 11.1026V10.073Z",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),eue||(eue=i.createElement("path",{d:"M17.5 18.0034C16.306 17.0804 14.6875 16.562 13 16.562C11.3125 16.562 9.69399 17.0804 8.5 18.0034",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})))},oue=(0,i.forwardRef)(rue);o.p;var iue,aue=["title","titleId"];function sue(){return sue=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},sue.apply(null,arguments)}var lue=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,aue);return i.createElement("svg",sue({viewBox:"0 0 24 23",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,iue||(iue=i.createElement("path",{d:"M12 1L15.399 7.91167L23 9.02681L17.5 14.4038L18.798 22L12 18.4117L5.202 22L6.5 14.4038L1 9.02681L8.601 7.91167L12 1Z",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})))},cue=(0,i.forwardRef)(lue);o.p;var uue,due,pue=["title","titleId"];function fue(){return fue=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},fue.apply(null,arguments)}var hue=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,pue);return i.createElement("svg",fue({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,uue||(uue=i.createElement("g",{clipPath:"url(#clip0_428_34943)"},i.createElement("path",{d:"M4 5H21",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M4 12H21",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M4 19H21",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),due||(due=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_428_34943"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},mue=(0,i.forwardRef)(hue);o.p;var gue,vue=["title","titleId"];function yue(){return yue=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},yue.apply(null,arguments)}var bue=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,vue);return i.createElement("svg",yue({width:16,height:16,viewBox:"0 0 16 16",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,gue||(gue=i.createElement("g",{fillRule:"nonzero",fill:"currentColor"},i.createElement("path",{d:"M6.4 2.2a6.4 6.4 0 0 0 6.4 6.4A6.4 6.4 0 0 0 6.4 15 6.4 6.4 0 0 0 0 8.6a6.4 6.4 0 0 0 6.4-6.4zM12.8 0A3.2 3.2 0 0 0 16 3.2a3.2 3.2 0 0 0-3.2 3.2 3.2 3.2 0 0 0-3.2-3.2A3.2 3.2 0 0 0 12.8 0zM12.8 12.8a1.6 1.6 0 0 0 1.6 1.6 1.6 1.6 0 0 0-1.6 1.6 1.6 1.6 0 0 0-1.6-1.6 1.6 1.6 0 0 0 1.6-1.6z"}))))},_ue=(0,i.forwardRef)(bue);o.p;const Aue=function(e){var t=e.iconSize,n=void 0===t?24:t,r=e.testId,o=void 0===r?"assistant-button":r,a=Cce().onToggle;return i.createElement(Wr,{"aria-label":"Open Poppy","data-testid":o,onClick:a,variant:"ghost",sx:{alignItems:"center",color:"#0c547d",display:"flex",gap:"6px",fontSize:"14px",fontWeight:"500",padding:"6px 10px",whiteSpace:"nowrap","&, &:hover, &:focus, &:active":{background:"transparent",boxShadow:"none"},"&:hover":{color:"#19a0cc"},"&:focus, &:active":{color:"#0c547d",outline:"none"}}},i.createElement(_ue,{width:n,height:n,style:{display:"block"}}),i.createElement("span",null,"Ask Poppy"))};const Eue=function(){var e=Cce(),t=e.isOpen,n=e.onClose;return i.createElement(_r,{display:{base:"none",md:"block"}},i.createElement(Aue,{iconSize:28,testId:"nav-assistant-button"}),i.createElement(oi,{isOpen:t,onClose:n}))};var wue,xue,kue,Cue,Sue=fr("span")((function(e){return"\n        color: "+e.theme.colors.white+";\n        display: block;\n        font-size: 16px;\n        font-weight: 300;\n        line-height: 21px;\n    "})),Mue=fr(_r,{shouldForwardProp:function(e){return!["isActive","isIcon","isRightAligned"].includes(String(e))}})((function(e){var t=e.isActive,n=e.isIcon,r=e.isRightAligned,o="#5AAFCC",i=n?"12px":"3px";return"\n        background: "+(t?o:"initial")+";\n        border-radius: 3px;\n        cursor: pointer;\n        margin-left: "+(r?i:"0")+";\n        margin-right: "+(r?"0":i)+";\n        padding: "+(n?"7px 10px 11px":"9px 22px")+";\n\n        &:hover {\n            background: "+o+";\n        }\n\n        "+(t?".notifications-label {\n                        color: "+o+";\n                        border: 3px solid "+o+";\n                    }":"")+"\n    "})),Tue=fr(_r,{shouldForwardProp:function(e){return!["isIcon","isRightAligned"].includes(String(e))}})((function(e){var t=e.isIcon,n=e.isRightAligned,r=t?"13px":"20px",o=t?"-1px":"3.5px",i=t?"11px":"18px",a=t?"-3px":"1.5px";return"\n        height: 14.5px;\n        position: relative;\n        z-index: 3;\n\n        &:after,\n        &:before {\n            border-bottom: solid;\n            border-left: solid transparent;\n            border-right: solid transparent;\n            border-top: none;\n            content: '';\n            height: 0;\n            position: absolute;\n            width: 0;\n        }\n\n        &:after {\n            border-bottom-color: "+e.theme.colors.white+';\n            border-width: 6.5px;\n            content: "";\n            left: '+(n?"initial":r)+";\n            right: "+(n?r:"initial")+";\n            top: "+o+';\n        }\n\n        &:before {\n            border-bottom-color: rgba(0, 0, 0, 0.1);\n            border-width: 8.5px;\n            content: "";\n            left: '+(n?"initial":i)+";\n            right: "+(n?i:"initial")+";\n            top: "+a+";\n        }\n    "})),Oue=["activeRouteGroup","buttonHref","children","currentBrandId","exclusiveOpenMenuId","icon","id","isRightAligned","menuItems","name","navigate","setExclusiveOpenMenuId"],Due=fr("span")(wue||(wue=zM(["\n    color: currentColor;\n"]))),Lue=fr(Kr)(xue||(xue=zM(["\n    &:focus {\n        box-shadow: none;\n    }\n"]))),Pue=fr(Cae)((function(){return'\n        border: 1px solid rgba(0, 0, 0, 0.1);\n        border-radius: 8px;\n        box-shadow: 0 4px 10px 0 rgb(0 0 0 / 30%);\n        margin: 0;\n        overflow: hidden;\n        padding: 16px;\n\n        &[x-placement^="bottom-start"] {\n            margin-top: 0;\n        }\n   '})),Iue=fr(Kr)((function(e){var t=e.theme,n=t.colors.blue[100];return"\n        background: "+t.colors.white+";\n        border-radius: 8px;\n        cursor: pointer;\n        display: block;\n        font-size: 16px;\n        font-weight: 300;\n        line-height: 20px;\n        padding: 10px 12px;\n\n        &, &:visited {\n            color: "+t.colors.gray[700]+";\n        }\n\n        &:focus {\n            box-shadow: none;\n        }\n\n        &:hover {\n            background: "+n+";\n            color: "+t.colors.navy[500]+";\n            font-weight: 600;\n            text-decoration: none;\n        }\n\n        &[disabled] {\n            color: #DAE1E3;\n            opacity: 1;\n        }\n    "})),Bue=fr(_r)((function(){return"\n        border-bottom: 1px solid #DAE1E3;\n        margin-bottom: 16px;\n        margin-top: 16px;\n    "})),Rue=function(e){var r=e.activeRouteGroup,o=e.buttonHref,a=e.children,s=e.currentBrandId,l=e.exclusiveOpenMenuId,c=e.icon,u=e.id,d=e.isRightAligned,p=void 0!==d&&d,f=e.menuItems,h=e.name,m=void 0===h?"":h,g=e.navigate,v=e.setExclusiveOpenMenuId,y=t(e,Oue),b=(0,i.useRef)(),_=Boolean(c),A=Yce(!1),E=A.setFalse,w=A.value,x=A.setTrue;(0,i.useEffect)((function(){l!==u&&(clearTimeout(b.current),E())}),[E,l,u]);var k=(0,i.useCallback)((function(){clearTimeout(b.current),v(u),x()}),[x,v,u]),C=(0,i.useCallback)((function(){v(null),E()}),[E,v]),S=(0,i.useCallback)((function(){b.current=setTimeout(C,1e3)}),[C]),M=i.createElement(bae,{as:Mue,"data-testid":"nav-menu-button-"+u,isActive:w||!o&&!_&&u===r,isIcon:_,isRightAligned:p,onClick:w?C:k,onMouseEnter:k,onMouseLeave:S},i.createElement(Sue,null,c||m));return i.createElement(vae,{autoSelect:!1,closeOnBlur:!1,"data-testid":"nav-menu",isOpen:w,gutter:_?4.5:13.5,offset:[12,4.5],placement:"bottom-start"},(function(){return i.createElement(_r,n({},y,{height:_?"40.5px":"40px",overflow:"visible"}),o?i.createElement(Lue,{"data-testid":"nav-menu-button-link",href:"/v2/"+s+o,onClick:function(e){g(o)&&!Tce(e)&&e.preventDefault()}},M):M,(a||f)&&i.createElement(i.Fragment,null,w&&i.createElement(Tue,{isIcon:_,isRightAligned:p}),i.createElement(Pue,{"data-testid":"nav-menu-list",zIndex:2,onMouseEnter:k,onMouseLeave:S},a,f&&f.map((function(e,t){var n=e.addSeparator,r=e.beforeName,o=e.content,a=e.href,l=e.isDisabled,c=e.name,u=e.opensInNewTab,d=e.prependBrandPathToHref,p=void 0===d||d,f=e.onClick,h=a?(p?"/v2/"+s:"")+a:void 0;return i.createElement(_r,{key:t},r&&i.createElement(Due,null,r),o||i.createElement(Iue,{"data-testid":"nav-menu-item-"+QT(c),href:h,disabled:l?"disabled":void 0,onClick:function(e){f?(e.preventDefault(),f()):a&&g(a,u)&&!Tce(e)&&e.preventDefault()}},c),n&&i.createElement(Bue,null))})))))}))},Nue=fr(Rue,{shouldForwardProp:function(e){return"isImposter"!==e}})((function(e){var t=e.isImposter,n=e.theme;return"\n        "+n.responsive.smallScreenOnly(kue||(kue=zM(["\n            display: none;\n        "])))+"\n\n        "+(t?"\n                    .chakra-menu__menu-button span {\n                        color: "+n.colors.red[400]+";\n                    }\n                ":"")+"\n    "})),Fue=fr(Rue)(Cue||(Cue=zM(["\n    @media only screen and (max-width: 768px) {\n        display: none;\n    }\n"])));var jue="48px",Yue={"& p":{m:"0 !important"},'& [data-testid="notification-tile-container"]':{color:"inherit !important",textDecoration:"none !important"},'& [data-testid="notification-tile-type"] svg':{color:"white !important",fill:"none !important",stroke:"white !important"},'& [data-testid="notification-tile-type"] svg path[stroke], & [data-testid="notification-tile-type"] svg line, & [data-testid="notification-tile-type"] svg circle, & [data-testid="notification-tile-type"] svg polyline':{fill:"none !important",stroke:"white !important"},'& [data-testid="notification-tile-type"] svg path[fill], & [data-testid="notification-tile-type"] svg path[fill="currentColor"]':{fill:"white !important"},'& .notification-flyout-tile, & [role="group"]':{height:"auto !important",minHeight:"0 !important",maxHeight:"none !important"},"& .notification-item-style-container, & .notification-message, & .notification-details, & .notification-group, & .notification-created, & .sp-notification-tile-item":{height:"auto !important",minHeight:"0 !important",m:"0 !important",p:"0 !important",width:"auto !important",lineHeight:"inherit !important",whiteSpace:"normal"}},$ue=n({border:"1px solid rgba(0, 0, 0, 0.1)",borderRadius:"8px",boxShadow:"0 4px 10px 0 rgb(0 0 0 / 30%)",fontFamily:"'azo-sans-web', 'Helvetica', 'Arial', sans-serif",margin:"0 !important",minW:"300px",maxW:"360px",overflow:"hidden",padding:"4px 0 !important"},Yue),Hue=n({bg:"white",border:"none",borderRadius:0,bottom:0,boxShadow:"none",display:"flex",flexDirection:"column",fontFamily:"'azo-sans-web', 'Helvetica', 'Arial', sans-serif",height:"calc(100vh - 48px)",left:0,margin:0,overflow:"hidden",padding:"4px 0",position:"fixed",right:0,top:jue,width:"100vw"},Yue),Uue={display:"flex",flexDirection:"column",maxHeight:"calc(50vh - 32px)",width:"100%"},zue={display:"flex",flexDirection:"column",flex:1,height:"100%",maxHeight:"100%",minHeight:0,width:"100%"},Wue={flex:"1",minHeight:0,overflowY:"auto"},Vue={alignItems:"center",borderBottom:"1px solid",borderColor:"neutral.200",flexShrink:0,justifyContent:"space-between",px:3,py:2,w:"full",'& [data-testid="notification-header-label"]':{color:"neutral.600"},'& [data-testid="notification-header-view-all"]':{color:"secondary.400",fontWeight:"bold",textDecoration:"none",_hover:{color:"secondary.500",textDecoration:"underline"}}},Gue={alignItems:"center",display:"flex",flexDirection:"row",gap:1,height:"auto !important",maxW:"100%",minHeight:"0 !important",minW:0,m:"0 !important",p:"8px 12px !important",w:"100%",borderBottom:"1px solid",borderColor:"neutral.100",_hover:{bg:"neutral.50"},"&:last-of-type":{borderBottom:"none"},'& [data-testid="notification-tile-container"]':{alignItems:"center",color:"inherit !important",display:"flex",flex:"1 1 0%",gap:2,height:"auto !important",maxW:"100%",minHeight:"0 !important",minW:0,m:"0 !important",overflow:"hidden",p:"0 !important",textDecoration:"none !important",_hover:{color:"inherit !important",textDecoration:"none !important"}},'& [data-testid="notification-tile-type"]':{flexShrink:0,lineHeight:0},'& [data-testid="notification-tile-message"]':{mt:"2px !important"},'& [data-testid="notification-tile-dismiss-button"]':{alignItems:"center",alignSelf:"center",color:"neutral.500",display:"inline-flex",flexShrink:0,h:"28px",justifyContent:"center",lineHeight:0,minH:"28px",minW:"28px",p:"0 !important",w:"28px","& .chakra-button__icon":{display:"flex",alignItems:"center",justifyContent:"center",m:"0 !important",lineHeight:0},"& svg":{display:"block"},_hover:{bg:"neutral.100",color:"neutral.700"}}},Que={color:"neutral.600",fontSize:"sm",m:"0 !important",px:4,py:10,textAlign:"center"};const que=function(e){var t=e.children,n=e.header,r=u9({base:!0,md:!1},{fallback:"md"})?zue:Uue;return i.createElement(_r,{sx:r},n,i.createElement(_r,{"data-testid":"notification-flyout-scroll",sx:Wue},t))};const Kue=function(e){var t=e.href,n=e.navigate,r=Co("studio.nav.notifications");return i.createElement(wr,{className:"notification-flyout-header",sx:Vue},i.createElement(qr,{as:"span",color:"neutral.600","data-testid":"notification-header-label",fontSize:"sm",fontWeight:"semibold"},r("header")),i.createElement(Kr,{color:"secondary.400","data-testid":"notification-header-view-all",fontSize:"sm",fontWeight:"bold",href:t,_hover:{color:"secondary.500",textDecoration:"underline"},onClick:function(e){return n(t)&&e.preventDefault()}},r("viewNotifications")))};const Zue=function(e){var t=e.children,n=e.bgColor,r=void 0===n?"primary.400":n;return i.createElement(_r,{width:"32px",height:"32px",borderRadius:"50%",bg:r,display:"flex",alignItems:"center",justifyContent:"center",color:"white"},t)};function Jue(){return Jue=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Jue.apply(this,arguments)}function Xue(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}var ede=(0,i.forwardRef)((function(e,t){var n=e.color,r=void 0===n?"currentColor":n,o=e.size,a=void 0===o?24:o,s=Xue(e,["color","size"]);return i.createElement("svg",Jue({ref:t,xmlns:"http://www.w3.org/2000/svg",width:a,height:a,viewBox:"0 0 24 24",fill:"none",stroke:r,strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"},s),i.createElement("path",{d:"M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"}),i.createElement("line",{x1:"7",y1:"7",x2:"7.01",y2:"7"}))}));ede.propTypes={color:Xr().string,size:Xr().oneOfType([Xr().string,Xr().number])},ede.displayName="Tag";const tde=ede;var nde={CONTRACT:"contract",EVENT:"event",INVOICE:"invoice",ORDER:"order",STUDIO:"studio",BOOKING:"booking",QUESTIONNAIRE:"questionnaire"},rde={GRANTED_ARCHIVING_SPACE:"granted-archiving-space",CONTRACT:{CANCELLED:"contract-canceled",SIGNED_BY_CLIENT:"contract-signed-by-client"},EVENT:{DOWNLOAD_EMAIL_UNSENT:"event-digital-download-email-unsent",FAVORITES_FINALIZED:"event-favorites-list-finalized-by-event-contact",PHOTO_DOWNLOADED:"event-photo-downloaded-by-event-contact",PHOTO_FAVORITED:"event-photo-favorited-by-event-contact",PHOTO_HIDDEN:"event-photo-hidden-by-event-contact",PHOTO_TAGGED:"event-photo-tagged-by-event-contact"},FAVORITES:"favorites",INVOICE:{PAYMENT_RECEIVED:"invoice-payment-received",PAST_DUE:"invoice-past-due"},ORDER:{APPROVAL_PROLONGED:"order-approval-prolonged",NEEDS_APPROVAL:"order-needs-approval",PLACED:"order-placed",SHIPPED_FROM_LAB:"order-shipped-from-lab"},STUDIO:{PROFIT_RELEASED:"studio-profit-released",PHOTO_PLAN_NEXT_BILL_DATE_RELEASED:"studio-photo-plan-next-bill-date-released",MONEY_BALANCE_INCREASED:"studio-money-balance-increased"},BOOKING:{SESSION_CONFIRMED:"booking-session-confirmed",SESSION_NEEDS_CONFIRMATION:"booking-session-needs-confirmation"},QUESTIONNAIRE:{COMPLETED:"questionnaire-completed"}};var ode,ide,ade=["title","titleId"];function sde(){return sde=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},sde.apply(null,arguments)}var lde=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,ade);return i.createElement("svg",sde({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,ode||(ode=i.createElement("g",{clipPath:"url(#clip0_448_11280)"},i.createElement("path",{d:"M16 2V6",stroke:"currentColor",strokeMiterlimit:10,strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M8 2V6",stroke:"currentColor",strokeMiterlimit:10,strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M3 9H21",stroke:"currentColor",strokeMiterlimit:10,strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M19 4H5C3.895 4 3 4.895 3 6V19C3 20.105 3.895 21 5 21H19C20.105 21 21 20.105 21 19V6C21 4.895 20.105 4 19 4Z",stroke:"currentColor",strokeMiterlimit:10,strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M7.013 12.729C6.875 12.729 6.763 12.841 6.764 12.979C6.764 13.117 6.876 13.229 7.014 13.229C7.152 13.229 7.264 13.117 7.264 12.979C7.264 12.841 7.152 12.729 7.013 12.729Z",stroke:"currentColor",strokeMiterlimit:10,strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M12.013 12.729C11.875 12.729 11.763 12.841 11.764 12.979C11.764 13.117 11.876 13.229 12.014 13.229C12.152 13.229 12.264 13.117 12.264 12.979C12.264 12.841 12.152 12.729 12.013 12.729Z",stroke:"currentColor",strokeMiterlimit:10,strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M17.013 12.729C16.875 12.729 16.763 12.841 16.764 12.979C16.764 13.117 16.876 13.229 17.014 13.229C17.152 13.229 17.264 13.117 17.264 12.979C17.264 12.841 17.152 12.729 17.013 12.729Z",stroke:"currentColor",strokeMiterlimit:10,strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M7.013 16.729C6.875 16.729 6.763 16.841 6.764 16.979C6.764 17.117 6.876 17.229 7.014 17.229C7.152 17.229 7.264 17.117 7.264 16.979C7.264 16.841 7.152 16.729 7.013 16.729Z",stroke:"currentColor",strokeMiterlimit:10,strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M12.013 16.729C11.875 16.729 11.763 16.841 11.764 16.979C11.764 17.117 11.876 17.229 12.014 17.229C12.152 17.229 12.264 17.117 12.264 16.979C12.264 16.841 12.152 16.729 12.013 16.729Z",stroke:"currentColor",strokeMiterlimit:10,strokeLinecap:"round",strokeLinejoin:"round"}))),ide||(ide=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_448_11280"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},cde=(0,i.forwardRef)(lde);o.p;var ude,dde,pde=["title","titleId"];function fde(){return fde=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},fde.apply(null,arguments)}var hde=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,pde);return i.createElement("svg",fde({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,ude||(ude=i.createElement("g",{clipPath:"url(#clip0_1395_37151)"},i.createElement("path",{d:"M14.722 20.676C14.5345 20.8636 14.2802 20.969 14.015 20.969H12V18.954C12.0001 18.6888 12.1055 18.4345 12.293 18.247L19.062 11.473C19.2218 11.3132 19.4115 11.1864 19.6204 11.0999C19.8292 11.0134 20.053 10.9689 20.279 10.9689C20.505 10.9689 20.7288 11.0134 20.9376 11.0999C21.1465 11.1864 21.3362 11.3132 21.496 11.473C21.6559 11.6328 21.7828 11.8225 21.8694 12.0313C21.956 12.2401 22.0006 12.464 22.0006 12.69C22.0006 12.9161 21.956 13.1399 21.8694 13.3487C21.7828 13.5576 21.6559 13.7473 21.496 13.907L14.722 20.676Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M16.564 13.978L18.994 16.408",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M20.7181 14.684L21.6181 15.584C21.8456 15.812 21.9734 16.1209 21.9734 16.443C21.9734 16.7651 21.8456 17.074 21.6181 17.302L19.9771 18.943",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M7 8.96899H13",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M7 12.969H11",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M9 20.969H6C5.20435 20.969 4.44129 20.6529 3.87868 20.0903C3.31607 19.5277 3 18.7646 3 17.969V5.96899C3 5.17334 3.31607 4.41028 3.87868 3.84767C4.44129 3.28506 5.20435 2.96899 6 2.96899H18C18.7956 2.96899 19.5587 3.28506 20.1213 3.84767C20.6839 4.41028 21 5.17334 21 5.96899V7.96899",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),dde||(dde=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1395_37151"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},mde=(0,i.forwardRef)(hde);o.p;var gde,vde,yde=["title","titleId"];function bde(){return bde=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},bde.apply(null,arguments)}var _de=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,yde);return i.createElement("svg",bde({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,gde||(gde=i.createElement("g",{clipPath:"url(#clip0_1395_83153)"},i.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M21 18V9C21 7.895 20.105 7 19 7H17L15.487 4.484C15.306 4.184 14.981 4 14.63 4H9.326C8.97 4 8.641 4.189 8.462 4.496L7 7H5C3.895 7 3 7.895 3 9V18C3 19.105 3.895 20 5 20H19C20.105 20 21 19.105 21 18ZM14.8785 15.8062C16.4355 14.2492 16.4355 11.7248 14.8785 10.1678C13.3215 8.61074 10.7971 8.61074 9.24003 10.1678C7.68301 11.7248 7.68301 14.2492 9.24003 15.8062C10.7971 17.3633 13.3215 17.3633 14.8785 15.8062Z",fill:"currentColor"}))),vde||(vde=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1395_83153"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},Ade=(0,i.forwardRef)(_de);o.p;var Ede,wde,xde=["title","titleId"];function kde(){return kde=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},kde.apply(null,arguments)}var Cde=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,xde);return i.createElement("svg",kde({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Ede||(Ede=i.createElement("g",{clipPath:"url(#clip0_1395_37161)"},i.createElement("path",{d:"M12 8.5H8",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M16 12H8",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M8 15.5H12",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M15 15.5H16",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M20 4.49751V19.5025C20 19.6879 19.9485 19.8696 19.8512 20.0274C19.7539 20.1852 19.6146 20.3128 19.449 20.396L18.459 20.8935C18.3206 20.9631 18.168 20.9995 18.0132 21C17.8584 21.0005 17.7055 20.9651 17.5667 20.8964L15.9942 20.1188L14.4533 20.8929C14.3146 20.9626 14.1615 20.999 14.0063 20.9993C13.851 20.9996 13.6978 20.9637 13.5588 20.8945L12 20.1185L10.4412 20.8945C10.3022 20.9637 10.149 20.9996 9.99377 20.9993C9.8385 20.999 9.68543 20.9626 9.54668 20.8929L8.00578 20.1188L6.4333 20.8964C6.2945 20.965 6.14166 21.0005 5.98682 21C5.83198 20.9995 5.67937 20.963 5.54102 20.8935L4.55102 20.396C4.38538 20.3128 4.24614 20.1851 4.14884 20.0274C4.05153 19.8696 4 19.6879 4 19.5025V4.49753C4 4.31216 4.05153 4.13044 4.14883 3.97266C4.24613 3.81487 4.38537 3.68724 4.551 3.60401L5.541 3.10649C5.67936 3.03696 5.83197 3.00051 5.98681 3.00001C6.14165 2.99951 6.2945 3.03497 6.4333 3.10361L8.00577 3.8812L9.54668 3.10712C9.68543 3.03742 9.8385 3.00099 9.99376 3.00071C10.149 3.00043 10.3022 3.03631 10.4412 3.10551L12 3.88151L13.5588 3.10551C13.6978 3.03631 13.851 3.00044 14.0062 3.00072C14.1615 3.001 14.3146 3.03743 14.4533 3.10713L15.9942 3.8812L17.5667 3.10361C17.7055 3.03497 17.8583 2.99951 18.0132 3.00001C18.168 3.0005 18.3206 3.03695 18.459 3.10648L19.449 3.604C19.6146 3.68723 19.7539 3.81486 19.8512 3.97264C19.9485 4.13042 20 4.31214 20 4.49751Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),wde||(wde=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1395_37161"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},Sde=(0,i.forwardRef)(Cde);o.p;var Mde,Tde,Ode=["title","titleId"];function Dde(){return Dde=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Dde.apply(null,arguments)}var Lde=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Ode);return i.createElement("svg",Dde({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Mde||(Mde=i.createElement("g",{clipPath:"url(#clip0_1395_37611)"},i.createElement("path",{d:"M8 4L9.3 2.375C9.49 2.138 9.777 2 10.081 2H13.92C14.224 2 14.511 2.138 14.701 2.375L16 4V5C16 5.552 15.552 6 15 6H9C8.448 6 8 5.552 8 5V4Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M9.667 9.33301L8 11L7 10",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M13 18H16",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M13 10H16",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M9.667 13.333L8 15L7 14",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M13 14H16",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M16 4H18C19.105 4 20 4.895 20 6V20C20 21.105 19.105 22 18 22H6C4.895 22 4 21.105 4 20V6C4 4.895 4.895 4 6 4H8",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),Tde||(Tde=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1395_37611"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},Pde=(0,i.forwardRef)(Lde);o.p;var Ide,Bde,Rde=["title","titleId"];function Nde(){return Nde=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Nde.apply(null,arguments)}var Fde=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Rde);return i.createElement("svg",Nde({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Ide||(Ide=i.createElement("g",{clipPath:"url(#clip0_1395_37624)"},i.createElement("path",{d:"M14.98 16L20.414 10.566C21.195 9.78497 21.195 8.51897 20.414 7.73797L17.263 4.58697C16.482 3.80597 15.216 3.80597 14.435 4.58697L8.294 10.728C7.513 11.509 7.513 12.775 8.294 13.556L10.738 16",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M20 20H4C3.448 20 3 19.552 3 19V17C3 16.448 3.448 16 4 16H20C20.552 16 21 16.448 21 17V19C21 19.552 20.552 20 20 20Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M3 4H8",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M3 7H6",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M3 10H4",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M9.12 14.38L18.09 5.41003",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),Bde||(Bde=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1395_37624"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},jde=(0,i.forwardRef)(Fde);o.p;var Yde,$de,Hde=["title","titleId"];function Ude(){return Ude=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Ude.apply(null,arguments)}var zde=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Hde);return i.createElement("svg",Ude({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Yde||(Yde=i.createElement("g",{clipPath:"url(#clip0_1253_7335)"},i.createElement("path",{d:"M16 18C16.8284 18 17.5 17.3284 17.5 16.5C17.5 15.6716 16.8284 15 16 15C15.1716 15 14.5 15.6716 14.5 16.5C14.5 17.3284 15.1716 18 16 18Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M7 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4.49752C2 4.31215 2.05153 4.13043 2.14883 3.97264C2.24613 3.81486 2.38537 3.68723 2.551 3.604L3.541 3.10648C3.67935 3.03695 3.83196 3.0005 3.9868 3.00001C4.14164 2.99951 4.29448 3.03497 4.43328 3.10361L6.00576 3.8812L7.54666 3.10713C7.68541 3.03743 7.83848 3.00099 7.99375 3.00071C8.14902 3.00043 8.30222 3.03631 8.44122 3.10551L10 3.88151L11.5588 3.10551C11.6978 3.03631 11.851 3.00043 12.0062 3.00071C12.1615 3.00099 12.3146 3.03743 12.4533 3.10713L13.9942 3.8812L15.5667 3.10361C15.7055 3.03497 15.8583 2.99951 16.0132 3.00001C16.168 3.0005 16.3206 3.03695 16.459 3.10648L17.449 3.604C17.6146 3.68723 17.7539 3.81486 17.8512 3.97264C17.9485 4.13042 18 4.31214 18 4.49752L18 9",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M6 8.99994H14.004",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M7 14.9999H6",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M6.00403 11.9999H7.00003",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M12 21H20C21.1046 21 22 20.1046 22 19V14C22 12.8954 21.1046 12 20 12L12 12C10.8954 12 10 12.8954 10 14V19C10 20.1046 10.8954 21 12 21Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),$de||($de=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1253_7335"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},Wde=(0,i.forwardRef)(zde);o.p;var Vde,Gde,Qde,qde,Kde,Zde,Jde,Xde,epe,tpe,npe,rpe,ope=["title","titleId"];function ipe(){return ipe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},ipe.apply(null,arguments)}var ape=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,ope);return i.createElement("svg",ipe({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Vde||(Vde=i.createElement("path",{d:"M3 19C3 20.1046 3.89543 21 5 21",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})),Gde||(Gde=i.createElement("path",{d:"M3 5V19",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})),Qde||(Qde=i.createElement("path",{d:"M9 21H5",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})),qde||(qde=i.createElement("path",{d:"M21 5C21 3.89543 20.1046 3 19 3",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})),Kde||(Kde=i.createElement("path",{d:"M21 8V5",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})),Zde||(Zde=i.createElement("path",{d:"M5 3H19",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})),Jde||(Jde=i.createElement("path",{d:"M3 5C3 3.89543 3.89543 3 5 3",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})),Xde||(Xde=i.createElement("path",{d:"M8.5 17.0615C7.67157 17.0615 7 16.39 7 15.5615C7 14.7331 7.67157 14.0615 8.5 14.0615C9.32843 14.0615 10 14.7331 10 15.5615C10 16.39 9.32843 17.0615 8.5 17.0615Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})),epe||(epe=i.createElement("path",{d:"M7 7.06152H15",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})),tpe||(tpe=i.createElement("path",{d:"M7 10.5615H12",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})),npe||(npe=i.createElement("path",{d:"M13.5 20.5V20.094C13.5033 18.9389 14.4389 18.0033 15.594 18H18.906C20.0611 18.0033 20.9967 18.9389 21 20.094V20.5C21 20.7761 20.7761 21 20.5 21H14C13.7239 21 13.5 20.7761 13.5 20.5Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})),rpe||(rpe=i.createElement("path",{d:"M15.25 13.492C15.2544 12.3874 16.1534 11.4956 17.258 11.5C18.3625 11.5044 19.2544 12.4034 19.25 13.508C19.2456 14.6094 18.3515 15.5 17.25 15.5C16.1454 15.5 15.25 14.6046 15.25 13.5C15.25 13.4974 15.25 13.4947 15.25 13.492Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})))},spe=(0,i.forwardRef)(ape);o.p;var lpe,cpe,upe=["title","titleId"];function dpe(){return dpe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},dpe.apply(null,arguments)}var ppe=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,upe);return i.createElement("svg",dpe({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,lpe||(lpe=i.createElement("g",{clipPath:"url(#clip0_1395_83655)"},i.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M8 21H16C17.3261 21 18.5979 20.4732 19.5355 19.5355C20.4732 18.5979 21 17.3261 21 16V8C21 6.67392 20.4732 5.40215 19.5355 4.46447C18.5979 3.52678 17.3261 3 16 3H8C6.67392 3 5.40215 3.52678 4.46447 4.46447C3.52678 5.40215 3 6.67392 3 8V16C3 17.3261 3.52678 18.5979 4.46447 19.5355C5.40215 20.4732 6.67392 21 8 21ZM9.222 6.25C8.43378 6.25 7.67784 6.56312 7.12048 7.12048C6.56312 7.67784 6.25 8.43378 6.25 9.222V10.333C6.25 10.7472 6.58579 11.083 7 11.083C7.41421 11.083 7.75 10.7472 7.75 10.333V9.222C7.75 8.8316 7.90509 8.45719 8.18114 8.18114C8.45719 7.90509 8.8316 7.75 9.222 7.75H10C10.4142 7.75 10.75 7.41421 10.75 7C10.75 6.58579 10.4142 6.25 10 6.25H9.222ZM14 6.25C13.5858 6.25 13.25 6.58579 13.25 7C13.25 7.41421 13.5858 7.75 14 7.75H14.778C15.1684 7.75 15.5428 7.90509 15.8189 8.18114C16.0949 8.45719 16.25 8.8316 16.25 9.222V10.333C16.25 10.7472 16.5858 11.083 17 11.083C17.4142 11.083 17.75 10.7472 17.75 10.333V9.222C17.75 8.43378 17.4369 7.67784 16.8795 7.12048C16.3222 6.56312 15.5662 6.25 14.778 6.25H14ZM7.75 14C7.75 13.5858 7.41421 13.25 7 13.25C6.58579 13.25 6.25 13.5858 6.25 14V14.778C6.25 15.5662 6.56312 16.3222 7.12048 16.8795C7.67784 17.4369 8.43378 17.75 9.222 17.75H10C10.4142 17.75 10.75 17.4142 10.75 17C10.75 16.5858 10.4142 16.25 10 16.25H9.222C8.8316 16.25 8.45719 16.0949 8.18114 15.8189C7.90509 15.5428 7.75 15.1684 7.75 14.778V14ZM17.75 14C17.75 13.5858 17.4142 13.25 17 13.25C16.5858 13.25 16.25 13.5858 16.25 14V14.778C16.25 15.1684 16.0949 15.5428 15.8189 15.8189C15.5428 16.0949 15.1684 16.25 14.778 16.25H14C13.5858 16.25 13.25 16.5858 13.25 17C13.25 17.4142 13.5858 17.75 14 17.75H14.778C15.5662 17.75 16.3222 17.4369 16.8795 16.8795C17.4369 16.3222 17.75 15.5662 17.75 14.778V14Z",fill:"currentColor"}))),cpe||(cpe=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1395_83655"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},fpe=(0,i.forwardRef)(ppe);o.p;var hpe={color:"white",fill:"none",stroke:"white"},mpe={color:"white",stroke:"white"},gpe={color:"white !important","& svg":{color:"white !important",fill:"none !important",stroke:"white !important"},"& svg path[stroke], & svg line, & svg circle, & svg polyline":{fill:"none !important",stroke:"white !important"},'& svg path[fill], & svg path[fill="currentColor"]':{fill:"white !important"}};function vpe(e){var t=function(t){var r=t.size,o=void 0===r?16:r;return i.createElement(e,n({width:o,height:o},mpe))};return t.displayName="NotificationNavIcon",t}function ype(e){var t=function(t){var r=t.size,o=void 0===r?16:r;return i.createElement(e,n({size:o},hpe))};return t.displayName="NotificationFeatherIcon",t}var bpe=ype(Ree),_pe=ype(xte),Ape=ype(Mte),Epe=ype(tde),wpe=vpe(Ade),xpe=vpe(mde),kpe=vpe(Sde),Cpe=vpe(Pde),Spe=vpe(cde),Mpe=vpe(spe),Tpe=vpe(jde),Ope=vpe(Wde),Dpe=vpe(fpe);function Lpe(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:16,r=function(e,t){if(e===nde.EVENT)switch(t){case rde.EVENT.DOWNLOAD_EMAIL_UNSENT:case rde.EVENT.PHOTO_DOWNLOADED:return bpe;case rde.EVENT.FAVORITES_FINALIZED:case rde.EVENT.PHOTO_FAVORITED:return _pe;case rde.EVENT.PHOTO_HIDDEN:return Ape;case rde.EVENT.PHOTO_TAGGED:return Epe;default:return wpe}switch(e){case nde.CONTRACT:return xpe;case nde.ORDER:return Cpe;case nde.INVOICE:return kpe;case nde.BOOKING:return Spe;case nde.QUESTIONNAIRE:return Mpe;case nde.STUDIO:return t===rde.STUDIO.MONEY_BALANCE_INCREASED||t===rde.STUDIO.PROFIT_RELEASED?Tpe:t===rde.STUDIO.PHOTO_PLAN_NEXT_BILL_DATE_RELEASED?Ope:Dpe;default:return Dpe}}(e,t);return i.createElement(r,{size:n})}var Ppe=function(){var e=Co("studio.nav.notifications");return i.createElement(qr,{as:"p","data-testid":"notification-tile-empty",sx:Que},e("emptyState"))};const Ipe=function(e){var t=e.brandId,n=e.navigate,r=e.notification,o=e.onDismissed,a=r.created,s=r.descriptor,l=r.id,c=r.links,u=r.message,d=r.notificationGroup,p=r.notificationType,f=zo("brand/"+t+"/notification/"+l,{data:{dismissed:!0,type:r.type},defer:!0,method:"patch"}).performFetch,h=c["studio-panel"].href,m=Co("studio.nav.notifications"),g=function(e,t){if(e===nde.EVENT)switch(t){case rde.EVENT.DOWNLOAD_EMAIL_UNSENT:case rde.EVENT.PHOTO_DOWNLOADED:return"accent.spblue";case rde.EVENT.FAVORITES_FINALIZED:case rde.EVENT.PHOTO_FAVORITED:return"secondary.400";case rde.EVENT.PHOTO_HIDDEN:return"neutral.600";case rde.EVENT.PHOTO_TAGGED:return"accent.fern";default:return"accent.spblue"}switch(e){case nde.CONTRACT:return"secondary.500";case nde.ORDER:return"primary.500";case nde.INVOICE:return"accent.warmhoney";case nde.BOOKING:return"accent.fern";case nde.QUESTIONNAIRE:return"accent.clayrust";case nde.STUDIO:return t===rde.GRANTED_ARCHIVING_SPACE?"accent.spblue":"accent.indigoslate";default:return"primary.500"}}(d,p),v=m(function(e){var t=e.notificationGroup,n=e.notificationType;if(t===nde.EVENT)switch(n){case rde.EVENT.DOWNLOAD_EMAIL_UNSENT:case rde.EVENT.PHOTO_DOWNLOADED:return"eventTypes.download";case rde.EVENT.FAVORITES_FINALIZED:case rde.EVENT.PHOTO_FAVORITED:return"eventTypes.favorite";case rde.EVENT.PHOTO_HIDDEN:return"eventTypes.hidden";case rde.EVENT.PHOTO_TAGGED:return"eventTypes.tagged"}return"groupTypes."+t}({notificationGroup:d,notificationType:p})),y=QU()().isSame(a,"day")?QU()(a).format("h:mm A"):QU()(a).format("MMM D, YYYY");return i.createElement(wr,{align:"center",className:"notification-flyout-tile",gap:1,maxW:"100%",minW:0,overflow:"hidden",role:"group",sx:Gue,w:"100%"},i.createElement(Kr,{alignItems:"center","data-testid":"notification-tile-container",display:"flex",flex:1,gap:2,href:h,maxW:"100%",minW:0,overflow:"hidden",onClick:function(e){return n(h)&&e.preventDefault()}},i.createElement(_r,{"aria-hidden":!0,"data-testid":"notification-tile-type",flexShrink:0,sx:gpe},i.createElement(Zue,{bgColor:g},Lpe(d,p))),i.createElement(_r,{flex:1,minW:0,overflow:"hidden"},i.createElement(wr,{align:"baseline",flexWrap:"wrap",gap:1,minW:0,rowGap:0},i.createElement(qr,{as:"span",color:"neutral.700","data-testid":"notification-tile-descriptor",flex:"1 1 auto",fontSize:"sm",fontWeight:"medium",minW:0,noOfLines:1},s||v),i.createElement(qr,{as:"span",color:"neutral.600","data-testid":"notification-tile-created",flexShrink:0,fontSize:"xs",whiteSpace:"nowrap"},y)),i.createElement(qr,{color:"neutral.600","data-testid":"notification-tile-message",fontSize:"xs",minW:0,noOfLines:1},u))),i.createElement(Gr,{_focus:{boxShadow:"none"},_focusVisible:{boxShadow:"outline"},"aria-label":"Dismiss notification",color:"neutral.500","data-testid":"notification-tile-dismiss-button",flexShrink:0,icon:i.createElement(ro,{size:14,strokeWidth:2}),size:"sm",variant:"ghost",onClick:function(){var e=Lo(Io().mark((function e(t){return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return t.preventDefault(),t.stopPropagation(),e.next=4,f();case 4:o();case 5:case"end":return e.stop()}}),e)})));return function(t){return e.apply(this,arguments)}}()}))};var Bpe,Rpe,Npe=["title","titleId"];function Fpe(){return Fpe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Fpe.apply(null,arguments)}var jpe=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Npe);return i.createElement("svg",Fpe({width:18,height:20,viewBox:"0 0 18 20",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Bpe||(Bpe=i.createElement("path",{d:"M11 18C10.7671 18.3105 10.4652 18.5625 10.118 18.7361C9.7709 18.9096 9.38811 19 9 19C8.61189 19 8.2291 18.9096 7.88197 18.7361C7.53483 18.5625 7.23287 18.3105 7 18",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})),Rpe||(Rpe=i.createElement("path",{d:"M3 10.4817V7C3 5.4087 3.63214 3.88258 4.75736 2.75736C5.88258 1.63214 7.4087 1 9 1C10.5913 1 12.1174 1.63214 13.2426 2.75736C14.3679 3.88258 15 5.4087 15 7V10.4817H14.9955L16.3715 11.8588C16.6697 12.1572 16.8727 12.5374 16.9549 12.9512C17.037 13.365 16.9947 13.7939 16.8331 14.1836C16.6715 14.5734 16.398 14.9064 16.0472 15.1407C15.6963 15.3751 15.2839 15.5001 14.862 15.5H3.138C2.7161 15.5001 2.30366 15.3751 1.95281 15.1407C1.60196 14.9064 1.32846 14.5734 1.1669 14.1836C1.00533 13.7939 0.962956 13.365 1.04513 12.9512C1.12729 12.5374 1.33032 12.1572 1.62853 11.8588L3.00453 10.4817",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})))},Ype=(0,i.forwardRef)(jpe);o.p;var $pe,Hpe,Upe=["title","titleId"];function zpe(){return zpe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},zpe.apply(null,arguments)}var Wpe=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Upe);return i.createElement("svg",zpe({viewBox:"0 0 40 39",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,i.createElement("mask",{id:"mask0_1554_41416",style:{maskType:"alpha"},maskUnits:"userSpaceOnUse",x:0,y:0,width:40,height:39},$pe||($pe=i.createElement("rect",{y:.53125,width:40,height:38.4375,rx:4,fill:"currentColor"}))),Hpe||(Hpe=i.createElement("g",{mask:"url(#mask0_1554_41416)"},i.createElement("path",{d:"M27.88 25.9C26.947 24.163 26.4592 22.2217 26.46 20.25V18.62C26.4706 17.7611 26.3119 16.9086 25.9929 16.1111C25.674 15.3136 25.2011 14.5867 24.6012 13.9719C24.0013 13.3572 23.2862 12.8667 22.4967 12.5283C21.7073 12.19 20.8589 12.0104 20 12C18.2645 12.0211 16.6084 12.7301 15.3953 13.9713C14.1822 15.2126 13.5113 16.8845 13.53 18.62V20.25C13.5343 22.2209 13.0499 24.1622 12.12 25.9L11 28H29L27.88 25.9Z",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M17 30C17.3493 30.4657 17.8022 30.8437 18.3229 31.1041C18.8437 31.3645 19.4178 31.5 20 31.5C20.5822 31.5 21.1563 31.3645 21.6771 31.1041C22.1978 30.8437 22.6507 30.4657 23 30",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"}))))},Vpe=(0,i.forwardRef)(Wpe);o.p;var Gpe,Qpe=fr(wr)((function(e){var t=e.theme;return"\n        color: "+t.colors.gray[700]+";\n        position: relative;\n\n        "+t.responsive.smallScreenOnly(Gpe||(Gpe=zM(["\n            color: var(--theme-colors-white);\n        "])))+"\n    "}));const qpe=function(e){var t=e.count,n=void 0===t?void 0:t,r=u9({base:"white",md:"gray.700"}),o=u9({base:!0,md:!1}),a=u9({base:{top:"-6px",left:"16px"},md:{top:"7px",left:"27px"}});return i.createElement(Qpe,null,n?i.createElement(_r,{"data-testid":"notification-counter-label",background:"#10B9D0",height:"8px",width:"8px",position:"absolute",top:null==a?void 0:a.top,left:null==a?void 0:a.left,borderRadius:"50%"}):i.createElement(i.Fragment,null),o?i.createElement(Ype,{"data-testid":"notification-counter-icon",height:"20px",width:"20px",color:r}):i.createElement(Vpe,{"data-testid":"notification-counter-icon",height:"40px",width:"40px"}))};var Kpe=Mce.Notifications;const Zpe=function(e){var t=e.children,n=e.count,r=e.exclusiveOpenMenuId,o=e.setExclusiveOpenMenuId,a=(0,i.useRef)(),s=u9({base:!0,md:!1},{fallback:"md"}),l=Yce(!1),c=l.setFalse,u=l.value,d=l.setTrue;(0,i.useEffect)((function(){r!==Kpe&&(clearTimeout(a.current),c())}),[c,r]);var p=(0,i.useCallback)((function(){clearTimeout(a.current),o(Kpe),d()}),[d,o]),f=(0,i.useCallback)((function(){o(null),c()}),[c,o]),h=(0,i.useCallback)((function(){a.current=setTimeout(f,1e3)}),[f]);return i.createElement(vae,{autoSelect:!1,closeOnBlur:!1,"data-testid":"nav-menu",isOpen:u,gutter:s?0:4.5,offset:s?[0,0]:[12,4.5],placement:"bottom-start"},(function(){return i.createElement(_r,{height:"40.5px",overflow:"visible"},i.createElement(bae,{as:Mue,"data-testid":"nav-menu-button-notifications",isActive:u,isIcon:!0,isRightAligned:!0,onClick:u?f:p,onMouseEnter:s?void 0:p,onMouseLeave:s?void 0:h},i.createElement(Sue,null,i.createElement(qpe,{count:n}))),u&&!s&&i.createElement(Tue,{isIcon:!0,isRightAligned:!0}),i.createElement(sm,null,s&&u?i.createElement(_r,{"data-testid":"notification-flyout-menu-list",role:"menu",sx:Hue,zIndex:1500},t):i.createElement(Cae,{"data-testid":"notification-flyout-menu-list",sx:$ue,zIndex:1500,onMouseEnter:p,onMouseLeave:h},t)))}))};var Jpe,Xpe,efe,tfe,nfe,rfe,ofe,ife,afe,sfe,lfe,cfe=fr(_r,{shouldForwardProp:function(e){return"isImposter"!==e}})((function(e){var t=e.isImposter,n=e.theme;return"\n        padding: 9px 7px 0 7px;\n\n        .chakra-menu__menu-button & svg {\n            "+(t?"stroke: "+n.colors.red[400]:"stroke: "+n.colors.gray[700])+";\n        }\n    "})),ufe=fr(wr)((function(e){var t=e.theme;return"\n        align-items: center;\n        background: "+t.colors.white+";\n        border-bottom: 1px solid "+t.colors.gray[200]+";\n        grid-area: header;\n        height: 65px;\n        justify-content: flex-end;\n        padding: 12px 25px 12px 12px;\n        z-index: 2;\n\n        "+t.responsive.smallScreenOnly(Jpe||(Jpe=zM(["\n            justify-content: space-between;\n            align-items: center;\n            padding: 12px;\n            border-bottom: none;\n            background: var(--chakra-colors-navy-700);\n            height: 48px;\n        "])))+"\n\n        > div {\n            "+t.responsive.smallScreenOnly(Xpe||(Xpe=zM(["\n                margin: 0 12px 0 auto;\n            "])))+"\n\n            &:last-of-type {\n                "+t.responsive.smallScreenOnly(efe||(efe=zM(["\n                    display: none;\n                "])))+"\n            }\n        }\n\n        .chakra-menu__menu-button {\n            background: transparent;\n\n            "+t.responsive.smallScreenOnly(tfe||(tfe=zM(["\n                padding: 10px;\n            "])))+"\n\n            "+t.responsive.mediumScreenUp(nfe||(nfe=zM(["\n                padding: 0 0 4px 0;\n            "])))+"\n\n            &:hover {\n                background: transparent;\n            }\n\n            svg {\n                stroke: "+t.colors.gray[700]+";\n\n                "+t.responsive.smallScreenOnly(rfe||(rfe=zM(["\n                    stroke: var(--chakra-colors-white);\n                    color: var(--chakra-colors-white);\n                "])))+"\n            }\n        }\n    "})),dfe=fr(Zce)((function(e){var t=e.theme;return"\n        fill: "+t.colors.white+";\n\n        width: 100px;\n\n        "+t.responsive.mediumScreenUp(ofe||(ofe=zM(["\n            display: none;\n        "])))+"\n    "})),pfe=fr(Kr)((function(e){return"\n        "+e.theme.responsive.smallScreenOnly(ife||(ife=zM(["\n            color: white;\n            padding-top: 14px;\n        "])))+"\n\n        &, &:hover, &:visited {\n            svg {\n                fill: white;\n            }\n        }\n\n        &:focus {\n            box-shadow: none;\n        }\n    "})),ffe=fr(mue,{shouldForwardProp:function(e){return"isSidebarShown"!==e}})((function(e){var t=e.isSidebarShown,n=e.theme;return"\n        cursor: pointer;\n        height: 24px;\n        width: 24px;\n        stroke: "+n.colors.gray[700]+";\n\n        "+n.responsive.smallScreenOnly(afe||(afe=zM(["\n            stroke: var(--chakra-colors-white);\n            color: var(--chakra-colors-white);\n        "])))+"\n\n        "+n.responsive.mediumScreenUp(sfe||(sfe=zM(["\n            display: none;\n        "])))+"\n\n        path {\n            color: currentColor;\n            transition: opacity 0.125s ease-in-out, transform 0.25s ease-in-out;\n\n            &:nth-of-type(1) {\n                "+(t?"transform: translate(6.5px, 0.5px) rotate(45deg);":"")+"\n            }\n\n            &:nth-of-type(2) {\n                "+(t?"opacity: 0;":"")+"\n            }\n\n            &:nth-of-type(3) {\n                "+(t?"transform: translate(-10px, 8px) rotate(-45deg);":"")+"\n            }\n        }\n"})),hfe=fr(wr)((function(e){return"\n        align-items: center;\n\n        button {\n            margin-right: 0;\n        }\n\n        "+e.theme.responsive.smallScreenOnly(lfe||(lfe=zM(["\n            margin-left: auto;\n\n            ~ div {\n                margin-left: 0;\n            }\n\n            > span {\n                display: none;\n            }\n        "])))+"\n    "}));const mfe=function(e){var t=e.activeRouteGroup,r=e.accountMenu,o=e.brandMenu,a=e.currentBrandId,s=e.imposter,l=e.isImposter,c=e.isSidebarShownSmallScreen,u=e.navigate,d=e.notifications,p=e.onNotificationDismissed,f=e.toggleShowMenuSmallScreen,h=e.totalActiveNotifications,g=e.upgradeButton,v=hO().me,y=v||{},b=y.firstName,_=y.id,A=Co("studio.nav"),E=Boolean(v),w=m((0,i.useState)(null),2),x=w[0],k=w[1],C=s?{beforeName:"Logged in as "+b+" ("+_+")",href:s.unsetUrl,name:"Switch back to "+s.name,prependBrandPathToHref:!1}:{href:Sce.LogOut,name:A("link.logOut"),prependBrandPathToHref:!1};return i.createElement(ufe,{"data-testid":"nav-main-bar"},i.createElement(pfe,{"data-testid":"nav-main-logo-link",href:"/v2/"+a+Sce.Dashboard,onClick:function(e){u(Sce.Dashboard)&&!Tce(e)&&e.preventDefault()}},i.createElement(dfe,null)),g&&i.createElement(hfe,{"data-testid":"nav-upgrade"},g),E&&(null==v?void 0:v.poppyEnabled)&&i.createElement(Eue,null),o&&i.createElement(Fue,n({},o,{activeRouteGroup:t,currentBrandId:a,exclusiveOpenMenuId:x,icon:i.createElement(_r,{padding:"10px 8px 0 8px",stroke:"gray.700"},i.createElement(cue,{height:"21px",width:"22px"})),isRightAligned:!0,navigate:u,setExclusiveOpenMenuId:k})),i.createElement(Zpe,{count:h,exclusiveOpenMenuId:x,setExclusiveOpenMenuId:k},d&&d.length>0?i.createElement(que,{header:i.createElement(Kue,{href:"/v2/"+a+Sce.Notifications,navigate:u})},d.map((function(e,t){return i.createElement(Ipe,{brandId:a,key:t,navigate:u,notification:e,onDismissed:function(){p(e.id)}})}))):i.createElement(Ppe,null)),i.createElement(Nue,n({},r,{activeRouteGroup:t,currentBrandId:a,exclusiveOpenMenuId:x,icon:i.createElement(cfe,{isImposter:l},i.createElement(oue,{height:"26px",width:"26px",stroke:"gray.700"})),isImposter:l,isRightAligned:!0,setExclusiveOpenMenuId:k,menuItems:[].concat(r.menuItems||[],[C]),navigate:u})),i.createElement(ffe,{"data-testid":"show-sidebar-button",isSidebarShown:c,onClick:f}))};const gfe=function(e){var t=e.initialPhotoPlan,n=e.initialPromoCode,r=e.trialCheckoutModalIsOpen,o=e.onClosedModal,a=e.openSelectPlan,s=nY(H4),l=s.Modal,c=s.close,u=s.open,d=zo("plan/photo").response,p=Boolean(n),f=zo("promo/"+(n||"__no_promo__"),{defer:!p}).response,h=t||{},m=h.totalActivePhotosCount,g=h.uuid,v=g||"",y=null!=m?m:1500,b=(0,i.useMemo)((function(){var e;return null!==(e=null==d?void 0:d.items.filter((function(e){return e.photosAllowed&&e.photosAllowed>y||e.isUnlimited})))&&void 0!==e?e:[]}),[d,y]),_=gK(b,t),A=_.getPlanPricing,E=_.planPricingInfo,w=E&&!E.isPromoAlwaysInvalid,x=(0,i.useCallback)((function(){c(),o()}),[c,o]);(0,i.useEffect)((function(){A(v,n)}),[A,v,n]),(0,i.useEffect)((function(){r&&u()}),[u,r]);var k=(0,i.useMemo)((function(){var e;if(f){if(f.worksYearly&&!f.worksMonthly)return!1;if(f.worksMonthly&&!f.worksYearly)return!0;if(f.worksYearly&&f.worksMonthly)return!1}return null!==(e=null==t?void 0:t.isMonthly)&&void 0!==e&&e}),[f,t]);return i.createElement(i.Fragment,null,w&&i.createElement(wK,{planType:"photo"},i.createElement(l,{initialPromoCode:n,onClose:x,showPlanSelectOnRender:a,isMonthly:k})))};function vfe(e){return d(e)||MV(e)||f(e)||h()}var yfe,bfe=["title","titleId"];function _fe(){return _fe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},_fe.apply(null,arguments)}var Afe=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,bfe);return i.createElement("svg",_fe({viewBox:"0 0 40 40",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,yfe||(yfe=i.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M7 17.89V12.83C7 11.57 8.24 10 9.79 10H14.79L12.62 12.2H9.79C9.48 12.2 9.17 12.51 9.17 12.83V15.69L7 17.89ZM14.8 30H9.8C8.55 30 7 28.74 7 27.17V22.11L9.17 24.31V27.17C9.17 27.49 9.48 27.8 9.79 27.8H12.62L14.8 30ZM33 22.11V27.17C33 28.43 31.76 30 30.21 30H25.21L27.38 27.8H30.21C30.52 27.8 30.83 27.49 30.83 27.17V24.31L33 22.11ZM25.2 10H30.2C31.45 10 33 11.26 33 12.83V17.89L30.83 15.69V12.83C30.83 12.51 30.52 12.2 30.21 12.2H27.38L25.2 10Z"})))},Efe=(0,i.forwardRef)(Afe);o.p;var wfe,xfe=["title","titleId"];function kfe(){return kfe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},kfe.apply(null,arguments)}var Cfe=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,xfe);return i.createElement("svg",kfe({width:6,height:10,viewBox:"0 0 6 10",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,wfe||(wfe=i.createElement("path",{d:"M5 9L1 5L5 1",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})))},Sfe=(0,i.forwardRef)(Cfe);o.p;var Mfe,Tfe,Ofe=fr(_r)(Mfe||(Mfe=zM(["\n    height: 100%;\n    -webkit-overflow-scrolling: touch;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    overflow-x: hidden;\n    overflow-y: auto;\n    perspective: 1px;\n    perspective-origin: right top;\n    position: sticky;\n    scrollbar-width: none;\n    transform-style: preserve-3d;\n    width: 100%;\n\n    ::-webkit-scrollbar {\n        display: none;\n    }\n"]))),Dfe=fr(_r)(Tfe||(Tfe=zM(["\n    transform-style: preserve-3d;\n    position: absolute;\n    width: 100%;\n"]))),Lfe=fr(_r,{shouldForwardProp:function(e){return!["isDragging","isHoveredOver","show"].includes(e)}})((function(e){var t=e.isDragging,n=e.isHoveredOver,r=e.show;return"\n        background: "+e.theme.colors.gray[500]+";\n        border-radius: 4px;\n        opacity: "+(r?t||n?1:.8:0)+";\n        position: absolute;\n        right: -4px;\n        top: -4px;\n        transform-origin: right top;\n        transition: opacity, right, width 0.275s ease-in-out;\n        width: "+(t||n?6:4)+"px;\n    "}));const Pfe=function(e){var t=(0,i.useRef)(null),n=(0,i.useRef)(null),r=m((0,i.useState)(!1),2),o=r[0],a=r[1],s=m((0,i.useState)(!1),2),l=s[0],c=s[1],u=m((0,i.useState)(!1),2),d=u[0],p=u[1],f=(0,i.useCallback)((function(e){var t=e.pageX,n=e.pageY,r=v.current;if(r){var o=r.getBoundingClientRect(),i=o.height,a=o.left,s=o.top,l=o.width;return t>=a&&t<=a+l&&n>=s&&n<=s+i}return!1}),[]),h=(0,i.useCallback)((function(e){var n=e.pageY,r=t.current;if(r){var o=r.clientHeight,i=r.scrollHeight-o,a=n-r.getBoundingClientRect().top;r.scrollTop=a>i?i:a}}),[]),g=(0,i.useCallback)((function(){var e=v.current;e&&(e.style.height="0px",e.style.transform="");var n=t.current;if(n){var r=n.clientHeight,o=n.scrollHeight;if(o>r){var i=n.getBoundingClientRect().height,a=i*i/o,s=1/((i-a)/(o-i));e&&(e.style.height=a-8+"px",e.style.transform="\n                        matrix3d(\n                            1, 0, 0, 0,\n                            0, 1, 0, 0,\n                            0, 0, 1, 0,\n                            0, 0, 0, -1\n                        )\n                        scale("+s+")\n                        translateZ("+(1-s-2)+"px)\n                    ")}}}),[]),v=(0,i.useRef)(null);return(0,i.useEffect)((function(){var e,t=n.current,r=function(){a(!1),document.removeEventListener("mousemove",h)};return document.addEventListener("mouseup",r),window.addEventListener("resize",g),window.ResizeObserver&&t&&(e=new ResizeObserver(g)).observe(t),function(){document.removeEventListener("mouseup",r),window.removeEventListener("resize",g),e&&e.disconnect()}}),[h,g]),i.createElement(Ofe,{ref:t},i.createElement(Dfe,{onMouseDown:function(e){f(e)&&(document.addEventListener("mousemove",h),e.preventDefault(),a(!0))},onMouseEnter:function(){return c(!0)},onMouseLeave:function(){return c(!1)},onMouseMove:function(e){p(f(e))},ref:n},i.createElement(Lfe,{isDragging:o,isHoveredOver:d,ref:v,show:o||l}),i.createElement(_r,e)))};var Ife;fr("div")((function(e){var t=e.theme;return"\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background: "+t.colors.blue[100]+";\n        grid-area: banner;\n        padding: 12px;\n        width: 100%;\n        text-align: center;\n        height: 48px;\n\n        "+t.responsive.smallScreenOnly("\n                flex-direction: column;\n                height: 64px;\n            ")+"\n    "})),fr("span")(Ife||(Ife=zM(["\n    font-size: 16px;\n    margin-right: 10px;\n"]))),fr(Kr)((function(e){var t=e.theme;return"\n        color: "+t.colors.blue[400]+";\n        font-size: "+t.fontSizes.md+";\n        font-weight: "+t.fontWeights.medium+";\n        line-height: "+t.lineHeights.md+";\n        transition: all 0.2s ease;\n\n        &:hover {\n            color: "+t.colors.blue[300]+";\n            cursor: pointer;\n            text-decoration: none;\n        }\n\n        &[disabled] {\n            opacity: 0.5;\n            pointer-events: none;\n        }\n    "}));var Bfe,Rfe,Nfe=function(e){return"\n    svg {\n        fill: transparent;\n      \n        .active-cutout {\n            fill: "+e+";\n\n            &:not(.active-cutout-stroke):not(.active-fill-stroke) {\n                stroke-width: 0;\n            }\n        }\n\n        .active-cutout-stroke {\n            stroke: "+e+";\n        }\n\n        .active-fill {\n            fill: currentColor;\n        }\n\n        .active-fill-stroke {\n            stroke: currentColor;\n        }\n\n        .active-only-stroke {\n            fill: none;\n        }\n    }\n"},Ffe=NJ,jfe=fr(pZ,{shouldForwardProp:function(e){return!["expandedIndex","hoveredIndex","isSidebarCollapsed"].includes(e)}})((function(e){var t=e.expandedIndex,n=e.isSidebarCollapsed,r=void 0!==n&&n,o=e.theme,i="\n        background: "+(r?Ffe:"transparent")+";\n\n        .chakra-accordion__button {\n            .accordion-button {\n                "+Nfe(r?Ffe:"#153F5D")+"\n\n                &:hover {\n                    background: transparent;\n                    border: none;\n                }\n            }\n        }\n    ",a=null!=t&&t>=0?t+1:0;return"\n        .chakra-accordion__item {\n            border-color: transparent;\n            border-radius: 0;\n            margin-bottom: 16px;\n            margin-left: 0;\n            margin-right: 0;\n\n            .chakra-accordion__button {\n                background: transparent;\n                border: none;\n                color: "+o.colors.white+";\n                font-family: inherit;\n                padding: 0;\n                position: relative;\n\n                > div {\n                    "+o.responsive.mediumScreenUp("\n                        "+(r?"text-align: center;":"")+"\n                    ")+"\n                }\n\n                > svg {\n                    color: "+o.colors.white+";\n                    position: absolute;\n                    right: 12px;\n\n                    "+(r&&o.responsive.mediumScreenUp("\n                            right: 2px;\n                        "))+"\n                }\n\n                .accordion-button {\n                    align-items: center;\n                    border-radius: 0;\n                    font-size: 14px;\n                    line-height: 20px;\n                    text-transform: uppercase;\n                    font-weight: 500;\n                    letter-spacing: 1.4px;\n                    height: 40px;\n           \n                    padding: "+(r?"12px 10px":"6px 24px")+";\n\n                    "+o.responsive.mediumScreenUp("\n                        "+(r?"justify-content: space-around;":"")+"\n                    ")+"\n\n                    &:hover {\n                        background: "+Ffe+";\n                        border-color: "+Ffe+";\n\n                        "+o.responsive.smallScreenOnly(Bfe||(Bfe=zM(["\n                            background: transparent;\n                            border: none;\n                        "])))+"\n\n                        "+o.responsive.mediumScreenUp(Nfe(Ffe))+";\n\n                        svg {\n                            "+o.responsive.smallScreenOnly(Rfe||(Rfe=zM(["\n                                fill: transparent;\n                            "])))+"\n                        }\n                    }\n\n                    span {\n                        color: inherit;\n                        font-size: inherit;\n                        line-height: inherit;\n\n                        "+o.responsive.mediumScreenUp("\n                            "+(r?"display: none;":"")+"\n                        ")+"\n                    }\n\n                    svg {\n                        fill: transparent;\n                        height: 24px;\n                        width: 24px;\n                        margin-right: 16px;\n\n                        "+(r&&o.responsive.mediumScreenUp("\n                                margin-right: 0;\n                            "))+"\n                    }\n                }\n\n                &:hover {\n                    background: transparent;\n                    border: none;\n                }\n            }\n\n            &:nth-of-type("+a+") {\n                "+(r?"":"padding-bottom: 8px;")+"\n            }\n\n            &:nth-of-type("+a+") {\n                "+i+"\n            }\n        }\n\n        .chakra-accordion__item,\n        .chakra-accordion__panel {\n            display: flex;\n            flex-direction: column;\n        }\n\n        .chakra-accordion__panel {\n            a {\n                margin: 0;\n\n                button {\n                    font-size: 14px;\n                    letter-spacing: inherit;\n     \n                    padding: 6px 24px;\n                    text-align: left;\n                    width: 100%;\n\n                    "+(r?"\n                                padding: 6px 22px;\n                            ":"")+"\n                }\n            }\n        }\n    "})),Yfe=(fr(_r,{shouldForwardProp:function(e){return"isSidebarCollapsed"!==e}})((function(e){var t=e.isSidebarCollapsed;return e.theme.responsive.mediumScreenUp("\n        "+(t?"display: none;":"")+"\n    ")})),fr(jfe)((function(){return'\n        .chakra-accordion__item {\n            position: relative;\n\n            &:last-of-type:after {\n                content: "";\n                width: calc(100% - 48px);\n                margin: 16px auto;\n                border-bottom: 1px solid rgba(255, 255, 255, 0.33);\n            }   \n        }\n    '})));const $fe=jfe;var Hfe,Ufe,zfe=fr(Wr,{shouldForwardProp:function(e){return!["isActive","isSidebarCollapsed"].includes(e)}})((function(e){var t=e.isActive,n=void 0!==t&&t,r=e.isSidebarCollapsed,o=void 0!==r&&r,i=e.theme,a="\n        background: "+NJ+";\n        border-color: "+NJ+";\n    ";return"\n        background: transparent;\n        border-color: transparent;\n        border-radius: 0;\n        font-family: inherit;\n        font-size: 16px;\n        line-height: 20px;\n        "+(n?a:"")+"\n\n        "+i.responsive.smallScreenOnly(Hfe||(Hfe=zM(["\n            justify-content: flex-start;\n        "])))+"\n\n        span {\n            color: inherit;\n            font-size: inherit;\n            line-height: inherit;\n\n            "+i.responsive.mediumScreenUp("\n                "+(o?"display: none;":"")+"\n            ")+"\n        }\n\n        svg {\n            fill: transparent;\n            height: 24px;\n            width: 24px;\n\n            transition: none;\n\n            "+i.responsive.mediumScreenUp("\n                "+(o?"":"margin-right: 16px;")+"\n            ")+"\n\n            "+i.responsive.smallScreenOnly(Ufe||(Ufe=zM(["\n                margin-right: 16px;\n            "])))+"\n        }\n\n        "+(n?Nfe(NJ):"")+"\n\n        &.chakra-button {\n            "+(o?"padding: 6px 22px;":"padding: 6px 24px;")+"\n\n            &:hover {\n                "+a+"\n                "+Nfe(NJ)+"\n            }\n        }\n    "}));const Wfe=zfe;var Vfe,Gfe=fr(_r,{shouldForwardProp:function(e){return"isSidebarCollapsed"!==e}})((function(e){var t=e.isSidebarCollapsed,n=e.theme;return"\n        background: "+n.colors.navy[700]+";\n        border: 1px solid "+n.colors.navy[700]+";\n        border-radius: 0 4px 4px 0;\n        cursor: pointer;\n        filter:\n            drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.1))\n            drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.3));\n        height: 48px;\n        position: absolute;\n        right: -14px;\n        top: 20px;\n        width: 14px;\n        z-index: 2;\n\n        svg {\n            stroke: "+n.colors.white+";\n            color: "+n.colors.white+";\n            height: 46px;\n            margin-left: 2px;\n            transform: rotate("+(t?180:0)+"deg);\n            transition: transform 0.6125s;\n        }\n\n        "+n.responsive.smallScreenOnly(Vfe||(Vfe=zM(["\n            display: none;\n        "])))+"\n    "})),Qfe=fr(Zw)((function(e){return"\n        background: #002B4C;\n        border-radius: 2px;\n        color: "+e.theme.colors.white+";\n        font-size: 10px;\n        line-height: 14px;\n        padding: 2px 8px;\n    "}));const qfe=Gfe;var Kfe,Zfe,Jfe=["title","titleId"];function Xfe(){return Xfe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Xfe.apply(null,arguments)}var ehe=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Jfe);return i.createElement("svg",Xfe({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Kfe||(Kfe=i.createElement("path",{d:"M20 12H4",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"})),Zfe||(Zfe=i.createElement("path",{d:"M12 4L12 20",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round"})))},the=(0,i.forwardRef)(ehe);o.p;const nhe={lessThanXSeconds:{one:"less than a second",other:"less than {{count}} seconds"},xSeconds:{one:"1 second",other:"{{count}} seconds"},halfAMinute:"half a minute",lessThanXMinutes:{one:"less than a minute",other:"less than {{count}} minutes"},xMinutes:{one:"1 minute",other:"{{count}} minutes"},aboutXHours:{one:"about 1 hour",other:"about {{count}} hours"},xHours:{one:"1 hour",other:"{{count}} hours"},xDays:{one:"1 day",other:"{{count}} days"},aboutXWeeks:{one:"about 1 week",other:"about {{count}} weeks"},xWeeks:{one:"1 week",other:"{{count}} weeks"},aboutXMonths:{one:"about 1 month",other:"about {{count}} months"},xMonths:{one:"1 month",other:"{{count}} months"},aboutXYears:{one:"about 1 year",other:"about {{count}} years"},xYears:{one:"1 year",other:"{{count}} years"},overXYears:{one:"over 1 year",other:"over {{count}} years"},almostXYears:{one:"almost 1 year",other:"almost {{count}} years"}};function rhe(e){return(t={})=>{const n=t.width?String(t.width):e.defaultWidth;return e.formats[n]||e.formats[e.defaultWidth]}}const ohe={date:rhe({formats:{full:"EEEE, MMMM do, y",long:"MMMM do, y",medium:"MMM d, y",short:"MM/dd/yyyy"},defaultWidth:"full"}),time:rhe({formats:{full:"h:mm:ss a zzzz",long:"h:mm:ss a z",medium:"h:mm:ss a",short:"h:mm a"},defaultWidth:"full"}),dateTime:rhe({formats:{full:"{{date}} 'at' {{time}}",long:"{{date}} 'at' {{time}}",medium:"{{date}}, {{time}}",short:"{{date}}, {{time}}"},defaultWidth:"full"})},ihe={lastWeek:"'last' eeee 'at' p",yesterday:"'yesterday at' p",today:"'today at' p",tomorrow:"'tomorrow at' p",nextWeek:"eeee 'at' p",other:"P"};function ahe(e){return(t,n)=>{let r;if("formatting"===(n?.context?String(n.context):"standalone")&&e.formattingValues){const t=e.defaultFormattingWidth||e.defaultWidth,o=n?.width?String(n.width):t;r=e.formattingValues[o]||e.formattingValues[t]}else{const t=e.defaultWidth,o=n?.width?String(n.width):e.defaultWidth;r=e.values[o]||e.values[t]}return r[e.argumentCallback?e.argumentCallback(t):t]}}const she={ordinalNumber:(e,t)=>{const n=Number(e),r=n%100;if(r>20||r<10)switch(r%10){case 1:return n+"st";case 2:return n+"nd";case 3:return n+"rd"}return n+"th"},era:ahe({values:{narrow:["B","A"],abbreviated:["BC","AD"],wide:["Before Christ","Anno Domini"]},defaultWidth:"wide"}),quarter:ahe({values:{narrow:["1","2","3","4"],abbreviated:["Q1","Q2","Q3","Q4"],wide:["1st quarter","2nd quarter","3rd quarter","4th quarter"]},defaultWidth:"wide",argumentCallback:e=>e-1}),month:ahe({values:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],abbreviated:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],wide:["January","February","March","April","May","June","July","August","September","October","November","December"]},defaultWidth:"wide"}),day:ahe({values:{narrow:["S","M","T","W","T","F","S"],short:["Su","Mo","Tu","We","Th","Fr","Sa"],abbreviated:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],wide:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},defaultWidth:"wide"}),dayPeriod:ahe({values:{narrow:{am:"a",pm:"p",midnight:"mi",noon:"n",morning:"morning",afternoon:"afternoon",evening:"evening",night:"night"},abbreviated:{am:"AM",pm:"PM",midnight:"midnight",noon:"noon",morning:"morning",afternoon:"afternoon",evening:"evening",night:"night"},wide:{am:"a.m.",pm:"p.m.",midnight:"midnight",noon:"noon",morning:"morning",afternoon:"afternoon",evening:"evening",night:"night"}},defaultWidth:"wide",formattingValues:{narrow:{am:"a",pm:"p",midnight:"mi",noon:"n",morning:"in the morning",afternoon:"in the afternoon",evening:"in the evening",night:"at night"},abbreviated:{am:"AM",pm:"PM",midnight:"midnight",noon:"noon",morning:"in the morning",afternoon:"in the afternoon",evening:"in the evening",night:"at night"},wide:{am:"a.m.",pm:"p.m.",midnight:"midnight",noon:"noon",morning:"in the morning",afternoon:"in the afternoon",evening:"in the evening",night:"at night"}},defaultFormattingWidth:"wide"})};function lhe(e){return(t,n={})=>{const r=n.width,o=r&&e.matchPatterns[r]||e.matchPatterns[e.defaultMatchWidth],i=t.match(o);if(!i)return null;const a=i[0],s=r&&e.parsePatterns[r]||e.parsePatterns[e.defaultParseWidth],l=Array.isArray(s)?function(e,t){for(let n=0;n<e.length;n++)if(t(e[n]))return n;return}(s,(e=>e.test(a))):function(e,t){for(const n in e)if(Object.prototype.hasOwnProperty.call(e,n)&&t(e[n]))return n;return}(s,(e=>e.test(a)));let c;c=e.valueCallback?e.valueCallback(l):l,c=n.valueCallback?n.valueCallback(c):c;return{value:c,rest:t.slice(a.length)}}}const che={ordinalNumber:(uhe={matchPattern:/^(\d+)(th|st|nd|rd)?/i,parsePattern:/\d+/i,valueCallback:e=>parseInt(e,10)},(e,t={})=>{const n=e.match(uhe.matchPattern);if(!n)return null;const r=n[0],o=e.match(uhe.parsePattern);if(!o)return null;let i=uhe.valueCallback?uhe.valueCallback(o[0]):o[0];return i=t.valueCallback?t.valueCallback(i):i,{value:i,rest:e.slice(r.length)}}),era:lhe({matchPatterns:{narrow:/^(b|a)/i,abbreviated:/^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,wide:/^(before christ|before common era|anno domini|common era)/i},defaultMatchWidth:"wide",parsePatterns:{any:[/^b/i,/^(a|c)/i]},defaultParseWidth:"any"}),quarter:lhe({matchPatterns:{narrow:/^[1234]/i,abbreviated:/^q[1234]/i,wide:/^[1234](th|st|nd|rd)? quarter/i},defaultMatchWidth:"wide",parsePatterns:{any:[/1/i,/2/i,/3/i,/4/i]},defaultParseWidth:"any",valueCallback:e=>e+1}),month:lhe({matchPatterns:{narrow:/^[jfmasond]/i,abbreviated:/^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,wide:/^(january|february|march|april|may|june|july|august|september|october|november|december)/i},defaultMatchWidth:"wide",parsePatterns:{narrow:[/^j/i,/^f/i,/^m/i,/^a/i,/^m/i,/^j/i,/^j/i,/^a/i,/^s/i,/^o/i,/^n/i,/^d/i],any:[/^ja/i,/^f/i,/^mar/i,/^ap/i,/^may/i,/^jun/i,/^jul/i,/^au/i,/^s/i,/^o/i,/^n/i,/^d/i]},defaultParseWidth:"any"}),day:lhe({matchPatterns:{narrow:/^[smtwf]/i,short:/^(su|mo|tu|we|th|fr|sa)/i,abbreviated:/^(sun|mon|tue|wed|thu|fri|sat)/i,wide:/^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i},defaultMatchWidth:"wide",parsePatterns:{narrow:[/^s/i,/^m/i,/^t/i,/^w/i,/^t/i,/^f/i,/^s/i],any:[/^su/i,/^m/i,/^tu/i,/^w/i,/^th/i,/^f/i,/^sa/i]},defaultParseWidth:"any"}),dayPeriod:lhe({matchPatterns:{narrow:/^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,any:/^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i},defaultMatchWidth:"any",parsePatterns:{any:{am:/^a/i,pm:/^p/i,midnight:/^mi/i,noon:/^no/i,morning:/morning/i,afternoon:/afternoon/i,evening:/evening/i,night:/night/i}},defaultParseWidth:"any"})};var uhe;const dhe={code:"en-US",formatDistance:(e,t,n)=>{let r;const o=nhe[e];return r="string"==typeof o?o:1===t?o.one:o.other.replace("{{count}}",t.toString()),n?.addSuffix?n.comparison&&n.comparison>0?"in "+r:r+" ago":r},formatLong:ohe,formatRelative:(e,t,n,r)=>ihe[e],localize:she,match:che,options:{weekStartsOn:0,firstWeekContainsDate:1}};let phe={};function fhe(){return phe}Math.pow(10,8);const hhe=6048e5,mhe=864e5,ghe=6e4,vhe=36e5,yhe=Symbol.for("constructDateFrom");function bhe(e,t){return"function"==typeof e?e(t):e&&"object"==typeof e&&yhe in e?e[yhe](t):e instanceof Date?new e.constructor(t):new Date(t)}function _he(e,t){return bhe(t||e,e)}function Ahe(e){const t=_he(e),n=new Date(Date.UTC(t.getFullYear(),t.getMonth(),t.getDate(),t.getHours(),t.getMinutes(),t.getSeconds(),t.getMilliseconds()));return n.setUTCFullYear(t.getFullYear()),+e-+n}function Ehe(e,t){const n=_he(e,t?.in);return n.setHours(0,0,0,0),n}function whe(e,t,n){const[r,o]=function(e,...t){const n=bhe.bind(null,e||t.find((e=>"object"==typeof e)));return t.map(n)}(n?.in,e,t),i=Ehe(r),a=Ehe(o),s=+i-Ahe(i),l=+a-Ahe(a);return Math.round((s-l)/mhe)}function xhe(e,t){const n=_he(e,t?.in);return n.setFullYear(n.getFullYear(),0,1),n.setHours(0,0,0,0),n}function khe(e,t){const n=_he(e,t?.in);return whe(n,xhe(n))+1}function Che(e,t){const n=fhe(),r=t?.weekStartsOn??t?.locale?.options?.weekStartsOn??n.weekStartsOn??n.locale?.options?.weekStartsOn??0,o=_he(e,t?.in),i=o.getDay(),a=(i<r?7:0)+i-r;return o.setDate(o.getDate()-a),o.setHours(0,0,0,0),o}function She(e,t){return Che(e,{...t,weekStartsOn:1})}function Mhe(e,t){const n=_he(e,t?.in),r=n.getFullYear(),o=bhe(n,0);o.setFullYear(r+1,0,4),o.setHours(0,0,0,0);const i=She(o),a=bhe(n,0);a.setFullYear(r,0,4),a.setHours(0,0,0,0);const s=She(a);return n.getTime()>=i.getTime()?r+1:n.getTime()>=s.getTime()?r:r-1}function The(e,t){const n=Mhe(e,t),r=bhe(t?.in||e,0);return r.setFullYear(n,0,4),r.setHours(0,0,0,0),She(r)}function Ohe(e,t){const n=_he(e,t?.in),r=+She(n)-+The(n);return Math.round(r/hhe)+1}function Dhe(e,t){const n=_he(e,t?.in),r=n.getFullYear(),o=fhe(),i=t?.firstWeekContainsDate??t?.locale?.options?.firstWeekContainsDate??o.firstWeekContainsDate??o.locale?.options?.firstWeekContainsDate??1,a=bhe(t?.in||e,0);a.setFullYear(r+1,0,i),a.setHours(0,0,0,0);const s=Che(a,t),l=bhe(t?.in||e,0);l.setFullYear(r,0,i),l.setHours(0,0,0,0);const c=Che(l,t);return+n>=+s?r+1:+n>=+c?r:r-1}function Lhe(e,t){const n=fhe(),r=t?.firstWeekContainsDate??t?.locale?.options?.firstWeekContainsDate??n.firstWeekContainsDate??n.locale?.options?.firstWeekContainsDate??1,o=Dhe(e,t),i=bhe(t?.in||e,0);i.setFullYear(o,0,r),i.setHours(0,0,0,0);return Che(i,t)}function Phe(e,t){const n=_he(e,t?.in),r=+Che(n,t)-+Lhe(n,t);return Math.round(r/hhe)+1}function Ihe(e,t){return(e<0?"-":"")+Math.abs(e).toString().padStart(t,"0")}const Bhe={y(e,t){const n=e.getFullYear(),r=n>0?n:1-n;return Ihe("yy"===t?r%100:r,t.length)},M(e,t){const n=e.getMonth();return"M"===t?String(n+1):Ihe(n+1,2)},d:(e,t)=>Ihe(e.getDate(),t.length),a(e,t){const n=e.getHours()/12>=1?"pm":"am";switch(t){case"a":case"aa":return n.toUpperCase();case"aaa":return n;case"aaaaa":return n[0];default:return"am"===n?"a.m.":"p.m."}},h:(e,t)=>Ihe(e.getHours()%12||12,t.length),H:(e,t)=>Ihe(e.getHours(),t.length),m:(e,t)=>Ihe(e.getMinutes(),t.length),s:(e,t)=>Ihe(e.getSeconds(),t.length),S(e,t){const n=t.length,r=e.getMilliseconds();return Ihe(Math.trunc(r*Math.pow(10,n-3)),t.length)}},Rhe="midnight",Nhe="noon",Fhe="morning",jhe="afternoon",Yhe="evening",$he="night",Hhe={G:function(e,t,n){const r=e.getFullYear()>0?1:0;switch(t){case"G":case"GG":case"GGG":return n.era(r,{width:"abbreviated"});case"GGGGG":return n.era(r,{width:"narrow"});default:return n.era(r,{width:"wide"})}},y:function(e,t,n){if("yo"===t){const t=e.getFullYear(),r=t>0?t:1-t;return n.ordinalNumber(r,{unit:"year"})}return Bhe.y(e,t)},Y:function(e,t,n,r){const o=Dhe(e,r),i=o>0?o:1-o;if("YY"===t){return Ihe(i%100,2)}return"Yo"===t?n.ordinalNumber(i,{unit:"year"}):Ihe(i,t.length)},R:function(e,t){return Ihe(Mhe(e),t.length)},u:function(e,t){return Ihe(e.getFullYear(),t.length)},Q:function(e,t,n){const r=Math.ceil((e.getMonth()+1)/3);switch(t){case"Q":return String(r);case"QQ":return Ihe(r,2);case"Qo":return n.ordinalNumber(r,{unit:"quarter"});case"QQQ":return n.quarter(r,{width:"abbreviated",context:"formatting"});case"QQQQQ":return n.quarter(r,{width:"narrow",context:"formatting"});default:return n.quarter(r,{width:"wide",context:"formatting"})}},q:function(e,t,n){const r=Math.ceil((e.getMonth()+1)/3);switch(t){case"q":return String(r);case"qq":return Ihe(r,2);case"qo":return n.ordinalNumber(r,{unit:"quarter"});case"qqq":return n.quarter(r,{width:"abbreviated",context:"standalone"});case"qqqqq":return n.quarter(r,{width:"narrow",context:"standalone"});default:return n.quarter(r,{width:"wide",context:"standalone"})}},M:function(e,t,n){const r=e.getMonth();switch(t){case"M":case"MM":return Bhe.M(e,t);case"Mo":return n.ordinalNumber(r+1,{unit:"month"});case"MMM":return n.month(r,{width:"abbreviated",context:"formatting"});case"MMMMM":return n.month(r,{width:"narrow",context:"formatting"});default:return n.month(r,{width:"wide",context:"formatting"})}},L:function(e,t,n){const r=e.getMonth();switch(t){case"L":return String(r+1);case"LL":return Ihe(r+1,2);case"Lo":return n.ordinalNumber(r+1,{unit:"month"});case"LLL":return n.month(r,{width:"abbreviated",context:"standalone"});case"LLLLL":return n.month(r,{width:"narrow",context:"standalone"});default:return n.month(r,{width:"wide",context:"standalone"})}},w:function(e,t,n,r){const o=Phe(e,r);return"wo"===t?n.ordinalNumber(o,{unit:"week"}):Ihe(o,t.length)},I:function(e,t,n){const r=Ohe(e);return"Io"===t?n.ordinalNumber(r,{unit:"week"}):Ihe(r,t.length)},d:function(e,t,n){return"do"===t?n.ordinalNumber(e.getDate(),{unit:"date"}):Bhe.d(e,t)},D:function(e,t,n){const r=khe(e);return"Do"===t?n.ordinalNumber(r,{unit:"dayOfYear"}):Ihe(r,t.length)},E:function(e,t,n){const r=e.getDay();switch(t){case"E":case"EE":case"EEE":return n.day(r,{width:"abbreviated",context:"formatting"});case"EEEEE":return n.day(r,{width:"narrow",context:"formatting"});case"EEEEEE":return n.day(r,{width:"short",context:"formatting"});default:return n.day(r,{width:"wide",context:"formatting"})}},e:function(e,t,n,r){const o=e.getDay(),i=(o-r.weekStartsOn+8)%7||7;switch(t){case"e":return String(i);case"ee":return Ihe(i,2);case"eo":return n.ordinalNumber(i,{unit:"day"});case"eee":return n.day(o,{width:"abbreviated",context:"formatting"});case"eeeee":return n.day(o,{width:"narrow",context:"formatting"});case"eeeeee":return n.day(o,{width:"short",context:"formatting"});default:return n.day(o,{width:"wide",context:"formatting"})}},c:function(e,t,n,r){const o=e.getDay(),i=(o-r.weekStartsOn+8)%7||7;switch(t){case"c":return String(i);case"cc":return Ihe(i,t.length);case"co":return n.ordinalNumber(i,{unit:"day"});case"ccc":return n.day(o,{width:"abbreviated",context:"standalone"});case"ccccc":return n.day(o,{width:"narrow",context:"standalone"});case"cccccc":return n.day(o,{width:"short",context:"standalone"});default:return n.day(o,{width:"wide",context:"standalone"})}},i:function(e,t,n){const r=e.getDay(),o=0===r?7:r;switch(t){case"i":return String(o);case"ii":return Ihe(o,t.length);case"io":return n.ordinalNumber(o,{unit:"day"});case"iii":return n.day(r,{width:"abbreviated",context:"formatting"});case"iiiii":return n.day(r,{width:"narrow",context:"formatting"});case"iiiiii":return n.day(r,{width:"short",context:"formatting"});default:return n.day(r,{width:"wide",context:"formatting"})}},a:function(e,t,n){const r=e.getHours()/12>=1?"pm":"am";switch(t){case"a":case"aa":return n.dayPeriod(r,{width:"abbreviated",context:"formatting"});case"aaa":return n.dayPeriod(r,{width:"abbreviated",context:"formatting"}).toLowerCase();case"aaaaa":return n.dayPeriod(r,{width:"narrow",context:"formatting"});default:return n.dayPeriod(r,{width:"wide",context:"formatting"})}},b:function(e,t,n){const r=e.getHours();let o;switch(o=12===r?Nhe:0===r?Rhe:r/12>=1?"pm":"am",t){case"b":case"bb":return n.dayPeriod(o,{width:"abbreviated",context:"formatting"});case"bbb":return n.dayPeriod(o,{width:"abbreviated",context:"formatting"}).toLowerCase();case"bbbbb":return n.dayPeriod(o,{width:"narrow",context:"formatting"});default:return n.dayPeriod(o,{width:"wide",context:"formatting"})}},B:function(e,t,n){const r=e.getHours();let o;switch(o=r>=17?Yhe:r>=12?jhe:r>=4?Fhe:$he,t){case"B":case"BB":case"BBB":return n.dayPeriod(o,{width:"abbreviated",context:"formatting"});case"BBBBB":return n.dayPeriod(o,{width:"narrow",context:"formatting"});default:return n.dayPeriod(o,{width:"wide",context:"formatting"})}},h:function(e,t,n){if("ho"===t){let t=e.getHours()%12;return 0===t&&(t=12),n.ordinalNumber(t,{unit:"hour"})}return Bhe.h(e,t)},H:function(e,t,n){return"Ho"===t?n.ordinalNumber(e.getHours(),{unit:"hour"}):Bhe.H(e,t)},K:function(e,t,n){const r=e.getHours()%12;return"Ko"===t?n.ordinalNumber(r,{unit:"hour"}):Ihe(r,t.length)},k:function(e,t,n){let r=e.getHours();return 0===r&&(r=24),"ko"===t?n.ordinalNumber(r,{unit:"hour"}):Ihe(r,t.length)},m:function(e,t,n){return"mo"===t?n.ordinalNumber(e.getMinutes(),{unit:"minute"}):Bhe.m(e,t)},s:function(e,t,n){return"so"===t?n.ordinalNumber(e.getSeconds(),{unit:"second"}):Bhe.s(e,t)},S:function(e,t){return Bhe.S(e,t)},X:function(e,t,n){const r=e.getTimezoneOffset();if(0===r)return"Z";switch(t){case"X":return zhe(r);case"XXXX":case"XX":return Whe(r);default:return Whe(r,":")}},x:function(e,t,n){const r=e.getTimezoneOffset();switch(t){case"x":return zhe(r);case"xxxx":case"xx":return Whe(r);default:return Whe(r,":")}},O:function(e,t,n){const r=e.getTimezoneOffset();switch(t){case"O":case"OO":case"OOO":return"GMT"+Uhe(r,":");default:return"GMT"+Whe(r,":")}},z:function(e,t,n){const r=e.getTimezoneOffset();switch(t){case"z":case"zz":case"zzz":return"GMT"+Uhe(r,":");default:return"GMT"+Whe(r,":")}},t:function(e,t,n){return Ihe(Math.trunc(+e/1e3),t.length)},T:function(e,t,n){return Ihe(+e,t.length)}};function Uhe(e,t=""){const n=e>0?"-":"+",r=Math.abs(e),o=Math.trunc(r/60),i=r%60;return 0===i?n+String(o):n+String(o)+t+Ihe(i,2)}function zhe(e,t){if(e%60==0){return(e>0?"-":"+")+Ihe(Math.abs(e)/60,2)}return Whe(e,t)}function Whe(e,t=""){const n=e>0?"-":"+",r=Math.abs(e);return n+Ihe(Math.trunc(r/60),2)+t+Ihe(r%60,2)}const Vhe=(e,t)=>{switch(e){case"P":return t.date({width:"short"});case"PP":return t.date({width:"medium"});case"PPP":return t.date({width:"long"});default:return t.date({width:"full"})}},Ghe=(e,t)=>{switch(e){case"p":return t.time({width:"short"});case"pp":return t.time({width:"medium"});case"ppp":return t.time({width:"long"});default:return t.time({width:"full"})}},Qhe={p:Ghe,P:(e,t)=>{const n=e.match(/(P+)(p+)?/)||[],r=n[1],o=n[2];if(!o)return Vhe(e,t);let i;switch(r){case"P":i=t.dateTime({width:"short"});break;case"PP":i=t.dateTime({width:"medium"});break;case"PPP":i=t.dateTime({width:"long"});break;default:i=t.dateTime({width:"full"})}return i.replace("{{date}}",Vhe(r,t)).replace("{{time}}",Ghe(o,t))}},qhe=/^D+$/,Khe=/^Y+$/,Zhe=["D","DD","YY","YYYY"];function Jhe(e){return qhe.test(e)}function Xhe(e){return Khe.test(e)}function eme(e,t,n){const r=function(e,t,n){const r="Y"===e[0]?"years":"days of the month";return`Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`}(e,t,n);if(console.warn(r),Zhe.includes(e))throw new RangeError(r)}function tme(e){return e instanceof Date||"object"==typeof e&&"[object Date]"===Object.prototype.toString.call(e)}function nme(e){return!(!tme(e)&&"number"!=typeof e||isNaN(+_he(e)))}const rme=/[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,ome=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,ime=/^'([^]*?)'?$/,ame=/''/g,sme=/[a-zA-Z]/;function lme(e,t,n){const r=fhe(),o=n?.locale??r.locale??dhe,i=n?.firstWeekContainsDate??n?.locale?.options?.firstWeekContainsDate??r.firstWeekContainsDate??r.locale?.options?.firstWeekContainsDate??1,a=n?.weekStartsOn??n?.locale?.options?.weekStartsOn??r.weekStartsOn??r.locale?.options?.weekStartsOn??0,s=_he(e,n?.in);if(!nme(s))throw new RangeError("Invalid time value");let l=t.match(ome).map((e=>{const t=e[0];if("p"===t||"P"===t){return(0,Qhe[t])(e,o.formatLong)}return e})).join("").match(rme).map((e=>{if("''"===e)return{isToken:!1,value:"'"};const t=e[0];if("'"===t)return{isToken:!1,value:cme(e)};if(Hhe[t])return{isToken:!0,value:e};if(t.match(sme))throw new RangeError("Format string contains an unescaped latin alphabet character `"+t+"`");return{isToken:!1,value:e}}));o.localize.preprocessor&&(l=o.localize.preprocessor(s,l));const c={firstWeekContainsDate:i,weekStartsOn:a,locale:o};return l.map((r=>{if(!r.isToken)return r.value;const i=r.value;(!n?.useAdditionalWeekYearTokens&&Xhe(i)||!n?.useAdditionalDayOfYearTokens&&Jhe(i))&&eme(i,t,String(e));return(0,Hhe[i[0]])(s,i,o.localize,c)})).join("")}function cme(e){const t=e.match(ime);return t?t[1].replace(ame,"'"):e}function ume(e,t){const n=()=>bhe(t?.in,NaN),r=t?.additionalDigits??2,o=function(e){const t={},n=e.split(dme.dateTimeDelimiter);let r;if(n.length>2)return t;/:/.test(n[0])?r=n[0]:(t.date=n[0],r=n[1],dme.timeZoneDelimiter.test(t.date)&&(t.date=e.split(dme.timeZoneDelimiter)[0],r=e.substr(t.date.length,e.length)));if(r){const e=dme.timezone.exec(r);e?(t.time=r.replace(e[1],""),t.timezone=e[1]):t.time=r}return t}(e);let i;if(o.date){const e=function(e,t){const n=new RegExp("^(?:(\\d{4}|[+-]\\d{"+(4+t)+"})|(\\d{2}|[+-]\\d{"+(2+t)+"})$)"),r=e.match(n);if(!r)return{year:NaN,restDateString:""};const o=r[1]?parseInt(r[1]):null,i=r[2]?parseInt(r[2]):null;return{year:null===i?o:100*i,restDateString:e.slice((r[1]||r[2]).length)}}(o.date,r);i=function(e,t){if(null===t)return new Date(NaN);const n=e.match(pme);if(!n)return new Date(NaN);const r=!!n[4],o=mme(n[1]),i=mme(n[2])-1,a=mme(n[3]),s=mme(n[4]),l=mme(n[5])-1;if(r)return function(e,t,n){return t>=1&&t<=53&&n>=0&&n<=6}(0,s,l)?function(e,t,n){const r=new Date(0);r.setUTCFullYear(e,0,4);const o=r.getUTCDay()||7,i=7*(t-1)+n+1-o;return r.setUTCDate(r.getUTCDate()+i),r}(t,s,l):new Date(NaN);{const e=new Date(0);return function(e,t,n){return t>=0&&t<=11&&n>=1&&n<=(vme[t]||(yme(e)?29:28))}(t,i,a)&&function(e,t){return t>=1&&t<=(yme(e)?366:365)}(t,o)?(e.setUTCFullYear(t,i,Math.max(o,a)),e):new Date(NaN)}}(e.restDateString,e.year)}if(!i||isNaN(+i))return n();const a=+i;let s,l=0;if(o.time&&(l=function(e){const t=e.match(fme);if(!t)return NaN;const n=gme(t[1]),r=gme(t[2]),o=gme(t[3]);if(!function(e,t,n){if(24===e)return 0===t&&0===n;return n>=0&&n<60&&t>=0&&t<60&&e>=0&&e<25}(n,r,o))return NaN;return n*vhe+r*ghe+1e3*o}(o.time),isNaN(l)))return n();if(!o.timezone){const e=new Date(a+l),n=_he(0,t?.in);return n.setFullYear(e.getUTCFullYear(),e.getUTCMonth(),e.getUTCDate()),n.setHours(e.getUTCHours(),e.getUTCMinutes(),e.getUTCSeconds(),e.getUTCMilliseconds()),n}return s=function(e){if("Z"===e)return 0;const t=e.match(hme);if(!t)return 0;const n="+"===t[1]?-1:1,r=parseInt(t[2]),o=t[3]&&parseInt(t[3])||0;if(!function(e,t){return t>=0&&t<=59}(0,o))return NaN;return n*(r*vhe+o*ghe)}(o.timezone),isNaN(s)?n():_he(a+l+s,t?.in)}const dme={dateTimeDelimiter:/[T ]/,timeZoneDelimiter:/[Z ]/i,timezone:/([Z+-].*)$/},pme=/^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/,fme=/^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/,hme=/^([+-])(\d{2})(?::?(\d{2}))?$/;function mme(e){return e?parseInt(e):1}function gme(e){return e&&parseFloat(e.replace(",","."))||0}const vme=[31,null,31,30,31,30,31,31,30,31,30,31];function yme(e){return e%400==0||e%4==0&&e%100!=0}function bme(){return Object.assign({},fhe())}function _me(e,t){const n=function(e){return"function"==typeof e&&e.prototype?.constructor===e}(t)?new t(0):bhe(t,0);return n.setFullYear(e.getFullYear(),e.getMonth(),e.getDate()),n.setHours(e.getHours(),e.getMinutes(),e.getSeconds(),e.getMilliseconds()),n}class Ame{subPriority=0;validate(e,t){return!0}}class Eme extends Ame{constructor(e,t,n,r,o){super(),this.value=e,this.validateValue=t,this.setValue=n,this.priority=r,o&&(this.subPriority=o)}validate(e,t){return this.validateValue(e,this.value,t)}set(e,t,n){return this.setValue(e,t,this.value,n)}}class wme extends Ame{priority=10;subPriority=-1;constructor(e,t){super(),this.context=e||(e=>bhe(t,e))}set(e,t){return t.timestampIsSet?e:bhe(e,_me(e,this.context))}}class xme{run(e,t,n,r){const o=this.parse(e,t,n,r);return o?{setter:new Eme(o.value,this.validate,this.set,this.priority,this.subPriority),rest:o.rest}:null}validate(e,t,n){return!0}}const kme=/^(1[0-2]|0?\d)/,Cme=/^(3[0-1]|[0-2]?\d)/,Sme=/^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,Mme=/^(5[0-3]|[0-4]?\d)/,Tme=/^(2[0-3]|[0-1]?\d)/,Ome=/^(2[0-4]|[0-1]?\d)/,Dme=/^(1[0-1]|0?\d)/,Lme=/^(1[0-2]|0?\d)/,Pme=/^[0-5]?\d/,Ime=/^[0-5]?\d/,Bme=/^\d/,Rme=/^\d{1,2}/,Nme=/^\d{1,3}/,Fme=/^\d{1,4}/,jme=/^-?\d+/,Yme=/^-?\d/,$me=/^-?\d{1,2}/,Hme=/^-?\d{1,3}/,Ume=/^-?\d{1,4}/,zme=/^([+-])(\d{2})(\d{2})?|Z/,Wme=/^([+-])(\d{2})(\d{2})|Z/,Vme=/^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,Gme=/^([+-])(\d{2}):(\d{2})|Z/,Qme=/^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/;function qme(e,t){return e?{value:t(e.value),rest:e.rest}:e}function Kme(e,t){const n=t.match(e);return n?{value:parseInt(n[0],10),rest:t.slice(n[0].length)}:null}function Zme(e,t){const n=t.match(e);if(!n)return null;if("Z"===n[0])return{value:0,rest:t.slice(1)};const r="+"===n[1]?1:-1,o=n[2]?parseInt(n[2],10):0,i=n[3]?parseInt(n[3],10):0,a=n[5]?parseInt(n[5],10):0;return{value:r*(o*vhe+i*ghe+1e3*a),rest:t.slice(n[0].length)}}function Jme(e){return Kme(jme,e)}function Xme(e,t){switch(e){case 1:return Kme(Bme,t);case 2:return Kme(Rme,t);case 3:return Kme(Nme,t);case 4:return Kme(Fme,t);default:return Kme(new RegExp("^\\d{1,"+e+"}"),t)}}function ege(e,t){switch(e){case 1:return Kme(Yme,t);case 2:return Kme($me,t);case 3:return Kme(Hme,t);case 4:return Kme(Ume,t);default:return Kme(new RegExp("^-?\\d{1,"+e+"}"),t)}}function tge(e){switch(e){case"morning":return 4;case"evening":return 17;case"pm":case"noon":case"afternoon":return 12;default:return 0}}function nge(e,t){const n=t>0,r=n?t:1-t;let o;if(r<=50)o=e||100;else{const t=r+50;o=e+100*Math.trunc(t/100)-(e>=t%100?100:0)}return n?o:1-o}function rge(e){return e%400==0||e%4==0&&e%100!=0}function oge(e,t,n){const r=_he(e,n?.in),o=Phe(r,n)-t;return r.setDate(r.getDate()-7*o),_he(r,n?.in)}function ige(e,t,n){const r=_he(e,n?.in),o=Ohe(r,n)-t;return r.setDate(r.getDate()-7*o),r}const age=[31,28,31,30,31,30,31,31,30,31,30,31],sge=[31,29,31,30,31,30,31,31,30,31,30,31];function lge(e,t,n){const r=_he(e,n?.in);return isNaN(t)?bhe(n?.in||e,NaN):t?(r.setDate(r.getDate()+t),r):r}function cge(e,t,n){const r=fhe(),o=n?.weekStartsOn??n?.locale?.options?.weekStartsOn??r.weekStartsOn??r.locale?.options?.weekStartsOn??0,i=_he(e,n?.in),a=i.getDay(),s=7-o;return lge(i,t<0||t>6?t-(a+s)%7:((t%7+7)%7+s)%7-(a+s)%7,n)}function uge(e,t){const n=_he(e,t?.in).getDay();return 0===n?7:n}function dge(e,t,n){const r=_he(e,n?.in);return lge(r,t-uge(r,n),n)}const pge={G:new class extends xme{priority=140;parse(e,t,n){switch(t){case"G":case"GG":case"GGG":return n.era(e,{width:"abbreviated"})||n.era(e,{width:"narrow"});case"GGGGG":return n.era(e,{width:"narrow"});default:return n.era(e,{width:"wide"})||n.era(e,{width:"abbreviated"})||n.era(e,{width:"narrow"})}}set(e,t,n){return t.era=n,e.setFullYear(n,0,1),e.setHours(0,0,0,0),e}incompatibleTokens=["R","u","t","T"]},y:new class extends xme{priority=130;incompatibleTokens=["Y","R","u","w","I","i","e","c","t","T"];parse(e,t,n){const r=e=>({year:e,isTwoDigitYear:"yy"===t});switch(t){case"y":return qme(Xme(4,e),r);case"yo":return qme(n.ordinalNumber(e,{unit:"year"}),r);default:return qme(Xme(t.length,e),r)}}validate(e,t){return t.isTwoDigitYear||t.year>0}set(e,t,n){const r=e.getFullYear();if(n.isTwoDigitYear){const t=nge(n.year,r);return e.setFullYear(t,0,1),e.setHours(0,0,0,0),e}const o="era"in t&&1!==t.era?1-n.year:n.year;return e.setFullYear(o,0,1),e.setHours(0,0,0,0),e}},Y:new class extends xme{priority=130;parse(e,t,n){const r=e=>({year:e,isTwoDigitYear:"YY"===t});switch(t){case"Y":return qme(Xme(4,e),r);case"Yo":return qme(n.ordinalNumber(e,{unit:"year"}),r);default:return qme(Xme(t.length,e),r)}}validate(e,t){return t.isTwoDigitYear||t.year>0}set(e,t,n,r){const o=Dhe(e,r);if(n.isTwoDigitYear){const t=nge(n.year,o);return e.setFullYear(t,0,r.firstWeekContainsDate),e.setHours(0,0,0,0),Che(e,r)}const i="era"in t&&1!==t.era?1-n.year:n.year;return e.setFullYear(i,0,r.firstWeekContainsDate),e.setHours(0,0,0,0),Che(e,r)}incompatibleTokens=["y","R","u","Q","q","M","L","I","d","D","i","t","T"]},R:new class extends xme{priority=130;parse(e,t){return ege("R"===t?4:t.length,e)}set(e,t,n){const r=bhe(e,0);return r.setFullYear(n,0,4),r.setHours(0,0,0,0),She(r)}incompatibleTokens=["G","y","Y","u","Q","q","M","L","w","d","D","e","c","t","T"]},u:new class extends xme{priority=130;parse(e,t){return ege("u"===t?4:t.length,e)}set(e,t,n){return e.setFullYear(n,0,1),e.setHours(0,0,0,0),e}incompatibleTokens=["G","y","Y","R","w","I","i","e","c","t","T"]},Q:new class extends xme{priority=120;parse(e,t,n){switch(t){case"Q":case"QQ":return Xme(t.length,e);case"Qo":return n.ordinalNumber(e,{unit:"quarter"});case"QQQ":return n.quarter(e,{width:"abbreviated",context:"formatting"})||n.quarter(e,{width:"narrow",context:"formatting"});case"QQQQQ":return n.quarter(e,{width:"narrow",context:"formatting"});default:return n.quarter(e,{width:"wide",context:"formatting"})||n.quarter(e,{width:"abbreviated",context:"formatting"})||n.quarter(e,{width:"narrow",context:"formatting"})}}validate(e,t){return t>=1&&t<=4}set(e,t,n){return e.setMonth(3*(n-1),1),e.setHours(0,0,0,0),e}incompatibleTokens=["Y","R","q","M","L","w","I","d","D","i","e","c","t","T"]},q:new class extends xme{priority=120;parse(e,t,n){switch(t){case"q":case"qq":return Xme(t.length,e);case"qo":return n.ordinalNumber(e,{unit:"quarter"});case"qqq":return n.quarter(e,{width:"abbreviated",context:"standalone"})||n.quarter(e,{width:"narrow",context:"standalone"});case"qqqqq":return n.quarter(e,{width:"narrow",context:"standalone"});default:return n.quarter(e,{width:"wide",context:"standalone"})||n.quarter(e,{width:"abbreviated",context:"standalone"})||n.quarter(e,{width:"narrow",context:"standalone"})}}validate(e,t){return t>=1&&t<=4}set(e,t,n){return e.setMonth(3*(n-1),1),e.setHours(0,0,0,0),e}incompatibleTokens=["Y","R","Q","M","L","w","I","d","D","i","e","c","t","T"]},M:new class extends xme{incompatibleTokens=["Y","R","q","Q","L","w","I","D","i","e","c","t","T"];priority=110;parse(e,t,n){const r=e=>e-1;switch(t){case"M":return qme(Kme(kme,e),r);case"MM":return qme(Xme(2,e),r);case"Mo":return qme(n.ordinalNumber(e,{unit:"month"}),r);case"MMM":return n.month(e,{width:"abbreviated",context:"formatting"})||n.month(e,{width:"narrow",context:"formatting"});case"MMMMM":return n.month(e,{width:"narrow",context:"formatting"});default:return n.month(e,{width:"wide",context:"formatting"})||n.month(e,{width:"abbreviated",context:"formatting"})||n.month(e,{width:"narrow",context:"formatting"})}}validate(e,t){return t>=0&&t<=11}set(e,t,n){return e.setMonth(n,1),e.setHours(0,0,0,0),e}},L:new class extends xme{priority=110;parse(e,t,n){const r=e=>e-1;switch(t){case"L":return qme(Kme(kme,e),r);case"LL":return qme(Xme(2,e),r);case"Lo":return qme(n.ordinalNumber(e,{unit:"month"}),r);case"LLL":return n.month(e,{width:"abbreviated",context:"standalone"})||n.month(e,{width:"narrow",context:"standalone"});case"LLLLL":return n.month(e,{width:"narrow",context:"standalone"});default:return n.month(e,{width:"wide",context:"standalone"})||n.month(e,{width:"abbreviated",context:"standalone"})||n.month(e,{width:"narrow",context:"standalone"})}}validate(e,t){return t>=0&&t<=11}set(e,t,n){return e.setMonth(n,1),e.setHours(0,0,0,0),e}incompatibleTokens=["Y","R","q","Q","M","w","I","D","i","e","c","t","T"]},w:new class extends xme{priority=100;parse(e,t,n){switch(t){case"w":return Kme(Mme,e);case"wo":return n.ordinalNumber(e,{unit:"week"});default:return Xme(t.length,e)}}validate(e,t){return t>=1&&t<=53}set(e,t,n,r){return Che(oge(e,n,r),r)}incompatibleTokens=["y","R","u","q","Q","M","L","I","d","D","i","t","T"]},I:new class extends xme{priority=100;parse(e,t,n){switch(t){case"I":return Kme(Mme,e);case"Io":return n.ordinalNumber(e,{unit:"week"});default:return Xme(t.length,e)}}validate(e,t){return t>=1&&t<=53}set(e,t,n){return She(ige(e,n))}incompatibleTokens=["y","Y","u","q","Q","M","L","w","d","D","e","c","t","T"]},d:new class extends xme{priority=90;subPriority=1;parse(e,t,n){switch(t){case"d":return Kme(Cme,e);case"do":return n.ordinalNumber(e,{unit:"date"});default:return Xme(t.length,e)}}validate(e,t){const n=rge(e.getFullYear()),r=e.getMonth();return n?t>=1&&t<=sge[r]:t>=1&&t<=age[r]}set(e,t,n){return e.setDate(n),e.setHours(0,0,0,0),e}incompatibleTokens=["Y","R","q","Q","w","I","D","i","e","c","t","T"]},D:new class extends xme{priority=90;subpriority=1;parse(e,t,n){switch(t){case"D":case"DD":return Kme(Sme,e);case"Do":return n.ordinalNumber(e,{unit:"date"});default:return Xme(t.length,e)}}validate(e,t){return rge(e.getFullYear())?t>=1&&t<=366:t>=1&&t<=365}set(e,t,n){return e.setMonth(0,n),e.setHours(0,0,0,0),e}incompatibleTokens=["Y","R","q","Q","M","L","w","I","d","E","i","e","c","t","T"]},E:new class extends xme{priority=90;parse(e,t,n){switch(t){case"E":case"EE":case"EEE":return n.day(e,{width:"abbreviated",context:"formatting"})||n.day(e,{width:"short",context:"formatting"})||n.day(e,{width:"narrow",context:"formatting"});case"EEEEE":return n.day(e,{width:"narrow",context:"formatting"});case"EEEEEE":return n.day(e,{width:"short",context:"formatting"})||n.day(e,{width:"narrow",context:"formatting"});default:return n.day(e,{width:"wide",context:"formatting"})||n.day(e,{width:"abbreviated",context:"formatting"})||n.day(e,{width:"short",context:"formatting"})||n.day(e,{width:"narrow",context:"formatting"})}}validate(e,t){return t>=0&&t<=6}set(e,t,n,r){return(e=cge(e,n,r)).setHours(0,0,0,0),e}incompatibleTokens=["D","i","e","c","t","T"]},e:new class extends xme{priority=90;parse(e,t,n,r){const o=e=>{const t=7*Math.floor((e-1)/7);return(e+r.weekStartsOn+6)%7+t};switch(t){case"e":case"ee":return qme(Xme(t.length,e),o);case"eo":return qme(n.ordinalNumber(e,{unit:"day"}),o);case"eee":return n.day(e,{width:"abbreviated",context:"formatting"})||n.day(e,{width:"short",context:"formatting"})||n.day(e,{width:"narrow",context:"formatting"});case"eeeee":return n.day(e,{width:"narrow",context:"formatting"});case"eeeeee":return n.day(e,{width:"short",context:"formatting"})||n.day(e,{width:"narrow",context:"formatting"});default:return n.day(e,{width:"wide",context:"formatting"})||n.day(e,{width:"abbreviated",context:"formatting"})||n.day(e,{width:"short",context:"formatting"})||n.day(e,{width:"narrow",context:"formatting"})}}validate(e,t){return t>=0&&t<=6}set(e,t,n,r){return(e=cge(e,n,r)).setHours(0,0,0,0),e}incompatibleTokens=["y","R","u","q","Q","M","L","I","d","D","E","i","c","t","T"]},c:new class extends xme{priority=90;parse(e,t,n,r){const o=e=>{const t=7*Math.floor((e-1)/7);return(e+r.weekStartsOn+6)%7+t};switch(t){case"c":case"cc":return qme(Xme(t.length,e),o);case"co":return qme(n.ordinalNumber(e,{unit:"day"}),o);case"ccc":return n.day(e,{width:"abbreviated",context:"standalone"})||n.day(e,{width:"short",context:"standalone"})||n.day(e,{width:"narrow",context:"standalone"});case"ccccc":return n.day(e,{width:"narrow",context:"standalone"});case"cccccc":return n.day(e,{width:"short",context:"standalone"})||n.day(e,{width:"narrow",context:"standalone"});default:return n.day(e,{width:"wide",context:"standalone"})||n.day(e,{width:"abbreviated",context:"standalone"})||n.day(e,{width:"short",context:"standalone"})||n.day(e,{width:"narrow",context:"standalone"})}}validate(e,t){return t>=0&&t<=6}set(e,t,n,r){return(e=cge(e,n,r)).setHours(0,0,0,0),e}incompatibleTokens=["y","R","u","q","Q","M","L","I","d","D","E","i","e","t","T"]},i:new class extends xme{priority=90;parse(e,t,n){const r=e=>0===e?7:e;switch(t){case"i":case"ii":return Xme(t.length,e);case"io":return n.ordinalNumber(e,{unit:"day"});case"iii":return qme(n.day(e,{width:"abbreviated",context:"formatting"})||n.day(e,{width:"short",context:"formatting"})||n.day(e,{width:"narrow",context:"formatting"}),r);case"iiiii":return qme(n.day(e,{width:"narrow",context:"formatting"}),r);case"iiiiii":return qme(n.day(e,{width:"short",context:"formatting"})||n.day(e,{width:"narrow",context:"formatting"}),r);default:return qme(n.day(e,{width:"wide",context:"formatting"})||n.day(e,{width:"abbreviated",context:"formatting"})||n.day(e,{width:"short",context:"formatting"})||n.day(e,{width:"narrow",context:"formatting"}),r)}}validate(e,t){return t>=1&&t<=7}set(e,t,n){return(e=dge(e,n)).setHours(0,0,0,0),e}incompatibleTokens=["y","Y","u","q","Q","M","L","w","d","D","E","e","c","t","T"]},a:new class extends xme{priority=80;parse(e,t,n){switch(t){case"a":case"aa":case"aaa":return n.dayPeriod(e,{width:"abbreviated",context:"formatting"})||n.dayPeriod(e,{width:"narrow",context:"formatting"});case"aaaaa":return n.dayPeriod(e,{width:"narrow",context:"formatting"});default:return n.dayPeriod(e,{width:"wide",context:"formatting"})||n.dayPeriod(e,{width:"abbreviated",context:"formatting"})||n.dayPeriod(e,{width:"narrow",context:"formatting"})}}set(e,t,n){return e.setHours(tge(n),0,0,0),e}incompatibleTokens=["b","B","H","k","t","T"]},b:new class extends xme{priority=80;parse(e,t,n){switch(t){case"b":case"bb":case"bbb":return n.dayPeriod(e,{width:"abbreviated",context:"formatting"})||n.dayPeriod(e,{width:"narrow",context:"formatting"});case"bbbbb":return n.dayPeriod(e,{width:"narrow",context:"formatting"});default:return n.dayPeriod(e,{width:"wide",context:"formatting"})||n.dayPeriod(e,{width:"abbreviated",context:"formatting"})||n.dayPeriod(e,{width:"narrow",context:"formatting"})}}set(e,t,n){return e.setHours(tge(n),0,0,0),e}incompatibleTokens=["a","B","H","k","t","T"]},B:new class extends xme{priority=80;parse(e,t,n){switch(t){case"B":case"BB":case"BBB":return n.dayPeriod(e,{width:"abbreviated",context:"formatting"})||n.dayPeriod(e,{width:"narrow",context:"formatting"});case"BBBBB":return n.dayPeriod(e,{width:"narrow",context:"formatting"});default:return n.dayPeriod(e,{width:"wide",context:"formatting"})||n.dayPeriod(e,{width:"abbreviated",context:"formatting"})||n.dayPeriod(e,{width:"narrow",context:"formatting"})}}set(e,t,n){return e.setHours(tge(n),0,0,0),e}incompatibleTokens=["a","b","t","T"]},h:new class extends xme{priority=70;parse(e,t,n){switch(t){case"h":return Kme(Lme,e);case"ho":return n.ordinalNumber(e,{unit:"hour"});default:return Xme(t.length,e)}}validate(e,t){return t>=1&&t<=12}set(e,t,n){const r=e.getHours()>=12;return r&&n<12?e.setHours(n+12,0,0,0):r||12!==n?e.setHours(n,0,0,0):e.setHours(0,0,0,0),e}incompatibleTokens=["H","K","k","t","T"]},H:new class extends xme{priority=70;parse(e,t,n){switch(t){case"H":return Kme(Tme,e);case"Ho":return n.ordinalNumber(e,{unit:"hour"});default:return Xme(t.length,e)}}validate(e,t){return t>=0&&t<=23}set(e,t,n){return e.setHours(n,0,0,0),e}incompatibleTokens=["a","b","h","K","k","t","T"]},K:new class extends xme{priority=70;parse(e,t,n){switch(t){case"K":return Kme(Dme,e);case"Ko":return n.ordinalNumber(e,{unit:"hour"});default:return Xme(t.length,e)}}validate(e,t){return t>=0&&t<=11}set(e,t,n){return e.getHours()>=12&&n<12?e.setHours(n+12,0,0,0):e.setHours(n,0,0,0),e}incompatibleTokens=["h","H","k","t","T"]},k:new class extends xme{priority=70;parse(e,t,n){switch(t){case"k":return Kme(Ome,e);case"ko":return n.ordinalNumber(e,{unit:"hour"});default:return Xme(t.length,e)}}validate(e,t){return t>=1&&t<=24}set(e,t,n){const r=n<=24?n%24:n;return e.setHours(r,0,0,0),e}incompatibleTokens=["a","b","h","H","K","t","T"]},m:new class extends xme{priority=60;parse(e,t,n){switch(t){case"m":return Kme(Pme,e);case"mo":return n.ordinalNumber(e,{unit:"minute"});default:return Xme(t.length,e)}}validate(e,t){return t>=0&&t<=59}set(e,t,n){return e.setMinutes(n,0,0),e}incompatibleTokens=["t","T"]},s:new class extends xme{priority=50;parse(e,t,n){switch(t){case"s":return Kme(Ime,e);case"so":return n.ordinalNumber(e,{unit:"second"});default:return Xme(t.length,e)}}validate(e,t){return t>=0&&t<=59}set(e,t,n){return e.setSeconds(n,0),e}incompatibleTokens=["t","T"]},S:new class extends xme{priority=30;parse(e,t){return qme(Xme(t.length,e),(e=>Math.trunc(e*Math.pow(10,3-t.length))))}set(e,t,n){return e.setMilliseconds(n),e}incompatibleTokens=["t","T"]},X:new class extends xme{priority=10;parse(e,t){switch(t){case"X":return Zme(zme,e);case"XX":return Zme(Wme,e);case"XXXX":return Zme(Vme,e);case"XXXXX":return Zme(Qme,e);default:return Zme(Gme,e)}}set(e,t,n){return t.timestampIsSet?e:bhe(e,e.getTime()-Ahe(e)-n)}incompatibleTokens=["t","T","x"]},x:new class extends xme{priority=10;parse(e,t){switch(t){case"x":return Zme(zme,e);case"xx":return Zme(Wme,e);case"xxxx":return Zme(Vme,e);case"xxxxx":return Zme(Qme,e);default:return Zme(Gme,e)}}set(e,t,n){return t.timestampIsSet?e:bhe(e,e.getTime()-Ahe(e)-n)}incompatibleTokens=["t","T","X"]},t:new class extends xme{priority=40;parse(e){return Jme(e)}set(e,t,n){return[bhe(e,1e3*n),{timestampIsSet:!0}]}incompatibleTokens="*"},T:new class extends xme{priority=20;parse(e){return Jme(e)}set(e,t,n){return[bhe(e,n),{timestampIsSet:!0}]}incompatibleTokens="*"}},fge=/[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,hge=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,mge=/^'([^]*?)'?$/,gge=/''/g,vge=/\S/,yge=/[a-zA-Z]/;function bge(e,t,n,r){const o=()=>bhe(r?.in||n,NaN),i=bme(),a=r?.locale??i.locale??dhe,s=r?.firstWeekContainsDate??r?.locale?.options?.firstWeekContainsDate??i.firstWeekContainsDate??i.locale?.options?.firstWeekContainsDate??1,l=r?.weekStartsOn??r?.locale?.options?.weekStartsOn??i.weekStartsOn??i.locale?.options?.weekStartsOn??0;if(!t)return e?o():_he(n,r?.in);const c={firstWeekContainsDate:s,weekStartsOn:l,locale:a},u=[new wme(r?.in,n)],d=t.match(hge).map((e=>{const t=e[0];if(t in Qhe){return(0,Qhe[t])(e,a.formatLong)}return e})).join("").match(fge),p=[];for(let n of d){!r?.useAdditionalWeekYearTokens&&Xhe(n)&&eme(n,t,e),!r?.useAdditionalDayOfYearTokens&&Jhe(n)&&eme(n,t,e);const i=n[0],s=pge[i];if(s){const{incompatibleTokens:t}=s;if(Array.isArray(t)){const e=p.find((e=>t.includes(e.token)||e.token===i));if(e)throw new RangeError(`The format string mustn't contain \`${e.fullToken}\` and \`${n}\` at the same time`)}else if("*"===s.incompatibleTokens&&p.length>0)throw new RangeError(`The format string mustn't contain \`${n}\` and any other token at the same time`);p.push({token:i,fullToken:n});const r=s.run(e,n,a.match,c);if(!r)return o();u.push(r.setter),e=r.rest}else{if(i.match(yge))throw new RangeError("Format string contains an unescaped latin alphabet character `"+i+"`");if("''"===n?n="'":"'"===i&&(n=n.match(mge)[1].replace(gge,"'")),0!==e.indexOf(n))return o();e=e.slice(n.length)}}if(e.length>0&&vge.test(e))return o();const f=u.map((e=>e.priority)).sort(((e,t)=>t-e)).filter(((e,t,n)=>n.indexOf(e)===t)).map((e=>u.filter((t=>t.priority===e)).sort(((e,t)=>t.subPriority-e.subPriority)))).map((e=>e[0]));let h=_he(n,r?.in);if(isNaN(+h))return o();const m={};for(const e of f){if(!e.validate(h,c))return o();const t=e.set(h,m,c);Array.isArray(t)?(h=t[0],Object.assign(m,t[1])):h=t}return h}function _ge(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return Age(e,t);var n={}.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?Age(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,s=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){s=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(s)throw i}}}}function Age(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=Array(t);n<t;n++)r[n]=e[n];return r}var Ege={numeric:{year:"numeric",month:"2-digit",day:"2-digit"},medium:{year:"numeric",month:"short",day:"numeric"}};function wge(e){if("string"==typeof e){var t=e.trim();if(t)return t.replace(/_/g,"-")}}var xge={dateFnsFormat:"MM/dd/yyyy",hint:"MM/DD/YYYY"};var kge=gW({d:"M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z",displayName:"ChevronLeftIcon"}),Cge=gW({d:"M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z",displayName:"ChevronRightIcon"});const Sge=function(e){var t=e.date,n=e.decreaseMonth,r=e.increaseMonth,o=e.changeMonth,a=e.changeYear,s=(0,i.useContext)(rve),l=s.centeredDate,c=s.showTodayButton,u=s.brandTimezone,d=Lr().components.DatePicker.baseStyle,p=d.color,f=d.headerBorderColor,h=d.headerPaddingBottom,g=void 0===h?"16px":h,v=d.chevronSize,y=void 0===v?"24px":v,b=d.chevronColor,_=d.monthYearFontSize,A=void 0===_?"inherit":_,E=d.monthYearFontWeight,w=void 0===E?"normal":E,x=d.todayButtonColor,k=f||p,C=b||p;return i.createElement(_r,{paddingBottom:g,borderBottom:"1px solid "+k,color:p},l?i.createElement(wr,{alignItems:"center",justifyContent:"center",width:"100%"},i.createElement(Gr,{"aria-label":"Previous month",icon:i.createElement(kge,{width:y,height:y}),onClick:n,variant:"ghost",size:"sm",color:C,minWidth:"auto",height:"auto"}),i.createElement(qr,{paddingRight:"30px",paddingLeft:"30px",margin:0,fontSize:A,fontWeight:w,userSelect:"none"},t.toLocaleDateString("en-US",{month:"long"})," ",t.getFullYear()),i.createElement(Gr,{"aria-label":"Next month",icon:i.createElement(Cge,{width:y,height:y}),onClick:r,variant:"ghost",size:"sm",color:C,minWidth:"auto",height:"auto"})):i.createElement(wr,{alignItems:"center",justifyContent:"space-between",width:"100%"},i.createElement(wr,{alignItems:"center",gap:"12px"},i.createElement(qr,{margin:0,fontSize:A,fontWeight:w},t.toLocaleDateString("en-US",{month:"long"})," ",t.getFullYear()),c&&i.createElement(Wr,{size:"xs",variant:"ghost",onClick:function(){if(u){var e=function(e){var t=new Date;return new Intl.DateTimeFormat("sv-SE",{timeZone:e,year:"numeric",month:"2-digit",day:"2-digit"}).format(t)}(u),t=m(e.split("-").map(Number),2),n=t[0],r=t[1];o(r-1),a(n)}else{var i=new Date;o(i.getMonth()),a(i.getFullYear())}},fontSize:"12px",fontWeight:"400",color:x||p,_hover:{backgroundColor:"gray.100"}},"Today")),i.createElement(wr,{alignItems:"end",gap:"8px"},i.createElement(Gr,{"aria-label":"Previous month",icon:i.createElement(kge,{width:y,height:y}),onClick:n,variant:"ghost",size:"sm",color:C,minWidth:"auto",height:"auto"}),i.createElement(Gr,{"aria-label":"Next month",icon:i.createElement(Cge,{width:y,height:y}),onClick:r,variant:"ghost",size:"sm",color:C,minWidth:"auto",height:"auto"}))))};var Mge=vr("div",{baseStyle:{display:"flex",alignItems:"center",justifyContent:"center",position:"absolute",top:"0",zIndex:2}}),Tge=yr((function(e,t){var n,r;const{placement:o="left",...i}=e,a=fz(),s=a.field,l="left"===o?"insetStart":"insetEnd",c={[l]:"0",width:null!=(n=null==s?void 0:s.height)?n:null==s?void 0:s.h,height:null!=(r=null==s?void 0:s.height)?r:null==s?void 0:s.h,fontSize:null==s?void 0:s.fontSize,...a.element};return(0,br.jsx)(Mge,{ref:t,__css:c,...i})}));Tge.id="InputElement",Tge.displayName="InputElement";var Oge=yr((function(e,t){const{className:n,...r}=e,o=g("chakra-input__left-element",n);return(0,br.jsx)(Tge,{ref:t,placement:"left",className:o,...r})}));Oge.id="InputLeftElement",Oge.displayName="InputLeftElement";var Dge,Lge,Pge,Ige,Bge,Rge,Nge,Fge,jge,Yge=yr((function(e,t){const{className:n,...r}=e,o=g("chakra-input__right-element",n);return(0,br.jsx)(Tge,{ref:t,placement:"right",className:o,...r})}));Yge.id="InputRightElement",Yge.displayName="InputRightElement";var $ge=["title","titleId"];function Hge(){return Hge=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Hge.apply(null,arguments)}var Uge=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,$ge);return i.createElement("svg",Hge({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Dge||(Dge=i.createElement("path",{d:"M16 2V6",stroke:"currentColor",strokeMiterlimit:10,strokeLinecap:"round",strokeLinejoin:"round"})),Lge||(Lge=i.createElement("path",{d:"M8 2V6",stroke:"currentColor",strokeMiterlimit:10,strokeLinecap:"round",strokeLinejoin:"round"})),Pge||(Pge=i.createElement("path",{d:"M3 9H21",stroke:"currentColor",strokeMiterlimit:10,strokeLinecap:"round",strokeLinejoin:"round"})),Ige||(Ige=i.createElement("path",{d:"M19 4H5C3.895 4 3 4.895 3 6V19C3 20.105 3.895 21 5 21H19C20.105 21 21 20.105 21 19V6C21 4.895 20.105 4 19 4Z",stroke:"currentColor",strokeMiterlimit:10,strokeLinecap:"round",strokeLinejoin:"round"})),Bge||(Bge=i.createElement("path",{d:"M7.01304 12.729C6.87504 12.729 6.76304 12.841 6.76404 12.979C6.76404 13.117 6.87604 13.229 7.01404 13.229C7.15204 13.229 7.26404 13.117 7.26404 12.979C7.26404 12.841 7.15204 12.729 7.01304 12.729Z",stroke:"currentColor",strokeMiterlimit:10,strokeLinecap:"round",strokeLinejoin:"round"})),Rge||(Rge=i.createElement("path",{d:"M12.013 12.729C11.875 12.729 11.763 12.841 11.764 12.979C11.764 13.117 11.876 13.229 12.014 13.229C12.152 13.229 12.264 13.117 12.264 12.979C12.264 12.841 12.152 12.729 12.013 12.729Z",stroke:"currentColor",strokeMiterlimit:10,strokeLinecap:"round",strokeLinejoin:"round"})),Nge||(Nge=i.createElement("path",{d:"M17.013 12.729C16.875 12.729 16.763 12.841 16.764 12.979C16.764 13.117 16.876 13.229 17.014 13.229C17.152 13.229 17.264 13.117 17.264 12.979C17.264 12.841 17.152 12.729 17.013 12.729Z",stroke:"currentColor",strokeMiterlimit:10,strokeLinecap:"round",strokeLinejoin:"round"})),Fge||(Fge=i.createElement("path",{d:"M7.01304 16.729C6.87504 16.729 6.76304 16.841 6.76404 16.979C6.76404 17.117 6.87604 17.229 7.01404 17.229C7.15204 17.229 7.26404 17.117 7.26404 16.979C7.26404 16.841 7.15204 16.729 7.01304 16.729Z",stroke:"currentColor",strokeMiterlimit:10,strokeLinecap:"round",strokeLinejoin:"round"})),jge||(jge=i.createElement("path",{d:"M12.013 16.729C11.875 16.729 11.763 16.841 11.764 16.979C11.764 17.117 11.876 17.229 12.014 17.229C12.152 17.229 12.264 17.117 12.264 16.979C12.264 16.841 12.152 16.729 12.013 16.729Z",stroke:"currentColor",strokeMiterlimit:10,strokeLinecap:"round",strokeLinejoin:"round"})))},zge=(0,i.forwardRef)(Uge);o.p;var Wge=["onClick","onFocus","onBlur","value"],Vge=(0,i.forwardRef)((function(e,r){var o=(0,i.useContext)(rve),a=o.isInvalid,s=o.open,l=o.value,c=o.brandLocale,u=o.brandTimezone,d=o.onInputBlur,p=m((0,i.useState)(!1),2),f=p[0],h=p[1],g=e,v=g.onClick,y=g.onFocus,b=g.onBlur,_=g.value,A=t(g,Wge),E=l?function(e){var t,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(!(e instanceof Date)||Number.isNaN(e.getTime()))return"";var o=r.brandLocale,i=r.fallbackLocale,a=r.timeZone,s=r.preset,l=void 0===s?"numeric":s,c=null!==(t=wge(o))&&void 0!==t?t:i,u="string"==typeof a&&a.trim()?a.trim():void 0;return new Intl.DateTimeFormat(c,n({},Ege[l],u?{timeZone:u}:{})).format(e)}(l,{brandLocale:c,fallbackLocale:"undefined"!=typeof navigator&&"string"==typeof navigator.language?navigator.language:void 0,timeZone:u,preset:"numeric"}):_,w=f?null!=_?_:"":E;return i.createElement(wr,{ref:r,role:"group"},i.createElement(hz,null,i.createElement(Yge,null,i.createElement(_r,{onClick:s,cursor:"pointer",padding:"8px",marginLeft:void 0},i.createElement(zge,null))),i.createElement(dz,n({isInvalid:a},A,{value:w,onClick:function(e){null==v||v(e),s()},onFocus:function(e){h(!0),null==y||y(e),s()},onBlur:function(e){h(!1),null==b||b(e),d()}}))))}));const Gge=Vge;var Qge,qge=["dateFormat","id","isDisabled","isInvalid","isValid","max","min","onChange","placeholder","value","centeredDate","availabilities","disableUnavailableDays","disabledDates","inline","inputProps","showTodayButton","brandTimezone","brandLocale","invalidDateMessage","onValidityChange"],Kge="common.datePicker.invalidDate",Zge=function(e){if(!e)return!0;if(Number.isNaN(e.getTime()))return!1;var t=e.getFullYear();return t>=1&&t<=9999},Jge=function(e){var t=e.borderColor,n=void 0===t?"gray":t,r=e.borderRadius,o=void 0===r?"4px":r,a=e.boxShadow,s=void 0===a?"none":a,l=e.popperBackgroundColor,c=void 0===l?"white":l;return i.createElement(Tr,{styles:Or(Qge||(Qge=zM(["\n            /* Floating UI sets inline z-index: 1 on the popper; !important beats that so we stay above Redactor\n               (.rx-toolbar 10, .rx-dropdown 9999, fullscreen 10000). */\n            .react-datepicker-popper {\n                background-color: ",";\n                z-index: 11000 !important;\n                border: 1px solid ",";\n                border-radius: ",";\n                box-shadow: ",";\n            }\n\n            .react-datepicker {\n                border: none;\n                font-family: inherit;\n            }\n\n            .react-datepicker__triangle {\n                display: none;\n            }\n        "])),c,n,o,s)})},Xge=function(e){return e.getFullYear()+"-"+String(e.getMonth()+1).padStart(2,"0")+"-"+String(e.getDate()).padStart(2,"0")},eve=fr(_r)((function(e){var t=e.theme.components.DatePicker.baseStyle,n=t.fontFamily,r=t.backgroundColor,o=t.headerBackgroundColor,i=t.color,a=t.dateColor,s=t.disabledColor,l=t.dayHeaderColor,c=t.calendarBackgroundColor,u=t.padding,d=void 0===u?"0":u,p=t.daySize,f=void 0===p?"42px":p,h=t.dayNameWidth,m=void 0===h?"40px":h,g=t.dayFontSize,v=void 0===g?"inherit":g,y=t.hoverBackgroundColor,b=void 0===y?"none":y,_=t.hoverBorderRadius,A=void 0===_?"50%":_,E=t.weekGap,w=void 0===E?"10px":E,x=t.weekPadding,k=void 0===x?"4px 10px":x,C=t.dayNamesGap,S=void 0===C?"10px":C,M=t.borderRadius;return"\n        font-family: "+n+";\n        background-color: "+(c||o||"white")+";\n        padding: "+d+";\n        border-radius: "+(void 0===M?"4px":M)+";\n        overflow: hidden;\n\n        .react-datepicker__month-container {\n            width: 100%;\n        }\n\n        .react-datepicker__header.react-datepicker__header--custom {\n            background-color: "+o+";\n            border-bottom: 0px;\n            padding-top: 0;\n        }\n\n        .react-datepicker__day {\n            font-family: "+n+";\n            color: "+i+";\n            width: "+f+";\n            height: "+f+";\n            line-height: "+f+";\n            font-size: "+v+";\n            font-weight: 400;\n            margin: 2px;\n            border-radius: 50%;\n            transition: background-color 0.15s ease;\n\n            &:hover {\n                background-color: "+b+";\n                border-radius: "+A+";\n            }\n\n            @media (max-width: 768px) {\n                width: 32px;\n                height: 32px;\n                line-height: 32px;\n            }\n\n            @media (max-width: 480px) {\n                width: 32px;\n                height: 32px;\n                line-height: 32px;\n            }\n        }\n\n        .react-datepicker__day-names {\n            display: flex;\n            justify-content: space-between;\n            gap: "+S+";\n            padding: 8px 0px 8px;\n            color: #000;\n            font-size: 12px;\n            font-style: normal;\n            line-height: 12px;\n            letter-spacing: 0.36px;\n            text-transform: uppercase;\n\n            .react-datepicker__day-name {\n                color: "+(l||i)+";\n                font-family: "+n+";\n                font-weight: 400;\n                width: "+m+";\n                padding: 2px 10px 2px 10px;\n\n                @media (max-width: 768px) {\n                    width: 30px;\n                    padding: 2px 5px;\n                }\n\n                @media (max-width: 480px) {\n                    width: 28px;\n                    padding: 2px;\n                }\n            }\n        }\n\n        .react-datepicker__week {\n            display: flex;\n            padding: "+k+";\n            justify-content: space-between;\n            align-items: center;\n            align-self: stretch;\n            gap: "+w+";\n\n            @media (max-width: 768px) {\n                gap: 5px;\n                padding-left: 5px;\n                padding-right: 5px;\n            }\n\n            @media (max-width: 480px) {\n                gap: 2px;\n                padding-left: 2px;\n                padding-right: 2px;\n            }\n        }\n\n        .react-datepicker__month {\n            margin: 0px;\n        }\n\n        .react-datepicker__day--keyboard-selected {\n            background-color: transparent;\n            color: "+i+";\n            font-weight: 400;\n\n            &:hover {\n                background-color: "+b+";\n            }\n        }\n\n        /* ReactDatePicker selected prop is selectedForPicker: brand-zone YMD (formatCalendarYmdInTimeZone) as local midnight (parseCalendarYmdAsLocalDate) so the grid highlights the same calendar day as the input */\n        .react-datepicker__day--selected {\n            background-color: "+r+";\n            border-radius: 50%;\n            color: "+(a||"white")+";\n            font-weight: 400;\n\n            &:hover {\n                background-color: "+r+";\n            }\n        }\n\n        .react-datepicker__day--today {\n            font-weight: 600;\n        }\n\n        .react-datepicker__day--disabled {\n            color: "+s+";\n            cursor: default;\n            background-color: transparent;\n\n            &:hover {\n                background-color: transparent;\n            }\n        }\n\n        .react-datepicker__day--outside-month {\n            color: "+s+";\n        }\n    "})),tve=function(e){var t=e.className,n=e.children;return i.createElement(eve,{className:t},n)},nve=function(e){return i.createElement(Sge,e)},rve=(0,i.createContext)({close:qT,dateFormat:"L",inline:!1,isInvalid:!1,isValid:!1,max:void 0,min:void 0,open:qT,onChange:qT,onInputBlur:qT,value:null,centeredDate:!1,showTodayButton:!1,brandTimezone:void 0,brandLocale:void 0});const ove=function(e){var r,o,a=e.dateFormat,s=void 0===a?"L":a,l=e.id,c=e.isDisabled,u=e.isInvalid,d=e.isValid,p=e.max,f=e.min,h=e.onChange,g=void 0===h?qT:h,v=e.placeholder,y=e.value,b=e.centeredDate,_=void 0!==b&&b,A=e.availabilities,E=void 0===A?[]:A,w=e.disableUnavailableDays,x=void 0!==w&&w,k=e.disabledDates,C=void 0===k?[]:k,S=e.inline,M=e.inputProps,T=e.showTodayButton,O=void 0!==T&&T,D=e.brandTimezone,L=e.brandLocale,P=e.invalidDateMessage,I=e.onValidityChange,B=t(e,qge),R=(0,i.useRef)(),N=m((0,i.useState)(!1),2),F=N[0],j=N[1],Y=(0,i.useRef)(""),$=n({},B);delete $.selected;var H=Co(),U=(0,i.useMemo)((function(){var e="undefined"!=typeof navigator&&"string"==typeof navigator.language?navigator.language:void 0;return function(e,t){var n,r,o=null!==(n=wge(e))&&void 0!==n?n:t,i="",a="",s=_ge(new Intl.DateTimeFormat(o,{year:"numeric",month:"2-digit",day:"2-digit"}).formatToParts(new Date(2023,0,2)));try{for(s.s();!(r=s.n()).done;){var l=r.value;switch(l.type){case"day":i+="dd",a+="DD";break;case"month":i+="MM",a+="MM";break;case"year":i+="yyyy",a+="YYYY";break;case"literal":i+=l.value,a+=l.value}}}catch(e){s.e(e)}finally{s.f()}return/d/.test(i)&&/M/.test(i)&&/y/.test(i)?{dateFnsFormat:i,hint:a}:xge}(L,e)}),[L]),z=U.dateFnsFormat,W=U.hint,V=(0,i.useMemo)((function(){if(P)return P;var e=H(Kge,{format:W,interpolation:{escapeValue:!1}});return e===Kge?"Enter a valid date ("+W+").":e}),[P,H,W]),G=y&&!Number.isNaN(y.getTime())?y:null,Q=(0,i.useCallback)((function(e){if(Y.current="",!Zge(e))return j(!0),null==I||I(!1),void g(null);j(!1),null==I||I(!0),g(e)}),[g,I]),q=(0,i.useCallback)((function(e){var t,n;Y.current=null!==(t=null==e||null===(n=e.target)||void 0===n?void 0:n.value)&&void 0!==t?t:""}),[]),K=(0,i.useCallback)((function(){var e=Y.current.trim();if(e){var t=bge(e,z,new Date);nme(t)&&Zge(t)||(j(!0),null==I||I(!1),g(null))}}),[g,I,z]),Z=null!==(r=null==D?void 0:D.trim())&&void 0!==r?r:"",J=G&&Z&&null!==(o=function(e){var t=e.trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);if(!t)return null;var n=parseInt(t[1],10),r=parseInt(t[2],10),o=parseInt(t[3],10);return[n,r,o].some((function(e){return Number.isNaN(e)}))?null:new Date(n,r-1,o)}(function(e,t){var n,r,o;if(!(e instanceof Date)||Number.isNaN(e.getTime()))return"";var i=t.trim();if(!i)return e.getFullYear()+"-"+String(e.getMonth()+1).padStart(2,"0")+"-"+String(e.getDate()).padStart(2,"0");var a=new Intl.DateTimeFormat("sv-SE",{timeZone:i,year:"numeric",month:"2-digit",day:"2-digit"}).formatToParts(e),s=null===(n=a.find((function(e){return"year"===e.type})))||void 0===n?void 0:n.value,l=null===(r=a.find((function(e){return"month"===e.type})))||void 0===r?void 0:r.value,c=null===(o=a.find((function(e){return"day"===e.type})))||void 0===o?void 0:o.value;if(s&&l&&c)return s+"-"+l.padStart(2,"0")+"-"+c.padStart(2,"0");var u,d,p,f,h=new Intl.DateTimeFormat("sv-SE",{timeZone:i,year:"numeric",month:"2-digit",day:"2-digit"}).format(e);return/^\d{4}-\d{1,2}-\d{1,2}$/.test(h)?(u=m(h.split("-"),3),d=u[0],p=u[1],f=u[2],d+"-"+p.padStart(2,"0")+"-"+f.padStart(2,"0")):h}(G,Z)))&&void 0!==o?o:G,X=J?Xge(J):"",ee=Lr().components.DatePicker.baseStyle,te=ee.color,ne=ee.borderColor,re=ee.borderRadius,oe=ee.boxShadow,ie=ee.popperBackgroundColor,ae=ee.calendarBackgroundColor,se=ee.headerBackgroundColor;return i.createElement(i.Fragment,null,i.createElement(Jge,{borderColor:ne,borderRadius:re,boxShadow:oe,popperBackgroundColor:ie||ae||se||"white"}),i.createElement(rve.Provider,{value:{close:function(){R&&R.current&&R.current.setOpen(!1)},dateFormat:s,inline:S,isInvalid:u||F,isValid:d,max:p,min:f,open:function(){R&&R.current&&R.current.setOpen(!0)},onChange:Q,onInputBlur:K,value:G,centeredDate:_,showTodayButton:O,brandTimezone:D,brandLocale:L}},i.createElement(KU(),n({},$,{calendarContainer:tve,customInput:i.createElement(Gge,M),dateFormat:z,disabled:c,filterDate:function(e){var t=Xge(e),n=C.includes(t),r=E[t],o=r&&r.length>0;return x?o&&!n:!n},id:l,inline:S,maxDate:p,minDate:f,onChange:Q,onChangeRaw:q,placeholderText:v,popperPlacement:"bottom-start",portalId:"sp-react-datepicker-portal",ref:R,renderCustomHeader:nve,renderDayContents:function(e,t){var n=Xge(t),r=E[n],o=r&&r.length>0,a=!!X&&!!t&&Xge(t)===X,s=o&&!a?"#141617":x&&!o&&((!f||t>=f)&&(!p||t<=p))?te:"";return i.createElement(_r,{gap:"10px",alignItems:"center",justifyContent:"center",flexDirection:"column",borderRadius:"50%",backgroundColor:o&&!a?"#EDF1F3":"transparent",color:s},e)},selected:J,shouldCloseOnSelect:!0,useWeekdaysShort:!0}))),!S&&F&&i.createElement(qr,{color:"red.500",fontSize:"sm",marginTop:"4px",role:"alert","data-testid":"datepicker-invalid-message"},V))};const ive=function(e){var t,r,o=e.brandId,a=e.isOpen,s=e.onClose,l=e.fromDashboard,c=zo("brand/"+o).response,u=Co(),d=m((0,i.useState)([]),2),p=d[0],f=d[1],h=m((0,i.useState)(new Date),2),g=h[0],v=h[1],y=m((0,i.useState)([]),2),b=y[0],_=y[1],A=jre({mode:"onTouched",defaultValues:{date:lme(g,"yyyy-MM-dd"),requiresPassword:!1,requiresPin:[!1,!1,!1,!1],name:"",password:"",freeDigitalPin:["","","",""],preset:0}}),E=A.control,w=A.formState,x=w.errors,k=w.isSubmitting,C=w.isValid,S=A.handleSubmit,M=A.register,T=A.watch,O=A.setValue,D=A.getValues,L=A.reset,P=T("preset");(0,i.useEffect)((function(){var e;if(p.length)if("public-password"===p[P].eventAccessLevel||"private-password"===p[P].eventAccessLevel?O("requiresPassword",!0):O("requiresPassword",!1),null!==(e=p[P])&&void 0!==e&&e.digitalRules.length){var t=D("requiresPin");p[P].digitalRules.forEach((function(e,n){e.requireDownloadPin?O("requiresPin",t.map((function(e,t){return t===n||e}))):O("requiresPin",t.map((function(e,t){return t===n&&e})))}))}else O("requiresPin",[!1,!1,!1,!1]),O("freeDigitalPin",["","","",""])}),[x,p,D,P,O]);var I=zo("brand/"+o+"/event",{defer:!0,method:Fo.POST}).performFetch,B=zo("brand/"+o+"/event-defaults?rows=100",{defer:!0}),R=B.response,N=B.performFetch;(0,i.useEffect)((function(){if(null!=R&&R.items){f(R.items);var e=R.items.findIndex((function(e){return e.isDefault}));e>=0&&O("preset",e),_(R.items.map((function(e,t){return{label:e.name,value:t}})))}}),[R,O]),(0,i.useEffect)((function(){a&&(N(),v(new Date))}),[a,N]);var F=(0,i.useCallback)((function(){s(),L()}),[s,L]),j=function(){var e=Lo(Io().mark((function e(t){var r,i,a,s,c,u,d,f,h,m,g;return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=t.date,i=t.name,a=t.password,s=t.freeDigitalPin,c=t.preset,u=t.requiresPassword,p.length&&(delete(f=JSON.parse(JSON.stringify(p[c]))).id,h=f.digitalRules.map((function(e,t){return delete e.id,e.requireDownloadPin?n({},e,{downloadPin:s[t]}):e})),d=n({},f,{digitalRules:h,isVolume:!1,eventDefaultsId:Number(c),eventDate:ume(r).toISOString(),name:i,type:"event"})),u&&a&&(d=n({},d,{eventPassword:a})),e.next=5,I({data:d});case 5:return 201===(null==(m=e.sent)?void 0:m.status)&&(F4("Gallery Created",{source:"Main/Side nav button"}),g="/v3/"+o+"/gallery/"+m.id,window.location.assign(l?g+"?from=dashboard":g),F()),e.abrupt("return",null);case 8:case"end":return e.stop()}}),e)})));return function(t){return e.apply(this,arguments)}}();return i.createElement(sB,{isOpen:a,onClose:F,blockScrollOnMount:!0,size:u9({base:"full",lg:"md"})},i.createElement(vF,null),i.createElement(uF,{borderRadius:u9({base:0,lg:"md"}),translate:"no",className:"notranslate"},i.createElement(dF,{fontWeight:"normal"},u("studio.event.createEventWizard.nameIt.title")),i.createElement(cB,{color:"gray.600",backgroundColor:"transparent",padding:0}),i.createElement("form",{onSubmit:S(j)},i.createElement(lB,{as:wr,flexDirection:"column",gap:"16px",marginTop:"8px"},i.createElement(wr,{justifyContent:"space-between",gap:"16px"},i.createElement(Mp,{isRequired:!0,isInvalid:!!x.name},i.createElement(Xp,null,u("studio.event.createEventWizard.nameIt.galleryName")),i.createElement(dz,n({"data-testid":"name-form-element"},M("name",{required:u("studio.event.createEventWizard.nameIt.galleryNameError")}),{placeholder:u("studio.event.createEventWizard.nameIt.eventNamePlaceholder"),height:"44px",sx:{"input&":{borderRadius:"md"}}})),i.createElement(tJ,null,null===(t=x.name)||void 0===t?void 0:t.message)),i.createElement(Mp,{isRequired:!0,isInvalid:!!x.date},i.createElement(Xp,{as:"span","data-testid":"datepicker-label"},u("studio.event.createEventWizard.nameIt.shootDate")),i.createElement(_r,{maxWidth:"200px"},i.createElement(Jne,{name:"date",control:E,rules:{required:!0},render:function(e){var t=e.field,n=t.value?new Date(t.value+"T00:00:00"):null,r=n&&!Number.isNaN(n.getTime())?n:null;return i.createElement(ove,{"data-testid":"datepicker-input",value:r,onChange:function(e){var n=e&&!Number.isNaN(e.getTime())?lme(e,"yyyy-MM-dd"):"";t.onChange(n)},onBlur:t.onBlur,isInvalid:!!x.date,showTodayButton:!0,brandTimezone:(null==c?void 0:c.timeZone)||void 0,brandLocale:wge(null==c?void 0:c.locale),inputProps:{bg:"white",height:"44px",sx:{"input&":{borderRadius:"md"}}}})}})),i.createElement(tJ,{"data-testid":"datepicker-error-msg"},u("studio.event.createEventWizard.nameIt.galleryDateError")))),i.createElement(Mp,null,i.createElement(Xp,null,u("studio.event.createEventWizard.nameIt.usePreset")),i.createElement(qZ,n({"data-testid":"preset-form-element"},M("preset",{required:u("studio.event.createEventWizard.nameIt.galleryPresetError")}),{borderRadius:"md",height:"44px",sx:{"select&":{padding:"0 0 0 16px"}},value:P}),b.map((function(e){return i.createElement("option",{key:e.value,value:e.value},e.label)})))),T("requiresPassword")&&i.createElement(Mp,{isRequired:!0,isInvalid:!!x.password},i.createElement(Xp,null,u("studio.event.createEventWizard.nameIt.requiredPassword")),i.createElement(dz,n({"data-testid":"password-form-element",isRequired:!0,placeholder:u("studio.event.createEventWizard.nameIt.requiredPasswordPlaceholder"),sx:{"input&":{borderRadius:"md"}}},M("password",{required:{value:!0,message:u("studio.event.createEventWizard.nameIt.requiredPasswordError")},shouldUnregister:!0}))),x.password?i.createElement(tJ,null,x.password.message):i.createElement(Tp,{"data-testid":"password-field-info"},u("studio.event.createEventWizard.nameIt.requiredPasswordInfo"))),T("requiresPin")&&(null===(r=p[P])||void 0===r?void 0:r.digitalRules.map((function(e,t){var r,o,a;return i.createElement(Mp,{key:t,isRequired:!0,isInvalid:!(null===(r=x.freeDigitalPin)||void 0===r||!r[t])},e.requireDownloadPin&&i.createElement(i.Fragment,null,i.createElement(Xp,{marginBottom:0,lineHeight:"25px"},u("studio.event.createEventWizard.nameIt.digitalRulePinLabel")),i.createElement(qr,{color:"gray.400",fontWeight:400,margin:0,marginTop:"-5px",lineHeight:"25px"},u("studio.event.createEventWizard.nameIt.digitalRulePinSubLabel",{name:e.name})),i.createElement(dz,n({"data-testid":"freeDigitalPin-"+t+"-form-element",isRequired:!0,defaultValue:"",sx:{"input&":{borderRadius:"md"}}},M("freeDigitalPin."+t,{required:{value:!0,message:u("studio.event.createEventWizard.nameIt.digitalRulePinError")},pattern:{value:/^[0-9]+$/,message:u("studio.event.createEventWizard.nameIt.digitalRulePinOnlyDigitsError")},minLength:{value:4,message:u("studio.event.createEventWizard.nameIt.digitalRulePinAtLeast4DigitsError")},maxLength:{value:8,message:u("studio.event.createEventWizard.nameIt.digitalRulePinAtMost8DigitsError")},shouldUnregister:!0}))),null!==(o=x.freeDigitalPin)&&void 0!==o&&o[t]?i.createElement(tJ,null,null===(a=x.freeDigitalPin)||void 0===a||null===(a=a[t])||void 0===a?void 0:a.message):i.createElement(Tp,{"data-testid":"freeDigitalPin-"+t+"-field-info"},u("studio.event.createEventWizard.nameIt.digitalRulePinHelper"))))})))),i.createElement(pF,{as:wr,gap:"16px",justifyContent:"flex-end"},i.createElement(P6,{"data-testid":"cancel-button",isDisabled:k,onClick:F,variant:"secondary",type:"reset"},u("studio.event.createEventWizard.nameIt.actionCancel")),i.createElement(P6,{"data-testid":"create-event-button",loadingText:u("studio.event.createEventWizard.nameIt.actionCreatingEvent"),isDisabled:!C||k,isLoading:k,type:"submit",variant:"primary"},u("studio.event.createEventWizard.nameIt.actionCreateEvent"))))))};var ave=fr(Wr,{shouldForwardProp:function(e){return"isSidebarCollapsed"!==e}})((function(e){var t=e.isSidebarCollapsed,n=e.theme;return"\n        &.chakra-button {\n            background: "+RJ+";\n            border: none;\n            justify-content: center;\n            text-align: center;\n            border-radius: 8px;\n            font-weight: 300;\n\n            "+(t?"\n                        width: 40px;\n                        padding: 0;\n                    ":"")+"\n\n            &:hover {\n                background: "+RJ+";\n            }\n        }\n\n        svg {\n            color: "+n.colors.white+";\n\n            "+n.responsive.smallScreenOnly("\n                display: none;\n            ")+"\n\n            "+n.responsive.mediumScreenUp("\n                "+(t?"":"display: none;")+"\n            ")+"\n        }\n\n        span {\n            color: "+n.colors.white+";\n            font-family: 'azo-sans-web', 'Helvetica', 'Arial', sans-serif;\n            font-size: 14px;\n            letter-spacing: initial;\n            line-height: 16px;\n            "+n.responsive.mediumScreenUp("\n                "+(t?"display: none;":"")+"\n            ")+"\n        }\n    "}));const sve=function(e){var t=e.currentBrandId,n=e.href,r=e.isSidebarCollapsed,o=Co("studio.nav"),a=m((0,i.useState)(!1),2),s=a[0],l=a[1],c=(0,i.useCallback)((function(e){e.preventDefault(),l(!0)}),[]),u=(0,i.useCallback)((function(){l(!1)}),[]);return i.createElement(i.Fragment,null,i.createElement(Zw,{placement:"right",variant:"bold",label:r?o("link.createGallery"):""},i.createElement(Kr,{"data-testid":"nav-sidebar-button-create-gallery-link",href:n,padding:r?"12px 16px":"12px 20px 24px 20px",marginBottom:r?"12px":void 0},i.createElement(ave,{"data-testid":"nav-sidebar-button-create-gallery",isSidebarCollapsed:r,onClick:c,_focus:{boxShadow:"none"}},i.createElement(the,null),i.createElement("span",null,o("link.createGallery"))))),i.createElement(ive,{onClose:u,isOpen:s,brandId:t}))};var lve,cve,uve=["title","titleId"];function dve(){return dve=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},dve.apply(null,arguments)}var pve=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,uve);return i.createElement("svg",dve({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,lve||(lve=i.createElement("path",{d:"M16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11C14.2091 11 16 9.20914 16 7Z",fill:"currentColor"})),cve||(cve=i.createElement("path",{d:"M20 21V18.5714C20 17.5106 19.5786 16.4932 18.8284 15.743C18.0783 14.9929 17.0609 14.5714 16 14.5714H8C6.93913 14.5714 5.92172 14.9929 5.17157 15.743C4.42143 16.4932 4 17.5106 4 18.5714V21",fill:"currentColor"})))},fve=(0,i.forwardRef)(pve);o.p;var hve,mve,gve,vve=["title","titleId"];function yve(){return yve=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},yve.apply(null,arguments)}var bve=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,vve);return i.createElement("svg",yve({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,hve||(hve=i.createElement("path",{d:"M5.66342 17.0004L5.53076 17.7528C5.43865 18.2752 5.55783 18.8127 5.86206 19.2472C6.1663 19.6817 6.63067 19.9776 7.15304 20.0697L17.9258 21.9692C18.4482 22.0613 18.9858 21.9422 19.4203 21.6379C19.8548 21.3337 20.1506 20.8693 20.2427 20.3469L21.9693 10.5549C22.0149 10.2963 22.0092 10.0312 21.9523 9.77475C21.8955 9.51832 21.7887 9.2756 21.6381 9.06045C21.4874 8.84529 21.2959 8.66192 21.0744 8.52079C20.8528 8.37967 20.6057 8.28355 20.347 8.23794L17.0217 7.65161",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})),mve||(mve=i.createElement("path",{d:"M4 2H15C15.2627 1.99993 15.5228 2.05161 15.7655 2.1521C16.0081 2.25258 16.2286 2.3999 16.4144 2.58563C16.6001 2.77136 16.7474 2.99187 16.8479 3.23455C16.9484 3.47723 17.0001 3.73734 17 4V15C17.0001 15.2627 16.9484 15.5228 16.8479 15.7655C16.7474 16.0081 16.6001 16.2286 16.4144 16.4144C16.2286 16.6001 16.0081 16.7474 15.7655 16.8479C15.5228 16.9484 15.2627 17.0001 15 17H4C3.73734 17.0001 3.47723 16.9484 3.23455 16.8479C2.99186 16.7474 2.77135 16.6001 2.58562 16.4144C2.39989 16.2286 2.25257 16.0081 2.15209 15.7655C2.05161 15.5228 1.99993 15.2627 2 15V4C2.00003 3.46958 2.21075 2.96088 2.58582 2.58582C2.96088 2.21075 3.46958 2.00003 4 2Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})),gve||(gve=i.createElement("path",{d:"M17 12H2",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})))},_ve=(0,i.forwardRef)(bve);o.p;var Ave,Eve,wve=["title","titleId"];function xve(){return xve=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},xve.apply(null,arguments)}var kve=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,wve);return i.createElement("svg",xve({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Ave||(Ave=i.createElement("g",{clipPath:"url(#clip0_1395_37170)"},i.createElement("path",{d:"M11.0801 7.38857C11.1648 7.2169 11.2959 7.07236 11.4584 6.97129C11.621 6.87022 11.8086 6.81665 12 6.81665C12.1914 6.81665 12.379 6.87022 12.5416 6.97129C12.7041 7.07236 12.8351 7.2169 12.9198 7.38857L13.6702 8.90967C13.7438 9.05882 13.8525 9.18785 13.9871 9.28563C14.1216 9.3834 14.2779 9.44699 14.4425 9.47092L16.1207 9.71484C16.3101 9.74236 16.488 9.8223 16.6343 9.94564C16.7806 10.069 16.8895 10.2308 16.9486 10.4128C17.0078 10.5947 17.0148 10.7896 16.969 10.9754C16.9232 11.1612 16.8263 11.3305 16.6894 11.4641L15.4747 12.6488C15.3557 12.7649 15.2667 12.9082 15.2153 13.0663C15.164 13.2244 15.1518 13.3926 15.1799 13.5565L15.4666 15.2277C15.499 15.4163 15.4779 15.6102 15.4058 15.7875C15.3337 15.9648 15.2135 16.1183 15.0586 16.2308C14.9038 16.3433 14.7206 16.4102 14.5298 16.4241C14.3389 16.4379 14.148 16.398 13.9786 16.309L12.4772 15.52C12.33 15.4426 12.1662 15.4022 12 15.4022C11.8337 15.4022 11.67 15.4426 11.5228 15.52L10.0214 16.3091C9.85201 16.3981 9.66108 16.438 9.4702 16.4242C9.27932 16.4103 9.09612 16.3434 8.9413 16.2309C8.78649 16.1184 8.66623 15.9648 8.59414 15.7876C8.52204 15.6103 8.50098 15.4164 8.53334 15.2277L8.81998 13.5565C8.84809 13.3926 8.83595 13.2244 8.78461 13.0663C8.73326 12.9082 8.64425 12.7649 8.52524 12.6488L7.31061 11.4641C7.17363 11.3305 7.07675 11.1612 7.03093 10.9754C6.98512 10.7896 6.99219 10.5947 7.05134 10.4128C7.1105 10.2308 7.21938 10.069 7.36569 9.94564C7.51199 9.8223 7.68988 9.74236 7.87924 9.71484L9.55747 9.47092C9.72206 9.44699 9.87837 9.3834 10.0129 9.28563C10.1475 9.18785 10.2562 9.05882 10.3298 8.90967L11.0801 7.38857Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M21.0327 9.06506L20.0291 9.39119",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M3.97099 14.6088L2.96729 14.9349",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M12 21.5V20.4445",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M12 2.5V3.55556",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M17.5784 19.678L16.9586 18.8249",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M6.42163 4.32196L7.0414 5.17509",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M2.96729 9.06506L3.97099 9.39119",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M21.0328 14.9349L20.0291 14.6088",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M17.5784 4.32196L16.9586 5.17509",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M6.42163 19.678L7.0414 18.8249",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),Eve||(Eve=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1395_37170"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},Cve=(0,i.forwardRef)(kve);o.p;var Sve,Mve,Tve,Ove=["title","titleId"];function Dve(){return Dve=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Dve.apply(null,arguments)}var Lve=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Ove);return i.createElement("svg",Dve({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Sve||(Sve=i.createElement("path",{d:"M0 18.6667C1.41449 18.6667 2.77104 19.2286 3.77124 20.2288C4.77143 21.229 5.33333 22.5855 5.33333 24C5.33333 22.5855 5.89524 21.229 6.89543 20.2288C7.89563 19.2286 9.25218 18.6667 10.6667 18.6667C9.25218 18.6667 7.89563 18.1048 6.89543 17.1046C5.89524 16.1044 5.33333 14.7478 5.33333 13.3333C5.33333 14.7478 4.77143 16.1044 3.77124 17.1046C2.77104 18.1048 1.41449 18.6667 0 18.6667Z",fill:"currentColor"})),Mve||(Mve=i.createElement("path",{d:"M13.3334 14.6667C14.7479 14.6667 16.1044 15.2286 17.1046 16.2288C18.1048 17.229 18.6667 18.5855 18.6667 20C18.6667 18.5855 19.2286 17.229 20.2288 16.2288C21.229 15.2286 22.5856 14.6667 24 14.6667C22.5856 14.6667 21.229 14.1048 20.2288 13.1046C19.2286 12.1044 18.6667 10.7478 18.6667 9.33333C18.6667 10.7478 18.1048 12.1044 17.1046 13.1046C16.1044 14.1048 14.7479 14.6667 13.3334 14.6667Z",fill:"currentColor"})),Tve||(Tve=i.createElement("path",{d:"M5.33337 5.33333C6.74786 5.33333 8.10442 5.89524 9.10461 6.89543C10.1048 7.89563 10.6667 9.25218 10.6667 10.6667C10.6667 9.25218 11.2286 7.89563 12.2288 6.89543C13.229 5.89524 14.5856 5.33333 16 5.33333C14.5856 5.33333 13.229 4.77143 12.2288 3.77124C11.2286 2.77104 10.6667 1.41449 10.6667 0C10.6667 1.41449 10.1048 2.77104 9.10461 3.77124C8.10442 4.77143 6.74786 5.33333 5.33337 5.33333Z",fill:"currentColor"})))},Pve=(0,i.forwardRef)(Lve);o.p;var Ive,Bve,Rve=["title","titleId"];function Nve(){return Nve=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Nve.apply(null,arguments)}var Fve=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Rve);return i.createElement("svg",Nve({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Ive||(Ive=i.createElement("g",{clipPath:"url(#clip0_1395_37142)"},i.createElement("path",{d:"M8.00001 12C9.92748 12 11.49 10.4375 11.49 8.51002C11.49 6.58255 9.92748 5.02002 8.00001 5.02002C6.07254 5.02002 4.51001 6.58255 4.51001 8.51002C4.51001 10.4375 6.07254 12 8.00001 12Z",stroke:"currentColor",strokeMiterlimit:10,strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M17 12C18.3807 12 19.5 10.8807 19.5 9.5C19.5 8.11929 18.3807 7 17 7C15.6193 7 14.5 8.11929 14.5 9.5C14.5 10.8807 15.6193 12 17 12Z",stroke:"currentColor",strokeMiterlimit:10,strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M2 20V18.983C2 16.783 3.783 15 5.983 15H10.017C12.217 15 14 16.783 14 18.983V20",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M17 15H18.102C20.302 15 22.085 16.783 22.085 18.983V20",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),Bve||(Bve=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1395_37142"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},jve=(0,i.forwardRef)(Fve);o.p;var Yve,$ve,Hve=["title","titleId"];function Uve(){return Uve=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Uve.apply(null,arguments)}var zve=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Hve);return i.createElement("svg",Uve({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Yve||(Yve=i.createElement("g",{clipPath:"url(#clip0_1253_7293)"},i.createElement("path",{d:"M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M11 15.5H13.3093",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M12.159 15.5V11.25H11.009",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M12.1 8.24725C12.1 8.2967 12.0853 8.34503 12.0578 8.38615C12.0304 8.42726 11.9913 8.4593 11.9456 8.47822C11.9 8.49714 11.8497 8.5021 11.8012 8.49245C11.7527 8.4828 11.7082 8.45899 11.6732 8.42403C11.6382 8.38907 11.6144 8.34452 11.6048 8.29603C11.5951 8.24753 11.6001 8.19726 11.619 8.15158C11.6379 8.1059 11.67 8.06686 11.7111 8.03939C11.7522 8.01192 11.8005 7.99725 11.85 7.99725",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M11.85 7.99725C11.9163 7.99725 11.9799 8.02359 12.0268 8.07048C12.0736 8.11736 12.1 8.18095 12.1 8.24725",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),$ve||($ve=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1253_7293"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},Wve=(0,i.forwardRef)(zve);o.p;var Vve,Gve,Qve=["title","titleId"];function qve(){return qve=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},qve.apply(null,arguments)}var Kve=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Qve);return i.createElement("svg",qve({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Vve||(Vve=i.createElement("g",{clipPath:"url(#clip0_1448_2231)"},i.createElement("path",{d:"M3 3H10V10H3V3Z",fill:"currentColor"}),i.createElement("path",{d:"M14 3H21V10H14V3Z",fill:"currentColor"}),i.createElement("path",{d:"M3 14H10V21H3V14Z",fill:"currentColor"}),i.createElement("path",{d:"M14 14H21V21H14V14Z",fill:"currentColor"}))),Gve||(Gve=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1448_2231"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},Zve=(0,i.forwardRef)(Kve);o.p;var Jve,Xve,eye=["title","titleId"];function tye(){return tye=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},tye.apply(null,arguments)}var nye=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,eye);return i.createElement("svg",tye({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Jve||(Jve=i.createElement("g",{clipPath:"url(#clip0_1395_37247)"},i.createElement("path",{d:"M18 21H6C4.343 21 3 19.657 3 18V6C3 4.343 4.343 3 6 3H18C19.657 3 21 4.343 21 6V18C21 19.657 19.657 21 18 21Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M14.333 10.667L12 13L9.66699 10.667",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M12 8V13",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M16.5 16L16.0858 16.4142C15.9001 16.5999 15.6796 16.7472 15.4369 16.8478C15.1943 16.9483 14.9342 17 14.6716 17H9.32843C9.06579 17 8.80571 16.9483 8.56306 16.8478C8.32041 16.7472 8.09993 16.5999 7.91421 16.4142L7.5 16",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),Xve||(Xve=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1395_37247"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},rye=(0,i.forwardRef)(nye);o.p;var oye,iye,aye=["title","titleId"];function sye(){return sye=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},sye.apply(null,arguments)}var lye=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,aye);return i.createElement("svg",sye({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,oye||(oye=i.createElement("g",{clipPath:"url(#clip0_1395_37185)"},i.createElement("path",{d:"M3 6.8C3 7.4 3.3 7.9 3.8 8.3L9.8 12.4C11.2 13.3 12.9 13.3 14.3 12.4L20.3 8.4C20.7 7.9 21 7.4 21 6.8C21 5.8 20.2 5 19.2 5H4.8C3.8 5 3 5.8 3 6.8Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M3 7V17C3 18.1 3.9 19 5 19H19C20.1 19 21 18.1 21 17V7",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M3.59998 18.4L9.69998 12.3",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M14.3 12.3L20.4 18.4",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),iye||(iye=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1395_37185"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},cye=(0,i.forwardRef)(lye);o.p;var uye,dye,pye=["title","titleId"];function fye(){return fye=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},fye.apply(null,arguments)}var hye=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,pye);return i.createElement("svg",fye({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,uye||(uye=i.createElement("g",{clipPath:"url(#clip0_1395_37222)"},i.createElement("path",{d:"M18 21H6C4.343 21 3 19.657 3 18V6C3 4.343 4.343 3 6 3H18C19.657 3 21 4.343 21 6V18C21 19.657 19.657 21 18 21Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M13.9116 7.65925C14.7906 8.53825 14.7906 9.96225 13.9116 10.8412C13.0326 11.7202 11.6086 11.7202 10.7296 10.8412C9.85056 9.96225 9.85056 8.53825 10.7296 7.65925C11.6086 6.78025 13.0326 6.78025 13.9116 7.65925Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M16.642 16.5414C16.421 15.1524 15.227 14.0884 13.777 14.0884H10.865C9.414 14.0884 8.221 15.1524 8 16.5414",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),dye||(dye=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1395_37222"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},mye=(0,i.forwardRef)(hye);o.p;var gye,vye,yye=["title","titleId"];function bye(){return bye=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},bye.apply(null,arguments)}var _ye=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,yye);return i.createElement("svg",bye({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,gye||(gye=i.createElement("g",{clipPath:"url(#clip0_1404_84328)"},i.createElement("path",{d:"M6.99997 3C6.46954 3 5.96083 3.21071 5.58575 3.58579C5.21068 3.96086 4.99997 4.46957 4.99997 5V8.55243C4.63683 8.47794 4.26167 8.48519 3.90168 8.57366C3.54169 8.66212 3.20589 8.82958 2.91864 9.06389C2.63138 9.2982 2.39987 9.5935 2.24087 9.92837C2.08188 10.2632 1.99939 10.6293 1.99939 11C1.99939 11.3707 2.08188 11.7368 2.24087 12.0716C2.39987 12.4065 2.63138 12.7018 2.91864 12.9361C3.20589 13.1704 3.54169 13.3379 3.90168 13.4263C4.26167 13.5148 4.63683 13.5221 4.99997 13.4476V17C4.99997 17.5304 5.21068 18.0391 5.58575 18.4142C5.96083 18.7893 6.46954 19 6.99997 19H10.5524C10.4779 19.3631 10.4852 19.7383 10.5736 20.0983C10.6621 20.4583 10.8295 20.7941 11.0639 21.0813C11.2982 21.3686 11.5935 21.6001 11.9283 21.7591C12.2632 21.9181 12.6293 22.0006 13 22.0006C13.3707 22.0006 13.7367 21.9181 14.0716 21.7591C14.4065 21.6001 14.7018 21.3686 14.9361 21.0813C15.1704 20.7941 15.3378 20.4583 15.4263 20.0983C15.5148 19.7383 15.522 19.3631 15.4475 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V13.4476C20.6368 13.5221 20.2617 13.5148 19.9017 13.4263C19.5417 13.3379 19.2059 13.1704 18.9186 12.9361C18.6314 12.7018 18.3999 12.4065 18.2409 12.0716C18.0819 11.7368 17.9994 11.3707 17.9994 11C17.9994 10.6293 18.0819 10.2632 18.2409 9.92837C18.3999 9.5935 18.6314 9.2982 18.9186 9.06389C19.2059 8.82958 19.5417 8.66212 19.9017 8.57366C20.2617 8.48519 20.6368 8.47794 21 8.55243V5C21 4.46957 20.7893 3.96086 20.4142 3.58579C20.0391 3.21071 19.5304 3 19 3H6.99997Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),vye||(vye=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1404_84328"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},Aye=(0,i.forwardRef)(_ye);o.p;var Eye,wye,xye=["title","titleId"];function kye(){return kye=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},kye.apply(null,arguments)}var Cye=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,xye);return i.createElement("svg",kye({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Eye||(Eye=i.createElement("g",{clipPath:"url(#clip0_1395_37263)"},i.createElement("path",{d:"M18 21H6C4.343 21 3 19.657 3 18V6C3 4.343 4.343 3 6 3H18C19.657 3 21 4.343 21 6V18C21 19.657 19.657 21 18 21Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M10 13.25H11.5",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M10 10.75H11.5",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M10.3333 7.71503L11.5577 7.10551C11.6967 7.03631 11.8499 7.00043 12.0052 7.00072C12.1604 7.001 12.3135 7.03743 12.4522 7.10713L13.6618 7.71477L14.8978 7.10361C15.0366 7.03497 15.1894 6.99951 15.3443 7.00001C15.4991 7.0005 15.6517 7.03695 15.7901 7.10648L16.4491 7.43763C16.6147 7.52087 16.7539 7.64851 16.8512 7.8063C16.9485 7.96409 17 8.14581 17 8.33118V15.6686C17 15.854 16.9485 16.0357 16.8512 16.1935C16.7539 16.3513 16.6146 16.4789 16.449 16.5621L15.79 16.8933C15.6516 16.9628 15.499 16.9993 15.3442 16.9998C15.1894 17.0003 15.0365 16.9648 14.8977 16.8962L13.6618 16.285H13.6667L12.4423 16.8945C12.3033 16.9637 12.1501 16.9996 11.9948 16.9993C11.8396 16.9991 11.6865 16.9626 11.5478 16.8929L10.3382 16.2853L9.10223 16.8964C8.96343 16.9651 8.81059 17.0006 8.65575 17.0001C8.50091 16.9996 8.34829 16.9631 8.20994 16.8936L7.55094 16.5624C7.38531 16.4792 7.24608 16.3515 7.14879 16.1938C7.05151 16.036 6.99999 15.8542 7 15.6689V8.33144C7 8.14607 7.05153 7.96435 7.14883 7.80657C7.24613 7.64878 7.38537 7.52115 7.551 7.43792L8.21 7.10677C8.34835 7.03724 8.50097 7.00079 8.65581 7.0003C8.81065 6.9998 8.96349 7.03526 9.10229 7.1039L10.3382 7.71506",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M14.0051 13.2501L14.0001 13.2551L13.9951 13.2501L14.0001 13.2451L14.0051 13.2501Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M14.0051 10.7501L14.0001 10.7551L13.9951 10.7501L14.0001 10.7451L14.0051 10.7501Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),wye||(wye=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1395_37263"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},Sye=(0,i.forwardRef)(Cye);o.p;var Mye,Tye,Oye,Dye=["title","titleId"];function Lye(){return Lye=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Lye.apply(null,arguments)}var Pye=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Dye);return i.createElement("svg",Lye({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Mye||(Mye=i.createElement("path",{d:"M21 11.25L8.5 11.25C8.09 11.25 7.75 11.59 7.75 12C7.75 12.42 8.09 12.75 8.5 12.75L21 12.75C21.42 12.75 21.75 12.42 21.75 12C21.75 11.59 21.42 11.25 21 11.25Z",fill:"currentColor"})),Tye||(Tye=i.createElement("path",{d:"M15.25 16L15.25 17.67C15.26 18.29 14.81 18.81 14.21 18.91L6.21997 20.25C5.53996 20.37 4.89997 19.91 4.78997 19.23C4.77997 19.17 4.77997 19.1 4.77997 19.03L4.78097 5.04C4.78097 4.35 5.34097 3.79 6.03097 3.79C6.10097 3.79 6.17097 3.8 6.24097 3.81L14.251 5.15C14.861 5.26 15.301 5.78 15.301 6.39L15.301 8.06C15.301 8.48 15.641 8.81 16.051 8.81C16.471 8.81 16.801 8.48 16.801 8.06L16.801 6.4C16.801 5.06 15.831 3.91 14.511 3.69L6.51097 2.36C6.37097 2.34 6.21097 2.33 6.06097 2.33C4.55097 2.34 3.32097 3.57 3.32097 5.09L3.32097 19.09C3.32097 19.25 3.34097 19.4 3.36097 19.55C3.61097 21.05 5.03097 22.07 6.53097 21.82L14.531 20.49C15.861 20.27 16.831 19.13 16.831 17.78L16.84 16.12C16.84 15.71 16.51 15.37 16.09 15.37C15.68 15.37 15.34 15.71 15.34 16.12L15.25 16Z",fill:"currentColor"})),Oye||(Oye=i.createElement("path",{d:"M12.04 14.47L9.04002 11.47L9.04002 12.54L12.04 9.54C12.34 9.25 12.34 8.78 12.04 8.48C11.75 8.19 11.28 8.19 10.98 8.48L7.98002 11.48C7.69002 11.78 7.69002 12.25 7.98002 12.55L10.98 15.55C11.28 15.85 11.75 15.85 12.05 15.55C12.35 15.26 12.35 14.79 12.05 14.49L12.04 14.47Z",fill:"currentColor"})))},Iye=(0,i.forwardRef)(Pye);o.p;var Bye,Rye,Nye=["title","titleId"];function Fye(){return Fye=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Fye.apply(null,arguments)}var jye=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Nye);return i.createElement("svg",Fye({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Bye||(Bye=i.createElement("g",{clipPath:"url(#clip0_1395_37308)"},i.createElement("path",{d:"M18 5V19C18 20.105 17.105 21 16 21H8C6.895 21 6 20.105 6 19V5C6 3.895 6.895 3 8 3H16C17.105 3 18 3.895 18 5Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M6.09998 17H18",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M13.232 7C14.29 7 15 7.931 15 8.798C15 10.559 12.054 12 12 12C11.946 12 9 10.559 9 8.798C9 7.931 9.71 7 10.768 7C11.373 7 11.77 7.283 12 7.535C12.23 7.283 12.627 7 13.232 7Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),Rye||(Rye=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1395_37308"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},Yye=(0,i.forwardRef)(jye);o.p;var $ye,Hye,Uye=["title","titleId"];function zye(){return zye=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},zye.apply(null,arguments)}var Wye=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Uye);return i.createElement("svg",zye({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,$ye||($ye=i.createElement("g",{clipPath:"url(#clip0_1395_37293)"},i.createElement("path",{d:"M8.5 17.781V7.96403C8.5 7.54903 8.756 7.17703 9.144 7.03003L17.644 3.79203C18.299 3.54203 19 4.02603 19 4.72603V15.775",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M18.2678 13.7322C19.2441 14.7085 19.2441 16.2915 18.2678 17.2678C17.2915 18.2441 15.7085 18.2441 14.7322 17.2678C13.7559 16.2915 13.7559 14.7085 14.7322 13.7322C15.7085 12.7559 17.2915 12.7559 18.2678 13.7322Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M7.76776 16.0073C8.74407 16.9836 8.74407 18.5665 7.76776 19.5428C6.79145 20.5191 5.20854 20.5191 4.23223 19.5428C3.25592 18.5665 3.25592 16.9836 4.23223 16.0073C5.20854 15.0309 6.79145 15.0309 7.76776 16.0073Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),Hye||(Hye=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1395_37293"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},Vye=(0,i.forwardRef)(Wye);o.p;var Gye,Qye,qye=["title","titleId"];function Kye(){return Kye=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Kye.apply(null,arguments)}var Zye=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,qye);return i.createElement("svg",Kye({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Gye||(Gye=i.createElement("g",{clipPath:"url(#clip0_1395_37238)"},i.createElement("path",{d:"M18 21H6C4.343 21 3 19.657 3 18V6C3 4.343 4.343 3 6 3H18C19.657 3 21 4.343 21 6V18C21 19.657 19.657 21 18 21Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M15.5058 16.542C15.3798 16.542 15.2768 16.644 15.2788 16.771C15.2788 16.897 15.3808 17 15.5078 17C15.6348 17 15.7368 16.898 15.7368 16.771C15.7348 16.644 15.6318 16.542 15.5058 16.542Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M10.248 16.542C10.122 16.542 10.019 16.644 10.021 16.771C10.02 16.897 10.123 17 10.249 17C10.375 17 10.478 16.898 10.478 16.771C10.478 16.644 10.375 16.542 10.248 16.542Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M8.484 8.875H16.375C16.782 8.875 17.08 9.257 16.981 9.652L16.139 13.022C16.011 13.534 15.576 13.91 15.051 13.963L10.791 14.389C10.156 14.452 9.575 14.028 9.444 13.404L8.078 7H7",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),Qye||(Qye=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1395_37238"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},Jye=(0,i.forwardRef)(Zye);o.p;var Xye,ebe,tbe=["title","titleId"];function nbe(){return nbe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},nbe.apply(null,arguments)}var rbe=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,tbe);return i.createElement("svg",nbe({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Xye||(Xye=i.createElement("g",{clipPath:"url(#clip0_1395_37196)"},i.createElement("path",{d:"M3 9H21",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M18.2803 15.6137C18.2943 15.6007 18.3132 15.5936 18.3323 15.5944C18.3515 15.5951 18.3696 15.6034 18.3826 15.6175C18.3957 15.6315 18.4026 15.6502 18.4019 15.6694C18.4012 15.6885 18.3929 15.7066 18.3788 15.7197C18.3648 15.7328 18.3461 15.7397 18.3269 15.739C18.3077 15.7383 18.2896 15.73 18.2766 15.7159C18.2635 15.7019 18.2566 15.6832 18.2572 15.6641C18.2579 15.6449 18.2662 15.6268 18.2803 15.6137Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M17.4 21C17.4283 20.8161 17.4431 20.6304 17.4444 20.4444C17.4444 19.413 17.0347 18.4239 16.3054 17.6946C15.5761 16.9653 14.587 16.5555 13.5556 16.5555C13.3696 16.5572 13.1839 16.5721 13 16.6",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M13 15.5V18.5C13 19.163 13.2634 19.7989 13.7322 20.2678C14.2011 20.7366 14.837 21 15.5 21H18.5C19.163 21 19.7989 20.7366 20.2678 20.2678C20.7366 19.7989 21 19.163 21 18.5V15.5C21 14.837 20.7366 14.2011 20.2678 13.7322C19.7989 13.2634 19.163 13 18.5 13H15.5C14.837 13 14.2011 13.2634 13.7322 13.7322C13.2634 14.2011 13 14.837 13 15.5Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M11 5.995L10.995 6L11 6.005L11.005 6L11 5.995Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M8.5 5.995L8.495 6L8.5 6.005L8.505 6L8.5 5.995Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M6 5.995L5.995 6L6 6.005L6.005 6L6 5.995Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M11 5.995L10.995 6L11 6.005L11.005 6L11 5.995Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M8.5 5.995L8.495 6L8.5 6.005L8.505 6L8.5 5.995Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M6 5.995L5.995 6L6 6.005L6.005 6L6 5.995Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M10 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7956 3 18V6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H18C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V10",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),ebe||(ebe=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1395_37196"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},obe=(0,i.forwardRef)(rbe);o.p;var ibe,abe,sbe,lbe,cbe=["title","titleId"];function ube(){return ube=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},ube.apply(null,arguments)}var dbe=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,cbe);return i.createElement("svg",ube({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,ibe||(ibe=i.createElement("path",{d:"M8 21H16C18.7614 21 21 18.7614 21 16V8C21 5.23858 18.7614 3 16 3H8C5.23858 3 3 5.23858 3 8V16C3 18.7614 5.23858 21 8 21Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})),abe||(abe=i.createElement("path",{d:"M12 7.5V8.5",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})),sbe||(sbe=i.createElement("path",{d:"M12 16.5V15.5",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})),lbe||(lbe=i.createElement("path",{d:"M9.8587 14.25C10.052 14.6468 10.3586 14.9773 10.7398 15.1998C11.1209 15.4223 11.5595 15.5268 12 15.5C12.5289 15.5578 13.0595 15.4074 13.4795 15.0807C13.8994 14.7541 14.1758 14.2768 14.25 13.75C14.25 13.3834 14.123 13.0282 13.8906 12.7447C13.6582 12.4612 13.3347 12.267 12.9753 12.1951L11.0247 11.805C10.6653 11.7331 10.3418 11.5389 10.1094 11.2554C9.87701 10.9719 9.75 10.6166 9.75 10.25C9.82423 9.72318 10.1006 9.24592 10.5205 8.91929C10.9405 8.59265 11.4711 8.44228 12 8.50002C12.4405 8.47326 12.8791 8.57774 13.2602 8.80024C13.6414 9.02273 13.948 9.35326 14.1413 9.75002",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"})))},pbe=(0,i.forwardRef)(dbe);o.p;var fbe,hbe,mbe=["title","titleId"];function gbe(){return gbe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},gbe.apply(null,arguments)}var vbe=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,mbe);return i.createElement("svg",gbe({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,fbe||(fbe=i.createElement("g",{clipPath:"url(#clip0_1395_37256)"},i.createElement("path",{d:"M18 21H6C4.343 21 3 19.657 3 18V6C3 4.343 4.343 3 6 3H18C19.657 3 21 4.343 21 6V18C21 19.657 19.657 21 18 21Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M7.15587 13.365L8.65987 10.979C9.00887 10.426 9.78587 10.351 10.2339 10.827L11.3089 11.969L12.4359 9.57405C12.7829 8.83605 13.8209 8.80205 14.2159 9.51605L16.3699 13.414C16.7379 14.081 16.2549 14.898 15.4939 14.898H8.00187C7.21387 14.898 6.73587 14.031 7.15587 13.365Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),hbe||(hbe=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1395_37256"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},ybe=(0,i.forwardRef)(vbe);o.p;var bbe,_be,Abe=["title","titleId"];function Ebe(){return Ebe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Ebe.apply(null,arguments)}var wbe=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Abe);return i.createElement("svg",Ebe({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,bbe||(bbe=i.createElement("g",{clipPath:"url(#clip0_1403_84319)"},i.createElement("path",{d:"M4.00003 19C3.99784 18.4769 4.0987 17.9585 4.29686 17.4744C4.49501 16.9903 4.78658 16.5499 5.15492 16.1785C5.52326 15.807 5.96114 15.5118 6.44358 15.3096C6.92602 15.1074 7.44357 15.0022 7.96667 15C7.97778 15 7.9889 15 8.00003 15H10.3111",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M13 16.4904C13.0485 17.491 13.4474 18.4427 14.127 19.1788C14.6698 19.8093 15.3174 20.3412 16.0414 20.751C16.3508 20.9237 16.7012 21.0093 17.0554 20.9989C17.4096 20.9884 17.7543 20.8823 18.0531 20.6918C18.7093 20.2723 19.2993 19.7574 19.8036 19.164C20.4958 18.4354 20.9179 17.492 21 16.4904C21.0048 15.8945 20.782 15.3193 20.3771 14.8821C20.1846 14.6724 19.951 14.5045 19.6909 14.3889C19.4307 14.2733 19.1496 14.2124 18.8649 14.2101C18.5094 14.1852 18.1534 14.2505 17.8298 14.3998C17.5062 14.5491 17.2255 14.7776 17.0138 15.0643L17.0001 15.0843L16.9862 15.0643C16.7933 14.7929 16.5367 14.573 16.239 14.4241C15.9412 14.2751 15.6114 14.2016 15.2785 14.2101C14.9777 14.205 14.679 14.2605 14.4001 14.3733C14.1213 14.4861 13.868 14.6539 13.6553 14.8667C13.4427 15.0795 13.2751 15.333 13.1625 15.6119C13.0499 15.8909 12.9946 16.1896 13 16.4904Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M12 11.5C14.3472 11.5 16.25 9.59721 16.25 7.25C16.25 4.90279 14.3472 3 12 3C9.65279 3 7.75 4.90279 7.75 7.25C7.75 9.59721 9.65279 11.5 12 11.5Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),_be||(_be=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1403_84319"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},xbe=(0,i.forwardRef)(wbe);o.p;var kbe,Cbe,Sbe=["title","titleId"];function Mbe(){return Mbe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Mbe.apply(null,arguments)}var Tbe=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Sbe);return i.createElement("svg",Mbe({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,kbe||(kbe=i.createElement("g",{clipPath:"url(#clip0_1395_83672)"},i.createElement("path",{d:"M22 21L18 21L18 3L22 3L22 21Z",fill:"currentColor"}),i.createElement("path",{d:"M14 21.0002L10 21.0002L10 8.68418L14 8.68418L14 21.0002Z",fill:"currentColor"}),i.createElement("path",{d:"M6 21.0005L2 21.0005L2 14.3685L6 14.3685L6 21.0005Z",fill:"currentColor"}))),Cbe||(Cbe=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1395_83672"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},Obe=(0,i.forwardRef)(Tbe);o.p;var Dbe,Lbe,Pbe=["title","titleId"];function Ibe(){return Ibe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Ibe.apply(null,arguments)}var Bbe=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Pbe);return i.createElement("svg",Ibe({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Dbe||(Dbe=i.createElement("g",{clipPath:"url(#clip0_1395_37230)"},i.createElement("path",{d:"M18 21H6C4.343 21 3 19.657 3 18V6C3 4.343 4.343 3 6 3H18C19.657 3 21 4.343 21 6V18C21 19.657 19.657 21 18 21Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M13.688 9.75H16.5V12.562",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M16.5 9.75L12.562 13.688L10.312 11.438L7.5 14.25",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),Lbe||(Lbe=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1395_37230"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},Rbe=(0,i.forwardRef)(Bbe);o.p;var Nbe,Fbe,jbe=["title","titleId"];function Ybe(){return Ybe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Ybe.apply(null,arguments)}var $be=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,jbe);return i.createElement("svg",Ybe({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Nbe||(Nbe=i.createElement("g",{clipPath:"url(#clip0_1395_83459)"},i.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M8 21H16C17.3261 21 18.5979 20.4732 19.5355 19.5355C20.4732 18.5979 21 17.3261 21 16V8C21 6.67392 20.4732 5.40215 19.5355 4.46447C18.5979 3.52678 17.3261 3 16 3H8C6.67392 3 5.40215 3.52678 4.46447 4.46447C3.52678 5.40215 3 6.67392 3 8V16C3 17.3261 3.52678 18.5979 4.46447 19.5355C5.40215 20.4732 6.67392 21 8 21ZM16.0246 7.07975C15.6697 6.86334 15.262 6.74923 14.8463 6.75H9.1471C8.73154 6.74992 8.32408 6.86491 7.96988 7.08225C7.61562 7.29963 7.32808 7.61169 7.13994 7.9823L6.48194 9.2823L6.47376 9.29896C6.30914 9.64521 6.2366 10.0281 6.26317 10.4105C6.28974 10.793 6.41451 11.1622 6.62542 11.4823C6.79856 11.7451 7.02494 11.9676 7.28906 12.1359V15.7659C6.94887 15.837 6.69336 16.1387 6.69336 16.5C6.69336 16.9142 7.02915 17.25 7.44336 17.25H8.01319C8.01781 17.2502 8.02244 17.2503 8.02708 17.2503C8.03107 17.2504 8.03506 17.2504 8.03906 17.2504C8.04772 17.2504 8.05634 17.2503 8.06493 17.25H11.998H15.9331C15.9417 17.2503 15.9503 17.2504 15.959 17.2504C15.9676 17.2504 15.9763 17.2503 15.9849 17.25H16.5554C16.9696 17.25 17.3054 16.9142 17.3054 16.5C17.3054 16.1384 17.0495 15.8366 16.709 15.7657V13.5004V12.1344C16.9737 11.966 17.2006 11.7431 17.374 11.4798C17.5848 11.1599 17.7096 10.791 17.7363 10.4088C17.7631 10.0266 17.6909 9.64392 17.5268 9.29772L17.5181 9.27989L16.8591 7.97989L16.8577 7.97715C16.6681 7.60691 16.3797 7.29632 16.0246 7.07975ZM11.248 15.75H8.78906V12.4825C9.24375 12.4549 9.68347 12.2986 10.0556 12.0291C10.1333 11.9729 10.2071 11.9123 10.277 11.8478C10.3451 11.9103 10.417 11.969 10.4925 12.0236C10.9301 12.3405 11.4609 12.5016 12.0001 12.4817C12.5393 12.5016 13.0701 12.3405 13.5077 12.0236C13.5841 11.9683 13.6568 11.9088 13.7257 11.8455C13.7955 11.9101 13.8694 11.9706 13.947 12.0269C14.3178 12.2956 14.7559 12.4518 15.209 12.4802V13.5004V15.75H12.748V14.5C12.748 14.0858 12.4123 13.75 11.998 13.75C11.5838 13.75 11.248 14.0858 11.248 14.5V15.75ZM15.8316 10.9092C15.7615 10.9212 15.6948 10.9429 15.6327 10.9729C15.5841 10.9811 15.5345 10.9844 15.4848 10.9825C15.4608 10.9816 15.4368 10.9819 15.4129 10.9833C15.2038 10.9957 14.9968 10.9352 14.8272 10.8123C14.6576 10.6894 14.5357 10.5115 14.4824 10.3089C14.3956 9.97955 14.0977 9.75 13.7571 9.75H13.7001C13.3613 9.75 13.0645 9.97717 12.9761 10.3042C12.9212 10.5073 12.7983 10.6854 12.628 10.8087C12.4576 10.9321 12.2501 10.9933 12.04 10.9821C12.0134 10.9806 11.9868 10.9806 11.9602 10.9821C11.7501 10.9933 11.5426 10.9321 11.3723 10.8087C11.2019 10.6854 11.079 10.5073 11.0241 10.3042C10.9357 9.97717 10.6389 9.75 10.3001 9.75H10.2471C9.90636 9.75 9.60845 9.97969 9.52177 10.3092C9.46831 10.5125 9.34606 10.6909 9.17583 10.8142C9.0056 10.9375 8.79791 10.998 8.58812 10.9854C8.56362 10.9839 8.53908 10.9836 8.51456 10.9845C8.46646 10.9864 8.41849 10.9834 8.37133 10.9759C8.30611 10.9436 8.23552 10.9205 8.16125 10.9083L8.15335 10.9043C8.04184 10.847 7.94702 10.7618 7.87804 10.6571C7.80906 10.5524 7.76825 10.4317 7.75957 10.3066C7.75105 10.1841 7.77365 10.0614 7.82519 9.94998L8.47803 8.66016C8.54075 8.53677 8.6364 8.43315 8.75437 8.36075C8.87246 8.28829 9.00856 8.24996 9.1471 8.25H14.8471L14.8488 8.25C14.9881 8.24968 15.1247 8.28789 15.2436 8.3604C15.3622 8.4327 15.4585 8.53629 15.522 8.65976L15.5225 8.66086L16.1749 9.94771C16.2261 10.0591 16.2486 10.1816 16.24 10.304C16.2312 10.4291 16.1904 10.5499 16.1214 10.6546C16.0524 10.7593 15.9576 10.8445 15.8461 10.902L15.8316 10.9092Z",fill:"currentColor"}))),Fbe||(Fbe=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1395_83459"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},Hbe=(0,i.forwardRef)($be);o.p;var Ube,zbe,Wbe=["title","titleId"];function Vbe(){return Vbe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Vbe.apply(null,arguments)}var Gbe=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Wbe);return i.createElement("svg",Vbe({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,Ube||(Ube=i.createElement("g",{clipPath:"url(#clip0_1253_7455)"},i.createElement("path",{d:"M12 17C12.0768 17 12.1509 16.972 12.2086 16.9215C12.2664 16.8709 12.3038 16.8011 12.314 16.725L12.462 15.619C12.5687 14.8192 12.9356 14.0767 13.5061 13.5061C14.0767 12.9356 14.8192 12.5687 15.619 12.462L16.725 12.314C16.8011 12.3038 16.8709 12.2664 16.9215 12.2086C16.972 12.1509 17 12.0768 17 12C17 11.9232 16.972 11.8491 16.9215 11.7914C16.8709 11.7336 16.8011 11.6962 16.725 11.686L15.619 11.538C14.8192 11.4313 14.0767 11.0644 13.5061 10.4939C12.9356 9.9233 12.5687 9.18082 12.462 8.381L12.314 7.275C12.3038 7.19891 12.2664 7.1291 12.2086 7.07853C12.1509 7.02795 12.0768 7.00005 12 7C11.9232 7.00005 11.8491 7.02795 11.7914 7.07853C11.7336 7.1291 11.6962 7.19891 11.686 7.275L11.538 8.381C11.4313 9.18082 11.0644 9.9233 10.4939 10.4939C9.9233 11.0644 9.18082 11.4313 8.381 11.538L7.275 11.686C7.19891 11.6962 7.1291 11.7336 7.07853 11.7914C7.02795 11.8491 7.00005 11.9232 7 12C7.00005 12.0768 7.02795 12.1509 7.07853 12.2086C7.1291 12.2664 7.19891 12.3038 7.275 12.314L8.381 12.462C9.18082 12.5687 9.9233 12.9356 10.4939 13.5061C11.0644 14.0767 11.4313 14.8192 11.538 15.619L11.686 16.725C11.6962 16.8011 11.7336 16.8709 11.7914 16.9215C11.8491 16.972 11.9232 17 12 17Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M18.718 5.282C20.0465 6.61066 20.9511 8.3034 21.3176 10.1462C21.684 11.989 21.4958 13.899 20.7767 15.6348C20.0577 17.3707 18.84 18.8543 17.2778 19.8981C15.7155 20.9419 13.8789 21.499 12 21.499C10.1211 21.499 8.28447 20.9419 6.72223 19.8981C5.15999 18.8543 3.94235 17.3707 3.22328 15.6348C2.50421 13.899 2.316 11.989 2.68244 10.1462C3.04889 8.3034 3.95354 6.61066 5.282 5.282C6.16418 4.3997 7.21151 3.69981 8.36419 3.22231C9.51688 2.7448 10.7523 2.49903 12 2.49903C13.2477 2.49903 14.4831 2.7448 15.6358 3.22231C16.7885 3.69981 17.8358 4.3997 18.718 5.282Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),zbe||(zbe=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1253_7455"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},Qbe=(0,i.forwardRef)(Gbe);o.p;var qbe,Kbe,Zbe=["title","titleId"];function Jbe(){return Jbe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},Jbe.apply(null,arguments)}var Xbe=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Zbe);return i.createElement("svg",Jbe({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,qbe||(qbe=i.createElement("g",{clipPath:"url(#clip0_1253_7308)"},i.createElement("path",{d:"M8.29405 10.705C8.29405 10.542 8.16205 10.411 8.00005 10.411C7.83705 10.412 7.70605 10.544 7.70605 10.706C7.70605 10.869 7.83805 11 8.00005 11C8.16205 11 8.29405 10.868 8.29405 10.705Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M8 10.411V5.5C8 4.119 9.119 3 10.5 3C11.881 3 13 4.119 13 5.5V6.072",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M10.162 15.183C10.969 15.741 11.945 16.072 13 16.072C13.662 16.072 14.29 15.937 14.868 15.703L17.877 18.708C18.065 18.895 18.319 19 18.583 19H20C20.552 19 21 18.552 21 18V16.588C21 16.322 20.894 16.068 20.706 15.88L17.662 12.84C17.872 12.289 18 11.697 18 11.072C18 8.31099 15.761 6.07199 13 6.07199C12.216 6.07199 11.484 6.26799 10.824 6.58999",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M6.00399 15.268C5.44699 15.025 4.92099 14.686 4.46499 14.23C2.51199 12.277 2.51199 9.11199 4.46499 7.15899C6.41799 5.20599 9.58299 5.20599 11.536 7.15899C13.489 9.11199 13.489 12.277 11.536 14.23C11.082 14.684 10.558 15.021 10.004 15.264L10.007 19.501C10.007 19.767 9.90199 20.021 9.71399 20.209L8.71599 21.207C8.32499 21.598 7.69199 21.598 7.30199 21.207L6.29999 20.205C6.11299 20.018 6.00699 19.764 6.00699 19.499L6.00399 15.268Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),Kbe||(Kbe=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1253_7308"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},e_e=(0,i.forwardRef)(Xbe);o.p;var t_e,n_e,r_e=["title","titleId"];function o_e(){return o_e=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},o_e.apply(null,arguments)}var i_e=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,r_e);return i.createElement("svg",o_e({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,t_e||(t_e=i.createElement("g",{clipPath:"url(#clip0_1395_37301)"},i.createElement("path",{d:"M19 14.8V13.454C19 12.785 18.572 12.189 17.936 11.978L14.333 10.777V7.667L15.417 6.973C16.215 6.461 16.587 5.487 16.33 4.574C16.069 3.642 15.222 3 14.254 3H9.746C8.78 3 7.931 3.642 7.669 4.574C7.413 5.487 7.784 6.461 8.582 6.973L9.666 7.667V10.778L6.063 11.979C5.428 12.19 5 12.784 5 13.455V14.8C5 15.212 5.163 15.609 5.456 15.9L6.1 16.544C6.392 16.837 6.787 17 7.2 17H16.8C17.212 17 17.609 16.837 17.9 16.544L18.544 15.9C18.837 15.608 19 15.213 19 14.8Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),i.createElement("path",{d:"M3 21H21",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}))),n_e||(n_e=i.createElement("defs",null,i.createElement("clipPath",{id:"clip0_1395_37301"},i.createElement("rect",{width:24,height:24,fill:"currentColor"})))))},a_e=(0,i.forwardRef)(i_e);o.p;const s_e=function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];switch(e){case Mce.Account:return i.createElement(fve,null);case Mce.Brand:return i.createElement(Pve,null);case Mce.Commerce:return i.createElement(Hbe,null);case Mce.Dashboard:return i.createElement(Zve,null);case Mce.Photos:return i.createElement(Ade,null);case Mce.Reports:return i.createElement(Obe,null);case Mce.Studio:return i.createElement(fpe,null);case Sce.Contacts:return i.createElement(jve,null);case Sce.Booking:return i.createElement(cde,null);case Sce.BrandThemes:return i.createElement(Cve,null);case Sce.BrandHomepage:return i.createElement(obe,null);case Sce.EmailActivity:case Sce.EmailTemplate:case Sce.EmailAutomation:return i.createElement(cye,null);case Sce.Contracts:case Sce.ContractTemplate:return i.createElement(mde,null);case Sce.Galleries:return i.createElement(_ve,null);case Sce.MobileApps:return i.createElement(Yye,null);case Sce.BrandWatermarks:return i.createElement(a_e,null);case Sce.Music:case Sce.MusicPlaylists:return i.createElement(Vye,null);case Sce.Orders:return i.createElement(Pde,null);case Sce.Payments:case Sce.AcceptPayments:return i.createElement(jde,null);case Sce.PriceSheets:return i.createElement(pbe,null);case Sce.Invoices:case Sce.InvoiceDiscountTemplate:case Sce.InvoiceTemplate:case Sce.InvoiceItemTemplate:return i.createElement(Sde,null);case Sce.GalleryVisitorsReport:return i.createElement(mye,null);case Sce.SalesReport:return i.createElement(Rbe,null);case Sce.OrdersReport:return i.createElement(Jye,null);case Sce.OrderFilesReport:return i.createElement(rye,null);case Sce.ItemsReport:return i.createElement(ybe,null);case Sce.InvoicePaymentsReport:return i.createElement(Sye,null);case Sce.ContactInfo:return i.createElement(Wve,null);case Sce.Users:return i.createElement(e_e,null);case Sce.PlanBilling:return i.createElement(Wde,null);case Sce.Questionnaires:return i.createElement(spe,null);case Sce.Refer:return i.createElement(xbe,null);case Sce.LogOut:return i.createElement(Iye,null);case Sce.AuthorizedApps:return i.createElement(Aye,null);default:if(t)return i.createElement(jde,null);return/.*\/v2\/[0-9]+/.test(e)?i.createElement(Qbe,null):null}};var l_e,c_e,u_e,d_e,p_e=fr(wr,{shouldForwardProp:function(e){return!["isShowingBanner","isShownOnSmallScreen","isSidebarCollapsed"].includes(e)}})((function(e){var t=e.isShowingBanner,n=e.isShownOnSmallScreen,r=e.isSidebarCollapsed,o=e.theme;return"\n        background: "+o.colors.navy[700]+";\n        flex-direction: column;\n        height: 100%;\n        position: relative;\n        width: "+(r?73:248)+"px;\n\n        "+o.responsive.mediumScreenUp("\n            border-right: 1px solid "+o.colors.gray[200]+";\n            grid-area: sidebar;\n        ")+"\n\n        "+o.responsive.smallScreenOnly("\n            display: "+(n?"initial":"none")+";\n            position: absolute;\n            height: calc(100% - "+(t?"112px":"48px")+");\n            top: "+(t?"112px":"48px")+";\n            overflow-y: auto;\n            padding-bottom: 20px;\n            width: 100%;\n            z-index: 2;\n        ")+"\n\n        a {\n            display: block;\n            outline: none;\n\n            svg {\n                color: white;\n                transition: none;\n            }\n        }\n\n        button {\n            margin: 0;\n            text-align: left;\n\n            "+(r?"\n                        width: 72px;\n                    ":"\n                        font-size: 14px;\n                        justify-content: flex-start;\n                        line-height: 20px;\n                        width: 100%;\n                    ")+"\n\n            "+o.responsive.smallScreenOnly(l_e||(l_e=zM(["\n                width: 100%;\n            "])))+"\n\n            &:hover {\n                background: "+o.colors.blue[100]+";\n            }\n        }\n\n        > a {\n            margin: 12px auto 12px 16px;\n\n            "+o.responsive.smallScreenOnly(c_e||(c_e=zM(["\n                display: none;\n            "])))+"\n        }\n    "})),f_e=fr(_r)((function(e){return"\n        "+e.theme.responsive.mediumScreenUp(u_e||(u_e=zM(["\n            display: none;\n        "])))+"\n\n        font-weight: 500;\n        letter-spacing: 1.4px;\n    "})),h_e=fr(wr)((function(e){return"\n        "+e.theme.responsive.smallScreenOnly(d_e||(d_e=zM(["\n            display: none;\n        "])))+"\n"})),m_e=fr(Wr)((function(e){var t=e.theme;return"\n        svg {\n            fill: "+t.colors.white+";\n            height: 40px;\n        }\n\n        &.chakra-button {\n            background: "+t.colors.navy[700]+";\n            border: none;\n            padding: 0;\n            width: auto;\n\n            &:hover {\n                background: "+t.colors.navy[700]+";\n\n                svg {\n                  fill: "+t.colors.white+";\n                }\n            }\n        }\n    "})),g_e=function(){var e=Co("studio.nav");return i.createElement(LK,{borderRadius:"full",color:NJ,fontSize:"8px",minHeight:"16px",left:"136px",letterSpacing:0,lineHeight:"normal",pointerEvents:"none",position:"absolute",textTransform:"uppercase",top:"12px"},e("new"))};function v_e(e,t){if(e.length!==t.length)return!1;var n=[].concat(e).sort((function(e,t){return e-t})),r=[].concat(t).sort((function(e,t){return e-t}));return n.every((function(e,t){return e===r[t]}))}function y_e(e,t,n){return e.reduce((function(e,r,o){var i=r.id,a=r.menuItems;return(i===n||null!=a&&a.find((function(e){return Oce(t,e)})))&&e.push(o),e}),[])}const b_e=function(e){var t,r=e.activeRoute,o=e.activeRouteGroup,a=e.currentBrandId,s=e.isImposter,l=e.isShowingBanner,c=e.isShownOnSmallScreen,u=e.menusSmallScreen,d=e.navigate,p=Co("studio.nav"),f=hO(),h=f.me,g=f.patchMeSettings,v=Hce().menus,y=aq().hasPermissions,b=vfe(v),_=b[1],A=_.buttonHref,E=_.id,w=_.name,x=b.slice(2),k=u9({base:!1,sm:!1,md:!0}),C=(null!==(t=null==h?void 0:h.settings.find((function(e){return"nav-collapsed"===e.key})))&&void 0!==t?t:{}).value,S=Yce(Boolean(C)),M=S.value,T=S.toggle,O=Boolean(M&&k),D=(0,i.useCallback)((function(e){var t=e.event,n=e.isPaymentsMenuItem,r=e.navRoute,o=e.onClick,i=e.openSidebarIfClosed,a=void 0===i?O:i,s=e.opensInNewTab,l=void 0!==s&&s;n&&!r&&o?(t.preventDefault(),o()):a?(t.preventDefault(),T()):r&&d(r,l)&&!Tce(t)&&t.preventDefault()}),[O,d,T]),L=(0,i.useCallback)((function(e){var t=e.menuItem,n=e.uppercase,o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,s=t.name,l=t.onClick,c=t.href,u=t.opensInNewTab,d=t.prependBrandPathToHref,p=void 0===d||d,f=t.isNew,h=t.isPaymentsMenuItem;return i.createElement(Zw,{key:o,placement:"right",label:O?s:""},i.createElement(Kr,{"data-testid":"nav-sidebar-button-"+QT(s),href:(p?"/v2/"+a:"")+c,position:"relative"},i.createElement(Wfe,{isActive:Oce(r,t),onClick:function(e){D({event:e,isPaymentsMenuItem:h,navRoute:c,openSidebarIfClosed:!1,opensInNewTab:u,onClick:l})},color:"white",fontWeight:300,_hover:{color:"white"},_focus:{boxShadow:"none"},textTransform:n?"uppercase":"none",isSidebarCollapsed:O},i.createElement(i.Fragment,null,s_e(c,h)),O?null:s),f&&i.createElement(g_e,null)))}),[r,a,O,D]),P=(0,i.useCallback)((function(e){var t=(arguments.length>1&&void 0!==arguments[1]?arguments[1]:{}).openSidebarIfClosed,n=void 0===t?O:t;return null==e?void 0:e.sort((function(e,t){var n=Boolean(e.localNavItems),r=Boolean(t.localNavItems);return n&&!r?1:!n&&r?-1:0})).map((function(e,t){return L({menuItem:e,uppercase:n},t)}))}),[L,O]);(0,i.useEffect)((function(){g([{key:"nav-collapsed",value:O}])}),[O,g]);var I=m((0,i.useState)((function(){return[y_e(x,r,o),y_e(u,r,o)]})),2),B=m(I[0],2),R=B[0],N=B[1],F=I[1];(0,i.useEffect)((function(){var e=y_e(vfe(v).slice(2),r,o),t=y_e(u,r,o);F((function(n){var r=m(n,2),o=r[0],i=r[1];return v_e(o,e)&&v_e(i,t)?n:[e,t]}))}),[v,u,r,o]);var j=(0,i.useMemo)((function(){return x.map((function(e,t){var n;return{panel:i.createElement(_r,{"data-testid":"nav-sidebar-accordion-panel-"+QT(e.name)},P(e.menuItems)),subtitle:i.createElement(i.Fragment,null,i.createElement(Zw,{variant:"bold",placement:"right",label:O?e.name:""},i.createElement(wr,{className:"accordion-button","data-testid":"nav-sidebar-button-"+QT(e.name),sx:{svg:{marginRight:"16px"}}},s_e(e.id),i.createElement("span",null,e.name))),!R.includes(t)&&(null===(n=e.menuItems)||void 0===n?void 0:n.some((function(e){return e.isNew})))&&i.createElement(g_e,null)),title:""}}))}),[R,P,O,x]),Y=(0,i.useMemo)((function(){return u.map((function(e,t){var n=e.id,r=e.menuItems,o=e.name;return{panel:i.createElement(_r,{"data-testid":"nav-sidebar-accordion-panel-"+QT(o)},P(r)),subtitle:i.createElement(i.Fragment,null,i.createElement(wr,{className:"accordion-button","data-testid":"nav-sidebar-button-"+QT(o)},s_e(n),i.createElement("span",null,o)),!N.includes(t)&&(null==r?void 0:r.some((function(e){return e.isNew})))&&i.createElement(g_e,null)),title:""}}))}),[N,P,u]),$=(0,i.useCallback)((function(e){var t=Array.isArray(e)?e:[e];F((function(e){return[t,e[1]]}))}),[]),H=(0,i.useCallback)((function(e){var t=Array.isArray(e)?e:[e];F((function(e){return[e[0],t]}))}),[]);return i.createElement(p_e,{"data-testid":"nav-sidebar",isShowingBanner:l,isShownOnSmallScreen:c,isSidebarCollapsed:O},k&&i.createElement(h_e,n({height:"98px",minHeight:"98px",alignItems:"center",backgroundColor:"navy.700"},O?{justifyContent:"center"}:{paddingLeft:"20px"}),i.createElement(Kr,{"data-testid":"nav-sidebar-logo-link",href:"/v2/"+a+A},i.createElement(m_e,{"data-testid":"nav-sidebar-logo-button",onClick:function(e){D({event:e,navRoute:null!=A?A:"",openSidebarIfClosed:!1})},_focus:{boxShadow:"none"}},O?i.createElement(Efe,{"data-testid":"nav-sidebar-logo",width:"40px"}):i.createElement(Zce,{"data-testid":"nav-sidebar-logo",width:"123px"})))),i.createElement(qfe,{"data-testid":"nav-sidebar-"+(O?"expand":"collapse")+"-button",isSidebarCollapsed:O,onClick:T},i.createElement(Qfe,{hasArrow:!1,placement:"right",label:p(O?"sidebar.expand":"sidebar.collapse")},i.createElement(Sfe,null))),i.createElement(Pfe,{paddingTop:"12px"},y(uO.EventCreate)&&i.createElement(sve,{currentBrandId:a,href:Nce.get(Sce.Galleries,{from:"create-gallery"}),isSidebarCollapsed:O}),i.createElement(Zw,{variant:"bold",placement:"right",label:O?w:""},i.createElement(Kr,{"data-testid":"nav-sidebar-button-dashboard",href:"/v2/"+a+A,marginBottom:"16px"},i.createElement(Wfe,{isActive:o===E,isSidebarCollapsed:O,textTransform:"uppercase",color:"white",cursor:"pointer",_hover:{color:"white"},fontWeight:500,letterSpacing:"1.4px",onClick:function(e){D({event:e,navRoute:null!=A?A:"",openSidebarIfClosed:!1})},_focus:{boxShadow:"none"}},s_e(E),i.createElement("span",null,w)))),i.createElement($fe,{allowMultiple:!0,index:R,onChange:$,"data-testid":"sp-ui-accordion",isSidebarCollapsed:O},j.map((function(e,t){return i.createElement(sZ,{key:t},i.createElement(tZ,{_focus:{boxShadow:"none"}},i.createElement(_r,{flex:"1",textAlign:"left","data-testid":"accordion-header-"+t,fontWeight:400},e.title,e.subtitle),i.createElement(aZ,null)),i.createElement(dZ,{"data-testid":"accordion-panel-"+t,padding:0},e.panel))}))),!k&&i.createElement(Yfe,{allowMultiple:!0,index:N,onChange:H,"data-testid":"sp-ui-accordion"},Y.map((function(e,t){return i.createElement(sZ,{key:t},i.createElement(tZ,{_focus:{boxShadow:"none"}},i.createElement(_r,{flex:"1",textAlign:"left","data-testid":"accordion-header-"+t,fontWeight:400},e.title,e.subtitle),i.createElement(aZ,null)),i.createElement(dZ,{"data-testid":"accordion-panel-"+t,padding:0},e.panel))}))),!s&&i.createElement(f_e,null,L({menuItem:{href:Sce.LogOut,name:p("link.logOut"),prependBrandPathToHref:!1},openSidebarIfClosed:O,uppercase:!0}))))};var __e,A_e=["currentBrandId","externalRoutes","imposter","subscribeGetNotifications","activeRoute"],E_e=fr(Wr)((function(e){var t=e.theme;return"\n        border: none;\n        border-radius: 8px;\n        box-shadow: 0 2px 4px 0 "+function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=m(Array.from(e),7),r=n[1],o=n[2],i=n[3],a=n[4],s=n[5],l=n[6],c=parseInt(""+s+l,16),u=parseInt(""+i+a,16);return t>1?t=1:t<0&&(t=0),"rgba("+parseInt(""+r+o,16)+","+u+","+c+","+t+")"}(t.colors.navy[400],.5)+";\n        font-family: inherit;\n        font-size: 16px;\n        font-weight: 500;\n        height: 38px;\n        line-height: 18px;\n        margin-right: 9px;\n        padding: 9px 15px;\n\n        &, &:hover {\n            background: #FFCE42;\n            color: "+t.colors.navy[400]+";\n        }\n    "})),w_e=fr("span")(__e||(__e=zM(["\n    font-size: 16px;\n    font-weight: 500;\n    margin-right: 10px;\n"])));const x_e=K2((function(e){var n=e.currentBrandId,r=e.externalRoutes,o=void 0===r?[]:r,a=e.imposter,s=e.subscribeGetNotifications,l=e.activeRoute,c=t(e,A_e),u=Hce(),d=u.externalRoutes,p=u.menus,f=u.showNav,h=m(p,1)[0],g=m((0,i.useState)(null),2),v=g[0],y=g[1],b=zo("brand").response,_=(0,i.useMemo)((function(){return(p.find((function(e){var t=e.buttonHref;return(e.menuItems||[]).some((function(e){return Oce(l,e)}))||t===l}))||{}).id}),[l,p]),A=zo("brand/"+n+"/notification?rows=50"),E=A.performFetch,w=A.response,x=(hO().me||{}).studio||{},k=x.photoPlan,C=x.bookingPlan,S=x.trialDaysRemaining,M=(k||{}).isFree,T=Boolean(a),O=m((0,i.useState)([h]),2),D=O[0],L=O[1],P=m((0,i.useState)([]),2),I=P[0],B=P[1],R=m((0,i.useState)(0),2),N=R[0],F=R[1],j=zce(n),Y=j.isPromoForBookingPlan,$=j.openTrialCheckoutModalOnRender,H=j.openSelectPlanFromQuery,U=j.promoCode,z=j.promoResponse,W=j.showUpgradeButton,V=j.trialCheckoutModalAvailable,G=m((0,i.useState)(!1),2),Q=G[0],q=G[1],K=(0,i.useCallback)((function(){q(!1);var e=new URL(window.location.href);e.searchParams.delete("promoCode"),e.searchParams.delete("openCheckout"),e.searchParams.delete("openSelectPlan"),window.history.replaceState({},"",e.toString())}),[q]),Z=nY(H4),J=Z.Modal,X=Z.close,ee=Z.open,te=Z.isOpen,ne=(0,i.useMemo)((function(){if(z){if(z.worksYearly&&!z.worksMonthly)return!1;if(z.worksMonthly&&!z.worksYearly)return!0;if(z.worksYearly&&z.worksMonthly)return!1}return"monthly"===(null==C?void 0:C.planPeriod)}),[z,null==C?void 0:C.planPeriod]),re=m((0,i.useState)(!1),2),oe=re[0],ie=re[1],ae=(0,i.useCallback)((function(){ie(!1),X();var e=new URL(window.location.href);e.searchParams.delete("promoCode"),e.searchParams.delete("openCheckout"),e.searchParams.delete("openSelectPlan"),window.history.replaceState({},"",e.toString())}),[X]);(0,i.useEffect)((function(){$&&(Y?Q&&!oe?(q(!1),ie(!0)):oe||Q||ie(!0):Q||oe||q(!0))}),[$,Y,Q,oe]),(0,i.useEffect)((function(){oe&&ee()}),[ee,oe]);var se=function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=c.navigate;return t?(window.open(e,"_blank","noopener noreferrer"),!0):!(function(e){var t;return o.includes(e)||d.includes(e)||v&&(null===(t=v.menuItems)||void 0===t?void 0:t.some((function(t){return t.href===e})))||I&&I.some((function(t){return t.links["studio-panel"].href===e}))}(e)||!n)&&(n(e),ce&&ue(),!0)},le=Yce(!1),ce=le.value,ue=le.toggle,de=Co("studio.nav");return(0,i.useEffect)((function(){if(b){var e=b.items;(null==e?void 0:e.length)>1&&y({id:Mce.Brand,menuItems:e.map((function(e){var t=e.id,r=e.name;return{prependBrandPathToHref:!1,href:"/v2/"+t,isActive:t===n,isDisabled:t===n,name:r}})),name:de("menu.brand")})}}),[b,n,de]),(0,i.useEffect)((function(){if(w){var e=w.items,t=w.meta;F(null==t?void 0:t.totalActiveNotifications),B(e)}}),[w]),(0,i.useEffect)((function(){s&&s(E)}),[E,s]),(0,i.useEffect)((function(){return e=function(e){if(void 0!==(null==e?void 0:e.dismissedNotificationId))return B((function(t){return t.filter((function(t){return t.id!==e.dismissedNotificationId}))})),void F((function(e){return Math.max(0,e-1)}));E()},$ce.add(e),function(){$ce.delete(e)};var e}),[E]),(0,i.useEffect)((function(){v&&L((function(e){return[].concat(e,[v])}))}),[v]),f?i.createElement(i.Fragment,null,i.createElement(mfe,{accountMenu:h,activeRouteGroup:_,brandMenu:v,currentBrandId:n,imposter:a,isImposter:T,isSidebarShownSmallScreen:ce,navigate:se,notifications:I,totalActiveNotifications:N,onNotificationDismissed:function(e){var t;t={dismissedNotificationId:e},$ce.forEach((function(e){return e(t)}))},toggleShowMenuSmallScreen:ue,upgradeButton:W?i.createElement(i.Fragment,null,i.createElement(w_e,null,M?de("upgradeButtonAside.freePlan"):Number(S)>0?de("upgradeButtonAside.trial",{trialDaysRemaining:S}):de(0===S?"upgradeButtonAside.trialEnding":"upgradeButtonAside.trialEnded")),i.createElement(Kr,{"data-testid":"nav-upgrade-button-container",href:Nce.get(Sce.PlanBilling,{from:"upgrade-plan-"+(M?"free":"trial")})},i.createElement(E_e,{"data-testid":"nav-upgrade-button",onClick:function(e){e.preventDefault(),q(!0)}},de(M?"upgradeButton":"upgradeButtonOpenModal")))):void 0}),i.createElement(b_e,{activeRoute:l,activeRouteGroup:_,currentBrandId:n,isImposter:T,isShowingBanner:!1,isShownOnSmallScreen:ce,menusSmallScreen:D,navigate:se}),V&&!Y&&i.createElement(gfe,{initialPhotoPlan:k,initialPromoCode:U,trialCheckoutModalIsOpen:Q,onClosedModal:K,openSelectPlan:H}),V&&Y&&i.createElement(wK,{defaultPlanUuid:z&&z.worksYearly!==z.worksMonthly||null==C?void 0:C.uuid,planType:"booking"},i.createElement(J,{key:"booking-"+U+"-"+(null==z?void 0:z.worksYearly)+"-"+(null==z?void 0:z.worksMonthly),onClose:ae,isOpen:te||oe,initialPromoCode:U,isMonthly:ne}))):null}));var k_e;var C_e,S_e,M_e,T_e,O_e=["activeRoute","currentBrandId"],D_e=["apiRoot","currentBrandId","dataToken"],L_e=document.getElementById("nav"),P_e=null!==(C_e=null==L_e?void 0:L_e.getAttribute("data-imposter-name"))&&void 0!==C_e?C_e:"",I_e=null!==(S_e=null==L_e?void 0:L_e.getAttribute("data-imposter-unset-url"))&&void 0!==S_e?S_e:"",B_e="true"===(null==L_e?void 0:L_e.getAttribute("data-is-imposter"))?{name:P_e,unsetUrl:I_e}:void 0,R_e=null!==(M_e=null==L_e?void 0:L_e.getAttribute("data-stripe-public-key"))&&void 0!==M_e?M_e:"",N_e=c6((function(e){var r=e.activeRoute,o=e.currentBrandId,a=t(e,O_e);return i.createElement(Ice,{currentBrandId:o,stripePublicKey:R_e},i.createElement(x_e,n({activeRoute:r,currentBrandId:o,imposter:B_e},a)))})),F_e=["title","titleId"];function j_e(){return j_e=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},j_e.apply(null,arguments)}var Y_e=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,F_e);return i.createElement("svg",j_e({viewBox:"0 0 18 15",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,T_e||(T_e=i.createElement("path",{d:"M4 12h.5v-.5H4v.5Zm.813 2.35.312.39-.312-.39ZM7.75 12v-.5h-.175l-.137.11.312.39ZM1.5 2a.5.5 0 0 1 .5-.5v-1A1.5 1.5 0 0 0 .5 2h1Zm0 9V2h-1v9h1Zm.5.5a.5.5 0 0 1-.5-.5h-1A1.5 1.5 0 0 0 2 12.5v-1Zm2 0H2v1h2v-1Zm.5 2.46V12h-1v1.96h1Zm0 0h-1a1 1 0 0 0 1.625.78l-.625-.78Zm2.938-2.35L4.5 13.96l.625.78 2.937-2.35-.624-.78ZM16 11.5H7.75v1H16v-1Zm.5-.5a.5.5 0 0 1-.5.5v1a1.5 1.5 0 0 0 1.5-1.5h-1Zm0-9v9h1V2h-1Zm-.5-.5a.5.5 0 0 1 .5.5h1A1.5 1.5 0 0 0 16 .5v1Zm-14 0h14v-1H2v1ZM4 4.5a.5.5 0 0 0 0 1v-1Zm10 1a.5.5 0 0 0 0-1v1Zm-10 0h10v-1H4v1ZM4 7a.5.5 0 0 0 0 1V7Zm8 1a.5.5 0 0 0 0-1v1ZM4 8h8V7H4v1Z"})))},$_e=(0,i.forwardRef)(Y_e);o.p;var H_e,U_e,z_e=fr($_e)((function(e){return"\n        fill: "+e.theme.colors.blue[400]+";\n        width: 16px;\n        height: 16px;\n    "})),W_e=fr(wr)(H_e||(H_e=zM(["\n    flex-direction: row;\n    align-items: baseline;\n"]))),V_e=fr(_r)(U_e||(U_e=zM(["\n    padding: 3px 10px 3px 0px;\n"]))),G_e=function(e){var t=e.header,n=e.item;return i.createElement(wr,{flexDirection:"column"},i.createElement(V_e,null,t),i.createElement(V_e,null,n))},Q_e=function(e){var t=e.editButton,n=e.editButtonAction,r=e.replaceButton,o=e.replaceButtonAction;return i.createElement(wr,{justifyContent:"flex-start",padding:"8px"},i.createElement(fp,{padding:"4",marginRight:"4",variant:sp.Secondary,onClick:o},r),i.createElement(fp,{padding:"8",variant:sp.Secondary,onClick:n},t))};const q_e=function(e){var t=e.isEditable,n=void 0===t||t,r=e.isOpen,o=void 0===r||r,a=e.itemFileName,s=e.itemProductName,l=e.itemQuantity,c=e.onEdit,u=e.onClose,d=void 0===u?qT:u,p=e.onReplace,f=e.item,h=e.photo,m=e.photoUrl,g=e.variant,v=e.frame,y=Co(),b=nY(),_=b.open,A=b.Modal,E=b.close;return(0,i.useEffect)((function(){o?_():E()}),[_,E,o]),i.createElement(A,{onClose:d,showCloseButton:!1,areButtonsCentered:!0},i.createElement(A.Body,null,i.createElement(W_e,{gap:10},i.createElement(G_e,{header:y("FILENAME"),item:a}),i.createElement(G_e,{header:y("ITEM"),item:s}),i.createElement(G_e,{header:y("QTY"),item:l})),n&&i.createElement(Q_e,{editButton:y("Edit Crop"),editButtonAction:c,replaceButton:y("Replace Image"),replaceButtonAction:p}),i.createElement(lO,{item:f,photo:h,photoUrl:m,variant:g,frame:v})))};var K_e,Z_e=fr(_r)(K_e||(K_e=zM(["\n    text-align: center;\n\n    img {\n        display: block;\n        filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2));\n        margin: 0 auto;\n        max-width: 700px;\n        width: 100%;\n    }\n"])));const J_e=function(e){var t=e.backProductImageUrl,n=e.frontProductImageUrl,r=e.withOpen,o=nY(),a=o.Modal,s=o.close,l=o.open;return(0,i.useEffect)((function(){r(l)}),[l,r]),i.createElement(a,{heading:"Preview",variant:yp.Large},i.createElement(a.Body,null,i.createElement(Z_e,null,i.createElement("img",{alt:"Front of WHCC Card Product",src:n}),i.createElement(wx,null,"Front"),i.createElement("img",{alt:"Back of WHCC Card Product",src:t}),i.createElement(wx,null,"Back"))),i.createElement(a.SecondaryButton,{onClick:s},"Close"))};function X_e(){return X_e=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},X_e.apply(null,arguments)}var eAe=function(e){return e.Cvc="cardCvc",e.Expiration="cardExpiry",e.Number="cardNumber",e}({}),tAe=function(e){return e.Empty="empty",e.Error="error",e.Submit="submit",e.Valid="valid",e}({}),nAe={[eAe.Cvc]:"'s security code",[eAe.Expiration]:"'s expiration date",[eAe.Number]:" number"};function rAe(e){return"Your card"+nAe[e]+" is incomplete."}var oAe={[eAe.Cvc]:null,[eAe.Expiration]:null,[eAe.Number]:null},iAe={errors:oAe,isValid:()=>!1,onCardEmpty:()=>{},onCardError:()=>{},onCardValid:()=>{},onFormSubmit:()=>{}},aAe=(0,i.createContext)(iAe);function sAe(e,t){switch(t.type){case tAe.Empty:return Object.assign({},e,{[t.name]:rAe(t.name)});case tAe.Error:return Object.assign({},e,{[t.name]:t.message});case tAe.Valid:return Object.assign({},e,{[t.name]:!0});case tAe.Submit:return Object.assign({},e,{[eAe.Cvc]:null===e[eAe.Cvc]?rAe(eAe.Cvc):e[eAe.Cvc],[eAe.Expiration]:null===e[eAe.Expiration]?rAe(eAe.Expiration):e[eAe.Expiration],[eAe.Number]:null===e[eAe.Number]?rAe(eAe.Number):e[eAe.Number]});default:return e}}var lAe=e=>{var{children:t}=e,[n,r]=(0,i.useReducer)(sAe,oAe),o={errors:n,isValid:()=>!0===n[eAe.Number]&&!0===n[eAe.Expiration]&&!0===n[eAe.Cvc],onCardEmpty:e=>{var t;r((t=e,{type:tAe.Empty,name:t}))},onCardError:(e,t)=>{r(((e,t)=>({type:tAe.Error,name:e,message:t}))(e,t))},onCardValid:e=>{var t;r((t=e,{type:tAe.Valid,name:t}))},onFormSubmit:()=>{r({type:tAe.Submit})}};return Mr(aAe.Provider,{value:X_e({},o)},t)};const cAe=function(e){var t=t=>Mr(lAe,null,Mr(e,t)),n=e.name||e.displayName;return t.displayName="withCardErrorContext"+n,t};var uAe=o(11382),dAe=o(85946);const pAe={SP_URL:"https://use.typekit.net/xbm1wuz.css"};var fAe=e=>{var{children:t,stripeKey:n}=e;n&&n.length||console.warn("Stripe API Key cannot be found!");var r=(0,dAe.loadStripe)(n),o={fonts:[{cssSrc:pAe.SP_URL}]};return Mr(uAe.Elements,{options:o,stripe:r},t)};var hAe=o(19543),mAe=["children"],gAe=["children","size"];function vAe(){return vAe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},vAe.apply(null,arguments)}function yAe(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}var bAe=pr(_r,{target:"esodu3k1"})("\n        display: inline-block;\n        width: 100%;\n    ",""),_Ae=e=>{var{children:t}=e,n=yAe(e,mAe);return Mr(bAe,vAe({"data-testid":"sp-ui-cell"},n),t)},AAe=pr(_r,{target:"esodu3k0"})("\n        display: inline-block;\n\n        &:first-of-type {\n            padding-left: 0;\n        }\n\n        &:last-of-type {\n            padding-right: 0;\n        }\n    ","");const EAe=e=>{var{children:t,size:n}=e,r=yAe(e,gAe),o=e=>100/12*e+"%",{gutters:i}=qd(),{sm:a}=i,s="number"==typeof n?100/12*n+"%":[o(n[0]),...n.map(o)];return Mr(AAe,vAe({"data-testid":"sp-ui-column",paddingLeft:a,paddingRight:a,width:s},r),Mr(_Ae,null,t))};var wAe=["showMobileView"];function xAe(){return xAe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},xAe.apply(null,arguments)}var kAe=pr(_r,{shouldForwardProp:e=>"isFieldInvalid"!==e,target:"ez6k3t61"})((e=>{var{theme:t,isFieldInvalid:n}=e,r=t.components.TextInput,{baseStyle:o}=r;return"\n            .StripeElement {\n                padding: 12px 12px;\n                height: 40px;\n                background-color: "+o.backgroundColor+";\n                border: 1px solid "+(n?o[tp.Invalid].borderColor:o.borderColor)+";\n                border-radius: 3px;\n\n                &--invalid {\n                    border-color: "+o[tp.Invalid].borderColor+";\n                }\n\n                &--focus {\n                    border-color: "+o[tp.Focus].borderColor+";\n                }\n\n                &--hover {\n                    border-color: "+o[tp.Hover].borderColor+";\n                }\n            }\n        "}),""),CAe=pr(EAe,{target:"ez6k3t60"})({name:"40f4ru",styles:"vertical-align:top"});const SAe=e=>{var{showMobileView:t=!1}=e,n=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,wAe),r=qd(),o=r.components.TextInput,{baseStyle:a}=o,s=xo(),{errors:l,onCardEmpty:c,onCardError:u,onCardValid:d}=(0,i.useContext)(aAe),p={style:{base:{color:a.color,fontFamily:r.fonts.body,fontSize:r.fontSizes.md,fontWeight:""+r.fontWeights.normal,"::placeholder":{color:a.placeholderColor,fontSize:r.fontSizes.md}},invalid:{color:a.color,iconColor:a[tp.Invalid].borderColor}}},{md:f}=r.breakpoints,h=(0,hAe.Ay)({minWidth:f});function m(e){var{elementType:t,complete:n,empty:r,error:o}=e;return o?u(t,o.message):r?c(t):n?d(t):void 0}function g(e){null===l[e]&&c(e)}function v(e){return"string"==typeof l[e]}var y=l[eAe.Number],b=l[eAe.Expiration],_=l[eAe.Cvc],A=()=>Mr(i.Fragment,null,Mr(wx,null,s("Card Number*")),Mr(kAe,{isFieldInvalid:v(eAe.Number)},Mr(uAe.CardNumberElement,{options:p,onBlur:()=>g(eAe.Number),onChange:m})),"string"==typeof y&&Mr(Ax,null,y)),E=()=>Mr(i.Fragment,null,Mr(wx,null,s("Expiration Date*")),Mr(kAe,{isFieldInvalid:v(eAe.Expiration)},Mr(uAe.CardExpiryElement,{options:p,onBlur:()=>g(eAe.Expiration),onChange:m})),"string"==typeof b&&Mr(Ax,null,b)),w=()=>Mr(i.Fragment,null,Mr(wx,null,s("Security Code*")),Mr(kAe,{isFieldInvalid:v(eAe.Cvc)},Mr(uAe.CardCvcElement,{options:p,onBlur:()=>g(eAe.Cvc),onChange:m})),"string"==typeof _&&Mr(Ax,null,_));return Mr(_r,xAe({onClick:function(e){e.stopPropagation(),e.preventDefault()}},n),h&&!t?Mr(BG,null,Mr(CAe,{size:6},A()),Mr(CAe,{size:3},E()),Mr(CAe,{size:3},w())):Mr(i.Fragment,null,Mr(BG,null,Mr(CAe,{size:12},A())),Mr(BG,null,Mr(CAe,{size:6},E()),Mr(CAe,{size:6},w()))))};function MAe(){return MAe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},MAe.apply(null,arguments)}function TAe(e,t,n,r,o,i,a){try{var s=e[i](a),l=s.value}catch(e){return void n(e)}s.done?t(l):Promise.resolve(l).then(r,o)}function OAe(e){return function(){var t=this,n=arguments;return new Promise((function(r,o){var i=e.apply(t,n);function a(e){TAe(i,r,o,a,s,"next",e)}function s(e){TAe(i,r,o,a,s,"throw",e)}a(void 0)}))}}var DAe=()=>{var e=(0,uAe.useStripe)(),t=(0,uAe.useElements)();return function(){var n=OAe((function*(n){if(!e||!t){return{error:{message:"Unable to initialize Stripe Elements!"},paymentMethod:void 0}}var r=t.getElement(uAe.CardNumberElement);if(!r){return{error:{message:"An error occurred retrieving the Stripe Card Element!"},paymentMethod:void 0}}return yield e.createPaymentMethod(MAe({card:r,type:"card"},n?{billing_details:n}:{}))}));return function(e){return n.apply(this,arguments)}}()};function LAe(){return LAe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},LAe.apply(null,arguments)}function PAe(){return PAe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},PAe.apply(null,arguments)}function IAe(e,t,n,r,o,i,a){try{var s=e[i](a),l=s.value}catch(e){return void n(e)}s.done?t(l):Promise.resolve(l).then(r,o)}const BAe=e=>{var{amount:t=0,amountIsFixed:n=!1,children:r,defaultAmount:o=0,formRef:a,onSubmit:s,showAutoPay:l=!1,showAmount:c=!1,showEmail:u=!0,showMemo:d=!0}=e,{isValid:p}=(0,i.useContext)(aAe),[f,h]=(0,i.useState)(""),m=DAe(),g=(0,i.useMemo)((()=>(e=>{var{maxAmount:t,showEmail:n}=e;return MU().shape(LAe({amount:lU().min(0).max(t).label("Amount").required("Please enter a valid amount"),cardholderName:aU().max(50).label("Name on Card").required("Name on Card is a required field")},n?{emailAddress:aU().email().label("Email address").required("Please enter a valid email address: yourname@example.com")}:{},{enableAutoPay:XH(),memo:aU(),postalCode:aU().max(10).label("Zip/Postal Code").required("Zip/Postal Code is a required field")}))})({maxAmount:t,showEmail:u})),[t,u]);function v(){var e;return e=function*(e){if(p()){var{cardholderName:t,emailAddress:n,postalCode:r}=e,o=PAe({},r&&{address:{postal_code:r}},{email:n,name:t}),{error:i,paymentMethod:a}=yield m(o);if(i&&i.message)return h(i.message);if(a){var{id:l,card:c}=a;yield s(Object.assign(e,{card:c,paymentMethodId:l}))}}},v=function(){var t=this,n=arguments;return new Promise((function(r,o){var i=e.apply(t,n);function a(e){IAe(i,r,o,a,s,"next",e)}function s(e){IAe(i,r,o,a,s,"throw",e)}a(void 0)}))},v.apply(this,arguments)}return Mr(TI,{initialValues:{amount:String((o||t).toFixed(2))||"",cardholderName:"",enableAutoPay:!1,emailAddress:"",memo:"",postalCode:""},innerRef:a,onSubmit:function(e){return v.apply(this,arguments)},validationSchema:g},Mr(BI,{"data-testid":"sp-ui-payment-form"},Mr(_r,{className:"sp-ui-payment-form",maxWidth:"428px"},c&&Mr(BG,null,Mr(sQ,{"data-testid":"payment-form-amount",isRequired:!0,label:"Amount",name:"amount",isReadOnly:n,isDisabled:n,showValidationIcons:!1})),Mr(BG,null,Mr(sQ,{isRequired:!0,label:"Name on Card",name:"cardholderName",showValidationIcons:!1})),Mr(BG,null,Mr(SAe,{showMobileView:!0})),Mr(BG,null,Mr(sQ,{isRequired:!0,label:"Zip/Postal Code",name:"postalCode",showValidationIcons:!1})),u&&Mr(BG,null,Mr(sQ,{"data-testid":"payment-form-email",isRequired:!0,label:"Email",name:"emailAddress",showValidationIcons:!1})),d&&Mr(BG,null,Mr(sQ,{"data-testid":"payment-form-memo",label:"Memo",variant:rQ.TextArea,name:"memo"})),l&&Mr(BG,null,Mr(sQ,{"data-testid":"payment-form-auto-pay",label:"AutoPay On",variant:rQ.Checkbox,name:"enableAutoPay"})),f&&f.length&&Mr(BG,null,Mr(Ax,null,f)),r)))};var RAe,NAe=["amount","amountIsFixed","onSubmit","stripeKey"],FAe=["title","titleId"];function jAe(){return jAe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},jAe.apply(null,arguments)}var YAe=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,FAe);return i.createElement("svg",jAe({fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,RAe||(RAe=i.createElement("path",{d:"M5.613 9.539l6.165-7.37c.421-.482.361-1.386-.12-1.808C11.174-.06 10.271 0 9.85.481l-6.165 7.37c-.422.483-.362 1.386.12 1.808.633.412 1.386.361 1.808-.12zm-4.86-2.55l3.052 2.67c.482.422 1.386.361 1.808-.12.421-.482.361-1.386-.12-1.808L2.44 5.061c-.482-.422-1.386-.362-1.807.12-.422.482-.372 1.235.12 1.807z"})))},$Ae=(0,i.forwardRef)(YAe);o.p;var HAe,UAe=["title","titleId"];function zAe(){return zAe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},zAe.apply(null,arguments)}var WAe=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,UAe);return i.createElement("svg",zAe({fill:"none",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,HAe||(HAe=i.createElement("path",{d:"M6.662 5.232l3.54 3.54a.996.996 0 11-1.41 1.41l-3.55-3.53-3.54 3.54a.996.996 0 11-1.41-1.41l3.54-3.54-3.54-3.54a.996.996 0 111.41-1.41l3.54 3.54 3.54-3.54a.996.996 0 111.41 1.41l-3.53 3.53z"})))},VAe=(0,i.forwardRef)(WAe);o.p;var GAe,QAe=["title","titleId"];function qAe(){return qAe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},qAe.apply(null,arguments)}var KAe=function(e,t){var n=e.title,r=e.titleId,o=function(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,QAe);return i.createElement("svg",qAe({viewBox:"0 0 14 20",xmlns:"http://www.w3.org/2000/svg",ref:t,"aria-labelledby":r},o),n?i.createElement("title",{id:r},n):null,GAe||(GAe=i.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M10 9H4V5c0-1.654 1.346-3 3-3s3 1.346 3 3v4zm-3 7a1.5 1.5 0 11.001-3.001A1.5 1.5 0 017 16zm5-7V5c0-2.757-2.243-5-5-5S2 2.243 2 5v4c-1.103 0-2 .896-2 2v7c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-7c0-1.104-.897-2-2-2z"})))},ZAe=(0,i.forwardRef)(KAe);o.p;var JAe=fr(_r,{shouldForwardProp:function(e){return"isInvalid"!==e}})((function(e){var t=e.isInvalid,n=e.theme;return t?"\n            .chakra-form-control > label, > span {\n                color: "+n.components.LabelError.baseStyle.color+";\n            }\n        ":""})),XAe=function(e){var t=e.isRequired,n=e.onChange,r=mI(),o=r.isValid,a=r.values,s=a.password,l=a.confirmPassword;return(0,i.useEffect)((function(){var e=Boolean(l),r=Boolean(s),i=e&&r;n(a,(t?i:i||!e&&!r)&&o)}),[t,o,n,l,s,a]),null},eEe=function(){var e=mI().setTouched;return(0,i.useEffect)((function(){e({confirmPassword:!0,password:!0})}),[e]),null},tEe=function(e){var t=e.rules,n=e.value;return i.createElement(i.Fragment,null,t.map((function(e,t){var r=e.description,o=e.pattern.test(n);return i.createElement(nEe,{"data-testid":"validation-rule",isValid:o,key:t},o?i.createElement($Ae,{"data-testid":"valid-icon",height:"10px",width:"12px"}):i.createElement(VAe,{"data-testid":"invalid-icon",height:"11px",width:"11px"}),r)})))},nEe=fr(Ax,{shouldForwardProp:function(e){return"isValid"!==e}})((function(e){var t=e.isValid,n=e.theme;return"\n        color: "+(t?n.colors.green[600]:n.components.LabelError.baseStyle.color)+";\n        font-weight: normal;\n        margin: 0;\n\n        svg {\n            fill: currentColor;\n            margin-right: 6px;\n        }\n    "}));const rEe=function(e){var t=e.isRequired,r=void 0===t||t,o=e.initialTouched,a=void 0!==o&&o,s=e.labelOverrides,l=e.onChange,c=void 0===l?qT:l,u=/[.*+?^${}()|[\]\\]/g,d=Co("studio.passwordForm"),p=function(e){return r?e.required(d("password.validation.isRequired")):e},f=i.createElement(wr,{alignItems:"center",paddingLeft:"11px",fill:"currentColor"},i.createElement(ZAe,{height:"20px",width:"14px"})),h=[{description:d("password.validation.minLength"),pattern:/.{8}/},{description:d("password.validation.minOneUppercaseLetter"),pattern:/[A-Z]/},{description:d("password.validation.minOneLowercaseLetter"),pattern:/[a-z]/},{description:d("password.validation.minOneNumber"),pattern:/[0-9]/}],m=MU().shape({confirmPassword:p(aU().equals([HH("password")],d("confirmPassword.validation.matchesPassword"))),password:p(aU().max(128,d("password.validation.maxLength")).min(8,d("password.validation.minLength")).matches(/[A-Z]/,d("password.validation.minOneUppercaseLetter")).matches(/[a-z]/,d("password.validation.minOneLowercaseLetter")).matches(/[0-9]/,d("password.validation.minOneNumber")))});return i.createElement(TI,{initialValues:{confirmPassword:"",password:""},onSubmit:qT,validateOnBlur:!0,validateOnChange:!1,validationSchema:m},(function(e){var t,o,l,p=e.getFieldMeta,m=e.touched,g=e.setTouched,v=e.values;return i.createElement(i.Fragment,null,a&&i.createElement(eEe,null),i.createElement(XAe,{isRequired:r,onChange:c}),i.createElement(JAe,{isInvalid:Boolean(m.password&&p("password").error)},i.createElement(sQ,{label:null!==(t=null==s?void 0:s.password)&&void 0!==t?t:"studio.passwordForm.password.label",name:"password",onFocus:function(){g(n({},m,{password:!0}),!1)},prepend:f,showValidationIcons:!1,type:"password"}),m.password&&i.createElement(i.Fragment,null,i.createElement(bx,{"data-testid":"password-subtext",marginBottom:"8px",marginTop:"10px"},d("password.labelSubtext")),i.createElement(tEe,{rules:h,value:v.password}))),i.createElement(JAe,{isInvalid:Boolean(m.confirmPassword&&p("confirmPassword").error),marginTop:"10px"},i.createElement(sQ,{label:null!==(o=null==s?void 0:s.confirmPassword)&&void 0!==o?o:"studio.passwordForm.confirmPassword.label",name:"confirmPassword",onFocus:function(){g(n({},m,{confirmPassword:!0}),!1)},prepend:f,showValidationIcons:!1,type:"password"}),m.confirmPassword&&i.createElement(tEe,{rules:(l=v.password,[{description:d("confirmPassword.validation.matchesPassword"),pattern:new RegExp("^(?=.{1})"+l.replace(u,"\\$&")+"$")}]),value:v.confirmPassword})))}))};var oEe=["isStudioSignup"],iEe={components:{LabelError:{baseStyle:{color:"#A94442"}},TextInput:{baseStyle:{borderColor:bk.colors.gray[300],color:bk.colors.gray[300],focus:{borderColor:bk.colors.navy[400]},invalid:{borderColor:bk.colors.red[700]}}}}},aEe={components:{LabelError:{baseStyle:{color:"#EF5E5E"}}}},sEe=["children","isHighlighted","label"];var lEe=pr(BG,{target:"edwvo052"})({name:"o3zqb0",styles:"margin-bottom:5px;p{margin-bottom:0;}"}),cEe=pr("hr",{target:"edwvo051"})({name:"t4vnrp",styles:"margin:5px 0px 10px"}),uEe=pr(Px,{shouldForwardProp:e=>"isHighlighted"!==e,target:"edwvo050"})((e=>{var{isHighlighted:t}=e;return"\n        font-weight: "+(t?"900":"normal")+";\n    "}),""),dEe=e=>{var{children:t,isHighlighted:n=!1,label:r}=e,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,sEe),i=xo();return Mr(lEe,o,Mr(EAe,{size:12},Mr(wr,{justifyContent:"space-between"},Mr(uEe,{isHighlighted:n},i(r)),Mr(Px,null,t))))};const pEe=e=>{var{balanceDue:t,errorMessage:n,labItemCost:r,labShippingCost:o,onClose:i,studioCost:a,totalCollected:s,openSubscribe:l=(()=>{})}=e,c=xo();return Mr(Fq,{headerText:c("Unable to process payment"),onClose:i,openSubscribe:l},Mr(wr,{flexDirection:"column"},Mr(Px,{marginTop:"8px","data-testid":"payment-failure-error"},c("The payment method could not be processed.")+" "+n),Mr(UI,{margin:"20px 0px 12px"},c("Lab Order Summary")),Mr(dEe,{"data-testid":"payment-failure-total-collected",label:"Total Collected At Checkout"},s),Mr(dEe,{"data-testid":"payment-failure-lab-item-cost",label:"Lab Item Cost"},r),Mr(dEe,{"data-testid":"payment-failure-lab-shipping-cost",label:"Lab Shipping Cost"},o),Mr(cEe,null),Mr(dEe,{"data-testid":"payment-failure-balance-due",label:"Balance Due"},t),Mr(dEe,{"data-testid":"payment-failure-studio-cost",isHighlighted:!0,label:"Studio will be charged"},a)))};var fEe=function(e){return e()},hEe=c6($q(pEe)),mEe=c6($q(iq(D4)));const gEe=function(e){var t,n=e.isEmailVerified,r=e.initialFormError,o=e.maskedCreditCardNumber,a=e.onCreditCardFormSubmit,s=e.onSendVerificationEmail,l=hO().me,c=(null!==(t=null==l?void 0:l.studio)&&void 0!==t?t:{}).country;return n||o?i.createElement(i.Fragment,null,i.createElement(oj,{"data-testid":"billing-info-heading"},"Billing Information"),i.createElement(Px,{"data-testid":"billing-info-description"},o?i.createElement(i.Fragment,null,"Current card on file:"," ",i.createElement("span",{style:{fontFamily:"monospace"}},o)):i.createElement(i.Fragment,null,"No card on file.")),i.createElement(oj,null,"New Credit Card"),i.createElement(iY,{initialValues:{paymentMethodNonce:null},onSubmit:function(e){a(e),o||F4("Subscribed",{source:"plan-and-billing"})},validationSchema:MU({paymentMethodNonce:ZH().required()})},(function(e){var t=e.isSubmitting;return i.createElement(i.Fragment,null,r&&i.createElement(Ax,{"data-testid":"credit-card-form-error",marginBottom:"16px"},r),i.createElement(QJ,{collectFullBillingAddressFields:"US"===c,marginBottom:"20px",name:"paymentMethodNonce",width:["100%","100%","490px","490px"]}),i.createElement(fp,{isDisabled:t},"Save Details"))}))):i.createElement(_r,{"data-testid":"email-verification-container"},i.createElement(Px,null,"For security purposes, please verify your email address.",i.createElement("br",null),"Click on the link in the email to complete verification. Then, refresh this screen to continue."),i.createElement(Px,null,"Can't find the email?"),i.createElement(fp,{onClick:s},"Resend Email"))};var[vEe,yEe,bEe,_Ee]=VK();var[AEe,EEe]=xr({name:"TabsContext",errorMessage:"useTabsContext: `context` is undefined. Seems you forgot to wrap all tabs components within <Tabs />"});var[wEe,xEe]=xr({});function kEe(e,t){return`${e}--tab-${t}`}function CEe(e,t){return`${e}--tabpanel-${t}`}var[SEe,MEe]=xr({name:"TabsStylesContext",errorMessage:"useTabsStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Tabs />\" "}),TEe=yr((function(e,t){const n=jr("Tabs",e),{children:r,className:o,...a}=pt(e),{htmlProps:s,descendants:l,...c}=function(e){var t;const{defaultIndex:n,onChange:r,index:o,isManual:a,isLazy:s,lazyBehavior:l="unmount",orientation:c="horizontal",direction:u="ltr",...d}=e,[p,f]=(0,i.useState)(null!=n?n:0),[h,m]=bM({defaultValue:null!=n?n:0,value:o,onChange:r});(0,i.useEffect)((()=>{null!=o&&f(o)}),[o]);const g=bEe(),v=(0,i.useId)();return{id:`tabs-${null!=(t=e.id)?t:v}`,selectedIndex:h,focusedIndex:p,setSelectedIndex:m,setFocusedIndex:f,isManual:a,isLazy:s,lazyBehavior:l,orientation:c,descendants:g,direction:u,htmlProps:d}}(a),u=(0,i.useMemo)((()=>c),[c]),{isFitted:d,...p}=s,f={position:"relative",...n.root};return(0,br.jsx)(vEe,{value:l,children:(0,br.jsx)(AEe,{value:u,children:(0,br.jsx)(SEe,{value:n,children:(0,br.jsx)(vr.div,{className:g("chakra-tabs",o),ref:t,...p,__css:f,children:r})})})})}));TEe.displayName="Tabs";var OEe=yr((function(e,t){const n=MEe(),r=function(e){const{isDisabled:t=!1,isFocusable:n=!1,...r}=e,{setSelectedIndex:o,isManual:i,id:a,setFocusedIndex:s,selectedIndex:l}=EEe(),{index:c,register:u}=_Ee({disabled:t&&!n}),d=c===l;return{...tae({...r,ref:Ur(u,e.ref),isDisabled:t,isFocusable:n,onClick:w(e.onClick,(()=>{o(c)}))}),id:kEe(a,c),role:"tab",tabIndex:d?0:-1,type:"button","aria-selected":d,"aria-controls":CEe(a,c),onFocus:t?void 0:w(e.onFocus,(()=>{s(c),!i&&(!t||!n)&&o(c)}))}}({...e,ref:t}),o={outline:"0",display:"flex",alignItems:"center",justifyContent:"center",...n.tab};return(0,br.jsx)(vr.button,{...r,className:g("chakra-tabs__tab",e.className),__css:o})}));OEe.displayName="Tab";var DEe=yr((function(e,t){const n=function(e){const t=EEe(),{id:n,selectedIndex:r}=t,o=Zp(e.children).map(((e,t)=>(0,i.createElement)(wEe,{key:t,value:{isSelected:t===r,id:CEe(n,t),tabId:kEe(n,t),selectedIndex:r}},e)));return{...e,children:o}}(e),r=MEe();return(0,br.jsx)(vr.div,{...n,width:"100%",ref:t,className:g("chakra-tabs__tab-panels",e.className),__css:r.tabpanels})}));DEe.displayName="TabPanels";var LEe=yr((function(e,t){const n=function(e){const{children:t,...n}=e,{isLazy:r,lazyBehavior:o}=EEe(),{isSelected:a,id:s,tabId:l}=xEe(),c=(0,i.useRef)(!1);return a&&(c.current=!0),{tabIndex:0,...n,children:Vte({wasSelected:c.current,isSelected:a,enabled:r,mode:o})?t:null,role:"tabpanel","aria-labelledby":l,hidden:!a,id:s}}({...e,ref:t}),r=MEe();return(0,br.jsx)(vr.div,{outline:"0",...n,className:g("chakra-tabs__tab-panel",e.className),__css:r.tabpanel})}));LEe.displayName="TabPanel";var PEe=yr((function(e,t){const n=function(e){const{focusedIndex:t,orientation:n,direction:r}=EEe(),o=yEe(),a=(0,i.useCallback)((e=>{const i=()=>{var e;const n=o.nextEnabled(t);n&&(null==(e=n.node)||e.focus())},a=()=>{var e;const n=o.prevEnabled(t);n&&(null==(e=n.node)||e.focus())},s="horizontal"===n,l="vertical"===n,c=e.key,u="ltr"===r?"ArrowLeft":"ArrowRight",d="ltr"===r?"ArrowRight":"ArrowLeft",p={[u]:()=>s&&a(),[d]:()=>s&&i(),ArrowDown:()=>l&&i(),ArrowUp:()=>l&&a(),Home:()=>{var e;const t=o.firstEnabled();t&&(null==(e=t.node)||e.focus())},End:()=>{var e;const t=o.lastEnabled();t&&(null==(e=t.node)||e.focus())}},f=p[c];f&&(e.preventDefault(),f(e))}),[o,t,n,r]);return{...e,role:"tablist","aria-orientation":n,onKeyDown:w(e.onKeyDown,a)}}({...e,ref:t}),r={display:"flex",...MEe().tablist};return(0,br.jsx)(vr.div,{...n,className:g("chakra-tabs__tablist",e.className),__css:r})}));PEe.displayName="TabList";var IEe=["defaultIndex","onChange","tabs"];function BEe(){return BEe=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},BEe.apply(null,arguments)}var REe=pr(OEe,{target:"e1mvxzl71"})((e=>{var{theme:t}=e;return"\n        border-color: "+t.components.TabControl.baseStyle.borderColor+";\n        color: "+t.components.TabControl.baseStyle.color+";\n        font-size: "+t.components.TabControl.baseStyle.fontSize+";\n        line-height: "+t.components.TabControl.baseStyle.lineHeight+';\n        min-height: 40px;\n        min-width: 192px;\n\n        &:active {\n            background-color: transparent;\n        }\n\n        &:focus {\n            box-shadow: none;\n        }\n\n        &[aria-selected="true"] {\n            border-color: '+t.components.TabControl.baseStyle[tp.Selected].borderColor+";\n            border-bottom-width: 3px;\n            color: "+t.components.TabControl.baseStyle[tp.Selected].color+";\n        }\n    "}),""),NEe=pr(PEe,{target:"e1mvxzl70"})((e=>{var{theme:t}=e;return"\n        border-color: "+t.components.TabControl.baseStyle.borderColor+"\n    "}),"");const FEe=e=>{var{defaultIndex:t=0,onChange:n,tabs:r}=e,o=function(e,t){if(null==e)return{};var n={};for(var r in e)if({}.hasOwnProperty.call(e,r)){if(-1!==t.indexOf(r))continue;n[r]=e[r]}return n}(e,IEe);return Mr(TEe,BEe({"data-testid":"tab-control",defaultIndex:t,onChange:function(e){n&&n(e)}},o),Mr(NEe,null,r.map(((e,t)=>{var{label:n}=e;return Mr(REe,{"data-testid":"tab-header-"+t,key:t},n)}))),Mr(DEe,null,r.map(((e,t)=>{var{content:n}=e;return Mr(LEe,{"data-testid":"tab-content-"+t,key:t},n)}))))};var jEe=function(e){return e.CreditCard="credit-card",e.LabCredit="lab-credit",e.PlanInfo="plan-info",e}({});const YEe=function(e){var t=e.creditCardPageContent,n=e.history,r=void 0===n?window.history:n,o=e.initialTab,a=e.labCreditPageContent,s=void 0===a?i.createElement(i.Fragment,null):a,l=e.location,c=void 0===l?window.location:l,u=e.onTabChange,d=void 0===u?function(){return null}:u,p=e.showLabCreditTab,f=function(e){return g.indexOf(h[e])},h=kC(kC(kC({},jEe.CreditCard,{content:t,label:"Credit Card"}),jEe.LabCredit,{content:s,label:"Lab Credit"}),jEe.PlanInfo,{content:i.createElement(i.Fragment,null),label:"Plan Info"}),g=[h[jEe.PlanInfo],h[jEe.CreditCard]].concat(p?[h[jEe.LabCredit]]:[]);return i.createElement(FEe,{defaultIndex:f(o),onChange:function(e){switch(e){case f(jEe.PlanInfo):o===jEe.PlanInfo?r&&r.replaceState&&r.replaceState({},"","/v2/account/planbilling"):c.assign("/v2/account/planbilling");break;case f(jEe.LabCredit):o===jEe.LabCredit?r&&r.replaceState&&r.replaceState({},"","/v2/account/labcredit"):c.assign("/v2/account/labcredit");break;case f(jEe.CreditCard):r&&r.replaceState&&r.replaceState({},"","/v2/account/creditcard")}if(d)for(var t=0,n=Object.entries(h);t<n.length;t++){var i=m(n[t],2),a=i[0];if(i[1]===g[e])return void d(a)}},tabs:g})};var $Ee,HEe=function(e){return e.Center="center",e.Left="left",e.Right="right",e}({}),UEe=fr(_r,{shouldForwardProp:function(e){return"expirationStatus"!==e}})((function(e){var t=e.expirationStatus,n=e.theme;return"\n        color: "+n.colors.green[500]+";\n        font-weight: "+n.fontWeights.medium+";\n\n        "+(t===WEe.Expired?"\n                    color: "+n.colors.gray[400]+";\n                ":"")+"\n    "})),zEe=fr(_r,{shouldForwardProp:function(e){return"expirationStatus"!==e}})((function(e){var t=e.expirationStatus,n=e.theme;return"\n        border-radius: 2px;\n        max-width: 220px;\n        padding: 2px 20px;\n        text-align: center;\n        width: 100%;\n\n        "+(t===WEe.Expired?"\n                    background-color: "+n.colors.red[300]+";\n                    color: "+n.colors.red[500]+";\n                ":"")+"\n\n        "+(t===WEe.Later?"\n                    background-color: "+n.colors.green[200]+";\n                    color: "+n.colors.green[500]+";\n                ":"")+"\n\n        "+(t===WEe.Never?"\n                    background-color: "+n.colors.gray[200]+";\n                    color: "+n.colors.gray[500]+";\n                ":"")+"\n\n        "+(t===WEe.None?"\n                    background-color: transparent;\n                ":"")+"\n\n        "+(t===WEe.Soon?" background-color: "+n.colors.orange[200]+";\n                    color: "+n.colors.orange[500]+";\n                ":"")+"\n    "})),WEe=function(e){return e.Expired="expired",e.Later="expire-later",e.Never="expire-never",e.None="none",e.Soon="expire-soon",e}({}),VEe=fr(oj)($Ee||($Ee=zM(["\n    font-size: 22px;\n    line-height: 1em;\n    font-weight: 400;\n"])));const GEe=function(e){var t=e.labCreditHistory,n=e.labCredits,r=e.onViewOrderClick,o=[{Header:"Date",disableSortBy:!0,id:"date",width:2},{Header:"Type",disableSortBy:!0,id:"type"},{Header:"Order Id",disableSortBy:!0,id:"orderId",Cell:function(e){return i.createElement(Sx,{"data-testid":"view-order-link",onClick:function(){r&&null!==e.value&&r(e.value)}},e.value)}},{Header:"Lab",disableSortBy:!0,id:"lab"},{Header:"Description",disableSortBy:!0,id:"description"},{Header:"Amount",alignment:HEe.Right,disableSortBy:!0,id:"amount"}],a=[{Header:"Lab",disableSortBy:!0,id:"lab"},{Header:"Expiration Date",alignment:HEe.Center,disableSortBy:!0,id:"expirationDate",Cell:function(e){return i.createElement(zEe,{"data-testid":"expiration-date-cell",expirationStatus:e.row.original.expirationStatus},e.value)}},{Header:"Credit Amount",alignment:HEe.Right,disableSortBy:!0,id:"creditAmount",Cell:function(e){return i.createElement(UEe,{"data-testid":"credit-amount-cell",expirationStatus:e.row.original.expirationStatus},e.value)}}];return i.createElement(i.Fragment,null,i.createElement(VEe,{"data-testid":"lab-credit-section-heading"},"Lab Credit"),n&&n.length>0&&i.createElement(_r,{maxWidth:"550px"},i.createElement(K3,{columns:a,data:n})),i.createElement(VEe,{marginTop:"30px","data-testid":"lab-credit-history-section-heading"},"History"),t&&t.length>0&&i.createElement(_r,{maxWidth:"1000px"},i.createElement(K3,{columns:o,data:t})))};var QEe,qEe=["initialFormError","initialFormValueErrors","initialFormValues","isEmailVerified","labCreditHistory","labCredits","maskedCreditCardNumber","onCreditCardFormSubmit","onSendVerificationEmail","onViewOrderClick","showLabCreditTab"],KEe=c6(iq(gEe)),ZEe=o(47816),JEe="https://js.stripe.com/v3",XEe=/^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/,ewe="loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used",twe=function(e){var t=e&&!e.advancedFraudSignals?"?advancedFraudSignals=false":"",n=document.createElement("script");n.src="".concat(JEe).concat(t);var r=document.head||document.body;if(!r)throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");return r.appendChild(n),n},nwe=null,rwe=null,owe=null,iwe=function(e){return null!==nwe?nwe:(nwe=new Promise((function(t,n){if("undefined"!=typeof window&&"undefined"!=typeof document)if(window.Stripe&&e&&console.warn(ewe),window.Stripe)t(window.Stripe);else try{var r=function(){for(var e=document.querySelectorAll('script[src^="'.concat(JEe,'"]')),t=0;t<e.length;t++){var n=e[t];if(XEe.test(n.src))return n}return null}();if(r&&e)console.warn(ewe);else if(r){if(r&&null!==owe&&null!==rwe){var o;r.removeEventListener("load",owe),r.removeEventListener("error",rwe),null===(o=r.parentNode)||void 0===o||o.removeChild(r),r=twe(e)}}else r=twe(e);owe=function(e,t){return function(){window.Stripe?e(window.Stripe):t(new Error("Stripe.js not available"))}}(t,n),rwe=function(e){return function(){e(new Error("Failed to load Stripe.js"))}}(n),r.addEventListener("load",owe),r.addEventListener("error",rwe)}catch(e){return void n(e)}else t(null)})),nwe.catch((function(e){return nwe=null,Promise.reject(e)})))},awe=!1,swe=function(){return QEe||(QEe=iwe(null).catch((function(e){return QEe=null,Promise.reject(e)})),QEe)};Promise.resolve().then((function(){return swe()})).catch((function(e){awe||console.warn(e)}));var lwe=vr("div",{baseStyle:{boxShadow:"none",backgroundClip:"padding-box",cursor:"default",color:"transparent",pointerEvents:"none",userSelect:"none","&::before, &::after, *":{visibility:"hidden"}}}),cwe=ke("skeleton-start-color"),uwe=ke("skeleton-end-color"),dwe=Dr({from:{opacity:0},to:{opacity:1}}),pwe=Dr({from:{borderColor:cwe.reference,background:cwe.reference},to:{borderColor:uwe.reference,background:uwe.reference}}),fwe=yr(((e,t)=>{const n={...e,fadeDuration:"number"==typeof e.fadeDuration?e.fadeDuration:.4,speed:"number"==typeof e.speed?e.speed:.8},r=Fr("Skeleton",n),o=function(){const e=(0,i.useRef)(!0);return(0,i.useEffect)((()=>{e.current=!1}),[]),e.current}(),{startColor:a="",endColor:s="",isLoaded:l,fadeDuration:c,speed:u,className:d,fitContent:p,...f}=pt(n),[h,m]=Ir("colors",[a,s]),v=function(e){const t=(0,i.useRef)();return(0,i.useEffect)((()=>{t.current=e}),[e]),t.current}(l),y=g("chakra-skeleton",d),b={...h&&{[cwe.variable]:h},...m&&{[uwe.variable]:m}};if(l){const e=o||v?"none":`${dwe} ${c}s`;return(0,br.jsx)(vr.div,{ref:t,className:y,__css:{animation:e},...f})}return(0,br.jsx)(lwe,{ref:t,className:y,...f,__css:{width:p?"fit-content":void 0,...r,...b,_dark:{...r._dark,...b},animation:`${u}s linear infinite alternate ${pwe}`}})}));fwe.displayName="Skeleton";const hwe=function(e){var t=e.currencyMultiplier,r=e.isOpen,o=e.onClose,a=e.orderAmount,s=e.orderId,l=(0,ZEe.useStripe)(),c=(0,ZEe.useElements)(),u=Co("studio.order.view.paymentModal"),d=m((0,i.useState)(!1),2),p=d[0],f=d[1],h=m((0,i.useState)(""),2),g=h[0],v=h[1],y=m((0,i.useState)(!1),2),b=y[0],_=y[1],A=function(e,t,r){var o=$o(new URL("/v2/"+k_e+"/csrf",window.location.origin).toString(),{defer:!0,method:Fo.GET,search:{form_name:t}}).performFetch,a=$o(new URL("/v2/"+k_e+"/"+e,window.location.origin).toString(),n({headers:{"Content-Type":"application/x-www-form-urlencoded"}},r,{defer:!0})),s=a.loading,l=a.performFetch,c=a.response,u=(0,i.useCallback)(function(){var e=Lo(Io().mark((function e(t){var r,i;return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,o();case 2:return i=e.sent,e.abrupt("return",l(n({},t,{search:n({token:null!==(r=null==i?void 0:i.token)&&void 0!==r?r:""},null==t?void 0:t.search)})));case 4:case"end":return e.stop()}}),e)})));return function(t){return e.apply(this,arguments)}}(),[o,l]);return{loading:s,performFetch:u,response:c}}("order/addcreditcard","order_addcreditcard",{method:Fo.POST}),E=A.performFetch;if(!l||!c)return null;var w=function(e){v(u("errors."+function(e){var t="";switch(e){case"card_declined":t="cardDeclined";break;case"expired_card":t="expiredCard";break;case"incorrect_cvc":t="incorrectCvc";break;case"incorrect_number":t="incorrectNumber";break;case"processing_error":t="processingError";break;default:t="otherError"}return t}(e))),_(!1)},x=function(){var e=Lo(Io().mark((function e(t){var n,r,o,i,a,s,u,d;return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return t.preventDefault(),_(!0),n=new FormData(t.target),r=n.get("email"),o=n.get("cardHolderName"),e.next=7,c.submit();case 7:if(i=e.sent,!i.error&&r&&o){e.next=12;break}return _(!1),e.abrupt("return");case 12:return e.next=14,l.createPaymentMethod({elements:c,params:{billing_details:{email:r.toString(),name:o.toString()}}});case 14:if(a=e.sent,s=a.error,u=a.paymentMethod,!s){e.next=20;break}return w(s.message),e.abrupt("return");case 20:return e.next=22,k({paymentMethodId:u.id});case 22:d=e.sent,C(d);case 24:case"end":return e.stop()}}),e)})));return function(t){return e.apply(this,arguments)}}(),k=function(){var e=Lo(Io().mark((function e(t){var r,o;return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=t.paymentMethodId,o=t.paymentIntendId,e.abrupt("return",E({body:new URLSearchParams(n({order_id:s},o&&{payment_intent_id:o},r&&{payment_method_id:r},{transaction_amount:String(a)}))}));case 2:case"end":return e.stop()}}),e)})));return function(t){return e.apply(this,arguments)}}(),C=function(){var e=Lo(Io().mark((function e(t){var n,r,i,a,s,c,u,d;return Io().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(null==t||null===(n=t.errorMessage)||void 0===n||!n.includes("requires_action")){e.next=19;break}if(r=t.errorMessage.split(":"),i=m(r,2),(a=i[1]).startsWith("pi_")){e.next=5;break}return w(),e.abrupt("return");case 5:return e.next=7,l.handleNextAction({clientSecret:a});case 7:if(s=e.sent,c=s.error,u=s.paymentIntent,!c&&"succeeded"===(null==u?void 0:u.status)){e.next=13;break}return w(null==c?void 0:c.message),e.abrupt("return");case 13:return e.next=15,k({paymentIntendId:u.id});case 15:d=e.sent,C(d),e.next=20;break;case 19:!t||200!==t.status||"success"!==t.statusText||t.errorMessage?w(null==t?void 0:t.errorMessage):(_(!1),o(),location.reload());case 20:case"end":return e.stop()}}),e)})));return function(t){return e.apply(this,arguments)}}();return i.createElement(sB,{isOpen:r,onClose:o,size:"md"},i.createElement(vF,null),i.createElement(uF,null,i.createElement("form",{"data-testid":"stripe-standard-payment-form",onSubmit:x},i.createElement(dF,null,i.createElement(qr,null,u("enterCreditCard"))),i.createElement(cB,null),i.createElement(lB,null,i.createElement(fwe,{minHeight:"300px",isLoaded:p},i.createElement(wr,{flexDirection:"column",gap:"10px"},i.createElement(_r,null,i.createElement(Xp,{sx:Ece},u("amount")),i.createElement(qr,{sx:Ece},a.toFixed(t.toString().length-1))),i.createElement(Mp,{isRequired:!0},i.createElement(Xp,{sx:Ece},u("email")),i.createElement(dz,{"data-testid":"email-input",name:"email",sx:Ace})),i.createElement(Mp,{isRequired:!0},i.createElement(Xp,{sx:Ece},u("cardHolderName")),i.createElement(dz,{"data-testid":"name-input",name:"cardHolderName",sx:Ace})),i.createElement(ZEe.PaymentElement,{onReady:function(){f(!0)}}),g&&i.createElement(qr,{marginTop:"12px",variant:"error"},g)))),i.createElement(pF,null,i.createElement(P6,{onClick:o,variant:"secondary"},u("cancel")),i.createElement(P6,{isDisabled:!c||!l,isLoading:b,type:"submit",variant:"primary"},u("processTransaction"))))))};var mwe=["currencyCode","currencyMultiplier","orderAmount","staticUrl","stripeApiKey","stripeConfigId","stripeStandardAccountId"];const gwe=c6(K2((function(e){var r=e.currencyCode,o=e.currencyMultiplier,a=e.orderAmount,s=e.staticUrl,l=e.stripeApiKey,c=e.stripeConfigId,u=e.stripeStandardAccountId,d=t(e,mwe),p=Z2().theme,f=function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];awe=!0;var r=Date.now();return swe().then((function(e){return function(e,t,n){if(null===e)return null;var r=e.apply(void 0,t);return function(e,t){e&&e._registerWrapper&&e._registerWrapper({name:"stripe-js",version:"2.4.0",startTime:t})}(r,n),r}(e,t,r)}))}(l,{stripeAccount:u,apiVersion:"2023-10-16"}),h={amount:Math.round(a*o),appearance:bce(p),currency:r.toLowerCase(),fonts:_ce(s),mode:"payment",paymentMethodConfiguration:c,paymentMethodCreation:"manual"};return i.createElement(ZEe.Elements,{options:h,stripe:f},i.createElement(hwe,n({currencyMultiplier:o,orderAmount:a},d)))})));const vwe=function(e){var t=e.isOpen,n=e.onClose,r=e.onConfirm,o=e.originalSalesTax,a=e.taxDifference,s=e.updatedSalesTax,l=Co("studio.order.view.updatedSalesTaxConfirmationModal"),c=Lr(),u="-"===a.charAt(0);return i.createElement(sB,{isOpen:t,onClose:n,size:"xl"},i.createElement(vF,null),i.createElement(uF,{"data-testid":"updatedSalesTaxConfirmationModal"},i.createElement(dF,null,i.createElement(qr,{marginBottom:"8px"},l("heading"))),i.createElement(cB,null),i.createElement(lB,{padding:"8 28px"},i.createElement(qr,null,l("description")),i.createElement(wr,{backgroundColor:c.colors.gray[100],justifyContent:"space-between",marginBottom:"16px",padding:"0 12px"},i.createElement(_r,null,i.createElement(tq,{as:"h6",size:"sm"},l("original")),i.createElement(qr,{"data-testid":"originalSalesTaxValue"},o)),i.createElement(wr,{alignItems:"center"},i.createElement(qr,null,"→")),i.createElement(_r,null,i.createElement(tq,{as:"h6",size:"sm"},l("updated")),i.createElement(qr,{"data-testid":"updatedSalesTaxValue"},s))),i.createElement("span",{"data-testid":"actionNotice"},i.createElement(qr,{as:"span"},l(u?"deductionNotice":"refundedNotice")),!u&&i.createElement(qr,{as:"span",color:c.colors.navy[400]},a))),i.createElement(pF,null,i.createElement(P6,{"data-testid":"cancelButton",onClick:n,variant:"secondary"},l("cancel")),i.createElement(P6,{"data-testid":"confirmButton",onClick:r,variant:"primary"},l("confirm")))))};var ywe=["onConfirm"];const bwe=c6(K2((function(e){var r=e.onConfirm,o=t(e,ywe),a=zF({defaultIsOpen:!0}),s=a.isOpen,l=a.onClose;return i.createElement(vwe,n({},o,{isOpen:s,onClose:l,onConfirm:function(){l(),r()}}))})));var _we,Awe,Ewe=$q((function(e){var t=e.onAccept,n=e.onClose,r=e.isOpen,o=nY(),a=o.Modal,s=o.open,l=o.close;(0,i.useEffect)((function(){r&&s()}),[r,s]);return i.createElement(a,{heading:"Upgrade to Create Unlimited User Profiles",onClose:n},i.createElement(a.Body,null,i.createElement("ul",null,i.createElement("li",null,"Add multiple user profiles and grant them specific permissions"),i.createElement("li",null,"Great for collaboration and big teams"))),i.createElement(a.PrimaryButton,{onClick:t},"View Plan Options"),i.createElement(a.SecondaryButton,{onClick:function(){return n(),l()}},"Cancel"))})),wwe=o6.bind(void 0,(function(e){return i.createElement(u6,n({openSubscribe:d6},e))})),xwe=o6.bind(void 0,p6),kwe=o6.bind(void 0,(function(e){return i.createElement(C6,n({openSubscribe:k6},e))})),Cwe=o6.bind(void 0,(function(e){return i.createElement(T6,n({openSubscribe:M6},e))})),Swe=o6.bind(void 0,B6),Mwe=o6.bind(void 0,Gie),Twe=o6.bind(void 0,(function(e){return i.createElement(qie,n({openSubscribe:Qie},e))})),Owe=o6.bind(void 0,EC(pQ,{translateService:s6})),Dwe=o6.bind(void 0,EC(eq)),Lwe=o6.bind(void 0,EC(c6(fO(U4)))),Pwe=o6.bind(void 0,(function(e){var r=e.apiRoot,o=e.currentBrandId,a=e.dataToken,s=t(e,D_e);return Ho=a,Uo=r,function(e){k_e=e}(o),i.createElement(kce,null,i.createElement(oq,null,i.createElement(N_e,n({currentBrandId:o},s))))})),Iwe=o6.bind(void 0,(function(e){var t=$q(rx);return i.createElement(t,e,i.createElement(z_e,null))})),Bwe=o6.bind(void 0,(function(e){var t=EC(r6,{partialTheme:{components:{Modal:{variants:{fullscreen:{body:{maxWidth:"100%"}}}}},colors:{gray:kC({},100,"transparent")}}});return i.createElement(t,e)})),Rwe=o6.bind(void 0,(function(e){var t=EC(q_e);return i.createElement(t,e)})),Nwe=o6.bind(void 0,EC(J_e)),Fwe=o6.bind(void 0,(function(e){var r=e.amount,o=e.amountIsFixed,a=e.onSubmit,s=e.stripeKey,l=t(e,NAe),c=$q(cAe(function(e,t){var n=n=>Mr(fAe,{stripeKey:t},Mr(e,n)),r=e.name||e.displayName;return n.displayName="withStripe"+r,n}(BAe,s))),u=(0,i.createRef)(null),d=i.createElement(c,n({amount:r,amountIsFixed:o,formRef:u,onSubmit:a,showAmount:!0,showEmail:!1,showMemo:!1},l));return i6({orderPaymentFormRef:u}),d})),jwe=o6.bind(void 0,(function(e){var r=e.isStudioSignup,o=t(e,oEe),a=EC(rEe,{partialTheme:r?iEe:aEe,translateService:s6});return i.createElement(a,n({},o,!r&&{labelOverrides:{confirmPassword:"studio.passwordForm.confirmPassword.newLabel",password:"studio.passwordForm.password.newLabel"}}))})),Ywe=o6.bind(void 0,(function(e){return i.createElement(hEe,n({openSubscribe:fEe},e))})),$we=o6.bind(void 0,(function(e){var t=e.onPlanSelected,n=e.plans,r=e.downgradePlanUuid,o=e.downgradeToFreePlan;return i.createElement(mEe,{downgradePlanUuid:r,onPlanSelected:t,plans:n,showPlanFeatures:!0,downgradeToFreePlan:o})})),Hwe=o6.bind(void 0,EC(X3)),Uwe=o6.bind(void 0,EC((function(e){var r=e.initialFormError,o=e.initialFormValueErrors,a=e.initialFormValues,s=e.isEmailVerified,l=e.labCreditHistory,c=e.labCredits,u=e.maskedCreditCardNumber,d=e.onCreditCardFormSubmit,p=e.onSendVerificationEmail,f=e.onViewOrderClick,h=e.showLabCreditTab,m=t(e,qEe);return i.createElement(YEe,n({},m,{creditCardPageContent:i.createElement(KEe,{initialFormError:r,initialFormValueErrors:o,initialFormValues:a,isEmailVerified:s,maskedCreditCardNumber:u,onCreditCardFormSubmit:d,onSendVerificationEmail:p}),labCreditPageContent:l&&c&&f&&i.createElement(GEe,{labCreditHistory:l,labCredits:c,onViewOrderClick:f}),showLabCreditTab:h}))}))),zwe=function(e,t,n){var o=e(n);(0,r.H)(t).render(o)}.bind(void 0,(function(e){var r=e.isCentered,o=void 0===r||r,a=e.item,s=e.photo,l=e.photoUrl,c=e.previewBackground,u=e.previewEffects,d=e.variant,p=void 0===d?sO:d,f=e.padding,h=void 0===f?"0px 10px":f,m=e.frame,g=t(e,oO),v=aO[p]||aO[sO],y=a.crop?nO(a,s,l):tO(s,l),b=n({},v,{pageSpecification:y.pageSpecification,project:y.project,frame:m});return i.createElement(iO,n({isCentered:o,padding:h},g),i.createElement(CS,n({previewBackground:c,previewEffects:u},b)))})),Wwe=o6.bind(void 0,gwe),Vwe=o6.bind(void 0,bwe),Gwe=o6.bind(void 0,Ewe),Qwe=["description","featureList","featureListHeading","name"],qwe=document.querySelector("body"),Kwe=qwe.getAttribute("data-app-env"),Zwe=qwe.getAttribute("data-braintree-client-authorization"),Jwe=document.getElementById("studio-react-app"),Xwe=document.getElementById("nav"),exe=(null==Jwe?void 0:Jwe.getAttribute("data-assistant-iframe-url"))||(null==Xwe?void 0:Xwe.getAttribute("data-assistant-iframe-url"))||qwe.getAttribute("data-assistant-iframe-url")||null;Zwe&&(c=Zwe),exe&&(_we=exe,To.baseUrl=_we,To.iframeSrc=null),Awe="production"===Kwe?s.Production:"staging"===Kwe?s.Staging:s.Development,function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:window;Object.assign(t,{Sp:n({},t.Sp,{v2ReactBridge:n({},e)})})}({renderConvertToSelfFulfilledFailureModal:Cwe,renderOrderPayment:Fwe,renderOrderItemPreviewModal:Rwe,renderOrderItemEditModal:Bwe,renderPaymentFailureModal:Ywe,renderProductPreviewThumbnail:zwe,showBraintreeChallenge:function(e){null!==document.getElementById("braintreeChallengeContainer")&&wwe("braintreeChallengeContainer",e)},showBrandUpgradeModal:function(e,t){null!==document.getElementById(e)&&xwe(e,t)},showCombineOrdersFailureModal:function(e){null!==document.getElementById("combineOrdersFailureModalContainer")&&kwe("combineOrdersFailureModalContainer",e)},showConvertToSelfFulfilledFailueModal:function(e){null!==document.getElementById("convertToSelfFulfilledFailureModalContainer")&&Cwe("convertToSelfFulfilledFailureModalContainer",{errorMessage:e.errorMessage,onClose:function(){return location.reload()}})},showEventResubscribeModal:function(e){var t="eventResubscribeModalContainer";document.getElementById(t)&&Swe(t,n({},e))},showGalleryPreview:function(e){document.getElementById(txe)&&Mwe(txe,e)},showMfaDeleteModal:function(e){var t="mfaDeleteModalContainer";document.getElementById(t)&&Owe(t,n({shouldOpen:!0,onClose:function(){return Owe(t,n({shouldOpen:!1},e))}},e))},showNav:function(e){var t=e.activeRoute,n=e.apiRoot,r=e.currentBrandId,o=e.dataToken,i=document.getElementById("nav");null!==i&&Pwe("nav",{activeRoute:t,apiRoot:n,currentBrandId:r,dataToken:o})},showErrorModal:function(e){var t=e.errorMessage,n=e.headerText,r=e.onClose;null!==document.getElementById("convertToSelfFulfilledFailureModalContainer")&&Twe("convertToSelfFulfilledFailureModalContainer",{children:t,headerText:n,onClose:r})},showMusicPlanSection:function(e){var t=e.canStartTrial,n=e.moneyBalance,r=e.musicPlans,o=e.onCancelPlan,i=e.onChangePlan;null!==document.getElementById("music-plan-section")&&Dwe("music-plan-section",{canStartTrial:t,moneyBalance:n,musicPlans:r,onCancelPlan:o,onChangePlan:i})},showBookingPlanSection:function(){null!==document.getElementById("booking-plan-section")&&Lwe("booking-plan-section")},showOrderCommentIndicator:function(e,t){if(!e)return;Iwe(e.id,t)},showOrderItemWhccCardPreviewModal:function(e,t){if(!e)return;Nwe(e.id,t)},showPasswordForm:function(e){null!==document.getElementById("password-form")&&jwe("password-form",e)},showPhotoPlans:function(){var e=document.getElementById("spUiPhotoPlansContainer"),r=window.Sp.studio.jsValues,o=r.photoPlans,i=r.downgradePlanUuid,a=new URL(location.href).searchParams.get("downgradeToFreePlan");null!==e&&$we("spUiPhotoPlansContainer",{downgradePlanUuid:null!==i?i:null,downgradeToFreePlan:!!a,onPlanSelected:function(e){window.Sp.studio.updatePlanInAnalyticsDataLayer(e)},plans:o.map((function(e){var r=e.description,o=e.featureList,i=e.featureListHeading,a=e.name,s=t(e,Qwe);return null===s.promoPrice&&delete s.promoPrice,n({description:o,descriptionHeading:i,heading:a,name:a,subheading:r},s)}))})},showPlanBillingHistory:function(e){var t="history-billing-section";document.getElementById(t)&&Hwe(t,e)},showPlanBillingSubNav:function(e){var t=e.initialFormError,n=e.initialFormValueErrors,r=e.initialFormValues,o=e.initialTab,i=e.isEmailVerified,a=e.labCreditHistory,s=e.labCredits,l=e.maskedCreditCardNumber,c=e.onCreditCardFormSubmit,u=e.onSendVerificationEmail,d=e.onViewOrderClick,p=e.onTabChange,f=e.showLabCreditTab;null!==document.getElementById("plan-billing-sub-nav")&&Uwe("plan-billing-sub-nav",{initialFormError:t,initialFormValueErrors:n,initialFormValues:r,initialTab:o,isEmailVerified:i,labCreditHistory:a,labCredits:s,maskedCreditCardNumber:l,onCreditCardFormSubmit:c,onSendVerificationEmail:u,onViewOrderClick:d,onTabChange:p,showLabCreditTab:f})},showStripeStandardPaymentModal:function(e){var t="stripeStandardOrderPaymentContainer",o=document.getElementById(t);null!==o&&Wwe(t,n({},e,{isOpen:!0,onClose:function(){(0,r.H)(o).unmount()}}))},showUpdatedSalesTaxConfirmationModal:function(e){var t="salesTaxConfirmationModalContainer";null!==document.getElementById(t)&&Vwe(t,n({},e))},showUsersUpsellModal:function(e){var t="usersUpsellModalContainer",r=document.getElementById(t);if(null===r)return;Gwe(t,n({},e,{onClose:function r(){return Gwe(t,n({},e,{onClose:r,isOpen:!1}))},isOpen:!0}))}}),window.addEventListener("load",(function(){if(null!==document.getElementById("paymentFailureModalContainer")){var e=window.Sp.studio.jsValues,t=e.paymentFailureModalContainer,r=e.orderViewUrl;Ywe("paymentFailureModalContainer",n({onClose:function(){return window.location.replace(r)}},t))}}));var txe="exampleGallery"})()})();
//# sourceMappingURL=build.js.map
/** FILE SIZE -- 6301722 bytes **/